webpackJsonp([1,0],[
/* 0 */,
/* 1 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// This is CodeMirror (http://codemirror.net), a code editor
	// implemented in JavaScript on top of the browser's DOM.
	//
	// You can find some technical background for some of the code below
	// at http://marijnhaverbeke.nl/blog/#cm-internals .
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.CodeMirror = factory());
	}(this, (function () { 'use strict';
	
	// Kludges for bugs and behavior differences that can't be feature
	// detected are enabled based on userAgent etc sniffing.
	var userAgent = navigator.userAgent
	var platform = navigator.platform
	
	var gecko = /gecko\/\d/i.test(userAgent)
	var ie_upto10 = /MSIE \d/.test(userAgent)
	var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent)
	var ie = ie_upto10 || ie_11up
	var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : ie_11up[1])
	var webkit = /WebKit\//.test(userAgent)
	var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent)
	var chrome = /Chrome\//.test(userAgent)
	var presto = /Opera\//.test(userAgent)
	var safari = /Apple Computer/.test(navigator.vendor)
	var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent)
	var phantom = /PhantomJS/.test(userAgent)
	
	var ios = /AppleWebKit/.test(userAgent) && /Mobile\/\w+/.test(userAgent)
	// This is woefully incomplete. Suggestions for alternative methods welcome.
	var mobile = ios || /Android|webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent)
	var mac = ios || /Mac/.test(platform)
	var chromeOS = /\bCrOS\b/.test(userAgent)
	var windows = /win/i.test(platform)
	
	var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/)
	if (presto_version) { presto_version = Number(presto_version[1]) }
	if (presto_version && presto_version >= 15) { presto = false; webkit = true }
	// Some browsers use the wrong event properties to signal cmd/ctrl on OS X
	var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11))
	var captureRightClick = gecko || (ie && ie_version >= 9)
	
	function classTest(cls) { return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*") }
	
	var rmClass = function(node, cls) {
	  var current = node.className
	  var match = classTest(cls).exec(current)
	  if (match) {
	    var after = current.slice(match.index + match[0].length)
	    node.className = current.slice(0, match.index) + (after ? match[1] + after : "")
	  }
	}
	
	function removeChildren(e) {
	  for (var count = e.childNodes.length; count > 0; --count)
	    { e.removeChild(e.firstChild) }
	  return e
	}
	
	function removeChildrenAndAdd(parent, e) {
	  return removeChildren(parent).appendChild(e)
	}
	
	function elt(tag, content, className, style) {
	  var e = document.createElement(tag)
	  if (className) { e.className = className }
	  if (style) { e.style.cssText = style }
	  if (typeof content == "string") { e.appendChild(document.createTextNode(content)) }
	  else if (content) { for (var i = 0; i < content.length; ++i) { e.appendChild(content[i]) } }
	  return e
	}
	
	var range
	if (document.createRange) { range = function(node, start, end, endNode) {
	  var r = document.createRange()
	  r.setEnd(endNode || node, end)
	  r.setStart(node, start)
	  return r
	} }
	else { range = function(node, start, end) {
	  var r = document.body.createTextRange()
	  try { r.moveToElementText(node.parentNode) }
	  catch(e) { return r }
	  r.collapse(true)
	  r.moveEnd("character", end)
	  r.moveStart("character", start)
	  return r
	} }
	
	function contains(parent, child) {
	  if (child.nodeType == 3) // Android browser always returns false when child is a textnode
	    { child = child.parentNode }
	  if (parent.contains)
	    { return parent.contains(child) }
	  do {
	    if (child.nodeType == 11) { child = child.host }
	    if (child == parent) { return true }
	  } while (child = child.parentNode)
	}
	
	function activeElt() {
	  // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
	  // IE < 10 will throw when accessed while the page is loading or in an iframe.
	  // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
	  var activeElement
	  try {
	    activeElement = document.activeElement
	  } catch(e) {
	    activeElement = document.body || null
	  }
	  while (activeElement && activeElement.root && activeElement.root.activeElement)
	    { activeElement = activeElement.root.activeElement }
	  return activeElement
	}
	
	function addClass(node, cls) {
	  var current = node.className
	  if (!classTest(cls).test(current)) { node.className += (current ? " " : "") + cls }
	}
	function joinClasses(a, b) {
	  var as = a.split(" ")
	  for (var i = 0; i < as.length; i++)
	    { if (as[i] && !classTest(as[i]).test(b)) { b += " " + as[i] } }
	  return b
	}
	
	var selectInput = function(node) { node.select() }
	if (ios) // Mobile Safari apparently has a bug where select() is broken.
	  { selectInput = function(node) { node.selectionStart = 0; node.selectionEnd = node.value.length } }
	else if (ie) // Suppress mysterious IE10 errors
	  { selectInput = function(node) { try { node.select() } catch(_e) {} } }
	
	function bind(f) {
	  var args = Array.prototype.slice.call(arguments, 1)
	  return function(){return f.apply(null, args)}
	}
	
	function copyObj(obj, target, overwrite) {
	  if (!target) { target = {} }
	  for (var prop in obj)
	    { if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop)))
	      { target[prop] = obj[prop] } }
	  return target
	}
	
	// Counts the column offset in a string, taking tabs into account.
	// Used mostly to find indentation.
	function countColumn(string, end, tabSize, startIndex, startValue) {
	  if (end == null) {
	    end = string.search(/[^\s\u00a0]/)
	    if (end == -1) { end = string.length }
	  }
	  for (var i = startIndex || 0, n = startValue || 0;;) {
	    var nextTab = string.indexOf("\t", i)
	    if (nextTab < 0 || nextTab >= end)
	      { return n + (end - i) }
	    n += nextTab - i
	    n += tabSize - (n % tabSize)
	    i = nextTab + 1
	  }
	}
	
	function Delayed() {this.id = null}
	Delayed.prototype.set = function(ms, f) {
	  clearTimeout(this.id)
	  this.id = setTimeout(f, ms)
	}
	
	function indexOf(array, elt) {
	  for (var i = 0; i < array.length; ++i)
	    { if (array[i] == elt) { return i } }
	  return -1
	}
	
	// Number of pixels added to scroller and sizer to hide scrollbar
	var scrollerGap = 30
	
	// Returned or thrown by various protocols to signal 'I'm not
	// handling this'.
	var Pass = {toString: function(){return "CodeMirror.Pass"}}
	
	// Reused option objects for setSelection & friends
	var sel_dontScroll = {scroll: false};
	var sel_mouse = {origin: "*mouse"};
	var sel_move = {origin: "+move"};
	// The inverse of countColumn -- find the offset that corresponds to
	// a particular column.
	function findColumn(string, goal, tabSize) {
	  for (var pos = 0, col = 0;;) {
	    var nextTab = string.indexOf("\t", pos)
	    if (nextTab == -1) { nextTab = string.length }
	    var skipped = nextTab - pos
	    if (nextTab == string.length || col + skipped >= goal)
	      { return pos + Math.min(skipped, goal - col) }
	    col += nextTab - pos
	    col += tabSize - (col % tabSize)
	    pos = nextTab + 1
	    if (col >= goal) { return pos }
	  }
	}
	
	var spaceStrs = [""]
	function spaceStr(n) {
	  while (spaceStrs.length <= n)
	    { spaceStrs.push(lst(spaceStrs) + " ") }
	  return spaceStrs[n]
	}
	
	function lst(arr) { return arr[arr.length-1] }
	
	function map(array, f) {
	  var out = []
	  for (var i = 0; i < array.length; i++) { out[i] = f(array[i], i) }
	  return out
	}
	
	function insertSorted(array, value, score) {
	  var pos = 0, priority = score(value)
	  while (pos < array.length && score(array[pos]) <= priority) { pos++ }
	  array.splice(pos, 0, value)
	}
	
	function nothing() {}
	
	function createObj(base, props) {
	  var inst
	  if (Object.create) {
	    inst = Object.create(base)
	  } else {
	    nothing.prototype = base
	    inst = new nothing()
	  }
	  if (props) { copyObj(props, inst) }
	  return inst
	}
	
	var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/
	function isWordCharBasic(ch) {
	  return /\w/.test(ch) || ch > "\x80" &&
	    (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch))
	}
	function isWordChar(ch, helper) {
	  if (!helper) { return isWordCharBasic(ch) }
	  if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) { return true }
	  return helper.test(ch)
	}
	
	function isEmpty(obj) {
	  for (var n in obj) { if (obj.hasOwnProperty(n) && obj[n]) { return false } }
	  return true
	}
	
	// Extending unicode characters. A series of a non-extending char +
	// any number of extending chars is treated as a single unit as far
	// as editing and measuring is concerned. This is not fully correct,
	// since some scripts/fonts/browsers also treat other configurations
	// of code points as a group.
	var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/
	function isExtendingChar(ch) { return ch.charCodeAt(0) >= 768 && extendingChars.test(ch) }
	
	// The display handles the DOM integration, both for input reading
	// and content drawing. It holds references to DOM nodes and
	// display-related state.
	
	function Display(place, doc, input) {
	  var d = this
	  this.input = input
	
	  // Covers bottom-right square when both scrollbars are present.
	  d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler")
	  d.scrollbarFiller.setAttribute("cm-not-content", "true")
	  // Covers bottom of gutter when coverGutterNextToScrollbar is on
	  // and h scrollbar is present.
	  d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler")
	  d.gutterFiller.setAttribute("cm-not-content", "true")
	  // Will contain the actual code, positioned to cover the viewport.
	  d.lineDiv = elt("div", null, "CodeMirror-code")
	  // Elements are added to these to represent selection and cursors.
	  d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1")
	  d.cursorDiv = elt("div", null, "CodeMirror-cursors")
	  // A visibility: hidden element used to find the size of things.
	  d.measure = elt("div", null, "CodeMirror-measure")
	  // When lines outside of the viewport are measured, they are drawn in this.
	  d.lineMeasure = elt("div", null, "CodeMirror-measure")
	  // Wraps everything that needs to exist inside the vertically-padded coordinate system
	  d.lineSpace = elt("div", [d.measure, d.lineMeasure, d.selectionDiv, d.cursorDiv, d.lineDiv],
	                    null, "position: relative; outline: none")
	  // Moved around its parent to cover visible view.
	  d.mover = elt("div", [elt("div", [d.lineSpace], "CodeMirror-lines")], null, "position: relative")
	  // Set to the height of the document, allowing scrolling.
	  d.sizer = elt("div", [d.mover], "CodeMirror-sizer")
	  d.sizerWidth = null
	  // Behavior of elts with overflow: auto and padding is
	  // inconsistent across browsers. This is used to ensure the
	  // scrollable area is big enough.
	  d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;")
	  // Will contain the gutters, if any.
	  d.gutters = elt("div", null, "CodeMirror-gutters")
	  d.lineGutter = null
	  // Actual scrollable element.
	  d.scroller = elt("div", [d.sizer, d.heightForcer, d.gutters], "CodeMirror-scroll")
	  d.scroller.setAttribute("tabIndex", "-1")
	  // The element in which the editor lives.
	  d.wrapper = elt("div", [d.scrollbarFiller, d.gutterFiller, d.scroller], "CodeMirror")
	
	  // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
	  if (ie && ie_version < 8) { d.gutters.style.zIndex = -1; d.scroller.style.paddingRight = 0 }
	  if (!webkit && !(gecko && mobile)) { d.scroller.draggable = true }
	
	  if (place) {
	    if (place.appendChild) { place.appendChild(d.wrapper) }
	    else { place(d.wrapper) }
	  }
	
	  // Current rendered range (may be bigger than the view window).
	  d.viewFrom = d.viewTo = doc.first
	  d.reportedViewFrom = d.reportedViewTo = doc.first
	  // Information about the rendered lines.
	  d.view = []
	  d.renderedView = null
	  // Holds info about a single rendered line when it was rendered
	  // for measurement, while not in view.
	  d.externalMeasured = null
	  // Empty space (in pixels) above the view
	  d.viewOffset = 0
	  d.lastWrapHeight = d.lastWrapWidth = 0
	  d.updateLineNumbers = null
	
	  d.nativeBarWidth = d.barHeight = d.barWidth = 0
	  d.scrollbarsClipped = false
	
	  // Used to only resize the line number gutter when necessary (when
	  // the amount of lines crosses a boundary that makes its width change)
	  d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null
	  // Set to true when a non-horizontal-scrolling line widget is
	  // added. As an optimization, line widget aligning is skipped when
	  // this is false.
	  d.alignWidgets = false
	
	  d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null
	
	  // Tracks the maximum line length so that the horizontal scrollbar
	  // can be kept static when scrolling.
	  d.maxLine = null
	  d.maxLineLength = 0
	  d.maxLineChanged = false
	
	  // Used for measuring wheel scrolling granularity
	  d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null
	
	  // True when shift is held down.
	  d.shift = false
	
	  // Used to track whether anything happened since the context menu
	  // was opened.
	  d.selForContextMenu = null
	
	  d.activeTouch = null
	
	  input.init(d)
	}
	
	// Find the line object corresponding to the given line number.
	function getLine(doc, n) {
	  n -= doc.first
	  if (n < 0 || n >= doc.size) { throw new Error("There is no line " + (n + doc.first) + " in the document.") }
	  var chunk = doc
	  while (!chunk.lines) {
	    for (var i = 0;; ++i) {
	      var child = chunk.children[i], sz = child.chunkSize()
	      if (n < sz) { chunk = child; break }
	      n -= sz
	    }
	  }
	  return chunk.lines[n]
	}
	
	// Get the part of a document between two positions, as an array of
	// strings.
	function getBetween(doc, start, end) {
	  var out = [], n = start.line
	  doc.iter(start.line, end.line + 1, function (line) {
	    var text = line.text
	    if (n == end.line) { text = text.slice(0, end.ch) }
	    if (n == start.line) { text = text.slice(start.ch) }
	    out.push(text)
	    ++n
	  })
	  return out
	}
	// Get the lines between from and to, as array of strings.
	function getLines(doc, from, to) {
	  var out = []
	  doc.iter(from, to, function (line) { out.push(line.text) }) // iter aborts when callback returns truthy value
	  return out
	}
	
	// Update the height of a line, propagating the height change
	// upwards to parent nodes.
	function updateLineHeight(line, height) {
	  var diff = height - line.height
	  if (diff) { for (var n = line; n; n = n.parent) { n.height += diff } }
	}
	
	// Given a line object, find its line number by walking up through
	// its parent links.
	function lineNo(line) {
	  if (line.parent == null) { return null }
	  var cur = line.parent, no = indexOf(cur.lines, line)
	  for (var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent) {
	    for (var i = 0;; ++i) {
	      if (chunk.children[i] == cur) { break }
	      no += chunk.children[i].chunkSize()
	    }
	  }
	  return no + cur.first
	}
	
	// Find the line at the given vertical position, using the height
	// information in the document tree.
	function lineAtHeight(chunk, h) {
	  var n = chunk.first
	  outer: do {
	    for (var i$1 = 0; i$1 < chunk.children.length; ++i$1) {
	      var child = chunk.children[i$1], ch = child.height
	      if (h < ch) { chunk = child; continue outer }
	      h -= ch
	      n += child.chunkSize()
	    }
	    return n
	  } while (!chunk.lines)
	  var i = 0
	  for (; i < chunk.lines.length; ++i) {
	    var line = chunk.lines[i], lh = line.height
	    if (h < lh) { break }
	    h -= lh
	  }
	  return n + i
	}
	
	function isLine(doc, l) {return l >= doc.first && l < doc.first + doc.size}
	
	function lineNumberFor(options, i) {
	  return String(options.lineNumberFormatter(i + options.firstLineNumber))
	}
	
	// A Pos instance represents a position within the text.
	function Pos (line, ch) {
	  if (!(this instanceof Pos)) { return new Pos(line, ch) }
	  this.line = line; this.ch = ch
	}
	
	// Compare two positions, return 0 if they are the same, a negative
	// number when a is less, and a positive number otherwise.
	function cmp(a, b) { return a.line - b.line || a.ch - b.ch }
	
	function copyPos(x) {return Pos(x.line, x.ch)}
	function maxPos(a, b) { return cmp(a, b) < 0 ? b : a }
	function minPos(a, b) { return cmp(a, b) < 0 ? a : b }
	
	// Most of the external API clips given positions to make sure they
	// actually exist within the document.
	function clipLine(doc, n) {return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1))}
	function clipPos(doc, pos) {
	  if (pos.line < doc.first) { return Pos(doc.first, 0) }
	  var last = doc.first + doc.size - 1
	  if (pos.line > last) { return Pos(last, getLine(doc, last).text.length) }
	  return clipToLen(pos, getLine(doc, pos.line).text.length)
	}
	function clipToLen(pos, linelen) {
	  var ch = pos.ch
	  if (ch == null || ch > linelen) { return Pos(pos.line, linelen) }
	  else if (ch < 0) { return Pos(pos.line, 0) }
	  else { return pos }
	}
	function clipPosArray(doc, array) {
	  var out = []
	  for (var i = 0; i < array.length; i++) { out[i] = clipPos(doc, array[i]) }
	  return out
	}
	
	// Optimize some code when these features are not used.
	var sawReadOnlySpans = false;
	var sawCollapsedSpans = false;
	function seeReadOnlySpans() {
	  sawReadOnlySpans = true
	}
	
	function seeCollapsedSpans() {
	  sawCollapsedSpans = true
	}
	
	// TEXTMARKER SPANS
	
	function MarkedSpan(marker, from, to) {
	  this.marker = marker
	  this.from = from; this.to = to
	}
	
	// Search an array of spans for a span matching the given marker.
	function getMarkedSpanFor(spans, marker) {
	  if (spans) { for (var i = 0; i < spans.length; ++i) {
	    var span = spans[i]
	    if (span.marker == marker) { return span }
	  } }
	}
	// Remove a span from an array, returning undefined if no spans are
	// left (we don't store arrays for lines without spans).
	function removeMarkedSpan(spans, span) {
	  var r
	  for (var i = 0; i < spans.length; ++i)
	    { if (spans[i] != span) { (r || (r = [])).push(spans[i]) } }
	  return r
	}
	// Add a span to a line.
	function addMarkedSpan(line, span) {
	  line.markedSpans = line.markedSpans ? line.markedSpans.concat([span]) : [span]
	  span.marker.attachLine(line)
	}
	
	// Used for the algorithm that adjusts markers for a change in the
	// document. These functions cut an array of spans at a given
	// character position, returning an array of remaining chunks (or
	// undefined if nothing remains).
	function markedSpansBefore(old, startCh, isInsert) {
	  var nw
	  if (old) { for (var i = 0; i < old.length; ++i) {
	    var span = old[i], marker = span.marker
	    var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh)
	    if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
	      var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh)
	      ;(nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to))
	    }
	  } }
	  return nw
	}
	function markedSpansAfter(old, endCh, isInsert) {
	  var nw
	  if (old) { for (var i = 0; i < old.length; ++i) {
	    var span = old[i], marker = span.marker
	    var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh)
	    if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
	      var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh)
	      ;(nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh,
	                                            span.to == null ? null : span.to - endCh))
	    }
	  } }
	  return nw
	}
	
	// Given a change object, compute the new set of marker spans that
	// cover the line in which the change took place. Removes spans
	// entirely within the change, reconnects spans belonging to the
	// same marker that appear on both sides of the change, and cuts off
	// spans partially within the change. Returns an array of span
	// arrays with one element for each line in (after) the change.
	function stretchSpansOverChange(doc, change) {
	  if (change.full) { return null }
	  var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans
	  var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans
	  if (!oldFirst && !oldLast) { return null }
	
	  var startCh = change.from.ch, endCh = change.to.ch, isInsert = cmp(change.from, change.to) == 0
	  // Get the spans that 'stick out' on both sides
	  var first = markedSpansBefore(oldFirst, startCh, isInsert)
	  var last = markedSpansAfter(oldLast, endCh, isInsert)
	
	  // Next, merge those two ends
	  var sameLine = change.text.length == 1, offset = lst(change.text).length + (sameLine ? startCh : 0)
	  if (first) {
	    // Fix up .to properties of first
	    for (var i = 0; i < first.length; ++i) {
	      var span = first[i]
	      if (span.to == null) {
	        var found = getMarkedSpanFor(last, span.marker)
	        if (!found) { span.to = startCh }
	        else if (sameLine) { span.to = found.to == null ? null : found.to + offset }
	      }
	    }
	  }
	  if (last) {
	    // Fix up .from in last (or move them into first in case of sameLine)
	    for (var i$1 = 0; i$1 < last.length; ++i$1) {
	      var span$1 = last[i$1]
	      if (span$1.to != null) { span$1.to += offset }
	      if (span$1.from == null) {
	        var found$1 = getMarkedSpanFor(first, span$1.marker)
	        if (!found$1) {
	          span$1.from = offset
	          if (sameLine) { (first || (first = [])).push(span$1) }
	        }
	      } else {
	        span$1.from += offset
	        if (sameLine) { (first || (first = [])).push(span$1) }
	      }
	    }
	  }
	  // Make sure we didn't create any zero-length spans
	  if (first) { first = clearEmptySpans(first) }
	  if (last && last != first) { last = clearEmptySpans(last) }
	
	  var newMarkers = [first]
	  if (!sameLine) {
	    // Fill gap with whole-line-spans
	    var gap = change.text.length - 2, gapMarkers
	    if (gap > 0 && first)
	      { for (var i$2 = 0; i$2 < first.length; ++i$2)
	        { if (first[i$2].to == null)
	          { (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null)) } } }
	    for (var i$3 = 0; i$3 < gap; ++i$3)
	      { newMarkers.push(gapMarkers) }
	    newMarkers.push(last)
	  }
	  return newMarkers
	}
	
	// Remove spans that are empty and don't have a clearWhenEmpty
	// option of false.
	function clearEmptySpans(spans) {
	  for (var i = 0; i < spans.length; ++i) {
	    var span = spans[i]
	    if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false)
	      { spans.splice(i--, 1) }
	  }
	  if (!spans.length) { return null }
	  return spans
	}
	
	// Used to 'clip' out readOnly ranges when making a change.
	function removeReadOnlyRanges(doc, from, to) {
	  var markers = null
	  doc.iter(from.line, to.line + 1, function (line) {
	    if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
	      var mark = line.markedSpans[i].marker
	      if (mark.readOnly && (!markers || indexOf(markers, mark) == -1))
	        { (markers || (markers = [])).push(mark) }
	    } }
	  })
	  if (!markers) { return null }
	  var parts = [{from: from, to: to}]
	  for (var i = 0; i < markers.length; ++i) {
	    var mk = markers[i], m = mk.find(0)
	    for (var j = 0; j < parts.length; ++j) {
	      var p = parts[j]
	      if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) { continue }
	      var newParts = [j, 1], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to)
	      if (dfrom < 0 || !mk.inclusiveLeft && !dfrom)
	        { newParts.push({from: p.from, to: m.from}) }
	      if (dto > 0 || !mk.inclusiveRight && !dto)
	        { newParts.push({from: m.to, to: p.to}) }
	      parts.splice.apply(parts, newParts)
	      j += newParts.length - 1
	    }
	  }
	  return parts
	}
	
	// Connect or disconnect spans from a line.
	function detachMarkedSpans(line) {
	  var spans = line.markedSpans
	  if (!spans) { return }
	  for (var i = 0; i < spans.length; ++i)
	    { spans[i].marker.detachLine(line) }
	  line.markedSpans = null
	}
	function attachMarkedSpans(line, spans) {
	  if (!spans) { return }
	  for (var i = 0; i < spans.length; ++i)
	    { spans[i].marker.attachLine(line) }
	  line.markedSpans = spans
	}
	
	// Helpers used when computing which overlapping collapsed span
	// counts as the larger one.
	function extraLeft(marker) { return marker.inclusiveLeft ? -1 : 0 }
	function extraRight(marker) { return marker.inclusiveRight ? 1 : 0 }
	
	// Returns a number indicating which of two overlapping collapsed
	// spans is larger (and thus includes the other). Falls back to
	// comparing ids when the spans cover exactly the same range.
	function compareCollapsedMarkers(a, b) {
	  var lenDiff = a.lines.length - b.lines.length
	  if (lenDiff != 0) { return lenDiff }
	  var aPos = a.find(), bPos = b.find()
	  var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b)
	  if (fromCmp) { return -fromCmp }
	  var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b)
	  if (toCmp) { return toCmp }
	  return b.id - a.id
	}
	
	// Find out whether a line ends or starts in a collapsed span. If
	// so, return the marker for that span.
	function collapsedSpanAtSide(line, start) {
	  var sps = sawCollapsedSpans && line.markedSpans, found
	  if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
	    sp = sps[i]
	    if (sp.marker.collapsed && (start ? sp.from : sp.to) == null &&
	        (!found || compareCollapsedMarkers(found, sp.marker) < 0))
	      { found = sp.marker }
	  } }
	  return found
	}
	function collapsedSpanAtStart(line) { return collapsedSpanAtSide(line, true) }
	function collapsedSpanAtEnd(line) { return collapsedSpanAtSide(line, false) }
	
	// Test whether there exists a collapsed span that partially
	// overlaps (covers the start or end, but not both) of a new span.
	// Such overlap is not allowed.
	function conflictingCollapsedRange(doc, lineNo, from, to, marker) {
	  var line = getLine(doc, lineNo)
	  var sps = sawCollapsedSpans && line.markedSpans
	  if (sps) { for (var i = 0; i < sps.length; ++i) {
	    var sp = sps[i]
	    if (!sp.marker.collapsed) { continue }
	    var found = sp.marker.find(0)
	    var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker)
	    var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker)
	    if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) { continue }
	    if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) ||
	        fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0))
	      { return true }
	  } }
	}
	
	// A visual line is a line as drawn on the screen. Folding, for
	// example, can cause multiple logical lines to appear on the same
	// visual line. This finds the start of the visual line that the
	// given line is part of (usually that is the line itself).
	function visualLine(line) {
	  var merged
	  while (merged = collapsedSpanAtStart(line))
	    { line = merged.find(-1, true).line }
	  return line
	}
	
	// Returns an array of logical lines that continue the visual line
	// started by the argument, or undefined if there are no such lines.
	function visualLineContinued(line) {
	  var merged, lines
	  while (merged = collapsedSpanAtEnd(line)) {
	    line = merged.find(1, true).line
	    ;(lines || (lines = [])).push(line)
	  }
	  return lines
	}
	
	// Get the line number of the start of the visual line that the
	// given line number is part of.
	function visualLineNo(doc, lineN) {
	  var line = getLine(doc, lineN), vis = visualLine(line)
	  if (line == vis) { return lineN }
	  return lineNo(vis)
	}
	
	// Get the line number of the start of the next visual line after
	// the given line.
	function visualLineEndNo(doc, lineN) {
	  if (lineN > doc.lastLine()) { return lineN }
	  var line = getLine(doc, lineN), merged
	  if (!lineIsHidden(doc, line)) { return lineN }
	  while (merged = collapsedSpanAtEnd(line))
	    { line = merged.find(1, true).line }
	  return lineNo(line) + 1
	}
	
	// Compute whether a line is hidden. Lines count as hidden when they
	// are part of a visual line that starts with another line, or when
	// they are entirely covered by collapsed, non-widget span.
	function lineIsHidden(doc, line) {
	  var sps = sawCollapsedSpans && line.markedSpans
	  if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
	    sp = sps[i]
	    if (!sp.marker.collapsed) { continue }
	    if (sp.from == null) { return true }
	    if (sp.marker.widgetNode) { continue }
	    if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp))
	      { return true }
	  } }
	}
	function lineIsHiddenInner(doc, line, span) {
	  if (span.to == null) {
	    var end = span.marker.find(1, true)
	    return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker))
	  }
	  if (span.marker.inclusiveRight && span.to == line.text.length)
	    { return true }
	  for (var sp = (void 0), i = 0; i < line.markedSpans.length; ++i) {
	    sp = line.markedSpans[i]
	    if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to &&
	        (sp.to == null || sp.to != span.from) &&
	        (sp.marker.inclusiveLeft || span.marker.inclusiveRight) &&
	        lineIsHiddenInner(doc, line, sp)) { return true }
	  }
	}
	
	// Find the height above the given line.
	function heightAtLine(lineObj) {
	  lineObj = visualLine(lineObj)
	
	  var h = 0, chunk = lineObj.parent
	  for (var i = 0; i < chunk.lines.length; ++i) {
	    var line = chunk.lines[i]
	    if (line == lineObj) { break }
	    else { h += line.height }
	  }
	  for (var p = chunk.parent; p; chunk = p, p = chunk.parent) {
	    for (var i$1 = 0; i$1 < p.children.length; ++i$1) {
	      var cur = p.children[i$1]
	      if (cur == chunk) { break }
	      else { h += cur.height }
	    }
	  }
	  return h
	}
	
	// Compute the character length of a line, taking into account
	// collapsed ranges (see markText) that might hide parts, and join
	// other lines onto it.
	function lineLength(line) {
	  if (line.height == 0) { return 0 }
	  var len = line.text.length, merged, cur = line
	  while (merged = collapsedSpanAtStart(cur)) {
	    var found = merged.find(0, true)
	    cur = found.from.line
	    len += found.from.ch - found.to.ch
	  }
	  cur = line
	  while (merged = collapsedSpanAtEnd(cur)) {
	    var found$1 = merged.find(0, true)
	    len -= cur.text.length - found$1.from.ch
	    cur = found$1.to.line
	    len += cur.text.length - found$1.to.ch
	  }
	  return len
	}
	
	// Find the longest line in the document.
	function findMaxLine(cm) {
	  var d = cm.display, doc = cm.doc
	  d.maxLine = getLine(doc, doc.first)
	  d.maxLineLength = lineLength(d.maxLine)
	  d.maxLineChanged = true
	  doc.iter(function (line) {
	    var len = lineLength(line)
	    if (len > d.maxLineLength) {
	      d.maxLineLength = len
	      d.maxLine = line
	    }
	  })
	}
	
	// BIDI HELPERS
	
	function iterateBidiSections(order, from, to, f) {
	  if (!order) { return f(from, to, "ltr") }
	  var found = false
	  for (var i = 0; i < order.length; ++i) {
	    var part = order[i]
	    if (part.from < to && part.to > from || from == to && part.to == from) {
	      f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr")
	      found = true
	    }
	  }
	  if (!found) { f(from, to, "ltr") }
	}
	
	function bidiLeft(part) { return part.level % 2 ? part.to : part.from }
	function bidiRight(part) { return part.level % 2 ? part.from : part.to }
	
	function lineLeft(line) { var order = getOrder(line); return order ? bidiLeft(order[0]) : 0 }
	function lineRight(line) {
	  var order = getOrder(line)
	  if (!order) { return line.text.length }
	  return bidiRight(lst(order))
	}
	
	function compareBidiLevel(order, a, b) {
	  var linedir = order[0].level
	  if (a == linedir) { return true }
	  if (b == linedir) { return false }
	  return a < b
	}
	
	var bidiOther = null
	function getBidiPartAt(order, pos) {
	  var found
	  bidiOther = null
	  for (var i = 0; i < order.length; ++i) {
	    var cur = order[i]
	    if (cur.from < pos && cur.to > pos) { return i }
	    if ((cur.from == pos || cur.to == pos)) {
	      if (found == null) {
	        found = i
	      } else if (compareBidiLevel(order, cur.level, order[found].level)) {
	        if (cur.from != cur.to) { bidiOther = found }
	        return i
	      } else {
	        if (cur.from != cur.to) { bidiOther = i }
	        return found
	      }
	    }
	  }
	  return found
	}
	
	function moveInLine(line, pos, dir, byUnit) {
	  if (!byUnit) { return pos + dir }
	  do { pos += dir }
	  while (pos > 0 && isExtendingChar(line.text.charAt(pos)))
	  return pos
	}
	
	// This is needed in order to move 'visually' through bi-directional
	// text -- i.e., pressing left should make the cursor go left, even
	// when in RTL text. The tricky part is the 'jumps', where RTL and
	// LTR text touch each other. This often requires the cursor offset
	// to move more than one unit, in order to visually move one unit.
	function moveVisually(line, start, dir, byUnit) {
	  var bidi = getOrder(line)
	  if (!bidi) { return moveLogically(line, start, dir, byUnit) }
	  var pos = getBidiPartAt(bidi, start), part = bidi[pos]
	  var target = moveInLine(line, start, part.level % 2 ? -dir : dir, byUnit)
	
	  for (;;) {
	    if (target > part.from && target < part.to) { return target }
	    if (target == part.from || target == part.to) {
	      if (getBidiPartAt(bidi, target) == pos) { return target }
	      part = bidi[pos += dir]
	      return (dir > 0) == part.level % 2 ? part.to : part.from
	    } else {
	      part = bidi[pos += dir]
	      if (!part) { return null }
	      if ((dir > 0) == part.level % 2)
	        { target = moveInLine(line, part.to, -1, byUnit) }
	      else
	        { target = moveInLine(line, part.from, 1, byUnit) }
	    }
	  }
	}
	
	function moveLogically(line, start, dir, byUnit) {
	  var target = start + dir
	  if (byUnit) { while (target > 0 && isExtendingChar(line.text.charAt(target))) { target += dir } }
	  return target < 0 || target > line.text.length ? null : target
	}
	
	// Bidirectional ordering algorithm
	// See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
	// that this (partially) implements.
	
	// One-char codes used for character types:
	// L (L):   Left-to-Right
	// R (R):   Right-to-Left
	// r (AL):  Right-to-Left Arabic
	// 1 (EN):  European Number
	// + (ES):  European Number Separator
	// % (ET):  European Number Terminator
	// n (AN):  Arabic Number
	// , (CS):  Common Number Separator
	// m (NSM): Non-Spacing Mark
	// b (BN):  Boundary Neutral
	// s (B):   Paragraph Separator
	// t (S):   Segment Separator
	// w (WS):  Whitespace
	// N (ON):  Other Neutrals
	
	// Returns null if characters are ordered as they appear
	// (left-to-right), or an array of sections ({from, to, level}
	// objects) in the order in which they occur visually.
	var bidiOrdering = (function() {
	  // Character types for codepoints 0 to 0xff
	  var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN"
	  // Character types for codepoints 0x600 to 0x6f9
	  var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111"
	  function charType(code) {
	    if (code <= 0xf7) { return lowTypes.charAt(code) }
	    else if (0x590 <= code && code <= 0x5f4) { return "R" }
	    else if (0x600 <= code && code <= 0x6f9) { return arabicTypes.charAt(code - 0x600) }
	    else if (0x6ee <= code && code <= 0x8ac) { return "r" }
	    else if (0x2000 <= code && code <= 0x200b) { return "w" }
	    else if (code == 0x200c) { return "b" }
	    else { return "L" }
	  }
	
	  var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/
	  var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/
	  // Browsers seem to always treat the boundaries of block elements as being L.
	  var outerType = "L"
	
	  function BidiSpan(level, from, to) {
	    this.level = level
	    this.from = from; this.to = to
	  }
	
	  return function(str) {
	    if (!bidiRE.test(str)) { return false }
	    var len = str.length, types = []
	    for (var i = 0; i < len; ++i)
	      { types.push(charType(str.charCodeAt(i))) }
	
	    // W1. Examine each non-spacing mark (NSM) in the level run, and
	    // change the type of the NSM to the type of the previous
	    // character. If the NSM is at the start of the level run, it will
	    // get the type of sor.
	    for (var i$1 = 0, prev = outerType; i$1 < len; ++i$1) {
	      var type = types[i$1]
	      if (type == "m") { types[i$1] = prev }
	      else { prev = type }
	    }
	
	    // W2. Search backwards from each instance of a European number
	    // until the first strong type (R, L, AL, or sor) is found. If an
	    // AL is found, change the type of the European number to Arabic
	    // number.
	    // W3. Change all ALs to R.
	    for (var i$2 = 0, cur = outerType; i$2 < len; ++i$2) {
	      var type$1 = types[i$2]
	      if (type$1 == "1" && cur == "r") { types[i$2] = "n" }
	      else if (isStrong.test(type$1)) { cur = type$1; if (type$1 == "r") { types[i$2] = "R" } }
	    }
	
	    // W4. A single European separator between two European numbers
	    // changes to a European number. A single common separator between
	    // two numbers of the same type changes to that type.
	    for (var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3) {
	      var type$2 = types[i$3]
	      if (type$2 == "+" && prev$1 == "1" && types[i$3+1] == "1") { types[i$3] = "1" }
	      else if (type$2 == "," && prev$1 == types[i$3+1] &&
	               (prev$1 == "1" || prev$1 == "n")) { types[i$3] = prev$1 }
	      prev$1 = type$2
	    }
	
	    // W5. A sequence of European terminators adjacent to European
	    // numbers changes to all European numbers.
	    // W6. Otherwise, separators and terminators change to Other
	    // Neutral.
	    for (var i$4 = 0; i$4 < len; ++i$4) {
	      var type$3 = types[i$4]
	      if (type$3 == ",") { types[i$4] = "N" }
	      else if (type$3 == "%") {
	        var end = (void 0)
	        for (end = i$4 + 1; end < len && types[end] == "%"; ++end) {}
	        var replace = (i$4 && types[i$4-1] == "!") || (end < len && types[end] == "1") ? "1" : "N"
	        for (var j = i$4; j < end; ++j) { types[j] = replace }
	        i$4 = end - 1
	      }
	    }
	
	    // W7. Search backwards from each instance of a European number
	    // until the first strong type (R, L, or sor) is found. If an L is
	    // found, then change the type of the European number to L.
	    for (var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5) {
	      var type$4 = types[i$5]
	      if (cur$1 == "L" && type$4 == "1") { types[i$5] = "L" }
	      else if (isStrong.test(type$4)) { cur$1 = type$4 }
	    }
	
	    // N1. A sequence of neutrals takes the direction of the
	    // surrounding strong text if the text on both sides has the same
	    // direction. European and Arabic numbers act as if they were R in
	    // terms of their influence on neutrals. Start-of-level-run (sor)
	    // and end-of-level-run (eor) are used at level run boundaries.
	    // N2. Any remaining neutrals take the embedding direction.
	    for (var i$6 = 0; i$6 < len; ++i$6) {
	      if (isNeutral.test(types[i$6])) {
	        var end$1 = (void 0)
	        for (end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1) {}
	        var before = (i$6 ? types[i$6-1] : outerType) == "L"
	        var after = (end$1 < len ? types[end$1] : outerType) == "L"
	        var replace$1 = before || after ? "L" : "R"
	        for (var j$1 = i$6; j$1 < end$1; ++j$1) { types[j$1] = replace$1 }
	        i$6 = end$1 - 1
	      }
	    }
	
	    // Here we depart from the documented algorithm, in order to avoid
	    // building up an actual levels array. Since there are only three
	    // levels (0, 1, 2) in an implementation that doesn't take
	    // explicit embedding into account, we can build up the order on
	    // the fly, without following the level-based algorithm.
	    var order = [], m
	    for (var i$7 = 0; i$7 < len;) {
	      if (countsAsLeft.test(types[i$7])) {
	        var start = i$7
	        for (++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7) {}
	        order.push(new BidiSpan(0, start, i$7))
	      } else {
	        var pos = i$7, at = order.length
	        for (++i$7; i$7 < len && types[i$7] != "L"; ++i$7) {}
	        for (var j$2 = pos; j$2 < i$7;) {
	          if (countsAsNum.test(types[j$2])) {
	            if (pos < j$2) { order.splice(at, 0, new BidiSpan(1, pos, j$2)) }
	            var nstart = j$2
	            for (++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2) {}
	            order.splice(at, 0, new BidiSpan(2, nstart, j$2))
	            pos = j$2
	          } else { ++j$2 }
	        }
	        if (pos < i$7) { order.splice(at, 0, new BidiSpan(1, pos, i$7)) }
	      }
	    }
	    if (order[0].level == 1 && (m = str.match(/^\s+/))) {
	      order[0].from = m[0].length
	      order.unshift(new BidiSpan(0, 0, m[0].length))
	    }
	    if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
	      lst(order).to -= m[0].length
	      order.push(new BidiSpan(0, len - m[0].length, len))
	    }
	    if (order[0].level == 2)
	      { order.unshift(new BidiSpan(1, order[0].to, order[0].to)) }
	    if (order[0].level != lst(order).level)
	      { order.push(new BidiSpan(order[0].level, len, len)) }
	
	    return order
	  }
	})()
	
	// Get the bidi ordering for the given line (and cache it). Returns
	// false for lines that are fully left-to-right, and an array of
	// BidiSpan objects otherwise.
	function getOrder(line) {
	  var order = line.order
	  if (order == null) { order = line.order = bidiOrdering(line.text) }
	  return order
	}
	
	// EVENT HANDLING
	
	// Lightweight event framework. on/off also work on DOM nodes,
	// registering native DOM handlers.
	
	var noHandlers = []
	
	var on = function(emitter, type, f) {
	  if (emitter.addEventListener) {
	    emitter.addEventListener(type, f, false)
	  } else if (emitter.attachEvent) {
	    emitter.attachEvent("on" + type, f)
	  } else {
	    var map = emitter._handlers || (emitter._handlers = {})
	    map[type] = (map[type] || noHandlers).concat(f)
	  }
	}
	
	function getHandlers(emitter, type) {
	  return emitter._handlers && emitter._handlers[type] || noHandlers
	}
	
	function off(emitter, type, f) {
	  if (emitter.removeEventListener) {
	    emitter.removeEventListener(type, f, false)
	  } else if (emitter.detachEvent) {
	    emitter.detachEvent("on" + type, f)
	  } else {
	    var map = emitter._handlers, arr = map && map[type]
	    if (arr) {
	      var index = indexOf(arr, f)
	      if (index > -1)
	        { map[type] = arr.slice(0, index).concat(arr.slice(index + 1)) }
	    }
	  }
	}
	
	function signal(emitter, type /*, values...*/) {
	  var handlers = getHandlers(emitter, type)
	  if (!handlers.length) { return }
	  var args = Array.prototype.slice.call(arguments, 2)
	  for (var i = 0; i < handlers.length; ++i) { handlers[i].apply(null, args) }
	}
	
	// The DOM events that CodeMirror handles can be overridden by
	// registering a (non-DOM) handler on the editor for the event name,
	// and preventDefault-ing the event in that handler.
	function signalDOMEvent(cm, e, override) {
	  if (typeof e == "string")
	    { e = {type: e, preventDefault: function() { this.defaultPrevented = true }} }
	  signal(cm, override || e.type, cm, e)
	  return e_defaultPrevented(e) || e.codemirrorIgnore
	}
	
	function signalCursorActivity(cm) {
	  var arr = cm._handlers && cm._handlers.cursorActivity
	  if (!arr) { return }
	  var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = [])
	  for (var i = 0; i < arr.length; ++i) { if (indexOf(set, arr[i]) == -1)
	    { set.push(arr[i]) } }
	}
	
	function hasHandler(emitter, type) {
	  return getHandlers(emitter, type).length > 0
	}
	
	// Add on and off methods to a constructor's prototype, to make
	// registering events on such objects more convenient.
	function eventMixin(ctor) {
	  ctor.prototype.on = function(type, f) {on(this, type, f)}
	  ctor.prototype.off = function(type, f) {off(this, type, f)}
	}
	
	// Due to the fact that we still support jurassic IE versions, some
	// compatibility wrappers are needed.
	
	function e_preventDefault(e) {
	  if (e.preventDefault) { e.preventDefault() }
	  else { e.returnValue = false }
	}
	function e_stopPropagation(e) {
	  if (e.stopPropagation) { e.stopPropagation() }
	  else { e.cancelBubble = true }
	}
	function e_defaultPrevented(e) {
	  return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false
	}
	function e_stop(e) {e_preventDefault(e); e_stopPropagation(e)}
	
	function e_target(e) {return e.target || e.srcElement}
	function e_button(e) {
	  var b = e.which
	  if (b == null) {
	    if (e.button & 1) { b = 1 }
	    else if (e.button & 2) { b = 3 }
	    else if (e.button & 4) { b = 2 }
	  }
	  if (mac && e.ctrlKey && b == 1) { b = 3 }
	  return b
	}
	
	// Detect drag-and-drop
	var dragAndDrop = function() {
	  // There is *some* kind of drag-and-drop support in IE6-8, but I
	  // couldn't get it to work yet.
	  if (ie && ie_version < 9) { return false }
	  var div = elt('div')
	  return "draggable" in div || "dragDrop" in div
	}()
	
	var zwspSupported
	function zeroWidthElement(measure) {
	  if (zwspSupported == null) {
	    var test = elt("span", "\u200b")
	    removeChildrenAndAdd(measure, elt("span", [test, document.createTextNode("x")]))
	    if (measure.firstChild.offsetHeight != 0)
	      { zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8) }
	  }
	  var node = zwspSupported ? elt("span", "\u200b") :
	    elt("span", "\u00a0", null, "display: inline-block; width: 1px; margin-right: -1px")
	  node.setAttribute("cm-text", "")
	  return node
	}
	
	// Feature-detect IE's crummy client rect reporting for bidi text
	var badBidiRects
	function hasBadBidiRects(measure) {
	  if (badBidiRects != null) { return badBidiRects }
	  var txt = removeChildrenAndAdd(measure, document.createTextNode("A\u062eA"))
	  var r0 = range(txt, 0, 1).getBoundingClientRect()
	  var r1 = range(txt, 1, 2).getBoundingClientRect()
	  removeChildren(measure)
	  if (!r0 || r0.left == r0.right) { return false } // Safari returns null in some cases (#2780)
	  return badBidiRects = (r1.right - r0.right < 3)
	}
	
	// See if "".split is the broken IE version, if so, provide an
	// alternative way to split lines.
	var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function (string) {
	  var pos = 0, result = [], l = string.length
	  while (pos <= l) {
	    var nl = string.indexOf("\n", pos)
	    if (nl == -1) { nl = string.length }
	    var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl)
	    var rt = line.indexOf("\r")
	    if (rt != -1) {
	      result.push(line.slice(0, rt))
	      pos += rt + 1
	    } else {
	      result.push(line)
	      pos = nl + 1
	    }
	  }
	  return result
	} : function (string) { return string.split(/\r\n?|\n/); }
	
	var hasSelection = window.getSelection ? function (te) {
	  try { return te.selectionStart != te.selectionEnd }
	  catch(e) { return false }
	} : function (te) {
	  var range
	  try {range = te.ownerDocument.selection.createRange()}
	  catch(e) {}
	  if (!range || range.parentElement() != te) { return false }
	  return range.compareEndPoints("StartToEnd", range) != 0
	}
	
	var hasCopyEvent = (function () {
	  var e = elt("div")
	  if ("oncopy" in e) { return true }
	  e.setAttribute("oncopy", "return;")
	  return typeof e.oncopy == "function"
	})()
	
	var badZoomedRects = null
	function hasBadZoomedRects(measure) {
	  if (badZoomedRects != null) { return badZoomedRects }
	  var node = removeChildrenAndAdd(measure, elt("span", "x"))
	  var normal = node.getBoundingClientRect()
	  var fromRange = range(node, 0, 1).getBoundingClientRect()
	  return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1
	}
	
	var modes = {};
	var mimeModes = {};
	// Extra arguments are stored as the mode's dependencies, which is
	// used by (legacy) mechanisms like loadmode.js to automatically
	// load a mode. (Preferred mechanism is the require/define calls.)
	function defineMode(name, mode) {
	  if (arguments.length > 2)
	    { mode.dependencies = Array.prototype.slice.call(arguments, 2) }
	  modes[name] = mode
	}
	
	function defineMIME(mime, spec) {
	  mimeModes[mime] = spec
	}
	
	// Given a MIME type, a {name, ...options} config object, or a name
	// string, return a mode config object.
	function resolveMode(spec) {
	  if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) {
	    spec = mimeModes[spec]
	  } else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
	    var found = mimeModes[spec.name]
	    if (typeof found == "string") { found = {name: found} }
	    spec = createObj(found, spec)
	    spec.name = found.name
	  } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) {
	    return resolveMode("application/xml")
	  } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) {
	    return resolveMode("application/json")
	  }
	  if (typeof spec == "string") { return {name: spec} }
	  else { return spec || {name: "null"} }
	}
	
	// Given a mode spec (anything that resolveMode accepts), find and
	// initialize an actual mode object.
	function getMode(options, spec) {
	  spec = resolveMode(spec)
	  var mfactory = modes[spec.name]
	  if (!mfactory) { return getMode(options, "text/plain") }
	  var modeObj = mfactory(options, spec)
	  if (modeExtensions.hasOwnProperty(spec.name)) {
	    var exts = modeExtensions[spec.name]
	    for (var prop in exts) {
	      if (!exts.hasOwnProperty(prop)) { continue }
	      if (modeObj.hasOwnProperty(prop)) { modeObj["_" + prop] = modeObj[prop] }
	      modeObj[prop] = exts[prop]
	    }
	  }
	  modeObj.name = spec.name
	  if (spec.helperType) { modeObj.helperType = spec.helperType }
	  if (spec.modeProps) { for (var prop$1 in spec.modeProps)
	    { modeObj[prop$1] = spec.modeProps[prop$1] } }
	
	  return modeObj
	}
	
	// This can be used to attach properties to mode objects from
	// outside the actual mode definition.
	var modeExtensions = {}
	function extendMode(mode, properties) {
	  var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : (modeExtensions[mode] = {})
	  copyObj(properties, exts)
	}
	
	function copyState(mode, state) {
	  if (state === true) { return state }
	  if (mode.copyState) { return mode.copyState(state) }
	  var nstate = {}
	  for (var n in state) {
	    var val = state[n]
	    if (val instanceof Array) { val = val.concat([]) }
	    nstate[n] = val
	  }
	  return nstate
	}
	
	// Given a mode and a state (for that mode), find the inner mode and
	// state at the position that the state refers to.
	function innerMode(mode, state) {
	  var info
	  while (mode.innerMode) {
	    info = mode.innerMode(state)
	    if (!info || info.mode == mode) { break }
	    state = info.state
	    mode = info.mode
	  }
	  return info || {mode: mode, state: state}
	}
	
	function startState(mode, a1, a2) {
	  return mode.startState ? mode.startState(a1, a2) : true
	}
	
	// STRING STREAM
	
	// Fed to the mode parsers, provides helper functions to make
	// parsers more succinct.
	
	var StringStream = function(string, tabSize) {
	  this.pos = this.start = 0
	  this.string = string
	  this.tabSize = tabSize || 8
	  this.lastColumnPos = this.lastColumnValue = 0
	  this.lineStart = 0
	}
	
	StringStream.prototype = {
	  eol: function() {return this.pos >= this.string.length},
	  sol: function() {return this.pos == this.lineStart},
	  peek: function() {return this.string.charAt(this.pos) || undefined},
	  next: function() {
	    if (this.pos < this.string.length)
	      { return this.string.charAt(this.pos++) }
	  },
	  eat: function(match) {
	    var ch = this.string.charAt(this.pos)
	    var ok
	    if (typeof match == "string") { ok = ch == match }
	    else { ok = ch && (match.test ? match.test(ch) : match(ch)) }
	    if (ok) {++this.pos; return ch}
	  },
	  eatWhile: function(match) {
	    var start = this.pos
	    while (this.eat(match)){}
	    return this.pos > start
	  },
	  eatSpace: function() {
	    var this$1 = this;
	
	    var start = this.pos
	    while (/[\s\u00a0]/.test(this.string.charAt(this.pos))) { ++this$1.pos }
	    return this.pos > start
	  },
	  skipToEnd: function() {this.pos = this.string.length},
	  skipTo: function(ch) {
	    var found = this.string.indexOf(ch, this.pos)
	    if (found > -1) {this.pos = found; return true}
	  },
	  backUp: function(n) {this.pos -= n},
	  column: function() {
	    if (this.lastColumnPos < this.start) {
	      this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue)
	      this.lastColumnPos = this.start
	    }
	    return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
	  },
	  indentation: function() {
	    return countColumn(this.string, null, this.tabSize) -
	      (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
	  },
	  match: function(pattern, consume, caseInsensitive) {
	    if (typeof pattern == "string") {
	      var cased = function (str) { return caseInsensitive ? str.toLowerCase() : str; }
	      var substr = this.string.substr(this.pos, pattern.length)
	      if (cased(substr) == cased(pattern)) {
	        if (consume !== false) { this.pos += pattern.length }
	        return true
	      }
	    } else {
	      var match = this.string.slice(this.pos).match(pattern)
	      if (match && match.index > 0) { return null }
	      if (match && consume !== false) { this.pos += match[0].length }
	      return match
	    }
	  },
	  current: function(){return this.string.slice(this.start, this.pos)},
	  hideFirstChars: function(n, inner) {
	    this.lineStart += n
	    try { return inner() }
	    finally { this.lineStart -= n }
	  }
	}
	
	// Compute a style array (an array starting with a mode generation
	// -- for invalidation -- followed by pairs of end positions and
	// style strings), which is used to highlight the tokens on the
	// line.
	function highlightLine(cm, line, state, forceToEnd) {
	  // A styles array always starts with a number identifying the
	  // mode/overlays that it is based on (for easy invalidation).
	  var st = [cm.state.modeGen], lineClasses = {}
	  // Compute the base array of styles
	  runMode(cm, line.text, cm.doc.mode, state, function (end, style) { return st.push(end, style); },
	    lineClasses, forceToEnd)
	
	  // Run overlays, adjust style array.
	  var loop = function ( o ) {
	    var overlay = cm.state.overlays[o], i = 1, at = 0
	    runMode(cm, line.text, overlay.mode, true, function (end, style) {
	      var start = i
	      // Ensure there's a token end at the current position, and that i points at it
	      while (at < end) {
	        var i_end = st[i]
	        if (i_end > end)
	          { st.splice(i, 1, end, st[i+1], i_end) }
	        i += 2
	        at = Math.min(end, i_end)
	      }
	      if (!style) { return }
	      if (overlay.opaque) {
	        st.splice(start, i - start, end, "overlay " + style)
	        i = start + 2
	      } else {
	        for (; start < i; start += 2) {
	          var cur = st[start+1]
	          st[start+1] = (cur ? cur + " " : "") + "overlay " + style
	        }
	      }
	    }, lineClasses)
	  };
	
	  for (var o = 0; o < cm.state.overlays.length; ++o) loop( o );
	
	  return {styles: st, classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null}
	}
	
	function getLineStyles(cm, line, updateFrontier) {
	  if (!line.styles || line.styles[0] != cm.state.modeGen) {
	    var state = getStateBefore(cm, lineNo(line))
	    var result = highlightLine(cm, line, line.text.length > cm.options.maxHighlightLength ? copyState(cm.doc.mode, state) : state)
	    line.stateAfter = state
	    line.styles = result.styles
	    if (result.classes) { line.styleClasses = result.classes }
	    else if (line.styleClasses) { line.styleClasses = null }
	    if (updateFrontier === cm.doc.frontier) { cm.doc.frontier++ }
	  }
	  return line.styles
	}
	
	function getStateBefore(cm, n, precise) {
	  var doc = cm.doc, display = cm.display
	  if (!doc.mode.startState) { return true }
	  var pos = findStartLine(cm, n, precise), state = pos > doc.first && getLine(doc, pos-1).stateAfter
	  if (!state) { state = startState(doc.mode) }
	  else { state = copyState(doc.mode, state) }
	  doc.iter(pos, n, function (line) {
	    processLine(cm, line.text, state)
	    var save = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo
	    line.stateAfter = save ? copyState(doc.mode, state) : null
	    ++pos
	  })
	  if (precise) { doc.frontier = pos }
	  return state
	}
	
	// Lightweight form of highlight -- proceed over this line and
	// update state, but don't save a style array. Used for lines that
	// aren't currently visible.
	function processLine(cm, text, state, startAt) {
	  var mode = cm.doc.mode
	  var stream = new StringStream(text, cm.options.tabSize)
	  stream.start = stream.pos = startAt || 0
	  if (text == "") { callBlankLine(mode, state) }
	  while (!stream.eol()) {
	    readToken(mode, stream, state)
	    stream.start = stream.pos
	  }
	}
	
	function callBlankLine(mode, state) {
	  if (mode.blankLine) { return mode.blankLine(state) }
	  if (!mode.innerMode) { return }
	  var inner = innerMode(mode, state)
	  if (inner.mode.blankLine) { return inner.mode.blankLine(inner.state) }
	}
	
	function readToken(mode, stream, state, inner) {
	  for (var i = 0; i < 10; i++) {
	    if (inner) { inner[0] = innerMode(mode, state).mode }
	    var style = mode.token(stream, state)
	    if (stream.pos > stream.start) { return style }
	  }
	  throw new Error("Mode " + mode.name + " failed to advance stream.")
	}
	
	// Utility for getTokenAt and getLineTokens
	function takeToken(cm, pos, precise, asArray) {
	  var getObj = function (copy) { return ({
	    start: stream.start, end: stream.pos,
	    string: stream.current(),
	    type: style || null,
	    state: copy ? copyState(doc.mode, state) : state
	  }); }
	
	  var doc = cm.doc, mode = doc.mode, style
	  pos = clipPos(doc, pos)
	  var line = getLine(doc, pos.line), state = getStateBefore(cm, pos.line, precise)
	  var stream = new StringStream(line.text, cm.options.tabSize), tokens
	  if (asArray) { tokens = [] }
	  while ((asArray || stream.pos < pos.ch) && !stream.eol()) {
	    stream.start = stream.pos
	    style = readToken(mode, stream, state)
	    if (asArray) { tokens.push(getObj(true)) }
	  }
	  return asArray ? tokens : getObj()
	}
	
	function extractLineClasses(type, output) {
	  if (type) { for (;;) {
	    var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/)
	    if (!lineClass) { break }
	    type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length)
	    var prop = lineClass[1] ? "bgClass" : "textClass"
	    if (output[prop] == null)
	      { output[prop] = lineClass[2] }
	    else if (!(new RegExp("(?:^|\s)" + lineClass[2] + "(?:$|\s)")).test(output[prop]))
	      { output[prop] += " " + lineClass[2] }
	  } }
	  return type
	}
	
	// Run the given mode's parser over a line, calling f for each token.
	function runMode(cm, text, mode, state, f, lineClasses, forceToEnd) {
	  var flattenSpans = mode.flattenSpans
	  if (flattenSpans == null) { flattenSpans = cm.options.flattenSpans }
	  var curStart = 0, curStyle = null
	  var stream = new StringStream(text, cm.options.tabSize), style
	  var inner = cm.options.addModeClass && [null]
	  if (text == "") { extractLineClasses(callBlankLine(mode, state), lineClasses) }
	  while (!stream.eol()) {
	    if (stream.pos > cm.options.maxHighlightLength) {
	      flattenSpans = false
	      if (forceToEnd) { processLine(cm, text, state, stream.pos) }
	      stream.pos = text.length
	      style = null
	    } else {
	      style = extractLineClasses(readToken(mode, stream, state, inner), lineClasses)
	    }
	    if (inner) {
	      var mName = inner[0].name
	      if (mName) { style = "m-" + (style ? mName + " " + style : mName) }
	    }
	    if (!flattenSpans || curStyle != style) {
	      while (curStart < stream.start) {
	        curStart = Math.min(stream.start, curStart + 5000)
	        f(curStart, curStyle)
	      }
	      curStyle = style
	    }
	    stream.start = stream.pos
	  }
	  while (curStart < stream.pos) {
	    // Webkit seems to refuse to render text nodes longer than 57444
	    // characters, and returns inaccurate measurements in nodes
	    // starting around 5000 chars.
	    var pos = Math.min(stream.pos, curStart + 5000)
	    f(pos, curStyle)
	    curStart = pos
	  }
	}
	
	// Finds the line to start with when starting a parse. Tries to
	// find a line with a stateAfter, so that it can start with a
	// valid state. If that fails, it returns the line with the
	// smallest indentation, which tends to need the least context to
	// parse correctly.
	function findStartLine(cm, n, precise) {
	  var minindent, minline, doc = cm.doc
	  var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100)
	  for (var search = n; search > lim; --search) {
	    if (search <= doc.first) { return doc.first }
	    var line = getLine(doc, search - 1)
	    if (line.stateAfter && (!precise || search <= doc.frontier)) { return search }
	    var indented = countColumn(line.text, null, cm.options.tabSize)
	    if (minline == null || minindent > indented) {
	      minline = search - 1
	      minindent = indented
	    }
	  }
	  return minline
	}
	
	// LINE DATA STRUCTURE
	
	// Line objects. These hold state related to a line, including
	// highlighting info (the styles array).
	function Line(text, markedSpans, estimateHeight) {
	  this.text = text
	  attachMarkedSpans(this, markedSpans)
	  this.height = estimateHeight ? estimateHeight(this) : 1
	}
	eventMixin(Line)
	Line.prototype.lineNo = function() { return lineNo(this) }
	
	// Change the content (text, markers) of a line. Automatically
	// invalidates cached information and tries to re-estimate the
	// line's height.
	function updateLine(line, text, markedSpans, estimateHeight) {
	  line.text = text
	  if (line.stateAfter) { line.stateAfter = null }
	  if (line.styles) { line.styles = null }
	  if (line.order != null) { line.order = null }
	  detachMarkedSpans(line)
	  attachMarkedSpans(line, markedSpans)
	  var estHeight = estimateHeight ? estimateHeight(line) : 1
	  if (estHeight != line.height) { updateLineHeight(line, estHeight) }
	}
	
	// Detach a line from the document tree and its markers.
	function cleanUpLine(line) {
	  line.parent = null
	  detachMarkedSpans(line)
	}
	
	// Convert a style as returned by a mode (either null, or a string
	// containing one or more styles) to a CSS style. This is cached,
	// and also looks for line-wide styles.
	var styleToClassCache = {};
	var styleToClassCacheWithMode = {};
	function interpretTokenStyle(style, options) {
	  if (!style || /^\s*$/.test(style)) { return null }
	  var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache
	  return cache[style] ||
	    (cache[style] = style.replace(/\S+/g, "cm-$&"))
	}
	
	// Render the DOM representation of the text of a line. Also builds
	// up a 'line map', which points at the DOM nodes that represent
	// specific stretches of text, and is used by the measuring code.
	// The returned object contains the DOM node, this map, and
	// information about line-wide styles that were set by the mode.
	function buildLineContent(cm, lineView) {
	  // The padding-right forces the element to have a 'border', which
	  // is needed on Webkit to be able to get line-level bounding
	  // rectangles for it (in measureChar).
	  var content = elt("span", null, null, webkit ? "padding-right: .1px" : null)
	  var builder = {pre: elt("pre", [content], "CodeMirror-line"), content: content,
	                 col: 0, pos: 0, cm: cm,
	                 trailingSpace: false,
	                 splitSpaces: (ie || webkit) && cm.getOption("lineWrapping")}
	  // hide from accessibility tree
	  content.setAttribute("role", "presentation")
	  builder.pre.setAttribute("role", "presentation")
	  lineView.measure = {}
	
	  // Iterate over the logical lines that make up this visual line.
	  for (var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++) {
	    var line = i ? lineView.rest[i - 1] : lineView.line, order = (void 0)
	    builder.pos = 0
	    builder.addToken = buildToken
	    // Optionally wire in some hacks into the token-rendering
	    // algorithm, to deal with browser quirks.
	    if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line)))
	      { builder.addToken = buildTokenBadBidi(builder.addToken, order) }
	    builder.map = []
	    var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line)
	    insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate))
	    if (line.styleClasses) {
	      if (line.styleClasses.bgClass)
	        { builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || "") }
	      if (line.styleClasses.textClass)
	        { builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || "") }
	    }
	
	    // Ensure at least a single node is present, for measuring.
	    if (builder.map.length == 0)
	      { builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure))) }
	
	    // Store the map and a cache object for the current logical line
	    if (i == 0) {
	      lineView.measure.map = builder.map
	      lineView.measure.cache = {}
	    } else {
	      ;(lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map)
	      ;(lineView.measure.caches || (lineView.measure.caches = [])).push({})
	    }
	  }
	
	  // See issue #2901
	  if (webkit) {
	    var last = builder.content.lastChild
	    if (/\bcm-tab\b/.test(last.className) || (last.querySelector && last.querySelector(".cm-tab")))
	      { builder.content.className = "cm-tab-wrap-hack" }
	  }
	
	  signal(cm, "renderLine", cm, lineView.line, builder.pre)
	  if (builder.pre.className)
	    { builder.textClass = joinClasses(builder.pre.className, builder.textClass || "") }
	
	  return builder
	}
	
	function defaultSpecialCharPlaceholder(ch) {
	  var token = elt("span", "\u2022", "cm-invalidchar")
	  token.title = "\\u" + ch.charCodeAt(0).toString(16)
	  token.setAttribute("aria-label", token.title)
	  return token
	}
	
	// Build up the DOM representation for a single token, and add it to
	// the line map. Takes care to render special characters separately.
	function buildToken(builder, text, style, startStyle, endStyle, title, css) {
	  if (!text) { return }
	  var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text
	  var special = builder.cm.state.specialChars, mustWrap = false
	  var content
	  if (!special.test(text)) {
	    builder.col += text.length
	    content = document.createTextNode(displayText)
	    builder.map.push(builder.pos, builder.pos + text.length, content)
	    if (ie && ie_version < 9) { mustWrap = true }
	    builder.pos += text.length
	  } else {
	    content = document.createDocumentFragment()
	    var pos = 0
	    while (true) {
	      special.lastIndex = pos
	      var m = special.exec(text)
	      var skipped = m ? m.index - pos : text.length - pos
	      if (skipped) {
	        var txt = document.createTextNode(displayText.slice(pos, pos + skipped))
	        if (ie && ie_version < 9) { content.appendChild(elt("span", [txt])) }
	        else { content.appendChild(txt) }
	        builder.map.push(builder.pos, builder.pos + skipped, txt)
	        builder.col += skipped
	        builder.pos += skipped
	      }
	      if (!m) { break }
	      pos += skipped + 1
	      var txt$1 = (void 0)
	      if (m[0] == "\t") {
	        var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize
	        txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"))
	        txt$1.setAttribute("role", "presentation")
	        txt$1.setAttribute("cm-text", "\t")
	        builder.col += tabWidth
	      } else if (m[0] == "\r" || m[0] == "\n") {
	        txt$1 = content.appendChild(elt("span", m[0] == "\r" ? "\u240d" : "\u2424", "cm-invalidchar"))
	        txt$1.setAttribute("cm-text", m[0])
	        builder.col += 1
	      } else {
	        txt$1 = builder.cm.options.specialCharPlaceholder(m[0])
	        txt$1.setAttribute("cm-text", m[0])
	        if (ie && ie_version < 9) { content.appendChild(elt("span", [txt$1])) }
	        else { content.appendChild(txt$1) }
	        builder.col += 1
	      }
	      builder.map.push(builder.pos, builder.pos + 1, txt$1)
	      builder.pos++
	    }
	  }
	  builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32
	  if (style || startStyle || endStyle || mustWrap || css) {
	    var fullStyle = style || ""
	    if (startStyle) { fullStyle += startStyle }
	    if (endStyle) { fullStyle += endStyle }
	    var token = elt("span", [content], fullStyle, css)
	    if (title) { token.title = title }
	    return builder.content.appendChild(token)
	  }
	  builder.content.appendChild(content)
	}
	
	function splitSpaces(text, trailingBefore) {
	  if (text.length > 1 && !/  /.test(text)) { return text }
	  var spaceBefore = trailingBefore, result = ""
	  for (var i = 0; i < text.length; i++) {
	    var ch = text.charAt(i)
	    if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32))
	      { ch = "\u00a0" }
	    result += ch
	    spaceBefore = ch == " "
	  }
	  return result
	}
	
	// Work around nonsense dimensions being reported for stretches of
	// right-to-left text.
	function buildTokenBadBidi(inner, order) {
	  return function (builder, text, style, startStyle, endStyle, title, css) {
	    style = style ? style + " cm-force-border" : "cm-force-border"
	    var start = builder.pos, end = start + text.length
	    for (;;) {
	      // Find the part that overlaps with the start of this text
	      var part = (void 0)
	      for (var i = 0; i < order.length; i++) {
	        part = order[i]
	        if (part.to > start && part.from <= start) { break }
	      }
	      if (part.to >= end) { return inner(builder, text, style, startStyle, endStyle, title, css) }
	      inner(builder, text.slice(0, part.to - start), style, startStyle, null, title, css)
	      startStyle = null
	      text = text.slice(part.to - start)
	      start = part.to
	    }
	  }
	}
	
	function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
	  var widget = !ignoreWidget && marker.widgetNode
	  if (widget) { builder.map.push(builder.pos, builder.pos + size, widget) }
	  if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
	    if (!widget)
	      { widget = builder.content.appendChild(document.createElement("span")) }
	    widget.setAttribute("cm-marker", marker.id)
	  }
	  if (widget) {
	    builder.cm.display.input.setUneditable(widget)
	    builder.content.appendChild(widget)
	  }
	  builder.pos += size
	  builder.trailingSpace = false
	}
	
	// Outputs a number of spans to make up a line, taking highlighting
	// and marked text into account.
	function insertLineContent(line, builder, styles) {
	  var spans = line.markedSpans, allText = line.text, at = 0
	  if (!spans) {
	    for (var i$1 = 1; i$1 < styles.length; i$1+=2)
	      { builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1+1], builder.cm.options)) }
	    return
	  }
	
	  var len = allText.length, pos = 0, i = 1, text = "", style, css
	  var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, title, collapsed
	  for (;;) {
	    if (nextChange == pos) { // Update current marker set
	      spanStyle = spanEndStyle = spanStartStyle = title = css = ""
	      collapsed = null; nextChange = Infinity
	      var foundBookmarks = [], endStyles = (void 0)
	      for (var j = 0; j < spans.length; ++j) {
	        var sp = spans[j], m = sp.marker
	        if (m.type == "bookmark" && sp.from == pos && m.widgetNode) {
	          foundBookmarks.push(m)
	        } else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
	          if (sp.to != null && sp.to != pos && nextChange > sp.to) {
	            nextChange = sp.to
	            spanEndStyle = ""
	          }
	          if (m.className) { spanStyle += " " + m.className }
	          if (m.css) { css = (css ? css + ";" : "") + m.css }
	          if (m.startStyle && sp.from == pos) { spanStartStyle += " " + m.startStyle }
	          if (m.endStyle && sp.to == nextChange) { (endStyles || (endStyles = [])).push(m.endStyle, sp.to) }
	          if (m.title && !title) { title = m.title }
	          if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0))
	            { collapsed = sp }
	        } else if (sp.from > pos && nextChange > sp.from) {
	          nextChange = sp.from
	        }
	      }
	      if (endStyles) { for (var j$1 = 0; j$1 < endStyles.length; j$1 += 2)
	        { if (endStyles[j$1 + 1] == nextChange) { spanEndStyle += " " + endStyles[j$1] } } }
	
	      if (!collapsed || collapsed.from == pos) { for (var j$2 = 0; j$2 < foundBookmarks.length; ++j$2)
	        { buildCollapsedSpan(builder, 0, foundBookmarks[j$2]) } }
	      if (collapsed && (collapsed.from || 0) == pos) {
	        buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos,
	                           collapsed.marker, collapsed.from == null)
	        if (collapsed.to == null) { return }
	        if (collapsed.to == pos) { collapsed = false }
	      }
	    }
	    if (pos >= len) { break }
	
	    var upto = Math.min(len, nextChange)
	    while (true) {
	      if (text) {
	        var end = pos + text.length
	        if (!collapsed) {
	          var tokenText = end > upto ? text.slice(0, upto - pos) : text
	          builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle,
	                           spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", title, css)
	        }
	        if (end >= upto) {text = text.slice(upto - pos); pos = upto; break}
	        pos = end
	        spanStartStyle = ""
	      }
	      text = allText.slice(at, at = styles[i++])
	      style = interpretTokenStyle(styles[i++], builder.cm.options)
	    }
	  }
	}
	
	
	// These objects are used to represent the visible (currently drawn)
	// part of the document. A LineView may correspond to multiple
	// logical lines, if those are connected by collapsed ranges.
	function LineView(doc, line, lineN) {
	  // The starting line
	  this.line = line
	  // Continuing lines, if any
	  this.rest = visualLineContinued(line)
	  // Number of logical lines in this visual line
	  this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1
	  this.node = this.text = null
	  this.hidden = lineIsHidden(doc, line)
	}
	
	// Create a range of LineView objects for the given lines.
	function buildViewArray(cm, from, to) {
	  var array = [], nextPos
	  for (var pos = from; pos < to; pos = nextPos) {
	    var view = new LineView(cm.doc, getLine(cm.doc, pos), pos)
	    nextPos = pos + view.size
	    array.push(view)
	  }
	  return array
	}
	
	var operationGroup = null
	
	function pushOperation(op) {
	  if (operationGroup) {
	    operationGroup.ops.push(op)
	  } else {
	    op.ownsGroup = operationGroup = {
	      ops: [op],
	      delayedCallbacks: []
	    }
	  }
	}
	
	function fireCallbacksForOps(group) {
	  // Calls delayed callbacks and cursorActivity handlers until no
	  // new ones appear
	  var callbacks = group.delayedCallbacks, i = 0
	  do {
	    for (; i < callbacks.length; i++)
	      { callbacks[i].call(null) }
	    for (var j = 0; j < group.ops.length; j++) {
	      var op = group.ops[j]
	      if (op.cursorActivityHandlers)
	        { while (op.cursorActivityCalled < op.cursorActivityHandlers.length)
	          { op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm) } }
	    }
	  } while (i < callbacks.length)
	}
	
	function finishOperation(op, endCb) {
	  var group = op.ownsGroup
	  if (!group) { return }
	
	  try { fireCallbacksForOps(group) }
	  finally {
	    operationGroup = null
	    endCb(group)
	  }
	}
	
	var orphanDelayedCallbacks = null
	
	// Often, we want to signal events at a point where we are in the
	// middle of some work, but don't want the handler to start calling
	// other methods on the editor, which might be in an inconsistent
	// state or simply not expect any other events to happen.
	// signalLater looks whether there are any handlers, and schedules
	// them to be executed when the last operation ends, or, if no
	// operation is active, when a timeout fires.
	function signalLater(emitter, type /*, values...*/) {
	  var arr = getHandlers(emitter, type)
	  if (!arr.length) { return }
	  var args = Array.prototype.slice.call(arguments, 2), list
	  if (operationGroup) {
	    list = operationGroup.delayedCallbacks
	  } else if (orphanDelayedCallbacks) {
	    list = orphanDelayedCallbacks
	  } else {
	    list = orphanDelayedCallbacks = []
	    setTimeout(fireOrphanDelayed, 0)
	  }
	  var loop = function ( i ) {
	    list.push(function () { return arr[i].apply(null, args); })
	  };
	
	  for (var i = 0; i < arr.length; ++i)
	    loop( i );
	}
	
	function fireOrphanDelayed() {
	  var delayed = orphanDelayedCallbacks
	  orphanDelayedCallbacks = null
	  for (var i = 0; i < delayed.length; ++i) { delayed[i]() }
	}
	
	// When an aspect of a line changes, a string is added to
	// lineView.changes. This updates the relevant part of the line's
	// DOM structure.
	function updateLineForChanges(cm, lineView, lineN, dims) {
	  for (var j = 0; j < lineView.changes.length; j++) {
	    var type = lineView.changes[j]
	    if (type == "text") { updateLineText(cm, lineView) }
	    else if (type == "gutter") { updateLineGutter(cm, lineView, lineN, dims) }
	    else if (type == "class") { updateLineClasses(lineView) }
	    else if (type == "widget") { updateLineWidgets(cm, lineView, dims) }
	  }
	  lineView.changes = null
	}
	
	// Lines with gutter elements, widgets or a background class need to
	// be wrapped, and have the extra elements added to the wrapper div
	function ensureLineWrapped(lineView) {
	  if (lineView.node == lineView.text) {
	    lineView.node = elt("div", null, null, "position: relative")
	    if (lineView.text.parentNode)
	      { lineView.text.parentNode.replaceChild(lineView.node, lineView.text) }
	    lineView.node.appendChild(lineView.text)
	    if (ie && ie_version < 8) { lineView.node.style.zIndex = 2 }
	  }
	  return lineView.node
	}
	
	function updateLineBackground(lineView) {
	  var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass
	  if (cls) { cls += " CodeMirror-linebackground" }
	  if (lineView.background) {
	    if (cls) { lineView.background.className = cls }
	    else { lineView.background.parentNode.removeChild(lineView.background); lineView.background = null }
	  } else if (cls) {
	    var wrap = ensureLineWrapped(lineView)
	    lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild)
	  }
	}
	
	// Wrapper around buildLineContent which will reuse the structure
	// in display.externalMeasured when possible.
	function getLineContent(cm, lineView) {
	  var ext = cm.display.externalMeasured
	  if (ext && ext.line == lineView.line) {
	    cm.display.externalMeasured = null
	    lineView.measure = ext.measure
	    return ext.built
	  }
	  return buildLineContent(cm, lineView)
	}
	
	// Redraw the line's text. Interacts with the background and text
	// classes because the mode may output tokens that influence these
	// classes.
	function updateLineText(cm, lineView) {
	  var cls = lineView.text.className
	  var built = getLineContent(cm, lineView)
	  if (lineView.text == lineView.node) { lineView.node = built.pre }
	  lineView.text.parentNode.replaceChild(built.pre, lineView.text)
	  lineView.text = built.pre
	  if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
	    lineView.bgClass = built.bgClass
	    lineView.textClass = built.textClass
	    updateLineClasses(lineView)
	  } else if (cls) {
	    lineView.text.className = cls
	  }
	}
	
	function updateLineClasses(lineView) {
	  updateLineBackground(lineView)
	  if (lineView.line.wrapClass)
	    { ensureLineWrapped(lineView).className = lineView.line.wrapClass }
	  else if (lineView.node != lineView.text)
	    { lineView.node.className = "" }
	  var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass
	  lineView.text.className = textClass || ""
	}
	
	function updateLineGutter(cm, lineView, lineN, dims) {
	  if (lineView.gutter) {
	    lineView.node.removeChild(lineView.gutter)
	    lineView.gutter = null
	  }
	  if (lineView.gutterBackground) {
	    lineView.node.removeChild(lineView.gutterBackground)
	    lineView.gutterBackground = null
	  }
	  if (lineView.line.gutterClass) {
	    var wrap = ensureLineWrapped(lineView)
	    lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass,
	                                    ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + (dims.gutterTotalWidth) + "px"))
	    wrap.insertBefore(lineView.gutterBackground, lineView.text)
	  }
	  var markers = lineView.line.gutterMarkers
	  if (cm.options.lineNumbers || markers) {
	    var wrap$1 = ensureLineWrapped(lineView)
	    var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px"))
	    cm.display.input.setUneditable(gutterWrap)
	    wrap$1.insertBefore(gutterWrap, lineView.text)
	    if (lineView.line.gutterClass)
	      { gutterWrap.className += " " + lineView.line.gutterClass }
	    if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"]))
	      { lineView.lineNumber = gutterWrap.appendChild(
	        elt("div", lineNumberFor(cm.options, lineN),
	            "CodeMirror-linenumber CodeMirror-gutter-elt",
	            ("left: " + (dims.gutterLeft["CodeMirror-linenumbers"]) + "px; width: " + (cm.display.lineNumInnerWidth) + "px"))) }
	    if (markers) { for (var k = 0; k < cm.options.gutters.length; ++k) {
	      var id = cm.options.gutters[k], found = markers.hasOwnProperty(id) && markers[id]
	      if (found)
	        { gutterWrap.appendChild(elt("div", [found], "CodeMirror-gutter-elt",
	                                   ("left: " + (dims.gutterLeft[id]) + "px; width: " + (dims.gutterWidth[id]) + "px"))) }
	    } }
	  }
	}
	
	function updateLineWidgets(cm, lineView, dims) {
	  if (lineView.alignable) { lineView.alignable = null }
	  for (var node = lineView.node.firstChild, next = (void 0); node; node = next) {
	    next = node.nextSibling
	    if (node.className == "CodeMirror-linewidget")
	      { lineView.node.removeChild(node) }
	  }
	  insertLineWidgets(cm, lineView, dims)
	}
	
	// Build a line's DOM representation from scratch
	function buildLineElement(cm, lineView, lineN, dims) {
	  var built = getLineContent(cm, lineView)
	  lineView.text = lineView.node = built.pre
	  if (built.bgClass) { lineView.bgClass = built.bgClass }
	  if (built.textClass) { lineView.textClass = built.textClass }
	
	  updateLineClasses(lineView)
	  updateLineGutter(cm, lineView, lineN, dims)
	  insertLineWidgets(cm, lineView, dims)
	  return lineView.node
	}
	
	// A lineView may contain multiple logical lines (when merged by
	// collapsed spans). The widgets for all of them need to be drawn.
	function insertLineWidgets(cm, lineView, dims) {
	  insertLineWidgetsFor(cm, lineView.line, lineView, dims, true)
	  if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
	    { insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false) } }
	}
	
	function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
	  if (!line.widgets) { return }
	  var wrap = ensureLineWrapped(lineView)
	  for (var i = 0, ws = line.widgets; i < ws.length; ++i) {
	    var widget = ws[i], node = elt("div", [widget.node], "CodeMirror-linewidget")
	    if (!widget.handleMouseEvents) { node.setAttribute("cm-ignore-events", "true") }
	    positionLineWidget(widget, node, lineView, dims)
	    cm.display.input.setUneditable(node)
	    if (allowAbove && widget.above)
	      { wrap.insertBefore(node, lineView.gutter || lineView.text) }
	    else
	      { wrap.appendChild(node) }
	    signalLater(widget, "redraw")
	  }
	}
	
	function positionLineWidget(widget, node, lineView, dims) {
	  if (widget.noHScroll) {
	    ;(lineView.alignable || (lineView.alignable = [])).push(node)
	    var width = dims.wrapperWidth
	    node.style.left = dims.fixedPos + "px"
	    if (!widget.coverGutter) {
	      width -= dims.gutterTotalWidth
	      node.style.paddingLeft = dims.gutterTotalWidth + "px"
	    }
	    node.style.width = width + "px"
	  }
	  if (widget.coverGutter) {
	    node.style.zIndex = 5
	    node.style.position = "relative"
	    if (!widget.noHScroll) { node.style.marginLeft = -dims.gutterTotalWidth + "px" }
	  }
	}
	
	function widgetHeight(widget) {
	  if (widget.height != null) { return widget.height }
	  var cm = widget.doc.cm
	  if (!cm) { return 0 }
	  if (!contains(document.body, widget.node)) {
	    var parentStyle = "position: relative;"
	    if (widget.coverGutter)
	      { parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;" }
	    if (widget.noHScroll)
	      { parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;" }
	    removeChildrenAndAdd(cm.display.measure, elt("div", [widget.node], null, parentStyle))
	  }
	  return widget.height = widget.node.parentNode.offsetHeight
	}
	
	// Return true when the given mouse event happened in a widget
	function eventInWidget(display, e) {
	  for (var n = e_target(e); n != display.wrapper; n = n.parentNode) {
	    if (!n || (n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true") ||
	        (n.parentNode == display.sizer && n != display.mover))
	      { return true }
	  }
	}
	
	// POSITION MEASUREMENT
	
	function paddingTop(display) {return display.lineSpace.offsetTop}
	function paddingVert(display) {return display.mover.offsetHeight - display.lineSpace.offsetHeight}
	function paddingH(display) {
	  if (display.cachedPaddingH) { return display.cachedPaddingH }
	  var e = removeChildrenAndAdd(display.measure, elt("pre", "x"))
	  var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle
	  var data = {left: parseInt(style.paddingLeft), right: parseInt(style.paddingRight)}
	  if (!isNaN(data.left) && !isNaN(data.right)) { display.cachedPaddingH = data }
	  return data
	}
	
	function scrollGap(cm) { return scrollerGap - cm.display.nativeBarWidth }
	function displayWidth(cm) {
	  return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth
	}
	function displayHeight(cm) {
	  return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight
	}
	
	// Ensure the lineView.wrapping.heights array is populated. This is
	// an array of bottom offsets for the lines that make up a drawn
	// line. When lineWrapping is on, there might be more than one
	// height.
	function ensureLineHeights(cm, lineView, rect) {
	  var wrapping = cm.options.lineWrapping
	  var curWidth = wrapping && displayWidth(cm)
	  if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
	    var heights = lineView.measure.heights = []
	    if (wrapping) {
	      lineView.measure.width = curWidth
	      var rects = lineView.text.firstChild.getClientRects()
	      for (var i = 0; i < rects.length - 1; i++) {
	        var cur = rects[i], next = rects[i + 1]
	        if (Math.abs(cur.bottom - next.bottom) > 2)
	          { heights.push((cur.bottom + next.top) / 2 - rect.top) }
	      }
	    }
	    heights.push(rect.bottom - rect.top)
	  }
	}
	
	// Find a line map (mapping character offsets to text nodes) and a
	// measurement cache for the given line number. (A line view might
	// contain multiple lines when collapsed ranges are present.)
	function mapFromLineView(lineView, line, lineN) {
	  if (lineView.line == line)
	    { return {map: lineView.measure.map, cache: lineView.measure.cache} }
	  for (var i = 0; i < lineView.rest.length; i++)
	    { if (lineView.rest[i] == line)
	      { return {map: lineView.measure.maps[i], cache: lineView.measure.caches[i]} } }
	  for (var i$1 = 0; i$1 < lineView.rest.length; i$1++)
	    { if (lineNo(lineView.rest[i$1]) > lineN)
	      { return {map: lineView.measure.maps[i$1], cache: lineView.measure.caches[i$1], before: true} } }
	}
	
	// Render a line into the hidden node display.externalMeasured. Used
	// when measurement is needed for a line that's not in the viewport.
	function updateExternalMeasurement(cm, line) {
	  line = visualLine(line)
	  var lineN = lineNo(line)
	  var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN)
	  view.lineN = lineN
	  var built = view.built = buildLineContent(cm, view)
	  view.text = built.pre
	  removeChildrenAndAdd(cm.display.lineMeasure, built.pre)
	  return view
	}
	
	// Get a {top, bottom, left, right} box (in line-local coordinates)
	// for a given character.
	function measureChar(cm, line, ch, bias) {
	  return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias)
	}
	
	// Find a line view that corresponds to the given line number.
	function findViewForLine(cm, lineN) {
	  if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo)
	    { return cm.display.view[findViewIndex(cm, lineN)] }
	  var ext = cm.display.externalMeasured
	  if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size)
	    { return ext }
	}
	
	// Measurement can be split in two steps, the set-up work that
	// applies to the whole line, and the measurement of the actual
	// character. Functions like coordsChar, that need to do a lot of
	// measurements in a row, can thus ensure that the set-up work is
	// only done once.
	function prepareMeasureForLine(cm, line) {
	  var lineN = lineNo(line)
	  var view = findViewForLine(cm, lineN)
	  if (view && !view.text) {
	    view = null
	  } else if (view && view.changes) {
	    updateLineForChanges(cm, view, lineN, getDimensions(cm))
	    cm.curOp.forceUpdate = true
	  }
	  if (!view)
	    { view = updateExternalMeasurement(cm, line) }
	
	  var info = mapFromLineView(view, line, lineN)
	  return {
	    line: line, view: view, rect: null,
	    map: info.map, cache: info.cache, before: info.before,
	    hasHeights: false
	  }
	}
	
	// Given a prepared measurement object, measures the position of an
	// actual character (or fetches it from the cache).
	function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
	  if (prepared.before) { ch = -1 }
	  var key = ch + (bias || ""), found
	  if (prepared.cache.hasOwnProperty(key)) {
	    found = prepared.cache[key]
	  } else {
	    if (!prepared.rect)
	      { prepared.rect = prepared.view.text.getBoundingClientRect() }
	    if (!prepared.hasHeights) {
	      ensureLineHeights(cm, prepared.view, prepared.rect)
	      prepared.hasHeights = true
	    }
	    found = measureCharInner(cm, prepared, ch, bias)
	    if (!found.bogus) { prepared.cache[key] = found }
	  }
	  return {left: found.left, right: found.right,
	          top: varHeight ? found.rtop : found.top,
	          bottom: varHeight ? found.rbottom : found.bottom}
	}
	
	var nullRect = {left: 0, right: 0, top: 0, bottom: 0}
	
	function nodeAndOffsetInLineMap(map, ch, bias) {
	  var node, start, end, collapse, mStart, mEnd
	  // First, search the line map for the text node corresponding to,
	  // or closest to, the target character.
	  for (var i = 0; i < map.length; i += 3) {
	    mStart = map[i]
	    mEnd = map[i + 1]
	    if (ch < mStart) {
	      start = 0; end = 1
	      collapse = "left"
	    } else if (ch < mEnd) {
	      start = ch - mStart
	      end = start + 1
	    } else if (i == map.length - 3 || ch == mEnd && map[i + 3] > ch) {
	      end = mEnd - mStart
	      start = end - 1
	      if (ch >= mEnd) { collapse = "right" }
	    }
	    if (start != null) {
	      node = map[i + 2]
	      if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right"))
	        { collapse = bias }
	      if (bias == "left" && start == 0)
	        { while (i && map[i - 2] == map[i - 3] && map[i - 1].insertLeft) {
	          node = map[(i -= 3) + 2]
	          collapse = "left"
	        } }
	      if (bias == "right" && start == mEnd - mStart)
	        { while (i < map.length - 3 && map[i + 3] == map[i + 4] && !map[i + 5].insertLeft) {
	          node = map[(i += 3) + 2]
	          collapse = "right"
	        } }
	      break
	    }
	  }
	  return {node: node, start: start, end: end, collapse: collapse, coverStart: mStart, coverEnd: mEnd}
	}
	
	function getUsefulRect(rects, bias) {
	  var rect = nullRect
	  if (bias == "left") { for (var i = 0; i < rects.length; i++) {
	    if ((rect = rects[i]).left != rect.right) { break }
	  } } else { for (var i$1 = rects.length - 1; i$1 >= 0; i$1--) {
	    if ((rect = rects[i$1]).left != rect.right) { break }
	  } }
	  return rect
	}
	
	function measureCharInner(cm, prepared, ch, bias) {
	  var place = nodeAndOffsetInLineMap(prepared.map, ch, bias)
	  var node = place.node, start = place.start, end = place.end, collapse = place.collapse
	
	  var rect
	  if (node.nodeType == 3) { // If it is a text node, use a range to retrieve the coordinates.
	    for (var i$1 = 0; i$1 < 4; i$1++) { // Retry a maximum of 4 times when nonsense rectangles are returned
	      while (start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start))) { --start }
	      while (place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end))) { ++end }
	      if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart)
	        { rect = node.parentNode.getBoundingClientRect() }
	      else
	        { rect = getUsefulRect(range(node, start, end).getClientRects(), bias) }
	      if (rect.left || rect.right || start == 0) { break }
	      end = start
	      start = start - 1
	      collapse = "right"
	    }
	    if (ie && ie_version < 11) { rect = maybeUpdateRectForZooming(cm.display.measure, rect) }
	  } else { // If it is a widget, simply get the box for the whole widget.
	    if (start > 0) { collapse = bias = "right" }
	    var rects
	    if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1)
	      { rect = rects[bias == "right" ? rects.length - 1 : 0] }
	    else
	      { rect = node.getBoundingClientRect() }
	  }
	  if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
	    var rSpan = node.parentNode.getClientRects()[0]
	    if (rSpan)
	      { rect = {left: rSpan.left, right: rSpan.left + charWidth(cm.display), top: rSpan.top, bottom: rSpan.bottom} }
	    else
	      { rect = nullRect }
	  }
	
	  var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top
	  var mid = (rtop + rbot) / 2
	  var heights = prepared.view.measure.heights
	  var i = 0
	  for (; i < heights.length - 1; i++)
	    { if (mid < heights[i]) { break } }
	  var top = i ? heights[i - 1] : 0, bot = heights[i]
	  var result = {left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
	                right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
	                top: top, bottom: bot}
	  if (!rect.left && !rect.right) { result.bogus = true }
	  if (!cm.options.singleCursorHeightPerLine) { result.rtop = rtop; result.rbottom = rbot }
	
	  return result
	}
	
	// Work around problem with bounding client rects on ranges being
	// returned incorrectly when zoomed on IE10 and below.
	function maybeUpdateRectForZooming(measure, rect) {
	  if (!window.screen || screen.logicalXDPI == null ||
	      screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure))
	    { return rect }
	  var scaleX = screen.logicalXDPI / screen.deviceXDPI
	  var scaleY = screen.logicalYDPI / screen.deviceYDPI
	  return {left: rect.left * scaleX, right: rect.right * scaleX,
	          top: rect.top * scaleY, bottom: rect.bottom * scaleY}
	}
	
	function clearLineMeasurementCacheFor(lineView) {
	  if (lineView.measure) {
	    lineView.measure.cache = {}
	    lineView.measure.heights = null
	    if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
	      { lineView.measure.caches[i] = {} } }
	  }
	}
	
	function clearLineMeasurementCache(cm) {
	  cm.display.externalMeasure = null
	  removeChildren(cm.display.lineMeasure)
	  for (var i = 0; i < cm.display.view.length; i++)
	    { clearLineMeasurementCacheFor(cm.display.view[i]) }
	}
	
	function clearCaches(cm) {
	  clearLineMeasurementCache(cm)
	  cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null
	  if (!cm.options.lineWrapping) { cm.display.maxLineChanged = true }
	  cm.display.lineNumChars = null
	}
	
	function pageScrollX() { return window.pageXOffset || (document.documentElement || document.body).scrollLeft }
	function pageScrollY() { return window.pageYOffset || (document.documentElement || document.body).scrollTop }
	
	// Converts a {top, bottom, left, right} box from line-local
	// coordinates into another coordinate system. Context may be one of
	// "line", "div" (display.lineDiv), "local"./null (editor), "window",
	// or "page".
	function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
	  if (!includeWidgets && lineObj.widgets) { for (var i = 0; i < lineObj.widgets.length; ++i) { if (lineObj.widgets[i].above) {
	    var size = widgetHeight(lineObj.widgets[i])
	    rect.top += size; rect.bottom += size
	  } } }
	  if (context == "line") { return rect }
	  if (!context) { context = "local" }
	  var yOff = heightAtLine(lineObj)
	  if (context == "local") { yOff += paddingTop(cm.display) }
	  else { yOff -= cm.display.viewOffset }
	  if (context == "page" || context == "window") {
	    var lOff = cm.display.lineSpace.getBoundingClientRect()
	    yOff += lOff.top + (context == "window" ? 0 : pageScrollY())
	    var xOff = lOff.left + (context == "window" ? 0 : pageScrollX())
	    rect.left += xOff; rect.right += xOff
	  }
	  rect.top += yOff; rect.bottom += yOff
	  return rect
	}
	
	// Coverts a box from "div" coords to another coordinate system.
	// Context may be "window", "page", "div", or "local"./null.
	function fromCoordSystem(cm, coords, context) {
	  if (context == "div") { return coords }
	  var left = coords.left, top = coords.top
	  // First move into "page" coordinate system
	  if (context == "page") {
	    left -= pageScrollX()
	    top -= pageScrollY()
	  } else if (context == "local" || !context) {
	    var localBox = cm.display.sizer.getBoundingClientRect()
	    left += localBox.left
	    top += localBox.top
	  }
	
	  var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect()
	  return {left: left - lineSpaceBox.left, top: top - lineSpaceBox.top}
	}
	
	function charCoords(cm, pos, context, lineObj, bias) {
	  if (!lineObj) { lineObj = getLine(cm.doc, pos.line) }
	  return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context)
	}
	
	// Returns a box for a given cursor position, which may have an
	// 'other' property containing the position of the secondary cursor
	// on a bidi boundary.
	function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
	  lineObj = lineObj || getLine(cm.doc, pos.line)
	  if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj) }
	  function get(ch, right) {
	    var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight)
	    if (right) { m.left = m.right; } else { m.right = m.left }
	    return intoCoordSystem(cm, lineObj, m, context)
	  }
	  function getBidi(ch, partPos) {
	    var part = order[partPos], right = part.level % 2
	    if (ch == bidiLeft(part) && partPos && part.level < order[partPos - 1].level) {
	      part = order[--partPos]
	      ch = bidiRight(part) - (part.level % 2 ? 0 : 1)
	      right = true
	    } else if (ch == bidiRight(part) && partPos < order.length - 1 && part.level < order[partPos + 1].level) {
	      part = order[++partPos]
	      ch = bidiLeft(part) - part.level % 2
	      right = false
	    }
	    if (right && ch == part.to && ch > part.from) { return get(ch - 1) }
	    return get(ch, right)
	  }
	  var order = getOrder(lineObj), ch = pos.ch
	  if (!order) { return get(ch) }
	  var partPos = getBidiPartAt(order, ch)
	  var val = getBidi(ch, partPos)
	  if (bidiOther != null) { val.other = getBidi(ch, bidiOther) }
	  return val
	}
	
	// Used to cheaply estimate the coordinates for a position. Used for
	// intermediate scroll updates.
	function estimateCoords(cm, pos) {
	  var left = 0
	  pos = clipPos(cm.doc, pos)
	  if (!cm.options.lineWrapping) { left = charWidth(cm.display) * pos.ch }
	  var lineObj = getLine(cm.doc, pos.line)
	  var top = heightAtLine(lineObj) + paddingTop(cm.display)
	  return {left: left, right: left, top: top, bottom: top + lineObj.height}
	}
	
	// Positions returned by coordsChar contain some extra information.
	// xRel is the relative x position of the input coordinates compared
	// to the found position (so xRel > 0 means the coordinates are to
	// the right of the character position, for example). When outside
	// is true, that means the coordinates lie outside the line's
	// vertical range.
	function PosWithInfo(line, ch, outside, xRel) {
	  var pos = Pos(line, ch)
	  pos.xRel = xRel
	  if (outside) { pos.outside = true }
	  return pos
	}
	
	// Compute the character position closest to the given coordinates.
	// Input must be lineSpace-local ("div" coordinate system).
	function coordsChar(cm, x, y) {
	  var doc = cm.doc
	  y += cm.display.viewOffset
	  if (y < 0) { return PosWithInfo(doc.first, 0, true, -1) }
	  var lineN = lineAtHeight(doc, y), last = doc.first + doc.size - 1
	  if (lineN > last)
	    { return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, true, 1) }
	  if (x < 0) { x = 0 }
	
	  var lineObj = getLine(doc, lineN)
	  for (;;) {
	    var found = coordsCharInner(cm, lineObj, lineN, x, y)
	    var merged = collapsedSpanAtEnd(lineObj)
	    var mergedPos = merged && merged.find(0, true)
	    if (merged && (found.ch > mergedPos.from.ch || found.ch == mergedPos.from.ch && found.xRel > 0))
	      { lineN = lineNo(lineObj = mergedPos.to.line) }
	    else
	      { return found }
	  }
	}
	
	function coordsCharInner(cm, lineObj, lineNo, x, y) {
	  var innerOff = y - heightAtLine(lineObj)
	  var wrongLine = false, adjust = 2 * cm.display.wrapper.clientWidth
	  var preparedMeasure = prepareMeasureForLine(cm, lineObj)
	
	  function getX(ch) {
	    var sp = cursorCoords(cm, Pos(lineNo, ch), "line", lineObj, preparedMeasure)
	    wrongLine = true
	    if (innerOff > sp.bottom) { return sp.left - adjust }
	    else if (innerOff < sp.top) { return sp.left + adjust }
	    else { wrongLine = false }
	    return sp.left
	  }
	
	  var bidi = getOrder(lineObj), dist = lineObj.text.length
	  var from = lineLeft(lineObj), to = lineRight(lineObj)
	  var fromX = getX(from), fromOutside = wrongLine, toX = getX(to), toOutside = wrongLine
	
	  if (x > toX) { return PosWithInfo(lineNo, to, toOutside, 1) }
	  // Do a binary search between these bounds.
	  for (;;) {
	    if (bidi ? to == from || to == moveVisually(lineObj, from, 1) : to - from <= 1) {
	      var ch = x < fromX || x - fromX <= toX - x ? from : to
	      var outside = ch == from ? fromOutside : toOutside
	      var xDiff = x - (ch == from ? fromX : toX)
	      // This is a kludge to handle the case where the coordinates
	      // are after a line-wrapped line. We should replace it with a
	      // more general handling of cursor positions around line
	      // breaks. (Issue #4078)
	      if (toOutside && !bidi && !/\s/.test(lineObj.text.charAt(ch)) && xDiff > 0 &&
	          ch < lineObj.text.length && preparedMeasure.view.measure.heights.length > 1) {
	        var charSize = measureCharPrepared(cm, preparedMeasure, ch, "right")
	        if (innerOff <= charSize.bottom && innerOff >= charSize.top && Math.abs(x - charSize.right) < xDiff) {
	          outside = false
	          ch++
	          xDiff = x - charSize.right
	        }
	      }
	      while (isExtendingChar(lineObj.text.charAt(ch))) { ++ch }
	      var pos = PosWithInfo(lineNo, ch, outside, xDiff < -1 ? -1 : xDiff > 1 ? 1 : 0)
	      return pos
	    }
	    var step = Math.ceil(dist / 2), middle = from + step
	    if (bidi) {
	      middle = from
	      for (var i = 0; i < step; ++i) { middle = moveVisually(lineObj, middle, 1) }
	    }
	    var middleX = getX(middle)
	    if (middleX > x) {to = middle; toX = middleX; if (toOutside = wrongLine) { toX += 1000; } dist = step}
	    else {from = middle; fromX = middleX; fromOutside = wrongLine; dist -= step}
	  }
	}
	
	var measureText
	// Compute the default text height.
	function textHeight(display) {
	  if (display.cachedTextHeight != null) { return display.cachedTextHeight }
	  if (measureText == null) {
	    measureText = elt("pre")
	    // Measure a bunch of lines, for browsers that compute
	    // fractional heights.
	    for (var i = 0; i < 49; ++i) {
	      measureText.appendChild(document.createTextNode("x"))
	      measureText.appendChild(elt("br"))
	    }
	    measureText.appendChild(document.createTextNode("x"))
	  }
	  removeChildrenAndAdd(display.measure, measureText)
	  var height = measureText.offsetHeight / 50
	  if (height > 3) { display.cachedTextHeight = height }
	  removeChildren(display.measure)
	  return height || 1
	}
	
	// Compute the default character width.
	function charWidth(display) {
	  if (display.cachedCharWidth != null) { return display.cachedCharWidth }
	  var anchor = elt("span", "xxxxxxxxxx")
	  var pre = elt("pre", [anchor])
	  removeChildrenAndAdd(display.measure, pre)
	  var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10
	  if (width > 2) { display.cachedCharWidth = width }
	  return width || 10
	}
	
	// Do a bulk-read of the DOM positions and sizes needed to draw the
	// view, so that we don't interleave reading and writing to the DOM.
	function getDimensions(cm) {
	  var d = cm.display, left = {}, width = {}
	  var gutterLeft = d.gutters.clientLeft
	  for (var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i) {
	    left[cm.options.gutters[i]] = n.offsetLeft + n.clientLeft + gutterLeft
	    width[cm.options.gutters[i]] = n.clientWidth
	  }
	  return {fixedPos: compensateForHScroll(d),
	          gutterTotalWidth: d.gutters.offsetWidth,
	          gutterLeft: left,
	          gutterWidth: width,
	          wrapperWidth: d.wrapper.clientWidth}
	}
	
	// Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
	// but using getBoundingClientRect to get a sub-pixel-accurate
	// result.
	function compensateForHScroll(display) {
	  return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left
	}
	
	// Returns a function that estimates the height of a line, to use as
	// first approximation until the line becomes visible (and is thus
	// properly measurable).
	function estimateHeight(cm) {
	  var th = textHeight(cm.display), wrapping = cm.options.lineWrapping
	  var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3)
	  return function (line) {
	    if (lineIsHidden(cm.doc, line)) { return 0 }
	
	    var widgetsHeight = 0
	    if (line.widgets) { for (var i = 0; i < line.widgets.length; i++) {
	      if (line.widgets[i].height) { widgetsHeight += line.widgets[i].height }
	    } }
	
	    if (wrapping)
	      { return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th }
	    else
	      { return widgetsHeight + th }
	  }
	}
	
	function estimateLineHeights(cm) {
	  var doc = cm.doc, est = estimateHeight(cm)
	  doc.iter(function (line) {
	    var estHeight = est(line)
	    if (estHeight != line.height) { updateLineHeight(line, estHeight) }
	  })
	}
	
	// Given a mouse event, find the corresponding position. If liberal
	// is false, it checks whether a gutter or scrollbar was clicked,
	// and returns null if it was. forRect is used by rectangular
	// selections, and tries to estimate a character position even for
	// coordinates beyond the right of the text.
	function posFromMouse(cm, e, liberal, forRect) {
	  var display = cm.display
	  if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") { return null }
	
	  var x, y, space = display.lineSpace.getBoundingClientRect()
	  // Fails unpredictably on IE[67] when mouse is dragged around quickly.
	  try { x = e.clientX - space.left; y = e.clientY - space.top }
	  catch (e) { return null }
	  var coords = coordsChar(cm, x, y), line
	  if (forRect && coords.xRel == 1 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
	    var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length
	    coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff))
	  }
	  return coords
	}
	
	// Find the view element corresponding to a given line. Return null
	// when the line isn't visible.
	function findViewIndex(cm, n) {
	  if (n >= cm.display.viewTo) { return null }
	  n -= cm.display.viewFrom
	  if (n < 0) { return null }
	  var view = cm.display.view
	  for (var i = 0; i < view.length; i++) {
	    n -= view[i].size
	    if (n < 0) { return i }
	  }
	}
	
	function updateSelection(cm) {
	  cm.display.input.showSelection(cm.display.input.prepareSelection())
	}
	
	function prepareSelection(cm, primary) {
	  var doc = cm.doc, result = {}
	  var curFragment = result.cursors = document.createDocumentFragment()
	  var selFragment = result.selection = document.createDocumentFragment()
	
	  for (var i = 0; i < doc.sel.ranges.length; i++) {
	    if (primary === false && i == doc.sel.primIndex) { continue }
	    var range = doc.sel.ranges[i]
	    if (range.from().line >= cm.display.viewTo || range.to().line < cm.display.viewFrom) { continue }
	    var collapsed = range.empty()
	    if (collapsed || cm.options.showCursorWhenSelecting)
	      { drawSelectionCursor(cm, range.head, curFragment) }
	    if (!collapsed)
	      { drawSelectionRange(cm, range, selFragment) }
	  }
	  return result
	}
	
	// Draws a cursor for the given range
	function drawSelectionCursor(cm, head, output) {
	  var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine)
	
	  var cursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor"))
	  cursor.style.left = pos.left + "px"
	  cursor.style.top = pos.top + "px"
	  cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px"
	
	  if (pos.other) {
	    // Secondary cursor, shown when on a 'jump' in bi-directional text
	    var otherCursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor CodeMirror-secondarycursor"))
	    otherCursor.style.display = ""
	    otherCursor.style.left = pos.other.left + "px"
	    otherCursor.style.top = pos.other.top + "px"
	    otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px"
	  }
	}
	
	// Draws the given range as a highlighted selection
	function drawSelectionRange(cm, range, output) {
	  var display = cm.display, doc = cm.doc
	  var fragment = document.createDocumentFragment()
	  var padding = paddingH(cm.display), leftSide = padding.left
	  var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right
	
	  function add(left, top, width, bottom) {
	    if (top < 0) { top = 0 }
	    top = Math.round(top)
	    bottom = Math.round(bottom)
	    fragment.appendChild(elt("div", null, "CodeMirror-selected", ("position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px")))
	  }
	
	  function drawForLine(line, fromArg, toArg) {
	    var lineObj = getLine(doc, line)
	    var lineLen = lineObj.text.length
	    var start, end
	    function coords(ch, bias) {
	      return charCoords(cm, Pos(line, ch), "div", lineObj, bias)
	    }
	
	    iterateBidiSections(getOrder(lineObj), fromArg || 0, toArg == null ? lineLen : toArg, function (from, to, dir) {
	      var leftPos = coords(from, "left"), rightPos, left, right
	      if (from == to) {
	        rightPos = leftPos
	        left = right = leftPos.left
	      } else {
	        rightPos = coords(to - 1, "right")
	        if (dir == "rtl") { var tmp = leftPos; leftPos = rightPos; rightPos = tmp }
	        left = leftPos.left
	        right = rightPos.right
	      }
	      if (fromArg == null && from == 0) { left = leftSide }
	      if (rightPos.top - leftPos.top > 3) { // Different lines, draw top part
	        add(left, leftPos.top, null, leftPos.bottom)
	        left = leftSide
	        if (leftPos.bottom < rightPos.top) { add(left, leftPos.bottom, null, rightPos.top) }
	      }
	      if (toArg == null && to == lineLen) { right = rightSide }
	      if (!start || leftPos.top < start.top || leftPos.top == start.top && leftPos.left < start.left)
	        { start = leftPos }
	      if (!end || rightPos.bottom > end.bottom || rightPos.bottom == end.bottom && rightPos.right > end.right)
	        { end = rightPos }
	      if (left < leftSide + 1) { left = leftSide }
	      add(left, rightPos.top, right - left, rightPos.bottom)
	    })
	    return {start: start, end: end}
	  }
	
	  var sFrom = range.from(), sTo = range.to()
	  if (sFrom.line == sTo.line) {
	    drawForLine(sFrom.line, sFrom.ch, sTo.ch)
	  } else {
	    var fromLine = getLine(doc, sFrom.line), toLine = getLine(doc, sTo.line)
	    var singleVLine = visualLine(fromLine) == visualLine(toLine)
	    var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end
	    var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start
	    if (singleVLine) {
	      if (leftEnd.top < rightStart.top - 2) {
	        add(leftEnd.right, leftEnd.top, null, leftEnd.bottom)
	        add(leftSide, rightStart.top, rightStart.left, rightStart.bottom)
	      } else {
	        add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom)
	      }
	    }
	    if (leftEnd.bottom < rightStart.top)
	      { add(leftSide, leftEnd.bottom, null, rightStart.top) }
	  }
	
	  output.appendChild(fragment)
	}
	
	// Cursor-blinking
	function restartBlink(cm) {
	  if (!cm.state.focused) { return }
	  var display = cm.display
	  clearInterval(display.blinker)
	  var on = true
	  display.cursorDiv.style.visibility = ""
	  if (cm.options.cursorBlinkRate > 0)
	    { display.blinker = setInterval(function () { return display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden"; },
	      cm.options.cursorBlinkRate) }
	  else if (cm.options.cursorBlinkRate < 0)
	    { display.cursorDiv.style.visibility = "hidden" }
	}
	
	function ensureFocus(cm) {
	  if (!cm.state.focused) { cm.display.input.focus(); onFocus(cm) }
	}
	
	function delayBlurEvent(cm) {
	  cm.state.delayingBlurEvent = true
	  setTimeout(function () { if (cm.state.delayingBlurEvent) {
	    cm.state.delayingBlurEvent = false
	    onBlur(cm)
	  } }, 100)
	}
	
	function onFocus(cm, e) {
	  if (cm.state.delayingBlurEvent) { cm.state.delayingBlurEvent = false }
	
	  if (cm.options.readOnly == "nocursor") { return }
	  if (!cm.state.focused) {
	    signal(cm, "focus", cm, e)
	    cm.state.focused = true
	    addClass(cm.display.wrapper, "CodeMirror-focused")
	    // This test prevents this from firing when a context
	    // menu is closed (since the input reset would kill the
	    // select-all detection hack)
	    if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
	      cm.display.input.reset()
	      if (webkit) { setTimeout(function () { return cm.display.input.reset(true); }, 20) } // Issue #1730
	    }
	    cm.display.input.receivedFocus()
	  }
	  restartBlink(cm)
	}
	function onBlur(cm, e) {
	  if (cm.state.delayingBlurEvent) { return }
	
	  if (cm.state.focused) {
	    signal(cm, "blur", cm, e)
	    cm.state.focused = false
	    rmClass(cm.display.wrapper, "CodeMirror-focused")
	  }
	  clearInterval(cm.display.blinker)
	  setTimeout(function () { if (!cm.state.focused) { cm.display.shift = false } }, 150)
	}
	
	// Re-align line numbers and gutter marks to compensate for
	// horizontal scrolling.
	function alignHorizontally(cm) {
	  var display = cm.display, view = display.view
	  if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) { return }
	  var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft
	  var gutterW = display.gutters.offsetWidth, left = comp + "px"
	  for (var i = 0; i < view.length; i++) { if (!view[i].hidden) {
	    if (cm.options.fixedGutter) {
	      if (view[i].gutter)
	        { view[i].gutter.style.left = left }
	      if (view[i].gutterBackground)
	        { view[i].gutterBackground.style.left = left }
	    }
	    var align = view[i].alignable
	    if (align) { for (var j = 0; j < align.length; j++)
	      { align[j].style.left = left } }
	  } }
	  if (cm.options.fixedGutter)
	    { display.gutters.style.left = (comp + gutterW) + "px" }
	}
	
	// Used to ensure that the line number gutter is still the right
	// size for the current document size. Returns true when an update
	// is needed.
	function maybeUpdateLineNumberWidth(cm) {
	  if (!cm.options.lineNumbers) { return false }
	  var doc = cm.doc, last = lineNumberFor(cm.options, doc.first + doc.size - 1), display = cm.display
	  if (last.length != display.lineNumChars) {
	    var test = display.measure.appendChild(elt("div", [elt("div", last)],
	                                               "CodeMirror-linenumber CodeMirror-gutter-elt"))
	    var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW
	    display.lineGutter.style.width = ""
	    display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1
	    display.lineNumWidth = display.lineNumInnerWidth + padding
	    display.lineNumChars = display.lineNumInnerWidth ? last.length : -1
	    display.lineGutter.style.width = display.lineNumWidth + "px"
	    updateGutterSpace(cm)
	    return true
	  }
	  return false
	}
	
	// Read the actual heights of the rendered lines, and update their
	// stored heights to match.
	function updateHeightsInViewport(cm) {
	  var display = cm.display
	  var prevBottom = display.lineDiv.offsetTop
	  for (var i = 0; i < display.view.length; i++) {
	    var cur = display.view[i], height = (void 0)
	    if (cur.hidden) { continue }
	    if (ie && ie_version < 8) {
	      var bot = cur.node.offsetTop + cur.node.offsetHeight
	      height = bot - prevBottom
	      prevBottom = bot
	    } else {
	      var box = cur.node.getBoundingClientRect()
	      height = box.bottom - box.top
	    }
	    var diff = cur.line.height - height
	    if (height < 2) { height = textHeight(display) }
	    if (diff > .001 || diff < -.001) {
	      updateLineHeight(cur.line, height)
	      updateWidgetHeight(cur.line)
	      if (cur.rest) { for (var j = 0; j < cur.rest.length; j++)
	        { updateWidgetHeight(cur.rest[j]) } }
	    }
	  }
	}
	
	// Read and store the height of line widgets associated with the
	// given line.
	function updateWidgetHeight(line) {
	  if (line.widgets) { for (var i = 0; i < line.widgets.length; ++i)
	    { line.widgets[i].height = line.widgets[i].node.parentNode.offsetHeight } }
	}
	
	// Compute the lines that are visible in a given viewport (defaults
	// the the current scroll position). viewport may contain top,
	// height, and ensure (see op.scrollToPos) properties.
	function visibleLines(display, doc, viewport) {
	  var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop
	  top = Math.floor(top - paddingTop(display))
	  var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight
	
	  var from = lineAtHeight(doc, top), to = lineAtHeight(doc, bottom)
	  // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
	  // forces those lines into the viewport (if possible).
	  if (viewport && viewport.ensure) {
	    var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line
	    if (ensureFrom < from) {
	      from = ensureFrom
	      to = lineAtHeight(doc, heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight)
	    } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
	      from = lineAtHeight(doc, heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight)
	      to = ensureTo
	    }
	  }
	  return {from: from, to: Math.max(to, from + 1)}
	}
	
	// Sync the scrollable area and scrollbars, ensure the viewport
	// covers the visible area.
	function setScrollTop(cm, val) {
	  if (Math.abs(cm.doc.scrollTop - val) < 2) { return }
	  cm.doc.scrollTop = val
	  if (!gecko) { updateDisplaySimple(cm, {top: val}) }
	  if (cm.display.scroller.scrollTop != val) { cm.display.scroller.scrollTop = val }
	  cm.display.scrollbars.setScrollTop(val)
	  if (gecko) { updateDisplaySimple(cm) }
	  startWorker(cm, 100)
	}
	// Sync scroller and scrollbar, ensure the gutter elements are
	// aligned.
	function setScrollLeft(cm, val, isScroller) {
	  if (isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) { return }
	  val = Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth)
	  cm.doc.scrollLeft = val
	  alignHorizontally(cm)
	  if (cm.display.scroller.scrollLeft != val) { cm.display.scroller.scrollLeft = val }
	  cm.display.scrollbars.setScrollLeft(val)
	}
	
	// Since the delta values reported on mouse wheel events are
	// unstandardized between browsers and even browser versions, and
	// generally horribly unpredictable, this code starts by measuring
	// the scroll effect that the first few mouse wheel events have,
	// and, from that, detects the way it can convert deltas to pixel
	// offsets afterwards.
	//
	// The reason we want to know the amount a wheel event will scroll
	// is that it gives us a chance to update the display before the
	// actual scrolling happens, reducing flickering.
	
	var wheelSamples = 0;
	var wheelPixelsPerUnit = null;
	// Fill in a browser-detected starting value on browsers where we
	// know one. These don't have to be accurate -- the result of them
	// being wrong would just be a slight flicker on the first wheel
	// scroll (if it is large enough).
	if (ie) { wheelPixelsPerUnit = -.53 }
	else if (gecko) { wheelPixelsPerUnit = 15 }
	else if (chrome) { wheelPixelsPerUnit = -.7 }
	else if (safari) { wheelPixelsPerUnit = -1/3 }
	
	function wheelEventDelta(e) {
	  var dx = e.wheelDeltaX, dy = e.wheelDeltaY
	  if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) { dx = e.detail }
	  if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) { dy = e.detail }
	  else if (dy == null) { dy = e.wheelDelta }
	  return {x: dx, y: dy}
	}
	function wheelEventPixels(e) {
	  var delta = wheelEventDelta(e)
	  delta.x *= wheelPixelsPerUnit
	  delta.y *= wheelPixelsPerUnit
	  return delta
	}
	
	function onScrollWheel(cm, e) {
	  var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y
	
	  var display = cm.display, scroll = display.scroller
	  // Quit if there's nothing to scroll here
	  var canScrollX = scroll.scrollWidth > scroll.clientWidth
	  var canScrollY = scroll.scrollHeight > scroll.clientHeight
	  if (!(dx && canScrollX || dy && canScrollY)) { return }
	
	  // Webkit browsers on OS X abort momentum scrolls when the target
	  // of the scroll event is removed from the scrollable element.
	  // This hack (see related code in patchDisplay) makes sure the
	  // element is kept around.
	  if (dy && mac && webkit) {
	    outer: for (var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode) {
	      for (var i = 0; i < view.length; i++) {
	        if (view[i].node == cur) {
	          cm.display.currentWheelTarget = cur
	          break outer
	        }
	      }
	    }
	  }
	
	  // On some browsers, horizontal scrolling will cause redraws to
	  // happen before the gutter has been realigned, causing it to
	  // wriggle around in a most unseemly way. When we have an
	  // estimated pixels/delta value, we just handle horizontal
	  // scrolling entirely here. It'll be slightly off from native, but
	  // better than glitching out.
	  if (dx && !gecko && !presto && wheelPixelsPerUnit != null) {
	    if (dy && canScrollY)
	      { setScrollTop(cm, Math.max(0, Math.min(scroll.scrollTop + dy * wheelPixelsPerUnit, scroll.scrollHeight - scroll.clientHeight))) }
	    setScrollLeft(cm, Math.max(0, Math.min(scroll.scrollLeft + dx * wheelPixelsPerUnit, scroll.scrollWidth - scroll.clientWidth)))
	    // Only prevent default scrolling if vertical scrolling is
	    // actually possible. Otherwise, it causes vertical scroll
	    // jitter on OSX trackpads when deltaX is small and deltaY
	    // is large (issue #3579)
	    if (!dy || (dy && canScrollY))
	      { e_preventDefault(e) }
	    display.wheelStartX = null // Abort measurement, if in progress
	    return
	  }
	
	  // 'Project' the visible viewport to cover the area that is being
	  // scrolled into view (if we know enough to estimate it).
	  if (dy && wheelPixelsPerUnit != null) {
	    var pixels = dy * wheelPixelsPerUnit
	    var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight
	    if (pixels < 0) { top = Math.max(0, top + pixels - 50) }
	    else { bot = Math.min(cm.doc.height, bot + pixels + 50) }
	    updateDisplaySimple(cm, {top: top, bottom: bot})
	  }
	
	  if (wheelSamples < 20) {
	    if (display.wheelStartX == null) {
	      display.wheelStartX = scroll.scrollLeft; display.wheelStartY = scroll.scrollTop
	      display.wheelDX = dx; display.wheelDY = dy
	      setTimeout(function () {
	        if (display.wheelStartX == null) { return }
	        var movedX = scroll.scrollLeft - display.wheelStartX
	        var movedY = scroll.scrollTop - display.wheelStartY
	        var sample = (movedY && display.wheelDY && movedY / display.wheelDY) ||
	          (movedX && display.wheelDX && movedX / display.wheelDX)
	        display.wheelStartX = display.wheelStartY = null
	        if (!sample) { return }
	        wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1)
	        ++wheelSamples
	      }, 200)
	    } else {
	      display.wheelDX += dx; display.wheelDY += dy
	    }
	  }
	}
	
	// SCROLLBARS
	
	// Prepare DOM reads needed to update the scrollbars. Done in one
	// shot to minimize update/measure roundtrips.
	function measureForScrollbars(cm) {
	  var d = cm.display, gutterW = d.gutters.offsetWidth
	  var docH = Math.round(cm.doc.height + paddingVert(cm.display))
	  return {
	    clientHeight: d.scroller.clientHeight,
	    viewHeight: d.wrapper.clientHeight,
	    scrollWidth: d.scroller.scrollWidth, clientWidth: d.scroller.clientWidth,
	    viewWidth: d.wrapper.clientWidth,
	    barLeft: cm.options.fixedGutter ? gutterW : 0,
	    docHeight: docH,
	    scrollHeight: docH + scrollGap(cm) + d.barHeight,
	    nativeBarWidth: d.nativeBarWidth,
	    gutterWidth: gutterW
	  }
	}
	
	var NativeScrollbars = function(place, scroll, cm) {
	  this.cm = cm
	  var vert = this.vert = elt("div", [elt("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar")
	  var horiz = this.horiz = elt("div", [elt("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar")
	  place(vert); place(horiz)
	
	  on(vert, "scroll", function () {
	    if (vert.clientHeight) { scroll(vert.scrollTop, "vertical") }
	  })
	  on(horiz, "scroll", function () {
	    if (horiz.clientWidth) { scroll(horiz.scrollLeft, "horizontal") }
	  })
	
	  this.checkedZeroWidth = false
	  // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
	  if (ie && ie_version < 8) { this.horiz.style.minHeight = this.vert.style.minWidth = "18px" }
	};
	
	NativeScrollbars.prototype.update = function (measure) {
	  var needsH = measure.scrollWidth > measure.clientWidth + 1
	  var needsV = measure.scrollHeight > measure.clientHeight + 1
	  var sWidth = measure.nativeBarWidth
	
	  if (needsV) {
	    this.vert.style.display = "block"
	    this.vert.style.bottom = needsH ? sWidth + "px" : "0"
	    var totalHeight = measure.viewHeight - (needsH ? sWidth : 0)
	    // A bug in IE8 can cause this value to be negative, so guard it.
	    this.vert.firstChild.style.height =
	      Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px"
	  } else {
	    this.vert.style.display = ""
	    this.vert.firstChild.style.height = "0"
	  }
	
	  if (needsH) {
	    this.horiz.style.display = "block"
	    this.horiz.style.right = needsV ? sWidth + "px" : "0"
	    this.horiz.style.left = measure.barLeft + "px"
	    var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0)
	    this.horiz.firstChild.style.width =
	      (measure.scrollWidth - measure.clientWidth + totalWidth) + "px"
	  } else {
	    this.horiz.style.display = ""
	    this.horiz.firstChild.style.width = "0"
	  }
	
	  if (!this.checkedZeroWidth && measure.clientHeight > 0) {
	    if (sWidth == 0) { this.zeroWidthHack() }
	    this.checkedZeroWidth = true
	  }
	
	  return {right: needsV ? sWidth : 0, bottom: needsH ? sWidth : 0}
	};
	
	NativeScrollbars.prototype.setScrollLeft = function (pos) {
	  if (this.horiz.scrollLeft != pos) { this.horiz.scrollLeft = pos }
	  if (this.disableHoriz) { this.enableZeroWidthBar(this.horiz, this.disableHoriz) }
	};
	
	NativeScrollbars.prototype.setScrollTop = function (pos) {
	  if (this.vert.scrollTop != pos) { this.vert.scrollTop = pos }
	  if (this.disableVert) { this.enableZeroWidthBar(this.vert, this.disableVert) }
	};
	
	NativeScrollbars.prototype.zeroWidthHack = function () {
	  var w = mac && !mac_geMountainLion ? "12px" : "18px"
	  this.horiz.style.height = this.vert.style.width = w
	  this.horiz.style.pointerEvents = this.vert.style.pointerEvents = "none"
	  this.disableHoriz = new Delayed
	  this.disableVert = new Delayed
	};
	
	NativeScrollbars.prototype.enableZeroWidthBar = function (bar, delay) {
	  bar.style.pointerEvents = "auto"
	  function maybeDisable() {
	    // To find out whether the scrollbar is still visible, we
	    // check whether the element under the pixel in the bottom
	    // left corner of the scrollbar box is the scrollbar box
	    // itself (when the bar is still visible) or its filler child
	    // (when the bar is hidden). If it is still visible, we keep
	    // it enabled, if it's hidden, we disable pointer events.
	    var box = bar.getBoundingClientRect()
	    var elt = document.elementFromPoint(box.left + 1, box.bottom - 1)
	    if (elt != bar) { bar.style.pointerEvents = "none" }
	    else { delay.set(1000, maybeDisable) }
	  }
	  delay.set(1000, maybeDisable)
	};
	
	NativeScrollbars.prototype.clear = function () {
	  var parent = this.horiz.parentNode
	  parent.removeChild(this.horiz)
	  parent.removeChild(this.vert)
	};
	
	var NullScrollbars = function () {};
	
	NullScrollbars.prototype.update = function () { return {bottom: 0, right: 0} };
	NullScrollbars.prototype.setScrollLeft = function () {};
	NullScrollbars.prototype.setScrollTop = function () {};
	NullScrollbars.prototype.clear = function () {};
	
	function updateScrollbars(cm, measure) {
	  if (!measure) { measure = measureForScrollbars(cm) }
	  var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight
	  updateScrollbarsInner(cm, measure)
	  for (var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++) {
	    if (startWidth != cm.display.barWidth && cm.options.lineWrapping)
	      { updateHeightsInViewport(cm) }
	    updateScrollbarsInner(cm, measureForScrollbars(cm))
	    startWidth = cm.display.barWidth; startHeight = cm.display.barHeight
	  }
	}
	
	// Re-synchronize the fake scrollbars with the actual size of the
	// content.
	function updateScrollbarsInner(cm, measure) {
	  var d = cm.display
	  var sizes = d.scrollbars.update(measure)
	
	  d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px"
	  d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px"
	  d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent"
	
	  if (sizes.right && sizes.bottom) {
	    d.scrollbarFiller.style.display = "block"
	    d.scrollbarFiller.style.height = sizes.bottom + "px"
	    d.scrollbarFiller.style.width = sizes.right + "px"
	  } else { d.scrollbarFiller.style.display = "" }
	  if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
	    d.gutterFiller.style.display = "block"
	    d.gutterFiller.style.height = sizes.bottom + "px"
	    d.gutterFiller.style.width = measure.gutterWidth + "px"
	  } else { d.gutterFiller.style.display = "" }
	}
	
	var scrollbarModel = {"native": NativeScrollbars, "null": NullScrollbars}
	
	function initScrollbars(cm) {
	  if (cm.display.scrollbars) {
	    cm.display.scrollbars.clear()
	    if (cm.display.scrollbars.addClass)
	      { rmClass(cm.display.wrapper, cm.display.scrollbars.addClass) }
	  }
	
	  cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function (node) {
	    cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller)
	    // Prevent clicks in the scrollbars from killing focus
	    on(node, "mousedown", function () {
	      if (cm.state.focused) { setTimeout(function () { return cm.display.input.focus(); }, 0) }
	    })
	    node.setAttribute("cm-not-content", "true")
	  }, function (pos, axis) {
	    if (axis == "horizontal") { setScrollLeft(cm, pos) }
	    else { setScrollTop(cm, pos) }
	  }, cm)
	  if (cm.display.scrollbars.addClass)
	    { addClass(cm.display.wrapper, cm.display.scrollbars.addClass) }
	}
	
	// SCROLLING THINGS INTO VIEW
	
	// If an editor sits on the top or bottom of the window, partially
	// scrolled out of view, this ensures that the cursor is visible.
	function maybeScrollWindow(cm, coords) {
	  if (signalDOMEvent(cm, "scrollCursorIntoView")) { return }
	
	  var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null
	  if (coords.top + box.top < 0) { doScroll = true }
	  else if (coords.bottom + box.top > (window.innerHeight || document.documentElement.clientHeight)) { doScroll = false }
	  if (doScroll != null && !phantom) {
	    var scrollNode = elt("div", "\u200b", null, ("position: absolute;\n                         top: " + (coords.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (coords.bottom - coords.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + (coords.left) + "px; width: 2px;"))
	    cm.display.lineSpace.appendChild(scrollNode)
	    scrollNode.scrollIntoView(doScroll)
	    cm.display.lineSpace.removeChild(scrollNode)
	  }
	}
	
	// Scroll a given position into view (immediately), verifying that
	// it actually became visible (as line heights are accurately
	// measured, the position of something may 'drift' during drawing).
	function scrollPosIntoView(cm, pos, end, margin) {
	  if (margin == null) { margin = 0 }
	  var coords
	  for (var limit = 0; limit < 5; limit++) {
	    var changed = false
	    coords = cursorCoords(cm, pos)
	    var endCoords = !end || end == pos ? coords : cursorCoords(cm, end)
	    var scrollPos = calculateScrollPos(cm, Math.min(coords.left, endCoords.left),
	                                       Math.min(coords.top, endCoords.top) - margin,
	                                       Math.max(coords.left, endCoords.left),
	                                       Math.max(coords.bottom, endCoords.bottom) + margin)
	    var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft
	    if (scrollPos.scrollTop != null) {
	      setScrollTop(cm, scrollPos.scrollTop)
	      if (Math.abs(cm.doc.scrollTop - startTop) > 1) { changed = true }
	    }
	    if (scrollPos.scrollLeft != null) {
	      setScrollLeft(cm, scrollPos.scrollLeft)
	      if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) { changed = true }
	    }
	    if (!changed) { break }
	  }
	  return coords
	}
	
	// Scroll a given set of coordinates into view (immediately).
	function scrollIntoView(cm, x1, y1, x2, y2) {
	  var scrollPos = calculateScrollPos(cm, x1, y1, x2, y2)
	  if (scrollPos.scrollTop != null) { setScrollTop(cm, scrollPos.scrollTop) }
	  if (scrollPos.scrollLeft != null) { setScrollLeft(cm, scrollPos.scrollLeft) }
	}
	
	// Calculate a new scroll position needed to scroll the given
	// rectangle into view. Returns an object with scrollTop and
	// scrollLeft properties. When these are undefined, the
	// vertical/horizontal position does not need to be adjusted.
	function calculateScrollPos(cm, x1, y1, x2, y2) {
	  var display = cm.display, snapMargin = textHeight(cm.display)
	  if (y1 < 0) { y1 = 0 }
	  var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop
	  var screen = displayHeight(cm), result = {}
	  if (y2 - y1 > screen) { y2 = y1 + screen }
	  var docBottom = cm.doc.height + paddingVert(display)
	  var atTop = y1 < snapMargin, atBottom = y2 > docBottom - snapMargin
	  if (y1 < screentop) {
	    result.scrollTop = atTop ? 0 : y1
	  } else if (y2 > screentop + screen) {
	    var newTop = Math.min(y1, (atBottom ? docBottom : y2) - screen)
	    if (newTop != screentop) { result.scrollTop = newTop }
	  }
	
	  var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft
	  var screenw = displayWidth(cm) - (cm.options.fixedGutter ? display.gutters.offsetWidth : 0)
	  var tooWide = x2 - x1 > screenw
	  if (tooWide) { x2 = x1 + screenw }
	  if (x1 < 10)
	    { result.scrollLeft = 0 }
	  else if (x1 < screenleft)
	    { result.scrollLeft = Math.max(0, x1 - (tooWide ? 0 : 10)) }
	  else if (x2 > screenw + screenleft - 3)
	    { result.scrollLeft = x2 + (tooWide ? 0 : 10) - screenw }
	  return result
	}
	
	// Store a relative adjustment to the scroll position in the current
	// operation (to be applied when the operation finishes).
	function addToScrollPos(cm, left, top) {
	  if (left != null || top != null) { resolveScrollToPos(cm) }
	  if (left != null)
	    { cm.curOp.scrollLeft = (cm.curOp.scrollLeft == null ? cm.doc.scrollLeft : cm.curOp.scrollLeft) + left }
	  if (top != null)
	    { cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top }
	}
	
	// Make sure that at the end of the operation the current cursor is
	// shown.
	function ensureCursorVisible(cm) {
	  resolveScrollToPos(cm)
	  var cur = cm.getCursor(), from = cur, to = cur
	  if (!cm.options.lineWrapping) {
	    from = cur.ch ? Pos(cur.line, cur.ch - 1) : cur
	    to = Pos(cur.line, cur.ch + 1)
	  }
	  cm.curOp.scrollToPos = {from: from, to: to, margin: cm.options.cursorScrollMargin, isCursor: true}
	}
	
	// When an operation has its scrollToPos property set, and another
	// scroll action is applied before the end of the operation, this
	// 'simulates' scrolling that position into view in a cheap way, so
	// that the effect of intermediate scroll commands is not ignored.
	function resolveScrollToPos(cm) {
	  var range = cm.curOp.scrollToPos
	  if (range) {
	    cm.curOp.scrollToPos = null
	    var from = estimateCoords(cm, range.from), to = estimateCoords(cm, range.to)
	    var sPos = calculateScrollPos(cm, Math.min(from.left, to.left),
	                                  Math.min(from.top, to.top) - range.margin,
	                                  Math.max(from.right, to.right),
	                                  Math.max(from.bottom, to.bottom) + range.margin)
	    cm.scrollTo(sPos.scrollLeft, sPos.scrollTop)
	  }
	}
	
	// Operations are used to wrap a series of changes to the editor
	// state in such a way that each change won't have to update the
	// cursor and display (which would be awkward, slow, and
	// error-prone). Instead, display updates are batched and then all
	// combined and executed at once.
	
	var nextOpId = 0
	// Start a new operation.
	function startOperation(cm) {
	  cm.curOp = {
	    cm: cm,
	    viewChanged: false,      // Flag that indicates that lines might need to be redrawn
	    startHeight: cm.doc.height, // Used to detect need to update scrollbar
	    forceUpdate: false,      // Used to force a redraw
	    updateInput: null,       // Whether to reset the input textarea
	    typing: false,           // Whether this reset should be careful to leave existing text (for compositing)
	    changeObjs: null,        // Accumulated changes, for firing change events
	    cursorActivityHandlers: null, // Set of handlers to fire cursorActivity on
	    cursorActivityCalled: 0, // Tracks which cursorActivity handlers have been called already
	    selectionChanged: false, // Whether the selection needs to be redrawn
	    updateMaxLine: false,    // Set when the widest line needs to be determined anew
	    scrollLeft: null, scrollTop: null, // Intermediate scroll position, not pushed to DOM yet
	    scrollToPos: null,       // Used to scroll to a specific position
	    focus: false,
	    id: ++nextOpId           // Unique ID
	  }
	  pushOperation(cm.curOp)
	}
	
	// Finish an operation, updating the display and signalling delayed events
	function endOperation(cm) {
	  var op = cm.curOp
	  finishOperation(op, function (group) {
	    for (var i = 0; i < group.ops.length; i++)
	      { group.ops[i].cm.curOp = null }
	    endOperations(group)
	  })
	}
	
	// The DOM updates done when an operation finishes are batched so
	// that the minimum number of relayouts are required.
	function endOperations(group) {
	  var ops = group.ops
	  for (var i = 0; i < ops.length; i++) // Read DOM
	    { endOperation_R1(ops[i]) }
	  for (var i$1 = 0; i$1 < ops.length; i$1++) // Write DOM (maybe)
	    { endOperation_W1(ops[i$1]) }
	  for (var i$2 = 0; i$2 < ops.length; i$2++) // Read DOM
	    { endOperation_R2(ops[i$2]) }
	  for (var i$3 = 0; i$3 < ops.length; i$3++) // Write DOM (maybe)
	    { endOperation_W2(ops[i$3]) }
	  for (var i$4 = 0; i$4 < ops.length; i$4++) // Read DOM
	    { endOperation_finish(ops[i$4]) }
	}
	
	function endOperation_R1(op) {
	  var cm = op.cm, display = cm.display
	  maybeClipScrollbars(cm)
	  if (op.updateMaxLine) { findMaxLine(cm) }
	
	  op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null ||
	    op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom ||
	                       op.scrollToPos.to.line >= display.viewTo) ||
	    display.maxLineChanged && cm.options.lineWrapping
	  op.update = op.mustUpdate &&
	    new DisplayUpdate(cm, op.mustUpdate && {top: op.scrollTop, ensure: op.scrollToPos}, op.forceUpdate)
	}
	
	function endOperation_W1(op) {
	  op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update)
	}
	
	function endOperation_R2(op) {
	  var cm = op.cm, display = cm.display
	  if (op.updatedDisplay) { updateHeightsInViewport(cm) }
	
	  op.barMeasure = measureForScrollbars(cm)
	
	  // If the max line changed since it was last measured, measure it,
	  // and ensure the document's width matches it.
	  // updateDisplay_W2 will use these properties to do the actual resizing
	  if (display.maxLineChanged && !cm.options.lineWrapping) {
	    op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3
	    cm.display.sizerWidth = op.adjustWidthTo
	    op.barMeasure.scrollWidth =
	      Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth)
	    op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm))
	  }
	
	  if (op.updatedDisplay || op.selectionChanged)
	    { op.preparedSelection = display.input.prepareSelection(op.focus) }
	}
	
	function endOperation_W2(op) {
	  var cm = op.cm
	
	  if (op.adjustWidthTo != null) {
	    cm.display.sizer.style.minWidth = op.adjustWidthTo + "px"
	    if (op.maxScrollLeft < cm.doc.scrollLeft)
	      { setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true) }
	    cm.display.maxLineChanged = false
	  }
	
	  var takeFocus = op.focus && op.focus == activeElt() && (!document.hasFocus || document.hasFocus())
	  if (op.preparedSelection)
	    { cm.display.input.showSelection(op.preparedSelection, takeFocus) }
	  if (op.updatedDisplay || op.startHeight != cm.doc.height)
	    { updateScrollbars(cm, op.barMeasure) }
	  if (op.updatedDisplay)
	    { setDocumentHeight(cm, op.barMeasure) }
	
	  if (op.selectionChanged) { restartBlink(cm) }
	
	  if (cm.state.focused && op.updateInput)
	    { cm.display.input.reset(op.typing) }
	  if (takeFocus) { ensureFocus(op.cm) }
	}
	
	function endOperation_finish(op) {
	  var cm = op.cm, display = cm.display, doc = cm.doc
	
	  if (op.updatedDisplay) { postUpdateDisplay(cm, op.update) }
	
	  // Abort mouse wheel delta measurement, when scrolling explicitly
	  if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos))
	    { display.wheelStartX = display.wheelStartY = null }
	
	  // Propagate the scroll position to the actual DOM scroller
	  if (op.scrollTop != null && (display.scroller.scrollTop != op.scrollTop || op.forceScroll)) {
	    doc.scrollTop = Math.max(0, Math.min(display.scroller.scrollHeight - display.scroller.clientHeight, op.scrollTop))
	    display.scrollbars.setScrollTop(doc.scrollTop)
	    display.scroller.scrollTop = doc.scrollTop
	  }
	  if (op.scrollLeft != null && (display.scroller.scrollLeft != op.scrollLeft || op.forceScroll)) {
	    doc.scrollLeft = Math.max(0, Math.min(display.scroller.scrollWidth - display.scroller.clientWidth, op.scrollLeft))
	    display.scrollbars.setScrollLeft(doc.scrollLeft)
	    display.scroller.scrollLeft = doc.scrollLeft
	    alignHorizontally(cm)
	  }
	  // If we need to scroll a specific position into view, do so.
	  if (op.scrollToPos) {
	    var coords = scrollPosIntoView(cm, clipPos(doc, op.scrollToPos.from),
	                                   clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin)
	    if (op.scrollToPos.isCursor && cm.state.focused) { maybeScrollWindow(cm, coords) }
	  }
	
	  // Fire events for markers that are hidden/unidden by editing or
	  // undoing
	  var hidden = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers
	  if (hidden) { for (var i = 0; i < hidden.length; ++i)
	    { if (!hidden[i].lines.length) { signal(hidden[i], "hide") } } }
	  if (unhidden) { for (var i$1 = 0; i$1 < unhidden.length; ++i$1)
	    { if (unhidden[i$1].lines.length) { signal(unhidden[i$1], "unhide") } } }
	
	  if (display.wrapper.offsetHeight)
	    { doc.scrollTop = cm.display.scroller.scrollTop }
	
	  // Fire change events, and delayed event handlers
	  if (op.changeObjs)
	    { signal(cm, "changes", cm, op.changeObjs) }
	  if (op.update)
	    { op.update.finish() }
	}
	
	// Run the given function in an operation
	function runInOp(cm, f) {
	  if (cm.curOp) { return f() }
	  startOperation(cm)
	  try { return f() }
	  finally { endOperation(cm) }
	}
	// Wraps a function in an operation. Returns the wrapped function.
	function operation(cm, f) {
	  return function() {
	    if (cm.curOp) { return f.apply(cm, arguments) }
	    startOperation(cm)
	    try { return f.apply(cm, arguments) }
	    finally { endOperation(cm) }
	  }
	}
	// Used to add methods to editor and doc instances, wrapping them in
	// operations.
	function methodOp(f) {
	  return function() {
	    if (this.curOp) { return f.apply(this, arguments) }
	    startOperation(this)
	    try { return f.apply(this, arguments) }
	    finally { endOperation(this) }
	  }
	}
	function docMethodOp(f) {
	  return function() {
	    var cm = this.cm
	    if (!cm || cm.curOp) { return f.apply(this, arguments) }
	    startOperation(cm)
	    try { return f.apply(this, arguments) }
	    finally { endOperation(cm) }
	  }
	}
	
	// Updates the display.view data structure for a given change to the
	// document. From and to are in pre-change coordinates. Lendiff is
	// the amount of lines added or subtracted by the change. This is
	// used for changes that span multiple lines, or change the way
	// lines are divided into visual lines. regLineChange (below)
	// registers single-line changes.
	function regChange(cm, from, to, lendiff) {
	  if (from == null) { from = cm.doc.first }
	  if (to == null) { to = cm.doc.first + cm.doc.size }
	  if (!lendiff) { lendiff = 0 }
	
	  var display = cm.display
	  if (lendiff && to < display.viewTo &&
	      (display.updateLineNumbers == null || display.updateLineNumbers > from))
	    { display.updateLineNumbers = from }
	
	  cm.curOp.viewChanged = true
	
	  if (from >= display.viewTo) { // Change after
	    if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo)
	      { resetView(cm) }
	  } else if (to <= display.viewFrom) { // Change before
	    if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) {
	      resetView(cm)
	    } else {
	      display.viewFrom += lendiff
	      display.viewTo += lendiff
	    }
	  } else if (from <= display.viewFrom && to >= display.viewTo) { // Full overlap
	    resetView(cm)
	  } else if (from <= display.viewFrom) { // Top overlap
	    var cut = viewCuttingPoint(cm, to, to + lendiff, 1)
	    if (cut) {
	      display.view = display.view.slice(cut.index)
	      display.viewFrom = cut.lineN
	      display.viewTo += lendiff
	    } else {
	      resetView(cm)
	    }
	  } else if (to >= display.viewTo) { // Bottom overlap
	    var cut$1 = viewCuttingPoint(cm, from, from, -1)
	    if (cut$1) {
	      display.view = display.view.slice(0, cut$1.index)
	      display.viewTo = cut$1.lineN
	    } else {
	      resetView(cm)
	    }
	  } else { // Gap in the middle
	    var cutTop = viewCuttingPoint(cm, from, from, -1)
	    var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1)
	    if (cutTop && cutBot) {
	      display.view = display.view.slice(0, cutTop.index)
	        .concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN))
	        .concat(display.view.slice(cutBot.index))
	      display.viewTo += lendiff
	    } else {
	      resetView(cm)
	    }
	  }
	
	  var ext = display.externalMeasured
	  if (ext) {
	    if (to < ext.lineN)
	      { ext.lineN += lendiff }
	    else if (from < ext.lineN + ext.size)
	      { display.externalMeasured = null }
	  }
	}
	
	// Register a change to a single line. Type must be one of "text",
	// "gutter", "class", "widget"
	function regLineChange(cm, line, type) {
	  cm.curOp.viewChanged = true
	  var display = cm.display, ext = cm.display.externalMeasured
	  if (ext && line >= ext.lineN && line < ext.lineN + ext.size)
	    { display.externalMeasured = null }
	
	  if (line < display.viewFrom || line >= display.viewTo) { return }
	  var lineView = display.view[findViewIndex(cm, line)]
	  if (lineView.node == null) { return }
	  var arr = lineView.changes || (lineView.changes = [])
	  if (indexOf(arr, type) == -1) { arr.push(type) }
	}
	
	// Clear the view.
	function resetView(cm) {
	  cm.display.viewFrom = cm.display.viewTo = cm.doc.first
	  cm.display.view = []
	  cm.display.viewOffset = 0
	}
	
	function viewCuttingPoint(cm, oldN, newN, dir) {
	  var index = findViewIndex(cm, oldN), diff, view = cm.display.view
	  if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size)
	    { return {index: index, lineN: newN} }
	  var n = cm.display.viewFrom
	  for (var i = 0; i < index; i++)
	    { n += view[i].size }
	  if (n != oldN) {
	    if (dir > 0) {
	      if (index == view.length - 1) { return null }
	      diff = (n + view[index].size) - oldN
	      index++
	    } else {
	      diff = n - oldN
	    }
	    oldN += diff; newN += diff
	  }
	  while (visualLineNo(cm.doc, newN) != newN) {
	    if (index == (dir < 0 ? 0 : view.length - 1)) { return null }
	    newN += dir * view[index - (dir < 0 ? 1 : 0)].size
	    index += dir
	  }
	  return {index: index, lineN: newN}
	}
	
	// Force the view to cover a given range, adding empty view element
	// or clipping off existing ones as needed.
	function adjustView(cm, from, to) {
	  var display = cm.display, view = display.view
	  if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
	    display.view = buildViewArray(cm, from, to)
	    display.viewFrom = from
	  } else {
	    if (display.viewFrom > from)
	      { display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view) }
	    else if (display.viewFrom < from)
	      { display.view = display.view.slice(findViewIndex(cm, from)) }
	    display.viewFrom = from
	    if (display.viewTo < to)
	      { display.view = display.view.concat(buildViewArray(cm, display.viewTo, to)) }
	    else if (display.viewTo > to)
	      { display.view = display.view.slice(0, findViewIndex(cm, to)) }
	  }
	  display.viewTo = to
	}
	
	// Count the number of lines in the view whose DOM representation is
	// out of date (or nonexistent).
	function countDirtyView(cm) {
	  var view = cm.display.view, dirty = 0
	  for (var i = 0; i < view.length; i++) {
	    var lineView = view[i]
	    if (!lineView.hidden && (!lineView.node || lineView.changes)) { ++dirty }
	  }
	  return dirty
	}
	
	// HIGHLIGHT WORKER
	
	function startWorker(cm, time) {
	  if (cm.doc.mode.startState && cm.doc.frontier < cm.display.viewTo)
	    { cm.state.highlight.set(time, bind(highlightWorker, cm)) }
	}
	
	function highlightWorker(cm) {
	  var doc = cm.doc
	  if (doc.frontier < doc.first) { doc.frontier = doc.first }
	  if (doc.frontier >= cm.display.viewTo) { return }
	  var end = +new Date + cm.options.workTime
	  var state = copyState(doc.mode, getStateBefore(cm, doc.frontier))
	  var changedLines = []
	
	  doc.iter(doc.frontier, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function (line) {
	    if (doc.frontier >= cm.display.viewFrom) { // Visible
	      var oldStyles = line.styles, tooLong = line.text.length > cm.options.maxHighlightLength
	      var highlighted = highlightLine(cm, line, tooLong ? copyState(doc.mode, state) : state, true)
	      line.styles = highlighted.styles
	      var oldCls = line.styleClasses, newCls = highlighted.classes
	      if (newCls) { line.styleClasses = newCls }
	      else if (oldCls) { line.styleClasses = null }
	      var ischange = !oldStyles || oldStyles.length != line.styles.length ||
	        oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass)
	      for (var i = 0; !ischange && i < oldStyles.length; ++i) { ischange = oldStyles[i] != line.styles[i] }
	      if (ischange) { changedLines.push(doc.frontier) }
	      line.stateAfter = tooLong ? state : copyState(doc.mode, state)
	    } else {
	      if (line.text.length <= cm.options.maxHighlightLength)
	        { processLine(cm, line.text, state) }
	      line.stateAfter = doc.frontier % 5 == 0 ? copyState(doc.mode, state) : null
	    }
	    ++doc.frontier
	    if (+new Date > end) {
	      startWorker(cm, cm.options.workDelay)
	      return true
	    }
	  })
	  if (changedLines.length) { runInOp(cm, function () {
	    for (var i = 0; i < changedLines.length; i++)
	      { regLineChange(cm, changedLines[i], "text") }
	  }) }
	}
	
	// DISPLAY DRAWING
	
	var DisplayUpdate = function(cm, viewport, force) {
	  var display = cm.display
	
	  this.viewport = viewport
	  // Store some values that we'll need later (but don't want to force a relayout for)
	  this.visible = visibleLines(display, cm.doc, viewport)
	  this.editorIsHidden = !display.wrapper.offsetWidth
	  this.wrapperHeight = display.wrapper.clientHeight
	  this.wrapperWidth = display.wrapper.clientWidth
	  this.oldDisplayWidth = displayWidth(cm)
	  this.force = force
	  this.dims = getDimensions(cm)
	  this.events = []
	};
	
	DisplayUpdate.prototype.signal = function (emitter, type) {
	  if (hasHandler(emitter, type))
	    { this.events.push(arguments) }
	};
	DisplayUpdate.prototype.finish = function () {
	    var this$1 = this;
	
	  for (var i = 0; i < this.events.length; i++)
	    { signal.apply(null, this$1.events[i]) }
	};
	
	function maybeClipScrollbars(cm) {
	  var display = cm.display
	  if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
	    display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth
	    display.heightForcer.style.height = scrollGap(cm) + "px"
	    display.sizer.style.marginBottom = -display.nativeBarWidth + "px"
	    display.sizer.style.borderRightWidth = scrollGap(cm) + "px"
	    display.scrollbarsClipped = true
	  }
	}
	
	// Does the actual updating of the line display. Bails out
	// (returning false) when there is nothing to be done and forced is
	// false.
	function updateDisplayIfNeeded(cm, update) {
	  var display = cm.display, doc = cm.doc
	
	  if (update.editorIsHidden) {
	    resetView(cm)
	    return false
	  }
	
	  // Bail out if the visible area is already rendered and nothing changed.
	  if (!update.force &&
	      update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo &&
	      (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) &&
	      display.renderedView == display.view && countDirtyView(cm) == 0)
	    { return false }
	
	  if (maybeUpdateLineNumberWidth(cm)) {
	    resetView(cm)
	    update.dims = getDimensions(cm)
	  }
	
	  // Compute a suitable new viewport (from & to)
	  var end = doc.first + doc.size
	  var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first)
	  var to = Math.min(end, update.visible.to + cm.options.viewportMargin)
	  if (display.viewFrom < from && from - display.viewFrom < 20) { from = Math.max(doc.first, display.viewFrom) }
	  if (display.viewTo > to && display.viewTo - to < 20) { to = Math.min(end, display.viewTo) }
	  if (sawCollapsedSpans) {
	    from = visualLineNo(cm.doc, from)
	    to = visualLineEndNo(cm.doc, to)
	  }
	
	  var different = from != display.viewFrom || to != display.viewTo ||
	    display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth
	  adjustView(cm, from, to)
	
	  display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom))
	  // Position the mover div to align with the current scroll position
	  cm.display.mover.style.top = display.viewOffset + "px"
	
	  var toUpdate = countDirtyView(cm)
	  if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view &&
	      (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo))
	    { return false }
	
	  // For big changes, we hide the enclosing element during the
	  // update, since that speeds up the operations on most browsers.
	  var focused = activeElt()
	  if (toUpdate > 4) { display.lineDiv.style.display = "none" }
	  patchDisplay(cm, display.updateLineNumbers, update.dims)
	  if (toUpdate > 4) { display.lineDiv.style.display = "" }
	  display.renderedView = display.view
	  // There might have been a widget with a focused element that got
	  // hidden or updated, if so re-focus it.
	  if (focused && activeElt() != focused && focused.offsetHeight) { focused.focus() }
	
	  // Prevent selection and cursors from interfering with the scroll
	  // width and height.
	  removeChildren(display.cursorDiv)
	  removeChildren(display.selectionDiv)
	  display.gutters.style.height = display.sizer.style.minHeight = 0
	
	  if (different) {
	    display.lastWrapHeight = update.wrapperHeight
	    display.lastWrapWidth = update.wrapperWidth
	    startWorker(cm, 400)
	  }
	
	  display.updateLineNumbers = null
	
	  return true
	}
	
	function postUpdateDisplay(cm, update) {
	  var viewport = update.viewport
	
	  for (var first = true;; first = false) {
	    if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
	      // Clip forced viewport to actual scrollable area.
	      if (viewport && viewport.top != null)
	        { viewport = {top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top)} }
	      // Updated line heights might result in the drawn area not
	      // actually covering the viewport. Keep looping until it does.
	      update.visible = visibleLines(cm.display, cm.doc, viewport)
	      if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo)
	        { break }
	    }
	    if (!updateDisplayIfNeeded(cm, update)) { break }
	    updateHeightsInViewport(cm)
	    var barMeasure = measureForScrollbars(cm)
	    updateSelection(cm)
	    updateScrollbars(cm, barMeasure)
	    setDocumentHeight(cm, barMeasure)
	  }
	
	  update.signal(cm, "update", cm)
	  if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
	    update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo)
	    cm.display.reportedViewFrom = cm.display.viewFrom; cm.display.reportedViewTo = cm.display.viewTo
	  }
	}
	
	function updateDisplaySimple(cm, viewport) {
	  var update = new DisplayUpdate(cm, viewport)
	  if (updateDisplayIfNeeded(cm, update)) {
	    updateHeightsInViewport(cm)
	    postUpdateDisplay(cm, update)
	    var barMeasure = measureForScrollbars(cm)
	    updateSelection(cm)
	    updateScrollbars(cm, barMeasure)
	    setDocumentHeight(cm, barMeasure)
	    update.finish()
	  }
	}
	
	// Sync the actual display DOM structure with display.view, removing
	// nodes for lines that are no longer in view, and creating the ones
	// that are not there yet, and updating the ones that are out of
	// date.
	function patchDisplay(cm, updateNumbersFrom, dims) {
	  var display = cm.display, lineNumbers = cm.options.lineNumbers
	  var container = display.lineDiv, cur = container.firstChild
	
	  function rm(node) {
	    var next = node.nextSibling
	    // Works around a throw-scroll bug in OS X Webkit
	    if (webkit && mac && cm.display.currentWheelTarget == node)
	      { node.style.display = "none" }
	    else
	      { node.parentNode.removeChild(node) }
	    return next
	  }
	
	  var view = display.view, lineN = display.viewFrom
	  // Loop over the elements in the view, syncing cur (the DOM nodes
	  // in display.lineDiv) with the view as we go.
	  for (var i = 0; i < view.length; i++) {
	    var lineView = view[i]
	    if (lineView.hidden) {
	    } else if (!lineView.node || lineView.node.parentNode != container) { // Not drawn yet
	      var node = buildLineElement(cm, lineView, lineN, dims)
	      container.insertBefore(node, cur)
	    } else { // Already drawn
	      while (cur != lineView.node) { cur = rm(cur) }
	      var updateNumber = lineNumbers && updateNumbersFrom != null &&
	        updateNumbersFrom <= lineN && lineView.lineNumber
	      if (lineView.changes) {
	        if (indexOf(lineView.changes, "gutter") > -1) { updateNumber = false }
	        updateLineForChanges(cm, lineView, lineN, dims)
	      }
	      if (updateNumber) {
	        removeChildren(lineView.lineNumber)
	        lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)))
	      }
	      cur = lineView.node.nextSibling
	    }
	    lineN += lineView.size
	  }
	  while (cur) { cur = rm(cur) }
	}
	
	function updateGutterSpace(cm) {
	  var width = cm.display.gutters.offsetWidth
	  cm.display.sizer.style.marginLeft = width + "px"
	}
	
	function setDocumentHeight(cm, measure) {
	  cm.display.sizer.style.minHeight = measure.docHeight + "px"
	  cm.display.heightForcer.style.top = measure.docHeight + "px"
	  cm.display.gutters.style.height = (measure.docHeight + cm.display.barHeight + scrollGap(cm)) + "px"
	}
	
	// Rebuild the gutter elements, ensure the margin to the left of the
	// code matches their width.
	function updateGutters(cm) {
	  var gutters = cm.display.gutters, specs = cm.options.gutters
	  removeChildren(gutters)
	  var i = 0
	  for (; i < specs.length; ++i) {
	    var gutterClass = specs[i]
	    var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + gutterClass))
	    if (gutterClass == "CodeMirror-linenumbers") {
	      cm.display.lineGutter = gElt
	      gElt.style.width = (cm.display.lineNumWidth || 1) + "px"
	    }
	  }
	  gutters.style.display = i ? "" : "none"
	  updateGutterSpace(cm)
	}
	
	// Make sure the gutters options contains the element
	// "CodeMirror-linenumbers" when the lineNumbers option is true.
	function setGuttersForLineNumbers(options) {
	  var found = indexOf(options.gutters, "CodeMirror-linenumbers")
	  if (found == -1 && options.lineNumbers) {
	    options.gutters = options.gutters.concat(["CodeMirror-linenumbers"])
	  } else if (found > -1 && !options.lineNumbers) {
	    options.gutters = options.gutters.slice(0)
	    options.gutters.splice(found, 1)
	  }
	}
	
	// Selection objects are immutable. A new one is created every time
	// the selection changes. A selection is one or more non-overlapping
	// (and non-touching) ranges, sorted, and an integer that indicates
	// which one is the primary selection (the one that's scrolled into
	// view, that getCursor returns, etc).
	function Selection(ranges, primIndex) {
	  this.ranges = ranges
	  this.primIndex = primIndex
	}
	
	Selection.prototype = {
	  primary: function() { return this.ranges[this.primIndex] },
	  equals: function(other) {
	    var this$1 = this;
	
	    if (other == this) { return true }
	    if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) { return false }
	    for (var i = 0; i < this.ranges.length; i++) {
	      var here = this$1.ranges[i], there = other.ranges[i]
	      if (cmp(here.anchor, there.anchor) != 0 || cmp(here.head, there.head) != 0) { return false }
	    }
	    return true
	  },
	  deepCopy: function() {
	    var this$1 = this;
	
	    var out = []
	    for (var i = 0; i < this.ranges.length; i++)
	      { out[i] = new Range(copyPos(this$1.ranges[i].anchor), copyPos(this$1.ranges[i].head)) }
	    return new Selection(out, this.primIndex)
	  },
	  somethingSelected: function() {
	    var this$1 = this;
	
	    for (var i = 0; i < this.ranges.length; i++)
	      { if (!this$1.ranges[i].empty()) { return true } }
	    return false
	  },
	  contains: function(pos, end) {
	    var this$1 = this;
	
	    if (!end) { end = pos }
	    for (var i = 0; i < this.ranges.length; i++) {
	      var range = this$1.ranges[i]
	      if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0)
	        { return i }
	    }
	    return -1
	  }
	}
	
	function Range(anchor, head) {
	  this.anchor = anchor; this.head = head
	}
	
	Range.prototype = {
	  from: function() { return minPos(this.anchor, this.head) },
	  to: function() { return maxPos(this.anchor, this.head) },
	  empty: function() {
	    return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch
	  }
	}
	
	// Take an unsorted, potentially overlapping set of ranges, and
	// build a selection out of it. 'Consumes' ranges array (modifying
	// it).
	function normalizeSelection(ranges, primIndex) {
	  var prim = ranges[primIndex]
	  ranges.sort(function (a, b) { return cmp(a.from(), b.from()); })
	  primIndex = indexOf(ranges, prim)
	  for (var i = 1; i < ranges.length; i++) {
	    var cur = ranges[i], prev = ranges[i - 1]
	    if (cmp(prev.to(), cur.from()) >= 0) {
	      var from = minPos(prev.from(), cur.from()), to = maxPos(prev.to(), cur.to())
	      var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head
	      if (i <= primIndex) { --primIndex }
	      ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to))
	    }
	  }
	  return new Selection(ranges, primIndex)
	}
	
	function simpleSelection(anchor, head) {
	  return new Selection([new Range(anchor, head || anchor)], 0)
	}
	
	// Compute the position of the end of a change (its 'to' property
	// refers to the pre-change end).
	function changeEnd(change) {
	  if (!change.text) { return change.to }
	  return Pos(change.from.line + change.text.length - 1,
	             lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0))
	}
	
	// Adjust a position to refer to the post-change position of the
	// same text, or the end of the change if the change covers it.
	function adjustForChange(pos, change) {
	  if (cmp(pos, change.from) < 0) { return pos }
	  if (cmp(pos, change.to) <= 0) { return changeEnd(change) }
	
	  var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1, ch = pos.ch
	  if (pos.line == change.to.line) { ch += changeEnd(change).ch - change.to.ch }
	  return Pos(line, ch)
	}
	
	function computeSelAfterChange(doc, change) {
	  var out = []
	  for (var i = 0; i < doc.sel.ranges.length; i++) {
	    var range = doc.sel.ranges[i]
	    out.push(new Range(adjustForChange(range.anchor, change),
	                       adjustForChange(range.head, change)))
	  }
	  return normalizeSelection(out, doc.sel.primIndex)
	}
	
	function offsetPos(pos, old, nw) {
	  if (pos.line == old.line)
	    { return Pos(nw.line, pos.ch - old.ch + nw.ch) }
	  else
	    { return Pos(nw.line + (pos.line - old.line), pos.ch) }
	}
	
	// Used by replaceSelections to allow moving the selection to the
	// start or around the replaced test. Hint may be "start" or "around".
	function computeReplacedSel(doc, changes, hint) {
	  var out = []
	  var oldPrev = Pos(doc.first, 0), newPrev = oldPrev
	  for (var i = 0; i < changes.length; i++) {
	    var change = changes[i]
	    var from = offsetPos(change.from, oldPrev, newPrev)
	    var to = offsetPos(changeEnd(change), oldPrev, newPrev)
	    oldPrev = change.to
	    newPrev = to
	    if (hint == "around") {
	      var range = doc.sel.ranges[i], inv = cmp(range.head, range.anchor) < 0
	      out[i] = new Range(inv ? to : from, inv ? from : to)
	    } else {
	      out[i] = new Range(from, from)
	    }
	  }
	  return new Selection(out, doc.sel.primIndex)
	}
	
	// Used to get the editor into a consistent state again when options change.
	
	function loadMode(cm) {
	  cm.doc.mode = getMode(cm.options, cm.doc.modeOption)
	  resetModeState(cm)
	}
	
	function resetModeState(cm) {
	  cm.doc.iter(function (line) {
	    if (line.stateAfter) { line.stateAfter = null }
	    if (line.styles) { line.styles = null }
	  })
	  cm.doc.frontier = cm.doc.first
	  startWorker(cm, 100)
	  cm.state.modeGen++
	  if (cm.curOp) { regChange(cm) }
	}
	
	// DOCUMENT DATA STRUCTURE
	
	// By default, updates that start and end at the beginning of a line
	// are treated specially, in order to make the association of line
	// widgets and marker elements with the text behave more intuitive.
	function isWholeLineUpdate(doc, change) {
	  return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" &&
	    (!doc.cm || doc.cm.options.wholeLineUpdateBefore)
	}
	
	// Perform a change on the document data structure.
	function updateDoc(doc, change, markedSpans, estimateHeight) {
	  function spansFor(n) {return markedSpans ? markedSpans[n] : null}
	  function update(line, text, spans) {
	    updateLine(line, text, spans, estimateHeight)
	    signalLater(line, "change", line, change)
	  }
	  function linesFor(start, end) {
	    var result = []
	    for (var i = start; i < end; ++i)
	      { result.push(new Line(text[i], spansFor(i), estimateHeight)) }
	    return result
	  }
	
	  var from = change.from, to = change.to, text = change.text
	  var firstLine = getLine(doc, from.line), lastLine = getLine(doc, to.line)
	  var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line
	
	  // Adjust the line structure
	  if (change.full) {
	    doc.insert(0, linesFor(0, text.length))
	    doc.remove(text.length, doc.size - text.length)
	  } else if (isWholeLineUpdate(doc, change)) {
	    // This is a whole-line replace. Treated specially to make
	    // sure line objects move the way they are supposed to.
	    var added = linesFor(0, text.length - 1)
	    update(lastLine, lastLine.text, lastSpans)
	    if (nlines) { doc.remove(from.line, nlines) }
	    if (added.length) { doc.insert(from.line, added) }
	  } else if (firstLine == lastLine) {
	    if (text.length == 1) {
	      update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans)
	    } else {
	      var added$1 = linesFor(1, text.length - 1)
	      added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight))
	      update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0))
	      doc.insert(from.line + 1, added$1)
	    }
	  } else if (text.length == 1) {
	    update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0))
	    doc.remove(from.line + 1, nlines)
	  } else {
	    update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0))
	    update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans)
	    var added$2 = linesFor(1, text.length - 1)
	    if (nlines > 1) { doc.remove(from.line + 1, nlines - 1) }
	    doc.insert(from.line + 1, added$2)
	  }
	
	  signalLater(doc, "change", doc, change)
	}
	
	// Call f for all linked documents.
	function linkedDocs(doc, f, sharedHistOnly) {
	  function propagate(doc, skip, sharedHist) {
	    if (doc.linked) { for (var i = 0; i < doc.linked.length; ++i) {
	      var rel = doc.linked[i]
	      if (rel.doc == skip) { continue }
	      var shared = sharedHist && rel.sharedHist
	      if (sharedHistOnly && !shared) { continue }
	      f(rel.doc, shared)
	      propagate(rel.doc, doc, shared)
	    } }
	  }
	  propagate(doc, null, true)
	}
	
	// Attach a document to an editor.
	function attachDoc(cm, doc) {
	  if (doc.cm) { throw new Error("This document is already in use.") }
	  cm.doc = doc
	  doc.cm = cm
	  estimateLineHeights(cm)
	  loadMode(cm)
	  if (!cm.options.lineWrapping) { findMaxLine(cm) }
	  cm.options.mode = doc.modeOption
	  regChange(cm)
	}
	
	function History(startGen) {
	  // Arrays of change events and selections. Doing something adds an
	  // event to done and clears undo. Undoing moves events from done
	  // to undone, redoing moves them in the other direction.
	  this.done = []; this.undone = []
	  this.undoDepth = Infinity
	  // Used to track when changes can be merged into a single undo
	  // event
	  this.lastModTime = this.lastSelTime = 0
	  this.lastOp = this.lastSelOp = null
	  this.lastOrigin = this.lastSelOrigin = null
	  // Used by the isClean() method
	  this.generation = this.maxGeneration = startGen || 1
	}
	
	// Create a history change event from an updateDoc-style change
	// object.
	function historyChangeFromChange(doc, change) {
	  var histChange = {from: copyPos(change.from), to: changeEnd(change), text: getBetween(doc, change.from, change.to)}
	  attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1)
	  linkedDocs(doc, function (doc) { return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1); }, true)
	  return histChange
	}
	
	// Pop all selection events off the end of a history array. Stop at
	// a change event.
	function clearSelectionEvents(array) {
	  while (array.length) {
	    var last = lst(array)
	    if (last.ranges) { array.pop() }
	    else { break }
	  }
	}
	
	// Find the top change event in the history. Pop off selection
	// events that are in the way.
	function lastChangeEvent(hist, force) {
	  if (force) {
	    clearSelectionEvents(hist.done)
	    return lst(hist.done)
	  } else if (hist.done.length && !lst(hist.done).ranges) {
	    return lst(hist.done)
	  } else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
	    hist.done.pop()
	    return lst(hist.done)
	  }
	}
	
	// Register a change in the history. Merges changes that are within
	// a single operation, or are close together with an origin that
	// allows merging (starting with "+") into a single event.
	function addChangeToHistory(doc, change, selAfter, opId) {
	  var hist = doc.history
	  hist.undone.length = 0
	  var time = +new Date, cur
	  var last
	
	  if ((hist.lastOp == opId ||
	       hist.lastOrigin == change.origin && change.origin &&
	       ((change.origin.charAt(0) == "+" && doc.cm && hist.lastModTime > time - doc.cm.options.historyEventDelay) ||
	        change.origin.charAt(0) == "*")) &&
	      (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
	    // Merge this change into the last event
	    last = lst(cur.changes)
	    if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) {
	      // Optimized case for simple insertion -- don't want to add
	      // new changesets for every character typed
	      last.to = changeEnd(change)
	    } else {
	      // Add new sub-event
	      cur.changes.push(historyChangeFromChange(doc, change))
	    }
	  } else {
	    // Can not be merged, start a new event.
	    var before = lst(hist.done)
	    if (!before || !before.ranges)
	      { pushSelectionToHistory(doc.sel, hist.done) }
	    cur = {changes: [historyChangeFromChange(doc, change)],
	           generation: hist.generation}
	    hist.done.push(cur)
	    while (hist.done.length > hist.undoDepth) {
	      hist.done.shift()
	      if (!hist.done[0].ranges) { hist.done.shift() }
	    }
	  }
	  hist.done.push(selAfter)
	  hist.generation = ++hist.maxGeneration
	  hist.lastModTime = hist.lastSelTime = time
	  hist.lastOp = hist.lastSelOp = opId
	  hist.lastOrigin = hist.lastSelOrigin = change.origin
	
	  if (!last) { signal(doc, "historyAdded") }
	}
	
	function selectionEventCanBeMerged(doc, origin, prev, sel) {
	  var ch = origin.charAt(0)
	  return ch == "*" ||
	    ch == "+" &&
	    prev.ranges.length == sel.ranges.length &&
	    prev.somethingSelected() == sel.somethingSelected() &&
	    new Date - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500)
	}
	
	// Called whenever the selection changes, sets the new selection as
	// the pending selection in the history, and pushes the old pending
	// selection into the 'done' array when it was significantly
	// different (in number of selected ranges, emptiness, or time).
	function addSelectionToHistory(doc, sel, opId, options) {
	  var hist = doc.history, origin = options && options.origin
	
	  // A new event is started when the previous origin does not match
	  // the current, or the origins don't allow matching. Origins
	  // starting with * are always merged, those starting with + are
	  // merged when similar and close together in time.
	  if (opId == hist.lastSelOp ||
	      (origin && hist.lastSelOrigin == origin &&
	       (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin ||
	        selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))))
	    { hist.done[hist.done.length - 1] = sel }
	  else
	    { pushSelectionToHistory(sel, hist.done) }
	
	  hist.lastSelTime = +new Date
	  hist.lastSelOrigin = origin
	  hist.lastSelOp = opId
	  if (options && options.clearRedo !== false)
	    { clearSelectionEvents(hist.undone) }
	}
	
	function pushSelectionToHistory(sel, dest) {
	  var top = lst(dest)
	  if (!(top && top.ranges && top.equals(sel)))
	    { dest.push(sel) }
	}
	
	// Used to store marked span information in the history.
	function attachLocalSpans(doc, change, from, to) {
	  var existing = change["spans_" + doc.id], n = 0
	  doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function (line) {
	    if (line.markedSpans)
	      { (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans }
	    ++n
	  })
	}
	
	// When un/re-doing restores text containing marked spans, those
	// that have been explicitly cleared should not be restored.
	function removeClearedSpans(spans) {
	  if (!spans) { return null }
	  var out
	  for (var i = 0; i < spans.length; ++i) {
	    if (spans[i].marker.explicitlyCleared) { if (!out) { out = spans.slice(0, i) } }
	    else if (out) { out.push(spans[i]) }
	  }
	  return !out ? spans : out.length ? out : null
	}
	
	// Retrieve and filter the old marked spans stored in a change event.
	function getOldSpans(doc, change) {
	  var found = change["spans_" + doc.id]
	  if (!found) { return null }
	  var nw = []
	  for (var i = 0; i < change.text.length; ++i)
	    { nw.push(removeClearedSpans(found[i])) }
	  return nw
	}
	
	// Used for un/re-doing changes from the history. Combines the
	// result of computing the existing spans with the set of spans that
	// existed in the history (so that deleting around a span and then
	// undoing brings back the span).
	function mergeOldSpans(doc, change) {
	  var old = getOldSpans(doc, change)
	  var stretched = stretchSpansOverChange(doc, change)
	  if (!old) { return stretched }
	  if (!stretched) { return old }
	
	  for (var i = 0; i < old.length; ++i) {
	    var oldCur = old[i], stretchCur = stretched[i]
	    if (oldCur && stretchCur) {
	      spans: for (var j = 0; j < stretchCur.length; ++j) {
	        var span = stretchCur[j]
	        for (var k = 0; k < oldCur.length; ++k)
	          { if (oldCur[k].marker == span.marker) { continue spans } }
	        oldCur.push(span)
	      }
	    } else if (stretchCur) {
	      old[i] = stretchCur
	    }
	  }
	  return old
	}
	
	// Used both to provide a JSON-safe object in .getHistory, and, when
	// detaching a document, to split the history in two
	function copyHistoryArray(events, newGroup, instantiateSel) {
	  var copy = []
	  for (var i = 0; i < events.length; ++i) {
	    var event = events[i]
	    if (event.ranges) {
	      copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event)
	      continue
	    }
	    var changes = event.changes, newChanges = []
	    copy.push({changes: newChanges})
	    for (var j = 0; j < changes.length; ++j) {
	      var change = changes[j], m = (void 0)
	      newChanges.push({from: change.from, to: change.to, text: change.text})
	      if (newGroup) { for (var prop in change) { if (m = prop.match(/^spans_(\d+)$/)) {
	        if (indexOf(newGroup, Number(m[1])) > -1) {
	          lst(newChanges)[prop] = change[prop]
	          delete change[prop]
	        }
	      } } }
	    }
	  }
	  return copy
	}
	
	// The 'scroll' parameter given to many of these indicated whether
	// the new cursor position should be scrolled into view after
	// modifying the selection.
	
	// If shift is held or the extend flag is set, extends a range to
	// include a given position (and optionally a second position).
	// Otherwise, simply returns the range between the given positions.
	// Used for cursor motion and such.
	function extendRange(doc, range, head, other) {
	  if (doc.cm && doc.cm.display.shift || doc.extend) {
	    var anchor = range.anchor
	    if (other) {
	      var posBefore = cmp(head, anchor) < 0
	      if (posBefore != (cmp(other, anchor) < 0)) {
	        anchor = head
	        head = other
	      } else if (posBefore != (cmp(head, other) < 0)) {
	        head = other
	      }
	    }
	    return new Range(anchor, head)
	  } else {
	    return new Range(other || head, head)
	  }
	}
	
	// Extend the primary selection range, discard the rest.
	function extendSelection(doc, head, other, options) {
	  setSelection(doc, new Selection([extendRange(doc, doc.sel.primary(), head, other)], 0), options)
	}
	
	// Extend all selections (pos is an array of selections with length
	// equal the number of selections)
	function extendSelections(doc, heads, options) {
	  var out = []
	  for (var i = 0; i < doc.sel.ranges.length; i++)
	    { out[i] = extendRange(doc, doc.sel.ranges[i], heads[i], null) }
	  var newSel = normalizeSelection(out, doc.sel.primIndex)
	  setSelection(doc, newSel, options)
	}
	
	// Updates a single range in the selection.
	function replaceOneSelection(doc, i, range, options) {
	  var ranges = doc.sel.ranges.slice(0)
	  ranges[i] = range
	  setSelection(doc, normalizeSelection(ranges, doc.sel.primIndex), options)
	}
	
	// Reset the selection to a single range.
	function setSimpleSelection(doc, anchor, head, options) {
	  setSelection(doc, simpleSelection(anchor, head), options)
	}
	
	// Give beforeSelectionChange handlers a change to influence a
	// selection update.
	function filterSelectionChange(doc, sel, options) {
	  var obj = {
	    ranges: sel.ranges,
	    update: function(ranges) {
	      var this$1 = this;
	
	      this.ranges = []
	      for (var i = 0; i < ranges.length; i++)
	        { this$1.ranges[i] = new Range(clipPos(doc, ranges[i].anchor),
	                                   clipPos(doc, ranges[i].head)) }
	    },
	    origin: options && options.origin
	  }
	  signal(doc, "beforeSelectionChange", doc, obj)
	  if (doc.cm) { signal(doc.cm, "beforeSelectionChange", doc.cm, obj) }
	  if (obj.ranges != sel.ranges) { return normalizeSelection(obj.ranges, obj.ranges.length - 1) }
	  else { return sel }
	}
	
	function setSelectionReplaceHistory(doc, sel, options) {
	  var done = doc.history.done, last = lst(done)
	  if (last && last.ranges) {
	    done[done.length - 1] = sel
	    setSelectionNoUndo(doc, sel, options)
	  } else {
	    setSelection(doc, sel, options)
	  }
	}
	
	// Set a new selection.
	function setSelection(doc, sel, options) {
	  setSelectionNoUndo(doc, sel, options)
	  addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options)
	}
	
	function setSelectionNoUndo(doc, sel, options) {
	  if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange"))
	    { sel = filterSelectionChange(doc, sel, options) }
	
	  var bias = options && options.bias ||
	    (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1)
	  setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true))
	
	  if (!(options && options.scroll === false) && doc.cm)
	    { ensureCursorVisible(doc.cm) }
	}
	
	function setSelectionInner(doc, sel) {
	  if (sel.equals(doc.sel)) { return }
	
	  doc.sel = sel
	
	  if (doc.cm) {
	    doc.cm.curOp.updateInput = doc.cm.curOp.selectionChanged = true
	    signalCursorActivity(doc.cm)
	  }
	  signalLater(doc, "cursorActivity", doc)
	}
	
	// Verify that the selection does not partially select any atomic
	// marked ranges.
	function reCheckSelection(doc) {
	  setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false), sel_dontScroll)
	}
	
	// Return a selection that does not partially select any atomic
	// ranges.
	function skipAtomicInSelection(doc, sel, bias, mayClear) {
	  var out
	  for (var i = 0; i < sel.ranges.length; i++) {
	    var range = sel.ranges[i]
	    var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i]
	    var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear)
	    var newHead = skipAtomic(doc, range.head, old && old.head, bias, mayClear)
	    if (out || newAnchor != range.anchor || newHead != range.head) {
	      if (!out) { out = sel.ranges.slice(0, i) }
	      out[i] = new Range(newAnchor, newHead)
	    }
	  }
	  return out ? normalizeSelection(out, sel.primIndex) : sel
	}
	
	function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
	  var line = getLine(doc, pos.line)
	  if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
	    var sp = line.markedSpans[i], m = sp.marker
	    if ((sp.from == null || (m.inclusiveLeft ? sp.from <= pos.ch : sp.from < pos.ch)) &&
	        (sp.to == null || (m.inclusiveRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
	      if (mayClear) {
	        signal(m, "beforeCursorEnter")
	        if (m.explicitlyCleared) {
	          if (!line.markedSpans) { break }
	          else {--i; continue}
	        }
	      }
	      if (!m.atomic) { continue }
	
	      if (oldPos) {
	        var near = m.find(dir < 0 ? 1 : -1), diff = (void 0)
	        if (dir < 0 ? m.inclusiveRight : m.inclusiveLeft)
	          { near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null) }
	        if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0))
	          { return skipAtomicInner(doc, near, pos, dir, mayClear) }
	      }
	
	      var far = m.find(dir < 0 ? -1 : 1)
	      if (dir < 0 ? m.inclusiveLeft : m.inclusiveRight)
	        { far = movePos(doc, far, dir, far.line == pos.line ? line : null) }
	      return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null
	    }
	  } }
	  return pos
	}
	
	// Ensure a given position is not inside an atomic range.
	function skipAtomic(doc, pos, oldPos, bias, mayClear) {
	  var dir = bias || 1
	  var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) ||
	      (!mayClear && skipAtomicInner(doc, pos, oldPos, dir, true)) ||
	      skipAtomicInner(doc, pos, oldPos, -dir, mayClear) ||
	      (!mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true))
	  if (!found) {
	    doc.cantEdit = true
	    return Pos(doc.first, 0)
	  }
	  return found
	}
	
	function movePos(doc, pos, dir, line) {
	  if (dir < 0 && pos.ch == 0) {
	    if (pos.line > doc.first) { return clipPos(doc, Pos(pos.line - 1)) }
	    else { return null }
	  } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
	    if (pos.line < doc.first + doc.size - 1) { return Pos(pos.line + 1, 0) }
	    else { return null }
	  } else {
	    return new Pos(pos.line, pos.ch + dir)
	  }
	}
	
	function selectAll(cm) {
	  cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll)
	}
	
	// UPDATING
	
	// Allow "beforeChange" event handlers to influence a change
	function filterChange(doc, change, update) {
	  var obj = {
	    canceled: false,
	    from: change.from,
	    to: change.to,
	    text: change.text,
	    origin: change.origin,
	    cancel: function () { return obj.canceled = true; }
	  }
	  if (update) { obj.update = function (from, to, text, origin) {
	    if (from) { obj.from = clipPos(doc, from) }
	    if (to) { obj.to = clipPos(doc, to) }
	    if (text) { obj.text = text }
	    if (origin !== undefined) { obj.origin = origin }
	  } }
	  signal(doc, "beforeChange", doc, obj)
	  if (doc.cm) { signal(doc.cm, "beforeChange", doc.cm, obj) }
	
	  if (obj.canceled) { return null }
	  return {from: obj.from, to: obj.to, text: obj.text, origin: obj.origin}
	}
	
	// Apply a change to a document, and add it to the document's
	// history, and propagating it to all linked documents.
	function makeChange(doc, change, ignoreReadOnly) {
	  if (doc.cm) {
	    if (!doc.cm.curOp) { return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly) }
	    if (doc.cm.state.suppressEdits) { return }
	  }
	
	  if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
	    change = filterChange(doc, change, true)
	    if (!change) { return }
	  }
	
	  // Possibly split or suppress the update based on the presence
	  // of read-only spans in its range.
	  var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to)
	  if (split) {
	    for (var i = split.length - 1; i >= 0; --i)
	      { makeChangeInner(doc, {from: split[i].from, to: split[i].to, text: i ? [""] : change.text}) }
	  } else {
	    makeChangeInner(doc, change)
	  }
	}
	
	function makeChangeInner(doc, change) {
	  if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) { return }
	  var selAfter = computeSelAfterChange(doc, change)
	  addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN)
	
	  makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change))
	  var rebased = []
	
	  linkedDocs(doc, function (doc, sharedHist) {
	    if (!sharedHist && indexOf(rebased, doc.history) == -1) {
	      rebaseHist(doc.history, change)
	      rebased.push(doc.history)
	    }
	    makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change))
	  })
	}
	
	// Revert a change stored in a document's history.
	function makeChangeFromHistory(doc, type, allowSelectionOnly) {
	  if (doc.cm && doc.cm.state.suppressEdits && !allowSelectionOnly) { return }
	
	  var hist = doc.history, event, selAfter = doc.sel
	  var source = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done
	
	  // Verify that there is a useable event (so that ctrl-z won't
	  // needlessly clear selection events)
	  var i = 0
	  for (; i < source.length; i++) {
	    event = source[i]
	    if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges)
	      { break }
	  }
	  if (i == source.length) { return }
	  hist.lastOrigin = hist.lastSelOrigin = null
	
	  for (;;) {
	    event = source.pop()
	    if (event.ranges) {
	      pushSelectionToHistory(event, dest)
	      if (allowSelectionOnly && !event.equals(doc.sel)) {
	        setSelection(doc, event, {clearRedo: false})
	        return
	      }
	      selAfter = event
	    }
	    else { break }
	  }
	
	  // Build up a reverse change object to add to the opposite history
	  // stack (redo when undoing, and vice versa).
	  var antiChanges = []
	  pushSelectionToHistory(selAfter, dest)
	  dest.push({changes: antiChanges, generation: hist.generation})
	  hist.generation = event.generation || ++hist.maxGeneration
	
	  var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")
	
	  var loop = function ( i ) {
	    var change = event.changes[i]
	    change.origin = type
	    if (filter && !filterChange(doc, change, false)) {
	      source.length = 0
	      return {}
	    }
	
	    antiChanges.push(historyChangeFromChange(doc, change))
	
	    var after = i ? computeSelAfterChange(doc, change) : lst(source)
	    makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change))
	    if (!i && doc.cm) { doc.cm.scrollIntoView({from: change.from, to: changeEnd(change)}) }
	    var rebased = []
	
	    // Propagate to the linked documents
	    linkedDocs(doc, function (doc, sharedHist) {
	      if (!sharedHist && indexOf(rebased, doc.history) == -1) {
	        rebaseHist(doc.history, change)
	        rebased.push(doc.history)
	      }
	      makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change))
	    })
	  };
	
	  for (var i$1 = event.changes.length - 1; i$1 >= 0; --i$1) {
	    var returned = loop( i$1 );
	
	    if ( returned ) return returned.v;
	  }
	}
	
	// Sub-views need their line numbers shifted when text is added
	// above or below them in the parent document.
	function shiftDoc(doc, distance) {
	  if (distance == 0) { return }
	  doc.first += distance
	  doc.sel = new Selection(map(doc.sel.ranges, function (range) { return new Range(
	    Pos(range.anchor.line + distance, range.anchor.ch),
	    Pos(range.head.line + distance, range.head.ch)
	  ); }), doc.sel.primIndex)
	  if (doc.cm) {
	    regChange(doc.cm, doc.first, doc.first - distance, distance)
	    for (var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++)
	      { regLineChange(doc.cm, l, "gutter") }
	  }
	}
	
	// More lower-level change function, handling only a single document
	// (not linked ones).
	function makeChangeSingleDoc(doc, change, selAfter, spans) {
	  if (doc.cm && !doc.cm.curOp)
	    { return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans) }
	
	  if (change.to.line < doc.first) {
	    shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line))
	    return
	  }
	  if (change.from.line > doc.lastLine()) { return }
	
	  // Clip the change to the size of this doc
	  if (change.from.line < doc.first) {
	    var shift = change.text.length - 1 - (doc.first - change.from.line)
	    shiftDoc(doc, shift)
	    change = {from: Pos(doc.first, 0), to: Pos(change.to.line + shift, change.to.ch),
	              text: [lst(change.text)], origin: change.origin}
	  }
	  var last = doc.lastLine()
	  if (change.to.line > last) {
	    change = {from: change.from, to: Pos(last, getLine(doc, last).text.length),
	              text: [change.text[0]], origin: change.origin}
	  }
	
	  change.removed = getBetween(doc, change.from, change.to)
	
	  if (!selAfter) { selAfter = computeSelAfterChange(doc, change) }
	  if (doc.cm) { makeChangeSingleDocInEditor(doc.cm, change, spans) }
	  else { updateDoc(doc, change, spans) }
	  setSelectionNoUndo(doc, selAfter, sel_dontScroll)
	}
	
	// Handle the interaction of a change to a document with the editor
	// that this document is part of.
	function makeChangeSingleDocInEditor(cm, change, spans) {
	  var doc = cm.doc, display = cm.display, from = change.from, to = change.to
	
	  var recomputeMaxLength = false, checkWidthStart = from.line
	  if (!cm.options.lineWrapping) {
	    checkWidthStart = lineNo(visualLine(getLine(doc, from.line)))
	    doc.iter(checkWidthStart, to.line + 1, function (line) {
	      if (line == display.maxLine) {
	        recomputeMaxLength = true
	        return true
	      }
	    })
	  }
	
	  if (doc.sel.contains(change.from, change.to) > -1)
	    { signalCursorActivity(cm) }
	
	  updateDoc(doc, change, spans, estimateHeight(cm))
	
	  if (!cm.options.lineWrapping) {
	    doc.iter(checkWidthStart, from.line + change.text.length, function (line) {
	      var len = lineLength(line)
	      if (len > display.maxLineLength) {
	        display.maxLine = line
	        display.maxLineLength = len
	        display.maxLineChanged = true
	        recomputeMaxLength = false
	      }
	    })
	    if (recomputeMaxLength) { cm.curOp.updateMaxLine = true }
	  }
	
	  // Adjust frontier, schedule worker
	  doc.frontier = Math.min(doc.frontier, from.line)
	  startWorker(cm, 400)
	
	  var lendiff = change.text.length - (to.line - from.line) - 1
	  // Remember that these lines changed, for updating the display
	  if (change.full)
	    { regChange(cm) }
	  else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change))
	    { regLineChange(cm, from.line, "text") }
	  else
	    { regChange(cm, from.line, to.line + 1, lendiff) }
	
	  var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change")
	  if (changeHandler || changesHandler) {
	    var obj = {
	      from: from, to: to,
	      text: change.text,
	      removed: change.removed,
	      origin: change.origin
	    }
	    if (changeHandler) { signalLater(cm, "change", cm, obj) }
	    if (changesHandler) { (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj) }
	  }
	  cm.display.selForContextMenu = null
	}
	
	function replaceRange(doc, code, from, to, origin) {
	  if (!to) { to = from }
	  if (cmp(to, from) < 0) { var tmp = to; to = from; from = tmp }
	  if (typeof code == "string") { code = doc.splitLines(code) }
	  makeChange(doc, {from: from, to: to, text: code, origin: origin})
	}
	
	// Rebasing/resetting history to deal with externally-sourced changes
	
	function rebaseHistSelSingle(pos, from, to, diff) {
	  if (to < pos.line) {
	    pos.line += diff
	  } else if (from < pos.line) {
	    pos.line = from
	    pos.ch = 0
	  }
	}
	
	// Tries to rebase an array of history events given a change in the
	// document. If the change touches the same lines as the event, the
	// event, and everything 'behind' it, is discarded. If the change is
	// before the event, the event's positions are updated. Uses a
	// copy-on-write scheme for the positions, to avoid having to
	// reallocate them all on every rebase, but also avoid problems with
	// shared position objects being unsafely updated.
	function rebaseHistArray(array, from, to, diff) {
	  for (var i = 0; i < array.length; ++i) {
	    var sub = array[i], ok = true
	    if (sub.ranges) {
	      if (!sub.copied) { sub = array[i] = sub.deepCopy(); sub.copied = true }
	      for (var j = 0; j < sub.ranges.length; j++) {
	        rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff)
	        rebaseHistSelSingle(sub.ranges[j].head, from, to, diff)
	      }
	      continue
	    }
	    for (var j$1 = 0; j$1 < sub.changes.length; ++j$1) {
	      var cur = sub.changes[j$1]
	      if (to < cur.from.line) {
	        cur.from = Pos(cur.from.line + diff, cur.from.ch)
	        cur.to = Pos(cur.to.line + diff, cur.to.ch)
	      } else if (from <= cur.to.line) {
	        ok = false
	        break
	      }
	    }
	    if (!ok) {
	      array.splice(0, i + 1)
	      i = 0
	    }
	  }
	}
	
	function rebaseHist(hist, change) {
	  var from = change.from.line, to = change.to.line, diff = change.text.length - (to - from) - 1
	  rebaseHistArray(hist.done, from, to, diff)
	  rebaseHistArray(hist.undone, from, to, diff)
	}
	
	// Utility for applying a change to a line by handle or number,
	// returning the number and optionally registering the line as
	// changed.
	function changeLine(doc, handle, changeType, op) {
	  var no = handle, line = handle
	  if (typeof handle == "number") { line = getLine(doc, clipLine(doc, handle)) }
	  else { no = lineNo(handle) }
	  if (no == null) { return null }
	  if (op(line, no) && doc.cm) { regLineChange(doc.cm, no, changeType) }
	  return line
	}
	
	// The document is represented as a BTree consisting of leaves, with
	// chunk of lines in them, and branches, with up to ten leaves or
	// other branch nodes below them. The top node is always a branch
	// node, and is the document object itself (meaning it has
	// additional methods and properties).
	//
	// All nodes have parent links. The tree is used both to go from
	// line numbers to line objects, and to go from objects to numbers.
	// It also indexes by height, and is used to convert between height
	// and line object, and to find the total height of the document.
	//
	// See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html
	
	function LeafChunk(lines) {
	  var this$1 = this;
	
	  this.lines = lines
	  this.parent = null
	  var height = 0
	  for (var i = 0; i < lines.length; ++i) {
	    lines[i].parent = this$1
	    height += lines[i].height
	  }
	  this.height = height
	}
	
	LeafChunk.prototype = {
	  chunkSize: function() { return this.lines.length },
	  // Remove the n lines at offset 'at'.
	  removeInner: function(at, n) {
	    var this$1 = this;
	
	    for (var i = at, e = at + n; i < e; ++i) {
	      var line = this$1.lines[i]
	      this$1.height -= line.height
	      cleanUpLine(line)
	      signalLater(line, "delete")
	    }
	    this.lines.splice(at, n)
	  },
	  // Helper used to collapse a small branch into a single leaf.
	  collapse: function(lines) {
	    lines.push.apply(lines, this.lines)
	  },
	  // Insert the given array of lines at offset 'at', count them as
	  // having the given height.
	  insertInner: function(at, lines, height) {
	    var this$1 = this;
	
	    this.height += height
	    this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at))
	    for (var i = 0; i < lines.length; ++i) { lines[i].parent = this$1 }
	  },
	  // Used to iterate over a part of the tree.
	  iterN: function(at, n, op) {
	    var this$1 = this;
	
	    for (var e = at + n; at < e; ++at)
	      { if (op(this$1.lines[at])) { return true } }
	  }
	}
	
	function BranchChunk(children) {
	  var this$1 = this;
	
	  this.children = children
	  var size = 0, height = 0
	  for (var i = 0; i < children.length; ++i) {
	    var ch = children[i]
	    size += ch.chunkSize(); height += ch.height
	    ch.parent = this$1
	  }
	  this.size = size
	  this.height = height
	  this.parent = null
	}
	
	BranchChunk.prototype = {
	  chunkSize: function() { return this.size },
	  removeInner: function(at, n) {
	    var this$1 = this;
	
	    this.size -= n
	    for (var i = 0; i < this.children.length; ++i) {
	      var child = this$1.children[i], sz = child.chunkSize()
	      if (at < sz) {
	        var rm = Math.min(n, sz - at), oldHeight = child.height
	        child.removeInner(at, rm)
	        this$1.height -= oldHeight - child.height
	        if (sz == rm) { this$1.children.splice(i--, 1); child.parent = null }
	        if ((n -= rm) == 0) { break }
	        at = 0
	      } else { at -= sz }
	    }
	    // If the result is smaller than 25 lines, ensure that it is a
	    // single leaf node.
	    if (this.size - n < 25 &&
	        (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
	      var lines = []
	      this.collapse(lines)
	      this.children = [new LeafChunk(lines)]
	      this.children[0].parent = this
	    }
	  },
	  collapse: function(lines) {
	    var this$1 = this;
	
	    for (var i = 0; i < this.children.length; ++i) { this$1.children[i].collapse(lines) }
	  },
	  insertInner: function(at, lines, height) {
	    var this$1 = this;
	
	    this.size += lines.length
	    this.height += height
	    for (var i = 0; i < this.children.length; ++i) {
	      var child = this$1.children[i], sz = child.chunkSize()
	      if (at <= sz) {
	        child.insertInner(at, lines, height)
	        if (child.lines && child.lines.length > 50) {
	          // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
	          // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
	          var remaining = child.lines.length % 25 + 25
	          for (var pos = remaining; pos < child.lines.length;) {
	            var leaf = new LeafChunk(child.lines.slice(pos, pos += 25))
	            child.height -= leaf.height
	            this$1.children.splice(++i, 0, leaf)
	            leaf.parent = this$1
	          }
	          child.lines = child.lines.slice(0, remaining)
	          this$1.maybeSpill()
	        }
	        break
	      }
	      at -= sz
	    }
	  },
	  // When a node has grown, check whether it should be split.
	  maybeSpill: function() {
	    if (this.children.length <= 10) { return }
	    var me = this
	    do {
	      var spilled = me.children.splice(me.children.length - 5, 5)
	      var sibling = new BranchChunk(spilled)
	      if (!me.parent) { // Become the parent node
	        var copy = new BranchChunk(me.children)
	        copy.parent = me
	        me.children = [copy, sibling]
	        me = copy
	     } else {
	        me.size -= sibling.size
	        me.height -= sibling.height
	        var myIndex = indexOf(me.parent.children, me)
	        me.parent.children.splice(myIndex + 1, 0, sibling)
	      }
	      sibling.parent = me.parent
	    } while (me.children.length > 10)
	    me.parent.maybeSpill()
	  },
	  iterN: function(at, n, op) {
	    var this$1 = this;
	
	    for (var i = 0; i < this.children.length; ++i) {
	      var child = this$1.children[i], sz = child.chunkSize()
	      if (at < sz) {
	        var used = Math.min(n, sz - at)
	        if (child.iterN(at, used, op)) { return true }
	        if ((n -= used) == 0) { break }
	        at = 0
	      } else { at -= sz }
	    }
	  }
	}
	
	// Line widgets are block elements displayed above or below a line.
	
	function LineWidget(doc, node, options) {
	  var this$1 = this;
	
	  if (options) { for (var opt in options) { if (options.hasOwnProperty(opt))
	    { this$1[opt] = options[opt] } } }
	  this.doc = doc
	  this.node = node
	}
	eventMixin(LineWidget)
	
	function adjustScrollWhenAboveVisible(cm, line, diff) {
	  if (heightAtLine(line) < ((cm.curOp && cm.curOp.scrollTop) || cm.doc.scrollTop))
	    { addToScrollPos(cm, null, diff) }
	}
	
	LineWidget.prototype.clear = function() {
	  var this$1 = this;
	
	  var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line)
	  if (no == null || !ws) { return }
	  for (var i = 0; i < ws.length; ++i) { if (ws[i] == this$1) { ws.splice(i--, 1) } }
	  if (!ws.length) { line.widgets = null }
	  var height = widgetHeight(this)
	  updateLineHeight(line, Math.max(0, line.height - height))
	  if (cm) { runInOp(cm, function () {
	    adjustScrollWhenAboveVisible(cm, line, -height)
	    regLineChange(cm, no, "widget")
	  }) }
	}
	LineWidget.prototype.changed = function() {
	  var oldH = this.height, cm = this.doc.cm, line = this.line
	  this.height = null
	  var diff = widgetHeight(this) - oldH
	  if (!diff) { return }
	  updateLineHeight(line, line.height + diff)
	  if (cm) { runInOp(cm, function () {
	    cm.curOp.forceUpdate = true
	    adjustScrollWhenAboveVisible(cm, line, diff)
	  }) }
	}
	
	function addLineWidget(doc, handle, node, options) {
	  var widget = new LineWidget(doc, node, options)
	  var cm = doc.cm
	  if (cm && widget.noHScroll) { cm.display.alignWidgets = true }
	  changeLine(doc, handle, "widget", function (line) {
	    var widgets = line.widgets || (line.widgets = [])
	    if (widget.insertAt == null) { widgets.push(widget) }
	    else { widgets.splice(Math.min(widgets.length - 1, Math.max(0, widget.insertAt)), 0, widget) }
	    widget.line = line
	    if (cm && !lineIsHidden(doc, line)) {
	      var aboveVisible = heightAtLine(line) < doc.scrollTop
	      updateLineHeight(line, line.height + widgetHeight(widget))
	      if (aboveVisible) { addToScrollPos(cm, null, widget.height) }
	      cm.curOp.forceUpdate = true
	    }
	    return true
	  })
	  return widget
	}
	
	// TEXTMARKERS
	
	// Created with markText and setBookmark methods. A TextMarker is a
	// handle that can be used to clear or find a marked position in the
	// document. Line objects hold arrays (markedSpans) containing
	// {from, to, marker} object pointing to such marker objects, and
	// indicating that such a marker is present on that line. Multiple
	// lines may point to the same marker when it spans across lines.
	// The spans will have null for their from/to properties when the
	// marker continues beyond the start/end of the line. Markers have
	// links back to the lines they currently touch.
	
	// Collapsed markers have unique ids, in order to be able to order
	// them, which is needed for uniquely determining an outer marker
	// when they overlap (they may nest, but not partially overlap).
	var nextMarkerId = 0
	
	function TextMarker(doc, type) {
	  this.lines = []
	  this.type = type
	  this.doc = doc
	  this.id = ++nextMarkerId
	}
	eventMixin(TextMarker)
	
	// Clear the marker.
	TextMarker.prototype.clear = function() {
	  var this$1 = this;
	
	  if (this.explicitlyCleared) { return }
	  var cm = this.doc.cm, withOp = cm && !cm.curOp
	  if (withOp) { startOperation(cm) }
	  if (hasHandler(this, "clear")) {
	    var found = this.find()
	    if (found) { signalLater(this, "clear", found.from, found.to) }
	  }
	  var min = null, max = null
	  for (var i = 0; i < this.lines.length; ++i) {
	    var line = this$1.lines[i]
	    var span = getMarkedSpanFor(line.markedSpans, this$1)
	    if (cm && !this$1.collapsed) { regLineChange(cm, lineNo(line), "text") }
	    else if (cm) {
	      if (span.to != null) { max = lineNo(line) }
	      if (span.from != null) { min = lineNo(line) }
	    }
	    line.markedSpans = removeMarkedSpan(line.markedSpans, span)
	    if (span.from == null && this$1.collapsed && !lineIsHidden(this$1.doc, line) && cm)
	      { updateLineHeight(line, textHeight(cm.display)) }
	  }
	  if (cm && this.collapsed && !cm.options.lineWrapping) { for (var i$1 = 0; i$1 < this.lines.length; ++i$1) {
	    var visual = visualLine(this$1.lines[i$1]), len = lineLength(visual)
	    if (len > cm.display.maxLineLength) {
	      cm.display.maxLine = visual
	      cm.display.maxLineLength = len
	      cm.display.maxLineChanged = true
	    }
	  } }
	
	  if (min != null && cm && this.collapsed) { regChange(cm, min, max + 1) }
	  this.lines.length = 0
	  this.explicitlyCleared = true
	  if (this.atomic && this.doc.cantEdit) {
	    this.doc.cantEdit = false
	    if (cm) { reCheckSelection(cm.doc) }
	  }
	  if (cm) { signalLater(cm, "markerCleared", cm, this) }
	  if (withOp) { endOperation(cm) }
	  if (this.parent) { this.parent.clear() }
	}
	
	// Find the position of the marker in the document. Returns a {from,
	// to} object by default. Side can be passed to get a specific side
	// -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
	// Pos objects returned contain a line object, rather than a line
	// number (used to prevent looking up the same line twice).
	TextMarker.prototype.find = function(side, lineObj) {
	  var this$1 = this;
	
	  if (side == null && this.type == "bookmark") { side = 1 }
	  var from, to
	  for (var i = 0; i < this.lines.length; ++i) {
	    var line = this$1.lines[i]
	    var span = getMarkedSpanFor(line.markedSpans, this$1)
	    if (span.from != null) {
	      from = Pos(lineObj ? line : lineNo(line), span.from)
	      if (side == -1) { return from }
	    }
	    if (span.to != null) {
	      to = Pos(lineObj ? line : lineNo(line), span.to)
	      if (side == 1) { return to }
	    }
	  }
	  return from && {from: from, to: to}
	}
	
	// Signals that the marker's widget changed, and surrounding layout
	// should be recomputed.
	TextMarker.prototype.changed = function() {
	  var pos = this.find(-1, true), widget = this, cm = this.doc.cm
	  if (!pos || !cm) { return }
	  runInOp(cm, function () {
	    var line = pos.line, lineN = lineNo(pos.line)
	    var view = findViewForLine(cm, lineN)
	    if (view) {
	      clearLineMeasurementCacheFor(view)
	      cm.curOp.selectionChanged = cm.curOp.forceUpdate = true
	    }
	    cm.curOp.updateMaxLine = true
	    if (!lineIsHidden(widget.doc, line) && widget.height != null) {
	      var oldHeight = widget.height
	      widget.height = null
	      var dHeight = widgetHeight(widget) - oldHeight
	      if (dHeight)
	        { updateLineHeight(line, line.height + dHeight) }
	    }
	  })
	}
	
	TextMarker.prototype.attachLine = function(line) {
	  if (!this.lines.length && this.doc.cm) {
	    var op = this.doc.cm.curOp
	    if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1)
	      { (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this) }
	  }
	  this.lines.push(line)
	}
	TextMarker.prototype.detachLine = function(line) {
	  this.lines.splice(indexOf(this.lines, line), 1)
	  if (!this.lines.length && this.doc.cm) {
	    var op = this.doc.cm.curOp
	    ;(op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this)
	  }
	}
	
	// Create a marker, wire it up to the right lines, and
	function markText(doc, from, to, options, type) {
	  // Shared markers (across linked documents) are handled separately
	  // (markTextShared will call out to this again, once per
	  // document).
	  if (options && options.shared) { return markTextShared(doc, from, to, options, type) }
	  // Ensure we are in an operation.
	  if (doc.cm && !doc.cm.curOp) { return operation(doc.cm, markText)(doc, from, to, options, type) }
	
	  var marker = new TextMarker(doc, type), diff = cmp(from, to)
	  if (options) { copyObj(options, marker, false) }
	  // Don't connect empty markers unless clearWhenEmpty is false
	  if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false)
	    { return marker }
	  if (marker.replacedWith) {
	    // Showing up as a widget implies collapsed (widget replaces text)
	    marker.collapsed = true
	    marker.widgetNode = elt("span", [marker.replacedWith], "CodeMirror-widget")
	    marker.widgetNode.setAttribute("role", "presentation") // hide from accessibility tree
	    if (!options.handleMouseEvents) { marker.widgetNode.setAttribute("cm-ignore-events", "true") }
	    if (options.insertLeft) { marker.widgetNode.insertLeft = true }
	  }
	  if (marker.collapsed) {
	    if (conflictingCollapsedRange(doc, from.line, from, to, marker) ||
	        from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker))
	      { throw new Error("Inserting collapsed marker partially overlapping an existing one") }
	    seeCollapsedSpans()
	  }
	
	  if (marker.addToHistory)
	    { addChangeToHistory(doc, {from: from, to: to, origin: "markText"}, doc.sel, NaN) }
	
	  var curLine = from.line, cm = doc.cm, updateMaxLine
	  doc.iter(curLine, to.line + 1, function (line) {
	    if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine)
	      { updateMaxLine = true }
	    if (marker.collapsed && curLine != from.line) { updateLineHeight(line, 0) }
	    addMarkedSpan(line, new MarkedSpan(marker,
	                                       curLine == from.line ? from.ch : null,
	                                       curLine == to.line ? to.ch : null))
	    ++curLine
	  })
	  // lineIsHidden depends on the presence of the spans, so needs a second pass
	  if (marker.collapsed) { doc.iter(from.line, to.line + 1, function (line) {
	    if (lineIsHidden(doc, line)) { updateLineHeight(line, 0) }
	  }) }
	
	  if (marker.clearOnEnter) { on(marker, "beforeCursorEnter", function () { return marker.clear(); }) }
	
	  if (marker.readOnly) {
	    seeReadOnlySpans()
	    if (doc.history.done.length || doc.history.undone.length)
	      { doc.clearHistory() }
	  }
	  if (marker.collapsed) {
	    marker.id = ++nextMarkerId
	    marker.atomic = true
	  }
	  if (cm) {
	    // Sync editor state
	    if (updateMaxLine) { cm.curOp.updateMaxLine = true }
	    if (marker.collapsed)
	      { regChange(cm, from.line, to.line + 1) }
	    else if (marker.className || marker.title || marker.startStyle || marker.endStyle || marker.css)
	      { for (var i = from.line; i <= to.line; i++) { regLineChange(cm, i, "text") } }
	    if (marker.atomic) { reCheckSelection(cm.doc) }
	    signalLater(cm, "markerAdded", cm, marker)
	  }
	  return marker
	}
	
	// SHARED TEXTMARKERS
	
	// A shared marker spans multiple linked documents. It is
	// implemented as a meta-marker-object controlling multiple normal
	// markers.
	function SharedTextMarker(markers, primary) {
	  var this$1 = this;
	
	  this.markers = markers
	  this.primary = primary
	  for (var i = 0; i < markers.length; ++i)
	    { markers[i].parent = this$1 }
	}
	eventMixin(SharedTextMarker)
	
	SharedTextMarker.prototype.clear = function() {
	  var this$1 = this;
	
	  if (this.explicitlyCleared) { return }
	  this.explicitlyCleared = true
	  for (var i = 0; i < this.markers.length; ++i)
	    { this$1.markers[i].clear() }
	  signalLater(this, "clear")
	}
	SharedTextMarker.prototype.find = function(side, lineObj) {
	  return this.primary.find(side, lineObj)
	}
	
	function markTextShared(doc, from, to, options, type) {
	  options = copyObj(options)
	  options.shared = false
	  var markers = [markText(doc, from, to, options, type)], primary = markers[0]
	  var widget = options.widgetNode
	  linkedDocs(doc, function (doc) {
	    if (widget) { options.widgetNode = widget.cloneNode(true) }
	    markers.push(markText(doc, clipPos(doc, from), clipPos(doc, to), options, type))
	    for (var i = 0; i < doc.linked.length; ++i)
	      { if (doc.linked[i].isParent) { return } }
	    primary = lst(markers)
	  })
	  return new SharedTextMarker(markers, primary)
	}
	
	function findSharedMarkers(doc) {
	  return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function (m) { return m.parent; })
	}
	
	function copySharedMarkers(doc, markers) {
	  for (var i = 0; i < markers.length; i++) {
	    var marker = markers[i], pos = marker.find()
	    var mFrom = doc.clipPos(pos.from), mTo = doc.clipPos(pos.to)
	    if (cmp(mFrom, mTo)) {
	      var subMark = markText(doc, mFrom, mTo, marker.primary, marker.primary.type)
	      marker.markers.push(subMark)
	      subMark.parent = marker
	    }
	  }
	}
	
	function detachSharedMarkers(markers) {
	  var loop = function ( i ) {
	    var marker = markers[i], linked = [marker.primary.doc]
	    linkedDocs(marker.primary.doc, function (d) { return linked.push(d); })
	    for (var j = 0; j < marker.markers.length; j++) {
	      var subMarker = marker.markers[j]
	      if (indexOf(linked, subMarker.doc) == -1) {
	        subMarker.parent = null
	        marker.markers.splice(j--, 1)
	      }
	    }
	  };
	
	  for (var i = 0; i < markers.length; i++) loop( i );
	}
	
	var nextDocId = 0
	var Doc = function(text, mode, firstLine, lineSep) {
	  if (!(this instanceof Doc)) { return new Doc(text, mode, firstLine, lineSep) }
	  if (firstLine == null) { firstLine = 0 }
	
	  BranchChunk.call(this, [new LeafChunk([new Line("", null)])])
	  this.first = firstLine
	  this.scrollTop = this.scrollLeft = 0
	  this.cantEdit = false
	  this.cleanGeneration = 1
	  this.frontier = firstLine
	  var start = Pos(firstLine, 0)
	  this.sel = simpleSelection(start)
	  this.history = new History(null)
	  this.id = ++nextDocId
	  this.modeOption = mode
	  this.lineSep = lineSep
	  this.extend = false
	
	  if (typeof text == "string") { text = this.splitLines(text) }
	  updateDoc(this, {from: start, to: start, text: text})
	  setSelection(this, simpleSelection(start), sel_dontScroll)
	}
	
	Doc.prototype = createObj(BranchChunk.prototype, {
	  constructor: Doc,
	  // Iterate over the document. Supports two forms -- with only one
	  // argument, it calls that for each line in the document. With
	  // three, it iterates over the range given by the first two (with
	  // the second being non-inclusive).
	  iter: function(from, to, op) {
	    if (op) { this.iterN(from - this.first, to - from, op) }
	    else { this.iterN(this.first, this.first + this.size, from) }
	  },
	
	  // Non-public interface for adding and removing lines.
	  insert: function(at, lines) {
	    var height = 0
	    for (var i = 0; i < lines.length; ++i) { height += lines[i].height }
	    this.insertInner(at - this.first, lines, height)
	  },
	  remove: function(at, n) { this.removeInner(at - this.first, n) },
	
	  // From here, the methods are part of the public interface. Most
	  // are also available from CodeMirror (editor) instances.
	
	  getValue: function(lineSep) {
	    var lines = getLines(this, this.first, this.first + this.size)
	    if (lineSep === false) { return lines }
	    return lines.join(lineSep || this.lineSeparator())
	  },
	  setValue: docMethodOp(function(code) {
	    var top = Pos(this.first, 0), last = this.first + this.size - 1
	    makeChange(this, {from: top, to: Pos(last, getLine(this, last).text.length),
	                      text: this.splitLines(code), origin: "setValue", full: true}, true)
	    setSelection(this, simpleSelection(top))
	  }),
	  replaceRange: function(code, from, to, origin) {
	    from = clipPos(this, from)
	    to = to ? clipPos(this, to) : from
	    replaceRange(this, code, from, to, origin)
	  },
	  getRange: function(from, to, lineSep) {
	    var lines = getBetween(this, clipPos(this, from), clipPos(this, to))
	    if (lineSep === false) { return lines }
	    return lines.join(lineSep || this.lineSeparator())
	  },
	
	  getLine: function(line) {var l = this.getLineHandle(line); return l && l.text},
	
	  getLineHandle: function(line) {if (isLine(this, line)) { return getLine(this, line) }},
	  getLineNumber: function(line) {return lineNo(line)},
	
	  getLineHandleVisualStart: function(line) {
	    if (typeof line == "number") { line = getLine(this, line) }
	    return visualLine(line)
	  },
	
	  lineCount: function() {return this.size},
	  firstLine: function() {return this.first},
	  lastLine: function() {return this.first + this.size - 1},
	
	  clipPos: function(pos) {return clipPos(this, pos)},
	
	  getCursor: function(start) {
	    var range = this.sel.primary(), pos
	    if (start == null || start == "head") { pos = range.head }
	    else if (start == "anchor") { pos = range.anchor }
	    else if (start == "end" || start == "to" || start === false) { pos = range.to() }
	    else { pos = range.from() }
	    return pos
	  },
	  listSelections: function() { return this.sel.ranges },
	  somethingSelected: function() {return this.sel.somethingSelected()},
	
	  setCursor: docMethodOp(function(line, ch, options) {
	    setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options)
	  }),
	  setSelection: docMethodOp(function(anchor, head, options) {
	    setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options)
	  }),
	  extendSelection: docMethodOp(function(head, other, options) {
	    extendSelection(this, clipPos(this, head), other && clipPos(this, other), options)
	  }),
	  extendSelections: docMethodOp(function(heads, options) {
	    extendSelections(this, clipPosArray(this, heads), options)
	  }),
	  extendSelectionsBy: docMethodOp(function(f, options) {
	    var heads = map(this.sel.ranges, f)
	    extendSelections(this, clipPosArray(this, heads), options)
	  }),
	  setSelections: docMethodOp(function(ranges, primary, options) {
	    var this$1 = this;
	
	    if (!ranges.length) { return }
	    var out = []
	    for (var i = 0; i < ranges.length; i++)
	      { out[i] = new Range(clipPos(this$1, ranges[i].anchor),
	                         clipPos(this$1, ranges[i].head)) }
	    if (primary == null) { primary = Math.min(ranges.length - 1, this.sel.primIndex) }
	    setSelection(this, normalizeSelection(out, primary), options)
	  }),
	  addSelection: docMethodOp(function(anchor, head, options) {
	    var ranges = this.sel.ranges.slice(0)
	    ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)))
	    setSelection(this, normalizeSelection(ranges, ranges.length - 1), options)
	  }),
	
	  getSelection: function(lineSep) {
	    var this$1 = this;
	
	    var ranges = this.sel.ranges, lines
	    for (var i = 0; i < ranges.length; i++) {
	      var sel = getBetween(this$1, ranges[i].from(), ranges[i].to())
	      lines = lines ? lines.concat(sel) : sel
	    }
	    if (lineSep === false) { return lines }
	    else { return lines.join(lineSep || this.lineSeparator()) }
	  },
	  getSelections: function(lineSep) {
	    var this$1 = this;
	
	    var parts = [], ranges = this.sel.ranges
	    for (var i = 0; i < ranges.length; i++) {
	      var sel = getBetween(this$1, ranges[i].from(), ranges[i].to())
	      if (lineSep !== false) { sel = sel.join(lineSep || this$1.lineSeparator()) }
	      parts[i] = sel
	    }
	    return parts
	  },
	  replaceSelection: function(code, collapse, origin) {
	    var dup = []
	    for (var i = 0; i < this.sel.ranges.length; i++)
	      { dup[i] = code }
	    this.replaceSelections(dup, collapse, origin || "+input")
	  },
	  replaceSelections: docMethodOp(function(code, collapse, origin) {
	    var this$1 = this;
	
	    var changes = [], sel = this.sel
	    for (var i = 0; i < sel.ranges.length; i++) {
	      var range = sel.ranges[i]
	      changes[i] = {from: range.from(), to: range.to(), text: this$1.splitLines(code[i]), origin: origin}
	    }
	    var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse)
	    for (var i$1 = changes.length - 1; i$1 >= 0; i$1--)
	      { makeChange(this$1, changes[i$1]) }
	    if (newSel) { setSelectionReplaceHistory(this, newSel) }
	    else if (this.cm) { ensureCursorVisible(this.cm) }
	  }),
	  undo: docMethodOp(function() {makeChangeFromHistory(this, "undo")}),
	  redo: docMethodOp(function() {makeChangeFromHistory(this, "redo")}),
	  undoSelection: docMethodOp(function() {makeChangeFromHistory(this, "undo", true)}),
	  redoSelection: docMethodOp(function() {makeChangeFromHistory(this, "redo", true)}),
	
	  setExtending: function(val) {this.extend = val},
	  getExtending: function() {return this.extend},
	
	  historySize: function() {
	    var hist = this.history, done = 0, undone = 0
	    for (var i = 0; i < hist.done.length; i++) { if (!hist.done[i].ranges) { ++done } }
	    for (var i$1 = 0; i$1 < hist.undone.length; i$1++) { if (!hist.undone[i$1].ranges) { ++undone } }
	    return {undo: done, redo: undone}
	  },
	  clearHistory: function() {this.history = new History(this.history.maxGeneration)},
	
	  markClean: function() {
	    this.cleanGeneration = this.changeGeneration(true)
	  },
	  changeGeneration: function(forceSplit) {
	    if (forceSplit)
	      { this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null }
	    return this.history.generation
	  },
	  isClean: function (gen) {
	    return this.history.generation == (gen || this.cleanGeneration)
	  },
	
	  getHistory: function() {
	    return {done: copyHistoryArray(this.history.done),
	            undone: copyHistoryArray(this.history.undone)}
	  },
	  setHistory: function(histData) {
	    var hist = this.history = new History(this.history.maxGeneration)
	    hist.done = copyHistoryArray(histData.done.slice(0), null, true)
	    hist.undone = copyHistoryArray(histData.undone.slice(0), null, true)
	  },
	
	  setGutterMarker: docMethodOp(function(line, gutterID, value) {
	    return changeLine(this, line, "gutter", function (line) {
	      var markers = line.gutterMarkers || (line.gutterMarkers = {})
	      markers[gutterID] = value
	      if (!value && isEmpty(markers)) { line.gutterMarkers = null }
	      return true
	    })
	  }),
	
	  clearGutter: docMethodOp(function(gutterID) {
	    var this$1 = this;
	
	    this.iter(function (line) {
	      if (line.gutterMarkers && line.gutterMarkers[gutterID]) {
	        changeLine(this$1, line, "gutter", function () {
	          line.gutterMarkers[gutterID] = null
	          if (isEmpty(line.gutterMarkers)) { line.gutterMarkers = null }
	          return true
	        })
	      }
	    })
	  }),
	
	  lineInfo: function(line) {
	    var n
	    if (typeof line == "number") {
	      if (!isLine(this, line)) { return null }
	      n = line
	      line = getLine(this, line)
	      if (!line) { return null }
	    } else {
	      n = lineNo(line)
	      if (n == null) { return null }
	    }
	    return {line: n, handle: line, text: line.text, gutterMarkers: line.gutterMarkers,
	            textClass: line.textClass, bgClass: line.bgClass, wrapClass: line.wrapClass,
	            widgets: line.widgets}
	  },
	
	  addLineClass: docMethodOp(function(handle, where, cls) {
	    return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
	      var prop = where == "text" ? "textClass"
	               : where == "background" ? "bgClass"
	               : where == "gutter" ? "gutterClass" : "wrapClass"
	      if (!line[prop]) { line[prop] = cls }
	      else if (classTest(cls).test(line[prop])) { return false }
	      else { line[prop] += " " + cls }
	      return true
	    })
	  }),
	  removeLineClass: docMethodOp(function(handle, where, cls) {
	    return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
	      var prop = where == "text" ? "textClass"
	               : where == "background" ? "bgClass"
	               : where == "gutter" ? "gutterClass" : "wrapClass"
	      var cur = line[prop]
	      if (!cur) { return false }
	      else if (cls == null) { line[prop] = null }
	      else {
	        var found = cur.match(classTest(cls))
	        if (!found) { return false }
	        var end = found.index + found[0].length
	        line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null
	      }
	      return true
	    })
	  }),
	
	  addLineWidget: docMethodOp(function(handle, node, options) {
	    return addLineWidget(this, handle, node, options)
	  }),
	  removeLineWidget: function(widget) { widget.clear() },
	
	  markText: function(from, to, options) {
	    return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range")
	  },
	  setBookmark: function(pos, options) {
	    var realOpts = {replacedWith: options && (options.nodeType == null ? options.widget : options),
	                    insertLeft: options && options.insertLeft,
	                    clearWhenEmpty: false, shared: options && options.shared,
	                    handleMouseEvents: options && options.handleMouseEvents}
	    pos = clipPos(this, pos)
	    return markText(this, pos, pos, realOpts, "bookmark")
	  },
	  findMarksAt: function(pos) {
	    pos = clipPos(this, pos)
	    var markers = [], spans = getLine(this, pos.line).markedSpans
	    if (spans) { for (var i = 0; i < spans.length; ++i) {
	      var span = spans[i]
	      if ((span.from == null || span.from <= pos.ch) &&
	          (span.to == null || span.to >= pos.ch))
	        { markers.push(span.marker.parent || span.marker) }
	    } }
	    return markers
	  },
	  findMarks: function(from, to, filter) {
	    from = clipPos(this, from); to = clipPos(this, to)
	    var found = [], lineNo = from.line
	    this.iter(from.line, to.line + 1, function (line) {
	      var spans = line.markedSpans
	      if (spans) { for (var i = 0; i < spans.length; i++) {
	        var span = spans[i]
	        if (!(span.to != null && lineNo == from.line && from.ch >= span.to ||
	              span.from == null && lineNo != from.line ||
	              span.from != null && lineNo == to.line && span.from >= to.ch) &&
	            (!filter || filter(span.marker)))
	          { found.push(span.marker.parent || span.marker) }
	      } }
	      ++lineNo
	    })
	    return found
	  },
	  getAllMarks: function() {
	    var markers = []
	    this.iter(function (line) {
	      var sps = line.markedSpans
	      if (sps) { for (var i = 0; i < sps.length; ++i)
	        { if (sps[i].from != null) { markers.push(sps[i].marker) } } }
	    })
	    return markers
	  },
	
	  posFromIndex: function(off) {
	    var ch, lineNo = this.first, sepSize = this.lineSeparator().length
	    this.iter(function (line) {
	      var sz = line.text.length + sepSize
	      if (sz > off) { ch = off; return true }
	      off -= sz
	      ++lineNo
	    })
	    return clipPos(this, Pos(lineNo, ch))
	  },
	  indexFromPos: function (coords) {
	    coords = clipPos(this, coords)
	    var index = coords.ch
	    if (coords.line < this.first || coords.ch < 0) { return 0 }
	    var sepSize = this.lineSeparator().length
	    this.iter(this.first, coords.line, function (line) { // iter aborts when callback returns a truthy value
	      index += line.text.length + sepSize
	    })
	    return index
	  },
	
	  copy: function(copyHistory) {
	    var doc = new Doc(getLines(this, this.first, this.first + this.size),
	                      this.modeOption, this.first, this.lineSep)
	    doc.scrollTop = this.scrollTop; doc.scrollLeft = this.scrollLeft
	    doc.sel = this.sel
	    doc.extend = false
	    if (copyHistory) {
	      doc.history.undoDepth = this.history.undoDepth
	      doc.setHistory(this.getHistory())
	    }
	    return doc
	  },
	
	  linkedDoc: function(options) {
	    if (!options) { options = {} }
	    var from = this.first, to = this.first + this.size
	    if (options.from != null && options.from > from) { from = options.from }
	    if (options.to != null && options.to < to) { to = options.to }
	    var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep)
	    if (options.sharedHist) { copy.history = this.history
	    ; }(this.linked || (this.linked = [])).push({doc: copy, sharedHist: options.sharedHist})
	    copy.linked = [{doc: this, isParent: true, sharedHist: options.sharedHist}]
	    copySharedMarkers(copy, findSharedMarkers(this))
	    return copy
	  },
	  unlinkDoc: function(other) {
	    var this$1 = this;
	
	    if (other instanceof CodeMirror) { other = other.doc }
	    if (this.linked) { for (var i = 0; i < this.linked.length; ++i) {
	      var link = this$1.linked[i]
	      if (link.doc != other) { continue }
	      this$1.linked.splice(i, 1)
	      other.unlinkDoc(this$1)
	      detachSharedMarkers(findSharedMarkers(this$1))
	      break
	    } }
	    // If the histories were shared, split them again
	    if (other.history == this.history) {
	      var splitIds = [other.id]
	      linkedDocs(other, function (doc) { return splitIds.push(doc.id); }, true)
	      other.history = new History(null)
	      other.history.done = copyHistoryArray(this.history.done, splitIds)
	      other.history.undone = copyHistoryArray(this.history.undone, splitIds)
	    }
	  },
	  iterLinkedDocs: function(f) {linkedDocs(this, f)},
	
	  getMode: function() {return this.mode},
	  getEditor: function() {return this.cm},
	
	  splitLines: function(str) {
	    if (this.lineSep) { return str.split(this.lineSep) }
	    return splitLinesAuto(str)
	  },
	  lineSeparator: function() { return this.lineSep || "\n" }
	})
	
	// Public alias.
	Doc.prototype.eachLine = Doc.prototype.iter
	
	// Kludge to work around strange IE behavior where it'll sometimes
	// re-fire a series of drag-related events right after the drop (#1551)
	var lastDrop = 0
	
	function onDrop(e) {
	  var cm = this
	  clearDragCursor(cm)
	  if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e))
	    { return }
	  e_preventDefault(e)
	  if (ie) { lastDrop = +new Date }
	  var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files
	  if (!pos || cm.isReadOnly()) { return }
	  // Might be a file drop, in which case we simply extract the text
	  // and insert it.
	  if (files && files.length && window.FileReader && window.File) {
	    var n = files.length, text = Array(n), read = 0
	    var loadFile = function (file, i) {
	      if (cm.options.allowDropFileTypes &&
	          indexOf(cm.options.allowDropFileTypes, file.type) == -1)
	        { return }
	
	      var reader = new FileReader
	      reader.onload = operation(cm, function () {
	        var content = reader.result
	        if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) { content = "" }
	        text[i] = content
	        if (++read == n) {
	          pos = clipPos(cm.doc, pos)
	          var change = {from: pos, to: pos,
	                        text: cm.doc.splitLines(text.join(cm.doc.lineSeparator())),
	                        origin: "paste"}
	          makeChange(cm.doc, change)
	          setSelectionReplaceHistory(cm.doc, simpleSelection(pos, changeEnd(change)))
	        }
	      })
	      reader.readAsText(file)
	    }
	    for (var i = 0; i < n; ++i) { loadFile(files[i], i) }
	  } else { // Normal drop
	    // Don't do a replace if the drop happened inside of the selected text.
	    if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
	      cm.state.draggingText(e)
	      // Ensure the editor is re-focused
	      setTimeout(function () { return cm.display.input.focus(); }, 20)
	      return
	    }
	    try {
	      var text$1 = e.dataTransfer.getData("Text")
	      if (text$1) {
	        var selected
	        if (cm.state.draggingText && !cm.state.draggingText.copy)
	          { selected = cm.listSelections() }
	        setSelectionNoUndo(cm.doc, simpleSelection(pos, pos))
	        if (selected) { for (var i$1 = 0; i$1 < selected.length; ++i$1)
	          { replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag") } }
	        cm.replaceSelection(text$1, "around", "paste")
	        cm.display.input.focus()
	      }
	    }
	    catch(e){}
	  }
	}
	
	function onDragStart(cm, e) {
	  if (ie && (!cm.state.draggingText || +new Date - lastDrop < 100)) { e_stop(e); return }
	  if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) { return }
	
	  e.dataTransfer.setData("Text", cm.getSelection())
	  e.dataTransfer.effectAllowed = "copyMove"
	
	  // Use dummy image instead of default browsers image.
	  // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
	  if (e.dataTransfer.setDragImage && !safari) {
	    var img = elt("img", null, null, "position: fixed; left: 0; top: 0;")
	    img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
	    if (presto) {
	      img.width = img.height = 1
	      cm.display.wrapper.appendChild(img)
	      // Force a relayout, or Opera won't use our image for some obscure reason
	      img._top = img.offsetTop
	    }
	    e.dataTransfer.setDragImage(img, 0, 0)
	    if (presto) { img.parentNode.removeChild(img) }
	  }
	}
	
	function onDragOver(cm, e) {
	  var pos = posFromMouse(cm, e)
	  if (!pos) { return }
	  var frag = document.createDocumentFragment()
	  drawSelectionCursor(cm, pos, frag)
	  if (!cm.display.dragCursor) {
	    cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors")
	    cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv)
	  }
	  removeChildrenAndAdd(cm.display.dragCursor, frag)
	}
	
	function clearDragCursor(cm) {
	  if (cm.display.dragCursor) {
	    cm.display.lineSpace.removeChild(cm.display.dragCursor)
	    cm.display.dragCursor = null
	  }
	}
	
	// These must be handled carefully, because naively registering a
	// handler for each editor will cause the editors to never be
	// garbage collected.
	
	function forEachCodeMirror(f) {
	  if (!document.body.getElementsByClassName) { return }
	  var byClass = document.body.getElementsByClassName("CodeMirror")
	  for (var i = 0; i < byClass.length; i++) {
	    var cm = byClass[i].CodeMirror
	    if (cm) { f(cm) }
	  }
	}
	
	var globalsRegistered = false
	function ensureGlobalHandlers() {
	  if (globalsRegistered) { return }
	  registerGlobalHandlers()
	  globalsRegistered = true
	}
	function registerGlobalHandlers() {
	  // When the window resizes, we need to refresh active editors.
	  var resizeTimer
	  on(window, "resize", function () {
	    if (resizeTimer == null) { resizeTimer = setTimeout(function () {
	      resizeTimer = null
	      forEachCodeMirror(onResize)
	    }, 100) }
	  })
	  // When the window loses focus, we want to show the editor as blurred
	  on(window, "blur", function () { return forEachCodeMirror(onBlur); })
	}
	// Called when the window resizes
	function onResize(cm) {
	  var d = cm.display
	  if (d.lastWrapHeight == d.wrapper.clientHeight && d.lastWrapWidth == d.wrapper.clientWidth)
	    { return }
	  // Might be a text scaling operation, clear size caches.
	  d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null
	  d.scrollbarsClipped = false
	  cm.setSize()
	}
	
	var keyNames = {
	  3: "Enter", 8: "Backspace", 9: "Tab", 13: "Enter", 16: "Shift", 17: "Ctrl", 18: "Alt",
	  19: "Pause", 20: "CapsLock", 27: "Esc", 32: "Space", 33: "PageUp", 34: "PageDown", 35: "End",
	  36: "Home", 37: "Left", 38: "Up", 39: "Right", 40: "Down", 44: "PrintScrn", 45: "Insert",
	  46: "Delete", 59: ";", 61: "=", 91: "Mod", 92: "Mod", 93: "Mod",
	  106: "*", 107: "=", 109: "-", 110: ".", 111: "/", 127: "Delete",
	  173: "-", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\",
	  221: "]", 222: "'", 63232: "Up", 63233: "Down", 63234: "Left", 63235: "Right", 63272: "Delete",
	  63273: "Home", 63275: "End", 63276: "PageUp", 63277: "PageDown", 63302: "Insert"
	}
	
	// Number keys
	for (var i = 0; i < 10; i++) { keyNames[i + 48] = keyNames[i + 96] = String(i) }
	// Alphabetic keys
	for (var i$1 = 65; i$1 <= 90; i$1++) { keyNames[i$1] = String.fromCharCode(i$1) }
	// Function keys
	for (var i$2 = 1; i$2 <= 12; i$2++) { keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2 }
	
	var keyMap = {}
	
	keyMap.basic = {
	  "Left": "goCharLeft", "Right": "goCharRight", "Up": "goLineUp", "Down": "goLineDown",
	  "End": "goLineEnd", "Home": "goLineStartSmart", "PageUp": "goPageUp", "PageDown": "goPageDown",
	  "Delete": "delCharAfter", "Backspace": "delCharBefore", "Shift-Backspace": "delCharBefore",
	  "Tab": "defaultTab", "Shift-Tab": "indentAuto",
	  "Enter": "newlineAndIndent", "Insert": "toggleOverwrite",
	  "Esc": "singleSelection"
	}
	// Note that the save and find-related commands aren't defined by
	// default. User code or addons can define them. Unknown commands
	// are simply ignored.
	keyMap.pcDefault = {
	  "Ctrl-A": "selectAll", "Ctrl-D": "deleteLine", "Ctrl-Z": "undo", "Shift-Ctrl-Z": "redo", "Ctrl-Y": "redo",
	  "Ctrl-Home": "goDocStart", "Ctrl-End": "goDocEnd", "Ctrl-Up": "goLineUp", "Ctrl-Down": "goLineDown",
	  "Ctrl-Left": "goGroupLeft", "Ctrl-Right": "goGroupRight", "Alt-Left": "goLineStart", "Alt-Right": "goLineEnd",
	  "Ctrl-Backspace": "delGroupBefore", "Ctrl-Delete": "delGroupAfter", "Ctrl-S": "save", "Ctrl-F": "find",
	  "Ctrl-G": "findNext", "Shift-Ctrl-G": "findPrev", "Shift-Ctrl-F": "replace", "Shift-Ctrl-R": "replaceAll",
	  "Ctrl-[": "indentLess", "Ctrl-]": "indentMore",
	  "Ctrl-U": "undoSelection", "Shift-Ctrl-U": "redoSelection", "Alt-U": "redoSelection",
	  fallthrough: "basic"
	}
	// Very basic readline/emacs-style bindings, which are standard on Mac.
	keyMap.emacsy = {
	  "Ctrl-F": "goCharRight", "Ctrl-B": "goCharLeft", "Ctrl-P": "goLineUp", "Ctrl-N": "goLineDown",
	  "Alt-F": "goWordRight", "Alt-B": "goWordLeft", "Ctrl-A": "goLineStart", "Ctrl-E": "goLineEnd",
	  "Ctrl-V": "goPageDown", "Shift-Ctrl-V": "goPageUp", "Ctrl-D": "delCharAfter", "Ctrl-H": "delCharBefore",
	  "Alt-D": "delWordAfter", "Alt-Backspace": "delWordBefore", "Ctrl-K": "killLine", "Ctrl-T": "transposeChars",
	  "Ctrl-O": "openLine"
	}
	keyMap.macDefault = {
	  "Cmd-A": "selectAll", "Cmd-D": "deleteLine", "Cmd-Z": "undo", "Shift-Cmd-Z": "redo", "Cmd-Y": "redo",
	  "Cmd-Home": "goDocStart", "Cmd-Up": "goDocStart", "Cmd-End": "goDocEnd", "Cmd-Down": "goDocEnd", "Alt-Left": "goGroupLeft",
	  "Alt-Right": "goGroupRight", "Cmd-Left": "goLineLeft", "Cmd-Right": "goLineRight", "Alt-Backspace": "delGroupBefore",
	  "Ctrl-Alt-Backspace": "delGroupAfter", "Alt-Delete": "delGroupAfter", "Cmd-S": "save", "Cmd-F": "find",
	  "Cmd-G": "findNext", "Shift-Cmd-G": "findPrev", "Cmd-Alt-F": "replace", "Shift-Cmd-Alt-F": "replaceAll",
	  "Cmd-[": "indentLess", "Cmd-]": "indentMore", "Cmd-Backspace": "delWrappedLineLeft", "Cmd-Delete": "delWrappedLineRight",
	  "Cmd-U": "undoSelection", "Shift-Cmd-U": "redoSelection", "Ctrl-Up": "goDocStart", "Ctrl-Down": "goDocEnd",
	  fallthrough: ["basic", "emacsy"]
	}
	keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault
	
	// KEYMAP DISPATCH
	
	function normalizeKeyName(name) {
	  var parts = name.split(/-(?!$)/)
	  name = parts[parts.length - 1]
	  var alt, ctrl, shift, cmd
	  for (var i = 0; i < parts.length - 1; i++) {
	    var mod = parts[i]
	    if (/^(cmd|meta|m)$/i.test(mod)) { cmd = true }
	    else if (/^a(lt)?$/i.test(mod)) { alt = true }
	    else if (/^(c|ctrl|control)$/i.test(mod)) { ctrl = true }
	    else if (/^s(hift)?$/i.test(mod)) { shift = true }
	    else { throw new Error("Unrecognized modifier name: " + mod) }
	  }
	  if (alt) { name = "Alt-" + name }
	  if (ctrl) { name = "Ctrl-" + name }
	  if (cmd) { name = "Cmd-" + name }
	  if (shift) { name = "Shift-" + name }
	  return name
	}
	
	// This is a kludge to keep keymaps mostly working as raw objects
	// (backwards compatibility) while at the same time support features
	// like normalization and multi-stroke key bindings. It compiles a
	// new normalized keymap, and then updates the old object to reflect
	// this.
	function normalizeKeyMap(keymap) {
	  var copy = {}
	  for (var keyname in keymap) { if (keymap.hasOwnProperty(keyname)) {
	    var value = keymap[keyname]
	    if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) { continue }
	    if (value == "...") { delete keymap[keyname]; continue }
	
	    var keys = map(keyname.split(" "), normalizeKeyName)
	    for (var i = 0; i < keys.length; i++) {
	      var val = (void 0), name = (void 0)
	      if (i == keys.length - 1) {
	        name = keys.join(" ")
	        val = value
	      } else {
	        name = keys.slice(0, i + 1).join(" ")
	        val = "..."
	      }
	      var prev = copy[name]
	      if (!prev) { copy[name] = val }
	      else if (prev != val) { throw new Error("Inconsistent bindings for " + name) }
	    }
	    delete keymap[keyname]
	  } }
	  for (var prop in copy) { keymap[prop] = copy[prop] }
	  return keymap
	}
	
	function lookupKey(key, map, handle, context) {
	  map = getKeyMap(map)
	  var found = map.call ? map.call(key, context) : map[key]
	  if (found === false) { return "nothing" }
	  if (found === "...") { return "multi" }
	  if (found != null && handle(found)) { return "handled" }
	
	  if (map.fallthrough) {
	    if (Object.prototype.toString.call(map.fallthrough) != "[object Array]")
	      { return lookupKey(key, map.fallthrough, handle, context) }
	    for (var i = 0; i < map.fallthrough.length; i++) {
	      var result = lookupKey(key, map.fallthrough[i], handle, context)
	      if (result) { return result }
	    }
	  }
	}
	
	// Modifier key presses don't count as 'real' key presses for the
	// purpose of keymap fallthrough.
	function isModifierKey(value) {
	  var name = typeof value == "string" ? value : keyNames[value.keyCode]
	  return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod"
	}
	
	// Look up the name of a key as indicated by an event object.
	function keyName(event, noShift) {
	  if (presto && event.keyCode == 34 && event["char"]) { return false }
	  var base = keyNames[event.keyCode], name = base
	  if (name == null || event.altGraphKey) { return false }
	  if (event.altKey && base != "Alt") { name = "Alt-" + name }
	  if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") { name = "Ctrl-" + name }
	  if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Cmd") { name = "Cmd-" + name }
	  if (!noShift && event.shiftKey && base != "Shift") { name = "Shift-" + name }
	  return name
	}
	
	function getKeyMap(val) {
	  return typeof val == "string" ? keyMap[val] : val
	}
	
	// Helper for deleting text near the selection(s), used to implement
	// backspace, delete, and similar functionality.
	function deleteNearSelection(cm, compute) {
	  var ranges = cm.doc.sel.ranges, kill = []
	  // Build up a set of ranges to kill first, merging overlapping
	  // ranges.
	  for (var i = 0; i < ranges.length; i++) {
	    var toKill = compute(ranges[i])
	    while (kill.length && cmp(toKill.from, lst(kill).to) <= 0) {
	      var replaced = kill.pop()
	      if (cmp(replaced.from, toKill.from) < 0) {
	        toKill.from = replaced.from
	        break
	      }
	    }
	    kill.push(toKill)
	  }
	  // Next, remove those actual ranges.
	  runInOp(cm, function () {
	    for (var i = kill.length - 1; i >= 0; i--)
	      { replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete") }
	    ensureCursorVisible(cm)
	  })
	}
	
	// Commands are parameter-less actions that can be performed on an
	// editor, mostly used for keybindings.
	var commands = {
	  selectAll: selectAll,
	  singleSelection: function (cm) { return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll); },
	  killLine: function (cm) { return deleteNearSelection(cm, function (range) {
	    if (range.empty()) {
	      var len = getLine(cm.doc, range.head.line).text.length
	      if (range.head.ch == len && range.head.line < cm.lastLine())
	        { return {from: range.head, to: Pos(range.head.line + 1, 0)} }
	      else
	        { return {from: range.head, to: Pos(range.head.line, len)} }
	    } else {
	      return {from: range.from(), to: range.to()}
	    }
	  }); },
	  deleteLine: function (cm) { return deleteNearSelection(cm, function (range) { return ({
	    from: Pos(range.from().line, 0),
	    to: clipPos(cm.doc, Pos(range.to().line + 1, 0))
	  }); }); },
	  delLineLeft: function (cm) { return deleteNearSelection(cm, function (range) { return ({
	    from: Pos(range.from().line, 0), to: range.from()
	  }); }); },
	  delWrappedLineLeft: function (cm) { return deleteNearSelection(cm, function (range) {
	    var top = cm.charCoords(range.head, "div").top + 5
	    var leftPos = cm.coordsChar({left: 0, top: top}, "div")
	    return {from: leftPos, to: range.from()}
	  }); },
	  delWrappedLineRight: function (cm) { return deleteNearSelection(cm, function (range) {
	    var top = cm.charCoords(range.head, "div").top + 5
	    var rightPos = cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div")
	    return {from: range.from(), to: rightPos }
	  }); },
	  undo: function (cm) { return cm.undo(); },
	  redo: function (cm) { return cm.redo(); },
	  undoSelection: function (cm) { return cm.undoSelection(); },
	  redoSelection: function (cm) { return cm.redoSelection(); },
	  goDocStart: function (cm) { return cm.extendSelection(Pos(cm.firstLine(), 0)); },
	  goDocEnd: function (cm) { return cm.extendSelection(Pos(cm.lastLine())); },
	  goLineStart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStart(cm, range.head.line); },
	    {origin: "+move", bias: 1}
	  ); },
	  goLineStartSmart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStartSmart(cm, range.head); },
	    {origin: "+move", bias: 1}
	  ); },
	  goLineEnd: function (cm) { return cm.extendSelectionsBy(function (range) { return lineEnd(cm, range.head.line); },
	    {origin: "+move", bias: -1}
	  ); },
	  goLineRight: function (cm) { return cm.extendSelectionsBy(function (range) {
	    var top = cm.charCoords(range.head, "div").top + 5
	    return cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div")
	  }, sel_move); },
	  goLineLeft: function (cm) { return cm.extendSelectionsBy(function (range) {
	    var top = cm.charCoords(range.head, "div").top + 5
	    return cm.coordsChar({left: 0, top: top}, "div")
	  }, sel_move); },
	  goLineLeftSmart: function (cm) { return cm.extendSelectionsBy(function (range) {
	    var top = cm.charCoords(range.head, "div").top + 5
	    var pos = cm.coordsChar({left: 0, top: top}, "div")
	    if (pos.ch < cm.getLine(pos.line).search(/\S/)) { return lineStartSmart(cm, range.head) }
	    return pos
	  }, sel_move); },
	  goLineUp: function (cm) { return cm.moveV(-1, "line"); },
	  goLineDown: function (cm) { return cm.moveV(1, "line"); },
	  goPageUp: function (cm) { return cm.moveV(-1, "page"); },
	  goPageDown: function (cm) { return cm.moveV(1, "page"); },
	  goCharLeft: function (cm) { return cm.moveH(-1, "char"); },
	  goCharRight: function (cm) { return cm.moveH(1, "char"); },
	  goColumnLeft: function (cm) { return cm.moveH(-1, "column"); },
	  goColumnRight: function (cm) { return cm.moveH(1, "column"); },
	  goWordLeft: function (cm) { return cm.moveH(-1, "word"); },
	  goGroupRight: function (cm) { return cm.moveH(1, "group"); },
	  goGroupLeft: function (cm) { return cm.moveH(-1, "group"); },
	  goWordRight: function (cm) { return cm.moveH(1, "word"); },
	  delCharBefore: function (cm) { return cm.deleteH(-1, "char"); },
	  delCharAfter: function (cm) { return cm.deleteH(1, "char"); },
	  delWordBefore: function (cm) { return cm.deleteH(-1, "word"); },
	  delWordAfter: function (cm) { return cm.deleteH(1, "word"); },
	  delGroupBefore: function (cm) { return cm.deleteH(-1, "group"); },
	  delGroupAfter: function (cm) { return cm.deleteH(1, "group"); },
	  indentAuto: function (cm) { return cm.indentSelection("smart"); },
	  indentMore: function (cm) { return cm.indentSelection("add"); },
	  indentLess: function (cm) { return cm.indentSelection("subtract"); },
	  insertTab: function (cm) { return cm.replaceSelection("\t"); },
	  insertSoftTab: function (cm) {
	    var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize
	    for (var i = 0; i < ranges.length; i++) {
	      var pos = ranges[i].from()
	      var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize)
	      spaces.push(spaceStr(tabSize - col % tabSize))
	    }
	    cm.replaceSelections(spaces)
	  },
	  defaultTab: function (cm) {
	    if (cm.somethingSelected()) { cm.indentSelection("add") }
	    else { cm.execCommand("insertTab") }
	  },
	  // Swap the two chars left and right of each selection's head.
	  // Move cursor behind the two swapped characters afterwards.
	  //
	  // Doesn't consider line feeds a character.
	  // Doesn't scan more than one line above to find a character.
	  // Doesn't do anything on an empty line.
	  // Doesn't do anything with non-empty selections.
	  transposeChars: function (cm) { return runInOp(cm, function () {
	    var ranges = cm.listSelections(), newSel = []
	    for (var i = 0; i < ranges.length; i++) {
	      if (!ranges[i].empty()) { continue }
	      var cur = ranges[i].head, line = getLine(cm.doc, cur.line).text
	      if (line) {
	        if (cur.ch == line.length) { cur = new Pos(cur.line, cur.ch - 1) }
	        if (cur.ch > 0) {
	          cur = new Pos(cur.line, cur.ch + 1)
	          cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2),
	                          Pos(cur.line, cur.ch - 2), cur, "+transpose")
	        } else if (cur.line > cm.doc.first) {
	          var prev = getLine(cm.doc, cur.line - 1).text
	          if (prev) {
	            cur = new Pos(cur.line, 1)
	            cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() +
	                            prev.charAt(prev.length - 1),
	                            Pos(cur.line - 1, prev.length - 1), cur, "+transpose")
	          }
	        }
	      }
	      newSel.push(new Range(cur, cur))
	    }
	    cm.setSelections(newSel)
	  }); },
	  newlineAndIndent: function (cm) { return runInOp(cm, function () {
	    var sels = cm.listSelections()
	    for (var i = sels.length - 1; i >= 0; i--)
	      { cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input") }
	    sels = cm.listSelections()
	    for (var i$1 = 0; i$1 < sels.length; i$1++)
	      { cm.indentLine(sels[i$1].from().line, null, true) }
	    ensureCursorVisible(cm)
	  }); },
	  openLine: function (cm) { return cm.replaceSelection("\n", "start"); },
	  toggleOverwrite: function (cm) { return cm.toggleOverwrite(); }
	}
	
	
	function lineStart(cm, lineN) {
	  var line = getLine(cm.doc, lineN)
	  var visual = visualLine(line)
	  if (visual != line) { lineN = lineNo(visual) }
	  var order = getOrder(visual)
	  var ch = !order ? 0 : order[0].level % 2 ? lineRight(visual) : lineLeft(visual)
	  return Pos(lineN, ch)
	}
	function lineEnd(cm, lineN) {
	  var merged, line = getLine(cm.doc, lineN)
	  while (merged = collapsedSpanAtEnd(line)) {
	    line = merged.find(1, true).line
	    lineN = null
	  }
	  var order = getOrder(line)
	  var ch = !order ? line.text.length : order[0].level % 2 ? lineLeft(line) : lineRight(line)
	  return Pos(lineN == null ? lineNo(line) : lineN, ch)
	}
	function lineStartSmart(cm, pos) {
	  var start = lineStart(cm, pos.line)
	  var line = getLine(cm.doc, start.line)
	  var order = getOrder(line)
	  if (!order || order[0].level == 0) {
	    var firstNonWS = Math.max(0, line.text.search(/\S/))
	    var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch
	    return Pos(start.line, inWS ? 0 : firstNonWS)
	  }
	  return start
	}
	
	// Run a handler that was bound to a key.
	function doHandleBinding(cm, bound, dropShift) {
	  if (typeof bound == "string") {
	    bound = commands[bound]
	    if (!bound) { return false }
	  }
	  // Ensure previous input has been read, so that the handler sees a
	  // consistent view of the document
	  cm.display.input.ensurePolled()
	  var prevShift = cm.display.shift, done = false
	  try {
	    if (cm.isReadOnly()) { cm.state.suppressEdits = true }
	    if (dropShift) { cm.display.shift = false }
	    done = bound(cm) != Pass
	  } finally {
	    cm.display.shift = prevShift
	    cm.state.suppressEdits = false
	  }
	  return done
	}
	
	function lookupKeyForEditor(cm, name, handle) {
	  for (var i = 0; i < cm.state.keyMaps.length; i++) {
	    var result = lookupKey(name, cm.state.keyMaps[i], handle, cm)
	    if (result) { return result }
	  }
	  return (cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm))
	    || lookupKey(name, cm.options.keyMap, handle, cm)
	}
	
	var stopSeq = new Delayed
	function dispatchKey(cm, name, e, handle) {
	  var seq = cm.state.keySeq
	  if (seq) {
	    if (isModifierKey(name)) { return "handled" }
	    stopSeq.set(50, function () {
	      if (cm.state.keySeq == seq) {
	        cm.state.keySeq = null
	        cm.display.input.reset()
	      }
	    })
	    name = seq + " " + name
	  }
	  var result = lookupKeyForEditor(cm, name, handle)
	
	  if (result == "multi")
	    { cm.state.keySeq = name }
	  if (result == "handled")
	    { signalLater(cm, "keyHandled", cm, name, e) }
	
	  if (result == "handled" || result == "multi") {
	    e_preventDefault(e)
	    restartBlink(cm)
	  }
	
	  if (seq && !result && /\'$/.test(name)) {
	    e_preventDefault(e)
	    return true
	  }
	  return !!result
	}
	
	// Handle a key from the keydown event.
	function handleKeyBinding(cm, e) {
	  var name = keyName(e, true)
	  if (!name) { return false }
	
	  if (e.shiftKey && !cm.state.keySeq) {
	    // First try to resolve full name (including 'Shift-'). Failing
	    // that, see if there is a cursor-motion command (starting with
	    // 'go') bound to the keyname without 'Shift-'.
	    return dispatchKey(cm, "Shift-" + name, e, function (b) { return doHandleBinding(cm, b, true); })
	        || dispatchKey(cm, name, e, function (b) {
	             if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion)
	               { return doHandleBinding(cm, b) }
	           })
	  } else {
	    return dispatchKey(cm, name, e, function (b) { return doHandleBinding(cm, b); })
	  }
	}
	
	// Handle a key from the keypress event
	function handleCharBinding(cm, e, ch) {
	  return dispatchKey(cm, "'" + ch + "'", e, function (b) { return doHandleBinding(cm, b, true); })
	}
	
	var lastStoppedKey = null
	function onKeyDown(e) {
	  var cm = this
	  cm.curOp.focus = activeElt()
	  if (signalDOMEvent(cm, e)) { return }
	  // IE does strange things with escape.
	  if (ie && ie_version < 11 && e.keyCode == 27) { e.returnValue = false }
	  var code = e.keyCode
	  cm.display.shift = code == 16 || e.shiftKey
	  var handled = handleKeyBinding(cm, e)
	  if (presto) {
	    lastStoppedKey = handled ? code : null
	    // Opera has no cut event... we try to at least catch the key combo
	    if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey))
	      { cm.replaceSelection("", null, "cut") }
	  }
	
	  // Turn mouse into crosshair when Alt is held on Mac.
	  if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className))
	    { showCrossHair(cm) }
	}
	
	function showCrossHair(cm) {
	  var lineDiv = cm.display.lineDiv
	  addClass(lineDiv, "CodeMirror-crosshair")
	
	  function up(e) {
	    if (e.keyCode == 18 || !e.altKey) {
	      rmClass(lineDiv, "CodeMirror-crosshair")
	      off(document, "keyup", up)
	      off(document, "mouseover", up)
	    }
	  }
	  on(document, "keyup", up)
	  on(document, "mouseover", up)
	}
	
	function onKeyUp(e) {
	  if (e.keyCode == 16) { this.doc.sel.shift = false }
	  signalDOMEvent(this, e)
	}
	
	function onKeyPress(e) {
	  var cm = this
	  if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) { return }
	  var keyCode = e.keyCode, charCode = e.charCode
	  if (presto && keyCode == lastStoppedKey) {lastStoppedKey = null; e_preventDefault(e); return}
	  if ((presto && (!e.which || e.which < 10)) && handleKeyBinding(cm, e)) { return }
	  var ch = String.fromCharCode(charCode == null ? keyCode : charCode)
	  // Some browsers fire keypress events for backspace
	  if (ch == "\x08") { return }
	  if (handleCharBinding(cm, e, ch)) { return }
	  cm.display.input.onKeyPress(e)
	}
	
	// A mouse down can be a single click, double click, triple click,
	// start of selection drag, start of text drag, new cursor
	// (ctrl-click), rectangle drag (alt-drag), or xwin
	// middle-click-paste. Or it might be a click on something we should
	// not interfere with, such as a scrollbar or widget.
	function onMouseDown(e) {
	  var cm = this, display = cm.display
	  if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) { return }
	  display.input.ensurePolled()
	  display.shift = e.shiftKey
	
	  if (eventInWidget(display, e)) {
	    if (!webkit) {
	      // Briefly turn off draggability, to allow widgets to do
	      // normal dragging things.
	      display.scroller.draggable = false
	      setTimeout(function () { return display.scroller.draggable = true; }, 100)
	    }
	    return
	  }
	  if (clickInGutter(cm, e)) { return }
	  var start = posFromMouse(cm, e)
	  window.focus()
	
	  switch (e_button(e)) {
	  case 1:
	    // #3261: make sure, that we're not starting a second selection
	    if (cm.state.selectingText)
	      { cm.state.selectingText(e) }
	    else if (start)
	      { leftButtonDown(cm, e, start) }
	    else if (e_target(e) == display.scroller)
	      { e_preventDefault(e) }
	    break
	  case 2:
	    if (webkit) { cm.state.lastMiddleDown = +new Date }
	    if (start) { extendSelection(cm.doc, start) }
	    setTimeout(function () { return display.input.focus(); }, 20)
	    e_preventDefault(e)
	    break
	  case 3:
	    if (captureRightClick) { onContextMenu(cm, e) }
	    else { delayBlurEvent(cm) }
	    break
	  }
	}
	
	var lastClick;
	var lastDoubleClick;
	function leftButtonDown(cm, e, start) {
	  if (ie) { setTimeout(bind(ensureFocus, cm), 0) }
	  else { cm.curOp.focus = activeElt() }
	
	  var now = +new Date, type
	  if (lastDoubleClick && lastDoubleClick.time > now - 400 && cmp(lastDoubleClick.pos, start) == 0) {
	    type = "triple"
	  } else if (lastClick && lastClick.time > now - 400 && cmp(lastClick.pos, start) == 0) {
	    type = "double"
	    lastDoubleClick = {time: now, pos: start}
	  } else {
	    type = "single"
	    lastClick = {time: now, pos: start}
	  }
	
	  var sel = cm.doc.sel, modifier = mac ? e.metaKey : e.ctrlKey, contained
	  if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() &&
	      type == "single" && (contained = sel.contains(start)) > -1 &&
	      (cmp((contained = sel.ranges[contained]).from(), start) < 0 || start.xRel > 0) &&
	      (cmp(contained.to(), start) > 0 || start.xRel < 0))
	    { leftButtonStartDrag(cm, e, start, modifier) }
	  else
	    { leftButtonSelect(cm, e, start, type, modifier) }
	}
	
	// Start a text drag. When it ends, see if any dragging actually
	// happen, and treat as a click if it didn't.
	function leftButtonStartDrag(cm, e, start, modifier) {
	  var display = cm.display, startTime = +new Date
	  var dragEnd = operation(cm, function (e2) {
	    if (webkit) { display.scroller.draggable = false }
	    cm.state.draggingText = false
	    off(document, "mouseup", dragEnd)
	    off(display.scroller, "drop", dragEnd)
	    if (Math.abs(e.clientX - e2.clientX) + Math.abs(e.clientY - e2.clientY) < 10) {
	      e_preventDefault(e2)
	      if (!modifier && +new Date - 200 < startTime)
	        { extendSelection(cm.doc, start) }
	      // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
	      if (webkit || ie && ie_version == 9)
	        { setTimeout(function () {document.body.focus(); display.input.focus()}, 20) }
	      else
	        { display.input.focus() }
	    }
	  })
	  // Let the drag handler handle this.
	  if (webkit) { display.scroller.draggable = true }
	  cm.state.draggingText = dragEnd
	  dragEnd.copy = mac ? e.altKey : e.ctrlKey
	  // IE's approach to draggable
	  if (display.scroller.dragDrop) { display.scroller.dragDrop() }
	  on(document, "mouseup", dragEnd)
	  on(display.scroller, "drop", dragEnd)
	}
	
	// Normal selection, as opposed to text dragging.
	function leftButtonSelect(cm, e, start, type, addNew) {
	  var display = cm.display, doc = cm.doc
	  e_preventDefault(e)
	
	  var ourRange, ourIndex, startSel = doc.sel, ranges = startSel.ranges
	  if (addNew && !e.shiftKey) {
	    ourIndex = doc.sel.contains(start)
	    if (ourIndex > -1)
	      { ourRange = ranges[ourIndex] }
	    else
	      { ourRange = new Range(start, start) }
	  } else {
	    ourRange = doc.sel.primary()
	    ourIndex = doc.sel.primIndex
	  }
	
	  if (chromeOS ? e.shiftKey && e.metaKey : e.altKey) {
	    type = "rect"
	    if (!addNew) { ourRange = new Range(start, start) }
	    start = posFromMouse(cm, e, true, true)
	    ourIndex = -1
	  } else if (type == "double") {
	    var word = cm.findWordAt(start)
	    if (cm.display.shift || doc.extend)
	      { ourRange = extendRange(doc, ourRange, word.anchor, word.head) }
	    else
	      { ourRange = word }
	  } else if (type == "triple") {
	    var line = new Range(Pos(start.line, 0), clipPos(doc, Pos(start.line + 1, 0)))
	    if (cm.display.shift || doc.extend)
	      { ourRange = extendRange(doc, ourRange, line.anchor, line.head) }
	    else
	      { ourRange = line }
	  } else {
	    ourRange = extendRange(doc, ourRange, start)
	  }
	
	  if (!addNew) {
	    ourIndex = 0
	    setSelection(doc, new Selection([ourRange], 0), sel_mouse)
	    startSel = doc.sel
	  } else if (ourIndex == -1) {
	    ourIndex = ranges.length
	    setSelection(doc, normalizeSelection(ranges.concat([ourRange]), ourIndex),
	                 {scroll: false, origin: "*mouse"})
	  } else if (ranges.length > 1 && ranges[ourIndex].empty() && type == "single" && !e.shiftKey) {
	    setSelection(doc, normalizeSelection(ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0),
	                 {scroll: false, origin: "*mouse"})
	    startSel = doc.sel
	  } else {
	    replaceOneSelection(doc, ourIndex, ourRange, sel_mouse)
	  }
	
	  var lastPos = start
	  function extendTo(pos) {
	    if (cmp(lastPos, pos) == 0) { return }
	    lastPos = pos
	
	    if (type == "rect") {
	      var ranges = [], tabSize = cm.options.tabSize
	      var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize)
	      var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize)
	      var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol)
	      for (var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line));
	           line <= end; line++) {
	        var text = getLine(doc, line).text, leftPos = findColumn(text, left, tabSize)
	        if (left == right)
	          { ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos))) }
	        else if (text.length > leftPos)
	          { ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize)))) }
	      }
	      if (!ranges.length) { ranges.push(new Range(start, start)) }
	      setSelection(doc, normalizeSelection(startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex),
	                   {origin: "*mouse", scroll: false})
	      cm.scrollIntoView(pos)
	    } else {
	      var oldRange = ourRange
	      var anchor = oldRange.anchor, head = pos
	      if (type != "single") {
	        var range
	        if (type == "double")
	          { range = cm.findWordAt(pos) }
	        else
	          { range = new Range(Pos(pos.line, 0), clipPos(doc, Pos(pos.line + 1, 0))) }
	        if (cmp(range.anchor, anchor) > 0) {
	          head = range.head
	          anchor = minPos(oldRange.from(), range.anchor)
	        } else {
	          head = range.anchor
	          anchor = maxPos(oldRange.to(), range.head)
	        }
	      }
	      var ranges$1 = startSel.ranges.slice(0)
	      ranges$1[ourIndex] = new Range(clipPos(doc, anchor), head)
	      setSelection(doc, normalizeSelection(ranges$1, ourIndex), sel_mouse)
	    }
	  }
	
	  var editorSize = display.wrapper.getBoundingClientRect()
	  // Used to ensure timeout re-tries don't fire when another extend
	  // happened in the meantime (clearTimeout isn't reliable -- at
	  // least on Chrome, the timeouts still happen even when cleared,
	  // if the clear happens after their scheduled firing time).
	  var counter = 0
	
	  function extend(e) {
	    var curCount = ++counter
	    var cur = posFromMouse(cm, e, true, type == "rect")
	    if (!cur) { return }
	    if (cmp(cur, lastPos) != 0) {
	      cm.curOp.focus = activeElt()
	      extendTo(cur)
	      var visible = visibleLines(display, doc)
	      if (cur.line >= visible.to || cur.line < visible.from)
	        { setTimeout(operation(cm, function () {if (counter == curCount) { extend(e) }}), 150) }
	    } else {
	      var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0
	      if (outside) { setTimeout(operation(cm, function () {
	        if (counter != curCount) { return }
	        display.scroller.scrollTop += outside
	        extend(e)
	      }), 50) }
	    }
	  }
	
	  function done(e) {
	    cm.state.selectingText = false
	    counter = Infinity
	    e_preventDefault(e)
	    display.input.focus()
	    off(document, "mousemove", move)
	    off(document, "mouseup", up)
	    doc.history.lastSelOrigin = null
	  }
	
	  var move = operation(cm, function (e) {
	    if (!e_button(e)) { done(e) }
	    else { extend(e) }
	  })
	  var up = operation(cm, done)
	  cm.state.selectingText = up
	  on(document, "mousemove", move)
	  on(document, "mouseup", up)
	}
	
	
	// Determines whether an event happened in the gutter, and fires the
	// handlers for the corresponding event.
	function gutterEvent(cm, e, type, prevent) {
	  var mX, mY
	  try { mX = e.clientX; mY = e.clientY }
	  catch(e) { return false }
	  if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) { return false }
	  if (prevent) { e_preventDefault(e) }
	
	  var display = cm.display
	  var lineBox = display.lineDiv.getBoundingClientRect()
	
	  if (mY > lineBox.bottom || !hasHandler(cm, type)) { return e_defaultPrevented(e) }
	  mY -= lineBox.top - display.viewOffset
	
	  for (var i = 0; i < cm.options.gutters.length; ++i) {
	    var g = display.gutters.childNodes[i]
	    if (g && g.getBoundingClientRect().right >= mX) {
	      var line = lineAtHeight(cm.doc, mY)
	      var gutter = cm.options.gutters[i]
	      signal(cm, type, cm, line, gutter, e)
	      return e_defaultPrevented(e)
	    }
	  }
	}
	
	function clickInGutter(cm, e) {
	  return gutterEvent(cm, e, "gutterClick", true)
	}
	
	// CONTEXT MENU HANDLING
	
	// To make the context menu work, we need to briefly unhide the
	// textarea (making it as unobtrusive as possible) to let the
	// right-click take effect on it.
	function onContextMenu(cm, e) {
	  if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) { return }
	  if (signalDOMEvent(cm, e, "contextmenu")) { return }
	  cm.display.input.onContextMenu(e)
	}
	
	function contextMenuInGutter(cm, e) {
	  if (!hasHandler(cm, "gutterContextMenu")) { return false }
	  return gutterEvent(cm, e, "gutterContextMenu", false)
	}
	
	function themeChanged(cm) {
	  cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") +
	    cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-")
	  clearCaches(cm)
	}
	
	var Init = {toString: function(){return "CodeMirror.Init"}}
	
	var defaults = {}
	var optionHandlers = {}
	
	function defineOptions(CodeMirror) {
	  var optionHandlers = CodeMirror.optionHandlers
	
	  function option(name, deflt, handle, notOnInit) {
	    CodeMirror.defaults[name] = deflt
	    if (handle) { optionHandlers[name] =
	      notOnInit ? function (cm, val, old) {if (old != Init) { handle(cm, val, old) }} : handle }
	  }
	
	  CodeMirror.defineOption = option
	
	  // Passed to option handlers when there is no old value.
	  CodeMirror.Init = Init
	
	  // These two are, on init, called from the constructor because they
	  // have to be initialized before the editor can start at all.
	  option("value", "", function (cm, val) { return cm.setValue(val); }, true)
	  option("mode", null, function (cm, val) {
	    cm.doc.modeOption = val
	    loadMode(cm)
	  }, true)
	
	  option("indentUnit", 2, loadMode, true)
	  option("indentWithTabs", false)
	  option("smartIndent", true)
	  option("tabSize", 4, function (cm) {
	    resetModeState(cm)
	    clearCaches(cm)
	    regChange(cm)
	  }, true)
	  option("lineSeparator", null, function (cm, val) {
	    cm.doc.lineSep = val
	    if (!val) { return }
	    var newBreaks = [], lineNo = cm.doc.first
	    cm.doc.iter(function (line) {
	      for (var pos = 0;;) {
	        var found = line.text.indexOf(val, pos)
	        if (found == -1) { break }
	        pos = found + val.length
	        newBreaks.push(Pos(lineNo, found))
	      }
	      lineNo++
	    })
	    for (var i = newBreaks.length - 1; i >= 0; i--)
	      { replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length)) }
	  })
	  option("specialChars", /[\u0000-\u001f\u007f\u00ad\u061c\u200b-\u200f\u2028\u2029\ufeff]/g, function (cm, val, old) {
	    cm.state.specialChars = new RegExp(val.source + (val.test("\t") ? "" : "|\t"), "g")
	    if (old != Init) { cm.refresh() }
	  })
	  option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function (cm) { return cm.refresh(); }, true)
	  option("electricChars", true)
	  option("inputStyle", mobile ? "contenteditable" : "textarea", function () {
	    throw new Error("inputStyle can not (yet) be changed in a running editor") // FIXME
	  }, true)
	  option("spellcheck", false, function (cm, val) { return cm.getInputField().spellcheck = val; }, true)
	  option("rtlMoveVisually", !windows)
	  option("wholeLineUpdateBefore", true)
	
	  option("theme", "default", function (cm) {
	    themeChanged(cm)
	    guttersChanged(cm)
	  }, true)
	  option("keyMap", "default", function (cm, val, old) {
	    var next = getKeyMap(val)
	    var prev = old != Init && getKeyMap(old)
	    if (prev && prev.detach) { prev.detach(cm, next) }
	    if (next.attach) { next.attach(cm, prev || null) }
	  })
	  option("extraKeys", null)
	
	  option("lineWrapping", false, wrappingChanged, true)
	  option("gutters", [], function (cm) {
	    setGuttersForLineNumbers(cm.options)
	    guttersChanged(cm)
	  }, true)
	  option("fixedGutter", true, function (cm, val) {
	    cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0"
	    cm.refresh()
	  }, true)
	  option("coverGutterNextToScrollbar", false, function (cm) { return updateScrollbars(cm); }, true)
	  option("scrollbarStyle", "native", function (cm) {
	    initScrollbars(cm)
	    updateScrollbars(cm)
	    cm.display.scrollbars.setScrollTop(cm.doc.scrollTop)
	    cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft)
	  }, true)
	  option("lineNumbers", false, function (cm) {
	    setGuttersForLineNumbers(cm.options)
	    guttersChanged(cm)
	  }, true)
	  option("firstLineNumber", 1, guttersChanged, true)
	  option("lineNumberFormatter", function (integer) { return integer; }, guttersChanged, true)
	  option("showCursorWhenSelecting", false, updateSelection, true)
	
	  option("resetSelectionOnContextMenu", true)
	  option("lineWiseCopyCut", true)
	
	  option("readOnly", false, function (cm, val) {
	    if (val == "nocursor") {
	      onBlur(cm)
	      cm.display.input.blur()
	      cm.display.disabled = true
	    } else {
	      cm.display.disabled = false
	    }
	    cm.display.input.readOnlyChanged(val)
	  })
	  option("disableInput", false, function (cm, val) {if (!val) { cm.display.input.reset() }}, true)
	  option("dragDrop", true, dragDropChanged)
	  option("allowDropFileTypes", null)
	
	  option("cursorBlinkRate", 530)
	  option("cursorScrollMargin", 0)
	  option("cursorHeight", 1, updateSelection, true)
	  option("singleCursorHeightPerLine", true, updateSelection, true)
	  option("workTime", 100)
	  option("workDelay", 100)
	  option("flattenSpans", true, resetModeState, true)
	  option("addModeClass", false, resetModeState, true)
	  option("pollInterval", 100)
	  option("undoDepth", 200, function (cm, val) { return cm.doc.history.undoDepth = val; })
	  option("historyEventDelay", 1250)
	  option("viewportMargin", 10, function (cm) { return cm.refresh(); }, true)
	  option("maxHighlightLength", 10000, resetModeState, true)
	  option("moveInputWithCursor", true, function (cm, val) {
	    if (!val) { cm.display.input.resetPosition() }
	  })
	
	  option("tabindex", null, function (cm, val) { return cm.display.input.getField().tabIndex = val || ""; })
	  option("autofocus", null)
	}
	
	function guttersChanged(cm) {
	  updateGutters(cm)
	  regChange(cm)
	  alignHorizontally(cm)
	}
	
	function dragDropChanged(cm, value, old) {
	  var wasOn = old && old != Init
	  if (!value != !wasOn) {
	    var funcs = cm.display.dragFunctions
	    var toggle = value ? on : off
	    toggle(cm.display.scroller, "dragstart", funcs.start)
	    toggle(cm.display.scroller, "dragenter", funcs.enter)
	    toggle(cm.display.scroller, "dragover", funcs.over)
	    toggle(cm.display.scroller, "dragleave", funcs.leave)
	    toggle(cm.display.scroller, "drop", funcs.drop)
	  }
	}
	
	function wrappingChanged(cm) {
	  if (cm.options.lineWrapping) {
	    addClass(cm.display.wrapper, "CodeMirror-wrap")
	    cm.display.sizer.style.minWidth = ""
	    cm.display.sizerWidth = null
	  } else {
	    rmClass(cm.display.wrapper, "CodeMirror-wrap")
	    findMaxLine(cm)
	  }
	  estimateLineHeights(cm)
	  regChange(cm)
	  clearCaches(cm)
	  setTimeout(function () { return updateScrollbars(cm); }, 100)
	}
	
	// A CodeMirror instance represents an editor. This is the object
	// that user code is usually dealing with.
	
	function CodeMirror(place, options) {
	  var this$1 = this;
	
	  if (!(this instanceof CodeMirror)) { return new CodeMirror(place, options) }
	
	  this.options = options = options ? copyObj(options) : {}
	  // Determine effective options based on given values and defaults.
	  copyObj(defaults, options, false)
	  setGuttersForLineNumbers(options)
	
	  var doc = options.value
	  if (typeof doc == "string") { doc = new Doc(doc, options.mode, null, options.lineSeparator) }
	  this.doc = doc
	
	  var input = new CodeMirror.inputStyles[options.inputStyle](this)
	  var display = this.display = new Display(place, doc, input)
	  display.wrapper.CodeMirror = this
	  updateGutters(this)
	  themeChanged(this)
	  if (options.lineWrapping)
	    { this.display.wrapper.className += " CodeMirror-wrap" }
	  initScrollbars(this)
	
	  this.state = {
	    keyMaps: [],  // stores maps added by addKeyMap
	    overlays: [], // highlighting overlays, as added by addOverlay
	    modeGen: 0,   // bumped when mode/overlay changes, used to invalidate highlighting info
	    overwrite: false,
	    delayingBlurEvent: false,
	    focused: false,
	    suppressEdits: false, // used to disable editing during key handlers when in readOnly mode
	    pasteIncoming: false, cutIncoming: false, // help recognize paste/cut edits in input.poll
	    selectingText: false,
	    draggingText: false,
	    highlight: new Delayed(), // stores highlight worker timeout
	    keySeq: null,  // Unfinished key sequence
	    specialChars: null
	  }
	
	  if (options.autofocus && !mobile) { display.input.focus() }
	
	  // Override magic textarea content restore that IE sometimes does
	  // on our hidden textarea on reload
	  if (ie && ie_version < 11) { setTimeout(function () { return this$1.display.input.reset(true); }, 20) }
	
	  registerEventHandlers(this)
	  ensureGlobalHandlers()
	
	  startOperation(this)
	  this.curOp.forceUpdate = true
	  attachDoc(this, doc)
	
	  if ((options.autofocus && !mobile) || this.hasFocus())
	    { setTimeout(bind(onFocus, this), 20) }
	  else
	    { onBlur(this) }
	
	  for (var opt in optionHandlers) { if (optionHandlers.hasOwnProperty(opt))
	    { optionHandlers[opt](this$1, options[opt], Init) } }
	  maybeUpdateLineNumberWidth(this)
	  if (options.finishInit) { options.finishInit(this) }
	  for (var i = 0; i < initHooks.length; ++i) { initHooks[i](this$1) }
	  endOperation(this)
	  // Suppress optimizelegibility in Webkit, since it breaks text
	  // measuring on line wrapping boundaries.
	  if (webkit && options.lineWrapping &&
	      getComputedStyle(display.lineDiv).textRendering == "optimizelegibility")
	    { display.lineDiv.style.textRendering = "auto" }
	}
	
	// The default configuration options.
	CodeMirror.defaults = defaults
	// Functions to run when options are changed.
	CodeMirror.optionHandlers = optionHandlers
	
	// Attach the necessary event handlers when initializing the editor
	function registerEventHandlers(cm) {
	  var d = cm.display
	  on(d.scroller, "mousedown", operation(cm, onMouseDown))
	  // Older IE's will not fire a second mousedown for a double click
	  if (ie && ie_version < 11)
	    { on(d.scroller, "dblclick", operation(cm, function (e) {
	      if (signalDOMEvent(cm, e)) { return }
	      var pos = posFromMouse(cm, e)
	      if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) { return }
	      e_preventDefault(e)
	      var word = cm.findWordAt(pos)
	      extendSelection(cm.doc, word.anchor, word.head)
	    })) }
	  else
	    { on(d.scroller, "dblclick", function (e) { return signalDOMEvent(cm, e) || e_preventDefault(e); }) }
	  // Some browsers fire contextmenu *after* opening the menu, at
	  // which point we can't mess with it anymore. Context menu is
	  // handled in onMouseDown for these browsers.
	  if (!captureRightClick) { on(d.scroller, "contextmenu", function (e) { return onContextMenu(cm, e); }) }
	
	  // Used to suppress mouse event handling when a touch happens
	  var touchFinished, prevTouch = {end: 0}
	  function finishTouch() {
	    if (d.activeTouch) {
	      touchFinished = setTimeout(function () { return d.activeTouch = null; }, 1000)
	      prevTouch = d.activeTouch
	      prevTouch.end = +new Date
	    }
	  }
	  function isMouseLikeTouchEvent(e) {
	    if (e.touches.length != 1) { return false }
	    var touch = e.touches[0]
	    return touch.radiusX <= 1 && touch.radiusY <= 1
	  }
	  function farAway(touch, other) {
	    if (other.left == null) { return true }
	    var dx = other.left - touch.left, dy = other.top - touch.top
	    return dx * dx + dy * dy > 20 * 20
	  }
	  on(d.scroller, "touchstart", function (e) {
	    if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e)) {
	      d.input.ensurePolled()
	      clearTimeout(touchFinished)
	      var now = +new Date
	      d.activeTouch = {start: now, moved: false,
	                       prev: now - prevTouch.end <= 300 ? prevTouch : null}
	      if (e.touches.length == 1) {
	        d.activeTouch.left = e.touches[0].pageX
	        d.activeTouch.top = e.touches[0].pageY
	      }
	    }
	  })
	  on(d.scroller, "touchmove", function () {
	    if (d.activeTouch) { d.activeTouch.moved = true }
	  })
	  on(d.scroller, "touchend", function (e) {
	    var touch = d.activeTouch
	    if (touch && !eventInWidget(d, e) && touch.left != null &&
	        !touch.moved && new Date - touch.start < 300) {
	      var pos = cm.coordsChar(d.activeTouch, "page"), range
	      if (!touch.prev || farAway(touch, touch.prev)) // Single tap
	        { range = new Range(pos, pos) }
	      else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) // Double tap
	        { range = cm.findWordAt(pos) }
	      else // Triple tap
	        { range = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))) }
	      cm.setSelection(range.anchor, range.head)
	      cm.focus()
	      e_preventDefault(e)
	    }
	    finishTouch()
	  })
	  on(d.scroller, "touchcancel", finishTouch)
	
	  // Sync scrolling between fake scrollbars and real scrollable
	  // area, ensure viewport is updated when scrolling.
	  on(d.scroller, "scroll", function () {
	    if (d.scroller.clientHeight) {
	      setScrollTop(cm, d.scroller.scrollTop)
	      setScrollLeft(cm, d.scroller.scrollLeft, true)
	      signal(cm, "scroll", cm)
	    }
	  })
	
	  // Listen to wheel events in order to try and update the viewport on time.
	  on(d.scroller, "mousewheel", function (e) { return onScrollWheel(cm, e); })
	  on(d.scroller, "DOMMouseScroll", function (e) { return onScrollWheel(cm, e); })
	
	  // Prevent wrapper from ever scrolling
	  on(d.wrapper, "scroll", function () { return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0; })
	
	  d.dragFunctions = {
	    enter: function (e) {if (!signalDOMEvent(cm, e)) { e_stop(e) }},
	    over: function (e) {if (!signalDOMEvent(cm, e)) { onDragOver(cm, e); e_stop(e) }},
	    start: function (e) { return onDragStart(cm, e); },
	    drop: operation(cm, onDrop),
	    leave: function (e) {if (!signalDOMEvent(cm, e)) { clearDragCursor(cm) }}
	  }
	
	  var inp = d.input.getField()
	  on(inp, "keyup", function (e) { return onKeyUp.call(cm, e); })
	  on(inp, "keydown", operation(cm, onKeyDown))
	  on(inp, "keypress", operation(cm, onKeyPress))
	  on(inp, "focus", function (e) { return onFocus(cm, e); })
	  on(inp, "blur", function (e) { return onBlur(cm, e); })
	}
	
	var initHooks = []
	CodeMirror.defineInitHook = function (f) { return initHooks.push(f); }
	
	// Indent the given line. The how parameter can be "smart",
	// "add"/null, "subtract", or "prev". When aggressive is false
	// (typically set to true for forced single-line indents), empty
	// lines are not indented, and places where the mode returns Pass
	// are left alone.
	function indentLine(cm, n, how, aggressive) {
	  var doc = cm.doc, state
	  if (how == null) { how = "add" }
	  if (how == "smart") {
	    // Fall back to "prev" when the mode doesn't have an indentation
	    // method.
	    if (!doc.mode.indent) { how = "prev" }
	    else { state = getStateBefore(cm, n) }
	  }
	
	  var tabSize = cm.options.tabSize
	  var line = getLine(doc, n), curSpace = countColumn(line.text, null, tabSize)
	  if (line.stateAfter) { line.stateAfter = null }
	  var curSpaceString = line.text.match(/^\s*/)[0], indentation
	  if (!aggressive && !/\S/.test(line.text)) {
	    indentation = 0
	    how = "not"
	  } else if (how == "smart") {
	    indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text)
	    if (indentation == Pass || indentation > 150) {
	      if (!aggressive) { return }
	      how = "prev"
	    }
	  }
	  if (how == "prev") {
	    if (n > doc.first) { indentation = countColumn(getLine(doc, n-1).text, null, tabSize) }
	    else { indentation = 0 }
	  } else if (how == "add") {
	    indentation = curSpace + cm.options.indentUnit
	  } else if (how == "subtract") {
	    indentation = curSpace - cm.options.indentUnit
	  } else if (typeof how == "number") {
	    indentation = curSpace + how
	  }
	  indentation = Math.max(0, indentation)
	
	  var indentString = "", pos = 0
	  if (cm.options.indentWithTabs)
	    { for (var i = Math.floor(indentation / tabSize); i; --i) {pos += tabSize; indentString += "\t"} }
	  if (pos < indentation) { indentString += spaceStr(indentation - pos) }
	
	  if (indentString != curSpaceString) {
	    replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input")
	    line.stateAfter = null
	    return true
	  } else {
	    // Ensure that, if the cursor was in the whitespace at the start
	    // of the line, it is moved to the end of that space.
	    for (var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++) {
	      var range = doc.sel.ranges[i$1]
	      if (range.head.line == n && range.head.ch < curSpaceString.length) {
	        var pos$1 = Pos(n, curSpaceString.length)
	        replaceOneSelection(doc, i$1, new Range(pos$1, pos$1))
	        break
	      }
	    }
	  }
	}
	
	// This will be set to a {lineWise: bool, text: [string]} object, so
	// that, when pasting, we know what kind of selections the copied
	// text was made out of.
	var lastCopied = null
	
	function setLastCopied(newLastCopied) {
	  lastCopied = newLastCopied
	}
	
	function applyTextInput(cm, inserted, deleted, sel, origin) {
	  var doc = cm.doc
	  cm.display.shift = false
	  if (!sel) { sel = doc.sel }
	
	  var paste = cm.state.pasteIncoming || origin == "paste"
	  var textLines = splitLinesAuto(inserted), multiPaste = null
	  // When pasing N lines into N selections, insert one line per selection
	  if (paste && sel.ranges.length > 1) {
	    if (lastCopied && lastCopied.text.join("\n") == inserted) {
	      if (sel.ranges.length % lastCopied.text.length == 0) {
	        multiPaste = []
	        for (var i = 0; i < lastCopied.text.length; i++)
	          { multiPaste.push(doc.splitLines(lastCopied.text[i])) }
	      }
	    } else if (textLines.length == sel.ranges.length) {
	      multiPaste = map(textLines, function (l) { return [l]; })
	    }
	  }
	
	  var updateInput
	  // Normal behavior is to insert the new text into every selection
	  for (var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--) {
	    var range = sel.ranges[i$1]
	    var from = range.from(), to = range.to()
	    if (range.empty()) {
	      if (deleted && deleted > 0) // Handle deletion
	        { from = Pos(from.line, from.ch - deleted) }
	      else if (cm.state.overwrite && !paste) // Handle overwrite
	        { to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length)) }
	      else if (lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == inserted)
	        { from = to = Pos(from.line, 0) }
	    }
	    updateInput = cm.curOp.updateInput
	    var changeEvent = {from: from, to: to, text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
	                       origin: origin || (paste ? "paste" : cm.state.cutIncoming ? "cut" : "+input")}
	    makeChange(cm.doc, changeEvent)
	    signalLater(cm, "inputRead", cm, changeEvent)
	  }
	  if (inserted && !paste)
	    { triggerElectric(cm, inserted) }
	
	  ensureCursorVisible(cm)
	  cm.curOp.updateInput = updateInput
	  cm.curOp.typing = true
	  cm.state.pasteIncoming = cm.state.cutIncoming = false
	}
	
	function handlePaste(e, cm) {
	  var pasted = e.clipboardData && e.clipboardData.getData("Text")
	  if (pasted) {
	    e.preventDefault()
	    if (!cm.isReadOnly() && !cm.options.disableInput)
	      { runInOp(cm, function () { return applyTextInput(cm, pasted, 0, null, "paste"); }) }
	    return true
	  }
	}
	
	function triggerElectric(cm, inserted) {
	  // When an 'electric' character is inserted, immediately trigger a reindent
	  if (!cm.options.electricChars || !cm.options.smartIndent) { return }
	  var sel = cm.doc.sel
	
	  for (var i = sel.ranges.length - 1; i >= 0; i--) {
	    var range = sel.ranges[i]
	    if (range.head.ch > 100 || (i && sel.ranges[i - 1].head.line == range.head.line)) { continue }
	    var mode = cm.getModeAt(range.head)
	    var indented = false
	    if (mode.electricChars) {
	      for (var j = 0; j < mode.electricChars.length; j++)
	        { if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
	          indented = indentLine(cm, range.head.line, "smart")
	          break
	        } }
	    } else if (mode.electricInput) {
	      if (mode.electricInput.test(getLine(cm.doc, range.head.line).text.slice(0, range.head.ch)))
	        { indented = indentLine(cm, range.head.line, "smart") }
	    }
	    if (indented) { signalLater(cm, "electricInput", cm, range.head.line) }
	  }
	}
	
	function copyableRanges(cm) {
	  var text = [], ranges = []
	  for (var i = 0; i < cm.doc.sel.ranges.length; i++) {
	    var line = cm.doc.sel.ranges[i].head.line
	    var lineRange = {anchor: Pos(line, 0), head: Pos(line + 1, 0)}
	    ranges.push(lineRange)
	    text.push(cm.getRange(lineRange.anchor, lineRange.head))
	  }
	  return {text: text, ranges: ranges}
	}
	
	function disableBrowserMagic(field, spellcheck) {
	  field.setAttribute("autocorrect", "off")
	  field.setAttribute("autocapitalize", "off")
	  field.setAttribute("spellcheck", !!spellcheck)
	}
	
	function hiddenTextarea() {
	  var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; outline: none")
	  var div = elt("div", [te], null, "overflow: hidden; position: relative; width: 3px; height: 0px;")
	  // The textarea is kept positioned near the cursor to prevent the
	  // fact that it'll be scrolled into view on input from scrolling
	  // our fake cursor out of view. On webkit, when wrap=off, paste is
	  // very slow. So make the area wide instead.
	  if (webkit) { te.style.width = "1000px" }
	  else { te.setAttribute("wrap", "off") }
	  // If border: 0; -- iOS fails to open keyboard (issue #1287)
	  if (ios) { te.style.border = "1px solid black" }
	  disableBrowserMagic(te)
	  return div
	}
	
	// The publicly visible API. Note that methodOp(f) means
	// 'wrap f in an operation, performed on its `this` parameter'.
	
	// This is not the complete set of editor methods. Most of the
	// methods defined on the Doc type are also injected into
	// CodeMirror.prototype, for backwards compatibility and
	// convenience.
	
	function addEditorMethods(CodeMirror) {
	  var optionHandlers = CodeMirror.optionHandlers
	
	  var helpers = CodeMirror.helpers = {}
	
	  CodeMirror.prototype = {
	    constructor: CodeMirror,
	    focus: function(){window.focus(); this.display.input.focus()},
	
	    setOption: function(option, value) {
	      var options = this.options, old = options[option]
	      if (options[option] == value && option != "mode") { return }
	      options[option] = value
	      if (optionHandlers.hasOwnProperty(option))
	        { operation(this, optionHandlers[option])(this, value, old) }
	      signal(this, "optionChange", this, option)
	    },
	
	    getOption: function(option) {return this.options[option]},
	    getDoc: function() {return this.doc},
	
	    addKeyMap: function(map, bottom) {
	      this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map))
	    },
	    removeKeyMap: function(map) {
	      var maps = this.state.keyMaps
	      for (var i = 0; i < maps.length; ++i)
	        { if (maps[i] == map || maps[i].name == map) {
	          maps.splice(i, 1)
	          return true
	        } }
	    },
	
	    addOverlay: methodOp(function(spec, options) {
	      var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec)
	      if (mode.startState) { throw new Error("Overlays may not be stateful.") }
	      insertSorted(this.state.overlays,
	                   {mode: mode, modeSpec: spec, opaque: options && options.opaque,
	                    priority: (options && options.priority) || 0},
	                   function (overlay) { return overlay.priority; })
	      this.state.modeGen++
	      regChange(this)
	    }),
	    removeOverlay: methodOp(function(spec) {
	      var this$1 = this;
	
	      var overlays = this.state.overlays
	      for (var i = 0; i < overlays.length; ++i) {
	        var cur = overlays[i].modeSpec
	        if (cur == spec || typeof spec == "string" && cur.name == spec) {
	          overlays.splice(i, 1)
	          this$1.state.modeGen++
	          regChange(this$1)
	          return
	        }
	      }
	    }),
	
	    indentLine: methodOp(function(n, dir, aggressive) {
	      if (typeof dir != "string" && typeof dir != "number") {
	        if (dir == null) { dir = this.options.smartIndent ? "smart" : "prev" }
	        else { dir = dir ? "add" : "subtract" }
	      }
	      if (isLine(this.doc, n)) { indentLine(this, n, dir, aggressive) }
	    }),
	    indentSelection: methodOp(function(how) {
	      var this$1 = this;
	
	      var ranges = this.doc.sel.ranges, end = -1
	      for (var i = 0; i < ranges.length; i++) {
	        var range = ranges[i]
	        if (!range.empty()) {
	          var from = range.from(), to = range.to()
	          var start = Math.max(end, from.line)
	          end = Math.min(this$1.lastLine(), to.line - (to.ch ? 0 : 1)) + 1
	          for (var j = start; j < end; ++j)
	            { indentLine(this$1, j, how) }
	          var newRanges = this$1.doc.sel.ranges
	          if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0)
	            { replaceOneSelection(this$1.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll) }
	        } else if (range.head.line > end) {
	          indentLine(this$1, range.head.line, how, true)
	          end = range.head.line
	          if (i == this$1.doc.sel.primIndex) { ensureCursorVisible(this$1) }
	        }
	      }
	    }),
	
	    // Fetch the parser token for a given character. Useful for hacks
	    // that want to inspect the mode state (say, for completion).
	    getTokenAt: function(pos, precise) {
	      return takeToken(this, pos, precise)
	    },
	
	    getLineTokens: function(line, precise) {
	      return takeToken(this, Pos(line), precise, true)
	    },
	
	    getTokenTypeAt: function(pos) {
	      pos = clipPos(this.doc, pos)
	      var styles = getLineStyles(this, getLine(this.doc, pos.line))
	      var before = 0, after = (styles.length - 1) / 2, ch = pos.ch
	      var type
	      if (ch == 0) { type = styles[2] }
	      else { for (;;) {
	        var mid = (before + after) >> 1
	        if ((mid ? styles[mid * 2 - 1] : 0) >= ch) { after = mid }
	        else if (styles[mid * 2 + 1] < ch) { before = mid + 1 }
	        else { type = styles[mid * 2 + 2]; break }
	      } }
	      var cut = type ? type.indexOf("overlay ") : -1
	      return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1)
	    },
	
	    getModeAt: function(pos) {
	      var mode = this.doc.mode
	      if (!mode.innerMode) { return mode }
	      return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode
	    },
	
	    getHelper: function(pos, type) {
	      return this.getHelpers(pos, type)[0]
	    },
	
	    getHelpers: function(pos, type) {
	      var this$1 = this;
	
	      var found = []
	      if (!helpers.hasOwnProperty(type)) { return found }
	      var help = helpers[type], mode = this.getModeAt(pos)
	      if (typeof mode[type] == "string") {
	        if (help[mode[type]]) { found.push(help[mode[type]]) }
	      } else if (mode[type]) {
	        for (var i = 0; i < mode[type].length; i++) {
	          var val = help[mode[type][i]]
	          if (val) { found.push(val) }
	        }
	      } else if (mode.helperType && help[mode.helperType]) {
	        found.push(help[mode.helperType])
	      } else if (help[mode.name]) {
	        found.push(help[mode.name])
	      }
	      for (var i$1 = 0; i$1 < help._global.length; i$1++) {
	        var cur = help._global[i$1]
	        if (cur.pred(mode, this$1) && indexOf(found, cur.val) == -1)
	          { found.push(cur.val) }
	      }
	      return found
	    },
	
	    getStateAfter: function(line, precise) {
	      var doc = this.doc
	      line = clipLine(doc, line == null ? doc.first + doc.size - 1: line)
	      return getStateBefore(this, line + 1, precise)
	    },
	
	    cursorCoords: function(start, mode) {
	      var pos, range = this.doc.sel.primary()
	      if (start == null) { pos = range.head }
	      else if (typeof start == "object") { pos = clipPos(this.doc, start) }
	      else { pos = start ? range.from() : range.to() }
	      return cursorCoords(this, pos, mode || "page")
	    },
	
	    charCoords: function(pos, mode) {
	      return charCoords(this, clipPos(this.doc, pos), mode || "page")
	    },
	
	    coordsChar: function(coords, mode) {
	      coords = fromCoordSystem(this, coords, mode || "page")
	      return coordsChar(this, coords.left, coords.top)
	    },
	
	    lineAtHeight: function(height, mode) {
	      height = fromCoordSystem(this, {top: height, left: 0}, mode || "page").top
	      return lineAtHeight(this.doc, height + this.display.viewOffset)
	    },
	    heightAtLine: function(line, mode, includeWidgets) {
	      var end = false, lineObj
	      if (typeof line == "number") {
	        var last = this.doc.first + this.doc.size - 1
	        if (line < this.doc.first) { line = this.doc.first }
	        else if (line > last) { line = last; end = true }
	        lineObj = getLine(this.doc, line)
	      } else {
	        lineObj = line
	      }
	      return intoCoordSystem(this, lineObj, {top: 0, left: 0}, mode || "page", includeWidgets).top +
	        (end ? this.doc.height - heightAtLine(lineObj) : 0)
	    },
	
	    defaultTextHeight: function() { return textHeight(this.display) },
	    defaultCharWidth: function() { return charWidth(this.display) },
	
	    getViewport: function() { return {from: this.display.viewFrom, to: this.display.viewTo}},
	
	    addWidget: function(pos, node, scroll, vert, horiz) {
	      var display = this.display
	      pos = cursorCoords(this, clipPos(this.doc, pos))
	      var top = pos.bottom, left = pos.left
	      node.style.position = "absolute"
	      node.setAttribute("cm-ignore-events", "true")
	      this.display.input.setUneditable(node)
	      display.sizer.appendChild(node)
	      if (vert == "over") {
	        top = pos.top
	      } else if (vert == "above" || vert == "near") {
	        var vspace = Math.max(display.wrapper.clientHeight, this.doc.height),
	        hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth)
	        // Default to positioning above (if specified and possible); otherwise default to positioning below
	        if ((vert == 'above' || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight)
	          { top = pos.top - node.offsetHeight }
	        else if (pos.bottom + node.offsetHeight <= vspace)
	          { top = pos.bottom }
	        if (left + node.offsetWidth > hspace)
	          { left = hspace - node.offsetWidth }
	      }
	      node.style.top = top + "px"
	      node.style.left = node.style.right = ""
	      if (horiz == "right") {
	        left = display.sizer.clientWidth - node.offsetWidth
	        node.style.right = "0px"
	      } else {
	        if (horiz == "left") { left = 0 }
	        else if (horiz == "middle") { left = (display.sizer.clientWidth - node.offsetWidth) / 2 }
	        node.style.left = left + "px"
	      }
	      if (scroll)
	        { scrollIntoView(this, left, top, left + node.offsetWidth, top + node.offsetHeight) }
	    },
	
	    triggerOnKeyDown: methodOp(onKeyDown),
	    triggerOnKeyPress: methodOp(onKeyPress),
	    triggerOnKeyUp: onKeyUp,
	
	    execCommand: function(cmd) {
	      if (commands.hasOwnProperty(cmd))
	        { return commands[cmd].call(null, this) }
	    },
	
	    triggerElectric: methodOp(function(text) { triggerElectric(this, text) }),
	
	    findPosH: function(from, amount, unit, visually) {
	      var this$1 = this;
	
	      var dir = 1
	      if (amount < 0) { dir = -1; amount = -amount }
	      var cur = clipPos(this.doc, from)
	      for (var i = 0; i < amount; ++i) {
	        cur = findPosH(this$1.doc, cur, dir, unit, visually)
	        if (cur.hitSide) { break }
	      }
	      return cur
	    },
	
	    moveH: methodOp(function(dir, unit) {
	      var this$1 = this;
	
	      this.extendSelectionsBy(function (range) {
	        if (this$1.display.shift || this$1.doc.extend || range.empty())
	          { return findPosH(this$1.doc, range.head, dir, unit, this$1.options.rtlMoveVisually) }
	        else
	          { return dir < 0 ? range.from() : range.to() }
	      }, sel_move)
	    }),
	
	    deleteH: methodOp(function(dir, unit) {
	      var sel = this.doc.sel, doc = this.doc
	      if (sel.somethingSelected())
	        { doc.replaceSelection("", null, "+delete") }
	      else
	        { deleteNearSelection(this, function (range) {
	          var other = findPosH(doc, range.head, dir, unit, false)
	          return dir < 0 ? {from: other, to: range.head} : {from: range.head, to: other}
	        }) }
	    }),
	
	    findPosV: function(from, amount, unit, goalColumn) {
	      var this$1 = this;
	
	      var dir = 1, x = goalColumn
	      if (amount < 0) { dir = -1; amount = -amount }
	      var cur = clipPos(this.doc, from)
	      for (var i = 0; i < amount; ++i) {
	        var coords = cursorCoords(this$1, cur, "div")
	        if (x == null) { x = coords.left }
	        else { coords.left = x }
	        cur = findPosV(this$1, coords, dir, unit)
	        if (cur.hitSide) { break }
	      }
	      return cur
	    },
	
	    moveV: methodOp(function(dir, unit) {
	      var this$1 = this;
	
	      var doc = this.doc, goals = []
	      var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected()
	      doc.extendSelectionsBy(function (range) {
	        if (collapse)
	          { return dir < 0 ? range.from() : range.to() }
	        var headPos = cursorCoords(this$1, range.head, "div")
	        if (range.goalColumn != null) { headPos.left = range.goalColumn }
	        goals.push(headPos.left)
	        var pos = findPosV(this$1, headPos, dir, unit)
	        if (unit == "page" && range == doc.sel.primary())
	          { addToScrollPos(this$1, null, charCoords(this$1, pos, "div").top - headPos.top) }
	        return pos
	      }, sel_move)
	      if (goals.length) { for (var i = 0; i < doc.sel.ranges.length; i++)
	        { doc.sel.ranges[i].goalColumn = goals[i] } }
	    }),
	
	    // Find the word at the given position (as returned by coordsChar).
	    findWordAt: function(pos) {
	      var doc = this.doc, line = getLine(doc, pos.line).text
	      var start = pos.ch, end = pos.ch
	      if (line) {
	        var helper = this.getHelper(pos, "wordChars")
	        if ((pos.xRel < 0 || end == line.length) && start) { --start; } else { ++end }
	        var startChar = line.charAt(start)
	        var check = isWordChar(startChar, helper)
	          ? function (ch) { return isWordChar(ch, helper); }
	          : /\s/.test(startChar) ? function (ch) { return /\s/.test(ch); }
	          : function (ch) { return (!/\s/.test(ch) && !isWordChar(ch)); }
	        while (start > 0 && check(line.charAt(start - 1))) { --start }
	        while (end < line.length && check(line.charAt(end))) { ++end }
	      }
	      return new Range(Pos(pos.line, start), Pos(pos.line, end))
	    },
	
	    toggleOverwrite: function(value) {
	      if (value != null && value == this.state.overwrite) { return }
	      if (this.state.overwrite = !this.state.overwrite)
	        { addClass(this.display.cursorDiv, "CodeMirror-overwrite") }
	      else
	        { rmClass(this.display.cursorDiv, "CodeMirror-overwrite") }
	
	      signal(this, "overwriteToggle", this, this.state.overwrite)
	    },
	    hasFocus: function() { return this.display.input.getField() == activeElt() },
	    isReadOnly: function() { return !!(this.options.readOnly || this.doc.cantEdit) },
	
	    scrollTo: methodOp(function(x, y) {
	      if (x != null || y != null) { resolveScrollToPos(this) }
	      if (x != null) { this.curOp.scrollLeft = x }
	      if (y != null) { this.curOp.scrollTop = y }
	    }),
	    getScrollInfo: function() {
	      var scroller = this.display.scroller
	      return {left: scroller.scrollLeft, top: scroller.scrollTop,
	              height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
	              width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
	              clientHeight: displayHeight(this), clientWidth: displayWidth(this)}
	    },
	
	    scrollIntoView: methodOp(function(range, margin) {
	      if (range == null) {
	        range = {from: this.doc.sel.primary().head, to: null}
	        if (margin == null) { margin = this.options.cursorScrollMargin }
	      } else if (typeof range == "number") {
	        range = {from: Pos(range, 0), to: null}
	      } else if (range.from == null) {
	        range = {from: range, to: null}
	      }
	      if (!range.to) { range.to = range.from }
	      range.margin = margin || 0
	
	      if (range.from.line != null) {
	        resolveScrollToPos(this)
	        this.curOp.scrollToPos = range
	      } else {
	        var sPos = calculateScrollPos(this, Math.min(range.from.left, range.to.left),
	                                      Math.min(range.from.top, range.to.top) - range.margin,
	                                      Math.max(range.from.right, range.to.right),
	                                      Math.max(range.from.bottom, range.to.bottom) + range.margin)
	        this.scrollTo(sPos.scrollLeft, sPos.scrollTop)
	      }
	    }),
	
	    setSize: methodOp(function(width, height) {
	      var this$1 = this;
	
	      var interpret = function (val) { return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val; }
	      if (width != null) { this.display.wrapper.style.width = interpret(width) }
	      if (height != null) { this.display.wrapper.style.height = interpret(height) }
	      if (this.options.lineWrapping) { clearLineMeasurementCache(this) }
	      var lineNo = this.display.viewFrom
	      this.doc.iter(lineNo, this.display.viewTo, function (line) {
	        if (line.widgets) { for (var i = 0; i < line.widgets.length; i++)
	          { if (line.widgets[i].noHScroll) { regLineChange(this$1, lineNo, "widget"); break } } }
	        ++lineNo
	      })
	      this.curOp.forceUpdate = true
	      signal(this, "refresh", this)
	    }),
	
	    operation: function(f){return runInOp(this, f)},
	
	    refresh: methodOp(function() {
	      var oldHeight = this.display.cachedTextHeight
	      regChange(this)
	      this.curOp.forceUpdate = true
	      clearCaches(this)
	      this.scrollTo(this.doc.scrollLeft, this.doc.scrollTop)
	      updateGutterSpace(this)
	      if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5)
	        { estimateLineHeights(this) }
	      signal(this, "refresh", this)
	    }),
	
	    swapDoc: methodOp(function(doc) {
	      var old = this.doc
	      old.cm = null
	      attachDoc(this, doc)
	      clearCaches(this)
	      this.display.input.reset()
	      this.scrollTo(doc.scrollLeft, doc.scrollTop)
	      this.curOp.forceScroll = true
	      signalLater(this, "swapDoc", this, old)
	      return old
	    }),
	
	    getInputField: function(){return this.display.input.getField()},
	    getWrapperElement: function(){return this.display.wrapper},
	    getScrollerElement: function(){return this.display.scroller},
	    getGutterElement: function(){return this.display.gutters}
	  }
	  eventMixin(CodeMirror)
	
	  CodeMirror.registerHelper = function(type, name, value) {
	    if (!helpers.hasOwnProperty(type)) { helpers[type] = CodeMirror[type] = {_global: []} }
	    helpers[type][name] = value
	  }
	  CodeMirror.registerGlobalHelper = function(type, name, predicate, value) {
	    CodeMirror.registerHelper(type, name, value)
	    helpers[type]._global.push({pred: predicate, val: value})
	  }
	}
	
	// Used for horizontal relative motion. Dir is -1 or 1 (left or
	// right), unit can be "char", "column" (like char, but doesn't
	// cross line boundaries), "word" (across next word), or "group" (to
	// the start of next group of word or non-word-non-whitespace
	// chars). The visually param controls whether, in right-to-left
	// text, direction 1 means to move towards the next index in the
	// string, or towards the character to the right of the current
	// position. The resulting position will have a hitSide=true
	// property if it reached the end of the document.
	function findPosH(doc, pos, dir, unit, visually) {
	  var line = pos.line, ch = pos.ch, origDir = dir
	  var lineObj = getLine(doc, line)
	  function findNextLine() {
	    var l = line + dir
	    if (l < doc.first || l >= doc.first + doc.size) { return false }
	    line = l
	    return lineObj = getLine(doc, l)
	  }
	  function moveOnce(boundToLine) {
	    var next = (visually ? moveVisually : moveLogically)(lineObj, ch, dir, true)
	    if (next == null) {
	      if (!boundToLine && findNextLine()) {
	        if (visually) { ch = (dir < 0 ? lineRight : lineLeft)(lineObj) }
	        else { ch = dir < 0 ? lineObj.text.length : 0 }
	      } else { return false }
	    } else { ch = next }
	    return true
	  }
	
	  if (unit == "char") {
	    moveOnce()
	  } else if (unit == "column") {
	    moveOnce(true)
	  } else if (unit == "word" || unit == "group") {
	    var sawType = null, group = unit == "group"
	    var helper = doc.cm && doc.cm.getHelper(pos, "wordChars")
	    for (var first = true;; first = false) {
	      if (dir < 0 && !moveOnce(!first)) { break }
	      var cur = lineObj.text.charAt(ch) || "\n"
	      var type = isWordChar(cur, helper) ? "w"
	        : group && cur == "\n" ? "n"
	        : !group || /\s/.test(cur) ? null
	        : "p"
	      if (group && !first && !type) { type = "s" }
	      if (sawType && sawType != type) {
	        if (dir < 0) {dir = 1; moveOnce()}
	        break
	      }
	
	      if (type) { sawType = type }
	      if (dir > 0 && !moveOnce(!first)) { break }
	    }
	  }
	  var result = skipAtomic(doc, Pos(line, ch), pos, origDir, true)
	  if (!cmp(pos, result)) { result.hitSide = true }
	  return result
	}
	
	// For relative vertical movement. Dir may be -1 or 1. Unit can be
	// "page" or "line". The resulting position will have a hitSide=true
	// property if it reached the end of the document.
	function findPosV(cm, pos, dir, unit) {
	  var doc = cm.doc, x = pos.left, y
	  if (unit == "page") {
	    var pageSize = Math.min(cm.display.wrapper.clientHeight, window.innerHeight || document.documentElement.clientHeight)
	    var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3)
	    y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount
	
	  } else if (unit == "line") {
	    y = dir > 0 ? pos.bottom + 3 : pos.top - 3
	  }
	  var target
	  for (;;) {
	    target = coordsChar(cm, x, y)
	    if (!target.outside) { break }
	    if (dir < 0 ? y <= 0 : y >= doc.height) { target.hitSide = true; break }
	    y += dir * 5
	  }
	  return target
	}
	
	// CONTENTEDITABLE INPUT STYLE
	
	var ContentEditableInput = function(cm) {
	  this.cm = cm
	  this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null
	  this.polling = new Delayed()
	  this.composing = null
	  this.gracePeriod = false
	  this.readDOMTimeout = null
	};
	
	ContentEditableInput.prototype.init = function (display) {
	    var this$1 = this;
	
	  var input = this, cm = input.cm
	  var div = input.div = display.lineDiv
	  disableBrowserMagic(div, cm.options.spellcheck)
	
	  on(div, "paste", function (e) {
	    if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }
	    // IE doesn't fire input events, so we schedule a read for the pasted content in this way
	    if (ie_version <= 11) { setTimeout(operation(cm, function () {
	      if (!input.pollContent()) { regChange(cm) }
	    }), 20) }
	  })
	
	  on(div, "compositionstart", function (e) {
	    this$1.composing = {data: e.data, done: false}
	  })
	  on(div, "compositionupdate", function (e) {
	    if (!this$1.composing) { this$1.composing = {data: e.data, done: false} }
	  })
	  on(div, "compositionend", function (e) {
	    if (this$1.composing) {
	      if (e.data != this$1.composing.data) { this$1.readFromDOMSoon() }
	      this$1.composing.done = true
	    }
	  })
	
	  on(div, "touchstart", function () { return input.forceCompositionEnd(); })
	
	  on(div, "input", function () {
	    if (!this$1.composing) { this$1.readFromDOMSoon() }
	  })
	
	  function onCopyCut(e) {
	    if (signalDOMEvent(cm, e)) { return }
	    if (cm.somethingSelected()) {
	      setLastCopied({lineWise: false, text: cm.getSelections()})
	      if (e.type == "cut") { cm.replaceSelection("", null, "cut") }
	    } else if (!cm.options.lineWiseCopyCut) {
	      return
	    } else {
	      var ranges = copyableRanges(cm)
	      setLastCopied({lineWise: true, text: ranges.text})
	      if (e.type == "cut") {
	        cm.operation(function () {
	          cm.setSelections(ranges.ranges, 0, sel_dontScroll)
	          cm.replaceSelection("", null, "cut")
	        })
	      }
	    }
	    if (e.clipboardData) {
	      e.clipboardData.clearData()
	      var content = lastCopied.text.join("\n")
	      // iOS exposes the clipboard API, but seems to discard content inserted into it
	      e.clipboardData.setData("Text", content)
	      if (e.clipboardData.getData("Text") == content) {
	        e.preventDefault()
	        return
	      }
	    }
	    // Old-fashioned briefly-focus-a-textarea hack
	    var kludge = hiddenTextarea(), te = kludge.firstChild
	    cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild)
	    te.value = lastCopied.text.join("\n")
	    var hadFocus = document.activeElement
	    selectInput(te)
	    setTimeout(function () {
	      cm.display.lineSpace.removeChild(kludge)
	      hadFocus.focus()
	      if (hadFocus == div) { input.showPrimarySelection() }
	    }, 50)
	  }
	  on(div, "copy", onCopyCut)
	  on(div, "cut", onCopyCut)
	};
	
	ContentEditableInput.prototype.prepareSelection = function () {
	  var result = prepareSelection(this.cm, false)
	  result.focus = this.cm.state.focused
	  return result
	};
	
	ContentEditableInput.prototype.showSelection = function (info, takeFocus) {
	  if (!info || !this.cm.display.view.length) { return }
	  if (info.focus || takeFocus) { this.showPrimarySelection() }
	  this.showMultipleSelections(info)
	};
	
	ContentEditableInput.prototype.showPrimarySelection = function () {
	  var sel = window.getSelection(), prim = this.cm.doc.sel.primary()
	  var curAnchor = domToPos(this.cm, sel.anchorNode, sel.anchorOffset)
	  var curFocus = domToPos(this.cm, sel.focusNode, sel.focusOffset)
	  if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad &&
	      cmp(minPos(curAnchor, curFocus), prim.from()) == 0 &&
	      cmp(maxPos(curAnchor, curFocus), prim.to()) == 0)
	    { return }
	
	  var start = posToDOM(this.cm, prim.from())
	  var end = posToDOM(this.cm, prim.to())
	  if (!start && !end) { return }
	
	  var view = this.cm.display.view
	  var old = sel.rangeCount && sel.getRangeAt(0)
	  if (!start) {
	    start = {node: view[0].measure.map[2], offset: 0}
	  } else if (!end) { // FIXME dangerously hacky
	    var measure = view[view.length - 1].measure
	    var map = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map
	    end = {node: map[map.length - 1], offset: map[map.length - 2] - map[map.length - 3]}
	  }
	
	  var rng
	  try { rng = range(start.node, start.offset, end.offset, end.node) }
	  catch(e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
	  if (rng) {
	    if (!gecko && this.cm.state.focused) {
	      sel.collapse(start.node, start.offset)
	      if (!rng.collapsed) {
	        sel.removeAllRanges()
	        sel.addRange(rng)
	      }
	    } else {
	      sel.removeAllRanges()
	      sel.addRange(rng)
	    }
	    if (old && sel.anchorNode == null) { sel.addRange(old) }
	    else if (gecko) { this.startGracePeriod() }
	  }
	  this.rememberSelection()
	};
	
	ContentEditableInput.prototype.startGracePeriod = function () {
	    var this$1 = this;
	
	  clearTimeout(this.gracePeriod)
	  this.gracePeriod = setTimeout(function () {
	    this$1.gracePeriod = false
	    if (this$1.selectionChanged())
	      { this$1.cm.operation(function () { return this$1.cm.curOp.selectionChanged = true; }) }
	  }, 20)
	};
	
	ContentEditableInput.prototype.showMultipleSelections = function (info) {
	  removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors)
	  removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection)
	};
	
	ContentEditableInput.prototype.rememberSelection = function () {
	  var sel = window.getSelection()
	  this.lastAnchorNode = sel.anchorNode; this.lastAnchorOffset = sel.anchorOffset
	  this.lastFocusNode = sel.focusNode; this.lastFocusOffset = sel.focusOffset
	};
	
	ContentEditableInput.prototype.selectionInEditor = function () {
	  var sel = window.getSelection()
	  if (!sel.rangeCount) { return false }
	  var node = sel.getRangeAt(0).commonAncestorContainer
	  return contains(this.div, node)
	};
	
	ContentEditableInput.prototype.focus = function () {
	  if (this.cm.options.readOnly != "nocursor") {
	    if (!this.selectionInEditor())
	      { this.showSelection(this.prepareSelection(), true) }
	    this.div.focus()
	  }
	};
	ContentEditableInput.prototype.blur = function () { this.div.blur() };
	ContentEditableInput.prototype.getField = function () { return this.div };
	
	ContentEditableInput.prototype.supportsTouch = function () { return true };
	
	ContentEditableInput.prototype.receivedFocus = function () {
	  var input = this
	  if (this.selectionInEditor())
	    { this.pollSelection() }
	  else
	    { runInOp(this.cm, function () { return input.cm.curOp.selectionChanged = true; }) }
	
	  function poll() {
	    if (input.cm.state.focused) {
	      input.pollSelection()
	      input.polling.set(input.cm.options.pollInterval, poll)
	    }
	  }
	  this.polling.set(this.cm.options.pollInterval, poll)
	};
	
	ContentEditableInput.prototype.selectionChanged = function () {
	  var sel = window.getSelection()
	  return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset ||
	    sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset
	};
	
	ContentEditableInput.prototype.pollSelection = function () {
	  if (!this.composing && this.readDOMTimeout == null && !this.gracePeriod && this.selectionChanged()) {
	    var sel = window.getSelection(), cm = this.cm
	    this.rememberSelection()
	    var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset)
	    var head = domToPos(cm, sel.focusNode, sel.focusOffset)
	    if (anchor && head) { runInOp(cm, function () {
	      setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll)
	      if (anchor.bad || head.bad) { cm.curOp.selectionChanged = true }
	    }) }
	  }
	};
	
	ContentEditableInput.prototype.pollContent = function () {
	  if (this.readDOMTimeout != null) {
	    clearTimeout(this.readDOMTimeout)
	    this.readDOMTimeout = null
	  }
	
	  var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary()
	  var from = sel.from(), to = sel.to()
	  if (from.ch == 0 && from.line > cm.firstLine())
	    { from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length) }
	  if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine())
	    { to = Pos(to.line + 1, 0) }
	  if (from.line < display.viewFrom || to.line > display.viewTo - 1) { return false }
	
	  var fromIndex, fromLine, fromNode
	  if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
	    fromLine = lineNo(display.view[0].line)
	    fromNode = display.view[0].node
	  } else {
	    fromLine = lineNo(display.view[fromIndex].line)
	    fromNode = display.view[fromIndex - 1].node.nextSibling
	  }
	  var toIndex = findViewIndex(cm, to.line)
	  var toLine, toNode
	  if (toIndex == display.view.length - 1) {
	    toLine = display.viewTo - 1
	    toNode = display.lineDiv.lastChild
	  } else {
	    toLine = lineNo(display.view[toIndex + 1].line) - 1
	    toNode = display.view[toIndex + 1].node.previousSibling
	  }
	
	  if (!fromNode) { return false }
	  var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine))
	  var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length))
	  while (newText.length > 1 && oldText.length > 1) {
	    if (lst(newText) == lst(oldText)) { newText.pop(); oldText.pop(); toLine-- }
	    else if (newText[0] == oldText[0]) { newText.shift(); oldText.shift(); fromLine++ }
	    else { break }
	  }
	
	  var cutFront = 0, cutEnd = 0
	  var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length)
	  while (cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront))
	    { ++cutFront }
	  var newBot = lst(newText), oldBot = lst(oldText)
	  var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0),
	                           oldBot.length - (oldText.length == 1 ? cutFront : 0))
	  while (cutEnd < maxCutEnd &&
	         newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1))
	    { ++cutEnd }
	
	  newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "")
	  newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "")
	
	  var chFrom = Pos(fromLine, cutFront)
	  var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0)
	  if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
	    replaceRange(cm.doc, newText, chFrom, chTo, "+input")
	    return true
	  }
	};
	
	ContentEditableInput.prototype.ensurePolled = function () {
	  this.forceCompositionEnd()
	};
	ContentEditableInput.prototype.reset = function () {
	  this.forceCompositionEnd()
	};
	ContentEditableInput.prototype.forceCompositionEnd = function () {
	  if (!this.composing) { return }
	  clearTimeout(this.readDOMTimeout)
	  this.composing = null
	  if (!this.pollContent()) { regChange(this.cm) }
	  this.div.blur()
	  this.div.focus()
	};
	ContentEditableInput.prototype.readFromDOMSoon = function () {
	    var this$1 = this;
	
	  if (this.readDOMTimeout != null) { return }
	  this.readDOMTimeout = setTimeout(function () {
	    this$1.readDOMTimeout = null
	    if (this$1.composing) {
	      if (this$1.composing.done) { this$1.composing = null }
	      else { return }
	    }
	    if (this$1.cm.isReadOnly() || !this$1.pollContent())
	      { runInOp(this$1.cm, function () { return regChange(this$1.cm); }) }
	  }, 80)
	};
	
	ContentEditableInput.prototype.setUneditable = function (node) {
	  node.contentEditable = "false"
	};
	
	ContentEditableInput.prototype.onKeyPress = function (e) {
	  e.preventDefault()
	  if (!this.cm.isReadOnly())
	    { operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0) }
	};
	
	ContentEditableInput.prototype.readOnlyChanged = function (val) {
	  this.div.contentEditable = String(val != "nocursor")
	};
	
	ContentEditableInput.prototype.onContextMenu = function () {};
	ContentEditableInput.prototype.resetPosition = function () {};
	
	ContentEditableInput.prototype.needsContentAttribute = true
	
	function posToDOM(cm, pos) {
	  var view = findViewForLine(cm, pos.line)
	  if (!view || view.hidden) { return null }
	  var line = getLine(cm.doc, pos.line)
	  var info = mapFromLineView(view, line, pos.line)
	
	  var order = getOrder(line), side = "left"
	  if (order) {
	    var partPos = getBidiPartAt(order, pos.ch)
	    side = partPos % 2 ? "right" : "left"
	  }
	  var result = nodeAndOffsetInLineMap(info.map, pos.ch, side)
	  result.offset = result.collapse == "right" ? result.end : result.start
	  return result
	}
	
	function badPos(pos, bad) { if (bad) { pos.bad = true; } return pos }
	
	function domTextBetween(cm, from, to, fromLine, toLine) {
	  var text = "", closing = false, lineSep = cm.doc.lineSeparator()
	  function recognizeMarker(id) { return function (marker) { return marker.id == id; } }
	  function walk(node) {
	    if (node.nodeType == 1) {
	      var cmText = node.getAttribute("cm-text")
	      if (cmText != null) {
	        if (cmText == "") { text += node.textContent.replace(/\u200b/g, "") }
	        else { text += cmText }
	        return
	      }
	      var markerID = node.getAttribute("cm-marker"), range
	      if (markerID) {
	        var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID))
	        if (found.length && (range = found[0].find()))
	          { text += getBetween(cm.doc, range.from, range.to).join(lineSep) }
	        return
	      }
	      if (node.getAttribute("contenteditable") == "false") { return }
	      for (var i = 0; i < node.childNodes.length; i++)
	        { walk(node.childNodes[i]) }
	      if (/^(pre|div|p)$/i.test(node.nodeName))
	        { closing = true }
	    } else if (node.nodeType == 3) {
	      var val = node.nodeValue
	      if (!val) { return }
	      if (closing) {
	        text += lineSep
	        closing = false
	      }
	      text += val
	    }
	  }
	  for (;;) {
	    walk(from)
	    if (from == to) { break }
	    from = from.nextSibling
	  }
	  return text
	}
	
	function domToPos(cm, node, offset) {
	  var lineNode
	  if (node == cm.display.lineDiv) {
	    lineNode = cm.display.lineDiv.childNodes[offset]
	    if (!lineNode) { return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true) }
	    node = null; offset = 0
	  } else {
	    for (lineNode = node;; lineNode = lineNode.parentNode) {
	      if (!lineNode || lineNode == cm.display.lineDiv) { return null }
	      if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) { break }
	    }
	  }
	  for (var i = 0; i < cm.display.view.length; i++) {
	    var lineView = cm.display.view[i]
	    if (lineView.node == lineNode)
	      { return locateNodeInLineView(lineView, node, offset) }
	  }
	}
	
	function locateNodeInLineView(lineView, node, offset) {
	  var wrapper = lineView.text.firstChild, bad = false
	  if (!node || !contains(wrapper, node)) { return badPos(Pos(lineNo(lineView.line), 0), true) }
	  if (node == wrapper) {
	    bad = true
	    node = wrapper.childNodes[offset]
	    offset = 0
	    if (!node) {
	      var line = lineView.rest ? lst(lineView.rest) : lineView.line
	      return badPos(Pos(lineNo(line), line.text.length), bad)
	    }
	  }
	
	  var textNode = node.nodeType == 3 ? node : null, topNode = node
	  if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
	    textNode = node.firstChild
	    if (offset) { offset = textNode.nodeValue.length }
	  }
	  while (topNode.parentNode != wrapper) { topNode = topNode.parentNode }
	  var measure = lineView.measure, maps = measure.maps
	
	  function find(textNode, topNode, offset) {
	    for (var i = -1; i < (maps ? maps.length : 0); i++) {
	      var map = i < 0 ? measure.map : maps[i]
	      for (var j = 0; j < map.length; j += 3) {
	        var curNode = map[j + 2]
	        if (curNode == textNode || curNode == topNode) {
	          var line = lineNo(i < 0 ? lineView.line : lineView.rest[i])
	          var ch = map[j] + offset
	          if (offset < 0 || curNode != textNode) { ch = map[j + (offset ? 1 : 0)] }
	          return Pos(line, ch)
	        }
	      }
	    }
	  }
	  var found = find(textNode, topNode, offset)
	  if (found) { return badPos(found, bad) }
	
	  // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
	  for (var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling) {
	    found = find(after, after.firstChild, 0)
	    if (found)
	      { return badPos(Pos(found.line, found.ch - dist), bad) }
	    else
	      { dist += after.textContent.length }
	  }
	  for (var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling) {
	    found = find(before, before.firstChild, -1)
	    if (found)
	      { return badPos(Pos(found.line, found.ch + dist$1), bad) }
	    else
	      { dist$1 += before.textContent.length }
	  }
	}
	
	// TEXTAREA INPUT STYLE
	
	var TextareaInput = function(cm) {
	  this.cm = cm
	  // See input.poll and input.reset
	  this.prevInput = ""
	
	  // Flag that indicates whether we expect input to appear real soon
	  // now (after some event like 'keypress' or 'input') and are
	  // polling intensively.
	  this.pollingFast = false
	  // Self-resetting timeout for the poller
	  this.polling = new Delayed()
	  // Tracks when input.reset has punted to just putting a short
	  // string into the textarea instead of the full selection.
	  this.inaccurateSelection = false
	  // Used to work around IE issue with selection being forgotten when focus moves away from textarea
	  this.hasSelection = false
	  this.composing = null
	};
	
	TextareaInput.prototype.init = function (display) {
	    var this$1 = this;
	
	  var input = this, cm = this.cm
	
	  // Wraps and hides input textarea
	  var div = this.wrapper = hiddenTextarea()
	  // The semihidden textarea that is focused when the editor is
	  // focused, and receives input.
	  var te = this.textarea = div.firstChild
	  display.wrapper.insertBefore(div, display.wrapper.firstChild)
	
	  // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
	  if (ios) { te.style.width = "0px" }
	
	  on(te, "input", function () {
	    if (ie && ie_version >= 9 && this$1.hasSelection) { this$1.hasSelection = null }
	    input.poll()
	  })
	
	  on(te, "paste", function (e) {
	    if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }
	
	    cm.state.pasteIncoming = true
	    input.fastPoll()
	  })
	
	  function prepareCopyCut(e) {
	    if (signalDOMEvent(cm, e)) { return }
	    if (cm.somethingSelected()) {
	      setLastCopied({lineWise: false, text: cm.getSelections()})
	      if (input.inaccurateSelection) {
	        input.prevInput = ""
	        input.inaccurateSelection = false
	        te.value = lastCopied.text.join("\n")
	        selectInput(te)
	      }
	    } else if (!cm.options.lineWiseCopyCut) {
	      return
	    } else {
	      var ranges = copyableRanges(cm)
	      setLastCopied({lineWise: true, text: ranges.text})
	      if (e.type == "cut") {
	        cm.setSelections(ranges.ranges, null, sel_dontScroll)
	      } else {
	        input.prevInput = ""
	        te.value = ranges.text.join("\n")
	        selectInput(te)
	      }
	    }
	    if (e.type == "cut") { cm.state.cutIncoming = true }
	  }
	  on(te, "cut", prepareCopyCut)
	  on(te, "copy", prepareCopyCut)
	
	  on(display.scroller, "paste", function (e) {
	    if (eventInWidget(display, e) || signalDOMEvent(cm, e)) { return }
	    cm.state.pasteIncoming = true
	    input.focus()
	  })
	
	  // Prevent normal selection in the editor (we handle our own)
	  on(display.lineSpace, "selectstart", function (e) {
	    if (!eventInWidget(display, e)) { e_preventDefault(e) }
	  })
	
	  on(te, "compositionstart", function () {
	    var start = cm.getCursor("from")
	    if (input.composing) { input.composing.range.clear() }
	    input.composing = {
	      start: start,
	      range: cm.markText(start, cm.getCursor("to"), {className: "CodeMirror-composing"})
	    }
	  })
	  on(te, "compositionend", function () {
	    if (input.composing) {
	      input.poll()
	      input.composing.range.clear()
	      input.composing = null
	    }
	  })
	};
	
	TextareaInput.prototype.prepareSelection = function () {
	  // Redraw the selection and/or cursor
	  var cm = this.cm, display = cm.display, doc = cm.doc
	  var result = prepareSelection(cm)
	
	  // Move the hidden textarea near the cursor to prevent scrolling artifacts
	  if (cm.options.moveInputWithCursor) {
	    var headPos = cursorCoords(cm, doc.sel.primary().head, "div")
	    var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect()
	    result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10,
	                                        headPos.top + lineOff.top - wrapOff.top))
	    result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10,
	                                         headPos.left + lineOff.left - wrapOff.left))
	  }
	
	  return result
	};
	
	TextareaInput.prototype.showSelection = function (drawn) {
	  var cm = this.cm, display = cm.display
	  removeChildrenAndAdd(display.cursorDiv, drawn.cursors)
	  removeChildrenAndAdd(display.selectionDiv, drawn.selection)
	  if (drawn.teTop != null) {
	    this.wrapper.style.top = drawn.teTop + "px"
	    this.wrapper.style.left = drawn.teLeft + "px"
	  }
	};
	
	// Reset the input to correspond to the selection (or to be empty,
	// when not typing and nothing is selected)
	TextareaInput.prototype.reset = function (typing) {
	  if (this.contextMenuPending) { return }
	  var minimal, selected, cm = this.cm, doc = cm.doc
	  if (cm.somethingSelected()) {
	    this.prevInput = ""
	    var range = doc.sel.primary()
	    minimal = hasCopyEvent &&
	      (range.to().line - range.from().line > 100 || (selected = cm.getSelection()).length > 1000)
	    var content = minimal ? "-" : selected || cm.getSelection()
	    this.textarea.value = content
	    if (cm.state.focused) { selectInput(this.textarea) }
	    if (ie && ie_version >= 9) { this.hasSelection = content }
	  } else if (!typing) {
	    this.prevInput = this.textarea.value = ""
	    if (ie && ie_version >= 9) { this.hasSelection = null }
	  }
	  this.inaccurateSelection = minimal
	};
	
	TextareaInput.prototype.getField = function () { return this.textarea };
	
	TextareaInput.prototype.supportsTouch = function () { return false };
	
	TextareaInput.prototype.focus = function () {
	  if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt() != this.textarea)) {
	    try { this.textarea.focus() }
	    catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
	  }
	};
	
	TextareaInput.prototype.blur = function () { this.textarea.blur() };
	
	TextareaInput.prototype.resetPosition = function () {
	  this.wrapper.style.top = this.wrapper.style.left = 0
	};
	
	TextareaInput.prototype.receivedFocus = function () { this.slowPoll() };
	
	// Poll for input changes, using the normal rate of polling. This
	// runs as long as the editor is focused.
	TextareaInput.prototype.slowPoll = function () {
	    var this$1 = this;
	
	  if (this.pollingFast) { return }
	  this.polling.set(this.cm.options.pollInterval, function () {
	    this$1.poll()
	    if (this$1.cm.state.focused) { this$1.slowPoll() }
	  })
	};
	
	// When an event has just come in that is likely to add or change
	// something in the input textarea, we poll faster, to ensure that
	// the change appears on the screen quickly.
	TextareaInput.prototype.fastPoll = function () {
	  var missed = false, input = this
	  input.pollingFast = true
	  function p() {
	    var changed = input.poll()
	    if (!changed && !missed) {missed = true; input.polling.set(60, p)}
	    else {input.pollingFast = false; input.slowPoll()}
	  }
	  input.polling.set(20, p)
	};
	
	// Read input from the textarea, and update the document to match.
	// When something is selected, it is present in the textarea, and
	// selected (unless it is huge, in which case a placeholder is
	// used). When nothing is selected, the cursor sits after previously
	// seen text (can be empty), which is stored in prevInput (we must
	// not reset the textarea when typing, because that breaks IME).
	TextareaInput.prototype.poll = function () {
	    var this$1 = this;
	
	  var cm = this.cm, input = this.textarea, prevInput = this.prevInput
	  // Since this is called a *lot*, try to bail out as cheaply as
	  // possible when it is clear that nothing happened. hasSelection
	  // will be the case when there is a lot of text in the textarea,
	  // in which case reading its value would be expensive.
	  if (this.contextMenuPending || !cm.state.focused ||
	      (hasSelection(input) && !prevInput && !this.composing) ||
	      cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq)
	    { return false }
	
	  var text = input.value
	  // If nothing changed, bail.
	  if (text == prevInput && !cm.somethingSelected()) { return false }
	  // Work around nonsensical selection resetting in IE9/10, and
	  // inexplicable appearance of private area unicode characters on
	  // some key combos in Mac (#2689).
	  if (ie && ie_version >= 9 && this.hasSelection === text ||
	      mac && /[\uf700-\uf7ff]/.test(text)) {
	    cm.display.input.reset()
	    return false
	  }
	
	  if (cm.doc.sel == cm.display.selForContextMenu) {
	    var first = text.charCodeAt(0)
	    if (first == 0x200b && !prevInput) { prevInput = "\u200b" }
	    if (first == 0x21da) { this.reset(); return this.cm.execCommand("undo") }
	  }
	  // Find the part of the input that is actually new
	  var same = 0, l = Math.min(prevInput.length, text.length)
	  while (same < l && prevInput.charCodeAt(same) == text.charCodeAt(same)) { ++same }
	
	  runInOp(cm, function () {
	    applyTextInput(cm, text.slice(same), prevInput.length - same,
	                   null, this$1.composing ? "*compose" : null)
	
	    // Don't leave long text in the textarea, since it makes further polling slow
	    if (text.length > 1000 || text.indexOf("\n") > -1) { input.value = this$1.prevInput = "" }
	    else { this$1.prevInput = text }
	
	    if (this$1.composing) {
	      this$1.composing.range.clear()
	      this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"),
	                                         {className: "CodeMirror-composing"})
	    }
	  })
	  return true
	};
	
	TextareaInput.prototype.ensurePolled = function () {
	  if (this.pollingFast && this.poll()) { this.pollingFast = false }
	};
	
	TextareaInput.prototype.onKeyPress = function () {
	  if (ie && ie_version >= 9) { this.hasSelection = null }
	  this.fastPoll()
	};
	
	TextareaInput.prototype.onContextMenu = function (e) {
	  var input = this, cm = input.cm, display = cm.display, te = input.textarea
	  var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop
	  if (!pos || presto) { return } // Opera is difficult.
	
	  // Reset the current text selection only if the click is done outside of the selection
	  // and 'resetSelectionOnContextMenu' option is true.
	  var reset = cm.options.resetSelectionOnContextMenu
	  if (reset && cm.doc.sel.contains(pos) == -1)
	    { operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll) }
	
	  var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText
	  input.wrapper.style.cssText = "position: absolute"
	  var wrapperBox = input.wrapper.getBoundingClientRect()
	  te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);"
	  var oldScrollY
	  if (webkit) { oldScrollY = window.scrollY } // Work around Chrome issue (#2712)
	  display.input.focus()
	  if (webkit) { window.scrollTo(null, oldScrollY) }
	  display.input.reset()
	  // Adds "Select all" to context menu in FF
	  if (!cm.somethingSelected()) { te.value = input.prevInput = " " }
	  input.contextMenuPending = true
	  display.selForContextMenu = cm.doc.sel
	  clearTimeout(display.detectingSelectAll)
	
	  // Select-all will be greyed out if there's nothing to select, so
	  // this adds a zero-width space so that we can later check whether
	  // it got selected.
	  function prepareSelectAllHack() {
	    if (te.selectionStart != null) {
	      var selected = cm.somethingSelected()
	      var extval = "\u200b" + (selected ? te.value : "")
	      te.value = "\u21da" // Used to catch context-menu undo
	      te.value = extval
	      input.prevInput = selected ? "" : "\u200b"
	      te.selectionStart = 1; te.selectionEnd = extval.length
	      // Re-set this, in case some other handler touched the
	      // selection in the meantime.
	      display.selForContextMenu = cm.doc.sel
	    }
	  }
	  function rehide() {
	    input.contextMenuPending = false
	    input.wrapper.style.cssText = oldWrapperCSS
	    te.style.cssText = oldCSS
	    if (ie && ie_version < 9) { display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos) }
	
	    // Try to detect the user choosing select-all
	    if (te.selectionStart != null) {
	      if (!ie || (ie && ie_version < 9)) { prepareSelectAllHack() }
	      var i = 0, poll = function () {
	        if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 &&
	            te.selectionEnd > 0 && input.prevInput == "\u200b")
	          { operation(cm, selectAll)(cm) }
	        else if (i++ < 10) { display.detectingSelectAll = setTimeout(poll, 500) }
	        else { display.input.reset() }
	      }
	      display.detectingSelectAll = setTimeout(poll, 200)
	    }
	  }
	
	  if (ie && ie_version >= 9) { prepareSelectAllHack() }
	  if (captureRightClick) {
	    e_stop(e)
	    var mouseup = function () {
	      off(window, "mouseup", mouseup)
	      setTimeout(rehide, 20)
	    }
	    on(window, "mouseup", mouseup)
	  } else {
	    setTimeout(rehide, 50)
	  }
	};
	
	TextareaInput.prototype.readOnlyChanged = function (val) {
	  if (!val) { this.reset() }
	};
	
	TextareaInput.prototype.setUneditable = function () {};
	
	TextareaInput.prototype.needsContentAttribute = false
	
	function fromTextArea(textarea, options) {
	  options = options ? copyObj(options) : {}
	  options.value = textarea.value
	  if (!options.tabindex && textarea.tabIndex)
	    { options.tabindex = textarea.tabIndex }
	  if (!options.placeholder && textarea.placeholder)
	    { options.placeholder = textarea.placeholder }
	  // Set autofocus to true if this textarea is focused, or if it has
	  // autofocus and no other element is focused.
	  if (options.autofocus == null) {
	    var hasFocus = activeElt()
	    options.autofocus = hasFocus == textarea ||
	      textarea.getAttribute("autofocus") != null && hasFocus == document.body
	  }
	
	  function save() {textarea.value = cm.getValue()}
	
	  var realSubmit
	  if (textarea.form) {
	    on(textarea.form, "submit", save)
	    // Deplorable hack to make the submit method do the right thing.
	    if (!options.leaveSubmitMethodAlone) {
	      var form = textarea.form
	      realSubmit = form.submit
	      try {
	        var wrappedSubmit = form.submit = function () {
	          save()
	          form.submit = realSubmit
	          form.submit()
	          form.submit = wrappedSubmit
	        }
	      } catch(e) {}
	    }
	  }
	
	  options.finishInit = function (cm) {
	    cm.save = save
	    cm.getTextArea = function () { return textarea; }
	    cm.toTextArea = function () {
	      cm.toTextArea = isNaN // Prevent this from being ran twice
	      save()
	      textarea.parentNode.removeChild(cm.getWrapperElement())
	      textarea.style.display = ""
	      if (textarea.form) {
	        off(textarea.form, "submit", save)
	        if (typeof textarea.form.submit == "function")
	          { textarea.form.submit = realSubmit }
	      }
	    }
	  }
	
	  textarea.style.display = "none"
	  var cm = CodeMirror(function (node) { return textarea.parentNode.insertBefore(node, textarea.nextSibling); },
	    options)
	  return cm
	}
	
	function addLegacyProps(CodeMirror) {
	  CodeMirror.off = off
	  CodeMirror.on = on
	  CodeMirror.wheelEventPixels = wheelEventPixels
	  CodeMirror.Doc = Doc
	  CodeMirror.splitLines = splitLinesAuto
	  CodeMirror.countColumn = countColumn
	  CodeMirror.findColumn = findColumn
	  CodeMirror.isWordChar = isWordCharBasic
	  CodeMirror.Pass = Pass
	  CodeMirror.signal = signal
	  CodeMirror.Line = Line
	  CodeMirror.changeEnd = changeEnd
	  CodeMirror.scrollbarModel = scrollbarModel
	  CodeMirror.Pos = Pos
	  CodeMirror.cmpPos = cmp
	  CodeMirror.modes = modes
	  CodeMirror.mimeModes = mimeModes
	  CodeMirror.resolveMode = resolveMode
	  CodeMirror.getMode = getMode
	  CodeMirror.modeExtensions = modeExtensions
	  CodeMirror.extendMode = extendMode
	  CodeMirror.copyState = copyState
	  CodeMirror.startState = startState
	  CodeMirror.innerMode = innerMode
	  CodeMirror.commands = commands
	  CodeMirror.keyMap = keyMap
	  CodeMirror.keyName = keyName
	  CodeMirror.isModifierKey = isModifierKey
	  CodeMirror.lookupKey = lookupKey
	  CodeMirror.normalizeKeyMap = normalizeKeyMap
	  CodeMirror.StringStream = StringStream
	  CodeMirror.SharedTextMarker = SharedTextMarker
	  CodeMirror.TextMarker = TextMarker
	  CodeMirror.LineWidget = LineWidget
	  CodeMirror.e_preventDefault = e_preventDefault
	  CodeMirror.e_stopPropagation = e_stopPropagation
	  CodeMirror.e_stop = e_stop
	  CodeMirror.addClass = addClass
	  CodeMirror.contains = contains
	  CodeMirror.rmClass = rmClass
	  CodeMirror.keyNames = keyNames
	}
	
	// EDITOR CONSTRUCTOR
	
	defineOptions(CodeMirror)
	
	addEditorMethods(CodeMirror)
	
	// Set up methods on CodeMirror's prototype to redirect to the editor's document.
	var dontDelegate = "iter insert remove copy getEditor constructor".split(" ")
	for (var prop in Doc.prototype) { if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0)
	  { CodeMirror.prototype[prop] = (function(method) {
	    return function() {return method.apply(this.doc, arguments)}
	  })(Doc.prototype[prop]) } }
	
	eventMixin(Doc)
	
	// INPUT HANDLING
	
	CodeMirror.inputStyles = {"textarea": TextareaInput, "contenteditable": ContentEditableInput}
	
	// MODE DEFINITION AND QUERYING
	
	// Extra arguments are stored as the mode's dependencies, which is
	// used by (legacy) mechanisms like loadmode.js to automatically
	// load a mode. (Preferred mechanism is the require/define calls.)
	CodeMirror.defineMode = function(name/*, mode, …*/) {
	  if (!CodeMirror.defaults.mode && name != "null") { CodeMirror.defaults.mode = name }
	  defineMode.apply(this, arguments)
	}
	
	CodeMirror.defineMIME = defineMIME
	
	// Minimal default mode.
	CodeMirror.defineMode("null", function () { return ({token: function (stream) { return stream.skipToEnd(); }}); })
	CodeMirror.defineMIME("text/plain", "null")
	
	// EXTENSIONS
	
	CodeMirror.defineExtension = function (name, func) {
	  CodeMirror.prototype[name] = func
	}
	CodeMirror.defineDocExtension = function (name, func) {
	  Doc.prototype[name] = func
	}
	
	CodeMirror.fromTextArea = fromTextArea
	
	addLegacyProps(CodeMirror)
	
	CodeMirror.version = "5.23.0"
	
	return CodeMirror;
	
	})));

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(120)
	var ieee754 = __webpack_require__(1317)
	var isArray = __webpack_require__(103)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 4 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(22), __webpack_require__(12), __webpack_require__(21));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../xml/xml", "../javascript/javascript", "../css/css"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  var defaultTags = {
	    script: [
	      ["lang", /(javascript|babel)/i, "javascript"],
	      ["type", /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^$/i, "javascript"],
	      ["type", /./, "text/plain"],
	      [null, null, "javascript"]
	    ],
	    style:  [
	      ["lang", /^css$/i, "css"],
	      ["type", /^(text\/)?(x-)?(stylesheet|css)$/i, "css"],
	      ["type", /./, "text/plain"],
	      [null, null, "css"]
	    ]
	  };
	
	  function maybeBackup(stream, pat, style) {
	    var cur = stream.current(), close = cur.search(pat);
	    if (close > -1) {
	      stream.backUp(cur.length - close);
	    } else if (cur.match(/<\/?$/)) {
	      stream.backUp(cur.length);
	      if (!stream.match(pat, false)) stream.match(cur);
	    }
	    return style;
	  }
	
	  var attrRegexpCache = {};
	  function getAttrRegexp(attr) {
	    var regexp = attrRegexpCache[attr];
	    if (regexp) return regexp;
	    return attrRegexpCache[attr] = new RegExp("\\s+" + attr + "\\s*=\\s*('|\")?([^'\"]+)('|\")?\\s*");
	  }
	
	  function getAttrValue(text, attr) {
	    var match = text.match(getAttrRegexp(attr))
	    return match ? /^\s*(.*?)\s*$/.exec(match[2])[1] : ""
	  }
	
	  function getTagRegexp(tagName, anchored) {
	    return new RegExp((anchored ? "^" : "") + "<\/\s*" + tagName + "\s*>", "i");
	  }
	
	  function addTags(from, to) {
	    for (var tag in from) {
	      var dest = to[tag] || (to[tag] = []);
	      var source = from[tag];
	      for (var i = source.length - 1; i >= 0; i--)
	        dest.unshift(source[i])
	    }
	  }
	
	  function findMatchingMode(tagInfo, tagText) {
	    for (var i = 0; i < tagInfo.length; i++) {
	      var spec = tagInfo[i];
	      if (!spec[0] || spec[1].test(getAttrValue(tagText, spec[0]))) return spec[2];
	    }
	  }
	
	  CodeMirror.defineMode("htmlmixed", function (config, parserConfig) {
	    var htmlMode = CodeMirror.getMode(config, {
	      name: "xml",
	      htmlMode: true,
	      multilineTagIndentFactor: parserConfig.multilineTagIndentFactor,
	      multilineTagIndentPastTag: parserConfig.multilineTagIndentPastTag
	    });
	
	    var tags = {};
	    var configTags = parserConfig && parserConfig.tags, configScript = parserConfig && parserConfig.scriptTypes;
	    addTags(defaultTags, tags);
	    if (configTags) addTags(configTags, tags);
	    if (configScript) for (var i = configScript.length - 1; i >= 0; i--)
	      tags.script.unshift(["type", configScript[i].matches, configScript[i].mode])
	
	    function html(stream, state) {
	      var style = htmlMode.token(stream, state.htmlState), tag = /\btag\b/.test(style), tagName
	      if (tag && !/[<>\s\/]/.test(stream.current()) &&
	          (tagName = state.htmlState.tagName && state.htmlState.tagName.toLowerCase()) &&
	          tags.hasOwnProperty(tagName)) {
	        state.inTag = tagName + " "
	      } else if (state.inTag && tag && />$/.test(stream.current())) {
	        var inTag = /^([\S]+) (.*)/.exec(state.inTag)
	        state.inTag = null
	        var modeSpec = stream.current() == ">" && findMatchingMode(tags[inTag[1]], inTag[2])
	        var mode = CodeMirror.getMode(config, modeSpec)
	        var endTagA = getTagRegexp(inTag[1], true), endTag = getTagRegexp(inTag[1], false);
	        state.token = function (stream, state) {
	          if (stream.match(endTagA, false)) {
	            state.token = html;
	            state.localState = state.localMode = null;
	            return null;
	          }
	          return maybeBackup(stream, endTag, state.localMode.token(stream, state.localState));
	        };
	        state.localMode = mode;
	        state.localState = CodeMirror.startState(mode, htmlMode.indent(state.htmlState, ""));
	      } else if (state.inTag) {
	        state.inTag += stream.current()
	        if (stream.eol()) state.inTag += " "
	      }
	      return style;
	    };
	
	    return {
	      startState: function () {
	        var state = CodeMirror.startState(htmlMode);
	        return {token: html, inTag: null, localMode: null, localState: null, htmlState: state};
	      },
	
	      copyState: function (state) {
	        var local;
	        if (state.localState) {
	          local = CodeMirror.copyState(state.localMode, state.localState);
	        }
	        return {token: state.token, inTag: state.inTag,
	                localMode: state.localMode, localState: local,
	                htmlState: CodeMirror.copyState(htmlMode, state.htmlState)};
	      },
	
	      token: function (stream, state) {
	        return state.token(stream, state);
	      },
	
	      indent: function (state, textAfter) {
	        if (!state.localMode || /^\s*<\//.test(textAfter))
	          return htmlMode.indent(state.htmlState, textAfter);
	        else if (state.localMode.indent)
	          return state.localMode.indent(state.localState, textAfter);
	        else
	          return CodeMirror.Pass;
	      },
	
	      innerMode: function (state) {
	        return {state: state.localState || state.htmlState, mode: state.localMode || htmlMode};
	      }
	    };
	  }, "xml", "javascript", "css");
	
	  CodeMirror.defineMIME("text/html", "htmlmixed");
	});


/***/ },
/* 6 */
/***/ function(module, exports) {

	/// <reference path="../index.d.ts" />
	"use strict";
	/**
	 * Returns random element of a collection
	 *
	 * @param collection
	 * @returns {T}
	 */
	function pick(collection) {
	    return collection[Math.floor(Math.random() * collection.length)];
	}
	/**
	 * Returns shuffled collection of elements
	 *
	 * @param collection
	 * @returns {T[]}
	 */
	function shuffle(collection) {
	    var tmp, key, copy = collection.slice(), length = collection.length;
	    for (; length > 0;) {
	        key = Math.floor(Math.random() * length);
	        // swap
	        tmp = copy[--length];
	        copy[length] = copy[key];
	        copy[key] = tmp;
	    }
	    return copy;
	}
	/**
	 * These values determine default range for random.number function
	 *
	 * @type {number}
	 */
	var MIN_NUMBER = -100, MAX_NUMBER = 100;
	/**
	 * Returns a random integer between min (inclusive) and max (inclusive)
	 * Using Math.round() will give you a non-uniform distribution!
	 * @see http://stackoverflow.com/a/1527820/769384
	 */
	function getRandomInt(min, max) {
	    return Math.floor(Math.random() * (max - min + 1)) + min;
	}
	/**
	 * Generates random number according to parameters passed
	 *
	 * @param min
	 * @param max
	 * @param defMin
	 * @param defMax
	 * @param hasPrecision
	 * @returns {number}
	 */
	function number(min, max, defMin, defMax, hasPrecision) {
	    if (hasPrecision === void 0) { hasPrecision = false; }
	    defMin = typeof defMin === 'undefined' ? MIN_NUMBER : defMin;
	    defMax = typeof defMax === 'undefined' ? MAX_NUMBER : defMax;
	    min = typeof min === 'undefined' ? defMin : min;
	    max = typeof max === 'undefined' ? defMax : max;
	    if (max < min) {
	        max += min;
	    }
	    var result = getRandomInt(min, max);
	    if (!hasPrecision) {
	        return parseInt(result + '', 10);
	    }
	    return result;
	}
	module.exports = {
	    pick: pick,
	    shuffle: shuffle,
	    number: number
	};


/***/ },
/* 7 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	  var Pos = CodeMirror.Pos;
	
	  function SearchCursor(doc, query, pos, caseFold) {
	    this.atOccurrence = false; this.doc = doc;
	    if (caseFold == null && typeof query == "string") caseFold = false;
	
	    pos = pos ? doc.clipPos(pos) : Pos(0, 0);
	    this.pos = {from: pos, to: pos};
	
	    // The matches method is filled in based on the type of query.
	    // It takes a position and a direction, and returns an object
	    // describing the next occurrence of the query, or null if no
	    // more matches were found.
	    if (typeof query != "string") { // Regexp match
	      if (!query.global) query = new RegExp(query.source, query.ignoreCase ? "ig" : "g");
	      this.matches = function(reverse, pos) {
	        if (reverse) {
	          query.lastIndex = 0;
	          var line = doc.getLine(pos.line).slice(0, pos.ch), cutOff = 0, match, start;
	          for (;;) {
	            query.lastIndex = cutOff;
	            var newMatch = query.exec(line);
	            if (!newMatch) break;
	            match = newMatch;
	            start = match.index;
	            cutOff = match.index + (match[0].length || 1);
	            if (cutOff == line.length) break;
	          }
	          var matchLen = (match && match[0].length) || 0;
	          if (!matchLen) {
	            if (start == 0 && line.length == 0) {match = undefined;}
	            else if (start != doc.getLine(pos.line).length) {
	              matchLen++;
	            }
	          }
	        } else {
	          query.lastIndex = pos.ch;
	          var line = doc.getLine(pos.line), match = query.exec(line);
	          var matchLen = (match && match[0].length) || 0;
	          var start = match && match.index;
	          if (start + matchLen != line.length && !matchLen) matchLen = 1;
	        }
	        if (match && matchLen)
	          return {from: Pos(pos.line, start),
	                  to: Pos(pos.line, start + matchLen),
	                  match: match};
	      };
	    } else { // String query
	      var origQuery = query;
	      if (caseFold) query = query.toLowerCase();
	      var fold = caseFold ? function(str){return str.toLowerCase();} : function(str){return str;};
	      var target = query.split("\n");
	      // Different methods for single-line and multi-line queries
	      if (target.length == 1) {
	        if (!query.length) {
	          // Empty string would match anything and never progress, so
	          // we define it to match nothing instead.
	          this.matches = function() {};
	        } else {
	          this.matches = function(reverse, pos) {
	            if (reverse) {
	              var orig = doc.getLine(pos.line).slice(0, pos.ch), line = fold(orig);
	              var match = line.lastIndexOf(query);
	              if (match > -1) {
	                match = adjustPos(orig, line, match);
	                return {from: Pos(pos.line, match), to: Pos(pos.line, match + origQuery.length)};
	              }
	             } else {
	               var orig = doc.getLine(pos.line).slice(pos.ch), line = fold(orig);
	               var match = line.indexOf(query);
	               if (match > -1) {
	                 match = adjustPos(orig, line, match) + pos.ch;
	                 return {from: Pos(pos.line, match), to: Pos(pos.line, match + origQuery.length)};
	               }
	            }
	          };
	        }
	      } else {
	        var origTarget = origQuery.split("\n");
	        this.matches = function(reverse, pos) {
	          var last = target.length - 1;
	          if (reverse) {
	            if (pos.line - (target.length - 1) < doc.firstLine()) return;
	            if (fold(doc.getLine(pos.line).slice(0, origTarget[last].length)) != target[target.length - 1]) return;
	            var to = Pos(pos.line, origTarget[last].length);
	            for (var ln = pos.line - 1, i = last - 1; i >= 1; --i, --ln)
	              if (target[i] != fold(doc.getLine(ln))) return;
	            var line = doc.getLine(ln), cut = line.length - origTarget[0].length;
	            if (fold(line.slice(cut)) != target[0]) return;
	            return {from: Pos(ln, cut), to: to};
	          } else {
	            if (pos.line + (target.length - 1) > doc.lastLine()) return;
	            var line = doc.getLine(pos.line), cut = line.length - origTarget[0].length;
	            if (fold(line.slice(cut)) != target[0]) return;
	            var from = Pos(pos.line, cut);
	            for (var ln = pos.line + 1, i = 1; i < last; ++i, ++ln)
	              if (target[i] != fold(doc.getLine(ln))) return;
	            if (fold(doc.getLine(ln).slice(0, origTarget[last].length)) != target[last]) return;
	            return {from: from, to: Pos(ln, origTarget[last].length)};
	          }
	        };
	      }
	    }
	  }
	
	  SearchCursor.prototype = {
	    findNext: function() {return this.find(false);},
	    findPrevious: function() {return this.find(true);},
	
	    find: function(reverse) {
	      var self = this, pos = this.doc.clipPos(reverse ? this.pos.from : this.pos.to);
	      function savePosAndFail(line) {
	        var pos = Pos(line, 0);
	        self.pos = {from: pos, to: pos};
	        self.atOccurrence = false;
	        return false;
	      }
	
	      for (;;) {
	        if (this.pos = this.matches(reverse, pos)) {
	          this.atOccurrence = true;
	          return this.pos.match || true;
	        }
	        if (reverse) {
	          if (!pos.line) return savePosAndFail(0);
	          pos = Pos(pos.line-1, this.doc.getLine(pos.line-1).length);
	        }
	        else {
	          var maxLine = this.doc.lineCount();
	          if (pos.line == maxLine - 1) return savePosAndFail(maxLine);
	          pos = Pos(pos.line + 1, 0);
	        }
	      }
	    },
	
	    from: function() {if (this.atOccurrence) return this.pos.from;},
	    to: function() {if (this.atOccurrence) return this.pos.to;},
	
	    replace: function(newText, origin) {
	      if (!this.atOccurrence) return;
	      var lines = CodeMirror.splitLines(newText);
	      this.doc.replaceRange(lines, this.pos.from, this.pos.to, origin);
	      this.pos.to = Pos(this.pos.from.line + lines.length - 1,
	                        lines[lines.length - 1].length + (lines.length == 1 ? this.pos.from.ch : 0));
	    }
	  };
	
	  // Maps a position in a case-folded line back to a position in the original line
	  // (compensating for codepoints increasing in number during folding)
	  function adjustPos(orig, folded, pos) {
	    if (orig.length == folded.length) return pos;
	    for (var pos1 = Math.min(pos, orig.length);;) {
	      var len1 = orig.slice(0, pos1).toLowerCase().length;
	      if (len1 < pos) ++pos1;
	      else if (len1 > pos) --pos1;
	      else return pos1;
	    }
	  }
	
	  CodeMirror.defineExtension("getSearchCursor", function(query, pos, caseFold) {
	    return new SearchCursor(this.doc, query, pos, caseFold);
	  });
	  CodeMirror.defineDocExtension("getSearchCursor", function(query, pos, caseFold) {
	    return new SearchCursor(this, query, pos, caseFold);
	  });
	
	  CodeMirror.defineExtension("selectMatches", function(query, caseFold) {
	    var ranges = [];
	    var cur = this.getSearchCursor(query, this.getCursor("from"), caseFold);
	    while (cur.findNext()) {
	      if (CodeMirror.cmpPos(cur.to(), this.getCursor("to")) > 0) break;
	      ranges.push({anchor: cur.from(), head: cur.to()});
	    }
	    if (ranges.length)
	      this.setSelections(ranges, 0);
	  });
	});


/***/ },
/* 9 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(264)
	  , defined = __webpack_require__(47);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var processNextTick = __webpack_require__(61);
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(23);
	util.inherits = __webpack_require__(4);
	/*</replacement>*/
	
	var Readable = __webpack_require__(109);
	var Writable = __webpack_require__(63);
	
	util.inherits(Duplex, Readable);
	
	var keys = objectKeys(Writable.prototype);
	for (var v = 0; v < keys.length; v++) {
	  var method = keys[v];
	  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  processNextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	function expressionAllowed(stream, state, backUp) {
	  return /^(?:operator|sof|keyword c|case|new|export|default|[\[{}\(,;:]|=>)$/.test(state.lastType) ||
	    (state.lastType == "quasi" && /\{\s*$/.test(stream.string.slice(0, stream.pos - (backUp || 0))))
	}
	
	CodeMirror.defineMode("javascript", function(config, parserConfig) {
	  var indentUnit = config.indentUnit;
	  var statementIndent = parserConfig.statementIndent;
	  var jsonldMode = parserConfig.jsonld;
	  var jsonMode = parserConfig.json || jsonldMode;
	  var isTS = parserConfig.typescript;
	  var wordRE = parserConfig.wordCharacters || /[\w$\xa1-\uffff]/;
	
	  // Tokenizer
	
	  var keywords = function(){
	    function kw(type) {return {type: type, style: "keyword"};}
	    var A = kw("keyword a"), B = kw("keyword b"), C = kw("keyword c");
	    var operator = kw("operator"), atom = {type: "atom", style: "atom"};
	
	    var jsKeywords = {
	      "if": kw("if"), "while": A, "with": A, "else": B, "do": B, "try": B, "finally": B,
	      "return": C, "break": C, "continue": C, "new": kw("new"), "delete": C, "throw": C, "debugger": C,
	      "var": kw("var"), "const": kw("var"), "let": kw("var"),
	      "function": kw("function"), "catch": kw("catch"),
	      "for": kw("for"), "switch": kw("switch"), "case": kw("case"), "default": kw("default"),
	      "in": operator, "typeof": operator, "instanceof": operator,
	      "true": atom, "false": atom, "null": atom, "undefined": atom, "NaN": atom, "Infinity": atom,
	      "this": kw("this"), "class": kw("class"), "super": kw("atom"),
	      "yield": C, "export": kw("export"), "import": kw("import"), "extends": C,
	      "await": C, "async": kw("async")
	    };
	
	    // Extend the 'normal' keywords with the TypeScript language extensions
	    if (isTS) {
	      var type = {type: "variable", style: "variable-3"};
	      var tsKeywords = {
	        // object-like things
	        "interface": kw("class"),
	        "implements": C,
	        "namespace": C,
	        "module": kw("module"),
	        "enum": kw("module"),
	        "type": kw("type"),
	
	        // scope modifiers
	        "public": kw("modifier"),
	        "private": kw("modifier"),
	        "protected": kw("modifier"),
	        "abstract": kw("modifier"),
	
	        // operators
	        "as": operator,
	
	        // types
	        "string": type, "number": type, "boolean": type, "any": type
	      };
	
	      for (var attr in tsKeywords) {
	        jsKeywords[attr] = tsKeywords[attr];
	      }
	    }
	
	    return jsKeywords;
	  }();
	
	  var isOperatorChar = /[+\-*&%=<>!?|~^]/;
	  var isJsonldKeyword = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;
	
	  function readRegexp(stream) {
	    var escaped = false, next, inSet = false;
	    while ((next = stream.next()) != null) {
	      if (!escaped) {
	        if (next == "/" && !inSet) return;
	        if (next == "[") inSet = true;
	        else if (inSet && next == "]") inSet = false;
	      }
	      escaped = !escaped && next == "\\";
	    }
	  }
	
	  // Used as scratch variables to communicate multiple values without
	  // consing up tons of objects.
	  var type, content;
	  function ret(tp, style, cont) {
	    type = tp; content = cont;
	    return style;
	  }
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    if (ch == '"' || ch == "'") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    } else if (ch == "." && stream.match(/^\d+(?:[eE][+\-]?\d+)?/)) {
	      return ret("number", "number");
	    } else if (ch == "." && stream.match("..")) {
	      return ret("spread", "meta");
	    } else if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
	      return ret(ch);
	    } else if (ch == "=" && stream.eat(">")) {
	      return ret("=>", "operator");
	    } else if (ch == "0" && stream.eat(/x/i)) {
	      stream.eatWhile(/[\da-f]/i);
	      return ret("number", "number");
	    } else if (ch == "0" && stream.eat(/o/i)) {
	      stream.eatWhile(/[0-7]/i);
	      return ret("number", "number");
	    } else if (ch == "0" && stream.eat(/b/i)) {
	      stream.eatWhile(/[01]/i);
	      return ret("number", "number");
	    } else if (/\d/.test(ch)) {
	      stream.match(/^\d*(?:\.\d*)?(?:[eE][+\-]?\d+)?/);
	      return ret("number", "number");
	    } else if (ch == "/") {
	      if (stream.eat("*")) {
	        state.tokenize = tokenComment;
	        return tokenComment(stream, state);
	      } else if (stream.eat("/")) {
	        stream.skipToEnd();
	        return ret("comment", "comment");
	      } else if (expressionAllowed(stream, state, 1)) {
	        readRegexp(stream);
	        stream.match(/^\b(([gimyu])(?![gimyu]*\2))+\b/);
	        return ret("regexp", "string-2");
	      } else {
	        stream.eatWhile(isOperatorChar);
	        return ret("operator", "operator", stream.current());
	      }
	    } else if (ch == "`") {
	      state.tokenize = tokenQuasi;
	      return tokenQuasi(stream, state);
	    } else if (ch == "#") {
	      stream.skipToEnd();
	      return ret("error", "error");
	    } else if (isOperatorChar.test(ch)) {
	      if (ch != ">" || !state.lexical || state.lexical.type != ">")
	        stream.eatWhile(isOperatorChar);
	      return ret("operator", "operator", stream.current());
	    } else if (wordRE.test(ch)) {
	      stream.eatWhile(wordRE);
	      var word = stream.current(), known = keywords.propertyIsEnumerable(word) && keywords[word];
	      return (known && state.lastType != ".") ? ret(known.type, known.style, word) :
	                     ret("variable", "variable", word);
	    }
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, next;
	      if (jsonldMode && stream.peek() == "@" && stream.match(isJsonldKeyword)){
	        state.tokenize = tokenBase;
	        return ret("jsonld-keyword", "meta");
	      }
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) break;
	        escaped = !escaped && next == "\\";
	      }
	      if (!escaped) state.tokenize = tokenBase;
	      return ret("string", "string");
	    };
	  }
	
	  function tokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while (ch = stream.next()) {
	      if (ch == "/" && maybeEnd) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return ret("comment", "comment");
	  }
	
	  function tokenQuasi(stream, state) {
	    var escaped = false, next;
	    while ((next = stream.next()) != null) {
	      if (!escaped && (next == "`" || next == "$" && stream.eat("{"))) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      escaped = !escaped && next == "\\";
	    }
	    return ret("quasi", "string-2", stream.current());
	  }
	
	  var brackets = "([{}])";
	  // This is a crude lookahead trick to try and notice that we're
	  // parsing the argument patterns for a fat-arrow function before we
	  // actually hit the arrow token. It only works if the arrow is on
	  // the same line as the arguments and there's no strange noise
	  // (comments) in between. Fallback is to only notice when we hit the
	  // arrow, and not declare the arguments as locals for the arrow
	  // body.
	  function findFatArrow(stream, state) {
	    if (state.fatArrowAt) state.fatArrowAt = null;
	    var arrow = stream.string.indexOf("=>", stream.start);
	    if (arrow < 0) return;
	
	    if (isTS) { // Try to skip TypeScript return type declarations after the arguments
	      var m = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(stream.string.slice(stream.start, arrow))
	      if (m) arrow = m.index
	    }
	
	    var depth = 0, sawSomething = false;
	    for (var pos = arrow - 1; pos >= 0; --pos) {
	      var ch = stream.string.charAt(pos);
	      var bracket = brackets.indexOf(ch);
	      if (bracket >= 0 && bracket < 3) {
	        if (!depth) { ++pos; break; }
	        if (--depth == 0) { if (ch == "(") sawSomething = true; break; }
	      } else if (bracket >= 3 && bracket < 6) {
	        ++depth;
	      } else if (wordRE.test(ch)) {
	        sawSomething = true;
	      } else if (/["'\/]/.test(ch)) {
	        return;
	      } else if (sawSomething && !depth) {
	        ++pos;
	        break;
	      }
	    }
	    if (sawSomething && !depth) state.fatArrowAt = pos;
	  }
	
	  // Parser
	
	  var atomicTypes = {"atom": true, "number": true, "variable": true, "string": true, "regexp": true, "this": true, "jsonld-keyword": true};
	
	  function JSLexical(indented, column, type, align, prev, info) {
	    this.indented = indented;
	    this.column = column;
	    this.type = type;
	    this.prev = prev;
	    this.info = info;
	    if (align != null) this.align = align;
	  }
	
	  function inScope(state, varname) {
	    for (var v = state.localVars; v; v = v.next)
	      if (v.name == varname) return true;
	    for (var cx = state.context; cx; cx = cx.prev) {
	      for (var v = cx.vars; v; v = v.next)
	        if (v.name == varname) return true;
	    }
	  }
	
	  function parseJS(state, style, type, content, stream) {
	    var cc = state.cc;
	    // Communicate our context to the combinators.
	    // (Less wasteful than consing up a hundred closures on every call.)
	    cx.state = state; cx.stream = stream; cx.marked = null, cx.cc = cc; cx.style = style;
	
	    if (!state.lexical.hasOwnProperty("align"))
	      state.lexical.align = true;
	
	    while(true) {
	      var combinator = cc.length ? cc.pop() : jsonMode ? expression : statement;
	      if (combinator(type, content)) {
	        while(cc.length && cc[cc.length - 1].lex)
	          cc.pop()();
	        if (cx.marked) return cx.marked;
	        if (type == "variable" && inScope(state, content)) return "variable-2";
	        return style;
	      }
	    }
	  }
	
	  // Combinator utils
	
	  var cx = {state: null, column: null, marked: null, cc: null};
	  function pass() {
	    for (var i = arguments.length - 1; i >= 0; i--) cx.cc.push(arguments[i]);
	  }
	  function cont() {
	    pass.apply(null, arguments);
	    return true;
	  }
	  function register(varname) {
	    function inList(list) {
	      for (var v = list; v; v = v.next)
	        if (v.name == varname) return true;
	      return false;
	    }
	    var state = cx.state;
	    cx.marked = "def";
	    if (state.context) {
	      if (inList(state.localVars)) return;
	      state.localVars = {name: varname, next: state.localVars};
	    } else {
	      if (inList(state.globalVars)) return;
	      if (parserConfig.globalVars)
	        state.globalVars = {name: varname, next: state.globalVars};
	    }
	  }
	
	  // Combinators
	
	  var defaultVars = {name: "this", next: {name: "arguments"}};
	  function pushcontext() {
	    cx.state.context = {prev: cx.state.context, vars: cx.state.localVars};
	    cx.state.localVars = defaultVars;
	  }
	  function popcontext() {
	    cx.state.localVars = cx.state.context.vars;
	    cx.state.context = cx.state.context.prev;
	  }
	  function pushlex(type, info) {
	    var result = function() {
	      var state = cx.state, indent = state.indented;
	      if (state.lexical.type == "stat") indent = state.lexical.indented;
	      else for (var outer = state.lexical; outer && outer.type == ")" && outer.align; outer = outer.prev)
	        indent = outer.indented;
	      state.lexical = new JSLexical(indent, cx.stream.column(), type, null, state.lexical, info);
	    };
	    result.lex = true;
	    return result;
	  }
	  function poplex() {
	    var state = cx.state;
	    if (state.lexical.prev) {
	      if (state.lexical.type == ")")
	        state.indented = state.lexical.indented;
	      state.lexical = state.lexical.prev;
	    }
	  }
	  poplex.lex = true;
	
	  function expect(wanted) {
	    function exp(type) {
	      if (type == wanted) return cont();
	      else if (wanted == ";") return pass();
	      else return cont(exp);
	    };
	    return exp;
	  }
	
	  function statement(type, value) {
	    if (type == "var") return cont(pushlex("vardef", value.length), vardef, expect(";"), poplex);
	    if (type == "keyword a") return cont(pushlex("form"), parenExpr, statement, poplex);
	    if (type == "keyword b") return cont(pushlex("form"), statement, poplex);
	    if (type == "{") return cont(pushlex("}"), block, poplex);
	    if (type == ";") return cont();
	    if (type == "if") {
	      if (cx.state.lexical.info == "else" && cx.state.cc[cx.state.cc.length - 1] == poplex)
	        cx.state.cc.pop()();
	      return cont(pushlex("form"), parenExpr, statement, poplex, maybeelse);
	    }
	    if (type == "function") return cont(functiondef);
	    if (type == "for") return cont(pushlex("form"), forspec, statement, poplex);
	    if (type == "variable") return cont(pushlex("stat"), maybelabel);
	    if (type == "switch") return cont(pushlex("form"), parenExpr, pushlex("}", "switch"), expect("{"),
	                                      block, poplex, poplex);
	    if (type == "case") return cont(expression, expect(":"));
	    if (type == "default") return cont(expect(":"));
	    if (type == "catch") return cont(pushlex("form"), pushcontext, expect("("), funarg, expect(")"),
	                                     statement, poplex, popcontext);
	    if (type == "class") return cont(pushlex("form"), className, poplex);
	    if (type == "export") return cont(pushlex("stat"), afterExport, poplex);
	    if (type == "import") return cont(pushlex("stat"), afterImport, poplex);
	    if (type == "module") return cont(pushlex("form"), pattern, pushlex("}"), expect("{"), block, poplex, poplex)
	    if (type == "type") return cont(typeexpr, expect("operator"), typeexpr, expect(";"));
	    if (type == "async") return cont(statement)
	    return pass(pushlex("stat"), expression, expect(";"), poplex);
	  }
	  function expression(type) {
	    return expressionInner(type, false);
	  }
	  function expressionNoComma(type) {
	    return expressionInner(type, true);
	  }
	  function parenExpr(type) {
	    if (type != "(") return pass()
	    return cont(pushlex(")"), expression, expect(")"), poplex)
	  }
	  function expressionInner(type, noComma) {
	    if (cx.state.fatArrowAt == cx.stream.start) {
	      var body = noComma ? arrowBodyNoComma : arrowBody;
	      if (type == "(") return cont(pushcontext, pushlex(")"), commasep(pattern, ")"), poplex, expect("=>"), body, popcontext);
	      else if (type == "variable") return pass(pushcontext, pattern, expect("=>"), body, popcontext);
	    }
	
	    var maybeop = noComma ? maybeoperatorNoComma : maybeoperatorComma;
	    if (atomicTypes.hasOwnProperty(type)) return cont(maybeop);
	    if (type == "function") return cont(functiondef, maybeop);
	    if (type == "class") return cont(pushlex("form"), classExpression, poplex);
	    if (type == "keyword c" || type == "async") return cont(noComma ? maybeexpressionNoComma : maybeexpression);
	    if (type == "(") return cont(pushlex(")"), maybeexpression, expect(")"), poplex, maybeop);
	    if (type == "operator" || type == "spread") return cont(noComma ? expressionNoComma : expression);
	    if (type == "[") return cont(pushlex("]"), arrayLiteral, poplex, maybeop);
	    if (type == "{") return contCommasep(objprop, "}", null, maybeop);
	    if (type == "quasi") return pass(quasi, maybeop);
	    if (type == "new") return cont(maybeTarget(noComma));
	    return cont();
	  }
	  function maybeexpression(type) {
	    if (type.match(/[;\}\)\],]/)) return pass();
	    return pass(expression);
	  }
	  function maybeexpressionNoComma(type) {
	    if (type.match(/[;\}\)\],]/)) return pass();
	    return pass(expressionNoComma);
	  }
	
	  function maybeoperatorComma(type, value) {
	    if (type == ",") return cont(expression);
	    return maybeoperatorNoComma(type, value, false);
	  }
	  function maybeoperatorNoComma(type, value, noComma) {
	    var me = noComma == false ? maybeoperatorComma : maybeoperatorNoComma;
	    var expr = noComma == false ? expression : expressionNoComma;
	    if (type == "=>") return cont(pushcontext, noComma ? arrowBodyNoComma : arrowBody, popcontext);
	    if (type == "operator") {
	      if (/\+\+|--/.test(value)) return cont(me);
	      if (value == "?") return cont(expression, expect(":"), expr);
	      return cont(expr);
	    }
	    if (type == "quasi") { return pass(quasi, me); }
	    if (type == ";") return;
	    if (type == "(") return contCommasep(expressionNoComma, ")", "call", me);
	    if (type == ".") return cont(property, me);
	    if (type == "[") return cont(pushlex("]"), maybeexpression, expect("]"), poplex, me);
	  }
	  function quasi(type, value) {
	    if (type != "quasi") return pass();
	    if (value.slice(value.length - 2) != "${") return cont(quasi);
	    return cont(expression, continueQuasi);
	  }
	  function continueQuasi(type) {
	    if (type == "}") {
	      cx.marked = "string-2";
	      cx.state.tokenize = tokenQuasi;
	      return cont(quasi);
	    }
	  }
	  function arrowBody(type) {
	    findFatArrow(cx.stream, cx.state);
	    return pass(type == "{" ? statement : expression);
	  }
	  function arrowBodyNoComma(type) {
	    findFatArrow(cx.stream, cx.state);
	    return pass(type == "{" ? statement : expressionNoComma);
	  }
	  function maybeTarget(noComma) {
	    return function(type) {
	      if (type == ".") return cont(noComma ? targetNoComma : target);
	      else return pass(noComma ? expressionNoComma : expression);
	    };
	  }
	  function target(_, value) {
	    if (value == "target") { cx.marked = "keyword"; return cont(maybeoperatorComma); }
	  }
	  function targetNoComma(_, value) {
	    if (value == "target") { cx.marked = "keyword"; return cont(maybeoperatorNoComma); }
	  }
	  function maybelabel(type) {
	    if (type == ":") return cont(poplex, statement);
	    return pass(maybeoperatorComma, expect(";"), poplex);
	  }
	  function property(type) {
	    if (type == "variable") {cx.marked = "property"; return cont();}
	  }
	  function objprop(type, value) {
	    if (type == "async") {
	      cx.marked = "property";
	      return cont(objprop);
	    } else if (type == "variable" || cx.style == "keyword") {
	      cx.marked = "property";
	      if (value == "get" || value == "set") return cont(getterSetter);
	      return cont(afterprop);
	    } else if (type == "number" || type == "string") {
	      cx.marked = jsonldMode ? "property" : (cx.style + " property");
	      return cont(afterprop);
	    } else if (type == "jsonld-keyword") {
	      return cont(afterprop);
	    } else if (type == "modifier") {
	      return cont(objprop)
	    } else if (type == "[") {
	      return cont(expression, expect("]"), afterprop);
	    } else if (type == "spread") {
	      return cont(expression);
	    } else if (type == ":") {
	      return pass(afterprop)
	    }
	  }
	  function getterSetter(type) {
	    if (type != "variable") return pass(afterprop);
	    cx.marked = "property";
	    return cont(functiondef);
	  }
	  function afterprop(type) {
	    if (type == ":") return cont(expressionNoComma);
	    if (type == "(") return pass(functiondef);
	  }
	  function commasep(what, end, sep) {
	    function proceed(type, value) {
	      if (sep ? sep.indexOf(type) > -1 : type == ",") {
	        var lex = cx.state.lexical;
	        if (lex.info == "call") lex.pos = (lex.pos || 0) + 1;
	        return cont(function(type, value) {
	          if (type == end || value == end) return pass()
	          return pass(what)
	        }, proceed);
	      }
	      if (type == end || value == end) return cont();
	      return cont(expect(end));
	    }
	    return function(type, value) {
	      if (type == end || value == end) return cont();
	      return pass(what, proceed);
	    };
	  }
	  function contCommasep(what, end, info) {
	    for (var i = 3; i < arguments.length; i++)
	      cx.cc.push(arguments[i]);
	    return cont(pushlex(end, info), commasep(what, end), poplex);
	  }
	  function block(type) {
	    if (type == "}") return cont();
	    return pass(statement, block);
	  }
	  function maybetype(type, value) {
	    if (isTS) {
	      if (type == ":") return cont(typeexpr);
	      if (value == "?") return cont(maybetype);
	    }
	  }
	  function typeexpr(type) {
	    if (type == "variable") {cx.marked = "variable-3"; return cont(afterType);}
	    if (type == "string" || type == "number" || type == "atom") return cont(afterType);
	    if (type == "{") return cont(pushlex("}"), commasep(typeprop, "}", ",;"), poplex)
	    if (type == "(") return cont(commasep(typearg, ")"), maybeReturnType)
	  }
	  function maybeReturnType(type) {
	    if (type == "=>") return cont(typeexpr)
	  }
	  function typeprop(type, value) {
	    if (type == "variable" || cx.style == "keyword") {
	      cx.marked = "property"
	      return cont(typeprop)
	    } else if (value == "?") {
	      return cont(typeprop)
	    } else if (type == ":") {
	      return cont(typeexpr)
	    }
	  }
	  function typearg(type) {
	    if (type == "variable") return cont(typearg)
	    else if (type == ":") return cont(typeexpr)
	  }
	  function afterType(type, value) {
	    if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType)
	    if (value == "|" || type == ".") return cont(typeexpr)
	    if (type == "[") return cont(expect("]"), afterType)
	  }
	  function vardef() {
	    return pass(pattern, maybetype, maybeAssign, vardefCont);
	  }
	  function pattern(type, value) {
	    if (type == "modifier") return cont(pattern)
	    if (type == "variable") { register(value); return cont(); }
	    if (type == "spread") return cont(pattern);
	    if (type == "[") return contCommasep(pattern, "]");
	    if (type == "{") return contCommasep(proppattern, "}");
	  }
	  function proppattern(type, value) {
	    if (type == "variable" && !cx.stream.match(/^\s*:/, false)) {
	      register(value);
	      return cont(maybeAssign);
	    }
	    if (type == "variable") cx.marked = "property";
	    if (type == "spread") return cont(pattern);
	    if (type == "}") return pass();
	    return cont(expect(":"), pattern, maybeAssign);
	  }
	  function maybeAssign(_type, value) {
	    if (value == "=") return cont(expressionNoComma);
	  }
	  function vardefCont(type) {
	    if (type == ",") return cont(vardef);
	  }
	  function maybeelse(type, value) {
	    if (type == "keyword b" && value == "else") return cont(pushlex("form", "else"), statement, poplex);
	  }
	  function forspec(type) {
	    if (type == "(") return cont(pushlex(")"), forspec1, expect(")"), poplex);
	  }
	  function forspec1(type) {
	    if (type == "var") return cont(vardef, expect(";"), forspec2);
	    if (type == ";") return cont(forspec2);
	    if (type == "variable") return cont(formaybeinof);
	    return pass(expression, expect(";"), forspec2);
	  }
	  function formaybeinof(_type, value) {
	    if (value == "in" || value == "of") { cx.marked = "keyword"; return cont(expression); }
	    return cont(maybeoperatorComma, forspec2);
	  }
	  function forspec2(type, value) {
	    if (type == ";") return cont(forspec3);
	    if (value == "in" || value == "of") { cx.marked = "keyword"; return cont(expression); }
	    return pass(expression, expect(";"), forspec3);
	  }
	  function forspec3(type) {
	    if (type != ")") cont(expression);
	  }
	  function functiondef(type, value) {
	    if (value == "*") {cx.marked = "keyword"; return cont(functiondef);}
	    if (type == "variable") {register(value); return cont(functiondef);}
	    if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, maybetype, statement, popcontext);
	  }
	  function funarg(type) {
	    if (type == "spread") return cont(funarg);
	    return pass(pattern, maybetype, maybeAssign);
	  }
	  function classExpression(type, value) {
	    // Class expressions may have an optional name.
	    if (type == "variable") return className(type, value);
	    return classNameAfter(type, value);
	  }
	  function className(type, value) {
	    if (type == "variable") {register(value); return cont(classNameAfter);}
	  }
	  function classNameAfter(type, value) {
	    if (value == "extends" || value == "implements") return cont(isTS ? typeexpr : expression, classNameAfter);
	    if (type == "{") return cont(pushlex("}"), classBody, poplex);
	  }
	  function classBody(type, value) {
	    if (type == "variable" || cx.style == "keyword") {
	      if ((value == "static" || value == "get" || value == "set" ||
	           (isTS && (value == "public" || value == "private" || value == "protected" || value == "readonly" || value == "abstract"))) &&
	          cx.stream.match(/^\s+[\w$\xa1-\uffff]/, false)) {
	        cx.marked = "keyword";
	        return cont(classBody);
	      }
	      cx.marked = "property";
	      return cont(isTS ? classfield : functiondef, classBody);
	    }
	    if (value == "*") {
	      cx.marked = "keyword";
	      return cont(classBody);
	    }
	    if (type == ";") return cont(classBody);
	    if (type == "}") return cont();
	  }
	  function classfield(type, value) {
	    if (value == "?") return cont(classfield)
	    if (type == ":") return cont(typeexpr, maybeAssign)
	    return pass(functiondef)
	  }
	  function afterExport(type, value) {
	    if (value == "*") { cx.marked = "keyword"; return cont(maybeFrom, expect(";")); }
	    if (value == "default") { cx.marked = "keyword"; return cont(expression, expect(";")); }
	    if (type == "{") return cont(commasep(exportField, "}"), maybeFrom, expect(";"));
	    return pass(statement);
	  }
	  function exportField(type, value) {
	    if (value == "as") { cx.marked = "keyword"; return cont(expect("variable")); }
	    if (type == "variable") return pass(expressionNoComma, exportField);
	  }
	  function afterImport(type) {
	    if (type == "string") return cont();
	    return pass(importSpec, maybeMoreImports, maybeFrom);
	  }
	  function importSpec(type, value) {
	    if (type == "{") return contCommasep(importSpec, "}");
	    if (type == "variable") register(value);
	    if (value == "*") cx.marked = "keyword";
	    return cont(maybeAs);
	  }
	  function maybeMoreImports(type) {
	    if (type == ",") return cont(importSpec, maybeMoreImports)
	  }
	  function maybeAs(_type, value) {
	    if (value == "as") { cx.marked = "keyword"; return cont(importSpec); }
	  }
	  function maybeFrom(_type, value) {
	    if (value == "from") { cx.marked = "keyword"; return cont(expression); }
	  }
	  function arrayLiteral(type) {
	    if (type == "]") return cont();
	    return pass(commasep(expressionNoComma, "]"));
	  }
	
	  function isContinuedStatement(state, textAfter) {
	    return state.lastType == "operator" || state.lastType == "," ||
	      isOperatorChar.test(textAfter.charAt(0)) ||
	      /[,.]/.test(textAfter.charAt(0));
	  }
	
	  // Interface
	
	  return {
	    startState: function(basecolumn) {
	      var state = {
	        tokenize: tokenBase,
	        lastType: "sof",
	        cc: [],
	        lexical: new JSLexical((basecolumn || 0) - indentUnit, 0, "block", false),
	        localVars: parserConfig.localVars,
	        context: parserConfig.localVars && {vars: parserConfig.localVars},
	        indented: basecolumn || 0
	      };
	      if (parserConfig.globalVars && typeof parserConfig.globalVars == "object")
	        state.globalVars = parserConfig.globalVars;
	      return state;
	    },
	
	    token: function(stream, state) {
	      if (stream.sol()) {
	        if (!state.lexical.hasOwnProperty("align"))
	          state.lexical.align = false;
	        state.indented = stream.indentation();
	        findFatArrow(stream, state);
	      }
	      if (state.tokenize != tokenComment && stream.eatSpace()) return null;
	      var style = state.tokenize(stream, state);
	      if (type == "comment") return style;
	      state.lastType = type == "operator" && (content == "++" || content == "--") ? "incdec" : type;
	      return parseJS(state, style, type, content, stream);
	    },
	
	    indent: function(state, textAfter) {
	      if (state.tokenize == tokenComment) return CodeMirror.Pass;
	      if (state.tokenize != tokenBase) return 0;
	      var firstChar = textAfter && textAfter.charAt(0), lexical = state.lexical, top
	      // Kludge to prevent 'maybelse' from blocking lexical scope pops
	      if (!/^\s*else\b/.test(textAfter)) for (var i = state.cc.length - 1; i >= 0; --i) {
	        var c = state.cc[i];
	        if (c == poplex) lexical = lexical.prev;
	        else if (c != maybeelse) break;
	      }
	      while ((lexical.type == "stat" || lexical.type == "form") &&
	             (firstChar == "}" || ((top = state.cc[state.cc.length - 1]) &&
	                                   (top == maybeoperatorComma || top == maybeoperatorNoComma) &&
	                                   !/^[,\.=+\-*:?[\(]/.test(textAfter))))
	        lexical = lexical.prev;
	      if (statementIndent && lexical.type == ")" && lexical.prev.type == "stat")
	        lexical = lexical.prev;
	      var type = lexical.type, closing = firstChar == type;
	
	      if (type == "vardef") return lexical.indented + (state.lastType == "operator" || state.lastType == "," ? lexical.info + 1 : 0);
	      else if (type == "form" && firstChar == "{") return lexical.indented;
	      else if (type == "form") return lexical.indented + indentUnit;
	      else if (type == "stat")
	        return lexical.indented + (isContinuedStatement(state, textAfter) ? statementIndent || indentUnit : 0);
	      else if (lexical.info == "switch" && !closing && parserConfig.doubleIndentSwitch != false)
	        return lexical.indented + (/^(?:case|default)\b/.test(textAfter) ? indentUnit : 2 * indentUnit);
	      else if (lexical.align) return lexical.column + (closing ? 0 : 1);
	      else return lexical.indented + (closing ? 0 : indentUnit);
	    },
	
	    electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
	    blockCommentStart: jsonMode ? null : "/*",
	    blockCommentEnd: jsonMode ? null : "*/",
	    lineComment: jsonMode ? null : "//",
	    fold: "brace",
	    closeBrackets: "()[]{}''\"\"``",
	
	    helperType: jsonMode ? "json" : "javascript",
	    jsonldMode: jsonldMode,
	    jsonMode: jsonMode,
	
	    expressionAllowed: expressionAllowed,
	    skipExpression: function(state) {
	      var top = state.cc[state.cc.length - 1]
	      if (top == expression || top == expressionNoComma) state.cc.pop()
	    }
	  };
	});
	
	CodeMirror.registerHelper("wordChars", "javascript", /[\w$]/);
	
	CodeMirror.defineMIME("text/javascript", "javascript");
	CodeMirror.defineMIME("text/ecmascript", "javascript");
	CodeMirror.defineMIME("application/javascript", "javascript");
	CodeMirror.defineMIME("application/x-javascript", "javascript");
	CodeMirror.defineMIME("application/ecmascript", "javascript");
	CodeMirror.defineMIME("application/json", {name: "javascript", json: true});
	CodeMirror.defineMIME("application/x-json", {name: "javascript", json: true});
	CodeMirror.defineMIME("application/ld+json", {name: "javascript", jsonld: true});
	CodeMirror.defineMIME("text/typescript", { name: "javascript", typescript: true });
	CodeMirror.defineMIME("application/typescript", { name: "javascript", typescript: true });
	
	});


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(29)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(15)
	  , createDesc = __webpack_require__(32);
	module.exports = __webpack_require__(13) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(27)
	  , IE8_DOM_DEFINE = __webpack_require__(93)
	  , toPrimitive    = __webpack_require__(56)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(13) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(54)('wks')
	  , uid        = __webpack_require__(33)
	  , Symbol     = __webpack_require__(7).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var OptionRegistry = __webpack_require__(1319);
	// instantiate
	var registry = new OptionRegistry();
	/**
	 * Custom option API
	 *
	 * @param nameOrOptionMap
	 * @returns {any}
	 */
	function optionAPI(nameOrOptionMap) {
	    if (typeof nameOrOptionMap === 'string') {
	        return registry.get(nameOrOptionMap);
	    }
	    else {
	        return registry.registerMany(nameOrOptionMap);
	    }
	}
	module.exports = optionAPI;


/***/ },
/* 18 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// Utility function that allows modes to be combined. The mode given
	// as the base argument takes care of most of the normal mode
	// functionality, but a second (typically simple) mode is used, which
	// can override the style of text. Both modes get to parse all of the
	// text, but when both assign a non-null style to a piece of code, the
	// overlay wins, unless the combine argument was true and not overridden,
	// or state.overlay.combineTokens was true, in which case the styles are
	// combined.
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.overlayMode = function(base, overlay, combine) {
	  return {
	    startState: function() {
	      return {
	        base: CodeMirror.startState(base),
	        overlay: CodeMirror.startState(overlay),
	        basePos: 0, baseCur: null,
	        overlayPos: 0, overlayCur: null,
	        streamSeen: null
	      };
	    },
	    copyState: function(state) {
	      return {
	        base: CodeMirror.copyState(base, state.base),
	        overlay: CodeMirror.copyState(overlay, state.overlay),
	        basePos: state.basePos, baseCur: null,
	        overlayPos: state.overlayPos, overlayCur: null
	      };
	    },
	
	    token: function(stream, state) {
	      if (stream != state.streamSeen ||
	          Math.min(state.basePos, state.overlayPos) < stream.start) {
	        state.streamSeen = stream;
	        state.basePos = state.overlayPos = stream.start;
	      }
	
	      if (stream.start == state.basePos) {
	        state.baseCur = base.token(stream, state.base);
	        state.basePos = stream.pos;
	      }
	      if (stream.start == state.overlayPos) {
	        stream.pos = stream.start;
	        state.overlayCur = overlay.token(stream, state.overlay);
	        state.overlayPos = stream.pos;
	      }
	      stream.pos = Math.min(state.basePos, state.overlayPos);
	
	      // state.overlay.combineTokens always takes precedence over combine,
	      // unless set to null
	      if (state.overlayCur == null) return state.baseCur;
	      else if (state.baseCur != null &&
	               state.overlay.combineTokens ||
	               combine && state.overlay.combineTokens == null)
	        return state.baseCur + " " + state.overlayCur;
	      else return state.overlayCur;
	    },
	
	    indent: base.indent && function(state, textAfter) {
	      return base.indent(state.base, textAfter);
	    },
	    electricChars: base.electricChars,
	
	    innerMode: function(state) { return {state: state.base, mode: base}; },
	
	    blankLine: function(state) {
	      var baseToken, overlayToken;
	      if (base.blankLine) baseToken = base.blankLine(state.base);
	      if (overlay.blankLine) overlayToken = overlay.blankLine(state.overlay);
	
	      return overlayToken == null ?
	        baseToken :
	        (combine && baseToken != null ? baseToken + " " + overlayToken : overlayToken);
	    }
	  };
	};
	
	});


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineSimpleMode = function(name, states) {
	    CodeMirror.defineMode(name, function(config) {
	      return CodeMirror.simpleMode(config, states);
	    });
	  };
	
	  CodeMirror.simpleMode = function(config, states) {
	    ensureState(states, "start");
	    var states_ = {}, meta = states.meta || {}, hasIndentation = false;
	    for (var state in states) if (state != meta && states.hasOwnProperty(state)) {
	      var list = states_[state] = [], orig = states[state];
	      for (var i = 0; i < orig.length; i++) {
	        var data = orig[i];
	        list.push(new Rule(data, states));
	        if (data.indent || data.dedent) hasIndentation = true;
	      }
	    }
	    var mode = {
	      startState: function() {
	        return {state: "start", pending: null,
	                local: null, localState: null,
	                indent: hasIndentation ? [] : null};
	      },
	      copyState: function(state) {
	        var s = {state: state.state, pending: state.pending,
	                 local: state.local, localState: null,
	                 indent: state.indent && state.indent.slice(0)};
	        if (state.localState)
	          s.localState = CodeMirror.copyState(state.local.mode, state.localState);
	        if (state.stack)
	          s.stack = state.stack.slice(0);
	        for (var pers = state.persistentStates; pers; pers = pers.next)
	          s.persistentStates = {mode: pers.mode,
	                                spec: pers.spec,
	                                state: pers.state == state.localState ? s.localState : CodeMirror.copyState(pers.mode, pers.state),
	                                next: s.persistentStates};
	        return s;
	      },
	      token: tokenFunction(states_, config),
	      innerMode: function(state) { return state.local && {mode: state.local.mode, state: state.localState}; },
	      indent: indentFunction(states_, meta)
	    };
	    if (meta) for (var prop in meta) if (meta.hasOwnProperty(prop))
	      mode[prop] = meta[prop];
	    return mode;
	  };
	
	  function ensureState(states, name) {
	    if (!states.hasOwnProperty(name))
	      throw new Error("Undefined state " + name + " in simple mode");
	  }
	
	  function toRegex(val, caret) {
	    if (!val) return /(?:)/;
	    var flags = "";
	    if (val instanceof RegExp) {
	      if (val.ignoreCase) flags = "i";
	      val = val.source;
	    } else {
	      val = String(val);
	    }
	    return new RegExp((caret === false ? "" : "^") + "(?:" + val + ")", flags);
	  }
	
	  function asToken(val) {
	    if (!val) return null;
	    if (typeof val == "string") return val.replace(/\./g, " ");
	    var result = [];
	    for (var i = 0; i < val.length; i++)
	      result.push(val[i] && val[i].replace(/\./g, " "));
	    return result;
	  }
	
	  function Rule(data, states) {
	    if (data.next || data.push) ensureState(states, data.next || data.push);
	    this.regex = toRegex(data.regex);
	    this.token = asToken(data.token);
	    this.data = data;
	  }
	
	  function tokenFunction(states, config) {
	    return function(stream, state) {
	      if (state.pending) {
	        var pend = state.pending.shift();
	        if (state.pending.length == 0) state.pending = null;
	        stream.pos += pend.text.length;
	        return pend.token;
	      }
	
	      if (state.local) {
	        if (state.local.end && stream.match(state.local.end)) {
	          var tok = state.local.endToken || null;
	          state.local = state.localState = null;
	          return tok;
	        } else {
	          var tok = state.local.mode.token(stream, state.localState), m;
	          if (state.local.endScan && (m = state.local.endScan.exec(stream.current())))
	            stream.pos = stream.start + m.index;
	          return tok;
	        }
	      }
	
	      var curState = states[state.state];
	      for (var i = 0; i < curState.length; i++) {
	        var rule = curState[i];
	        var matches = (!rule.data.sol || stream.sol()) && stream.match(rule.regex);
	        if (matches) {
	          if (rule.data.next) {
	            state.state = rule.data.next;
	          } else if (rule.data.push) {
	            (state.stack || (state.stack = [])).push(state.state);
	            state.state = rule.data.push;
	          } else if (rule.data.pop && state.stack && state.stack.length) {
	            state.state = state.stack.pop();
	          }
	
	          if (rule.data.mode)
	            enterLocalMode(config, state, rule.data.mode, rule.token);
	          if (rule.data.indent)
	            state.indent.push(stream.indentation() + config.indentUnit);
	          if (rule.data.dedent)
	            state.indent.pop();
	          if (matches.length > 2) {
	            state.pending = [];
	            for (var j = 2; j < matches.length; j++)
	              if (matches[j])
	                state.pending.push({text: matches[j], token: rule.token[j - 1]});
	            stream.backUp(matches[0].length - (matches[1] ? matches[1].length : 0));
	            return rule.token[0];
	          } else if (rule.token && rule.token.join) {
	            return rule.token[0];
	          } else {
	            return rule.token;
	          }
	        }
	      }
	      stream.next();
	      return null;
	    };
	  }
	
	  function cmp(a, b) {
	    if (a === b) return true;
	    if (!a || typeof a != "object" || !b || typeof b != "object") return false;
	    var props = 0;
	    for (var prop in a) if (a.hasOwnProperty(prop)) {
	      if (!b.hasOwnProperty(prop) || !cmp(a[prop], b[prop])) return false;
	      props++;
	    }
	    for (var prop in b) if (b.hasOwnProperty(prop)) props--;
	    return props == 0;
	  }
	
	  function enterLocalMode(config, state, spec, token) {
	    var pers;
	    if (spec.persistent) for (var p = state.persistentStates; p && !pers; p = p.next)
	      if (spec.spec ? cmp(spec.spec, p.spec) : spec.mode == p.mode) pers = p;
	    var mode = pers ? pers.mode : spec.mode || CodeMirror.getMode(config, spec.spec);
	    var lState = pers ? pers.state : CodeMirror.startState(mode);
	    if (spec.persistent && !pers)
	      state.persistentStates = {mode: mode, spec: spec.spec, state: lState, next: state.persistentStates};
	
	    state.localState = lState;
	    state.local = {mode: mode,
	                   end: spec.end && toRegex(spec.end),
	                   endScan: spec.end && spec.forceEnd !== false && toRegex(spec.end, false),
	                   endToken: token && token.join ? token[token.length - 1] : token};
	  }
	
	  function indexOf(val, arr) {
	    for (var i = 0; i < arr.length; i++) if (arr[i] === val) return true;
	  }
	
	  function indentFunction(states, meta) {
	    return function(state, textAfter, line) {
	      if (state.local && state.local.mode.indent)
	        return state.local.mode.indent(state.localState, textAfter, line);
	      if (state.indent == null || state.local || meta.dontIndentStates && indexOf(state.state, meta.dontIndentStates) > -1)
	        return CodeMirror.Pass;
	
	      var pos = state.indent.length - 1, rules = states[state.state];
	      scan: for (;;) {
	        for (var i = 0; i < rules.length; i++) {
	          var rule = rules[i];
	          if (rule.data.dedent && rule.data.dedentIfLineStart !== false) {
	            var m = rule.regex.exec(textAfter);
	            if (m && m[0]) {
	              pos--;
	              if (rule.next || rule.push) rules = states[rule.next || rule.push];
	              textAfter = textAfter.slice(m[0].length);
	              continue scan;
	            }
	          }
	        }
	        break;
	      }
	      return pos < 0 ? 0 : state.indent[pos];
	    };
	  }
	});


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("css", function(config, parserConfig) {
	  var inline = parserConfig.inline
	  if (!parserConfig.propertyKeywords) parserConfig = CodeMirror.resolveMode("text/css");
	
	  var indentUnit = config.indentUnit,
	      tokenHooks = parserConfig.tokenHooks,
	      documentTypes = parserConfig.documentTypes || {},
	      mediaTypes = parserConfig.mediaTypes || {},
	      mediaFeatures = parserConfig.mediaFeatures || {},
	      mediaValueKeywords = parserConfig.mediaValueKeywords || {},
	      propertyKeywords = parserConfig.propertyKeywords || {},
	      nonStandardPropertyKeywords = parserConfig.nonStandardPropertyKeywords || {},
	      fontProperties = parserConfig.fontProperties || {},
	      counterDescriptors = parserConfig.counterDescriptors || {},
	      colorKeywords = parserConfig.colorKeywords || {},
	      valueKeywords = parserConfig.valueKeywords || {},
	      allowNested = parserConfig.allowNested,
	      supportsAtComponent = parserConfig.supportsAtComponent === true;
	
	  var type, override;
	  function ret(style, tp) { type = tp; return style; }
	
	  // Tokenizers
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    if (tokenHooks[ch]) {
	      var result = tokenHooks[ch](stream, state);
	      if (result !== false) return result;
	    }
	    if (ch == "@") {
	      stream.eatWhile(/[\w\\\-]/);
	      return ret("def", stream.current());
	    } else if (ch == "=" || (ch == "~" || ch == "|") && stream.eat("=")) {
	      return ret(null, "compare");
	    } else if (ch == "\"" || ch == "'") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    } else if (ch == "#") {
	      stream.eatWhile(/[\w\\\-]/);
	      return ret("atom", "hash");
	    } else if (ch == "!") {
	      stream.match(/^\s*\w*/);
	      return ret("keyword", "important");
	    } else if (/\d/.test(ch) || ch == "." && stream.eat(/\d/)) {
	      stream.eatWhile(/[\w.%]/);
	      return ret("number", "unit");
	    } else if (ch === "-") {
	      if (/[\d.]/.test(stream.peek())) {
	        stream.eatWhile(/[\w.%]/);
	        return ret("number", "unit");
	      } else if (stream.match(/^-[\w\\\-]+/)) {
	        stream.eatWhile(/[\w\\\-]/);
	        if (stream.match(/^\s*:/, false))
	          return ret("variable-2", "variable-definition");
	        return ret("variable-2", "variable");
	      } else if (stream.match(/^\w+-/)) {
	        return ret("meta", "meta");
	      }
	    } else if (/[,+>*\/]/.test(ch)) {
	      return ret(null, "select-op");
	    } else if (ch == "." && stream.match(/^-?[_a-z][_a-z0-9-]*/i)) {
	      return ret("qualifier", "qualifier");
	    } else if (/[:;{}\[\]\(\)]/.test(ch)) {
	      return ret(null, ch);
	    } else if ((ch == "u" && stream.match(/rl(-prefix)?\(/)) ||
	               (ch == "d" && stream.match("omain(")) ||
	               (ch == "r" && stream.match("egexp("))) {
	      stream.backUp(1);
	      state.tokenize = tokenParenthesized;
	      return ret("property", "word");
	    } else if (/[\w\\\-]/.test(ch)) {
	      stream.eatWhile(/[\w\\\-]/);
	      return ret("property", "word");
	    } else {
	      return ret(null, null);
	    }
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == quote && !escaped) {
	          if (quote == ")") stream.backUp(1);
	          break;
	        }
	        escaped = !escaped && ch == "\\";
	      }
	      if (ch == quote || !escaped && quote != ")") state.tokenize = null;
	      return ret("string", "string");
	    };
	  }
	
	  function tokenParenthesized(stream, state) {
	    stream.next(); // Must be '('
	    if (!stream.match(/\s*[\"\')]/, false))
	      state.tokenize = tokenString(")");
	    else
	      state.tokenize = null;
	    return ret(null, "(");
	  }
	
	  // Context management
	
	  function Context(type, indent, prev) {
	    this.type = type;
	    this.indent = indent;
	    this.prev = prev;
	  }
	
	  function pushContext(state, stream, type, indent) {
	    state.context = new Context(type, stream.indentation() + (indent === false ? 0 : indentUnit), state.context);
	    return type;
	  }
	
	  function popContext(state) {
	    if (state.context.prev)
	      state.context = state.context.prev;
	    return state.context.type;
	  }
	
	  function pass(type, stream, state) {
	    return states[state.context.type](type, stream, state);
	  }
	  function popAndPass(type, stream, state, n) {
	    for (var i = n || 1; i > 0; i--)
	      state.context = state.context.prev;
	    return pass(type, stream, state);
	  }
	
	  // Parser
	
	  function wordAsValue(stream) {
	    var word = stream.current().toLowerCase();
	    if (valueKeywords.hasOwnProperty(word))
	      override = "atom";
	    else if (colorKeywords.hasOwnProperty(word))
	      override = "keyword";
	    else
	      override = "variable";
	  }
	
	  var states = {};
	
	  states.top = function(type, stream, state) {
	    if (type == "{") {
	      return pushContext(state, stream, "block");
	    } else if (type == "}" && state.context.prev) {
	      return popContext(state);
	    } else if (supportsAtComponent && /@component/.test(type)) {
	      return pushContext(state, stream, "atComponentBlock");
	    } else if (/^@(-moz-)?document$/.test(type)) {
	      return pushContext(state, stream, "documentTypes");
	    } else if (/^@(media|supports|(-moz-)?document|import)$/.test(type)) {
	      return pushContext(state, stream, "atBlock");
	    } else if (/^@(font-face|counter-style)/.test(type)) {
	      state.stateArg = type;
	      return "restricted_atBlock_before";
	    } else if (/^@(-(moz|ms|o|webkit)-)?keyframes$/.test(type)) {
	      return "keyframes";
	    } else if (type && type.charAt(0) == "@") {
	      return pushContext(state, stream, "at");
	    } else if (type == "hash") {
	      override = "builtin";
	    } else if (type == "word") {
	      override = "tag";
	    } else if (type == "variable-definition") {
	      return "maybeprop";
	    } else if (type == "interpolation") {
	      return pushContext(state, stream, "interpolation");
	    } else if (type == ":") {
	      return "pseudo";
	    } else if (allowNested && type == "(") {
	      return pushContext(state, stream, "parens");
	    }
	    return state.context.type;
	  };
	
	  states.block = function(type, stream, state) {
	    if (type == "word") {
	      var word = stream.current().toLowerCase();
	      if (propertyKeywords.hasOwnProperty(word)) {
	        override = "property";
	        return "maybeprop";
	      } else if (nonStandardPropertyKeywords.hasOwnProperty(word)) {
	        override = "string-2";
	        return "maybeprop";
	      } else if (allowNested) {
	        override = stream.match(/^\s*:(?:\s|$)/, false) ? "property" : "tag";
	        return "block";
	      } else {
	        override += " error";
	        return "maybeprop";
	      }
	    } else if (type == "meta") {
	      return "block";
	    } else if (!allowNested && (type == "hash" || type == "qualifier")) {
	      override = "error";
	      return "block";
	    } else {
	      return states.top(type, stream, state);
	    }
	  };
	
	  states.maybeprop = function(type, stream, state) {
	    if (type == ":") return pushContext(state, stream, "prop");
	    return pass(type, stream, state);
	  };
	
	  states.prop = function(type, stream, state) {
	    if (type == ";") return popContext(state);
	    if (type == "{" && allowNested) return pushContext(state, stream, "propBlock");
	    if (type == "}" || type == "{") return popAndPass(type, stream, state);
	    if (type == "(") return pushContext(state, stream, "parens");
	
	    if (type == "hash" && !/^#([0-9a-fA-f]{3,4}|[0-9a-fA-f]{6}|[0-9a-fA-f]{8})$/.test(stream.current())) {
	      override += " error";
	    } else if (type == "word") {
	      wordAsValue(stream);
	    } else if (type == "interpolation") {
	      return pushContext(state, stream, "interpolation");
	    }
	    return "prop";
	  };
	
	  states.propBlock = function(type, _stream, state) {
	    if (type == "}") return popContext(state);
	    if (type == "word") { override = "property"; return "maybeprop"; }
	    return state.context.type;
	  };
	
	  states.parens = function(type, stream, state) {
	    if (type == "{" || type == "}") return popAndPass(type, stream, state);
	    if (type == ")") return popContext(state);
	    if (type == "(") return pushContext(state, stream, "parens");
	    if (type == "interpolation") return pushContext(state, stream, "interpolation");
	    if (type == "word") wordAsValue(stream);
	    return "parens";
	  };
	
	  states.pseudo = function(type, stream, state) {
	    if (type == "word") {
	      override = "variable-3";
	      return state.context.type;
	    }
	    return pass(type, stream, state);
	  };
	
	  states.documentTypes = function(type, stream, state) {
	    if (type == "word" && documentTypes.hasOwnProperty(stream.current())) {
	      override = "tag";
	      return state.context.type;
	    } else {
	      return states.atBlock(type, stream, state);
	    }
	  };
	
	  states.atBlock = function(type, stream, state) {
	    if (type == "(") return pushContext(state, stream, "atBlock_parens");
	    if (type == "}" || type == ";") return popAndPass(type, stream, state);
	    if (type == "{") return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top");
	
	    if (type == "interpolation") return pushContext(state, stream, "interpolation");
	
	    if (type == "word") {
	      var word = stream.current().toLowerCase();
	      if (word == "only" || word == "not" || word == "and" || word == "or")
	        override = "keyword";
	      else if (mediaTypes.hasOwnProperty(word))
	        override = "attribute";
	      else if (mediaFeatures.hasOwnProperty(word))
	        override = "property";
	      else if (mediaValueKeywords.hasOwnProperty(word))
	        override = "keyword";
	      else if (propertyKeywords.hasOwnProperty(word))
	        override = "property";
	      else if (nonStandardPropertyKeywords.hasOwnProperty(word))
	        override = "string-2";
	      else if (valueKeywords.hasOwnProperty(word))
	        override = "atom";
	      else if (colorKeywords.hasOwnProperty(word))
	        override = "keyword";
	      else
	        override = "error";
	    }
	    return state.context.type;
	  };
	
	  states.atComponentBlock = function(type, stream, state) {
	    if (type == "}")
	      return popAndPass(type, stream, state);
	    if (type == "{")
	      return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top", false);
	    if (type == "word")
	      override = "error";
	    return state.context.type;
	  };
	
	  states.atBlock_parens = function(type, stream, state) {
	    if (type == ")") return popContext(state);
	    if (type == "{" || type == "}") return popAndPass(type, stream, state, 2);
	    return states.atBlock(type, stream, state);
	  };
	
	  states.restricted_atBlock_before = function(type, stream, state) {
	    if (type == "{")
	      return pushContext(state, stream, "restricted_atBlock");
	    if (type == "word" && state.stateArg == "@counter-style") {
	      override = "variable";
	      return "restricted_atBlock_before";
	    }
	    return pass(type, stream, state);
	  };
	
	  states.restricted_atBlock = function(type, stream, state) {
	    if (type == "}") {
	      state.stateArg = null;
	      return popContext(state);
	    }
	    if (type == "word") {
	      if ((state.stateArg == "@font-face" && !fontProperties.hasOwnProperty(stream.current().toLowerCase())) ||
	          (state.stateArg == "@counter-style" && !counterDescriptors.hasOwnProperty(stream.current().toLowerCase())))
	        override = "error";
	      else
	        override = "property";
	      return "maybeprop";
	    }
	    return "restricted_atBlock";
	  };
	
	  states.keyframes = function(type, stream, state) {
	    if (type == "word") { override = "variable"; return "keyframes"; }
	    if (type == "{") return pushContext(state, stream, "top");
	    return pass(type, stream, state);
	  };
	
	  states.at = function(type, stream, state) {
	    if (type == ";") return popContext(state);
	    if (type == "{" || type == "}") return popAndPass(type, stream, state);
	    if (type == "word") override = "tag";
	    else if (type == "hash") override = "builtin";
	    return "at";
	  };
	
	  states.interpolation = function(type, stream, state) {
	    if (type == "}") return popContext(state);
	    if (type == "{" || type == ";") return popAndPass(type, stream, state);
	    if (type == "word") override = "variable";
	    else if (type != "variable" && type != "(" && type != ")") override = "error";
	    return "interpolation";
	  };
	
	  return {
	    startState: function(base) {
	      return {tokenize: null,
	              state: inline ? "block" : "top",
	              stateArg: null,
	              context: new Context(inline ? "block" : "top", base || 0, null)};
	    },
	
	    token: function(stream, state) {
	      if (!state.tokenize && stream.eatSpace()) return null;
	      var style = (state.tokenize || tokenBase)(stream, state);
	      if (style && typeof style == "object") {
	        type = style[1];
	        style = style[0];
	      }
	      override = style;
	      state.state = states[state.state](type, stream, state);
	      return override;
	    },
	
	    indent: function(state, textAfter) {
	      var cx = state.context, ch = textAfter && textAfter.charAt(0);
	      var indent = cx.indent;
	      if (cx.type == "prop" && (ch == "}" || ch == ")")) cx = cx.prev;
	      if (cx.prev) {
	        if (ch == "}" && (cx.type == "block" || cx.type == "top" ||
	                          cx.type == "interpolation" || cx.type == "restricted_atBlock")) {
	          // Resume indentation from parent context.
	          cx = cx.prev;
	          indent = cx.indent;
	        } else if (ch == ")" && (cx.type == "parens" || cx.type == "atBlock_parens") ||
	            ch == "{" && (cx.type == "at" || cx.type == "atBlock")) {
	          // Dedent relative to current context.
	          indent = Math.max(0, cx.indent - indentUnit);
	          cx = cx.prev;
	        }
	      }
	      return indent;
	    },
	
	    electricChars: "}",
	    blockCommentStart: "/*",
	    blockCommentEnd: "*/",
	    fold: "brace"
	  };
	});
	
	  function keySet(array) {
	    var keys = {};
	    for (var i = 0; i < array.length; ++i) {
	      keys[array[i].toLowerCase()] = true;
	    }
	    return keys;
	  }
	
	  var documentTypes_ = [
	    "domain", "regexp", "url", "url-prefix"
	  ], documentTypes = keySet(documentTypes_);
	
	  var mediaTypes_ = [
	    "all", "aural", "braille", "handheld", "print", "projection", "screen",
	    "tty", "tv", "embossed"
	  ], mediaTypes = keySet(mediaTypes_);
	
	  var mediaFeatures_ = [
	    "width", "min-width", "max-width", "height", "min-height", "max-height",
	    "device-width", "min-device-width", "max-device-width", "device-height",
	    "min-device-height", "max-device-height", "aspect-ratio",
	    "min-aspect-ratio", "max-aspect-ratio", "device-aspect-ratio",
	    "min-device-aspect-ratio", "max-device-aspect-ratio", "color", "min-color",
	    "max-color", "color-index", "min-color-index", "max-color-index",
	    "monochrome", "min-monochrome", "max-monochrome", "resolution",
	    "min-resolution", "max-resolution", "scan", "grid", "orientation",
	    "device-pixel-ratio", "min-device-pixel-ratio", "max-device-pixel-ratio",
	    "pointer", "any-pointer", "hover", "any-hover"
	  ], mediaFeatures = keySet(mediaFeatures_);
	
	  var mediaValueKeywords_ = [
	    "landscape", "portrait", "none", "coarse", "fine", "on-demand", "hover",
	    "interlace", "progressive"
	  ], mediaValueKeywords = keySet(mediaValueKeywords_);
	
	  var propertyKeywords_ = [
	    "align-content", "align-items", "align-self", "alignment-adjust",
	    "alignment-baseline", "anchor-point", "animation", "animation-delay",
	    "animation-direction", "animation-duration", "animation-fill-mode",
	    "animation-iteration-count", "animation-name", "animation-play-state",
	    "animation-timing-function", "appearance", "azimuth", "backface-visibility",
	    "background", "background-attachment", "background-blend-mode", "background-clip",
	    "background-color", "background-image", "background-origin", "background-position",
	    "background-repeat", "background-size", "baseline-shift", "binding",
	    "bleed", "bookmark-label", "bookmark-level", "bookmark-state",
	    "bookmark-target", "border", "border-bottom", "border-bottom-color",
	    "border-bottom-left-radius", "border-bottom-right-radius",
	    "border-bottom-style", "border-bottom-width", "border-collapse",
	    "border-color", "border-image", "border-image-outset",
	    "border-image-repeat", "border-image-slice", "border-image-source",
	    "border-image-width", "border-left", "border-left-color",
	    "border-left-style", "border-left-width", "border-radius", "border-right",
	    "border-right-color", "border-right-style", "border-right-width",
	    "border-spacing", "border-style", "border-top", "border-top-color",
	    "border-top-left-radius", "border-top-right-radius", "border-top-style",
	    "border-top-width", "border-width", "bottom", "box-decoration-break",
	    "box-shadow", "box-sizing", "break-after", "break-before", "break-inside",
	    "caption-side", "clear", "clip", "color", "color-profile", "column-count",
	    "column-fill", "column-gap", "column-rule", "column-rule-color",
	    "column-rule-style", "column-rule-width", "column-span", "column-width",
	    "columns", "content", "counter-increment", "counter-reset", "crop", "cue",
	    "cue-after", "cue-before", "cursor", "direction", "display",
	    "dominant-baseline", "drop-initial-after-adjust",
	    "drop-initial-after-align", "drop-initial-before-adjust",
	    "drop-initial-before-align", "drop-initial-size", "drop-initial-value",
	    "elevation", "empty-cells", "fit", "fit-position", "flex", "flex-basis",
	    "flex-direction", "flex-flow", "flex-grow", "flex-shrink", "flex-wrap",
	    "float", "float-offset", "flow-from", "flow-into", "font", "font-feature-settings",
	    "font-family", "font-kerning", "font-language-override", "font-size", "font-size-adjust",
	    "font-stretch", "font-style", "font-synthesis", "font-variant",
	    "font-variant-alternates", "font-variant-caps", "font-variant-east-asian",
	    "font-variant-ligatures", "font-variant-numeric", "font-variant-position",
	    "font-weight", "grid", "grid-area", "grid-auto-columns", "grid-auto-flow",
	    "grid-auto-rows", "grid-column", "grid-column-end", "grid-column-gap",
	    "grid-column-start", "grid-gap", "grid-row", "grid-row-end", "grid-row-gap",
	    "grid-row-start", "grid-template", "grid-template-areas", "grid-template-columns",
	    "grid-template-rows", "hanging-punctuation", "height", "hyphens",
	    "icon", "image-orientation", "image-rendering", "image-resolution",
	    "inline-box-align", "justify-content", "left", "letter-spacing",
	    "line-break", "line-height", "line-stacking", "line-stacking-ruby",
	    "line-stacking-shift", "line-stacking-strategy", "list-style",
	    "list-style-image", "list-style-position", "list-style-type", "margin",
	    "margin-bottom", "margin-left", "margin-right", "margin-top",
	    "marks", "marquee-direction", "marquee-loop",
	    "marquee-play-count", "marquee-speed", "marquee-style", "max-height",
	    "max-width", "min-height", "min-width", "move-to", "nav-down", "nav-index",
	    "nav-left", "nav-right", "nav-up", "object-fit", "object-position",
	    "opacity", "order", "orphans", "outline",
	    "outline-color", "outline-offset", "outline-style", "outline-width",
	    "overflow", "overflow-style", "overflow-wrap", "overflow-x", "overflow-y",
	    "padding", "padding-bottom", "padding-left", "padding-right", "padding-top",
	    "page", "page-break-after", "page-break-before", "page-break-inside",
	    "page-policy", "pause", "pause-after", "pause-before", "perspective",
	    "perspective-origin", "pitch", "pitch-range", "play-during", "position",
	    "presentation-level", "punctuation-trim", "quotes", "region-break-after",
	    "region-break-before", "region-break-inside", "region-fragment",
	    "rendering-intent", "resize", "rest", "rest-after", "rest-before", "richness",
	    "right", "rotation", "rotation-point", "ruby-align", "ruby-overhang",
	    "ruby-position", "ruby-span", "shape-image-threshold", "shape-inside", "shape-margin",
	    "shape-outside", "size", "speak", "speak-as", "speak-header",
	    "speak-numeral", "speak-punctuation", "speech-rate", "stress", "string-set",
	    "tab-size", "table-layout", "target", "target-name", "target-new",
	    "target-position", "text-align", "text-align-last", "text-decoration",
	    "text-decoration-color", "text-decoration-line", "text-decoration-skip",
	    "text-decoration-style", "text-emphasis", "text-emphasis-color",
	    "text-emphasis-position", "text-emphasis-style", "text-height",
	    "text-indent", "text-justify", "text-outline", "text-overflow", "text-shadow",
	    "text-size-adjust", "text-space-collapse", "text-transform", "text-underline-position",
	    "text-wrap", "top", "transform", "transform-origin", "transform-style",
	    "transition", "transition-delay", "transition-duration",
	    "transition-property", "transition-timing-function", "unicode-bidi",
	    "user-select", "vertical-align", "visibility", "voice-balance", "voice-duration",
	    "voice-family", "voice-pitch", "voice-range", "voice-rate", "voice-stress",
	    "voice-volume", "volume", "white-space", "widows", "width", "will-change", "word-break",
	    "word-spacing", "word-wrap", "z-index",
	    // SVG-specific
	    "clip-path", "clip-rule", "mask", "enable-background", "filter", "flood-color",
	    "flood-opacity", "lighting-color", "stop-color", "stop-opacity", "pointer-events",
	    "color-interpolation", "color-interpolation-filters",
	    "color-rendering", "fill", "fill-opacity", "fill-rule", "image-rendering",
	    "marker", "marker-end", "marker-mid", "marker-start", "shape-rendering", "stroke",
	    "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin",
	    "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-rendering",
	    "baseline-shift", "dominant-baseline", "glyph-orientation-horizontal",
	    "glyph-orientation-vertical", "text-anchor", "writing-mode"
	  ], propertyKeywords = keySet(propertyKeywords_);
	
	  var nonStandardPropertyKeywords_ = [
	    "scrollbar-arrow-color", "scrollbar-base-color", "scrollbar-dark-shadow-color",
	    "scrollbar-face-color", "scrollbar-highlight-color", "scrollbar-shadow-color",
	    "scrollbar-3d-light-color", "scrollbar-track-color", "shape-inside",
	    "searchfield-cancel-button", "searchfield-decoration", "searchfield-results-button",
	    "searchfield-results-decoration", "zoom"
	  ], nonStandardPropertyKeywords = keySet(nonStandardPropertyKeywords_);
	
	  var fontProperties_ = [
	    "font-family", "src", "unicode-range", "font-variant", "font-feature-settings",
	    "font-stretch", "font-weight", "font-style"
	  ], fontProperties = keySet(fontProperties_);
	
	  var counterDescriptors_ = [
	    "additive-symbols", "fallback", "negative", "pad", "prefix", "range",
	    "speak-as", "suffix", "symbols", "system"
	  ], counterDescriptors = keySet(counterDescriptors_);
	
	  var colorKeywords_ = [
	    "aliceblue", "antiquewhite", "aqua", "aquamarine", "azure", "beige",
	    "bisque", "black", "blanchedalmond", "blue", "blueviolet", "brown",
	    "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue",
	    "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod",
	    "darkgray", "darkgreen", "darkkhaki", "darkmagenta", "darkolivegreen",
	    "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen",
	    "darkslateblue", "darkslategray", "darkturquoise", "darkviolet",
	    "deeppink", "deepskyblue", "dimgray", "dodgerblue", "firebrick",
	    "floralwhite", "forestgreen", "fuchsia", "gainsboro", "ghostwhite",
	    "gold", "goldenrod", "gray", "grey", "green", "greenyellow", "honeydew",
	    "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender",
	    "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral",
	    "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightpink",
	    "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray",
	    "lightsteelblue", "lightyellow", "lime", "limegreen", "linen", "magenta",
	    "maroon", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple",
	    "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise",
	    "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin",
	    "navajowhite", "navy", "oldlace", "olive", "olivedrab", "orange", "orangered",
	    "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred",
	    "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue",
	    "purple", "rebeccapurple", "red", "rosybrown", "royalblue", "saddlebrown",
	    "salmon", "sandybrown", "seagreen", "seashell", "sienna", "silver", "skyblue",
	    "slateblue", "slategray", "snow", "springgreen", "steelblue", "tan",
	    "teal", "thistle", "tomato", "turquoise", "violet", "wheat", "white",
	    "whitesmoke", "yellow", "yellowgreen"
	  ], colorKeywords = keySet(colorKeywords_);
	
	  var valueKeywords_ = [
	    "above", "absolute", "activeborder", "additive", "activecaption", "afar",
	    "after-white-space", "ahead", "alias", "all", "all-scroll", "alphabetic", "alternate",
	    "always", "amharic", "amharic-abegede", "antialiased", "appworkspace",
	    "arabic-indic", "armenian", "asterisks", "attr", "auto", "auto-flow", "avoid", "avoid-column", "avoid-page",
	    "avoid-region", "background", "backwards", "baseline", "below", "bidi-override", "binary",
	    "bengali", "blink", "block", "block-axis", "bold", "bolder", "border", "border-box",
	    "both", "bottom", "break", "break-all", "break-word", "bullets", "button", "button-bevel",
	    "buttonface", "buttonhighlight", "buttonshadow", "buttontext", "calc", "cambodian",
	    "capitalize", "caps-lock-indicator", "caption", "captiontext", "caret",
	    "cell", "center", "checkbox", "circle", "cjk-decimal", "cjk-earthly-branch",
	    "cjk-heavenly-stem", "cjk-ideographic", "clear", "clip", "close-quote",
	    "col-resize", "collapse", "color", "color-burn", "color-dodge", "column", "column-reverse",
	    "compact", "condensed", "contain", "content", "contents",
	    "content-box", "context-menu", "continuous", "copy", "counter", "counters", "cover", "crop",
	    "cross", "crosshair", "currentcolor", "cursive", "cyclic", "darken", "dashed", "decimal",
	    "decimal-leading-zero", "default", "default-button", "dense", "destination-atop",
	    "destination-in", "destination-out", "destination-over", "devanagari", "difference",
	    "disc", "discard", "disclosure-closed", "disclosure-open", "document",
	    "dot-dash", "dot-dot-dash",
	    "dotted", "double", "down", "e-resize", "ease", "ease-in", "ease-in-out", "ease-out",
	    "element", "ellipse", "ellipsis", "embed", "end", "ethiopic", "ethiopic-abegede",
	    "ethiopic-abegede-am-et", "ethiopic-abegede-gez", "ethiopic-abegede-ti-er",
	    "ethiopic-abegede-ti-et", "ethiopic-halehame-aa-er",
	    "ethiopic-halehame-aa-et", "ethiopic-halehame-am-et",
	    "ethiopic-halehame-gez", "ethiopic-halehame-om-et",
	    "ethiopic-halehame-sid-et", "ethiopic-halehame-so-et",
	    "ethiopic-halehame-ti-er", "ethiopic-halehame-ti-et", "ethiopic-halehame-tig",
	    "ethiopic-numeric", "ew-resize", "exclusion", "expanded", "extends", "extra-condensed",
	    "extra-expanded", "fantasy", "fast", "fill", "fixed", "flat", "flex", "flex-end", "flex-start", "footnotes",
	    "forwards", "from", "geometricPrecision", "georgian", "graytext", "grid", "groove",
	    "gujarati", "gurmukhi", "hand", "hangul", "hangul-consonant", "hard-light", "hebrew",
	    "help", "hidden", "hide", "higher", "highlight", "highlighttext",
	    "hiragana", "hiragana-iroha", "horizontal", "hsl", "hsla", "hue", "icon", "ignore",
	    "inactiveborder", "inactivecaption", "inactivecaptiontext", "infinite",
	    "infobackground", "infotext", "inherit", "initial", "inline", "inline-axis",
	    "inline-block", "inline-flex", "inline-grid", "inline-table", "inset", "inside", "intrinsic", "invert",
	    "italic", "japanese-formal", "japanese-informal", "justify", "kannada",
	    "katakana", "katakana-iroha", "keep-all", "khmer",
	    "korean-hangul-formal", "korean-hanja-formal", "korean-hanja-informal",
	    "landscape", "lao", "large", "larger", "left", "level", "lighter", "lighten",
	    "line-through", "linear", "linear-gradient", "lines", "list-item", "listbox", "listitem",
	    "local", "logical", "loud", "lower", "lower-alpha", "lower-armenian",
	    "lower-greek", "lower-hexadecimal", "lower-latin", "lower-norwegian",
	    "lower-roman", "lowercase", "ltr", "luminosity", "malayalam", "match", "matrix", "matrix3d",
	    "media-controls-background", "media-current-time-display",
	    "media-fullscreen-button", "media-mute-button", "media-play-button",
	    "media-return-to-realtime-button", "media-rewind-button",
	    "media-seek-back-button", "media-seek-forward-button", "media-slider",
	    "media-sliderthumb", "media-time-remaining-display", "media-volume-slider",
	    "media-volume-slider-container", "media-volume-sliderthumb", "medium",
	    "menu", "menulist", "menulist-button", "menulist-text",
	    "menulist-textfield", "menutext", "message-box", "middle", "min-intrinsic",
	    "mix", "mongolian", "monospace", "move", "multiple", "multiply", "myanmar", "n-resize",
	    "narrower", "ne-resize", "nesw-resize", "no-close-quote", "no-drop",
	    "no-open-quote", "no-repeat", "none", "normal", "not-allowed", "nowrap",
	    "ns-resize", "numbers", "numeric", "nw-resize", "nwse-resize", "oblique", "octal", "opacity", "open-quote",
	    "optimizeLegibility", "optimizeSpeed", "oriya", "oromo", "outset",
	    "outside", "outside-shape", "overlay", "overline", "padding", "padding-box",
	    "painted", "page", "paused", "persian", "perspective", "plus-darker", "plus-lighter",
	    "pointer", "polygon", "portrait", "pre", "pre-line", "pre-wrap", "preserve-3d",
	    "progress", "push-button", "radial-gradient", "radio", "read-only",
	    "read-write", "read-write-plaintext-only", "rectangle", "region",
	    "relative", "repeat", "repeating-linear-gradient",
	    "repeating-radial-gradient", "repeat-x", "repeat-y", "reset", "reverse",
	    "rgb", "rgba", "ridge", "right", "rotate", "rotate3d", "rotateX", "rotateY",
	    "rotateZ", "round", "row", "row-resize", "row-reverse", "rtl", "run-in", "running",
	    "s-resize", "sans-serif", "saturation", "scale", "scale3d", "scaleX", "scaleY", "scaleZ", "screen",
	    "scroll", "scrollbar", "scroll-position", "se-resize", "searchfield",
	    "searchfield-cancel-button", "searchfield-decoration",
	    "searchfield-results-button", "searchfield-results-decoration",
	    "semi-condensed", "semi-expanded", "separate", "serif", "show", "sidama",
	    "simp-chinese-formal", "simp-chinese-informal", "single",
	    "skew", "skewX", "skewY", "skip-white-space", "slide", "slider-horizontal",
	    "slider-vertical", "sliderthumb-horizontal", "sliderthumb-vertical", "slow",
	    "small", "small-caps", "small-caption", "smaller", "soft-light", "solid", "somali",
	    "source-atop", "source-in", "source-out", "source-over", "space", "space-around", "space-between", "spell-out", "square",
	    "square-button", "start", "static", "status-bar", "stretch", "stroke", "sub",
	    "subpixel-antialiased", "super", "sw-resize", "symbolic", "symbols", "table",
	    "table-caption", "table-cell", "table-column", "table-column-group",
	    "table-footer-group", "table-header-group", "table-row", "table-row-group",
	    "tamil",
	    "telugu", "text", "text-bottom", "text-top", "textarea", "textfield", "thai",
	    "thick", "thin", "threeddarkshadow", "threedface", "threedhighlight",
	    "threedlightshadow", "threedshadow", "tibetan", "tigre", "tigrinya-er",
	    "tigrinya-er-abegede", "tigrinya-et", "tigrinya-et-abegede", "to", "top",
	    "trad-chinese-formal", "trad-chinese-informal", "transform",
	    "translate", "translate3d", "translateX", "translateY", "translateZ",
	    "transparent", "ultra-condensed", "ultra-expanded", "underline", "unset", "up",
	    "upper-alpha", "upper-armenian", "upper-greek", "upper-hexadecimal",
	    "upper-latin", "upper-norwegian", "upper-roman", "uppercase", "urdu", "url",
	    "var", "vertical", "vertical-text", "visible", "visibleFill", "visiblePainted",
	    "visibleStroke", "visual", "w-resize", "wait", "wave", "wider",
	    "window", "windowframe", "windowtext", "words", "wrap", "wrap-reverse", "x-large", "x-small", "xor",
	    "xx-large", "xx-small"
	  ], valueKeywords = keySet(valueKeywords_);
	
	  var allWords = documentTypes_.concat(mediaTypes_).concat(mediaFeatures_).concat(mediaValueKeywords_)
	    .concat(propertyKeywords_).concat(nonStandardPropertyKeywords_).concat(colorKeywords_)
	    .concat(valueKeywords_);
	  CodeMirror.registerHelper("hintWords", "css", allWords);
	
	  function tokenCComment(stream, state) {
	    var maybeEnd = false, ch;
	    while ((ch = stream.next()) != null) {
	      if (maybeEnd && ch == "/") {
	        state.tokenize = null;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return ["comment", "comment"];
	  }
	
	  CodeMirror.defineMIME("text/css", {
	    documentTypes: documentTypes,
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    fontProperties: fontProperties,
	    counterDescriptors: counterDescriptors,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    tokenHooks: {
	      "/": function(stream, state) {
	        if (!stream.eat("*")) return false;
	        state.tokenize = tokenCComment;
	        return tokenCComment(stream, state);
	      }
	    },
	    name: "css"
	  });
	
	  CodeMirror.defineMIME("text/x-scss", {
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    fontProperties: fontProperties,
	    allowNested: true,
	    tokenHooks: {
	      "/": function(stream, state) {
	        if (stream.eat("/")) {
	          stream.skipToEnd();
	          return ["comment", "comment"];
	        } else if (stream.eat("*")) {
	          state.tokenize = tokenCComment;
	          return tokenCComment(stream, state);
	        } else {
	          return ["operator", "operator"];
	        }
	      },
	      ":": function(stream) {
	        if (stream.match(/\s*\{/))
	          return [null, "{"];
	        return false;
	      },
	      "$": function(stream) {
	        stream.match(/^[\w-]+/);
	        if (stream.match(/^\s*:/, false))
	          return ["variable-2", "variable-definition"];
	        return ["variable-2", "variable"];
	      },
	      "#": function(stream) {
	        if (!stream.eat("{")) return false;
	        return [null, "interpolation"];
	      }
	    },
	    name: "css",
	    helperType: "scss"
	  });
	
	  CodeMirror.defineMIME("text/x-less", {
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    fontProperties: fontProperties,
	    allowNested: true,
	    tokenHooks: {
	      "/": function(stream, state) {
	        if (stream.eat("/")) {
	          stream.skipToEnd();
	          return ["comment", "comment"];
	        } else if (stream.eat("*")) {
	          state.tokenize = tokenCComment;
	          return tokenCComment(stream, state);
	        } else {
	          return ["operator", "operator"];
	        }
	      },
	      "@": function(stream) {
	        if (stream.eat("{")) return [null, "interpolation"];
	        if (stream.match(/^(charset|document|font-face|import|(-(moz|ms|o|webkit)-)?keyframes|media|namespace|page|supports)\b/, false)) return false;
	        stream.eatWhile(/[\w\\\-]/);
	        if (stream.match(/^\s*:/, false))
	          return ["variable-2", "variable-definition"];
	        return ["variable-2", "variable"];
	      },
	      "&": function() {
	        return ["atom", "atom"];
	      }
	    },
	    name: "css",
	    helperType: "less"
	  });
	
	  CodeMirror.defineMIME("text/x-gss", {
	    documentTypes: documentTypes,
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    fontProperties: fontProperties,
	    counterDescriptors: counterDescriptors,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    supportsAtComponent: true,
	    tokenHooks: {
	      "/": function(stream, state) {
	        if (!stream.eat("*")) return false;
	        state.tokenize = tokenCComment;
	        return tokenCComment(stream, state);
	      }
	    },
	    name: "css",
	    helperType: "gss"
	  });
	
	});


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	var htmlConfig = {
	  autoSelfClosers: {'area': true, 'base': true, 'br': true, 'col': true, 'command': true,
	                    'embed': true, 'frame': true, 'hr': true, 'img': true, 'input': true,
	                    'keygen': true, 'link': true, 'meta': true, 'param': true, 'source': true,
	                    'track': true, 'wbr': true, 'menuitem': true},
	  implicitlyClosed: {'dd': true, 'li': true, 'optgroup': true, 'option': true, 'p': true,
	                     'rp': true, 'rt': true, 'tbody': true, 'td': true, 'tfoot': true,
	                     'th': true, 'tr': true},
	  contextGrabbers: {
	    'dd': {'dd': true, 'dt': true},
	    'dt': {'dd': true, 'dt': true},
	    'li': {'li': true},
	    'option': {'option': true, 'optgroup': true},
	    'optgroup': {'optgroup': true},
	    'p': {'address': true, 'article': true, 'aside': true, 'blockquote': true, 'dir': true,
	          'div': true, 'dl': true, 'fieldset': true, 'footer': true, 'form': true,
	          'h1': true, 'h2': true, 'h3': true, 'h4': true, 'h5': true, 'h6': true,
	          'header': true, 'hgroup': true, 'hr': true, 'menu': true, 'nav': true, 'ol': true,
	          'p': true, 'pre': true, 'section': true, 'table': true, 'ul': true},
	    'rp': {'rp': true, 'rt': true},
	    'rt': {'rp': true, 'rt': true},
	    'tbody': {'tbody': true, 'tfoot': true},
	    'td': {'td': true, 'th': true},
	    'tfoot': {'tbody': true},
	    'th': {'td': true, 'th': true},
	    'thead': {'tbody': true, 'tfoot': true},
	    'tr': {'tr': true}
	  },
	  doNotIndent: {"pre": true},
	  allowUnquoted: true,
	  allowMissing: true,
	  caseFold: true
	}
	
	var xmlConfig = {
	  autoSelfClosers: {},
	  implicitlyClosed: {},
	  contextGrabbers: {},
	  doNotIndent: {},
	  allowUnquoted: false,
	  allowMissing: false,
	  caseFold: false
	}
	
	CodeMirror.defineMode("xml", function(editorConf, config_) {
	  var indentUnit = editorConf.indentUnit
	  var config = {}
	  var defaults = config_.htmlMode ? htmlConfig : xmlConfig
	  for (var prop in defaults) config[prop] = defaults[prop]
	  for (var prop in config_) config[prop] = config_[prop]
	
	  // Return variables for tokenizers
	  var type, setStyle;
	
	  function inText(stream, state) {
	    function chain(parser) {
	      state.tokenize = parser;
	      return parser(stream, state);
	    }
	
	    var ch = stream.next();
	    if (ch == "<") {
	      if (stream.eat("!")) {
	        if (stream.eat("[")) {
	          if (stream.match("CDATA[")) return chain(inBlock("atom", "]]>"));
	          else return null;
	        } else if (stream.match("--")) {
	          return chain(inBlock("comment", "-->"));
	        } else if (stream.match("DOCTYPE", true, true)) {
	          stream.eatWhile(/[\w\._\-]/);
	          return chain(doctype(1));
	        } else {
	          return null;
	        }
	      } else if (stream.eat("?")) {
	        stream.eatWhile(/[\w\._\-]/);
	        state.tokenize = inBlock("meta", "?>");
	        return "meta";
	      } else {
	        type = stream.eat("/") ? "closeTag" : "openTag";
	        state.tokenize = inTag;
	        return "tag bracket";
	      }
	    } else if (ch == "&") {
	      var ok;
	      if (stream.eat("#")) {
	        if (stream.eat("x")) {
	          ok = stream.eatWhile(/[a-fA-F\d]/) && stream.eat(";");
	        } else {
	          ok = stream.eatWhile(/[\d]/) && stream.eat(";");
	        }
	      } else {
	        ok = stream.eatWhile(/[\w\.\-:]/) && stream.eat(";");
	      }
	      return ok ? "atom" : "error";
	    } else {
	      stream.eatWhile(/[^&<]/);
	      return null;
	    }
	  }
	  inText.isInText = true;
	
	  function inTag(stream, state) {
	    var ch = stream.next();
	    if (ch == ">" || (ch == "/" && stream.eat(">"))) {
	      state.tokenize = inText;
	      type = ch == ">" ? "endTag" : "selfcloseTag";
	      return "tag bracket";
	    } else if (ch == "=") {
	      type = "equals";
	      return null;
	    } else if (ch == "<") {
	      state.tokenize = inText;
	      state.state = baseState;
	      state.tagName = state.tagStart = null;
	      var next = state.tokenize(stream, state);
	      return next ? next + " tag error" : "tag error";
	    } else if (/[\'\"]/.test(ch)) {
	      state.tokenize = inAttribute(ch);
	      state.stringStartCol = stream.column();
	      return state.tokenize(stream, state);
	    } else {
	      stream.match(/^[^\s\u00a0=<>\"\']*[^\s\u00a0=<>\"\'\/]/);
	      return "word";
	    }
	  }
	
	  function inAttribute(quote) {
	    var closure = function(stream, state) {
	      while (!stream.eol()) {
	        if (stream.next() == quote) {
	          state.tokenize = inTag;
	          break;
	        }
	      }
	      return "string";
	    };
	    closure.isInAttribute = true;
	    return closure;
	  }
	
	  function inBlock(style, terminator) {
	    return function(stream, state) {
	      while (!stream.eol()) {
	        if (stream.match(terminator)) {
	          state.tokenize = inText;
	          break;
	        }
	        stream.next();
	      }
	      return style;
	    };
	  }
	  function doctype(depth) {
	    return function(stream, state) {
	      var ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == "<") {
	          state.tokenize = doctype(depth + 1);
	          return state.tokenize(stream, state);
	        } else if (ch == ">") {
	          if (depth == 1) {
	            state.tokenize = inText;
	            break;
	          } else {
	            state.tokenize = doctype(depth - 1);
	            return state.tokenize(stream, state);
	          }
	        }
	      }
	      return "meta";
	    };
	  }
	
	  function Context(state, tagName, startOfLine) {
	    this.prev = state.context;
	    this.tagName = tagName;
	    this.indent = state.indented;
	    this.startOfLine = startOfLine;
	    if (config.doNotIndent.hasOwnProperty(tagName) || (state.context && state.context.noIndent))
	      this.noIndent = true;
	  }
	  function popContext(state) {
	    if (state.context) state.context = state.context.prev;
	  }
	  function maybePopContext(state, nextTagName) {
	    var parentTagName;
	    while (true) {
	      if (!state.context) {
	        return;
	      }
	      parentTagName = state.context.tagName;
	      if (!config.contextGrabbers.hasOwnProperty(parentTagName) ||
	          !config.contextGrabbers[parentTagName].hasOwnProperty(nextTagName)) {
	        return;
	      }
	      popContext(state);
	    }
	  }
	
	  function baseState(type, stream, state) {
	    if (type == "openTag") {
	      state.tagStart = stream.column();
	      return tagNameState;
	    } else if (type == "closeTag") {
	      return closeTagNameState;
	    } else {
	      return baseState;
	    }
	  }
	  function tagNameState(type, stream, state) {
	    if (type == "word") {
	      state.tagName = stream.current();
	      setStyle = "tag";
	      return attrState;
	    } else {
	      setStyle = "error";
	      return tagNameState;
	    }
	  }
	  function closeTagNameState(type, stream, state) {
	    if (type == "word") {
	      var tagName = stream.current();
	      if (state.context && state.context.tagName != tagName &&
	          config.implicitlyClosed.hasOwnProperty(state.context.tagName))
	        popContext(state);
	      if ((state.context && state.context.tagName == tagName) || config.matchClosing === false) {
	        setStyle = "tag";
	        return closeState;
	      } else {
	        setStyle = "tag error";
	        return closeStateErr;
	      }
	    } else {
	      setStyle = "error";
	      return closeStateErr;
	    }
	  }
	
	  function closeState(type, _stream, state) {
	    if (type != "endTag") {
	      setStyle = "error";
	      return closeState;
	    }
	    popContext(state);
	    return baseState;
	  }
	  function closeStateErr(type, stream, state) {
	    setStyle = "error";
	    return closeState(type, stream, state);
	  }
	
	  function attrState(type, _stream, state) {
	    if (type == "word") {
	      setStyle = "attribute";
	      return attrEqState;
	    } else if (type == "endTag" || type == "selfcloseTag") {
	      var tagName = state.tagName, tagStart = state.tagStart;
	      state.tagName = state.tagStart = null;
	      if (type == "selfcloseTag" ||
	          config.autoSelfClosers.hasOwnProperty(tagName)) {
	        maybePopContext(state, tagName);
	      } else {
	        maybePopContext(state, tagName);
	        state.context = new Context(state, tagName, tagStart == state.indented);
	      }
	      return baseState;
	    }
	    setStyle = "error";
	    return attrState;
	  }
	  function attrEqState(type, stream, state) {
	    if (type == "equals") return attrValueState;
	    if (!config.allowMissing) setStyle = "error";
	    return attrState(type, stream, state);
	  }
	  function attrValueState(type, stream, state) {
	    if (type == "string") return attrContinuedState;
	    if (type == "word" && config.allowUnquoted) {setStyle = "string"; return attrState;}
	    setStyle = "error";
	    return attrState(type, stream, state);
	  }
	  function attrContinuedState(type, stream, state) {
	    if (type == "string") return attrContinuedState;
	    return attrState(type, stream, state);
	  }
	
	  return {
	    startState: function(baseIndent) {
	      var state = {tokenize: inText,
	                   state: baseState,
	                   indented: baseIndent || 0,
	                   tagName: null, tagStart: null,
	                   context: null}
	      if (baseIndent != null) state.baseIndent = baseIndent
	      return state
	    },
	
	    token: function(stream, state) {
	      if (!state.tagName && stream.sol())
	        state.indented = stream.indentation();
	
	      if (stream.eatSpace()) return null;
	      type = null;
	      var style = state.tokenize(stream, state);
	      if ((style || type) && style != "comment") {
	        setStyle = null;
	        state.state = state.state(type || style, stream, state);
	        if (setStyle)
	          style = setStyle == "error" ? style + " error" : setStyle;
	      }
	      return style;
	    },
	
	    indent: function(state, textAfter, fullLine) {
	      var context = state.context;
	      // Indent multi-line strings (e.g. css).
	      if (state.tokenize.isInAttribute) {
	        if (state.tagStart == state.indented)
	          return state.stringStartCol + 1;
	        else
	          return state.indented + indentUnit;
	      }
	      if (context && context.noIndent) return CodeMirror.Pass;
	      if (state.tokenize != inTag && state.tokenize != inText)
	        return fullLine ? fullLine.match(/^(\s*)/)[0].length : 0;
	      // Indent the starts of attribute names.
	      if (state.tagName) {
	        if (config.multilineTagIndentPastTag !== false)
	          return state.tagStart + state.tagName.length + 2;
	        else
	          return state.tagStart + indentUnit * (config.multilineTagIndentFactor || 1);
	      }
	      if (config.alignCDATA && /<!\[CDATA\[/.test(textAfter)) return 0;
	      var tagAfter = textAfter && /^<(\/)?([\w_:\.-]*)/.exec(textAfter);
	      if (tagAfter && tagAfter[1]) { // Closing tag spotted
	        while (context) {
	          if (context.tagName == tagAfter[2]) {
	            context = context.prev;
	            break;
	          } else if (config.implicitlyClosed.hasOwnProperty(context.tagName)) {
	            context = context.prev;
	          } else {
	            break;
	          }
	        }
	      } else if (tagAfter) { // Opening tag spotted
	        while (context) {
	          var grabbers = config.contextGrabbers[context.tagName];
	          if (grabbers && grabbers.hasOwnProperty(tagAfter[2]))
	            context = context.prev;
	          else
	            break;
	        }
	      }
	      while (context && context.prev && !context.startOfLine)
	        context = context.prev;
	      if (context) return context.indent + indentUnit;
	      else return state.baseIndent || 0;
	    },
	
	    electricInput: /<\/[\s\w:]+>$/,
	    blockCommentStart: "<!--",
	    blockCommentEnd: "-->",
	
	    configuration: config.htmlMode ? "html" : "xml",
	    helperType: config.htmlMode ? "html" : "xml",
	
	    skipAttribute: function(state) {
	      if (state.state == attrValueState)
	        state.state = attrState
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/xml", "xml");
	CodeMirror.defineMIME("application/xml", "xml");
	if (!CodeMirror.mimeModes.hasOwnProperty("text/html"))
	  CodeMirror.defineMIME("text/html", {name: "xml", htmlMode: true});
	
	});


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var RandExp = __webpack_require__(1344);
	var option = __webpack_require__(17);
	// set maximum default, see #193
	RandExp.prototype.max = 10;
	/**
	 * Container is used to wrap external libraries (faker, chance, casual, randexp) that are used among the whole codebase. These
	 * libraries might be configured, customized, etc. and each internal JSF module needs to access those instances instead
	 * of pure npm module instances. This class supports consistent access to these instances.
	 */
	var Container = (function () {
	    function Container() {
	        // static requires - handle both initial dependency load (deps will be available
	        // among other modules) as well as they will be included by browserify AST
	        this.registry = {
	            faker: null,
	            chance: null,
	            casual: null,
	            // randexp is required for "pattern" values
	            randexp: RandExp
	        };
	    }
	    /**
	     * Override dependency given by name
	     * @param name
	     * @param callback
	     */
	    Container.prototype.extend = function (name, callback) {
	        if (typeof this.registry[name] === 'undefined') {
	            throw new ReferenceError('"' + name + '" dependency is not allowed.');
	        }
	        this.registry[name] = callback(this.registry[name]);
	    };
	    /**
	     * Returns dependency given by name
	     * @param name
	     * @returns {Dependency}
	     */
	    Container.prototype.get = function (name) {
	        if (typeof this.registry[name] === 'undefined') {
	            throw new ReferenceError('"' + name + '" dependency doesn\'t exist.');
	        }
	        else if (name === 'randexp') {
	            var RandExp_ = this.registry['randexp'];
	            // wrapped generator
	            return function (pattern) {
	                var re = new RandExp_(pattern);
	                // apply given setting
	                re.max = option('defaultRandExpMax');
	                return re.gen();
	            };
	        }
	        return this.registry[name];
	    };
	    /**
	     * Returns all dependencies
	     *
	     * @returns {Registry}
	     */
	    Container.prototype.getAll = function () {
	        return {
	            faker: this.get('faker'),
	            chance: this.get('chance'),
	            randexp: this.get('randexp'),
	            casual: this.get('casual')
	        };
	    };
	    return Container;
	}());
	// TODO move instantiation somewhere else (out from class file)
	// instantiate
	var container = new Container();
	module.exports = container;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = xor;
	function xor(a, b) {
	  var len = Math.min(a.length, b.length);
	  var out = new Buffer(len);
	  var i = -1;
	  while (++i < len) {
	    out.writeUInt8(a[i] ^ b[i], i);
	  }
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	function Context(indented, column, type, info, align, prev) {
	  this.indented = indented;
	  this.column = column;
	  this.type = type;
	  this.info = info;
	  this.align = align;
	  this.prev = prev;
	}
	function pushContext(state, col, type, info) {
	  var indent = state.indented;
	  if (state.context && state.context.type == "statement" && type != "statement")
	    indent = state.context.indented;
	  return state.context = new Context(indent, col, type, info, null, state.context);
	}
	function popContext(state) {
	  var t = state.context.type;
	  if (t == ")" || t == "]" || t == "}")
	    state.indented = state.context.indented;
	  return state.context = state.context.prev;
	}
	
	function typeBefore(stream, state, pos) {
	  if (state.prevToken == "variable" || state.prevToken == "variable-3") return true;
	  if (/\S(?:[^- ]>|[*\]])\s*$|\*$/.test(stream.string.slice(0, pos))) return true;
	  if (state.typeAtEndOfLine && stream.column() == stream.indentation()) return true;
	}
	
	function isTopScope(context) {
	  for (;;) {
	    if (!context || context.type == "top") return true;
	    if (context.type == "}" && context.prev.info != "namespace") return false;
	    context = context.prev;
	  }
	}
	
	CodeMirror.defineMode("clike", function(config, parserConfig) {
	  var indentUnit = config.indentUnit,
	      statementIndentUnit = parserConfig.statementIndentUnit || indentUnit,
	      dontAlignCalls = parserConfig.dontAlignCalls,
	      keywords = parserConfig.keywords || {},
	      types = parserConfig.types || {},
	      builtin = parserConfig.builtin || {},
	      blockKeywords = parserConfig.blockKeywords || {},
	      defKeywords = parserConfig.defKeywords || {},
	      atoms = parserConfig.atoms || {},
	      hooks = parserConfig.hooks || {},
	      multiLineStrings = parserConfig.multiLineStrings,
	      indentStatements = parserConfig.indentStatements !== false,
	      indentSwitch = parserConfig.indentSwitch !== false,
	      namespaceSeparator = parserConfig.namespaceSeparator,
	      isPunctuationChar = parserConfig.isPunctuationChar || /[\[\]{}\(\),;\:\.]/,
	      numberStart = parserConfig.numberStart || /[\d\.]/,
	      number = parserConfig.number || /^(?:0x[a-f\d]+|0b[01]+|(?:\d+\.?\d*|\.\d+)(?:e[-+]?\d+)?)(u|ll?|l|f)?/i,
	      isOperatorChar = parserConfig.isOperatorChar || /[+\-*&%=<>!?|\/]/;
	
	  var curPunc, isDefKeyword;
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    if (hooks[ch]) {
	      var result = hooks[ch](stream, state);
	      if (result !== false) return result;
	    }
	    if (ch == '"' || ch == "'") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    }
	    if (isPunctuationChar.test(ch)) {
	      curPunc = ch;
	      return null;
	    }
	    if (numberStart.test(ch)) {
	      stream.backUp(1)
	      if (stream.match(number)) return "number"
	      stream.next()
	    }
	    if (ch == "/") {
	      if (stream.eat("*")) {
	        state.tokenize = tokenComment;
	        return tokenComment(stream, state);
	      }
	      if (stream.eat("/")) {
	        stream.skipToEnd();
	        return "comment";
	      }
	    }
	    if (isOperatorChar.test(ch)) {
	      while (!stream.match(/^\/[\/*]/, false) && stream.eat(isOperatorChar)) {}
	      return "operator";
	    }
	    stream.eatWhile(/[\w\$_\xa1-\uffff]/);
	    if (namespaceSeparator) while (stream.match(namespaceSeparator))
	      stream.eatWhile(/[\w\$_\xa1-\uffff]/);
	
	    var cur = stream.current();
	    if (contains(keywords, cur)) {
	      if (contains(blockKeywords, cur)) curPunc = "newstatement";
	      if (contains(defKeywords, cur)) isDefKeyword = true;
	      return "keyword";
	    }
	    if (contains(types, cur)) return "variable-3";
	    if (contains(builtin, cur)) {
	      if (contains(blockKeywords, cur)) curPunc = "newstatement";
	      return "builtin";
	    }
	    if (contains(atoms, cur)) return "atom";
	    return "variable";
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, next, end = false;
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) {end = true; break;}
	        escaped = !escaped && next == "\\";
	      }
	      if (end || !(escaped || multiLineStrings))
	        state.tokenize = null;
	      return "string";
	    };
	  }
	
	  function tokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while (ch = stream.next()) {
	      if (ch == "/" && maybeEnd) {
	        state.tokenize = null;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return "comment";
	  }
	
	  function maybeEOL(stream, state) {
	    if (parserConfig.typeFirstDefinitions && stream.eol() && isTopScope(state.context))
	      state.typeAtEndOfLine = typeBefore(stream, state, stream.pos)
	  }
	
	  // Interface
	
	  return {
	    startState: function(basecolumn) {
	      return {
	        tokenize: null,
	        context: new Context((basecolumn || 0) - indentUnit, 0, "top", null, false),
	        indented: 0,
	        startOfLine: true,
	        prevToken: null
	      };
	    },
	
	    token: function(stream, state) {
	      var ctx = state.context;
	      if (stream.sol()) {
	        if (ctx.align == null) ctx.align = false;
	        state.indented = stream.indentation();
	        state.startOfLine = true;
	      }
	      if (stream.eatSpace()) { maybeEOL(stream, state); return null; }
	      curPunc = isDefKeyword = null;
	      var style = (state.tokenize || tokenBase)(stream, state);
	      if (style == "comment" || style == "meta") return style;
	      if (ctx.align == null) ctx.align = true;
	
	      if (curPunc == ";" || curPunc == ":" || (curPunc == "," && stream.match(/^\s*(?:\/\/.*)?$/, false)))
	        while (state.context.type == "statement") popContext(state);
	      else if (curPunc == "{") pushContext(state, stream.column(), "}");
	      else if (curPunc == "[") pushContext(state, stream.column(), "]");
	      else if (curPunc == "(") pushContext(state, stream.column(), ")");
	      else if (curPunc == "}") {
	        while (ctx.type == "statement") ctx = popContext(state);
	        if (ctx.type == "}") ctx = popContext(state);
	        while (ctx.type == "statement") ctx = popContext(state);
	      }
	      else if (curPunc == ctx.type) popContext(state);
	      else if (indentStatements &&
	               (((ctx.type == "}" || ctx.type == "top") && curPunc != ";") ||
	                (ctx.type == "statement" && curPunc == "newstatement"))) {
	        pushContext(state, stream.column(), "statement", stream.current());
	      }
	
	      if (style == "variable" &&
	          ((state.prevToken == "def" ||
	            (parserConfig.typeFirstDefinitions && typeBefore(stream, state, stream.start) &&
	             isTopScope(state.context) && stream.match(/^\s*\(/, false)))))
	        style = "def";
	
	      if (hooks.token) {
	        var result = hooks.token(stream, state, style);
	        if (result !== undefined) style = result;
	      }
	
	      if (style == "def" && parserConfig.styleDefs === false) style = "variable";
	
	      state.startOfLine = false;
	      state.prevToken = isDefKeyword ? "def" : style || curPunc;
	      maybeEOL(stream, state);
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      if (state.tokenize != tokenBase && state.tokenize != null || state.typeAtEndOfLine) return CodeMirror.Pass;
	      var ctx = state.context, firstChar = textAfter && textAfter.charAt(0);
	      if (ctx.type == "statement" && firstChar == "}") ctx = ctx.prev;
	      if (parserConfig.dontIndentStatements)
	        while (ctx.type == "statement" && parserConfig.dontIndentStatements.test(ctx.info))
	          ctx = ctx.prev
	      if (hooks.indent) {
	        var hook = hooks.indent(state, ctx, textAfter);
	        if (typeof hook == "number") return hook
	      }
	      var closing = firstChar == ctx.type;
	      var switchBlock = ctx.prev && ctx.prev.info == "switch";
	      if (parserConfig.allmanIndentation && /[{(]/.test(firstChar)) {
	        while (ctx.type != "top" && ctx.type != "}") ctx = ctx.prev
	        return ctx.indented
	      }
	      if (ctx.type == "statement")
	        return ctx.indented + (firstChar == "{" ? 0 : statementIndentUnit);
	      if (ctx.align && (!dontAlignCalls || ctx.type != ")"))
	        return ctx.column + (closing ? 0 : 1);
	      if (ctx.type == ")" && !closing)
	        return ctx.indented + statementIndentUnit;
	
	      return ctx.indented + (closing ? 0 : indentUnit) +
	        (!closing && switchBlock && !/^(?:case|default)\b/.test(textAfter) ? indentUnit : 0);
	    },
	
	    electricInput: indentSwitch ? /^\s*(?:case .*?:|default:|\{\}?|\})$/ : /^\s*[{}]$/,
	    blockCommentStart: "/*",
	    blockCommentEnd: "*/",
	    lineComment: "//",
	    fold: "brace"
	  };
	});
	
	  function words(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	  function contains(words, word) {
	    if (typeof words === "function") {
	      return words(word);
	    } else {
	      return words.propertyIsEnumerable(word);
	    }
	  }
	  var cKeywords = "auto if break case register continue return default do sizeof " +
	    "static else struct switch extern typedef union for goto while enum const volatile";
	  var cTypes = "int long char short double float unsigned signed void size_t ptrdiff_t";
	
	  function cppHook(stream, state) {
	    if (!state.startOfLine) return false
	    for (var ch, next = null; ch = stream.peek();) {
	      if (ch == "\\" && stream.match(/^.$/)) {
	        next = cppHook
	        break
	      } else if (ch == "/" && stream.match(/^\/[\/\*]/, false)) {
	        break
	      }
	      stream.next()
	    }
	    state.tokenize = next
	    return "meta"
	  }
	
	  function pointerHook(_stream, state) {
	    if (state.prevToken == "variable-3") return "variable-3";
	    return false;
	  }
	
	  function cpp14Literal(stream) {
	    stream.eatWhile(/[\w\.']/);
	    return "number";
	  }
	
	  function cpp11StringHook(stream, state) {
	    stream.backUp(1);
	    // Raw strings.
	    if (stream.match(/(R|u8R|uR|UR|LR)/)) {
	      var match = stream.match(/"([^\s\\()]{0,16})\(/);
	      if (!match) {
	        return false;
	      }
	      state.cpp11RawStringDelim = match[1];
	      state.tokenize = tokenRawString;
	      return tokenRawString(stream, state);
	    }
	    // Unicode strings/chars.
	    if (stream.match(/(u8|u|U|L)/)) {
	      if (stream.match(/["']/, /* eat */ false)) {
	        return "string";
	      }
	      return false;
	    }
	    // Ignore this hook.
	    stream.next();
	    return false;
	  }
	
	  function cppLooksLikeConstructor(word) {
	    var lastTwo = /(\w+)::(\w+)$/.exec(word);
	    return lastTwo && lastTwo[1] == lastTwo[2];
	  }
	
	  // C#-style strings where "" escapes a quote.
	  function tokenAtString(stream, state) {
	    var next;
	    while ((next = stream.next()) != null) {
	      if (next == '"' && !stream.eat('"')) {
	        state.tokenize = null;
	        break;
	      }
	    }
	    return "string";
	  }
	
	  // C++11 raw string literal is <prefix>"<delim>( anything )<delim>", where
	  // <delim> can be a string up to 16 characters long.
	  function tokenRawString(stream, state) {
	    // Escape characters that have special regex meanings.
	    var delim = state.cpp11RawStringDelim.replace(/[^\w\s]/g, '\\$&');
	    var match = stream.match(new RegExp(".*?\\)" + delim + '"'));
	    if (match)
	      state.tokenize = null;
	    else
	      stream.skipToEnd();
	    return "string";
	  }
	
	  function def(mimes, mode) {
	    if (typeof mimes == "string") mimes = [mimes];
	    var words = [];
	    function add(obj) {
	      if (obj) for (var prop in obj) if (obj.hasOwnProperty(prop))
	        words.push(prop);
	    }
	    add(mode.keywords);
	    add(mode.types);
	    add(mode.builtin);
	    add(mode.atoms);
	    if (words.length) {
	      mode.helperType = mimes[0];
	      CodeMirror.registerHelper("hintWords", mimes[0], words);
	    }
	
	    for (var i = 0; i < mimes.length; ++i)
	      CodeMirror.defineMIME(mimes[i], mode);
	  }
	
	  def(["text/x-csrc", "text/x-c", "text/x-chdr"], {
	    name: "clike",
	    keywords: words(cKeywords),
	    types: words(cTypes + " bool _Complex _Bool float_t double_t intptr_t intmax_t " +
	                 "int8_t int16_t int32_t int64_t uintptr_t uintmax_t uint8_t uint16_t " +
	                 "uint32_t uint64_t"),
	    blockKeywords: words("case do else for if switch while struct"),
	    defKeywords: words("struct"),
	    typeFirstDefinitions: true,
	    atoms: words("null true false"),
	    hooks: {"#": cppHook, "*": pointerHook},
	    modeProps: {fold: ["brace", "include"]}
	  });
	
	  def(["text/x-c++src", "text/x-c++hdr"], {
	    name: "clike",
	    keywords: words(cKeywords + " asm dynamic_cast namespace reinterpret_cast try explicit new " +
	                    "static_cast typeid catch operator template typename class friend private " +
	                    "this using const_cast inline public throw virtual delete mutable protected " +
	                    "alignas alignof constexpr decltype nullptr noexcept thread_local final " +
	                    "static_assert override"),
	    types: words(cTypes + " bool wchar_t"),
	    blockKeywords: words("catch class do else finally for if struct switch try while"),
	    defKeywords: words("class namespace struct enum union"),
	    typeFirstDefinitions: true,
	    atoms: words("true false null"),
	    dontIndentStatements: /^template$/,
	    hooks: {
	      "#": cppHook,
	      "*": pointerHook,
	      "u": cpp11StringHook,
	      "U": cpp11StringHook,
	      "L": cpp11StringHook,
	      "R": cpp11StringHook,
	      "0": cpp14Literal,
	      "1": cpp14Literal,
	      "2": cpp14Literal,
	      "3": cpp14Literal,
	      "4": cpp14Literal,
	      "5": cpp14Literal,
	      "6": cpp14Literal,
	      "7": cpp14Literal,
	      "8": cpp14Literal,
	      "9": cpp14Literal,
	      token: function(stream, state, style) {
	        if (style == "variable" && stream.peek() == "(" &&
	            (state.prevToken == ";" || state.prevToken == null ||
	             state.prevToken == "}") &&
	            cppLooksLikeConstructor(stream.current()))
	          return "def";
	      }
	    },
	    namespaceSeparator: "::",
	    modeProps: {fold: ["brace", "include"]}
	  });
	
	  def("text/x-java", {
	    name: "clike",
	    keywords: words("abstract assert break case catch class const continue default " +
	                    "do else enum extends final finally float for goto if implements import " +
	                    "instanceof interface native new package private protected public " +
	                    "return static strictfp super switch synchronized this throw throws transient " +
	                    "try volatile while"),
	    types: words("byte short int long float double boolean char void Boolean Byte Character Double Float " +
	                 "Integer Long Number Object Short String StringBuffer StringBuilder Void"),
	    blockKeywords: words("catch class do else finally for if switch try while"),
	    defKeywords: words("class interface package enum"),
	    typeFirstDefinitions: true,
	    atoms: words("true false null"),
	    number: /^(?:0x[a-f\d_]+|0b[01_]+|(?:[\d_]+\.?\d*|\.\d+)(?:e[-+]?[\d_]+)?)(u|ll?|l|f)?/i,
	    hooks: {
	      "@": function(stream) {
	        stream.eatWhile(/[\w\$_]/);
	        return "meta";
	      }
	    },
	    modeProps: {fold: ["brace", "import"]}
	  });
	
	  def("text/x-csharp", {
	    name: "clike",
	    keywords: words("abstract as async await base break case catch checked class const continue" +
	                    " default delegate do else enum event explicit extern finally fixed for" +
	                    " foreach goto if implicit in interface internal is lock namespace new" +
	                    " operator out override params private protected public readonly ref return sealed" +
	                    " sizeof stackalloc static struct switch this throw try typeof unchecked" +
	                    " unsafe using virtual void volatile while add alias ascending descending dynamic from get" +
	                    " global group into join let orderby partial remove select set value var yield"),
	    types: words("Action Boolean Byte Char DateTime DateTimeOffset Decimal Double Func" +
	                 " Guid Int16 Int32 Int64 Object SByte Single String Task TimeSpan UInt16 UInt32" +
	                 " UInt64 bool byte char decimal double short int long object"  +
	                 " sbyte float string ushort uint ulong"),
	    blockKeywords: words("catch class do else finally for foreach if struct switch try while"),
	    defKeywords: words("class interface namespace struct var"),
	    typeFirstDefinitions: true,
	    atoms: words("true false null"),
	    hooks: {
	      "@": function(stream, state) {
	        if (stream.eat('"')) {
	          state.tokenize = tokenAtString;
	          return tokenAtString(stream, state);
	        }
	        stream.eatWhile(/[\w\$_]/);
	        return "meta";
	      }
	    }
	  });
	
	  function tokenTripleString(stream, state) {
	    var escaped = false;
	    while (!stream.eol()) {
	      if (!escaped && stream.match('"""')) {
	        state.tokenize = null;
	        break;
	      }
	      escaped = stream.next() == "\\" && !escaped;
	    }
	    return "string";
	  }
	
	  def("text/x-scala", {
	    name: "clike",
	    keywords: words(
	
	      /* scala */
	      "abstract case catch class def do else extends final finally for forSome if " +
	      "implicit import lazy match new null object override package private protected return " +
	      "sealed super this throw trait try type val var while with yield _ : = => <- <: " +
	      "<% >: # @ " +
	
	      /* package scala */
	      "assert assume require print println printf readLine readBoolean readByte readShort " +
	      "readChar readInt readLong readFloat readDouble " +
	
	      ":: #:: "
	    ),
	    types: words(
	      "AnyVal App Application Array BufferedIterator BigDecimal BigInt Char Console Either " +
	      "Enumeration Equiv Error Exception Fractional Function IndexedSeq Int Integral Iterable " +
	      "Iterator List Map Numeric Nil NotNull Option Ordered Ordering PartialFunction PartialOrdering " +
	      "Product Proxy Range Responder Seq Serializable Set Specializable Stream StringBuilder " +
	      "StringContext Symbol Throwable Traversable TraversableOnce Tuple Unit Vector " +
	
	      /* package java.lang */
	      "Boolean Byte Character CharSequence Class ClassLoader Cloneable Comparable " +
	      "Compiler Double Exception Float Integer Long Math Number Object Package Pair Process " +
	      "Runtime Runnable SecurityManager Short StackTraceElement StrictMath String " +
	      "StringBuffer System Thread ThreadGroup ThreadLocal Throwable Triple Void"
	    ),
	    multiLineStrings: true,
	    blockKeywords: words("catch class do else finally for forSome if match switch try while"),
	    defKeywords: words("class def object package trait type val var"),
	    atoms: words("true false null"),
	    indentStatements: false,
	    indentSwitch: false,
	    hooks: {
	      "@": function(stream) {
	        stream.eatWhile(/[\w\$_]/);
	        return "meta";
	      },
	      '"': function(stream, state) {
	        if (!stream.match('""')) return false;
	        state.tokenize = tokenTripleString;
	        return state.tokenize(stream, state);
	      },
	      "'": function(stream) {
	        stream.eatWhile(/[\w\$_\xa1-\uffff]/);
	        return "atom";
	      },
	      "=": function(stream, state) {
	        var cx = state.context
	        if (cx.type == "}" && cx.align && stream.eat(">")) {
	          state.context = new Context(cx.indented, cx.column, cx.type, cx.info, null, cx.prev)
	          return "operator"
	        } else {
	          return false
	        }
	      }
	    },
	    modeProps: {closeBrackets: {triples: '"'}}
	  });
	
	  function tokenKotlinString(tripleString){
	    return function (stream, state) {
	      var escaped = false, next, end = false;
	      while (!stream.eol()) {
	        if (!tripleString && !escaped && stream.match('"') ) {end = true; break;}
	        if (tripleString && stream.match('"""')) {end = true; break;}
	        next = stream.next();
	        if(!escaped && next == "$" && stream.match('{'))
	          stream.skipTo("}");
	        escaped = !escaped && next == "\\" && !tripleString;
	      }
	      if (end || !tripleString)
	        state.tokenize = null;
	      return "string";
	    }
	  }
	
	  def("text/x-kotlin", {
	    name: "clike",
	    keywords: words(
	      /*keywords*/
	      "package as typealias class interface this super val " +
	      "var fun for is in This throw return " +
	      "break continue object if else while do try when !in !is as? " +
	
	      /*soft keywords*/
	      "file import where by get set abstract enum open inner override private public internal " +
	      "protected catch finally out final vararg reified dynamic companion constructor init " +
	      "sealed field property receiver param sparam lateinit data inline noinline tailrec " +
	      "external annotation crossinline const operator infix"
	    ),
	    types: words(
	      /* package java.lang */
	      "Boolean Byte Character CharSequence Class ClassLoader Cloneable Comparable " +
	      "Compiler Double Exception Float Integer Long Math Number Object Package Pair Process " +
	      "Runtime Runnable SecurityManager Short StackTraceElement StrictMath String " +
	      "StringBuffer System Thread ThreadGroup ThreadLocal Throwable Triple Void"
	    ),
	    intendSwitch: false,
	    indentStatements: false,
	    multiLineStrings: true,
	    blockKeywords: words("catch class do else finally for if where try while enum"),
	    defKeywords: words("class val var object package interface fun"),
	    atoms: words("true false null this"),
	    hooks: {
	      '"': function(stream, state) {
	        state.tokenize = tokenKotlinString(stream.match('""'));
	        return state.tokenize(stream, state);
	      }
	    },
	    modeProps: {closeBrackets: {triples: '"'}}
	  });
	
	  def(["x-shader/x-vertex", "x-shader/x-fragment"], {
	    name: "clike",
	    keywords: words("sampler1D sampler2D sampler3D samplerCube " +
	                    "sampler1DShadow sampler2DShadow " +
	                    "const attribute uniform varying " +
	                    "break continue discard return " +
	                    "for while do if else struct " +
	                    "in out inout"),
	    types: words("float int bool void " +
	                 "vec2 vec3 vec4 ivec2 ivec3 ivec4 bvec2 bvec3 bvec4 " +
	                 "mat2 mat3 mat4"),
	    blockKeywords: words("for while do if else struct"),
	    builtin: words("radians degrees sin cos tan asin acos atan " +
	                    "pow exp log exp2 sqrt inversesqrt " +
	                    "abs sign floor ceil fract mod min max clamp mix step smoothstep " +
	                    "length distance dot cross normalize ftransform faceforward " +
	                    "reflect refract matrixCompMult " +
	                    "lessThan lessThanEqual greaterThan greaterThanEqual " +
	                    "equal notEqual any all not " +
	                    "texture1D texture1DProj texture1DLod texture1DProjLod " +
	                    "texture2D texture2DProj texture2DLod texture2DProjLod " +
	                    "texture3D texture3DProj texture3DLod texture3DProjLod " +
	                    "textureCube textureCubeLod " +
	                    "shadow1D shadow2D shadow1DProj shadow2DProj " +
	                    "shadow1DLod shadow2DLod shadow1DProjLod shadow2DProjLod " +
	                    "dFdx dFdy fwidth " +
	                    "noise1 noise2 noise3 noise4"),
	    atoms: words("true false " +
	                "gl_FragColor gl_SecondaryColor gl_Normal gl_Vertex " +
	                "gl_MultiTexCoord0 gl_MultiTexCoord1 gl_MultiTexCoord2 gl_MultiTexCoord3 " +
	                "gl_MultiTexCoord4 gl_MultiTexCoord5 gl_MultiTexCoord6 gl_MultiTexCoord7 " +
	                "gl_FogCoord gl_PointCoord " +
	                "gl_Position gl_PointSize gl_ClipVertex " +
	                "gl_FrontColor gl_BackColor gl_FrontSecondaryColor gl_BackSecondaryColor " +
	                "gl_TexCoord gl_FogFragCoord " +
	                "gl_FragCoord gl_FrontFacing " +
	                "gl_FragData gl_FragDepth " +
	                "gl_ModelViewMatrix gl_ProjectionMatrix gl_ModelViewProjectionMatrix " +
	                "gl_TextureMatrix gl_NormalMatrix gl_ModelViewMatrixInverse " +
	                "gl_ProjectionMatrixInverse gl_ModelViewProjectionMatrixInverse " +
	                "gl_TexureMatrixTranspose gl_ModelViewMatrixInverseTranspose " +
	                "gl_ProjectionMatrixInverseTranspose " +
	                "gl_ModelViewProjectionMatrixInverseTranspose " +
	                "gl_TextureMatrixInverseTranspose " +
	                "gl_NormalScale gl_DepthRange gl_ClipPlane " +
	                "gl_Point gl_FrontMaterial gl_BackMaterial gl_LightSource gl_LightModel " +
	                "gl_FrontLightModelProduct gl_BackLightModelProduct " +
	                "gl_TextureColor gl_EyePlaneS gl_EyePlaneT gl_EyePlaneR gl_EyePlaneQ " +
	                "gl_FogParameters " +
	                "gl_MaxLights gl_MaxClipPlanes gl_MaxTextureUnits gl_MaxTextureCoords " +
	                "gl_MaxVertexAttribs gl_MaxVertexUniformComponents gl_MaxVaryingFloats " +
	                "gl_MaxVertexTextureImageUnits gl_MaxTextureImageUnits " +
	                "gl_MaxFragmentUniformComponents gl_MaxCombineTextureImageUnits " +
	                "gl_MaxDrawBuffers"),
	    indentSwitch: false,
	    hooks: {"#": cppHook},
	    modeProps: {fold: ["brace", "include"]}
	  });
	
	  def("text/x-nesc", {
	    name: "clike",
	    keywords: words(cKeywords + "as atomic async call command component components configuration event generic " +
	                    "implementation includes interface module new norace nx_struct nx_union post provides " +
	                    "signal task uses abstract extends"),
	    types: words(cTypes),
	    blockKeywords: words("case do else for if switch while struct"),
	    atoms: words("null true false"),
	    hooks: {"#": cppHook},
	    modeProps: {fold: ["brace", "include"]}
	  });
	
	  def("text/x-objectivec", {
	    name: "clike",
	    keywords: words(cKeywords + "inline restrict _Bool _Complex _Imaginary BOOL Class bycopy byref id IMP in " +
	                    "inout nil oneway out Protocol SEL self super atomic nonatomic retain copy readwrite readonly"),
	    types: words(cTypes),
	    atoms: words("YES NO NULL NILL ON OFF true false"),
	    hooks: {
	      "@": function(stream) {
	        stream.eatWhile(/[\w\$]/);
	        return "keyword";
	      },
	      "#": cppHook,
	      indent: function(_state, ctx, textAfter) {
	        if (ctx.type == "statement" && /^@\w/.test(textAfter)) return ctx.indented
	      }
	    },
	    modeProps: {fold: "brace"}
	  });
	
	  def("text/x-squirrel", {
	    name: "clike",
	    keywords: words("base break clone continue const default delete enum extends function in class" +
	                    " foreach local resume return this throw typeof yield constructor instanceof static"),
	    types: words(cTypes),
	    blockKeywords: words("case catch class else for foreach if switch try while"),
	    defKeywords: words("function local class"),
	    typeFirstDefinitions: true,
	    atoms: words("true false null"),
	    hooks: {"#": cppHook},
	    modeProps: {fold: ["brace", "include"]}
	  });
	
	  // Ceylon Strings need to deal with interpolation
	  var stringTokenizer = null;
	  function tokenCeylonString(type) {
	    return function(stream, state) {
	      var escaped = false, next, end = false;
	      while (!stream.eol()) {
	        if (!escaped && stream.match('"') &&
	              (type == "single" || stream.match('""'))) {
	          end = true;
	          break;
	        }
	        if (!escaped && stream.match('``')) {
	          stringTokenizer = tokenCeylonString(type);
	          end = true;
	          break;
	        }
	        next = stream.next();
	        escaped = type == "single" && !escaped && next == "\\";
	      }
	      if (end)
	          state.tokenize = null;
	      return "string";
	    }
	  }
	
	  def("text/x-ceylon", {
	    name: "clike",
	    keywords: words("abstracts alias assembly assert assign break case catch class continue dynamic else" +
	                    " exists extends finally for function given if import in interface is let module new" +
	                    " nonempty object of out outer package return satisfies super switch then this throw" +
	                    " try value void while"),
	    types: function(word) {
	        // In Ceylon all identifiers that start with an uppercase are types
	        var first = word.charAt(0);
	        return (first === first.toUpperCase() && first !== first.toLowerCase());
	    },
	    blockKeywords: words("case catch class dynamic else finally for function if interface module new object switch try while"),
	    defKeywords: words("class dynamic function interface module object package value"),
	    builtin: words("abstract actual aliased annotation by default deprecated doc final formal late license" +
	                   " native optional sealed see serializable shared suppressWarnings tagged throws variable"),
	    isPunctuationChar: /[\[\]{}\(\),;\:\.`]/,
	    isOperatorChar: /[+\-*&%=<>!?|^~:\/]/,
	    numberStart: /[\d#$]/,
	    number: /^(?:#[\da-fA-F_]+|\$[01_]+|[\d_]+[kMGTPmunpf]?|[\d_]+\.[\d_]+(?:[eE][-+]?\d+|[kMGTPmunpf]|)|)/i,
	    multiLineStrings: true,
	    typeFirstDefinitions: true,
	    atoms: words("true false null larger smaller equal empty finished"),
	    indentSwitch: false,
	    styleDefs: false,
	    hooks: {
	      "@": function(stream) {
	        stream.eatWhile(/[\w\$_]/);
	        return "meta";
	      },
	      '"': function(stream, state) {
	          state.tokenize = tokenCeylonString(stream.match('""') ? "triple" : "single");
	          return state.tokenize(stream, state);
	        },
	      '`': function(stream, state) {
	          if (!stringTokenizer || !stream.match('`')) return false;
	          state.tokenize = stringTokenizer;
	          stringTokenizer = null;
	          return state.tokenize(stream, state);
	        },
	      "'": function(stream) {
	        stream.eatWhile(/[\w\$_\xa1-\uffff]/);
	        return "atom";
	      },
	      token: function(_stream, state, style) {
	          if ((style == "variable" || style == "variable-3") &&
	              state.prevToken == ".") {
	            return "variable-2";
	          }
	        }
	    },
	    modeProps: {
	        fold: ["brace", "import"],
	        closeBrackets: {triples: '"'}
	    }
	  });
	
	});


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(30);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 28 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 29 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(98)
	  , enumBugKeys = __webpack_require__(48);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 32 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 33 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 34 */
/***/ function(module, exports) {

	'use strict';
	
	// https://gist.github.com/pjt33/efb2f1134bab986113fd
	
	function URLUtils(url, baseURL) {
	  // remove leading ./
	  url = url.replace(/^\.\//, '');
	
	  var m = String(url).replace(/^\s+|\s+$/g, '').match(/^([^:\/?#]+:)?(?:\/\/(?:([^:@]*)(?::([^:@]*))?@)?(([^:\/?#]*)(?::(\d*))?))?([^?#]*)(\?[^#]*)?(#[\s\S]*)?/);
	  if (!m) {
	    throw new RangeError();
	  }
	  var href = m[0] || '';
	  var protocol = m[1] || '';
	  var username = m[2] || '';
	  var password = m[3] || '';
	  var host = m[4] || '';
	  var hostname = m[5] || '';
	  var port = m[6] || '';
	  var pathname = m[7] || '';
	  var search = m[8] || '';
	  var hash = m[9] || '';
	  if (baseURL !== undefined) {
	    var base = new URLUtils(baseURL);
	    var flag = protocol === '' && host === '' && username === '';
	    if (flag && pathname === '' && search === '') {
	      search = base.search;
	    }
	    if (flag && pathname.charAt(0) !== '/') {
	      pathname = (pathname !== '' ? (base.pathname.slice(0, base.pathname.lastIndexOf('/') + 1) + pathname) : base.pathname);
	    }
	    // dot segments removal
	    var output = [];
	
	    pathname.replace(/\/?[^\/]+/g, function(p) {
	      if (p === '/..') {
	        output.pop();
	      } else {
	        output.push(p);
	      }
	    });
	
	    pathname = output.join('') || '/';
	
	    if (flag) {
	      port = base.port;
	      hostname = base.hostname;
	      host = base.host;
	      password = base.password;
	      username = base.username;
	    }
	    if (protocol === '') {
	      protocol = base.protocol;
	    }
	    href = protocol + (host !== '' ? '//' : '') + (username !== '' ? username + (password !== '' ? ':' + password : '') + '@' : '') + host + pathname + search + hash;
	  }
	  this.href = href;
	  this.origin = protocol + (host !== '' ? '//' + host : '');
	  this.protocol = protocol;
	  this.username = username;
	  this.password = password;
	  this.host = host;
	  this.hostname = hostname;
	  this.port = port;
	  this.pathname = pathname;
	  this.search = search;
	  this.hash = hash;
	}
	
	function isURL(path) {
	  if (typeof path === 'string' && /^\w+:\/\//.test(path)) {
	    return true;
	  }
	}
	
	function parseURI(href, base) {
	  return new URLUtils(href, base);
	}
	
	function resolveURL(base, href) {
	  base = base || 'http://json-schema.org/schema#';
	
	  href = parseURI(href, base);
	  base = parseURI(base);
	
	  if (base.hash && !href.hash) {
	    return href.href + base.hash;
	  }
	
	  return href.href;
	}
	
	function getDocumentURI(uri) {
	  return typeof uri === 'string' && uri.split('#')[0];
	}
	
	function isKeyword(prop) {
	  return prop === 'enum' || prop === 'default' || prop === 'required';
	}
	
	module.exports = {
	  isURL: isURL,
	  parseURI: parseURI,
	  isKeyword: isKeyword,
	  resolveURL: resolveURL,
	  getDocumentURI: getDocumentURI
	};


/***/ },
/* 35 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 36 */
/***/ function(module, exports) {

	"use strict";
	function getSubAttribute(obj, dotSeparatedKey) {
	    var keyElements = dotSeparatedKey.split('.');
	    while (keyElements.length) {
	        var prop = keyElements.shift();
	        if (!obj[prop]) {
	            break;
	        }
	        obj = obj[prop];
	    }
	    return obj;
	}
	/**
	 * Returns true/false whether the object parameter has its own properties defined
	 *
	 * @param obj
	 * @param properties
	 * @returns {boolean}
	 */
	function hasProperties(obj) {
	    var properties = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        properties[_i - 1] = arguments[_i];
	    }
	    return properties.filter(function (key) {
	        return typeof obj[key] !== 'undefined';
	    }).length > 0;
	}
	/**
	 * Returns typecasted value.
	 * External generators (faker, chance, casual) may return data in non-expected formats, such as string, when you might expect an
	 * integer. This function is used to force the typecast.
	 *
	 * @param value
	 * @param targetType
	 * @returns {any}
	 */
	function typecast(value, targetType) {
	    switch (targetType) {
	        case 'integer':
	            return parseInt(value, 10);
	        case 'number':
	            return parseFloat(value);
	        case 'string':
	            return '' + value;
	        case 'boolean':
	            return !!value;
	        default:
	            return value;
	    }
	}
	function clone(arr) {
	    var out = [];
	    arr.forEach(function (item, index) {
	        if (typeof item === 'object' && item !== null) {
	            out[index] = Array.isArray(item) ? clone(item) : merge({}, item);
	        }
	        else {
	            out[index] = item;
	        }
	    });
	    return out;
	}
	// TODO refactor merge function
	function merge(a, b) {
	    for (var key in b) {
	        if (typeof b[key] !== 'object' || b[key] === null) {
	            a[key] = b[key];
	        }
	        else if (Array.isArray(b[key])) {
	            a[key] = (a[key] || []).concat(clone(b[key]));
	        }
	        else if (typeof a[key] !== 'object' || a[key] === null || Array.isArray(a[key])) {
	            a[key] = merge({}, b[key]);
	        }
	        else {
	            a[key] = merge(a[key], b[key]);
	        }
	    }
	    return a;
	}
	module.exports = {
	    getSubAttribute: getSubAttribute,
	    hasProperties: hasProperties,
	    typecast: typecast,
	    clone: clone,
	    merge: merge
	};


/***/ },
/* 37 */
/***/ function(module, exports) {

	module.exports = {
	  ROOT       : 0,
	  GROUP      : 1,
	  POSITION   : 2,
	  SET        : 3,
	  RANGE      : 4,
	  REPETITION : 5,
	  REFERENCE  : 6,
	  CHAR       : 7,
	};


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(35).EventEmitter;
	var inherits = __webpack_require__(4);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(1348);
	Stream.Writable = __webpack_require__(1350);
	Stream.Duplex = __webpack_require__(1345);
	Stream.Transform = __webpack_require__(1349);
	Stream.PassThrough = __webpack_require__(1347);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var uint_max = Math.pow(2, 32);
	function fixup_uint32(x) {
	    var ret, x_pos;
	    ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x;
	    return ret;
	}
	function scrub_vec(v) {
	  var i, _i, _ref;
	  for (i = _i = 0, _ref = v.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
	    v[i] = 0;
	  }
	  return false;
	}
	
	function Global() {
	  var i;
	  this.SBOX = [];
	  this.INV_SBOX = [];
	  this.SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.INV_SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.init();
	  this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	}
	
	Global.prototype.init = function() {
	  var d, i, sx, t, x, x2, x4, x8, xi, _i;
	  d = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 256; i = ++_i) {
	      if (i < 128) {
	        _results.push(i << 1);
	      } else {
	        _results.push((i << 1) ^ 0x11b);
	      }
	    }
	    return _results;
	  })();
	  x = 0;
	  xi = 0;
	  for (i = _i = 0; _i < 256; i = ++_i) {
	    sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	    this.SBOX[x] = sx;
	    this.INV_SBOX[sx] = x;
	    x2 = d[x];
	    x4 = d[x2];
	    x8 = d[x4];
	    t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	    this.SUB_MIX[0][x] = (t << 24) | (t >>> 8);
	    this.SUB_MIX[1][x] = (t << 16) | (t >>> 16);
	    this.SUB_MIX[2][x] = (t << 8) | (t >>> 24);
	    this.SUB_MIX[3][x] = t;
	    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	    this.INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8);
	    this.INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16);
	    this.INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24);
	    this.INV_SUB_MIX[3][sx] = t;
	    if (x === 0) {
	      x = xi = 1;
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]];
	      xi ^= d[d[xi]];
	    }
	  }
	  return true;
	};
	
	var G = new Global();
	
	
	AES.blockSize = 4 * 4;
	
	AES.prototype.blockSize = AES.blockSize;
	
	AES.keySize = 256 / 8;
	
	AES.prototype.keySize = AES.keySize;
	
	AES.ivSize = AES.blockSize;
	
	AES.prototype.ivSize = AES.ivSize;
	
	 function bufferToArray(buf) {
	  var len = buf.length/4;
	  var out = new Array(len);
	  var i = -1;
	  while (++i < len) {
	    out[i] = buf.readUInt32BE(i * 4);
	  }
	  return out;
	 }
	function AES(key) {
	  this._key = bufferToArray(key);
	  this._doReset();
	}
	
	AES.prototype._doReset = function() {
	  var invKsRow, keySize, keyWords, ksRow, ksRows, t, _i, _j;
	  keyWords = this._key;
	  keySize = keyWords.length;
	  this._nRounds = keySize + 6;
	  ksRows = (this._nRounds + 1) * 4;
	  this._keySchedule = [];
	  for (ksRow = _i = 0; 0 <= ksRows ? _i < ksRows : _i > ksRows; ksRow = 0 <= ksRows ? ++_i : --_i) {
	    this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], (ksRow % keySize) === 0 ? (t = (t << 8) | (t >>> 24), t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff], t ^= G.RCON[(ksRow / keySize) | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t);
	  }
	  this._invKeySchedule = [];
	  for (invKsRow = _j = 0; 0 <= ksRows ? _j < ksRows : _j > ksRows; invKsRow = 0 <= ksRows ? ++_j : --_j) {
	    ksRow = ksRows - invKsRow;
	    t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)];
	    this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[(t >>> 16) & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[(t >>> 8) & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]];
	  }
	  return true;
	};
	
	AES.prototype.encryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[1], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[3], 12);
	  return buf;
	};
	
	AES.prototype.decryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var temp = [M[3], M[1]];
	  M[1] = temp[0];
	  M[3] = temp[1];
	  var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[3], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[1], 12);
	  return buf;
	};
	
	AES.prototype.scrub = function() {
	  scrub_vec(this._keySchedule);
	  scrub_vec(this._invKeySchedule);
	  scrub_vec(this._key);
	};
	
	AES.prototype._doCryptBlock = function(M, keySchedule, SUB_MIX, SBOX) {
	  var ksRow, round, s0, s1, s2, s3, t0, t1, t2, t3, _i, _ref;
	
	  s0 = M[0] ^ keySchedule[0];
	  s1 = M[1] ^ keySchedule[1];
	  s2 = M[2] ^ keySchedule[2];
	  s3 = M[3] ^ keySchedule[3];
	  ksRow = 4;
	  for (round = _i = 1, _ref = this._nRounds; 1 <= _ref ? _i < _ref : _i > _ref; round = 1 <= _ref ? ++_i : --_i) {
	    t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][(s1 >>> 16) & 0xff] ^ SUB_MIX[2][(s2 >>> 8) & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++];
	    t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][(s2 >>> 16) & 0xff] ^ SUB_MIX[2][(s3 >>> 8) & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++];
	    t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][(s3 >>> 16) & 0xff] ^ SUB_MIX[2][(s0 >>> 8) & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++];
	    t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][(s0 >>> 16) & 0xff] ^ SUB_MIX[2][(s1 >>> 8) & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++];
	    s0 = t0;
	    s1 = t1;
	    s2 = t2;
	    s3 = t3;
	  }
	  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	  return [
	    fixup_uint32(t0),
	    fixup_uint32(t1),
	    fixup_uint32(t2),
	    fixup_uint32(t3)
	  ];
	
	};
	
	
	
	
	  exports.AES = AES;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var Transform = __webpack_require__(38).Transform;
	var inherits = __webpack_require__(4);
	
	module.exports = CipherBase;
	inherits(CipherBase, Transform);
	function CipherBase() {
	  Transform.call(this);
	}
	CipherBase.prototype.update = function (data, inputEnd, outputEnc) {
	  this.write(data, inputEnd);
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	CipherBase.prototype.final = function (outputEnc) {
	  this.end();
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ },
/* 41 */
/***/ function(module, exports) {

	exports['aes-128-ecb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-192-ecb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-256-ecb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-128-cbc'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-192-cbc'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-256-cbc'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes128'] = exports['aes-128-cbc'];
	exports['aes192'] = exports['aes-192-cbc'];
	exports['aes256'] = exports['aes-256-cbc'];
	exports['aes-128-cfb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-192-cfb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-256-cfb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-128-ofb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-192-ofb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-256-ofb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-128-ctr'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-192-ctr'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-256-ctr'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var buffer = __webpack_require__(3);
	var Buffer = buffer.Buffer;
	var SlowBuffer = buffer.SlowBuffer;
	var MAX_LEN = buffer.kMaxLength || 2147483647;
	exports.alloc = function alloc(size, fill, encoding) {
	  if (typeof Buffer.alloc === 'function') {
	    return Buffer.alloc(size, fill, encoding);
	  }
	  if (typeof encoding === 'number') {
	    throw new TypeError('encoding must not be number');
	  }
	  if (typeof size !== 'number') {
	    throw new TypeError('size must be a number');
	  }
	  if (size > MAX_LEN) {
	    throw new RangeError('size is too large');
	  }
	  var enc = encoding;
	  var _fill = fill;
	  if (_fill === undefined) {
	    enc = undefined;
	    _fill = 0;
	  }
	  var buf = new Buffer(size);
	  if (typeof _fill === 'string') {
	    var fillBuf = new Buffer(_fill, enc);
	    var flen = fillBuf.length;
	    var i = -1;
	    while (++i < size) {
	      buf[i] = fillBuf[i % flen];
	    }
	  } else {
	    buf.fill(_fill);
	  }
	  return buf;
	}
	exports.allocUnsafe = function allocUnsafe(size) {
	  if (typeof Buffer.allocUnsafe === 'function') {
	    return Buffer.allocUnsafe(size);
	  }
	  if (typeof size !== 'number') {
	    throw new TypeError('size must be a number');
	  }
	  if (size > MAX_LEN) {
	    throw new RangeError('size is too large');
	  }
	  return new Buffer(size);
	}
	exports.from = function from(value, encodingOrOffset, length) {
	  if (typeof Buffer.from === 'function' && (!global.Uint8Array || Uint8Array.from !== Buffer.from)) {
	    return Buffer.from(value, encodingOrOffset, length);
	  }
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number');
	  }
	  if (typeof value === 'string') {
	    return new Buffer(value, encodingOrOffset);
	  }
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    var offset = encodingOrOffset;
	    if (arguments.length === 1) {
	      return new Buffer(value);
	    }
	    if (typeof offset === 'undefined') {
	      offset = 0;
	    }
	    var len = length;
	    if (typeof len === 'undefined') {
	      len = value.byteLength - offset;
	    }
	    if (offset >= value.byteLength) {
	      throw new RangeError('\'offset\' is out of bounds');
	    }
	    if (len > value.byteLength - offset) {
	      throw new RangeError('\'length\' is out of bounds');
	    }
	    return new Buffer(value.slice(offset, offset + len));
	  }
	  if (Buffer.isBuffer(value)) {
	    var out = new Buffer(value.length);
	    value.copy(out, 0, 0, value.length);
	    return out;
	  }
	  if (value) {
	    if (Array.isArray(value) || (typeof ArrayBuffer !== 'undefined' && value.buffer instanceof ArrayBuffer) || 'length' in value) {
	      return new Buffer(value);
	    }
	    if (value.type === 'Buffer' && Array.isArray(value.data)) {
	      return new Buffer(value.data);
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ' + 'ArrayBuffer, Array, or array-like object.');
	}
	exports.allocUnsafeSlow = function allocUnsafeSlow(size) {
	  if (typeof Buffer.allocUnsafeSlow === 'function') {
	    return Buffer.allocUnsafeSlow(size);
	  }
	  if (typeof size !== 'number') {
	    throw new TypeError('size must be a number');
	  }
	  if (size >= MAX_LEN) {
	    throw new RangeError('size is too large');
	  }
	  return new SlowBuffer(size);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// Open simple dialogs on top of an editor. Relies on dialog.css.
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  function dialogDiv(cm, template, bottom) {
	    var wrap = cm.getWrapperElement();
	    var dialog;
	    dialog = wrap.appendChild(document.createElement("div"));
	    if (bottom)
	      dialog.className = "CodeMirror-dialog CodeMirror-dialog-bottom";
	    else
	      dialog.className = "CodeMirror-dialog CodeMirror-dialog-top";
	
	    if (typeof template == "string") {
	      dialog.innerHTML = template;
	    } else { // Assuming it's a detached DOM element.
	      dialog.appendChild(template);
	    }
	    return dialog;
	  }
	
	  function closeNotification(cm, newVal) {
	    if (cm.state.currentNotificationClose)
	      cm.state.currentNotificationClose();
	    cm.state.currentNotificationClose = newVal;
	  }
	
	  CodeMirror.defineExtension("openDialog", function(template, callback, options) {
	    if (!options) options = {};
	
	    closeNotification(this, null);
	
	    var dialog = dialogDiv(this, template, options.bottom);
	    var closed = false, me = this;
	    function close(newVal) {
	      if (typeof newVal == 'string') {
	        inp.value = newVal;
	      } else {
	        if (closed) return;
	        closed = true;
	        dialog.parentNode.removeChild(dialog);
	        me.focus();
	
	        if (options.onClose) options.onClose(dialog);
	      }
	    }
	
	    var inp = dialog.getElementsByTagName("input")[0], button;
	    if (inp) {
	      inp.focus();
	
	      if (options.value) {
	        inp.value = options.value;
	        if (options.selectValueOnOpen !== false) {
	          inp.select();
	        }
	      }
	
	      if (options.onInput)
	        CodeMirror.on(inp, "input", function(e) { options.onInput(e, inp.value, close);});
	      if (options.onKeyUp)
	        CodeMirror.on(inp, "keyup", function(e) {options.onKeyUp(e, inp.value, close);});
	
	      CodeMirror.on(inp, "keydown", function(e) {
	        if (options && options.onKeyDown && options.onKeyDown(e, inp.value, close)) { return; }
	        if (e.keyCode == 27 || (options.closeOnEnter !== false && e.keyCode == 13)) {
	          inp.blur();
	          CodeMirror.e_stop(e);
	          close();
	        }
	        if (e.keyCode == 13) callback(inp.value, e);
	      });
	
	      if (options.closeOnBlur !== false) CodeMirror.on(inp, "blur", close);
	    } else if (button = dialog.getElementsByTagName("button")[0]) {
	      CodeMirror.on(button, "click", function() {
	        close();
	        me.focus();
	      });
	
	      if (options.closeOnBlur !== false) CodeMirror.on(button, "blur", close);
	
	      button.focus();
	    }
	    return close;
	  });
	
	  CodeMirror.defineExtension("openConfirm", function(template, callbacks, options) {
	    closeNotification(this, null);
	    var dialog = dialogDiv(this, template, options && options.bottom);
	    var buttons = dialog.getElementsByTagName("button");
	    var closed = false, me = this, blurring = 1;
	    function close() {
	      if (closed) return;
	      closed = true;
	      dialog.parentNode.removeChild(dialog);
	      me.focus();
	    }
	    buttons[0].focus();
	    for (var i = 0; i < buttons.length; ++i) {
	      var b = buttons[i];
	      (function(callback) {
	        CodeMirror.on(b, "click", function(e) {
	          CodeMirror.e_preventDefault(e);
	          close();
	          if (callback) callback(me);
	        });
	      })(callbacks[i]);
	      CodeMirror.on(b, "blur", function() {
	        --blurring;
	        setTimeout(function() { if (blurring <= 0) close(); }, 200);
	      });
	      CodeMirror.on(b, "focus", function() { ++blurring; });
	    }
	  });
	
	  /*
	   * openNotification
	   * Opens a notification, that can be closed with an optional timer
	   * (default 5000ms timer) and always closes on click.
	   *
	   * If a notification is opened while another is opened, it will close the
	   * currently opened one and open the new one immediately.
	   */
	  CodeMirror.defineExtension("openNotification", function(template, options) {
	    closeNotification(this, close);
	    var dialog = dialogDiv(this, template, options && options.bottom);
	    var closed = false, doneTimer;
	    var duration = options && typeof options.duration !== "undefined" ? options.duration : 5000;
	
	    function close() {
	      if (closed) return;
	      closed = true;
	      clearTimeout(doneTimer);
	      dialog.parentNode.removeChild(dialog);
	    }
	
	    CodeMirror.on(dialog, 'click', function(e) {
	      CodeMirror.e_preventDefault(e);
	      close();
	    });
	
	    if (duration)
	      doneTimer = setTimeout(close, duration);
	
	    return close;
	  });
	});


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  var ie_lt8 = /MSIE \d/.test(navigator.userAgent) &&
	    (document.documentMode == null || document.documentMode < 8);
	
	  var Pos = CodeMirror.Pos;
	
	  var matching = {"(": ")>", ")": "(<", "[": "]>", "]": "[<", "{": "}>", "}": "{<"};
	
	  function findMatchingBracket(cm, where, strict, config) {
	    var line = cm.getLineHandle(where.line), pos = where.ch - 1;
	    var match = (pos >= 0 && matching[line.text.charAt(pos)]) || matching[line.text.charAt(++pos)];
	    if (!match) return null;
	    var dir = match.charAt(1) == ">" ? 1 : -1;
	    if (strict && (dir > 0) != (pos == where.ch)) return null;
	    var style = cm.getTokenTypeAt(Pos(where.line, pos + 1));
	
	    var found = scanForBracket(cm, Pos(where.line, pos + (dir > 0 ? 1 : 0)), dir, style || null, config);
	    if (found == null) return null;
	    return {from: Pos(where.line, pos), to: found && found.pos,
	            match: found && found.ch == match.charAt(0), forward: dir > 0};
	  }
	
	  // bracketRegex is used to specify which type of bracket to scan
	  // should be a regexp, e.g. /[[\]]/
	  //
	  // Note: If "where" is on an open bracket, then this bracket is ignored.
	  //
	  // Returns false when no bracket was found, null when it reached
	  // maxScanLines and gave up
	  function scanForBracket(cm, where, dir, style, config) {
	    var maxScanLen = (config && config.maxScanLineLength) || 10000;
	    var maxScanLines = (config && config.maxScanLines) || 1000;
	
	    var stack = [];
	    var re = config && config.bracketRegex ? config.bracketRegex : /[(){}[\]]/;
	    var lineEnd = dir > 0 ? Math.min(where.line + maxScanLines, cm.lastLine() + 1)
	                          : Math.max(cm.firstLine() - 1, where.line - maxScanLines);
	    for (var lineNo = where.line; lineNo != lineEnd; lineNo += dir) {
	      var line = cm.getLine(lineNo);
	      if (!line) continue;
	      var pos = dir > 0 ? 0 : line.length - 1, end = dir > 0 ? line.length : -1;
	      if (line.length > maxScanLen) continue;
	      if (lineNo == where.line) pos = where.ch - (dir < 0 ? 1 : 0);
	      for (; pos != end; pos += dir) {
	        var ch = line.charAt(pos);
	        if (re.test(ch) && (style === undefined || cm.getTokenTypeAt(Pos(lineNo, pos + 1)) == style)) {
	          var match = matching[ch];
	          if ((match.charAt(1) == ">") == (dir > 0)) stack.push(ch);
	          else if (!stack.length) return {pos: Pos(lineNo, pos), ch: ch};
	          else stack.pop();
	        }
	      }
	    }
	    return lineNo - dir == (dir > 0 ? cm.lastLine() : cm.firstLine()) ? false : null;
	  }
	
	  function matchBrackets(cm, autoclear, config) {
	    // Disable brace matching in long lines, since it'll cause hugely slow updates
	    var maxHighlightLen = cm.state.matchBrackets.maxHighlightLineLength || 1000;
	    var marks = [], ranges = cm.listSelections();
	    for (var i = 0; i < ranges.length; i++) {
	      var match = ranges[i].empty() && findMatchingBracket(cm, ranges[i].head, false, config);
	      if (match && cm.getLine(match.from.line).length <= maxHighlightLen) {
	        var style = match.match ? "CodeMirror-matchingbracket" : "CodeMirror-nonmatchingbracket";
	        marks.push(cm.markText(match.from, Pos(match.from.line, match.from.ch + 1), {className: style}));
	        if (match.to && cm.getLine(match.to.line).length <= maxHighlightLen)
	          marks.push(cm.markText(match.to, Pos(match.to.line, match.to.ch + 1), {className: style}));
	      }
	    }
	
	    if (marks.length) {
	      // Kludge to work around the IE bug from issue #1193, where text
	      // input stops going to the textare whever this fires.
	      if (ie_lt8 && cm.state.focused) cm.focus();
	
	      var clear = function() {
	        cm.operation(function() {
	          for (var i = 0; i < marks.length; i++) marks[i].clear();
	        });
	      };
	      if (autoclear) setTimeout(clear, 800);
	      else return clear;
	    }
	  }
	
	  var currentlyHighlighted = null;
	  function doMatchBrackets(cm) {
	    cm.operation(function() {
	      if (currentlyHighlighted) {currentlyHighlighted(); currentlyHighlighted = null;}
	      currentlyHighlighted = matchBrackets(cm, false, cm.state.matchBrackets);
	    });
	  }
	
	  CodeMirror.defineOption("matchBrackets", false, function(cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      cm.off("cursorActivity", doMatchBrackets);
	      if (currentlyHighlighted) {currentlyHighlighted(); currentlyHighlighted = null;}
	    }
	    if (val) {
	      cm.state.matchBrackets = typeof val == "object" ? val : {};
	      cm.on("cursorActivity", doMatchBrackets);
	    }
	  });
	
	  CodeMirror.defineExtension("matchBrackets", function() {matchBrackets(this, true);});
	  CodeMirror.defineExtension("findMatchingBracket", function(pos, strict, config){
	    return findMatchingBracket(this, pos, strict, config);
	  });
	  CodeMirror.defineExtension("scanForBracket", function(pos, dir, style, config){
	    return scanForBracket(this, pos, dir, style, config);
	  });
	});


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.multiplexingMode = function(outer /*, others */) {
	  // Others should be {open, close, mode [, delimStyle] [, innerStyle]} objects
	  var others = Array.prototype.slice.call(arguments, 1);
	
	  function indexOf(string, pattern, from, returnEnd) {
	    if (typeof pattern == "string") {
	      var found = string.indexOf(pattern, from);
	      return returnEnd && found > -1 ? found + pattern.length : found;
	    }
	    var m = pattern.exec(from ? string.slice(from) : string);
	    return m ? m.index + from + (returnEnd ? m[0].length : 0) : -1;
	  }
	
	  return {
	    startState: function() {
	      return {
	        outer: CodeMirror.startState(outer),
	        innerActive: null,
	        inner: null
	      };
	    },
	
	    copyState: function(state) {
	      return {
	        outer: CodeMirror.copyState(outer, state.outer),
	        innerActive: state.innerActive,
	        inner: state.innerActive && CodeMirror.copyState(state.innerActive.mode, state.inner)
	      };
	    },
	
	    token: function(stream, state) {
	      if (!state.innerActive) {
	        var cutOff = Infinity, oldContent = stream.string;
	        for (var i = 0; i < others.length; ++i) {
	          var other = others[i];
	          var found = indexOf(oldContent, other.open, stream.pos);
	          if (found == stream.pos) {
	            if (!other.parseDelimiters) stream.match(other.open);
	            state.innerActive = other;
	            state.inner = CodeMirror.startState(other.mode, outer.indent ? outer.indent(state.outer, "") : 0);
	            return other.delimStyle && (other.delimStyle + " " + other.delimStyle + "-open");
	          } else if (found != -1 && found < cutOff) {
	            cutOff = found;
	          }
	        }
	        if (cutOff != Infinity) stream.string = oldContent.slice(0, cutOff);
	        var outerToken = outer.token(stream, state.outer);
	        if (cutOff != Infinity) stream.string = oldContent;
	        return outerToken;
	      } else {
	        var curInner = state.innerActive, oldContent = stream.string;
	        if (!curInner.close && stream.sol()) {
	          state.innerActive = state.inner = null;
	          return this.token(stream, state);
	        }
	        var found = curInner.close ? indexOf(oldContent, curInner.close, stream.pos, curInner.parseDelimiters) : -1;
	        if (found == stream.pos && !curInner.parseDelimiters) {
	          stream.match(curInner.close);
	          state.innerActive = state.inner = null;
	          return curInner.delimStyle && (curInner.delimStyle + " " + curInner.delimStyle + "-close");
	        }
	        if (found > -1) stream.string = oldContent.slice(0, found);
	        var innerToken = curInner.mode.token(stream, state.inner);
	        if (found > -1) stream.string = oldContent;
	
	        if (found == stream.pos && curInner.parseDelimiters)
	          state.innerActive = state.inner = null;
	
	        if (curInner.innerStyle) {
	          if (innerToken) innerToken = innerToken + " " + curInner.innerStyle;
	          else innerToken = curInner.innerStyle;
	        }
	
	        return innerToken;
	      }
	    },
	
	    indent: function(state, textAfter) {
	      var mode = state.innerActive ? state.innerActive.mode : outer;
	      if (!mode.indent) return CodeMirror.Pass;
	      return mode.indent(state.innerActive ? state.inner : state.outer, textAfter);
	    },
	
	    blankLine: function(state) {
	      var mode = state.innerActive ? state.innerActive.mode : outer;
	      if (mode.blankLine) {
	        mode.blankLine(state.innerActive ? state.inner : state.outer);
	      }
	      if (!state.innerActive) {
	        for (var i = 0; i < others.length; ++i) {
	          var other = others[i];
	          if (other.open === "\n") {
	            state.innerActive = other;
	            state.inner = CodeMirror.startState(other.mode, mode.indent ? mode.indent(state.outer, "") : 0);
	          }
	        }
	      } else if (state.innerActive.close === "\n") {
	        state.innerActive = state.inner = null;
	      }
	    },
	
	    electricChars: outer.electricChars,
	
	    innerMode: function(state) {
	      return state.inner ? {state: state.inner, mode: state.innerActive.mode} : {state: state.outer, mode: outer};
	    }
	  };
	};
	
	});


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("ruby", function(config) {
	  function wordObj(words) {
	    var o = {};
	    for (var i = 0, e = words.length; i < e; ++i) o[words[i]] = true;
	    return o;
	  }
	  var keywords = wordObj([
	    "alias", "and", "BEGIN", "begin", "break", "case", "class", "def", "defined?", "do", "else",
	    "elsif", "END", "end", "ensure", "false", "for", "if", "in", "module", "next", "not", "or",
	    "redo", "rescue", "retry", "return", "self", "super", "then", "true", "undef", "unless",
	    "until", "when", "while", "yield", "nil", "raise", "throw", "catch", "fail", "loop", "callcc",
	    "caller", "lambda", "proc", "public", "protected", "private", "require", "load",
	    "require_relative", "extend", "autoload", "__END__", "__FILE__", "__LINE__", "__dir__"
	  ]);
	  var indentWords = wordObj(["def", "class", "case", "for", "while", "until", "module", "then",
	                             "catch", "loop", "proc", "begin"]);
	  var dedentWords = wordObj(["end", "until"]);
	  var matching = {"[": "]", "{": "}", "(": ")"};
	  var curPunc;
	
	  function chain(newtok, stream, state) {
	    state.tokenize.push(newtok);
	    return newtok(stream, state);
	  }
	
	  function tokenBase(stream, state) {
	    if (stream.sol() && stream.match("=begin") && stream.eol()) {
	      state.tokenize.push(readBlockComment);
	      return "comment";
	    }
	    if (stream.eatSpace()) return null;
	    var ch = stream.next(), m;
	    if (ch == "`" || ch == "'" || ch == '"') {
	      return chain(readQuoted(ch, "string", ch == '"' || ch == "`"), stream, state);
	    } else if (ch == "/") {
	      var currentIndex = stream.current().length;
	      if (stream.skipTo("/")) {
	        var search_till = stream.current().length;
	        stream.backUp(stream.current().length - currentIndex);
	        var balance = 0;  // balance brackets
	        while (stream.current().length < search_till) {
	          var chchr = stream.next();
	          if (chchr == "(") balance += 1;
	          else if (chchr == ")") balance -= 1;
	          if (balance < 0) break;
	        }
	        stream.backUp(stream.current().length - currentIndex);
	        if (balance == 0)
	          return chain(readQuoted(ch, "string-2", true), stream, state);
	      }
	      return "operator";
	    } else if (ch == "%") {
	      var style = "string", embed = true;
	      if (stream.eat("s")) style = "atom";
	      else if (stream.eat(/[WQ]/)) style = "string";
	      else if (stream.eat(/[r]/)) style = "string-2";
	      else if (stream.eat(/[wxq]/)) { style = "string"; embed = false; }
	      var delim = stream.eat(/[^\w\s=]/);
	      if (!delim) return "operator";
	      if (matching.propertyIsEnumerable(delim)) delim = matching[delim];
	      return chain(readQuoted(delim, style, embed, true), stream, state);
	    } else if (ch == "#") {
	      stream.skipToEnd();
	      return "comment";
	    } else if (ch == "<" && (m = stream.match(/^<-?[\`\"\']?([a-zA-Z_?]\w*)[\`\"\']?(?:;|$)/))) {
	      return chain(readHereDoc(m[1]), stream, state);
	    } else if (ch == "0") {
	      if (stream.eat("x")) stream.eatWhile(/[\da-fA-F]/);
	      else if (stream.eat("b")) stream.eatWhile(/[01]/);
	      else stream.eatWhile(/[0-7]/);
	      return "number";
	    } else if (/\d/.test(ch)) {
	      stream.match(/^[\d_]*(?:\.[\d_]+)?(?:[eE][+\-]?[\d_]+)?/);
	      return "number";
	    } else if (ch == "?") {
	      while (stream.match(/^\\[CM]-/)) {}
	      if (stream.eat("\\")) stream.eatWhile(/\w/);
	      else stream.next();
	      return "string";
	    } else if (ch == ":") {
	      if (stream.eat("'")) return chain(readQuoted("'", "atom", false), stream, state);
	      if (stream.eat('"')) return chain(readQuoted('"', "atom", true), stream, state);
	
	      // :> :>> :< :<< are valid symbols
	      if (stream.eat(/[\<\>]/)) {
	        stream.eat(/[\<\>]/);
	        return "atom";
	      }
	
	      // :+ :- :/ :* :| :& :! are valid symbols
	      if (stream.eat(/[\+\-\*\/\&\|\:\!]/)) {
	        return "atom";
	      }
	
	      // Symbols can't start by a digit
	      if (stream.eat(/[a-zA-Z$@_\xa1-\uffff]/)) {
	        stream.eatWhile(/[\w$\xa1-\uffff]/);
	        // Only one ? ! = is allowed and only as the last character
	        stream.eat(/[\?\!\=]/);
	        return "atom";
	      }
	      return "operator";
	    } else if (ch == "@" && stream.match(/^@?[a-zA-Z_\xa1-\uffff]/)) {
	      stream.eat("@");
	      stream.eatWhile(/[\w\xa1-\uffff]/);
	      return "variable-2";
	    } else if (ch == "$") {
	      if (stream.eat(/[a-zA-Z_]/)) {
	        stream.eatWhile(/[\w]/);
	      } else if (stream.eat(/\d/)) {
	        stream.eat(/\d/);
	      } else {
	        stream.next(); // Must be a special global like $: or $!
	      }
	      return "variable-3";
	    } else if (/[a-zA-Z_\xa1-\uffff]/.test(ch)) {
	      stream.eatWhile(/[\w\xa1-\uffff]/);
	      stream.eat(/[\?\!]/);
	      if (stream.eat(":")) return "atom";
	      return "ident";
	    } else if (ch == "|" && (state.varList || state.lastTok == "{" || state.lastTok == "do")) {
	      curPunc = "|";
	      return null;
	    } else if (/[\(\)\[\]{}\\;]/.test(ch)) {
	      curPunc = ch;
	      return null;
	    } else if (ch == "-" && stream.eat(">")) {
	      return "arrow";
	    } else if (/[=+\-\/*:\.^%<>~|]/.test(ch)) {
	      var more = stream.eatWhile(/[=+\-\/*:\.^%<>~|]/);
	      if (ch == "." && !more) curPunc = ".";
	      return "operator";
	    } else {
	      return null;
	    }
	  }
	
	  function tokenBaseUntilBrace(depth) {
	    if (!depth) depth = 1;
	    return function(stream, state) {
	      if (stream.peek() == "}") {
	        if (depth == 1) {
	          state.tokenize.pop();
	          return state.tokenize[state.tokenize.length-1](stream, state);
	        } else {
	          state.tokenize[state.tokenize.length - 1] = tokenBaseUntilBrace(depth - 1);
	        }
	      } else if (stream.peek() == "{") {
	        state.tokenize[state.tokenize.length - 1] = tokenBaseUntilBrace(depth + 1);
	      }
	      return tokenBase(stream, state);
	    };
	  }
	  function tokenBaseOnce() {
	    var alreadyCalled = false;
	    return function(stream, state) {
	      if (alreadyCalled) {
	        state.tokenize.pop();
	        return state.tokenize[state.tokenize.length-1](stream, state);
	      }
	      alreadyCalled = true;
	      return tokenBase(stream, state);
	    };
	  }
	  function readQuoted(quote, style, embed, unescaped) {
	    return function(stream, state) {
	      var escaped = false, ch;
	
	      if (state.context.type === 'read-quoted-paused') {
	        state.context = state.context.prev;
	        stream.eat("}");
	      }
	
	      while ((ch = stream.next()) != null) {
	        if (ch == quote && (unescaped || !escaped)) {
	          state.tokenize.pop();
	          break;
	        }
	        if (embed && ch == "#" && !escaped) {
	          if (stream.eat("{")) {
	            if (quote == "}") {
	              state.context = {prev: state.context, type: 'read-quoted-paused'};
	            }
	            state.tokenize.push(tokenBaseUntilBrace());
	            break;
	          } else if (/[@\$]/.test(stream.peek())) {
	            state.tokenize.push(tokenBaseOnce());
	            break;
	          }
	        }
	        escaped = !escaped && ch == "\\";
	      }
	      return style;
	    };
	  }
	  function readHereDoc(phrase) {
	    return function(stream, state) {
	      if (stream.match(phrase)) state.tokenize.pop();
	      else stream.skipToEnd();
	      return "string";
	    };
	  }
	  function readBlockComment(stream, state) {
	    if (stream.sol() && stream.match("=end") && stream.eol())
	      state.tokenize.pop();
	    stream.skipToEnd();
	    return "comment";
	  }
	
	  return {
	    startState: function() {
	      return {tokenize: [tokenBase],
	              indented: 0,
	              context: {type: "top", indented: -config.indentUnit},
	              continuedLine: false,
	              lastTok: null,
	              varList: false};
	    },
	
	    token: function(stream, state) {
	      curPunc = null;
	      if (stream.sol()) state.indented = stream.indentation();
	      var style = state.tokenize[state.tokenize.length-1](stream, state), kwtype;
	      var thisTok = curPunc;
	      if (style == "ident") {
	        var word = stream.current();
	        style = state.lastTok == "." ? "property"
	          : keywords.propertyIsEnumerable(stream.current()) ? "keyword"
	          : /^[A-Z]/.test(word) ? "tag"
	          : (state.lastTok == "def" || state.lastTok == "class" || state.varList) ? "def"
	          : "variable";
	        if (style == "keyword") {
	          thisTok = word;
	          if (indentWords.propertyIsEnumerable(word)) kwtype = "indent";
	          else if (dedentWords.propertyIsEnumerable(word)) kwtype = "dedent";
	          else if ((word == "if" || word == "unless") && stream.column() == stream.indentation())
	            kwtype = "indent";
	          else if (word == "do" && state.context.indented < state.indented)
	            kwtype = "indent";
	        }
	      }
	      if (curPunc || (style && style != "comment")) state.lastTok = thisTok;
	      if (curPunc == "|") state.varList = !state.varList;
	
	      if (kwtype == "indent" || /[\(\[\{]/.test(curPunc))
	        state.context = {prev: state.context, type: curPunc || style, indented: state.indented};
	      else if ((kwtype == "dedent" || /[\)\]\}]/.test(curPunc)) && state.context.prev)
	        state.context = state.context.prev;
	
	      if (stream.eol())
	        state.continuedLine = (curPunc == "\\" || style == "operator");
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      if (state.tokenize[state.tokenize.length-1] != tokenBase) return 0;
	      var firstChar = textAfter && textAfter.charAt(0);
	      var ct = state.context;
	      var closing = ct.type == matching[firstChar] ||
	        ct.type == "keyword" && /^(?:end|until|else|elsif|when|rescue)\b/.test(textAfter);
	      return ct.indented + (closing ? 0 : config.indentUnit) +
	        (state.continuedLine ? config.indentUnit : 0);
	    },
	
	    electricInput: /^\s*(?:end|rescue|elsif|else|\})$/,
	    lineComment: "#"
	  };
	});
	
	CodeMirror.defineMIME("text/x-ruby", "ruby");
	
	});


/***/ },
/* 47 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 48 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 50 */
/***/ function(module, exports) {

	module.exports = true;

/***/ },
/* 51 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(15).f
	  , has = __webpack_require__(9)
	  , TAG = __webpack_require__(16)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(54)('keys')
	  , uid    = __webpack_require__(33);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(7)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 55 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(30);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(7)
	  , core           = __webpack_require__(28)
	  , LIBRARY        = __webpack_require__(50)
	  , wksExt         = __webpack_require__(58)
	  , defineProperty = __webpack_require__(15).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(16);

/***/ },
/* 59 */
/***/ function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ParseError = (function (_super) {
	    __extends(ParseError, _super);
	    function ParseError(message, path) {
	        var _this = _super.call(this) || this;
	        _this.path = path;
	        Error.captureStackTrace(_this, _this.constructor);
	        _this.name = 'ParseError';
	        _this.message = message;
	        _this.path = path;
	        return _this;
	    }
	    return ParseError;
	}(Error));
	module.exports = ParseError;


/***/ },
/* 60 */
/***/ function(module, exports) {

	'use strict';
	
	exports.isObject = function(value) {
	  return (null !== value && typeof value === typeof {} && !exports.isArray(value));
	};
	
	exports.isNumber = function(value) {
	  return !exports.isArray( value ) && (value - parseFloat( value ) + 1) >= 0;
	};
	
	exports.isArray = function(value) {
	  return (value instanceof Array);
	};
	
	exports.isString = function(value) {
	  return (typeof value === typeof '');
	};
	
	exports.isNull = function(value) {
	  return (null === value);
	};
	
	exports.isBoolean = function(value) {
	  return (value === true || value === false);
	};
	
	exports.toObject = function(arr) {
	  var rv = {};
	  for (var i = 0; i < arr.length; ++i)
	    rv[i] = arr[i];
	  return rv;
	};
	
	exports.oneIsNull = function(v1, v2) {
	  return ((v1 === null && v2 !== null) || (v1 !== null && v2 === null));
	};
	
	exports.isUndefined = function(val) {
	  return (null === val || typeof val === 'undefined');
	};
	
	exports.isFunction = function(fn) {
	  return (typeof fn === 'function');
	};
	
	exports.isEqual = function(v1, v2) {
	  if (typeof v1 !== typeof v2 || exports.oneIsNull(v1, v2)) {
	    return false;
	  }
	
	  if (typeof v1 === typeof "" || typeof v1 === typeof 0) {
	    return v1 === v2;
	  }
	
	  var _isEqual = true;
	
	  if (typeof v1 === typeof {}) {
	    var compare = function(value1, value2) {
	      for (var i in value1) {
	        if (!value2.hasOwnProperty(i)) {
	          _isEqual = false;
	          break;
	        }
	
	        if (exports.isObject(value1[i])) {
	          compare(value1[i], value2[i]);
	        } else if (typeof value1[i] === typeof "") {
	          if (value1[i] !== value2[i]) {
	            _isEqual = false;
	            break;
	          }
	        }
	      }
	    }
	
	    compare(v1, v2);
	  }
	
	  return _isEqual;
	};
	
	exports.getType = function(data) {
	  if (exports.isObject(data)) {
	    return 'object';
	  } else if (exports.isArray(data)) {
	    return 'array';
	  } else if (exports.isNull(data)) {
	    return null;
	  } else if (exports.isBoolean(data)) {
	    return 'boolean';
	  } else if (exports.isString(data)) {
	    return 'string';
	  } else if (exports.isNumber(data)) {
	    return 'number';
	  }
	};

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = nextTick;
	} else {
	  module.exports = process.nextTick;
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(11);
	
	/*<replacement>*/
	var util = __webpack_require__(23);
	util.inherits = __webpack_require__(4);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function TransformState(stream) {
	  this.afterTransform = function (er, data) {
	    return afterTransform(stream, er, data);
	  };
	
	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	  this.writeencoding = null;
	}
	
	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data !== null && data !== undefined) stream.push(data);
	
	  cb(er);
	
	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = new TransformState(this);
	
	  var stream = this;
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.once('prefinish', function () {
	    if (typeof this._flush === 'function') this._flush(function (er, data) {
	      done(stream, er, data);
	    });else done(stream);
	  });
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data !== null && data !== undefined) stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;
	
	  if (ws.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (ts.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate) {// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	module.exports = Writable;
	
	/*<replacement>*/
	var processNextTick = __webpack_require__(61);
	/*</replacement>*/
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(23);
	util.inherits = __webpack_require__(4);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(1364)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream;
	(function () {
	  try {
	    Stream = __webpack_require__(38);
	  } catch (_) {} finally {
	    if (!Stream) Stream = __webpack_require__(35).EventEmitter;
	  }
	})();
	/*</replacement>*/
	
	var Buffer = __webpack_require__(3).Buffer;
	/*<replacement>*/
	var bufferShim = __webpack_require__(42);
	/*</replacement>*/
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(11);
	
	  options = options || {};
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = ~ ~this.highWaterMark;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(11);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  processNextTick(cb, er);
	}
	
	// If we get something that is not a buffer, string, null, or undefined,
	// and we're not in objectMode, then that's an error.
	// Otherwise stream chunks are all considered to be of length=1, and the
	// watermarks determine how many objects to keep in the buffer, rather than
	// how many bytes or characters.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	  // Always throw error if a null is written
	  // if we are not in object mode then throw
	  // if it is not a buffer, string, or undefined.
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    processNextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (Buffer.isBuffer(chunk)) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = bufferShim.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, chunk, encoding, cb) {
	  chunk = decodeChunk(state, chunk, encoding);
	
	  if (Buffer.isBuffer(chunk)) encoding = 'buffer';
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	  if (sync) processNextTick(cb, er);else cb(er);
	
	  stream._writableState.errorEmitted = true;
	  stream.emit('error', er);
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	        afterWrite(stream, state, finished, cb);
	      }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    while (entry) {
	      buffer[count] = entry;
	      entry = entry.next;
	      count += 1;
	    }
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequestCount = 0;
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	
	function prefinish(stream, state) {
	  if (!state.prefinished) {
	    state.prefinished = true;
	    stream.emit('prefinish');
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    if (state.pendingcb === 0) {
	      prefinish(stream, state);
	      state.finished = true;
	      stream.emit('finish');
	    } else {
	      prefinish(stream, state);
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	
	  this.finish = function (err) {
	    var entry = _this.entry;
	    _this.entry = null;
	    while (entry) {
	      var cb = entry.callback;
	      state.pendingcb--;
	      cb(err);
	      entry = entry.next;
	    }
	    if (state.corkedRequestsFree) {
	      state.corkedRequestsFree.next = _this;
	    } else {
	      state.corkedRequestsFree = _this;
	    }
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18), __webpack_require__(1362).setImmediate))

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(1366);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(1365);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(18)))

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = function (crypto, password, keyLen, ivLen) {
	  keyLen = keyLen/8;
	  ivLen = ivLen || 0;
	  var ki = 0;
	  var ii = 0;
	  var key = new Buffer(keyLen);
	  var iv = new Buffer(ivLen);
	  var addmd = 0;
	  var md, md_buf;
	  var i;
	  while (true) {
	    md = crypto.createHash('md5');
	    if(addmd++ > 0) {
	       md.update(md_buf);
	    }
	    md.update(password);
	    md_buf = md.digest();
	    i = 0;
	    if(keyLen > 0) {
	      while(true) {
	        if(keyLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	        key[ki++] = md_buf[i];
	        keyLen--;
	        i++;
	       }
	    }
	    if(ivLen > 0 && i !== md_buf.length) {
	      while(true) {
	        if(ivLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	       iv[ii++] = md_buf[i];
	       ivLen--;
	       i++;
	     }
	   }
	   if(keyLen === 0 && ivLen === 0) {
	      break;
	    }
	  }
	  for(i=0;i<md_buf.length;i++) {
	    md_buf[i] = 0;
	  }
	  return {
	    key: key,
	    iv: iv
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var xor = __webpack_require__(25);
	exports.encrypt = function (self, block) {
	  var data = xor(block, self._prev);
	  self._prev = self._cipher.encryptBlock(data);
	  return self._prev;
	};
	exports.decrypt = function (self, block) {
	  var pad = self._prev;
	  self._prev = block;
	  var out = self._cipher.decryptBlock(block);
	  return xor(out, pad);
	};

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(25);
	exports.encrypt = function (self, data, decrypt) {
	  var out = new Buffer('');
	  var len;
	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev);
	      self._prev = new Buffer('');
	    }
	    if (self._cache.length <= data.length) {
	      len = self._cache.length;
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
	      data = data.slice(len);
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
	      break;
	    }
	  }
	  return out;
	};
	function encryptStart(self, data, decrypt) {
	  var len = data.length;
	  var out = xor(data, self._cache);
	  self._cache = self._cache.slice(len);
	  self._prev = Buffer.concat([self._prev, decrypt?data:out]);
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(25);
	function getBlock(self) {
	  var out = self._cipher.encryptBlock(self._prev);
	  incr32(self._prev);
	  return out;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	function incr32(iv) {
	  var len = iv.length;
	  var item;
	  while (len--) {
	    item = iv.readUInt8(len);
	    if (item === 255) {
	      iv.writeUInt8(0, len);
	    } else {
	      item++;
	      iv.writeUInt8(item, len);
	      break;
	    }
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ },
/* 69 */
/***/ function(module, exports) {

	exports.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block);
	};
	exports.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block);
	};

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(25);
	function getBlock(self) {
	  self._prev = self._cipher.encryptBlock(self._prev);
	  return self._prev;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(39);
	var Transform = __webpack_require__(40);
	var inherits = __webpack_require__(4);
	
	inherits(StreamCipher, Transform);
	module.exports = StreamCipher;
	function StreamCipher(mode, key, iv, decrypt) {
	  if (!(this instanceof StreamCipher)) {
	    return new StreamCipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  this._cache = new Buffer('');
	  this._secCache = new Buffer('');
	  this._decrypt = decrypt;
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	StreamCipher.prototype._transform = function (chunk, _, next) {
	  next(null, this._mode.encrypt(this, chunk, this._decrypt));
	};
	StreamCipher.prototype._flush = function (next) {
	  this._cipher.scrub();
	  next();
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  function doFold(cm, pos, options, force) {
	    if (options && options.call) {
	      var finder = options;
	      options = null;
	    } else {
	      var finder = getOption(cm, options, "rangeFinder");
	    }
	    if (typeof pos == "number") pos = CodeMirror.Pos(pos, 0);
	    var minSize = getOption(cm, options, "minFoldSize");
	
	    function getRange(allowFolded) {
	      var range = finder(cm, pos);
	      if (!range || range.to.line - range.from.line < minSize) return null;
	      var marks = cm.findMarksAt(range.from);
	      for (var i = 0; i < marks.length; ++i) {
	        if (marks[i].__isFold && force !== "fold") {
	          if (!allowFolded) return null;
	          range.cleared = true;
	          marks[i].clear();
	        }
	      }
	      return range;
	    }
	
	    var range = getRange(true);
	    if (getOption(cm, options, "scanUp")) while (!range && pos.line > cm.firstLine()) {
	      pos = CodeMirror.Pos(pos.line - 1, 0);
	      range = getRange(false);
	    }
	    if (!range || range.cleared || force === "unfold") return;
	
	    var myWidget = makeWidget(cm, options);
	    CodeMirror.on(myWidget, "mousedown", function(e) {
	      myRange.clear();
	      CodeMirror.e_preventDefault(e);
	    });
	    var myRange = cm.markText(range.from, range.to, {
	      replacedWith: myWidget,
	      clearOnEnter: getOption(cm, options, "clearOnEnter"),
	      __isFold: true
	    });
	    myRange.on("clear", function(from, to) {
	      CodeMirror.signal(cm, "unfold", cm, from, to);
	    });
	    CodeMirror.signal(cm, "fold", cm, range.from, range.to);
	  }
	
	  function makeWidget(cm, options) {
	    var widget = getOption(cm, options, "widget");
	    if (typeof widget == "string") {
	      var text = document.createTextNode(widget);
	      widget = document.createElement("span");
	      widget.appendChild(text);
	      widget.className = "CodeMirror-foldmarker";
	    }
	    return widget;
	  }
	
	  // Clumsy backwards-compatible interface
	  CodeMirror.newFoldFunction = function(rangeFinder, widget) {
	    return function(cm, pos) { doFold(cm, pos, {rangeFinder: rangeFinder, widget: widget}); };
	  };
	
	  // New-style interface
	  CodeMirror.defineExtension("foldCode", function(pos, options, force) {
	    doFold(this, pos, options, force);
	  });
	
	  CodeMirror.defineExtension("isFolded", function(pos) {
	    var marks = this.findMarksAt(pos);
	    for (var i = 0; i < marks.length; ++i)
	      if (marks[i].__isFold) return true;
	  });
	
	  CodeMirror.commands.toggleFold = function(cm) {
	    cm.foldCode(cm.getCursor());
	  };
	  CodeMirror.commands.fold = function(cm) {
	    cm.foldCode(cm.getCursor(), null, "fold");
	  };
	  CodeMirror.commands.unfold = function(cm) {
	    cm.foldCode(cm.getCursor(), null, "unfold");
	  };
	  CodeMirror.commands.foldAll = function(cm) {
	    cm.operation(function() {
	      for (var i = cm.firstLine(), e = cm.lastLine(); i <= e; i++)
	        cm.foldCode(CodeMirror.Pos(i, 0), null, "fold");
	    });
	  };
	  CodeMirror.commands.unfoldAll = function(cm) {
	    cm.operation(function() {
	      for (var i = cm.firstLine(), e = cm.lastLine(); i <= e; i++)
	        cm.foldCode(CodeMirror.Pos(i, 0), null, "unfold");
	    });
	  };
	
	  CodeMirror.registerHelper("fold", "combine", function() {
	    var funcs = Array.prototype.slice.call(arguments, 0);
	    return function(cm, start) {
	      for (var i = 0; i < funcs.length; ++i) {
	        var found = funcs[i](cm, start);
	        if (found) return found;
	      }
	    };
	  });
	
	  CodeMirror.registerHelper("fold", "auto", function(cm, start) {
	    var helpers = cm.getHelpers(start, "fold");
	    for (var i = 0; i < helpers.length; i++) {
	      var cur = helpers[i](cm, start);
	      if (cur) return cur;
	    }
	  });
	
	  var defaultOptions = {
	    rangeFinder: CodeMirror.fold.auto,
	    widget: "\u2194",
	    minFoldSize: 0,
	    scanUp: false,
	    clearOnEnter: true
	  };
	
	  CodeMirror.defineOption("foldOptions", null);
	
	  function getOption(cm, options, name) {
	    if (options && options[name] !== undefined)
	      return options[name];
	    var editorOptions = cm.options.foldOptions;
	    if (editorOptions && editorOptions[name] !== undefined)
	      return editorOptions[name];
	    return defaultOptions[name];
	  }
	
	  CodeMirror.defineExtension("foldOption", function(options, name) {
	    return getOption(this, options, name);
	  });
	});


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  var Pos = CodeMirror.Pos;
	  function cmp(a, b) { return a.line - b.line || a.ch - b.ch; }
	
	  var nameStartChar = "A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
	  var nameChar = nameStartChar + "\-\:\.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
	  var xmlTagStart = new RegExp("<(/?)([" + nameStartChar + "][" + nameChar + "]*)", "g");
	
	  function Iter(cm, line, ch, range) {
	    this.line = line; this.ch = ch;
	    this.cm = cm; this.text = cm.getLine(line);
	    this.min = range ? Math.max(range.from, cm.firstLine()) : cm.firstLine();
	    this.max = range ? Math.min(range.to - 1, cm.lastLine()) : cm.lastLine();
	  }
	
	  function tagAt(iter, ch) {
	    var type = iter.cm.getTokenTypeAt(Pos(iter.line, ch));
	    return type && /\btag\b/.test(type);
	  }
	
	  function nextLine(iter) {
	    if (iter.line >= iter.max) return;
	    iter.ch = 0;
	    iter.text = iter.cm.getLine(++iter.line);
	    return true;
	  }
	  function prevLine(iter) {
	    if (iter.line <= iter.min) return;
	    iter.text = iter.cm.getLine(--iter.line);
	    iter.ch = iter.text.length;
	    return true;
	  }
	
	  function toTagEnd(iter) {
	    for (;;) {
	      var gt = iter.text.indexOf(">", iter.ch);
	      if (gt == -1) { if (nextLine(iter)) continue; else return; }
	      if (!tagAt(iter, gt + 1)) { iter.ch = gt + 1; continue; }
	      var lastSlash = iter.text.lastIndexOf("/", gt);
	      var selfClose = lastSlash > -1 && !/\S/.test(iter.text.slice(lastSlash + 1, gt));
	      iter.ch = gt + 1;
	      return selfClose ? "selfClose" : "regular";
	    }
	  }
	  function toTagStart(iter) {
	    for (;;) {
	      var lt = iter.ch ? iter.text.lastIndexOf("<", iter.ch - 1) : -1;
	      if (lt == -1) { if (prevLine(iter)) continue; else return; }
	      if (!tagAt(iter, lt + 1)) { iter.ch = lt; continue; }
	      xmlTagStart.lastIndex = lt;
	      iter.ch = lt;
	      var match = xmlTagStart.exec(iter.text);
	      if (match && match.index == lt) return match;
	    }
	  }
	
	  function toNextTag(iter) {
	    for (;;) {
	      xmlTagStart.lastIndex = iter.ch;
	      var found = xmlTagStart.exec(iter.text);
	      if (!found) { if (nextLine(iter)) continue; else return; }
	      if (!tagAt(iter, found.index + 1)) { iter.ch = found.index + 1; continue; }
	      iter.ch = found.index + found[0].length;
	      return found;
	    }
	  }
	  function toPrevTag(iter) {
	    for (;;) {
	      var gt = iter.ch ? iter.text.lastIndexOf(">", iter.ch - 1) : -1;
	      if (gt == -1) { if (prevLine(iter)) continue; else return; }
	      if (!tagAt(iter, gt + 1)) { iter.ch = gt; continue; }
	      var lastSlash = iter.text.lastIndexOf("/", gt);
	      var selfClose = lastSlash > -1 && !/\S/.test(iter.text.slice(lastSlash + 1, gt));
	      iter.ch = gt + 1;
	      return selfClose ? "selfClose" : "regular";
	    }
	  }
	
	  function findMatchingClose(iter, tag) {
	    var stack = [];
	    for (;;) {
	      var next = toNextTag(iter), end, startLine = iter.line, startCh = iter.ch - (next ? next[0].length : 0);
	      if (!next || !(end = toTagEnd(iter))) return;
	      if (end == "selfClose") continue;
	      if (next[1]) { // closing tag
	        for (var i = stack.length - 1; i >= 0; --i) if (stack[i] == next[2]) {
	          stack.length = i;
	          break;
	        }
	        if (i < 0 && (!tag || tag == next[2])) return {
	          tag: next[2],
	          from: Pos(startLine, startCh),
	          to: Pos(iter.line, iter.ch)
	        };
	      } else { // opening tag
	        stack.push(next[2]);
	      }
	    }
	  }
	  function findMatchingOpen(iter, tag) {
	    var stack = [];
	    for (;;) {
	      var prev = toPrevTag(iter);
	      if (!prev) return;
	      if (prev == "selfClose") { toTagStart(iter); continue; }
	      var endLine = iter.line, endCh = iter.ch;
	      var start = toTagStart(iter);
	      if (!start) return;
	      if (start[1]) { // closing tag
	        stack.push(start[2]);
	      } else { // opening tag
	        for (var i = stack.length - 1; i >= 0; --i) if (stack[i] == start[2]) {
	          stack.length = i;
	          break;
	        }
	        if (i < 0 && (!tag || tag == start[2])) return {
	          tag: start[2],
	          from: Pos(iter.line, iter.ch),
	          to: Pos(endLine, endCh)
	        };
	      }
	    }
	  }
	
	  CodeMirror.registerHelper("fold", "xml", function(cm, start) {
	    var iter = new Iter(cm, start.line, 0);
	    for (;;) {
	      var openTag = toNextTag(iter), end;
	      if (!openTag || iter.line != start.line || !(end = toTagEnd(iter))) return;
	      if (!openTag[1] && end != "selfClose") {
	        var startPos = Pos(iter.line, iter.ch);
	        var endPos = findMatchingClose(iter, openTag[2]);
	        return endPos && {from: startPos, to: endPos.from};
	      }
	    }
	  });
	  CodeMirror.findMatchingTag = function(cm, pos, range) {
	    var iter = new Iter(cm, pos.line, pos.ch, range);
	    if (iter.text.indexOf(">") == -1 && iter.text.indexOf("<") == -1) return;
	    var end = toTagEnd(iter), to = end && Pos(iter.line, iter.ch);
	    var start = end && toTagStart(iter);
	    if (!end || !start || cmp(iter, pos) > 0) return;
	    var here = {from: Pos(iter.line, iter.ch), to: to, tag: start[2]};
	    if (end == "selfClose") return {open: here, close: null, at: "open"};
	
	    if (start[1]) { // closing tag
	      return {open: findMatchingOpen(iter, start[2]), close: here, at: "close"};
	    } else { // opening tag
	      iter = new Iter(cm, to.line, to.ch, range);
	      return {open: here, close: findMatchingClose(iter, start[2]), at: "open"};
	    }
	  };
	
	  CodeMirror.findEnclosingTag = function(cm, pos, range) {
	    var iter = new Iter(cm, pos.line, pos.ch, range);
	    for (;;) {
	      var open = findMatchingOpen(iter);
	      if (!open) break;
	      var forward = new Iter(cm, pos.line, pos.ch, range);
	      var close = findMatchingClose(forward, open.tag);
	      if (close) return {open: open, close: close};
	    }
	  };
	
	  // Used by addon/edit/closetag.js
	  CodeMirror.scanForClosingTag = function(cm, pos, name, end) {
	    var iter = new Iter(cm, pos.line, pos.ch, end ? {from: 0, to: end} : null);
	    return findMatchingClose(iter, name);
	  };
	});


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  var HINT_ELEMENT_CLASS        = "CodeMirror-hint";
	  var ACTIVE_HINT_ELEMENT_CLASS = "CodeMirror-hint-active";
	
	  // This is the old interface, kept around for now to stay
	  // backwards-compatible.
	  CodeMirror.showHint = function(cm, getHints, options) {
	    if (!getHints) return cm.showHint(options);
	    if (options && options.async) getHints.async = true;
	    var newOpts = {hint: getHints};
	    if (options) for (var prop in options) newOpts[prop] = options[prop];
	    return cm.showHint(newOpts);
	  };
	
	  CodeMirror.defineExtension("showHint", function(options) {
	    options = parseOptions(this, this.getCursor("start"), options);
	    var selections = this.listSelections()
	    if (selections.length > 1) return;
	    // By default, don't allow completion when something is selected.
	    // A hint function can have a `supportsSelection` property to
	    // indicate that it can handle selections.
	    if (this.somethingSelected()) {
	      if (!options.hint.supportsSelection) return;
	      // Don't try with cross-line selections
	      for (var i = 0; i < selections.length; i++)
	        if (selections[i].head.line != selections[i].anchor.line) return;
	    }
	
	    if (this.state.completionActive) this.state.completionActive.close();
	    var completion = this.state.completionActive = new Completion(this, options);
	    if (!completion.options.hint) return;
	
	    CodeMirror.signal(this, "startCompletion", this);
	    completion.update(true);
	  });
	
	  function Completion(cm, options) {
	    this.cm = cm;
	    this.options = options;
	    this.widget = null;
	    this.debounce = 0;
	    this.tick = 0;
	    this.startPos = this.cm.getCursor("start");
	    this.startLen = this.cm.getLine(this.startPos.line).length - this.cm.getSelection().length;
	
	    var self = this;
	    cm.on("cursorActivity", this.activityFunc = function() { self.cursorActivity(); });
	  }
	
	  var requestAnimationFrame = window.requestAnimationFrame || function(fn) {
	    return setTimeout(fn, 1000/60);
	  };
	  var cancelAnimationFrame = window.cancelAnimationFrame || clearTimeout;
	
	  Completion.prototype = {
	    close: function() {
	      if (!this.active()) return;
	      this.cm.state.completionActive = null;
	      this.tick = null;
	      this.cm.off("cursorActivity", this.activityFunc);
	
	      if (this.widget && this.data) CodeMirror.signal(this.data, "close");
	      if (this.widget) this.widget.close();
	      CodeMirror.signal(this.cm, "endCompletion", this.cm);
	    },
	
	    active: function() {
	      return this.cm.state.completionActive == this;
	    },
	
	    pick: function(data, i) {
	      var completion = data.list[i];
	      if (completion.hint) completion.hint(this.cm, data, completion);
	      else this.cm.replaceRange(getText(completion), completion.from || data.from,
	                                completion.to || data.to, "complete");
	      CodeMirror.signal(data, "pick", completion);
	      this.close();
	    },
	
	    cursorActivity: function() {
	      if (this.debounce) {
	        cancelAnimationFrame(this.debounce);
	        this.debounce = 0;
	      }
	
	      var pos = this.cm.getCursor(), line = this.cm.getLine(pos.line);
	      if (pos.line != this.startPos.line || line.length - pos.ch != this.startLen - this.startPos.ch ||
	          pos.ch < this.startPos.ch || this.cm.somethingSelected() ||
	          (pos.ch && this.options.closeCharacters.test(line.charAt(pos.ch - 1)))) {
	        this.close();
	      } else {
	        var self = this;
	        this.debounce = requestAnimationFrame(function() {self.update();});
	        if (this.widget) this.widget.disable();
	      }
	    },
	
	    update: function(first) {
	      if (this.tick == null) return
	      var self = this, myTick = ++this.tick
	      fetchHints(this.options.hint, this.cm, this.options, function(data) {
	        if (self.tick == myTick) self.finishUpdate(data, first)
	      })
	    },
	
	    finishUpdate: function(data, first) {
	      if (this.data) CodeMirror.signal(this.data, "update");
	
	      var picked = (this.widget && this.widget.picked) || (first && this.options.completeSingle);
	      if (this.widget) this.widget.close();
	
	      if (data && this.data && isNewCompletion(this.data, data)) return;
	      this.data = data;
	
	      if (data && data.list.length) {
	        if (picked && data.list.length == 1) {
	          this.pick(data, 0);
	        } else {
	          this.widget = new Widget(this, data);
	          CodeMirror.signal(data, "shown");
	        }
	      }
	    }
	  };
	
	  function isNewCompletion(old, nw) {
	    var moved = CodeMirror.cmpPos(nw.from, old.from)
	    return moved > 0 && old.to.ch - old.from.ch != nw.to.ch - nw.from.ch
	  }
	
	  function parseOptions(cm, pos, options) {
	    var editor = cm.options.hintOptions;
	    var out = {};
	    for (var prop in defaultOptions) out[prop] = defaultOptions[prop];
	    if (editor) for (var prop in editor)
	      if (editor[prop] !== undefined) out[prop] = editor[prop];
	    if (options) for (var prop in options)
	      if (options[prop] !== undefined) out[prop] = options[prop];
	    if (out.hint.resolve) out.hint = out.hint.resolve(cm, pos)
	    return out;
	  }
	
	  function getText(completion) {
	    if (typeof completion == "string") return completion;
	    else return completion.text;
	  }
	
	  function buildKeyMap(completion, handle) {
	    var baseMap = {
	      Up: function() {handle.moveFocus(-1);},
	      Down: function() {handle.moveFocus(1);},
	      PageUp: function() {handle.moveFocus(-handle.menuSize() + 1, true);},
	      PageDown: function() {handle.moveFocus(handle.menuSize() - 1, true);},
	      Home: function() {handle.setFocus(0);},
	      End: function() {handle.setFocus(handle.length - 1);},
	      Enter: handle.pick,
	      Tab: handle.pick,
	      Esc: handle.close
	    };
	    var custom = completion.options.customKeys;
	    var ourMap = custom ? {} : baseMap;
	    function addBinding(key, val) {
	      var bound;
	      if (typeof val != "string")
	        bound = function(cm) { return val(cm, handle); };
	      // This mechanism is deprecated
	      else if (baseMap.hasOwnProperty(val))
	        bound = baseMap[val];
	      else
	        bound = val;
	      ourMap[key] = bound;
	    }
	    if (custom)
	      for (var key in custom) if (custom.hasOwnProperty(key))
	        addBinding(key, custom[key]);
	    var extra = completion.options.extraKeys;
	    if (extra)
	      for (var key in extra) if (extra.hasOwnProperty(key))
	        addBinding(key, extra[key]);
	    return ourMap;
	  }
	
	  function getHintElement(hintsElement, el) {
	    while (el && el != hintsElement) {
	      if (el.nodeName.toUpperCase() === "LI" && el.parentNode == hintsElement) return el;
	      el = el.parentNode;
	    }
	  }
	
	  function Widget(completion, data) {
	    this.completion = completion;
	    this.data = data;
	    this.picked = false;
	    var widget = this, cm = completion.cm;
	
	    var hints = this.hints = document.createElement("ul");
	    hints.className = "CodeMirror-hints";
	    this.selectedHint = data.selectedHint || 0;
	
	    var completions = data.list;
	    for (var i = 0; i < completions.length; ++i) {
	      var elt = hints.appendChild(document.createElement("li")), cur = completions[i];
	      var className = HINT_ELEMENT_CLASS + (i != this.selectedHint ? "" : " " + ACTIVE_HINT_ELEMENT_CLASS);
	      if (cur.className != null) className = cur.className + " " + className;
	      elt.className = className;
	      if (cur.render) cur.render(elt, data, cur);
	      else elt.appendChild(document.createTextNode(cur.displayText || getText(cur)));
	      elt.hintId = i;
	    }
	
	    var pos = cm.cursorCoords(completion.options.alignWithWord ? data.from : null);
	    var left = pos.left, top = pos.bottom, below = true;
	    hints.style.left = left + "px";
	    hints.style.top = top + "px";
	    // If we're at the edge of the screen, then we want the menu to appear on the left of the cursor.
	    var winW = window.innerWidth || Math.max(document.body.offsetWidth, document.documentElement.offsetWidth);
	    var winH = window.innerHeight || Math.max(document.body.offsetHeight, document.documentElement.offsetHeight);
	    (completion.options.container || document.body).appendChild(hints);
	    var box = hints.getBoundingClientRect(), overlapY = box.bottom - winH;
	    var scrolls = hints.scrollHeight > hints.clientHeight + 1
	    var startScroll = cm.getScrollInfo();
	
	    if (overlapY > 0) {
	      var height = box.bottom - box.top, curTop = pos.top - (pos.bottom - box.top);
	      if (curTop - height > 0) { // Fits above cursor
	        hints.style.top = (top = pos.top - height) + "px";
	        below = false;
	      } else if (height > winH) {
	        hints.style.height = (winH - 5) + "px";
	        hints.style.top = (top = pos.bottom - box.top) + "px";
	        var cursor = cm.getCursor();
	        if (data.from.ch != cursor.ch) {
	          pos = cm.cursorCoords(cursor);
	          hints.style.left = (left = pos.left) + "px";
	          box = hints.getBoundingClientRect();
	        }
	      }
	    }
	    var overlapX = box.right - winW;
	    if (overlapX > 0) {
	      if (box.right - box.left > winW) {
	        hints.style.width = (winW - 5) + "px";
	        overlapX -= (box.right - box.left) - winW;
	      }
	      hints.style.left = (left = pos.left - overlapX) + "px";
	    }
	    if (scrolls) for (var node = hints.firstChild; node; node = node.nextSibling)
	      node.style.paddingRight = cm.display.nativeBarWidth + "px"
	
	    cm.addKeyMap(this.keyMap = buildKeyMap(completion, {
	      moveFocus: function(n, avoidWrap) { widget.changeActive(widget.selectedHint + n, avoidWrap); },
	      setFocus: function(n) { widget.changeActive(n); },
	      menuSize: function() { return widget.screenAmount(); },
	      length: completions.length,
	      close: function() { completion.close(); },
	      pick: function() { widget.pick(); },
	      data: data
	    }));
	
	    if (completion.options.closeOnUnfocus) {
	      var closingOnBlur;
	      cm.on("blur", this.onBlur = function() { closingOnBlur = setTimeout(function() { completion.close(); }, 100); });
	      cm.on("focus", this.onFocus = function() { clearTimeout(closingOnBlur); });
	    }
	
	    cm.on("scroll", this.onScroll = function() {
	      var curScroll = cm.getScrollInfo(), editor = cm.getWrapperElement().getBoundingClientRect();
	      var newTop = top + startScroll.top - curScroll.top;
	      var point = newTop - (window.pageYOffset || (document.documentElement || document.body).scrollTop);
	      if (!below) point += hints.offsetHeight;
	      if (point <= editor.top || point >= editor.bottom) return completion.close();
	      hints.style.top = newTop + "px";
	      hints.style.left = (left + startScroll.left - curScroll.left) + "px";
	    });
	
	    CodeMirror.on(hints, "dblclick", function(e) {
	      var t = getHintElement(hints, e.target || e.srcElement);
	      if (t && t.hintId != null) {widget.changeActive(t.hintId); widget.pick();}
	    });
	
	    CodeMirror.on(hints, "click", function(e) {
	      var t = getHintElement(hints, e.target || e.srcElement);
	      if (t && t.hintId != null) {
	        widget.changeActive(t.hintId);
	        if (completion.options.completeOnSingleClick) widget.pick();
	      }
	    });
	
	    CodeMirror.on(hints, "mousedown", function() {
	      setTimeout(function(){cm.focus();}, 20);
	    });
	
	    CodeMirror.signal(data, "select", completions[0], hints.firstChild);
	    return true;
	  }
	
	  Widget.prototype = {
	    close: function() {
	      if (this.completion.widget != this) return;
	      this.completion.widget = null;
	      this.hints.parentNode.removeChild(this.hints);
	      this.completion.cm.removeKeyMap(this.keyMap);
	
	      var cm = this.completion.cm;
	      if (this.completion.options.closeOnUnfocus) {
	        cm.off("blur", this.onBlur);
	        cm.off("focus", this.onFocus);
	      }
	      cm.off("scroll", this.onScroll);
	    },
	
	    disable: function() {
	      this.completion.cm.removeKeyMap(this.keyMap);
	      var widget = this;
	      this.keyMap = {Enter: function() { widget.picked = true; }};
	      this.completion.cm.addKeyMap(this.keyMap);
	    },
	
	    pick: function() {
	      this.completion.pick(this.data, this.selectedHint);
	    },
	
	    changeActive: function(i, avoidWrap) {
	      if (i >= this.data.list.length)
	        i = avoidWrap ? this.data.list.length - 1 : 0;
	      else if (i < 0)
	        i = avoidWrap ? 0  : this.data.list.length - 1;
	      if (this.selectedHint == i) return;
	      var node = this.hints.childNodes[this.selectedHint];
	      node.className = node.className.replace(" " + ACTIVE_HINT_ELEMENT_CLASS, "");
	      node = this.hints.childNodes[this.selectedHint = i];
	      node.className += " " + ACTIVE_HINT_ELEMENT_CLASS;
	      if (node.offsetTop < this.hints.scrollTop)
	        this.hints.scrollTop = node.offsetTop - 3;
	      else if (node.offsetTop + node.offsetHeight > this.hints.scrollTop + this.hints.clientHeight)
	        this.hints.scrollTop = node.offsetTop + node.offsetHeight - this.hints.clientHeight + 3;
	      CodeMirror.signal(this.data, "select", this.data.list[this.selectedHint], node);
	    },
	
	    screenAmount: function() {
	      return Math.floor(this.hints.clientHeight / this.hints.firstChild.offsetHeight) || 1;
	    }
	  };
	
	  function applicableHelpers(cm, helpers) {
	    if (!cm.somethingSelected()) return helpers
	    var result = []
	    for (var i = 0; i < helpers.length; i++)
	      if (helpers[i].supportsSelection) result.push(helpers[i])
	    return result
	  }
	
	  function fetchHints(hint, cm, options, callback) {
	    if (hint.async) {
	      hint(cm, callback, options)
	    } else {
	      var result = hint(cm, options)
	      if (result && result.then) result.then(callback)
	      else callback(result)
	    }
	  }
	
	  function resolveAutoHints(cm, pos) {
	    var helpers = cm.getHelpers(pos, "hint"), words
	    if (helpers.length) {
	      var resolved = function(cm, callback, options) {
	        var app = applicableHelpers(cm, helpers);
	        function run(i) {
	          if (i == app.length) return callback(null)
	          fetchHints(app[i], cm, options, function(result) {
	            if (result && result.list.length > 0) callback(result)
	            else run(i + 1)
	          })
	        }
	        run(0)
	      }
	      resolved.async = true
	      resolved.supportsSelection = true
	      return resolved
	    } else if (words = cm.getHelper(cm.getCursor(), "hintWords")) {
	      return function(cm) { return CodeMirror.hint.fromList(cm, {words: words}) }
	    } else if (CodeMirror.hint.anyword) {
	      return function(cm, options) { return CodeMirror.hint.anyword(cm, options) }
	    } else {
	      return function() {}
	    }
	  }
	
	  CodeMirror.registerHelper("hint", "auto", {
	    resolve: resolveAutoHints
	  });
	
	  CodeMirror.registerHelper("hint", "fromList", function(cm, options) {
	    var cur = cm.getCursor(), token = cm.getTokenAt(cur);
	    var to = CodeMirror.Pos(cur.line, token.end);
	    if (token.string && /\w/.test(token.string[token.string.length - 1])) {
	      var term = token.string, from = CodeMirror.Pos(cur.line, token.start);
	    } else {
	      var term = "", from = to;
	    }
	    var found = [];
	    for (var i = 0; i < options.words.length; i++) {
	      var word = options.words[i];
	      if (word.slice(0, term.length) == term)
	        found.push(word);
	    }
	
	    if (found.length) return {list: found, from: from, to: to};
	  });
	
	  CodeMirror.commands.autocomplete = CodeMirror.showHint;
	
	  var defaultOptions = {
	    hint: CodeMirror.hint.auto,
	    completeSingle: true,
	    alignWithWord: true,
	    closeCharacters: /[\s()\[\]{};:>,]/,
	    closeOnUnfocus: true,
	    completeOnSingleClick: true,
	    container: null,
	    customKeys: null,
	    extraKeys: null
	  };
	
	  CodeMirror.defineOption("hintOptions", null);
	});


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  var Pos = CodeMirror.Pos;
	
	  function getHints(cm, options) {
	    var tags = options && options.schemaInfo;
	    var quote = (options && options.quoteChar) || '"';
	    if (!tags) return;
	    var cur = cm.getCursor(), token = cm.getTokenAt(cur);
	    if (token.end > cur.ch) {
	      token.end = cur.ch;
	      token.string = token.string.slice(0, cur.ch - token.start);
	    }
	    var inner = CodeMirror.innerMode(cm.getMode(), token.state);
	    if (inner.mode.name != "xml") return;
	    var result = [], replaceToken = false, prefix;
	    var tag = /\btag\b/.test(token.type) && !/>$/.test(token.string);
	    var tagName = tag && /^\w/.test(token.string), tagStart;
	
	    if (tagName) {
	      var before = cm.getLine(cur.line).slice(Math.max(0, token.start - 2), token.start);
	      var tagType = /<\/$/.test(before) ? "close" : /<$/.test(before) ? "open" : null;
	      if (tagType) tagStart = token.start - (tagType == "close" ? 2 : 1);
	    } else if (tag && token.string == "<") {
	      tagType = "open";
	    } else if (tag && token.string == "</") {
	      tagType = "close";
	    }
	
	    if (!tag && !inner.state.tagName || tagType) {
	      if (tagName)
	        prefix = token.string;
	      replaceToken = tagType;
	      var cx = inner.state.context, curTag = cx && tags[cx.tagName];
	      var childList = cx ? curTag && curTag.children : tags["!top"];
	      if (childList && tagType != "close") {
	        for (var i = 0; i < childList.length; ++i) if (!prefix || childList[i].lastIndexOf(prefix, 0) == 0)
	          result.push("<" + childList[i]);
	      } else if (tagType != "close") {
	        for (var name in tags)
	          if (tags.hasOwnProperty(name) && name != "!top" && name != "!attrs" && (!prefix || name.lastIndexOf(prefix, 0) == 0))
	            result.push("<" + name);
	      }
	      if (cx && (!prefix || tagType == "close" && cx.tagName.lastIndexOf(prefix, 0) == 0))
	        result.push("</" + cx.tagName + ">");
	    } else {
	      // Attribute completion
	      var curTag = tags[inner.state.tagName], attrs = curTag && curTag.attrs;
	      var globalAttrs = tags["!attrs"];
	      if (!attrs && !globalAttrs) return;
	      if (!attrs) {
	        attrs = globalAttrs;
	      } else if (globalAttrs) { // Combine tag-local and global attributes
	        var set = {};
	        for (var nm in globalAttrs) if (globalAttrs.hasOwnProperty(nm)) set[nm] = globalAttrs[nm];
	        for (var nm in attrs) if (attrs.hasOwnProperty(nm)) set[nm] = attrs[nm];
	        attrs = set;
	      }
	      if (token.type == "string" || token.string == "=") { // A value
	        var before = cm.getRange(Pos(cur.line, Math.max(0, cur.ch - 60)),
	                                 Pos(cur.line, token.type == "string" ? token.start : token.end));
	        var atName = before.match(/([^\s\u00a0=<>\"\']+)=$/), atValues;
	        if (!atName || !attrs.hasOwnProperty(atName[1]) || !(atValues = attrs[atName[1]])) return;
	        if (typeof atValues == 'function') atValues = atValues.call(this, cm); // Functions can be used to supply values for autocomplete widget
	        if (token.type == "string") {
	          prefix = token.string;
	          var n = 0;
	          if (/['"]/.test(token.string.charAt(0))) {
	            quote = token.string.charAt(0);
	            prefix = token.string.slice(1);
	            n++;
	          }
	          var len = token.string.length;
	          if (/['"]/.test(token.string.charAt(len - 1))) {
	            quote = token.string.charAt(len - 1);
	            prefix = token.string.substr(n, len - 2);
	          }
	          replaceToken = true;
	        }
	        for (var i = 0; i < atValues.length; ++i) if (!prefix || atValues[i].lastIndexOf(prefix, 0) == 0)
	          result.push(quote + atValues[i] + quote);
	      } else { // An attribute name
	        if (token.type == "attribute") {
	          prefix = token.string;
	          replaceToken = true;
	        }
	        for (var attr in attrs) if (attrs.hasOwnProperty(attr) && (!prefix || attr.lastIndexOf(prefix, 0) == 0))
	          result.push(attr);
	      }
	    }
	    return {
	      list: result,
	      from: replaceToken ? Pos(cur.line, tagStart == null ? token.start : tagStart) : cur,
	      to: replaceToken ? Pos(cur.line, token.end) : cur
	    };
	  }
	
	  CodeMirror.registerHelper("hint", "xml", getHints);
	});


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineExtension("annotateScrollbar", function(options) {
	    if (typeof options == "string") options = {className: options};
	    return new Annotation(this, options);
	  });
	
	  CodeMirror.defineOption("scrollButtonHeight", 0);
	
	  function Annotation(cm, options) {
	    this.cm = cm;
	    this.options = options;
	    this.buttonHeight = options.scrollButtonHeight || cm.getOption("scrollButtonHeight");
	    this.annotations = [];
	    this.doRedraw = this.doUpdate = null;
	    this.div = cm.getWrapperElement().appendChild(document.createElement("div"));
	    this.div.style.cssText = "position: absolute; right: 0; top: 0; z-index: 7; pointer-events: none";
	    this.computeScale();
	
	    function scheduleRedraw(delay) {
	      clearTimeout(self.doRedraw);
	      self.doRedraw = setTimeout(function() { self.redraw(); }, delay);
	    }
	
	    var self = this;
	    cm.on("refresh", this.resizeHandler = function() {
	      clearTimeout(self.doUpdate);
	      self.doUpdate = setTimeout(function() {
	        if (self.computeScale()) scheduleRedraw(20);
	      }, 100);
	    });
	    cm.on("markerAdded", this.resizeHandler);
	    cm.on("markerCleared", this.resizeHandler);
	    if (options.listenForChanges !== false)
	      cm.on("change", this.changeHandler = function() {
	        scheduleRedraw(250);
	      });
	  }
	
	  Annotation.prototype.computeScale = function() {
	    var cm = this.cm;
	    var hScale = (cm.getWrapperElement().clientHeight - cm.display.barHeight - this.buttonHeight * 2) /
	      cm.getScrollerElement().scrollHeight
	    if (hScale != this.hScale) {
	      this.hScale = hScale;
	      return true;
	    }
	  };
	
	  Annotation.prototype.update = function(annotations) {
	    this.annotations = annotations;
	    this.redraw();
	  };
	
	  Annotation.prototype.redraw = function(compute) {
	    if (compute !== false) this.computeScale();
	    var cm = this.cm, hScale = this.hScale;
	
	    var frag = document.createDocumentFragment(), anns = this.annotations;
	
	    var wrapping = cm.getOption("lineWrapping");
	    var singleLineH = wrapping && cm.defaultTextHeight() * 1.5;
	    var curLine = null, curLineObj = null;
	    function getY(pos, top) {
	      if (curLine != pos.line) {
	        curLine = pos.line;
	        curLineObj = cm.getLineHandle(curLine);
	      }
	      if (wrapping && curLineObj.height > singleLineH)
	        return cm.charCoords(pos, "local")[top ? "top" : "bottom"];
	      var topY = cm.heightAtLine(curLineObj, "local");
	      return topY + (top ? 0 : curLineObj.height);
	    }
	
	    if (cm.display.barWidth) for (var i = 0, nextTop; i < anns.length; i++) {
	      var ann = anns[i];
	      var top = nextTop || getY(ann.from, true) * hScale;
	      var bottom = getY(ann.to, false) * hScale;
	      while (i < anns.length - 1) {
	        nextTop = getY(anns[i + 1].from, true) * hScale;
	        if (nextTop > bottom + .9) break;
	        ann = anns[++i];
	        bottom = getY(ann.to, false) * hScale;
	      }
	      if (bottom == top) continue;
	      var height = Math.max(bottom - top, 3);
	
	      var elt = frag.appendChild(document.createElement("div"));
	      elt.style.cssText = "position: absolute; right: 0px; width: " + Math.max(cm.display.barWidth - 1, 2) + "px; top: "
	        + (top + this.buttonHeight) + "px; height: " + height + "px";
	      elt.className = this.options.className;
	      if (ann.id) {
	        elt.setAttribute("annotation-id", ann.id);
	      }
	    }
	    this.div.textContent = "";
	    this.div.appendChild(frag);
	  };
	
	  Annotation.prototype.clear = function() {
	    this.cm.off("refresh", this.resizeHandler);
	    this.cm.off("markerAdded", this.resizeHandler);
	    this.cm.off("markerCleared", this.resizeHandler);
	    if (this.changeHandler) this.cm.off("change", this.changeHandler);
	    this.div.parentNode.removeChild(this.div);
	  };
	});


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(8), __webpack_require__(76));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "./searchcursor", "../scroll/annotatescrollbar"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineExtension("showMatchesOnScrollbar", function(query, caseFold, options) {
	    if (typeof options == "string") options = {className: options};
	    if (!options) options = {};
	    return new SearchAnnotation(this, query, caseFold, options);
	  });
	
	  function SearchAnnotation(cm, query, caseFold, options) {
	    this.cm = cm;
	    this.options = options;
	    var annotateOptions = {listenForChanges: false};
	    for (var prop in options) annotateOptions[prop] = options[prop];
	    if (!annotateOptions.className) annotateOptions.className = "CodeMirror-search-match";
	    this.annotation = cm.annotateScrollbar(annotateOptions);
	    this.query = query;
	    this.caseFold = caseFold;
	    this.gap = {from: cm.firstLine(), to: cm.lastLine() + 1};
	    this.matches = [];
	    this.update = null;
	
	    this.findMatches();
	    this.annotation.update(this.matches);
	
	    var self = this;
	    cm.on("change", this.changeHandler = function(_cm, change) { self.onChange(change); });
	  }
	
	  var MAX_MATCHES = 1000;
	
	  SearchAnnotation.prototype.findMatches = function() {
	    if (!this.gap) return;
	    for (var i = 0; i < this.matches.length; i++) {
	      var match = this.matches[i];
	      if (match.from.line >= this.gap.to) break;
	      if (match.to.line >= this.gap.from) this.matches.splice(i--, 1);
	    }
	    var cursor = this.cm.getSearchCursor(this.query, CodeMirror.Pos(this.gap.from, 0), this.caseFold);
	    var maxMatches = this.options && this.options.maxMatches || MAX_MATCHES;
	    while (cursor.findNext()) {
	      var match = {from: cursor.from(), to: cursor.to()};
	      if (match.from.line >= this.gap.to) break;
	      this.matches.splice(i++, 0, match);
	      if (this.matches.length > maxMatches) break;
	    }
	    this.gap = null;
	  };
	
	  function offsetLine(line, changeStart, sizeChange) {
	    if (line <= changeStart) return line;
	    return Math.max(changeStart, line + sizeChange);
	  }
	
	  SearchAnnotation.prototype.onChange = function(change) {
	    var startLine = change.from.line;
	    var endLine = CodeMirror.changeEnd(change).line;
	    var sizeChange = endLine - change.to.line;
	    if (this.gap) {
	      this.gap.from = Math.min(offsetLine(this.gap.from, startLine, sizeChange), change.from.line);
	      this.gap.to = Math.max(offsetLine(this.gap.to, startLine, sizeChange), change.from.line);
	    } else {
	      this.gap = {from: change.from.line, to: endLine + 1};
	    }
	
	    if (sizeChange) for (var i = 0; i < this.matches.length; i++) {
	      var match = this.matches[i];
	      var newFrom = offsetLine(match.from.line, startLine, sizeChange);
	      if (newFrom != match.from.line) match.from = CodeMirror.Pos(newFrom, match.from.ch);
	      var newTo = offsetLine(match.to.line, startLine, sizeChange);
	      if (newTo != match.to.line) match.to = CodeMirror.Pos(newTo, match.to.ch);
	    }
	    clearTimeout(this.update);
	    var self = this;
	    this.update = setTimeout(function() { self.updateAfterChange(); }, 250);
	  };
	
	  SearchAnnotation.prototype.updateAfterChange = function() {
	    this.findMatches();
	    this.annotation.update(this.matches);
	  };
	
	  SearchAnnotation.prototype.clear = function() {
	    this.cm.off("change", this.changeHandler);
	    this.annotation.clear();
	  };
	});


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	/**
	 * Link to the project's GitHub page:
	 * https://github.com/pickhardt/coffeescript-codemirror-mode
	 */
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("coffeescript", function(conf, parserConf) {
	  var ERRORCLASS = "error";
	
	  function wordRegexp(words) {
	    return new RegExp("^((" + words.join(")|(") + "))\\b");
	  }
	
	  var operators = /^(?:->|=>|\+[+=]?|-[\-=]?|\*[\*=]?|\/[\/=]?|[=!]=|<[><]?=?|>>?=?|%=?|&=?|\|=?|\^=?|\~|!|\?|(or|and|\|\||&&|\?)=)/;
	  var delimiters = /^(?:[()\[\]{},:`=;]|\.\.?\.?)/;
	  var identifiers = /^[_A-Za-z$][_A-Za-z$0-9]*/;
	  var atProp = /^@[_A-Za-z$][_A-Za-z$0-9]*/;
	
	  var wordOperators = wordRegexp(["and", "or", "not",
	                                  "is", "isnt", "in",
	                                  "instanceof", "typeof"]);
	  var indentKeywords = ["for", "while", "loop", "if", "unless", "else",
	                        "switch", "try", "catch", "finally", "class"];
	  var commonKeywords = ["break", "by", "continue", "debugger", "delete",
	                        "do", "in", "of", "new", "return", "then",
	                        "this", "@", "throw", "when", "until", "extends"];
	
	  var keywords = wordRegexp(indentKeywords.concat(commonKeywords));
	
	  indentKeywords = wordRegexp(indentKeywords);
	
	
	  var stringPrefixes = /^('{3}|\"{3}|['\"])/;
	  var regexPrefixes = /^(\/{3}|\/)/;
	  var commonConstants = ["Infinity", "NaN", "undefined", "null", "true", "false", "on", "off", "yes", "no"];
	  var constants = wordRegexp(commonConstants);
	
	  // Tokenizers
	  function tokenBase(stream, state) {
	    // Handle scope changes
	    if (stream.sol()) {
	      if (state.scope.align === null) state.scope.align = false;
	      var scopeOffset = state.scope.offset;
	      if (stream.eatSpace()) {
	        var lineOffset = stream.indentation();
	        if (lineOffset > scopeOffset && state.scope.type == "coffee") {
	          return "indent";
	        } else if (lineOffset < scopeOffset) {
	          return "dedent";
	        }
	        return null;
	      } else {
	        if (scopeOffset > 0) {
	          dedent(stream, state);
	        }
	      }
	    }
	    if (stream.eatSpace()) {
	      return null;
	    }
	
	    var ch = stream.peek();
	
	    // Handle docco title comment (single line)
	    if (stream.match("####")) {
	      stream.skipToEnd();
	      return "comment";
	    }
	
	    // Handle multi line comments
	    if (stream.match("###")) {
	      state.tokenize = longComment;
	      return state.tokenize(stream, state);
	    }
	
	    // Single line comment
	    if (ch === "#") {
	      stream.skipToEnd();
	      return "comment";
	    }
	
	    // Handle number literals
	    if (stream.match(/^-?[0-9\.]/, false)) {
	      var floatLiteral = false;
	      // Floats
	      if (stream.match(/^-?\d*\.\d+(e[\+\-]?\d+)?/i)) {
	        floatLiteral = true;
	      }
	      if (stream.match(/^-?\d+\.\d*/)) {
	        floatLiteral = true;
	      }
	      if (stream.match(/^-?\.\d+/)) {
	        floatLiteral = true;
	      }
	
	      if (floatLiteral) {
	        // prevent from getting extra . on 1..
	        if (stream.peek() == "."){
	          stream.backUp(1);
	        }
	        return "number";
	      }
	      // Integers
	      var intLiteral = false;
	      // Hex
	      if (stream.match(/^-?0x[0-9a-f]+/i)) {
	        intLiteral = true;
	      }
	      // Decimal
	      if (stream.match(/^-?[1-9]\d*(e[\+\-]?\d+)?/)) {
	        intLiteral = true;
	      }
	      // Zero by itself with no other piece of number.
	      if (stream.match(/^-?0(?![\dx])/i)) {
	        intLiteral = true;
	      }
	      if (intLiteral) {
	        return "number";
	      }
	    }
	
	    // Handle strings
	    if (stream.match(stringPrefixes)) {
	      state.tokenize = tokenFactory(stream.current(), false, "string");
	      return state.tokenize(stream, state);
	    }
	    // Handle regex literals
	    if (stream.match(regexPrefixes)) {
	      if (stream.current() != "/" || stream.match(/^.*\//, false)) { // prevent highlight of division
	        state.tokenize = tokenFactory(stream.current(), true, "string-2");
	        return state.tokenize(stream, state);
	      } else {
	        stream.backUp(1);
	      }
	    }
	
	
	
	    // Handle operators and delimiters
	    if (stream.match(operators) || stream.match(wordOperators)) {
	      return "operator";
	    }
	    if (stream.match(delimiters)) {
	      return "punctuation";
	    }
	
	    if (stream.match(constants)) {
	      return "atom";
	    }
	
	    if (stream.match(atProp) || state.prop && stream.match(identifiers)) {
	      return "property";
	    }
	
	    if (stream.match(keywords)) {
	      return "keyword";
	    }
	
	    if (stream.match(identifiers)) {
	      return "variable";
	    }
	
	    // Handle non-detected items
	    stream.next();
	    return ERRORCLASS;
	  }
	
	  function tokenFactory(delimiter, singleline, outclass) {
	    return function(stream, state) {
	      while (!stream.eol()) {
	        stream.eatWhile(/[^'"\/\\]/);
	        if (stream.eat("\\")) {
	          stream.next();
	          if (singleline && stream.eol()) {
	            return outclass;
	          }
	        } else if (stream.match(delimiter)) {
	          state.tokenize = tokenBase;
	          return outclass;
	        } else {
	          stream.eat(/['"\/]/);
	        }
	      }
	      if (singleline) {
	        if (parserConf.singleLineStringErrors) {
	          outclass = ERRORCLASS;
	        } else {
	          state.tokenize = tokenBase;
	        }
	      }
	      return outclass;
	    };
	  }
	
	  function longComment(stream, state) {
	    while (!stream.eol()) {
	      stream.eatWhile(/[^#]/);
	      if (stream.match("###")) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      stream.eatWhile("#");
	    }
	    return "comment";
	  }
	
	  function indent(stream, state, type) {
	    type = type || "coffee";
	    var offset = 0, align = false, alignOffset = null;
	    for (var scope = state.scope; scope; scope = scope.prev) {
	      if (scope.type === "coffee" || scope.type == "}") {
	        offset = scope.offset + conf.indentUnit;
	        break;
	      }
	    }
	    if (type !== "coffee") {
	      align = null;
	      alignOffset = stream.column() + stream.current().length;
	    } else if (state.scope.align) {
	      state.scope.align = false;
	    }
	    state.scope = {
	      offset: offset,
	      type: type,
	      prev: state.scope,
	      align: align,
	      alignOffset: alignOffset
	    };
	  }
	
	  function dedent(stream, state) {
	    if (!state.scope.prev) return;
	    if (state.scope.type === "coffee") {
	      var _indent = stream.indentation();
	      var matched = false;
	      for (var scope = state.scope; scope; scope = scope.prev) {
	        if (_indent === scope.offset) {
	          matched = true;
	          break;
	        }
	      }
	      if (!matched) {
	        return true;
	      }
	      while (state.scope.prev && state.scope.offset !== _indent) {
	        state.scope = state.scope.prev;
	      }
	      return false;
	    } else {
	      state.scope = state.scope.prev;
	      return false;
	    }
	  }
	
	  function tokenLexer(stream, state) {
	    var style = state.tokenize(stream, state);
	    var current = stream.current();
	
	    // Handle scope changes.
	    if (current === "return") {
	      state.dedent = true;
	    }
	    if (((current === "->" || current === "=>") && stream.eol())
	        || style === "indent") {
	      indent(stream, state);
	    }
	    var delimiter_index = "[({".indexOf(current);
	    if (delimiter_index !== -1) {
	      indent(stream, state, "])}".slice(delimiter_index, delimiter_index+1));
	    }
	    if (indentKeywords.exec(current)){
	      indent(stream, state);
	    }
	    if (current == "then"){
	      dedent(stream, state);
	    }
	
	
	    if (style === "dedent") {
	      if (dedent(stream, state)) {
	        return ERRORCLASS;
	      }
	    }
	    delimiter_index = "])}".indexOf(current);
	    if (delimiter_index !== -1) {
	      while (state.scope.type == "coffee" && state.scope.prev)
	        state.scope = state.scope.prev;
	      if (state.scope.type == current)
	        state.scope = state.scope.prev;
	    }
	    if (state.dedent && stream.eol()) {
	      if (state.scope.type == "coffee" && state.scope.prev)
	        state.scope = state.scope.prev;
	      state.dedent = false;
	    }
	
	    return style;
	  }
	
	  var external = {
	    startState: function(basecolumn) {
	      return {
	        tokenize: tokenBase,
	        scope: {offset:basecolumn || 0, type:"coffee", prev: null, align: false},
	        prop: false,
	        dedent: 0
	      };
	    },
	
	    token: function(stream, state) {
	      var fillAlign = state.scope.align === null && state.scope;
	      if (fillAlign && stream.sol()) fillAlign.align = false;
	
	      var style = tokenLexer(stream, state);
	      if (style && style != "comment") {
	        if (fillAlign) fillAlign.align = true;
	        state.prop = style == "punctuation" && stream.current() == "."
	      }
	
	      return style;
	    },
	
	    indent: function(state, text) {
	      if (state.tokenize != tokenBase) return 0;
	      var scope = state.scope;
	      var closer = text && "])}".indexOf(text.charAt(0)) > -1;
	      if (closer) while (scope.type == "coffee" && scope.prev) scope = scope.prev;
	      var closes = closer && scope.type === text.charAt(0);
	      if (scope.align)
	        return scope.alignOffset - (closes ? 1 : 0);
	      else
	        return (closes ? scope.prev : scope).offset;
	    },
	
	    lineComment: "#",
	    fold: "indent"
	  };
	  return external;
	});
	
	CodeMirror.defineMIME("text/x-coffeescript", "coffeescript");
	CodeMirror.defineMIME("text/coffeescript", "coffeescript");
	
	});


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(20), __webpack_require__(45));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../../addon/mode/simple", "../../addon/mode/multiplex"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineSimpleMode("handlebars-tags", {
	    start: [
	      { regex: /\{\{!--/, push: "dash_comment", token: "comment" },
	      { regex: /\{\{!/,   push: "comment", token: "comment" },
	      { regex: /\{\{/,    push: "handlebars", token: "tag" }
	    ],
	    handlebars: [
	      { regex: /\}\}/, pop: true, token: "tag" },
	
	      // Double and single quotes
	      { regex: /"(?:[^\\"]|\\.)*"?/, token: "string" },
	      { regex: /'(?:[^\\']|\\.)*'?/, token: "string" },
	
	      // Handlebars keywords
	      { regex: />|[#\/]([A-Za-z_]\w*)/, token: "keyword" },
	      { regex: /(?:else|this)\b/, token: "keyword" },
	
	      // Numeral
	      { regex: /\d+/i, token: "number" },
	
	      // Atoms like = and .
	      { regex: /=|~|@|true|false/, token: "atom" },
	
	      // Paths
	      { regex: /(?:\.\.\/)*(?:[A-Za-z_][\w\.]*)+/, token: "variable-2" }
	    ],
	    dash_comment: [
	      { regex: /--\}\}/, pop: true, token: "comment" },
	
	      // Commented code
	      { regex: /./, token: "comment"}
	    ],
	    comment: [
	      { regex: /\}\}/, pop: true, token: "comment" },
	      { regex: /./, token: "comment" }
	    ]
	  });
	
	  CodeMirror.defineMode("handlebars", function(config, parserConfig) {
	    var handlebars = CodeMirror.getMode(config, "handlebars-tags");
	    if (!parserConfig || !parserConfig.base) return handlebars;
	    return CodeMirror.multiplexingMode(
	      CodeMirror.getMode(config, parserConfig.base),
	      {open: "{{", close: "}}", mode: handlebars, parseDelimiters: true}
	    );
	  });
	
	  CodeMirror.defineMIME("text/x-handlebars-template", "handlebars");
	});


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("haskell", function(_config, modeConfig) {
	
	  function switchState(source, setState, f) {
	    setState(f);
	    return f(source, setState);
	  }
	
	  // These should all be Unicode extended, as per the Haskell 2010 report
	  var smallRE = /[a-z_]/;
	  var largeRE = /[A-Z]/;
	  var digitRE = /\d/;
	  var hexitRE = /[0-9A-Fa-f]/;
	  var octitRE = /[0-7]/;
	  var idRE = /[a-z_A-Z0-9'\xa1-\uffff]/;
	  var symbolRE = /[-!#$%&*+.\/<=>?@\\^|~:]/;
	  var specialRE = /[(),;[\]`{}]/;
	  var whiteCharRE = /[ \t\v\f]/; // newlines are handled in tokenizer
	
	  function normal(source, setState) {
	    if (source.eatWhile(whiteCharRE)) {
	      return null;
	    }
	
	    var ch = source.next();
	    if (specialRE.test(ch)) {
	      if (ch == '{' && source.eat('-')) {
	        var t = "comment";
	        if (source.eat('#')) {
	          t = "meta";
	        }
	        return switchState(source, setState, ncomment(t, 1));
	      }
	      return null;
	    }
	
	    if (ch == '\'') {
	      if (source.eat('\\')) {
	        source.next();  // should handle other escapes here
	      }
	      else {
	        source.next();
	      }
	      if (source.eat('\'')) {
	        return "string";
	      }
	      return "string error";
	    }
	
	    if (ch == '"') {
	      return switchState(source, setState, stringLiteral);
	    }
	
	    if (largeRE.test(ch)) {
	      source.eatWhile(idRE);
	      if (source.eat('.')) {
	        return "qualifier";
	      }
	      return "variable-2";
	    }
	
	    if (smallRE.test(ch)) {
	      source.eatWhile(idRE);
	      return "variable";
	    }
	
	    if (digitRE.test(ch)) {
	      if (ch == '0') {
	        if (source.eat(/[xX]/)) {
	          source.eatWhile(hexitRE); // should require at least 1
	          return "integer";
	        }
	        if (source.eat(/[oO]/)) {
	          source.eatWhile(octitRE); // should require at least 1
	          return "number";
	        }
	      }
	      source.eatWhile(digitRE);
	      var t = "number";
	      if (source.match(/^\.\d+/)) {
	        t = "number";
	      }
	      if (source.eat(/[eE]/)) {
	        t = "number";
	        source.eat(/[-+]/);
	        source.eatWhile(digitRE); // should require at least 1
	      }
	      return t;
	    }
	
	    if (ch == "." && source.eat("."))
	      return "keyword";
	
	    if (symbolRE.test(ch)) {
	      if (ch == '-' && source.eat(/-/)) {
	        source.eatWhile(/-/);
	        if (!source.eat(symbolRE)) {
	          source.skipToEnd();
	          return "comment";
	        }
	      }
	      var t = "variable";
	      if (ch == ':') {
	        t = "variable-2";
	      }
	      source.eatWhile(symbolRE);
	      return t;
	    }
	
	    return "error";
	  }
	
	  function ncomment(type, nest) {
	    if (nest == 0) {
	      return normal;
	    }
	    return function(source, setState) {
	      var currNest = nest;
	      while (!source.eol()) {
	        var ch = source.next();
	        if (ch == '{' && source.eat('-')) {
	          ++currNest;
	        }
	        else if (ch == '-' && source.eat('}')) {
	          --currNest;
	          if (currNest == 0) {
	            setState(normal);
	            return type;
	          }
	        }
	      }
	      setState(ncomment(type, currNest));
	      return type;
	    };
	  }
	
	  function stringLiteral(source, setState) {
	    while (!source.eol()) {
	      var ch = source.next();
	      if (ch == '"') {
	        setState(normal);
	        return "string";
	      }
	      if (ch == '\\') {
	        if (source.eol() || source.eat(whiteCharRE)) {
	          setState(stringGap);
	          return "string";
	        }
	        if (source.eat('&')) {
	        }
	        else {
	          source.next(); // should handle other escapes here
	        }
	      }
	    }
	    setState(normal);
	    return "string error";
	  }
	
	  function stringGap(source, setState) {
	    if (source.eat('\\')) {
	      return switchState(source, setState, stringLiteral);
	    }
	    source.next();
	    setState(normal);
	    return "error";
	  }
	
	
	  var wellKnownWords = (function() {
	    var wkw = {};
	    function setType(t) {
	      return function () {
	        for (var i = 0; i < arguments.length; i++)
	          wkw[arguments[i]] = t;
	      };
	    }
	
	    setType("keyword")(
	      "case", "class", "data", "default", "deriving", "do", "else", "foreign",
	      "if", "import", "in", "infix", "infixl", "infixr", "instance", "let",
	      "module", "newtype", "of", "then", "type", "where", "_");
	
	    setType("keyword")(
	      "\.\.", ":", "::", "=", "\\", "<-", "->", "@", "~", "=>");
	
	    setType("builtin")(
	      "!!", "$!", "$", "&&", "+", "++", "-", ".", "/", "/=", "<", "<=", "=<<",
	      "==", ">", ">=", ">>", ">>=", "^", "^^", "||", "*", "**");
	
	    setType("builtin")(
	      "Bool", "Bounded", "Char", "Double", "EQ", "Either", "Enum", "Eq",
	      "False", "FilePath", "Float", "Floating", "Fractional", "Functor", "GT",
	      "IO", "IOError", "Int", "Integer", "Integral", "Just", "LT", "Left",
	      "Maybe", "Monad", "Nothing", "Num", "Ord", "Ordering", "Rational", "Read",
	      "ReadS", "Real", "RealFloat", "RealFrac", "Right", "Show", "ShowS",
	      "String", "True");
	
	    setType("builtin")(
	      "abs", "acos", "acosh", "all", "and", "any", "appendFile", "asTypeOf",
	      "asin", "asinh", "atan", "atan2", "atanh", "break", "catch", "ceiling",
	      "compare", "concat", "concatMap", "const", "cos", "cosh", "curry",
	      "cycle", "decodeFloat", "div", "divMod", "drop", "dropWhile", "either",
	      "elem", "encodeFloat", "enumFrom", "enumFromThen", "enumFromThenTo",
	      "enumFromTo", "error", "even", "exp", "exponent", "fail", "filter",
	      "flip", "floatDigits", "floatRadix", "floatRange", "floor", "fmap",
	      "foldl", "foldl1", "foldr", "foldr1", "fromEnum", "fromInteger",
	      "fromIntegral", "fromRational", "fst", "gcd", "getChar", "getContents",
	      "getLine", "head", "id", "init", "interact", "ioError", "isDenormalized",
	      "isIEEE", "isInfinite", "isNaN", "isNegativeZero", "iterate", "last",
	      "lcm", "length", "lex", "lines", "log", "logBase", "lookup", "map",
	      "mapM", "mapM_", "max", "maxBound", "maximum", "maybe", "min", "minBound",
	      "minimum", "mod", "negate", "not", "notElem", "null", "odd", "or",
	      "otherwise", "pi", "pred", "print", "product", "properFraction",
	      "putChar", "putStr", "putStrLn", "quot", "quotRem", "read", "readFile",
	      "readIO", "readList", "readLn", "readParen", "reads", "readsPrec",
	      "realToFrac", "recip", "rem", "repeat", "replicate", "return", "reverse",
	      "round", "scaleFloat", "scanl", "scanl1", "scanr", "scanr1", "seq",
	      "sequence", "sequence_", "show", "showChar", "showList", "showParen",
	      "showString", "shows", "showsPrec", "significand", "signum", "sin",
	      "sinh", "snd", "span", "splitAt", "sqrt", "subtract", "succ", "sum",
	      "tail", "take", "takeWhile", "tan", "tanh", "toEnum", "toInteger",
	      "toRational", "truncate", "uncurry", "undefined", "unlines", "until",
	      "unwords", "unzip", "unzip3", "userError", "words", "writeFile", "zip",
	      "zip3", "zipWith", "zipWith3");
	
	    var override = modeConfig.overrideKeywords;
	    if (override) for (var word in override) if (override.hasOwnProperty(word))
	      wkw[word] = override[word];
	
	    return wkw;
	  })();
	
	
	
	  return {
	    startState: function ()  { return { f: normal }; },
	    copyState:  function (s) { return { f: s.f }; },
	
	    token: function(stream, state) {
	      var t = state.f(stream, function(s) { state.f = s; });
	      var w = stream.current();
	      return wellKnownWords.hasOwnProperty(w) ? wellKnownWords[w] : t;
	    },
	
	    blockCommentStart: "{-",
	    blockCommentEnd: "-}",
	    lineComment: "--"
	  };
	
	});
	
	CodeMirror.defineMIME("text/x-haskell", "haskell");
	
	});


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(22), __webpack_require__(82));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../xml/xml", "../meta"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("markdown", function(cmCfg, modeCfg) {
	
	  var htmlMode = CodeMirror.getMode(cmCfg, "text/html");
	  var htmlModeMissing = htmlMode.name == "null"
	
	  function getMode(name) {
	    if (CodeMirror.findModeByName) {
	      var found = CodeMirror.findModeByName(name);
	      if (found) name = found.mime || found.mimes[0];
	    }
	    var mode = CodeMirror.getMode(cmCfg, name);
	    return mode.name == "null" ? null : mode;
	  }
	
	  // Should characters that affect highlighting be highlighted separate?
	  // Does not include characters that will be output (such as `1.` and `-` for lists)
	  if (modeCfg.highlightFormatting === undefined)
	    modeCfg.highlightFormatting = false;
	
	  // Maximum number of nested blockquotes. Set to 0 for infinite nesting.
	  // Excess `>` will emit `error` token.
	  if (modeCfg.maxBlockquoteDepth === undefined)
	    modeCfg.maxBlockquoteDepth = 0;
	
	  // Should underscores in words open/close em/strong?
	  if (modeCfg.underscoresBreakWords === undefined)
	    modeCfg.underscoresBreakWords = true;
	
	  // Use `fencedCodeBlocks` to configure fenced code blocks. false to
	  // disable, string to specify a precise regexp that the fence should
	  // match, and true to allow three or more backticks or tildes (as
	  // per CommonMark).
	
	  // Turn on task lists? ("- [ ] " and "- [x] ")
	  if (modeCfg.taskLists === undefined) modeCfg.taskLists = false;
	
	  // Turn on strikethrough syntax
	  if (modeCfg.strikethrough === undefined)
	    modeCfg.strikethrough = false;
	
	  // Allow token types to be overridden by user-provided token types.
	  if (modeCfg.tokenTypeOverrides === undefined)
	    modeCfg.tokenTypeOverrides = {};
	
	  var tokenTypes = {
	    header: "header",
	    code: "comment",
	    quote: "quote",
	    list1: "variable-2",
	    list2: "variable-3",
	    list3: "keyword",
	    hr: "hr",
	    image: "image",
	    imageAltText: "image-alt-text",
	    imageMarker: "image-marker",
	    formatting: "formatting",
	    linkInline: "link",
	    linkEmail: "link",
	    linkText: "link",
	    linkHref: "string",
	    em: "em",
	    strong: "strong",
	    strikethrough: "strikethrough"
	  };
	
	  for (var tokenType in tokenTypes) {
	    if (tokenTypes.hasOwnProperty(tokenType) && modeCfg.tokenTypeOverrides[tokenType]) {
	      tokenTypes[tokenType] = modeCfg.tokenTypeOverrides[tokenType];
	    }
	  }
	
	  var hrRE = /^([*\-_])(?:\s*\1){2,}\s*$/
	  ,   listRE = /^(?:[*\-+]|^[0-9]+([.)]))\s+/
	  ,   taskListRE = /^\[(x| )\](?=\s)/ // Must follow listRE
	  ,   atxHeaderRE = modeCfg.allowAtxHeaderWithoutSpace ? /^(#+)/ : /^(#+)(?: |$)/
	  ,   setextHeaderRE = /^ *(?:\={1,}|-{1,})\s*$/
	  ,   textRE = /^[^#!\[\]*_\\<>` "'(~]+/
	  ,   fencedCodeRE = new RegExp("^(" + (modeCfg.fencedCodeBlocks === true ? "~~~+|```+" : modeCfg.fencedCodeBlocks) +
	                                ")[ \\t]*([\\w+#\-]*)");
	
	  function switchInline(stream, state, f) {
	    state.f = state.inline = f;
	    return f(stream, state);
	  }
	
	  function switchBlock(stream, state, f) {
	    state.f = state.block = f;
	    return f(stream, state);
	  }
	
	  function lineIsEmpty(line) {
	    return !line || !/\S/.test(line.string)
	  }
	
	  // Blocks
	
	  function blankLine(state) {
	    // Reset linkTitle state
	    state.linkTitle = false;
	    // Reset EM state
	    state.em = false;
	    // Reset STRONG state
	    state.strong = false;
	    // Reset strikethrough state
	    state.strikethrough = false;
	    // Reset state.quote
	    state.quote = 0;
	    // Reset state.indentedCode
	    state.indentedCode = false;
	    if (htmlModeMissing && state.f == htmlBlock) {
	      state.f = inlineNormal;
	      state.block = blockNormal;
	    }
	    // Reset state.trailingSpace
	    state.trailingSpace = 0;
	    state.trailingSpaceNewLine = false;
	    // Mark this line as blank
	    state.prevLine = state.thisLine
	    state.thisLine = null
	    return null;
	  }
	
	  function blockNormal(stream, state) {
	
	    var sol = stream.sol();
	
	    var prevLineIsList = state.list !== false,
	        prevLineIsIndentedCode = state.indentedCode;
	
	    state.indentedCode = false;
	
	    if (prevLineIsList) {
	      if (state.indentationDiff >= 0) { // Continued list
	        if (state.indentationDiff < 4) { // Only adjust indentation if *not* a code block
	          state.indentation -= state.indentationDiff;
	        }
	        state.list = null;
	      } else if (state.indentation > 0) {
	        state.list = null;
	      } else { // No longer a list
	        state.list = false;
	      }
	    }
	
	    var match = null;
	    if (state.indentationDiff >= 4) {
	      stream.skipToEnd();
	      if (prevLineIsIndentedCode || lineIsEmpty(state.prevLine)) {
	        state.indentation -= 4;
	        state.indentedCode = true;
	        return tokenTypes.code;
	      } else {
	        return null;
	      }
	    } else if (stream.eatSpace()) {
	      return null;
	    } else if ((match = stream.match(atxHeaderRE)) && match[1].length <= 6) {
	      state.header = match[1].length;
	      if (modeCfg.highlightFormatting) state.formatting = "header";
	      state.f = state.inline;
	      return getType(state);
	    } else if (!lineIsEmpty(state.prevLine) && !state.quote && !prevLineIsList &&
	               !prevLineIsIndentedCode && (match = stream.match(setextHeaderRE))) {
	      state.header = match[0].charAt(0) == '=' ? 1 : 2;
	      if (modeCfg.highlightFormatting) state.formatting = "header";
	      state.f = state.inline;
	      return getType(state);
	    } else if (stream.eat('>')) {
	      state.quote = sol ? 1 : state.quote + 1;
	      if (modeCfg.highlightFormatting) state.formatting = "quote";
	      stream.eatSpace();
	      return getType(state);
	    } else if (stream.peek() === '[') {
	      return switchInline(stream, state, footnoteLink);
	    } else if (stream.match(hrRE, true)) {
	      state.hr = true;
	      return tokenTypes.hr;
	    } else if (match = stream.match(listRE)) {
	      var listType = match[1] ? "ol" : "ul";
	      state.indentation = stream.column() + stream.current().length;
	      state.list = true;
	
	      // While this list item's marker's indentation
	      // is less than the deepest list item's content's indentation,
	      // pop the deepest list item indentation off the stack.
	      while (state.listStack && stream.column() < state.listStack[state.listStack.length - 1]) {
	        state.listStack.pop();
	      }
	
	      // Add this list item's content's indentation to the stack
	      state.listStack.push(state.indentation);
	
	      if (modeCfg.taskLists && stream.match(taskListRE, false)) {
	        state.taskList = true;
	      }
	      state.f = state.inline;
	      if (modeCfg.highlightFormatting) state.formatting = ["list", "list-" + listType];
	      return getType(state);
	    } else if (modeCfg.fencedCodeBlocks && (match = stream.match(fencedCodeRE, true))) {
	      state.fencedChars = match[1]
	      // try switching mode
	      state.localMode = getMode(match[2]);
	      if (state.localMode) state.localState = CodeMirror.startState(state.localMode);
	      state.f = state.block = local;
	      if (modeCfg.highlightFormatting) state.formatting = "code-block";
	      state.code = -1
	      return getType(state);
	    }
	
	    return switchInline(stream, state, state.inline);
	  }
	
	  function htmlBlock(stream, state) {
	    var style = htmlMode.token(stream, state.htmlState);
	    if (!htmlModeMissing) {
	      var inner = CodeMirror.innerMode(htmlMode, state.htmlState)
	      if ((inner.mode.name == "xml" && inner.state.tagStart === null &&
	           (!inner.state.context && inner.state.tokenize.isInText)) ||
	          (state.md_inside && stream.current().indexOf(">") > -1)) {
	        state.f = inlineNormal;
	        state.block = blockNormal;
	        state.htmlState = null;
	      }
	    }
	    return style;
	  }
	
	  function local(stream, state) {
	    if (state.fencedChars && stream.match(state.fencedChars, false)) {
	      state.localMode = state.localState = null;
	      state.f = state.block = leavingLocal;
	      return null;
	    } else if (state.localMode) {
	      return state.localMode.token(stream, state.localState);
	    } else {
	      stream.skipToEnd();
	      return tokenTypes.code;
	    }
	  }
	
	  function leavingLocal(stream, state) {
	    stream.match(state.fencedChars);
	    state.block = blockNormal;
	    state.f = inlineNormal;
	    state.fencedChars = null;
	    if (modeCfg.highlightFormatting) state.formatting = "code-block";
	    state.code = 1
	    var returnType = getType(state);
	    state.code = 0
	    return returnType;
	  }
	
	  // Inline
	  function getType(state) {
	    var styles = [];
	
	    if (state.formatting) {
	      styles.push(tokenTypes.formatting);
	
	      if (typeof state.formatting === "string") state.formatting = [state.formatting];
	
	      for (var i = 0; i < state.formatting.length; i++) {
	        styles.push(tokenTypes.formatting + "-" + state.formatting[i]);
	
	        if (state.formatting[i] === "header") {
	          styles.push(tokenTypes.formatting + "-" + state.formatting[i] + "-" + state.header);
	        }
	
	        // Add `formatting-quote` and `formatting-quote-#` for blockquotes
	        // Add `error` instead if the maximum blockquote nesting depth is passed
	        if (state.formatting[i] === "quote") {
	          if (!modeCfg.maxBlockquoteDepth || modeCfg.maxBlockquoteDepth >= state.quote) {
	            styles.push(tokenTypes.formatting + "-" + state.formatting[i] + "-" + state.quote);
	          } else {
	            styles.push("error");
	          }
	        }
	      }
	    }
	
	    if (state.taskOpen) {
	      styles.push("meta");
	      return styles.length ? styles.join(' ') : null;
	    }
	    if (state.taskClosed) {
	      styles.push("property");
	      return styles.length ? styles.join(' ') : null;
	    }
	
	    if (state.linkHref) {
	      styles.push(tokenTypes.linkHref, "url");
	    } else { // Only apply inline styles to non-url text
	      if (state.strong) { styles.push(tokenTypes.strong); }
	      if (state.em) { styles.push(tokenTypes.em); }
	      if (state.strikethrough) { styles.push(tokenTypes.strikethrough); }
	      if (state.linkText) { styles.push(tokenTypes.linkText); }
	      if (state.code) { styles.push(tokenTypes.code); }
	      if (state.image) { styles.push(tokenTypes.image); }
	      if (state.imageAltText) { styles.push(tokenTypes.imageAltText, "link"); }
	      if (state.imageMarker) { styles.push(tokenTypes.imageMarker); }
	    }
	
	    if (state.header) { styles.push(tokenTypes.header, tokenTypes.header + "-" + state.header); }
	
	    if (state.quote) {
	      styles.push(tokenTypes.quote);
	
	      // Add `quote-#` where the maximum for `#` is modeCfg.maxBlockquoteDepth
	      if (!modeCfg.maxBlockquoteDepth || modeCfg.maxBlockquoteDepth >= state.quote) {
	        styles.push(tokenTypes.quote + "-" + state.quote);
	      } else {
	        styles.push(tokenTypes.quote + "-" + modeCfg.maxBlockquoteDepth);
	      }
	    }
	
	    if (state.list !== false) {
	      var listMod = (state.listStack.length - 1) % 3;
	      if (!listMod) {
	        styles.push(tokenTypes.list1);
	      } else if (listMod === 1) {
	        styles.push(tokenTypes.list2);
	      } else {
	        styles.push(tokenTypes.list3);
	      }
	    }
	
	    if (state.trailingSpaceNewLine) {
	      styles.push("trailing-space-new-line");
	    } else if (state.trailingSpace) {
	      styles.push("trailing-space-" + (state.trailingSpace % 2 ? "a" : "b"));
	    }
	
	    return styles.length ? styles.join(' ') : null;
	  }
	
	  function handleText(stream, state) {
	    if (stream.match(textRE, true)) {
	      return getType(state);
	    }
	    return undefined;
	  }
	
	  function inlineNormal(stream, state) {
	    var style = state.text(stream, state);
	    if (typeof style !== 'undefined')
	      return style;
	
	    if (state.list) { // List marker (*, +, -, 1., etc)
	      state.list = null;
	      return getType(state);
	    }
	
	    if (state.taskList) {
	      var taskOpen = stream.match(taskListRE, true)[1] !== "x";
	      if (taskOpen) state.taskOpen = true;
	      else state.taskClosed = true;
	      if (modeCfg.highlightFormatting) state.formatting = "task";
	      state.taskList = false;
	      return getType(state);
	    }
	
	    state.taskOpen = false;
	    state.taskClosed = false;
	
	    if (state.header && stream.match(/^#+$/, true)) {
	      if (modeCfg.highlightFormatting) state.formatting = "header";
	      return getType(state);
	    }
	
	    // Get sol() value now, before character is consumed
	    var sol = stream.sol();
	
	    var ch = stream.next();
	
	    // Matches link titles present on next line
	    if (state.linkTitle) {
	      state.linkTitle = false;
	      var matchCh = ch;
	      if (ch === '(') {
	        matchCh = ')';
	      }
	      matchCh = (matchCh+'').replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
	      var regex = '^\\s*(?:[^' + matchCh + '\\\\]+|\\\\\\\\|\\\\.)' + matchCh;
	      if (stream.match(new RegExp(regex), true)) {
	        return tokenTypes.linkHref;
	      }
	    }
	
	    // If this block is changed, it may need to be updated in GFM mode
	    if (ch === '`') {
	      var previousFormatting = state.formatting;
	      if (modeCfg.highlightFormatting) state.formatting = "code";
	      stream.eatWhile('`');
	      var count = stream.current().length
	      if (state.code == 0) {
	        state.code = count
	        return getType(state)
	      } else if (count == state.code) { // Must be exact
	        var t = getType(state)
	        state.code = 0
	        return t
	      } else {
	        state.formatting = previousFormatting
	        return getType(state)
	      }
	    } else if (state.code) {
	      return getType(state);
	    }
	
	    if (ch === '\\') {
	      stream.next();
	      if (modeCfg.highlightFormatting) {
	        var type = getType(state);
	        var formattingEscape = tokenTypes.formatting + "-escape";
	        return type ? type + " " + formattingEscape : formattingEscape;
	      }
	    }
	
	    if (ch === '!' && stream.match(/\[[^\]]*\] ?(?:\(|\[)/, false)) {
	      state.imageMarker = true;
	      state.image = true;
	      if (modeCfg.highlightFormatting) state.formatting = "image";
	      return getType(state);
	    }
	
	    if (ch === '[' && state.imageMarker && stream.match(/[^\]]*\](\(.*?\)| ?\[.*?\])/, false)) {
	      state.imageMarker = false;
	      state.imageAltText = true
	      if (modeCfg.highlightFormatting) state.formatting = "image";
	      return getType(state);
	    }
	
	    if (ch === ']' && state.imageAltText) {
	      if (modeCfg.highlightFormatting) state.formatting = "image";
	      var type = getType(state);
	      state.imageAltText = false;
	      state.image = false;
	      state.inline = state.f = linkHref;
	      return type;
	    }
	
	    if (ch === '[' && stream.match(/[^\]]*\](\(.*\)| ?\[.*?\])/, false) && !state.image) {
	      state.linkText = true;
	      if (modeCfg.highlightFormatting) state.formatting = "link";
	      return getType(state);
	    }
	
	    if (ch === ']' && state.linkText && stream.match(/\(.*?\)| ?\[.*?\]/, false)) {
	      if (modeCfg.highlightFormatting) state.formatting = "link";
	      var type = getType(state);
	      state.linkText = false;
	      state.inline = state.f = linkHref;
	      return type;
	    }
	
	    if (ch === '<' && stream.match(/^(https?|ftps?):\/\/(?:[^\\>]|\\.)+>/, false)) {
	      state.f = state.inline = linkInline;
	      if (modeCfg.highlightFormatting) state.formatting = "link";
	      var type = getType(state);
	      if (type){
	        type += " ";
	      } else {
	        type = "";
	      }
	      return type + tokenTypes.linkInline;
	    }
	
	    if (ch === '<' && stream.match(/^[^> \\]+@(?:[^\\>]|\\.)+>/, false)) {
	      state.f = state.inline = linkInline;
	      if (modeCfg.highlightFormatting) state.formatting = "link";
	      var type = getType(state);
	      if (type){
	        type += " ";
	      } else {
	        type = "";
	      }
	      return type + tokenTypes.linkEmail;
	    }
	
	    if (ch === '<' && stream.match(/^(!--|[a-z]+(?:\s+[a-z_:.\-]+(?:\s*=\s*[^ >]+)?)*\s*>)/i, false)) {
	      var end = stream.string.indexOf(">", stream.pos);
	      if (end != -1) {
	        var atts = stream.string.substring(stream.start, end);
	        if (/markdown\s*=\s*('|"){0,1}1('|"){0,1}/.test(atts)) state.md_inside = true;
	      }
	      stream.backUp(1);
	      state.htmlState = CodeMirror.startState(htmlMode);
	      return switchBlock(stream, state, htmlBlock);
	    }
	
	    if (ch === '<' && stream.match(/^\/\w*?>/)) {
	      state.md_inside = false;
	      return "tag";
	    }
	
	    var ignoreUnderscore = false;
	    if (!modeCfg.underscoresBreakWords) {
	      if (ch === '_' && stream.peek() !== '_' && stream.match(/(\w)/, false)) {
	        var prevPos = stream.pos - 2;
	        if (prevPos >= 0) {
	          var prevCh = stream.string.charAt(prevPos);
	          if (prevCh !== '_' && prevCh.match(/(\w)/, false)) {
	            ignoreUnderscore = true;
	          }
	        }
	      }
	    }
	    if (ch === '*' || (ch === '_' && !ignoreUnderscore)) {
	      if (sol && stream.peek() === ' ') {
	        // Do nothing, surrounded by newline and space
	      } else if (state.strong === ch && stream.eat(ch)) { // Remove STRONG
	        if (modeCfg.highlightFormatting) state.formatting = "strong";
	        var t = getType(state);
	        state.strong = false;
	        return t;
	      } else if (!state.strong && stream.eat(ch)) { // Add STRONG
	        state.strong = ch;
	        if (modeCfg.highlightFormatting) state.formatting = "strong";
	        return getType(state);
	      } else if (state.em === ch) { // Remove EM
	        if (modeCfg.highlightFormatting) state.formatting = "em";
	        var t = getType(state);
	        state.em = false;
	        return t;
	      } else if (!state.em) { // Add EM
	        state.em = ch;
	        if (modeCfg.highlightFormatting) state.formatting = "em";
	        return getType(state);
	      }
	    } else if (ch === ' ') {
	      if (stream.eat('*') || stream.eat('_')) { // Probably surrounded by spaces
	        if (stream.peek() === ' ') { // Surrounded by spaces, ignore
	          return getType(state);
	        } else { // Not surrounded by spaces, back up pointer
	          stream.backUp(1);
	        }
	      }
	    }
	
	    if (modeCfg.strikethrough) {
	      if (ch === '~' && stream.eatWhile(ch)) {
	        if (state.strikethrough) {// Remove strikethrough
	          if (modeCfg.highlightFormatting) state.formatting = "strikethrough";
	          var t = getType(state);
	          state.strikethrough = false;
	          return t;
	        } else if (stream.match(/^[^\s]/, false)) {// Add strikethrough
	          state.strikethrough = true;
	          if (modeCfg.highlightFormatting) state.formatting = "strikethrough";
	          return getType(state);
	        }
	      } else if (ch === ' ') {
	        if (stream.match(/^~~/, true)) { // Probably surrounded by space
	          if (stream.peek() === ' ') { // Surrounded by spaces, ignore
	            return getType(state);
	          } else { // Not surrounded by spaces, back up pointer
	            stream.backUp(2);
	          }
	        }
	      }
	    }
	
	    if (ch === ' ') {
	      if (stream.match(/ +$/, false)) {
	        state.trailingSpace++;
	      } else if (state.trailingSpace) {
	        state.trailingSpaceNewLine = true;
	      }
	    }
	
	    return getType(state);
	  }
	
	  function linkInline(stream, state) {
	    var ch = stream.next();
	
	    if (ch === ">") {
	      state.f = state.inline = inlineNormal;
	      if (modeCfg.highlightFormatting) state.formatting = "link";
	      var type = getType(state);
	      if (type){
	        type += " ";
	      } else {
	        type = "";
	      }
	      return type + tokenTypes.linkInline;
	    }
	
	    stream.match(/^[^>]+/, true);
	
	    return tokenTypes.linkInline;
	  }
	
	  function linkHref(stream, state) {
	    // Check if space, and return NULL if so (to avoid marking the space)
	    if(stream.eatSpace()){
	      return null;
	    }
	    var ch = stream.next();
	    if (ch === '(' || ch === '[') {
	      state.f = state.inline = getLinkHrefInside(ch === "(" ? ")" : "]", 0);
	      if (modeCfg.highlightFormatting) state.formatting = "link-string";
	      state.linkHref = true;
	      return getType(state);
	    }
	    return 'error';
	  }
	
	  var linkRE = {
	    ")": /^(?:[^\\\(\)]|\\.|\((?:[^\\\(\)]|\\.)*\))*?(?=\))/,
	    "]": /^(?:[^\\\[\]]|\\.|\[(?:[^\\\[\\]]|\\.)*\])*?(?=\])/
	  }
	
	  function getLinkHrefInside(endChar) {
	    return function(stream, state) {
	      var ch = stream.next();
	
	      if (ch === endChar) {
	        state.f = state.inline = inlineNormal;
	        if (modeCfg.highlightFormatting) state.formatting = "link-string";
	        var returnState = getType(state);
	        state.linkHref = false;
	        return returnState;
	      }
	
	      stream.match(linkRE[endChar])
	      state.linkHref = true;
	      return getType(state);
	    };
	  }
	
	  function footnoteLink(stream, state) {
	    if (stream.match(/^([^\]\\]|\\.)*\]:/, false)) {
	      state.f = footnoteLinkInside;
	      stream.next(); // Consume [
	      if (modeCfg.highlightFormatting) state.formatting = "link";
	      state.linkText = true;
	      return getType(state);
	    }
	    return switchInline(stream, state, inlineNormal);
	  }
	
	  function footnoteLinkInside(stream, state) {
	    if (stream.match(/^\]:/, true)) {
	      state.f = state.inline = footnoteUrl;
	      if (modeCfg.highlightFormatting) state.formatting = "link";
	      var returnType = getType(state);
	      state.linkText = false;
	      return returnType;
	    }
	
	    stream.match(/^([^\]\\]|\\.)+/, true);
	
	    return tokenTypes.linkText;
	  }
	
	  function footnoteUrl(stream, state) {
	    // Check if space, and return NULL if so (to avoid marking the space)
	    if(stream.eatSpace()){
	      return null;
	    }
	    // Match URL
	    stream.match(/^[^\s]+/, true);
	    // Check for link title
	    if (stream.peek() === undefined) { // End of line, set flag to check next line
	      state.linkTitle = true;
	    } else { // More content on line, check if link title
	      stream.match(/^(?:\s+(?:"(?:[^"\\]|\\\\|\\.)+"|'(?:[^'\\]|\\\\|\\.)+'|\((?:[^)\\]|\\\\|\\.)+\)))?/, true);
	    }
	    state.f = state.inline = inlineNormal;
	    return tokenTypes.linkHref + " url";
	  }
	
	  var mode = {
	    startState: function() {
	      return {
	        f: blockNormal,
	
	        prevLine: null,
	        thisLine: null,
	
	        block: blockNormal,
	        htmlState: null,
	        indentation: 0,
	
	        inline: inlineNormal,
	        text: handleText,
	
	        formatting: false,
	        linkText: false,
	        linkHref: false,
	        linkTitle: false,
	        code: 0,
	        em: false,
	        strong: false,
	        header: 0,
	        hr: false,
	        taskList: false,
	        list: false,
	        listStack: [],
	        quote: 0,
	        trailingSpace: 0,
	        trailingSpaceNewLine: false,
	        strikethrough: false,
	        fencedChars: null
	      };
	    },
	
	    copyState: function(s) {
	      return {
	        f: s.f,
	
	        prevLine: s.prevLine,
	        thisLine: s.thisLine,
	
	        block: s.block,
	        htmlState: s.htmlState && CodeMirror.copyState(htmlMode, s.htmlState),
	        indentation: s.indentation,
	
	        localMode: s.localMode,
	        localState: s.localMode ? CodeMirror.copyState(s.localMode, s.localState) : null,
	
	        inline: s.inline,
	        text: s.text,
	        formatting: false,
	        linkTitle: s.linkTitle,
	        code: s.code,
	        em: s.em,
	        strong: s.strong,
	        strikethrough: s.strikethrough,
	        header: s.header,
	        hr: s.hr,
	        taskList: s.taskList,
	        list: s.list,
	        listStack: s.listStack.slice(0),
	        quote: s.quote,
	        indentedCode: s.indentedCode,
	        trailingSpace: s.trailingSpace,
	        trailingSpaceNewLine: s.trailingSpaceNewLine,
	        md_inside: s.md_inside,
	        fencedChars: s.fencedChars
	      };
	    },
	
	    token: function(stream, state) {
	
	      // Reset state.formatting
	      state.formatting = false;
	
	      if (stream != state.thisLine) {
	        var forceBlankLine = state.header || state.hr;
	
	        // Reset state.header and state.hr
	        state.header = 0;
	        state.hr = false;
	
	        if (stream.match(/^\s*$/, true) || forceBlankLine) {
	          blankLine(state);
	          if (!forceBlankLine) return null
	          state.prevLine = null
	        }
	
	        state.prevLine = state.thisLine
	        state.thisLine = stream
	
	        // Reset state.taskList
	        state.taskList = false;
	
	        // Reset state.trailingSpace
	        state.trailingSpace = 0;
	        state.trailingSpaceNewLine = false;
	
	        state.f = state.block;
	        var indentation = stream.match(/^\s*/, true)[0].replace(/\t/g, '    ').length;
	        state.indentationDiff = Math.min(indentation - state.indentation, 4);
	        state.indentation = state.indentation + state.indentationDiff;
	        if (indentation > 0) return null;
	      }
	      return state.f(stream, state);
	    },
	
	    innerMode: function(state) {
	      if (state.block == htmlBlock) return {state: state.htmlState, mode: htmlMode};
	      if (state.localState) return {state: state.localState, mode: state.localMode};
	      return {state: state, mode: mode};
	    },
	
	    blankLine: blankLine,
	
	    getType: getType,
	
	    closeBrackets: "()[]{}''\"\"``",
	    fold: "markdown"
	  };
	  return mode;
	}, "xml");
	
	CodeMirror.defineMIME("text/x-markdown", "markdown");
	
	});


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.modeInfo = [
	    {name: "APL", mime: "text/apl", mode: "apl", ext: ["dyalog", "apl"]},
	    {name: "PGP", mimes: ["application/pgp", "application/pgp-keys", "application/pgp-signature"], mode: "asciiarmor", ext: ["pgp"]},
	    {name: "ASN.1", mime: "text/x-ttcn-asn", mode: "asn.1", ext: ["asn", "asn1"]},
	    {name: "Asterisk", mime: "text/x-asterisk", mode: "asterisk", file: /^extensions\.conf$/i},
	    {name: "Brainfuck", mime: "text/x-brainfuck", mode: "brainfuck", ext: ["b", "bf"]},
	    {name: "C", mime: "text/x-csrc", mode: "clike", ext: ["c", "h"]},
	    {name: "C++", mime: "text/x-c++src", mode: "clike", ext: ["cpp", "c++", "cc", "cxx", "hpp", "h++", "hh", "hxx"], alias: ["cpp"]},
	    {name: "Cobol", mime: "text/x-cobol", mode: "cobol", ext: ["cob", "cpy"]},
	    {name: "C#", mime: "text/x-csharp", mode: "clike", ext: ["cs"], alias: ["csharp"]},
	    {name: "Clojure", mime: "text/x-clojure", mode: "clojure", ext: ["clj", "cljc", "cljx"]},
	    {name: "ClojureScript", mime: "text/x-clojurescript", mode: "clojure", ext: ["cljs"]},
	    {name: "Closure Stylesheets (GSS)", mime: "text/x-gss", mode: "css", ext: ["gss"]},
	    {name: "CMake", mime: "text/x-cmake", mode: "cmake", ext: ["cmake", "cmake.in"], file: /^CMakeLists.txt$/},
	    {name: "CoffeeScript", mime: "text/x-coffeescript", mode: "coffeescript", ext: ["coffee"], alias: ["coffee", "coffee-script"]},
	    {name: "Common Lisp", mime: "text/x-common-lisp", mode: "commonlisp", ext: ["cl", "lisp", "el"], alias: ["lisp"]},
	    {name: "Cypher", mime: "application/x-cypher-query", mode: "cypher", ext: ["cyp", "cypher"]},
	    {name: "Cython", mime: "text/x-cython", mode: "python", ext: ["pyx", "pxd", "pxi"]},
	    {name: "Crystal", mime: "text/x-crystal", mode: "crystal", ext: ["cr"]},
	    {name: "CSS", mime: "text/css", mode: "css", ext: ["css"]},
	    {name: "CQL", mime: "text/x-cassandra", mode: "sql", ext: ["cql"]},
	    {name: "D", mime: "text/x-d", mode: "d", ext: ["d"]},
	    {name: "Dart", mimes: ["application/dart", "text/x-dart"], mode: "dart", ext: ["dart"]},
	    {name: "diff", mime: "text/x-diff", mode: "diff", ext: ["diff", "patch"]},
	    {name: "Django", mime: "text/x-django", mode: "django"},
	    {name: "Dockerfile", mime: "text/x-dockerfile", mode: "dockerfile", file: /^Dockerfile$/},
	    {name: "DTD", mime: "application/xml-dtd", mode: "dtd", ext: ["dtd"]},
	    {name: "Dylan", mime: "text/x-dylan", mode: "dylan", ext: ["dylan", "dyl", "intr"]},
	    {name: "EBNF", mime: "text/x-ebnf", mode: "ebnf"},
	    {name: "ECL", mime: "text/x-ecl", mode: "ecl", ext: ["ecl"]},
	    {name: "edn", mime: "application/edn", mode: "clojure", ext: ["edn"]},
	    {name: "Eiffel", mime: "text/x-eiffel", mode: "eiffel", ext: ["e"]},
	    {name: "Elm", mime: "text/x-elm", mode: "elm", ext: ["elm"]},
	    {name: "Embedded Javascript", mime: "application/x-ejs", mode: "htmlembedded", ext: ["ejs"]},
	    {name: "Embedded Ruby", mime: "application/x-erb", mode: "htmlembedded", ext: ["erb"]},
	    {name: "Erlang", mime: "text/x-erlang", mode: "erlang", ext: ["erl"]},
	    {name: "Factor", mime: "text/x-factor", mode: "factor", ext: ["factor"]},
	    {name: "FCL", mime: "text/x-fcl", mode: "fcl"},
	    {name: "Forth", mime: "text/x-forth", mode: "forth", ext: ["forth", "fth", "4th"]},
	    {name: "Fortran", mime: "text/x-fortran", mode: "fortran", ext: ["f", "for", "f77", "f90"]},
	    {name: "F#", mime: "text/x-fsharp", mode: "mllike", ext: ["fs"], alias: ["fsharp"]},
	    {name: "Gas", mime: "text/x-gas", mode: "gas", ext: ["s"]},
	    {name: "Gherkin", mime: "text/x-feature", mode: "gherkin", ext: ["feature"]},
	    {name: "GitHub Flavored Markdown", mime: "text/x-gfm", mode: "gfm", file: /^(readme|contributing|history).md$/i},
	    {name: "Go", mime: "text/x-go", mode: "go", ext: ["go"]},
	    {name: "Groovy", mime: "text/x-groovy", mode: "groovy", ext: ["groovy", "gradle"], file: /^Jenkinsfile$/},
	    {name: "HAML", mime: "text/x-haml", mode: "haml", ext: ["haml"]},
	    {name: "Haskell", mime: "text/x-haskell", mode: "haskell", ext: ["hs"]},
	    {name: "Haskell (Literate)", mime: "text/x-literate-haskell", mode: "haskell-literate", ext: ["lhs"]},
	    {name: "Haxe", mime: "text/x-haxe", mode: "haxe", ext: ["hx"]},
	    {name: "HXML", mime: "text/x-hxml", mode: "haxe", ext: ["hxml"]},
	    {name: "ASP.NET", mime: "application/x-aspx", mode: "htmlembedded", ext: ["aspx"], alias: ["asp", "aspx"]},
	    {name: "HTML", mime: "text/html", mode: "htmlmixed", ext: ["html", "htm"], alias: ["xhtml"]},
	    {name: "HTTP", mime: "message/http", mode: "http"},
	    {name: "IDL", mime: "text/x-idl", mode: "idl", ext: ["pro"]},
	    {name: "Pug", mime: "text/x-pug", mode: "pug", ext: ["jade", "pug"], alias: ["jade"]},
	    {name: "Java", mime: "text/x-java", mode: "clike", ext: ["java"]},
	    {name: "Java Server Pages", mime: "application/x-jsp", mode: "htmlembedded", ext: ["jsp"], alias: ["jsp"]},
	    {name: "JavaScript", mimes: ["text/javascript", "text/ecmascript", "application/javascript", "application/x-javascript", "application/ecmascript"],
	     mode: "javascript", ext: ["js"], alias: ["ecmascript", "js", "node"]},
	    {name: "JSON", mimes: ["application/json", "application/x-json"], mode: "javascript", ext: ["json", "map"], alias: ["json5"]},
	    {name: "JSON-LD", mime: "application/ld+json", mode: "javascript", ext: ["jsonld"], alias: ["jsonld"]},
	    {name: "JSX", mime: "text/jsx", mode: "jsx", ext: ["jsx"]},
	    {name: "Jinja2", mime: "null", mode: "jinja2"},
	    {name: "Julia", mime: "text/x-julia", mode: "julia", ext: ["jl"]},
	    {name: "Kotlin", mime: "text/x-kotlin", mode: "clike", ext: ["kt"]},
	    {name: "LESS", mime: "text/x-less", mode: "css", ext: ["less"]},
	    {name: "LiveScript", mime: "text/x-livescript", mode: "livescript", ext: ["ls"], alias: ["ls"]},
	    {name: "Lua", mime: "text/x-lua", mode: "lua", ext: ["lua"]},
	    {name: "Markdown", mime: "text/x-markdown", mode: "markdown", ext: ["markdown", "md", "mkd"]},
	    {name: "mIRC", mime: "text/mirc", mode: "mirc"},
	    {name: "MariaDB SQL", mime: "text/x-mariadb", mode: "sql"},
	    {name: "Mathematica", mime: "text/x-mathematica", mode: "mathematica", ext: ["m", "nb"]},
	    {name: "Modelica", mime: "text/x-modelica", mode: "modelica", ext: ["mo"]},
	    {name: "MUMPS", mime: "text/x-mumps", mode: "mumps", ext: ["mps"]},
	    {name: "MS SQL", mime: "text/x-mssql", mode: "sql"},
	    {name: "mbox", mime: "application/mbox", mode: "mbox", ext: ["mbox"]},
	    {name: "MySQL", mime: "text/x-mysql", mode: "sql"},
	    {name: "Nginx", mime: "text/x-nginx-conf", mode: "nginx", file: /nginx.*\.conf$/i},
	    {name: "NSIS", mime: "text/x-nsis", mode: "nsis", ext: ["nsh", "nsi"]},
	    {name: "NTriples", mime: "text/n-triples", mode: "ntriples", ext: ["nt"]},
	    {name: "Objective C", mime: "text/x-objectivec", mode: "clike", ext: ["m", "mm"], alias: ["objective-c", "objc"]},
	    {name: "OCaml", mime: "text/x-ocaml", mode: "mllike", ext: ["ml", "mli", "mll", "mly"]},
	    {name: "Octave", mime: "text/x-octave", mode: "octave", ext: ["m"]},
	    {name: "Oz", mime: "text/x-oz", mode: "oz", ext: ["oz"]},
	    {name: "Pascal", mime: "text/x-pascal", mode: "pascal", ext: ["p", "pas"]},
	    {name: "PEG.js", mime: "null", mode: "pegjs", ext: ["jsonld"]},
	    {name: "Perl", mime: "text/x-perl", mode: "perl", ext: ["pl", "pm"]},
	    {name: "PHP", mime: "application/x-httpd-php", mode: "php", ext: ["php", "php3", "php4", "php5", "phtml"]},
	    {name: "Pig", mime: "text/x-pig", mode: "pig", ext: ["pig"]},
	    {name: "Plain Text", mime: "text/plain", mode: "null", ext: ["txt", "text", "conf", "def", "list", "log"]},
	    {name: "PLSQL", mime: "text/x-plsql", mode: "sql", ext: ["pls"]},
	    {name: "PowerShell", mime: "application/x-powershell", mode: "powershell", ext: ["ps1", "psd1", "psm1"]},
	    {name: "Properties files", mime: "text/x-properties", mode: "properties", ext: ["properties", "ini", "in"], alias: ["ini", "properties"]},
	    {name: "ProtoBuf", mime: "text/x-protobuf", mode: "protobuf", ext: ["proto"]},
	    {name: "Python", mime: "text/x-python", mode: "python", ext: ["BUILD", "bzl", "py", "pyw"], file: /^(BUCK|BUILD)$/},
	    {name: "Puppet", mime: "text/x-puppet", mode: "puppet", ext: ["pp"]},
	    {name: "Q", mime: "text/x-q", mode: "q", ext: ["q"]},
	    {name: "R", mime: "text/x-rsrc", mode: "r", ext: ["r", "R"], alias: ["rscript"]},
	    {name: "reStructuredText", mime: "text/x-rst", mode: "rst", ext: ["rst"], alias: ["rst"]},
	    {name: "RPM Changes", mime: "text/x-rpm-changes", mode: "rpm"},
	    {name: "RPM Spec", mime: "text/x-rpm-spec", mode: "rpm", ext: ["spec"]},
	    {name: "Ruby", mime: "text/x-ruby", mode: "ruby", ext: ["rb"], alias: ["jruby", "macruby", "rake", "rb", "rbx"]},
	    {name: "Rust", mime: "text/x-rustsrc", mode: "rust", ext: ["rs"]},
	    {name: "SAS", mime: "text/x-sas", mode: "sas", ext: ["sas"]},
	    {name: "Sass", mime: "text/x-sass", mode: "sass", ext: ["sass"]},
	    {name: "Scala", mime: "text/x-scala", mode: "clike", ext: ["scala"]},
	    {name: "Scheme", mime: "text/x-scheme", mode: "scheme", ext: ["scm", "ss"]},
	    {name: "SCSS", mime: "text/x-scss", mode: "css", ext: ["scss"]},
	    {name: "Shell", mime: "text/x-sh", mode: "shell", ext: ["sh", "ksh", "bash"], alias: ["bash", "sh", "zsh"], file: /^PKGBUILD$/},
	    {name: "Sieve", mime: "application/sieve", mode: "sieve", ext: ["siv", "sieve"]},
	    {name: "Slim", mimes: ["text/x-slim", "application/x-slim"], mode: "slim", ext: ["slim"]},
	    {name: "Smalltalk", mime: "text/x-stsrc", mode: "smalltalk", ext: ["st"]},
	    {name: "Smarty", mime: "text/x-smarty", mode: "smarty", ext: ["tpl"]},
	    {name: "Solr", mime: "text/x-solr", mode: "solr"},
	    {name: "Soy", mime: "text/x-soy", mode: "soy", ext: ["soy"], alias: ["closure template"]},
	    {name: "SPARQL", mime: "application/sparql-query", mode: "sparql", ext: ["rq", "sparql"], alias: ["sparul"]},
	    {name: "Spreadsheet", mime: "text/x-spreadsheet", mode: "spreadsheet", alias: ["excel", "formula"]},
	    {name: "SQL", mime: "text/x-sql", mode: "sql", ext: ["sql"]},
	    {name: "Squirrel", mime: "text/x-squirrel", mode: "clike", ext: ["nut"]},
	    {name: "Stylus", mime: "text/x-styl", mode: "stylus", ext: ["styl"]},
	    {name: "Swift", mime: "text/x-swift", mode: "swift", ext: ["swift"]},
	    {name: "sTeX", mime: "text/x-stex", mode: "stex"},
	    {name: "LaTeX", mime: "text/x-latex", mode: "stex", ext: ["text", "ltx"], alias: ["tex"]},
	    {name: "SystemVerilog", mime: "text/x-systemverilog", mode: "verilog", ext: ["v"]},
	    {name: "Tcl", mime: "text/x-tcl", mode: "tcl", ext: ["tcl"]},
	    {name: "Textile", mime: "text/x-textile", mode: "textile", ext: ["textile"]},
	    {name: "TiddlyWiki ", mime: "text/x-tiddlywiki", mode: "tiddlywiki"},
	    {name: "Tiki wiki", mime: "text/tiki", mode: "tiki"},
	    {name: "TOML", mime: "text/x-toml", mode: "toml", ext: ["toml"]},
	    {name: "Tornado", mime: "text/x-tornado", mode: "tornado"},
	    {name: "troff", mime: "text/troff", mode: "troff", ext: ["1", "2", "3", "4", "5", "6", "7", "8", "9"]},
	    {name: "TTCN", mime: "text/x-ttcn", mode: "ttcn", ext: ["ttcn", "ttcn3", "ttcnpp"]},
	    {name: "TTCN_CFG", mime: "text/x-ttcn-cfg", mode: "ttcn-cfg", ext: ["cfg"]},
	    {name: "Turtle", mime: "text/turtle", mode: "turtle", ext: ["ttl"]},
	    {name: "TypeScript", mime: "application/typescript", mode: "javascript", ext: ["ts"], alias: ["ts"]},
	    {name: "Twig", mime: "text/x-twig", mode: "twig"},
	    {name: "Web IDL", mime: "text/x-webidl", mode: "webidl", ext: ["webidl"]},
	    {name: "VB.NET", mime: "text/x-vb", mode: "vb", ext: ["vb"]},
	    {name: "VBScript", mime: "text/vbscript", mode: "vbscript", ext: ["vbs"]},
	    {name: "Velocity", mime: "text/velocity", mode: "velocity", ext: ["vtl"]},
	    {name: "Verilog", mime: "text/x-verilog", mode: "verilog", ext: ["v"]},
	    {name: "VHDL", mime: "text/x-vhdl", mode: "vhdl", ext: ["vhd", "vhdl"]},
	    {name: "Vue.js Component", mimes: ["script/x-vue", "text/x-vue"], mode: "vue", ext: ["vue"]},
	    {name: "XML", mimes: ["application/xml", "text/xml"], mode: "xml", ext: ["xml", "xsl", "xsd", "svg"], alias: ["rss", "wsdl", "xsd"]},
	    {name: "XQuery", mime: "application/xquery", mode: "xquery", ext: ["xy", "xquery"]},
	    {name: "Yacas", mime: "text/x-yacas", mode: "yacas", ext: ["ys"]},
	    {name: "YAML", mimes: ["text/x-yaml", "text/yaml"], mode: "yaml", ext: ["yaml", "yml"], alias: ["yml"]},
	    {name: "Z80", mime: "text/x-z80", mode: "z80", ext: ["z80"]},
	    {name: "mscgen", mime: "text/x-mscgen", mode: "mscgen", ext: ["mscgen", "mscin", "msc"]},
	    {name: "xu", mime: "text/x-xu", mode: "mscgen", ext: ["xu"]},
	    {name: "msgenny", mime: "text/x-msgenny", mode: "mscgen", ext: ["msgenny"]}
	  ];
	  // Ensure all modes have a mime property for backwards compatibility
	  for (var i = 0; i < CodeMirror.modeInfo.length; i++) {
	    var info = CodeMirror.modeInfo[i];
	    if (info.mimes) info.mime = info.mimes[0];
	  }
	
	  CodeMirror.findModeByMIME = function(mime) {
	    mime = mime.toLowerCase();
	    for (var i = 0; i < CodeMirror.modeInfo.length; i++) {
	      var info = CodeMirror.modeInfo[i];
	      if (info.mime == mime) return info;
	      if (info.mimes) for (var j = 0; j < info.mimes.length; j++)
	        if (info.mimes[j] == mime) return info;
	    }
	    if (/\+xml$/.test(mime)) return CodeMirror.findModeByMIME("application/xml")
	    if (/\+json$/.test(mime)) return CodeMirror.findModeByMIME("application/json")
	  };
	
	  CodeMirror.findModeByExtension = function(ext) {
	    for (var i = 0; i < CodeMirror.modeInfo.length; i++) {
	      var info = CodeMirror.modeInfo[i];
	      if (info.ext) for (var j = 0; j < info.ext.length; j++)
	        if (info.ext[j] == ext) return info;
	    }
	  };
	
	  CodeMirror.findModeByFileName = function(filename) {
	    for (var i = 0; i < CodeMirror.modeInfo.length; i++) {
	      var info = CodeMirror.modeInfo[i];
	      if (info.file && info.file.test(filename)) return info;
	    }
	    var dot = filename.lastIndexOf(".");
	    var ext = dot > -1 && filename.substring(dot + 1, filename.length);
	    if (ext) return CodeMirror.findModeByExtension(ext);
	  };
	
	  CodeMirror.findModeByName = function(name) {
	    name = name.toLowerCase();
	    for (var i = 0; i < CodeMirror.modeInfo.length; i++) {
	      var info = CodeMirror.modeInfo[i];
	      if (info.name.toLowerCase() == name) return info;
	      if (info.alias) for (var j = 0; j < info.alias.length; j++)
	        if (info.alias[j].toLowerCase() == name) return info;
	    }
	  };
	});


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(12), __webpack_require__(21), __webpack_require__(5));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../javascript/javascript", "../css/css", "../htmlmixed/htmlmixed"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("pug", function (config) {
	  // token types
	  var KEYWORD = 'keyword';
	  var DOCTYPE = 'meta';
	  var ID = 'builtin';
	  var CLASS = 'qualifier';
	
	  var ATTRS_NEST = {
	    '{': '}',
	    '(': ')',
	    '[': ']'
	  };
	
	  var jsMode = CodeMirror.getMode(config, 'javascript');
	
	  function State() {
	    this.javaScriptLine = false;
	    this.javaScriptLineExcludesColon = false;
	
	    this.javaScriptArguments = false;
	    this.javaScriptArgumentsDepth = 0;
	
	    this.isInterpolating = false;
	    this.interpolationNesting = 0;
	
	    this.jsState = CodeMirror.startState(jsMode);
	
	    this.restOfLine = '';
	
	    this.isIncludeFiltered = false;
	    this.isEach = false;
	
	    this.lastTag = '';
	    this.scriptType = '';
	
	    // Attributes Mode
	    this.isAttrs = false;
	    this.attrsNest = [];
	    this.inAttributeName = true;
	    this.attributeIsType = false;
	    this.attrValue = '';
	
	    // Indented Mode
	    this.indentOf = Infinity;
	    this.indentToken = '';
	
	    this.innerMode = null;
	    this.innerState = null;
	
	    this.innerModeForLine = false;
	  }
	  /**
	   * Safely copy a state
	   *
	   * @return {State}
	   */
	  State.prototype.copy = function () {
	    var res = new State();
	    res.javaScriptLine = this.javaScriptLine;
	    res.javaScriptLineExcludesColon = this.javaScriptLineExcludesColon;
	    res.javaScriptArguments = this.javaScriptArguments;
	    res.javaScriptArgumentsDepth = this.javaScriptArgumentsDepth;
	    res.isInterpolating = this.isInterpolating;
	    res.interpolationNesting = this.interpolationNesting;
	
	    res.jsState = CodeMirror.copyState(jsMode, this.jsState);
	
	    res.innerMode = this.innerMode;
	    if (this.innerMode && this.innerState) {
	      res.innerState = CodeMirror.copyState(this.innerMode, this.innerState);
	    }
	
	    res.restOfLine = this.restOfLine;
	
	    res.isIncludeFiltered = this.isIncludeFiltered;
	    res.isEach = this.isEach;
	    res.lastTag = this.lastTag;
	    res.scriptType = this.scriptType;
	    res.isAttrs = this.isAttrs;
	    res.attrsNest = this.attrsNest.slice();
	    res.inAttributeName = this.inAttributeName;
	    res.attributeIsType = this.attributeIsType;
	    res.attrValue = this.attrValue;
	    res.indentOf = this.indentOf;
	    res.indentToken = this.indentToken;
	
	    res.innerModeForLine = this.innerModeForLine;
	
	    return res;
	  };
	
	  function javaScript(stream, state) {
	    if (stream.sol()) {
	      // if javaScriptLine was set at end of line, ignore it
	      state.javaScriptLine = false;
	      state.javaScriptLineExcludesColon = false;
	    }
	    if (state.javaScriptLine) {
	      if (state.javaScriptLineExcludesColon && stream.peek() === ':') {
	        state.javaScriptLine = false;
	        state.javaScriptLineExcludesColon = false;
	        return;
	      }
	      var tok = jsMode.token(stream, state.jsState);
	      if (stream.eol()) state.javaScriptLine = false;
	      return tok || true;
	    }
	  }
	  function javaScriptArguments(stream, state) {
	    if (state.javaScriptArguments) {
	      if (state.javaScriptArgumentsDepth === 0 && stream.peek() !== '(') {
	        state.javaScriptArguments = false;
	        return;
	      }
	      if (stream.peek() === '(') {
	        state.javaScriptArgumentsDepth++;
	      } else if (stream.peek() === ')') {
	        state.javaScriptArgumentsDepth--;
	      }
	      if (state.javaScriptArgumentsDepth === 0) {
	        state.javaScriptArguments = false;
	        return;
	      }
	
	      var tok = jsMode.token(stream, state.jsState);
	      return tok || true;
	    }
	  }
	
	  function yieldStatement(stream) {
	    if (stream.match(/^yield\b/)) {
	        return 'keyword';
	    }
	  }
	
	  function doctype(stream) {
	    if (stream.match(/^(?:doctype) *([^\n]+)?/)) {
	        return DOCTYPE;
	    }
	  }
	
	  function interpolation(stream, state) {
	    if (stream.match('#{')) {
	      state.isInterpolating = true;
	      state.interpolationNesting = 0;
	      return 'punctuation';
	    }
	  }
	
	  function interpolationContinued(stream, state) {
	    if (state.isInterpolating) {
	      if (stream.peek() === '}') {
	        state.interpolationNesting--;
	        if (state.interpolationNesting < 0) {
	          stream.next();
	          state.isInterpolating = false;
	          return 'punctuation';
	        }
	      } else if (stream.peek() === '{') {
	        state.interpolationNesting++;
	      }
	      return jsMode.token(stream, state.jsState) || true;
	    }
	  }
	
	  function caseStatement(stream, state) {
	    if (stream.match(/^case\b/)) {
	      state.javaScriptLine = true;
	      return KEYWORD;
	    }
	  }
	
	  function when(stream, state) {
	    if (stream.match(/^when\b/)) {
	      state.javaScriptLine = true;
	      state.javaScriptLineExcludesColon = true;
	      return KEYWORD;
	    }
	  }
	
	  function defaultStatement(stream) {
	    if (stream.match(/^default\b/)) {
	      return KEYWORD;
	    }
	  }
	
	  function extendsStatement(stream, state) {
	    if (stream.match(/^extends?\b/)) {
	      state.restOfLine = 'string';
	      return KEYWORD;
	    }
	  }
	
	  function append(stream, state) {
	    if (stream.match(/^append\b/)) {
	      state.restOfLine = 'variable';
	      return KEYWORD;
	    }
	  }
	  function prepend(stream, state) {
	    if (stream.match(/^prepend\b/)) {
	      state.restOfLine = 'variable';
	      return KEYWORD;
	    }
	  }
	  function block(stream, state) {
	    if (stream.match(/^block\b *(?:(prepend|append)\b)?/)) {
	      state.restOfLine = 'variable';
	      return KEYWORD;
	    }
	  }
	
	  function include(stream, state) {
	    if (stream.match(/^include\b/)) {
	      state.restOfLine = 'string';
	      return KEYWORD;
	    }
	  }
	
	  function includeFiltered(stream, state) {
	    if (stream.match(/^include:([a-zA-Z0-9\-]+)/, false) && stream.match('include')) {
	      state.isIncludeFiltered = true;
	      return KEYWORD;
	    }
	  }
	
	  function includeFilteredContinued(stream, state) {
	    if (state.isIncludeFiltered) {
	      var tok = filter(stream, state);
	      state.isIncludeFiltered = false;
	      state.restOfLine = 'string';
	      return tok;
	    }
	  }
	
	  function mixin(stream, state) {
	    if (stream.match(/^mixin\b/)) {
	      state.javaScriptLine = true;
	      return KEYWORD;
	    }
	  }
	
	  function call(stream, state) {
	    if (stream.match(/^\+([-\w]+)/)) {
	      if (!stream.match(/^\( *[-\w]+ *=/, false)) {
	        state.javaScriptArguments = true;
	        state.javaScriptArgumentsDepth = 0;
	      }
	      return 'variable';
	    }
	    if (stream.match(/^\+#{/, false)) {
	      stream.next();
	      state.mixinCallAfter = true;
	      return interpolation(stream, state);
	    }
	  }
	  function callArguments(stream, state) {
	    if (state.mixinCallAfter) {
	      state.mixinCallAfter = false;
	      if (!stream.match(/^\( *[-\w]+ *=/, false)) {
	        state.javaScriptArguments = true;
	        state.javaScriptArgumentsDepth = 0;
	      }
	      return true;
	    }
	  }
	
	  function conditional(stream, state) {
	    if (stream.match(/^(if|unless|else if|else)\b/)) {
	      state.javaScriptLine = true;
	      return KEYWORD;
	    }
	  }
	
	  function each(stream, state) {
	    if (stream.match(/^(- *)?(each|for)\b/)) {
	      state.isEach = true;
	      return KEYWORD;
	    }
	  }
	  function eachContinued(stream, state) {
	    if (state.isEach) {
	      if (stream.match(/^ in\b/)) {
	        state.javaScriptLine = true;
	        state.isEach = false;
	        return KEYWORD;
	      } else if (stream.sol() || stream.eol()) {
	        state.isEach = false;
	      } else if (stream.next()) {
	        while (!stream.match(/^ in\b/, false) && stream.next());
	        return 'variable';
	      }
	    }
	  }
	
	  function whileStatement(stream, state) {
	    if (stream.match(/^while\b/)) {
	      state.javaScriptLine = true;
	      return KEYWORD;
	    }
	  }
	
	  function tag(stream, state) {
	    var captures;
	    if (captures = stream.match(/^(\w(?:[-:\w]*\w)?)\/?/)) {
	      state.lastTag = captures[1].toLowerCase();
	      if (state.lastTag === 'script') {
	        state.scriptType = 'application/javascript';
	      }
	      return 'tag';
	    }
	  }
	
	  function filter(stream, state) {
	    if (stream.match(/^:([\w\-]+)/)) {
	      var innerMode;
	      if (config && config.innerModes) {
	        innerMode = config.innerModes(stream.current().substring(1));
	      }
	      if (!innerMode) {
	        innerMode = stream.current().substring(1);
	      }
	      if (typeof innerMode === 'string') {
	        innerMode = CodeMirror.getMode(config, innerMode);
	      }
	      setInnerMode(stream, state, innerMode);
	      return 'atom';
	    }
	  }
	
	  function code(stream, state) {
	    if (stream.match(/^(!?=|-)/)) {
	      state.javaScriptLine = true;
	      return 'punctuation';
	    }
	  }
	
	  function id(stream) {
	    if (stream.match(/^#([\w-]+)/)) {
	      return ID;
	    }
	  }
	
	  function className(stream) {
	    if (stream.match(/^\.([\w-]+)/)) {
	      return CLASS;
	    }
	  }
	
	  function attrs(stream, state) {
	    if (stream.peek() == '(') {
	      stream.next();
	      state.isAttrs = true;
	      state.attrsNest = [];
	      state.inAttributeName = true;
	      state.attrValue = '';
	      state.attributeIsType = false;
	      return 'punctuation';
	    }
	  }
	
	  function attrsContinued(stream, state) {
	    if (state.isAttrs) {
	      if (ATTRS_NEST[stream.peek()]) {
	        state.attrsNest.push(ATTRS_NEST[stream.peek()]);
	      }
	      if (state.attrsNest[state.attrsNest.length - 1] === stream.peek()) {
	        state.attrsNest.pop();
	      } else  if (stream.eat(')')) {
	        state.isAttrs = false;
	        return 'punctuation';
	      }
	      if (state.inAttributeName && stream.match(/^[^=,\)!]+/)) {
	        if (stream.peek() === '=' || stream.peek() === '!') {
	          state.inAttributeName = false;
	          state.jsState = CodeMirror.startState(jsMode);
	          if (state.lastTag === 'script' && stream.current().trim().toLowerCase() === 'type') {
	            state.attributeIsType = true;
	          } else {
	            state.attributeIsType = false;
	          }
	        }
	        return 'attribute';
	      }
	
	      var tok = jsMode.token(stream, state.jsState);
	      if (state.attributeIsType && tok === 'string') {
	        state.scriptType = stream.current().toString();
	      }
	      if (state.attrsNest.length === 0 && (tok === 'string' || tok === 'variable' || tok === 'keyword')) {
	        try {
	          Function('', 'var x ' + state.attrValue.replace(/,\s*$/, '').replace(/^!/, ''));
	          state.inAttributeName = true;
	          state.attrValue = '';
	          stream.backUp(stream.current().length);
	          return attrsContinued(stream, state);
	        } catch (ex) {
	          //not the end of an attribute
	        }
	      }
	      state.attrValue += stream.current();
	      return tok || true;
	    }
	  }
	
	  function attributesBlock(stream, state) {
	    if (stream.match(/^&attributes\b/)) {
	      state.javaScriptArguments = true;
	      state.javaScriptArgumentsDepth = 0;
	      return 'keyword';
	    }
	  }
	
	  function indent(stream) {
	    if (stream.sol() && stream.eatSpace()) {
	      return 'indent';
	    }
	  }
	
	  function comment(stream, state) {
	    if (stream.match(/^ *\/\/(-)?([^\n]*)/)) {
	      state.indentOf = stream.indentation();
	      state.indentToken = 'comment';
	      return 'comment';
	    }
	  }
	
	  function colon(stream) {
	    if (stream.match(/^: */)) {
	      return 'colon';
	    }
	  }
	
	  function text(stream, state) {
	    if (stream.match(/^(?:\| ?| )([^\n]+)/)) {
	      return 'string';
	    }
	    if (stream.match(/^(<[^\n]*)/, false)) {
	      // html string
	      setInnerMode(stream, state, 'htmlmixed');
	      state.innerModeForLine = true;
	      return innerMode(stream, state, true);
	    }
	  }
	
	  function dot(stream, state) {
	    if (stream.eat('.')) {
	      var innerMode = null;
	      if (state.lastTag === 'script' && state.scriptType.toLowerCase().indexOf('javascript') != -1) {
	        innerMode = state.scriptType.toLowerCase().replace(/"|'/g, '');
	      } else if (state.lastTag === 'style') {
	        innerMode = 'css';
	      }
	      setInnerMode(stream, state, innerMode);
	      return 'dot';
	    }
	  }
	
	  function fail(stream) {
	    stream.next();
	    return null;
	  }
	
	
	  function setInnerMode(stream, state, mode) {
	    mode = CodeMirror.mimeModes[mode] || mode;
	    mode = config.innerModes ? config.innerModes(mode) || mode : mode;
	    mode = CodeMirror.mimeModes[mode] || mode;
	    mode = CodeMirror.getMode(config, mode);
	    state.indentOf = stream.indentation();
	
	    if (mode && mode.name !== 'null') {
	      state.innerMode = mode;
	    } else {
	      state.indentToken = 'string';
	    }
	  }
	  function innerMode(stream, state, force) {
	    if (stream.indentation() > state.indentOf || (state.innerModeForLine && !stream.sol()) || force) {
	      if (state.innerMode) {
	        if (!state.innerState) {
	          state.innerState = state.innerMode.startState ? CodeMirror.startState(state.innerMode, stream.indentation()) : {};
	        }
	        return stream.hideFirstChars(state.indentOf + 2, function () {
	          return state.innerMode.token(stream, state.innerState) || true;
	        });
	      } else {
	        stream.skipToEnd();
	        return state.indentToken;
	      }
	    } else if (stream.sol()) {
	      state.indentOf = Infinity;
	      state.indentToken = null;
	      state.innerMode = null;
	      state.innerState = null;
	    }
	  }
	  function restOfLine(stream, state) {
	    if (stream.sol()) {
	      // if restOfLine was set at end of line, ignore it
	      state.restOfLine = '';
	    }
	    if (state.restOfLine) {
	      stream.skipToEnd();
	      var tok = state.restOfLine;
	      state.restOfLine = '';
	      return tok;
	    }
	  }
	
	
	  function startState() {
	    return new State();
	  }
	  function copyState(state) {
	    return state.copy();
	  }
	  /**
	   * Get the next token in the stream
	   *
	   * @param {Stream} stream
	   * @param {State} state
	   */
	  function nextToken(stream, state) {
	    var tok = innerMode(stream, state)
	      || restOfLine(stream, state)
	      || interpolationContinued(stream, state)
	      || includeFilteredContinued(stream, state)
	      || eachContinued(stream, state)
	      || attrsContinued(stream, state)
	      || javaScript(stream, state)
	      || javaScriptArguments(stream, state)
	      || callArguments(stream, state)
	
	      || yieldStatement(stream, state)
	      || doctype(stream, state)
	      || interpolation(stream, state)
	      || caseStatement(stream, state)
	      || when(stream, state)
	      || defaultStatement(stream, state)
	      || extendsStatement(stream, state)
	      || append(stream, state)
	      || prepend(stream, state)
	      || block(stream, state)
	      || include(stream, state)
	      || includeFiltered(stream, state)
	      || mixin(stream, state)
	      || call(stream, state)
	      || conditional(stream, state)
	      || each(stream, state)
	      || whileStatement(stream, state)
	      || tag(stream, state)
	      || filter(stream, state)
	      || code(stream, state)
	      || id(stream, state)
	      || className(stream, state)
	      || attrs(stream, state)
	      || attributesBlock(stream, state)
	      || indent(stream, state)
	      || text(stream, state)
	      || comment(stream, state)
	      || colon(stream, state)
	      || dot(stream, state)
	      || fail(stream, state);
	
	    return tok === true ? null : tok;
	  }
	  return {
	    startState: startState,
	    copyState: copyState,
	    token: nextToken
	  };
	}, 'javascript', 'css', 'htmlmixed');
	
	CodeMirror.defineMIME('text/x-pug', 'pug');
	CodeMirror.defineMIME('text/x-jade', 'pug');
	
	});


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  function wordRegexp(words) {
	    return new RegExp("^((" + words.join(")|(") + "))\\b");
	  }
	
	  var wordOperators = wordRegexp(["and", "or", "not", "is"]);
	  var commonKeywords = ["as", "assert", "break", "class", "continue",
	                        "def", "del", "elif", "else", "except", "finally",
	                        "for", "from", "global", "if", "import",
	                        "lambda", "pass", "raise", "return",
	                        "try", "while", "with", "yield", "in"];
	  var commonBuiltins = ["abs", "all", "any", "bin", "bool", "bytearray", "callable", "chr",
	                        "classmethod", "compile", "complex", "delattr", "dict", "dir", "divmod",
	                        "enumerate", "eval", "filter", "float", "format", "frozenset",
	                        "getattr", "globals", "hasattr", "hash", "help", "hex", "id",
	                        "input", "int", "isinstance", "issubclass", "iter", "len",
	                        "list", "locals", "map", "max", "memoryview", "min", "next",
	                        "object", "oct", "open", "ord", "pow", "property", "range",
	                        "repr", "reversed", "round", "set", "setattr", "slice",
	                        "sorted", "staticmethod", "str", "sum", "super", "tuple",
	                        "type", "vars", "zip", "__import__", "NotImplemented",
	                        "Ellipsis", "__debug__"];
	  CodeMirror.registerHelper("hintWords", "python", commonKeywords.concat(commonBuiltins));
	
	  function top(state) {
	    return state.scopes[state.scopes.length - 1];
	  }
	
	  CodeMirror.defineMode("python", function(conf, parserConf) {
	    var ERRORCLASS = "error";
	
	    var singleDelimiters = parserConf.singleDelimiters || /^[\(\)\[\]\{\}@,:`=;\.]/;
	    var doubleOperators = parserConf.doubleOperators || /^([!<>]==|<>|<<|>>|\/\/|\*\*)/;
	    var doubleDelimiters = parserConf.doubleDelimiters || /^(\+=|\-=|\*=|%=|\/=|&=|\|=|\^=)/;
	    var tripleDelimiters = parserConf.tripleDelimiters || /^(\/\/=|>>=|<<=|\*\*=)/;
	
	    var hangingIndent = parserConf.hangingIndent || conf.indentUnit;
	
	    var myKeywords = commonKeywords, myBuiltins = commonBuiltins;
	    if (parserConf.extra_keywords != undefined)
	      myKeywords = myKeywords.concat(parserConf.extra_keywords);
	
	    if (parserConf.extra_builtins != undefined)
	      myBuiltins = myBuiltins.concat(parserConf.extra_builtins);
	
	    var py3 = !(parserConf.version && Number(parserConf.version) < 3)
	    if (py3) {
	      // since http://legacy.python.org/dev/peps/pep-0465/ @ is also an operator
	      var singleOperators = parserConf.singleOperators || /^[\+\-\*\/%&|\^~<>!@]/;
	      var identifiers = parserConf.identifiers|| /^[_A-Za-z\u00A1-\uFFFF][_A-Za-z0-9\u00A1-\uFFFF]*/;
	      myKeywords = myKeywords.concat(["nonlocal", "False", "True", "None", "async", "await"]);
	      myBuiltins = myBuiltins.concat(["ascii", "bytes", "exec", "print"]);
	      var stringPrefixes = new RegExp("^(([rbuf]|(br))?('{3}|\"{3}|['\"]))", "i");
	    } else {
	      var singleOperators = parserConf.singleOperators || /^[\+\-\*\/%&|\^~<>!]/;
	      var identifiers = parserConf.identifiers|| /^[_A-Za-z][_A-Za-z0-9]*/;
	      myKeywords = myKeywords.concat(["exec", "print"]);
	      myBuiltins = myBuiltins.concat(["apply", "basestring", "buffer", "cmp", "coerce", "execfile",
	                                      "file", "intern", "long", "raw_input", "reduce", "reload",
	                                      "unichr", "unicode", "xrange", "False", "True", "None"]);
	      var stringPrefixes = new RegExp("^(([rubf]|(ur)|(br))?('{3}|\"{3}|['\"]))", "i");
	    }
	    var keywords = wordRegexp(myKeywords);
	    var builtins = wordRegexp(myBuiltins);
	
	    // tokenizers
	    function tokenBase(stream, state) {
	      if (stream.sol()) state.indent = stream.indentation()
	      // Handle scope changes
	      if (stream.sol() && top(state).type == "py") {
	        var scopeOffset = top(state).offset;
	        if (stream.eatSpace()) {
	          var lineOffset = stream.indentation();
	          if (lineOffset > scopeOffset)
	            pushPyScope(state);
	          else if (lineOffset < scopeOffset && dedent(stream, state) && stream.peek() != "#")
	            state.errorToken = true;
	          return null;
	        } else {
	          var style = tokenBaseInner(stream, state);
	          if (scopeOffset > 0 && dedent(stream, state))
	            style += " " + ERRORCLASS;
	          return style;
	        }
	      }
	      return tokenBaseInner(stream, state);
	    }
	
	    function tokenBaseInner(stream, state) {
	      if (stream.eatSpace()) return null;
	
	      var ch = stream.peek();
	
	      // Handle Comments
	      if (ch == "#") {
	        stream.skipToEnd();
	        return "comment";
	      }
	
	      // Handle Number Literals
	      if (stream.match(/^[0-9\.]/, false)) {
	        var floatLiteral = false;
	        // Floats
	        if (stream.match(/^\d*\.\d+(e[\+\-]?\d+)?/i)) { floatLiteral = true; }
	        if (stream.match(/^\d+\.\d*/)) { floatLiteral = true; }
	        if (stream.match(/^\.\d+/)) { floatLiteral = true; }
	        if (floatLiteral) {
	          // Float literals may be "imaginary"
	          stream.eat(/J/i);
	          return "number";
	        }
	        // Integers
	        var intLiteral = false;
	        // Hex
	        if (stream.match(/^0x[0-9a-f]+/i)) intLiteral = true;
	        // Binary
	        if (stream.match(/^0b[01]+/i)) intLiteral = true;
	        // Octal
	        if (stream.match(/^0o[0-7]+/i)) intLiteral = true;
	        // Decimal
	        if (stream.match(/^[1-9]\d*(e[\+\-]?\d+)?/)) {
	          // Decimal literals may be "imaginary"
	          stream.eat(/J/i);
	          // TODO - Can you have imaginary longs?
	          intLiteral = true;
	        }
	        // Zero by itself with no other piece of number.
	        if (stream.match(/^0(?![\dx])/i)) intLiteral = true;
	        if (intLiteral) {
	          // Integer literals may be "long"
	          stream.eat(/L/i);
	          return "number";
	        }
	      }
	
	      // Handle Strings
	      if (stream.match(stringPrefixes)) {
	        state.tokenize = tokenStringFactory(stream.current());
	        return state.tokenize(stream, state);
	      }
	
	      // Handle operators and Delimiters
	      if (stream.match(tripleDelimiters) || stream.match(doubleDelimiters))
	        return "punctuation";
	
	      if (stream.match(doubleOperators) || stream.match(singleOperators))
	        return "operator";
	
	      if (stream.match(singleDelimiters))
	        return "punctuation";
	
	      if (state.lastToken == "." && stream.match(identifiers))
	        return "property";
	
	      if (stream.match(keywords) || stream.match(wordOperators))
	        return "keyword";
	
	      if (stream.match(builtins))
	        return "builtin";
	
	      if (stream.match(/^(self|cls)\b/))
	        return "variable-2";
	
	      if (stream.match(identifiers)) {
	        if (state.lastToken == "def" || state.lastToken == "class")
	          return "def";
	        return "variable";
	      }
	
	      // Handle non-detected items
	      stream.next();
	      return ERRORCLASS;
	    }
	
	    function tokenStringFactory(delimiter) {
	      while ("rubf".indexOf(delimiter.charAt(0).toLowerCase()) >= 0)
	        delimiter = delimiter.substr(1);
	
	      var singleline = delimiter.length == 1;
	      var OUTCLASS = "string";
	
	      function tokenString(stream, state) {
	        while (!stream.eol()) {
	          stream.eatWhile(/[^'"\\]/);
	          if (stream.eat("\\")) {
	            stream.next();
	            if (singleline && stream.eol())
	              return OUTCLASS;
	          } else if (stream.match(delimiter)) {
	            state.tokenize = tokenBase;
	            return OUTCLASS;
	          } else {
	            stream.eat(/['"]/);
	          }
	        }
	        if (singleline) {
	          if (parserConf.singleLineStringErrors)
	            return ERRORCLASS;
	          else
	            state.tokenize = tokenBase;
	        }
	        return OUTCLASS;
	      }
	      tokenString.isString = true;
	      return tokenString;
	    }
	
	    function pushPyScope(state) {
	      while (top(state).type != "py") state.scopes.pop()
	      state.scopes.push({offset: top(state).offset + conf.indentUnit,
	                         type: "py",
	                         align: null})
	    }
	
	    function pushBracketScope(stream, state, type) {
	      var align = stream.match(/^([\s\[\{\(]|#.*)*$/, false) ? null : stream.column() + 1
	      state.scopes.push({offset: state.indent + hangingIndent,
	                         type: type,
	                         align: align})
	    }
	
	    function dedent(stream, state) {
	      var indented = stream.indentation();
	      while (state.scopes.length > 1 && top(state).offset > indented) {
	        if (top(state).type != "py") return true;
	        state.scopes.pop();
	      }
	      return top(state).offset != indented;
	    }
	
	    function tokenLexer(stream, state) {
	      if (stream.sol()) state.beginningOfLine = true;
	
	      var style = state.tokenize(stream, state);
	      var current = stream.current();
	
	      // Handle decorators
	      if (state.beginningOfLine && current == "@")
	        return stream.match(identifiers, false) ? "meta" : py3 ? "operator" : ERRORCLASS;
	
	      if (/\S/.test(current)) state.beginningOfLine = false;
	
	      if ((style == "variable" || style == "builtin")
	          && state.lastToken == "meta")
	        style = "meta";
	
	      // Handle scope changes.
	      if (current == "pass" || current == "return")
	        state.dedent += 1;
	
	      if (current == "lambda") state.lambda = true;
	      if (current == ":" && !state.lambda && top(state).type == "py")
	        pushPyScope(state);
	
	      var delimiter_index = current.length == 1 ? "[({".indexOf(current) : -1;
	      if (delimiter_index != -1)
	        pushBracketScope(stream, state, "])}".slice(delimiter_index, delimiter_index+1));
	
	      delimiter_index = "])}".indexOf(current);
	      if (delimiter_index != -1) {
	        if (top(state).type == current) state.indent = state.scopes.pop().offset - hangingIndent
	        else return ERRORCLASS;
	      }
	      if (state.dedent > 0 && stream.eol() && top(state).type == "py") {
	        if (state.scopes.length > 1) state.scopes.pop();
	        state.dedent -= 1;
	      }
	
	      return style;
	    }
	
	    var external = {
	      startState: function(basecolumn) {
	        return {
	          tokenize: tokenBase,
	          scopes: [{offset: basecolumn || 0, type: "py", align: null}],
	          indent: basecolumn || 0,
	          lastToken: null,
	          lambda: false,
	          dedent: 0
	        };
	      },
	
	      token: function(stream, state) {
	        var addErr = state.errorToken;
	        if (addErr) state.errorToken = false;
	        var style = tokenLexer(stream, state);
	
	        if (style && style != "comment")
	          state.lastToken = (style == "keyword" || style == "punctuation") ? stream.current() : style;
	        if (style == "punctuation") style = null;
	
	        if (stream.eol() && state.lambda)
	          state.lambda = false;
	        return addErr ? style + " " + ERRORCLASS : style;
	      },
	
	      indent: function(state, textAfter) {
	        if (state.tokenize != tokenBase)
	          return state.tokenize.isString ? CodeMirror.Pass : 0;
	
	        var scope = top(state), closing = scope.type == textAfter.charAt(0)
	        if (scope.align != null)
	          return scope.align - (closing ? 1 : 0)
	        else
	          return scope.offset - (closing ? hangingIndent : 0)
	      },
	
	      electricInput: /^\s*[\}\]\)]$/,
	      closeBrackets: {triples: "'\""},
	      lineComment: "#",
	      fold: "indent"
	    };
	    return external;
	  });
	
	  CodeMirror.defineMIME("text/x-python", "python");
	
	  var words = function(str) { return str.split(" "); };
	
	  CodeMirror.defineMIME("text/x-cython", {
	    name: "python",
	    extra_keywords: words("by cdef cimport cpdef ctypedef enum except"+
	                          "extern gil include nogil property public"+
	                          "readonly struct union DEF IF ELIF ELSE")
	  });
	
	});


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("sass", function(config) {
	  function tokenRegexp(words) {
	    return new RegExp("^" + words.join("|"));
	  }
	
	  var keywords = ["true", "false", "null", "auto"];
	  var keywordsRegexp = new RegExp("^" + keywords.join("|"));
	
	  var operators = ["\\(", "\\)", "=", ">", "<", "==", ">=", "<=", "\\+", "-",
	                   "\\!=", "/", "\\*", "%", "and", "or", "not", ";","\\{","\\}",":"];
	  var opRegexp = tokenRegexp(operators);
	
	  var pseudoElementsRegexp = /^::?[a-zA-Z_][\w\-]*/;
	
	  function urlTokens(stream, state) {
	    var ch = stream.peek();
	
	    if (ch === ")") {
	      stream.next();
	      state.tokenizer = tokenBase;
	      return "operator";
	    } else if (ch === "(") {
	      stream.next();
	      stream.eatSpace();
	
	      return "operator";
	    } else if (ch === "'" || ch === '"') {
	      state.tokenizer = buildStringTokenizer(stream.next());
	      return "string";
	    } else {
	      state.tokenizer = buildStringTokenizer(")", false);
	      return "string";
	    }
	  }
	  function comment(indentation, multiLine) {
	    return function(stream, state) {
	      if (stream.sol() && stream.indentation() <= indentation) {
	        state.tokenizer = tokenBase;
	        return tokenBase(stream, state);
	      }
	
	      if (multiLine && stream.skipTo("*/")) {
	        stream.next();
	        stream.next();
	        state.tokenizer = tokenBase;
	      } else {
	        stream.skipToEnd();
	      }
	
	      return "comment";
	    };
	  }
	
	  function buildStringTokenizer(quote, greedy) {
	    if (greedy == null) { greedy = true; }
	
	    function stringTokenizer(stream, state) {
	      var nextChar = stream.next();
	      var peekChar = stream.peek();
	      var previousChar = stream.string.charAt(stream.pos-2);
	
	      var endingString = ((nextChar !== "\\" && peekChar === quote) || (nextChar === quote && previousChar !== "\\"));
	
	      if (endingString) {
	        if (nextChar !== quote && greedy) { stream.next(); }
	        state.tokenizer = tokenBase;
	        return "string";
	      } else if (nextChar === "#" && peekChar === "{") {
	        state.tokenizer = buildInterpolationTokenizer(stringTokenizer);
	        stream.next();
	        return "operator";
	      } else {
	        return "string";
	      }
	    }
	
	    return stringTokenizer;
	  }
	
	  function buildInterpolationTokenizer(currentTokenizer) {
	    return function(stream, state) {
	      if (stream.peek() === "}") {
	        stream.next();
	        state.tokenizer = currentTokenizer;
	        return "operator";
	      } else {
	        return tokenBase(stream, state);
	      }
	    };
	  }
	
	  function indent(state) {
	    if (state.indentCount == 0) {
	      state.indentCount++;
	      var lastScopeOffset = state.scopes[0].offset;
	      var currentOffset = lastScopeOffset + config.indentUnit;
	      state.scopes.unshift({ offset:currentOffset });
	    }
	  }
	
	  function dedent(state) {
	    if (state.scopes.length == 1) return;
	
	    state.scopes.shift();
	  }
	
	  function tokenBase(stream, state) {
	    var ch = stream.peek();
	
	    // Comment
	    if (stream.match("/*")) {
	      state.tokenizer = comment(stream.indentation(), true);
	      return state.tokenizer(stream, state);
	    }
	    if (stream.match("//")) {
	      state.tokenizer = comment(stream.indentation(), false);
	      return state.tokenizer(stream, state);
	    }
	
	    // Interpolation
	    if (stream.match("#{")) {
	      state.tokenizer = buildInterpolationTokenizer(tokenBase);
	      return "operator";
	    }
	
	    // Strings
	    if (ch === '"' || ch === "'") {
	      stream.next();
	      state.tokenizer = buildStringTokenizer(ch);
	      return "string";
	    }
	
	    if(!state.cursorHalf){// state.cursorHalf === 0
	    // first half i.e. before : for key-value pairs
	    // including selectors
	
	      if (ch === ".") {
	        stream.next();
	        if (stream.match(/^[\w-]+/)) {
	          indent(state);
	          return "atom";
	        } else if (stream.peek() === "#") {
	          indent(state);
	          return "atom";
	        }
	      }
	
	      if (ch === "#") {
	        stream.next();
	        // ID selectors
	        if (stream.match(/^[\w-]+/)) {
	          indent(state);
	          return "atom";
	        }
	        if (stream.peek() === "#") {
	          indent(state);
	          return "atom";
	        }
	      }
	
	      // Variables
	      if (ch === "$") {
	        stream.next();
	        stream.eatWhile(/[\w-]/);
	        return "variable-2";
	      }
	
	      // Numbers
	      if (stream.match(/^-?[0-9\.]+/))
	        return "number";
	
	      // Units
	      if (stream.match(/^(px|em|in)\b/))
	        return "unit";
	
	      if (stream.match(keywordsRegexp))
	        return "keyword";
	
	      if (stream.match(/^url/) && stream.peek() === "(") {
	        state.tokenizer = urlTokens;
	        return "atom";
	      }
	
	      if (ch === "=") {
	        // Match shortcut mixin definition
	        if (stream.match(/^=[\w-]+/)) {
	          indent(state);
	          return "meta";
	        }
	      }
	
	      if (ch === "+") {
	        // Match shortcut mixin definition
	        if (stream.match(/^\+[\w-]+/)){
	          return "variable-3";
	        }
	      }
	
	      if(ch === "@"){
	        if(stream.match(/@extend/)){
	          if(!stream.match(/\s*[\w]/))
	            dedent(state);
	        }
	      }
	
	
	      // Indent Directives
	      if (stream.match(/^@(else if|if|media|else|for|each|while|mixin|function)/)) {
	        indent(state);
	        return "meta";
	      }
	
	      // Other Directives
	      if (ch === "@") {
	        stream.next();
	        stream.eatWhile(/[\w-]/);
	        return "meta";
	      }
	
	      if (stream.eatWhile(/[\w-]/)){
	        if(stream.match(/ *: *[\w-\+\$#!\("']/,false)){
	          return "property";
	        }
	        else if(stream.match(/ *:/,false)){
	          indent(state);
	          state.cursorHalf = 1;
	          return "atom";
	        }
	        else if(stream.match(/ *,/,false)){
	          return "atom";
	        }
	        else{
	          indent(state);
	          return "atom";
	        }
	      }
	
	      if(ch === ":"){
	        if (stream.match(pseudoElementsRegexp)){ // could be a pseudo-element
	          return "keyword";
	        }
	        stream.next();
	        state.cursorHalf=1;
	        return "operator";
	      }
	
	    } // cursorHalf===0 ends here
	    else{
	
	      if (ch === "#") {
	        stream.next();
	        // Hex numbers
	        if (stream.match(/[0-9a-fA-F]{6}|[0-9a-fA-F]{3}/)){
	          if(!stream.peek()){
	            state.cursorHalf = 0;
	          }
	          return "number";
	        }
	      }
	
	      // Numbers
	      if (stream.match(/^-?[0-9\.]+/)){
	        if(!stream.peek()){
	          state.cursorHalf = 0;
	        }
	        return "number";
	      }
	
	      // Units
	      if (stream.match(/^(px|em|in)\b/)){
	        if(!stream.peek()){
	          state.cursorHalf = 0;
	        }
	        return "unit";
	      }
	
	      if (stream.match(keywordsRegexp)){
	        if(!stream.peek()){
	          state.cursorHalf = 0;
	        }
	        return "keyword";
	      }
	
	      if (stream.match(/^url/) && stream.peek() === "(") {
	        state.tokenizer = urlTokens;
	        if(!stream.peek()){
	          state.cursorHalf = 0;
	        }
	        return "atom";
	      }
	
	      // Variables
	      if (ch === "$") {
	        stream.next();
	        stream.eatWhile(/[\w-]/);
	        if(!stream.peek()){
	          state.cursorHalf = 0;
	        }
	        return "variable-3";
	      }
	
	      // bang character for !important, !default, etc.
	      if (ch === "!") {
	        stream.next();
	        if(!stream.peek()){
	          state.cursorHalf = 0;
	        }
	        return stream.match(/^[\w]+/) ? "keyword": "operator";
	      }
	
	      if (stream.match(opRegexp)){
	        if(!stream.peek()){
	          state.cursorHalf = 0;
	        }
	        return "operator";
	      }
	
	      // attributes
	      if (stream.eatWhile(/[\w-]/)) {
	        if(!stream.peek()){
	          state.cursorHalf = 0;
	        }
	        return "attribute";
	      }
	
	      //stream.eatSpace();
	      if(!stream.peek()){
	        state.cursorHalf = 0;
	        return null;
	      }
	
	    } // else ends here
	
	    if (stream.match(opRegexp))
	      return "operator";
	
	    // If we haven't returned by now, we move 1 character
	    // and return an error
	    stream.next();
	    return null;
	  }
	
	  function tokenLexer(stream, state) {
	    if (stream.sol()) state.indentCount = 0;
	    var style = state.tokenizer(stream, state);
	    var current = stream.current();
	
	    if (current === "@return" || current === "}"){
	      dedent(state);
	    }
	
	    if (style !== null) {
	      var startOfToken = stream.pos - current.length;
	
	      var withCurrentIndent = startOfToken + (config.indentUnit * state.indentCount);
	
	      var newScopes = [];
	
	      for (var i = 0; i < state.scopes.length; i++) {
	        var scope = state.scopes[i];
	
	        if (scope.offset <= withCurrentIndent)
	          newScopes.push(scope);
	      }
	
	      state.scopes = newScopes;
	    }
	
	
	    return style;
	  }
	
	  return {
	    startState: function() {
	      return {
	        tokenizer: tokenBase,
	        scopes: [{offset: 0, type: "sass"}],
	        indentCount: 0,
	        cursorHalf: 0,  // cursor half tells us if cursor lies after (1)
	                        // or before (0) colon (well... more or less)
	        definedVars: [],
	        definedMixins: []
	      };
	    },
	    token: function(stream, state) {
	      var style = tokenLexer(stream, state);
	
	      state.lastToken = { style: style, content: stream.current() };
	
	      return style;
	    },
	
	    indent: function(state) {
	      return state.scopes[0].offset;
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/x-sass", "sass");
	
	});


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("sql", function(config, parserConfig) {
	  "use strict";
	
	  var client         = parserConfig.client || {},
	      atoms          = parserConfig.atoms || {"false": true, "true": true, "null": true},
	      builtin        = parserConfig.builtin || {},
	      keywords       = parserConfig.keywords || {},
	      operatorChars  = parserConfig.operatorChars || /^[*+\-%<>!=&|~^]/,
	      support        = parserConfig.support || {},
	      hooks          = parserConfig.hooks || {},
	      dateSQL        = parserConfig.dateSQL || {"date" : true, "time" : true, "timestamp" : true};
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	
	    // call hooks from the mime type
	    if (hooks[ch]) {
	      var result = hooks[ch](stream, state);
	      if (result !== false) return result;
	    }
	
	    if (support.hexNumber &&
	      ((ch == "0" && stream.match(/^[xX][0-9a-fA-F]+/))
	      || (ch == "x" || ch == "X") && stream.match(/^'[0-9a-fA-F]+'/))) {
	      // hex
	      // ref: http://dev.mysql.com/doc/refman/5.5/en/hexadecimal-literals.html
	      return "number";
	    } else if (support.binaryNumber &&
	      (((ch == "b" || ch == "B") && stream.match(/^'[01]+'/))
	      || (ch == "0" && stream.match(/^b[01]+/)))) {
	      // bitstring
	      // ref: http://dev.mysql.com/doc/refman/5.5/en/bit-field-literals.html
	      return "number";
	    } else if (ch.charCodeAt(0) > 47 && ch.charCodeAt(0) < 58) {
	      // numbers
	      // ref: http://dev.mysql.com/doc/refman/5.5/en/number-literals.html
	          stream.match(/^[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?/);
	      support.decimallessFloat && stream.eat('.');
	      return "number";
	    } else if (ch == "?" && (stream.eatSpace() || stream.eol() || stream.eat(";"))) {
	      // placeholders
	      return "variable-3";
	    } else if (ch == "'" || (ch == '"' && support.doubleQuote)) {
	      // strings
	      // ref: http://dev.mysql.com/doc/refman/5.5/en/string-literals.html
	      state.tokenize = tokenLiteral(ch);
	      return state.tokenize(stream, state);
	    } else if ((((support.nCharCast && (ch == "n" || ch == "N"))
	        || (support.charsetCast && ch == "_" && stream.match(/[a-z][a-z0-9]*/i)))
	        && (stream.peek() == "'" || stream.peek() == '"'))) {
	      // charset casting: _utf8'str', N'str', n'str'
	      // ref: http://dev.mysql.com/doc/refman/5.5/en/string-literals.html
	      return "keyword";
	    } else if (/^[\(\),\;\[\]]/.test(ch)) {
	      // no highlighting
	      return null;
	    } else if (support.commentSlashSlash && ch == "/" && stream.eat("/")) {
	      // 1-line comment
	      stream.skipToEnd();
	      return "comment";
	    } else if ((support.commentHash && ch == "#")
	        || (ch == "-" && stream.eat("-") && (!support.commentSpaceRequired || stream.eat(" ")))) {
	      // 1-line comments
	      // ref: https://kb.askmonty.org/en/comment-syntax/
	      stream.skipToEnd();
	      return "comment";
	    } else if (ch == "/" && stream.eat("*")) {
	      // multi-line comments
	      // ref: https://kb.askmonty.org/en/comment-syntax/
	      state.tokenize = tokenComment;
	      return state.tokenize(stream, state);
	    } else if (ch == ".") {
	      // .1 for 0.1
	      if (support.zerolessFloat && stream.match(/^(?:\d+(?:e[+-]?\d+)?)/i)) {
	        return "number";
	      }
	      // .table_name (ODBC)
	      // // ref: http://dev.mysql.com/doc/refman/5.6/en/identifier-qualifiers.html
	      if (support.ODBCdotTable && stream.match(/^[a-zA-Z_]+/)) {
	        return "variable-2";
	      }
	    } else if (operatorChars.test(ch)) {
	      // operators
	      stream.eatWhile(operatorChars);
	      return null;
	    } else if (ch == '{' &&
	        (stream.match(/^( )*(d|D|t|T|ts|TS)( )*'[^']*'( )*}/) || stream.match(/^( )*(d|D|t|T|ts|TS)( )*"[^"]*"( )*}/))) {
	      // dates (weird ODBC syntax)
	      // ref: http://dev.mysql.com/doc/refman/5.5/en/date-and-time-literals.html
	      return "number";
	    } else {
	      stream.eatWhile(/^[_\w\d]/);
	      var word = stream.current().toLowerCase();
	      // dates (standard SQL syntax)
	      // ref: http://dev.mysql.com/doc/refman/5.5/en/date-and-time-literals.html
	      if (dateSQL.hasOwnProperty(word) && (stream.match(/^( )+'[^']*'/) || stream.match(/^( )+"[^"]*"/)))
	        return "number";
	      if (atoms.hasOwnProperty(word)) return "atom";
	      if (builtin.hasOwnProperty(word)) return "builtin";
	      if (keywords.hasOwnProperty(word)) return "keyword";
	      if (client.hasOwnProperty(word)) return "string-2";
	      return null;
	    }
	  }
	
	  // 'string', with char specified in quote escaped by '\'
	  function tokenLiteral(quote) {
	    return function(stream, state) {
	      var escaped = false, ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == quote && !escaped) {
	          state.tokenize = tokenBase;
	          break;
	        }
	        escaped = !escaped && ch == "\\";
	      }
	      return "string";
	    };
	  }
	  function tokenComment(stream, state) {
	    while (true) {
	      if (stream.skipTo("*")) {
	        stream.next();
	        if (stream.eat("/")) {
	          state.tokenize = tokenBase;
	          break;
	        }
	      } else {
	        stream.skipToEnd();
	        break;
	      }
	    }
	    return "comment";
	  }
	
	  function pushContext(stream, state, type) {
	    state.context = {
	      prev: state.context,
	      indent: stream.indentation(),
	      col: stream.column(),
	      type: type
	    };
	  }
	
	  function popContext(state) {
	    state.indent = state.context.indent;
	    state.context = state.context.prev;
	  }
	
	  return {
	    startState: function() {
	      return {tokenize: tokenBase, context: null};
	    },
	
	    token: function(stream, state) {
	      if (stream.sol()) {
	        if (state.context && state.context.align == null)
	          state.context.align = false;
	      }
	      if (stream.eatSpace()) return null;
	
	      var style = state.tokenize(stream, state);
	      if (style == "comment") return style;
	
	      if (state.context && state.context.align == null)
	        state.context.align = true;
	
	      var tok = stream.current();
	      if (tok == "(")
	        pushContext(stream, state, ")");
	      else if (tok == "[")
	        pushContext(stream, state, "]");
	      else if (state.context && state.context.type == tok)
	        popContext(state);
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      var cx = state.context;
	      if (!cx) return CodeMirror.Pass;
	      var closing = textAfter.charAt(0) == cx.type;
	      if (cx.align) return cx.col + (closing ? 0 : 1);
	      else return cx.indent + (closing ? 0 : config.indentUnit);
	    },
	
	    blockCommentStart: "/*",
	    blockCommentEnd: "*/",
	    lineComment: support.commentSlashSlash ? "//" : support.commentHash ? "#" : null
	  };
	});
	
	(function() {
	  "use strict";
	
	  // `identifier`
	  function hookIdentifier(stream) {
	    // MySQL/MariaDB identifiers
	    // ref: http://dev.mysql.com/doc/refman/5.6/en/identifier-qualifiers.html
	    var ch;
	    while ((ch = stream.next()) != null) {
	      if (ch == "`" && !stream.eat("`")) return "variable-2";
	    }
	    stream.backUp(stream.current().length - 1);
	    return stream.eatWhile(/\w/) ? "variable-2" : null;
	  }
	
	  // variable token
	  function hookVar(stream) {
	    // variables
	    // @@prefix.varName @varName
	    // varName can be quoted with ` or ' or "
	    // ref: http://dev.mysql.com/doc/refman/5.5/en/user-variables.html
	    if (stream.eat("@")) {
	      stream.match(/^session\./);
	      stream.match(/^local\./);
	      stream.match(/^global\./);
	    }
	
	    if (stream.eat("'")) {
	      stream.match(/^.*'/);
	      return "variable-2";
	    } else if (stream.eat('"')) {
	      stream.match(/^.*"/);
	      return "variable-2";
	    } else if (stream.eat("`")) {
	      stream.match(/^.*`/);
	      return "variable-2";
	    } else if (stream.match(/^[0-9a-zA-Z$\.\_]+/)) {
	      return "variable-2";
	    }
	    return null;
	  };
	
	  // short client keyword token
	  function hookClient(stream) {
	    // \N means NULL
	    // ref: http://dev.mysql.com/doc/refman/5.5/en/null-values.html
	    if (stream.eat("N")) {
	        return "atom";
	    }
	    // \g, etc
	    // ref: http://dev.mysql.com/doc/refman/5.5/en/mysql-commands.html
	    return stream.match(/^[a-zA-Z.#!?]/) ? "variable-2" : null;
	  }
	
	  // these keywords are used by all SQL dialects (however, a mode can still overwrite it)
	  var sqlKeywords = "alter and as asc between by count create delete desc distinct drop from group having in insert into is join like not on or order select set table union update values where limit ";
	
	  // turn a space-separated list into an array
	  function set(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	
	  // A generic SQL Mode. It's not a standard, it just try to support what is generally supported
	  CodeMirror.defineMIME("text/x-sql", {
	    name: "sql",
	    keywords: set(sqlKeywords + "begin"),
	    builtin: set("bool boolean bit blob enum long longblob longtext medium mediumblob mediumint mediumtext time timestamp tinyblob tinyint tinytext text bigint int int1 int2 int3 int4 int8 integer float float4 float8 double char varbinary varchar varcharacter precision real date datetime year unsigned signed decimal numeric"),
	    atoms: set("false true null unknown"),
	    operatorChars: /^[*+\-%<>!=]/,
	    dateSQL: set("date time timestamp"),
	    support: set("ODBCdotTable doubleQuote binaryNumber hexNumber")
	  });
	
	  CodeMirror.defineMIME("text/x-mssql", {
	    name: "sql",
	    client: set("charset clear connect edit ego exit go help nopager notee nowarning pager print prompt quit rehash source status system tee"),
	    keywords: set(sqlKeywords + "begin trigger proc view index for add constraint key primary foreign collate clustered nonclustered declare exec"),
	    builtin: set("bigint numeric bit smallint decimal smallmoney int tinyint money float real char varchar text nchar nvarchar ntext binary varbinary image cursor timestamp hierarchyid uniqueidentifier sql_variant xml table "),
	    atoms: set("false true null unknown"),
	    operatorChars: /^[*+\-%<>!=]/,
	    dateSQL: set("date datetimeoffset datetime2 smalldatetime datetime time"),
	    hooks: {
	      "@":   hookVar
	    }
	  });
	
	  CodeMirror.defineMIME("text/x-mysql", {
	    name: "sql",
	    client: set("charset clear connect edit ego exit go help nopager notee nowarning pager print prompt quit rehash source status system tee"),
	    keywords: set(sqlKeywords + "accessible action add after algorithm all analyze asensitive at authors auto_increment autocommit avg avg_row_length before binary binlog both btree cache call cascade cascaded case catalog_name chain change changed character check checkpoint checksum class_origin client_statistics close coalesce code collate collation collations column columns comment commit committed completion concurrent condition connection consistent constraint contains continue contributors convert cross current current_date current_time current_timestamp current_user cursor data database databases day_hour day_microsecond day_minute day_second deallocate dec declare default delay_key_write delayed delimiter des_key_file describe deterministic dev_pop dev_samp deviance diagnostics directory disable discard distinctrow div dual dumpfile each elseif enable enclosed end ends engine engines enum errors escape escaped even event events every execute exists exit explain extended fast fetch field fields first flush for force foreign found_rows full fulltext function general get global grant grants group group_concat handler hash help high_priority hosts hour_microsecond hour_minute hour_second if ignore ignore_server_ids import index index_statistics infile inner innodb inout insensitive insert_method install interval invoker isolation iterate key keys kill language last leading leave left level limit linear lines list load local localtime localtimestamp lock logs low_priority master master_heartbeat_period master_ssl_verify_server_cert masters match max max_rows maxvalue message_text middleint migrate min min_rows minute_microsecond minute_second mod mode modifies modify mutex mysql_errno natural next no no_write_to_binlog offline offset one online open optimize option optionally out outer outfile pack_keys parser partition partitions password phase plugin plugins prepare preserve prev primary privileges procedure processlist profile profiles purge query quick range read read_write reads real rebuild recover references regexp relaylog release remove rename reorganize repair repeatable replace require resignal restrict resume return returns revoke right rlike rollback rollup row row_format rtree savepoint schedule schema schema_name schemas second_microsecond security sensitive separator serializable server session share show signal slave slow smallint snapshot soname spatial specific sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows sql_no_cache sql_small_result sqlexception sqlstate sqlwarning ssl start starting starts status std stddev stddev_pop stddev_samp storage straight_join subclass_origin sum suspend table_name table_statistics tables tablespace temporary terminated to trailing transaction trigger triggers truncate uncommitted undo uninstall unique unlock upgrade usage use use_frm user user_resources user_statistics using utc_date utc_time utc_timestamp value variables varying view views warnings when while with work write xa xor year_month zerofill begin do then else loop repeat"),
	    builtin: set("bool boolean bit blob decimal double float long longblob longtext medium mediumblob mediumint mediumtext time timestamp tinyblob tinyint tinytext text bigint int int1 int2 int3 int4 int8 integer float float4 float8 double char varbinary varchar varcharacter precision date datetime year unsigned signed numeric"),
	    atoms: set("false true null unknown"),
	    operatorChars: /^[*+\-%<>!=&|^]/,
	    dateSQL: set("date time timestamp"),
	    support: set("ODBCdotTable decimallessFloat zerolessFloat binaryNumber hexNumber doubleQuote nCharCast charsetCast commentHash commentSpaceRequired"),
	    hooks: {
	      "@":   hookVar,
	      "`":   hookIdentifier,
	      "\\":  hookClient
	    }
	  });
	
	  CodeMirror.defineMIME("text/x-mariadb", {
	    name: "sql",
	    client: set("charset clear connect edit ego exit go help nopager notee nowarning pager print prompt quit rehash source status system tee"),
	    keywords: set(sqlKeywords + "accessible action add after algorithm all always analyze asensitive at authors auto_increment autocommit avg avg_row_length before binary binlog both btree cache call cascade cascaded case catalog_name chain change changed character check checkpoint checksum class_origin client_statistics close coalesce code collate collation collations column columns comment commit committed completion concurrent condition connection consistent constraint contains continue contributors convert cross current current_date current_time current_timestamp current_user cursor data database databases day_hour day_microsecond day_minute day_second deallocate dec declare default delay_key_write delayed delimiter des_key_file describe deterministic dev_pop dev_samp deviance diagnostics directory disable discard distinctrow div dual dumpfile each elseif enable enclosed end ends engine engines enum errors escape escaped even event events every execute exists exit explain extended fast fetch field fields first flush for force foreign found_rows full fulltext function general generated get global grant grants group groupby_concat handler hard hash help high_priority hosts hour_microsecond hour_minute hour_second if ignore ignore_server_ids import index index_statistics infile inner innodb inout insensitive insert_method install interval invoker isolation iterate key keys kill language last leading leave left level limit linear lines list load local localtime localtimestamp lock logs low_priority master master_heartbeat_period master_ssl_verify_server_cert masters match max max_rows maxvalue message_text middleint migrate min min_rows minute_microsecond minute_second mod mode modifies modify mutex mysql_errno natural next no no_write_to_binlog offline offset one online open optimize option optionally out outer outfile pack_keys parser partition partitions password persistent phase plugin plugins prepare preserve prev primary privileges procedure processlist profile profiles purge query quick range read read_write reads real rebuild recover references regexp relaylog release remove rename reorganize repair repeatable replace require resignal restrict resume return returns revoke right rlike rollback rollup row row_format rtree savepoint schedule schema schema_name schemas second_microsecond security sensitive separator serializable server session share show shutdown signal slave slow smallint snapshot soft soname spatial specific sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows sql_no_cache sql_small_result sqlexception sqlstate sqlwarning ssl start starting starts status std stddev stddev_pop stddev_samp storage straight_join subclass_origin sum suspend table_name table_statistics tables tablespace temporary terminated to trailing transaction trigger triggers truncate uncommitted undo uninstall unique unlock upgrade usage use use_frm user user_resources user_statistics using utc_date utc_time utc_timestamp value variables varying view views virtual warnings when while with work write xa xor year_month zerofill begin do then else loop repeat"),
	    builtin: set("bool boolean bit blob decimal double float long longblob longtext medium mediumblob mediumint mediumtext time timestamp tinyblob tinyint tinytext text bigint int int1 int2 int3 int4 int8 integer float float4 float8 double char varbinary varchar varcharacter precision date datetime year unsigned signed numeric"),
	    atoms: set("false true null unknown"),
	    operatorChars: /^[*+\-%<>!=&|^]/,
	    dateSQL: set("date time timestamp"),
	    support: set("ODBCdotTable decimallessFloat zerolessFloat binaryNumber hexNumber doubleQuote nCharCast charsetCast commentHash commentSpaceRequired"),
	    hooks: {
	      "@":   hookVar,
	      "`":   hookIdentifier,
	      "\\":  hookClient
	    }
	  });
	
	  // the query language used by Apache Cassandra is called CQL, but this mime type
	  // is called Cassandra to avoid confusion with Contextual Query Language
	  CodeMirror.defineMIME("text/x-cassandra", {
	    name: "sql",
	    client: { },
	    keywords: set("add all allow alter and any apply as asc authorize batch begin by clustering columnfamily compact consistency count create custom delete desc distinct drop each_quorum exists filtering from grant if in index insert into key keyspace keyspaces level limit local_one local_quorum modify nan norecursive nosuperuser not of on one order password permission permissions primary quorum rename revoke schema select set storage superuser table three to token truncate ttl two type unlogged update use user users using values where with writetime"),
	    builtin: set("ascii bigint blob boolean counter decimal double float frozen inet int list map static text timestamp timeuuid tuple uuid varchar varint"),
	    atoms: set("false true infinity NaN"),
	    operatorChars: /^[<>=]/,
	    dateSQL: { },
	    support: set("commentSlashSlash decimallessFloat"),
	    hooks: { }
	  });
	
	  // this is based on Peter Raganitsch's 'plsql' mode
	  CodeMirror.defineMIME("text/x-plsql", {
	    name:       "sql",
	    client:     set("appinfo arraysize autocommit autoprint autorecovery autotrace blockterminator break btitle cmdsep colsep compatibility compute concat copycommit copytypecheck define describe echo editfile embedded escape exec execute feedback flagger flush heading headsep instance linesize lno loboffset logsource long longchunksize markup native newpage numformat numwidth pagesize pause pno recsep recsepchar release repfooter repheader serveroutput shiftinout show showmode size spool sqlblanklines sqlcase sqlcode sqlcontinue sqlnumber sqlpluscompatibility sqlprefix sqlprompt sqlterminator suffix tab term termout time timing trimout trimspool ttitle underline verify version wrap"),
	    keywords:   set("abort accept access add all alter and any array arraylen as asc assert assign at attributes audit authorization avg base_table begin between binary_integer body boolean by case cast char char_base check close cluster clusters colauth column comment commit compress connect connected constant constraint crash create current currval cursor data_base database date dba deallocate debugoff debugon decimal declare default definition delay delete desc digits dispose distinct do drop else elseif elsif enable end entry escape exception exception_init exchange exclusive exists exit external fast fetch file for force form from function generic goto grant group having identified if immediate in increment index indexes indicator initial initrans insert interface intersect into is key level library like limited local lock log logging long loop master maxextents maxtrans member minextents minus mislabel mode modify multiset new next no noaudit nocompress nologging noparallel not nowait number_base object of off offline on online only open option or order out package parallel partition pctfree pctincrease pctused pls_integer positive positiven pragma primary prior private privileges procedure public raise range raw read rebuild record ref references refresh release rename replace resource restrict return returning returns reverse revoke rollback row rowid rowlabel rownum rows run savepoint schema segment select separate session set share snapshot some space split sql start statement storage subtype successful synonym tabauth table tables tablespace task terminate then to trigger truncate type union unique unlimited unrecoverable unusable update use using validate value values variable view views when whenever where while with work"),
	    builtin:    set("abs acos add_months ascii asin atan atan2 average bfile bfilename bigserial bit blob ceil character chartorowid chr clob concat convert cos cosh count dec decode deref dual dump dup_val_on_index empty error exp false float floor found glb greatest hextoraw initcap instr instrb int integer isopen last_day least length lengthb ln lower lpad ltrim lub make_ref max min mlslabel mod months_between natural naturaln nchar nclob new_time next_day nextval nls_charset_decl_len nls_charset_id nls_charset_name nls_initcap nls_lower nls_sort nls_upper nlssort no_data_found notfound null number numeric nvarchar2 nvl others power rawtohex real reftohex round rowcount rowidtochar rowtype rpad rtrim serial sign signtype sin sinh smallint soundex sqlcode sqlerrm sqrt stddev string substr substrb sum sysdate tan tanh to_char text to_date to_label to_multi_byte to_number to_single_byte translate true trunc uid unlogged upper user userenv varchar varchar2 variance varying vsize xml"),
	    operatorChars: /^[*+\-%<>!=~]/,
	    dateSQL:    set("date time timestamp"),
	    support:    set("doubleQuote nCharCast zerolessFloat binaryNumber hexNumber")
	  });
	
	  // Created to support specific hive keywords
	  CodeMirror.defineMIME("text/x-hive", {
	    name: "sql",
	    keywords: set("select alter $elem$ $key$ $value$ add after all analyze and archive as asc before between binary both bucket buckets by cascade case cast change cluster clustered clusterstatus collection column columns comment compute concatenate continue create cross cursor data database databases dbproperties deferred delete delimited desc describe directory disable distinct distribute drop else enable end escaped exclusive exists explain export extended external false fetch fields fileformat first format formatted from full function functions grant group having hold_ddltime idxproperties if import in index indexes inpath inputdriver inputformat insert intersect into is items join keys lateral left like limit lines load local location lock locks mapjoin materialized minus msck no_drop nocompress not of offline on option or order out outer outputdriver outputformat overwrite partition partitioned partitions percent plus preserve procedure purge range rcfile read readonly reads rebuild recordreader recordwriter recover reduce regexp rename repair replace restrict revoke right rlike row schema schemas semi sequencefile serde serdeproperties set shared show show_database sort sorted ssl statistics stored streamtable table tables tablesample tblproperties temporary terminated textfile then tmp to touch transform trigger true unarchive undo union uniquejoin unlock update use using utc utc_tmestamp view when where while with"),
	    builtin: set("bool boolean long timestamp tinyint smallint bigint int float double date datetime unsigned string array struct map uniontype"),
	    atoms: set("false true null unknown"),
	    operatorChars: /^[*+\-%<>!=]/,
	    dateSQL: set("date timestamp"),
	    support: set("ODBCdotTable doubleQuote binaryNumber hexNumber")
	  });
	
	  CodeMirror.defineMIME("text/x-pgsql", {
	    name: "sql",
	    client: set("source"),
	    // http://www.postgresql.org/docs/9.5/static/sql-keywords-appendix.html
	    keywords: set(sqlKeywords + "a abort abs absent absolute access according action ada add admin after aggregate all allocate also always analyse analyze any are array array_agg array_max_cardinality asensitive assertion assignment asymmetric at atomic attribute attributes authorization avg backward base64 before begin begin_frame begin_partition bernoulli binary bit_length blob blocked bom both breadth c cache call called cardinality cascade cascaded case cast catalog catalog_name ceil ceiling chain characteristics characters character_length character_set_catalog character_set_name character_set_schema char_length check checkpoint class class_origin clob close cluster coalesce cobol collate collation collation_catalog collation_name collation_schema collect column columns column_name command_function command_function_code comment comments commit committed concurrently condition condition_number configuration conflict connect connection connection_name constraint constraints constraint_catalog constraint_name constraint_schema constructor contains content continue control conversion convert copy corr corresponding cost covar_pop covar_samp cross csv cube cume_dist current current_catalog current_date current_default_transform_group current_path current_role current_row current_schema current_time current_timestamp current_transform_group_for_type current_user cursor cursor_name cycle data database datalink datetime_interval_code datetime_interval_precision day db deallocate dec declare default defaults deferrable deferred defined definer degree delimiter delimiters dense_rank depth deref derived describe descriptor deterministic diagnostics dictionary disable discard disconnect dispatch dlnewcopy dlpreviouscopy dlurlcomplete dlurlcompleteonly dlurlcompletewrite dlurlpath dlurlpathonly dlurlpathwrite dlurlscheme dlurlserver dlvalue do document domain dynamic dynamic_function dynamic_function_code each element else empty enable encoding encrypted end end-exec end_frame end_partition enforced enum equals escape event every except exception exclude excluding exclusive exec execute exists exp explain expression extension external extract false family fetch file filter final first first_value flag float floor following for force foreign fortran forward found frame_row free freeze fs full function functions fusion g general generated get global go goto grant granted greatest grouping groups handler header hex hierarchy hold hour id identity if ignore ilike immediate immediately immutable implementation implicit import including increment indent index indexes indicator inherit inherits initially inline inner inout input insensitive instance instantiable instead integrity intersect intersection invoker isnull isolation k key key_member key_type label lag language large last last_value lateral lead leading leakproof least left length level library like_regex link listen ln load local localtime localtimestamp location locator lock locked logged lower m map mapping match matched materialized max maxvalue max_cardinality member merge message_length message_octet_length message_text method min minute minvalue mod mode modifies module month more move multiset mumps name names namespace national natural nchar nclob nesting new next nfc nfd nfkc nfkd nil no none normalize normalized nothing notify notnull nowait nth_value ntile null nullable nullif nulls number object occurrences_regex octets octet_length of off offset oids old only open operator option options ordering ordinality others out outer output over overlaps overlay overriding owned owner p pad parameter parameter_mode parameter_name parameter_ordinal_position parameter_specific_catalog parameter_specific_name parameter_specific_schema parser partial partition pascal passing passthrough password percent percentile_cont percentile_disc percent_rank period permission placing plans pli policy portion position position_regex power precedes preceding prepare prepared preserve primary prior privileges procedural procedure program public quote range rank read reads reassign recheck recovery recursive ref references referencing refresh regr_avgx regr_avgy regr_count regr_intercept regr_r2 regr_slope regr_sxx regr_sxy regr_syy reindex relative release rename repeatable replace replica requiring reset respect restart restore restrict result return returned_cardinality returned_length returned_octet_length returned_sqlstate returning returns revoke right role rollback rollup routine routine_catalog routine_name routine_schema row rows row_count row_number rule savepoint scale schema schema_name scope scope_catalog scope_name scope_schema scroll search second section security selective self sensitive sequence sequences serializable server server_name session session_user setof sets share show similar simple size skip snapshot some source space specific specifictype specific_name sql sqlcode sqlerror sqlexception sqlstate sqlwarning sqrt stable standalone start state statement static statistics stddev_pop stddev_samp stdin stdout storage strict strip structure style subclass_origin submultiset substring substring_regex succeeds sum symmetric sysid system system_time system_user t tables tablesample tablespace table_name temp template temporary then ties timezone_hour timezone_minute to token top_level_count trailing transaction transactions_committed transactions_rolled_back transaction_active transform transforms translate translate_regex translation treat trigger trigger_catalog trigger_name trigger_schema trim trim_array true truncate trusted type types uescape unbounded uncommitted under unencrypted unique unknown unlink unlisten unlogged unnamed unnest until untyped upper uri usage user user_defined_type_catalog user_defined_type_code user_defined_type_name user_defined_type_schema using vacuum valid validate validator value value_of varbinary variadic var_pop var_samp verbose version versioning view views volatile when whenever whitespace width_bucket window within work wrapper write xmlagg xmlattributes xmlbinary xmlcast xmlcomment xmlconcat xmldeclaration xmldocument xmlelement xmlexists xmlforest xmliterate xmlnamespaces xmlparse xmlpi xmlquery xmlroot xmlschema xmlserialize xmltable xmltext xmlvalidate year yes loop repeat"),
	    // http://www.postgresql.org/docs/9.5/static/datatype.html
	    builtin: set("bigint int8 bigserial serial8 bit varying varbit boolean bool box bytea character char varchar cidr circle date double precision float8 inet integer int int4 interval json jsonb line lseg macaddr money numeric decimal path pg_lsn point polygon real float4 smallint int2 smallserial serial2 serial serial4 text time without zone with timetz timestamp timestamptz tsquery tsvector txid_snapshot uuid xml"),
	    atoms: set("false true null unknown"),
	    operatorChars: /^[*+\-%<>!=&|^\/#@?~]/,
	    dateSQL: set("date time timestamp"),
	    support: set("ODBCdotTable decimallessFloat zerolessFloat binaryNumber hexNumber nCharCast charsetCast")
	  });
	
	  // Google's SQL-like query language, GQL
	  CodeMirror.defineMIME("text/x-gql", {
	    name: "sql",
	    keywords: set("ancestor and asc by contains desc descendant distinct from group has in is limit offset on order select superset where"),
	    atoms: set("false true"),
	    builtin: set("blob datetime first key __key__ string integer double boolean null"),
	    operatorChars: /^[*+\-%<>!=]/
	  });
	}());
	
	});
	
	/*
	  How Properties of Mime Types are used by SQL Mode
	  =================================================
	
	  keywords:
	    A list of keywords you want to be highlighted.
	  builtin:
	    A list of builtin types you want to be highlighted (if you want types to be of class "builtin" instead of "keyword").
	  operatorChars:
	    All characters that must be handled as operators.
	  client:
	    Commands parsed and executed by the client (not the server).
	  support:
	    A list of supported syntaxes which are not common, but are supported by more than 1 DBMS.
	    * ODBCdotTable: .tableName
	    * zerolessFloat: .1
	    * doubleQuote
	    * nCharCast: N'string'
	    * charsetCast: _utf8'string'
	    * commentHash: use # char for comments
	    * commentSlashSlash: use // for comments
	    * commentSpaceRequired: require a space after -- for comments
	  atoms:
	    Keywords that must be highlighted as atoms,. Some DBMS's support more atoms than others:
	    UNKNOWN, INFINITY, UNDERFLOW, NaN...
	  dateSQL:
	    Used for date/time SQL standard syntax, because not all DBMS's support same temporal types.
	*/


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	/*
	 * Author: Constantin Jucovschi (c.jucovschi@jacobs-university.de)
	 * Licence: MIT
	 */
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("stex", function() {
	    "use strict";
	
	    function pushCommand(state, command) {
	      state.cmdState.push(command);
	    }
	
	    function peekCommand(state) {
	      if (state.cmdState.length > 0) {
	        return state.cmdState[state.cmdState.length - 1];
	      } else {
	        return null;
	      }
	    }
	
	    function popCommand(state) {
	      var plug = state.cmdState.pop();
	      if (plug) {
	        plug.closeBracket();
	      }
	    }
	
	    // returns the non-default plugin closest to the end of the list
	    function getMostPowerful(state) {
	      var context = state.cmdState;
	      for (var i = context.length - 1; i >= 0; i--) {
	        var plug = context[i];
	        if (plug.name == "DEFAULT") {
	          continue;
	        }
	        return plug;
	      }
	      return { styleIdentifier: function() { return null; } };
	    }
	
	    function addPluginPattern(pluginName, cmdStyle, styles) {
	      return function () {
	        this.name = pluginName;
	        this.bracketNo = 0;
	        this.style = cmdStyle;
	        this.styles = styles;
	        this.argument = null;   // \begin and \end have arguments that follow. These are stored in the plugin
	
	        this.styleIdentifier = function() {
	          return this.styles[this.bracketNo - 1] || null;
	        };
	        this.openBracket = function() {
	          this.bracketNo++;
	          return "bracket";
	        };
	        this.closeBracket = function() {};
	      };
	    }
	
	    var plugins = {};
	
	    plugins["importmodule"] = addPluginPattern("importmodule", "tag", ["string", "builtin"]);
	    plugins["documentclass"] = addPluginPattern("documentclass", "tag", ["", "atom"]);
	    plugins["usepackage"] = addPluginPattern("usepackage", "tag", ["atom"]);
	    plugins["begin"] = addPluginPattern("begin", "tag", ["atom"]);
	    plugins["end"] = addPluginPattern("end", "tag", ["atom"]);
	
	    plugins["DEFAULT"] = function () {
	      this.name = "DEFAULT";
	      this.style = "tag";
	
	      this.styleIdentifier = this.openBracket = this.closeBracket = function() {};
	    };
	
	    function setState(state, f) {
	      state.f = f;
	    }
	
	    // called when in a normal (no environment) context
	    function normal(source, state) {
	      var plug;
	      // Do we look like '\command' ?  If so, attempt to apply the plugin 'command'
	      if (source.match(/^\\[a-zA-Z@]+/)) {
	        var cmdName = source.current().slice(1);
	        plug = plugins[cmdName] || plugins["DEFAULT"];
	        plug = new plug();
	        pushCommand(state, plug);
	        setState(state, beginParams);
	        return plug.style;
	      }
	
	      // escape characters
	      if (source.match(/^\\[$&%#{}_]/)) {
	        return "tag";
	      }
	
	      // white space control characters
	      if (source.match(/^\\[,;!\/\\]/)) {
	        return "tag";
	      }
	
	      // find if we're starting various math modes
	      if (source.match("\\[")) {
	        setState(state, function(source, state){ return inMathMode(source, state, "\\]"); });
	        return "keyword";
	      }
	      if (source.match("$$")) {
	        setState(state, function(source, state){ return inMathMode(source, state, "$$"); });
	        return "keyword";
	      }
	      if (source.match("$")) {
	        setState(state, function(source, state){ return inMathMode(source, state, "$"); });
	        return "keyword";
	      }
	
	      var ch = source.next();
	      if (ch == "%") {
	        source.skipToEnd();
	        return "comment";
	      } else if (ch == '}' || ch == ']') {
	        plug = peekCommand(state);
	        if (plug) {
	          plug.closeBracket(ch);
	          setState(state, beginParams);
	        } else {
	          return "error";
	        }
	        return "bracket";
	      } else if (ch == '{' || ch == '[') {
	        plug = plugins["DEFAULT"];
	        plug = new plug();
	        pushCommand(state, plug);
	        return "bracket";
	      } else if (/\d/.test(ch)) {
	        source.eatWhile(/[\w.%]/);
	        return "atom";
	      } else {
	        source.eatWhile(/[\w\-_]/);
	        plug = getMostPowerful(state);
	        if (plug.name == 'begin') {
	          plug.argument = source.current();
	        }
	        return plug.styleIdentifier();
	      }
	    }
	
	    function inMathMode(source, state, endModeSeq) {
	      if (source.eatSpace()) {
	        return null;
	      }
	      if (source.match(endModeSeq)) {
	        setState(state, normal);
	        return "keyword";
	      }
	      if (source.match(/^\\[a-zA-Z@]+/)) {
	        return "tag";
	      }
	      if (source.match(/^[a-zA-Z]+/)) {
	        return "variable-2";
	      }
	      // escape characters
	      if (source.match(/^\\[$&%#{}_]/)) {
	        return "tag";
	      }
	      // white space control characters
	      if (source.match(/^\\[,;!\/]/)) {
	        return "tag";
	      }
	      // special math-mode characters
	      if (source.match(/^[\^_&]/)) {
	        return "tag";
	      }
	      // non-special characters
	      if (source.match(/^[+\-<>|=,\/@!*:;'"`~#?]/)) {
	        return null;
	      }
	      if (source.match(/^(\d+\.\d*|\d*\.\d+|\d+)/)) {
	        return "number";
	      }
	      var ch = source.next();
	      if (ch == "{" || ch == "}" || ch == "[" || ch == "]" || ch == "(" || ch == ")") {
	        return "bracket";
	      }
	
	      if (ch == "%") {
	        source.skipToEnd();
	        return "comment";
	      }
	      return "error";
	    }
	
	    function beginParams(source, state) {
	      var ch = source.peek(), lastPlug;
	      if (ch == '{' || ch == '[') {
	        lastPlug = peekCommand(state);
	        lastPlug.openBracket(ch);
	        source.eat(ch);
	        setState(state, normal);
	        return "bracket";
	      }
	      if (/[ \t\r]/.test(ch)) {
	        source.eat(ch);
	        return null;
	      }
	      setState(state, normal);
	      popCommand(state);
	
	      return normal(source, state);
	    }
	
	    return {
	      startState: function() {
	        return {
	          cmdState: [],
	          f: normal
	        };
	      },
	      copyState: function(s) {
	        return {
	          cmdState: s.cmdState.slice(),
	          f: s.f
	        };
	      },
	      token: function(stream, state) {
	        return state.f(stream, state);
	      },
	      blankLine: function(state) {
	        state.f = normal;
	        state.cmdState.length = 0;
	      },
	      lineComment: "%"
	    };
	  });
	
	  CodeMirror.defineMIME("text/x-stex", "stex");
	  CodeMirror.defineMIME("text/x-latex", "stex");
	
	});


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// Stylus mode created by Dmitry Kiselyov http://git.io/AaRB
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("stylus", function(config) {
	    var indentUnit = config.indentUnit,
	        tagKeywords = keySet(tagKeywords_),
	        tagVariablesRegexp = /^(a|b|i|s|col|em)$/i,
	        propertyKeywords = keySet(propertyKeywords_),
	        nonStandardPropertyKeywords = keySet(nonStandardPropertyKeywords_),
	        valueKeywords = keySet(valueKeywords_),
	        colorKeywords = keySet(colorKeywords_),
	        documentTypes = keySet(documentTypes_),
	        documentTypesRegexp = wordRegexp(documentTypes_),
	        mediaFeatures = keySet(mediaFeatures_),
	        mediaTypes = keySet(mediaTypes_),
	        fontProperties = keySet(fontProperties_),
	        operatorsRegexp = /^\s*([.]{2,3}|&&|\|\||\*\*|[?!=:]?=|[-+*\/%<>]=?|\?:|\~)/,
	        wordOperatorKeywordsRegexp = wordRegexp(wordOperatorKeywords_),
	        blockKeywords = keySet(blockKeywords_),
	        vendorPrefixesRegexp = new RegExp(/^\-(moz|ms|o|webkit)-/i),
	        commonAtoms = keySet(commonAtoms_),
	        firstWordMatch = "",
	        states = {},
	        ch,
	        style,
	        type,
	        override;
	
	    /**
	     * Tokenizers
	     */
	    function tokenBase(stream, state) {
	      firstWordMatch = stream.string.match(/(^[\w-]+\s*=\s*$)|(^\s*[\w-]+\s*=\s*[\w-])|(^\s*(\.|#|@|\$|\&|\[|\d|\+|::?|\{|\>|~|\/)?\s*[\w-]*([a-z0-9-]|\*|\/\*)(\(|,)?)/);
	      state.context.line.firstWord = firstWordMatch ? firstWordMatch[0].replace(/^\s*/, "") : "";
	      state.context.line.indent = stream.indentation();
	      ch = stream.peek();
	
	      // Line comment
	      if (stream.match("//")) {
	        stream.skipToEnd();
	        return ["comment", "comment"];
	      }
	      // Block comment
	      if (stream.match("/*")) {
	        state.tokenize = tokenCComment;
	        return tokenCComment(stream, state);
	      }
	      // String
	      if (ch == "\"" || ch == "'") {
	        stream.next();
	        state.tokenize = tokenString(ch);
	        return state.tokenize(stream, state);
	      }
	      // Def
	      if (ch == "@") {
	        stream.next();
	        stream.eatWhile(/[\w\\-]/);
	        return ["def", stream.current()];
	      }
	      // ID selector or Hex color
	      if (ch == "#") {
	        stream.next();
	        // Hex color
	        if (stream.match(/^[0-9a-f]{6}|[0-9a-f]{3}/i)) {
	          return ["atom", "atom"];
	        }
	        // ID selector
	        if (stream.match(/^[a-z][\w-]*/i)) {
	          return ["builtin", "hash"];
	        }
	      }
	      // Vendor prefixes
	      if (stream.match(vendorPrefixesRegexp)) {
	        return ["meta", "vendor-prefixes"];
	      }
	      // Numbers
	      if (stream.match(/^-?[0-9]?\.?[0-9]/)) {
	        stream.eatWhile(/[a-z%]/i);
	        return ["number", "unit"];
	      }
	      // !important|optional
	      if (ch == "!") {
	        stream.next();
	        return [stream.match(/^(important|optional)/i) ? "keyword": "operator", "important"];
	      }
	      // Class
	      if (ch == "." && stream.match(/^\.[a-z][\w-]*/i)) {
	        return ["qualifier", "qualifier"];
	      }
	      // url url-prefix domain regexp
	      if (stream.match(documentTypesRegexp)) {
	        if (stream.peek() == "(") state.tokenize = tokenParenthesized;
	        return ["property", "word"];
	      }
	      // Mixins / Functions
	      if (stream.match(/^[a-z][\w-]*\(/i)) {
	        stream.backUp(1);
	        return ["keyword", "mixin"];
	      }
	      // Block mixins
	      if (stream.match(/^(\+|-)[a-z][\w-]*\(/i)) {
	        stream.backUp(1);
	        return ["keyword", "block-mixin"];
	      }
	      // Parent Reference BEM naming
	      if (stream.string.match(/^\s*&/) && stream.match(/^[-_]+[a-z][\w-]*/)) {
	        return ["qualifier", "qualifier"];
	      }
	      // / Root Reference & Parent Reference
	      if (stream.match(/^(\/|&)(-|_|:|\.|#|[a-z])/)) {
	        stream.backUp(1);
	        return ["variable-3", "reference"];
	      }
	      if (stream.match(/^&{1}\s*$/)) {
	        return ["variable-3", "reference"];
	      }
	      // Word operator
	      if (stream.match(wordOperatorKeywordsRegexp)) {
	        return ["operator", "operator"];
	      }
	      // Word
	      if (stream.match(/^\$?[-_]*[a-z0-9]+[\w-]*/i)) {
	        // Variable
	        if (stream.match(/^(\.|\[)[\w-\'\"\]]+/i, false)) {
	          if (!wordIsTag(stream.current())) {
	            stream.match(/\./);
	            return ["variable-2", "variable-name"];
	          }
	        }
	        return ["variable-2", "word"];
	      }
	      // Operators
	      if (stream.match(operatorsRegexp)) {
	        return ["operator", stream.current()];
	      }
	      // Delimiters
	      if (/[:;,{}\[\]\(\)]/.test(ch)) {
	        stream.next();
	        return [null, ch];
	      }
	      // Non-detected items
	      stream.next();
	      return [null, null];
	    }
	
	    /**
	     * Token comment
	     */
	    function tokenCComment(stream, state) {
	      var maybeEnd = false, ch;
	      while ((ch = stream.next()) != null) {
	        if (maybeEnd && ch == "/") {
	          state.tokenize = null;
	          break;
	        }
	        maybeEnd = (ch == "*");
	      }
	      return ["comment", "comment"];
	    }
	
	    /**
	     * Token string
	     */
	    function tokenString(quote) {
	      return function(stream, state) {
	        var escaped = false, ch;
	        while ((ch = stream.next()) != null) {
	          if (ch == quote && !escaped) {
	            if (quote == ")") stream.backUp(1);
	            break;
	          }
	          escaped = !escaped && ch == "\\";
	        }
	        if (ch == quote || !escaped && quote != ")") state.tokenize = null;
	        return ["string", "string"];
	      };
	    }
	
	    /**
	     * Token parenthesized
	     */
	    function tokenParenthesized(stream, state) {
	      stream.next(); // Must be "("
	      if (!stream.match(/\s*[\"\')]/, false))
	        state.tokenize = tokenString(")");
	      else
	        state.tokenize = null;
	      return [null, "("];
	    }
	
	    /**
	     * Context management
	     */
	    function Context(type, indent, prev, line) {
	      this.type = type;
	      this.indent = indent;
	      this.prev = prev;
	      this.line = line || {firstWord: "", indent: 0};
	    }
	
	    function pushContext(state, stream, type, indent) {
	      indent = indent >= 0 ? indent : indentUnit;
	      state.context = new Context(type, stream.indentation() + indent, state.context);
	      return type;
	    }
	
	    function popContext(state, currentIndent) {
	      var contextIndent = state.context.indent - indentUnit;
	      currentIndent = currentIndent || false;
	      state.context = state.context.prev;
	      if (currentIndent) state.context.indent = contextIndent;
	      return state.context.type;
	    }
	
	    function pass(type, stream, state) {
	      return states[state.context.type](type, stream, state);
	    }
	
	    function popAndPass(type, stream, state, n) {
	      for (var i = n || 1; i > 0; i--)
	        state.context = state.context.prev;
	      return pass(type, stream, state);
	    }
	
	
	    /**
	     * Parser
	     */
	    function wordIsTag(word) {
	      return word.toLowerCase() in tagKeywords;
	    }
	
	    function wordIsProperty(word) {
	      word = word.toLowerCase();
	      return word in propertyKeywords || word in fontProperties;
	    }
	
	    function wordIsBlock(word) {
	      return word.toLowerCase() in blockKeywords;
	    }
	
	    function wordIsVendorPrefix(word) {
	      return word.toLowerCase().match(vendorPrefixesRegexp);
	    }
	
	    function wordAsValue(word) {
	      var wordLC = word.toLowerCase();
	      var override = "variable-2";
	      if (wordIsTag(word)) override = "tag";
	      else if (wordIsBlock(word)) override = "block-keyword";
	      else if (wordIsProperty(word)) override = "property";
	      else if (wordLC in valueKeywords || wordLC in commonAtoms) override = "atom";
	      else if (wordLC == "return" || wordLC in colorKeywords) override = "keyword";
	
	      // Font family
	      else if (word.match(/^[A-Z]/)) override = "string";
	      return override;
	    }
	
	    function typeIsBlock(type, stream) {
	      return ((endOfLine(stream) && (type == "{" || type == "]" || type == "hash" || type == "qualifier")) || type == "block-mixin");
	    }
	
	    function typeIsInterpolation(type, stream) {
	      return type == "{" && stream.match(/^\s*\$?[\w-]+/i, false);
	    }
	
	    function typeIsPseudo(type, stream) {
	      return type == ":" && stream.match(/^[a-z-]+/, false);
	    }
	
	    function startOfLine(stream) {
	      return stream.sol() || stream.string.match(new RegExp("^\\s*" + escapeRegExp(stream.current())));
	    }
	
	    function endOfLine(stream) {
	      return stream.eol() || stream.match(/^\s*$/, false);
	    }
	
	    function firstWordOfLine(line) {
	      var re = /^\s*[-_]*[a-z0-9]+[\w-]*/i;
	      var result = typeof line == "string" ? line.match(re) : line.string.match(re);
	      return result ? result[0].replace(/^\s*/, "") : "";
	    }
	
	
	    /**
	     * Block
	     */
	    states.block = function(type, stream, state) {
	      if ((type == "comment" && startOfLine(stream)) ||
	          (type == "," && endOfLine(stream)) ||
	          type == "mixin") {
	        return pushContext(state, stream, "block", 0);
	      }
	      if (typeIsInterpolation(type, stream)) {
	        return pushContext(state, stream, "interpolation");
	      }
	      if (endOfLine(stream) && type == "]") {
	        if (!/^\s*(\.|#|:|\[|\*|&)/.test(stream.string) && !wordIsTag(firstWordOfLine(stream))) {
	          return pushContext(state, stream, "block", 0);
	        }
	      }
	      if (typeIsBlock(type, stream, state)) {
	        return pushContext(state, stream, "block");
	      }
	      if (type == "}" && endOfLine(stream)) {
	        return pushContext(state, stream, "block", 0);
	      }
	      if (type == "variable-name") {
	        if (stream.string.match(/^\s?\$[\w-\.\[\]\'\"]+$/) || wordIsBlock(firstWordOfLine(stream))) {
	          return pushContext(state, stream, "variableName");
	        }
	        else {
	          return pushContext(state, stream, "variableName", 0);
	        }
	      }
	      if (type == "=") {
	        if (!endOfLine(stream) && !wordIsBlock(firstWordOfLine(stream))) {
	          return pushContext(state, stream, "block", 0);
	        }
	        return pushContext(state, stream, "block");
	      }
	      if (type == "*") {
	        if (endOfLine(stream) || stream.match(/\s*(,|\.|#|\[|:|{)/,false)) {
	          override = "tag";
	          return pushContext(state, stream, "block");
	        }
	      }
	      if (typeIsPseudo(type, stream)) {
	        return pushContext(state, stream, "pseudo");
	      }
	      if (/@(font-face|media|supports|(-moz-)?document)/.test(type)) {
	        return pushContext(state, stream, endOfLine(stream) ? "block" : "atBlock");
	      }
	      if (/@(-(moz|ms|o|webkit)-)?keyframes$/.test(type)) {
	        return pushContext(state, stream, "keyframes");
	      }
	      if (/@extends?/.test(type)) {
	        return pushContext(state, stream, "extend", 0);
	      }
	      if (type && type.charAt(0) == "@") {
	
	        // Property Lookup
	        if (stream.indentation() > 0 && wordIsProperty(stream.current().slice(1))) {
	          override = "variable-2";
	          return "block";
	        }
	        if (/(@import|@require|@charset)/.test(type)) {
	          return pushContext(state, stream, "block", 0);
	        }
	        return pushContext(state, stream, "block");
	      }
	      if (type == "reference" && endOfLine(stream)) {
	        return pushContext(state, stream, "block");
	      }
	      if (type == "(") {
	        return pushContext(state, stream, "parens");
	      }
	
	      if (type == "vendor-prefixes") {
	        return pushContext(state, stream, "vendorPrefixes");
	      }
	      if (type == "word") {
	        var word = stream.current();
	        override = wordAsValue(word);
	
	        if (override == "property") {
	          if (startOfLine(stream)) {
	            return pushContext(state, stream, "block", 0);
	          } else {
	            override = "atom";
	            return "block";
	          }
	        }
	
	        if (override == "tag") {
	
	          // tag is a css value
	          if (/embed|menu|pre|progress|sub|table/.test(word)) {
	            if (wordIsProperty(firstWordOfLine(stream))) {
	              override = "atom";
	              return "block";
	            }
	          }
	
	          // tag is an attribute
	          if (stream.string.match(new RegExp("\\[\\s*" + word + "|" + word +"\\s*\\]"))) {
	            override = "atom";
	            return "block";
	          }
	
	          // tag is a variable
	          if (tagVariablesRegexp.test(word)) {
	            if ((startOfLine(stream) && stream.string.match(/=/)) ||
	                (!startOfLine(stream) &&
	                 !stream.string.match(/^(\s*\.|#|\&|\[|\/|>|\*)/) &&
	                 !wordIsTag(firstWordOfLine(stream)))) {
	              override = "variable-2";
	              if (wordIsBlock(firstWordOfLine(stream)))  return "block";
	              return pushContext(state, stream, "block", 0);
	            }
	          }
	
	          if (endOfLine(stream)) return pushContext(state, stream, "block");
	        }
	        if (override == "block-keyword") {
	          override = "keyword";
	
	          // Postfix conditionals
	          if (stream.current(/(if|unless)/) && !startOfLine(stream)) {
	            return "block";
	          }
	          return pushContext(state, stream, "block");
	        }
	        if (word == "return") return pushContext(state, stream, "block", 0);
	
	        // Placeholder selector
	        if (override == "variable-2" && stream.string.match(/^\s?\$[\w-\.\[\]\'\"]+$/)) {
	          return pushContext(state, stream, "block");
	        }
	      }
	      return state.context.type;
	    };
	
	
	    /**
	     * Parens
	     */
	    states.parens = function(type, stream, state) {
	      if (type == "(") return pushContext(state, stream, "parens");
	      if (type == ")") {
	        if (state.context.prev.type == "parens") {
	          return popContext(state);
	        }
	        if ((stream.string.match(/^[a-z][\w-]*\(/i) && endOfLine(stream)) ||
	            wordIsBlock(firstWordOfLine(stream)) ||
	            /(\.|#|:|\[|\*|&|>|~|\+|\/)/.test(firstWordOfLine(stream)) ||
	            (!stream.string.match(/^-?[a-z][\w-\.\[\]\'\"]*\s*=/) &&
	             wordIsTag(firstWordOfLine(stream)))) {
	          return pushContext(state, stream, "block");
	        }
	        if (stream.string.match(/^[\$-]?[a-z][\w-\.\[\]\'\"]*\s*=/) ||
	            stream.string.match(/^\s*(\(|\)|[0-9])/) ||
	            stream.string.match(/^\s+[a-z][\w-]*\(/i) ||
	            stream.string.match(/^\s+[\$-]?[a-z]/i)) {
	          return pushContext(state, stream, "block", 0);
	        }
	        if (endOfLine(stream)) return pushContext(state, stream, "block");
	        else return pushContext(state, stream, "block", 0);
	      }
	      if (type && type.charAt(0) == "@" && wordIsProperty(stream.current().slice(1))) {
	        override = "variable-2";
	      }
	      if (type == "word") {
	        var word = stream.current();
	        override = wordAsValue(word);
	        if (override == "tag" && tagVariablesRegexp.test(word)) {
	          override = "variable-2";
	        }
	        if (override == "property" || word == "to") override = "atom";
	      }
	      if (type == "variable-name") {
	        return pushContext(state, stream, "variableName");
	      }
	      if (typeIsPseudo(type, stream)) {
	        return pushContext(state, stream, "pseudo");
	      }
	      return state.context.type;
	    };
	
	
	    /**
	     * Vendor prefixes
	     */
	    states.vendorPrefixes = function(type, stream, state) {
	      if (type == "word") {
	        override = "property";
	        return pushContext(state, stream, "block", 0);
	      }
	      return popContext(state);
	    };
	
	
	    /**
	     * Pseudo
	     */
	    states.pseudo = function(type, stream, state) {
	      if (!wordIsProperty(firstWordOfLine(stream.string))) {
	        stream.match(/^[a-z-]+/);
	        override = "variable-3";
	        if (endOfLine(stream)) return pushContext(state, stream, "block");
	        return popContext(state);
	      }
	      return popAndPass(type, stream, state);
	    };
	
	
	    /**
	     * atBlock
	     */
	    states.atBlock = function(type, stream, state) {
	      if (type == "(") return pushContext(state, stream, "atBlock_parens");
	      if (typeIsBlock(type, stream, state)) {
	        return pushContext(state, stream, "block");
	      }
	      if (typeIsInterpolation(type, stream)) {
	        return pushContext(state, stream, "interpolation");
	      }
	      if (type == "word") {
	        var word = stream.current().toLowerCase();
	        if (/^(only|not|and|or)$/.test(word))
	          override = "keyword";
	        else if (documentTypes.hasOwnProperty(word))
	          override = "tag";
	        else if (mediaTypes.hasOwnProperty(word))
	          override = "attribute";
	        else if (mediaFeatures.hasOwnProperty(word))
	          override = "property";
	        else if (nonStandardPropertyKeywords.hasOwnProperty(word))
	          override = "string-2";
	        else override = wordAsValue(stream.current());
	        if (override == "tag" && endOfLine(stream)) {
	          return pushContext(state, stream, "block");
	        }
	      }
	      if (type == "operator" && /^(not|and|or)$/.test(stream.current())) {
	        override = "keyword";
	      }
	      return state.context.type;
	    };
	
	    states.atBlock_parens = function(type, stream, state) {
	      if (type == "{" || type == "}") return state.context.type;
	      if (type == ")") {
	        if (endOfLine(stream)) return pushContext(state, stream, "block");
	        else return pushContext(state, stream, "atBlock");
	      }
	      if (type == "word") {
	        var word = stream.current().toLowerCase();
	        override = wordAsValue(word);
	        if (/^(max|min)/.test(word)) override = "property";
	        if (override == "tag") {
	          tagVariablesRegexp.test(word) ? override = "variable-2" : override = "atom";
	        }
	        return state.context.type;
	      }
	      return states.atBlock(type, stream, state);
	    };
	
	
	    /**
	     * Keyframes
	     */
	    states.keyframes = function(type, stream, state) {
	      if (stream.indentation() == "0" && ((type == "}" && startOfLine(stream)) || type == "]" || type == "hash"
	                                          || type == "qualifier" || wordIsTag(stream.current()))) {
	        return popAndPass(type, stream, state);
	      }
	      if (type == "{") return pushContext(state, stream, "keyframes");
	      if (type == "}") {
	        if (startOfLine(stream)) return popContext(state, true);
	        else return pushContext(state, stream, "keyframes");
	      }
	      if (type == "unit" && /^[0-9]+\%$/.test(stream.current())) {
	        return pushContext(state, stream, "keyframes");
	      }
	      if (type == "word") {
	        override = wordAsValue(stream.current());
	        if (override == "block-keyword") {
	          override = "keyword";
	          return pushContext(state, stream, "keyframes");
	        }
	      }
	      if (/@(font-face|media|supports|(-moz-)?document)/.test(type)) {
	        return pushContext(state, stream, endOfLine(stream) ? "block" : "atBlock");
	      }
	      if (type == "mixin") {
	        return pushContext(state, stream, "block", 0);
	      }
	      return state.context.type;
	    };
	
	
	    /**
	     * Interpolation
	     */
	    states.interpolation = function(type, stream, state) {
	      if (type == "{") popContext(state) && pushContext(state, stream, "block");
	      if (type == "}") {
	        if (stream.string.match(/^\s*(\.|#|:|\[|\*|&|>|~|\+|\/)/i) ||
	            (stream.string.match(/^\s*[a-z]/i) && wordIsTag(firstWordOfLine(stream)))) {
	          return pushContext(state, stream, "block");
	        }
	        if (!stream.string.match(/^(\{|\s*\&)/) ||
	            stream.match(/\s*[\w-]/,false)) {
	          return pushContext(state, stream, "block", 0);
	        }
	        return pushContext(state, stream, "block");
	      }
	      if (type == "variable-name") {
	        return pushContext(state, stream, "variableName", 0);
	      }
	      if (type == "word") {
	        override = wordAsValue(stream.current());
	        if (override == "tag") override = "atom";
	      }
	      return state.context.type;
	    };
	
	
	    /**
	     * Extend/s
	     */
	    states.extend = function(type, stream, state) {
	      if (type == "[" || type == "=") return "extend";
	      if (type == "]") return popContext(state);
	      if (type == "word") {
	        override = wordAsValue(stream.current());
	        return "extend";
	      }
	      return popContext(state);
	    };
	
	
	    /**
	     * Variable name
	     */
	    states.variableName = function(type, stream, state) {
	      if (type == "string" || type == "[" || type == "]" || stream.current().match(/^(\.|\$)/)) {
	        if (stream.current().match(/^\.[\w-]+/i)) override = "variable-2";
	        return "variableName";
	      }
	      return popAndPass(type, stream, state);
	    };
	
	
	    return {
	      startState: function(base) {
	        return {
	          tokenize: null,
	          state: "block",
	          context: new Context("block", base || 0, null)
	        };
	      },
	      token: function(stream, state) {
	        if (!state.tokenize && stream.eatSpace()) return null;
	        style = (state.tokenize || tokenBase)(stream, state);
	        if (style && typeof style == "object") {
	          type = style[1];
	          style = style[0];
	        }
	        override = style;
	        state.state = states[state.state](type, stream, state);
	        return override;
	      },
	      indent: function(state, textAfter, line) {
	
	        var cx = state.context,
	            ch = textAfter && textAfter.charAt(0),
	            indent = cx.indent,
	            lineFirstWord = firstWordOfLine(textAfter),
	            lineIndent = line.length - line.replace(/^\s*/, "").length,
	            prevLineFirstWord = state.context.prev ? state.context.prev.line.firstWord : "",
	            prevLineIndent = state.context.prev ? state.context.prev.line.indent : lineIndent;
	
	        if (cx.prev &&
	            (ch == "}" && (cx.type == "block" || cx.type == "atBlock" || cx.type == "keyframes") ||
	             ch == ")" && (cx.type == "parens" || cx.type == "atBlock_parens") ||
	             ch == "{" && (cx.type == "at"))) {
	          indent = cx.indent - indentUnit;
	          cx = cx.prev;
	        } else if (!(/(\})/.test(ch))) {
	          if (/@|\$|\d/.test(ch) ||
	              /^\{/.test(textAfter) ||
	/^\s*\/(\/|\*)/.test(textAfter) ||
	              /^\s*\/\*/.test(prevLineFirstWord) ||
	              /^\s*[\w-\.\[\]\'\"]+\s*(\?|:|\+)?=/i.test(textAfter) ||
	/^(\+|-)?[a-z][\w-]*\(/i.test(textAfter) ||
	/^return/.test(textAfter) ||
	              wordIsBlock(lineFirstWord)) {
	            indent = lineIndent;
	          } else if (/(\.|#|:|\[|\*|&|>|~|\+|\/)/.test(ch) || wordIsTag(lineFirstWord)) {
	            if (/\,\s*$/.test(prevLineFirstWord)) {
	              indent = prevLineIndent;
	            } else if (/^\s+/.test(line) && (/(\.|#|:|\[|\*|&|>|~|\+|\/)/.test(prevLineFirstWord) || wordIsTag(prevLineFirstWord))) {
	              indent = lineIndent <= prevLineIndent ? prevLineIndent : prevLineIndent + indentUnit;
	            } else {
	              indent = lineIndent;
	            }
	          } else if (!/,\s*$/.test(line) && (wordIsVendorPrefix(lineFirstWord) || wordIsProperty(lineFirstWord))) {
	            if (wordIsBlock(prevLineFirstWord)) {
	              indent = lineIndent <= prevLineIndent ? prevLineIndent : prevLineIndent + indentUnit;
	            } else if (/^\{/.test(prevLineFirstWord)) {
	              indent = lineIndent <= prevLineIndent ? lineIndent : prevLineIndent + indentUnit;
	            } else if (wordIsVendorPrefix(prevLineFirstWord) || wordIsProperty(prevLineFirstWord)) {
	              indent = lineIndent >= prevLineIndent ? prevLineIndent : lineIndent;
	            } else if (/^(\.|#|:|\[|\*|&|@|\+|\-|>|~|\/)/.test(prevLineFirstWord) ||
	                      /=\s*$/.test(prevLineFirstWord) ||
	                      wordIsTag(prevLineFirstWord) ||
	                      /^\$[\w-\.\[\]\'\"]/.test(prevLineFirstWord)) {
	              indent = prevLineIndent + indentUnit;
	            } else {
	              indent = lineIndent;
	            }
	          }
	        }
	        return indent;
	      },
	      electricChars: "}",
	      lineComment: "//",
	      fold: "indent"
	    };
	  });
	
	  // developer.mozilla.org/en-US/docs/Web/HTML/Element
	  var tagKeywords_ = ["a","abbr","address","area","article","aside","audio", "b", "base","bdi", "bdo","bgsound","blockquote","body","br","button","canvas","caption","cite", "code","col","colgroup","data","datalist","dd","del","details","dfn","div", "dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1", "h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe", "img","input","ins","kbd","keygen","label","legend","li","link","main","map", "mark","marquee","menu","menuitem","meta","meter","nav","nobr","noframes", "noscript","object","ol","optgroup","option","output","p","param","pre", "progress","q","rp","rt","ruby","s","samp","script","section","select", "small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","tr","track", "u","ul","var","video"];
	
	  // github.com/codemirror/CodeMirror/blob/master/mode/css/css.js
	  var documentTypes_ = ["domain", "regexp", "url", "url-prefix"];
	  var mediaTypes_ = ["all","aural","braille","handheld","print","projection","screen","tty","tv","embossed"];
	  var mediaFeatures_ = ["width","min-width","max-width","height","min-height","max-height","device-width","min-device-width","max-device-width","device-height","min-device-height","max-device-height","aspect-ratio","min-aspect-ratio","max-aspect-ratio","device-aspect-ratio","min-device-aspect-ratio","max-device-aspect-ratio","color","min-color","max-color","color-index","min-color-index","max-color-index","monochrome","min-monochrome","max-monochrome","resolution","min-resolution","max-resolution","scan","grid"];
	  var propertyKeywords_ = ["align-content","align-items","align-self","alignment-adjust","alignment-baseline","anchor-point","animation","animation-delay","animation-direction","animation-duration","animation-fill-mode","animation-iteration-count","animation-name","animation-play-state","animation-timing-function","appearance","azimuth","backface-visibility","background","background-attachment","background-clip","background-color","background-image","background-origin","background-position","background-repeat","background-size","baseline-shift","binding","bleed","bookmark-label","bookmark-level","bookmark-state","bookmark-target","border","border-bottom","border-bottom-color","border-bottom-left-radius","border-bottom-right-radius","border-bottom-style","border-bottom-width","border-collapse","border-color","border-image","border-image-outset","border-image-repeat","border-image-slice","border-image-source","border-image-width","border-left","border-left-color","border-left-style","border-left-width","border-radius","border-right","border-right-color","border-right-style","border-right-width","border-spacing","border-style","border-top","border-top-color","border-top-left-radius","border-top-right-radius","border-top-style","border-top-width","border-width","bottom","box-decoration-break","box-shadow","box-sizing","break-after","break-before","break-inside","caption-side","clear","clip","color","color-profile","column-count","column-fill","column-gap","column-rule","column-rule-color","column-rule-style","column-rule-width","column-span","column-width","columns","content","counter-increment","counter-reset","crop","cue","cue-after","cue-before","cursor","direction","display","dominant-baseline","drop-initial-after-adjust","drop-initial-after-align","drop-initial-before-adjust","drop-initial-before-align","drop-initial-size","drop-initial-value","elevation","empty-cells","fit","fit-position","flex","flex-basis","flex-direction","flex-flow","flex-grow","flex-shrink","flex-wrap","float","float-offset","flow-from","flow-into","font","font-feature-settings","font-family","font-kerning","font-language-override","font-size","font-size-adjust","font-stretch","font-style","font-synthesis","font-variant","font-variant-alternates","font-variant-caps","font-variant-east-asian","font-variant-ligatures","font-variant-numeric","font-variant-position","font-weight","grid","grid-area","grid-auto-columns","grid-auto-flow","grid-auto-position","grid-auto-rows","grid-column","grid-column-end","grid-column-start","grid-row","grid-row-end","grid-row-start","grid-template","grid-template-areas","grid-template-columns","grid-template-rows","hanging-punctuation","height","hyphens","icon","image-orientation","image-rendering","image-resolution","inline-box-align","justify-content","left","letter-spacing","line-break","line-height","line-stacking","line-stacking-ruby","line-stacking-shift","line-stacking-strategy","list-style","list-style-image","list-style-position","list-style-type","margin","margin-bottom","margin-left","margin-right","margin-top","marker-offset","marks","marquee-direction","marquee-loop","marquee-play-count","marquee-speed","marquee-style","max-height","max-width","min-height","min-width","move-to","nav-down","nav-index","nav-left","nav-right","nav-up","object-fit","object-position","opacity","order","orphans","outline","outline-color","outline-offset","outline-style","outline-width","overflow","overflow-style","overflow-wrap","overflow-x","overflow-y","padding","padding-bottom","padding-left","padding-right","padding-top","page","page-break-after","page-break-before","page-break-inside","page-policy","pause","pause-after","pause-before","perspective","perspective-origin","pitch","pitch-range","play-during","position","presentation-level","punctuation-trim","quotes","region-break-after","region-break-before","region-break-inside","region-fragment","rendering-intent","resize","rest","rest-after","rest-before","richness","right","rotation","rotation-point","ruby-align","ruby-overhang","ruby-position","ruby-span","shape-image-threshold","shape-inside","shape-margin","shape-outside","size","speak","speak-as","speak-header","speak-numeral","speak-punctuation","speech-rate","stress","string-set","tab-size","table-layout","target","target-name","target-new","target-position","text-align","text-align-last","text-decoration","text-decoration-color","text-decoration-line","text-decoration-skip","text-decoration-style","text-emphasis","text-emphasis-color","text-emphasis-position","text-emphasis-style","text-height","text-indent","text-justify","text-outline","text-overflow","text-shadow","text-size-adjust","text-space-collapse","text-transform","text-underline-position","text-wrap","top","transform","transform-origin","transform-style","transition","transition-delay","transition-duration","transition-property","transition-timing-function","unicode-bidi","vertical-align","visibility","voice-balance","voice-duration","voice-family","voice-pitch","voice-range","voice-rate","voice-stress","voice-volume","volume","white-space","widows","width","will-change","word-break","word-spacing","word-wrap","z-index","clip-path","clip-rule","mask","enable-background","filter","flood-color","flood-opacity","lighting-color","stop-color","stop-opacity","pointer-events","color-interpolation","color-interpolation-filters","color-rendering","fill","fill-opacity","fill-rule","image-rendering","marker","marker-end","marker-mid","marker-start","shape-rendering","stroke","stroke-dasharray","stroke-dashoffset","stroke-linecap","stroke-linejoin","stroke-miterlimit","stroke-opacity","stroke-width","text-rendering","baseline-shift","dominant-baseline","glyph-orientation-horizontal","glyph-orientation-vertical","text-anchor","writing-mode","font-smoothing","osx-font-smoothing"];
	  var nonStandardPropertyKeywords_ = ["scrollbar-arrow-color","scrollbar-base-color","scrollbar-dark-shadow-color","scrollbar-face-color","scrollbar-highlight-color","scrollbar-shadow-color","scrollbar-3d-light-color","scrollbar-track-color","shape-inside","searchfield-cancel-button","searchfield-decoration","searchfield-results-button","searchfield-results-decoration","zoom"];
	  var fontProperties_ = ["font-family","src","unicode-range","font-variant","font-feature-settings","font-stretch","font-weight","font-style"];
	  var colorKeywords_ = ["aliceblue","antiquewhite","aqua","aquamarine","azure","beige","bisque","black","blanchedalmond","blue","blueviolet","brown","burlywood","cadetblue","chartreuse","chocolate","coral","cornflowerblue","cornsilk","crimson","cyan","darkblue","darkcyan","darkgoldenrod","darkgray","darkgreen","darkkhaki","darkmagenta","darkolivegreen","darkorange","darkorchid","darkred","darksalmon","darkseagreen","darkslateblue","darkslategray","darkturquoise","darkviolet","deeppink","deepskyblue","dimgray","dodgerblue","firebrick","floralwhite","forestgreen","fuchsia","gainsboro","ghostwhite","gold","goldenrod","gray","grey","green","greenyellow","honeydew","hotpink","indianred","indigo","ivory","khaki","lavender","lavenderblush","lawngreen","lemonchiffon","lightblue","lightcoral","lightcyan","lightgoldenrodyellow","lightgray","lightgreen","lightpink","lightsalmon","lightseagreen","lightskyblue","lightslategray","lightsteelblue","lightyellow","lime","limegreen","linen","magenta","maroon","mediumaquamarine","mediumblue","mediumorchid","mediumpurple","mediumseagreen","mediumslateblue","mediumspringgreen","mediumturquoise","mediumvioletred","midnightblue","mintcream","mistyrose","moccasin","navajowhite","navy","oldlace","olive","olivedrab","orange","orangered","orchid","palegoldenrod","palegreen","paleturquoise","palevioletred","papayawhip","peachpuff","peru","pink","plum","powderblue","purple","rebeccapurple","red","rosybrown","royalblue","saddlebrown","salmon","sandybrown","seagreen","seashell","sienna","silver","skyblue","slateblue","slategray","snow","springgreen","steelblue","tan","teal","thistle","tomato","turquoise","violet","wheat","white","whitesmoke","yellow","yellowgreen"];
	  var valueKeywords_ = ["above","absolute","activeborder","additive","activecaption","afar","after-white-space","ahead","alias","all","all-scroll","alphabetic","alternate","always","amharic","amharic-abegede","antialiased","appworkspace","arabic-indic","armenian","asterisks","attr","auto","avoid","avoid-column","avoid-page","avoid-region","background","backwards","baseline","below","bidi-override","binary","bengali","blink","block","block-axis","bold","bolder","border","border-box","both","bottom","break","break-all","break-word","bullets","button","button-bevel","buttonface","buttonhighlight","buttonshadow","buttontext","calc","cambodian","capitalize","caps-lock-indicator","caption","captiontext","caret","cell","center","checkbox","circle","cjk-decimal","cjk-earthly-branch","cjk-heavenly-stem","cjk-ideographic","clear","clip","close-quote","col-resize","collapse","column","compact","condensed","contain","content","contents","content-box","context-menu","continuous","copy","counter","counters","cover","crop","cross","crosshair","currentcolor","cursive","cyclic","dashed","decimal","decimal-leading-zero","default","default-button","destination-atop","destination-in","destination-out","destination-over","devanagari","disc","discard","disclosure-closed","disclosure-open","document","dot-dash","dot-dot-dash","dotted","double","down","e-resize","ease","ease-in","ease-in-out","ease-out","element","ellipse","ellipsis","embed","end","ethiopic","ethiopic-abegede","ethiopic-abegede-am-et","ethiopic-abegede-gez","ethiopic-abegede-ti-er","ethiopic-abegede-ti-et","ethiopic-halehame-aa-er","ethiopic-halehame-aa-et","ethiopic-halehame-am-et","ethiopic-halehame-gez","ethiopic-halehame-om-et","ethiopic-halehame-sid-et","ethiopic-halehame-so-et","ethiopic-halehame-ti-er","ethiopic-halehame-ti-et","ethiopic-halehame-tig","ethiopic-numeric","ew-resize","expanded","extends","extra-condensed","extra-expanded","fantasy","fast","fill","fixed","flat","flex","footnotes","forwards","from","geometricPrecision","georgian","graytext","groove","gujarati","gurmukhi","hand","hangul","hangul-consonant","hebrew","help","hidden","hide","higher","highlight","highlighttext","hiragana","hiragana-iroha","horizontal","hsl","hsla","icon","ignore","inactiveborder","inactivecaption","inactivecaptiontext","infinite","infobackground","infotext","inherit","initial","inline","inline-axis","inline-block","inline-flex","inline-table","inset","inside","intrinsic","invert","italic","japanese-formal","japanese-informal","justify","kannada","katakana","katakana-iroha","keep-all","khmer","korean-hangul-formal","korean-hanja-formal","korean-hanja-informal","landscape","lao","large","larger","left","level","lighter","line-through","linear","linear-gradient","lines","list-item","listbox","listitem","local","logical","loud","lower","lower-alpha","lower-armenian","lower-greek","lower-hexadecimal","lower-latin","lower-norwegian","lower-roman","lowercase","ltr","malayalam","match","matrix","matrix3d","media-controls-background","media-current-time-display","media-fullscreen-button","media-mute-button","media-play-button","media-return-to-realtime-button","media-rewind-button","media-seek-back-button","media-seek-forward-button","media-slider","media-sliderthumb","media-time-remaining-display","media-volume-slider","media-volume-slider-container","media-volume-sliderthumb","medium","menu","menulist","menulist-button","menulist-text","menulist-textfield","menutext","message-box","middle","min-intrinsic","mix","mongolian","monospace","move","multiple","myanmar","n-resize","narrower","ne-resize","nesw-resize","no-close-quote","no-drop","no-open-quote","no-repeat","none","normal","not-allowed","nowrap","ns-resize","numbers","numeric","nw-resize","nwse-resize","oblique","octal","open-quote","optimizeLegibility","optimizeSpeed","oriya","oromo","outset","outside","outside-shape","overlay","overline","padding","padding-box","painted","page","paused","persian","perspective","plus-darker","plus-lighter","pointer","polygon","portrait","pre","pre-line","pre-wrap","preserve-3d","progress","push-button","radial-gradient","radio","read-only","read-write","read-write-plaintext-only","rectangle","region","relative","repeat","repeating-linear-gradient","repeating-radial-gradient","repeat-x","repeat-y","reset","reverse","rgb","rgba","ridge","right","rotate","rotate3d","rotateX","rotateY","rotateZ","round","row-resize","rtl","run-in","running","s-resize","sans-serif","scale","scale3d","scaleX","scaleY","scaleZ","scroll","scrollbar","scroll-position","se-resize","searchfield","searchfield-cancel-button","searchfield-decoration","searchfield-results-button","searchfield-results-decoration","semi-condensed","semi-expanded","separate","serif","show","sidama","simp-chinese-formal","simp-chinese-informal","single","skew","skewX","skewY","skip-white-space","slide","slider-horizontal","slider-vertical","sliderthumb-horizontal","sliderthumb-vertical","slow","small","small-caps","small-caption","smaller","solid","somali","source-atop","source-in","source-out","source-over","space","spell-out","square","square-button","start","static","status-bar","stretch","stroke","sub","subpixel-antialiased","super","sw-resize","symbolic","symbols","table","table-caption","table-cell","table-column","table-column-group","table-footer-group","table-header-group","table-row","table-row-group","tamil","telugu","text","text-bottom","text-top","textarea","textfield","thai","thick","thin","threeddarkshadow","threedface","threedhighlight","threedlightshadow","threedshadow","tibetan","tigre","tigrinya-er","tigrinya-er-abegede","tigrinya-et","tigrinya-et-abegede","to","top","trad-chinese-formal","trad-chinese-informal","translate","translate3d","translateX","translateY","translateZ","transparent","ultra-condensed","ultra-expanded","underline","up","upper-alpha","upper-armenian","upper-greek","upper-hexadecimal","upper-latin","upper-norwegian","upper-roman","uppercase","urdu","url","var","vertical","vertical-text","visible","visibleFill","visiblePainted","visibleStroke","visual","w-resize","wait","wave","wider","window","windowframe","windowtext","words","x-large","x-small","xor","xx-large","xx-small","bicubic","optimizespeed","grayscale","row","row-reverse","wrap","wrap-reverse","column-reverse","flex-start","flex-end","space-between","space-around", "unset"];
	
	  var wordOperatorKeywords_ = ["in","and","or","not","is not","is a","is","isnt","defined","if unless"],
	      blockKeywords_ = ["for","if","else","unless", "from", "to"],
	      commonAtoms_ = ["null","true","false","href","title","type","not-allowed","readonly","disabled"],
	      commonDef_ = ["@font-face", "@keyframes", "@media", "@viewport", "@page", "@host", "@supports", "@block", "@css"];
	
	  var hintWords = tagKeywords_.concat(documentTypes_,mediaTypes_,mediaFeatures_,
	                                      propertyKeywords_,nonStandardPropertyKeywords_,
	                                      colorKeywords_,valueKeywords_,fontProperties_,
	                                      wordOperatorKeywords_,blockKeywords_,
	                                      commonAtoms_,commonDef_);
	
	  function wordRegexp(words) {
	    words = words.sort(function(a,b){return b > a;});
	    return new RegExp("^((" + words.join(")|(") + "))\\b");
	  }
	
	  function keySet(array) {
	    var keys = {};
	    for (var i = 0; i < array.length; ++i) keys[array[i]] = true;
	    return keys;
	  }
	
	  function escapeRegExp(text) {
	    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
	  }
	
	  CodeMirror.registerHelper("hintWords", "stylus", hintWords);
	  CodeMirror.defineMIME("text/x-styl", "stylus");
	});


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("yaml", function() {
	
	  var cons = ['true', 'false', 'on', 'off', 'yes', 'no'];
	  var keywordRegex = new RegExp("\\b(("+cons.join(")|(")+"))$", 'i');
	
	  return {
	    token: function(stream, state) {
	      var ch = stream.peek();
	      var esc = state.escaped;
	      state.escaped = false;
	      /* comments */
	      if (ch == "#" && (stream.pos == 0 || /\s/.test(stream.string.charAt(stream.pos - 1)))) {
	        stream.skipToEnd();
	        return "comment";
	      }
	
	      if (stream.match(/^('([^']|\\.)*'?|"([^"]|\\.)*"?)/))
	        return "string";
	
	      if (state.literal && stream.indentation() > state.keyCol) {
	        stream.skipToEnd(); return "string";
	      } else if (state.literal) { state.literal = false; }
	      if (stream.sol()) {
	        state.keyCol = 0;
	        state.pair = false;
	        state.pairStart = false;
	        /* document start */
	        if(stream.match(/---/)) { return "def"; }
	        /* document end */
	        if (stream.match(/\.\.\./)) { return "def"; }
	        /* array list item */
	        if (stream.match(/\s*-\s+/)) { return 'meta'; }
	      }
	      /* inline pairs/lists */
	      if (stream.match(/^(\{|\}|\[|\])/)) {
	        if (ch == '{')
	          state.inlinePairs++;
	        else if (ch == '}')
	          state.inlinePairs--;
	        else if (ch == '[')
	          state.inlineList++;
	        else
	          state.inlineList--;
	        return 'meta';
	      }
	
	      /* list seperator */
	      if (state.inlineList > 0 && !esc && ch == ',') {
	        stream.next();
	        return 'meta';
	      }
	      /* pairs seperator */
	      if (state.inlinePairs > 0 && !esc && ch == ',') {
	        state.keyCol = 0;
	        state.pair = false;
	        state.pairStart = false;
	        stream.next();
	        return 'meta';
	      }
	
	      /* start of value of a pair */
	      if (state.pairStart) {
	        /* block literals */
	        if (stream.match(/^\s*(\||\>)\s*/)) { state.literal = true; return 'meta'; };
	        /* references */
	        if (stream.match(/^\s*(\&|\*)[a-z0-9\._-]+\b/i)) { return 'variable-2'; }
	        /* numbers */
	        if (state.inlinePairs == 0 && stream.match(/^\s*-?[0-9\.\,]+\s?$/)) { return 'number'; }
	        if (state.inlinePairs > 0 && stream.match(/^\s*-?[0-9\.\,]+\s?(?=(,|}))/)) { return 'number'; }
	        /* keywords */
	        if (stream.match(keywordRegex)) { return 'keyword'; }
	      }
	
	      /* pairs (associative arrays) -> key */
	      if (!state.pair && stream.match(/^\s*(?:[,\[\]{}&*!|>'"%@`][^\s'":]|[^,\[\]{}#&*!|>'"%@`])[^#]*?(?=\s*:($|\s))/)) {
	        state.pair = true;
	        state.keyCol = stream.indentation();
	        return "atom";
	      }
	      if (state.pair && stream.match(/^:\s*/)) { state.pairStart = true; return 'meta'; }
	
	      /* nothing found, continue */
	      state.pairStart = false;
	      state.escaped = (ch == '\\');
	      stream.next();
	      return null;
	    },
	    startState: function() {
	      return {
	        pair: false,
	        pairStart: false,
	        keyCol: 0,
	        inlinePairs: 0,
	        inlineList: 0,
	        literal: false,
	        escaped: false
	      };
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/x-yaml", "yaml");
	CodeMirror.defineMIME("text/yaml", "yaml");
	
	});


/***/ },
/* 90 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(30)
	  , document = __webpack_require__(7).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(7)
	  , core      = __webpack_require__(28)
	  , ctx       = __webpack_require__(261)
	  , hide      = __webpack_require__(14)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(13) && !__webpack_require__(29)(function(){
	  return Object.defineProperty(__webpack_require__(91)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(50)
	  , $export        = __webpack_require__(92)
	  , redefine       = __webpack_require__(99)
	  , hide           = __webpack_require__(14)
	  , has            = __webpack_require__(9)
	  , Iterators      = __webpack_require__(49)
	  , $iterCreate    = __webpack_require__(266)
	  , setToStringTag = __webpack_require__(52)
	  , getPrototypeOf = __webpack_require__(273)
	  , ITERATOR       = __webpack_require__(16)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(27)
	  , dPs         = __webpack_require__(270)
	  , enumBugKeys = __webpack_require__(48)
	  , IE_PROTO    = __webpack_require__(53)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(91)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(263).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(98)
	  , hiddenKeys = __webpack_require__(48).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ },
/* 97 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(9)
	  , toIObject    = __webpack_require__(10)
	  , arrayIndexOf = __webpack_require__(260)(false)
	  , IE_PROTO     = __webpack_require__(53)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(14);

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(1358)
	
	var md5 = toConstructor(__webpack_require__(288))
	var rmd160 = toConstructor(__webpack_require__(1354))
	
	function toConstructor (fn) {
	  return function () {
	    var buffers = []
	    var m= {
	      update: function (data, enc) {
	        if(!Buffer.isBuffer(data)) data = new Buffer(data, enc)
	        buffers.push(data)
	        return this
	      },
	      digest: function (enc) {
	        var buf = Buffer.concat(buffers)
	        var r = fn(buf)
	        buffers = null
	        return enc ? r.toString(enc) : r
	      }
	    }
	    return m
	  }
	}
	
	module.exports = function (alg) {
	  if('md5' === alg) return new md5()
	  if('rmd160' === alg) return new rmd160()
	  return createHash(alg)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(34);
	
	function get(obj, path) {
	  var hash = path.split('#')[1];
	
	  var parts = hash.split('/').slice(1);
	
	  while (parts.length) {
	    var key = decodeURIComponent(parts.shift()).replace(/~1/g, '/').replace(/~0/g, '~');
	
	    if (typeof obj[key] === 'undefined') {
	      throw new Error('JSON pointer not found: ' + path);
	    }
	
	    obj = obj[key];
	  }
	
	  return obj;
	}
	
	var find = module.exports = function(id, refs) {
	  var target = refs[id] || refs[id.split('#')[1]] || refs[$.getDocumentURI(id)];
	
	  if (target) {
	    target = id.indexOf('#/') > -1 ? get(target, id) : target;
	  } else {
	    for (var key in refs) {
	      if ($.resolveURL(refs[key].id, id) === refs[key].id) {
	        target = refs[key];
	        break;
	      }
	    }
	  }
	
	  if (!target) {
	    throw new Error('Reference not found: ' + id);
	  }
	
	  while (target.$ref) {
	    target = find(target.$ref, refs);
	  }
	
	  return target;
	};


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var mersenne = __webpack_require__(1312);
	
	/**
	 *
	 * @namespace faker.random
	 */
	function Random (faker, seed) {
	  // Use a user provided seed if it exists
	  if (seed) {
	    if (Array.isArray(seed) && seed.length) {
	      mersenne.seed_array(seed);
	    }
	    else {
	      mersenne.seed(seed);
	    }
	  }
	  /**
	   * returns a single random number based on a max number or range
	   *
	   * @method faker.random.number
	   * @param {mixed} options
	   */
	  this.number = function (options) {
	
	    if (typeof options === "number") {
	      options = {
	        max: options
	      };
	    }
	
	    options = options || {};
	
	    if (typeof options.min === "undefined") {
	      options.min = 0;
	    }
	
	    if (typeof options.max === "undefined") {
	      options.max = 99999;
	    }
	    if (typeof options.precision === "undefined") {
	      options.precision = 1;
	    }
	
	    // Make the range inclusive of the max value
	    var max = options.max;
	    if (max >= 0) {
	      max += options.precision;
	    }
	
	    var randomNumber = options.precision * Math.floor(
	      mersenne.rand(max / options.precision, options.min / options.precision));
	
	    return randomNumber;
	
	  }
	
	  /**
	   * takes an array and returns a random element of the array
	   *
	   * @method faker.random.arrayElement
	   * @param {array} array
	   */
	  this.arrayElement = function (array) {
	      array = array || ["a", "b", "c"];
	      var r = faker.random.number({ max: array.length - 1 });
	      return array[r];
	  }
	
	  /**
	   * takes an object and returns the randomly key or value
	   *
	   * @method faker.random.objectElement
	   * @param {object} object
	   * @param {mixed} field
	   */
	  this.objectElement = function (object, field) {
	      object = object || { "foo": "bar", "too": "car" };
	      var array = Object.keys(object);
	      var key = faker.random.arrayElement(array);
	
	      return field === "key" ? key : object[key];
	  }
	
	  /**
	   * uuid
	   *
	   * @method faker.random.uuid
	   */
	  this.uuid = function () {
	      var self = this;
	      var RFC4122_TEMPLATE = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
	      var replacePlaceholders = function (placeholder) {
	          var random = self.number({ min: 0, max: 15 });
	          var value = placeholder == 'x' ? random : (random &0x3 | 0x8);
	          return value.toString(16);
	      };
	      return RFC4122_TEMPLATE.replace(/[xy]/g, replacePlaceholders);
	  }
	
	  /**
	   * boolean
	   *
	   * @method faker.random.boolean
	   */
	  this.boolean = function () {
	      return !!faker.random.number(1)
	  }
	
	  // TODO: have ability to return specific type of word? As in: noun, adjective, verb, etc
	  /**
	   * word
	   *
	   * @method faker.random.word
	   * @param {string} type
	   */
	  this.word = function randomWord (type) {
	
	    var wordMethods = [
	    'commerce.department',
	    'commerce.productName',
	    'commerce.productAdjective',
	    'commerce.productMaterial',
	    'commerce.product',
	    'commerce.color',
	
	    'company.catchPhraseAdjective',
	    'company.catchPhraseDescriptor',
	    'company.catchPhraseNoun',
	    'company.bsAdjective',
	    'company.bsBuzz',
	    'company.bsNoun',
	    'address.streetSuffix',
	    'address.county',
	    'address.country',
	    'address.state',
	
	    'finance.accountName',
	    'finance.transactionType',
	    'finance.currencyName',
	
	    'hacker.noun',
	    'hacker.verb',
	    'hacker.adjective',
	    'hacker.ingverb',
	    'hacker.abbreviation',
	
	    'name.jobDescriptor',
	    'name.jobArea',
	    'name.jobType'];
	
	    // randomly pick from the many faker methods that can generate words
	    var randomWordMethod = faker.random.arrayElement(wordMethods);
	    return faker.fake('{{' + randomWordMethod + '}}');
	
	  }
	
	  /**
	   * randomWords
	   *
	   * @method faker.random.words
	   * @param {number} count defaults to a random value between 1 and 3
	   */
	  this.words = function randomWords (count) {
	    var words = [];
	    if (typeof count === "undefined") {
	      count = faker.random.number({min:1, max: 3});
	    }
	    for (var i = 0; i<count; i++) {
	      words.push(faker.random.word());
	    }
	    return words.join(' ');
	  }
	
	  /**
	   * locale
	   *
	   * @method faker.random.image
	   */
	  this.image = function randomImage () {
	    return faker.image.image();
	  }
	
	  /**
	   * locale
	   *
	   * @method faker.random.locale
	   */
	  this.locale = function randomLocale () {
	    return faker.random.arrayElement(Object.keys(faker.locales));
	  };
	
	  /**
	   * alphaNumeric
	   *
	   * @method faker.random.alphaNumeric
	   */
	  this.alphaNumeric = function alphaNumeric() {
	    return faker.random.arrayElement(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"]);
	  }
	
	  return this;
	
	}
	
	module['exports'] = Random;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 103 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Registry = __webpack_require__(105);
	// instantiate
	var registry = new Registry();
	/**
	 * Custom format API
	 *
	 * @see https://github.com/json-schema-faker/json-schema-faker#custom-formats
	 * @param nameOrFormatMap
	 * @param callback
	 * @returns {any}
	 */
	function formatAPI(nameOrFormatMap, callback) {
	    if (typeof nameOrFormatMap === 'undefined') {
	        return registry.list();
	    }
	    else if (typeof nameOrFormatMap === 'string') {
	        if (typeof callback === 'function') {
	            registry.register(nameOrFormatMap, callback);
	        }
	        else {
	            return registry.get(nameOrFormatMap);
	        }
	    }
	    else {
	        registry.registerMany(nameOrFormatMap);
	    }
	}
	module.exports = formatAPI;


/***/ },
/* 105 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * This class defines a registry for custom formats used within JSF.
	 */
	var Registry = (function () {
	    function Registry() {
	        // empty by default
	        this.data = {};
	    }
	    /**
	     * Registers custom format
	     */
	    Registry.prototype.register = function (name, callback) {
	        this.data[name] = callback;
	    };
	    /**
	     * Register many formats at one shot
	     */
	    Registry.prototype.registerMany = function (formats) {
	        for (var name in formats) {
	            this.data[name] = formats[name];
	        }
	    };
	    /**
	     * Returns element by registry key
	     */
	    Registry.prototype.get = function (name) {
	        var format = this.data[name];
	        if (typeof format === 'undefined') {
	            throw new Error('unknown registry key ' + JSON.stringify(name));
	        }
	        return format;
	    };
	    /**
	     * Returns the whole registry content
	     */
	    Registry.prototype.list = function () {
	        return this.data;
	    };
	    return Registry;
	}());
	module.exports = Registry;


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var random = __webpack_require__(6);
	var LIPSUM_WORDS = ('Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod tempor incididunt ut labore'
	    + ' et dolore magna aliqua Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea'
	    + ' commodo consequat Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla'
	    + ' pariatur Excepteur sint occaecat cupidatat non proident sunt in culpa qui officia deserunt mollit anim id est'
	    + ' laborum').split(' ');
	/**
	 * Generates randomized array of single lorem ipsum words.
	 *
	 * @param length
	 * @returns {Array.<string>}
	 */
	function wordsGenerator(length) {
	    var words = random.shuffle(LIPSUM_WORDS);
	    return words.slice(0, length);
	}
	module.exports = wordsGenerator;


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var random = __webpack_require__(6);
	var MIN_INTEGER = -100000000, MAX_INTEGER = 100000000;
	var numberType = function numberType(value) {
	    var min = typeof value.minimum === 'undefined' ? MIN_INTEGER : value.minimum, max = typeof value.maximum === 'undefined' ? MAX_INTEGER : value.maximum, multipleOf = value.multipleOf;
	    if (multipleOf) {
	        max = Math.floor(max / multipleOf) * multipleOf;
	        min = Math.ceil(min / multipleOf) * multipleOf;
	    }
	    if (value.exclusiveMinimum && value.minimum && min === value.minimum) {
	        min += multipleOf || 1;
	    }
	    if (value.exclusiveMaximum && value.maximum && max === value.maximum) {
	        max -= multipleOf || 1;
	    }
	    if (min > max) {
	        return NaN;
	    }
	    if (multipleOf) {
	        return Math.floor(random.number(min, max) / multipleOf) * multipleOf;
	    }
	    return random.number(min, max, undefined, undefined, true);
	};
	module.exports = numberType;


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(62);
	
	/*<replacement>*/
	var util = __webpack_require__(23);
	util.inherits = __webpack_require__(4);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	module.exports = Readable;
	
	/*<replacement>*/
	var processNextTick = __webpack_require__(61);
	/*</replacement>*/
	
	/*<replacement>*/
	var isArray = __webpack_require__(103);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(35).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream;
	(function () {
	  try {
	    Stream = __webpack_require__(38);
	  } catch (_) {} finally {
	    if (!Stream) Stream = __webpack_require__(35).EventEmitter;
	  }
	})();
	/*</replacement>*/
	
	var Buffer = __webpack_require__(3).Buffer;
	/*<replacement>*/
	var bufferShim = __webpack_require__(42);
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(23);
	util.inherits = __webpack_require__(4);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(1375);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(1346);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') {
	    return emitter.prependListener(event, fn);
	  } else {
	    // This is a hack to make sure that our error handler is attached before any
	    // userland ones.  NEVER DO THIS. This is here only because this code needs
	    // to continue to work with older versions of Node.js that do not include
	    // the prependListener() method. The goal is to eventually remove this hack.
	    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	  }
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(11);
	
	  options = options || {};
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = ~ ~this.highWaterMark;
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // when piping, we only care about 'readable' events that happen
	  // after read()ing all the bytes and not getting any pushback.
	  this.ranOut = false;
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(111).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(11);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options && typeof options.read === 'function') this._read = options.read;
	
	  Stream.call(this);
	}
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	
	  if (!state.objectMode && typeof chunk === 'string') {
	    encoding = encoding || state.defaultEncoding;
	    if (encoding !== state.encoding) {
	      chunk = bufferShim.from(chunk, encoding);
	      encoding = '';
	    }
	  }
	
	  return readableAddChunk(this, state, chunk, encoding, false);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  var state = this._readableState;
	  return readableAddChunk(this, state, chunk, '', true);
	};
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	function readableAddChunk(stream, state, chunk, encoding, addToFront) {
	  var er = chunkInvalid(state, chunk);
	  if (er) {
	    stream.emit('error', er);
	  } else if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else if (state.objectMode || chunk && chunk.length > 0) {
	    if (state.ended && !addToFront) {
	      var e = new Error('stream.push() after EOF');
	      stream.emit('error', e);
	    } else if (state.endEmitted && addToFront) {
	      var _e = new Error('stream.unshift() after end event');
	      stream.emit('error', _e);
	    } else {
	      var skipAdd;
	      if (state.decoder && !addToFront && !encoding) {
	        chunk = state.decoder.write(chunk);
	        skipAdd = !state.objectMode && chunk.length === 0;
	      }
	
	      if (!addToFront) state.reading = false;
	
	      // Don't add to the buffer if we've decoded to an empty string chunk and
	      // we're not in object mode
	      if (!skipAdd) {
	        // if we want the data now, just emit it.
	        if (state.flowing && state.length === 0 && !state.sync) {
	          stream.emit('data', chunk);
	          stream.read(0);
	        } else {
	          // update the buffer info.
	          state.length += state.objectMode ? 1 : chunk.length;
	          if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	          if (state.needReadable) emitReadable(stream);
	        }
	      }
	
	      maybeReadMore(stream, state);
	    }
	  } else if (!addToFront) {
	    state.reading = false;
	  }
	
	  return needMoreData(state);
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(111).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function chunkInvalid(state, chunk) {
	  var er = null;
	  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    processNextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : cleanup;
	  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable) {
	    debug('onunpipe');
	    if (readable === src) {
	      cleanup();
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', cleanup);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        processNextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this, state);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    processNextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var state = this._readableState;
	  var paused = false;
	
	  var self = this;
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) self.push(chunk);
	    }
	
	    self.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
	  forEach(events, function (ev) {
	    stream.on(ev, self.emit.bind(self, ev));
	  });
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return self;
	};
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = bufferShim.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    processNextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var types = __webpack_require__(37);
	
	var INTS = function() {
	 return [{ type: types.RANGE , from: 48, to: 57 }];
	};
	
	var WORDS = function() {
	 return [
	    { type: types.CHAR, value: 95 },
	    { type: types.RANGE, from: 97, to: 122 },
	    { type: types.RANGE, from: 65, to: 90 }
	  ].concat(INTS());
	};
	
	var WHITESPACE = function() {
	 return [
	    { type: types.CHAR, value: 9 },
	    { type: types.CHAR, value: 10 },
	    { type: types.CHAR, value: 11 },
	    { type: types.CHAR, value: 12 },
	    { type: types.CHAR, value: 13 },
	    { type: types.CHAR, value: 32 },
	    { type: types.CHAR, value: 160 },
	    { type: types.CHAR, value: 5760 },
	    { type: types.CHAR, value: 6158 },
	    { type: types.CHAR, value: 8192 },
	    { type: types.CHAR, value: 8193 },
	    { type: types.CHAR, value: 8194 },
	    { type: types.CHAR, value: 8195 },
	    { type: types.CHAR, value: 8196 },
	    { type: types.CHAR, value: 8197 },
	    { type: types.CHAR, value: 8198 },
	    { type: types.CHAR, value: 8199 },
	    { type: types.CHAR, value: 8200 },
	    { type: types.CHAR, value: 8201 },
	    { type: types.CHAR, value: 8202 },
	    { type: types.CHAR, value: 8232 },
	    { type: types.CHAR, value: 8233 },
	    { type: types.CHAR, value: 8239 },
	    { type: types.CHAR, value: 8287 },
	    { type: types.CHAR, value: 12288 },
	    { type: types.CHAR, value: 65279 }
	  ];
	};
	
	var NOTANYCHAR = function() {
	  return [
	    { type: types.CHAR, value: 10 },
	    { type: types.CHAR, value: 13 },
	    { type: types.CHAR, value: 8232 },
	    { type: types.CHAR, value: 8233 },
	  ];
	};
	
	// Predefined class objects.
	exports.words = function() {
	  return { type: types.SET, set: WORDS(), not: false };
	};
	
	exports.notWords = function() {
	  return { type: types.SET, set: WORDS(), not: true };
	};
	
	exports.ints = function() {
	  return { type: types.SET, set: INTS(), not: false };
	};
	
	exports.notInts = function() {
	  return { type: types.SET, set: INTS(), not: true };
	};
	
	exports.whitespace = function() {
	  return { type: types.SET, set: WHITESPACE(), not: false };
	};
	
	exports.notWhitespace = function() {
	  return { type: types.SET, set: WHITESPACE(), not: true };
	};
	
	exports.anyChar = function() {
	  return { type: types.SET, set: NOTANYCHAR(), not: true };
	};


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Buffer = __webpack_require__(3).Buffer;
	
	var isBufferEncoding = Buffer.isEncoding
	  || function(encoding) {
	       switch (encoding && encoding.toLowerCase()) {
	         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
	         default: return false;
	       }
	     }
	
	
	function assertEncoding(encoding) {
	  if (encoding && !isBufferEncoding(encoding)) {
	    throw new Error('Unknown encoding: ' + encoding);
	  }
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters. CESU-8 is handled as part of the UTF-8 encoding.
	//
	// @TODO Handling all encodings inside a single object makes it very difficult
	// to reason about this code, so it should be split up in the future.
	// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
	// points as used by CESU-8.
	var StringDecoder = exports.StringDecoder = function(encoding) {
	  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
	  assertEncoding(encoding);
	  switch (this.encoding) {
	    case 'utf8':
	      // CESU-8 represents each of Surrogate Pair by 3-bytes
	      this.surrogateSize = 3;
	      break;
	    case 'ucs2':
	    case 'utf16le':
	      // UTF-16 represents each of Surrogate Pair by 2-bytes
	      this.surrogateSize = 2;
	      this.detectIncompleteChar = utf16DetectIncompleteChar;
	      break;
	    case 'base64':
	      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
	      this.surrogateSize = 3;
	      this.detectIncompleteChar = base64DetectIncompleteChar;
	      break;
	    default:
	      this.write = passThroughWrite;
	      return;
	  }
	
	  // Enough space to store all bytes of a single character. UTF-8 needs 4
	  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
	  this.charBuffer = new Buffer(6);
	  // Number of bytes received for the current incomplete multi-byte character.
	  this.charReceived = 0;
	  // Number of bytes expected for the current incomplete multi-byte character.
	  this.charLength = 0;
	};
	
	
	// write decodes the given buffer and returns it as JS string that is
	// guaranteed to not contain any partial multi-byte characters. Any partial
	// character found at the end of the buffer is buffered up, and will be
	// returned when calling write again with the remaining bytes.
	//
	// Note: Converting a Buffer containing an orphan surrogate to a String
	// currently works, but converting a String to a Buffer (via `new Buffer`, or
	// Buffer#write) will replace incomplete surrogates with the unicode
	// replacement character. See https://codereview.chromium.org/121173009/ .
	StringDecoder.prototype.write = function(buffer) {
	  var charStr = '';
	  // if our last write ended with an incomplete multibyte character
	  while (this.charLength) {
	    // determine how many remaining bytes this buffer has to offer for this char
	    var available = (buffer.length >= this.charLength - this.charReceived) ?
	        this.charLength - this.charReceived :
	        buffer.length;
	
	    // add the new bytes to the char buffer
	    buffer.copy(this.charBuffer, this.charReceived, 0, available);
	    this.charReceived += available;
	
	    if (this.charReceived < this.charLength) {
	      // still not enough chars in this buffer? wait for more ...
	      return '';
	    }
	
	    // remove bytes belonging to the current character from the buffer
	    buffer = buffer.slice(available, buffer.length);
	
	    // get the character that was split
	    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
	
	    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	    var charCode = charStr.charCodeAt(charStr.length - 1);
	    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	      this.charLength += this.surrogateSize;
	      charStr = '';
	      continue;
	    }
	    this.charReceived = this.charLength = 0;
	
	    // if there are no more bytes in this buffer, just emit our char
	    if (buffer.length === 0) {
	      return charStr;
	    }
	    break;
	  }
	
	  // determine and set charLength / charReceived
	  this.detectIncompleteChar(buffer);
	
	  var end = buffer.length;
	  if (this.charLength) {
	    // buffer the incomplete character bytes we got
	    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
	    end -= this.charReceived;
	  }
	
	  charStr += buffer.toString(this.encoding, 0, end);
	
	  var end = charStr.length - 1;
	  var charCode = charStr.charCodeAt(end);
	  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	    var size = this.surrogateSize;
	    this.charLength += size;
	    this.charReceived += size;
	    this.charBuffer.copy(this.charBuffer, size, 0, size);
	    buffer.copy(this.charBuffer, 0, 0, size);
	    return charStr.substring(0, end);
	  }
	
	  // or just emit the charStr
	  return charStr;
	};
	
	// detectIncompleteChar determines if there is an incomplete UTF-8 character at
	// the end of the given buffer. If so, it sets this.charLength to the byte
	// length that character, and sets this.charReceived to the number of bytes
	// that are available for this character.
	StringDecoder.prototype.detectIncompleteChar = function(buffer) {
	  // determine how many bytes we have to check at the end of this buffer
	  var i = (buffer.length >= 3) ? 3 : buffer.length;
	
	  // Figure out if one of the last i bytes of our buffer announces an
	  // incomplete char.
	  for (; i > 0; i--) {
	    var c = buffer[buffer.length - i];
	
	    // See http://en.wikipedia.org/wiki/UTF-8#Description
	
	    // 110XXXXX
	    if (i == 1 && c >> 5 == 0x06) {
	      this.charLength = 2;
	      break;
	    }
	
	    // 1110XXXX
	    if (i <= 2 && c >> 4 == 0x0E) {
	      this.charLength = 3;
	      break;
	    }
	
	    // 11110XXX
	    if (i <= 3 && c >> 3 == 0x1E) {
	      this.charLength = 4;
	      break;
	    }
	  }
	  this.charReceived = i;
	};
	
	StringDecoder.prototype.end = function(buffer) {
	  var res = '';
	  if (buffer && buffer.length)
	    res = this.write(buffer);
	
	  if (this.charReceived) {
	    var cr = this.charReceived;
	    var buf = this.charBuffer;
	    var enc = this.encoding;
	    res += buf.slice(0, cr).toString(enc);
	  }
	
	  return res;
	};
	
	function passThroughWrite(buffer) {
	  return buffer.toString(this.encoding);
	}
	
	function utf16DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 2;
	  this.charLength = this.charReceived ? 2 : 0;
	}
	
	function base64DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 3;
	  this.charLength = this.charReceived ? 3 : 0;
	}


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function normalizeComponent (
	  name,
	  scriptExports,
	  compiledTemplate,
	  scopeId,
	  cssModules
	) {
	  scriptExports = scriptExports || {}
	
	  // ES6 modules interop
	  var type = typeof scriptExports.default
	  if (type === 'object' || type === 'function') {
	    // check named exports
	    if (false) {
	      if (Object.keys(scriptExports).some(function (key) {
	        return key !== 'default' && key !== '__esModule'
	      })) {
	        console.error('named exports are not supported in *.vue files.')
	      }
	    }
	    scriptExports = scriptExports.default
	  }
	
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // default name option based on filename
	  if (options.name == null) {
	    options.name = name
	  }
	
	  // render functions
	  if (compiledTemplate) {
	    options.render = compiledTemplate.render
	    options.staticRenderFns = compiledTemplate.staticRenderFns
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = scopeId
	  }
	
	  // inject cssModules
	  if (cssModules) {
	    var computed = options.computed || (options.computed = {})
	    Object.keys(cssModules).forEach(function (key) {
	      var module = cssModules[key]
	      computed[key] = function () { return module }
	    })
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * Vue.js v2.1.10
	 * (c) 2014-2017 Evan You
	 * Released under the MIT License.
	 */
	'use strict';
	
	/*  */
	
	/**
	 * Convert a value to a string that is actually rendered.
	 */
	function _toString (val) {
	  return val == null
	    ? ''
	    : typeof val === 'object'
	      ? JSON.stringify(val, null, 2)
	      : String(val)
	}
	
	/**
	 * Convert a input value to a number for persistence.
	 * If the conversion fails, return original string.
	 */
	function toNumber (val) {
	  var n = parseFloat(val);
	  return isNaN(n) ? val : n
	}
	
	/**
	 * Make a map and return a function for checking if a key
	 * is in that map.
	 */
	function makeMap (
	  str,
	  expectsLowerCase
	) {
	  var map = Object.create(null);
	  var list = str.split(',');
	  for (var i = 0; i < list.length; i++) {
	    map[list[i]] = true;
	  }
	  return expectsLowerCase
	    ? function (val) { return map[val.toLowerCase()]; }
	    : function (val) { return map[val]; }
	}
	
	/**
	 * Check if a tag is a built-in tag.
	 */
	var isBuiltInTag = makeMap('slot,component', true);
	
	/**
	 * Remove an item from an array
	 */
	function remove$1 (arr, item) {
	  if (arr.length) {
	    var index = arr.indexOf(item);
	    if (index > -1) {
	      return arr.splice(index, 1)
	    }
	  }
	}
	
	/**
	 * Check whether the object has the property.
	 */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwn (obj, key) {
	  return hasOwnProperty.call(obj, key)
	}
	
	/**
	 * Check if value is primitive
	 */
	function isPrimitive (value) {
	  return typeof value === 'string' || typeof value === 'number'
	}
	
	/**
	 * Create a cached version of a pure function.
	 */
	function cached (fn) {
	  var cache = Object.create(null);
	  return (function cachedFn (str) {
	    var hit = cache[str];
	    return hit || (cache[str] = fn(str))
	  })
	}
	
	/**
	 * Camelize a hyphen-delimited string.
	 */
	var camelizeRE = /-(\w)/g;
	var camelize = cached(function (str) {
	  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
	});
	
	/**
	 * Capitalize a string.
	 */
	var capitalize = cached(function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1)
	});
	
	/**
	 * Hyphenate a camelCase string.
	 */
	var hyphenateRE = /([^-])([A-Z])/g;
	var hyphenate = cached(function (str) {
	  return str
	    .replace(hyphenateRE, '$1-$2')
	    .replace(hyphenateRE, '$1-$2')
	    .toLowerCase()
	});
	
	/**
	 * Simple bind, faster than native
	 */
	function bind$1 (fn, ctx) {
	  function boundFn (a) {
	    var l = arguments.length;
	    return l
	      ? l > 1
	        ? fn.apply(ctx, arguments)
	        : fn.call(ctx, a)
	      : fn.call(ctx)
	  }
	  // record original fn length
	  boundFn._length = fn.length;
	  return boundFn
	}
	
	/**
	 * Convert an Array-like object to a real Array.
	 */
	function toArray (list, start) {
	  start = start || 0;
	  var i = list.length - start;
	  var ret = new Array(i);
	  while (i--) {
	    ret[i] = list[i + start];
	  }
	  return ret
	}
	
	/**
	 * Mix properties into target object.
	 */
	function extend (to, _from) {
	  for (var key in _from) {
	    to[key] = _from[key];
	  }
	  return to
	}
	
	/**
	 * Quick object check - this is primarily used to tell
	 * Objects from primitive values when we know the value
	 * is a JSON-compliant type.
	 */
	function isObject (obj) {
	  return obj !== null && typeof obj === 'object'
	}
	
	/**
	 * Strict object type check. Only returns true
	 * for plain JavaScript objects.
	 */
	var toString = Object.prototype.toString;
	var OBJECT_STRING = '[object Object]';
	function isPlainObject (obj) {
	  return toString.call(obj) === OBJECT_STRING
	}
	
	/**
	 * Merge an Array of Objects into a single Object.
	 */
	function toObject (arr) {
	  var res = {};
	  for (var i = 0; i < arr.length; i++) {
	    if (arr[i]) {
	      extend(res, arr[i]);
	    }
	  }
	  return res
	}
	
	/**
	 * Perform no operation.
	 */
	function noop () {}
	
	/**
	 * Always return false.
	 */
	var no = function () { return false; };
	
	/**
	 * Return same value
	 */
	var identity = function (_) { return _; };
	
	/**
	 * Generate a static keys string from compiler modules.
	 */
	function genStaticKeys (modules) {
	  return modules.reduce(function (keys, m) {
	    return keys.concat(m.staticKeys || [])
	  }, []).join(',')
	}
	
	/**
	 * Check if two values are loosely equal - that is,
	 * if they are plain objects, do they have the same shape?
	 */
	function looseEqual (a, b) {
	  var isObjectA = isObject(a);
	  var isObjectB = isObject(b);
	  if (isObjectA && isObjectB) {
	    return JSON.stringify(a) === JSON.stringify(b)
	  } else if (!isObjectA && !isObjectB) {
	    return String(a) === String(b)
	  } else {
	    return false
	  }
	}
	
	function looseIndexOf (arr, val) {
	  for (var i = 0; i < arr.length; i++) {
	    if (looseEqual(arr[i], val)) { return i }
	  }
	  return -1
	}
	
	/*  */
	
	var config = {
	  /**
	   * Option merge strategies (used in core/util/options)
	   */
	  optionMergeStrategies: Object.create(null),
	
	  /**
	   * Whether to suppress warnings.
	   */
	  silent: false,
	
	  /**
	   * Whether to enable devtools
	   */
	  devtools: ("production") !== 'production',
	
	  /**
	   * Error handler for watcher errors
	   */
	  errorHandler: null,
	
	  /**
	   * Ignore certain custom elements
	   */
	  ignoredElements: [],
	
	  /**
	   * Custom user key aliases for v-on
	   */
	  keyCodes: Object.create(null),
	
	  /**
	   * Check if a tag is reserved so that it cannot be registered as a
	   * component. This is platform-dependent and may be overwritten.
	   */
	  isReservedTag: no,
	
	  /**
	   * Check if a tag is an unknown element.
	   * Platform-dependent.
	   */
	  isUnknownElement: no,
	
	  /**
	   * Get the namespace of an element
	   */
	  getTagNamespace: noop,
	
	  /**
	   * Parse the real tag name for the specific platform.
	   */
	  parsePlatformTagName: identity,
	
	  /**
	   * Check if an attribute must be bound using property, e.g. value
	   * Platform-dependent.
	   */
	  mustUseProp: no,
	
	  /**
	   * List of asset types that a component can own.
	   */
	  _assetTypes: [
	    'component',
	    'directive',
	    'filter'
	  ],
	
	  /**
	   * List of lifecycle hooks.
	   */
	  _lifecycleHooks: [
	    'beforeCreate',
	    'created',
	    'beforeMount',
	    'mounted',
	    'beforeUpdate',
	    'updated',
	    'beforeDestroy',
	    'destroyed',
	    'activated',
	    'deactivated'
	  ],
	
	  /**
	   * Max circular updates allowed in a scheduler flush cycle.
	   */
	  _maxUpdateCount: 100
	};
	
	/*  */
	
	/**
	 * Check if a string starts with $ or _
	 */
	function isReserved (str) {
	  var c = (str + '').charCodeAt(0);
	  return c === 0x24 || c === 0x5F
	}
	
	/**
	 * Define a property.
	 */
	function def (obj, key, val, enumerable) {
	  Object.defineProperty(obj, key, {
	    value: val,
	    enumerable: !!enumerable,
	    writable: true,
	    configurable: true
	  });
	}
	
	/**
	 * Parse simple path.
	 */
	var bailRE = /[^\w.$]/;
	function parsePath (path) {
	  if (bailRE.test(path)) {
	    return
	  } else {
	    var segments = path.split('.');
	    return function (obj) {
	      for (var i = 0; i < segments.length; i++) {
	        if (!obj) { return }
	        obj = obj[segments[i]];
	      }
	      return obj
	    }
	  }
	}
	
	/*  */
	/* globals MutationObserver */
	
	// can we use __proto__?
	var hasProto = '__proto__' in {};
	
	// Browser environment sniffing
	var inBrowser = typeof window !== 'undefined';
	var UA = inBrowser && window.navigator.userAgent.toLowerCase();
	var isIE = UA && /msie|trident/.test(UA);
	var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
	var isEdge = UA && UA.indexOf('edge/') > 0;
	var isAndroid = UA && UA.indexOf('android') > 0;
	var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
	
	// this needs to be lazy-evaled because vue may be required before
	// vue-server-renderer can set VUE_ENV
	var _isServer;
	var isServerRendering = function () {
	  if (_isServer === undefined) {
	    /* istanbul ignore if */
	    if (!inBrowser && typeof global !== 'undefined') {
	      // detect presence of vue-server-renderer and avoid
	      // Webpack shimming the process
	      _isServer = global['process'].env.VUE_ENV === 'server';
	    } else {
	      _isServer = false;
	    }
	  }
	  return _isServer
	};
	
	// detect devtools
	var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	
	/* istanbul ignore next */
	function isNative (Ctor) {
	  return /native code/.test(Ctor.toString())
	}
	
	/**
	 * Defer a task to execute it asynchronously.
	 */
	var nextTick = (function () {
	  var callbacks = [];
	  var pending = false;
	  var timerFunc;
	
	  function nextTickHandler () {
	    pending = false;
	    var copies = callbacks.slice(0);
	    callbacks.length = 0;
	    for (var i = 0; i < copies.length; i++) {
	      copies[i]();
	    }
	  }
	
	  // the nextTick behavior leverages the microtask queue, which can be accessed
	  // via either native Promise.then or MutationObserver.
	  // MutationObserver has wider support, however it is seriously bugged in
	  // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
	  // completely stops working after triggering a few times... so, if native
	  // Promise is available, we will use it:
	  /* istanbul ignore if */
	  if (typeof Promise !== 'undefined' && isNative(Promise)) {
	    var p = Promise.resolve();
	    var logError = function (err) { console.error(err); };
	    timerFunc = function () {
	      p.then(nextTickHandler).catch(logError);
	      // in problematic UIWebViews, Promise.then doesn't completely break, but
	      // it can get stuck in a weird state where callbacks are pushed into the
	      // microtask queue but the queue isn't being flushed, until the browser
	      // needs to do some other work, e.g. handle a timer. Therefore we can
	      // "force" the microtask queue to be flushed by adding an empty timer.
	      if (isIOS) { setTimeout(noop); }
	    };
	  } else if (typeof MutationObserver !== 'undefined' && (
	    isNative(MutationObserver) ||
	    // PhantomJS and iOS 7.x
	    MutationObserver.toString() === '[object MutationObserverConstructor]'
	  )) {
	    // use MutationObserver where native Promise is not available,
	    // e.g. PhantomJS IE11, iOS7, Android 4.4
	    var counter = 1;
	    var observer = new MutationObserver(nextTickHandler);
	    var textNode = document.createTextNode(String(counter));
	    observer.observe(textNode, {
	      characterData: true
	    });
	    timerFunc = function () {
	      counter = (counter + 1) % 2;
	      textNode.data = String(counter);
	    };
	  } else {
	    // fallback to setTimeout
	    /* istanbul ignore next */
	    timerFunc = function () {
	      setTimeout(nextTickHandler, 0);
	    };
	  }
	
	  return function queueNextTick (cb, ctx) {
	    var _resolve;
	    callbacks.push(function () {
	      if (cb) { cb.call(ctx); }
	      if (_resolve) { _resolve(ctx); }
	    });
	    if (!pending) {
	      pending = true;
	      timerFunc();
	    }
	    if (!cb && typeof Promise !== 'undefined') {
	      return new Promise(function (resolve) {
	        _resolve = resolve;
	      })
	    }
	  }
	})();
	
	var _Set;
	/* istanbul ignore if */
	if (typeof Set !== 'undefined' && isNative(Set)) {
	  // use native Set when available.
	  _Set = Set;
	} else {
	  // a non-standard Set polyfill that only works with primitive keys.
	  _Set = (function () {
	    function Set () {
	      this.set = Object.create(null);
	    }
	    Set.prototype.has = function has (key) {
	      return this.set[key] === true
	    };
	    Set.prototype.add = function add (key) {
	      this.set[key] = true;
	    };
	    Set.prototype.clear = function clear () {
	      this.set = Object.create(null);
	    };
	
	    return Set;
	  }());
	}
	
	var warn = noop;
	var formatComponentName;
	
	if (false) {
	  var hasConsole = typeof console !== 'undefined';
	
	  warn = function (msg, vm) {
	    if (hasConsole && (!config.silent)) {
	      console.error("[Vue warn]: " + msg + " " + (
	        vm ? formatLocation(formatComponentName(vm)) : ''
	      ));
	    }
	  };
	
	  formatComponentName = function (vm) {
	    if (vm.$root === vm) {
	      return 'root instance'
	    }
	    var name = vm._isVue
	      ? vm.$options.name || vm.$options._componentTag
	      : vm.name;
	    return (
	      (name ? ("component <" + name + ">") : "anonymous component") +
	      (vm._isVue && vm.$options.__file ? (" at " + (vm.$options.__file)) : '')
	    )
	  };
	
	  var formatLocation = function (str) {
	    if (str === 'anonymous component') {
	      str += " - use the \"name\" option for better debugging messages.";
	    }
	    return ("\n(found in " + str + ")")
	  };
	}
	
	/*  */
	
	
	var uid$1 = 0;
	
	/**
	 * A dep is an observable that can have multiple
	 * directives subscribing to it.
	 */
	var Dep = function Dep () {
	  this.id = uid$1++;
	  this.subs = [];
	};
	
	Dep.prototype.addSub = function addSub (sub) {
	  this.subs.push(sub);
	};
	
	Dep.prototype.removeSub = function removeSub (sub) {
	  remove$1(this.subs, sub);
	};
	
	Dep.prototype.depend = function depend () {
	  if (Dep.target) {
	    Dep.target.addDep(this);
	  }
	};
	
	Dep.prototype.notify = function notify () {
	  // stablize the subscriber list first
	  var subs = this.subs.slice();
	  for (var i = 0, l = subs.length; i < l; i++) {
	    subs[i].update();
	  }
	};
	
	// the current target watcher being evaluated.
	// this is globally unique because there could be only one
	// watcher being evaluated at any time.
	Dep.target = null;
	var targetStack = [];
	
	function pushTarget (_target) {
	  if (Dep.target) { targetStack.push(Dep.target); }
	  Dep.target = _target;
	}
	
	function popTarget () {
	  Dep.target = targetStack.pop();
	}
	
	/*
	 * not type checking this file because flow doesn't play well with
	 * dynamically accessing methods on Array prototype
	 */
	
	var arrayProto = Array.prototype;
	var arrayMethods = Object.create(arrayProto);[
	  'push',
	  'pop',
	  'shift',
	  'unshift',
	  'splice',
	  'sort',
	  'reverse'
	]
	.forEach(function (method) {
	  // cache original method
	  var original = arrayProto[method];
	  def(arrayMethods, method, function mutator () {
	    var arguments$1 = arguments;
	
	    // avoid leaking arguments:
	    // http://jsperf.com/closure-with-arguments
	    var i = arguments.length;
	    var args = new Array(i);
	    while (i--) {
	      args[i] = arguments$1[i];
	    }
	    var result = original.apply(this, args);
	    var ob = this.__ob__;
	    var inserted;
	    switch (method) {
	      case 'push':
	        inserted = args;
	        break
	      case 'unshift':
	        inserted = args;
	        break
	      case 'splice':
	        inserted = args.slice(2);
	        break
	    }
	    if (inserted) { ob.observeArray(inserted); }
	    // notify change
	    ob.dep.notify();
	    return result
	  });
	});
	
	/*  */
	
	var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
	
	/**
	 * By default, when a reactive property is set, the new value is
	 * also converted to become reactive. However when passing down props,
	 * we don't want to force conversion because the value may be a nested value
	 * under a frozen data structure. Converting it would defeat the optimization.
	 */
	var observerState = {
	  shouldConvert: true,
	  isSettingProps: false
	};
	
	/**
	 * Observer class that are attached to each observed
	 * object. Once attached, the observer converts target
	 * object's property keys into getter/setters that
	 * collect dependencies and dispatches updates.
	 */
	var Observer = function Observer (value) {
	  this.value = value;
	  this.dep = new Dep();
	  this.vmCount = 0;
	  def(value, '__ob__', this);
	  if (Array.isArray(value)) {
	    var augment = hasProto
	      ? protoAugment
	      : copyAugment;
	    augment(value, arrayMethods, arrayKeys);
	    this.observeArray(value);
	  } else {
	    this.walk(value);
	  }
	};
	
	/**
	 * Walk through each property and convert them into
	 * getter/setters. This method should only be called when
	 * value type is Object.
	 */
	Observer.prototype.walk = function walk (obj) {
	  var keys = Object.keys(obj);
	  for (var i = 0; i < keys.length; i++) {
	    defineReactive$$1(obj, keys[i], obj[keys[i]]);
	  }
	};
	
	/**
	 * Observe a list of Array items.
	 */
	Observer.prototype.observeArray = function observeArray (items) {
	  for (var i = 0, l = items.length; i < l; i++) {
	    observe(items[i]);
	  }
	};
	
	// helpers
	
	/**
	 * Augment an target Object or Array by intercepting
	 * the prototype chain using __proto__
	 */
	function protoAugment (target, src) {
	  /* eslint-disable no-proto */
	  target.__proto__ = src;
	  /* eslint-enable no-proto */
	}
	
	/**
	 * Augment an target Object or Array by defining
	 * hidden properties.
	 */
	/* istanbul ignore next */
	function copyAugment (target, src, keys) {
	  for (var i = 0, l = keys.length; i < l; i++) {
	    var key = keys[i];
	    def(target, key, src[key]);
	  }
	}
	
	/**
	 * Attempt to create an observer instance for a value,
	 * returns the new observer if successfully observed,
	 * or the existing observer if the value already has one.
	 */
	function observe (value, asRootData) {
	  if (!isObject(value)) {
	    return
	  }
	  var ob;
	  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
	    ob = value.__ob__;
	  } else if (
	    observerState.shouldConvert &&
	    !isServerRendering() &&
	    (Array.isArray(value) || isPlainObject(value)) &&
	    Object.isExtensible(value) &&
	    !value._isVue
	  ) {
	    ob = new Observer(value);
	  }
	  if (asRootData && ob) {
	    ob.vmCount++;
	  }
	  return ob
	}
	
	/**
	 * Define a reactive property on an Object.
	 */
	function defineReactive$$1 (
	  obj,
	  key,
	  val,
	  customSetter
	) {
	  var dep = new Dep();
	
	  var property = Object.getOwnPropertyDescriptor(obj, key);
	  if (property && property.configurable === false) {
	    return
	  }
	
	  // cater for pre-defined getter/setters
	  var getter = property && property.get;
	  var setter = property && property.set;
	
	  var childOb = observe(val);
	  Object.defineProperty(obj, key, {
	    enumerable: true,
	    configurable: true,
	    get: function reactiveGetter () {
	      var value = getter ? getter.call(obj) : val;
	      if (Dep.target) {
	        dep.depend();
	        if (childOb) {
	          childOb.dep.depend();
	        }
	        if (Array.isArray(value)) {
	          dependArray(value);
	        }
	      }
	      return value
	    },
	    set: function reactiveSetter (newVal) {
	      var value = getter ? getter.call(obj) : val;
	      /* eslint-disable no-self-compare */
	      if (newVal === value || (newVal !== newVal && value !== value)) {
	        return
	      }
	      /* eslint-enable no-self-compare */
	      if (false) {
	        customSetter();
	      }
	      if (setter) {
	        setter.call(obj, newVal);
	      } else {
	        val = newVal;
	      }
	      childOb = observe(newVal);
	      dep.notify();
	    }
	  });
	}
	
	/**
	 * Set a property on an object. Adds the new property and
	 * triggers change notification if the property doesn't
	 * already exist.
	 */
	function set$1 (obj, key, val) {
	  if (Array.isArray(obj)) {
	    obj.length = Math.max(obj.length, key);
	    obj.splice(key, 1, val);
	    return val
	  }
	  if (hasOwn(obj, key)) {
	    obj[key] = val;
	    return
	  }
	  var ob = obj.__ob__;
	  if (obj._isVue || (ob && ob.vmCount)) {
	    ("production") !== 'production' && warn(
	      'Avoid adding reactive properties to a Vue instance or its root $data ' +
	      'at runtime - declare it upfront in the data option.'
	    );
	    return
	  }
	  if (!ob) {
	    obj[key] = val;
	    return
	  }
	  defineReactive$$1(ob.value, key, val);
	  ob.dep.notify();
	  return val
	}
	
	/**
	 * Delete a property and trigger change if necessary.
	 */
	function del (obj, key) {
	  var ob = obj.__ob__;
	  if (obj._isVue || (ob && ob.vmCount)) {
	    ("production") !== 'production' && warn(
	      'Avoid deleting properties on a Vue instance or its root $data ' +
	      '- just set it to null.'
	    );
	    return
	  }
	  if (!hasOwn(obj, key)) {
	    return
	  }
	  delete obj[key];
	  if (!ob) {
	    return
	  }
	  ob.dep.notify();
	}
	
	/**
	 * Collect dependencies on array elements when the array is touched, since
	 * we cannot intercept array element access like property getters.
	 */
	function dependArray (value) {
	  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
	    e = value[i];
	    e && e.__ob__ && e.__ob__.dep.depend();
	    if (Array.isArray(e)) {
	      dependArray(e);
	    }
	  }
	}
	
	/*  */
	
	/**
	 * Option overwriting strategies are functions that handle
	 * how to merge a parent option value and a child option
	 * value into the final value.
	 */
	var strats = config.optionMergeStrategies;
	
	/**
	 * Options with restrictions
	 */
	if (false) {
	  strats.el = strats.propsData = function (parent, child, vm, key) {
	    if (!vm) {
	      warn(
	        "option \"" + key + "\" can only be used during instance " +
	        'creation with the `new` keyword.'
	      );
	    }
	    return defaultStrat(parent, child)
	  };
	}
	
	/**
	 * Helper that recursively merges two data objects together.
	 */
	function mergeData (to, from) {
	  if (!from) { return to }
	  var key, toVal, fromVal;
	  var keys = Object.keys(from);
	  for (var i = 0; i < keys.length; i++) {
	    key = keys[i];
	    toVal = to[key];
	    fromVal = from[key];
	    if (!hasOwn(to, key)) {
	      set$1(to, key, fromVal);
	    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
	      mergeData(toVal, fromVal);
	    }
	  }
	  return to
	}
	
	/**
	 * Data
	 */
	strats.data = function (
	  parentVal,
	  childVal,
	  vm
	) {
	  if (!vm) {
	    // in a Vue.extend merge, both should be functions
	    if (!childVal) {
	      return parentVal
	    }
	    if (typeof childVal !== 'function') {
	      ("production") !== 'production' && warn(
	        'The "data" option should be a function ' +
	        'that returns a per-instance value in component ' +
	        'definitions.',
	        vm
	      );
	      return parentVal
	    }
	    if (!parentVal) {
	      return childVal
	    }
	    // when parentVal & childVal are both present,
	    // we need to return a function that returns the
	    // merged result of both functions... no need to
	    // check if parentVal is a function here because
	    // it has to be a function to pass previous merges.
	    return function mergedDataFn () {
	      return mergeData(
	        childVal.call(this),
	        parentVal.call(this)
	      )
	    }
	  } else if (parentVal || childVal) {
	    return function mergedInstanceDataFn () {
	      // instance merge
	      var instanceData = typeof childVal === 'function'
	        ? childVal.call(vm)
	        : childVal;
	      var defaultData = typeof parentVal === 'function'
	        ? parentVal.call(vm)
	        : undefined;
	      if (instanceData) {
	        return mergeData(instanceData, defaultData)
	      } else {
	        return defaultData
	      }
	    }
	  }
	};
	
	/**
	 * Hooks and param attributes are merged as arrays.
	 */
	function mergeHook (
	  parentVal,
	  childVal
	) {
	  return childVal
	    ? parentVal
	      ? parentVal.concat(childVal)
	      : Array.isArray(childVal)
	        ? childVal
	        : [childVal]
	    : parentVal
	}
	
	config._lifecycleHooks.forEach(function (hook) {
	  strats[hook] = mergeHook;
	});
	
	/**
	 * Assets
	 *
	 * When a vm is present (instance creation), we need to do
	 * a three-way merge between constructor options, instance
	 * options and parent options.
	 */
	function mergeAssets (parentVal, childVal) {
	  var res = Object.create(parentVal || null);
	  return childVal
	    ? extend(res, childVal)
	    : res
	}
	
	config._assetTypes.forEach(function (type) {
	  strats[type + 's'] = mergeAssets;
	});
	
	/**
	 * Watchers.
	 *
	 * Watchers hashes should not overwrite one
	 * another, so we merge them as arrays.
	 */
	strats.watch = function (parentVal, childVal) {
	  /* istanbul ignore if */
	  if (!childVal) { return parentVal }
	  if (!parentVal) { return childVal }
	  var ret = {};
	  extend(ret, parentVal);
	  for (var key in childVal) {
	    var parent = ret[key];
	    var child = childVal[key];
	    if (parent && !Array.isArray(parent)) {
	      parent = [parent];
	    }
	    ret[key] = parent
	      ? parent.concat(child)
	      : [child];
	  }
	  return ret
	};
	
	/**
	 * Other object hashes.
	 */
	strats.props =
	strats.methods =
	strats.computed = function (parentVal, childVal) {
	  if (!childVal) { return parentVal }
	  if (!parentVal) { return childVal }
	  var ret = Object.create(null);
	  extend(ret, parentVal);
	  extend(ret, childVal);
	  return ret
	};
	
	/**
	 * Default strategy.
	 */
	var defaultStrat = function (parentVal, childVal) {
	  return childVal === undefined
	    ? parentVal
	    : childVal
	};
	
	/**
	 * Validate component names
	 */
	function checkComponents (options) {
	  for (var key in options.components) {
	    var lower = key.toLowerCase();
	    if (isBuiltInTag(lower) || config.isReservedTag(lower)) {
	      warn(
	        'Do not use built-in or reserved HTML elements as component ' +
	        'id: ' + key
	      );
	    }
	  }
	}
	
	/**
	 * Ensure all props option syntax are normalized into the
	 * Object-based format.
	 */
	function normalizeProps (options) {
	  var props = options.props;
	  if (!props) { return }
	  var res = {};
	  var i, val, name;
	  if (Array.isArray(props)) {
	    i = props.length;
	    while (i--) {
	      val = props[i];
	      if (typeof val === 'string') {
	        name = camelize(val);
	        res[name] = { type: null };
	      } else if (false) {
	        warn('props must be strings when using array syntax.');
	      }
	    }
	  } else if (isPlainObject(props)) {
	    for (var key in props) {
	      val = props[key];
	      name = camelize(key);
	      res[name] = isPlainObject(val)
	        ? val
	        : { type: val };
	    }
	  }
	  options.props = res;
	}
	
	/**
	 * Normalize raw function directives into object format.
	 */
	function normalizeDirectives (options) {
	  var dirs = options.directives;
	  if (dirs) {
	    for (var key in dirs) {
	      var def = dirs[key];
	      if (typeof def === 'function') {
	        dirs[key] = { bind: def, update: def };
	      }
	    }
	  }
	}
	
	/**
	 * Merge two option objects into a new one.
	 * Core utility used in both instantiation and inheritance.
	 */
	function mergeOptions (
	  parent,
	  child,
	  vm
	) {
	  if (false) {
	    checkComponents(child);
	  }
	  normalizeProps(child);
	  normalizeDirectives(child);
	  var extendsFrom = child.extends;
	  if (extendsFrom) {
	    parent = typeof extendsFrom === 'function'
	      ? mergeOptions(parent, extendsFrom.options, vm)
	      : mergeOptions(parent, extendsFrom, vm);
	  }
	  if (child.mixins) {
	    for (var i = 0, l = child.mixins.length; i < l; i++) {
	      var mixin = child.mixins[i];
	      if (mixin.prototype instanceof Vue$3) {
	        mixin = mixin.options;
	      }
	      parent = mergeOptions(parent, mixin, vm);
	    }
	  }
	  var options = {};
	  var key;
	  for (key in parent) {
	    mergeField(key);
	  }
	  for (key in child) {
	    if (!hasOwn(parent, key)) {
	      mergeField(key);
	    }
	  }
	  function mergeField (key) {
	    var strat = strats[key] || defaultStrat;
	    options[key] = strat(parent[key], child[key], vm, key);
	  }
	  return options
	}
	
	/**
	 * Resolve an asset.
	 * This function is used because child instances need access
	 * to assets defined in its ancestor chain.
	 */
	function resolveAsset (
	  options,
	  type,
	  id,
	  warnMissing
	) {
	  /* istanbul ignore if */
	  if (typeof id !== 'string') {
	    return
	  }
	  var assets = options[type];
	  // check local registration variations first
	  if (hasOwn(assets, id)) { return assets[id] }
	  var camelizedId = camelize(id);
	  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
	  var PascalCaseId = capitalize(camelizedId);
	  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
	  // fallback to prototype chain
	  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
	  if (false) {
	    warn(
	      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
	      options
	    );
	  }
	  return res
	}
	
	/*  */
	
	function validateProp (
	  key,
	  propOptions,
	  propsData,
	  vm
	) {
	  var prop = propOptions[key];
	  var absent = !hasOwn(propsData, key);
	  var value = propsData[key];
	  // handle boolean props
	  if (isType(Boolean, prop.type)) {
	    if (absent && !hasOwn(prop, 'default')) {
	      value = false;
	    } else if (!isType(String, prop.type) && (value === '' || value === hyphenate(key))) {
	      value = true;
	    }
	  }
	  // check default value
	  if (value === undefined) {
	    value = getPropDefaultValue(vm, prop, key);
	    // since the default value is a fresh copy,
	    // make sure to observe it.
	    var prevShouldConvert = observerState.shouldConvert;
	    observerState.shouldConvert = true;
	    observe(value);
	    observerState.shouldConvert = prevShouldConvert;
	  }
	  if (false) {
	    assertProp(prop, key, value, vm, absent);
	  }
	  return value
	}
	
	/**
	 * Get the default value of a prop.
	 */
	function getPropDefaultValue (vm, prop, key) {
	  // no default, return undefined
	  if (!hasOwn(prop, 'default')) {
	    return undefined
	  }
	  var def = prop.default;
	  // warn against non-factory defaults for Object & Array
	  if (isObject(def)) {
	    ("production") !== 'production' && warn(
	      'Invalid default value for prop "' + key + '": ' +
	      'Props with type Object/Array must use a factory function ' +
	      'to return the default value.',
	      vm
	    );
	  }
	  // the raw prop value was also undefined from previous render,
	  // return previous default value to avoid unnecessary watcher trigger
	  if (vm && vm.$options.propsData &&
	    vm.$options.propsData[key] === undefined &&
	    vm[key] !== undefined) {
	    return vm[key]
	  }
	  // call factory function for non-Function types
	  return typeof def === 'function' && prop.type !== Function
	    ? def.call(vm)
	    : def
	}
	
	/**
	 * Assert whether a prop is valid.
	 */
	function assertProp (
	  prop,
	  name,
	  value,
	  vm,
	  absent
	) {
	  if (prop.required && absent) {
	    warn(
	      'Missing required prop: "' + name + '"',
	      vm
	    );
	    return
	  }
	  if (value == null && !prop.required) {
	    return
	  }
	  var type = prop.type;
	  var valid = !type || type === true;
	  var expectedTypes = [];
	  if (type) {
	    if (!Array.isArray(type)) {
	      type = [type];
	    }
	    for (var i = 0; i < type.length && !valid; i++) {
	      var assertedType = assertType(value, type[i]);
	      expectedTypes.push(assertedType.expectedType || '');
	      valid = assertedType.valid;
	    }
	  }
	  if (!valid) {
	    warn(
	      'Invalid prop: type check failed for prop "' + name + '".' +
	      ' Expected ' + expectedTypes.map(capitalize).join(', ') +
	      ', got ' + Object.prototype.toString.call(value).slice(8, -1) + '.',
	      vm
	    );
	    return
	  }
	  var validator = prop.validator;
	  if (validator) {
	    if (!validator(value)) {
	      warn(
	        'Invalid prop: custom validator check failed for prop "' + name + '".',
	        vm
	      );
	    }
	  }
	}
	
	/**
	 * Assert the type of a value
	 */
	function assertType (value, type) {
	  var valid;
	  var expectedType = getType(type);
	  if (expectedType === 'String') {
	    valid = typeof value === (expectedType = 'string');
	  } else if (expectedType === 'Number') {
	    valid = typeof value === (expectedType = 'number');
	  } else if (expectedType === 'Boolean') {
	    valid = typeof value === (expectedType = 'boolean');
	  } else if (expectedType === 'Function') {
	    valid = typeof value === (expectedType = 'function');
	  } else if (expectedType === 'Object') {
	    valid = isPlainObject(value);
	  } else if (expectedType === 'Array') {
	    valid = Array.isArray(value);
	  } else {
	    valid = value instanceof type;
	  }
	  return {
	    valid: valid,
	    expectedType: expectedType
	  }
	}
	
	/**
	 * Use function string name to check built-in types,
	 * because a simple equality check will fail when running
	 * across different vms / iframes.
	 */
	function getType (fn) {
	  var match = fn && fn.toString().match(/^\s*function (\w+)/);
	  return match && match[1]
	}
	
	function isType (type, fn) {
	  if (!Array.isArray(fn)) {
	    return getType(fn) === getType(type)
	  }
	  for (var i = 0, len = fn.length; i < len; i++) {
	    if (getType(fn[i]) === getType(type)) {
	      return true
	    }
	  }
	  /* istanbul ignore next */
	  return false
	}
	
	
	
	var util = Object.freeze({
		defineReactive: defineReactive$$1,
		_toString: _toString,
		toNumber: toNumber,
		makeMap: makeMap,
		isBuiltInTag: isBuiltInTag,
		remove: remove$1,
		hasOwn: hasOwn,
		isPrimitive: isPrimitive,
		cached: cached,
		camelize: camelize,
		capitalize: capitalize,
		hyphenate: hyphenate,
		bind: bind$1,
		toArray: toArray,
		extend: extend,
		isObject: isObject,
		isPlainObject: isPlainObject,
		toObject: toObject,
		noop: noop,
		no: no,
		identity: identity,
		genStaticKeys: genStaticKeys,
		looseEqual: looseEqual,
		looseIndexOf: looseIndexOf,
		isReserved: isReserved,
		def: def,
		parsePath: parsePath,
		hasProto: hasProto,
		inBrowser: inBrowser,
		UA: UA,
		isIE: isIE,
		isIE9: isIE9,
		isEdge: isEdge,
		isAndroid: isAndroid,
		isIOS: isIOS,
		isServerRendering: isServerRendering,
		devtools: devtools,
		nextTick: nextTick,
		get _Set () { return _Set; },
		mergeOptions: mergeOptions,
		resolveAsset: resolveAsset,
		get warn () { return warn; },
		get formatComponentName () { return formatComponentName; },
		validateProp: validateProp
	});
	
	/* not type checking this file because flow doesn't play well with Proxy */
	
	var initProxy;
	
	if (false) {
	  var allowedGlobals = makeMap(
	    'Infinity,undefined,NaN,isFinite,isNaN,' +
	    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
	    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
	    'require' // for Webpack/Browserify
	  );
	
	  var warnNonPresent = function (target, key) {
	    warn(
	      "Property or method \"" + key + "\" is not defined on the instance but " +
	      "referenced during render. Make sure to declare reactive data " +
	      "properties in the data option.",
	      target
	    );
	  };
	
	  var hasProxy =
	    typeof Proxy !== 'undefined' &&
	    Proxy.toString().match(/native code/);
	
	  if (hasProxy) {
	    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta');
	    config.keyCodes = new Proxy(config.keyCodes, {
	      set: function set (target, key, value) {
	        if (isBuiltInModifier(key)) {
	          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
	          return false
	        } else {
	          target[key] = value;
	          return true
	        }
	      }
	    });
	  }
	
	  var hasHandler = {
	    has: function has (target, key) {
	      var has = key in target;
	      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
	      if (!has && !isAllowed) {
	        warnNonPresent(target, key);
	      }
	      return has || !isAllowed
	    }
	  };
	
	  var getHandler = {
	    get: function get (target, key) {
	      if (typeof key === 'string' && !(key in target)) {
	        warnNonPresent(target, key);
	      }
	      return target[key]
	    }
	  };
	
	  initProxy = function initProxy (vm) {
	    if (hasProxy) {
	      // determine which proxy handler to use
	      var options = vm.$options;
	      var handlers = options.render && options.render._withStripped
	        ? getHandler
	        : hasHandler;
	      vm._renderProxy = new Proxy(vm, handlers);
	    } else {
	      vm._renderProxy = vm;
	    }
	  };
	}
	
	/*  */
	
	var VNode = function VNode (
	  tag,
	  data,
	  children,
	  text,
	  elm,
	  context,
	  componentOptions
	) {
	  this.tag = tag;
	  this.data = data;
	  this.children = children;
	  this.text = text;
	  this.elm = elm;
	  this.ns = undefined;
	  this.context = context;
	  this.functionalContext = undefined;
	  this.key = data && data.key;
	  this.componentOptions = componentOptions;
	  this.componentInstance = undefined;
	  this.parent = undefined;
	  this.raw = false;
	  this.isStatic = false;
	  this.isRootInsert = true;
	  this.isComment = false;
	  this.isCloned = false;
	  this.isOnce = false;
	};
	
	var prototypeAccessors = { child: {} };
	
	// DEPRECATED: alias for componentInstance for backwards compat.
	/* istanbul ignore next */
	prototypeAccessors.child.get = function () {
	  return this.componentInstance
	};
	
	Object.defineProperties( VNode.prototype, prototypeAccessors );
	
	var createEmptyVNode = function () {
	  var node = new VNode();
	  node.text = '';
	  node.isComment = true;
	  return node
	};
	
	function createTextVNode (val) {
	  return new VNode(undefined, undefined, undefined, String(val))
	}
	
	// optimized shallow clone
	// used for static nodes and slot nodes because they may be reused across
	// multiple renders, cloning them avoids errors when DOM manipulations rely
	// on their elm reference.
	function cloneVNode (vnode) {
	  var cloned = new VNode(
	    vnode.tag,
	    vnode.data,
	    vnode.children,
	    vnode.text,
	    vnode.elm,
	    vnode.context,
	    vnode.componentOptions
	  );
	  cloned.ns = vnode.ns;
	  cloned.isStatic = vnode.isStatic;
	  cloned.key = vnode.key;
	  cloned.isCloned = true;
	  return cloned
	}
	
	function cloneVNodes (vnodes) {
	  var res = new Array(vnodes.length);
	  for (var i = 0; i < vnodes.length; i++) {
	    res[i] = cloneVNode(vnodes[i]);
	  }
	  return res
	}
	
	/*  */
	
	var hooks = { init: init, prepatch: prepatch, insert: insert, destroy: destroy$1 };
	var hooksToMerge = Object.keys(hooks);
	
	function createComponent (
	  Ctor,
	  data,
	  context,
	  children,
	  tag
	) {
	  if (!Ctor) {
	    return
	  }
	
	  var baseCtor = context.$options._base;
	  if (isObject(Ctor)) {
	    Ctor = baseCtor.extend(Ctor);
	  }
	
	  if (typeof Ctor !== 'function') {
	    if (false) {
	      warn(("Invalid Component definition: " + (String(Ctor))), context);
	    }
	    return
	  }
	
	  // async component
	  if (!Ctor.cid) {
	    if (Ctor.resolved) {
	      Ctor = Ctor.resolved;
	    } else {
	      Ctor = resolveAsyncComponent(Ctor, baseCtor, function () {
	        // it's ok to queue this on every render because
	        // $forceUpdate is buffered by the scheduler.
	        context.$forceUpdate();
	      });
	      if (!Ctor) {
	        // return nothing if this is indeed an async component
	        // wait for the callback to trigger parent update.
	        return
	      }
	    }
	  }
	
	  // resolve constructor options in case global mixins are applied after
	  // component constructor creation
	  resolveConstructorOptions(Ctor);
	
	  data = data || {};
	
	  // extract props
	  var propsData = extractProps(data, Ctor);
	
	  // functional component
	  if (Ctor.options.functional) {
	    return createFunctionalComponent(Ctor, propsData, data, context, children)
	  }
	
	  // extract listeners, since these needs to be treated as
	  // child component listeners instead of DOM listeners
	  var listeners = data.on;
	  // replace with listeners with .native modifier
	  data.on = data.nativeOn;
	
	  if (Ctor.options.abstract) {
	    // abstract components do not keep anything
	    // other than props & listeners
	    data = {};
	  }
	
	  // merge component management hooks onto the placeholder node
	  mergeHooks(data);
	
	  // return a placeholder vnode
	  var name = Ctor.options.name || tag;
	  var vnode = new VNode(
	    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
	    data, undefined, undefined, undefined, context,
	    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children }
	  );
	  return vnode
	}
	
	function createFunctionalComponent (
	  Ctor,
	  propsData,
	  data,
	  context,
	  children
	) {
	  var props = {};
	  var propOptions = Ctor.options.props;
	  if (propOptions) {
	    for (var key in propOptions) {
	      props[key] = validateProp(key, propOptions, propsData);
	    }
	  }
	  // ensure the createElement function in functional components
	  // gets a unique context - this is necessary for correct named slot check
	  var _context = Object.create(context);
	  var h = function (a, b, c, d) { return createElement(_context, a, b, c, d, true); };
	  var vnode = Ctor.options.render.call(null, h, {
	    props: props,
	    data: data,
	    parent: context,
	    children: children,
	    slots: function () { return resolveSlots(children, context); }
	  });
	  if (vnode instanceof VNode) {
	    vnode.functionalContext = context;
	    if (data.slot) {
	      (vnode.data || (vnode.data = {})).slot = data.slot;
	    }
	  }
	  return vnode
	}
	
	function createComponentInstanceForVnode (
	  vnode, // we know it's MountedComponentVNode but flow doesn't
	  parent, // activeInstance in lifecycle state
	  parentElm,
	  refElm
	) {
	  var vnodeComponentOptions = vnode.componentOptions;
	  var options = {
	    _isComponent: true,
	    parent: parent,
	    propsData: vnodeComponentOptions.propsData,
	    _componentTag: vnodeComponentOptions.tag,
	    _parentVnode: vnode,
	    _parentListeners: vnodeComponentOptions.listeners,
	    _renderChildren: vnodeComponentOptions.children,
	    _parentElm: parentElm || null,
	    _refElm: refElm || null
	  };
	  // check inline-template render functions
	  var inlineTemplate = vnode.data.inlineTemplate;
	  if (inlineTemplate) {
	    options.render = inlineTemplate.render;
	    options.staticRenderFns = inlineTemplate.staticRenderFns;
	  }
	  return new vnodeComponentOptions.Ctor(options)
	}
	
	function init (
	  vnode,
	  hydrating,
	  parentElm,
	  refElm
	) {
	  if (!vnode.componentInstance || vnode.componentInstance._isDestroyed) {
	    var child = vnode.componentInstance = createComponentInstanceForVnode(
	      vnode,
	      activeInstance,
	      parentElm,
	      refElm
	    );
	    child.$mount(hydrating ? vnode.elm : undefined, hydrating);
	  } else if (vnode.data.keepAlive) {
	    // kept-alive components, treat as a patch
	    var mountedNode = vnode; // work around flow
	    prepatch(mountedNode, mountedNode);
	  }
	}
	
	function prepatch (
	  oldVnode,
	  vnode
	) {
	  var options = vnode.componentOptions;
	  var child = vnode.componentInstance = oldVnode.componentInstance;
	  child._updateFromParent(
	    options.propsData, // updated props
	    options.listeners, // updated listeners
	    vnode, // new parent vnode
	    options.children // new children
	  );
	}
	
	function insert (vnode) {
	  if (!vnode.componentInstance._isMounted) {
	    vnode.componentInstance._isMounted = true;
	    callHook(vnode.componentInstance, 'mounted');
	  }
	  if (vnode.data.keepAlive) {
	    vnode.componentInstance._inactive = false;
	    callHook(vnode.componentInstance, 'activated');
	  }
	}
	
	function destroy$1 (vnode) {
	  if (!vnode.componentInstance._isDestroyed) {
	    if (!vnode.data.keepAlive) {
	      vnode.componentInstance.$destroy();
	    } else {
	      vnode.componentInstance._inactive = true;
	      callHook(vnode.componentInstance, 'deactivated');
	    }
	  }
	}
	
	function resolveAsyncComponent (
	  factory,
	  baseCtor,
	  cb
	) {
	  if (factory.requested) {
	    // pool callbacks
	    factory.pendingCallbacks.push(cb);
	  } else {
	    factory.requested = true;
	    var cbs = factory.pendingCallbacks = [cb];
	    var sync = true;
	
	    var resolve = function (res) {
	      if (isObject(res)) {
	        res = baseCtor.extend(res);
	      }
	      // cache resolved
	      factory.resolved = res;
	      // invoke callbacks only if this is not a synchronous resolve
	      // (async resolves are shimmed as synchronous during SSR)
	      if (!sync) {
	        for (var i = 0, l = cbs.length; i < l; i++) {
	          cbs[i](res);
	        }
	      }
	    };
	
	    var reject = function (reason) {
	      ("production") !== 'production' && warn(
	        "Failed to resolve async component: " + (String(factory)) +
	        (reason ? ("\nReason: " + reason) : '')
	      );
	    };
	
	    var res = factory(resolve, reject);
	
	    // handle promise
	    if (res && typeof res.then === 'function' && !factory.resolved) {
	      res.then(resolve, reject);
	    }
	
	    sync = false;
	    // return in case resolved synchronously
	    return factory.resolved
	  }
	}
	
	function extractProps (data, Ctor) {
	  // we are only extracting raw values here.
	  // validation and default values are handled in the child
	  // component itself.
	  var propOptions = Ctor.options.props;
	  if (!propOptions) {
	    return
	  }
	  var res = {};
	  var attrs = data.attrs;
	  var props = data.props;
	  var domProps = data.domProps;
	  if (attrs || props || domProps) {
	    for (var key in propOptions) {
	      var altKey = hyphenate(key);
	      checkProp(res, props, key, altKey, true) ||
	      checkProp(res, attrs, key, altKey) ||
	      checkProp(res, domProps, key, altKey);
	    }
	  }
	  return res
	}
	
	function checkProp (
	  res,
	  hash,
	  key,
	  altKey,
	  preserve
	) {
	  if (hash) {
	    if (hasOwn(hash, key)) {
	      res[key] = hash[key];
	      if (!preserve) {
	        delete hash[key];
	      }
	      return true
	    } else if (hasOwn(hash, altKey)) {
	      res[key] = hash[altKey];
	      if (!preserve) {
	        delete hash[altKey];
	      }
	      return true
	    }
	  }
	  return false
	}
	
	function mergeHooks (data) {
	  if (!data.hook) {
	    data.hook = {};
	  }
	  for (var i = 0; i < hooksToMerge.length; i++) {
	    var key = hooksToMerge[i];
	    var fromParent = data.hook[key];
	    var ours = hooks[key];
	    data.hook[key] = fromParent ? mergeHook$1(ours, fromParent) : ours;
	  }
	}
	
	function mergeHook$1 (one, two) {
	  return function (a, b, c, d) {
	    one(a, b, c, d);
	    two(a, b, c, d);
	  }
	}
	
	/*  */
	
	function mergeVNodeHook (def, hookKey, hook, key) {
	  key = key + hookKey;
	  var injectedHash = def.__injected || (def.__injected = {});
	  if (!injectedHash[key]) {
	    injectedHash[key] = true;
	    var oldHook = def[hookKey];
	    if (oldHook) {
	      def[hookKey] = function () {
	        oldHook.apply(this, arguments);
	        hook.apply(this, arguments);
	      };
	    } else {
	      def[hookKey] = hook;
	    }
	  }
	}
	
	/*  */
	
	var normalizeEvent = cached(function (name) {
	  var once = name.charAt(0) === '~'; // Prefixed last, checked first
	  name = once ? name.slice(1) : name;
	  var capture = name.charAt(0) === '!';
	  name = capture ? name.slice(1) : name;
	  return {
	    name: name,
	    once: once,
	    capture: capture
	  }
	});
	
	function createEventHandle (fn) {
	  var handle = {
	    fn: fn,
	    invoker: function () {
	      var arguments$1 = arguments;
	
	      var fn = handle.fn;
	      if (Array.isArray(fn)) {
	        for (var i = 0; i < fn.length; i++) {
	          fn[i].apply(null, arguments$1);
	        }
	      } else {
	        fn.apply(null, arguments);
	      }
	    }
	  };
	  return handle
	}
	
	function updateListeners (
	  on,
	  oldOn,
	  add,
	  remove$$1,
	  vm
	) {
	  var name, cur, old, event;
	  for (name in on) {
	    cur = on[name];
	    old = oldOn[name];
	    event = normalizeEvent(name);
	    if (!cur) {
	      ("production") !== 'production' && warn(
	        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
	        vm
	      );
	    } else if (!old) {
	      if (!cur.invoker) {
	        cur = on[name] = createEventHandle(cur);
	      }
	      add(event.name, cur.invoker, event.once, event.capture);
	    } else if (cur !== old) {
	      old.fn = cur;
	      on[name] = old;
	    }
	  }
	  for (name in oldOn) {
	    if (!on[name]) {
	      event = normalizeEvent(name);
	      remove$$1(event.name, oldOn[name].invoker, event.capture);
	    }
	  }
	}
	
	/*  */
	
	// The template compiler attempts to minimize the need for normalization by
	// statically analyzing the template at compile time.
	//
	// For plain HTML markup, normalization can be completely skipped because the
	// generated render function is guaranteed to return Array<VNode>. There are
	// two cases where extra normalization is needed:
	
	// 1. When the children contains components - because a functional component
	// may return an Array instead of a single root. In this case, just a simple
	// nomralization is needed - if any child is an Array, we flatten the whole
	// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
	// because functional components already normalize their own children.
	function simpleNormalizeChildren (children) {
	  for (var i = 0; i < children.length; i++) {
	    if (Array.isArray(children[i])) {
	      return Array.prototype.concat.apply([], children)
	    }
	  }
	  return children
	}
	
	// 2. When the children contains constrcuts that always generated nested Arrays,
	// e.g. <template>, <slot>, v-for, or when the children is provided by user
	// with hand-written render functions / JSX. In such cases a full normalization
	// is needed to cater to all possible types of children values.
	function normalizeChildren (children) {
	  return isPrimitive(children)
	    ? [createTextVNode(children)]
	    : Array.isArray(children)
	      ? normalizeArrayChildren(children)
	      : undefined
	}
	
	function normalizeArrayChildren (children, nestedIndex) {
	  var res = [];
	  var i, c, last;
	  for (i = 0; i < children.length; i++) {
	    c = children[i];
	    if (c == null || typeof c === 'boolean') { continue }
	    last = res[res.length - 1];
	    //  nested
	    if (Array.isArray(c)) {
	      res.push.apply(res, normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i)));
	    } else if (isPrimitive(c)) {
	      if (last && last.text) {
	        last.text += String(c);
	      } else if (c !== '') {
	        // convert primitive to vnode
	        res.push(createTextVNode(c));
	      }
	    } else {
	      if (c.text && last && last.text) {
	        res[res.length - 1] = createTextVNode(last.text + c.text);
	      } else {
	        // default key for nested array children (likely generated by v-for)
	        if (c.tag && c.key == null && nestedIndex != null) {
	          c.key = "__vlist" + nestedIndex + "_" + i + "__";
	        }
	        res.push(c);
	      }
	    }
	  }
	  return res
	}
	
	/*  */
	
	function getFirstComponentChild (children) {
	  return children && children.filter(function (c) { return c && c.componentOptions; })[0]
	}
	
	/*  */
	
	var SIMPLE_NORMALIZE = 1;
	var ALWAYS_NORMALIZE = 2;
	
	// wrapper function for providing a more flexible interface
	// without getting yelled at by flow
	function createElement (
	  context,
	  tag,
	  data,
	  children,
	  normalizationType,
	  alwaysNormalize
	) {
	  if (Array.isArray(data) || isPrimitive(data)) {
	    normalizationType = children;
	    children = data;
	    data = undefined;
	  }
	  if (alwaysNormalize) { normalizationType = ALWAYS_NORMALIZE; }
	  return _createElement(context, tag, data, children, normalizationType)
	}
	
	function _createElement (
	  context,
	  tag,
	  data,
	  children,
	  normalizationType
	) {
	  if (data && data.__ob__) {
	    ("production") !== 'production' && warn(
	      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
	      'Always create fresh vnode data objects in each render!',
	      context
	    );
	    return createEmptyVNode()
	  }
	  if (!tag) {
	    // in case of component :is set to falsy value
	    return createEmptyVNode()
	  }
	  // support single function children as default scoped slot
	  if (Array.isArray(children) &&
	      typeof children[0] === 'function') {
	    data = data || {};
	    data.scopedSlots = { default: children[0] };
	    children.length = 0;
	  }
	  if (normalizationType === ALWAYS_NORMALIZE) {
	    children = normalizeChildren(children);
	  } else if (normalizationType === SIMPLE_NORMALIZE) {
	    children = simpleNormalizeChildren(children);
	  }
	  var vnode, ns;
	  if (typeof tag === 'string') {
	    var Ctor;
	    ns = config.getTagNamespace(tag);
	    if (config.isReservedTag(tag)) {
	      // platform built-in elements
	      vnode = new VNode(
	        config.parsePlatformTagName(tag), data, children,
	        undefined, undefined, context
	      );
	    } else if ((Ctor = resolveAsset(context.$options, 'components', tag))) {
	      // component
	      vnode = createComponent(Ctor, data, context, children, tag);
	    } else {
	      // unknown or unlisted namespaced elements
	      // check at runtime because it may get assigned a namespace when its
	      // parent normalizes children
	      vnode = new VNode(
	        tag, data, children,
	        undefined, undefined, context
	      );
	    }
	  } else {
	    // direct component options / constructor
	    vnode = createComponent(tag, data, context, children);
	  }
	  if (vnode) {
	    if (ns) { applyNS(vnode, ns); }
	    return vnode
	  } else {
	    return createEmptyVNode()
	  }
	}
	
	function applyNS (vnode, ns) {
	  vnode.ns = ns;
	  if (vnode.tag === 'foreignObject') {
	    // use default namespace inside foreignObject
	    return
	  }
	  if (vnode.children) {
	    for (var i = 0, l = vnode.children.length; i < l; i++) {
	      var child = vnode.children[i];
	      if (child.tag && !child.ns) {
	        applyNS(child, ns);
	      }
	    }
	  }
	}
	
	/*  */
	
	function initRender (vm) {
	  vm.$vnode = null; // the placeholder node in parent tree
	  vm._vnode = null; // the root of the child tree
	  vm._staticTrees = null;
	  var parentVnode = vm.$options._parentVnode;
	  var renderContext = parentVnode && parentVnode.context;
	  vm.$slots = resolveSlots(vm.$options._renderChildren, renderContext);
	  vm.$scopedSlots = {};
	  // bind the createElement fn to this instance
	  // so that we get proper render context inside it.
	  // args order: tag, data, children, normalizationType, alwaysNormalize
	  // internal version is used by render functions compiled from templates
	  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
	  // normalization is always applied for the public version, used in
	  // user-written render functions.
	  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };
	}
	
	function renderMixin (Vue) {
	  Vue.prototype.$nextTick = function (fn) {
	    return nextTick(fn, this)
	  };
	
	  Vue.prototype._render = function () {
	    var vm = this;
	    var ref = vm.$options;
	    var render = ref.render;
	    var staticRenderFns = ref.staticRenderFns;
	    var _parentVnode = ref._parentVnode;
	
	    if (vm._isMounted) {
	      // clone slot nodes on re-renders
	      for (var key in vm.$slots) {
	        vm.$slots[key] = cloneVNodes(vm.$slots[key]);
	      }
	    }
	
	    if (_parentVnode && _parentVnode.data.scopedSlots) {
	      vm.$scopedSlots = _parentVnode.data.scopedSlots;
	    }
	
	    if (staticRenderFns && !vm._staticTrees) {
	      vm._staticTrees = [];
	    }
	    // set parent vnode. this allows render functions to have access
	    // to the data on the placeholder node.
	    vm.$vnode = _parentVnode;
	    // render self
	    var vnode;
	    try {
	      vnode = render.call(vm._renderProxy, vm.$createElement);
	    } catch (e) {
	      /* istanbul ignore else */
	      if (config.errorHandler) {
	        config.errorHandler.call(null, e, vm);
	      } else {
	        if (false) {
	          warn(("Error when rendering " + (formatComponentName(vm)) + ":"));
	        }
	        throw e
	      }
	      // return previous vnode to prevent render error causing blank component
	      vnode = vm._vnode;
	    }
	    // return empty vnode in case the render function errored out
	    if (!(vnode instanceof VNode)) {
	      if (false) {
	        warn(
	          'Multiple root nodes returned from render function. Render function ' +
	          'should return a single root node.',
	          vm
	        );
	      }
	      vnode = createEmptyVNode();
	    }
	    // set parent
	    vnode.parent = _parentVnode;
	    return vnode
	  };
	
	  // toString for mustaches
	  Vue.prototype._s = _toString;
	  // convert text to vnode
	  Vue.prototype._v = createTextVNode;
	  // number conversion
	  Vue.prototype._n = toNumber;
	  // empty vnode
	  Vue.prototype._e = createEmptyVNode;
	  // loose equal
	  Vue.prototype._q = looseEqual;
	  // loose indexOf
	  Vue.prototype._i = looseIndexOf;
	
	  // render static tree by index
	  Vue.prototype._m = function renderStatic (
	    index,
	    isInFor
	  ) {
	    var tree = this._staticTrees[index];
	    // if has already-rendered static tree and not inside v-for,
	    // we can reuse the same tree by doing a shallow clone.
	    if (tree && !isInFor) {
	      return Array.isArray(tree)
	        ? cloneVNodes(tree)
	        : cloneVNode(tree)
	    }
	    // otherwise, render a fresh tree.
	    tree = this._staticTrees[index] = this.$options.staticRenderFns[index].call(this._renderProxy);
	    markStatic(tree, ("__static__" + index), false);
	    return tree
	  };
	
	  // mark node as static (v-once)
	  Vue.prototype._o = function markOnce (
	    tree,
	    index,
	    key
	  ) {
	    markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
	    return tree
	  };
	
	  function markStatic (tree, key, isOnce) {
	    if (Array.isArray(tree)) {
	      for (var i = 0; i < tree.length; i++) {
	        if (tree[i] && typeof tree[i] !== 'string') {
	          markStaticNode(tree[i], (key + "_" + i), isOnce);
	        }
	      }
	    } else {
	      markStaticNode(tree, key, isOnce);
	    }
	  }
	
	  function markStaticNode (node, key, isOnce) {
	    node.isStatic = true;
	    node.key = key;
	    node.isOnce = isOnce;
	  }
	
	  // filter resolution helper
	  Vue.prototype._f = function resolveFilter (id) {
	    return resolveAsset(this.$options, 'filters', id, true) || identity
	  };
	
	  // render v-for
	  Vue.prototype._l = function renderList (
	    val,
	    render
	  ) {
	    var ret, i, l, keys, key;
	    if (Array.isArray(val) || typeof val === 'string') {
	      ret = new Array(val.length);
	      for (i = 0, l = val.length; i < l; i++) {
	        ret[i] = render(val[i], i);
	      }
	    } else if (typeof val === 'number') {
	      ret = new Array(val);
	      for (i = 0; i < val; i++) {
	        ret[i] = render(i + 1, i);
	      }
	    } else if (isObject(val)) {
	      keys = Object.keys(val);
	      ret = new Array(keys.length);
	      for (i = 0, l = keys.length; i < l; i++) {
	        key = keys[i];
	        ret[i] = render(val[key], key, i);
	      }
	    }
	    return ret
	  };
	
	  // renderSlot
	  Vue.prototype._t = function (
	    name,
	    fallback,
	    props,
	    bindObject
	  ) {
	    var scopedSlotFn = this.$scopedSlots[name];
	    if (scopedSlotFn) { // scoped slot
	      props = props || {};
	      if (bindObject) {
	        extend(props, bindObject);
	      }
	      return scopedSlotFn(props) || fallback
	    } else {
	      var slotNodes = this.$slots[name];
	      // warn duplicate slot usage
	      if (slotNodes && ("production") !== 'production') {
	        slotNodes._rendered && warn(
	          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
	          "- this will likely cause render errors.",
	          this
	        );
	        slotNodes._rendered = true;
	      }
	      return slotNodes || fallback
	    }
	  };
	
	  // apply v-bind object
	  Vue.prototype._b = function bindProps (
	    data,
	    tag,
	    value,
	    asProp
	  ) {
	    if (value) {
	      if (!isObject(value)) {
	        ("production") !== 'production' && warn(
	          'v-bind without argument expects an Object or Array value',
	          this
	        );
	      } else {
	        if (Array.isArray(value)) {
	          value = toObject(value);
	        }
	        for (var key in value) {
	          if (key === 'class' || key === 'style') {
	            data[key] = value[key];
	          } else {
	            var type = data.attrs && data.attrs.type;
	            var hash = asProp || config.mustUseProp(tag, type, key)
	              ? data.domProps || (data.domProps = {})
	              : data.attrs || (data.attrs = {});
	            hash[key] = value[key];
	          }
	        }
	      }
	    }
	    return data
	  };
	
	  // check v-on keyCodes
	  Vue.prototype._k = function checkKeyCodes (
	    eventKeyCode,
	    key,
	    builtInAlias
	  ) {
	    var keyCodes = config.keyCodes[key] || builtInAlias;
	    if (Array.isArray(keyCodes)) {
	      return keyCodes.indexOf(eventKeyCode) === -1
	    } else {
	      return keyCodes !== eventKeyCode
	    }
	  };
	}
	
	function resolveSlots (
	  children,
	  context
	) {
	  var slots = {};
	  if (!children) {
	    return slots
	  }
	  var defaultSlot = [];
	  var name, child;
	  for (var i = 0, l = children.length; i < l; i++) {
	    child = children[i];
	    // named slots should only be respected if the vnode was rendered in the
	    // same context.
	    if ((child.context === context || child.functionalContext === context) &&
	        child.data && (name = child.data.slot)) {
	      var slot = (slots[name] || (slots[name] = []));
	      if (child.tag === 'template') {
	        slot.push.apply(slot, child.children);
	      } else {
	        slot.push(child);
	      }
	    } else {
	      defaultSlot.push(child);
	    }
	  }
	  // ignore single whitespace
	  if (defaultSlot.length && !(
	    defaultSlot.length === 1 &&
	    (defaultSlot[0].text === ' ' || defaultSlot[0].isComment)
	  )) {
	    slots.default = defaultSlot;
	  }
	  return slots
	}
	
	/*  */
	
	function initEvents (vm) {
	  vm._events = Object.create(null);
	  vm._hasHookEvent = false;
	  // init parent attached events
	  var listeners = vm.$options._parentListeners;
	  if (listeners) {
	    updateComponentListeners(vm, listeners);
	  }
	}
	
	var target;
	
	function add$1 (event, fn, once) {
	  if (once) {
	    target.$once(event, fn);
	  } else {
	    target.$on(event, fn);
	  }
	}
	
	function remove$2 (event, fn) {
	  target.$off(event, fn);
	}
	
	function updateComponentListeners (
	  vm,
	  listeners,
	  oldListeners
	) {
	  target = vm;
	  updateListeners(listeners, oldListeners || {}, add$1, remove$2, vm);
	}
	
	function eventsMixin (Vue) {
	  var hookRE = /^hook:/;
	  Vue.prototype.$on = function (event, fn) {
	    var vm = this;(vm._events[event] || (vm._events[event] = [])).push(fn);
	    // optimize hook:event cost by using a boolean flag marked at registration
	    // instead of a hash lookup
	    if (hookRE.test(event)) {
	      vm._hasHookEvent = true;
	    }
	    return vm
	  };
	
	  Vue.prototype.$once = function (event, fn) {
	    var vm = this;
	    function on () {
	      vm.$off(event, on);
	      fn.apply(vm, arguments);
	    }
	    on.fn = fn;
	    vm.$on(event, on);
	    return vm
	  };
	
	  Vue.prototype.$off = function (event, fn) {
	    var vm = this;
	    // all
	    if (!arguments.length) {
	      vm._events = Object.create(null);
	      return vm
	    }
	    // specific event
	    var cbs = vm._events[event];
	    if (!cbs) {
	      return vm
	    }
	    if (arguments.length === 1) {
	      vm._events[event] = null;
	      return vm
	    }
	    // specific handler
	    var cb;
	    var i = cbs.length;
	    while (i--) {
	      cb = cbs[i];
	      if (cb === fn || cb.fn === fn) {
	        cbs.splice(i, 1);
	        break
	      }
	    }
	    return vm
	  };
	
	  Vue.prototype.$emit = function (event) {
	    var vm = this;
	    var cbs = vm._events[event];
	    if (cbs) {
	      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
	      var args = toArray(arguments, 1);
	      for (var i = 0, l = cbs.length; i < l; i++) {
	        cbs[i].apply(vm, args);
	      }
	    }
	    return vm
	  };
	}
	
	/*  */
	
	var activeInstance = null;
	
	function initLifecycle (vm) {
	  var options = vm.$options;
	
	  // locate first non-abstract parent
	  var parent = options.parent;
	  if (parent && !options.abstract) {
	    while (parent.$options.abstract && parent.$parent) {
	      parent = parent.$parent;
	    }
	    parent.$children.push(vm);
	  }
	
	  vm.$parent = parent;
	  vm.$root = parent ? parent.$root : vm;
	
	  vm.$children = [];
	  vm.$refs = {};
	
	  vm._watcher = null;
	  vm._inactive = false;
	  vm._isMounted = false;
	  vm._isDestroyed = false;
	  vm._isBeingDestroyed = false;
	}
	
	function lifecycleMixin (Vue) {
	  Vue.prototype._mount = function (
	    el,
	    hydrating
	  ) {
	    var vm = this;
	    vm.$el = el;
	    if (!vm.$options.render) {
	      vm.$options.render = createEmptyVNode;
	      if (false) {
	        /* istanbul ignore if */
	        if (vm.$options.template && vm.$options.template.charAt(0) !== '#') {
	          warn(
	            'You are using the runtime-only build of Vue where the template ' +
	            'option is not available. Either pre-compile the templates into ' +
	            'render functions, or use the compiler-included build.',
	            vm
	          );
	        } else {
	          warn(
	            'Failed to mount component: template or render function not defined.',
	            vm
	          );
	        }
	      }
	    }
	    callHook(vm, 'beforeMount');
	    vm._watcher = new Watcher(vm, function updateComponent () {
	      vm._update(vm._render(), hydrating);
	    }, noop);
	    hydrating = false;
	    // manually mounted instance, call mounted on self
	    // mounted is called for render-created child components in its inserted hook
	    if (vm.$vnode == null) {
	      vm._isMounted = true;
	      callHook(vm, 'mounted');
	    }
	    return vm
	  };
	
	  Vue.prototype._update = function (vnode, hydrating) {
	    var vm = this;
	    if (vm._isMounted) {
	      callHook(vm, 'beforeUpdate');
	    }
	    var prevEl = vm.$el;
	    var prevVnode = vm._vnode;
	    var prevActiveInstance = activeInstance;
	    activeInstance = vm;
	    vm._vnode = vnode;
	    // Vue.prototype.__patch__ is injected in entry points
	    // based on the rendering backend used.
	    if (!prevVnode) {
	      // initial render
	      vm.$el = vm.__patch__(
	        vm.$el, vnode, hydrating, false /* removeOnly */,
	        vm.$options._parentElm,
	        vm.$options._refElm
	      );
	    } else {
	      // updates
	      vm.$el = vm.__patch__(prevVnode, vnode);
	    }
	    activeInstance = prevActiveInstance;
	    // update __vue__ reference
	    if (prevEl) {
	      prevEl.__vue__ = null;
	    }
	    if (vm.$el) {
	      vm.$el.__vue__ = vm;
	    }
	    // if parent is an HOC, update its $el as well
	    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
	      vm.$parent.$el = vm.$el;
	    }
	    // updated hook is called by the scheduler to ensure that children are
	    // updated in a parent's updated hook.
	  };
	
	  Vue.prototype._updateFromParent = function (
	    propsData,
	    listeners,
	    parentVnode,
	    renderChildren
	  ) {
	    var vm = this;
	    var hasChildren = !!(vm.$options._renderChildren || renderChildren);
	    vm.$options._parentVnode = parentVnode;
	    vm.$vnode = parentVnode; // update vm's placeholder node without re-render
	    if (vm._vnode) { // update child tree's parent
	      vm._vnode.parent = parentVnode;
	    }
	    vm.$options._renderChildren = renderChildren;
	    // update props
	    if (propsData && vm.$options.props) {
	      observerState.shouldConvert = false;
	      if (false) {
	        observerState.isSettingProps = true;
	      }
	      var propKeys = vm.$options._propKeys || [];
	      for (var i = 0; i < propKeys.length; i++) {
	        var key = propKeys[i];
	        vm[key] = validateProp(key, vm.$options.props, propsData, vm);
	      }
	      observerState.shouldConvert = true;
	      if (false) {
	        observerState.isSettingProps = false;
	      }
	      vm.$options.propsData = propsData;
	    }
	    // update listeners
	    if (listeners) {
	      var oldListeners = vm.$options._parentListeners;
	      vm.$options._parentListeners = listeners;
	      updateComponentListeners(vm, listeners, oldListeners);
	    }
	    // resolve slots + force update if has children
	    if (hasChildren) {
	      vm.$slots = resolveSlots(renderChildren, parentVnode.context);
	      vm.$forceUpdate();
	    }
	  };
	
	  Vue.prototype.$forceUpdate = function () {
	    var vm = this;
	    if (vm._watcher) {
	      vm._watcher.update();
	    }
	  };
	
	  Vue.prototype.$destroy = function () {
	    var vm = this;
	    if (vm._isBeingDestroyed) {
	      return
	    }
	    callHook(vm, 'beforeDestroy');
	    vm._isBeingDestroyed = true;
	    // remove self from parent
	    var parent = vm.$parent;
	    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
	      remove$1(parent.$children, vm);
	    }
	    // teardown watchers
	    if (vm._watcher) {
	      vm._watcher.teardown();
	    }
	    var i = vm._watchers.length;
	    while (i--) {
	      vm._watchers[i].teardown();
	    }
	    // remove reference from data ob
	    // frozen object may not have observer.
	    if (vm._data.__ob__) {
	      vm._data.__ob__.vmCount--;
	    }
	    // call the last hook...
	    vm._isDestroyed = true;
	    callHook(vm, 'destroyed');
	    // turn off all instance listeners.
	    vm.$off();
	    // remove __vue__ reference
	    if (vm.$el) {
	      vm.$el.__vue__ = null;
	    }
	    // invoke destroy hooks on current rendered tree
	    vm.__patch__(vm._vnode, null);
	  };
	}
	
	function callHook (vm, hook) {
	  var handlers = vm.$options[hook];
	  if (handlers) {
	    for (var i = 0, j = handlers.length; i < j; i++) {
	      handlers[i].call(vm);
	    }
	  }
	  if (vm._hasHookEvent) {
	    vm.$emit('hook:' + hook);
	  }
	}
	
	/*  */
	
	
	var queue = [];
	var has$1 = {};
	var circular = {};
	var waiting = false;
	var flushing = false;
	var index = 0;
	
	/**
	 * Reset the scheduler's state.
	 */
	function resetSchedulerState () {
	  queue.length = 0;
	  has$1 = {};
	  if (false) {
	    circular = {};
	  }
	  waiting = flushing = false;
	}
	
	/**
	 * Flush both queues and run the watchers.
	 */
	function flushSchedulerQueue () {
	  flushing = true;
	  var watcher, id, vm;
	
	  // Sort queue before flush.
	  // This ensures that:
	  // 1. Components are updated from parent to child. (because parent is always
	  //    created before the child)
	  // 2. A component's user watchers are run before its render watcher (because
	  //    user watchers are created before the render watcher)
	  // 3. If a component is destroyed during a parent component's watcher run,
	  //    its watchers can be skipped.
	  queue.sort(function (a, b) { return a.id - b.id; });
	
	  // do not cache length because more watchers might be pushed
	  // as we run existing watchers
	  for (index = 0; index < queue.length; index++) {
	    watcher = queue[index];
	    id = watcher.id;
	    has$1[id] = null;
	    watcher.run();
	    // in dev build, check and stop circular updates.
	    if (false) {
	      circular[id] = (circular[id] || 0) + 1;
	      if (circular[id] > config._maxUpdateCount) {
	        warn(
	          'You may have an infinite update loop ' + (
	            watcher.user
	              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
	              : "in a component render function."
	          ),
	          watcher.vm
	        );
	        break
	      }
	    }
	  }
	
	  // call updated hooks
	  index = queue.length;
	  while (index--) {
	    watcher = queue[index];
	    vm = watcher.vm;
	    if (vm._watcher === watcher && vm._isMounted) {
	      callHook(vm, 'updated');
	    }
	  }
	
	  // devtool hook
	  /* istanbul ignore if */
	  if (devtools && config.devtools) {
	    devtools.emit('flush');
	  }
	
	  resetSchedulerState();
	}
	
	/**
	 * Push a watcher into the watcher queue.
	 * Jobs with duplicate IDs will be skipped unless it's
	 * pushed when the queue is being flushed.
	 */
	function queueWatcher (watcher) {
	  var id = watcher.id;
	  if (has$1[id] == null) {
	    has$1[id] = true;
	    if (!flushing) {
	      queue.push(watcher);
	    } else {
	      // if already flushing, splice the watcher based on its id
	      // if already past its id, it will be run next immediately.
	      var i = queue.length - 1;
	      while (i >= 0 && queue[i].id > watcher.id) {
	        i--;
	      }
	      queue.splice(Math.max(i, index) + 1, 0, watcher);
	    }
	    // queue the flush
	    if (!waiting) {
	      waiting = true;
	      nextTick(flushSchedulerQueue);
	    }
	  }
	}
	
	/*  */
	
	var uid$2 = 0;
	
	/**
	 * A watcher parses an expression, collects dependencies,
	 * and fires callback when the expression value changes.
	 * This is used for both the $watch() api and directives.
	 */
	var Watcher = function Watcher (
	  vm,
	  expOrFn,
	  cb,
	  options
	) {
	  this.vm = vm;
	  vm._watchers.push(this);
	  // options
	  if (options) {
	    this.deep = !!options.deep;
	    this.user = !!options.user;
	    this.lazy = !!options.lazy;
	    this.sync = !!options.sync;
	  } else {
	    this.deep = this.user = this.lazy = this.sync = false;
	  }
	  this.cb = cb;
	  this.id = ++uid$2; // uid for batching
	  this.active = true;
	  this.dirty = this.lazy; // for lazy watchers
	  this.deps = [];
	  this.newDeps = [];
	  this.depIds = new _Set();
	  this.newDepIds = new _Set();
	  this.expression =  false
	    ? expOrFn.toString()
	    : '';
	  // parse expression for getter
	  if (typeof expOrFn === 'function') {
	    this.getter = expOrFn;
	  } else {
	    this.getter = parsePath(expOrFn);
	    if (!this.getter) {
	      this.getter = function () {};
	      ("production") !== 'production' && warn(
	        "Failed watching path: \"" + expOrFn + "\" " +
	        'Watcher only accepts simple dot-delimited paths. ' +
	        'For full control, use a function instead.',
	        vm
	      );
	    }
	  }
	  this.value = this.lazy
	    ? undefined
	    : this.get();
	};
	
	/**
	 * Evaluate the getter, and re-collect dependencies.
	 */
	Watcher.prototype.get = function get () {
	  pushTarget(this);
	  var value = this.getter.call(this.vm, this.vm);
	  // "touch" every property so they are all tracked as
	  // dependencies for deep watching
	  if (this.deep) {
	    traverse(value);
	  }
	  popTarget();
	  this.cleanupDeps();
	  return value
	};
	
	/**
	 * Add a dependency to this directive.
	 */
	Watcher.prototype.addDep = function addDep (dep) {
	  var id = dep.id;
	  if (!this.newDepIds.has(id)) {
	    this.newDepIds.add(id);
	    this.newDeps.push(dep);
	    if (!this.depIds.has(id)) {
	      dep.addSub(this);
	    }
	  }
	};
	
	/**
	 * Clean up for dependency collection.
	 */
	Watcher.prototype.cleanupDeps = function cleanupDeps () {
	    var this$1 = this;
	
	  var i = this.deps.length;
	  while (i--) {
	    var dep = this$1.deps[i];
	    if (!this$1.newDepIds.has(dep.id)) {
	      dep.removeSub(this$1);
	    }
	  }
	  var tmp = this.depIds;
	  this.depIds = this.newDepIds;
	  this.newDepIds = tmp;
	  this.newDepIds.clear();
	  tmp = this.deps;
	  this.deps = this.newDeps;
	  this.newDeps = tmp;
	  this.newDeps.length = 0;
	};
	
	/**
	 * Subscriber interface.
	 * Will be called when a dependency changes.
	 */
	Watcher.prototype.update = function update () {
	  /* istanbul ignore else */
	  if (this.lazy) {
	    this.dirty = true;
	  } else if (this.sync) {
	    this.run();
	  } else {
	    queueWatcher(this);
	  }
	};
	
	/**
	 * Scheduler job interface.
	 * Will be called by the scheduler.
	 */
	Watcher.prototype.run = function run () {
	  if (this.active) {
	    var value = this.get();
	    if (
	      value !== this.value ||
	      // Deep watchers and watchers on Object/Arrays should fire even
	      // when the value is the same, because the value may
	      // have mutated.
	      isObject(value) ||
	      this.deep
	    ) {
	      // set new value
	      var oldValue = this.value;
	      this.value = value;
	      if (this.user) {
	        try {
	          this.cb.call(this.vm, value, oldValue);
	        } catch (e) {
	          /* istanbul ignore else */
	          if (config.errorHandler) {
	            config.errorHandler.call(null, e, this.vm);
	          } else {
	            ("production") !== 'production' && warn(
	              ("Error in watcher \"" + (this.expression) + "\""),
	              this.vm
	            );
	            throw e
	          }
	        }
	      } else {
	        this.cb.call(this.vm, value, oldValue);
	      }
	    }
	  }
	};
	
	/**
	 * Evaluate the value of the watcher.
	 * This only gets called for lazy watchers.
	 */
	Watcher.prototype.evaluate = function evaluate () {
	  this.value = this.get();
	  this.dirty = false;
	};
	
	/**
	 * Depend on all deps collected by this watcher.
	 */
	Watcher.prototype.depend = function depend () {
	    var this$1 = this;
	
	  var i = this.deps.length;
	  while (i--) {
	    this$1.deps[i].depend();
	  }
	};
	
	/**
	 * Remove self from all dependencies' subscriber list.
	 */
	Watcher.prototype.teardown = function teardown () {
	    var this$1 = this;
	
	  if (this.active) {
	    // remove self from vm's watcher list
	    // this is a somewhat expensive operation so we skip it
	    // if the vm is being destroyed.
	    if (!this.vm._isBeingDestroyed) {
	      remove$1(this.vm._watchers, this);
	    }
	    var i = this.deps.length;
	    while (i--) {
	      this$1.deps[i].removeSub(this$1);
	    }
	    this.active = false;
	  }
	};
	
	/**
	 * Recursively traverse an object to evoke all converted
	 * getters, so that every nested property inside the object
	 * is collected as a "deep" dependency.
	 */
	var seenObjects = new _Set();
	function traverse (val) {
	  seenObjects.clear();
	  _traverse(val, seenObjects);
	}
	
	function _traverse (val, seen) {
	  var i, keys;
	  var isA = Array.isArray(val);
	  if ((!isA && !isObject(val)) || !Object.isExtensible(val)) {
	    return
	  }
	  if (val.__ob__) {
	    var depId = val.__ob__.dep.id;
	    if (seen.has(depId)) {
	      return
	    }
	    seen.add(depId);
	  }
	  if (isA) {
	    i = val.length;
	    while (i--) { _traverse(val[i], seen); }
	  } else {
	    keys = Object.keys(val);
	    i = keys.length;
	    while (i--) { _traverse(val[keys[i]], seen); }
	  }
	}
	
	/*  */
	
	function initState (vm) {
	  vm._watchers = [];
	  var opts = vm.$options;
	  if (opts.props) { initProps(vm, opts.props); }
	  if (opts.methods) { initMethods(vm, opts.methods); }
	  if (opts.data) {
	    initData(vm);
	  } else {
	    observe(vm._data = {}, true /* asRootData */);
	  }
	  if (opts.computed) { initComputed(vm, opts.computed); }
	  if (opts.watch) { initWatch(vm, opts.watch); }
	}
	
	var isReservedProp = { key: 1, ref: 1, slot: 1 };
	
	function initProps (vm, props) {
	  var propsData = vm.$options.propsData || {};
	  var keys = vm.$options._propKeys = Object.keys(props);
	  var isRoot = !vm.$parent;
	  // root instance props should be converted
	  observerState.shouldConvert = isRoot;
	  var loop = function ( i ) {
	    var key = keys[i];
	    /* istanbul ignore else */
	    if (false) {
	      if (isReservedProp[key]) {
	        warn(
	          ("\"" + key + "\" is a reserved attribute and cannot be used as component prop."),
	          vm
	        );
	      }
	      defineReactive$$1(vm, key, validateProp(key, props, propsData, vm), function () {
	        if (vm.$parent && !observerState.isSettingProps) {
	          warn(
	            "Avoid mutating a prop directly since the value will be " +
	            "overwritten whenever the parent component re-renders. " +
	            "Instead, use a data or computed property based on the prop's " +
	            "value. Prop being mutated: \"" + key + "\"",
	            vm
	          );
	        }
	      });
	    } else {
	      defineReactive$$1(vm, key, validateProp(key, props, propsData, vm));
	    }
	  };
	
	  for (var i = 0; i < keys.length; i++) loop( i );
	  observerState.shouldConvert = true;
	}
	
	function initData (vm) {
	  var data = vm.$options.data;
	  data = vm._data = typeof data === 'function'
	    ? data.call(vm)
	    : data || {};
	  if (!isPlainObject(data)) {
	    data = {};
	    ("production") !== 'production' && warn(
	      'data functions should return an object:\n' +
	      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
	      vm
	    );
	  }
	  // proxy data on instance
	  var keys = Object.keys(data);
	  var props = vm.$options.props;
	  var i = keys.length;
	  while (i--) {
	    if (props && hasOwn(props, keys[i])) {
	      ("production") !== 'production' && warn(
	        "The data property \"" + (keys[i]) + "\" is already declared as a prop. " +
	        "Use prop default value instead.",
	        vm
	      );
	    } else {
	      proxy(vm, keys[i]);
	    }
	  }
	  // observe data
	  observe(data, true /* asRootData */);
	}
	
	var computedSharedDefinition = {
	  enumerable: true,
	  configurable: true,
	  get: noop,
	  set: noop
	};
	
	function initComputed (vm, computed) {
	  for (var key in computed) {
	    /* istanbul ignore if */
	    if (false) {
	      warn(
	        "existing instance property \"" + key + "\" will be " +
	        "overwritten by a computed property with the same name.",
	        vm
	      );
	    }
	    var userDef = computed[key];
	    if (typeof userDef === 'function') {
	      computedSharedDefinition.get = makeComputedGetter(userDef, vm);
	      computedSharedDefinition.set = noop;
	    } else {
	      computedSharedDefinition.get = userDef.get
	        ? userDef.cache !== false
	          ? makeComputedGetter(userDef.get, vm)
	          : bind$1(userDef.get, vm)
	        : noop;
	      computedSharedDefinition.set = userDef.set
	        ? bind$1(userDef.set, vm)
	        : noop;
	    }
	    Object.defineProperty(vm, key, computedSharedDefinition);
	  }
	}
	
	function makeComputedGetter (getter, owner) {
	  var watcher = new Watcher(owner, getter, noop, {
	    lazy: true
	  });
	  return function computedGetter () {
	    if (watcher.dirty) {
	      watcher.evaluate();
	    }
	    if (Dep.target) {
	      watcher.depend();
	    }
	    return watcher.value
	  }
	}
	
	function initMethods (vm, methods) {
	  for (var key in methods) {
	    vm[key] = methods[key] == null ? noop : bind$1(methods[key], vm);
	    if (false) {
	      warn(
	        "method \"" + key + "\" has an undefined value in the component definition. " +
	        "Did you reference the function correctly?",
	        vm
	      );
	    }
	  }
	}
	
	function initWatch (vm, watch) {
	  for (var key in watch) {
	    var handler = watch[key];
	    if (Array.isArray(handler)) {
	      for (var i = 0; i < handler.length; i++) {
	        createWatcher(vm, key, handler[i]);
	      }
	    } else {
	      createWatcher(vm, key, handler);
	    }
	  }
	}
	
	function createWatcher (vm, key, handler) {
	  var options;
	  if (isPlainObject(handler)) {
	    options = handler;
	    handler = handler.handler;
	  }
	  if (typeof handler === 'string') {
	    handler = vm[handler];
	  }
	  vm.$watch(key, handler, options);
	}
	
	function stateMixin (Vue) {
	  // flow somehow has problems with directly declared definition object
	  // when using Object.defineProperty, so we have to procedurally build up
	  // the object here.
	  var dataDef = {};
	  dataDef.get = function () {
	    return this._data
	  };
	  if (false) {
	    dataDef.set = function (newData) {
	      warn(
	        'Avoid replacing instance root $data. ' +
	        'Use nested data properties instead.',
	        this
	      );
	    };
	  }
	  Object.defineProperty(Vue.prototype, '$data', dataDef);
	
	  Vue.prototype.$set = set$1;
	  Vue.prototype.$delete = del;
	
	  Vue.prototype.$watch = function (
	    expOrFn,
	    cb,
	    options
	  ) {
	    var vm = this;
	    options = options || {};
	    options.user = true;
	    var watcher = new Watcher(vm, expOrFn, cb, options);
	    if (options.immediate) {
	      cb.call(vm, watcher.value);
	    }
	    return function unwatchFn () {
	      watcher.teardown();
	    }
	  };
	}
	
	function proxy (vm, key) {
	  if (!isReserved(key)) {
	    Object.defineProperty(vm, key, {
	      configurable: true,
	      enumerable: true,
	      get: function proxyGetter () {
	        return vm._data[key]
	      },
	      set: function proxySetter (val) {
	        vm._data[key] = val;
	      }
	    });
	  }
	}
	
	/*  */
	
	var uid = 0;
	
	function initMixin (Vue) {
	  Vue.prototype._init = function (options) {
	    var vm = this;
	    // a uid
	    vm._uid = uid++;
	    // a flag to avoid this being observed
	    vm._isVue = true;
	    // merge options
	    if (options && options._isComponent) {
	      // optimize internal component instantiation
	      // since dynamic options merging is pretty slow, and none of the
	      // internal component options needs special treatment.
	      initInternalComponent(vm, options);
	    } else {
	      vm.$options = mergeOptions(
	        resolveConstructorOptions(vm.constructor),
	        options || {},
	        vm
	      );
	    }
	    /* istanbul ignore else */
	    if (false) {
	      initProxy(vm);
	    } else {
	      vm._renderProxy = vm;
	    }
	    // expose real self
	    vm._self = vm;
	    initLifecycle(vm);
	    initEvents(vm);
	    initRender(vm);
	    callHook(vm, 'beforeCreate');
	    initState(vm);
	    callHook(vm, 'created');
	    if (vm.$options.el) {
	      vm.$mount(vm.$options.el);
	    }
	  };
	}
	
	function initInternalComponent (vm, options) {
	  var opts = vm.$options = Object.create(vm.constructor.options);
	  // doing this because it's faster than dynamic enumeration.
	  opts.parent = options.parent;
	  opts.propsData = options.propsData;
	  opts._parentVnode = options._parentVnode;
	  opts._parentListeners = options._parentListeners;
	  opts._renderChildren = options._renderChildren;
	  opts._componentTag = options._componentTag;
	  opts._parentElm = options._parentElm;
	  opts._refElm = options._refElm;
	  if (options.render) {
	    opts.render = options.render;
	    opts.staticRenderFns = options.staticRenderFns;
	  }
	}
	
	function resolveConstructorOptions (Ctor) {
	  var options = Ctor.options;
	  if (Ctor.super) {
	    var superOptions = Ctor.super.options;
	    var cachedSuperOptions = Ctor.superOptions;
	    var extendOptions = Ctor.extendOptions;
	    if (superOptions !== cachedSuperOptions) {
	      // super option changed
	      Ctor.superOptions = superOptions;
	      extendOptions.render = options.render;
	      extendOptions.staticRenderFns = options.staticRenderFns;
	      extendOptions._scopeId = options._scopeId;
	      options = Ctor.options = mergeOptions(superOptions, extendOptions);
	      if (options.name) {
	        options.components[options.name] = Ctor;
	      }
	    }
	  }
	  return options
	}
	
	function Vue$3 (options) {
	  if (false) {
	    warn('Vue is a constructor and should be called with the `new` keyword');
	  }
	  this._init(options);
	}
	
	initMixin(Vue$3);
	stateMixin(Vue$3);
	eventsMixin(Vue$3);
	lifecycleMixin(Vue$3);
	renderMixin(Vue$3);
	
	/*  */
	
	function initUse (Vue) {
	  Vue.use = function (plugin) {
	    /* istanbul ignore if */
	    if (plugin.installed) {
	      return
	    }
	    // additional parameters
	    var args = toArray(arguments, 1);
	    args.unshift(this);
	    if (typeof plugin.install === 'function') {
	      plugin.install.apply(plugin, args);
	    } else {
	      plugin.apply(null, args);
	    }
	    plugin.installed = true;
	    return this
	  };
	}
	
	/*  */
	
	function initMixin$1 (Vue) {
	  Vue.mixin = function (mixin) {
	    this.options = mergeOptions(this.options, mixin);
	  };
	}
	
	/*  */
	
	function initExtend (Vue) {
	  /**
	   * Each instance constructor, including Vue, has a unique
	   * cid. This enables us to create wrapped "child
	   * constructors" for prototypal inheritance and cache them.
	   */
	  Vue.cid = 0;
	  var cid = 1;
	
	  /**
	   * Class inheritance
	   */
	  Vue.extend = function (extendOptions) {
	    extendOptions = extendOptions || {};
	    var Super = this;
	    var SuperId = Super.cid;
	    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
	    if (cachedCtors[SuperId]) {
	      return cachedCtors[SuperId]
	    }
	    var name = extendOptions.name || Super.options.name;
	    if (false) {
	      if (!/^[a-zA-Z][\w-]*$/.test(name)) {
	        warn(
	          'Invalid component name: "' + name + '". Component names ' +
	          'can only contain alphanumeric characters and the hyphen, ' +
	          'and must start with a letter.'
	        );
	      }
	    }
	    var Sub = function VueComponent (options) {
	      this._init(options);
	    };
	    Sub.prototype = Object.create(Super.prototype);
	    Sub.prototype.constructor = Sub;
	    Sub.cid = cid++;
	    Sub.options = mergeOptions(
	      Super.options,
	      extendOptions
	    );
	    Sub['super'] = Super;
	    // allow further extension/mixin/plugin usage
	    Sub.extend = Super.extend;
	    Sub.mixin = Super.mixin;
	    Sub.use = Super.use;
	    // create asset registers, so extended classes
	    // can have their private assets too.
	    config._assetTypes.forEach(function (type) {
	      Sub[type] = Super[type];
	    });
	    // enable recursive self-lookup
	    if (name) {
	      Sub.options.components[name] = Sub;
	    }
	    // keep a reference to the super options at extension time.
	    // later at instantiation we can check if Super's options have
	    // been updated.
	    Sub.superOptions = Super.options;
	    Sub.extendOptions = extendOptions;
	    // cache constructor
	    cachedCtors[SuperId] = Sub;
	    return Sub
	  };
	}
	
	/*  */
	
	function initAssetRegisters (Vue) {
	  /**
	   * Create asset registration methods.
	   */
	  config._assetTypes.forEach(function (type) {
	    Vue[type] = function (
	      id,
	      definition
	    ) {
	      if (!definition) {
	        return this.options[type + 's'][id]
	      } else {
	        /* istanbul ignore if */
	        if (false) {
	          if (type === 'component' && config.isReservedTag(id)) {
	            warn(
	              'Do not use built-in or reserved HTML elements as component ' +
	              'id: ' + id
	            );
	          }
	        }
	        if (type === 'component' && isPlainObject(definition)) {
	          definition.name = definition.name || id;
	          definition = this.options._base.extend(definition);
	        }
	        if (type === 'directive' && typeof definition === 'function') {
	          definition = { bind: definition, update: definition };
	        }
	        this.options[type + 's'][id] = definition;
	        return definition
	      }
	    };
	  });
	}
	
	/*  */
	
	var patternTypes = [String, RegExp];
	
	function getComponentName (opts) {
	  return opts && (opts.Ctor.options.name || opts.tag)
	}
	
	function matches (pattern, name) {
	  if (typeof pattern === 'string') {
	    return pattern.split(',').indexOf(name) > -1
	  } else {
	    return pattern.test(name)
	  }
	}
	
	function pruneCache (cache, filter) {
	  for (var key in cache) {
	    var cachedNode = cache[key];
	    if (cachedNode) {
	      var name = getComponentName(cachedNode.componentOptions);
	      if (name && !filter(name)) {
	        pruneCacheEntry(cachedNode);
	        cache[key] = null;
	      }
	    }
	  }
	}
	
	function pruneCacheEntry (vnode) {
	  if (vnode) {
	    if (!vnode.componentInstance._inactive) {
	      callHook(vnode.componentInstance, 'deactivated');
	    }
	    vnode.componentInstance.$destroy();
	  }
	}
	
	var KeepAlive = {
	  name: 'keep-alive',
	  abstract: true,
	
	  props: {
	    include: patternTypes,
	    exclude: patternTypes
	  },
	
	  created: function created () {
	    this.cache = Object.create(null);
	  },
	
	  destroyed: function destroyed () {
	    var this$1 = this;
	
	    for (var key in this.cache) {
	      pruneCacheEntry(this$1.cache[key]);
	    }
	  },
	
	  watch: {
	    include: function include (val) {
	      pruneCache(this.cache, function (name) { return matches(val, name); });
	    },
	    exclude: function exclude (val) {
	      pruneCache(this.cache, function (name) { return !matches(val, name); });
	    }
	  },
	
	  render: function render () {
	    var vnode = getFirstComponentChild(this.$slots.default);
	    var componentOptions = vnode && vnode.componentOptions;
	    if (componentOptions) {
	      // check pattern
	      var name = getComponentName(componentOptions);
	      if (name && (
	        (this.include && !matches(this.include, name)) ||
	        (this.exclude && matches(this.exclude, name))
	      )) {
	        return vnode
	      }
	      var key = vnode.key == null
	        // same constructor may get registered as different local components
	        // so cid alone is not enough (#3269)
	        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
	        : vnode.key;
	      if (this.cache[key]) {
	        vnode.componentInstance = this.cache[key].componentInstance;
	      } else {
	        this.cache[key] = vnode;
	      }
	      vnode.data.keepAlive = true;
	    }
	    return vnode
	  }
	};
	
	var builtInComponents = {
	  KeepAlive: KeepAlive
	};
	
	/*  */
	
	function initGlobalAPI (Vue) {
	  // config
	  var configDef = {};
	  configDef.get = function () { return config; };
	  if (false) {
	    configDef.set = function () {
	      warn(
	        'Do not replace the Vue.config object, set individual fields instead.'
	      );
	    };
	  }
	  Object.defineProperty(Vue, 'config', configDef);
	  Vue.util = util;
	  Vue.set = set$1;
	  Vue.delete = del;
	  Vue.nextTick = nextTick;
	
	  Vue.options = Object.create(null);
	  config._assetTypes.forEach(function (type) {
	    Vue.options[type + 's'] = Object.create(null);
	  });
	
	  // this is used to identify the "base" constructor to extend all plain-object
	  // components with in Weex's multi-instance scenarios.
	  Vue.options._base = Vue;
	
	  extend(Vue.options.components, builtInComponents);
	
	  initUse(Vue);
	  initMixin$1(Vue);
	  initExtend(Vue);
	  initAssetRegisters(Vue);
	}
	
	initGlobalAPI(Vue$3);
	
	Object.defineProperty(Vue$3.prototype, '$isServer', {
	  get: isServerRendering
	});
	
	Vue$3.version = '2.1.10';
	
	/*  */
	
	// attributes that should be using props for binding
	var acceptValue = makeMap('input,textarea,option,select');
	var mustUseProp = function (tag, type, attr) {
	  return (
	    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
	    (attr === 'selected' && tag === 'option') ||
	    (attr === 'checked' && tag === 'input') ||
	    (attr === 'muted' && tag === 'video')
	  )
	};
	
	var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
	
	var isBooleanAttr = makeMap(
	  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
	  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
	  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
	  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
	  'required,reversed,scoped,seamless,selected,sortable,translate,' +
	  'truespeed,typemustmatch,visible'
	);
	
	var xlinkNS = 'http://www.w3.org/1999/xlink';
	
	var isXlink = function (name) {
	  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
	};
	
	var getXlinkProp = function (name) {
	  return isXlink(name) ? name.slice(6, name.length) : ''
	};
	
	var isFalsyAttrValue = function (val) {
	  return val == null || val === false
	};
	
	/*  */
	
	function genClassForVnode (vnode) {
	  var data = vnode.data;
	  var parentNode = vnode;
	  var childNode = vnode;
	  while (childNode.componentInstance) {
	    childNode = childNode.componentInstance._vnode;
	    if (childNode.data) {
	      data = mergeClassData(childNode.data, data);
	    }
	  }
	  while ((parentNode = parentNode.parent)) {
	    if (parentNode.data) {
	      data = mergeClassData(data, parentNode.data);
	    }
	  }
	  return genClassFromData(data)
	}
	
	function mergeClassData (child, parent) {
	  return {
	    staticClass: concat(child.staticClass, parent.staticClass),
	    class: child.class
	      ? [child.class, parent.class]
	      : parent.class
	  }
	}
	
	function genClassFromData (data) {
	  var dynamicClass = data.class;
	  var staticClass = data.staticClass;
	  if (staticClass || dynamicClass) {
	    return concat(staticClass, stringifyClass(dynamicClass))
	  }
	  /* istanbul ignore next */
	  return ''
	}
	
	function concat (a, b) {
	  return a ? b ? (a + ' ' + b) : a : (b || '')
	}
	
	function stringifyClass (value) {
	  var res = '';
	  if (!value) {
	    return res
	  }
	  if (typeof value === 'string') {
	    return value
	  }
	  if (Array.isArray(value)) {
	    var stringified;
	    for (var i = 0, l = value.length; i < l; i++) {
	      if (value[i]) {
	        if ((stringified = stringifyClass(value[i]))) {
	          res += stringified + ' ';
	        }
	      }
	    }
	    return res.slice(0, -1)
	  }
	  if (isObject(value)) {
	    for (var key in value) {
	      if (value[key]) { res += key + ' '; }
	    }
	    return res.slice(0, -1)
	  }
	  /* istanbul ignore next */
	  return res
	}
	
	/*  */
	
	var namespaceMap = {
	  svg: 'http://www.w3.org/2000/svg',
	  math: 'http://www.w3.org/1998/Math/MathML'
	};
	
	var isHTMLTag = makeMap(
	  'html,body,base,head,link,meta,style,title,' +
	  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
	  'div,dd,dl,dt,figcaption,figure,hr,img,li,main,ol,p,pre,ul,' +
	  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
	  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
	  'embed,object,param,source,canvas,script,noscript,del,ins,' +
	  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
	  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
	  'output,progress,select,textarea,' +
	  'details,dialog,menu,menuitem,summary,' +
	  'content,element,shadow,template'
	);
	
	// this map is intentionally selective, only covering SVG elements that may
	// contain child elements.
	var isSVG = makeMap(
	  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,' +
	  'font-face,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
	  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
	  true
	);
	
	var isPreTag = function (tag) { return tag === 'pre'; };
	
	var isReservedTag = function (tag) {
	  return isHTMLTag(tag) || isSVG(tag)
	};
	
	function getTagNamespace (tag) {
	  if (isSVG(tag)) {
	    return 'svg'
	  }
	  // basic support for MathML
	  // note it doesn't support other MathML elements being component roots
	  if (tag === 'math') {
	    return 'math'
	  }
	}
	
	var unknownElementCache = Object.create(null);
	function isUnknownElement (tag) {
	  /* istanbul ignore if */
	  if (!inBrowser) {
	    return true
	  }
	  if (isReservedTag(tag)) {
	    return false
	  }
	  tag = tag.toLowerCase();
	  /* istanbul ignore if */
	  if (unknownElementCache[tag] != null) {
	    return unknownElementCache[tag]
	  }
	  var el = document.createElement(tag);
	  if (tag.indexOf('-') > -1) {
	    // http://stackoverflow.com/a/28210364/1070244
	    return (unknownElementCache[tag] = (
	      el.constructor === window.HTMLUnknownElement ||
	      el.constructor === window.HTMLElement
	    ))
	  } else {
	    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
	  }
	}
	
	/*  */
	
	/**
	 * Query an element selector if it's not an element already.
	 */
	function query (el) {
	  if (typeof el === 'string') {
	    var selector = el;
	    el = document.querySelector(el);
	    if (!el) {
	      ("production") !== 'production' && warn(
	        'Cannot find element: ' + selector
	      );
	      return document.createElement('div')
	    }
	  }
	  return el
	}
	
	/*  */
	
	function createElement$1 (tagName, vnode) {
	  var elm = document.createElement(tagName);
	  if (tagName !== 'select') {
	    return elm
	  }
	  if (vnode.data && vnode.data.attrs && 'multiple' in vnode.data.attrs) {
	    elm.setAttribute('multiple', 'multiple');
	  }
	  return elm
	}
	
	function createElementNS (namespace, tagName) {
	  return document.createElementNS(namespaceMap[namespace], tagName)
	}
	
	function createTextNode (text) {
	  return document.createTextNode(text)
	}
	
	function createComment (text) {
	  return document.createComment(text)
	}
	
	function insertBefore (parentNode, newNode, referenceNode) {
	  parentNode.insertBefore(newNode, referenceNode);
	}
	
	function removeChild (node, child) {
	  node.removeChild(child);
	}
	
	function appendChild (node, child) {
	  node.appendChild(child);
	}
	
	function parentNode (node) {
	  return node.parentNode
	}
	
	function nextSibling (node) {
	  return node.nextSibling
	}
	
	function tagName (node) {
	  return node.tagName
	}
	
	function setTextContent (node, text) {
	  node.textContent = text;
	}
	
	function setAttribute (node, key, val) {
	  node.setAttribute(key, val);
	}
	
	
	var nodeOps = Object.freeze({
		createElement: createElement$1,
		createElementNS: createElementNS,
		createTextNode: createTextNode,
		createComment: createComment,
		insertBefore: insertBefore,
		removeChild: removeChild,
		appendChild: appendChild,
		parentNode: parentNode,
		nextSibling: nextSibling,
		tagName: tagName,
		setTextContent: setTextContent,
		setAttribute: setAttribute
	});
	
	/*  */
	
	var ref = {
	  create: function create (_, vnode) {
	    registerRef(vnode);
	  },
	  update: function update (oldVnode, vnode) {
	    if (oldVnode.data.ref !== vnode.data.ref) {
	      registerRef(oldVnode, true);
	      registerRef(vnode);
	    }
	  },
	  destroy: function destroy (vnode) {
	    registerRef(vnode, true);
	  }
	};
	
	function registerRef (vnode, isRemoval) {
	  var key = vnode.data.ref;
	  if (!key) { return }
	
	  var vm = vnode.context;
	  var ref = vnode.componentInstance || vnode.elm;
	  var refs = vm.$refs;
	  if (isRemoval) {
	    if (Array.isArray(refs[key])) {
	      remove$1(refs[key], ref);
	    } else if (refs[key] === ref) {
	      refs[key] = undefined;
	    }
	  } else {
	    if (vnode.data.refInFor) {
	      if (Array.isArray(refs[key]) && refs[key].indexOf(ref) < 0) {
	        refs[key].push(ref);
	      } else {
	        refs[key] = [ref];
	      }
	    } else {
	      refs[key] = ref;
	    }
	  }
	}
	
	/**
	 * Virtual DOM patching algorithm based on Snabbdom by
	 * Simon Friis Vindum (@paldepind)
	 * Licensed under the MIT License
	 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
	 *
	 * modified by Evan You (@yyx990803)
	 *
	
	/*
	 * Not type-checking this because this file is perf-critical and the cost
	 * of making flow understand it is not worth it.
	 */
	
	var emptyNode = new VNode('', {}, []);
	
	var hooks$1 = ['create', 'activate', 'update', 'remove', 'destroy'];
	
	function isUndef (s) {
	  return s == null
	}
	
	function isDef (s) {
	  return s != null
	}
	
	function sameVnode (vnode1, vnode2) {
	  return (
	    vnode1.key === vnode2.key &&
	    vnode1.tag === vnode2.tag &&
	    vnode1.isComment === vnode2.isComment &&
	    !vnode1.data === !vnode2.data
	  )
	}
	
	function createKeyToOldIdx (children, beginIdx, endIdx) {
	  var i, key;
	  var map = {};
	  for (i = beginIdx; i <= endIdx; ++i) {
	    key = children[i].key;
	    if (isDef(key)) { map[key] = i; }
	  }
	  return map
	}
	
	function createPatchFunction (backend) {
	  var i, j;
	  var cbs = {};
	
	  var modules = backend.modules;
	  var nodeOps = backend.nodeOps;
	
	  for (i = 0; i < hooks$1.length; ++i) {
	    cbs[hooks$1[i]] = [];
	    for (j = 0; j < modules.length; ++j) {
	      if (modules[j][hooks$1[i]] !== undefined) { cbs[hooks$1[i]].push(modules[j][hooks$1[i]]); }
	    }
	  }
	
	  function emptyNodeAt (elm) {
	    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
	  }
	
	  function createRmCb (childElm, listeners) {
	    function remove$$1 () {
	      if (--remove$$1.listeners === 0) {
	        removeNode(childElm);
	      }
	    }
	    remove$$1.listeners = listeners;
	    return remove$$1
	  }
	
	  function removeNode (el) {
	    var parent = nodeOps.parentNode(el);
	    // element may have already been removed due to v-html / v-text
	    if (parent) {
	      nodeOps.removeChild(parent, el);
	    }
	  }
	
	  var inPre = 0;
	  function createElm (vnode, insertedVnodeQueue, parentElm, refElm, nested) {
	    vnode.isRootInsert = !nested; // for transition enter check
	    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
	      return
	    }
	
	    var data = vnode.data;
	    var children = vnode.children;
	    var tag = vnode.tag;
	    if (isDef(tag)) {
	      if (false) {
	        if (data && data.pre) {
	          inPre++;
	        }
	        if (
	          !inPre &&
	          !vnode.ns &&
	          !(config.ignoredElements.length && config.ignoredElements.indexOf(tag) > -1) &&
	          config.isUnknownElement(tag)
	        ) {
	          warn(
	            'Unknown custom element: <' + tag + '> - did you ' +
	            'register the component correctly? For recursive components, ' +
	            'make sure to provide the "name" option.',
	            vnode.context
	          );
	        }
	      }
	      vnode.elm = vnode.ns
	        ? nodeOps.createElementNS(vnode.ns, tag)
	        : nodeOps.createElement(tag, vnode);
	      setScope(vnode);
	
	      /* istanbul ignore if */
	      {
	        createChildren(vnode, children, insertedVnodeQueue);
	        if (isDef(data)) {
	          invokeCreateHooks(vnode, insertedVnodeQueue);
	        }
	        insert(parentElm, vnode.elm, refElm);
	      }
	
	      if (false) {
	        inPre--;
	      }
	    } else if (vnode.isComment) {
	      vnode.elm = nodeOps.createComment(vnode.text);
	      insert(parentElm, vnode.elm, refElm);
	    } else {
	      vnode.elm = nodeOps.createTextNode(vnode.text);
	      insert(parentElm, vnode.elm, refElm);
	    }
	  }
	
	  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
	    var i = vnode.data;
	    if (isDef(i)) {
	      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
	      if (isDef(i = i.hook) && isDef(i = i.init)) {
	        i(vnode, false /* hydrating */, parentElm, refElm);
	      }
	      // after calling the init hook, if the vnode is a child component
	      // it should've created a child instance and mounted it. the child
	      // component also has set the placeholder vnode's elm.
	      // in that case we can just return the element and be done.
	      if (isDef(vnode.componentInstance)) {
	        initComponent(vnode, insertedVnodeQueue);
	        if (isReactivated) {
	          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
	        }
	        return true
	      }
	    }
	  }
	
	  function initComponent (vnode, insertedVnodeQueue) {
	    if (vnode.data.pendingInsert) {
	      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
	    }
	    vnode.elm = vnode.componentInstance.$el;
	    if (isPatchable(vnode)) {
	      invokeCreateHooks(vnode, insertedVnodeQueue);
	      setScope(vnode);
	    } else {
	      // empty component root.
	      // skip all element-related modules except for ref (#3455)
	      registerRef(vnode);
	      // make sure to invoke the insert hook
	      insertedVnodeQueue.push(vnode);
	    }
	  }
	
	  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
	    var i;
	    // hack for #4339: a reactivated component with inner transition
	    // does not trigger because the inner node's created hooks are not called
	    // again. It's not ideal to involve module-specific logic in here but
	    // there doesn't seem to be a better way to do it.
	    var innerNode = vnode;
	    while (innerNode.componentInstance) {
	      innerNode = innerNode.componentInstance._vnode;
	      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
	        for (i = 0; i < cbs.activate.length; ++i) {
	          cbs.activate[i](emptyNode, innerNode);
	        }
	        insertedVnodeQueue.push(innerNode);
	        break
	      }
	    }
	    // unlike a newly created component,
	    // a reactivated keep-alive component doesn't insert itself
	    insert(parentElm, vnode.elm, refElm);
	  }
	
	  function insert (parent, elm, ref) {
	    if (parent) {
	      if (ref) {
	        nodeOps.insertBefore(parent, elm, ref);
	      } else {
	        nodeOps.appendChild(parent, elm);
	      }
	    }
	  }
	
	  function createChildren (vnode, children, insertedVnodeQueue) {
	    if (Array.isArray(children)) {
	      for (var i = 0; i < children.length; ++i) {
	        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true);
	      }
	    } else if (isPrimitive(vnode.text)) {
	      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(vnode.text));
	    }
	  }
	
	  function isPatchable (vnode) {
	    while (vnode.componentInstance) {
	      vnode = vnode.componentInstance._vnode;
	    }
	    return isDef(vnode.tag)
	  }
	
	  function invokeCreateHooks (vnode, insertedVnodeQueue) {
	    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
	      cbs.create[i$1](emptyNode, vnode);
	    }
	    i = vnode.data.hook; // Reuse variable
	    if (isDef(i)) {
	      if (i.create) { i.create(emptyNode, vnode); }
	      if (i.insert) { insertedVnodeQueue.push(vnode); }
	    }
	  }
	
	  // set scope id attribute for scoped CSS.
	  // this is implemented as a special case to avoid the overhead
	  // of going through the normal attribute patching process.
	  function setScope (vnode) {
	    var i;
	    if (isDef(i = vnode.context) && isDef(i = i.$options._scopeId)) {
	      nodeOps.setAttribute(vnode.elm, i, '');
	    }
	    if (isDef(i = activeInstance) &&
	        i !== vnode.context &&
	        isDef(i = i.$options._scopeId)) {
	      nodeOps.setAttribute(vnode.elm, i, '');
	    }
	  }
	
	  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
	    for (; startIdx <= endIdx; ++startIdx) {
	      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm);
	    }
	  }
	
	  function invokeDestroyHook (vnode) {
	    var i, j;
	    var data = vnode.data;
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
	      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
	    }
	    if (isDef(i = vnode.children)) {
	      for (j = 0; j < vnode.children.length; ++j) {
	        invokeDestroyHook(vnode.children[j]);
	      }
	    }
	  }
	
	  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
	    for (; startIdx <= endIdx; ++startIdx) {
	      var ch = vnodes[startIdx];
	      if (isDef(ch)) {
	        if (isDef(ch.tag)) {
	          removeAndInvokeRemoveHook(ch);
	          invokeDestroyHook(ch);
	        } else { // Text node
	          removeNode(ch.elm);
	        }
	      }
	    }
	  }
	
	  function removeAndInvokeRemoveHook (vnode, rm) {
	    if (rm || isDef(vnode.data)) {
	      var listeners = cbs.remove.length + 1;
	      if (!rm) {
	        // directly removing
	        rm = createRmCb(vnode.elm, listeners);
	      } else {
	        // we have a recursively passed down rm callback
	        // increase the listeners count
	        rm.listeners += listeners;
	      }
	      // recursively invoke hooks on child component root node
	      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
	        removeAndInvokeRemoveHook(i, rm);
	      }
	      for (i = 0; i < cbs.remove.length; ++i) {
	        cbs.remove[i](vnode, rm);
	      }
	      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
	        i(vnode, rm);
	      } else {
	        rm();
	      }
	    } else {
	      removeNode(vnode.elm);
	    }
	  }
	
	  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
	    var oldStartIdx = 0;
	    var newStartIdx = 0;
	    var oldEndIdx = oldCh.length - 1;
	    var oldStartVnode = oldCh[0];
	    var oldEndVnode = oldCh[oldEndIdx];
	    var newEndIdx = newCh.length - 1;
	    var newStartVnode = newCh[0];
	    var newEndVnode = newCh[newEndIdx];
	    var oldKeyToIdx, idxInOld, elmToMove, refElm;
	
	    // removeOnly is a special flag used only by <transition-group>
	    // to ensure removed elements stay in correct relative positions
	    // during leaving transitions
	    var canMove = !removeOnly;
	
	    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
	      if (isUndef(oldStartVnode)) {
	        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
	      } else if (isUndef(oldEndVnode)) {
	        oldEndVnode = oldCh[--oldEndIdx];
	      } else if (sameVnode(oldStartVnode, newStartVnode)) {
	        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
	        oldStartVnode = oldCh[++oldStartIdx];
	        newStartVnode = newCh[++newStartIdx];
	      } else if (sameVnode(oldEndVnode, newEndVnode)) {
	        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
	        oldEndVnode = oldCh[--oldEndIdx];
	        newEndVnode = newCh[--newEndIdx];
	      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
	        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
	        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
	        oldStartVnode = oldCh[++oldStartIdx];
	        newEndVnode = newCh[--newEndIdx];
	      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
	        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
	        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
	        oldEndVnode = oldCh[--oldEndIdx];
	        newStartVnode = newCh[++newStartIdx];
	      } else {
	        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
	        idxInOld = isDef(newStartVnode.key) ? oldKeyToIdx[newStartVnode.key] : null;
	        if (isUndef(idxInOld)) { // New element
	          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
	          newStartVnode = newCh[++newStartIdx];
	        } else {
	          elmToMove = oldCh[idxInOld];
	          /* istanbul ignore if */
	          if (false) {
	            warn(
	              'It seems there are duplicate keys that is causing an update error. ' +
	              'Make sure each v-for item has a unique key.'
	            );
	          }
	          if (sameVnode(elmToMove, newStartVnode)) {
	            patchVnode(elmToMove, newStartVnode, insertedVnodeQueue);
	            oldCh[idxInOld] = undefined;
	            canMove && nodeOps.insertBefore(parentElm, newStartVnode.elm, oldStartVnode.elm);
	            newStartVnode = newCh[++newStartIdx];
	          } else {
	            // same key but different element. treat as new element
	            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
	            newStartVnode = newCh[++newStartIdx];
	          }
	        }
	      }
	    }
	    if (oldStartIdx > oldEndIdx) {
	      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
	      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
	    } else if (newStartIdx > newEndIdx) {
	      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
	    }
	  }
	
	  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
	    if (oldVnode === vnode) {
	      return
	    }
	    // reuse element for static trees.
	    // note we only do this if the vnode is cloned -
	    // if the new node is not cloned it means the render functions have been
	    // reset by the hot-reload-api and we need to do a proper re-render.
	    if (vnode.isStatic &&
	        oldVnode.isStatic &&
	        vnode.key === oldVnode.key &&
	        (vnode.isCloned || vnode.isOnce)) {
	      vnode.elm = oldVnode.elm;
	      vnode.componentInstance = oldVnode.componentInstance;
	      return
	    }
	    var i;
	    var data = vnode.data;
	    var hasData = isDef(data);
	    if (hasData && isDef(i = data.hook) && isDef(i = i.prepatch)) {
	      i(oldVnode, vnode);
	    }
	    var elm = vnode.elm = oldVnode.elm;
	    var oldCh = oldVnode.children;
	    var ch = vnode.children;
	    if (hasData && isPatchable(vnode)) {
	      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
	      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
	    }
	    if (isUndef(vnode.text)) {
	      if (isDef(oldCh) && isDef(ch)) {
	        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
	      } else if (isDef(ch)) {
	        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
	        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
	      } else if (isDef(oldCh)) {
	        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
	      } else if (isDef(oldVnode.text)) {
	        nodeOps.setTextContent(elm, '');
	      }
	    } else if (oldVnode.text !== vnode.text) {
	      nodeOps.setTextContent(elm, vnode.text);
	    }
	    if (hasData) {
	      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
	    }
	  }
	
	  function invokeInsertHook (vnode, queue, initial) {
	    // delay insert hooks for component root nodes, invoke them after the
	    // element is really inserted
	    if (initial && vnode.parent) {
	      vnode.parent.data.pendingInsert = queue;
	    } else {
	      for (var i = 0; i < queue.length; ++i) {
	        queue[i].data.hook.insert(queue[i]);
	      }
	    }
	  }
	
	  var bailed = false;
	  // list of modules that can skip create hook during hydration because they
	  // are already rendered on the client or has no need for initialization
	  var isRenderedModule = makeMap('attrs,style,class,staticClass,staticStyle,key');
	
	  // Note: this is a browser-only function so we can assume elms are DOM nodes.
	  function hydrate (elm, vnode, insertedVnodeQueue) {
	    if (false) {
	      if (!assertNodeMatch(elm, vnode)) {
	        return false
	      }
	    }
	    vnode.elm = elm;
	    var tag = vnode.tag;
	    var data = vnode.data;
	    var children = vnode.children;
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
	      if (isDef(i = vnode.componentInstance)) {
	        // child component. it should have hydrated its own tree.
	        initComponent(vnode, insertedVnodeQueue);
	        return true
	      }
	    }
	    if (isDef(tag)) {
	      if (isDef(children)) {
	        // empty element, allow client to pick up and populate children
	        if (!elm.hasChildNodes()) {
	          createChildren(vnode, children, insertedVnodeQueue);
	        } else {
	          var childrenMatch = true;
	          var childNode = elm.firstChild;
	          for (var i$1 = 0; i$1 < children.length; i$1++) {
	            if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue)) {
	              childrenMatch = false;
	              break
	            }
	            childNode = childNode.nextSibling;
	          }
	          // if childNode is not null, it means the actual childNodes list is
	          // longer than the virtual children list.
	          if (!childrenMatch || childNode) {
	            if (false) {
	              bailed = true;
	              console.warn('Parent: ', elm);
	              console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
	            }
	            return false
	          }
	        }
	      }
	      if (isDef(data)) {
	        for (var key in data) {
	          if (!isRenderedModule(key)) {
	            invokeCreateHooks(vnode, insertedVnodeQueue);
	            break
	          }
	        }
	      }
	    } else if (elm.data !== vnode.text) {
	      elm.data = vnode.text;
	    }
	    return true
	  }
	
	  function assertNodeMatch (node, vnode) {
	    if (vnode.tag) {
	      return (
	        vnode.tag.indexOf('vue-component') === 0 ||
	        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
	      )
	    } else {
	      return node.nodeType === (vnode.isComment ? 8 : 3)
	    }
	  }
	
	  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
	    if (!vnode) {
	      if (oldVnode) { invokeDestroyHook(oldVnode); }
	      return
	    }
	
	    var isInitialPatch = false;
	    var insertedVnodeQueue = [];
	
	    if (!oldVnode) {
	      // empty mount (likely as component), create new root element
	      isInitialPatch = true;
	      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
	    } else {
	      var isRealElement = isDef(oldVnode.nodeType);
	      if (!isRealElement && sameVnode(oldVnode, vnode)) {
	        // patch existing root node
	        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
	      } else {
	        if (isRealElement) {
	          // mounting to a real element
	          // check if this is server-rendered content and if we can perform
	          // a successful hydration.
	          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute('server-rendered')) {
	            oldVnode.removeAttribute('server-rendered');
	            hydrating = true;
	          }
	          if (hydrating) {
	            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
	              invokeInsertHook(vnode, insertedVnodeQueue, true);
	              return oldVnode
	            } else if (false) {
	              warn(
	                'The client-side rendered virtual DOM tree is not matching ' +
	                'server-rendered content. This is likely caused by incorrect ' +
	                'HTML markup, for example nesting block-level elements inside ' +
	                '<p>, or missing <tbody>. Bailing hydration and performing ' +
	                'full client-side render.'
	              );
	            }
	          }
	          // either not server-rendered, or hydration failed.
	          // create an empty node and replace it
	          oldVnode = emptyNodeAt(oldVnode);
	        }
	        // replacing existing element
	        var oldElm = oldVnode.elm;
	        var parentElm$1 = nodeOps.parentNode(oldElm);
	        createElm(
	          vnode,
	          insertedVnodeQueue,
	          // extremely rare edge case: do not insert if old element is in a
	          // leaving transition. Only happens when combining transition +
	          // keep-alive + HOCs. (#4590)
	          oldElm._leaveCb ? null : parentElm$1,
	          nodeOps.nextSibling(oldElm)
	        );
	
	        if (vnode.parent) {
	          // component root element replaced.
	          // update parent placeholder node element, recursively
	          var ancestor = vnode.parent;
	          while (ancestor) {
	            ancestor.elm = vnode.elm;
	            ancestor = ancestor.parent;
	          }
	          if (isPatchable(vnode)) {
	            for (var i = 0; i < cbs.create.length; ++i) {
	              cbs.create[i](emptyNode, vnode.parent);
	            }
	          }
	        }
	
	        if (parentElm$1 !== null) {
	          removeVnodes(parentElm$1, [oldVnode], 0, 0);
	        } else if (isDef(oldVnode.tag)) {
	          invokeDestroyHook(oldVnode);
	        }
	      }
	    }
	
	    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
	    return vnode.elm
	  }
	}
	
	/*  */
	
	var directives = {
	  create: updateDirectives,
	  update: updateDirectives,
	  destroy: function unbindDirectives (vnode) {
	    updateDirectives(vnode, emptyNode);
	  }
	};
	
	function updateDirectives (oldVnode, vnode) {
	  if (oldVnode.data.directives || vnode.data.directives) {
	    _update(oldVnode, vnode);
	  }
	}
	
	function _update (oldVnode, vnode) {
	  var isCreate = oldVnode === emptyNode;
	  var isDestroy = vnode === emptyNode;
	  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
	  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);
	
	  var dirsWithInsert = [];
	  var dirsWithPostpatch = [];
	
	  var key, oldDir, dir;
	  for (key in newDirs) {
	    oldDir = oldDirs[key];
	    dir = newDirs[key];
	    if (!oldDir) {
	      // new directive, bind
	      callHook$1(dir, 'bind', vnode, oldVnode);
	      if (dir.def && dir.def.inserted) {
	        dirsWithInsert.push(dir);
	      }
	    } else {
	      // existing directive, update
	      dir.oldValue = oldDir.value;
	      callHook$1(dir, 'update', vnode, oldVnode);
	      if (dir.def && dir.def.componentUpdated) {
	        dirsWithPostpatch.push(dir);
	      }
	    }
	  }
	
	  if (dirsWithInsert.length) {
	    var callInsert = function () {
	      for (var i = 0; i < dirsWithInsert.length; i++) {
	        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
	      }
	    };
	    if (isCreate) {
	      mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'insert', callInsert, 'dir-insert');
	    } else {
	      callInsert();
	    }
	  }
	
	  if (dirsWithPostpatch.length) {
	    mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'postpatch', function () {
	      for (var i = 0; i < dirsWithPostpatch.length; i++) {
	        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
	      }
	    }, 'dir-postpatch');
	  }
	
	  if (!isCreate) {
	    for (key in oldDirs) {
	      if (!newDirs[key]) {
	        // no longer present, unbind
	        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
	      }
	    }
	  }
	}
	
	var emptyModifiers = Object.create(null);
	
	function normalizeDirectives$1 (
	  dirs,
	  vm
	) {
	  var res = Object.create(null);
	  if (!dirs) {
	    return res
	  }
	  var i, dir;
	  for (i = 0; i < dirs.length; i++) {
	    dir = dirs[i];
	    if (!dir.modifiers) {
	      dir.modifiers = emptyModifiers;
	    }
	    res[getRawDirName(dir)] = dir;
	    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
	  }
	  return res
	}
	
	function getRawDirName (dir) {
	  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
	}
	
	function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
	  var fn = dir.def && dir.def[hook];
	  if (fn) {
	    fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
	  }
	}
	
	var baseModules = [
	  ref,
	  directives
	];
	
	/*  */
	
	function updateAttrs (oldVnode, vnode) {
	  if (!oldVnode.data.attrs && !vnode.data.attrs) {
	    return
	  }
	  var key, cur, old;
	  var elm = vnode.elm;
	  var oldAttrs = oldVnode.data.attrs || {};
	  var attrs = vnode.data.attrs || {};
	  // clone observed objects, as the user probably wants to mutate it
	  if (attrs.__ob__) {
	    attrs = vnode.data.attrs = extend({}, attrs);
	  }
	
	  for (key in attrs) {
	    cur = attrs[key];
	    old = oldAttrs[key];
	    if (old !== cur) {
	      setAttr(elm, key, cur);
	    }
	  }
	  // #4391: in IE9, setting type can reset value for input[type=radio]
	  /* istanbul ignore if */
	  if (isIE9 && attrs.value !== oldAttrs.value) {
	    setAttr(elm, 'value', attrs.value);
	  }
	  for (key in oldAttrs) {
	    if (attrs[key] == null) {
	      if (isXlink(key)) {
	        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
	      } else if (!isEnumeratedAttr(key)) {
	        elm.removeAttribute(key);
	      }
	    }
	  }
	}
	
	function setAttr (el, key, value) {
	  if (isBooleanAttr(key)) {
	    // set attribute for blank value
	    // e.g. <option disabled>Select one</option>
	    if (isFalsyAttrValue(value)) {
	      el.removeAttribute(key);
	    } else {
	      el.setAttribute(key, key);
	    }
	  } else if (isEnumeratedAttr(key)) {
	    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
	  } else if (isXlink(key)) {
	    if (isFalsyAttrValue(value)) {
	      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
	    } else {
	      el.setAttributeNS(xlinkNS, key, value);
	    }
	  } else {
	    if (isFalsyAttrValue(value)) {
	      el.removeAttribute(key);
	    } else {
	      el.setAttribute(key, value);
	    }
	  }
	}
	
	var attrs = {
	  create: updateAttrs,
	  update: updateAttrs
	};
	
	/*  */
	
	function updateClass (oldVnode, vnode) {
	  var el = vnode.elm;
	  var data = vnode.data;
	  var oldData = oldVnode.data;
	  if (!data.staticClass && !data.class &&
	      (!oldData || (!oldData.staticClass && !oldData.class))) {
	    return
	  }
	
	  var cls = genClassForVnode(vnode);
	
	  // handle transition classes
	  var transitionClass = el._transitionClasses;
	  if (transitionClass) {
	    cls = concat(cls, stringifyClass(transitionClass));
	  }
	
	  // set the class
	  if (cls !== el._prevClass) {
	    el.setAttribute('class', cls);
	    el._prevClass = cls;
	  }
	}
	
	var klass = {
	  create: updateClass,
	  update: updateClass
	};
	
	/*  */
	
	var target$1;
	
	function add$2 (
	  event,
	  handler,
	  once,
	  capture
	) {
	  if (once) {
	    var oldHandler = handler;
	    var _target = target$1; // save current target element in closure
	    handler = function (ev) {
	      remove$3(event, handler, capture, _target);
	      arguments.length === 1
	        ? oldHandler(ev)
	        : oldHandler.apply(null, arguments);
	    };
	  }
	  target$1.addEventListener(event, handler, capture);
	}
	
	function remove$3 (
	  event,
	  handler,
	  capture,
	  _target
	) {
	  (_target || target$1).removeEventListener(event, handler, capture);
	}
	
	function updateDOMListeners (oldVnode, vnode) {
	  if (!oldVnode.data.on && !vnode.data.on) {
	    return
	  }
	  var on = vnode.data.on || {};
	  var oldOn = oldVnode.data.on || {};
	  target$1 = vnode.elm;
	  updateListeners(on, oldOn, add$2, remove$3, vnode.context);
	}
	
	var events = {
	  create: updateDOMListeners,
	  update: updateDOMListeners
	};
	
	/*  */
	
	function updateDOMProps (oldVnode, vnode) {
	  if (!oldVnode.data.domProps && !vnode.data.domProps) {
	    return
	  }
	  var key, cur;
	  var elm = vnode.elm;
	  var oldProps = oldVnode.data.domProps || {};
	  var props = vnode.data.domProps || {};
	  // clone observed objects, as the user probably wants to mutate it
	  if (props.__ob__) {
	    props = vnode.data.domProps = extend({}, props);
	  }
	
	  for (key in oldProps) {
	    if (props[key] == null) {
	      elm[key] = '';
	    }
	  }
	  for (key in props) {
	    cur = props[key];
	    // ignore children if the node has textContent or innerHTML,
	    // as these will throw away existing DOM nodes and cause removal errors
	    // on subsequent patches (#3360)
	    if (key === 'textContent' || key === 'innerHTML') {
	      if (vnode.children) { vnode.children.length = 0; }
	      if (cur === oldProps[key]) { continue }
	    }
	
	    if (key === 'value') {
	      // store value as _value as well since
	      // non-string values will be stringified
	      elm._value = cur;
	      // avoid resetting cursor position when value is the same
	      var strCur = cur == null ? '' : String(cur);
	      if (shouldUpdateValue(elm, vnode, strCur)) {
	        elm.value = strCur;
	      }
	    } else {
	      elm[key] = cur;
	    }
	  }
	}
	
	// check platforms/web/util/attrs.js acceptValue
	
	
	function shouldUpdateValue (
	  elm,
	  vnode,
	  checkVal
	) {
	  return (!elm.composing && (
	    vnode.tag === 'option' ||
	    isDirty(elm, checkVal) ||
	    isInputChanged(vnode, checkVal)
	  ))
	}
	
	function isDirty (elm, checkVal) {
	  // return true when textbox (.number and .trim) loses focus and its value is not equal to the updated value
	  return document.activeElement !== elm && elm.value !== checkVal
	}
	
	function isInputChanged (vnode, newVal) {
	  var value = vnode.elm.value;
	  var modifiers = vnode.elm._vModifiers; // injected by v-model runtime
	  if ((modifiers && modifiers.number) || vnode.elm.type === 'number') {
	    return toNumber(value) !== toNumber(newVal)
	  }
	  if (modifiers && modifiers.trim) {
	    return value.trim() !== newVal.trim()
	  }
	  return value !== newVal
	}
	
	var domProps = {
	  create: updateDOMProps,
	  update: updateDOMProps
	};
	
	/*  */
	
	var parseStyleText = cached(function (cssText) {
	  var res = {};
	  var listDelimiter = /;(?![^(]*\))/g;
	  var propertyDelimiter = /:(.+)/;
	  cssText.split(listDelimiter).forEach(function (item) {
	    if (item) {
	      var tmp = item.split(propertyDelimiter);
	      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
	    }
	  });
	  return res
	});
	
	// merge static and dynamic style data on the same vnode
	function normalizeStyleData (data) {
	  var style = normalizeStyleBinding(data.style);
	  // static style is pre-processed into an object during compilation
	  // and is always a fresh object, so it's safe to merge into it
	  return data.staticStyle
	    ? extend(data.staticStyle, style)
	    : style
	}
	
	// normalize possible array / string values into Object
	function normalizeStyleBinding (bindingStyle) {
	  if (Array.isArray(bindingStyle)) {
	    return toObject(bindingStyle)
	  }
	  if (typeof bindingStyle === 'string') {
	    return parseStyleText(bindingStyle)
	  }
	  return bindingStyle
	}
	
	/**
	 * parent component style should be after child's
	 * so that parent component's style could override it
	 */
	function getStyle (vnode, checkChild) {
	  var res = {};
	  var styleData;
	
	  if (checkChild) {
	    var childNode = vnode;
	    while (childNode.componentInstance) {
	      childNode = childNode.componentInstance._vnode;
	      if (childNode.data && (styleData = normalizeStyleData(childNode.data))) {
	        extend(res, styleData);
	      }
	    }
	  }
	
	  if ((styleData = normalizeStyleData(vnode.data))) {
	    extend(res, styleData);
	  }
	
	  var parentNode = vnode;
	  while ((parentNode = parentNode.parent)) {
	    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
	      extend(res, styleData);
	    }
	  }
	  return res
	}
	
	/*  */
	
	var cssVarRE = /^--/;
	var importantRE = /\s*!important$/;
	var setProp = function (el, name, val) {
	  /* istanbul ignore if */
	  if (cssVarRE.test(name)) {
	    el.style.setProperty(name, val);
	  } else if (importantRE.test(val)) {
	    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
	  } else {
	    el.style[normalize(name)] = val;
	  }
	};
	
	var prefixes = ['Webkit', 'Moz', 'ms'];
	
	var testEl;
	var normalize = cached(function (prop) {
	  testEl = testEl || document.createElement('div');
	  prop = camelize(prop);
	  if (prop !== 'filter' && (prop in testEl.style)) {
	    return prop
	  }
	  var upper = prop.charAt(0).toUpperCase() + prop.slice(1);
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefixed = prefixes[i] + upper;
	    if (prefixed in testEl.style) {
	      return prefixed
	    }
	  }
	});
	
	function updateStyle (oldVnode, vnode) {
	  var data = vnode.data;
	  var oldData = oldVnode.data;
	
	  if (!data.staticStyle && !data.style &&
	      !oldData.staticStyle && !oldData.style) {
	    return
	  }
	
	  var cur, name;
	  var el = vnode.elm;
	  var oldStaticStyle = oldVnode.data.staticStyle;
	  var oldStyleBinding = oldVnode.data.style || {};
	
	  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
	  var oldStyle = oldStaticStyle || oldStyleBinding;
	
	  var style = normalizeStyleBinding(vnode.data.style) || {};
	
	  vnode.data.style = style.__ob__ ? extend({}, style) : style;
	
	  var newStyle = getStyle(vnode, true);
	
	  for (name in oldStyle) {
	    if (newStyle[name] == null) {
	      setProp(el, name, '');
	    }
	  }
	  for (name in newStyle) {
	    cur = newStyle[name];
	    if (cur !== oldStyle[name]) {
	      // ie9 setting to null has no effect, must use empty string
	      setProp(el, name, cur == null ? '' : cur);
	    }
	  }
	}
	
	var style = {
	  create: updateStyle,
	  update: updateStyle
	};
	
	/*  */
	
	/**
	 * Add class with compatibility for SVG since classList is not supported on
	 * SVG elements in IE
	 */
	function addClass (el, cls) {
	  /* istanbul ignore if */
	  if (!cls || !cls.trim()) {
	    return
	  }
	
	  /* istanbul ignore else */
	  if (el.classList) {
	    if (cls.indexOf(' ') > -1) {
	      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
	    } else {
	      el.classList.add(cls);
	    }
	  } else {
	    var cur = ' ' + el.getAttribute('class') + ' ';
	    if (cur.indexOf(' ' + cls + ' ') < 0) {
	      el.setAttribute('class', (cur + cls).trim());
	    }
	  }
	}
	
	/**
	 * Remove class with compatibility for SVG since classList is not supported on
	 * SVG elements in IE
	 */
	function removeClass (el, cls) {
	  /* istanbul ignore if */
	  if (!cls || !cls.trim()) {
	    return
	  }
	
	  /* istanbul ignore else */
	  if (el.classList) {
	    if (cls.indexOf(' ') > -1) {
	      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
	    } else {
	      el.classList.remove(cls);
	    }
	  } else {
	    var cur = ' ' + el.getAttribute('class') + ' ';
	    var tar = ' ' + cls + ' ';
	    while (cur.indexOf(tar) >= 0) {
	      cur = cur.replace(tar, ' ');
	    }
	    el.setAttribute('class', cur.trim());
	  }
	}
	
	/*  */
	
	var hasTransition = inBrowser && !isIE9;
	var TRANSITION = 'transition';
	var ANIMATION = 'animation';
	
	// Transition property/event sniffing
	var transitionProp = 'transition';
	var transitionEndEvent = 'transitionend';
	var animationProp = 'animation';
	var animationEndEvent = 'animationend';
	if (hasTransition) {
	  /* istanbul ignore if */
	  if (window.ontransitionend === undefined &&
	    window.onwebkittransitionend !== undefined) {
	    transitionProp = 'WebkitTransition';
	    transitionEndEvent = 'webkitTransitionEnd';
	  }
	  if (window.onanimationend === undefined &&
	    window.onwebkitanimationend !== undefined) {
	    animationProp = 'WebkitAnimation';
	    animationEndEvent = 'webkitAnimationEnd';
	  }
	}
	
	// binding to window is necessary to make hot reload work in IE in strict mode
	var raf = inBrowser && window.requestAnimationFrame
	  ? window.requestAnimationFrame.bind(window)
	  : setTimeout;
	
	function nextFrame (fn) {
	  raf(function () {
	    raf(fn);
	  });
	}
	
	function addTransitionClass (el, cls) {
	  (el._transitionClasses || (el._transitionClasses = [])).push(cls);
	  addClass(el, cls);
	}
	
	function removeTransitionClass (el, cls) {
	  if (el._transitionClasses) {
	    remove$1(el._transitionClasses, cls);
	  }
	  removeClass(el, cls);
	}
	
	function whenTransitionEnds (
	  el,
	  expectedType,
	  cb
	) {
	  var ref = getTransitionInfo(el, expectedType);
	  var type = ref.type;
	  var timeout = ref.timeout;
	  var propCount = ref.propCount;
	  if (!type) { return cb() }
	  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
	  var ended = 0;
	  var end = function () {
	    el.removeEventListener(event, onEnd);
	    cb();
	  };
	  var onEnd = function (e) {
	    if (e.target === el) {
	      if (++ended >= propCount) {
	        end();
	      }
	    }
	  };
	  setTimeout(function () {
	    if (ended < propCount) {
	      end();
	    }
	  }, timeout + 1);
	  el.addEventListener(event, onEnd);
	}
	
	var transformRE = /\b(transform|all)(,|$)/;
	
	function getTransitionInfo (el, expectedType) {
	  var styles = window.getComputedStyle(el);
	  var transitioneDelays = styles[transitionProp + 'Delay'].split(', ');
	  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
	  var transitionTimeout = getTimeout(transitioneDelays, transitionDurations);
	  var animationDelays = styles[animationProp + 'Delay'].split(', ');
	  var animationDurations = styles[animationProp + 'Duration'].split(', ');
	  var animationTimeout = getTimeout(animationDelays, animationDurations);
	
	  var type;
	  var timeout = 0;
	  var propCount = 0;
	  /* istanbul ignore if */
	  if (expectedType === TRANSITION) {
	    if (transitionTimeout > 0) {
	      type = TRANSITION;
	      timeout = transitionTimeout;
	      propCount = transitionDurations.length;
	    }
	  } else if (expectedType === ANIMATION) {
	    if (animationTimeout > 0) {
	      type = ANIMATION;
	      timeout = animationTimeout;
	      propCount = animationDurations.length;
	    }
	  } else {
	    timeout = Math.max(transitionTimeout, animationTimeout);
	    type = timeout > 0
	      ? transitionTimeout > animationTimeout
	        ? TRANSITION
	        : ANIMATION
	      : null;
	    propCount = type
	      ? type === TRANSITION
	        ? transitionDurations.length
	        : animationDurations.length
	      : 0;
	  }
	  var hasTransform =
	    type === TRANSITION &&
	    transformRE.test(styles[transitionProp + 'Property']);
	  return {
	    type: type,
	    timeout: timeout,
	    propCount: propCount,
	    hasTransform: hasTransform
	  }
	}
	
	function getTimeout (delays, durations) {
	  /* istanbul ignore next */
	  while (delays.length < durations.length) {
	    delays = delays.concat(delays);
	  }
	
	  return Math.max.apply(null, durations.map(function (d, i) {
	    return toMs(d) + toMs(delays[i])
	  }))
	}
	
	function toMs (s) {
	  return Number(s.slice(0, -1)) * 1000
	}
	
	/*  */
	
	function enter (vnode, toggleDisplay) {
	  var el = vnode.elm;
	
	  // call leave callback now
	  if (el._leaveCb) {
	    el._leaveCb.cancelled = true;
	    el._leaveCb();
	  }
	
	  var data = resolveTransition(vnode.data.transition);
	  if (!data) {
	    return
	  }
	
	  /* istanbul ignore if */
	  if (el._enterCb || el.nodeType !== 1) {
	    return
	  }
	
	  var css = data.css;
	  var type = data.type;
	  var enterClass = data.enterClass;
	  var enterToClass = data.enterToClass;
	  var enterActiveClass = data.enterActiveClass;
	  var appearClass = data.appearClass;
	  var appearToClass = data.appearToClass;
	  var appearActiveClass = data.appearActiveClass;
	  var beforeEnter = data.beforeEnter;
	  var enter = data.enter;
	  var afterEnter = data.afterEnter;
	  var enterCancelled = data.enterCancelled;
	  var beforeAppear = data.beforeAppear;
	  var appear = data.appear;
	  var afterAppear = data.afterAppear;
	  var appearCancelled = data.appearCancelled;
	
	  // activeInstance will always be the <transition> component managing this
	  // transition. One edge case to check is when the <transition> is placed
	  // as the root node of a child component. In that case we need to check
	  // <transition>'s parent for appear check.
	  var context = activeInstance;
	  var transitionNode = activeInstance.$vnode;
	  while (transitionNode && transitionNode.parent) {
	    transitionNode = transitionNode.parent;
	    context = transitionNode.context;
	  }
	
	  var isAppear = !context._isMounted || !vnode.isRootInsert;
	
	  if (isAppear && !appear && appear !== '') {
	    return
	  }
	
	  var startClass = isAppear ? appearClass : enterClass;
	  var activeClass = isAppear ? appearActiveClass : enterActiveClass;
	  var toClass = isAppear ? appearToClass : enterToClass;
	  var beforeEnterHook = isAppear ? (beforeAppear || beforeEnter) : beforeEnter;
	  var enterHook = isAppear ? (typeof appear === 'function' ? appear : enter) : enter;
	  var afterEnterHook = isAppear ? (afterAppear || afterEnter) : afterEnter;
	  var enterCancelledHook = isAppear ? (appearCancelled || enterCancelled) : enterCancelled;
	
	  var expectsCSS = css !== false && !isIE9;
	  var userWantsControl =
	    enterHook &&
	    // enterHook may be a bound method which exposes
	    // the length of original fn as _length
	    (enterHook._length || enterHook.length) > 1;
	
	  var cb = el._enterCb = once(function () {
	    if (expectsCSS) {
	      removeTransitionClass(el, toClass);
	      removeTransitionClass(el, activeClass);
	    }
	    if (cb.cancelled) {
	      if (expectsCSS) {
	        removeTransitionClass(el, startClass);
	      }
	      enterCancelledHook && enterCancelledHook(el);
	    } else {
	      afterEnterHook && afterEnterHook(el);
	    }
	    el._enterCb = null;
	  });
	
	  if (!vnode.data.show) {
	    // remove pending leave element on enter by injecting an insert hook
	    mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'insert', function () {
	      var parent = el.parentNode;
	      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
	      if (pendingNode &&
	          pendingNode.tag === vnode.tag &&
	          pendingNode.elm._leaveCb) {
	        pendingNode.elm._leaveCb();
	      }
	      enterHook && enterHook(el, cb);
	    }, 'transition-insert');
	  }
	
	  // start enter transition
	  beforeEnterHook && beforeEnterHook(el);
	  if (expectsCSS) {
	    addTransitionClass(el, startClass);
	    addTransitionClass(el, activeClass);
	    nextFrame(function () {
	      addTransitionClass(el, toClass);
	      removeTransitionClass(el, startClass);
	      if (!cb.cancelled && !userWantsControl) {
	        whenTransitionEnds(el, type, cb);
	      }
	    });
	  }
	
	  if (vnode.data.show) {
	    toggleDisplay && toggleDisplay();
	    enterHook && enterHook(el, cb);
	  }
	
	  if (!expectsCSS && !userWantsControl) {
	    cb();
	  }
	}
	
	function leave (vnode, rm) {
	  var el = vnode.elm;
	
	  // call enter callback now
	  if (el._enterCb) {
	    el._enterCb.cancelled = true;
	    el._enterCb();
	  }
	
	  var data = resolveTransition(vnode.data.transition);
	  if (!data) {
	    return rm()
	  }
	
	  /* istanbul ignore if */
	  if (el._leaveCb || el.nodeType !== 1) {
	    return
	  }
	
	  var css = data.css;
	  var type = data.type;
	  var leaveClass = data.leaveClass;
	  var leaveToClass = data.leaveToClass;
	  var leaveActiveClass = data.leaveActiveClass;
	  var beforeLeave = data.beforeLeave;
	  var leave = data.leave;
	  var afterLeave = data.afterLeave;
	  var leaveCancelled = data.leaveCancelled;
	  var delayLeave = data.delayLeave;
	
	  var expectsCSS = css !== false && !isIE9;
	  var userWantsControl =
	    leave &&
	    // leave hook may be a bound method which exposes
	    // the length of original fn as _length
	    (leave._length || leave.length) > 1;
	
	  var cb = el._leaveCb = once(function () {
	    if (el.parentNode && el.parentNode._pending) {
	      el.parentNode._pending[vnode.key] = null;
	    }
	    if (expectsCSS) {
	      removeTransitionClass(el, leaveToClass);
	      removeTransitionClass(el, leaveActiveClass);
	    }
	    if (cb.cancelled) {
	      if (expectsCSS) {
	        removeTransitionClass(el, leaveClass);
	      }
	      leaveCancelled && leaveCancelled(el);
	    } else {
	      rm();
	      afterLeave && afterLeave(el);
	    }
	    el._leaveCb = null;
	  });
	
	  if (delayLeave) {
	    delayLeave(performLeave);
	  } else {
	    performLeave();
	  }
	
	  function performLeave () {
	    // the delayed leave may have already been cancelled
	    if (cb.cancelled) {
	      return
	    }
	    // record leaving element
	    if (!vnode.data.show) {
	      (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] = vnode;
	    }
	    beforeLeave && beforeLeave(el);
	    if (expectsCSS) {
	      addTransitionClass(el, leaveClass);
	      addTransitionClass(el, leaveActiveClass);
	      nextFrame(function () {
	        addTransitionClass(el, leaveToClass);
	        removeTransitionClass(el, leaveClass);
	        if (!cb.cancelled && !userWantsControl) {
	          whenTransitionEnds(el, type, cb);
	        }
	      });
	    }
	    leave && leave(el, cb);
	    if (!expectsCSS && !userWantsControl) {
	      cb();
	    }
	  }
	}
	
	function resolveTransition (def$$1) {
	  if (!def$$1) {
	    return
	  }
	  /* istanbul ignore else */
	  if (typeof def$$1 === 'object') {
	    var res = {};
	    if (def$$1.css !== false) {
	      extend(res, autoCssTransition(def$$1.name || 'v'));
	    }
	    extend(res, def$$1);
	    return res
	  } else if (typeof def$$1 === 'string') {
	    return autoCssTransition(def$$1)
	  }
	}
	
	var autoCssTransition = cached(function (name) {
	  return {
	    enterClass: (name + "-enter"),
	    leaveClass: (name + "-leave"),
	    appearClass: (name + "-enter"),
	    enterToClass: (name + "-enter-to"),
	    leaveToClass: (name + "-leave-to"),
	    appearToClass: (name + "-enter-to"),
	    enterActiveClass: (name + "-enter-active"),
	    leaveActiveClass: (name + "-leave-active"),
	    appearActiveClass: (name + "-enter-active")
	  }
	});
	
	function once (fn) {
	  var called = false;
	  return function () {
	    if (!called) {
	      called = true;
	      fn();
	    }
	  }
	}
	
	function _enter (_, vnode) {
	  if (!vnode.data.show) {
	    enter(vnode);
	  }
	}
	
	var transition = inBrowser ? {
	  create: _enter,
	  activate: _enter,
	  remove: function remove (vnode, rm) {
	    /* istanbul ignore else */
	    if (!vnode.data.show) {
	      leave(vnode, rm);
	    } else {
	      rm();
	    }
	  }
	} : {};
	
	var platformModules = [
	  attrs,
	  klass,
	  events,
	  domProps,
	  style,
	  transition
	];
	
	/*  */
	
	// the directive module should be applied last, after all
	// built-in modules have been applied.
	var modules = platformModules.concat(baseModules);
	
	var patch$1 = createPatchFunction({ nodeOps: nodeOps, modules: modules });
	
	/**
	 * Not type checking this file because flow doesn't like attaching
	 * properties to Elements.
	 */
	
	var modelableTagRE = /^input|select|textarea|vue-component-[0-9]+(-[0-9a-zA-Z_-]*)?$/;
	
	/* istanbul ignore if */
	if (isIE9) {
	  // http://www.matts411.com/post/internet-explorer-9-oninput/
	  document.addEventListener('selectionchange', function () {
	    var el = document.activeElement;
	    if (el && el.vmodel) {
	      trigger(el, 'input');
	    }
	  });
	}
	
	var model = {
	  inserted: function inserted (el, binding, vnode) {
	    if (false) {
	      if (!modelableTagRE.test(vnode.tag)) {
	        warn(
	          "v-model is not supported on element type: <" + (vnode.tag) + ">. " +
	          'If you are working with contenteditable, it\'s recommended to ' +
	          'wrap a library dedicated for that purpose inside a custom component.',
	          vnode.context
	        );
	      }
	    }
	    if (vnode.tag === 'select') {
	      var cb = function () {
	        setSelected(el, binding, vnode.context);
	      };
	      cb();
	      /* istanbul ignore if */
	      if (isIE || isEdge) {
	        setTimeout(cb, 0);
	      }
	    } else if (vnode.tag === 'textarea' || el.type === 'text') {
	      el._vModifiers = binding.modifiers;
	      if (!binding.modifiers.lazy) {
	        if (!isAndroid) {
	          el.addEventListener('compositionstart', onCompositionStart);
	          el.addEventListener('compositionend', onCompositionEnd);
	        }
	        /* istanbul ignore if */
	        if (isIE9) {
	          el.vmodel = true;
	        }
	      }
	    }
	  },
	  componentUpdated: function componentUpdated (el, binding, vnode) {
	    if (vnode.tag === 'select') {
	      setSelected(el, binding, vnode.context);
	      // in case the options rendered by v-for have changed,
	      // it's possible that the value is out-of-sync with the rendered options.
	      // detect such cases and filter out values that no longer has a matching
	      // option in the DOM.
	      var needReset = el.multiple
	        ? binding.value.some(function (v) { return hasNoMatchingOption(v, el.options); })
	        : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, el.options);
	      if (needReset) {
	        trigger(el, 'change');
	      }
	    }
	  }
	};
	
	function setSelected (el, binding, vm) {
	  var value = binding.value;
	  var isMultiple = el.multiple;
	  if (isMultiple && !Array.isArray(value)) {
	    ("production") !== 'production' && warn(
	      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
	      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
	      vm
	    );
	    return
	  }
	  var selected, option;
	  for (var i = 0, l = el.options.length; i < l; i++) {
	    option = el.options[i];
	    if (isMultiple) {
	      selected = looseIndexOf(value, getValue(option)) > -1;
	      if (option.selected !== selected) {
	        option.selected = selected;
	      }
	    } else {
	      if (looseEqual(getValue(option), value)) {
	        if (el.selectedIndex !== i) {
	          el.selectedIndex = i;
	        }
	        return
	      }
	    }
	  }
	  if (!isMultiple) {
	    el.selectedIndex = -1;
	  }
	}
	
	function hasNoMatchingOption (value, options) {
	  for (var i = 0, l = options.length; i < l; i++) {
	    if (looseEqual(getValue(options[i]), value)) {
	      return false
	    }
	  }
	  return true
	}
	
	function getValue (option) {
	  return '_value' in option
	    ? option._value
	    : option.value
	}
	
	function onCompositionStart (e) {
	  e.target.composing = true;
	}
	
	function onCompositionEnd (e) {
	  e.target.composing = false;
	  trigger(e.target, 'input');
	}
	
	function trigger (el, type) {
	  var e = document.createEvent('HTMLEvents');
	  e.initEvent(type, true, true);
	  el.dispatchEvent(e);
	}
	
	/*  */
	
	// recursively search for possible transition defined inside the component root
	function locateNode (vnode) {
	  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
	    ? locateNode(vnode.componentInstance._vnode)
	    : vnode
	}
	
	var show = {
	  bind: function bind (el, ref, vnode) {
	    var value = ref.value;
	
	    vnode = locateNode(vnode);
	    var transition = vnode.data && vnode.data.transition;
	    var originalDisplay = el.__vOriginalDisplay =
	      el.style.display === 'none' ? '' : el.style.display;
	    if (value && transition && !isIE9) {
	      vnode.data.show = true;
	      enter(vnode, function () {
	        el.style.display = originalDisplay;
	      });
	    } else {
	      el.style.display = value ? originalDisplay : 'none';
	    }
	  },
	
	  update: function update (el, ref, vnode) {
	    var value = ref.value;
	    var oldValue = ref.oldValue;
	
	    /* istanbul ignore if */
	    if (value === oldValue) { return }
	    vnode = locateNode(vnode);
	    var transition = vnode.data && vnode.data.transition;
	    if (transition && !isIE9) {
	      vnode.data.show = true;
	      if (value) {
	        enter(vnode, function () {
	          el.style.display = el.__vOriginalDisplay;
	        });
	      } else {
	        leave(vnode, function () {
	          el.style.display = 'none';
	        });
	      }
	    } else {
	      el.style.display = value ? el.__vOriginalDisplay : 'none';
	    }
	  },
	
	  unbind: function unbind (
	    el,
	    binding,
	    vnode,
	    oldVnode,
	    isDestroy
	  ) {
	    if (!isDestroy) {
	      el.style.display = el.__vOriginalDisplay;
	    }
	  }
	};
	
	var platformDirectives = {
	  model: model,
	  show: show
	};
	
	/*  */
	
	// Provides transition support for a single element/component.
	// supports transition mode (out-in / in-out)
	
	var transitionProps = {
	  name: String,
	  appear: Boolean,
	  css: Boolean,
	  mode: String,
	  type: String,
	  enterClass: String,
	  leaveClass: String,
	  enterToClass: String,
	  leaveToClass: String,
	  enterActiveClass: String,
	  leaveActiveClass: String,
	  appearClass: String,
	  appearActiveClass: String,
	  appearToClass: String
	};
	
	// in case the child is also an abstract component, e.g. <keep-alive>
	// we want to recursively retrieve the real component to be rendered
	function getRealChild (vnode) {
	  var compOptions = vnode && vnode.componentOptions;
	  if (compOptions && compOptions.Ctor.options.abstract) {
	    return getRealChild(getFirstComponentChild(compOptions.children))
	  } else {
	    return vnode
	  }
	}
	
	function extractTransitionData (comp) {
	  var data = {};
	  var options = comp.$options;
	  // props
	  for (var key in options.propsData) {
	    data[key] = comp[key];
	  }
	  // events.
	  // extract listeners and pass them directly to the transition methods
	  var listeners = options._parentListeners;
	  for (var key$1 in listeners) {
	    data[camelize(key$1)] = listeners[key$1].fn;
	  }
	  return data
	}
	
	function placeholder (h, rawChild) {
	  return /\d-keep-alive$/.test(rawChild.tag)
	    ? h('keep-alive')
	    : null
	}
	
	function hasParentTransition (vnode) {
	  while ((vnode = vnode.parent)) {
	    if (vnode.data.transition) {
	      return true
	    }
	  }
	}
	
	function isSameChild (child, oldChild) {
	  return oldChild.key === child.key && oldChild.tag === child.tag
	}
	
	var Transition = {
	  name: 'transition',
	  props: transitionProps,
	  abstract: true,
	
	  render: function render (h) {
	    var this$1 = this;
	
	    var children = this.$slots.default;
	    if (!children) {
	      return
	    }
	
	    // filter out text nodes (possible whitespaces)
	    children = children.filter(function (c) { return c.tag; });
	    /* istanbul ignore if */
	    if (!children.length) {
	      return
	    }
	
	    // warn multiple elements
	    if (false) {
	      warn(
	        '<transition> can only be used on a single element. Use ' +
	        '<transition-group> for lists.',
	        this.$parent
	      );
	    }
	
	    var mode = this.mode;
	
	    // warn invalid mode
	    if (false) {
	      warn(
	        'invalid <transition> mode: ' + mode,
	        this.$parent
	      );
	    }
	
	    var rawChild = children[0];
	
	    // if this is a component root node and the component's
	    // parent container node also has transition, skip.
	    if (hasParentTransition(this.$vnode)) {
	      return rawChild
	    }
	
	    // apply transition data to child
	    // use getRealChild() to ignore abstract components e.g. keep-alive
	    var child = getRealChild(rawChild);
	    /* istanbul ignore if */
	    if (!child) {
	      return rawChild
	    }
	
	    if (this._leaving) {
	      return placeholder(h, rawChild)
	    }
	
	    // ensure a key that is unique to the vnode type and to this transition
	    // component instance. This key will be used to remove pending leaving nodes
	    // during entering.
	    var id = "__transition-" + (this._uid) + "-";
	    var key = child.key = child.key == null
	      ? id + child.tag
	      : isPrimitive(child.key)
	        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
	        : child.key;
	    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
	    var oldRawChild = this._vnode;
	    var oldChild = getRealChild(oldRawChild);
	
	    // mark v-show
	    // so that the transition module can hand over the control to the directive
	    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
	      child.data.show = true;
	    }
	
	    if (oldChild && oldChild.data && !isSameChild(child, oldChild)) {
	      // replace old child transition data with fresh one
	      // important for dynamic transitions!
	      var oldData = oldChild && (oldChild.data.transition = extend({}, data));
	      // handle transition mode
	      if (mode === 'out-in') {
	        // return placeholder node and queue update when leave finishes
	        this._leaving = true;
	        mergeVNodeHook(oldData, 'afterLeave', function () {
	          this$1._leaving = false;
	          this$1.$forceUpdate();
	        }, key);
	        return placeholder(h, rawChild)
	      } else if (mode === 'in-out') {
	        var delayedLeave;
	        var performLeave = function () { delayedLeave(); };
	        mergeVNodeHook(data, 'afterEnter', performLeave, key);
	        mergeVNodeHook(data, 'enterCancelled', performLeave, key);
	        mergeVNodeHook(oldData, 'delayLeave', function (leave) {
	          delayedLeave = leave;
	        }, key);
	      }
	    }
	
	    return rawChild
	  }
	};
	
	/*  */
	
	// Provides transition support for list items.
	// supports move transitions using the FLIP technique.
	
	// Because the vdom's children update algorithm is "unstable" - i.e.
	// it doesn't guarantee the relative positioning of removed elements,
	// we force transition-group to update its children into two passes:
	// in the first pass, we remove all nodes that need to be removed,
	// triggering their leaving transition; in the second pass, we insert/move
	// into the final disired state. This way in the second pass removed
	// nodes will remain where they should be.
	
	var props = extend({
	  tag: String,
	  moveClass: String
	}, transitionProps);
	
	delete props.mode;
	
	var TransitionGroup = {
	  props: props,
	
	  render: function render (h) {
	    var tag = this.tag || this.$vnode.data.tag || 'span';
	    var map = Object.create(null);
	    var prevChildren = this.prevChildren = this.children;
	    var rawChildren = this.$slots.default || [];
	    var children = this.children = [];
	    var transitionData = extractTransitionData(this);
	
	    for (var i = 0; i < rawChildren.length; i++) {
	      var c = rawChildren[i];
	      if (c.tag) {
	        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
	          children.push(c);
	          map[c.key] = c
	          ;(c.data || (c.data = {})).transition = transitionData;
	        } else if (false) {
	          var opts = c.componentOptions;
	          var name = opts
	            ? (opts.Ctor.options.name || opts.tag)
	            : c.tag;
	          warn(("<transition-group> children must be keyed: <" + name + ">"));
	        }
	      }
	    }
	
	    if (prevChildren) {
	      var kept = [];
	      var removed = [];
	      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
	        var c$1 = prevChildren[i$1];
	        c$1.data.transition = transitionData;
	        c$1.data.pos = c$1.elm.getBoundingClientRect();
	        if (map[c$1.key]) {
	          kept.push(c$1);
	        } else {
	          removed.push(c$1);
	        }
	      }
	      this.kept = h(tag, null, kept);
	      this.removed = removed;
	    }
	
	    return h(tag, null, children)
	  },
	
	  beforeUpdate: function beforeUpdate () {
	    // force removing pass
	    this.__patch__(
	      this._vnode,
	      this.kept,
	      false, // hydrating
	      true // removeOnly (!important, avoids unnecessary moves)
	    );
	    this._vnode = this.kept;
	  },
	
	  updated: function updated () {
	    var children = this.prevChildren;
	    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
	    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
	      return
	    }
	
	    // we divide the work into three loops to avoid mixing DOM reads and writes
	    // in each iteration - which helps prevent layout thrashing.
	    children.forEach(callPendingCbs);
	    children.forEach(recordPosition);
	    children.forEach(applyTranslation);
	
	    // force reflow to put everything in position
	    var f = document.body.offsetHeight; // eslint-disable-line
	
	    children.forEach(function (c) {
	      if (c.data.moved) {
	        var el = c.elm;
	        var s = el.style;
	        addTransitionClass(el, moveClass);
	        s.transform = s.WebkitTransform = s.transitionDuration = '';
	        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
	          if (!e || /transform$/.test(e.propertyName)) {
	            el.removeEventListener(transitionEndEvent, cb);
	            el._moveCb = null;
	            removeTransitionClass(el, moveClass);
	          }
	        });
	      }
	    });
	  },
	
	  methods: {
	    hasMove: function hasMove (el, moveClass) {
	      /* istanbul ignore if */
	      if (!hasTransition) {
	        return false
	      }
	      if (this._hasMove != null) {
	        return this._hasMove
	      }
	      addTransitionClass(el, moveClass);
	      var info = getTransitionInfo(el);
	      removeTransitionClass(el, moveClass);
	      return (this._hasMove = info.hasTransform)
	    }
	  }
	};
	
	function callPendingCbs (c) {
	  /* istanbul ignore if */
	  if (c.elm._moveCb) {
	    c.elm._moveCb();
	  }
	  /* istanbul ignore if */
	  if (c.elm._enterCb) {
	    c.elm._enterCb();
	  }
	}
	
	function recordPosition (c) {
	  c.data.newPos = c.elm.getBoundingClientRect();
	}
	
	function applyTranslation (c) {
	  var oldPos = c.data.pos;
	  var newPos = c.data.newPos;
	  var dx = oldPos.left - newPos.left;
	  var dy = oldPos.top - newPos.top;
	  if (dx || dy) {
	    c.data.moved = true;
	    var s = c.elm.style;
	    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
	    s.transitionDuration = '0s';
	  }
	}
	
	var platformComponents = {
	  Transition: Transition,
	  TransitionGroup: TransitionGroup
	};
	
	/*  */
	
	// install platform specific utils
	Vue$3.config.isUnknownElement = isUnknownElement;
	Vue$3.config.isReservedTag = isReservedTag;
	Vue$3.config.getTagNamespace = getTagNamespace;
	Vue$3.config.mustUseProp = mustUseProp;
	
	// install platform runtime directives & components
	extend(Vue$3.options.directives, platformDirectives);
	extend(Vue$3.options.components, platformComponents);
	
	// install platform patch function
	Vue$3.prototype.__patch__ = inBrowser ? patch$1 : noop;
	
	// wrap mount
	Vue$3.prototype.$mount = function (
	  el,
	  hydrating
	) {
	  el = el && inBrowser ? query(el) : undefined;
	  return this._mount(el, hydrating)
	};
	
	if (false) {
	  console[console.info ? 'info' : 'log'](
	    "You are running Vue in development mode.\n" +
	    "Make sure to turn on production mode when deploying for production.\n" +
	    "See more tips at https://vuejs.org/guide/deployment.html"
	  );
	}
	
	// devtools global hook
	/* istanbul ignore next */
	setTimeout(function () {
	  if (config.devtools) {
	    if (devtools) {
	      devtools.emit('init', Vue$3);
	    } else if (
	      false
	    ) {
	      console[console.info ? 'info' : 'log'](
	        'Download the Vue Devtools extension for a better development experience:\n' +
	        'https://github.com/vuejs/vue-devtools'
	      );
	    }
	  }
	}, 0);
	
	/*  */
	
	// check whether current browser encodes a char inside attribute values
	function shouldDecode (content, encoded) {
	  var div = document.createElement('div');
	  div.innerHTML = "<div a=\"" + content + "\">";
	  return div.innerHTML.indexOf(encoded) > 0
	}
	
	// #3663
	// IE encodes newlines inside attribute values while other browsers don't
	var shouldDecodeNewlines = inBrowser ? shouldDecode('\n', '&#10;') : false;
	
	/*  */
	
	var decoder;
	
	function decode (html) {
	  decoder = decoder || document.createElement('div');
	  decoder.innerHTML = html;
	  return decoder.textContent
	}
	
	/*  */
	
	var isUnaryTag = makeMap(
	  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
	  'link,meta,param,source,track,wbr',
	  true
	);
	
	// Elements that you can, intentionally, leave open
	// (and which close themselves)
	var canBeLeftOpenTag = makeMap(
	  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source',
	  true
	);
	
	// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
	// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
	var isNonPhrasingTag = makeMap(
	  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
	  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
	  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
	  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
	  'title,tr,track',
	  true
	);
	
	/**
	 * Not type-checking this file because it's mostly vendor code.
	 */
	
	/*!
	 * HTML Parser By John Resig (ejohn.org)
	 * Modified by Juriy "kangax" Zaytsev
	 * Original code by Erik Arvidsson, Mozilla Public License
	 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
	 */
	
	// Regular Expressions for parsing tags and attributes
	var singleAttrIdentifier = /([^\s"'<>/=]+)/;
	var singleAttrAssign = /(?:=)/;
	var singleAttrValues = [
	  // attr value double quotes
	  /"([^"]*)"+/.source,
	  // attr value, single quotes
	  /'([^']*)'+/.source,
	  // attr value, no quotes
	  /([^\s"'=<>`]+)/.source
	];
	var attribute = new RegExp(
	  '^\\s*' + singleAttrIdentifier.source +
	  '(?:\\s*(' + singleAttrAssign.source + ')' +
	  '\\s*(?:' + singleAttrValues.join('|') + '))?'
	);
	
	// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
	// but for Vue templates we can enforce a simple charset
	var ncname = '[a-zA-Z_][\\w\\-\\.]*';
	var qnameCapture = '((?:' + ncname + '\\:)?' + ncname + ')';
	var startTagOpen = new RegExp('^<' + qnameCapture);
	var startTagClose = /^\s*(\/?)>/;
	var endTag = new RegExp('^<\\/' + qnameCapture + '[^>]*>');
	var doctype = /^<!DOCTYPE [^>]+>/i;
	var comment = /^<!--/;
	var conditionalComment = /^<!\[/;
	
	var IS_REGEX_CAPTURING_BROKEN = false;
	'x'.replace(/x(.)?/g, function (m, g) {
	  IS_REGEX_CAPTURING_BROKEN = g === '';
	});
	
	// Special Elements (can contain anything)
	var isScriptOrStyle = makeMap('script,style', true);
	var reCache = {};
	
	var ltRE = /&lt;/g;
	var gtRE = /&gt;/g;
	var nlRE = /&#10;/g;
	var ampRE = /&amp;/g;
	var quoteRE = /&quot;/g;
	
	function decodeAttr (value, shouldDecodeNewlines) {
	  if (shouldDecodeNewlines) {
	    value = value.replace(nlRE, '\n');
	  }
	  return value
	    .replace(ltRE, '<')
	    .replace(gtRE, '>')
	    .replace(ampRE, '&')
	    .replace(quoteRE, '"')
	}
	
	function parseHTML (html, options) {
	  var stack = [];
	  var expectHTML = options.expectHTML;
	  var isUnaryTag$$1 = options.isUnaryTag || no;
	  var index = 0;
	  var last, lastTag;
	  while (html) {
	    last = html;
	    // Make sure we're not in a script or style element
	    if (!lastTag || !isScriptOrStyle(lastTag)) {
	      var textEnd = html.indexOf('<');
	      if (textEnd === 0) {
	        // Comment:
	        if (comment.test(html)) {
	          var commentEnd = html.indexOf('-->');
	
	          if (commentEnd >= 0) {
	            advance(commentEnd + 3);
	            continue
	          }
	        }
	
	        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
	        if (conditionalComment.test(html)) {
	          var conditionalEnd = html.indexOf(']>');
	
	          if (conditionalEnd >= 0) {
	            advance(conditionalEnd + 2);
	            continue
	          }
	        }
	
	        // Doctype:
	        var doctypeMatch = html.match(doctype);
	        if (doctypeMatch) {
	          advance(doctypeMatch[0].length);
	          continue
	        }
	
	        // End tag:
	        var endTagMatch = html.match(endTag);
	        if (endTagMatch) {
	          var curIndex = index;
	          advance(endTagMatch[0].length);
	          parseEndTag(endTagMatch[1], curIndex, index);
	          continue
	        }
	
	        // Start tag:
	        var startTagMatch = parseStartTag();
	        if (startTagMatch) {
	          handleStartTag(startTagMatch);
	          continue
	        }
	      }
	
	      var text = (void 0), rest$1 = (void 0), next = (void 0);
	      if (textEnd > 0) {
	        rest$1 = html.slice(textEnd);
	        while (
	          !endTag.test(rest$1) &&
	          !startTagOpen.test(rest$1) &&
	          !comment.test(rest$1) &&
	          !conditionalComment.test(rest$1)
	        ) {
	          // < in plain text, be forgiving and treat it as text
	          next = rest$1.indexOf('<', 1);
	          if (next < 0) { break }
	          textEnd += next;
	          rest$1 = html.slice(textEnd);
	        }
	        text = html.substring(0, textEnd);
	        advance(textEnd);
	      }
	
	      if (textEnd < 0) {
	        text = html;
	        html = '';
	      }
	
	      if (options.chars && text) {
	        options.chars(text);
	      }
	    } else {
	      var stackedTag = lastTag.toLowerCase();
	      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
	      var endTagLength = 0;
	      var rest = html.replace(reStackedTag, function (all, text, endTag) {
	        endTagLength = endTag.length;
	        if (stackedTag !== 'script' && stackedTag !== 'style' && stackedTag !== 'noscript') {
	          text = text
	            .replace(/<!--([\s\S]*?)-->/g, '$1')
	            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
	        }
	        if (options.chars) {
	          options.chars(text);
	        }
	        return ''
	      });
	      index += html.length - rest.length;
	      html = rest;
	      parseEndTag(stackedTag, index - endTagLength, index);
	    }
	
	    if (html === last && options.chars) {
	      options.chars(html);
	      break
	    }
	  }
	
	  // Clean up any remaining tags
	  parseEndTag();
	
	  function advance (n) {
	    index += n;
	    html = html.substring(n);
	  }
	
	  function parseStartTag () {
	    var start = html.match(startTagOpen);
	    if (start) {
	      var match = {
	        tagName: start[1],
	        attrs: [],
	        start: index
	      };
	      advance(start[0].length);
	      var end, attr;
	      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
	        advance(attr[0].length);
	        match.attrs.push(attr);
	      }
	      if (end) {
	        match.unarySlash = end[1];
	        advance(end[0].length);
	        match.end = index;
	        return match
	      }
	    }
	  }
	
	  function handleStartTag (match) {
	    var tagName = match.tagName;
	    var unarySlash = match.unarySlash;
	
	    if (expectHTML) {
	      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
	        parseEndTag(lastTag);
	      }
	      if (canBeLeftOpenTag(tagName) && lastTag === tagName) {
	        parseEndTag(tagName);
	      }
	    }
	
	    var unary = isUnaryTag$$1(tagName) || tagName === 'html' && lastTag === 'head' || !!unarySlash;
	
	    var l = match.attrs.length;
	    var attrs = new Array(l);
	    for (var i = 0; i < l; i++) {
	      var args = match.attrs[i];
	      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
	      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
	        if (args[3] === '') { delete args[3]; }
	        if (args[4] === '') { delete args[4]; }
	        if (args[5] === '') { delete args[5]; }
	      }
	      var value = args[3] || args[4] || args[5] || '';
	      attrs[i] = {
	        name: args[1],
	        value: decodeAttr(
	          value,
	          options.shouldDecodeNewlines
	        )
	      };
	    }
	
	    if (!unary) {
	      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
	      lastTag = tagName;
	      unarySlash = '';
	    }
	
	    if (options.start) {
	      options.start(tagName, attrs, unary, match.start, match.end);
	    }
	  }
	
	  function parseEndTag (tagName, start, end) {
	    var pos, lowerCasedTagName;
	    if (start == null) { start = index; }
	    if (end == null) { end = index; }
	
	    if (tagName) {
	      lowerCasedTagName = tagName.toLowerCase();
	    }
	
	    // Find the closest opened tag of the same type
	    if (tagName) {
	      for (pos = stack.length - 1; pos >= 0; pos--) {
	        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
	          break
	        }
	      }
	    } else {
	      // If no tag name is provided, clean shop
	      pos = 0;
	    }
	
	    if (pos >= 0) {
	      // Close all the open elements, up the stack
	      for (var i = stack.length - 1; i >= pos; i--) {
	        if (options.end) {
	          options.end(stack[i].tag, start, end);
	        }
	      }
	
	      // Remove the open elements from the stack
	      stack.length = pos;
	      lastTag = pos && stack[pos - 1].tag;
	    } else if (lowerCasedTagName === 'br') {
	      if (options.start) {
	        options.start(tagName, [], true, start, end);
	      }
	    } else if (lowerCasedTagName === 'p') {
	      if (options.start) {
	        options.start(tagName, [], false, start, end);
	      }
	      if (options.end) {
	        options.end(tagName, start, end);
	      }
	    }
	  }
	}
	
	/*  */
	
	function parseFilters (exp) {
	  var inSingle = false;
	  var inDouble = false;
	  var inTemplateString = false;
	  var inRegex = false;
	  var curly = 0;
	  var square = 0;
	  var paren = 0;
	  var lastFilterIndex = 0;
	  var c, prev, i, expression, filters;
	
	  for (i = 0; i < exp.length; i++) {
	    prev = c;
	    c = exp.charCodeAt(i);
	    if (inSingle) {
	      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
	    } else if (inDouble) {
	      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
	    } else if (inTemplateString) {
	      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
	    } else if (inRegex) {
	      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
	    } else if (
	      c === 0x7C && // pipe
	      exp.charCodeAt(i + 1) !== 0x7C &&
	      exp.charCodeAt(i - 1) !== 0x7C &&
	      !curly && !square && !paren
	    ) {
	      if (expression === undefined) {
	        // first filter, end of expression
	        lastFilterIndex = i + 1;
	        expression = exp.slice(0, i).trim();
	      } else {
	        pushFilter();
	      }
	    } else {
	      switch (c) {
	        case 0x22: inDouble = true; break         // "
	        case 0x27: inSingle = true; break         // '
	        case 0x60: inTemplateString = true; break // `
	        case 0x28: paren++; break                 // (
	        case 0x29: paren--; break                 // )
	        case 0x5B: square++; break                // [
	        case 0x5D: square--; break                // ]
	        case 0x7B: curly++; break                 // {
	        case 0x7D: curly--; break                 // }
	      }
	      if (c === 0x2f) { // /
	        var j = i - 1;
	        var p = (void 0);
	        // find first non-whitespace prev char
	        for (; j >= 0; j--) {
	          p = exp.charAt(j);
	          if (p !== ' ') { break }
	        }
	        if (!p || !/[\w$]/.test(p)) {
	          inRegex = true;
	        }
	      }
	    }
	  }
	
	  if (expression === undefined) {
	    expression = exp.slice(0, i).trim();
	  } else if (lastFilterIndex !== 0) {
	    pushFilter();
	  }
	
	  function pushFilter () {
	    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
	    lastFilterIndex = i + 1;
	  }
	
	  if (filters) {
	    for (i = 0; i < filters.length; i++) {
	      expression = wrapFilter(expression, filters[i]);
	    }
	  }
	
	  return expression
	}
	
	function wrapFilter (exp, filter) {
	  var i = filter.indexOf('(');
	  if (i < 0) {
	    // _f: resolveFilter
	    return ("_f(\"" + filter + "\")(" + exp + ")")
	  } else {
	    var name = filter.slice(0, i);
	    var args = filter.slice(i + 1);
	    return ("_f(\"" + name + "\")(" + exp + "," + args)
	  }
	}
	
	/*  */
	
	var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
	var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
	
	var buildRegex = cached(function (delimiters) {
	  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
	  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
	  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
	});
	
	function parseText (
	  text,
	  delimiters
	) {
	  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
	  if (!tagRE.test(text)) {
	    return
	  }
	  var tokens = [];
	  var lastIndex = tagRE.lastIndex = 0;
	  var match, index;
	  while ((match = tagRE.exec(text))) {
	    index = match.index;
	    // push text token
	    if (index > lastIndex) {
	      tokens.push(JSON.stringify(text.slice(lastIndex, index)));
	    }
	    // tag token
	    var exp = parseFilters(match[1].trim());
	    tokens.push(("_s(" + exp + ")"));
	    lastIndex = index + match[0].length;
	  }
	  if (lastIndex < text.length) {
	    tokens.push(JSON.stringify(text.slice(lastIndex)));
	  }
	  return tokens.join('+')
	}
	
	/*  */
	
	function baseWarn (msg) {
	  console.error(("[Vue parser]: " + msg));
	}
	
	function pluckModuleFunction (
	  modules,
	  key
	) {
	  return modules
	    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
	    : []
	}
	
	function addProp (el, name, value) {
	  (el.props || (el.props = [])).push({ name: name, value: value });
	}
	
	function addAttr (el, name, value) {
	  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
	}
	
	function addDirective (
	  el,
	  name,
	  rawName,
	  value,
	  arg,
	  modifiers
	) {
	  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
	}
	
	function addHandler (
	  el,
	  name,
	  value,
	  modifiers,
	  important
	) {
	  // check capture modifier
	  if (modifiers && modifiers.capture) {
	    delete modifiers.capture;
	    name = '!' + name; // mark the event as captured
	  }
	  if (modifiers && modifiers.once) {
	    delete modifiers.once;
	    name = '~' + name; // mark the event as once
	  }
	  var events;
	  if (modifiers && modifiers.native) {
	    delete modifiers.native;
	    events = el.nativeEvents || (el.nativeEvents = {});
	  } else {
	    events = el.events || (el.events = {});
	  }
	  var newHandler = { value: value, modifiers: modifiers };
	  var handlers = events[name];
	  /* istanbul ignore if */
	  if (Array.isArray(handlers)) {
	    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
	  } else if (handlers) {
	    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
	  } else {
	    events[name] = newHandler;
	  }
	}
	
	function getBindingAttr (
	  el,
	  name,
	  getStatic
	) {
	  var dynamicValue =
	    getAndRemoveAttr(el, ':' + name) ||
	    getAndRemoveAttr(el, 'v-bind:' + name);
	  if (dynamicValue != null) {
	    return parseFilters(dynamicValue)
	  } else if (getStatic !== false) {
	    var staticValue = getAndRemoveAttr(el, name);
	    if (staticValue != null) {
	      return JSON.stringify(staticValue)
	    }
	  }
	}
	
	function getAndRemoveAttr (el, name) {
	  var val;
	  if ((val = el.attrsMap[name]) != null) {
	    var list = el.attrsList;
	    for (var i = 0, l = list.length; i < l; i++) {
	      if (list[i].name === name) {
	        list.splice(i, 1);
	        break
	      }
	    }
	  }
	  return val
	}
	
	var len;
	var str;
	var chr;
	var index$1;
	var expressionPos;
	var expressionEndPos;
	
	/**
	 * parse directive model to do the array update transform. a[idx] = val => $$a.splice($$idx, 1, val)
	 *
	 * for loop possible cases:
	 *
	 * - test
	 * - test[idx]
	 * - test[test1[idx]]
	 * - test["a"][idx]
	 * - xxx.test[a[a].test1[idx]]
	 * - test.xxx.a["asa"][test1[idx]]
	 *
	 */
	
	function parseModel (val) {
	  str = val;
	  len = str.length;
	  index$1 = expressionPos = expressionEndPos = 0;
	
	  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
	    return {
	      exp: val,
	      idx: null
	    }
	  }
	
	  while (!eof()) {
	    chr = next();
	    /* istanbul ignore if */
	    if (isStringStart(chr)) {
	      parseString(chr);
	    } else if (chr === 0x5B) {
	      parseBracket(chr);
	    }
	  }
	
	  return {
	    exp: val.substring(0, expressionPos),
	    idx: val.substring(expressionPos + 1, expressionEndPos)
	  }
	}
	
	function next () {
	  return str.charCodeAt(++index$1)
	}
	
	function eof () {
	  return index$1 >= len
	}
	
	function isStringStart (chr) {
	  return chr === 0x22 || chr === 0x27
	}
	
	function parseBracket (chr) {
	  var inBracket = 1;
	  expressionPos = index$1;
	  while (!eof()) {
	    chr = next();
	    if (isStringStart(chr)) {
	      parseString(chr);
	      continue
	    }
	    if (chr === 0x5B) { inBracket++; }
	    if (chr === 0x5D) { inBracket--; }
	    if (inBracket === 0) {
	      expressionEndPos = index$1;
	      break
	    }
	  }
	}
	
	function parseString (chr) {
	  var stringQuote = chr;
	  while (!eof()) {
	    chr = next();
	    if (chr === stringQuote) {
	      break
	    }
	  }
	}
	
	/*  */
	
	var dirRE = /^v-|^@|^:/;
	var forAliasRE = /(.*?)\s+(?:in|of)\s+(.*)/;
	var forIteratorRE = /\((\{[^}]*\}|[^,]*),([^,]*)(?:,([^,]*))?\)/;
	var bindRE = /^:|^v-bind:/;
	var onRE = /^@|^v-on:/;
	var argRE = /:(.*)$/;
	var modifierRE = /\.[^.]+/g;
	
	var decodeHTMLCached = cached(decode);
	
	// configurable state
	var warn$1;
	var platformGetTagNamespace;
	var platformMustUseProp;
	var platformIsPreTag;
	var preTransforms;
	var transforms;
	var postTransforms;
	var delimiters;
	
	/**
	 * Convert HTML string to AST.
	 */
	function parse (
	  template,
	  options
	) {
	  warn$1 = options.warn || baseWarn;
	  platformGetTagNamespace = options.getTagNamespace || no;
	  platformMustUseProp = options.mustUseProp || no;
	  platformIsPreTag = options.isPreTag || no;
	  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
	  transforms = pluckModuleFunction(options.modules, 'transformNode');
	  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');
	  delimiters = options.delimiters;
	  var stack = [];
	  var preserveWhitespace = options.preserveWhitespace !== false;
	  var root;
	  var currentParent;
	  var inVPre = false;
	  var inPre = false;
	  var warned = false;
	  parseHTML(template, {
	    expectHTML: options.expectHTML,
	    isUnaryTag: options.isUnaryTag,
	    shouldDecodeNewlines: options.shouldDecodeNewlines,
	    start: function start (tag, attrs, unary) {
	      // check namespace.
	      // inherit parent ns if there is one
	      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);
	
	      // handle IE svg bug
	      /* istanbul ignore if */
	      if (isIE && ns === 'svg') {
	        attrs = guardIESVGBug(attrs);
	      }
	
	      var element = {
	        type: 1,
	        tag: tag,
	        attrsList: attrs,
	        attrsMap: makeAttrsMap(attrs),
	        parent: currentParent,
	        children: []
	      };
	      if (ns) {
	        element.ns = ns;
	      }
	
	      if (isForbiddenTag(element) && !isServerRendering()) {
	        element.forbidden = true;
	        ("production") !== 'production' && warn$1(
	          'Templates should only be responsible for mapping the state to the ' +
	          'UI. Avoid placing tags with side-effects in your templates, such as ' +
	          "<" + tag + ">" + ', as they will not be parsed.'
	        );
	      }
	
	      // apply pre-transforms
	      for (var i = 0; i < preTransforms.length; i++) {
	        preTransforms[i](element, options);
	      }
	
	      if (!inVPre) {
	        processPre(element);
	        if (element.pre) {
	          inVPre = true;
	        }
	      }
	      if (platformIsPreTag(element.tag)) {
	        inPre = true;
	      }
	      if (inVPre) {
	        processRawAttrs(element);
	      } else {
	        processFor(element);
	        processIf(element);
	        processOnce(element);
	        processKey(element);
	
	        // determine whether this is a plain element after
	        // removing structural attributes
	        element.plain = !element.key && !attrs.length;
	
	        processRef(element);
	        processSlot(element);
	        processComponent(element);
	        for (var i$1 = 0; i$1 < transforms.length; i$1++) {
	          transforms[i$1](element, options);
	        }
	        processAttrs(element);
	      }
	
	      function checkRootConstraints (el) {
	        if (false) {
	          if (el.tag === 'slot' || el.tag === 'template') {
	            warned = true;
	            warn$1(
	              "Cannot use <" + (el.tag) + "> as component root element because it may " +
	              'contain multiple nodes:\n' + template
	            );
	          }
	          if (el.attrsMap.hasOwnProperty('v-for')) {
	            warned = true;
	            warn$1(
	              'Cannot use v-for on stateful component root element because ' +
	              'it renders multiple elements:\n' + template
	            );
	          }
	        }
	      }
	
	      // tree management
	      if (!root) {
	        root = element;
	        checkRootConstraints(root);
	      } else if (!stack.length) {
	        // allow root elements with v-if, v-else-if and v-else
	        if (root.if && (element.elseif || element.else)) {
	          checkRootConstraints(element);
	          addIfCondition(root, {
	            exp: element.elseif,
	            block: element
	          });
	        } else if (false) {
	          warned = true;
	          warn$1(
	            "Component template should contain exactly one root element:" +
	            "\n\n" + template + "\n\n" +
	            "If you are using v-if on multiple elements, " +
	            "use v-else-if to chain them instead."
	          );
	        }
	      }
	      if (currentParent && !element.forbidden) {
	        if (element.elseif || element.else) {
	          processIfConditions(element, currentParent);
	        } else if (element.slotScope) { // scoped slot
	          currentParent.plain = false;
	          var name = element.slotTarget || 'default';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
	        } else {
	          currentParent.children.push(element);
	          element.parent = currentParent;
	        }
	      }
	      if (!unary) {
	        currentParent = element;
	        stack.push(element);
	      }
	      // apply post-transforms
	      for (var i$2 = 0; i$2 < postTransforms.length; i$2++) {
	        postTransforms[i$2](element, options);
	      }
	    },
	
	    end: function end () {
	      // remove trailing whitespace
	      var element = stack[stack.length - 1];
	      var lastNode = element.children[element.children.length - 1];
	      if (lastNode && lastNode.type === 3 && lastNode.text === ' ') {
	        element.children.pop();
	      }
	      // pop stack
	      stack.length -= 1;
	      currentParent = stack[stack.length - 1];
	      // check pre state
	      if (element.pre) {
	        inVPre = false;
	      }
	      if (platformIsPreTag(element.tag)) {
	        inPre = false;
	      }
	    },
	
	    chars: function chars (text) {
	      if (!currentParent) {
	        if (false) {
	          warned = true;
	          warn$1(
	            'Component template requires a root element, rather than just text:\n\n' + template
	          );
	        }
	        return
	      }
	      // IE textarea placeholder bug
	      /* istanbul ignore if */
	      if (isIE &&
	          currentParent.tag === 'textarea' &&
	          currentParent.attrsMap.placeholder === text) {
	        return
	      }
	      var children = currentParent.children;
	      text = inPre || text.trim()
	        ? decodeHTMLCached(text)
	        // only preserve whitespace if its not right after a starting tag
	        : preserveWhitespace && children.length ? ' ' : '';
	      if (text) {
	        var expression;
	        if (!inVPre && text !== ' ' && (expression = parseText(text, delimiters))) {
	          children.push({
	            type: 2,
	            expression: expression,
	            text: text
	          });
	        } else if (text !== ' ' || children[children.length - 1].text !== ' ') {
	          currentParent.children.push({
	            type: 3,
	            text: text
	          });
	        }
	      }
	    }
	  });
	  return root
	}
	
	function processPre (el) {
	  if (getAndRemoveAttr(el, 'v-pre') != null) {
	    el.pre = true;
	  }
	}
	
	function processRawAttrs (el) {
	  var l = el.attrsList.length;
	  if (l) {
	    var attrs = el.attrs = new Array(l);
	    for (var i = 0; i < l; i++) {
	      attrs[i] = {
	        name: el.attrsList[i].name,
	        value: JSON.stringify(el.attrsList[i].value)
	      };
	    }
	  } else if (!el.pre) {
	    // non root node in pre blocks with no attributes
	    el.plain = true;
	  }
	}
	
	function processKey (el) {
	  var exp = getBindingAttr(el, 'key');
	  if (exp) {
	    if (false) {
	      warn$1("<template> cannot be keyed. Place the key on real elements instead.");
	    }
	    el.key = exp;
	  }
	}
	
	function processRef (el) {
	  var ref = getBindingAttr(el, 'ref');
	  if (ref) {
	    el.ref = ref;
	    el.refInFor = checkInFor(el);
	  }
	}
	
	function processFor (el) {
	  var exp;
	  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
	    var inMatch = exp.match(forAliasRE);
	    if (!inMatch) {
	      ("production") !== 'production' && warn$1(
	        ("Invalid v-for expression: " + exp)
	      );
	      return
	    }
	    el.for = inMatch[2].trim();
	    var alias = inMatch[1].trim();
	    var iteratorMatch = alias.match(forIteratorRE);
	    if (iteratorMatch) {
	      el.alias = iteratorMatch[1].trim();
	      el.iterator1 = iteratorMatch[2].trim();
	      if (iteratorMatch[3]) {
	        el.iterator2 = iteratorMatch[3].trim();
	      }
	    } else {
	      el.alias = alias;
	    }
	  }
	}
	
	function processIf (el) {
	  var exp = getAndRemoveAttr(el, 'v-if');
	  if (exp) {
	    el.if = exp;
	    addIfCondition(el, {
	      exp: exp,
	      block: el
	    });
	  } else {
	    if (getAndRemoveAttr(el, 'v-else') != null) {
	      el.else = true;
	    }
	    var elseif = getAndRemoveAttr(el, 'v-else-if');
	    if (elseif) {
	      el.elseif = elseif;
	    }
	  }
	}
	
	function processIfConditions (el, parent) {
	  var prev = findPrevElement(parent.children);
	  if (prev && prev.if) {
	    addIfCondition(prev, {
	      exp: el.elseif,
	      block: el
	    });
	  } else if (false) {
	    warn$1(
	      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
	      "used on element <" + (el.tag) + "> without corresponding v-if."
	    );
	  }
	}
	
	function findPrevElement (children) {
	  var i = children.length;
	  while (i--) {
	    if (children[i].type === 1) {
	      return children[i]
	    } else {
	      if (false) {
	        warn$1(
	          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
	          "will be ignored."
	        );
	      }
	      children.pop();
	    }
	  }
	}
	
	function addIfCondition (el, condition) {
	  if (!el.ifConditions) {
	    el.ifConditions = [];
	  }
	  el.ifConditions.push(condition);
	}
	
	function processOnce (el) {
	  var once = getAndRemoveAttr(el, 'v-once');
	  if (once != null) {
	    el.once = true;
	  }
	}
	
	function processSlot (el) {
	  if (el.tag === 'slot') {
	    el.slotName = getBindingAttr(el, 'name');
	    if (false) {
	      warn$1(
	        "`key` does not work on <slot> because slots are abstract outlets " +
	        "and can possibly expand into multiple elements. " +
	        "Use the key on a wrapping element instead."
	      );
	    }
	  } else {
	    var slotTarget = getBindingAttr(el, 'slot');
	    if (slotTarget) {
	      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
	    }
	    if (el.tag === 'template') {
	      el.slotScope = getAndRemoveAttr(el, 'scope');
	    }
	  }
	}
	
	function processComponent (el) {
	  var binding;
	  if ((binding = getBindingAttr(el, 'is'))) {
	    el.component = binding;
	  }
	  if (getAndRemoveAttr(el, 'inline-template') != null) {
	    el.inlineTemplate = true;
	  }
	}
	
	function processAttrs (el) {
	  var list = el.attrsList;
	  var i, l, name, rawName, value, arg, modifiers, isProp;
	  for (i = 0, l = list.length; i < l; i++) {
	    name = rawName = list[i].name;
	    value = list[i].value;
	    if (dirRE.test(name)) {
	      // mark element as dynamic
	      el.hasBindings = true;
	      // modifiers
	      modifiers = parseModifiers(name);
	      if (modifiers) {
	        name = name.replace(modifierRE, '');
	      }
	      if (bindRE.test(name)) { // v-bind
	        name = name.replace(bindRE, '');
	        value = parseFilters(value);
	        isProp = false;
	        if (modifiers) {
	          if (modifiers.prop) {
	            isProp = true;
	            name = camelize(name);
	            if (name === 'innerHtml') { name = 'innerHTML'; }
	          }
	          if (modifiers.camel) {
	            name = camelize(name);
	          }
	        }
	        if (isProp || platformMustUseProp(el.tag, el.attrsMap.type, name)) {
	          addProp(el, name, value);
	        } else {
	          addAttr(el, name, value);
	        }
	      } else if (onRE.test(name)) { // v-on
	        name = name.replace(onRE, '');
	        addHandler(el, name, value, modifiers);
	      } else { // normal directives
	        name = name.replace(dirRE, '');
	        // parse arg
	        var argMatch = name.match(argRE);
	        if (argMatch && (arg = argMatch[1])) {
	          name = name.slice(0, -(arg.length + 1));
	        }
	        addDirective(el, name, rawName, value, arg, modifiers);
	        if (false) {
	          checkForAliasModel(el, value);
	        }
	      }
	    } else {
	      // literal attribute
	      if (false) {
	        var expression = parseText(value, delimiters);
	        if (expression) {
	          warn$1(
	            name + "=\"" + value + "\": " +
	            'Interpolation inside attributes has been removed. ' +
	            'Use v-bind or the colon shorthand instead. For example, ' +
	            'instead of <div id="{{ val }}">, use <div :id="val">.'
	          );
	        }
	      }
	      addAttr(el, name, JSON.stringify(value));
	    }
	  }
	}
	
	function checkInFor (el) {
	  var parent = el;
	  while (parent) {
	    if (parent.for !== undefined) {
	      return true
	    }
	    parent = parent.parent;
	  }
	  return false
	}
	
	function parseModifiers (name) {
	  var match = name.match(modifierRE);
	  if (match) {
	    var ret = {};
	    match.forEach(function (m) { ret[m.slice(1)] = true; });
	    return ret
	  }
	}
	
	function makeAttrsMap (attrs) {
	  var map = {};
	  for (var i = 0, l = attrs.length; i < l; i++) {
	    if (false) {
	      warn$1('duplicate attribute: ' + attrs[i].name);
	    }
	    map[attrs[i].name] = attrs[i].value;
	  }
	  return map
	}
	
	function isForbiddenTag (el) {
	  return (
	    el.tag === 'style' ||
	    (el.tag === 'script' && (
	      !el.attrsMap.type ||
	      el.attrsMap.type === 'text/javascript'
	    ))
	  )
	}
	
	var ieNSBug = /^xmlns:NS\d+/;
	var ieNSPrefix = /^NS\d+:/;
	
	/* istanbul ignore next */
	function guardIESVGBug (attrs) {
	  var res = [];
	  for (var i = 0; i < attrs.length; i++) {
	    var attr = attrs[i];
	    if (!ieNSBug.test(attr.name)) {
	      attr.name = attr.name.replace(ieNSPrefix, '');
	      res.push(attr);
	    }
	  }
	  return res
	}
	
	function checkForAliasModel (el, value) {
	  var _el = el;
	  while (_el) {
	    if (_el.for && _el.alias === value) {
	      warn$1(
	        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
	        "You are binding v-model directly to a v-for iteration alias. " +
	        "This will not be able to modify the v-for source array because " +
	        "writing to the alias is like modifying a function local variable. " +
	        "Consider using an array of objects and use v-model on an object property instead."
	      );
	    }
	    _el = _el.parent;
	  }
	}
	
	/*  */
	
	var isStaticKey;
	var isPlatformReservedTag;
	
	var genStaticKeysCached = cached(genStaticKeys$1);
	
	/**
	 * Goal of the optimizer: walk the generated template AST tree
	 * and detect sub-trees that are purely static, i.e. parts of
	 * the DOM that never needs to change.
	 *
	 * Once we detect these sub-trees, we can:
	 *
	 * 1. Hoist them into constants, so that we no longer need to
	 *    create fresh nodes for them on each re-render;
	 * 2. Completely skip them in the patching process.
	 */
	function optimize (root, options) {
	  if (!root) { return }
	  isStaticKey = genStaticKeysCached(options.staticKeys || '');
	  isPlatformReservedTag = options.isReservedTag || no;
	  // first pass: mark all non-static nodes.
	  markStatic(root);
	  // second pass: mark static roots.
	  markStaticRoots(root, false);
	}
	
	function genStaticKeys$1 (keys) {
	  return makeMap(
	    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
	    (keys ? ',' + keys : '')
	  )
	}
	
	function markStatic (node) {
	  node.static = isStatic(node);
	  if (node.type === 1) {
	    // do not make component slot content static. this avoids
	    // 1. components not able to mutate slot nodes
	    // 2. static slot content fails for hot-reloading
	    if (
	      !isPlatformReservedTag(node.tag) &&
	      node.tag !== 'slot' &&
	      node.attrsMap['inline-template'] == null
	    ) {
	      return
	    }
	    for (var i = 0, l = node.children.length; i < l; i++) {
	      var child = node.children[i];
	      markStatic(child);
	      if (!child.static) {
	        node.static = false;
	      }
	    }
	  }
	}
	
	function markStaticRoots (node, isInFor) {
	  if (node.type === 1) {
	    if (node.static || node.once) {
	      node.staticInFor = isInFor;
	    }
	    // For a node to qualify as a static root, it should have children that
	    // are not just static text. Otherwise the cost of hoisting out will
	    // outweigh the benefits and it's better off to just always render it fresh.
	    if (node.static && node.children.length && !(
	      node.children.length === 1 &&
	      node.children[0].type === 3
	    )) {
	      node.staticRoot = true;
	      return
	    } else {
	      node.staticRoot = false;
	    }
	    if (node.children) {
	      for (var i = 0, l = node.children.length; i < l; i++) {
	        markStaticRoots(node.children[i], isInFor || !!node.for);
	      }
	    }
	    if (node.ifConditions) {
	      walkThroughConditionsBlocks(node.ifConditions, isInFor);
	    }
	  }
	}
	
	function walkThroughConditionsBlocks (conditionBlocks, isInFor) {
	  for (var i = 1, len = conditionBlocks.length; i < len; i++) {
	    markStaticRoots(conditionBlocks[i].block, isInFor);
	  }
	}
	
	function isStatic (node) {
	  if (node.type === 2) { // expression
	    return false
	  }
	  if (node.type === 3) { // text
	    return true
	  }
	  return !!(node.pre || (
	    !node.hasBindings && // no dynamic bindings
	    !node.if && !node.for && // not v-if or v-for or v-else
	    !isBuiltInTag(node.tag) && // not a built-in
	    isPlatformReservedTag(node.tag) && // not a component
	    !isDirectChildOfTemplateFor(node) &&
	    Object.keys(node).every(isStaticKey)
	  ))
	}
	
	function isDirectChildOfTemplateFor (node) {
	  while (node.parent) {
	    node = node.parent;
	    if (node.tag !== 'template') {
	      return false
	    }
	    if (node.for) {
	      return true
	    }
	  }
	  return false
	}
	
	/*  */
	
	var fnExpRE = /^\s*([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
	var simplePathRE = /^\s*[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?']|\[".*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*\s*$/;
	
	// keyCode aliases
	var keyCodes = {
	  esc: 27,
	  tab: 9,
	  enter: 13,
	  space: 32,
	  up: 38,
	  left: 37,
	  right: 39,
	  down: 40,
	  'delete': [8, 46]
	};
	
	var modifierCode = {
	  stop: '$event.stopPropagation();',
	  prevent: '$event.preventDefault();',
	  self: 'if($event.target !== $event.currentTarget)return;',
	  ctrl: 'if(!$event.ctrlKey)return;',
	  shift: 'if(!$event.shiftKey)return;',
	  alt: 'if(!$event.altKey)return;',
	  meta: 'if(!$event.metaKey)return;'
	};
	
	function genHandlers (events, native) {
	  var res = native ? 'nativeOn:{' : 'on:{';
	  for (var name in events) {
	    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
	  }
	  return res.slice(0, -1) + '}'
	}
	
	function genHandler (
	  name,
	  handler
	) {
	  if (!handler) {
	    return 'function(){}'
	  } else if (Array.isArray(handler)) {
	    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
	  } else if (!handler.modifiers) {
	    return fnExpRE.test(handler.value) || simplePathRE.test(handler.value)
	      ? handler.value
	      : ("function($event){" + (handler.value) + "}")
	  } else {
	    var code = '';
	    var keys = [];
	    for (var key in handler.modifiers) {
	      if (modifierCode[key]) {
	        code += modifierCode[key];
	      } else {
	        keys.push(key);
	      }
	    }
	    if (keys.length) {
	      code = genKeyFilter(keys) + code;
	    }
	    var handlerCode = simplePathRE.test(handler.value)
	      ? handler.value + '($event)'
	      : handler.value;
	    return 'function($event){' + code + handlerCode + '}'
	  }
	}
	
	function genKeyFilter (keys) {
	  return ("if(" + (keys.map(genFilterCode).join('&&')) + ")return;")
	}
	
	function genFilterCode (key) {
	  var keyVal = parseInt(key, 10);
	  if (keyVal) {
	    return ("$event.keyCode!==" + keyVal)
	  }
	  var alias = keyCodes[key];
	  return ("_k($event.keyCode," + (JSON.stringify(key)) + (alias ? ',' + JSON.stringify(alias) : '') + ")")
	}
	
	/*  */
	
	function bind$2 (el, dir) {
	  el.wrapData = function (code) {
	    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + (dir.modifiers && dir.modifiers.prop ? ',true' : '') + ")")
	  };
	}
	
	/*  */
	
	var baseDirectives = {
	  bind: bind$2,
	  cloak: noop
	};
	
	/*  */
	
	// configurable state
	var warn$2;
	var transforms$1;
	var dataGenFns;
	var platformDirectives$1;
	var isPlatformReservedTag$1;
	var staticRenderFns;
	var onceCount;
	var currentOptions;
	
	function generate (
	  ast,
	  options
	) {
	  // save previous staticRenderFns so generate calls can be nested
	  var prevStaticRenderFns = staticRenderFns;
	  var currentStaticRenderFns = staticRenderFns = [];
	  var prevOnceCount = onceCount;
	  onceCount = 0;
	  currentOptions = options;
	  warn$2 = options.warn || baseWarn;
	  transforms$1 = pluckModuleFunction(options.modules, 'transformCode');
	  dataGenFns = pluckModuleFunction(options.modules, 'genData');
	  platformDirectives$1 = options.directives || {};
	  isPlatformReservedTag$1 = options.isReservedTag || no;
	  var code = ast ? genElement(ast) : '_c("div")';
	  staticRenderFns = prevStaticRenderFns;
	  onceCount = prevOnceCount;
	  return {
	    render: ("with(this){return " + code + "}"),
	    staticRenderFns: currentStaticRenderFns
	  }
	}
	
	function genElement (el) {
	  if (el.staticRoot && !el.staticProcessed) {
	    return genStatic(el)
	  } else if (el.once && !el.onceProcessed) {
	    return genOnce(el)
	  } else if (el.for && !el.forProcessed) {
	    return genFor(el)
	  } else if (el.if && !el.ifProcessed) {
	    return genIf(el)
	  } else if (el.tag === 'template' && !el.slotTarget) {
	    return genChildren(el) || 'void 0'
	  } else if (el.tag === 'slot') {
	    return genSlot(el)
	  } else {
	    // component or element
	    var code;
	    if (el.component) {
	      code = genComponent(el.component, el);
	    } else {
	      var data = el.plain ? undefined : genData(el);
	
	      var children = el.inlineTemplate ? null : genChildren(el, true);
	      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
	    }
	    // module transforms
	    for (var i = 0; i < transforms$1.length; i++) {
	      code = transforms$1[i](el, code);
	    }
	    return code
	  }
	}
	
	// hoist static sub-trees out
	function genStatic (el) {
	  el.staticProcessed = true;
	  staticRenderFns.push(("with(this){return " + (genElement(el)) + "}"));
	  return ("_m(" + (staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
	}
	
	// v-once
	function genOnce (el) {
	  el.onceProcessed = true;
	  if (el.if && !el.ifProcessed) {
	    return genIf(el)
	  } else if (el.staticInFor) {
	    var key = '';
	    var parent = el.parent;
	    while (parent) {
	      if (parent.for) {
	        key = parent.key;
	        break
	      }
	      parent = parent.parent;
	    }
	    if (!key) {
	      ("production") !== 'production' && warn$2(
	        "v-once can only be used inside v-for that is keyed. "
	      );
	      return genElement(el)
	    }
	    return ("_o(" + (genElement(el)) + "," + (onceCount++) + (key ? ("," + key) : "") + ")")
	  } else {
	    return genStatic(el)
	  }
	}
	
	function genIf (el) {
	  el.ifProcessed = true; // avoid recursion
	  return genIfConditions(el.ifConditions.slice())
	}
	
	function genIfConditions (conditions) {
	  if (!conditions.length) {
	    return '_e()'
	  }
	
	  var condition = conditions.shift();
	  if (condition.exp) {
	    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions)))
	  } else {
	    return ("" + (genTernaryExp(condition.block)))
	  }
	
	  // v-if with v-once should generate code like (a)?_m(0):_m(1)
	  function genTernaryExp (el) {
	    return el.once ? genOnce(el) : genElement(el)
	  }
	}
	
	function genFor (el) {
	  var exp = el.for;
	  var alias = el.alias;
	  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
	  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
	  el.forProcessed = true; // avoid recursion
	  return "_l((" + exp + ")," +
	    "function(" + alias + iterator1 + iterator2 + "){" +
	      "return " + (genElement(el)) +
	    '})'
	}
	
	function genData (el) {
	  var data = '{';
	
	  // directives first.
	  // directives may mutate the el's other properties before they are generated.
	  var dirs = genDirectives(el);
	  if (dirs) { data += dirs + ','; }
	
	  // key
	  if (el.key) {
	    data += "key:" + (el.key) + ",";
	  }
	  // ref
	  if (el.ref) {
	    data += "ref:" + (el.ref) + ",";
	  }
	  if (el.refInFor) {
	    data += "refInFor:true,";
	  }
	  // pre
	  if (el.pre) {
	    data += "pre:true,";
	  }
	  // record original tag name for components using "is" attribute
	  if (el.component) {
	    data += "tag:\"" + (el.tag) + "\",";
	  }
	  // module data generation functions
	  for (var i = 0; i < dataGenFns.length; i++) {
	    data += dataGenFns[i](el);
	  }
	  // attributes
	  if (el.attrs) {
	    data += "attrs:{" + (genProps(el.attrs)) + "},";
	  }
	  // DOM props
	  if (el.props) {
	    data += "domProps:{" + (genProps(el.props)) + "},";
	  }
	  // event handlers
	  if (el.events) {
	    data += (genHandlers(el.events)) + ",";
	  }
	  if (el.nativeEvents) {
	    data += (genHandlers(el.nativeEvents, true)) + ",";
	  }
	  // slot target
	  if (el.slotTarget) {
	    data += "slot:" + (el.slotTarget) + ",";
	  }
	  // scoped slots
	  if (el.scopedSlots) {
	    data += (genScopedSlots(el.scopedSlots)) + ",";
	  }
	  // inline-template
	  if (el.inlineTemplate) {
	    var inlineTemplate = genInlineTemplate(el);
	    if (inlineTemplate) {
	      data += inlineTemplate + ",";
	    }
	  }
	  data = data.replace(/,$/, '') + '}';
	  // v-bind data wrap
	  if (el.wrapData) {
	    data = el.wrapData(data);
	  }
	  return data
	}
	
	function genDirectives (el) {
	  var dirs = el.directives;
	  if (!dirs) { return }
	  var res = 'directives:[';
	  var hasRuntime = false;
	  var i, l, dir, needRuntime;
	  for (i = 0, l = dirs.length; i < l; i++) {
	    dir = dirs[i];
	    needRuntime = true;
	    var gen = platformDirectives$1[dir.name] || baseDirectives[dir.name];
	    if (gen) {
	      // compile-time directive that manipulates AST.
	      // returns true if it also needs a runtime counterpart.
	      needRuntime = !!gen(el, dir, warn$2);
	    }
	    if (needRuntime) {
	      hasRuntime = true;
	      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
	    }
	  }
	  if (hasRuntime) {
	    return res.slice(0, -1) + ']'
	  }
	}
	
	function genInlineTemplate (el) {
	  var ast = el.children[0];
	  if (false) {
	    warn$2('Inline-template components must have exactly one child element.');
	  }
	  if (ast.type === 1) {
	    var inlineRenderFns = generate(ast, currentOptions);
	    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
	  }
	}
	
	function genScopedSlots (slots) {
	  return ("scopedSlots:{" + (Object.keys(slots).map(function (key) { return genScopedSlot(key, slots[key]); }).join(',')) + "}")
	}
	
	function genScopedSlot (key, el) {
	  return key + ":function(" + (String(el.attrsMap.scope)) + "){" +
	    "return " + (el.tag === 'template'
	      ? genChildren(el) || 'void 0'
	      : genElement(el)) + "}"
	}
	
	function genChildren (el, checkSkip) {
	  var children = el.children;
	  if (children.length) {
	    var el$1 = children[0];
	    // optimize single v-for
	    if (children.length === 1 &&
	        el$1.for &&
	        el$1.tag !== 'template' &&
	        el$1.tag !== 'slot') {
	      return genElement(el$1)
	    }
	    var normalizationType = getNormalizationType(children);
	    return ("[" + (children.map(genNode).join(',')) + "]" + (checkSkip
	        ? normalizationType ? ("," + normalizationType) : ''
	        : ''))
	  }
	}
	
	// determine the normalization needed for the children array.
	// 0: no normalization needed
	// 1: simple normalization needed (possible 1-level deep nested array)
	// 2: full normalization needed
	function getNormalizationType (children) {
	  var res = 0;
	  for (var i = 0; i < children.length; i++) {
	    var el = children[i];
	    if (el.type !== 1) {
	      continue
	    }
	    if (needsNormalization(el) ||
	        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
	      res = 2;
	      break
	    }
	    if (maybeComponent(el) ||
	        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
	      res = 1;
	    }
	  }
	  return res
	}
	
	function needsNormalization (el) {
	  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
	}
	
	function maybeComponent (el) {
	  return !isPlatformReservedTag$1(el.tag)
	}
	
	function genNode (node) {
	  if (node.type === 1) {
	    return genElement(node)
	  } else {
	    return genText(node)
	  }
	}
	
	function genText (text) {
	  return ("_v(" + (text.type === 2
	    ? text.expression // no need for () because already wrapped in _s()
	    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
	}
	
	function genSlot (el) {
	  var slotName = el.slotName || '"default"';
	  var children = genChildren(el);
	  var res = "_t(" + slotName + (children ? ("," + children) : '');
	  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
	  var bind$$1 = el.attrsMap['v-bind'];
	  if ((attrs || bind$$1) && !children) {
	    res += ",null";
	  }
	  if (attrs) {
	    res += "," + attrs;
	  }
	  if (bind$$1) {
	    res += (attrs ? '' : ',null') + "," + bind$$1;
	  }
	  return res + ')'
	}
	
	// componentName is el.component, take it as argument to shun flow's pessimistic refinement
	function genComponent (componentName, el) {
	  var children = el.inlineTemplate ? null : genChildren(el, true);
	  return ("_c(" + componentName + "," + (genData(el)) + (children ? ("," + children) : '') + ")")
	}
	
	function genProps (props) {
	  var res = '';
	  for (var i = 0; i < props.length; i++) {
	    var prop = props[i];
	    res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
	  }
	  return res.slice(0, -1)
	}
	
	// #3895, #4268
	function transformSpecialNewlines (text) {
	  return text
	    .replace(/\u2028/g, '\\u2028')
	    .replace(/\u2029/g, '\\u2029')
	}
	
	/*  */
	
	/**
	 * Compile a template.
	 */
	function compile$1 (
	  template,
	  options
	) {
	  var ast = parse(template.trim(), options);
	  optimize(ast, options);
	  var code = generate(ast, options);
	  return {
	    ast: ast,
	    render: code.render,
	    staticRenderFns: code.staticRenderFns
	  }
	}
	
	/*  */
	
	// operators like typeof, instanceof and in are allowed
	var prohibitedKeywordRE = new RegExp('\\b' + (
	  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
	  'super,throw,while,yield,delete,export,import,return,switch,default,' +
	  'extends,finally,continue,debugger,function,arguments'
	).split(',').join('\\b|\\b') + '\\b');
	// check valid identifier for v-for
	var identRE = /[A-Za-z_$][\w$]*/;
	// strip strings in expressions
	var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
	
	// detect problematic expressions in a template
	function detectErrors (ast) {
	  var errors = [];
	  if (ast) {
	    checkNode(ast, errors);
	  }
	  return errors
	}
	
	function checkNode (node, errors) {
	  if (node.type === 1) {
	    for (var name in node.attrsMap) {
	      if (dirRE.test(name)) {
	        var value = node.attrsMap[name];
	        if (value) {
	          if (name === 'v-for') {
	            checkFor(node, ("v-for=\"" + value + "\""), errors);
	          } else {
	            checkExpression(value, (name + "=\"" + value + "\""), errors);
	          }
	        }
	      }
	    }
	    if (node.children) {
	      for (var i = 0; i < node.children.length; i++) {
	        checkNode(node.children[i], errors);
	      }
	    }
	  } else if (node.type === 2) {
	    checkExpression(node.expression, node.text, errors);
	  }
	}
	
	function checkFor (node, text, errors) {
	  checkExpression(node.for || '', text, errors);
	  checkIdentifier(node.alias, 'v-for alias', text, errors);
	  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
	  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
	}
	
	function checkIdentifier (ident, type, text, errors) {
	  if (typeof ident === 'string' && !identRE.test(ident)) {
	    errors.push(("- invalid " + type + " \"" + ident + "\" in expression: " + text));
	  }
	}
	
	function checkExpression (exp, text, errors) {
	  try {
	    new Function(("return " + exp));
	  } catch (e) {
	    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
	    if (keywordMatch) {
	      errors.push(
	        "- avoid using JavaScript keyword as property name: " +
	        "\"" + (keywordMatch[0]) + "\" in expression " + text
	      );
	    } else {
	      errors.push(("- invalid expression: " + text));
	    }
	  }
	}
	
	/*  */
	
	function transformNode (el, options) {
	  var warn = options.warn || baseWarn;
	  var staticClass = getAndRemoveAttr(el, 'class');
	  if (false) {
	    var expression = parseText(staticClass, options.delimiters);
	    if (expression) {
	      warn(
	        "class=\"" + staticClass + "\": " +
	        'Interpolation inside attributes has been removed. ' +
	        'Use v-bind or the colon shorthand instead. For example, ' +
	        'instead of <div class="{{ val }}">, use <div :class="val">.'
	      );
	    }
	  }
	  if (staticClass) {
	    el.staticClass = JSON.stringify(staticClass);
	  }
	  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
	  if (classBinding) {
	    el.classBinding = classBinding;
	  }
	}
	
	function genData$1 (el) {
	  var data = '';
	  if (el.staticClass) {
	    data += "staticClass:" + (el.staticClass) + ",";
	  }
	  if (el.classBinding) {
	    data += "class:" + (el.classBinding) + ",";
	  }
	  return data
	}
	
	var klass$1 = {
	  staticKeys: ['staticClass'],
	  transformNode: transformNode,
	  genData: genData$1
	};
	
	/*  */
	
	function transformNode$1 (el, options) {
	  var warn = options.warn || baseWarn;
	  var staticStyle = getAndRemoveAttr(el, 'style');
	  if (staticStyle) {
	    /* istanbul ignore if */
	    if (false) {
	      var expression = parseText(staticStyle, options.delimiters);
	      if (expression) {
	        warn(
	          "style=\"" + staticStyle + "\": " +
	          'Interpolation inside attributes has been removed. ' +
	          'Use v-bind or the colon shorthand instead. For example, ' +
	          'instead of <div style="{{ val }}">, use <div :style="val">.'
	        );
	      }
	    }
	    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
	  }
	
	  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
	  if (styleBinding) {
	    el.styleBinding = styleBinding;
	  }
	}
	
	function genData$2 (el) {
	  var data = '';
	  if (el.staticStyle) {
	    data += "staticStyle:" + (el.staticStyle) + ",";
	  }
	  if (el.styleBinding) {
	    data += "style:(" + (el.styleBinding) + "),";
	  }
	  return data
	}
	
	var style$1 = {
	  staticKeys: ['staticStyle'],
	  transformNode: transformNode$1,
	  genData: genData$2
	};
	
	var modules$1 = [
	  klass$1,
	  style$1
	];
	
	/*  */
	
	var warn$3;
	
	function model$1 (
	  el,
	  dir,
	  _warn
	) {
	  warn$3 = _warn;
	  var value = dir.value;
	  var modifiers = dir.modifiers;
	  var tag = el.tag;
	  var type = el.attrsMap.type;
	  if (false) {
	    var dynamicType = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
	    if (tag === 'input' && dynamicType) {
	      warn$3(
	        "<input :type=\"" + dynamicType + "\" v-model=\"" + value + "\">:\n" +
	        "v-model does not support dynamic input types. Use v-if branches instead."
	      );
	    }
	  }
	  if (tag === 'select') {
	    genSelect(el, value, modifiers);
	  } else if (tag === 'input' && type === 'checkbox') {
	    genCheckboxModel(el, value, modifiers);
	  } else if (tag === 'input' && type === 'radio') {
	    genRadioModel(el, value, modifiers);
	  } else {
	    genDefaultModel(el, value, modifiers);
	  }
	  // ensure runtime directive metadata
	  return true
	}
	
	function genCheckboxModel (
	  el,
	  value,
	  modifiers
	) {
	  if (false) {
	    warn$3(
	      "<" + (el.tag) + " v-model=\"" + value + "\" checked>:\n" +
	      "inline checked attributes will be ignored when using v-model. " +
	      'Declare initial values in the component\'s data option instead.'
	    );
	  }
	  var number = modifiers && modifiers.number;
	  var valueBinding = getBindingAttr(el, 'value') || 'null';
	  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
	  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
	  addProp(el, 'checked',
	    "Array.isArray(" + value + ")" +
	      "?_i(" + value + "," + valueBinding + ")>-1" + (
	        trueValueBinding === 'true'
	          ? (":(" + value + ")")
	          : (":_q(" + value + "," + trueValueBinding + ")")
	      )
	  );
	  addHandler(el, 'click',
	    "var $$a=" + value + "," +
	        '$$el=$event.target,' +
	        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
	    'if(Array.isArray($$a)){' +
	      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
	          '$$i=_i($$a,$$v);' +
	      "if($$c){$$i<0&&(" + value + "=$$a.concat($$v))}" +
	      "else{$$i>-1&&(" + value + "=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}" +
	    "}else{" + value + "=$$c}",
	    null, true
	  );
	}
	
	function genRadioModel (
	    el,
	    value,
	    modifiers
	) {
	  if (false) {
	    warn$3(
	      "<" + (el.tag) + " v-model=\"" + value + "\" checked>:\n" +
	      "inline checked attributes will be ignored when using v-model. " +
	      'Declare initial values in the component\'s data option instead.'
	    );
	  }
	  var number = modifiers && modifiers.number;
	  var valueBinding = getBindingAttr(el, 'value') || 'null';
	  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
	  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
	  addHandler(el, 'click', genAssignmentCode(value, valueBinding), null, true);
	}
	
	function genDefaultModel (
	  el,
	  value,
	  modifiers
	) {
	  if (false) {
	    if (el.tag === 'input' && el.attrsMap.value) {
	      warn$3(
	        "<" + (el.tag) + " v-model=\"" + value + "\" value=\"" + (el.attrsMap.value) + "\">:\n" +
	        'inline value attributes will be ignored when using v-model. ' +
	        'Declare initial values in the component\'s data option instead.'
	      );
	    }
	    if (el.tag === 'textarea' && el.children.length) {
	      warn$3(
	        "<textarea v-model=\"" + value + "\">:\n" +
	        'inline content inside <textarea> will be ignored when using v-model. ' +
	        'Declare initial values in the component\'s data option instead.'
	      );
	    }
	  }
	
	  var type = el.attrsMap.type;
	  var ref = modifiers || {};
	  var lazy = ref.lazy;
	  var number = ref.number;
	  var trim = ref.trim;
	  var event = lazy || (isIE && type === 'range') ? 'change' : 'input';
	  var needCompositionGuard = !lazy && type !== 'range';
	  var isNative = el.tag === 'input' || el.tag === 'textarea';
	
	  var valueExpression = isNative
	    ? ("$event.target.value" + (trim ? '.trim()' : ''))
	    : trim ? "(typeof $event === 'string' ? $event.trim() : $event)" : "$event";
	  valueExpression = number || type === 'number'
	    ? ("_n(" + valueExpression + ")")
	    : valueExpression;
	
	  var code = genAssignmentCode(value, valueExpression);
	  if (isNative && needCompositionGuard) {
	    code = "if($event.target.composing)return;" + code;
	  }
	
	  // inputs with type="file" are read only and setting the input's
	  // value will throw an error.
	  if (false) {
	    warn$3(
	      "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
	      "File inputs are read only. Use a v-on:change listener instead."
	    );
	  }
	
	  addProp(el, 'value', isNative ? ("_s(" + value + ")") : ("(" + value + ")"));
	  addHandler(el, event, code, null, true);
	  if (trim || number || type === 'number') {
	    addHandler(el, 'blur', '$forceUpdate()');
	  }
	}
	
	function genSelect (
	    el,
	    value,
	    modifiers
	) {
	  if (false) {
	    el.children.some(checkOptionWarning);
	  }
	
	  var number = modifiers && modifiers.number;
	  var assignment = "Array.prototype.filter" +
	    ".call($event.target.options,function(o){return o.selected})" +
	    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
	    "return " + (number ? '_n(val)' : 'val') + "})" +
	    (el.attrsMap.multiple == null ? '[0]' : '');
	
	  var code = genAssignmentCode(value, assignment);
	  addHandler(el, 'change', code, null, true);
	}
	
	function checkOptionWarning (option) {
	  if (option.type === 1 &&
	    option.tag === 'option' &&
	    option.attrsMap.selected != null) {
	    warn$3(
	      "<select v-model=\"" + (option.parent.attrsMap['v-model']) + "\">:\n" +
	      'inline selected attributes on <option> will be ignored when using v-model. ' +
	      'Declare initial values in the component\'s data option instead.'
	    );
	    return true
	  }
	  return false
	}
	
	function genAssignmentCode (value, assignment) {
	  var modelRs = parseModel(value);
	  if (modelRs.idx === null) {
	    return (value + "=" + assignment)
	  } else {
	    return "var $$exp = " + (modelRs.exp) + ", $$idx = " + (modelRs.idx) + ";" +
	      "if (!Array.isArray($$exp)){" +
	        value + "=" + assignment + "}" +
	      "else{$$exp.splice($$idx, 1, " + assignment + ")}"
	  }
	}
	
	/*  */
	
	function text (el, dir) {
	  if (dir.value) {
	    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
	  }
	}
	
	/*  */
	
	function html (el, dir) {
	  if (dir.value) {
	    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
	  }
	}
	
	var directives$1 = {
	  model: model$1,
	  text: text,
	  html: html
	};
	
	/*  */
	
	var cache = Object.create(null);
	
	var baseOptions = {
	  expectHTML: true,
	  modules: modules$1,
	  staticKeys: genStaticKeys(modules$1),
	  directives: directives$1,
	  isReservedTag: isReservedTag,
	  isUnaryTag: isUnaryTag,
	  mustUseProp: mustUseProp,
	  getTagNamespace: getTagNamespace,
	  isPreTag: isPreTag
	};
	
	function compile$$1 (
	  template,
	  options
	) {
	  options = options
	    ? extend(extend({}, baseOptions), options)
	    : baseOptions;
	  return compile$1(template, options)
	}
	
	function compileToFunctions (
	  template,
	  options,
	  vm
	) {
	  var _warn = (options && options.warn) || warn;
	  // detect possible CSP restriction
	  /* istanbul ignore if */
	  if (false) {
	    try {
	      new Function('return 1');
	    } catch (e) {
	      if (e.toString().match(/unsafe-eval|CSP/)) {
	        _warn(
	          'It seems you are using the standalone build of Vue.js in an ' +
	          'environment with Content Security Policy that prohibits unsafe-eval. ' +
	          'The template compiler cannot work in this environment. Consider ' +
	          'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
	          'templates into render functions.'
	        );
	      }
	    }
	  }
	  var key = options && options.delimiters
	    ? String(options.delimiters) + template
	    : template;
	  if (cache[key]) {
	    return cache[key]
	  }
	  var res = {};
	  var compiled = compile$$1(template, options);
	  res.render = makeFunction(compiled.render);
	  var l = compiled.staticRenderFns.length;
	  res.staticRenderFns = new Array(l);
	  for (var i = 0; i < l; i++) {
	    res.staticRenderFns[i] = makeFunction(compiled.staticRenderFns[i]);
	  }
	  if (false) {
	    if (res.render === noop || res.staticRenderFns.some(function (fn) { return fn === noop; })) {
	      _warn(
	        "failed to compile template:\n\n" + template + "\n\n" +
	        detectErrors(compiled.ast).join('\n') +
	        '\n\n',
	        vm
	      );
	    }
	  }
	  return (cache[key] = res)
	}
	
	function makeFunction (code) {
	  try {
	    return new Function(code)
	  } catch (e) {
	    return noop
	  }
	}
	
	/*  */
	
	var idToTemplate = cached(function (id) {
	  var el = query(id);
	  return el && el.innerHTML
	});
	
	var mount = Vue$3.prototype.$mount;
	Vue$3.prototype.$mount = function (
	  el,
	  hydrating
	) {
	  el = el && query(el);
	
	  /* istanbul ignore if */
	  if (el === document.body || el === document.documentElement) {
	    ("production") !== 'production' && warn(
	      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
	    );
	    return this
	  }
	
	  var options = this.$options;
	  // resolve template/el and convert to render function
	  if (!options.render) {
	    var template = options.template;
	    if (template) {
	      if (typeof template === 'string') {
	        if (template.charAt(0) === '#') {
	          template = idToTemplate(template);
	          /* istanbul ignore if */
	          if (false) {
	            warn(
	              ("Template element not found or is empty: " + (options.template)),
	              this
	            );
	          }
	        }
	      } else if (template.nodeType) {
	        template = template.innerHTML;
	      } else {
	        if (false) {
	          warn('invalid template option:' + template, this);
	        }
	        return this
	      }
	    } else if (el) {
	      template = getOuterHTML(el);
	    }
	    if (template) {
	      var ref = compileToFunctions(template, {
	        warn: warn,
	        shouldDecodeNewlines: shouldDecodeNewlines,
	        delimiters: options.delimiters
	      }, this);
	      var render = ref.render;
	      var staticRenderFns = ref.staticRenderFns;
	      options.render = render;
	      options.staticRenderFns = staticRenderFns;
	    }
	  }
	  return mount.call(this, el, hydrating)
	};
	
	/**
	 * Get outerHTML of elements, taking care
	 * of SVG elements in IE as well.
	 */
	function getOuterHTML (el) {
	  if (el.outerHTML) {
	    return el.outerHTML
	  } else {
	    var container = document.createElement('div');
	    container.appendChild(el.cloneNode(true));
	    return container.innerHTML
	  }
	}
	
	Vue$3.compile = compileToFunctions;
	
	module.exports = Vue$3;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 114 */,
/* 115 */,
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(255), __esModule: true };

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(256), __esModule: true };

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(257), __esModule: true };

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(118);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(117);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 120 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return b64.length * 3 / 4 - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, j, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr(len * 3 / 4 - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0, j = 0; i < l; i += 4, j += 3) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(39);
	var Transform = __webpack_require__(40);
	var inherits = __webpack_require__(4);
	var modes = __webpack_require__(41);
	var StreamCipher = __webpack_require__(71);
	var ebtk = __webpack_require__(65);
	
	inherits(Decipher, Transform);
	function Decipher(mode, key, iv) {
	  if (!(this instanceof Decipher)) {
	    return new Decipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._last = void 0;
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Decipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.decrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Decipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  if (!chunk) {
	    return next;
	  }
	
	  this.push(unpad(this._mode.decrypt(this, chunk)));
	
	  next();
	};
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 16) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  if (this.cache.length) {
	    return this.cache;
	  }
	};
	function unpad(last) {
	  var padded = last[15];
	  if (padded === 16) {
	    return;
	  }
	  return last.slice(0, 16 - padded);
	}
	
	var modelist = {
	  ECB: __webpack_require__(69),
	  CBC: __webpack_require__(66),
	  CFB: __webpack_require__(67),
	  OFB: __webpack_require__(70),
	  CTR: __webpack_require__(68)
	};
	
	module.exports = function (crypto) {
	  function createDecipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv, true);
	    }
	    return new Decipher(modelist[config.mode], password, iv);
	  }
	
	  function createDecipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createDecipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createDecipher: createDecipher,
	    createDecipheriv: createDecipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(39);
	var Transform = __webpack_require__(40);
	var inherits = __webpack_require__(4);
	var modes = __webpack_require__(41);
	var ebtk = __webpack_require__(65);
	var StreamCipher = __webpack_require__(71);
	inherits(Cipher, Transform);
	function Cipher(mode, key, iv) {
	  if (!(this instanceof Cipher)) {
	    return new Cipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Cipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.encrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Cipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  this.push(this._mode.encrypt(this, chunk));
	  this._cipher.scrub();
	  next();
	};
	
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length;
	  var padBuff = new Buffer(len);
	
	  var i = -1;
	  while (++i < len) {
	    padBuff.writeUInt8(len, i);
	  }
	  var out = Buffer.concat([this.cache, padBuff]);
	  return out;
	};
	var modelist = {
	  ECB: __webpack_require__(69),
	  CBC: __webpack_require__(66),
	  CFB: __webpack_require__(67),
	  OFB: __webpack_require__(70),
	  CTR: __webpack_require__(68)
	};
	module.exports = function (crypto) {
	  function createCipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv);
	    }
	    return new Cipher(modelist[config.mode], password, iv);
	  }
	  function createCipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createCipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createCipher: createCipher,
	    createCipheriv: createCipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function (crypto, exports) {
	  exports = exports || {};
	  var ciphers = __webpack_require__(122)(crypto);
	  exports.createCipher = ciphers.createCipher;
	  exports.createCipheriv = ciphers.createCipheriv;
	  var deciphers = __webpack_require__(121)(crypto);
	  exports.createDecipher = deciphers.createDecipher;
	  exports.createDecipheriv = deciphers.createDecipheriv;
	  var modes = __webpack_require__(41);
	  function listCiphers () {
	    return Object.keys(modes);
	  }
	  exports.listCiphers = listCiphers;
	};
	


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Buffer) {//  Chance.js 1.0.4
	//  http://chancejs.com
	//  (c) 2013 Victor Quinn
	//  Chance may be freely distributed or modified under the MIT license.
	
	(function () {
	
	    // Constants
	    var MAX_INT = 9007199254740992;
	    var MIN_INT = -MAX_INT;
	    var NUMBERS = '0123456789';
	    var CHARS_LOWER = 'abcdefghijklmnopqrstuvwxyz';
	    var CHARS_UPPER = CHARS_LOWER.toUpperCase();
	    var HEX_POOL  = NUMBERS + "abcdef";
	
	    // Cached array helpers
	    var slice = Array.prototype.slice;
	
	    // Constructor
	    function Chance (seed) {
	        if (!(this instanceof Chance)) {
	            return seed == null ? new Chance() : new Chance(seed);
	        }
	
	        // if user has provided a function, use that as the generator
	        if (typeof seed === 'function') {
	            this.random = seed;
	            return this;
	        }
	
	        if (arguments.length) {
	            // set a starting value of zero so we can add to it
	            this.seed = 0;
	        }
	
	        // otherwise, leave this.seed blank so that MT will receive a blank
	
	        for (var i = 0; i < arguments.length; i++) {
	            var seedling = 0;
	            if (Object.prototype.toString.call(arguments[i]) === '[object String]') {
	                for (var j = 0; j < arguments[i].length; j++) {
	                    // create a numeric hash for each argument, add to seedling
	                    var hash = 0;
	                    for (var k = 0; k < arguments[i].length; k++) {
	                        hash = arguments[i].charCodeAt(k) + (hash << 6) + (hash << 16) - hash;
	                    }
	                    seedling += hash;
	                }
	            } else {
	                seedling = arguments[i];
	            }
	            this.seed += (arguments.length - i) * seedling;
	        }
	
	        // If no generator function was provided, use our MT
	        this.mt = this.mersenne_twister(this.seed);
	        this.bimd5 = this.blueimp_md5();
	        this.random = function () {
	            return this.mt.random(this.seed);
	        };
	
	        return this;
	    }
	
	    Chance.prototype.VERSION = "1.0.4";
	
	    // Random helper functions
	    function initOptions(options, defaults) {
	        options || (options = {});
	
	        if (defaults) {
	            for (var i in defaults) {
	                if (typeof options[i] === 'undefined') {
	                    options[i] = defaults[i];
	                }
	            }
	        }
	
	        return options;
	    }
	
	    function testRange(test, errorMessage) {
	        if (test) {
	            throw new RangeError(errorMessage);
	        }
	    }
	
	    /**
	     * Encode the input string with Base64.
	     */
	    var base64 = function() {
	        throw new Error('No Base64 encoder available.');
	    };
	
	    // Select proper Base64 encoder.
	    (function determineBase64Encoder() {
	        if (typeof btoa === 'function') {
	            base64 = btoa;
	        } else if (typeof Buffer === 'function') {
	            base64 = function(input) {
	                return new Buffer(input).toString('base64');
	            };
	        }
	    })();
	
	    // -- Basics --
	
	    /**
	     *  Return a random bool, either true or false
	     *
	     *  @param {Object} [options={ likelihood: 50 }] alter the likelihood of
	     *    receiving a true or false value back.
	     *  @throws {RangeError} if the likelihood is out of bounds
	     *  @returns {Bool} either true or false
	     */
	    Chance.prototype.bool = function (options) {
	        // likelihood of success (true)
	        options = initOptions(options, {likelihood : 50});
	
	        // Note, we could get some minor perf optimizations by checking range
	        // prior to initializing defaults, but that makes code a bit messier
	        // and the check more complicated as we have to check existence of
	        // the object then existence of the key before checking constraints.
	        // Since the options initialization should be minor computationally,
	        // decision made for code cleanliness intentionally. This is mentioned
	        // here as it's the first occurrence, will not be mentioned again.
	        testRange(
	            options.likelihood < 0 || options.likelihood > 100,
	            "Chance: Likelihood accepts values from 0 to 100."
	        );
	
	        return this.random() * 100 < options.likelihood;
	    };
	
	    /**
	     *  Return a random character.
	     *
	     *  @param {Object} [options={}] can specify a character pool, only alpha,
	     *    only symbols, and casing (lower or upper)
	     *  @returns {String} a single random character
	     *  @throws {RangeError} Can only specify alpha or symbols, not both
	     */
	    Chance.prototype.character = function (options) {
	        options = initOptions(options);
	        testRange(
	            options.alpha && options.symbols,
	            "Chance: Cannot specify both alpha and symbols."
	        );
	
	        var symbols = "!@#$%^&*()[]",
	            letters, pool;
	
	        if (options.casing === 'lower') {
	            letters = CHARS_LOWER;
	        } else if (options.casing === 'upper') {
	            letters = CHARS_UPPER;
	        } else {
	            letters = CHARS_LOWER + CHARS_UPPER;
	        }
	
	        if (options.pool) {
	            pool = options.pool;
	        } else if (options.alpha) {
	            pool = letters;
	        } else if (options.symbols) {
	            pool = symbols;
	        } else {
	            pool = letters + NUMBERS + symbols;
	        }
	
	        return pool.charAt(this.natural({max: (pool.length - 1)}));
	    };
	
	    // Note, wanted to use "float" or "double" but those are both JS reserved words.
	
	    // Note, fixed means N OR LESS digits after the decimal. This because
	    // It could be 14.9000 but in JavaScript, when this is cast as a number,
	    // the trailing zeroes are dropped. Left to the consumer if trailing zeroes are
	    // needed
	    /**
	     *  Return a random floating point number
	     *
	     *  @param {Object} [options={}] can specify a fixed precision, min, max
	     *  @returns {Number} a single floating point number
	     *  @throws {RangeError} Can only specify fixed or precision, not both. Also
	     *    min cannot be greater than max
	     */
	    Chance.prototype.floating = function (options) {
	        options = initOptions(options, {fixed : 4});
	        testRange(
	            options.fixed && options.precision,
	            "Chance: Cannot specify both fixed and precision."
	        );
	
	        var num;
	        var fixed = Math.pow(10, options.fixed);
	
	        var max = MAX_INT / fixed;
	        var min = -max;
	
	        testRange(
	            options.min && options.fixed && options.min < min,
	            "Chance: Min specified is out of range with fixed. Min should be, at least, " + min
	        );
	        testRange(
	            options.max && options.fixed && options.max > max,
	            "Chance: Max specified is out of range with fixed. Max should be, at most, " + max
	        );
	
	        options = initOptions(options, { min : min, max : max });
	
	        // Todo - Make this work!
	        // options.precision = (typeof options.precision !== "undefined") ? options.precision : false;
	
	        num = this.integer({min: options.min * fixed, max: options.max * fixed});
	        var num_fixed = (num / fixed).toFixed(options.fixed);
	
	        return parseFloat(num_fixed);
	    };
	
	    /**
	     *  Return a random integer
	     *
	     *  NOTE the max and min are INCLUDED in the range. So:
	     *  chance.integer({min: 1, max: 3});
	     *  would return either 1, 2, or 3.
	     *
	     *  @param {Object} [options={}] can specify a min and/or max
	     *  @returns {Number} a single random integer number
	     *  @throws {RangeError} min cannot be greater than max
	     */
	    Chance.prototype.integer = function (options) {
	        // 9007199254740992 (2^53) is the max integer number in JavaScript
	        // See: http://vq.io/132sa2j
	        options = initOptions(options, {min: MIN_INT, max: MAX_INT});
	        testRange(options.min > options.max, "Chance: Min cannot be greater than Max.");
	
	        return Math.floor(this.random() * (options.max - options.min + 1) + options.min);
	    };
	
	    /**
	     *  Return a random natural
	     *
	     *  NOTE the max and min are INCLUDED in the range. So:
	     *  chance.natural({min: 1, max: 3});
	     *  would return either 1, 2, or 3.
	     *
	     *  @param {Object} [options={}] can specify a min and/or max
	     *  @returns {Number} a single random integer number
	     *  @throws {RangeError} min cannot be greater than max
	     */
	    Chance.prototype.natural = function (options) {
	        options = initOptions(options, {min: 0, max: MAX_INT});
	        testRange(options.min < 0, "Chance: Min cannot be less than zero.");
	        return this.integer(options);
	    };
	
	    /**
	     *  Return a random string
	     *
	     *  @param {Object} [options={}] can specify a length
	     *  @returns {String} a string of random length
	     *  @throws {RangeError} length cannot be less than zero
	     */
	    Chance.prototype.string = function (options) {
	        options = initOptions(options, { length: this.natural({min: 5, max: 20}) });
	        testRange(options.length < 0, "Chance: Length cannot be less than zero.");
	        var length = options.length,
	            text = this.n(this.character, length, options);
	
	        return text.join("");
	    };
	
	    // -- End Basics --
	
	    // -- Helpers --
	
	    Chance.prototype.capitalize = function (word) {
	        return word.charAt(0).toUpperCase() + word.substr(1);
	    };
	
	    Chance.prototype.mixin = function (obj) {
	        for (var func_name in obj) {
	            Chance.prototype[func_name] = obj[func_name];
	        }
	        return this;
	    };
	
	    /**
	     *  Given a function that generates something random and a number of items to generate,
	     *    return an array of items where none repeat.
	     *
	     *  @param {Function} fn the function that generates something random
	     *  @param {Number} num number of terms to generate
	     *  @param {Object} options any options to pass on to the generator function
	     *  @returns {Array} an array of length `num` with every item generated by `fn` and unique
	     *
	     *  There can be more parameters after these. All additional parameters are provided to the given function
	     */
	    Chance.prototype.unique = function(fn, num, options) {
	        testRange(
	            typeof fn !== "function",
	            "Chance: The first argument must be a function."
	        );
	
	        var comparator = function(arr, val) { return arr.indexOf(val) !== -1; };
	
	        if (options) {
	            comparator = options.comparator || comparator;
	        }
	
	        var arr = [], count = 0, result, MAX_DUPLICATES = num * 50, params = slice.call(arguments, 2);
	
	        while (arr.length < num) {
	            var clonedParams = JSON.parse(JSON.stringify(params));
	            result = fn.apply(this, clonedParams);
	            if (!comparator(arr, result)) {
	                arr.push(result);
	                // reset count when unique found
	                count = 0;
	            }
	
	            if (++count > MAX_DUPLICATES) {
	                throw new RangeError("Chance: num is likely too large for sample set");
	            }
	        }
	        return arr;
	    };
	
	    /**
	     *  Gives an array of n random terms
	     *
	     *  @param {Function} fn the function that generates something random
	     *  @param {Number} n number of terms to generate
	     *  @returns {Array} an array of length `n` with items generated by `fn`
	     *
	     *  There can be more parameters after these. All additional parameters are provided to the given function
	     */
	    Chance.prototype.n = function(fn, n) {
	        testRange(
	            typeof fn !== "function",
	            "Chance: The first argument must be a function."
	        );
	
	        if (typeof n === 'undefined') {
	            n = 1;
	        }
	        var i = n, arr = [], params = slice.call(arguments, 2);
	
	        // Providing a negative count should result in a noop.
	        i = Math.max( 0, i );
	
	        for (null; i--; null) {
	            arr.push(fn.apply(this, params));
	        }
	
	        return arr;
	    };
	
	    // H/T to SO for this one: http://vq.io/OtUrZ5
	    Chance.prototype.pad = function (number, width, pad) {
	        // Default pad to 0 if none provided
	        pad = pad || '0';
	        // Convert number to a string
	        number = number + '';
	        return number.length >= width ? number : new Array(width - number.length + 1).join(pad) + number;
	    };
	
	    // DEPRECATED on 2015-10-01
	    Chance.prototype.pick = function (arr, count) {
	        if (arr.length === 0) {
	            throw new RangeError("Chance: Cannot pick() from an empty array");
	        }
	        if (!count || count === 1) {
	            return arr[this.natural({max: arr.length - 1})];
	        } else {
	            return this.shuffle(arr).slice(0, count);
	        }
	    };
	
	    // Given an array, returns a single random element
	    Chance.prototype.pickone = function (arr) {
	        if (arr.length === 0) {
	          throw new RangeError("Chance: Cannot pickone() from an empty array");
	        }
	        return arr[this.natural({max: arr.length - 1})];
	    };
	
	    // Given an array, returns a random set with 'count' elements
	    Chance.prototype.pickset = function (arr, count) {
	        if (count === 0) {
	            return [];
	        }
	        if (arr.length === 0) {
	            throw new RangeError("Chance: Cannot pickset() from an empty array");
	        }
	        if (count < 0) {
	            throw new RangeError("Chance: count must be positive number");
	        }
	        if (!count || count === 1) {
	            return [ this.pickone(arr) ];
	        } else {
	            return this.shuffle(arr).slice(0, count);
	        }
	    };
	
	    Chance.prototype.shuffle = function (arr) {
	        var old_array = arr.slice(0),
	            new_array = [],
	            j = 0,
	            length = Number(old_array.length);
	
	        for (var i = 0; i < length; i++) {
	            // Pick a random index from the array
	            j = this.natural({max: old_array.length - 1});
	            // Add it to the new array
	            new_array[i] = old_array[j];
	            // Remove that element from the original array
	            old_array.splice(j, 1);
	        }
	
	        return new_array;
	    };
	
	    // Returns a single item from an array with relative weighting of odds
	    Chance.prototype.weighted = function (arr, weights, trim) {
	        if (arr.length !== weights.length) {
	            throw new RangeError("Chance: length of array and weights must match");
	        }
	
	        // scan weights array and sum valid entries
	        var sum = 0;
	        var val;
	        for (var weightIndex = 0; weightIndex < weights.length; ++weightIndex) {
	            val = weights[weightIndex];
	            if (val > 0) {
	                sum += val;
	            }
	        }
	
	        if (sum === 0) {
	            throw new RangeError("Chance: no valid entries in array weights");
	        }
	
	        // select a value within range
	        var selected = this.random() * sum;
	
	        // find array entry corresponding to selected value
	        var total = 0;
	        var lastGoodIdx = -1;
	        var chosenIdx;
	        for (weightIndex = 0; weightIndex < weights.length; ++weightIndex) {
	            val = weights[weightIndex];
	            total += val;
	            if (val > 0) {
	                if (selected <= total) {
	                    chosenIdx = weightIndex;
	                    break;
	                }
	                lastGoodIdx = weightIndex;
	            }
	
	            // handle any possible rounding error comparison to ensure something is picked
	            if (weightIndex === (weights.length - 1)) {
	                chosenIdx = lastGoodIdx;
	            }
	        }
	
	        var chosen = arr[chosenIdx];
	        trim = (typeof trim === 'undefined') ? false : trim;
	        if (trim) {
	            arr.splice(chosenIdx, 1);
	            weights.splice(chosenIdx, 1);
	        }
	
	        return chosen;
	    };
	
	    // -- End Helpers --
	
	    // -- Text --
	
	    Chance.prototype.paragraph = function (options) {
	        options = initOptions(options);
	
	        var sentences = options.sentences || this.natural({min: 3, max: 7}),
	            sentence_array = this.n(this.sentence, sentences);
	
	        return sentence_array.join(' ');
	    };
	
	    // Could get smarter about this than generating random words and
	    // chaining them together. Such as: http://vq.io/1a5ceOh
	    Chance.prototype.sentence = function (options) {
	        options = initOptions(options);
	
	        var words = options.words || this.natural({min: 12, max: 18}),
	            punctuation = options.punctuation,
	            text, word_array = this.n(this.word, words);
	
	        text = word_array.join(' ');
	
	        // Capitalize first letter of sentence
	        text = this.capitalize(text);
	
	        // Make sure punctuation has a usable value
	        if (punctuation !== false && !/^[\.\?;!:]$/.test(punctuation)) {
	            punctuation = '.';
	        }
	
	        // Add punctuation mark
	        if (punctuation) {
	            text += punctuation;
	        }
	
	        return text;
	    };
	
	    Chance.prototype.syllable = function (options) {
	        options = initOptions(options);
	
	        var length = options.length || this.natural({min: 2, max: 3}),
	            consonants = 'bcdfghjklmnprstvwz', // consonants except hard to speak ones
	            vowels = 'aeiou', // vowels
	            all = consonants + vowels, // all
	            text = '',
	            chr;
	
	        // I'm sure there's a more elegant way to do this, but this works
	        // decently well.
	        for (var i = 0; i < length; i++) {
	            if (i === 0) {
	                // First character can be anything
	                chr = this.character({pool: all});
	            } else if (consonants.indexOf(chr) === -1) {
	                // Last character was a vowel, now we want a consonant
	                chr = this.character({pool: consonants});
	            } else {
	                // Last character was a consonant, now we want a vowel
	                chr = this.character({pool: vowels});
	            }
	
	            text += chr;
	        }
	
	        if (options.capitalize) {
	            text = this.capitalize(text);
	        }
	
	        return text;
	    };
	
	    Chance.prototype.word = function (options) {
	        options = initOptions(options);
	
	        testRange(
	            options.syllables && options.length,
	            "Chance: Cannot specify both syllables AND length."
	        );
	
	        var syllables = options.syllables || this.natural({min: 1, max: 3}),
	            text = '';
	
	        if (options.length) {
	            // Either bound word by length
	            do {
	                text += this.syllable();
	            } while (text.length < options.length);
	            text = text.substring(0, options.length);
	        } else {
	            // Or by number of syllables
	            for (var i = 0; i < syllables; i++) {
	                text += this.syllable();
	            }
	        }
	
	        if (options.capitalize) {
	            text = this.capitalize(text);
	        }
	
	        return text;
	    };
	
	    // -- End Text --
	
	    // -- Person --
	
	    Chance.prototype.age = function (options) {
	        options = initOptions(options);
	        var ageRange;
	
	        switch (options.type) {
	            case 'child':
	                ageRange = {min: 0, max: 12};
	                break;
	            case 'teen':
	                ageRange = {min: 13, max: 19};
	                break;
	            case 'adult':
	                ageRange = {min: 18, max: 65};
	                break;
	            case 'senior':
	                ageRange = {min: 65, max: 100};
	                break;
	            case 'all':
	                ageRange = {min: 0, max: 100};
	                break;
	            default:
	                ageRange = {min: 18, max: 65};
	                break;
	        }
	
	        return this.natural(ageRange);
	    };
	
	    Chance.prototype.birthday = function (options) {
	        var age = this.age(options);
	        var currentYear = new Date().getFullYear();
	
	        if (options && options.type) {
	            var min = new Date();
	            var max = new Date();
	            min.setFullYear(currentYear - age - 1);
	            max.setFullYear(currentYear - age);
	
	            options = initOptions(options, {
	                min: min,
	                max: max
	            });
	        } else {
	            options = initOptions(options, {
	                year: currentYear - age
	            });
	        }
	
	        return this.date(options);
	    };
	
	    // CPF; ID to identify taxpayers in Brazil
	    Chance.prototype.cpf = function (options) {
	        options = initOptions(options, {
	            formatted: true
	        });
	
	        var n = this.n(this.natural, 9, { max: 9 });
	        var d1 = n[8]*2+n[7]*3+n[6]*4+n[5]*5+n[4]*6+n[3]*7+n[2]*8+n[1]*9+n[0]*10;
	        d1 = 11 - (d1 % 11);
	        if (d1>=10) {
	            d1 = 0;
	        }
	        var d2 = d1*2+n[8]*3+n[7]*4+n[6]*5+n[5]*6+n[4]*7+n[3]*8+n[2]*9+n[1]*10+n[0]*11;
	        d2 = 11 - (d2 % 11);
	        if (d2>=10) {
	            d2 = 0;
	        }
	        var cpf = ''+n[0]+n[1]+n[2]+'.'+n[3]+n[4]+n[5]+'.'+n[6]+n[7]+n[8]+'-'+d1+d2;
	        return options.formatted ? cpf : cpf.replace(/\D/g,'');
	    };
	
	    // CNPJ: ID to identify companies in Brazil
	    Chance.prototype.cnpj = function (options) {
	        options = initOptions(options, {
	            formatted: true
	        });
	
	        var n = this.n(this.natural, 12, { max: 12 });
	        var d1 = n[11]*2+n[10]*3+n[9]*4+n[8]*5+n[7]*6+n[6]*7+n[5]*8+n[4]*9+n[3]*2+n[2]*3+n[1]*4+n[0]*5;
	        d1 = 11 - (d1 % 11);
	        if (d1<2) {
	            d1 = 0;
	        }
	        var d2 = d1*2+n[11]*3+n[10]*4+n[9]*5+n[8]*6+n[7]*7+n[6]*8+n[5]*9+n[4]*2+n[3]*3+n[2]*4+n[1]*5+n[0]*6;
	        d2 = 11 - (d2 % 11);
	        if (d2<2) {
	            d2 = 0;
	        }
	        var cnpj = ''+n[0]+n[1]+'.'+n[2]+n[3]+n[4]+'.'+n[5]+n[6]+n[7]+'/'+n[8]+n[9]+n[10]+n[11]+'-'+d1+d2;
	        return options.formatted ? cnpj : cnpj.replace(/\D/g,'');
	    };
	
	    Chance.prototype.first = function (options) {
	        options = initOptions(options, {gender: this.gender(), nationality: 'en'});
	        return this.pick(this.get("firstNames")[options.gender.toLowerCase()][options.nationality.toLowerCase()]);
	    };
	
	    Chance.prototype.gender = function (options) {
	        options = initOptions(options, {extraGenders: []});
	        return this.pick(['Male', 'Female'].concat(options.extraGenders));
	    };
	
	    Chance.prototype.last = function (options) {
	        options = initOptions(options, {nationality: 'en'});
	        return this.pick(this.get("lastNames")[options.nationality.toLowerCase()]);
	    };
	
	    Chance.prototype.israelId=function(){
	        var x=this.string({pool: '0123456789',length:8});
	        var y=0;
	        for (var i=0;i<x.length;i++){
	            var thisDigit=  x[i] *  (i/2===parseInt(i/2) ? 1 : 2);
	            thisDigit=this.pad(thisDigit,2).toString();
	            thisDigit=parseInt(thisDigit[0]) + parseInt(thisDigit[1]);
	            y=y+thisDigit;
	        }
	        x=x+(10-parseInt(y.toString().slice(-1))).toString().slice(-1);
	        return x;
	    };
	
	    Chance.prototype.mrz = function (options) {
	        var checkDigit = function (input) {
	            var alpha = "<ABCDEFGHIJKLMNOPQRSTUVWXYXZ".split(''),
	                multipliers = [ 7, 3, 1 ],
	                runningTotal = 0;
	
	            if (typeof input !== 'string') {
	                input = input.toString();
	            }
	
	            input.split('').forEach(function(character, idx) {
	                var pos = alpha.indexOf(character);
	
	                if(pos !== -1) {
	                    character = pos === 0 ? 0 : pos + 9;
	                } else {
	                    character = parseInt(character, 10);
	                }
	                character *= multipliers[idx % multipliers.length];
	                runningTotal += character;
	            });
	            return runningTotal % 10;
	        };
	        var generate = function (opts) {
	            var pad = function (length) {
	                return new Array(length + 1).join('<');
	            };
	            var number = [ 'P<',
	                           opts.issuer,
	                           opts.last.toUpperCase(),
	                           '<<',
	                           opts.first.toUpperCase(),
	                           pad(39 - (opts.last.length + opts.first.length + 2)),
	                           opts.passportNumber,
	                           checkDigit(opts.passportNumber),
	                           opts.nationality,
	                           opts.dob,
	                           checkDigit(opts.dob),
	                           opts.gender,
	                           opts.expiry,
	                           checkDigit(opts.expiry),
	                           pad(14),
	                           checkDigit(pad(14)) ].join('');
	
	            return number +
	                (checkDigit(number.substr(44, 10) +
	                            number.substr(57, 7) +
	                            number.substr(65, 7)));
	        };
	
	        var that = this;
	
	        options = initOptions(options, {
	            first: this.first(),
	            last: this.last(),
	            passportNumber: this.integer({min: 100000000, max: 999999999}),
	            dob: (function () {
	                var date = that.birthday({type: 'adult'});
	                return [date.getFullYear().toString().substr(2),
	                        that.pad(date.getMonth() + 1, 2),
	                        that.pad(date.getDate(), 2)].join('');
	            }()),
	            expiry: (function () {
	                var date = new Date();
	                return [(date.getFullYear() + 5).toString().substr(2),
	                        that.pad(date.getMonth() + 1, 2),
	                        that.pad(date.getDate(), 2)].join('');
	            }()),
	            gender: this.gender() === 'Female' ? 'F': 'M',
	            issuer: 'GBR',
	            nationality: 'GBR'
	        });
	        return generate (options);
	    };
	
	    Chance.prototype.name = function (options) {
	        options = initOptions(options);
	
	        var first = this.first(options),
	            last = this.last(options),
	            name;
	
	        if (options.middle) {
	            name = first + ' ' + this.first(options) + ' ' + last;
	        } else if (options.middle_initial) {
	            name = first + ' ' + this.character({alpha: true, casing: 'upper'}) + '. ' + last;
	        } else {
	            name = first + ' ' + last;
	        }
	
	        if (options.prefix) {
	            name = this.prefix(options) + ' ' + name;
	        }
	
	        if (options.suffix) {
	            name = name + ' ' + this.suffix(options);
	        }
	
	        return name;
	    };
	
	    // Return the list of available name prefixes based on supplied gender.
	    // @todo introduce internationalization
	    Chance.prototype.name_prefixes = function (gender) {
	        gender = gender || "all";
	        gender = gender.toLowerCase();
	
	        var prefixes = [
	            { name: 'Doctor', abbreviation: 'Dr.' }
	        ];
	
	        if (gender === "male" || gender === "all") {
	            prefixes.push({ name: 'Mister', abbreviation: 'Mr.' });
	        }
	
	        if (gender === "female" || gender === "all") {
	            prefixes.push({ name: 'Miss', abbreviation: 'Miss' });
	            prefixes.push({ name: 'Misses', abbreviation: 'Mrs.' });
	        }
	
	        return prefixes;
	    };
	
	    // Alias for name_prefix
	    Chance.prototype.prefix = function (options) {
	        return this.name_prefix(options);
	    };
	
	    Chance.prototype.name_prefix = function (options) {
	        options = initOptions(options, { gender: "all" });
	        return options.full ?
	            this.pick(this.name_prefixes(options.gender)).name :
	            this.pick(this.name_prefixes(options.gender)).abbreviation;
	    };
	    //Hungarian ID number
	    Chance.prototype.HIDN= function(){
	     //Hungarian ID nuber structure: XXXXXXYY (X=number,Y=Capital Latin letter)
	      var idn_pool="0123456789";
	      var idn_chrs="ABCDEFGHIJKLMNOPQRSTUVWXYXZ";
	      var idn="";
	        idn+=this.string({pool:idn_pool,length:6});
	        idn+=this.string({pool:idn_chrs,length:2});
	        return idn;
	    };
	
	
	    Chance.prototype.ssn = function (options) {
	        options = initOptions(options, {ssnFour: false, dashes: true});
	        var ssn_pool = "1234567890",
	            ssn,
	            dash = options.dashes ? '-' : '';
	
	        if(!options.ssnFour) {
	            ssn = this.string({pool: ssn_pool, length: 3}) + dash +
	            this.string({pool: ssn_pool, length: 2}) + dash +
	            this.string({pool: ssn_pool, length: 4});
	        } else {
	            ssn = this.string({pool: ssn_pool, length: 4});
	        }
	        return ssn;
	    };
	
	    // Return the list of available name suffixes
	    // @todo introduce internationalization
	    Chance.prototype.name_suffixes = function () {
	        var suffixes = [
	            { name: 'Doctor of Osteopathic Medicine', abbreviation: 'D.O.' },
	            { name: 'Doctor of Philosophy', abbreviation: 'Ph.D.' },
	            { name: 'Esquire', abbreviation: 'Esq.' },
	            { name: 'Junior', abbreviation: 'Jr.' },
	            { name: 'Juris Doctor', abbreviation: 'J.D.' },
	            { name: 'Master of Arts', abbreviation: 'M.A.' },
	            { name: 'Master of Business Administration', abbreviation: 'M.B.A.' },
	            { name: 'Master of Science', abbreviation: 'M.S.' },
	            { name: 'Medical Doctor', abbreviation: 'M.D.' },
	            { name: 'Senior', abbreviation: 'Sr.' },
	            { name: 'The Third', abbreviation: 'III' },
	            { name: 'The Fourth', abbreviation: 'IV' },
	            { name: 'Bachelor of Engineering', abbreviation: 'B.E' },
	            { name: 'Bachelor of Technology', abbreviation: 'B.TECH' }
	        ];
	        return suffixes;
	    };
	
	    // Alias for name_suffix
	    Chance.prototype.suffix = function (options) {
	        return this.name_suffix(options);
	    };
	
	    Chance.prototype.name_suffix = function (options) {
	        options = initOptions(options);
	        return options.full ?
	            this.pick(this.name_suffixes()).name :
	            this.pick(this.name_suffixes()).abbreviation;
	    };
	
	    Chance.prototype.nationalities = function () {
	        return this.get("nationalities");
	    };
	
	    // Generate random nationality based on json list
	    Chance.prototype.nationality = function () {
	        var nationality = this.pick(this.nationalities());
	        return nationality.name;
	    };
	
	    // -- End Person --
	
	    // -- Mobile --
	    // Android GCM Registration ID
	    Chance.prototype.android_id = function () {
	        return "APA91" + this.string({ pool: "0123456789abcefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-_", length: 178 });
	    };
	
	    // Apple Push Token
	    Chance.prototype.apple_token = function () {
	        return this.string({ pool: "abcdef1234567890", length: 64 });
	    };
	
	    // Windows Phone 8 ANID2
	    Chance.prototype.wp8_anid2 = function () {
	        return base64( this.hash( { length : 32 } ) );
	    };
	
	    // Windows Phone 7 ANID
	    Chance.prototype.wp7_anid = function () {
	        return 'A=' + this.guid().replace(/-/g, '').toUpperCase() + '&E=' + this.hash({ length:3 }) + '&W=' + this.integer({ min:0, max:9 });
	    };
	
	    // BlackBerry Device PIN
	    Chance.prototype.bb_pin = function () {
	        return this.hash({ length: 8 });
	    };
	
	    // -- End Mobile --
	
	    // -- Web --
	    Chance.prototype.avatar = function (options) {
	        var url = null;
	        var URL_BASE = '//www.gravatar.com/avatar/';
	        var PROTOCOLS = {
	            http: 'http',
	            https: 'https'
	        };
	        var FILE_TYPES = {
	            bmp: 'bmp',
	            gif: 'gif',
	            jpg: 'jpg',
	            png: 'png'
	        };
	        var FALLBACKS = {
	            '404': '404', // Return 404 if not found
	            mm: 'mm', // Mystery man
	            identicon: 'identicon', // Geometric pattern based on hash
	            monsterid: 'monsterid', // A generated monster icon
	            wavatar: 'wavatar', // A generated face
	            retro: 'retro', // 8-bit icon
	            blank: 'blank' // A transparent png
	        };
	        var RATINGS = {
	            g: 'g',
	            pg: 'pg',
	            r: 'r',
	            x: 'x'
	        };
	        var opts = {
	            protocol: null,
	            email: null,
	            fileExtension: null,
	            size: null,
	            fallback: null,
	            rating: null
	        };
	
	        if (!options) {
	            // Set to a random email
	            opts.email = this.email();
	            options = {};
	        }
	        else if (typeof options === 'string') {
	            opts.email = options;
	            options = {};
	        }
	        else if (typeof options !== 'object') {
	            return null;
	        }
	        else if (options.constructor === 'Array') {
	            return null;
	        }
	
	        opts = initOptions(options, opts);
	
	        if (!opts.email) {
	            // Set to a random email
	            opts.email = this.email();
	        }
	
	        // Safe checking for params
	        opts.protocol = PROTOCOLS[opts.protocol] ? opts.protocol + ':' : '';
	        opts.size = parseInt(opts.size, 0) ? opts.size : '';
	        opts.rating = RATINGS[opts.rating] ? opts.rating : '';
	        opts.fallback = FALLBACKS[opts.fallback] ? opts.fallback : '';
	        opts.fileExtension = FILE_TYPES[opts.fileExtension] ? opts.fileExtension : '';
	
	        url =
	            opts.protocol +
	            URL_BASE +
	            this.bimd5.md5(opts.email) +
	            (opts.fileExtension ? '.' + opts.fileExtension : '') +
	            (opts.size || opts.rating || opts.fallback ? '?' : '') +
	            (opts.size ? '&s=' + opts.size.toString() : '') +
	            (opts.rating ? '&r=' + opts.rating : '') +
	            (opts.fallback ? '&d=' + opts.fallback : '')
	            ;
	
	        return url;
	    };
	
	    /**
	     * #Description:
	     * ===============================================
	     * Generate random color value base on color type:
	     * -> hex
	     * -> rgb
	     * -> rgba
	     * -> 0x
	     * -> named color
	     *
	     * #Examples:
	     * ===============================================
	     * * Geerate random hex color
	     * chance.color() => '#79c157' / 'rgb(110,52,164)' / '0x67ae0b' / '#e2e2e2' / '#29CFA7'
	     *
	     * * Generate Hex based color value
	     * chance.color({format: 'hex'})    => '#d67118'
	     *
	     * * Generate simple rgb value
	     * chance.color({format: 'rgb'})    => 'rgb(110,52,164)'
	     *
	     * * Generate Ox based color value
	     * chance.color({format: '0x'})     => '0x67ae0b'
	     *
	     * * Generate graiscale based value
	     * chance.color({grayscale: true})  => '#e2e2e2'
	     *
	     * * Return valide color name
	     * chance.color({format: 'name'})   => 'red'
	     *
	     * * Make color uppercase
	     * chance.color({casing: 'upper'})  => '#29CFA7'
	     *
	     * @param  [object] options
	     * @return [string] color value
	     */
	    Chance.prototype.color = function (options) {
	
	        function gray(value, delimiter) {
	            return [value, value, value].join(delimiter || '');
	        }
	
	        function rgb(hasAlpha) {
	
	            var rgbValue    = (hasAlpha)    ? 'rgba' : 'rgb';
	            var alphaChanal = (hasAlpha)    ? (',' + this.floating({min:0, max:1})) : "";
	            var colorValue  = (isGrayscale) ? (gray(this.natural({max: 255}), ',')) : (this.natural({max: 255}) + ',' + this.natural({max: 255}) + ',' + this.natural({max: 255}));
	
	            return rgbValue + '(' + colorValue + alphaChanal + ')';
	        }
	
	        function hex(start, end, withHash) {
	
	            var simbol = (withHash) ? "#" : "";
	            var expression  = (isGrayscale ? gray(this.hash({length: start})) : this.hash({length: end}));
	            return simbol + expression;
	        }
	
	        options = initOptions(options, {
	            format: this.pick(['hex', 'shorthex', 'rgb', 'rgba', '0x', 'name']),
	            grayscale: false,
	            casing: 'lower'
	        });
	
	        var isGrayscale = options.grayscale;
	        var colorValue;
	
	        if (options.format === 'hex') {
	            colorValue =  hex.call(this, 2, 6, true);
	        }
	        else if (options.format === 'shorthex') {
	            colorValue = hex.call(this, 1, 3, true);
	        }
	        else if (options.format === 'rgb') {
	            colorValue = rgb.call(this, false);
	        }
	        else if (options.format === 'rgba') {
	            colorValue = rgb.call(this, true);
	        }
	        else if (options.format === '0x') {
	            colorValue = '0x' + hex.call(this, 2, 6);
	        }
	        else if(options.format === 'name') {
	            return this.pick(this.get("colorNames"));
	        }
	        else {
	            throw new RangeError('Invalid format provided. Please provide one of "hex", "shorthex", "rgb", "rgba", "0x" or "name".');
	        }
	
	        if (options.casing === 'upper' ) {
	            colorValue = colorValue.toUpperCase();
	        }
	
	        return colorValue;
	    };
	
	    Chance.prototype.domain = function (options) {
	        options = initOptions(options);
	        return this.word() + '.' + (options.tld || this.tld());
	    };
	
	    Chance.prototype.email = function (options) {
	        options = initOptions(options);
	        return this.word({length: options.length}) + '@' + (options.domain || this.domain());
	    };
	
	    Chance.prototype.fbid = function () {
	        return parseInt('10000' + this.natural({max: 100000000000}), 10);
	    };
	
	    Chance.prototype.google_analytics = function () {
	        var account = this.pad(this.natural({max: 999999}), 6);
	        var property = this.pad(this.natural({max: 99}), 2);
	
	        return 'UA-' + account + '-' + property;
	    };
	
	    Chance.prototype.hashtag = function () {
	        return '#' + this.word();
	    };
	
	    Chance.prototype.ip = function () {
	        // Todo: This could return some reserved IPs. See http://vq.io/137dgYy
	        // this should probably be updated to account for that rare as it may be
	        return this.natural({min: 1, max: 254}) + '.' +
	               this.natural({max: 255}) + '.' +
	               this.natural({max: 255}) + '.' +
	               this.natural({min: 1, max: 254});
	    };
	
	    Chance.prototype.ipv6 = function () {
	        var ip_addr = this.n(this.hash, 8, {length: 4});
	
	        return ip_addr.join(":");
	    };
	
	    Chance.prototype.klout = function () {
	        return this.natural({min: 1, max: 99});
	    };
	
	    Chance.prototype.semver = function (options) {
	        options = initOptions(options, { include_prerelease: true });
	
	        var range = this.pickone(["^", "~", "<", ">", "<=", ">=", "="]);
	        if (options.range) {
	            range = options.range;
	        }
	
	        var prerelease = "";
	        if (options.include_prerelease) {
	            prerelease = this.weighted(["", "-dev", "-beta", "-alpha"], [50, 10, 5, 1]);
	        }
	        return range + this.rpg('3d10').join('.') + prerelease;
	    };
	
	    Chance.prototype.tlds = function () {
	        return ['com', 'org', 'edu', 'gov', 'co.uk', 'net', 'io', 'ac', 'ad', 'ae', 'af', 'ag', 'ai', 'al', 'am', 'an', 'ao', 'aq', 'ar', 'as', 'at', 'au', 'aw', 'ax', 'az', 'ba', 'bb', 'bd', 'be', 'bf', 'bg', 'bh', 'bi', 'bj', 'bm', 'bn', 'bo', 'bq', 'br', 'bs', 'bt', 'bv', 'bw', 'by', 'bz', 'ca', 'cc', 'cd', 'cf', 'cg', 'ch', 'ci', 'ck', 'cl', 'cm', 'cn', 'co', 'cr', 'cu', 'cv', 'cw', 'cx', 'cy', 'cz', 'de', 'dj', 'dk', 'dm', 'do', 'dz', 'ec', 'ee', 'eg', 'eh', 'er', 'es', 'et', 'eu', 'fi', 'fj', 'fk', 'fm', 'fo', 'fr', 'ga', 'gb', 'gd', 'ge', 'gf', 'gg', 'gh', 'gi', 'gl', 'gm', 'gn', 'gp', 'gq', 'gr', 'gs', 'gt', 'gu', 'gw', 'gy', 'hk', 'hm', 'hn', 'hr', 'ht', 'hu', 'id', 'ie', 'il', 'im', 'in', 'io', 'iq', 'ir', 'is', 'it', 'je', 'jm', 'jo', 'jp', 'ke', 'kg', 'kh', 'ki', 'km', 'kn', 'kp', 'kr', 'kw', 'ky', 'kz', 'la', 'lb', 'lc', 'li', 'lk', 'lr', 'ls', 'lt', 'lu', 'lv', 'ly', 'ma', 'mc', 'md', 'me', 'mg', 'mh', 'mk', 'ml', 'mm', 'mn', 'mo', 'mp', 'mq', 'mr', 'ms', 'mt', 'mu', 'mv', 'mw', 'mx', 'my', 'mz', 'na', 'nc', 'ne', 'nf', 'ng', 'ni', 'nl', 'no', 'np', 'nr', 'nu', 'nz', 'om', 'pa', 'pe', 'pf', 'pg', 'ph', 'pk', 'pl', 'pm', 'pn', 'pr', 'ps', 'pt', 'pw', 'py', 'qa', 're', 'ro', 'rs', 'ru', 'rw', 'sa', 'sb', 'sc', 'sd', 'se', 'sg', 'sh', 'si', 'sj', 'sk', 'sl', 'sm', 'sn', 'so', 'sr', 'ss', 'st', 'su', 'sv', 'sx', 'sy', 'sz', 'tc', 'td', 'tf', 'tg', 'th', 'tj', 'tk', 'tl', 'tm', 'tn', 'to', 'tp', 'tr', 'tt', 'tv', 'tw', 'tz', 'ua', 'ug', 'uk', 'us', 'uy', 'uz', 'va', 'vc', 've', 'vg', 'vi', 'vn', 'vu', 'wf', 'ws', 'ye', 'yt', 'za', 'zm', 'zw'];
	    };
	
	    Chance.prototype.tld = function () {
	        return this.pick(this.tlds());
	    };
	
	    Chance.prototype.twitter = function () {
	        return '@' + this.word();
	    };
	
	    Chance.prototype.url = function (options) {
	        options = initOptions(options, { protocol: "http", domain: this.domain(options), domain_prefix: "", path: this.word(), extensions: []});
	
	        var extension = options.extensions.length > 0 ? "." + this.pick(options.extensions) : "";
	        var domain = options.domain_prefix ? options.domain_prefix + "." + options.domain : options.domain;
	
	        return options.protocol + "://" + domain + "/" + options.path + extension;
	    };
	
	    // -- End Web --
	
	    // -- Location --
	
	    Chance.prototype.address = function (options) {
	        options = initOptions(options);
	        return this.natural({min: 5, max: 2000}) + ' ' + this.street(options);
	    };
	
	    Chance.prototype.altitude = function (options) {
	        options = initOptions(options, {fixed: 5, min: 0, max: 8848});
	        return this.floating({
	            min: options.min,
	            max: options.max,
	            fixed: options.fixed
	        });
	    };
	
	    Chance.prototype.areacode = function (options) {
	        options = initOptions(options, {parens : true});
	        // Don't want area codes to start with 1, or have a 9 as the second digit
	        var areacode = this.natural({min: 2, max: 9}).toString() +
	                this.natural({min: 0, max: 8}).toString() +
	                this.natural({min: 0, max: 9}).toString();
	
	        return options.parens ? '(' + areacode + ')' : areacode;
	    };
	
	    Chance.prototype.city = function () {
	        return this.capitalize(this.word({syllables: 3}));
	    };
	
	    Chance.prototype.coordinates = function (options) {
	        return this.latitude(options) + ', ' + this.longitude(options);
	    };
	
	    Chance.prototype.countries = function () {
	        return this.get("countries");
	    };
	
	    Chance.prototype.country = function (options) {
	        options = initOptions(options);
	        var country = this.pick(this.countries());
	        return options.full ? country.name : country.abbreviation;
	    };
	
	    Chance.prototype.depth = function (options) {
	        options = initOptions(options, {fixed: 5, min: -10994, max: 0});
	        return this.floating({
	            min: options.min,
	            max: options.max,
	            fixed: options.fixed
	        });
	    };
	
	    Chance.prototype.geohash = function (options) {
	        options = initOptions(options, { length: 7 });
	        return this.string({ length: options.length, pool: '0123456789bcdefghjkmnpqrstuvwxyz' });
	    };
	
	    Chance.prototype.geojson = function (options) {
	        return this.latitude(options) + ', ' + this.longitude(options) + ', ' + this.altitude(options);
	    };
	
	    Chance.prototype.latitude = function (options) {
	        options = initOptions(options, {fixed: 5, min: -90, max: 90});
	        return this.floating({min: options.min, max: options.max, fixed: options.fixed});
	    };
	
	    Chance.prototype.longitude = function (options) {
	        options = initOptions(options, {fixed: 5, min: -180, max: 180});
	        return this.floating({min: options.min, max: options.max, fixed: options.fixed});
	    };
	
	    Chance.prototype.phone = function (options) {
	        var self = this,
	            numPick,
	            ukNum = function (parts) {
	                var section = [];
	                //fills the section part of the phone number with random numbers.
	                parts.sections.forEach(function(n) {
	                    section.push(self.string({ pool: '0123456789', length: n}));
	                });
	                return parts.area + section.join(' ');
	            };
	        options = initOptions(options, {
	            formatted: true,
	            country: 'us',
	            mobile: false
	        });
	        if (!options.formatted) {
	            options.parens = false;
	        }
	        var phone;
	        switch (options.country) {
	            case 'fr':
	                if (!options.mobile) {
	                    numPick = this.pick([
	                        // Valid zone and département codes.
	                        '01' + this.pick(['30', '34', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '53', '55', '56', '58', '60', '64', '69', '70', '72', '73', '74', '75', '76', '77', '78', '79', '80', '81', '82', '83']) + self.string({ pool: '0123456789', length: 6}),
	                        '02' + this.pick(['14', '18', '22', '23', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '40', '41', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '56', '57', '61', '62', '69', '72', '76', '77', '78', '85', '90', '96', '97', '98', '99']) + self.string({ pool: '0123456789', length: 6}),
	                        '03' + this.pick(['10', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '39', '44', '45', '51', '52', '54', '55', '57', '58', '59', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '70', '71', '72', '73', '80', '81', '82', '83', '84', '85', '86', '87', '88', '89', '90']) + self.string({ pool: '0123456789', length: 6}),
	                        '04' + this.pick(['11', '13', '15', '20', '22', '26', '27', '30', '32', '34', '37', '42', '43', '44', '50', '56', '57', '63', '66', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '80', '81', '82', '83', '84', '85', '86', '88', '89', '90', '91', '92', '93', '94', '95', '97', '98']) + self.string({ pool: '0123456789', length: 6}),
	                        '05' + this.pick(['08', '16', '17', '19', '24', '31', '32', '33', '34', '35', '40', '45', '46', '47', '49', '53', '55', '56', '57', '58', '59', '61', '62', '63', '64', '65', '67', '79', '81', '82', '86', '87', '90', '94']) + self.string({ pool: '0123456789', length: 6}),
	                        '09' + self.string({ pool: '0123456789', length: 8}),
	                    ]);
	                    phone = options.formatted ? numPick.match(/../g).join(' ') : numPick;
	                } else {
	                    numPick = this.pick(['06', '07']) + self.string({ pool: '0123456789', length: 8});
	                    phone = options.formatted ? numPick.match(/../g).join(' ') : numPick;
	                }
	                break;
	            case 'uk':
	                if (!options.mobile) {
	                    numPick = this.pick([
	                        //valid area codes of major cities/counties followed by random numbers in required format.
	                        { area: '01' + this.character({ pool: '234569' }) + '1 ', sections: [3,4] },
	                        { area: '020 ' + this.character({ pool: '378' }), sections: [3,4] },
	                        { area: '023 ' + this.character({ pool: '89' }), sections: [3,4] },
	                        { area: '024 7', sections: [3,4] },
	                        { area: '028 ' + this.pick(['25','28','37','71','82','90','92','95']), sections: [2,4] },
	                        { area: '012' + this.pick(['04','08','54','76','97','98']) + ' ', sections: [6] },
	                        { area: '013' + this.pick(['63','64','84','86']) + ' ', sections: [6] },
	                        { area: '014' + this.pick(['04','20','60','61','80','88']) + ' ', sections: [6] },
	                        { area: '015' + this.pick(['24','27','62','66']) + ' ', sections: [6] },
	                        { area: '016' + this.pick(['06','29','35','47','59','95']) + ' ', sections: [6] },
	                        { area: '017' + this.pick(['26','44','50','68']) + ' ', sections: [6] },
	                        { area: '018' + this.pick(['27','37','84','97']) + ' ', sections: [6] },
	                        { area: '019' + this.pick(['00','05','35','46','49','63','95']) + ' ', sections: [6] }
	                    ]);
	                    phone = options.formatted ? ukNum(numPick) : ukNum(numPick).replace(' ', '', 'g');
	                } else {
	                    numPick = this.pick([
	                        { area: '07' + this.pick(['4','5','7','8','9']), sections: [2,6] },
	                        { area: '07624 ', sections: [6] }
	                    ]);
	                    phone = options.formatted ? ukNum(numPick) : ukNum(numPick).replace(' ', '');
	                }
	                break;
	            case 'us':
	                var areacode = this.areacode(options).toString();
	                var exchange = this.natural({ min: 2, max: 9 }).toString() +
	                    this.natural({ min: 0, max: 9 }).toString() +
	                    this.natural({ min: 0, max: 9 }).toString();
	                var subscriber = this.natural({ min: 1000, max: 9999 }).toString(); // this could be random [0-9]{4}
	                phone = options.formatted ? areacode + ' ' + exchange + '-' + subscriber : areacode + exchange + subscriber;
	        }
	        return phone;
	    };
	
	    Chance.prototype.postal = function () {
	        // Postal District
	        var pd = this.character({pool: "XVTSRPNKLMHJGECBA"});
	        // Forward Sortation Area (FSA)
	        var fsa = pd + this.natural({max: 9}) + this.character({alpha: true, casing: "upper"});
	        // Local Delivery Unut (LDU)
	        var ldu = this.natural({max: 9}) + this.character({alpha: true, casing: "upper"}) + this.natural({max: 9});
	
	        return fsa + " " + ldu;
	    };
	
	    Chance.prototype.counties = function (options) {
	        options = initOptions(options, { country: 'uk' });
	        return this.get("counties")[options.country.toLowerCase()];
	    };
	
	    Chance.prototype.county = function (options) {
	        return this.pick(this.counties(options)).name;
	    };
	
	    Chance.prototype.provinces = function (options) {
	        options = initOptions(options, { country: 'ca' });
	        return this.get("provinces")[options.country.toLowerCase()];
	    };
	
	    Chance.prototype.province = function (options) {
	        return (options && options.full) ?
	            this.pick(this.provinces(options)).name :
	            this.pick(this.provinces(options)).abbreviation;
	    };
	
	    Chance.prototype.state = function (options) {
	        return (options && options.full) ?
	            this.pick(this.states(options)).name :
	            this.pick(this.states(options)).abbreviation;
	    };
	
	    Chance.prototype.states = function (options) {
	        options = initOptions(options, { country: 'us', us_states_and_dc: true } );
	
	        var states;
	
	        switch (options.country.toLowerCase()) {
	            case 'us':
	                var us_states_and_dc = this.get("us_states_and_dc"),
	                    territories = this.get("territories"),
	                    armed_forces = this.get("armed_forces");
	
	                states = [];
	
	                if (options.us_states_and_dc) {
	                    states = states.concat(us_states_and_dc);
	                }
	                if (options.territories) {
	                    states = states.concat(territories);
	                }
	                if (options.armed_forces) {
	                    states = states.concat(armed_forces);
	                }
	                break;
	            case 'it':
	                states = this.get("country_regions")[options.country.toLowerCase()];
	                break;
	            case 'uk':
	                states = this.get("counties")[options.country.toLowerCase()];
	                break;
	        }
	
	        return states;
	    };
	
	    Chance.prototype.street = function (options) {
	        options = initOptions(options, { country: 'us', syllables: 2 });
	        var     street;
	
	        switch (options.country.toLowerCase()) {
	            case 'us':
	                street = this.word({ syllables: options.syllables });
	                street = this.capitalize(street);
	                street += ' ';
	                street += options.short_suffix ?
	                    this.street_suffix(options).abbreviation :
	                    this.street_suffix(options).name;
	                break;
	            case 'it':
	                street = this.word({ syllables: options.syllables });
	                street = this.capitalize(street);
	                street = (options.short_suffix ?
	                    this.street_suffix(options).abbreviation :
	                    this.street_suffix(options).name) + " " + street;
	                break;
	        }
	        return street;
	    };
	
	    Chance.prototype.street_suffix = function (options) {
	        options = initOptions(options, { country: 'us' });
	        return this.pick(this.street_suffixes(options));
	    };
	
	    Chance.prototype.street_suffixes = function (options) {
	        options = initOptions(options, { country: 'us' });
	        // These are the most common suffixes.
	        return this.get("street_suffixes")[options.country.toLowerCase()];
	    };
	
	    // Note: only returning US zip codes, internationalization will be a whole
	    // other beast to tackle at some point.
	    Chance.prototype.zip = function (options) {
	        var zip = this.n(this.natural, 5, {max: 9});
	
	        if (options && options.plusfour === true) {
	            zip.push('-');
	            zip = zip.concat(this.n(this.natural, 4, {max: 9}));
	        }
	
	        return zip.join("");
	    };
	
	    // -- End Location --
	
	    // -- Time
	
	    Chance.prototype.ampm = function () {
	        return this.bool() ? 'am' : 'pm';
	    };
	
	    Chance.prototype.date = function (options) {
	        var date_string, date;
	
	        // If interval is specified we ignore preset
	        if(options && (options.min || options.max)) {
	            options = initOptions(options, {
	                american: true,
	                string: false
	            });
	            var min = typeof options.min !== "undefined" ? options.min.getTime() : 1;
	            // 100,000,000 days measured relative to midnight at the beginning of 01 January, 1970 UTC. http://es5.github.io/#x15.9.1.1
	            var max = typeof options.max !== "undefined" ? options.max.getTime() : 8640000000000000;
	
	            date = new Date(this.integer({min: min, max: max}));
	        } else {
	            var m = this.month({raw: true});
	            var daysInMonth = m.days;
	
	            if(options && options.month) {
	                // Mod 12 to allow months outside range of 0-11 (not encouraged, but also not prevented).
	                daysInMonth = this.get('months')[((options.month % 12) + 12) % 12].days;
	            }
	
	            options = initOptions(options, {
	                year: parseInt(this.year(), 10),
	                // Necessary to subtract 1 because Date() 0-indexes month but not day or year
	                // for some reason.
	                month: m.numeric - 1,
	                day: this.natural({min: 1, max: daysInMonth}),
	                hour: this.hour({twentyfour: true}),
	                minute: this.minute(),
	                second: this.second(),
	                millisecond: this.millisecond(),
	                american: true,
	                string: false
	            });
	
	            date = new Date(options.year, options.month, options.day, options.hour, options.minute, options.second, options.millisecond);
	        }
	
	        if (options.american) {
	            // Adding 1 to the month is necessary because Date() 0-indexes
	            // months but not day for some odd reason.
	            date_string = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
	        } else {
	            date_string = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
	        }
	
	        return options.string ? date_string : date;
	    };
	
	    Chance.prototype.hammertime = function (options) {
	        return this.date(options).getTime();
	    };
	
	    Chance.prototype.hour = function (options) {
	        options = initOptions(options, {
	            min: options && options.twentyfour ? 0 : 1,
	            max: options && options.twentyfour ? 23 : 12
	        });
	
	        testRange(options.min < 0, "Chance: Min cannot be less than 0.");
	        testRange(options.twentyfour && options.max > 23, "Chance: Max cannot be greater than 23 for twentyfour option.");
	        testRange(!options.twentyfour && options.max > 12, "Chance: Max cannot be greater than 12.");
	        testRange(options.min > options.max, "Chance: Min cannot be greater than Max.");
	
	        return this.natural({min: options.min, max: options.max});
	    };
	
	    Chance.prototype.millisecond = function () {
	        return this.natural({max: 999});
	    };
	
	    Chance.prototype.minute = Chance.prototype.second = function (options) {
	        options = initOptions(options, {min: 0, max: 59});
	
	        testRange(options.min < 0, "Chance: Min cannot be less than 0.");
	        testRange(options.max > 59, "Chance: Max cannot be greater than 59.");
	        testRange(options.min > options.max, "Chance: Min cannot be greater than Max.");
	
	        return this.natural({min: options.min, max: options.max});
	    };
	
	    Chance.prototype.month = function (options) {
	        options = initOptions(options, {min: 1, max: 12});
	
	        testRange(options.min < 1, "Chance: Min cannot be less than 1.");
	        testRange(options.max > 12, "Chance: Max cannot be greater than 12.");
	        testRange(options.min > options.max, "Chance: Min cannot be greater than Max.");
	
	        var month = this.pick(this.months().slice(options.min - 1, options.max));
	        return options.raw ? month : month.name;
	    };
	
	    Chance.prototype.months = function () {
	        return this.get("months");
	    };
	
	    Chance.prototype.second = function () {
	        return this.natural({max: 59});
	    };
	
	    Chance.prototype.timestamp = function () {
	        return this.natural({min: 1, max: parseInt(new Date().getTime() / 1000, 10)});
	    };
	
	    Chance.prototype.weekday = function (options) {
	        options = initOptions(options, {weekday_only: false});
	        var weekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
	        if (!options.weekday_only) {
	            weekdays.push("Saturday");
	            weekdays.push("Sunday");
	        }
	        return this.pickone(weekdays);
	    };
	
	    Chance.prototype.year = function (options) {
	        // Default to current year as min if none specified
	        options = initOptions(options, {min: new Date().getFullYear()});
	
	        // Default to one century after current year as max if none specified
	        options.max = (typeof options.max !== "undefined") ? options.max : options.min + 100;
	
	        return this.natural(options).toString();
	    };
	
	    // -- End Time
	
	    // -- Finance --
	
	    Chance.prototype.cc = function (options) {
	        options = initOptions(options);
	
	        var type, number, to_generate;
	
	        type = (options.type) ?
	                    this.cc_type({ name: options.type, raw: true }) :
	                    this.cc_type({ raw: true });
	
	        number = type.prefix.split("");
	        to_generate = type.length - type.prefix.length - 1;
	
	        // Generates n - 1 digits
	        number = number.concat(this.n(this.integer, to_generate, {min: 0, max: 9}));
	
	        // Generates the last digit according to Luhn algorithm
	        number.push(this.luhn_calculate(number.join("")));
	
	        return number.join("");
	    };
	
	    Chance.prototype.cc_types = function () {
	        // http://en.wikipedia.org/wiki/Bank_card_number#Issuer_identification_number_.28IIN.29
	        return this.get("cc_types");
	    };
	
	    Chance.prototype.cc_type = function (options) {
	        options = initOptions(options);
	        var types = this.cc_types(),
	            type = null;
	
	        if (options.name) {
	            for (var i = 0; i < types.length; i++) {
	                // Accept either name or short_name to specify card type
	                if (types[i].name === options.name || types[i].short_name === options.name) {
	                    type = types[i];
	                    break;
	                }
	            }
	            if (type === null) {
	                throw new RangeError("Credit card type '" + options.name + "'' is not supported");
	            }
	        } else {
	            type = this.pick(types);
	        }
	
	        return options.raw ? type : type.name;
	    };
	
	    //return all world currency by ISO 4217
	    Chance.prototype.currency_types = function () {
	        return this.get("currency_types");
	    };
	
	    //return random world currency by ISO 4217
	    Chance.prototype.currency = function () {
	        return this.pick(this.currency_types());
	    };
	
	    //return all timezones availabel
	    Chance.prototype.timezones = function () {
	        return this.get("timezones");
	    };
	
	    //return random timezone
	    Chance.prototype.timezone = function () {
	        return this.pick(this.timezones());
	    };
	
	    //Return random correct currency exchange pair (e.g. EUR/USD) or array of currency code
	    Chance.prototype.currency_pair = function (returnAsString) {
	        var currencies = this.unique(this.currency, 2, {
	            comparator: function(arr, val) {
	
	                return arr.reduce(function(acc, item) {
	                    // If a match has been found, short circuit check and just return
	                    return acc || (item.code === val.code);
	                }, false);
	            }
	        });
	
	        if (returnAsString) {
	            return currencies[0].code + '/' + currencies[1].code;
	        } else {
	            return currencies;
	        }
	    };
	
	    Chance.prototype.dollar = function (options) {
	        // By default, a somewhat more sane max for dollar than all available numbers
	        options = initOptions(options, {max : 10000, min : 0});
	
	        var dollar = this.floating({min: options.min, max: options.max, fixed: 2}).toString(),
	            cents = dollar.split('.')[1];
	
	        if (cents === undefined) {
	            dollar += '.00';
	        } else if (cents.length < 2) {
	            dollar = dollar + '0';
	        }
	
	        if (dollar < 0) {
	            return '-$' + dollar.replace('-', '');
	        } else {
	            return '$' + dollar;
	        }
	    };
	
	    Chance.prototype.euro = function (options) {
	        return Number(this.dollar(options).replace("$", "")).toLocaleString() + "€";
	    };
	
	    Chance.prototype.exp = function (options) {
	        options = initOptions(options);
	        var exp = {};
	
	        exp.year = this.exp_year();
	
	        // If the year is this year, need to ensure month is greater than the
	        // current month or this expiration will not be valid
	        if (exp.year === (new Date().getFullYear()).toString()) {
	            exp.month = this.exp_month({future: true});
	        } else {
	            exp.month = this.exp_month();
	        }
	
	        return options.raw ? exp : exp.month + '/' + exp.year;
	    };
	
	    Chance.prototype.exp_month = function (options) {
	        options = initOptions(options);
	        var month, month_int,
	            // Date object months are 0 indexed
	            curMonth = new Date().getMonth() + 1;
	
	        if (options.future && (curMonth !== 12)) {
	            do {
	                month = this.month({raw: true}).numeric;
	                month_int = parseInt(month, 10);
	            } while (month_int <= curMonth);
	        } else {
	            month = this.month({raw: true}).numeric;
	        }
	
	        return month;
	    };
	
	    Chance.prototype.exp_year = function () {
	        var curMonth = new Date().getMonth() + 1,
	            curYear = new Date().getFullYear();
	
	        return this.year({min: ((curMonth === 12) ? (curYear + 1) : curYear), max: (curYear + 10)});
	    };
	
	    Chance.prototype.vat = function (options) {
	        options = initOptions(options, { country: 'it' });
	        switch (options.country.toLowerCase()) {
	            case 'it':
	                return this.it_vat();
	        }
	    };
	
	    // -- End Finance
	
	    // -- Regional
	
	    Chance.prototype.it_vat = function () {
	        var it_vat = this.natural({min: 1, max: 1800000});
	
	        it_vat = this.pad(it_vat, 7) + this.pad(this.pick(this.provinces({ country: 'it' })).code, 3);
	        return it_vat + this.luhn_calculate(it_vat);
	    };
	
	    /*
	     * this generator is written following the official algorithm
	     * all data can be passed explicitely or randomized by calling chance.cf() without options
	     * the code does not check that the input data is valid (it goes beyond the scope of the generator)
	     *
	     * @param  [Object] options = { first: first name,
	     *                              last: last name,
	     *                              gender: female|male,
	                                    birthday: JavaScript date object,
	                                    city: string(4), 1 letter + 3 numbers
	                                   }
	     * @return [string] codice fiscale
	     *
	    */
	    Chance.prototype.cf = function (options) {
	        options = options || {};
	        var gender = !!options.gender ? options.gender : this.gender(),
	            first = !!options.first ? options.first : this.first( { gender: gender, nationality: 'it'} ),
	            last = !!options.last ? options.last : this.last( { nationality: 'it'} ),
	            birthday = !!options.birthday ? options.birthday : this.birthday(),
	            city = !!options.city ? options.city : this.pickone(['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'L', 'M', 'Z']) + this.pad(this.natural({max:999}), 3),
	            cf = [],
	            name_generator = function(name, isLast) {
	                var temp,
	                    return_value = [];
	
	                if (name.length < 3) {
	                    return_value = name.split("").concat("XXX".split("")).splice(0,3);
	                }
	                else {
	                    temp = name.toUpperCase().split('').map(function(c){
	                        return ("BCDFGHJKLMNPRSTVWZ".indexOf(c) !== -1) ? c : undefined;
	                    }).join('');
	                    if (temp.length > 3) {
	                        if (isLast) {
	                            temp = temp.substr(0,3);
	                        } else {
	                            temp = temp[0] + temp.substr(2,2);
	                        }
	                    }
	                    if (temp.length < 3) {
	                        return_value = temp;
	                        temp = name.toUpperCase().split('').map(function(c){
	                            return ("AEIOU".indexOf(c) !== -1) ? c : undefined;
	                        }).join('').substr(0, 3 - return_value.length);
	                    }
	                    return_value = return_value + temp;
	                }
	
	                return return_value;
	            },
	            date_generator = function(birthday, gender, that) {
	                var lettermonths = ['A', 'B', 'C', 'D', 'E', 'H', 'L', 'M', 'P', 'R', 'S', 'T'];
	
	                return  birthday.getFullYear().toString().substr(2) +
	                        lettermonths[birthday.getMonth()] +
	                        that.pad(birthday.getDate() + ((gender.toLowerCase() === "female") ? 40 : 0), 2);
	            },
	            checkdigit_generator = function(cf) {
	                var range1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ",
	                    range2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ",
	                    evens  = "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
	                    odds   = "BAKPLCQDREVOSFTGUHMINJWZYX",
	                    digit  = 0;
	
	
	                for(var i = 0; i < 15; i++) {
	                    if (i % 2 !== 0) {
	                        digit += evens.indexOf(range2[range1.indexOf(cf[i])]);
	                    }
	                    else {
	                        digit +=  odds.indexOf(range2[range1.indexOf(cf[i])]);
	                    }
	                }
	                return evens[digit % 26];
	            };
	
	        cf = cf.concat(name_generator(last, true), name_generator(first), date_generator(birthday, gender, this), city.toUpperCase().split("")).join("");
	        cf += checkdigit_generator(cf.toUpperCase(), this);
	
	        return cf.toUpperCase();
	    };
	
	    Chance.prototype.pl_pesel = function () {
	        var number = this.natural({min: 1, max: 9999999999});
	        var arr = this.pad(number, 10).split('');
	        for (var i = 0; i < arr.length; i++) {
	            arr[i] = parseInt(arr[i]);
	        }
	
	        var controlNumber = (1 * arr[0] + 3 * arr[1] + 7 * arr[2] + 9 * arr[3] + 1 * arr[4] + 3 * arr[5] + 7 * arr[6] + 9 * arr[7] + 1 * arr[8] + 3 * arr[9]) % 10;
	        if(controlNumber !== 0) {
	            controlNumber = 10 - controlNumber;
	        }
	
	        return arr.join('') + controlNumber;
	    };
	
	    Chance.prototype.pl_nip = function () {
	        var number = this.natural({min: 1, max: 999999999});
	        var arr = this.pad(number, 9).split('');
	        for (var i = 0; i < arr.length; i++) {
	            arr[i] = parseInt(arr[i]);
	        }
	
	        var controlNumber = (6 * arr[0] + 5 * arr[1] + 7 * arr[2] + 2 * arr[3] + 3 * arr[4] + 4 * arr[5] + 5 * arr[6] + 6 * arr[7] + 7 * arr[8]) % 11;
	        if(controlNumber === 10) {
	            return this.pl_nip();
	        }
	
	        return arr.join('') + controlNumber;
	    };
	
	    Chance.prototype.pl_regon = function () {
	        var number = this.natural({min: 1, max: 99999999});
	        var arr = this.pad(number, 8).split('');
	        for (var i = 0; i < arr.length; i++) {
	            arr[i] = parseInt(arr[i]);
	        }
	
	        var controlNumber = (8 * arr[0] + 9 * arr[1] + 2 * arr[2] + 3 * arr[3] + 4 * arr[4] + 5 * arr[5] + 6 * arr[6] + 7 * arr[7]) % 11;
	        if(controlNumber === 10) {
	            controlNumber = 0;
	        }
	
	        return arr.join('') + controlNumber;
	    };
	
	    // -- End Regional
	
	    // -- Miscellaneous --
	
	    // Dice - For all the board game geeks out there, myself included ;)
	    function diceFn (range) {
	        return function () {
	            return this.natural(range);
	        };
	    }
	    Chance.prototype.d4 = diceFn({min: 1, max: 4});
	    Chance.prototype.d6 = diceFn({min: 1, max: 6});
	    Chance.prototype.d8 = diceFn({min: 1, max: 8});
	    Chance.prototype.d10 = diceFn({min: 1, max: 10});
	    Chance.prototype.d12 = diceFn({min: 1, max: 12});
	    Chance.prototype.d20 = diceFn({min: 1, max: 20});
	    Chance.prototype.d30 = diceFn({min: 1, max: 30});
	    Chance.prototype.d100 = diceFn({min: 1, max: 100});
	
	    Chance.prototype.rpg = function (thrown, options) {
	        options = initOptions(options);
	        if (!thrown) {
	            throw new RangeError("A type of die roll must be included");
	        } else {
	            var bits = thrown.toLowerCase().split("d"),
	                rolls = [];
	
	            if (bits.length !== 2 || !parseInt(bits[0], 10) || !parseInt(bits[1], 10)) {
	                throw new Error("Invalid format provided. Please provide #d# where the first # is the number of dice to roll, the second # is the max of each die");
	            }
	            for (var i = bits[0]; i > 0; i--) {
	                rolls[i - 1] = this.natural({min: 1, max: bits[1]});
	            }
	            return (typeof options.sum !== 'undefined' && options.sum) ? rolls.reduce(function (p, c) { return p + c; }) : rolls;
	        }
	    };
	
	    // Guid
	    Chance.prototype.guid = function (options) {
	        options = initOptions(options, { version: 5 });
	
	        var guid_pool = "abcdef1234567890",
	            variant_pool = "ab89",
	            guid = this.string({ pool: guid_pool, length: 8 }) + '-' +
	                   this.string({ pool: guid_pool, length: 4 }) + '-' +
	                   // The Version
	                   options.version +
	                   this.string({ pool: guid_pool, length: 3 }) + '-' +
	                   // The Variant
	                   this.string({ pool: variant_pool, length: 1 }) +
	                   this.string({ pool: guid_pool, length: 3 }) + '-' +
	                   this.string({ pool: guid_pool, length: 12 });
	        return guid;
	    };
	
	    // Hash
	    Chance.prototype.hash = function (options) {
	        options = initOptions(options, {length : 40, casing: 'lower'});
	        var pool = options.casing === 'upper' ? HEX_POOL.toUpperCase() : HEX_POOL;
	        return this.string({pool: pool, length: options.length});
	    };
	
	    Chance.prototype.luhn_check = function (num) {
	        var str = num.toString();
	        var checkDigit = +str.substring(str.length - 1);
	        return checkDigit === this.luhn_calculate(+str.substring(0, str.length - 1));
	    };
	
	    Chance.prototype.luhn_calculate = function (num) {
	        var digits = num.toString().split("").reverse();
	        var sum = 0;
	        var digit;
	
	        for (var i = 0, l = digits.length; l > i; ++i) {
	            digit = +digits[i];
	            if (i % 2 === 0) {
	                digit *= 2;
	                if (digit > 9) {
	                    digit -= 9;
	                }
	            }
	            sum += digit;
	        }
	        return (sum * 9) % 10;
	    };
	
	    // MD5 Hash
	    Chance.prototype.md5 = function(options) {
	        var opts = { str: '', key: null, raw: false };
	
	        if (!options) {
	            opts.str = this.string();
	            options = {};
	        }
	        else if (typeof options === 'string') {
	            opts.str = options;
	            options = {};
	        }
	        else if (typeof options !== 'object') {
	            return null;
	        }
	        else if(options.constructor === 'Array') {
	            return null;
	        }
	
	        opts = initOptions(options, opts);
	
	        if(!opts.str){
	            throw new Error('A parameter is required to return an md5 hash.');
	        }
	
	        return this.bimd5.md5(opts.str, opts.key, opts.raw);
	    };
	
	    /**
	     * #Description:
	     * =====================================================
	     * Generate random file name with extention
	     *
	     * The argument provide extention type
	     * -> raster
	     * -> vector
	     * -> 3d
	     * -> document
	     *
	     * If noting is provided the function return random file name with random
	     * extention type of any kind
	     *
	     * The user can validate the file name length range
	     * If noting provided the generated file name is radom
	     *
	     * #Extention Pool :
	     * * Currently the supported extentions are
	     *  -> some of the most popular raster image extentions
	     *  -> some of the most popular vector image extentions
	     *  -> some of the most popular 3d image extentions
	     *  -> some of the most popular document extentions
	     *
	     * #Examples :
	     * =====================================================
	     *
	     * Return random file name with random extention. The file extention
	     * is provided by a predifined collection of extentions. More abouth the extention
	     * pool can be fond in #Extention Pool section
	     *
	     * chance.file()
	     * => dsfsdhjf.xml
	     *
	     * In order to generate a file name with sspecific length, specify the
	     * length property and integer value. The extention is going to be random
	     *
	     * chance.file({length : 10})
	     * => asrtineqos.pdf
	     *
	     * In order to geerate file with extention form some of the predifined groups
	     * of the extention pool just specify the extenton pool category in fileType property
	     *
	     * chance.file({fileType : 'raster'})
	     * => dshgssds.psd
	     *
	     * You can provide specific extention for your files
	     * chance.file({extention : 'html'})
	     * => djfsd.html
	     *
	     * Or you could pass custom collection of extentons bt array or by object
	     * chance.file({extentions : [...]})
	     * => dhgsdsd.psd
	     *
	     * chance.file({extentions : { key : [...], key : [...]}})
	     * => djsfksdjsd.xml
	     *
	     * @param  [collection] options
	     * @return [string]
	     *
	     */
	    Chance.prototype.file = function(options) {
	
	        var fileOptions = options || {};
	        var poolCollectionKey = "fileExtension";
	        var typeRange   = Object.keys(this.get("fileExtension"));//['raster', 'vector', '3d', 'document'];
	        var fileName;
	        var fileExtention;
	
	        // Generate random file name
	        fileName = this.word({length : fileOptions.length});
	
	        // Generate file by specific extention provided by the user
	        if(fileOptions.extention) {
	
	            fileExtention = fileOptions.extention;
	            return (fileName + '.' + fileExtention);
	        }
	
	        // Generate file by specific axtention collection
	        if(fileOptions.extentions) {
	
	            if(Array.isArray(fileOptions.extentions)) {
	
	                fileExtention = this.pickone(fileOptions.extentions);
	                return (fileName + '.' + fileExtention);
	            }
	            else if(fileOptions.extentions.constructor === Object) {
	
	                var extentionObjectCollection = fileOptions.extentions;
	                var keys = Object.keys(extentionObjectCollection);
	
	                fileExtention = this.pickone(extentionObjectCollection[this.pickone(keys)]);
	                return (fileName + '.' + fileExtention);
	            }
	
	            throw new Error("Expect collection of type Array or Object to be passed as an argument ");
	        }
	
	        // Generate file extention based on specific file type
	        if(fileOptions.fileType) {
	
	            var fileType = fileOptions.fileType;
	            if(typeRange.indexOf(fileType) !== -1) {
	
	                fileExtention = this.pickone(this.get(poolCollectionKey)[fileType]);
	                return (fileName + '.' + fileExtention);
	            }
	
	            throw new Error("Expect file type value to be 'raster', 'vector', '3d' or 'document' ");
	        }
	
	        // Generate random file name if no extenton options are passed
	        fileExtention = this.pickone(this.get(poolCollectionKey)[this.pickone(typeRange)]);
	        return (fileName + '.' + fileExtention);
	    };
	
	    var data = {
	
	        firstNames: {
	            "male": {
	                "en": ["James", "John", "Robert", "Michael", "William", "David", "Richard", "Joseph", "Charles", "Thomas", "Christopher", "Daniel", "Matthew", "George", "Donald", "Anthony", "Paul", "Mark", "Edward", "Steven", "Kenneth", "Andrew", "Brian", "Joshua", "Kevin", "Ronald", "Timothy", "Jason", "Jeffrey", "Frank", "Gary", "Ryan", "Nicholas", "Eric", "Stephen", "Jacob", "Larry", "Jonathan", "Scott", "Raymond", "Justin", "Brandon", "Gregory", "Samuel", "Benjamin", "Patrick", "Jack", "Henry", "Walter", "Dennis", "Jerry", "Alexander", "Peter", "Tyler", "Douglas", "Harold", "Aaron", "Jose", "Adam", "Arthur", "Zachary", "Carl", "Nathan", "Albert", "Kyle", "Lawrence", "Joe", "Willie", "Gerald", "Roger", "Keith", "Jeremy", "Terry", "Harry", "Ralph", "Sean", "Jesse", "Roy", "Louis", "Billy", "Austin", "Bruce", "Eugene", "Christian", "Bryan", "Wayne", "Russell", "Howard", "Fred", "Ethan", "Jordan", "Philip", "Alan", "Juan", "Randy", "Vincent", "Bobby", "Dylan", "Johnny", "Phillip", "Victor", "Clarence", "Ernest", "Martin", "Craig", "Stanley", "Shawn", "Travis", "Bradley", "Leonard", "Earl", "Gabriel", "Jimmy", "Francis", "Todd", "Noah", "Danny", "Dale", "Cody", "Carlos", "Allen", "Frederick", "Logan", "Curtis", "Alex", "Joel", "Luis", "Norman", "Marvin", "Glenn", "Tony", "Nathaniel", "Rodney", "Melvin", "Alfred", "Steve", "Cameron", "Chad", "Edwin", "Caleb", "Evan", "Antonio", "Lee", "Herbert", "Jeffery", "Isaac", "Derek", "Ricky", "Marcus", "Theodore", "Elijah", "Luke", "Jesus", "Eddie", "Troy", "Mike", "Dustin", "Ray", "Adrian", "Bernard", "Leroy", "Angel", "Randall", "Wesley", "Ian", "Jared", "Mason", "Hunter", "Calvin", "Oscar", "Clifford", "Jay", "Shane", "Ronnie", "Barry", "Lucas", "Corey", "Manuel", "Leo", "Tommy", "Warren", "Jackson", "Isaiah", "Connor", "Don", "Dean", "Jon", "Julian", "Miguel", "Bill", "Lloyd", "Charlie", "Mitchell", "Leon", "Jerome", "Darrell", "Jeremiah", "Alvin", "Brett", "Seth", "Floyd", "Jim", "Blake", "Micheal", "Gordon", "Trevor", "Lewis", "Erik", "Edgar", "Vernon", "Devin", "Gavin", "Jayden", "Chris", "Clyde", "Tom", "Derrick", "Mario", "Brent", "Marc", "Herman", "Chase", "Dominic", "Ricardo", "Franklin", "Maurice", "Max", "Aiden", "Owen", "Lester", "Gilbert", "Elmer", "Gene", "Francisco", "Glen", "Cory", "Garrett", "Clayton", "Sam", "Jorge", "Chester", "Alejandro", "Jeff", "Harvey", "Milton", "Cole", "Ivan", "Andre", "Duane", "Landon"],
	                // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0163
	                "it": ["Adolfo", "Alberto", "Aldo", "Alessandro", "Alessio", "Alfredo", "Alvaro", "Andrea", "Angelo", "Angiolo", "Antonino", "Antonio", "Attilio", "Benito", "Bernardo", "Bruno", "Carlo", "Cesare", "Christian", "Claudio", "Corrado", "Cosimo", "Cristian", "Cristiano", "Daniele", "Dario", "David", "Davide", "Diego", "Dino", "Domenico", "Duccio", "Edoardo", "Elia", "Elio", "Emanuele", "Emiliano", "Emilio", "Enrico", "Enzo", "Ettore", "Fabio", "Fabrizio", "Federico", "Ferdinando", "Fernando", "Filippo", "Francesco", "Franco", "Gabriele", "Giacomo", "Giampaolo", "Giampiero", "Giancarlo", "Gianfranco", "Gianluca", "Gianmarco", "Gianni", "Gino", "Giorgio", "Giovanni", "Giuliano", "Giulio", "Giuseppe", "Graziano", "Gregorio", "Guido", "Iacopo", "Jacopo", "Lapo", "Leonardo", "Lorenzo", "Luca", "Luciano", "Luigi", "Manuel", "Marcello", "Marco", "Marino", "Mario", "Massimiliano", "Massimo", "Matteo", "Mattia", "Maurizio", "Mauro", "Michele", "Mirko", "Mohamed", "Nello", "Neri", "Niccolò", "Nicola", "Osvaldo", "Otello", "Paolo", "Pier Luigi", "Piero", "Pietro", "Raffaele", "Remo", "Renato", "Renzo", "Riccardo", "Roberto", "Rolando", "Romano", "Salvatore", "Samuele", "Sandro", "Sergio", "Silvano", "Simone", "Stefano", "Thomas", "Tommaso", "Ubaldo", "Ugo", "Umberto", "Valerio", "Valter", "Vasco", "Vincenzo", "Vittorio"]
	            },
	            "female": {
	                "en": ["Mary", "Emma", "Elizabeth", "Minnie", "Margaret", "Ida", "Alice", "Bertha", "Sarah", "Annie", "Clara", "Ella", "Florence", "Cora", "Martha", "Laura", "Nellie", "Grace", "Carrie", "Maude", "Mabel", "Bessie", "Jennie", "Gertrude", "Julia", "Hattie", "Edith", "Mattie", "Rose", "Catherine", "Lillian", "Ada", "Lillie", "Helen", "Jessie", "Louise", "Ethel", "Lula", "Myrtle", "Eva", "Frances", "Lena", "Lucy", "Edna", "Maggie", "Pearl", "Daisy", "Fannie", "Josephine", "Dora", "Rosa", "Katherine", "Agnes", "Marie", "Nora", "May", "Mamie", "Blanche", "Stella", "Ellen", "Nancy", "Effie", "Sallie", "Nettie", "Della", "Lizzie", "Flora", "Susie", "Maud", "Mae", "Etta", "Harriet", "Sadie", "Caroline", "Katie", "Lydia", "Elsie", "Kate", "Susan", "Mollie", "Alma", "Addie", "Georgia", "Eliza", "Lulu", "Nannie", "Lottie", "Amanda", "Belle", "Charlotte", "Rebecca", "Ruth", "Viola", "Olive", "Amelia", "Hannah", "Jane", "Virginia", "Emily", "Matilda", "Irene", "Kathryn", "Esther", "Willie", "Henrietta", "Ollie", "Amy", "Rachel", "Sara", "Estella", "Theresa", "Augusta", "Ora", "Pauline", "Josie", "Lola", "Sophia", "Leona", "Anne", "Mildred", "Ann", "Beulah", "Callie", "Lou", "Delia", "Eleanor", "Barbara", "Iva", "Louisa", "Maria", "Mayme", "Evelyn", "Estelle", "Nina", "Betty", "Marion", "Bettie", "Dorothy", "Luella", "Inez", "Lela", "Rosie", "Allie", "Millie", "Janie", "Cornelia", "Victoria", "Ruby", "Winifred", "Alta", "Celia", "Christine", "Beatrice", "Birdie", "Harriett", "Mable", "Myra", "Sophie", "Tillie", "Isabel", "Sylvia", "Carolyn", "Isabelle", "Leila", "Sally", "Ina", "Essie", "Bertie", "Nell", "Alberta", "Katharine", "Lora", "Rena", "Mina", "Rhoda", "Mathilda", "Abbie", "Eula", "Dollie", "Hettie", "Eunice", "Fanny", "Ola", "Lenora", "Adelaide", "Christina", "Lelia", "Nelle", "Sue", "Johanna", "Lilly", "Lucinda", "Minerva", "Lettie", "Roxie", "Cynthia", "Helena", "Hilda", "Hulda", "Bernice", "Genevieve", "Jean", "Cordelia", "Marian", "Francis", "Jeanette", "Adeline", "Gussie", "Leah", "Lois", "Lura", "Mittie", "Hallie", "Isabella", "Olga", "Phoebe", "Teresa", "Hester", "Lida", "Lina", "Winnie", "Claudia", "Marguerite", "Vera", "Cecelia", "Bess", "Emilie", "John", "Rosetta", "Verna", "Myrtie", "Cecilia", "Elva", "Olivia", "Ophelia", "Georgie", "Elnora", "Violet", "Adele", "Lily", "Linnie", "Loretta", "Madge", "Polly", "Virgie", "Eugenia", "Lucile", "Lucille", "Mabelle", "Rosalie"],
	                // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0162
	                "it": ["Ada", "Adriana", "Alessandra", "Alessia", "Alice", "Angela", "Anna", "Anna Maria", "Annalisa", "Annita", "Annunziata", "Antonella", "Arianna", "Asia", "Assunta", "Aurora", "Barbara", "Beatrice", "Benedetta", "Bianca", "Bruna", "Camilla", "Carla", "Carlotta", "Carmela", "Carolina", "Caterina", "Catia", "Cecilia", "Chiara", "Cinzia", "Clara", "Claudia", "Costanza", "Cristina", "Daniela", "Debora", "Diletta", "Dina", "Donatella", "Elena", "Eleonora", "Elisa", "Elisabetta", "Emanuela", "Emma", "Eva", "Federica", "Fernanda", "Fiorella", "Fiorenza", "Flora", "Franca", "Francesca", "Gabriella", "Gaia", "Gemma", "Giada", "Gianna", "Gina", "Ginevra", "Giorgia", "Giovanna", "Giulia", "Giuliana", "Giuseppa", "Giuseppina", "Grazia", "Graziella", "Greta", "Ida", "Ilaria", "Ines", "Iolanda", "Irene", "Irma", "Isabella", "Jessica", "Laura", "Leda", "Letizia", "Licia", "Lidia", "Liliana", "Lina", "Linda", "Lisa", "Livia", "Loretta", "Luana", "Lucia", "Luciana", "Lucrezia", "Luisa", "Manuela", "Mara", "Marcella", "Margherita", "Maria", "Maria Cristina", "Maria Grazia", "Maria Luisa", "Maria Pia", "Maria Teresa", "Marina", "Marisa", "Marta", "Martina", "Marzia", "Matilde", "Melissa", "Michela", "Milena", "Mirella", "Monica", "Natalina", "Nella", "Nicoletta", "Noemi", "Olga", "Paola", "Patrizia", "Piera", "Pierina", "Raffaella", "Rebecca", "Renata", "Rina", "Rita", "Roberta", "Rosa", "Rosanna", "Rossana", "Rossella", "Sabrina", "Sandra", "Sara", "Serena", "Silvana", "Silvia", "Simona", "Simonetta", "Sofia", "Sonia", "Stefania", "Susanna", "Teresa", "Tina", "Tiziana", "Tosca", "Valentina", "Valeria", "Vanda", "Vanessa", "Vanna", "Vera", "Veronica", "Vilma", "Viola", "Virginia", "Vittoria"]
	            }
	        },
	
	        lastNames: {
	            "en": ['Smith', 'Johnson', 'Williams', 'Jones', 'Brown', 'Davis', 'Miller', 'Wilson', 'Moore', 'Taylor', 'Anderson', 'Thomas', 'Jackson', 'White', 'Harris', 'Martin', 'Thompson', 'Garcia', 'Martinez', 'Robinson', 'Clark', 'Rodriguez', 'Lewis', 'Lee', 'Walker', 'Hall', 'Allen', 'Young', 'Hernandez', 'King', 'Wright', 'Lopez', 'Hill', 'Scott', 'Green', 'Adams', 'Baker', 'Gonzalez', 'Nelson', 'Carter', 'Mitchell', 'Perez', 'Roberts', 'Turner', 'Phillips', 'Campbell', 'Parker', 'Evans', 'Edwards', 'Collins', 'Stewart', 'Sanchez', 'Morris', 'Rogers', 'Reed', 'Cook', 'Morgan', 'Bell', 'Murphy', 'Bailey', 'Rivera', 'Cooper', 'Richardson', 'Cox', 'Howard', 'Ward', 'Torres', 'Peterson', 'Gray', 'Ramirez', 'James', 'Watson', 'Brooks', 'Kelly', 'Sanders', 'Price', 'Bennett', 'Wood', 'Barnes', 'Ross', 'Henderson', 'Coleman', 'Jenkins', 'Perry', 'Powell', 'Long', 'Patterson', 'Hughes', 'Flores', 'Washington', 'Butler', 'Simmons', 'Foster', 'Gonzales', 'Bryant', 'Alexander', 'Russell', 'Griffin', 'Diaz', 'Hayes', 'Myers', 'Ford', 'Hamilton', 'Graham', 'Sullivan', 'Wallace', 'Woods', 'Cole', 'West', 'Jordan', 'Owens', 'Reynolds', 'Fisher', 'Ellis', 'Harrison', 'Gibson', 'McDonald', 'Cruz', 'Marshall', 'Ortiz', 'Gomez', 'Murray', 'Freeman', 'Wells', 'Webb', 'Simpson', 'Stevens', 'Tucker', 'Porter', 'Hunter', 'Hicks', 'Crawford', 'Henry', 'Boyd', 'Mason', 'Morales', 'Kennedy', 'Warren', 'Dixon', 'Ramos', 'Reyes', 'Burns', 'Gordon', 'Shaw', 'Holmes', 'Rice', 'Robertson', 'Hunt', 'Black', 'Daniels', 'Palmer', 'Mills', 'Nichols', 'Grant', 'Knight', 'Ferguson', 'Rose', 'Stone', 'Hawkins', 'Dunn', 'Perkins', 'Hudson', 'Spencer', 'Gardner', 'Stephens', 'Payne', 'Pierce', 'Berry', 'Matthews', 'Arnold', 'Wagner', 'Willis', 'Ray', 'Watkins', 'Olson', 'Carroll', 'Duncan', 'Snyder', 'Hart', 'Cunningham', 'Bradley', 'Lane', 'Andrews', 'Ruiz', 'Harper', 'Fox', 'Riley', 'Armstrong', 'Carpenter', 'Weaver', 'Greene', 'Lawrence', 'Elliott', 'Chavez', 'Sims', 'Austin', 'Peters', 'Kelley', 'Franklin', 'Lawson', 'Fields', 'Gutierrez', 'Ryan', 'Schmidt', 'Carr', 'Vasquez', 'Castillo', 'Wheeler', 'Chapman', 'Oliver', 'Montgomery', 'Richards', 'Williamson', 'Johnston', 'Banks', 'Meyer', 'Bishop', 'McCoy', 'Howell', 'Alvarez', 'Morrison', 'Hansen', 'Fernandez', 'Garza', 'Harvey', 'Little', 'Burton', 'Stanley', 'Nguyen', 'George', 'Jacobs', 'Reid', 'Kim', 'Fuller', 'Lynch', 'Dean', 'Gilbert', 'Garrett', 'Romero', 'Welch', 'Larson', 'Frazier', 'Burke', 'Hanson', 'Day', 'Mendoza', 'Moreno', 'Bowman', 'Medina', 'Fowler', 'Brewer', 'Hoffman', 'Carlson', 'Silva', 'Pearson', 'Holland', 'Douglas', 'Fleming', 'Jensen', 'Vargas', 'Byrd', 'Davidson', 'Hopkins', 'May', 'Terry', 'Herrera', 'Wade', 'Soto', 'Walters', 'Curtis', 'Neal', 'Caldwell', 'Lowe', 'Jennings', 'Barnett', 'Graves', 'Jimenez', 'Horton', 'Shelton', 'Barrett', 'Obrien', 'Castro', 'Sutton', 'Gregory', 'McKinney', 'Lucas', 'Miles', 'Craig', 'Rodriquez', 'Chambers', 'Holt', 'Lambert', 'Fletcher', 'Watts', 'Bates', 'Hale', 'Rhodes', 'Pena', 'Beck', 'Newman', 'Haynes', 'McDaniel', 'Mendez', 'Bush', 'Vaughn', 'Parks', 'Dawson', 'Santiago', 'Norris', 'Hardy', 'Love', 'Steele', 'Curry', 'Powers', 'Schultz', 'Barker', 'Guzman', 'Page', 'Munoz', 'Ball', 'Keller', 'Chandler', 'Weber', 'Leonard', 'Walsh', 'Lyons', 'Ramsey', 'Wolfe', 'Schneider', 'Mullins', 'Benson', 'Sharp', 'Bowen', 'Daniel', 'Barber', 'Cummings', 'Hines', 'Baldwin', 'Griffith', 'Valdez', 'Hubbard', 'Salazar', 'Reeves', 'Warner', 'Stevenson', 'Burgess', 'Santos', 'Tate', 'Cross', 'Garner', 'Mann', 'Mack', 'Moss', 'Thornton', 'Dennis', 'McGee', 'Farmer', 'Delgado', 'Aguilar', 'Vega', 'Glover', 'Manning', 'Cohen', 'Harmon', 'Rodgers', 'Robbins', 'Newton', 'Todd', 'Blair', 'Higgins', 'Ingram', 'Reese', 'Cannon', 'Strickland', 'Townsend', 'Potter', 'Goodwin', 'Walton', 'Rowe', 'Hampton', 'Ortega', 'Patton', 'Swanson', 'Joseph', 'Francis', 'Goodman', 'Maldonado', 'Yates', 'Becker', 'Erickson', 'Hodges', 'Rios', 'Conner', 'Adkins', 'Webster', 'Norman', 'Malone', 'Hammond', 'Flowers', 'Cobb', 'Moody', 'Quinn', 'Blake', 'Maxwell', 'Pope', 'Floyd', 'Osborne', 'Paul', 'McCarthy', 'Guerrero', 'Lindsey', 'Estrada', 'Sandoval', 'Gibbs', 'Tyler', 'Gross', 'Fitzgerald', 'Stokes', 'Doyle', 'Sherman', 'Saunders', 'Wise', 'Colon', 'Gill', 'Alvarado', 'Greer', 'Padilla', 'Simon', 'Waters', 'Nunez', 'Ballard', 'Schwartz', 'McBride', 'Houston', 'Christensen', 'Klein', 'Pratt', 'Briggs', 'Parsons', 'McLaughlin', 'Zimmerman', 'French', 'Buchanan', 'Moran', 'Copeland', 'Roy', 'Pittman', 'Brady', 'McCormick', 'Holloway', 'Brock', 'Poole', 'Frank', 'Logan', 'Owen', 'Bass', 'Marsh', 'Drake', 'Wong', 'Jefferson', 'Park', 'Morton', 'Abbott', 'Sparks', 'Patrick', 'Norton', 'Huff', 'Clayton', 'Massey', 'Lloyd', 'Figueroa', 'Carson', 'Bowers', 'Roberson', 'Barton', 'Tran', 'Lamb', 'Harrington', 'Casey', 'Boone', 'Cortez', 'Clarke', 'Mathis', 'Singleton', 'Wilkins', 'Cain', 'Bryan', 'Underwood', 'Hogan', 'McKenzie', 'Collier', 'Luna', 'Phelps', 'McGuire', 'Allison', 'Bridges', 'Wilkerson', 'Nash', 'Summers', 'Atkins'],
	                // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0164 (first 1000)
	            "it": ["Acciai", "Aglietti", "Agostini", "Agresti", "Ahmed", "Aiazzi", "Albanese", "Alberti", "Alessi", "Alfani", "Alinari", "Alterini", "Amato", "Ammannati", "Ancillotti", "Andrei", "Andreini", "Andreoni", "Angeli", "Anichini", "Antonelli", "Antonini", "Arena", "Ariani", "Arnetoli", "Arrighi", "Baccani", "Baccetti", "Bacci", "Bacherini", "Badii", "Baggiani", "Baglioni", "Bagni", "Bagnoli", "Baldassini", "Baldi", "Baldini", "Ballerini", "Balli", "Ballini", "Balloni", "Bambi", "Banchi", "Bandinelli", "Bandini", "Bani", "Barbetti", "Barbieri", "Barchielli", "Bardazzi", "Bardelli", "Bardi", "Barducci", "Bargellini", "Bargiacchi", "Barni", "Baroncelli", "Baroncini", "Barone", "Baroni", "Baronti", "Bartalesi", "Bartoletti", "Bartoli", "Bartolini", "Bartoloni", "Bartolozzi", "Basagni", "Basile", "Bassi", "Batacchi", "Battaglia", "Battaglini", "Bausi", "Becagli", "Becattini", "Becchi", "Becucci", "Bellandi", "Bellesi", "Belli", "Bellini", "Bellucci", "Bencini", "Benedetti", "Benelli", "Beni", "Benini", "Bensi", "Benucci", "Benvenuti", "Berlincioni", "Bernacchioni", "Bernardi", "Bernardini", "Berni", "Bernini", "Bertelli", "Berti", "Bertini", "Bessi", "Betti", "Bettini", "Biagi", "Biagini", "Biagioni", "Biagiotti", "Biancalani", "Bianchi", "Bianchini", "Bianco", "Biffoli", "Bigazzi", "Bigi", "Biliotti", "Billi", "Binazzi", "Bindi", "Bini", "Biondi", "Bizzarri", "Bocci", "Bogani", "Bolognesi", "Bonaiuti", "Bonanni", "Bonciani", "Boncinelli", "Bondi", "Bonechi", "Bongini", "Boni", "Bonini", "Borchi", "Boretti", "Borghi", "Borghini", "Borgioli", "Borri", "Borselli", "Boschi", "Bottai", "Bracci", "Braccini", "Brandi", "Braschi", "Bravi", "Brazzini", "Breschi", "Brilli", "Brizzi", "Brogelli", "Brogi", "Brogioni", "Brunelli", "Brunetti", "Bruni", "Bruno", "Brunori", "Bruschi", "Bucci", "Bucciarelli", "Buccioni", "Bucelli", "Bulli", "Burberi", "Burchi", "Burgassi", "Burroni", "Bussotti", "Buti", "Caciolli", "Caiani", "Calabrese", "Calamai", "Calamandrei", "Caldini", "Calo'", "Calonaci", "Calosi", "Calvelli", "Cambi", "Camiciottoli", "Cammelli", "Cammilli", "Campolmi", "Cantini", "Capanni", "Capecchi", "Caponi", "Cappelletti", "Cappelli", "Cappellini", "Cappugi", "Capretti", "Caputo", "Carbone", "Carboni", "Cardini", "Carlesi", "Carletti", "Carli", "Caroti", "Carotti", "Carrai", "Carraresi", "Carta", "Caruso", "Casalini", "Casati", "Caselli", "Casini", "Castagnoli", "Castellani", "Castelli", "Castellucci", "Catalano", "Catarzi", "Catelani", "Cavaciocchi", "Cavallaro", "Cavallini", "Cavicchi", "Cavini", "Ceccarelli", "Ceccatelli", "Ceccherelli", "Ceccherini", "Cecchi", "Cecchini", "Cecconi", "Cei", "Cellai", "Celli", "Cellini", "Cencetti", "Ceni", "Cenni", "Cerbai", "Cesari", "Ceseri", "Checcacci", "Checchi", "Checcucci", "Cheli", "Chellini", "Chen", "Cheng", "Cherici", "Cherubini", "Chiaramonti", "Chiarantini", "Chiarelli", "Chiari", "Chiarini", "Chiarugi", "Chiavacci", "Chiesi", "Chimenti", "Chini", "Chirici", "Chiti", "Ciabatti", "Ciampi", "Cianchi", "Cianfanelli", "Cianferoni", "Ciani", "Ciapetti", "Ciappi", "Ciardi", "Ciatti", "Cicali", "Ciccone", "Cinelli", "Cini", "Ciobanu", "Ciolli", "Cioni", "Cipriani", "Cirillo", "Cirri", "Ciucchi", "Ciuffi", "Ciulli", "Ciullini", "Clemente", "Cocchi", "Cognome", "Coli", "Collini", "Colombo", "Colzi", "Comparini", "Conforti", "Consigli", "Conte", "Conti", "Contini", "Coppini", "Coppola", "Corsi", "Corsini", "Corti", "Cortini", "Cosi", "Costa", "Costantini", "Costantino", "Cozzi", "Cresci", "Crescioli", "Cresti", "Crini", "Curradi", "D'Agostino", "D'Alessandro", "D'Amico", "D'Angelo", "Daddi", "Dainelli", "Dallai", "Danti", "Davitti", "De Angelis", "De Luca", "De Marco", "De Rosa", "De Santis", "De Simone", "De Vita", "Degl'Innocenti", "Degli Innocenti", "Dei", "Del Lungo", "Del Re", "Di Marco", "Di Stefano", "Dini", "Diop", "Dobre", "Dolfi", "Donati", "Dondoli", "Dong", "Donnini", "Ducci", "Dumitru", "Ermini", "Esposito", "Evangelisti", "Fabbri", "Fabbrini", "Fabbrizzi", "Fabbroni", "Fabbrucci", "Fabiani", "Facchini", "Faggi", "Fagioli", "Failli", "Faini", "Falciani", "Falcini", "Falcone", "Fallani", "Falorni", "Falsini", "Falugiani", "Fancelli", "Fanelli", "Fanetti", "Fanfani", "Fani", "Fantappie'", "Fantechi", "Fanti", "Fantini", "Fantoni", "Farina", "Fattori", "Favilli", "Fedi", "Fei", "Ferrante", "Ferrara", "Ferrari", "Ferraro", "Ferretti", "Ferri", "Ferrini", "Ferroni", "Fiaschi", "Fibbi", "Fiesoli", "Filippi", "Filippini", "Fini", "Fioravanti", "Fiore", "Fiorentini", "Fiorini", "Fissi", "Focardi", "Foggi", "Fontana", "Fontanelli", "Fontani", "Forconi", "Formigli", "Forte", "Forti", "Fortini", "Fossati", "Fossi", "Francalanci", "Franceschi", "Franceschini", "Franchi", "Franchini", "Franci", "Francini", "Francioni", "Franco", "Frassineti", "Frati", "Fratini", "Frilli", "Frizzi", "Frosali", "Frosini", "Frullini", "Fusco", "Fusi", "Gabbrielli", "Gabellini", "Gagliardi", "Galanti", "Galardi", "Galeotti", "Galletti", "Galli", "Gallo", "Gallori", "Gambacciani", "Gargani", "Garofalo", "Garuglieri", "Gashi", "Gasperini", "Gatti", "Gelli", "Gensini", "Gentile", "Gentili", "Geri", "Gerini", "Gheri", "Ghini", "Giachetti", "Giachi", "Giacomelli", "Gianassi", "Giani", "Giannelli", "Giannetti", "Gianni", "Giannini", "Giannoni", "Giannotti", "Giannozzi", "Gigli", "Giordano", "Giorgetti", "Giorgi", "Giovacchini", "Giovannelli", "Giovannetti", "Giovannini", "Giovannoni", "Giuliani", "Giunti", "Giuntini", "Giusti", "Gonnelli", "Goretti", "Gori", "Gradi", "Gramigni", "Grassi", "Grasso", "Graziani", "Grazzini", "Greco", "Grifoni", "Grillo", "Grimaldi", "Grossi", "Gualtieri", "Guarducci", "Guarino", "Guarnieri", "Guasti", "Guerra", "Guerri", "Guerrini", "Guidi", "Guidotti", "He", "Hoxha", "Hu", "Huang", "Iandelli", "Ignesti", "Innocenti", "Jin", "La Rosa", "Lai", "Landi", "Landini", "Lanini", "Lapi", "Lapini", "Lari", "Lascialfari", "Lastrucci", "Latini", "Lazzeri", "Lazzerini", "Lelli", "Lenzi", "Leonardi", "Leoncini", "Leone", "Leoni", "Lepri", "Li", "Liao", "Lin", "Linari", "Lippi", "Lisi", "Livi", "Lombardi", "Lombardini", "Lombardo", "Longo", "Lopez", "Lorenzi", "Lorenzini", "Lorini", "Lotti", "Lu", "Lucchesi", "Lucherini", "Lunghi", "Lupi", "Madiai", "Maestrini", "Maffei", "Maggi", "Maggini", "Magherini", "Magini", "Magnani", "Magnelli", "Magni", "Magnolfi", "Magrini", "Malavolti", "Malevolti", "Manca", "Mancini", "Manetti", "Manfredi", "Mangani", "Mannelli", "Manni", "Mannini", "Mannucci", "Manuelli", "Manzini", "Marcelli", "Marchese", "Marchetti", "Marchi", "Marchiani", "Marchionni", "Marconi", "Marcucci", "Margheri", "Mari", "Mariani", "Marilli", "Marinai", "Marinari", "Marinelli", "Marini", "Marino", "Mariotti", "Marsili", "Martelli", "Martinelli", "Martini", "Martino", "Marzi", "Masi", "Masini", "Masoni", "Massai", "Materassi", "Mattei", "Matteini", "Matteucci", "Matteuzzi", "Mattioli", "Mattolini", "Matucci", "Mauro", "Mazzanti", "Mazzei", "Mazzetti", "Mazzi", "Mazzini", "Mazzocchi", "Mazzoli", "Mazzoni", "Mazzuoli", "Meacci", "Mecocci", "Meini", "Melani", "Mele", "Meli", "Mengoni", "Menichetti", "Meoni", "Merlini", "Messeri", "Messina", "Meucci", "Miccinesi", "Miceli", "Micheli", "Michelini", "Michelozzi", "Migliori", "Migliorini", "Milani", "Miniati", "Misuri", "Monaco", "Montagnani", "Montagni", "Montanari", "Montelatici", "Monti", "Montigiani", "Montini", "Morandi", "Morandini", "Morelli", "Moretti", "Morganti", "Mori", "Morini", "Moroni", "Morozzi", "Mugnai", "Mugnaini", "Mustafa", "Naldi", "Naldini", "Nannelli", "Nanni", "Nannini", "Nannucci", "Nardi", "Nardini", "Nardoni", "Natali", "Ndiaye", "Nencetti", "Nencini", "Nencioni", "Neri", "Nesi", "Nesti", "Niccolai", "Niccoli", "Niccolini", "Nigi", "Nistri", "Nocentini", "Noferini", "Novelli", "Nucci", "Nuti", "Nutini", "Oliva", "Olivieri", "Olmi", "Orlandi", "Orlandini", "Orlando", "Orsini", "Ortolani", "Ottanelli", "Pacciani", "Pace", "Paci", "Pacini", "Pagani", "Pagano", "Paggetti", "Pagliai", "Pagni", "Pagnini", "Paladini", "Palagi", "Palchetti", "Palloni", "Palmieri", "Palumbo", "Pampaloni", "Pancani", "Pandolfi", "Pandolfini", "Panerai", "Panichi", "Paoletti", "Paoli", "Paolini", "Papi", "Papini", "Papucci", "Parenti", "Parigi", "Parisi", "Parri", "Parrini", "Pasquini", "Passeri", "Pecchioli", "Pecorini", "Pellegrini", "Pepi", "Perini", "Perrone", "Peruzzi", "Pesci", "Pestelli", "Petri", "Petrini", "Petrucci", "Pettini", "Pezzati", "Pezzatini", "Piani", "Piazza", "Piazzesi", "Piazzini", "Piccardi", "Picchi", "Piccini", "Piccioli", "Pieraccini", "Pieraccioni", "Pieralli", "Pierattini", "Pieri", "Pierini", "Pieroni", "Pietrini", "Pini", "Pinna", "Pinto", "Pinzani", "Pinzauti", "Piras", "Pisani", "Pistolesi", "Poggesi", "Poggi", "Poggiali", "Poggiolini", "Poli", "Pollastri", "Porciani", "Pozzi", "Pratellesi", "Pratesi", "Prosperi", "Pruneti", "Pucci", "Puccini", "Puccioni", "Pugi", "Pugliese", "Puliti", "Querci", "Quercioli", "Raddi", "Radu", "Raffaelli", "Ragazzini", "Ranfagni", "Ranieri", "Rastrelli", "Raugei", "Raveggi", "Renai", "Renzi", "Rettori", "Ricci", "Ricciardi", "Ridi", "Ridolfi", "Rigacci", "Righi", "Righini", "Rinaldi", "Risaliti", "Ristori", "Rizzo", "Rocchi", "Rocchini", "Rogai", "Romagnoli", "Romanelli", "Romani", "Romano", "Romei", "Romeo", "Romiti", "Romoli", "Romolini", "Rontini", "Rosati", "Roselli", "Rosi", "Rossetti", "Rossi", "Rossini", "Rovai", "Ruggeri", "Ruggiero", "Russo", "Sabatini", "Saccardi", "Sacchetti", "Sacchi", "Sacco", "Salerno", "Salimbeni", "Salucci", "Salvadori", "Salvestrini", "Salvi", "Salvini", "Sanesi", "Sani", "Sanna", "Santi", "Santini", "Santoni", "Santoro", "Santucci", "Sardi", "Sarri", "Sarti", "Sassi", "Sbolci", "Scali", "Scarpelli", "Scarselli", "Scopetani", "Secci", "Selvi", "Senatori", "Senesi", "Serafini", "Sereni", "Serra", "Sestini", "Sguanci", "Sieni", "Signorini", "Silvestri", "Simoncini", "Simonetti", "Simoni", "Singh", "Sodi", "Soldi", "Somigli", "Sorbi", "Sorelli", "Sorrentino", "Sottili", "Spina", "Spinelli", "Staccioli", "Staderini", "Stefanelli", "Stefani", "Stefanini", "Stella", "Susini", "Tacchi", "Tacconi", "Taddei", "Tagliaferri", "Tamburini", "Tanganelli", "Tani", "Tanini", "Tapinassi", "Tarchi", "Tarchiani", "Targioni", "Tassi", "Tassini", "Tempesti", "Terzani", "Tesi", "Testa", "Testi", "Tilli", "Tinti", "Tirinnanzi", "Toccafondi", "Tofanari", "Tofani", "Tognaccini", "Tonelli", "Tonini", "Torelli", "Torrini", "Tosi", "Toti", "Tozzi", "Trambusti", "Trapani", "Tucci", "Turchi", "Ugolini", "Ulivi", "Valente", "Valenti", "Valentini", "Vangelisti", "Vanni", "Vannini", "Vannoni", "Vannozzi", "Vannucchi", "Vannucci", "Ventura", "Venturi", "Venturini", "Vestri", "Vettori", "Vichi", "Viciani", "Vieri", "Vigiani", "Vignoli", "Vignolini", "Vignozzi", "Villani", "Vinci", "Visani", "Vitale", "Vitali", "Viti", "Viviani", "Vivoli", "Volpe", "Volpi", "Wang", "Wu", "Xu", "Yang", "Ye", "Zagli", "Zani", "Zanieri", "Zanobini", "Zecchi", "Zetti", "Zhang", "Zheng", "Zhou", "Zhu", "Zingoni", "Zini", "Zoppi"]
	        },
	
	        // Data taken from https://github.com/umpirsky/country-list/blob/master/data/en_US/country.json
	        countries: [{"name":"Afghanistan","abbreviation":"AF"},{"name":"Åland Islands","abbreviation":"AX"},{"name":"Albania","abbreviation":"AL"},{"name":"Algeria","abbreviation":"DZ"},{"name":"American Samoa","abbreviation":"AS"},{"name":"Andorra","abbreviation":"AD"},{"name":"Angola","abbreviation":"AO"},{"name":"Anguilla","abbreviation":"AI"},{"name":"Antarctica","abbreviation":"AQ"},{"name":"Antigua & Barbuda","abbreviation":"AG"},{"name":"Argentina","abbreviation":"AR"},{"name":"Armenia","abbreviation":"AM"},{"name":"Aruba","abbreviation":"AW"},{"name":"Ascension Island","abbreviation":"AC"},{"name":"Australia","abbreviation":"AU"},{"name":"Austria","abbreviation":"AT"},{"name":"Azerbaijan","abbreviation":"AZ"},{"name":"Bahamas","abbreviation":"BS"},{"name":"Bahrain","abbreviation":"BH"},{"name":"Bangladesh","abbreviation":"BD"},{"name":"Barbados","abbreviation":"BB"},{"name":"Belarus","abbreviation":"BY"},{"name":"Belgium","abbreviation":"BE"},{"name":"Belize","abbreviation":"BZ"},{"name":"Benin","abbreviation":"BJ"},{"name":"Bermuda","abbreviation":"BM"},{"name":"Bhutan","abbreviation":"BT"},{"name":"Bolivia","abbreviation":"BO"},{"name":"Bosnia & Herzegovina","abbreviation":"BA"},{"name":"Botswana","abbreviation":"BW"},{"name":"Brazil","abbreviation":"BR"},{"name":"British Indian Ocean Territory","abbreviation":"IO"},{"name":"British Virgin Islands","abbreviation":"VG"},{"name":"Brunei","abbreviation":"BN"},{"name":"Bulgaria","abbreviation":"BG"},{"name":"Burkina Faso","abbreviation":"BF"},{"name":"Burundi","abbreviation":"BI"},{"name":"Cambodia","abbreviation":"KH"},{"name":"Cameroon","abbreviation":"CM"},{"name":"Canada","abbreviation":"CA"},{"name":"Canary Islands","abbreviation":"IC"},{"name":"Cape Verde","abbreviation":"CV"},{"name":"Caribbean Netherlands","abbreviation":"BQ"},{"name":"Cayman Islands","abbreviation":"KY"},{"name":"Central African Republic","abbreviation":"CF"},{"name":"Ceuta & Melilla","abbreviation":"EA"},{"name":"Chad","abbreviation":"TD"},{"name":"Chile","abbreviation":"CL"},{"name":"China","abbreviation":"CN"},{"name":"Christmas Island","abbreviation":"CX"},{"name":"Cocos (Keeling) Islands","abbreviation":"CC"},{"name":"Colombia","abbreviation":"CO"},{"name":"Comoros","abbreviation":"KM"},{"name":"Congo - Brazzaville","abbreviation":"CG"},{"name":"Congo - Kinshasa","abbreviation":"CD"},{"name":"Cook Islands","abbreviation":"CK"},{"name":"Costa Rica","abbreviation":"CR"},{"name":"Côte d'Ivoire","abbreviation":"CI"},{"name":"Croatia","abbreviation":"HR"},{"name":"Cuba","abbreviation":"CU"},{"name":"Curaçao","abbreviation":"CW"},{"name":"Cyprus","abbreviation":"CY"},{"name":"Czech Republic","abbreviation":"CZ"},{"name":"Denmark","abbreviation":"DK"},{"name":"Diego Garcia","abbreviation":"DG"},{"name":"Djibouti","abbreviation":"DJ"},{"name":"Dominica","abbreviation":"DM"},{"name":"Dominican Republic","abbreviation":"DO"},{"name":"Ecuador","abbreviation":"EC"},{"name":"Egypt","abbreviation":"EG"},{"name":"El Salvador","abbreviation":"SV"},{"name":"Equatorial Guinea","abbreviation":"GQ"},{"name":"Eritrea","abbreviation":"ER"},{"name":"Estonia","abbreviation":"EE"},{"name":"Ethiopia","abbreviation":"ET"},{"name":"Falkland Islands","abbreviation":"FK"},{"name":"Faroe Islands","abbreviation":"FO"},{"name":"Fiji","abbreviation":"FJ"},{"name":"Finland","abbreviation":"FI"},{"name":"France","abbreviation":"FR"},{"name":"French Guiana","abbreviation":"GF"},{"name":"French Polynesia","abbreviation":"PF"},{"name":"French Southern Territories","abbreviation":"TF"},{"name":"Gabon","abbreviation":"GA"},{"name":"Gambia","abbreviation":"GM"},{"name":"Georgia","abbreviation":"GE"},{"name":"Germany","abbreviation":"DE"},{"name":"Ghana","abbreviation":"GH"},{"name":"Gibraltar","abbreviation":"GI"},{"name":"Greece","abbreviation":"GR"},{"name":"Greenland","abbreviation":"GL"},{"name":"Grenada","abbreviation":"GD"},{"name":"Guadeloupe","abbreviation":"GP"},{"name":"Guam","abbreviation":"GU"},{"name":"Guatemala","abbreviation":"GT"},{"name":"Guernsey","abbreviation":"GG"},{"name":"Guinea","abbreviation":"GN"},{"name":"Guinea-Bissau","abbreviation":"GW"},{"name":"Guyana","abbreviation":"GY"},{"name":"Haiti","abbreviation":"HT"},{"name":"Honduras","abbreviation":"HN"},{"name":"Hong Kong SAR China","abbreviation":"HK"},{"name":"Hungary","abbreviation":"HU"},{"name":"Iceland","abbreviation":"IS"},{"name":"India","abbreviation":"IN"},{"name":"Indonesia","abbreviation":"ID"},{"name":"Iran","abbreviation":"IR"},{"name":"Iraq","abbreviation":"IQ"},{"name":"Ireland","abbreviation":"IE"},{"name":"Isle of Man","abbreviation":"IM"},{"name":"Israel","abbreviation":"IL"},{"name":"Italy","abbreviation":"IT"},{"name":"Jamaica","abbreviation":"JM"},{"name":"Japan","abbreviation":"JP"},{"name":"Jersey","abbreviation":"JE"},{"name":"Jordan","abbreviation":"JO"},{"name":"Kazakhstan","abbreviation":"KZ"},{"name":"Kenya","abbreviation":"KE"},{"name":"Kiribati","abbreviation":"KI"},{"name":"Kosovo","abbreviation":"XK"},{"name":"Kuwait","abbreviation":"KW"},{"name":"Kyrgyzstan","abbreviation":"KG"},{"name":"Laos","abbreviation":"LA"},{"name":"Latvia","abbreviation":"LV"},{"name":"Lebanon","abbreviation":"LB"},{"name":"Lesotho","abbreviation":"LS"},{"name":"Liberia","abbreviation":"LR"},{"name":"Libya","abbreviation":"LY"},{"name":"Liechtenstein","abbreviation":"LI"},{"name":"Lithuania","abbreviation":"LT"},{"name":"Luxembourg","abbreviation":"LU"},{"name":"Macau SAR China","abbreviation":"MO"},{"name":"Macedonia","abbreviation":"MK"},{"name":"Madagascar","abbreviation":"MG"},{"name":"Malawi","abbreviation":"MW"},{"name":"Malaysia","abbreviation":"MY"},{"name":"Maldives","abbreviation":"MV"},{"name":"Mali","abbreviation":"ML"},{"name":"Malta","abbreviation":"MT"},{"name":"Marshall Islands","abbreviation":"MH"},{"name":"Martinique","abbreviation":"MQ"},{"name":"Mauritania","abbreviation":"MR"},{"name":"Mauritius","abbreviation":"MU"},{"name":"Mayotte","abbreviation":"YT"},{"name":"Mexico","abbreviation":"MX"},{"name":"Micronesia","abbreviation":"FM"},{"name":"Moldova","abbreviation":"MD"},{"name":"Monaco","abbreviation":"MC"},{"name":"Mongolia","abbreviation":"MN"},{"name":"Montenegro","abbreviation":"ME"},{"name":"Montserrat","abbreviation":"MS"},{"name":"Morocco","abbreviation":"MA"},{"name":"Mozambique","abbreviation":"MZ"},{"name":"Myanmar (Burma)","abbreviation":"MM"},{"name":"Namibia","abbreviation":"NA"},{"name":"Nauru","abbreviation":"NR"},{"name":"Nepal","abbreviation":"NP"},{"name":"Netherlands","abbreviation":"NL"},{"name":"New Caledonia","abbreviation":"NC"},{"name":"New Zealand","abbreviation":"NZ"},{"name":"Nicaragua","abbreviation":"NI"},{"name":"Niger","abbreviation":"NE"},{"name":"Nigeria","abbreviation":"NG"},{"name":"Niue","abbreviation":"NU"},{"name":"Norfolk Island","abbreviation":"NF"},{"name":"North Korea","abbreviation":"KP"},{"name":"Northern Mariana Islands","abbreviation":"MP"},{"name":"Norway","abbreviation":"NO"},{"name":"Oman","abbreviation":"OM"},{"name":"Pakistan","abbreviation":"PK"},{"name":"Palau","abbreviation":"PW"},{"name":"Palestinian Territories","abbreviation":"PS"},{"name":"Panama","abbreviation":"PA"},{"name":"Papua New Guinea","abbreviation":"PG"},{"name":"Paraguay","abbreviation":"PY"},{"name":"Peru","abbreviation":"PE"},{"name":"Philippines","abbreviation":"PH"},{"name":"Pitcairn Islands","abbreviation":"PN"},{"name":"Poland","abbreviation":"PL"},{"name":"Portugal","abbreviation":"PT"},{"name":"Puerto Rico","abbreviation":"PR"},{"name":"Qatar","abbreviation":"QA"},{"name":"Réunion","abbreviation":"RE"},{"name":"Romania","abbreviation":"RO"},{"name":"Russia","abbreviation":"RU"},{"name":"Rwanda","abbreviation":"RW"},{"name":"Samoa","abbreviation":"WS"},{"name":"San Marino","abbreviation":"SM"},{"name":"São Tomé and Príncipe","abbreviation":"ST"},{"name":"Saudi Arabia","abbreviation":"SA"},{"name":"Senegal","abbreviation":"SN"},{"name":"Serbia","abbreviation":"RS"},{"name":"Seychelles","abbreviation":"SC"},{"name":"Sierra Leone","abbreviation":"SL"},{"name":"Singapore","abbreviation":"SG"},{"name":"Sint Maarten","abbreviation":"SX"},{"name":"Slovakia","abbreviation":"SK"},{"name":"Slovenia","abbreviation":"SI"},{"name":"Solomon Islands","abbreviation":"SB"},{"name":"Somalia","abbreviation":"SO"},{"name":"South Africa","abbreviation":"ZA"},{"name":"South Georgia & South Sandwich Islands","abbreviation":"GS"},{"name":"South Korea","abbreviation":"KR"},{"name":"South Sudan","abbreviation":"SS"},{"name":"Spain","abbreviation":"ES"},{"name":"Sri Lanka","abbreviation":"LK"},{"name":"St. Barthélemy","abbreviation":"BL"},{"name":"St. Helena","abbreviation":"SH"},{"name":"St. Kitts & Nevis","abbreviation":"KN"},{"name":"St. Lucia","abbreviation":"LC"},{"name":"St. Martin","abbreviation":"MF"},{"name":"St. Pierre & Miquelon","abbreviation":"PM"},{"name":"St. Vincent & Grenadines","abbreviation":"VC"},{"name":"Sudan","abbreviation":"SD"},{"name":"Suriname","abbreviation":"SR"},{"name":"Svalbard & Jan Mayen","abbreviation":"SJ"},{"name":"Swaziland","abbreviation":"SZ"},{"name":"Sweden","abbreviation":"SE"},{"name":"Switzerland","abbreviation":"CH"},{"name":"Syria","abbreviation":"SY"},{"name":"Taiwan","abbreviation":"TW"},{"name":"Tajikistan","abbreviation":"TJ"},{"name":"Tanzania","abbreviation":"TZ"},{"name":"Thailand","abbreviation":"TH"},{"name":"Timor-Leste","abbreviation":"TL"},{"name":"Togo","abbreviation":"TG"},{"name":"Tokelau","abbreviation":"TK"},{"name":"Tonga","abbreviation":"TO"},{"name":"Trinidad & Tobago","abbreviation":"TT"},{"name":"Tristan da Cunha","abbreviation":"TA"},{"name":"Tunisia","abbreviation":"TN"},{"name":"Turkey","abbreviation":"TR"},{"name":"Turkmenistan","abbreviation":"TM"},{"name":"Turks & Caicos Islands","abbreviation":"TC"},{"name":"Tuvalu","abbreviation":"TV"},{"name":"U.S. Outlying Islands","abbreviation":"UM"},{"name":"U.S. Virgin Islands","abbreviation":"VI"},{"name":"Uganda","abbreviation":"UG"},{"name":"Ukraine","abbreviation":"UA"},{"name":"United Arab Emirates","abbreviation":"AE"},{"name":"United Kingdom","abbreviation":"GB"},{"name":"United States","abbreviation":"US"},{"name":"Uruguay","abbreviation":"UY"},{"name":"Uzbekistan","abbreviation":"UZ"},{"name":"Vanuatu","abbreviation":"VU"},{"name":"Vatican City","abbreviation":"VA"},{"name":"Venezuela","abbreviation":"VE"},{"name":"Vietnam","abbreviation":"VN"},{"name":"Wallis & Futuna","abbreviation":"WF"},{"name":"Western Sahara","abbreviation":"EH"},{"name":"Yemen","abbreviation":"YE"},{"name":"Zambia","abbreviation":"ZM"},{"name":"Zimbabwe","abbreviation":"ZW"}],
	
			counties: {
	            // Data taken from http://www.downloadexcelfiles.com/gb_en/download-excel-file-list-counties-uk
	            "uk": [
	                {name: 'Bath and North East Somerset'},
	                {name: 'Bedford'},
	                {name: 'Blackburn with Darwen'},
	                {name: 'Blackpool'},
	                {name: 'Bournemouth'},
	                {name: 'Bracknell Forest'},
	                {name: 'Brighton & Hove'},
	                {name: 'Bristol'},
	                {name: 'Buckinghamshire'},
	                {name: 'Cambridgeshire'},
	                {name: 'Central Bedfordshire'},
	                {name: 'Cheshire East'},
	                {name: 'Cheshire West and Chester'},
	                {name: 'Cornwall'},
	                {name: 'County Durham'},
	                {name: 'Cumbria'},
	                {name: 'Darlington'},
	                {name: 'Derby'},
	                {name: 'Derbyshire'},
	                {name: 'Devon'},
	                {name: 'Dorset'},
	                {name: 'East Riding of Yorkshire'},
	                {name: 'East Sussex'},
	                {name: 'Essex'},
	                {name: 'Gloucestershire'},
	                {name: 'Greater London'},
	                {name: 'Greater Manchester'},
	                {name: 'Halton'},
	                {name: 'Hampshire'},
	                {name: 'Hartlepool'},
	                {name: 'Herefordshire'},
	                {name: 'Hertfordshire'},
	                {name: 'Hull'},
	                {name: 'Isle of Wight'},
	                {name: 'Isles of Scilly'},
	                {name: 'Kent'},
	                {name: 'Lancashire'},
	                {name: 'Leicester'},
	                {name: 'Leicestershire'},
	                {name: 'Lincolnshire'},
	                {name: 'Luton'},
	                {name: 'Medway'},
	                {name: 'Merseyside'},
	                {name: 'Middlesbrough'},
	                {name: 'Milton Keynes'},
	                {name: 'Norfolk'},
	                {name: 'North East Lincolnshire'},
	                {name: 'North Lincolnshire'},
	                {name: 'North Somerset'},
	                {name: 'North Yorkshire'},
	                {name: 'Northamptonshire'},
	                {name: 'Northumberland'},
	                {name: 'Nottingham'},
	                {name: 'Nottinghamshire'},
	                {name: 'Oxfordshire'},
	                {name: 'Peterborough'},
	                {name: 'Plymouth'},
	                {name: 'Poole'},
	                {name: 'Portsmouth'},
	                {name: 'Reading'},
	                {name: 'Redcar and Cleveland'},
	                {name: 'Rutland'},
	                {name: 'Shropshire'},
	                {name: 'Slough'},
	                {name: 'Somerset'},
	                {name: 'South Gloucestershire'},
	                {name: 'South Yorkshire'},
	                {name: 'Southampton'},
	                {name: 'Southend-on-Sea'},
	                {name: 'Staffordshire'},
	                {name: 'Stockton-on-Tees'},
	                {name: 'Stoke-on-Trent'},
	                {name: 'Suffolk'},
	                {name: 'Surrey'},
	                {name: 'Swindon'},
	                {name: 'Telford and Wrekin'},
	                {name: 'Thurrock'},
	                {name: 'Torbay'},
	                {name: 'Tyne and Wear'},
	                {name: 'Warrington'},
	                {name: 'Warwickshire'},
	                {name: 'West Berkshire'},
	                {name: 'West Midlands'},
	                {name: 'West Sussex'},
	                {name: 'West Yorkshire'},
	                {name: 'Wiltshire'},
	                {name: 'Windsor and Maidenhead'},
	                {name: 'Wokingham'},
	                {name: 'Worcestershire'},
	                {name: 'York'}]
					},
	        provinces: {
	            "ca": [
	                {name: 'Alberta', abbreviation: 'AB'},
	                {name: 'British Columbia', abbreviation: 'BC'},
	                {name: 'Manitoba', abbreviation: 'MB'},
	                {name: 'New Brunswick', abbreviation: 'NB'},
	                {name: 'Newfoundland and Labrador', abbreviation: 'NL'},
	                {name: 'Nova Scotia', abbreviation: 'NS'},
	                {name: 'Ontario', abbreviation: 'ON'},
	                {name: 'Prince Edward Island', abbreviation: 'PE'},
	                {name: 'Quebec', abbreviation: 'QC'},
	                {name: 'Saskatchewan', abbreviation: 'SK'},
	
	                // The case could be made that the following are not actually provinces
	                // since they are technically considered "territories" however they all
	                // look the same on an envelope!
	                {name: 'Northwest Territories', abbreviation: 'NT'},
	                {name: 'Nunavut', abbreviation: 'NU'},
	                {name: 'Yukon', abbreviation: 'YT'}
	            ],
	            "it": [
	                { name: "Agrigento", abbreviation: "AG", code: 84 },
	                { name: "Alessandria", abbreviation: "AL", code: 6 },
	                { name: "Ancona", abbreviation: "AN", code: 42 },
	                { name: "Aosta", abbreviation: "AO", code: 7 },
	                { name: "L'Aquila", abbreviation: "AQ", code: 66 },
	                { name: "Arezzo", abbreviation: "AR", code: 51 },
	                { name: "Ascoli-Piceno", abbreviation: "AP", code: 44 },
	                { name: "Asti", abbreviation: "AT", code: 5 },
	                { name: "Avellino", abbreviation: "AV", code: 64 },
	                { name: "Bari", abbreviation: "BA", code: 72 },
	                { name: "Barletta-Andria-Trani", abbreviation: "BT", code: 72 },
	                { name: "Belluno", abbreviation: "BL", code: 25 },
	                { name: "Benevento", abbreviation: "BN", code: 62 },
	                { name: "Bergamo", abbreviation: "BG", code: 16 },
	                { name: "Biella", abbreviation: "BI", code: 96 },
	                { name: "Bologna", abbreviation: "BO", code: 37 },
	                { name: "Bolzano", abbreviation: "BZ", code: 21 },
	                { name: "Brescia", abbreviation: "BS", code: 17 },
	                { name: "Brindisi", abbreviation: "BR", code: 74 },
	                { name: "Cagliari", abbreviation: "CA", code: 92 },
	                { name: "Caltanissetta", abbreviation: "CL", code: 85 },
	                { name: "Campobasso", abbreviation: "CB", code: 70 },
	                { name: "Carbonia Iglesias", abbreviation: "CI", code: 70 },
	                { name: "Caserta", abbreviation: "CE", code: 61 },
	                { name: "Catania", abbreviation: "CT", code: 87 },
	                { name: "Catanzaro", abbreviation: "CZ", code: 79 },
	                { name: "Chieti", abbreviation: "CH", code: 69 },
	                { name: "Como", abbreviation: "CO", code: 13 },
	                { name: "Cosenza", abbreviation: "CS", code: 78 },
	                { name: "Cremona", abbreviation: "CR", code: 19 },
	                { name: "Crotone", abbreviation: "KR", code: 101 },
	                { name: "Cuneo", abbreviation: "CN", code: 4 },
	                { name: "Enna", abbreviation: "EN", code: 86 },
	                { name: "Fermo", abbreviation: "FM", code: 86 },
	                { name: "Ferrara", abbreviation: "FE", code: 38 },
	                { name: "Firenze", abbreviation: "FI", code: 48 },
	                { name: "Foggia", abbreviation: "FG", code: 71 },
	                { name: "Forli-Cesena", abbreviation: "FC", code: 71 },
	                { name: "Frosinone", abbreviation: "FR", code: 60 },
	                { name: "Genova", abbreviation: "GE", code: 10 },
	                { name: "Gorizia", abbreviation: "GO", code: 31 },
	                { name: "Grosseto", abbreviation: "GR", code: 53 },
	                { name: "Imperia", abbreviation: "IM", code: 8 },
	                { name: "Isernia", abbreviation: "IS", code: 94 },
	                { name: "La-Spezia", abbreviation: "SP", code: 66 },
	                { name: "Latina", abbreviation: "LT", code: 59 },
	                { name: "Lecce", abbreviation: "LE", code: 75 },
	                { name: "Lecco", abbreviation: "LC", code: 97 },
	                { name: "Livorno", abbreviation: "LI", code: 49 },
	                { name: "Lodi", abbreviation: "LO", code: 98 },
	                { name: "Lucca", abbreviation: "LU", code: 46 },
	                { name: "Macerata", abbreviation: "MC", code: 43 },
	                { name: "Mantova", abbreviation: "MN", code: 20 },
	                { name: "Massa-Carrara", abbreviation: "MS", code: 45 },
	                { name: "Matera", abbreviation: "MT", code: 77 },
	                { name: "Medio Campidano", abbreviation: "VS", code: 77 },
	                { name: "Messina", abbreviation: "ME", code: 83 },
	                { name: "Milano", abbreviation: "MI", code: 15 },
	                { name: "Modena", abbreviation: "MO", code: 36 },
	                { name: "Monza-Brianza", abbreviation: "MB", code: 36 },
	                { name: "Napoli", abbreviation: "NA", code: 63 },
	                { name: "Novara", abbreviation: "NO", code: 3 },
	                { name: "Nuoro", abbreviation: "NU", code: 91 },
	                { name: "Ogliastra", abbreviation: "OG", code: 91 },
	                { name: "Olbia Tempio", abbreviation: "OT", code: 91 },
	                { name: "Oristano", abbreviation: "OR", code: 95 },
	                { name: "Padova", abbreviation: "PD", code: 28 },
	                { name: "Palermo", abbreviation: "PA", code: 82 },
	                { name: "Parma", abbreviation: "PR", code: 34 },
	                { name: "Pavia", abbreviation: "PV", code: 18 },
	                { name: "Perugia", abbreviation: "PG", code: 54 },
	                { name: "Pesaro-Urbino", abbreviation: "PU", code: 41 },
	                { name: "Pescara", abbreviation: "PE", code: 68 },
	                { name: "Piacenza", abbreviation: "PC", code: 33 },
	                { name: "Pisa", abbreviation: "PI", code: 50 },
	                { name: "Pistoia", abbreviation: "PT", code: 47 },
	                { name: "Pordenone", abbreviation: "PN", code: 93 },
	                { name: "Potenza", abbreviation: "PZ", code: 76 },
	                { name: "Prato", abbreviation: "PO", code: 100 },
	                { name: "Ragusa", abbreviation: "RG", code: 88 },
	                { name: "Ravenna", abbreviation: "RA", code: 39 },
	                { name: "Reggio-Calabria", abbreviation: "RC", code: 35 },
	                { name: "Reggio-Emilia", abbreviation: "RE", code: 35 },
	                { name: "Rieti", abbreviation: "RI", code: 57 },
	                { name: "Rimini", abbreviation: "RN", code: 99 },
	                { name: "Roma", abbreviation: "Roma", code: 58 },
	                { name: "Rovigo", abbreviation: "RO", code: 29 },
	                { name: "Salerno", abbreviation: "SA", code: 65 },
	                { name: "Sassari", abbreviation: "SS", code: 90 },
	                { name: "Savona", abbreviation: "SV", code: 9 },
	                { name: "Siena", abbreviation: "SI", code: 52 },
	                { name: "Siracusa", abbreviation: "SR", code: 89 },
	                { name: "Sondrio", abbreviation: "SO", code: 14 },
	                { name: "Taranto", abbreviation: "TA", code: 73 },
	                { name: "Teramo", abbreviation: "TE", code: 67 },
	                { name: "Terni", abbreviation: "TR", code: 55 },
	                { name: "Torino", abbreviation: "TO", code: 1 },
	                { name: "Trapani", abbreviation: "TP", code: 81 },
	                { name: "Trento", abbreviation: "TN", code: 22 },
	                { name: "Treviso", abbreviation: "TV", code: 26 },
	                { name: "Trieste", abbreviation: "TS", code: 32 },
	                { name: "Udine", abbreviation: "UD", code: 30 },
	                { name: "Varese", abbreviation: "VA", code: 12 },
	                { name: "Venezia", abbreviation: "VE", code: 27 },
	                { name: "Verbania", abbreviation: "VB", code: 27 },
	                { name: "Vercelli", abbreviation: "VC", code: 2 },
	                { name: "Verona", abbreviation: "VR", code: 23 },
	                { name: "Vibo-Valentia", abbreviation: "VV", code: 102 },
	                { name: "Vicenza", abbreviation: "VI", code: 24 },
	                { name: "Viterbo", abbreviation: "VT", code: 56 }
	            ]
	        },
	
	            // from: https://github.com/samsargent/Useful-Autocomplete-Data/blob/master/data/nationalities.json
	        nationalities: [
	           {name: 'Afghan'},
	           {name: 'Albanian'},
	           {name: 'Algerian'},
	           {name: 'American'},
	           {name: 'Andorran'},
	           {name: 'Angolan'},
	           {name: 'Antiguans'},
	           {name: 'Argentinean'},
	           {name: 'Armenian'},
	           {name: 'Australian'},
	           {name: 'Austrian'},
	           {name: 'Azerbaijani'},
	           {name: 'Bahami'},
	           {name: 'Bahraini'},
	           {name: 'Bangladeshi'},
	           {name: 'Barbadian'},
	           {name: 'Barbudans'},
	           {name: 'Batswana'},
	           {name: 'Belarusian'},
	           {name: 'Belgian'},
	           {name: 'Belizean'},
	           {name: 'Beninese'},
	           {name: 'Bhutanese'},
	           {name: 'Bolivian'},
	           {name: 'Bosnian'},
	           {name: 'Brazilian'},
	           {name: 'British'},
	           {name: 'Bruneian'},
	           {name: 'Bulgarian'},
	           {name: 'Burkinabe'},
	           {name: 'Burmese'},
	           {name: 'Burundian'},
	           {name: 'Cambodian'},
	           {name: 'Cameroonian'},
	           {name: 'Canadian'},
	           {name: 'Cape Verdean'},
	           {name: 'Central African'},
	           {name: 'Chadian'},
	           {name: 'Chilean'},
	           {name: 'Chinese'},
	           {name: 'Colombian'},
	           {name: 'Comoran'},
	           {name: 'Congolese'},
	           {name: 'Costa Rican'},
	           {name: 'Croatian'},
	           {name: 'Cuban'},
	           {name: 'Cypriot'},
	           {name: 'Czech'},
	           {name: 'Danish'},
	           {name: 'Djibouti'},
	           {name: 'Dominican'},
	           {name: 'Dutch'},
	           {name: 'East Timorese'},
	           {name: 'Ecuadorean'},
	           {name: 'Egyptian'},
	           {name: 'Emirian'},
	           {name: 'Equatorial Guinean'},
	           {name: 'Eritrean'},
	           {name: 'Estonian'},
	           {name: 'Ethiopian'},
	           {name: 'Fijian'},
	           {name: 'Filipino'},
	           {name: 'Finnish'},
	           {name: 'French'},
	           {name: 'Gabonese'},
	           {name: 'Gambian'},
	           {name: 'Georgian'},
	           {name: 'German'},
	           {name: 'Ghanaian'},
	           {name: 'Greek'},
	           {name: 'Grenadian'},
	           {name: 'Guatemalan'},
	           {name: 'Guinea-Bissauan'},
	           {name: 'Guinean'},
	           {name: 'Guyanese'},
	           {name: 'Haitian'},
	           {name: 'Herzegovinian'},
	           {name: 'Honduran'},
	           {name: 'Hungarian'},
	           {name: 'I-Kiribati'},
	           {name: 'Icelander'},
	           {name: 'Indian'},
	           {name: 'Indonesian'},
	           {name: 'Iranian'},
	           {name: 'Iraqi'},
	           {name: 'Irish'},
	           {name: 'Israeli'},
	           {name: 'Italian'},
	           {name: 'Ivorian'},
	           {name: 'Jamaican'},
	           {name: 'Japanese'},
	           {name: 'Jordanian'},
	           {name: 'Kazakhstani'},
	           {name: 'Kenyan'},
	           {name: 'Kittian and Nevisian'},
	           {name: 'Kuwaiti'},
	           {name: 'Kyrgyz'},
	           {name: 'Laotian'},
	           {name: 'Latvian'},
	           {name: 'Lebanese'},
	           {name: 'Liberian'},
	           {name: 'Libyan'},
	           {name: 'Liechtensteiner'},
	           {name: 'Lithuanian'},
	           {name: 'Luxembourger'},
	           {name: 'Macedonian'},
	           {name: 'Malagasy'},
	           {name: 'Malawian'},
	           {name: 'Malaysian'},
	           {name: 'Maldivan'},
	           {name: 'Malian'},
	           {name: 'Maltese'},
	           {name: 'Marshallese'},
	           {name: 'Mauritanian'},
	           {name: 'Mauritian'},
	           {name: 'Mexican'},
	           {name: 'Micronesian'},
	           {name: 'Moldovan'},
	           {name: 'Monacan'},
	           {name: 'Mongolian'},
	           {name: 'Moroccan'},
	           {name: 'Mosotho'},
	           {name: 'Motswana'},
	           {name: 'Mozambican'},
	           {name: 'Namibian'},
	           {name: 'Nauruan'},
	           {name: 'Nepalese'},
	           {name: 'New Zealander'},
	           {name: 'Nicaraguan'},
	           {name: 'Nigerian'},
	           {name: 'Nigerien'},
	           {name: 'North Korean'},
	           {name: 'Northern Irish'},
	           {name: 'Norwegian'},
	           {name: 'Omani'},
	           {name: 'Pakistani'},
	           {name: 'Palauan'},
	           {name: 'Panamanian'},
	           {name: 'Papua New Guinean'},
	           {name: 'Paraguayan'},
	           {name: 'Peruvian'},
	           {name: 'Polish'},
	           {name: 'Portuguese'},
	           {name: 'Qatari'},
	           {name: 'Romani'},
	           {name: 'Russian'},
	           {name: 'Rwandan'},
	           {name: 'Saint Lucian'},
	           {name: 'Salvadoran'},
	           {name: 'Samoan'},
	           {name: 'San Marinese'},
	           {name: 'Sao Tomean'},
	           {name: 'Saudi'},
	           {name: 'Scottish'},
	           {name: 'Senegalese'},
	           {name: 'Serbian'},
	           {name: 'Seychellois'},
	           {name: 'Sierra Leonean'},
	           {name: 'Singaporean'},
	           {name: 'Slovakian'},
	           {name: 'Slovenian'},
	           {name: 'Solomon Islander'},
	           {name: 'Somali'},
	           {name: 'South African'},
	           {name: 'South Korean'},
	           {name: 'Spanish'},
	           {name: 'Sri Lankan'},
	           {name: 'Sudanese'},
	           {name: 'Surinamer'},
	           {name: 'Swazi'},
	           {name: 'Swedish'},
	           {name: 'Swiss'},
	           {name: 'Syrian'},
	           {name: 'Taiwanese'},
	           {name: 'Tajik'},
	           {name: 'Tanzanian'},
	           {name: 'Thai'},
	           {name: 'Togolese'},
	           {name: 'Tongan'},
	           {name: 'Trinidadian or Tobagonian'},
	           {name: 'Tunisian'},
	           {name: 'Turkish'},
	           {name: 'Tuvaluan'},
	           {name: 'Ugandan'},
	           {name: 'Ukrainian'},
	           {name: 'Uruguaya'},
	           {name: 'Uzbekistani'},
	           {name: 'Venezuela'},
	           {name: 'Vietnamese'},
	           {name: 'Wels'},
	           {name: 'Yemenit'},
	           {name: 'Zambia'},
	           {name: 'Zimbabwe'},
	        ],
	
	        us_states_and_dc: [
	            {name: 'Alabama', abbreviation: 'AL'},
	            {name: 'Alaska', abbreviation: 'AK'},
	            {name: 'Arizona', abbreviation: 'AZ'},
	            {name: 'Arkansas', abbreviation: 'AR'},
	            {name: 'California', abbreviation: 'CA'},
	            {name: 'Colorado', abbreviation: 'CO'},
	            {name: 'Connecticut', abbreviation: 'CT'},
	            {name: 'Delaware', abbreviation: 'DE'},
	            {name: 'District of Columbia', abbreviation: 'DC'},
	            {name: 'Florida', abbreviation: 'FL'},
	            {name: 'Georgia', abbreviation: 'GA'},
	            {name: 'Hawaii', abbreviation: 'HI'},
	            {name: 'Idaho', abbreviation: 'ID'},
	            {name: 'Illinois', abbreviation: 'IL'},
	            {name: 'Indiana', abbreviation: 'IN'},
	            {name: 'Iowa', abbreviation: 'IA'},
	            {name: 'Kansas', abbreviation: 'KS'},
	            {name: 'Kentucky', abbreviation: 'KY'},
	            {name: 'Louisiana', abbreviation: 'LA'},
	            {name: 'Maine', abbreviation: 'ME'},
	            {name: 'Maryland', abbreviation: 'MD'},
	            {name: 'Massachusetts', abbreviation: 'MA'},
	            {name: 'Michigan', abbreviation: 'MI'},
	            {name: 'Minnesota', abbreviation: 'MN'},
	            {name: 'Mississippi', abbreviation: 'MS'},
	            {name: 'Missouri', abbreviation: 'MO'},
	            {name: 'Montana', abbreviation: 'MT'},
	            {name: 'Nebraska', abbreviation: 'NE'},
	            {name: 'Nevada', abbreviation: 'NV'},
	            {name: 'New Hampshire', abbreviation: 'NH'},
	            {name: 'New Jersey', abbreviation: 'NJ'},
	            {name: 'New Mexico', abbreviation: 'NM'},
	            {name: 'New York', abbreviation: 'NY'},
	            {name: 'North Carolina', abbreviation: 'NC'},
	            {name: 'North Dakota', abbreviation: 'ND'},
	            {name: 'Ohio', abbreviation: 'OH'},
	            {name: 'Oklahoma', abbreviation: 'OK'},
	            {name: 'Oregon', abbreviation: 'OR'},
	            {name: 'Pennsylvania', abbreviation: 'PA'},
	            {name: 'Rhode Island', abbreviation: 'RI'},
	            {name: 'South Carolina', abbreviation: 'SC'},
	            {name: 'South Dakota', abbreviation: 'SD'},
	            {name: 'Tennessee', abbreviation: 'TN'},
	            {name: 'Texas', abbreviation: 'TX'},
	            {name: 'Utah', abbreviation: 'UT'},
	            {name: 'Vermont', abbreviation: 'VT'},
	            {name: 'Virginia', abbreviation: 'VA'},
	            {name: 'Washington', abbreviation: 'WA'},
	            {name: 'West Virginia', abbreviation: 'WV'},
	            {name: 'Wisconsin', abbreviation: 'WI'},
	            {name: 'Wyoming', abbreviation: 'WY'}
	        ],
	
	        territories: [
	            {name: 'American Samoa', abbreviation: 'AS'},
	            {name: 'Federated States of Micronesia', abbreviation: 'FM'},
	            {name: 'Guam', abbreviation: 'GU'},
	            {name: 'Marshall Islands', abbreviation: 'MH'},
	            {name: 'Northern Mariana Islands', abbreviation: 'MP'},
	            {name: 'Puerto Rico', abbreviation: 'PR'},
	            {name: 'Virgin Islands, U.S.', abbreviation: 'VI'}
	        ],
	
	        armed_forces: [
	            {name: 'Armed Forces Europe', abbreviation: 'AE'},
	            {name: 'Armed Forces Pacific', abbreviation: 'AP'},
	            {name: 'Armed Forces the Americas', abbreviation: 'AA'}
	        ],
	
	        country_regions: {
	            it: [
	                { name: "Valle d'Aosta", abbreviation: "VDA" },
	                { name: "Piemonte", abbreviation: "PIE" },
	                { name: "Lombardia", abbreviation: "LOM" },
	                { name: "Veneto", abbreviation: "VEN" },
	                { name: "Trentino Alto Adige", abbreviation: "TAA" },
	                { name: "Friuli Venezia Giulia", abbreviation: "FVG" },
	                { name: "Liguria", abbreviation: "LIG" },
	                { name: "Emilia Romagna", abbreviation: "EMR" },
	                { name: "Toscana", abbreviation: "TOS" },
	                { name: "Umbria", abbreviation: "UMB" },
	                { name: "Marche", abbreviation: "MAR" },
	                { name: "Abruzzo", abbreviation: "ABR" },
	                { name: "Lazio", abbreviation: "LAZ" },
	                { name: "Campania", abbreviation: "CAM" },
	                { name: "Puglia", abbreviation: "PUG" },
	                { name: "Basilicata", abbreviation: "BAS" },
	                { name: "Molise", abbreviation: "MOL" },
	                { name: "Calabria", abbreviation: "CAL" },
	                { name: "Sicilia", abbreviation: "SIC" },
	                { name: "Sardegna", abbreviation: "SAR" }
	            ]
	        },
	
	        street_suffixes: {
	            'us': [
	                {name: 'Avenue', abbreviation: 'Ave'},
	                {name: 'Boulevard', abbreviation: 'Blvd'},
	                {name: 'Center', abbreviation: 'Ctr'},
	                {name: 'Circle', abbreviation: 'Cir'},
	                {name: 'Court', abbreviation: 'Ct'},
	                {name: 'Drive', abbreviation: 'Dr'},
	                {name: 'Extension', abbreviation: 'Ext'},
	                {name: 'Glen', abbreviation: 'Gln'},
	                {name: 'Grove', abbreviation: 'Grv'},
	                {name: 'Heights', abbreviation: 'Hts'},
	                {name: 'Highway', abbreviation: 'Hwy'},
	                {name: 'Junction', abbreviation: 'Jct'},
	                {name: 'Key', abbreviation: 'Key'},
	                {name: 'Lane', abbreviation: 'Ln'},
	                {name: 'Loop', abbreviation: 'Loop'},
	                {name: 'Manor', abbreviation: 'Mnr'},
	                {name: 'Mill', abbreviation: 'Mill'},
	                {name: 'Park', abbreviation: 'Park'},
	                {name: 'Parkway', abbreviation: 'Pkwy'},
	                {name: 'Pass', abbreviation: 'Pass'},
	                {name: 'Path', abbreviation: 'Path'},
	                {name: 'Pike', abbreviation: 'Pike'},
	                {name: 'Place', abbreviation: 'Pl'},
	                {name: 'Plaza', abbreviation: 'Plz'},
	                {name: 'Point', abbreviation: 'Pt'},
	                {name: 'Ridge', abbreviation: 'Rdg'},
	                {name: 'River', abbreviation: 'Riv'},
	                {name: 'Road', abbreviation: 'Rd'},
	                {name: 'Square', abbreviation: 'Sq'},
	                {name: 'Street', abbreviation: 'St'},
	                {name: 'Terrace', abbreviation: 'Ter'},
	                {name: 'Trail', abbreviation: 'Trl'},
	                {name: 'Turnpike', abbreviation: 'Tpke'},
	                {name: 'View', abbreviation: 'Vw'},
	                {name: 'Way', abbreviation: 'Way'}
	            ],
	            'it': [
	                { name: 'Accesso', abbreviation: 'Acc.' },
	                { name: 'Alzaia', abbreviation: 'Alz.' },
	                { name: 'Arco', abbreviation: 'Arco' },
	                { name: 'Archivolto', abbreviation: 'Acv.' },
	                { name: 'Arena', abbreviation: 'Arena' },
	                { name: 'Argine', abbreviation: 'Argine' },
	                { name: 'Bacino', abbreviation: 'Bacino' },
	                { name: 'Banchi', abbreviation: 'Banchi' },
	                { name: 'Banchina', abbreviation: 'Ban.' },
	                { name: 'Bastioni', abbreviation: 'Bas.' },
	                { name: 'Belvedere', abbreviation: 'Belv.' },
	                { name: 'Borgata', abbreviation: 'B.ta' },
	                { name: 'Borgo', abbreviation: 'B.go' },
	                { name: 'Calata', abbreviation: 'Cal.' },
	                { name: 'Calle', abbreviation: 'Calle' },
	                { name: 'Campiello', abbreviation: 'Cam.' },
	                { name: 'Campo', abbreviation: 'Cam.' },
	                { name: 'Canale', abbreviation: 'Can.' },
	                { name: 'Carraia', abbreviation: 'Carr.' },
	                { name: 'Cascina', abbreviation: 'Cascina' },
	                { name: 'Case sparse', abbreviation: 'c.s.' },
	                { name: 'Cavalcavia', abbreviation: 'Cv.' },
	                { name: 'Circonvallazione', abbreviation: 'Cv.' },
	                { name: 'Complanare', abbreviation: 'C.re' },
	                { name: 'Contrada', abbreviation: 'C.da' },
	                { name: 'Corso', abbreviation: 'C.so' },
	                { name: 'Corte', abbreviation: 'C.te' },
	                { name: 'Cortile', abbreviation: 'C.le' },
	                { name: 'Diramazione', abbreviation: 'Dir.' },
	                { name: 'Fondaco', abbreviation: 'F.co' },
	                { name: 'Fondamenta', abbreviation: 'F.ta' },
	                { name: 'Fondo', abbreviation: 'F.do' },
	                { name: 'Frazione', abbreviation: 'Fr.' },
	                { name: 'Isola', abbreviation: 'Is.' },
	                { name: 'Largo', abbreviation: 'L.go' },
	                { name: 'Litoranea', abbreviation: 'Lit.' },
	                { name: 'Lungolago', abbreviation: 'L.go lago' },
	                { name: 'Lungo Po', abbreviation: 'l.go Po' },
	                { name: 'Molo', abbreviation: 'Molo' },
	                { name: 'Mura', abbreviation: 'Mura' },
	                { name: 'Passaggio privato', abbreviation: 'pass. priv.' },
	                { name: 'Passeggiata', abbreviation: 'Pass.' },
	                { name: 'Piazza', abbreviation: 'P.zza' },
	                { name: 'Piazzale', abbreviation: 'P.le' },
	                { name: 'Ponte', abbreviation: 'P.te' },
	                { name: 'Portico', abbreviation: 'P.co' },
	                { name: 'Rampa', abbreviation: 'Rampa' },
	                { name: 'Regione', abbreviation: 'Reg.' },
	                { name: 'Rione', abbreviation: 'R.ne' },
	                { name: 'Rio', abbreviation: 'Rio' },
	                { name: 'Ripa', abbreviation: 'Ripa' },
	                { name: 'Riva', abbreviation: 'Riva' },
	                { name: 'Rondò', abbreviation: 'Rondò' },
	                { name: 'Rotonda', abbreviation: 'Rot.' },
	                { name: 'Sagrato', abbreviation: 'Sagr.' },
	                { name: 'Salita', abbreviation: 'Sal.' },
	                { name: 'Scalinata', abbreviation: 'Scal.' },
	                { name: 'Scalone', abbreviation: 'Scal.' },
	                { name: 'Slargo', abbreviation: 'Sl.' },
	                { name: 'Sottoportico', abbreviation: 'Sott.' },
	                { name: 'Strada', abbreviation: 'Str.' },
	                { name: 'Stradale', abbreviation: 'Str.le' },
	                { name: 'Strettoia', abbreviation: 'Strett.' },
	                { name: 'Traversa', abbreviation: 'Trav.' },
	                { name: 'Via', abbreviation: 'V.' },
	                { name: 'Viale', abbreviation: 'V.le' },
	                { name: 'Vicinale', abbreviation: 'Vic.le' },
	                { name: 'Vicolo', abbreviation: 'Vic.' }
	            ]
	        },
	
	        months: [
	            {name: 'January', short_name: 'Jan', numeric: '01', days: 31},
	            // Not messing with leap years...
	            {name: 'February', short_name: 'Feb', numeric: '02', days: 28},
	            {name: 'March', short_name: 'Mar', numeric: '03', days: 31},
	            {name: 'April', short_name: 'Apr', numeric: '04', days: 30},
	            {name: 'May', short_name: 'May', numeric: '05', days: 31},
	            {name: 'June', short_name: 'Jun', numeric: '06', days: 30},
	            {name: 'July', short_name: 'Jul', numeric: '07', days: 31},
	            {name: 'August', short_name: 'Aug', numeric: '08', days: 31},
	            {name: 'September', short_name: 'Sep', numeric: '09', days: 30},
	            {name: 'October', short_name: 'Oct', numeric: '10', days: 31},
	            {name: 'November', short_name: 'Nov', numeric: '11', days: 30},
	            {name: 'December', short_name: 'Dec', numeric: '12', days: 31}
	        ],
	
	        // http://en.wikipedia.org/wiki/Bank_card_number#Issuer_identification_number_.28IIN.29
	        cc_types: [
	            {name: "American Express", short_name: 'amex', prefix: '34', length: 15},
	            {name: "Bankcard", short_name: 'bankcard', prefix: '5610', length: 16},
	            {name: "China UnionPay", short_name: 'chinaunion', prefix: '62', length: 16},
	            {name: "Diners Club Carte Blanche", short_name: 'dccarte', prefix: '300', length: 14},
	            {name: "Diners Club enRoute", short_name: 'dcenroute', prefix: '2014', length: 15},
	            {name: "Diners Club International", short_name: 'dcintl', prefix: '36', length: 14},
	            {name: "Diners Club United States & Canada", short_name: 'dcusc', prefix: '54', length: 16},
	            {name: "Discover Card", short_name: 'discover', prefix: '6011', length: 16},
	            {name: "InstaPayment", short_name: 'instapay', prefix: '637', length: 16},
	            {name: "JCB", short_name: 'jcb', prefix: '3528', length: 16},
	            {name: "Laser", short_name: 'laser', prefix: '6304', length: 16},
	            {name: "Maestro", short_name: 'maestro', prefix: '5018', length: 16},
	            {name: "Mastercard", short_name: 'mc', prefix: '51', length: 16},
	            {name: "Solo", short_name: 'solo', prefix: '6334', length: 16},
	            {name: "Switch", short_name: 'switch', prefix: '4903', length: 16},
	            {name: "Visa", short_name: 'visa', prefix: '4', length: 16},
	            {name: "Visa Electron", short_name: 'electron', prefix: '4026', length: 16}
	        ],
	
	        //return all world currency by ISO 4217
	        currency_types: [
	            {'code' : 'AED', 'name' : 'United Arab Emirates Dirham'},
	            {'code' : 'AFN', 'name' : 'Afghanistan Afghani'},
	            {'code' : 'ALL', 'name' : 'Albania Lek'},
	            {'code' : 'AMD', 'name' : 'Armenia Dram'},
	            {'code' : 'ANG', 'name' : 'Netherlands Antilles Guilder'},
	            {'code' : 'AOA', 'name' : 'Angola Kwanza'},
	            {'code' : 'ARS', 'name' : 'Argentina Peso'},
	            {'code' : 'AUD', 'name' : 'Australia Dollar'},
	            {'code' : 'AWG', 'name' : 'Aruba Guilder'},
	            {'code' : 'AZN', 'name' : 'Azerbaijan New Manat'},
	            {'code' : 'BAM', 'name' : 'Bosnia and Herzegovina Convertible Marka'},
	            {'code' : 'BBD', 'name' : 'Barbados Dollar'},
	            {'code' : 'BDT', 'name' : 'Bangladesh Taka'},
	            {'code' : 'BGN', 'name' : 'Bulgaria Lev'},
	            {'code' : 'BHD', 'name' : 'Bahrain Dinar'},
	            {'code' : 'BIF', 'name' : 'Burundi Franc'},
	            {'code' : 'BMD', 'name' : 'Bermuda Dollar'},
	            {'code' : 'BND', 'name' : 'Brunei Darussalam Dollar'},
	            {'code' : 'BOB', 'name' : 'Bolivia Boliviano'},
	            {'code' : 'BRL', 'name' : 'Brazil Real'},
	            {'code' : 'BSD', 'name' : 'Bahamas Dollar'},
	            {'code' : 'BTN', 'name' : 'Bhutan Ngultrum'},
	            {'code' : 'BWP', 'name' : 'Botswana Pula'},
	            {'code' : 'BYR', 'name' : 'Belarus Ruble'},
	            {'code' : 'BZD', 'name' : 'Belize Dollar'},
	            {'code' : 'CAD', 'name' : 'Canada Dollar'},
	            {'code' : 'CDF', 'name' : 'Congo/Kinshasa Franc'},
	            {'code' : 'CHF', 'name' : 'Switzerland Franc'},
	            {'code' : 'CLP', 'name' : 'Chile Peso'},
	            {'code' : 'CNY', 'name' : 'China Yuan Renminbi'},
	            {'code' : 'COP', 'name' : 'Colombia Peso'},
	            {'code' : 'CRC', 'name' : 'Costa Rica Colon'},
	            {'code' : 'CUC', 'name' : 'Cuba Convertible Peso'},
	            {'code' : 'CUP', 'name' : 'Cuba Peso'},
	            {'code' : 'CVE', 'name' : 'Cape Verde Escudo'},
	            {'code' : 'CZK', 'name' : 'Czech Republic Koruna'},
	            {'code' : 'DJF', 'name' : 'Djibouti Franc'},
	            {'code' : 'DKK', 'name' : 'Denmark Krone'},
	            {'code' : 'DOP', 'name' : 'Dominican Republic Peso'},
	            {'code' : 'DZD', 'name' : 'Algeria Dinar'},
	            {'code' : 'EGP', 'name' : 'Egypt Pound'},
	            {'code' : 'ERN', 'name' : 'Eritrea Nakfa'},
	            {'code' : 'ETB', 'name' : 'Ethiopia Birr'},
	            {'code' : 'EUR', 'name' : 'Euro Member Countries'},
	            {'code' : 'FJD', 'name' : 'Fiji Dollar'},
	            {'code' : 'FKP', 'name' : 'Falkland Islands (Malvinas) Pound'},
	            {'code' : 'GBP', 'name' : 'United Kingdom Pound'},
	            {'code' : 'GEL', 'name' : 'Georgia Lari'},
	            {'code' : 'GGP', 'name' : 'Guernsey Pound'},
	            {'code' : 'GHS', 'name' : 'Ghana Cedi'},
	            {'code' : 'GIP', 'name' : 'Gibraltar Pound'},
	            {'code' : 'GMD', 'name' : 'Gambia Dalasi'},
	            {'code' : 'GNF', 'name' : 'Guinea Franc'},
	            {'code' : 'GTQ', 'name' : 'Guatemala Quetzal'},
	            {'code' : 'GYD', 'name' : 'Guyana Dollar'},
	            {'code' : 'HKD', 'name' : 'Hong Kong Dollar'},
	            {'code' : 'HNL', 'name' : 'Honduras Lempira'},
	            {'code' : 'HRK', 'name' : 'Croatia Kuna'},
	            {'code' : 'HTG', 'name' : 'Haiti Gourde'},
	            {'code' : 'HUF', 'name' : 'Hungary Forint'},
	            {'code' : 'IDR', 'name' : 'Indonesia Rupiah'},
	            {'code' : 'ILS', 'name' : 'Israel Shekel'},
	            {'code' : 'IMP', 'name' : 'Isle of Man Pound'},
	            {'code' : 'INR', 'name' : 'India Rupee'},
	            {'code' : 'IQD', 'name' : 'Iraq Dinar'},
	            {'code' : 'IRR', 'name' : 'Iran Rial'},
	            {'code' : 'ISK', 'name' : 'Iceland Krona'},
	            {'code' : 'JEP', 'name' : 'Jersey Pound'},
	            {'code' : 'JMD', 'name' : 'Jamaica Dollar'},
	            {'code' : 'JOD', 'name' : 'Jordan Dinar'},
	            {'code' : 'JPY', 'name' : 'Japan Yen'},
	            {'code' : 'KES', 'name' : 'Kenya Shilling'},
	            {'code' : 'KGS', 'name' : 'Kyrgyzstan Som'},
	            {'code' : 'KHR', 'name' : 'Cambodia Riel'},
	            {'code' : 'KMF', 'name' : 'Comoros Franc'},
	            {'code' : 'KPW', 'name' : 'Korea (North) Won'},
	            {'code' : 'KRW', 'name' : 'Korea (South) Won'},
	            {'code' : 'KWD', 'name' : 'Kuwait Dinar'},
	            {'code' : 'KYD', 'name' : 'Cayman Islands Dollar'},
	            {'code' : 'KZT', 'name' : 'Kazakhstan Tenge'},
	            {'code' : 'LAK', 'name' : 'Laos Kip'},
	            {'code' : 'LBP', 'name' : 'Lebanon Pound'},
	            {'code' : 'LKR', 'name' : 'Sri Lanka Rupee'},
	            {'code' : 'LRD', 'name' : 'Liberia Dollar'},
	            {'code' : 'LSL', 'name' : 'Lesotho Loti'},
	            {'code' : 'LTL', 'name' : 'Lithuania Litas'},
	            {'code' : 'LYD', 'name' : 'Libya Dinar'},
	            {'code' : 'MAD', 'name' : 'Morocco Dirham'},
	            {'code' : 'MDL', 'name' : 'Moldova Leu'},
	            {'code' : 'MGA', 'name' : 'Madagascar Ariary'},
	            {'code' : 'MKD', 'name' : 'Macedonia Denar'},
	            {'code' : 'MMK', 'name' : 'Myanmar (Burma) Kyat'},
	            {'code' : 'MNT', 'name' : 'Mongolia Tughrik'},
	            {'code' : 'MOP', 'name' : 'Macau Pataca'},
	            {'code' : 'MRO', 'name' : 'Mauritania Ouguiya'},
	            {'code' : 'MUR', 'name' : 'Mauritius Rupee'},
	            {'code' : 'MVR', 'name' : 'Maldives (Maldive Islands) Rufiyaa'},
	            {'code' : 'MWK', 'name' : 'Malawi Kwacha'},
	            {'code' : 'MXN', 'name' : 'Mexico Peso'},
	            {'code' : 'MYR', 'name' : 'Malaysia Ringgit'},
	            {'code' : 'MZN', 'name' : 'Mozambique Metical'},
	            {'code' : 'NAD', 'name' : 'Namibia Dollar'},
	            {'code' : 'NGN', 'name' : 'Nigeria Naira'},
	            {'code' : 'NIO', 'name' : 'Nicaragua Cordoba'},
	            {'code' : 'NOK', 'name' : 'Norway Krone'},
	            {'code' : 'NPR', 'name' : 'Nepal Rupee'},
	            {'code' : 'NZD', 'name' : 'New Zealand Dollar'},
	            {'code' : 'OMR', 'name' : 'Oman Rial'},
	            {'code' : 'PAB', 'name' : 'Panama Balboa'},
	            {'code' : 'PEN', 'name' : 'Peru Nuevo Sol'},
	            {'code' : 'PGK', 'name' : 'Papua New Guinea Kina'},
	            {'code' : 'PHP', 'name' : 'Philippines Peso'},
	            {'code' : 'PKR', 'name' : 'Pakistan Rupee'},
	            {'code' : 'PLN', 'name' : 'Poland Zloty'},
	            {'code' : 'PYG', 'name' : 'Paraguay Guarani'},
	            {'code' : 'QAR', 'name' : 'Qatar Riyal'},
	            {'code' : 'RON', 'name' : 'Romania New Leu'},
	            {'code' : 'RSD', 'name' : 'Serbia Dinar'},
	            {'code' : 'RUB', 'name' : 'Russia Ruble'},
	            {'code' : 'RWF', 'name' : 'Rwanda Franc'},
	            {'code' : 'SAR', 'name' : 'Saudi Arabia Riyal'},
	            {'code' : 'SBD', 'name' : 'Solomon Islands Dollar'},
	            {'code' : 'SCR', 'name' : 'Seychelles Rupee'},
	            {'code' : 'SDG', 'name' : 'Sudan Pound'},
	            {'code' : 'SEK', 'name' : 'Sweden Krona'},
	            {'code' : 'SGD', 'name' : 'Singapore Dollar'},
	            {'code' : 'SHP', 'name' : 'Saint Helena Pound'},
	            {'code' : 'SLL', 'name' : 'Sierra Leone Leone'},
	            {'code' : 'SOS', 'name' : 'Somalia Shilling'},
	            {'code' : 'SPL', 'name' : 'Seborga Luigino'},
	            {'code' : 'SRD', 'name' : 'Suriname Dollar'},
	            {'code' : 'STD', 'name' : 'São Tomé and Príncipe Dobra'},
	            {'code' : 'SVC', 'name' : 'El Salvador Colon'},
	            {'code' : 'SYP', 'name' : 'Syria Pound'},
	            {'code' : 'SZL', 'name' : 'Swaziland Lilangeni'},
	            {'code' : 'THB', 'name' : 'Thailand Baht'},
	            {'code' : 'TJS', 'name' : 'Tajikistan Somoni'},
	            {'code' : 'TMT', 'name' : 'Turkmenistan Manat'},
	            {'code' : 'TND', 'name' : 'Tunisia Dinar'},
	            {'code' : 'TOP', 'name' : 'Tonga Pa\'anga'},
	            {'code' : 'TRY', 'name' : 'Turkey Lira'},
	            {'code' : 'TTD', 'name' : 'Trinidad and Tobago Dollar'},
	            {'code' : 'TVD', 'name' : 'Tuvalu Dollar'},
	            {'code' : 'TWD', 'name' : 'Taiwan New Dollar'},
	            {'code' : 'TZS', 'name' : 'Tanzania Shilling'},
	            {'code' : 'UAH', 'name' : 'Ukraine Hryvnia'},
	            {'code' : 'UGX', 'name' : 'Uganda Shilling'},
	            {'code' : 'USD', 'name' : 'United States Dollar'},
	            {'code' : 'UYU', 'name' : 'Uruguay Peso'},
	            {'code' : 'UZS', 'name' : 'Uzbekistan Som'},
	            {'code' : 'VEF', 'name' : 'Venezuela Bolivar'},
	            {'code' : 'VND', 'name' : 'Viet Nam Dong'},
	            {'code' : 'VUV', 'name' : 'Vanuatu Vatu'},
	            {'code' : 'WST', 'name' : 'Samoa Tala'},
	            {'code' : 'XAF', 'name' : 'Communauté Financière Africaine (BEAC) CFA Franc BEAC'},
	            {'code' : 'XCD', 'name' : 'East Caribbean Dollar'},
	            {'code' : 'XDR', 'name' : 'International Monetary Fund (IMF) Special Drawing Rights'},
	            {'code' : 'XOF', 'name' : 'Communauté Financière Africaine (BCEAO) Franc'},
	            {'code' : 'XPF', 'name' : 'Comptoirs Français du Pacifique (CFP) Franc'},
	            {'code' : 'YER', 'name' : 'Yemen Rial'},
	            {'code' : 'ZAR', 'name' : 'South Africa Rand'},
	            {'code' : 'ZMW', 'name' : 'Zambia Kwacha'},
	            {'code' : 'ZWD', 'name' : 'Zimbabwe Dollar'}
	        ],
	
	        // return the names of all valide colors
	        colorNames : [  "AliceBlue", "Black", "Navy", "DarkBlue", "MediumBlue", "Blue", "DarkGreen", "Green", "Teal", "DarkCyan", "DeepSkyBlue", "DarkTurquoise", "MediumSpringGreen", "Lime", "SpringGreen",
	            "Aqua", "Cyan", "MidnightBlue", "DodgerBlue", "LightSeaGreen", "ForestGreen", "SeaGreen", "DarkSlateGray", "LimeGreen", "MediumSeaGreen", "Turquoise", "RoyalBlue", "SteelBlue", "DarkSlateBlue", "MediumTurquoise",
	            "Indigo", "DarkOliveGreen", "CadetBlue", "CornflowerBlue", "RebeccaPurple", "MediumAquaMarine", "DimGray", "SlateBlue", "OliveDrab", "SlateGray", "LightSlateGray", "MediumSlateBlue", "LawnGreen", "Chartreuse",
	            "Aquamarine", "Maroon", "Purple", "Olive", "Gray", "SkyBlue", "LightSkyBlue", "BlueViolet", "DarkRed", "DarkMagenta", "SaddleBrown", "Ivory", "White",
	            "DarkSeaGreen", "LightGreen", "MediumPurple", "DarkViolet", "PaleGreen", "DarkOrchid", "YellowGreen", "Sienna", "Brown", "DarkGray", "LightBlue", "GreenYellow", "PaleTurquoise", "LightSteelBlue", "PowderBlue",
	            "FireBrick", "DarkGoldenRod", "MediumOrchid", "RosyBrown", "DarkKhaki", "Silver", "MediumVioletRed", "IndianRed", "Peru", "Chocolate", "Tan", "LightGray", "Thistle", "Orchid", "GoldenRod", "PaleVioletRed",
	            "Crimson", "Gainsboro", "Plum", "BurlyWood", "LightCyan", "Lavender", "DarkSalmon", "Violet", "PaleGoldenRod", "LightCoral", "Khaki", "AliceBlue", "HoneyDew", "Azure", "SandyBrown", "Wheat", "Beige", "WhiteSmoke",
	            "MintCream", "GhostWhite", "Salmon", "AntiqueWhite", "Linen", "LightGoldenRodYellow", "OldLace", "Red", "Fuchsia", "Magenta", "DeepPink", "OrangeRed", "Tomato", "HotPink", "Coral", "DarkOrange", "LightSalmon", "Orange",
	            "LightPink", "Pink", "Gold", "PeachPuff", "NavajoWhite", "Moccasin", "Bisque", "MistyRose", "BlanchedAlmond", "PapayaWhip", "LavenderBlush", "SeaShell", "Cornsilk", "LemonChiffon", "FloralWhite", "Snow", "Yellow", "LightYellow"
	        ],
	
	        fileExtension : {
	            "raster"    : ["bmp", "gif", "gpl", "ico", "jpeg", "psd", "png", "psp", "raw", "tiff"],
	            "vector"    : ["3dv", "amf", "awg", "ai", "cgm", "cdr", "cmx", "dxf", "e2d", "egt", "eps", "fs", "odg", "svg", "xar"],
	            "3d"        : ["3dmf", "3dm", "3mf", "3ds", "an8", "aoi", "blend", "cal3d", "cob", "ctm", "iob", "jas", "max", "mb", "mdx", "obj", "x", "x3d"],
	            "document"  : ["doc", "docx", "dot", "html", "xml", "odt", "odm", "ott", "csv", "rtf", "tex", "xhtml", "xps"]
	        },
	
	        // Data taken from https://github.com/dmfilipenko/timezones.json/blob/master/timezones.json
	        timezones: [
	                  {
	                    "name": "Dateline Standard Time",
	                    "abbr": "DST",
	                    "offset": -12,
	                    "isdst": false,
	                    "text": "(UTC-12:00) International Date Line West",
	                    "utc": [
	                      "Etc/GMT+12"
	                    ]
	                  },
	                  {
	                    "name": "UTC-11",
	                    "abbr": "U",
	                    "offset": -11,
	                    "isdst": false,
	                    "text": "(UTC-11:00) Coordinated Universal Time-11",
	                    "utc": [
	                      "Etc/GMT+11",
	                      "Pacific/Midway",
	                      "Pacific/Niue",
	                      "Pacific/Pago_Pago"
	                    ]
	                  },
	                  {
	                    "name": "Hawaiian Standard Time",
	                    "abbr": "HST",
	                    "offset": -10,
	                    "isdst": false,
	                    "text": "(UTC-10:00) Hawaii",
	                    "utc": [
	                      "Etc/GMT+10",
	                      "Pacific/Honolulu",
	                      "Pacific/Johnston",
	                      "Pacific/Rarotonga",
	                      "Pacific/Tahiti"
	                    ]
	                  },
	                  {
	                    "name": "Alaskan Standard Time",
	                    "abbr": "AKDT",
	                    "offset": -8,
	                    "isdst": true,
	                    "text": "(UTC-09:00) Alaska",
	                    "utc": [
	                      "America/Anchorage",
	                      "America/Juneau",
	                      "America/Nome",
	                      "America/Sitka",
	                      "America/Yakutat"
	                    ]
	                  },
	                  {
	                    "name": "Pacific Standard Time (Mexico)",
	                    "abbr": "PDT",
	                    "offset": -7,
	                    "isdst": true,
	                    "text": "(UTC-08:00) Baja California",
	                    "utc": [
	                      "America/Santa_Isabel"
	                    ]
	                  },
	                  {
	                    "name": "Pacific Standard Time",
	                    "abbr": "PDT",
	                    "offset": -7,
	                    "isdst": true,
	                    "text": "(UTC-08:00) Pacific Time (US & Canada)",
	                    "utc": [
	                      "America/Dawson",
	                      "America/Los_Angeles",
	                      "America/Tijuana",
	                      "America/Vancouver",
	                      "America/Whitehorse",
	                      "PST8PDT"
	                    ]
	                  },
	                  {
	                    "name": "US Mountain Standard Time",
	                    "abbr": "UMST",
	                    "offset": -7,
	                    "isdst": false,
	                    "text": "(UTC-07:00) Arizona",
	                    "utc": [
	                      "America/Creston",
	                      "America/Dawson_Creek",
	                      "America/Hermosillo",
	                      "America/Phoenix",
	                      "Etc/GMT+7"
	                    ]
	                  },
	                  {
	                    "name": "Mountain Standard Time (Mexico)",
	                    "abbr": "MDT",
	                    "offset": -6,
	                    "isdst": true,
	                    "text": "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
	                    "utc": [
	                      "America/Chihuahua",
	                      "America/Mazatlan"
	                    ]
	                  },
	                  {
	                    "name": "Mountain Standard Time",
	                    "abbr": "MDT",
	                    "offset": -6,
	                    "isdst": true,
	                    "text": "(UTC-07:00) Mountain Time (US & Canada)",
	                    "utc": [
	                      "America/Boise",
	                      "America/Cambridge_Bay",
	                      "America/Denver",
	                      "America/Edmonton",
	                      "America/Inuvik",
	                      "America/Ojinaga",
	                      "America/Yellowknife",
	                      "MST7MDT"
	                    ]
	                  },
	                  {
	                    "name": "Central America Standard Time",
	                    "abbr": "CAST",
	                    "offset": -6,
	                    "isdst": false,
	                    "text": "(UTC-06:00) Central America",
	                    "utc": [
	                      "America/Belize",
	                      "America/Costa_Rica",
	                      "America/El_Salvador",
	                      "America/Guatemala",
	                      "America/Managua",
	                      "America/Tegucigalpa",
	                      "Etc/GMT+6",
	                      "Pacific/Galapagos"
	                    ]
	                  },
	                  {
	                    "name": "Central Standard Time",
	                    "abbr": "CDT",
	                    "offset": -5,
	                    "isdst": true,
	                    "text": "(UTC-06:00) Central Time (US & Canada)",
	                    "utc": [
	                      "America/Chicago",
	                      "America/Indiana/Knox",
	                      "America/Indiana/Tell_City",
	                      "America/Matamoros",
	                      "America/Menominee",
	                      "America/North_Dakota/Beulah",
	                      "America/North_Dakota/Center",
	                      "America/North_Dakota/New_Salem",
	                      "America/Rainy_River",
	                      "America/Rankin_Inlet",
	                      "America/Resolute",
	                      "America/Winnipeg",
	                      "CST6CDT"
	                    ]
	                  },
	                  {
	                    "name": "Central Standard Time (Mexico)",
	                    "abbr": "CDT",
	                    "offset": -5,
	                    "isdst": true,
	                    "text": "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
	                    "utc": [
	                      "America/Bahia_Banderas",
	                      "America/Cancun",
	                      "America/Merida",
	                      "America/Mexico_City",
	                      "America/Monterrey"
	                    ]
	                  },
	                  {
	                    "name": "Canada Central Standard Time",
	                    "abbr": "CCST",
	                    "offset": -6,
	                    "isdst": false,
	                    "text": "(UTC-06:00) Saskatchewan",
	                    "utc": [
	                      "America/Regina",
	                      "America/Swift_Current"
	                    ]
	                  },
	                  {
	                    "name": "SA Pacific Standard Time",
	                    "abbr": "SPST",
	                    "offset": -5,
	                    "isdst": false,
	                    "text": "(UTC-05:00) Bogota, Lima, Quito",
	                    "utc": [
	                      "America/Bogota",
	                      "America/Cayman",
	                      "America/Coral_Harbour",
	                      "America/Eirunepe",
	                      "America/Guayaquil",
	                      "America/Jamaica",
	                      "America/Lima",
	                      "America/Panama",
	                      "America/Rio_Branco",
	                      "Etc/GMT+5"
	                    ]
	                  },
	                  {
	                    "name": "Eastern Standard Time",
	                    "abbr": "EDT",
	                    "offset": -4,
	                    "isdst": true,
	                    "text": "(UTC-05:00) Eastern Time (US & Canada)",
	                    "utc": [
	                      "America/Detroit",
	                      "America/Havana",
	                      "America/Indiana/Petersburg",
	                      "America/Indiana/Vincennes",
	                      "America/Indiana/Winamac",
	                      "America/Iqaluit",
	                      "America/Kentucky/Monticello",
	                      "America/Louisville",
	                      "America/Montreal",
	                      "America/Nassau",
	                      "America/New_York",
	                      "America/Nipigon",
	                      "America/Pangnirtung",
	                      "America/Port-au-Prince",
	                      "America/Thunder_Bay",
	                      "America/Toronto",
	                      "EST5EDT"
	                    ]
	                  },
	                  {
	                    "name": "US Eastern Standard Time",
	                    "abbr": "UEDT",
	                    "offset": -4,
	                    "isdst": true,
	                    "text": "(UTC-05:00) Indiana (East)",
	                    "utc": [
	                      "America/Indiana/Marengo",
	                      "America/Indiana/Vevay",
	                      "America/Indianapolis"
	                    ]
	                  },
	                  {
	                    "name": "Venezuela Standard Time",
	                    "abbr": "VST",
	                    "offset": -4.5,
	                    "isdst": false,
	                    "text": "(UTC-04:30) Caracas",
	                    "utc": [
	                      "America/Caracas"
	                    ]
	                  },
	                  {
	                    "name": "Paraguay Standard Time",
	                    "abbr": "PST",
	                    "offset": -4,
	                    "isdst": false,
	                    "text": "(UTC-04:00) Asuncion",
	                    "utc": [
	                      "America/Asuncion"
	                    ]
	                  },
	                  {
	                    "name": "Atlantic Standard Time",
	                    "abbr": "ADT",
	                    "offset": -3,
	                    "isdst": true,
	                    "text": "(UTC-04:00) Atlantic Time (Canada)",
	                    "utc": [
	                      "America/Glace_Bay",
	                      "America/Goose_Bay",
	                      "America/Halifax",
	                      "America/Moncton",
	                      "America/Thule",
	                      "Atlantic/Bermuda"
	                    ]
	                  },
	                  {
	                    "name": "Central Brazilian Standard Time",
	                    "abbr": "CBST",
	                    "offset": -4,
	                    "isdst": false,
	                    "text": "(UTC-04:00) Cuiaba",
	                    "utc": [
	                      "America/Campo_Grande",
	                      "America/Cuiaba"
	                    ]
	                  },
	                  {
	                    "name": "SA Western Standard Time",
	                    "abbr": "SWST",
	                    "offset": -4,
	                    "isdst": false,
	                    "text": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
	                    "utc": [
	                      "America/Anguilla",
	                      "America/Antigua",
	                      "America/Aruba",
	                      "America/Barbados",
	                      "America/Blanc-Sablon",
	                      "America/Boa_Vista",
	                      "America/Curacao",
	                      "America/Dominica",
	                      "America/Grand_Turk",
	                      "America/Grenada",
	                      "America/Guadeloupe",
	                      "America/Guyana",
	                      "America/Kralendijk",
	                      "America/La_Paz",
	                      "America/Lower_Princes",
	                      "America/Manaus",
	                      "America/Marigot",
	                      "America/Martinique",
	                      "America/Montserrat",
	                      "America/Port_of_Spain",
	                      "America/Porto_Velho",
	                      "America/Puerto_Rico",
	                      "America/Santo_Domingo",
	                      "America/St_Barthelemy",
	                      "America/St_Kitts",
	                      "America/St_Lucia",
	                      "America/St_Thomas",
	                      "America/St_Vincent",
	                      "America/Tortola",
	                      "Etc/GMT+4"
	                    ]
	                  },
	                  {
	                    "name": "Pacific SA Standard Time",
	                    "abbr": "PSST",
	                    "offset": -4,
	                    "isdst": false,
	                    "text": "(UTC-04:00) Santiago",
	                    "utc": [
	                      "America/Santiago",
	                      "Antarctica/Palmer"
	                    ]
	                  },
	                  {
	                    "name": "Newfoundland Standard Time",
	                    "abbr": "NDT",
	                    "offset": -2.5,
	                    "isdst": true,
	                    "text": "(UTC-03:30) Newfoundland",
	                    "utc": [
	                      "America/St_Johns"
	                    ]
	                  },
	                  {
	                    "name": "E. South America Standard Time",
	                    "abbr": "ESAST",
	                    "offset": -3,
	                    "isdst": false,
	                    "text": "(UTC-03:00) Brasilia",
	                    "utc": [
	                      "America/Sao_Paulo"
	                    ]
	                  },
	                  {
	                    "name": "Argentina Standard Time",
	                    "abbr": "AST",
	                    "offset": -3,
	                    "isdst": false,
	                    "text": "(UTC-03:00) Buenos Aires",
	                    "utc": [
	                      "America/Argentina/La_Rioja",
	                      "America/Argentina/Rio_Gallegos",
	                      "America/Argentina/Salta",
	                      "America/Argentina/San_Juan",
	                      "America/Argentina/San_Luis",
	                      "America/Argentina/Tucuman",
	                      "America/Argentina/Ushuaia",
	                      "America/Buenos_Aires",
	                      "America/Catamarca",
	                      "America/Cordoba",
	                      "America/Jujuy",
	                      "America/Mendoza"
	                    ]
	                  },
	                  {
	                    "name": "SA Eastern Standard Time",
	                    "abbr": "SEST",
	                    "offset": -3,
	                    "isdst": false,
	                    "text": "(UTC-03:00) Cayenne, Fortaleza",
	                    "utc": [
	                      "America/Araguaina",
	                      "America/Belem",
	                      "America/Cayenne",
	                      "America/Fortaleza",
	                      "America/Maceio",
	                      "America/Paramaribo",
	                      "America/Recife",
	                      "America/Santarem",
	                      "Antarctica/Rothera",
	                      "Atlantic/Stanley",
	                      "Etc/GMT+3"
	                    ]
	                  },
	                  {
	                    "name": "Greenland Standard Time",
	                    "abbr": "GDT",
	                    "offset": -2,
	                    "isdst": true,
	                    "text": "(UTC-03:00) Greenland",
	                    "utc": [
	                      "America/Godthab"
	                    ]
	                  },
	                  {
	                    "name": "Montevideo Standard Time",
	                    "abbr": "MST",
	                    "offset": -3,
	                    "isdst": false,
	                    "text": "(UTC-03:00) Montevideo",
	                    "utc": [
	                      "America/Montevideo"
	                    ]
	                  },
	                  {
	                    "name": "Bahia Standard Time",
	                    "abbr": "BST",
	                    "offset": -3,
	                    "isdst": false,
	                    "text": "(UTC-03:00) Salvador",
	                    "utc": [
	                      "America/Bahia"
	                    ]
	                  },
	                  {
	                    "name": "UTC-02",
	                    "abbr": "U",
	                    "offset": -2,
	                    "isdst": false,
	                    "text": "(UTC-02:00) Coordinated Universal Time-02",
	                    "utc": [
	                      "America/Noronha",
	                      "Atlantic/South_Georgia",
	                      "Etc/GMT+2"
	                    ]
	                  },
	                  {
	                    "name": "Mid-Atlantic Standard Time",
	                    "abbr": "MDT",
	                    "offset": -1,
	                    "isdst": true,
	                    "text": "(UTC-02:00) Mid-Atlantic - Old"
	                  },
	                  {
	                    "name": "Azores Standard Time",
	                    "abbr": "ADT",
	                    "offset": 0,
	                    "isdst": true,
	                    "text": "(UTC-01:00) Azores",
	                    "utc": [
	                      "America/Scoresbysund",
	                      "Atlantic/Azores"
	                    ]
	                  },
	                  {
	                    "name": "Cape Verde Standard Time",
	                    "abbr": "CVST",
	                    "offset": -1,
	                    "isdst": false,
	                    "text": "(UTC-01:00) Cape Verde Is.",
	                    "utc": [
	                      "Atlantic/Cape_Verde",
	                      "Etc/GMT+1"
	                    ]
	                  },
	                  {
	                    "name": "Morocco Standard Time",
	                    "abbr": "MDT",
	                    "offset": 1,
	                    "isdst": true,
	                    "text": "(UTC) Casablanca",
	                    "utc": [
	                      "Africa/Casablanca",
	                      "Africa/El_Aaiun"
	                    ]
	                  },
	                  {
	                    "name": "UTC",
	                    "abbr": "CUT",
	                    "offset": 0,
	                    "isdst": false,
	                    "text": "(UTC) Coordinated Universal Time",
	                    "utc": [
	                      "America/Danmarkshavn",
	                      "Etc/GMT"
	                    ]
	                  },
	                  {
	                    "name": "GMT Standard Time",
	                    "abbr": "GDT",
	                    "offset": 1,
	                    "isdst": true,
	                    "text": "(UTC) Dublin, Edinburgh, Lisbon, London",
	                    "utc": [
	                      "Atlantic/Canary",
	                      "Atlantic/Faeroe",
	                      "Atlantic/Madeira",
	                      "Europe/Dublin",
	                      "Europe/Guernsey",
	                      "Europe/Isle_of_Man",
	                      "Europe/Jersey",
	                      "Europe/Lisbon",
	                      "Europe/London"
	                    ]
	                  },
	                  {
	                    "name": "Greenwich Standard Time",
	                    "abbr": "GST",
	                    "offset": 0,
	                    "isdst": false,
	                    "text": "(UTC) Monrovia, Reykjavik",
	                    "utc": [
	                      "Africa/Abidjan",
	                      "Africa/Accra",
	                      "Africa/Bamako",
	                      "Africa/Banjul",
	                      "Africa/Bissau",
	                      "Africa/Conakry",
	                      "Africa/Dakar",
	                      "Africa/Freetown",
	                      "Africa/Lome",
	                      "Africa/Monrovia",
	                      "Africa/Nouakchott",
	                      "Africa/Ouagadougou",
	                      "Africa/Sao_Tome",
	                      "Atlantic/Reykjavik",
	                      "Atlantic/St_Helena"
	                    ]
	                  },
	                  {
	                    "name": "W. Europe Standard Time",
	                    "abbr": "WEDT",
	                    "offset": 2,
	                    "isdst": true,
	                    "text": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
	                    "utc": [
	                      "Arctic/Longyearbyen",
	                      "Europe/Amsterdam",
	                      "Europe/Andorra",
	                      "Europe/Berlin",
	                      "Europe/Busingen",
	                      "Europe/Gibraltar",
	                      "Europe/Luxembourg",
	                      "Europe/Malta",
	                      "Europe/Monaco",
	                      "Europe/Oslo",
	                      "Europe/Rome",
	                      "Europe/San_Marino",
	                      "Europe/Stockholm",
	                      "Europe/Vaduz",
	                      "Europe/Vatican",
	                      "Europe/Vienna",
	                      "Europe/Zurich"
	                    ]
	                  },
	                  {
	                    "name": "Central Europe Standard Time",
	                    "abbr": "CEDT",
	                    "offset": 2,
	                    "isdst": true,
	                    "text": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
	                    "utc": [
	                      "Europe/Belgrade",
	                      "Europe/Bratislava",
	                      "Europe/Budapest",
	                      "Europe/Ljubljana",
	                      "Europe/Podgorica",
	                      "Europe/Prague",
	                      "Europe/Tirane"
	                    ]
	                  },
	                  {
	                    "name": "Romance Standard Time",
	                    "abbr": "RDT",
	                    "offset": 2,
	                    "isdst": true,
	                    "text": "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
	                    "utc": [
	                      "Africa/Ceuta",
	                      "Europe/Brussels",
	                      "Europe/Copenhagen",
	                      "Europe/Madrid",
	                      "Europe/Paris"
	                    ]
	                  },
	                  {
	                    "name": "Central European Standard Time",
	                    "abbr": "CEDT",
	                    "offset": 2,
	                    "isdst": true,
	                    "text": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
	                    "utc": [
	                      "Europe/Sarajevo",
	                      "Europe/Skopje",
	                      "Europe/Warsaw",
	                      "Europe/Zagreb"
	                    ]
	                  },
	                  {
	                    "name": "W. Central Africa Standard Time",
	                    "abbr": "WCAST",
	                    "offset": 1,
	                    "isdst": false,
	                    "text": "(UTC+01:00) West Central Africa",
	                    "utc": [
	                      "Africa/Algiers",
	                      "Africa/Bangui",
	                      "Africa/Brazzaville",
	                      "Africa/Douala",
	                      "Africa/Kinshasa",
	                      "Africa/Lagos",
	                      "Africa/Libreville",
	                      "Africa/Luanda",
	                      "Africa/Malabo",
	                      "Africa/Ndjamena",
	                      "Africa/Niamey",
	                      "Africa/Porto-Novo",
	                      "Africa/Tunis",
	                      "Etc/GMT-1"
	                    ]
	                  },
	                  {
	                    "name": "Namibia Standard Time",
	                    "abbr": "NST",
	                    "offset": 1,
	                    "isdst": false,
	                    "text": "(UTC+01:00) Windhoek",
	                    "utc": [
	                      "Africa/Windhoek"
	                    ]
	                  },
	                  {
	                    "name": "GTB Standard Time",
	                    "abbr": "GDT",
	                    "offset": 3,
	                    "isdst": true,
	                    "text": "(UTC+02:00) Athens, Bucharest",
	                    "utc": [
	                      "Asia/Nicosia",
	                      "Europe/Athens",
	                      "Europe/Bucharest",
	                      "Europe/Chisinau"
	                    ]
	                  },
	                  {
	                    "name": "Middle East Standard Time",
	                    "abbr": "MEDT",
	                    "offset": 3,
	                    "isdst": true,
	                    "text": "(UTC+02:00) Beirut",
	                    "utc": [
	                      "Asia/Beirut"
	                    ]
	                  },
	                  {
	                    "name": "Egypt Standard Time",
	                    "abbr": "EST",
	                    "offset": 2,
	                    "isdst": false,
	                    "text": "(UTC+02:00) Cairo",
	                    "utc": [
	                      "Africa/Cairo"
	                    ]
	                  },
	                  {
	                    "name": "Syria Standard Time",
	                    "abbr": "SDT",
	                    "offset": 3,
	                    "isdst": true,
	                    "text": "(UTC+02:00) Damascus",
	                    "utc": [
	                      "Asia/Damascus"
	                    ]
	                  },
	                  {
	                    "name": "E. Europe Standard Time",
	                    "abbr": "EEDT",
	                    "offset": 3,
	                    "isdst": true,
	                    "text": "(UTC+02:00) E. Europe"
	                  },
	                  {
	                    "name": "South Africa Standard Time",
	                    "abbr": "SAST",
	                    "offset": 2,
	                    "isdst": false,
	                    "text": "(UTC+02:00) Harare, Pretoria",
	                    "utc": [
	                      "Africa/Blantyre",
	                      "Africa/Bujumbura",
	                      "Africa/Gaborone",
	                      "Africa/Harare",
	                      "Africa/Johannesburg",
	                      "Africa/Kigali",
	                      "Africa/Lubumbashi",
	                      "Africa/Lusaka",
	                      "Africa/Maputo",
	                      "Africa/Maseru",
	                      "Africa/Mbabane",
	                      "Etc/GMT-2"
	                    ]
	                  },
	                  {
	                    "name": "FLE Standard Time",
	                    "abbr": "FDT",
	                    "offset": 3,
	                    "isdst": true,
	                    "text": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
	                    "utc": [
	                      "Europe/Helsinki",
	                      "Europe/Kiev",
	                      "Europe/Mariehamn",
	                      "Europe/Riga",
	                      "Europe/Sofia",
	                      "Europe/Tallinn",
	                      "Europe/Uzhgorod",
	                      "Europe/Vilnius",
	                      "Europe/Zaporozhye"
	                    ]
	                  },
	                  {
	                    "name": "Turkey Standard Time",
	                    "abbr": "TDT",
	                    "offset": 3,
	                    "isdst": true,
	                    "text": "(UTC+02:00) Istanbul",
	                    "utc": [
	                      "Europe/Istanbul"
	                    ]
	                  },
	                  {
	                    "name": "Israel Standard Time",
	                    "abbr": "JDT",
	                    "offset": 3,
	                    "isdst": true,
	                    "text": "(UTC+02:00) Jerusalem",
	                    "utc": [
	                      "Asia/Jerusalem"
	                    ]
	                  },
	                  {
	                    "name": "Libya Standard Time",
	                    "abbr": "LST",
	                    "offset": 2,
	                    "isdst": false,
	                    "text": "(UTC+02:00) Tripoli",
	                    "utc": [
	                      "Africa/Tripoli"
	                    ]
	                  },
	                  {
	                    "name": "Jordan Standard Time",
	                    "abbr": "JST",
	                    "offset": 3,
	                    "isdst": false,
	                    "text": "(UTC+03:00) Amman",
	                    "utc": [
	                      "Asia/Amman"
	                    ]
	                  },
	                  {
	                    "name": "Arabic Standard Time",
	                    "abbr": "AST",
	                    "offset": 3,
	                    "isdst": false,
	                    "text": "(UTC+03:00) Baghdad",
	                    "utc": [
	                      "Asia/Baghdad"
	                    ]
	                  },
	                  {
	                    "name": "Kaliningrad Standard Time",
	                    "abbr": "KST",
	                    "offset": 3,
	                    "isdst": false,
	                    "text": "(UTC+03:00) Kaliningrad, Minsk",
	                    "utc": [
	                      "Europe/Kaliningrad",
	                      "Europe/Minsk"
	                    ]
	                  },
	                  {
	                    "name": "Arab Standard Time",
	                    "abbr": "AST",
	                    "offset": 3,
	                    "isdst": false,
	                    "text": "(UTC+03:00) Kuwait, Riyadh",
	                    "utc": [
	                      "Asia/Aden",
	                      "Asia/Bahrain",
	                      "Asia/Kuwait",
	                      "Asia/Qatar",
	                      "Asia/Riyadh"
	                    ]
	                  },
	                  {
	                    "name": "E. Africa Standard Time",
	                    "abbr": "EAST",
	                    "offset": 3,
	                    "isdst": false,
	                    "text": "(UTC+03:00) Nairobi",
	                    "utc": [
	                      "Africa/Addis_Ababa",
	                      "Africa/Asmera",
	                      "Africa/Dar_es_Salaam",
	                      "Africa/Djibouti",
	                      "Africa/Juba",
	                      "Africa/Kampala",
	                      "Africa/Khartoum",
	                      "Africa/Mogadishu",
	                      "Africa/Nairobi",
	                      "Antarctica/Syowa",
	                      "Etc/GMT-3",
	                      "Indian/Antananarivo",
	                      "Indian/Comoro",
	                      "Indian/Mayotte"
	                    ]
	                  },
	                  {
	                    "name": "Iran Standard Time",
	                    "abbr": "IDT",
	                    "offset": 4.5,
	                    "isdst": true,
	                    "text": "(UTC+03:30) Tehran",
	                    "utc": [
	                      "Asia/Tehran"
	                    ]
	                  },
	                  {
	                    "name": "Arabian Standard Time",
	                    "abbr": "AST",
	                    "offset": 4,
	                    "isdst": false,
	                    "text": "(UTC+04:00) Abu Dhabi, Muscat",
	                    "utc": [
	                      "Asia/Dubai",
	                      "Asia/Muscat",
	                      "Etc/GMT-4"
	                    ]
	                  },
	                  {
	                    "name": "Azerbaijan Standard Time",
	                    "abbr": "ADT",
	                    "offset": 5,
	                    "isdst": true,
	                    "text": "(UTC+04:00) Baku",
	                    "utc": [
	                      "Asia/Baku"
	                    ]
	                  },
	                  {
	                    "name": "Russian Standard Time",
	                    "abbr": "RST",
	                    "offset": 4,
	                    "isdst": false,
	                    "text": "(UTC+04:00) Moscow, St. Petersburg, Volgograd",
	                    "utc": [
	                      "Europe/Moscow",
	                      "Europe/Samara",
	                      "Europe/Simferopol",
	                      "Europe/Volgograd"
	                    ]
	                  },
	                  {
	                    "name": "Mauritius Standard Time",
	                    "abbr": "MST",
	                    "offset": 4,
	                    "isdst": false,
	                    "text": "(UTC+04:00) Port Louis",
	                    "utc": [
	                      "Indian/Mahe",
	                      "Indian/Mauritius",
	                      "Indian/Reunion"
	                    ]
	                  },
	                  {
	                    "name": "Georgian Standard Time",
	                    "abbr": "GST",
	                    "offset": 4,
	                    "isdst": false,
	                    "text": "(UTC+04:00) Tbilisi",
	                    "utc": [
	                      "Asia/Tbilisi"
	                    ]
	                  },
	                  {
	                    "name": "Caucasus Standard Time",
	                    "abbr": "CST",
	                    "offset": 4,
	                    "isdst": false,
	                    "text": "(UTC+04:00) Yerevan",
	                    "utc": [
	                      "Asia/Yerevan"
	                    ]
	                  },
	                  {
	                    "name": "Afghanistan Standard Time",
	                    "abbr": "AST",
	                    "offset": 4.5,
	                    "isdst": false,
	                    "text": "(UTC+04:30) Kabul",
	                    "utc": [
	                      "Asia/Kabul"
	                    ]
	                  },
	                  {
	                    "name": "West Asia Standard Time",
	                    "abbr": "WAST",
	                    "offset": 5,
	                    "isdst": false,
	                    "text": "(UTC+05:00) Ashgabat, Tashkent",
	                    "utc": [
	                      "Antarctica/Mawson",
	                      "Asia/Aqtau",
	                      "Asia/Aqtobe",
	                      "Asia/Ashgabat",
	                      "Asia/Dushanbe",
	                      "Asia/Oral",
	                      "Asia/Samarkand",
	                      "Asia/Tashkent",
	                      "Etc/GMT-5",
	                      "Indian/Kerguelen",
	                      "Indian/Maldives"
	                    ]
	                  },
	                  {
	                    "name": "Pakistan Standard Time",
	                    "abbr": "PST",
	                    "offset": 5,
	                    "isdst": false,
	                    "text": "(UTC+05:00) Islamabad, Karachi",
	                    "utc": [
	                      "Asia/Karachi"
	                    ]
	                  },
	                  {
	                    "name": "India Standard Time",
	                    "abbr": "IST",
	                    "offset": 5.5,
	                    "isdst": false,
	                    "text": "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
	                    "utc": [
	                      "Asia/Calcutta"
	                    ]
	                  },
	                  {
	                    "name": "Sri Lanka Standard Time",
	                    "abbr": "SLST",
	                    "offset": 5.5,
	                    "isdst": false,
	                    "text": "(UTC+05:30) Sri Jayawardenepura",
	                    "utc": [
	                      "Asia/Colombo"
	                    ]
	                  },
	                  {
	                    "name": "Nepal Standard Time",
	                    "abbr": "NST",
	                    "offset": 5.75,
	                    "isdst": false,
	                    "text": "(UTC+05:45) Kathmandu",
	                    "utc": [
	                      "Asia/Katmandu"
	                    ]
	                  },
	                  {
	                    "name": "Central Asia Standard Time",
	                    "abbr": "CAST",
	                    "offset": 6,
	                    "isdst": false,
	                    "text": "(UTC+06:00) Astana",
	                    "utc": [
	                      "Antarctica/Vostok",
	                      "Asia/Almaty",
	                      "Asia/Bishkek",
	                      "Asia/Qyzylorda",
	                      "Asia/Urumqi",
	                      "Etc/GMT-6",
	                      "Indian/Chagos"
	                    ]
	                  },
	                  {
	                    "name": "Bangladesh Standard Time",
	                    "abbr": "BST",
	                    "offset": 6,
	                    "isdst": false,
	                    "text": "(UTC+06:00) Dhaka",
	                    "utc": [
	                      "Asia/Dhaka",
	                      "Asia/Thimphu"
	                    ]
	                  },
	                  {
	                    "name": "Ekaterinburg Standard Time",
	                    "abbr": "EST",
	                    "offset": 6,
	                    "isdst": false,
	                    "text": "(UTC+06:00) Ekaterinburg",
	                    "utc": [
	                      "Asia/Yekaterinburg"
	                    ]
	                  },
	                  {
	                    "name": "Myanmar Standard Time",
	                    "abbr": "MST",
	                    "offset": 6.5,
	                    "isdst": false,
	                    "text": "(UTC+06:30) Yangon (Rangoon)",
	                    "utc": [
	                      "Asia/Rangoon",
	                      "Indian/Cocos"
	                    ]
	                  },
	                  {
	                    "name": "SE Asia Standard Time",
	                    "abbr": "SAST",
	                    "offset": 7,
	                    "isdst": false,
	                    "text": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
	                    "utc": [
	                      "Antarctica/Davis",
	                      "Asia/Bangkok",
	                      "Asia/Hovd",
	                      "Asia/Jakarta",
	                      "Asia/Phnom_Penh",
	                      "Asia/Pontianak",
	                      "Asia/Saigon",
	                      "Asia/Vientiane",
	                      "Etc/GMT-7",
	                      "Indian/Christmas"
	                    ]
	                  },
	                  {
	                    "name": "N. Central Asia Standard Time",
	                    "abbr": "NCAST",
	                    "offset": 7,
	                    "isdst": false,
	                    "text": "(UTC+07:00) Novosibirsk",
	                    "utc": [
	                      "Asia/Novokuznetsk",
	                      "Asia/Novosibirsk",
	                      "Asia/Omsk"
	                    ]
	                  },
	                  {
	                    "name": "China Standard Time",
	                    "abbr": "CST",
	                    "offset": 8,
	                    "isdst": false,
	                    "text": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
	                    "utc": [
	                      "Asia/Hong_Kong",
	                      "Asia/Macau",
	                      "Asia/Shanghai"
	                    ]
	                  },
	                  {
	                    "name": "North Asia Standard Time",
	                    "abbr": "NAST",
	                    "offset": 8,
	                    "isdst": false,
	                    "text": "(UTC+08:00) Krasnoyarsk",
	                    "utc": [
	                      "Asia/Krasnoyarsk"
	                    ]
	                  },
	                  {
	                    "name": "Singapore Standard Time",
	                    "abbr": "MPST",
	                    "offset": 8,
	                    "isdst": false,
	                    "text": "(UTC+08:00) Kuala Lumpur, Singapore",
	                    "utc": [
	                      "Asia/Brunei",
	                      "Asia/Kuala_Lumpur",
	                      "Asia/Kuching",
	                      "Asia/Makassar",
	                      "Asia/Manila",
	                      "Asia/Singapore",
	                      "Etc/GMT-8"
	                    ]
	                  },
	                  {
	                    "name": "W. Australia Standard Time",
	                    "abbr": "WAST",
	                    "offset": 8,
	                    "isdst": false,
	                    "text": "(UTC+08:00) Perth",
	                    "utc": [
	                      "Antarctica/Casey",
	                      "Australia/Perth"
	                    ]
	                  },
	                  {
	                    "name": "Taipei Standard Time",
	                    "abbr": "TST",
	                    "offset": 8,
	                    "isdst": false,
	                    "text": "(UTC+08:00) Taipei",
	                    "utc": [
	                      "Asia/Taipei"
	                    ]
	                  },
	                  {
	                    "name": "Ulaanbaatar Standard Time",
	                    "abbr": "UST",
	                    "offset": 8,
	                    "isdst": false,
	                    "text": "(UTC+08:00) Ulaanbaatar",
	                    "utc": [
	                      "Asia/Choibalsan",
	                      "Asia/Ulaanbaatar"
	                    ]
	                  },
	                  {
	                    "name": "North Asia East Standard Time",
	                    "abbr": "NAEST",
	                    "offset": 9,
	                    "isdst": false,
	                    "text": "(UTC+09:00) Irkutsk",
	                    "utc": [
	                      "Asia/Irkutsk"
	                    ]
	                  },
	                  {
	                    "name": "Tokyo Standard Time",
	                    "abbr": "TST",
	                    "offset": 9,
	                    "isdst": false,
	                    "text": "(UTC+09:00) Osaka, Sapporo, Tokyo",
	                    "utc": [
	                      "Asia/Dili",
	                      "Asia/Jayapura",
	                      "Asia/Tokyo",
	                      "Etc/GMT-9",
	                      "Pacific/Palau"
	                    ]
	                  },
	                  {
	                    "name": "Korea Standard Time",
	                    "abbr": "KST",
	                    "offset": 9,
	                    "isdst": false,
	                    "text": "(UTC+09:00) Seoul",
	                    "utc": [
	                      "Asia/Pyongyang",
	                      "Asia/Seoul"
	                    ]
	                  },
	                  {
	                    "name": "Cen. Australia Standard Time",
	                    "abbr": "CAST",
	                    "offset": 9.5,
	                    "isdst": false,
	                    "text": "(UTC+09:30) Adelaide",
	                    "utc": [
	                      "Australia/Adelaide",
	                      "Australia/Broken_Hill"
	                    ]
	                  },
	                  {
	                    "name": "AUS Central Standard Time",
	                    "abbr": "ACST",
	                    "offset": 9.5,
	                    "isdst": false,
	                    "text": "(UTC+09:30) Darwin",
	                    "utc": [
	                      "Australia/Darwin"
	                    ]
	                  },
	                  {
	                    "name": "E. Australia Standard Time",
	                    "abbr": "EAST",
	                    "offset": 10,
	                    "isdst": false,
	                    "text": "(UTC+10:00) Brisbane",
	                    "utc": [
	                      "Australia/Brisbane",
	                      "Australia/Lindeman"
	                    ]
	                  },
	                  {
	                    "name": "AUS Eastern Standard Time",
	                    "abbr": "AEST",
	                    "offset": 10,
	                    "isdst": false,
	                    "text": "(UTC+10:00) Canberra, Melbourne, Sydney",
	                    "utc": [
	                      "Australia/Melbourne",
	                      "Australia/Sydney"
	                    ]
	                  },
	                  {
	                    "name": "West Pacific Standard Time",
	                    "abbr": "WPST",
	                    "offset": 10,
	                    "isdst": false,
	                    "text": "(UTC+10:00) Guam, Port Moresby",
	                    "utc": [
	                      "Antarctica/DumontDUrville",
	                      "Etc/GMT-10",
	                      "Pacific/Guam",
	                      "Pacific/Port_Moresby",
	                      "Pacific/Saipan",
	                      "Pacific/Truk"
	                    ]
	                  },
	                  {
	                    "name": "Tasmania Standard Time",
	                    "abbr": "TST",
	                    "offset": 10,
	                    "isdst": false,
	                    "text": "(UTC+10:00) Hobart",
	                    "utc": [
	                      "Australia/Currie",
	                      "Australia/Hobart"
	                    ]
	                  },
	                  {
	                    "name": "Yakutsk Standard Time",
	                    "abbr": "YST",
	                    "offset": 10,
	                    "isdst": false,
	                    "text": "(UTC+10:00) Yakutsk",
	                    "utc": [
	                      "Asia/Chita",
	                      "Asia/Khandyga",
	                      "Asia/Yakutsk"
	                    ]
	                  },
	                  {
	                    "name": "Central Pacific Standard Time",
	                    "abbr": "CPST",
	                    "offset": 11,
	                    "isdst": false,
	                    "text": "(UTC+11:00) Solomon Is., New Caledonia",
	                    "utc": [
	                      "Antarctica/Macquarie",
	                      "Etc/GMT-11",
	                      "Pacific/Efate",
	                      "Pacific/Guadalcanal",
	                      "Pacific/Kosrae",
	                      "Pacific/Noumea",
	                      "Pacific/Ponape"
	                    ]
	                  },
	                  {
	                    "name": "Vladivostok Standard Time",
	                    "abbr": "VST",
	                    "offset": 11,
	                    "isdst": false,
	                    "text": "(UTC+11:00) Vladivostok",
	                    "utc": [
	                      "Asia/Sakhalin",
	                      "Asia/Ust-Nera",
	                      "Asia/Vladivostok"
	                    ]
	                  },
	                  {
	                    "name": "New Zealand Standard Time",
	                    "abbr": "NZST",
	                    "offset": 12,
	                    "isdst": false,
	                    "text": "(UTC+12:00) Auckland, Wellington",
	                    "utc": [
	                      "Antarctica/McMurdo",
	                      "Pacific/Auckland"
	                    ]
	                  },
	                  {
	                    "name": "UTC+12",
	                    "abbr": "U",
	                    "offset": 12,
	                    "isdst": false,
	                    "text": "(UTC+12:00) Coordinated Universal Time+12",
	                    "utc": [
	                      "Etc/GMT-12",
	                      "Pacific/Funafuti",
	                      "Pacific/Kwajalein",
	                      "Pacific/Majuro",
	                      "Pacific/Nauru",
	                      "Pacific/Tarawa",
	                      "Pacific/Wake",
	                      "Pacific/Wallis"
	                    ]
	                  },
	                  {
	                    "name": "Fiji Standard Time",
	                    "abbr": "FST",
	                    "offset": 12,
	                    "isdst": false,
	                    "text": "(UTC+12:00) Fiji",
	                    "utc": [
	                      "Pacific/Fiji"
	                    ]
	                  },
	                  {
	                    "name": "Magadan Standard Time",
	                    "abbr": "MST",
	                    "offset": 12,
	                    "isdst": false,
	                    "text": "(UTC+12:00) Magadan",
	                    "utc": [
	                      "Asia/Anadyr",
	                      "Asia/Kamchatka",
	                      "Asia/Magadan",
	                      "Asia/Srednekolymsk"
	                    ]
	                  },
	                  {
	                    "name": "Kamchatka Standard Time",
	                    "abbr": "KDT",
	                    "offset": 13,
	                    "isdst": true,
	                    "text": "(UTC+12:00) Petropavlovsk-Kamchatsky - Old"
	                  },
	                  {
	                    "name": "Tonga Standard Time",
	                    "abbr": "TST",
	                    "offset": 13,
	                    "isdst": false,
	                    "text": "(UTC+13:00) Nuku'alofa",
	                    "utc": [
	                      "Etc/GMT-13",
	                      "Pacific/Enderbury",
	                      "Pacific/Fakaofo",
	                      "Pacific/Tongatapu"
	                    ]
	                  },
	                  {
	                    "name": "Samoa Standard Time",
	                    "abbr": "SST",
	                    "offset": 13,
	                    "isdst": false,
	                    "text": "(UTC+13:00) Samoa",
	                    "utc": [
	                      "Pacific/Apia"
	                    ]
	                  }
	                ]
	    };
	
	    var o_hasOwnProperty = Object.prototype.hasOwnProperty;
	    var o_keys = (Object.keys || function(obj) {
	      var result = [];
	      for (var key in obj) {
	        if (o_hasOwnProperty.call(obj, key)) {
	          result.push(key);
	        }
	      }
	
	      return result;
	    });
	
	    function _copyObject(source, target) {
	      var keys = o_keys(source);
	      var key;
	
	      for (var i = 0, l = keys.length; i < l; i++) {
	        key = keys[i];
	        target[key] = source[key] || target[key];
	      }
	    }
	
	    function _copyArray(source, target) {
	      for (var i = 0, l = source.length; i < l; i++) {
	        target[i] = source[i];
	      }
	    }
	
	    function copyObject(source, _target) {
	        var isArray = Array.isArray(source);
	        var target = _target || (isArray ? new Array(source.length) : {});
	
	        if (isArray) {
	          _copyArray(source, target);
	        } else {
	          _copyObject(source, target);
	        }
	
	        return target;
	    }
	
	    /** Get the data based on key**/
	    Chance.prototype.get = function (name) {
	        return copyObject(data[name]);
	    };
	
	    // Mac Address
	    Chance.prototype.mac_address = function(options){
	        // typically mac addresses are separated by ":"
	        // however they can also be separated by "-"
	        // the network variant uses a dot every fourth byte
	
	        options = initOptions(options);
	        if(!options.separator) {
	            options.separator =  options.networkVersion ? "." : ":";
	        }
	
	        var mac_pool="ABCDEF1234567890",
	            mac = "";
	        if(!options.networkVersion) {
	            mac = this.n(this.string, 6, { pool: mac_pool, length:2 }).join(options.separator);
	        } else {
	            mac = this.n(this.string, 3, { pool: mac_pool, length:4 }).join(options.separator);
	        }
	
	        return mac;
	    };
	
	    Chance.prototype.normal = function (options) {
	        options = initOptions(options, {mean : 0, dev : 1, pool : []});
	
	        testRange(
	            options.pool.constructor !== Array,
	            "Chance: The pool option must be a valid array."
	        );
	
	        // If a pool has been passed, then we are returning an item from that pool,
	        // using the normal distribution settings that were passed in
	        if (options.pool.length > 0) {
	            return this.normal_pool(options);
	        }
	
	        // The Marsaglia Polar method
	        var s, u, v, norm,
	            mean = options.mean,
	            dev = options.dev;
	
	        do {
	            // U and V are from the uniform distribution on (-1, 1)
	            u = this.random() * 2 - 1;
	            v = this.random() * 2 - 1;
	
	            s = u * u + v * v;
	        } while (s >= 1);
	
	        // Compute the standard normal variate
	        norm = u * Math.sqrt(-2 * Math.log(s) / s);
	
	        // Shape and scale
	        return dev * norm + mean;
	    };
	
	    Chance.prototype.normal_pool = function(options) {
	        var performanceCounter = 0;
	        do {
	            var idx = Math.round(this.normal({ mean: options.mean, dev: options.dev }));
	            if (idx < options.pool.length && idx >= 0) {
	                return options.pool[idx];
	            } else {
	                performanceCounter++;
	            }
	        } while(performanceCounter < 100);
	
	        throw new RangeError("Chance: Your pool is too small for the given mean and standard deviation. Please adjust.");
	    };
	
	    Chance.prototype.radio = function (options) {
	        // Initial Letter (Typically Designated by Side of Mississippi River)
	        options = initOptions(options, {side : "?"});
	        var fl = "";
	        switch (options.side.toLowerCase()) {
	        case "east":
	        case "e":
	            fl = "W";
	            break;
	        case "west":
	        case "w":
	            fl = "K";
	            break;
	        default:
	            fl = this.character({pool: "KW"});
	            break;
	        }
	
	        return fl + this.character({alpha: true, casing: "upper"}) +
	                this.character({alpha: true, casing: "upper"}) +
	                this.character({alpha: true, casing: "upper"});
	    };
	
	    // Set the data as key and data or the data map
	    Chance.prototype.set = function (name, values) {
	        if (typeof name === "string") {
	            data[name] = values;
	        } else {
	            data = copyObject(name, data);
	        }
	    };
	
	    Chance.prototype.tv = function (options) {
	        return this.radio(options);
	    };
	
	    // ID number for Brazil companies
	    Chance.prototype.cnpj = function () {
	        var n = this.n(this.natural, 8, { max: 9 });
	        var d1 = 2+n[7]*6+n[6]*7+n[5]*8+n[4]*9+n[3]*2+n[2]*3+n[1]*4+n[0]*5;
	        d1 = 11 - (d1 % 11);
	        if (d1>=10){
	            d1 = 0;
	        }
	        var d2 = d1*2+3+n[7]*7+n[6]*8+n[5]*9+n[4]*2+n[3]*3+n[2]*4+n[1]*5+n[0]*6;
	        d2 = 11 - (d2 % 11);
	        if (d2>=10){
	            d2 = 0;
	        }
	        return ''+n[0]+n[1]+'.'+n[2]+n[3]+n[4]+'.'+n[5]+n[6]+n[7]+'/0001-'+d1+d2;
	    };
	
	    // -- End Miscellaneous --
	
	    Chance.prototype.mersenne_twister = function (seed) {
	        return new MersenneTwister(seed);
	    };
	
	    Chance.prototype.blueimp_md5 = function () {
	        return new BlueImpMD5();
	    };
	
	    // Mersenne Twister from https://gist.github.com/banksean/300494
	    var MersenneTwister = function (seed) {
	        if (seed === undefined) {
	            // kept random number same size as time used previously to ensure no unexpected results downstream
	            seed = Math.floor(Math.random()*Math.pow(10,13));
	        }
	        /* Period parameters */
	        this.N = 624;
	        this.M = 397;
	        this.MATRIX_A = 0x9908b0df;   /* constant vector a */
	        this.UPPER_MASK = 0x80000000; /* most significant w-r bits */
	        this.LOWER_MASK = 0x7fffffff; /* least significant r bits */
	
	        this.mt = new Array(this.N); /* the array for the state vector */
	        this.mti = this.N + 1; /* mti==N + 1 means mt[N] is not initialized */
	
	        this.init_genrand(seed);
	    };
	
	    /* initializes mt[N] with a seed */
	    MersenneTwister.prototype.init_genrand = function (s) {
	        this.mt[0] = s >>> 0;
	        for (this.mti = 1; this.mti < this.N; this.mti++) {
	            s = this.mt[this.mti - 1] ^ (this.mt[this.mti - 1] >>> 30);
	            this.mt[this.mti] = (((((s & 0xffff0000) >>> 16) * 1812433253) << 16) + (s & 0x0000ffff) * 1812433253) + this.mti;
	            /* See Knuth TAOCP Vol2. 3rd Ed. P.106 for multiplier. */
	            /* In the previous versions, MSBs of the seed affect   */
	            /* only MSBs of the array mt[].                        */
	            /* 2002/01/09 modified by Makoto Matsumoto             */
	            this.mt[this.mti] >>>= 0;
	            /* for >32 bit machines */
	        }
	    };
	
	    /* initialize by an array with array-length */
	    /* init_key is the array for initializing keys */
	    /* key_length is its length */
	    /* slight change for C++, 2004/2/26 */
	    MersenneTwister.prototype.init_by_array = function (init_key, key_length) {
	        var i = 1, j = 0, k, s;
	        this.init_genrand(19650218);
	        k = (this.N > key_length ? this.N : key_length);
	        for (; k; k--) {
	            s = this.mt[i - 1] ^ (this.mt[i - 1] >>> 30);
	            this.mt[i] = (this.mt[i] ^ (((((s & 0xffff0000) >>> 16) * 1664525) << 16) + ((s & 0x0000ffff) * 1664525))) + init_key[j] + j; /* non linear */
	            this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */
	            i++;
	            j++;
	            if (i >= this.N) { this.mt[0] = this.mt[this.N - 1]; i = 1; }
	            if (j >= key_length) { j = 0; }
	        }
	        for (k = this.N - 1; k; k--) {
	            s = this.mt[i - 1] ^ (this.mt[i - 1] >>> 30);
	            this.mt[i] = (this.mt[i] ^ (((((s & 0xffff0000) >>> 16) * 1566083941) << 16) + (s & 0x0000ffff) * 1566083941)) - i; /* non linear */
	            this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */
	            i++;
	            if (i >= this.N) { this.mt[0] = this.mt[this.N - 1]; i = 1; }
	        }
	
	        this.mt[0] = 0x80000000; /* MSB is 1; assuring non-zero initial array */
	    };
	
	    /* generates a random number on [0,0xffffffff]-interval */
	    MersenneTwister.prototype.genrand_int32 = function () {
	        var y;
	        var mag01 = new Array(0x0, this.MATRIX_A);
	        /* mag01[x] = x * MATRIX_A  for x=0,1 */
	
	        if (this.mti >= this.N) { /* generate N words at one time */
	            var kk;
	
	            if (this.mti === this.N + 1) {   /* if init_genrand() has not been called, */
	                this.init_genrand(5489); /* a default initial seed is used */
	            }
	            for (kk = 0; kk < this.N - this.M; kk++) {
	                y = (this.mt[kk]&this.UPPER_MASK)|(this.mt[kk + 1]&this.LOWER_MASK);
	                this.mt[kk] = this.mt[kk + this.M] ^ (y >>> 1) ^ mag01[y & 0x1];
	            }
	            for (;kk < this.N - 1; kk++) {
	                y = (this.mt[kk]&this.UPPER_MASK)|(this.mt[kk + 1]&this.LOWER_MASK);
	                this.mt[kk] = this.mt[kk + (this.M - this.N)] ^ (y >>> 1) ^ mag01[y & 0x1];
	            }
	            y = (this.mt[this.N - 1]&this.UPPER_MASK)|(this.mt[0]&this.LOWER_MASK);
	            this.mt[this.N - 1] = this.mt[this.M - 1] ^ (y >>> 1) ^ mag01[y & 0x1];
	
	            this.mti = 0;
	        }
	
	        y = this.mt[this.mti++];
	
	        /* Tempering */
	        y ^= (y >>> 11);
	        y ^= (y << 7) & 0x9d2c5680;
	        y ^= (y << 15) & 0xefc60000;
	        y ^= (y >>> 18);
	
	        return y >>> 0;
	    };
	
	    /* generates a random number on [0,0x7fffffff]-interval */
	    MersenneTwister.prototype.genrand_int31 = function () {
	        return (this.genrand_int32() >>> 1);
	    };
	
	    /* generates a random number on [0,1]-real-interval */
	    MersenneTwister.prototype.genrand_real1 = function () {
	        return this.genrand_int32() * (1.0 / 4294967295.0);
	        /* divided by 2^32-1 */
	    };
	
	    /* generates a random number on [0,1)-real-interval */
	    MersenneTwister.prototype.random = function () {
	        return this.genrand_int32() * (1.0 / 4294967296.0);
	        /* divided by 2^32 */
	    };
	
	    /* generates a random number on (0,1)-real-interval */
	    MersenneTwister.prototype.genrand_real3 = function () {
	        return (this.genrand_int32() + 0.5) * (1.0 / 4294967296.0);
	        /* divided by 2^32 */
	    };
	
	    /* generates a random number on [0,1) with 53-bit resolution*/
	    MersenneTwister.prototype.genrand_res53 = function () {
	        var a = this.genrand_int32()>>>5, b = this.genrand_int32()>>>6;
	        return (a * 67108864.0 + b) * (1.0 / 9007199254740992.0);
	    };
	
	    // BlueImp MD5 hashing algorithm from https://github.com/blueimp/JavaScript-MD5
	    var BlueImpMD5 = function () {};
	
	    BlueImpMD5.prototype.VERSION = '1.0.1';
	
	    /*
	    * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	    * to work around bugs in some JS interpreters.
	    */
	    BlueImpMD5.prototype.safe_add = function safe_add(x, y) {
	        var lsw = (x & 0xFFFF) + (y & 0xFFFF),
	            msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	        return (msw << 16) | (lsw & 0xFFFF);
	    };
	
	    /*
	    * Bitwise rotate a 32-bit number to the left.
	    */
	    BlueImpMD5.prototype.bit_roll = function (num, cnt) {
	        return (num << cnt) | (num >>> (32 - cnt));
	    };
	
	    /*
	    * These functions implement the five basic operations the algorithm uses.
	    */
	    BlueImpMD5.prototype.md5_cmn = function (q, a, b, x, s, t) {
	        return this.safe_add(this.bit_roll(this.safe_add(this.safe_add(a, q), this.safe_add(x, t)), s), b);
	    };
	    BlueImpMD5.prototype.md5_ff = function (a, b, c, d, x, s, t) {
	        return this.md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	    };
	    BlueImpMD5.prototype.md5_gg = function (a, b, c, d, x, s, t) {
	        return this.md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	    };
	    BlueImpMD5.prototype.md5_hh = function (a, b, c, d, x, s, t) {
	        return this.md5_cmn(b ^ c ^ d, a, b, x, s, t);
	    };
	    BlueImpMD5.prototype.md5_ii = function (a, b, c, d, x, s, t) {
	        return this.md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	    };
	
	    /*
	    * Calculate the MD5 of an array of little-endian words, and a bit length.
	    */
	    BlueImpMD5.prototype.binl_md5 = function (x, len) {
	        /* append padding */
	        x[len >> 5] |= 0x80 << (len % 32);
	        x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	        var i, olda, oldb, oldc, oldd,
	            a =  1732584193,
	            b = -271733879,
	            c = -1732584194,
	            d =  271733878;
	
	        for (i = 0; i < x.length; i += 16) {
	            olda = a;
	            oldb = b;
	            oldc = c;
	            oldd = d;
	
	            a = this.md5_ff(a, b, c, d, x[i],       7, -680876936);
	            d = this.md5_ff(d, a, b, c, x[i +  1], 12, -389564586);
	            c = this.md5_ff(c, d, a, b, x[i +  2], 17,  606105819);
	            b = this.md5_ff(b, c, d, a, x[i +  3], 22, -1044525330);
	            a = this.md5_ff(a, b, c, d, x[i +  4],  7, -176418897);
	            d = this.md5_ff(d, a, b, c, x[i +  5], 12,  1200080426);
	            c = this.md5_ff(c, d, a, b, x[i +  6], 17, -1473231341);
	            b = this.md5_ff(b, c, d, a, x[i +  7], 22, -45705983);
	            a = this.md5_ff(a, b, c, d, x[i +  8],  7,  1770035416);
	            d = this.md5_ff(d, a, b, c, x[i +  9], 12, -1958414417);
	            c = this.md5_ff(c, d, a, b, x[i + 10], 17, -42063);
	            b = this.md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
	            a = this.md5_ff(a, b, c, d, x[i + 12],  7,  1804603682);
	            d = this.md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
	            c = this.md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
	            b = this.md5_ff(b, c, d, a, x[i + 15], 22,  1236535329);
	
	            a = this.md5_gg(a, b, c, d, x[i +  1],  5, -165796510);
	            d = this.md5_gg(d, a, b, c, x[i +  6],  9, -1069501632);
	            c = this.md5_gg(c, d, a, b, x[i + 11], 14,  643717713);
	            b = this.md5_gg(b, c, d, a, x[i],      20, -373897302);
	            a = this.md5_gg(a, b, c, d, x[i +  5],  5, -701558691);
	            d = this.md5_gg(d, a, b, c, x[i + 10],  9,  38016083);
	            c = this.md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
	            b = this.md5_gg(b, c, d, a, x[i +  4], 20, -405537848);
	            a = this.md5_gg(a, b, c, d, x[i +  9],  5,  568446438);
	            d = this.md5_gg(d, a, b, c, x[i + 14],  9, -1019803690);
	            c = this.md5_gg(c, d, a, b, x[i +  3], 14, -187363961);
	            b = this.md5_gg(b, c, d, a, x[i +  8], 20,  1163531501);
	            a = this.md5_gg(a, b, c, d, x[i + 13],  5, -1444681467);
	            d = this.md5_gg(d, a, b, c, x[i +  2],  9, -51403784);
	            c = this.md5_gg(c, d, a, b, x[i +  7], 14,  1735328473);
	            b = this.md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);
	
	            a = this.md5_hh(a, b, c, d, x[i +  5],  4, -378558);
	            d = this.md5_hh(d, a, b, c, x[i +  8], 11, -2022574463);
	            c = this.md5_hh(c, d, a, b, x[i + 11], 16,  1839030562);
	            b = this.md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
	            a = this.md5_hh(a, b, c, d, x[i +  1],  4, -1530992060);
	            d = this.md5_hh(d, a, b, c, x[i +  4], 11,  1272893353);
	            c = this.md5_hh(c, d, a, b, x[i +  7], 16, -155497632);
	            b = this.md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
	            a = this.md5_hh(a, b, c, d, x[i + 13],  4,  681279174);
	            d = this.md5_hh(d, a, b, c, x[i],      11, -358537222);
	            c = this.md5_hh(c, d, a, b, x[i +  3], 16, -722521979);
	            b = this.md5_hh(b, c, d, a, x[i +  6], 23,  76029189);
	            a = this.md5_hh(a, b, c, d, x[i +  9],  4, -640364487);
	            d = this.md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
	            c = this.md5_hh(c, d, a, b, x[i + 15], 16,  530742520);
	            b = this.md5_hh(b, c, d, a, x[i +  2], 23, -995338651);
	
	            a = this.md5_ii(a, b, c, d, x[i],       6, -198630844);
	            d = this.md5_ii(d, a, b, c, x[i +  7], 10,  1126891415);
	            c = this.md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
	            b = this.md5_ii(b, c, d, a, x[i +  5], 21, -57434055);
	            a = this.md5_ii(a, b, c, d, x[i + 12],  6,  1700485571);
	            d = this.md5_ii(d, a, b, c, x[i +  3], 10, -1894986606);
	            c = this.md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
	            b = this.md5_ii(b, c, d, a, x[i +  1], 21, -2054922799);
	            a = this.md5_ii(a, b, c, d, x[i +  8],  6,  1873313359);
	            d = this.md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
	            c = this.md5_ii(c, d, a, b, x[i +  6], 15, -1560198380);
	            b = this.md5_ii(b, c, d, a, x[i + 13], 21,  1309151649);
	            a = this.md5_ii(a, b, c, d, x[i +  4],  6, -145523070);
	            d = this.md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
	            c = this.md5_ii(c, d, a, b, x[i +  2], 15,  718787259);
	            b = this.md5_ii(b, c, d, a, x[i +  9], 21, -343485551);
	
	            a = this.safe_add(a, olda);
	            b = this.safe_add(b, oldb);
	            c = this.safe_add(c, oldc);
	            d = this.safe_add(d, oldd);
	        }
	        return [a, b, c, d];
	    };
	
	    /*
	    * Convert an array of little-endian words to a string
	    */
	    BlueImpMD5.prototype.binl2rstr = function (input) {
	        var i,
	            output = '';
	        for (i = 0; i < input.length * 32; i += 8) {
	            output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xFF);
	        }
	        return output;
	    };
	
	    /*
	    * Convert a raw string to an array of little-endian words
	    * Characters >255 have their high-byte silently ignored.
	    */
	    BlueImpMD5.prototype.rstr2binl = function (input) {
	        var i,
	            output = [];
	        output[(input.length >> 2) - 1] = undefined;
	        for (i = 0; i < output.length; i += 1) {
	            output[i] = 0;
	        }
	        for (i = 0; i < input.length * 8; i += 8) {
	            output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << (i % 32);
	        }
	        return output;
	    };
	
	    /*
	    * Calculate the MD5 of a raw string
	    */
	    BlueImpMD5.prototype.rstr_md5 = function (s) {
	        return this.binl2rstr(this.binl_md5(this.rstr2binl(s), s.length * 8));
	    };
	
	    /*
	    * Calculate the HMAC-MD5, of a key and some data (raw strings)
	    */
	    BlueImpMD5.prototype.rstr_hmac_md5 = function (key, data) {
	        var i,
	            bkey = this.rstr2binl(key),
	            ipad = [],
	            opad = [],
	            hash;
	        ipad[15] = opad[15] = undefined;
	        if (bkey.length > 16) {
	            bkey = this.binl_md5(bkey, key.length * 8);
	        }
	        for (i = 0; i < 16; i += 1) {
	            ipad[i] = bkey[i] ^ 0x36363636;
	            opad[i] = bkey[i] ^ 0x5C5C5C5C;
	        }
	        hash = this.binl_md5(ipad.concat(this.rstr2binl(data)), 512 + data.length * 8);
	        return this.binl2rstr(this.binl_md5(opad.concat(hash), 512 + 128));
	    };
	
	    /*
	    * Convert a raw string to a hex string
	    */
	    BlueImpMD5.prototype.rstr2hex = function (input) {
	        var hex_tab = '0123456789abcdef',
	            output = '',
	            x,
	            i;
	        for (i = 0; i < input.length; i += 1) {
	            x = input.charCodeAt(i);
	            output += hex_tab.charAt((x >>> 4) & 0x0F) +
	                hex_tab.charAt(x & 0x0F);
	        }
	        return output;
	    };
	
	    /*
	    * Encode a string as utf-8
	    */
	    BlueImpMD5.prototype.str2rstr_utf8 = function (input) {
	        return unescape(encodeURIComponent(input));
	    };
	
	    /*
	    * Take string arguments and return either raw or hex encoded strings
	    */
	    BlueImpMD5.prototype.raw_md5 = function (s) {
	        return this.rstr_md5(this.str2rstr_utf8(s));
	    };
	    BlueImpMD5.prototype.hex_md5 = function (s) {
	        return this.rstr2hex(this.raw_md5(s));
	    };
	    BlueImpMD5.prototype.raw_hmac_md5 = function (k, d) {
	        return this.rstr_hmac_md5(this.str2rstr_utf8(k), this.str2rstr_utf8(d));
	    };
	    BlueImpMD5.prototype.hex_hmac_md5 = function (k, d) {
	        return this.rstr2hex(this.raw_hmac_md5(k, d));
	    };
	
	    BlueImpMD5.prototype.md5 = function (string, key, raw) {
	        if (!key) {
	            if (!raw) {
	                return this.hex_md5(string);
	            }
	
	            return this.raw_md5(string);
	        }
	
	        if (!raw) {
	            return this.hex_hmac_md5(key, string);
	        }
	
	        return this.raw_hmac_md5(key, string);
	    };
	
	    // CommonJS module
	    if (true) {
	        if (typeof module !== 'undefined' && module.exports) {
	            exports = module.exports = Chance;
	        }
	        exports.Chance = Chance;
	    }
	
	    // Register as an anonymous AMD module
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return Chance;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	
	    // if there is a importsScrips object define chance for worker
	    if (typeof importScripts !== 'undefined') {
	        chance = new Chance();
	    }
	
	    // If there is a window object, that at least has a document property,
	    // instantiate and define chance on the window
	    if (typeof window === "object" && typeof window.document === "object") {
	        window.Chance = Chance;
	        window.chance = new Chance();
	    }
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(1355)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(module, require('select'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod, global.select);
	        global.clipboardAction = mod.exports;
	    }
	})(this, function (module, _select) {
	    'use strict';
	
	    var _select2 = _interopRequireDefault(_select);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	        return typeof obj;
	    } : function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    var ClipboardAction = function () {
	        /**
	         * @param {Object} options
	         */
	        function ClipboardAction(options) {
	            _classCallCheck(this, ClipboardAction);
	
	            this.resolveOptions(options);
	            this.initSelection();
	        }
	
	        /**
	         * Defines base properties passed from constructor.
	         * @param {Object} options
	         */
	
	
	        _createClass(ClipboardAction, [{
	            key: 'resolveOptions',
	            value: function resolveOptions() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                this.action = options.action;
	                this.emitter = options.emitter;
	                this.target = options.target;
	                this.text = options.text;
	                this.trigger = options.trigger;
	
	                this.selectedText = '';
	            }
	        }, {
	            key: 'initSelection',
	            value: function initSelection() {
	                if (this.text) {
	                    this.selectFake();
	                } else if (this.target) {
	                    this.selectTarget();
	                }
	            }
	        }, {
	            key: 'selectFake',
	            value: function selectFake() {
	                var _this = this;
	
	                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';
	
	                this.removeFake();
	
	                this.fakeHandlerCallback = function () {
	                    return _this.removeFake();
	                };
	                this.fakeHandler = document.body.addEventListener('click', this.fakeHandlerCallback) || true;
	
	                this.fakeElem = document.createElement('textarea');
	                // Prevent zooming on iOS
	                this.fakeElem.style.fontSize = '12pt';
	                // Reset box model
	                this.fakeElem.style.border = '0';
	                this.fakeElem.style.padding = '0';
	                this.fakeElem.style.margin = '0';
	                // Move element out of screen horizontally
	                this.fakeElem.style.position = 'absolute';
	                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
	                // Move element to the same position vertically
	                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
	                this.fakeElem.addEventListener('focus', window.scrollTo(0, yPosition));
	                this.fakeElem.style.top = yPosition + 'px';
	
	                this.fakeElem.setAttribute('readonly', '');
	                this.fakeElem.value = this.text;
	
	                document.body.appendChild(this.fakeElem);
	
	                this.selectedText = (0, _select2.default)(this.fakeElem);
	                this.copyText();
	            }
	        }, {
	            key: 'removeFake',
	            value: function removeFake() {
	                if (this.fakeHandler) {
	                    document.body.removeEventListener('click', this.fakeHandlerCallback);
	                    this.fakeHandler = null;
	                    this.fakeHandlerCallback = null;
	                }
	
	                if (this.fakeElem) {
	                    document.body.removeChild(this.fakeElem);
	                    this.fakeElem = null;
	                }
	            }
	        }, {
	            key: 'selectTarget',
	            value: function selectTarget() {
	                this.selectedText = (0, _select2.default)(this.target);
	                this.copyText();
	            }
	        }, {
	            key: 'copyText',
	            value: function copyText() {
	                var succeeded = void 0;
	
	                try {
	                    succeeded = document.execCommand(this.action);
	                } catch (err) {
	                    succeeded = false;
	                }
	
	                this.handleResult(succeeded);
	            }
	        }, {
	            key: 'handleResult',
	            value: function handleResult(succeeded) {
	                this.emitter.emit(succeeded ? 'success' : 'error', {
	                    action: this.action,
	                    text: this.selectedText,
	                    trigger: this.trigger,
	                    clearSelection: this.clearSelection.bind(this)
	                });
	            }
	        }, {
	            key: 'clearSelection',
	            value: function clearSelection() {
	                if (this.target) {
	                    this.target.blur();
	                }
	
	                window.getSelection().removeAllRanges();
	            }
	        }, {
	            key: 'destroy',
	            value: function destroy() {
	                this.removeFake();
	            }
	        }, {
	            key: 'action',
	            set: function set() {
	                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';
	
	                this._action = action;
	
	                if (this._action !== 'copy' && this._action !== 'cut') {
	                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
	                }
	            },
	            get: function get() {
	                return this._action;
	            }
	        }, {
	            key: 'target',
	            set: function set(target) {
	                if (target !== undefined) {
	                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
	                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
	                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
	                        }
	
	                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
	                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
	                        }
	
	                        this._target = target;
	                    } else {
	                        throw new Error('Invalid "target" value, use a valid Element');
	                    }
	                }
	            },
	            get: function get() {
	                return this._target;
	            }
	        }]);
	
	        return ClipboardAction;
	    }();
	
	    module.exports = ClipboardAction;
	});

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(125), __webpack_require__(1363), __webpack_require__(1316)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
	        global.clipboard = mod.exports;
	    }
	})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
	    'use strict';
	
	    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);
	
	    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);
	
	    var _goodListener2 = _interopRequireDefault(_goodListener);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    function _possibleConstructorReturn(self, call) {
	        if (!self) {
	            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        }
	
	        return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    }
	
	    function _inherits(subClass, superClass) {
	        if (typeof superClass !== "function" && superClass !== null) {
	            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	        }
	
	        subClass.prototype = Object.create(superClass && superClass.prototype, {
	            constructor: {
	                value: subClass,
	                enumerable: false,
	                writable: true,
	                configurable: true
	            }
	        });
	        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    }
	
	    var Clipboard = function (_Emitter) {
	        _inherits(Clipboard, _Emitter);
	
	        /**
	         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
	         * @param {Object} options
	         */
	        function Clipboard(trigger, options) {
	            _classCallCheck(this, Clipboard);
	
	            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));
	
	            _this.resolveOptions(options);
	            _this.listenClick(trigger);
	            return _this;
	        }
	
	        /**
	         * Defines if attributes would be resolved using internal setter functions
	         * or custom functions that were passed in the constructor.
	         * @param {Object} options
	         */
	
	
	        _createClass(Clipboard, [{
	            key: 'resolveOptions',
	            value: function resolveOptions() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
	                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
	                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
	            }
	        }, {
	            key: 'listenClick',
	            value: function listenClick(trigger) {
	                var _this2 = this;
	
	                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
	                    return _this2.onClick(e);
	                });
	            }
	        }, {
	            key: 'onClick',
	            value: function onClick(e) {
	                var trigger = e.delegateTarget || e.currentTarget;
	
	                if (this.clipboardAction) {
	                    this.clipboardAction = null;
	                }
	
	                this.clipboardAction = new _clipboardAction2.default({
	                    action: this.action(trigger),
	                    target: this.target(trigger),
	                    text: this.text(trigger),
	                    trigger: trigger,
	                    emitter: this
	                });
	            }
	        }, {
	            key: 'defaultAction',
	            value: function defaultAction(trigger) {
	                return getAttributeValue('action', trigger);
	            }
	        }, {
	            key: 'defaultTarget',
	            value: function defaultTarget(trigger) {
	                var selector = getAttributeValue('target', trigger);
	
	                if (selector) {
	                    return document.querySelector(selector);
	                }
	            }
	        }, {
	            key: 'defaultText',
	            value: function defaultText(trigger) {
	                return getAttributeValue('text', trigger);
	            }
	        }, {
	            key: 'destroy',
	            value: function destroy() {
	                this.listener.destroy();
	
	                if (this.clipboardAction) {
	                    this.clipboardAction.destroy();
	                    this.clipboardAction = null;
	                }
	            }
	        }]);
	
	        return Clipboard;
	    }(_tinyEmitter2.default);
	
	    /**
	     * Helper function to retrieve attribute value.
	     * @param {String} suffix
	     * @param {Element} element
	     */
	    function getAttributeValue(suffix, element) {
	        var attribute = 'data-clipboard-' + suffix;
	
	        if (!element.hasAttribute(attribute)) {
	            return;
	        }
	
	        return element.getAttribute(attribute);
	    }
	
	    module.exports = Clipboard;
	});

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  var noOptions = {};
	  var nonWS = /[^\s\u00a0]/;
	  var Pos = CodeMirror.Pos;
	
	  function firstNonWS(str) {
	    var found = str.search(nonWS);
	    return found == -1 ? 0 : found;
	  }
	
	  CodeMirror.commands.toggleComment = function(cm) {
	    cm.toggleComment();
	  };
	
	  CodeMirror.defineExtension("toggleComment", function(options) {
	    if (!options) options = noOptions;
	    var cm = this;
	    var minLine = Infinity, ranges = this.listSelections(), mode = null;
	    for (var i = ranges.length - 1; i >= 0; i--) {
	      var from = ranges[i].from(), to = ranges[i].to();
	      if (from.line >= minLine) continue;
	      if (to.line >= minLine) to = Pos(minLine, 0);
	      minLine = from.line;
	      if (mode == null) {
	        if (cm.uncomment(from, to, options)) mode = "un";
	        else { cm.lineComment(from, to, options); mode = "line"; }
	      } else if (mode == "un") {
	        cm.uncomment(from, to, options);
	      } else {
	        cm.lineComment(from, to, options);
	      }
	    }
	  });
	
	  // Rough heuristic to try and detect lines that are part of multi-line string
	  function probablyInsideString(cm, pos, line) {
	    return /\bstring\b/.test(cm.getTokenTypeAt(Pos(pos.line, 0))) && !/^[\'\"`]/.test(line)
	  }
	
	  CodeMirror.defineExtension("lineComment", function(from, to, options) {
	    if (!options) options = noOptions;
	    var self = this, mode = self.getModeAt(from);
	    var firstLine = self.getLine(from.line);
	    if (firstLine == null || probablyInsideString(self, from, firstLine)) return;
	
	    var commentString = options.lineComment || mode.lineComment;
	    if (!commentString) {
	      if (options.blockCommentStart || mode.blockCommentStart) {
	        options.fullLines = true;
	        self.blockComment(from, to, options);
	      }
	      return;
	    }
	
	    var end = Math.min(to.ch != 0 || to.line == from.line ? to.line + 1 : to.line, self.lastLine() + 1);
	    var pad = options.padding == null ? " " : options.padding;
	    var blankLines = options.commentBlankLines || from.line == to.line;
	
	    self.operation(function() {
	      if (options.indent) {
	        var baseString = null;
	        for (var i = from.line; i < end; ++i) {
	          var line = self.getLine(i);
	          var whitespace = line.slice(0, firstNonWS(line));
	          if (baseString == null || baseString.length > whitespace.length) {
	            baseString = whitespace;
	          }
	        }
	        for (var i = from.line; i < end; ++i) {
	          var line = self.getLine(i), cut = baseString.length;
	          if (!blankLines && !nonWS.test(line)) continue;
	          if (line.slice(0, cut) != baseString) cut = firstNonWS(line);
	          self.replaceRange(baseString + commentString + pad, Pos(i, 0), Pos(i, cut));
	        }
	      } else {
	        for (var i = from.line; i < end; ++i) {
	          if (blankLines || nonWS.test(self.getLine(i)))
	            self.replaceRange(commentString + pad, Pos(i, 0));
	        }
	      }
	    });
	  });
	
	  CodeMirror.defineExtension("blockComment", function(from, to, options) {
	    if (!options) options = noOptions;
	    var self = this, mode = self.getModeAt(from);
	    var startString = options.blockCommentStart || mode.blockCommentStart;
	    var endString = options.blockCommentEnd || mode.blockCommentEnd;
	    if (!startString || !endString) {
	      if ((options.lineComment || mode.lineComment) && options.fullLines != false)
	        self.lineComment(from, to, options);
	      return;
	    }
	    if (/\bcomment\b/.test(self.getTokenTypeAt(Pos(from.line, 0)))) return
	
	    var end = Math.min(to.line, self.lastLine());
	    if (end != from.line && to.ch == 0 && nonWS.test(self.getLine(end))) --end;
	
	    var pad = options.padding == null ? " " : options.padding;
	    if (from.line > end) return;
	
	    self.operation(function() {
	      if (options.fullLines != false) {
	        var lastLineHasText = nonWS.test(self.getLine(end));
	        self.replaceRange(pad + endString, Pos(end));
	        self.replaceRange(startString + pad, Pos(from.line, 0));
	        var lead = options.blockCommentLead || mode.blockCommentLead;
	        if (lead != null) for (var i = from.line + 1; i <= end; ++i)
	          if (i != end || lastLineHasText)
	            self.replaceRange(lead + pad, Pos(i, 0));
	      } else {
	        self.replaceRange(endString, to);
	        self.replaceRange(startString, from);
	      }
	    });
	  });
	
	  CodeMirror.defineExtension("uncomment", function(from, to, options) {
	    if (!options) options = noOptions;
	    var self = this, mode = self.getModeAt(from);
	    var end = Math.min(to.ch != 0 || to.line == from.line ? to.line : to.line - 1, self.lastLine()), start = Math.min(from.line, end);
	
	    // Try finding line comments
	    var lineString = options.lineComment || mode.lineComment, lines = [];
	    var pad = options.padding == null ? " " : options.padding, didSomething;
	    lineComment: {
	      if (!lineString) break lineComment;
	      for (var i = start; i <= end; ++i) {
	        var line = self.getLine(i);
	        var found = line.indexOf(lineString);
	        if (found > -1 && !/comment/.test(self.getTokenTypeAt(Pos(i, found + 1)))) found = -1;
	        if (found == -1 && nonWS.test(line)) break lineComment;
	        if (found > -1 && nonWS.test(line.slice(0, found))) break lineComment;
	        lines.push(line);
	      }
	      self.operation(function() {
	        for (var i = start; i <= end; ++i) {
	          var line = lines[i - start];
	          var pos = line.indexOf(lineString), endPos = pos + lineString.length;
	          if (pos < 0) continue;
	          if (line.slice(endPos, endPos + pad.length) == pad) endPos += pad.length;
	          didSomething = true;
	          self.replaceRange("", Pos(i, pos), Pos(i, endPos));
	        }
	      });
	      if (didSomething) return true;
	    }
	
	    // Try block comments
	    var startString = options.blockCommentStart || mode.blockCommentStart;
	    var endString = options.blockCommentEnd || mode.blockCommentEnd;
	    if (!startString || !endString) return false;
	    var lead = options.blockCommentLead || mode.blockCommentLead;
	    var startLine = self.getLine(start), open = startLine.indexOf(startString)
	    if (open == -1) return false
	    var endLine = end == start ? startLine : self.getLine(end)
	    var close = endLine.indexOf(endString, end == start ? open + startString.length : 0);
	    if (close == -1 && start != end) {
	      endLine = self.getLine(--end);
	      close = endLine.indexOf(endString);
	    }
	    if (close == -1 ||
	        !/comment/.test(self.getTokenTypeAt(Pos(start, open + 1))) ||
	        !/comment/.test(self.getTokenTypeAt(Pos(end, close + 1))))
	      return false;
	
	    // Avoid killing block comments completely outside the selection.
	    // Positions of the last startString before the start of the selection, and the first endString after it.
	    var lastStart = startLine.lastIndexOf(startString, from.ch);
	    var firstEnd = lastStart == -1 ? -1 : startLine.slice(0, from.ch).indexOf(endString, lastStart + startString.length);
	    if (lastStart != -1 && firstEnd != -1 && firstEnd + endString.length != from.ch) return false;
	    // Positions of the first endString after the end of the selection, and the last startString before it.
	    firstEnd = endLine.indexOf(endString, to.ch);
	    var almostLastStart = endLine.slice(to.ch).lastIndexOf(startString, firstEnd - to.ch);
	    lastStart = (firstEnd == -1 || almostLastStart == -1) ? -1 : to.ch + almostLastStart;
	    if (firstEnd != -1 && lastStart != -1 && lastStart != to.ch) return false;
	
	    self.operation(function() {
	      self.replaceRange("", Pos(end, close - (pad && endLine.slice(close - pad.length, close) == pad ? pad.length : 0)),
	                        Pos(end, close + endString.length));
	      var openEnd = open + startString.length;
	      if (pad && startLine.slice(openEnd, openEnd + pad.length) == pad) openEnd += pad.length;
	      self.replaceRange("", Pos(start, open), Pos(start, openEnd));
	      if (lead) for (var i = start + 1; i <= end; ++i) {
	        var line = self.getLine(i), found = line.indexOf(lead);
	        if (found == -1 || nonWS.test(line.slice(0, found))) continue;
	        var foundEnd = found + lead.length;
	        if (pad && line.slice(foundEnd, foundEnd + pad.length) == pad) foundEnd += pad.length;
	        self.replaceRange("", Pos(i, found), Pos(i, foundEnd));
	      }
	    });
	    return true;
	  });
	});


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineOption("fullScreen", false, function(cm, val, old) {
	    if (old == CodeMirror.Init) old = false;
	    if (!old == !val) return;
	    if (val) setFullscreen(cm);
	    else setNormal(cm);
	  });
	
	  function setFullscreen(cm) {
	    var wrap = cm.getWrapperElement();
	    cm.state.fullScreenRestore = {scrollTop: window.pageYOffset, scrollLeft: window.pageXOffset,
	                                  width: wrap.style.width, height: wrap.style.height};
	    wrap.style.width = "";
	    wrap.style.height = "auto";
	    wrap.className += " CodeMirror-fullscreen";
	    document.documentElement.style.overflow = "hidden";
	    cm.refresh();
	  }
	
	  function setNormal(cm) {
	    var wrap = cm.getWrapperElement();
	    wrap.className = wrap.className.replace(/\s*CodeMirror-fullscreen\b/, "");
	    document.documentElement.style.overflow = "";
	    var info = cm.state.fullScreenRestore;
	    wrap.style.width = info.width; wrap.style.height = info.height;
	    window.scrollTo(info.scrollLeft, info.scrollTop);
	    cm.refresh();
	  }
	});


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  var defaults = {
	    pairs: "()[]{}''\"\"",
	    triples: "",
	    explode: "[]{}"
	  };
	
	  var Pos = CodeMirror.Pos;
	
	  CodeMirror.defineOption("autoCloseBrackets", false, function(cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      cm.removeKeyMap(keyMap);
	      cm.state.closeBrackets = null;
	    }
	    if (val) {
	      cm.state.closeBrackets = val;
	      cm.addKeyMap(keyMap);
	    }
	  });
	
	  function getOption(conf, name) {
	    if (name == "pairs" && typeof conf == "string") return conf;
	    if (typeof conf == "object" && conf[name] != null) return conf[name];
	    return defaults[name];
	  }
	
	  var bind = defaults.pairs + "`";
	  var keyMap = {Backspace: handleBackspace, Enter: handleEnter};
	  for (var i = 0; i < bind.length; i++)
	    keyMap["'" + bind.charAt(i) + "'"] = handler(bind.charAt(i));
	
	  function handler(ch) {
	    return function(cm) { return handleChar(cm, ch); };
	  }
	
	  function getConfig(cm) {
	    var deflt = cm.state.closeBrackets;
	    if (!deflt || deflt.override) return deflt;
	    var mode = cm.getModeAt(cm.getCursor());
	    return mode.closeBrackets || deflt;
	  }
	
	  function handleBackspace(cm) {
	    var conf = getConfig(cm);
	    if (!conf || cm.getOption("disableInput")) return CodeMirror.Pass;
	
	    var pairs = getOption(conf, "pairs");
	    var ranges = cm.listSelections();
	    for (var i = 0; i < ranges.length; i++) {
	      if (!ranges[i].empty()) return CodeMirror.Pass;
	      var around = charsAround(cm, ranges[i].head);
	      if (!around || pairs.indexOf(around) % 2 != 0) return CodeMirror.Pass;
	    }
	    for (var i = ranges.length - 1; i >= 0; i--) {
	      var cur = ranges[i].head;
	      cm.replaceRange("", Pos(cur.line, cur.ch - 1), Pos(cur.line, cur.ch + 1), "+delete");
	    }
	  }
	
	  function handleEnter(cm) {
	    var conf = getConfig(cm);
	    var explode = conf && getOption(conf, "explode");
	    if (!explode || cm.getOption("disableInput")) return CodeMirror.Pass;
	
	    var ranges = cm.listSelections();
	    for (var i = 0; i < ranges.length; i++) {
	      if (!ranges[i].empty()) return CodeMirror.Pass;
	      var around = charsAround(cm, ranges[i].head);
	      if (!around || explode.indexOf(around) % 2 != 0) return CodeMirror.Pass;
	    }
	    cm.operation(function() {
	      cm.replaceSelection("\n\n", null);
	      cm.execCommand("goCharLeft");
	      ranges = cm.listSelections();
	      for (var i = 0; i < ranges.length; i++) {
	        var line = ranges[i].head.line;
	        cm.indentLine(line, null, true);
	        cm.indentLine(line + 1, null, true);
	      }
	    });
	  }
	
	  function contractSelection(sel) {
	    var inverted = CodeMirror.cmpPos(sel.anchor, sel.head) > 0;
	    return {anchor: new Pos(sel.anchor.line, sel.anchor.ch + (inverted ? -1 : 1)),
	            head: new Pos(sel.head.line, sel.head.ch + (inverted ? 1 : -1))};
	  }
	
	  function handleChar(cm, ch) {
	    var conf = getConfig(cm);
	    if (!conf || cm.getOption("disableInput")) return CodeMirror.Pass;
	
	    var pairs = getOption(conf, "pairs");
	    var pos = pairs.indexOf(ch);
	    if (pos == -1) return CodeMirror.Pass;
	    var triples = getOption(conf, "triples");
	
	    var identical = pairs.charAt(pos + 1) == ch;
	    var ranges = cm.listSelections();
	    var opening = pos % 2 == 0;
	
	    var type;
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i], cur = range.head, curType;
	      var next = cm.getRange(cur, Pos(cur.line, cur.ch + 1));
	      if (opening && !range.empty()) {
	        curType = "surround";
	      } else if ((identical || !opening) && next == ch) {
	        if (identical && stringStartsAfter(cm, cur))
	          curType = "both";
	        else if (triples.indexOf(ch) >= 0 && cm.getRange(cur, Pos(cur.line, cur.ch + 3)) == ch + ch + ch)
	          curType = "skipThree";
	        else
	          curType = "skip";
	      } else if (identical && cur.ch > 1 && triples.indexOf(ch) >= 0 &&
	                 cm.getRange(Pos(cur.line, cur.ch - 2), cur) == ch + ch &&
	                 (cur.ch <= 2 || cm.getRange(Pos(cur.line, cur.ch - 3), Pos(cur.line, cur.ch - 2)) != ch)) {
	        curType = "addFour";
	      } else if (identical) {
	        if (!CodeMirror.isWordChar(next) && enteringString(cm, cur, ch)) curType = "both";
	        else return CodeMirror.Pass;
	      } else if (opening && (cm.getLine(cur.line).length == cur.ch ||
	                             isClosingBracket(next, pairs) ||
	                             /\s/.test(next))) {
	        curType = "both";
	      } else {
	        return CodeMirror.Pass;
	      }
	      if (!type) type = curType;
	      else if (type != curType) return CodeMirror.Pass;
	    }
	
	    var left = pos % 2 ? pairs.charAt(pos - 1) : ch;
	    var right = pos % 2 ? ch : pairs.charAt(pos + 1);
	    cm.operation(function() {
	      if (type == "skip") {
	        cm.execCommand("goCharRight");
	      } else if (type == "skipThree") {
	        for (var i = 0; i < 3; i++)
	          cm.execCommand("goCharRight");
	      } else if (type == "surround") {
	        var sels = cm.getSelections();
	        for (var i = 0; i < sels.length; i++)
	          sels[i] = left + sels[i] + right;
	        cm.replaceSelections(sels, "around");
	        sels = cm.listSelections().slice();
	        for (var i = 0; i < sels.length; i++)
	          sels[i] = contractSelection(sels[i]);
	        cm.setSelections(sels);
	      } else if (type == "both") {
	        cm.replaceSelection(left + right, null);
	        cm.triggerElectric(left + right);
	        cm.execCommand("goCharLeft");
	      } else if (type == "addFour") {
	        cm.replaceSelection(left + left + left + left, "before");
	        cm.execCommand("goCharRight");
	      }
	    });
	  }
	
	  function isClosingBracket(ch, pairs) {
	    var pos = pairs.lastIndexOf(ch);
	    return pos > -1 && pos % 2 == 1;
	  }
	
	  function charsAround(cm, pos) {
	    var str = cm.getRange(Pos(pos.line, pos.ch - 1),
	                          Pos(pos.line, pos.ch + 1));
	    return str.length == 2 ? str : null;
	  }
	
	  // Project the token type that will exists after the given char is
	  // typed, and use it to determine whether it would cause the start
	  // of a string token.
	  function enteringString(cm, pos, ch) {
	    var line = cm.getLine(pos.line);
	    var token = cm.getTokenAt(pos);
	    if (/\bstring2?\b/.test(token.type)) return false;
	    var stream = new CodeMirror.StringStream(line.slice(0, pos.ch) + ch + line.slice(pos.ch), 4);
	    stream.pos = stream.start = token.start;
	    for (;;) {
	      var type1 = cm.getMode().token(stream, token.state);
	      if (stream.pos >= pos.ch + 1) return /\bstring2?\b/.test(type1);
	      stream.start = stream.pos;
	    }
	  }
	
	  function stringStartsAfter(cm, pos) {
	    var token = cm.getTokenAt(Pos(pos.line, pos.ch + 1))
	    return /\bstring/.test(token.type) && token.start == pos.ch
	  }
	});


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	/**
	 * Tag-closer extension for CodeMirror.
	 *
	 * This extension adds an "autoCloseTags" option that can be set to
	 * either true to get the default behavior, or an object to further
	 * configure its behavior.
	 *
	 * These are supported options:
	 *
	 * `whenClosing` (default true)
	 *   Whether to autoclose when the '/' of a closing tag is typed.
	 * `whenOpening` (default true)
	 *   Whether to autoclose the tag when the final '>' of an opening
	 *   tag is typed.
	 * `dontCloseTags` (default is empty tags for HTML, none for XML)
	 *   An array of tag names that should not be autoclosed.
	 * `indentTags` (default is block tags for HTML, none for XML)
	 *   An array of tag names that should, when opened, cause a
	 *   blank line to be added inside the tag, and the blank line and
	 *   closing line to be indented.
	 *
	 * See demos/closetag.html for a usage example.
	 */
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(73));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../fold/xml-fold"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  CodeMirror.defineOption("autoCloseTags", false, function(cm, val, old) {
	    if (old != CodeMirror.Init && old)
	      cm.removeKeyMap("autoCloseTags");
	    if (!val) return;
	    var map = {name: "autoCloseTags"};
	    if (typeof val != "object" || val.whenClosing)
	      map["'/'"] = function(cm) { return autoCloseSlash(cm); };
	    if (typeof val != "object" || val.whenOpening)
	      map["'>'"] = function(cm) { return autoCloseGT(cm); };
	    cm.addKeyMap(map);
	  });
	
	  var htmlDontClose = ["area", "base", "br", "col", "command", "embed", "hr", "img", "input", "keygen", "link", "meta", "param",
	                       "source", "track", "wbr"];
	  var htmlIndent = ["applet", "blockquote", "body", "button", "div", "dl", "fieldset", "form", "frameset", "h1", "h2", "h3", "h4",
	                    "h5", "h6", "head", "html", "iframe", "layer", "legend", "object", "ol", "p", "select", "table", "ul"];
	
	  function autoCloseGT(cm) {
	    if (cm.getOption("disableInput")) return CodeMirror.Pass;
	    var ranges = cm.listSelections(), replacements = [];
	    for (var i = 0; i < ranges.length; i++) {
	      if (!ranges[i].empty()) return CodeMirror.Pass;
	      var pos = ranges[i].head, tok = cm.getTokenAt(pos);
	      var inner = CodeMirror.innerMode(cm.getMode(), tok.state), state = inner.state;
	      if (inner.mode.name != "xml" || !state.tagName) return CodeMirror.Pass;
	
	      var opt = cm.getOption("autoCloseTags"), html = inner.mode.configuration == "html";
	      var dontCloseTags = (typeof opt == "object" && opt.dontCloseTags) || (html && htmlDontClose);
	      var indentTags = (typeof opt == "object" && opt.indentTags) || (html && htmlIndent);
	
	      var tagName = state.tagName;
	      if (tok.end > pos.ch) tagName = tagName.slice(0, tagName.length - tok.end + pos.ch);
	      var lowerTagName = tagName.toLowerCase();
	      // Don't process the '>' at the end of an end-tag or self-closing tag
	      if (!tagName ||
	          tok.type == "string" && (tok.end != pos.ch || !/[\"\']/.test(tok.string.charAt(tok.string.length - 1)) || tok.string.length == 1) ||
	          tok.type == "tag" && state.type == "closeTag" ||
	          tok.string.indexOf("/") == (tok.string.length - 1) || // match something like <someTagName />
	          dontCloseTags && indexOf(dontCloseTags, lowerTagName) > -1 ||
	          closingTagExists(cm, tagName, pos, state, true))
	        return CodeMirror.Pass;
	
	      var indent = indentTags && indexOf(indentTags, lowerTagName) > -1;
	      replacements[i] = {indent: indent,
	                         text: ">" + (indent ? "\n\n" : "") + "</" + tagName + ">",
	                         newPos: indent ? CodeMirror.Pos(pos.line + 1, 0) : CodeMirror.Pos(pos.line, pos.ch + 1)};
	    }
	
	    for (var i = ranges.length - 1; i >= 0; i--) {
	      var info = replacements[i];
	      cm.replaceRange(info.text, ranges[i].head, ranges[i].anchor, "+insert");
	      var sel = cm.listSelections().slice(0);
	      sel[i] = {head: info.newPos, anchor: info.newPos};
	      cm.setSelections(sel);
	      if (info.indent) {
	        cm.indentLine(info.newPos.line, null, true);
	        cm.indentLine(info.newPos.line + 1, null, true);
	      }
	    }
	  }
	
	  function autoCloseCurrent(cm, typingSlash) {
	    var ranges = cm.listSelections(), replacements = [];
	    var head = typingSlash ? "/" : "</";
	    for (var i = 0; i < ranges.length; i++) {
	      if (!ranges[i].empty()) return CodeMirror.Pass;
	      var pos = ranges[i].head, tok = cm.getTokenAt(pos);
	      var inner = CodeMirror.innerMode(cm.getMode(), tok.state), state = inner.state;
	      if (typingSlash && (tok.type == "string" || tok.string.charAt(0) != "<" ||
	                          tok.start != pos.ch - 1))
	        return CodeMirror.Pass;
	      // Kludge to get around the fact that we are not in XML mode
	      // when completing in JS/CSS snippet in htmlmixed mode. Does not
	      // work for other XML embedded languages (there is no general
	      // way to go from a mixed mode to its current XML state).
	      var replacement;
	      if (inner.mode.name != "xml") {
	        if (cm.getMode().name == "htmlmixed" && inner.mode.name == "javascript")
	          replacement = head + "script";
	        else if (cm.getMode().name == "htmlmixed" && inner.mode.name == "css")
	          replacement = head + "style";
	        else
	          return CodeMirror.Pass;
	      } else {
	        if (!state.context || !state.context.tagName ||
	            closingTagExists(cm, state.context.tagName, pos, state))
	          return CodeMirror.Pass;
	        replacement = head + state.context.tagName;
	      }
	      if (cm.getLine(pos.line).charAt(tok.end) != ">") replacement += ">";
	      replacements[i] = replacement;
	    }
	    cm.replaceSelections(replacements);
	    ranges = cm.listSelections();
	    for (var i = 0; i < ranges.length; i++)
	      if (i == ranges.length - 1 || ranges[i].head.line < ranges[i + 1].head.line)
	        cm.indentLine(ranges[i].head.line);
	  }
	
	  function autoCloseSlash(cm) {
	    if (cm.getOption("disableInput")) return CodeMirror.Pass;
	    return autoCloseCurrent(cm, true);
	  }
	
	  CodeMirror.commands.closeTag = function(cm) { return autoCloseCurrent(cm); };
	
	  function indexOf(collection, elt) {
	    if (collection.indexOf) return collection.indexOf(elt);
	    for (var i = 0, e = collection.length; i < e; ++i)
	      if (collection[i] == elt) return i;
	    return -1;
	  }
	
	  // If xml-fold is loaded, we use its functionality to try and verify
	  // whether a given tag is actually unclosed.
	  function closingTagExists(cm, tagName, pos, state, newTag) {
	    if (!CodeMirror.scanForClosingTag) return false;
	    var end = Math.min(cm.lastLine() + 1, pos.line + 500);
	    var nextClose = CodeMirror.scanForClosingTag(cm, pos, null, end);
	    if (!nextClose || nextClose.tag != tagName) return false;
	    var cx = state.context;
	    // If the immediate wrapping context contains onCx instances of
	    // the same tag, a closing tag only exists if there are at least
	    // that many closing tags of that type following.
	    for (var onCx = newTag ? 1 : 0; cx && cx.tagName == tagName; cx = cx.prev) ++onCx;
	    pos = nextClose.to;
	    for (var i = 1; i < onCx; i++) {
	      var next = CodeMirror.scanForClosingTag(cm, pos, null, end);
	      if (!next || next.tag != tagName) return false;
	      pos = next.to;
	    }
	    return true;
	  }
	});


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.registerHelper("fold", "brace", function(cm, start) {
	  var line = start.line, lineText = cm.getLine(line);
	  var tokenType;
	
	  function findOpening(openCh) {
	    for (var at = start.ch, pass = 0;;) {
	      var found = at <= 0 ? -1 : lineText.lastIndexOf(openCh, at - 1);
	      if (found == -1) {
	        if (pass == 1) break;
	        pass = 1;
	        at = lineText.length;
	        continue;
	      }
	      if (pass == 1 && found < start.ch) break;
	      tokenType = cm.getTokenTypeAt(CodeMirror.Pos(line, found + 1));
	      if (!/^(comment|string)/.test(tokenType)) return found + 1;
	      at = found - 1;
	    }
	  }
	
	  var startToken = "{", endToken = "}", startCh = findOpening("{");
	  if (startCh == null) {
	    startToken = "[", endToken = "]";
	    startCh = findOpening("[");
	  }
	
	  if (startCh == null) return;
	  var count = 1, lastLine = cm.lastLine(), end, endCh;
	  outer: for (var i = line; i <= lastLine; ++i) {
	    var text = cm.getLine(i), pos = i == line ? startCh : 0;
	    for (;;) {
	      var nextOpen = text.indexOf(startToken, pos), nextClose = text.indexOf(endToken, pos);
	      if (nextOpen < 0) nextOpen = text.length;
	      if (nextClose < 0) nextClose = text.length;
	      pos = Math.min(nextOpen, nextClose);
	      if (pos == text.length) break;
	      if (cm.getTokenTypeAt(CodeMirror.Pos(i, pos + 1)) == tokenType) {
	        if (pos == nextOpen) ++count;
	        else if (!--count) { end = i; endCh = pos; break outer; }
	      }
	      ++pos;
	    }
	  }
	  if (end == null || line == end && endCh == startCh) return;
	  return {from: CodeMirror.Pos(line, startCh),
	          to: CodeMirror.Pos(end, endCh)};
	});
	
	CodeMirror.registerHelper("fold", "import", function(cm, start) {
	  function hasImport(line) {
	    if (line < cm.firstLine() || line > cm.lastLine()) return null;
	    var start = cm.getTokenAt(CodeMirror.Pos(line, 1));
	    if (!/\S/.test(start.string)) start = cm.getTokenAt(CodeMirror.Pos(line, start.end + 1));
	    if (start.type != "keyword" || start.string != "import") return null;
	    // Now find closing semicolon, return its position
	    for (var i = line, e = Math.min(cm.lastLine(), line + 10); i <= e; ++i) {
	      var text = cm.getLine(i), semi = text.indexOf(";");
	      if (semi != -1) return {startCh: start.end, end: CodeMirror.Pos(i, semi)};
	    }
	  }
	
	  var startLine = start.line, has = hasImport(startLine), prev;
	  if (!has || hasImport(startLine - 1) || ((prev = hasImport(startLine - 2)) && prev.end.line == startLine - 1))
	    return null;
	  for (var end = has.end;;) {
	    var next = hasImport(end.line + 1);
	    if (next == null) break;
	    end = next.end;
	  }
	  return {from: cm.clipPos(CodeMirror.Pos(startLine, has.startCh + 1)), to: end};
	});
	
	CodeMirror.registerHelper("fold", "include", function(cm, start) {
	  function hasInclude(line) {
	    if (line < cm.firstLine() || line > cm.lastLine()) return null;
	    var start = cm.getTokenAt(CodeMirror.Pos(line, 1));
	    if (!/\S/.test(start.string)) start = cm.getTokenAt(CodeMirror.Pos(line, start.end + 1));
	    if (start.type == "meta" && start.string.slice(0, 8) == "#include") return start.start + 8;
	  }
	
	  var startLine = start.line, has = hasInclude(startLine);
	  if (has == null || hasInclude(startLine - 1) != null) return null;
	  for (var end = startLine;;) {
	    var next = hasInclude(end + 1);
	    if (next == null) break;
	    ++end;
	  }
	  return {from: CodeMirror.Pos(startLine, has + 1),
	          to: cm.clipPos(CodeMirror.Pos(end))};
	});
	
	});


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.registerGlobalHelper("fold", "comment", function(mode) {
	  return mode.blockCommentStart && mode.blockCommentEnd;
	}, function(cm, start) {
	  var mode = cm.getModeAt(start), startToken = mode.blockCommentStart, endToken = mode.blockCommentEnd;
	  if (!startToken || !endToken) return;
	  var line = start.line, lineText = cm.getLine(line);
	
	  var startCh;
	  for (var at = start.ch, pass = 0;;) {
	    var found = at <= 0 ? -1 : lineText.lastIndexOf(startToken, at - 1);
	    if (found == -1) {
	      if (pass == 1) return;
	      pass = 1;
	      at = lineText.length;
	      continue;
	    }
	    if (pass == 1 && found < start.ch) return;
	    if (/comment/.test(cm.getTokenTypeAt(CodeMirror.Pos(line, found + 1))) &&
	        (found == 0 || lineText.slice(found - endToken.length, found) == endToken ||
	         !/comment/.test(cm.getTokenTypeAt(CodeMirror.Pos(line, found))))) {
	      startCh = found + startToken.length;
	      break;
	    }
	    at = found - 1;
	  }
	
	  var depth = 1, lastLine = cm.lastLine(), end, endCh;
	  outer: for (var i = line; i <= lastLine; ++i) {
	    var text = cm.getLine(i), pos = i == line ? startCh : 0;
	    for (;;) {
	      var nextOpen = text.indexOf(startToken, pos), nextClose = text.indexOf(endToken, pos);
	      if (nextOpen < 0) nextOpen = text.length;
	      if (nextClose < 0) nextClose = text.length;
	      pos = Math.min(nextOpen, nextClose);
	      if (pos == text.length) break;
	      if (pos == nextOpen) ++depth;
	      else if (!--depth) { end = i; endCh = pos; break outer; }
	      ++pos;
	    }
	  }
	  if (end == null || line == end && endCh == startCh) return;
	  return {from: CodeMirror.Pos(line, startCh),
	          to: CodeMirror.Pos(end, endCh)};
	});
	
	});


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(72));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "./foldcode"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineOption("foldGutter", false, function(cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      cm.clearGutter(cm.state.foldGutter.options.gutter);
	      cm.state.foldGutter = null;
	      cm.off("gutterClick", onGutterClick);
	      cm.off("change", onChange);
	      cm.off("viewportChange", onViewportChange);
	      cm.off("fold", onFold);
	      cm.off("unfold", onFold);
	      cm.off("swapDoc", onChange);
	    }
	    if (val) {
	      cm.state.foldGutter = new State(parseOptions(val));
	      updateInViewport(cm);
	      cm.on("gutterClick", onGutterClick);
	      cm.on("change", onChange);
	      cm.on("viewportChange", onViewportChange);
	      cm.on("fold", onFold);
	      cm.on("unfold", onFold);
	      cm.on("swapDoc", onChange);
	    }
	  });
	
	  var Pos = CodeMirror.Pos;
	
	  function State(options) {
	    this.options = options;
	    this.from = this.to = 0;
	  }
	
	  function parseOptions(opts) {
	    if (opts === true) opts = {};
	    if (opts.gutter == null) opts.gutter = "CodeMirror-foldgutter";
	    if (opts.indicatorOpen == null) opts.indicatorOpen = "CodeMirror-foldgutter-open";
	    if (opts.indicatorFolded == null) opts.indicatorFolded = "CodeMirror-foldgutter-folded";
	    return opts;
	  }
	
	  function isFolded(cm, line) {
	    var marks = cm.findMarks(Pos(line, 0), Pos(line + 1, 0));
	    for (var i = 0; i < marks.length; ++i)
	      if (marks[i].__isFold && marks[i].find().from.line == line) return marks[i];
	  }
	
	  function marker(spec) {
	    if (typeof spec == "string") {
	      var elt = document.createElement("div");
	      elt.className = spec + " CodeMirror-guttermarker-subtle";
	      return elt;
	    } else {
	      return spec.cloneNode(true);
	    }
	  }
	
	  function updateFoldInfo(cm, from, to) {
	    var opts = cm.state.foldGutter.options, cur = from;
	    var minSize = cm.foldOption(opts, "minFoldSize");
	    var func = cm.foldOption(opts, "rangeFinder");
	    cm.eachLine(from, to, function(line) {
	      var mark = null;
	      if (isFolded(cm, cur)) {
	        mark = marker(opts.indicatorFolded);
	      } else {
	        var pos = Pos(cur, 0);
	        var range = func && func(cm, pos);
	        if (range && range.to.line - range.from.line >= minSize)
	          mark = marker(opts.indicatorOpen);
	      }
	      cm.setGutterMarker(line, opts.gutter, mark);
	      ++cur;
	    });
	  }
	
	  function updateInViewport(cm) {
	    var vp = cm.getViewport(), state = cm.state.foldGutter;
	    if (!state) return;
	    cm.operation(function() {
	      updateFoldInfo(cm, vp.from, vp.to);
	    });
	    state.from = vp.from; state.to = vp.to;
	  }
	
	  function onGutterClick(cm, line, gutter) {
	    var state = cm.state.foldGutter;
	    if (!state) return;
	    var opts = state.options;
	    if (gutter != opts.gutter) return;
	    var folded = isFolded(cm, line);
	    if (folded) folded.clear();
	    else cm.foldCode(Pos(line, 0), opts.rangeFinder);
	  }
	
	  function onChange(cm) {
	    var state = cm.state.foldGutter;
	    if (!state) return;
	    var opts = state.options;
	    state.from = state.to = 0;
	    clearTimeout(state.changeUpdate);
	    state.changeUpdate = setTimeout(function() { updateInViewport(cm); }, opts.foldOnChangeTimeSpan || 600);
	  }
	
	  function onViewportChange(cm) {
	    var state = cm.state.foldGutter;
	    if (!state) return;
	    var opts = state.options;
	    clearTimeout(state.changeUpdate);
	    state.changeUpdate = setTimeout(function() {
	      var vp = cm.getViewport();
	      if (state.from == state.to || vp.from - state.to > 20 || state.from - vp.to > 20) {
	        updateInViewport(cm);
	      } else {
	        cm.operation(function() {
	          if (vp.from < state.from) {
	            updateFoldInfo(cm, vp.from, state.from);
	            state.from = vp.from;
	          }
	          if (vp.to > state.to) {
	            updateFoldInfo(cm, state.to, vp.to);
	            state.to = vp.to;
	          }
	        });
	      }
	    }, opts.updateViewportTimeSpan || 400);
	  }
	
	  function onFold(cm, from) {
	    var state = cm.state.foldGutter;
	    if (!state) return;
	    var line = from.line;
	    if (line >= state.from && line < state.to)
	      updateFoldInfo(cm, line, line + 1);
	  }
	});


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.registerHelper("fold", "indent", function(cm, start) {
	  var tabSize = cm.getOption("tabSize"), firstLine = cm.getLine(start.line);
	  if (!/\S/.test(firstLine)) return;
	  var getIndent = function(line) {
	    return CodeMirror.countColumn(line, null, tabSize);
	  };
	  var myIndent = getIndent(firstLine);
	  var lastLineInFold = null;
	  // Go through lines until we find a line that definitely doesn't belong in
	  // the block we're folding, or to the end.
	  for (var i = start.line + 1, end = cm.lastLine(); i <= end; ++i) {
	    var curLine = cm.getLine(i);
	    var curIndent = getIndent(curLine);
	    if (curIndent > myIndent) {
	      // Lines with a greater indent are considered part of the block.
	      lastLineInFold = i;
	    } else if (!/\S/.test(curLine)) {
	      // Empty lines might be breaks within the block we're trying to fold.
	    } else {
	      // A non-empty line at an indent equal to or less than ours marks the
	      // start of another block.
	      break;
	    }
	  }
	  if (lastLineInFold) return {
	    from: CodeMirror.Pos(start.line, firstLine.length),
	    to: CodeMirror.Pos(lastLineInFold, cm.getLine(lastLineInFold).length)
	  };
	});
	
	});


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.registerHelper("fold", "markdown", function(cm, start) {
	  var maxDepth = 100;
	
	  function isHeader(lineNo) {
	    var tokentype = cm.getTokenTypeAt(CodeMirror.Pos(lineNo, 0));
	    return tokentype && /\bheader\b/.test(tokentype);
	  }
	
	  function headerLevel(lineNo, line, nextLine) {
	    var match = line && line.match(/^#+/);
	    if (match && isHeader(lineNo)) return match[0].length;
	    match = nextLine && nextLine.match(/^[=\-]+\s*$/);
	    if (match && isHeader(lineNo + 1)) return nextLine[0] == "=" ? 1 : 2;
	    return maxDepth;
	  }
	
	  var firstLine = cm.getLine(start.line), nextLine = cm.getLine(start.line + 1);
	  var level = headerLevel(start.line, firstLine, nextLine);
	  if (level === maxDepth) return undefined;
	
	  var lastLineNo = cm.lastLine();
	  var end = start.line, nextNextLine = cm.getLine(end + 2);
	  while (end < lastLineNo) {
	    if (headerLevel(end + 1, nextLine, nextNextLine) <= level) break;
	    ++end;
	    nextLine = nextNextLine;
	    nextNextLine = cm.getLine(end + 2);
	  }
	
	  return {
	    from: CodeMirror.Pos(start.line, firstLine.length),
	    to: CodeMirror.Pos(end, cm.getLine(end).length)
	  };
	});
	
	});


/***/ },
/* 136 */,
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  var WORD = /[\w$]+/, RANGE = 500;
	
	  CodeMirror.registerHelper("hint", "anyword", function(editor, options) {
	    var word = options && options.word || WORD;
	    var range = options && options.range || RANGE;
	    var cur = editor.getCursor(), curLine = editor.getLine(cur.line);
	    var end = cur.ch, start = end;
	    while (start && word.test(curLine.charAt(start - 1))) --start;
	    var curWord = start != end && curLine.slice(start, end);
	
	    var list = options && options.list || [], seen = {};
	    var re = new RegExp(word.source, "g");
	    for (var dir = -1; dir <= 1; dir += 2) {
	      var line = cur.line, endLine = Math.min(Math.max(line + dir * range, editor.firstLine()), editor.lastLine()) + dir;
	      for (; line != endLine; line += dir) {
	        var text = editor.getLine(line), m;
	        while (m = re.exec(text)) {
	          if (line == cur.line && m[0] === curWord) continue;
	          if ((!curWord || m[0].lastIndexOf(curWord, 0) == 0) && !Object.prototype.hasOwnProperty.call(seen, m[0])) {
	            seen[m[0]] = true;
	            list.push(m[0]);
	          }
	        }
	      }
	    }
	    return {list: list, from: CodeMirror.Pos(cur.line, start), to: CodeMirror.Pos(cur.line, end)};
	  });
	});


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(21));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../../mode/css/css"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  var pseudoClasses = {link: 1, visited: 1, active: 1, hover: 1, focus: 1,
	                       "first-letter": 1, "first-line": 1, "first-child": 1,
	                       before: 1, after: 1, lang: 1};
	
	  CodeMirror.registerHelper("hint", "css", function(cm) {
	    var cur = cm.getCursor(), token = cm.getTokenAt(cur);
	    var inner = CodeMirror.innerMode(cm.getMode(), token.state);
	    if (inner.mode.name != "css") return;
	
	    if (token.type == "keyword" && "!important".indexOf(token.string) == 0)
	      return {list: ["!important"], from: CodeMirror.Pos(cur.line, token.start),
	              to: CodeMirror.Pos(cur.line, token.end)};
	
	    var start = token.start, end = cur.ch, word = token.string.slice(0, end - start);
	    if (/[^\w$_-]/.test(word)) {
	      word = ""; start = end = cur.ch;
	    }
	
	    var spec = CodeMirror.resolveMode("text/css");
	
	    var result = [];
	    function add(keywords) {
	      for (var name in keywords)
	        if (!word || name.lastIndexOf(word, 0) == 0)
	          result.push(name);
	    }
	
	    var st = inner.state.state;
	    if (st == "pseudo" || token.type == "variable-3") {
	      add(pseudoClasses);
	    } else if (st == "block" || st == "maybeprop") {
	      add(spec.propertyKeywords);
	    } else if (st == "prop" || st == "parens" || st == "at" || st == "params") {
	      add(spec.valueKeywords);
	      add(spec.colorKeywords);
	    } else if (st == "media" || st == "media_parens") {
	      add(spec.mediaTypes);
	      add(spec.mediaFeatures);
	    }
	
	    if (result.length) return {
	      list: result,
	      from: CodeMirror.Pos(cur.line, start),
	      to: CodeMirror.Pos(cur.line, end)
	    };
	  });
	});


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(75));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "./xml-hint"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  var langs = "ab aa af ak sq am ar an hy as av ae ay az bm ba eu be bn bh bi bs br bg my ca ch ce ny zh cv kw co cr hr cs da dv nl dz en eo et ee fo fj fi fr ff gl ka de el gn gu ht ha he hz hi ho hu ia id ie ga ig ik io is it iu ja jv kl kn kr ks kk km ki rw ky kv kg ko ku kj la lb lg li ln lo lt lu lv gv mk mg ms ml mt mi mr mh mn na nv nb nd ne ng nn no ii nr oc oj cu om or os pa pi fa pl ps pt qu rm rn ro ru sa sc sd se sm sg sr gd sn si sk sl so st es su sw ss sv ta te tg th ti bo tk tl tn to tr ts tt tw ty ug uk ur uz ve vi vo wa cy wo fy xh yi yo za zu".split(" ");
	  var targets = ["_blank", "_self", "_top", "_parent"];
	  var charsets = ["ascii", "utf-8", "utf-16", "latin1", "latin1"];
	  var methods = ["get", "post", "put", "delete"];
	  var encs = ["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"];
	  var media = ["all", "screen", "print", "embossed", "braille", "handheld", "print", "projection", "screen", "tty", "tv", "speech",
	               "3d-glasses", "resolution [>][<][=] [X]", "device-aspect-ratio: X/Y", "orientation:portrait",
	               "orientation:landscape", "device-height: [X]", "device-width: [X]"];
	  var s = { attrs: {} }; // Simple tag, reused for a whole lot of tags
	
	  var data = {
	    a: {
	      attrs: {
	        href: null, ping: null, type: null,
	        media: media,
	        target: targets,
	        hreflang: langs
	      }
	    },
	    abbr: s,
	    acronym: s,
	    address: s,
	    applet: s,
	    area: {
	      attrs: {
	        alt: null, coords: null, href: null, target: null, ping: null,
	        media: media, hreflang: langs, type: null,
	        shape: ["default", "rect", "circle", "poly"]
	      }
	    },
	    article: s,
	    aside: s,
	    audio: {
	      attrs: {
	        src: null, mediagroup: null,
	        crossorigin: ["anonymous", "use-credentials"],
	        preload: ["none", "metadata", "auto"],
	        autoplay: ["", "autoplay"],
	        loop: ["", "loop"],
	        controls: ["", "controls"]
	      }
	    },
	    b: s,
	    base: { attrs: { href: null, target: targets } },
	    basefont: s,
	    bdi: s,
	    bdo: s,
	    big: s,
	    blockquote: { attrs: { cite: null } },
	    body: s,
	    br: s,
	    button: {
	      attrs: {
	        form: null, formaction: null, name: null, value: null,
	        autofocus: ["", "autofocus"],
	        disabled: ["", "autofocus"],
	        formenctype: encs,
	        formmethod: methods,
	        formnovalidate: ["", "novalidate"],
	        formtarget: targets,
	        type: ["submit", "reset", "button"]
	      }
	    },
	    canvas: { attrs: { width: null, height: null } },
	    caption: s,
	    center: s,
	    cite: s,
	    code: s,
	    col: { attrs: { span: null } },
	    colgroup: { attrs: { span: null } },
	    command: {
	      attrs: {
	        type: ["command", "checkbox", "radio"],
	        label: null, icon: null, radiogroup: null, command: null, title: null,
	        disabled: ["", "disabled"],
	        checked: ["", "checked"]
	      }
	    },
	    data: { attrs: { value: null } },
	    datagrid: { attrs: { disabled: ["", "disabled"], multiple: ["", "multiple"] } },
	    datalist: { attrs: { data: null } },
	    dd: s,
	    del: { attrs: { cite: null, datetime: null } },
	    details: { attrs: { open: ["", "open"] } },
	    dfn: s,
	    dir: s,
	    div: s,
	    dl: s,
	    dt: s,
	    em: s,
	    embed: { attrs: { src: null, type: null, width: null, height: null } },
	    eventsource: { attrs: { src: null } },
	    fieldset: { attrs: { disabled: ["", "disabled"], form: null, name: null } },
	    figcaption: s,
	    figure: s,
	    font: s,
	    footer: s,
	    form: {
	      attrs: {
	        action: null, name: null,
	        "accept-charset": charsets,
	        autocomplete: ["on", "off"],
	        enctype: encs,
	        method: methods,
	        novalidate: ["", "novalidate"],
	        target: targets
	      }
	    },
	    frame: s,
	    frameset: s,
	    h1: s, h2: s, h3: s, h4: s, h5: s, h6: s,
	    head: {
	      attrs: {},
	      children: ["title", "base", "link", "style", "meta", "script", "noscript", "command"]
	    },
	    header: s,
	    hgroup: s,
	    hr: s,
	    html: {
	      attrs: { manifest: null },
	      children: ["head", "body"]
	    },
	    i: s,
	    iframe: {
	      attrs: {
	        src: null, srcdoc: null, name: null, width: null, height: null,
	        sandbox: ["allow-top-navigation", "allow-same-origin", "allow-forms", "allow-scripts"],
	        seamless: ["", "seamless"]
	      }
	    },
	    img: {
	      attrs: {
	        alt: null, src: null, ismap: null, usemap: null, width: null, height: null,
	        crossorigin: ["anonymous", "use-credentials"]
	      }
	    },
	    input: {
	      attrs: {
	        alt: null, dirname: null, form: null, formaction: null,
	        height: null, list: null, max: null, maxlength: null, min: null,
	        name: null, pattern: null, placeholder: null, size: null, src: null,
	        step: null, value: null, width: null,
	        accept: ["audio/*", "video/*", "image/*"],
	        autocomplete: ["on", "off"],
	        autofocus: ["", "autofocus"],
	        checked: ["", "checked"],
	        disabled: ["", "disabled"],
	        formenctype: encs,
	        formmethod: methods,
	        formnovalidate: ["", "novalidate"],
	        formtarget: targets,
	        multiple: ["", "multiple"],
	        readonly: ["", "readonly"],
	        required: ["", "required"],
	        type: ["hidden", "text", "search", "tel", "url", "email", "password", "datetime", "date", "month",
	               "week", "time", "datetime-local", "number", "range", "color", "checkbox", "radio",
	               "file", "submit", "image", "reset", "button"]
	      }
	    },
	    ins: { attrs: { cite: null, datetime: null } },
	    kbd: s,
	    keygen: {
	      attrs: {
	        challenge: null, form: null, name: null,
	        autofocus: ["", "autofocus"],
	        disabled: ["", "disabled"],
	        keytype: ["RSA"]
	      }
	    },
	    label: { attrs: { "for": null, form: null } },
	    legend: s,
	    li: { attrs: { value: null } },
	    link: {
	      attrs: {
	        href: null, type: null,
	        hreflang: langs,
	        media: media,
	        sizes: ["all", "16x16", "16x16 32x32", "16x16 32x32 64x64"]
	      }
	    },
	    map: { attrs: { name: null } },
	    mark: s,
	    menu: { attrs: { label: null, type: ["list", "context", "toolbar"] } },
	    meta: {
	      attrs: {
	        content: null,
	        charset: charsets,
	        name: ["viewport", "application-name", "author", "description", "generator", "keywords"],
	        "http-equiv": ["content-language", "content-type", "default-style", "refresh"]
	      }
	    },
	    meter: { attrs: { value: null, min: null, low: null, high: null, max: null, optimum: null } },
	    nav: s,
	    noframes: s,
	    noscript: s,
	    object: {
	      attrs: {
	        data: null, type: null, name: null, usemap: null, form: null, width: null, height: null,
	        typemustmatch: ["", "typemustmatch"]
	      }
	    },
	    ol: { attrs: { reversed: ["", "reversed"], start: null, type: ["1", "a", "A", "i", "I"] } },
	    optgroup: { attrs: { disabled: ["", "disabled"], label: null } },
	    option: { attrs: { disabled: ["", "disabled"], label: null, selected: ["", "selected"], value: null } },
	    output: { attrs: { "for": null, form: null, name: null } },
	    p: s,
	    param: { attrs: { name: null, value: null } },
	    pre: s,
	    progress: { attrs: { value: null, max: null } },
	    q: { attrs: { cite: null } },
	    rp: s,
	    rt: s,
	    ruby: s,
	    s: s,
	    samp: s,
	    script: {
	      attrs: {
	        type: ["text/javascript"],
	        src: null,
	        async: ["", "async"],
	        defer: ["", "defer"],
	        charset: charsets
	      }
	    },
	    section: s,
	    select: {
	      attrs: {
	        form: null, name: null, size: null,
	        autofocus: ["", "autofocus"],
	        disabled: ["", "disabled"],
	        multiple: ["", "multiple"]
	      }
	    },
	    small: s,
	    source: { attrs: { src: null, type: null, media: null } },
	    span: s,
	    strike: s,
	    strong: s,
	    style: {
	      attrs: {
	        type: ["text/css"],
	        media: media,
	        scoped: null
	      }
	    },
	    sub: s,
	    summary: s,
	    sup: s,
	    table: s,
	    tbody: s,
	    td: { attrs: { colspan: null, rowspan: null, headers: null } },
	    textarea: {
	      attrs: {
	        dirname: null, form: null, maxlength: null, name: null, placeholder: null,
	        rows: null, cols: null,
	        autofocus: ["", "autofocus"],
	        disabled: ["", "disabled"],
	        readonly: ["", "readonly"],
	        required: ["", "required"],
	        wrap: ["soft", "hard"]
	      }
	    },
	    tfoot: s,
	    th: { attrs: { colspan: null, rowspan: null, headers: null, scope: ["row", "col", "rowgroup", "colgroup"] } },
	    thead: s,
	    time: { attrs: { datetime: null } },
	    title: s,
	    tr: s,
	    track: {
	      attrs: {
	        src: null, label: null, "default": null,
	        kind: ["subtitles", "captions", "descriptions", "chapters", "metadata"],
	        srclang: langs
	      }
	    },
	    tt: s,
	    u: s,
	    ul: s,
	    "var": s,
	    video: {
	      attrs: {
	        src: null, poster: null, width: null, height: null,
	        crossorigin: ["anonymous", "use-credentials"],
	        preload: ["auto", "metadata", "none"],
	        autoplay: ["", "autoplay"],
	        mediagroup: ["movie"],
	        muted: ["", "muted"],
	        controls: ["", "controls"]
	      }
	    },
	    wbr: s
	  };
	
	  var globalAttrs = {
	    accesskey: ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
	    "class": null,
	    contenteditable: ["true", "false"],
	    contextmenu: null,
	    dir: ["ltr", "rtl", "auto"],
	    draggable: ["true", "false", "auto"],
	    dropzone: ["copy", "move", "link", "string:", "file:"],
	    hidden: ["hidden"],
	    id: null,
	    inert: ["inert"],
	    itemid: null,
	    itemprop: null,
	    itemref: null,
	    itemscope: ["itemscope"],
	    itemtype: null,
	    lang: ["en", "es"],
	    spellcheck: ["true", "false"],
	    style: null,
	    tabindex: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
	    title: null,
	    translate: ["yes", "no"],
	    onclick: null,
	    rel: ["stylesheet", "alternate", "author", "bookmark", "help", "license", "next", "nofollow", "noreferrer", "prefetch", "prev", "search", "tag"]
	  };
	  function populate(obj) {
	    for (var attr in globalAttrs) if (globalAttrs.hasOwnProperty(attr))
	      obj.attrs[attr] = globalAttrs[attr];
	  }
	
	  populate(s);
	  for (var tag in data) if (data.hasOwnProperty(tag) && data[tag] != s)
	    populate(data[tag]);
	
	  CodeMirror.htmlSchema = data;
	  function htmlHint(cm, options) {
	    var local = {schemaInfo: data};
	    if (options) for (var opt in options) local[opt] = options[opt];
	    return CodeMirror.hint.xml(cm, local);
	  }
	  CodeMirror.registerHelper("hint", "html", htmlHint);
	});


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  var Pos = CodeMirror.Pos;
	
	  function forEach(arr, f) {
	    for (var i = 0, e = arr.length; i < e; ++i) f(arr[i]);
	  }
	
	  function arrayContains(arr, item) {
	    if (!Array.prototype.indexOf) {
	      var i = arr.length;
	      while (i--) {
	        if (arr[i] === item) {
	          return true;
	        }
	      }
	      return false;
	    }
	    return arr.indexOf(item) != -1;
	  }
	
	  function scriptHint(editor, keywords, getToken, options) {
	    // Find the token at the cursor
	    var cur = editor.getCursor(), token = getToken(editor, cur);
	    if (/\b(?:string|comment)\b/.test(token.type)) return;
	    token.state = CodeMirror.innerMode(editor.getMode(), token.state).state;
	
	    // If it's not a 'word-style' token, ignore the token.
	    if (!/^[\w$_]*$/.test(token.string)) {
	      token = {start: cur.ch, end: cur.ch, string: "", state: token.state,
	               type: token.string == "." ? "property" : null};
	    } else if (token.end > cur.ch) {
	      token.end = cur.ch;
	      token.string = token.string.slice(0, cur.ch - token.start);
	    }
	
	    var tprop = token;
	    // If it is a property, find out what it is a property of.
	    while (tprop.type == "property") {
	      tprop = getToken(editor, Pos(cur.line, tprop.start));
	      if (tprop.string != ".") return;
	      tprop = getToken(editor, Pos(cur.line, tprop.start));
	      if (!context) var context = [];
	      context.push(tprop);
	    }
	    return {list: getCompletions(token, context, keywords, options),
	            from: Pos(cur.line, token.start),
	            to: Pos(cur.line, token.end)};
	  }
	
	  function javascriptHint(editor, options) {
	    return scriptHint(editor, javascriptKeywords,
	                      function (e, cur) {return e.getTokenAt(cur);},
	                      options);
	  };
	  CodeMirror.registerHelper("hint", "javascript", javascriptHint);
	
	  function getCoffeeScriptToken(editor, cur) {
	  // This getToken, it is for coffeescript, imitates the behavior of
	  // getTokenAt method in javascript.js, that is, returning "property"
	  // type and treat "." as indepenent token.
	    var token = editor.getTokenAt(cur);
	    if (cur.ch == token.start + 1 && token.string.charAt(0) == '.') {
	      token.end = token.start;
	      token.string = '.';
	      token.type = "property";
	    }
	    else if (/^\.[\w$_]*$/.test(token.string)) {
	      token.type = "property";
	      token.start++;
	      token.string = token.string.replace(/\./, '');
	    }
	    return token;
	  }
	
	  function coffeescriptHint(editor, options) {
	    return scriptHint(editor, coffeescriptKeywords, getCoffeeScriptToken, options);
	  }
	  CodeMirror.registerHelper("hint", "coffeescript", coffeescriptHint);
	
	  var stringProps = ("charAt charCodeAt indexOf lastIndexOf substring substr slice trim trimLeft trimRight " +
	                     "toUpperCase toLowerCase split concat match replace search").split(" ");
	  var arrayProps = ("length concat join splice push pop shift unshift slice reverse sort indexOf " +
	                    "lastIndexOf every some filter forEach map reduce reduceRight ").split(" ");
	  var funcProps = "prototype apply call bind".split(" ");
	  var javascriptKeywords = ("break case catch continue debugger default delete do else false finally for function " +
	                  "if in instanceof new null return switch throw true try typeof var void while with").split(" ");
	  var coffeescriptKeywords = ("and break catch class continue delete do else extends false finally for " +
	                  "if in instanceof isnt new no not null of off on or return switch then throw true try typeof until void while with yes").split(" ");
	
	  function forAllProps(obj, callback) {
	    if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) {
	      for (var name in obj) callback(name)
	    } else {
	      for (var o = obj; o; o = Object.getPrototypeOf(o))
	        Object.getOwnPropertyNames(o).forEach(callback)
	    }
	  }
	
	  function getCompletions(token, context, keywords, options) {
	    var found = [], start = token.string, global = options && options.globalScope || window;
	    function maybeAdd(str) {
	      if (str.lastIndexOf(start, 0) == 0 && !arrayContains(found, str)) found.push(str);
	    }
	    function gatherCompletions(obj) {
	      if (typeof obj == "string") forEach(stringProps, maybeAdd);
	      else if (obj instanceof Array) forEach(arrayProps, maybeAdd);
	      else if (obj instanceof Function) forEach(funcProps, maybeAdd);
	      forAllProps(obj, maybeAdd)
	    }
	
	    if (context && context.length) {
	      // If this is a property, see if it belongs to some object we can
	      // find in the current environment.
	      var obj = context.pop(), base;
	      if (obj.type && obj.type.indexOf("variable") === 0) {
	        if (options && options.additionalContext)
	          base = options.additionalContext[obj.string];
	        if (!options || options.useGlobalScope !== false)
	          base = base || global[obj.string];
	      } else if (obj.type == "string") {
	        base = "";
	      } else if (obj.type == "atom") {
	        base = 1;
	      } else if (obj.type == "function") {
	        if (global.jQuery != null && (obj.string == '$' || obj.string == 'jQuery') &&
	            (typeof global.jQuery == 'function'))
	          base = global.jQuery();
	        else if (global._ != null && (obj.string == '_') && (typeof global._ == 'function'))
	          base = global._();
	      }
	      while (base != null && context.length)
	        base = base[context.pop().string];
	      if (base != null) gatherCompletions(base);
	    } else {
	      // If not, just look in the global object and any local scope
	      // (reading into JS mode internals to get at the local and global variables)
	      for (var v = token.state.localVars; v; v = v.next) maybeAdd(v.name);
	      for (var v = token.state.globalVars; v; v = v.next) maybeAdd(v.name);
	      if (!options || options.useGlobalScope !== false)
	        gatherCompletions(global);
	      forEach(keywords, maybeAdd);
	    }
	    return found;
	  }
	});


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(86));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../../mode/sql/sql"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  var tables;
	  var defaultTable;
	  var keywords;
	  var CONS = {
	    QUERY_DIV: ";",
	    ALIAS_KEYWORD: "AS"
	  };
	  var Pos = CodeMirror.Pos, cmpPos = CodeMirror.cmpPos;
	
	  function isArray(val) { return Object.prototype.toString.call(val) == "[object Array]" }
	
	  function getKeywords(editor) {
	    var mode = editor.doc.modeOption;
	    if (mode === "sql") mode = "text/x-sql";
	    return CodeMirror.resolveMode(mode).keywords;
	  }
	
	  function getText(item) {
	    return typeof item == "string" ? item : item.text;
	  }
	
	  function wrapTable(name, value) {
	    if (isArray(value)) value = {columns: value}
	    if (!value.text) value.text = name
	    return value
	  }
	
	  function parseTables(input) {
	    var result = {}
	    if (isArray(input)) {
	      for (var i = input.length - 1; i >= 0; i--) {
	        var item = input[i]
	        result[getText(item).toUpperCase()] = wrapTable(getText(item), item)
	      }
	    } else if (input) {
	      for (var name in input)
	        result[name.toUpperCase()] = wrapTable(name, input[name])
	    }
	    return result
	  }
	
	  function getTable(name) {
	    return tables[name.toUpperCase()]
	  }
	
	  function shallowClone(object) {
	    var result = {};
	    for (var key in object) if (object.hasOwnProperty(key))
	      result[key] = object[key];
	    return result;
	  }
	
	  function match(string, word) {
	    var len = string.length;
	    var sub = getText(word).substr(0, len);
	    return string.toUpperCase() === sub.toUpperCase();
	  }
	
	  function addMatches(result, search, wordlist, formatter) {
	    if (isArray(wordlist)) {
	      for (var i = 0; i < wordlist.length; i++)
	        if (match(search, wordlist[i])) result.push(formatter(wordlist[i]))
	    } else {
	      for (var word in wordlist) if (wordlist.hasOwnProperty(word)) {
	        var val = wordlist[word]
	        if (!val || val === true)
	          val = word
	        else
	          val = val.displayText ? {text: val.text, displayText: val.displayText} : val.text
	        if (match(search, val)) result.push(formatter(val))
	      }
	    }
	  }
	
	  function cleanName(name) {
	    // Get rid name from backticks(`) and preceding dot(.)
	    if (name.charAt(0) == ".") {
	      name = name.substr(1);
	    }
	    return name.replace(/`/g, "");
	  }
	
	  function insertBackticks(name) {
	    var nameParts = getText(name).split(".");
	    for (var i = 0; i < nameParts.length; i++)
	      nameParts[i] = "`" + nameParts[i] + "`";
	    var escaped = nameParts.join(".");
	    if (typeof name == "string") return escaped;
	    name = shallowClone(name);
	    name.text = escaped;
	    return name;
	  }
	
	  function nameCompletion(cur, token, result, editor) {
	    // Try to complete table, column names and return start position of completion
	    var useBacktick = false;
	    var nameParts = [];
	    var start = token.start;
	    var cont = true;
	    while (cont) {
	      cont = (token.string.charAt(0) == ".");
	      useBacktick = useBacktick || (token.string.charAt(0) == "`");
	
	      start = token.start;
	      nameParts.unshift(cleanName(token.string));
	
	      token = editor.getTokenAt(Pos(cur.line, token.start));
	      if (token.string == ".") {
	        cont = true;
	        token = editor.getTokenAt(Pos(cur.line, token.start));
	      }
	    }
	
	    // Try to complete table names
	    var string = nameParts.join(".");
	    addMatches(result, string, tables, function(w) {
	      return useBacktick ? insertBackticks(w) : w;
	    });
	
	    // Try to complete columns from defaultTable
	    addMatches(result, string, defaultTable, function(w) {
	      return useBacktick ? insertBackticks(w) : w;
	    });
	
	    // Try to complete columns
	    string = nameParts.pop();
	    var table = nameParts.join(".");
	
	    var alias = false;
	    var aliasTable = table;
	    // Check if table is available. If not, find table by Alias
	    if (!getTable(table)) {
	      var oldTable = table;
	      table = findTableByAlias(table, editor);
	      if (table !== oldTable) alias = true;
	    }
	
	    var columns = getTable(table);
	    if (columns && columns.columns)
	      columns = columns.columns;
	
	    if (columns) {
	      addMatches(result, string, columns, function(w) {
	        var tableInsert = table;
	        if (alias == true) tableInsert = aliasTable;
	        if (typeof w == "string") {
	          w = tableInsert + "." + w;
	        } else {
	          w = shallowClone(w);
	          w.text = tableInsert + "." + w.text;
	        }
	        return useBacktick ? insertBackticks(w) : w;
	      });
	    }
	
	    return start;
	  }
	
	  function eachWord(lineText, f) {
	    if (!lineText) return;
	    var excepted = /[,;]/g;
	    var words = lineText.split(" ");
	    for (var i = 0; i < words.length; i++) {
	      f(words[i]?words[i].replace(excepted, '') : '');
	    }
	  }
	
	  function findTableByAlias(alias, editor) {
	    var doc = editor.doc;
	    var fullQuery = doc.getValue();
	    var aliasUpperCase = alias.toUpperCase();
	    var previousWord = "";
	    var table = "";
	    var separator = [];
	    var validRange = {
	      start: Pos(0, 0),
	      end: Pos(editor.lastLine(), editor.getLineHandle(editor.lastLine()).length)
	    };
	
	    //add separator
	    var indexOfSeparator = fullQuery.indexOf(CONS.QUERY_DIV);
	    while(indexOfSeparator != -1) {
	      separator.push(doc.posFromIndex(indexOfSeparator));
	      indexOfSeparator = fullQuery.indexOf(CONS.QUERY_DIV, indexOfSeparator+1);
	    }
	    separator.unshift(Pos(0, 0));
	    separator.push(Pos(editor.lastLine(), editor.getLineHandle(editor.lastLine()).text.length));
	
	    //find valid range
	    var prevItem = null;
	    var current = editor.getCursor()
	    for (var i = 0; i < separator.length; i++) {
	      if ((prevItem == null || cmpPos(current, prevItem) > 0) && cmpPos(current, separator[i]) <= 0) {
	        validRange = {start: prevItem, end: separator[i]};
	        break;
	      }
	      prevItem = separator[i];
	    }
	
	    var query = doc.getRange(validRange.start, validRange.end, false);
	
	    for (var i = 0; i < query.length; i++) {
	      var lineText = query[i];
	      eachWord(lineText, function(word) {
	        var wordUpperCase = word.toUpperCase();
	        if (wordUpperCase === aliasUpperCase && getTable(previousWord))
	          table = previousWord;
	        if (wordUpperCase !== CONS.ALIAS_KEYWORD)
	          previousWord = word;
	      });
	      if (table) break;
	    }
	    return table;
	  }
	
	  CodeMirror.registerHelper("hint", "sql", function(editor, options) {
	    tables = parseTables(options && options.tables)
	    var defaultTableName = options && options.defaultTable;
	    var disableKeywords = options && options.disableKeywords;
	    defaultTable = defaultTableName && getTable(defaultTableName);
	    keywords = getKeywords(editor);
	
	    if (defaultTableName && !defaultTable)
	      defaultTable = findTableByAlias(defaultTableName, editor);
	
	    defaultTable = defaultTable || [];
	
	    if (defaultTable.columns)
	      defaultTable = defaultTable.columns;
	
	    var cur = editor.getCursor();
	    var result = [];
	    var token = editor.getTokenAt(cur), start, end, search;
	    if (token.end > cur.ch) {
	      token.end = cur.ch;
	      token.string = token.string.slice(0, cur.ch - token.start);
	    }
	
	    if (token.string.match(/^[.`\w@]\w*$/)) {
	      search = token.string;
	      start = token.start;
	      end = token.end;
	    } else {
	      start = end = cur.ch;
	      search = "";
	    }
	    if (search.charAt(0) == "." || search.charAt(0) == "`") {
	      start = nameCompletion(cur, token, result, editor);
	    } else {
	      addMatches(result, search, tables, function(w) {return w;});
	      addMatches(result, search, defaultTable, function(w) {return w;});
	      if (!disableKeywords)
	        addMatches(result, search, keywords, function(w) {return w.toUpperCase();});
	    }
	
	    return {list: result, from: Pos(cur.line, start), to: Pos(cur.line, end)};
	  });
	});


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// Highlighting text that matches the selection
	//
	// Defines an option highlightSelectionMatches, which, when enabled,
	// will style strings that match the selection throughout the
	// document.
	//
	// The option can be set to true to simply enable it, or to a
	// {minChars, style, wordsOnly, showToken, delay} object to explicitly
	// configure it. minChars is the minimum amount of characters that should be
	// selected for the behavior to occur, and style is the token style to
	// apply to the matches. This will be prefixed by "cm-" to create an
	// actual CSS class name. If wordsOnly is enabled, the matches will be
	// highlighted only if the selected text is a word. showToken, when enabled,
	// will cause the current token to be highlighted when nothing is selected.
	// delay is used to specify how much time to wait, in milliseconds, before
	// highlighting the matches. If annotateScrollbar is enabled, the occurences
	// will be highlighted on the scrollbar via the matchesonscrollbar addon.
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(77));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "./matchesonscrollbar"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  var defaults = {
	    style: "matchhighlight",
	    minChars: 2,
	    delay: 100,
	    wordsOnly: false,
	    annotateScrollbar: false,
	    showToken: false,
	    trim: true
	  }
	
	  function State(options) {
	    this.options = {}
	    for (var name in defaults)
	      this.options[name] = (options && options.hasOwnProperty(name) ? options : defaults)[name]
	    this.overlay = this.timeout = null;
	    this.matchesonscroll = null;
	    this.active = false;
	  }
	
	  CodeMirror.defineOption("highlightSelectionMatches", false, function(cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      removeOverlay(cm);
	      clearTimeout(cm.state.matchHighlighter.timeout);
	      cm.state.matchHighlighter = null;
	      cm.off("cursorActivity", cursorActivity);
	      cm.off("focus", onFocus)
	    }
	    if (val) {
	      var state = cm.state.matchHighlighter = new State(val);
	      if (cm.hasFocus()) {
	        state.active = true
	        highlightMatches(cm)
	      } else {
	        cm.on("focus", onFocus)
	      }
	      cm.on("cursorActivity", cursorActivity);
	    }
	  });
	
	  function cursorActivity(cm) {
	    var state = cm.state.matchHighlighter;
	    if (state.active || cm.hasFocus()) scheduleHighlight(cm, state)
	  }
	
	  function onFocus(cm) {
	    var state = cm.state.matchHighlighter
	    if (!state.active) {
	      state.active = true
	      scheduleHighlight(cm, state)
	    }
	  }
	
	  function scheduleHighlight(cm, state) {
	    clearTimeout(state.timeout);
	    state.timeout = setTimeout(function() {highlightMatches(cm);}, state.options.delay);
	  }
	
	  function addOverlay(cm, query, hasBoundary, style) {
	    var state = cm.state.matchHighlighter;
	    cm.addOverlay(state.overlay = makeOverlay(query, hasBoundary, style));
	    if (state.options.annotateScrollbar && cm.showMatchesOnScrollbar) {
	      var searchFor = hasBoundary ? new RegExp("\\b" + query + "\\b") : query;
	      state.matchesonscroll = cm.showMatchesOnScrollbar(searchFor, false,
	        {className: "CodeMirror-selection-highlight-scrollbar"});
	    }
	  }
	
	  function removeOverlay(cm) {
	    var state = cm.state.matchHighlighter;
	    if (state.overlay) {
	      cm.removeOverlay(state.overlay);
	      state.overlay = null;
	      if (state.matchesonscroll) {
	        state.matchesonscroll.clear();
	        state.matchesonscroll = null;
	      }
	    }
	  }
	
	  function highlightMatches(cm) {
	    cm.operation(function() {
	      var state = cm.state.matchHighlighter;
	      removeOverlay(cm);
	      if (!cm.somethingSelected() && state.options.showToken) {
	        var re = state.options.showToken === true ? /[\w$]/ : state.options.showToken;
	        var cur = cm.getCursor(), line = cm.getLine(cur.line), start = cur.ch, end = start;
	        while (start && re.test(line.charAt(start - 1))) --start;
	        while (end < line.length && re.test(line.charAt(end))) ++end;
	        if (start < end)
	          addOverlay(cm, line.slice(start, end), re, state.options.style);
	        return;
	      }
	      var from = cm.getCursor("from"), to = cm.getCursor("to");
	      if (from.line != to.line) return;
	      if (state.options.wordsOnly && !isWord(cm, from, to)) return;
	      var selection = cm.getRange(from, to)
	      if (state.options.trim) selection = selection.replace(/^\s+|\s+$/g, "")
	      if (selection.length >= state.options.minChars)
	        addOverlay(cm, selection, false, state.options.style);
	    });
	  }
	
	  function isWord(cm, from, to) {
	    var str = cm.getRange(from, to);
	    if (str.match(/^\w+$/) !== null) {
	        if (from.ch > 0) {
	            var pos = {line: from.line, ch: from.ch - 1};
	            var chr = cm.getRange(pos, from);
	            if (chr.match(/\W/) === null) return false;
	        }
	        if (to.ch < cm.getLine(from.line).length) {
	            var pos = {line: to.line, ch: to.ch + 1};
	            var chr = cm.getRange(to, pos);
	            if (chr.match(/\W/) === null) return false;
	        }
	        return true;
	    } else return false;
	  }
	
	  function boundariesAround(stream, re) {
	    return (!stream.start || !re.test(stream.string.charAt(stream.start - 1))) &&
	      (stream.pos == stream.string.length || !re.test(stream.string.charAt(stream.pos)));
	  }
	
	  function makeOverlay(query, hasBoundary, style) {
	    return {token: function(stream) {
	      if (stream.match(query) &&
	          (!hasBoundary || boundariesAround(stream, hasBoundary)))
	        return style;
	      stream.next();
	      stream.skipTo(query.charAt(0)) || stream.skipToEnd();
	    }};
	  }
	});


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// Define search commands. Depends on dialog.js or another
	// implementation of the openDialog method.
	
	// Replace works a little oddly -- it will do the replace on the next
	// Ctrl-G (or whatever is bound to findNext) press. You prevent a
	// replace by making sure the match is no longer selected when hitting
	// Ctrl-G.
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(8), __webpack_require__(43));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "./searchcursor", "../dialog/dialog"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  function searchOverlay(query, caseInsensitive) {
	    if (typeof query == "string")
	      query = new RegExp(query.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&"), caseInsensitive ? "gi" : "g");
	    else if (!query.global)
	      query = new RegExp(query.source, query.ignoreCase ? "gi" : "g");
	
	    return {token: function(stream) {
	      query.lastIndex = stream.pos;
	      var match = query.exec(stream.string);
	      if (match && match.index == stream.pos) {
	        stream.pos += match[0].length || 1;
	        return "searching";
	      } else if (match) {
	        stream.pos = match.index;
	      } else {
	        stream.skipToEnd();
	      }
	    }};
	  }
	
	  function SearchState() {
	    this.posFrom = this.posTo = this.lastQuery = this.query = null;
	    this.overlay = null;
	  }
	
	  function getSearchState(cm) {
	    return cm.state.search || (cm.state.search = new SearchState());
	  }
	
	  function queryCaseInsensitive(query) {
	    return typeof query == "string" && query == query.toLowerCase();
	  }
	
	  function getSearchCursor(cm, query, pos) {
	    // Heuristic: if the query string is all lowercase, do a case insensitive search.
	    return cm.getSearchCursor(query, pos, queryCaseInsensitive(query));
	  }
	
	  function persistentDialog(cm, text, deflt, onEnter, onKeyDown) {
	    cm.openDialog(text, onEnter, {
	      value: deflt,
	      selectValueOnOpen: true,
	      closeOnEnter: false,
	      onClose: function() { clearSearch(cm); },
	      onKeyDown: onKeyDown
	    });
	  }
	
	  function dialog(cm, text, shortText, deflt, f) {
	    if (cm.openDialog) cm.openDialog(text, f, {value: deflt, selectValueOnOpen: true});
	    else f(prompt(shortText, deflt));
	  }
	
	  function confirmDialog(cm, text, shortText, fs) {
	    if (cm.openConfirm) cm.openConfirm(text, fs);
	    else if (confirm(shortText)) fs[0]();
	  }
	
	  function parseString(string) {
	    return string.replace(/\\(.)/g, function(_, ch) {
	      if (ch == "n") return "\n"
	      if (ch == "r") return "\r"
	      return ch
	    })
	  }
	
	  function parseQuery(query) {
	    var isRE = query.match(/^\/(.*)\/([a-z]*)$/);
	    if (isRE) {
	      try { query = new RegExp(isRE[1], isRE[2].indexOf("i") == -1 ? "" : "i"); }
	      catch(e) {} // Not a regular expression after all, do a string search
	    } else {
	      query = parseString(query)
	    }
	    if (typeof query == "string" ? query == "" : query.test(""))
	      query = /x^/;
	    return query;
	  }
	
	  var queryDialog =
	    'Search: <input type="text" style="width: 10em" class="CodeMirror-search-field"/> <span style="color: #888" class="CodeMirror-search-hint">(Use /re/ syntax for regexp search)</span>';
	
	  function startSearch(cm, state, query) {
	    state.queryText = query;
	    state.query = parseQuery(query);
	    cm.removeOverlay(state.overlay, queryCaseInsensitive(state.query));
	    state.overlay = searchOverlay(state.query, queryCaseInsensitive(state.query));
	    cm.addOverlay(state.overlay);
	    if (cm.showMatchesOnScrollbar) {
	      if (state.annotate) { state.annotate.clear(); state.annotate = null; }
	      state.annotate = cm.showMatchesOnScrollbar(state.query, queryCaseInsensitive(state.query));
	    }
	  }
	
	  function doSearch(cm, rev, persistent, immediate) {
	    var state = getSearchState(cm);
	    if (state.query) return findNext(cm, rev);
	    var q = cm.getSelection() || state.lastQuery;
	    if (persistent && cm.openDialog) {
	      var hiding = null
	      var searchNext = function(query, event) {
	        CodeMirror.e_stop(event);
	        if (!query) return;
	        if (query != state.queryText) {
	          startSearch(cm, state, query);
	          state.posFrom = state.posTo = cm.getCursor();
	        }
	        if (hiding) hiding.style.opacity = 1
	        findNext(cm, event.shiftKey, function(_, to) {
	          var dialog
	          if (to.line < 3 && document.querySelector &&
	              (dialog = cm.display.wrapper.querySelector(".CodeMirror-dialog")) &&
	              dialog.getBoundingClientRect().bottom - 4 > cm.cursorCoords(to, "window").top)
	            (hiding = dialog).style.opacity = .4
	        })
	      };
	      persistentDialog(cm, queryDialog, q, searchNext, function(event, query) {
	        var keyName = CodeMirror.keyName(event)
	        var cmd = CodeMirror.keyMap[cm.getOption("keyMap")][keyName]
	        if (!cmd) cmd = cm.getOption('extraKeys')[keyName]
	        if (cmd == "findNext" || cmd == "findPrev" ||
	          cmd == "findPersistentNext" || cmd == "findPersistentPrev") {
	          CodeMirror.e_stop(event);
	          startSearch(cm, getSearchState(cm), query);
	          cm.execCommand(cmd);
	        } else if (cmd == "find" || cmd == "findPersistent") {
	          CodeMirror.e_stop(event);
	          searchNext(query, event);
	        }
	      });
	      if (immediate && q) {
	        startSearch(cm, state, q);
	        findNext(cm, rev);
	      }
	    } else {
	      dialog(cm, queryDialog, "Search for:", q, function(query) {
	        if (query && !state.query) cm.operation(function() {
	          startSearch(cm, state, query);
	          state.posFrom = state.posTo = cm.getCursor();
	          findNext(cm, rev);
	        });
	      });
	    }
	  }
	
	  function findNext(cm, rev, callback) {cm.operation(function() {
	    var state = getSearchState(cm);
	    var cursor = getSearchCursor(cm, state.query, rev ? state.posFrom : state.posTo);
	    if (!cursor.find(rev)) {
	      cursor = getSearchCursor(cm, state.query, rev ? CodeMirror.Pos(cm.lastLine()) : CodeMirror.Pos(cm.firstLine(), 0));
	      if (!cursor.find(rev)) return;
	    }
	    cm.setSelection(cursor.from(), cursor.to());
	    cm.scrollIntoView({from: cursor.from(), to: cursor.to()}, 20);
	    state.posFrom = cursor.from(); state.posTo = cursor.to();
	    if (callback) callback(cursor.from(), cursor.to())
	  });}
	
	  function clearSearch(cm) {cm.operation(function() {
	    var state = getSearchState(cm);
	    state.lastQuery = state.query;
	    if (!state.query) return;
	    state.query = state.queryText = null;
	    cm.removeOverlay(state.overlay);
	    if (state.annotate) { state.annotate.clear(); state.annotate = null; }
	  });}
	
	  var replaceQueryDialog =
	    ' <input type="text" style="width: 10em" class="CodeMirror-search-field"/> <span style="color: #888" class="CodeMirror-search-hint">(Use /re/ syntax for regexp search)</span>';
	  var replacementQueryDialog = 'With: <input type="text" style="width: 10em" class="CodeMirror-search-field"/>';
	  var doReplaceConfirm = "Replace? <button>Yes</button> <button>No</button> <button>All</button> <button>Stop</button>";
	
	  function replaceAll(cm, query, text) {
	    cm.operation(function() {
	      for (var cursor = getSearchCursor(cm, query); cursor.findNext();) {
	        if (typeof query != "string") {
	          var match = cm.getRange(cursor.from(), cursor.to()).match(query);
	          cursor.replace(text.replace(/\$(\d)/g, function(_, i) {return match[i];}));
	        } else cursor.replace(text);
	      }
	    });
	  }
	
	  function replace(cm, all) {
	    if (cm.getOption("readOnly")) return;
	    var query = cm.getSelection() || getSearchState(cm).lastQuery;
	    var dialogText = all ? "Replace all:" : "Replace:"
	    dialog(cm, dialogText + replaceQueryDialog, dialogText, query, function(query) {
	      if (!query) return;
	      query = parseQuery(query);
	      dialog(cm, replacementQueryDialog, "Replace with:", "", function(text) {
	        text = parseString(text)
	        if (all) {
	          replaceAll(cm, query, text)
	        } else {
	          clearSearch(cm);
	          var cursor = getSearchCursor(cm, query, cm.getCursor("from"));
	          var advance = function() {
	            var start = cursor.from(), match;
	            if (!(match = cursor.findNext())) {
	              cursor = getSearchCursor(cm, query);
	              if (!(match = cursor.findNext()) ||
	                  (start && cursor.from().line == start.line && cursor.from().ch == start.ch)) return;
	            }
	            cm.setSelection(cursor.from(), cursor.to());
	            cm.scrollIntoView({from: cursor.from(), to: cursor.to()});
	            confirmDialog(cm, doReplaceConfirm, "Replace?",
	                          [function() {doReplace(match);}, advance,
	                           function() {replaceAll(cm, query, text)}]);
	          };
	          var doReplace = function(match) {
	            cursor.replace(typeof query == "string" ? text :
	                           text.replace(/\$(\d)/g, function(_, i) {return match[i];}));
	            advance();
	          };
	          advance();
	        }
	      });
	    });
	  }
	
	  CodeMirror.commands.find = function(cm) {clearSearch(cm); doSearch(cm);};
	  CodeMirror.commands.findPersistent = function(cm) {clearSearch(cm); doSearch(cm, false, true);};
	  CodeMirror.commands.findPersistentNext = function(cm) {doSearch(cm, false, true, true);};
	  CodeMirror.commands.findPersistentPrev = function(cm) {doSearch(cm, true, true, true);};
	  CodeMirror.commands.findNext = doSearch;
	  CodeMirror.commands.findPrev = function(cm) {doSearch(cm, true);};
	  CodeMirror.commands.clearSearch = clearSearch;
	  CodeMirror.commands.replace = replace;
	  CodeMirror.commands.replaceAll = function(cm) {replace(cm, true);};
	});


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	  var WRAP_CLASS = "CodeMirror-activeline";
	  var BACK_CLASS = "CodeMirror-activeline-background";
	  var GUTT_CLASS = "CodeMirror-activeline-gutter";
	
	  CodeMirror.defineOption("styleActiveLine", false, function(cm, val, old) {
	    var prev = old == CodeMirror.Init ? false : old;
	    if (val == prev) return
	    if (prev) {
	      cm.off("beforeSelectionChange", selectionChange);
	      clearActiveLines(cm);
	      delete cm.state.activeLines;
	    }
	    if (val) {
	      cm.state.activeLines = [];
	      updateActiveLines(cm, cm.listSelections());
	      cm.on("beforeSelectionChange", selectionChange);
	    }
	  });
	
	  function clearActiveLines(cm) {
	    for (var i = 0; i < cm.state.activeLines.length; i++) {
	      cm.removeLineClass(cm.state.activeLines[i], "wrap", WRAP_CLASS);
	      cm.removeLineClass(cm.state.activeLines[i], "background", BACK_CLASS);
	      cm.removeLineClass(cm.state.activeLines[i], "gutter", GUTT_CLASS);
	    }
	  }
	
	  function sameArray(a, b) {
	    if (a.length != b.length) return false;
	    for (var i = 0; i < a.length; i++)
	      if (a[i] != b[i]) return false;
	    return true;
	  }
	
	  function updateActiveLines(cm, ranges) {
	    var active = [];
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i];
	      var option = cm.getOption("styleActiveLine");
	      if (typeof option == "object" && option.nonEmpty ? range.anchor.line != range.head.line : !range.empty())
	        continue
	      var line = cm.getLineHandleVisualStart(range.head.line);
	      if (active[active.length - 1] != line) active.push(line);
	    }
	    if (sameArray(cm.state.activeLines, active)) return;
	    cm.operation(function() {
	      clearActiveLines(cm);
	      for (var i = 0; i < active.length; i++) {
	        cm.addLineClass(active[i], "wrap", WRAP_CLASS);
	        cm.addLineClass(active[i], "background", BACK_CLASS);
	        cm.addLineClass(active[i], "gutter", GUTT_CLASS);
	      }
	      cm.state.activeLines = active;
	    });
	  }
	
	  function selectionChange(cm, sel) {
	    updateActiveLines(cm, sel.ranges);
	  }
	});


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// Because sometimes you need to mark the selected *text*.
	//
	// Adds an option 'styleSelectedText' which, when enabled, gives
	// selected text the CSS class given as option value, or
	// "CodeMirror-selectedtext" when the value is not a string.
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineOption("styleSelectedText", false, function(cm, val, old) {
	    var prev = old && old != CodeMirror.Init;
	    if (val && !prev) {
	      cm.state.markedSelection = [];
	      cm.state.markedSelectionStyle = typeof val == "string" ? val : "CodeMirror-selectedtext";
	      reset(cm);
	      cm.on("cursorActivity", onCursorActivity);
	      cm.on("change", onChange);
	    } else if (!val && prev) {
	      cm.off("cursorActivity", onCursorActivity);
	      cm.off("change", onChange);
	      clear(cm);
	      cm.state.markedSelection = cm.state.markedSelectionStyle = null;
	    }
	  });
	
	  function onCursorActivity(cm) {
	    cm.operation(function() { update(cm); });
	  }
	
	  function onChange(cm) {
	    if (cm.state.markedSelection.length)
	      cm.operation(function() { clear(cm); });
	  }
	
	  var CHUNK_SIZE = 8;
	  var Pos = CodeMirror.Pos;
	  var cmp = CodeMirror.cmpPos;
	
	  function coverRange(cm, from, to, addAt) {
	    if (cmp(from, to) == 0) return;
	    var array = cm.state.markedSelection;
	    var cls = cm.state.markedSelectionStyle;
	    for (var line = from.line;;) {
	      var start = line == from.line ? from : Pos(line, 0);
	      var endLine = line + CHUNK_SIZE, atEnd = endLine >= to.line;
	      var end = atEnd ? to : Pos(endLine, 0);
	      var mark = cm.markText(start, end, {className: cls});
	      if (addAt == null) array.push(mark);
	      else array.splice(addAt++, 0, mark);
	      if (atEnd) break;
	      line = endLine;
	    }
	  }
	
	  function clear(cm) {
	    var array = cm.state.markedSelection;
	    for (var i = 0; i < array.length; ++i) array[i].clear();
	    array.length = 0;
	  }
	
	  function reset(cm) {
	    clear(cm);
	    var ranges = cm.listSelections();
	    for (var i = 0; i < ranges.length; i++)
	      coverRange(cm, ranges[i].from(), ranges[i].to());
	  }
	
	  function update(cm) {
	    if (!cm.somethingSelected()) return clear(cm);
	    if (cm.listSelections().length > 1) return reset(cm);
	
	    var from = cm.getCursor("start"), to = cm.getCursor("end");
	
	    var array = cm.state.markedSelection;
	    if (!array.length) return coverRange(cm, from, to);
	
	    var coverStart = array[0].find(), coverEnd = array[array.length - 1].find();
	    if (!coverStart || !coverEnd || to.line - from.line < CHUNK_SIZE ||
	        cmp(from, coverEnd.to) >= 0 || cmp(to, coverStart.from) <= 0)
	      return reset(cm);
	
	    while (cmp(from, coverStart.from) > 0) {
	      array.shift().clear();
	      coverStart = array[0].find();
	    }
	    if (cmp(from, coverStart.from) < 0) {
	      if (coverStart.to.line - from.line < CHUNK_SIZE) {
	        array.shift().clear();
	        coverRange(cm, from, coverStart.to, 0);
	      } else {
	        coverRange(cm, from, coverStart.from, 0);
	      }
	    }
	
	    while (cmp(to, coverEnd.to) < 0) {
	      array.pop().clear();
	      coverEnd = array[array.length - 1].find();
	    }
	    if (cmp(to, coverEnd.to) > 0) {
	      if (to.line - coverEnd.from.line < CHUNK_SIZE) {
	        array.pop().clear();
	        coverRange(cm, coverEnd.from, to);
	      } else {
	        coverRange(cm, coverEnd.to, to);
	      }
	    }
	  }
	});


/***/ },
/* 146 */,
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  var Pos = CodeMirror.Pos;
	  function posEq(a, b) { return a.line == b.line && a.ch == b.ch; }
	
	  // Kill 'ring'
	
	  var killRing = [];
	  function addToRing(str) {
	    killRing.push(str);
	    if (killRing.length > 50) killRing.shift();
	  }
	  function growRingTop(str) {
	    if (!killRing.length) return addToRing(str);
	    killRing[killRing.length - 1] += str;
	  }
	  function getFromRing(n) { return killRing[killRing.length - (n ? Math.min(n, 1) : 1)] || ""; }
	  function popFromRing() { if (killRing.length > 1) killRing.pop(); return getFromRing(); }
	
	  var lastKill = null;
	
	  function kill(cm, from, to, mayGrow, text) {
	    if (text == null) text = cm.getRange(from, to);
	
	    if (mayGrow && lastKill && lastKill.cm == cm && posEq(from, lastKill.pos) && cm.isClean(lastKill.gen))
	      growRingTop(text);
	    else
	      addToRing(text);
	    cm.replaceRange("", from, to, "+delete");
	
	    if (mayGrow) lastKill = {cm: cm, pos: from, gen: cm.changeGeneration()};
	    else lastKill = null;
	  }
	
	  // Boundaries of various units
	
	  function byChar(cm, pos, dir) {
	    return cm.findPosH(pos, dir, "char", true);
	  }
	
	  function byWord(cm, pos, dir) {
	    return cm.findPosH(pos, dir, "word", true);
	  }
	
	  function byLine(cm, pos, dir) {
	    return cm.findPosV(pos, dir, "line", cm.doc.sel.goalColumn);
	  }
	
	  function byPage(cm, pos, dir) {
	    return cm.findPosV(pos, dir, "page", cm.doc.sel.goalColumn);
	  }
	
	  function byParagraph(cm, pos, dir) {
	    var no = pos.line, line = cm.getLine(no);
	    var sawText = /\S/.test(dir < 0 ? line.slice(0, pos.ch) : line.slice(pos.ch));
	    var fst = cm.firstLine(), lst = cm.lastLine();
	    for (;;) {
	      no += dir;
	      if (no < fst || no > lst)
	        return cm.clipPos(Pos(no - dir, dir < 0 ? 0 : null));
	      line = cm.getLine(no);
	      var hasText = /\S/.test(line);
	      if (hasText) sawText = true;
	      else if (sawText) return Pos(no, 0);
	    }
	  }
	
	  function bySentence(cm, pos, dir) {
	    var line = pos.line, ch = pos.ch;
	    var text = cm.getLine(pos.line), sawWord = false;
	    for (;;) {
	      var next = text.charAt(ch + (dir < 0 ? -1 : 0));
	      if (!next) { // End/beginning of line reached
	        if (line == (dir < 0 ? cm.firstLine() : cm.lastLine())) return Pos(line, ch);
	        text = cm.getLine(line + dir);
	        if (!/\S/.test(text)) return Pos(line, ch);
	        line += dir;
	        ch = dir < 0 ? text.length : 0;
	        continue;
	      }
	      if (sawWord && /[!?.]/.test(next)) return Pos(line, ch + (dir > 0 ? 1 : 0));
	      if (!sawWord) sawWord = /\w/.test(next);
	      ch += dir;
	    }
	  }
	
	  function byExpr(cm, pos, dir) {
	    var wrap;
	    if (cm.findMatchingBracket && (wrap = cm.findMatchingBracket(pos, true))
	        && wrap.match && (wrap.forward ? 1 : -1) == dir)
	      return dir > 0 ? Pos(wrap.to.line, wrap.to.ch + 1) : wrap.to;
	
	    for (var first = true;; first = false) {
	      var token = cm.getTokenAt(pos);
	      var after = Pos(pos.line, dir < 0 ? token.start : token.end);
	      if (first && dir > 0 && token.end == pos.ch || !/\w/.test(token.string)) {
	        var newPos = cm.findPosH(after, dir, "char");
	        if (posEq(after, newPos)) return pos;
	        else pos = newPos;
	      } else {
	        return after;
	      }
	    }
	  }
	
	  // Prefixes (only crudely supported)
	
	  function getPrefix(cm, precise) {
	    var digits = cm.state.emacsPrefix;
	    if (!digits) return precise ? null : 1;
	    clearPrefix(cm);
	    return digits == "-" ? -1 : Number(digits);
	  }
	
	  function repeated(cmd) {
	    var f = typeof cmd == "string" ? function(cm) { cm.execCommand(cmd); } : cmd;
	    return function(cm) {
	      var prefix = getPrefix(cm);
	      f(cm);
	      for (var i = 1; i < prefix; ++i) f(cm);
	    };
	  }
	
	  function findEnd(cm, pos, by, dir) {
	    var prefix = getPrefix(cm);
	    if (prefix < 0) { dir = -dir; prefix = -prefix; }
	    for (var i = 0; i < prefix; ++i) {
	      var newPos = by(cm, pos, dir);
	      if (posEq(newPos, pos)) break;
	      pos = newPos;
	    }
	    return pos;
	  }
	
	  function move(by, dir) {
	    var f = function(cm) {
	      cm.extendSelection(findEnd(cm, cm.getCursor(), by, dir));
	    };
	    f.motion = true;
	    return f;
	  }
	
	  function killTo(cm, by, dir) {
	    var selections = cm.listSelections(), cursor;
	    var i = selections.length;
	    while (i--) {
	      cursor = selections[i].head;
	      kill(cm, cursor, findEnd(cm, cursor, by, dir), true);
	    }
	  }
	
	  function killRegion(cm) {
	    if (cm.somethingSelected()) {
	      var selections = cm.listSelections(), selection;
	      var i = selections.length;
	      while (i--) {
	        selection = selections[i];
	        kill(cm, selection.anchor, selection.head);
	      }
	      return true;
	    }
	  }
	
	  function addPrefix(cm, digit) {
	    if (cm.state.emacsPrefix) {
	      if (digit != "-") cm.state.emacsPrefix += digit;
	      return;
	    }
	    // Not active yet
	    cm.state.emacsPrefix = digit;
	    cm.on("keyHandled", maybeClearPrefix);
	    cm.on("inputRead", maybeDuplicateInput);
	  }
	
	  var prefixPreservingKeys = {"Alt-G": true, "Ctrl-X": true, "Ctrl-Q": true, "Ctrl-U": true};
	
	  function maybeClearPrefix(cm, arg) {
	    if (!cm.state.emacsPrefixMap && !prefixPreservingKeys.hasOwnProperty(arg))
	      clearPrefix(cm);
	  }
	
	  function clearPrefix(cm) {
	    cm.state.emacsPrefix = null;
	    cm.off("keyHandled", maybeClearPrefix);
	    cm.off("inputRead", maybeDuplicateInput);
	  }
	
	  function maybeDuplicateInput(cm, event) {
	    var dup = getPrefix(cm);
	    if (dup > 1 && event.origin == "+input") {
	      var one = event.text.join("\n"), txt = "";
	      for (var i = 1; i < dup; ++i) txt += one;
	      cm.replaceSelection(txt);
	    }
	  }
	
	  function addPrefixMap(cm) {
	    cm.state.emacsPrefixMap = true;
	    cm.addKeyMap(prefixMap);
	    cm.on("keyHandled", maybeRemovePrefixMap);
	    cm.on("inputRead", maybeRemovePrefixMap);
	  }
	
	  function maybeRemovePrefixMap(cm, arg) {
	    if (typeof arg == "string" && (/^\d$/.test(arg) || arg == "Ctrl-U")) return;
	    cm.removeKeyMap(prefixMap);
	    cm.state.emacsPrefixMap = false;
	    cm.off("keyHandled", maybeRemovePrefixMap);
	    cm.off("inputRead", maybeRemovePrefixMap);
	  }
	
	  // Utilities
	
	  function setMark(cm) {
	    cm.setCursor(cm.getCursor());
	    cm.setExtending(!cm.getExtending());
	    cm.on("change", function() { cm.setExtending(false); });
	  }
	
	  function clearMark(cm) {
	    cm.setExtending(false);
	    cm.setCursor(cm.getCursor());
	  }
	
	  function getInput(cm, msg, f) {
	    if (cm.openDialog)
	      cm.openDialog(msg + ": <input type=\"text\" style=\"width: 10em\"/>", f, {bottom: true});
	    else
	      f(prompt(msg, ""));
	  }
	
	  function operateOnWord(cm, op) {
	    var start = cm.getCursor(), end = cm.findPosH(start, 1, "word");
	    cm.replaceRange(op(cm.getRange(start, end)), start, end);
	    cm.setCursor(end);
	  }
	
	  function toEnclosingExpr(cm) {
	    var pos = cm.getCursor(), line = pos.line, ch = pos.ch;
	    var stack = [];
	    while (line >= cm.firstLine()) {
	      var text = cm.getLine(line);
	      for (var i = ch == null ? text.length : ch; i > 0;) {
	        var ch = text.charAt(--i);
	        if (ch == ")")
	          stack.push("(");
	        else if (ch == "]")
	          stack.push("[");
	        else if (ch == "}")
	          stack.push("{");
	        else if (/[\(\{\[]/.test(ch) && (!stack.length || stack.pop() != ch))
	          return cm.extendSelection(Pos(line, i));
	      }
	      --line; ch = null;
	    }
	  }
	
	  function quit(cm) {
	    cm.execCommand("clearSearch");
	    clearMark(cm);
	  }
	
	  CodeMirror.emacs = {kill: kill, killRegion: killRegion, repeated: repeated};
	
	  // Actual keymap
	
	  var keyMap = CodeMirror.keyMap.emacs = CodeMirror.normalizeKeyMap({
	    "Ctrl-W": function(cm) {kill(cm, cm.getCursor("start"), cm.getCursor("end"));},
	    "Ctrl-K": repeated(function(cm) {
	      var start = cm.getCursor(), end = cm.clipPos(Pos(start.line));
	      var text = cm.getRange(start, end);
	      if (!/\S/.test(text)) {
	        text += "\n";
	        end = Pos(start.line + 1, 0);
	      }
	      kill(cm, start, end, true, text);
	    }),
	    "Alt-W": function(cm) {
	      addToRing(cm.getSelection());
	      clearMark(cm);
	    },
	    "Ctrl-Y": function(cm) {
	      var start = cm.getCursor();
	      cm.replaceRange(getFromRing(getPrefix(cm)), start, start, "paste");
	      cm.setSelection(start, cm.getCursor());
	    },
	    "Alt-Y": function(cm) {cm.replaceSelection(popFromRing(), "around", "paste");},
	
	    "Ctrl-Space": setMark, "Ctrl-Shift-2": setMark,
	
	    "Ctrl-F": move(byChar, 1), "Ctrl-B": move(byChar, -1),
	    "Right": move(byChar, 1), "Left": move(byChar, -1),
	    "Ctrl-D": function(cm) { killTo(cm, byChar, 1); },
	    "Delete": function(cm) { killRegion(cm) || killTo(cm, byChar, 1); },
	    "Ctrl-H": function(cm) { killTo(cm, byChar, -1); },
	    "Backspace": function(cm) { killRegion(cm) || killTo(cm, byChar, -1); },
	
	    "Alt-F": move(byWord, 1), "Alt-B": move(byWord, -1),
	    "Alt-D": function(cm) { killTo(cm, byWord, 1); },
	    "Alt-Backspace": function(cm) { killTo(cm, byWord, -1); },
	
	    "Ctrl-N": move(byLine, 1), "Ctrl-P": move(byLine, -1),
	    "Down": move(byLine, 1), "Up": move(byLine, -1),
	    "Ctrl-A": "goLineStart", "Ctrl-E": "goLineEnd",
	    "End": "goLineEnd", "Home": "goLineStart",
	
	    "Alt-V": move(byPage, -1), "Ctrl-V": move(byPage, 1),
	    "PageUp": move(byPage, -1), "PageDown": move(byPage, 1),
	
	    "Ctrl-Up": move(byParagraph, -1), "Ctrl-Down": move(byParagraph, 1),
	
	    "Alt-A": move(bySentence, -1), "Alt-E": move(bySentence, 1),
	    "Alt-K": function(cm) { killTo(cm, bySentence, 1); },
	
	    "Ctrl-Alt-K": function(cm) { killTo(cm, byExpr, 1); },
	    "Ctrl-Alt-Backspace": function(cm) { killTo(cm, byExpr, -1); },
	    "Ctrl-Alt-F": move(byExpr, 1), "Ctrl-Alt-B": move(byExpr, -1),
	
	    "Shift-Ctrl-Alt-2": function(cm) {
	      var cursor = cm.getCursor();
	      cm.setSelection(findEnd(cm, cursor, byExpr, 1), cursor);
	    },
	    "Ctrl-Alt-T": function(cm) {
	      var leftStart = byExpr(cm, cm.getCursor(), -1), leftEnd = byExpr(cm, leftStart, 1);
	      var rightEnd = byExpr(cm, leftEnd, 1), rightStart = byExpr(cm, rightEnd, -1);
	      cm.replaceRange(cm.getRange(rightStart, rightEnd) + cm.getRange(leftEnd, rightStart) +
	                      cm.getRange(leftStart, leftEnd), leftStart, rightEnd);
	    },
	    "Ctrl-Alt-U": repeated(toEnclosingExpr),
	
	    "Alt-Space": function(cm) {
	      var pos = cm.getCursor(), from = pos.ch, to = pos.ch, text = cm.getLine(pos.line);
	      while (from && /\s/.test(text.charAt(from - 1))) --from;
	      while (to < text.length && /\s/.test(text.charAt(to))) ++to;
	      cm.replaceRange(" ", Pos(pos.line, from), Pos(pos.line, to));
	    },
	    "Ctrl-O": repeated(function(cm) { cm.replaceSelection("\n", "start"); }),
	    "Ctrl-T": repeated(function(cm) {
	      cm.execCommand("transposeChars");
	    }),
	
	    "Alt-C": repeated(function(cm) {
	      operateOnWord(cm, function(w) {
	        var letter = w.search(/\w/);
	        if (letter == -1) return w;
	        return w.slice(0, letter) + w.charAt(letter).toUpperCase() + w.slice(letter + 1).toLowerCase();
	      });
	    }),
	    "Alt-U": repeated(function(cm) {
	      operateOnWord(cm, function(w) { return w.toUpperCase(); });
	    }),
	    "Alt-L": repeated(function(cm) {
	      operateOnWord(cm, function(w) { return w.toLowerCase(); });
	    }),
	
	    "Alt-;": "toggleComment",
	
	    "Ctrl-/": repeated("undo"), "Shift-Ctrl--": repeated("undo"),
	    "Ctrl-Z": repeated("undo"), "Cmd-Z": repeated("undo"),
	    "Shift-Alt-,": "goDocStart", "Shift-Alt-.": "goDocEnd",
	    "Ctrl-S": "findNext", "Ctrl-R": "findPrev", "Ctrl-G": quit, "Shift-Alt-5": "replace",
	    "Alt-/": "autocomplete",
	    "Ctrl-J": "newlineAndIndent", "Enter": false, "Tab": "indentAuto",
	
	    "Alt-G G": function(cm) {
	      var prefix = getPrefix(cm, true);
	      if (prefix != null && prefix > 0) return cm.setCursor(prefix - 1);
	
	      getInput(cm, "Goto line", function(str) {
	        var num;
	        if (str && !isNaN(num = Number(str)) && num == (num|0) && num > 0)
	          cm.setCursor(num - 1);
	      });
	    },
	
	    "Ctrl-X Tab": function(cm) {
	      cm.indentSelection(getPrefix(cm, true) || cm.getOption("indentUnit"));
	    },
	    "Ctrl-X Ctrl-X": function(cm) {
	      cm.setSelection(cm.getCursor("head"), cm.getCursor("anchor"));
	    },
	    "Ctrl-X Ctrl-S": "save",
	    "Ctrl-X Ctrl-W": "save",
	    "Ctrl-X S": "saveAll",
	    "Ctrl-X F": "open",
	    "Ctrl-X U": repeated("undo"),
	    "Ctrl-X K": "close",
	    "Ctrl-X Delete": function(cm) { kill(cm, cm.getCursor(), bySentence(cm, cm.getCursor(), 1), true); },
	    "Ctrl-X H": "selectAll",
	
	    "Ctrl-Q Tab": repeated("insertTab"),
	    "Ctrl-U": addPrefixMap
	  });
	
	  var prefixMap = {"Ctrl-G": clearPrefix};
	  function regPrefix(d) {
	    prefixMap[d] = function(cm) { addPrefix(cm, d); };
	    keyMap["Ctrl-" + d] = function(cm) { addPrefix(cm, d); };
	    prefixPreservingKeys["Ctrl-" + d] = true;
	  }
	  for (var i = 0; i < 10; ++i) regPrefix(String(i));
	  regPrefix("-");
	});


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// A rough approximation of Sublime Text's keybindings
	// Depends on addon/search/searchcursor.js and optionally addon/dialog/dialogs.js
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(8), __webpack_require__(44));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../lib/codemirror", "../addon/search/searchcursor", "../addon/edit/matchbrackets"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  var map = CodeMirror.keyMap.sublime = {fallthrough: "default"};
	  var cmds = CodeMirror.commands;
	  var Pos = CodeMirror.Pos;
	  var mac = CodeMirror.keyMap["default"] == CodeMirror.keyMap.macDefault;
	  var ctrl = mac ? "Cmd-" : "Ctrl-";
	
	  // This is not exactly Sublime's algorithm. I couldn't make heads or tails of that.
	  function findPosSubword(doc, start, dir) {
	    if (dir < 0 && start.ch == 0) return doc.clipPos(Pos(start.line - 1));
	    var line = doc.getLine(start.line);
	    if (dir > 0 && start.ch >= line.length) return doc.clipPos(Pos(start.line + 1, 0));
	    var state = "start", type;
	    for (var pos = start.ch, e = dir < 0 ? 0 : line.length, i = 0; pos != e; pos += dir, i++) {
	      var next = line.charAt(dir < 0 ? pos - 1 : pos);
	      var cat = next != "_" && CodeMirror.isWordChar(next) ? "w" : "o";
	      if (cat == "w" && next.toUpperCase() == next) cat = "W";
	      if (state == "start") {
	        if (cat != "o") { state = "in"; type = cat; }
	      } else if (state == "in") {
	        if (type != cat) {
	          if (type == "w" && cat == "W" && dir < 0) pos--;
	          if (type == "W" && cat == "w" && dir > 0) { type = "w"; continue; }
	          break;
	        }
	      }
	    }
	    return Pos(start.line, pos);
	  }
	
	  function moveSubword(cm, dir) {
	    cm.extendSelectionsBy(function(range) {
	      if (cm.display.shift || cm.doc.extend || range.empty())
	        return findPosSubword(cm.doc, range.head, dir);
	      else
	        return dir < 0 ? range.from() : range.to();
	    });
	  }
	
	  var goSubwordCombo = mac ? "Ctrl-" : "Alt-";
	
	  cmds[map[goSubwordCombo + "Left"] = "goSubwordLeft"] = function(cm) { moveSubword(cm, -1); };
	  cmds[map[goSubwordCombo + "Right"] = "goSubwordRight"] = function(cm) { moveSubword(cm, 1); };
	
	  if (mac) map["Cmd-Left"] = "goLineStartSmart";
	
	  var scrollLineCombo = mac ? "Ctrl-Alt-" : "Ctrl-";
	
	  cmds[map[scrollLineCombo + "Up"] = "scrollLineUp"] = function(cm) {
	    var info = cm.getScrollInfo();
	    if (!cm.somethingSelected()) {
	      var visibleBottomLine = cm.lineAtHeight(info.top + info.clientHeight, "local");
	      if (cm.getCursor().line >= visibleBottomLine)
	        cm.execCommand("goLineUp");
	    }
	    cm.scrollTo(null, info.top - cm.defaultTextHeight());
	  };
	  cmds[map[scrollLineCombo + "Down"] = "scrollLineDown"] = function(cm) {
	    var info = cm.getScrollInfo();
	    if (!cm.somethingSelected()) {
	      var visibleTopLine = cm.lineAtHeight(info.top, "local")+1;
	      if (cm.getCursor().line <= visibleTopLine)
	        cm.execCommand("goLineDown");
	    }
	    cm.scrollTo(null, info.top + cm.defaultTextHeight());
	  };
	
	  cmds[map["Shift-" + ctrl + "L"] = "splitSelectionByLine"] = function(cm) {
	    var ranges = cm.listSelections(), lineRanges = [];
	    for (var i = 0; i < ranges.length; i++) {
	      var from = ranges[i].from(), to = ranges[i].to();
	      for (var line = from.line; line <= to.line; ++line)
	        if (!(to.line > from.line && line == to.line && to.ch == 0))
	          lineRanges.push({anchor: line == from.line ? from : Pos(line, 0),
	                           head: line == to.line ? to : Pos(line)});
	    }
	    cm.setSelections(lineRanges, 0);
	  };
	
	  map["Shift-Tab"] = "indentLess";
	
	  cmds[map["Esc"] = "singleSelectionTop"] = function(cm) {
	    var range = cm.listSelections()[0];
	    cm.setSelection(range.anchor, range.head, {scroll: false});
	  };
	
	  cmds[map[ctrl + "L"] = "selectLine"] = function(cm) {
	    var ranges = cm.listSelections(), extended = [];
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i];
	      extended.push({anchor: Pos(range.from().line, 0),
	                     head: Pos(range.to().line + 1, 0)});
	    }
	    cm.setSelections(extended);
	  };
	
	  map["Shift-Ctrl-K"] = "deleteLine";
	
	  function insertLine(cm, above) {
	    if (cm.isReadOnly()) return CodeMirror.Pass
	    cm.operation(function() {
	      var len = cm.listSelections().length, newSelection = [], last = -1;
	      for (var i = 0; i < len; i++) {
	        var head = cm.listSelections()[i].head;
	        if (head.line <= last) continue;
	        var at = Pos(head.line + (above ? 0 : 1), 0);
	        cm.replaceRange("\n", at, null, "+insertLine");
	        cm.indentLine(at.line, null, true);
	        newSelection.push({head: at, anchor: at});
	        last = head.line + 1;
	      }
	      cm.setSelections(newSelection);
	    });
	    cm.execCommand("indentAuto");
	  }
	
	  cmds[map[ctrl + "Enter"] = "insertLineAfter"] = function(cm) { return insertLine(cm, false); };
	
	  cmds[map["Shift-" + ctrl + "Enter"] = "insertLineBefore"] = function(cm) { return insertLine(cm, true); };
	
	  function wordAt(cm, pos) {
	    var start = pos.ch, end = start, line = cm.getLine(pos.line);
	    while (start && CodeMirror.isWordChar(line.charAt(start - 1))) --start;
	    while (end < line.length && CodeMirror.isWordChar(line.charAt(end))) ++end;
	    return {from: Pos(pos.line, start), to: Pos(pos.line, end), word: line.slice(start, end)};
	  }
	
	  cmds[map[ctrl + "D"] = "selectNextOccurrence"] = function(cm) {
	    var from = cm.getCursor("from"), to = cm.getCursor("to");
	    var fullWord = cm.state.sublimeFindFullWord == cm.doc.sel;
	    if (CodeMirror.cmpPos(from, to) == 0) {
	      var word = wordAt(cm, from);
	      if (!word.word) return;
	      cm.setSelection(word.from, word.to);
	      fullWord = true;
	    } else {
	      var text = cm.getRange(from, to);
	      var query = fullWord ? new RegExp("\\b" + text + "\\b") : text;
	      var cur = cm.getSearchCursor(query, to);
	      if (cur.findNext()) {
	        cm.addSelection(cur.from(), cur.to());
	      } else {
	        cur = cm.getSearchCursor(query, Pos(cm.firstLine(), 0));
	        if (cur.findNext())
	          cm.addSelection(cur.from(), cur.to());
	      }
	    }
	    if (fullWord)
	      cm.state.sublimeFindFullWord = cm.doc.sel;
	  };
	
	  var mirror = "(){}[]";
	  function selectBetweenBrackets(cm) {
	    var ranges = cm.listSelections(), newRanges = []
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i], pos = range.head, opening = cm.scanForBracket(pos, -1);
	      if (!opening) return false;
	      for (;;) {
	        var closing = cm.scanForBracket(pos, 1);
	        if (!closing) return false;
	        if (closing.ch == mirror.charAt(mirror.indexOf(opening.ch) + 1)) {
	          newRanges.push({anchor: Pos(opening.pos.line, opening.pos.ch + 1),
	                          head: closing.pos});
	          break;
	        }
	        pos = Pos(closing.pos.line, closing.pos.ch + 1);
	      }
	    }
	    cm.setSelections(newRanges);
	    return true;
	  }
	
	  cmds[map["Shift-" + ctrl + "Space"] = "selectScope"] = function(cm) {
	    selectBetweenBrackets(cm) || cm.execCommand("selectAll");
	  };
	  cmds[map["Shift-" + ctrl + "M"] = "selectBetweenBrackets"] = function(cm) {
	    if (!selectBetweenBrackets(cm)) return CodeMirror.Pass;
	  };
	
	  cmds[map[ctrl + "M"] = "goToBracket"] = function(cm) {
	    cm.extendSelectionsBy(function(range) {
	      var next = cm.scanForBracket(range.head, 1);
	      if (next && CodeMirror.cmpPos(next.pos, range.head) != 0) return next.pos;
	      var prev = cm.scanForBracket(range.head, -1);
	      return prev && Pos(prev.pos.line, prev.pos.ch + 1) || range.head;
	    });
	  };
	
	  var swapLineCombo = mac ? "Cmd-Ctrl-" : "Shift-Ctrl-";
	
	  cmds[map[swapLineCombo + "Up"] = "swapLineUp"] = function(cm) {
	    if (cm.isReadOnly()) return CodeMirror.Pass
	    var ranges = cm.listSelections(), linesToMove = [], at = cm.firstLine() - 1, newSels = [];
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i], from = range.from().line - 1, to = range.to().line;
	      newSels.push({anchor: Pos(range.anchor.line - 1, range.anchor.ch),
	                    head: Pos(range.head.line - 1, range.head.ch)});
	      if (range.to().ch == 0 && !range.empty()) --to;
	      if (from > at) linesToMove.push(from, to);
	      else if (linesToMove.length) linesToMove[linesToMove.length - 1] = to;
	      at = to;
	    }
	    cm.operation(function() {
	      for (var i = 0; i < linesToMove.length; i += 2) {
	        var from = linesToMove[i], to = linesToMove[i + 1];
	        var line = cm.getLine(from);
	        cm.replaceRange("", Pos(from, 0), Pos(from + 1, 0), "+swapLine");
	        if (to > cm.lastLine())
	          cm.replaceRange("\n" + line, Pos(cm.lastLine()), null, "+swapLine");
	        else
	          cm.replaceRange(line + "\n", Pos(to, 0), null, "+swapLine");
	      }
	      cm.setSelections(newSels);
	      cm.scrollIntoView();
	    });
	  };
	
	  cmds[map[swapLineCombo + "Down"] = "swapLineDown"] = function(cm) {
	    if (cm.isReadOnly()) return CodeMirror.Pass
	    var ranges = cm.listSelections(), linesToMove = [], at = cm.lastLine() + 1;
	    for (var i = ranges.length - 1; i >= 0; i--) {
	      var range = ranges[i], from = range.to().line + 1, to = range.from().line;
	      if (range.to().ch == 0 && !range.empty()) from--;
	      if (from < at) linesToMove.push(from, to);
	      else if (linesToMove.length) linesToMove[linesToMove.length - 1] = to;
	      at = to;
	    }
	    cm.operation(function() {
	      for (var i = linesToMove.length - 2; i >= 0; i -= 2) {
	        var from = linesToMove[i], to = linesToMove[i + 1];
	        var line = cm.getLine(from);
	        if (from == cm.lastLine())
	          cm.replaceRange("", Pos(from - 1), Pos(from), "+swapLine");
	        else
	          cm.replaceRange("", Pos(from, 0), Pos(from + 1, 0), "+swapLine");
	        cm.replaceRange(line + "\n", Pos(to, 0), null, "+swapLine");
	      }
	      cm.scrollIntoView();
	    });
	  };
	
	  cmds[map[ctrl + "/"] = "toggleCommentIndented"] = function(cm) {
	    cm.toggleComment({ indent: true });
	  }
	
	  cmds[map[ctrl + "J"] = "joinLines"] = function(cm) {
	    var ranges = cm.listSelections(), joined = [];
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i], from = range.from();
	      var start = from.line, end = range.to().line;
	      while (i < ranges.length - 1 && ranges[i + 1].from().line == end)
	        end = ranges[++i].to().line;
	      joined.push({start: start, end: end, anchor: !range.empty() && from});
	    }
	    cm.operation(function() {
	      var offset = 0, ranges = [];
	      for (var i = 0; i < joined.length; i++) {
	        var obj = joined[i];
	        var anchor = obj.anchor && Pos(obj.anchor.line - offset, obj.anchor.ch), head;
	        for (var line = obj.start; line <= obj.end; line++) {
	          var actual = line - offset;
	          if (line == obj.end) head = Pos(actual, cm.getLine(actual).length + 1);
	          if (actual < cm.lastLine()) {
	            cm.replaceRange(" ", Pos(actual), Pos(actual + 1, /^\s*/.exec(cm.getLine(actual + 1))[0].length));
	            ++offset;
	          }
	        }
	        ranges.push({anchor: anchor || head, head: head});
	      }
	      cm.setSelections(ranges, 0);
	    });
	  };
	
	  cmds[map["Shift-" + ctrl + "D"] = "duplicateLine"] = function(cm) {
	    cm.operation(function() {
	      var rangeCount = cm.listSelections().length;
	      for (var i = 0; i < rangeCount; i++) {
	        var range = cm.listSelections()[i];
	        if (range.empty())
	          cm.replaceRange(cm.getLine(range.head.line) + "\n", Pos(range.head.line, 0));
	        else
	          cm.replaceRange(cm.getRange(range.from(), range.to()), range.from());
	      }
	      cm.scrollIntoView();
	    });
	  };
	
	  if (!mac) map[ctrl + "T"] = "transposeChars";
	
	  function sortLines(cm, caseSensitive) {
	    if (cm.isReadOnly()) return CodeMirror.Pass
	    var ranges = cm.listSelections(), toSort = [], selected;
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i];
	      if (range.empty()) continue;
	      var from = range.from().line, to = range.to().line;
	      while (i < ranges.length - 1 && ranges[i + 1].from().line == to)
	        to = ranges[++i].to().line;
	      if (!ranges[i].to().ch) to--;
	      toSort.push(from, to);
	    }
	    if (toSort.length) selected = true;
	    else toSort.push(cm.firstLine(), cm.lastLine());
	
	    cm.operation(function() {
	      var ranges = [];
	      for (var i = 0; i < toSort.length; i += 2) {
	        var from = toSort[i], to = toSort[i + 1];
	        var start = Pos(from, 0), end = Pos(to);
	        var lines = cm.getRange(start, end, false);
	        if (caseSensitive)
	          lines.sort();
	        else
	          lines.sort(function(a, b) {
	            var au = a.toUpperCase(), bu = b.toUpperCase();
	            if (au != bu) { a = au; b = bu; }
	            return a < b ? -1 : a == b ? 0 : 1;
	          });
	        cm.replaceRange(lines, start, end);
	        if (selected) ranges.push({anchor: start, head: Pos(to + 1, 0)});
	      }
	      if (selected) cm.setSelections(ranges, 0);
	    });
	  }
	
	  cmds[map["F9"] = "sortLines"] = function(cm) { sortLines(cm, true); };
	  cmds[map[ctrl + "F9"] = "sortLinesInsensitive"] = function(cm) { sortLines(cm, false); };
	
	  cmds[map["F2"] = "nextBookmark"] = function(cm) {
	    var marks = cm.state.sublimeBookmarks;
	    if (marks) while (marks.length) {
	      var current = marks.shift();
	      var found = current.find();
	      if (found) {
	        marks.push(current);
	        return cm.setSelection(found.from, found.to);
	      }
	    }
	  };
	
	  cmds[map["Shift-F2"] = "prevBookmark"] = function(cm) {
	    var marks = cm.state.sublimeBookmarks;
	    if (marks) while (marks.length) {
	      marks.unshift(marks.pop());
	      var found = marks[marks.length - 1].find();
	      if (!found)
	        marks.pop();
	      else
	        return cm.setSelection(found.from, found.to);
	    }
	  };
	
	  cmds[map[ctrl + "F2"] = "toggleBookmark"] = function(cm) {
	    var ranges = cm.listSelections();
	    var marks = cm.state.sublimeBookmarks || (cm.state.sublimeBookmarks = []);
	    for (var i = 0; i < ranges.length; i++) {
	      var from = ranges[i].from(), to = ranges[i].to();
	      var found = cm.findMarks(from, to);
	      for (var j = 0; j < found.length; j++) {
	        if (found[j].sublimeBookmark) {
	          found[j].clear();
	          for (var k = 0; k < marks.length; k++)
	            if (marks[k] == found[j])
	              marks.splice(k--, 1);
	          break;
	        }
	      }
	      if (j == found.length)
	        marks.push(cm.markText(from, to, {sublimeBookmark: true, clearWhenEmpty: false}));
	    }
	  };
	
	  cmds[map["Shift-" + ctrl + "F2"] = "clearBookmarks"] = function(cm) {
	    var marks = cm.state.sublimeBookmarks;
	    if (marks) for (var i = 0; i < marks.length; i++) marks[i].clear();
	    marks.length = 0;
	  };
	
	  cmds[map["Alt-F2"] = "selectBookmarks"] = function(cm) {
	    var marks = cm.state.sublimeBookmarks, ranges = [];
	    if (marks) for (var i = 0; i < marks.length; i++) {
	      var found = marks[i].find();
	      if (!found)
	        marks.splice(i--, 0);
	      else
	        ranges.push({anchor: found.from, head: found.to});
	    }
	    if (ranges.length)
	      cm.setSelections(ranges, 0);
	  };
	
	  map["Alt-Q"] = "wrapLines";
	
	  var cK = ctrl + "K ";
	
	  function modifyWordOrSelection(cm, mod) {
	    cm.operation(function() {
	      var ranges = cm.listSelections(), indices = [], replacements = [];
	      for (var i = 0; i < ranges.length; i++) {
	        var range = ranges[i];
	        if (range.empty()) { indices.push(i); replacements.push(""); }
	        else replacements.push(mod(cm.getRange(range.from(), range.to())));
	      }
	      cm.replaceSelections(replacements, "around", "case");
	      for (var i = indices.length - 1, at; i >= 0; i--) {
	        var range = ranges[indices[i]];
	        if (at && CodeMirror.cmpPos(range.head, at) > 0) continue;
	        var word = wordAt(cm, range.head);
	        at = word.from;
	        cm.replaceRange(mod(word.word), word.from, word.to);
	      }
	    });
	  }
	
	  map[cK + ctrl + "Backspace"] = "delLineLeft";
	
	  cmds[map["Backspace"] = "smartBackspace"] = function(cm) {
	    if (cm.somethingSelected()) return CodeMirror.Pass;
	
	    cm.operation(function() {
	      var cursors = cm.listSelections();
	      var indentUnit = cm.getOption("indentUnit");
	
	      for (var i = cursors.length - 1; i >= 0; i--) {
	        var cursor = cursors[i].head;
	        var toStartOfLine = cm.getRange({line: cursor.line, ch: 0}, cursor);
	        var column = CodeMirror.countColumn(toStartOfLine, null, cm.getOption("tabSize"));
	
	        // Delete by one character by default
	        var deletePos = cm.findPosH(cursor, -1, "char", false);
	
	        if (toStartOfLine && !/\S/.test(toStartOfLine) && column % indentUnit == 0) {
	          var prevIndent = new Pos(cursor.line,
	            CodeMirror.findColumn(toStartOfLine, column - indentUnit, indentUnit));
	
	          // Smart delete only if we found a valid prevIndent location
	          if (prevIndent.ch != cursor.ch) deletePos = prevIndent;
	        }
	
	        cm.replaceRange("", deletePos, cursor, "+delete");
	      }
	    });
	  };
	
	  cmds[map[cK + ctrl + "K"] = "delLineRight"] = function(cm) {
	    cm.operation(function() {
	      var ranges = cm.listSelections();
	      for (var i = ranges.length - 1; i >= 0; i--)
	        cm.replaceRange("", ranges[i].anchor, Pos(ranges[i].to().line), "+delete");
	      cm.scrollIntoView();
	    });
	  };
	
	  cmds[map[cK + ctrl + "U"] = "upcaseAtCursor"] = function(cm) {
	    modifyWordOrSelection(cm, function(str) { return str.toUpperCase(); });
	  };
	  cmds[map[cK + ctrl + "L"] = "downcaseAtCursor"] = function(cm) {
	    modifyWordOrSelection(cm, function(str) { return str.toLowerCase(); });
	  };
	
	  cmds[map[cK + ctrl + "Space"] = "setSublimeMark"] = function(cm) {
	    if (cm.state.sublimeMark) cm.state.sublimeMark.clear();
	    cm.state.sublimeMark = cm.setBookmark(cm.getCursor());
	  };
	  cmds[map[cK + ctrl + "A"] = "selectToSublimeMark"] = function(cm) {
	    var found = cm.state.sublimeMark && cm.state.sublimeMark.find();
	    if (found) cm.setSelection(cm.getCursor(), found);
	  };
	  cmds[map[cK + ctrl + "W"] = "deleteToSublimeMark"] = function(cm) {
	    var found = cm.state.sublimeMark && cm.state.sublimeMark.find();
	    if (found) {
	      var from = cm.getCursor(), to = found;
	      if (CodeMirror.cmpPos(from, to) > 0) { var tmp = to; to = from; from = tmp; }
	      cm.state.sublimeKilled = cm.getRange(from, to);
	      cm.replaceRange("", from, to);
	    }
	  };
	  cmds[map[cK + ctrl + "X"] = "swapWithSublimeMark"] = function(cm) {
	    var found = cm.state.sublimeMark && cm.state.sublimeMark.find();
	    if (found) {
	      cm.state.sublimeMark.clear();
	      cm.state.sublimeMark = cm.setBookmark(cm.getCursor());
	      cm.setCursor(found);
	    }
	  };
	  cmds[map[cK + ctrl + "Y"] = "sublimeYank"] = function(cm) {
	    if (cm.state.sublimeKilled != null)
	      cm.replaceSelection(cm.state.sublimeKilled, null, "paste");
	  };
	
	  map[cK + ctrl + "G"] = "clearBookmarks";
	  cmds[map[cK + ctrl + "C"] = "showInCenter"] = function(cm) {
	    var pos = cm.cursorCoords(null, "local");
	    cm.scrollTo(null, (pos.top + pos.bottom) / 2 - cm.getScrollInfo().clientHeight / 2);
	  };
	
	  var selectLinesCombo = mac ? "Ctrl-Shift-" : "Ctrl-Alt-";
	  cmds[map[selectLinesCombo + "Up"] = "selectLinesUpward"] = function(cm) {
	    cm.operation(function() {
	      var ranges = cm.listSelections();
	      for (var i = 0; i < ranges.length; i++) {
	        var range = ranges[i];
	        if (range.head.line > cm.firstLine())
	          cm.addSelection(Pos(range.head.line - 1, range.head.ch));
	      }
	    });
	  };
	  cmds[map[selectLinesCombo + "Down"] = "selectLinesDownward"] = function(cm) {
	    cm.operation(function() {
	      var ranges = cm.listSelections();
	      for (var i = 0; i < ranges.length; i++) {
	        var range = ranges[i];
	        if (range.head.line < cm.lastLine())
	          cm.addSelection(Pos(range.head.line + 1, range.head.ch));
	      }
	    });
	  };
	
	  function getTarget(cm) {
	    var from = cm.getCursor("from"), to = cm.getCursor("to");
	    if (CodeMirror.cmpPos(from, to) == 0) {
	      var word = wordAt(cm, from);
	      if (!word.word) return;
	      from = word.from;
	      to = word.to;
	    }
	    return {from: from, to: to, query: cm.getRange(from, to), word: word};
	  }
	
	  function findAndGoTo(cm, forward) {
	    var target = getTarget(cm);
	    if (!target) return;
	    var query = target.query;
	    var cur = cm.getSearchCursor(query, forward ? target.to : target.from);
	
	    if (forward ? cur.findNext() : cur.findPrevious()) {
	      cm.setSelection(cur.from(), cur.to());
	    } else {
	      cur = cm.getSearchCursor(query, forward ? Pos(cm.firstLine(), 0)
	                                              : cm.clipPos(Pos(cm.lastLine())));
	      if (forward ? cur.findNext() : cur.findPrevious())
	        cm.setSelection(cur.from(), cur.to());
	      else if (target.word)
	        cm.setSelection(target.from, target.to);
	    }
	  };
	  cmds[map[ctrl + "F3"] = "findUnder"] = function(cm) { findAndGoTo(cm, true); };
	  cmds[map["Shift-" + ctrl + "F3"] = "findUnderPrevious"] = function(cm) { findAndGoTo(cm,false); };
	  cmds[map["Alt-F3"] = "findAllUnder"] = function(cm) {
	    var target = getTarget(cm);
	    if (!target) return;
	    var cur = cm.getSearchCursor(target.query);
	    var matches = [];
	    var primaryIndex = -1;
	    while (cur.findNext()) {
	      matches.push({anchor: cur.from(), head: cur.to()});
	      if (cur.from().line <= target.from.line && cur.from().ch <= target.from.ch)
	        primaryIndex++;
	    }
	    cm.setSelections(matches, primaryIndex);
	  };
	
	  map["Shift-" + ctrl + "["] = "fold";
	  map["Shift-" + ctrl + "]"] = "unfold";
	  map[cK + ctrl + "0"] = map[cK + ctrl + "J"] = "unfoldAll";
	
	  map[ctrl + "I"] = "findIncremental";
	  map["Shift-" + ctrl + "I"] = "findIncrementalReverse";
	  map[ctrl + "H"] = "replace";
	  map["F3"] = "findNext";
	  map["Shift-F3"] = "findPrev";
	
	  CodeMirror.normalizeKeyMap(map);
	});


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	/**
	 * Supported keybindings:
	 *   Too many to list. Refer to defaultKeyMap below.
	 *
	 * Supported Ex commands:
	 *   Refer to defaultExCommandMap below.
	 *
	 * Registers: unnamed, -, a-z, A-Z, 0-9
	 *   (Does not respect the special case for number registers when delete
	 *    operator is made with these commands: %, (, ),  , /, ?, n, N, {, } )
	 *   TODO: Implement the remaining registers.
	 *
	 * Marks: a-z, A-Z, and 0-9
	 *   TODO: Implement the remaining special marks. They have more complex
	 *       behavior.
	 *
	 * Events:
	 *  'vim-mode-change' - raised on the editor anytime the current mode changes,
	 *                      Event object: {mode: "visual", subMode: "linewise"}
	 *
	 * Code structure:
	 *  1. Default keymap
	 *  2. Variable declarations and short basic helpers
	 *  3. Instance (External API) implementation
	 *  4. Internal state tracking objects (input state, counter) implementation
	 *     and instantiation
	 *  5. Key handler (the main command dispatcher) implementation
	 *  6. Motion, operator, and action implementations
	 *  7. Helper functions for the key handler, motions, operators, and actions
	 *  8. Set up Vim to work as a keymap for CodeMirror.
	 *  9. Ex command implementations.
	 */
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(8), __webpack_require__(43), __webpack_require__(44));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../lib/codemirror", "../addon/search/searchcursor", "../addon/dialog/dialog", "../addon/edit/matchbrackets"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  'use strict';
	
	  var defaultKeymap = [
	    // Key to key mapping. This goes first to make it possible to override
	    // existing mappings.
	    { keys: '<Left>', type: 'keyToKey', toKeys: 'h' },
	    { keys: '<Right>', type: 'keyToKey', toKeys: 'l' },
	    { keys: '<Up>', type: 'keyToKey', toKeys: 'k' },
	    { keys: '<Down>', type: 'keyToKey', toKeys: 'j' },
	    { keys: '<Space>', type: 'keyToKey', toKeys: 'l' },
	    { keys: '<BS>', type: 'keyToKey', toKeys: 'h', context: 'normal'},
	    { keys: '<C-Space>', type: 'keyToKey', toKeys: 'W' },
	    { keys: '<C-BS>', type: 'keyToKey', toKeys: 'B', context: 'normal' },
	    { keys: '<S-Space>', type: 'keyToKey', toKeys: 'w' },
	    { keys: '<S-BS>', type: 'keyToKey', toKeys: 'b', context: 'normal' },
	    { keys: '<C-n>', type: 'keyToKey', toKeys: 'j' },
	    { keys: '<C-p>', type: 'keyToKey', toKeys: 'k' },
	    { keys: '<C-[>', type: 'keyToKey', toKeys: '<Esc>' },
	    { keys: '<C-c>', type: 'keyToKey', toKeys: '<Esc>' },
	    { keys: '<C-[>', type: 'keyToKey', toKeys: '<Esc>', context: 'insert' },
	    { keys: '<C-c>', type: 'keyToKey', toKeys: '<Esc>', context: 'insert' },
	    { keys: 's', type: 'keyToKey', toKeys: 'cl', context: 'normal' },
	    { keys: 's', type: 'keyToKey', toKeys: 'c', context: 'visual'},
	    { keys: 'S', type: 'keyToKey', toKeys: 'cc', context: 'normal' },
	    { keys: 'S', type: 'keyToKey', toKeys: 'VdO', context: 'visual' },
	    { keys: '<Home>', type: 'keyToKey', toKeys: '0' },
	    { keys: '<End>', type: 'keyToKey', toKeys: '$' },
	    { keys: '<PageUp>', type: 'keyToKey', toKeys: '<C-b>' },
	    { keys: '<PageDown>', type: 'keyToKey', toKeys: '<C-f>' },
	    { keys: '<CR>', type: 'keyToKey', toKeys: 'j^', context: 'normal' },
	    { keys: '<Ins>', type: 'action', action: 'toggleOverwrite', context: 'insert' },
	    // Motions
	    { keys: 'H', type: 'motion', motion: 'moveToTopLine', motionArgs: { linewise: true, toJumplist: true }},
	    { keys: 'M', type: 'motion', motion: 'moveToMiddleLine', motionArgs: { linewise: true, toJumplist: true }},
	    { keys: 'L', type: 'motion', motion: 'moveToBottomLine', motionArgs: { linewise: true, toJumplist: true }},
	    { keys: 'h', type: 'motion', motion: 'moveByCharacters', motionArgs: { forward: false }},
	    { keys: 'l', type: 'motion', motion: 'moveByCharacters', motionArgs: { forward: true }},
	    { keys: 'j', type: 'motion', motion: 'moveByLines', motionArgs: { forward: true, linewise: true }},
	    { keys: 'k', type: 'motion', motion: 'moveByLines', motionArgs: { forward: false, linewise: true }},
	    { keys: 'gj', type: 'motion', motion: 'moveByDisplayLines', motionArgs: { forward: true }},
	    { keys: 'gk', type: 'motion', motion: 'moveByDisplayLines', motionArgs: { forward: false }},
	    { keys: 'w', type: 'motion', motion: 'moveByWords', motionArgs: { forward: true, wordEnd: false }},
	    { keys: 'W', type: 'motion', motion: 'moveByWords', motionArgs: { forward: true, wordEnd: false, bigWord: true }},
	    { keys: 'e', type: 'motion', motion: 'moveByWords', motionArgs: { forward: true, wordEnd: true, inclusive: true }},
	    { keys: 'E', type: 'motion', motion: 'moveByWords', motionArgs: { forward: true, wordEnd: true, bigWord: true, inclusive: true }},
	    { keys: 'b', type: 'motion', motion: 'moveByWords', motionArgs: { forward: false, wordEnd: false }},
	    { keys: 'B', type: 'motion', motion: 'moveByWords', motionArgs: { forward: false, wordEnd: false, bigWord: true }},
	    { keys: 'ge', type: 'motion', motion: 'moveByWords', motionArgs: { forward: false, wordEnd: true, inclusive: true }},
	    { keys: 'gE', type: 'motion', motion: 'moveByWords', motionArgs: { forward: false, wordEnd: true, bigWord: true, inclusive: true }},
	    { keys: '{', type: 'motion', motion: 'moveByParagraph', motionArgs: { forward: false, toJumplist: true }},
	    { keys: '}', type: 'motion', motion: 'moveByParagraph', motionArgs: { forward: true, toJumplist: true }},
	    { keys: '<C-f>', type: 'motion', motion: 'moveByPage', motionArgs: { forward: true }},
	    { keys: '<C-b>', type: 'motion', motion: 'moveByPage', motionArgs: { forward: false }},
	    { keys: '<C-d>', type: 'motion', motion: 'moveByScroll', motionArgs: { forward: true, explicitRepeat: true }},
	    { keys: '<C-u>', type: 'motion', motion: 'moveByScroll', motionArgs: { forward: false, explicitRepeat: true }},
	    { keys: 'gg', type: 'motion', motion: 'moveToLineOrEdgeOfDocument', motionArgs: { forward: false, explicitRepeat: true, linewise: true, toJumplist: true }},
	    { keys: 'G', type: 'motion', motion: 'moveToLineOrEdgeOfDocument', motionArgs: { forward: true, explicitRepeat: true, linewise: true, toJumplist: true }},
	    { keys: '0', type: 'motion', motion: 'moveToStartOfLine' },
	    { keys: '^', type: 'motion', motion: 'moveToFirstNonWhiteSpaceCharacter' },
	    { keys: '+', type: 'motion', motion: 'moveByLines', motionArgs: { forward: true, toFirstChar:true }},
	    { keys: '-', type: 'motion', motion: 'moveByLines', motionArgs: { forward: false, toFirstChar:true }},
	    { keys: '_', type: 'motion', motion: 'moveByLines', motionArgs: { forward: true, toFirstChar:true, repeatOffset:-1 }},
	    { keys: '$', type: 'motion', motion: 'moveToEol', motionArgs: { inclusive: true }},
	    { keys: '%', type: 'motion', motion: 'moveToMatchedSymbol', motionArgs: { inclusive: true, toJumplist: true }},
	    { keys: 'f<character>', type: 'motion', motion: 'moveToCharacter', motionArgs: { forward: true , inclusive: true }},
	    { keys: 'F<character>', type: 'motion', motion: 'moveToCharacter', motionArgs: { forward: false }},
	    { keys: 't<character>', type: 'motion', motion: 'moveTillCharacter', motionArgs: { forward: true, inclusive: true }},
	    { keys: 'T<character>', type: 'motion', motion: 'moveTillCharacter', motionArgs: { forward: false }},
	    { keys: ';', type: 'motion', motion: 'repeatLastCharacterSearch', motionArgs: { forward: true }},
	    { keys: ',', type: 'motion', motion: 'repeatLastCharacterSearch', motionArgs: { forward: false }},
	    { keys: '\'<character>', type: 'motion', motion: 'goToMark', motionArgs: {toJumplist: true, linewise: true}},
	    { keys: '`<character>', type: 'motion', motion: 'goToMark', motionArgs: {toJumplist: true}},
	    { keys: ']`', type: 'motion', motion: 'jumpToMark', motionArgs: { forward: true } },
	    { keys: '[`', type: 'motion', motion: 'jumpToMark', motionArgs: { forward: false } },
	    { keys: ']\'', type: 'motion', motion: 'jumpToMark', motionArgs: { forward: true, linewise: true } },
	    { keys: '[\'', type: 'motion', motion: 'jumpToMark', motionArgs: { forward: false, linewise: true } },
	    // the next two aren't motions but must come before more general motion declarations
	    { keys: ']p', type: 'action', action: 'paste', isEdit: true, actionArgs: { after: true, isEdit: true, matchIndent: true}},
	    { keys: '[p', type: 'action', action: 'paste', isEdit: true, actionArgs: { after: false, isEdit: true, matchIndent: true}},
	    { keys: ']<character>', type: 'motion', motion: 'moveToSymbol', motionArgs: { forward: true, toJumplist: true}},
	    { keys: '[<character>', type: 'motion', motion: 'moveToSymbol', motionArgs: { forward: false, toJumplist: true}},
	    { keys: '|', type: 'motion', motion: 'moveToColumn'},
	    { keys: 'o', type: 'motion', motion: 'moveToOtherHighlightedEnd', context:'visual'},
	    { keys: 'O', type: 'motion', motion: 'moveToOtherHighlightedEnd', motionArgs: {sameLine: true}, context:'visual'},
	    // Operators
	    { keys: 'd', type: 'operator', operator: 'delete' },
	    { keys: 'y', type: 'operator', operator: 'yank' },
	    { keys: 'c', type: 'operator', operator: 'change' },
	    { keys: '>', type: 'operator', operator: 'indent', operatorArgs: { indentRight: true }},
	    { keys: '<', type: 'operator', operator: 'indent', operatorArgs: { indentRight: false }},
	    { keys: 'g~', type: 'operator', operator: 'changeCase' },
	    { keys: 'gu', type: 'operator', operator: 'changeCase', operatorArgs: {toLower: true}, isEdit: true },
	    { keys: 'gU', type: 'operator', operator: 'changeCase', operatorArgs: {toLower: false}, isEdit: true },
	    { keys: 'n', type: 'motion', motion: 'findNext', motionArgs: { forward: true, toJumplist: true }},
	    { keys: 'N', type: 'motion', motion: 'findNext', motionArgs: { forward: false, toJumplist: true }},
	    // Operator-Motion dual commands
	    { keys: 'x', type: 'operatorMotion', operator: 'delete', motion: 'moveByCharacters', motionArgs: { forward: true }, operatorMotionArgs: { visualLine: false }},
	    { keys: 'X', type: 'operatorMotion', operator: 'delete', motion: 'moveByCharacters', motionArgs: { forward: false }, operatorMotionArgs: { visualLine: true }},
	    { keys: 'D', type: 'operatorMotion', operator: 'delete', motion: 'moveToEol', motionArgs: { inclusive: true }, context: 'normal'},
	    { keys: 'D', type: 'operator', operator: 'delete', operatorArgs: { linewise: true }, context: 'visual'},
	    { keys: 'Y', type: 'operatorMotion', operator: 'yank', motion: 'moveToEol', motionArgs: { inclusive: true }, context: 'normal'},
	    { keys: 'Y', type: 'operator', operator: 'yank', operatorArgs: { linewise: true }, context: 'visual'},
	    { keys: 'C', type: 'operatorMotion', operator: 'change', motion: 'moveToEol', motionArgs: { inclusive: true }, context: 'normal'},
	    { keys: 'C', type: 'operator', operator: 'change', operatorArgs: { linewise: true }, context: 'visual'},
	    { keys: '~', type: 'operatorMotion', operator: 'changeCase', motion: 'moveByCharacters', motionArgs: { forward: true }, operatorArgs: { shouldMoveCursor: true }, context: 'normal'},
	    { keys: '~', type: 'operator', operator: 'changeCase', context: 'visual'},
	    { keys: '<C-w>', type: 'operatorMotion', operator: 'delete', motion: 'moveByWords', motionArgs: { forward: false, wordEnd: false }, context: 'insert' },
	    // Actions
	    { keys: '<C-i>', type: 'action', action: 'jumpListWalk', actionArgs: { forward: true }},
	    { keys: '<C-o>', type: 'action', action: 'jumpListWalk', actionArgs: { forward: false }},
	    { keys: '<C-e>', type: 'action', action: 'scroll', actionArgs: { forward: true, linewise: true }},
	    { keys: '<C-y>', type: 'action', action: 'scroll', actionArgs: { forward: false, linewise: true }},
	    { keys: 'a', type: 'action', action: 'enterInsertMode', isEdit: true, actionArgs: { insertAt: 'charAfter' }, context: 'normal' },
	    { keys: 'A', type: 'action', action: 'enterInsertMode', isEdit: true, actionArgs: { insertAt: 'eol' }, context: 'normal' },
	    { keys: 'A', type: 'action', action: 'enterInsertMode', isEdit: true, actionArgs: { insertAt: 'endOfSelectedArea' }, context: 'visual' },
	    { keys: 'i', type: 'action', action: 'enterInsertMode', isEdit: true, actionArgs: { insertAt: 'inplace' }, context: 'normal' },
	    { keys: 'I', type: 'action', action: 'enterInsertMode', isEdit: true, actionArgs: { insertAt: 'firstNonBlank'}, context: 'normal' },
	    { keys: 'I', type: 'action', action: 'enterInsertMode', isEdit: true, actionArgs: { insertAt: 'startOfSelectedArea' }, context: 'visual' },
	    { keys: 'o', type: 'action', action: 'newLineAndEnterInsertMode', isEdit: true, interlaceInsertRepeat: true, actionArgs: { after: true }, context: 'normal' },
	    { keys: 'O', type: 'action', action: 'newLineAndEnterInsertMode', isEdit: true, interlaceInsertRepeat: true, actionArgs: { after: false }, context: 'normal' },
	    { keys: 'v', type: 'action', action: 'toggleVisualMode' },
	    { keys: 'V', type: 'action', action: 'toggleVisualMode', actionArgs: { linewise: true }},
	    { keys: '<C-v>', type: 'action', action: 'toggleVisualMode', actionArgs: { blockwise: true }},
	    { keys: '<C-q>', type: 'action', action: 'toggleVisualMode', actionArgs: { blockwise: true }},
	    { keys: 'gv', type: 'action', action: 'reselectLastSelection' },
	    { keys: 'J', type: 'action', action: 'joinLines', isEdit: true },
	    { keys: 'p', type: 'action', action: 'paste', isEdit: true, actionArgs: { after: true, isEdit: true }},
	    { keys: 'P', type: 'action', action: 'paste', isEdit: true, actionArgs: { after: false, isEdit: true }},
	    { keys: 'r<character>', type: 'action', action: 'replace', isEdit: true },
	    { keys: '@<character>', type: 'action', action: 'replayMacro' },
	    { keys: 'q<character>', type: 'action', action: 'enterMacroRecordMode' },
	    // Handle Replace-mode as a special case of insert mode.
	    { keys: 'R', type: 'action', action: 'enterInsertMode', isEdit: true, actionArgs: { replace: true }},
	    { keys: 'u', type: 'action', action: 'undo', context: 'normal' },
	    { keys: 'u', type: 'operator', operator: 'changeCase', operatorArgs: {toLower: true}, context: 'visual', isEdit: true },
	    { keys: 'U', type: 'operator', operator: 'changeCase', operatorArgs: {toLower: false}, context: 'visual', isEdit: true },
	    { keys: '<C-r>', type: 'action', action: 'redo' },
	    { keys: 'm<character>', type: 'action', action: 'setMark' },
	    { keys: '"<character>', type: 'action', action: 'setRegister' },
	    { keys: 'zz', type: 'action', action: 'scrollToCursor', actionArgs: { position: 'center' }},
	    { keys: 'z.', type: 'action', action: 'scrollToCursor', actionArgs: { position: 'center' }, motion: 'moveToFirstNonWhiteSpaceCharacter' },
	    { keys: 'zt', type: 'action', action: 'scrollToCursor', actionArgs: { position: 'top' }},
	    { keys: 'z<CR>', type: 'action', action: 'scrollToCursor', actionArgs: { position: 'top' }, motion: 'moveToFirstNonWhiteSpaceCharacter' },
	    { keys: 'z-', type: 'action', action: 'scrollToCursor', actionArgs: { position: 'bottom' }},
	    { keys: 'zb', type: 'action', action: 'scrollToCursor', actionArgs: { position: 'bottom' }, motion: 'moveToFirstNonWhiteSpaceCharacter' },
	    { keys: '.', type: 'action', action: 'repeatLastEdit' },
	    { keys: '<C-a>', type: 'action', action: 'incrementNumberToken', isEdit: true, actionArgs: {increase: true, backtrack: false}},
	    { keys: '<C-x>', type: 'action', action: 'incrementNumberToken', isEdit: true, actionArgs: {increase: false, backtrack: false}},
	    { keys: '<C-t>', type: 'action', action: 'indent', actionArgs: { indentRight: true }, context: 'insert' },
	    { keys: '<C-d>', type: 'action', action: 'indent', actionArgs: { indentRight: false }, context: 'insert' },
	    // Text object motions
	    { keys: 'a<character>', type: 'motion', motion: 'textObjectManipulation' },
	    { keys: 'i<character>', type: 'motion', motion: 'textObjectManipulation', motionArgs: { textObjectInner: true }},
	    // Search
	    { keys: '/', type: 'search', searchArgs: { forward: true, querySrc: 'prompt', toJumplist: true }},
	    { keys: '?', type: 'search', searchArgs: { forward: false, querySrc: 'prompt', toJumplist: true }},
	    { keys: '*', type: 'search', searchArgs: { forward: true, querySrc: 'wordUnderCursor', wholeWordOnly: true, toJumplist: true }},
	    { keys: '#', type: 'search', searchArgs: { forward: false, querySrc: 'wordUnderCursor', wholeWordOnly: true, toJumplist: true }},
	    { keys: 'g*', type: 'search', searchArgs: { forward: true, querySrc: 'wordUnderCursor', toJumplist: true }},
	    { keys: 'g#', type: 'search', searchArgs: { forward: false, querySrc: 'wordUnderCursor', toJumplist: true }},
	    // Ex command
	    { keys: ':', type: 'ex' }
	  ];
	
	  /**
	   * Ex commands
	   * Care must be taken when adding to the default Ex command map. For any
	   * pair of commands that have a shared prefix, at least one of their
	   * shortNames must not match the prefix of the other command.
	   */
	  var defaultExCommandMap = [
	    { name: 'colorscheme', shortName: 'colo' },
	    { name: 'map' },
	    { name: 'imap', shortName: 'im' },
	    { name: 'nmap', shortName: 'nm' },
	    { name: 'vmap', shortName: 'vm' },
	    { name: 'unmap' },
	    { name: 'write', shortName: 'w' },
	    { name: 'undo', shortName: 'u' },
	    { name: 'redo', shortName: 'red' },
	    { name: 'set', shortName: 'se' },
	    { name: 'set', shortName: 'se' },
	    { name: 'setlocal', shortName: 'setl' },
	    { name: 'setglobal', shortName: 'setg' },
	    { name: 'sort', shortName: 'sor' },
	    { name: 'substitute', shortName: 's', possiblyAsync: true },
	    { name: 'nohlsearch', shortName: 'noh' },
	    { name: 'yank', shortName: 'y' },
	    { name: 'delmarks', shortName: 'delm' },
	    { name: 'registers', shortName: 'reg', excludeFromCommandHistory: true },
	    { name: 'global', shortName: 'g' }
	  ];
	
	  var Pos = CodeMirror.Pos;
	
	  var Vim = function() {
	    function enterVimMode(cm) {
	      cm.setOption('disableInput', true);
	      cm.setOption('showCursorWhenSelecting', false);
	      CodeMirror.signal(cm, "vim-mode-change", {mode: "normal"});
	      cm.on('cursorActivity', onCursorActivity);
	      maybeInitVimState(cm);
	      CodeMirror.on(cm.getInputField(), 'paste', getOnPasteFn(cm));
	    }
	
	    function leaveVimMode(cm) {
	      cm.setOption('disableInput', false);
	      cm.off('cursorActivity', onCursorActivity);
	      CodeMirror.off(cm.getInputField(), 'paste', getOnPasteFn(cm));
	      cm.state.vim = null;
	    }
	
	    function detachVimMap(cm, next) {
	      if (this == CodeMirror.keyMap.vim)
	        CodeMirror.rmClass(cm.getWrapperElement(), "cm-fat-cursor");
	
	      if (!next || next.attach != attachVimMap)
	        leaveVimMode(cm, false);
	    }
	    function attachVimMap(cm, prev) {
	      if (this == CodeMirror.keyMap.vim)
	        CodeMirror.addClass(cm.getWrapperElement(), "cm-fat-cursor");
	
	      if (!prev || prev.attach != attachVimMap)
	        enterVimMode(cm);
	    }
	
	    // Deprecated, simply setting the keymap works again.
	    CodeMirror.defineOption('vimMode', false, function(cm, val, prev) {
	      if (val && cm.getOption("keyMap") != "vim")
	        cm.setOption("keyMap", "vim");
	      else if (!val && prev != CodeMirror.Init && /^vim/.test(cm.getOption("keyMap")))
	        cm.setOption("keyMap", "default");
	    });
	
	    function cmKey(key, cm) {
	      if (!cm) { return undefined; }
	      if (this[key]) { return this[key]; }
	      var vimKey = cmKeyToVimKey(key);
	      if (!vimKey) {
	        return false;
	      }
	      var cmd = CodeMirror.Vim.findKey(cm, vimKey);
	      if (typeof cmd == 'function') {
	        CodeMirror.signal(cm, 'vim-keypress', vimKey);
	      }
	      return cmd;
	    }
	
	    var modifiers = {'Shift': 'S', 'Ctrl': 'C', 'Alt': 'A', 'Cmd': 'D', 'Mod': 'A'};
	    var specialKeys = {Enter:'CR',Backspace:'BS',Delete:'Del',Insert:'Ins'};
	    function cmKeyToVimKey(key) {
	      if (key.charAt(0) == '\'') {
	        // Keypress character binding of format "'a'"
	        return key.charAt(1);
	      }
	      var pieces = key.split(/-(?!$)/);
	      var lastPiece = pieces[pieces.length - 1];
	      if (pieces.length == 1 && pieces[0].length == 1) {
	        // No-modifier bindings use literal character bindings above. Skip.
	        return false;
	      } else if (pieces.length == 2 && pieces[0] == 'Shift' && lastPiece.length == 1) {
	        // Ignore Shift+char bindings as they should be handled by literal character.
	        return false;
	      }
	      var hasCharacter = false;
	      for (var i = 0; i < pieces.length; i++) {
	        var piece = pieces[i];
	        if (piece in modifiers) { pieces[i] = modifiers[piece]; }
	        else { hasCharacter = true; }
	        if (piece in specialKeys) { pieces[i] = specialKeys[piece]; }
	      }
	      if (!hasCharacter) {
	        // Vim does not support modifier only keys.
	        return false;
	      }
	      // TODO: Current bindings expect the character to be lower case, but
	      // it looks like vim key notation uses upper case.
	      if (isUpperCase(lastPiece)) {
	        pieces[pieces.length - 1] = lastPiece.toLowerCase();
	      }
	      return '<' + pieces.join('-') + '>';
	    }
	
	    function getOnPasteFn(cm) {
	      var vim = cm.state.vim;
	      if (!vim.onPasteFn) {
	        vim.onPasteFn = function() {
	          if (!vim.insertMode) {
	            cm.setCursor(offsetCursor(cm.getCursor(), 0, 1));
	            actions.enterInsertMode(cm, {}, vim);
	          }
	        };
	      }
	      return vim.onPasteFn;
	    }
	
	    var numberRegex = /[\d]/;
	    var wordCharTest = [CodeMirror.isWordChar, function(ch) {
	      return ch && !CodeMirror.isWordChar(ch) && !/\s/.test(ch);
	    }], bigWordCharTest = [function(ch) {
	      return /\S/.test(ch);
	    }];
	    function makeKeyRange(start, size) {
	      var keys = [];
	      for (var i = start; i < start + size; i++) {
	        keys.push(String.fromCharCode(i));
	      }
	      return keys;
	    }
	    var upperCaseAlphabet = makeKeyRange(65, 26);
	    var lowerCaseAlphabet = makeKeyRange(97, 26);
	    var numbers = makeKeyRange(48, 10);
	    var validMarks = [].concat(upperCaseAlphabet, lowerCaseAlphabet, numbers, ['<', '>']);
	    var validRegisters = [].concat(upperCaseAlphabet, lowerCaseAlphabet, numbers, ['-', '"', '.', ':', '/']);
	
	    function isLine(cm, line) {
	      return line >= cm.firstLine() && line <= cm.lastLine();
	    }
	    function isLowerCase(k) {
	      return (/^[a-z]$/).test(k);
	    }
	    function isMatchableSymbol(k) {
	      return '()[]{}'.indexOf(k) != -1;
	    }
	    function isNumber(k) {
	      return numberRegex.test(k);
	    }
	    function isUpperCase(k) {
	      return (/^[A-Z]$/).test(k);
	    }
	    function isWhiteSpaceString(k) {
	      return (/^\s*$/).test(k);
	    }
	    function inArray(val, arr) {
	      for (var i = 0; i < arr.length; i++) {
	        if (arr[i] == val) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    var options = {};
	    function defineOption(name, defaultValue, type, aliases, callback) {
	      if (defaultValue === undefined && !callback) {
	        throw Error('defaultValue is required unless callback is provided');
	      }
	      if (!type) { type = 'string'; }
	      options[name] = {
	        type: type,
	        defaultValue: defaultValue,
	        callback: callback
	      };
	      if (aliases) {
	        for (var i = 0; i < aliases.length; i++) {
	          options[aliases[i]] = options[name];
	        }
	      }
	      if (defaultValue) {
	        setOption(name, defaultValue);
	      }
	    }
	
	    function setOption(name, value, cm, cfg) {
	      var option = options[name];
	      cfg = cfg || {};
	      var scope = cfg.scope;
	      if (!option) {
	        throw Error('Unknown option: ' + name);
	      }
	      if (option.type == 'boolean') {
	        if (value && value !== true) {
	          throw Error('Invalid argument: ' + name + '=' + value);
	        } else if (value !== false) {
	          // Boolean options are set to true if value is not defined.
	          value = true;
	        }
	      }
	      if (option.callback) {
	        if (scope !== 'local') {
	          option.callback(value, undefined);
	        }
	        if (scope !== 'global' && cm) {
	          option.callback(value, cm);
	        }
	      } else {
	        if (scope !== 'local') {
	          option.value = option.type == 'boolean' ? !!value : value;
	        }
	        if (scope !== 'global' && cm) {
	          cm.state.vim.options[name] = {value: value};
	        }
	      }
	    }
	
	    function getOption(name, cm, cfg) {
	      var option = options[name];
	      cfg = cfg || {};
	      var scope = cfg.scope;
	      if (!option) {
	        throw Error('Unknown option: ' + name);
	      }
	      if (option.callback) {
	        var local = cm && option.callback(undefined, cm);
	        if (scope !== 'global' && local !== undefined) {
	          return local;
	        }
	        if (scope !== 'local') {
	          return option.callback();
	        }
	        return;
	      } else {
	        var local = (scope !== 'global') && (cm && cm.state.vim.options[name]);
	        return (local || (scope !== 'local') && option || {}).value;
	      }
	    }
	
	    defineOption('filetype', undefined, 'string', ['ft'], function(name, cm) {
	      // Option is local. Do nothing for global.
	      if (cm === undefined) {
	        return;
	      }
	      // The 'filetype' option proxies to the CodeMirror 'mode' option.
	      if (name === undefined) {
	        var mode = cm.getOption('mode');
	        return mode == 'null' ? '' : mode;
	      } else {
	        var mode = name == '' ? 'null' : name;
	        cm.setOption('mode', mode);
	      }
	    });
	
	    var createCircularJumpList = function() {
	      var size = 100;
	      var pointer = -1;
	      var head = 0;
	      var tail = 0;
	      var buffer = new Array(size);
	      function add(cm, oldCur, newCur) {
	        var current = pointer % size;
	        var curMark = buffer[current];
	        function useNextSlot(cursor) {
	          var next = ++pointer % size;
	          var trashMark = buffer[next];
	          if (trashMark) {
	            trashMark.clear();
	          }
	          buffer[next] = cm.setBookmark(cursor);
	        }
	        if (curMark) {
	          var markPos = curMark.find();
	          // avoid recording redundant cursor position
	          if (markPos && !cursorEqual(markPos, oldCur)) {
	            useNextSlot(oldCur);
	          }
	        } else {
	          useNextSlot(oldCur);
	        }
	        useNextSlot(newCur);
	        head = pointer;
	        tail = pointer - size + 1;
	        if (tail < 0) {
	          tail = 0;
	        }
	      }
	      function move(cm, offset) {
	        pointer += offset;
	        if (pointer > head) {
	          pointer = head;
	        } else if (pointer < tail) {
	          pointer = tail;
	        }
	        var mark = buffer[(size + pointer) % size];
	        // skip marks that are temporarily removed from text buffer
	        if (mark && !mark.find()) {
	          var inc = offset > 0 ? 1 : -1;
	          var newCur;
	          var oldCur = cm.getCursor();
	          do {
	            pointer += inc;
	            mark = buffer[(size + pointer) % size];
	            // skip marks that are the same as current position
	            if (mark &&
	                (newCur = mark.find()) &&
	                !cursorEqual(oldCur, newCur)) {
	              break;
	            }
	          } while (pointer < head && pointer > tail);
	        }
	        return mark;
	      }
	      return {
	        cachedCursor: undefined, //used for # and * jumps
	        add: add,
	        move: move
	      };
	    };
	
	    // Returns an object to track the changes associated insert mode.  It
	    // clones the object that is passed in, or creates an empty object one if
	    // none is provided.
	    var createInsertModeChanges = function(c) {
	      if (c) {
	        // Copy construction
	        return {
	          changes: c.changes,
	          expectCursorActivityForChange: c.expectCursorActivityForChange
	        };
	      }
	      return {
	        // Change list
	        changes: [],
	        // Set to true on change, false on cursorActivity.
	        expectCursorActivityForChange: false
	      };
	    };
	
	    function MacroModeState() {
	      this.latestRegister = undefined;
	      this.isPlaying = false;
	      this.isRecording = false;
	      this.replaySearchQueries = [];
	      this.onRecordingDone = undefined;
	      this.lastInsertModeChanges = createInsertModeChanges();
	    }
	    MacroModeState.prototype = {
	      exitMacroRecordMode: function() {
	        var macroModeState = vimGlobalState.macroModeState;
	        if (macroModeState.onRecordingDone) {
	          macroModeState.onRecordingDone(); // close dialog
	        }
	        macroModeState.onRecordingDone = undefined;
	        macroModeState.isRecording = false;
	      },
	      enterMacroRecordMode: function(cm, registerName) {
	        var register =
	            vimGlobalState.registerController.getRegister(registerName);
	        if (register) {
	          register.clear();
	          this.latestRegister = registerName;
	          if (cm.openDialog) {
	            this.onRecordingDone = cm.openDialog(
	                '(recording)['+registerName+']', null, {bottom:true});
	          }
	          this.isRecording = true;
	        }
	      }
	    };
	
	    function maybeInitVimState(cm) {
	      if (!cm.state.vim) {
	        // Store instance state in the CodeMirror object.
	        cm.state.vim = {
	          inputState: new InputState(),
	          // Vim's input state that triggered the last edit, used to repeat
	          // motions and operators with '.'.
	          lastEditInputState: undefined,
	          // Vim's action command before the last edit, used to repeat actions
	          // with '.' and insert mode repeat.
	          lastEditActionCommand: undefined,
	          // When using jk for navigation, if you move from a longer line to a
	          // shorter line, the cursor may clip to the end of the shorter line.
	          // If j is pressed again and cursor goes to the next line, the
	          // cursor should go back to its horizontal position on the longer
	          // line if it can. This is to keep track of the horizontal position.
	          lastHPos: -1,
	          // Doing the same with screen-position for gj/gk
	          lastHSPos: -1,
	          // The last motion command run. Cleared if a non-motion command gets
	          // executed in between.
	          lastMotion: null,
	          marks: {},
	          // Mark for rendering fake cursor for visual mode.
	          fakeCursor: null,
	          insertMode: false,
	          // Repeat count for changes made in insert mode, triggered by key
	          // sequences like 3,i. Only exists when insertMode is true.
	          insertModeRepeat: undefined,
	          visualMode: false,
	          // If we are in visual line mode. No effect if visualMode is false.
	          visualLine: false,
	          visualBlock: false,
	          lastSelection: null,
	          lastPastedText: null,
	          sel: {},
	          // Buffer-local/window-local values of vim options.
	          options: {}
	        };
	      }
	      return cm.state.vim;
	    }
	    var vimGlobalState;
	    function resetVimGlobalState() {
	      vimGlobalState = {
	        // The current search query.
	        searchQuery: null,
	        // Whether we are searching backwards.
	        searchIsReversed: false,
	        // Replace part of the last substituted pattern
	        lastSubstituteReplacePart: undefined,
	        jumpList: createCircularJumpList(),
	        macroModeState: new MacroModeState,
	        // Recording latest f, t, F or T motion command.
	        lastCharacterSearch: {increment:0, forward:true, selectedCharacter:''},
	        registerController: new RegisterController({}),
	        // search history buffer
	        searchHistoryController: new HistoryController({}),
	        // ex Command history buffer
	        exCommandHistoryController : new HistoryController({})
	      };
	      for (var optionName in options) {
	        var option = options[optionName];
	        option.value = option.defaultValue;
	      }
	    }
	
	    var lastInsertModeKeyTimer;
	    var vimApi= {
	      buildKeyMap: function() {
	        // TODO: Convert keymap into dictionary format for fast lookup.
	      },
	      // Testing hook, though it might be useful to expose the register
	      // controller anyways.
	      getRegisterController: function() {
	        return vimGlobalState.registerController;
	      },
	      // Testing hook.
	      resetVimGlobalState_: resetVimGlobalState,
	
	      // Testing hook.
	      getVimGlobalState_: function() {
	        return vimGlobalState;
	      },
	
	      // Testing hook.
	      maybeInitVimState_: maybeInitVimState,
	
	      suppressErrorLogging: false,
	
	      InsertModeKey: InsertModeKey,
	      map: function(lhs, rhs, ctx) {
	        // Add user defined key bindings.
	        exCommandDispatcher.map(lhs, rhs, ctx);
	      },
	      unmap: function(lhs, ctx) {
	        exCommandDispatcher.unmap(lhs, ctx);
	      },
	      // TODO: Expose setOption and getOption as instance methods. Need to decide how to namespace
	      // them, or somehow make them work with the existing CodeMirror setOption/getOption API.
	      setOption: setOption,
	      getOption: getOption,
	      defineOption: defineOption,
	      defineEx: function(name, prefix, func){
	        if (!prefix) {
	          prefix = name;
	        } else if (name.indexOf(prefix) !== 0) {
	          throw new Error('(Vim.defineEx) "'+prefix+'" is not a prefix of "'+name+'", command not registered');
	        }
	        exCommands[name]=func;
	        exCommandDispatcher.commandMap_[prefix]={name:name, shortName:prefix, type:'api'};
	      },
	      handleKey: function (cm, key, origin) {
	        var command = this.findKey(cm, key, origin);
	        if (typeof command === 'function') {
	          return command();
	        }
	      },
	      /**
	       * This is the outermost function called by CodeMirror, after keys have
	       * been mapped to their Vim equivalents.
	       *
	       * Finds a command based on the key (and cached keys if there is a
	       * multi-key sequence). Returns `undefined` if no key is matched, a noop
	       * function if a partial match is found (multi-key), and a function to
	       * execute the bound command if a a key is matched. The function always
	       * returns true.
	       */
	      findKey: function(cm, key, origin) {
	        var vim = maybeInitVimState(cm);
	        function handleMacroRecording() {
	          var macroModeState = vimGlobalState.macroModeState;
	          if (macroModeState.isRecording) {
	            if (key == 'q') {
	              macroModeState.exitMacroRecordMode();
	              clearInputState(cm);
	              return true;
	            }
	            if (origin != 'mapping') {
	              logKey(macroModeState, key);
	            }
	          }
	        }
	        function handleEsc() {
	          if (key == '<Esc>') {
	            // Clear input state and get back to normal mode.
	            clearInputState(cm);
	            if (vim.visualMode) {
	              exitVisualMode(cm);
	            } else if (vim.insertMode) {
	              exitInsertMode(cm);
	            }
	            return true;
	          }
	        }
	        function doKeyToKey(keys) {
	          // TODO: prevent infinite recursion.
	          var match;
	          while (keys) {
	            // Pull off one command key, which is either a single character
	            // or a special sequence wrapped in '<' and '>', e.g. '<Space>'.
	            match = (/<\w+-.+?>|<\w+>|./).exec(keys);
	            key = match[0];
	            keys = keys.substring(match.index + key.length);
	            CodeMirror.Vim.handleKey(cm, key, 'mapping');
	          }
	        }
	
	        function handleKeyInsertMode() {
	          if (handleEsc()) { return true; }
	          var keys = vim.inputState.keyBuffer = vim.inputState.keyBuffer + key;
	          var keysAreChars = key.length == 1;
	          var match = commandDispatcher.matchCommand(keys, defaultKeymap, vim.inputState, 'insert');
	          // Need to check all key substrings in insert mode.
	          while (keys.length > 1 && match.type != 'full') {
	            var keys = vim.inputState.keyBuffer = keys.slice(1);
	            var thisMatch = commandDispatcher.matchCommand(keys, defaultKeymap, vim.inputState, 'insert');
	            if (thisMatch.type != 'none') { match = thisMatch; }
	          }
	          if (match.type == 'none') { clearInputState(cm); return false; }
	          else if (match.type == 'partial') {
	            if (lastInsertModeKeyTimer) { window.clearTimeout(lastInsertModeKeyTimer); }
	            lastInsertModeKeyTimer = window.setTimeout(
	              function() { if (vim.insertMode && vim.inputState.keyBuffer) { clearInputState(cm); } },
	              getOption('insertModeEscKeysTimeout'));
	            return !keysAreChars;
	          }
	
	          if (lastInsertModeKeyTimer) { window.clearTimeout(lastInsertModeKeyTimer); }
	          if (keysAreChars) {
	            var selections = cm.listSelections();
	            for (var i = 0; i < selections.length; i++) {
	              var here = selections[i].head;
	              cm.replaceRange('', offsetCursor(here, 0, -(keys.length - 1)), here, '+input');
	            }
	            vimGlobalState.macroModeState.lastInsertModeChanges.changes.pop();
	          }
	          clearInputState(cm);
	          return match.command;
	        }
	
	        function handleKeyNonInsertMode() {
	          if (handleMacroRecording() || handleEsc()) { return true; };
	
	          var keys = vim.inputState.keyBuffer = vim.inputState.keyBuffer + key;
	          if (/^[1-9]\d*$/.test(keys)) { return true; }
	
	          var keysMatcher = /^(\d*)(.*)$/.exec(keys);
	          if (!keysMatcher) { clearInputState(cm); return false; }
	          var context = vim.visualMode ? 'visual' :
	                                         'normal';
	          var match = commandDispatcher.matchCommand(keysMatcher[2] || keysMatcher[1], defaultKeymap, vim.inputState, context);
	          if (match.type == 'none') { clearInputState(cm); return false; }
	          else if (match.type == 'partial') { return true; }
	
	          vim.inputState.keyBuffer = '';
	          var keysMatcher = /^(\d*)(.*)$/.exec(keys);
	          if (keysMatcher[1] && keysMatcher[1] != '0') {
	            vim.inputState.pushRepeatDigit(keysMatcher[1]);
	          }
	          return match.command;
	        }
	
	        var command;
	        if (vim.insertMode) { command = handleKeyInsertMode(); }
	        else { command = handleKeyNonInsertMode(); }
	        if (command === false) {
	          return undefined;
	        } else if (command === true) {
	          // TODO: Look into using CodeMirror's multi-key handling.
	          // Return no-op since we are caching the key. Counts as handled, but
	          // don't want act on it just yet.
	          return function() { return true; };
	        } else {
	          return function() {
	            return cm.operation(function() {
	              cm.curOp.isVimOp = true;
	              try {
	                if (command.type == 'keyToKey') {
	                  doKeyToKey(command.toKeys);
	                } else {
	                  commandDispatcher.processCommand(cm, vim, command);
	                }
	              } catch (e) {
	                // clear VIM state in case it's in a bad state.
	                cm.state.vim = undefined;
	                maybeInitVimState(cm);
	                if (!CodeMirror.Vim.suppressErrorLogging) {
	                  console['log'](e);
	                }
	                throw e;
	              }
	              return true;
	            });
	          };
	        }
	      },
	      handleEx: function(cm, input) {
	        exCommandDispatcher.processCommand(cm, input);
	      },
	
	      defineMotion: defineMotion,
	      defineAction: defineAction,
	      defineOperator: defineOperator,
	      mapCommand: mapCommand,
	      _mapCommand: _mapCommand,
	
	      defineRegister: defineRegister,
	
	      exitVisualMode: exitVisualMode,
	      exitInsertMode: exitInsertMode
	    };
	
	    // Represents the current input state.
	    function InputState() {
	      this.prefixRepeat = [];
	      this.motionRepeat = [];
	
	      this.operator = null;
	      this.operatorArgs = null;
	      this.motion = null;
	      this.motionArgs = null;
	      this.keyBuffer = []; // For matching multi-key commands.
	      this.registerName = null; // Defaults to the unnamed register.
	    }
	    InputState.prototype.pushRepeatDigit = function(n) {
	      if (!this.operator) {
	        this.prefixRepeat = this.prefixRepeat.concat(n);
	      } else {
	        this.motionRepeat = this.motionRepeat.concat(n);
	      }
	    };
	    InputState.prototype.getRepeat = function() {
	      var repeat = 0;
	      if (this.prefixRepeat.length > 0 || this.motionRepeat.length > 0) {
	        repeat = 1;
	        if (this.prefixRepeat.length > 0) {
	          repeat *= parseInt(this.prefixRepeat.join(''), 10);
	        }
	        if (this.motionRepeat.length > 0) {
	          repeat *= parseInt(this.motionRepeat.join(''), 10);
	        }
	      }
	      return repeat;
	    };
	
	    function clearInputState(cm, reason) {
	      cm.state.vim.inputState = new InputState();
	      CodeMirror.signal(cm, 'vim-command-done', reason);
	    }
	
	    /*
	     * Register stores information about copy and paste registers.  Besides
	     * text, a register must store whether it is linewise (i.e., when it is
	     * pasted, should it insert itself into a new line, or should the text be
	     * inserted at the cursor position.)
	     */
	    function Register(text, linewise, blockwise) {
	      this.clear();
	      this.keyBuffer = [text || ''];
	      this.insertModeChanges = [];
	      this.searchQueries = [];
	      this.linewise = !!linewise;
	      this.blockwise = !!blockwise;
	    }
	    Register.prototype = {
	      setText: function(text, linewise, blockwise) {
	        this.keyBuffer = [text || ''];
	        this.linewise = !!linewise;
	        this.blockwise = !!blockwise;
	      },
	      pushText: function(text, linewise) {
	        // if this register has ever been set to linewise, use linewise.
	        if (linewise) {
	          if (!this.linewise) {
	            this.keyBuffer.push('\n');
	          }
	          this.linewise = true;
	        }
	        this.keyBuffer.push(text);
	      },
	      pushInsertModeChanges: function(changes) {
	        this.insertModeChanges.push(createInsertModeChanges(changes));
	      },
	      pushSearchQuery: function(query) {
	        this.searchQueries.push(query);
	      },
	      clear: function() {
	        this.keyBuffer = [];
	        this.insertModeChanges = [];
	        this.searchQueries = [];
	        this.linewise = false;
	      },
	      toString: function() {
	        return this.keyBuffer.join('');
	      }
	    };
	
	    /**
	     * Defines an external register.
	     *
	     * The name should be a single character that will be used to reference the register.
	     * The register should support setText, pushText, clear, and toString(). See Register
	     * for a reference implementation.
	     */
	    function defineRegister(name, register) {
	      var registers = vimGlobalState.registerController.registers[name];
	      if (!name || name.length != 1) {
	        throw Error('Register name must be 1 character');
	      }
	      if (registers[name]) {
	        throw Error('Register already defined ' + name);
	      }
	      registers[name] = register;
	      validRegisters.push(name);
	    }
	
	    /*
	     * vim registers allow you to keep many independent copy and paste buffers.
	     * See http://usevim.com/2012/04/13/registers/ for an introduction.
	     *
	     * RegisterController keeps the state of all the registers.  An initial
	     * state may be passed in.  The unnamed register '"' will always be
	     * overridden.
	     */
	    function RegisterController(registers) {
	      this.registers = registers;
	      this.unnamedRegister = registers['"'] = new Register();
	      registers['.'] = new Register();
	      registers[':'] = new Register();
	      registers['/'] = new Register();
	    }
	    RegisterController.prototype = {
	      pushText: function(registerName, operator, text, linewise, blockwise) {
	        if (linewise && text.charAt(0) == '\n') {
	          text = text.slice(1) + '\n';
	        }
	        if (linewise && text.charAt(text.length - 1) !== '\n'){
	          text += '\n';
	        }
	        // Lowercase and uppercase registers refer to the same register.
	        // Uppercase just means append.
	        var register = this.isValidRegister(registerName) ?
	            this.getRegister(registerName) : null;
	        // if no register/an invalid register was specified, things go to the
	        // default registers
	        if (!register) {
	          switch (operator) {
	            case 'yank':
	              // The 0 register contains the text from the most recent yank.
	              this.registers['0'] = new Register(text, linewise, blockwise);
	              break;
	            case 'delete':
	            case 'change':
	              if (text.indexOf('\n') == -1) {
	                // Delete less than 1 line. Update the small delete register.
	                this.registers['-'] = new Register(text, linewise);
	              } else {
	                // Shift down the contents of the numbered registers and put the
	                // deleted text into register 1.
	                this.shiftNumericRegisters_();
	                this.registers['1'] = new Register(text, linewise);
	              }
	              break;
	          }
	          // Make sure the unnamed register is set to what just happened
	          this.unnamedRegister.setText(text, linewise, blockwise);
	          return;
	        }
	
	        // If we've gotten to this point, we've actually specified a register
	        var append = isUpperCase(registerName);
	        if (append) {
	          register.pushText(text, linewise);
	        } else {
	          register.setText(text, linewise, blockwise);
	        }
	        // The unnamed register always has the same value as the last used
	        // register.
	        this.unnamedRegister.setText(register.toString(), linewise);
	      },
	      // Gets the register named @name.  If one of @name doesn't already exist,
	      // create it.  If @name is invalid, return the unnamedRegister.
	      getRegister: function(name) {
	        if (!this.isValidRegister(name)) {
	          return this.unnamedRegister;
	        }
	        name = name.toLowerCase();
	        if (!this.registers[name]) {
	          this.registers[name] = new Register();
	        }
	        return this.registers[name];
	      },
	      isValidRegister: function(name) {
	        return name && inArray(name, validRegisters);
	      },
	      shiftNumericRegisters_: function() {
	        for (var i = 9; i >= 2; i--) {
	          this.registers[i] = this.getRegister('' + (i - 1));
	        }
	      }
	    };
	    function HistoryController() {
	        this.historyBuffer = [];
	        this.iterator = 0;
	        this.initialPrefix = null;
	    }
	    HistoryController.prototype = {
	      // the input argument here acts a user entered prefix for a small time
	      // until we start autocompletion in which case it is the autocompleted.
	      nextMatch: function (input, up) {
	        var historyBuffer = this.historyBuffer;
	        var dir = up ? -1 : 1;
	        if (this.initialPrefix === null) this.initialPrefix = input;
	        for (var i = this.iterator + dir; up ? i >= 0 : i < historyBuffer.length; i+= dir) {
	          var element = historyBuffer[i];
	          for (var j = 0; j <= element.length; j++) {
	            if (this.initialPrefix == element.substring(0, j)) {
	              this.iterator = i;
	              return element;
	            }
	          }
	        }
	        // should return the user input in case we reach the end of buffer.
	        if (i >= historyBuffer.length) {
	          this.iterator = historyBuffer.length;
	          return this.initialPrefix;
	        }
	        // return the last autocompleted query or exCommand as it is.
	        if (i < 0 ) return input;
	      },
	      pushInput: function(input) {
	        var index = this.historyBuffer.indexOf(input);
	        if (index > -1) this.historyBuffer.splice(index, 1);
	        if (input.length) this.historyBuffer.push(input);
	      },
	      reset: function() {
	        this.initialPrefix = null;
	        this.iterator = this.historyBuffer.length;
	      }
	    };
	    var commandDispatcher = {
	      matchCommand: function(keys, keyMap, inputState, context) {
	        var matches = commandMatches(keys, keyMap, context, inputState);
	        if (!matches.full && !matches.partial) {
	          return {type: 'none'};
	        } else if (!matches.full && matches.partial) {
	          return {type: 'partial'};
	        }
	
	        var bestMatch;
	        for (var i = 0; i < matches.full.length; i++) {
	          var match = matches.full[i];
	          if (!bestMatch) {
	            bestMatch = match;
	          }
	        }
	        if (bestMatch.keys.slice(-11) == '<character>') {
	          inputState.selectedCharacter = lastChar(keys);
	        }
	        return {type: 'full', command: bestMatch};
	      },
	      processCommand: function(cm, vim, command) {
	        vim.inputState.repeatOverride = command.repeatOverride;
	        switch (command.type) {
	          case 'motion':
	            this.processMotion(cm, vim, command);
	            break;
	          case 'operator':
	            this.processOperator(cm, vim, command);
	            break;
	          case 'operatorMotion':
	            this.processOperatorMotion(cm, vim, command);
	            break;
	          case 'action':
	            this.processAction(cm, vim, command);
	            break;
	          case 'search':
	            this.processSearch(cm, vim, command);
	            break;
	          case 'ex':
	          case 'keyToEx':
	            this.processEx(cm, vim, command);
	            break;
	          default:
	            break;
	        }
	      },
	      processMotion: function(cm, vim, command) {
	        vim.inputState.motion = command.motion;
	        vim.inputState.motionArgs = copyArgs(command.motionArgs);
	        this.evalInput(cm, vim);
	      },
	      processOperator: function(cm, vim, command) {
	        var inputState = vim.inputState;
	        if (inputState.operator) {
	          if (inputState.operator == command.operator) {
	            // Typing an operator twice like 'dd' makes the operator operate
	            // linewise
	            inputState.motion = 'expandToLine';
	            inputState.motionArgs = { linewise: true };
	            this.evalInput(cm, vim);
	            return;
	          } else {
	            // 2 different operators in a row doesn't make sense.
	            clearInputState(cm);
	          }
	        }
	        inputState.operator = command.operator;
	        inputState.operatorArgs = copyArgs(command.operatorArgs);
	        if (vim.visualMode) {
	          // Operating on a selection in visual mode. We don't need a motion.
	          this.evalInput(cm, vim);
	        }
	      },
	      processOperatorMotion: function(cm, vim, command) {
	        var visualMode = vim.visualMode;
	        var operatorMotionArgs = copyArgs(command.operatorMotionArgs);
	        if (operatorMotionArgs) {
	          // Operator motions may have special behavior in visual mode.
	          if (visualMode && operatorMotionArgs.visualLine) {
	            vim.visualLine = true;
	          }
	        }
	        this.processOperator(cm, vim, command);
	        if (!visualMode) {
	          this.processMotion(cm, vim, command);
	        }
	      },
	      processAction: function(cm, vim, command) {
	        var inputState = vim.inputState;
	        var repeat = inputState.getRepeat();
	        var repeatIsExplicit = !!repeat;
	        var actionArgs = copyArgs(command.actionArgs) || {};
	        if (inputState.selectedCharacter) {
	          actionArgs.selectedCharacter = inputState.selectedCharacter;
	        }
	        // Actions may or may not have motions and operators. Do these first.
	        if (command.operator) {
	          this.processOperator(cm, vim, command);
	        }
	        if (command.motion) {
	          this.processMotion(cm, vim, command);
	        }
	        if (command.motion || command.operator) {
	          this.evalInput(cm, vim);
	        }
	        actionArgs.repeat = repeat || 1;
	        actionArgs.repeatIsExplicit = repeatIsExplicit;
	        actionArgs.registerName = inputState.registerName;
	        clearInputState(cm);
	        vim.lastMotion = null;
	        if (command.isEdit) {
	          this.recordLastEdit(vim, inputState, command);
	        }
	        actions[command.action](cm, actionArgs, vim);
	      },
	      processSearch: function(cm, vim, command) {
	        if (!cm.getSearchCursor) {
	          // Search depends on SearchCursor.
	          return;
	        }
	        var forward = command.searchArgs.forward;
	        var wholeWordOnly = command.searchArgs.wholeWordOnly;
	        getSearchState(cm).setReversed(!forward);
	        var promptPrefix = (forward) ? '/' : '?';
	        var originalQuery = getSearchState(cm).getQuery();
	        var originalScrollPos = cm.getScrollInfo();
	        function handleQuery(query, ignoreCase, smartCase) {
	          vimGlobalState.searchHistoryController.pushInput(query);
	          vimGlobalState.searchHistoryController.reset();
	          try {
	            updateSearchQuery(cm, query, ignoreCase, smartCase);
	          } catch (e) {
	            showConfirm(cm, 'Invalid regex: ' + query);
	            clearInputState(cm);
	            return;
	          }
	          commandDispatcher.processMotion(cm, vim, {
	            type: 'motion',
	            motion: 'findNext',
	            motionArgs: { forward: true, toJumplist: command.searchArgs.toJumplist }
	          });
	        }
	        function onPromptClose(query) {
	          cm.scrollTo(originalScrollPos.left, originalScrollPos.top);
	          handleQuery(query, true /** ignoreCase */, true /** smartCase */);
	          var macroModeState = vimGlobalState.macroModeState;
	          if (macroModeState.isRecording) {
	            logSearchQuery(macroModeState, query);
	          }
	        }
	        function onPromptKeyUp(e, query, close) {
	          var keyName = CodeMirror.keyName(e), up;
	          if (keyName == 'Up' || keyName == 'Down') {
	            up = keyName == 'Up' ? true : false;
	            query = vimGlobalState.searchHistoryController.nextMatch(query, up) || '';
	            close(query);
	          } else {
	            if ( keyName != 'Left' && keyName != 'Right' && keyName != 'Ctrl' && keyName != 'Alt' && keyName != 'Shift')
	              vimGlobalState.searchHistoryController.reset();
	          }
	          var parsedQuery;
	          try {
	            parsedQuery = updateSearchQuery(cm, query,
	                true /** ignoreCase */, true /** smartCase */);
	          } catch (e) {
	            // Swallow bad regexes for incremental search.
	          }
	          if (parsedQuery) {
	            cm.scrollIntoView(findNext(cm, !forward, parsedQuery), 30);
	          } else {
	            clearSearchHighlight(cm);
	            cm.scrollTo(originalScrollPos.left, originalScrollPos.top);
	          }
	        }
	        function onPromptKeyDown(e, query, close) {
	          var keyName = CodeMirror.keyName(e);
	          if (keyName == 'Esc' || keyName == 'Ctrl-C' || keyName == 'Ctrl-[' ||
	              (keyName == 'Backspace' && query == '')) {
	            vimGlobalState.searchHistoryController.pushInput(query);
	            vimGlobalState.searchHistoryController.reset();
	            updateSearchQuery(cm, originalQuery);
	            clearSearchHighlight(cm);
	            cm.scrollTo(originalScrollPos.left, originalScrollPos.top);
	            CodeMirror.e_stop(e);
	            clearInputState(cm);
	            close();
	            cm.focus();
	          } else if (keyName == 'Ctrl-U') {
	            // Ctrl-U clears input.
	            CodeMirror.e_stop(e);
	            close('');
	          }
	        }
	        switch (command.searchArgs.querySrc) {
	          case 'prompt':
	            var macroModeState = vimGlobalState.macroModeState;
	            if (macroModeState.isPlaying) {
	              var query = macroModeState.replaySearchQueries.shift();
	              handleQuery(query, true /** ignoreCase */, false /** smartCase */);
	            } else {
	              showPrompt(cm, {
	                  onClose: onPromptClose,
	                  prefix: promptPrefix,
	                  desc: searchPromptDesc,
	                  onKeyUp: onPromptKeyUp,
	                  onKeyDown: onPromptKeyDown
	              });
	            }
	            break;
	          case 'wordUnderCursor':
	            var word = expandWordUnderCursor(cm, false /** inclusive */,
	                true /** forward */, false /** bigWord */,
	                true /** noSymbol */);
	            var isKeyword = true;
	            if (!word) {
	              word = expandWordUnderCursor(cm, false /** inclusive */,
	                  true /** forward */, false /** bigWord */,
	                  false /** noSymbol */);
	              isKeyword = false;
	            }
	            if (!word) {
	              return;
	            }
	            var query = cm.getLine(word.start.line).substring(word.start.ch,
	                word.end.ch);
	            if (isKeyword && wholeWordOnly) {
	                query = '\\b' + query + '\\b';
	            } else {
	              query = escapeRegex(query);
	            }
	
	            // cachedCursor is used to save the old position of the cursor
	            // when * or # causes vim to seek for the nearest word and shift
	            // the cursor before entering the motion.
	            vimGlobalState.jumpList.cachedCursor = cm.getCursor();
	            cm.setCursor(word.start);
	
	            handleQuery(query, true /** ignoreCase */, false /** smartCase */);
	            break;
	        }
	      },
	      processEx: function(cm, vim, command) {
	        function onPromptClose(input) {
	          // Give the prompt some time to close so that if processCommand shows
	          // an error, the elements don't overlap.
	          vimGlobalState.exCommandHistoryController.pushInput(input);
	          vimGlobalState.exCommandHistoryController.reset();
	          exCommandDispatcher.processCommand(cm, input);
	        }
	        function onPromptKeyDown(e, input, close) {
	          var keyName = CodeMirror.keyName(e), up;
	          if (keyName == 'Esc' || keyName == 'Ctrl-C' || keyName == 'Ctrl-[' ||
	              (keyName == 'Backspace' && input == '')) {
	            vimGlobalState.exCommandHistoryController.pushInput(input);
	            vimGlobalState.exCommandHistoryController.reset();
	            CodeMirror.e_stop(e);
	            clearInputState(cm);
	            close();
	            cm.focus();
	          }
	          if (keyName == 'Up' || keyName == 'Down') {
	            up = keyName == 'Up' ? true : false;
	            input = vimGlobalState.exCommandHistoryController.nextMatch(input, up) || '';
	            close(input);
	          } else if (keyName == 'Ctrl-U') {
	            // Ctrl-U clears input.
	            CodeMirror.e_stop(e);
	            close('');
	          } else {
	            if ( keyName != 'Left' && keyName != 'Right' && keyName != 'Ctrl' && keyName != 'Alt' && keyName != 'Shift')
	              vimGlobalState.exCommandHistoryController.reset();
	          }
	        }
	        if (command.type == 'keyToEx') {
	          // Handle user defined Ex to Ex mappings
	          exCommandDispatcher.processCommand(cm, command.exArgs.input);
	        } else {
	          if (vim.visualMode) {
	            showPrompt(cm, { onClose: onPromptClose, prefix: ':', value: '\'<,\'>',
	                onKeyDown: onPromptKeyDown});
	          } else {
	            showPrompt(cm, { onClose: onPromptClose, prefix: ':',
	                onKeyDown: onPromptKeyDown});
	          }
	        }
	      },
	      evalInput: function(cm, vim) {
	        // If the motion command is set, execute both the operator and motion.
	        // Otherwise return.
	        var inputState = vim.inputState;
	        var motion = inputState.motion;
	        var motionArgs = inputState.motionArgs || {};
	        var operator = inputState.operator;
	        var operatorArgs = inputState.operatorArgs || {};
	        var registerName = inputState.registerName;
	        var sel = vim.sel;
	        // TODO: Make sure cm and vim selections are identical outside visual mode.
	        var origHead = copyCursor(vim.visualMode ? clipCursorToContent(cm, sel.head): cm.getCursor('head'));
	        var origAnchor = copyCursor(vim.visualMode ? clipCursorToContent(cm, sel.anchor) : cm.getCursor('anchor'));
	        var oldHead = copyCursor(origHead);
	        var oldAnchor = copyCursor(origAnchor);
	        var newHead, newAnchor;
	        var repeat;
	        if (operator) {
	          this.recordLastEdit(vim, inputState);
	        }
	        if (inputState.repeatOverride !== undefined) {
	          // If repeatOverride is specified, that takes precedence over the
	          // input state's repeat. Used by Ex mode and can be user defined.
	          repeat = inputState.repeatOverride;
	        } else {
	          repeat = inputState.getRepeat();
	        }
	        if (repeat > 0 && motionArgs.explicitRepeat) {
	          motionArgs.repeatIsExplicit = true;
	        } else if (motionArgs.noRepeat ||
	            (!motionArgs.explicitRepeat && repeat === 0)) {
	          repeat = 1;
	          motionArgs.repeatIsExplicit = false;
	        }
	        if (inputState.selectedCharacter) {
	          // If there is a character input, stick it in all of the arg arrays.
	          motionArgs.selectedCharacter = operatorArgs.selectedCharacter =
	              inputState.selectedCharacter;
	        }
	        motionArgs.repeat = repeat;
	        clearInputState(cm);
	        if (motion) {
	          var motionResult = motions[motion](cm, origHead, motionArgs, vim);
	          vim.lastMotion = motions[motion];
	          if (!motionResult) {
	            return;
	          }
	          if (motionArgs.toJumplist) {
	            var jumpList = vimGlobalState.jumpList;
	            // if the current motion is # or *, use cachedCursor
	            var cachedCursor = jumpList.cachedCursor;
	            if (cachedCursor) {
	              recordJumpPosition(cm, cachedCursor, motionResult);
	              delete jumpList.cachedCursor;
	            } else {
	              recordJumpPosition(cm, origHead, motionResult);
	            }
	          }
	          if (motionResult instanceof Array) {
	            newAnchor = motionResult[0];
	            newHead = motionResult[1];
	          } else {
	            newHead = motionResult;
	          }
	          // TODO: Handle null returns from motion commands better.
	          if (!newHead) {
	            newHead = copyCursor(origHead);
	          }
	          if (vim.visualMode) {
	            if (!(vim.visualBlock && newHead.ch === Infinity)) {
	              newHead = clipCursorToContent(cm, newHead, vim.visualBlock);
	            }
	            if (newAnchor) {
	              newAnchor = clipCursorToContent(cm, newAnchor, true);
	            }
	            newAnchor = newAnchor || oldAnchor;
	            sel.anchor = newAnchor;
	            sel.head = newHead;
	            updateCmSelection(cm);
	            updateMark(cm, vim, '<',
	                cursorIsBefore(newAnchor, newHead) ? newAnchor
	                    : newHead);
	            updateMark(cm, vim, '>',
	                cursorIsBefore(newAnchor, newHead) ? newHead
	                    : newAnchor);
	          } else if (!operator) {
	            newHead = clipCursorToContent(cm, newHead);
	            cm.setCursor(newHead.line, newHead.ch);
	          }
	        }
	        if (operator) {
	          if (operatorArgs.lastSel) {
	            // Replaying a visual mode operation
	            newAnchor = oldAnchor;
	            var lastSel = operatorArgs.lastSel;
	            var lineOffset = Math.abs(lastSel.head.line - lastSel.anchor.line);
	            var chOffset = Math.abs(lastSel.head.ch - lastSel.anchor.ch);
	            if (lastSel.visualLine) {
	              // Linewise Visual mode: The same number of lines.
	              newHead = Pos(oldAnchor.line + lineOffset, oldAnchor.ch);
	            } else if (lastSel.visualBlock) {
	              // Blockwise Visual mode: The same number of lines and columns.
	              newHead = Pos(oldAnchor.line + lineOffset, oldAnchor.ch + chOffset);
	            } else if (lastSel.head.line == lastSel.anchor.line) {
	              // Normal Visual mode within one line: The same number of characters.
	              newHead = Pos(oldAnchor.line, oldAnchor.ch + chOffset);
	            } else {
	              // Normal Visual mode with several lines: The same number of lines, in the
	              // last line the same number of characters as in the last line the last time.
	              newHead = Pos(oldAnchor.line + lineOffset, oldAnchor.ch);
	            }
	            vim.visualMode = true;
	            vim.visualLine = lastSel.visualLine;
	            vim.visualBlock = lastSel.visualBlock;
	            sel = vim.sel = {
	              anchor: newAnchor,
	              head: newHead
	            };
	            updateCmSelection(cm);
	          } else if (vim.visualMode) {
	            operatorArgs.lastSel = {
	              anchor: copyCursor(sel.anchor),
	              head: copyCursor(sel.head),
	              visualBlock: vim.visualBlock,
	              visualLine: vim.visualLine
	            };
	          }
	          var curStart, curEnd, linewise, mode;
	          var cmSel;
	          if (vim.visualMode) {
	            // Init visual op
	            curStart = cursorMin(sel.head, sel.anchor);
	            curEnd = cursorMax(sel.head, sel.anchor);
	            linewise = vim.visualLine || operatorArgs.linewise;
	            mode = vim.visualBlock ? 'block' :
	                   linewise ? 'line' :
	                   'char';
	            cmSel = makeCmSelection(cm, {
	              anchor: curStart,
	              head: curEnd
	            }, mode);
	            if (linewise) {
	              var ranges = cmSel.ranges;
	              if (mode == 'block') {
	                // Linewise operators in visual block mode extend to end of line
	                for (var i = 0; i < ranges.length; i++) {
	                  ranges[i].head.ch = lineLength(cm, ranges[i].head.line);
	                }
	              } else if (mode == 'line') {
	                ranges[0].head = Pos(ranges[0].head.line + 1, 0);
	              }
	            }
	          } else {
	            // Init motion op
	            curStart = copyCursor(newAnchor || oldAnchor);
	            curEnd = copyCursor(newHead || oldHead);
	            if (cursorIsBefore(curEnd, curStart)) {
	              var tmp = curStart;
	              curStart = curEnd;
	              curEnd = tmp;
	            }
	            linewise = motionArgs.linewise || operatorArgs.linewise;
	            if (linewise) {
	              // Expand selection to entire line.
	              expandSelectionToLine(cm, curStart, curEnd);
	            } else if (motionArgs.forward) {
	              // Clip to trailing newlines only if the motion goes forward.
	              clipToLine(cm, curStart, curEnd);
	            }
	            mode = 'char';
	            var exclusive = !motionArgs.inclusive || linewise;
	            cmSel = makeCmSelection(cm, {
	              anchor: curStart,
	              head: curEnd
	            }, mode, exclusive);
	          }
	          cm.setSelections(cmSel.ranges, cmSel.primary);
	          vim.lastMotion = null;
	          operatorArgs.repeat = repeat; // For indent in visual mode.
	          operatorArgs.registerName = registerName;
	          // Keep track of linewise as it affects how paste and change behave.
	          operatorArgs.linewise = linewise;
	          var operatorMoveTo = operators[operator](
	            cm, operatorArgs, cmSel.ranges, oldAnchor, newHead);
	          if (vim.visualMode) {
	            exitVisualMode(cm, operatorMoveTo != null);
	          }
	          if (operatorMoveTo) {
	            cm.setCursor(operatorMoveTo);
	          }
	        }
	      },
	      recordLastEdit: function(vim, inputState, actionCommand) {
	        var macroModeState = vimGlobalState.macroModeState;
	        if (macroModeState.isPlaying) { return; }
	        vim.lastEditInputState = inputState;
	        vim.lastEditActionCommand = actionCommand;
	        macroModeState.lastInsertModeChanges.changes = [];
	        macroModeState.lastInsertModeChanges.expectCursorActivityForChange = false;
	      }
	    };
	
	    /**
	     * typedef {Object{line:number,ch:number}} Cursor An object containing the
	     *     position of the cursor.
	     */
	    // All of the functions below return Cursor objects.
	    var motions = {
	      moveToTopLine: function(cm, _head, motionArgs) {
	        var line = getUserVisibleLines(cm).top + motionArgs.repeat -1;
	        return Pos(line, findFirstNonWhiteSpaceCharacter(cm.getLine(line)));
	      },
	      moveToMiddleLine: function(cm) {
	        var range = getUserVisibleLines(cm);
	        var line = Math.floor((range.top + range.bottom) * 0.5);
	        return Pos(line, findFirstNonWhiteSpaceCharacter(cm.getLine(line)));
	      },
	      moveToBottomLine: function(cm, _head, motionArgs) {
	        var line = getUserVisibleLines(cm).bottom - motionArgs.repeat +1;
	        return Pos(line, findFirstNonWhiteSpaceCharacter(cm.getLine(line)));
	      },
	      expandToLine: function(_cm, head, motionArgs) {
	        // Expands forward to end of line, and then to next line if repeat is
	        // >1. Does not handle backward motion!
	        var cur = head;
	        return Pos(cur.line + motionArgs.repeat - 1, Infinity);
	      },
	      findNext: function(cm, _head, motionArgs) {
	        var state = getSearchState(cm);
	        var query = state.getQuery();
	        if (!query) {
	          return;
	        }
	        var prev = !motionArgs.forward;
	        // If search is initiated with ? instead of /, negate direction.
	        prev = (state.isReversed()) ? !prev : prev;
	        highlightSearchMatches(cm, query);
	        return findNext(cm, prev/** prev */, query, motionArgs.repeat);
	      },
	      goToMark: function(cm, _head, motionArgs, vim) {
	        var mark = vim.marks[motionArgs.selectedCharacter];
	        if (mark) {
	          var pos = mark.find();
	          return motionArgs.linewise ? { line: pos.line, ch: findFirstNonWhiteSpaceCharacter(cm.getLine(pos.line)) } : pos;
	        }
	        return null;
	      },
	      moveToOtherHighlightedEnd: function(cm, _head, motionArgs, vim) {
	        if (vim.visualBlock && motionArgs.sameLine) {
	          var sel = vim.sel;
	          return [
	            clipCursorToContent(cm, Pos(sel.anchor.line, sel.head.ch)),
	            clipCursorToContent(cm, Pos(sel.head.line, sel.anchor.ch))
	          ];
	        } else {
	          return ([vim.sel.head, vim.sel.anchor]);
	        }
	      },
	      jumpToMark: function(cm, head, motionArgs, vim) {
	        var best = head;
	        for (var i = 0; i < motionArgs.repeat; i++) {
	          var cursor = best;
	          for (var key in vim.marks) {
	            if (!isLowerCase(key)) {
	              continue;
	            }
	            var mark = vim.marks[key].find();
	            var isWrongDirection = (motionArgs.forward) ?
	              cursorIsBefore(mark, cursor) : cursorIsBefore(cursor, mark);
	
	            if (isWrongDirection) {
	              continue;
	            }
	            if (motionArgs.linewise && (mark.line == cursor.line)) {
	              continue;
	            }
	
	            var equal = cursorEqual(cursor, best);
	            var between = (motionArgs.forward) ?
	              cursorIsBetween(cursor, mark, best) :
	              cursorIsBetween(best, mark, cursor);
	
	            if (equal || between) {
	              best = mark;
	            }
	          }
	        }
	
	        if (motionArgs.linewise) {
	          // Vim places the cursor on the first non-whitespace character of
	          // the line if there is one, else it places the cursor at the end
	          // of the line, regardless of whether a mark was found.
	          best = Pos(best.line, findFirstNonWhiteSpaceCharacter(cm.getLine(best.line)));
	        }
	        return best;
	      },
	      moveByCharacters: function(_cm, head, motionArgs) {
	        var cur = head;
	        var repeat = motionArgs.repeat;
	        var ch = motionArgs.forward ? cur.ch + repeat : cur.ch - repeat;
	        return Pos(cur.line, ch);
	      },
	      moveByLines: function(cm, head, motionArgs, vim) {
	        var cur = head;
	        var endCh = cur.ch;
	        // Depending what our last motion was, we may want to do different
	        // things. If our last motion was moving vertically, we want to
	        // preserve the HPos from our last horizontal move.  If our last motion
	        // was going to the end of a line, moving vertically we should go to
	        // the end of the line, etc.
	        switch (vim.lastMotion) {
	          case this.moveByLines:
	          case this.moveByDisplayLines:
	          case this.moveByScroll:
	          case this.moveToColumn:
	          case this.moveToEol:
	            endCh = vim.lastHPos;
	            break;
	          default:
	            vim.lastHPos = endCh;
	        }
	        var repeat = motionArgs.repeat+(motionArgs.repeatOffset||0);
	        var line = motionArgs.forward ? cur.line + repeat : cur.line - repeat;
	        var first = cm.firstLine();
	        var last = cm.lastLine();
	        // Vim go to line begin or line end when cursor at first/last line and
	        // move to previous/next line is triggered.
	        if (line < first && cur.line == first){
	          return this.moveToStartOfLine(cm, head, motionArgs, vim);
	        }else if (line > last && cur.line == last){
	            return this.moveToEol(cm, head, motionArgs, vim);
	        }
	        if (motionArgs.toFirstChar){
	          endCh=findFirstNonWhiteSpaceCharacter(cm.getLine(line));
	          vim.lastHPos = endCh;
	        }
	        vim.lastHSPos = cm.charCoords(Pos(line, endCh),'div').left;
	        return Pos(line, endCh);
	      },
	      moveByDisplayLines: function(cm, head, motionArgs, vim) {
	        var cur = head;
	        switch (vim.lastMotion) {
	          case this.moveByDisplayLines:
	          case this.moveByScroll:
	          case this.moveByLines:
	          case this.moveToColumn:
	          case this.moveToEol:
	            break;
	          default:
	            vim.lastHSPos = cm.charCoords(cur,'div').left;
	        }
	        var repeat = motionArgs.repeat;
	        var res=cm.findPosV(cur,(motionArgs.forward ? repeat : -repeat),'line',vim.lastHSPos);
	        if (res.hitSide) {
	          if (motionArgs.forward) {
	            var lastCharCoords = cm.charCoords(res, 'div');
	            var goalCoords = { top: lastCharCoords.top + 8, left: vim.lastHSPos };
	            var res = cm.coordsChar(goalCoords, 'div');
	          } else {
	            var resCoords = cm.charCoords(Pos(cm.firstLine(), 0), 'div');
	            resCoords.left = vim.lastHSPos;
	            res = cm.coordsChar(resCoords, 'div');
	          }
	        }
	        vim.lastHPos = res.ch;
	        return res;
	      },
	      moveByPage: function(cm, head, motionArgs) {
	        // CodeMirror only exposes functions that move the cursor page down, so
	        // doing this bad hack to move the cursor and move it back. evalInput
	        // will move the cursor to where it should be in the end.
	        var curStart = head;
	        var repeat = motionArgs.repeat;
	        return cm.findPosV(curStart, (motionArgs.forward ? repeat : -repeat), 'page');
	      },
	      moveByParagraph: function(cm, head, motionArgs) {
	        var dir = motionArgs.forward ? 1 : -1;
	        return findParagraph(cm, head, motionArgs.repeat, dir);
	      },
	      moveByScroll: function(cm, head, motionArgs, vim) {
	        var scrollbox = cm.getScrollInfo();
	        var curEnd = null;
	        var repeat = motionArgs.repeat;
	        if (!repeat) {
	          repeat = scrollbox.clientHeight / (2 * cm.defaultTextHeight());
	        }
	        var orig = cm.charCoords(head, 'local');
	        motionArgs.repeat = repeat;
	        var curEnd = motions.moveByDisplayLines(cm, head, motionArgs, vim);
	        if (!curEnd) {
	          return null;
	        }
	        var dest = cm.charCoords(curEnd, 'local');
	        cm.scrollTo(null, scrollbox.top + dest.top - orig.top);
	        return curEnd;
	      },
	      moveByWords: function(cm, head, motionArgs) {
	        return moveToWord(cm, head, motionArgs.repeat, !!motionArgs.forward,
	            !!motionArgs.wordEnd, !!motionArgs.bigWord);
	      },
	      moveTillCharacter: function(cm, _head, motionArgs) {
	        var repeat = motionArgs.repeat;
	        var curEnd = moveToCharacter(cm, repeat, motionArgs.forward,
	            motionArgs.selectedCharacter);
	        var increment = motionArgs.forward ? -1 : 1;
	        recordLastCharacterSearch(increment, motionArgs);
	        if (!curEnd) return null;
	        curEnd.ch += increment;
	        return curEnd;
	      },
	      moveToCharacter: function(cm, head, motionArgs) {
	        var repeat = motionArgs.repeat;
	        recordLastCharacterSearch(0, motionArgs);
	        return moveToCharacter(cm, repeat, motionArgs.forward,
	            motionArgs.selectedCharacter) || head;
	      },
	      moveToSymbol: function(cm, head, motionArgs) {
	        var repeat = motionArgs.repeat;
	        return findSymbol(cm, repeat, motionArgs.forward,
	            motionArgs.selectedCharacter) || head;
	      },
	      moveToColumn: function(cm, head, motionArgs, vim) {
	        var repeat = motionArgs.repeat;
	        // repeat is equivalent to which column we want to move to!
	        vim.lastHPos = repeat - 1;
	        vim.lastHSPos = cm.charCoords(head,'div').left;
	        return moveToColumn(cm, repeat);
	      },
	      moveToEol: function(cm, head, motionArgs, vim) {
	        var cur = head;
	        vim.lastHPos = Infinity;
	        var retval= Pos(cur.line + motionArgs.repeat - 1, Infinity);
	        var end=cm.clipPos(retval);
	        end.ch--;
	        vim.lastHSPos = cm.charCoords(end,'div').left;
	        return retval;
	      },
	      moveToFirstNonWhiteSpaceCharacter: function(cm, head) {
	        // Go to the start of the line where the text begins, or the end for
	        // whitespace-only lines
	        var cursor = head;
	        return Pos(cursor.line,
	                   findFirstNonWhiteSpaceCharacter(cm.getLine(cursor.line)));
	      },
	      moveToMatchedSymbol: function(cm, head) {
	        var cursor = head;
	        var line = cursor.line;
	        var ch = cursor.ch;
	        var lineText = cm.getLine(line);
	        var symbol;
	        do {
	          symbol = lineText.charAt(ch++);
	          if (symbol && isMatchableSymbol(symbol)) {
	            var style = cm.getTokenTypeAt(Pos(line, ch));
	            if (style !== "string" && style !== "comment") {
	              break;
	            }
	          }
	        } while (symbol);
	        if (symbol) {
	          var matched = cm.findMatchingBracket(Pos(line, ch));
	          return matched.to;
	        } else {
	          return cursor;
	        }
	      },
	      moveToStartOfLine: function(_cm, head) {
	        return Pos(head.line, 0);
	      },
	      moveToLineOrEdgeOfDocument: function(cm, _head, motionArgs) {
	        var lineNum = motionArgs.forward ? cm.lastLine() : cm.firstLine();
	        if (motionArgs.repeatIsExplicit) {
	          lineNum = motionArgs.repeat - cm.getOption('firstLineNumber');
	        }
	        return Pos(lineNum,
	                   findFirstNonWhiteSpaceCharacter(cm.getLine(lineNum)));
	      },
	      textObjectManipulation: function(cm, head, motionArgs, vim) {
	        // TODO: lots of possible exceptions that can be thrown here. Try da(
	        //     outside of a () block.
	
	        // TODO: adding <> >< to this map doesn't work, presumably because
	        // they're operators
	        var mirroredPairs = {'(': ')', ')': '(',
	                             '{': '}', '}': '{',
	                             '[': ']', ']': '['};
	        var selfPaired = {'\'': true, '"': true};
	
	        var character = motionArgs.selectedCharacter;
	        // 'b' refers to  '()' block.
	        // 'B' refers to  '{}' block.
	        if (character == 'b') {
	          character = '(';
	        } else if (character == 'B') {
	          character = '{';
	        }
	
	        // Inclusive is the difference between a and i
	        // TODO: Instead of using the additional text object map to perform text
	        //     object operations, merge the map into the defaultKeyMap and use
	        //     motionArgs to define behavior. Define separate entries for 'aw',
	        //     'iw', 'a[', 'i[', etc.
	        var inclusive = !motionArgs.textObjectInner;
	
	        var tmp;
	        if (mirroredPairs[character]) {
	          tmp = selectCompanionObject(cm, head, character, inclusive);
	        } else if (selfPaired[character]) {
	          tmp = findBeginningAndEnd(cm, head, character, inclusive);
	        } else if (character === 'W') {
	          tmp = expandWordUnderCursor(cm, inclusive, true /** forward */,
	                                                     true /** bigWord */);
	        } else if (character === 'w') {
	          tmp = expandWordUnderCursor(cm, inclusive, true /** forward */,
	                                                     false /** bigWord */);
	        } else if (character === 'p') {
	          tmp = findParagraph(cm, head, motionArgs.repeat, 0, inclusive);
	          motionArgs.linewise = true;
	          if (vim.visualMode) {
	            if (!vim.visualLine) { vim.visualLine = true; }
	          } else {
	            var operatorArgs = vim.inputState.operatorArgs;
	            if (operatorArgs) { operatorArgs.linewise = true; }
	            tmp.end.line--;
	          }
	        } else {
	          // No text object defined for this, don't move.
	          return null;
	        }
	
	        if (!cm.state.vim.visualMode) {
	          return [tmp.start, tmp.end];
	        } else {
	          return expandSelection(cm, tmp.start, tmp.end);
	        }
	      },
	
	      repeatLastCharacterSearch: function(cm, head, motionArgs) {
	        var lastSearch = vimGlobalState.lastCharacterSearch;
	        var repeat = motionArgs.repeat;
	        var forward = motionArgs.forward === lastSearch.forward;
	        var increment = (lastSearch.increment ? 1 : 0) * (forward ? -1 : 1);
	        cm.moveH(-increment, 'char');
	        motionArgs.inclusive = forward ? true : false;
	        var curEnd = moveToCharacter(cm, repeat, forward, lastSearch.selectedCharacter);
	        if (!curEnd) {
	          cm.moveH(increment, 'char');
	          return head;
	        }
	        curEnd.ch += increment;
	        return curEnd;
	      }
	    };
	
	    function defineMotion(name, fn) {
	      motions[name] = fn;
	    }
	
	    function fillArray(val, times) {
	      var arr = [];
	      for (var i = 0; i < times; i++) {
	        arr.push(val);
	      }
	      return arr;
	    }
	    /**
	     * An operator acts on a text selection. It receives the list of selections
	     * as input. The corresponding CodeMirror selection is guaranteed to
	    * match the input selection.
	     */
	    var operators = {
	      change: function(cm, args, ranges) {
	        var finalHead, text;
	        var vim = cm.state.vim;
	        vimGlobalState.macroModeState.lastInsertModeChanges.inVisualBlock = vim.visualBlock;
	        if (!vim.visualMode) {
	          var anchor = ranges[0].anchor,
	              head = ranges[0].head;
	          text = cm.getRange(anchor, head);
	          var lastState = vim.lastEditInputState || {};
	          if (lastState.motion == "moveByWords" && !isWhiteSpaceString(text)) {
	            // Exclude trailing whitespace if the range is not all whitespace.
	            var match = (/\s+$/).exec(text);
	            if (match && lastState.motionArgs && lastState.motionArgs.forward) {
	              head = offsetCursor(head, 0, - match[0].length);
	              text = text.slice(0, - match[0].length);
	            }
	          }
	          var prevLineEnd = new Pos(anchor.line - 1, Number.MAX_VALUE);
	          var wasLastLine = cm.firstLine() == cm.lastLine();
	          if (head.line > cm.lastLine() && args.linewise && !wasLastLine) {
	            cm.replaceRange('', prevLineEnd, head);
	          } else {
	            cm.replaceRange('', anchor, head);
	          }
	          if (args.linewise) {
	            // Push the next line back down, if there is a next line.
	            if (!wasLastLine) {
	              cm.setCursor(prevLineEnd);
	              CodeMirror.commands.newlineAndIndent(cm);
	            }
	            // make sure cursor ends up at the end of the line.
	            anchor.ch = Number.MAX_VALUE;
	          }
	          finalHead = anchor;
	        } else {
	          text = cm.getSelection();
	          var replacement = fillArray('', ranges.length);
	          cm.replaceSelections(replacement);
	          finalHead = cursorMin(ranges[0].head, ranges[0].anchor);
	        }
	        vimGlobalState.registerController.pushText(
	            args.registerName, 'change', text,
	            args.linewise, ranges.length > 1);
	        actions.enterInsertMode(cm, {head: finalHead}, cm.state.vim);
	      },
	      // delete is a javascript keyword.
	      'delete': function(cm, args, ranges) {
	        var finalHead, text;
	        var vim = cm.state.vim;
	        if (!vim.visualBlock) {
	          var anchor = ranges[0].anchor,
	              head = ranges[0].head;
	          if (args.linewise &&
	              head.line != cm.firstLine() &&
	              anchor.line == cm.lastLine() &&
	              anchor.line == head.line - 1) {
	            // Special case for dd on last line (and first line).
	            if (anchor.line == cm.firstLine()) {
	              anchor.ch = 0;
	            } else {
	              anchor = Pos(anchor.line - 1, lineLength(cm, anchor.line - 1));
	            }
	          }
	          text = cm.getRange(anchor, head);
	          cm.replaceRange('', anchor, head);
	          finalHead = anchor;
	          if (args.linewise) {
	            finalHead = motions.moveToFirstNonWhiteSpaceCharacter(cm, anchor);
	          }
	        } else {
	          text = cm.getSelection();
	          var replacement = fillArray('', ranges.length);
	          cm.replaceSelections(replacement);
	          finalHead = ranges[0].anchor;
	        }
	        vimGlobalState.registerController.pushText(
	            args.registerName, 'delete', text,
	            args.linewise, vim.visualBlock);
	        return clipCursorToContent(cm, finalHead);
	      },
	      indent: function(cm, args, ranges) {
	        var vim = cm.state.vim;
	        var startLine = ranges[0].anchor.line;
	        var endLine = vim.visualBlock ?
	          ranges[ranges.length - 1].anchor.line :
	          ranges[0].head.line;
	        // In visual mode, n> shifts the selection right n times, instead of
	        // shifting n lines right once.
	        var repeat = (vim.visualMode) ? args.repeat : 1;
	        if (args.linewise) {
	          // The only way to delete a newline is to delete until the start of
	          // the next line, so in linewise mode evalInput will include the next
	          // line. We don't want this in indent, so we go back a line.
	          endLine--;
	        }
	        for (var i = startLine; i <= endLine; i++) {
	          for (var j = 0; j < repeat; j++) {
	            cm.indentLine(i, args.indentRight);
	          }
	        }
	        return motions.moveToFirstNonWhiteSpaceCharacter(cm, ranges[0].anchor);
	      },
	      changeCase: function(cm, args, ranges, oldAnchor, newHead) {
	        var selections = cm.getSelections();
	        var swapped = [];
	        var toLower = args.toLower;
	        for (var j = 0; j < selections.length; j++) {
	          var toSwap = selections[j];
	          var text = '';
	          if (toLower === true) {
	            text = toSwap.toLowerCase();
	          } else if (toLower === false) {
	            text = toSwap.toUpperCase();
	          } else {
	            for (var i = 0; i < toSwap.length; i++) {
	              var character = toSwap.charAt(i);
	              text += isUpperCase(character) ? character.toLowerCase() :
	                  character.toUpperCase();
	            }
	          }
	          swapped.push(text);
	        }
	        cm.replaceSelections(swapped);
	        if (args.shouldMoveCursor){
	          return newHead;
	        } else if (!cm.state.vim.visualMode && args.linewise && ranges[0].anchor.line + 1 == ranges[0].head.line) {
	          return motions.moveToFirstNonWhiteSpaceCharacter(cm, oldAnchor);
	        } else if (args.linewise){
	          return oldAnchor;
	        } else {
	          return cursorMin(ranges[0].anchor, ranges[0].head);
	        }
	      },
	      yank: function(cm, args, ranges, oldAnchor) {
	        var vim = cm.state.vim;
	        var text = cm.getSelection();
	        var endPos = vim.visualMode
	          ? cursorMin(vim.sel.anchor, vim.sel.head, ranges[0].head, ranges[0].anchor)
	          : oldAnchor;
	        vimGlobalState.registerController.pushText(
	            args.registerName, 'yank',
	            text, args.linewise, vim.visualBlock);
	        return endPos;
	      }
	    };
	
	    function defineOperator(name, fn) {
	      operators[name] = fn;
	    }
	
	    var actions = {
	      jumpListWalk: function(cm, actionArgs, vim) {
	        if (vim.visualMode) {
	          return;
	        }
	        var repeat = actionArgs.repeat;
	        var forward = actionArgs.forward;
	        var jumpList = vimGlobalState.jumpList;
	
	        var mark = jumpList.move(cm, forward ? repeat : -repeat);
	        var markPos = mark ? mark.find() : undefined;
	        markPos = markPos ? markPos : cm.getCursor();
	        cm.setCursor(markPos);
	      },
	      scroll: function(cm, actionArgs, vim) {
	        if (vim.visualMode) {
	          return;
	        }
	        var repeat = actionArgs.repeat || 1;
	        var lineHeight = cm.defaultTextHeight();
	        var top = cm.getScrollInfo().top;
	        var delta = lineHeight * repeat;
	        var newPos = actionArgs.forward ? top + delta : top - delta;
	        var cursor = copyCursor(cm.getCursor());
	        var cursorCoords = cm.charCoords(cursor, 'local');
	        if (actionArgs.forward) {
	          if (newPos > cursorCoords.top) {
	             cursor.line += (newPos - cursorCoords.top) / lineHeight;
	             cursor.line = Math.ceil(cursor.line);
	             cm.setCursor(cursor);
	             cursorCoords = cm.charCoords(cursor, 'local');
	             cm.scrollTo(null, cursorCoords.top);
	          } else {
	             // Cursor stays within bounds.  Just reposition the scroll window.
	             cm.scrollTo(null, newPos);
	          }
	        } else {
	          var newBottom = newPos + cm.getScrollInfo().clientHeight;
	          if (newBottom < cursorCoords.bottom) {
	             cursor.line -= (cursorCoords.bottom - newBottom) / lineHeight;
	             cursor.line = Math.floor(cursor.line);
	             cm.setCursor(cursor);
	             cursorCoords = cm.charCoords(cursor, 'local');
	             cm.scrollTo(
	                 null, cursorCoords.bottom - cm.getScrollInfo().clientHeight);
	          } else {
	             // Cursor stays within bounds.  Just reposition the scroll window.
	             cm.scrollTo(null, newPos);
	          }
	        }
	      },
	      scrollToCursor: function(cm, actionArgs) {
	        var lineNum = cm.getCursor().line;
	        var charCoords = cm.charCoords(Pos(lineNum, 0), 'local');
	        var height = cm.getScrollInfo().clientHeight;
	        var y = charCoords.top;
	        var lineHeight = charCoords.bottom - y;
	        switch (actionArgs.position) {
	          case 'center': y = y - (height / 2) + lineHeight;
	            break;
	          case 'bottom': y = y - height + lineHeight;
	            break;
	        }
	        cm.scrollTo(null, y);
	      },
	      replayMacro: function(cm, actionArgs, vim) {
	        var registerName = actionArgs.selectedCharacter;
	        var repeat = actionArgs.repeat;
	        var macroModeState = vimGlobalState.macroModeState;
	        if (registerName == '@') {
	          registerName = macroModeState.latestRegister;
	        }
	        while(repeat--){
	          executeMacroRegister(cm, vim, macroModeState, registerName);
	        }
	      },
	      enterMacroRecordMode: function(cm, actionArgs) {
	        var macroModeState = vimGlobalState.macroModeState;
	        var registerName = actionArgs.selectedCharacter;
	        macroModeState.enterMacroRecordMode(cm, registerName);
	      },
	      toggleOverwrite: function(cm) {
	        if (!cm.state.overwrite) {
	          cm.toggleOverwrite(true);
	          cm.setOption('keyMap', 'vim-replace');
	          CodeMirror.signal(cm, "vim-mode-change", {mode: "replace"});
	        } else {
	          cm.toggleOverwrite(false);
	          cm.setOption('keyMap', 'vim-insert');
	          CodeMirror.signal(cm, "vim-mode-change", {mode: "insert"});
	        }
	      },
	      enterInsertMode: function(cm, actionArgs, vim) {
	        if (cm.getOption('readOnly')) { return; }
	        vim.insertMode = true;
	        vim.insertModeRepeat = actionArgs && actionArgs.repeat || 1;
	        var insertAt = (actionArgs) ? actionArgs.insertAt : null;
	        var sel = vim.sel;
	        var head = actionArgs.head || cm.getCursor('head');
	        var height = cm.listSelections().length;
	        if (insertAt == 'eol') {
	          head = Pos(head.line, lineLength(cm, head.line));
	        } else if (insertAt == 'charAfter') {
	          head = offsetCursor(head, 0, 1);
	        } else if (insertAt == 'firstNonBlank') {
	          head = motions.moveToFirstNonWhiteSpaceCharacter(cm, head);
	        } else if (insertAt == 'startOfSelectedArea') {
	          if (!vim.visualBlock) {
	            if (sel.head.line < sel.anchor.line) {
	              head = sel.head;
	            } else {
	              head = Pos(sel.anchor.line, 0);
	            }
	          } else {
	            head = Pos(
	                Math.min(sel.head.line, sel.anchor.line),
	                Math.min(sel.head.ch, sel.anchor.ch));
	            height = Math.abs(sel.head.line - sel.anchor.line) + 1;
	          }
	        } else if (insertAt == 'endOfSelectedArea') {
	          if (!vim.visualBlock) {
	            if (sel.head.line >= sel.anchor.line) {
	              head = offsetCursor(sel.head, 0, 1);
	            } else {
	              head = Pos(sel.anchor.line, 0);
	            }
	          } else {
	            head = Pos(
	                Math.min(sel.head.line, sel.anchor.line),
	                Math.max(sel.head.ch + 1, sel.anchor.ch));
	            height = Math.abs(sel.head.line - sel.anchor.line) + 1;
	          }
	        } else if (insertAt == 'inplace') {
	          if (vim.visualMode){
	            return;
	          }
	        }
	        cm.setOption('disableInput', false);
	        if (actionArgs && actionArgs.replace) {
	          // Handle Replace-mode as a special case of insert mode.
	          cm.toggleOverwrite(true);
	          cm.setOption('keyMap', 'vim-replace');
	          CodeMirror.signal(cm, "vim-mode-change", {mode: "replace"});
	        } else {
	          cm.toggleOverwrite(false);
	          cm.setOption('keyMap', 'vim-insert');
	          CodeMirror.signal(cm, "vim-mode-change", {mode: "insert"});
	        }
	        if (!vimGlobalState.macroModeState.isPlaying) {
	          // Only record if not replaying.
	          cm.on('change', onChange);
	          CodeMirror.on(cm.getInputField(), 'keydown', onKeyEventTargetKeyDown);
	        }
	        if (vim.visualMode) {
	          exitVisualMode(cm);
	        }
	        selectForInsert(cm, head, height);
	      },
	      toggleVisualMode: function(cm, actionArgs, vim) {
	        var repeat = actionArgs.repeat;
	        var anchor = cm.getCursor();
	        var head;
	        // TODO: The repeat should actually select number of characters/lines
	        //     equal to the repeat times the size of the previous visual
	        //     operation.
	        if (!vim.visualMode) {
	          // Entering visual mode
	          vim.visualMode = true;
	          vim.visualLine = !!actionArgs.linewise;
	          vim.visualBlock = !!actionArgs.blockwise;
	          head = clipCursorToContent(
	              cm, Pos(anchor.line, anchor.ch + repeat - 1),
	              true /** includeLineBreak */);
	          vim.sel = {
	            anchor: anchor,
	            head: head
	          };
	          CodeMirror.signal(cm, "vim-mode-change", {mode: "visual", subMode: vim.visualLine ? "linewise" : vim.visualBlock ? "blockwise" : ""});
	          updateCmSelection(cm);
	          updateMark(cm, vim, '<', cursorMin(anchor, head));
	          updateMark(cm, vim, '>', cursorMax(anchor, head));
	        } else if (vim.visualLine ^ actionArgs.linewise ||
	            vim.visualBlock ^ actionArgs.blockwise) {
	          // Toggling between modes
	          vim.visualLine = !!actionArgs.linewise;
	          vim.visualBlock = !!actionArgs.blockwise;
	          CodeMirror.signal(cm, "vim-mode-change", {mode: "visual", subMode: vim.visualLine ? "linewise" : vim.visualBlock ? "blockwise" : ""});
	          updateCmSelection(cm);
	        } else {
	          exitVisualMode(cm);
	        }
	      },
	      reselectLastSelection: function(cm, _actionArgs, vim) {
	        var lastSelection = vim.lastSelection;
	        if (vim.visualMode) {
	          updateLastSelection(cm, vim);
	        }
	        if (lastSelection) {
	          var anchor = lastSelection.anchorMark.find();
	          var head = lastSelection.headMark.find();
	          if (!anchor || !head) {
	            // If the marks have been destroyed due to edits, do nothing.
	            return;
	          }
	          vim.sel = {
	            anchor: anchor,
	            head: head
	          };
	          vim.visualMode = true;
	          vim.visualLine = lastSelection.visualLine;
	          vim.visualBlock = lastSelection.visualBlock;
	          updateCmSelection(cm);
	          updateMark(cm, vim, '<', cursorMin(anchor, head));
	          updateMark(cm, vim, '>', cursorMax(anchor, head));
	          CodeMirror.signal(cm, 'vim-mode-change', {
	            mode: 'visual',
	            subMode: vim.visualLine ? 'linewise' :
	                     vim.visualBlock ? 'blockwise' : ''});
	        }
	      },
	      joinLines: function(cm, actionArgs, vim) {
	        var curStart, curEnd;
	        if (vim.visualMode) {
	          curStart = cm.getCursor('anchor');
	          curEnd = cm.getCursor('head');
	          if (cursorIsBefore(curEnd, curStart)) {
	            var tmp = curEnd;
	            curEnd = curStart;
	            curStart = tmp;
	          }
	          curEnd.ch = lineLength(cm, curEnd.line) - 1;
	        } else {
	          // Repeat is the number of lines to join. Minimum 2 lines.
	          var repeat = Math.max(actionArgs.repeat, 2);
	          curStart = cm.getCursor();
	          curEnd = clipCursorToContent(cm, Pos(curStart.line + repeat - 1,
	                                               Infinity));
	        }
	        var finalCh = 0;
	        for (var i = curStart.line; i < curEnd.line; i++) {
	          finalCh = lineLength(cm, curStart.line);
	          var tmp = Pos(curStart.line + 1,
	                        lineLength(cm, curStart.line + 1));
	          var text = cm.getRange(curStart, tmp);
	          text = text.replace(/\n\s*/g, ' ');
	          cm.replaceRange(text, curStart, tmp);
	        }
	        var curFinalPos = Pos(curStart.line, finalCh);
	        if (vim.visualMode) {
	          exitVisualMode(cm, false);
	        }
	        cm.setCursor(curFinalPos);
	      },
	      newLineAndEnterInsertMode: function(cm, actionArgs, vim) {
	        vim.insertMode = true;
	        var insertAt = copyCursor(cm.getCursor());
	        if (insertAt.line === cm.firstLine() && !actionArgs.after) {
	          // Special case for inserting newline before start of document.
	          cm.replaceRange('\n', Pos(cm.firstLine(), 0));
	          cm.setCursor(cm.firstLine(), 0);
	        } else {
	          insertAt.line = (actionArgs.after) ? insertAt.line :
	              insertAt.line - 1;
	          insertAt.ch = lineLength(cm, insertAt.line);
	          cm.setCursor(insertAt);
	          var newlineFn = CodeMirror.commands.newlineAndIndentContinueComment ||
	              CodeMirror.commands.newlineAndIndent;
	          newlineFn(cm);
	        }
	        this.enterInsertMode(cm, { repeat: actionArgs.repeat }, vim);
	      },
	      paste: function(cm, actionArgs, vim) {
	        var cur = copyCursor(cm.getCursor());
	        var register = vimGlobalState.registerController.getRegister(
	            actionArgs.registerName);
	        var text = register.toString();
	        if (!text) {
	          return;
	        }
	        if (actionArgs.matchIndent) {
	          var tabSize = cm.getOption("tabSize");
	          // length that considers tabs and tabSize
	          var whitespaceLength = function(str) {
	            var tabs = (str.split("\t").length - 1);
	            var spaces = (str.split(" ").length - 1);
	            return tabs * tabSize + spaces * 1;
	          };
	          var currentLine = cm.getLine(cm.getCursor().line);
	          var indent = whitespaceLength(currentLine.match(/^\s*/)[0]);
	          // chomp last newline b/c don't want it to match /^\s*/gm
	          var chompedText = text.replace(/\n$/, '');
	          var wasChomped = text !== chompedText;
	          var firstIndent = whitespaceLength(text.match(/^\s*/)[0]);
	          var text = chompedText.replace(/^\s*/gm, function(wspace) {
	            var newIndent = indent + (whitespaceLength(wspace) - firstIndent);
	            if (newIndent < 0) {
	              return "";
	            }
	            else if (cm.getOption("indentWithTabs")) {
	              var quotient = Math.floor(newIndent / tabSize);
	              return Array(quotient + 1).join('\t');
	            }
	            else {
	              return Array(newIndent + 1).join(' ');
	            }
	          });
	          text += wasChomped ? "\n" : "";
	        }
	        if (actionArgs.repeat > 1) {
	          var text = Array(actionArgs.repeat + 1).join(text);
	        }
	        var linewise = register.linewise;
	        var blockwise = register.blockwise;
	        if (linewise) {
	          if(vim.visualMode) {
	            text = vim.visualLine ? text.slice(0, -1) : '\n' + text.slice(0, text.length - 1) + '\n';
	          } else if (actionArgs.after) {
	            // Move the newline at the end to the start instead, and paste just
	            // before the newline character of the line we are on right now.
	            text = '\n' + text.slice(0, text.length - 1);
	            cur.ch = lineLength(cm, cur.line);
	          } else {
	            cur.ch = 0;
	          }
	        } else {
	          if (blockwise) {
	            text = text.split('\n');
	            for (var i = 0; i < text.length; i++) {
	              text[i] = (text[i] == '') ? ' ' : text[i];
	            }
	          }
	          cur.ch += actionArgs.after ? 1 : 0;
	        }
	        var curPosFinal;
	        var idx;
	        if (vim.visualMode) {
	          //  save the pasted text for reselection if the need arises
	          vim.lastPastedText = text;
	          var lastSelectionCurEnd;
	          var selectedArea = getSelectedAreaRange(cm, vim);
	          var selectionStart = selectedArea[0];
	          var selectionEnd = selectedArea[1];
	          var selectedText = cm.getSelection();
	          var selections = cm.listSelections();
	          var emptyStrings = new Array(selections.length).join('1').split('1');
	          // save the curEnd marker before it get cleared due to cm.replaceRange.
	          if (vim.lastSelection) {
	            lastSelectionCurEnd = vim.lastSelection.headMark.find();
	          }
	          // push the previously selected text to unnamed register
	          vimGlobalState.registerController.unnamedRegister.setText(selectedText);
	          if (blockwise) {
	            // first delete the selected text
	            cm.replaceSelections(emptyStrings);
	            // Set new selections as per the block length of the yanked text
	            selectionEnd = Pos(selectionStart.line + text.length-1, selectionStart.ch);
	            cm.setCursor(selectionStart);
	            selectBlock(cm, selectionEnd);
	            cm.replaceSelections(text);
	            curPosFinal = selectionStart;
	          } else if (vim.visualBlock) {
	            cm.replaceSelections(emptyStrings);
	            cm.setCursor(selectionStart);
	            cm.replaceRange(text, selectionStart, selectionStart);
	            curPosFinal = selectionStart;
	          } else {
	            cm.replaceRange(text, selectionStart, selectionEnd);
	            curPosFinal = cm.posFromIndex(cm.indexFromPos(selectionStart) + text.length - 1);
	          }
	          // restore the the curEnd marker
	          if(lastSelectionCurEnd) {
	            vim.lastSelection.headMark = cm.setBookmark(lastSelectionCurEnd);
	          }
	          if (linewise) {
	            curPosFinal.ch=0;
	          }
	        } else {
	          if (blockwise) {
	            cm.setCursor(cur);
	            for (var i = 0; i < text.length; i++) {
	              var line = cur.line+i;
	              if (line > cm.lastLine()) {
	                cm.replaceRange('\n',  Pos(line, 0));
	              }
	              var lastCh = lineLength(cm, line);
	              if (lastCh < cur.ch) {
	                extendLineToColumn(cm, line, cur.ch);
	              }
	            }
	            cm.setCursor(cur);
	            selectBlock(cm, Pos(cur.line + text.length-1, cur.ch));
	            cm.replaceSelections(text);
	            curPosFinal = cur;
	          } else {
	            cm.replaceRange(text, cur);
	            // Now fine tune the cursor to where we want it.
	            if (linewise && actionArgs.after) {
	              curPosFinal = Pos(
	              cur.line + 1,
	              findFirstNonWhiteSpaceCharacter(cm.getLine(cur.line + 1)));
	            } else if (linewise && !actionArgs.after) {
	              curPosFinal = Pos(
	                cur.line,
	                findFirstNonWhiteSpaceCharacter(cm.getLine(cur.line)));
	            } else if (!linewise && actionArgs.after) {
	              idx = cm.indexFromPos(cur);
	              curPosFinal = cm.posFromIndex(idx + text.length - 1);
	            } else {
	              idx = cm.indexFromPos(cur);
	              curPosFinal = cm.posFromIndex(idx + text.length);
	            }
	          }
	        }
	        if (vim.visualMode) {
	          exitVisualMode(cm, false);
	        }
	        cm.setCursor(curPosFinal);
	      },
	      undo: function(cm, actionArgs) {
	        cm.operation(function() {
	          repeatFn(cm, CodeMirror.commands.undo, actionArgs.repeat)();
	          cm.setCursor(cm.getCursor('anchor'));
	        });
	      },
	      redo: function(cm, actionArgs) {
	        repeatFn(cm, CodeMirror.commands.redo, actionArgs.repeat)();
	      },
	      setRegister: function(_cm, actionArgs, vim) {
	        vim.inputState.registerName = actionArgs.selectedCharacter;
	      },
	      setMark: function(cm, actionArgs, vim) {
	        var markName = actionArgs.selectedCharacter;
	        updateMark(cm, vim, markName, cm.getCursor());
	      },
	      replace: function(cm, actionArgs, vim) {
	        var replaceWith = actionArgs.selectedCharacter;
	        var curStart = cm.getCursor();
	        var replaceTo;
	        var curEnd;
	        var selections = cm.listSelections();
	        if (vim.visualMode) {
	          curStart = cm.getCursor('start');
	          curEnd = cm.getCursor('end');
	        } else {
	          var line = cm.getLine(curStart.line);
	          replaceTo = curStart.ch + actionArgs.repeat;
	          if (replaceTo > line.length) {
	            replaceTo=line.length;
	          }
	          curEnd = Pos(curStart.line, replaceTo);
	        }
	        if (replaceWith=='\n') {
	          if (!vim.visualMode) cm.replaceRange('', curStart, curEnd);
	          // special case, where vim help says to replace by just one line-break
	          (CodeMirror.commands.newlineAndIndentContinueComment || CodeMirror.commands.newlineAndIndent)(cm);
	        } else {
	          var replaceWithStr = cm.getRange(curStart, curEnd);
	          //replace all characters in range by selected, but keep linebreaks
	          replaceWithStr = replaceWithStr.replace(/[^\n]/g, replaceWith);
	          if (vim.visualBlock) {
	            // Tabs are split in visua block before replacing
	            var spaces = new Array(cm.getOption("tabSize")+1).join(' ');
	            replaceWithStr = cm.getSelection();
	            replaceWithStr = replaceWithStr.replace(/\t/g, spaces).replace(/[^\n]/g, replaceWith).split('\n');
	            cm.replaceSelections(replaceWithStr);
	          } else {
	            cm.replaceRange(replaceWithStr, curStart, curEnd);
	          }
	          if (vim.visualMode) {
	            curStart = cursorIsBefore(selections[0].anchor, selections[0].head) ?
	                         selections[0].anchor : selections[0].head;
	            cm.setCursor(curStart);
	            exitVisualMode(cm, false);
	          } else {
	            cm.setCursor(offsetCursor(curEnd, 0, -1));
	          }
	        }
	      },
	      incrementNumberToken: function(cm, actionArgs) {
	        var cur = cm.getCursor();
	        var lineStr = cm.getLine(cur.line);
	        var re = /-?\d+/g;
	        var match;
	        var start;
	        var end;
	        var numberStr;
	        var token;
	        while ((match = re.exec(lineStr)) !== null) {
	          token = match[0];
	          start = match.index;
	          end = start + token.length;
	          if (cur.ch < end)break;
	        }
	        if (!actionArgs.backtrack && (end <= cur.ch))return;
	        if (token) {
	          var increment = actionArgs.increase ? 1 : -1;
	          var number = parseInt(token) + (increment * actionArgs.repeat);
	          var from = Pos(cur.line, start);
	          var to = Pos(cur.line, end);
	          numberStr = number.toString();
	          cm.replaceRange(numberStr, from, to);
	        } else {
	          return;
	        }
	        cm.setCursor(Pos(cur.line, start + numberStr.length - 1));
	      },
	      repeatLastEdit: function(cm, actionArgs, vim) {
	        var lastEditInputState = vim.lastEditInputState;
	        if (!lastEditInputState) { return; }
	        var repeat = actionArgs.repeat;
	        if (repeat && actionArgs.repeatIsExplicit) {
	          vim.lastEditInputState.repeatOverride = repeat;
	        } else {
	          repeat = vim.lastEditInputState.repeatOverride || repeat;
	        }
	        repeatLastEdit(cm, vim, repeat, false /** repeatForInsert */);
	      },
	      indent: function(cm, actionArgs) {
	        cm.indentLine(cm.getCursor().line, actionArgs.indentRight);
	      },
	      exitInsertMode: exitInsertMode
	    };
	
	    function defineAction(name, fn) {
	      actions[name] = fn;
	    }
	
	    /*
	     * Below are miscellaneous utility functions used by vim.js
	     */
	
	    /**
	     * Clips cursor to ensure that line is within the buffer's range
	     * If includeLineBreak is true, then allow cur.ch == lineLength.
	     */
	    function clipCursorToContent(cm, cur, includeLineBreak) {
	      var line = Math.min(Math.max(cm.firstLine(), cur.line), cm.lastLine() );
	      var maxCh = lineLength(cm, line) - 1;
	      maxCh = (includeLineBreak) ? maxCh + 1 : maxCh;
	      var ch = Math.min(Math.max(0, cur.ch), maxCh);
	      return Pos(line, ch);
	    }
	    function copyArgs(args) {
	      var ret = {};
	      for (var prop in args) {
	        if (args.hasOwnProperty(prop)) {
	          ret[prop] = args[prop];
	        }
	      }
	      return ret;
	    }
	    function offsetCursor(cur, offsetLine, offsetCh) {
	      if (typeof offsetLine === 'object') {
	        offsetCh = offsetLine.ch;
	        offsetLine = offsetLine.line;
	      }
	      return Pos(cur.line + offsetLine, cur.ch + offsetCh);
	    }
	    function getOffset(anchor, head) {
	      return {
	        line: head.line - anchor.line,
	        ch: head.line - anchor.line
	      };
	    }
	    function commandMatches(keys, keyMap, context, inputState) {
	      // Partial matches are not applied. They inform the key handler
	      // that the current key sequence is a subsequence of a valid key
	      // sequence, so that the key buffer is not cleared.
	      var match, partial = [], full = [];
	      for (var i = 0; i < keyMap.length; i++) {
	        var command = keyMap[i];
	        if (context == 'insert' && command.context != 'insert' ||
	            command.context && command.context != context ||
	            inputState.operator && command.type == 'action' ||
	            !(match = commandMatch(keys, command.keys))) { continue; }
	        if (match == 'partial') { partial.push(command); }
	        if (match == 'full') { full.push(command); }
	      }
	      return {
	        partial: partial.length && partial,
	        full: full.length && full
	      };
	    }
	    function commandMatch(pressed, mapped) {
	      if (mapped.slice(-11) == '<character>') {
	        // Last character matches anything.
	        var prefixLen = mapped.length - 11;
	        var pressedPrefix = pressed.slice(0, prefixLen);
	        var mappedPrefix = mapped.slice(0, prefixLen);
	        return pressedPrefix == mappedPrefix && pressed.length > prefixLen ? 'full' :
	               mappedPrefix.indexOf(pressedPrefix) == 0 ? 'partial' : false;
	      } else {
	        return pressed == mapped ? 'full' :
	               mapped.indexOf(pressed) == 0 ? 'partial' : false;
	      }
	    }
	    function lastChar(keys) {
	      var match = /^.*(<[\w\-]+>)$/.exec(keys);
	      var selectedCharacter = match ? match[1] : keys.slice(-1);
	      if (selectedCharacter.length > 1){
	        switch(selectedCharacter){
	          case '<CR>':
	            selectedCharacter='\n';
	            break;
	          case '<Space>':
	            selectedCharacter=' ';
	            break;
	          default:
	            break;
	        }
	      }
	      return selectedCharacter;
	    }
	    function repeatFn(cm, fn, repeat) {
	      return function() {
	        for (var i = 0; i < repeat; i++) {
	          fn(cm);
	        }
	      };
	    }
	    function copyCursor(cur) {
	      return Pos(cur.line, cur.ch);
	    }
	    function cursorEqual(cur1, cur2) {
	      return cur1.ch == cur2.ch && cur1.line == cur2.line;
	    }
	    function cursorIsBefore(cur1, cur2) {
	      if (cur1.line < cur2.line) {
	        return true;
	      }
	      if (cur1.line == cur2.line && cur1.ch < cur2.ch) {
	        return true;
	      }
	      return false;
	    }
	    function cursorMin(cur1, cur2) {
	      if (arguments.length > 2) {
	        cur2 = cursorMin.apply(undefined, Array.prototype.slice.call(arguments, 1));
	      }
	      return cursorIsBefore(cur1, cur2) ? cur1 : cur2;
	    }
	    function cursorMax(cur1, cur2) {
	      if (arguments.length > 2) {
	        cur2 = cursorMax.apply(undefined, Array.prototype.slice.call(arguments, 1));
	      }
	      return cursorIsBefore(cur1, cur2) ? cur2 : cur1;
	    }
	    function cursorIsBetween(cur1, cur2, cur3) {
	      // returns true if cur2 is between cur1 and cur3.
	      var cur1before2 = cursorIsBefore(cur1, cur2);
	      var cur2before3 = cursorIsBefore(cur2, cur3);
	      return cur1before2 && cur2before3;
	    }
	    function lineLength(cm, lineNum) {
	      return cm.getLine(lineNum).length;
	    }
	    function trim(s) {
	      if (s.trim) {
	        return s.trim();
	      }
	      return s.replace(/^\s+|\s+$/g, '');
	    }
	    function escapeRegex(s) {
	      return s.replace(/([.?*+$\[\]\/\\(){}|\-])/g, '\\$1');
	    }
	    function extendLineToColumn(cm, lineNum, column) {
	      var endCh = lineLength(cm, lineNum);
	      var spaces = new Array(column-endCh+1).join(' ');
	      cm.setCursor(Pos(lineNum, endCh));
	      cm.replaceRange(spaces, cm.getCursor());
	    }
	    // This functions selects a rectangular block
	    // of text with selectionEnd as any of its corner
	    // Height of block:
	    // Difference in selectionEnd.line and first/last selection.line
	    // Width of the block:
	    // Distance between selectionEnd.ch and any(first considered here) selection.ch
	    function selectBlock(cm, selectionEnd) {
	      var selections = [], ranges = cm.listSelections();
	      var head = copyCursor(cm.clipPos(selectionEnd));
	      var isClipped = !cursorEqual(selectionEnd, head);
	      var curHead = cm.getCursor('head');
	      var primIndex = getIndex(ranges, curHead);
	      var wasClipped = cursorEqual(ranges[primIndex].head, ranges[primIndex].anchor);
	      var max = ranges.length - 1;
	      var index = max - primIndex > primIndex ? max : 0;
	      var base = ranges[index].anchor;
	
	      var firstLine = Math.min(base.line, head.line);
	      var lastLine = Math.max(base.line, head.line);
	      var baseCh = base.ch, headCh = head.ch;
	
	      var dir = ranges[index].head.ch - baseCh;
	      var newDir = headCh - baseCh;
	      if (dir > 0 && newDir <= 0) {
	        baseCh++;
	        if (!isClipped) { headCh--; }
	      } else if (dir < 0 && newDir >= 0) {
	        baseCh--;
	        if (!wasClipped) { headCh++; }
	      } else if (dir < 0 && newDir == -1) {
	        baseCh--;
	        headCh++;
	      }
	      for (var line = firstLine; line <= lastLine; line++) {
	        var range = {anchor: new Pos(line, baseCh), head: new Pos(line, headCh)};
	        selections.push(range);
	      }
	      primIndex = head.line == lastLine ? selections.length - 1 : 0;
	      cm.setSelections(selections);
	      selectionEnd.ch = headCh;
	      base.ch = baseCh;
	      return base;
	    }
	    function selectForInsert(cm, head, height) {
	      var sel = [];
	      for (var i = 0; i < height; i++) {
	        var lineHead = offsetCursor(head, i, 0);
	        sel.push({anchor: lineHead, head: lineHead});
	      }
	      cm.setSelections(sel, 0);
	    }
	    // getIndex returns the index of the cursor in the selections.
	    function getIndex(ranges, cursor, end) {
	      for (var i = 0; i < ranges.length; i++) {
	        var atAnchor = end != 'head' && cursorEqual(ranges[i].anchor, cursor);
	        var atHead = end != 'anchor' && cursorEqual(ranges[i].head, cursor);
	        if (atAnchor || atHead) {
	          return i;
	        }
	      }
	      return -1;
	    }
	    function getSelectedAreaRange(cm, vim) {
	      var lastSelection = vim.lastSelection;
	      var getCurrentSelectedAreaRange = function() {
	        var selections = cm.listSelections();
	        var start =  selections[0];
	        var end = selections[selections.length-1];
	        var selectionStart = cursorIsBefore(start.anchor, start.head) ? start.anchor : start.head;
	        var selectionEnd = cursorIsBefore(end.anchor, end.head) ? end.head : end.anchor;
	        return [selectionStart, selectionEnd];
	      };
	      var getLastSelectedAreaRange = function() {
	        var selectionStart = cm.getCursor();
	        var selectionEnd = cm.getCursor();
	        var block = lastSelection.visualBlock;
	        if (block) {
	          var width = block.width;
	          var height = block.height;
	          selectionEnd = Pos(selectionStart.line + height, selectionStart.ch + width);
	          var selections = [];
	          // selectBlock creates a 'proper' rectangular block.
	          // We do not want that in all cases, so we manually set selections.
	          for (var i = selectionStart.line; i < selectionEnd.line; i++) {
	            var anchor = Pos(i, selectionStart.ch);
	            var head = Pos(i, selectionEnd.ch);
	            var range = {anchor: anchor, head: head};
	            selections.push(range);
	          }
	          cm.setSelections(selections);
	        } else {
	          var start = lastSelection.anchorMark.find();
	          var end = lastSelection.headMark.find();
	          var line = end.line - start.line;
	          var ch = end.ch - start.ch;
	          selectionEnd = {line: selectionEnd.line + line, ch: line ? selectionEnd.ch : ch + selectionEnd.ch};
	          if (lastSelection.visualLine) {
	            selectionStart = Pos(selectionStart.line, 0);
	            selectionEnd = Pos(selectionEnd.line, lineLength(cm, selectionEnd.line));
	          }
	          cm.setSelection(selectionStart, selectionEnd);
	        }
	        return [selectionStart, selectionEnd];
	      };
	      if (!vim.visualMode) {
	      // In case of replaying the action.
	        return getLastSelectedAreaRange();
	      } else {
	        return getCurrentSelectedAreaRange();
	      }
	    }
	    // Updates the previous selection with the current selection's values. This
	    // should only be called in visual mode.
	    function updateLastSelection(cm, vim) {
	      var anchor = vim.sel.anchor;
	      var head = vim.sel.head;
	      // To accommodate the effect of lastPastedText in the last selection
	      if (vim.lastPastedText) {
	        head = cm.posFromIndex(cm.indexFromPos(anchor) + vim.lastPastedText.length);
	        vim.lastPastedText = null;
	      }
	      vim.lastSelection = {'anchorMark': cm.setBookmark(anchor),
	                           'headMark': cm.setBookmark(head),
	                           'anchor': copyCursor(anchor),
	                           'head': copyCursor(head),
	                           'visualMode': vim.visualMode,
	                           'visualLine': vim.visualLine,
	                           'visualBlock': vim.visualBlock};
	    }
	    function expandSelection(cm, start, end) {
	      var sel = cm.state.vim.sel;
	      var head = sel.head;
	      var anchor = sel.anchor;
	      var tmp;
	      if (cursorIsBefore(end, start)) {
	        tmp = end;
	        end = start;
	        start = tmp;
	      }
	      if (cursorIsBefore(head, anchor)) {
	        head = cursorMin(start, head);
	        anchor = cursorMax(anchor, end);
	      } else {
	        anchor = cursorMin(start, anchor);
	        head = cursorMax(head, end);
	        head = offsetCursor(head, 0, -1);
	        if (head.ch == -1 && head.line != cm.firstLine()) {
	          head = Pos(head.line - 1, lineLength(cm, head.line - 1));
	        }
	      }
	      return [anchor, head];
	    }
	    /**
	     * Updates the CodeMirror selection to match the provided vim selection.
	     * If no arguments are given, it uses the current vim selection state.
	     */
	    function updateCmSelection(cm, sel, mode) {
	      var vim = cm.state.vim;
	      sel = sel || vim.sel;
	      var mode = mode ||
	        vim.visualLine ? 'line' : vim.visualBlock ? 'block' : 'char';
	      var cmSel = makeCmSelection(cm, sel, mode);
	      cm.setSelections(cmSel.ranges, cmSel.primary);
	      updateFakeCursor(cm);
	    }
	    function makeCmSelection(cm, sel, mode, exclusive) {
	      var head = copyCursor(sel.head);
	      var anchor = copyCursor(sel.anchor);
	      if (mode == 'char') {
	        var headOffset = !exclusive && !cursorIsBefore(sel.head, sel.anchor) ? 1 : 0;
	        var anchorOffset = cursorIsBefore(sel.head, sel.anchor) ? 1 : 0;
	        head = offsetCursor(sel.head, 0, headOffset);
	        anchor = offsetCursor(sel.anchor, 0, anchorOffset);
	        return {
	          ranges: [{anchor: anchor, head: head}],
	          primary: 0
	        };
	      } else if (mode == 'line') {
	        if (!cursorIsBefore(sel.head, sel.anchor)) {
	          anchor.ch = 0;
	
	          var lastLine = cm.lastLine();
	          if (head.line > lastLine) {
	            head.line = lastLine;
	          }
	          head.ch = lineLength(cm, head.line);
	        } else {
	          head.ch = 0;
	          anchor.ch = lineLength(cm, anchor.line);
	        }
	        return {
	          ranges: [{anchor: anchor, head: head}],
	          primary: 0
	        };
	      } else if (mode == 'block') {
	        var top = Math.min(anchor.line, head.line),
	            left = Math.min(anchor.ch, head.ch),
	            bottom = Math.max(anchor.line, head.line),
	            right = Math.max(anchor.ch, head.ch) + 1;
	        var height = bottom - top + 1;
	        var primary = head.line == top ? 0 : height - 1;
	        var ranges = [];
	        for (var i = 0; i < height; i++) {
	          ranges.push({
	            anchor: Pos(top + i, left),
	            head: Pos(top + i, right)
	          });
	        }
	        return {
	          ranges: ranges,
	          primary: primary
	        };
	      }
	    }
	    function getHead(cm) {
	      var cur = cm.getCursor('head');
	      if (cm.getSelection().length == 1) {
	        // Small corner case when only 1 character is selected. The "real"
	        // head is the left of head and anchor.
	        cur = cursorMin(cur, cm.getCursor('anchor'));
	      }
	      return cur;
	    }
	
	    /**
	     * If moveHead is set to false, the CodeMirror selection will not be
	     * touched. The caller assumes the responsibility of putting the cursor
	    * in the right place.
	     */
	    function exitVisualMode(cm, moveHead) {
	      var vim = cm.state.vim;
	      if (moveHead !== false) {
	        cm.setCursor(clipCursorToContent(cm, vim.sel.head));
	      }
	      updateLastSelection(cm, vim);
	      vim.visualMode = false;
	      vim.visualLine = false;
	      vim.visualBlock = false;
	      CodeMirror.signal(cm, "vim-mode-change", {mode: "normal"});
	      if (vim.fakeCursor) {
	        vim.fakeCursor.clear();
	      }
	    }
	
	    // Remove any trailing newlines from the selection. For
	    // example, with the caret at the start of the last word on the line,
	    // 'dw' should word, but not the newline, while 'w' should advance the
	    // caret to the first character of the next line.
	    function clipToLine(cm, curStart, curEnd) {
	      var selection = cm.getRange(curStart, curEnd);
	      // Only clip if the selection ends with trailing newline + whitespace
	      if (/\n\s*$/.test(selection)) {
	        var lines = selection.split('\n');
	        // We know this is all whitespace.
	        lines.pop();
	
	        // Cases:
	        // 1. Last word is an empty line - do not clip the trailing '\n'
	        // 2. Last word is not an empty line - clip the trailing '\n'
	        var line;
	        // Find the line containing the last word, and clip all whitespace up
	        // to it.
	        for (var line = lines.pop(); lines.length > 0 && line && isWhiteSpaceString(line); line = lines.pop()) {
	          curEnd.line--;
	          curEnd.ch = 0;
	        }
	        // If the last word is not an empty line, clip an additional newline
	        if (line) {
	          curEnd.line--;
	          curEnd.ch = lineLength(cm, curEnd.line);
	        } else {
	          curEnd.ch = 0;
	        }
	      }
	    }
	
	    // Expand the selection to line ends.
	    function expandSelectionToLine(_cm, curStart, curEnd) {
	      curStart.ch = 0;
	      curEnd.ch = 0;
	      curEnd.line++;
	    }
	
	    function findFirstNonWhiteSpaceCharacter(text) {
	      if (!text) {
	        return 0;
	      }
	      var firstNonWS = text.search(/\S/);
	      return firstNonWS == -1 ? text.length : firstNonWS;
	    }
	
	    function expandWordUnderCursor(cm, inclusive, _forward, bigWord, noSymbol) {
	      var cur = getHead(cm);
	      var line = cm.getLine(cur.line);
	      var idx = cur.ch;
	
	      // Seek to first word or non-whitespace character, depending on if
	      // noSymbol is true.
	      var test = noSymbol ? wordCharTest[0] : bigWordCharTest [0];
	      while (!test(line.charAt(idx))) {
	        idx++;
	        if (idx >= line.length) { return null; }
	      }
	
	      if (bigWord) {
	        test = bigWordCharTest[0];
	      } else {
	        test = wordCharTest[0];
	        if (!test(line.charAt(idx))) {
	          test = wordCharTest[1];
	        }
	      }
	
	      var end = idx, start = idx;
	      while (test(line.charAt(end)) && end < line.length) { end++; }
	      while (test(line.charAt(start)) && start >= 0) { start--; }
	      start++;
	
	      if (inclusive) {
	        // If present, include all whitespace after word.
	        // Otherwise, include all whitespace before word, except indentation.
	        var wordEnd = end;
	        while (/\s/.test(line.charAt(end)) && end < line.length) { end++; }
	        if (wordEnd == end) {
	          var wordStart = start;
	          while (/\s/.test(line.charAt(start - 1)) && start > 0) { start--; }
	          if (!start) { start = wordStart; }
	        }
	      }
	      return { start: Pos(cur.line, start), end: Pos(cur.line, end) };
	    }
	
	    function recordJumpPosition(cm, oldCur, newCur) {
	      if (!cursorEqual(oldCur, newCur)) {
	        vimGlobalState.jumpList.add(cm, oldCur, newCur);
	      }
	    }
	
	    function recordLastCharacterSearch(increment, args) {
	        vimGlobalState.lastCharacterSearch.increment = increment;
	        vimGlobalState.lastCharacterSearch.forward = args.forward;
	        vimGlobalState.lastCharacterSearch.selectedCharacter = args.selectedCharacter;
	    }
	
	    var symbolToMode = {
	        '(': 'bracket', ')': 'bracket', '{': 'bracket', '}': 'bracket',
	        '[': 'section', ']': 'section',
	        '*': 'comment', '/': 'comment',
	        'm': 'method', 'M': 'method',
	        '#': 'preprocess'
	    };
	    var findSymbolModes = {
	      bracket: {
	        isComplete: function(state) {
	          if (state.nextCh === state.symb) {
	            state.depth++;
	            if (state.depth >= 1)return true;
	          } else if (state.nextCh === state.reverseSymb) {
	            state.depth--;
	          }
	          return false;
	        }
	      },
	      section: {
	        init: function(state) {
	          state.curMoveThrough = true;
	          state.symb = (state.forward ? ']' : '[') === state.symb ? '{' : '}';
	        },
	        isComplete: function(state) {
	          return state.index === 0 && state.nextCh === state.symb;
	        }
	      },
	      comment: {
	        isComplete: function(state) {
	          var found = state.lastCh === '*' && state.nextCh === '/';
	          state.lastCh = state.nextCh;
	          return found;
	        }
	      },
	      // TODO: The original Vim implementation only operates on level 1 and 2.
	      // The current implementation doesn't check for code block level and
	      // therefore it operates on any levels.
	      method: {
	        init: function(state) {
	          state.symb = (state.symb === 'm' ? '{' : '}');
	          state.reverseSymb = state.symb === '{' ? '}' : '{';
	        },
	        isComplete: function(state) {
	          if (state.nextCh === state.symb)return true;
	          return false;
	        }
	      },
	      preprocess: {
	        init: function(state) {
	          state.index = 0;
	        },
	        isComplete: function(state) {
	          if (state.nextCh === '#') {
	            var token = state.lineText.match(/#(\w+)/)[1];
	            if (token === 'endif') {
	              if (state.forward && state.depth === 0) {
	                return true;
	              }
	              state.depth++;
	            } else if (token === 'if') {
	              if (!state.forward && state.depth === 0) {
	                return true;
	              }
	              state.depth--;
	            }
	            if (token === 'else' && state.depth === 0)return true;
	          }
	          return false;
	        }
	      }
	    };
	    function findSymbol(cm, repeat, forward, symb) {
	      var cur = copyCursor(cm.getCursor());
	      var increment = forward ? 1 : -1;
	      var endLine = forward ? cm.lineCount() : -1;
	      var curCh = cur.ch;
	      var line = cur.line;
	      var lineText = cm.getLine(line);
	      var state = {
	        lineText: lineText,
	        nextCh: lineText.charAt(curCh),
	        lastCh: null,
	        index: curCh,
	        symb: symb,
	        reverseSymb: (forward ?  { ')': '(', '}': '{' } : { '(': ')', '{': '}' })[symb],
	        forward: forward,
	        depth: 0,
	        curMoveThrough: false
	      };
	      var mode = symbolToMode[symb];
	      if (!mode)return cur;
	      var init = findSymbolModes[mode].init;
	      var isComplete = findSymbolModes[mode].isComplete;
	      if (init) { init(state); }
	      while (line !== endLine && repeat) {
	        state.index += increment;
	        state.nextCh = state.lineText.charAt(state.index);
	        if (!state.nextCh) {
	          line += increment;
	          state.lineText = cm.getLine(line) || '';
	          if (increment > 0) {
	            state.index = 0;
	          } else {
	            var lineLen = state.lineText.length;
	            state.index = (lineLen > 0) ? (lineLen-1) : 0;
	          }
	          state.nextCh = state.lineText.charAt(state.index);
	        }
	        if (isComplete(state)) {
	          cur.line = line;
	          cur.ch = state.index;
	          repeat--;
	        }
	      }
	      if (state.nextCh || state.curMoveThrough) {
	        return Pos(line, state.index);
	      }
	      return cur;
	    }
	
	    /**
	     * Returns the boundaries of the next word. If the cursor in the middle of
	     * the word, then returns the boundaries of the current word, starting at
	     * the cursor. If the cursor is at the start/end of a word, and we are going
	     * forward/backward, respectively, find the boundaries of the next word.
	     *
	     * @param {CodeMirror} cm CodeMirror object.
	     * @param {Cursor} cur The cursor position.
	     * @param {boolean} forward True to search forward. False to search
	     *     backward.
	     * @param {boolean} bigWord True if punctuation count as part of the word.
	     *     False if only [a-zA-Z0-9] characters count as part of the word.
	     * @param {boolean} emptyLineIsWord True if empty lines should be treated
	     *     as words.
	     * @return {Object{from:number, to:number, line: number}} The boundaries of
	     *     the word, or null if there are no more words.
	     */
	    function findWord(cm, cur, forward, bigWord, emptyLineIsWord) {
	      var lineNum = cur.line;
	      var pos = cur.ch;
	      var line = cm.getLine(lineNum);
	      var dir = forward ? 1 : -1;
	      var charTests = bigWord ? bigWordCharTest: wordCharTest;
	
	      if (emptyLineIsWord && line == '') {
	        lineNum += dir;
	        line = cm.getLine(lineNum);
	        if (!isLine(cm, lineNum)) {
	          return null;
	        }
	        pos = (forward) ? 0 : line.length;
	      }
	
	      while (true) {
	        if (emptyLineIsWord && line == '') {
	          return { from: 0, to: 0, line: lineNum };
	        }
	        var stop = (dir > 0) ? line.length : -1;
	        var wordStart = stop, wordEnd = stop;
	        // Find bounds of next word.
	        while (pos != stop) {
	          var foundWord = false;
	          for (var i = 0; i < charTests.length && !foundWord; ++i) {
	            if (charTests[i](line.charAt(pos))) {
	              wordStart = pos;
	              // Advance to end of word.
	              while (pos != stop && charTests[i](line.charAt(pos))) {
	                pos += dir;
	              }
	              wordEnd = pos;
	              foundWord = wordStart != wordEnd;
	              if (wordStart == cur.ch && lineNum == cur.line &&
	                  wordEnd == wordStart + dir) {
	                // We started at the end of a word. Find the next one.
	                continue;
	              } else {
	                return {
	                  from: Math.min(wordStart, wordEnd + 1),
	                  to: Math.max(wordStart, wordEnd),
	                  line: lineNum };
	              }
	            }
	          }
	          if (!foundWord) {
	            pos += dir;
	          }
	        }
	        // Advance to next/prev line.
	        lineNum += dir;
	        if (!isLine(cm, lineNum)) {
	          return null;
	        }
	        line = cm.getLine(lineNum);
	        pos = (dir > 0) ? 0 : line.length;
	      }
	    }
	
	    /**
	     * @param {CodeMirror} cm CodeMirror object.
	     * @param {Pos} cur The position to start from.
	     * @param {int} repeat Number of words to move past.
	     * @param {boolean} forward True to search forward. False to search
	     *     backward.
	     * @param {boolean} wordEnd True to move to end of word. False to move to
	     *     beginning of word.
	     * @param {boolean} bigWord True if punctuation count as part of the word.
	     *     False if only alphabet characters count as part of the word.
	     * @return {Cursor} The position the cursor should move to.
	     */
	    function moveToWord(cm, cur, repeat, forward, wordEnd, bigWord) {
	      var curStart = copyCursor(cur);
	      var words = [];
	      if (forward && !wordEnd || !forward && wordEnd) {
	        repeat++;
	      }
	      // For 'e', empty lines are not considered words, go figure.
	      var emptyLineIsWord = !(forward && wordEnd);
	      for (var i = 0; i < repeat; i++) {
	        var word = findWord(cm, cur, forward, bigWord, emptyLineIsWord);
	        if (!word) {
	          var eodCh = lineLength(cm, cm.lastLine());
	          words.push(forward
	              ? {line: cm.lastLine(), from: eodCh, to: eodCh}
	              : {line: 0, from: 0, to: 0});
	          break;
	        }
	        words.push(word);
	        cur = Pos(word.line, forward ? (word.to - 1) : word.from);
	      }
	      var shortCircuit = words.length != repeat;
	      var firstWord = words[0];
	      var lastWord = words.pop();
	      if (forward && !wordEnd) {
	        // w
	        if (!shortCircuit && (firstWord.from != curStart.ch || firstWord.line != curStart.line)) {
	          // We did not start in the middle of a word. Discard the extra word at the end.
	          lastWord = words.pop();
	        }
	        return Pos(lastWord.line, lastWord.from);
	      } else if (forward && wordEnd) {
	        return Pos(lastWord.line, lastWord.to - 1);
	      } else if (!forward && wordEnd) {
	        // ge
	        if (!shortCircuit && (firstWord.to != curStart.ch || firstWord.line != curStart.line)) {
	          // We did not start in the middle of a word. Discard the extra word at the end.
	          lastWord = words.pop();
	        }
	        return Pos(lastWord.line, lastWord.to);
	      } else {
	        // b
	        return Pos(lastWord.line, lastWord.from);
	      }
	    }
	
	    function moveToCharacter(cm, repeat, forward, character) {
	      var cur = cm.getCursor();
	      var start = cur.ch;
	      var idx;
	      for (var i = 0; i < repeat; i ++) {
	        var line = cm.getLine(cur.line);
	        idx = charIdxInLine(start, line, character, forward, true);
	        if (idx == -1) {
	          return null;
	        }
	        start = idx;
	      }
	      return Pos(cm.getCursor().line, idx);
	    }
	
	    function moveToColumn(cm, repeat) {
	      // repeat is always >= 1, so repeat - 1 always corresponds
	      // to the column we want to go to.
	      var line = cm.getCursor().line;
	      return clipCursorToContent(cm, Pos(line, repeat - 1));
	    }
	
	    function updateMark(cm, vim, markName, pos) {
	      if (!inArray(markName, validMarks)) {
	        return;
	      }
	      if (vim.marks[markName]) {
	        vim.marks[markName].clear();
	      }
	      vim.marks[markName] = cm.setBookmark(pos);
	    }
	
	    function charIdxInLine(start, line, character, forward, includeChar) {
	      // Search for char in line.
	      // motion_options: {forward, includeChar}
	      // If includeChar = true, include it too.
	      // If forward = true, search forward, else search backwards.
	      // If char is not found on this line, do nothing
	      var idx;
	      if (forward) {
	        idx = line.indexOf(character, start + 1);
	        if (idx != -1 && !includeChar) {
	          idx -= 1;
	        }
	      } else {
	        idx = line.lastIndexOf(character, start - 1);
	        if (idx != -1 && !includeChar) {
	          idx += 1;
	        }
	      }
	      return idx;
	    }
	
	    function findParagraph(cm, head, repeat, dir, inclusive) {
	      var line = head.line;
	      var min = cm.firstLine();
	      var max = cm.lastLine();
	      var start, end, i = line;
	      function isEmpty(i) { return !cm.getLine(i); }
	      function isBoundary(i, dir, any) {
	        if (any) { return isEmpty(i) != isEmpty(i + dir); }
	        return !isEmpty(i) && isEmpty(i + dir);
	      }
	      if (dir) {
	        while (min <= i && i <= max && repeat > 0) {
	          if (isBoundary(i, dir)) { repeat--; }
	          i += dir;
	        }
	        return new Pos(i, 0);
	      }
	
	      var vim = cm.state.vim;
	      if (vim.visualLine && isBoundary(line, 1, true)) {
	        var anchor = vim.sel.anchor;
	        if (isBoundary(anchor.line, -1, true)) {
	          if (!inclusive || anchor.line != line) {
	            line += 1;
	          }
	        }
	      }
	      var startState = isEmpty(line);
	      for (i = line; i <= max && repeat; i++) {
	        if (isBoundary(i, 1, true)) {
	          if (!inclusive || isEmpty(i) != startState) {
	            repeat--;
	          }
	        }
	      }
	      end = new Pos(i, 0);
	      // select boundary before paragraph for the last one
	      if (i > max && !startState) { startState = true; }
	      else { inclusive = false; }
	      for (i = line; i > min; i--) {
	        if (!inclusive || isEmpty(i) == startState || i == line) {
	          if (isBoundary(i, -1, true)) { break; }
	        }
	      }
	      start = new Pos(i, 0);
	      return { start: start, end: end };
	    }
	
	    // TODO: perhaps this finagling of start and end positions belonds
	    // in codemirror/replaceRange?
	    function selectCompanionObject(cm, head, symb, inclusive) {
	      var cur = head, start, end;
	
	      var bracketRegexp = ({
	        '(': /[()]/, ')': /[()]/,
	        '[': /[[\]]/, ']': /[[\]]/,
	        '{': /[{}]/, '}': /[{}]/})[symb];
	      var openSym = ({
	        '(': '(', ')': '(',
	        '[': '[', ']': '[',
	        '{': '{', '}': '{'})[symb];
	      var curChar = cm.getLine(cur.line).charAt(cur.ch);
	      // Due to the behavior of scanForBracket, we need to add an offset if the
	      // cursor is on a matching open bracket.
	      var offset = curChar === openSym ? 1 : 0;
	
	      start = cm.scanForBracket(Pos(cur.line, cur.ch + offset), -1, null, {'bracketRegex': bracketRegexp});
	      end = cm.scanForBracket(Pos(cur.line, cur.ch + offset), 1, null, {'bracketRegex': bracketRegexp});
	
	      if (!start || !end) {
	        return { start: cur, end: cur };
	      }
	
	      start = start.pos;
	      end = end.pos;
	
	      if ((start.line == end.line && start.ch > end.ch)
	          || (start.line > end.line)) {
	        var tmp = start;
	        start = end;
	        end = tmp;
	      }
	
	      if (inclusive) {
	        end.ch += 1;
	      } else {
	        start.ch += 1;
	      }
	
	      return { start: start, end: end };
	    }
	
	    // Takes in a symbol and a cursor and tries to simulate text objects that
	    // have identical opening and closing symbols
	    // TODO support across multiple lines
	    function findBeginningAndEnd(cm, head, symb, inclusive) {
	      var cur = copyCursor(head);
	      var line = cm.getLine(cur.line);
	      var chars = line.split('');
	      var start, end, i, len;
	      var firstIndex = chars.indexOf(symb);
	
	      // the decision tree is to always look backwards for the beginning first,
	      // but if the cursor is in front of the first instance of the symb,
	      // then move the cursor forward
	      if (cur.ch < firstIndex) {
	        cur.ch = firstIndex;
	        // Why is this line even here???
	        // cm.setCursor(cur.line, firstIndex+1);
	      }
	      // otherwise if the cursor is currently on the closing symbol
	      else if (firstIndex < cur.ch && chars[cur.ch] == symb) {
	        end = cur.ch; // assign end to the current cursor
	        --cur.ch; // make sure to look backwards
	      }
	
	      // if we're currently on the symbol, we've got a start
	      if (chars[cur.ch] == symb && !end) {
	        start = cur.ch + 1; // assign start to ahead of the cursor
	      } else {
	        // go backwards to find the start
	        for (i = cur.ch; i > -1 && !start; i--) {
	          if (chars[i] == symb) {
	            start = i + 1;
	          }
	        }
	      }
	
	      // look forwards for the end symbol
	      if (start && !end) {
	        for (i = start, len = chars.length; i < len && !end; i++) {
	          if (chars[i] == symb) {
	            end = i;
	          }
	        }
	      }
	
	      // nothing found
	      if (!start || !end) {
	        return { start: cur, end: cur };
	      }
	
	      // include the symbols
	      if (inclusive) {
	        --start; ++end;
	      }
	
	      return {
	        start: Pos(cur.line, start),
	        end: Pos(cur.line, end)
	      };
	    }
	
	    // Search functions
	    defineOption('pcre', true, 'boolean');
	    function SearchState() {}
	    SearchState.prototype = {
	      getQuery: function() {
	        return vimGlobalState.query;
	      },
	      setQuery: function(query) {
	        vimGlobalState.query = query;
	      },
	      getOverlay: function() {
	        return this.searchOverlay;
	      },
	      setOverlay: function(overlay) {
	        this.searchOverlay = overlay;
	      },
	      isReversed: function() {
	        return vimGlobalState.isReversed;
	      },
	      setReversed: function(reversed) {
	        vimGlobalState.isReversed = reversed;
	      },
	      getScrollbarAnnotate: function() {
	        return this.annotate;
	      },
	      setScrollbarAnnotate: function(annotate) {
	        this.annotate = annotate;
	      }
	    };
	    function getSearchState(cm) {
	      var vim = cm.state.vim;
	      return vim.searchState_ || (vim.searchState_ = new SearchState());
	    }
	    function dialog(cm, template, shortText, onClose, options) {
	      if (cm.openDialog) {
	        cm.openDialog(template, onClose, { bottom: true, value: options.value,
	            onKeyDown: options.onKeyDown, onKeyUp: options.onKeyUp,
	            selectValueOnOpen: false});
	      }
	      else {
	        onClose(prompt(shortText, ''));
	      }
	    }
	    function splitBySlash(argString) {
	      var slashes = findUnescapedSlashes(argString) || [];
	      if (!slashes.length) return [];
	      var tokens = [];
	      // in case of strings like foo/bar
	      if (slashes[0] !== 0) return;
	      for (var i = 0; i < slashes.length; i++) {
	        if (typeof slashes[i] == 'number')
	          tokens.push(argString.substring(slashes[i] + 1, slashes[i+1]));
	      }
	      return tokens;
	    }
	
	    function findUnescapedSlashes(str) {
	      var escapeNextChar = false;
	      var slashes = [];
	      for (var i = 0; i < str.length; i++) {
	        var c = str.charAt(i);
	        if (!escapeNextChar && c == '/') {
	          slashes.push(i);
	        }
	        escapeNextChar = !escapeNextChar && (c == '\\');
	      }
	      return slashes;
	    }
	
	    // Translates a search string from ex (vim) syntax into javascript form.
	    function translateRegex(str) {
	      // When these match, add a '\' if unescaped or remove one if escaped.
	      var specials = '|(){';
	      // Remove, but never add, a '\' for these.
	      var unescape = '}';
	      var escapeNextChar = false;
	      var out = [];
	      for (var i = -1; i < str.length; i++) {
	        var c = str.charAt(i) || '';
	        var n = str.charAt(i+1) || '';
	        var specialComesNext = (n && specials.indexOf(n) != -1);
	        if (escapeNextChar) {
	          if (c !== '\\' || !specialComesNext) {
	            out.push(c);
	          }
	          escapeNextChar = false;
	        } else {
	          if (c === '\\') {
	            escapeNextChar = true;
	            // Treat the unescape list as special for removing, but not adding '\'.
	            if (n && unescape.indexOf(n) != -1) {
	              specialComesNext = true;
	            }
	            // Not passing this test means removing a '\'.
	            if (!specialComesNext || n === '\\') {
	              out.push(c);
	            }
	          } else {
	            out.push(c);
	            if (specialComesNext && n !== '\\') {
	              out.push('\\');
	            }
	          }
	        }
	      }
	      return out.join('');
	    }
	
	    // Translates the replace part of a search and replace from ex (vim) syntax into
	    // javascript form.  Similar to translateRegex, but additionally fixes back references
	    // (translates '\[0..9]' to '$[0..9]') and follows different rules for escaping '$'.
	    var charUnescapes = {'\\n': '\n', '\\r': '\r', '\\t': '\t'};
	    function translateRegexReplace(str) {
	      var escapeNextChar = false;
	      var out = [];
	      for (var i = -1; i < str.length; i++) {
	        var c = str.charAt(i) || '';
	        var n = str.charAt(i+1) || '';
	        if (charUnescapes[c + n]) {
	          out.push(charUnescapes[c+n]);
	          i++;
	        } else if (escapeNextChar) {
	          // At any point in the loop, escapeNextChar is true if the previous
	          // character was a '\' and was not escaped.
	          out.push(c);
	          escapeNextChar = false;
	        } else {
	          if (c === '\\') {
	            escapeNextChar = true;
	            if ((isNumber(n) || n === '$')) {
	              out.push('$');
	            } else if (n !== '/' && n !== '\\') {
	              out.push('\\');
	            }
	          } else {
	            if (c === '$') {
	              out.push('$');
	            }
	            out.push(c);
	            if (n === '/') {
	              out.push('\\');
	            }
	          }
	        }
	      }
	      return out.join('');
	    }
	
	    // Unescape \ and / in the replace part, for PCRE mode.
	    var unescapes = {'\\/': '/', '\\\\': '\\', '\\n': '\n', '\\r': '\r', '\\t': '\t'};
	    function unescapeRegexReplace(str) {
	      var stream = new CodeMirror.StringStream(str);
	      var output = [];
	      while (!stream.eol()) {
	        // Search for \.
	        while (stream.peek() && stream.peek() != '\\') {
	          output.push(stream.next());
	        }
	        var matched = false;
	        for (var matcher in unescapes) {
	          if (stream.match(matcher, true)) {
	            matched = true;
	            output.push(unescapes[matcher]);
	            break;
	          }
	        }
	        if (!matched) {
	          // Don't change anything
	          output.push(stream.next());
	        }
	      }
	      return output.join('');
	    }
	
	    /**
	     * Extract the regular expression from the query and return a Regexp object.
	     * Returns null if the query is blank.
	     * If ignoreCase is passed in, the Regexp object will have the 'i' flag set.
	     * If smartCase is passed in, and the query contains upper case letters,
	     *   then ignoreCase is overridden, and the 'i' flag will not be set.
	     * If the query contains the /i in the flag part of the regular expression,
	     *   then both ignoreCase and smartCase are ignored, and 'i' will be passed
	     *   through to the Regex object.
	     */
	    function parseQuery(query, ignoreCase, smartCase) {
	      // First update the last search register
	      var lastSearchRegister = vimGlobalState.registerController.getRegister('/');
	      lastSearchRegister.setText(query);
	      // Check if the query is already a regex.
	      if (query instanceof RegExp) { return query; }
	      // First try to extract regex + flags from the input. If no flags found,
	      // extract just the regex. IE does not accept flags directly defined in
	      // the regex string in the form /regex/flags
	      var slashes = findUnescapedSlashes(query);
	      var regexPart;
	      var forceIgnoreCase;
	      if (!slashes.length) {
	        // Query looks like 'regexp'
	        regexPart = query;
	      } else {
	        // Query looks like 'regexp/...'
	        regexPart = query.substring(0, slashes[0]);
	        var flagsPart = query.substring(slashes[0]);
	        forceIgnoreCase = (flagsPart.indexOf('i') != -1);
	      }
	      if (!regexPart) {
	        return null;
	      }
	      if (!getOption('pcre')) {
	        regexPart = translateRegex(regexPart);
	      }
	      if (smartCase) {
	        ignoreCase = (/^[^A-Z]*$/).test(regexPart);
	      }
	      var regexp = new RegExp(regexPart,
	          (ignoreCase || forceIgnoreCase) ? 'i' : undefined);
	      return regexp;
	    }
	    function showConfirm(cm, text) {
	      if (cm.openNotification) {
	        cm.openNotification('<span style="color: red">' + text + '</span>',
	                            {bottom: true, duration: 5000});
	      } else {
	        alert(text);
	      }
	    }
	    function makePrompt(prefix, desc) {
	      var raw = '<span style="font-family: monospace; white-space: pre">' +
	          (prefix || "") + '<input type="text"></span>';
	      if (desc)
	        raw += ' <span style="color: #888">' + desc + '</span>';
	      return raw;
	    }
	    var searchPromptDesc = '(Javascript regexp)';
	    function showPrompt(cm, options) {
	      var shortText = (options.prefix || '') + ' ' + (options.desc || '');
	      var prompt = makePrompt(options.prefix, options.desc);
	      dialog(cm, prompt, shortText, options.onClose, options);
	    }
	    function regexEqual(r1, r2) {
	      if (r1 instanceof RegExp && r2 instanceof RegExp) {
	          var props = ['global', 'multiline', 'ignoreCase', 'source'];
	          for (var i = 0; i < props.length; i++) {
	              var prop = props[i];
	              if (r1[prop] !== r2[prop]) {
	                  return false;
	              }
	          }
	          return true;
	      }
	      return false;
	    }
	    // Returns true if the query is valid.
	    function updateSearchQuery(cm, rawQuery, ignoreCase, smartCase) {
	      if (!rawQuery) {
	        return;
	      }
	      var state = getSearchState(cm);
	      var query = parseQuery(rawQuery, !!ignoreCase, !!smartCase);
	      if (!query) {
	        return;
	      }
	      highlightSearchMatches(cm, query);
	      if (regexEqual(query, state.getQuery())) {
	        return query;
	      }
	      state.setQuery(query);
	      return query;
	    }
	    function searchOverlay(query) {
	      if (query.source.charAt(0) == '^') {
	        var matchSol = true;
	      }
	      return {
	        token: function(stream) {
	          if (matchSol && !stream.sol()) {
	            stream.skipToEnd();
	            return;
	          }
	          var match = stream.match(query, false);
	          if (match) {
	            if (match[0].length == 0) {
	              // Matched empty string, skip to next.
	              stream.next();
	              return 'searching';
	            }
	            if (!stream.sol()) {
	              // Backtrack 1 to match \b
	              stream.backUp(1);
	              if (!query.exec(stream.next() + match[0])) {
	                stream.next();
	                return null;
	              }
	            }
	            stream.match(query);
	            return 'searching';
	          }
	          while (!stream.eol()) {
	            stream.next();
	            if (stream.match(query, false)) break;
	          }
	        },
	        query: query
	      };
	    }
	    function highlightSearchMatches(cm, query) {
	      var searchState = getSearchState(cm);
	      var overlay = searchState.getOverlay();
	      if (!overlay || query != overlay.query) {
	        if (overlay) {
	          cm.removeOverlay(overlay);
	        }
	        overlay = searchOverlay(query);
	        cm.addOverlay(overlay);
	        if (cm.showMatchesOnScrollbar) {
	          if (searchState.getScrollbarAnnotate()) {
	            searchState.getScrollbarAnnotate().clear();
	          }
	          searchState.setScrollbarAnnotate(cm.showMatchesOnScrollbar(query));
	        }
	        searchState.setOverlay(overlay);
	      }
	    }
	    function findNext(cm, prev, query, repeat) {
	      if (repeat === undefined) { repeat = 1; }
	      return cm.operation(function() {
	        var pos = cm.getCursor();
	        var cursor = cm.getSearchCursor(query, pos);
	        for (var i = 0; i < repeat; i++) {
	          var found = cursor.find(prev);
	          if (i == 0 && found && cursorEqual(cursor.from(), pos)) { found = cursor.find(prev); }
	          if (!found) {
	            // SearchCursor may have returned null because it hit EOF, wrap
	            // around and try again.
	            cursor = cm.getSearchCursor(query,
	                (prev) ? Pos(cm.lastLine()) : Pos(cm.firstLine(), 0) );
	            if (!cursor.find(prev)) {
	              return;
	            }
	          }
	        }
	        return cursor.from();
	      });
	    }
	    function clearSearchHighlight(cm) {
	      var state = getSearchState(cm);
	      cm.removeOverlay(getSearchState(cm).getOverlay());
	      state.setOverlay(null);
	      if (state.getScrollbarAnnotate()) {
	        state.getScrollbarAnnotate().clear();
	        state.setScrollbarAnnotate(null);
	      }
	    }
	    /**
	     * Check if pos is in the specified range, INCLUSIVE.
	     * Range can be specified with 1 or 2 arguments.
	     * If the first range argument is an array, treat it as an array of line
	     * numbers. Match pos against any of the lines.
	     * If the first range argument is a number,
	     *   if there is only 1 range argument, check if pos has the same line
	     *       number
	     *   if there are 2 range arguments, then check if pos is in between the two
	     *       range arguments.
	     */
	    function isInRange(pos, start, end) {
	      if (typeof pos != 'number') {
	        // Assume it is a cursor position. Get the line number.
	        pos = pos.line;
	      }
	      if (start instanceof Array) {
	        return inArray(pos, start);
	      } else {
	        if (end) {
	          return (pos >= start && pos <= end);
	        } else {
	          return pos == start;
	        }
	      }
	    }
	    function getUserVisibleLines(cm) {
	      var scrollInfo = cm.getScrollInfo();
	      var occludeToleranceTop = 6;
	      var occludeToleranceBottom = 10;
	      var from = cm.coordsChar({left:0, top: occludeToleranceTop + scrollInfo.top}, 'local');
	      var bottomY = scrollInfo.clientHeight - occludeToleranceBottom + scrollInfo.top;
	      var to = cm.coordsChar({left:0, top: bottomY}, 'local');
	      return {top: from.line, bottom: to.line};
	    }
	
	    var ExCommandDispatcher = function() {
	      this.buildCommandMap_();
	    };
	    ExCommandDispatcher.prototype = {
	      processCommand: function(cm, input, opt_params) {
	        var that = this;
	        cm.operation(function () {
	          cm.curOp.isVimOp = true;
	          that._processCommand(cm, input, opt_params);
	        });
	      },
	      _processCommand: function(cm, input, opt_params) {
	        var vim = cm.state.vim;
	        var commandHistoryRegister = vimGlobalState.registerController.getRegister(':');
	        var previousCommand = commandHistoryRegister.toString();
	        if (vim.visualMode) {
	          exitVisualMode(cm);
	        }
	        var inputStream = new CodeMirror.StringStream(input);
	        // update ": with the latest command whether valid or invalid
	        commandHistoryRegister.setText(input);
	        var params = opt_params || {};
	        params.input = input;
	        try {
	          this.parseInput_(cm, inputStream, params);
	        } catch(e) {
	          showConfirm(cm, e);
	          throw e;
	        }
	        var command;
	        var commandName;
	        if (!params.commandName) {
	          // If only a line range is defined, move to the line.
	          if (params.line !== undefined) {
	            commandName = 'move';
	          }
	        } else {
	          command = this.matchCommand_(params.commandName);
	          if (command) {
	            commandName = command.name;
	            if (command.excludeFromCommandHistory) {
	              commandHistoryRegister.setText(previousCommand);
	            }
	            this.parseCommandArgs_(inputStream, params, command);
	            if (command.type == 'exToKey') {
	              // Handle Ex to Key mapping.
	              for (var i = 0; i < command.toKeys.length; i++) {
	                CodeMirror.Vim.handleKey(cm, command.toKeys[i], 'mapping');
	              }
	              return;
	            } else if (command.type == 'exToEx') {
	              // Handle Ex to Ex mapping.
	              this.processCommand(cm, command.toInput);
	              return;
	            }
	          }
	        }
	        if (!commandName) {
	          showConfirm(cm, 'Not an editor command ":' + input + '"');
	          return;
	        }
	        try {
	          exCommands[commandName](cm, params);
	          // Possibly asynchronous commands (e.g. substitute, which might have a
	          // user confirmation), are responsible for calling the callback when
	          // done. All others have it taken care of for them here.
	          if ((!command || !command.possiblyAsync) && params.callback) {
	            params.callback();
	          }
	        } catch(e) {
	          showConfirm(cm, e);
	          throw e;
	        }
	      },
	      parseInput_: function(cm, inputStream, result) {
	        inputStream.eatWhile(':');
	        // Parse range.
	        if (inputStream.eat('%')) {
	          result.line = cm.firstLine();
	          result.lineEnd = cm.lastLine();
	        } else {
	          result.line = this.parseLineSpec_(cm, inputStream);
	          if (result.line !== undefined && inputStream.eat(',')) {
	            result.lineEnd = this.parseLineSpec_(cm, inputStream);
	          }
	        }
	
	        // Parse command name.
	        var commandMatch = inputStream.match(/^(\w+)/);
	        if (commandMatch) {
	          result.commandName = commandMatch[1];
	        } else {
	          result.commandName = inputStream.match(/.*/)[0];
	        }
	
	        return result;
	      },
	      parseLineSpec_: function(cm, inputStream) {
	        var numberMatch = inputStream.match(/^(\d+)/);
	        if (numberMatch) {
	          return parseInt(numberMatch[1], 10) - 1;
	        }
	        switch (inputStream.next()) {
	          case '.':
	            return cm.getCursor().line;
	          case '$':
	            return cm.lastLine();
	          case '\'':
	            var mark = cm.state.vim.marks[inputStream.next()];
	            if (mark && mark.find()) {
	              return mark.find().line;
	            }
	            throw new Error('Mark not set');
	          default:
	            inputStream.backUp(1);
	            return undefined;
	        }
	      },
	      parseCommandArgs_: function(inputStream, params, command) {
	        if (inputStream.eol()) {
	          return;
	        }
	        params.argString = inputStream.match(/.*/)[0];
	        // Parse command-line arguments
	        var delim = command.argDelimiter || /\s+/;
	        var args = trim(params.argString).split(delim);
	        if (args.length && args[0]) {
	          params.args = args;
	        }
	      },
	      matchCommand_: function(commandName) {
	        // Return the command in the command map that matches the shortest
	        // prefix of the passed in command name. The match is guaranteed to be
	        // unambiguous if the defaultExCommandMap's shortNames are set up
	        // correctly. (see @code{defaultExCommandMap}).
	        for (var i = commandName.length; i > 0; i--) {
	          var prefix = commandName.substring(0, i);
	          if (this.commandMap_[prefix]) {
	            var command = this.commandMap_[prefix];
	            if (command.name.indexOf(commandName) === 0) {
	              return command;
	            }
	          }
	        }
	        return null;
	      },
	      buildCommandMap_: function() {
	        this.commandMap_ = {};
	        for (var i = 0; i < defaultExCommandMap.length; i++) {
	          var command = defaultExCommandMap[i];
	          var key = command.shortName || command.name;
	          this.commandMap_[key] = command;
	        }
	      },
	      map: function(lhs, rhs, ctx) {
	        if (lhs != ':' && lhs.charAt(0) == ':') {
	          if (ctx) { throw Error('Mode not supported for ex mappings'); }
	          var commandName = lhs.substring(1);
	          if (rhs != ':' && rhs.charAt(0) == ':') {
	            // Ex to Ex mapping
	            this.commandMap_[commandName] = {
	              name: commandName,
	              type: 'exToEx',
	              toInput: rhs.substring(1),
	              user: true
	            };
	          } else {
	            // Ex to key mapping
	            this.commandMap_[commandName] = {
	              name: commandName,
	              type: 'exToKey',
	              toKeys: rhs,
	              user: true
	            };
	          }
	        } else {
	          if (rhs != ':' && rhs.charAt(0) == ':') {
	            // Key to Ex mapping.
	            var mapping = {
	              keys: lhs,
	              type: 'keyToEx',
	              exArgs: { input: rhs.substring(1) },
	              user: true};
	            if (ctx) { mapping.context = ctx; }
	            defaultKeymap.unshift(mapping);
	          } else {
	            // Key to key mapping
	            var mapping = {
	              keys: lhs,
	              type: 'keyToKey',
	              toKeys: rhs,
	              user: true
	            };
	            if (ctx) { mapping.context = ctx; }
	            defaultKeymap.unshift(mapping);
	          }
	        }
	      },
	      unmap: function(lhs, ctx) {
	        if (lhs != ':' && lhs.charAt(0) == ':') {
	          // Ex to Ex or Ex to key mapping
	          if (ctx) { throw Error('Mode not supported for ex mappings'); }
	          var commandName = lhs.substring(1);
	          if (this.commandMap_[commandName] && this.commandMap_[commandName].user) {
	            delete this.commandMap_[commandName];
	            return;
	          }
	        } else {
	          // Key to Ex or key to key mapping
	          var keys = lhs;
	          for (var i = 0; i < defaultKeymap.length; i++) {
	            if (keys == defaultKeymap[i].keys
	                && defaultKeymap[i].context === ctx
	                && defaultKeymap[i].user) {
	              defaultKeymap.splice(i, 1);
	              return;
	            }
	          }
	        }
	        throw Error('No such mapping.');
	      }
	    };
	
	    var exCommands = {
	      colorscheme: function(cm, params) {
	        if (!params.args || params.args.length < 1) {
	          showConfirm(cm, cm.getOption('theme'));
	          return;
	        }
	        cm.setOption('theme', params.args[0]);
	      },
	      map: function(cm, params, ctx) {
	        var mapArgs = params.args;
	        if (!mapArgs || mapArgs.length < 2) {
	          if (cm) {
	            showConfirm(cm, 'Invalid mapping: ' + params.input);
	          }
	          return;
	        }
	        exCommandDispatcher.map(mapArgs[0], mapArgs[1], ctx);
	      },
	      imap: function(cm, params) { this.map(cm, params, 'insert'); },
	      nmap: function(cm, params) { this.map(cm, params, 'normal'); },
	      vmap: function(cm, params) { this.map(cm, params, 'visual'); },
	      unmap: function(cm, params, ctx) {
	        var mapArgs = params.args;
	        if (!mapArgs || mapArgs.length < 1) {
	          if (cm) {
	            showConfirm(cm, 'No such mapping: ' + params.input);
	          }
	          return;
	        }
	        exCommandDispatcher.unmap(mapArgs[0], ctx);
	      },
	      move: function(cm, params) {
	        commandDispatcher.processCommand(cm, cm.state.vim, {
	            type: 'motion',
	            motion: 'moveToLineOrEdgeOfDocument',
	            motionArgs: { forward: false, explicitRepeat: true,
	              linewise: true },
	            repeatOverride: params.line+1});
	      },
	      set: function(cm, params) {
	        var setArgs = params.args;
	        // Options passed through to the setOption/getOption calls. May be passed in by the
	        // local/global versions of the set command
	        var setCfg = params.setCfg || {};
	        if (!setArgs || setArgs.length < 1) {
	          if (cm) {
	            showConfirm(cm, 'Invalid mapping: ' + params.input);
	          }
	          return;
	        }
	        var expr = setArgs[0].split('=');
	        var optionName = expr[0];
	        var value = expr[1];
	        var forceGet = false;
	
	        if (optionName.charAt(optionName.length - 1) == '?') {
	          // If post-fixed with ?, then the set is actually a get.
	          if (value) { throw Error('Trailing characters: ' + params.argString); }
	          optionName = optionName.substring(0, optionName.length - 1);
	          forceGet = true;
	        }
	        if (value === undefined && optionName.substring(0, 2) == 'no') {
	          // To set boolean options to false, the option name is prefixed with
	          // 'no'.
	          optionName = optionName.substring(2);
	          value = false;
	        }
	
	        var optionIsBoolean = options[optionName] && options[optionName].type == 'boolean';
	        if (optionIsBoolean && value == undefined) {
	          // Calling set with a boolean option sets it to true.
	          value = true;
	        }
	        // If no value is provided, then we assume this is a get.
	        if (!optionIsBoolean && value === undefined || forceGet) {
	          var oldValue = getOption(optionName, cm, setCfg);
	          if (oldValue === true || oldValue === false) {
	            showConfirm(cm, ' ' + (oldValue ? '' : 'no') + optionName);
	          } else {
	            showConfirm(cm, '  ' + optionName + '=' + oldValue);
	          }
	        } else {
	          setOption(optionName, value, cm, setCfg);
	        }
	      },
	      setlocal: function (cm, params) {
	        // setCfg is passed through to setOption
	        params.setCfg = {scope: 'local'};
	        this.set(cm, params);
	      },
	      setglobal: function (cm, params) {
	        // setCfg is passed through to setOption
	        params.setCfg = {scope: 'global'};
	        this.set(cm, params);
	      },
	      registers: function(cm, params) {
	        var regArgs = params.args;
	        var registers = vimGlobalState.registerController.registers;
	        var regInfo = '----------Registers----------<br><br>';
	        if (!regArgs) {
	          for (var registerName in registers) {
	            var text = registers[registerName].toString();
	            if (text.length) {
	              regInfo += '"' + registerName + '    ' + text + '<br>';
	            }
	          }
	        } else {
	          var registerName;
	          regArgs = regArgs.join('');
	          for (var i = 0; i < regArgs.length; i++) {
	            registerName = regArgs.charAt(i);
	            if (!vimGlobalState.registerController.isValidRegister(registerName)) {
	              continue;
	            }
	            var register = registers[registerName] || new Register();
	            regInfo += '"' + registerName + '    ' + register.toString() + '<br>';
	          }
	        }
	        showConfirm(cm, regInfo);
	      },
	      sort: function(cm, params) {
	        var reverse, ignoreCase, unique, number;
	        function parseArgs() {
	          if (params.argString) {
	            var args = new CodeMirror.StringStream(params.argString);
	            if (args.eat('!')) { reverse = true; }
	            if (args.eol()) { return; }
	            if (!args.eatSpace()) { return 'Invalid arguments'; }
	            var opts = args.match(/[a-z]+/);
	            if (opts) {
	              opts = opts[0];
	              ignoreCase = opts.indexOf('i') != -1;
	              unique = opts.indexOf('u') != -1;
	              var decimal = opts.indexOf('d') != -1 && 1;
	              var hex = opts.indexOf('x') != -1 && 1;
	              var octal = opts.indexOf('o') != -1 && 1;
	              if (decimal + hex + octal > 1) { return 'Invalid arguments'; }
	              number = decimal && 'decimal' || hex && 'hex' || octal && 'octal';
	            }
	            if (args.match(/\/.*\//)) { return 'patterns not supported'; }
	          }
	        }
	        var err = parseArgs();
	        if (err) {
	          showConfirm(cm, err + ': ' + params.argString);
	          return;
	        }
	        var lineStart = params.line || cm.firstLine();
	        var lineEnd = params.lineEnd || params.line || cm.lastLine();
	        if (lineStart == lineEnd) { return; }
	        var curStart = Pos(lineStart, 0);
	        var curEnd = Pos(lineEnd, lineLength(cm, lineEnd));
	        var text = cm.getRange(curStart, curEnd).split('\n');
	        var numberRegex = (number == 'decimal') ? /(-?)([\d]+)/ :
	           (number == 'hex') ? /(-?)(?:0x)?([0-9a-f]+)/i :
	           (number == 'octal') ? /([0-7]+)/ : null;
	        var radix = (number == 'decimal') ? 10 : (number == 'hex') ? 16 : (number == 'octal') ? 8 : null;
	        var numPart = [], textPart = [];
	        if (number) {
	          for (var i = 0; i < text.length; i++) {
	            if (numberRegex.exec(text[i])) {
	              numPart.push(text[i]);
	            } else {
	              textPart.push(text[i]);
	            }
	          }
	        } else {
	          textPart = text;
	        }
	        function compareFn(a, b) {
	          if (reverse) { var tmp; tmp = a; a = b; b = tmp; }
	          if (ignoreCase) { a = a.toLowerCase(); b = b.toLowerCase(); }
	          var anum = number && numberRegex.exec(a);
	          var bnum = number && numberRegex.exec(b);
	          if (!anum) { return a < b ? -1 : 1; }
	          anum = parseInt((anum[1] + anum[2]).toLowerCase(), radix);
	          bnum = parseInt((bnum[1] + bnum[2]).toLowerCase(), radix);
	          return anum - bnum;
	        }
	        numPart.sort(compareFn);
	        textPart.sort(compareFn);
	        text = (!reverse) ? textPart.concat(numPart) : numPart.concat(textPart);
	        if (unique) { // Remove duplicate lines
	          var textOld = text;
	          var lastLine;
	          text = [];
	          for (var i = 0; i < textOld.length; i++) {
	            if (textOld[i] != lastLine) {
	              text.push(textOld[i]);
	            }
	            lastLine = textOld[i];
	          }
	        }
	        cm.replaceRange(text.join('\n'), curStart, curEnd);
	      },
	      global: function(cm, params) {
	        // a global command is of the form
	        // :[range]g/pattern/[cmd]
	        // argString holds the string /pattern/[cmd]
	        var argString = params.argString;
	        if (!argString) {
	          showConfirm(cm, 'Regular Expression missing from global');
	          return;
	        }
	        // range is specified here
	        var lineStart = (params.line !== undefined) ? params.line : cm.firstLine();
	        var lineEnd = params.lineEnd || params.line || cm.lastLine();
	        // get the tokens from argString
	        var tokens = splitBySlash(argString);
	        var regexPart = argString, cmd;
	        if (tokens.length) {
	          regexPart = tokens[0];
	          cmd = tokens.slice(1, tokens.length).join('/');
	        }
	        if (regexPart) {
	          // If regex part is empty, then use the previous query. Otherwise
	          // use the regex part as the new query.
	          try {
	           updateSearchQuery(cm, regexPart, true /** ignoreCase */,
	             true /** smartCase */);
	          } catch (e) {
	           showConfirm(cm, 'Invalid regex: ' + regexPart);
	           return;
	          }
	        }
	        // now that we have the regexPart, search for regex matches in the
	        // specified range of lines
	        var query = getSearchState(cm).getQuery();
	        var matchedLines = [], content = '';
	        for (var i = lineStart; i <= lineEnd; i++) {
	          var matched = query.test(cm.getLine(i));
	          if (matched) {
	            matchedLines.push(i+1);
	            content+= cm.getLine(i) + '<br>';
	          }
	        }
	        // if there is no [cmd], just display the list of matched lines
	        if (!cmd) {
	          showConfirm(cm, content);
	          return;
	        }
	        var index = 0;
	        var nextCommand = function() {
	          if (index < matchedLines.length) {
	            var command = matchedLines[index] + cmd;
	            exCommandDispatcher.processCommand(cm, command, {
	              callback: nextCommand
	            });
	          }
	          index++;
	        };
	        nextCommand();
	      },
	      substitute: function(cm, params) {
	        if (!cm.getSearchCursor) {
	          throw new Error('Search feature not available. Requires searchcursor.js or ' +
	              'any other getSearchCursor implementation.');
	        }
	        var argString = params.argString;
	        var tokens = argString ? splitBySlash(argString) : [];
	        var regexPart, replacePart = '', trailing, flagsPart, count;
	        var confirm = false; // Whether to confirm each replace.
	        var global = false; // True to replace all instances on a line, false to replace only 1.
	        if (tokens.length) {
	          regexPart = tokens[0];
	          replacePart = tokens[1];
	          if (replacePart !== undefined) {
	            if (getOption('pcre')) {
	              replacePart = unescapeRegexReplace(replacePart);
	            } else {
	              replacePart = translateRegexReplace(replacePart);
	            }
	            vimGlobalState.lastSubstituteReplacePart = replacePart;
	          }
	          trailing = tokens[2] ? tokens[2].split(' ') : [];
	        } else {
	          // either the argString is empty or its of the form ' hello/world'
	          // actually splitBySlash returns a list of tokens
	          // only if the string starts with a '/'
	          if (argString && argString.length) {
	            showConfirm(cm, 'Substitutions should be of the form ' +
	                ':s/pattern/replace/');
	            return;
	          }
	        }
	        // After the 3rd slash, we can have flags followed by a space followed
	        // by count.
	        if (trailing) {
	          flagsPart = trailing[0];
	          count = parseInt(trailing[1]);
	          if (flagsPart) {
	            if (flagsPart.indexOf('c') != -1) {
	              confirm = true;
	              flagsPart.replace('c', '');
	            }
	            if (flagsPart.indexOf('g') != -1) {
	              global = true;
	              flagsPart.replace('g', '');
	            }
	            regexPart = regexPart + '/' + flagsPart;
	          }
	        }
	        if (regexPart) {
	          // If regex part is empty, then use the previous query. Otherwise use
	          // the regex part as the new query.
	          try {
	            updateSearchQuery(cm, regexPart, true /** ignoreCase */,
	              true /** smartCase */);
	          } catch (e) {
	            showConfirm(cm, 'Invalid regex: ' + regexPart);
	            return;
	          }
	        }
	        replacePart = replacePart || vimGlobalState.lastSubstituteReplacePart;
	        if (replacePart === undefined) {
	          showConfirm(cm, 'No previous substitute regular expression');
	          return;
	        }
	        var state = getSearchState(cm);
	        var query = state.getQuery();
	        var lineStart = (params.line !== undefined) ? params.line : cm.getCursor().line;
	        var lineEnd = params.lineEnd || lineStart;
	        if (lineStart == cm.firstLine() && lineEnd == cm.lastLine()) {
	          lineEnd = Infinity;
	        }
	        if (count) {
	          lineStart = lineEnd;
	          lineEnd = lineStart + count - 1;
	        }
	        var startPos = clipCursorToContent(cm, Pos(lineStart, 0));
	        var cursor = cm.getSearchCursor(query, startPos);
	        doReplace(cm, confirm, global, lineStart, lineEnd, cursor, query, replacePart, params.callback);
	      },
	      redo: CodeMirror.commands.redo,
	      undo: CodeMirror.commands.undo,
	      write: function(cm) {
	        if (CodeMirror.commands.save) {
	          // If a save command is defined, call it.
	          CodeMirror.commands.save(cm);
	        } else if (cm.save) {
	          // Saves to text area if no save command is defined and cm.save() is available.
	          cm.save();
	        }
	      },
	      nohlsearch: function(cm) {
	        clearSearchHighlight(cm);
	      },
	      yank: function (cm) {
	        var cur = copyCursor(cm.getCursor());
	        var line = cur.line;
	        var lineText = cm.getLine(line);
	        vimGlobalState.registerController.pushText(
	          '0', 'yank', lineText, true, true);
	      },
	      delmarks: function(cm, params) {
	        if (!params.argString || !trim(params.argString)) {
	          showConfirm(cm, 'Argument required');
	          return;
	        }
	
	        var state = cm.state.vim;
	        var stream = new CodeMirror.StringStream(trim(params.argString));
	        while (!stream.eol()) {
	          stream.eatSpace();
	
	          // Record the streams position at the beginning of the loop for use
	          // in error messages.
	          var count = stream.pos;
	
	          if (!stream.match(/[a-zA-Z]/, false)) {
	            showConfirm(cm, 'Invalid argument: ' + params.argString.substring(count));
	            return;
	          }
	
	          var sym = stream.next();
	          // Check if this symbol is part of a range
	          if (stream.match('-', true)) {
	            // This symbol is part of a range.
	
	            // The range must terminate at an alphabetic character.
	            if (!stream.match(/[a-zA-Z]/, false)) {
	              showConfirm(cm, 'Invalid argument: ' + params.argString.substring(count));
	              return;
	            }
	
	            var startMark = sym;
	            var finishMark = stream.next();
	            // The range must terminate at an alphabetic character which
	            // shares the same case as the start of the range.
	            if (isLowerCase(startMark) && isLowerCase(finishMark) ||
	                isUpperCase(startMark) && isUpperCase(finishMark)) {
	              var start = startMark.charCodeAt(0);
	              var finish = finishMark.charCodeAt(0);
	              if (start >= finish) {
	                showConfirm(cm, 'Invalid argument: ' + params.argString.substring(count));
	                return;
	              }
	
	              // Because marks are always ASCII values, and we have
	              // determined that they are the same case, we can use
	              // their char codes to iterate through the defined range.
	              for (var j = 0; j <= finish - start; j++) {
	                var mark = String.fromCharCode(start + j);
	                delete state.marks[mark];
	              }
	            } else {
	              showConfirm(cm, 'Invalid argument: ' + startMark + '-');
	              return;
	            }
	          } else {
	            // This symbol is a valid mark, and is not part of a range.
	            delete state.marks[sym];
	          }
	        }
	      }
	    };
	
	    var exCommandDispatcher = new ExCommandDispatcher();
	
	    /**
	    * @param {CodeMirror} cm CodeMirror instance we are in.
	    * @param {boolean} confirm Whether to confirm each replace.
	    * @param {Cursor} lineStart Line to start replacing from.
	    * @param {Cursor} lineEnd Line to stop replacing at.
	    * @param {RegExp} query Query for performing matches with.
	    * @param {string} replaceWith Text to replace matches with. May contain $1,
	    *     $2, etc for replacing captured groups using Javascript replace.
	    * @param {function()} callback A callback for when the replace is done.
	    */
	    function doReplace(cm, confirm, global, lineStart, lineEnd, searchCursor, query,
	        replaceWith, callback) {
	      // Set up all the functions.
	      cm.state.vim.exMode = true;
	      var done = false;
	      var lastPos = searchCursor.from();
	      function replaceAll() {
	        cm.operation(function() {
	          while (!done) {
	            replace();
	            next();
	          }
	          stop();
	        });
	      }
	      function replace() {
	        var text = cm.getRange(searchCursor.from(), searchCursor.to());
	        var newText = text.replace(query, replaceWith);
	        searchCursor.replace(newText);
	      }
	      function next() {
	        // The below only loops to skip over multiple occurrences on the same
	        // line when 'global' is not true.
	        while(searchCursor.findNext() &&
	              isInRange(searchCursor.from(), lineStart, lineEnd)) {
	          if (!global && lastPos && searchCursor.from().line == lastPos.line) {
	            continue;
	          }
	          cm.scrollIntoView(searchCursor.from(), 30);
	          cm.setSelection(searchCursor.from(), searchCursor.to());
	          lastPos = searchCursor.from();
	          done = false;
	          return;
	        }
	        done = true;
	      }
	      function stop(close) {
	        if (close) { close(); }
	        cm.focus();
	        if (lastPos) {
	          cm.setCursor(lastPos);
	          var vim = cm.state.vim;
	          vim.exMode = false;
	          vim.lastHPos = vim.lastHSPos = lastPos.ch;
	        }
	        if (callback) { callback(); }
	      }
	      function onPromptKeyDown(e, _value, close) {
	        // Swallow all keys.
	        CodeMirror.e_stop(e);
	        var keyName = CodeMirror.keyName(e);
	        switch (keyName) {
	          case 'Y':
	            replace(); next(); break;
	          case 'N':
	            next(); break;
	          case 'A':
	            // replaceAll contains a call to close of its own. We don't want it
	            // to fire too early or multiple times.
	            var savedCallback = callback;
	            callback = undefined;
	            cm.operation(replaceAll);
	            callback = savedCallback;
	            break;
	          case 'L':
	            replace();
	            // fall through and exit.
	          case 'Q':
	          case 'Esc':
	          case 'Ctrl-C':
	          case 'Ctrl-[':
	            stop(close);
	            break;
	        }
	        if (done) { stop(close); }
	        return true;
	      }
	
	      // Actually do replace.
	      next();
	      if (done) {
	        showConfirm(cm, 'No matches for ' + query.source);
	        return;
	      }
	      if (!confirm) {
	        replaceAll();
	        if (callback) { callback(); };
	        return;
	      }
	      showPrompt(cm, {
	        prefix: 'replace with <strong>' + replaceWith + '</strong> (y/n/a/q/l)',
	        onKeyDown: onPromptKeyDown
	      });
	    }
	
	    CodeMirror.keyMap.vim = {
	      attach: attachVimMap,
	      detach: detachVimMap,
	      call: cmKey
	    };
	
	    function exitInsertMode(cm) {
	      var vim = cm.state.vim;
	      var macroModeState = vimGlobalState.macroModeState;
	      var insertModeChangeRegister = vimGlobalState.registerController.getRegister('.');
	      var isPlaying = macroModeState.isPlaying;
	      var lastChange = macroModeState.lastInsertModeChanges;
	      // In case of visual block, the insertModeChanges are not saved as a
	      // single word, so we convert them to a single word
	      // so as to update the ". register as expected in real vim.
	      var text = [];
	      if (!isPlaying) {
	        var selLength = lastChange.inVisualBlock ? vim.lastSelection.visualBlock.height : 1;
	        var changes = lastChange.changes;
	        var text = [];
	        var i = 0;
	        // In case of multiple selections in blockwise visual,
	        // the inserted text, for example: 'f<Backspace>oo', is stored as
	        // 'f', 'f', InsertModeKey 'o', 'o', 'o', 'o'. (if you have a block with 2 lines).
	        // We push the contents of the changes array as per the following:
	        // 1. In case of InsertModeKey, just increment by 1.
	        // 2. In case of a character, jump by selLength (2 in the example).
	        while (i < changes.length) {
	          // This loop will convert 'ff<bs>oooo' to 'f<bs>oo'.
	          text.push(changes[i]);
	          if (changes[i] instanceof InsertModeKey) {
	             i++;
	          } else {
	             i+= selLength;
	          }
	        }
	        lastChange.changes = text;
	        cm.off('change', onChange);
	        CodeMirror.off(cm.getInputField(), 'keydown', onKeyEventTargetKeyDown);
	      }
	      if (!isPlaying && vim.insertModeRepeat > 1) {
	        // Perform insert mode repeat for commands like 3,a and 3,o.
	        repeatLastEdit(cm, vim, vim.insertModeRepeat - 1,
	            true /** repeatForInsert */);
	        vim.lastEditInputState.repeatOverride = vim.insertModeRepeat;
	      }
	      delete vim.insertModeRepeat;
	      vim.insertMode = false;
	      cm.setCursor(cm.getCursor().line, cm.getCursor().ch-1);
	      cm.setOption('keyMap', 'vim');
	      cm.setOption('disableInput', true);
	      cm.toggleOverwrite(false); // exit replace mode if we were in it.
	      // update the ". register before exiting insert mode
	      insertModeChangeRegister.setText(lastChange.changes.join(''));
	      CodeMirror.signal(cm, "vim-mode-change", {mode: "normal"});
	      if (macroModeState.isRecording) {
	        logInsertModeChange(macroModeState);
	      }
	    }
	
	    function _mapCommand(command) {
	      defaultKeymap.unshift(command);
	    }
	
	    function mapCommand(keys, type, name, args, extra) {
	      var command = {keys: keys, type: type};
	      command[type] = name;
	      command[type + "Args"] = args;
	      for (var key in extra)
	        command[key] = extra[key];
	      _mapCommand(command);
	    }
	
	    // The timeout in milliseconds for the two-character ESC keymap should be
	    // adjusted according to your typing speed to prevent false positives.
	    defineOption('insertModeEscKeysTimeout', 200, 'number');
	
	    CodeMirror.keyMap['vim-insert'] = {
	      // TODO: override navigation keys so that Esc will cancel automatic
	      // indentation from o, O, i_<CR>
	      fallthrough: ['default'],
	      attach: attachVimMap,
	      detach: detachVimMap,
	      call: cmKey
	    };
	
	    CodeMirror.keyMap['vim-replace'] = {
	      'Backspace': 'goCharLeft',
	      fallthrough: ['vim-insert'],
	      attach: attachVimMap,
	      detach: detachVimMap,
	      call: cmKey
	    };
	
	    function executeMacroRegister(cm, vim, macroModeState, registerName) {
	      var register = vimGlobalState.registerController.getRegister(registerName);
	      if (registerName == ':') {
	        // Read-only register containing last Ex command.
	        if (register.keyBuffer[0]) {
	          exCommandDispatcher.processCommand(cm, register.keyBuffer[0]);
	        }
	        macroModeState.isPlaying = false;
	        return;
	      }
	      var keyBuffer = register.keyBuffer;
	      var imc = 0;
	      macroModeState.isPlaying = true;
	      macroModeState.replaySearchQueries = register.searchQueries.slice(0);
	      for (var i = 0; i < keyBuffer.length; i++) {
	        var text = keyBuffer[i];
	        var match, key;
	        while (text) {
	          // Pull off one command key, which is either a single character
	          // or a special sequence wrapped in '<' and '>', e.g. '<Space>'.
	          match = (/<\w+-.+?>|<\w+>|./).exec(text);
	          key = match[0];
	          text = text.substring(match.index + key.length);
	          CodeMirror.Vim.handleKey(cm, key, 'macro');
	          if (vim.insertMode) {
	            var changes = register.insertModeChanges[imc++].changes;
	            vimGlobalState.macroModeState.lastInsertModeChanges.changes =
	                changes;
	            repeatInsertModeChanges(cm, changes, 1);
	            exitInsertMode(cm);
	          }
	        }
	      };
	      macroModeState.isPlaying = false;
	    }
	
	    function logKey(macroModeState, key) {
	      if (macroModeState.isPlaying) { return; }
	      var registerName = macroModeState.latestRegister;
	      var register = vimGlobalState.registerController.getRegister(registerName);
	      if (register) {
	        register.pushText(key);
	      }
	    }
	
	    function logInsertModeChange(macroModeState) {
	      if (macroModeState.isPlaying) { return; }
	      var registerName = macroModeState.latestRegister;
	      var register = vimGlobalState.registerController.getRegister(registerName);
	      if (register && register.pushInsertModeChanges) {
	        register.pushInsertModeChanges(macroModeState.lastInsertModeChanges);
	      }
	    }
	
	    function logSearchQuery(macroModeState, query) {
	      if (macroModeState.isPlaying) { return; }
	      var registerName = macroModeState.latestRegister;
	      var register = vimGlobalState.registerController.getRegister(registerName);
	      if (register && register.pushSearchQuery) {
	        register.pushSearchQuery(query);
	      }
	    }
	
	    /**
	     * Listens for changes made in insert mode.
	     * Should only be active in insert mode.
	     */
	    function onChange(_cm, changeObj) {
	      var macroModeState = vimGlobalState.macroModeState;
	      var lastChange = macroModeState.lastInsertModeChanges;
	      if (!macroModeState.isPlaying) {
	        while(changeObj) {
	          lastChange.expectCursorActivityForChange = true;
	          if (changeObj.origin == '+input' || changeObj.origin == 'paste'
	              || changeObj.origin === undefined /* only in testing */) {
	            var text = changeObj.text.join('\n');
	            if (lastChange.maybeReset) {
	              lastChange.changes = [];
	              lastChange.maybeReset = false;
	            }
	            lastChange.changes.push(text);
	          }
	          // Change objects may be chained with next.
	          changeObj = changeObj.next;
	        }
	      }
	    }
	
	    /**
	    * Listens for any kind of cursor activity on CodeMirror.
	    */
	    function onCursorActivity(cm) {
	      var vim = cm.state.vim;
	      if (vim.insertMode) {
	        // Tracking cursor activity in insert mode (for macro support).
	        var macroModeState = vimGlobalState.macroModeState;
	        if (macroModeState.isPlaying) { return; }
	        var lastChange = macroModeState.lastInsertModeChanges;
	        if (lastChange.expectCursorActivityForChange) {
	          lastChange.expectCursorActivityForChange = false;
	        } else {
	          // Cursor moved outside the context of an edit. Reset the change.
	          lastChange.maybeReset = true;
	        }
	      } else if (!cm.curOp.isVimOp) {
	        handleExternalSelection(cm, vim);
	      }
	      if (vim.visualMode) {
	        updateFakeCursor(cm);
	      }
	    }
	    function updateFakeCursor(cm) {
	      var vim = cm.state.vim;
	      var from = clipCursorToContent(cm, copyCursor(vim.sel.head));
	      var to = offsetCursor(from, 0, 1);
	      if (vim.fakeCursor) {
	        vim.fakeCursor.clear();
	      }
	      vim.fakeCursor = cm.markText(from, to, {className: 'cm-animate-fat-cursor'});
	    }
	    function handleExternalSelection(cm, vim) {
	      var anchor = cm.getCursor('anchor');
	      var head = cm.getCursor('head');
	      // Enter or exit visual mode to match mouse selection.
	      if (vim.visualMode && !cm.somethingSelected()) {
	        exitVisualMode(cm, false);
	      } else if (!vim.visualMode && !vim.insertMode && cm.somethingSelected()) {
	        vim.visualMode = true;
	        vim.visualLine = false;
	        CodeMirror.signal(cm, "vim-mode-change", {mode: "visual"});
	      }
	      if (vim.visualMode) {
	        // Bind CodeMirror selection model to vim selection model.
	        // Mouse selections are considered visual characterwise.
	        var headOffset = !cursorIsBefore(head, anchor) ? -1 : 0;
	        var anchorOffset = cursorIsBefore(head, anchor) ? -1 : 0;
	        head = offsetCursor(head, 0, headOffset);
	        anchor = offsetCursor(anchor, 0, anchorOffset);
	        vim.sel = {
	          anchor: anchor,
	          head: head
	        };
	        updateMark(cm, vim, '<', cursorMin(head, anchor));
	        updateMark(cm, vim, '>', cursorMax(head, anchor));
	      } else if (!vim.insertMode) {
	        // Reset lastHPos if selection was modified by something outside of vim mode e.g. by mouse.
	        vim.lastHPos = cm.getCursor().ch;
	      }
	    }
	
	    /** Wrapper for special keys pressed in insert mode */
	    function InsertModeKey(keyName) {
	      this.keyName = keyName;
	    }
	
	    /**
	    * Handles raw key down events from the text area.
	    * - Should only be active in insert mode.
	    * - For recording deletes in insert mode.
	    */
	    function onKeyEventTargetKeyDown(e) {
	      var macroModeState = vimGlobalState.macroModeState;
	      var lastChange = macroModeState.lastInsertModeChanges;
	      var keyName = CodeMirror.keyName(e);
	      if (!keyName) { return; }
	      function onKeyFound() {
	        if (lastChange.maybeReset) {
	          lastChange.changes = [];
	          lastChange.maybeReset = false;
	        }
	        lastChange.changes.push(new InsertModeKey(keyName));
	        return true;
	      }
	      if (keyName.indexOf('Delete') != -1 || keyName.indexOf('Backspace') != -1) {
	        CodeMirror.lookupKey(keyName, 'vim-insert', onKeyFound);
	      }
	    }
	
	    /**
	     * Repeats the last edit, which includes exactly 1 command and at most 1
	     * insert. Operator and motion commands are read from lastEditInputState,
	     * while action commands are read from lastEditActionCommand.
	     *
	     * If repeatForInsert is true, then the function was called by
	     * exitInsertMode to repeat the insert mode changes the user just made. The
	     * corresponding enterInsertMode call was made with a count.
	     */
	    function repeatLastEdit(cm, vim, repeat, repeatForInsert) {
	      var macroModeState = vimGlobalState.macroModeState;
	      macroModeState.isPlaying = true;
	      var isAction = !!vim.lastEditActionCommand;
	      var cachedInputState = vim.inputState;
	      function repeatCommand() {
	        if (isAction) {
	          commandDispatcher.processAction(cm, vim, vim.lastEditActionCommand);
	        } else {
	          commandDispatcher.evalInput(cm, vim);
	        }
	      }
	      function repeatInsert(repeat) {
	        if (macroModeState.lastInsertModeChanges.changes.length > 0) {
	          // For some reason, repeat cw in desktop VIM does not repeat
	          // insert mode changes. Will conform to that behavior.
	          repeat = !vim.lastEditActionCommand ? 1 : repeat;
	          var changeObject = macroModeState.lastInsertModeChanges;
	          repeatInsertModeChanges(cm, changeObject.changes, repeat);
	        }
	      }
	      vim.inputState = vim.lastEditInputState;
	      if (isAction && vim.lastEditActionCommand.interlaceInsertRepeat) {
	        // o and O repeat have to be interlaced with insert repeats so that the
	        // insertions appear on separate lines instead of the last line.
	        for (var i = 0; i < repeat; i++) {
	          repeatCommand();
	          repeatInsert(1);
	        }
	      } else {
	        if (!repeatForInsert) {
	          // Hack to get the cursor to end up at the right place. If I is
	          // repeated in insert mode repeat, cursor will be 1 insert
	          // change set left of where it should be.
	          repeatCommand();
	        }
	        repeatInsert(repeat);
	      }
	      vim.inputState = cachedInputState;
	      if (vim.insertMode && !repeatForInsert) {
	        // Don't exit insert mode twice. If repeatForInsert is set, then we
	        // were called by an exitInsertMode call lower on the stack.
	        exitInsertMode(cm);
	      }
	      macroModeState.isPlaying = false;
	    };
	
	    function repeatInsertModeChanges(cm, changes, repeat) {
	      function keyHandler(binding) {
	        if (typeof binding == 'string') {
	          CodeMirror.commands[binding](cm);
	        } else {
	          binding(cm);
	        }
	        return true;
	      }
	      var head = cm.getCursor('head');
	      var inVisualBlock = vimGlobalState.macroModeState.lastInsertModeChanges.inVisualBlock;
	      if (inVisualBlock) {
	        // Set up block selection again for repeating the changes.
	        var vim = cm.state.vim;
	        var lastSel = vim.lastSelection;
	        var offset = getOffset(lastSel.anchor, lastSel.head);
	        selectForInsert(cm, head, offset.line + 1);
	        repeat = cm.listSelections().length;
	        cm.setCursor(head);
	      }
	      for (var i = 0; i < repeat; i++) {
	        if (inVisualBlock) {
	          cm.setCursor(offsetCursor(head, i, 0));
	        }
	        for (var j = 0; j < changes.length; j++) {
	          var change = changes[j];
	          if (change instanceof InsertModeKey) {
	            CodeMirror.lookupKey(change.keyName, 'vim-insert', keyHandler);
	          } else {
	            var cur = cm.getCursor();
	            cm.replaceRange(change, cur, cur);
	          }
	        }
	      }
	      if (inVisualBlock) {
	        cm.setCursor(offsetCursor(head, 0, 1));
	      }
	    }
	
	    resetVimGlobalState();
	    return vimApi;
	  };
	  // Initialize Vim and make it available as an API.
	  CodeMirror.Vim = Vim();
	});


/***/ },
/* 150 */,
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("apl", function() {
	  var builtInOps = {
	    ".": "innerProduct",
	    "\\": "scan",
	    "/": "reduce",
	    "⌿": "reduce1Axis",
	    "⍀": "scan1Axis",
	    "¨": "each",
	    "⍣": "power"
	  };
	  var builtInFuncs = {
	    "+": ["conjugate", "add"],
	    "−": ["negate", "subtract"],
	    "×": ["signOf", "multiply"],
	    "÷": ["reciprocal", "divide"],
	    "⌈": ["ceiling", "greaterOf"],
	    "⌊": ["floor", "lesserOf"],
	    "∣": ["absolute", "residue"],
	    "⍳": ["indexGenerate", "indexOf"],
	    "?": ["roll", "deal"],
	    "⋆": ["exponentiate", "toThePowerOf"],
	    "⍟": ["naturalLog", "logToTheBase"],
	    "○": ["piTimes", "circularFuncs"],
	    "!": ["factorial", "binomial"],
	    "⌹": ["matrixInverse", "matrixDivide"],
	    "<": [null, "lessThan"],
	    "≤": [null, "lessThanOrEqual"],
	    "=": [null, "equals"],
	    ">": [null, "greaterThan"],
	    "≥": [null, "greaterThanOrEqual"],
	    "≠": [null, "notEqual"],
	    "≡": ["depth", "match"],
	    "≢": [null, "notMatch"],
	    "∈": ["enlist", "membership"],
	    "⍷": [null, "find"],
	    "∪": ["unique", "union"],
	    "∩": [null, "intersection"],
	    "∼": ["not", "without"],
	    "∨": [null, "or"],
	    "∧": [null, "and"],
	    "⍱": [null, "nor"],
	    "⍲": [null, "nand"],
	    "⍴": ["shapeOf", "reshape"],
	    ",": ["ravel", "catenate"],
	    "⍪": [null, "firstAxisCatenate"],
	    "⌽": ["reverse", "rotate"],
	    "⊖": ["axis1Reverse", "axis1Rotate"],
	    "⍉": ["transpose", null],
	    "↑": ["first", "take"],
	    "↓": [null, "drop"],
	    "⊂": ["enclose", "partitionWithAxis"],
	    "⊃": ["diclose", "pick"],
	    "⌷": [null, "index"],
	    "⍋": ["gradeUp", null],
	    "⍒": ["gradeDown", null],
	    "⊤": ["encode", null],
	    "⊥": ["decode", null],
	    "⍕": ["format", "formatByExample"],
	    "⍎": ["execute", null],
	    "⊣": ["stop", "left"],
	    "⊢": ["pass", "right"]
	  };
	
	  var isOperator = /[\.\/⌿⍀¨⍣]/;
	  var isNiladic = /⍬/;
	  var isFunction = /[\+−×÷⌈⌊∣⍳\?⋆⍟○!⌹<≤=>≥≠≡≢∈⍷∪∩∼∨∧⍱⍲⍴,⍪⌽⊖⍉↑↓⊂⊃⌷⍋⍒⊤⊥⍕⍎⊣⊢]/;
	  var isArrow = /←/;
	  var isComment = /[⍝#].*$/;
	
	  var stringEater = function(type) {
	    var prev;
	    prev = false;
	    return function(c) {
	      prev = c;
	      if (c === type) {
	        return prev === "\\";
	      }
	      return true;
	    };
	  };
	  return {
	    startState: function() {
	      return {
	        prev: false,
	        func: false,
	        op: false,
	        string: false,
	        escape: false
	      };
	    },
	    token: function(stream, state) {
	      var ch, funcName;
	      if (stream.eatSpace()) {
	        return null;
	      }
	      ch = stream.next();
	      if (ch === '"' || ch === "'") {
	        stream.eatWhile(stringEater(ch));
	        stream.next();
	        state.prev = true;
	        return "string";
	      }
	      if (/[\[{\(]/.test(ch)) {
	        state.prev = false;
	        return null;
	      }
	      if (/[\]}\)]/.test(ch)) {
	        state.prev = true;
	        return null;
	      }
	      if (isNiladic.test(ch)) {
	        state.prev = false;
	        return "niladic";
	      }
	      if (/[¯\d]/.test(ch)) {
	        if (state.func) {
	          state.func = false;
	          state.prev = false;
	        } else {
	          state.prev = true;
	        }
	        stream.eatWhile(/[\w\.]/);
	        return "number";
	      }
	      if (isOperator.test(ch)) {
	        return "operator apl-" + builtInOps[ch];
	      }
	      if (isArrow.test(ch)) {
	        return "apl-arrow";
	      }
	      if (isFunction.test(ch)) {
	        funcName = "apl-";
	        if (builtInFuncs[ch] != null) {
	          if (state.prev) {
	            funcName += builtInFuncs[ch][1];
	          } else {
	            funcName += builtInFuncs[ch][0];
	          }
	        }
	        state.func = true;
	        state.prev = false;
	        return "function " + funcName;
	      }
	      if (isComment.test(ch)) {
	        stream.skipToEnd();
	        return "comment";
	      }
	      if (ch === "∘" && stream.peek() === ".") {
	        stream.next();
	        return "function jot-dot";
	      }
	      stream.eatWhile(/[\w\$_]/);
	      state.prev = true;
	      return "keyword";
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/apl", "apl");
	
	});


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  function errorIfNotEmpty(stream) {
	    var nonWS = stream.match(/^\s*\S/);
	    stream.skipToEnd();
	    return nonWS ? "error" : null;
	  }
	
	  CodeMirror.defineMode("asciiarmor", function() {
	    return {
	      token: function(stream, state) {
	        var m;
	        if (state.state == "top") {
	          if (stream.sol() && (m = stream.match(/^-----BEGIN (.*)?-----\s*$/))) {
	            state.state = "headers";
	            state.type = m[1];
	            return "tag";
	          }
	          return errorIfNotEmpty(stream);
	        } else if (state.state == "headers") {
	          if (stream.sol() && stream.match(/^\w+:/)) {
	            state.state = "header";
	            return "atom";
	          } else {
	            var result = errorIfNotEmpty(stream);
	            if (result) state.state = "body";
	            return result;
	          }
	        } else if (state.state == "header") {
	          stream.skipToEnd();
	          state.state = "headers";
	          return "string";
	        } else if (state.state == "body") {
	          if (stream.sol() && (m = stream.match(/^-----END (.*)?-----\s*$/))) {
	            if (m[1] != state.type) return "error";
	            state.state = "end";
	            return "tag";
	          } else {
	            if (stream.eatWhile(/[A-Za-z0-9+\/=]/)) {
	              return null;
	            } else {
	              stream.next();
	              return "error";
	            }
	          }
	        } else if (state.state == "end") {
	          return errorIfNotEmpty(stream);
	        }
	      },
	      blankLine: function(state) {
	        if (state.state == "headers") state.state = "body";
	      },
	      startState: function() {
	        return {state: "top", type: null};
	      }
	    };
	  });
	
	  CodeMirror.defineMIME("application/pgp", "asciiarmor");
	  CodeMirror.defineMIME("application/pgp-keys", "asciiarmor");
	  CodeMirror.defineMIME("application/pgp-signature", "asciiarmor");
	});


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("asn.1", function(config, parserConfig) {
	    var indentUnit = config.indentUnit,
	        keywords = parserConfig.keywords || {},
	        cmipVerbs = parserConfig.cmipVerbs || {},
	        compareTypes = parserConfig.compareTypes || {},
	        status = parserConfig.status || {},
	        tags = parserConfig.tags || {},
	        storage = parserConfig.storage || {},
	        modifier = parserConfig.modifier || {},
	        accessTypes = parserConfig.accessTypes|| {},
	        multiLineStrings = parserConfig.multiLineStrings,
	        indentStatements = parserConfig.indentStatements !== false;
	    var isOperatorChar = /[\|\^]/;
	    var curPunc;
	
	    function tokenBase(stream, state) {
	      var ch = stream.next();
	      if (ch == '"' || ch == "'") {
	        state.tokenize = tokenString(ch);
	        return state.tokenize(stream, state);
	      }
	      if (/[\[\]\(\){}:=,;]/.test(ch)) {
	        curPunc = ch;
	        return "punctuation";
	      }
	      if (ch == "-"){
	        if (stream.eat("-")) {
	          stream.skipToEnd();
	          return "comment";
	        }
	      }
	      if (/\d/.test(ch)) {
	        stream.eatWhile(/[\w\.]/);
	        return "number";
	      }
	      if (isOperatorChar.test(ch)) {
	        stream.eatWhile(isOperatorChar);
	        return "operator";
	      }
	
	      stream.eatWhile(/[\w\-]/);
	      var cur = stream.current();
	      if (keywords.propertyIsEnumerable(cur)) return "keyword";
	      if (cmipVerbs.propertyIsEnumerable(cur)) return "variable cmipVerbs";
	      if (compareTypes.propertyIsEnumerable(cur)) return "atom compareTypes";
	      if (status.propertyIsEnumerable(cur)) return "comment status";
	      if (tags.propertyIsEnumerable(cur)) return "variable-3 tags";
	      if (storage.propertyIsEnumerable(cur)) return "builtin storage";
	      if (modifier.propertyIsEnumerable(cur)) return "string-2 modifier";
	      if (accessTypes.propertyIsEnumerable(cur)) return "atom accessTypes";
	
	      return "variable";
	    }
	
	    function tokenString(quote) {
	      return function(stream, state) {
	        var escaped = false, next, end = false;
	        while ((next = stream.next()) != null) {
	          if (next == quote && !escaped){
	            var afterNext = stream.peek();
	            //look if the character if the quote is like the B in '10100010'B
	            if (afterNext){
	              afterNext = afterNext.toLowerCase();
	              if(afterNext == "b" || afterNext == "h" || afterNext == "o")
	                stream.next();
	            }
	            end = true; break;
	          }
	          escaped = !escaped && next == "\\";
	        }
	        if (end || !(escaped || multiLineStrings))
	          state.tokenize = null;
	        return "string";
	      };
	    }
	
	    function Context(indented, column, type, align, prev) {
	      this.indented = indented;
	      this.column = column;
	      this.type = type;
	      this.align = align;
	      this.prev = prev;
	    }
	    function pushContext(state, col, type) {
	      var indent = state.indented;
	      if (state.context && state.context.type == "statement")
	        indent = state.context.indented;
	      return state.context = new Context(indent, col, type, null, state.context);
	    }
	    function popContext(state) {
	      var t = state.context.type;
	      if (t == ")" || t == "]" || t == "}")
	        state.indented = state.context.indented;
	      return state.context = state.context.prev;
	    }
	
	    //Interface
	    return {
	      startState: function(basecolumn) {
	        return {
	          tokenize: null,
	          context: new Context((basecolumn || 0) - indentUnit, 0, "top", false),
	          indented: 0,
	          startOfLine: true
	        };
	      },
	
	      token: function(stream, state) {
	        var ctx = state.context;
	        if (stream.sol()) {
	          if (ctx.align == null) ctx.align = false;
	          state.indented = stream.indentation();
	          state.startOfLine = true;
	        }
	        if (stream.eatSpace()) return null;
	        curPunc = null;
	        var style = (state.tokenize || tokenBase)(stream, state);
	        if (style == "comment") return style;
	        if (ctx.align == null) ctx.align = true;
	
	        if ((curPunc == ";" || curPunc == ":" || curPunc == ",")
	            && ctx.type == "statement"){
	          popContext(state);
	        }
	        else if (curPunc == "{") pushContext(state, stream.column(), "}");
	        else if (curPunc == "[") pushContext(state, stream.column(), "]");
	        else if (curPunc == "(") pushContext(state, stream.column(), ")");
	        else if (curPunc == "}") {
	          while (ctx.type == "statement") ctx = popContext(state);
	          if (ctx.type == "}") ctx = popContext(state);
	          while (ctx.type == "statement") ctx = popContext(state);
	        }
	        else if (curPunc == ctx.type) popContext(state);
	        else if (indentStatements && (((ctx.type == "}" || ctx.type == "top")
	            && curPunc != ';') || (ctx.type == "statement"
	            && curPunc == "newstatement")))
	          pushContext(state, stream.column(), "statement");
	
	        state.startOfLine = false;
	        return style;
	      },
	
	      electricChars: "{}",
	      lineComment: "--",
	      fold: "brace"
	    };
	  });
	
	  function words(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	
	  CodeMirror.defineMIME("text/x-ttcn-asn", {
	    name: "asn.1",
	    keywords: words("DEFINITIONS OBJECTS IF DERIVED INFORMATION ACTION" +
	    " REPLY ANY NAMED CHARACTERIZED BEHAVIOUR REGISTERED" +
	    " WITH AS IDENTIFIED CONSTRAINED BY PRESENT BEGIN" +
	    " IMPORTS FROM UNITS SYNTAX MIN-ACCESS MAX-ACCESS" +
	    " MINACCESS MAXACCESS REVISION STATUS DESCRIPTION" +
	    " SEQUENCE SET COMPONENTS OF CHOICE DistinguishedName" +
	    " ENUMERATED SIZE MODULE END INDEX AUGMENTS EXTENSIBILITY" +
	    " IMPLIED EXPORTS"),
	    cmipVerbs: words("ACTIONS ADD GET NOTIFICATIONS REPLACE REMOVE"),
	    compareTypes: words("OPTIONAL DEFAULT MANAGED MODULE-TYPE MODULE_IDENTITY" +
	    " MODULE-COMPLIANCE OBJECT-TYPE OBJECT-IDENTITY" +
	    " OBJECT-COMPLIANCE MODE CONFIRMED CONDITIONAL" +
	    " SUBORDINATE SUPERIOR CLASS TRUE FALSE NULL" +
	    " TEXTUAL-CONVENTION"),
	    status: words("current deprecated mandatory obsolete"),
	    tags: words("APPLICATION AUTOMATIC EXPLICIT IMPLICIT PRIVATE TAGS" +
	    " UNIVERSAL"),
	    storage: words("BOOLEAN INTEGER OBJECT IDENTIFIER BIT OCTET STRING" +
	    " UTCTime InterfaceIndex IANAifType CMIP-Attribute" +
	    " REAL PACKAGE PACKAGES IpAddress PhysAddress" +
	    " NetworkAddress BITS BMPString TimeStamp TimeTicks" +
	    " TruthValue RowStatus DisplayString GeneralString" +
	    " GraphicString IA5String NumericString" +
	    " PrintableString SnmpAdminAtring TeletexString" +
	    " UTF8String VideotexString VisibleString StringStore" +
	    " ISO646String T61String UniversalString Unsigned32" +
	    " Integer32 Gauge Gauge32 Counter Counter32 Counter64"),
	    modifier: words("ATTRIBUTE ATTRIBUTES MANDATORY-GROUP MANDATORY-GROUPS" +
	    " GROUP GROUPS ELEMENTS EQUALITY ORDERING SUBSTRINGS" +
	    " DEFINED"),
	    accessTypes: words("not-accessible accessible-for-notify read-only" +
	    " read-create read-write"),
	    multiLineStrings: true
	  });
	});


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	/*
	 * =====================================================================================
	 *
	 *       Filename:  mode/asterisk/asterisk.js
	 *
	 *    Description:  CodeMirror mode for Asterisk dialplan
	 *
	 *        Created:  05/17/2012 09:20:25 PM
	 *       Revision:  none
	 *
	 *         Author:  Stas Kobzar (stas@modulis.ca),
	 *        Company:  Modulis.ca Inc.
	 *
	 * =====================================================================================
	 */
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("asterisk", function() {
	  var atoms    = ["exten", "same", "include","ignorepat","switch"],
	      dpcmd    = ["#include","#exec"],
	      apps     = [
	                  "addqueuemember","adsiprog","aelsub","agentlogin","agentmonitoroutgoing","agi",
	                  "alarmreceiver","amd","answer","authenticate","background","backgrounddetect",
	                  "bridge","busy","callcompletioncancel","callcompletionrequest","celgenuserevent",
	                  "changemonitor","chanisavail","channelredirect","chanspy","clearhash","confbridge",
	                  "congestion","continuewhile","controlplayback","dahdiacceptr2call","dahdibarge",
	                  "dahdiras","dahdiscan","dahdisendcallreroutingfacility","dahdisendkeypadfacility",
	                  "datetime","dbdel","dbdeltree","deadagi","dial","dictate","directory","disa",
	                  "dumpchan","eagi","echo","endwhile","exec","execif","execiftime","exitwhile","extenspy",
	                  "externalivr","festival","flash","followme","forkcdr","getcpeid","gosub","gosubif",
	                  "goto","gotoif","gotoiftime","hangup","iax2provision","ices","importvar","incomplete",
	                  "ivrdemo","jabberjoin","jabberleave","jabbersend","jabbersendgroup","jabberstatus",
	                  "jack","log","macro","macroexclusive","macroexit","macroif","mailboxexists","meetme",
	                  "meetmeadmin","meetmechanneladmin","meetmecount","milliwatt","minivmaccmess","minivmdelete",
	                  "minivmgreet","minivmmwi","minivmnotify","minivmrecord","mixmonitor","monitor","morsecode",
	                  "mp3player","mset","musiconhold","nbscat","nocdr","noop","odbc","odbc","odbcfinish",
	                  "originate","ospauth","ospfinish","osplookup","ospnext","page","park","parkandannounce",
	                  "parkedcall","pausemonitor","pausequeuemember","pickup","pickupchan","playback","playtones",
	                  "privacymanager","proceeding","progress","queue","queuelog","raiseexception","read","readexten",
	                  "readfile","receivefax","receivefax","receivefax","record","removequeuemember",
	                  "resetcdr","retrydial","return","ringing","sayalpha","saycountedadj","saycountednoun",
	                  "saycountpl","saydigits","saynumber","sayphonetic","sayunixtime","senddtmf","sendfax",
	                  "sendfax","sendfax","sendimage","sendtext","sendurl","set","setamaflags",
	                  "setcallerpres","setmusiconhold","sipaddheader","sipdtmfmode","sipremoveheader","skel",
	                  "slastation","slatrunk","sms","softhangup","speechactivategrammar","speechbackground",
	                  "speechcreate","speechdeactivategrammar","speechdestroy","speechloadgrammar","speechprocessingsound",
	                  "speechstart","speechunloadgrammar","stackpop","startmusiconhold","stopmixmonitor","stopmonitor",
	                  "stopmusiconhold","stopplaytones","system","testclient","testserver","transfer","tryexec",
	                  "trysystem","unpausemonitor","unpausequeuemember","userevent","verbose","vmauthenticate",
	                  "vmsayname","voicemail","voicemailmain","wait","waitexten","waitfornoise","waitforring",
	                  "waitforsilence","waitmusiconhold","waituntil","while","zapateller"
	                 ];
	
	  function basicToken(stream,state){
	    var cur = '';
	    var ch = stream.next();
	    // comment
	    if(ch == ";") {
	      stream.skipToEnd();
	      return "comment";
	    }
	    // context
	    if(ch == '[') {
	      stream.skipTo(']');
	      stream.eat(']');
	      return "header";
	    }
	    // string
	    if(ch == '"') {
	      stream.skipTo('"');
	      return "string";
	    }
	    if(ch == "'") {
	      stream.skipTo("'");
	      return "string-2";
	    }
	    // dialplan commands
	    if(ch == '#') {
	      stream.eatWhile(/\w/);
	      cur = stream.current();
	      if(dpcmd.indexOf(cur) !== -1) {
	        stream.skipToEnd();
	        return "strong";
	      }
	    }
	    // application args
	    if(ch == '$'){
	      var ch1 = stream.peek();
	      if(ch1 == '{'){
	        stream.skipTo('}');
	        stream.eat('}');
	        return "variable-3";
	      }
	    }
	    // extension
	    stream.eatWhile(/\w/);
	    cur = stream.current();
	    if(atoms.indexOf(cur) !== -1) {
	      state.extenStart = true;
	      switch(cur) {
	        case 'same': state.extenSame = true; break;
	        case 'include':
	        case 'switch':
	        case 'ignorepat':
	          state.extenInclude = true;break;
	        default:break;
	      }
	      return "atom";
	    }
	  }
	
	  return {
	    startState: function() {
	      return {
	        extenStart: false,
	        extenSame:  false,
	        extenInclude: false,
	        extenExten: false,
	        extenPriority: false,
	        extenApplication: false
	      };
	    },
	    token: function(stream, state) {
	
	      var cur = '';
	      if(stream.eatSpace()) return null;
	      // extension started
	      if(state.extenStart){
	        stream.eatWhile(/[^\s]/);
	        cur = stream.current();
	        if(/^=>?$/.test(cur)){
	          state.extenExten = true;
	          state.extenStart = false;
	          return "strong";
	        } else {
	          state.extenStart = false;
	          stream.skipToEnd();
	          return "error";
	        }
	      } else if(state.extenExten) {
	        // set exten and priority
	        state.extenExten = false;
	        state.extenPriority = true;
	        stream.eatWhile(/[^,]/);
	        if(state.extenInclude) {
	          stream.skipToEnd();
	          state.extenPriority = false;
	          state.extenInclude = false;
	        }
	        if(state.extenSame) {
	          state.extenPriority = false;
	          state.extenSame = false;
	          state.extenApplication = true;
	        }
	        return "tag";
	      } else if(state.extenPriority) {
	        state.extenPriority = false;
	        state.extenApplication = true;
	        stream.next(); // get comma
	        if(state.extenSame) return null;
	        stream.eatWhile(/[^,]/);
	        return "number";
	      } else if(state.extenApplication) {
	        stream.eatWhile(/,/);
	        cur = stream.current();
	        if(cur === ',') return null;
	        stream.eatWhile(/\w/);
	        cur = stream.current().toLowerCase();
	        state.extenApplication = false;
	        if(apps.indexOf(cur) !== -1){
	          return "def strong";
	        }
	      } else{
	        return basicToken(stream,state);
	      }
	
	      return null;
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/x-asterisk", "asterisk");
	
	});


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// Brainfuck mode created by Michael Kaminsky https://github.com/mkaminsky11
	
	(function(mod) {
	  if (true)
	    mod(__webpack_require__(2))
	  else if (typeof define == "function" && define.amd)
	    define(["../../lib/codemirror"], mod)
	  else
	    mod(CodeMirror)
	})(function(CodeMirror) {
	  "use strict"
	  var reserve = "><+-.,[]".split("");
	  /*
	  comments can be either:
	  placed behind lines
	
	        +++    this is a comment
	
	  where reserved characters cannot be used
	  or in a loop
	  [
	    this is ok to use [ ] and stuff
	  ]
	  or preceded by #
	  */
	  CodeMirror.defineMode("brainfuck", function() {
	    return {
	      startState: function() {
	        return {
	          commentLine: false,
	          left: 0,
	          right: 0,
	          commentLoop: false
	        }
	      },
	      token: function(stream, state) {
	        if (stream.eatSpace()) return null
	        if(stream.sol()){
	          state.commentLine = false;
	        }
	        var ch = stream.next().toString();
	        if(reserve.indexOf(ch) !== -1){
	          if(state.commentLine === true){
	            if(stream.eol()){
	              state.commentLine = false;
	            }
	            return "comment";
	          }
	          if(ch === "]" || ch === "["){
	            if(ch === "["){
	              state.left++;
	            }
	            else{
	              state.right++;
	            }
	            return "bracket";
	          }
	          else if(ch === "+" || ch === "-"){
	            return "keyword";
	          }
	          else if(ch === "<" || ch === ">"){
	            return "atom";
	          }
	          else if(ch === "." || ch === ","){
	            return "def";
	          }
	        }
	        else{
	          state.commentLine = true;
	          if(stream.eol()){
	            state.commentLine = false;
	          }
	          return "comment";
	        }
	        if(stream.eol()){
	          state.commentLine = false;
	        }
	      }
	    };
	  });
	CodeMirror.defineMIME("text/x-brainfuck","brainfuck")
	});


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	/**
	 * Author: Hans Engel
	 * Branched from CodeMirror's Scheme mode (by Koh Zi Han, based on implementation by Koh Zi Chun)
	 */
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("clojure", function (options) {
	    var BUILTIN = "builtin", COMMENT = "comment", STRING = "string", CHARACTER = "string-2",
	        ATOM = "atom", NUMBER = "number", BRACKET = "bracket", KEYWORD = "keyword", VAR = "variable";
	    var INDENT_WORD_SKIP = options.indentUnit || 2;
	    var NORMAL_INDENT_UNIT = options.indentUnit || 2;
	
	    function makeKeywords(str) {
	        var obj = {}, words = str.split(" ");
	        for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	        return obj;
	    }
	
	    var atoms = makeKeywords("true false nil");
	
	    var keywords = makeKeywords(
	      "defn defn- def def- defonce defmulti defmethod defmacro defstruct deftype defprotocol defrecord defproject deftest " +
	      "slice defalias defhinted defmacro- defn-memo defnk defnk defonce- defunbound defunbound- defvar defvar- let letfn " +
	      "do case cond condp for loop recur when when-not when-let when-first if if-let if-not . .. -> ->> doto and or dosync " +
	      "doseq dotimes dorun doall load import unimport ns in-ns refer try catch finally throw with-open with-local-vars " +
	      "binding gen-class gen-and-load-class gen-and-save-class handler-case handle");
	
	    var builtins = makeKeywords(
	        "* *' *1 *2 *3 *agent* *allow-unresolved-vars* *assert* *clojure-version* *command-line-args* *compile-files* " +
	        "*compile-path* *compiler-options* *data-readers* *e *err* *file* *flush-on-newline* *fn-loader* *in* " +
	        "*math-context* *ns* *out* *print-dup* *print-length* *print-level* *print-meta* *print-readably* *read-eval* " +
	        "*source-path* *unchecked-math* *use-context-classloader* *verbose-defrecords* *warn-on-reflection* + +' - -' -> " +
	        "->> ->ArrayChunk ->Vec ->VecNode ->VecSeq -cache-protocol-fn -reset-methods .. / < <= = == > >= EMPTY-NODE accessor " +
	        "aclone add-classpath add-watch agent agent-error agent-errors aget alength alias all-ns alter alter-meta! " +
	        "alter-var-root amap ancestors and apply areduce array-map aset aset-boolean aset-byte aset-char aset-double " +
	        "aset-float aset-int aset-long aset-short assert assoc assoc! assoc-in associative? atom await await-for await1 " +
	        "bases bean bigdec bigint biginteger binding bit-and bit-and-not bit-clear bit-flip bit-not bit-or bit-set " +
	        "bit-shift-left bit-shift-right bit-test bit-xor boolean boolean-array booleans bound-fn bound-fn* bound? butlast " +
	        "byte byte-array bytes case cat cast char char-array char-escape-string char-name-string char? chars chunk chunk-append " +
	        "chunk-buffer chunk-cons chunk-first chunk-next chunk-rest chunked-seq? class class? clear-agent-errors " +
	        "clojure-version coll? comment commute comp comparator compare compare-and-set! compile complement completing concat cond condp " +
	        "conj conj! cons constantly construct-proxy contains? count counted? create-ns create-struct cycle dec dec' decimal? " +
	        "declare dedupe default-data-readers definline definterface defmacro defmethod defmulti defn defn- defonce defprotocol " +
	        "defrecord defstruct deftype delay delay? deliver denominator deref derive descendants destructure disj disj! dissoc " +
	        "dissoc! distinct distinct? doall dorun doseq dosync dotimes doto double double-array doubles drop drop-last " +
	        "drop-while eduction empty empty? ensure enumeration-seq error-handler error-mode eval even? every-pred every? ex-data ex-info " +
	        "extend extend-protocol extend-type extenders extends? false? ffirst file-seq filter filterv find find-keyword " +
	        "find-ns find-protocol-impl find-protocol-method find-var first flatten float float-array float? floats flush fn fn? " +
	        "fnext fnil for force format frequencies future future-call future-cancel future-cancelled? future-done? future? " +
	        "gen-class gen-interface gensym get get-in get-method get-proxy-class get-thread-bindings get-validator group-by hash " +
	        "hash-combine hash-map hash-set identical? identity if-let if-not ifn? import in-ns inc inc' init-proxy instance? " +
	        "int int-array integer? interleave intern interpose into into-array ints io! isa? iterate iterator-seq juxt keep " +
	        "keep-indexed key keys keyword keyword? last lazy-cat lazy-seq let letfn line-seq list list* list? load load-file " +
	        "load-reader load-string loaded-libs locking long long-array longs loop macroexpand macroexpand-1 make-array " +
	        "make-hierarchy map map-indexed map? mapcat mapv max max-key memfn memoize merge merge-with meta method-sig methods " +
	        "min min-key mod munge name namespace namespace-munge neg? newline next nfirst nil? nnext not not-any? not-empty " +
	        "not-every? not= ns ns-aliases ns-imports ns-interns ns-map ns-name ns-publics ns-refers ns-resolve ns-unalias " +
	        "ns-unmap nth nthnext nthrest num number? numerator object-array odd? or parents partial partition partition-all " +
	        "partition-by pcalls peek persistent! pmap pop pop! pop-thread-bindings pos? pr pr-str prefer-method prefers " +
	        "primitives-classnames print print-ctor print-dup print-method print-simple print-str printf println println-str " +
	        "prn prn-str promise proxy proxy-call-with-super proxy-mappings proxy-name proxy-super push-thread-bindings pvalues " +
	        "quot rand rand-int rand-nth random-sample range ratio? rational? rationalize re-find re-groups re-matcher re-matches re-pattern " +
	        "re-seq read read-line read-string realized? reduce reduce-kv reductions ref ref-history-count ref-max-history " +
	        "ref-min-history ref-set refer refer-clojure reify release-pending-sends rem remove remove-all-methods " +
	        "remove-method remove-ns remove-watch repeat repeatedly replace replicate require reset! reset-meta! resolve rest " +
	        "restart-agent resultset-seq reverse reversible? rseq rsubseq satisfies? second select-keys send send-off seq seq? " +
	        "seque sequence sequential? set set-error-handler! set-error-mode! set-validator! set? short short-array shorts " +
	        "shuffle shutdown-agents slurp some some-fn sort sort-by sorted-map sorted-map-by sorted-set sorted-set-by sorted? " +
	        "special-symbol? spit split-at split-with str string? struct struct-map subs subseq subvec supers swap! symbol " +
	        "symbol? sync take take-last take-nth take-while test the-ns thread-bound? time to-array to-array-2d trampoline transduce " +
	        "transient tree-seq true? type unchecked-add unchecked-add-int unchecked-byte unchecked-char unchecked-dec " +
	        "unchecked-dec-int unchecked-divide-int unchecked-double unchecked-float unchecked-inc unchecked-inc-int " +
	        "unchecked-int unchecked-long unchecked-multiply unchecked-multiply-int unchecked-negate unchecked-negate-int "+
	        "unchecked-remainder-int unchecked-short unchecked-subtract unchecked-subtract-int underive unquote " +
	        "unquote-splicing update update-in update-proxy use val vals var-get var-set var? vary-meta vec vector vector-of " +
	        "vector? volatile! volatile? vreset! vswap! when when-first when-let when-not while with-bindings with-bindings* with-in-str with-loading-context " +
	        "with-local-vars with-meta with-open with-out-str with-precision with-redefs with-redefs-fn xml-seq zero? zipmap " +
	        "*default-data-reader-fn* as-> cond-> cond->> reduced reduced? send-via set-agent-send-executor! " +
	        "set-agent-send-off-executor! some-> some->>");
	
	    var indentKeys = makeKeywords(
	        // Built-ins
	        "ns fn def defn defmethod bound-fn if if-not case condp when while when-not when-first do future comment doto " +
	        "locking proxy with-open with-precision reify deftype defrecord defprotocol extend extend-protocol extend-type " +
	        "try catch " +
	
	        // Binding forms
	        "let letfn binding loop for doseq dotimes when-let if-let " +
	
	        // Data structures
	        "defstruct struct-map assoc " +
	
	        // clojure.test
	        "testing deftest " +
	
	        // contrib
	        "handler-case handle dotrace deftrace");
	
	    var tests = {
	        digit: /\d/,
	        digit_or_colon: /[\d:]/,
	        hex: /[0-9a-f]/i,
	        sign: /[+-]/,
	        exponent: /e/i,
	        keyword_char: /[^\s\(\[\;\)\]]/,
	        symbol: /[\w*+!\-\._?:<>\/\xa1-\uffff]/,
	        block_indent: /^(?:def|with)[^\/]+$|\/(?:def|with)/
	    };
	
	    function stateStack(indent, type, prev) { // represents a state stack object
	        this.indent = indent;
	        this.type = type;
	        this.prev = prev;
	    }
	
	    function pushStack(state, indent, type) {
	        state.indentStack = new stateStack(indent, type, state.indentStack);
	    }
	
	    function popStack(state) {
	        state.indentStack = state.indentStack.prev;
	    }
	
	    function isNumber(ch, stream){
	        // hex
	        if ( ch === '0' && stream.eat(/x/i) ) {
	            stream.eatWhile(tests.hex);
	            return true;
	        }
	
	        // leading sign
	        if ( ( ch == '+' || ch == '-' ) && ( tests.digit.test(stream.peek()) ) ) {
	          stream.eat(tests.sign);
	          ch = stream.next();
	        }
	
	        if ( tests.digit.test(ch) ) {
	            stream.eat(ch);
	            stream.eatWhile(tests.digit);
	
	            if ( '.' == stream.peek() ) {
	                stream.eat('.');
	                stream.eatWhile(tests.digit);
	            } else if ('/' == stream.peek() ) {
	                stream.eat('/');
	                stream.eatWhile(tests.digit);
	            }
	
	            if ( stream.eat(tests.exponent) ) {
	                stream.eat(tests.sign);
	                stream.eatWhile(tests.digit);
	            }
	
	            return true;
	        }
	
	        return false;
	    }
	
	    // Eat character that starts after backslash \
	    function eatCharacter(stream) {
	        var first = stream.next();
	        // Read special literals: backspace, newline, space, return.
	        // Just read all lowercase letters.
	        if (first && first.match(/[a-z]/) && stream.match(/[a-z]+/, true)) {
	            return;
	        }
	        // Read unicode character: \u1000 \uA0a1
	        if (first === "u") {
	            stream.match(/[0-9a-z]{4}/i, true);
	        }
	    }
	
	    return {
	        startState: function () {
	            return {
	                indentStack: null,
	                indentation: 0,
	                mode: false
	            };
	        },
	
	        token: function (stream, state) {
	            if (state.indentStack == null && stream.sol()) {
	                // update indentation, but only if indentStack is empty
	                state.indentation = stream.indentation();
	            }
	
	            // skip spaces
	            if (state.mode != "string" && stream.eatSpace()) {
	                return null;
	            }
	            var returnType = null;
	
	            switch(state.mode){
	                case "string": // multi-line string parsing mode
	                    var next, escaped = false;
	                    while ((next = stream.next()) != null) {
	                        if (next == "\"" && !escaped) {
	
	                            state.mode = false;
	                            break;
	                        }
	                        escaped = !escaped && next == "\\";
	                    }
	                    returnType = STRING; // continue on in string mode
	                    break;
	                default: // default parsing mode
	                    var ch = stream.next();
	
	                    if (ch == "\"") {
	                        state.mode = "string";
	                        returnType = STRING;
	                    } else if (ch == "\\") {
	                        eatCharacter(stream);
	                        returnType = CHARACTER;
	                    } else if (ch == "'" && !( tests.digit_or_colon.test(stream.peek()) )) {
	                        returnType = ATOM;
	                    } else if (ch == ";") { // comment
	                        stream.skipToEnd(); // rest of the line is a comment
	                        returnType = COMMENT;
	                    } else if (isNumber(ch,stream)){
	                        returnType = NUMBER;
	                    } else if (ch == "(" || ch == "[" || ch == "{" ) {
	                        var keyWord = '', indentTemp = stream.column(), letter;
	                        /**
	                        Either
	                        (indent-word ..
	                        (non-indent-word ..
	                        (;something else, bracket, etc.
	                        */
	
	                        if (ch == "(") while ((letter = stream.eat(tests.keyword_char)) != null) {
	                            keyWord += letter;
	                        }
	
	                        if (keyWord.length > 0 && (indentKeys.propertyIsEnumerable(keyWord) ||
	                                                   tests.block_indent.test(keyWord))) { // indent-word
	                            pushStack(state, indentTemp + INDENT_WORD_SKIP, ch);
	                        } else { // non-indent word
	                            // we continue eating the spaces
	                            stream.eatSpace();
	                            if (stream.eol() || stream.peek() == ";") {
	                                // nothing significant after
	                                // we restart indentation the user defined spaces after
	                                pushStack(state, indentTemp + NORMAL_INDENT_UNIT, ch);
	                            } else {
	                                pushStack(state, indentTemp + stream.current().length, ch); // else we match
	                            }
	                        }
	                        stream.backUp(stream.current().length - 1); // undo all the eating
	
	                        returnType = BRACKET;
	                    } else if (ch == ")" || ch == "]" || ch == "}") {
	                        returnType = BRACKET;
	                        if (state.indentStack != null && state.indentStack.type == (ch == ")" ? "(" : (ch == "]" ? "[" :"{"))) {
	                            popStack(state);
	                        }
	                    } else if ( ch == ":" ) {
	                        stream.eatWhile(tests.symbol);
	                        return ATOM;
	                    } else {
	                        stream.eatWhile(tests.symbol);
	
	                        if (keywords && keywords.propertyIsEnumerable(stream.current())) {
	                            returnType = KEYWORD;
	                        } else if (builtins && builtins.propertyIsEnumerable(stream.current())) {
	                            returnType = BUILTIN;
	                        } else if (atoms && atoms.propertyIsEnumerable(stream.current())) {
	                            returnType = ATOM;
	                        } else {
	                          returnType = VAR;
	                        }
	                    }
	            }
	
	            return returnType;
	        },
	
	        indent: function (state) {
	            if (state.indentStack == null) return state.indentation;
	            return state.indentStack.indent;
	        },
	
	        closeBrackets: {pairs: "()[]{}\"\""},
	        lineComment: ";;"
	    };
	});
	
	CodeMirror.defineMIME("text/x-clojure", "clojure");
	CodeMirror.defineMIME("text/x-clojurescript", "clojure");
	CodeMirror.defineMIME("application/edn", "clojure");
	
	});


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true)
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd)
	    define(["../../lib/codemirror"], mod);
	  else
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("cmake", function () {
	  var variable_regex = /({)?[a-zA-Z0-9_]+(})?/;
	
	  function tokenString(stream, state) {
	    var current, prev, found_var = false;
	    while (!stream.eol() && (current = stream.next()) != state.pending) {
	      if (current === '$' && prev != '\\' && state.pending == '"') {
	        found_var = true;
	        break;
	      }
	      prev = current;
	    }
	    if (found_var) {
	      stream.backUp(1);
	    }
	    if (current == state.pending) {
	      state.continueString = false;
	    } else {
	      state.continueString = true;
	    }
	    return "string";
	  }
	
	  function tokenize(stream, state) {
	    var ch = stream.next();
	
	    // Have we found a variable?
	    if (ch === '$') {
	      if (stream.match(variable_regex)) {
	        return 'variable-2';
	      }
	      return 'variable';
	    }
	    // Should we still be looking for the end of a string?
	    if (state.continueString) {
	      // If so, go through the loop again
	      stream.backUp(1);
	      return tokenString(stream, state);
	    }
	    // Do we just have a function on our hands?
	    // In 'cmake_minimum_required (VERSION 2.8.8)', 'cmake_minimum_required' is matched
	    if (stream.match(/(\s+)?\w+\(/) || stream.match(/(\s+)?\w+\ \(/)) {
	      stream.backUp(1);
	      return 'def';
	    }
	    if (ch == "#") {
	      stream.skipToEnd();
	      return "comment";
	    }
	    // Have we found a string?
	    if (ch == "'" || ch == '"') {
	      // Store the type (single or double)
	      state.pending = ch;
	      // Perform the looping function to find the end
	      return tokenString(stream, state);
	    }
	    if (ch == '(' || ch == ')') {
	      return 'bracket';
	    }
	    if (ch.match(/[0-9]/)) {
	      return 'number';
	    }
	    stream.eatWhile(/[\w-]/);
	    return null;
	  }
	  return {
	    startState: function () {
	      var state = {};
	      state.inDefinition = false;
	      state.inInclude = false;
	      state.continueString = false;
	      state.pending = false;
	      return state;
	    },
	    token: function (stream, state) {
	      if (stream.eatSpace()) return null;
	      return tokenize(stream, state);
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/x-cmake", "cmake");
	
	});


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	/**
	 * Author: Gautam Mehta
	 * Branched from CodeMirror's Scheme mode
	 */
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("cobol", function () {
	  var BUILTIN = "builtin", COMMENT = "comment", STRING = "string",
	      ATOM = "atom", NUMBER = "number", KEYWORD = "keyword", MODTAG = "header",
	      COBOLLINENUM = "def", PERIOD = "link";
	  function makeKeywords(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	  var atoms = makeKeywords("TRUE FALSE ZEROES ZEROS ZERO SPACES SPACE LOW-VALUE LOW-VALUES ");
	  var keywords = makeKeywords(
	      "ACCEPT ACCESS ACQUIRE ADD ADDRESS " +
	      "ADVANCING AFTER ALIAS ALL ALPHABET " +
	      "ALPHABETIC ALPHABETIC-LOWER ALPHABETIC-UPPER ALPHANUMERIC ALPHANUMERIC-EDITED " +
	      "ALSO ALTER ALTERNATE AND ANY " +
	      "ARE AREA AREAS ARITHMETIC ASCENDING " +
	      "ASSIGN AT ATTRIBUTE AUTHOR AUTO " +
	      "AUTO-SKIP AUTOMATIC B-AND B-EXOR B-LESS " +
	      "B-NOT B-OR BACKGROUND-COLOR BACKGROUND-COLOUR BEEP " +
	      "BEFORE BELL BINARY BIT BITS " +
	      "BLANK BLINK BLOCK BOOLEAN BOTTOM " +
	      "BY CALL CANCEL CD CF " +
	      "CH CHARACTER CHARACTERS CLASS CLOCK-UNITS " +
	      "CLOSE COBOL CODE CODE-SET COL " +
	      "COLLATING COLUMN COMMA COMMIT COMMITMENT " +
	      "COMMON COMMUNICATION COMP COMP-0 COMP-1 " +
	      "COMP-2 COMP-3 COMP-4 COMP-5 COMP-6 " +
	      "COMP-7 COMP-8 COMP-9 COMPUTATIONAL COMPUTATIONAL-0 " +
	      "COMPUTATIONAL-1 COMPUTATIONAL-2 COMPUTATIONAL-3 COMPUTATIONAL-4 COMPUTATIONAL-5 " +
	      "COMPUTATIONAL-6 COMPUTATIONAL-7 COMPUTATIONAL-8 COMPUTATIONAL-9 COMPUTE " +
	      "CONFIGURATION CONNECT CONSOLE CONTAINED CONTAINS " +
	      "CONTENT CONTINUE CONTROL CONTROL-AREA CONTROLS " +
	      "CONVERTING COPY CORR CORRESPONDING COUNT " +
	      "CRT CRT-UNDER CURRENCY CURRENT CURSOR " +
	      "DATA DATE DATE-COMPILED DATE-WRITTEN DAY " +
	      "DAY-OF-WEEK DB DB-ACCESS-CONTROL-KEY DB-DATA-NAME DB-EXCEPTION " +
	      "DB-FORMAT-NAME DB-RECORD-NAME DB-SET-NAME DB-STATUS DBCS " +
	      "DBCS-EDITED DE DEBUG-CONTENTS DEBUG-ITEM DEBUG-LINE " +
	      "DEBUG-NAME DEBUG-SUB-1 DEBUG-SUB-2 DEBUG-SUB-3 DEBUGGING " +
	      "DECIMAL-POINT DECLARATIVES DEFAULT DELETE DELIMITED " +
	      "DELIMITER DEPENDING DESCENDING DESCRIBED DESTINATION " +
	      "DETAIL DISABLE DISCONNECT DISPLAY DISPLAY-1 " +
	      "DISPLAY-2 DISPLAY-3 DISPLAY-4 DISPLAY-5 DISPLAY-6 " +
	      "DISPLAY-7 DISPLAY-8 DISPLAY-9 DIVIDE DIVISION " +
	      "DOWN DROP DUPLICATE DUPLICATES DYNAMIC " +
	      "EBCDIC EGI EJECT ELSE EMI " +
	      "EMPTY EMPTY-CHECK ENABLE END END. END-ACCEPT END-ACCEPT. " +
	      "END-ADD END-CALL END-COMPUTE END-DELETE END-DISPLAY " +
	      "END-DIVIDE END-EVALUATE END-IF END-INVOKE END-MULTIPLY " +
	      "END-OF-PAGE END-PERFORM END-READ END-RECEIVE END-RETURN " +
	      "END-REWRITE END-SEARCH END-START END-STRING END-SUBTRACT " +
	      "END-UNSTRING END-WRITE END-XML ENTER ENTRY " +
	      "ENVIRONMENT EOP EQUAL EQUALS ERASE " +
	      "ERROR ESI EVALUATE EVERY EXCEEDS " +
	      "EXCEPTION EXCLUSIVE EXIT EXTEND EXTERNAL " +
	      "EXTERNALLY-DESCRIBED-KEY FD FETCH FILE FILE-CONTROL " +
	      "FILE-STREAM FILES FILLER FINAL FIND " +
	      "FINISH FIRST FOOTING FOR FOREGROUND-COLOR " +
	      "FOREGROUND-COLOUR FORMAT FREE FROM FULL " +
	      "FUNCTION GENERATE GET GIVING GLOBAL " +
	      "GO GOBACK GREATER GROUP HEADING " +
	      "HIGH-VALUE HIGH-VALUES HIGHLIGHT I-O I-O-CONTROL " +
	      "ID IDENTIFICATION IF IN INDEX " +
	      "INDEX-1 INDEX-2 INDEX-3 INDEX-4 INDEX-5 " +
	      "INDEX-6 INDEX-7 INDEX-8 INDEX-9 INDEXED " +
	      "INDIC INDICATE INDICATOR INDICATORS INITIAL " +
	      "INITIALIZE INITIATE INPUT INPUT-OUTPUT INSPECT " +
	      "INSTALLATION INTO INVALID INVOKE IS " +
	      "JUST JUSTIFIED KANJI KEEP KEY " +
	      "LABEL LAST LD LEADING LEFT " +
	      "LEFT-JUSTIFY LENGTH LENGTH-CHECK LESS LIBRARY " +
	      "LIKE LIMIT LIMITS LINAGE LINAGE-COUNTER " +
	      "LINE LINE-COUNTER LINES LINKAGE LOCAL-STORAGE " +
	      "LOCALE LOCALLY LOCK " +
	      "MEMBER MEMORY MERGE MESSAGE METACLASS " +
	      "MODE MODIFIED MODIFY MODULES MOVE " +
	      "MULTIPLE MULTIPLY NATIONAL NATIVE NEGATIVE " +
	      "NEXT NO NO-ECHO NONE NOT " +
	      "NULL NULL-KEY-MAP NULL-MAP NULLS NUMBER " +
	      "NUMERIC NUMERIC-EDITED OBJECT OBJECT-COMPUTER OCCURS " +
	      "OF OFF OMITTED ON ONLY " +
	      "OPEN OPTIONAL OR ORDER ORGANIZATION " +
	      "OTHER OUTPUT OVERFLOW OWNER PACKED-DECIMAL " +
	      "PADDING PAGE PAGE-COUNTER PARSE PERFORM " +
	      "PF PH PIC PICTURE PLUS " +
	      "POINTER POSITION POSITIVE PREFIX PRESENT " +
	      "PRINTING PRIOR PROCEDURE PROCEDURE-POINTER PROCEDURES " +
	      "PROCEED PROCESS PROCESSING PROGRAM PROGRAM-ID " +
	      "PROMPT PROTECTED PURGE QUEUE QUOTE " +
	      "QUOTES RANDOM RD READ READY " +
	      "REALM RECEIVE RECONNECT RECORD RECORD-NAME " +
	      "RECORDS RECURSIVE REDEFINES REEL REFERENCE " +
	      "REFERENCE-MONITOR REFERENCES RELATION RELATIVE RELEASE " +
	      "REMAINDER REMOVAL RENAMES REPEATED REPLACE " +
	      "REPLACING REPORT REPORTING REPORTS REPOSITORY " +
	      "REQUIRED RERUN RESERVE RESET RETAINING " +
	      "RETRIEVAL RETURN RETURN-CODE RETURNING REVERSE-VIDEO " +
	      "REVERSED REWIND REWRITE RF RH " +
	      "RIGHT RIGHT-JUSTIFY ROLLBACK ROLLING ROUNDED " +
	      "RUN SAME SCREEN SD SEARCH " +
	      "SECTION SECURE SECURITY SEGMENT SEGMENT-LIMIT " +
	      "SELECT SEND SENTENCE SEPARATE SEQUENCE " +
	      "SEQUENTIAL SET SHARED SIGN SIZE " +
	      "SKIP1 SKIP2 SKIP3 SORT SORT-MERGE " +
	      "SORT-RETURN SOURCE SOURCE-COMPUTER SPACE-FILL " +
	      "SPECIAL-NAMES STANDARD STANDARD-1 STANDARD-2 " +
	      "START STARTING STATUS STOP STORE " +
	      "STRING SUB-QUEUE-1 SUB-QUEUE-2 SUB-QUEUE-3 SUB-SCHEMA " +
	      "SUBFILE SUBSTITUTE SUBTRACT SUM SUPPRESS " +
	      "SYMBOLIC SYNC SYNCHRONIZED SYSIN SYSOUT " +
	      "TABLE TALLYING TAPE TENANT TERMINAL " +
	      "TERMINATE TEST TEXT THAN THEN " +
	      "THROUGH THRU TIME TIMES TITLE " +
	      "TO TOP TRAILING TRAILING-SIGN TRANSACTION " +
	      "TYPE TYPEDEF UNDERLINE UNEQUAL UNIT " +
	      "UNSTRING UNTIL UP UPDATE UPON " +
	      "USAGE USAGE-MODE USE USING VALID " +
	      "VALIDATE VALUE VALUES VARYING VLR " +
	      "WAIT WHEN WHEN-COMPILED WITH WITHIN " +
	      "WORDS WORKING-STORAGE WRITE XML XML-CODE " +
	      "XML-EVENT XML-NTEXT XML-TEXT ZERO ZERO-FILL " );
	
	  var builtins = makeKeywords("- * ** / + < <= = > >= ");
	  var tests = {
	    digit: /\d/,
	    digit_or_colon: /[\d:]/,
	    hex: /[0-9a-f]/i,
	    sign: /[+-]/,
	    exponent: /e/i,
	    keyword_char: /[^\s\(\[\;\)\]]/,
	    symbol: /[\w*+\-]/
	  };
	  function isNumber(ch, stream){
	    // hex
	    if ( ch === '0' && stream.eat(/x/i) ) {
	      stream.eatWhile(tests.hex);
	      return true;
	    }
	    // leading sign
	    if ( ( ch == '+' || ch == '-' ) && ( tests.digit.test(stream.peek()) ) ) {
	      stream.eat(tests.sign);
	      ch = stream.next();
	    }
	    if ( tests.digit.test(ch) ) {
	      stream.eat(ch);
	      stream.eatWhile(tests.digit);
	      if ( '.' == stream.peek()) {
	        stream.eat('.');
	        stream.eatWhile(tests.digit);
	      }
	      if ( stream.eat(tests.exponent) ) {
	        stream.eat(tests.sign);
	        stream.eatWhile(tests.digit);
	      }
	      return true;
	    }
	    return false;
	  }
	  return {
	    startState: function () {
	      return {
	        indentStack: null,
	        indentation: 0,
	        mode: false
	      };
	    },
	    token: function (stream, state) {
	      if (state.indentStack == null && stream.sol()) {
	        // update indentation, but only if indentStack is empty
	        state.indentation = 6 ; //stream.indentation();
	      }
	      // skip spaces
	      if (stream.eatSpace()) {
	        return null;
	      }
	      var returnType = null;
	      switch(state.mode){
	      case "string": // multi-line string parsing mode
	        var next = false;
	        while ((next = stream.next()) != null) {
	          if (next == "\"" || next == "\'") {
	            state.mode = false;
	            break;
	          }
	        }
	        returnType = STRING; // continue on in string mode
	        break;
	      default: // default parsing mode
	        var ch = stream.next();
	        var col = stream.column();
	        if (col >= 0 && col <= 5) {
	          returnType = COBOLLINENUM;
	        } else if (col >= 72 && col <= 79) {
	          stream.skipToEnd();
	          returnType = MODTAG;
	        } else if (ch == "*" && col == 6) { // comment
	          stream.skipToEnd(); // rest of the line is a comment
	          returnType = COMMENT;
	        } else if (ch == "\"" || ch == "\'") {
	          state.mode = "string";
	          returnType = STRING;
	        } else if (ch == "'" && !( tests.digit_or_colon.test(stream.peek()) )) {
	          returnType = ATOM;
	        } else if (ch == ".") {
	          returnType = PERIOD;
	        } else if (isNumber(ch,stream)){
	          returnType = NUMBER;
	        } else {
	          if (stream.current().match(tests.symbol)) {
	            while (col < 71) {
	              if (stream.eat(tests.symbol) === undefined) {
	                break;
	              } else {
	                col++;
	              }
	            }
	          }
	          if (keywords && keywords.propertyIsEnumerable(stream.current().toUpperCase())) {
	            returnType = KEYWORD;
	          } else if (builtins && builtins.propertyIsEnumerable(stream.current().toUpperCase())) {
	            returnType = BUILTIN;
	          } else if (atoms && atoms.propertyIsEnumerable(stream.current().toUpperCase())) {
	            returnType = ATOM;
	          } else returnType = null;
	        }
	      }
	      return returnType;
	    },
	    indent: function (state) {
	      if (state.indentStack == null) return state.indentation;
	      return state.indentStack.indent;
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/x-cobol", "cobol");
	
	});


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("commonlisp", function (config) {
	  var specialForm = /^(block|let*|return-from|catch|load-time-value|setq|eval-when|locally|symbol-macrolet|flet|macrolet|tagbody|function|multiple-value-call|the|go|multiple-value-prog1|throw|if|progn|unwind-protect|labels|progv|let|quote)$/;
	  var assumeBody = /^with|^def|^do|^prog|case$|^cond$|bind$|when$|unless$/;
	  var numLiteral = /^(?:[+\-]?(?:\d+|\d*\.\d+)(?:[efd][+\-]?\d+)?|[+\-]?\d+(?:\/[+\-]?\d+)?|#b[+\-]?[01]+|#o[+\-]?[0-7]+|#x[+\-]?[\da-f]+)/;
	  var symbol = /[^\s'`,@()\[\]";]/;
	  var type;
	
	  function readSym(stream) {
	    var ch;
	    while (ch = stream.next()) {
	      if (ch == "\\") stream.next();
	      else if (!symbol.test(ch)) { stream.backUp(1); break; }
	    }
	    return stream.current();
	  }
	
	  function base(stream, state) {
	    if (stream.eatSpace()) {type = "ws"; return null;}
	    if (stream.match(numLiteral)) return "number";
	    var ch = stream.next();
	    if (ch == "\\") ch = stream.next();
	
	    if (ch == '"') return (state.tokenize = inString)(stream, state);
	    else if (ch == "(") { type = "open"; return "bracket"; }
	    else if (ch == ")" || ch == "]") { type = "close"; return "bracket"; }
	    else if (ch == ";") { stream.skipToEnd(); type = "ws"; return "comment"; }
	    else if (/['`,@]/.test(ch)) return null;
	    else if (ch == "|") {
	      if (stream.skipTo("|")) { stream.next(); return "symbol"; }
	      else { stream.skipToEnd(); return "error"; }
	    } else if (ch == "#") {
	      var ch = stream.next();
	      if (ch == "[") { type = "open"; return "bracket"; }
	      else if (/[+\-=\.']/.test(ch)) return null;
	      else if (/\d/.test(ch) && stream.match(/^\d*#/)) return null;
	      else if (ch == "|") return (state.tokenize = inComment)(stream, state);
	      else if (ch == ":") { readSym(stream); return "meta"; }
	      else if (ch == "\\") { stream.next(); readSym(stream); return "string-2" }
	      else return "error";
	    } else {
	      var name = readSym(stream);
	      if (name == ".") return null;
	      type = "symbol";
	      if (name == "nil" || name == "t" || name.charAt(0) == ":") return "atom";
	      if (state.lastType == "open" && (specialForm.test(name) || assumeBody.test(name))) return "keyword";
	      if (name.charAt(0) == "&") return "variable-2";
	      return "variable";
	    }
	  }
	
	  function inString(stream, state) {
	    var escaped = false, next;
	    while (next = stream.next()) {
	      if (next == '"' && !escaped) { state.tokenize = base; break; }
	      escaped = !escaped && next == "\\";
	    }
	    return "string";
	  }
	
	  function inComment(stream, state) {
	    var next, last;
	    while (next = stream.next()) {
	      if (next == "#" && last == "|") { state.tokenize = base; break; }
	      last = next;
	    }
	    type = "ws";
	    return "comment";
	  }
	
	  return {
	    startState: function () {
	      return {ctx: {prev: null, start: 0, indentTo: 0}, lastType: null, tokenize: base};
	    },
	
	    token: function (stream, state) {
	      if (stream.sol() && typeof state.ctx.indentTo != "number")
	        state.ctx.indentTo = state.ctx.start + 1;
	
	      type = null;
	      var style = state.tokenize(stream, state);
	      if (type != "ws") {
	        if (state.ctx.indentTo == null) {
	          if (type == "symbol" && assumeBody.test(stream.current()))
	            state.ctx.indentTo = state.ctx.start + config.indentUnit;
	          else
	            state.ctx.indentTo = "next";
	        } else if (state.ctx.indentTo == "next") {
	          state.ctx.indentTo = stream.column();
	        }
	        state.lastType = type;
	      }
	      if (type == "open") state.ctx = {prev: state.ctx, start: stream.column(), indentTo: null};
	      else if (type == "close") state.ctx = state.ctx.prev || state.ctx;
	      return style;
	    },
	
	    indent: function (state, _textAfter) {
	      var i = state.ctx.indentTo;
	      return typeof i == "number" ? i : state.ctx.start + 1;
	    },
	
	    closeBrackets: {pairs: "()[]{}\"\""},
	    lineComment: ";;",
	    blockCommentStart: "#|",
	    blockCommentEnd: "|#"
	  };
	});
	
	CodeMirror.defineMIME("text/x-common-lisp", "commonlisp");
	
	});


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("crystal", function(config) {
	    function wordRegExp(words, end) {
	      return new RegExp((end ? "" : "^") + "(?:" + words.join("|") + ")" + (end ? "$" : "\\b"));
	    }
	
	    function chain(tokenize, stream, state) {
	      state.tokenize.push(tokenize);
	      return tokenize(stream, state);
	    }
	
	    var operators = /^(?:[-+/%|&^]|\*\*?|[<>]{2})/;
	    var conditionalOperators = /^(?:[=!]~|===|<=>|[<>=!]=?|[|&]{2}|~)/;
	    var indexingOperators = /^(?:\[\][?=]?)/;
	    var anotherOperators = /^(?:\.(?:\.{2})?|->|[?:])/;
	    var idents = /^[a-z_\u009F-\uFFFF][a-zA-Z0-9_\u009F-\uFFFF]*/;
	    var types = /^[A-Z_\u009F-\uFFFF][a-zA-Z0-9_\u009F-\uFFFF]*/;
	    var keywords = wordRegExp([
	      "abstract", "alias", "as", "asm", "begin", "break", "case", "class", "def", "do",
	      "else", "elsif", "end", "ensure", "enum", "extend", "for", "fun", "if", "ifdef",
	      "include", "instance_sizeof", "lib", "macro", "module", "next", "of", "out", "pointerof",
	      "private", "protected", "rescue", "return", "require", "sizeof", "struct",
	      "super", "then", "type", "typeof", "union", "unless", "until", "when", "while", "with",
	      "yield", "__DIR__", "__FILE__", "__LINE__"
	    ]);
	    var atomWords = wordRegExp(["true", "false", "nil", "self"]);
	    var indentKeywordsArray = [
	      "def", "fun", "macro",
	      "class", "module", "struct", "lib", "enum", "union",
	      "if", "unless", "case", "while", "until", "begin", "then",
	      "do",
	      "for", "ifdef"
	    ];
	    var indentKeywords = wordRegExp(indentKeywordsArray);
	    var dedentKeywordsArray = [
	      "end",
	      "else", "elsif",
	      "rescue", "ensure"
	    ];
	    var dedentKeywords = wordRegExp(dedentKeywordsArray);
	    var dedentPunctualsArray = ["\\)", "\\}", "\\]"];
	    var dedentPunctuals = new RegExp("^(?:" + dedentPunctualsArray.join("|") + ")$");
	    var nextTokenizer = {
	      "def": tokenFollowIdent, "fun": tokenFollowIdent, "macro": tokenMacroDef,
	      "class": tokenFollowType, "module": tokenFollowType, "struct": tokenFollowType,
	      "lib": tokenFollowType, "enum": tokenFollowType, "union": tokenFollowType
	    };
	    var matching = {"[": "]", "{": "}", "(": ")", "<": ">"};
	
	    function tokenBase(stream, state) {
	      if (stream.eatSpace()) {
	        return null;
	      }
	
	      // Macros
	      if (state.lastToken != "\\" && stream.match("{%", false)) {
	        return chain(tokenMacro("%", "%"), stream, state);
	      }
	
	      if (state.lastToken != "\\" && stream.match("{{", false)) {
	        return chain(tokenMacro("{", "}"), stream, state);
	      }
	
	      // Comments
	      if (stream.peek() == "#") {
	        stream.skipToEnd();
	        return "comment";
	      }
	
	      // Variables and keywords
	      var matched;
	      if (stream.match(idents)) {
	        stream.eat(/[?!]/);
	
	        matched = stream.current();
	        if (stream.eat(":")) {
	          return "atom";
	        } else if (state.lastToken == ".") {
	          return "property";
	        } else if (keywords.test(matched)) {
	          if (state.lastToken != "abstract" && indentKeywords.test(matched)) {
	            if (!(matched == "fun" && state.blocks.indexOf("lib") >= 0)) {
	              state.blocks.push(matched);
	              state.currentIndent += 1;
	            }
	          } else if (dedentKeywords.test(matched)) {
	            state.blocks.pop();
	            state.currentIndent -= 1;
	          }
	
	          if (nextTokenizer.hasOwnProperty(matched)) {
	            state.tokenize.push(nextTokenizer[matched]);
	          }
	
	          return "keyword";
	        } else if (atomWords.test(matched)) {
	          return "atom";
	        }
	
	        return "variable";
	      }
	
	      // Class variables and instance variables
	      // or attributes
	      if (stream.eat("@")) {
	        if (stream.peek() == "[") {
	          return chain(tokenNest("[", "]", "meta"), stream, state);
	        }
	
	        stream.eat("@");
	        stream.match(idents) || stream.match(types);
	        return "variable-2";
	      }
	
	      // Global variables
	      if (stream.eat("$")) {
	        stream.eat(/[0-9]+|\?/) || stream.match(idents) || stream.match(types);
	        return "variable-3";
	      }
	
	      // Constants and types
	      if (stream.match(types)) {
	        return "tag";
	      }
	
	      // Symbols or ':' operator
	      if (stream.eat(":")) {
	        if (stream.eat("\"")) {
	          return chain(tokenQuote("\"", "atom", false), stream, state);
	        } else if (stream.match(idents) || stream.match(types) ||
	                   stream.match(operators) || stream.match(conditionalOperators) || stream.match(indexingOperators)) {
	          return "atom";
	        }
	        stream.eat(":");
	        return "operator";
	      }
	
	      // Strings
	      if (stream.eat("\"")) {
	        return chain(tokenQuote("\"", "string", true), stream, state);
	      }
	
	      // Strings or regexps or macro variables or '%' operator
	      if (stream.peek() == "%") {
	        var style = "string";
	        var embed = true;
	        var delim;
	
	        if (stream.match("%r")) {
	          // Regexps
	          style = "string-2";
	          delim = stream.next();
	        } else if (stream.match("%w")) {
	          embed = false;
	          delim = stream.next();
	        } else {
	          if(delim = stream.match(/^%([^\w\s=])/)) {
	            delim = delim[1];
	          } else if (stream.match(/^%[a-zA-Z0-9_\u009F-\uFFFF]*/)) {
	            // Macro variables
	            return "meta";
	          } else {
	            // '%' operator
	            return "operator";
	          }
	        }
	
	        if (matching.hasOwnProperty(delim)) {
	          delim = matching[delim];
	        }
	        return chain(tokenQuote(delim, style, embed), stream, state);
	      }
	
	      // Characters
	      if (stream.eat("'")) {
	        stream.match(/^(?:[^']|\\(?:[befnrtv0'"]|[0-7]{3}|u(?:[0-9a-fA-F]{4}|\{[0-9a-fA-F]{1,6}\})))/);
	        stream.eat("'");
	        return "atom";
	      }
	
	      // Numbers
	      if (stream.eat("0")) {
	        if (stream.eat("x")) {
	          stream.match(/^[0-9a-fA-F]+/);
	        } else if (stream.eat("o")) {
	          stream.match(/^[0-7]+/);
	        } else if (stream.eat("b")) {
	          stream.match(/^[01]+/);
	        }
	        return "number";
	      }
	
	      if (stream.eat(/\d/)) {
	        stream.match(/^\d*(?:\.\d+)?(?:[eE][+-]?\d+)?/);
	        return "number";
	      }
	
	      // Operators
	      if (stream.match(operators)) {
	        stream.eat("="); // Operators can follow assign symbol.
	        return "operator";
	      }
	
	      if (stream.match(conditionalOperators) || stream.match(anotherOperators)) {
	        return "operator";
	      }
	
	      // Parens and braces
	      if (matched = stream.match(/[({[]/, false)) {
	        matched = matched[0];
	        return chain(tokenNest(matched, matching[matched], null), stream, state);
	      }
	
	      // Escapes
	      if (stream.eat("\\")) {
	        stream.next();
	        return "meta";
	      }
	
	      stream.next();
	      return null;
	    }
	
	    function tokenNest(begin, end, style, started) {
	      return function (stream, state) {
	        if (!started && stream.match(begin)) {
	          state.tokenize[state.tokenize.length - 1] = tokenNest(begin, end, style, true);
	          state.currentIndent += 1;
	          return style;
	        }
	
	        var nextStyle = tokenBase(stream, state);
	        if (stream.current() === end) {
	          state.tokenize.pop();
	          state.currentIndent -= 1;
	          nextStyle = style;
	        }
	
	        return nextStyle;
	      };
	    }
	
	    function tokenMacro(begin, end, started) {
	      return function (stream, state) {
	        if (!started && stream.match("{" + begin)) {
	          state.currentIndent += 1;
	          state.tokenize[state.tokenize.length - 1] = tokenMacro(begin, end, true);
	          return "meta";
	        }
	
	        if (stream.match(end + "}")) {
	          state.currentIndent -= 1;
	          state.tokenize.pop();
	          return "meta";
	        }
	
	        return tokenBase(stream, state);
	      };
	    }
	
	    function tokenMacroDef(stream, state) {
	      if (stream.eatSpace()) {
	        return null;
	      }
	
	      var matched;
	      if (matched = stream.match(idents)) {
	        if (matched == "def") {
	          return "keyword";
	        }
	        stream.eat(/[?!]/);
	      }
	
	      state.tokenize.pop();
	      return "def";
	    }
	
	    function tokenFollowIdent(stream, state) {
	      if (stream.eatSpace()) {
	        return null;
	      }
	
	      if (stream.match(idents)) {
	        stream.eat(/[!?]/);
	      } else {
	        stream.match(operators) || stream.match(conditionalOperators) || stream.match(indexingOperators);
	      }
	      state.tokenize.pop();
	      return "def";
	    }
	
	    function tokenFollowType(stream, state) {
	      if (stream.eatSpace()) {
	        return null;
	      }
	
	      stream.match(types);
	      state.tokenize.pop();
	      return "def";
	    }
	
	    function tokenQuote(end, style, embed) {
	      return function (stream, state) {
	        var escaped = false;
	
	        while (stream.peek()) {
	          if (!escaped) {
	            if (stream.match("{%", false)) {
	              state.tokenize.push(tokenMacro("%", "%"));
	              return style;
	            }
	
	            if (stream.match("{{", false)) {
	              state.tokenize.push(tokenMacro("{", "}"));
	              return style;
	            }
	
	            if (embed && stream.match("#{", false)) {
	              state.tokenize.push(tokenNest("#{", "}", "meta"));
	              return style;
	            }
	
	            var ch = stream.next();
	
	            if (ch == end) {
	              state.tokenize.pop();
	              return style;
	            }
	
	            escaped = ch == "\\";
	          } else {
	            stream.next();
	            escaped = false;
	          }
	        }
	
	        return style;
	      };
	    }
	
	    return {
	      startState: function () {
	        return {
	          tokenize: [tokenBase],
	          currentIndent: 0,
	          lastToken: null,
	          blocks: []
	        };
	      },
	
	      token: function (stream, state) {
	        var style = state.tokenize[state.tokenize.length - 1](stream, state);
	        var token = stream.current();
	
	        if (style && style != "comment") {
	          state.lastToken = token;
	        }
	
	        return style;
	      },
	
	      indent: function (state, textAfter) {
	        textAfter = textAfter.replace(/^\s*(?:\{%)?\s*|\s*(?:%\})?\s*$/g, "");
	
	        if (dedentKeywords.test(textAfter) || dedentPunctuals.test(textAfter)) {
	          return config.indentUnit * (state.currentIndent - 1);
	        }
	
	        return config.indentUnit * state.currentIndent;
	      },
	
	      fold: "indent",
	      electricInput: wordRegExp(dedentPunctualsArray.concat(dedentKeywordsArray), true),
	      lineComment: '#'
	    };
	  });
	
	  CodeMirror.defineMIME("text/x-crystal", "crystal");
	});


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// By the Neo4j Team and contributors.
	// https://github.com/neo4j-contrib/CodeMirror
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	  var wordRegexp = function(words) {
	    return new RegExp("^(?:" + words.join("|") + ")$", "i");
	  };
	
	  CodeMirror.defineMode("cypher", function(config) {
	    var tokenBase = function(stream/*, state*/) {
	      var ch = stream.next();
	      if (ch ==='"') {
	        stream.match(/.*?"/);
	        return "string";
	      }
	      if (ch === "'") {
	        stream.match(/.*?'/);
	        return "string";
	      }
	      if (/[{}\(\),\.;\[\]]/.test(ch)) {
	        curPunc = ch;
	        return "node";
	      } else if (ch === "/" && stream.eat("/")) {
	        stream.skipToEnd();
	        return "comment";
	      } else if (operatorChars.test(ch)) {
	        stream.eatWhile(operatorChars);
	        return null;
	      } else {
	        stream.eatWhile(/[_\w\d]/);
	        if (stream.eat(":")) {
	          stream.eatWhile(/[\w\d_\-]/);
	          return "atom";
	        }
	        var word = stream.current();
	        if (funcs.test(word)) return "builtin";
	        if (preds.test(word)) return "def";
	        if (keywords.test(word)) return "keyword";
	        return "variable";
	      }
	    };
	    var pushContext = function(state, type, col) {
	      return state.context = {
	        prev: state.context,
	        indent: state.indent,
	        col: col,
	        type: type
	      };
	    };
	    var popContext = function(state) {
	      state.indent = state.context.indent;
	      return state.context = state.context.prev;
	    };
	    var indentUnit = config.indentUnit;
	    var curPunc;
	    var funcs = wordRegexp(["abs", "acos", "allShortestPaths", "asin", "atan", "atan2", "avg", "ceil", "coalesce", "collect", "cos", "cot", "count", "degrees", "e", "endnode", "exp", "extract", "filter", "floor", "haversin", "head", "id", "keys", "labels", "last", "left", "length", "log", "log10", "lower", "ltrim", "max", "min", "node", "nodes", "percentileCont", "percentileDisc", "pi", "radians", "rand", "range", "reduce", "rel", "relationship", "relationships", "replace", "reverse", "right", "round", "rtrim", "shortestPath", "sign", "sin", "size", "split", "sqrt", "startnode", "stdev", "stdevp", "str", "substring", "sum", "tail", "tan", "timestamp", "toFloat", "toInt", "toString", "trim", "type", "upper"]);
	    var preds = wordRegexp(["all", "and", "any", "contains", "exists", "has", "in", "none", "not", "or", "single", "xor"]);
	    var keywords = wordRegexp(["as", "asc", "ascending", "assert", "by", "case", "commit", "constraint", "create", "csv", "cypher", "delete", "desc", "descending", "detach", "distinct", "drop", "else", "end", "ends", "explain", "false", "fieldterminator", "foreach", "from", "headers", "in", "index", "is", "join", "limit", "load", "match", "merge", "null", "on", "optional", "order", "periodic", "profile", "remove", "return", "scan", "set", "skip", "start", "starts", "then", "true", "union", "unique", "unwind", "using", "when", "where", "with", "call", "yield"]);
	    var operatorChars = /[*+\-<>=&|~%^]/;
	
	    return {
	      startState: function(/*base*/) {
	        return {
	          tokenize: tokenBase,
	          context: null,
	          indent: 0,
	          col: 0
	        };
	      },
	      token: function(stream, state) {
	        if (stream.sol()) {
	          if (state.context && (state.context.align == null)) {
	            state.context.align = false;
	          }
	          state.indent = stream.indentation();
	        }
	        if (stream.eatSpace()) {
	          return null;
	        }
	        var style = state.tokenize(stream, state);
	        if (style !== "comment" && state.context && (state.context.align == null) && state.context.type !== "pattern") {
	          state.context.align = true;
	        }
	        if (curPunc === "(") {
	          pushContext(state, ")", stream.column());
	        } else if (curPunc === "[") {
	          pushContext(state, "]", stream.column());
	        } else if (curPunc === "{") {
	          pushContext(state, "}", stream.column());
	        } else if (/[\]\}\)]/.test(curPunc)) {
	          while (state.context && state.context.type === "pattern") {
	            popContext(state);
	          }
	          if (state.context && curPunc === state.context.type) {
	            popContext(state);
	          }
	        } else if (curPunc === "." && state.context && state.context.type === "pattern") {
	          popContext(state);
	        } else if (/atom|string|variable/.test(style) && state.context) {
	          if (/[\}\]]/.test(state.context.type)) {
	            pushContext(state, "pattern", stream.column());
	          } else if (state.context.type === "pattern" && !state.context.align) {
	            state.context.align = true;
	            state.context.col = stream.column();
	          }
	        }
	        return style;
	      },
	      indent: function(state, textAfter) {
	        var firstChar = textAfter && textAfter.charAt(0);
	        var context = state.context;
	        if (/[\]\}]/.test(firstChar)) {
	          while (context && context.type === "pattern") {
	            context = context.prev;
	          }
	        }
	        var closing = context && firstChar === context.type;
	        if (!context) return 0;
	        if (context.type === "keywords") return CodeMirror.commands.newlineAndIndent;
	        if (context.align) return context.col + (closing ? 0 : 1);
	        return context.indent + (closing ? 0 : indentUnit);
	      }
	    };
	  });
	
	  CodeMirror.modeExtensions["cypher"] = {
	    autoFormatLineBreaks: function(text) {
	      var i, lines, reProcessedPortion;
	      var lines = text.split("\n");
	      var reProcessedPortion = /\s+\b(return|where|order by|match|with|skip|limit|create|delete|set)\b\s/g;
	      for (var i = 0; i < lines.length; i++)
	        lines[i] = lines[i].replace(reProcessedPortion, " \n$1 ").trim();
	      return lines.join("\n");
	    }
	  };
	
	  CodeMirror.defineMIME("application/x-cypher-query", "cypher");
	
	});


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("d", function(config, parserConfig) {
	  var indentUnit = config.indentUnit,
	      statementIndentUnit = parserConfig.statementIndentUnit || indentUnit,
	      keywords = parserConfig.keywords || {},
	      builtin = parserConfig.builtin || {},
	      blockKeywords = parserConfig.blockKeywords || {},
	      atoms = parserConfig.atoms || {},
	      hooks = parserConfig.hooks || {},
	      multiLineStrings = parserConfig.multiLineStrings;
	  var isOperatorChar = /[+\-*&%=<>!?|\/]/;
	
	  var curPunc;
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    if (hooks[ch]) {
	      var result = hooks[ch](stream, state);
	      if (result !== false) return result;
	    }
	    if (ch == '"' || ch == "'" || ch == "`") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    }
	    if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
	      curPunc = ch;
	      return null;
	    }
	    if (/\d/.test(ch)) {
	      stream.eatWhile(/[\w\.]/);
	      return "number";
	    }
	    if (ch == "/") {
	      if (stream.eat("+")) {
	        state.tokenize = tokenComment;
	        return tokenNestedComment(stream, state);
	      }
	      if (stream.eat("*")) {
	        state.tokenize = tokenComment;
	        return tokenComment(stream, state);
	      }
	      if (stream.eat("/")) {
	        stream.skipToEnd();
	        return "comment";
	      }
	    }
	    if (isOperatorChar.test(ch)) {
	      stream.eatWhile(isOperatorChar);
	      return "operator";
	    }
	    stream.eatWhile(/[\w\$_\xa1-\uffff]/);
	    var cur = stream.current();
	    if (keywords.propertyIsEnumerable(cur)) {
	      if (blockKeywords.propertyIsEnumerable(cur)) curPunc = "newstatement";
	      return "keyword";
	    }
	    if (builtin.propertyIsEnumerable(cur)) {
	      if (blockKeywords.propertyIsEnumerable(cur)) curPunc = "newstatement";
	      return "builtin";
	    }
	    if (atoms.propertyIsEnumerable(cur)) return "atom";
	    return "variable";
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, next, end = false;
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) {end = true; break;}
	        escaped = !escaped && next == "\\";
	      }
	      if (end || !(escaped || multiLineStrings))
	        state.tokenize = null;
	      return "string";
	    };
	  }
	
	  function tokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while (ch = stream.next()) {
	      if (ch == "/" && maybeEnd) {
	        state.tokenize = null;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return "comment";
	  }
	
	  function tokenNestedComment(stream, state) {
	    var maybeEnd = false, ch;
	    while (ch = stream.next()) {
	      if (ch == "/" && maybeEnd) {
	        state.tokenize = null;
	        break;
	      }
	      maybeEnd = (ch == "+");
	    }
	    return "comment";
	  }
	
	  function Context(indented, column, type, align, prev) {
	    this.indented = indented;
	    this.column = column;
	    this.type = type;
	    this.align = align;
	    this.prev = prev;
	  }
	  function pushContext(state, col, type) {
	    var indent = state.indented;
	    if (state.context && state.context.type == "statement")
	      indent = state.context.indented;
	    return state.context = new Context(indent, col, type, null, state.context);
	  }
	  function popContext(state) {
	    var t = state.context.type;
	    if (t == ")" || t == "]" || t == "}")
	      state.indented = state.context.indented;
	    return state.context = state.context.prev;
	  }
	
	  // Interface
	
	  return {
	    startState: function(basecolumn) {
	      return {
	        tokenize: null,
	        context: new Context((basecolumn || 0) - indentUnit, 0, "top", false),
	        indented: 0,
	        startOfLine: true
	      };
	    },
	
	    token: function(stream, state) {
	      var ctx = state.context;
	      if (stream.sol()) {
	        if (ctx.align == null) ctx.align = false;
	        state.indented = stream.indentation();
	        state.startOfLine = true;
	      }
	      if (stream.eatSpace()) return null;
	      curPunc = null;
	      var style = (state.tokenize || tokenBase)(stream, state);
	      if (style == "comment" || style == "meta") return style;
	      if (ctx.align == null) ctx.align = true;
	
	      if ((curPunc == ";" || curPunc == ":" || curPunc == ",") && ctx.type == "statement") popContext(state);
	      else if (curPunc == "{") pushContext(state, stream.column(), "}");
	      else if (curPunc == "[") pushContext(state, stream.column(), "]");
	      else if (curPunc == "(") pushContext(state, stream.column(), ")");
	      else if (curPunc == "}") {
	        while (ctx.type == "statement") ctx = popContext(state);
	        if (ctx.type == "}") ctx = popContext(state);
	        while (ctx.type == "statement") ctx = popContext(state);
	      }
	      else if (curPunc == ctx.type) popContext(state);
	      else if (((ctx.type == "}" || ctx.type == "top") && curPunc != ';') || (ctx.type == "statement" && curPunc == "newstatement"))
	        pushContext(state, stream.column(), "statement");
	      state.startOfLine = false;
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      if (state.tokenize != tokenBase && state.tokenize != null) return CodeMirror.Pass;
	      var ctx = state.context, firstChar = textAfter && textAfter.charAt(0);
	      if (ctx.type == "statement" && firstChar == "}") ctx = ctx.prev;
	      var closing = firstChar == ctx.type;
	      if (ctx.type == "statement") return ctx.indented + (firstChar == "{" ? 0 : statementIndentUnit);
	      else if (ctx.align) return ctx.column + (closing ? 0 : 1);
	      else return ctx.indented + (closing ? 0 : indentUnit);
	    },
	
	    electricChars: "{}"
	  };
	});
	
	  function words(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	
	  var blockKeywords = "body catch class do else enum for foreach foreach_reverse if in interface mixin " +
	                      "out scope struct switch try union unittest version while with";
	
	  CodeMirror.defineMIME("text/x-d", {
	    name: "d",
	    keywords: words("abstract alias align asm assert auto break case cast cdouble cent cfloat const continue " +
	                    "debug default delegate delete deprecated export extern final finally function goto immutable " +
	                    "import inout invariant is lazy macro module new nothrow override package pragma private " +
	                    "protected public pure ref return shared short static super synchronized template this " +
	                    "throw typedef typeid typeof volatile __FILE__ __LINE__ __gshared __traits __vector __parameters " +
	                    blockKeywords),
	    blockKeywords: words(blockKeywords),
	    builtin: words("bool byte char creal dchar double float idouble ifloat int ireal long real short ubyte " +
	                   "ucent uint ulong ushort wchar wstring void size_t sizediff_t"),
	    atoms: words("exit failure success true false null"),
	    hooks: {
	      "@": function(stream, _state) {
	        stream.eatWhile(/[\w\$_]/);
	        return "meta";
	      }
	    }
	  });
	
	});


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(26));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../clike/clike"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  var keywords = ("this super static final const abstract class extends external factory " +
	    "implements get native operator set typedef with enum throw rethrow " +
	    "assert break case continue default in return new deferred async await " +
	    "try catch finally do else for if switch while import library export " +
	    "part of show hide is as").split(" ");
	  var blockKeywords = "try catch finally do else for if switch while".split(" ");
	  var atoms = "true false null".split(" ");
	  var builtins = "void bool num int double dynamic var String".split(" ");
	
	  function set(words) {
	    var obj = {};
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	
	  function pushInterpolationStack(state) {
	    (state.interpolationStack || (state.interpolationStack = [])).push(state.tokenize);
	  }
	
	  function popInterpolationStack(state) {
	    return (state.interpolationStack || (state.interpolationStack = [])).pop();
	  }
	
	  function sizeInterpolationStack(state) {
	    return state.interpolationStack ? state.interpolationStack.length : 0;
	  }
	
	  CodeMirror.defineMIME("application/dart", {
	    name: "clike",
	    keywords: set(keywords),
	    blockKeywords: set(blockKeywords),
	    builtin: set(builtins),
	    atoms: set(atoms),
	    hooks: {
	      "@": function(stream) {
	        stream.eatWhile(/[\w\$_\.]/);
	        return "meta";
	      },
	
	      // custom string handling to deal with triple-quoted strings and string interpolation
	      "'": function(stream, state) {
	        return tokenString("'", stream, state, false);
	      },
	      "\"": function(stream, state) {
	        return tokenString("\"", stream, state, false);
	      },
	      "r": function(stream, state) {
	        var peek = stream.peek();
	        if (peek == "'" || peek == "\"") {
	          return tokenString(stream.next(), stream, state, true);
	        }
	        return false;
	      },
	
	      "}": function(_stream, state) {
	        // "}" is end of interpolation, if interpolation stack is non-empty
	        if (sizeInterpolationStack(state) > 0) {
	          state.tokenize = popInterpolationStack(state);
	          return null;
	        }
	        return false;
	      },
	
	      "/": function(stream, state) {
	        if (!stream.eat("*")) return false
	        state.tokenize = tokenNestedComment(1)
	        return state.tokenize(stream, state)
	      }
	    }
	  });
	
	  function tokenString(quote, stream, state, raw) {
	    var tripleQuoted = false;
	    if (stream.eat(quote)) {
	      if (stream.eat(quote)) tripleQuoted = true;
	      else return "string"; //empty string
	    }
	    function tokenStringHelper(stream, state) {
	      var escaped = false;
	      while (!stream.eol()) {
	        if (!raw && !escaped && stream.peek() == "$") {
	          pushInterpolationStack(state);
	          state.tokenize = tokenInterpolation;
	          return "string";
	        }
	        var next = stream.next();
	        if (next == quote && !escaped && (!tripleQuoted || stream.match(quote + quote))) {
	          state.tokenize = null;
	          break;
	        }
	        escaped = !raw && !escaped && next == "\\";
	      }
	      return "string";
	    }
	    state.tokenize = tokenStringHelper;
	    return tokenStringHelper(stream, state);
	  }
	
	  function tokenInterpolation(stream, state) {
	    stream.eat("$");
	    if (stream.eat("{")) {
	      // let clike handle the content of ${...},
	      // we take over again when "}" appears (see hooks).
	      state.tokenize = null;
	    } else {
	      state.tokenize = tokenInterpolationIdentifier;
	    }
	    return null;
	  }
	
	  function tokenInterpolationIdentifier(stream, state) {
	    stream.eatWhile(/[\w_]/);
	    state.tokenize = popInterpolationStack(state);
	    return "variable";
	  }
	
	  function tokenNestedComment(depth) {
	    return function (stream, state) {
	      var ch
	      while (ch = stream.next()) {
	        if (ch == "*" && stream.eat("/")) {
	          if (depth == 1) {
	            state.tokenize = null
	            break
	          } else {
	            state.tokenize = tokenNestedComment(depth - 1)
	            return state.tokenize(stream, state)
	          }
	        } else if (ch == "/" && stream.eat("*")) {
	          state.tokenize = tokenNestedComment(depth + 1)
	          return state.tokenize(stream, state)
	        }
	      }
	      return "comment"
	    }
	  }
	
	  CodeMirror.registerHelper("hintWords", "application/dart", keywords.concat(atoms).concat(builtins));
	
	  // This is needed to make loading through meta.js work.
	  CodeMirror.defineMode("dart", function(conf) {
	    return CodeMirror.getMode(conf, "application/dart");
	  }, "clike");
	});


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("diff", function() {
	
	  var TOKEN_NAMES = {
	    '+': 'positive',
	    '-': 'negative',
	    '@': 'meta'
	  };
	
	  return {
	    token: function(stream) {
	      var tw_pos = stream.string.search(/[\t ]+?$/);
	
	      if (!stream.sol() || tw_pos === 0) {
	        stream.skipToEnd();
	        return ("error " + (
	          TOKEN_NAMES[stream.string.charAt(0)] || '')).replace(/ $/, '');
	      }
	
	      var token_name = TOKEN_NAMES[stream.peek()] || stream.skipToEnd();
	
	      if (tw_pos === -1) {
	        stream.skipToEnd();
	      } else {
	        stream.pos = tw_pos;
	      }
	
	      return token_name;
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/x-diff", "diff");
	
	});


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(5),
	        __webpack_require__(19));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../htmlmixed/htmlmixed",
	            "../../addon/mode/overlay"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("django:inner", function() {
	    var keywords = ["block", "endblock", "for", "endfor", "true", "false", "filter", "endfilter",
	                    "loop", "none", "self", "super", "if", "elif", "endif", "as", "else", "import",
	                    "with", "endwith", "without", "context", "ifequal", "endifequal", "ifnotequal",
	                    "endifnotequal", "extends", "include", "load", "comment", "endcomment",
	                    "empty", "url", "static", "trans", "blocktrans", "endblocktrans", "now",
	                    "regroup", "lorem", "ifchanged", "endifchanged", "firstof", "debug", "cycle",
	                    "csrf_token", "autoescape", "endautoescape", "spaceless", "endspaceless",
	                    "ssi", "templatetag", "verbatim", "endverbatim", "widthratio"],
	        filters = ["add", "addslashes", "capfirst", "center", "cut", "date",
	                   "default", "default_if_none", "dictsort",
	                   "dictsortreversed", "divisibleby", "escape", "escapejs",
	                   "filesizeformat", "first", "floatformat", "force_escape",
	                   "get_digit", "iriencode", "join", "last", "length",
	                   "length_is", "linebreaks", "linebreaksbr", "linenumbers",
	                   "ljust", "lower", "make_list", "phone2numeric", "pluralize",
	                   "pprint", "random", "removetags", "rjust", "safe",
	                   "safeseq", "slice", "slugify", "stringformat", "striptags",
	                   "time", "timesince", "timeuntil", "title", "truncatechars",
	                   "truncatechars_html", "truncatewords", "truncatewords_html",
	                   "unordered_list", "upper", "urlencode", "urlize",
	                   "urlizetrunc", "wordcount", "wordwrap", "yesno"],
	        operators = ["==", "!=", "<", ">", "<=", ">="],
	        wordOperators = ["in", "not", "or", "and"];
	
	    keywords = new RegExp("^\\b(" + keywords.join("|") + ")\\b");
	    filters = new RegExp("^\\b(" + filters.join("|") + ")\\b");
	    operators = new RegExp("^\\b(" + operators.join("|") + ")\\b");
	    wordOperators = new RegExp("^\\b(" + wordOperators.join("|") + ")\\b");
	
	    // We have to return "null" instead of null, in order to avoid string
	    // styling as the default, when using Django templates inside HTML
	    // element attributes
	    function tokenBase (stream, state) {
	      // Attempt to identify a variable, template or comment tag respectively
	      if (stream.match("{{")) {
	        state.tokenize = inVariable;
	        return "tag";
	      } else if (stream.match("{%")) {
	        state.tokenize = inTag;
	        return "tag";
	      } else if (stream.match("{#")) {
	        state.tokenize = inComment;
	        return "comment";
	      }
	
	      // Ignore completely any stream series that do not match the
	      // Django template opening tags.
	      while (stream.next() != null && !stream.match(/\{[{%#]/, false)) {}
	      return null;
	    }
	
	    // A string can be included in either single or double quotes (this is
	    // the delimiter). Mark everything as a string until the start delimiter
	    // occurs again.
	    function inString (delimiter, previousTokenizer) {
	      return function (stream, state) {
	        if (!state.escapeNext && stream.eat(delimiter)) {
	          state.tokenize = previousTokenizer;
	        } else {
	          if (state.escapeNext) {
	            state.escapeNext = false;
	          }
	
	          var ch = stream.next();
	
	          // Take into account the backslash for escaping characters, such as
	          // the string delimiter.
	          if (ch == "\\") {
	            state.escapeNext = true;
	          }
	        }
	
	        return "string";
	      };
	    }
	
	    // Apply Django template variable syntax highlighting
	    function inVariable (stream, state) {
	      // Attempt to match a dot that precedes a property
	      if (state.waitDot) {
	        state.waitDot = false;
	
	        if (stream.peek() != ".") {
	          return "null";
	        }
	
	        // Dot followed by a non-word character should be considered an error.
	        if (stream.match(/\.\W+/)) {
	          return "error";
	        } else if (stream.eat(".")) {
	          state.waitProperty = true;
	          return "null";
	        } else {
	          throw Error ("Unexpected error while waiting for property.");
	        }
	      }
	
	      // Attempt to match a pipe that precedes a filter
	      if (state.waitPipe) {
	        state.waitPipe = false;
	
	        if (stream.peek() != "|") {
	          return "null";
	        }
	
	        // Pipe followed by a non-word character should be considered an error.
	        if (stream.match(/\.\W+/)) {
	          return "error";
	        } else if (stream.eat("|")) {
	          state.waitFilter = true;
	          return "null";
	        } else {
	          throw Error ("Unexpected error while waiting for filter.");
	        }
	      }
	
	      // Highlight properties
	      if (state.waitProperty) {
	        state.waitProperty = false;
	        if (stream.match(/\b(\w+)\b/)) {
	          state.waitDot = true;  // A property can be followed by another property
	          state.waitPipe = true;  // A property can be followed by a filter
	          return "property";
	        }
	      }
	
	      // Highlight filters
	      if (state.waitFilter) {
	          state.waitFilter = false;
	        if (stream.match(filters)) {
	          return "variable-2";
	        }
	      }
	
	      // Ignore all white spaces
	      if (stream.eatSpace()) {
	        state.waitProperty = false;
	        return "null";
	      }
	
	      // Identify numbers
	      if (stream.match(/\b\d+(\.\d+)?\b/)) {
	        return "number";
	      }
	
	      // Identify strings
	      if (stream.match("'")) {
	        state.tokenize = inString("'", state.tokenize);
	        return "string";
	      } else if (stream.match('"')) {
	        state.tokenize = inString('"', state.tokenize);
	        return "string";
	      }
	
	      // Attempt to find the variable
	      if (stream.match(/\b(\w+)\b/) && !state.foundVariable) {
	        state.waitDot = true;
	        state.waitPipe = true;  // A property can be followed by a filter
	        return "variable";
	      }
	
	      // If found closing tag reset
	      if (stream.match("}}")) {
	        state.waitProperty = null;
	        state.waitFilter = null;
	        state.waitDot = null;
	        state.waitPipe = null;
	        state.tokenize = tokenBase;
	        return "tag";
	      }
	
	      // If nothing was found, advance to the next character
	      stream.next();
	      return "null";
	    }
	
	    function inTag (stream, state) {
	      // Attempt to match a dot that precedes a property
	      if (state.waitDot) {
	        state.waitDot = false;
	
	        if (stream.peek() != ".") {
	          return "null";
	        }
	
	        // Dot followed by a non-word character should be considered an error.
	        if (stream.match(/\.\W+/)) {
	          return "error";
	        } else if (stream.eat(".")) {
	          state.waitProperty = true;
	          return "null";
	        } else {
	          throw Error ("Unexpected error while waiting for property.");
	        }
	      }
	
	      // Attempt to match a pipe that precedes a filter
	      if (state.waitPipe) {
	        state.waitPipe = false;
	
	        if (stream.peek() != "|") {
	          return "null";
	        }
	
	        // Pipe followed by a non-word character should be considered an error.
	        if (stream.match(/\.\W+/)) {
	          return "error";
	        } else if (stream.eat("|")) {
	          state.waitFilter = true;
	          return "null";
	        } else {
	          throw Error ("Unexpected error while waiting for filter.");
	        }
	      }
	
	      // Highlight properties
	      if (state.waitProperty) {
	        state.waitProperty = false;
	        if (stream.match(/\b(\w+)\b/)) {
	          state.waitDot = true;  // A property can be followed by another property
	          state.waitPipe = true;  // A property can be followed by a filter
	          return "property";
	        }
	      }
	
	      // Highlight filters
	      if (state.waitFilter) {
	          state.waitFilter = false;
	        if (stream.match(filters)) {
	          return "variable-2";
	        }
	      }
	
	      // Ignore all white spaces
	      if (stream.eatSpace()) {
	        state.waitProperty = false;
	        return "null";
	      }
	
	      // Identify numbers
	      if (stream.match(/\b\d+(\.\d+)?\b/)) {
	        return "number";
	      }
	
	      // Identify strings
	      if (stream.match("'")) {
	        state.tokenize = inString("'", state.tokenize);
	        return "string";
	      } else if (stream.match('"')) {
	        state.tokenize = inString('"', state.tokenize);
	        return "string";
	      }
	
	      // Attempt to match an operator
	      if (stream.match(operators)) {
	        return "operator";
	      }
	
	      // Attempt to match a word operator
	      if (stream.match(wordOperators)) {
	        return "keyword";
	      }
	
	      // Attempt to match a keyword
	      var keywordMatch = stream.match(keywords);
	      if (keywordMatch) {
	        if (keywordMatch[0] == "comment") {
	          state.blockCommentTag = true;
	        }
	        return "keyword";
	      }
	
	      // Attempt to match a variable
	      if (stream.match(/\b(\w+)\b/)) {
	        state.waitDot = true;
	        state.waitPipe = true;  // A property can be followed by a filter
	        return "variable";
	      }
	
	      // If found closing tag reset
	      if (stream.match("%}")) {
	        state.waitProperty = null;
	        state.waitFilter = null;
	        state.waitDot = null;
	        state.waitPipe = null;
	        // If the tag that closes is a block comment tag, we want to mark the
	        // following code as comment, until the tag closes.
	        if (state.blockCommentTag) {
	          state.blockCommentTag = false;  // Release the "lock"
	          state.tokenize = inBlockComment;
	        } else {
	          state.tokenize = tokenBase;
	        }
	        return "tag";
	      }
	
	      // If nothing was found, advance to the next character
	      stream.next();
	      return "null";
	    }
	
	    // Mark everything as comment inside the tag and the tag itself.
	    function inComment (stream, state) {
	      if (stream.match(/^.*?#\}/)) state.tokenize = tokenBase
	      else stream.skipToEnd()
	      return "comment";
	    }
	
	    // Mark everything as a comment until the `blockcomment` tag closes.
	    function inBlockComment (stream, state) {
	      if (stream.match(/\{%\s*endcomment\s*%\}/, false)) {
	        state.tokenize = inTag;
	        stream.match("{%");
	        return "tag";
	      } else {
	        stream.next();
	        return "comment";
	      }
	    }
	
	    return {
	      startState: function () {
	        return {tokenize: tokenBase};
	      },
	      token: function (stream, state) {
	        return state.tokenize(stream, state);
	      },
	      blockCommentStart: "{% comment %}",
	      blockCommentEnd: "{% endcomment %}"
	    };
	  });
	
	  CodeMirror.defineMode("django", function(config) {
	    var htmlBase = CodeMirror.getMode(config, "text/html");
	    var djangoInner = CodeMirror.getMode(config, "django:inner");
	    return CodeMirror.overlayMode(htmlBase, djangoInner);
	  });
	
	  CodeMirror.defineMIME("text/x-django", "django");
	});


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(20));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../../addon/mode/simple"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  // Collect all Dockerfile directives
	  var instructions = ["from", "maintainer", "run", "cmd", "expose", "env",
	                      "add", "copy", "entrypoint", "volume", "user",
	                      "workdir", "onbuild"],
	      instructionRegex = "(" + instructions.join('|') + ")",
	      instructionOnlyLine = new RegExp(instructionRegex + "\\s*$", "i"),
	      instructionWithArguments = new RegExp(instructionRegex + "(\\s+)", "i");
	
	  CodeMirror.defineSimpleMode("dockerfile", {
	    start: [
	      // Block comment: This is a line starting with a comment
	      {
	        regex: /#.*$/,
	        token: "comment"
	      },
	      // Highlight an instruction without any arguments (for convenience)
	      {
	        regex: instructionOnlyLine,
	        token: "variable-2"
	      },
	      // Highlight an instruction followed by arguments
	      {
	        regex: instructionWithArguments,
	        token: ["variable-2", null],
	        next: "arguments"
	      },
	      {
	        regex: /./,
	        token: null
	      }
	    ],
	    arguments: [
	      {
	        // Line comment without instruction arguments is an error
	        regex: /#.*$/,
	        token: "error",
	        next: "start"
	      },
	      {
	        regex: /[^#]+\\$/,
	        token: null
	      },
	      {
	        // Match everything except for the inline comment
	        regex: /[^#]+/,
	        token: null,
	        next: "start"
	      },
	      {
	        regex: /$/,
	        token: null,
	        next: "start"
	      },
	      // Fail safe return to start
	      {
	        token: null,
	        next: "start"
	      }
	    ],
	      meta: {
	          lineComment: "#"
	      }
	  });
	
	  CodeMirror.defineMIME("text/x-dockerfile", "dockerfile");
	});


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	/*
	  DTD mode
	  Ported to CodeMirror by Peter Kroon <plakroon@gmail.com>
	  Report bugs/issues here: https://github.com/codemirror/CodeMirror/issues
	  GitHub: @peterkroon
	*/
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("dtd", function(config) {
	  var indentUnit = config.indentUnit, type;
	  function ret(style, tp) {type = tp; return style;}
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	
	    if (ch == "<" && stream.eat("!") ) {
	      if (stream.eatWhile(/[\-]/)) {
	        state.tokenize = tokenSGMLComment;
	        return tokenSGMLComment(stream, state);
	      } else if (stream.eatWhile(/[\w]/)) return ret("keyword", "doindent");
	    } else if (ch == "<" && stream.eat("?")) { //xml declaration
	      state.tokenize = inBlock("meta", "?>");
	      return ret("meta", ch);
	    } else if (ch == "#" && stream.eatWhile(/[\w]/)) return ret("atom", "tag");
	    else if (ch == "|") return ret("keyword", "seperator");
	    else if (ch.match(/[\(\)\[\]\-\.,\+\?>]/)) return ret(null, ch);//if(ch === ">") return ret(null, "endtag"); else
	    else if (ch.match(/[\[\]]/)) return ret("rule", ch);
	    else if (ch == "\"" || ch == "'") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    } else if (stream.eatWhile(/[a-zA-Z\?\+\d]/)) {
	      var sc = stream.current();
	      if( sc.substr(sc.length-1,sc.length).match(/\?|\+/) !== null )stream.backUp(1);
	      return ret("tag", "tag");
	    } else if (ch == "%" || ch == "*" ) return ret("number", "number");
	    else {
	      stream.eatWhile(/[\w\\\-_%.{,]/);
	      return ret(null, null);
	    }
	  }
	
	  function tokenSGMLComment(stream, state) {
	    var dashes = 0, ch;
	    while ((ch = stream.next()) != null) {
	      if (dashes >= 2 && ch == ">") {
	        state.tokenize = tokenBase;
	        break;
	      }
	      dashes = (ch == "-") ? dashes + 1 : 0;
	    }
	    return ret("comment", "comment");
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == quote && !escaped) {
	          state.tokenize = tokenBase;
	          break;
	        }
	        escaped = !escaped && ch == "\\";
	      }
	      return ret("string", "tag");
	    };
	  }
	
	  function inBlock(style, terminator) {
	    return function(stream, state) {
	      while (!stream.eol()) {
	        if (stream.match(terminator)) {
	          state.tokenize = tokenBase;
	          break;
	        }
	        stream.next();
	      }
	      return style;
	    };
	  }
	
	  return {
	    startState: function(base) {
	      return {tokenize: tokenBase,
	              baseIndent: base || 0,
	              stack: []};
	    },
	
	    token: function(stream, state) {
	      if (stream.eatSpace()) return null;
	      var style = state.tokenize(stream, state);
	
	      var context = state.stack[state.stack.length-1];
	      if (stream.current() == "[" || type === "doindent" || type == "[") state.stack.push("rule");
	      else if (type === "endtag") state.stack[state.stack.length-1] = "endtag";
	      else if (stream.current() == "]" || type == "]" || (type == ">" && context == "rule")) state.stack.pop();
	      else if (type == "[") state.stack.push("[");
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      var n = state.stack.length;
	
	      if( textAfter.match(/\]\s+|\]/) )n=n-1;
	      else if(textAfter.substr(textAfter.length-1, textAfter.length) === ">"){
	        if(textAfter.substr(0,1) === "<") {}
	        else if( type == "doindent" && textAfter.length > 1 ) {}
	        else if( type == "doindent")n--;
	        else if( type == ">" && textAfter.length > 1) {}
	        else if( type == "tag" && textAfter !== ">") {}
	        else if( type == "tag" && state.stack[state.stack.length-1] == "rule")n--;
	        else if( type == "tag")n++;
	        else if( textAfter === ">" && state.stack[state.stack.length-1] == "rule" && type === ">")n--;
	        else if( textAfter === ">" && state.stack[state.stack.length-1] == "rule") {}
	        else if( textAfter.substr(0,1) !== "<" && textAfter.substr(0,1) === ">" )n=n-1;
	        else if( textAfter === ">") {}
	        else n=n-1;
	        //over rule them all
	        if(type == null || type == "]")n--;
	      }
	
	      return state.baseIndent + n * indentUnit;
	    },
	
	    electricChars: "]>"
	  };
	});
	
	CodeMirror.defineMIME("application/xml-dtd", "dtd");
	
	});


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("dylan", function(_config) {
	  // Words
	  var words = {
	    // Words that introduce unnamed definitions like "define interface"
	    unnamedDefinition: ["interface"],
	
	    // Words that introduce simple named definitions like "define library"
	    namedDefinition: ["module", "library", "macro",
	                      "C-struct", "C-union",
	                      "C-function", "C-callable-wrapper"
	                     ],
	
	    // Words that introduce type definitions like "define class".
	    // These are also parameterized like "define method" and are
	    // appended to otherParameterizedDefinitionWords
	    typeParameterizedDefinition: ["class", "C-subtype", "C-mapped-subtype"],
	
	    // Words that introduce trickier definitions like "define method".
	    // These require special definitions to be added to startExpressions
	    otherParameterizedDefinition: ["method", "function",
	                                   "C-variable", "C-address"
	                                  ],
	
	    // Words that introduce module constant definitions.
	    // These must also be simple definitions and are
	    // appended to otherSimpleDefinitionWords
	    constantSimpleDefinition: ["constant"],
	
	    // Words that introduce module variable definitions.
	    // These must also be simple definitions and are
	    // appended to otherSimpleDefinitionWords
	    variableSimpleDefinition: ["variable"],
	
	    // Other words that introduce simple definitions
	    // (without implicit bodies).
	    otherSimpleDefinition: ["generic", "domain",
	                            "C-pointer-type",
	                            "table"
	                           ],
	
	    // Words that begin statements with implicit bodies.
	    statement: ["if", "block", "begin", "method", "case",
	                "for", "select", "when", "unless", "until",
	                "while", "iterate", "profiling", "dynamic-bind"
	               ],
	
	    // Patterns that act as separators in compound statements.
	    // This may include any general pattern that must be indented
	    // specially.
	    separator: ["finally", "exception", "cleanup", "else",
	                "elseif", "afterwards"
	               ],
	
	    // Keywords that do not require special indentation handling,
	    // but which should be highlighted
	    other: ["above", "below", "by", "from", "handler", "in",
	            "instance", "let", "local", "otherwise", "slot",
	            "subclass", "then", "to", "keyed-by", "virtual"
	           ],
	
	    // Condition signaling function calls
	    signalingCalls: ["signal", "error", "cerror",
	                     "break", "check-type", "abort"
	                    ]
	  };
	
	  words["otherDefinition"] =
	    words["unnamedDefinition"]
	    .concat(words["namedDefinition"])
	    .concat(words["otherParameterizedDefinition"]);
	
	  words["definition"] =
	    words["typeParameterizedDefinition"]
	    .concat(words["otherDefinition"]);
	
	  words["parameterizedDefinition"] =
	    words["typeParameterizedDefinition"]
	    .concat(words["otherParameterizedDefinition"]);
	
	  words["simpleDefinition"] =
	    words["constantSimpleDefinition"]
	    .concat(words["variableSimpleDefinition"])
	    .concat(words["otherSimpleDefinition"]);
	
	  words["keyword"] =
	    words["statement"]
	    .concat(words["separator"])
	    .concat(words["other"]);
	
	  // Patterns
	  var symbolPattern = "[-_a-zA-Z?!*@<>$%]+";
	  var symbol = new RegExp("^" + symbolPattern);
	  var patterns = {
	    // Symbols with special syntax
	    symbolKeyword: symbolPattern + ":",
	    symbolClass: "<" + symbolPattern + ">",
	    symbolGlobal: "\\*" + symbolPattern + "\\*",
	    symbolConstant: "\\$" + symbolPattern
	  };
	  var patternStyles = {
	    symbolKeyword: "atom",
	    symbolClass: "tag",
	    symbolGlobal: "variable-2",
	    symbolConstant: "variable-3"
	  };
	
	  // Compile all patterns to regular expressions
	  for (var patternName in patterns)
	    if (patterns.hasOwnProperty(patternName))
	      patterns[patternName] = new RegExp("^" + patterns[patternName]);
	
	  // Names beginning "with-" and "without-" are commonly
	  // used as statement macro
	  patterns["keyword"] = [/^with(?:out)?-[-_a-zA-Z?!*@<>$%]+/];
	
	  var styles = {};
	  styles["keyword"] = "keyword";
	  styles["definition"] = "def";
	  styles["simpleDefinition"] = "def";
	  styles["signalingCalls"] = "builtin";
	
	  // protected words lookup table
	  var wordLookup = {};
	  var styleLookup = {};
	
	  [
	    "keyword",
	    "definition",
	    "simpleDefinition",
	    "signalingCalls"
	  ].forEach(function(type) {
	    words[type].forEach(function(word) {
	      wordLookup[word] = type;
	      styleLookup[word] = styles[type];
	    });
	  });
	
	
	  function chain(stream, state, f) {
	    state.tokenize = f;
	    return f(stream, state);
	  }
	
	  function tokenBase(stream, state) {
	    // String
	    var ch = stream.peek();
	    if (ch == "'" || ch == '"') {
	      stream.next();
	      return chain(stream, state, tokenString(ch, "string"));
	    }
	    // Comment
	    else if (ch == "/") {
	      stream.next();
	      if (stream.eat("*")) {
	        return chain(stream, state, tokenComment);
	      } else if (stream.eat("/")) {
	        stream.skipToEnd();
	        return "comment";
	      }
	      stream.backUp(1);
	    }
	    // Decimal
	    else if (/[+\-\d\.]/.test(ch)) {
	      if (stream.match(/^[+-]?[0-9]*\.[0-9]*([esdx][+-]?[0-9]+)?/i) ||
	          stream.match(/^[+-]?[0-9]+([esdx][+-]?[0-9]+)/i) ||
	          stream.match(/^[+-]?\d+/)) {
	        return "number";
	      }
	    }
	    // Hash
	    else if (ch == "#") {
	      stream.next();
	      // Symbol with string syntax
	      ch = stream.peek();
	      if (ch == '"') {
	        stream.next();
	        return chain(stream, state, tokenString('"', "string"));
	      }
	      // Binary number
	      else if (ch == "b") {
	        stream.next();
	        stream.eatWhile(/[01]/);
	        return "number";
	      }
	      // Hex number
	      else if (ch == "x") {
	        stream.next();
	        stream.eatWhile(/[\da-f]/i);
	        return "number";
	      }
	      // Octal number
	      else if (ch == "o") {
	        stream.next();
	        stream.eatWhile(/[0-7]/);
	        return "number";
	      }
	      // Token concatenation in macros
	      else if (ch == '#') {
	        stream.next();
	        return "punctuation";
	      }
	      // Sequence literals
	      else if ((ch == '[') || (ch == '(')) {
	        stream.next();
	        return "bracket";
	      // Hash symbol
	      } else if (stream.match(/f|t|all-keys|include|key|next|rest/i)) {
	        return "atom";
	      } else {
	        stream.eatWhile(/[-a-zA-Z]/);
	        return "error";
	      }
	    } else if (ch == "~") {
	      stream.next();
	      ch = stream.peek();
	      if (ch == "=") {
	        stream.next();
	        ch = stream.peek();
	        if (ch == "=") {
	          stream.next();
	          return "operator";
	        }
	        return "operator";
	      }
	      return "operator";
	    } else if (ch == ":") {
	      stream.next();
	      ch = stream.peek();
	      if (ch == "=") {
	        stream.next();
	        return "operator";
	      } else if (ch == ":") {
	        stream.next();
	        return "punctuation";
	      }
	    } else if ("[](){}".indexOf(ch) != -1) {
	      stream.next();
	      return "bracket";
	    } else if (".,".indexOf(ch) != -1) {
	      stream.next();
	      return "punctuation";
	    } else if (stream.match("end")) {
	      return "keyword";
	    }
	    for (var name in patterns) {
	      if (patterns.hasOwnProperty(name)) {
	        var pattern = patterns[name];
	        if ((pattern instanceof Array && pattern.some(function(p) {
	          return stream.match(p);
	        })) || stream.match(pattern))
	          return patternStyles[name];
	      }
	    }
	    if (/[+\-*\/^=<>&|]/.test(ch)) {
	      stream.next();
	      return "operator";
	    }
	    if (stream.match("define")) {
	      return "def";
	    } else {
	      stream.eatWhile(/[\w\-]/);
	      // Keyword
	      if (wordLookup[stream.current()]) {
	        return styleLookup[stream.current()];
	      } else if (stream.current().match(symbol)) {
	        return "variable";
	      } else {
	        stream.next();
	        return "variable-2";
	      }
	    }
	  }
	
	  function tokenComment(stream, state) {
	    var maybeEnd = false, maybeNested = false, nestedCount = 0, ch;
	    while ((ch = stream.next())) {
	      if (ch == "/" && maybeEnd) {
	        if (nestedCount > 0) {
	          nestedCount--;
	        } else {
	          state.tokenize = tokenBase;
	          break;
	        }
	      } else if (ch == "*" && maybeNested) {
	        nestedCount++;
	      }
	      maybeEnd = (ch == "*");
	      maybeNested = (ch == "/");
	    }
	    return "comment";
	  }
	
	  function tokenString(quote, style) {
	    return function(stream, state) {
	      var escaped = false, next, end = false;
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) {
	          end = true;
	          break;
	        }
	        escaped = !escaped && next == "\\";
	      }
	      if (end || !escaped) {
	        state.tokenize = tokenBase;
	      }
	      return style;
	    };
	  }
	
	  // Interface
	  return {
	    startState: function() {
	      return {
	        tokenize: tokenBase,
	        currentIndent: 0
	      };
	    },
	    token: function(stream, state) {
	      if (stream.eatSpace())
	        return null;
	      var style = state.tokenize(stream, state);
	      return style;
	    },
	    blockCommentStart: "/*",
	    blockCommentEnd: "*/"
	  };
	});
	
	CodeMirror.defineMIME("text/x-dylan", "dylan");
	
	});


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("ebnf", function (config) {
	    var commentType = {slash: 0, parenthesis: 1};
	    var stateType = {comment: 0, _string: 1, characterClass: 2};
	    var bracesMode = null;
	
	    if (config.bracesMode)
	      bracesMode = CodeMirror.getMode(config, config.bracesMode);
	
	    return {
	      startState: function () {
	        return {
	          stringType: null,
	          commentType: null,
	          braced: 0,
	          lhs: true,
	          localState: null,
	          stack: [],
	          inDefinition: false
	        };
	      },
	      token: function (stream, state) {
	        if (!stream) return;
	
	        //check for state changes
	        if (state.stack.length === 0) {
	          //strings
	          if ((stream.peek() == '"') || (stream.peek() == "'")) {
	            state.stringType = stream.peek();
	            stream.next(); // Skip quote
	            state.stack.unshift(stateType._string);
	          } else if (stream.match(/^\/\*/)) { //comments starting with /*
	            state.stack.unshift(stateType.comment);
	            state.commentType = commentType.slash;
	          } else if (stream.match(/^\(\*/)) { //comments starting with (*
	            state.stack.unshift(stateType.comment);
	            state.commentType = commentType.parenthesis;
	          }
	        }
	
	        //return state
	        //stack has
	        switch (state.stack[0]) {
	        case stateType._string:
	          while (state.stack[0] === stateType._string && !stream.eol()) {
	            if (stream.peek() === state.stringType) {
	              stream.next(); // Skip quote
	              state.stack.shift(); // Clear flag
	            } else if (stream.peek() === "\\") {
	              stream.next();
	              stream.next();
	            } else {
	              stream.match(/^.[^\\\"\']*/);
	            }
	          }
	          return state.lhs ? "property string" : "string"; // Token style
	
	        case stateType.comment:
	          while (state.stack[0] === stateType.comment && !stream.eol()) {
	            if (state.commentType === commentType.slash && stream.match(/\*\//)) {
	              state.stack.shift(); // Clear flag
	              state.commentType = null;
	            } else if (state.commentType === commentType.parenthesis && stream.match(/\*\)/)) {
	              state.stack.shift(); // Clear flag
	              state.commentType = null;
	            } else {
	              stream.match(/^.[^\*]*/);
	            }
	          }
	          return "comment";
	
	        case stateType.characterClass:
	          while (state.stack[0] === stateType.characterClass && !stream.eol()) {
	            if (!(stream.match(/^[^\]\\]+/) || stream.match(/^\\./))) {
	              state.stack.shift();
	            }
	          }
	          return "operator";
	        }
	
	        var peek = stream.peek();
	
	        if (bracesMode !== null && (state.braced || peek === "{")) {
	          if (state.localState === null)
	            state.localState = CodeMirror.startState(bracesMode);
	
	          var token = bracesMode.token(stream, state.localState),
	          text = stream.current();
	
	          if (!token) {
	            for (var i = 0; i < text.length; i++) {
	              if (text[i] === "{") {
	                if (state.braced === 0) {
	                  token = "matchingbracket";
	                }
	                state.braced++;
	              } else if (text[i] === "}") {
	                state.braced--;
	                if (state.braced === 0) {
	                  token = "matchingbracket";
	                }
	              }
	            }
	          }
	          return token;
	        }
	
	        //no stack
	        switch (peek) {
	        case "[":
	          stream.next();
	          state.stack.unshift(stateType.characterClass);
	          return "bracket";
	        case ":":
	        case "|":
	        case ";":
	          stream.next();
	          return "operator";
	        case "%":
	          if (stream.match("%%")) {
	            return "header";
	          } else if (stream.match(/[%][A-Za-z]+/)) {
	            return "keyword";
	          } else if (stream.match(/[%][}]/)) {
	            return "matchingbracket";
	          }
	          break;
	        case "/":
	          if (stream.match(/[\/][A-Za-z]+/)) {
	          return "keyword";
	        }
	        case "\\":
	          if (stream.match(/[\][a-z]+/)) {
	            return "string-2";
	          }
	        case ".":
	          if (stream.match(".")) {
	            return "atom";
	          }
	        case "*":
	        case "-":
	        case "+":
	        case "^":
	          if (stream.match(peek)) {
	            return "atom";
	          }
	        case "$":
	          if (stream.match("$$")) {
	            return "builtin";
	          } else if (stream.match(/[$][0-9]+/)) {
	            return "variable-3";
	          }
	        case "<":
	          if (stream.match(/<<[a-zA-Z_]+>>/)) {
	            return "builtin";
	          }
	        }
	
	        if (stream.match(/^\/\//)) {
	          stream.skipToEnd();
	          return "comment";
	        } else if (stream.match(/return/)) {
	          return "operator";
	        } else if (stream.match(/^[a-zA-Z_][a-zA-Z0-9_]*/)) {
	          if (stream.match(/(?=[\(.])/)) {
	            return "variable";
	          } else if (stream.match(/(?=[\s\n]*[:=])/)) {
	            return "def";
	          }
	          return "variable-2";
	        } else if (["[", "]", "(", ")"].indexOf(stream.peek()) != -1) {
	          stream.next();
	          return "bracket";
	        } else if (!stream.eatSpace()) {
	          stream.next();
	        }
	        return null;
	      }
	    };
	  });
	
	  CodeMirror.defineMIME("text/x-ebnf", "ebnf");
	});


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("ecl", function(config) {
	
	  function words(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	
	  function metaHook(stream, state) {
	    if (!state.startOfLine) return false;
	    stream.skipToEnd();
	    return "meta";
	  }
	
	  var indentUnit = config.indentUnit;
	  var keyword = words("abs acos allnodes ascii asin asstring atan atan2 ave case choose choosen choosesets clustersize combine correlation cos cosh count covariance cron dataset dedup define denormalize distribute distributed distribution ebcdic enth error evaluate event eventextra eventname exists exp failcode failmessage fetch fromunicode getisvalid global graph group hash hash32 hash64 hashcrc hashmd5 having if index intformat isvalid iterate join keyunicode length library limit ln local log loop map matched matchlength matchposition matchtext matchunicode max merge mergejoin min nolocal nonempty normalize parse pipe power preload process project pull random range rank ranked realformat recordof regexfind regexreplace regroup rejected rollup round roundup row rowdiff sample set sin sinh sizeof soapcall sort sorted sqrt stepped stored sum table tan tanh thisnode topn tounicode transfer trim truncate typeof ungroup unicodeorder variance which workunit xmldecode xmlencode xmltext xmlunicode");
	  var variable = words("apply assert build buildindex evaluate fail keydiff keypatch loadxml nothor notify output parallel sequential soapcall wait");
	  var variable_2 = words("__compressed__ all and any as atmost before beginc++ best between case const counter csv descend encrypt end endc++ endmacro except exclusive expire export extend false few first flat from full function group header heading hole ifblock import in interface joined keep keyed last left limit load local locale lookup macro many maxcount maxlength min skew module named nocase noroot noscan nosort not of only opt or outer overwrite packed partition penalty physicallength pipe quote record relationship repeat return right scan self separator service shared skew skip sql store terminator thor threshold token transform trim true type unicodeorder unsorted validate virtual whole wild within xml xpath");
	  var variable_3 = words("ascii big_endian boolean data decimal ebcdic integer pattern qstring real record rule set of string token udecimal unicode unsigned varstring varunicode");
	  var builtin = words("checkpoint deprecated failcode failmessage failure global independent onwarning persist priority recovery stored success wait when");
	  var blockKeywords = words("catch class do else finally for if switch try while");
	  var atoms = words("true false null");
	  var hooks = {"#": metaHook};
	  var isOperatorChar = /[+\-*&%=<>!?|\/]/;
	
	  var curPunc;
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    if (hooks[ch]) {
	      var result = hooks[ch](stream, state);
	      if (result !== false) return result;
	    }
	    if (ch == '"' || ch == "'") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    }
	    if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
	      curPunc = ch;
	      return null;
	    }
	    if (/\d/.test(ch)) {
	      stream.eatWhile(/[\w\.]/);
	      return "number";
	    }
	    if (ch == "/") {
	      if (stream.eat("*")) {
	        state.tokenize = tokenComment;
	        return tokenComment(stream, state);
	      }
	      if (stream.eat("/")) {
	        stream.skipToEnd();
	        return "comment";
	      }
	    }
	    if (isOperatorChar.test(ch)) {
	      stream.eatWhile(isOperatorChar);
	      return "operator";
	    }
	    stream.eatWhile(/[\w\$_]/);
	    var cur = stream.current().toLowerCase();
	    if (keyword.propertyIsEnumerable(cur)) {
	      if (blockKeywords.propertyIsEnumerable(cur)) curPunc = "newstatement";
	      return "keyword";
	    } else if (variable.propertyIsEnumerable(cur)) {
	      if (blockKeywords.propertyIsEnumerable(cur)) curPunc = "newstatement";
	      return "variable";
	    } else if (variable_2.propertyIsEnumerable(cur)) {
	      if (blockKeywords.propertyIsEnumerable(cur)) curPunc = "newstatement";
	      return "variable-2";
	    } else if (variable_3.propertyIsEnumerable(cur)) {
	      if (blockKeywords.propertyIsEnumerable(cur)) curPunc = "newstatement";
	      return "variable-3";
	    } else if (builtin.propertyIsEnumerable(cur)) {
	      if (blockKeywords.propertyIsEnumerable(cur)) curPunc = "newstatement";
	      return "builtin";
	    } else { //Data types are of from KEYWORD##
	                var i = cur.length - 1;
	                while(i >= 0 && (!isNaN(cur[i]) || cur[i] == '_'))
	                        --i;
	
	                if (i > 0) {
	                        var cur2 = cur.substr(0, i + 1);
	                if (variable_3.propertyIsEnumerable(cur2)) {
	                        if (blockKeywords.propertyIsEnumerable(cur2)) curPunc = "newstatement";
	                        return "variable-3";
	                }
	            }
	    }
	    if (atoms.propertyIsEnumerable(cur)) return "atom";
	    return null;
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, next, end = false;
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) {end = true; break;}
	        escaped = !escaped && next == "\\";
	      }
	      if (end || !escaped)
	        state.tokenize = tokenBase;
	      return "string";
	    };
	  }
	
	  function tokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while (ch = stream.next()) {
	      if (ch == "/" && maybeEnd) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return "comment";
	  }
	
	  function Context(indented, column, type, align, prev) {
	    this.indented = indented;
	    this.column = column;
	    this.type = type;
	    this.align = align;
	    this.prev = prev;
	  }
	  function pushContext(state, col, type) {
	    return state.context = new Context(state.indented, col, type, null, state.context);
	  }
	  function popContext(state) {
	    var t = state.context.type;
	    if (t == ")" || t == "]" || t == "}")
	      state.indented = state.context.indented;
	    return state.context = state.context.prev;
	  }
	
	  // Interface
	
	  return {
	    startState: function(basecolumn) {
	      return {
	        tokenize: null,
	        context: new Context((basecolumn || 0) - indentUnit, 0, "top", false),
	        indented: 0,
	        startOfLine: true
	      };
	    },
	
	    token: function(stream, state) {
	      var ctx = state.context;
	      if (stream.sol()) {
	        if (ctx.align == null) ctx.align = false;
	        state.indented = stream.indentation();
	        state.startOfLine = true;
	      }
	      if (stream.eatSpace()) return null;
	      curPunc = null;
	      var style = (state.tokenize || tokenBase)(stream, state);
	      if (style == "comment" || style == "meta") return style;
	      if (ctx.align == null) ctx.align = true;
	
	      if ((curPunc == ";" || curPunc == ":") && ctx.type == "statement") popContext(state);
	      else if (curPunc == "{") pushContext(state, stream.column(), "}");
	      else if (curPunc == "[") pushContext(state, stream.column(), "]");
	      else if (curPunc == "(") pushContext(state, stream.column(), ")");
	      else if (curPunc == "}") {
	        while (ctx.type == "statement") ctx = popContext(state);
	        if (ctx.type == "}") ctx = popContext(state);
	        while (ctx.type == "statement") ctx = popContext(state);
	      }
	      else if (curPunc == ctx.type) popContext(state);
	      else if (ctx.type == "}" || ctx.type == "top" || (ctx.type == "statement" && curPunc == "newstatement"))
	        pushContext(state, stream.column(), "statement");
	      state.startOfLine = false;
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      if (state.tokenize != tokenBase && state.tokenize != null) return 0;
	      var ctx = state.context, firstChar = textAfter && textAfter.charAt(0);
	      if (ctx.type == "statement" && firstChar == "}") ctx = ctx.prev;
	      var closing = firstChar == ctx.type;
	      if (ctx.type == "statement") return ctx.indented + (firstChar == "{" ? 0 : indentUnit);
	      else if (ctx.align) return ctx.column + (closing ? 0 : 1);
	      else return ctx.indented + (closing ? 0 : indentUnit);
	    },
	
	    electricChars: "{}"
	  };
	});
	
	CodeMirror.defineMIME("text/x-ecl", "ecl");
	
	});


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("eiffel", function() {
	  function wordObj(words) {
	    var o = {};
	    for (var i = 0, e = words.length; i < e; ++i) o[words[i]] = true;
	    return o;
	  }
	  var keywords = wordObj([
	    'note',
	    'across',
	    'when',
	    'variant',
	    'until',
	    'unique',
	    'undefine',
	    'then',
	    'strip',
	    'select',
	    'retry',
	    'rescue',
	    'require',
	    'rename',
	    'reference',
	    'redefine',
	    'prefix',
	    'once',
	    'old',
	    'obsolete',
	    'loop',
	    'local',
	    'like',
	    'is',
	    'inspect',
	    'infix',
	    'include',
	    'if',
	    'frozen',
	    'from',
	    'external',
	    'export',
	    'ensure',
	    'end',
	    'elseif',
	    'else',
	    'do',
	    'creation',
	    'create',
	    'check',
	    'alias',
	    'agent',
	    'separate',
	    'invariant',
	    'inherit',
	    'indexing',
	    'feature',
	    'expanded',
	    'deferred',
	    'class',
	    'Void',
	    'True',
	    'Result',
	    'Precursor',
	    'False',
	    'Current',
	    'create',
	    'attached',
	    'detachable',
	    'as',
	    'and',
	    'implies',
	    'not',
	    'or'
	  ]);
	  var operators = wordObj([":=", "and then","and", "or","<<",">>"]);
	
	  function chain(newtok, stream, state) {
	    state.tokenize.push(newtok);
	    return newtok(stream, state);
	  }
	
	  function tokenBase(stream, state) {
	    if (stream.eatSpace()) return null;
	    var ch = stream.next();
	    if (ch == '"'||ch == "'") {
	      return chain(readQuoted(ch, "string"), stream, state);
	    } else if (ch == "-"&&stream.eat("-")) {
	      stream.skipToEnd();
	      return "comment";
	    } else if (ch == ":"&&stream.eat("=")) {
	      return "operator";
	    } else if (/[0-9]/.test(ch)) {
	      stream.eatWhile(/[xXbBCc0-9\.]/);
	      stream.eat(/[\?\!]/);
	      return "ident";
	    } else if (/[a-zA-Z_0-9]/.test(ch)) {
	      stream.eatWhile(/[a-zA-Z_0-9]/);
	      stream.eat(/[\?\!]/);
	      return "ident";
	    } else if (/[=+\-\/*^%<>~]/.test(ch)) {
	      stream.eatWhile(/[=+\-\/*^%<>~]/);
	      return "operator";
	    } else {
	      return null;
	    }
	  }
	
	  function readQuoted(quote, style,  unescaped) {
	    return function(stream, state) {
	      var escaped = false, ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == quote && (unescaped || !escaped)) {
	          state.tokenize.pop();
	          break;
	        }
	        escaped = !escaped && ch == "%";
	      }
	      return style;
	    };
	  }
	
	  return {
	    startState: function() {
	      return {tokenize: [tokenBase]};
	    },
	
	    token: function(stream, state) {
	      var style = state.tokenize[state.tokenize.length-1](stream, state);
	      if (style == "ident") {
	        var word = stream.current();
	        style = keywords.propertyIsEnumerable(stream.current()) ? "keyword"
	          : operators.propertyIsEnumerable(stream.current()) ? "operator"
	          : /^[A-Z][A-Z_0-9]*$/g.test(word) ? "tag"
	          : /^0[bB][0-1]+$/g.test(word) ? "number"
	          : /^0[cC][0-7]+$/g.test(word) ? "number"
	          : /^0[xX][a-fA-F0-9]+$/g.test(word) ? "number"
	          : /^([0-9]+\.[0-9]*)|([0-9]*\.[0-9]+)$/g.test(word) ? "number"
	          : /^[0-9]+$/g.test(word) ? "number"
	          : "variable";
	      }
	      return style;
	    },
	    lineComment: "--"
	  };
	});
	
	CodeMirror.defineMIME("text/x-eiffel", "eiffel");
	
	});


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("elm", function() {
	
	    function switchState(source, setState, f) {
	      setState(f);
	      return f(source, setState);
	    }
	
	    // These should all be Unicode extended, as per the Haskell 2010 report
	    var smallRE = /[a-z_]/;
	    var largeRE = /[A-Z]/;
	    var digitRE = /[0-9]/;
	    var hexitRE = /[0-9A-Fa-f]/;
	    var octitRE = /[0-7]/;
	    var idRE = /[a-z_A-Z0-9\']/;
	    var symbolRE = /[-!#$%&*+.\/<=>?@\\^|~:\u03BB\u2192]/;
	    var specialRE = /[(),;[\]`{}]/;
	    var whiteCharRE = /[ \t\v\f]/; // newlines are handled in tokenizer
	
	    function normal() {
	      return function (source, setState) {
	        if (source.eatWhile(whiteCharRE)) {
	          return null;
	        }
	
	        var ch = source.next();
	        if (specialRE.test(ch)) {
	          if (ch == '{' && source.eat('-')) {
	            var t = "comment";
	            if (source.eat('#')) t = "meta";
	            return switchState(source, setState, ncomment(t, 1));
	          }
	          return null;
	        }
	
	        if (ch == '\'') {
	          if (source.eat('\\'))
	            source.next();  // should handle other escapes here
	          else
	            source.next();
	
	          if (source.eat('\''))
	            return "string";
	          return "error";
	        }
	
	        if (ch == '"') {
	          return switchState(source, setState, stringLiteral);
	        }
	
	        if (largeRE.test(ch)) {
	          source.eatWhile(idRE);
	          if (source.eat('.'))
	            return "qualifier";
	          return "variable-2";
	        }
	
	        if (smallRE.test(ch)) {
	          var isDef = source.pos === 1;
	          source.eatWhile(idRE);
	          return isDef ? "variable-3" : "variable";
	        }
	
	        if (digitRE.test(ch)) {
	          if (ch == '0') {
	            if (source.eat(/[xX]/)) {
	              source.eatWhile(hexitRE); // should require at least 1
	              return "integer";
	            }
	            if (source.eat(/[oO]/)) {
	              source.eatWhile(octitRE); // should require at least 1
	              return "number";
	            }
	          }
	          source.eatWhile(digitRE);
	          var t = "number";
	          if (source.eat('.')) {
	            t = "number";
	            source.eatWhile(digitRE); // should require at least 1
	          }
	          if (source.eat(/[eE]/)) {
	            t = "number";
	            source.eat(/[-+]/);
	            source.eatWhile(digitRE); // should require at least 1
	          }
	          return t;
	        }
	
	        if (symbolRE.test(ch)) {
	          if (ch == '-' && source.eat(/-/)) {
	            source.eatWhile(/-/);
	            if (!source.eat(symbolRE)) {
	              source.skipToEnd();
	              return "comment";
	            }
	          }
	          source.eatWhile(symbolRE);
	          return "builtin";
	        }
	
	        return "error";
	      }
	    }
	
	    function ncomment(type, nest) {
	      if (nest == 0) {
	        return normal();
	      }
	      return function(source, setState) {
	        var currNest = nest;
	        while (!source.eol()) {
	          var ch = source.next();
	          if (ch == '{' && source.eat('-')) {
	            ++currNest;
	          } else if (ch == '-' && source.eat('}')) {
	            --currNest;
	            if (currNest == 0) {
	              setState(normal());
	              return type;
	            }
	          }
	        }
	        setState(ncomment(type, currNest));
	        return type;
	      }
	    }
	
	    function stringLiteral(source, setState) {
	      while (!source.eol()) {
	        var ch = source.next();
	        if (ch == '"') {
	          setState(normal());
	          return "string";
	        }
	        if (ch == '\\') {
	          if (source.eol() || source.eat(whiteCharRE)) {
	            setState(stringGap);
	            return "string";
	          }
	          if (!source.eat('&')) source.next(); // should handle other escapes here
	        }
	      }
	      setState(normal());
	      return "error";
	    }
	
	    function stringGap(source, setState) {
	      if (source.eat('\\')) {
	        return switchState(source, setState, stringLiteral);
	      }
	      source.next();
	      setState(normal());
	      return "error";
	    }
	
	
	    var wellKnownWords = (function() {
	      var wkw = {};
	
	      var keywords = [
	        "case", "of", "as",
	        "if", "then", "else",
	        "let", "in",
	        "infix", "infixl", "infixr",
	        "type", "alias",
	        "input", "output", "foreign", "loopback",
	        "module", "where", "import", "exposing",
	        "_", "..", "|", ":", "=", "\\", "\"", "->", "<-"
	      ];
	
	      for (var i = keywords.length; i--;)
	        wkw[keywords[i]] = "keyword";
	
	      return wkw;
	    })();
	
	
	
	    return {
	      startState: function ()  { return { f: normal() }; },
	      copyState:  function (s) { return { f: s.f }; },
	
	      token: function(stream, state) {
	        var t = state.f(stream, function(s) { state.f = s; });
	        var w = stream.current();
	        return (wellKnownWords.hasOwnProperty(w)) ? wellKnownWords[w] : t;
	      }
	    };
	
	  });
	
	  CodeMirror.defineMIME("text/x-elm", "elm");
	});


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	/*jshint unused:true, eqnull:true, curly:true, bitwise:true */
	/*jshint undef:true, latedef:true, trailing:true */
	/*global CodeMirror:true */
	
	// erlang mode.
	// tokenizer -> token types -> CodeMirror styles
	// tokenizer maintains a parse stack
	// indenter uses the parse stack
	
	// TODO indenter:
	//   bit syntax
	//   old guard/bif/conversion clashes (e.g. "float/1")
	//   type/spec/opaque
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMIME("text/x-erlang", "erlang");
	
	CodeMirror.defineMode("erlang", function(cmCfg) {
	  "use strict";
	
	/////////////////////////////////////////////////////////////////////////////
	// constants
	
	  var typeWords = [
	    "-type", "-spec", "-export_type", "-opaque"];
	
	  var keywordWords = [
	    "after","begin","catch","case","cond","end","fun","if",
	    "let","of","query","receive","try","when"];
	
	  var separatorRE    = /[\->,;]/;
	  var separatorWords = [
	    "->",";",","];
	
	  var operatorAtomWords = [
	    "and","andalso","band","bnot","bor","bsl","bsr","bxor",
	    "div","not","or","orelse","rem","xor"];
	
	  var operatorSymbolRE    = /[\+\-\*\/<>=\|:!]/;
	  var operatorSymbolWords = [
	    "=","+","-","*","/",">",">=","<","=<","=:=","==","=/=","/=","||","<-","!"];
	
	  var openParenRE    = /[<\(\[\{]/;
	  var openParenWords = [
	    "<<","(","[","{"];
	
	  var closeParenRE    = /[>\)\]\}]/;
	  var closeParenWords = [
	    "}","]",")",">>"];
	
	  var guardWords = [
	    "is_atom","is_binary","is_bitstring","is_boolean","is_float",
	    "is_function","is_integer","is_list","is_number","is_pid",
	    "is_port","is_record","is_reference","is_tuple",
	    "atom","binary","bitstring","boolean","function","integer","list",
	    "number","pid","port","record","reference","tuple"];
	
	  var bifWords = [
	    "abs","adler32","adler32_combine","alive","apply","atom_to_binary",
	    "atom_to_list","binary_to_atom","binary_to_existing_atom",
	    "binary_to_list","binary_to_term","bit_size","bitstring_to_list",
	    "byte_size","check_process_code","contact_binary","crc32",
	    "crc32_combine","date","decode_packet","delete_module",
	    "disconnect_node","element","erase","exit","float","float_to_list",
	    "garbage_collect","get","get_keys","group_leader","halt","hd",
	    "integer_to_list","internal_bif","iolist_size","iolist_to_binary",
	    "is_alive","is_atom","is_binary","is_bitstring","is_boolean",
	    "is_float","is_function","is_integer","is_list","is_number","is_pid",
	    "is_port","is_process_alive","is_record","is_reference","is_tuple",
	    "length","link","list_to_atom","list_to_binary","list_to_bitstring",
	    "list_to_existing_atom","list_to_float","list_to_integer",
	    "list_to_pid","list_to_tuple","load_module","make_ref","module_loaded",
	    "monitor_node","node","node_link","node_unlink","nodes","notalive",
	    "now","open_port","pid_to_list","port_close","port_command",
	    "port_connect","port_control","pre_loaded","process_flag",
	    "process_info","processes","purge_module","put","register",
	    "registered","round","self","setelement","size","spawn","spawn_link",
	    "spawn_monitor","spawn_opt","split_binary","statistics",
	    "term_to_binary","time","throw","tl","trunc","tuple_size",
	    "tuple_to_list","unlink","unregister","whereis"];
	
	// upper case: [A-Z] [Ø-Þ] [À-Ö]
	// lower case: [a-z] [ß-ö] [ø-ÿ]
	  var anumRE       = /[\w@Ø-ÞÀ-Öß-öø-ÿ]/;
	  var escapesRE    =
	    /[0-7]{1,3}|[bdefnrstv\\"']|\^[a-zA-Z]|x[0-9a-zA-Z]{2}|x{[0-9a-zA-Z]+}/;
	
	/////////////////////////////////////////////////////////////////////////////
	// tokenizer
	
	  function tokenizer(stream,state) {
	    // in multi-line string
	    if (state.in_string) {
	      state.in_string = (!doubleQuote(stream));
	      return rval(state,stream,"string");
	    }
	
	    // in multi-line atom
	    if (state.in_atom) {
	      state.in_atom = (!singleQuote(stream));
	      return rval(state,stream,"atom");
	    }
	
	    // whitespace
	    if (stream.eatSpace()) {
	      return rval(state,stream,"whitespace");
	    }
	
	    // attributes and type specs
	    if (!peekToken(state) &&
	        stream.match(/-\s*[a-zß-öø-ÿ][\wØ-ÞÀ-Öß-öø-ÿ]*/)) {
	      if (is_member(stream.current(),typeWords)) {
	        return rval(state,stream,"type");
	      }else{
	        return rval(state,stream,"attribute");
	      }
	    }
	
	    var ch = stream.next();
	
	    // comment
	    if (ch == '%') {
	      stream.skipToEnd();
	      return rval(state,stream,"comment");
	    }
	
	    // colon
	    if (ch == ":") {
	      return rval(state,stream,"colon");
	    }
	
	    // macro
	    if (ch == '?') {
	      stream.eatSpace();
	      stream.eatWhile(anumRE);
	      return rval(state,stream,"macro");
	    }
	
	    // record
	    if (ch == "#") {
	      stream.eatSpace();
	      stream.eatWhile(anumRE);
	      return rval(state,stream,"record");
	    }
	
	    // dollar escape
	    if (ch == "$") {
	      if (stream.next() == "\\" && !stream.match(escapesRE)) {
	        return rval(state,stream,"error");
	      }
	      return rval(state,stream,"number");
	    }
	
	    // dot
	    if (ch == ".") {
	      return rval(state,stream,"dot");
	    }
	
	    // quoted atom
	    if (ch == '\'') {
	      if (!(state.in_atom = (!singleQuote(stream)))) {
	        if (stream.match(/\s*\/\s*[0-9]/,false)) {
	          stream.match(/\s*\/\s*[0-9]/,true);
	          return rval(state,stream,"fun");      // 'f'/0 style fun
	        }
	        if (stream.match(/\s*\(/,false) || stream.match(/\s*:/,false)) {
	          return rval(state,stream,"function");
	        }
	      }
	      return rval(state,stream,"atom");
	    }
	
	    // string
	    if (ch == '"') {
	      state.in_string = (!doubleQuote(stream));
	      return rval(state,stream,"string");
	    }
	
	    // variable
	    if (/[A-Z_Ø-ÞÀ-Ö]/.test(ch)) {
	      stream.eatWhile(anumRE);
	      return rval(state,stream,"variable");
	    }
	
	    // atom/keyword/BIF/function
	    if (/[a-z_ß-öø-ÿ]/.test(ch)) {
	      stream.eatWhile(anumRE);
	
	      if (stream.match(/\s*\/\s*[0-9]/,false)) {
	        stream.match(/\s*\/\s*[0-9]/,true);
	        return rval(state,stream,"fun");      // f/0 style fun
	      }
	
	      var w = stream.current();
	
	      if (is_member(w,keywordWords)) {
	        return rval(state,stream,"keyword");
	      }else if (is_member(w,operatorAtomWords)) {
	        return rval(state,stream,"operator");
	      }else if (stream.match(/\s*\(/,false)) {
	        // 'put' and 'erlang:put' are bifs, 'foo:put' is not
	        if (is_member(w,bifWords) &&
	            ((peekToken(state).token != ":") ||
	             (peekToken(state,2).token == "erlang"))) {
	          return rval(state,stream,"builtin");
	        }else if (is_member(w,guardWords)) {
	          return rval(state,stream,"guard");
	        }else{
	          return rval(state,stream,"function");
	        }
	      }else if (lookahead(stream) == ":") {
	        if (w == "erlang") {
	          return rval(state,stream,"builtin");
	        } else {
	          return rval(state,stream,"function");
	        }
	      }else if (is_member(w,["true","false"])) {
	        return rval(state,stream,"boolean");
	      }else{
	        return rval(state,stream,"atom");
	      }
	    }
	
	    // number
	    var digitRE      = /[0-9]/;
	    var radixRE      = /[0-9a-zA-Z]/;         // 36#zZ style int
	    if (digitRE.test(ch)) {
	      stream.eatWhile(digitRE);
	      if (stream.eat('#')) {                // 36#aZ  style integer
	        if (!stream.eatWhile(radixRE)) {
	          stream.backUp(1);                 //"36#" - syntax error
	        }
	      } else if (stream.eat('.')) {       // float
	        if (!stream.eatWhile(digitRE)) {
	          stream.backUp(1);        // "3." - probably end of function
	        } else {
	          if (stream.eat(/[eE]/)) {        // float with exponent
	            if (stream.eat(/[-+]/)) {
	              if (!stream.eatWhile(digitRE)) {
	                stream.backUp(2);            // "2e-" - syntax error
	              }
	            } else {
	              if (!stream.eatWhile(digitRE)) {
	                stream.backUp(1);            // "2e" - syntax error
	              }
	            }
	          }
	        }
	      }
	      return rval(state,stream,"number");   // normal integer
	    }
	
	    // open parens
	    if (nongreedy(stream,openParenRE,openParenWords)) {
	      return rval(state,stream,"open_paren");
	    }
	
	    // close parens
	    if (nongreedy(stream,closeParenRE,closeParenWords)) {
	      return rval(state,stream,"close_paren");
	    }
	
	    // separators
	    if (greedy(stream,separatorRE,separatorWords)) {
	      return rval(state,stream,"separator");
	    }
	
	    // operators
	    if (greedy(stream,operatorSymbolRE,operatorSymbolWords)) {
	      return rval(state,stream,"operator");
	    }
	
	    return rval(state,stream,null);
	  }
	
	/////////////////////////////////////////////////////////////////////////////
	// utilities
	  function nongreedy(stream,re,words) {
	    if (stream.current().length == 1 && re.test(stream.current())) {
	      stream.backUp(1);
	      while (re.test(stream.peek())) {
	        stream.next();
	        if (is_member(stream.current(),words)) {
	          return true;
	        }
	      }
	      stream.backUp(stream.current().length-1);
	    }
	    return false;
	  }
	
	  function greedy(stream,re,words) {
	    if (stream.current().length == 1 && re.test(stream.current())) {
	      while (re.test(stream.peek())) {
	        stream.next();
	      }
	      while (0 < stream.current().length) {
	        if (is_member(stream.current(),words)) {
	          return true;
	        }else{
	          stream.backUp(1);
	        }
	      }
	      stream.next();
	    }
	    return false;
	  }
	
	  function doubleQuote(stream) {
	    return quote(stream, '"', '\\');
	  }
	
	  function singleQuote(stream) {
	    return quote(stream,'\'','\\');
	  }
	
	  function quote(stream,quoteChar,escapeChar) {
	    while (!stream.eol()) {
	      var ch = stream.next();
	      if (ch == quoteChar) {
	        return true;
	      }else if (ch == escapeChar) {
	        stream.next();
	      }
	    }
	    return false;
	  }
	
	  function lookahead(stream) {
	    var m = stream.match(/([\n\s]+|%[^\n]*\n)*(.)/,false);
	    return m ? m.pop() : "";
	  }
	
	  function is_member(element,list) {
	    return (-1 < list.indexOf(element));
	  }
	
	  function rval(state,stream,type) {
	
	    // parse stack
	    pushToken(state,realToken(type,stream));
	
	    // map erlang token type to CodeMirror style class
	    //     erlang             -> CodeMirror tag
	    switch (type) {
	      case "atom":        return "atom";
	      case "attribute":   return "attribute";
	      case "boolean":     return "atom";
	      case "builtin":     return "builtin";
	      case "close_paren": return null;
	      case "colon":       return null;
	      case "comment":     return "comment";
	      case "dot":         return null;
	      case "error":       return "error";
	      case "fun":         return "meta";
	      case "function":    return "tag";
	      case "guard":       return "property";
	      case "keyword":     return "keyword";
	      case "macro":       return "variable-2";
	      case "number":      return "number";
	      case "open_paren":  return null;
	      case "operator":    return "operator";
	      case "record":      return "bracket";
	      case "separator":   return null;
	      case "string":      return "string";
	      case "type":        return "def";
	      case "variable":    return "variable";
	      default:            return null;
	    }
	  }
	
	  function aToken(tok,col,ind,typ) {
	    return {token:  tok,
	            column: col,
	            indent: ind,
	            type:   typ};
	  }
	
	  function realToken(type,stream) {
	    return aToken(stream.current(),
	                 stream.column(),
	                 stream.indentation(),
	                 type);
	  }
	
	  function fakeToken(type) {
	    return aToken(type,0,0,type);
	  }
	
	  function peekToken(state,depth) {
	    var len = state.tokenStack.length;
	    var dep = (depth ? depth : 1);
	
	    if (len < dep) {
	      return false;
	    }else{
	      return state.tokenStack[len-dep];
	    }
	  }
	
	  function pushToken(state,token) {
	
	    if (!(token.type == "comment" || token.type == "whitespace")) {
	      state.tokenStack = maybe_drop_pre(state.tokenStack,token);
	      state.tokenStack = maybe_drop_post(state.tokenStack);
	    }
	  }
	
	  function maybe_drop_pre(s,token) {
	    var last = s.length-1;
	
	    if (0 < last && s[last].type === "record" && token.type === "dot") {
	      s.pop();
	    }else if (0 < last && s[last].type === "group") {
	      s.pop();
	      s.push(token);
	    }else{
	      s.push(token);
	    }
	    return s;
	  }
	
	  function maybe_drop_post(s) {
	    if (!s.length) return s
	    var last = s.length-1;
	
	    if (s[last].type === "dot") {
	      return [];
	    }
	    if (last > 1 && s[last].type === "fun" && s[last-1].token === "fun") {
	      return s.slice(0,last-1);
	    }
	    switch (s[last].token) {
	      case "}":    return d(s,{g:["{"]});
	      case "]":    return d(s,{i:["["]});
	      case ")":    return d(s,{i:["("]});
	      case ">>":   return d(s,{i:["<<"]});
	      case "end":  return d(s,{i:["begin","case","fun","if","receive","try"]});
	      case ",":    return d(s,{e:["begin","try","when","->",
	                                  ",","(","[","{","<<"]});
	      case "->":   return d(s,{r:["when"],
	                               m:["try","if","case","receive"]});
	      case ";":    return d(s,{E:["case","fun","if","receive","try","when"]});
	      case "catch":return d(s,{e:["try"]});
	      case "of":   return d(s,{e:["case"]});
	      case "after":return d(s,{e:["receive","try"]});
	      default:     return s;
	    }
	  }
	
	  function d(stack,tt) {
	    // stack is a stack of Token objects.
	    // tt is an object; {type:tokens}
	    // type is a char, tokens is a list of token strings.
	    // The function returns (possibly truncated) stack.
	    // It will descend the stack, looking for a Token such that Token.token
	    //  is a member of tokens. If it does not find that, it will normally (but
	    //  see "E" below) return stack. If it does find a match, it will remove
	    //  all the Tokens between the top and the matched Token.
	    // If type is "m", that is all it does.
	    // If type is "i", it will also remove the matched Token and the top Token.
	    // If type is "g", like "i", but add a fake "group" token at the top.
	    // If type is "r", it will remove the matched Token, but not the top Token.
	    // If type is "e", it will keep the matched Token but not the top Token.
	    // If type is "E", it behaves as for type "e", except if there is no match,
	    //  in which case it will return an empty stack.
	
	    for (var type in tt) {
	      var len = stack.length-1;
	      var tokens = tt[type];
	      for (var i = len-1; -1 < i ; i--) {
	        if (is_member(stack[i].token,tokens)) {
	          var ss = stack.slice(0,i);
	          switch (type) {
	              case "m": return ss.concat(stack[i]).concat(stack[len]);
	              case "r": return ss.concat(stack[len]);
	              case "i": return ss;
	              case "g": return ss.concat(fakeToken("group"));
	              case "E": return ss.concat(stack[i]);
	              case "e": return ss.concat(stack[i]);
	          }
	        }
	      }
	    }
	    return (type == "E" ? [] : stack);
	  }
	
	/////////////////////////////////////////////////////////////////////////////
	// indenter
	
	  function indenter(state,textAfter) {
	    var t;
	    var unit = cmCfg.indentUnit;
	    var wordAfter = wordafter(textAfter);
	    var currT = peekToken(state,1);
	    var prevT = peekToken(state,2);
	
	    if (state.in_string || state.in_atom) {
	      return CodeMirror.Pass;
	    }else if (!prevT) {
	      return 0;
	    }else if (currT.token == "when") {
	      return currT.column+unit;
	    }else if (wordAfter === "when" && prevT.type === "function") {
	      return prevT.indent+unit;
	    }else if (wordAfter === "(" && currT.token === "fun") {
	      return  currT.column+3;
	    }else if (wordAfter === "catch" && (t = getToken(state,["try"]))) {
	      return t.column;
	    }else if (is_member(wordAfter,["end","after","of"])) {
	      t = getToken(state,["begin","case","fun","if","receive","try"]);
	      return t ? t.column : CodeMirror.Pass;
	    }else if (is_member(wordAfter,closeParenWords)) {
	      t = getToken(state,openParenWords);
	      return t ? t.column : CodeMirror.Pass;
	    }else if (is_member(currT.token,[",","|","||"]) ||
	              is_member(wordAfter,[",","|","||"])) {
	      t = postcommaToken(state);
	      return t ? t.column+t.token.length : unit;
	    }else if (currT.token == "->") {
	      if (is_member(prevT.token, ["receive","case","if","try"])) {
	        return prevT.column+unit+unit;
	      }else{
	        return prevT.column+unit;
	      }
	    }else if (is_member(currT.token,openParenWords)) {
	      return currT.column+currT.token.length;
	    }else{
	      t = defaultToken(state);
	      return truthy(t) ? t.column+unit : 0;
	    }
	  }
	
	  function wordafter(str) {
	    var m = str.match(/,|[a-z]+|\}|\]|\)|>>|\|+|\(/);
	
	    return truthy(m) && (m.index === 0) ? m[0] : "";
	  }
	
	  function postcommaToken(state) {
	    var objs = state.tokenStack.slice(0,-1);
	    var i = getTokenIndex(objs,"type",["open_paren"]);
	
	    return truthy(objs[i]) ? objs[i] : false;
	  }
	
	  function defaultToken(state) {
	    var objs = state.tokenStack;
	    var stop = getTokenIndex(objs,"type",["open_paren","separator","keyword"]);
	    var oper = getTokenIndex(objs,"type",["operator"]);
	
	    if (truthy(stop) && truthy(oper) && stop < oper) {
	      return objs[stop+1];
	    } else if (truthy(stop)) {
	      return objs[stop];
	    } else {
	      return false;
	    }
	  }
	
	  function getToken(state,tokens) {
	    var objs = state.tokenStack;
	    var i = getTokenIndex(objs,"token",tokens);
	
	    return truthy(objs[i]) ? objs[i] : false;
	  }
	
	  function getTokenIndex(objs,propname,propvals) {
	
	    for (var i = objs.length-1; -1 < i ; i--) {
	      if (is_member(objs[i][propname],propvals)) {
	        return i;
	      }
	    }
	    return false;
	  }
	
	  function truthy(x) {
	    return (x !== false) && (x != null);
	  }
	
	/////////////////////////////////////////////////////////////////////////////
	// this object defines the mode
	
	  return {
	    startState:
	      function() {
	        return {tokenStack: [],
	                in_string:  false,
	                in_atom:    false};
	      },
	
	    token:
	      function(stream, state) {
	        return tokenizer(stream, state);
	      },
	
	    indent:
	      function(state, textAfter) {
	        return indenter(state,textAfter);
	      },
	
	    lineComment: "%"
	  };
	});
	
	});


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// Factor syntax highlight - simple mode
	//
	// by Dimage Sapelkin (https://github.com/kerabromsmu)
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(20));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../../addon/mode/simple"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineSimpleMode("factor", {
	    // The start state contains the rules that are intially used
	    start: [
	      // comments
	      {regex: /#?!.*/, token: "comment"},
	      // strings """, multiline --> state
	      {regex: /"""/, token: "string", next: "string3"},
	      {regex: /"/, token: "string", next: "string"},
	      // numbers: dec, hex, unicode, bin, fractional, complex
	      {regex: /(?:[+-]?)(?:0x[\d,a-f]+)|(?:0o[0-7]+)|(?:0b[0,1]+)|(?:\d+.?\d*)/, token: "number"},
	      //{regex: /[+-]?/} //fractional
	      // definition: defining word, defined word, etc
	      {regex: /(\:)(\s+)(\S+)(\s+)(\()/, token: ["keyword", null, "def", null, "keyword"], next: "stack"},
	      // vocabulary using --> state
	      {regex: /USING\:/, token: "keyword", next: "vocabulary"},
	      // vocabulary definition/use
	      {regex: /(USE\:|IN\:)(\s+)(\S+)/, token: ["keyword", null, "variable-2"]},
	      // <constructors>
	      {regex: /<\S+>/, token: "builtin"},
	      // "keywords", incl. ; t f . [ ] { } defining words
	      {regex: /;|t|f|if|\.|\[|\]|\{|\}|MAIN:/, token: "keyword"},
	      // any id (?)
	      {regex: /\S+/, token: "variable"},
	
	      {
	        regex: /./,
	        token: null
	      }
	    ],
	    vocabulary: [
	      {regex: /;/, token: "keyword", next: "start"},
	      {regex: /\S+/, token: "variable-2"},
	      {
	        regex: /./,
	        token: null
	      }
	    ],
	    string: [
	      {regex: /(?:[^\\]|\\.)*?"/, token: "string", next: "start"},
	      {regex: /.*/, token: "string"}
	    ],
	    string3: [
	      {regex: /(?:[^\\]|\\.)*?"""/, token: "string", next: "start"},
	      {regex: /.*/, token: "string"}
	    ],
	    stack: [
	      {regex: /\)/, token: "meta", next: "start"},
	      {regex: /--/, token: "meta"},
	      {regex: /\S+/, token: "variable-3"},
	      {
	        regex: /./,
	        token: null
	      }
	    ],
	    // The meta property contains global information about the mode. It
	    // can contain properties like lineComment, which are supported by
	    // all modes, and also directives like dontIndentStates, which are
	    // specific to simple modes.
	    meta: {
	      dontIndentStates: ["start", "vocabulary", "string", "string3", "stack"],
	      lineComment: [ "!", "#!" ]
	    }
	  });
	
	  CodeMirror.defineMIME("text/x-factor", "factor");
	});


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("fcl", function(config) {
	  var indentUnit = config.indentUnit;
	
	  var keywords = {
	      "term": true,
	      "method": true, "accu": true,
	      "rule": true, "then": true, "is": true, "and": true, "or": true,
	      "if": true, "default": true
	  };
	
	  var start_blocks = {
	      "var_input": true,
	      "var_output": true,
	      "fuzzify": true,
	      "defuzzify": true,
	      "function_block": true,
	      "ruleblock": true
	  };
	
	  var end_blocks = {
	      "end_ruleblock": true,
	      "end_defuzzify": true,
	      "end_function_block": true,
	      "end_fuzzify": true,
	      "end_var": true
	  };
	
	  var atoms = {
	      "true": true, "false": true, "nan": true,
	      "real": true, "min": true, "max": true, "cog": true, "cogs": true
	  };
	
	  var isOperatorChar = /[+\-*&^%:=<>!|\/]/;
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	
	    if (/[\d\.]/.test(ch)) {
	      if (ch == ".") {
	        stream.match(/^[0-9]+([eE][\-+]?[0-9]+)?/);
	      } else if (ch == "0") {
	        stream.match(/^[xX][0-9a-fA-F]+/) || stream.match(/^0[0-7]+/);
	      } else {
	        stream.match(/^[0-9]*\.?[0-9]*([eE][\-+]?[0-9]+)?/);
	      }
	      return "number";
	    }
	
	    if (ch == "/" || ch == "(") {
	      if (stream.eat("*")) {
	        state.tokenize = tokenComment;
	        return tokenComment(stream, state);
	      }
	      if (stream.eat("/")) {
	        stream.skipToEnd();
	        return "comment";
	      }
	    }
	    if (isOperatorChar.test(ch)) {
	      stream.eatWhile(isOperatorChar);
	      return "operator";
	    }
	    stream.eatWhile(/[\w\$_\xa1-\uffff]/);
	
	    var cur = stream.current().toLowerCase();
	    if (keywords.propertyIsEnumerable(cur) ||
	        start_blocks.propertyIsEnumerable(cur) ||
	        end_blocks.propertyIsEnumerable(cur)) {
	      return "keyword";
	    }
	    if (atoms.propertyIsEnumerable(cur)) return "atom";
	    return "variable";
	  }
	
	
	  function tokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while (ch = stream.next()) {
	      if ((ch == "/" || ch == ")") && maybeEnd) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return "comment";
	  }
	
	  function Context(indented, column, type, align, prev) {
	    this.indented = indented;
	    this.column = column;
	    this.type = type;
	    this.align = align;
	    this.prev = prev;
	  }
	
	  function pushContext(state, col, type) {
	    return state.context = new Context(state.indented, col, type, null, state.context);
	  }
	
	  function popContext(state) {
	    if (!state.context.prev) return;
	    var t = state.context.type;
	    if (t == "end_block")
	      state.indented = state.context.indented;
	    return state.context = state.context.prev;
	  }
	
	  // Interface
	
	  return {
	    startState: function(basecolumn) {
	      return {
	        tokenize: null,
	        context: new Context((basecolumn || 0) - indentUnit, 0, "top", false),
	        indented: 0,
	        startOfLine: true
	      };
	    },
	
	    token: function(stream, state) {
	        var ctx = state.context;
	        if (stream.sol()) {
	            if (ctx.align == null) ctx.align = false;
	            state.indented = stream.indentation();
	            state.startOfLine = true;
	        }
	        if (stream.eatSpace()) return null;
	
	        var style = (state.tokenize || tokenBase)(stream, state);
	        if (style == "comment") return style;
	        if (ctx.align == null) ctx.align = true;
	
	        var cur = stream.current().toLowerCase();
	
	        if (start_blocks.propertyIsEnumerable(cur)) pushContext(state, stream.column(), "end_block");
	        else if (end_blocks.propertyIsEnumerable(cur))  popContext(state);
	
	        state.startOfLine = false;
	        return style;
	    },
	
	    indent: function(state, textAfter) {
	      if (state.tokenize != tokenBase && state.tokenize != null) return 0;
	      var ctx = state.context;
	
	      var closing = end_blocks.propertyIsEnumerable(textAfter);
	      if (ctx.align) return ctx.column + (closing ? 0 : 1);
	      else return ctx.indented + (closing ? 0 : indentUnit);
	    },
	
	    electricChars: "ryk",
	    fold: "brace",
	    blockCommentStart: "(*",
	    blockCommentEnd: "*)",
	    lineComment: "//"
	  };
	});
	
	CodeMirror.defineMIME("text/x-fcl", "fcl");
	});


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// Author: Aliaksei Chapyzhenka
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  function toWordList(words) {
	    var ret = [];
	    words.split(' ').forEach(function(e){
	      ret.push({name: e});
	    });
	    return ret;
	  }
	
	  var coreWordList = toWordList(
	'INVERT AND OR XOR\
	 2* 2/ LSHIFT RSHIFT\
	 0= = 0< < > U< MIN MAX\
	 2DROP 2DUP 2OVER 2SWAP ?DUP DEPTH DROP DUP OVER ROT SWAP\
	 >R R> R@\
	 + - 1+ 1- ABS NEGATE\
	 S>D * M* UM*\
	 FM/MOD SM/REM UM/MOD */ */MOD / /MOD MOD\
	 HERE , @ ! CELL+ CELLS C, C@ C! CHARS 2@ 2!\
	 ALIGN ALIGNED +! ALLOT\
	 CHAR [CHAR] [ ] BL\
	 FIND EXECUTE IMMEDIATE COUNT LITERAL STATE\
	 ; DOES> >BODY\
	 EVALUATE\
	 SOURCE >IN\
	 <# # #S #> HOLD SIGN BASE >NUMBER HEX DECIMAL\
	 FILL MOVE\
	 . CR EMIT SPACE SPACES TYPE U. .R U.R\
	 ACCEPT\
	 TRUE FALSE\
	 <> U> 0<> 0>\
	 NIP TUCK ROLL PICK\
	 2>R 2R@ 2R>\
	 WITHIN UNUSED MARKER\
	 I J\
	 TO\
	 COMPILE, [COMPILE]\
	 SAVE-INPUT RESTORE-INPUT\
	 PAD ERASE\
	 2LITERAL DNEGATE\
	 D- D+ D0< D0= D2* D2/ D< D= DMAX DMIN D>S DABS\
	 M+ M*/ D. D.R 2ROT DU<\
	 CATCH THROW\
	 FREE RESIZE ALLOCATE\
	 CS-PICK CS-ROLL\
	 GET-CURRENT SET-CURRENT FORTH-WORDLIST GET-ORDER SET-ORDER\
	 PREVIOUS SEARCH-WORDLIST WORDLIST FIND ALSO ONLY FORTH DEFINITIONS ORDER\
	 -TRAILING /STRING SEARCH COMPARE CMOVE CMOVE> BLANK SLITERAL');
	
	  var immediateWordList = toWordList('IF ELSE THEN BEGIN WHILE REPEAT UNTIL RECURSE [IF] [ELSE] [THEN] ?DO DO LOOP +LOOP UNLOOP LEAVE EXIT AGAIN CASE OF ENDOF ENDCASE');
	
	  CodeMirror.defineMode('forth', function() {
	    function searchWordList (wordList, word) {
	      var i;
	      for (i = wordList.length - 1; i >= 0; i--) {
	        if (wordList[i].name === word.toUpperCase()) {
	          return wordList[i];
	        }
	      }
	      return undefined;
	    }
	  return {
	    startState: function() {
	      return {
	        state: '',
	        base: 10,
	        coreWordList: coreWordList,
	        immediateWordList: immediateWordList,
	        wordList: []
	      };
	    },
	    token: function (stream, stt) {
	      var mat;
	      if (stream.eatSpace()) {
	        return null;
	      }
	      if (stt.state === '') { // interpretation
	        if (stream.match(/^(\]|:NONAME)(\s|$)/i)) {
	          stt.state = ' compilation';
	          return 'builtin compilation';
	        }
	        mat = stream.match(/^(\:)\s+(\S+)(\s|$)+/);
	        if (mat) {
	          stt.wordList.push({name: mat[2].toUpperCase()});
	          stt.state = ' compilation';
	          return 'def' + stt.state;
	        }
	        mat = stream.match(/^(VARIABLE|2VARIABLE|CONSTANT|2CONSTANT|CREATE|POSTPONE|VALUE|WORD)\s+(\S+)(\s|$)+/i);
	        if (mat) {
	          stt.wordList.push({name: mat[2].toUpperCase()});
	          return 'def' + stt.state;
	        }
	        mat = stream.match(/^(\'|\[\'\])\s+(\S+)(\s|$)+/);
	        if (mat) {
	          return 'builtin' + stt.state;
	        }
	        } else { // compilation
	        // ; [
	        if (stream.match(/^(\;|\[)(\s)/)) {
	          stt.state = '';
	          stream.backUp(1);
	          return 'builtin compilation';
	        }
	        if (stream.match(/^(\;|\[)($)/)) {
	          stt.state = '';
	          return 'builtin compilation';
	        }
	        if (stream.match(/^(POSTPONE)\s+\S+(\s|$)+/)) {
	          return 'builtin';
	        }
	      }
	
	      // dynamic wordlist
	      mat = stream.match(/^(\S+)(\s+|$)/);
	      if (mat) {
	        if (searchWordList(stt.wordList, mat[1]) !== undefined) {
	          return 'variable' + stt.state;
	        }
	
	        // comments
	        if (mat[1] === '\\') {
	          stream.skipToEnd();
	            return 'comment' + stt.state;
	          }
	
	          // core words
	          if (searchWordList(stt.coreWordList, mat[1]) !== undefined) {
	            return 'builtin' + stt.state;
	          }
	          if (searchWordList(stt.immediateWordList, mat[1]) !== undefined) {
	            return 'keyword' + stt.state;
	          }
	
	          if (mat[1] === '(') {
	            stream.eatWhile(function (s) { return s !== ')'; });
	            stream.eat(')');
	            return 'comment' + stt.state;
	          }
	
	          // // strings
	          if (mat[1] === '.(') {
	            stream.eatWhile(function (s) { return s !== ')'; });
	            stream.eat(')');
	            return 'string' + stt.state;
	          }
	          if (mat[1] === 'S"' || mat[1] === '."' || mat[1] === 'C"') {
	            stream.eatWhile(function (s) { return s !== '"'; });
	            stream.eat('"');
	            return 'string' + stt.state;
	          }
	
	          // numbers
	          if (mat[1] - 0xfffffffff) {
	            return 'number' + stt.state;
	          }
	          // if (mat[1].match(/^[-+]?[0-9]+\.[0-9]*/)) {
	          //     return 'number' + stt.state;
	          // }
	
	          return 'atom' + stt.state;
	        }
	      }
	    };
	  });
	  CodeMirror.defineMIME("text/x-forth", "forth");
	});


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("fortran", function() {
	  function words(array) {
	    var keys = {};
	    for (var i = 0; i < array.length; ++i) {
	      keys[array[i]] = true;
	    }
	    return keys;
	  }
	
	  var keywords = words([
	                  "abstract", "accept", "allocatable", "allocate",
	                  "array", "assign", "asynchronous", "backspace",
	                  "bind", "block", "byte", "call", "case",
	                  "class", "close", "common", "contains",
	                  "continue", "cycle", "data", "deallocate",
	                  "decode", "deferred", "dimension", "do",
	                  "elemental", "else", "encode", "end",
	                  "endif", "entry", "enumerator", "equivalence",
	                  "exit", "external", "extrinsic", "final",
	                  "forall", "format", "function", "generic",
	                  "go", "goto", "if", "implicit", "import", "include",
	                  "inquire", "intent", "interface", "intrinsic",
	                  "module", "namelist", "non_intrinsic",
	                  "non_overridable", "none", "nopass",
	                  "nullify", "open", "optional", "options",
	                  "parameter", "pass", "pause", "pointer",
	                  "print", "private", "program", "protected",
	                  "public", "pure", "read", "recursive", "result",
	                  "return", "rewind", "save", "select", "sequence",
	                  "stop", "subroutine", "target", "then", "to", "type",
	                  "use", "value", "volatile", "where", "while",
	                  "write"]);
	  var builtins = words(["abort", "abs", "access", "achar", "acos",
	                          "adjustl", "adjustr", "aimag", "aint", "alarm",
	                          "all", "allocated", "alog", "amax", "amin",
	                          "amod", "and", "anint", "any", "asin",
	                          "associated", "atan", "besj", "besjn", "besy",
	                          "besyn", "bit_size", "btest", "cabs", "ccos",
	                          "ceiling", "cexp", "char", "chdir", "chmod",
	                          "clog", "cmplx", "command_argument_count",
	                          "complex", "conjg", "cos", "cosh", "count",
	                          "cpu_time", "cshift", "csin", "csqrt", "ctime",
	                          "c_funloc", "c_loc", "c_associated", "c_null_ptr",
	                          "c_null_funptr", "c_f_pointer", "c_null_char",
	                          "c_alert", "c_backspace", "c_form_feed",
	                          "c_new_line", "c_carriage_return",
	                          "c_horizontal_tab", "c_vertical_tab", "dabs",
	                          "dacos", "dasin", "datan", "date_and_time",
	                          "dbesj", "dbesj", "dbesjn", "dbesy", "dbesy",
	                          "dbesyn", "dble", "dcos", "dcosh", "ddim", "derf",
	                          "derfc", "dexp", "digits", "dim", "dint", "dlog",
	                          "dlog", "dmax", "dmin", "dmod", "dnint",
	                          "dot_product", "dprod", "dsign", "dsinh",
	                          "dsin", "dsqrt", "dtanh", "dtan", "dtime",
	                          "eoshift", "epsilon", "erf", "erfc", "etime",
	                          "exit", "exp", "exponent", "extends_type_of",
	                          "fdate", "fget", "fgetc", "float", "floor",
	                          "flush", "fnum", "fputc", "fput", "fraction",
	                          "fseek", "fstat", "ftell", "gerror", "getarg",
	                          "get_command", "get_command_argument",
	                          "get_environment_variable", "getcwd",
	                          "getenv", "getgid", "getlog", "getpid",
	                          "getuid", "gmtime", "hostnm", "huge", "iabs",
	                          "iachar", "iand", "iargc", "ibclr", "ibits",
	                          "ibset", "ichar", "idate", "idim", "idint",
	                          "idnint", "ieor", "ierrno", "ifix", "imag",
	                          "imagpart", "index", "int", "ior", "irand",
	                          "isatty", "ishft", "ishftc", "isign",
	                          "iso_c_binding", "is_iostat_end", "is_iostat_eor",
	                          "itime", "kill", "kind", "lbound", "len", "len_trim",
	                          "lge", "lgt", "link", "lle", "llt", "lnblnk", "loc",
	                          "log", "logical", "long", "lshift", "lstat", "ltime",
	                          "matmul", "max", "maxexponent", "maxloc", "maxval",
	                          "mclock", "merge", "move_alloc", "min", "minexponent",
	                          "minloc", "minval", "mod", "modulo", "mvbits",
	                          "nearest", "new_line", "nint", "not", "or", "pack",
	                          "perror", "precision", "present", "product", "radix",
	                          "rand", "random_number", "random_seed", "range",
	                          "real", "realpart", "rename", "repeat", "reshape",
	                          "rrspacing", "rshift", "same_type_as", "scale",
	                          "scan", "second", "selected_int_kind",
	                          "selected_real_kind", "set_exponent", "shape",
	                          "short", "sign", "signal", "sinh", "sin", "sleep",
	                          "sngl", "spacing", "spread", "sqrt", "srand", "stat",
	                          "sum", "symlnk", "system", "system_clock", "tan",
	                          "tanh", "time", "tiny", "transfer", "transpose",
	                          "trim", "ttynam", "ubound", "umask", "unlink",
	                          "unpack", "verify", "xor", "zabs", "zcos", "zexp",
	                          "zlog", "zsin", "zsqrt"]);
	
	    var dataTypes =  words(["c_bool", "c_char", "c_double", "c_double_complex",
	                     "c_float", "c_float_complex", "c_funptr", "c_int",
	                     "c_int16_t", "c_int32_t", "c_int64_t", "c_int8_t",
	                     "c_int_fast16_t", "c_int_fast32_t", "c_int_fast64_t",
	                     "c_int_fast8_t", "c_int_least16_t", "c_int_least32_t",
	                     "c_int_least64_t", "c_int_least8_t", "c_intmax_t",
	                     "c_intptr_t", "c_long", "c_long_double",
	                     "c_long_double_complex", "c_long_long", "c_ptr",
	                     "c_short", "c_signed_char", "c_size_t", "character",
	                     "complex", "double", "integer", "logical", "real"]);
	  var isOperatorChar = /[+\-*&=<>\/\:]/;
	  var litOperator = new RegExp("(\.and\.|\.or\.|\.eq\.|\.lt\.|\.le\.|\.gt\.|\.ge\.|\.ne\.|\.not\.|\.eqv\.|\.neqv\.)", "i");
	
	  function tokenBase(stream, state) {
	
	    if (stream.match(litOperator)){
	        return 'operator';
	    }
	
	    var ch = stream.next();
	    if (ch == "!") {
	      stream.skipToEnd();
	      return "comment";
	    }
	    if (ch == '"' || ch == "'") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    }
	    if (/[\[\]\(\),]/.test(ch)) {
	      return null;
	    }
	    if (/\d/.test(ch)) {
	      stream.eatWhile(/[\w\.]/);
	      return "number";
	    }
	    if (isOperatorChar.test(ch)) {
	      stream.eatWhile(isOperatorChar);
	      return "operator";
	    }
	    stream.eatWhile(/[\w\$_]/);
	    var word = stream.current().toLowerCase();
	
	    if (keywords.hasOwnProperty(word)){
	            return 'keyword';
	    }
	    if (builtins.hasOwnProperty(word) || dataTypes.hasOwnProperty(word)) {
	            return 'builtin';
	    }
	    return "variable";
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, next, end = false;
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) {
	            end = true;
	            break;
	        }
	        escaped = !escaped && next == "\\";
	      }
	      if (end || !escaped) state.tokenize = null;
	      return "string";
	    };
	  }
	
	  // Interface
	
	  return {
	    startState: function() {
	      return {tokenize: null};
	    },
	
	    token: function(stream, state) {
	      if (stream.eatSpace()) return null;
	      var style = (state.tokenize || tokenBase)(stream, state);
	      if (style == "comment" || style == "meta") return style;
	      return style;
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/x-fortran", "fortran");
	
	});


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("gas", function(_config, parserConfig) {
	  'use strict';
	
	  // If an architecture is specified, its initialization function may
	  // populate this array with custom parsing functions which will be
	  // tried in the event that the standard functions do not find a match.
	  var custom = [];
	
	  // The symbol used to start a line comment changes based on the target
	  // architecture.
	  // If no architecture is pased in "parserConfig" then only multiline
	  // comments will have syntax support.
	  var lineCommentStartSymbol = "";
	
	  // These directives are architecture independent.
	  // Machine specific directives should go in their respective
	  // architecture initialization function.
	  // Reference:
	  // http://sourceware.org/binutils/docs/as/Pseudo-Ops.html#Pseudo-Ops
	  var directives = {
	    ".abort" : "builtin",
	    ".align" : "builtin",
	    ".altmacro" : "builtin",
	    ".ascii" : "builtin",
	    ".asciz" : "builtin",
	    ".balign" : "builtin",
	    ".balignw" : "builtin",
	    ".balignl" : "builtin",
	    ".bundle_align_mode" : "builtin",
	    ".bundle_lock" : "builtin",
	    ".bundle_unlock" : "builtin",
	    ".byte" : "builtin",
	    ".cfi_startproc" : "builtin",
	    ".comm" : "builtin",
	    ".data" : "builtin",
	    ".def" : "builtin",
	    ".desc" : "builtin",
	    ".dim" : "builtin",
	    ".double" : "builtin",
	    ".eject" : "builtin",
	    ".else" : "builtin",
	    ".elseif" : "builtin",
	    ".end" : "builtin",
	    ".endef" : "builtin",
	    ".endfunc" : "builtin",
	    ".endif" : "builtin",
	    ".equ" : "builtin",
	    ".equiv" : "builtin",
	    ".eqv" : "builtin",
	    ".err" : "builtin",
	    ".error" : "builtin",
	    ".exitm" : "builtin",
	    ".extern" : "builtin",
	    ".fail" : "builtin",
	    ".file" : "builtin",
	    ".fill" : "builtin",
	    ".float" : "builtin",
	    ".func" : "builtin",
	    ".global" : "builtin",
	    ".gnu_attribute" : "builtin",
	    ".hidden" : "builtin",
	    ".hword" : "builtin",
	    ".ident" : "builtin",
	    ".if" : "builtin",
	    ".incbin" : "builtin",
	    ".include" : "builtin",
	    ".int" : "builtin",
	    ".internal" : "builtin",
	    ".irp" : "builtin",
	    ".irpc" : "builtin",
	    ".lcomm" : "builtin",
	    ".lflags" : "builtin",
	    ".line" : "builtin",
	    ".linkonce" : "builtin",
	    ".list" : "builtin",
	    ".ln" : "builtin",
	    ".loc" : "builtin",
	    ".loc_mark_labels" : "builtin",
	    ".local" : "builtin",
	    ".long" : "builtin",
	    ".macro" : "builtin",
	    ".mri" : "builtin",
	    ".noaltmacro" : "builtin",
	    ".nolist" : "builtin",
	    ".octa" : "builtin",
	    ".offset" : "builtin",
	    ".org" : "builtin",
	    ".p2align" : "builtin",
	    ".popsection" : "builtin",
	    ".previous" : "builtin",
	    ".print" : "builtin",
	    ".protected" : "builtin",
	    ".psize" : "builtin",
	    ".purgem" : "builtin",
	    ".pushsection" : "builtin",
	    ".quad" : "builtin",
	    ".reloc" : "builtin",
	    ".rept" : "builtin",
	    ".sbttl" : "builtin",
	    ".scl" : "builtin",
	    ".section" : "builtin",
	    ".set" : "builtin",
	    ".short" : "builtin",
	    ".single" : "builtin",
	    ".size" : "builtin",
	    ".skip" : "builtin",
	    ".sleb128" : "builtin",
	    ".space" : "builtin",
	    ".stab" : "builtin",
	    ".string" : "builtin",
	    ".struct" : "builtin",
	    ".subsection" : "builtin",
	    ".symver" : "builtin",
	    ".tag" : "builtin",
	    ".text" : "builtin",
	    ".title" : "builtin",
	    ".type" : "builtin",
	    ".uleb128" : "builtin",
	    ".val" : "builtin",
	    ".version" : "builtin",
	    ".vtable_entry" : "builtin",
	    ".vtable_inherit" : "builtin",
	    ".warning" : "builtin",
	    ".weak" : "builtin",
	    ".weakref" : "builtin",
	    ".word" : "builtin"
	  };
	
	  var registers = {};
	
	  function x86(_parserConfig) {
	    lineCommentStartSymbol = "#";
	
	    registers.ax  = "variable";
	    registers.eax = "variable-2";
	    registers.rax = "variable-3";
	
	    registers.bx  = "variable";
	    registers.ebx = "variable-2";
	    registers.rbx = "variable-3";
	
	    registers.cx  = "variable";
	    registers.ecx = "variable-2";
	    registers.rcx = "variable-3";
	
	    registers.dx  = "variable";
	    registers.edx = "variable-2";
	    registers.rdx = "variable-3";
	
	    registers.si  = "variable";
	    registers.esi = "variable-2";
	    registers.rsi = "variable-3";
	
	    registers.di  = "variable";
	    registers.edi = "variable-2";
	    registers.rdi = "variable-3";
	
	    registers.sp  = "variable";
	    registers.esp = "variable-2";
	    registers.rsp = "variable-3";
	
	    registers.bp  = "variable";
	    registers.ebp = "variable-2";
	    registers.rbp = "variable-3";
	
	    registers.ip  = "variable";
	    registers.eip = "variable-2";
	    registers.rip = "variable-3";
	
	    registers.cs  = "keyword";
	    registers.ds  = "keyword";
	    registers.ss  = "keyword";
	    registers.es  = "keyword";
	    registers.fs  = "keyword";
	    registers.gs  = "keyword";
	  }
	
	  function armv6(_parserConfig) {
	    // Reference:
	    // http://infocenter.arm.com/help/topic/com.arm.doc.qrc0001l/QRC0001_UAL.pdf
	    // http://infocenter.arm.com/help/topic/com.arm.doc.ddi0301h/DDI0301H_arm1176jzfs_r0p7_trm.pdf
	    lineCommentStartSymbol = "@";
	    directives.syntax = "builtin";
	
	    registers.r0  = "variable";
	    registers.r1  = "variable";
	    registers.r2  = "variable";
	    registers.r3  = "variable";
	    registers.r4  = "variable";
	    registers.r5  = "variable";
	    registers.r6  = "variable";
	    registers.r7  = "variable";
	    registers.r8  = "variable";
	    registers.r9  = "variable";
	    registers.r10 = "variable";
	    registers.r11 = "variable";
	    registers.r12 = "variable";
	
	    registers.sp  = "variable-2";
	    registers.lr  = "variable-2";
	    registers.pc  = "variable-2";
	    registers.r13 = registers.sp;
	    registers.r14 = registers.lr;
	    registers.r15 = registers.pc;
	
	    custom.push(function(ch, stream) {
	      if (ch === '#') {
	        stream.eatWhile(/\w/);
	        return "number";
	      }
	    });
	  }
	
	  var arch = (parserConfig.architecture || "x86").toLowerCase();
	  if (arch === "x86") {
	    x86(parserConfig);
	  } else if (arch === "arm" || arch === "armv6") {
	    armv6(parserConfig);
	  }
	
	  function nextUntilUnescaped(stream, end) {
	    var escaped = false, next;
	    while ((next = stream.next()) != null) {
	      if (next === end && !escaped) {
	        return false;
	      }
	      escaped = !escaped && next === "\\";
	    }
	    return escaped;
	  }
	
	  function clikeComment(stream, state) {
	    var maybeEnd = false, ch;
	    while ((ch = stream.next()) != null) {
	      if (ch === "/" && maybeEnd) {
	        state.tokenize = null;
	        break;
	      }
	      maybeEnd = (ch === "*");
	    }
	    return "comment";
	  }
	
	  return {
	    startState: function() {
	      return {
	        tokenize: null
	      };
	    },
	
	    token: function(stream, state) {
	      if (state.tokenize) {
	        return state.tokenize(stream, state);
	      }
	
	      if (stream.eatSpace()) {
	        return null;
	      }
	
	      var style, cur, ch = stream.next();
	
	      if (ch === "/") {
	        if (stream.eat("*")) {
	          state.tokenize = clikeComment;
	          return clikeComment(stream, state);
	        }
	      }
	
	      if (ch === lineCommentStartSymbol) {
	        stream.skipToEnd();
	        return "comment";
	      }
	
	      if (ch === '"') {
	        nextUntilUnescaped(stream, '"');
	        return "string";
	      }
	
	      if (ch === '.') {
	        stream.eatWhile(/\w/);
	        cur = stream.current().toLowerCase();
	        style = directives[cur];
	        return style || null;
	      }
	
	      if (ch === '=') {
	        stream.eatWhile(/\w/);
	        return "tag";
	      }
	
	      if (ch === '{') {
	        return "braket";
	      }
	
	      if (ch === '}') {
	        return "braket";
	      }
	
	      if (/\d/.test(ch)) {
	        if (ch === "0" && stream.eat("x")) {
	          stream.eatWhile(/[0-9a-fA-F]/);
	          return "number";
	        }
	        stream.eatWhile(/\d/);
	        return "number";
	      }
	
	      if (/\w/.test(ch)) {
	        stream.eatWhile(/\w/);
	        if (stream.eat(":")) {
	          return 'tag';
	        }
	        cur = stream.current().toLowerCase();
	        style = registers[cur];
	        return style || null;
	      }
	
	      for (var i = 0; i < custom.length; i++) {
	        style = custom[i](ch, stream, state);
	        if (style) {
	          return style;
	        }
	      }
	    },
	
	    lineComment: lineCommentStartSymbol,
	    blockCommentStart: "/*",
	    blockCommentEnd: "*/"
	  };
	});
	
	});


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(81), __webpack_require__(19));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../markdown/markdown", "../../addon/mode/overlay"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	var urlRE = /^((?:(?:aaas?|about|acap|adiumxtra|af[ps]|aim|apt|attachment|aw|beshare|bitcoin|bolo|callto|cap|chrome(?:-extension)?|cid|coap|com-eventbrite-attendee|content|crid|cvs|data|dav|dict|dlna-(?:playcontainer|playsingle)|dns|doi|dtn|dvb|ed2k|facetime|feed|file|finger|fish|ftp|geo|gg|git|gizmoproject|go|gopher|gtalk|h323|hcp|https?|iax|icap|icon|im|imap|info|ipn|ipp|irc[6s]?|iris(?:\.beep|\.lwz|\.xpc|\.xpcs)?|itms|jar|javascript|jms|keyparc|lastfm|ldaps?|magnet|mailto|maps|market|message|mid|mms|ms-help|msnim|msrps?|mtqp|mumble|mupdate|mvn|news|nfs|nih?|nntp|notes|oid|opaquelocktoken|palm|paparazzi|platform|pop|pres|proxy|psyc|query|res(?:ource)?|rmi|rsync|rtmp|rtsp|secondlife|service|session|sftp|sgn|shttp|sieve|sips?|skype|sm[bs]|snmp|soap\.beeps?|soldat|spotify|ssh|steam|svn|tag|teamspeak|tel(?:net)?|tftp|things|thismessage|tip|tn3270|tv|udp|unreal|urn|ut2004|vemmi|ventrilo|view-source|webcal|wss?|wtai|wyciwyg|xcon(?:-userid)?|xfire|xmlrpc\.beeps?|xmpp|xri|ymsgr|z39\.50[rs]?):(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]|\([^\s()<>]*\))+(?:\([^\s()<>]*\)|[^\s`*!()\[\]{};:'".,<>?«»“”‘’]))/i
	
	CodeMirror.defineMode("gfm", function(config, modeConfig) {
	  var codeDepth = 0;
	  function blankLine(state) {
	    state.code = false;
	    return null;
	  }
	  var gfmOverlay = {
	    startState: function() {
	      return {
	        code: false,
	        codeBlock: false,
	        ateSpace: false
	      };
	    },
	    copyState: function(s) {
	      return {
	        code: s.code,
	        codeBlock: s.codeBlock,
	        ateSpace: s.ateSpace
	      };
	    },
	    token: function(stream, state) {
	      state.combineTokens = null;
	
	      // Hack to prevent formatting override inside code blocks (block and inline)
	      if (state.codeBlock) {
	        if (stream.match(/^```+/)) {
	          state.codeBlock = false;
	          return null;
	        }
	        stream.skipToEnd();
	        return null;
	      }
	      if (stream.sol()) {
	        state.code = false;
	      }
	      if (stream.sol() && stream.match(/^```+/)) {
	        stream.skipToEnd();
	        state.codeBlock = true;
	        return null;
	      }
	      // If this block is changed, it may need to be updated in Markdown mode
	      if (stream.peek() === '`') {
	        stream.next();
	        var before = stream.pos;
	        stream.eatWhile('`');
	        var difference = 1 + stream.pos - before;
	        if (!state.code) {
	          codeDepth = difference;
	          state.code = true;
	        } else {
	          if (difference === codeDepth) { // Must be exact
	            state.code = false;
	          }
	        }
	        return null;
	      } else if (state.code) {
	        stream.next();
	        return null;
	      }
	      // Check if space. If so, links can be formatted later on
	      if (stream.eatSpace()) {
	        state.ateSpace = true;
	        return null;
	      }
	      if (stream.sol() || state.ateSpace) {
	        state.ateSpace = false;
	        if (modeConfig.gitHubSpice !== false) {
	          if(stream.match(/^(?:[a-zA-Z0-9\-_]+\/)?(?:[a-zA-Z0-9\-_]+@)?(?:[a-f0-9]{7,40}\b)/)) {
	            // User/Project@SHA
	            // User@SHA
	            // SHA
	            state.combineTokens = true;
	            return "link";
	          } else if (stream.match(/^(?:[a-zA-Z0-9\-_]+\/)?(?:[a-zA-Z0-9\-_]+)?#[0-9]+\b/)) {
	            // User/Project#Num
	            // User#Num
	            // #Num
	            state.combineTokens = true;
	            return "link";
	          }
	        }
	      }
	      if (stream.match(urlRE) &&
	          stream.string.slice(stream.start - 2, stream.start) != "](" &&
	          (stream.start == 0 || /\W/.test(stream.string.charAt(stream.start - 1)))) {
	        // URLs
	        // Taken from http://daringfireball.net/2010/07/improved_regex_for_matching_urls
	        // And then (issue #1160) simplified to make it not crash the Chrome Regexp engine
	        // And then limited url schemes to the CommonMark list, so foo:bar isn't matched as a URL
	        state.combineTokens = true;
	        return "link";
	      }
	      stream.next();
	      return null;
	    },
	    blankLine: blankLine
	  };
	
	  var markdownConfig = {
	    underscoresBreakWords: false,
	    taskLists: true,
	    fencedCodeBlocks: '```',
	    strikethrough: true
	  };
	  for (var attr in modeConfig) {
	    markdownConfig[attr] = modeConfig[attr];
	  }
	  markdownConfig.name = "markdown";
	  return CodeMirror.overlayMode(CodeMirror.getMode(config, markdownConfig), gfmOverlay);
	
	}, "markdown");
	
	  CodeMirror.defineMIME("text/x-gfm", "gfm");
	});


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	/*
	Gherkin mode - http://www.cukes.info/
	Report bugs/issues here: https://github.com/codemirror/CodeMirror/issues
	*/
	
	// Following Objs from Brackets implementation: https://github.com/tregusti/brackets-gherkin/blob/master/main.js
	//var Quotes = {
	//  SINGLE: 1,
	//  DOUBLE: 2
	//};
	
	//var regex = {
	//  keywords: /(Feature| {2}(Scenario|In order to|As|I)| {4}(Given|When|Then|And))/
	//};
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("gherkin", function () {
	  return {
	    startState: function () {
	      return {
	        lineNumber: 0,
	        tableHeaderLine: false,
	        allowFeature: true,
	        allowBackground: false,
	        allowScenario: false,
	        allowSteps: false,
	        allowPlaceholders: false,
	        allowMultilineArgument: false,
	        inMultilineString: false,
	        inMultilineTable: false,
	        inKeywordLine: false
	      };
	    },
	    token: function (stream, state) {
	      if (stream.sol()) {
	        state.lineNumber++;
	        state.inKeywordLine = false;
	        if (state.inMultilineTable) {
	            state.tableHeaderLine = false;
	            if (!stream.match(/\s*\|/, false)) {
	              state.allowMultilineArgument = false;
	              state.inMultilineTable = false;
	            }
	        }
	      }
	
	      stream.eatSpace();
	
	      if (state.allowMultilineArgument) {
	
	        // STRING
	        if (state.inMultilineString) {
	          if (stream.match('"""')) {
	            state.inMultilineString = false;
	            state.allowMultilineArgument = false;
	          } else {
	            stream.match(/.*/);
	          }
	          return "string";
	        }
	
	        // TABLE
	        if (state.inMultilineTable) {
	          if (stream.match(/\|\s*/)) {
	            return "bracket";
	          } else {
	            stream.match(/[^\|]*/);
	            return state.tableHeaderLine ? "header" : "string";
	          }
	        }
	
	        // DETECT START
	        if (stream.match('"""')) {
	          // String
	          state.inMultilineString = true;
	          return "string";
	        } else if (stream.match("|")) {
	          // Table
	          state.inMultilineTable = true;
	          state.tableHeaderLine = true;
	          return "bracket";
	        }
	
	      }
	
	      // LINE COMMENT
	      if (stream.match(/#.*/)) {
	        return "comment";
	
	      // TAG
	      } else if (!state.inKeywordLine && stream.match(/@\S+/)) {
	        return "tag";
	
	      // FEATURE
	      } else if (!state.inKeywordLine && state.allowFeature && stream.match(/(機能|功能|フィーチャ|기능|โครงหลัก|ความสามารถ|ความต้องการทางธุรกิจ|ಹೆಚ್ಚಳ|గుణము|ਮੁਹਾਂਦਰਾ|ਨਕਸ਼ ਨੁਹਾਰ|ਖਾਸੀਅਤ|रूप लेख|وِیژگی|خاصية|תכונה|Функціонал|Функция|Функционалност|Функционал|Үзенчәлеклелек|Свойство|Особина|Мөмкинлек|Могућност|Λειτουργία|Δυνατότητα|Właściwość|Vlastnosť|Trajto|Tính năng|Savybė|Pretty much|Požiadavka|Požadavek|Potrzeba biznesowa|Özellik|Osobina|Ominaisuus|Omadus|OH HAI|Mogućnost|Mogucnost|Jellemző|Hwæt|Hwaet|Funzionalità|Funktionalitéit|Funktionalität|Funkcja|Funkcionalnost|Funkcionalitāte|Funkcia|Fungsi|Functionaliteit|Funcționalitate|Funcţionalitate|Functionalitate|Funcionalitat|Funcionalidade|Fonctionnalité|Fitur|Fīča|Feature|Eiginleiki|Egenskap|Egenskab|Característica|Caracteristica|Business Need|Aspekt|Arwedd|Ahoy matey!|Ability):/)) {
	        state.allowScenario = true;
	        state.allowBackground = true;
	        state.allowPlaceholders = false;
	        state.allowSteps = false;
	        state.allowMultilineArgument = false;
	        state.inKeywordLine = true;
	        return "keyword";
	
	      // BACKGROUND
	      } else if (!state.inKeywordLine && state.allowBackground && stream.match(/(背景|배경|แนวคิด|ಹಿನ್ನೆಲೆ|నేపథ్యం|ਪਿਛੋਕੜ|पृष्ठभूमि|زمینه|الخلفية|רקע|Тарих|Предыстория|Предистория|Позадина|Передумова|Основа|Контекст|Кереш|Υπόβαθρο|Założenia|Yo\-ho\-ho|Tausta|Taust|Situācija|Rerefons|Pozadina|Pozadie|Pozadí|Osnova|Latar Belakang|Kontext|Konteksts|Kontekstas|Kontekst|Háttér|Hannergrond|Grundlage|Geçmiş|Fundo|Fono|First off|Dis is what went down|Dasar|Contexto|Contexte|Context|Contesto|Cenário de Fundo|Cenario de Fundo|Cefndir|Bối cảnh|Bakgrunnur|Bakgrunn|Bakgrund|Baggrund|Background|B4|Antecedents|Antecedentes|Ær|Aer|Achtergrond):/)) {
	        state.allowPlaceholders = false;
	        state.allowSteps = true;
	        state.allowBackground = false;
	        state.allowMultilineArgument = false;
	        state.inKeywordLine = true;
	        return "keyword";
	
	      // SCENARIO OUTLINE
	      } else if (!state.inKeywordLine && state.allowScenario && stream.match(/(場景大綱|场景大纲|劇本大綱|剧本大纲|テンプレ|シナリオテンプレート|シナリオテンプレ|シナリオアウトライン|시나리오 개요|สรุปเหตุการณ์|โครงสร้างของเหตุการณ์|ವಿವರಣೆ|కథనం|ਪਟਕਥਾ ਰੂਪ ਰੇਖਾ|ਪਟਕਥਾ ਢਾਂਚਾ|परिदृश्य रूपरेखा|سيناريو مخطط|الگوی سناریو|תבנית תרחיש|Сценарийның төзелеше|Сценарий структураси|Структура сценарію|Структура сценария|Структура сценарија|Скица|Рамка на сценарий|Концепт|Περιγραφή Σεναρίου|Wharrimean is|Template Situai|Template Senario|Template Keadaan|Tapausaihio|Szenariogrundriss|Szablon scenariusza|Swa hwær swa|Swa hwaer swa|Struktura scenarija|Structură scenariu|Structura scenariu|Skica|Skenario konsep|Shiver me timbers|Senaryo taslağı|Schema dello scenario|Scenariomall|Scenariomal|Scenario Template|Scenario Outline|Scenario Amlinellol|Scenārijs pēc parauga|Scenarijaus šablonas|Reckon it's like|Raamstsenaarium|Plang vum Szenario|Plan du Scénario|Plan du scénario|Osnova scénáře|Osnova Scenára|Náčrt Scenáru|Náčrt Scénáře|Náčrt Scenára|MISHUN SRSLY|Menggariskan Senario|Lýsing Dæma|Lýsing Atburðarásar|Konturo de la scenaro|Koncept|Khung tình huống|Khung kịch bản|Forgatókönyv vázlat|Esquema do Cenário|Esquema do Cenario|Esquema del escenario|Esquema de l'escenari|Esbozo do escenario|Delineação do Cenário|Delineacao do Cenario|All y'all|Abstrakt Scenario|Abstract Scenario):/)) {
	        state.allowPlaceholders = true;
	        state.allowSteps = true;
	        state.allowMultilineArgument = false;
	        state.inKeywordLine = true;
	        return "keyword";
	
	      // EXAMPLES
	      } else if (state.allowScenario && stream.match(/(例子|例|サンプル|예|ชุดของเหตุการณ์|ชุดของตัวอย่าง|ಉದಾಹರಣೆಗಳು|ఉదాహరణలు|ਉਦਾਹਰਨਾਂ|उदाहरण|نمونه ها|امثلة|דוגמאות|Үрнәкләр|Сценарији|Примеры|Примери|Приклади|Мисоллар|Мисаллар|Σενάρια|Παραδείγματα|You'll wanna|Voorbeelden|Variantai|Tapaukset|Se þe|Se the|Se ðe|Scenarios|Scenariji|Scenarijai|Przykłady|Primjeri|Primeri|Příklady|Príklady|Piemēri|Példák|Pavyzdžiai|Paraugs|Örnekler|Juhtumid|Exemplos|Exemples|Exemple|Exempel|EXAMPLZ|Examples|Esempi|Enghreifftiau|Ekzemploj|Eksempler|Ejemplos|Dữ liệu|Dead men tell no tales|Dæmi|Contoh|Cenários|Cenarios|Beispiller|Beispiele|Atburðarásir):/)) {
	        state.allowPlaceholders = false;
	        state.allowSteps = true;
	        state.allowBackground = false;
	        state.allowMultilineArgument = true;
	        return "keyword";
	
	      // SCENARIO
	      } else if (!state.inKeywordLine && state.allowScenario && stream.match(/(場景|场景|劇本|剧本|シナリオ|시나리오|เหตุการณ์|ಕಥಾಸಾರಾಂಶ|సన్నివేశం|ਪਟਕਥਾ|परिदृश्य|سيناريو|سناریو|תרחיש|Сценарій|Сценарио|Сценарий|Пример|Σενάριο|Tình huống|The thing of it is|Tapaus|Szenario|Swa|Stsenaarium|Skenario|Situai|Senaryo|Senario|Scenaro|Scenariusz|Scenariu|Scénario|Scenario|Scenarijus|Scenārijs|Scenarij|Scenarie|Scénář|Scenár|Primer|MISHUN|Kịch bản|Keadaan|Heave to|Forgatókönyv|Escenario|Escenari|Cenário|Cenario|Awww, look mate|Atburðarás):/)) {
	        state.allowPlaceholders = false;
	        state.allowSteps = true;
	        state.allowBackground = false;
	        state.allowMultilineArgument = false;
	        state.inKeywordLine = true;
	        return "keyword";
	
	      // STEPS
	      } else if (!state.inKeywordLine && state.allowSteps && stream.match(/(那麼|那么|而且|當|当|并且|同時|同时|前提|假设|假設|假定|假如|但是|但し|並且|もし|ならば|ただし|しかし|かつ|하지만|조건|먼저|만일|만약|단|그리고|그러면|และ |เมื่อ |แต่ |ดังนั้น |กำหนดให้ |ಸ್ಥಿತಿಯನ್ನು |ಮತ್ತು |ನೀಡಿದ |ನಂತರ |ಆದರೆ |మరియు |చెప్పబడినది |కాని |ఈ పరిస్థితిలో |అప్పుడు |ਪਰ |ਤਦ |ਜੇਕਰ |ਜਿਵੇਂ ਕਿ |ਜਦੋਂ |ਅਤੇ |यदि |परन्तु |पर |तब |तदा |तथा |जब |चूंकि |किन्तु |कदा |और |अगर |و |هنگامی |متى |لكن |عندما |ثم |بفرض |با فرض |اما |اذاً |آنگاه |כאשר |וגם |בהינתן |אזי |אז |אבל |Якщо |Һәм |Унда |Тоді |Тогда |То |Также |Та |Пусть |Припустимо, що |Припустимо |Онда |Но |Нехай |Нәтиҗәдә |Лекин |Ләкин |Коли |Когда |Когато |Када |Кад |К тому же |І |И |Задато |Задати |Задате |Если |Допустим |Дано |Дадено |Вә |Ва |Бирок |Әмма |Әйтик |Әгәр |Аммо |Али |Але |Агар |А також |А |Τότε |Όταν |Και |Δεδομένου |Αλλά |Þurh |Þegar |Þa þe |Þá |Þa |Zatati |Zakładając |Zadato |Zadate |Zadano |Zadani |Zadan |Za předpokladu |Za predpokladu |Youse know when youse got |Youse know like when |Yna |Yeah nah |Y'know |Y |Wun |Wtedy |When y'all |When |Wenn |WEN |wann |Ve |Và |Und |Un |ugeholl |Too right |Thurh |Thì |Then y'all |Then |Tha the |Tha |Tetapi |Tapi |Tak |Tada |Tad |Stel |Soit |Siis |Și |Şi |Si |Sed |Se |Så |Quando |Quand |Quan |Pryd |Potom |Pokud |Pokiaľ |Però |Pero |Pak |Oraz |Onda |Ond |Oletetaan |Og |Och |O zaman |Niin |Nhưng |När |Når |Mutta |Men |Mas |Maka |Majd |Mając |Mais |Maar |mä |Ma |Lorsque |Lorsqu'|Logo |Let go and haul |Kun |Kuid |Kui |Kiedy |Khi |Ketika |Kemudian |Keď |Když |Kaj |Kai |Kada |Kad |Jeżeli |Jeśli |Ja |It's just unbelievable |Ir |I CAN HAZ |I |Ha |Givun |Givet |Given y'all |Given |Gitt |Gegeven |Gegeben seien |Gegeben sei |Gdy |Gangway! |Fakat |Étant donnés |Etant donnés |Étant données |Etant données |Étant donnée |Etant donnée |Étant donné |Etant donné |Et |És |Entonces |Entón |Então |Entao |En |Eğer ki |Ef |Eeldades |E |Ðurh |Duota |Dun |Donitaĵo |Donat |Donada |Do |Diyelim ki |Diberi |Dengan |Den youse gotta |DEN |De |Dato |Dați fiind |Daţi fiind |Dati fiind |Dati |Date fiind |Date |Data |Dat fiind |Dar |Dann |dann |Dan |Dados |Dado |Dadas |Dada |Ða ðe |Ða |Cuando |Cho |Cando |Când |Cand |Cal |But y'all |But at the end of the day I reckon |BUT |But |Buh |Blimey! |Biết |Bet |Bagi |Aye |awer |Avast! |Atunci |Atesa |Atès |Apabila |Anrhegedig a |Angenommen |And y'all |And |AN |An |an |Amikor |Amennyiben |Ama |Als |Alors |Allora |Ali |Aleshores |Ale |Akkor |Ak |Adott |Ac |Aber |A zároveň |A tiež |A taktiež |A také |A |a |7 |\* )/)) {
	        state.inStep = true;
	        state.allowPlaceholders = true;
	        state.allowMultilineArgument = true;
	        state.inKeywordLine = true;
	        return "keyword";
	
	      // INLINE STRING
	      } else if (stream.match(/"[^"]*"?/)) {
	        return "string";
	
	      // PLACEHOLDER
	      } else if (state.allowPlaceholders && stream.match(/<[^>]*>?/)) {
	        return "variable";
	
	      // Fall through
	      } else {
	        stream.next();
	        stream.eatWhile(/[^@"<#]/);
	        return null;
	      }
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/x-feature", "gherkin");
	
	});


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("go", function(config) {
	  var indentUnit = config.indentUnit;
	
	  var keywords = {
	    "break":true, "case":true, "chan":true, "const":true, "continue":true,
	    "default":true, "defer":true, "else":true, "fallthrough":true, "for":true,
	    "func":true, "go":true, "goto":true, "if":true, "import":true,
	    "interface":true, "map":true, "package":true, "range":true, "return":true,
	    "select":true, "struct":true, "switch":true, "type":true, "var":true,
	    "bool":true, "byte":true, "complex64":true, "complex128":true,
	    "float32":true, "float64":true, "int8":true, "int16":true, "int32":true,
	    "int64":true, "string":true, "uint8":true, "uint16":true, "uint32":true,
	    "uint64":true, "int":true, "uint":true, "uintptr":true, "error": true
	  };
	
	  var atoms = {
	    "true":true, "false":true, "iota":true, "nil":true, "append":true,
	    "cap":true, "close":true, "complex":true, "copy":true, "imag":true,
	    "len":true, "make":true, "new":true, "panic":true, "print":true,
	    "println":true, "real":true, "recover":true
	  };
	
	  var isOperatorChar = /[+\-*&^%:=<>!|\/]/;
	
	  var curPunc;
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    if (ch == '"' || ch == "'" || ch == "`") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    }
	    if (/[\d\.]/.test(ch)) {
	      if (ch == ".") {
	        stream.match(/^[0-9]+([eE][\-+]?[0-9]+)?/);
	      } else if (ch == "0") {
	        stream.match(/^[xX][0-9a-fA-F]+/) || stream.match(/^0[0-7]+/);
	      } else {
	        stream.match(/^[0-9]*\.?[0-9]*([eE][\-+]?[0-9]+)?/);
	      }
	      return "number";
	    }
	    if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
	      curPunc = ch;
	      return null;
	    }
	    if (ch == "/") {
	      if (stream.eat("*")) {
	        state.tokenize = tokenComment;
	        return tokenComment(stream, state);
	      }
	      if (stream.eat("/")) {
	        stream.skipToEnd();
	        return "comment";
	      }
	    }
	    if (isOperatorChar.test(ch)) {
	      stream.eatWhile(isOperatorChar);
	      return "operator";
	    }
	    stream.eatWhile(/[\w\$_\xa1-\uffff]/);
	    var cur = stream.current();
	    if (keywords.propertyIsEnumerable(cur)) {
	      if (cur == "case" || cur == "default") curPunc = "case";
	      return "keyword";
	    }
	    if (atoms.propertyIsEnumerable(cur)) return "atom";
	    return "variable";
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, next, end = false;
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) {end = true; break;}
	        escaped = !escaped && quote != "`" && next == "\\";
	      }
	      if (end || !(escaped || quote == "`"))
	        state.tokenize = tokenBase;
	      return "string";
	    };
	  }
	
	  function tokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while (ch = stream.next()) {
	      if (ch == "/" && maybeEnd) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return "comment";
	  }
	
	  function Context(indented, column, type, align, prev) {
	    this.indented = indented;
	    this.column = column;
	    this.type = type;
	    this.align = align;
	    this.prev = prev;
	  }
	  function pushContext(state, col, type) {
	    return state.context = new Context(state.indented, col, type, null, state.context);
	  }
	  function popContext(state) {
	    if (!state.context.prev) return;
	    var t = state.context.type;
	    if (t == ")" || t == "]" || t == "}")
	      state.indented = state.context.indented;
	    return state.context = state.context.prev;
	  }
	
	  // Interface
	
	  return {
	    startState: function(basecolumn) {
	      return {
	        tokenize: null,
	        context: new Context((basecolumn || 0) - indentUnit, 0, "top", false),
	        indented: 0,
	        startOfLine: true
	      };
	    },
	
	    token: function(stream, state) {
	      var ctx = state.context;
	      if (stream.sol()) {
	        if (ctx.align == null) ctx.align = false;
	        state.indented = stream.indentation();
	        state.startOfLine = true;
	        if (ctx.type == "case") ctx.type = "}";
	      }
	      if (stream.eatSpace()) return null;
	      curPunc = null;
	      var style = (state.tokenize || tokenBase)(stream, state);
	      if (style == "comment") return style;
	      if (ctx.align == null) ctx.align = true;
	
	      if (curPunc == "{") pushContext(state, stream.column(), "}");
	      else if (curPunc == "[") pushContext(state, stream.column(), "]");
	      else if (curPunc == "(") pushContext(state, stream.column(), ")");
	      else if (curPunc == "case") ctx.type = "case";
	      else if (curPunc == "}" && ctx.type == "}") ctx = popContext(state);
	      else if (curPunc == ctx.type) popContext(state);
	      state.startOfLine = false;
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      if (state.tokenize != tokenBase && state.tokenize != null) return 0;
	      var ctx = state.context, firstChar = textAfter && textAfter.charAt(0);
	      if (ctx.type == "case" && /^(?:case|default)\b/.test(textAfter)) {
	        state.context.type = "}";
	        return ctx.indented;
	      }
	      var closing = firstChar == ctx.type;
	      if (ctx.align) return ctx.column + (closing ? 0 : 1);
	      else return ctx.indented + (closing ? 0 : indentUnit);
	    },
	
	    electricChars: "{}):",
	    closeBrackets: "()[]{}''\"\"``",
	    fold: "brace",
	    blockCommentStart: "/*",
	    blockCommentEnd: "*/",
	    lineComment: "//"
	  };
	});
	
	CodeMirror.defineMIME("text/x-go", "go");
	
	});


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("groovy", function(config) {
	  function words(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	  var keywords = words(
	    "abstract as assert boolean break byte case catch char class const continue def default " +
	    "do double else enum extends final finally float for goto if implements import in " +
	    "instanceof int interface long native new package private protected public return " +
	    "short static strictfp super switch synchronized threadsafe throw throws transient " +
	    "try void volatile while");
	  var blockKeywords = words("catch class do else finally for if switch try while enum interface def");
	  var standaloneKeywords = words("return break continue");
	  var atoms = words("null true false this");
	
	  var curPunc;
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    if (ch == '"' || ch == "'") {
	      return startString(ch, stream, state);
	    }
	    if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
	      curPunc = ch;
	      return null;
	    }
	    if (/\d/.test(ch)) {
	      stream.eatWhile(/[\w\.]/);
	      if (stream.eat(/eE/)) { stream.eat(/\+\-/); stream.eatWhile(/\d/); }
	      return "number";
	    }
	    if (ch == "/") {
	      if (stream.eat("*")) {
	        state.tokenize.push(tokenComment);
	        return tokenComment(stream, state);
	      }
	      if (stream.eat("/")) {
	        stream.skipToEnd();
	        return "comment";
	      }
	      if (expectExpression(state.lastToken, false)) {
	        return startString(ch, stream, state);
	      }
	    }
	    if (ch == "-" && stream.eat(">")) {
	      curPunc = "->";
	      return null;
	    }
	    if (/[+\-*&%=<>!?|\/~]/.test(ch)) {
	      stream.eatWhile(/[+\-*&%=<>|~]/);
	      return "operator";
	    }
	    stream.eatWhile(/[\w\$_]/);
	    if (ch == "@") { stream.eatWhile(/[\w\$_\.]/); return "meta"; }
	    if (state.lastToken == ".") return "property";
	    if (stream.eat(":")) { curPunc = "proplabel"; return "property"; }
	    var cur = stream.current();
	    if (atoms.propertyIsEnumerable(cur)) { return "atom"; }
	    if (keywords.propertyIsEnumerable(cur)) {
	      if (blockKeywords.propertyIsEnumerable(cur)) curPunc = "newstatement";
	      else if (standaloneKeywords.propertyIsEnumerable(cur)) curPunc = "standalone";
	      return "keyword";
	    }
	    return "variable";
	  }
	  tokenBase.isBase = true;
	
	  function startString(quote, stream, state) {
	    var tripleQuoted = false;
	    if (quote != "/" && stream.eat(quote)) {
	      if (stream.eat(quote)) tripleQuoted = true;
	      else return "string";
	    }
	    function t(stream, state) {
	      var escaped = false, next, end = !tripleQuoted;
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) {
	          if (!tripleQuoted) { break; }
	          if (stream.match(quote + quote)) { end = true; break; }
	        }
	        if (quote == '"' && next == "$" && !escaped && stream.eat("{")) {
	          state.tokenize.push(tokenBaseUntilBrace());
	          return "string";
	        }
	        escaped = !escaped && next == "\\";
	      }
	      if (end) state.tokenize.pop();
	      return "string";
	    }
	    state.tokenize.push(t);
	    return t(stream, state);
	  }
	
	  function tokenBaseUntilBrace() {
	    var depth = 1;
	    function t(stream, state) {
	      if (stream.peek() == "}") {
	        depth--;
	        if (depth == 0) {
	          state.tokenize.pop();
	          return state.tokenize[state.tokenize.length-1](stream, state);
	        }
	      } else if (stream.peek() == "{") {
	        depth++;
	      }
	      return tokenBase(stream, state);
	    }
	    t.isBase = true;
	    return t;
	  }
	
	  function tokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while (ch = stream.next()) {
	      if (ch == "/" && maybeEnd) {
	        state.tokenize.pop();
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return "comment";
	  }
	
	  function expectExpression(last, newline) {
	    return !last || last == "operator" || last == "->" || /[\.\[\{\(,;:]/.test(last) ||
	      last == "newstatement" || last == "keyword" || last == "proplabel" ||
	      (last == "standalone" && !newline);
	  }
	
	  function Context(indented, column, type, align, prev) {
	    this.indented = indented;
	    this.column = column;
	    this.type = type;
	    this.align = align;
	    this.prev = prev;
	  }
	  function pushContext(state, col, type) {
	    return state.context = new Context(state.indented, col, type, null, state.context);
	  }
	  function popContext(state) {
	    var t = state.context.type;
	    if (t == ")" || t == "]" || t == "}")
	      state.indented = state.context.indented;
	    return state.context = state.context.prev;
	  }
	
	  // Interface
	
	  return {
	    startState: function(basecolumn) {
	      return {
	        tokenize: [tokenBase],
	        context: new Context((basecolumn || 0) - config.indentUnit, 0, "top", false),
	        indented: 0,
	        startOfLine: true,
	        lastToken: null
	      };
	    },
	
	    token: function(stream, state) {
	      var ctx = state.context;
	      if (stream.sol()) {
	        if (ctx.align == null) ctx.align = false;
	        state.indented = stream.indentation();
	        state.startOfLine = true;
	        // Automatic semicolon insertion
	        if (ctx.type == "statement" && !expectExpression(state.lastToken, true)) {
	          popContext(state); ctx = state.context;
	        }
	      }
	      if (stream.eatSpace()) return null;
	      curPunc = null;
	      var style = state.tokenize[state.tokenize.length-1](stream, state);
	      if (style == "comment") return style;
	      if (ctx.align == null) ctx.align = true;
	
	      if ((curPunc == ";" || curPunc == ":") && ctx.type == "statement") popContext(state);
	      // Handle indentation for {x -> \n ... }
	      else if (curPunc == "->" && ctx.type == "statement" && ctx.prev.type == "}") {
	        popContext(state);
	        state.context.align = false;
	      }
	      else if (curPunc == "{") pushContext(state, stream.column(), "}");
	      else if (curPunc == "[") pushContext(state, stream.column(), "]");
	      else if (curPunc == "(") pushContext(state, stream.column(), ")");
	      else if (curPunc == "}") {
	        while (ctx.type == "statement") ctx = popContext(state);
	        if (ctx.type == "}") ctx = popContext(state);
	        while (ctx.type == "statement") ctx = popContext(state);
	      }
	      else if (curPunc == ctx.type) popContext(state);
	      else if (ctx.type == "}" || ctx.type == "top" || (ctx.type == "statement" && curPunc == "newstatement"))
	        pushContext(state, stream.column(), "statement");
	      state.startOfLine = false;
	      state.lastToken = curPunc || style;
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      if (!state.tokenize[state.tokenize.length-1].isBase) return CodeMirror.Pass;
	      var firstChar = textAfter && textAfter.charAt(0), ctx = state.context;
	      if (ctx.type == "statement" && !expectExpression(state.lastToken, true)) ctx = ctx.prev;
	      var closing = firstChar == ctx.type;
	      if (ctx.type == "statement") return ctx.indented + (firstChar == "{" ? 0 : config.indentUnit);
	      else if (ctx.align) return ctx.column + (closing ? 0 : 1);
	      else return ctx.indented + (closing ? 0 : config.indentUnit);
	    },
	
	    electricChars: "{}",
	    closeBrackets: {triples: "'\""},
	    fold: "brace"
	  };
	});
	
	CodeMirror.defineMIME("text/x-groovy", "groovy");
	
	});


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(5), __webpack_require__(46));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../htmlmixed/htmlmixed", "../ruby/ruby"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	  // full haml mode. This handled embedded ruby and html fragments too
	  CodeMirror.defineMode("haml", function(config) {
	    var htmlMode = CodeMirror.getMode(config, {name: "htmlmixed"});
	    var rubyMode = CodeMirror.getMode(config, "ruby");
	
	    function rubyInQuote(endQuote) {
	      return function(stream, state) {
	        var ch = stream.peek();
	        if (ch == endQuote && state.rubyState.tokenize.length == 1) {
	          // step out of ruby context as it seems to complete processing all the braces
	          stream.next();
	          state.tokenize = html;
	          return "closeAttributeTag";
	        } else {
	          return ruby(stream, state);
	        }
	      };
	    }
	
	    function ruby(stream, state) {
	      if (stream.match("-#")) {
	        stream.skipToEnd();
	        return "comment";
	      }
	      return rubyMode.token(stream, state.rubyState);
	    }
	
	    function html(stream, state) {
	      var ch = stream.peek();
	
	      // handle haml declarations. All declarations that cant be handled here
	      // will be passed to html mode
	      if (state.previousToken.style == "comment" ) {
	        if (state.indented > state.previousToken.indented) {
	          stream.skipToEnd();
	          return "commentLine";
	        }
	      }
	
	      if (state.startOfLine) {
	        if (ch == "!" && stream.match("!!")) {
	          stream.skipToEnd();
	          return "tag";
	        } else if (stream.match(/^%[\w:#\.]+=/)) {
	          state.tokenize = ruby;
	          return "hamlTag";
	        } else if (stream.match(/^%[\w:]+/)) {
	          return "hamlTag";
	        } else if (ch == "/" ) {
	          stream.skipToEnd();
	          return "comment";
	        }
	      }
	
	      if (state.startOfLine || state.previousToken.style == "hamlTag") {
	        if ( ch == "#" || ch == ".") {
	          stream.match(/[\w-#\.]*/);
	          return "hamlAttribute";
	        }
	      }
	
	      // donot handle --> as valid ruby, make it HTML close comment instead
	      if (state.startOfLine && !stream.match("-->", false) && (ch == "=" || ch == "-" )) {
	        state.tokenize = ruby;
	        return state.tokenize(stream, state);
	      }
	
	      if (state.previousToken.style == "hamlTag" ||
	          state.previousToken.style == "closeAttributeTag" ||
	          state.previousToken.style == "hamlAttribute") {
	        if (ch == "(") {
	          state.tokenize = rubyInQuote(")");
	          return state.tokenize(stream, state);
	        } else if (ch == "{") {
	          if (!stream.match(/^\{%.*/)) {
	            state.tokenize = rubyInQuote("}");
	            return state.tokenize(stream, state);
	          }
	        }
	      }
	
	      return htmlMode.token(stream, state.htmlState);
	    }
	
	    return {
	      // default to html mode
	      startState: function() {
	        var htmlState = CodeMirror.startState(htmlMode);
	        var rubyState = CodeMirror.startState(rubyMode);
	        return {
	          htmlState: htmlState,
	          rubyState: rubyState,
	          indented: 0,
	          previousToken: { style: null, indented: 0},
	          tokenize: html
	        };
	      },
	
	      copyState: function(state) {
	        return {
	          htmlState : CodeMirror.copyState(htmlMode, state.htmlState),
	          rubyState: CodeMirror.copyState(rubyMode, state.rubyState),
	          indented: state.indented,
	          previousToken: state.previousToken,
	          tokenize: state.tokenize
	        };
	      },
	
	      token: function(stream, state) {
	        if (stream.sol()) {
	          state.indented = stream.indentation();
	          state.startOfLine = true;
	        }
	        if (stream.eatSpace()) return null;
	        var style = state.tokenize(stream, state);
	        state.startOfLine = false;
	        // dont record comment line as we only want to measure comment line with
	        // the opening comment block
	        if (style && style != "commentLine") {
	          state.previousToken = { style: style, indented: state.indented };
	        }
	        // if current state is ruby and the previous token is not `,` reset the
	        // tokenize to html
	        if (stream.eol() && state.tokenize == ruby) {
	          stream.backUp(1);
	          var ch = stream.peek();
	          stream.next();
	          if (ch && ch != ",") {
	            state.tokenize = html;
	          }
	        }
	        // reprocess some of the specific style tag when finish setting previousToken
	        if (style == "hamlTag") {
	          style = "tag";
	        } else if (style == "commentLine") {
	          style = "comment";
	        } else if (style == "hamlAttribute") {
	          style = "attribute";
	        } else if (style == "closeAttributeTag") {
	          style = null;
	        }
	        return style;
	      }
	    };
	  }, "htmlmixed", "ruby");
	
	  CodeMirror.defineMIME("text/x-haml", "haml");
	});


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function (mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(80))
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../haskell/haskell"], mod)
	  else // Plain browser env
	    mod(CodeMirror)
	})(function (CodeMirror) {
	  "use strict"
	
	  CodeMirror.defineMode("haskell-literate", function (config, parserConfig) {
	    var baseMode = CodeMirror.getMode(config, (parserConfig && parserConfig.base) || "haskell")
	
	    return {
	      startState: function () {
	        return {
	          inCode: false,
	          baseState: CodeMirror.startState(baseMode)
	        }
	      },
	      token: function (stream, state) {
	        if (stream.sol()) {
	          if (state.inCode = stream.eat(">"))
	            return "meta"
	        }
	        if (state.inCode) {
	          return baseMode.token(stream, state.baseState)
	        } else {
	          stream.skipToEnd()
	          return "comment"
	        }
	      },
	      innerMode: function (state) {
	        return state.inCode ? {state: state.baseState, mode: baseMode} : null
	      }
	    }
	  }, "haskell")
	
	  CodeMirror.defineMIME("text/x-literate-haskell", "haskell-literate")
	});


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("haxe", function(config, parserConfig) {
	  var indentUnit = config.indentUnit;
	
	  // Tokenizer
	
	  function kw(type) {return {type: type, style: "keyword"};}
	  var A = kw("keyword a"), B = kw("keyword b"), C = kw("keyword c");
	  var operator = kw("operator"), atom = {type: "atom", style: "atom"}, attribute = {type:"attribute", style: "attribute"};
	  var type = kw("typedef");
	  var keywords = {
	    "if": A, "while": A, "else": B, "do": B, "try": B,
	    "return": C, "break": C, "continue": C, "new": C, "throw": C,
	    "var": kw("var"), "inline":attribute, "static": attribute, "using":kw("import"),
	    "public": attribute, "private": attribute, "cast": kw("cast"), "import": kw("import"), "macro": kw("macro"),
	    "function": kw("function"), "catch": kw("catch"), "untyped": kw("untyped"), "callback": kw("cb"),
	    "for": kw("for"), "switch": kw("switch"), "case": kw("case"), "default": kw("default"),
	    "in": operator, "never": kw("property_access"), "trace":kw("trace"),
	    "class": type, "abstract":type, "enum":type, "interface":type, "typedef":type, "extends":type, "implements":type, "dynamic":type,
	    "true": atom, "false": atom, "null": atom
	  };
	
	  var isOperatorChar = /[+\-*&%=<>!?|]/;
	
	  function chain(stream, state, f) {
	    state.tokenize = f;
	    return f(stream, state);
	  }
	
	  function toUnescaped(stream, end) {
	    var escaped = false, next;
	    while ((next = stream.next()) != null) {
	      if (next == end && !escaped)
	        return true;
	      escaped = !escaped && next == "\\";
	    }
	  }
	
	  // Used as scratch variables to communicate multiple values without
	  // consing up tons of objects.
	  var type, content;
	  function ret(tp, style, cont) {
	    type = tp; content = cont;
	    return style;
	  }
	
	  function haxeTokenBase(stream, state) {
	    var ch = stream.next();
	    if (ch == '"' || ch == "'") {
	      return chain(stream, state, haxeTokenString(ch));
	    } else if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
	      return ret(ch);
	    } else if (ch == "0" && stream.eat(/x/i)) {
	      stream.eatWhile(/[\da-f]/i);
	      return ret("number", "number");
	    } else if (/\d/.test(ch) || ch == "-" && stream.eat(/\d/)) {
	      stream.match(/^\d*(?:\.\d*(?!\.))?(?:[eE][+\-]?\d+)?/);
	      return ret("number", "number");
	    } else if (state.reAllowed && (ch == "~" && stream.eat(/\//))) {
	      toUnescaped(stream, "/");
	      stream.eatWhile(/[gimsu]/);
	      return ret("regexp", "string-2");
	    } else if (ch == "/") {
	      if (stream.eat("*")) {
	        return chain(stream, state, haxeTokenComment);
	      } else if (stream.eat("/")) {
	        stream.skipToEnd();
	        return ret("comment", "comment");
	      } else {
	        stream.eatWhile(isOperatorChar);
	        return ret("operator", null, stream.current());
	      }
	    } else if (ch == "#") {
	        stream.skipToEnd();
	        return ret("conditional", "meta");
	    } else if (ch == "@") {
	      stream.eat(/:/);
	      stream.eatWhile(/[\w_]/);
	      return ret ("metadata", "meta");
	    } else if (isOperatorChar.test(ch)) {
	      stream.eatWhile(isOperatorChar);
	      return ret("operator", null, stream.current());
	    } else {
	      var word;
	      if(/[A-Z]/.test(ch)) {
	        stream.eatWhile(/[\w_<>]/);
	        word = stream.current();
	        return ret("type", "variable-3", word);
	      } else {
	        stream.eatWhile(/[\w_]/);
	        var word = stream.current(), known = keywords.propertyIsEnumerable(word) && keywords[word];
	        return (known && state.kwAllowed) ? ret(known.type, known.style, word) :
	                       ret("variable", "variable", word);
	      }
	    }
	  }
	
	  function haxeTokenString(quote) {
	    return function(stream, state) {
	      if (toUnescaped(stream, quote))
	        state.tokenize = haxeTokenBase;
	      return ret("string", "string");
	    };
	  }
	
	  function haxeTokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while (ch = stream.next()) {
	      if (ch == "/" && maybeEnd) {
	        state.tokenize = haxeTokenBase;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return ret("comment", "comment");
	  }
	
	  // Parser
	
	  var atomicTypes = {"atom": true, "number": true, "variable": true, "string": true, "regexp": true};
	
	  function HaxeLexical(indented, column, type, align, prev, info) {
	    this.indented = indented;
	    this.column = column;
	    this.type = type;
	    this.prev = prev;
	    this.info = info;
	    if (align != null) this.align = align;
	  }
	
	  function inScope(state, varname) {
	    for (var v = state.localVars; v; v = v.next)
	      if (v.name == varname) return true;
	  }
	
	  function parseHaxe(state, style, type, content, stream) {
	    var cc = state.cc;
	    // Communicate our context to the combinators.
	    // (Less wasteful than consing up a hundred closures on every call.)
	    cx.state = state; cx.stream = stream; cx.marked = null, cx.cc = cc;
	
	    if (!state.lexical.hasOwnProperty("align"))
	      state.lexical.align = true;
	
	    while(true) {
	      var combinator = cc.length ? cc.pop() : statement;
	      if (combinator(type, content)) {
	        while(cc.length && cc[cc.length - 1].lex)
	          cc.pop()();
	        if (cx.marked) return cx.marked;
	        if (type == "variable" && inScope(state, content)) return "variable-2";
	        if (type == "variable" && imported(state, content)) return "variable-3";
	        return style;
	      }
	    }
	  }
	
	  function imported(state, typename) {
	    if (/[a-z]/.test(typename.charAt(0)))
	      return false;
	    var len = state.importedtypes.length;
	    for (var i = 0; i<len; i++)
	      if(state.importedtypes[i]==typename) return true;
	  }
	
	  function registerimport(importname) {
	    var state = cx.state;
	    for (var t = state.importedtypes; t; t = t.next)
	      if(t.name == importname) return;
	    state.importedtypes = { name: importname, next: state.importedtypes };
	  }
	  // Combinator utils
	
	  var cx = {state: null, column: null, marked: null, cc: null};
	  function pass() {
	    for (var i = arguments.length - 1; i >= 0; i--) cx.cc.push(arguments[i]);
	  }
	  function cont() {
	    pass.apply(null, arguments);
	    return true;
	  }
	  function inList(name, list) {
	    for (var v = list; v; v = v.next)
	      if (v.name == name) return true;
	    return false;
	  }
	  function register(varname) {
	    var state = cx.state;
	    if (state.context) {
	      cx.marked = "def";
	      if (inList(varname, state.localVars)) return;
	      state.localVars = {name: varname, next: state.localVars};
	    } else if (state.globalVars) {
	      if (inList(varname, state.globalVars)) return;
	      state.globalVars = {name: varname, next: state.globalVars};
	    }
	  }
	
	  // Combinators
	
	  var defaultVars = {name: "this", next: null};
	  function pushcontext() {
	    if (!cx.state.context) cx.state.localVars = defaultVars;
	    cx.state.context = {prev: cx.state.context, vars: cx.state.localVars};
	  }
	  function popcontext() {
	    cx.state.localVars = cx.state.context.vars;
	    cx.state.context = cx.state.context.prev;
	  }
	  popcontext.lex = true;
	  function pushlex(type, info) {
	    var result = function() {
	      var state = cx.state;
	      state.lexical = new HaxeLexical(state.indented, cx.stream.column(), type, null, state.lexical, info);
	    };
	    result.lex = true;
	    return result;
	  }
	  function poplex() {
	    var state = cx.state;
	    if (state.lexical.prev) {
	      if (state.lexical.type == ")")
	        state.indented = state.lexical.indented;
	      state.lexical = state.lexical.prev;
	    }
	  }
	  poplex.lex = true;
	
	  function expect(wanted) {
	    function f(type) {
	      if (type == wanted) return cont();
	      else if (wanted == ";") return pass();
	      else return cont(f);
	    }
	    return f;
	  }
	
	  function statement(type) {
	    if (type == "@") return cont(metadef);
	    if (type == "var") return cont(pushlex("vardef"), vardef1, expect(";"), poplex);
	    if (type == "keyword a") return cont(pushlex("form"), expression, statement, poplex);
	    if (type == "keyword b") return cont(pushlex("form"), statement, poplex);
	    if (type == "{") return cont(pushlex("}"), pushcontext, block, poplex, popcontext);
	    if (type == ";") return cont();
	    if (type == "attribute") return cont(maybeattribute);
	    if (type == "function") return cont(functiondef);
	    if (type == "for") return cont(pushlex("form"), expect("("), pushlex(")"), forspec1, expect(")"),
	                                   poplex, statement, poplex);
	    if (type == "variable") return cont(pushlex("stat"), maybelabel);
	    if (type == "switch") return cont(pushlex("form"), expression, pushlex("}", "switch"), expect("{"),
	                                      block, poplex, poplex);
	    if (type == "case") return cont(expression, expect(":"));
	    if (type == "default") return cont(expect(":"));
	    if (type == "catch") return cont(pushlex("form"), pushcontext, expect("("), funarg, expect(")"),
	                                     statement, poplex, popcontext);
	    if (type == "import") return cont(importdef, expect(";"));
	    if (type == "typedef") return cont(typedef);
	    return pass(pushlex("stat"), expression, expect(";"), poplex);
	  }
	  function expression(type) {
	    if (atomicTypes.hasOwnProperty(type)) return cont(maybeoperator);
	    if (type == "type" ) return cont(maybeoperator);
	    if (type == "function") return cont(functiondef);
	    if (type == "keyword c") return cont(maybeexpression);
	    if (type == "(") return cont(pushlex(")"), maybeexpression, expect(")"), poplex, maybeoperator);
	    if (type == "operator") return cont(expression);
	    if (type == "[") return cont(pushlex("]"), commasep(maybeexpression, "]"), poplex, maybeoperator);
	    if (type == "{") return cont(pushlex("}"), commasep(objprop, "}"), poplex, maybeoperator);
	    return cont();
	  }
	  function maybeexpression(type) {
	    if (type.match(/[;\}\)\],]/)) return pass();
	    return pass(expression);
	  }
	
	  function maybeoperator(type, value) {
	    if (type == "operator" && /\+\+|--/.test(value)) return cont(maybeoperator);
	    if (type == "operator" || type == ":") return cont(expression);
	    if (type == ";") return;
	    if (type == "(") return cont(pushlex(")"), commasep(expression, ")"), poplex, maybeoperator);
	    if (type == ".") return cont(property, maybeoperator);
	    if (type == "[") return cont(pushlex("]"), expression, expect("]"), poplex, maybeoperator);
	  }
	
	  function maybeattribute(type) {
	    if (type == "attribute") return cont(maybeattribute);
	    if (type == "function") return cont(functiondef);
	    if (type == "var") return cont(vardef1);
	  }
	
	  function metadef(type) {
	    if(type == ":") return cont(metadef);
	    if(type == "variable") return cont(metadef);
	    if(type == "(") return cont(pushlex(")"), commasep(metaargs, ")"), poplex, statement);
	  }
	  function metaargs(type) {
	    if(type == "variable") return cont();
	  }
	
	  function importdef (type, value) {
	    if(type == "variable" && /[A-Z]/.test(value.charAt(0))) { registerimport(value); return cont(); }
	    else if(type == "variable" || type == "property" || type == "." || value == "*") return cont(importdef);
	  }
	
	  function typedef (type, value)
	  {
	    if(type == "variable" && /[A-Z]/.test(value.charAt(0))) { registerimport(value); return cont(); }
	    else if (type == "type" && /[A-Z]/.test(value.charAt(0))) { return cont(); }
	  }
	
	  function maybelabel(type) {
	    if (type == ":") return cont(poplex, statement);
	    return pass(maybeoperator, expect(";"), poplex);
	  }
	  function property(type) {
	    if (type == "variable") {cx.marked = "property"; return cont();}
	  }
	  function objprop(type) {
	    if (type == "variable") cx.marked = "property";
	    if (atomicTypes.hasOwnProperty(type)) return cont(expect(":"), expression);
	  }
	  function commasep(what, end) {
	    function proceed(type) {
	      if (type == ",") return cont(what, proceed);
	      if (type == end) return cont();
	      return cont(expect(end));
	    }
	    return function(type) {
	      if (type == end) return cont();
	      else return pass(what, proceed);
	    };
	  }
	  function block(type) {
	    if (type == "}") return cont();
	    return pass(statement, block);
	  }
	  function vardef1(type, value) {
	    if (type == "variable"){register(value); return cont(typeuse, vardef2);}
	    return cont();
	  }
	  function vardef2(type, value) {
	    if (value == "=") return cont(expression, vardef2);
	    if (type == ",") return cont(vardef1);
	  }
	  function forspec1(type, value) {
	    if (type == "variable") {
	      register(value);
	      return cont(forin, expression)
	    } else {
	      return pass()
	    }
	  }
	  function forin(_type, value) {
	    if (value == "in") return cont();
	  }
	  function functiondef(type, value) {
	    //function names starting with upper-case letters are recognised as types, so cludging them together here.
	    if (type == "variable" || type == "type") {register(value); return cont(functiondef);}
	    if (value == "new") return cont(functiondef);
	    if (type == "(") return cont(pushlex(")"), pushcontext, commasep(funarg, ")"), poplex, typeuse, statement, popcontext);
	  }
	  function typeuse(type) {
	    if(type == ":") return cont(typestring);
	  }
	  function typestring(type) {
	    if(type == "type") return cont();
	    if(type == "variable") return cont();
	    if(type == "{") return cont(pushlex("}"), commasep(typeprop, "}"), poplex);
	  }
	  function typeprop(type) {
	    if(type == "variable") return cont(typeuse);
	  }
	  function funarg(type, value) {
	    if (type == "variable") {register(value); return cont(typeuse);}
	  }
	
	  // Interface
	  return {
	    startState: function(basecolumn) {
	      var defaulttypes = ["Int", "Float", "String", "Void", "Std", "Bool", "Dynamic", "Array"];
	      var state = {
	        tokenize: haxeTokenBase,
	        reAllowed: true,
	        kwAllowed: true,
	        cc: [],
	        lexical: new HaxeLexical((basecolumn || 0) - indentUnit, 0, "block", false),
	        localVars: parserConfig.localVars,
	        importedtypes: defaulttypes,
	        context: parserConfig.localVars && {vars: parserConfig.localVars},
	        indented: 0
	      };
	      if (parserConfig.globalVars && typeof parserConfig.globalVars == "object")
	        state.globalVars = parserConfig.globalVars;
	      return state;
	    },
	
	    token: function(stream, state) {
	      if (stream.sol()) {
	        if (!state.lexical.hasOwnProperty("align"))
	          state.lexical.align = false;
	        state.indented = stream.indentation();
	      }
	      if (stream.eatSpace()) return null;
	      var style = state.tokenize(stream, state);
	      if (type == "comment") return style;
	      state.reAllowed = !!(type == "operator" || type == "keyword c" || type.match(/^[\[{}\(,;:]$/));
	      state.kwAllowed = type != '.';
	      return parseHaxe(state, style, type, content, stream);
	    },
	
	    indent: function(state, textAfter) {
	      if (state.tokenize != haxeTokenBase) return 0;
	      var firstChar = textAfter && textAfter.charAt(0), lexical = state.lexical;
	      if (lexical.type == "stat" && firstChar == "}") lexical = lexical.prev;
	      var type = lexical.type, closing = firstChar == type;
	      if (type == "vardef") return lexical.indented + 4;
	      else if (type == "form" && firstChar == "{") return lexical.indented;
	      else if (type == "stat" || type == "form") return lexical.indented + indentUnit;
	      else if (lexical.info == "switch" && !closing)
	        return lexical.indented + (/^(?:case|default)\b/.test(textAfter) ? indentUnit : 2 * indentUnit);
	      else if (lexical.align) return lexical.column + (closing ? 0 : 1);
	      else return lexical.indented + (closing ? 0 : indentUnit);
	    },
	
	    electricChars: "{}",
	    blockCommentStart: "/*",
	    blockCommentEnd: "*/",
	    lineComment: "//"
	  };
	});
	
	CodeMirror.defineMIME("text/x-haxe", "haxe");
	
	CodeMirror.defineMode("hxml", function () {
	
	  return {
	    startState: function () {
	      return {
	        define: false,
	        inString: false
	      };
	    },
	    token: function (stream, state) {
	      var ch = stream.peek();
	      var sol = stream.sol();
	
	      ///* comments */
	      if (ch == "#") {
	        stream.skipToEnd();
	        return "comment";
	      }
	      if (sol && ch == "-") {
	        var style = "variable-2";
	
	        stream.eat(/-/);
	
	        if (stream.peek() == "-") {
	          stream.eat(/-/);
	          style = "keyword a";
	        }
	
	        if (stream.peek() == "D") {
	          stream.eat(/[D]/);
	          style = "keyword c";
	          state.define = true;
	        }
	
	        stream.eatWhile(/[A-Z]/i);
	        return style;
	      }
	
	      var ch = stream.peek();
	
	      if (state.inString == false && ch == "'") {
	        state.inString = true;
	        ch = stream.next();
	      }
	
	      if (state.inString == true) {
	        if (stream.skipTo("'")) {
	
	        } else {
	          stream.skipToEnd();
	        }
	
	        if (stream.peek() == "'") {
	          stream.next();
	          state.inString = false;
	        }
	
	        return "string";
	      }
	
	      stream.next();
	      return null;
	    },
	    lineComment: "#"
	  };
	});
	
	CodeMirror.defineMIME("text/x-hxml", "hxml");
	
	});


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(5),
	        __webpack_require__(45));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../htmlmixed/htmlmixed",
	            "../../addon/mode/multiplex"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("htmlembedded", function(config, parserConfig) {
	    return CodeMirror.multiplexingMode(CodeMirror.getMode(config, "htmlmixed"), {
	      open: parserConfig.open || parserConfig.scriptStartRegex || "<%",
	      close: parserConfig.close || parserConfig.scriptEndRegex || "%>",
	      mode: CodeMirror.getMode(config, parserConfig.scriptingModeSpec)
	    });
	  }, "htmlmixed");
	
	  CodeMirror.defineMIME("application/x-ejs", {name: "htmlembedded", scriptingModeSpec:"javascript"});
	  CodeMirror.defineMIME("application/x-aspx", {name: "htmlembedded", scriptingModeSpec:"text/x-csharp"});
	  CodeMirror.defineMIME("application/x-jsp", {name: "htmlembedded", scriptingModeSpec:"text/x-java"});
	  CodeMirror.defineMIME("application/x-erb", {name: "htmlembedded", scriptingModeSpec:"ruby"});
	});


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("http", function() {
	  function failFirstLine(stream, state) {
	    stream.skipToEnd();
	    state.cur = header;
	    return "error";
	  }
	
	  function start(stream, state) {
	    if (stream.match(/^HTTP\/\d\.\d/)) {
	      state.cur = responseStatusCode;
	      return "keyword";
	    } else if (stream.match(/^[A-Z]+/) && /[ \t]/.test(stream.peek())) {
	      state.cur = requestPath;
	      return "keyword";
	    } else {
	      return failFirstLine(stream, state);
	    }
	  }
	
	  function responseStatusCode(stream, state) {
	    var code = stream.match(/^\d+/);
	    if (!code) return failFirstLine(stream, state);
	
	    state.cur = responseStatusText;
	    var status = Number(code[0]);
	    if (status >= 100 && status < 200) {
	      return "positive informational";
	    } else if (status >= 200 && status < 300) {
	      return "positive success";
	    } else if (status >= 300 && status < 400) {
	      return "positive redirect";
	    } else if (status >= 400 && status < 500) {
	      return "negative client-error";
	    } else if (status >= 500 && status < 600) {
	      return "negative server-error";
	    } else {
	      return "error";
	    }
	  }
	
	  function responseStatusText(stream, state) {
	    stream.skipToEnd();
	    state.cur = header;
	    return null;
	  }
	
	  function requestPath(stream, state) {
	    stream.eatWhile(/\S/);
	    state.cur = requestProtocol;
	    return "string-2";
	  }
	
	  function requestProtocol(stream, state) {
	    if (stream.match(/^HTTP\/\d\.\d$/)) {
	      state.cur = header;
	      return "keyword";
	    } else {
	      return failFirstLine(stream, state);
	    }
	  }
	
	  function header(stream) {
	    if (stream.sol() && !stream.eat(/[ \t]/)) {
	      if (stream.match(/^.*?:/)) {
	        return "atom";
	      } else {
	        stream.skipToEnd();
	        return "error";
	      }
	    } else {
	      stream.skipToEnd();
	      return "string";
	    }
	  }
	
	  function body(stream) {
	    stream.skipToEnd();
	    return null;
	  }
	
	  return {
	    token: function(stream, state) {
	      var cur = state.cur;
	      if (cur != header && cur != body && stream.eatSpace()) return null;
	      return cur(stream, state);
	    },
	
	    blankLine: function(state) {
	      state.cur = body;
	    },
	
	    startState: function() {
	      return {cur: start};
	    }
	  };
	});
	
	CodeMirror.defineMIME("message/http", "http");
	
	});


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  function wordRegexp(words) {
	    return new RegExp('^((' + words.join(')|(') + '))\\b', 'i');
	  };
	
	  var builtinArray = [
	    'a_correlate', 'abs', 'acos', 'adapt_hist_equal', 'alog',
	    'alog2', 'alog10', 'amoeba', 'annotate', 'app_user_dir',
	    'app_user_dir_query', 'arg_present', 'array_equal', 'array_indices',
	    'arrow', 'ascii_template', 'asin', 'assoc', 'atan',
	    'axis', 'axis', 'bandpass_filter', 'bandreject_filter', 'barplot',
	    'bar_plot', 'beseli', 'beselj', 'beselk', 'besely',
	    'beta', 'biginteger', 'bilinear', 'bin_date', 'binary_template',
	    'bindgen', 'binomial', 'bit_ffs', 'bit_population', 'blas_axpy',
	    'blk_con', 'boolarr', 'boolean', 'boxplot', 'box_cursor',
	    'breakpoint', 'broyden', 'bubbleplot', 'butterworth', 'bytarr',
	    'byte', 'byteorder', 'bytscl', 'c_correlate', 'calendar',
	    'caldat', 'call_external', 'call_function', 'call_method',
	    'call_procedure', 'canny', 'catch', 'cd', 'cdf', 'ceil',
	    'chebyshev', 'check_math', 'chisqr_cvf', 'chisqr_pdf', 'choldc',
	    'cholsol', 'cindgen', 'cir_3pnt', 'clipboard', 'close',
	    'clust_wts', 'cluster', 'cluster_tree', 'cmyk_convert', 'code_coverage',
	    'color_convert', 'color_exchange', 'color_quan', 'color_range_map',
	    'colorbar', 'colorize_sample', 'colormap_applicable',
	    'colormap_gradient', 'colormap_rotation', 'colortable',
	    'comfit', 'command_line_args', 'common', 'compile_opt', 'complex',
	    'complexarr', 'complexround', 'compute_mesh_normals', 'cond', 'congrid',
	    'conj', 'constrained_min', 'contour', 'contour', 'convert_coord',
	    'convol', 'convol_fft', 'coord2to3', 'copy_lun', 'correlate',
	    'cos', 'cosh', 'cpu', 'cramer', 'createboxplotdata',
	    'create_cursor', 'create_struct', 'create_view', 'crossp', 'crvlength',
	    'ct_luminance', 'cti_test', 'cursor', 'curvefit', 'cv_coord',
	    'cvttobm', 'cw_animate', 'cw_animate_getp', 'cw_animate_load',
	    'cw_animate_run', 'cw_arcball', 'cw_bgroup', 'cw_clr_index',
	    'cw_colorsel', 'cw_defroi', 'cw_field', 'cw_filesel', 'cw_form',
	    'cw_fslider', 'cw_light_editor', 'cw_light_editor_get',
	    'cw_light_editor_set', 'cw_orient', 'cw_palette_editor',
	    'cw_palette_editor_get', 'cw_palette_editor_set', 'cw_pdmenu',
	    'cw_rgbslider', 'cw_tmpl', 'cw_zoom', 'db_exists',
	    'dblarr', 'dcindgen', 'dcomplex', 'dcomplexarr', 'define_key',
	    'define_msgblk', 'define_msgblk_from_file', 'defroi', 'defsysv',
	    'delvar', 'dendro_plot', 'dendrogram', 'deriv', 'derivsig',
	    'determ', 'device', 'dfpmin', 'diag_matrix', 'dialog_dbconnect',
	    'dialog_message', 'dialog_pickfile', 'dialog_printersetup',
	    'dialog_printjob', 'dialog_read_image',
	    'dialog_write_image', 'dictionary', 'digital_filter', 'dilate', 'dindgen',
	    'dissolve', 'dist', 'distance_measure', 'dlm_load', 'dlm_register',
	    'doc_library', 'double', 'draw_roi', 'edge_dog', 'efont',
	    'eigenql', 'eigenvec', 'ellipse', 'elmhes', 'emboss',
	    'empty', 'enable_sysrtn', 'eof', 'eos', 'erase',
	    'erf', 'erfc', 'erfcx', 'erode', 'errorplot',
	    'errplot', 'estimator_filter', 'execute', 'exit', 'exp',
	    'expand', 'expand_path', 'expint', 'extrac', 'extract_slice',
	    'f_cvf', 'f_pdf', 'factorial', 'fft', 'file_basename',
	    'file_chmod', 'file_copy', 'file_delete', 'file_dirname',
	    'file_expand_path', 'file_gunzip', 'file_gzip', 'file_info',
	    'file_lines', 'file_link', 'file_mkdir', 'file_move',
	    'file_poll_input', 'file_readlink', 'file_same',
	    'file_search', 'file_tar', 'file_test', 'file_untar', 'file_unzip',
	    'file_which', 'file_zip', 'filepath', 'findgen', 'finite',
	    'fix', 'flick', 'float', 'floor', 'flow3',
	    'fltarr', 'flush', 'format_axis_values', 'forward_function', 'free_lun',
	    'fstat', 'fulstr', 'funct', 'function', 'fv_test',
	    'fx_root', 'fz_roots', 'gamma', 'gamma_ct', 'gauss_cvf',
	    'gauss_pdf', 'gauss_smooth', 'gauss2dfit', 'gaussfit',
	    'gaussian_function', 'gaussint', 'get_drive_list', 'get_dxf_objects',
	    'get_kbrd', 'get_login_info',
	    'get_lun', 'get_screen_size', 'getenv', 'getwindows', 'greg2jul',
	    'grib', 'grid_input', 'grid_tps', 'grid3', 'griddata',
	    'gs_iter', 'h_eq_ct', 'h_eq_int', 'hanning', 'hash',
	    'hdf', 'hdf5', 'heap_free', 'heap_gc', 'heap_nosave',
	    'heap_refcount', 'heap_save', 'help', 'hilbert', 'hist_2d',
	    'hist_equal', 'histogram', 'hls', 'hough', 'hqr',
	    'hsv', 'i18n_multibytetoutf8',
	    'i18n_multibytetowidechar', 'i18n_utf8tomultibyte',
	    'i18n_widechartomultibyte',
	    'ibeta', 'icontour', 'iconvertcoord', 'idelete', 'identity',
	    'idl_base64', 'idl_container', 'idl_validname',
	    'idlexbr_assistant', 'idlitsys_createtool',
	    'idlunit', 'iellipse', 'igamma', 'igetcurrent', 'igetdata',
	    'igetid', 'igetproperty', 'iimage', 'image', 'image_cont',
	    'image_statistics', 'image_threshold', 'imaginary', 'imap', 'indgen',
	    'int_2d', 'int_3d', 'int_tabulated', 'intarr', 'interpol',
	    'interpolate', 'interval_volume', 'invert', 'ioctl', 'iopen',
	    'ir_filter', 'iplot', 'ipolygon', 'ipolyline', 'iputdata',
	    'iregister', 'ireset', 'iresolve', 'irotate', 'isa',
	    'isave', 'iscale', 'isetcurrent', 'isetproperty', 'ishft',
	    'isocontour', 'isosurface', 'isurface', 'itext', 'itranslate',
	    'ivector', 'ivolume', 'izoom', 'journal', 'json_parse',
	    'json_serialize', 'jul2greg', 'julday', 'keyword_set', 'krig2d',
	    'kurtosis', 'kw_test', 'l64indgen', 'la_choldc', 'la_cholmprove',
	    'la_cholsol', 'la_determ', 'la_eigenproblem', 'la_eigenql', 'la_eigenvec',
	    'la_elmhes', 'la_gm_linear_model', 'la_hqr', 'la_invert',
	    'la_least_square_equality', 'la_least_squares', 'la_linear_equation',
	    'la_ludc', 'la_lumprove', 'la_lusol',
	    'la_svd', 'la_tridc', 'la_trimprove', 'la_triql', 'la_trired',
	    'la_trisol', 'label_date', 'label_region', 'ladfit', 'laguerre',
	    'lambda', 'lambdap', 'lambertw', 'laplacian', 'least_squares_filter',
	    'leefilt', 'legend', 'legendre', 'linbcg', 'lindgen',
	    'linfit', 'linkimage', 'list', 'll_arc_distance', 'lmfit',
	    'lmgr', 'lngamma', 'lnp_test', 'loadct', 'locale_get',
	    'logical_and', 'logical_or', 'logical_true', 'lon64arr', 'lonarr',
	    'long', 'long64', 'lsode', 'lu_complex', 'ludc',
	    'lumprove', 'lusol', 'm_correlate', 'machar', 'make_array',
	    'make_dll', 'make_rt', 'map', 'mapcontinents', 'mapgrid',
	    'map_2points', 'map_continents', 'map_grid', 'map_image', 'map_patch',
	    'map_proj_forward', 'map_proj_image', 'map_proj_info',
	    'map_proj_init', 'map_proj_inverse',
	    'map_set', 'matrix_multiply', 'matrix_power', 'max', 'md_test',
	    'mean', 'meanabsdev', 'mean_filter', 'median', 'memory',
	    'mesh_clip', 'mesh_decimate', 'mesh_issolid',
	    'mesh_merge', 'mesh_numtriangles',
	    'mesh_obj', 'mesh_smooth', 'mesh_surfacearea',
	    'mesh_validate', 'mesh_volume',
	    'message', 'min', 'min_curve_surf', 'mk_html_help', 'modifyct',
	    'moment', 'morph_close', 'morph_distance',
	    'morph_gradient', 'morph_hitormiss',
	    'morph_open', 'morph_thin', 'morph_tophat', 'multi', 'n_elements',
	    'n_params', 'n_tags', 'ncdf', 'newton', 'noise_hurl',
	    'noise_pick', 'noise_scatter', 'noise_slur', 'norm', 'obj_class',
	    'obj_destroy', 'obj_hasmethod', 'obj_isa', 'obj_new', 'obj_valid',
	    'objarr', 'on_error', 'on_ioerror', 'online_help', 'openr',
	    'openu', 'openw', 'oplot', 'oploterr', 'orderedhash',
	    'p_correlate', 'parse_url', 'particle_trace', 'path_cache', 'path_sep',
	    'pcomp', 'plot', 'plot3d', 'plot', 'plot_3dbox',
	    'plot_field', 'ploterr', 'plots', 'polar_contour', 'polar_surface',
	    'polyfill', 'polyshade', 'pnt_line', 'point_lun', 'polarplot',
	    'poly', 'poly_2d', 'poly_area', 'poly_fit', 'polyfillv',
	    'polygon', 'polyline', 'polywarp', 'popd', 'powell',
	    'pref_commit', 'pref_get', 'pref_set', 'prewitt', 'primes',
	    'print', 'printf', 'printd', 'pro', 'product',
	    'profile', 'profiler', 'profiles', 'project_vol', 'ps_show_fonts',
	    'psafm', 'pseudo', 'ptr_free', 'ptr_new', 'ptr_valid',
	    'ptrarr', 'pushd', 'qgrid3', 'qhull', 'qromb',
	    'qromo', 'qsimp', 'query_*', 'query_ascii', 'query_bmp',
	    'query_csv', 'query_dicom', 'query_gif', 'query_image', 'query_jpeg',
	    'query_jpeg2000', 'query_mrsid', 'query_pict', 'query_png', 'query_ppm',
	    'query_srf', 'query_tiff', 'query_video', 'query_wav', 'r_correlate',
	    'r_test', 'radon', 'randomn', 'randomu', 'ranks',
	    'rdpix', 'read', 'readf', 'read_ascii', 'read_binary',
	    'read_bmp', 'read_csv', 'read_dicom', 'read_gif', 'read_image',
	    'read_interfile', 'read_jpeg', 'read_jpeg2000', 'read_mrsid', 'read_pict',
	    'read_png', 'read_ppm', 'read_spr', 'read_srf', 'read_sylk',
	    'read_tiff', 'read_video', 'read_wav', 'read_wave', 'read_x11_bitmap',
	    'read_xwd', 'reads', 'readu', 'real_part', 'rebin',
	    'recall_commands', 'recon3', 'reduce_colors', 'reform', 'region_grow',
	    'register_cursor', 'regress', 'replicate',
	    'replicate_inplace', 'resolve_all',
	    'resolve_routine', 'restore', 'retall', 'return', 'reverse',
	    'rk4', 'roberts', 'rot', 'rotate', 'round',
	    'routine_filepath', 'routine_info', 'rs_test', 's_test', 'save',
	    'savgol', 'scale3', 'scale3d', 'scatterplot', 'scatterplot3d',
	    'scope_level', 'scope_traceback', 'scope_varfetch',
	    'scope_varname', 'search2d',
	    'search3d', 'sem_create', 'sem_delete', 'sem_lock', 'sem_release',
	    'set_plot', 'set_shading', 'setenv', 'sfit', 'shade_surf',
	    'shade_surf_irr', 'shade_volume', 'shift', 'shift_diff', 'shmdebug',
	    'shmmap', 'shmunmap', 'shmvar', 'show3', 'showfont',
	    'signum', 'simplex', 'sin', 'sindgen', 'sinh',
	    'size', 'skewness', 'skip_lun', 'slicer3', 'slide_image',
	    'smooth', 'sobel', 'socket', 'sort', 'spawn',
	    'sph_4pnt', 'sph_scat', 'spher_harm', 'spl_init', 'spl_interp',
	    'spline', 'spline_p', 'sprsab', 'sprsax', 'sprsin',
	    'sprstp', 'sqrt', 'standardize', 'stddev', 'stop',
	    'strarr', 'strcmp', 'strcompress', 'streamline', 'streamline',
	    'stregex', 'stretch', 'string', 'strjoin', 'strlen',
	    'strlowcase', 'strmatch', 'strmessage', 'strmid', 'strpos',
	    'strput', 'strsplit', 'strtrim', 'struct_assign', 'struct_hide',
	    'strupcase', 'surface', 'surface', 'surfr', 'svdc',
	    'svdfit', 'svsol', 'swap_endian', 'swap_endian_inplace', 'symbol',
	    'systime', 't_cvf', 't_pdf', 't3d', 'tag_names',
	    'tan', 'tanh', 'tek_color', 'temporary', 'terminal_size',
	    'tetra_clip', 'tetra_surface', 'tetra_volume', 'text', 'thin',
	    'thread', 'threed', 'tic', 'time_test2', 'timegen',
	    'timer', 'timestamp', 'timestamptovalues', 'tm_test', 'toc',
	    'total', 'trace', 'transpose', 'tri_surf', 'triangulate',
	    'trigrid', 'triql', 'trired', 'trisol', 'truncate_lun',
	    'ts_coef', 'ts_diff', 'ts_fcast', 'ts_smooth', 'tv',
	    'tvcrs', 'tvlct', 'tvrd', 'tvscl', 'typename',
	    'uindgen', 'uint', 'uintarr', 'ul64indgen', 'ulindgen',
	    'ulon64arr', 'ulonarr', 'ulong', 'ulong64', 'uniq',
	    'unsharp_mask', 'usersym', 'value_locate', 'variance', 'vector',
	    'vector_field', 'vel', 'velovect', 'vert_t3d', 'voigt',
	    'volume', 'voronoi', 'voxel_proj', 'wait', 'warp_tri',
	    'watershed', 'wdelete', 'wf_draw', 'where', 'widget_base',
	    'widget_button', 'widget_combobox', 'widget_control',
	    'widget_displaycontextmenu', 'widget_draw',
	    'widget_droplist', 'widget_event', 'widget_info',
	    'widget_label', 'widget_list',
	    'widget_propertysheet', 'widget_slider', 'widget_tab',
	    'widget_table', 'widget_text',
	    'widget_tree', 'widget_tree_move', 'widget_window',
	    'wiener_filter', 'window',
	    'window', 'write_bmp', 'write_csv', 'write_gif', 'write_image',
	    'write_jpeg', 'write_jpeg2000', 'write_nrif', 'write_pict', 'write_png',
	    'write_ppm', 'write_spr', 'write_srf', 'write_sylk', 'write_tiff',
	    'write_video', 'write_wav', 'write_wave', 'writeu', 'wset',
	    'wshow', 'wtn', 'wv_applet', 'wv_cwt', 'wv_cw_wavelet',
	    'wv_denoise', 'wv_dwt', 'wv_fn_coiflet',
	    'wv_fn_daubechies', 'wv_fn_gaussian',
	    'wv_fn_haar', 'wv_fn_morlet', 'wv_fn_paul',
	    'wv_fn_symlet', 'wv_import_data',
	    'wv_import_wavelet', 'wv_plot3d_wps', 'wv_plot_multires',
	    'wv_pwt', 'wv_tool_denoise',
	    'xbm_edit', 'xdisplayfile', 'xdxf', 'xfont', 'xinteranimate',
	    'xloadct', 'xmanager', 'xmng_tmpl', 'xmtool', 'xobjview',
	    'xobjview_rotate', 'xobjview_write_image',
	    'xpalette', 'xpcolor', 'xplot3d',
	    'xregistered', 'xroi', 'xsq_test', 'xsurface', 'xvaredit',
	    'xvolume', 'xvolume_rotate', 'xvolume_write_image',
	    'xyouts', 'zlib_compress', 'zlib_uncompress', 'zoom', 'zoom_24'
	  ];
	  var builtins = wordRegexp(builtinArray);
	
	  var keywordArray = [
	    'begin', 'end', 'endcase', 'endfor',
	    'endwhile', 'endif', 'endrep', 'endforeach',
	    'break', 'case', 'continue', 'for',
	    'foreach', 'goto', 'if', 'then', 'else',
	    'repeat', 'until', 'switch', 'while',
	    'do', 'pro', 'function'
	  ];
	  var keywords = wordRegexp(keywordArray);
	
	  CodeMirror.registerHelper("hintWords", "idl", builtinArray.concat(keywordArray));
	
	  var identifiers = new RegExp('^[_a-z\xa1-\uffff][_a-z0-9\xa1-\uffff]*', 'i');
	
	  var singleOperators = /[+\-*&=<>\/@#~$]/;
	  var boolOperators = new RegExp('(and|or|eq|lt|le|gt|ge|ne|not)', 'i');
	
	  function tokenBase(stream) {
	    // whitespaces
	    if (stream.eatSpace()) return null;
	
	    // Handle one line Comments
	    if (stream.match(';')) {
	      stream.skipToEnd();
	      return 'comment';
	    }
	
	    // Handle Number Literals
	    if (stream.match(/^[0-9\.+-]/, false)) {
	      if (stream.match(/^[+-]?0x[0-9a-fA-F]+/))
	        return 'number';
	      if (stream.match(/^[+-]?\d*\.\d+([EeDd][+-]?\d+)?/))
	        return 'number';
	      if (stream.match(/^[+-]?\d+([EeDd][+-]?\d+)?/))
	        return 'number';
	    }
	
	    // Handle Strings
	    if (stream.match(/^"([^"]|(""))*"/)) { return 'string'; }
	    if (stream.match(/^'([^']|(''))*'/)) { return 'string'; }
	
	    // Handle words
	    if (stream.match(keywords)) { return 'keyword'; }
	    if (stream.match(builtins)) { return 'builtin'; }
	    if (stream.match(identifiers)) { return 'variable'; }
	
	    if (stream.match(singleOperators) || stream.match(boolOperators)) {
	      return 'operator'; }
	
	    // Handle non-detected items
	    stream.next();
	    return null;
	  };
	
	  CodeMirror.defineMode('idl', function() {
	    return {
	      token: function(stream) {
	        return tokenBase(stream);
	      }
	    };
	  });
	
	  CodeMirror.defineMIME('text/x-idl', 'idl');
	});


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("jinja2", function() {
	    var keywords = ["and", "as", "block", "endblock", "by", "cycle", "debug", "else", "elif",
	      "extends", "filter", "endfilter", "firstof", "for",
	      "endfor", "if", "endif", "ifchanged", "endifchanged",
	      "ifequal", "endifequal", "ifnotequal",
	      "endifnotequal", "in", "include", "load", "not", "now", "or",
	      "parsed", "regroup", "reversed", "spaceless",
	      "endspaceless", "ssi", "templatetag", "openblock",
	      "closeblock", "openvariable", "closevariable",
	      "openbrace", "closebrace", "opencomment",
	      "closecomment", "widthratio", "url", "with", "endwith",
	      "get_current_language", "trans", "endtrans", "noop", "blocktrans",
	      "endblocktrans", "get_available_languages",
	      "get_current_language_bidi", "plural"],
	    operator = /^[+\-*&%=<>!?|~^]/,
	    sign = /^[:\[\(\{]/,
	    atom = ["true", "false"],
	    number = /^(\d[+\-\*\/])?\d+(\.\d+)?/;
	
	    keywords = new RegExp("((" + keywords.join(")|(") + "))\\b");
	    atom = new RegExp("((" + atom.join(")|(") + "))\\b");
	
	    function tokenBase (stream, state) {
	      var ch = stream.peek();
	
	      //Comment
	      if (state.incomment) {
	        if(!stream.skipTo("#}")) {
	          stream.skipToEnd();
	        } else {
	          stream.eatWhile(/\#|}/);
	          state.incomment = false;
	        }
	        return "comment";
	      //Tag
	      } else if (state.intag) {
	        //After operator
	        if(state.operator) {
	          state.operator = false;
	          if(stream.match(atom)) {
	            return "atom";
	          }
	          if(stream.match(number)) {
	            return "number";
	          }
	        }
	        //After sign
	        if(state.sign) {
	          state.sign = false;
	          if(stream.match(atom)) {
	            return "atom";
	          }
	          if(stream.match(number)) {
	            return "number";
	          }
	        }
	
	        if(state.instring) {
	          if(ch == state.instring) {
	            state.instring = false;
	          }
	          stream.next();
	          return "string";
	        } else if(ch == "'" || ch == '"') {
	          state.instring = ch;
	          stream.next();
	          return "string";
	        } else if(stream.match(state.intag + "}") || stream.eat("-") && stream.match(state.intag + "}")) {
	          state.intag = false;
	          return "tag";
	        } else if(stream.match(operator)) {
	          state.operator = true;
	          return "operator";
	        } else if(stream.match(sign)) {
	          state.sign = true;
	        } else {
	          if(stream.eat(" ") || stream.sol()) {
	            if(stream.match(keywords)) {
	              return "keyword";
	            }
	            if(stream.match(atom)) {
	              return "atom";
	            }
	            if(stream.match(number)) {
	              return "number";
	            }
	            if(stream.sol()) {
	              stream.next();
	            }
	          } else {
	            stream.next();
	          }
	
	        }
	        return "variable";
	      } else if (stream.eat("{")) {
	        if (ch = stream.eat("#")) {
	          state.incomment = true;
	          if(!stream.skipTo("#}")) {
	            stream.skipToEnd();
	          } else {
	            stream.eatWhile(/\#|}/);
	            state.incomment = false;
	          }
	          return "comment";
	        //Open tag
	        } else if (ch = stream.eat(/\{|%/)) {
	          //Cache close tag
	          state.intag = ch;
	          if(ch == "{") {
	            state.intag = "}";
	          }
	          stream.eat("-");
	          return "tag";
	        }
	      }
	      stream.next();
	    };
	
	    return {
	      startState: function () {
	        return {tokenize: tokenBase};
	      },
	      token: function (stream, state) {
	        return state.tokenize(stream, state);
	      }
	    };
	  });
	});


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(22), __webpack_require__(12))
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../xml/xml", "../javascript/javascript"], mod)
	  else // Plain browser env
	    mod(CodeMirror)
	})(function(CodeMirror) {
	  "use strict"
	
	  // Depth means the amount of open braces in JS context, in XML
	  // context 0 means not in tag, 1 means in tag, and 2 means in tag
	  // and js block comment.
	  function Context(state, mode, depth, prev) {
	    this.state = state; this.mode = mode; this.depth = depth; this.prev = prev
	  }
	
	  function copyContext(context) {
	    return new Context(CodeMirror.copyState(context.mode, context.state),
	                       context.mode,
	                       context.depth,
	                       context.prev && copyContext(context.prev))
	  }
	
	  CodeMirror.defineMode("jsx", function(config, modeConfig) {
	    var xmlMode = CodeMirror.getMode(config, {name: "xml", allowMissing: true, multilineTagIndentPastTag: false})
	    var jsMode = CodeMirror.getMode(config, modeConfig && modeConfig.base || "javascript")
	
	    function flatXMLIndent(state) {
	      var tagName = state.tagName
	      state.tagName = null
	      var result = xmlMode.indent(state, "")
	      state.tagName = tagName
	      return result
	    }
	
	    function token(stream, state) {
	      if (state.context.mode == xmlMode)
	        return xmlToken(stream, state, state.context)
	      else
	        return jsToken(stream, state, state.context)
	    }
	
	    function xmlToken(stream, state, cx) {
	      if (cx.depth == 2) { // Inside a JS /* */ comment
	        if (stream.match(/^.*?\*\//)) cx.depth = 1
	        else stream.skipToEnd()
	        return "comment"
	      }
	
	      if (stream.peek() == "{") {
	        xmlMode.skipAttribute(cx.state)
	
	        var indent = flatXMLIndent(cx.state), xmlContext = cx.state.context
	        // If JS starts on same line as tag
	        if (xmlContext && stream.match(/^[^>]*>\s*$/, false)) {
	          while (xmlContext.prev && !xmlContext.startOfLine)
	            xmlContext = xmlContext.prev
	          // If tag starts the line, use XML indentation level
	          if (xmlContext.startOfLine) indent -= config.indentUnit
	          // Else use JS indentation level
	          else if (cx.prev.state.lexical) indent = cx.prev.state.lexical.indented
	        // Else if inside of tag
	        } else if (cx.depth == 1) {
	          indent += config.indentUnit
	        }
	
	        state.context = new Context(CodeMirror.startState(jsMode, indent),
	                                    jsMode, 0, state.context)
	        return null
	      }
	
	      if (cx.depth == 1) { // Inside of tag
	        if (stream.peek() == "<") { // Tag inside of tag
	          xmlMode.skipAttribute(cx.state)
	          state.context = new Context(CodeMirror.startState(xmlMode, flatXMLIndent(cx.state)),
	                                      xmlMode, 0, state.context)
	          return null
	        } else if (stream.match("//")) {
	          stream.skipToEnd()
	          return "comment"
	        } else if (stream.match("/*")) {
	          cx.depth = 2
	          return token(stream, state)
	        }
	      }
	
	      var style = xmlMode.token(stream, cx.state), cur = stream.current(), stop
	      if (/\btag\b/.test(style)) {
	        if (/>$/.test(cur)) {
	          if (cx.state.context) cx.depth = 0
	          else state.context = state.context.prev
	        } else if (/^</.test(cur)) {
	          cx.depth = 1
	        }
	      } else if (!style && (stop = cur.indexOf("{")) > -1) {
	        stream.backUp(cur.length - stop)
	      }
	      return style
	    }
	
	    function jsToken(stream, state, cx) {
	      if (stream.peek() == "<" && jsMode.expressionAllowed(stream, cx.state)) {
	        jsMode.skipExpression(cx.state)
	        state.context = new Context(CodeMirror.startState(xmlMode, jsMode.indent(cx.state, "")),
	                                    xmlMode, 0, state.context)
	        return null
	      }
	
	      var style = jsMode.token(stream, cx.state)
	      if (!style && cx.depth != null) {
	        var cur = stream.current()
	        if (cur == "{") {
	          cx.depth++
	        } else if (cur == "}") {
	          if (--cx.depth == 0) state.context = state.context.prev
	        }
	      }
	      return style
	    }
	
	    return {
	      startState: function() {
	        return {context: new Context(CodeMirror.startState(jsMode), jsMode)}
	      },
	
	      copyState: function(state) {
	        return {context: copyContext(state.context)}
	      },
	
	      token: token,
	
	      indent: function(state, textAfter, fullLine) {
	        return state.context.mode.indent(state.context.state, textAfter, fullLine)
	      },
	
	      innerMode: function(state) {
	        return state.context
	      }
	    }
	  }, "xml", "javascript")
	
	  CodeMirror.defineMIME("text/jsx", "jsx")
	  CodeMirror.defineMIME("text/typescript-jsx", {name: "jsx", base: {name: "javascript", typescript: true}})
	});


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("julia", function(config, parserConf) {
	  function wordRegexp(words, end) {
	    if (typeof end === "undefined") { end = "\\b"; }
	    return new RegExp("^((" + words.join(")|(") + "))" + end);
	  }
	
	  var octChar = "\\\\[0-7]{1,3}";
	  var hexChar = "\\\\x[A-Fa-f0-9]{1,2}";
	  var sChar = "\\\\[abefnrtv0%?'\"\\\\]";
	  var uChar = "([^\\u0027\\u005C\\uD800-\\uDFFF]|[\\uD800-\\uDFFF][\\uDC00-\\uDFFF])";
	
	  var operators = parserConf.operators || wordRegexp([
	      "\\.?[\\\\%*+\\-<>!=\\/^]=?", "\\.?[|&\\u00F7\\u2260\\u2264\\u2265]",
	      "\\u00D7", "\\u2208", "\\u2209", "\\u220B", "\\u220C", "\\u2229",
	      "\\u222A", "\\u2286", "\\u2288", "\\u228A", "\\u22c5", "\\?", "~", ":",
	      "\\$", "\\.[<>]", "<<=?", ">>>?=?", "\\.[<>=]=", "->?", "\\/\\/", "=>",
	      "<:", "\\bin\\b(?!\\()"], "");
	  var delimiters = parserConf.delimiters || /^[;,()[\]{}]/;
	  var identifiers = parserConf.identifiers || /^[_A-Za-z\u00A1-\uFFFF][\w\u00A1-\uFFFF]*!*/;
	
	  var chars = wordRegexp([octChar, hexChar, sChar, uChar], "'");
	  var openers = wordRegexp(["begin", "function", "type", "immutable", "let",
	      "macro", "for", "while", "quote", "if", "else", "elseif", "try",
	      "finally", "catch", "do"]);
	  var closers = wordRegexp(["end", "else", "elseif", "catch", "finally"]);
	  var keywords = wordRegexp(["if", "else", "elseif", "while", "for", "begin",
	      "let", "end", "do", "try", "catch", "finally", "return", "break",
	      "continue", "global", "local", "const", "export", "import", "importall",
	      "using", "function", "macro", "module", "baremodule", "type",
	      "immutable", "quote", "typealias", "abstract", "bitstype"]);
	  var builtins = wordRegexp(["true", "false", "nothing", "NaN", "Inf"]);
	
	  var macro = /^@[_A-Za-z][\w]*/;
	  var symbol = /^:[_A-Za-z\u00A1-\uFFFF][\w\u00A1-\uFFFF]*!*/;
	  var stringPrefixes = /^(`|"{3}|([_A-Za-z\u00A1-\uFFFF]*"))/;
	
	  function inArray(state) {
	    return inGenerator(state, '[')
	  }
	
	  function inGenerator(state, bracket) {
	    var curr = currentScope(state),
	        prev = currentScope(state, 1);
	    if (typeof(bracket) === "undefined") { bracket = '('; }
	    if (curr === bracket || (prev === bracket && curr === "for")) {
	      return true;
	    }
	    return false;
	  }
	
	  function currentScope(state, n) {
	    if (typeof(n) === "undefined") { n = 0; }
	    if (state.scopes.length <= n) {
	      return null;
	    }
	    return state.scopes[state.scopes.length - (n + 1)];
	  }
	
	  // tokenizers
	  function tokenBase(stream, state) {
	    // Handle multiline comments
	    if (stream.match(/^#=/, false)) {
	      state.tokenize = tokenComment;
	      return state.tokenize(stream, state);
	    }
	
	    // Handle scope changes
	    var leavingExpr = state.leavingExpr;
	    if (stream.sol()) {
	      leavingExpr = false;
	    }
	    state.leavingExpr = false;
	
	    if (leavingExpr) {
	      if (stream.match(/^'+/)) {
	        return "operator";
	      }
	    }
	
	    if (stream.match(/^\.{2,3}/)) {
	      return "operator";
	    }
	
	    if (stream.eatSpace()) {
	      return null;
	    }
	
	    var ch = stream.peek();
	
	    // Handle single line comments
	    if (ch === '#') {
	      stream.skipToEnd();
	      return "comment";
	    }
	
	    if (ch === '[') {
	      state.scopes.push('[');
	    }
	
	    if (ch === '(') {
	      state.scopes.push('(');
	    }
	
	    var scope = currentScope(state);
	
	    if (inArray(state) && ch === ']') {
	      if (scope === "for") { state.scopes.pop(); }
	      state.scopes.pop();
	      state.leavingExpr = true;
	    }
	
	    if (inGenerator(state) && ch === ')') {
	      if (scope === "for") { state.scopes.pop(); }
	      state.scopes.pop();
	      state.leavingExpr = true;
	    }
	
	    var match;
	    if (match = stream.match(openers, false)) {
	      state.scopes.push(match[0]);
	    }
	
	    if (stream.match(closers, false)) {
	      state.scopes.pop();
	    }
	
	    if (inArray(state)) {
	      if (state.lastToken == "end" && stream.match(/^:/)) {
	        return "operator";
	      }
	      if (stream.match(/^end/)) {
	        return "number";
	      }
	    }
	
	    // Handle type annotations
	    if (stream.match(/^::(?![:\$])/)) {
	      state.tokenize = tokenAnnotation;
	      return state.tokenize(stream, state);
	    }
	
	    // Handle symbols
	    if (!leavingExpr && stream.match(symbol) || stream.match(/:\./)) {
	      return "builtin";
	    }
	
	    // Handle parametric types
	    if (stream.match(/^{[^}]*}(?=\()/)) {
	      return "builtin";
	    }
	
	    // Handle operators and Delimiters
	    if (stream.match(operators)) {
	      return "operator";
	    }
	
	    // Handle Number Literals
	    if (stream.match(/^[0-9\.]/, false)) {
	      var imMatcher = RegExp(/^im\b/);
	      var numberLiteral = false;
	      // Floats
	      if (stream.match(/^\d*\.(?!\.)\d*([Eef][\+\-]?\d+)?/i)) { numberLiteral = true; }
	      if (stream.match(/^\d+\.(?!\.)\d*/)) { numberLiteral = true; }
	      if (stream.match(/^\.\d+/)) { numberLiteral = true; }
	      if (stream.match(/^0x\.[0-9a-f]+p[\+\-]?\d+/i)) { numberLiteral = true; }
	      // Integers
	      if (stream.match(/^0x[0-9a-f]+/i)) { numberLiteral = true; } // Hex
	      if (stream.match(/^0b[01]+/i)) { numberLiteral = true; } // Binary
	      if (stream.match(/^0o[0-7]+/i)) { numberLiteral = true; } // Octal
	      if (stream.match(/^[1-9]\d*(e[\+\-]?\d+)?/)) { numberLiteral = true; } // Decimal
	      // Zero by itself with no other piece of number.
	      if (stream.match(/^0(?![\dx])/i)) { numberLiteral = true; }
	      if (numberLiteral) {
	          // Integer literals may be "long"
	          stream.match(imMatcher);
	          state.leavingExpr = true;
	          return "number";
	      }
	    }
	
	    // Handle Chars
	    if (stream.match(/^'/)) {
	      state.tokenize = tokenChar;
	      return state.tokenize(stream, state);
	    }
	
	    // Handle Strings
	    if (stream.match(stringPrefixes)) {
	      state.tokenize = tokenStringFactory(stream.current());
	      return state.tokenize(stream, state);
	    }
	
	    if (stream.match(macro)) {
	      return "meta";
	    }
	
	    if (stream.match(delimiters)) {
	      return null;
	    }
	
	    if (stream.match(keywords)) {
	      return "keyword";
	    }
	
	    if (stream.match(builtins)) {
	      return "builtin";
	    }
	
	    var isDefinition = state.isDefinition || state.lastToken == "function" ||
	                       state.lastToken == "macro" || state.lastToken == "type" ||
	                       state.lastToken == "immutable";
	
	    if (stream.match(identifiers)) {
	      if (isDefinition) {
	        if (stream.peek() === '.') {
	          state.isDefinition = true;
	          return "variable";
	        }
	        state.isDefinition = false;
	        return "def";
	      }
	      if (stream.match(/^({[^}]*})*\(/, false)) {
	        return callOrDef(stream, state);
	      }
	      state.leavingExpr = true;
	      return "variable";
	    }
	
	    // Handle non-detected items
	    stream.next();
	    return "error";
	  }
	
	  function callOrDef(stream, state) {
	    var match = stream.match(/^(\(\s*)/);
	    if (match) {
	      if (state.firstParenPos < 0)
	        state.firstParenPos = state.scopes.length;
	      state.scopes.push('(');
	      state.charsAdvanced += match[1].length;
	    }
	    if (currentScope(state) == '(' && stream.match(/^\)/)) {
	      state.scopes.pop();
	      state.charsAdvanced += 1;
	      if (state.scopes.length <= state.firstParenPos) {
	        var isDefinition = stream.match(/^\s*?=(?!=)/, false);
	        stream.backUp(state.charsAdvanced);
	        state.firstParenPos = -1;
	        state.charsAdvanced = 0;
	        if (isDefinition)
	          return "def";
	        return "builtin";
	      }
	    }
	    // Unfortunately javascript does not support multiline strings, so we have
	    // to undo anything done upto here if a function call or definition splits
	    // over two or more lines.
	    if (stream.match(/^$/g, false)) {
	      stream.backUp(state.charsAdvanced);
	      while (state.scopes.length > state.firstParenPos)
	        state.scopes.pop();
	      state.firstParenPos = -1;
	      state.charsAdvanced = 0;
	      return "builtin";
	    }
	    state.charsAdvanced += stream.match(/^([^()]*)/)[1].length;
	    return callOrDef(stream, state);
	  }
	
	  function tokenAnnotation(stream, state) {
	    stream.match(/.*?(?=,|;|{|}|\(|\)|=|$|\s)/);
	    if (stream.match(/^{/)) {
	      state.nestedLevels++;
	    } else if (stream.match(/^}/)) {
	      state.nestedLevels--;
	    }
	    if (state.nestedLevels > 0) {
	      stream.match(/.*?(?={|})/);
	    } else if (state.nestedLevels == 0) {
	      state.tokenize = tokenBase;
	    }
	    return "builtin";
	  }
	
	  function tokenComment(stream, state) {
	    if (stream.match(/^#=/)) {
	      state.nestedLevels++;
	    }
	    if (!stream.match(/.*?(?=(#=|=#))/)) {
	      stream.skipToEnd();
	    }
	    if (stream.match(/^=#/)) {
	      state.nestedLevels--;
	      if (state.nestedLevels == 0)
	        state.tokenize = tokenBase;
	    }
	    return "comment";
	  }
	
	  function tokenChar(stream, state) {
	    var isChar = false, match;
	    if (stream.match(chars)) {
	      isChar = true;
	    } else if (match = stream.match(/\\u([a-f0-9]{1,4})(?=')/i)) {
	      var value = parseInt(match[1], 16);
	      if (value <= 55295 || value >= 57344) { // (U+0,U+D7FF), (U+E000,U+FFFF)
	        isChar = true;
	        stream.next();
	      }
	    } else if (match = stream.match(/\\U([A-Fa-f0-9]{5,8})(?=')/)) {
	      var value = parseInt(match[1], 16);
	      if (value <= 1114111) { // U+10FFFF
	        isChar = true;
	        stream.next();
	      }
	    }
	    if (isChar) {
	      state.leavingExpr = true;
	      state.tokenize = tokenBase;
	      return "string";
	    }
	    if (!stream.match(/^[^']+(?=')/)) { stream.skipToEnd(); }
	    if (stream.match(/^'/)) { state.tokenize = tokenBase; }
	    return "error";
	  }
	
	  function tokenStringFactory(delimiter) {
	    delimiter = (delimiter === '`' || delimiter === '"""') ? delimiter : '"';
	    function tokenString(stream, state) {
	      if (stream.eat('\\')) {
	        stream.next();
	      } else if (stream.match(delimiter)) {
	        state.tokenize = tokenBase;
	        state.leavingExpr = true;
	        return "string";
	      } else {
	        stream.eat(/[`"]/);
	      }
	      stream.eatWhile(/[^\\`"]/);
	      return "string";
	    }
	    return tokenString;
	  }
	
	  var external = {
	    startState: function() {
	      return {
	        tokenize: tokenBase,
	        scopes: [],
	        lastToken: null,
	        leavingExpr: false,
	        isDefinition: false,
	        nestedLevels: 0,
	        charsAdvanced: 0,
	        firstParenPos: -1
	      };
	    },
	
	    token: function(stream, state) {
	      var style = state.tokenize(stream, state);
	      var current = stream.current();
	
	      if (current && style) {
	        state.lastToken = current;
	      }
	
	      // Handle '.' connected identifiers
	      if (current === '.') {
	        style = stream.match(identifiers, false) || stream.match(macro, false) ||
	                stream.match(/\(/, false) ? "operator" : "error";
	      }
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      var delta = 0;
	      if ( textAfter === ']' || textAfter === ')' || textAfter === "end" ||
	           textAfter === "else" || textAfter === "catch" ||
	           textAfter === "finally" ) {
	        delta = -1;
	      }
	      return (state.scopes.length + delta) * config.indentUnit;
	    },
	
	    electricInput: /\b(end|else|catch|finally)\b/,
	    blockCommentStart: "#=",
	    blockCommentEnd: "=#",
	    lineComment: "#",
	    fold: "indent"
	  };
	  return external;
	});
	
	
	CodeMirror.defineMIME("text/x-julia", "julia");
	
	});


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	/**
	 * Link to the project's GitHub page:
	 * https://github.com/duralog/CodeMirror
	 */
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode('livescript', function(){
	    var tokenBase = function(stream, state) {
	      var next_rule = state.next || "start";
	      if (next_rule) {
	        state.next = state.next;
	        var nr = Rules[next_rule];
	        if (nr.splice) {
	          for (var i$ = 0; i$ < nr.length; ++i$) {
	            var r = nr[i$];
	            if (r.regex && stream.match(r.regex)) {
	              state.next = r.next || state.next;
	              return r.token;
	            }
	          }
	          stream.next();
	          return 'error';
	        }
	        if (stream.match(r = Rules[next_rule])) {
	          if (r.regex && stream.match(r.regex)) {
	            state.next = r.next;
	            return r.token;
	          } else {
	            stream.next();
	            return 'error';
	          }
	        }
	      }
	      stream.next();
	      return 'error';
	    };
	    var external = {
	      startState: function(){
	        return {
	          next: 'start',
	          lastToken: {style: null, indent: 0, content: ""}
	        };
	      },
	      token: function(stream, state){
	        while (stream.pos == stream.start)
	          var style = tokenBase(stream, state);
	        state.lastToken = {
	          style: style,
	          indent: stream.indentation(),
	          content: stream.current()
	        };
	        return style.replace(/\./g, ' ');
	      },
	      indent: function(state){
	        var indentation = state.lastToken.indent;
	        if (state.lastToken.content.match(indenter)) {
	          indentation += 2;
	        }
	        return indentation;
	      }
	    };
	    return external;
	  });
	
	  var identifier = '(?![\\d\\s])[$\\w\\xAA-\\uFFDC](?:(?!\\s)[$\\w\\xAA-\\uFFDC]|-[A-Za-z])*';
	  var indenter = RegExp('(?:[({[=:]|[-~]>|\\b(?:e(?:lse|xport)|d(?:o|efault)|t(?:ry|hen)|finally|import(?:\\s*all)?|const|var|let|new|catch(?:\\s*' + identifier + ')?))\\s*$');
	  var keywordend = '(?![$\\w]|-[A-Za-z]|\\s*:(?![:=]))';
	  var stringfill = {
	    token: 'string',
	    regex: '.+'
	  };
	  var Rules = {
	    start: [
	      {
	        token: 'comment.doc',
	        regex: '/\\*',
	        next: 'comment'
	      }, {
	        token: 'comment',
	        regex: '#.*'
	      }, {
	        token: 'keyword',
	        regex: '(?:t(?:h(?:is|row|en)|ry|ypeof!?)|c(?:on(?:tinue|st)|a(?:se|tch)|lass)|i(?:n(?:stanceof)?|mp(?:ort(?:\\s+all)?|lements)|[fs])|d(?:e(?:fault|lete|bugger)|o)|f(?:or(?:\\s+own)?|inally|unction)|s(?:uper|witch)|e(?:lse|x(?:tends|port)|val)|a(?:nd|rguments)|n(?:ew|ot)|un(?:less|til)|w(?:hile|ith)|o[fr]|return|break|let|var|loop)' + keywordend
	      }, {
	        token: 'constant.language',
	        regex: '(?:true|false|yes|no|on|off|null|void|undefined)' + keywordend
	      }, {
	        token: 'invalid.illegal',
	        regex: '(?:p(?:ackage|r(?:ivate|otected)|ublic)|i(?:mplements|nterface)|enum|static|yield)' + keywordend
	      }, {
	        token: 'language.support.class',
	        regex: '(?:R(?:e(?:gExp|ferenceError)|angeError)|S(?:tring|yntaxError)|E(?:rror|valError)|Array|Boolean|Date|Function|Number|Object|TypeError|URIError)' + keywordend
	      }, {
	        token: 'language.support.function',
	        regex: '(?:is(?:NaN|Finite)|parse(?:Int|Float)|Math|JSON|(?:en|de)codeURI(?:Component)?)' + keywordend
	      }, {
	        token: 'variable.language',
	        regex: '(?:t(?:hat|il|o)|f(?:rom|allthrough)|it|by|e)' + keywordend
	      }, {
	        token: 'identifier',
	        regex: identifier + '\\s*:(?![:=])'
	      }, {
	        token: 'variable',
	        regex: identifier
	      }, {
	        token: 'keyword.operator',
	        regex: '(?:\\.{3}|\\s+\\?)'
	      }, {
	        token: 'keyword.variable',
	        regex: '(?:@+|::|\\.\\.)',
	        next: 'key'
	      }, {
	        token: 'keyword.operator',
	        regex: '\\.\\s*',
	        next: 'key'
	      }, {
	        token: 'string',
	        regex: '\\\\\\S[^\\s,;)}\\]]*'
	      }, {
	        token: 'string.doc',
	        regex: '\'\'\'',
	        next: 'qdoc'
	      }, {
	        token: 'string.doc',
	        regex: '"""',
	        next: 'qqdoc'
	      }, {
	        token: 'string',
	        regex: '\'',
	        next: 'qstring'
	      }, {
	        token: 'string',
	        regex: '"',
	        next: 'qqstring'
	      }, {
	        token: 'string',
	        regex: '`',
	        next: 'js'
	      }, {
	        token: 'string',
	        regex: '<\\[',
	        next: 'words'
	      }, {
	        token: 'string.regex',
	        regex: '//',
	        next: 'heregex'
	      }, {
	        token: 'string.regex',
	        regex: '\\/(?:[^[\\/\\n\\\\]*(?:(?:\\\\.|\\[[^\\]\\n\\\\]*(?:\\\\.[^\\]\\n\\\\]*)*\\])[^[\\/\\n\\\\]*)*)\\/[gimy$]{0,4}',
	        next: 'key'
	      }, {
	        token: 'constant.numeric',
	        regex: '(?:0x[\\da-fA-F][\\da-fA-F_]*|(?:[2-9]|[12]\\d|3[0-6])r[\\da-zA-Z][\\da-zA-Z_]*|(?:\\d[\\d_]*(?:\\.\\d[\\d_]*)?|\\.\\d[\\d_]*)(?:e[+-]?\\d[\\d_]*)?[\\w$]*)'
	      }, {
	        token: 'lparen',
	        regex: '[({[]'
	      }, {
	        token: 'rparen',
	        regex: '[)}\\]]',
	        next: 'key'
	      }, {
	        token: 'keyword.operator',
	        regex: '\\S+'
	      }, {
	        token: 'text',
	        regex: '\\s+'
	      }
	    ],
	    heregex: [
	      {
	        token: 'string.regex',
	        regex: '.*?//[gimy$?]{0,4}',
	        next: 'start'
	      }, {
	        token: 'string.regex',
	        regex: '\\s*#{'
	      }, {
	        token: 'comment.regex',
	        regex: '\\s+(?:#.*)?'
	      }, {
	        token: 'string.regex',
	        regex: '\\S+'
	      }
	    ],
	    key: [
	      {
	        token: 'keyword.operator',
	        regex: '[.?@!]+'
	      }, {
	        token: 'identifier',
	        regex: identifier,
	        next: 'start'
	      }, {
	        token: 'text',
	        regex: '',
	        next: 'start'
	      }
	    ],
	    comment: [
	      {
	        token: 'comment.doc',
	        regex: '.*?\\*/',
	        next: 'start'
	      }, {
	        token: 'comment.doc',
	        regex: '.+'
	      }
	    ],
	    qdoc: [
	      {
	        token: 'string',
	        regex: ".*?'''",
	        next: 'key'
	      }, stringfill
	    ],
	    qqdoc: [
	      {
	        token: 'string',
	        regex: '.*?"""',
	        next: 'key'
	      }, stringfill
	    ],
	    qstring: [
	      {
	        token: 'string',
	        regex: '[^\\\\\']*(?:\\\\.[^\\\\\']*)*\'',
	        next: 'key'
	      }, stringfill
	    ],
	    qqstring: [
	      {
	        token: 'string',
	        regex: '[^\\\\"]*(?:\\\\.[^\\\\"]*)*"',
	        next: 'key'
	      }, stringfill
	    ],
	    js: [
	      {
	        token: 'string',
	        regex: '[^\\\\`]*(?:\\\\.[^\\\\`]*)*`',
	        next: 'key'
	      }, stringfill
	    ],
	    words: [
	      {
	        token: 'string',
	        regex: '.*?\\]>',
	        next: 'key'
	      }, stringfill
	    ]
	  };
	  for (var idx in Rules) {
	    var r = Rules[idx];
	    if (r.splice) {
	      for (var i = 0, len = r.length; i < len; ++i) {
	        var rr = r[i];
	        if (typeof rr.regex === 'string') {
	          Rules[idx][i].regex = new RegExp('^' + rr.regex);
	        }
	      }
	    } else if (typeof rr.regex === 'string') {
	      Rules[idx].regex = new RegExp('^' + r.regex);
	    }
	  }
	
	  CodeMirror.defineMIME('text/x-livescript', 'livescript');
	
	});


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// LUA mode. Ported to CodeMirror 2 from Franciszek Wawrzak's
	// CodeMirror 1 mode.
	// highlights keywords, strings, comments (no leveling supported! ("[==[")), tokens, basic indenting
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("lua", function(config, parserConfig) {
	  var indentUnit = config.indentUnit;
	
	  function prefixRE(words) {
	    return new RegExp("^(?:" + words.join("|") + ")", "i");
	  }
	  function wordRE(words) {
	    return new RegExp("^(?:" + words.join("|") + ")$", "i");
	  }
	  var specials = wordRE(parserConfig.specials || []);
	
	  // long list of standard functions from lua manual
	  var builtins = wordRE([
	    "_G","_VERSION","assert","collectgarbage","dofile","error","getfenv","getmetatable","ipairs","load",
	    "loadfile","loadstring","module","next","pairs","pcall","print","rawequal","rawget","rawset","require",
	    "select","setfenv","setmetatable","tonumber","tostring","type","unpack","xpcall",
	
	    "coroutine.create","coroutine.resume","coroutine.running","coroutine.status","coroutine.wrap","coroutine.yield",
	
	    "debug.debug","debug.getfenv","debug.gethook","debug.getinfo","debug.getlocal","debug.getmetatable",
	    "debug.getregistry","debug.getupvalue","debug.setfenv","debug.sethook","debug.setlocal","debug.setmetatable",
	    "debug.setupvalue","debug.traceback",
	
	    "close","flush","lines","read","seek","setvbuf","write",
	
	    "io.close","io.flush","io.input","io.lines","io.open","io.output","io.popen","io.read","io.stderr","io.stdin",
	    "io.stdout","io.tmpfile","io.type","io.write",
	
	    "math.abs","math.acos","math.asin","math.atan","math.atan2","math.ceil","math.cos","math.cosh","math.deg",
	    "math.exp","math.floor","math.fmod","math.frexp","math.huge","math.ldexp","math.log","math.log10","math.max",
	    "math.min","math.modf","math.pi","math.pow","math.rad","math.random","math.randomseed","math.sin","math.sinh",
	    "math.sqrt","math.tan","math.tanh",
	
	    "os.clock","os.date","os.difftime","os.execute","os.exit","os.getenv","os.remove","os.rename","os.setlocale",
	    "os.time","os.tmpname",
	
	    "package.cpath","package.loaded","package.loaders","package.loadlib","package.path","package.preload",
	    "package.seeall",
	
	    "string.byte","string.char","string.dump","string.find","string.format","string.gmatch","string.gsub",
	    "string.len","string.lower","string.match","string.rep","string.reverse","string.sub","string.upper",
	
	    "table.concat","table.insert","table.maxn","table.remove","table.sort"
	  ]);
	  var keywords = wordRE(["and","break","elseif","false","nil","not","or","return",
	                         "true","function", "end", "if", "then", "else", "do",
	                         "while", "repeat", "until", "for", "in", "local" ]);
	
	  var indentTokens = wordRE(["function", "if","repeat","do", "\\(", "{"]);
	  var dedentTokens = wordRE(["end", "until", "\\)", "}"]);
	  var dedentPartial = prefixRE(["end", "until", "\\)", "}", "else", "elseif"]);
	
	  function readBracket(stream) {
	    var level = 0;
	    while (stream.eat("=")) ++level;
	    stream.eat("[");
	    return level;
	  }
	
	  function normal(stream, state) {
	    var ch = stream.next();
	    if (ch == "-" && stream.eat("-")) {
	      if (stream.eat("[") && stream.eat("["))
	        return (state.cur = bracketed(readBracket(stream), "comment"))(stream, state);
	      stream.skipToEnd();
	      return "comment";
	    }
	    if (ch == "\"" || ch == "'")
	      return (state.cur = string(ch))(stream, state);
	    if (ch == "[" && /[\[=]/.test(stream.peek()))
	      return (state.cur = bracketed(readBracket(stream), "string"))(stream, state);
	    if (/\d/.test(ch)) {
	      stream.eatWhile(/[\w.%]/);
	      return "number";
	    }
	    if (/[\w_]/.test(ch)) {
	      stream.eatWhile(/[\w\\\-_.]/);
	      return "variable";
	    }
	    return null;
	  }
	
	  function bracketed(level, style) {
	    return function(stream, state) {
	      var curlev = null, ch;
	      while ((ch = stream.next()) != null) {
	        if (curlev == null) {if (ch == "]") curlev = 0;}
	        else if (ch == "=") ++curlev;
	        else if (ch == "]" && curlev == level) { state.cur = normal; break; }
	        else curlev = null;
	      }
	      return style;
	    };
	  }
	
	  function string(quote) {
	    return function(stream, state) {
	      var escaped = false, ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == quote && !escaped) break;
	        escaped = !escaped && ch == "\\";
	      }
	      if (!escaped) state.cur = normal;
	      return "string";
	    };
	  }
	
	  return {
	    startState: function(basecol) {
	      return {basecol: basecol || 0, indentDepth: 0, cur: normal};
	    },
	
	    token: function(stream, state) {
	      if (stream.eatSpace()) return null;
	      var style = state.cur(stream, state);
	      var word = stream.current();
	      if (style == "variable") {
	        if (keywords.test(word)) style = "keyword";
	        else if (builtins.test(word)) style = "builtin";
	        else if (specials.test(word)) style = "variable-2";
	      }
	      if ((style != "comment") && (style != "string")){
	        if (indentTokens.test(word)) ++state.indentDepth;
	        else if (dedentTokens.test(word)) --state.indentDepth;
	      }
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      var closing = dedentPartial.test(textAfter);
	      return state.basecol + indentUnit * (state.indentDepth - (closing ? 1 : 0));
	    },
	
	    lineComment: "--",
	    blockCommentStart: "--[[",
	    blockCommentEnd: "]]"
	  };
	});
	
	CodeMirror.defineMIME("text/x-lua", "lua");
	
	});


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// Mathematica mode copyright (c) 2015 by Calin Barbat
	// Based on code by Patrick Scheibe (halirutan)
	// See: https://github.com/halirutan/Mathematica-Source-Highlighting/tree/master/src/lang-mma.js
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode('mathematica', function(_config, _parserConfig) {
	
	  // used pattern building blocks
	  var Identifier = '[a-zA-Z\\$][a-zA-Z0-9\\$]*';
	  var pBase      = "(?:\\d+)";
	  var pFloat     = "(?:\\.\\d+|\\d+\\.\\d*|\\d+)";
	  var pFloatBase = "(?:\\.\\w+|\\w+\\.\\w*|\\w+)";
	  var pPrecision = "(?:`(?:`?"+pFloat+")?)";
	
	  // regular expressions
	  var reBaseForm        = new RegExp('(?:'+pBase+'(?:\\^\\^'+pFloatBase+pPrecision+'?(?:\\*\\^[+-]?\\d+)?))');
	  var reFloatForm       = new RegExp('(?:' + pFloat + pPrecision + '?(?:\\*\\^[+-]?\\d+)?)');
	  var reIdInContext     = new RegExp('(?:`?)(?:' + Identifier + ')(?:`(?:' + Identifier + '))*(?:`?)');
	
	  function tokenBase(stream, state) {
	    var ch;
	
	    // get next character
	    ch = stream.next();
	
	    // string
	    if (ch === '"') {
	      state.tokenize = tokenString;
	      return state.tokenize(stream, state);
	    }
	
	    // comment
	    if (ch === '(') {
	      if (stream.eat('*')) {
	        state.commentLevel++;
	        state.tokenize = tokenComment;
	        return state.tokenize(stream, state);
	      }
	    }
	
	    // go back one character
	    stream.backUp(1);
	
	    // look for numbers
	    // Numbers in a baseform
	    if (stream.match(reBaseForm, true, false)) {
	      return 'number';
	    }
	
	    // Mathematica numbers. Floats (1.2, .2, 1.) can have optionally a precision (`float) or an accuracy definition
	    // (``float). Note: while 1.2` is possible 1.2`` is not. At the end an exponent (float*^+12) can follow.
	    if (stream.match(reFloatForm, true, false)) {
	      return 'number';
	    }
	
	    /* In[23] and Out[34] */
	    if (stream.match(/(?:In|Out)\[[0-9]*\]/, true, false)) {
	      return 'atom';
	    }
	
	    // usage
	    if (stream.match(/([a-zA-Z\$]+(?:`?[a-zA-Z0-9\$])*::usage)/, true, false)) {
	      return 'meta';
	    }
	
	    // message
	    if (stream.match(/([a-zA-Z\$]+(?:`?[a-zA-Z0-9\$])*::[a-zA-Z\$][a-zA-Z0-9\$]*):?/, true, false)) {
	      return 'string-2';
	    }
	
	    // this makes a look-ahead match for something like variable:{_Integer}
	    // the match is then forwarded to the mma-patterns tokenizer.
	    if (stream.match(/([a-zA-Z\$][a-zA-Z0-9\$]*\s*:)(?:(?:[a-zA-Z\$][a-zA-Z0-9\$]*)|(?:[^:=>~@\^\&\*\)\[\]'\?,\|])).*/, true, false)) {
	      return 'variable-2';
	    }
	
	    // catch variables which are used together with Blank (_), BlankSequence (__) or BlankNullSequence (___)
	    // Cannot start with a number, but can have numbers at any other position. Examples
	    // blub__Integer, a1_, b34_Integer32
	    if (stream.match(/[a-zA-Z\$][a-zA-Z0-9\$]*_+[a-zA-Z\$][a-zA-Z0-9\$]*/, true, false)) {
	      return 'variable-2';
	    }
	    if (stream.match(/[a-zA-Z\$][a-zA-Z0-9\$]*_+/, true, false)) {
	      return 'variable-2';
	    }
	    if (stream.match(/_+[a-zA-Z\$][a-zA-Z0-9\$]*/, true, false)) {
	      return 'variable-2';
	    }
	
	    // Named characters in Mathematica, like \[Gamma].
	    if (stream.match(/\\\[[a-zA-Z\$][a-zA-Z0-9\$]*\]/, true, false)) {
	      return 'variable-3';
	    }
	
	    // Match all braces separately
	    if (stream.match(/(?:\[|\]|{|}|\(|\))/, true, false)) {
	      return 'bracket';
	    }
	
	    // Catch Slots (#, ##, #3, ##9 and the V10 named slots #name). I have never seen someone using more than one digit after #, so we match
	    // only one.
	    if (stream.match(/(?:#[a-zA-Z\$][a-zA-Z0-9\$]*|#+[0-9]?)/, true, false)) {
	      return 'variable-2';
	    }
	
	    // Literals like variables, keywords, functions
	    if (stream.match(reIdInContext, true, false)) {
	      return 'keyword';
	    }
	
	    // operators. Note that operators like @@ or /; are matched separately for each symbol.
	    if (stream.match(/(?:\\|\+|\-|\*|\/|,|;|\.|:|@|~|=|>|<|&|\||_|`|'|\^|\?|!|%)/, true, false)) {
	      return 'operator';
	    }
	
	    // everything else is an error
	    stream.next(); // advance the stream.
	    return 'error';
	  }
	
	  function tokenString(stream, state) {
	    var next, end = false, escaped = false;
	    while ((next = stream.next()) != null) {
	      if (next === '"' && !escaped) {
	        end = true;
	        break;
	      }
	      escaped = !escaped && next === '\\';
	    }
	    if (end && !escaped) {
	      state.tokenize = tokenBase;
	    }
	    return 'string';
	  };
	
	  function tokenComment(stream, state) {
	    var prev, next;
	    while(state.commentLevel > 0 && (next = stream.next()) != null) {
	      if (prev === '(' && next === '*') state.commentLevel++;
	      if (prev === '*' && next === ')') state.commentLevel--;
	      prev = next;
	    }
	    if (state.commentLevel <= 0) {
	      state.tokenize = tokenBase;
	    }
	    return 'comment';
	  }
	
	  return {
	    startState: function() {return {tokenize: tokenBase, commentLevel: 0};},
	    token: function(stream, state) {
	      if (stream.eatSpace()) return null;
	      return state.tokenize(stream, state);
	    },
	    blockCommentStart: "(*",
	    blockCommentEnd: "*)"
	  };
	});
	
	CodeMirror.defineMIME('text/x-mathematica', {
	  name: 'mathematica'
	});
	
	});


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	var rfc2822 = [
	  "From", "Sender", "Reply-To", "To", "Cc", "Bcc", "Message-ID",
	  "In-Reply-To", "References", "Resent-From", "Resent-Sender", "Resent-To",
	  "Resent-Cc", "Resent-Bcc", "Resent-Message-ID", "Return-Path", "Received"
	];
	var rfc2822NoEmail = [
	  "Date", "Subject", "Comments", "Keywords", "Resent-Date"
	];
	
	CodeMirror.registerHelper("hintWords", "mbox", rfc2822.concat(rfc2822NoEmail));
	
	var whitespace = /^[ \t]/;
	var separator = /^From /; // See RFC 4155
	var rfc2822Header = new RegExp("^(" + rfc2822.join("|") + "): ");
	var rfc2822HeaderNoEmail = new RegExp("^(" + rfc2822NoEmail.join("|") + "): ");
	var header = /^[^:]+:/; // Optional fields defined in RFC 2822
	var email = /^[^ ]+@[^ ]+/;
	var untilEmail = /^.*?(?=[^ ]+?@[^ ]+)/;
	var bracketedEmail = /^<.*?>/;
	var untilBracketedEmail = /^.*?(?=<.*>)/;
	
	function styleForHeader(header) {
	  if (header === "Subject") return "header";
	  return "string";
	}
	
	function readToken(stream, state) {
	  if (stream.sol()) {
	    // From last line
	    state.inSeparator = false;
	    if (state.inHeader && stream.match(whitespace)) {
	      // Header folding
	      return null;
	    } else {
	      state.inHeader = false;
	      state.header = null;
	    }
	
	    if (stream.match(separator)) {
	      state.inHeaders = true;
	      state.inSeparator = true;
	      return "atom";
	    }
	
	    var match;
	    var emailPermitted = false;
	    if ((match = stream.match(rfc2822HeaderNoEmail)) ||
	        (emailPermitted = true) && (match = stream.match(rfc2822Header))) {
	      state.inHeaders = true;
	      state.inHeader = true;
	      state.emailPermitted = emailPermitted;
	      state.header = match[1];
	      return "atom";
	    }
	
	    // Use vim's heuristics: recognize custom headers only if the line is in a
	    // block of legitimate headers.
	    if (state.inHeaders && (match = stream.match(header))) {
	      state.inHeader = true;
	      state.emailPermitted = true;
	      state.header = match[1];
	      return "atom";
	    }
	
	    state.inHeaders = false;
	    stream.skipToEnd();
	    return null;
	  }
	
	  if (state.inSeparator) {
	    if (stream.match(email)) return "link";
	    if (stream.match(untilEmail)) return "atom";
	    stream.skipToEnd();
	    return "atom";
	  }
	
	  if (state.inHeader) {
	    var style = styleForHeader(state.header);
	
	    if (state.emailPermitted) {
	      if (stream.match(bracketedEmail)) return style + " link";
	      if (stream.match(untilBracketedEmail)) return style;
	    }
	    stream.skipToEnd();
	    return style;
	  }
	
	  stream.skipToEnd();
	  return null;
	};
	
	CodeMirror.defineMode("mbox", function() {
	  return {
	    startState: function() {
	      return {
	        // Is in a mbox separator
	        inSeparator: false,
	        // Is in a mail header
	        inHeader: false,
	        // If bracketed email is permitted. Only applicable when inHeader
	        emailPermitted: false,
	        // Name of current header
	        header: null,
	        // Is in a region of mail headers
	        inHeaders: false
	      };
	    },
	    token: readToken,
	    blankLine: function(state) {
	      state.inHeaders = state.inSeparator = state.inHeader = false;
	    }
	  };
	});
	
	CodeMirror.defineMIME("application/mbox", "mbox");
	});


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	//mIRC mode by Ford_Lawnmower :: Based on Velocity mode by Steve O'Hara
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMIME("text/mirc", "mirc");
	CodeMirror.defineMode("mirc", function() {
	  function parseWords(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	  var specials = parseWords("$! $$ $& $? $+ $abook $abs $active $activecid " +
	                            "$activewid $address $addtok $agent $agentname $agentstat $agentver " +
	                            "$alias $and $anick $ansi2mirc $aop $appactive $appstate $asc $asctime " +
	                            "$asin $atan $avoice $away $awaymsg $awaytime $banmask $base $bfind " +
	                            "$binoff $biton $bnick $bvar $bytes $calc $cb $cd $ceil $chan $chanmodes " +
	                            "$chantypes $chat $chr $cid $clevel $click $cmdbox $cmdline $cnick $color " +
	                            "$com $comcall $comchan $comerr $compact $compress $comval $cos $count " +
	                            "$cr $crc $creq $crlf $ctime $ctimer $ctrlenter $date $day $daylight " +
	                            "$dbuh $dbuw $dccignore $dccport $dde $ddename $debug $decode $decompress " +
	                            "$deltok $devent $dialog $did $didreg $didtok $didwm $disk $dlevel $dll " +
	                            "$dllcall $dname $dns $duration $ebeeps $editbox $emailaddr $encode $error " +
	                            "$eval $event $exist $feof $ferr $fgetc $file $filename $filtered $finddir " +
	                            "$finddirn $findfile $findfilen $findtok $fline $floor $fopen $fread $fserve " +
	                            "$fulladdress $fulldate $fullname $fullscreen $get $getdir $getdot $gettok $gmt " +
	                            "$group $halted $hash $height $hfind $hget $highlight $hnick $hotline " +
	                            "$hotlinepos $ial $ialchan $ibl $idle $iel $ifmatch $ignore $iif $iil " +
	                            "$inelipse $ini $inmidi $inpaste $inpoly $input $inrect $inroundrect " +
	                            "$insong $instok $int $inwave $ip $isalias $isbit $isdde $isdir $isfile " +
	                            "$isid $islower $istok $isupper $keychar $keyrpt $keyval $knick $lactive " +
	                            "$lactivecid $lactivewid $left $len $level $lf $line $lines $link $lock " +
	                            "$lock $locked $log $logstamp $logstampfmt $longfn $longip $lower $ltimer " +
	                            "$maddress $mask $matchkey $matchtok $md5 $me $menu $menubar $menucontext " +
	                            "$menutype $mid $middir $mircdir $mircexe $mircini $mklogfn $mnick $mode " +
	                            "$modefirst $modelast $modespl $mouse $msfile $network $newnick $nick $nofile " +
	                            "$nopath $noqt $not $notags $notify $null $numeric $numok $oline $onpoly " +
	                            "$opnick $or $ord $os $passivedcc $pic $play $pnick $port $portable $portfree " +
	                            "$pos $prefix $prop $protect $puttok $qt $query $rand $r $rawmsg $read $readomo " +
	                            "$readn $regex $regml $regsub $regsubex $remove $remtok $replace $replacex " +
	                            "$reptok $result $rgb $right $round $scid $scon $script $scriptdir $scriptline " +
	                            "$sdir $send $server $serverip $sfile $sha1 $shortfn $show $signal $sin " +
	                            "$site $sline $snick $snicks $snotify $sock $sockbr $sockerr $sockname " +
	                            "$sorttok $sound $sqrt $ssl $sreq $sslready $status $strip $str $stripped " +
	                            "$syle $submenu $switchbar $tan $target $ticks $time $timer $timestamp " +
	                            "$timestampfmt $timezone $tip $titlebar $toolbar $treebar $trust $ulevel " +
	                            "$ulist $upper $uptime $url $usermode $v1 $v2 $var $vcmd $vcmdstat $vcmdver " +
	                            "$version $vnick $vol $wid $width $wildsite $wildtok $window $wrap $xor");
	  var keywords = parseWords("abook ajinvite alias aline ame amsg anick aop auser autojoin avoice " +
	                            "away background ban bcopy beep bread break breplace bset btrunc bunset bwrite " +
	                            "channel clear clearall cline clipboard close cnick color comclose comopen " +
	                            "comreg continue copy creq ctcpreply ctcps dcc dccserver dde ddeserver " +
	                            "debug dec describe dialog did didtok disable disconnect dlevel dline dll " +
	                            "dns dqwindow drawcopy drawdot drawfill drawline drawpic drawrect drawreplace " +
	                            "drawrot drawsave drawscroll drawtext ebeeps echo editbox emailaddr enable " +
	                            "events exit fclose filter findtext finger firewall flash flist flood flush " +
	                            "flushini font fopen fseek fsend fserve fullname fwrite ghide gload gmove " +
	                            "gopts goto gplay gpoint gqreq groups gshow gsize gstop gtalk gunload hadd " +
	                            "halt haltdef hdec hdel help hfree hinc hload hmake hop hsave ial ialclear " +
	                            "ialmark identd if ignore iline inc invite iuser join kick linesep links list " +
	                            "load loadbuf localinfo log mdi me menubar mkdir mnick mode msg nick noop notice " +
	                            "notify omsg onotice part partall pdcc perform play playctrl pop protect pvoice " +
	                            "qme qmsg query queryn quit raw reload remini remote remove rename renwin " +
	                            "reseterror resetidle return rlevel rline rmdir run ruser save savebuf saveini " +
	                            "say scid scon server set showmirc signam sline sockaccept sockclose socklist " +
	                            "socklisten sockmark sockopen sockpause sockread sockrename sockudp sockwrite " +
	                            "sound speak splay sreq strip switchbar timer timestamp titlebar tnick tokenize " +
	                            "toolbar topic tray treebar ulist unload unset unsetall updatenl url uwho " +
	                            "var vcadd vcmd vcrem vol while whois window winhelp write writeint if isalnum " +
	                            "isalpha isaop isavoice isban ischan ishop isignore isin isincs isletter islower " +
	                            "isnotify isnum ison isop isprotect isreg isupper isvoice iswm iswmcs " +
	                            "elseif else goto menu nicklist status title icon size option text edit " +
	                            "button check radio box scroll list combo link tab item");
	  var functions = parseWords("if elseif else and not or eq ne in ni for foreach while switch");
	  var isOperatorChar = /[+\-*&%=<>!?^\/\|]/;
	  function chain(stream, state, f) {
	    state.tokenize = f;
	    return f(stream, state);
	  }
	  function tokenBase(stream, state) {
	    var beforeParams = state.beforeParams;
	    state.beforeParams = false;
	    var ch = stream.next();
	    if (/[\[\]{}\(\),\.]/.test(ch)) {
	      if (ch == "(" && beforeParams) state.inParams = true;
	      else if (ch == ")") state.inParams = false;
	      return null;
	    }
	    else if (/\d/.test(ch)) {
	      stream.eatWhile(/[\w\.]/);
	      return "number";
	    }
	    else if (ch == "\\") {
	      stream.eat("\\");
	      stream.eat(/./);
	      return "number";
	    }
	    else if (ch == "/" && stream.eat("*")) {
	      return chain(stream, state, tokenComment);
	    }
	    else if (ch == ";" && stream.match(/ *\( *\(/)) {
	      return chain(stream, state, tokenUnparsed);
	    }
	    else if (ch == ";" && !state.inParams) {
	      stream.skipToEnd();
	      return "comment";
	    }
	    else if (ch == '"') {
	      stream.eat(/"/);
	      return "keyword";
	    }
	    else if (ch == "$") {
	      stream.eatWhile(/[$_a-z0-9A-Z\.:]/);
	      if (specials && specials.propertyIsEnumerable(stream.current().toLowerCase())) {
	        return "keyword";
	      }
	      else {
	        state.beforeParams = true;
	        return "builtin";
	      }
	    }
	    else if (ch == "%") {
	      stream.eatWhile(/[^,^\s^\(^\)]/);
	      state.beforeParams = true;
	      return "string";
	    }
	    else if (isOperatorChar.test(ch)) {
	      stream.eatWhile(isOperatorChar);
	      return "operator";
	    }
	    else {
	      stream.eatWhile(/[\w\$_{}]/);
	      var word = stream.current().toLowerCase();
	      if (keywords && keywords.propertyIsEnumerable(word))
	        return "keyword";
	      if (functions && functions.propertyIsEnumerable(word)) {
	        state.beforeParams = true;
	        return "keyword";
	      }
	      return null;
	    }
	  }
	  function tokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while (ch = stream.next()) {
	      if (ch == "/" && maybeEnd) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return "comment";
	  }
	  function tokenUnparsed(stream, state) {
	    var maybeEnd = 0, ch;
	    while (ch = stream.next()) {
	      if (ch == ";" && maybeEnd == 2) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      if (ch == ")")
	        maybeEnd++;
	      else if (ch != " ")
	        maybeEnd = 0;
	    }
	    return "meta";
	  }
	  return {
	    startState: function() {
	      return {
	        tokenize: tokenBase,
	        beforeParams: false,
	        inParams: false
	      };
	    },
	    token: function(stream, state) {
	      if (stream.eatSpace()) return null;
	      return state.tokenize(stream, state);
	    }
	  };
	});
	
	});


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode('mllike', function(_config, parserConfig) {
	  var words = {
	    'let': 'keyword',
	    'rec': 'keyword',
	    'in': 'keyword',
	    'of': 'keyword',
	    'and': 'keyword',
	    'if': 'keyword',
	    'then': 'keyword',
	    'else': 'keyword',
	    'for': 'keyword',
	    'to': 'keyword',
	    'while': 'keyword',
	    'do': 'keyword',
	    'done': 'keyword',
	    'fun': 'keyword',
	    'function': 'keyword',
	    'val': 'keyword',
	    'type': 'keyword',
	    'mutable': 'keyword',
	    'match': 'keyword',
	    'with': 'keyword',
	    'try': 'keyword',
	    'open': 'builtin',
	    'ignore': 'builtin',
	    'begin': 'keyword',
	    'end': 'keyword'
	  };
	
	  var extraWords = parserConfig.extraWords || {};
	  for (var prop in extraWords) {
	    if (extraWords.hasOwnProperty(prop)) {
	      words[prop] = parserConfig.extraWords[prop];
	    }
	  }
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	
	    if (ch === '"') {
	      state.tokenize = tokenString;
	      return state.tokenize(stream, state);
	    }
	    if (ch === '(') {
	      if (stream.eat('*')) {
	        state.commentLevel++;
	        state.tokenize = tokenComment;
	        return state.tokenize(stream, state);
	      }
	    }
	    if (ch === '~') {
	      stream.eatWhile(/\w/);
	      return 'variable-2';
	    }
	    if (ch === '`') {
	      stream.eatWhile(/\w/);
	      return 'quote';
	    }
	    if (ch === '/' && parserConfig.slashComments && stream.eat('/')) {
	      stream.skipToEnd();
	      return 'comment';
	    }
	    if (/\d/.test(ch)) {
	      stream.eatWhile(/[\d]/);
	      if (stream.eat('.')) {
	        stream.eatWhile(/[\d]/);
	      }
	      return 'number';
	    }
	    if ( /[+\-*&%=<>!?|]/.test(ch)) {
	      return 'operator';
	    }
	    if (/[\w\xa1-\uffff]/.test(ch)) {
	      stream.eatWhile(/[\w\xa1-\uffff]/);
	      var cur = stream.current();
	      return words.hasOwnProperty(cur) ? words[cur] : 'variable';
	    }
	    return null
	  }
	
	  function tokenString(stream, state) {
	    var next, end = false, escaped = false;
	    while ((next = stream.next()) != null) {
	      if (next === '"' && !escaped) {
	        end = true;
	        break;
	      }
	      escaped = !escaped && next === '\\';
	    }
	    if (end && !escaped) {
	      state.tokenize = tokenBase;
	    }
	    return 'string';
	  };
	
	  function tokenComment(stream, state) {
	    var prev, next;
	    while(state.commentLevel > 0 && (next = stream.next()) != null) {
	      if (prev === '(' && next === '*') state.commentLevel++;
	      if (prev === '*' && next === ')') state.commentLevel--;
	      prev = next;
	    }
	    if (state.commentLevel <= 0) {
	      state.tokenize = tokenBase;
	    }
	    return 'comment';
	  }
	
	  return {
	    startState: function() {return {tokenize: tokenBase, commentLevel: 0};},
	    token: function(stream, state) {
	      if (stream.eatSpace()) return null;
	      return state.tokenize(stream, state);
	    },
	
	    blockCommentStart: "(*",
	    blockCommentEnd: "*)",
	    lineComment: parserConfig.slashComments ? "//" : null
	  };
	});
	
	CodeMirror.defineMIME('text/x-ocaml', {
	  name: 'mllike',
	  extraWords: {
	    'succ': 'keyword',
	    'trace': 'builtin',
	    'exit': 'builtin',
	    'print_string': 'builtin',
	    'print_endline': 'builtin',
	    'true': 'atom',
	    'false': 'atom',
	    'raise': 'keyword'
	  }
	});
	
	CodeMirror.defineMIME('text/x-fsharp', {
	  name: 'mllike',
	  extraWords: {
	    'abstract': 'keyword',
	    'as': 'keyword',
	    'assert': 'keyword',
	    'base': 'keyword',
	    'class': 'keyword',
	    'default': 'keyword',
	    'delegate': 'keyword',
	    'downcast': 'keyword',
	    'downto': 'keyword',
	    'elif': 'keyword',
	    'exception': 'keyword',
	    'extern': 'keyword',
	    'finally': 'keyword',
	    'global': 'keyword',
	    'inherit': 'keyword',
	    'inline': 'keyword',
	    'interface': 'keyword',
	    'internal': 'keyword',
	    'lazy': 'keyword',
	    'let!': 'keyword',
	    'member' : 'keyword',
	    'module': 'keyword',
	    'namespace': 'keyword',
	    'new': 'keyword',
	    'null': 'keyword',
	    'override': 'keyword',
	    'private': 'keyword',
	    'public': 'keyword',
	    'return': 'keyword',
	    'return!': 'keyword',
	    'select': 'keyword',
	    'static': 'keyword',
	    'struct': 'keyword',
	    'upcast': 'keyword',
	    'use': 'keyword',
	    'use!': 'keyword',
	    'val': 'keyword',
	    'when': 'keyword',
	    'yield': 'keyword',
	    'yield!': 'keyword',
	
	    'List': 'builtin',
	    'Seq': 'builtin',
	    'Map': 'builtin',
	    'Set': 'builtin',
	    'int': 'builtin',
	    'string': 'builtin',
	    'raise': 'builtin',
	    'failwith': 'builtin',
	    'not': 'builtin',
	    'true': 'builtin',
	    'false': 'builtin'
	  },
	  slashComments: true
	});
	
	});


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// Modelica support for CodeMirror, copyright (c) by Lennart Ochel
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})
	
	(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("modelica", function(config, parserConfig) {
	
	    var indentUnit = config.indentUnit;
	    var keywords = parserConfig.keywords || {};
	    var builtin = parserConfig.builtin || {};
	    var atoms = parserConfig.atoms || {};
	
	    var isSingleOperatorChar = /[;=\(:\),{}.*<>+\-\/^\[\]]/;
	    var isDoubleOperatorChar = /(:=|<=|>=|==|<>|\.\+|\.\-|\.\*|\.\/|\.\^)/;
	    var isDigit = /[0-9]/;
	    var isNonDigit = /[_a-zA-Z]/;
	
	    function tokenLineComment(stream, state) {
	      stream.skipToEnd();
	      state.tokenize = null;
	      return "comment";
	    }
	
	    function tokenBlockComment(stream, state) {
	      var maybeEnd = false, ch;
	      while (ch = stream.next()) {
	        if (maybeEnd && ch == "/") {
	          state.tokenize = null;
	          break;
	        }
	        maybeEnd = (ch == "*");
	      }
	      return "comment";
	    }
	
	    function tokenString(stream, state) {
	      var escaped = false, ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == '"' && !escaped) {
	          state.tokenize = null;
	          state.sol = false;
	          break;
	        }
	        escaped = !escaped && ch == "\\";
	      }
	
	      return "string";
	    }
	
	    function tokenIdent(stream, state) {
	      stream.eatWhile(isDigit);
	      while (stream.eat(isDigit) || stream.eat(isNonDigit)) { }
	
	
	      var cur = stream.current();
	
	      if(state.sol && (cur == "package" || cur == "model" || cur == "when" || cur == "connector")) state.level++;
	      else if(state.sol && cur == "end" && state.level > 0) state.level--;
	
	      state.tokenize = null;
	      state.sol = false;
	
	      if (keywords.propertyIsEnumerable(cur)) return "keyword";
	      else if (builtin.propertyIsEnumerable(cur)) return "builtin";
	      else if (atoms.propertyIsEnumerable(cur)) return "atom";
	      else return "variable";
	    }
	
	    function tokenQIdent(stream, state) {
	      while (stream.eat(/[^']/)) { }
	
	      state.tokenize = null;
	      state.sol = false;
	
	      if(stream.eat("'"))
	        return "variable";
	      else
	        return "error";
	    }
	
	    function tokenUnsignedNuber(stream, state) {
	      stream.eatWhile(isDigit);
	      if (stream.eat('.')) {
	        stream.eatWhile(isDigit);
	      }
	      if (stream.eat('e') || stream.eat('E')) {
	        if (!stream.eat('-'))
	          stream.eat('+');
	        stream.eatWhile(isDigit);
	      }
	
	      state.tokenize = null;
	      state.sol = false;
	      return "number";
	    }
	
	    // Interface
	    return {
	      startState: function() {
	        return {
	          tokenize: null,
	          level: 0,
	          sol: true
	        };
	      },
	
	      token: function(stream, state) {
	        if(state.tokenize != null) {
	          return state.tokenize(stream, state);
	        }
	
	        if(stream.sol()) {
	          state.sol = true;
	        }
	
	        // WHITESPACE
	        if(stream.eatSpace()) {
	          state.tokenize = null;
	          return null;
	        }
	
	        var ch = stream.next();
	
	        // LINECOMMENT
	        if(ch == '/' && stream.eat('/')) {
	          state.tokenize = tokenLineComment;
	        }
	        // BLOCKCOMMENT
	        else if(ch == '/' && stream.eat('*')) {
	          state.tokenize = tokenBlockComment;
	        }
	        // TWO SYMBOL TOKENS
	        else if(isDoubleOperatorChar.test(ch+stream.peek())) {
	          stream.next();
	          state.tokenize = null;
	          return "operator";
	        }
	        // SINGLE SYMBOL TOKENS
	        else if(isSingleOperatorChar.test(ch)) {
	          state.tokenize = null;
	          return "operator";
	        }
	        // IDENT
	        else if(isNonDigit.test(ch)) {
	          state.tokenize = tokenIdent;
	        }
	        // Q-IDENT
	        else if(ch == "'" && stream.peek() && stream.peek() != "'") {
	          state.tokenize = tokenQIdent;
	        }
	        // STRING
	        else if(ch == '"') {
	          state.tokenize = tokenString;
	        }
	        // UNSIGNED_NUBER
	        else if(isDigit.test(ch)) {
	          state.tokenize = tokenUnsignedNuber;
	        }
	        // ERROR
	        else {
	          state.tokenize = null;
	          return "error";
	        }
	
	        return state.tokenize(stream, state);
	      },
	
	      indent: function(state, textAfter) {
	        if (state.tokenize != null) return CodeMirror.Pass;
	
	        var level = state.level;
	        if(/(algorithm)/.test(textAfter)) level--;
	        if(/(equation)/.test(textAfter)) level--;
	        if(/(initial algorithm)/.test(textAfter)) level--;
	        if(/(initial equation)/.test(textAfter)) level--;
	        if(/(end)/.test(textAfter)) level--;
	
	        if(level > 0)
	          return indentUnit*level;
	        else
	          return 0;
	      },
	
	      blockCommentStart: "/*",
	      blockCommentEnd: "*/",
	      lineComment: "//"
	    };
	  });
	
	  function words(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i=0; i<words.length; ++i)
	      obj[words[i]] = true;
	    return obj;
	  }
	
	  var modelicaKeywords = "algorithm and annotation assert block break class connect connector constant constrainedby der discrete each else elseif elsewhen encapsulated end enumeration equation expandable extends external false final flow for function if import impure in initial inner input loop model not operator or outer output package parameter partial protected public pure record redeclare replaceable return stream then true type when while within";
	  var modelicaBuiltin = "abs acos actualStream asin atan atan2 cardinality ceil cos cosh delay div edge exp floor getInstanceName homotopy inStream integer log log10 mod pre reinit rem semiLinear sign sin sinh spatialDistribution sqrt tan tanh";
	  var modelicaAtoms = "Real Boolean Integer String";
	
	  function def(mimes, mode) {
	    if (typeof mimes == "string")
	      mimes = [mimes];
	
	    var words = [];
	
	    function add(obj) {
	      if (obj)
	        for (var prop in obj)
	          if (obj.hasOwnProperty(prop))
	            words.push(prop);
	    }
	
	    add(mode.keywords);
	    add(mode.builtin);
	    add(mode.atoms);
	
	    if (words.length) {
	      mode.helperType = mimes[0];
	      CodeMirror.registerHelper("hintWords", mimes[0], words);
	    }
	
	    for (var i=0; i<mimes.length; ++i)
	      CodeMirror.defineMIME(mimes[i], mode);
	  }
	
	  def(["text/x-modelica"], {
	    name: "modelica",
	    keywords: words(modelicaKeywords),
	    builtin: words(modelicaBuiltin),
	    atoms: words(modelicaAtoms)
	  });
	});


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// mode(s) for the sequence chart dsl's mscgen, xù and msgenny
	// For more information on mscgen, see the site of the original author:
	// http://www.mcternan.me.uk/mscgen
	//
	// This mode for mscgen and the two derivative languages were
	// originally made for use in the mscgen_js interpreter
	// (https://sverweij.github.io/mscgen_js)
	
	(function(mod) {
	  if ( true)// CommonJS
	    mod(__webpack_require__(2));
	  else if ( typeof define == "function" && define.amd)// AMD
	    define(["../../lib/codemirror"], mod);
	  else// Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  var languages = {
	    mscgen: {
	      "keywords" : ["msc"],
	      "options" : ["hscale", "width", "arcgradient", "wordwraparcs"],
	      "constants" : ["true", "false", "on", "off"],
	      "attributes" : ["label", "idurl", "id", "url", "linecolor", "linecolour", "textcolor", "textcolour", "textbgcolor", "textbgcolour", "arclinecolor", "arclinecolour", "arctextcolor", "arctextcolour", "arctextbgcolor", "arctextbgcolour", "arcskip"],
	      "brackets" : ["\\{", "\\}"], // [ and  ] are brackets too, but these get handled in with lists
	      "arcsWords" : ["note", "abox", "rbox", "box"],
	      "arcsOthers" : ["\\|\\|\\|", "\\.\\.\\.", "---", "--", "<->", "==", "<<=>>", "<=>", "\\.\\.", "<<>>", "::", "<:>", "->", "=>>", "=>", ">>", ":>", "<-", "<<=", "<=", "<<", "<:", "x-", "-x"],
	      "singlecomment" : ["//", "#"],
	      "operators" : ["="]
	    },
	    xu: {
	      "keywords" : ["msc", "xu"],
	      "options" : ["hscale", "width", "arcgradient", "wordwraparcs", "watermark"],
	      "constants" : ["true", "false", "on", "off", "auto"],
	      "attributes" : ["label", "idurl", "id", "url", "linecolor", "linecolour", "textcolor", "textcolour", "textbgcolor", "textbgcolour", "arclinecolor", "arclinecolour", "arctextcolor", "arctextcolour", "arctextbgcolor", "arctextbgcolour", "arcskip"],
	      "brackets" : ["\\{", "\\}"],  // [ and  ] are brackets too, but these get handled in with lists
	      "arcsWords" : ["note", "abox", "rbox", "box", "alt", "else", "opt", "break", "par", "seq", "strict", "neg", "critical", "ignore", "consider", "assert", "loop", "ref", "exc"],
	      "arcsOthers" : ["\\|\\|\\|", "\\.\\.\\.", "---", "--", "<->", "==", "<<=>>", "<=>", "\\.\\.", "<<>>", "::", "<:>", "->", "=>>", "=>", ">>", ":>", "<-", "<<=", "<=", "<<", "<:", "x-", "-x"],
	      "singlecomment" : ["//", "#"],
	      "operators" : ["="]
	    },
	    msgenny: {
	      "keywords" : null,
	      "options" : ["hscale", "width", "arcgradient", "wordwraparcs", "watermark"],
	      "constants" : ["true", "false", "on", "off", "auto"],
	      "attributes" : null,
	      "brackets" : ["\\{", "\\}"],
	      "arcsWords" : ["note", "abox", "rbox", "box", "alt", "else", "opt", "break", "par", "seq", "strict", "neg", "critical", "ignore", "consider", "assert", "loop", "ref", "exc"],
	      "arcsOthers" : ["\\|\\|\\|", "\\.\\.\\.", "---", "--", "<->", "==", "<<=>>", "<=>", "\\.\\.", "<<>>", "::", "<:>", "->", "=>>", "=>", ">>", ":>", "<-", "<<=", "<=", "<<", "<:", "x-", "-x"],
	      "singlecomment" : ["//", "#"],
	      "operators" : ["="]
	    }
	  }
	
	  CodeMirror.defineMode("mscgen", function(_, modeConfig) {
	    var language = languages[modeConfig && modeConfig.language || "mscgen"]
	    return {
	      startState: startStateFn,
	      copyState: copyStateFn,
	      token: produceTokenFunction(language),
	      lineComment : "#",
	      blockCommentStart : "/*",
	      blockCommentEnd : "*/"
	    };
	  });
	
	  CodeMirror.defineMIME("text/x-mscgen", "mscgen");
	  CodeMirror.defineMIME("text/x-xu", {name: "mscgen", language: "xu"});
	  CodeMirror.defineMIME("text/x-msgenny", {name: "mscgen", language: "msgenny"});
	
	  function wordRegexpBoundary(pWords) {
	    return new RegExp("\\b(" + pWords.join("|") + ")\\b", "i");
	  }
	
	  function wordRegexp(pWords) {
	    return new RegExp("(" + pWords.join("|") + ")", "i");
	  }
	
	  function startStateFn() {
	    return {
	      inComment : false,
	      inString : false,
	      inAttributeList : false,
	      inScript : false
	    };
	  }
	
	  function copyStateFn(pState) {
	    return {
	      inComment : pState.inComment,
	      inString : pState.inString,
	      inAttributeList : pState.inAttributeList,
	      inScript : pState.inScript
	    };
	  }
	
	  function produceTokenFunction(pConfig) {
	
	    return function(pStream, pState) {
	      if (pStream.match(wordRegexp(pConfig.brackets), true, true)) {
	        return "bracket";
	      }
	      /* comments */
	      if (!pState.inComment) {
	        if (pStream.match(/\/\*[^\*\/]*/, true, true)) {
	          pState.inComment = true;
	          return "comment";
	        }
	        if (pStream.match(wordRegexp(pConfig.singlecomment), true, true)) {
	          pStream.skipToEnd();
	          return "comment";
	        }
	      }
	      if (pState.inComment) {
	        if (pStream.match(/[^\*\/]*\*\//, true, true))
	          pState.inComment = false;
	        else
	          pStream.skipToEnd();
	        return "comment";
	      }
	      /* strings */
	      if (!pState.inString && pStream.match(/\"(\\\"|[^\"])*/, true, true)) {
	        pState.inString = true;
	        return "string";
	      }
	      if (pState.inString) {
	        if (pStream.match(/[^\"]*\"/, true, true))
	          pState.inString = false;
	        else
	          pStream.skipToEnd();
	        return "string";
	      }
	      /* keywords & operators */
	      if (!!pConfig.keywords && pStream.match(wordRegexpBoundary(pConfig.keywords), true, true))
	        return "keyword";
	
	      if (pStream.match(wordRegexpBoundary(pConfig.options), true, true))
	        return "keyword";
	
	      if (pStream.match(wordRegexpBoundary(pConfig.arcsWords), true, true))
	        return "keyword";
	
	      if (pStream.match(wordRegexp(pConfig.arcsOthers), true, true))
	        return "keyword";
	
	      if (!!pConfig.operators && pStream.match(wordRegexp(pConfig.operators), true, true))
	        return "operator";
	
	      if (!!pConfig.constants && pStream.match(wordRegexp(pConfig.constants), true, true))
	        return "variable";
	
	      /* attribute lists */
	      if (!pConfig.inAttributeList && !!pConfig.attributes && pStream.match(/\[/, true, true)) {
	        pConfig.inAttributeList = true;
	        return "bracket";
	      }
	      if (pConfig.inAttributeList) {
	        if (pConfig.attributes !== null && pStream.match(wordRegexpBoundary(pConfig.attributes), true, true)) {
	          return "attribute";
	        }
	        if (pStream.match(/]/, true, true)) {
	          pConfig.inAttributeList = false;
	          return "bracket";
	        }
	      }
	
	      pStream.next();
	      return "base";
	    };
	  }
	
	});


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	/*
	  This MUMPS Language script was constructed using vbscript.js as a template.
	*/
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("mumps", function() {
	    function wordRegexp(words) {
	      return new RegExp("^((" + words.join(")|(") + "))\\b", "i");
	    }
	
	    var singleOperators = new RegExp("^[\\+\\-\\*/&#!_?\\\\<>=\\'\\[\\]]");
	    var doubleOperators = new RegExp("^(('=)|(<=)|(>=)|('>)|('<)|([[)|(]])|(^$))");
	    var singleDelimiters = new RegExp("^[\\.,:]");
	    var brackets = new RegExp("[()]");
	    var identifiers = new RegExp("^[%A-Za-z][A-Za-z0-9]*");
	    var commandKeywords = ["break","close","do","else","for","goto", "halt", "hang", "if", "job","kill","lock","merge","new","open", "quit", "read", "set", "tcommit", "trollback", "tstart", "use", "view", "write", "xecute", "b","c","d","e","f","g", "h", "i", "j","k","l","m","n","o", "q", "r", "s", "tc", "tro", "ts", "u", "v", "w", "x"];
	    // The following list includes instrinsic functions _and_ special variables
	    var intrinsicFuncsWords = ["\\$ascii", "\\$char", "\\$data", "\\$ecode", "\\$estack", "\\$etrap", "\\$extract", "\\$find", "\\$fnumber", "\\$get", "\\$horolog", "\\$io", "\\$increment", "\\$job", "\\$justify", "\\$length", "\\$name", "\\$next", "\\$order", "\\$piece", "\\$qlength", "\\$qsubscript", "\\$query", "\\$quit", "\\$random", "\\$reverse", "\\$select", "\\$stack", "\\$test", "\\$text", "\\$translate", "\\$view", "\\$x", "\\$y", "\\$a", "\\$c", "\\$d", "\\$e", "\\$ec", "\\$es", "\\$et", "\\$f", "\\$fn", "\\$g", "\\$h", "\\$i", "\\$j", "\\$l", "\\$n", "\\$na", "\\$o", "\\$p", "\\$q", "\\$ql", "\\$qs", "\\$r", "\\$re", "\\$s", "\\$st", "\\$t", "\\$tr", "\\$v", "\\$z"];
	    var intrinsicFuncs = wordRegexp(intrinsicFuncsWords);
	    var command = wordRegexp(commandKeywords);
	
	    function tokenBase(stream, state) {
	      if (stream.sol()) {
	        state.label = true;
	        state.commandMode = 0;
	      }
	
	      // The <space> character has meaning in MUMPS. Ignoring consecutive
	      // spaces would interfere with interpreting whether the next non-space
	      // character belongs to the command or argument context.
	
	      // Examine each character and update a mode variable whose interpretation is:
	      //   >0 => command    0 => argument    <0 => command post-conditional
	      var ch = stream.peek();
	
	      if (ch == " " || ch == "\t") { // Pre-process <space>
	        state.label = false;
	        if (state.commandMode == 0)
	          state.commandMode = 1;
	        else if ((state.commandMode < 0) || (state.commandMode == 2))
	          state.commandMode = 0;
	      } else if ((ch != ".") && (state.commandMode > 0)) {
	        if (ch == ":")
	          state.commandMode = -1;   // SIS - Command post-conditional
	        else
	          state.commandMode = 2;
	      }
	
	      // Do not color parameter list as line tag
	      if ((ch === "(") || (ch === "\u0009"))
	        state.label = false;
	
	      // MUMPS comment starts with ";"
	      if (ch === ";") {
	        stream.skipToEnd();
	        return "comment";
	      }
	
	      // Number Literals // SIS/RLM - MUMPS permits canonic number followed by concatenate operator
	      if (stream.match(/^[-+]?\d+(\.\d+)?([eE][-+]?\d+)?/))
	        return "number";
	
	      // Handle Strings
	      if (ch == '"') {
	        if (stream.skipTo('"')) {
	          stream.next();
	          return "string";
	        } else {
	          stream.skipToEnd();
	          return "error";
	        }
	      }
	
	      // Handle operators and Delimiters
	      if (stream.match(doubleOperators) || stream.match(singleOperators))
	        return "operator";
	
	      // Prevents leading "." in DO block from falling through to error
	      if (stream.match(singleDelimiters))
	        return null;
	
	      if (brackets.test(ch)) {
	        stream.next();
	        return "bracket";
	      }
	
	      if (state.commandMode > 0 && stream.match(command))
	        return "variable-2";
	
	      if (stream.match(intrinsicFuncs))
	        return "builtin";
	
	      if (stream.match(identifiers))
	        return "variable";
	
	      // Detect dollar-sign when not a documented intrinsic function
	      // "^" may introduce a GVN or SSVN - Color same as function
	      if (ch === "$" || ch === "^") {
	        stream.next();
	        return "builtin";
	      }
	
	      // MUMPS Indirection
	      if (ch === "@") {
	        stream.next();
	        return "string-2";
	      }
	
	      if (/[\w%]/.test(ch)) {
	        stream.eatWhile(/[\w%]/);
	        return "variable";
	      }
	
	      // Handle non-detected items
	      stream.next();
	      return "error";
	    }
	
	    return {
	      startState: function() {
	        return {
	          label: false,
	          commandMode: 0
	        };
	      },
	
	      token: function(stream, state) {
	        var style = tokenBase(stream, state);
	        if (state.label) return "tag";
	        return style;
	      }
	    };
	  });
	
	  CodeMirror.defineMIME("text/x-mumps", "mumps");
	});


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("nginx", function(config) {
	
	  function words(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	
	  var keywords = words(
	    /* ngxDirectiveControl */ "break return rewrite set" +
	    /* ngxDirective */ " accept_mutex accept_mutex_delay access_log add_after_body add_before_body add_header addition_types aio alias allow ancient_browser ancient_browser_value auth_basic auth_basic_user_file auth_http auth_http_header auth_http_timeout autoindex autoindex_exact_size autoindex_localtime charset charset_types client_body_buffer_size client_body_in_file_only client_body_in_single_buffer client_body_temp_path client_body_timeout client_header_buffer_size client_header_timeout client_max_body_size connection_pool_size create_full_put_path daemon dav_access dav_methods debug_connection debug_points default_type degradation degrade deny devpoll_changes devpoll_events directio directio_alignment empty_gif env epoll_events error_log eventport_events expires fastcgi_bind fastcgi_buffer_size fastcgi_buffers fastcgi_busy_buffers_size fastcgi_cache fastcgi_cache_key fastcgi_cache_methods fastcgi_cache_min_uses fastcgi_cache_path fastcgi_cache_use_stale fastcgi_cache_valid fastcgi_catch_stderr fastcgi_connect_timeout fastcgi_hide_header fastcgi_ignore_client_abort fastcgi_ignore_headers fastcgi_index fastcgi_intercept_errors fastcgi_max_temp_file_size fastcgi_next_upstream fastcgi_param fastcgi_pass_header fastcgi_pass_request_body fastcgi_pass_request_headers fastcgi_read_timeout fastcgi_send_lowat fastcgi_send_timeout fastcgi_split_path_info fastcgi_store fastcgi_store_access fastcgi_temp_file_write_size fastcgi_temp_path fastcgi_upstream_fail_timeout fastcgi_upstream_max_fails flv geoip_city geoip_country google_perftools_profiles gzip gzip_buffers gzip_comp_level gzip_disable gzip_hash gzip_http_version gzip_min_length gzip_no_buffer gzip_proxied gzip_static gzip_types gzip_vary gzip_window if_modified_since ignore_invalid_headers image_filter image_filter_buffer image_filter_jpeg_quality image_filter_transparency imap_auth imap_capabilities imap_client_buffer index ip_hash keepalive_requests keepalive_timeout kqueue_changes kqueue_events large_client_header_buffers limit_conn limit_conn_log_level limit_rate limit_rate_after limit_req limit_req_log_level limit_req_zone limit_zone lingering_time lingering_timeout lock_file log_format log_not_found log_subrequest map_hash_bucket_size map_hash_max_size master_process memcached_bind memcached_buffer_size memcached_connect_timeout memcached_next_upstream memcached_read_timeout memcached_send_timeout memcached_upstream_fail_timeout memcached_upstream_max_fails merge_slashes min_delete_depth modern_browser modern_browser_value msie_padding msie_refresh multi_accept open_file_cache open_file_cache_errors open_file_cache_events open_file_cache_min_uses open_file_cache_valid open_log_file_cache output_buffers override_charset perl perl_modules perl_require perl_set pid pop3_auth pop3_capabilities port_in_redirect postpone_gzipping postpone_output protocol proxy proxy_bind proxy_buffer proxy_buffer_size proxy_buffering proxy_buffers proxy_busy_buffers_size proxy_cache proxy_cache_key proxy_cache_methods proxy_cache_min_uses proxy_cache_path proxy_cache_use_stale proxy_cache_valid proxy_connect_timeout proxy_headers_hash_bucket_size proxy_headers_hash_max_size proxy_hide_header proxy_ignore_client_abort proxy_ignore_headers proxy_intercept_errors proxy_max_temp_file_size proxy_method proxy_next_upstream proxy_pass_error_message proxy_pass_header proxy_pass_request_body proxy_pass_request_headers proxy_read_timeout proxy_redirect proxy_send_lowat proxy_send_timeout proxy_set_body proxy_set_header proxy_ssl_session_reuse proxy_store proxy_store_access proxy_temp_file_write_size proxy_temp_path proxy_timeout proxy_upstream_fail_timeout proxy_upstream_max_fails random_index read_ahead real_ip_header recursive_error_pages request_pool_size reset_timedout_connection resolver resolver_timeout rewrite_log rtsig_overflow_events rtsig_overflow_test rtsig_overflow_threshold rtsig_signo satisfy secure_link_secret send_lowat send_timeout sendfile sendfile_max_chunk server_name_in_redirect server_names_hash_bucket_size server_names_hash_max_size server_tokens set_real_ip_from smtp_auth smtp_capabilities smtp_client_buffer smtp_greeting_delay so_keepalive source_charset ssi ssi_ignore_recycled_buffers ssi_min_file_chunk ssi_silent_errors ssi_types ssi_value_length ssl ssl_certificate ssl_certificate_key ssl_ciphers ssl_client_certificate ssl_crl ssl_dhparam ssl_engine ssl_prefer_server_ciphers ssl_protocols ssl_session_cache ssl_session_timeout ssl_verify_client ssl_verify_depth starttls stub_status sub_filter sub_filter_once sub_filter_types tcp_nodelay tcp_nopush thread_stack_size timeout timer_resolution types_hash_bucket_size types_hash_max_size underscores_in_headers uninitialized_variable_warn use user userid userid_domain userid_expires userid_mark userid_name userid_p3p userid_path userid_service valid_referers variables_hash_bucket_size variables_hash_max_size worker_connections worker_cpu_affinity worker_priority worker_processes worker_rlimit_core worker_rlimit_nofile worker_rlimit_sigpending worker_threads working_directory xclient xml_entities xslt_stylesheet xslt_typesdrew@li229-23"
	    );
	
	  var keywords_block = words(
	    /* ngxDirectiveBlock */ "http mail events server types location upstream charset_map limit_except if geo map"
	    );
	
	  var keywords_important = words(
	    /* ngxDirectiveImportant */ "include root server server_name listen internal proxy_pass memcached_pass fastcgi_pass try_files"
	    );
	
	  var indentUnit = config.indentUnit, type;
	  function ret(style, tp) {type = tp; return style;}
	
	  function tokenBase(stream, state) {
	
	
	    stream.eatWhile(/[\w\$_]/);
	
	    var cur = stream.current();
	
	
	    if (keywords.propertyIsEnumerable(cur)) {
	      return "keyword";
	    }
	    else if (keywords_block.propertyIsEnumerable(cur)) {
	      return "variable-2";
	    }
	    else if (keywords_important.propertyIsEnumerable(cur)) {
	      return "string-2";
	    }
	    /**/
	
	    var ch = stream.next();
	    if (ch == "@") {stream.eatWhile(/[\w\\\-]/); return ret("meta", stream.current());}
	    else if (ch == "/" && stream.eat("*")) {
	      state.tokenize = tokenCComment;
	      return tokenCComment(stream, state);
	    }
	    else if (ch == "<" && stream.eat("!")) {
	      state.tokenize = tokenSGMLComment;
	      return tokenSGMLComment(stream, state);
	    }
	    else if (ch == "=") ret(null, "compare");
	    else if ((ch == "~" || ch == "|") && stream.eat("=")) return ret(null, "compare");
	    else if (ch == "\"" || ch == "'") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    }
	    else if (ch == "#") {
	      stream.skipToEnd();
	      return ret("comment", "comment");
	    }
	    else if (ch == "!") {
	      stream.match(/^\s*\w*/);
	      return ret("keyword", "important");
	    }
	    else if (/\d/.test(ch)) {
	      stream.eatWhile(/[\w.%]/);
	      return ret("number", "unit");
	    }
	    else if (/[,.+>*\/]/.test(ch)) {
	      return ret(null, "select-op");
	    }
	    else if (/[;{}:\[\]]/.test(ch)) {
	      return ret(null, ch);
	    }
	    else {
	      stream.eatWhile(/[\w\\\-]/);
	      return ret("variable", "variable");
	    }
	  }
	
	  function tokenCComment(stream, state) {
	    var maybeEnd = false, ch;
	    while ((ch = stream.next()) != null) {
	      if (maybeEnd && ch == "/") {
	        state.tokenize = tokenBase;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return ret("comment", "comment");
	  }
	
	  function tokenSGMLComment(stream, state) {
	    var dashes = 0, ch;
	    while ((ch = stream.next()) != null) {
	      if (dashes >= 2 && ch == ">") {
	        state.tokenize = tokenBase;
	        break;
	      }
	      dashes = (ch == "-") ? dashes + 1 : 0;
	    }
	    return ret("comment", "comment");
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == quote && !escaped)
	          break;
	        escaped = !escaped && ch == "\\";
	      }
	      if (!escaped) state.tokenize = tokenBase;
	      return ret("string", "string");
	    };
	  }
	
	  return {
	    startState: function(base) {
	      return {tokenize: tokenBase,
	              baseIndent: base || 0,
	              stack: []};
	    },
	
	    token: function(stream, state) {
	      if (stream.eatSpace()) return null;
	      type = null;
	      var style = state.tokenize(stream, state);
	
	      var context = state.stack[state.stack.length-1];
	      if (type == "hash" && context == "rule") style = "atom";
	      else if (style == "variable") {
	        if (context == "rule") style = "number";
	        else if (!context || context == "@media{") style = "tag";
	      }
	
	      if (context == "rule" && /^[\{\};]$/.test(type))
	        state.stack.pop();
	      if (type == "{") {
	        if (context == "@media") state.stack[state.stack.length-1] = "@media{";
	        else state.stack.push("{");
	      }
	      else if (type == "}") state.stack.pop();
	      else if (type == "@media") state.stack.push("@media");
	      else if (context == "{" && type != "comment") state.stack.push("rule");
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      var n = state.stack.length;
	      if (/^\}/.test(textAfter))
	        n -= state.stack[state.stack.length-1] == "rule" ? 2 : 1;
	      return state.baseIndent + n * indentUnit;
	    },
	
	    electricChars: "}"
	  };
	});
	
	CodeMirror.defineMIME("text/x-nginx-conf", "nginx");
	
	});


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// Author: Jan T. Sott (http://github.com/idleberg)
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(20));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../../addon/mode/simple"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineSimpleMode("nsis",{
	  start:[
	    // Numbers
	    {regex: /(?:[+-]?)(?:0x[\d,a-f]+)|(?:0o[0-7]+)|(?:0b[0,1]+)|(?:\d+.?\d*)/, token: "number"},
	
	    // Strings
	    { regex: /"(?:[^\\"]|\\.)*"?/, token: "string" },
	    { regex: /'(?:[^\\']|\\.)*'?/, token: "string" },
	    { regex: /`(?:[^\\`]|\\.)*`?/, token: "string" },
	
	    // Compile Time Commands
	    {regex: /^\s*(?:\!(include|addincludedir|addplugindir|appendfile|cd|delfile|echo|error|execute|packhdr|finalize|getdllversion|system|tempfile|warning|verbose|define|undef|insertmacro|makensis|searchparse|searchreplace))\b/, token: "keyword"},
	
	    // Conditional Compilation
	    {regex: /^\s*(?:\!(if(?:n?def)?|ifmacron?def|macro))\b/, token: "keyword", indent: true},
	    {regex: /^\s*(?:\!(else|endif|macroend))\b/, token: "keyword", dedent: true},
	
	    // Runtime Commands
	    {regex: /^\s*(?:Abort|AddBrandingImage|AddSize|AllowRootDirInstall|AllowSkipFiles|AutoCloseWindow|BGFont|BGGradient|BrandingText|BringToFront|Call|CallInstDLL|Caption|ChangeUI|CheckBitmap|ClearErrors|CompletedText|ComponentText|CopyFiles|CRCCheck|CreateDirectory|CreateFont|CreateShortCut|Delete|DeleteINISec|DeleteINIStr|DeleteRegKey|DeleteRegValue|DetailPrint|DetailsButtonText|DirText|DirVar|DirVerify|EnableWindow|EnumRegKey|EnumRegValue|Exch|Exec|ExecShell|ExecWait|ExpandEnvStrings|File|FileBufSize|FileClose|FileErrorText|FileOpen|FileRead|FileReadByte|FileReadUTF16LE|FileReadWord|FileWriteUTF16LE|FileSeek|FileWrite|FileWriteByte|FileWriteWord|FindClose|FindFirst|FindNext|FindWindow|FlushINI|GetCurInstType|GetCurrentAddress|GetDlgItem|GetDLLVersion|GetDLLVersionLocal|GetErrorLevel|GetFileTime|GetFileTimeLocal|GetFullPathName|GetFunctionAddress|GetInstDirError|GetLabelAddress|GetTempFileName|Goto|HideWindow|Icon|IfAbort|IfErrors|IfFileExists|IfRebootFlag|IfSilent|InitPluginsDir|InstallButtonText|InstallColors|InstallDir|InstallDirRegKey|InstProgressFlags|InstType|InstTypeGetText|InstTypeSetText|IntCmp|IntCmpU|IntFmt|IntOp|IsWindow|LangString|LicenseBkColor|LicenseData|LicenseForceSelection|LicenseLangString|LicenseText|LoadLanguageFile|LockWindow|LogSet|LogText|ManifestDPIAware|ManifestSupportedOS|MessageBox|MiscButtonText|Name|Nop|OutFile|Page|PageCallbacks|Pop|Push|Quit|ReadEnvStr|ReadINIStr|ReadRegDWORD|ReadRegStr|Reboot|RegDLL|Rename|RequestExecutionLevel|ReserveFile|Return|RMDir|SearchPath|SectionGetFlags|SectionGetInstTypes|SectionGetSize|SectionGetText|SectionIn|SectionSetFlags|SectionSetInstTypes|SectionSetSize|SectionSetText|SendMessage|SetAutoClose|SetBrandingImage|SetCompress|SetCompressor|SetCompressorDictSize|SetCtlColors|SetCurInstType|SetDatablockOptimize|SetDateSave|SetDetailsPrint|SetDetailsView|SetErrorLevel|SetErrors|SetFileAttributes|SetFont|SetOutPath|SetOverwrite|SetRebootFlag|SetRegView|SetShellVarContext|SetSilent|ShowInstDetails|ShowUninstDetails|ShowWindow|SilentInstall|SilentUnInstall|Sleep|SpaceTexts|StrCmp|StrCmpS|StrCpy|StrLen|SubCaption|Unicode|UninstallButtonText|UninstallCaption|UninstallIcon|UninstallSubCaption|UninstallText|UninstPage|UnRegDLL|Var|VIAddVersionKey|VIFileVersion|VIProductVersion|WindowIcon|WriteINIStr|WriteRegBin|WriteRegDWORD|WriteRegExpandStr|WriteRegStr|WriteUninstaller|XPStyle)\b/, token: "keyword"},
	    {regex: /^\s*(?:Function|PageEx|Section(?:Group)?)\b/, token: "keyword", indent: true},
	    {regex: /^\s*(?:(Function|PageEx|Section(?:Group)?)End)\b/, token: "keyword", dedent: true},
	
	    // Command Options
	    {regex: /\b(?:ARCHIVE|FILE_ATTRIBUTE_ARCHIVE|FILE_ATTRIBUTE_HIDDEN|FILE_ATTRIBUTE_NORMAL|FILE_ATTRIBUTE_OFFLINE|FILE_ATTRIBUTE_READONLY|FILE_ATTRIBUTE_SYSTEM|FILE_ATTRIBUTE_TEMPORARY|HIDDEN|HKCC|HKCR|HKCU|HKDD|HKEY_CLASSES_ROOT|HKEY_CURRENT_CONFIG|HKEY_CURRENT_USER|HKEY_DYN_DATA|HKEY_LOCAL_MACHINE|HKEY_PERFORMANCE_DATA|HKEY_USERS|HKLM|HKPD|HKU|IDABORT|IDCANCEL|IDD_DIR|IDD_INST|IDD_INSTFILES|IDD_LICENSE|IDD_SELCOM|IDD_UNINST|IDD_VERIFY|IDIGNORE|IDNO|IDOK|IDRETRY|IDYES|MB_ABORTRETRYIGNORE|MB_DEFBUTTON1|MB_DEFBUTTON2|MB_DEFBUTTON3|MB_DEFBUTTON4|MB_ICONEXCLAMATION|MB_ICONINFORMATION|MB_ICONQUESTION|MB_ICONSTOP|MB_OK|MB_OKCANCEL|MB_RETRYCANCEL|MB_RIGHT|MB_RTLREADING|MB_SETFOREGROUND|MB_TOPMOST|MB_USERICON|MB_YESNO|MB_YESNOCANCEL|NORMAL|OFFLINE|READONLY|SHCTX|SHELL_CONTEXT|SW_HIDE|SW_SHOWDEFAULT|SW_SHOWMAXIMIZED|SW_SHOWMINIMIZED|SW_SHOWNORMAL|SYSTEM|TEMPORARY)\b/, token: "atom"},
	    {regex: /\b(?:admin|all|auto|both|bottom|bzip2|components|current|custom|directory|force|hide|highest|ifdiff|ifnewer|instfiles|lastused|leave|left|license|listonly|lzma|nevershow|none|normal|notset|right|show|silent|silentlog|textonly|top|try|un\.components|un\.custom|un\.directory|un\.instfiles|un\.license|uninstConfirm|user|Win10|Win7|Win8|WinVista|zlib)\b/, token: "builtin"},
	
	    // LogicLib.nsh
	    {regex: /\$\{(?:And(?:If(?:Not)?|Unless)|Break|Case(?:Else)?|Continue|Default|Do(?:Until|While)?|Else(?:If(?:Not)?|Unless)?|End(?:If|Select|Switch)|Exit(?:Do|For|While)|For(?:Each)?|If(?:Cmd|Not(?:Then)?|Then)?|Loop(?:Until|While)?|Or(?:If(?:Not)?|Unless)|Select|Switch|Unless|While)\}/, token: "variable-2", indent: true},
	
	    // FileFunc.nsh
	    {regex: /\$\{(?:BannerTrimPath|DirState|DriveSpace|Get(BaseName|Drives|ExeName|ExePath|FileAttributes|FileExt|FileName|FileVersion|Options|OptionsS|Parameters|Parent|Root|Size|Time)|Locate|RefreshShellIcons)\}/, token: "variable-2", dedent: true},
	
	    // Memento.nsh
	    {regex: /\$\{(?:Memento(?:Section(?:Done|End|Restore|Save)?|UnselectedSection))\}/, token: "variable-2", dedent: true},
	
	    // TextFunc.nsh
	    {regex: /\$\{(?:Config(?:Read|ReadS|Write|WriteS)|File(?:Join|ReadFromEnd|Recode)|Line(?:Find|Read|Sum)|Text(?:Compare|CompareS)|TrimNewLines)\}/, token: "variable-2", dedent: true},
	
	    // WinVer.nsh
	    {regex: /\$\{(?:(?:At(?:Least|Most)|Is)(?:ServicePack|Win(?:7|8|10|95|98|200(?:0|3|8(?:R2)?)|ME|NT4|Vista|XP))|Is(?:NT|Server))\}/, token: "variable", dedent: true},
	
	    // WordFunc.nsh
	    {regex: /\$\{(?:StrFilterS?|Version(?:Compare|Convert)|Word(?:AddS?|Find(?:(?:2|3)X)?S?|InsertS?|ReplaceS?))\}/, token: "variable-2", dedent: true},
	
	    // x64.nsh
	    {regex: /\$\{(?:RunningX64)\}/, token: "variable", dedent: true},
	    {regex: /\$\{(?:Disable|Enable)X64FSRedirection\}/, token: "variable-2", dedent: true},
	
	    // Line Comment
	    {regex: /(#|;).*/, token: "comment"},
	
	    // Block Comment
	    {regex: /\/\*/, token: "comment", next: "comment"},
	
	    // Operator
	    {regex: /[-+\/*=<>!]+/, token: "operator"},
	
	    // Variable
	    {regex: /\$\w+/, token: "variable"},
	
	    // Constant
	    {regex: /\${[\w\.:-]+}/, token: "variable-2"},
	
	    // Language String
	    {regex: /\$\([\w\.:-]+\)/, token: "variable-3"}
	  ],
	  comment: [
	    {regex: /.*?\*\//, token: "comment", next: "start"},
	    {regex: /.*/, token: "comment"}
	  ],
	  meta: {
	    electricInput: /^\s*((Function|PageEx|Section|Section(Group)?)End|(\!(endif|macroend))|\$\{(End(If|Unless|While)|Loop(Until)|Next)\})$/,
	    blockCommentStart: "/*",
	    blockCommentEnd: "*/",
	    lineComment: ["#", ";"]
	  }
	});
	
	CodeMirror.defineMIME("text/x-nsis", "nsis");
	});


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	/**********************************************************
	* This script provides syntax highlighting support for
	* the Ntriples format.
	* Ntriples format specification:
	*     http://www.w3.org/TR/rdf-testcases/#ntriples
	***********************************************************/
	
	/*
	    The following expression defines the defined ASF grammar transitions.
	
	    pre_subject ->
	        {
	        ( writing_subject_uri | writing_bnode_uri )
	            -> pre_predicate
	                -> writing_predicate_uri
	                    -> pre_object
	                        -> writing_object_uri | writing_object_bnode |
	                          (
	                            writing_object_literal
	                                -> writing_literal_lang | writing_literal_type
	                          )
	                            -> post_object
	                                -> BEGIN
	         } otherwise {
	             -> ERROR
	         }
	*/
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("ntriples", function() {
	
	  var Location = {
	    PRE_SUBJECT         : 0,
	    WRITING_SUB_URI     : 1,
	    WRITING_BNODE_URI   : 2,
	    PRE_PRED            : 3,
	    WRITING_PRED_URI    : 4,
	    PRE_OBJ             : 5,
	    WRITING_OBJ_URI     : 6,
	    WRITING_OBJ_BNODE   : 7,
	    WRITING_OBJ_LITERAL : 8,
	    WRITING_LIT_LANG    : 9,
	    WRITING_LIT_TYPE    : 10,
	    POST_OBJ            : 11,
	    ERROR               : 12
	  };
	  function transitState(currState, c) {
	    var currLocation = currState.location;
	    var ret;
	
	    // Opening.
	    if     (currLocation == Location.PRE_SUBJECT && c == '<') ret = Location.WRITING_SUB_URI;
	    else if(currLocation == Location.PRE_SUBJECT && c == '_') ret = Location.WRITING_BNODE_URI;
	    else if(currLocation == Location.PRE_PRED    && c == '<') ret = Location.WRITING_PRED_URI;
	    else if(currLocation == Location.PRE_OBJ     && c == '<') ret = Location.WRITING_OBJ_URI;
	    else if(currLocation == Location.PRE_OBJ     && c == '_') ret = Location.WRITING_OBJ_BNODE;
	    else if(currLocation == Location.PRE_OBJ     && c == '"') ret = Location.WRITING_OBJ_LITERAL;
	
	    // Closing.
	    else if(currLocation == Location.WRITING_SUB_URI     && c == '>') ret = Location.PRE_PRED;
	    else if(currLocation == Location.WRITING_BNODE_URI   && c == ' ') ret = Location.PRE_PRED;
	    else if(currLocation == Location.WRITING_PRED_URI    && c == '>') ret = Location.PRE_OBJ;
	    else if(currLocation == Location.WRITING_OBJ_URI     && c == '>') ret = Location.POST_OBJ;
	    else if(currLocation == Location.WRITING_OBJ_BNODE   && c == ' ') ret = Location.POST_OBJ;
	    else if(currLocation == Location.WRITING_OBJ_LITERAL && c == '"') ret = Location.POST_OBJ;
	    else if(currLocation == Location.WRITING_LIT_LANG && c == ' ') ret = Location.POST_OBJ;
	    else if(currLocation == Location.WRITING_LIT_TYPE && c == '>') ret = Location.POST_OBJ;
	
	    // Closing typed and language literal.
	    else if(currLocation == Location.WRITING_OBJ_LITERAL && c == '@') ret = Location.WRITING_LIT_LANG;
	    else if(currLocation == Location.WRITING_OBJ_LITERAL && c == '^') ret = Location.WRITING_LIT_TYPE;
	
	    // Spaces.
	    else if( c == ' ' &&
	             (
	               currLocation == Location.PRE_SUBJECT ||
	               currLocation == Location.PRE_PRED    ||
	               currLocation == Location.PRE_OBJ     ||
	               currLocation == Location.POST_OBJ
	             )
	           ) ret = currLocation;
	
	    // Reset.
	    else if(currLocation == Location.POST_OBJ && c == '.') ret = Location.PRE_SUBJECT;
	
	    // Error
	    else ret = Location.ERROR;
	
	    currState.location=ret;
	  }
	
	  return {
	    startState: function() {
	       return {
	           location : Location.PRE_SUBJECT,
	           uris     : [],
	           anchors  : [],
	           bnodes   : [],
	           langs    : [],
	           types    : []
	       };
	    },
	    token: function(stream, state) {
	      var ch = stream.next();
	      if(ch == '<') {
	         transitState(state, ch);
	         var parsedURI = '';
	         stream.eatWhile( function(c) { if( c != '#' && c != '>' ) { parsedURI += c; return true; } return false;} );
	         state.uris.push(parsedURI);
	         if( stream.match('#', false) ) return 'variable';
	         stream.next();
	         transitState(state, '>');
	         return 'variable';
	      }
	      if(ch == '#') {
	        var parsedAnchor = '';
	        stream.eatWhile(function(c) { if(c != '>' && c != ' ') { parsedAnchor+= c; return true; } return false;});
	        state.anchors.push(parsedAnchor);
	        return 'variable-2';
	      }
	      if(ch == '>') {
	          transitState(state, '>');
	          return 'variable';
	      }
	      if(ch == '_') {
	          transitState(state, ch);
	          var parsedBNode = '';
	          stream.eatWhile(function(c) { if( c != ' ' ) { parsedBNode += c; return true; } return false;});
	          state.bnodes.push(parsedBNode);
	          stream.next();
	          transitState(state, ' ');
	          return 'builtin';
	      }
	      if(ch == '"') {
	          transitState(state, ch);
	          stream.eatWhile( function(c) { return c != '"'; } );
	          stream.next();
	          if( stream.peek() != '@' && stream.peek() != '^' ) {
	              transitState(state, '"');
	          }
	          return 'string';
	      }
	      if( ch == '@' ) {
	          transitState(state, '@');
	          var parsedLang = '';
	          stream.eatWhile(function(c) { if( c != ' ' ) { parsedLang += c; return true; } return false;});
	          state.langs.push(parsedLang);
	          stream.next();
	          transitState(state, ' ');
	          return 'string-2';
	      }
	      if( ch == '^' ) {
	          stream.next();
	          transitState(state, '^');
	          var parsedType = '';
	          stream.eatWhile(function(c) { if( c != '>' ) { parsedType += c; return true; } return false;} );
	          state.types.push(parsedType);
	          stream.next();
	          transitState(state, '>');
	          return 'variable';
	      }
	      if( ch == ' ' ) {
	          transitState(state, ch);
	      }
	      if( ch == '.' ) {
	          transitState(state, ch);
	      }
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/n-triples", "ntriples");
	
	});


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("octave", function() {
	  function wordRegexp(words) {
	    return new RegExp("^((" + words.join(")|(") + "))\\b");
	  }
	
	  var singleOperators = new RegExp("^[\\+\\-\\*/&|\\^~<>!@'\\\\]");
	  var singleDelimiters = new RegExp('^[\\(\\[\\{\\},:=;]');
	  var doubleOperators = new RegExp("^((==)|(~=)|(<=)|(>=)|(<<)|(>>)|(\\.[\\+\\-\\*/\\^\\\\]))");
	  var doubleDelimiters = new RegExp("^((!=)|(\\+=)|(\\-=)|(\\*=)|(/=)|(&=)|(\\|=)|(\\^=))");
	  var tripleDelimiters = new RegExp("^((>>=)|(<<=))");
	  var expressionEnd = new RegExp("^[\\]\\)]");
	  var identifiers = new RegExp("^[_A-Za-z\xa1-\uffff][_A-Za-z0-9\xa1-\uffff]*");
	
	  var builtins = wordRegexp([
	    'error', 'eval', 'function', 'abs', 'acos', 'atan', 'asin', 'cos',
	    'cosh', 'exp', 'log', 'prod', 'sum', 'log10', 'max', 'min', 'sign', 'sin', 'sinh',
	    'sqrt', 'tan', 'reshape', 'break', 'zeros', 'default', 'margin', 'round', 'ones',
	    'rand', 'syn', 'ceil', 'floor', 'size', 'clear', 'zeros', 'eye', 'mean', 'std', 'cov',
	    'det', 'eig', 'inv', 'norm', 'rank', 'trace', 'expm', 'logm', 'sqrtm', 'linspace', 'plot',
	    'title', 'xlabel', 'ylabel', 'legend', 'text', 'grid', 'meshgrid', 'mesh', 'num2str',
	    'fft', 'ifft', 'arrayfun', 'cellfun', 'input', 'fliplr', 'flipud', 'ismember'
	  ]);
	
	  var keywords = wordRegexp([
	    'return', 'case', 'switch', 'else', 'elseif', 'end', 'endif', 'endfunction',
	    'if', 'otherwise', 'do', 'for', 'while', 'try', 'catch', 'classdef', 'properties', 'events',
	    'methods', 'global', 'persistent', 'endfor', 'endwhile', 'printf', 'sprintf', 'disp', 'until',
	    'continue', 'pkg'
	  ]);
	
	
	  // tokenizers
	  function tokenTranspose(stream, state) {
	    if (!stream.sol() && stream.peek() === '\'') {
	      stream.next();
	      state.tokenize = tokenBase;
	      return 'operator';
	    }
	    state.tokenize = tokenBase;
	    return tokenBase(stream, state);
	  }
	
	
	  function tokenComment(stream, state) {
	    if (stream.match(/^.*%}/)) {
	      state.tokenize = tokenBase;
	      return 'comment';
	    };
	    stream.skipToEnd();
	    return 'comment';
	  }
	
	  function tokenBase(stream, state) {
	    // whitespaces
	    if (stream.eatSpace()) return null;
	
	    // Handle one line Comments
	    if (stream.match('%{')){
	      state.tokenize = tokenComment;
	      stream.skipToEnd();
	      return 'comment';
	    }
	
	    if (stream.match(/^[%#]/)){
	      stream.skipToEnd();
	      return 'comment';
	    }
	
	    // Handle Number Literals
	    if (stream.match(/^[0-9\.+-]/, false)) {
	      if (stream.match(/^[+-]?0x[0-9a-fA-F]+[ij]?/)) {
	        stream.tokenize = tokenBase;
	        return 'number'; };
	      if (stream.match(/^[+-]?\d*\.\d+([EeDd][+-]?\d+)?[ij]?/)) { return 'number'; };
	      if (stream.match(/^[+-]?\d+([EeDd][+-]?\d+)?[ij]?/)) { return 'number'; };
	    }
	    if (stream.match(wordRegexp(['nan','NaN','inf','Inf']))) { return 'number'; };
	
	    // Handle Strings
	    if (stream.match(/^"([^"]|(""))*"/)) { return 'string'; } ;
	    if (stream.match(/^'([^']|(''))*'/)) { return 'string'; } ;
	
	    // Handle words
	    if (stream.match(keywords)) { return 'keyword'; } ;
	    if (stream.match(builtins)) { return 'builtin'; } ;
	    if (stream.match(identifiers)) { return 'variable'; } ;
	
	    if (stream.match(singleOperators) || stream.match(doubleOperators)) { return 'operator'; };
	    if (stream.match(singleDelimiters) || stream.match(doubleDelimiters) || stream.match(tripleDelimiters)) { return null; };
	
	    if (stream.match(expressionEnd)) {
	      state.tokenize = tokenTranspose;
	      return null;
	    };
	
	
	    // Handle non-detected items
	    stream.next();
	    return 'error';
	  };
	
	
	  return {
	    startState: function() {
	      return {
	        tokenize: tokenBase
	      };
	    },
	
	    token: function(stream, state) {
	      var style = state.tokenize(stream, state);
	      if (style === 'number' || style === 'variable'){
	        state.tokenize = tokenTranspose;
	      }
	      return style;
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/x-octave", "octave");
	
	});


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("oz", function (conf) {
	
	  function wordRegexp(words) {
	    return new RegExp("^((" + words.join(")|(") + "))\\b");
	  }
	
	  var singleOperators = /[\^@!\|<>#~\.\*\-\+\\/,=]/;
	  var doubleOperators = /(<-)|(:=)|(=<)|(>=)|(<=)|(<:)|(>:)|(=:)|(\\=)|(\\=:)|(!!)|(==)|(::)/;
	  var tripleOperators = /(:::)|(\.\.\.)|(=<:)|(>=:)/;
	
	  var middle = ["in", "then", "else", "of", "elseof", "elsecase", "elseif", "catch",
	    "finally", "with", "require", "prepare", "import", "export", "define", "do"];
	  var end = ["end"];
	
	  var atoms = wordRegexp(["true", "false", "nil", "unit"]);
	  var commonKeywords = wordRegexp(["andthen", "at", "attr", "declare", "feat", "from", "lex",
	    "mod", "mode", "orelse", "parser", "prod", "prop", "scanner", "self", "syn", "token"]);
	  var openingKeywords = wordRegexp(["local", "proc", "fun", "case", "class", "if", "cond", "or", "dis",
	    "choice", "not", "thread", "try", "raise", "lock", "for", "suchthat", "meth", "functor"]);
	  var middleKeywords = wordRegexp(middle);
	  var endKeywords = wordRegexp(end);
	
	  // Tokenizers
	  function tokenBase(stream, state) {
	    if (stream.eatSpace()) {
	      return null;
	    }
	
	    // Brackets
	    if(stream.match(/[{}]/)) {
	      return "bracket";
	    }
	
	    // Special [] keyword
	    if (stream.match(/(\[])/)) {
	        return "keyword"
	    }
	
	    // Operators
	    if (stream.match(tripleOperators) || stream.match(doubleOperators)) {
	      return "operator";
	    }
	
	    // Atoms
	    if(stream.match(atoms)) {
	      return 'atom';
	    }
	
	    // Opening keywords
	    var matched = stream.match(openingKeywords);
	    if (matched) {
	      if (!state.doInCurrentLine)
	        state.currentIndent++;
	      else
	        state.doInCurrentLine = false;
	
	      // Special matching for signatures
	      if(matched[0] == "proc" || matched[0] == "fun")
	        state.tokenize = tokenFunProc;
	      else if(matched[0] == "class")
	        state.tokenize = tokenClass;
	      else if(matched[0] == "meth")
	        state.tokenize = tokenMeth;
	
	      return 'keyword';
	    }
	
	    // Middle and other keywords
	    if (stream.match(middleKeywords) || stream.match(commonKeywords)) {
	      return "keyword"
	    }
	
	    // End keywords
	    if (stream.match(endKeywords)) {
	      state.currentIndent--;
	      return 'keyword';
	    }
	
	    // Eat the next char for next comparisons
	    var ch = stream.next();
	
	    // Strings
	    if (ch == '"' || ch == "'") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    }
	
	    // Numbers
	    if (/[~\d]/.test(ch)) {
	      if (ch == "~") {
	        if(! /^[0-9]/.test(stream.peek()))
	          return null;
	        else if (( stream.next() == "0" && stream.match(/^[xX][0-9a-fA-F]+/)) || stream.match(/^[0-9]*(\.[0-9]+)?([eE][~+]?[0-9]+)?/))
	          return "number";
	      }
	
	      if ((ch == "0" && stream.match(/^[xX][0-9a-fA-F]+/)) || stream.match(/^[0-9]*(\.[0-9]+)?([eE][~+]?[0-9]+)?/))
	        return "number";
	
	      return null;
	    }
	
	    // Comments
	    if (ch == "%") {
	      stream.skipToEnd();
	      return 'comment';
	    }
	    else if (ch == "/") {
	      if (stream.eat("*")) {
	        state.tokenize = tokenComment;
	        return tokenComment(stream, state);
	      }
	    }
	
	    // Single operators
	    if(singleOperators.test(ch)) {
	      return "operator";
	    }
	
	    // If nothing match, we skip the entire alphanumerical block
	    stream.eatWhile(/\w/);
	
	    return "variable";
	  }
	
	  function tokenClass(stream, state) {
	    if (stream.eatSpace()) {
	      return null;
	    }
	    stream.match(/([A-Z][A-Za-z0-9_]*)|(`.+`)/);
	    state.tokenize = tokenBase;
	    return "variable-3"
	  }
	
	  function tokenMeth(stream, state) {
	    if (stream.eatSpace()) {
	      return null;
	    }
	    stream.match(/([a-zA-Z][A-Za-z0-9_]*)|(`.+`)/);
	    state.tokenize = tokenBase;
	    return "def"
	  }
	
	  function tokenFunProc(stream, state) {
	    if (stream.eatSpace()) {
	      return null;
	    }
	
	    if(!state.hasPassedFirstStage && stream.eat("{")) {
	      state.hasPassedFirstStage = true;
	      return "bracket";
	    }
	    else if(state.hasPassedFirstStage) {
	      stream.match(/([A-Z][A-Za-z0-9_]*)|(`.+`)|\$/);
	      state.hasPassedFirstStage = false;
	      state.tokenize = tokenBase;
	      return "def"
	    }
	    else {
	      state.tokenize = tokenBase;
	      return null;
	    }
	  }
	
	  function tokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while (ch = stream.next()) {
	      if (ch == "/" && maybeEnd) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return "comment";
	  }
	
	  function tokenString(quote) {
	    return function (stream, state) {
	      var escaped = false, next, end = false;
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) {
	          end = true;
	          break;
	        }
	        escaped = !escaped && next == "\\";
	      }
	      if (end || !escaped)
	        state.tokenize = tokenBase;
	      return "string";
	    };
	  }
	
	  function buildElectricInputRegEx() {
	    // Reindentation should occur on [] or on a match of any of
	    // the block closing keywords, at the end of a line.
	    var allClosings = middle.concat(end);
	    return new RegExp("[\\[\\]]|(" + allClosings.join("|") + ")$");
	  }
	
	  return {
	
	    startState: function () {
	      return {
	        tokenize: tokenBase,
	        currentIndent: 0,
	        doInCurrentLine: false,
	        hasPassedFirstStage: false
	      };
	    },
	
	    token: function (stream, state) {
	      if (stream.sol())
	        state.doInCurrentLine = 0;
	
	      return state.tokenize(stream, state);
	    },
	
	    indent: function (state, textAfter) {
	      var trueText = textAfter.replace(/^\s+|\s+$/g, '');
	
	      if (trueText.match(endKeywords) || trueText.match(middleKeywords) || trueText.match(/(\[])/))
	        return conf.indentUnit * (state.currentIndent - 1);
	
	      if (state.currentIndent < 0)
	        return 0;
	
	      return state.currentIndent * conf.indentUnit;
	    },
	    fold: "indent",
	    electricInput: buildElectricInputRegEx(),
	    lineComment: "%",
	    blockCommentStart: "/*",
	    blockCommentEnd: "*/"
	  };
	});
	
	CodeMirror.defineMIME("text/x-oz", "oz");
	
	});


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("pascal", function() {
	  function words(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	  var keywords = words("and array begin case const div do downto else end file for forward integer " +
	                       "boolean char function goto if in label mod nil not of or packed procedure " +
	                       "program record repeat set string then to type until var while with");
	  var atoms = {"null": true};
	
	  var isOperatorChar = /[+\-*&%=<>!?|\/]/;
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    if (ch == "#" && state.startOfLine) {
	      stream.skipToEnd();
	      return "meta";
	    }
	    if (ch == '"' || ch == "'") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    }
	    if (ch == "(" && stream.eat("*")) {
	      state.tokenize = tokenComment;
	      return tokenComment(stream, state);
	    }
	    if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
	      return null;
	    }
	    if (/\d/.test(ch)) {
	      stream.eatWhile(/[\w\.]/);
	      return "number";
	    }
	    if (ch == "/") {
	      if (stream.eat("/")) {
	        stream.skipToEnd();
	        return "comment";
	      }
	    }
	    if (isOperatorChar.test(ch)) {
	      stream.eatWhile(isOperatorChar);
	      return "operator";
	    }
	    stream.eatWhile(/[\w\$_]/);
	    var cur = stream.current();
	    if (keywords.propertyIsEnumerable(cur)) return "keyword";
	    if (atoms.propertyIsEnumerable(cur)) return "atom";
	    return "variable";
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, next, end = false;
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) {end = true; break;}
	        escaped = !escaped && next == "\\";
	      }
	      if (end || !escaped) state.tokenize = null;
	      return "string";
	    };
	  }
	
	  function tokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while (ch = stream.next()) {
	      if (ch == ")" && maybeEnd) {
	        state.tokenize = null;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return "comment";
	  }
	
	  // Interface
	
	  return {
	    startState: function() {
	      return {tokenize: null};
	    },
	
	    token: function(stream, state) {
	      if (stream.eatSpace()) return null;
	      var style = (state.tokenize || tokenBase)(stream, state);
	      if (style == "comment" || style == "meta") return style;
	      return style;
	    },
	
	    electricChars: "{}"
	  };
	});
	
	CodeMirror.defineMIME("text/x-pascal", "pascal");
	
	});


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(12));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../javascript/javascript"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("pegjs", function (config) {
	  var jsMode = CodeMirror.getMode(config, "javascript");
	
	  function identifier(stream) {
	    return stream.match(/^[a-zA-Z_][a-zA-Z0-9_]*/);
	  }
	
	  return {
	    startState: function () {
	      return {
	        inString: false,
	        stringType: null,
	        inComment: false,
	        inCharacterClass: false,
	        braced: 0,
	        lhs: true,
	        localState: null
	      };
	    },
	    token: function (stream, state) {
	      if (stream)
	
	      //check for state changes
	      if (!state.inString && !state.inComment && ((stream.peek() == '"') || (stream.peek() == "'"))) {
	        state.stringType = stream.peek();
	        stream.next(); // Skip quote
	        state.inString = true; // Update state
	      }
	      if (!state.inString && !state.inComment && stream.match(/^\/\*/)) {
	        state.inComment = true;
	      }
	
	      //return state
	      if (state.inString) {
	        while (state.inString && !stream.eol()) {
	          if (stream.peek() === state.stringType) {
	            stream.next(); // Skip quote
	            state.inString = false; // Clear flag
	          } else if (stream.peek() === '\\') {
	            stream.next();
	            stream.next();
	          } else {
	            stream.match(/^.[^\\\"\']*/);
	          }
	        }
	        return state.lhs ? "property string" : "string"; // Token style
	      } else if (state.inComment) {
	        while (state.inComment && !stream.eol()) {
	          if (stream.match(/\*\//)) {
	            state.inComment = false; // Clear flag
	          } else {
	            stream.match(/^.[^\*]*/);
	          }
	        }
	        return "comment";
	      } else if (state.inCharacterClass) {
	          while (state.inCharacterClass && !stream.eol()) {
	            if (!(stream.match(/^[^\]\\]+/) || stream.match(/^\\./))) {
	              state.inCharacterClass = false;
	            }
	          }
	      } else if (stream.peek() === '[') {
	        stream.next();
	        state.inCharacterClass = true;
	        return 'bracket';
	      } else if (stream.match(/^\/\//)) {
	        stream.skipToEnd();
	        return "comment";
	      } else if (state.braced || stream.peek() === '{') {
	        if (state.localState === null) {
	          state.localState = CodeMirror.startState(jsMode);
	        }
	        var token = jsMode.token(stream, state.localState);
	        var text = stream.current();
	        if (!token) {
	          for (var i = 0; i < text.length; i++) {
	            if (text[i] === '{') {
	              state.braced++;
	            } else if (text[i] === '}') {
	              state.braced--;
	            }
	          };
	        }
	        return token;
	      } else if (identifier(stream)) {
	        if (stream.peek() === ':') {
	          return 'variable';
	        }
	        return 'variable-2';
	      } else if (['[', ']', '(', ')'].indexOf(stream.peek()) != -1) {
	        stream.next();
	        return 'bracket';
	      } else if (!stream.eatSpace()) {
	        stream.next();
	      }
	      return null;
	    }
	  };
	}, "javascript");
	
	});


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// CodeMirror2 mode/perl/perl.js (text/x-perl) beta 0.10 (2011-11-08)
	// This is a part of CodeMirror from https://github.com/sabaca/CodeMirror_mode_perl (mail@sabaca.com)
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("perl",function(){
	        // http://perldoc.perl.org
	        var PERL={                                      //   null - magic touch
	                                                        //   1 - keyword
	                                                        //   2 - def
	                                                        //   3 - atom
	                                                        //   4 - operator
	                                                        //   5 - variable-2 (predefined)
	                                                        //   [x,y] - x=1,2,3; y=must be defined if x{...}
	                                                //      PERL operators
	                '->'                            :   4,
	                '++'                            :   4,
	                '--'                            :   4,
	                '**'                            :   4,
	                                                        //   ! ~ \ and unary + and -
	                '=~'                            :   4,
	                '!~'                            :   4,
	                '*'                             :   4,
	                '/'                             :   4,
	                '%'                             :   4,
	                'x'                             :   4,
	                '+'                             :   4,
	                '-'                             :   4,
	                '.'                             :   4,
	                '<<'                            :   4,
	                '>>'                            :   4,
	                                                        //   named unary operators
	                '<'                             :   4,
	                '>'                             :   4,
	                '<='                            :   4,
	                '>='                            :   4,
	                'lt'                            :   4,
	                'gt'                            :   4,
	                'le'                            :   4,
	                'ge'                            :   4,
	                '=='                            :   4,
	                '!='                            :   4,
	                '<=>'                           :   4,
	                'eq'                            :   4,
	                'ne'                            :   4,
	                'cmp'                           :   4,
	                '~~'                            :   4,
	                '&'                             :   4,
	                '|'                             :   4,
	                '^'                             :   4,
	                '&&'                            :   4,
	                '||'                            :   4,
	                '//'                            :   4,
	                '..'                            :   4,
	                '...'                           :   4,
	                '?'                             :   4,
	                ':'                             :   4,
	                '='                             :   4,
	                '+='                            :   4,
	                '-='                            :   4,
	                '*='                            :   4,  //   etc. ???
	                ','                             :   4,
	                '=>'                            :   4,
	                '::'                            :   4,
	                                                        //   list operators (rightward)
	                'not'                           :   4,
	                'and'                           :   4,
	                'or'                            :   4,
	                'xor'                           :   4,
	                                                //      PERL predefined variables (I know, what this is a paranoid idea, but may be needed for people, who learn PERL, and for me as well, ...and may be for you?;)
	                'BEGIN'                         :   [5,1],
	                'END'                           :   [5,1],
	                'PRINT'                         :   [5,1],
	                'PRINTF'                        :   [5,1],
	                'GETC'                          :   [5,1],
	                'READ'                          :   [5,1],
	                'READLINE'                      :   [5,1],
	                'DESTROY'                       :   [5,1],
	                'TIE'                           :   [5,1],
	                'TIEHANDLE'                     :   [5,1],
	                'UNTIE'                         :   [5,1],
	                'STDIN'                         :    5,
	                'STDIN_TOP'                     :    5,
	                'STDOUT'                        :    5,
	                'STDOUT_TOP'                    :    5,
	                'STDERR'                        :    5,
	                'STDERR_TOP'                    :    5,
	                '$ARG'                          :    5,
	                '$_'                            :    5,
	                '@ARG'                          :    5,
	                '@_'                            :    5,
	                '$LIST_SEPARATOR'               :    5,
	                '$"'                            :    5,
	                '$PROCESS_ID'                   :    5,
	                '$PID'                          :    5,
	                '$$'                            :    5,
	                '$REAL_GROUP_ID'                :    5,
	                '$GID'                          :    5,
	                '$('                            :    5,
	                '$EFFECTIVE_GROUP_ID'           :    5,
	                '$EGID'                         :    5,
	                '$)'                            :    5,
	                '$PROGRAM_NAME'                 :    5,
	                '$0'                            :    5,
	                '$SUBSCRIPT_SEPARATOR'          :    5,
	                '$SUBSEP'                       :    5,
	                '$;'                            :    5,
	                '$REAL_USER_ID'                 :    5,
	                '$UID'                          :    5,
	                '$<'                            :    5,
	                '$EFFECTIVE_USER_ID'            :    5,
	                '$EUID'                         :    5,
	                '$>'                            :    5,
	                '$a'                            :    5,
	                '$b'                            :    5,
	                '$COMPILING'                    :    5,
	                '$^C'                           :    5,
	                '$DEBUGGING'                    :    5,
	                '$^D'                           :    5,
	                '${^ENCODING}'                  :    5,
	                '$ENV'                          :    5,
	                '%ENV'                          :    5,
	                '$SYSTEM_FD_MAX'                :    5,
	                '$^F'                           :    5,
	                '@F'                            :    5,
	                '${^GLOBAL_PHASE}'              :    5,
	                '$^H'                           :    5,
	                '%^H'                           :    5,
	                '@INC'                          :    5,
	                '%INC'                          :    5,
	                '$INPLACE_EDIT'                 :    5,
	                '$^I'                           :    5,
	                '$^M'                           :    5,
	                '$OSNAME'                       :    5,
	                '$^O'                           :    5,
	                '${^OPEN}'                      :    5,
	                '$PERLDB'                       :    5,
	                '$^P'                           :    5,
	                '$SIG'                          :    5,
	                '%SIG'                          :    5,
	                '$BASETIME'                     :    5,
	                '$^T'                           :    5,
	                '${^TAINT}'                     :    5,
	                '${^UNICODE}'                   :    5,
	                '${^UTF8CACHE}'                 :    5,
	                '${^UTF8LOCALE}'                :    5,
	                '$PERL_VERSION'                 :    5,
	                '$^V'                           :    5,
	                '${^WIN32_SLOPPY_STAT}'         :    5,
	                '$EXECUTABLE_NAME'              :    5,
	                '$^X'                           :    5,
	                '$1'                            :    5, // - regexp $1, $2...
	                '$MATCH'                        :    5,
	                '$&'                            :    5,
	                '${^MATCH}'                     :    5,
	                '$PREMATCH'                     :    5,
	                '$`'                            :    5,
	                '${^PREMATCH}'                  :    5,
	                '$POSTMATCH'                    :    5,
	                "$'"                            :    5,
	                '${^POSTMATCH}'                 :    5,
	                '$LAST_PAREN_MATCH'             :    5,
	                '$+'                            :    5,
	                '$LAST_SUBMATCH_RESULT'         :    5,
	                '$^N'                           :    5,
	                '@LAST_MATCH_END'               :    5,
	                '@+'                            :    5,
	                '%LAST_PAREN_MATCH'             :    5,
	                '%+'                            :    5,
	                '@LAST_MATCH_START'             :    5,
	                '@-'                            :    5,
	                '%LAST_MATCH_START'             :    5,
	                '%-'                            :    5,
	                '$LAST_REGEXP_CODE_RESULT'      :    5,
	                '$^R'                           :    5,
	                '${^RE_DEBUG_FLAGS}'            :    5,
	                '${^RE_TRIE_MAXBUF}'            :    5,
	                '$ARGV'                         :    5,
	                '@ARGV'                         :    5,
	                'ARGV'                          :    5,
	                'ARGVOUT'                       :    5,
	                '$OUTPUT_FIELD_SEPARATOR'       :    5,
	                '$OFS'                          :    5,
	                '$,'                            :    5,
	                '$INPUT_LINE_NUMBER'            :    5,
	                '$NR'                           :    5,
	                '$.'                            :    5,
	                '$INPUT_RECORD_SEPARATOR'       :    5,
	                '$RS'                           :    5,
	                '$/'                            :    5,
	                '$OUTPUT_RECORD_SEPARATOR'      :    5,
	                '$ORS'                          :    5,
	                '$\\'                           :    5,
	                '$OUTPUT_AUTOFLUSH'             :    5,
	                '$|'                            :    5,
	                '$ACCUMULATOR'                  :    5,
	                '$^A'                           :    5,
	                '$FORMAT_FORMFEED'              :    5,
	                '$^L'                           :    5,
	                '$FORMAT_PAGE_NUMBER'           :    5,
	                '$%'                            :    5,
	                '$FORMAT_LINES_LEFT'            :    5,
	                '$-'                            :    5,
	                '$FORMAT_LINE_BREAK_CHARACTERS' :    5,
	                '$:'                            :    5,
	                '$FORMAT_LINES_PER_PAGE'        :    5,
	                '$='                            :    5,
	                '$FORMAT_TOP_NAME'              :    5,
	                '$^'                            :    5,
	                '$FORMAT_NAME'                  :    5,
	                '$~'                            :    5,
	                '${^CHILD_ERROR_NATIVE}'        :    5,
	                '$EXTENDED_OS_ERROR'            :    5,
	                '$^E'                           :    5,
	                '$EXCEPTIONS_BEING_CAUGHT'      :    5,
	                '$^S'                           :    5,
	                '$WARNING'                      :    5,
	                '$^W'                           :    5,
	                '${^WARNING_BITS}'              :    5,
	                '$OS_ERROR'                     :    5,
	                '$ERRNO'                        :    5,
	                '$!'                            :    5,
	                '%OS_ERROR'                     :    5,
	                '%ERRNO'                        :    5,
	                '%!'                            :    5,
	                '$CHILD_ERROR'                  :    5,
	                '$?'                            :    5,
	                '$EVAL_ERROR'                   :    5,
	                '$@'                            :    5,
	                '$OFMT'                         :    5,
	                '$#'                            :    5,
	                '$*'                            :    5,
	                '$ARRAY_BASE'                   :    5,
	                '$['                            :    5,
	                '$OLD_PERL_VERSION'             :    5,
	                '$]'                            :    5,
	                                                //      PERL blocks
	                'if'                            :[1,1],
	                elsif                           :[1,1],
	                'else'                          :[1,1],
	                'while'                         :[1,1],
	                unless                          :[1,1],
	                'for'                           :[1,1],
	                foreach                         :[1,1],
	                                                //      PERL functions
	                'abs'                           :1,     // - absolute value function
	                accept                          :1,     // - accept an incoming socket connect
	                alarm                           :1,     // - schedule a SIGALRM
	                'atan2'                         :1,     // - arctangent of Y/X in the range -PI to PI
	                bind                            :1,     // - binds an address to a socket
	                binmode                         :1,     // - prepare binary files for I/O
	                bless                           :1,     // - create an object
	                bootstrap                       :1,     //
	                'break'                         :1,     // - break out of a "given" block
	                caller                          :1,     // - get context of the current subroutine call
	                chdir                           :1,     // - change your current working directory
	                chmod                           :1,     // - changes the permissions on a list of files
	                chomp                           :1,     // - remove a trailing record separator from a string
	                chop                            :1,     // - remove the last character from a string
	                chown                           :1,     // - change the ownership on a list of files
	                chr                             :1,     // - get character this number represents
	                chroot                          :1,     // - make directory new root for path lookups
	                close                           :1,     // - close file (or pipe or socket) handle
	                closedir                        :1,     // - close directory handle
	                connect                         :1,     // - connect to a remote socket
	                'continue'                      :[1,1], // - optional trailing block in a while or foreach
	                'cos'                           :1,     // - cosine function
	                crypt                           :1,     // - one-way passwd-style encryption
	                dbmclose                        :1,     // - breaks binding on a tied dbm file
	                dbmopen                         :1,     // - create binding on a tied dbm file
	                'default'                       :1,     //
	                defined                         :1,     // - test whether a value, variable, or function is defined
	                'delete'                        :1,     // - deletes a value from a hash
	                die                             :1,     // - raise an exception or bail out
	                'do'                            :1,     // - turn a BLOCK into a TERM
	                dump                            :1,     // - create an immediate core dump
	                each                            :1,     // - retrieve the next key/value pair from a hash
	                endgrent                        :1,     // - be done using group file
	                endhostent                      :1,     // - be done using hosts file
	                endnetent                       :1,     // - be done using networks file
	                endprotoent                     :1,     // - be done using protocols file
	                endpwent                        :1,     // - be done using passwd file
	                endservent                      :1,     // - be done using services file
	                eof                             :1,     // - test a filehandle for its end
	                'eval'                          :1,     // - catch exceptions or compile and run code
	                'exec'                          :1,     // - abandon this program to run another
	                exists                          :1,     // - test whether a hash key is present
	                exit                            :1,     // - terminate this program
	                'exp'                           :1,     // - raise I to a power
	                fcntl                           :1,     // - file control system call
	                fileno                          :1,     // - return file descriptor from filehandle
	                flock                           :1,     // - lock an entire file with an advisory lock
	                fork                            :1,     // - create a new process just like this one
	                format                          :1,     // - declare a picture format with use by the write() function
	                formline                        :1,     // - internal function used for formats
	                getc                            :1,     // - get the next character from the filehandle
	                getgrent                        :1,     // - get next group record
	                getgrgid                        :1,     // - get group record given group user ID
	                getgrnam                        :1,     // - get group record given group name
	                gethostbyaddr                   :1,     // - get host record given its address
	                gethostbyname                   :1,     // - get host record given name
	                gethostent                      :1,     // - get next hosts record
	                getlogin                        :1,     // - return who logged in at this tty
	                getnetbyaddr                    :1,     // - get network record given its address
	                getnetbyname                    :1,     // - get networks record given name
	                getnetent                       :1,     // - get next networks record
	                getpeername                     :1,     // - find the other end of a socket connection
	                getpgrp                         :1,     // - get process group
	                getppid                         :1,     // - get parent process ID
	                getpriority                     :1,     // - get current nice value
	                getprotobyname                  :1,     // - get protocol record given name
	                getprotobynumber                :1,     // - get protocol record numeric protocol
	                getprotoent                     :1,     // - get next protocols record
	                getpwent                        :1,     // - get next passwd record
	                getpwnam                        :1,     // - get passwd record given user login name
	                getpwuid                        :1,     // - get passwd record given user ID
	                getservbyname                   :1,     // - get services record given its name
	                getservbyport                   :1,     // - get services record given numeric port
	                getservent                      :1,     // - get next services record
	                getsockname                     :1,     // - retrieve the sockaddr for a given socket
	                getsockopt                      :1,     // - get socket options on a given socket
	                given                           :1,     //
	                glob                            :1,     // - expand filenames using wildcards
	                gmtime                          :1,     // - convert UNIX time into record or string using Greenwich time
	                'goto'                          :1,     // - create spaghetti code
	                grep                            :1,     // - locate elements in a list test true against a given criterion
	                hex                             :1,     // - convert a string to a hexadecimal number
	                'import'                        :1,     // - patch a module's namespace into your own
	                index                           :1,     // - find a substring within a string
	                'int'                           :1,     // - get the integer portion of a number
	                ioctl                           :1,     // - system-dependent device control system call
	                'join'                          :1,     // - join a list into a string using a separator
	                keys                            :1,     // - retrieve list of indices from a hash
	                kill                            :1,     // - send a signal to a process or process group
	                last                            :1,     // - exit a block prematurely
	                lc                              :1,     // - return lower-case version of a string
	                lcfirst                         :1,     // - return a string with just the next letter in lower case
	                length                          :1,     // - return the number of bytes in a string
	                'link'                          :1,     // - create a hard link in the filesytem
	                listen                          :1,     // - register your socket as a server
	                local                           : 2,    // - create a temporary value for a global variable (dynamic scoping)
	                localtime                       :1,     // - convert UNIX time into record or string using local time
	                lock                            :1,     // - get a thread lock on a variable, subroutine, or method
	                'log'                           :1,     // - retrieve the natural logarithm for a number
	                lstat                           :1,     // - stat a symbolic link
	                m                               :null,  // - match a string with a regular expression pattern
	                map                             :1,     // - apply a change to a list to get back a new list with the changes
	                mkdir                           :1,     // - create a directory
	                msgctl                          :1,     // - SysV IPC message control operations
	                msgget                          :1,     // - get SysV IPC message queue
	                msgrcv                          :1,     // - receive a SysV IPC message from a message queue
	                msgsnd                          :1,     // - send a SysV IPC message to a message queue
	                my                              : 2,    // - declare and assign a local variable (lexical scoping)
	                'new'                           :1,     //
	                next                            :1,     // - iterate a block prematurely
	                no                              :1,     // - unimport some module symbols or semantics at compile time
	                oct                             :1,     // - convert a string to an octal number
	                open                            :1,     // - open a file, pipe, or descriptor
	                opendir                         :1,     // - open a directory
	                ord                             :1,     // - find a character's numeric representation
	                our                             : 2,    // - declare and assign a package variable (lexical scoping)
	                pack                            :1,     // - convert a list into a binary representation
	                'package'                       :1,     // - declare a separate global namespace
	                pipe                            :1,     // - open a pair of connected filehandles
	                pop                             :1,     // - remove the last element from an array and return it
	                pos                             :1,     // - find or set the offset for the last/next m//g search
	                print                           :1,     // - output a list to a filehandle
	                printf                          :1,     // - output a formatted list to a filehandle
	                prototype                       :1,     // - get the prototype (if any) of a subroutine
	                push                            :1,     // - append one or more elements to an array
	                q                               :null,  // - singly quote a string
	                qq                              :null,  // - doubly quote a string
	                qr                              :null,  // - Compile pattern
	                quotemeta                       :null,  // - quote regular expression magic characters
	                qw                              :null,  // - quote a list of words
	                qx                              :null,  // - backquote quote a string
	                rand                            :1,     // - retrieve the next pseudorandom number
	                read                            :1,     // - fixed-length buffered input from a filehandle
	                readdir                         :1,     // - get a directory from a directory handle
	                readline                        :1,     // - fetch a record from a file
	                readlink                        :1,     // - determine where a symbolic link is pointing
	                readpipe                        :1,     // - execute a system command and collect standard output
	                recv                            :1,     // - receive a message over a Socket
	                redo                            :1,     // - start this loop iteration over again
	                ref                             :1,     // - find out the type of thing being referenced
	                rename                          :1,     // - change a filename
	                require                         :1,     // - load in external functions from a library at runtime
	                reset                           :1,     // - clear all variables of a given name
	                'return'                        :1,     // - get out of a function early
	                reverse                         :1,     // - flip a string or a list
	                rewinddir                       :1,     // - reset directory handle
	                rindex                          :1,     // - right-to-left substring search
	                rmdir                           :1,     // - remove a directory
	                s                               :null,  // - replace a pattern with a string
	                say                             :1,     // - print with newline
	                scalar                          :1,     // - force a scalar context
	                seek                            :1,     // - reposition file pointer for random-access I/O
	                seekdir                         :1,     // - reposition directory pointer
	                select                          :1,     // - reset default output or do I/O multiplexing
	                semctl                          :1,     // - SysV semaphore control operations
	                semget                          :1,     // - get set of SysV semaphores
	                semop                           :1,     // - SysV semaphore operations
	                send                            :1,     // - send a message over a socket
	                setgrent                        :1,     // - prepare group file for use
	                sethostent                      :1,     // - prepare hosts file for use
	                setnetent                       :1,     // - prepare networks file for use
	                setpgrp                         :1,     // - set the process group of a process
	                setpriority                     :1,     // - set a process's nice value
	                setprotoent                     :1,     // - prepare protocols file for use
	                setpwent                        :1,     // - prepare passwd file for use
	                setservent                      :1,     // - prepare services file for use
	                setsockopt                      :1,     // - set some socket options
	                shift                           :1,     // - remove the first element of an array, and return it
	                shmctl                          :1,     // - SysV shared memory operations
	                shmget                          :1,     // - get SysV shared memory segment identifier
	                shmread                         :1,     // - read SysV shared memory
	                shmwrite                        :1,     // - write SysV shared memory
	                shutdown                        :1,     // - close down just half of a socket connection
	                'sin'                           :1,     // - return the sine of a number
	                sleep                           :1,     // - block for some number of seconds
	                socket                          :1,     // - create a socket
	                socketpair                      :1,     // - create a pair of sockets
	                'sort'                          :1,     // - sort a list of values
	                splice                          :1,     // - add or remove elements anywhere in an array
	                'split'                         :1,     // - split up a string using a regexp delimiter
	                sprintf                         :1,     // - formatted print into a string
	                'sqrt'                          :1,     // - square root function
	                srand                           :1,     // - seed the random number generator
	                stat                            :1,     // - get a file's status information
	                state                           :1,     // - declare and assign a state variable (persistent lexical scoping)
	                study                           :1,     // - optimize input data for repeated searches
	                'sub'                           :1,     // - declare a subroutine, possibly anonymously
	                'substr'                        :1,     // - get or alter a portion of a stirng
	                symlink                         :1,     // - create a symbolic link to a file
	                syscall                         :1,     // - execute an arbitrary system call
	                sysopen                         :1,     // - open a file, pipe, or descriptor
	                sysread                         :1,     // - fixed-length unbuffered input from a filehandle
	                sysseek                         :1,     // - position I/O pointer on handle used with sysread and syswrite
	                system                          :1,     // - run a separate program
	                syswrite                        :1,     // - fixed-length unbuffered output to a filehandle
	                tell                            :1,     // - get current seekpointer on a filehandle
	                telldir                         :1,     // - get current seekpointer on a directory handle
	                tie                             :1,     // - bind a variable to an object class
	                tied                            :1,     // - get a reference to the object underlying a tied variable
	                time                            :1,     // - return number of seconds since 1970
	                times                           :1,     // - return elapsed time for self and child processes
	                tr                              :null,  // - transliterate a string
	                truncate                        :1,     // - shorten a file
	                uc                              :1,     // - return upper-case version of a string
	                ucfirst                         :1,     // - return a string with just the next letter in upper case
	                umask                           :1,     // - set file creation mode mask
	                undef                           :1,     // - remove a variable or function definition
	                unlink                          :1,     // - remove one link to a file
	                unpack                          :1,     // - convert binary structure into normal perl variables
	                unshift                         :1,     // - prepend more elements to the beginning of a list
	                untie                           :1,     // - break a tie binding to a variable
	                use                             :1,     // - load in a module at compile time
	                utime                           :1,     // - set a file's last access and modify times
	                values                          :1,     // - return a list of the values in a hash
	                vec                             :1,     // - test or set particular bits in a string
	                wait                            :1,     // - wait for any child process to die
	                waitpid                         :1,     // - wait for a particular child process to die
	                wantarray                       :1,     // - get void vs scalar vs list context of current subroutine call
	                warn                            :1,     // - print debugging info
	                when                            :1,     //
	                write                           :1,     // - print a picture record
	                y                               :null}; // - transliterate a string
	
	        var RXstyle="string-2";
	        var RXmodifiers=/[goseximacplud]/;              // NOTE: "m", "s", "y" and "tr" need to correct real modifiers for each regexp type
	
	        function tokenChain(stream,state,chain,style,tail){     // NOTE: chain.length > 2 is not working now (it's for s[...][...]geos;)
	                state.chain=null;                               //                                                          12   3tail
	                state.style=null;
	                state.tail=null;
	                state.tokenize=function(stream,state){
	                        var e=false,c,i=0;
	                        while(c=stream.next()){
	                                if(c===chain[i]&&!e){
	                                        if(chain[++i]!==undefined){
	                                                state.chain=chain[i];
	                                                state.style=style;
	                                                state.tail=tail;}
	                                        else if(tail)
	                                                stream.eatWhile(tail);
	                                        state.tokenize=tokenPerl;
	                                        return style;}
	                                e=!e&&c=="\\";}
	                        return style;};
	                return state.tokenize(stream,state);}
	
	        function tokenSOMETHING(stream,state,string){
	                state.tokenize=function(stream,state){
	                        if(stream.string==string)
	                                state.tokenize=tokenPerl;
	                        stream.skipToEnd();
	                        return "string";};
	                return state.tokenize(stream,state);}
	
	        function tokenPerl(stream,state){
	                if(stream.eatSpace())
	                        return null;
	                if(state.chain)
	                        return tokenChain(stream,state,state.chain,state.style,state.tail);
	                if(stream.match(/^\-?[\d\.]/,false))
	                        if(stream.match(/^(\-?(\d*\.\d+(e[+-]?\d+)?|\d+\.\d*)|0x[\da-fA-F]+|0b[01]+|\d+(e[+-]?\d+)?)/))
	                                return 'number';
	                if(stream.match(/^<<(?=\w)/)){                  // NOTE: <<SOMETHING\n...\nSOMETHING\n
	                        stream.eatWhile(/\w/);
	                        return tokenSOMETHING(stream,state,stream.current().substr(2));}
	                if(stream.sol()&&stream.match(/^\=item(?!\w)/)){// NOTE: \n=item...\n=cut\n
	                        return tokenSOMETHING(stream,state,'=cut');}
	                var ch=stream.next();
	                if(ch=='"'||ch=="'"){                           // NOTE: ' or " or <<'SOMETHING'\n...\nSOMETHING\n or <<"SOMETHING"\n...\nSOMETHING\n
	                        if(prefix(stream, 3)=="<<"+ch){
	                                var p=stream.pos;
	                                stream.eatWhile(/\w/);
	                                var n=stream.current().substr(1);
	                                if(n&&stream.eat(ch))
	                                        return tokenSOMETHING(stream,state,n);
	                                stream.pos=p;}
	                        return tokenChain(stream,state,[ch],"string");}
	                if(ch=="q"){
	                        var c=look(stream, -2);
	                        if(!(c&&/\w/.test(c))){
	                                c=look(stream, 0);
	                                if(c=="x"){
	                                        c=look(stream, 1);
	                                        if(c=="("){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,[")"],RXstyle,RXmodifiers);}
	                                        if(c=="["){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,["]"],RXstyle,RXmodifiers);}
	                                        if(c=="{"){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,["}"],RXstyle,RXmodifiers);}
	                                        if(c=="<"){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,[">"],RXstyle,RXmodifiers);}
	                                        if(/[\^'"!~\/]/.test(c)){
	                                                eatSuffix(stream, 1);
	                                                return tokenChain(stream,state,[stream.eat(c)],RXstyle,RXmodifiers);}}
	                                else if(c=="q"){
	                                        c=look(stream, 1);
	                                        if(c=="("){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,[")"],"string");}
	                                        if(c=="["){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,["]"],"string");}
	                                        if(c=="{"){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,["}"],"string");}
	                                        if(c=="<"){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,[">"],"string");}
	                                        if(/[\^'"!~\/]/.test(c)){
	                                                eatSuffix(stream, 1);
	                                                return tokenChain(stream,state,[stream.eat(c)],"string");}}
	                                else if(c=="w"){
	                                        c=look(stream, 1);
	                                        if(c=="("){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,[")"],"bracket");}
	                                        if(c=="["){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,["]"],"bracket");}
	                                        if(c=="{"){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,["}"],"bracket");}
	                                        if(c=="<"){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,[">"],"bracket");}
	                                        if(/[\^'"!~\/]/.test(c)){
	                                                eatSuffix(stream, 1);
	                                                return tokenChain(stream,state,[stream.eat(c)],"bracket");}}
	                                else if(c=="r"){
	                                        c=look(stream, 1);
	                                        if(c=="("){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,[")"],RXstyle,RXmodifiers);}
	                                        if(c=="["){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,["]"],RXstyle,RXmodifiers);}
	                                        if(c=="{"){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,["}"],RXstyle,RXmodifiers);}
	                                        if(c=="<"){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,[">"],RXstyle,RXmodifiers);}
	                                        if(/[\^'"!~\/]/.test(c)){
	                                                eatSuffix(stream, 1);
	                                                return tokenChain(stream,state,[stream.eat(c)],RXstyle,RXmodifiers);}}
	                                else if(/[\^'"!~\/(\[{<]/.test(c)){
	                                        if(c=="("){
	                                                eatSuffix(stream, 1);
	                                                return tokenChain(stream,state,[")"],"string");}
	                                        if(c=="["){
	                                                eatSuffix(stream, 1);
	                                                return tokenChain(stream,state,["]"],"string");}
	                                        if(c=="{"){
	                                                eatSuffix(stream, 1);
	                                                return tokenChain(stream,state,["}"],"string");}
	                                        if(c=="<"){
	                                                eatSuffix(stream, 1);
	                                                return tokenChain(stream,state,[">"],"string");}
	                                        if(/[\^'"!~\/]/.test(c)){
	                                                return tokenChain(stream,state,[stream.eat(c)],"string");}}}}
	                if(ch=="m"){
	                        var c=look(stream, -2);
	                        if(!(c&&/\w/.test(c))){
	                                c=stream.eat(/[(\[{<\^'"!~\/]/);
	                                if(c){
	                                        if(/[\^'"!~\/]/.test(c)){
	                                                return tokenChain(stream,state,[c],RXstyle,RXmodifiers);}
	                                        if(c=="("){
	                                                return tokenChain(stream,state,[")"],RXstyle,RXmodifiers);}
	                                        if(c=="["){
	                                                return tokenChain(stream,state,["]"],RXstyle,RXmodifiers);}
	                                        if(c=="{"){
	                                                return tokenChain(stream,state,["}"],RXstyle,RXmodifiers);}
	                                        if(c=="<"){
	                                                return tokenChain(stream,state,[">"],RXstyle,RXmodifiers);}}}}
	                if(ch=="s"){
	                        var c=/[\/>\]})\w]/.test(look(stream, -2));
	                        if(!c){
	                                c=stream.eat(/[(\[{<\^'"!~\/]/);
	                                if(c){
	                                        if(c=="[")
	                                                return tokenChain(stream,state,["]","]"],RXstyle,RXmodifiers);
	                                        if(c=="{")
	                                                return tokenChain(stream,state,["}","}"],RXstyle,RXmodifiers);
	                                        if(c=="<")
	                                                return tokenChain(stream,state,[">",">"],RXstyle,RXmodifiers);
	                                        if(c=="(")
	                                                return tokenChain(stream,state,[")",")"],RXstyle,RXmodifiers);
	                                        return tokenChain(stream,state,[c,c],RXstyle,RXmodifiers);}}}
	                if(ch=="y"){
	                        var c=/[\/>\]})\w]/.test(look(stream, -2));
	                        if(!c){
	                                c=stream.eat(/[(\[{<\^'"!~\/]/);
	                                if(c){
	                                        if(c=="[")
	                                                return tokenChain(stream,state,["]","]"],RXstyle,RXmodifiers);
	                                        if(c=="{")
	                                                return tokenChain(stream,state,["}","}"],RXstyle,RXmodifiers);
	                                        if(c=="<")
	                                                return tokenChain(stream,state,[">",">"],RXstyle,RXmodifiers);
	                                        if(c=="(")
	                                                return tokenChain(stream,state,[")",")"],RXstyle,RXmodifiers);
	                                        return tokenChain(stream,state,[c,c],RXstyle,RXmodifiers);}}}
	                if(ch=="t"){
	                        var c=/[\/>\]})\w]/.test(look(stream, -2));
	                        if(!c){
	                                c=stream.eat("r");if(c){
	                                c=stream.eat(/[(\[{<\^'"!~\/]/);
	                                if(c){
	                                        if(c=="[")
	                                                return tokenChain(stream,state,["]","]"],RXstyle,RXmodifiers);
	                                        if(c=="{")
	                                                return tokenChain(stream,state,["}","}"],RXstyle,RXmodifiers);
	                                        if(c=="<")
	                                                return tokenChain(stream,state,[">",">"],RXstyle,RXmodifiers);
	                                        if(c=="(")
	                                                return tokenChain(stream,state,[")",")"],RXstyle,RXmodifiers);
	                                        return tokenChain(stream,state,[c,c],RXstyle,RXmodifiers);}}}}
	                if(ch=="`"){
	                        return tokenChain(stream,state,[ch],"variable-2");}
	                if(ch=="/"){
	                        if(!/~\s*$/.test(prefix(stream)))
	                                return "operator";
	                        else
	                                return tokenChain(stream,state,[ch],RXstyle,RXmodifiers);}
	                if(ch=="$"){
	                        var p=stream.pos;
	                        if(stream.eatWhile(/\d/)||stream.eat("{")&&stream.eatWhile(/\d/)&&stream.eat("}"))
	                                return "variable-2";
	                        else
	                                stream.pos=p;}
	                if(/[$@%]/.test(ch)){
	                        var p=stream.pos;
	                        if(stream.eat("^")&&stream.eat(/[A-Z]/)||!/[@$%&]/.test(look(stream, -2))&&stream.eat(/[=|\\\-#?@;:&`~\^!\[\]*'"$+.,\/<>()]/)){
	                                var c=stream.current();
	                                if(PERL[c])
	                                        return "variable-2";}
	                        stream.pos=p;}
	                if(/[$@%&]/.test(ch)){
	                        if(stream.eatWhile(/[\w$\[\]]/)||stream.eat("{")&&stream.eatWhile(/[\w$\[\]]/)&&stream.eat("}")){
	                                var c=stream.current();
	                                if(PERL[c])
	                                        return "variable-2";
	                                else
	                                        return "variable";}}
	                if(ch=="#"){
	                        if(look(stream, -2)!="$"){
	                                stream.skipToEnd();
	                                return "comment";}}
	                if(/[:+\-\^*$&%@=<>!?|\/~\.]/.test(ch)){
	                        var p=stream.pos;
	                        stream.eatWhile(/[:+\-\^*$&%@=<>!?|\/~\.]/);
	                        if(PERL[stream.current()])
	                                return "operator";
	                        else
	                                stream.pos=p;}
	                if(ch=="_"){
	                        if(stream.pos==1){
	                                if(suffix(stream, 6)=="_END__"){
	                                        return tokenChain(stream,state,['\0'],"comment");}
	                                else if(suffix(stream, 7)=="_DATA__"){
	                                        return tokenChain(stream,state,['\0'],"variable-2");}
	                                else if(suffix(stream, 7)=="_C__"){
	                                        return tokenChain(stream,state,['\0'],"string");}}}
	                if(/\w/.test(ch)){
	                        var p=stream.pos;
	                        if(look(stream, -2)=="{"&&(look(stream, 0)=="}"||stream.eatWhile(/\w/)&&look(stream, 0)=="}"))
	                                return "string";
	                        else
	                                stream.pos=p;}
	                if(/[A-Z]/.test(ch)){
	                        var l=look(stream, -2);
	                        var p=stream.pos;
	                        stream.eatWhile(/[A-Z_]/);
	                        if(/[\da-z]/.test(look(stream, 0))){
	                                stream.pos=p;}
	                        else{
	                                var c=PERL[stream.current()];
	                                if(!c)
	                                        return "meta";
	                                if(c[1])
	                                        c=c[0];
	                                if(l!=":"){
	                                        if(c==1)
	                                                return "keyword";
	                                        else if(c==2)
	                                                return "def";
	                                        else if(c==3)
	                                                return "atom";
	                                        else if(c==4)
	                                                return "operator";
	                                        else if(c==5)
	                                                return "variable-2";
	                                        else
	                                                return "meta";}
	                                else
	                                        return "meta";}}
	                if(/[a-zA-Z_]/.test(ch)){
	                        var l=look(stream, -2);
	                        stream.eatWhile(/\w/);
	                        var c=PERL[stream.current()];
	                        if(!c)
	                                return "meta";
	                        if(c[1])
	                                c=c[0];
	                        if(l!=":"){
	                                if(c==1)
	                                        return "keyword";
	                                else if(c==2)
	                                        return "def";
	                                else if(c==3)
	                                        return "atom";
	                                else if(c==4)
	                                        return "operator";
	                                else if(c==5)
	                                        return "variable-2";
	                                else
	                                        return "meta";}
	                        else
	                                return "meta";}
	                return null;}
	
	        return {
	            startState: function() {
	                return {
	                    tokenize: tokenPerl,
	                    chain: null,
	                    style: null,
	                    tail: null
	                };
	            },
	            token: function(stream, state) {
	                return (state.tokenize || tokenPerl)(stream, state);
	            },
	            lineComment: '#'
	        };
	});
	
	CodeMirror.registerHelper("wordChars", "perl", /[\w$]/);
	
	CodeMirror.defineMIME("text/x-perl", "perl");
	
	// it's like "peek", but need for look-ahead or look-behind if index < 0
	function look(stream, c){
	  return stream.string.charAt(stream.pos+(c||0));
	}
	
	// return a part of prefix of current stream from current position
	function prefix(stream, c){
	  if(c){
	    var x=stream.pos-c;
	    return stream.string.substr((x>=0?x:0),c);}
	  else{
	    return stream.string.substr(0,stream.pos-1);
	  }
	}
	
	// return a part of suffix of current stream from current position
	function suffix(stream, c){
	  var y=stream.string.length;
	  var x=y-stream.pos+1;
	  return stream.string.substr(stream.pos,(c&&c<y?c:x));
	}
	
	// eating and vomiting a part of stream from current position
	function eatSuffix(stream, c){
	  var x=stream.pos+c;
	  var y;
	  if(x<=0)
	    stream.pos=0;
	  else if(x>=(y=stream.string.length-1))
	    stream.pos=y;
	  else
	    stream.pos=x;
	}
	
	});


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(5), __webpack_require__(26));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../htmlmixed/htmlmixed", "../clike/clike"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  function keywords(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	
	  // Helper for phpString
	  function matchSequence(list, end, escapes) {
	    if (list.length == 0) return phpString(end);
	    return function (stream, state) {
	      var patterns = list[0];
	      for (var i = 0; i < patterns.length; i++) if (stream.match(patterns[i][0])) {
	        state.tokenize = matchSequence(list.slice(1), end);
	        return patterns[i][1];
	      }
	      state.tokenize = phpString(end, escapes);
	      return "string";
	    };
	  }
	  function phpString(closing, escapes) {
	    return function(stream, state) { return phpString_(stream, state, closing, escapes); };
	  }
	  function phpString_(stream, state, closing, escapes) {
	    // "Complex" syntax
	    if (escapes !== false && stream.match("${", false) || stream.match("{$", false)) {
	      state.tokenize = null;
	      return "string";
	    }
	
	    // Simple syntax
	    if (escapes !== false && stream.match(/^\$[a-zA-Z_][a-zA-Z0-9_]*/)) {
	      // After the variable name there may appear array or object operator.
	      if (stream.match("[", false)) {
	        // Match array operator
	        state.tokenize = matchSequence([
	          [["[", null]],
	          [[/\d[\w\.]*/, "number"],
	           [/\$[a-zA-Z_][a-zA-Z0-9_]*/, "variable-2"],
	           [/[\w\$]+/, "variable"]],
	          [["]", null]]
	        ], closing, escapes);
	      }
	      if (stream.match(/\-\>\w/, false)) {
	        // Match object operator
	        state.tokenize = matchSequence([
	          [["->", null]],
	          [[/[\w]+/, "variable"]]
	        ], closing, escapes);
	      }
	      return "variable-2";
	    }
	
	    var escaped = false;
	    // Normal string
	    while (!stream.eol() &&
	           (escaped || escapes === false ||
	            (!stream.match("{$", false) &&
	             !stream.match(/^(\$[a-zA-Z_][a-zA-Z0-9_]*|\$\{)/, false)))) {
	      if (!escaped && stream.match(closing)) {
	        state.tokenize = null;
	        state.tokStack.pop(); state.tokStack.pop();
	        break;
	      }
	      escaped = stream.next() == "\\" && !escaped;
	    }
	    return "string";
	  }
	
	  var phpKeywords = "abstract and array as break case catch class clone const continue declare default " +
	    "do else elseif enddeclare endfor endforeach endif endswitch endwhile extends final " +
	    "for foreach function global goto if implements interface instanceof namespace " +
	    "new or private protected public static switch throw trait try use var while xor " +
	    "die echo empty exit eval include include_once isset list require require_once return " +
	    "print unset __halt_compiler self static parent yield insteadof finally";
	  var phpAtoms = "true false null TRUE FALSE NULL __CLASS__ __DIR__ __FILE__ __LINE__ __METHOD__ __FUNCTION__ __NAMESPACE__ __TRAIT__";
	  var phpBuiltin = "func_num_args func_get_arg func_get_args strlen strcmp strncmp strcasecmp strncasecmp each error_reporting define defined trigger_error user_error set_error_handler restore_error_handler get_declared_classes get_loaded_extensions extension_loaded get_extension_funcs debug_backtrace constant bin2hex hex2bin sleep usleep time mktime gmmktime strftime gmstrftime strtotime date gmdate getdate localtime checkdate flush wordwrap htmlspecialchars htmlentities html_entity_decode md5 md5_file crc32 getimagesize image_type_to_mime_type phpinfo phpversion phpcredits strnatcmp strnatcasecmp substr_count strspn strcspn strtok strtoupper strtolower strpos strrpos strrev hebrev hebrevc nl2br basename dirname pathinfo stripslashes stripcslashes strstr stristr strrchr str_shuffle str_word_count strcoll substr substr_replace quotemeta ucfirst ucwords strtr addslashes addcslashes rtrim str_replace str_repeat count_chars chunk_split trim ltrim strip_tags similar_text explode implode setlocale localeconv parse_str str_pad chop strchr sprintf printf vprintf vsprintf sscanf fscanf parse_url urlencode urldecode rawurlencode rawurldecode readlink linkinfo link unlink exec system escapeshellcmd escapeshellarg passthru shell_exec proc_open proc_close rand srand getrandmax mt_rand mt_srand mt_getrandmax base64_decode base64_encode abs ceil floor round is_finite is_nan is_infinite bindec hexdec octdec decbin decoct dechex base_convert number_format fmod ip2long long2ip getenv putenv getopt microtime gettimeofday getrusage uniqid quoted_printable_decode set_time_limit get_cfg_var magic_quotes_runtime set_magic_quotes_runtime get_magic_quotes_gpc get_magic_quotes_runtime import_request_variables error_log serialize unserialize memory_get_usage var_dump var_export debug_zval_dump print_r highlight_file show_source highlight_string ini_get ini_get_all ini_set ini_alter ini_restore get_include_path set_include_path restore_include_path setcookie header headers_sent connection_aborted connection_status ignore_user_abort parse_ini_file is_uploaded_file move_uploaded_file intval floatval doubleval strval gettype settype is_null is_resource is_bool is_long is_float is_int is_integer is_double is_real is_numeric is_string is_array is_object is_scalar ereg ereg_replace eregi eregi_replace split spliti join sql_regcase dl pclose popen readfile rewind rmdir umask fclose feof fgetc fgets fgetss fread fopen fpassthru ftruncate fstat fseek ftell fflush fwrite fputs mkdir rename copy tempnam tmpfile file file_get_contents file_put_contents stream_select stream_context_create stream_context_set_params stream_context_set_option stream_context_get_options stream_filter_prepend stream_filter_append fgetcsv flock get_meta_tags stream_set_write_buffer set_file_buffer set_socket_blocking stream_set_blocking socket_set_blocking stream_get_meta_data stream_register_wrapper stream_wrapper_register stream_set_timeout socket_set_timeout socket_get_status realpath fnmatch fsockopen pfsockopen pack unpack get_browser crypt opendir closedir chdir getcwd rewinddir readdir dir glob fileatime filectime filegroup fileinode filemtime fileowner fileperms filesize filetype file_exists is_writable is_writeable is_readable is_executable is_file is_dir is_link stat lstat chown touch clearstatcache mail ob_start ob_flush ob_clean ob_end_flush ob_end_clean ob_get_flush ob_get_clean ob_get_length ob_get_level ob_get_status ob_get_contents ob_implicit_flush ob_list_handlers ksort krsort natsort natcasesort asort arsort sort rsort usort uasort uksort shuffle array_walk count end prev next reset current key min max in_array array_search extract compact array_fill range array_multisort array_push array_pop array_shift array_unshift array_splice array_slice array_merge array_merge_recursive array_keys array_values array_count_values array_reverse array_reduce array_pad array_flip array_change_key_case array_rand array_unique array_intersect array_intersect_assoc array_diff array_diff_assoc array_sum array_filter array_map array_chunk array_key_exists array_intersect_key array_combine array_column pos sizeof key_exists assert assert_options version_compare ftok str_rot13 aggregate session_name session_module_name session_save_path session_id session_regenerate_id session_decode session_register session_unregister session_is_registered session_encode session_start session_destroy session_unset session_set_save_handler session_cache_limiter session_cache_expire session_set_cookie_params session_get_cookie_params session_write_close preg_match preg_match_all preg_replace preg_replace_callback preg_split preg_quote preg_grep overload ctype_alnum ctype_alpha ctype_cntrl ctype_digit ctype_lower ctype_graph ctype_print ctype_punct ctype_space ctype_upper ctype_xdigit virtual apache_request_headers apache_note apache_lookup_uri apache_child_terminate apache_setenv apache_response_headers apache_get_version getallheaders mysql_connect mysql_pconnect mysql_close mysql_select_db mysql_create_db mysql_drop_db mysql_query mysql_unbuffered_query mysql_db_query mysql_list_dbs mysql_list_tables mysql_list_fields mysql_list_processes mysql_error mysql_errno mysql_affected_rows mysql_insert_id mysql_result mysql_num_rows mysql_num_fields mysql_fetch_row mysql_fetch_array mysql_fetch_assoc mysql_fetch_object mysql_data_seek mysql_fetch_lengths mysql_fetch_field mysql_field_seek mysql_free_result mysql_field_name mysql_field_table mysql_field_len mysql_field_type mysql_field_flags mysql_escape_string mysql_real_escape_string mysql_stat mysql_thread_id mysql_client_encoding mysql_get_client_info mysql_get_host_info mysql_get_proto_info mysql_get_server_info mysql_info mysql mysql_fieldname mysql_fieldtable mysql_fieldlen mysql_fieldtype mysql_fieldflags mysql_selectdb mysql_createdb mysql_dropdb mysql_freeresult mysql_numfields mysql_numrows mysql_listdbs mysql_listtables mysql_listfields mysql_db_name mysql_dbname mysql_tablename mysql_table_name pg_connect pg_pconnect pg_close pg_connection_status pg_connection_busy pg_connection_reset pg_host pg_dbname pg_port pg_tty pg_options pg_ping pg_query pg_send_query pg_cancel_query pg_fetch_result pg_fetch_row pg_fetch_assoc pg_fetch_array pg_fetch_object pg_fetch_all pg_affected_rows pg_get_result pg_result_seek pg_result_status pg_free_result pg_last_oid pg_num_rows pg_num_fields pg_field_name pg_field_num pg_field_size pg_field_type pg_field_prtlen pg_field_is_null pg_get_notify pg_get_pid pg_result_error pg_last_error pg_last_notice pg_put_line pg_end_copy pg_copy_to pg_copy_from pg_trace pg_untrace pg_lo_create pg_lo_unlink pg_lo_open pg_lo_close pg_lo_read pg_lo_write pg_lo_read_all pg_lo_import pg_lo_export pg_lo_seek pg_lo_tell pg_escape_string pg_escape_bytea pg_unescape_bytea pg_client_encoding pg_set_client_encoding pg_meta_data pg_convert pg_insert pg_update pg_delete pg_select pg_exec pg_getlastoid pg_cmdtuples pg_errormessage pg_numrows pg_numfields pg_fieldname pg_fieldsize pg_fieldtype pg_fieldnum pg_fieldprtlen pg_fieldisnull pg_freeresult pg_result pg_loreadall pg_locreate pg_lounlink pg_loopen pg_loclose pg_loread pg_lowrite pg_loimport pg_loexport http_response_code get_declared_traits getimagesizefromstring socket_import_stream stream_set_chunk_size trait_exists header_register_callback class_uses session_status session_register_shutdown echo print global static exit array empty eval isset unset die include require include_once require_once json_decode json_encode json_last_error json_last_error_msg curl_close curl_copy_handle curl_errno curl_error curl_escape curl_exec curl_file_create curl_getinfo curl_init curl_multi_add_handle curl_multi_close curl_multi_exec curl_multi_getcontent curl_multi_info_read curl_multi_init curl_multi_remove_handle curl_multi_select curl_multi_setopt curl_multi_strerror curl_pause curl_reset curl_setopt_array curl_setopt curl_share_close curl_share_init curl_share_setopt curl_strerror curl_unescape curl_version mysqli_affected_rows mysqli_autocommit mysqli_change_user mysqli_character_set_name mysqli_close mysqli_commit mysqli_connect_errno mysqli_connect_error mysqli_connect mysqli_data_seek mysqli_debug mysqli_dump_debug_info mysqli_errno mysqli_error_list mysqli_error mysqli_fetch_all mysqli_fetch_array mysqli_fetch_assoc mysqli_fetch_field_direct mysqli_fetch_field mysqli_fetch_fields mysqli_fetch_lengths mysqli_fetch_object mysqli_fetch_row mysqli_field_count mysqli_field_seek mysqli_field_tell mysqli_free_result mysqli_get_charset mysqli_get_client_info mysqli_get_client_stats mysqli_get_client_version mysqli_get_connection_stats mysqli_get_host_info mysqli_get_proto_info mysqli_get_server_info mysqli_get_server_version mysqli_info mysqli_init mysqli_insert_id mysqli_kill mysqli_more_results mysqli_multi_query mysqli_next_result mysqli_num_fields mysqli_num_rows mysqli_options mysqli_ping mysqli_prepare mysqli_query mysqli_real_connect mysqli_real_escape_string mysqli_real_query mysqli_reap_async_query mysqli_refresh mysqli_rollback mysqli_select_db mysqli_set_charset mysqli_set_local_infile_default mysqli_set_local_infile_handler mysqli_sqlstate mysqli_ssl_set mysqli_stat mysqli_stmt_init mysqli_store_result mysqli_thread_id mysqli_thread_safe mysqli_use_result mysqli_warning_count";
	  CodeMirror.registerHelper("hintWords", "php", [phpKeywords, phpAtoms, phpBuiltin].join(" ").split(" "));
	  CodeMirror.registerHelper("wordChars", "php", /[\w$]/);
	
	  var phpConfig = {
	    name: "clike",
	    helperType: "php",
	    keywords: keywords(phpKeywords),
	    blockKeywords: keywords("catch do else elseif for foreach if switch try while finally"),
	    defKeywords: keywords("class function interface namespace trait"),
	    atoms: keywords(phpAtoms),
	    builtin: keywords(phpBuiltin),
	    multiLineStrings: true,
	    hooks: {
	      "$": function(stream) {
	        stream.eatWhile(/[\w\$_]/);
	        return "variable-2";
	      },
	      "<": function(stream, state) {
	        var before;
	        if (before = stream.match(/<<\s*/)) {
	          var quoted = stream.eat(/['"]/);
	          stream.eatWhile(/[\w\.]/);
	          var delim = stream.current().slice(before[0].length + (quoted ? 2 : 1));
	          if (quoted) stream.eat(quoted);
	          if (delim) {
	            (state.tokStack || (state.tokStack = [])).push(delim, 0);
	            state.tokenize = phpString(delim, quoted != "'");
	            return "string";
	          }
	        }
	        return false;
	      },
	      "#": function(stream) {
	        while (!stream.eol() && !stream.match("?>", false)) stream.next();
	        return "comment";
	      },
	      "/": function(stream) {
	        if (stream.eat("/")) {
	          while (!stream.eol() && !stream.match("?>", false)) stream.next();
	          return "comment";
	        }
	        return false;
	      },
	      '"': function(_stream, state) {
	        (state.tokStack || (state.tokStack = [])).push('"', 0);
	        state.tokenize = phpString('"');
	        return "string";
	      },
	      "{": function(_stream, state) {
	        if (state.tokStack && state.tokStack.length)
	          state.tokStack[state.tokStack.length - 1]++;
	        return false;
	      },
	      "}": function(_stream, state) {
	        if (state.tokStack && state.tokStack.length > 0 &&
	            !--state.tokStack[state.tokStack.length - 1]) {
	          state.tokenize = phpString(state.tokStack[state.tokStack.length - 2]);
	        }
	        return false;
	      }
	    }
	  };
	
	  CodeMirror.defineMode("php", function(config, parserConfig) {
	    var htmlMode = CodeMirror.getMode(config, "text/html");
	    var phpMode = CodeMirror.getMode(config, phpConfig);
	
	    function dispatch(stream, state) {
	      var isPHP = state.curMode == phpMode;
	      if (stream.sol() && state.pending && state.pending != '"' && state.pending != "'") state.pending = null;
	      if (!isPHP) {
	        if (stream.match(/^<\?\w*/)) {
	          state.curMode = phpMode;
	          if (!state.php) state.php = CodeMirror.startState(phpMode, htmlMode.indent(state.html, ""))
	          state.curState = state.php;
	          return "meta";
	        }
	        if (state.pending == '"' || state.pending == "'") {
	          while (!stream.eol() && stream.next() != state.pending) {}
	          var style = "string";
	        } else if (state.pending && stream.pos < state.pending.end) {
	          stream.pos = state.pending.end;
	          var style = state.pending.style;
	        } else {
	          var style = htmlMode.token(stream, state.curState);
	        }
	        if (state.pending) state.pending = null;
	        var cur = stream.current(), openPHP = cur.search(/<\?/), m;
	        if (openPHP != -1) {
	          if (style == "string" && (m = cur.match(/[\'\"]$/)) && !/\?>/.test(cur)) state.pending = m[0];
	          else state.pending = {end: stream.pos, style: style};
	          stream.backUp(cur.length - openPHP);
	        }
	        return style;
	      } else if (isPHP && state.php.tokenize == null && stream.match("?>")) {
	        state.curMode = htmlMode;
	        state.curState = state.html;
	        if (!state.php.context.prev) state.php = null;
	        return "meta";
	      } else {
	        return phpMode.token(stream, state.curState);
	      }
	    }
	
	    return {
	      startState: function() {
	        var html = CodeMirror.startState(htmlMode)
	        var php = parserConfig.startOpen ? CodeMirror.startState(phpMode) : null
	        return {html: html,
	                php: php,
	                curMode: parserConfig.startOpen ? phpMode : htmlMode,
	                curState: parserConfig.startOpen ? php : html,
	                pending: null};
	      },
	
	      copyState: function(state) {
	        var html = state.html, htmlNew = CodeMirror.copyState(htmlMode, html),
	            php = state.php, phpNew = php && CodeMirror.copyState(phpMode, php), cur;
	        if (state.curMode == htmlMode) cur = htmlNew;
	        else cur = phpNew;
	        return {html: htmlNew, php: phpNew, curMode: state.curMode, curState: cur,
	                pending: state.pending};
	      },
	
	      token: dispatch,
	
	      indent: function(state, textAfter) {
	        if ((state.curMode != phpMode && /^\s*<\//.test(textAfter)) ||
	            (state.curMode == phpMode && /^\?>/.test(textAfter)))
	          return htmlMode.indent(state.html, textAfter);
	        return state.curMode.indent(state.curState, textAfter);
	      },
	
	      blockCommentStart: "/*",
	      blockCommentEnd: "*/",
	      lineComment: "//",
	
	      innerMode: function(state) { return {state: state.curState, mode: state.curMode}; }
	    };
	  }, "htmlmixed", "clike");
	
	  CodeMirror.defineMIME("application/x-httpd-php", "php");
	  CodeMirror.defineMIME("application/x-httpd-php-open", {name: "php", startOpen: true});
	  CodeMirror.defineMIME("text/x-php", phpConfig);
	});


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	/*
	 *      Pig Latin Mode for CodeMirror 2
	 *      @author Prasanth Jayachandran
	 *      @link   https://github.com/prasanthj/pig-codemirror-2
	 *  This implementation is adapted from PL/SQL mode in CodeMirror 2.
	 */
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("pig", function(_config, parserConfig) {
	  var keywords = parserConfig.keywords,
	  builtins = parserConfig.builtins,
	  types = parserConfig.types,
	  multiLineStrings = parserConfig.multiLineStrings;
	
	  var isOperatorChar = /[*+\-%<>=&?:\/!|]/;
	
	  function chain(stream, state, f) {
	    state.tokenize = f;
	    return f(stream, state);
	  }
	
	  function tokenComment(stream, state) {
	    var isEnd = false;
	    var ch;
	    while(ch = stream.next()) {
	      if(ch == "/" && isEnd) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      isEnd = (ch == "*");
	    }
	    return "comment";
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, next, end = false;
	      while((next = stream.next()) != null) {
	        if (next == quote && !escaped) {
	          end = true; break;
	        }
	        escaped = !escaped && next == "\\";
	      }
	      if (end || !(escaped || multiLineStrings))
	        state.tokenize = tokenBase;
	      return "error";
	    };
	  }
	
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	
	    // is a start of string?
	    if (ch == '"' || ch == "'")
	      return chain(stream, state, tokenString(ch));
	    // is it one of the special chars
	    else if(/[\[\]{}\(\),;\.]/.test(ch))
	      return null;
	    // is it a number?
	    else if(/\d/.test(ch)) {
	      stream.eatWhile(/[\w\.]/);
	      return "number";
	    }
	    // multi line comment or operator
	    else if (ch == "/") {
	      if (stream.eat("*")) {
	        return chain(stream, state, tokenComment);
	      }
	      else {
	        stream.eatWhile(isOperatorChar);
	        return "operator";
	      }
	    }
	    // single line comment or operator
	    else if (ch=="-") {
	      if(stream.eat("-")){
	        stream.skipToEnd();
	        return "comment";
	      }
	      else {
	        stream.eatWhile(isOperatorChar);
	        return "operator";
	      }
	    }
	    // is it an operator
	    else if (isOperatorChar.test(ch)) {
	      stream.eatWhile(isOperatorChar);
	      return "operator";
	    }
	    else {
	      // get the while word
	      stream.eatWhile(/[\w\$_]/);
	      // is it one of the listed keywords?
	      if (keywords && keywords.propertyIsEnumerable(stream.current().toUpperCase())) {
	        //keywords can be used as variables like flatten(group), group.$0 etc..
	        if (!stream.eat(")") && !stream.eat("."))
	          return "keyword";
	      }
	      // is it one of the builtin functions?
	      if (builtins && builtins.propertyIsEnumerable(stream.current().toUpperCase()))
	        return "variable-2";
	      // is it one of the listed types?
	      if (types && types.propertyIsEnumerable(stream.current().toUpperCase()))
	        return "variable-3";
	      // default is a 'variable'
	      return "variable";
	    }
	  }
	
	  // Interface
	  return {
	    startState: function() {
	      return {
	        tokenize: tokenBase,
	        startOfLine: true
	      };
	    },
	
	    token: function(stream, state) {
	      if(stream.eatSpace()) return null;
	      var style = state.tokenize(stream, state);
	      return style;
	    }
	  };
	});
	
	(function() {
	  function keywords(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	
	  // builtin funcs taken from trunk revision 1303237
	  var pBuiltins = "ABS ACOS ARITY ASIN ATAN AVG BAGSIZE BINSTORAGE BLOOM BUILDBLOOM CBRT CEIL "
	    + "CONCAT COR COS COSH COUNT COUNT_STAR COV CONSTANTSIZE CUBEDIMENSIONS DIFF DISTINCT DOUBLEABS "
	    + "DOUBLEAVG DOUBLEBASE DOUBLEMAX DOUBLEMIN DOUBLEROUND DOUBLESUM EXP FLOOR FLOATABS FLOATAVG "
	    + "FLOATMAX FLOATMIN FLOATROUND FLOATSUM GENERICINVOKER INDEXOF INTABS INTAVG INTMAX INTMIN "
	    + "INTSUM INVOKEFORDOUBLE INVOKEFORFLOAT INVOKEFORINT INVOKEFORLONG INVOKEFORSTRING INVOKER "
	    + "ISEMPTY JSONLOADER JSONMETADATA JSONSTORAGE LAST_INDEX_OF LCFIRST LOG LOG10 LOWER LONGABS "
	    + "LONGAVG LONGMAX LONGMIN LONGSUM MAX MIN MAPSIZE MONITOREDUDF NONDETERMINISTIC OUTPUTSCHEMA  "
	    + "PIGSTORAGE PIGSTREAMING RANDOM REGEX_EXTRACT REGEX_EXTRACT_ALL REPLACE ROUND SIN SINH SIZE "
	    + "SQRT STRSPLIT SUBSTRING SUM STRINGCONCAT STRINGMAX STRINGMIN STRINGSIZE TAN TANH TOBAG "
	    + "TOKENIZE TOMAP TOP TOTUPLE TRIM TEXTLOADER TUPLESIZE UCFIRST UPPER UTF8STORAGECONVERTER ";
	
	  // taken from QueryLexer.g
	  var pKeywords = "VOID IMPORT RETURNS DEFINE LOAD FILTER FOREACH ORDER CUBE DISTINCT COGROUP "
	    + "JOIN CROSS UNION SPLIT INTO IF OTHERWISE ALL AS BY USING INNER OUTER ONSCHEMA PARALLEL "
	    + "PARTITION GROUP AND OR NOT GENERATE FLATTEN ASC DESC IS STREAM THROUGH STORE MAPREDUCE "
	    + "SHIP CACHE INPUT OUTPUT STDERROR STDIN STDOUT LIMIT SAMPLE LEFT RIGHT FULL EQ GT LT GTE LTE "
	    + "NEQ MATCHES TRUE FALSE DUMP";
	
	  // data types
	  var pTypes = "BOOLEAN INT LONG FLOAT DOUBLE CHARARRAY BYTEARRAY BAG TUPLE MAP ";
	
	  CodeMirror.defineMIME("text/x-pig", {
	    name: "pig",
	    builtins: keywords(pBuiltins),
	    keywords: keywords(pKeywords),
	    types: keywords(pTypes)
	  });
	
	  CodeMirror.registerHelper("hintWords", "pig", (pBuiltins + pTypes + pKeywords).split(" "));
	}());
	
	});


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  'use strict';
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == 'function' && define.amd) // AMD
	    define(['codemirror'], mod);
	  else // Plain browser env
	    mod(window.CodeMirror);
	})(function(CodeMirror) {
	'use strict';
	
	CodeMirror.defineMode('powershell', function() {
	  function buildRegexp(patterns, options) {
	    options = options || {};
	    var prefix = options.prefix !== undefined ? options.prefix : '^';
	    var suffix = options.suffix !== undefined ? options.suffix : '\\b';
	
	    for (var i = 0; i < patterns.length; i++) {
	      if (patterns[i] instanceof RegExp) {
	        patterns[i] = patterns[i].source;
	      }
	      else {
	        patterns[i] = patterns[i].replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	      }
	    }
	
	    return new RegExp(prefix + '(' + patterns.join('|') + ')' + suffix, 'i');
	  }
	
	  var notCharacterOrDash = '(?=[^A-Za-z\\d\\-_]|$)';
	  var varNames = /[\w\-:]/
	  var keywords = buildRegexp([
	    /begin|break|catch|continue|data|default|do|dynamicparam/,
	    /else|elseif|end|exit|filter|finally|for|foreach|from|function|if|in/,
	    /param|process|return|switch|throw|trap|try|until|where|while/
	  ], { suffix: notCharacterOrDash });
	
	  var punctuation = /[\[\]{},;`\.]|@[({]/;
	  var wordOperators = buildRegexp([
	    'f',
	    /b?not/,
	    /[ic]?split/, 'join',
	    /is(not)?/, 'as',
	    /[ic]?(eq|ne|[gl][te])/,
	    /[ic]?(not)?(like|match|contains)/,
	    /[ic]?replace/,
	    /b?(and|or|xor)/
	  ], { prefix: '-' });
	  var symbolOperators = /[+\-*\/%]=|\+\+|--|\.\.|[+\-*&^%:=!|\/]|<(?!#)|(?!#)>/;
	  var operators = buildRegexp([wordOperators, symbolOperators], { suffix: '' });
	
	  var numbers = /^((0x[\da-f]+)|((\d+\.\d+|\d\.|\.\d+|\d+)(e[\+\-]?\d+)?))[ld]?([kmgtp]b)?/i;
	
	  var identifiers = /^[A-Za-z\_][A-Za-z\-\_\d]*\b/;
	
	  var symbolBuiltins = /[A-Z]:|%|\?/i;
	  var namedBuiltins = buildRegexp([
	    /Add-(Computer|Content|History|Member|PSSnapin|Type)/,
	    /Checkpoint-Computer/,
	    /Clear-(Content|EventLog|History|Host|Item(Property)?|Variable)/,
	    /Compare-Object/,
	    /Complete-Transaction/,
	    /Connect-PSSession/,
	    /ConvertFrom-(Csv|Json|SecureString|StringData)/,
	    /Convert-Path/,
	    /ConvertTo-(Csv|Html|Json|SecureString|Xml)/,
	    /Copy-Item(Property)?/,
	    /Debug-Process/,
	    /Disable-(ComputerRestore|PSBreakpoint|PSRemoting|PSSessionConfiguration)/,
	    /Disconnect-PSSession/,
	    /Enable-(ComputerRestore|PSBreakpoint|PSRemoting|PSSessionConfiguration)/,
	    /(Enter|Exit)-PSSession/,
	    /Export-(Alias|Clixml|Console|Counter|Csv|FormatData|ModuleMember|PSSession)/,
	    /ForEach-Object/,
	    /Format-(Custom|List|Table|Wide)/,
	    new RegExp('Get-(Acl|Alias|AuthenticodeSignature|ChildItem|Command|ComputerRestorePoint|Content|ControlPanelItem|Counter|Credential'
	      + '|Culture|Date|Event|EventLog|EventSubscriber|ExecutionPolicy|FormatData|Help|History|Host|HotFix|Item|ItemProperty|Job'
	      + '|Location|Member|Module|PfxCertificate|Process|PSBreakpoint|PSCallStack|PSDrive|PSProvider|PSSession|PSSessionConfiguration'
	      + '|PSSnapin|Random|Service|TraceSource|Transaction|TypeData|UICulture|Unique|Variable|Verb|WinEvent|WmiObject)'),
	    /Group-Object/,
	    /Import-(Alias|Clixml|Counter|Csv|LocalizedData|Module|PSSession)/,
	    /ImportSystemModules/,
	    /Invoke-(Command|Expression|History|Item|RestMethod|WebRequest|WmiMethod)/,
	    /Join-Path/,
	    /Limit-EventLog/,
	    /Measure-(Command|Object)/,
	    /Move-Item(Property)?/,
	    new RegExp('New-(Alias|Event|EventLog|Item(Property)?|Module|ModuleManifest|Object|PSDrive|PSSession|PSSessionConfigurationFile'
	      + '|PSSessionOption|PSTransportOption|Service|TimeSpan|Variable|WebServiceProxy|WinEvent)'),
	    /Out-(Default|File|GridView|Host|Null|Printer|String)/,
	    /Pause/,
	    /(Pop|Push)-Location/,
	    /Read-Host/,
	    /Receive-(Job|PSSession)/,
	    /Register-(EngineEvent|ObjectEvent|PSSessionConfiguration|WmiEvent)/,
	    /Remove-(Computer|Event|EventLog|Item(Property)?|Job|Module|PSBreakpoint|PSDrive|PSSession|PSSnapin|TypeData|Variable|WmiObject)/,
	    /Rename-(Computer|Item(Property)?)/,
	    /Reset-ComputerMachinePassword/,
	    /Resolve-Path/,
	    /Restart-(Computer|Service)/,
	    /Restore-Computer/,
	    /Resume-(Job|Service)/,
	    /Save-Help/,
	    /Select-(Object|String|Xml)/,
	    /Send-MailMessage/,
	    new RegExp('Set-(Acl|Alias|AuthenticodeSignature|Content|Date|ExecutionPolicy|Item(Property)?|Location|PSBreakpoint|PSDebug' +
	               '|PSSessionConfiguration|Service|StrictMode|TraceSource|Variable|WmiInstance)'),
	    /Show-(Command|ControlPanelItem|EventLog)/,
	    /Sort-Object/,
	    /Split-Path/,
	    /Start-(Job|Process|Service|Sleep|Transaction|Transcript)/,
	    /Stop-(Computer|Job|Process|Service|Transcript)/,
	    /Suspend-(Job|Service)/,
	    /TabExpansion2/,
	    /Tee-Object/,
	    /Test-(ComputerSecureChannel|Connection|ModuleManifest|Path|PSSessionConfigurationFile)/,
	    /Trace-Command/,
	    /Unblock-File/,
	    /Undo-Transaction/,
	    /Unregister-(Event|PSSessionConfiguration)/,
	    /Update-(FormatData|Help|List|TypeData)/,
	    /Use-Transaction/,
	    /Wait-(Event|Job|Process)/,
	    /Where-Object/,
	    /Write-(Debug|Error|EventLog|Host|Output|Progress|Verbose|Warning)/,
	    /cd|help|mkdir|more|oss|prompt/,
	    /ac|asnp|cat|cd|chdir|clc|clear|clhy|cli|clp|cls|clv|cnsn|compare|copy|cp|cpi|cpp|cvpa|dbp|del|diff|dir|dnsn|ebp/,
	    /echo|epal|epcsv|epsn|erase|etsn|exsn|fc|fl|foreach|ft|fw|gal|gbp|gc|gci|gcm|gcs|gdr|ghy|gi|gjb|gl|gm|gmo|gp|gps/,
	    /group|gsn|gsnp|gsv|gu|gv|gwmi|h|history|icm|iex|ihy|ii|ipal|ipcsv|ipmo|ipsn|irm|ise|iwmi|iwr|kill|lp|ls|man|md/,
	    /measure|mi|mount|move|mp|mv|nal|ndr|ni|nmo|npssc|nsn|nv|ogv|oh|popd|ps|pushd|pwd|r|rbp|rcjb|rcsn|rd|rdr|ren|ri/,
	    /rjb|rm|rmdir|rmo|rni|rnp|rp|rsn|rsnp|rujb|rv|rvpa|rwmi|sajb|sal|saps|sasv|sbp|sc|select|set|shcm|si|sl|sleep|sls/,
	    /sort|sp|spjb|spps|spsv|start|sujb|sv|swmi|tee|trcm|type|where|wjb|write/
	  ], { prefix: '', suffix: '' });
	  var variableBuiltins = buildRegexp([
	    /[$?^_]|Args|ConfirmPreference|ConsoleFileName|DebugPreference|Error|ErrorActionPreference|ErrorView|ExecutionContext/,
	    /FormatEnumerationLimit|Home|Host|Input|MaximumAliasCount|MaximumDriveCount|MaximumErrorCount|MaximumFunctionCount/,
	    /MaximumHistoryCount|MaximumVariableCount|MyInvocation|NestedPromptLevel|OutputEncoding|Pid|Profile|ProgressPreference/,
	    /PSBoundParameters|PSCommandPath|PSCulture|PSDefaultParameterValues|PSEmailServer|PSHome|PSScriptRoot|PSSessionApplicationName/,
	    /PSSessionConfigurationName|PSSessionOption|PSUICulture|PSVersionTable|Pwd|ShellId|StackTrace|VerbosePreference/,
	    /WarningPreference|WhatIfPreference/,
	
	    /Event|EventArgs|EventSubscriber|Sender/,
	    /Matches|Ofs|ForEach|LastExitCode|PSCmdlet|PSItem|PSSenderInfo|This/,
	    /true|false|null/
	  ], { prefix: '\\$', suffix: '' });
	
	  var builtins = buildRegexp([symbolBuiltins, namedBuiltins, variableBuiltins], { suffix: notCharacterOrDash });
	
	  var grammar = {
	    keyword: keywords,
	    number: numbers,
	    operator: operators,
	    builtin: builtins,
	    punctuation: punctuation,
	    identifier: identifiers
	  };
	
	  // tokenizers
	  function tokenBase(stream, state) {
	    // Handle Comments
	    //var ch = stream.peek();
	
	    var parent = state.returnStack[state.returnStack.length - 1];
	    if (parent && parent.shouldReturnFrom(state)) {
	      state.tokenize = parent.tokenize;
	      state.returnStack.pop();
	      return state.tokenize(stream, state);
	    }
	
	    if (stream.eatSpace()) {
	      return null;
	    }
	
	    if (stream.eat('(')) {
	      state.bracketNesting += 1;
	      return 'punctuation';
	    }
	
	    if (stream.eat(')')) {
	      state.bracketNesting -= 1;
	      return 'punctuation';
	    }
	
	    for (var key in grammar) {
	      if (stream.match(grammar[key])) {
	        return key;
	      }
	    }
	
	    var ch = stream.next();
	
	    // single-quote string
	    if (ch === "'") {
	      return tokenSingleQuoteString(stream, state);
	    }
	
	    if (ch === '$') {
	      return tokenVariable(stream, state);
	    }
	
	    // double-quote string
	    if (ch === '"') {
	      return tokenDoubleQuoteString(stream, state);
	    }
	
	    if (ch === '<' && stream.eat('#')) {
	      state.tokenize = tokenComment;
	      return tokenComment(stream, state);
	    }
	
	    if (ch === '#') {
	      stream.skipToEnd();
	      return 'comment';
	    }
	
	    if (ch === '@') {
	      var quoteMatch = stream.eat(/["']/);
	      if (quoteMatch && stream.eol()) {
	        state.tokenize = tokenMultiString;
	        state.startQuote = quoteMatch[0];
	        return tokenMultiString(stream, state);
	      } else if (stream.peek().match(/[({]/)) {
	        return 'punctuation';
	      } else if (stream.peek().match(varNames)) {
	        // splatted variable
	        return tokenVariable(stream, state);
	      }
	    }
	    return 'error';
	  }
	
	  function tokenSingleQuoteString(stream, state) {
	    var ch;
	    while ((ch = stream.peek()) != null) {
	      stream.next();
	
	      if (ch === "'" && !stream.eat("'")) {
	        state.tokenize = tokenBase;
	        return 'string';
	      }
	    }
	
	    return 'error';
	  }
	
	  function tokenDoubleQuoteString(stream, state) {
	    var ch;
	    while ((ch = stream.peek()) != null) {
	      if (ch === '$') {
	        state.tokenize = tokenStringInterpolation;
	        return 'string';
	      }
	
	      stream.next();
	      if (ch === '`') {
	        stream.next();
	        continue;
	      }
	
	      if (ch === '"' && !stream.eat('"')) {
	        state.tokenize = tokenBase;
	        return 'string';
	      }
	    }
	
	    return 'error';
	  }
	
	  function tokenStringInterpolation(stream, state) {
	    return tokenInterpolation(stream, state, tokenDoubleQuoteString);
	  }
	
	  function tokenMultiStringReturn(stream, state) {
	    state.tokenize = tokenMultiString;
	    state.startQuote = '"'
	    return tokenMultiString(stream, state);
	  }
	
	  function tokenHereStringInterpolation(stream, state) {
	    return tokenInterpolation(stream, state, tokenMultiStringReturn);
	  }
	
	  function tokenInterpolation(stream, state, parentTokenize) {
	    if (stream.match('$(')) {
	      var savedBracketNesting = state.bracketNesting;
	      state.returnStack.push({
	        /*jshint loopfunc:true */
	        shouldReturnFrom: function(state) {
	          return state.bracketNesting === savedBracketNesting;
	        },
	        tokenize: parentTokenize
	      });
	      state.tokenize = tokenBase;
	      state.bracketNesting += 1;
	      return 'punctuation';
	    } else {
	      stream.next();
	      state.returnStack.push({
	        shouldReturnFrom: function() { return true; },
	        tokenize: parentTokenize
	      });
	      state.tokenize = tokenVariable;
	      return state.tokenize(stream, state);
	    }
	  }
	
	  function tokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while ((ch = stream.next()) != null) {
	      if (maybeEnd && ch == '>') {
	          state.tokenize = tokenBase;
	          break;
	      }
	      maybeEnd = (ch === '#');
	    }
	    return 'comment';
	  }
	
	  function tokenVariable(stream, state) {
	    var ch = stream.peek();
	    if (stream.eat('{')) {
	      state.tokenize = tokenVariableWithBraces;
	      return tokenVariableWithBraces(stream, state);
	    } else if (ch != undefined && ch.match(varNames)) {
	      stream.eatWhile(varNames);
	      state.tokenize = tokenBase;
	      return 'variable-2';
	    } else {
	      state.tokenize = tokenBase;
	      return 'error';
	    }
	  }
	
	  function tokenVariableWithBraces(stream, state) {
	    var ch;
	    while ((ch = stream.next()) != null) {
	      if (ch === '}') {
	        state.tokenize = tokenBase;
	        break;
	      }
	    }
	    return 'variable-2';
	  }
	
	  function tokenMultiString(stream, state) {
	    var quote = state.startQuote;
	    if (stream.sol() && stream.match(new RegExp(quote + '@'))) {
	      state.tokenize = tokenBase;
	    }
	    else if (quote === '"') {
	      while (!stream.eol()) {
	        var ch = stream.peek();
	        if (ch === '$') {
	          state.tokenize = tokenHereStringInterpolation;
	          return 'string';
	        }
	
	        stream.next();
	        if (ch === '`') {
	          stream.next();
	        }
	      }
	    }
	    else {
	      stream.skipToEnd();
	    }
	
	    return 'string';
	  }
	
	  var external = {
	    startState: function() {
	      return {
	        returnStack: [],
	        bracketNesting: 0,
	        tokenize: tokenBase
	      };
	    },
	
	    token: function(stream, state) {
	      return state.tokenize(stream, state);
	    },
	
	    blockCommentStart: '<#',
	    blockCommentEnd: '#>',
	    lineComment: '#',
	    fold: 'brace'
	  };
	  return external;
	});
	
	CodeMirror.defineMIME('application/x-powershell', 'powershell');
	});


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("properties", function() {
	  return {
	    token: function(stream, state) {
	      var sol = stream.sol() || state.afterSection;
	      var eol = stream.eol();
	
	      state.afterSection = false;
	
	      if (sol) {
	        if (state.nextMultiline) {
	          state.inMultiline = true;
	          state.nextMultiline = false;
	        } else {
	          state.position = "def";
	        }
	      }
	
	      if (eol && ! state.nextMultiline) {
	        state.inMultiline = false;
	        state.position = "def";
	      }
	
	      if (sol) {
	        while(stream.eatSpace()) {}
	      }
	
	      var ch = stream.next();
	
	      if (sol && (ch === "#" || ch === "!" || ch === ";")) {
	        state.position = "comment";
	        stream.skipToEnd();
	        return "comment";
	      } else if (sol && ch === "[") {
	        state.afterSection = true;
	        stream.skipTo("]"); stream.eat("]");
	        return "header";
	      } else if (ch === "=" || ch === ":") {
	        state.position = "quote";
	        return null;
	      } else if (ch === "\\" && state.position === "quote") {
	        if (stream.eol()) {  // end of line?
	          // Multiline value
	          state.nextMultiline = true;
	        }
	      }
	
	      return state.position;
	    },
	
	    startState: function() {
	      return {
	        position : "def",       // Current position, "def", "quote" or "comment"
	        nextMultiline : false,  // Is the next line multiline value
	        inMultiline : false,    // Is the current line a multiline value
	        afterSection : false    // Did we just open a section
	      };
	    }
	
	  };
	});
	
	CodeMirror.defineMIME("text/x-properties", "properties");
	CodeMirror.defineMIME("text/x-ini", "properties");
	
	});


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  function wordRegexp(words) {
	    return new RegExp("^((" + words.join(")|(") + "))\\b", "i");
	  };
	
	  var keywordArray = [
	    "package", "message", "import", "syntax",
	    "required", "optional", "repeated", "reserved", "default", "extensions", "packed",
	    "bool", "bytes", "double", "enum", "float", "string",
	    "int32", "int64", "uint32", "uint64", "sint32", "sint64", "fixed32", "fixed64", "sfixed32", "sfixed64"
	  ];
	  var keywords = wordRegexp(keywordArray);
	
	  CodeMirror.registerHelper("hintWords", "protobuf", keywordArray);
	
	  var identifiers = new RegExp("^[_A-Za-z\xa1-\uffff][_A-Za-z0-9\xa1-\uffff]*");
	
	  function tokenBase(stream) {
	    // whitespaces
	    if (stream.eatSpace()) return null;
	
	    // Handle one line Comments
	    if (stream.match("//")) {
	      stream.skipToEnd();
	      return "comment";
	    }
	
	    // Handle Number Literals
	    if (stream.match(/^[0-9\.+-]/, false)) {
	      if (stream.match(/^[+-]?0x[0-9a-fA-F]+/))
	        return "number";
	      if (stream.match(/^[+-]?\d*\.\d+([EeDd][+-]?\d+)?/))
	        return "number";
	      if (stream.match(/^[+-]?\d+([EeDd][+-]?\d+)?/))
	        return "number";
	    }
	
	    // Handle Strings
	    if (stream.match(/^"([^"]|(""))*"/)) { return "string"; }
	    if (stream.match(/^'([^']|(''))*'/)) { return "string"; }
	
	    // Handle words
	    if (stream.match(keywords)) { return "keyword"; }
	    if (stream.match(identifiers)) { return "variable"; } ;
	
	    // Handle non-detected items
	    stream.next();
	    return null;
	  };
	
	  CodeMirror.defineMode("protobuf", function() {
	    return {token: tokenBase};
	  });
	
	  CodeMirror.defineMIME("text/x-protobuf", "protobuf");
	});


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("puppet", function () {
	  // Stores the words from the define method
	  var words = {};
	  // Taken, mostly, from the Puppet official variable standards regex
	  var variable_regex = /({)?([a-z][a-z0-9_]*)?((::[a-z][a-z0-9_]*)*::)?[a-zA-Z0-9_]+(})?/;
	
	  // Takes a string of words separated by spaces and adds them as
	  // keys with the value of the first argument 'style'
	  function define(style, string) {
	    var split = string.split(' ');
	    for (var i = 0; i < split.length; i++) {
	      words[split[i]] = style;
	    }
	  }
	
	  // Takes commonly known puppet types/words and classifies them to a style
	  define('keyword', 'class define site node include import inherits');
	  define('keyword', 'case if else in and elsif default or');
	  define('atom', 'false true running present absent file directory undef');
	  define('builtin', 'action augeas burst chain computer cron destination dport exec ' +
	    'file filebucket group host icmp iniface interface jump k5login limit log_level ' +
	    'log_prefix macauthorization mailalias maillist mcx mount nagios_command ' +
	    'nagios_contact nagios_contactgroup nagios_host nagios_hostdependency ' +
	    'nagios_hostescalation nagios_hostextinfo nagios_hostgroup nagios_service ' +
	    'nagios_servicedependency nagios_serviceescalation nagios_serviceextinfo ' +
	    'nagios_servicegroup nagios_timeperiod name notify outiface package proto reject ' +
	    'resources router schedule scheduled_task selboolean selmodule service source ' +
	    'sport ssh_authorized_key sshkey stage state table tidy todest toports tosource ' +
	    'user vlan yumrepo zfs zone zpool');
	
	  // After finding a start of a string ('|") this function attempts to find the end;
	  // If a variable is encountered along the way, we display it differently when it
	  // is encapsulated in a double-quoted string.
	  function tokenString(stream, state) {
	    var current, prev, found_var = false;
	    while (!stream.eol() && (current = stream.next()) != state.pending) {
	      if (current === '$' && prev != '\\' && state.pending == '"') {
	        found_var = true;
	        break;
	      }
	      prev = current;
	    }
	    if (found_var) {
	      stream.backUp(1);
	    }
	    if (current == state.pending) {
	      state.continueString = false;
	    } else {
	      state.continueString = true;
	    }
	    return "string";
	  }
	
	  // Main function
	  function tokenize(stream, state) {
	    // Matches one whole word
	    var word = stream.match(/[\w]+/, false);
	    // Matches attributes (i.e. ensure => present ; 'ensure' would be matched)
	    var attribute = stream.match(/(\s+)?\w+\s+=>.*/, false);
	    // Matches non-builtin resource declarations
	    // (i.e. "apache::vhost {" or "mycustomclasss {" would be matched)
	    var resource = stream.match(/(\s+)?[\w:_]+(\s+)?{/, false);
	    // Matches virtual and exported resources (i.e. @@user { ; and the like)
	    var special_resource = stream.match(/(\s+)?[@]{1,2}[\w:_]+(\s+)?{/, false);
	
	    // Finally advance the stream
	    var ch = stream.next();
	
	    // Have we found a variable?
	    if (ch === '$') {
	      if (stream.match(variable_regex)) {
	        // If so, and its in a string, assign it a different color
	        return state.continueString ? 'variable-2' : 'variable';
	      }
	      // Otherwise return an invalid variable
	      return "error";
	    }
	    // Should we still be looking for the end of a string?
	    if (state.continueString) {
	      // If so, go through the loop again
	      stream.backUp(1);
	      return tokenString(stream, state);
	    }
	    // Are we in a definition (class, node, define)?
	    if (state.inDefinition) {
	      // If so, return def (i.e. for 'class myclass {' ; 'myclass' would be matched)
	      if (stream.match(/(\s+)?[\w:_]+(\s+)?/)) {
	        return 'def';
	      }
	      // Match the rest it the next time around
	      stream.match(/\s+{/);
	      state.inDefinition = false;
	    }
	    // Are we in an 'include' statement?
	    if (state.inInclude) {
	      // Match and return the included class
	      stream.match(/(\s+)?\S+(\s+)?/);
	      state.inInclude = false;
	      return 'def';
	    }
	    // Do we just have a function on our hands?
	    // In 'ensure_resource("myclass")', 'ensure_resource' is matched
	    if (stream.match(/(\s+)?\w+\(/)) {
	      stream.backUp(1);
	      return 'def';
	    }
	    // Have we matched the prior attribute regex?
	    if (attribute) {
	      stream.match(/(\s+)?\w+/);
	      return 'tag';
	    }
	    // Do we have Puppet specific words?
	    if (word && words.hasOwnProperty(word)) {
	      // Negates the initial next()
	      stream.backUp(1);
	      // rs move the stream
	      stream.match(/[\w]+/);
	      // We want to process these words differently
	      // do to the importance they have in Puppet
	      if (stream.match(/\s+\S+\s+{/, false)) {
	        state.inDefinition = true;
	      }
	      if (word == 'include') {
	        state.inInclude = true;
	      }
	      // Returns their value as state in the prior define methods
	      return words[word];
	    }
	    // Is there a match on a reference?
	    if (/(^|\s+)[A-Z][\w:_]+/.test(word)) {
	      // Negate the next()
	      stream.backUp(1);
	      // Match the full reference
	      stream.match(/(^|\s+)[A-Z][\w:_]+/);
	      return 'def';
	    }
	    // Have we matched the prior resource regex?
	    if (resource) {
	      stream.match(/(\s+)?[\w:_]+/);
	      return 'def';
	    }
	    // Have we matched the prior special_resource regex?
	    if (special_resource) {
	      stream.match(/(\s+)?[@]{1,2}/);
	      return 'special';
	    }
	    // Match all the comments. All of them.
	    if (ch == "#") {
	      stream.skipToEnd();
	      return "comment";
	    }
	    // Have we found a string?
	    if (ch == "'" || ch == '"') {
	      // Store the type (single or double)
	      state.pending = ch;
	      // Perform the looping function to find the end
	      return tokenString(stream, state);
	    }
	    // Match all the brackets
	    if (ch == '{' || ch == '}') {
	      return 'bracket';
	    }
	    // Match characters that we are going to assume
	    // are trying to be regex
	    if (ch == '/') {
	      stream.match(/.*?\//);
	      return 'variable-3';
	    }
	    // Match all the numbers
	    if (ch.match(/[0-9]/)) {
	      stream.eatWhile(/[0-9]+/);
	      return 'number';
	    }
	    // Match the '=' and '=>' operators
	    if (ch == '=') {
	      if (stream.peek() == '>') {
	          stream.next();
	      }
	      return "operator";
	    }
	    // Keep advancing through all the rest
	    stream.eatWhile(/[\w-]/);
	    // Return a blank line for everything else
	    return null;
	  }
	  // Start it all
	  return {
	    startState: function () {
	      var state = {};
	      state.inDefinition = false;
	      state.inInclude = false;
	      state.continueString = false;
	      state.pending = false;
	      return state;
	    },
	    token: function (stream, state) {
	      // Strip the spaces, but regex will account for them eitherway
	      if (stream.eatSpace()) return null;
	      // Go through the main process
	      return tokenize(stream, state);
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/x-puppet", "puppet");
	
	});


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("q",function(config){
	  var indentUnit=config.indentUnit,
	      curPunc,
	      keywords=buildRE(["abs","acos","aj","aj0","all","and","any","asc","asin","asof","atan","attr","avg","avgs","bin","by","ceiling","cols","cor","cos","count","cov","cross","csv","cut","delete","deltas","desc","dev","differ","distinct","div","do","each","ej","enlist","eval","except","exec","exit","exp","fby","fills","first","fkeys","flip","floor","from","get","getenv","group","gtime","hclose","hcount","hdel","hopen","hsym","iasc","idesc","if","ij","in","insert","inter","inv","key","keys","last","like","list","lj","load","log","lower","lsq","ltime","ltrim","mavg","max","maxs","mcount","md5","mdev","med","meta","min","mins","mmax","mmin","mmu","mod","msum","neg","next","not","null","or","over","parse","peach","pj","plist","prd","prds","prev","prior","rand","rank","ratios","raze","read0","read1","reciprocal","reverse","rload","rotate","rsave","rtrim","save","scan","select","set","setenv","show","signum","sin","sqrt","ss","ssr","string","sublist","sum","sums","sv","system","tables","tan","til","trim","txf","type","uj","ungroup","union","update","upper","upsert","value","var","view","views","vs","wavg","where","where","while","within","wj","wj1","wsum","xasc","xbar","xcol","xcols","xdesc","xexp","xgroup","xkey","xlog","xprev","xrank"]),
	      E=/[|/&^!+:\\\-*%$=~#;@><,?_\'\"\[\(\]\)\s{}]/;
	  function buildRE(w){return new RegExp("^("+w.join("|")+")$");}
	  function tokenBase(stream,state){
	    var sol=stream.sol(),c=stream.next();
	    curPunc=null;
	    if(sol)
	      if(c=="/")
	        return(state.tokenize=tokenLineComment)(stream,state);
	      else if(c=="\\"){
	        if(stream.eol()||/\s/.test(stream.peek()))
	          return stream.skipToEnd(),/^\\\s*$/.test(stream.current())?(state.tokenize=tokenCommentToEOF)(stream, state):state.tokenize=tokenBase,"comment";
	        else
	          return state.tokenize=tokenBase,"builtin";
	      }
	    if(/\s/.test(c))
	      return stream.peek()=="/"?(stream.skipToEnd(),"comment"):"whitespace";
	    if(c=='"')
	      return(state.tokenize=tokenString)(stream,state);
	    if(c=='`')
	      return stream.eatWhile(/[A-Z|a-z|\d|_|:|\/|\.]/),"symbol";
	    if(("."==c&&/\d/.test(stream.peek()))||/\d/.test(c)){
	      var t=null;
	      stream.backUp(1);
	      if(stream.match(/^\d{4}\.\d{2}(m|\.\d{2}([D|T](\d{2}(:\d{2}(:\d{2}(\.\d{1,9})?)?)?)?)?)/)
	      || stream.match(/^\d+D(\d{2}(:\d{2}(:\d{2}(\.\d{1,9})?)?)?)/)
	      || stream.match(/^\d{2}:\d{2}(:\d{2}(\.\d{1,9})?)?/)
	      || stream.match(/^\d+[ptuv]{1}/))
	        t="temporal";
	      else if(stream.match(/^0[NwW]{1}/)
	      || stream.match(/^0x[\d|a-f|A-F]*/)
	      || stream.match(/^[0|1]+[b]{1}/)
	      || stream.match(/^\d+[chijn]{1}/)
	      || stream.match(/-?\d*(\.\d*)?(e[+\-]?\d+)?(e|f)?/))
	        t="number";
	      return(t&&(!(c=stream.peek())||E.test(c)))?t:(stream.next(),"error");
	    }
	    if(/[A-Z|a-z]|\./.test(c))
	      return stream.eatWhile(/[A-Z|a-z|\.|_|\d]/),keywords.test(stream.current())?"keyword":"variable";
	    if(/[|/&^!+:\\\-*%$=~#;@><\.,?_\']/.test(c))
	      return null;
	    if(/[{}\(\[\]\)]/.test(c))
	      return null;
	    return"error";
	  }
	  function tokenLineComment(stream,state){
	    return stream.skipToEnd(),/\/\s*$/.test(stream.current())?(state.tokenize=tokenBlockComment)(stream,state):(state.tokenize=tokenBase),"comment";
	  }
	  function tokenBlockComment(stream,state){
	    var f=stream.sol()&&stream.peek()=="\\";
	    stream.skipToEnd();
	    if(f&&/^\\\s*$/.test(stream.current()))
	      state.tokenize=tokenBase;
	    return"comment";
	  }
	  function tokenCommentToEOF(stream){return stream.skipToEnd(),"comment";}
	  function tokenString(stream,state){
	    var escaped=false,next,end=false;
	    while((next=stream.next())){
	      if(next=="\""&&!escaped){end=true;break;}
	      escaped=!escaped&&next=="\\";
	    }
	    if(end)state.tokenize=tokenBase;
	    return"string";
	  }
	  function pushContext(state,type,col){state.context={prev:state.context,indent:state.indent,col:col,type:type};}
	  function popContext(state){state.indent=state.context.indent;state.context=state.context.prev;}
	  return{
	    startState:function(){
	      return{tokenize:tokenBase,
	             context:null,
	             indent:0,
	             col:0};
	    },
	    token:function(stream,state){
	      if(stream.sol()){
	        if(state.context&&state.context.align==null)
	          state.context.align=false;
	        state.indent=stream.indentation();
	      }
	      //if (stream.eatSpace()) return null;
	      var style=state.tokenize(stream,state);
	      if(style!="comment"&&state.context&&state.context.align==null&&state.context.type!="pattern"){
	        state.context.align=true;
	      }
	      if(curPunc=="(")pushContext(state,")",stream.column());
	      else if(curPunc=="[")pushContext(state,"]",stream.column());
	      else if(curPunc=="{")pushContext(state,"}",stream.column());
	      else if(/[\]\}\)]/.test(curPunc)){
	        while(state.context&&state.context.type=="pattern")popContext(state);
	        if(state.context&&curPunc==state.context.type)popContext(state);
	      }
	      else if(curPunc=="."&&state.context&&state.context.type=="pattern")popContext(state);
	      else if(/atom|string|variable/.test(style)&&state.context){
	        if(/[\}\]]/.test(state.context.type))
	          pushContext(state,"pattern",stream.column());
	        else if(state.context.type=="pattern"&&!state.context.align){
	          state.context.align=true;
	          state.context.col=stream.column();
	        }
	      }
	      return style;
	    },
	    indent:function(state,textAfter){
	      var firstChar=textAfter&&textAfter.charAt(0);
	      var context=state.context;
	      if(/[\]\}]/.test(firstChar))
	        while (context&&context.type=="pattern")context=context.prev;
	      var closing=context&&firstChar==context.type;
	      if(!context)
	        return 0;
	      else if(context.type=="pattern")
	        return context.col;
	      else if(context.align)
	        return context.col+(closing?0:1);
	      else
	        return context.indent+(closing?0:indentUnit);
	    }
	  };
	});
	CodeMirror.defineMIME("text/x-q","q");
	
	});


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.registerHelper("wordChars", "r", /[\w.]/);
	
	CodeMirror.defineMode("r", function(config) {
	  function wordObj(str) {
	    var words = str.split(" "), res = {};
	    for (var i = 0; i < words.length; ++i) res[words[i]] = true;
	    return res;
	  }
	  var atoms = wordObj("NULL NA Inf NaN NA_integer_ NA_real_ NA_complex_ NA_character_");
	  var builtins = wordObj("list quote bquote eval return call parse deparse");
	  var keywords = wordObj("if else repeat while function for in next break");
	  var blockkeywords = wordObj("if else repeat while function for");
	  var opChars = /[+\-*\/^<>=!&|~$:]/;
	  var curPunc;
	
	  function tokenBase(stream, state) {
	    curPunc = null;
	    var ch = stream.next();
	    if (ch == "#") {
	      stream.skipToEnd();
	      return "comment";
	    } else if (ch == "0" && stream.eat("x")) {
	      stream.eatWhile(/[\da-f]/i);
	      return "number";
	    } else if (ch == "." && stream.eat(/\d/)) {
	      stream.match(/\d*(?:e[+\-]?\d+)?/);
	      return "number";
	    } else if (/\d/.test(ch)) {
	      stream.match(/\d*(?:\.\d+)?(?:e[+\-]\d+)?L?/);
	      return "number";
	    } else if (ch == "'" || ch == '"') {
	      state.tokenize = tokenString(ch);
	      return "string";
	    } else if (ch == "`") {
	      stream.match(/[^`]+`/);
	      return "variable-3";
	    } else if (ch == "." && stream.match(/.[.\d]+/)) {
	      return "keyword";
	    } else if (/[\w\.]/.test(ch) && ch != "_") {
	      stream.eatWhile(/[\w\.]/);
	      var word = stream.current();
	      if (atoms.propertyIsEnumerable(word)) return "atom";
	      if (keywords.propertyIsEnumerable(word)) {
	        // Block keywords start new blocks, except 'else if', which only starts
	        // one new block for the 'if', no block for the 'else'.
	        if (blockkeywords.propertyIsEnumerable(word) &&
	            !stream.match(/\s*if(\s+|$)/, false))
	          curPunc = "block";
	        return "keyword";
	      }
	      if (builtins.propertyIsEnumerable(word)) return "builtin";
	      return "variable";
	    } else if (ch == "%") {
	      if (stream.skipTo("%")) stream.next();
	      return "operator variable-2";
	    } else if (
	        (ch == "<" && stream.eat("-")) ||
	        (ch == "<" && stream.match("<-")) ||
	        (ch == "-" && stream.match(/>>?/))
	      ) {
	      return "operator arrow";
	    } else if (ch == "=" && state.ctx.argList) {
	      return "arg-is";
	    } else if (opChars.test(ch)) {
	      if (ch == "$") return "operator dollar";
	      stream.eatWhile(opChars);
	      return "operator";
	    } else if (/[\(\){}\[\];]/.test(ch)) {
	      curPunc = ch;
	      if (ch == ";") return "semi";
	      return null;
	    } else {
	      return null;
	    }
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      if (stream.eat("\\")) {
	        var ch = stream.next();
	        if (ch == "x") stream.match(/^[a-f0-9]{2}/i);
	        else if ((ch == "u" || ch == "U") && stream.eat("{") && stream.skipTo("}")) stream.next();
	        else if (ch == "u") stream.match(/^[a-f0-9]{4}/i);
	        else if (ch == "U") stream.match(/^[a-f0-9]{8}/i);
	        else if (/[0-7]/.test(ch)) stream.match(/^[0-7]{1,2}/);
	        return "string-2";
	      } else {
	        var next;
	        while ((next = stream.next()) != null) {
	          if (next == quote) { state.tokenize = tokenBase; break; }
	          if (next == "\\") { stream.backUp(1); break; }
	        }
	        return "string";
	      }
	    };
	  }
	
	  function push(state, type, stream) {
	    state.ctx = {type: type,
	                 indent: state.indent,
	                 align: null,
	                 column: stream.column(),
	                 prev: state.ctx};
	  }
	  function pop(state) {
	    state.indent = state.ctx.indent;
	    state.ctx = state.ctx.prev;
	  }
	
	  return {
	    startState: function() {
	      return {tokenize: tokenBase,
	              ctx: {type: "top",
	                    indent: -config.indentUnit,
	                    align: false},
	              indent: 0,
	              afterIdent: false};
	    },
	
	    token: function(stream, state) {
	      if (stream.sol()) {
	        if (state.ctx.align == null) state.ctx.align = false;
	        state.indent = stream.indentation();
	      }
	      if (stream.eatSpace()) return null;
	      var style = state.tokenize(stream, state);
	      if (style != "comment" && state.ctx.align == null) state.ctx.align = true;
	
	      var ctype = state.ctx.type;
	      if ((curPunc == ";" || curPunc == "{" || curPunc == "}") && ctype == "block") pop(state);
	      if (curPunc == "{") push(state, "}", stream);
	      else if (curPunc == "(") {
	        push(state, ")", stream);
	        if (state.afterIdent) state.ctx.argList = true;
	      }
	      else if (curPunc == "[") push(state, "]", stream);
	      else if (curPunc == "block") push(state, "block", stream);
	      else if (curPunc == ctype) pop(state);
	      state.afterIdent = style == "variable" || style == "keyword";
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      if (state.tokenize != tokenBase) return 0;
	      var firstChar = textAfter && textAfter.charAt(0), ctx = state.ctx,
	          closing = firstChar == ctx.type;
	      if (ctx.type == "block") return ctx.indent + (firstChar == "{" ? 0 : config.indentUnit);
	      else if (ctx.align) return ctx.column + (closing ? 0 : 1);
	      else return ctx.indent + (closing ? 0 : config.indentUnit);
	    },
	
	    lineComment: "#"
	  };
	});
	
	CodeMirror.defineMIME("text/x-rsrc", "r");
	
	});


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("rpm-changes", function() {
	  var headerSeperator = /^-+$/;
	  var headerLine = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)  ?\d{1,2} \d{2}:\d{2}(:\d{2})? [A-Z]{3,4} \d{4} - /;
	  var simpleEmail = /^[\w+.-]+@[\w.-]+/;
	
	  return {
	    token: function(stream) {
	      if (stream.sol()) {
	        if (stream.match(headerSeperator)) { return 'tag'; }
	        if (stream.match(headerLine)) { return 'tag'; }
	      }
	      if (stream.match(simpleEmail)) { return 'string'; }
	      stream.next();
	      return null;
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/x-rpm-changes", "rpm-changes");
	
	// Quick and dirty spec file highlighting
	
	CodeMirror.defineMode("rpm-spec", function() {
	  var arch = /^(i386|i586|i686|x86_64|ppc64le|ppc64|ppc|ia64|s390x|s390|sparc64|sparcv9|sparc|noarch|alphaev6|alpha|hppa|mipsel)/;
	
	  var preamble = /^[a-zA-Z0-9()]+:/;
	  var section = /^%(debug_package|package|description|prep|build|install|files|clean|changelog|preinstall|preun|postinstall|postun|pretrans|posttrans|pre|post|triggerin|triggerun|verifyscript|check|triggerpostun|triggerprein|trigger)/;
	  var control_flow_complex = /^%(ifnarch|ifarch|if)/; // rpm control flow macros
	  var control_flow_simple = /^%(else|endif)/; // rpm control flow macros
	  var operators = /^(\!|\?|\<\=|\<|\>\=|\>|\=\=|\&\&|\|\|)/; // operators in control flow macros
	
	  return {
	    startState: function () {
	        return {
	          controlFlow: false,
	          macroParameters: false,
	          section: false
	        };
	    },
	    token: function (stream, state) {
	      var ch = stream.peek();
	      if (ch == "#") { stream.skipToEnd(); return "comment"; }
	
	      if (stream.sol()) {
	        if (stream.match(preamble)) { return "header"; }
	        if (stream.match(section)) { return "atom"; }
	      }
	
	      if (stream.match(/^\$\w+/)) { return "def"; } // Variables like '$RPM_BUILD_ROOT'
	      if (stream.match(/^\$\{\w+\}/)) { return "def"; } // Variables like '${RPM_BUILD_ROOT}'
	
	      if (stream.match(control_flow_simple)) { return "keyword"; }
	      if (stream.match(control_flow_complex)) {
	        state.controlFlow = true;
	        return "keyword";
	      }
	      if (state.controlFlow) {
	        if (stream.match(operators)) { return "operator"; }
	        if (stream.match(/^(\d+)/)) { return "number"; }
	        if (stream.eol()) { state.controlFlow = false; }
	      }
	
	      if (stream.match(arch)) {
	        if (stream.eol()) { state.controlFlow = false; }
	        return "number";
	      }
	
	      // Macros like '%make_install' or '%attr(0775,root,root)'
	      if (stream.match(/^%[\w]+/)) {
	        if (stream.match(/^\(/)) { state.macroParameters = true; }
	        return "keyword";
	      }
	      if (state.macroParameters) {
	        if (stream.match(/^\d+/)) { return "number";}
	        if (stream.match(/^\)/)) {
	          state.macroParameters = false;
	          return "keyword";
	        }
	      }
	
	      // Macros like '%{defined fedora}'
	      if (stream.match(/^%\{\??[\w \-\:\!]+\}/)) {
	        if (stream.eol()) { state.controlFlow = false; }
	        return "def";
	      }
	
	      //TODO: Include bash script sub-parser (CodeMirror supports that)
	      stream.next();
	      return null;
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/x-rpm-spec", "rpm-spec");
	
	});


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(84), __webpack_require__(87), __webpack_require__(19));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../python/python", "../stex/stex", "../../addon/mode/overlay"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode('rst', function (config, options) {
	
	  var rx_strong = /^\*\*[^\*\s](?:[^\*]*[^\*\s])?\*\*/;
	  var rx_emphasis = /^\*[^\*\s](?:[^\*]*[^\*\s])?\*/;
	  var rx_literal = /^``[^`\s](?:[^`]*[^`\s])``/;
	
	  var rx_number = /^(?:[\d]+(?:[\.,]\d+)*)/;
	  var rx_positive = /^(?:\s\+[\d]+(?:[\.,]\d+)*)/;
	  var rx_negative = /^(?:\s\-[\d]+(?:[\.,]\d+)*)/;
	
	  var rx_uri_protocol = "[Hh][Tt][Tt][Pp][Ss]?://";
	  var rx_uri_domain = "(?:[\\d\\w.-]+)\\.(?:\\w{2,6})";
	  var rx_uri_path = "(?:/[\\d\\w\\#\\%\\&\\-\\.\\,\\/\\:\\=\\?\\~]+)*";
	  var rx_uri = new RegExp("^" + rx_uri_protocol + rx_uri_domain + rx_uri_path);
	
	  var overlay = {
	    token: function (stream) {
	
	      if (stream.match(rx_strong) && stream.match (/\W+|$/, false))
	        return 'strong';
	      if (stream.match(rx_emphasis) && stream.match (/\W+|$/, false))
	        return 'em';
	      if (stream.match(rx_literal) && stream.match (/\W+|$/, false))
	        return 'string-2';
	      if (stream.match(rx_number))
	        return 'number';
	      if (stream.match(rx_positive))
	        return 'positive';
	      if (stream.match(rx_negative))
	        return 'negative';
	      if (stream.match(rx_uri))
	        return 'link';
	
	      while (stream.next() != null) {
	        if (stream.match(rx_strong, false)) break;
	        if (stream.match(rx_emphasis, false)) break;
	        if (stream.match(rx_literal, false)) break;
	        if (stream.match(rx_number, false)) break;
	        if (stream.match(rx_positive, false)) break;
	        if (stream.match(rx_negative, false)) break;
	        if (stream.match(rx_uri, false)) break;
	      }
	
	      return null;
	    }
	  };
	
	  var mode = CodeMirror.getMode(
	    config, options.backdrop || 'rst-base'
	  );
	
	  return CodeMirror.overlayMode(mode, overlay, true); // combine
	}, 'python', 'stex');
	
	///////////////////////////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////
	
	CodeMirror.defineMode('rst-base', function (config) {
	
	  ///////////////////////////////////////////////////////////////////////////
	  ///////////////////////////////////////////////////////////////////////////
	
	  function format(string) {
	    var args = Array.prototype.slice.call(arguments, 1);
	    return string.replace(/{(\d+)}/g, function (match, n) {
	      return typeof args[n] != 'undefined' ? args[n] : match;
	    });
	  }
	
	  ///////////////////////////////////////////////////////////////////////////
	  ///////////////////////////////////////////////////////////////////////////
	
	  var mode_python = CodeMirror.getMode(config, 'python');
	  var mode_stex = CodeMirror.getMode(config, 'stex');
	
	  ///////////////////////////////////////////////////////////////////////////
	  ///////////////////////////////////////////////////////////////////////////
	
	  var SEPA = "\\s+";
	  var TAIL = "(?:\\s*|\\W|$)",
	  rx_TAIL = new RegExp(format('^{0}', TAIL));
	
	  var NAME =
	    "(?:[^\\W\\d_](?:[\\w!\"#$%&'()\\*\\+,\\-\\.\/:;<=>\\?]*[^\\W_])?)",
	  rx_NAME = new RegExp(format('^{0}', NAME));
	  var NAME_WWS =
	    "(?:[^\\W\\d_](?:[\\w\\s!\"#$%&'()\\*\\+,\\-\\.\/:;<=>\\?]*[^\\W_])?)";
	  var REF_NAME = format('(?:{0}|`{1}`)', NAME, NAME_WWS);
	
	  var TEXT1 = "(?:[^\\s\\|](?:[^\\|]*[^\\s\\|])?)";
	  var TEXT2 = "(?:[^\\`]+)",
	  rx_TEXT2 = new RegExp(format('^{0}', TEXT2));
	
	  var rx_section = new RegExp(
	    "^([!'#$%&\"()*+,-./:;<=>?@\\[\\\\\\]^_`{|}~])\\1{3,}\\s*$");
	  var rx_explicit = new RegExp(
	    format('^\\.\\.{0}', SEPA));
	  var rx_link = new RegExp(
	    format('^_{0}:{1}|^__:{1}', REF_NAME, TAIL));
	  var rx_directive = new RegExp(
	    format('^{0}::{1}', REF_NAME, TAIL));
	  var rx_substitution = new RegExp(
	    format('^\\|{0}\\|{1}{2}::{3}', TEXT1, SEPA, REF_NAME, TAIL));
	  var rx_footnote = new RegExp(
	    format('^\\[(?:\\d+|#{0}?|\\*)]{1}', REF_NAME, TAIL));
	  var rx_citation = new RegExp(
	    format('^\\[{0}\\]{1}', REF_NAME, TAIL));
	
	  var rx_substitution_ref = new RegExp(
	    format('^\\|{0}\\|', TEXT1));
	  var rx_footnote_ref = new RegExp(
	    format('^\\[(?:\\d+|#{0}?|\\*)]_', REF_NAME));
	  var rx_citation_ref = new RegExp(
	    format('^\\[{0}\\]_', REF_NAME));
	  var rx_link_ref1 = new RegExp(
	    format('^{0}__?', REF_NAME));
	  var rx_link_ref2 = new RegExp(
	    format('^`{0}`_', TEXT2));
	
	  var rx_role_pre = new RegExp(
	    format('^:{0}:`{1}`{2}', NAME, TEXT2, TAIL));
	  var rx_role_suf = new RegExp(
	    format('^`{1}`:{0}:{2}', NAME, TEXT2, TAIL));
	  var rx_role = new RegExp(
	    format('^:{0}:{1}', NAME, TAIL));
	
	  var rx_directive_name = new RegExp(format('^{0}', REF_NAME));
	  var rx_directive_tail = new RegExp(format('^::{0}', TAIL));
	  var rx_substitution_text = new RegExp(format('^\\|{0}\\|', TEXT1));
	  var rx_substitution_sepa = new RegExp(format('^{0}', SEPA));
	  var rx_substitution_name = new RegExp(format('^{0}', REF_NAME));
	  var rx_substitution_tail = new RegExp(format('^::{0}', TAIL));
	  var rx_link_head = new RegExp("^_");
	  var rx_link_name = new RegExp(format('^{0}|_', REF_NAME));
	  var rx_link_tail = new RegExp(format('^:{0}', TAIL));
	
	  var rx_verbatim = new RegExp('^::\\s*$');
	  var rx_examples = new RegExp('^\\s+(?:>>>|In \\[\\d+\\]:)\\s');
	
	  ///////////////////////////////////////////////////////////////////////////
	  ///////////////////////////////////////////////////////////////////////////
	
	  function to_normal(stream, state) {
	    var token = null;
	
	    if (stream.sol() && stream.match(rx_examples, false)) {
	      change(state, to_mode, {
	        mode: mode_python, local: CodeMirror.startState(mode_python)
	      });
	    } else if (stream.sol() && stream.match(rx_explicit)) {
	      change(state, to_explicit);
	      token = 'meta';
	    } else if (stream.sol() && stream.match(rx_section)) {
	      change(state, to_normal);
	      token = 'header';
	    } else if (phase(state) == rx_role_pre ||
	               stream.match(rx_role_pre, false)) {
	
	      switch (stage(state)) {
	      case 0:
	        change(state, to_normal, context(rx_role_pre, 1));
	        stream.match(/^:/);
	        token = 'meta';
	        break;
	      case 1:
	        change(state, to_normal, context(rx_role_pre, 2));
	        stream.match(rx_NAME);
	        token = 'keyword';
	
	        if (stream.current().match(/^(?:math|latex)/)) {
	          state.tmp_stex = true;
	        }
	        break;
	      case 2:
	        change(state, to_normal, context(rx_role_pre, 3));
	        stream.match(/^:`/);
	        token = 'meta';
	        break;
	      case 3:
	        if (state.tmp_stex) {
	          state.tmp_stex = undefined; state.tmp = {
	            mode: mode_stex, local: CodeMirror.startState(mode_stex)
	          };
	        }
	
	        if (state.tmp) {
	          if (stream.peek() == '`') {
	            change(state, to_normal, context(rx_role_pre, 4));
	            state.tmp = undefined;
	            break;
	          }
	
	          token = state.tmp.mode.token(stream, state.tmp.local);
	          break;
	        }
	
	        change(state, to_normal, context(rx_role_pre, 4));
	        stream.match(rx_TEXT2);
	        token = 'string';
	        break;
	      case 4:
	        change(state, to_normal, context(rx_role_pre, 5));
	        stream.match(/^`/);
	        token = 'meta';
	        break;
	      case 5:
	        change(state, to_normal, context(rx_role_pre, 6));
	        stream.match(rx_TAIL);
	        break;
	      default:
	        change(state, to_normal);
	      }
	    } else if (phase(state) == rx_role_suf ||
	               stream.match(rx_role_suf, false)) {
	
	      switch (stage(state)) {
	      case 0:
	        change(state, to_normal, context(rx_role_suf, 1));
	        stream.match(/^`/);
	        token = 'meta';
	        break;
	      case 1:
	        change(state, to_normal, context(rx_role_suf, 2));
	        stream.match(rx_TEXT2);
	        token = 'string';
	        break;
	      case 2:
	        change(state, to_normal, context(rx_role_suf, 3));
	        stream.match(/^`:/);
	        token = 'meta';
	        break;
	      case 3:
	        change(state, to_normal, context(rx_role_suf, 4));
	        stream.match(rx_NAME);
	        token = 'keyword';
	        break;
	      case 4:
	        change(state, to_normal, context(rx_role_suf, 5));
	        stream.match(/^:/);
	        token = 'meta';
	        break;
	      case 5:
	        change(state, to_normal, context(rx_role_suf, 6));
	        stream.match(rx_TAIL);
	        break;
	      default:
	        change(state, to_normal);
	      }
	    } else if (phase(state) == rx_role || stream.match(rx_role, false)) {
	
	      switch (stage(state)) {
	      case 0:
	        change(state, to_normal, context(rx_role, 1));
	        stream.match(/^:/);
	        token = 'meta';
	        break;
	      case 1:
	        change(state, to_normal, context(rx_role, 2));
	        stream.match(rx_NAME);
	        token = 'keyword';
	        break;
	      case 2:
	        change(state, to_normal, context(rx_role, 3));
	        stream.match(/^:/);
	        token = 'meta';
	        break;
	      case 3:
	        change(state, to_normal, context(rx_role, 4));
	        stream.match(rx_TAIL);
	        break;
	      default:
	        change(state, to_normal);
	      }
	    } else if (phase(state) == rx_substitution_ref ||
	               stream.match(rx_substitution_ref, false)) {
	
	      switch (stage(state)) {
	      case 0:
	        change(state, to_normal, context(rx_substitution_ref, 1));
	        stream.match(rx_substitution_text);
	        token = 'variable-2';
	        break;
	      case 1:
	        change(state, to_normal, context(rx_substitution_ref, 2));
	        if (stream.match(/^_?_?/)) token = 'link';
	        break;
	      default:
	        change(state, to_normal);
	      }
	    } else if (stream.match(rx_footnote_ref)) {
	      change(state, to_normal);
	      token = 'quote';
	    } else if (stream.match(rx_citation_ref)) {
	      change(state, to_normal);
	      token = 'quote';
	    } else if (stream.match(rx_link_ref1)) {
	      change(state, to_normal);
	      if (!stream.peek() || stream.peek().match(/^\W$/)) {
	        token = 'link';
	      }
	    } else if (phase(state) == rx_link_ref2 ||
	               stream.match(rx_link_ref2, false)) {
	
	      switch (stage(state)) {
	      case 0:
	        if (!stream.peek() || stream.peek().match(/^\W$/)) {
	          change(state, to_normal, context(rx_link_ref2, 1));
	        } else {
	          stream.match(rx_link_ref2);
	        }
	        break;
	      case 1:
	        change(state, to_normal, context(rx_link_ref2, 2));
	        stream.match(/^`/);
	        token = 'link';
	        break;
	      case 2:
	        change(state, to_normal, context(rx_link_ref2, 3));
	        stream.match(rx_TEXT2);
	        break;
	      case 3:
	        change(state, to_normal, context(rx_link_ref2, 4));
	        stream.match(/^`_/);
	        token = 'link';
	        break;
	      default:
	        change(state, to_normal);
	      }
	    } else if (stream.match(rx_verbatim)) {
	      change(state, to_verbatim);
	    }
	
	    else {
	      if (stream.next()) change(state, to_normal);
	    }
	
	    return token;
	  }
	
	  ///////////////////////////////////////////////////////////////////////////
	  ///////////////////////////////////////////////////////////////////////////
	
	  function to_explicit(stream, state) {
	    var token = null;
	
	    if (phase(state) == rx_substitution ||
	        stream.match(rx_substitution, false)) {
	
	      switch (stage(state)) {
	      case 0:
	        change(state, to_explicit, context(rx_substitution, 1));
	        stream.match(rx_substitution_text);
	        token = 'variable-2';
	        break;
	      case 1:
	        change(state, to_explicit, context(rx_substitution, 2));
	        stream.match(rx_substitution_sepa);
	        break;
	      case 2:
	        change(state, to_explicit, context(rx_substitution, 3));
	        stream.match(rx_substitution_name);
	        token = 'keyword';
	        break;
	      case 3:
	        change(state, to_explicit, context(rx_substitution, 4));
	        stream.match(rx_substitution_tail);
	        token = 'meta';
	        break;
	      default:
	        change(state, to_normal);
	      }
	    } else if (phase(state) == rx_directive ||
	               stream.match(rx_directive, false)) {
	
	      switch (stage(state)) {
	      case 0:
	        change(state, to_explicit, context(rx_directive, 1));
	        stream.match(rx_directive_name);
	        token = 'keyword';
	
	        if (stream.current().match(/^(?:math|latex)/))
	          state.tmp_stex = true;
	        else if (stream.current().match(/^python/))
	          state.tmp_py = true;
	        break;
	      case 1:
	        change(state, to_explicit, context(rx_directive, 2));
	        stream.match(rx_directive_tail);
	        token = 'meta';
	
	        if (stream.match(/^latex\s*$/) || state.tmp_stex) {
	          state.tmp_stex = undefined; change(state, to_mode, {
	            mode: mode_stex, local: CodeMirror.startState(mode_stex)
	          });
	        }
	        break;
	      case 2:
	        change(state, to_explicit, context(rx_directive, 3));
	        if (stream.match(/^python\s*$/) || state.tmp_py) {
	          state.tmp_py = undefined; change(state, to_mode, {
	            mode: mode_python, local: CodeMirror.startState(mode_python)
	          });
	        }
	        break;
	      default:
	        change(state, to_normal);
	      }
	    } else if (phase(state) == rx_link || stream.match(rx_link, false)) {
	
	      switch (stage(state)) {
	      case 0:
	        change(state, to_explicit, context(rx_link, 1));
	        stream.match(rx_link_head);
	        stream.match(rx_link_name);
	        token = 'link';
	        break;
	      case 1:
	        change(state, to_explicit, context(rx_link, 2));
	        stream.match(rx_link_tail);
	        token = 'meta';
	        break;
	      default:
	        change(state, to_normal);
	      }
	    } else if (stream.match(rx_footnote)) {
	      change(state, to_normal);
	      token = 'quote';
	    } else if (stream.match(rx_citation)) {
	      change(state, to_normal);
	      token = 'quote';
	    }
	
	    else {
	      stream.eatSpace();
	      if (stream.eol()) {
	        change(state, to_normal);
	      } else {
	        stream.skipToEnd();
	        change(state, to_comment);
	        token = 'comment';
	      }
	    }
	
	    return token;
	  }
	
	  ///////////////////////////////////////////////////////////////////////////
	  ///////////////////////////////////////////////////////////////////////////
	
	  function to_comment(stream, state) {
	    return as_block(stream, state, 'comment');
	  }
	
	  function to_verbatim(stream, state) {
	    return as_block(stream, state, 'meta');
	  }
	
	  function as_block(stream, state, token) {
	    if (stream.eol() || stream.eatSpace()) {
	      stream.skipToEnd();
	      return token;
	    } else {
	      change(state, to_normal);
	      return null;
	    }
	  }
	
	  ///////////////////////////////////////////////////////////////////////////
	  ///////////////////////////////////////////////////////////////////////////
	
	  function to_mode(stream, state) {
	
	    if (state.ctx.mode && state.ctx.local) {
	
	      if (stream.sol()) {
	        if (!stream.eatSpace()) change(state, to_normal);
	        return null;
	      }
	
	      return state.ctx.mode.token(stream, state.ctx.local);
	    }
	
	    change(state, to_normal);
	    return null;
	  }
	
	  ///////////////////////////////////////////////////////////////////////////
	  ///////////////////////////////////////////////////////////////////////////
	
	  function context(phase, stage, mode, local) {
	    return {phase: phase, stage: stage, mode: mode, local: local};
	  }
	
	  function change(state, tok, ctx) {
	    state.tok = tok;
	    state.ctx = ctx || {};
	  }
	
	  function stage(state) {
	    return state.ctx.stage || 0;
	  }
	
	  function phase(state) {
	    return state.ctx.phase;
	  }
	
	  ///////////////////////////////////////////////////////////////////////////
	  ///////////////////////////////////////////////////////////////////////////
	
	  return {
	    startState: function () {
	      return {tok: to_normal, ctx: context(undefined, 0)};
	    },
	
	    copyState: function (state) {
	      var ctx = state.ctx, tmp = state.tmp;
	      if (ctx.local)
	        ctx = {mode: ctx.mode, local: CodeMirror.copyState(ctx.mode, ctx.local)};
	      if (tmp)
	        tmp = {mode: tmp.mode, local: CodeMirror.copyState(tmp.mode, tmp.local)};
	      return {tok: state.tok, ctx: ctx, tmp: tmp};
	    },
	
	    innerMode: function (state) {
	      return state.tmp      ? {state: state.tmp.local, mode: state.tmp.mode}
	      : state.ctx.mode ? {state: state.ctx.local, mode: state.ctx.mode}
	      : null;
	    },
	
	    token: function (stream, state) {
	      return state.tok(stream, state);
	    }
	  };
	}, 'python', 'stex');
	
	///////////////////////////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////
	
	CodeMirror.defineMIME('text/x-rst', 'rst');
	
	///////////////////////////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////
	
	});


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(20));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../../addon/mode/simple"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineSimpleMode("rust",{
	  start: [
	    // string and byte string
	    {regex: /b?"/, token: "string", next: "string"},
	    // raw string and raw byte string
	    {regex: /b?r"/, token: "string", next: "string_raw"},
	    {regex: /b?r#+"/, token: "string", next: "string_raw_hash"},
	    // character
	    {regex: /'(?:[^'\\]|\\(?:[nrt0'"]|x[\da-fA-F]{2}|u\{[\da-fA-F]{6}\}))'/, token: "string-2"},
	    // byte
	    {regex: /b'(?:[^']|\\(?:['\\nrt0]|x[\da-fA-F]{2}))'/, token: "string-2"},
	
	    {regex: /(?:(?:[0-9][0-9_]*)(?:(?:[Ee][+-]?[0-9_]+)|\.[0-9_]+(?:[Ee][+-]?[0-9_]+)?)(?:f32|f64)?)|(?:0(?:b[01_]+|(?:o[0-7_]+)|(?:x[0-9a-fA-F_]+))|(?:[0-9][0-9_]*))(?:u8|u16|u32|u64|i8|i16|i32|i64|isize|usize)?/,
	     token: "number"},
	    {regex: /(let(?:\s+mut)?|fn|enum|mod|struct|type)(\s+)([a-zA-Z_][a-zA-Z0-9_]*)/, token: ["keyword", null, "def"]},
	    {regex: /(?:abstract|alignof|as|box|break|continue|const|crate|do|else|enum|extern|fn|for|final|if|impl|in|loop|macro|match|mod|move|offsetof|override|priv|proc|pub|pure|ref|return|self|sizeof|static|struct|super|trait|type|typeof|unsafe|unsized|use|virtual|where|while|yield)\b/, token: "keyword"},
	    {regex: /\b(?:Self|isize|usize|char|bool|u8|u16|u32|u64|f16|f32|f64|i8|i16|i32|i64|str|Option)\b/, token: "atom"},
	    {regex: /\b(?:true|false|Some|None|Ok|Err)\b/, token: "builtin"},
	    {regex: /\b(fn)(\s+)([a-zA-Z_][a-zA-Z0-9_]*)/,
	     token: ["keyword", null ,"def"]},
	    {regex: /#!?\[.*\]/, token: "meta"},
	    {regex: /\/\/.*/, token: "comment"},
	    {regex: /\/\*/, token: "comment", next: "comment"},
	    {regex: /[-+\/*=<>!]+/, token: "operator"},
	    {regex: /[a-zA-Z_]\w*!/,token: "variable-3"},
	    {regex: /[a-zA-Z_]\w*/, token: "variable"},
	    {regex: /[\{\[\(]/, indent: true},
	    {regex: /[\}\]\)]/, dedent: true}
	  ],
	  string: [
	    {regex: /"/, token: "string", next: "start"},
	    {regex: /(?:[^\\"]|\\(?:.|$))*/, token: "string"}
	  ],
	  string_raw: [
	    {regex: /"/, token: "string", next: "start"},
	    {regex: /[^"]*/, token: "string"}
	  ],
	  string_raw_hash: [
	    {regex: /"#+/, token: "string", next: "start"},
	    {regex: /(?:[^"]|"(?!#))*/, token: "string"}
	  ],
	  comment: [
	    {regex: /.*?\*\//, token: "comment", next: "start"},
	    {regex: /.*/, token: "comment"}
	  ],
	  meta: {
	    dontIndentStates: ["comment"],
	    electricInput: /^\s*\}$/,
	    blockCommentStart: "/*",
	    blockCommentEnd: "*/",
	    lineComment: "//",
	    fold: "brace"
	  }
	});
	
	
	CodeMirror.defineMIME("text/x-rustsrc", "rust");
	});


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	
	// SAS mode copyright (c) 2016 Jared Dean, SAS Institute
	// Created by Jared Dean
	
	// TODO
	// indent and de-indent
	// identify macro variables
	
	
	//Definitions
	//  comment -- text withing * ; or /* */
	//  keyword -- SAS language variable
	//  variable -- macro variables starts with '&' or variable formats
	//  variable-2 -- DATA Step, proc, or macro names
	//  string -- text within ' ' or " "
	//  operator -- numeric operator + / - * ** le eq ge ... and so on
	//  builtin -- proc %macro data run mend
	//  atom
	//  def
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("sas", function () {
	    var words = {};
	    var isDoubleOperatorSym = {
	      eq: 'operator',
	      lt: 'operator',
	      le: 'operator',
	      gt: 'operator',
	      ge: 'operator',
	      "in": 'operator',
	      ne: 'operator',
	      or: 'operator'
	    };
	    var isDoubleOperatorChar = /(<=|>=|!=|<>)/;
	    var isSingleOperatorChar = /[=\(:\),{}.*<>+\-\/^\[\]]/;
	
	    // Takes a string of words separated by spaces and adds them as
	    // keys with the value of the first argument 'style'
	    function define(style, string, context) {
	      if (context) {
	        var split = string.split(' ');
	        for (var i = 0; i < split.length; i++) {
	          words[split[i]] = {style: style, state: context};
	        }
	      }
	    }
	    //datastep
	    define('def', 'stack pgm view source debug nesting nolist', ['inDataStep']);
	    define('def', 'if while until for do do; end end; then else cancel', ['inDataStep']);
	    define('def', 'label format _n_ _error_', ['inDataStep']);
	    define('def', 'ALTER BUFNO BUFSIZE CNTLLEV COMPRESS DLDMGACTION ENCRYPT ENCRYPTKEY EXTENDOBSCOUNTER GENMAX GENNUM INDEX LABEL OBSBUF OUTREP PW PWREQ READ REPEMPTY REPLACE REUSE ROLE SORTEDBY SPILL TOBSNO TYPE WRITE FILECLOSE FIRSTOBS IN OBS POINTOBS WHERE WHEREUP IDXNAME IDXWHERE DROP KEEP RENAME', ['inDataStep']);
	    define('def', 'filevar finfo finv fipname fipnamel fipstate first firstobs floor', ['inDataStep']);
	    define('def', 'varfmt varinfmt varlabel varlen varname varnum varray varrayx vartype verify vformat vformatd vformatdx vformatn vformatnx vformatw vformatwx vformatx vinarray vinarrayx vinformat vinformatd vinformatdx vinformatn vinformatnx vinformatw vinformatwx vinformatx vlabel vlabelx vlength vlengthx vname vnamex vnferr vtype vtypex weekday', ['inDataStep']);
	    define('def', 'zipfips zipname zipnamel zipstate', ['inDataStep']);
	    define('def', 'put putc putn', ['inDataStep']);
	    define('builtin', 'data run', ['inDataStep']);
	
	
	    //proc
	    define('def', 'data', ['inProc']);
	
	    // flow control for macros
	    define('def', '%if %end %end; %else %else; %do %do; %then', ['inMacro']);
	
	    //everywhere
	    define('builtin', 'proc run; quit; libname filename %macro %mend option options', ['ALL']);
	
	    define('def', 'footnote title libname ods', ['ALL']);
	    define('def', '%let %put %global %sysfunc %eval ', ['ALL']);
	    // automatic macro variables http://support.sas.com/documentation/cdl/en/mcrolref/61885/HTML/default/viewer.htm#a003167023.htm
	    define('variable', '&sysbuffr &syscc &syscharwidth &syscmd &sysdate &sysdate9 &sysday &sysdevic &sysdmg &sysdsn &sysencoding &sysenv &syserr &syserrortext &sysfilrc &syshostname &sysindex &sysinfo &sysjobid &syslast &syslckrc &syslibrc &syslogapplname &sysmacroname &sysmenv &sysmsg &sysncpu &sysodspath &sysparm &syspbuff &sysprocessid &sysprocessname &sysprocname &sysrc &sysscp &sysscpl &sysscpl &syssite &sysstartid &sysstartname &systcpiphostname &systime &sysuserid &sysver &sysvlong &sysvlong4 &syswarningtext', ['ALL']);
	
	    //footnote[1-9]? title[1-9]?
	
	    //options statement
	    define('def', 'source2 nosource2 page pageno pagesize', ['ALL']);
	
	    //proc and datastep
	    define('def', '_all_ _character_ _cmd_ _freq_ _i_ _infile_ _last_ _msg_ _null_ _numeric_ _temporary_ _type_ abort abs addr adjrsq airy alpha alter altlog altprint and arcos array arsin as atan attrc attrib attrn authserver autoexec awscontrol awsdef awsmenu awsmenumerge awstitle backward band base betainv between blocksize blshift bnot bor brshift bufno bufsize bxor by byerr byline byte calculated call cards cards4 catcache cbufno cdf ceil center cexist change chisq cinv class cleanup close cnonct cntllev coalesce codegen col collate collin column comamid comaux1 comaux2 comdef compbl compound compress config continue convert cos cosh cpuid create cross crosstab css curobs cv daccdb daccdbsl daccsl daccsyd dacctab dairy datalines datalines4 datejul datepart datetime day dbcslang dbcstype dclose ddm delete delimiter depdb depdbsl depsl depsyd deptab dequote descending descript design= device dflang dhms dif digamma dim dinfo display distinct dkricond dkrocond dlm dnum do dopen doptname doptnum dread drop dropnote dsname dsnferr echo else emaildlg emailid emailpw emailserver emailsys encrypt end endsas engine eof eov erf erfc error errorcheck errors exist exp fappend fclose fcol fdelete feedback fetch fetchobs fexist fget file fileclose fileexist filefmt filename fileref  fmterr fmtsearch fnonct fnote font fontalias  fopen foptname foptnum force formatted formchar formdelim formdlim forward fpoint fpos fput fread frewind frlen from fsep fuzz fwrite gaminv gamma getoption getvarc getvarn go goto group gwindow hbar hbound helpenv helploc hms honorappearance hosthelp hostprint hour hpct html hvar ibessel ibr id if index indexc indexw initcmd initstmt inner input inputc inputn inr insert int intck intnx into intrr invaliddata irr is jbessel join juldate keep kentb kurtosis label lag last lbound leave left length levels lgamma lib  library libref line linesize link list log log10 log2 logpdf logpmf logsdf lostcard lowcase lrecl ls macro macrogen maps mautosource max maxdec maxr mdy mean measures median memtype merge merror min minute missing missover mlogic mod mode model modify month mopen mort mprint mrecall msglevel msymtabmax mvarsize myy n nest netpv new news nmiss no nobatch nobs nocaps nocardimage nocenter nocharcode nocmdmac nocol nocum nodate nodbcs nodetails nodmr nodms nodmsbatch nodup nodupkey noduplicates noechoauto noequals noerrorabend noexitwindows nofullstimer noicon noimplmac noint nolist noloadlist nomiss nomlogic nomprint nomrecall nomsgcase nomstored nomultenvappl nonotes nonumber noobs noovp nopad nopercent noprint noprintinit normal norow norsasuser nosetinit  nosplash nosymbolgen note notes notitle notitles notsorted noverbose noxsync noxwait npv null number numkeys nummousekeys nway obs  on open     order ordinal otherwise out outer outp= output over ovp p(1 5 10 25 50 75 90 95 99) pad pad2  paired parm parmcards path pathdll pathname pdf peek peekc pfkey pmf point poisson poke position printer probbeta probbnml probchi probf probgam probhypr probit probnegb probnorm probsig probt procleave prt ps  pw pwreq qtr quote r ranbin rancau ranexp rangam range ranks rannor ranpoi rantbl rantri ranuni read recfm register regr remote remove rename repeat replace resolve retain return reuse reverse rewind right round rsquare rtf rtrace rtraceloc s s2 samploc sasautos sascontrol sasfrscr sasmsg sasmstore sasscript sasuser saving scan sdf second select selection separated seq serror set setcomm setot sign simple sin sinh siteinfo skewness skip sle sls sortedby sortpgm sortseq sortsize soundex  spedis splashlocation split spool sqrt start std stderr stdin stfips stimer stname stnamel stop stopover subgroup subpopn substr sum sumwgt symbol symbolgen symget symput sysget sysin sysleave sysmsg sysparm sysprint sysprintfont sysprod sysrc system t table tables tan tanh tapeclose tbufsize terminal test then timepart tinv  tnonct to today tol tooldef totper transformout translate trantab tranwrd trigamma trim trimn trunc truncover type unformatted uniform union until upcase update user usericon uss validate value var  weight when where while wincharset window work workinit workterm write wsum xsync xwait yearcutoff yes yyq  min max', ['inDataStep', 'inProc']);
	    define('operator', 'and not ', ['inDataStep', 'inProc']);
	
	    // Main function
	    function tokenize(stream, state) {
	      // Finally advance the stream
	      var ch = stream.next();
	
	      // BLOCKCOMMENT
	      if (ch === '/' && stream.eat('*')) {
	        state.continueComment = true;
	        return "comment";
	      } else if (state.continueComment === true) { // in comment block
	        //comment ends at the beginning of the line
	        if (ch === '*' && stream.peek() === '/') {
	          stream.next();
	          state.continueComment = false;
	        } else if (stream.skipTo('*')) { //comment is potentially later in line
	          stream.skipTo('*');
	          stream.next();
	          if (stream.eat('/'))
	            state.continueComment = false;
	        } else {
	          stream.skipToEnd();
	        }
	        return "comment";
	      }
	
	      // DoubleOperator match
	      var doubleOperator = ch + stream.peek();
	
	      // Match all line comments.
	      var myString = stream.string;
	      var myRegexp = /(?:^\s*|[;]\s*)(\*.*?);/ig;
	      var match = myRegexp.exec(myString);
	      if (match !== null) {
	        if (match.index === 0 && (stream.column() !== (match.index + match[0].length - 1))) {
	          stream.backUp(stream.column());
	          stream.skipTo(';');
	          stream.next();
	          return 'comment';
	        } else if (match.index + 1 < stream.column() && stream.column() < match.index + match[0].length - 1) {
	          // the ';' triggers the match so move one past it to start
	          // the comment block that is why match.index+1
	          stream.backUp(stream.column() - match.index - 1);
	          stream.skipTo(';');
	          stream.next();
	          return 'comment';
	        }
	      } else if ((ch === '"' || ch === "'") && !state.continueString) {
	        state.continueString = ch
	        return "string"
	      } else if (state.continueString) {
	        if (state.continueString == ch) {
	          state.continueString = null;
	        } else if (stream.skipTo(state.continueString)) {
	          // quote found on this line
	          stream.next();
	          state.continueString = null;
	        } else {
	          stream.skipToEnd();
	        }
	        return "string";
	      } else if (state.continueString !== null && stream.eol()) {
	        stream.skipTo(state.continueString) || stream.skipToEnd();
	        return "string";
	      } else if (/[\d\.]/.test(ch)) { //find numbers
	        if (ch === ".")
	          stream.match(/^[0-9]+([eE][\-+]?[0-9]+)?/);
	        else if (ch === "0")
	          stream.match(/^[xX][0-9a-fA-F]+/) || stream.match(/^0[0-7]+/);
	        else
	          stream.match(/^[0-9]*\.?[0-9]*([eE][\-+]?[0-9]+)?/);
	        return "number";
	      } else if (isDoubleOperatorChar.test(ch + stream.peek())) { // TWO SYMBOL TOKENS
	        stream.next();
	        return "operator";
	      } else if (isDoubleOperatorSym.hasOwnProperty(doubleOperator)) {
	        stream.next();
	        if (stream.peek() === ' ')
	          return isDoubleOperatorSym[doubleOperator.toLowerCase()];
	      } else if (isSingleOperatorChar.test(ch)) { // SINGLE SYMBOL TOKENS
	        return "operator";
	      }
	
	      // Matches one whole word -- even if the word is a character
	      var word;
	      if (stream.match(/[%&;\w]+/, false) != null) {
	        word = ch + stream.match(/[%&;\w]+/, true);
	        if (/&/.test(word)) return 'variable'
	      } else {
	        word = ch;
	      }
	      // the word after DATA PROC or MACRO
	      if (state.nextword) {
	        stream.match(/[\w]+/);
	        // match memname.libname
	        if (stream.peek() === '.') stream.skipTo(' ');
	        state.nextword = false;
	        return 'variable-2';
	      }
	
	      word = word.toLowerCase()
	      // Are we in a DATA Step?
	      if (state.inDataStep) {
	        if (word === 'run;' || stream.match(/run\s;/)) {
	          state.inDataStep = false;
	          return 'builtin';
	        }
	        // variable formats
	        if ((word) && stream.next() === '.') {
	          //either a format or libname.memname
	          if (/\w/.test(stream.peek())) return 'variable-2';
	          else return 'variable';
	        }
	        // do we have a DATA Step keyword
	        if (word && words.hasOwnProperty(word) &&
	            (words[word].state.indexOf("inDataStep") !== -1 ||
	             words[word].state.indexOf("ALL") !== -1)) {
	          //backup to the start of the word
	          if (stream.start < stream.pos)
	            stream.backUp(stream.pos - stream.start);
	          //advance the length of the word and return
	          for (var i = 0; i < word.length; ++i) stream.next();
	          return words[word].style;
	        }
	      }
	      // Are we in an Proc statement?
	      if (state.inProc) {
	        if (word === 'run;' || word === 'quit;') {
	          state.inProc = false;
	          return 'builtin';
	        }
	        // do we have a proc keyword
	        if (word && words.hasOwnProperty(word) &&
	            (words[word].state.indexOf("inProc") !== -1 ||
	             words[word].state.indexOf("ALL") !== -1)) {
	          stream.match(/[\w]+/);
	          return words[word].style;
	        }
	      }
	      // Are we in a Macro statement?
	      if (state.inMacro) {
	        if (word === '%mend') {
	          if (stream.peek() === ';') stream.next();
	          state.inMacro = false;
	          return 'builtin';
	        }
	        if (word && words.hasOwnProperty(word) &&
	            (words[word].state.indexOf("inMacro") !== -1 ||
	             words[word].state.indexOf("ALL") !== -1)) {
	          stream.match(/[\w]+/);
	          return words[word].style;
	        }
	
	        return 'atom';
	      }
	      // Do we have Keywords specific words?
	      if (word && words.hasOwnProperty(word)) {
	        // Negates the initial next()
	        stream.backUp(1);
	        // Actually move the stream
	        stream.match(/[\w]+/);
	        if (word === 'data' && /=/.test(stream.peek()) === false) {
	          state.inDataStep = true;
	          state.nextword = true;
	          return 'builtin';
	        }
	        if (word === 'proc') {
	          state.inProc = true;
	          state.nextword = true;
	          return 'builtin';
	        }
	        if (word === '%macro') {
	          state.inMacro = true;
	          state.nextword = true;
	          return 'builtin';
	        }
	        if (/title[1-9]/.test(word)) return 'def';
	
	        if (word === 'footnote') {
	          stream.eat(/[1-9]/);
	          return 'def';
	        }
	
	        // Returns their value as state in the prior define methods
	        if (state.inDataStep === true && words[word].state.indexOf("inDataStep") !== -1)
	          return words[word].style;
	        if (state.inProc === true && words[word].state.indexOf("inProc") !== -1)
	          return words[word].style;
	        if (state.inMacro === true && words[word].state.indexOf("inMacro") !== -1)
	          return words[word].style;
	        if (words[word].state.indexOf("ALL") !== -1)
	          return words[word].style;
	        return null;
	      }
	      // Unrecognized syntax
	      return null;
	    }
	
	    return {
	      startState: function () {
	        return {
	          inDataStep: false,
	          inProc: false,
	          inMacro: false,
	          nextword: false,
	          continueString: null,
	          continueComment: false
	        };
	      },
	      token: function (stream, state) {
	        // Strip the spaces, but regex will account for them either way
	        if (stream.eatSpace()) return null;
	        // Go through the main process
	        return tokenize(stream, state);
	      },
	
	      blockCommentStart: "/*",
	      blockCommentEnd: "*/"
	    };
	
	  });
	
	  CodeMirror.defineMIME("text/x-sas", "sas");
	});


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	/**
	 * Author: Koh Zi Han, based on implementation by Koh Zi Chun
	 */
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("scheme", function () {
	    var BUILTIN = "builtin", COMMENT = "comment", STRING = "string",
	        ATOM = "atom", NUMBER = "number", BRACKET = "bracket";
	    var INDENT_WORD_SKIP = 2;
	
	    function makeKeywords(str) {
	        var obj = {}, words = str.split(" ");
	        for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	        return obj;
	    }
	
	    var keywords = makeKeywords("λ case-lambda call/cc class define-class exit-handler field import inherit init-field interface let*-values let-values let/ec mixin opt-lambda override protect provide public rename require require-for-syntax syntax syntax-case syntax-error unit/sig unless when with-syntax and begin call-with-current-continuation call-with-input-file call-with-output-file case cond define define-syntax delay do dynamic-wind else for-each if lambda let let* let-syntax letrec letrec-syntax map or syntax-rules abs acos angle append apply asin assoc assq assv atan boolean? caar cadr call-with-input-file call-with-output-file call-with-values car cdddar cddddr cdr ceiling char->integer char-alphabetic? char-ci<=? char-ci<? char-ci=? char-ci>=? char-ci>? char-downcase char-lower-case? char-numeric? char-ready? char-upcase char-upper-case? char-whitespace? char<=? char<? char=? char>=? char>? char? close-input-port close-output-port complex? cons cos current-input-port current-output-port denominator display eof-object? eq? equal? eqv? eval even? exact->inexact exact? exp expt #f floor force gcd imag-part inexact->exact inexact? input-port? integer->char integer? interaction-environment lcm length list list->string list->vector list-ref list-tail list? load log magnitude make-polar make-rectangular make-string make-vector max member memq memv min modulo negative? newline not null-environment null? number->string number? numerator odd? open-input-file open-output-file output-port? pair? peek-char port? positive? procedure? quasiquote quote quotient rational? rationalize read read-char real-part real? remainder reverse round scheme-report-environment set! set-car! set-cdr! sin sqrt string string->list string->number string->symbol string-append string-ci<=? string-ci<? string-ci=? string-ci>=? string-ci>? string-copy string-fill! string-length string-ref string-set! string<=? string<? string=? string>=? string>? string? substring symbol->string symbol? #t tan transcript-off transcript-on truncate values vector vector->list vector-fill! vector-length vector-ref vector-set! with-input-from-file with-output-to-file write write-char zero?");
	    var indentKeys = makeKeywords("define let letrec let* lambda");
	
	    function stateStack(indent, type, prev) { // represents a state stack object
	        this.indent = indent;
	        this.type = type;
	        this.prev = prev;
	    }
	
	    function pushStack(state, indent, type) {
	        state.indentStack = new stateStack(indent, type, state.indentStack);
	    }
	
	    function popStack(state) {
	        state.indentStack = state.indentStack.prev;
	    }
	
	    var binaryMatcher = new RegExp(/^(?:[-+]i|[-+][01]+#*(?:\/[01]+#*)?i|[-+]?[01]+#*(?:\/[01]+#*)?@[-+]?[01]+#*(?:\/[01]+#*)?|[-+]?[01]+#*(?:\/[01]+#*)?[-+](?:[01]+#*(?:\/[01]+#*)?)?i|[-+]?[01]+#*(?:\/[01]+#*)?)(?=[()\s;"]|$)/i);
	    var octalMatcher = new RegExp(/^(?:[-+]i|[-+][0-7]+#*(?:\/[0-7]+#*)?i|[-+]?[0-7]+#*(?:\/[0-7]+#*)?@[-+]?[0-7]+#*(?:\/[0-7]+#*)?|[-+]?[0-7]+#*(?:\/[0-7]+#*)?[-+](?:[0-7]+#*(?:\/[0-7]+#*)?)?i|[-+]?[0-7]+#*(?:\/[0-7]+#*)?)(?=[()\s;"]|$)/i);
	    var hexMatcher = new RegExp(/^(?:[-+]i|[-+][\da-f]+#*(?:\/[\da-f]+#*)?i|[-+]?[\da-f]+#*(?:\/[\da-f]+#*)?@[-+]?[\da-f]+#*(?:\/[\da-f]+#*)?|[-+]?[\da-f]+#*(?:\/[\da-f]+#*)?[-+](?:[\da-f]+#*(?:\/[\da-f]+#*)?)?i|[-+]?[\da-f]+#*(?:\/[\da-f]+#*)?)(?=[()\s;"]|$)/i);
	    var decimalMatcher = new RegExp(/^(?:[-+]i|[-+](?:(?:(?:\d+#+\.?#*|\d+\.\d*#*|\.\d+#*|\d+)(?:[esfdl][-+]?\d+)?)|\d+#*\/\d+#*)i|[-+]?(?:(?:(?:\d+#+\.?#*|\d+\.\d*#*|\.\d+#*|\d+)(?:[esfdl][-+]?\d+)?)|\d+#*\/\d+#*)@[-+]?(?:(?:(?:\d+#+\.?#*|\d+\.\d*#*|\.\d+#*|\d+)(?:[esfdl][-+]?\d+)?)|\d+#*\/\d+#*)|[-+]?(?:(?:(?:\d+#+\.?#*|\d+\.\d*#*|\.\d+#*|\d+)(?:[esfdl][-+]?\d+)?)|\d+#*\/\d+#*)[-+](?:(?:(?:\d+#+\.?#*|\d+\.\d*#*|\.\d+#*|\d+)(?:[esfdl][-+]?\d+)?)|\d+#*\/\d+#*)?i|(?:(?:(?:\d+#+\.?#*|\d+\.\d*#*|\.\d+#*|\d+)(?:[esfdl][-+]?\d+)?)|\d+#*\/\d+#*))(?=[()\s;"]|$)/i);
	
	    function isBinaryNumber (stream) {
	        return stream.match(binaryMatcher);
	    }
	
	    function isOctalNumber (stream) {
	        return stream.match(octalMatcher);
	    }
	
	    function isDecimalNumber (stream, backup) {
	        if (backup === true) {
	            stream.backUp(1);
	        }
	        return stream.match(decimalMatcher);
	    }
	
	    function isHexNumber (stream) {
	        return stream.match(hexMatcher);
	    }
	
	    return {
	        startState: function () {
	            return {
	                indentStack: null,
	                indentation: 0,
	                mode: false,
	                sExprComment: false
	            };
	        },
	
	        token: function (stream, state) {
	            if (state.indentStack == null && stream.sol()) {
	                // update indentation, but only if indentStack is empty
	                state.indentation = stream.indentation();
	            }
	
	            // skip spaces
	            if (stream.eatSpace()) {
	                return null;
	            }
	            var returnType = null;
	
	            switch(state.mode){
	                case "string": // multi-line string parsing mode
	                    var next, escaped = false;
	                    while ((next = stream.next()) != null) {
	                        if (next == "\"" && !escaped) {
	
	                            state.mode = false;
	                            break;
	                        }
	                        escaped = !escaped && next == "\\";
	                    }
	                    returnType = STRING; // continue on in scheme-string mode
	                    break;
	                case "comment": // comment parsing mode
	                    var next, maybeEnd = false;
	                    while ((next = stream.next()) != null) {
	                        if (next == "#" && maybeEnd) {
	
	                            state.mode = false;
	                            break;
	                        }
	                        maybeEnd = (next == "|");
	                    }
	                    returnType = COMMENT;
	                    break;
	                case "s-expr-comment": // s-expr commenting mode
	                    state.mode = false;
	                    if(stream.peek() == "(" || stream.peek() == "["){
	                        // actually start scheme s-expr commenting mode
	                        state.sExprComment = 0;
	                    }else{
	                        // if not we just comment the entire of the next token
	                        stream.eatWhile(/[^/s]/); // eat non spaces
	                        returnType = COMMENT;
	                        break;
	                    }
	                default: // default parsing mode
	                    var ch = stream.next();
	
	                    if (ch == "\"") {
	                        state.mode = "string";
	                        returnType = STRING;
	
	                    } else if (ch == "'") {
	                        returnType = ATOM;
	                    } else if (ch == '#') {
	                        if (stream.eat("|")) {                    // Multi-line comment
	                            state.mode = "comment"; // toggle to comment mode
	                            returnType = COMMENT;
	                        } else if (stream.eat(/[tf]/i)) {            // #t/#f (atom)
	                            returnType = ATOM;
	                        } else if (stream.eat(';')) {                // S-Expr comment
	                            state.mode = "s-expr-comment";
	                            returnType = COMMENT;
	                        } else {
	                            var numTest = null, hasExactness = false, hasRadix = true;
	                            if (stream.eat(/[ei]/i)) {
	                                hasExactness = true;
	                            } else {
	                                stream.backUp(1);       // must be radix specifier
	                            }
	                            if (stream.match(/^#b/i)) {
	                                numTest = isBinaryNumber;
	                            } else if (stream.match(/^#o/i)) {
	                                numTest = isOctalNumber;
	                            } else if (stream.match(/^#x/i)) {
	                                numTest = isHexNumber;
	                            } else if (stream.match(/^#d/i)) {
	                                numTest = isDecimalNumber;
	                            } else if (stream.match(/^[-+0-9.]/, false)) {
	                                hasRadix = false;
	                                numTest = isDecimalNumber;
	                            // re-consume the intial # if all matches failed
	                            } else if (!hasExactness) {
	                                stream.eat('#');
	                            }
	                            if (numTest != null) {
	                                if (hasRadix && !hasExactness) {
	                                    // consume optional exactness after radix
	                                    stream.match(/^#[ei]/i);
	                                }
	                                if (numTest(stream))
	                                    returnType = NUMBER;
	                            }
	                        }
	                    } else if (/^[-+0-9.]/.test(ch) && isDecimalNumber(stream, true)) { // match non-prefixed number, must be decimal
	                        returnType = NUMBER;
	                    } else if (ch == ";") { // comment
	                        stream.skipToEnd(); // rest of the line is a comment
	                        returnType = COMMENT;
	                    } else if (ch == "(" || ch == "[") {
	                      var keyWord = ''; var indentTemp = stream.column(), letter;
	                        /**
	                        Either
	                        (indent-word ..
	                        (non-indent-word ..
	                        (;something else, bracket, etc.
	                        */
	
	                        while ((letter = stream.eat(/[^\s\(\[\;\)\]]/)) != null) {
	                            keyWord += letter;
	                        }
	
	                        if (keyWord.length > 0 && indentKeys.propertyIsEnumerable(keyWord)) { // indent-word
	
	                            pushStack(state, indentTemp + INDENT_WORD_SKIP, ch);
	                        } else { // non-indent word
	                            // we continue eating the spaces
	                            stream.eatSpace();
	                            if (stream.eol() || stream.peek() == ";") {
	                                // nothing significant after
	                                // we restart indentation 1 space after
	                                pushStack(state, indentTemp + 1, ch);
	                            } else {
	                                pushStack(state, indentTemp + stream.current().length, ch); // else we match
	                            }
	                        }
	                        stream.backUp(stream.current().length - 1); // undo all the eating
	
	                        if(typeof state.sExprComment == "number") state.sExprComment++;
	
	                        returnType = BRACKET;
	                    } else if (ch == ")" || ch == "]") {
	                        returnType = BRACKET;
	                        if (state.indentStack != null && state.indentStack.type == (ch == ")" ? "(" : "[")) {
	                            popStack(state);
	
	                            if(typeof state.sExprComment == "number"){
	                                if(--state.sExprComment == 0){
	                                    returnType = COMMENT; // final closing bracket
	                                    state.sExprComment = false; // turn off s-expr commenting mode
	                                }
	                            }
	                        }
	                    } else {
	                        stream.eatWhile(/[\w\$_\-!$%&*+\.\/:<=>?@\^~]/);
	
	                        if (keywords && keywords.propertyIsEnumerable(stream.current())) {
	                            returnType = BUILTIN;
	                        } else returnType = "variable";
	                    }
	            }
	            return (typeof state.sExprComment == "number") ? COMMENT : returnType;
	        },
	
	        indent: function (state) {
	            if (state.indentStack == null) return state.indentation;
	            return state.indentStack.indent;
	        },
	
	        closeBrackets: {pairs: "()[]{}\"\""},
	        lineComment: ";;"
	    };
	});
	
	CodeMirror.defineMIME("text/x-scheme", "scheme");
	
	});


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode('shell', function() {
	
	  var words = {};
	  function define(style, string) {
	    var split = string.split(' ');
	    for(var i = 0; i < split.length; i++) {
	      words[split[i]] = style;
	    }
	  };
	
	  // Atoms
	  define('atom', 'true false');
	
	  // Keywords
	  define('keyword', 'if then do else elif while until for in esac fi fin ' +
	    'fil done exit set unset export function');
	
	  // Commands
	  define('builtin', 'ab awk bash beep cat cc cd chown chmod chroot clear cp ' +
	    'curl cut diff echo find gawk gcc get git grep kill killall ln ls make ' +
	    'mkdir openssl mv nc node npm ping ps restart rm rmdir sed service sh ' +
	    'shopt shred source sort sleep ssh start stop su sudo tee telnet top ' +
	    'touch vi vim wall wc wget who write yes zsh');
	
	  function tokenBase(stream, state) {
	    if (stream.eatSpace()) return null;
	
	    var sol = stream.sol();
	    var ch = stream.next();
	
	    if (ch === '\\') {
	      stream.next();
	      return null;
	    }
	    if (ch === '\'' || ch === '"' || ch === '`') {
	      state.tokens.unshift(tokenString(ch));
	      return tokenize(stream, state);
	    }
	    if (ch === '#') {
	      if (sol && stream.eat('!')) {
	        stream.skipToEnd();
	        return 'meta'; // 'comment'?
	      }
	      stream.skipToEnd();
	      return 'comment';
	    }
	    if (ch === '$') {
	      state.tokens.unshift(tokenDollar);
	      return tokenize(stream, state);
	    }
	    if (ch === '+' || ch === '=') {
	      return 'operator';
	    }
	    if (ch === '-') {
	      stream.eat('-');
	      stream.eatWhile(/\w/);
	      return 'attribute';
	    }
	    if (/\d/.test(ch)) {
	      stream.eatWhile(/\d/);
	      if(stream.eol() || !/\w/.test(stream.peek())) {
	        return 'number';
	      }
	    }
	    stream.eatWhile(/[\w-]/);
	    var cur = stream.current();
	    if (stream.peek() === '=' && /\w+/.test(cur)) return 'def';
	    return words.hasOwnProperty(cur) ? words[cur] : null;
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var next, end = false, escaped = false;
	      while ((next = stream.next()) != null) {
	        if (next === quote && !escaped) {
	          end = true;
	          break;
	        }
	        if (next === '$' && !escaped && quote !== '\'') {
	          escaped = true;
	          stream.backUp(1);
	          state.tokens.unshift(tokenDollar);
	          break;
	        }
	        escaped = !escaped && next === '\\';
	      }
	      if (end || !escaped) {
	        state.tokens.shift();
	      }
	      return (quote === '`' || quote === ')' ? 'quote' : 'string');
	    };
	  };
	
	  var tokenDollar = function(stream, state) {
	    if (state.tokens.length > 1) stream.eat('$');
	    var ch = stream.next(), hungry = /\w/;
	    if (ch === '{') hungry = /[^}]/;
	    if (ch === '(') {
	      state.tokens[0] = tokenString(')');
	      return tokenize(stream, state);
	    }
	    if (!/\d/.test(ch)) {
	      stream.eatWhile(hungry);
	      stream.eat('}');
	    }
	    state.tokens.shift();
	    return 'def';
	  };
	
	  function tokenize(stream, state) {
	    return (state.tokens[0] || tokenBase) (stream, state);
	  };
	
	  return {
	    startState: function() {return {tokens:[]};},
	    token: function(stream, state) {
	      return tokenize(stream, state);
	    },
	    closeBrackets: "()[]{}''\"\"``",
	    lineComment: '#',
	    fold: "brace"
	  };
	});
	
	CodeMirror.defineMIME('text/x-sh', 'shell');
	
	});


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("sieve", function(config) {
	  function words(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	
	  var keywords = words("if elsif else stop require");
	  var atoms = words("true false not");
	  var indentUnit = config.indentUnit;
	
	  function tokenBase(stream, state) {
	
	    var ch = stream.next();
	    if (ch == "/" && stream.eat("*")) {
	      state.tokenize = tokenCComment;
	      return tokenCComment(stream, state);
	    }
	
	    if (ch === '#') {
	      stream.skipToEnd();
	      return "comment";
	    }
	
	    if (ch == "\"") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    }
	
	    if (ch == "(") {
	      state._indent.push("(");
	      // add virtual angel wings so that editor behaves...
	      // ...more sane incase of broken brackets
	      state._indent.push("{");
	      return null;
	    }
	
	    if (ch === "{") {
	      state._indent.push("{");
	      return null;
	    }
	
	    if (ch == ")")  {
	      state._indent.pop();
	      state._indent.pop();
	    }
	
	    if (ch === "}") {
	      state._indent.pop();
	      return null;
	    }
	
	    if (ch == ",")
	      return null;
	
	    if (ch == ";")
	      return null;
	
	
	    if (/[{}\(\),;]/.test(ch))
	      return null;
	
	    // 1*DIGIT "K" / "M" / "G"
	    if (/\d/.test(ch)) {
	      stream.eatWhile(/[\d]/);
	      stream.eat(/[KkMmGg]/);
	      return "number";
	    }
	
	    // ":" (ALPHA / "_") *(ALPHA / DIGIT / "_")
	    if (ch == ":") {
	      stream.eatWhile(/[a-zA-Z_]/);
	      stream.eatWhile(/[a-zA-Z0-9_]/);
	
	      return "operator";
	    }
	
	    stream.eatWhile(/\w/);
	    var cur = stream.current();
	
	    // "text:" *(SP / HTAB) (hash-comment / CRLF)
	    // *(multiline-literal / multiline-dotstart)
	    // "." CRLF
	    if ((cur == "text") && stream.eat(":"))
	    {
	      state.tokenize = tokenMultiLineString;
	      return "string";
	    }
	
	    if (keywords.propertyIsEnumerable(cur))
	      return "keyword";
	
	    if (atoms.propertyIsEnumerable(cur))
	      return "atom";
	
	    return null;
	  }
	
	  function tokenMultiLineString(stream, state)
	  {
	    state._multiLineString = true;
	    // the first line is special it may contain a comment
	    if (!stream.sol()) {
	      stream.eatSpace();
	
	      if (stream.peek() == "#") {
	        stream.skipToEnd();
	        return "comment";
	      }
	
	      stream.skipToEnd();
	      return "string";
	    }
	
	    if ((stream.next() == ".")  && (stream.eol()))
	    {
	      state._multiLineString = false;
	      state.tokenize = tokenBase;
	    }
	
	    return "string";
	  }
	
	  function tokenCComment(stream, state) {
	    var maybeEnd = false, ch;
	    while ((ch = stream.next()) != null) {
	      if (maybeEnd && ch == "/") {
	        state.tokenize = tokenBase;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return "comment";
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == quote && !escaped)
	          break;
	        escaped = !escaped && ch == "\\";
	      }
	      if (!escaped) state.tokenize = tokenBase;
	      return "string";
	    };
	  }
	
	  return {
	    startState: function(base) {
	      return {tokenize: tokenBase,
	              baseIndent: base || 0,
	              _indent: []};
	    },
	
	    token: function(stream, state) {
	      if (stream.eatSpace())
	        return null;
	
	      return (state.tokenize || tokenBase)(stream, state);;
	    },
	
	    indent: function(state, _textAfter) {
	      var length = state._indent.length;
	      if (_textAfter && (_textAfter[0] == "}"))
	        length--;
	
	      if (length <0)
	        length = 0;
	
	      return length * indentUnit;
	    },
	
	    electricChars: "}"
	  };
	});
	
	CodeMirror.defineMIME("application/sieve", "sieve");
	
	});


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// Slim Highlighting for CodeMirror copyright (c) HicknHack Software Gmbh
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(5), __webpack_require__(46));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../htmlmixed/htmlmixed", "../ruby/ruby"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	  CodeMirror.defineMode("slim", function(config) {
	    var htmlMode = CodeMirror.getMode(config, {name: "htmlmixed"});
	    var rubyMode = CodeMirror.getMode(config, "ruby");
	    var modes = { html: htmlMode, ruby: rubyMode };
	    var embedded = {
	      ruby: "ruby",
	      javascript: "javascript",
	      css: "text/css",
	      sass: "text/x-sass",
	      scss: "text/x-scss",
	      less: "text/x-less",
	      styl: "text/x-styl", // no highlighting so far
	      coffee: "coffeescript",
	      asciidoc: "text/x-asciidoc",
	      markdown: "text/x-markdown",
	      textile: "text/x-textile", // no highlighting so far
	      creole: "text/x-creole", // no highlighting so far
	      wiki: "text/x-wiki", // no highlighting so far
	      mediawiki: "text/x-mediawiki", // no highlighting so far
	      rdoc: "text/x-rdoc", // no highlighting so far
	      builder: "text/x-builder", // no highlighting so far
	      nokogiri: "text/x-nokogiri", // no highlighting so far
	      erb: "application/x-erb"
	    };
	    var embeddedRegexp = function(map){
	      var arr = [];
	      for(var key in map) arr.push(key);
	      return new RegExp("^("+arr.join('|')+"):");
	    }(embedded);
	
	    var styleMap = {
	      "commentLine": "comment",
	      "slimSwitch": "operator special",
	      "slimTag": "tag",
	      "slimId": "attribute def",
	      "slimClass": "attribute qualifier",
	      "slimAttribute": "attribute",
	      "slimSubmode": "keyword special",
	      "closeAttributeTag": null,
	      "slimDoctype": null,
	      "lineContinuation": null
	    };
	    var closing = {
	      "{": "}",
	      "[": "]",
	      "(": ")"
	    };
	
	    var nameStartChar = "_a-zA-Z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD";
	    var nameChar = nameStartChar + "\\-0-9\xB7\u0300-\u036F\u203F-\u2040";
	    var nameRegexp = new RegExp("^[:"+nameStartChar+"](?::["+nameChar+"]|["+nameChar+"]*)");
	    var attributeNameRegexp = new RegExp("^[:"+nameStartChar+"][:\\."+nameChar+"]*(?=\\s*=)");
	    var wrappedAttributeNameRegexp = new RegExp("^[:"+nameStartChar+"][:\\."+nameChar+"]*");
	    var classNameRegexp = /^\.-?[_a-zA-Z]+[\w\-]*/;
	    var classIdRegexp = /^#[_a-zA-Z]+[\w\-]*/;
	
	    function backup(pos, tokenize, style) {
	      var restore = function(stream, state) {
	        state.tokenize = tokenize;
	        if (stream.pos < pos) {
	          stream.pos = pos;
	          return style;
	        }
	        return state.tokenize(stream, state);
	      };
	      return function(stream, state) {
	        state.tokenize = restore;
	        return tokenize(stream, state);
	      };
	    }
	
	    function maybeBackup(stream, state, pat, offset, style) {
	      var cur = stream.current();
	      var idx = cur.search(pat);
	      if (idx > -1) {
	        state.tokenize = backup(stream.pos, state.tokenize, style);
	        stream.backUp(cur.length - idx - offset);
	      }
	      return style;
	    }
	
	    function continueLine(state, column) {
	      state.stack = {
	        parent: state.stack,
	        style: "continuation",
	        indented: column,
	        tokenize: state.line
	      };
	      state.line = state.tokenize;
	    }
	    function finishContinue(state) {
	      if (state.line == state.tokenize) {
	        state.line = state.stack.tokenize;
	        state.stack = state.stack.parent;
	      }
	    }
	
	    function lineContinuable(column, tokenize) {
	      return function(stream, state) {
	        finishContinue(state);
	        if (stream.match(/^\\$/)) {
	          continueLine(state, column);
	          return "lineContinuation";
	        }
	        var style = tokenize(stream, state);
	        if (stream.eol() && stream.current().match(/(?:^|[^\\])(?:\\\\)*\\$/)) {
	          stream.backUp(1);
	        }
	        return style;
	      };
	    }
	    function commaContinuable(column, tokenize) {
	      return function(stream, state) {
	        finishContinue(state);
	        var style = tokenize(stream, state);
	        if (stream.eol() && stream.current().match(/,$/)) {
	          continueLine(state, column);
	        }
	        return style;
	      };
	    }
	
	    function rubyInQuote(endQuote, tokenize) {
	      // TODO: add multi line support
	      return function(stream, state) {
	        var ch = stream.peek();
	        if (ch == endQuote && state.rubyState.tokenize.length == 1) {
	          // step out of ruby context as it seems to complete processing all the braces
	          stream.next();
	          state.tokenize = tokenize;
	          return "closeAttributeTag";
	        } else {
	          return ruby(stream, state);
	        }
	      };
	    }
	    function startRubySplat(tokenize) {
	      var rubyState;
	      var runSplat = function(stream, state) {
	        if (state.rubyState.tokenize.length == 1 && !state.rubyState.context.prev) {
	          stream.backUp(1);
	          if (stream.eatSpace()) {
	            state.rubyState = rubyState;
	            state.tokenize = tokenize;
	            return tokenize(stream, state);
	          }
	          stream.next();
	        }
	        return ruby(stream, state);
	      };
	      return function(stream, state) {
	        rubyState = state.rubyState;
	        state.rubyState = CodeMirror.startState(rubyMode);
	        state.tokenize = runSplat;
	        return ruby(stream, state);
	      };
	    }
	
	    function ruby(stream, state) {
	      return rubyMode.token(stream, state.rubyState);
	    }
	
	    function htmlLine(stream, state) {
	      if (stream.match(/^\\$/)) {
	        return "lineContinuation";
	      }
	      return html(stream, state);
	    }
	    function html(stream, state) {
	      if (stream.match(/^#\{/)) {
	        state.tokenize = rubyInQuote("}", state.tokenize);
	        return null;
	      }
	      return maybeBackup(stream, state, /[^\\]#\{/, 1, htmlMode.token(stream, state.htmlState));
	    }
	
	    function startHtmlLine(lastTokenize) {
	      return function(stream, state) {
	        var style = htmlLine(stream, state);
	        if (stream.eol()) state.tokenize = lastTokenize;
	        return style;
	      };
	    }
	
	    function startHtmlMode(stream, state, offset) {
	      state.stack = {
	        parent: state.stack,
	        style: "html",
	        indented: stream.column() + offset, // pipe + space
	        tokenize: state.line
	      };
	      state.line = state.tokenize = html;
	      return null;
	    }
	
	    function comment(stream, state) {
	      stream.skipToEnd();
	      return state.stack.style;
	    }
	
	    function commentMode(stream, state) {
	      state.stack = {
	        parent: state.stack,
	        style: "comment",
	        indented: state.indented + 1,
	        tokenize: state.line
	      };
	      state.line = comment;
	      return comment(stream, state);
	    }
	
	    function attributeWrapper(stream, state) {
	      if (stream.eat(state.stack.endQuote)) {
	        state.line = state.stack.line;
	        state.tokenize = state.stack.tokenize;
	        state.stack = state.stack.parent;
	        return null;
	      }
	      if (stream.match(wrappedAttributeNameRegexp)) {
	        state.tokenize = attributeWrapperAssign;
	        return "slimAttribute";
	      }
	      stream.next();
	      return null;
	    }
	    function attributeWrapperAssign(stream, state) {
	      if (stream.match(/^==?/)) {
	        state.tokenize = attributeWrapperValue;
	        return null;
	      }
	      return attributeWrapper(stream, state);
	    }
	    function attributeWrapperValue(stream, state) {
	      var ch = stream.peek();
	      if (ch == '"' || ch == "\'") {
	        state.tokenize = readQuoted(ch, "string", true, false, attributeWrapper);
	        stream.next();
	        return state.tokenize(stream, state);
	      }
	      if (ch == '[') {
	        return startRubySplat(attributeWrapper)(stream, state);
	      }
	      if (stream.match(/^(true|false|nil)\b/)) {
	        state.tokenize = attributeWrapper;
	        return "keyword";
	      }
	      return startRubySplat(attributeWrapper)(stream, state);
	    }
	
	    function startAttributeWrapperMode(state, endQuote, tokenize) {
	      state.stack = {
	        parent: state.stack,
	        style: "wrapper",
	        indented: state.indented + 1,
	        tokenize: tokenize,
	        line: state.line,
	        endQuote: endQuote
	      };
	      state.line = state.tokenize = attributeWrapper;
	      return null;
	    }
	
	    function sub(stream, state) {
	      if (stream.match(/^#\{/)) {
	        state.tokenize = rubyInQuote("}", state.tokenize);
	        return null;
	      }
	      var subStream = new CodeMirror.StringStream(stream.string.slice(state.stack.indented), stream.tabSize);
	      subStream.pos = stream.pos - state.stack.indented;
	      subStream.start = stream.start - state.stack.indented;
	      subStream.lastColumnPos = stream.lastColumnPos - state.stack.indented;
	      subStream.lastColumnValue = stream.lastColumnValue - state.stack.indented;
	      var style = state.subMode.token(subStream, state.subState);
	      stream.pos = subStream.pos + state.stack.indented;
	      return style;
	    }
	    function firstSub(stream, state) {
	      state.stack.indented = stream.column();
	      state.line = state.tokenize = sub;
	      return state.tokenize(stream, state);
	    }
	
	    function createMode(mode) {
	      var query = embedded[mode];
	      var spec = CodeMirror.mimeModes[query];
	      if (spec) {
	        return CodeMirror.getMode(config, spec);
	      }
	      var factory = CodeMirror.modes[query];
	      if (factory) {
	        return factory(config, {name: query});
	      }
	      return CodeMirror.getMode(config, "null");
	    }
	
	    function getMode(mode) {
	      if (!modes.hasOwnProperty(mode)) {
	        return modes[mode] = createMode(mode);
	      }
	      return modes[mode];
	    }
	
	    function startSubMode(mode, state) {
	      var subMode = getMode(mode);
	      var subState = CodeMirror.startState(subMode);
	
	      state.subMode = subMode;
	      state.subState = subState;
	
	      state.stack = {
	        parent: state.stack,
	        style: "sub",
	        indented: state.indented + 1,
	        tokenize: state.line
	      };
	      state.line = state.tokenize = firstSub;
	      return "slimSubmode";
	    }
	
	    function doctypeLine(stream, _state) {
	      stream.skipToEnd();
	      return "slimDoctype";
	    }
	
	    function startLine(stream, state) {
	      var ch = stream.peek();
	      if (ch == '<') {
	        return (state.tokenize = startHtmlLine(state.tokenize))(stream, state);
	      }
	      if (stream.match(/^[|']/)) {
	        return startHtmlMode(stream, state, 1);
	      }
	      if (stream.match(/^\/(!|\[\w+])?/)) {
	        return commentMode(stream, state);
	      }
	      if (stream.match(/^(-|==?[<>]?)/)) {
	        state.tokenize = lineContinuable(stream.column(), commaContinuable(stream.column(), ruby));
	        return "slimSwitch";
	      }
	      if (stream.match(/^doctype\b/)) {
	        state.tokenize = doctypeLine;
	        return "keyword";
	      }
	
	      var m = stream.match(embeddedRegexp);
	      if (m) {
	        return startSubMode(m[1], state);
	      }
	
	      return slimTag(stream, state);
	    }
	
	    function slim(stream, state) {
	      if (state.startOfLine) {
	        return startLine(stream, state);
	      }
	      return slimTag(stream, state);
	    }
	
	    function slimTag(stream, state) {
	      if (stream.eat('*')) {
	        state.tokenize = startRubySplat(slimTagExtras);
	        return null;
	      }
	      if (stream.match(nameRegexp)) {
	        state.tokenize = slimTagExtras;
	        return "slimTag";
	      }
	      return slimClass(stream, state);
	    }
	    function slimTagExtras(stream, state) {
	      if (stream.match(/^(<>?|><?)/)) {
	        state.tokenize = slimClass;
	        return null;
	      }
	      return slimClass(stream, state);
	    }
	    function slimClass(stream, state) {
	      if (stream.match(classIdRegexp)) {
	        state.tokenize = slimClass;
	        return "slimId";
	      }
	      if (stream.match(classNameRegexp)) {
	        state.tokenize = slimClass;
	        return "slimClass";
	      }
	      return slimAttribute(stream, state);
	    }
	    function slimAttribute(stream, state) {
	      if (stream.match(/^([\[\{\(])/)) {
	        return startAttributeWrapperMode(state, closing[RegExp.$1], slimAttribute);
	      }
	      if (stream.match(attributeNameRegexp)) {
	        state.tokenize = slimAttributeAssign;
	        return "slimAttribute";
	      }
	      if (stream.peek() == '*') {
	        stream.next();
	        state.tokenize = startRubySplat(slimContent);
	        return null;
	      }
	      return slimContent(stream, state);
	    }
	    function slimAttributeAssign(stream, state) {
	      if (stream.match(/^==?/)) {
	        state.tokenize = slimAttributeValue;
	        return null;
	      }
	      // should never happen, because of forward lookup
	      return slimAttribute(stream, state);
	    }
	
	    function slimAttributeValue(stream, state) {
	      var ch = stream.peek();
	      if (ch == '"' || ch == "\'") {
	        state.tokenize = readQuoted(ch, "string", true, false, slimAttribute);
	        stream.next();
	        return state.tokenize(stream, state);
	      }
	      if (ch == '[') {
	        return startRubySplat(slimAttribute)(stream, state);
	      }
	      if (ch == ':') {
	        return startRubySplat(slimAttributeSymbols)(stream, state);
	      }
	      if (stream.match(/^(true|false|nil)\b/)) {
	        state.tokenize = slimAttribute;
	        return "keyword";
	      }
	      return startRubySplat(slimAttribute)(stream, state);
	    }
	    function slimAttributeSymbols(stream, state) {
	      stream.backUp(1);
	      if (stream.match(/^[^\s],(?=:)/)) {
	        state.tokenize = startRubySplat(slimAttributeSymbols);
	        return null;
	      }
	      stream.next();
	      return slimAttribute(stream, state);
	    }
	    function readQuoted(quote, style, embed, unescaped, nextTokenize) {
	      return function(stream, state) {
	        finishContinue(state);
	        var fresh = stream.current().length == 0;
	        if (stream.match(/^\\$/, fresh)) {
	          if (!fresh) return style;
	          continueLine(state, state.indented);
	          return "lineContinuation";
	        }
	        if (stream.match(/^#\{/, fresh)) {
	          if (!fresh) return style;
	          state.tokenize = rubyInQuote("}", state.tokenize);
	          return null;
	        }
	        var escaped = false, ch;
	        while ((ch = stream.next()) != null) {
	          if (ch == quote && (unescaped || !escaped)) {
	            state.tokenize = nextTokenize;
	            break;
	          }
	          if (embed && ch == "#" && !escaped) {
	            if (stream.eat("{")) {
	              stream.backUp(2);
	              break;
	            }
	          }
	          escaped = !escaped && ch == "\\";
	        }
	        if (stream.eol() && escaped) {
	          stream.backUp(1);
	        }
	        return style;
	      };
	    }
	    function slimContent(stream, state) {
	      if (stream.match(/^==?/)) {
	        state.tokenize = ruby;
	        return "slimSwitch";
	      }
	      if (stream.match(/^\/$/)) { // tag close hint
	        state.tokenize = slim;
	        return null;
	      }
	      if (stream.match(/^:/)) { // inline tag
	        state.tokenize = slimTag;
	        return "slimSwitch";
	      }
	      startHtmlMode(stream, state, 0);
	      return state.tokenize(stream, state);
	    }
	
	    var mode = {
	      // default to html mode
	      startState: function() {
	        var htmlState = CodeMirror.startState(htmlMode);
	        var rubyState = CodeMirror.startState(rubyMode);
	        return {
	          htmlState: htmlState,
	          rubyState: rubyState,
	          stack: null,
	          last: null,
	          tokenize: slim,
	          line: slim,
	          indented: 0
	        };
	      },
	
	      copyState: function(state) {
	        return {
	          htmlState : CodeMirror.copyState(htmlMode, state.htmlState),
	          rubyState: CodeMirror.copyState(rubyMode, state.rubyState),
	          subMode: state.subMode,
	          subState: state.subMode && CodeMirror.copyState(state.subMode, state.subState),
	          stack: state.stack,
	          last: state.last,
	          tokenize: state.tokenize,
	          line: state.line
	        };
	      },
	
	      token: function(stream, state) {
	        if (stream.sol()) {
	          state.indented = stream.indentation();
	          state.startOfLine = true;
	          state.tokenize = state.line;
	          while (state.stack && state.stack.indented > state.indented && state.last != "slimSubmode") {
	            state.line = state.tokenize = state.stack.tokenize;
	            state.stack = state.stack.parent;
	            state.subMode = null;
	            state.subState = null;
	          }
	        }
	        if (stream.eatSpace()) return null;
	        var style = state.tokenize(stream, state);
	        state.startOfLine = false;
	        if (style) state.last = style;
	        return styleMap.hasOwnProperty(style) ? styleMap[style] : style;
	      },
	
	      blankLine: function(state) {
	        if (state.subMode && state.subMode.blankLine) {
	          return state.subMode.blankLine(state.subState);
	        }
	      },
	
	      innerMode: function(state) {
	        if (state.subMode) return {state: state.subState, mode: state.subMode};
	        return {state: state, mode: mode};
	      }
	
	      //indent: function(state) {
	      //  return state.indented;
	      //}
	    };
	    return mode;
	  }, "htmlmixed", "ruby");
	
	  CodeMirror.defineMIME("text/x-slim", "slim");
	  CodeMirror.defineMIME("application/x-slim", "slim");
	});


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode('smalltalk', function(config) {
	
	  var specialChars = /[+\-\/\\*~<>=@%|&?!.,:;^]/;
	  var keywords = /true|false|nil|self|super|thisContext/;
	
	  var Context = function(tokenizer, parent) {
	    this.next = tokenizer;
	    this.parent = parent;
	  };
	
	  var Token = function(name, context, eos) {
	    this.name = name;
	    this.context = context;
	    this.eos = eos;
	  };
	
	  var State = function() {
	    this.context = new Context(next, null);
	    this.expectVariable = true;
	    this.indentation = 0;
	    this.userIndentationDelta = 0;
	  };
	
	  State.prototype.userIndent = function(indentation) {
	    this.userIndentationDelta = indentation > 0 ? (indentation / config.indentUnit - this.indentation) : 0;
	  };
	
	  var next = function(stream, context, state) {
	    var token = new Token(null, context, false);
	    var aChar = stream.next();
	
	    if (aChar === '"') {
	      token = nextComment(stream, new Context(nextComment, context));
	
	    } else if (aChar === '\'') {
	      token = nextString(stream, new Context(nextString, context));
	
	    } else if (aChar === '#') {
	      if (stream.peek() === '\'') {
	        stream.next();
	        token = nextSymbol(stream, new Context(nextSymbol, context));
	      } else {
	        if (stream.eatWhile(/[^\s.{}\[\]()]/))
	          token.name = 'string-2';
	        else
	          token.name = 'meta';
	      }
	
	    } else if (aChar === '$') {
	      if (stream.next() === '<') {
	        stream.eatWhile(/[^\s>]/);
	        stream.next();
	      }
	      token.name = 'string-2';
	
	    } else if (aChar === '|' && state.expectVariable) {
	      token.context = new Context(nextTemporaries, context);
	
	    } else if (/[\[\]{}()]/.test(aChar)) {
	      token.name = 'bracket';
	      token.eos = /[\[{(]/.test(aChar);
	
	      if (aChar === '[') {
	        state.indentation++;
	      } else if (aChar === ']') {
	        state.indentation = Math.max(0, state.indentation - 1);
	      }
	
	    } else if (specialChars.test(aChar)) {
	      stream.eatWhile(specialChars);
	      token.name = 'operator';
	      token.eos = aChar !== ';'; // ; cascaded message expression
	
	    } else if (/\d/.test(aChar)) {
	      stream.eatWhile(/[\w\d]/);
	      token.name = 'number';
	
	    } else if (/[\w_]/.test(aChar)) {
	      stream.eatWhile(/[\w\d_]/);
	      token.name = state.expectVariable ? (keywords.test(stream.current()) ? 'keyword' : 'variable') : null;
	
	    } else {
	      token.eos = state.expectVariable;
	    }
	
	    return token;
	  };
	
	  var nextComment = function(stream, context) {
	    stream.eatWhile(/[^"]/);
	    return new Token('comment', stream.eat('"') ? context.parent : context, true);
	  };
	
	  var nextString = function(stream, context) {
	    stream.eatWhile(/[^']/);
	    return new Token('string', stream.eat('\'') ? context.parent : context, false);
	  };
	
	  var nextSymbol = function(stream, context) {
	    stream.eatWhile(/[^']/);
	    return new Token('string-2', stream.eat('\'') ? context.parent : context, false);
	  };
	
	  var nextTemporaries = function(stream, context) {
	    var token = new Token(null, context, false);
	    var aChar = stream.next();
	
	    if (aChar === '|') {
	      token.context = context.parent;
	      token.eos = true;
	
	    } else {
	      stream.eatWhile(/[^|]/);
	      token.name = 'variable';
	    }
	
	    return token;
	  };
	
	  return {
	    startState: function() {
	      return new State;
	    },
	
	    token: function(stream, state) {
	      state.userIndent(stream.indentation());
	
	      if (stream.eatSpace()) {
	        return null;
	      }
	
	      var token = state.context.next(stream, state.context, state);
	      state.context = token.context;
	      state.expectVariable = token.eos;
	
	      return token.name;
	    },
	
	    blankLine: function(state) {
	      state.userIndent(0);
	    },
	
	    indent: function(state, textAfter) {
	      var i = state.context.next === next && textAfter && textAfter.charAt(0) === ']' ? -1 : state.userIndentationDelta;
	      return (state.indentation + i) * config.indentUnit;
	    },
	
	    electricChars: ']'
	  };
	
	});
	
	CodeMirror.defineMIME('text/x-stsrc', {name: 'smalltalk'});
	
	});


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	/**
	 * Smarty 2 and 3 mode.
	 */
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("smarty", function(config, parserConf) {
	    var rightDelimiter = parserConf.rightDelimiter || "}";
	    var leftDelimiter = parserConf.leftDelimiter || "{";
	    var version = parserConf.version || 2;
	    var baseMode = CodeMirror.getMode(config, parserConf.baseMode || "null");
	
	    var keyFunctions = ["debug", "extends", "function", "include", "literal"];
	    var regs = {
	      operatorChars: /[+\-*&%=<>!?]/,
	      validIdentifier: /[a-zA-Z0-9_]/,
	      stringChar: /['"]/
	    };
	
	    var last;
	    function cont(style, lastType) {
	      last = lastType;
	      return style;
	    }
	
	    function chain(stream, state, parser) {
	      state.tokenize = parser;
	      return parser(stream, state);
	    }
	
	    // Smarty 3 allows { and } surrounded by whitespace to NOT slip into Smarty mode
	    function doesNotCount(stream, pos) {
	      if (pos == null) pos = stream.pos;
	      return version === 3 && leftDelimiter == "{" &&
	        (pos == stream.string.length || /\s/.test(stream.string.charAt(pos)));
	    }
	
	    function tokenTop(stream, state) {
	      var string = stream.string;
	      for (var scan = stream.pos;;) {
	        var nextMatch = string.indexOf(leftDelimiter, scan);
	        scan = nextMatch + leftDelimiter.length;
	        if (nextMatch == -1 || !doesNotCount(stream, nextMatch + leftDelimiter.length)) break;
	      }
	      if (nextMatch == stream.pos) {
	        stream.match(leftDelimiter);
	        if (stream.eat("*")) {
	          return chain(stream, state, tokenBlock("comment", "*" + rightDelimiter));
	        } else {
	          state.depth++;
	          state.tokenize = tokenSmarty;
	          last = "startTag";
	          return "tag";
	        }
	      }
	
	      if (nextMatch > -1) stream.string = string.slice(0, nextMatch);
	      var token = baseMode.token(stream, state.base);
	      if (nextMatch > -1) stream.string = string;
	      return token;
	    }
	
	    // parsing Smarty content
	    function tokenSmarty(stream, state) {
	      if (stream.match(rightDelimiter, true)) {
	        if (version === 3) {
	          state.depth--;
	          if (state.depth <= 0) {
	            state.tokenize = tokenTop;
	          }
	        } else {
	          state.tokenize = tokenTop;
	        }
	        return cont("tag", null);
	      }
	
	      if (stream.match(leftDelimiter, true)) {
	        state.depth++;
	        return cont("tag", "startTag");
	      }
	
	      var ch = stream.next();
	      if (ch == "$") {
	        stream.eatWhile(regs.validIdentifier);
	        return cont("variable-2", "variable");
	      } else if (ch == "|") {
	        return cont("operator", "pipe");
	      } else if (ch == ".") {
	        return cont("operator", "property");
	      } else if (regs.stringChar.test(ch)) {
	        state.tokenize = tokenAttribute(ch);
	        return cont("string", "string");
	      } else if (regs.operatorChars.test(ch)) {
	        stream.eatWhile(regs.operatorChars);
	        return cont("operator", "operator");
	      } else if (ch == "[" || ch == "]") {
	        return cont("bracket", "bracket");
	      } else if (ch == "(" || ch == ")") {
	        return cont("bracket", "operator");
	      } else if (/\d/.test(ch)) {
	        stream.eatWhile(/\d/);
	        return cont("number", "number");
	      } else {
	
	        if (state.last == "variable") {
	          if (ch == "@") {
	            stream.eatWhile(regs.validIdentifier);
	            return cont("property", "property");
	          } else if (ch == "|") {
	            stream.eatWhile(regs.validIdentifier);
	            return cont("qualifier", "modifier");
	          }
	        } else if (state.last == "pipe") {
	          stream.eatWhile(regs.validIdentifier);
	          return cont("qualifier", "modifier");
	        } else if (state.last == "whitespace") {
	          stream.eatWhile(regs.validIdentifier);
	          return cont("attribute", "modifier");
	        } if (state.last == "property") {
	          stream.eatWhile(regs.validIdentifier);
	          return cont("property", null);
	        } else if (/\s/.test(ch)) {
	          last = "whitespace";
	          return null;
	        }
	
	        var str = "";
	        if (ch != "/") {
	          str += ch;
	        }
	        var c = null;
	        while (c = stream.eat(regs.validIdentifier)) {
	          str += c;
	        }
	        for (var i=0, j=keyFunctions.length; i<j; i++) {
	          if (keyFunctions[i] == str) {
	            return cont("keyword", "keyword");
	          }
	        }
	        if (/\s/.test(ch)) {
	          return null;
	        }
	        return cont("tag", "tag");
	      }
	    }
	
	    function tokenAttribute(quote) {
	      return function(stream, state) {
	        var prevChar = null;
	        var currChar = null;
	        while (!stream.eol()) {
	          currChar = stream.peek();
	          if (stream.next() == quote && prevChar !== '\\') {
	            state.tokenize = tokenSmarty;
	            break;
	          }
	          prevChar = currChar;
	        }
	        return "string";
	      };
	    }
	
	    function tokenBlock(style, terminator) {
	      return function(stream, state) {
	        while (!stream.eol()) {
	          if (stream.match(terminator)) {
	            state.tokenize = tokenTop;
	            break;
	          }
	          stream.next();
	        }
	        return style;
	      };
	    }
	
	    return {
	      startState: function() {
	        return {
	          base: CodeMirror.startState(baseMode),
	          tokenize: tokenTop,
	          last: null,
	          depth: 0
	        };
	      },
	      copyState: function(state) {
	        return {
	          base: CodeMirror.copyState(baseMode, state.base),
	          tokenize: state.tokenize,
	          last: state.last,
	          depth: state.depth
	        };
	      },
	      innerMode: function(state) {
	        if (state.tokenize == tokenTop)
	          return {mode: baseMode, state: state.base};
	      },
	      token: function(stream, state) {
	        var style = state.tokenize(stream, state);
	        state.last = last;
	        return style;
	      },
	      indent: function(state, text) {
	        if (state.tokenize == tokenTop && baseMode.indent)
	          return baseMode.indent(state.base, text);
	        else
	          return CodeMirror.Pass;
	      },
	      blockCommentStart: leftDelimiter + "*",
	      blockCommentEnd: "*" + rightDelimiter
	    };
	  });
	
	  CodeMirror.defineMIME("text/x-smarty", "smarty");
	});


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("solr", function() {
	  "use strict";
	
	  var isStringChar = /[^\s\|\!\+\-\*\?\~\^\&\:\(\)\[\]\{\}\^\"\\]/;
	  var isOperatorChar = /[\|\!\+\-\*\?\~\^\&]/;
	  var isOperatorString = /^(OR|AND|NOT|TO)$/i;
	
	  function isNumber(word) {
	    return parseFloat(word, 10).toString() === word;
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, next;
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) break;
	        escaped = !escaped && next == "\\";
	      }
	
	      if (!escaped) state.tokenize = tokenBase;
	      return "string";
	    };
	  }
	
	  function tokenOperator(operator) {
	    return function(stream, state) {
	      var style = "operator";
	      if (operator == "+")
	        style += " positive";
	      else if (operator == "-")
	        style += " negative";
	      else if (operator == "|")
	        stream.eat(/\|/);
	      else if (operator == "&")
	        stream.eat(/\&/);
	      else if (operator == "^")
	        style += " boost";
	
	      state.tokenize = tokenBase;
	      return style;
	    };
	  }
	
	  function tokenWord(ch) {
	    return function(stream, state) {
	      var word = ch;
	      while ((ch = stream.peek()) && ch.match(isStringChar) != null) {
	        word += stream.next();
	      }
	
	      state.tokenize = tokenBase;
	      if (isOperatorString.test(word))
	        return "operator";
	      else if (isNumber(word))
	        return "number";
	      else if (stream.peek() == ":")
	        return "field";
	      else
	        return "string";
	    };
	  }
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    if (ch == '"')
	      state.tokenize = tokenString(ch);
	    else if (isOperatorChar.test(ch))
	      state.tokenize = tokenOperator(ch);
	    else if (isStringChar.test(ch))
	      state.tokenize = tokenWord(ch);
	
	    return (state.tokenize != tokenBase) ? state.tokenize(stream, state) : null;
	  }
	
	  return {
	    startState: function() {
	      return {
	        tokenize: tokenBase
	      };
	    },
	
	    token: function(stream, state) {
	      if (stream.eatSpace()) return null;
	      return state.tokenize(stream, state);
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/x-solr", "solr");
	
	});


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(5));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../htmlmixed/htmlmixed"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  var indentingTags = ["template", "literal", "msg", "fallbackmsg", "let", "if", "elseif",
	                       "else", "switch", "case", "default", "foreach", "ifempty", "for",
	                       "call", "param", "deltemplate", "delcall", "log"];
	
	  CodeMirror.defineMode("soy", function(config) {
	    var textMode = CodeMirror.getMode(config, "text/plain");
	    var modes = {
	      html: CodeMirror.getMode(config, {name: "text/html", multilineTagIndentFactor: 2, multilineTagIndentPastTag: false}),
	      attributes: textMode,
	      text: textMode,
	      uri: textMode,
	      css: CodeMirror.getMode(config, "text/css"),
	      js: CodeMirror.getMode(config, {name: "text/javascript", statementIndent: 2 * config.indentUnit})
	    };
	
	    function last(array) {
	      return array[array.length - 1];
	    }
	
	    function tokenUntil(stream, state, untilRegExp) {
	      var oldString = stream.string;
	      var match = untilRegExp.exec(oldString.substr(stream.pos));
	      if (match) {
	        // We don't use backUp because it backs up just the position, not the state.
	        // This uses an undocumented API.
	        stream.string = oldString.substr(0, stream.pos + match.index);
	      }
	      var result = stream.hideFirstChars(state.indent, function() {
	        return state.localMode.token(stream, state.localState);
	      });
	      stream.string = oldString;
	      return result;
	    }
	
	    function contains(list, element) {
	      while (list) {
	        if (list.element === element) return true;
	        list = list.next;
	      }
	      return false;
	    }
	
	    function prepend(list, element) {
	      return {
	        element: element,
	        next: list
	      };
	    }
	
	    // Reference a variable `name` in `list`.
	    // Let `loose` be truthy to ignore missing identifiers.
	    function ref(list, name, loose) {
	      return contains(list, name) ? "variable-2" : (loose ? "variable" : "variable-2 error");
	    }
	
	    function popscope(state) {
	      if (state.scopes) {
	        state.variables = state.scopes.element;
	        state.scopes = state.scopes.next;
	      }
	    }
	
	    return {
	      startState: function() {
	        return {
	          kind: [],
	          kindTag: [],
	          soyState: [],
	          templates: null,
	          variables: null,
	          scopes: null,
	          indent: 0,
	          localMode: modes.html,
	          localState: CodeMirror.startState(modes.html)
	        };
	      },
	
	      copyState: function(state) {
	        return {
	          tag: state.tag, // Last seen Soy tag.
	          kind: state.kind.concat([]), // Values of kind="" attributes.
	          kindTag: state.kindTag.concat([]), // Opened tags with kind="" attributes.
	          soyState: state.soyState.concat([]),
	          templates: state.templates,
	          variables: state.variables,
	          scopes: state.scopes,
	          indent: state.indent, // Indentation of the following line.
	          localMode: state.localMode,
	          localState: CodeMirror.copyState(state.localMode, state.localState)
	        };
	      },
	
	      token: function(stream, state) {
	        var match;
	
	        switch (last(state.soyState)) {
	          case "comment":
	            if (stream.match(/^.*?\*\//)) {
	              state.soyState.pop();
	            } else {
	              stream.skipToEnd();
	            }
	            return "comment";
	
	          case "templ-def":
	            if (match = stream.match(/^\.?([\w]+(?!\.[\w]+)*)/)) {
	              state.templates = prepend(state.templates, match[1]);
	              state.scopes = prepend(state.scopes, state.variables);
	              state.soyState.pop();
	              return "def";
	            }
	            stream.next();
	            return null;
	
	          case "templ-ref":
	            if (match = stream.match(/^\.?([\w]+)/)) {
	              state.soyState.pop();
	              // If the first character is '.', try to match against a local template name.
	              if (match[0][0] == '.') {
	                return ref(state.templates, match[1], true);
	              }
	              // Otherwise
	              return "variable";
	            }
	            stream.next();
	            return null;
	
	          case "param-def":
	            if (match = stream.match(/^([\w]+)(?=:)/)) {
	              state.variables = prepend(state.variables, match[1]);
	              state.soyState.pop();
	              state.soyState.push("param-type");
	              return "def";
	            }
	            stream.next();
	            return null;
	
	          case "param-type":
	            if (stream.peek() == "}") {
	              state.soyState.pop();
	              return null;
	            }
	            if (stream.eatWhile(/^[\w]+/)) {
	              return "variable-3";
	            }
	            stream.next();
	            return null;
	
	          case "var-def":
	            if (match = stream.match(/^\$([\w]+)/)) {
	              state.variables = prepend(state.variables, match[1]);
	              state.soyState.pop();
	              return "def";
	            }
	            stream.next();
	            return null;
	
	          case "tag":
	            if (stream.match(/^\/?}/)) {
	              if (state.tag == "/template" || state.tag == "/deltemplate") {
	                popscope(state);
	                state.indent = 0;
	              } else {
	                if (state.tag == "/for" || state.tag == "/foreach") {
	                  popscope(state);
	                }
	                state.indent -= config.indentUnit *
	                    (stream.current() == "/}" || indentingTags.indexOf(state.tag) == -1 ? 2 : 1);
	              }
	              state.soyState.pop();
	              return "keyword";
	            } else if (stream.match(/^([\w?]+)(?==)/)) {
	              if (stream.current() == "kind" && (match = stream.match(/^="([^"]+)/, false))) {
	                var kind = match[1];
	                state.kind.push(kind);
	                state.kindTag.push(state.tag);
	                state.localMode = modes[kind] || modes.html;
	                state.localState = CodeMirror.startState(state.localMode);
	              }
	              return "attribute";
	            } else if (stream.match(/^"/)) {
	              state.soyState.push("string");
	              return "string";
	            }
	            if (match = stream.match(/^\$([\w]+)/)) {
	              return ref(state.variables, match[1]);
	            }
	            if (match = stream.match(/^\w+/)) {
	              return /^(?:as|and|or|not|in)$/.test(match[0]) ? "keyword" : null;
	            }
	            stream.next();
	            return null;
	
	          case "literal":
	            if (stream.match(/^(?=\{\/literal})/)) {
	              state.indent -= config.indentUnit;
	              state.soyState.pop();
	              return this.token(stream, state);
	            }
	            return tokenUntil(stream, state, /\{\/literal}/);
	
	          case "string":
	            var match = stream.match(/^.*?("|\\[\s\S])/);
	            if (!match) {
	              stream.skipToEnd();
	            } else if (match[1] == "\"") {
	              state.soyState.pop();
	            }
	            return "string";
	        }
	
	        if (stream.match(/^\/\*/)) {
	          state.soyState.push("comment");
	          return "comment";
	        } else if (stream.match(stream.sol() ? /^\s*\/\/.*/ : /^\s+\/\/.*/)) {
	          return "comment";
	        } else if (stream.match(/^\{literal}/)) {
	          state.indent += config.indentUnit;
	          state.soyState.push("literal");
	          return "keyword";
	        } else if (match = stream.match(/^\{([\/@\\]?[\w?]*)/)) {
	          if (match[1] != "/switch")
	            state.indent += (/^(\/|(else|elseif|ifempty|case|default)$)/.test(match[1]) && state.tag != "switch" ? 1 : 2) * config.indentUnit;
	          state.tag = match[1];
	          if (state.tag == "/" + last(state.kindTag)) {
	            // We found the tag that opened the current kind="".
	            state.kind.pop();
	            state.kindTag.pop();
	            state.localMode = modes[last(state.kind)] || modes.html;
	            state.localState = CodeMirror.startState(state.localMode);
	          }
	          state.soyState.push("tag");
	          if (state.tag == "template" || state.tag == "deltemplate") {
	            state.soyState.push("templ-def");
	          }
	          if (state.tag == "call" || state.tag == "delcall") {
	            state.soyState.push("templ-ref");
	          }
	          if (state.tag == "let") {
	            state.soyState.push("var-def");
	          }
	          if (state.tag == "for" || state.tag == "foreach") {
	            state.scopes = prepend(state.scopes, state.variables);
	            state.soyState.push("var-def");
	          }
	          if (state.tag.match(/^@param\??/)) {
	            state.soyState.push("param-def");
	          }
	          return "keyword";
	        }
	
	        return tokenUntil(stream, state, /\{|\s+\/\/|\/\*/);
	      },
	
	      indent: function(state, textAfter) {
	        var indent = state.indent, top = last(state.soyState);
	        if (top == "comment") return CodeMirror.Pass;
	
	        if (top == "literal") {
	          if (/^\{\/literal}/.test(textAfter)) indent -= config.indentUnit;
	        } else {
	          if (/^\s*\{\/(template|deltemplate)\b/.test(textAfter)) return 0;
	          if (/^\{(\/|(fallbackmsg|elseif|else|ifempty)\b)/.test(textAfter)) indent -= config.indentUnit;
	          if (state.tag != "switch" && /^\{(case|default)\b/.test(textAfter)) indent -= config.indentUnit;
	          if (/^\{\/switch\b/.test(textAfter)) indent -= config.indentUnit;
	        }
	        if (indent && state.localMode.indent)
	          indent += state.localMode.indent(state.localState, textAfter);
	        return indent;
	      },
	
	      innerMode: function(state) {
	        if (state.soyState.length && last(state.soyState) != "literal") return null;
	        else return {state: state.localState, mode: state.localMode};
	      },
	
	      electricInput: /^\s*\{(\/|\/template|\/deltemplate|\/switch|fallbackmsg|elseif|else|case|default|ifempty|\/literal\})$/,
	      lineComment: "//",
	      blockCommentStart: "/*",
	      blockCommentEnd: "*/",
	      blockCommentContinue: " * ",
	      fold: "indent"
	    };
	  }, "htmlmixed");
	
	  CodeMirror.registerHelper("hintWords", "soy", indentingTags.concat(
	      ["delpackage", "namespace", "alias", "print", "css", "debugger"]));
	
	  CodeMirror.defineMIME("text/x-soy", "soy");
	});


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("sparql", function(config) {
	  var indentUnit = config.indentUnit;
	  var curPunc;
	
	  function wordRegexp(words) {
	    return new RegExp("^(?:" + words.join("|") + ")$", "i");
	  }
	  var ops = wordRegexp(["str", "lang", "langmatches", "datatype", "bound", "sameterm", "isiri", "isuri",
	                        "iri", "uri", "bnode", "count", "sum", "min", "max", "avg", "sample",
	                        "group_concat", "rand", "abs", "ceil", "floor", "round", "concat", "substr", "strlen",
	                        "replace", "ucase", "lcase", "encode_for_uri", "contains", "strstarts", "strends",
	                        "strbefore", "strafter", "year", "month", "day", "hours", "minutes", "seconds",
	                        "timezone", "tz", "now", "uuid", "struuid", "md5", "sha1", "sha256", "sha384",
	                        "sha512", "coalesce", "if", "strlang", "strdt", "isnumeric", "regex", "exists",
	                        "isblank", "isliteral", "a", "bind"]);
	  var keywords = wordRegexp(["base", "prefix", "select", "distinct", "reduced", "construct", "describe",
	                             "ask", "from", "named", "where", "order", "limit", "offset", "filter", "optional",
	                             "graph", "by", "asc", "desc", "as", "having", "undef", "values", "group",
	                             "minus", "in", "not", "service", "silent", "using", "insert", "delete", "union",
	                             "true", "false", "with",
	                             "data", "copy", "to", "move", "add", "create", "drop", "clear", "load"]);
	  var operatorChars = /[*+\-<>=&|\^\/!\?]/;
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    curPunc = null;
	    if (ch == "$" || ch == "?") {
	      if(ch == "?" && stream.match(/\s/, false)){
	        return "operator";
	      }
	      stream.match(/^[\w\d]*/);
	      return "variable-2";
	    }
	    else if (ch == "<" && !stream.match(/^[\s\u00a0=]/, false)) {
	      stream.match(/^[^\s\u00a0>]*>?/);
	      return "atom";
	    }
	    else if (ch == "\"" || ch == "'") {
	      state.tokenize = tokenLiteral(ch);
	      return state.tokenize(stream, state);
	    }
	    else if (/[{}\(\),\.;\[\]]/.test(ch)) {
	      curPunc = ch;
	      return "bracket";
	    }
	    else if (ch == "#") {
	      stream.skipToEnd();
	      return "comment";
	    }
	    else if (operatorChars.test(ch)) {
	      stream.eatWhile(operatorChars);
	      return "operator";
	    }
	    else if (ch == ":") {
	      stream.eatWhile(/[\w\d\._\-]/);
	      return "atom";
	    }
	    else if (ch == "@") {
	      stream.eatWhile(/[a-z\d\-]/i);
	      return "meta";
	    }
	    else {
	      stream.eatWhile(/[_\w\d]/);
	      if (stream.eat(":")) {
	        stream.eatWhile(/[\w\d_\-]/);
	        return "atom";
	      }
	      var word = stream.current();
	      if (ops.test(word))
	        return "builtin";
	      else if (keywords.test(word))
	        return "keyword";
	      else
	        return "variable";
	    }
	  }
	
	  function tokenLiteral(quote) {
	    return function(stream, state) {
	      var escaped = false, ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == quote && !escaped) {
	          state.tokenize = tokenBase;
	          break;
	        }
	        escaped = !escaped && ch == "\\";
	      }
	      return "string";
	    };
	  }
	
	  function pushContext(state, type, col) {
	    state.context = {prev: state.context, indent: state.indent, col: col, type: type};
	  }
	  function popContext(state) {
	    state.indent = state.context.indent;
	    state.context = state.context.prev;
	  }
	
	  return {
	    startState: function() {
	      return {tokenize: tokenBase,
	              context: null,
	              indent: 0,
	              col: 0};
	    },
	
	    token: function(stream, state) {
	      if (stream.sol()) {
	        if (state.context && state.context.align == null) state.context.align = false;
	        state.indent = stream.indentation();
	      }
	      if (stream.eatSpace()) return null;
	      var style = state.tokenize(stream, state);
	
	      if (style != "comment" && state.context && state.context.align == null && state.context.type != "pattern") {
	        state.context.align = true;
	      }
	
	      if (curPunc == "(") pushContext(state, ")", stream.column());
	      else if (curPunc == "[") pushContext(state, "]", stream.column());
	      else if (curPunc == "{") pushContext(state, "}", stream.column());
	      else if (/[\]\}\)]/.test(curPunc)) {
	        while (state.context && state.context.type == "pattern") popContext(state);
	        if (state.context && curPunc == state.context.type) {
	          popContext(state);
	          if (curPunc == "}" && state.context && state.context.type == "pattern")
	            popContext(state);
	        }
	      }
	      else if (curPunc == "." && state.context && state.context.type == "pattern") popContext(state);
	      else if (/atom|string|variable/.test(style) && state.context) {
	        if (/[\}\]]/.test(state.context.type))
	          pushContext(state, "pattern", stream.column());
	        else if (state.context.type == "pattern" && !state.context.align) {
	          state.context.align = true;
	          state.context.col = stream.column();
	        }
	      }
	
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      var firstChar = textAfter && textAfter.charAt(0);
	      var context = state.context;
	      if (/[\]\}]/.test(firstChar))
	        while (context && context.type == "pattern") context = context.prev;
	
	      var closing = context && firstChar == context.type;
	      if (!context)
	        return 0;
	      else if (context.type == "pattern")
	        return context.col;
	      else if (context.align)
	        return context.col + (closing ? 0 : 1);
	      else
	        return context.indent + (closing ? 0 : indentUnit);
	    },
	
	    lineComment: "#"
	  };
	});
	
	CodeMirror.defineMIME("application/sparql-query", "sparql");
	
	});


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("spreadsheet", function () {
	    return {
	      startState: function () {
	        return {
	          stringType: null,
	          stack: []
	        };
	      },
	      token: function (stream, state) {
	        if (!stream) return;
	
	        //check for state changes
	        if (state.stack.length === 0) {
	          //strings
	          if ((stream.peek() == '"') || (stream.peek() == "'")) {
	            state.stringType = stream.peek();
	            stream.next(); // Skip quote
	            state.stack.unshift("string");
	          }
	        }
	
	        //return state
	        //stack has
	        switch (state.stack[0]) {
	        case "string":
	          while (state.stack[0] === "string" && !stream.eol()) {
	            if (stream.peek() === state.stringType) {
	              stream.next(); // Skip quote
	              state.stack.shift(); // Clear flag
	            } else if (stream.peek() === "\\") {
	              stream.next();
	              stream.next();
	            } else {
	              stream.match(/^.[^\\\"\']*/);
	            }
	          }
	          return "string";
	
	        case "characterClass":
	          while (state.stack[0] === "characterClass" && !stream.eol()) {
	            if (!(stream.match(/^[^\]\\]+/) || stream.match(/^\\./)))
	              state.stack.shift();
	          }
	          return "operator";
	        }
	
	        var peek = stream.peek();
	
	        //no stack
	        switch (peek) {
	        case "[":
	          stream.next();
	          state.stack.unshift("characterClass");
	          return "bracket";
	        case ":":
	          stream.next();
	          return "operator";
	        case "\\":
	          if (stream.match(/\\[a-z]+/)) return "string-2";
	          else {
	            stream.next();
	            return "atom";
	          }
	        case ".":
	        case ",":
	        case ";":
	        case "*":
	        case "-":
	        case "+":
	        case "^":
	        case "<":
	        case "/":
	        case "=":
	          stream.next();
	          return "atom";
	        case "$":
	          stream.next();
	          return "builtin";
	        }
	
	        if (stream.match(/\d+/)) {
	          if (stream.match(/^\w+/)) return "error";
	          return "number";
	        } else if (stream.match(/^[a-zA-Z_]\w*/)) {
	          if (stream.match(/(?=[\(.])/, false)) return "keyword";
	          return "variable-2";
	        } else if (["[", "]", "(", ")", "{", "}"].indexOf(peek) != -1) {
	          stream.next();
	          return "bracket";
	        } else if (!stream.eatSpace()) {
	          stream.next();
	        }
	        return null;
	      }
	    };
	  });
	
	  CodeMirror.defineMIME("text/x-spreadsheet", "spreadsheet");
	});


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// Swift mode created by Michael Kaminsky https://github.com/mkaminsky11
	
	(function(mod) {
	  if (true)
	    mod(__webpack_require__(2))
	  else if (typeof define == "function" && define.amd)
	    define(["../../lib/codemirror"], mod)
	  else
	    mod(CodeMirror)
	})(function(CodeMirror) {
	  "use strict"
	
	  function wordSet(words) {
	    var set = {}
	    for (var i = 0; i < words.length; i++) set[words[i]] = true
	    return set
	  }
	
	  var keywords = wordSet(["_","var","let","class","enum","extension","import","protocol","struct","func","typealias","associatedtype",
	                          "open","public","internal","fileprivate","private","deinit","init","new","override","self","subscript","super",
	                          "convenience","dynamic","final","indirect","lazy","required","static","unowned","unowned(safe)","unowned(unsafe)","weak","as","is",
	                          "break","case","continue","default","else","fallthrough","for","guard","if","in","repeat","switch","where","while",
	                          "defer","return","inout","mutating","nonmutating","catch","do","rethrows","throw","throws","try","didSet","get","set","willSet",
	                          "assignment","associativity","infix","left","none","operator","postfix","precedence","precedencegroup","prefix","right",
	                          "Any","AnyObject","Type","dynamicType","Self","Protocol","__COLUMN__","__FILE__","__FUNCTION__","__LINE__"])
	  var definingKeywords = wordSet(["var","let","class","enum","extension","import","protocol","struct","func","typealias","associatedtype","for"])
	  var atoms = wordSet(["true","false","nil","self","super","_"])
	  var types = wordSet(["Array","Bool","Character","Dictionary","Double","Float","Int","Int8","Int16","Int32","Int64","Never","Optional","Set","String",
	                       "UInt8","UInt16","UInt32","UInt64","Void"])
	  var operators = "+-/*%=|&<>~^?!"
	  var punc = ":;,.(){}[]"
	  var binary = /^\-?0b[01][01_]*/
	  var octal = /^\-?0o[0-7][0-7_]*/
	  var hexadecimal = /^\-?0x[\dA-Fa-f][\dA-Fa-f_]*(?:(?:\.[\dA-Fa-f][\dA-Fa-f_]*)?[Pp]\-?\d[\d_]*)?/
	  var decimal = /^\-?\d[\d_]*(?:\.\d[\d_]*)?(?:[Ee]\-?\d[\d_]*)?/
	  var identifier = /^\$\d+|(`?)[_A-Za-z][_A-Za-z$0-9]*\1/
	  var property = /^\.(?:\$\d+|(`?)[_A-Za-z][_A-Za-z$0-9]*\1)/
	  var instruction = /^\#[A-Za-z]+/
	  var attribute = /^@(?:\$\d+|(`?)[_A-Za-z][_A-Za-z$0-9]*\1)/
	  //var regexp = /^\/(?!\s)(?:\/\/)?(?:\\.|[^\/])+\//
	
	  function tokenBase(stream, state, prev) {
	    if (stream.sol()) state.indented = stream.indentation()
	    if (stream.eatSpace()) return null
	
	    var ch = stream.peek()
	    if (ch == "/") {
	      if (stream.match("//")) {
	        stream.skipToEnd()
	        return "comment"
	      }
	      if (stream.match("/*")) {
	        state.tokenize.push(tokenComment)
	        return tokenComment(stream, state)
	      }
	    }
	    if (stream.match(instruction)) return "builtin"
	    if (stream.match(attribute)) return "attribute"
	    if (stream.match(binary)) return "number"
	    if (stream.match(octal)) return "number"
	    if (stream.match(hexadecimal)) return "number"
	    if (stream.match(decimal)) return "number"
	    if (stream.match(property)) return "property"
	    if (operators.indexOf(ch) > -1) {
	      stream.next()
	      return "operator"
	    }
	    if (punc.indexOf(ch) > -1) {
	      stream.next()
	      stream.match("..")
	      return "punctuation"
	    }
	    if (ch == '"' || ch == "'") {
	      stream.next()
	      var tokenize = tokenString(ch)
	      state.tokenize.push(tokenize)
	      return tokenize(stream, state)
	    }
	
	    if (stream.match(identifier)) {
	      var ident = stream.current()
	      if (types.hasOwnProperty(ident)) return "variable-2"
	      if (atoms.hasOwnProperty(ident)) return "atom"
	      if (keywords.hasOwnProperty(ident)) {
	        if (definingKeywords.hasOwnProperty(ident))
	          state.prev = "define"
	        return "keyword"
	      }
	      if (prev == "define") return "def"
	      return "variable"
	    }
	
	    stream.next()
	    return null
	  }
	
	  function tokenUntilClosingParen() {
	    var depth = 0
	    return function(stream, state, prev) {
	      var inner = tokenBase(stream, state, prev)
	      if (inner == "punctuation") {
	        if (stream.current() == "(") ++depth
	        else if (stream.current() == ")") {
	          if (depth == 0) {
	            stream.backUp(1)
	            state.tokenize.pop()
	            return state.tokenize[state.tokenize.length - 1](stream, state)
	          }
	          else --depth
	        }
	      }
	      return inner
	    }
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var ch, escaped = false
	      while (ch = stream.next()) {
	        if (escaped) {
	          if (ch == "(") {
	            state.tokenize.push(tokenUntilClosingParen())
	            return "string"
	          }
	          escaped = false
	        } else if (ch == quote) {
	          break
	        } else {
	          escaped = ch == "\\"
	        }
	      }
	      state.tokenize.pop()
	      return "string"
	    }
	  }
	
	  function tokenComment(stream, state) {
	    stream.match(/^(?:[^*]|\*(?!\/))*/)
	    if (stream.match("*/")) state.tokenize.pop()
	    return "comment"
	  }
	
	  function Context(prev, align, indented) {
	    this.prev = prev
	    this.align = align
	    this.indented = indented
	  }
	
	  function pushContext(state, stream) {
	    var align = stream.match(/^\s*($|\/[\/\*])/, false) ? null : stream.column() + 1
	    state.context = new Context(state.context, align, state.indented)
	  }
	
	  function popContext(state) {
	    if (state.context) {
	      state.indented = state.context.indented
	      state.context = state.context.prev
	    }
	  }
	
	  CodeMirror.defineMode("swift", function(config) {
	    return {
	      startState: function() {
	        return {
	          prev: null,
	          context: null,
	          indented: 0,
	          tokenize: []
	        }
	      },
	
	      token: function(stream, state) {
	        var prev = state.prev
	        state.prev = null
	        var tokenize = state.tokenize[state.tokenize.length - 1] || tokenBase
	        var style = tokenize(stream, state, prev)
	        if (!style || style == "comment") state.prev = prev
	        else if (!state.prev) state.prev = style
	
	        if (style == "punctuation") {
	          var bracket = /[\(\[\{]|([\]\)\}])/.exec(stream.current())
	          if (bracket) (bracket[1] ? popContext : pushContext)(state, stream)
	        }
	
	        return style
	      },
	
	      indent: function(state, textAfter) {
	        var cx = state.context
	        if (!cx) return 0
	        var closing = /^[\]\}\)]/.test(textAfter)
	        if (cx.align != null) return cx.align - (closing ? 1 : 0)
	        return cx.indented + (closing ? 0 : config.indentUnit)
	      },
	
	      electricInput: /^\s*[\)\}\]]$/,
	
	      lineComment: "//",
	      blockCommentStart: "/*",
	      blockCommentEnd: "*/",
	      fold: "brace",
	      closeBrackets: "()[]{}''\"\"``"
	    }
	  })
	
	  CodeMirror.defineMIME("text/x-swift","swift")
	});


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	//tcl mode by Ford_Lawnmower :: Based on Velocity mode by Steve O'Hara
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("tcl", function() {
	  function parseWords(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	  var keywords = parseWords("Tcl safe after append array auto_execok auto_import auto_load " +
	        "auto_mkindex auto_mkindex_old auto_qualify auto_reset bgerror " +
	        "binary break catch cd close concat continue dde eof encoding error " +
	        "eval exec exit expr fblocked fconfigure fcopy file fileevent filename " +
	        "filename flush for foreach format gets glob global history http if " +
	        "incr info interp join lappend lindex linsert list llength load lrange " +
	        "lreplace lsearch lset lsort memory msgcat namespace open package parray " +
	        "pid pkg::create pkg_mkIndex proc puts pwd re_syntax read regex regexp " +
	        "registry regsub rename resource return scan seek set socket source split " +
	        "string subst switch tcl_endOfWord tcl_findLibrary tcl_startOfNextWord " +
	        "tcl_wordBreakAfter tcl_startOfPreviousWord tcl_wordBreakBefore tcltest " +
	        "tclvars tell time trace unknown unset update uplevel upvar variable " +
	    "vwait");
	    var functions = parseWords("if elseif else and not or eq ne in ni for foreach while switch");
	    var isOperatorChar = /[+\-*&%=<>!?^\/\|]/;
	    function chain(stream, state, f) {
	      state.tokenize = f;
	      return f(stream, state);
	    }
	    function tokenBase(stream, state) {
	      var beforeParams = state.beforeParams;
	      state.beforeParams = false;
	      var ch = stream.next();
	      if ((ch == '"' || ch == "'") && state.inParams) {
	        return chain(stream, state, tokenString(ch));
	      } else if (/[\[\]{}\(\),;\.]/.test(ch)) {
	        if (ch == "(" && beforeParams) state.inParams = true;
	        else if (ch == ")") state.inParams = false;
	          return null;
	      } else if (/\d/.test(ch)) {
	        stream.eatWhile(/[\w\.]/);
	        return "number";
	      } else if (ch == "#") {
	        if (stream.eat("*"))
	          return chain(stream, state, tokenComment);
	        if (ch == "#" && stream.match(/ *\[ *\[/))
	          return chain(stream, state, tokenUnparsed);
	        stream.skipToEnd();
	        return "comment";
	      } else if (ch == '"') {
	        stream.skipTo(/"/);
	        return "comment";
	      } else if (ch == "$") {
	        stream.eatWhile(/[$_a-z0-9A-Z\.{:]/);
	        stream.eatWhile(/}/);
	        state.beforeParams = true;
	        return "builtin";
	      } else if (isOperatorChar.test(ch)) {
	        stream.eatWhile(isOperatorChar);
	        return "comment";
	      } else {
	        stream.eatWhile(/[\w\$_{}\xa1-\uffff]/);
	        var word = stream.current().toLowerCase();
	        if (keywords && keywords.propertyIsEnumerable(word))
	          return "keyword";
	        if (functions && functions.propertyIsEnumerable(word)) {
	          state.beforeParams = true;
	          return "keyword";
	        }
	        return null;
	      }
	    }
	    function tokenString(quote) {
	      return function(stream, state) {
	      var escaped = false, next, end = false;
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) {
	          end = true;
	          break;
	        }
	        escaped = !escaped && next == "\\";
	      }
	      if (end) state.tokenize = tokenBase;
	        return "string";
	      };
	    }
	    function tokenComment(stream, state) {
	      var maybeEnd = false, ch;
	      while (ch = stream.next()) {
	        if (ch == "#" && maybeEnd) {
	          state.tokenize = tokenBase;
	          break;
	        }
	        maybeEnd = (ch == "*");
	      }
	      return "comment";
	    }
	    function tokenUnparsed(stream, state) {
	      var maybeEnd = 0, ch;
	      while (ch = stream.next()) {
	        if (ch == "#" && maybeEnd == 2) {
	          state.tokenize = tokenBase;
	          break;
	        }
	        if (ch == "]")
	          maybeEnd++;
	        else if (ch != " ")
	          maybeEnd = 0;
	      }
	      return "meta";
	    }
	    return {
	      startState: function() {
	        return {
	          tokenize: tokenBase,
	          beforeParams: false,
	          inParams: false
	        };
	      },
	      token: function(stream, state) {
	        if (stream.eatSpace()) return null;
	        return state.tokenize(stream, state);
	      }
	    };
	});
	CodeMirror.defineMIME("text/x-tcl", "tcl");
	
	});


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) { // CommonJS
	    mod(__webpack_require__(2));
	  } else if (typeof define == "function" && define.amd) { // AMD
	    define(["../../lib/codemirror"], mod);
	  } else { // Plain browser env
	    mod(CodeMirror);
	  }
	})(function(CodeMirror) {
	  "use strict";
	
	  var TOKEN_STYLES = {
	    addition: "positive",
	    attributes: "attribute",
	    bold: "strong",
	    cite: "keyword",
	    code: "atom",
	    definitionList: "number",
	    deletion: "negative",
	    div: "punctuation",
	    em: "em",
	    footnote: "variable",
	    footCite: "qualifier",
	    header: "header",
	    html: "comment",
	    image: "string",
	    italic: "em",
	    link: "link",
	    linkDefinition: "link",
	    list1: "variable-2",
	    list2: "variable-3",
	    list3: "keyword",
	    notextile: "string-2",
	    pre: "operator",
	    p: "property",
	    quote: "bracket",
	    span: "quote",
	    specialChar: "tag",
	    strong: "strong",
	    sub: "builtin",
	    sup: "builtin",
	    table: "variable-3",
	    tableHeading: "operator"
	  };
	
	  function startNewLine(stream, state) {
	    state.mode = Modes.newLayout;
	    state.tableHeading = false;
	
	    if (state.layoutType === "definitionList" && state.spanningLayout &&
	        stream.match(RE("definitionListEnd"), false))
	      state.spanningLayout = false;
	  }
	
	  function handlePhraseModifier(stream, state, ch) {
	    if (ch === "_") {
	      if (stream.eat("_"))
	        return togglePhraseModifier(stream, state, "italic", /__/, 2);
	      else
	        return togglePhraseModifier(stream, state, "em", /_/, 1);
	    }
	
	    if (ch === "*") {
	      if (stream.eat("*")) {
	        return togglePhraseModifier(stream, state, "bold", /\*\*/, 2);
	      }
	      return togglePhraseModifier(stream, state, "strong", /\*/, 1);
	    }
	
	    if (ch === "[") {
	      if (stream.match(/\d+\]/)) state.footCite = true;
	      return tokenStyles(state);
	    }
	
	    if (ch === "(") {
	      var spec = stream.match(/^(r|tm|c)\)/);
	      if (spec)
	        return tokenStylesWith(state, TOKEN_STYLES.specialChar);
	    }
	
	    if (ch === "<" && stream.match(/(\w+)[^>]+>[^<]+<\/\1>/))
	      return tokenStylesWith(state, TOKEN_STYLES.html);
	
	    if (ch === "?" && stream.eat("?"))
	      return togglePhraseModifier(stream, state, "cite", /\?\?/, 2);
	
	    if (ch === "=" && stream.eat("="))
	      return togglePhraseModifier(stream, state, "notextile", /==/, 2);
	
	    if (ch === "-" && !stream.eat("-"))
	      return togglePhraseModifier(stream, state, "deletion", /-/, 1);
	
	    if (ch === "+")
	      return togglePhraseModifier(stream, state, "addition", /\+/, 1);
	
	    if (ch === "~")
	      return togglePhraseModifier(stream, state, "sub", /~/, 1);
	
	    if (ch === "^")
	      return togglePhraseModifier(stream, state, "sup", /\^/, 1);
	
	    if (ch === "%")
	      return togglePhraseModifier(stream, state, "span", /%/, 1);
	
	    if (ch === "@")
	      return togglePhraseModifier(stream, state, "code", /@/, 1);
	
	    if (ch === "!") {
	      var type = togglePhraseModifier(stream, state, "image", /(?:\([^\)]+\))?!/, 1);
	      stream.match(/^:\S+/); // optional Url portion
	      return type;
	    }
	    return tokenStyles(state);
	  }
	
	  function togglePhraseModifier(stream, state, phraseModifier, closeRE, openSize) {
	    var charBefore = stream.pos > openSize ? stream.string.charAt(stream.pos - openSize - 1) : null;
	    var charAfter = stream.peek();
	    if (state[phraseModifier]) {
	      if ((!charAfter || /\W/.test(charAfter)) && charBefore && /\S/.test(charBefore)) {
	        var type = tokenStyles(state);
	        state[phraseModifier] = false;
	        return type;
	      }
	    } else if ((!charBefore || /\W/.test(charBefore)) && charAfter && /\S/.test(charAfter) &&
	               stream.match(new RegExp("^.*\\S" + closeRE.source + "(?:\\W|$)"), false)) {
	      state[phraseModifier] = true;
	      state.mode = Modes.attributes;
	    }
	    return tokenStyles(state);
	  };
	
	  function tokenStyles(state) {
	    var disabled = textileDisabled(state);
	    if (disabled) return disabled;
	
	    var styles = [];
	    if (state.layoutType) styles.push(TOKEN_STYLES[state.layoutType]);
	
	    styles = styles.concat(activeStyles(
	      state, "addition", "bold", "cite", "code", "deletion", "em", "footCite",
	      "image", "italic", "link", "span", "strong", "sub", "sup", "table", "tableHeading"));
	
	    if (state.layoutType === "header")
	      styles.push(TOKEN_STYLES.header + "-" + state.header);
	
	    return styles.length ? styles.join(" ") : null;
	  }
	
	  function textileDisabled(state) {
	    var type = state.layoutType;
	
	    switch(type) {
	    case "notextile":
	    case "code":
	    case "pre":
	      return TOKEN_STYLES[type];
	    default:
	      if (state.notextile)
	        return TOKEN_STYLES.notextile + (type ? (" " + TOKEN_STYLES[type]) : "");
	      return null;
	    }
	  }
	
	  function tokenStylesWith(state, extraStyles) {
	    var disabled = textileDisabled(state);
	    if (disabled) return disabled;
	
	    var type = tokenStyles(state);
	    if (extraStyles)
	      return type ? (type + " " + extraStyles) : extraStyles;
	    else
	      return type;
	  }
	
	  function activeStyles(state) {
	    var styles = [];
	    for (var i = 1; i < arguments.length; ++i) {
	      if (state[arguments[i]])
	        styles.push(TOKEN_STYLES[arguments[i]]);
	    }
	    return styles;
	  }
	
	  function blankLine(state) {
	    var spanningLayout = state.spanningLayout, type = state.layoutType;
	
	    for (var key in state) if (state.hasOwnProperty(key))
	      delete state[key];
	
	    state.mode = Modes.newLayout;
	    if (spanningLayout) {
	      state.layoutType = type;
	      state.spanningLayout = true;
	    }
	  }
	
	  var REs = {
	    cache: {},
	    single: {
	      bc: "bc",
	      bq: "bq",
	      definitionList: /- [^(?::=)]+:=+/,
	      definitionListEnd: /.*=:\s*$/,
	      div: "div",
	      drawTable: /\|.*\|/,
	      foot: /fn\d+/,
	      header: /h[1-6]/,
	      html: /\s*<(?:\/)?(\w+)(?:[^>]+)?>(?:[^<]+<\/\1>)?/,
	      link: /[^"]+":\S/,
	      linkDefinition: /\[[^\s\]]+\]\S+/,
	      list: /(?:#+|\*+)/,
	      notextile: "notextile",
	      para: "p",
	      pre: "pre",
	      table: "table",
	      tableCellAttributes: /[\/\\]\d+/,
	      tableHeading: /\|_\./,
	      tableText: /[^"_\*\[\(\?\+~\^%@|-]+/,
	      text: /[^!"_=\*\[\(<\?\+~\^%@-]+/
	    },
	    attributes: {
	      align: /(?:<>|<|>|=)/,
	      selector: /\([^\(][^\)]+\)/,
	      lang: /\[[^\[\]]+\]/,
	      pad: /(?:\(+|\)+){1,2}/,
	      css: /\{[^\}]+\}/
	    },
	    createRe: function(name) {
	      switch (name) {
	      case "drawTable":
	        return REs.makeRe("^", REs.single.drawTable, "$");
	      case "html":
	        return REs.makeRe("^", REs.single.html, "(?:", REs.single.html, ")*", "$");
	      case "linkDefinition":
	        return REs.makeRe("^", REs.single.linkDefinition, "$");
	      case "listLayout":
	        return REs.makeRe("^", REs.single.list, RE("allAttributes"), "*\\s+");
	      case "tableCellAttributes":
	        return REs.makeRe("^", REs.choiceRe(REs.single.tableCellAttributes,
	                                            RE("allAttributes")), "+\\.");
	      case "type":
	        return REs.makeRe("^", RE("allTypes"));
	      case "typeLayout":
	        return REs.makeRe("^", RE("allTypes"), RE("allAttributes"),
	                          "*\\.\\.?", "(\\s+|$)");
	      case "attributes":
	        return REs.makeRe("^", RE("allAttributes"), "+");
	
	      case "allTypes":
	        return REs.choiceRe(REs.single.div, REs.single.foot,
	                            REs.single.header, REs.single.bc, REs.single.bq,
	                            REs.single.notextile, REs.single.pre, REs.single.table,
	                            REs.single.para);
	
	      case "allAttributes":
	        return REs.choiceRe(REs.attributes.selector, REs.attributes.css,
	                            REs.attributes.lang, REs.attributes.align, REs.attributes.pad);
	
	      default:
	        return REs.makeRe("^", REs.single[name]);
	      }
	    },
	    makeRe: function() {
	      var pattern = "";
	      for (var i = 0; i < arguments.length; ++i) {
	        var arg = arguments[i];
	        pattern += (typeof arg === "string") ? arg : arg.source;
	      }
	      return new RegExp(pattern);
	    },
	    choiceRe: function() {
	      var parts = [arguments[0]];
	      for (var i = 1; i < arguments.length; ++i) {
	        parts[i * 2 - 1] = "|";
	        parts[i * 2] = arguments[i];
	      }
	
	      parts.unshift("(?:");
	      parts.push(")");
	      return REs.makeRe.apply(null, parts);
	    }
	  };
	
	  function RE(name) {
	    return (REs.cache[name] || (REs.cache[name] = REs.createRe(name)));
	  }
	
	  var Modes = {
	    newLayout: function(stream, state) {
	      if (stream.match(RE("typeLayout"), false)) {
	        state.spanningLayout = false;
	        return (state.mode = Modes.blockType)(stream, state);
	      }
	      var newMode;
	      if (!textileDisabled(state)) {
	        if (stream.match(RE("listLayout"), false))
	          newMode = Modes.list;
	        else if (stream.match(RE("drawTable"), false))
	          newMode = Modes.table;
	        else if (stream.match(RE("linkDefinition"), false))
	          newMode = Modes.linkDefinition;
	        else if (stream.match(RE("definitionList")))
	          newMode = Modes.definitionList;
	        else if (stream.match(RE("html"), false))
	          newMode = Modes.html;
	      }
	      return (state.mode = (newMode || Modes.text))(stream, state);
	    },
	
	    blockType: function(stream, state) {
	      var match, type;
	      state.layoutType = null;
	
	      if (match = stream.match(RE("type")))
	        type = match[0];
	      else
	        return (state.mode = Modes.text)(stream, state);
	
	      if (match = type.match(RE("header"))) {
	        state.layoutType = "header";
	        state.header = parseInt(match[0][1]);
	      } else if (type.match(RE("bq"))) {
	        state.layoutType = "quote";
	      } else if (type.match(RE("bc"))) {
	        state.layoutType = "code";
	      } else if (type.match(RE("foot"))) {
	        state.layoutType = "footnote";
	      } else if (type.match(RE("notextile"))) {
	        state.layoutType = "notextile";
	      } else if (type.match(RE("pre"))) {
	        state.layoutType = "pre";
	      } else if (type.match(RE("div"))) {
	        state.layoutType = "div";
	      } else if (type.match(RE("table"))) {
	        state.layoutType = "table";
	      }
	
	      state.mode = Modes.attributes;
	      return tokenStyles(state);
	    },
	
	    text: function(stream, state) {
	      if (stream.match(RE("text"))) return tokenStyles(state);
	
	      var ch = stream.next();
	      if (ch === '"')
	        return (state.mode = Modes.link)(stream, state);
	      return handlePhraseModifier(stream, state, ch);
	    },
	
	    attributes: function(stream, state) {
	      state.mode = Modes.layoutLength;
	
	      if (stream.match(RE("attributes")))
	        return tokenStylesWith(state, TOKEN_STYLES.attributes);
	      else
	        return tokenStyles(state);
	    },
	
	    layoutLength: function(stream, state) {
	      if (stream.eat(".") && stream.eat("."))
	        state.spanningLayout = true;
	
	      state.mode = Modes.text;
	      return tokenStyles(state);
	    },
	
	    list: function(stream, state) {
	      var match = stream.match(RE("list"));
	      state.listDepth = match[0].length;
	      var listMod = (state.listDepth - 1) % 3;
	      if (!listMod)
	        state.layoutType = "list1";
	      else if (listMod === 1)
	        state.layoutType = "list2";
	      else
	        state.layoutType = "list3";
	
	      state.mode = Modes.attributes;
	      return tokenStyles(state);
	    },
	
	    link: function(stream, state) {
	      state.mode = Modes.text;
	      if (stream.match(RE("link"))) {
	        stream.match(/\S+/);
	        return tokenStylesWith(state, TOKEN_STYLES.link);
	      }
	      return tokenStyles(state);
	    },
	
	    linkDefinition: function(stream, state) {
	      stream.skipToEnd();
	      return tokenStylesWith(state, TOKEN_STYLES.linkDefinition);
	    },
	
	    definitionList: function(stream, state) {
	      stream.match(RE("definitionList"));
	
	      state.layoutType = "definitionList";
	
	      if (stream.match(/\s*$/))
	        state.spanningLayout = true;
	      else
	        state.mode = Modes.attributes;
	
	      return tokenStyles(state);
	    },
	
	    html: function(stream, state) {
	      stream.skipToEnd();
	      return tokenStylesWith(state, TOKEN_STYLES.html);
	    },
	
	    table: function(stream, state) {
	      state.layoutType = "table";
	      return (state.mode = Modes.tableCell)(stream, state);
	    },
	
	    tableCell: function(stream, state) {
	      if (stream.match(RE("tableHeading")))
	        state.tableHeading = true;
	      else
	        stream.eat("|");
	
	      state.mode = Modes.tableCellAttributes;
	      return tokenStyles(state);
	    },
	
	    tableCellAttributes: function(stream, state) {
	      state.mode = Modes.tableText;
	
	      if (stream.match(RE("tableCellAttributes")))
	        return tokenStylesWith(state, TOKEN_STYLES.attributes);
	      else
	        return tokenStyles(state);
	    },
	
	    tableText: function(stream, state) {
	      if (stream.match(RE("tableText")))
	        return tokenStyles(state);
	
	      if (stream.peek() === "|") { // end of cell
	        state.mode = Modes.tableCell;
	        return tokenStyles(state);
	      }
	      return handlePhraseModifier(stream, state, stream.next());
	    }
	  };
	
	  CodeMirror.defineMode("textile", function() {
	    return {
	      startState: function() {
	        return { mode: Modes.newLayout };
	      },
	      token: function(stream, state) {
	        if (stream.sol()) startNewLine(stream, state);
	        return state.mode(stream, state);
	      },
	      blankLine: blankLine
	    };
	  });
	
	  CodeMirror.defineMIME("text/x-textile", "textile");
	});


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	/***
	    |''Name''|tiddlywiki.js|
	    |''Description''|Enables TiddlyWikiy syntax highlighting using CodeMirror|
	    |''Author''|PMario|
	    |''Version''|0.1.7|
	    |''Status''|''stable''|
	    |''Source''|[[GitHub|https://github.com/pmario/CodeMirror2/blob/tw-syntax/mode/tiddlywiki]]|
	    |''Documentation''|http://codemirror.tiddlyspace.com/|
	    |''License''|[[MIT License|http://www.opensource.org/licenses/mit-license.php]]|
	    |''CoreVersion''|2.5.0|
	    |''Requires''|codemirror.js|
	    |''Keywords''|syntax highlighting color code mirror codemirror|
	    ! Info
	    CoreVersion parameter is needed for TiddlyWiki only!
	***/
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("tiddlywiki", function () {
	  // Tokenizer
	  var textwords = {};
	
	  var keywords = {
	    "allTags": true, "closeAll": true, "list": true,
	    "newJournal": true, "newTiddler": true,
	    "permaview": true, "saveChanges": true,
	    "search": true, "slider": true, "tabs": true,
	    "tag": true, "tagging": true, "tags": true,
	    "tiddler": true, "timeline": true,
	    "today": true, "version": true, "option": true,
	    "with": true, "filter": true
	  };
	
	  var isSpaceName = /[\w_\-]/i,
	      reHR = /^\-\-\-\-+$/,                                 // <hr>
	      reWikiCommentStart = /^\/\*\*\*$/,            // /***
	      reWikiCommentStop = /^\*\*\*\/$/,             // ***/
	      reBlockQuote = /^<<<$/,
	
	      reJsCodeStart = /^\/\/\{\{\{$/,                       // //{{{ js block start
	      reJsCodeStop = /^\/\/\}\}\}$/,                        // //}}} js stop
	      reXmlCodeStart = /^<!--\{\{\{-->$/,           // xml block start
	      reXmlCodeStop = /^<!--\}\}\}-->$/,            // xml stop
	
	      reCodeBlockStart = /^\{\{\{$/,                        // {{{ TW text div block start
	      reCodeBlockStop = /^\}\}\}$/,                 // }}} TW text stop
	
	      reUntilCodeStop = /.*?\}\}\}/;
	
	  function chain(stream, state, f) {
	    state.tokenize = f;
	    return f(stream, state);
	  }
	
	  function tokenBase(stream, state) {
	    var sol = stream.sol(), ch = stream.peek();
	
	    state.block = false;        // indicates the start of a code block.
	
	    // check start of  blocks
	    if (sol && /[<\/\*{}\-]/.test(ch)) {
	      if (stream.match(reCodeBlockStart)) {
	        state.block = true;
	        return chain(stream, state, twTokenCode);
	      }
	      if (stream.match(reBlockQuote))
	        return 'quote';
	      if (stream.match(reWikiCommentStart) || stream.match(reWikiCommentStop))
	        return 'comment';
	      if (stream.match(reJsCodeStart) || stream.match(reJsCodeStop) || stream.match(reXmlCodeStart) || stream.match(reXmlCodeStop))
	        return 'comment';
	      if (stream.match(reHR))
	        return 'hr';
	    }
	
	    stream.next();
	    if (sol && /[\/\*!#;:>|]/.test(ch)) {
	      if (ch == "!") { // tw header
	        stream.skipToEnd();
	        return "header";
	      }
	      if (ch == "*") { // tw list
	        stream.eatWhile('*');
	        return "comment";
	      }
	      if (ch == "#") { // tw numbered list
	        stream.eatWhile('#');
	        return "comment";
	      }
	      if (ch == ";") { // definition list, term
	        stream.eatWhile(';');
	        return "comment";
	      }
	      if (ch == ":") { // definition list, description
	        stream.eatWhile(':');
	        return "comment";
	      }
	      if (ch == ">") { // single line quote
	        stream.eatWhile(">");
	        return "quote";
	      }
	      if (ch == '|')
	        return 'header';
	    }
	
	    if (ch == '{' && stream.match(/\{\{/))
	      return chain(stream, state, twTokenCode);
	
	    // rudimentary html:// file:// link matching. TW knows much more ...
	    if (/[hf]/i.test(ch) &&
	        /[ti]/i.test(stream.peek()) &&
	        stream.match(/\b(ttps?|tp|ile):\/\/[\-A-Z0-9+&@#\/%?=~_|$!:,.;]*[A-Z0-9+&@#\/%=~_|$]/i))
	      return "link";
	
	    // just a little string indicator, don't want to have the whole string covered
	    if (ch == '"')
	      return 'string';
	
	    if (ch == '~')    // _no_ CamelCase indicator should be bold
	      return 'brace';
	
	    if (/[\[\]]/.test(ch) && stream.match(ch)) // check for [[..]]
	      return 'brace';
	
	    if (ch == "@") {    // check for space link. TODO fix @@...@@ highlighting
	      stream.eatWhile(isSpaceName);
	      return "link";
	    }
	
	    if (/\d/.test(ch)) {        // numbers
	      stream.eatWhile(/\d/);
	      return "number";
	    }
	
	    if (ch == "/") { // tw invisible comment
	      if (stream.eat("%")) {
	        return chain(stream, state, twTokenComment);
	      } else if (stream.eat("/")) { //
	        return chain(stream, state, twTokenEm);
	      }
	    }
	
	    if (ch == "_" && stream.eat("_")) // tw underline
	        return chain(stream, state, twTokenUnderline);
	
	    // strikethrough and mdash handling
	    if (ch == "-" && stream.eat("-")) {
	      // if strikethrough looks ugly, change CSS.
	      if (stream.peek() != ' ')
	        return chain(stream, state, twTokenStrike);
	      // mdash
	      if (stream.peek() == ' ')
	        return 'brace';
	    }
	
	    if (ch == "'" && stream.eat("'")) // tw bold
	      return chain(stream, state, twTokenStrong);
	
	    if (ch == "<" && stream.eat("<")) // tw macro
	      return chain(stream, state, twTokenMacro);
	
	    // core macro handling
	    stream.eatWhile(/[\w\$_]/);
	    return textwords.propertyIsEnumerable(stream.current()) ? "keyword" : null
	  }
	
	  // tw invisible comment
	  function twTokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while (ch = stream.next()) {
	      if (ch == "/" && maybeEnd) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      maybeEnd = (ch == "%");
	    }
	    return "comment";
	  }
	
	  // tw strong / bold
	  function twTokenStrong(stream, state) {
	    var maybeEnd = false,
	    ch;
	    while (ch = stream.next()) {
	      if (ch == "'" && maybeEnd) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      maybeEnd = (ch == "'");
	    }
	    return "strong";
	  }
	
	  // tw code
	  function twTokenCode(stream, state) {
	    var sb = state.block;
	
	    if (sb && stream.current()) {
	      return "comment";
	    }
	
	    if (!sb && stream.match(reUntilCodeStop)) {
	      state.tokenize = tokenBase;
	      return "comment";
	    }
	
	    if (sb && stream.sol() && stream.match(reCodeBlockStop)) {
	      state.tokenize = tokenBase;
	      return "comment";
	    }
	
	    stream.next();
	    return "comment";
	  }
	
	  // tw em / italic
	  function twTokenEm(stream, state) {
	    var maybeEnd = false,
	    ch;
	    while (ch = stream.next()) {
	      if (ch == "/" && maybeEnd) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      maybeEnd = (ch == "/");
	    }
	    return "em";
	  }
	
	  // tw underlined text
	  function twTokenUnderline(stream, state) {
	    var maybeEnd = false,
	    ch;
	    while (ch = stream.next()) {
	      if (ch == "_" && maybeEnd) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      maybeEnd = (ch == "_");
	    }
	    return "underlined";
	  }
	
	  // tw strike through text looks ugly
	  // change CSS if needed
	  function twTokenStrike(stream, state) {
	    var maybeEnd = false, ch;
	
	    while (ch = stream.next()) {
	      if (ch == "-" && maybeEnd) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      maybeEnd = (ch == "-");
	    }
	    return "strikethrough";
	  }
	
	  // macro
	  function twTokenMacro(stream, state) {
	    if (stream.current() == '<<') {
	      return 'macro';
	    }
	
	    var ch = stream.next();
	    if (!ch) {
	      state.tokenize = tokenBase;
	      return null;
	    }
	    if (ch == ">") {
	      if (stream.peek() == '>') {
	        stream.next();
	        state.tokenize = tokenBase;
	        return "macro";
	      }
	    }
	
	    stream.eatWhile(/[\w\$_]/);
	    return keywords.propertyIsEnumerable(stream.current()) ? "keyword" : null
	  }
	
	  // Interface
	  return {
	    startState: function () {
	      return {tokenize: tokenBase};
	    },
	
	    token: function (stream, state) {
	      if (stream.eatSpace()) return null;
	      var style = state.tokenize(stream, state);
	      return style;
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/x-tiddlywiki", "tiddlywiki");
	});


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode('tiki', function(config) {
	  function inBlock(style, terminator, returnTokenizer) {
	    return function(stream, state) {
	      while (!stream.eol()) {
	        if (stream.match(terminator)) {
	          state.tokenize = inText;
	          break;
	        }
	        stream.next();
	      }
	
	      if (returnTokenizer) state.tokenize = returnTokenizer;
	
	      return style;
	    };
	  }
	
	  function inLine(style) {
	    return function(stream, state) {
	      while(!stream.eol()) {
	        stream.next();
	      }
	      state.tokenize = inText;
	      return style;
	    };
	  }
	
	  function inText(stream, state) {
	    function chain(parser) {
	      state.tokenize = parser;
	      return parser(stream, state);
	    }
	
	    var sol = stream.sol();
	    var ch = stream.next();
	
	    //non start of line
	    switch (ch) { //switch is generally much faster than if, so it is used here
	    case "{": //plugin
	      stream.eat("/");
	      stream.eatSpace();
	      stream.eatWhile(/[^\s\u00a0=\"\'\/?(}]/);
	      state.tokenize = inPlugin;
	      return "tag";
	    case "_": //bold
	      if (stream.eat("_"))
	        return chain(inBlock("strong", "__", inText));
	      break;
	    case "'": //italics
	      if (stream.eat("'"))
	        return chain(inBlock("em", "''", inText));
	      break;
	    case "(":// Wiki Link
	      if (stream.eat("("))
	        return chain(inBlock("variable-2", "))", inText));
	      break;
	    case "[":// Weblink
	      return chain(inBlock("variable-3", "]", inText));
	      break;
	    case "|": //table
	      if (stream.eat("|"))
	        return chain(inBlock("comment", "||"));
	      break;
	    case "-":
	      if (stream.eat("=")) {//titleBar
	        return chain(inBlock("header string", "=-", inText));
	      } else if (stream.eat("-")) {//deleted
	        return chain(inBlock("error tw-deleted", "--", inText));
	      }
	      break;
	    case "=": //underline
	      if (stream.match("=="))
	        return chain(inBlock("tw-underline", "===", inText));
	      break;
	    case ":":
	      if (stream.eat(":"))
	        return chain(inBlock("comment", "::"));
	      break;
	    case "^": //box
	      return chain(inBlock("tw-box", "^"));
	      break;
	    case "~": //np
	      if (stream.match("np~"))
	        return chain(inBlock("meta", "~/np~"));
	      break;
	    }
	
	    //start of line types
	    if (sol) {
	      switch (ch) {
	      case "!": //header at start of line
	        if (stream.match('!!!!!')) {
	          return chain(inLine("header string"));
	        } else if (stream.match('!!!!')) {
	          return chain(inLine("header string"));
	        } else if (stream.match('!!!')) {
	          return chain(inLine("header string"));
	        } else if (stream.match('!!')) {
	          return chain(inLine("header string"));
	        } else {
	          return chain(inLine("header string"));
	        }
	        break;
	      case "*": //unordered list line item, or <li /> at start of line
	      case "#": //ordered list line item, or <li /> at start of line
	      case "+": //ordered list line item, or <li /> at start of line
	        return chain(inLine("tw-listitem bracket"));
	        break;
	      }
	    }
	
	    //stream.eatWhile(/[&{]/); was eating up plugins, turned off to act less like html and more like tiki
	    return null;
	  }
	
	  var indentUnit = config.indentUnit;
	
	  // Return variables for tokenizers
	  var pluginName, type;
	  function inPlugin(stream, state) {
	    var ch = stream.next();
	    var peek = stream.peek();
	
	    if (ch == "}") {
	      state.tokenize = inText;
	      //type = ch == ")" ? "endPlugin" : "selfclosePlugin"; inPlugin
	      return "tag";
	    } else if (ch == "(" || ch == ")") {
	      return "bracket";
	    } else if (ch == "=") {
	      type = "equals";
	
	      if (peek == ">") {
	        ch = stream.next();
	        peek = stream.peek();
	      }
	
	      //here we detect values directly after equal character with no quotes
	      if (!/[\'\"]/.test(peek)) {
	        state.tokenize = inAttributeNoQuote();
	      }
	      //end detect values
	
	      return "operator";
	    } else if (/[\'\"]/.test(ch)) {
	      state.tokenize = inAttribute(ch);
	      return state.tokenize(stream, state);
	    } else {
	      stream.eatWhile(/[^\s\u00a0=\"\'\/?]/);
	      return "keyword";
	    }
	  }
	
	  function inAttribute(quote) {
	    return function(stream, state) {
	      while (!stream.eol()) {
	        if (stream.next() == quote) {
	          state.tokenize = inPlugin;
	          break;
	        }
	      }
	      return "string";
	    };
	  }
	
	  function inAttributeNoQuote() {
	    return function(stream, state) {
	      while (!stream.eol()) {
	        var ch = stream.next();
	        var peek = stream.peek();
	        if (ch == " " || ch == "," || /[ )}]/.test(peek)) {
	      state.tokenize = inPlugin;
	      break;
	    }
	  }
	  return "string";
	};
	                     }
	
	var curState, setStyle;
	function pass() {
	  for (var i = arguments.length - 1; i >= 0; i--) curState.cc.push(arguments[i]);
	}
	
	function cont() {
	  pass.apply(null, arguments);
	  return true;
	}
	
	function pushContext(pluginName, startOfLine) {
	  var noIndent = curState.context && curState.context.noIndent;
	  curState.context = {
	    prev: curState.context,
	    pluginName: pluginName,
	    indent: curState.indented,
	    startOfLine: startOfLine,
	    noIndent: noIndent
	  };
	}
	
	function popContext() {
	  if (curState.context) curState.context = curState.context.prev;
	}
	
	function element(type) {
	  if (type == "openPlugin") {curState.pluginName = pluginName; return cont(attributes, endplugin(curState.startOfLine));}
	  else if (type == "closePlugin") {
	    var err = false;
	    if (curState.context) {
	      err = curState.context.pluginName != pluginName;
	      popContext();
	    } else {
	      err = true;
	    }
	    if (err) setStyle = "error";
	    return cont(endcloseplugin(err));
	  }
	  else if (type == "string") {
	    if (!curState.context || curState.context.name != "!cdata") pushContext("!cdata");
	    if (curState.tokenize == inText) popContext();
	    return cont();
	  }
	  else return cont();
	}
	
	function endplugin(startOfLine) {
	  return function(type) {
	    if (
	      type == "selfclosePlugin" ||
	        type == "endPlugin"
	    )
	      return cont();
	    if (type == "endPlugin") {pushContext(curState.pluginName, startOfLine); return cont();}
	    return cont();
	  };
	}
	
	function endcloseplugin(err) {
	  return function(type) {
	    if (err) setStyle = "error";
	    if (type == "endPlugin") return cont();
	    return pass();
	  };
	}
	
	function attributes(type) {
	  if (type == "keyword") {setStyle = "attribute"; return cont(attributes);}
	  if (type == "equals") return cont(attvalue, attributes);
	  return pass();
	}
	function attvalue(type) {
	  if (type == "keyword") {setStyle = "string"; return cont();}
	  if (type == "string") return cont(attvaluemaybe);
	  return pass();
	}
	function attvaluemaybe(type) {
	  if (type == "string") return cont(attvaluemaybe);
	  else return pass();
	}
	return {
	  startState: function() {
	    return {tokenize: inText, cc: [], indented: 0, startOfLine: true, pluginName: null, context: null};
	  },
	  token: function(stream, state) {
	    if (stream.sol()) {
	      state.startOfLine = true;
	      state.indented = stream.indentation();
	    }
	    if (stream.eatSpace()) return null;
	
	    setStyle = type = pluginName = null;
	    var style = state.tokenize(stream, state);
	    if ((style || type) && style != "comment") {
	      curState = state;
	      while (true) {
	        var comb = state.cc.pop() || element;
	        if (comb(type || style)) break;
	      }
	    }
	    state.startOfLine = false;
	    return setStyle || style;
	  },
	  indent: function(state, textAfter) {
	    var context = state.context;
	    if (context && context.noIndent) return 0;
	    if (context && /^{\//.test(textAfter))
	        context = context.prev;
	        while (context && !context.startOfLine)
	          context = context.prev;
	        if (context) return context.indent + indentUnit;
	        else return 0;
	       },
	    electricChars: "/"
	  };
	});
	
	CodeMirror.defineMIME("text/tiki", "tiki");
	
	});


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("toml", function () {
	  return {
	    startState: function () {
	      return {
	        inString: false,
	        stringType: "",
	        lhs: true,
	        inArray: 0
	      };
	    },
	    token: function (stream, state) {
	      //check for state changes
	      if (!state.inString && ((stream.peek() == '"') || (stream.peek() == "'"))) {
	        state.stringType = stream.peek();
	        stream.next(); // Skip quote
	        state.inString = true; // Update state
	      }
	      if (stream.sol() && state.inArray === 0) {
	        state.lhs = true;
	      }
	      //return state
	      if (state.inString) {
	        while (state.inString && !stream.eol()) {
	          if (stream.peek() === state.stringType) {
	            stream.next(); // Skip quote
	            state.inString = false; // Clear flag
	          } else if (stream.peek() === '\\') {
	            stream.next();
	            stream.next();
	          } else {
	            stream.match(/^.[^\\\"\']*/);
	          }
	        }
	        return state.lhs ? "property string" : "string"; // Token style
	      } else if (state.inArray && stream.peek() === ']') {
	        stream.next();
	        state.inArray--;
	        return 'bracket';
	      } else if (state.lhs && stream.peek() === '[' && stream.skipTo(']')) {
	        stream.next();//skip closing ]
	        // array of objects has an extra open & close []
	        if (stream.peek() === ']') stream.next();
	        return "atom";
	      } else if (stream.peek() === "#") {
	        stream.skipToEnd();
	        return "comment";
	      } else if (stream.eatSpace()) {
	        return null;
	      } else if (state.lhs && stream.eatWhile(function (c) { return c != '=' && c != ' '; })) {
	        return "property";
	      } else if (state.lhs && stream.peek() === "=") {
	        stream.next();
	        state.lhs = false;
	        return null;
	      } else if (!state.lhs && stream.match(/^\d\d\d\d[\d\-\:\.T]*Z/)) {
	        return 'atom'; //date
	      } else if (!state.lhs && (stream.match('true') || stream.match('false'))) {
	        return 'atom';
	      } else if (!state.lhs && stream.peek() === '[') {
	        state.inArray++;
	        stream.next();
	        return 'bracket';
	      } else if (!state.lhs && stream.match(/^\-?\d+(?:\.\d+)?/)) {
	        return 'number';
	      } else if (!stream.eatSpace()) {
	        stream.next();
	      }
	      return null;
	    }
	  };
	});
	
	CodeMirror.defineMIME('text/x-toml', 'toml');
	
	});


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(5),
	        __webpack_require__(19));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../htmlmixed/htmlmixed",
	            "../../addon/mode/overlay"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("tornado:inner", function() {
	    var keywords = ["and","as","assert","autoescape","block","break","class","comment","context",
	                    "continue","datetime","def","del","elif","else","end","escape","except",
	                    "exec","extends","false","finally","for","from","global","if","import","in",
	                    "include","is","json_encode","lambda","length","linkify","load","module",
	                    "none","not","or","pass","print","put","raise","raw","return","self","set",
	                    "squeeze","super","true","try","url_escape","while","with","without","xhtml_escape","yield"];
	    keywords = new RegExp("^((" + keywords.join(")|(") + "))\\b");
	
	    function tokenBase (stream, state) {
	      stream.eatWhile(/[^\{]/);
	      var ch = stream.next();
	      if (ch == "{") {
	        if (ch = stream.eat(/\{|%|#/)) {
	          state.tokenize = inTag(ch);
	          return "tag";
	        }
	      }
	    }
	    function inTag (close) {
	      if (close == "{") {
	        close = "}";
	      }
	      return function (stream, state) {
	        var ch = stream.next();
	        if ((ch == close) && stream.eat("}")) {
	          state.tokenize = tokenBase;
	          return "tag";
	        }
	        if (stream.match(keywords)) {
	          return "keyword";
	        }
	        return close == "#" ? "comment" : "string";
	      };
	    }
	    return {
	      startState: function () {
	        return {tokenize: tokenBase};
	      },
	      token: function (stream, state) {
	        return state.tokenize(stream, state);
	      }
	    };
	  });
	
	  CodeMirror.defineMode("tornado", function(config) {
	    var htmlBase = CodeMirror.getMode(config, "text/html");
	    var tornadoInner = CodeMirror.getMode(config, "tornado:inner");
	    return CodeMirror.overlayMode(htmlBase, tornadoInner);
	  });
	
	  CodeMirror.defineMIME("text/x-tornado", "tornado");
	});


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true)
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd)
	    define(["../../lib/codemirror"], mod);
	  else
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode('troff', function() {
	
	  var words = {};
	
	  function tokenBase(stream) {
	    if (stream.eatSpace()) return null;
	
	    var sol = stream.sol();
	    var ch = stream.next();
	
	    if (ch === '\\') {
	      if (stream.match('fB') || stream.match('fR') || stream.match('fI') ||
	          stream.match('u')  || stream.match('d')  ||
	          stream.match('%')  || stream.match('&')) {
	        return 'string';
	      }
	      if (stream.match('m[')) {
	        stream.skipTo(']');
	        stream.next();
	        return 'string';
	      }
	      if (stream.match('s+') || stream.match('s-')) {
	        stream.eatWhile(/[\d-]/);
	        return 'string';
	      }
	      if (stream.match('\(') || stream.match('*\(')) {
	        stream.eatWhile(/[\w-]/);
	        return 'string';
	      }
	      return 'string';
	    }
	    if (sol && (ch === '.' || ch === '\'')) {
	      if (stream.eat('\\') && stream.eat('\"')) {
	        stream.skipToEnd();
	        return 'comment';
	      }
	    }
	    if (sol && ch === '.') {
	      if (stream.match('B ') || stream.match('I ') || stream.match('R ')) {
	        return 'attribute';
	      }
	      if (stream.match('TH ') || stream.match('SH ') || stream.match('SS ') || stream.match('HP ')) {
	        stream.skipToEnd();
	        return 'quote';
	      }
	      if ((stream.match(/[A-Z]/) && stream.match(/[A-Z]/)) || (stream.match(/[a-z]/) && stream.match(/[a-z]/))) {
	        return 'attribute';
	      }
	    }
	    stream.eatWhile(/[\w-]/);
	    var cur = stream.current();
	    return words.hasOwnProperty(cur) ? words[cur] : null;
	  }
	
	  function tokenize(stream, state) {
	    return (state.tokens[0] || tokenBase) (stream, state);
	  };
	
	  return {
	    startState: function() {return {tokens:[]};},
	    token: function(stream, state) {
	      return tokenize(stream, state);
	    }
	  };
	});
	
	CodeMirror.defineMIME('text/troff', 'troff');
	CodeMirror.defineMIME('text/x-troff', 'troff');
	CodeMirror.defineMIME('application/x-troff', 'troff');
	
	});


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("ttcn-cfg", function(config, parserConfig) {
	    var indentUnit = config.indentUnit,
	        keywords = parserConfig.keywords || {},
	        fileNCtrlMaskOptions = parserConfig.fileNCtrlMaskOptions || {},
	        externalCommands = parserConfig.externalCommands || {},
	        multiLineStrings = parserConfig.multiLineStrings,
	        indentStatements = parserConfig.indentStatements !== false;
	    var isOperatorChar = /[\|]/;
	    var curPunc;
	
	    function tokenBase(stream, state) {
	      var ch = stream.next();
	      if (ch == '"' || ch == "'") {
	        state.tokenize = tokenString(ch);
	        return state.tokenize(stream, state);
	      }
	      if (/[:=]/.test(ch)) {
	        curPunc = ch;
	        return "punctuation";
	      }
	      if (ch == "#"){
	        stream.skipToEnd();
	        return "comment";
	      }
	      if (/\d/.test(ch)) {
	        stream.eatWhile(/[\w\.]/);
	        return "number";
	      }
	      if (isOperatorChar.test(ch)) {
	        stream.eatWhile(isOperatorChar);
	        return "operator";
	      }
	      if (ch == "["){
	        stream.eatWhile(/[\w_\]]/);
	        return "number sectionTitle";
	      }
	
	      stream.eatWhile(/[\w\$_]/);
	      var cur = stream.current();
	      if (keywords.propertyIsEnumerable(cur)) return "keyword";
	      if (fileNCtrlMaskOptions.propertyIsEnumerable(cur))
	        return "negative fileNCtrlMaskOptions";
	      if (externalCommands.propertyIsEnumerable(cur)) return "negative externalCommands";
	
	      return "variable";
	    }
	
	    function tokenString(quote) {
	      return function(stream, state) {
	        var escaped = false, next, end = false;
	        while ((next = stream.next()) != null) {
	          if (next == quote && !escaped){
	            var afterNext = stream.peek();
	            //look if the character if the quote is like the B in '10100010'B
	            if (afterNext){
	              afterNext = afterNext.toLowerCase();
	              if(afterNext == "b" || afterNext == "h" || afterNext == "o")
	                stream.next();
	            }
	            end = true; break;
	          }
	          escaped = !escaped && next == "\\";
	        }
	        if (end || !(escaped || multiLineStrings))
	          state.tokenize = null;
	        return "string";
	      };
	    }
	
	    function Context(indented, column, type, align, prev) {
	      this.indented = indented;
	      this.column = column;
	      this.type = type;
	      this.align = align;
	      this.prev = prev;
	    }
	    function pushContext(state, col, type) {
	      var indent = state.indented;
	      if (state.context && state.context.type == "statement")
	        indent = state.context.indented;
	      return state.context = new Context(indent, col, type, null, state.context);
	    }
	    function popContext(state) {
	      var t = state.context.type;
	      if (t == ")" || t == "]" || t == "}")
	        state.indented = state.context.indented;
	      return state.context = state.context.prev;
	    }
	
	    //Interface
	    return {
	      startState: function(basecolumn) {
	        return {
	          tokenize: null,
	          context: new Context((basecolumn || 0) - indentUnit, 0, "top", false),
	          indented: 0,
	          startOfLine: true
	        };
	      },
	
	      token: function(stream, state) {
	        var ctx = state.context;
	        if (stream.sol()) {
	          if (ctx.align == null) ctx.align = false;
	          state.indented = stream.indentation();
	          state.startOfLine = true;
	        }
	        if (stream.eatSpace()) return null;
	        curPunc = null;
	        var style = (state.tokenize || tokenBase)(stream, state);
	        if (style == "comment") return style;
	        if (ctx.align == null) ctx.align = true;
	
	        if ((curPunc == ";" || curPunc == ":" || curPunc == ",")
	            && ctx.type == "statement"){
	          popContext(state);
	        }
	        else if (curPunc == "{") pushContext(state, stream.column(), "}");
	        else if (curPunc == "[") pushContext(state, stream.column(), "]");
	        else if (curPunc == "(") pushContext(state, stream.column(), ")");
	        else if (curPunc == "}") {
	          while (ctx.type == "statement") ctx = popContext(state);
	          if (ctx.type == "}") ctx = popContext(state);
	          while (ctx.type == "statement") ctx = popContext(state);
	        }
	        else if (curPunc == ctx.type) popContext(state);
	        else if (indentStatements && (((ctx.type == "}" || ctx.type == "top")
	            && curPunc != ';') || (ctx.type == "statement"
	            && curPunc == "newstatement")))
	          pushContext(state, stream.column(), "statement");
	        state.startOfLine = false;
	        return style;
	      },
	
	      electricChars: "{}",
	      lineComment: "#",
	      fold: "brace"
	    };
	  });
	
	  function words(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i)
	      obj[words[i]] = true;
	    return obj;
	  }
	
	  CodeMirror.defineMIME("text/x-ttcn-cfg", {
	    name: "ttcn-cfg",
	    keywords: words("Yes No LogFile FileMask ConsoleMask AppendFile" +
	    " TimeStampFormat LogEventTypes SourceInfoFormat" +
	    " LogEntityName LogSourceInfo DiskFullAction" +
	    " LogFileNumber LogFileSize MatchingHints Detailed" +
	    " Compact SubCategories Stack Single None Seconds" +
	    " DateTime Time Stop Error Retry Delete TCPPort KillTimer" +
	    " NumHCs UnixSocketsEnabled LocalAddress"),
	    fileNCtrlMaskOptions: words("TTCN_EXECUTOR TTCN_ERROR TTCN_WARNING" +
	    " TTCN_PORTEVENT TTCN_TIMEROP TTCN_VERDICTOP" +
	    " TTCN_DEFAULTOP TTCN_TESTCASE TTCN_ACTION" +
	    " TTCN_USER TTCN_FUNCTION TTCN_STATISTICS" +
	    " TTCN_PARALLEL TTCN_MATCHING TTCN_DEBUG" +
	    " EXECUTOR ERROR WARNING PORTEVENT TIMEROP" +
	    " VERDICTOP DEFAULTOP TESTCASE ACTION USER" +
	    " FUNCTION STATISTICS PARALLEL MATCHING DEBUG" +
	    " LOG_ALL LOG_NOTHING ACTION_UNQUALIFIED" +
	    " DEBUG_ENCDEC DEBUG_TESTPORT" +
	    " DEBUG_UNQUALIFIED DEFAULTOP_ACTIVATE" +
	    " DEFAULTOP_DEACTIVATE DEFAULTOP_EXIT" +
	    " DEFAULTOP_UNQUALIFIED ERROR_UNQUALIFIED" +
	    " EXECUTOR_COMPONENT EXECUTOR_CONFIGDATA" +
	    " EXECUTOR_EXTCOMMAND EXECUTOR_LOGOPTIONS" +
	    " EXECUTOR_RUNTIME EXECUTOR_UNQUALIFIED" +
	    " FUNCTION_RND FUNCTION_UNQUALIFIED" +
	    " MATCHING_DONE MATCHING_MCSUCCESS" +
	    " MATCHING_MCUNSUCC MATCHING_MMSUCCESS" +
	    " MATCHING_MMUNSUCC MATCHING_PCSUCCESS" +
	    " MATCHING_PCUNSUCC MATCHING_PMSUCCESS" +
	    " MATCHING_PMUNSUCC MATCHING_PROBLEM" +
	    " MATCHING_TIMEOUT MATCHING_UNQUALIFIED" +
	    " PARALLEL_PORTCONN PARALLEL_PORTMAP" +
	    " PARALLEL_PTC PARALLEL_UNQUALIFIED" +
	    " PORTEVENT_DUALRECV PORTEVENT_DUALSEND" +
	    " PORTEVENT_MCRECV PORTEVENT_MCSEND" +
	    " PORTEVENT_MMRECV PORTEVENT_MMSEND" +
	    " PORTEVENT_MQUEUE PORTEVENT_PCIN" +
	    " PORTEVENT_PCOUT PORTEVENT_PMIN" +
	    " PORTEVENT_PMOUT PORTEVENT_PQUEUE" +
	    " PORTEVENT_STATE PORTEVENT_UNQUALIFIED" +
	    " STATISTICS_UNQUALIFIED STATISTICS_VERDICT" +
	    " TESTCASE_FINISH TESTCASE_START" +
	    " TESTCASE_UNQUALIFIED TIMEROP_GUARD" +
	    " TIMEROP_READ TIMEROP_START TIMEROP_STOP" +
	    " TIMEROP_TIMEOUT TIMEROP_UNQUALIFIED" +
	    " USER_UNQUALIFIED VERDICTOP_FINAL" +
	    " VERDICTOP_GETVERDICT VERDICTOP_SETVERDICT" +
	    " VERDICTOP_UNQUALIFIED WARNING_UNQUALIFIED"),
	    externalCommands: words("BeginControlPart EndControlPart BeginTestCase" +
	    " EndTestCase"),
	    multiLineStrings: true
	  });
	});

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("ttcn", function(config, parserConfig) {
	    var indentUnit = config.indentUnit,
	        keywords = parserConfig.keywords || {},
	        builtin = parserConfig.builtin || {},
	        timerOps = parserConfig.timerOps || {},
	        portOps  = parserConfig.portOps || {},
	        configOps = parserConfig.configOps || {},
	        verdictOps = parserConfig.verdictOps || {},
	        sutOps = parserConfig.sutOps || {},
	        functionOps = parserConfig.functionOps || {},
	
	        verdictConsts = parserConfig.verdictConsts || {},
	        booleanConsts = parserConfig.booleanConsts || {},
	        otherConsts   = parserConfig.otherConsts || {},
	
	        types = parserConfig.types || {},
	        visibilityModifiers = parserConfig.visibilityModifiers || {},
	        templateMatch = parserConfig.templateMatch || {},
	        multiLineStrings = parserConfig.multiLineStrings,
	        indentStatements = parserConfig.indentStatements !== false;
	    var isOperatorChar = /[+\-*&@=<>!\/]/;
	    var curPunc;
	
	    function tokenBase(stream, state) {
	      var ch = stream.next();
	
	      if (ch == '"' || ch == "'") {
	        state.tokenize = tokenString(ch);
	        return state.tokenize(stream, state);
	      }
	      if (/[\[\]{}\(\),;\\:\?\.]/.test(ch)) {
	        curPunc = ch;
	        return "punctuation";
	      }
	      if (ch == "#"){
	        stream.skipToEnd();
	        return "atom preprocessor";
	      }
	      if (ch == "%"){
	        stream.eatWhile(/\b/);
	        return "atom ttcn3Macros";
	      }
	      if (/\d/.test(ch)) {
	        stream.eatWhile(/[\w\.]/);
	        return "number";
	      }
	      if (ch == "/") {
	        if (stream.eat("*")) {
	          state.tokenize = tokenComment;
	          return tokenComment(stream, state);
	        }
	        if (stream.eat("/")) {
	          stream.skipToEnd();
	          return "comment";
	        }
	      }
	      if (isOperatorChar.test(ch)) {
	        if(ch == "@"){
	          if(stream.match("try") || stream.match("catch")
	              || stream.match("lazy")){
	            return "keyword";
	          }
	        }
	        stream.eatWhile(isOperatorChar);
	        return "operator";
	      }
	      stream.eatWhile(/[\w\$_\xa1-\uffff]/);
	      var cur = stream.current();
	
	      if (keywords.propertyIsEnumerable(cur)) return "keyword";
	      if (builtin.propertyIsEnumerable(cur)) return "builtin";
	
	      if (timerOps.propertyIsEnumerable(cur)) return "def timerOps";
	      if (configOps.propertyIsEnumerable(cur)) return "def configOps";
	      if (verdictOps.propertyIsEnumerable(cur)) return "def verdictOps";
	      if (portOps.propertyIsEnumerable(cur)) return "def portOps";
	      if (sutOps.propertyIsEnumerable(cur)) return "def sutOps";
	      if (functionOps.propertyIsEnumerable(cur)) return "def functionOps";
	
	      if (verdictConsts.propertyIsEnumerable(cur)) return "string verdictConsts";
	      if (booleanConsts.propertyIsEnumerable(cur)) return "string booleanConsts";
	      if (otherConsts.propertyIsEnumerable(cur)) return "string otherConsts";
	
	      if (types.propertyIsEnumerable(cur)) return "builtin types";
	      if (visibilityModifiers.propertyIsEnumerable(cur))
	        return "builtin visibilityModifiers";
	      if (templateMatch.propertyIsEnumerable(cur)) return "atom templateMatch";
	
	      return "variable";
	    }
	
	    function tokenString(quote) {
	      return function(stream, state) {
	        var escaped = false, next, end = false;
	        while ((next = stream.next()) != null) {
	          if (next == quote && !escaped){
	            var afterQuote = stream.peek();
	            //look if the character after the quote is like the B in '10100010'B
	            if (afterQuote){
	              afterQuote = afterQuote.toLowerCase();
	              if(afterQuote == "b" || afterQuote == "h" || afterQuote == "o")
	                stream.next();
	            }
	            end = true; break;
	          }
	          escaped = !escaped && next == "\\";
	        }
	        if (end || !(escaped || multiLineStrings))
	          state.tokenize = null;
	        return "string";
	      };
	    }
	
	    function tokenComment(stream, state) {
	      var maybeEnd = false, ch;
	      while (ch = stream.next()) {
	        if (ch == "/" && maybeEnd) {
	          state.tokenize = null;
	          break;
	        }
	        maybeEnd = (ch == "*");
	      }
	      return "comment";
	    }
	
	    function Context(indented, column, type, align, prev) {
	      this.indented = indented;
	      this.column = column;
	      this.type = type;
	      this.align = align;
	      this.prev = prev;
	    }
	
	    function pushContext(state, col, type) {
	      var indent = state.indented;
	      if (state.context && state.context.type == "statement")
	        indent = state.context.indented;
	      return state.context = new Context(indent, col, type, null, state.context);
	    }
	
	    function popContext(state) {
	      var t = state.context.type;
	      if (t == ")" || t == "]" || t == "}")
	        state.indented = state.context.indented;
	      return state.context = state.context.prev;
	    }
	
	    //Interface
	    return {
	      startState: function(basecolumn) {
	        return {
	          tokenize: null,
	          context: new Context((basecolumn || 0) - indentUnit, 0, "top", false),
	          indented: 0,
	          startOfLine: true
	        };
	      },
	
	      token: function(stream, state) {
	        var ctx = state.context;
	        if (stream.sol()) {
	          if (ctx.align == null) ctx.align = false;
	          state.indented = stream.indentation();
	          state.startOfLine = true;
	        }
	        if (stream.eatSpace()) return null;
	        curPunc = null;
	        var style = (state.tokenize || tokenBase)(stream, state);
	        if (style == "comment") return style;
	        if (ctx.align == null) ctx.align = true;
	
	        if ((curPunc == ";" || curPunc == ":" || curPunc == ",")
	            && ctx.type == "statement"){
	          popContext(state);
	        }
	        else if (curPunc == "{") pushContext(state, stream.column(), "}");
	        else if (curPunc == "[") pushContext(state, stream.column(), "]");
	        else if (curPunc == "(") pushContext(state, stream.column(), ")");
	        else if (curPunc == "}") {
	          while (ctx.type == "statement") ctx = popContext(state);
	          if (ctx.type == "}") ctx = popContext(state);
	          while (ctx.type == "statement") ctx = popContext(state);
	        }
	        else if (curPunc == ctx.type) popContext(state);
	        else if (indentStatements &&
	            (((ctx.type == "}" || ctx.type == "top") && curPunc != ';') ||
	            (ctx.type == "statement" && curPunc == "newstatement")))
	          pushContext(state, stream.column(), "statement");
	
	        state.startOfLine = false;
	
	        return style;
	      },
	
	      electricChars: "{}",
	      blockCommentStart: "/*",
	      blockCommentEnd: "*/",
	      lineComment: "//",
	      fold: "brace"
	    };
	  });
	
	  function words(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	
	  function def(mimes, mode) {
	    if (typeof mimes == "string") mimes = [mimes];
	    var words = [];
	    function add(obj) {
	      if (obj) for (var prop in obj) if (obj.hasOwnProperty(prop))
	        words.push(prop);
	    }
	
	    add(mode.keywords);
	    add(mode.builtin);
	    add(mode.timerOps);
	    add(mode.portOps);
	
	    if (words.length) {
	      mode.helperType = mimes[0];
	      CodeMirror.registerHelper("hintWords", mimes[0], words);
	    }
	
	    for (var i = 0; i < mimes.length; ++i)
	      CodeMirror.defineMIME(mimes[i], mode);
	  }
	
	  def(["text/x-ttcn", "text/x-ttcn3", "text/x-ttcnpp"], {
	    name: "ttcn",
	    keywords: words("activate address alive all alt altstep and and4b any" +
	    " break case component const continue control deactivate" +
	    " display do else encode enumerated except exception" +
	    " execute extends extension external for from function" +
	    " goto group if import in infinity inout interleave" +
	    " label language length log match message mixed mod" +
	    " modifies module modulepar mtc noblock not not4b nowait" +
	    " of on optional or or4b out override param pattern port" +
	    " procedure record recursive rem repeat return runs select" +
	    " self sender set signature system template testcase to" +
	    " type union value valueof var variant while with xor xor4b"),
	    builtin: words("bit2hex bit2int bit2oct bit2str char2int char2oct encvalue" +
	    " decomp decvalue float2int float2str hex2bit hex2int" +
	    " hex2oct hex2str int2bit int2char int2float int2hex" +
	    " int2oct int2str int2unichar isbound ischosen ispresent" +
	    " isvalue lengthof log2str oct2bit oct2char oct2hex oct2int" +
	    " oct2str regexp replace rnd sizeof str2bit str2float" +
	    " str2hex str2int str2oct substr unichar2int unichar2char" +
	    " enum2int"),
	    types: words("anytype bitstring boolean char charstring default float" +
	    " hexstring integer objid octetstring universal verdicttype timer"),
	    timerOps: words("read running start stop timeout"),
	    portOps: words("call catch check clear getcall getreply halt raise receive" +
	    " reply send trigger"),
	    configOps: words("create connect disconnect done kill killed map unmap"),
	    verdictOps: words("getverdict setverdict"),
	    sutOps: words("action"),
	    functionOps: words("apply derefers refers"),
	
	    verdictConsts: words("error fail inconc none pass"),
	    booleanConsts: words("true false"),
	    otherConsts: words("null NULL omit"),
	
	    visibilityModifiers: words("private public friend"),
	    templateMatch: words("complement ifpresent subset superset permutation"),
	    multiLineStrings: true
	  });
	});


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("turtle", function(config) {
	  var indentUnit = config.indentUnit;
	  var curPunc;
	
	  function wordRegexp(words) {
	    return new RegExp("^(?:" + words.join("|") + ")$", "i");
	  }
	  var ops = wordRegexp([]);
	  var keywords = wordRegexp(["@prefix", "@base", "a"]);
	  var operatorChars = /[*+\-<>=&|]/;
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    curPunc = null;
	    if (ch == "<" && !stream.match(/^[\s\u00a0=]/, false)) {
	      stream.match(/^[^\s\u00a0>]*>?/);
	      return "atom";
	    }
	    else if (ch == "\"" || ch == "'") {
	      state.tokenize = tokenLiteral(ch);
	      return state.tokenize(stream, state);
	    }
	    else if (/[{}\(\),\.;\[\]]/.test(ch)) {
	      curPunc = ch;
	      return null;
	    }
	    else if (ch == "#") {
	      stream.skipToEnd();
	      return "comment";
	    }
	    else if (operatorChars.test(ch)) {
	      stream.eatWhile(operatorChars);
	      return null;
	    }
	    else if (ch == ":") {
	          return "operator";
	        } else {
	      stream.eatWhile(/[_\w\d]/);
	      if(stream.peek() == ":") {
	        return "variable-3";
	      } else {
	             var word = stream.current();
	
	             if(keywords.test(word)) {
	                        return "meta";
	             }
	
	             if(ch >= "A" && ch <= "Z") {
	                    return "comment";
	                 } else {
	                        return "keyword";
	                 }
	      }
	      var word = stream.current();
	      if (ops.test(word))
	        return null;
	      else if (keywords.test(word))
	        return "meta";
	      else
	        return "variable";
	    }
	  }
	
	  function tokenLiteral(quote) {
	    return function(stream, state) {
	      var escaped = false, ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == quote && !escaped) {
	          state.tokenize = tokenBase;
	          break;
	        }
	        escaped = !escaped && ch == "\\";
	      }
	      return "string";
	    };
	  }
	
	  function pushContext(state, type, col) {
	    state.context = {prev: state.context, indent: state.indent, col: col, type: type};
	  }
	  function popContext(state) {
	    state.indent = state.context.indent;
	    state.context = state.context.prev;
	  }
	
	  return {
	    startState: function() {
	      return {tokenize: tokenBase,
	              context: null,
	              indent: 0,
	              col: 0};
	    },
	
	    token: function(stream, state) {
	      if (stream.sol()) {
	        if (state.context && state.context.align == null) state.context.align = false;
	        state.indent = stream.indentation();
	      }
	      if (stream.eatSpace()) return null;
	      var style = state.tokenize(stream, state);
	
	      if (style != "comment" && state.context && state.context.align == null && state.context.type != "pattern") {
	        state.context.align = true;
	      }
	
	      if (curPunc == "(") pushContext(state, ")", stream.column());
	      else if (curPunc == "[") pushContext(state, "]", stream.column());
	      else if (curPunc == "{") pushContext(state, "}", stream.column());
	      else if (/[\]\}\)]/.test(curPunc)) {
	        while (state.context && state.context.type == "pattern") popContext(state);
	        if (state.context && curPunc == state.context.type) popContext(state);
	      }
	      else if (curPunc == "." && state.context && state.context.type == "pattern") popContext(state);
	      else if (/atom|string|variable/.test(style) && state.context) {
	        if (/[\}\]]/.test(state.context.type))
	          pushContext(state, "pattern", stream.column());
	        else if (state.context.type == "pattern" && !state.context.align) {
	          state.context.align = true;
	          state.context.col = stream.column();
	        }
	      }
	
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      var firstChar = textAfter && textAfter.charAt(0);
	      var context = state.context;
	      if (/[\]\}]/.test(firstChar))
	        while (context && context.type == "pattern") context = context.prev;
	
	      var closing = context && firstChar == context.type;
	      if (!context)
	        return 0;
	      else if (context.type == "pattern")
	        return context.col;
	      else if (context.align)
	        return context.col + (closing ? 0 : 1);
	      else
	        return context.indent + (closing ? 0 : indentUnit);
	    },
	
	    lineComment: "#"
	  };
	});
	
	CodeMirror.defineMIME("text/turtle", "turtle");
	
	});


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2),  __webpack_require__(45));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../../addon/mode/multiplex"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("twig:inner", function() {
	    var keywords = ["and", "as", "autoescape", "endautoescape", "block", "do", "endblock", "else", "elseif", "extends", "for", "endfor", "embed", "endembed", "filter", "endfilter", "flush", "from", "if", "endif", "in", "is", "include", "import", "not", "or", "set", "spaceless", "endspaceless", "with", "endwith", "trans", "endtrans", "blocktrans", "endblocktrans", "macro", "endmacro", "use", "verbatim", "endverbatim"],
	        operator = /^[+\-*&%=<>!?|~^]/,
	        sign = /^[:\[\(\{]/,
	        atom = ["true", "false", "null", "empty", "defined", "divisibleby", "divisible by", "even", "odd", "iterable", "sameas", "same as"],
	        number = /^(\d[+\-\*\/])?\d+(\.\d+)?/;
	
	    keywords = new RegExp("((" + keywords.join(")|(") + "))\\b");
	    atom = new RegExp("((" + atom.join(")|(") + "))\\b");
	
	    function tokenBase (stream, state) {
	      var ch = stream.peek();
	
	      //Comment
	      if (state.incomment) {
	        if (!stream.skipTo("#}")) {
	          stream.skipToEnd();
	        } else {
	          stream.eatWhile(/\#|}/);
	          state.incomment = false;
	        }
	        return "comment";
	      //Tag
	      } else if (state.intag) {
	        //After operator
	        if (state.operator) {
	          state.operator = false;
	          if (stream.match(atom)) {
	            return "atom";
	          }
	          if (stream.match(number)) {
	            return "number";
	          }
	        }
	        //After sign
	        if (state.sign) {
	          state.sign = false;
	          if (stream.match(atom)) {
	            return "atom";
	          }
	          if (stream.match(number)) {
	            return "number";
	          }
	        }
	
	        if (state.instring) {
	          if (ch == state.instring) {
	            state.instring = false;
	          }
	          stream.next();
	          return "string";
	        } else if (ch == "'" || ch == '"') {
	          state.instring = ch;
	          stream.next();
	          return "string";
	        } else if (stream.match(state.intag + "}") || stream.eat("-") && stream.match(state.intag + "}")) {
	          state.intag = false;
	          return "tag";
	        } else if (stream.match(operator)) {
	          state.operator = true;
	          return "operator";
	        } else if (stream.match(sign)) {
	          state.sign = true;
	        } else {
	          if (stream.eat(" ") || stream.sol()) {
	            if (stream.match(keywords)) {
	              return "keyword";
	            }
	            if (stream.match(atom)) {
	              return "atom";
	            }
	            if (stream.match(number)) {
	              return "number";
	            }
	            if (stream.sol()) {
	              stream.next();
	            }
	          } else {
	            stream.next();
	          }
	
	        }
	        return "variable";
	      } else if (stream.eat("{")) {
	        if (ch = stream.eat("#")) {
	          state.incomment = true;
	          if (!stream.skipTo("#}")) {
	            stream.skipToEnd();
	          } else {
	            stream.eatWhile(/\#|}/);
	            state.incomment = false;
	          }
	          return "comment";
	        //Open tag
	        } else if (ch = stream.eat(/\{|%/)) {
	          //Cache close tag
	          state.intag = ch;
	          if (ch == "{") {
	            state.intag = "}";
	          }
	          stream.eat("-");
	          return "tag";
	        }
	      }
	      stream.next();
	    };
	
	    return {
	      startState: function () {
	        return {};
	      },
	      token: function (stream, state) {
	        return tokenBase(stream, state);
	      }
	    };
	  });
	
	  CodeMirror.defineMode("twig", function(config, parserConfig) {
	    var twigInner = CodeMirror.getMode(config, "twig:inner");
	    if (!parserConfig || !parserConfig.base) return twigInner;
	    return CodeMirror.multiplexingMode(
	      CodeMirror.getMode(config, parserConfig.base), {
	        open: /\{[{#%]/, close: /[}#%]\}/, mode: twigInner, parseDelimiters: true
	      }
	    );
	  });
	  CodeMirror.defineMIME("text/x-twig", "twig");
	});


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("vb", function(conf, parserConf) {
	    var ERRORCLASS = 'error';
	
	    function wordRegexp(words) {
	        return new RegExp("^((" + words.join(")|(") + "))\\b", "i");
	    }
	
	    var singleOperators = new RegExp("^[\\+\\-\\*/%&\\\\|\\^~<>!]");
	    var singleDelimiters = new RegExp('^[\\(\\)\\[\\]\\{\\}@,:`=;\\.]');
	    var doubleOperators = new RegExp("^((==)|(<>)|(<=)|(>=)|(<>)|(<<)|(>>)|(//)|(\\*\\*))");
	    var doubleDelimiters = new RegExp("^((\\+=)|(\\-=)|(\\*=)|(%=)|(/=)|(&=)|(\\|=)|(\\^=))");
	    var tripleDelimiters = new RegExp("^((//=)|(>>=)|(<<=)|(\\*\\*=))");
	    var identifiers = new RegExp("^[_A-Za-z][_A-Za-z0-9]*");
	
	    var openingKeywords = ['class','module', 'sub','enum','select','while','if','function',  'get','set','property', 'try'];
	    var middleKeywords = ['else','elseif','case', 'catch'];
	    var endKeywords = ['next','loop'];
	
	    var operatorKeywords = ['and', 'or', 'not', 'xor', 'in'];
	    var wordOperators = wordRegexp(operatorKeywords);
	    var commonKeywords = ['as', 'dim', 'break',  'continue','optional', 'then',  'until',
	                          'goto', 'byval','byref','new','handles','property', 'return',
	                          'const','private', 'protected', 'friend', 'public', 'shared', 'static', 'true','false'];
	    var commontypes = ['integer','string','double','decimal','boolean','short','char', 'float','single'];
	
	    var keywords = wordRegexp(commonKeywords);
	    var types = wordRegexp(commontypes);
	    var stringPrefixes = '"';
	
	    var opening = wordRegexp(openingKeywords);
	    var middle = wordRegexp(middleKeywords);
	    var closing = wordRegexp(endKeywords);
	    var doubleClosing = wordRegexp(['end']);
	    var doOpening = wordRegexp(['do']);
	
	    var indentInfo = null;
	
	    CodeMirror.registerHelper("hintWords", "vb", openingKeywords.concat(middleKeywords).concat(endKeywords)
	                                .concat(operatorKeywords).concat(commonKeywords).concat(commontypes));
	
	    function indent(_stream, state) {
	      state.currentIndent++;
	    }
	
	    function dedent(_stream, state) {
	      state.currentIndent--;
	    }
	    // tokenizers
	    function tokenBase(stream, state) {
	        if (stream.eatSpace()) {
	            return null;
	        }
	
	        var ch = stream.peek();
	
	        // Handle Comments
	        if (ch === "'") {
	            stream.skipToEnd();
	            return 'comment';
	        }
	
	
	        // Handle Number Literals
	        if (stream.match(/^((&H)|(&O))?[0-9\.a-f]/i, false)) {
	            var floatLiteral = false;
	            // Floats
	            if (stream.match(/^\d*\.\d+F?/i)) { floatLiteral = true; }
	            else if (stream.match(/^\d+\.\d*F?/)) { floatLiteral = true; }
	            else if (stream.match(/^\.\d+F?/)) { floatLiteral = true; }
	
	            if (floatLiteral) {
	                // Float literals may be "imaginary"
	                stream.eat(/J/i);
	                return 'number';
	            }
	            // Integers
	            var intLiteral = false;
	            // Hex
	            if (stream.match(/^&H[0-9a-f]+/i)) { intLiteral = true; }
	            // Octal
	            else if (stream.match(/^&O[0-7]+/i)) { intLiteral = true; }
	            // Decimal
	            else if (stream.match(/^[1-9]\d*F?/)) {
	                // Decimal literals may be "imaginary"
	                stream.eat(/J/i);
	                // TODO - Can you have imaginary longs?
	                intLiteral = true;
	            }
	            // Zero by itself with no other piece of number.
	            else if (stream.match(/^0(?![\dx])/i)) { intLiteral = true; }
	            if (intLiteral) {
	                // Integer literals may be "long"
	                stream.eat(/L/i);
	                return 'number';
	            }
	        }
	
	        // Handle Strings
	        if (stream.match(stringPrefixes)) {
	            state.tokenize = tokenStringFactory(stream.current());
	            return state.tokenize(stream, state);
	        }
	
	        // Handle operators and Delimiters
	        if (stream.match(tripleDelimiters) || stream.match(doubleDelimiters)) {
	            return null;
	        }
	        if (stream.match(doubleOperators)
	            || stream.match(singleOperators)
	            || stream.match(wordOperators)) {
	            return 'operator';
	        }
	        if (stream.match(singleDelimiters)) {
	            return null;
	        }
	        if (stream.match(doOpening)) {
	            indent(stream,state);
	            state.doInCurrentLine = true;
	            return 'keyword';
	        }
	        if (stream.match(opening)) {
	            if (! state.doInCurrentLine)
	              indent(stream,state);
	            else
	              state.doInCurrentLine = false;
	            return 'keyword';
	        }
	        if (stream.match(middle)) {
	            return 'keyword';
	        }
	
	        if (stream.match(doubleClosing)) {
	            dedent(stream,state);
	            dedent(stream,state);
	            return 'keyword';
	        }
	        if (stream.match(closing)) {
	            dedent(stream,state);
	            return 'keyword';
	        }
	
	        if (stream.match(types)) {
	            return 'keyword';
	        }
	
	        if (stream.match(keywords)) {
	            return 'keyword';
	        }
	
	        if (stream.match(identifiers)) {
	            return 'variable';
	        }
	
	        // Handle non-detected items
	        stream.next();
	        return ERRORCLASS;
	    }
	
	    function tokenStringFactory(delimiter) {
	        var singleline = delimiter.length == 1;
	        var OUTCLASS = 'string';
	
	        return function(stream, state) {
	            while (!stream.eol()) {
	                stream.eatWhile(/[^'"]/);
	                if (stream.match(delimiter)) {
	                    state.tokenize = tokenBase;
	                    return OUTCLASS;
	                } else {
	                    stream.eat(/['"]/);
	                }
	            }
	            if (singleline) {
	                if (parserConf.singleLineStringErrors) {
	                    return ERRORCLASS;
	                } else {
	                    state.tokenize = tokenBase;
	                }
	            }
	            return OUTCLASS;
	        };
	    }
	
	
	    function tokenLexer(stream, state) {
	        var style = state.tokenize(stream, state);
	        var current = stream.current();
	
	        // Handle '.' connected identifiers
	        if (current === '.') {
	            style = state.tokenize(stream, state);
	            current = stream.current();
	            if (style === 'variable') {
	                return 'variable';
	            } else {
	                return ERRORCLASS;
	            }
	        }
	
	
	        var delimiter_index = '[({'.indexOf(current);
	        if (delimiter_index !== -1) {
	            indent(stream, state );
	        }
	        if (indentInfo === 'dedent') {
	            if (dedent(stream, state)) {
	                return ERRORCLASS;
	            }
	        }
	        delimiter_index = '])}'.indexOf(current);
	        if (delimiter_index !== -1) {
	            if (dedent(stream, state)) {
	                return ERRORCLASS;
	            }
	        }
	
	        return style;
	    }
	
	    var external = {
	        electricChars:"dDpPtTfFeE ",
	        startState: function() {
	            return {
	              tokenize: tokenBase,
	              lastToken: null,
	              currentIndent: 0,
	              nextLineIndent: 0,
	              doInCurrentLine: false
	
	
	          };
	        },
	
	        token: function(stream, state) {
	            if (stream.sol()) {
	              state.currentIndent += state.nextLineIndent;
	              state.nextLineIndent = 0;
	              state.doInCurrentLine = 0;
	            }
	            var style = tokenLexer(stream, state);
	
	            state.lastToken = {style:style, content: stream.current()};
	
	
	
	            return style;
	        },
	
	        indent: function(state, textAfter) {
	            var trueText = textAfter.replace(/^\s+|\s+$/g, '') ;
	            if (trueText.match(closing) || trueText.match(doubleClosing) || trueText.match(middle)) return conf.indentUnit*(state.currentIndent-1);
	            if(state.currentIndent < 0) return 0;
	            return state.currentIndent * conf.indentUnit;
	        },
	
	        lineComment: "'"
	    };
	    return external;
	});
	
	CodeMirror.defineMIME("text/x-vb", "vb");
	
	});


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	/*
	For extra ASP classic objects, initialize CodeMirror instance with this option:
	    isASP: true
	
	E.G.:
	    var editor = CodeMirror.fromTextArea(document.getElementById("code"), {
	        lineNumbers: true,
	        isASP: true
	      });
	*/
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("vbscript", function(conf, parserConf) {
	    var ERRORCLASS = 'error';
	
	    function wordRegexp(words) {
	        return new RegExp("^((" + words.join(")|(") + "))\\b", "i");
	    }
	
	    var singleOperators = new RegExp("^[\\+\\-\\*/&\\\\\\^<>=]");
	    var doubleOperators = new RegExp("^((<>)|(<=)|(>=))");
	    var singleDelimiters = new RegExp('^[\\.,]');
	    var brakets = new RegExp('^[\\(\\)]');
	    var identifiers = new RegExp("^[A-Za-z][_A-Za-z0-9]*");
	
	    var openingKeywords = ['class','sub','select','while','if','function', 'property', 'with', 'for'];
	    var middleKeywords = ['else','elseif','case'];
	    var endKeywords = ['next','loop','wend'];
	
	    var wordOperators = wordRegexp(['and', 'or', 'not', 'xor', 'is', 'mod', 'eqv', 'imp']);
	    var commonkeywords = ['dim', 'redim', 'then',  'until', 'randomize',
	                          'byval','byref','new','property', 'exit', 'in',
	                          'const','private', 'public',
	                          'get','set','let', 'stop', 'on error resume next', 'on error goto 0', 'option explicit', 'call', 'me'];
	
	    //This list was from: http://msdn.microsoft.com/en-us/library/f8tbc79x(v=vs.84).aspx
	    var atomWords = ['true', 'false', 'nothing', 'empty', 'null'];
	    //This list was from: http://msdn.microsoft.com/en-us/library/3ca8tfek(v=vs.84).aspx
	    var builtinFuncsWords = ['abs', 'array', 'asc', 'atn', 'cbool', 'cbyte', 'ccur', 'cdate', 'cdbl', 'chr', 'cint', 'clng', 'cos', 'csng', 'cstr', 'date', 'dateadd', 'datediff', 'datepart',
	                        'dateserial', 'datevalue', 'day', 'escape', 'eval', 'execute', 'exp', 'filter', 'formatcurrency', 'formatdatetime', 'formatnumber', 'formatpercent', 'getlocale', 'getobject',
	                        'getref', 'hex', 'hour', 'inputbox', 'instr', 'instrrev', 'int', 'fix', 'isarray', 'isdate', 'isempty', 'isnull', 'isnumeric', 'isobject', 'join', 'lbound', 'lcase', 'left',
	                        'len', 'loadpicture', 'log', 'ltrim', 'rtrim', 'trim', 'maths', 'mid', 'minute', 'month', 'monthname', 'msgbox', 'now', 'oct', 'replace', 'rgb', 'right', 'rnd', 'round',
	                        'scriptengine', 'scriptenginebuildversion', 'scriptenginemajorversion', 'scriptengineminorversion', 'second', 'setlocale', 'sgn', 'sin', 'space', 'split', 'sqr', 'strcomp',
	                        'string', 'strreverse', 'tan', 'time', 'timer', 'timeserial', 'timevalue', 'typename', 'ubound', 'ucase', 'unescape', 'vartype', 'weekday', 'weekdayname', 'year'];
	
	    //This list was from: http://msdn.microsoft.com/en-us/library/ydz4cfk3(v=vs.84).aspx
	    var builtinConsts = ['vbBlack', 'vbRed', 'vbGreen', 'vbYellow', 'vbBlue', 'vbMagenta', 'vbCyan', 'vbWhite', 'vbBinaryCompare', 'vbTextCompare',
	                         'vbSunday', 'vbMonday', 'vbTuesday', 'vbWednesday', 'vbThursday', 'vbFriday', 'vbSaturday', 'vbUseSystemDayOfWeek', 'vbFirstJan1', 'vbFirstFourDays', 'vbFirstFullWeek',
	                         'vbGeneralDate', 'vbLongDate', 'vbShortDate', 'vbLongTime', 'vbShortTime', 'vbObjectError',
	                         'vbOKOnly', 'vbOKCancel', 'vbAbortRetryIgnore', 'vbYesNoCancel', 'vbYesNo', 'vbRetryCancel', 'vbCritical', 'vbQuestion', 'vbExclamation', 'vbInformation', 'vbDefaultButton1', 'vbDefaultButton2',
	                         'vbDefaultButton3', 'vbDefaultButton4', 'vbApplicationModal', 'vbSystemModal', 'vbOK', 'vbCancel', 'vbAbort', 'vbRetry', 'vbIgnore', 'vbYes', 'vbNo',
	                         'vbCr', 'VbCrLf', 'vbFormFeed', 'vbLf', 'vbNewLine', 'vbNullChar', 'vbNullString', 'vbTab', 'vbVerticalTab', 'vbUseDefault', 'vbTrue', 'vbFalse',
	                         'vbEmpty', 'vbNull', 'vbInteger', 'vbLong', 'vbSingle', 'vbDouble', 'vbCurrency', 'vbDate', 'vbString', 'vbObject', 'vbError', 'vbBoolean', 'vbVariant', 'vbDataObject', 'vbDecimal', 'vbByte', 'vbArray'];
	    //This list was from: http://msdn.microsoft.com/en-us/library/hkc375ea(v=vs.84).aspx
	    var builtinObjsWords = ['WScript', 'err', 'debug', 'RegExp'];
	    var knownProperties = ['description', 'firstindex', 'global', 'helpcontext', 'helpfile', 'ignorecase', 'length', 'number', 'pattern', 'source', 'value', 'count'];
	    var knownMethods = ['clear', 'execute', 'raise', 'replace', 'test', 'write', 'writeline', 'close', 'open', 'state', 'eof', 'update', 'addnew', 'end', 'createobject', 'quit'];
	
	    var aspBuiltinObjsWords = ['server', 'response', 'request', 'session', 'application'];
	    var aspKnownProperties = ['buffer', 'cachecontrol', 'charset', 'contenttype', 'expires', 'expiresabsolute', 'isclientconnected', 'pics', 'status', //response
	                              'clientcertificate', 'cookies', 'form', 'querystring', 'servervariables', 'totalbytes', //request
	                              'contents', 'staticobjects', //application
	                              'codepage', 'lcid', 'sessionid', 'timeout', //session
	                              'scripttimeout']; //server
	    var aspKnownMethods = ['addheader', 'appendtolog', 'binarywrite', 'end', 'flush', 'redirect', //response
	                           'binaryread', //request
	                           'remove', 'removeall', 'lock', 'unlock', //application
	                           'abandon', //session
	                           'getlasterror', 'htmlencode', 'mappath', 'transfer', 'urlencode']; //server
	
	    var knownWords = knownMethods.concat(knownProperties);
	
	    builtinObjsWords = builtinObjsWords.concat(builtinConsts);
	
	    if (conf.isASP){
	        builtinObjsWords = builtinObjsWords.concat(aspBuiltinObjsWords);
	        knownWords = knownWords.concat(aspKnownMethods, aspKnownProperties);
	    };
	
	    var keywords = wordRegexp(commonkeywords);
	    var atoms = wordRegexp(atomWords);
	    var builtinFuncs = wordRegexp(builtinFuncsWords);
	    var builtinObjs = wordRegexp(builtinObjsWords);
	    var known = wordRegexp(knownWords);
	    var stringPrefixes = '"';
	
	    var opening = wordRegexp(openingKeywords);
	    var middle = wordRegexp(middleKeywords);
	    var closing = wordRegexp(endKeywords);
	    var doubleClosing = wordRegexp(['end']);
	    var doOpening = wordRegexp(['do']);
	    var noIndentWords = wordRegexp(['on error resume next', 'exit']);
	    var comment = wordRegexp(['rem']);
	
	
	    function indent(_stream, state) {
	      state.currentIndent++;
	    }
	
	    function dedent(_stream, state) {
	      state.currentIndent--;
	    }
	    // tokenizers
	    function tokenBase(stream, state) {
	        if (stream.eatSpace()) {
	            return 'space';
	            //return null;
	        }
	
	        var ch = stream.peek();
	
	        // Handle Comments
	        if (ch === "'") {
	            stream.skipToEnd();
	            return 'comment';
	        }
	        if (stream.match(comment)){
	            stream.skipToEnd();
	            return 'comment';
	        }
	
	
	        // Handle Number Literals
	        if (stream.match(/^((&H)|(&O))?[0-9\.]/i, false) && !stream.match(/^((&H)|(&O))?[0-9\.]+[a-z_]/i, false)) {
	            var floatLiteral = false;
	            // Floats
	            if (stream.match(/^\d*\.\d+/i)) { floatLiteral = true; }
	            else if (stream.match(/^\d+\.\d*/)) { floatLiteral = true; }
	            else if (stream.match(/^\.\d+/)) { floatLiteral = true; }
	
	            if (floatLiteral) {
	                // Float literals may be "imaginary"
	                stream.eat(/J/i);
	                return 'number';
	            }
	            // Integers
	            var intLiteral = false;
	            // Hex
	            if (stream.match(/^&H[0-9a-f]+/i)) { intLiteral = true; }
	            // Octal
	            else if (stream.match(/^&O[0-7]+/i)) { intLiteral = true; }
	            // Decimal
	            else if (stream.match(/^[1-9]\d*F?/)) {
	                // Decimal literals may be "imaginary"
	                stream.eat(/J/i);
	                // TODO - Can you have imaginary longs?
	                intLiteral = true;
	            }
	            // Zero by itself with no other piece of number.
	            else if (stream.match(/^0(?![\dx])/i)) { intLiteral = true; }
	            if (intLiteral) {
	                // Integer literals may be "long"
	                stream.eat(/L/i);
	                return 'number';
	            }
	        }
	
	        // Handle Strings
	        if (stream.match(stringPrefixes)) {
	            state.tokenize = tokenStringFactory(stream.current());
	            return state.tokenize(stream, state);
	        }
	
	        // Handle operators and Delimiters
	        if (stream.match(doubleOperators)
	            || stream.match(singleOperators)
	            || stream.match(wordOperators)) {
	            return 'operator';
	        }
	        if (stream.match(singleDelimiters)) {
	            return null;
	        }
	
	        if (stream.match(brakets)) {
	            return "bracket";
	        }
	
	        if (stream.match(noIndentWords)) {
	            state.doInCurrentLine = true;
	
	            return 'keyword';
	        }
	
	        if (stream.match(doOpening)) {
	            indent(stream,state);
	            state.doInCurrentLine = true;
	
	            return 'keyword';
	        }
	        if (stream.match(opening)) {
	            if (! state.doInCurrentLine)
	              indent(stream,state);
	            else
	              state.doInCurrentLine = false;
	
	            return 'keyword';
	        }
	        if (stream.match(middle)) {
	            return 'keyword';
	        }
	
	
	        if (stream.match(doubleClosing)) {
	            dedent(stream,state);
	            dedent(stream,state);
	
	            return 'keyword';
	        }
	        if (stream.match(closing)) {
	            if (! state.doInCurrentLine)
	              dedent(stream,state);
	            else
	              state.doInCurrentLine = false;
	
	            return 'keyword';
	        }
	
	        if (stream.match(keywords)) {
	            return 'keyword';
	        }
	
	        if (stream.match(atoms)) {
	            return 'atom';
	        }
	
	        if (stream.match(known)) {
	            return 'variable-2';
	        }
	
	        if (stream.match(builtinFuncs)) {
	            return 'builtin';
	        }
	
	        if (stream.match(builtinObjs)){
	            return 'variable-2';
	        }
	
	        if (stream.match(identifiers)) {
	            return 'variable';
	        }
	
	        // Handle non-detected items
	        stream.next();
	        return ERRORCLASS;
	    }
	
	    function tokenStringFactory(delimiter) {
	        var singleline = delimiter.length == 1;
	        var OUTCLASS = 'string';
	
	        return function(stream, state) {
	            while (!stream.eol()) {
	                stream.eatWhile(/[^'"]/);
	                if (stream.match(delimiter)) {
	                    state.tokenize = tokenBase;
	                    return OUTCLASS;
	                } else {
	                    stream.eat(/['"]/);
	                }
	            }
	            if (singleline) {
	                if (parserConf.singleLineStringErrors) {
	                    return ERRORCLASS;
	                } else {
	                    state.tokenize = tokenBase;
	                }
	            }
	            return OUTCLASS;
	        };
	    }
	
	
	    function tokenLexer(stream, state) {
	        var style = state.tokenize(stream, state);
	        var current = stream.current();
	
	        // Handle '.' connected identifiers
	        if (current === '.') {
	            style = state.tokenize(stream, state);
	
	            current = stream.current();
	            if (style && (style.substr(0, 8) === 'variable' || style==='builtin' || style==='keyword')){//|| knownWords.indexOf(current.substring(1)) > -1) {
	                if (style === 'builtin' || style === 'keyword') style='variable';
	                if (knownWords.indexOf(current.substr(1)) > -1) style='variable-2';
	
	                return style;
	            } else {
	                return ERRORCLASS;
	            }
	        }
	
	        return style;
	    }
	
	    var external = {
	        electricChars:"dDpPtTfFeE ",
	        startState: function() {
	            return {
	              tokenize: tokenBase,
	              lastToken: null,
	              currentIndent: 0,
	              nextLineIndent: 0,
	              doInCurrentLine: false,
	              ignoreKeyword: false
	
	
	          };
	        },
	
	        token: function(stream, state) {
	            if (stream.sol()) {
	              state.currentIndent += state.nextLineIndent;
	              state.nextLineIndent = 0;
	              state.doInCurrentLine = 0;
	            }
	            var style = tokenLexer(stream, state);
	
	            state.lastToken = {style:style, content: stream.current()};
	
	            if (style==='space') style=null;
	
	            return style;
	        },
	
	        indent: function(state, textAfter) {
	            var trueText = textAfter.replace(/^\s+|\s+$/g, '') ;
	            if (trueText.match(closing) || trueText.match(doubleClosing) || trueText.match(middle)) return conf.indentUnit*(state.currentIndent-1);
	            if(state.currentIndent < 0) return 0;
	            return state.currentIndent * conf.indentUnit;
	        }
	
	    };
	    return external;
	});
	
	CodeMirror.defineMIME("text/vbscript", "vbscript");
	
	});


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("velocity", function() {
	    function parseWords(str) {
	        var obj = {}, words = str.split(" ");
	        for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	        return obj;
	    }
	
	    var keywords = parseWords("#end #else #break #stop #[[ #]] " +
	                              "#{end} #{else} #{break} #{stop}");
	    var functions = parseWords("#if #elseif #foreach #set #include #parse #macro #define #evaluate " +
	                               "#{if} #{elseif} #{foreach} #{set} #{include} #{parse} #{macro} #{define} #{evaluate}");
	    var specials = parseWords("$foreach.count $foreach.hasNext $foreach.first $foreach.last $foreach.topmost $foreach.parent.count $foreach.parent.hasNext $foreach.parent.first $foreach.parent.last $foreach.parent $velocityCount $!bodyContent $bodyContent");
	    var isOperatorChar = /[+\-*&%=<>!?:\/|]/;
	
	    function chain(stream, state, f) {
	        state.tokenize = f;
	        return f(stream, state);
	    }
	    function tokenBase(stream, state) {
	        var beforeParams = state.beforeParams;
	        state.beforeParams = false;
	        var ch = stream.next();
	        // start of unparsed string?
	        if ((ch == "'") && !state.inString && state.inParams) {
	            state.lastTokenWasBuiltin = false;
	            return chain(stream, state, tokenString(ch));
	        }
	        // start of parsed string?
	        else if ((ch == '"')) {
	            state.lastTokenWasBuiltin = false;
	            if (state.inString) {
	                state.inString = false;
	                return "string";
	            }
	            else if (state.inParams)
	                return chain(stream, state, tokenString(ch));
	        }
	        // is it one of the special signs []{}().,;? Seperator?
	        else if (/[\[\]{}\(\),;\.]/.test(ch)) {
	            if (ch == "(" && beforeParams)
	                state.inParams = true;
	            else if (ch == ")") {
	                state.inParams = false;
	                state.lastTokenWasBuiltin = true;
	            }
	            return null;
	        }
	        // start of a number value?
	        else if (/\d/.test(ch)) {
	            state.lastTokenWasBuiltin = false;
	            stream.eatWhile(/[\w\.]/);
	            return "number";
	        }
	        // multi line comment?
	        else if (ch == "#" && stream.eat("*")) {
	            state.lastTokenWasBuiltin = false;
	            return chain(stream, state, tokenComment);
	        }
	        // unparsed content?
	        else if (ch == "#" && stream.match(/ *\[ *\[/)) {
	            state.lastTokenWasBuiltin = false;
	            return chain(stream, state, tokenUnparsed);
	        }
	        // single line comment?
	        else if (ch == "#" && stream.eat("#")) {
	            state.lastTokenWasBuiltin = false;
	            stream.skipToEnd();
	            return "comment";
	        }
	        // variable?
	        else if (ch == "$") {
	            stream.eatWhile(/[\w\d\$_\.{}]/);
	            // is it one of the specials?
	            if (specials && specials.propertyIsEnumerable(stream.current())) {
	                return "keyword";
	            }
	            else {
	                state.lastTokenWasBuiltin = true;
	                state.beforeParams = true;
	                return "builtin";
	            }
	        }
	        // is it a operator?
	        else if (isOperatorChar.test(ch)) {
	            state.lastTokenWasBuiltin = false;
	            stream.eatWhile(isOperatorChar);
	            return "operator";
	        }
	        else {
	            // get the whole word
	            stream.eatWhile(/[\w\$_{}@]/);
	            var word = stream.current();
	            // is it one of the listed keywords?
	            if (keywords && keywords.propertyIsEnumerable(word))
	                return "keyword";
	            // is it one of the listed functions?
	            if (functions && functions.propertyIsEnumerable(word) ||
	                    (stream.current().match(/^#@?[a-z0-9_]+ *$/i) && stream.peek()=="(") &&
	                     !(functions && functions.propertyIsEnumerable(word.toLowerCase()))) {
	                state.beforeParams = true;
	                state.lastTokenWasBuiltin = false;
	                return "keyword";
	            }
	            if (state.inString) {
	                state.lastTokenWasBuiltin = false;
	                return "string";
	            }
	            if (stream.pos > word.length && stream.string.charAt(stream.pos-word.length-1)=="." && state.lastTokenWasBuiltin)
	                return "builtin";
	            // default: just a "word"
	            state.lastTokenWasBuiltin = false;
	            return null;
	        }
	    }
	
	    function tokenString(quote) {
	        return function(stream, state) {
	            var escaped = false, next, end = false;
	            while ((next = stream.next()) != null) {
	                if ((next == quote) && !escaped) {
	                    end = true;
	                    break;
	                }
	                if (quote=='"' && stream.peek() == '$' && !escaped) {
	                    state.inString = true;
	                    end = true;
	                    break;
	                }
	                escaped = !escaped && next == "\\";
	            }
	            if (end) state.tokenize = tokenBase;
	            return "string";
	        };
	    }
	
	    function tokenComment(stream, state) {
	        var maybeEnd = false, ch;
	        while (ch = stream.next()) {
	            if (ch == "#" && maybeEnd) {
	                state.tokenize = tokenBase;
	                break;
	            }
	            maybeEnd = (ch == "*");
	        }
	        return "comment";
	    }
	
	    function tokenUnparsed(stream, state) {
	        var maybeEnd = 0, ch;
	        while (ch = stream.next()) {
	            if (ch == "#" && maybeEnd == 2) {
	                state.tokenize = tokenBase;
	                break;
	            }
	            if (ch == "]")
	                maybeEnd++;
	            else if (ch != " ")
	                maybeEnd = 0;
	        }
	        return "meta";
	    }
	    // Interface
	
	    return {
	        startState: function() {
	            return {
	                tokenize: tokenBase,
	                beforeParams: false,
	                inParams: false,
	                inString: false,
	                lastTokenWasBuiltin: false
	            };
	        },
	
	        token: function(stream, state) {
	            if (stream.eatSpace()) return null;
	            return state.tokenize(stream, state);
	        },
	        blockCommentStart: "#*",
	        blockCommentEnd: "*#",
	        lineComment: "##",
	        fold: "velocity"
	    };
	});
	
	CodeMirror.defineMIME("text/velocity", "velocity");
	
	});


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("verilog", function(config, parserConfig) {
	
	  var indentUnit = config.indentUnit,
	      statementIndentUnit = parserConfig.statementIndentUnit || indentUnit,
	      dontAlignCalls = parserConfig.dontAlignCalls,
	      noIndentKeywords = parserConfig.noIndentKeywords || [],
	      multiLineStrings = parserConfig.multiLineStrings,
	      hooks = parserConfig.hooks || {};
	
	  function words(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	
	  /**
	   * Keywords from IEEE 1800-2012
	   */
	  var keywords = words(
	    "accept_on alias always always_comb always_ff always_latch and assert assign assume automatic before begin bind " +
	    "bins binsof bit break buf bufif0 bufif1 byte case casex casez cell chandle checker class clocking cmos config " +
	    "const constraint context continue cover covergroup coverpoint cross deassign default defparam design disable " +
	    "dist do edge else end endcase endchecker endclass endclocking endconfig endfunction endgenerate endgroup " +
	    "endinterface endmodule endpackage endprimitive endprogram endproperty endspecify endsequence endtable endtask " +
	    "enum event eventually expect export extends extern final first_match for force foreach forever fork forkjoin " +
	    "function generate genvar global highz0 highz1 if iff ifnone ignore_bins illegal_bins implements implies import " +
	    "incdir include initial inout input inside instance int integer interconnect interface intersect join join_any " +
	    "join_none large let liblist library local localparam logic longint macromodule matches medium modport module " +
	    "nand negedge nettype new nexttime nmos nor noshowcancelled not notif0 notif1 null or output package packed " +
	    "parameter pmos posedge primitive priority program property protected pull0 pull1 pulldown pullup " +
	    "pulsestyle_ondetect pulsestyle_onevent pure rand randc randcase randsequence rcmos real realtime ref reg " +
	    "reject_on release repeat restrict return rnmos rpmos rtran rtranif0 rtranif1 s_always s_eventually s_nexttime " +
	    "s_until s_until_with scalared sequence shortint shortreal showcancelled signed small soft solve specify " +
	    "specparam static string strong strong0 strong1 struct super supply0 supply1 sync_accept_on sync_reject_on " +
	    "table tagged task this throughout time timeprecision timeunit tran tranif0 tranif1 tri tri0 tri1 triand trior " +
	    "trireg type typedef union unique unique0 unsigned until until_with untyped use uwire var vectored virtual void " +
	    "wait wait_order wand weak weak0 weak1 while wildcard wire with within wor xnor xor");
	
	  /** Operators from IEEE 1800-2012
	     unary_operator ::=
	       + | - | ! | ~ | & | ~& | | | ~| | ^ | ~^ | ^~
	     binary_operator ::=
	       + | - | * | / | % | == | != | === | !== | ==? | !=? | && | || | **
	       | < | <= | > | >= | & | | | ^ | ^~ | ~^ | >> | << | >>> | <<<
	       | -> | <->
	     inc_or_dec_operator ::= ++ | --
	     unary_module_path_operator ::=
	       ! | ~ | & | ~& | | | ~| | ^ | ~^ | ^~
	     binary_module_path_operator ::=
	       == | != | && | || | & | | | ^ | ^~ | ~^
	  */
	  var isOperatorChar = /[\+\-\*\/!~&|^%=?:]/;
	  var isBracketChar = /[\[\]{}()]/;
	
	  var unsignedNumber = /\d[0-9_]*/;
	  var decimalLiteral = /\d*\s*'s?d\s*\d[0-9_]*/i;
	  var binaryLiteral = /\d*\s*'s?b\s*[xz01][xz01_]*/i;
	  var octLiteral = /\d*\s*'s?o\s*[xz0-7][xz0-7_]*/i;
	  var hexLiteral = /\d*\s*'s?h\s*[0-9a-fxz?][0-9a-fxz?_]*/i;
	  var realLiteral = /(\d[\d_]*(\.\d[\d_]*)?E-?[\d_]+)|(\d[\d_]*\.\d[\d_]*)/i;
	
	  var closingBracketOrWord = /^((\w+)|[)}\]])/;
	  var closingBracket = /[)}\]]/;
	
	  var curPunc;
	  var curKeyword;
	
	  // Block openings which are closed by a matching keyword in the form of ("end" + keyword)
	  // E.g. "task" => "endtask"
	  var blockKeywords = words(
	    "case checker class clocking config function generate interface module package" +
	    "primitive program property specify sequence table task"
	  );
	
	  // Opening/closing pairs
	  var openClose = {};
	  for (var keyword in blockKeywords) {
	    openClose[keyword] = "end" + keyword;
	  }
	  openClose["begin"] = "end";
	  openClose["casex"] = "endcase";
	  openClose["casez"] = "endcase";
	  openClose["do"   ] = "while";
	  openClose["fork" ] = "join;join_any;join_none";
	  openClose["covergroup"] = "endgroup";
	
	  for (var i in noIndentKeywords) {
	    var keyword = noIndentKeywords[i];
	    if (openClose[keyword]) {
	      openClose[keyword] = undefined;
	    }
	  }
	
	  // Keywords which open statements that are ended with a semi-colon
	  var statementKeywords = words("always always_comb always_ff always_latch assert assign assume else export for foreach forever if import initial repeat while");
	
	  function tokenBase(stream, state) {
	    var ch = stream.peek(), style;
	    if (hooks[ch] && (style = hooks[ch](stream, state)) != false) return style;
	    if (hooks.tokenBase && (style = hooks.tokenBase(stream, state)) != false)
	      return style;
	
	    if (/[,;:\.]/.test(ch)) {
	      curPunc = stream.next();
	      return null;
	    }
	    if (isBracketChar.test(ch)) {
	      curPunc = stream.next();
	      return "bracket";
	    }
	    // Macros (tick-defines)
	    if (ch == '`') {
	      stream.next();
	      if (stream.eatWhile(/[\w\$_]/)) {
	        return "def";
	      } else {
	        return null;
	      }
	    }
	    // System calls
	    if (ch == '$') {
	      stream.next();
	      if (stream.eatWhile(/[\w\$_]/)) {
	        return "meta";
	      } else {
	        return null;
	      }
	    }
	    // Time literals
	    if (ch == '#') {
	      stream.next();
	      stream.eatWhile(/[\d_.]/);
	      return "def";
	    }
	    // Strings
	    if (ch == '"') {
	      stream.next();
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    }
	    // Comments
	    if (ch == "/") {
	      stream.next();
	      if (stream.eat("*")) {
	        state.tokenize = tokenComment;
	        return tokenComment(stream, state);
	      }
	      if (stream.eat("/")) {
	        stream.skipToEnd();
	        return "comment";
	      }
	      stream.backUp(1);
	    }
	
	    // Numeric literals
	    if (stream.match(realLiteral) ||
	        stream.match(decimalLiteral) ||
	        stream.match(binaryLiteral) ||
	        stream.match(octLiteral) ||
	        stream.match(hexLiteral) ||
	        stream.match(unsignedNumber) ||
	        stream.match(realLiteral)) {
	      return "number";
	    }
	
	    // Operators
	    if (stream.eatWhile(isOperatorChar)) {
	      return "meta";
	    }
	
	    // Keywords / plain variables
	    if (stream.eatWhile(/[\w\$_]/)) {
	      var cur = stream.current();
	      if (keywords[cur]) {
	        if (openClose[cur]) {
	          curPunc = "newblock";
	        }
	        if (statementKeywords[cur]) {
	          curPunc = "newstatement";
	        }
	        curKeyword = cur;
	        return "keyword";
	      }
	      return "variable";
	    }
	
	    stream.next();
	    return null;
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, next, end = false;
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) {end = true; break;}
	        escaped = !escaped && next == "\\";
	      }
	      if (end || !(escaped || multiLineStrings))
	        state.tokenize = tokenBase;
	      return "string";
	    };
	  }
	
	  function tokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while (ch = stream.next()) {
	      if (ch == "/" && maybeEnd) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return "comment";
	  }
	
	  function Context(indented, column, type, align, prev) {
	    this.indented = indented;
	    this.column = column;
	    this.type = type;
	    this.align = align;
	    this.prev = prev;
	  }
	  function pushContext(state, col, type) {
	    var indent = state.indented;
	    var c = new Context(indent, col, type, null, state.context);
	    return state.context = c;
	  }
	  function popContext(state) {
	    var t = state.context.type;
	    if (t == ")" || t == "]" || t == "}") {
	      state.indented = state.context.indented;
	    }
	    return state.context = state.context.prev;
	  }
	
	  function isClosing(text, contextClosing) {
	    if (text == contextClosing) {
	      return true;
	    } else {
	      // contextClosing may be multiple keywords separated by ;
	      var closingKeywords = contextClosing.split(";");
	      for (var i in closingKeywords) {
	        if (text == closingKeywords[i]) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }
	
	  function buildElectricInputRegEx() {
	    // Reindentation should occur on any bracket char: {}()[]
	    // or on a match of any of the block closing keywords, at
	    // the end of a line
	    var allClosings = [];
	    for (var i in openClose) {
	      if (openClose[i]) {
	        var closings = openClose[i].split(";");
	        for (var j in closings) {
	          allClosings.push(closings[j]);
	        }
	      }
	    }
	    var re = new RegExp("[{}()\\[\\]]|(" + allClosings.join("|") + ")$");
	    return re;
	  }
	
	  // Interface
	  return {
	
	    // Regex to force current line to reindent
	    electricInput: buildElectricInputRegEx(),
	
	    startState: function(basecolumn) {
	      var state = {
	        tokenize: null,
	        context: new Context((basecolumn || 0) - indentUnit, 0, "top", false),
	        indented: 0,
	        startOfLine: true
	      };
	      if (hooks.startState) hooks.startState(state);
	      return state;
	    },
	
	    token: function(stream, state) {
	      var ctx = state.context;
	      if (stream.sol()) {
	        if (ctx.align == null) ctx.align = false;
	        state.indented = stream.indentation();
	        state.startOfLine = true;
	      }
	      if (hooks.token) {
	        // Call hook, with an optional return value of a style to override verilog styling.
	        var style = hooks.token(stream, state);
	        if (style !== undefined) {
	          return style;
	        }
	      }
	      if (stream.eatSpace()) return null;
	      curPunc = null;
	      curKeyword = null;
	      var style = (state.tokenize || tokenBase)(stream, state);
	      if (style == "comment" || style == "meta" || style == "variable") return style;
	      if (ctx.align == null) ctx.align = true;
	
	      if (curPunc == ctx.type) {
	        popContext(state);
	      } else if ((curPunc == ";" && ctx.type == "statement") ||
	               (ctx.type && isClosing(curKeyword, ctx.type))) {
	        ctx = popContext(state);
	        while (ctx && ctx.type == "statement") ctx = popContext(state);
	      } else if (curPunc == "{") {
	        pushContext(state, stream.column(), "}");
	      } else if (curPunc == "[") {
	        pushContext(state, stream.column(), "]");
	      } else if (curPunc == "(") {
	        pushContext(state, stream.column(), ")");
	      } else if (ctx && ctx.type == "endcase" && curPunc == ":") {
	        pushContext(state, stream.column(), "statement");
	      } else if (curPunc == "newstatement") {
	        pushContext(state, stream.column(), "statement");
	      } else if (curPunc == "newblock") {
	        if (curKeyword == "function" && ctx && (ctx.type == "statement" || ctx.type == "endgroup")) {
	          // The 'function' keyword can appear in some other contexts where it actually does not
	          // indicate a function (import/export DPI and covergroup definitions).
	          // Do nothing in this case
	        } else if (curKeyword == "task" && ctx && ctx.type == "statement") {
	          // Same thing for task
	        } else {
	          var close = openClose[curKeyword];
	          pushContext(state, stream.column(), close);
	        }
	      }
	
	      state.startOfLine = false;
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      if (state.tokenize != tokenBase && state.tokenize != null) return CodeMirror.Pass;
	      if (hooks.indent) {
	        var fromHook = hooks.indent(state);
	        if (fromHook >= 0) return fromHook;
	      }
	      var ctx = state.context, firstChar = textAfter && textAfter.charAt(0);
	      if (ctx.type == "statement" && firstChar == "}") ctx = ctx.prev;
	      var closing = false;
	      var possibleClosing = textAfter.match(closingBracketOrWord);
	      if (possibleClosing)
	        closing = isClosing(possibleClosing[0], ctx.type);
	      if (ctx.type == "statement") return ctx.indented + (firstChar == "{" ? 0 : statementIndentUnit);
	      else if (closingBracket.test(ctx.type) && ctx.align && !dontAlignCalls) return ctx.column + (closing ? 0 : 1);
	      else if (ctx.type == ")" && !closing) return ctx.indented + statementIndentUnit;
	      else return ctx.indented + (closing ? 0 : indentUnit);
	    },
	
	    blockCommentStart: "/*",
	    blockCommentEnd: "*/",
	    lineComment: "//"
	  };
	});
	
	  CodeMirror.defineMIME("text/x-verilog", {
	    name: "verilog"
	  });
	
	  CodeMirror.defineMIME("text/x-systemverilog", {
	    name: "verilog"
	  });
	
	
	
	  // TL-Verilog mode.
	  // See tl-x.org for language spec.
	  // See the mode in action at makerchip.com.
	  // Contact: steve.hoover@redwoodeda.com
	
	  // TLV Identifier prefixes.
	  // Note that sign is not treated separately, so "+/-" versions of numeric identifiers
	  // are included.
	  var tlvIdentifierStyle = {
	    "|": "link",
	    ">": "property",  // Should condition this off for > TLV 1c.
	    "$": "variable",
	    "$$": "variable",
	    "?$": "qualifier",
	    "?*": "qualifier",
	    "-": "hr",
	    "/": "property",
	    "/-": "property",
	    "@": "variable-3",
	    "@-": "variable-3",
	    "@++": "variable-3",
	    "@+=": "variable-3",
	    "@+=-": "variable-3",
	    "@--": "variable-3",
	    "@-=": "variable-3",
	    "%+": "tag",
	    "%-": "tag",
	    "%": "tag",
	    ">>": "tag",
	    "<<": "tag",
	    "<>": "tag",
	    "#": "tag",  // Need to choose a style for this.
	    "^": "attribute",
	    "^^": "attribute",
	    "^!": "attribute",
	    "*": "variable-2",
	    "**": "variable-2",
	    "\\": "keyword",
	    "\"": "comment"
	  };
	
	  // Lines starting with these characters define scope (result in indentation).
	  var tlvScopePrefixChars = {
	    "/": "beh-hier",
	    ">": "beh-hier",
	    "-": "phys-hier",
	    "|": "pipe",
	    "?": "when",
	    "@": "stage",
	    "\\": "keyword"
	  };
	  var tlvIndentUnit = 3;
	  var tlvTrackStatements = false;
	  var tlvIdentMatch = /^([~!@#\$%\^&\*-\+=\?\/\\\|'"<>]+)([\d\w_]*)/;  // Matches an identifiere.
	  // Note that ':' is excluded, because of it's use in [:].
	  var tlvFirstLevelIndentMatch = /^[! ]  /;
	  var tlvLineIndentationMatch = /^[! ] */;
	  var tlvCommentMatch = /^\/[\/\*]/;
	
	
	  // Returns a style specific to the scope at the given indentation column.
	  // Type is one of: "indent", "scope-ident", "before-scope-ident".
	  function tlvScopeStyle(state, indentation, type) {
	    // Begin scope.
	    var depth = indentation / tlvIndentUnit;  // TODO: Pass this in instead.
	    return "tlv-" + state.tlvIndentationStyle[depth] + "-" + type;
	  }
	
	  // Return true if the next thing in the stream is an identifier with a mnemonic.
	  function tlvIdentNext(stream) {
	    var match;
	    return (match = stream.match(tlvIdentMatch, false)) && match[2].length > 0;
	  }
	
	  CodeMirror.defineMIME("text/x-tlv", {
	    name: "verilog",
	
	    hooks: {
	
	      electricInput: false,
	
	
	      // Return undefined for verilog tokenizing, or style for TLV token (null not used).
	      // Standard CM styles are used for most formatting, but some TL-Verilog-specific highlighting
	      // can be enabled with the definition of cm-tlv-* styles, including highlighting for:
	      //   - M4 tokens
	      //   - TLV scope indentation
	      //   - Statement delimitation (enabled by tlvTrackStatements)
	      token: function(stream, state) {
	        var style = undefined;
	        var match;  // Return value of pattern matches.
	
	        // Set highlighting mode based on code region (TLV or SV).
	        if (stream.sol() && ! state.tlvInBlockComment) {
	          // Process region.
	          if (stream.peek() == '\\') {
	            style = "def";
	            stream.skipToEnd();
	            if (stream.string.match(/\\SV/)) {
	              state.tlvCodeActive = false;
	            } else if (stream.string.match(/\\TLV/)){
	              state.tlvCodeActive = true;
	            }
	          }
	          // Correct indentation in the face of a line prefix char.
	          if (state.tlvCodeActive && stream.pos == 0 &&
	              (state.indented == 0) && (match = stream.match(tlvLineIndentationMatch, false))) {
	            state.indented = match[0].length;
	          }
	
	          // Compute indentation state:
	          //   o Auto indentation on next line
	          //   o Indentation scope styles
	          var indented = state.indented;
	          var depth = indented / tlvIndentUnit;
	          if (depth <= state.tlvIndentationStyle.length) {
	            // not deeper than current scope
	
	            var blankline = stream.string.length == indented;
	            var chPos = depth * tlvIndentUnit;
	            if (chPos < stream.string.length) {
	              var bodyString = stream.string.slice(chPos);
	              var ch = bodyString[0];
	              if (tlvScopePrefixChars[ch] && ((match = bodyString.match(tlvIdentMatch)) &&
	                  tlvIdentifierStyle[match[1]])) {
	                // This line begins scope.
	                // Next line gets indented one level.
	                indented += tlvIndentUnit;
	                // Style the next level of indentation (except non-region keyword identifiers,
	                //   which are statements themselves)
	                if (!(ch == "\\" && chPos > 0)) {
	                  state.tlvIndentationStyle[depth] = tlvScopePrefixChars[ch];
	                  if (tlvTrackStatements) {state.statementComment = false;}
	                  depth++;
	                }
	              }
	            }
	            // Clear out deeper indentation levels unless line is blank.
	            if (!blankline) {
	              while (state.tlvIndentationStyle.length > depth) {
	                state.tlvIndentationStyle.pop();
	              }
	            }
	          }
	          // Set next level of indentation.
	          state.tlvNextIndent = indented;
	        }
	
	        if (state.tlvCodeActive) {
	          // Highlight as TLV.
	
	          var beginStatement = false;
	          if (tlvTrackStatements) {
	            // This starts a statement if the position is at the scope level
	            // and we're not within a statement leading comment.
	            beginStatement =
	                   (stream.peek() != " ") &&   // not a space
	                   (style === undefined) &&    // not a region identifier
	                   !state.tlvInBlockComment && // not in block comment
	                   //!stream.match(tlvCommentMatch, false) && // not comment start
	                   (stream.column() == state.tlvIndentationStyle.length * tlvIndentUnit);  // at scope level
	            if (beginStatement) {
	              if (state.statementComment) {
	                // statement already started by comment
	                beginStatement = false;
	              }
	              state.statementComment =
	                   stream.match(tlvCommentMatch, false); // comment start
	            }
	          }
	
	          var match;
	          if (style !== undefined) {
	            // Region line.
	            style += " " + tlvScopeStyle(state, 0, "scope-ident")
	          } else if (((stream.pos / tlvIndentUnit) < state.tlvIndentationStyle.length) &&
	                     (match = stream.match(stream.sol() ? tlvFirstLevelIndentMatch : /^   /))) {
	            // Indentation
	            style = // make this style distinct from the previous one to prevent
	                    // codemirror from combining spans
	                    "tlv-indent-" + (((stream.pos % 2) == 0) ? "even" : "odd") +
	                    // and style it
	                    " " + tlvScopeStyle(state, stream.pos - tlvIndentUnit, "indent");
	            // Style the line prefix character.
	            if (match[0].charAt(0) == "!") {
	              style += " tlv-alert-line-prefix";
	            }
	            // Place a class before a scope identifier.
	            if (tlvIdentNext(stream)) {
	              style += " " + tlvScopeStyle(state, stream.pos, "before-scope-ident");
	            }
	          } else if (state.tlvInBlockComment) {
	            // In a block comment.
	            if (stream.match(/^.*?\*\//)) {
	              // Exit block comment.
	              state.tlvInBlockComment = false;
	              if (tlvTrackStatements && !stream.eol()) {
	                // Anything after comment is assumed to be real statement content.
	                state.statementComment = false;
	              }
	            } else {
	              stream.skipToEnd();
	            }
	            style = "comment";
	          } else if ((match = stream.match(tlvCommentMatch)) && !state.tlvInBlockComment) {
	            // Start comment.
	            if (match[0] == "//") {
	              // Line comment.
	              stream.skipToEnd();
	            } else {
	              // Block comment.
	              state.tlvInBlockComment = true;
	            }
	            style = "comment";
	          } else if (match = stream.match(tlvIdentMatch)) {
	            // looks like an identifier (or identifier prefix)
	            var prefix = match[1];
	            var mnemonic = match[2];
	            if (// is identifier prefix
	                (prefix in tlvIdentifierStyle) &&
	                // has mnemonic or we're at the end of the line (maybe it hasn't been typed yet)
	                (mnemonic.length > 0 || stream.eol())) {
	              style = tlvIdentifierStyle[prefix];
	              if (stream.column() == state.indented) {
	                // Begin scope.
	                style += " " + tlvScopeStyle(state, stream.column(), "scope-ident")
	              }
	            } else {
	              // Just swallow one character and try again.
	              // This enables subsequent identifier match with preceding symbol character, which
	              //   is legal within a statement.  (Eg, !$reset).  It also enables detection of
	              //   comment start with preceding symbols.
	              stream.backUp(stream.current().length - 1);
	              style = "tlv-default";
	            }
	          } else if (stream.match(/^\t+/)) {
	            // Highlight tabs, which are illegal.
	            style = "tlv-tab";
	          } else if (stream.match(/^[\[\]{}\(\);\:]+/)) {
	            // [:], (), {}, ;.
	            style = "meta";
	          } else if (match = stream.match(/^[mM]4([\+_])?[\w\d_]*/)) {
	            // m4 pre proc
	            style = (match[1] == "+") ? "tlv-m4-plus" : "tlv-m4";
	          } else if (stream.match(/^ +/)){
	            // Skip over spaces.
	            if (stream.eol()) {
	              // Trailing spaces.
	              style = "error";
	            } else {
	              // Non-trailing spaces.
	              style = "tlv-default";
	            }
	          } else if (stream.match(/^[\w\d_]+/)) {
	            // alpha-numeric token.
	            style = "number";
	          } else {
	            // Eat the next char w/ no formatting.
	            stream.next();
	            style = "tlv-default";
	          }
	          if (beginStatement) {
	            style += " tlv-statement";
	          }
	        } else {
	          if (stream.match(/^[mM]4([\w\d_]*)/)) {
	            // m4 pre proc
	            style = "tlv-m4";
	          }
	        }
	        return style;
	      },
	
	      indent: function(state) {
	        return (state.tlvCodeActive == true) ? state.tlvNextIndent : -1;
	      },
	
	      startState: function(state) {
	        state.tlvIndentationStyle = [];  // Styles to use for each level of indentation.
	        state.tlvCodeActive = true;  // True when we're in a TLV region (and at beginning of file).
	        state.tlvNextIndent = -1;    // The number of spaces to autoindent the next line if tlvCodeActive.
	        state.tlvInBlockComment = false;  // True inside /**/ comment.
	        if (tlvTrackStatements) {
	          state.statementComment = false;  // True inside a statement's header comment.
	        }
	      }
	
	    }
	  });
	});


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// Originally written by Alf Nielsen, re-written by Michael Zhou
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	function words(str) {
	  var obj = {}, words = str.split(",");
	  for (var i = 0; i < words.length; ++i) {
	    var allCaps = words[i].toUpperCase();
	    var firstCap = words[i].charAt(0).toUpperCase() + words[i].slice(1);
	    obj[words[i]] = true;
	    obj[allCaps] = true;
	    obj[firstCap] = true;
	  }
	  return obj;
	}
	
	function metaHook(stream) {
	  stream.eatWhile(/[\w\$_]/);
	  return "meta";
	}
	
	CodeMirror.defineMode("vhdl", function(config, parserConfig) {
	  var indentUnit = config.indentUnit,
	      atoms = parserConfig.atoms || words("null"),
	      hooks = parserConfig.hooks || {"`": metaHook, "$": metaHook},
	      multiLineStrings = parserConfig.multiLineStrings;
	
	  var keywords = words("abs,access,after,alias,all,and,architecture,array,assert,attribute,begin,block," +
	      "body,buffer,bus,case,component,configuration,constant,disconnect,downto,else,elsif,end,end block,end case," +
	      "end component,end for,end generate,end if,end loop,end process,end record,end units,entity,exit,file,for," +
	      "function,generate,generic,generic map,group,guarded,if,impure,in,inertial,inout,is,label,library,linkage," +
	      "literal,loop,map,mod,nand,new,next,nor,null,of,on,open,or,others,out,package,package body,port,port map," +
	      "postponed,procedure,process,pure,range,record,register,reject,rem,report,return,rol,ror,select,severity,signal," +
	      "sla,sll,sra,srl,subtype,then,to,transport,type,unaffected,units,until,use,variable,wait,when,while,with,xnor,xor");
	
	  var blockKeywords = words("architecture,entity,begin,case,port,else,elsif,end,for,function,if");
	
	  var isOperatorChar = /[&|~><!\)\(*#%@+\/=?\:;}{,\.\^\-\[\]]/;
	  var curPunc;
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    if (hooks[ch]) {
	      var result = hooks[ch](stream, state);
	      if (result !== false) return result;
	    }
	    if (ch == '"') {
	      state.tokenize = tokenString2(ch);
	      return state.tokenize(stream, state);
	    }
	    if (ch == "'") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    }
	    if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
	      curPunc = ch;
	      return null;
	    }
	    if (/[\d']/.test(ch)) {
	      stream.eatWhile(/[\w\.']/);
	      return "number";
	    }
	    if (ch == "-") {
	      if (stream.eat("-")) {
	        stream.skipToEnd();
	        return "comment";
	      }
	    }
	    if (isOperatorChar.test(ch)) {
	      stream.eatWhile(isOperatorChar);
	      return "operator";
	    }
	    stream.eatWhile(/[\w\$_]/);
	    var cur = stream.current();
	    if (keywords.propertyIsEnumerable(cur.toLowerCase())) {
	      if (blockKeywords.propertyIsEnumerable(cur)) curPunc = "newstatement";
	      return "keyword";
	    }
	    if (atoms.propertyIsEnumerable(cur)) return "atom";
	    return "variable";
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, next, end = false;
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) {end = true; break;}
	        escaped = !escaped && next == "--";
	      }
	      if (end || !(escaped || multiLineStrings))
	        state.tokenize = tokenBase;
	      return "string";
	    };
	  }
	  function tokenString2(quote) {
	    return function(stream, state) {
	      var escaped = false, next, end = false;
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) {end = true; break;}
	        escaped = !escaped && next == "--";
	      }
	      if (end || !(escaped || multiLineStrings))
	        state.tokenize = tokenBase;
	      return "string-2";
	    };
	  }
	
	  function Context(indented, column, type, align, prev) {
	    this.indented = indented;
	    this.column = column;
	    this.type = type;
	    this.align = align;
	    this.prev = prev;
	  }
	  function pushContext(state, col, type) {
	    return state.context = new Context(state.indented, col, type, null, state.context);
	  }
	  function popContext(state) {
	    var t = state.context.type;
	    if (t == ")" || t == "]" || t == "}")
	      state.indented = state.context.indented;
	    return state.context = state.context.prev;
	  }
	
	  // Interface
	  return {
	    startState: function(basecolumn) {
	      return {
	        tokenize: null,
	        context: new Context((basecolumn || 0) - indentUnit, 0, "top", false),
	        indented: 0,
	        startOfLine: true
	      };
	    },
	
	    token: function(stream, state) {
	      var ctx = state.context;
	      if (stream.sol()) {
	        if (ctx.align == null) ctx.align = false;
	        state.indented = stream.indentation();
	        state.startOfLine = true;
	      }
	      if (stream.eatSpace()) return null;
	      curPunc = null;
	      var style = (state.tokenize || tokenBase)(stream, state);
	      if (style == "comment" || style == "meta") return style;
	      if (ctx.align == null) ctx.align = true;
	
	      if ((curPunc == ";" || curPunc == ":") && ctx.type == "statement") popContext(state);
	      else if (curPunc == "{") pushContext(state, stream.column(), "}");
	      else if (curPunc == "[") pushContext(state, stream.column(), "]");
	      else if (curPunc == "(") pushContext(state, stream.column(), ")");
	      else if (curPunc == "}") {
	        while (ctx.type == "statement") ctx = popContext(state);
	        if (ctx.type == "}") ctx = popContext(state);
	        while (ctx.type == "statement") ctx = popContext(state);
	      }
	      else if (curPunc == ctx.type) popContext(state);
	      else if (ctx.type == "}" || ctx.type == "top" || (ctx.type == "statement" && curPunc == "newstatement"))
	        pushContext(state, stream.column(), "statement");
	      state.startOfLine = false;
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      if (state.tokenize != tokenBase && state.tokenize != null) return 0;
	      var firstChar = textAfter && textAfter.charAt(0), ctx = state.context, closing = firstChar == ctx.type;
	      if (ctx.type == "statement") return ctx.indented + (firstChar == "{" ? 0 : indentUnit);
	      else if (ctx.align) return ctx.column + (closing ? 0 : 1);
	      else return ctx.indented + (closing ? 0 : indentUnit);
	    },
	
	    electricChars: "{}"
	  };
	});
	
	CodeMirror.defineMIME("text/x-vhdl", "vhdl");
	
	});


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function (mod) {
	  "use strict";
	  if (true) {// CommonJS
	    mod(__webpack_require__(2),
	        __webpack_require__(19),
	        __webpack_require__(22),
	        __webpack_require__(12),
	        __webpack_require__(78),
	        __webpack_require__(21),
	        __webpack_require__(85),
	        __webpack_require__(88),
	        __webpack_require__(83),
	        __webpack_require__(79));
	  } else if (typeof define === "function" && define.amd) { // AMD
	    define(["../../lib/codemirror",
	            "../../addon/mode/overlay",
	            "../xml/xml",
	            "../javascript/javascript",
	            "../coffeescript/coffeescript",
	            "../css/css",
	            "../sass/sass",
	            "../stylus/stylus",
	            "../pug/pug",
	            "../handlebars/handlebars"], mod);
	  } else { // Plain browser env
	    mod(CodeMirror);
	  }
	})(function (CodeMirror) {
	  var tagLanguages = {
	    script: [
	      ["lang", /coffee(script)?/, "coffeescript"],
	      ["type", /^(?:text|application)\/(?:x-)?coffee(?:script)?$/, "coffeescript"]
	    ],
	    style: [
	      ["lang", /^stylus$/i, "stylus"],
	      ["lang", /^sass$/i, "sass"],
	      ["type", /^(text\/)?(x-)?styl(us)?$/i, "stylus"],
	      ["type", /^text\/sass/i, "sass"]
	    ],
	    template: [
	      ["lang", /^vue-template$/i, "vue"],
	      ["lang", /^pug$/i, "pug"],
	      ["lang", /^handlebars$/i, "handlebars"],
	      ["type", /^(text\/)?(x-)?pug$/i, "pug"],
	      ["type", /^text\/x-handlebars-template$/i, "handlebars"],
	      [null, null, "vue-template"]
	    ]
	  };
	
	  CodeMirror.defineMode("vue-template", function (config, parserConfig) {
	    var mustacheOverlay = {
	      token: function (stream) {
	        if (stream.match(/^\{\{.*?\}\}/)) return "meta mustache";
	        while (stream.next() && !stream.match("{{", false)) {}
	        return null;
	      }
	    };
	    return CodeMirror.overlayMode(CodeMirror.getMode(config, parserConfig.backdrop || "text/html"), mustacheOverlay);
	  });
	
	  CodeMirror.defineMode("vue", function (config) {
	    return CodeMirror.getMode(config, {name: "htmlmixed", tags: tagLanguages});
	  }, "htmlmixed", "xml", "javascript", "coffeescript", "css", "sass", "stylus", "pug", "handlebars");
	
	  CodeMirror.defineMIME("script/x-vue", "vue");
	  CodeMirror.defineMIME("text/x-vue", "vue");
	});


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	function wordRegexp(words) {
	  return new RegExp("^((" + words.join(")|(") + "))\\b");
	};
	
	var builtinArray = [
	  "Clamp",
	  "Constructor",
	  "EnforceRange",
	  "Exposed",
	  "ImplicitThis",
	  "Global", "PrimaryGlobal",
	  "LegacyArrayClass",
	  "LegacyUnenumerableNamedProperties",
	  "LenientThis",
	  "NamedConstructor",
	  "NewObject",
	  "NoInterfaceObject",
	  "OverrideBuiltins",
	  "PutForwards",
	  "Replaceable",
	  "SameObject",
	  "TreatNonObjectAsNull",
	  "TreatNullAs",
	    "EmptyString",
	  "Unforgeable",
	  "Unscopeable"
	];
	var builtins = wordRegexp(builtinArray);
	
	var typeArray = [
	  "unsigned", "short", "long",                  // UnsignedIntegerType
	  "unrestricted", "float", "double",            // UnrestrictedFloatType
	  "boolean", "byte", "octet",                   // Rest of PrimitiveType
	  "Promise",                                    // PromiseType
	  "ArrayBuffer", "DataView", "Int8Array", "Int16Array", "Int32Array",
	  "Uint8Array", "Uint16Array", "Uint32Array", "Uint8ClampedArray",
	  "Float32Array", "Float64Array",               // BufferRelatedType
	  "ByteString", "DOMString", "USVString", "sequence", "object", "RegExp",
	  "Error", "DOMException", "FrozenArray",       // Rest of NonAnyType
	  "any",                                        // Rest of SingleType
	  "void"                                        // Rest of ReturnType
	];
	var types = wordRegexp(typeArray);
	
	var keywordArray = [
	  "attribute", "callback", "const", "deleter", "dictionary", "enum", "getter",
	  "implements", "inherit", "interface", "iterable", "legacycaller", "maplike",
	  "partial", "required", "serializer", "setlike", "setter", "static",
	  "stringifier", "typedef",                     // ArgumentNameKeyword except
	                                                // "unrestricted"
	  "optional", "readonly", "or"
	];
	var keywords = wordRegexp(keywordArray);
	
	var atomArray = [
	  "true", "false",                              // BooleanLiteral
	  "Infinity", "NaN",                            // FloatLiteral
	  "null"                                        // Rest of ConstValue
	];
	var atoms = wordRegexp(atomArray);
	
	CodeMirror.registerHelper("hintWords", "webidl",
	    builtinArray.concat(typeArray).concat(keywordArray).concat(atomArray));
	
	var startDefArray = ["callback", "dictionary", "enum", "interface"];
	var startDefs = wordRegexp(startDefArray);
	
	var endDefArray = ["typedef"];
	var endDefs = wordRegexp(endDefArray);
	
	var singleOperators = /^[:<=>?]/;
	var integers = /^-?([1-9][0-9]*|0[Xx][0-9A-Fa-f]+|0[0-7]*)/;
	var floats = /^-?(([0-9]+\.[0-9]*|[0-9]*\.[0-9]+)([Ee][+-]?[0-9]+)?|[0-9]+[Ee][+-]?[0-9]+)/;
	var identifiers = /^_?[A-Za-z][0-9A-Z_a-z-]*/;
	var identifiersEnd = /^_?[A-Za-z][0-9A-Z_a-z-]*(?=\s*;)/;
	var strings = /^"[^"]*"/;
	var multilineComments = /^\/\*.*?\*\//;
	var multilineCommentsStart = /^\/\*.*/;
	var multilineCommentsEnd = /^.*?\*\//;
	
	function readToken(stream, state) {
	  // whitespace
	  if (stream.eatSpace()) return null;
	
	  // comment
	  if (state.inComment) {
	    if (stream.match(multilineCommentsEnd)) {
	      state.inComment = false;
	      return "comment";
	    }
	    stream.skipToEnd();
	    return "comment";
	  }
	  if (stream.match("//")) {
	    stream.skipToEnd();
	    return "comment";
	  }
	  if (stream.match(multilineComments)) return "comment";
	  if (stream.match(multilineCommentsStart)) {
	    state.inComment = true;
	    return "comment";
	  }
	
	  // integer and float
	  if (stream.match(/^-?[0-9\.]/, false)) {
	    if (stream.match(integers) || stream.match(floats)) return "number";
	  }
	
	  // string
	  if (stream.match(strings)) return "string";
	
	  // identifier
	  if (state.startDef && stream.match(identifiers)) return "def";
	
	  if (state.endDef && stream.match(identifiersEnd)) {
	    state.endDef = false;
	    return "def";
	  }
	
	  if (stream.match(keywords)) return "keyword";
	
	  if (stream.match(types)) {
	    var lastToken = state.lastToken;
	    var nextToken = (stream.match(/^\s*(.+?)\b/, false) || [])[1];
	
	    if (lastToken === ":" || lastToken === "implements" ||
	        nextToken === "implements" || nextToken === "=") {
	      // Used as identifier
	      return "builtin";
	    } else {
	      // Used as type
	      return "variable-3";
	    }
	  }
	
	  if (stream.match(builtins)) return "builtin";
	  if (stream.match(atoms)) return "atom";
	  if (stream.match(identifiers)) return "variable";
	
	  // other
	  if (stream.match(singleOperators)) return "operator";
	
	  // unrecognized
	  stream.next();
	  return null;
	};
	
	CodeMirror.defineMode("webidl", function() {
	  return {
	    startState: function() {
	      return {
	        // Is in multiline comment
	        inComment: false,
	        // Last non-whitespace, matched token
	        lastToken: "",
	        // Next token is a definition
	        startDef: false,
	        // Last token of the statement is a definition
	        endDef: false
	      };
	    },
	    token: function(stream, state) {
	      var style = readToken(stream, state);
	
	      if (style) {
	        var cur = stream.current();
	        state.lastToken = cur;
	        if (style === "keyword") {
	          state.startDef = startDefs.test(cur);
	          state.endDef = state.endDef || endDefs.test(cur);
	        } else {
	          state.startDef = false;
	        }
	      }
	
	      return style;
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/x-webidl", "webidl");
	});


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("xquery", function() {
	
	  // The keywords object is set to the result of this self executing
	  // function. Each keyword is a property of the keywords object whose
	  // value is {type: atype, style: astyle}
	  var keywords = function(){
	    // convenience functions used to build keywords object
	    function kw(type) {return {type: type, style: "keyword"};}
	    var A = kw("keyword a")
	      , B = kw("keyword b")
	      , C = kw("keyword c")
	      , operator = kw("operator")
	      , atom = {type: "atom", style: "atom"}
	      , punctuation = {type: "punctuation", style: null}
	      , qualifier = {type: "axis_specifier", style: "qualifier"};
	
	    // kwObj is what is return from this function at the end
	    var kwObj = {
	      'if': A, 'switch': A, 'while': A, 'for': A,
	      'else': B, 'then': B, 'try': B, 'finally': B, 'catch': B,
	      'element': C, 'attribute': C, 'let': C, 'implements': C, 'import': C, 'module': C, 'namespace': C,
	      'return': C, 'super': C, 'this': C, 'throws': C, 'where': C, 'private': C,
	      ',': punctuation,
	      'null': atom, 'fn:false()': atom, 'fn:true()': atom
	    };
	
	    // a list of 'basic' keywords. For each add a property to kwObj with the value of
	    // {type: basic[i], style: "keyword"} e.g. 'after' --> {type: "after", style: "keyword"}
	    var basic = ['after','ancestor','ancestor-or-self','and','as','ascending','assert','attribute','before',
	    'by','case','cast','child','comment','declare','default','define','descendant','descendant-or-self',
	    'descending','document','document-node','element','else','eq','every','except','external','following',
	    'following-sibling','follows','for','function','if','import','in','instance','intersect','item',
	    'let','module','namespace','node','node','of','only','or','order','parent','precedes','preceding',
	    'preceding-sibling','processing-instruction','ref','return','returns','satisfies','schema','schema-element',
	    'self','some','sortby','stable','text','then','to','treat','typeswitch','union','variable','version','where',
	    'xquery', 'empty-sequence'];
	    for(var i=0, l=basic.length; i < l; i++) { kwObj[basic[i]] = kw(basic[i]);};
	
	    // a list of types. For each add a property to kwObj with the value of
	    // {type: "atom", style: "atom"}
	    var types = ['xs:string', 'xs:float', 'xs:decimal', 'xs:double', 'xs:integer', 'xs:boolean', 'xs:date', 'xs:dateTime',
	    'xs:time', 'xs:duration', 'xs:dayTimeDuration', 'xs:time', 'xs:yearMonthDuration', 'numeric', 'xs:hexBinary',
	    'xs:base64Binary', 'xs:anyURI', 'xs:QName', 'xs:byte','xs:boolean','xs:anyURI','xf:yearMonthDuration'];
	    for(var i=0, l=types.length; i < l; i++) { kwObj[types[i]] = atom;};
	
	    // each operator will add a property to kwObj with value of {type: "operator", style: "keyword"}
	    var operators = ['eq', 'ne', 'lt', 'le', 'gt', 'ge', ':=', '=', '>', '>=', '<', '<=', '.', '|', '?', 'and', 'or', 'div', 'idiv', 'mod', '*', '/', '+', '-'];
	    for(var i=0, l=operators.length; i < l; i++) { kwObj[operators[i]] = operator;};
	
	    // each axis_specifiers will add a property to kwObj with value of {type: "axis_specifier", style: "qualifier"}
	    var axis_specifiers = ["self::", "attribute::", "child::", "descendant::", "descendant-or-self::", "parent::",
	    "ancestor::", "ancestor-or-self::", "following::", "preceding::", "following-sibling::", "preceding-sibling::"];
	    for(var i=0, l=axis_specifiers.length; i < l; i++) { kwObj[axis_specifiers[i]] = qualifier; };
	
	    return kwObj;
	  }();
	
	  function chain(stream, state, f) {
	    state.tokenize = f;
	    return f(stream, state);
	  }
	
	  // the primary mode tokenizer
	  function tokenBase(stream, state) {
	    var ch = stream.next(),
	        mightBeFunction = false,
	        isEQName = isEQNameAhead(stream);
	
	    // an XML tag (if not in some sub, chained tokenizer)
	    if (ch == "<") {
	      if(stream.match("!--", true))
	        return chain(stream, state, tokenXMLComment);
	
	      if(stream.match("![CDATA", false)) {
	        state.tokenize = tokenCDATA;
	        return "tag";
	      }
	
	      if(stream.match("?", false)) {
	        return chain(stream, state, tokenPreProcessing);
	      }
	
	      var isclose = stream.eat("/");
	      stream.eatSpace();
	      var tagName = "", c;
	      while ((c = stream.eat(/[^\s\u00a0=<>\"\'\/?]/))) tagName += c;
	
	      return chain(stream, state, tokenTag(tagName, isclose));
	    }
	    // start code block
	    else if(ch == "{") {
	      pushStateStack(state,{ type: "codeblock"});
	      return null;
	    }
	    // end code block
	    else if(ch == "}") {
	      popStateStack(state);
	      return null;
	    }
	    // if we're in an XML block
	    else if(isInXmlBlock(state)) {
	      if(ch == ">")
	        return "tag";
	      else if(ch == "/" && stream.eat(">")) {
	        popStateStack(state);
	        return "tag";
	      }
	      else
	        return "variable";
	    }
	    // if a number
	    else if (/\d/.test(ch)) {
	      stream.match(/^\d*(?:\.\d*)?(?:E[+\-]?\d+)?/);
	      return "atom";
	    }
	    // comment start
	    else if (ch === "(" && stream.eat(":")) {
	      pushStateStack(state, { type: "comment"});
	      return chain(stream, state, tokenComment);
	    }
	    // quoted string
	    else if (  !isEQName && (ch === '"' || ch === "'"))
	      return chain(stream, state, tokenString(ch));
	    // variable
	    else if(ch === "$") {
	      return chain(stream, state, tokenVariable);
	    }
	    // assignment
	    else if(ch ===":" && stream.eat("=")) {
	      return "keyword";
	    }
	    // open paren
	    else if(ch === "(") {
	      pushStateStack(state, { type: "paren"});
	      return null;
	    }
	    // close paren
	    else if(ch === ")") {
	      popStateStack(state);
	      return null;
	    }
	    // open paren
	    else if(ch === "[") {
	      pushStateStack(state, { type: "bracket"});
	      return null;
	    }
	    // close paren
	    else if(ch === "]") {
	      popStateStack(state);
	      return null;
	    }
	    else {
	      var known = keywords.propertyIsEnumerable(ch) && keywords[ch];
	
	      // if there's a EQName ahead, consume the rest of the string portion, it's likely a function
	      if(isEQName && ch === '\"') while(stream.next() !== '"'){}
	      if(isEQName && ch === '\'') while(stream.next() !== '\''){}
	
	      // gobble up a word if the character is not known
	      if(!known) stream.eatWhile(/[\w\$_-]/);
	
	      // gobble a colon in the case that is a lib func type call fn:doc
	      var foundColon = stream.eat(":");
	
	      // if there's not a second colon, gobble another word. Otherwise, it's probably an axis specifier
	      // which should get matched as a keyword
	      if(!stream.eat(":") && foundColon) {
	        stream.eatWhile(/[\w\$_-]/);
	      }
	      // if the next non whitespace character is an open paren, this is probably a function (if not a keyword of other sort)
	      if(stream.match(/^[ \t]*\(/, false)) {
	        mightBeFunction = true;
	      }
	      // is the word a keyword?
	      var word = stream.current();
	      known = keywords.propertyIsEnumerable(word) && keywords[word];
	
	      // if we think it's a function call but not yet known,
	      // set style to variable for now for lack of something better
	      if(mightBeFunction && !known) known = {type: "function_call", style: "variable def"};
	
	      // if the previous word was element, attribute, axis specifier, this word should be the name of that
	      if(isInXmlConstructor(state)) {
	        popStateStack(state);
	        return "variable";
	      }
	      // as previously checked, if the word is element,attribute, axis specifier, call it an "xmlconstructor" and
	      // push the stack so we know to look for it on the next word
	      if(word == "element" || word == "attribute" || known.type == "axis_specifier") pushStateStack(state, {type: "xmlconstructor"});
	
	      // if the word is known, return the details of that else just call this a generic 'word'
	      return known ? known.style : "variable";
	    }
	  }
	
	  // handle comments, including nested
	  function tokenComment(stream, state) {
	    var maybeEnd = false, maybeNested = false, nestedCount = 0, ch;
	    while (ch = stream.next()) {
	      if (ch == ")" && maybeEnd) {
	        if(nestedCount > 0)
	          nestedCount--;
	        else {
	          popStateStack(state);
	          break;
	        }
	      }
	      else if(ch == ":" && maybeNested) {
	        nestedCount++;
	      }
	      maybeEnd = (ch == ":");
	      maybeNested = (ch == "(");
	    }
	
	    return "comment";
	  }
	
	  // tokenizer for string literals
	  // optionally pass a tokenizer function to set state.tokenize back to when finished
	  function tokenString(quote, f) {
	    return function(stream, state) {
	      var ch;
	
	      if(isInString(state) && stream.current() == quote) {
	        popStateStack(state);
	        if(f) state.tokenize = f;
	        return "string";
	      }
	
	      pushStateStack(state, { type: "string", name: quote, tokenize: tokenString(quote, f) });
	
	      // if we're in a string and in an XML block, allow an embedded code block
	      if(stream.match("{", false) && isInXmlAttributeBlock(state)) {
	        state.tokenize = tokenBase;
	        return "string";
	      }
	
	
	      while (ch = stream.next()) {
	        if (ch ==  quote) {
	          popStateStack(state);
	          if(f) state.tokenize = f;
	          break;
	        }
	        else {
	          // if we're in a string and in an XML block, allow an embedded code block in an attribute
	          if(stream.match("{", false) && isInXmlAttributeBlock(state)) {
	            state.tokenize = tokenBase;
	            return "string";
	          }
	
	        }
	      }
	
	      return "string";
	    };
	  }
	
	  // tokenizer for variables
	  function tokenVariable(stream, state) {
	    var isVariableChar = /[\w\$_-]/;
	
	    // a variable may start with a quoted EQName so if the next character is quote, consume to the next quote
	    if(stream.eat("\"")) {
	      while(stream.next() !== '\"'){};
	      stream.eat(":");
	    } else {
	      stream.eatWhile(isVariableChar);
	      if(!stream.match(":=", false)) stream.eat(":");
	    }
	    stream.eatWhile(isVariableChar);
	    state.tokenize = tokenBase;
	    return "variable";
	  }
	
	  // tokenizer for XML tags
	  function tokenTag(name, isclose) {
	    return function(stream, state) {
	      stream.eatSpace();
	      if(isclose && stream.eat(">")) {
	        popStateStack(state);
	        state.tokenize = tokenBase;
	        return "tag";
	      }
	      // self closing tag without attributes?
	      if(!stream.eat("/"))
	        pushStateStack(state, { type: "tag", name: name, tokenize: tokenBase});
	      if(!stream.eat(">")) {
	        state.tokenize = tokenAttribute;
	        return "tag";
	      }
	      else {
	        state.tokenize = tokenBase;
	      }
	      return "tag";
	    };
	  }
	
	  // tokenizer for XML attributes
	  function tokenAttribute(stream, state) {
	    var ch = stream.next();
	
	    if(ch == "/" && stream.eat(">")) {
	      if(isInXmlAttributeBlock(state)) popStateStack(state);
	      if(isInXmlBlock(state)) popStateStack(state);
	      return "tag";
	    }
	    if(ch == ">") {
	      if(isInXmlAttributeBlock(state)) popStateStack(state);
	      return "tag";
	    }
	    if(ch == "=")
	      return null;
	    // quoted string
	    if (ch == '"' || ch == "'")
	      return chain(stream, state, tokenString(ch, tokenAttribute));
	
	    if(!isInXmlAttributeBlock(state))
	      pushStateStack(state, { type: "attribute", tokenize: tokenAttribute});
	
	    stream.eat(/[a-zA-Z_:]/);
	    stream.eatWhile(/[-a-zA-Z0-9_:.]/);
	    stream.eatSpace();
	
	    // the case where the attribute has not value and the tag was closed
	    if(stream.match(">", false) || stream.match("/", false)) {
	      popStateStack(state);
	      state.tokenize = tokenBase;
	    }
	
	    return "attribute";
	  }
	
	  // handle comments, including nested
	  function tokenXMLComment(stream, state) {
	    var ch;
	    while (ch = stream.next()) {
	      if (ch == "-" && stream.match("->", true)) {
	        state.tokenize = tokenBase;
	        return "comment";
	      }
	    }
	  }
	
	
	  // handle CDATA
	  function tokenCDATA(stream, state) {
	    var ch;
	    while (ch = stream.next()) {
	      if (ch == "]" && stream.match("]", true)) {
	        state.tokenize = tokenBase;
	        return "comment";
	      }
	    }
	  }
	
	  // handle preprocessing instructions
	  function tokenPreProcessing(stream, state) {
	    var ch;
	    while (ch = stream.next()) {
	      if (ch == "?" && stream.match(">", true)) {
	        state.tokenize = tokenBase;
	        return "comment meta";
	      }
	    }
	  }
	
	
	  // functions to test the current context of the state
	  function isInXmlBlock(state) { return isIn(state, "tag"); }
	  function isInXmlAttributeBlock(state) { return isIn(state, "attribute"); }
	  function isInXmlConstructor(state) { return isIn(state, "xmlconstructor"); }
	  function isInString(state) { return isIn(state, "string"); }
	
	  function isEQNameAhead(stream) {
	    // assume we've already eaten a quote (")
	    if(stream.current() === '"')
	      return stream.match(/^[^\"]+\"\:/, false);
	    else if(stream.current() === '\'')
	      return stream.match(/^[^\"]+\'\:/, false);
	    else
	      return false;
	  }
	
	  function isIn(state, type) {
	    return (state.stack.length && state.stack[state.stack.length - 1].type == type);
	  }
	
	  function pushStateStack(state, newState) {
	    state.stack.push(newState);
	  }
	
	  function popStateStack(state) {
	    state.stack.pop();
	    var reinstateTokenize = state.stack.length && state.stack[state.stack.length-1].tokenize;
	    state.tokenize = reinstateTokenize || tokenBase;
	  }
	
	  // the interface for the mode API
	  return {
	    startState: function() {
	      return {
	        tokenize: tokenBase,
	        cc: [],
	        stack: []
	      };
	    },
	
	    token: function(stream, state) {
	      if (stream.eatSpace()) return null;
	      var style = state.tokenize(stream, state);
	      return style;
	    },
	
	    blockCommentStart: "(:",
	    blockCommentEnd: ":)"
	
	  };
	
	});
	
	CodeMirror.defineMIME("application/xquery", "xquery");
	
	});


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// Yacas mode copyright (c) 2015 by Grzegorz Mazur
	// Loosely based on mathematica mode by Calin Barbat
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode('yacas', function(_config, _parserConfig) {
	
	  function words(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	
	  var bodiedOps = words("Assert BackQuote D Defun Deriv For ForEach FromFile " +
	                        "FromString Function Integrate InverseTaylor Limit " +
	                        "LocalSymbols Macro MacroRule MacroRulePattern " +
	                        "NIntegrate Rule RulePattern Subst TD TExplicitSum " +
	                        "TSum Taylor Taylor1 Taylor2 Taylor3 ToFile " +
	                        "ToStdout ToString TraceRule Until While");
	
	  // patterns
	  var pFloatForm  = "(?:(?:\\.\\d+|\\d+\\.\\d*|\\d+)(?:[eE][+-]?\\d+)?)";
	  var pIdentifier = "(?:[a-zA-Z\\$'][a-zA-Z0-9\\$']*)";
	
	  // regular expressions
	  var reFloatForm    = new RegExp(pFloatForm);
	  var reIdentifier   = new RegExp(pIdentifier);
	  var rePattern      = new RegExp(pIdentifier + "?_" + pIdentifier);
	  var reFunctionLike = new RegExp(pIdentifier + "\\s*\\(");
	
	  function tokenBase(stream, state) {
	    var ch;
	
	    // get next character
	    ch = stream.next();
	
	    // string
	    if (ch === '"') {
	      state.tokenize = tokenString;
	      return state.tokenize(stream, state);
	    }
	
	    // comment
	    if (ch === '/') {
	      if (stream.eat('*')) {
	        state.tokenize = tokenComment;
	        return state.tokenize(stream, state);
	      }
	      if (stream.eat("/")) {
	        stream.skipToEnd();
	        return "comment";
	      }
	    }
	
	    // go back one character
	    stream.backUp(1);
	
	    // update scope info
	    var m = stream.match(/^(\w+)\s*\(/, false);
	    if (m !== null && bodiedOps.hasOwnProperty(m[1]))
	      state.scopes.push('bodied');
	
	    var scope = currentScope(state);
	
	    if (scope === 'bodied' && ch === '[')
	      state.scopes.pop();
	
	    if (ch === '[' || ch === '{' || ch === '(')
	      state.scopes.push(ch);
	
	    scope = currentScope(state);
	
	    if (scope === '[' && ch === ']' ||
	        scope === '{' && ch === '}' ||
	        scope === '(' && ch === ')')
	      state.scopes.pop();
	
	    if (ch === ';') {
	      while (scope === 'bodied') {
	        state.scopes.pop();
	        scope = currentScope(state);
	      }
	    }
	
	    // look for ordered rules
	    if (stream.match(/\d+ *#/, true, false)) {
	      return 'qualifier';
	    }
	
	    // look for numbers
	    if (stream.match(reFloatForm, true, false)) {
	      return 'number';
	    }
	
	    // look for placeholders
	    if (stream.match(rePattern, true, false)) {
	      return 'variable-3';
	    }
	
	    // match all braces separately
	    if (stream.match(/(?:\[|\]|{|}|\(|\))/, true, false)) {
	      return 'bracket';
	    }
	
	    // literals looking like function calls
	    if (stream.match(reFunctionLike, true, false)) {
	      stream.backUp(1);
	      return 'variable';
	    }
	
	    // all other identifiers
	    if (stream.match(reIdentifier, true, false)) {
	      return 'variable-2';
	    }
	
	    // operators; note that operators like @@ or /; are matched separately for each symbol.
	    if (stream.match(/(?:\\|\+|\-|\*|\/|,|;|\.|:|@|~|=|>|<|&|\||_|`|'|\^|\?|!|%)/, true, false)) {
	      return 'operator';
	    }
	
	    // everything else is an error
	    return 'error';
	  }
	
	  function tokenString(stream, state) {
	    var next, end = false, escaped = false;
	    while ((next = stream.next()) != null) {
	      if (next === '"' && !escaped) {
	        end = true;
	        break;
	      }
	      escaped = !escaped && next === '\\';
	    }
	    if (end && !escaped) {
	      state.tokenize = tokenBase;
	    }
	    return 'string';
	  };
	
	  function tokenComment(stream, state) {
	    var prev, next;
	    while((next = stream.next()) != null) {
	      if (prev === '*' && next === '/') {
	        state.tokenize = tokenBase;
	        break;
	      }
	      prev = next;
	    }
	    return 'comment';
	  }
	
	  function currentScope(state) {
	    var scope = null;
	    if (state.scopes.length > 0)
	      scope = state.scopes[state.scopes.length - 1];
	    return scope;
	  }
	
	  return {
	    startState: function() {
	      return {
	        tokenize: tokenBase,
	        scopes: []
	      };
	    },
	    token: function(stream, state) {
	      if (stream.eatSpace()) return null;
	      return state.tokenize(stream, state);
	    },
	    indent: function(state, textAfter) {
	      if (state.tokenize !== tokenBase && state.tokenize !== null)
	        return CodeMirror.Pass;
	
	      var delta = 0;
	      if (textAfter === ']' || textAfter === '];' ||
	          textAfter === '}' || textAfter === '};' ||
	          textAfter === ');')
	        delta = -1;
	
	      return (state.scopes.length + delta) * _config.indentUnit;
	    },
	    electricChars: "{}[]();",
	    blockCommentStart: "/*",
	    blockCommentEnd: "*/",
	    lineComment: "//"
	  };
	});
	
	CodeMirror.defineMIME('text/x-yacas', {
	  name: 'yacas'
	});
	
	});


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function (mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(2), __webpack_require__(89))
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../yaml/yaml"], mod)
	  else // Plain browser env
	    mod(CodeMirror)
	})(function (CodeMirror) {
	
	  var START = 0, FRONTMATTER = 1, BODY = 2
	
	  // a mixed mode for Markdown text with an optional YAML front matter
	  CodeMirror.defineMode("yaml-frontmatter", function (config, parserConfig) {
	    var yamlMode = CodeMirror.getMode(config, "yaml")
	    var innerMode = CodeMirror.getMode(config, parserConfig && parserConfig.base || "gfm")
	
	    function curMode(state) {
	      return state.state == BODY ? innerMode : yamlMode
	    }
	
	    return {
	      startState: function () {
	        return {
	          state: START,
	          inner: CodeMirror.startState(yamlMode)
	        }
	      },
	      copyState: function (state) {
	        return {
	          state: state.state,
	          inner: CodeMirror.copyState(curMode(state), state.inner)
	        }
	      },
	      token: function (stream, state) {
	        if (state.state == START) {
	          if (stream.match(/---/, false)) {
	            state.state = FRONTMATTER
	            return yamlMode.token(stream, state.inner)
	          } else {
	            state.state = BODY
	            state.inner = CodeMirror.startState(innerMode)
	            return innerMode.token(stream, state.inner)
	          }
	        } else if (state.state == FRONTMATTER) {
	          var end = stream.sol() && stream.match(/---/, false)
	          var style = yamlMode.token(stream, state.inner)
	          if (end) {
	            state.state = BODY
	            state.inner = CodeMirror.startState(innerMode)
	          }
	          return style
	        } else {
	          return innerMode.token(stream, state.inner)
	        }
	      },
	      innerMode: function (state) {
	        return {mode: curMode(state), state: state.inner}
	      },
	      blankLine: function (state) {
	        var mode = curMode(state)
	        if (mode.blankLine) return mode.blankLine(state.inner)
	      }
	    }
	  })
	});


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	  mod(__webpack_require__(2));
	  else if (typeof define == "function" && define.amd) // AMD
	  define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	  mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode('z80', function(_config, parserConfig) {
	  var ez80 = parserConfig.ez80;
	  var keywords1, keywords2;
	  if (ez80) {
	    keywords1 = /^(exx?|(ld|cp)([di]r?)?|[lp]ea|pop|push|ad[cd]|cpl|daa|dec|inc|neg|sbc|sub|and|bit|[cs]cf|x?or|res|set|r[lr]c?a?|r[lr]d|s[lr]a|srl|djnz|nop|[de]i|halt|im|in([di]mr?|ir?|irx|2r?)|ot(dmr?|[id]rx|imr?)|out(0?|[di]r?|[di]2r?)|tst(io)?|slp)(\.([sl]?i)?[sl])?\b/i;
	    keywords2 = /^(((call|j[pr]|rst|ret[in]?)(\.([sl]?i)?[sl])?)|(rs|st)mix)\b/i;
	  } else {
	    keywords1 = /^(exx?|(ld|cp|in)([di]r?)?|pop|push|ad[cd]|cpl|daa|dec|inc|neg|sbc|sub|and|bit|[cs]cf|x?or|res|set|r[lr]c?a?|r[lr]d|s[lr]a|srl|djnz|nop|rst|[de]i|halt|im|ot[di]r|out[di]?)\b/i;
	    keywords2 = /^(call|j[pr]|ret[in]?|b_?(call|jump))\b/i;
	  }
	
	  var variables1 = /^(af?|bc?|c|de?|e|hl?|l|i[xy]?|r|sp)\b/i;
	  var variables2 = /^(n?[zc]|p[oe]?|m)\b/i;
	  var errors = /^([hl][xy]|i[xy][hl]|slia|sll)\b/i;
	  var numbers = /^([\da-f]+h|[0-7]+o|[01]+b|\d+d?)\b/i;
	
	  return {
	    startState: function() {
	      return {
	        context: 0
	      };
	    },
	    token: function(stream, state) {
	      if (!stream.column())
	        state.context = 0;
	
	      if (stream.eatSpace())
	        return null;
	
	      var w;
	
	      if (stream.eatWhile(/\w/)) {
	        if (ez80 && stream.eat('.')) {
	          stream.eatWhile(/\w/);
	        }
	        w = stream.current();
	
	        if (stream.indentation()) {
	          if ((state.context == 1 || state.context == 4) && variables1.test(w)) {
	            state.context = 4;
	            return 'var2';
	          }
	
	          if (state.context == 2 && variables2.test(w)) {
	            state.context = 4;
	            return 'var3';
	          }
	
	          if (keywords1.test(w)) {
	            state.context = 1;
	            return 'keyword';
	          } else if (keywords2.test(w)) {
	            state.context = 2;
	            return 'keyword';
	          } else if (state.context == 4 && numbers.test(w)) {
	            return 'number';
	          }
	
	          if (errors.test(w))
	            return 'error';
	        } else if (stream.match(numbers)) {
	          return 'number';
	        } else {
	          return null;
	        }
	      } else if (stream.eat(';')) {
	        stream.skipToEnd();
	        return 'comment';
	      } else if (stream.eat('"')) {
	        while (w = stream.next()) {
	          if (w == '"')
	            break;
	
	          if (w == '\\')
	            stream.next();
	        }
	        return 'string';
	      } else if (stream.eat('\'')) {
	        if (stream.match(/\\?.'/))
	          return 'number';
	      } else if (stream.eat('.') || stream.sol() && stream.eat('#')) {
	        state.context = 5;
	
	        if (stream.eatWhile(/\w/))
	          return 'def';
	      } else if (stream.eat('$')) {
	        if (stream.eatWhile(/[\da-f]/i))
	          return 'number';
	      } else if (stream.eat('%')) {
	        if (stream.eatWhile(/[01]/))
	          return 'number';
	      } else {
	        stream.next();
	      }
	      return null;
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/x-z80", "z80");
	CodeMirror.defineMIME("text/x-ez80", { name: "z80", ez80: true });
	
	});


/***/ },
/* 254 */,
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var core  = __webpack_require__(28)
	  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
	module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(281);
	__webpack_require__(279);
	__webpack_require__(282);
	__webpack_require__(283);
	module.exports = __webpack_require__(28).Symbol;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(280);
	__webpack_require__(284);
	module.exports = __webpack_require__(58).f('iterator');

/***/ },
/* 258 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 259 */
/***/ function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(10)
	  , toLength  = __webpack_require__(276)
	  , toIndex   = __webpack_require__(275);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(258);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(31)
	  , gOPS    = __webpack_require__(97)
	  , pIE     = __webpack_require__(51);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(7).document && document.documentElement;

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(90);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(90);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(95)
	  , descriptor     = __webpack_require__(32)
	  , setToStringTag = __webpack_require__(52)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(14)(IteratorPrototype, __webpack_require__(16)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 267 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(31)
	  , toIObject = __webpack_require__(10);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(33)('meta')
	  , isObject = __webpack_require__(30)
	  , has      = __webpack_require__(9)
	  , setDesc  = __webpack_require__(15).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(29)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(15)
	  , anObject = __webpack_require__(27)
	  , getKeys  = __webpack_require__(31);
	
	module.exports = __webpack_require__(13) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(51)
	  , createDesc     = __webpack_require__(32)
	  , toIObject      = __webpack_require__(10)
	  , toPrimitive    = __webpack_require__(56)
	  , has            = __webpack_require__(9)
	  , IE8_DOM_DEFINE = __webpack_require__(93)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(13) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(10)
	  , gOPN      = __webpack_require__(96).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(9)
	  , toObject    = __webpack_require__(277)
	  , IE_PROTO    = __webpack_require__(53)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(55)
	  , defined   = __webpack_require__(47);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(55)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(55)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(47);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(259)
	  , step             = __webpack_require__(267)
	  , Iterators        = __webpack_require__(49)
	  , toIObject        = __webpack_require__(10);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(94)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 279 */
/***/ function(module, exports) {



/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(274)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(94)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(7)
	  , has            = __webpack_require__(9)
	  , DESCRIPTORS    = __webpack_require__(13)
	  , $export        = __webpack_require__(92)
	  , redefine       = __webpack_require__(99)
	  , META           = __webpack_require__(269).KEY
	  , $fails         = __webpack_require__(29)
	  , shared         = __webpack_require__(54)
	  , setToStringTag = __webpack_require__(52)
	  , uid            = __webpack_require__(33)
	  , wks            = __webpack_require__(16)
	  , wksExt         = __webpack_require__(58)
	  , wksDefine      = __webpack_require__(57)
	  , keyOf          = __webpack_require__(268)
	  , enumKeys       = __webpack_require__(262)
	  , isArray        = __webpack_require__(265)
	  , anObject       = __webpack_require__(27)
	  , toIObject      = __webpack_require__(10)
	  , toPrimitive    = __webpack_require__(56)
	  , createDesc     = __webpack_require__(32)
	  , _create        = __webpack_require__(95)
	  , gOPNExt        = __webpack_require__(272)
	  , $GOPD          = __webpack_require__(271)
	  , $DP            = __webpack_require__(15)
	  , $keys          = __webpack_require__(31)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(96).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(51).f  = $propertyIsEnumerable;
	  __webpack_require__(97).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(50)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(14)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(57)('asyncIterator');

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(57)('observable');

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(278);
	var global        = __webpack_require__(7)
	  , hide          = __webpack_require__(14)
	  , Iterators     = __webpack_require__(49)
	  , TO_STRING_TAG = __webpack_require__(16)('toStringTag');
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype;
	  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(100)
	
	var zeroBuffer = new Buffer(128)
	zeroBuffer.fill(0)
	
	module.exports = Hmac
	
	function Hmac (alg, key) {
	  if(!(this instanceof Hmac)) return new Hmac(alg, key)
	  this._opad = opad
	  this._alg = alg
	
	  var blocksize = (alg === 'sha512') ? 128 : 64
	
	  key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key
	
	  if(key.length > blocksize) {
	    key = createHash(alg).update(key).digest()
	  } else if(key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize)
	  }
	
	  var ipad = this._ipad = new Buffer(blocksize)
	  var opad = this._opad = new Buffer(blocksize)
	
	  for(var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  this._hash = createHash(alg).update(ipad)
	}
	
	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc)
	  return this
	}
	
	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest()
	  return createHash(this._alg).update(this._opad).update(h).digest(enc)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;
	
	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}
	
	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}
	
	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}
	
	module.exports = { hash: hash };
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var rng = __webpack_require__(290)
	
	function error () {
	  var m = [].slice.call(arguments).join(' ')
	  throw new Error([
	    m,
	    'we accept pull requests',
	    'http://github.com/dominictarr/crypto-browserify'
	    ].join('\n'))
	}
	
	exports.createHash = __webpack_require__(100)
	
	exports.createHmac = __webpack_require__(285)
	
	exports.randomBytes = function(size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)))
	    } catch (err) { callback(err) }
	  } else {
	    return new Buffer(rng(size))
	  }
	}
	
	function each(a, f) {
	  for(var i in a)
	    f(a[i], i)
	}
	
	exports.getHashes = function () {
	  return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160']
	}
	
	var p = __webpack_require__(289)(exports)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	__webpack_require__(123)(exports, module.exports);
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials'
	, 'createSign'
	, 'createVerify'
	, 'createDiffieHellman'
	], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet')
	  }
	})
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var helpers = __webpack_require__(286);
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;
	
	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
	
	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	var pbkdf2Export = __webpack_require__(1343)
	
	module.exports = function (crypto, exports) {
	  exports = exports || {}
	
	  var exported = pbkdf2Export(crypto)
	
	  exports.pbkdf2 = exported.pbkdf2
	  exports.pbkdf2Sync = exported.pbkdf2Sync
	
	  return exports
	}


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function() {
	  var g = ('undefined' === typeof window ? global : window) || {}
	  _crypto = (
	    g.crypto || g.msCrypto || __webpack_require__(1374)
	  )
	  module.exports = function(size) {
	    // Modern Browsers
	    if(_crypto.getRandomValues) {
	      var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
	      /* This will not work in older browsers.
	       * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	       */
	    
	      _crypto.getRandomValues(bytes);
	      return bytes;
	    }
	    else if (_crypto.randomBytes) {
	      return _crypto.randomBytes(size)
	    }
	    else
	      throw new Error(
	        'secure random number generation not supported by this browser\n'+
	        'use chrome, FireFox or Internet Explorer 11'
	      )
	  }
	}())
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(3).Buffer))

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * @description Recursive object extending
	 * @author Viacheslav Lotsmanov <lotsmanov89@gmail.com>
	 * @license MIT
	 *
	 * The MIT License (MIT)
	 *
	 * Copyright (c) 2013-2015 Viacheslav Lotsmanov
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of
	 * this software and associated documentation files (the "Software"), to deal in
	 * the Software without restriction, including without limitation the rights to
	 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
	 * the Software, and to permit persons to whom the Software is furnished to do so,
	 * subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
	 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
	 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
	 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	
	'use strict';
	
	function isSpecificValue(val) {
		return (
			val instanceof Buffer
			|| val instanceof Date
			|| val instanceof RegExp
		) ? true : false;
	}
	
	function cloneSpecificValue(val) {
		if (val instanceof Buffer) {
			var x = new Buffer(val.length);
			val.copy(x);
			return x;
		} else if (val instanceof Date) {
			return new Date(val.getTime());
		} else if (val instanceof RegExp) {
			return new RegExp(val);
		} else {
			throw new Error('Unexpected situation');
		}
	}
	
	/**
	 * Recursive cloning array.
	 */
	function deepCloneArray(arr) {
		var clone = [];
		arr.forEach(function (item, index) {
			if (typeof item === 'object' && item !== null) {
				if (Array.isArray(item)) {
					clone[index] = deepCloneArray(item);
				} else if (isSpecificValue(item)) {
					clone[index] = cloneSpecificValue(item);
				} else {
					clone[index] = deepExtend({}, item);
				}
			} else {
				clone[index] = item;
			}
		});
		return clone;
	}
	
	/**
	 * Extening object that entered in first argument.
	 *
	 * Returns extended object or false if have no target object or incorrect type.
	 *
	 * If you wish to clone source object (without modify it), just use empty new
	 * object as first argument, like this:
	 *   deepExtend({}, yourObj_1, [yourObj_N]);
	 */
	var deepExtend = module.exports = function (/*obj_1, [obj_2], [obj_N]*/) {
		if (arguments.length < 1 || typeof arguments[0] !== 'object') {
			return false;
		}
	
		if (arguments.length < 2) {
			return arguments[0];
		}
	
		var target = arguments[0];
	
		// convert arguments to array and cut off target object
		var args = Array.prototype.slice.call(arguments, 1);
	
		var val, src, clone;
	
		args.forEach(function (obj) {
			// skip argument if it is array or isn't object
			if (typeof obj !== 'object' || Array.isArray(obj)) {
				return;
			}
	
			Object.keys(obj).forEach(function (key) {
				src = target[key]; // source value
				val = obj[key]; // new value
	
				// recursion prevention
				if (val === target) {
					return;
	
				/**
				 * if new value isn't object then just overwrite by new value
				 * instead of extending.
				 */
				} else if (typeof val !== 'object' || val === null) {
					target[key] = val;
					return;
	
				// just clone arrays (and recursive clone objects inside)
				} else if (Array.isArray(val)) {
					target[key] = deepCloneArray(val);
					return;
	
				// custom cloning and overwrite for specific objects
				} else if (isSpecificValue(val)) {
					target[key] = cloneSpecificValue(val);
					return;
	
				// overwrite by new value if source isn't object or array
				} else if (typeof src !== 'object' || src === null || Array.isArray(src)) {
					target[key] = deepExtend({}, val);
					return;
	
				// source value and new value is objects both, extending...
				} else {
					target[key] = deepExtend(src, val);
					return;
				}
			});
		});
	
		return target;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ },
/* 292 */
/***/ function(module, exports) {

	var DOCUMENT_NODE_TYPE = 9;
	
	/**
	 * A polyfill for Element.matches()
	 */
	if (Element && !Element.prototype.matches) {
	    var proto = Element.prototype;
	
	    proto.matches = proto.matchesSelector ||
	                    proto.mozMatchesSelector ||
	                    proto.msMatchesSelector ||
	                    proto.oMatchesSelector ||
	                    proto.webkitMatchesSelector;
	}
	
	/**
	 * Finds the closest parent that matches a selector.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @return {Function}
	 */
	function closest (element, selector) {
	    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
	        if (element.matches(selector)) return element;
	        element = element.parentNode;
	    }
	}
	
	module.exports = closest;


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	var closest = __webpack_require__(292);
	
	/**
	 * Delegates event to a selector.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @param {Boolean} useCapture
	 * @return {Object}
	 */
	function delegate(element, selector, type, callback, useCapture) {
	    var listenerFn = listener.apply(this, arguments);
	
	    element.addEventListener(type, listenerFn, useCapture);
	
	    return {
	        destroy: function() {
	            element.removeEventListener(type, listenerFn, useCapture);
	        }
	    }
	}
	
	/**
	 * Finds closest match and invokes callback.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Function}
	 */
	function listener(element, selector, type, callback) {
	    return function(e) {
	        e.delegateTarget = closest(e.target, selector);
	
	        if (e.delegateTarget) {
	            callback.call(element, e);
	        }
	    }
	}
	
	module.exports = delegate;


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(34);
	
	$.findByRef = __webpack_require__(101);
	$.resolveSchema = __webpack_require__(297);
	$.normalizeSchema = __webpack_require__(296);
	
	var instance = module.exports = function() {
	  function $ref(fakeroot, schema, refs, ex) {
	    if (typeof fakeroot === 'object') {
	      ex = refs;
	      refs = schema;
	      schema = fakeroot;
	      fakeroot = undefined;
	    }
	
	    if (typeof schema !== 'object') {
	      throw new Error('schema must be an object');
	    }
	
	    if (typeof refs === 'object' && refs !== null) {
	      var aux = refs;
	
	      refs = [];
	
	      for (var k in aux) {
	        aux[k].id = aux[k].id || k;
	        refs.push(aux[k]);
	      }
	    }
	
	    if (typeof refs !== 'undefined' && !Array.isArray(refs)) {
	      ex = !!refs;
	      refs = [];
	    }
	
	    function push(ref) {
	      if (typeof ref.id === 'string') {
	        var id = $.resolveURL(fakeroot, ref.id).replace(/\/#?$/, '');
	
	        if (id.indexOf('#') > -1) {
	          var parts = id.split('#');
	
	          if (parts[1].charAt() === '/') {
	            id = parts[0];
	          } else {
	            id = parts[1] || parts[0];
	          }
	        }
	
	        if (!$ref.refs[id]) {
	          $ref.refs[id] = ref;
	        }
	      }
	    }
	
	    (refs || []).concat([schema]).forEach(function(ref) {
	      schema = $.normalizeSchema(fakeroot, ref, push);
	      push(schema);
	    });
	
	    return $.resolveSchema(schema, $ref.refs, ex);
	  }
	
	  $ref.refs = {};
	  $ref.util = $;
	
	  return $ref;
	};
	
	instance.util = $;


/***/ },
/* 295 */
/***/ function(module, exports) {

	'use strict';
	
	var clone = module.exports = function(obj, seen) {
	  seen = seen || [];
	
	  if (seen.indexOf(obj) > -1) {
	    throw new Error('unable dereference circular structures');
	  }
	
	  if (!obj || typeof obj !== 'object') {
	    return obj;
	  }
	
	  seen = seen.concat([obj]);
	
	  var target = Array.isArray(obj) ? [] : {};
	
	  function copy(key, value) {
	    target[key] = clone(value, seen);
	  }
	
	  if (Array.isArray(target)) {
	    obj.forEach(function(value, key) {
	      copy(key, value);
	    });
	  } else if (Object.prototype.toString.call(obj) === '[object Object]') {
	    Object.keys(obj).forEach(function(key) {
	      copy(key, obj[key]);
	    });
	  }
	
	  return target;
	};


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(34);
	
	var cloneObj = __webpack_require__(295);
	
	var SCHEMA_URI = [
	  'http://json-schema.org/schema#',
	  'http://json-schema.org/draft-04/schema#'
	];
	
	function expand(obj, parent, callback) {
	  if (obj) {
	    var id = typeof obj.id === 'string' ? obj.id : '#';
	
	    if (!$.isURL(id)) {
	      id = $.resolveURL(parent === id ? null : parent, id);
	    }
	
	    if (typeof obj.$ref === 'string' && !$.isURL(obj.$ref)) {
	      obj.$ref = $.resolveURL(id, obj.$ref);
	    }
	
	    if (typeof obj.id === 'string') {
	      obj.id = parent = id;
	    }
	  }
	
	  for (var key in obj) {
	    var value = obj[key];
	
	    if (typeof value === 'object' && value !== null && !$.isKeyword(key)) {
	      expand(value, parent, callback);
	    }
	  }
	
	  if (typeof callback === 'function') {
	    callback(obj);
	  }
	}
	
	module.exports = function(fakeroot, schema, push) {
	  if (typeof fakeroot === 'object') {
	    push = schema;
	    schema = fakeroot;
	    fakeroot = null;
	  }
	
	  var base = fakeroot || '',
	      copy = cloneObj(schema);
	
	  if (copy.$schema && SCHEMA_URI.indexOf(copy.$schema) === -1) {
	    throw new Error('Unsupported schema version (v4 only)');
	  }
	
	  base = $.resolveURL(copy.$schema || SCHEMA_URI[0], base);
	
	  expand(copy, $.resolveURL(copy.id || '#', base), push);
	
	  copy.id = copy.id || base;
	
	  return copy;
	};


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(34);
	
	var find = __webpack_require__(101);
	
	var deepExtend = __webpack_require__(291);
	
	function copy(obj, refs, parent, resolve) {
	  var target =  Array.isArray(obj) ? [] : {};
	
	  if (typeof obj.$ref === 'string') {
	    var base = $.getDocumentURI(obj.$ref);
	
	    if (parent !== base || (resolve && obj.$ref.indexOf('#/') > -1)) {
	      var fixed = find(obj.$ref, refs);
	
	      deepExtend(obj, fixed);
	
	      delete obj.$ref;
	      delete obj.id;
	    }
	  }
	
	  for (var prop in obj) {
	    if (typeof obj[prop] === 'object' && obj[prop] !== null && !$.isKeyword(prop)) {
	      target[prop] = copy(obj[prop], refs, parent, resolve);
	    } else {
	      target[prop] = obj[prop];
	    }
	  }
	
	  return target;
	}
	
	module.exports = function(obj, refs, resolve) {
	  var fixedId = $.resolveURL(obj.$schema, obj.id),
	      parent = $.getDocumentURI(fixedId);
	
	  return copy(obj, refs, parent, resolve);
	};


/***/ },
/* 298 */
/***/ function(module, exports) {

	//protected helper class
	function _SubRange(low, high) {
	    this.low = low;
	    this.high = high;
	    this.length = 1 + high - low;
	}
	
	_SubRange.prototype.overlaps = function (range) {
	    return !(this.high < range.low || this.low > range.high);
	};
	
	_SubRange.prototype.touches = function (range) {
	    return !(this.high + 1 < range.low || this.low - 1 > range.high);
	};
	
	//returns inclusive combination of _SubRanges as a _SubRange
	_SubRange.prototype.add = function (range) {
	    return this.touches(range) && new _SubRange(Math.min(this.low, range.low), Math.max(this.high, range.high));
	};
	
	//returns subtraction of _SubRanges as an array of _SubRanges (there's a case where subtraction divides it in 2)
	_SubRange.prototype.subtract = function (range) {
	    if (!this.overlaps(range)) return false;
	    if (range.low <= this.low && range.high >= this.high) return [];
	    if (range.low > this.low && range.high < this.high) return [new _SubRange(this.low, range.low - 1), new _SubRange(range.high + 1, this.high)];
	    if (range.low <= this.low) return [new _SubRange(range.high + 1, this.high)];
	    return [new _SubRange(this.low, range.low - 1)];
	};
	
	_SubRange.prototype.toString = function () {
	    if (this.low == this.high) return this.low.toString();
	    return this.low + '-' + this.high;
	};
	
	_SubRange.prototype.clone = function () {
	    return new _SubRange(this.low, this.high);
	};
	
	
	
	
	function DiscontinuousRange(a, b) {
	    if (this instanceof DiscontinuousRange) {
	        this.ranges = [];
	        this.length = 0;
	        if (a !== undefined) this.add(a, b);
	    } else {
	        return new DiscontinuousRange(a, b);
	    }
	}
	
	function _update_length(self) {
	    self.length = self.ranges.reduce(function (previous, range) {return previous + range.length}, 0);
	}
	
	DiscontinuousRange.prototype.add = function (a, b) {
	    var self = this;
	    function _add(subrange) {
	        var new_ranges = [];
	        var i = 0;
	        while (i < self.ranges.length && !subrange.touches(self.ranges[i])) {
	            new_ranges.push(self.ranges[i].clone());
	            i++;
	        }
	        while (i < self.ranges.length && subrange.touches(self.ranges[i])) {
	            subrange = subrange.add(self.ranges[i]);
	            i++;
	        }
	        new_ranges.push(subrange);
	        while (i < self.ranges.length) {
	            new_ranges.push(self.ranges[i].clone());
	            i++;
	        }
	        self.ranges = new_ranges;
	        _update_length(self);
	    }
	
	    if (a instanceof DiscontinuousRange) {
	        a.ranges.forEach(_add);
	    } else {
	        if (a instanceof _SubRange) {
	            _add(a);
	        } else {
	            if (b === undefined) b = a;
	            _add(new _SubRange(a, b));
	        }
	    }
	    return this;
	};
	
	DiscontinuousRange.prototype.subtract = function (a, b) {
	    var self = this;
	    function _subtract(subrange) {
	        var new_ranges = [];
	        var i = 0;
	        while (i < self.ranges.length && !subrange.overlaps(self.ranges[i])) {
	            new_ranges.push(self.ranges[i].clone());
	            i++;
	        }
	        while (i < self.ranges.length && subrange.overlaps(self.ranges[i])) {
	            new_ranges = new_ranges.concat(self.ranges[i].subtract(subrange));
	            i++;
	        }
	        while (i < self.ranges.length) {
	            new_ranges.push(self.ranges[i].clone());
	            i++;
	        }
	        self.ranges = new_ranges;
	        _update_length(self);
	    }
	    if (a instanceof DiscontinuousRange) {
	        a.ranges.forEach(_subtract);
	    } else {
	        if (a instanceof _SubRange) {
	            _subtract(a);
	        } else {
	            if (b === undefined) b = a;
	            _subtract(new _SubRange(a, b));
	        }
	    }
	    return this;
	};
	
	
	DiscontinuousRange.prototype.index = function (index) {
	    var i = 0;
	    while (i < this.ranges.length && this.ranges[i].length <= index) {
	        index -= this.ranges[i].length;
	        i++;
	    }
	    if (i >= this.ranges.length) return null;
	    return this.ranges[i].low + index;
	};
	
	
	DiscontinuousRange.prototype.toString = function () {
	    return '[ ' + this.ranges.join(', ') + ' ]'
	};
	
	DiscontinuousRange.prototype.clone = function () {
	    return new DiscontinuousRange(this);
	};
	
	module.exports = DiscontinuousRange;


/***/ },
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// since we are requiring the top level of faker, load all locales by default
	var Faker = __webpack_require__(365);
	var faker = new Faker({ locales: __webpack_require__(367) });
	module['exports'] = faker;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 356 */
/***/ function(module, exports) {

	/**
	 *
	 * @namespace faker.address
	 */
	function Address (faker) {
	  var f = faker.fake,
	      Helpers = faker.helpers;
	
	  /**
	   * Generates random zipcode from format. If format is not specified, the
	   * locale's zip format is used.
	   *
	   * @method faker.address.zipCode
	   * @param {String} format
	   */
	  this.zipCode = function(format) {
	    // if zip format is not specified, use the zip format defined for the locale
	    if (typeof format === 'undefined') {
	      var localeFormat = faker.definitions.address.postcode;
	      if (typeof localeFormat === 'string') {
	        format = localeFormat;
	      } else {
	        format = faker.random.arrayElement(localeFormat);
	      }
	    }
	    return Helpers.replaceSymbols(format);
	  }
	
	  /**
	   * Generates a random localized city name. The format string can contain any
	   * method provided by faker wrapped in `{{}}`, e.g. `{{name.firstName}}` in
	   * order to build the city name.
	   *
	   * If no format string is provided one of the following is randomly used:
	   * 
	   * * `{{address.cityPrefix}} {{name.firstName}}{{address.citySuffix}}`
	   * * `{{address.cityPrefix}} {{name.firstName}}`
	   * * `{{name.firstName}}{{address.citySuffix}}`
	   * * `{{name.lastName}}{{address.citySuffix}}`
	   *
	   * @method faker.address.city
	   * @param {String} format
	   */
	  this.city = function (format) {
	    var formats = [
	      '{{address.cityPrefix}} {{name.firstName}}{{address.citySuffix}}',
	      '{{address.cityPrefix}} {{name.firstName}}',
	      '{{name.firstName}}{{address.citySuffix}}',
	      '{{name.lastName}}{{address.citySuffix}}'
	    ];
	
	    if (typeof format !== "number") {
	      format = faker.random.number(formats.length - 1);
	    }
	
	    return f(formats[format]);
	
	  }
	
	  /**
	   * Return a random localized city prefix
	   * @method faker.address.cityPrefix
	   */
	  this.cityPrefix = function () {
	    return faker.random.arrayElement(faker.definitions.address.city_prefix);
	  }
	
	  /**
	   * Return a random localized city suffix
	   *
	   * @method faker.address.citySuffix
	   */
	  this.citySuffix = function () {
	    return faker.random.arrayElement(faker.definitions.address.city_suffix);
	  }
	
	  /**
	   * Returns a random localized street name
	   *
	   * @method faker.address.streetName
	   */
	  this.streetName = function () {
	      var result;
	      var suffix = faker.address.streetSuffix();
	      if (suffix !== "") {
	          suffix = " " + suffix
	      }
	
	      switch (faker.random.number(1)) {
	      case 0:
	          result = faker.name.lastName() + suffix;
	          break;
	      case 1:
	          result = faker.name.firstName() + suffix;
	          break;
	      }
	      return result;
	  }
	
	  //
	  // TODO: change all these methods that accept a boolean to instead accept an options hash.
	  //
	  /**
	   * Returns a random localized street address
	   *
	   * @method faker.address.streetAddress
	   * @param {Boolean} useFullAddress
	   */
	  this.streetAddress = function (useFullAddress) {
	      if (useFullAddress === undefined) { useFullAddress = false; }
	      var address = "";
	      switch (faker.random.number(2)) {
	      case 0:
	          address = Helpers.replaceSymbolWithNumber("#####") + " " + faker.address.streetName();
	          break;
	      case 1:
	          address = Helpers.replaceSymbolWithNumber("####") +  " " + faker.address.streetName();
	          break;
	      case 2:
	          address = Helpers.replaceSymbolWithNumber("###") + " " + faker.address.streetName();
	          break;
	      }
	      return useFullAddress ? (address + " " + faker.address.secondaryAddress()) : address;
	  }
	
	  /**
	   * streetSuffix
	   *
	   * @method faker.address.streetSuffix
	   */
	  this.streetSuffix = function () {
	      return faker.random.arrayElement(faker.definitions.address.street_suffix);
	  }
	  
	  /**
	   * streetPrefix
	   *
	   * @method faker.address.streetPrefix
	   */
	  this.streetPrefix = function () {
	      return faker.random.arrayElement(faker.definitions.address.street_prefix);
	  }
	
	  /**
	   * secondaryAddress
	   *
	   * @method faker.address.secondaryAddress
	   */
	  this.secondaryAddress = function () {
	      return Helpers.replaceSymbolWithNumber(faker.random.arrayElement(
	          [
	              'Apt. ###',
	              'Suite ###'
	          ]
	      ));
	  }
	
	  /**
	   * county
	   *
	   * @method faker.address.county
	   */
	  this.county = function () {
	    return faker.random.arrayElement(faker.definitions.address.county);
	  }
	
	  /**
	   * country
	   *
	   * @method faker.address.country
	   */
	  this.country = function () {
	    return faker.random.arrayElement(faker.definitions.address.country);
	  }
	
	  /**
	   * countryCode
	   *
	   * @method faker.address.countryCode
	   */
	  this.countryCode = function () {
	    return faker.random.arrayElement(faker.definitions.address.country_code);
	  }
	
	  /**
	   * state
	   *
	   * @method faker.address.state
	   * @param {Boolean} useAbbr
	   */
	  this.state = function (useAbbr) {
	      return faker.random.arrayElement(faker.definitions.address.state);
	  }
	
	  /**
	   * stateAbbr
	   *
	   * @method faker.address.stateAbbr
	   */
	  this.stateAbbr = function () {
	      return faker.random.arrayElement(faker.definitions.address.state_abbr);
	  }
	
	  /**
	   * latitude
	   *
	   * @method faker.address.latitude
	   */
	  this.latitude = function () {
	      return (faker.random.number(180 * 10000) / 10000.0 - 90.0).toFixed(4);
	  }
	
	  /**
	   * longitude
	   *
	   * @method faker.address.longitude
	   */
	  this.longitude = function () {
	      return (faker.random.number(360 * 10000) / 10000.0 - 180.0).toFixed(4);
	  }
	  
	  return this;
	}
	
	
	module.exports = Address;


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.commerce
	 */
	var Commerce = function (faker) {
	  var self = this;
	
	  /**
	   * color
	   *
	   * @method faker.commerce.color
	   */
	  self.color = function() {
	      return faker.random.arrayElement(faker.definitions.commerce.color);
	  };
	
	  /**
	   * department
	   *
	   * @method faker.commerce.department
	   * @param {number} max
	   * @param {number} fixedAmount
	   */
	  self.department = function(max, fixedAmount) {
	      return faker.random.arrayElement(faker.definitions.commerce.department);
	  };
	
	  /**
	   * productName
	   *
	   * @method faker.commerce.productName
	   */
	  self.productName = function() {
	      return faker.commerce.productAdjective() + " " +
	              faker.commerce.productMaterial() + " " +
	              faker.commerce.product();
	  };
	
	  /**
	   * price
	   *
	   * @method faker.commerce.price
	   * @param {number} min
	   * @param {number} max
	   * @param {number} dec
	   * @param {string} symbol
	   */
	  self.price = function(min, max, dec, symbol) {
	      min = min || 0;
	      max = max || 1000;
	      dec = dec || 2;
	      symbol = symbol || '';
	
	      if(min < 0 || max < 0) {
	          return symbol + 0.00;
	      }
	
	      var randValue = faker.random.number({ max: max, min: min });
	
	      return symbol + (Math.round(randValue * Math.pow(10, dec)) / Math.pow(10, dec)).toFixed(dec);
	  };
	
	  /*
	  self.categories = function(num) {
	      var categories = [];
	
	      do {
	          var category = faker.random.arrayElement(faker.definitions.commerce.department);
	          if(categories.indexOf(category) === -1) {
	              categories.push(category);
	          }
	      } while(categories.length < num);
	
	      return categories;
	  };
	
	  */
	  /*
	  self.mergeCategories = function(categories) {
	      var separator = faker.definitions.separator || " &";
	      // TODO: find undefined here
	      categories = categories || faker.definitions.commerce.categories;
	      var commaSeparated = categories.slice(0, -1).join(', ');
	
	      return [commaSeparated, categories[categories.length - 1]].join(separator + " ");
	  };
	  */
	
	  /**
	   * productAdjective
	   *
	   * @method faker.commerce.productAdjective
	   */
	  self.productAdjective = function() {
	      return faker.random.arrayElement(faker.definitions.commerce.product_name.adjective);
	  };
	
	  /**
	   * productMaterial
	   *
	   * @method faker.commerce.productMaterial
	   */
	  self.productMaterial = function() {
	      return faker.random.arrayElement(faker.definitions.commerce.product_name.material);
	  };
	
	  /**
	   * product
	   *
	   * @method faker.commerce.product
	   */
	  self.product = function() {
	      return faker.random.arrayElement(faker.definitions.commerce.product_name.product);
	  }
	
	  return self;
	};
	
	module['exports'] = Commerce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.company
	 */
	var Company = function (faker) {
	  
	  var self = this;
	  var f = faker.fake;
	  
	  /**
	   * suffixes
	   *
	   * @method faker.company.suffixes
	   */
	  this.suffixes = function () {
	    // Don't want the source array exposed to modification, so return a copy
	    return faker.definitions.company.suffix.slice(0);
	  }
	
	  /**
	   * companyName
	   *
	   * @method faker.company.companyName
	   * @param {string} format
	   */
	  this.companyName = function (format) {
	
	    var formats = [
	      '{{name.lastName}} {{company.companySuffix}}',
	      '{{name.lastName}} - {{name.lastName}}',
	      '{{name.lastName}}, {{name.lastName}} and {{name.lastName}}'
	    ];
	
	    if (typeof format !== "number") {
	      format = faker.random.number(formats.length - 1);
	    }
	
	    return f(formats[format]);
	  }
	
	  /**
	   * companySuffix
	   *
	   * @method faker.company.companySuffix
	   */
	  this.companySuffix = function () {
	      return faker.random.arrayElement(faker.company.suffixes());
	  }
	
	  /**
	   * catchPhrase
	   *
	   * @method faker.company.catchPhrase
	   */
	  this.catchPhrase = function () {
	    return f('{{company.catchPhraseAdjective}} {{company.catchPhraseDescriptor}} {{company.catchPhraseNoun}}')
	  }
	
	  /**
	   * bs
	   *
	   * @method faker.company.bs
	   */
	  this.bs = function () {
	    return f('{{company.bsAdjective}} {{company.bsBuzz}} {{company.bsNoun}}');
	  }
	
	  /**
	   * catchPhraseAdjective
	   *
	   * @method faker.company.catchPhraseAdjective
	   */
	  this.catchPhraseAdjective = function () {
	      return faker.random.arrayElement(faker.definitions.company.adjective);
	  }
	
	  /**
	   * catchPhraseDescriptor
	   *
	   * @method faker.company.catchPhraseDescriptor
	   */
	  this.catchPhraseDescriptor = function () {
	      return faker.random.arrayElement(faker.definitions.company.descriptor);
	  }
	
	  /**
	   * catchPhraseNoun
	   *
	   * @method faker.company.catchPhraseNoun
	   */
	  this.catchPhraseNoun = function () {
	      return faker.random.arrayElement(faker.definitions.company.noun);
	  }
	
	  /**
	   * bsAdjective
	   *
	   * @method faker.company.bsAdjective
	   */
	  this.bsAdjective = function () {
	      return faker.random.arrayElement(faker.definitions.company.bs_adjective);
	  }
	
	  /**
	   * bsBuzz
	   *
	   * @method faker.company.bsBuzz
	   */
	  this.bsBuzz = function () {
	      return faker.random.arrayElement(faker.definitions.company.bs_verb);
	  }
	
	  /**
	   * bsNoun
	   *
	   * @method faker.company.bsNoun
	   */
	  this.bsNoun = function () {
	      return faker.random.arrayElement(faker.definitions.company.bs_noun);
	  }
	  
	}
	
	module['exports'] = Company;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.date
	 */
	var _Date = function (faker) {
	  var self = this;
	  /**
	   * past
	   *
	   * @method faker.date.past
	   * @param {number} years
	   * @param {date} refDate
	   */
	  self.past = function (years, refDate) {
	      var date = (refDate) ? new Date(Date.parse(refDate)) : new Date();
	      var range = {
	        min: 1000,
	        max: (years || 1) * 365 * 24 * 3600 * 1000
	      };
	
	      var past = date.getTime();
	      past -= faker.random.number(range); // some time from now to N years ago, in milliseconds
	      date.setTime(past);
	
	      return date;
	  };
	
	  /**
	   * future
	   *
	   * @method faker.date.future
	   * @param {number} years
	   * @param {date} refDate
	   */
	  self.future = function (years, refDate) {
	      var date = (refDate) ? new Date(Date.parse(refDate)) : new Date();
	      var range = {
	        min: 1000,
	        max: (years || 1) * 365 * 24 * 3600 * 1000
	      };
	
	      var future = date.getTime();
	      future += faker.random.number(range); // some time from now to N years later, in milliseconds
	      date.setTime(future);
	
	      return date;
	  };
	
	  /**
	   * between
	   *
	   * @method faker.date.between
	   * @param {date} from
	   * @param {date} to
	   */
	  self.between = function (from, to) {
	      var fromMilli = Date.parse(from);
	      var dateOffset = faker.random.number(Date.parse(to) - fromMilli);
	
	      var newDate = new Date(fromMilli + dateOffset);
	
	      return newDate;
	  };
	
	  /**
	   * recent
	   *
	   * @method faker.date.recent
	   * @param {number} days
	   */
	  self.recent = function (days) {
	      var date = new Date();
	      var range = {
	        min: 1000,
	        max: (days || 1) * 24 * 3600 * 1000
	      };
	
	      var future = date.getTime();
	      future -= faker.random.number(range); // some time from now to N days ago, in milliseconds
	      date.setTime(future);
	
	      return date;
	  };
	
	  /**
	   * month
	   *
	   * @method faker.date.month
	   * @param {object} options
	   */
	  self.month = function (options) {
	      options = options || {};
	
	      var type = 'wide';
	      if (options.abbr) {
	          type = 'abbr';
	      }
	      if (options.context && typeof faker.definitions.date.month[type + '_context'] !== 'undefined') {
	          type += '_context';
	      }
	
	      var source = faker.definitions.date.month[type];
	
	      return faker.random.arrayElement(source);
	  };
	
	  /**
	   * weekday
	   *
	   * @param {object} options
	   * @method faker.date.weekday
	   */
	  self.weekday = function (options) {
	      options = options || {};
	
	      var type = 'wide';
	      if (options.abbr) {
	          type = 'abbr';
	      }
	      if (options.context && typeof faker.definitions.date.weekday[type + '_context'] !== 'undefined') {
	          type += '_context';
	      }
	
	      var source = faker.definitions.date.weekday[type];
	
	      return faker.random.arrayElement(source);
	  };
	  
	  return self;
	  
	};
	
	module['exports'] = _Date;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*
	  fake.js - generator method for combining faker methods based on string input
	
	*/
	
	function Fake (faker) {
	  
	  /**
	   * Generator method for combining faker methods based on string input
	   *
	   * __Example:__
	   *
	   * ```
	   * console.log(faker.fake('{{name.lastName}}, {{name.firstName}} {{name.suffix}}'));
	   * //outputs: "Marks, Dean Sr."
	   * ```
	   *
	   * This will interpolate the format string with the value of methods
	   * [name.lastName]{@link faker.name.lastName}, [name.firstName]{@link faker.name.firstName},
	   * and [name.suffix]{@link faker.name.suffix}
	   *
	   * @method faker.fake
	   * @param {string} str
	   */
	  this.fake = function fake (str) {
	    // setup default response as empty string
	    var res = '';
	
	    // if incoming str parameter is not provided, return error message
	    if (typeof str !== 'string' || str.length === 0) {
	      res = 'string parameter is required!';
	      return res;
	    }
	
	    // find first matching {{ and }}
	    var start = str.search('{{');
	    var end = str.search('}}');
	
	    // if no {{ and }} is found, we are done
	    if (start === -1 && end === -1) {
	      return str;
	    }
	
	    // console.log('attempting to parse', str);
	
	    // extract method name from between the {{ }} that we found
	    // for example: {{name.firstName}}
	    var token = str.substr(start + 2,  end - start - 2);
	    var method = token.replace('}}', '').replace('{{', '');
	
	    // console.log('method', method)
	
	    // extract method parameters
	    var regExp = /\(([^)]+)\)/;
	    var matches = regExp.exec(method);
	    var parameters = '';
	    if (matches) {
	      method = method.replace(regExp, '');
	      parameters = matches[1];
	    }
	
	    // split the method into module and function
	    var parts = method.split('.');
	
	    if (typeof faker[parts[0]] === "undefined") {
	      throw new Error('Invalid module: ' + parts[0]);
	    }
	
	    if (typeof faker[parts[0]][parts[1]] === "undefined") {
	      throw new Error('Invalid method: ' + parts[0] + "." + parts[1]);
	    }
	
	    // assign the function from the module.function namespace
	    var fn = faker[parts[0]][parts[1]];
	
	    // If parameters are populated here, they are always going to be of string type
	    // since we might actually be dealing with an object or array,
	    // we always attempt to the parse the incoming parameters into JSON
	    var params;
	    // Note: we experience a small performance hit here due to JSON.parse try / catch
	    // If anyone actually needs to optimize this specific code path, please open a support issue on github
	    try {
	      params = JSON.parse(parameters)
	    } catch (err) {
	      // since JSON.parse threw an error, assume parameters was actually a string
	      params = parameters;
	    }
	
	    var result;
	    if (typeof params === "string" && params.length === 0) {
	      result = fn.call(this);
	    } else {
	      result = fn.call(this, params);
	    }
	
	    // replace the found tag with the returned fake value
	    res = str.replace('{{' + token + '}}', result);
	
	    // return the response recursively until we are done finding all tags
	    return fake(res);    
	  }
	  
	  return this;
	  
	  
	}
	
	module['exports'] = Fake;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.finance
	 */
	var Finance = function (faker) {
	  var Helpers = faker.helpers,
	      self = this;
	
	  /**
	   * account
	   *
	   * @method faker.finance.account
	   * @param {number} length
	   */
	  self.account = function (length) {
	
	      length = length || 8;
	
	      var template = '';
	
	      for (var i = 0; i < length; i++) {
	          template = template + '#';
	      }
	      length = null;
	      return Helpers.replaceSymbolWithNumber(template);
	  }
	
	  /**
	   * accountName
	   *
	   * @method faker.finance.accountName
	   */
	  self.accountName = function () {
	
	      return [Helpers.randomize(faker.definitions.finance.account_type), 'Account'].join(' ');
	  }
	
	  /**
	   * mask
	   *
	   * @method faker.finance.mask
	   * @param {number} length
	   * @param {boolean} parens
	   * @param {boolean} elipsis
	   */
	  self.mask = function (length, parens, elipsis) {
	
	
	      //set defaults
	      length = (length == 0 || !length || typeof length == 'undefined') ? 4 : length;
	      parens = (parens === null) ? true : parens;
	      elipsis = (elipsis === null) ? true : elipsis;
	
	      //create a template for length
	      var template = '';
	
	      for (var i = 0; i < length; i++) {
	          template = template + '#';
	      }
	
	      //prefix with elipsis
	      template = (elipsis) ? ['...', template].join('') : template;
	
	      template = (parens) ? ['(', template, ')'].join('') : template;
	
	      //generate random numbers
	      template = Helpers.replaceSymbolWithNumber(template);
	
	      return template;
	
	  }
	
	  //min and max take in minimum and maximum amounts, dec is the decimal place you want rounded to, symbol is $, €, £, etc
	  //NOTE: this returns a string representation of the value, if you want a number use parseFloat and no symbol
	
	  /**
	   * amount
	   *
	   * @method faker.finance.amount
	   * @param {number} min
	   * @param {number} max
	   * @param {number} dec
	   * @param {string} symbol
	   */
	  self.amount = function (min, max, dec, symbol) {
	
	      min = min || 0;
	      max = max || 1000;
	      dec = dec || 2;
	      symbol = symbol || '';
	      var randValue = faker.random.number({ max: max, min: min });
	
	      return symbol + (Math.round(randValue * Math.pow(10, dec)) / Math.pow(10, dec)).toFixed(dec);
	
	  }
	
	  /**
	   * transactionType
	   *
	   * @method faker.finance.transactionType
	   */
	  self.transactionType = function () {
	      return Helpers.randomize(faker.definitions.finance.transaction_type);
	  }
	
	  /**
	   * currencyCode
	   *
	   * @method faker.finance.currencyCode
	   */
	  self.currencyCode = function () {
	      return faker.random.objectElement(faker.definitions.finance.currency)['code'];
	  }
	
	  /**
	   * currencyName
	   *
	   * @method faker.finance.currencyName
	   */
	  self.currencyName = function () {
	      return faker.random.objectElement(faker.definitions.finance.currency, 'key');
	  }
	
	  /**
	   * currencySymbol
	   *
	   * @method faker.finance.currencySymbol
	   */
	  self.currencySymbol = function () {
	      var symbol;
	
	      while (!symbol) {
	          symbol = faker.random.objectElement(faker.definitions.finance.currency)['symbol'];
	      }
	      return symbol;
	  }
	
	  /**
	   * bitcoinAddress
	   *
	   * @method  faker.finance.bitcoinAddress
	   */
	  self.bitcoinAddress = function () {
	    var addressLength = faker.random.number({ min: 27, max: 34 });
	
	    var address = faker.random.arrayElement(['1', '3']);
	
	    for (var i = 0; i < addressLength - 1; i++)
	      address += faker.random.alphaNumeric().toUpperCase();
	
	    return address;
	  }
	}
	
	module['exports'] = Finance;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.hacker
	 */
	var Hacker = function (faker) {
	  var self = this;
	  
	  /**
	   * abbreviation
	   *
	   * @method faker.hacker.abbreviation
	   */
	  self.abbreviation = function () {
	    return faker.random.arrayElement(faker.definitions.hacker.abbreviation);
	  };
	
	  /**
	   * adjective
	   *
	   * @method faker.hacker.adjective
	   */
	  self.adjective = function () {
	    return faker.random.arrayElement(faker.definitions.hacker.adjective);
	  };
	
	  /**
	   * noun
	   *
	   * @method faker.hacker.noun
	   */
	  self.noun = function () {
	    return faker.random.arrayElement(faker.definitions.hacker.noun);
	  };
	
	  /**
	   * verb
	   *
	   * @method faker.hacker.verb
	   */
	  self.verb = function () {
	    return faker.random.arrayElement(faker.definitions.hacker.verb);
	  };
	
	  /**
	   * ingverb
	   *
	   * @method faker.hacker.ingverb
	   */
	  self.ingverb = function () {
	    return faker.random.arrayElement(faker.definitions.hacker.ingverb);
	  };
	
	  /**
	   * phrase
	   *
	   * @method faker.hacker.phrase
	   */
	  self.phrase = function () {
	
	    var data = {
	      abbreviation: self.abbreviation,
	      adjective: self.adjective,
	      ingverb: self.ingverb,
	      noun: self.noun,
	      verb: self.verb
	    };
	
	    var phrase = faker.random.arrayElement([ "If we {{verb}} the {{noun}}, we can get to the {{abbreviation}} {{noun}} through the {{adjective}} {{abbreviation}} {{noun}}!",
	      "We need to {{verb}} the {{adjective}} {{abbreviation}} {{noun}}!",
	      "Try to {{verb}} the {{abbreviation}} {{noun}}, maybe it will {{verb}} the {{adjective}} {{noun}}!",
	      "You can't {{verb}} the {{noun}} without {{ingverb}} the {{adjective}} {{abbreviation}} {{noun}}!",
	      "Use the {{adjective}} {{abbreviation}} {{noun}}, then you can {{verb}} the {{adjective}} {{noun}}!",
	      "The {{abbreviation}} {{noun}} is down, {{verb}} the {{adjective}} {{noun}} so we can {{verb}} the {{abbreviation}} {{noun}}!",
	      "{{ingverb}} the {{noun}} won't do anything, we need to {{verb}} the {{adjective}} {{abbreviation}} {{noun}}!",
	      "I'll {{verb}} the {{adjective}} {{abbreviation}} {{noun}}, that should {{noun}} the {{abbreviation}} {{noun}}!"
	   ]);
	
	   return faker.helpers.mustache(phrase, data);
	
	  };
	  
	  return self;
	};
	
	module['exports'] = Hacker;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.helpers
	 */
	var Helpers = function (faker) {
	
	  var self = this;
	
	  /**
	   * backword-compatibility
	   *
	   * @method faker.helpers.randomize
	   * @param {array} array
	   */
	  self.randomize = function (array) {
	      array = array || ["a", "b", "c"];
	      return faker.random.arrayElement(array);
	  };
	
	  /**
	   * slugifies string
	   *
	   * @method faker.helpers.slugify
	   * @param {string} string
	   */
	  self.slugify = function (string) {
	      string = string || "";
	      return string.replace(/ /g, '-').replace(/[^\w\.\-]+/g, '');
	  };
	
	  /**
	   * parses string for a symbol and replace it with a random number from 1-10
	   *
	   * @method faker.helpers.replaceSymbolWithNumber
	   * @param {string} string
	   * @param {string} symbol defaults to `"#"`
	   */
	  self.replaceSymbolWithNumber = function (string, symbol) {
	      string = string || "";
	      // default symbol is '#'
	      if (symbol === undefined) {
	          symbol = '#';
	      }
	
	      var str = '';
	      for (var i = 0; i < string.length; i++) {
	          if (string.charAt(i) == symbol) {
	              str += faker.random.number(9);
	          } else {
	              str += string.charAt(i);
	          }
	      }
	      return str;
	  };
	
	  /**
	   * parses string for symbols (numbers or letters) and replaces them appropriately
	   *
	   * @method faker.helpers.replaceSymbols
	   * @param {string} string
	   */
	  self.replaceSymbols = function (string) {
	      string = string || "";
	  	var alpha = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
	      var str = '';
	
	      for (var i = 0; i < string.length; i++) {
	          if (string.charAt(i) == "#") {
	              str += faker.random.number(9);
	  		} else if (string.charAt(i) == "?") {
	  			str += faker.random.arrayElement(alpha);
	          } else {
	              str += string.charAt(i);
	          }
	      }
	      return str;
	  };
	
	  /**
	   * takes an array and returns it randomized
	   *
	   * @method faker.helpers.shuffle
	   * @param {array} o
	   */
	  self.shuffle = function (o) {
	      o = o || ["a", "b", "c"];
	      for (var j, x, i = o.length-1; i; j = faker.random.number(i), x = o[--i], o[i] = o[j], o[j] = x);
	      return o;
	  };
	
	  /**
	   * mustache
	   *
	   * @method faker.helpers.mustache
	   * @param {string} str
	   * @param {object} data
	   */
	  self.mustache = function (str, data) {
	    if (typeof str === 'undefined') {
	      return '';
	    }
	    for(var p in data) {
	      var re = new RegExp('{{' + p + '}}', 'g')
	      str = str.replace(re, data[p]);
	    }
	    return str;
	  };
	
	  /**
	   * createCard
	   *
	   * @method faker.helpers.createCard
	   */
	  self.createCard = function () {
	      return {
	          "name": faker.name.findName(),
	          "username": faker.internet.userName(),
	          "email": faker.internet.email(),
	          "address": {
	              "streetA": faker.address.streetName(),
	              "streetB": faker.address.streetAddress(),
	              "streetC": faker.address.streetAddress(true),
	              "streetD": faker.address.secondaryAddress(),
	              "city": faker.address.city(),
	              "state": faker.address.state(),
	              "country": faker.address.country(),
	              "zipcode": faker.address.zipCode(),
	              "geo": {
	                  "lat": faker.address.latitude(),
	                  "lng": faker.address.longitude()
	              }
	          },
	          "phone": faker.phone.phoneNumber(),
	          "website": faker.internet.domainName(),
	          "company": {
	              "name": faker.company.companyName(),
	              "catchPhrase": faker.company.catchPhrase(),
	              "bs": faker.company.bs()
	          },
	          "posts": [
	              {
	                  "words": faker.lorem.words(),
	                  "sentence": faker.lorem.sentence(),
	                  "sentences": faker.lorem.sentences(),
	                  "paragraph": faker.lorem.paragraph()
	              },
	              {
	                  "words": faker.lorem.words(),
	                  "sentence": faker.lorem.sentence(),
	                  "sentences": faker.lorem.sentences(),
	                  "paragraph": faker.lorem.paragraph()
	              },
	              {
	                  "words": faker.lorem.words(),
	                  "sentence": faker.lorem.sentence(),
	                  "sentences": faker.lorem.sentences(),
	                  "paragraph": faker.lorem.paragraph()
	              }
	          ],
	          "accountHistory": [faker.helpers.createTransaction(), faker.helpers.createTransaction(), faker.helpers.createTransaction()]
	      };
	  };
	
	  /**
	   * contextualCard
	   *
	   * @method faker.helpers.contextualCard
	   */
	  self.contextualCard = function () {
	    var name = faker.name.firstName(),
	        userName = faker.internet.userName(name);
	    return {
	        "name": name,
	        "username": userName,
	        "avatar": faker.internet.avatar(),
	        "email": faker.internet.email(userName),
	        "dob": faker.date.past(50, new Date("Sat Sep 20 1992 21:35:02 GMT+0200 (CEST)")),
	        "phone": faker.phone.phoneNumber(),
	        "address": {
	            "street": faker.address.streetName(true),
	            "suite": faker.address.secondaryAddress(),
	            "city": faker.address.city(),
	            "zipcode": faker.address.zipCode(),
	            "geo": {
	                "lat": faker.address.latitude(),
	                "lng": faker.address.longitude()
	            }
	        },
	        "website": faker.internet.domainName(),
	        "company": {
	            "name": faker.company.companyName(),
	            "catchPhrase": faker.company.catchPhrase(),
	            "bs": faker.company.bs()
	        }
	    };
	  };
	
	
	  /**
	   * userCard
	   *
	   * @method faker.helpers.userCard
	   */
	  self.userCard = function () {
	      return {
	          "name": faker.name.findName(),
	          "username": faker.internet.userName(),
	          "email": faker.internet.email(),
	          "address": {
	              "street": faker.address.streetName(true),
	              "suite": faker.address.secondaryAddress(),
	              "city": faker.address.city(),
	              "zipcode": faker.address.zipCode(),
	              "geo": {
	                  "lat": faker.address.latitude(),
	                  "lng": faker.address.longitude()
	              }
	          },
	          "phone": faker.phone.phoneNumber(),
	          "website": faker.internet.domainName(),
	          "company": {
	              "name": faker.company.companyName(),
	              "catchPhrase": faker.company.catchPhrase(),
	              "bs": faker.company.bs()
	          }
	      };
	  };
	
	  /**
	   * createTransaction
	   *
	   * @method faker.helpers.createTransaction
	   */
	  self.createTransaction = function(){
	    return {
	      "amount" : faker.finance.amount(),
	      "date" : new Date(2012, 1, 2),  //TODO: add a ranged date method
	      "business": faker.company.companyName(),
	      "name": [faker.finance.accountName(), faker.finance.mask()].join(' '),
	      "type" : self.randomize(faker.definitions.finance.transaction_type),
	      "account" : faker.finance.account()
	    };
	  };
	
	  return self;
	
	};
	
	
	/*
	String.prototype.capitalize = function () { //v1.0
	    return this.replace(/\w+/g, function (a) {
	        return a.charAt(0).toUpperCase() + a.substr(1).toLowerCase();
	    });
	};
	*/
	
	module['exports'] = Helpers;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.image
	 */
	var Image = function (faker) {
	
	  var self = this;
	
	  /**
	   * image
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.image
	   */
	  self.image = function (width, height, randomize) {
	    var categories = ["abstract", "animals", "business", "cats", "city", "food", "nightlife", "fashion", "people", "nature", "sports", "technics", "transport"];
	    return self[faker.random.arrayElement(categories)](width, height, randomize);
	  };
	  /**
	   * avatar
	   *
	   * @method faker.image.avatar
	   */
	  self.avatar = function () {
	    return faker.internet.avatar();
	  };
	  /**
	   * imageUrl
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {string} category
	   * @param {boolean} randomize
	   * @method faker.image.imageUrl
	   */
	  self.imageUrl = function (width, height, category, randomize) {
	      var width = width || 640;
	      var height = height || 480;
	
	      var url ='http://lorempixel.com/' + width + '/' + height;
	      if (typeof category !== 'undefined') {
	        url += '/' + category;
	      }
	
	      if (randomize) {
	        url += '?' + faker.random.number()
	      }
	
	      return url;
	  };
	  /**
	   * abstract
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.abstract
	   */
	  self.abstract = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'abstract', randomize);
	  };
	  /**
	   * animals
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.animals
	   */
	  self.animals = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'animals', randomize);
	  };
	  /**
	   * business
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.business
	   */
	  self.business = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'business', randomize);
	  };
	  /**
	   * cats
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.cats
	   */
	  self.cats = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'cats', randomize);
	  };
	  /**
	   * city
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.city
	   */
	  self.city = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'city', randomize);
	  };
	  /**
	   * food
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.food
	   */
	  self.food = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'food', randomize);
	  };
	  /**
	   * nightlife
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.nightlife
	   */
	  self.nightlife = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'nightlife', randomize);
	  };
	  /**
	   * fashion
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.fashion
	   */
	  self.fashion = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'fashion', randomize);
	  };
	  /**
	   * people
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.people
	   */
	  self.people = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'people', randomize);
	  };
	  /**
	   * nature
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.nature
	   */
	  self.nature = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'nature', randomize);
	  };
	  /**
	   * sports
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.sports
	   */
	  self.sports = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'sports', randomize);
	  };
	  /**
	   * technics
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.technics
	   */
	  self.technics = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'technics', randomize);
	  };
	  /**
	   * transport
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.transport
	   */
	  self.transport = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'transport', randomize);
	  }  
	}
	
	module["exports"] = Image;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*
	
	   this index.js file is used for including the faker library as a CommonJS module, instead of a bundle
	
	   you can include the faker library into your existing node.js application by requiring the entire /faker directory
	
	    var faker = require(./faker);
	    var randomName = faker.name.findName();
	
	   you can also simply include the "faker.js" file which is the auto-generated bundled version of the faker library
	
	    var faker = require(./customAppPath/faker);
	    var randomName = faker.name.findName();
	
	
	  if you plan on modifying the faker library you should be performing your changes in the /lib/ directory
	
	*/
	
	/**
	 *
	 * @namespace faker
	 */
	function Faker (opts) {
	
	  var self = this;
	
	  opts = opts || {};
	
	  // assign options
	  var locales = self.locales || opts.locales || {};
	  var locale = self.locale || opts.locale || "en";
	  var localeFallback = self.localeFallback || opts.localeFallback || "en";
	
	  self.locales = locales;
	  self.locale = locale;
	  self.localeFallback = localeFallback;
	
	  self.definitions = {};
	
	  var Fake = __webpack_require__(360);
	  self.fake = new Fake(self).fake;
	
	  var Random = __webpack_require__(102);
	  self.random = new Random(self);
	  // self.random = require('./random');
	
	  var Helpers = __webpack_require__(363);
	  self.helpers = new Helpers(self);
	
	  var Name = __webpack_require__(1309);
	  self.name = new Name(self);
	  // self.name = require('./name');
	
	  var Address = __webpack_require__(356);
	  self.address = new Address(self);
	
	  var Company = __webpack_require__(358);
	  self.company = new Company(self);
	
	  var Finance = __webpack_require__(361);
	  self.finance = new Finance(self);
	
	  var Image = __webpack_require__(364);
	  self.image = new Image(self);
	
	  var Lorem = __webpack_require__(1308);
	  self.lorem = new Lorem(self);
	
	  var Hacker = __webpack_require__(362);
	  self.hacker = new Hacker(self);
	
	  var Internet = __webpack_require__(366);
	  self.internet = new Internet(self);
	
	  var Phone = __webpack_require__(1310);
	  self.phone = new Phone(self);
	
	  var _Date = __webpack_require__(359);
	  self.date = new _Date(self);
	
	  var Commerce = __webpack_require__(357);
	  self.commerce = new Commerce(self);
	
	  var System = __webpack_require__(1311);
	  self.system = new System(self);
	
	  var _definitions = {
	    "name": ["first_name", "last_name", "prefix", "suffix", "title", "male_first_name", "female_first_name", "male_middle_name", "female_middle_name", "male_last_name", "female_last_name"],
	    "address": ["city_prefix", "city_suffix", "street_suffix", "county", "country", "country_code", "state", "state_abbr", "street_prefix", "postcode"],
	    "company": ["adjective", "noun", "descriptor", "bs_adjective", "bs_noun", "bs_verb", "suffix"],
	    "lorem": ["words"],
	    "hacker": ["abbreviation", "adjective", "noun", "verb", "ingverb"],
	    "phone_number": ["formats"],
	    "finance": ["account_type", "transaction_type", "currency"],
	    "internet": ["avatar_uri", "domain_suffix", "free_email", "example_email", "password"],
	    "commerce": ["color", "department", "product_name", "price", "categories"],
	    "system": ["mimeTypes"],
	    "date": ["month", "weekday"],
	    "title": "",
	    "separator": ""
	  };
	
	  // Create a Getter for all definitions.foo.bar propetries
	  Object.keys(_definitions).forEach(function(d){
	    if (typeof self.definitions[d] === "undefined") {
	      self.definitions[d] = {};
	    }
	
	    if (typeof _definitions[d] === "string") {
	        self.definitions[d] = _definitions[d];
	      return;
	    }
	
	    _definitions[d].forEach(function(p){
	      Object.defineProperty(self.definitions[d], p, {
	        get: function () {
	          if (typeof self.locales[self.locale][d] === "undefined" || typeof self.locales[self.locale][d][p] === "undefined") {
	            // certain localization sets contain less data then others.
	            // in the case of a missing defintion, use the default localeFallback to substitute the missing set data
	            // throw new Error('unknown property ' + d + p)
	            return self.locales[localeFallback][d][p];
	          } else {
	            // return localized data
	            return self.locales[self.locale][d][p];
	          }
	        }
	      });
	    });
	  });
	
	};
	
	Faker.prototype.seed = function(value) {
	  var Random = __webpack_require__(102);
	  this.seedValue = value;
	  this.random = new Random(this, this.seedValue);
	}
	module['exports'] = Faker;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var password_generator = __webpack_require__(1313),
	    random_ua = __webpack_require__(1314);
	
	/**
	 *
	 * @namespace faker.internet
	 */
	var Internet = function (faker) {
	  var self = this;
	  /**
	   * avatar
	   *
	   * @method faker.internet.avatar
	   */
	  self.avatar = function () {
	      return faker.random.arrayElement(faker.definitions.internet.avatar_uri);
	  };
	
	  self.avatar.schema = {
	    "description": "Generates a URL for an avatar.",
	    "sampleResults": ["https://s3.amazonaws.com/uifaces/faces/twitter/igorgarybaldi/128.jpg"]
	  };
	
	  /**
	   * email
	   *
	   * @method faker.internet.email
	   * @param {string} firstName
	   * @param {string} lastName
	   * @param {string} provider
	   */
	  self.email = function (firstName, lastName, provider) {
	      provider = provider || faker.random.arrayElement(faker.definitions.internet.free_email);
	      return  faker.helpers.slugify(faker.internet.userName(firstName, lastName)) + "@" + provider;
	  };
	
	  self.email.schema = {
	    "description": "Generates a valid email address based on optional input criteria",
	    "sampleResults": ["foo.bar@gmail.com"],
	    "properties": {
	      "firstName": {
	        "type": "string",
	        "required": false,
	        "description": "The first name of the user"
	      },
	      "lastName": {
	        "type": "string",
	        "required": false,
	        "description": "The last name of the user"
	      },
	      "provider": {
	        "type": "string",
	        "required": false,
	        "description": "The domain of the user"
	      }
	    }
	  };
	  /**
	   * exampleEmail
	   *
	   * @method faker.internet.exampleEmail
	   * @param {string} firstName
	   * @param {string} lastName
	   */
	  self.exampleEmail = function (firstName, lastName) {
	      var provider = faker.random.arrayElement(faker.definitions.internet.example_email);
	      return self.email(firstName, lastName, provider);
	  };
	
	  /**
	   * userName
	   *
	   * @method faker.internet.userName
	   * @param {string} firstName
	   * @param {string} lastName
	   */
	  self.userName = function (firstName, lastName) {
	      var result;
	      firstName = firstName || faker.name.firstName();
	      lastName = lastName || faker.name.lastName();
	      switch (faker.random.number(2)) {
	      case 0:
	          result = firstName + faker.random.number(99);
	          break;
	      case 1:
	          result = firstName + faker.random.arrayElement([".", "_"]) + lastName;
	          break;
	      case 2:
	          result = firstName + faker.random.arrayElement([".", "_"]) + lastName + faker.random.number(99);
	          break;
	      }
	      result = result.toString().replace(/'/g, "");
	      result = result.replace(/ /g, "");
	      return result;
	  };
	
	  self.userName.schema = {
	    "description": "Generates a username based on one of several patterns. The pattern is chosen randomly.",
	    "sampleResults": [
	      "Kirstin39",
	      "Kirstin.Smith",
	      "Kirstin.Smith39",
	      "KirstinSmith",
	      "KirstinSmith39",
	    ],
	    "properties": {
	      "firstName": {
	        "type": "string",
	        "required": false,
	        "description": "The first name of the user"
	      },
	      "lastName": {
	        "type": "string",
	        "required": false,
	        "description": "The last name of the user"
	      }
	    }
	  };
	
	  /**
	   * protocol
	   *
	   * @method faker.internet.protocol
	   */
	  self.protocol = function () {
	      var protocols = ['http','https'];
	      return faker.random.arrayElement(protocols);
	  };
	
	  self.protocol.schema = {
	    "description": "Randomly generates http or https",
	    "sampleResults": ["https", "http"]
	  };
	
	  /**
	   * url
	   *
	   * @method faker.internet.url
	   */
	  self.url = function () {
	      return faker.internet.protocol() + '://' + faker.internet.domainName();
	  };
	
	  self.url.schema = {
	    "description": "Generates a random URL. The URL could be secure or insecure.",
	    "sampleResults": [
	      "http://rashawn.name",
	      "https://rashawn.name"
	    ]
	  };
	
	  /**
	   * domainName
	   *
	   * @method faker.internet.domainName
	   */
	  self.domainName = function () {
	      return faker.internet.domainWord() + "." + faker.internet.domainSuffix();
	  };
	
	  self.domainName.schema = {
	    "description": "Generates a random domain name.",
	    "sampleResults": ["marvin.org"]
	  };
	
	  /**
	   * domainSuffix
	   *
	   * @method faker.internet.domainSuffix
	   */
	  self.domainSuffix = function () {
	      return faker.random.arrayElement(faker.definitions.internet.domain_suffix);
	  };
	
	  self.domainSuffix.schema = {
	    "description": "Generates a random domain suffix.",
	    "sampleResults": ["net"]
	  };
	
	  /**
	   * domainWord
	   *
	   * @method faker.internet.domainWord
	   */
	  self.domainWord = function () {
	      return faker.name.firstName().replace(/([\\~#&*{}/:<>?|\"'])/ig, '').toLowerCase();
	  };
	
	  self.domainWord.schema = {
	    "description": "Generates a random domain word.",
	    "sampleResults": ["alyce"]
	  };
	
	  /**
	   * ip
	   *
	   * @method faker.internet.ip
	   */
	  self.ip = function () {
	      var randNum = function () {
	          return (faker.random.number(255)).toFixed(0);
	      };
	
	      var result = [];
	      for (var i = 0; i < 4; i++) {
	          result[i] = randNum();
	      }
	
	      return result.join(".");
	  };
	
	  self.ip.schema = {
	    "description": "Generates a random IP.",
	    "sampleResults": ["97.238.241.11"]
	  };
	
	  /**
	   * userAgent
	   *
	   * @method faker.internet.userAgent
	   */
	  self.userAgent = function () {
	    return random_ua.generate();
	  };
	
	  self.userAgent.schema = {
	    "description": "Generates a random user agent.",
	    "sampleResults": ["Mozilla/5.0 (Macintosh; U; PPC Mac OS X 10_7_5 rv:6.0; SL) AppleWebKit/532.0.1 (KHTML, like Gecko) Version/7.1.6 Safari/532.0.1"]
	  };
	
	  /**
	   * color
	   *
	   * @method faker.internet.color
	   * @param {number} baseRed255
	   * @param {number} baseGreen255
	   * @param {number} baseBlue255
	   */
	  self.color = function (baseRed255, baseGreen255, baseBlue255) {
	      baseRed255 = baseRed255 || 0;
	      baseGreen255 = baseGreen255 || 0;
	      baseBlue255 = baseBlue255 || 0;
	      // based on awesome response : http://stackoverflow.com/questions/43044/algorithm-to-randomly-generate-an-aesthetically-pleasing-color-palette
	      var red = Math.floor((faker.random.number(256) + baseRed255) / 2);
	      var green = Math.floor((faker.random.number(256) + baseGreen255) / 2);
	      var blue = Math.floor((faker.random.number(256) + baseBlue255) / 2);
	      var redStr = red.toString(16);
	      var greenStr = green.toString(16);
	      var blueStr = blue.toString(16);
	      return '#' +
	        (redStr.length === 1 ? '0' : '') + redStr +
	        (greenStr.length === 1 ? '0' : '') + greenStr +
	        (blueStr.length === 1 ? '0': '') + blueStr;
	
	  };
	
	  self.color.schema = {
	    "description": "Generates a random hexadecimal color.",
	    "sampleResults": ["#06267f"],
	    "properties": {
	      "baseRed255": {
	        "type": "number",
	        "required": false,
	        "description": "The red value. Valid values are 0 - 255."
	      },
	      "baseGreen255": {
	        "type": "number",
	        "required": false,
	        "description": "The green value. Valid values are 0 - 255."
	      },
	      "baseBlue255": {
	        "type": "number",
	        "required": false,
	        "description": "The blue value. Valid values are 0 - 255."
	      }
	    }
	  };
	
	  /**
	   * mac
	   *
	   * @method faker.internet.mac
	   */
	  self.mac = function(){
	      var i, mac = "";
	      for (i=0; i < 12; i++) {
	          mac+= faker.random.number(15).toString(16);
	          if (i%2==1 && i != 11) {
	              mac+=":";
	          }
	      }
	      return mac;
	  };
	
	  self.mac.schema = {
	    "description": "Generates a random mac address.",
	    "sampleResults": ["78:06:cc:ae:b3:81"]
	  };
	
	  /**
	   * password
	   *
	   * @method faker.internet.password
	   * @param {number} len
	   * @param {boolean} memorable
	   * @param {string} pattern
	   * @param {string} prefix
	   */
	  self.password = function (len, memorable, pattern, prefix) {
	    len = len || 15;
	    if (typeof memorable === "undefined") {
	      memorable = false;
	    }
	    return password_generator(len, memorable, pattern, prefix);
	  }
	
	  self.password.schema = {
	    "description": "Generates a random password.",
	    "sampleResults": [
	      "AM7zl6Mg",
	      "susejofe"
	    ],
	    "properties": {
	      "length": {
	        "type": "number",
	        "required": false,
	        "description": "The number of characters in the password."
	      },
	      "memorable": {
	        "type": "boolean",
	        "required": false,
	        "description": "Whether a password should be easy to remember."
	      },
	      "pattern": {
	        "type": "regex",
	        "required": false,
	        "description": "A regex to match each character of the password against. This parameter will be negated if the memorable setting is turned on."
	      },
	      "prefix": {
	        "type": "string",
	        "required": false,
	        "description": "A value to prepend to the generated password. The prefix counts towards the length of the password."
	      }
	    }
	  };
	
	};
	
	
	module["exports"] = Internet;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	exports['de'] = __webpack_require__(388);
	exports['de_AT'] = __webpack_require__(421);
	exports['de_CH'] = __webpack_require__(440);
	exports['en'] = __webpack_require__(515);
	exports['en_AU'] = __webpack_require__(547);
	exports['en_BORK'] = __webpack_require__(555);
	exports['en_CA'] = __webpack_require__(563);
	exports['en_GB'] = __webpack_require__(576);
	exports['en_IE'] = __webpack_require__(586);
	exports['en_IND'] = __webpack_require__(598);
	exports['en_US'] = __webpack_require__(610);
	exports['en_au_ocker'] = __webpack_require__(630);
	exports['es'] = __webpack_require__(662);
	exports['es_MX'] = __webpack_require__(706);
	exports['fa'] = __webpack_require__(725);
	exports['fr'] = __webpack_require__(751);
	exports['fr_CA'] = __webpack_require__(771);
	exports['ge'] = __webpack_require__(797);
	exports['id_ID'] = __webpack_require__(826);
	exports['it'] = __webpack_require__(863);
	exports['ja'] = __webpack_require__(885);
	exports['ko'] = __webpack_require__(906);
	exports['nb_NO'] = __webpack_require__(936);
	exports['nep'] = __webpack_require__(956);
	exports['nl'] = __webpack_require__(980);
	exports['pl'] = __webpack_require__(1020);
	exports['pt_BR'] = __webpack_require__(1049);
	exports['ru'] = __webpack_require__(1086);
	exports['sk'] = __webpack_require__(1126);
	exports['sv'] = __webpack_require__(1173);
	exports['tr'] = __webpack_require__(1199);
	exports['uk'] = __webpack_require__(1232);
	exports['vi'] = __webpack_require__(1259);
	exports['zh_CN'] = __webpack_require__(1282);
	exports['zh_TW'] = __webpack_require__(1301);


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###",
	  "##",
	  "#",
	  "##a",
	  "##b",
	  "##c"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix} #{Name.first_name}#{city_suffix}",
	  "#{city_prefix} #{Name.first_name}",
	  "#{Name.first_name}#{city_suffix}",
	  "#{Name.last_name}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Nord",
	  "Ost",
	  "West",
	  "Süd",
	  "Neu",
	  "Alt",
	  "Bad"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "stadt",
	  "dorf",
	  "land",
	  "scheid",
	  "burg"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ägypten",
	  "Äquatorialguinea",
	  "Äthiopien",
	  "Österreich",
	  "Afghanistan",
	  "Albanien",
	  "Algerien",
	  "Amerikanisch-Samoa",
	  "Amerikanische Jungferninseln",
	  "Andorra",
	  "Angola",
	  "Anguilla",
	  "Antarktis",
	  "Antigua und Barbuda",
	  "Argentinien",
	  "Armenien",
	  "Aruba",
	  "Aserbaidschan",
	  "Australien",
	  "Bahamas",
	  "Bahrain",
	  "Bangladesch",
	  "Barbados",
	  "Belarus",
	  "Belgien",
	  "Belize",
	  "Benin",
	  "die Bermudas",
	  "Bhutan",
	  "Bolivien",
	  "Bosnien und Herzegowina",
	  "Botsuana",
	  "Bouvetinsel",
	  "Brasilien",
	  "Britische Jungferninseln",
	  "Britisches Territorium im Indischen Ozean",
	  "Brunei Darussalam",
	  "Bulgarien",
	  "Burkina Faso",
	  "Burundi",
	  "Chile",
	  "China",
	  "Cookinseln",
	  "Costa Rica",
	  "Dänemark",
	  "Demokratische Republik Kongo",
	  "Demokratische Volksrepublik Korea",
	  "Deutschland",
	  "Dominica",
	  "Dominikanische Republik",
	  "Dschibuti",
	  "Ecuador",
	  "El Salvador",
	  "Eritrea",
	  "Estland",
	  "Färöer",
	  "Falklandinseln",
	  "Fidschi",
	  "Finnland",
	  "Frankreich",
	  "Französisch-Guayana",
	  "Französisch-Polynesien",
	  "Französische Gebiete im südlichen Indischen Ozean",
	  "Gabun",
	  "Gambia",
	  "Georgien",
	  "Ghana",
	  "Gibraltar",
	  "Grönland",
	  "Grenada",
	  "Griechenland",
	  "Guadeloupe",
	  "Guam",
	  "Guatemala",
	  "Guinea",
	  "Guinea-Bissau",
	  "Guyana",
	  "Haiti",
	  "Heard und McDonaldinseln",
	  "Honduras",
	  "Hongkong",
	  "Indien",
	  "Indonesien",
	  "Irak",
	  "Iran",
	  "Irland",
	  "Island",
	  "Israel",
	  "Italien",
	  "Jamaika",
	  "Japan",
	  "Jemen",
	  "Jordanien",
	  "Jugoslawien",
	  "Kaimaninseln",
	  "Kambodscha",
	  "Kamerun",
	  "Kanada",
	  "Kap Verde",
	  "Kasachstan",
	  "Katar",
	  "Kenia",
	  "Kirgisistan",
	  "Kiribati",
	  "Kleinere amerikanische Überseeinseln",
	  "Kokosinseln",
	  "Kolumbien",
	  "Komoren",
	  "Kongo",
	  "Kroatien",
	  "Kuba",
	  "Kuwait",
	  "Laos",
	  "Lesotho",
	  "Lettland",
	  "Libanon",
	  "Liberia",
	  "Libyen",
	  "Liechtenstein",
	  "Litauen",
	  "Luxemburg",
	  "Macau",
	  "Madagaskar",
	  "Malawi",
	  "Malaysia",
	  "Malediven",
	  "Mali",
	  "Malta",
	  "ehemalige jugoslawische Republik Mazedonien",
	  "Marokko",
	  "Marshallinseln",
	  "Martinique",
	  "Mauretanien",
	  "Mauritius",
	  "Mayotte",
	  "Mexiko",
	  "Mikronesien",
	  "Monaco",
	  "Mongolei",
	  "Montserrat",
	  "Mosambik",
	  "Myanmar",
	  "Nördliche Marianen",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Neukaledonien",
	  "Neuseeland",
	  "Nicaragua",
	  "Niederländische Antillen",
	  "Niederlande",
	  "Niger",
	  "Nigeria",
	  "Niue",
	  "Norfolkinsel",
	  "Norwegen",
	  "Oman",
	  "Osttimor",
	  "Pakistan",
	  "Palau",
	  "Panama",
	  "Papua-Neuguinea",
	  "Paraguay",
	  "Peru",
	  "Philippinen",
	  "Pitcairninseln",
	  "Polen",
	  "Portugal",
	  "Puerto Rico",
	  "Réunion",
	  "Republik Korea",
	  "Republik Moldau",
	  "Ruanda",
	  "Rumänien",
	  "Russische Föderation",
	  "São Tomé und Príncipe",
	  "Südafrika",
	  "Südgeorgien und Südliche Sandwichinseln",
	  "Salomonen",
	  "Sambia",
	  "Samoa",
	  "San Marino",
	  "Saudi-Arabien",
	  "Schweden",
	  "Schweiz",
	  "Senegal",
	  "Seychellen",
	  "Sierra Leone",
	  "Simbabwe",
	  "Singapur",
	  "Slowakei",
	  "Slowenien",
	  "Somalien",
	  "Spanien",
	  "Sri Lanka",
	  "St. Helena",
	  "St. Kitts und Nevis",
	  "St. Lucia",
	  "St. Pierre und Miquelon",
	  "St. Vincent und die Grenadinen",
	  "Sudan",
	  "Surinam",
	  "Svalbard und Jan Mayen",
	  "Swasiland",
	  "Syrien",
	  "Türkei",
	  "Tadschikistan",
	  "Taiwan",
	  "Tansania",
	  "Thailand",
	  "Togo",
	  "Tokelau",
	  "Tonga",
	  "Trinidad und Tobago",
	  "Tschad",
	  "Tschechische Republik",
	  "Tunesien",
	  "Turkmenistan",
	  "Turks- und Caicosinseln",
	  "Tuvalu",
	  "Uganda",
	  "Ukraine",
	  "Ungarn",
	  "Uruguay",
	  "Usbekistan",
	  "Vanuatu",
	  "Vatikanstadt",
	  "Venezuela",
	  "Vereinigte Arabische Emirate",
	  "Vereinigte Staaten",
	  "Vereinigtes Königreich",
	  "Vietnam",
	  "Wallis und Futuna",
	  "Weihnachtsinsel",
	  "Westsahara",
	  "Zentralafrikanische Republik",
	  "Zypern"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Deutschland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(370);
	address.city_suffix = __webpack_require__(371);
	address.country = __webpack_require__(372);
	address.street_root = __webpack_require__(381);
	address.building_number = __webpack_require__(368);
	address.secondary_address = __webpack_require__(376);
	address.postcode = __webpack_require__(375);
	address.state = __webpack_require__(377);
	address.state_abbr = __webpack_require__(378);
	address.city = __webpack_require__(369);
	address.street_name = __webpack_require__(380);
	address.street_address = __webpack_require__(379);
	address.default_country = __webpack_require__(373);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apt. ###",
	  "Zimmer ###",
	  "# OG"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Baden-Württemberg",
	  "Bayern",
	  "Berlin",
	  "Brandenburg",
	  "Bremen",
	  "Hamburg",
	  "Hessen",
	  "Mecklenburg-Vorpommern",
	  "Niedersachsen",
	  "Nordrhein-Westfalen",
	  "Rheinland-Pfalz",
	  "Saarland",
	  "Sachsen",
	  "Sachsen-Anhalt",
	  "Schleswig-Holstein",
	  "Thüringen"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "BW",
	  "BY",
	  "BE",
	  "BB",
	  "HB",
	  "HH",
	  "HE",
	  "MV",
	  "NI",
	  "NW",
	  "RP",
	  "SL",
	  "SN",
	  "ST",
	  "SH",
	  "TH"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ackerweg",
	  "Adalbert-Stifter-Str.",
	  "Adalbertstr.",
	  "Adolf-Baeyer-Str.",
	  "Adolf-Kaschny-Str.",
	  "Adolf-Reichwein-Str.",
	  "Adolfsstr.",
	  "Ahornweg",
	  "Ahrstr.",
	  "Akazienweg",
	  "Albert-Einstein-Str.",
	  "Albert-Schweitzer-Str.",
	  "Albertus-Magnus-Str.",
	  "Albert-Zarthe-Weg",
	  "Albin-Edelmann-Str.",
	  "Albrecht-Haushofer-Str.",
	  "Aldegundisstr.",
	  "Alexanderstr.",
	  "Alfred-Delp-Str.",
	  "Alfred-Kubin-Str.",
	  "Alfred-Stock-Str.",
	  "Alkenrather Str.",
	  "Allensteiner Str.",
	  "Alsenstr.",
	  "Alt Steinbücheler Weg",
	  "Alte Garten",
	  "Alte Heide",
	  "Alte Landstr.",
	  "Alte Ziegelei",
	  "Altenberger Str.",
	  "Altenhof",
	  "Alter Grenzweg",
	  "Altstadtstr.",
	  "Am Alten Gaswerk",
	  "Am Alten Schafstall",
	  "Am Arenzberg",
	  "Am Benthal",
	  "Am Birkenberg",
	  "Am Blauen Berg",
	  "Am Borsberg",
	  "Am Brungen",
	  "Am Büchelter Hof",
	  "Am Buttermarkt",
	  "Am Ehrenfriedhof",
	  "Am Eselsdamm",
	  "Am Falkenberg",
	  "Am Frankenberg",
	  "Am Gesundheitspark",
	  "Am Gierlichshof",
	  "Am Graben",
	  "Am Hagelkreuz",
	  "Am Hang",
	  "Am Heidkamp",
	  "Am Hemmelrather Hof",
	  "Am Hofacker",
	  "Am Hohen Ufer",
	  "Am Höllers Eck",
	  "Am Hühnerberg",
	  "Am Jägerhof",
	  "Am Junkernkamp",
	  "Am Kemperstiegel",
	  "Am Kettnersbusch",
	  "Am Kiesberg",
	  "Am Klösterchen",
	  "Am Knechtsgraben",
	  "Am Köllerweg",
	  "Am Köttersbach",
	  "Am Kreispark",
	  "Am Kronefeld",
	  "Am Küchenhof",
	  "Am Kühnsbusch",
	  "Am Lindenfeld",
	  "Am Märchen",
	  "Am Mittelberg",
	  "Am Mönchshof",
	  "Am Mühlenbach",
	  "Am Neuenhof",
	  "Am Nonnenbruch",
	  "Am Plattenbusch",
	  "Am Quettinger Feld",
	  "Am Rosenhügel",
	  "Am Sandberg",
	  "Am Scherfenbrand",
	  "Am Schokker",
	  "Am Silbersee",
	  "Am Sonnenhang",
	  "Am Sportplatz",
	  "Am Stadtpark",
	  "Am Steinberg",
	  "Am Telegraf",
	  "Am Thelenhof",
	  "Am Vogelkreuz",
	  "Am Vogelsang",
	  "Am Vogelsfeldchen",
	  "Am Wambacher Hof",
	  "Am Wasserturm",
	  "Am Weidenbusch",
	  "Am Weiher",
	  "Am Weingarten",
	  "Am Werth",
	  "Amselweg",
	  "An den Irlen",
	  "An den Rheinauen",
	  "An der Bergerweide",
	  "An der Dingbank",
	  "An der Evangelischen Kirche",
	  "An der Evgl. Kirche",
	  "An der Feldgasse",
	  "An der Fettehenne",
	  "An der Kante",
	  "An der Laach",
	  "An der Lehmkuhle",
	  "An der Lichtenburg",
	  "An der Luisenburg",
	  "An der Robertsburg",
	  "An der Schmitten",
	  "An der Schusterinsel",
	  "An der Steinrütsch",
	  "An St. Andreas",
	  "An St. Remigius",
	  "Andreasstr.",
	  "Ankerweg",
	  "Annette-Kolb-Str.",
	  "Apenrader Str.",
	  "Arnold-Ohletz-Str.",
	  "Atzlenbacher Str.",
	  "Auerweg",
	  "Auestr.",
	  "Auf dem Acker",
	  "Auf dem Blahnenhof",
	  "Auf dem Bohnbüchel",
	  "Auf dem Bruch",
	  "Auf dem End",
	  "Auf dem Forst",
	  "Auf dem Herberg",
	  "Auf dem Lehn",
	  "Auf dem Stein",
	  "Auf dem Weierberg",
	  "Auf dem Weiherhahn",
	  "Auf den Reien",
	  "Auf der Donnen",
	  "Auf der Grieße",
	  "Auf der Ohmer",
	  "Auf der Weide",
	  "Auf'm Berg",
	  "Auf'm Kamp",
	  "Augustastr.",
	  "August-Kekulé-Str.",
	  "A.-W.-v.-Hofmann-Str.",
	  "Bahnallee",
	  "Bahnhofstr.",
	  "Baltrumstr.",
	  "Bamberger Str.",
	  "Baumberger Str.",
	  "Bebelstr.",
	  "Beckers Kämpchen",
	  "Beerenstr.",
	  "Beethovenstr.",
	  "Behringstr.",
	  "Bendenweg",
	  "Bensberger Str.",
	  "Benzstr.",
	  "Bergische Landstr.",
	  "Bergstr.",
	  "Berliner Platz",
	  "Berliner Str.",
	  "Bernhard-Letterhaus-Str.",
	  "Bernhard-Lichtenberg-Str.",
	  "Bernhard-Ridder-Str.",
	  "Bernsteinstr.",
	  "Bertha-Middelhauve-Str.",
	  "Bertha-von-Suttner-Str.",
	  "Bertolt-Brecht-Str.",
	  "Berzeliusstr.",
	  "Bielertstr.",
	  "Biesenbach",
	  "Billrothstr.",
	  "Birkenbergstr.",
	  "Birkengartenstr.",
	  "Birkenweg",
	  "Bismarckstr.",
	  "Bitterfelder Str.",
	  "Blankenburg",
	  "Blaukehlchenweg",
	  "Blütenstr.",
	  "Boberstr.",
	  "Böcklerstr.",
	  "Bodelschwinghstr.",
	  "Bodestr.",
	  "Bogenstr.",
	  "Bohnenkampsweg",
	  "Bohofsweg",
	  "Bonifatiusstr.",
	  "Bonner Str.",
	  "Borkumstr.",
	  "Bornheimer Str.",
	  "Borsigstr.",
	  "Borussiastr.",
	  "Bracknellstr.",
	  "Brahmsweg",
	  "Brandenburger Str.",
	  "Breidenbachstr.",
	  "Breslauer Str.",
	  "Bruchhauser Str.",
	  "Brückenstr.",
	  "Brucknerstr.",
	  "Brüder-Bonhoeffer-Str.",
	  "Buchenweg",
	  "Bürgerbuschweg",
	  "Burgloch",
	  "Burgplatz",
	  "Burgstr.",
	  "Burgweg",
	  "Bürriger Weg",
	  "Burscheider Str.",
	  "Buschkämpchen",
	  "Butterheider Str.",
	  "Carl-Duisberg-Platz",
	  "Carl-Duisberg-Str.",
	  "Carl-Leverkus-Str.",
	  "Carl-Maria-von-Weber-Platz",
	  "Carl-Maria-von-Weber-Str.",
	  "Carlo-Mierendorff-Str.",
	  "Carl-Rumpff-Str.",
	  "Carl-von-Ossietzky-Str.",
	  "Charlottenburger Str.",
	  "Christian-Heß-Str.",
	  "Claasbruch",
	  "Clemens-Winkler-Str.",
	  "Concordiastr.",
	  "Cranachstr.",
	  "Dahlemer Str.",
	  "Daimlerstr.",
	  "Damaschkestr.",
	  "Danziger Str.",
	  "Debengasse",
	  "Dechant-Fein-Str.",
	  "Dechant-Krey-Str.",
	  "Deichtorstr.",
	  "Dhünnberg",
	  "Dhünnstr.",
	  "Dianastr.",
	  "Diedenhofener Str.",
	  "Diepental",
	  "Diepenthaler Str.",
	  "Dieselstr.",
	  "Dillinger Str.",
	  "Distelkamp",
	  "Dohrgasse",
	  "Domblick",
	  "Dönhoffstr.",
	  "Dornierstr.",
	  "Drachenfelsstr.",
	  "Dr.-August-Blank-Str.",
	  "Dresdener Str.",
	  "Driescher Hecke",
	  "Drosselweg",
	  "Dudweilerstr.",
	  "Dünenweg",
	  "Dünfelder Str.",
	  "Dünnwalder Grenzweg",
	  "Düppeler Str.",
	  "Dürerstr.",
	  "Dürscheider Weg",
	  "Düsseldorfer Str.",
	  "Edelrather Weg",
	  "Edmund-Husserl-Str.",
	  "Eduard-Spranger-Str.",
	  "Ehrlichstr.",
	  "Eichenkamp",
	  "Eichenweg",
	  "Eidechsenweg",
	  "Eifelstr.",
	  "Eifgenstr.",
	  "Eintrachtstr.",
	  "Elbestr.",
	  "Elisabeth-Langgässer-Str.",
	  "Elisabethstr.",
	  "Elisabeth-von-Thadden-Str.",
	  "Elisenstr.",
	  "Elsa-Brändström-Str.",
	  "Elsbachstr.",
	  "Else-Lasker-Schüler-Str.",
	  "Elsterstr.",
	  "Emil-Fischer-Str.",
	  "Emil-Nolde-Str.",
	  "Engelbertstr.",
	  "Engstenberger Weg",
	  "Entenpfuhl",
	  "Erbelegasse",
	  "Erftstr.",
	  "Erfurter Str.",
	  "Erich-Heckel-Str.",
	  "Erich-Klausener-Str.",
	  "Erich-Ollenhauer-Str.",
	  "Erlenweg",
	  "Ernst-Bloch-Str.",
	  "Ernst-Ludwig-Kirchner-Str.",
	  "Erzbergerstr.",
	  "Eschenallee",
	  "Eschenweg",
	  "Esmarchstr.",
	  "Espenweg",
	  "Euckenstr.",
	  "Eulengasse",
	  "Eulenkamp",
	  "Ewald-Flamme-Str.",
	  "Ewald-Röll-Str.",
	  "Fährstr.",
	  "Farnweg",
	  "Fasanenweg",
	  "Faßbacher Hof",
	  "Felderstr.",
	  "Feldkampstr.",
	  "Feldsiefer Weg",
	  "Feldsiefer Wiesen",
	  "Feldstr.",
	  "Feldtorstr.",
	  "Felix-von-Roll-Str.",
	  "Ferdinand-Lassalle-Str.",
	  "Fester Weg",
	  "Feuerbachstr.",
	  "Feuerdornweg",
	  "Fichtenweg",
	  "Fichtestr.",
	  "Finkelsteinstr.",
	  "Finkenweg",
	  "Fixheider Str.",
	  "Flabbenhäuschen",
	  "Flensburger Str.",
	  "Fliederweg",
	  "Florastr.",
	  "Florianweg",
	  "Flotowstr.",
	  "Flurstr.",
	  "Föhrenweg",
	  "Fontanestr.",
	  "Forellental",
	  "Fortunastr.",
	  "Franz-Esser-Str.",
	  "Franz-Hitze-Str.",
	  "Franz-Kail-Str.",
	  "Franz-Marc-Str.",
	  "Freiburger Str.",
	  "Freiheitstr.",
	  "Freiherr-vom-Stein-Str.",
	  "Freudenthal",
	  "Freudenthaler Weg",
	  "Fridtjof-Nansen-Str.",
	  "Friedenberger Str.",
	  "Friedensstr.",
	  "Friedhofstr.",
	  "Friedlandstr.",
	  "Friedlieb-Ferdinand-Runge-Str.",
	  "Friedrich-Bayer-Str.",
	  "Friedrich-Bergius-Platz",
	  "Friedrich-Ebert-Platz",
	  "Friedrich-Ebert-Str.",
	  "Friedrich-Engels-Str.",
	  "Friedrich-List-Str.",
	  "Friedrich-Naumann-Str.",
	  "Friedrich-Sertürner-Str.",
	  "Friedrichstr.",
	  "Friedrich-Weskott-Str.",
	  "Friesenweg",
	  "Frischenberg",
	  "Fritz-Erler-Str.",
	  "Fritz-Henseler-Str.",
	  "Fröbelstr.",
	  "Fürstenbergplatz",
	  "Fürstenbergstr.",
	  "Gabriele-Münter-Str.",
	  "Gartenstr.",
	  "Gebhardstr.",
	  "Geibelstr.",
	  "Gellertstr.",
	  "Georg-von-Vollmar-Str.",
	  "Gerhard-Domagk-Str.",
	  "Gerhart-Hauptmann-Str.",
	  "Gerichtsstr.",
	  "Geschwister-Scholl-Str.",
	  "Gezelinallee",
	  "Gierener Weg",
	  "Ginsterweg",
	  "Gisbert-Cremer-Str.",
	  "Glücksburger Str.",
	  "Gluckstr.",
	  "Gneisenaustr.",
	  "Goetheplatz",
	  "Goethestr.",
	  "Golo-Mann-Str.",
	  "Görlitzer Str.",
	  "Görresstr.",
	  "Graebestr.",
	  "Graf-Galen-Platz",
	  "Gregor-Mendel-Str.",
	  "Greifswalder Str.",
	  "Grillenweg",
	  "Gronenborner Weg",
	  "Große Kirchstr.",
	  "Grunder Wiesen",
	  "Grundermühle",
	  "Grundermühlenhof",
	  "Grundermühlenweg",
	  "Grüner Weg",
	  "Grunewaldstr.",
	  "Grünstr.",
	  "Günther-Weisenborn-Str.",
	  "Gustav-Freytag-Str.",
	  "Gustav-Heinemann-Str.",
	  "Gustav-Radbruch-Str.",
	  "Gut Reuschenberg",
	  "Gutenbergstr.",
	  "Haberstr.",
	  "Habichtgasse",
	  "Hafenstr.",
	  "Hagenauer Str.",
	  "Hahnenblecher",
	  "Halenseestr.",
	  "Halfenleimbach",
	  "Hallesche Str.",
	  "Halligstr.",
	  "Hamberger Str.",
	  "Hammerweg",
	  "Händelstr.",
	  "Hannah-Höch-Str.",
	  "Hans-Arp-Str.",
	  "Hans-Gerhard-Str.",
	  "Hans-Sachs-Str.",
	  "Hans-Schlehahn-Str.",
	  "Hans-von-Dohnanyi-Str.",
	  "Hardenbergstr.",
	  "Haselweg",
	  "Hauptstr.",
	  "Haus-Vorster-Str.",
	  "Hauweg",
	  "Havelstr.",
	  "Havensteinstr.",
	  "Haydnstr.",
	  "Hebbelstr.",
	  "Heckenweg",
	  "Heerweg",
	  "Hegelstr.",
	  "Heidberg",
	  "Heidehöhe",
	  "Heidestr.",
	  "Heimstättenweg",
	  "Heinrich-Böll-Str.",
	  "Heinrich-Brüning-Str.",
	  "Heinrich-Claes-Str.",
	  "Heinrich-Heine-Str.",
	  "Heinrich-Hörlein-Str.",
	  "Heinrich-Lübke-Str.",
	  "Heinrich-Lützenkirchen-Weg",
	  "Heinrichstr.",
	  "Heinrich-Strerath-Str.",
	  "Heinrich-von-Kleist-Str.",
	  "Heinrich-von-Stephan-Str.",
	  "Heisterbachstr.",
	  "Helenenstr.",
	  "Helmestr.",
	  "Hemmelrather Weg",
	  "Henry-T.-v.-Böttinger-Str.",
	  "Herderstr.",
	  "Heribertstr.",
	  "Hermann-Ehlers-Str.",
	  "Hermann-Hesse-Str.",
	  "Hermann-König-Str.",
	  "Hermann-Löns-Str.",
	  "Hermann-Milde-Str.",
	  "Hermann-Nörrenberg-Str.",
	  "Hermann-von-Helmholtz-Str.",
	  "Hermann-Waibel-Str.",
	  "Herzogstr.",
	  "Heymannstr.",
	  "Hindenburgstr.",
	  "Hirzenberg",
	  "Hitdorfer Kirchweg",
	  "Hitdorfer Str.",
	  "Höfer Mühle",
	  "Höfer Weg",
	  "Hohe Str.",
	  "Höhenstr.",
	  "Höltgestal",
	  "Holunderweg",
	  "Holzer Weg",
	  "Holzer Wiesen",
	  "Hornpottweg",
	  "Hubertusweg",
	  "Hufelandstr.",
	  "Hufer Weg",
	  "Humboldtstr.",
	  "Hummelsheim",
	  "Hummelweg",
	  "Humperdinckstr.",
	  "Hüscheider Gärten",
	  "Hüscheider Str.",
	  "Hütte",
	  "Ilmstr.",
	  "Im Bergischen Heim",
	  "Im Bruch",
	  "Im Buchenhain",
	  "Im Bühl",
	  "Im Burgfeld",
	  "Im Dorf",
	  "Im Eisholz",
	  "Im Friedenstal",
	  "Im Frohental",
	  "Im Grunde",
	  "Im Hederichsfeld",
	  "Im Jücherfeld",
	  "Im Kalkfeld",
	  "Im Kirberg",
	  "Im Kirchfeld",
	  "Im Kreuzbruch",
	  "Im Mühlenfeld",
	  "Im Nesselrader Kamp",
	  "Im Oberdorf",
	  "Im Oberfeld",
	  "Im Rosengarten",
	  "Im Rottland",
	  "Im Scheffengarten",
	  "Im Staderfeld",
	  "Im Steinfeld",
	  "Im Weidenblech",
	  "Im Winkel",
	  "Im Ziegelfeld",
	  "Imbach",
	  "Imbacher Weg",
	  "Immenweg",
	  "In den Blechenhöfen",
	  "In den Dehlen",
	  "In der Birkenau",
	  "In der Dasladen",
	  "In der Felderhütten",
	  "In der Hartmannswiese",
	  "In der Höhle",
	  "In der Schaafsdellen",
	  "In der Wasserkuhl",
	  "In der Wüste",
	  "In Holzhausen",
	  "Insterstr.",
	  "Jacob-Fröhlen-Str.",
	  "Jägerstr.",
	  "Jahnstr.",
	  "Jakob-Eulenberg-Weg",
	  "Jakobistr.",
	  "Jakob-Kaiser-Str.",
	  "Jenaer Str.",
	  "Johannes-Baptist-Str.",
	  "Johannes-Dott-Str.",
	  "Johannes-Popitz-Str.",
	  "Johannes-Wislicenus-Str.",
	  "Johannisburger Str.",
	  "Johann-Janssen-Str.",
	  "Johann-Wirtz-Weg",
	  "Josefstr.",
	  "Jüch",
	  "Julius-Doms-Str.",
	  "Julius-Leber-Str.",
	  "Kaiserplatz",
	  "Kaiserstr.",
	  "Kaiser-Wilhelm-Allee",
	  "Kalkstr.",
	  "Kämpchenstr.",
	  "Kämpenwiese",
	  "Kämper Weg",
	  "Kamptalweg",
	  "Kanalstr.",
	  "Kandinskystr.",
	  "Kantstr.",
	  "Kapellenstr.",
	  "Karl-Arnold-Str.",
	  "Karl-Bosch-Str.",
	  "Karl-Bückart-Str.",
	  "Karl-Carstens-Ring",
	  "Karl-Friedrich-Goerdeler-Str.",
	  "Karl-Jaspers-Str.",
	  "Karl-König-Str.",
	  "Karl-Krekeler-Str.",
	  "Karl-Marx-Str.",
	  "Karlstr.",
	  "Karl-Ulitzka-Str.",
	  "Karl-Wichmann-Str.",
	  "Karl-Wingchen-Str.",
	  "Käsenbrod",
	  "Käthe-Kollwitz-Str.",
	  "Katzbachstr.",
	  "Kerschensteinerstr.",
	  "Kiefernweg",
	  "Kieler Str.",
	  "Kieselstr.",
	  "Kiesweg",
	  "Kinderhausen",
	  "Kleiberweg",
	  "Kleine Kirchstr.",
	  "Kleingansweg",
	  "Kleinheider Weg",
	  "Klief",
	  "Kneippstr.",
	  "Knochenbergsweg",
	  "Kochergarten",
	  "Kocherstr.",
	  "Kockelsberg",
	  "Kolberger Str.",
	  "Kolmarer Str.",
	  "Kölner Gasse",
	  "Kölner Str.",
	  "Kolpingstr.",
	  "Königsberger Platz",
	  "Konrad-Adenauer-Platz",
	  "Köpenicker Str.",
	  "Kopernikusstr.",
	  "Körnerstr.",
	  "Köschenberg",
	  "Köttershof",
	  "Kreuzbroicher Str.",
	  "Kreuzkamp",
	  "Krummer Weg",
	  "Kruppstr.",
	  "Kuhlmannweg",
	  "Kump",
	  "Kumper Weg",
	  "Kunstfeldstr.",
	  "Küppersteger Str.",
	  "Kursiefen",
	  "Kursiefer Weg",
	  "Kurtekottenweg",
	  "Kurt-Schumacher-Ring",
	  "Kyllstr.",
	  "Langenfelder Str.",
	  "Längsleimbach",
	  "Lärchenweg",
	  "Legienstr.",
	  "Lehner Mühle",
	  "Leichlinger Str.",
	  "Leimbacher Hof",
	  "Leinestr.",
	  "Leineweberstr.",
	  "Leipziger Str.",
	  "Lerchengasse",
	  "Lessingstr.",
	  "Libellenweg",
	  "Lichstr.",
	  "Liebigstr.",
	  "Lindenstr.",
	  "Lingenfeld",
	  "Linienstr.",
	  "Lippe",
	  "Löchergraben",
	  "Löfflerstr.",
	  "Loheweg",
	  "Lohrbergstr.",
	  "Lohrstr.",
	  "Löhstr.",
	  "Lortzingstr.",
	  "Lötzener Str.",
	  "Löwenburgstr.",
	  "Lucasstr.",
	  "Ludwig-Erhard-Platz",
	  "Ludwig-Girtler-Str.",
	  "Ludwig-Knorr-Str.",
	  "Luisenstr.",
	  "Lupinenweg",
	  "Lurchenweg",
	  "Lützenkirchener Str.",
	  "Lycker Str.",
	  "Maashofstr.",
	  "Manforter Str.",
	  "Marc-Chagall-Str.",
	  "Maria-Dresen-Str.",
	  "Maria-Terwiel-Str.",
	  "Marie-Curie-Str.",
	  "Marienburger Str.",
	  "Mariendorfer Str.",
	  "Marienwerderstr.",
	  "Marie-Schlei-Str.",
	  "Marktplatz",
	  "Markusweg",
	  "Martin-Buber-Str.",
	  "Martin-Heidegger-Str.",
	  "Martin-Luther-Str.",
	  "Masurenstr.",
	  "Mathildenweg",
	  "Maurinusstr.",
	  "Mauspfad",
	  "Max-Beckmann-Str.",
	  "Max-Delbrück-Str.",
	  "Max-Ernst-Str.",
	  "Max-Holthausen-Platz",
	  "Max-Horkheimer-Str.",
	  "Max-Liebermann-Str.",
	  "Max-Pechstein-Str.",
	  "Max-Planck-Str.",
	  "Max-Scheler-Str.",
	  "Max-Schönenberg-Str.",
	  "Maybachstr.",
	  "Meckhofer Feld",
	  "Meisenweg",
	  "Memelstr.",
	  "Menchendahler Str.",
	  "Mendelssohnstr.",
	  "Merziger Str.",
	  "Mettlacher Str.",
	  "Metzer Str.",
	  "Michaelsweg",
	  "Miselohestr.",
	  "Mittelstr.",
	  "Mohlenstr.",
	  "Moltkestr.",
	  "Monheimer Str.",
	  "Montanusstr.",
	  "Montessoriweg",
	  "Moosweg",
	  "Morsbroicher Str.",
	  "Moselstr.",
	  "Moskauer Str.",
	  "Mozartstr.",
	  "Mühlenweg",
	  "Muhrgasse",
	  "Muldestr.",
	  "Mülhausener Str.",
	  "Mülheimer Str.",
	  "Münsters Gäßchen",
	  "Münzstr.",
	  "Müritzstr.",
	  "Myliusstr.",
	  "Nachtigallenweg",
	  "Nauener Str.",
	  "Neißestr.",
	  "Nelly-Sachs-Str.",
	  "Netzestr.",
	  "Neuendriesch",
	  "Neuenhausgasse",
	  "Neuenkamp",
	  "Neujudenhof",
	  "Neukronenberger Str.",
	  "Neustadtstr.",
	  "Nicolai-Hartmann-Str.",
	  "Niederblecher",
	  "Niederfeldstr.",
	  "Nietzschestr.",
	  "Nikolaus-Groß-Str.",
	  "Nobelstr.",
	  "Norderneystr.",
	  "Nordstr.",
	  "Ober dem Hof",
	  "Obere Lindenstr.",
	  "Obere Str.",
	  "Oberölbach",
	  "Odenthaler Str.",
	  "Oderstr.",
	  "Okerstr.",
	  "Olof-Palme-Str.",
	  "Ophovener Str.",
	  "Opladener Platz",
	  "Opladener Str.",
	  "Ortelsburger Str.",
	  "Oskar-Moll-Str.",
	  "Oskar-Schlemmer-Str.",
	  "Oststr.",
	  "Oswald-Spengler-Str.",
	  "Otto-Dix-Str.",
	  "Otto-Grimm-Str.",
	  "Otto-Hahn-Str.",
	  "Otto-Müller-Str.",
	  "Otto-Stange-Str.",
	  "Ottostr.",
	  "Otto-Varnhagen-Str.",
	  "Otto-Wels-Str.",
	  "Ottweilerstr.",
	  "Oulustr.",
	  "Overfeldweg",
	  "Pappelweg",
	  "Paracelsusstr.",
	  "Parkstr.",
	  "Pastor-Louis-Str.",
	  "Pastor-Scheibler-Str.",
	  "Pastorskamp",
	  "Paul-Klee-Str.",
	  "Paul-Löbe-Str.",
	  "Paulstr.",
	  "Peenestr.",
	  "Pescher Busch",
	  "Peschstr.",
	  "Pestalozzistr.",
	  "Peter-Grieß-Str.",
	  "Peter-Joseph-Lenné-Str.",
	  "Peter-Neuenheuser-Str.",
	  "Petersbergstr.",
	  "Peterstr.",
	  "Pfarrer-Jekel-Str.",
	  "Pfarrer-Klein-Str.",
	  "Pfarrer-Röhr-Str.",
	  "Pfeilshofstr.",
	  "Philipp-Ott-Str.",
	  "Piet-Mondrian-Str.",
	  "Platanenweg",
	  "Pommernstr.",
	  "Porschestr.",
	  "Poststr.",
	  "Potsdamer Str.",
	  "Pregelstr.",
	  "Prießnitzstr.",
	  "Pützdelle",
	  "Quarzstr.",
	  "Quettinger Str.",
	  "Rat-Deycks-Str.",
	  "Rathenaustr.",
	  "Ratherkämp",
	  "Ratiborer Str.",
	  "Raushofstr.",
	  "Regensburger Str.",
	  "Reinickendorfer Str.",
	  "Renkgasse",
	  "Rennbaumplatz",
	  "Rennbaumstr.",
	  "Reuschenberger Str.",
	  "Reusrather Str.",
	  "Reuterstr.",
	  "Rheinallee",
	  "Rheindorfer Str.",
	  "Rheinstr.",
	  "Rhein-Wupper-Platz",
	  "Richard-Wagner-Str.",
	  "Rilkestr.",
	  "Ringstr.",
	  "Robert-Blum-Str.",
	  "Robert-Koch-Str.",
	  "Robert-Medenwald-Str.",
	  "Rolandstr.",
	  "Romberg",
	  "Röntgenstr.",
	  "Roonstr.",
	  "Ropenstall",
	  "Ropenstaller Weg",
	  "Rosenthal",
	  "Rostocker Str.",
	  "Rotdornweg",
	  "Röttgerweg",
	  "Rückertstr.",
	  "Rudolf-Breitscheid-Str.",
	  "Rudolf-Mann-Platz",
	  "Rudolf-Stracke-Str.",
	  "Ruhlachplatz",
	  "Ruhlachstr.",
	  "Rüttersweg",
	  "Saalestr.",
	  "Saarbrücker Str.",
	  "Saarlauterner Str.",
	  "Saarstr.",
	  "Salamanderweg",
	  "Samlandstr.",
	  "Sanddornstr.",
	  "Sandstr.",
	  "Sauerbruchstr.",
	  "Schäfershütte",
	  "Scharnhorststr.",
	  "Scheffershof",
	  "Scheidemannstr.",
	  "Schellingstr.",
	  "Schenkendorfstr.",
	  "Schießbergstr.",
	  "Schillerstr.",
	  "Schlangenhecke",
	  "Schlebuscher Heide",
	  "Schlebuscher Str.",
	  "Schlebuschrath",
	  "Schlehdornstr.",
	  "Schleiermacherstr.",
	  "Schloßstr.",
	  "Schmalenbruch",
	  "Schnepfenflucht",
	  "Schöffenweg",
	  "Schöllerstr.",
	  "Schöne Aussicht",
	  "Schöneberger Str.",
	  "Schopenhauerstr.",
	  "Schubertplatz",
	  "Schubertstr.",
	  "Schulberg",
	  "Schulstr.",
	  "Schumannstr.",
	  "Schwalbenweg",
	  "Schwarzastr.",
	  "Sebastianusweg",
	  "Semmelweisstr.",
	  "Siebelplatz",
	  "Siemensstr.",
	  "Solinger Str.",
	  "Sonderburger Str.",
	  "Spandauer Str.",
	  "Speestr.",
	  "Sperberweg",
	  "Sperlingsweg",
	  "Spitzwegstr.",
	  "Sporrenberger Mühle",
	  "Spreestr.",
	  "St. Ingberter Str.",
	  "Starenweg",
	  "Stauffenbergstr.",
	  "Stefan-Zweig-Str.",
	  "Stegerwaldstr.",
	  "Steglitzer Str.",
	  "Steinbücheler Feld",
	  "Steinbücheler Str.",
	  "Steinstr.",
	  "Steinweg",
	  "Stephan-Lochner-Str.",
	  "Stephanusstr.",
	  "Stettiner Str.",
	  "Stixchesstr.",
	  "Stöckenstr.",
	  "Stralsunder Str.",
	  "Straßburger Str.",
	  "Stresemannplatz",
	  "Strombergstr.",
	  "Stromstr.",
	  "Stüttekofener Str.",
	  "Sudestr.",
	  "Sürderstr.",
	  "Syltstr.",
	  "Talstr.",
	  "Tannenbergstr.",
	  "Tannenweg",
	  "Taubenweg",
	  "Teitscheider Weg",
	  "Telegrafenstr.",
	  "Teltower Str.",
	  "Tempelhofer Str.",
	  "Theodor-Adorno-Str.",
	  "Theodor-Fliedner-Str.",
	  "Theodor-Gierath-Str.",
	  "Theodor-Haubach-Str.",
	  "Theodor-Heuss-Ring",
	  "Theodor-Storm-Str.",
	  "Theodorstr.",
	  "Thomas-Dehler-Str.",
	  "Thomas-Morus-Str.",
	  "Thomas-von-Aquin-Str.",
	  "Tönges Feld",
	  "Torstr.",
	  "Treptower Str.",
	  "Treuburger Str.",
	  "Uhlandstr.",
	  "Ulmenweg",
	  "Ulmer Str.",
	  "Ulrichstr.",
	  "Ulrich-von-Hassell-Str.",
	  "Umlag",
	  "Unstrutstr.",
	  "Unter dem Schildchen",
	  "Unterölbach",
	  "Unterstr.",
	  "Uppersberg",
	  "Van\\'t-Hoff-Str.",
	  "Veit-Stoß-Str.",
	  "Vereinsstr.",
	  "Viktor-Meyer-Str.",
	  "Vincent-van-Gogh-Str.",
	  "Virchowstr.",
	  "Voigtslach",
	  "Volhardstr.",
	  "Völklinger Str.",
	  "Von-Brentano-Str.",
	  "Von-Diergardt-Str.",
	  "Von-Eichendorff-Str.",
	  "Von-Ketteler-Str.",
	  "Von-Knoeringen-Str.",
	  "Von-Pettenkofer-Str.",
	  "Von-Siebold-Str.",
	  "Wacholderweg",
	  "Waldstr.",
	  "Walter-Flex-Str.",
	  "Walter-Hempel-Str.",
	  "Walter-Hochapfel-Str.",
	  "Walter-Nernst-Str.",
	  "Wannseestr.",
	  "Warnowstr.",
	  "Warthestr.",
	  "Weddigenstr.",
	  "Weichselstr.",
	  "Weidenstr.",
	  "Weidfeldstr.",
	  "Weiherfeld",
	  "Weiherstr.",
	  "Weinhäuser Str.",
	  "Weißdornweg",
	  "Weißenseestr.",
	  "Weizkamp",
	  "Werftstr.",
	  "Werkstättenstr.",
	  "Werner-Heisenberg-Str.",
	  "Werrastr.",
	  "Weyerweg",
	  "Widdauener Str.",
	  "Wiebertshof",
	  "Wiehbachtal",
	  "Wiembachallee",
	  "Wiesdorfer Platz",
	  "Wiesenstr.",
	  "Wilhelm-Busch-Str.",
	  "Wilhelm-Hastrich-Str.",
	  "Wilhelm-Leuschner-Str.",
	  "Wilhelm-Liebknecht-Str.",
	  "Wilhelmsgasse",
	  "Wilhelmstr.",
	  "Willi-Baumeister-Str.",
	  "Willy-Brandt-Ring",
	  "Winand-Rossi-Str.",
	  "Windthorststr.",
	  "Winkelweg",
	  "Winterberg",
	  "Wittenbergstr.",
	  "Wolf-Vostell-Str.",
	  "Wolkenburgstr.",
	  "Wupperstr.",
	  "Wuppertalstr.",
	  "Wüstenhof",
	  "Yitzhak-Rabin-Str.",
	  "Zauberkuhle",
	  "Zedernweg",
	  "Zehlendorfer Str.",
	  "Zehntenweg",
	  "Zeisigweg",
	  "Zeppelinstr.",
	  "Zschopaustr.",
	  "Zum Claashäuschen",
	  "Zündhütchenweg",
	  "Zur Alten Brauerei",
	  "Zur alten Fabrik"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "+49-1##-#######",
	  "+49-1###-########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(382);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(387);
	company.legal_form = __webpack_require__(385);
	company.name = __webpack_require__(386);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "GmbH",
	  "AG",
	  "Gruppe",
	  "KG",
	  "GmbH & Co. KG",
	  "UG",
	  "OHG"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} und #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "GmbH",
	  "AG",
	  "Gruppe",
	  "KG",
	  "GmbH & Co. KG",
	  "UG",
	  "OHG"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var de = {};
	module['exports'] = de;
	de.title = "German";
	de.address = __webpack_require__(374);
	de.company = __webpack_require__(384);
	de.internet = __webpack_require__(391);
	de.lorem = __webpack_require__(392);
	de.name = __webpack_require__(395);
	de.phone_number = __webpack_require__(401);
	de.cell_phone = __webpack_require__(383);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "info",
	  "name",
	  "net",
	  "org",
	  "de",
	  "ch"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(390);
	internet.domain_suffix = __webpack_require__(389);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(393);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aaron",
	  "Abdul",
	  "Abdullah",
	  "Adam",
	  "Adrian",
	  "Adriano",
	  "Ahmad",
	  "Ahmed",
	  "Ahmet",
	  "Alan",
	  "Albert",
	  "Alessandro",
	  "Alessio",
	  "Alex",
	  "Alexander",
	  "Alfred",
	  "Ali",
	  "Amar",
	  "Amir",
	  "Amon",
	  "Andre",
	  "Andreas",
	  "Andrew",
	  "Angelo",
	  "Ansgar",
	  "Anthony",
	  "Anton",
	  "Antonio",
	  "Arda",
	  "Arian",
	  "Armin",
	  "Arne",
	  "Arno",
	  "Arthur",
	  "Artur",
	  "Arved",
	  "Arvid",
	  "Ayman",
	  "Baran",
	  "Baris",
	  "Bastian",
	  "Batuhan",
	  "Bela",
	  "Ben",
	  "Benedikt",
	  "Benjamin",
	  "Bennet",
	  "Bennett",
	  "Benno",
	  "Bent",
	  "Berat",
	  "Berkay",
	  "Bernd",
	  "Bilal",
	  "Bjarne",
	  "Björn",
	  "Bo",
	  "Boris",
	  "Brandon",
	  "Brian",
	  "Bruno",
	  "Bryan",
	  "Burak",
	  "Calvin",
	  "Can",
	  "Carl",
	  "Carlo",
	  "Carlos",
	  "Caspar",
	  "Cedric",
	  "Cedrik",
	  "Cem",
	  "Charlie",
	  "Chris",
	  "Christian",
	  "Christiano",
	  "Christoph",
	  "Christopher",
	  "Claas",
	  "Clemens",
	  "Colin",
	  "Collin",
	  "Conner",
	  "Connor",
	  "Constantin",
	  "Corvin",
	  "Curt",
	  "Damian",
	  "Damien",
	  "Daniel",
	  "Danilo",
	  "Danny",
	  "Darian",
	  "Dario",
	  "Darius",
	  "Darren",
	  "David",
	  "Davide",
	  "Davin",
	  "Dean",
	  "Deniz",
	  "Dennis",
	  "Denny",
	  "Devin",
	  "Diego",
	  "Dion",
	  "Domenic",
	  "Domenik",
	  "Dominic",
	  "Dominik",
	  "Dorian",
	  "Dustin",
	  "Dylan",
	  "Ecrin",
	  "Eddi",
	  "Eddy",
	  "Edgar",
	  "Edwin",
	  "Efe",
	  "Ege",
	  "Elia",
	  "Eliah",
	  "Elias",
	  "Elijah",
	  "Emanuel",
	  "Emil",
	  "Emilian",
	  "Emilio",
	  "Emir",
	  "Emirhan",
	  "Emre",
	  "Enes",
	  "Enno",
	  "Enrico",
	  "Eren",
	  "Eric",
	  "Erik",
	  "Etienne",
	  "Fabian",
	  "Fabien",
	  "Fabio",
	  "Fabrice",
	  "Falk",
	  "Felix",
	  "Ferdinand",
	  "Fiete",
	  "Filip",
	  "Finlay",
	  "Finley",
	  "Finn",
	  "Finnley",
	  "Florian",
	  "Francesco",
	  "Franz",
	  "Frederic",
	  "Frederick",
	  "Frederik",
	  "Friedrich",
	  "Fritz",
	  "Furkan",
	  "Fynn",
	  "Gabriel",
	  "Georg",
	  "Gerrit",
	  "Gian",
	  "Gianluca",
	  "Gino",
	  "Giuliano",
	  "Giuseppe",
	  "Gregor",
	  "Gustav",
	  "Hagen",
	  "Hamza",
	  "Hannes",
	  "Hanno",
	  "Hans",
	  "Hasan",
	  "Hassan",
	  "Hauke",
	  "Hendrik",
	  "Hennes",
	  "Henning",
	  "Henri",
	  "Henrick",
	  "Henrik",
	  "Henry",
	  "Hugo",
	  "Hussein",
	  "Ian",
	  "Ibrahim",
	  "Ilias",
	  "Ilja",
	  "Ilyas",
	  "Immanuel",
	  "Ismael",
	  "Ismail",
	  "Ivan",
	  "Iven",
	  "Jack",
	  "Jacob",
	  "Jaden",
	  "Jakob",
	  "Jamal",
	  "James",
	  "Jamie",
	  "Jan",
	  "Janek",
	  "Janis",
	  "Janne",
	  "Jannek",
	  "Jannes",
	  "Jannik",
	  "Jannis",
	  "Jano",
	  "Janosch",
	  "Jared",
	  "Jari",
	  "Jarne",
	  "Jarno",
	  "Jaron",
	  "Jason",
	  "Jasper",
	  "Jay",
	  "Jayden",
	  "Jayson",
	  "Jean",
	  "Jens",
	  "Jeremias",
	  "Jeremie",
	  "Jeremy",
	  "Jermaine",
	  "Jerome",
	  "Jesper",
	  "Jesse",
	  "Jim",
	  "Jimmy",
	  "Joe",
	  "Joel",
	  "Joey",
	  "Johann",
	  "Johannes",
	  "John",
	  "Johnny",
	  "Jon",
	  "Jona",
	  "Jonah",
	  "Jonas",
	  "Jonathan",
	  "Jonte",
	  "Joost",
	  "Jordan",
	  "Joris",
	  "Joscha",
	  "Joschua",
	  "Josef",
	  "Joseph",
	  "Josh",
	  "Joshua",
	  "Josua",
	  "Juan",
	  "Julian",
	  "Julien",
	  "Julius",
	  "Juri",
	  "Justin",
	  "Justus",
	  "Kaan",
	  "Kai",
	  "Kalle",
	  "Karim",
	  "Karl",
	  "Karlo",
	  "Kay",
	  "Keanu",
	  "Kenan",
	  "Kenny",
	  "Keno",
	  "Kerem",
	  "Kerim",
	  "Kevin",
	  "Kian",
	  "Kilian",
	  "Kim",
	  "Kimi",
	  "Kjell",
	  "Klaas",
	  "Klemens",
	  "Konrad",
	  "Konstantin",
	  "Koray",
	  "Korbinian",
	  "Kurt",
	  "Lars",
	  "Lasse",
	  "Laurence",
	  "Laurens",
	  "Laurenz",
	  "Laurin",
	  "Lean",
	  "Leander",
	  "Leandro",
	  "Leif",
	  "Len",
	  "Lenn",
	  "Lennard",
	  "Lennart",
	  "Lennert",
	  "Lennie",
	  "Lennox",
	  "Lenny",
	  "Leo",
	  "Leon",
	  "Leonard",
	  "Leonardo",
	  "Leonhard",
	  "Leonidas",
	  "Leopold",
	  "Leroy",
	  "Levent",
	  "Levi",
	  "Levin",
	  "Lewin",
	  "Lewis",
	  "Liam",
	  "Lian",
	  "Lias",
	  "Lino",
	  "Linus",
	  "Lio",
	  "Lion",
	  "Lionel",
	  "Logan",
	  "Lorenz",
	  "Lorenzo",
	  "Loris",
	  "Louis",
	  "Luan",
	  "Luc",
	  "Luca",
	  "Lucas",
	  "Lucian",
	  "Lucien",
	  "Ludwig",
	  "Luis",
	  "Luiz",
	  "Luk",
	  "Luka",
	  "Lukas",
	  "Luke",
	  "Lutz",
	  "Maddox",
	  "Mads",
	  "Magnus",
	  "Maik",
	  "Maksim",
	  "Malik",
	  "Malte",
	  "Manuel",
	  "Marc",
	  "Marcel",
	  "Marco",
	  "Marcus",
	  "Marek",
	  "Marian",
	  "Mario",
	  "Marius",
	  "Mark",
	  "Marko",
	  "Markus",
	  "Marlo",
	  "Marlon",
	  "Marten",
	  "Martin",
	  "Marvin",
	  "Marwin",
	  "Mateo",
	  "Mathis",
	  "Matis",
	  "Mats",
	  "Matteo",
	  "Mattes",
	  "Matthias",
	  "Matthis",
	  "Matti",
	  "Mattis",
	  "Maurice",
	  "Max",
	  "Maxim",
	  "Maximilian",
	  "Mehmet",
	  "Meik",
	  "Melvin",
	  "Merlin",
	  "Mert",
	  "Michael",
	  "Michel",
	  "Mick",
	  "Miguel",
	  "Mika",
	  "Mikail",
	  "Mike",
	  "Milan",
	  "Milo",
	  "Mio",
	  "Mirac",
	  "Mirco",
	  "Mirko",
	  "Mohamed",
	  "Mohammad",
	  "Mohammed",
	  "Moritz",
	  "Morten",
	  "Muhammed",
	  "Murat",
	  "Mustafa",
	  "Nathan",
	  "Nathanael",
	  "Nelson",
	  "Neo",
	  "Nevio",
	  "Nick",
	  "Niclas",
	  "Nico",
	  "Nicolai",
	  "Nicolas",
	  "Niels",
	  "Nikita",
	  "Niklas",
	  "Niko",
	  "Nikolai",
	  "Nikolas",
	  "Nils",
	  "Nino",
	  "Noah",
	  "Noel",
	  "Norman",
	  "Odin",
	  "Oke",
	  "Ole",
	  "Oliver",
	  "Omar",
	  "Onur",
	  "Oscar",
	  "Oskar",
	  "Pascal",
	  "Patrice",
	  "Patrick",
	  "Paul",
	  "Peer",
	  "Pepe",
	  "Peter",
	  "Phil",
	  "Philip",
	  "Philipp",
	  "Pierre",
	  "Piet",
	  "Pit",
	  "Pius",
	  "Quentin",
	  "Quirin",
	  "Rafael",
	  "Raik",
	  "Ramon",
	  "Raphael",
	  "Rasmus",
	  "Raul",
	  "Rayan",
	  "René",
	  "Ricardo",
	  "Riccardo",
	  "Richard",
	  "Rick",
	  "Rico",
	  "Robert",
	  "Robin",
	  "Rocco",
	  "Roman",
	  "Romeo",
	  "Ron",
	  "Ruben",
	  "Ryan",
	  "Said",
	  "Salih",
	  "Sam",
	  "Sami",
	  "Sammy",
	  "Samuel",
	  "Sandro",
	  "Santino",
	  "Sascha",
	  "Sean",
	  "Sebastian",
	  "Selim",
	  "Semih",
	  "Shawn",
	  "Silas",
	  "Simeon",
	  "Simon",
	  "Sinan",
	  "Sky",
	  "Stefan",
	  "Steffen",
	  "Stephan",
	  "Steve",
	  "Steven",
	  "Sven",
	  "Sönke",
	  "Sören",
	  "Taha",
	  "Tamino",
	  "Tammo",
	  "Tarik",
	  "Tayler",
	  "Taylor",
	  "Teo",
	  "Theo",
	  "Theodor",
	  "Thies",
	  "Thilo",
	  "Thomas",
	  "Thorben",
	  "Thore",
	  "Thorge",
	  "Tiago",
	  "Til",
	  "Till",
	  "Tillmann",
	  "Tim",
	  "Timm",
	  "Timo",
	  "Timon",
	  "Timothy",
	  "Tino",
	  "Titus",
	  "Tizian",
	  "Tjark",
	  "Tobias",
	  "Tom",
	  "Tommy",
	  "Toni",
	  "Tony",
	  "Torben",
	  "Tore",
	  "Tristan",
	  "Tyler",
	  "Tyron",
	  "Umut",
	  "Valentin",
	  "Valentino",
	  "Veit",
	  "Victor",
	  "Viktor",
	  "Vin",
	  "Vincent",
	  "Vito",
	  "Vitus",
	  "Wilhelm",
	  "Willi",
	  "William",
	  "Willy",
	  "Xaver",
	  "Yannic",
	  "Yannick",
	  "Yannik",
	  "Yannis",
	  "Yasin",
	  "Youssef",
	  "Yunus",
	  "Yusuf",
	  "Yven",
	  "Yves",
	  "Ömer",
	  "Aaliyah",
	  "Abby",
	  "Abigail",
	  "Ada",
	  "Adelina",
	  "Adriana",
	  "Aileen",
	  "Aimee",
	  "Alana",
	  "Alea",
	  "Alena",
	  "Alessa",
	  "Alessia",
	  "Alexa",
	  "Alexandra",
	  "Alexia",
	  "Alexis",
	  "Aleyna",
	  "Alia",
	  "Alica",
	  "Alice",
	  "Alicia",
	  "Alina",
	  "Alisa",
	  "Alisha",
	  "Alissa",
	  "Aliya",
	  "Aliyah",
	  "Allegra",
	  "Alma",
	  "Alyssa",
	  "Amalia",
	  "Amanda",
	  "Amelia",
	  "Amelie",
	  "Amina",
	  "Amira",
	  "Amy",
	  "Ana",
	  "Anabel",
	  "Anastasia",
	  "Andrea",
	  "Angela",
	  "Angelina",
	  "Angelique",
	  "Anja",
	  "Ann",
	  "Anna",
	  "Annabel",
	  "Annabell",
	  "Annabelle",
	  "Annalena",
	  "Anne",
	  "Anneke",
	  "Annelie",
	  "Annemarie",
	  "Anni",
	  "Annie",
	  "Annika",
	  "Anny",
	  "Anouk",
	  "Antonia",
	  "Arda",
	  "Ariana",
	  "Ariane",
	  "Arwen",
	  "Ashley",
	  "Asya",
	  "Aurelia",
	  "Aurora",
	  "Ava",
	  "Ayleen",
	  "Aylin",
	  "Ayse",
	  "Azra",
	  "Betty",
	  "Bianca",
	  "Bianka",
	  "Caitlin",
	  "Cara",
	  "Carina",
	  "Carla",
	  "Carlotta",
	  "Carmen",
	  "Carolin",
	  "Carolina",
	  "Caroline",
	  "Cassandra",
	  "Catharina",
	  "Catrin",
	  "Cecile",
	  "Cecilia",
	  "Celia",
	  "Celina",
	  "Celine",
	  "Ceyda",
	  "Ceylin",
	  "Chantal",
	  "Charleen",
	  "Charlotta",
	  "Charlotte",
	  "Chayenne",
	  "Cheyenne",
	  "Chiara",
	  "Christin",
	  "Christina",
	  "Cindy",
	  "Claire",
	  "Clara",
	  "Clarissa",
	  "Colleen",
	  "Collien",
	  "Cora",
	  "Corinna",
	  "Cosima",
	  "Dana",
	  "Daniela",
	  "Daria",
	  "Darleen",
	  "Defne",
	  "Delia",
	  "Denise",
	  "Diana",
	  "Dilara",
	  "Dina",
	  "Dorothea",
	  "Ecrin",
	  "Eda",
	  "Eileen",
	  "Ela",
	  "Elaine",
	  "Elanur",
	  "Elea",
	  "Elena",
	  "Eleni",
	  "Eleonora",
	  "Eliana",
	  "Elif",
	  "Elina",
	  "Elisa",
	  "Elisabeth",
	  "Ella",
	  "Ellen",
	  "Elli",
	  "Elly",
	  "Elsa",
	  "Emelie",
	  "Emely",
	  "Emilia",
	  "Emilie",
	  "Emily",
	  "Emma",
	  "Emmely",
	  "Emmi",
	  "Emmy",
	  "Enie",
	  "Enna",
	  "Enya",
	  "Esma",
	  "Estelle",
	  "Esther",
	  "Eva",
	  "Evelin",
	  "Evelina",
	  "Eveline",
	  "Evelyn",
	  "Fabienne",
	  "Fatima",
	  "Fatma",
	  "Felicia",
	  "Felicitas",
	  "Felina",
	  "Femke",
	  "Fenja",
	  "Fine",
	  "Finia",
	  "Finja",
	  "Finnja",
	  "Fiona",
	  "Flora",
	  "Florentine",
	  "Francesca",
	  "Franka",
	  "Franziska",
	  "Frederike",
	  "Freya",
	  "Frida",
	  "Frieda",
	  "Friederike",
	  "Giada",
	  "Gina",
	  "Giulia",
	  "Giuliana",
	  "Greta",
	  "Hailey",
	  "Hana",
	  "Hanna",
	  "Hannah",
	  "Heidi",
	  "Helen",
	  "Helena",
	  "Helene",
	  "Helin",
	  "Henriette",
	  "Henrike",
	  "Hermine",
	  "Ida",
	  "Ilayda",
	  "Imke",
	  "Ina",
	  "Ines",
	  "Inga",
	  "Inka",
	  "Irem",
	  "Isa",
	  "Isabel",
	  "Isabell",
	  "Isabella",
	  "Isabelle",
	  "Ivonne",
	  "Jacqueline",
	  "Jamie",
	  "Jamila",
	  "Jana",
	  "Jane",
	  "Janin",
	  "Janina",
	  "Janine",
	  "Janna",
	  "Janne",
	  "Jara",
	  "Jasmin",
	  "Jasmina",
	  "Jasmine",
	  "Jella",
	  "Jenna",
	  "Jennifer",
	  "Jenny",
	  "Jessica",
	  "Jessy",
	  "Jette",
	  "Jil",
	  "Jill",
	  "Joana",
	  "Joanna",
	  "Joelina",
	  "Joeline",
	  "Joelle",
	  "Johanna",
	  "Joleen",
	  "Jolie",
	  "Jolien",
	  "Jolin",
	  "Jolina",
	  "Joline",
	  "Jona",
	  "Jonah",
	  "Jonna",
	  "Josefin",
	  "Josefine",
	  "Josephin",
	  "Josephine",
	  "Josie",
	  "Josy",
	  "Joy",
	  "Joyce",
	  "Judith",
	  "Judy",
	  "Jule",
	  "Julia",
	  "Juliana",
	  "Juliane",
	  "Julie",
	  "Julienne",
	  "Julika",
	  "Julina",
	  "Juna",
	  "Justine",
	  "Kaja",
	  "Karina",
	  "Karla",
	  "Karlotta",
	  "Karolina",
	  "Karoline",
	  "Kassandra",
	  "Katarina",
	  "Katharina",
	  "Kathrin",
	  "Katja",
	  "Katrin",
	  "Kaya",
	  "Kayra",
	  "Kiana",
	  "Kiara",
	  "Kim",
	  "Kimberley",
	  "Kimberly",
	  "Kira",
	  "Klara",
	  "Korinna",
	  "Kristin",
	  "Kyra",
	  "Laila",
	  "Lana",
	  "Lara",
	  "Larissa",
	  "Laura",
	  "Laureen",
	  "Lavinia",
	  "Lea",
	  "Leah",
	  "Leana",
	  "Leandra",
	  "Leann",
	  "Lee",
	  "Leila",
	  "Lena",
	  "Lene",
	  "Leni",
	  "Lenia",
	  "Lenja",
	  "Lenya",
	  "Leona",
	  "Leoni",
	  "Leonie",
	  "Leonora",
	  "Leticia",
	  "Letizia",
	  "Levke",
	  "Leyla",
	  "Lia",
	  "Liah",
	  "Liana",
	  "Lili",
	  "Lilia",
	  "Lilian",
	  "Liliana",
	  "Lilith",
	  "Lilli",
	  "Lillian",
	  "Lilly",
	  "Lily",
	  "Lina",
	  "Linda",
	  "Lindsay",
	  "Line",
	  "Linn",
	  "Linnea",
	  "Lisa",
	  "Lisann",
	  "Lisanne",
	  "Liv",
	  "Livia",
	  "Liz",
	  "Lola",
	  "Loreen",
	  "Lorena",
	  "Lotta",
	  "Lotte",
	  "Louisa",
	  "Louise",
	  "Luana",
	  "Luca",
	  "Lucia",
	  "Lucie",
	  "Lucienne",
	  "Lucy",
	  "Luisa",
	  "Luise",
	  "Luka",
	  "Luna",
	  "Luzie",
	  "Lya",
	  "Lydia",
	  "Lyn",
	  "Lynn",
	  "Madeleine",
	  "Madita",
	  "Madleen",
	  "Madlen",
	  "Magdalena",
	  "Maike",
	  "Mailin",
	  "Maira",
	  "Maja",
	  "Malena",
	  "Malia",
	  "Malin",
	  "Malina",
	  "Mandy",
	  "Mara",
	  "Marah",
	  "Mareike",
	  "Maren",
	  "Maria",
	  "Mariam",
	  "Marie",
	  "Marieke",
	  "Mariella",
	  "Marika",
	  "Marina",
	  "Marisa",
	  "Marissa",
	  "Marit",
	  "Marla",
	  "Marleen",
	  "Marlen",
	  "Marlena",
	  "Marlene",
	  "Marta",
	  "Martha",
	  "Mary",
	  "Maryam",
	  "Mathilda",
	  "Mathilde",
	  "Matilda",
	  "Maxi",
	  "Maxima",
	  "Maxine",
	  "Maya",
	  "Mayra",
	  "Medina",
	  "Medine",
	  "Meike",
	  "Melanie",
	  "Melek",
	  "Melike",
	  "Melina",
	  "Melinda",
	  "Melis",
	  "Melisa",
	  "Melissa",
	  "Merle",
	  "Merve",
	  "Meryem",
	  "Mette",
	  "Mia",
	  "Michaela",
	  "Michelle",
	  "Mieke",
	  "Mila",
	  "Milana",
	  "Milena",
	  "Milla",
	  "Mina",
	  "Mira",
	  "Miray",
	  "Miriam",
	  "Mirja",
	  "Mona",
	  "Monique",
	  "Nadine",
	  "Nadja",
	  "Naemi",
	  "Nancy",
	  "Naomi",
	  "Natalia",
	  "Natalie",
	  "Nathalie",
	  "Neele",
	  "Nela",
	  "Nele",
	  "Nelli",
	  "Nelly",
	  "Nia",
	  "Nicole",
	  "Nika",
	  "Nike",
	  "Nikita",
	  "Nila",
	  "Nina",
	  "Nisa",
	  "Noemi",
	  "Nora",
	  "Olivia",
	  "Patricia",
	  "Patrizia",
	  "Paula",
	  "Paulina",
	  "Pauline",
	  "Penelope",
	  "Philine",
	  "Phoebe",
	  "Pia",
	  "Rahel",
	  "Rania",
	  "Rebecca",
	  "Rebekka",
	  "Riana",
	  "Rieke",
	  "Rike",
	  "Romina",
	  "Romy",
	  "Ronja",
	  "Rosa",
	  "Rosalie",
	  "Ruby",
	  "Sabrina",
	  "Sahra",
	  "Sally",
	  "Salome",
	  "Samantha",
	  "Samia",
	  "Samira",
	  "Sandra",
	  "Sandy",
	  "Sanja",
	  "Saphira",
	  "Sara",
	  "Sarah",
	  "Saskia",
	  "Selin",
	  "Selina",
	  "Selma",
	  "Sena",
	  "Sidney",
	  "Sienna",
	  "Silja",
	  "Sina",
	  "Sinja",
	  "Smilla",
	  "Sofia",
	  "Sofie",
	  "Sonja",
	  "Sophia",
	  "Sophie",
	  "Soraya",
	  "Stefanie",
	  "Stella",
	  "Stephanie",
	  "Stina",
	  "Sude",
	  "Summer",
	  "Susanne",
	  "Svea",
	  "Svenja",
	  "Sydney",
	  "Tabea",
	  "Talea",
	  "Talia",
	  "Tamara",
	  "Tamia",
	  "Tamina",
	  "Tanja",
	  "Tara",
	  "Tarja",
	  "Teresa",
	  "Tessa",
	  "Thalea",
	  "Thalia",
	  "Thea",
	  "Theresa",
	  "Tia",
	  "Tina",
	  "Tomke",
	  "Tuana",
	  "Valentina",
	  "Valeria",
	  "Valerie",
	  "Vanessa",
	  "Vera",
	  "Veronika",
	  "Victoria",
	  "Viktoria",
	  "Viola",
	  "Vivian",
	  "Vivien",
	  "Vivienne",
	  "Wibke",
	  "Wiebke",
	  "Xenia",
	  "Yara",
	  "Yaren",
	  "Yasmin",
	  "Ylvi",
	  "Ylvie",
	  "Yvonne",
	  "Zara",
	  "Zehra",
	  "Zeynep",
	  "Zoe",
	  "Zoey",
	  "Zoé"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(394);
	name.last_name = __webpack_require__(396);
	name.prefix = __webpack_require__(399);
	name.nobility_title_prefix = __webpack_require__(398);
	name.name = __webpack_require__(397);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abel",
	  "Abicht",
	  "Abraham",
	  "Abramovic",
	  "Abt",
	  "Achilles",
	  "Achkinadze",
	  "Ackermann",
	  "Adam",
	  "Adams",
	  "Ade",
	  "Agostini",
	  "Ahlke",
	  "Ahrenberg",
	  "Ahrens",
	  "Aigner",
	  "Albert",
	  "Albrecht",
	  "Alexa",
	  "Alexander",
	  "Alizadeh",
	  "Allgeyer",
	  "Amann",
	  "Amberg",
	  "Anding",
	  "Anggreny",
	  "Apitz",
	  "Arendt",
	  "Arens",
	  "Arndt",
	  "Aryee",
	  "Aschenbroich",
	  "Assmus",
	  "Astafei",
	  "Auer",
	  "Axmann",
	  "Baarck",
	  "Bachmann",
	  "Badane",
	  "Bader",
	  "Baganz",
	  "Bahl",
	  "Bak",
	  "Balcer",
	  "Balck",
	  "Balkow",
	  "Balnuweit",
	  "Balzer",
	  "Banse",
	  "Barr",
	  "Bartels",
	  "Barth",
	  "Barylla",
	  "Baseda",
	  "Battke",
	  "Bauer",
	  "Bauermeister",
	  "Baumann",
	  "Baumeister",
	  "Bauschinger",
	  "Bauschke",
	  "Bayer",
	  "Beavogui",
	  "Beck",
	  "Beckel",
	  "Becker",
	  "Beckmann",
	  "Bedewitz",
	  "Beele",
	  "Beer",
	  "Beggerow",
	  "Beh",
	  "Behr",
	  "Behrenbruch",
	  "Belz",
	  "Bender",
	  "Benecke",
	  "Benner",
	  "Benninger",
	  "Benzing",
	  "Berends",
	  "Berger",
	  "Berner",
	  "Berning",
	  "Bertenbreiter",
	  "Best",
	  "Bethke",
	  "Betz",
	  "Beushausen",
	  "Beutelspacher",
	  "Beyer",
	  "Biba",
	  "Bichler",
	  "Bickel",
	  "Biedermann",
	  "Bieler",
	  "Bielert",
	  "Bienasch",
	  "Bienias",
	  "Biesenbach",
	  "Bigdeli",
	  "Birkemeyer",
	  "Bittner",
	  "Blank",
	  "Blaschek",
	  "Blassneck",
	  "Bloch",
	  "Blochwitz",
	  "Blockhaus",
	  "Blum",
	  "Blume",
	  "Bock",
	  "Bode",
	  "Bogdashin",
	  "Bogenrieder",
	  "Bohge",
	  "Bolm",
	  "Borgschulze",
	  "Bork",
	  "Bormann",
	  "Bornscheuer",
	  "Borrmann",
	  "Borsch",
	  "Boruschewski",
	  "Bos",
	  "Bosler",
	  "Bourrouag",
	  "Bouschen",
	  "Boxhammer",
	  "Boyde",
	  "Bozsik",
	  "Brand",
	  "Brandenburg",
	  "Brandis",
	  "Brandt",
	  "Brauer",
	  "Braun",
	  "Brehmer",
	  "Breitenstein",
	  "Bremer",
	  "Bremser",
	  "Brenner",
	  "Brettschneider",
	  "Breu",
	  "Breuer",
	  "Briesenick",
	  "Bringmann",
	  "Brinkmann",
	  "Brix",
	  "Broening",
	  "Brosch",
	  "Bruckmann",
	  "Bruder",
	  "Bruhns",
	  "Brunner",
	  "Bruns",
	  "Bräutigam",
	  "Brömme",
	  "Brüggmann",
	  "Buchholz",
	  "Buchrucker",
	  "Buder",
	  "Bultmann",
	  "Bunjes",
	  "Burger",
	  "Burghagen",
	  "Burkhard",
	  "Burkhardt",
	  "Burmeister",
	  "Busch",
	  "Buschbaum",
	  "Busemann",
	  "Buss",
	  "Busse",
	  "Bussmann",
	  "Byrd",
	  "Bäcker",
	  "Böhm",
	  "Bönisch",
	  "Börgeling",
	  "Börner",
	  "Böttner",
	  "Büchele",
	  "Bühler",
	  "Büker",
	  "Büngener",
	  "Bürger",
	  "Bürklein",
	  "Büscher",
	  "Büttner",
	  "Camara",
	  "Carlowitz",
	  "Carlsohn",
	  "Caspari",
	  "Caspers",
	  "Chapron",
	  "Christ",
	  "Cierpinski",
	  "Clarius",
	  "Cleem",
	  "Cleve",
	  "Co",
	  "Conrad",
	  "Cordes",
	  "Cornelsen",
	  "Cors",
	  "Cotthardt",
	  "Crews",
	  "Cronjäger",
	  "Crosskofp",
	  "Da",
	  "Dahm",
	  "Dahmen",
	  "Daimer",
	  "Damaske",
	  "Danneberg",
	  "Danner",
	  "Daub",
	  "Daubner",
	  "Daudrich",
	  "Dauer",
	  "Daum",
	  "Dauth",
	  "Dautzenberg",
	  "De",
	  "Decker",
	  "Deckert",
	  "Deerberg",
	  "Dehmel",
	  "Deja",
	  "Delonge",
	  "Demut",
	  "Dengler",
	  "Denner",
	  "Denzinger",
	  "Derr",
	  "Dertmann",
	  "Dethloff",
	  "Deuschle",
	  "Dieckmann",
	  "Diedrich",
	  "Diekmann",
	  "Dienel",
	  "Dies",
	  "Dietrich",
	  "Dietz",
	  "Dietzsch",
	  "Diezel",
	  "Dilla",
	  "Dingelstedt",
	  "Dippl",
	  "Dittmann",
	  "Dittmar",
	  "Dittmer",
	  "Dix",
	  "Dobbrunz",
	  "Dobler",
	  "Dohring",
	  "Dolch",
	  "Dold",
	  "Dombrowski",
	  "Donie",
	  "Doskoczynski",
	  "Dragu",
	  "Drechsler",
	  "Drees",
	  "Dreher",
	  "Dreier",
	  "Dreissigacker",
	  "Dressler",
	  "Drews",
	  "Duma",
	  "Dutkiewicz",
	  "Dyett",
	  "Dylus",
	  "Dächert",
	  "Döbel",
	  "Döring",
	  "Dörner",
	  "Dörre",
	  "Dück",
	  "Eberhard",
	  "Eberhardt",
	  "Ecker",
	  "Eckhardt",
	  "Edorh",
	  "Effler",
	  "Eggenmueller",
	  "Ehm",
	  "Ehmann",
	  "Ehrig",
	  "Eich",
	  "Eichmann",
	  "Eifert",
	  "Einert",
	  "Eisenlauer",
	  "Ekpo",
	  "Elbe",
	  "Eleyth",
	  "Elss",
	  "Emert",
	  "Emmelmann",
	  "Ender",
	  "Engel",
	  "Engelen",
	  "Engelmann",
	  "Eplinius",
	  "Erdmann",
	  "Erhardt",
	  "Erlei",
	  "Erm",
	  "Ernst",
	  "Ertl",
	  "Erwes",
	  "Esenwein",
	  "Esser",
	  "Evers",
	  "Everts",
	  "Ewald",
	  "Fahner",
	  "Faller",
	  "Falter",
	  "Farber",
	  "Fassbender",
	  "Faulhaber",
	  "Fehrig",
	  "Feld",
	  "Felke",
	  "Feller",
	  "Fenner",
	  "Fenske",
	  "Feuerbach",
	  "Fietz",
	  "Figl",
	  "Figura",
	  "Filipowski",
	  "Filsinger",
	  "Fincke",
	  "Fink",
	  "Finke",
	  "Fischer",
	  "Fitschen",
	  "Fleischer",
	  "Fleischmann",
	  "Floder",
	  "Florczak",
	  "Flore",
	  "Flottmann",
	  "Forkel",
	  "Forst",
	  "Frahmeke",
	  "Frank",
	  "Franke",
	  "Franta",
	  "Frantz",
	  "Franz",
	  "Franzis",
	  "Franzmann",
	  "Frauen",
	  "Frauendorf",
	  "Freigang",
	  "Freimann",
	  "Freimuth",
	  "Freisen",
	  "Frenzel",
	  "Frey",
	  "Fricke",
	  "Fried",
	  "Friedek",
	  "Friedenberg",
	  "Friedmann",
	  "Friedrich",
	  "Friess",
	  "Frisch",
	  "Frohn",
	  "Frosch",
	  "Fuchs",
	  "Fuhlbrügge",
	  "Fusenig",
	  "Fust",
	  "Förster",
	  "Gaba",
	  "Gabius",
	  "Gabler",
	  "Gadschiew",
	  "Gakstädter",
	  "Galander",
	  "Gamlin",
	  "Gamper",
	  "Gangnus",
	  "Ganzmann",
	  "Garatva",
	  "Gast",
	  "Gastel",
	  "Gatzka",
	  "Gauder",
	  "Gebhardt",
	  "Geese",
	  "Gehre",
	  "Gehrig",
	  "Gehring",
	  "Gehrke",
	  "Geiger",
	  "Geisler",
	  "Geissler",
	  "Gelling",
	  "Gens",
	  "Gerbennow",
	  "Gerdel",
	  "Gerhardt",
	  "Gerschler",
	  "Gerson",
	  "Gesell",
	  "Geyer",
	  "Ghirmai",
	  "Ghosh",
	  "Giehl",
	  "Gierisch",
	  "Giesa",
	  "Giesche",
	  "Gilde",
	  "Glatting",
	  "Goebel",
	  "Goedicke",
	  "Goldbeck",
	  "Goldfuss",
	  "Goldkamp",
	  "Goldkühle",
	  "Goller",
	  "Golling",
	  "Gollnow",
	  "Golomski",
	  "Gombert",
	  "Gotthardt",
	  "Gottschalk",
	  "Gotz",
	  "Goy",
	  "Gradzki",
	  "Graf",
	  "Grams",
	  "Grasse",
	  "Gratzky",
	  "Grau",
	  "Greb",
	  "Green",
	  "Greger",
	  "Greithanner",
	  "Greschner",
	  "Griem",
	  "Griese",
	  "Grimm",
	  "Gromisch",
	  "Gross",
	  "Grosser",
	  "Grossheim",
	  "Grosskopf",
	  "Grothaus",
	  "Grothkopp",
	  "Grotke",
	  "Grube",
	  "Gruber",
	  "Grundmann",
	  "Gruning",
	  "Gruszecki",
	  "Gröss",
	  "Grötzinger",
	  "Grün",
	  "Grüner",
	  "Gummelt",
	  "Gunkel",
	  "Gunther",
	  "Gutjahr",
	  "Gutowicz",
	  "Gutschank",
	  "Göbel",
	  "Göckeritz",
	  "Göhler",
	  "Görlich",
	  "Görmer",
	  "Götz",
	  "Götzelmann",
	  "Güldemeister",
	  "Günther",
	  "Günz",
	  "Gürbig",
	  "Haack",
	  "Haaf",
	  "Habel",
	  "Hache",
	  "Hackbusch",
	  "Hackelbusch",
	  "Hadfield",
	  "Hadwich",
	  "Haferkamp",
	  "Hahn",
	  "Hajek",
	  "Hallmann",
	  "Hamann",
	  "Hanenberger",
	  "Hannecker",
	  "Hanniske",
	  "Hansen",
	  "Hardy",
	  "Hargasser",
	  "Harms",
	  "Harnapp",
	  "Harter",
	  "Harting",
	  "Hartlieb",
	  "Hartmann",
	  "Hartwig",
	  "Hartz",
	  "Haschke",
	  "Hasler",
	  "Hasse",
	  "Hassfeld",
	  "Haug",
	  "Hauke",
	  "Haupt",
	  "Haverney",
	  "Heberstreit",
	  "Hechler",
	  "Hecht",
	  "Heck",
	  "Hedermann",
	  "Hehl",
	  "Heidelmann",
	  "Heidler",
	  "Heinemann",
	  "Heinig",
	  "Heinke",
	  "Heinrich",
	  "Heinze",
	  "Heiser",
	  "Heist",
	  "Hellmann",
	  "Helm",
	  "Helmke",
	  "Helpling",
	  "Hengmith",
	  "Henkel",
	  "Hennes",
	  "Henry",
	  "Hense",
	  "Hensel",
	  "Hentel",
	  "Hentschel",
	  "Hentschke",
	  "Hepperle",
	  "Herberger",
	  "Herbrand",
	  "Hering",
	  "Hermann",
	  "Hermecke",
	  "Herms",
	  "Herold",
	  "Herrmann",
	  "Herschmann",
	  "Hertel",
	  "Herweg",
	  "Herwig",
	  "Herzenberg",
	  "Hess",
	  "Hesse",
	  "Hessek",
	  "Hessler",
	  "Hetzler",
	  "Heuck",
	  "Heydemüller",
	  "Hiebl",
	  "Hildebrand",
	  "Hildenbrand",
	  "Hilgendorf",
	  "Hillard",
	  "Hiller",
	  "Hingsen",
	  "Hingst",
	  "Hinrichs",
	  "Hirsch",
	  "Hirschberg",
	  "Hirt",
	  "Hodea",
	  "Hoffman",
	  "Hoffmann",
	  "Hofmann",
	  "Hohenberger",
	  "Hohl",
	  "Hohn",
	  "Hohnheiser",
	  "Hold",
	  "Holdt",
	  "Holinski",
	  "Holl",
	  "Holtfreter",
	  "Holz",
	  "Holzdeppe",
	  "Holzner",
	  "Hommel",
	  "Honz",
	  "Hooss",
	  "Hoppe",
	  "Horak",
	  "Horn",
	  "Horna",
	  "Hornung",
	  "Hort",
	  "Howard",
	  "Huber",
	  "Huckestein",
	  "Hudak",
	  "Huebel",
	  "Hugo",
	  "Huhn",
	  "Hujo",
	  "Huke",
	  "Huls",
	  "Humbert",
	  "Huneke",
	  "Huth",
	  "Häber",
	  "Häfner",
	  "Höcke",
	  "Höft",
	  "Höhne",
	  "Hönig",
	  "Hördt",
	  "Hübenbecker",
	  "Hübl",
	  "Hübner",
	  "Hügel",
	  "Hüttcher",
	  "Hütter",
	  "Ibe",
	  "Ihly",
	  "Illing",
	  "Isak",
	  "Isekenmeier",
	  "Itt",
	  "Jacob",
	  "Jacobs",
	  "Jagusch",
	  "Jahn",
	  "Jahnke",
	  "Jakobs",
	  "Jakubczyk",
	  "Jambor",
	  "Jamrozy",
	  "Jander",
	  "Janich",
	  "Janke",
	  "Jansen",
	  "Jarets",
	  "Jaros",
	  "Jasinski",
	  "Jasper",
	  "Jegorov",
	  "Jellinghaus",
	  "Jeorga",
	  "Jerschabek",
	  "Jess",
	  "John",
	  "Jonas",
	  "Jossa",
	  "Jucken",
	  "Jung",
	  "Jungbluth",
	  "Jungton",
	  "Just",
	  "Jürgens",
	  "Kaczmarek",
	  "Kaesmacher",
	  "Kahl",
	  "Kahlert",
	  "Kahles",
	  "Kahlmeyer",
	  "Kaiser",
	  "Kalinowski",
	  "Kallabis",
	  "Kallensee",
	  "Kampf",
	  "Kampschulte",
	  "Kappe",
	  "Kappler",
	  "Karhoff",
	  "Karrass",
	  "Karst",
	  "Karsten",
	  "Karus",
	  "Kass",
	  "Kasten",
	  "Kastner",
	  "Katzinski",
	  "Kaufmann",
	  "Kaul",
	  "Kausemann",
	  "Kawohl",
	  "Kazmarek",
	  "Kedzierski",
	  "Keil",
	  "Keiner",
	  "Keller",
	  "Kelm",
	  "Kempe",
	  "Kemper",
	  "Kempter",
	  "Kerl",
	  "Kern",
	  "Kesselring",
	  "Kesselschläger",
	  "Kette",
	  "Kettenis",
	  "Keutel",
	  "Kick",
	  "Kiessling",
	  "Kinadeter",
	  "Kinzel",
	  "Kinzy",
	  "Kirch",
	  "Kirst",
	  "Kisabaka",
	  "Klaas",
	  "Klabuhn",
	  "Klapper",
	  "Klauder",
	  "Klaus",
	  "Kleeberg",
	  "Kleiber",
	  "Klein",
	  "Kleinert",
	  "Kleininger",
	  "Kleinmann",
	  "Kleinsteuber",
	  "Kleiss",
	  "Klemme",
	  "Klimczak",
	  "Klinger",
	  "Klink",
	  "Klopsch",
	  "Klose",
	  "Kloss",
	  "Kluge",
	  "Kluwe",
	  "Knabe",
	  "Kneifel",
	  "Knetsch",
	  "Knies",
	  "Knippel",
	  "Knobel",
	  "Knoblich",
	  "Knoll",
	  "Knorr",
	  "Knorscheidt",
	  "Knut",
	  "Kobs",
	  "Koch",
	  "Kochan",
	  "Kock",
	  "Koczulla",
	  "Koderisch",
	  "Koehl",
	  "Koehler",
	  "Koenig",
	  "Koester",
	  "Kofferschlager",
	  "Koha",
	  "Kohle",
	  "Kohlmann",
	  "Kohnle",
	  "Kohrt",
	  "Koj",
	  "Kolb",
	  "Koleiski",
	  "Kolokas",
	  "Komoll",
	  "Konieczny",
	  "Konig",
	  "Konow",
	  "Konya",
	  "Koob",
	  "Kopf",
	  "Kosenkow",
	  "Koster",
	  "Koszewski",
	  "Koubaa",
	  "Kovacs",
	  "Kowalick",
	  "Kowalinski",
	  "Kozakiewicz",
	  "Krabbe",
	  "Kraft",
	  "Kral",
	  "Kramer",
	  "Krauel",
	  "Kraus",
	  "Krause",
	  "Krauspe",
	  "Kreb",
	  "Krebs",
	  "Kreissig",
	  "Kresse",
	  "Kreutz",
	  "Krieger",
	  "Krippner",
	  "Krodinger",
	  "Krohn",
	  "Krol",
	  "Kron",
	  "Krueger",
	  "Krug",
	  "Kruger",
	  "Krull",
	  "Kruschinski",
	  "Krämer",
	  "Kröckert",
	  "Kröger",
	  "Krüger",
	  "Kubera",
	  "Kufahl",
	  "Kuhlee",
	  "Kuhnen",
	  "Kulimann",
	  "Kulma",
	  "Kumbernuss",
	  "Kummle",
	  "Kunz",
	  "Kupfer",
	  "Kupprion",
	  "Kuprion",
	  "Kurnicki",
	  "Kurrat",
	  "Kurschilgen",
	  "Kuschewitz",
	  "Kuschmann",
	  "Kuske",
	  "Kustermann",
	  "Kutscherauer",
	  "Kutzner",
	  "Kwadwo",
	  "Kähler",
	  "Käther",
	  "Köhler",
	  "Köhrbrück",
	  "Köhre",
	  "Kölotzei",
	  "König",
	  "Köpernick",
	  "Köseoglu",
	  "Kúhn",
	  "Kúhnert",
	  "Kühn",
	  "Kühnel",
	  "Kühnemund",
	  "Kühnert",
	  "Kühnke",
	  "Küsters",
	  "Küter",
	  "Laack",
	  "Lack",
	  "Ladewig",
	  "Lakomy",
	  "Lammert",
	  "Lamos",
	  "Landmann",
	  "Lang",
	  "Lange",
	  "Langfeld",
	  "Langhirt",
	  "Lanig",
	  "Lauckner",
	  "Lauinger",
	  "Laurén",
	  "Lausecker",
	  "Laux",
	  "Laws",
	  "Lax",
	  "Leberer",
	  "Lehmann",
	  "Lehner",
	  "Leibold",
	  "Leide",
	  "Leimbach",
	  "Leipold",
	  "Leist",
	  "Leiter",
	  "Leiteritz",
	  "Leitheim",
	  "Leiwesmeier",
	  "Lenfers",
	  "Lenk",
	  "Lenz",
	  "Lenzen",
	  "Leo",
	  "Lepthin",
	  "Lesch",
	  "Leschnik",
	  "Letzelter",
	  "Lewin",
	  "Lewke",
	  "Leyckes",
	  "Lg",
	  "Lichtenfeld",
	  "Lichtenhagen",
	  "Lichtl",
	  "Liebach",
	  "Liebe",
	  "Liebich",
	  "Liebold",
	  "Lieder",
	  "Lienshöft",
	  "Linden",
	  "Lindenberg",
	  "Lindenmayer",
	  "Lindner",
	  "Linke",
	  "Linnenbaum",
	  "Lippe",
	  "Lipske",
	  "Lipus",
	  "Lischka",
	  "Lobinger",
	  "Logsch",
	  "Lohmann",
	  "Lohre",
	  "Lohse",
	  "Lokar",
	  "Loogen",
	  "Lorenz",
	  "Losch",
	  "Loska",
	  "Lott",
	  "Loy",
	  "Lubina",
	  "Ludolf",
	  "Lufft",
	  "Lukoschek",
	  "Lutje",
	  "Lutz",
	  "Löser",
	  "Löwa",
	  "Lübke",
	  "Maak",
	  "Maczey",
	  "Madetzky",
	  "Madubuko",
	  "Mai",
	  "Maier",
	  "Maisch",
	  "Malek",
	  "Malkus",
	  "Mallmann",
	  "Malucha",
	  "Manns",
	  "Manz",
	  "Marahrens",
	  "Marchewski",
	  "Margis",
	  "Markowski",
	  "Marl",
	  "Marner",
	  "Marquart",
	  "Marschek",
	  "Martel",
	  "Marten",
	  "Martin",
	  "Marx",
	  "Marxen",
	  "Mathes",
	  "Mathies",
	  "Mathiszik",
	  "Matschke",
	  "Mattern",
	  "Matthes",
	  "Matula",
	  "Mau",
	  "Maurer",
	  "Mauroff",
	  "May",
	  "Maybach",
	  "Mayer",
	  "Mebold",
	  "Mehl",
	  "Mehlhorn",
	  "Mehlorn",
	  "Meier",
	  "Meisch",
	  "Meissner",
	  "Meloni",
	  "Melzer",
	  "Menga",
	  "Menne",
	  "Mensah",
	  "Mensing",
	  "Merkel",
	  "Merseburg",
	  "Mertens",
	  "Mesloh",
	  "Metzger",
	  "Metzner",
	  "Mewes",
	  "Meyer",
	  "Michallek",
	  "Michel",
	  "Mielke",
	  "Mikitenko",
	  "Milde",
	  "Minah",
	  "Mintzlaff",
	  "Mockenhaupt",
	  "Moede",
	  "Moedl",
	  "Moeller",
	  "Moguenara",
	  "Mohr",
	  "Mohrhard",
	  "Molitor",
	  "Moll",
	  "Moller",
	  "Molzan",
	  "Montag",
	  "Moormann",
	  "Mordhorst",
	  "Morgenstern",
	  "Morhelfer",
	  "Moritz",
	  "Moser",
	  "Motchebon",
	  "Motzenbbäcker",
	  "Mrugalla",
	  "Muckenthaler",
	  "Mues",
	  "Muller",
	  "Mulrain",
	  "Mächtig",
	  "Mäder",
	  "Möcks",
	  "Mögenburg",
	  "Möhsner",
	  "Möldner",
	  "Möllenbeck",
	  "Möller",
	  "Möllinger",
	  "Mörsch",
	  "Mühleis",
	  "Müller",
	  "Münch",
	  "Nabein",
	  "Nabow",
	  "Nagel",
	  "Nannen",
	  "Nastvogel",
	  "Nau",
	  "Naubert",
	  "Naumann",
	  "Ne",
	  "Neimke",
	  "Nerius",
	  "Neubauer",
	  "Neubert",
	  "Neuendorf",
	  "Neumair",
	  "Neumann",
	  "Neupert",
	  "Neurohr",
	  "Neuschwander",
	  "Newton",
	  "Ney",
	  "Nicolay",
	  "Niedermeier",
	  "Nieklauson",
	  "Niklaus",
	  "Nitzsche",
	  "Noack",
	  "Nodler",
	  "Nolte",
	  "Normann",
	  "Norris",
	  "Northoff",
	  "Nowak",
	  "Nussbeck",
	  "Nwachukwu",
	  "Nytra",
	  "Nöh",
	  "Oberem",
	  "Obergföll",
	  "Obermaier",
	  "Ochs",
	  "Oeser",
	  "Olbrich",
	  "Onnen",
	  "Ophey",
	  "Oppong",
	  "Orth",
	  "Orthmann",
	  "Oschkenat",
	  "Osei",
	  "Osenberg",
	  "Ostendarp",
	  "Ostwald",
	  "Otte",
	  "Otto",
	  "Paesler",
	  "Pajonk",
	  "Pallentin",
	  "Panzig",
	  "Paschke",
	  "Patzwahl",
	  "Paukner",
	  "Peselman",
	  "Peter",
	  "Peters",
	  "Petzold",
	  "Pfeiffer",
	  "Pfennig",
	  "Pfersich",
	  "Pfingsten",
	  "Pflieger",
	  "Pflügner",
	  "Philipp",
	  "Pichlmaier",
	  "Piesker",
	  "Pietsch",
	  "Pingpank",
	  "Pinnock",
	  "Pippig",
	  "Pitschugin",
	  "Plank",
	  "Plass",
	  "Platzer",
	  "Plauk",
	  "Plautz",
	  "Pletsch",
	  "Plotzitzka",
	  "Poehn",
	  "Poeschl",
	  "Pogorzelski",
	  "Pohl",
	  "Pohland",
	  "Pohle",
	  "Polifka",
	  "Polizzi",
	  "Pollmächer",
	  "Pomp",
	  "Ponitzsch",
	  "Porsche",
	  "Porth",
	  "Poschmann",
	  "Poser",
	  "Pottel",
	  "Prah",
	  "Prange",
	  "Prediger",
	  "Pressler",
	  "Preuk",
	  "Preuss",
	  "Prey",
	  "Priemer",
	  "Proske",
	  "Pusch",
	  "Pöche",
	  "Pöge",
	  "Raabe",
	  "Rabenstein",
	  "Rach",
	  "Radtke",
	  "Rahn",
	  "Ranftl",
	  "Rangen",
	  "Ranz",
	  "Rapp",
	  "Rath",
	  "Rau",
	  "Raubuch",
	  "Raukuc",
	  "Rautenkranz",
	  "Rehwagen",
	  "Reiber",
	  "Reichardt",
	  "Reichel",
	  "Reichling",
	  "Reif",
	  "Reifenrath",
	  "Reimann",
	  "Reinberg",
	  "Reinelt",
	  "Reinhardt",
	  "Reinke",
	  "Reitze",
	  "Renk",
	  "Rentz",
	  "Renz",
	  "Reppin",
	  "Restle",
	  "Restorff",
	  "Retzke",
	  "Reuber",
	  "Reumann",
	  "Reus",
	  "Reuss",
	  "Reusse",
	  "Rheder",
	  "Rhoden",
	  "Richards",
	  "Richter",
	  "Riedel",
	  "Riediger",
	  "Rieger",
	  "Riekmann",
	  "Riepl",
	  "Riermeier",
	  "Riester",
	  "Riethmüller",
	  "Rietmüller",
	  "Rietscher",
	  "Ringel",
	  "Ringer",
	  "Rink",
	  "Ripken",
	  "Ritosek",
	  "Ritschel",
	  "Ritter",
	  "Rittweg",
	  "Ritz",
	  "Roba",
	  "Rockmeier",
	  "Rodehau",
	  "Rodowski",
	  "Roecker",
	  "Roggatz",
	  "Rohländer",
	  "Rohrer",
	  "Rokossa",
	  "Roleder",
	  "Roloff",
	  "Roos",
	  "Rosbach",
	  "Roschinsky",
	  "Rose",
	  "Rosenauer",
	  "Rosenbauer",
	  "Rosenthal",
	  "Rosksch",
	  "Rossberg",
	  "Rossler",
	  "Roth",
	  "Rother",
	  "Ruch",
	  "Ruckdeschel",
	  "Rumpf",
	  "Rupprecht",
	  "Ruth",
	  "Ryjikh",
	  "Ryzih",
	  "Rädler",
	  "Räntsch",
	  "Rödiger",
	  "Röse",
	  "Röttger",
	  "Rücker",
	  "Rüdiger",
	  "Rüter",
	  "Sachse",
	  "Sack",
	  "Saflanis",
	  "Sagafe",
	  "Sagonas",
	  "Sahner",
	  "Saile",
	  "Sailer",
	  "Salow",
	  "Salzer",
	  "Salzmann",
	  "Sammert",
	  "Sander",
	  "Sarvari",
	  "Sattelmaier",
	  "Sauer",
	  "Sauerland",
	  "Saumweber",
	  "Savoia",
	  "Scc",
	  "Schacht",
	  "Schaefer",
	  "Schaffarzik",
	  "Schahbasian",
	  "Scharf",
	  "Schedler",
	  "Scheer",
	  "Schelk",
	  "Schellenbeck",
	  "Schembera",
	  "Schenk",
	  "Scherbarth",
	  "Scherer",
	  "Schersing",
	  "Scherz",
	  "Scheurer",
	  "Scheuring",
	  "Scheytt",
	  "Schielke",
	  "Schieskow",
	  "Schildhauer",
	  "Schilling",
	  "Schima",
	  "Schimmer",
	  "Schindzielorz",
	  "Schirmer",
	  "Schirrmeister",
	  "Schlachter",
	  "Schlangen",
	  "Schlawitz",
	  "Schlechtweg",
	  "Schley",
	  "Schlicht",
	  "Schlitzer",
	  "Schmalzle",
	  "Schmid",
	  "Schmidt",
	  "Schmidtchen",
	  "Schmitt",
	  "Schmitz",
	  "Schmuhl",
	  "Schneider",
	  "Schnelting",
	  "Schnieder",
	  "Schniedermeier",
	  "Schnürer",
	  "Schoberg",
	  "Scholz",
	  "Schonberg",
	  "Schondelmaier",
	  "Schorr",
	  "Schott",
	  "Schottmann",
	  "Schouren",
	  "Schrader",
	  "Schramm",
	  "Schreck",
	  "Schreiber",
	  "Schreiner",
	  "Schreiter",
	  "Schroder",
	  "Schröder",
	  "Schuermann",
	  "Schuff",
	  "Schuhaj",
	  "Schuldt",
	  "Schult",
	  "Schulte",
	  "Schultz",
	  "Schultze",
	  "Schulz",
	  "Schulze",
	  "Schumacher",
	  "Schumann",
	  "Schupp",
	  "Schuri",
	  "Schuster",
	  "Schwab",
	  "Schwalm",
	  "Schwanbeck",
	  "Schwandke",
	  "Schwanitz",
	  "Schwarthoff",
	  "Schwartz",
	  "Schwarz",
	  "Schwarzer",
	  "Schwarzkopf",
	  "Schwarzmeier",
	  "Schwatlo",
	  "Schweisfurth",
	  "Schwennen",
	  "Schwerdtner",
	  "Schwidde",
	  "Schwirkschlies",
	  "Schwuchow",
	  "Schäfer",
	  "Schäffel",
	  "Schäffer",
	  "Schäning",
	  "Schöckel",
	  "Schönball",
	  "Schönbeck",
	  "Schönberg",
	  "Schönebeck",
	  "Schönenberger",
	  "Schönfeld",
	  "Schönherr",
	  "Schönlebe",
	  "Schötz",
	  "Schüler",
	  "Schüppel",
	  "Schütz",
	  "Schütze",
	  "Seeger",
	  "Seelig",
	  "Sehls",
	  "Seibold",
	  "Seidel",
	  "Seiders",
	  "Seigel",
	  "Seiler",
	  "Seitz",
	  "Semisch",
	  "Senkel",
	  "Sewald",
	  "Siebel",
	  "Siebert",
	  "Siegling",
	  "Sielemann",
	  "Siemon",
	  "Siener",
	  "Sievers",
	  "Siewert",
	  "Sihler",
	  "Sillah",
	  "Simon",
	  "Sinnhuber",
	  "Sischka",
	  "Skibicki",
	  "Sladek",
	  "Slotta",
	  "Smieja",
	  "Soboll",
	  "Sokolowski",
	  "Soller",
	  "Sollner",
	  "Sommer",
	  "Somssich",
	  "Sonn",
	  "Sonnabend",
	  "Spahn",
	  "Spank",
	  "Spelmeyer",
	  "Spiegelburg",
	  "Spielvogel",
	  "Spinner",
	  "Spitzmüller",
	  "Splinter",
	  "Sporrer",
	  "Sprenger",
	  "Spöttel",
	  "Stahl",
	  "Stang",
	  "Stanger",
	  "Stauss",
	  "Steding",
	  "Steffen",
	  "Steffny",
	  "Steidl",
	  "Steigauf",
	  "Stein",
	  "Steinecke",
	  "Steinert",
	  "Steinkamp",
	  "Steinmetz",
	  "Stelkens",
	  "Stengel",
	  "Stengl",
	  "Stenzel",
	  "Stepanov",
	  "Stephan",
	  "Stern",
	  "Steuk",
	  "Stief",
	  "Stifel",
	  "Stoll",
	  "Stolle",
	  "Stolz",
	  "Storl",
	  "Storp",
	  "Stoutjesdijk",
	  "Stratmann",
	  "Straub",
	  "Strausa",
	  "Streck",
	  "Streese",
	  "Strege",
	  "Streit",
	  "Streller",
	  "Strieder",
	  "Striezel",
	  "Strogies",
	  "Strohschank",
	  "Strunz",
	  "Strutz",
	  "Stube",
	  "Stöckert",
	  "Stöppler",
	  "Stöwer",
	  "Stürmer",
	  "Suffa",
	  "Sujew",
	  "Sussmann",
	  "Suthe",
	  "Sutschet",
	  "Swillims",
	  "Szendrei",
	  "Sören",
	  "Sürth",
	  "Tafelmeier",
	  "Tang",
	  "Tasche",
	  "Taufratshofer",
	  "Tegethof",
	  "Teichmann",
	  "Tepper",
	  "Terheiden",
	  "Terlecki",
	  "Teufel",
	  "Theele",
	  "Thieke",
	  "Thimm",
	  "Thiomas",
	  "Thomas",
	  "Thriene",
	  "Thränhardt",
	  "Thust",
	  "Thyssen",
	  "Thöne",
	  "Tidow",
	  "Tiedtke",
	  "Tietze",
	  "Tilgner",
	  "Tillack",
	  "Timmermann",
	  "Tischler",
	  "Tischmann",
	  "Tittman",
	  "Tivontschik",
	  "Tonat",
	  "Tonn",
	  "Trampeli",
	  "Trauth",
	  "Trautmann",
	  "Travan",
	  "Treff",
	  "Tremmel",
	  "Tress",
	  "Tsamonikian",
	  "Tschiers",
	  "Tschirch",
	  "Tuch",
	  "Tucholke",
	  "Tudow",
	  "Tuschmo",
	  "Tächl",
	  "Többen",
	  "Töpfer",
	  "Uhlemann",
	  "Uhlig",
	  "Uhrig",
	  "Uibel",
	  "Uliczka",
	  "Ullmann",
	  "Ullrich",
	  "Umbach",
	  "Umlauft",
	  "Umminger",
	  "Unger",
	  "Unterpaintner",
	  "Urban",
	  "Urbaniak",
	  "Urbansky",
	  "Urhig",
	  "Vahlensieck",
	  "Van",
	  "Vangermain",
	  "Vater",
	  "Venghaus",
	  "Verniest",
	  "Verzi",
	  "Vey",
	  "Viellehner",
	  "Vieweg",
	  "Voelkel",
	  "Vogel",
	  "Vogelgsang",
	  "Vogt",
	  "Voigt",
	  "Vokuhl",
	  "Volk",
	  "Volker",
	  "Volkmann",
	  "Von",
	  "Vona",
	  "Vontein",
	  "Wachenbrunner",
	  "Wachtel",
	  "Wagner",
	  "Waibel",
	  "Wakan",
	  "Waldmann",
	  "Wallner",
	  "Wallstab",
	  "Walter",
	  "Walther",
	  "Walton",
	  "Walz",
	  "Wanner",
	  "Wartenberg",
	  "Waschbüsch",
	  "Wassilew",
	  "Wassiluk",
	  "Weber",
	  "Wehrsen",
	  "Weidlich",
	  "Weidner",
	  "Weigel",
	  "Weight",
	  "Weiler",
	  "Weimer",
	  "Weis",
	  "Weiss",
	  "Weller",
	  "Welsch",
	  "Welz",
	  "Welzel",
	  "Weniger",
	  "Wenk",
	  "Werle",
	  "Werner",
	  "Werrmann",
	  "Wessel",
	  "Wessinghage",
	  "Weyel",
	  "Wezel",
	  "Wichmann",
	  "Wickert",
	  "Wiebe",
	  "Wiechmann",
	  "Wiegelmann",
	  "Wierig",
	  "Wiese",
	  "Wieser",
	  "Wilhelm",
	  "Wilky",
	  "Will",
	  "Willwacher",
	  "Wilts",
	  "Wimmer",
	  "Winkelmann",
	  "Winkler",
	  "Winter",
	  "Wischek",
	  "Wischer",
	  "Wissing",
	  "Wittich",
	  "Wittl",
	  "Wolf",
	  "Wolfarth",
	  "Wolff",
	  "Wollenberg",
	  "Wollmann",
	  "Woytkowska",
	  "Wujak",
	  "Wurm",
	  "Wyludda",
	  "Wölpert",
	  "Wöschler",
	  "Wühn",
	  "Wünsche",
	  "Zach",
	  "Zaczkiewicz",
	  "Zahn",
	  "Zaituc",
	  "Zandt",
	  "Zanner",
	  "Zapletal",
	  "Zauber",
	  "Zeidler",
	  "Zekl",
	  "Zender",
	  "Zeuch",
	  "Zeyen",
	  "Zeyhle",
	  "Ziegler",
	  "Zimanyi",
	  "Zimmer",
	  "Zimmermann",
	  "Zinser",
	  "Zintl",
	  "Zipp",
	  "Zipse",
	  "Zschunke",
	  "Zuber",
	  "Zwiener",
	  "Zümsande",
	  "Östringer",
	  "Überacker"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{nobility_title_prefix} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "zu",
	  "von",
	  "vom",
	  "von der"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Hr.",
	  "Fr.",
	  "Dr.",
	  "Prof. Dr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(0###) #########",
	  "(0####) #######",
	  "+49-###-#######",
	  "+49-####-########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(400);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###",
	  "##",
	  "#",
	  "##a",
	  "##b",
	  "##c"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aigen im Mühlkreis",
	  "Allerheiligen bei Wildon",
	  "Altenfelden",
	  "Arriach",
	  "Axams",
	  "Baumgartenberg",
	  "Bergern im Dunkelsteinerwald",
	  "Berndorf bei Salzburg",
	  "Bregenz",
	  "Breitenbach am Inn",
	  "Deutsch-Wagram",
	  "Dienten am Hochkönig",
	  "Dietach",
	  "Dornbirn",
	  "Dürnkrut",
	  "Eben im Pongau",
	  "Ebenthal in Kärnten",
	  "Eichgraben",
	  "Eisenstadt",
	  "Ellmau",
	  "Feistritz am Wechsel",
	  "Finkenberg",
	  "Fiss",
	  "Frantschach-St. Gertraud",
	  "Fritzens",
	  "Gams bei Hieflau",
	  "Geiersberg",
	  "Graz",
	  "Großhöflein",
	  "Gößnitz",
	  "Hartl",
	  "Hausleiten",
	  "Herzogenburg",
	  "Hinterhornbach",
	  "Hochwolkersdorf",
	  "Ilz",
	  "Ilztal",
	  "Innerbraz",
	  "Innsbruck",
	  "Itter",
	  "Jagerberg",
	  "Jeging",
	  "Johnsbach",
	  "Johnsdorf-Brunn",
	  "Jungholz",
	  "Kirchdorf am Inn",
	  "Klagenfurt",
	  "Kottes-Purk",
	  "Krumau am Kamp",
	  "Krumbach",
	  "Lavamünd",
	  "Lech",
	  "Linz",
	  "Ludesch",
	  "Lödersdorf",
	  "Marbach an der Donau",
	  "Mattsee",
	  "Mautern an der Donau",
	  "Mauterndorf",
	  "Mitterbach am Erlaufsee",
	  "Neudorf bei Passail",
	  "Neudorf bei Staatz",
	  "Neukirchen an der Enknach",
	  "Neustift an der Lafnitz",
	  "Niederleis",
	  "Oberndorf in Tirol",
	  "Oberstorcha",
	  "Oberwaltersdorf",
	  "Oed-Oehling",
	  "Ort im Innkreis",
	  "Pilgersdorf",
	  "Pitschgau",
	  "Pollham",
	  "Preitenegg",
	  "Purbach am Neusiedler See",
	  "Rabenwald",
	  "Raiding",
	  "Rastenfeld",
	  "Ratten",
	  "Rettenegg",
	  "Salzburg",
	  "Sankt Johann im Saggautal",
	  "St. Peter am Kammersberg",
	  "St. Pölten",
	  "St. Veit an der Glan",
	  "Taxenbach",
	  "Tragwein",
	  "Trebesing",
	  "Trieben",
	  "Turnau",
	  "Ungerdorf",
	  "Unterauersbach",
	  "Unterstinkenbrunn",
	  "Untertilliach",
	  "Uttendorf",
	  "Vals",
	  "Velden am Wörther See",
	  "Viehhofen",
	  "Villach",
	  "Vitis",
	  "Waidhofen an der Thaya",
	  "Waldkirchen am Wesen",
	  "Weißkirchen an der Traun",
	  "Wien",
	  "Wimpassing im Schwarzatale",
	  "Ybbs an der Donau",
	  "Ybbsitz",
	  "Yspertal",
	  "Zeillern",
	  "Zell am Pettenfirst",
	  "Zell an der Pram",
	  "Zerlach",
	  "Zwölfaxing",
	  "Öblarn",
	  "Übelbach",
	  "Überackern",
	  "Übersaxen",
	  "Übersbach"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ägypten",
	  "Äquatorialguinea",
	  "Äthiopien",
	  "Österreich",
	  "Afghanistan",
	  "Albanien",
	  "Algerien",
	  "Amerikanisch-Samoa",
	  "Amerikanische Jungferninseln",
	  "Andorra",
	  "Angola",
	  "Anguilla",
	  "Antarktis",
	  "Antigua und Barbuda",
	  "Argentinien",
	  "Armenien",
	  "Aruba",
	  "Aserbaidschan",
	  "Australien",
	  "Bahamas",
	  "Bahrain",
	  "Bangladesch",
	  "Barbados",
	  "Belarus",
	  "Belgien",
	  "Belize",
	  "Benin",
	  "die Bermudas",
	  "Bhutan",
	  "Bolivien",
	  "Bosnien und Herzegowina",
	  "Botsuana",
	  "Bouvetinsel",
	  "Brasilien",
	  "Britische Jungferninseln",
	  "Britisches Territorium im Indischen Ozean",
	  "Brunei Darussalam",
	  "Bulgarien",
	  "Burkina Faso",
	  "Burundi",
	  "Chile",
	  "China",
	  "Cookinseln",
	  "Costa Rica",
	  "Dänemark",
	  "Demokratische Republik Kongo",
	  "Demokratische Volksrepublik Korea",
	  "Deutschland",
	  "Dominica",
	  "Dominikanische Republik",
	  "Dschibuti",
	  "Ecuador",
	  "El Salvador",
	  "Eritrea",
	  "Estland",
	  "Färöer",
	  "Falklandinseln",
	  "Fidschi",
	  "Finnland",
	  "Frankreich",
	  "Französisch-Guayana",
	  "Französisch-Polynesien",
	  "Französische Gebiete im südlichen Indischen Ozean",
	  "Gabun",
	  "Gambia",
	  "Georgien",
	  "Ghana",
	  "Gibraltar",
	  "Grönland",
	  "Grenada",
	  "Griechenland",
	  "Guadeloupe",
	  "Guam",
	  "Guatemala",
	  "Guinea",
	  "Guinea-Bissau",
	  "Guyana",
	  "Haiti",
	  "Heard und McDonaldinseln",
	  "Honduras",
	  "Hongkong",
	  "Indien",
	  "Indonesien",
	  "Irak",
	  "Iran",
	  "Irland",
	  "Island",
	  "Israel",
	  "Italien",
	  "Jamaika",
	  "Japan",
	  "Jemen",
	  "Jordanien",
	  "Jugoslawien",
	  "Kaimaninseln",
	  "Kambodscha",
	  "Kamerun",
	  "Kanada",
	  "Kap Verde",
	  "Kasachstan",
	  "Katar",
	  "Kenia",
	  "Kirgisistan",
	  "Kiribati",
	  "Kleinere amerikanische Überseeinseln",
	  "Kokosinseln",
	  "Kolumbien",
	  "Komoren",
	  "Kongo",
	  "Kroatien",
	  "Kuba",
	  "Kuwait",
	  "Laos",
	  "Lesotho",
	  "Lettland",
	  "Libanon",
	  "Liberia",
	  "Libyen",
	  "Liechtenstein",
	  "Litauen",
	  "Luxemburg",
	  "Macau",
	  "Madagaskar",
	  "Malawi",
	  "Malaysia",
	  "Malediven",
	  "Mali",
	  "Malta",
	  "ehemalige jugoslawische Republik Mazedonien",
	  "Marokko",
	  "Marshallinseln",
	  "Martinique",
	  "Mauretanien",
	  "Mauritius",
	  "Mayotte",
	  "Mexiko",
	  "Mikronesien",
	  "Monaco",
	  "Mongolei",
	  "Montserrat",
	  "Mosambik",
	  "Myanmar",
	  "Nördliche Marianen",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Neukaledonien",
	  "Neuseeland",
	  "Nicaragua",
	  "Niederländische Antillen",
	  "Niederlande",
	  "Niger",
	  "Nigeria",
	  "Niue",
	  "Norfolkinsel",
	  "Norwegen",
	  "Oman",
	  "Osttimor",
	  "Pakistan",
	  "Palau",
	  "Panama",
	  "Papua-Neuguinea",
	  "Paraguay",
	  "Peru",
	  "Philippinen",
	  "Pitcairninseln",
	  "Polen",
	  "Portugal",
	  "Puerto Rico",
	  "Réunion",
	  "Republik Korea",
	  "Republik Moldau",
	  "Ruanda",
	  "Rumänien",
	  "Russische Föderation",
	  "São Tomé und Príncipe",
	  "Südafrika",
	  "Südgeorgien und Südliche Sandwichinseln",
	  "Salomonen",
	  "Sambia",
	  "Samoa",
	  "San Marino",
	  "Saudi-Arabien",
	  "Schweden",
	  "Schweiz",
	  "Senegal",
	  "Seychellen",
	  "Sierra Leone",
	  "Simbabwe",
	  "Singapur",
	  "Slowakei",
	  "Slowenien",
	  "Somalien",
	  "Spanien",
	  "Sri Lanka",
	  "St. Helena",
	  "St. Kitts und Nevis",
	  "St. Lucia",
	  "St. Pierre und Miquelon",
	  "St. Vincent und die Grenadinen",
	  "Sudan",
	  "Surinam",
	  "Svalbard und Jan Mayen",
	  "Swasiland",
	  "Syrien",
	  "Türkei",
	  "Tadschikistan",
	  "Taiwan",
	  "Tansania",
	  "Thailand",
	  "Togo",
	  "Tokelau",
	  "Tonga",
	  "Trinidad und Tobago",
	  "Tschad",
	  "Tschechische Republik",
	  "Tunesien",
	  "Turkmenistan",
	  "Turks- und Caicosinseln",
	  "Tuvalu",
	  "Uganda",
	  "Ukraine",
	  "Ungarn",
	  "Uruguay",
	  "Usbekistan",
	  "Vanuatu",
	  "Vatikanstadt",
	  "Venezuela",
	  "Vereinigte Arabische Emirate",
	  "Vereinigte Staaten",
	  "Vereinigtes Königreich",
	  "Vietnam",
	  "Wallis und Futuna",
	  "Weihnachtsinsel",
	  "Westsahara",
	  "Zentralafrikanische Republik",
	  "Zypern"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Österreich"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.country = __webpack_require__(405);
	address.street_root = __webpack_require__(414);
	address.building_number = __webpack_require__(402);
	address.secondary_address = __webpack_require__(409);
	address.postcode = __webpack_require__(408);
	address.state = __webpack_require__(410);
	address.state_abbr = __webpack_require__(411);
	address.city_name = __webpack_require__(404);
	address.city = __webpack_require__(403);
	address.street_name = __webpack_require__(413);
	address.street_address = __webpack_require__(412);
	address.default_country = __webpack_require__(406);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apt. ###",
	  "Zimmer ###",
	  "# OG"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Burgenland",
	  "Kärnten",
	  "Niederösterreich",
	  "Oberösterreich",
	  "Salzburg",
	  "Steiermark",
	  "Tirol",
	  "Vorarlberg",
	  "Wien"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bgld.",
	  "Ktn.",
	  "NÖ",
	  "OÖ",
	  "Sbg.",
	  "Stmk.",
	  "T",
	  "Vbg.",
	  "W"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ahorn",
	  "Ahorngasse (St. Andrä)",
	  "Alleestraße (Poysbrunn)",
	  "Alpenlandstraße",
	  "Alte Poststraße",
	  "Alte Ufergasse",
	  "Am Kronawett (Hagenbrunn)",
	  "Am Mühlwasser",
	  "Am Rebenhang",
	  "Am Sternweg",
	  "Anton Wildgans-Straße",
	  "Auer-von-Welsbach-Weg",
	  "Auf der Stift",
	  "Aufeldgasse",
	  "Bahngasse",
	  "Bahnhofstraße",
	  "Bahnstraße (Gerhaus)",
	  "Basteigasse",
	  "Berggasse",
	  "Bergstraße",
	  "Birkenweg",
	  "Blasiussteig",
	  "Blattur",
	  "Bruderhofgasse",
	  "Brunnelligasse",
	  "Bühelweg",
	  "Darnautgasse",
	  "Donaugasse",
	  "Dorfplatz (Haselbach)",
	  "Dr.-Oberreiter-Straße",
	  "Dr.Karl Holoubek-Str.",
	  "Drautal Bundesstraße",
	  "Dürnrohrer Straße",
	  "Ebenthalerstraße",
	  "Eckgrabenweg",
	  "Erlenstraße",
	  "Erlenweg",
	  "Eschenweg",
	  "Etrichgasse",
	  "Fassergasse",
	  "Feichteggerwiese",
	  "Feld-Weg",
	  "Feldgasse",
	  "Feldstapfe",
	  "Fischpointweg",
	  "Flachbergstraße",
	  "Flurweg",
	  "Franz Schubert-Gasse",
	  "Franz-Schneeweiß-Weg",
	  "Franz-von-Assisi-Straße",
	  "Fritz-Pregl-Straße",
	  "Fuchsgrubenweg",
	  "Födlerweg",
	  "Föhrenweg",
	  "Fünfhaus (Paasdorf)",
	  "Gabelsbergerstraße",
	  "Gartenstraße",
	  "Geigen",
	  "Geigergasse",
	  "Gemeindeaugasse",
	  "Gemeindeplatz",
	  "Georg-Aichinger-Straße",
	  "Glanfeldbachweg",
	  "Graben (Burgauberg)",
	  "Grub",
	  "Gröretgasse",
	  "Grünbach",
	  "Gösting",
	  "Hainschwang",
	  "Hans-Mauracher-Straße",
	  "Hart",
	  "Teichstraße",
	  "Hauptplatz",
	  "Hauptstraße",
	  "Heideweg",
	  "Heinrich Landauer Gasse",
	  "Helenengasse",
	  "Hermann von Gilmweg",
	  "Hermann-Löns-Gasse",
	  "Herminengasse",
	  "Hernstorferstraße",
	  "Hirsdorf",
	  "Hochfeistritz",
	  "Hochhaus Neue Donau",
	  "Hof",
	  "Hussovits Gasse",
	  "Höggen",
	  "Hütten",
	  "Janzgasse",
	  "Jochriemgutstraße",
	  "Johann-Strauß-Gasse",
	  "Julius-Raab-Straße",
	  "Kahlenberger Straße",
	  "Karl Kraft-Straße",
	  "Kegelprielstraße",
	  "Keltenberg-Eponaweg",
	  "Kennedybrücke",
	  "Kerpelystraße",
	  "Kindergartenstraße",
	  "Kinderheimgasse",
	  "Kirchenplatz",
	  "Kirchweg",
	  "Klagenfurter Straße",
	  "Klamm",
	  "Kleinbaumgarten",
	  "Klingergasse",
	  "Koloniestraße",
	  "Konrad-Duden-Gasse",
	  "Krankenhausstraße",
	  "Kubinstraße",
	  "Köhldorfergasse",
	  "Lackenweg",
	  "Lange Mekotte",
	  "Leifling",
	  "Leopold Frank-Straße (Pellendorf)",
	  "Lerchengasse (Pirka)",
	  "Lichtensternsiedlung V",
	  "Lindenhofstraße",
	  "Lindenweg",
	  "Luegstraße",
	  "Maierhof",
	  "Malerweg",
	  "Mitterweg",
	  "Mittlere Hauptstraße",
	  "Moosbachgasse",
	  "Morettigasse",
	  "Musikpavillon Riezlern",
	  "Mühlboden",
	  "Mühle",
	  "Mühlenweg",
	  "Neustiftgasse",
	  "Niederegg",
	  "Niedergams",
	  "Nordwestbahnbrücke",
	  "Oberbödenalm",
	  "Obere Berggasse",
	  "Oedt",
	  "Am Färberberg",
	  "Ottogasse",
	  "Paul Peters-Gasse",
	  "Perspektivstraße",
	  "Poppichl",
	  "Privatweg",
	  "Prixgasse",
	  "Pyhra",
	  "Radetzkystraße",
	  "Raiden",
	  "Reichensteinstraße",
	  "Reitbauernstraße",
	  "Reiterweg",
	  "Reitschulgasse",
	  "Ringweg",
	  "Rupertistraße",
	  "Römerstraße",
	  "Römerweg",
	  "Sackgasse",
	  "Schaunbergerstraße",
	  "Schloßweg",
	  "Schulgasse (Langeck)",
	  "Schönholdsiedlung",
	  "Seeblick",
	  "Seestraße",
	  "Semriacherstraße",
	  "Simling",
	  "Sipbachzeller Straße",
	  "Sonnenweg",
	  "Spargelfeldgasse",
	  "Spiesmayrweg",
	  "Sportplatzstraße",
	  "St.Ulrich",
	  "Steilmannstraße",
	  "Steingrüneredt",
	  "Strassfeld",
	  "Straßerau",
	  "Stöpflweg",
	  "Stüra",
	  "Taferngasse",
	  "Tennweg",
	  "Thomas Koschat-Gasse",
	  "Tiroler Straße",
	  "Torrogasse",
	  "Uferstraße (Schwarzau am Steinfeld)",
	  "Unterdörfl",
	  "Unterer Sonnrainweg",
	  "Verwaltersiedlung",
	  "Waldhang",
	  "Wasen",
	  "Weidenstraße",
	  "Weiherweg",
	  "Wettsteingasse",
	  "Wiener Straße",
	  "Windisch",
	  "Zebragasse",
	  "Zellerstraße",
	  "Ziehrerstraße",
	  "Zulechnerweg",
	  "Zwergjoch",
	  "Ötzbruck"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "+43-6##-#######",
	  "06##-########",
	  "+436#########",
	  "06##########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(415);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(420);
	company.legal_form = __webpack_require__(418);
	company.name = __webpack_require__(419);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "GmbH",
	  "AG",
	  "Gruppe",
	  "KG",
	  "GmbH & Co. KG",
	  "UG",
	  "OHG"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} und #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "GmbH",
	  "AG",
	  "Gruppe",
	  "KG",
	  "GmbH & Co. KG",
	  "UG",
	  "OHG"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var de_AT = {};
	module['exports'] = de_AT;
	de_AT.title = "German (Austria)";
	de_AT.address = __webpack_require__(407);
	de_AT.company = __webpack_require__(417);
	de_AT.internet = __webpack_require__(424);
	de_AT.name = __webpack_require__(426);
	de_AT.phone_number = __webpack_require__(432);
	de_AT.cell_phone = __webpack_require__(416);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "info",
	  "name",
	  "net",
	  "org",
	  "de",
	  "ch",
	  "at"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(423);
	internet.domain_suffix = __webpack_require__(422);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aaron",
	  "Abdul",
	  "Abdullah",
	  "Adam",
	  "Adrian",
	  "Adriano",
	  "Ahmad",
	  "Ahmed",
	  "Ahmet",
	  "Alan",
	  "Albert",
	  "Alessandro",
	  "Alessio",
	  "Alex",
	  "Alexander",
	  "Alfred",
	  "Ali",
	  "Amar",
	  "Amir",
	  "Amon",
	  "Andre",
	  "Andreas",
	  "Andrew",
	  "Angelo",
	  "Ansgar",
	  "Anthony",
	  "Anton",
	  "Antonio",
	  "Arda",
	  "Arian",
	  "Armin",
	  "Arne",
	  "Arno",
	  "Arthur",
	  "Artur",
	  "Arved",
	  "Arvid",
	  "Ayman",
	  "Baran",
	  "Baris",
	  "Bastian",
	  "Batuhan",
	  "Bela",
	  "Ben",
	  "Benedikt",
	  "Benjamin",
	  "Bennet",
	  "Bennett",
	  "Benno",
	  "Bent",
	  "Berat",
	  "Berkay",
	  "Bernd",
	  "Bilal",
	  "Bjarne",
	  "Björn",
	  "Bo",
	  "Boris",
	  "Brandon",
	  "Brian",
	  "Bruno",
	  "Bryan",
	  "Burak",
	  "Calvin",
	  "Can",
	  "Carl",
	  "Carlo",
	  "Carlos",
	  "Caspar",
	  "Cedric",
	  "Cedrik",
	  "Cem",
	  "Charlie",
	  "Chris",
	  "Christian",
	  "Christiano",
	  "Christoph",
	  "Christopher",
	  "Claas",
	  "Clemens",
	  "Colin",
	  "Collin",
	  "Conner",
	  "Connor",
	  "Constantin",
	  "Corvin",
	  "Curt",
	  "Damian",
	  "Damien",
	  "Daniel",
	  "Danilo",
	  "Danny",
	  "Darian",
	  "Dario",
	  "Darius",
	  "Darren",
	  "David",
	  "Davide",
	  "Davin",
	  "Dean",
	  "Deniz",
	  "Dennis",
	  "Denny",
	  "Devin",
	  "Diego",
	  "Dion",
	  "Domenic",
	  "Domenik",
	  "Dominic",
	  "Dominik",
	  "Dorian",
	  "Dustin",
	  "Dylan",
	  "Ecrin",
	  "Eddi",
	  "Eddy",
	  "Edgar",
	  "Edwin",
	  "Efe",
	  "Ege",
	  "Elia",
	  "Eliah",
	  "Elias",
	  "Elijah",
	  "Emanuel",
	  "Emil",
	  "Emilian",
	  "Emilio",
	  "Emir",
	  "Emirhan",
	  "Emre",
	  "Enes",
	  "Enno",
	  "Enrico",
	  "Eren",
	  "Eric",
	  "Erik",
	  "Etienne",
	  "Fabian",
	  "Fabien",
	  "Fabio",
	  "Fabrice",
	  "Falk",
	  "Felix",
	  "Ferdinand",
	  "Fiete",
	  "Filip",
	  "Finlay",
	  "Finley",
	  "Finn",
	  "Finnley",
	  "Florian",
	  "Francesco",
	  "Franz",
	  "Frederic",
	  "Frederick",
	  "Frederik",
	  "Friedrich",
	  "Fritz",
	  "Furkan",
	  "Fynn",
	  "Gabriel",
	  "Georg",
	  "Gerrit",
	  "Gian",
	  "Gianluca",
	  "Gino",
	  "Giuliano",
	  "Giuseppe",
	  "Gregor",
	  "Gustav",
	  "Hagen",
	  "Hamza",
	  "Hannes",
	  "Hanno",
	  "Hans",
	  "Hasan",
	  "Hassan",
	  "Hauke",
	  "Hendrik",
	  "Hennes",
	  "Henning",
	  "Henri",
	  "Henrick",
	  "Henrik",
	  "Henry",
	  "Hugo",
	  "Hussein",
	  "Ian",
	  "Ibrahim",
	  "Ilias",
	  "Ilja",
	  "Ilyas",
	  "Immanuel",
	  "Ismael",
	  "Ismail",
	  "Ivan",
	  "Iven",
	  "Jack",
	  "Jacob",
	  "Jaden",
	  "Jakob",
	  "Jamal",
	  "James",
	  "Jamie",
	  "Jan",
	  "Janek",
	  "Janis",
	  "Janne",
	  "Jannek",
	  "Jannes",
	  "Jannik",
	  "Jannis",
	  "Jano",
	  "Janosch",
	  "Jared",
	  "Jari",
	  "Jarne",
	  "Jarno",
	  "Jaron",
	  "Jason",
	  "Jasper",
	  "Jay",
	  "Jayden",
	  "Jayson",
	  "Jean",
	  "Jens",
	  "Jeremias",
	  "Jeremie",
	  "Jeremy",
	  "Jermaine",
	  "Jerome",
	  "Jesper",
	  "Jesse",
	  "Jim",
	  "Jimmy",
	  "Joe",
	  "Joel",
	  "Joey",
	  "Johann",
	  "Johannes",
	  "John",
	  "Johnny",
	  "Jon",
	  "Jona",
	  "Jonah",
	  "Jonas",
	  "Jonathan",
	  "Jonte",
	  "Joost",
	  "Jordan",
	  "Joris",
	  "Joscha",
	  "Joschua",
	  "Josef",
	  "Joseph",
	  "Josh",
	  "Joshua",
	  "Josua",
	  "Juan",
	  "Julian",
	  "Julien",
	  "Julius",
	  "Juri",
	  "Justin",
	  "Justus",
	  "Kaan",
	  "Kai",
	  "Kalle",
	  "Karim",
	  "Karl",
	  "Karlo",
	  "Kay",
	  "Keanu",
	  "Kenan",
	  "Kenny",
	  "Keno",
	  "Kerem",
	  "Kerim",
	  "Kevin",
	  "Kian",
	  "Kilian",
	  "Kim",
	  "Kimi",
	  "Kjell",
	  "Klaas",
	  "Klemens",
	  "Konrad",
	  "Konstantin",
	  "Koray",
	  "Korbinian",
	  "Kurt",
	  "Lars",
	  "Lasse",
	  "Laurence",
	  "Laurens",
	  "Laurenz",
	  "Laurin",
	  "Lean",
	  "Leander",
	  "Leandro",
	  "Leif",
	  "Len",
	  "Lenn",
	  "Lennard",
	  "Lennart",
	  "Lennert",
	  "Lennie",
	  "Lennox",
	  "Lenny",
	  "Leo",
	  "Leon",
	  "Leonard",
	  "Leonardo",
	  "Leonhard",
	  "Leonidas",
	  "Leopold",
	  "Leroy",
	  "Levent",
	  "Levi",
	  "Levin",
	  "Lewin",
	  "Lewis",
	  "Liam",
	  "Lian",
	  "Lias",
	  "Lino",
	  "Linus",
	  "Lio",
	  "Lion",
	  "Lionel",
	  "Logan",
	  "Lorenz",
	  "Lorenzo",
	  "Loris",
	  "Louis",
	  "Luan",
	  "Luc",
	  "Luca",
	  "Lucas",
	  "Lucian",
	  "Lucien",
	  "Ludwig",
	  "Luis",
	  "Luiz",
	  "Luk",
	  "Luka",
	  "Lukas",
	  "Luke",
	  "Lutz",
	  "Maddox",
	  "Mads",
	  "Magnus",
	  "Maik",
	  "Maksim",
	  "Malik",
	  "Malte",
	  "Manuel",
	  "Marc",
	  "Marcel",
	  "Marco",
	  "Marcus",
	  "Marek",
	  "Marian",
	  "Mario",
	  "Marius",
	  "Mark",
	  "Marko",
	  "Markus",
	  "Marlo",
	  "Marlon",
	  "Marten",
	  "Martin",
	  "Marvin",
	  "Marwin",
	  "Mateo",
	  "Mathis",
	  "Matis",
	  "Mats",
	  "Matteo",
	  "Mattes",
	  "Matthias",
	  "Matthis",
	  "Matti",
	  "Mattis",
	  "Maurice",
	  "Max",
	  "Maxim",
	  "Maximilian",
	  "Mehmet",
	  "Meik",
	  "Melvin",
	  "Merlin",
	  "Mert",
	  "Michael",
	  "Michel",
	  "Mick",
	  "Miguel",
	  "Mika",
	  "Mikail",
	  "Mike",
	  "Milan",
	  "Milo",
	  "Mio",
	  "Mirac",
	  "Mirco",
	  "Mirko",
	  "Mohamed",
	  "Mohammad",
	  "Mohammed",
	  "Moritz",
	  "Morten",
	  "Muhammed",
	  "Murat",
	  "Mustafa",
	  "Nathan",
	  "Nathanael",
	  "Nelson",
	  "Neo",
	  "Nevio",
	  "Nick",
	  "Niclas",
	  "Nico",
	  "Nicolai",
	  "Nicolas",
	  "Niels",
	  "Nikita",
	  "Niklas",
	  "Niko",
	  "Nikolai",
	  "Nikolas",
	  "Nils",
	  "Nino",
	  "Noah",
	  "Noel",
	  "Norman",
	  "Odin",
	  "Oke",
	  "Ole",
	  "Oliver",
	  "Omar",
	  "Onur",
	  "Oscar",
	  "Oskar",
	  "Pascal",
	  "Patrice",
	  "Patrick",
	  "Paul",
	  "Peer",
	  "Pepe",
	  "Peter",
	  "Phil",
	  "Philip",
	  "Philipp",
	  "Pierre",
	  "Piet",
	  "Pit",
	  "Pius",
	  "Quentin",
	  "Quirin",
	  "Rafael",
	  "Raik",
	  "Ramon",
	  "Raphael",
	  "Rasmus",
	  "Raul",
	  "Rayan",
	  "René",
	  "Ricardo",
	  "Riccardo",
	  "Richard",
	  "Rick",
	  "Rico",
	  "Robert",
	  "Robin",
	  "Rocco",
	  "Roman",
	  "Romeo",
	  "Ron",
	  "Ruben",
	  "Ryan",
	  "Said",
	  "Salih",
	  "Sam",
	  "Sami",
	  "Sammy",
	  "Samuel",
	  "Sandro",
	  "Santino",
	  "Sascha",
	  "Sean",
	  "Sebastian",
	  "Selim",
	  "Semih",
	  "Shawn",
	  "Silas",
	  "Simeon",
	  "Simon",
	  "Sinan",
	  "Sky",
	  "Stefan",
	  "Steffen",
	  "Stephan",
	  "Steve",
	  "Steven",
	  "Sven",
	  "Sönke",
	  "Sören",
	  "Taha",
	  "Tamino",
	  "Tammo",
	  "Tarik",
	  "Tayler",
	  "Taylor",
	  "Teo",
	  "Theo",
	  "Theodor",
	  "Thies",
	  "Thilo",
	  "Thomas",
	  "Thorben",
	  "Thore",
	  "Thorge",
	  "Tiago",
	  "Til",
	  "Till",
	  "Tillmann",
	  "Tim",
	  "Timm",
	  "Timo",
	  "Timon",
	  "Timothy",
	  "Tino",
	  "Titus",
	  "Tizian",
	  "Tjark",
	  "Tobias",
	  "Tom",
	  "Tommy",
	  "Toni",
	  "Tony",
	  "Torben",
	  "Tore",
	  "Tristan",
	  "Tyler",
	  "Tyron",
	  "Umut",
	  "Valentin",
	  "Valentino",
	  "Veit",
	  "Victor",
	  "Viktor",
	  "Vin",
	  "Vincent",
	  "Vito",
	  "Vitus",
	  "Wilhelm",
	  "Willi",
	  "William",
	  "Willy",
	  "Xaver",
	  "Yannic",
	  "Yannick",
	  "Yannik",
	  "Yannis",
	  "Yasin",
	  "Youssef",
	  "Yunus",
	  "Yusuf",
	  "Yven",
	  "Yves",
	  "Ömer",
	  "Aaliyah",
	  "Abby",
	  "Abigail",
	  "Ada",
	  "Adelina",
	  "Adriana",
	  "Aileen",
	  "Aimee",
	  "Alana",
	  "Alea",
	  "Alena",
	  "Alessa",
	  "Alessia",
	  "Alexa",
	  "Alexandra",
	  "Alexia",
	  "Alexis",
	  "Aleyna",
	  "Alia",
	  "Alica",
	  "Alice",
	  "Alicia",
	  "Alina",
	  "Alisa",
	  "Alisha",
	  "Alissa",
	  "Aliya",
	  "Aliyah",
	  "Allegra",
	  "Alma",
	  "Alyssa",
	  "Amalia",
	  "Amanda",
	  "Amelia",
	  "Amelie",
	  "Amina",
	  "Amira",
	  "Amy",
	  "Ana",
	  "Anabel",
	  "Anastasia",
	  "Andrea",
	  "Angela",
	  "Angelina",
	  "Angelique",
	  "Anja",
	  "Ann",
	  "Anna",
	  "Annabel",
	  "Annabell",
	  "Annabelle",
	  "Annalena",
	  "Anne",
	  "Anneke",
	  "Annelie",
	  "Annemarie",
	  "Anni",
	  "Annie",
	  "Annika",
	  "Anny",
	  "Anouk",
	  "Antonia",
	  "Arda",
	  "Ariana",
	  "Ariane",
	  "Arwen",
	  "Ashley",
	  "Asya",
	  "Aurelia",
	  "Aurora",
	  "Ava",
	  "Ayleen",
	  "Aylin",
	  "Ayse",
	  "Azra",
	  "Betty",
	  "Bianca",
	  "Bianka",
	  "Caitlin",
	  "Cara",
	  "Carina",
	  "Carla",
	  "Carlotta",
	  "Carmen",
	  "Carolin",
	  "Carolina",
	  "Caroline",
	  "Cassandra",
	  "Catharina",
	  "Catrin",
	  "Cecile",
	  "Cecilia",
	  "Celia",
	  "Celina",
	  "Celine",
	  "Ceyda",
	  "Ceylin",
	  "Chantal",
	  "Charleen",
	  "Charlotta",
	  "Charlotte",
	  "Chayenne",
	  "Cheyenne",
	  "Chiara",
	  "Christin",
	  "Christina",
	  "Cindy",
	  "Claire",
	  "Clara",
	  "Clarissa",
	  "Colleen",
	  "Collien",
	  "Cora",
	  "Corinna",
	  "Cosima",
	  "Dana",
	  "Daniela",
	  "Daria",
	  "Darleen",
	  "Defne",
	  "Delia",
	  "Denise",
	  "Diana",
	  "Dilara",
	  "Dina",
	  "Dorothea",
	  "Ecrin",
	  "Eda",
	  "Eileen",
	  "Ela",
	  "Elaine",
	  "Elanur",
	  "Elea",
	  "Elena",
	  "Eleni",
	  "Eleonora",
	  "Eliana",
	  "Elif",
	  "Elina",
	  "Elisa",
	  "Elisabeth",
	  "Ella",
	  "Ellen",
	  "Elli",
	  "Elly",
	  "Elsa",
	  "Emelie",
	  "Emely",
	  "Emilia",
	  "Emilie",
	  "Emily",
	  "Emma",
	  "Emmely",
	  "Emmi",
	  "Emmy",
	  "Enie",
	  "Enna",
	  "Enya",
	  "Esma",
	  "Estelle",
	  "Esther",
	  "Eva",
	  "Evelin",
	  "Evelina",
	  "Eveline",
	  "Evelyn",
	  "Fabienne",
	  "Fatima",
	  "Fatma",
	  "Felicia",
	  "Felicitas",
	  "Felina",
	  "Femke",
	  "Fenja",
	  "Fine",
	  "Finia",
	  "Finja",
	  "Finnja",
	  "Fiona",
	  "Flora",
	  "Florentine",
	  "Francesca",
	  "Franka",
	  "Franziska",
	  "Frederike",
	  "Freya",
	  "Frida",
	  "Frieda",
	  "Friederike",
	  "Giada",
	  "Gina",
	  "Giulia",
	  "Giuliana",
	  "Greta",
	  "Hailey",
	  "Hana",
	  "Hanna",
	  "Hannah",
	  "Heidi",
	  "Helen",
	  "Helena",
	  "Helene",
	  "Helin",
	  "Henriette",
	  "Henrike",
	  "Hermine",
	  "Ida",
	  "Ilayda",
	  "Imke",
	  "Ina",
	  "Ines",
	  "Inga",
	  "Inka",
	  "Irem",
	  "Isa",
	  "Isabel",
	  "Isabell",
	  "Isabella",
	  "Isabelle",
	  "Ivonne",
	  "Jacqueline",
	  "Jamie",
	  "Jamila",
	  "Jana",
	  "Jane",
	  "Janin",
	  "Janina",
	  "Janine",
	  "Janna",
	  "Janne",
	  "Jara",
	  "Jasmin",
	  "Jasmina",
	  "Jasmine",
	  "Jella",
	  "Jenna",
	  "Jennifer",
	  "Jenny",
	  "Jessica",
	  "Jessy",
	  "Jette",
	  "Jil",
	  "Jill",
	  "Joana",
	  "Joanna",
	  "Joelina",
	  "Joeline",
	  "Joelle",
	  "Johanna",
	  "Joleen",
	  "Jolie",
	  "Jolien",
	  "Jolin",
	  "Jolina",
	  "Joline",
	  "Jona",
	  "Jonah",
	  "Jonna",
	  "Josefin",
	  "Josefine",
	  "Josephin",
	  "Josephine",
	  "Josie",
	  "Josy",
	  "Joy",
	  "Joyce",
	  "Judith",
	  "Judy",
	  "Jule",
	  "Julia",
	  "Juliana",
	  "Juliane",
	  "Julie",
	  "Julienne",
	  "Julika",
	  "Julina",
	  "Juna",
	  "Justine",
	  "Kaja",
	  "Karina",
	  "Karla",
	  "Karlotta",
	  "Karolina",
	  "Karoline",
	  "Kassandra",
	  "Katarina",
	  "Katharina",
	  "Kathrin",
	  "Katja",
	  "Katrin",
	  "Kaya",
	  "Kayra",
	  "Kiana",
	  "Kiara",
	  "Kim",
	  "Kimberley",
	  "Kimberly",
	  "Kira",
	  "Klara",
	  "Korinna",
	  "Kristin",
	  "Kyra",
	  "Laila",
	  "Lana",
	  "Lara",
	  "Larissa",
	  "Laura",
	  "Laureen",
	  "Lavinia",
	  "Lea",
	  "Leah",
	  "Leana",
	  "Leandra",
	  "Leann",
	  "Lee",
	  "Leila",
	  "Lena",
	  "Lene",
	  "Leni",
	  "Lenia",
	  "Lenja",
	  "Lenya",
	  "Leona",
	  "Leoni",
	  "Leonie",
	  "Leonora",
	  "Leticia",
	  "Letizia",
	  "Levke",
	  "Leyla",
	  "Lia",
	  "Liah",
	  "Liana",
	  "Lili",
	  "Lilia",
	  "Lilian",
	  "Liliana",
	  "Lilith",
	  "Lilli",
	  "Lillian",
	  "Lilly",
	  "Lily",
	  "Lina",
	  "Linda",
	  "Lindsay",
	  "Line",
	  "Linn",
	  "Linnea",
	  "Lisa",
	  "Lisann",
	  "Lisanne",
	  "Liv",
	  "Livia",
	  "Liz",
	  "Lola",
	  "Loreen",
	  "Lorena",
	  "Lotta",
	  "Lotte",
	  "Louisa",
	  "Louise",
	  "Luana",
	  "Luca",
	  "Lucia",
	  "Lucie",
	  "Lucienne",
	  "Lucy",
	  "Luisa",
	  "Luise",
	  "Luka",
	  "Luna",
	  "Luzie",
	  "Lya",
	  "Lydia",
	  "Lyn",
	  "Lynn",
	  "Madeleine",
	  "Madita",
	  "Madleen",
	  "Madlen",
	  "Magdalena",
	  "Maike",
	  "Mailin",
	  "Maira",
	  "Maja",
	  "Malena",
	  "Malia",
	  "Malin",
	  "Malina",
	  "Mandy",
	  "Mara",
	  "Marah",
	  "Mareike",
	  "Maren",
	  "Maria",
	  "Mariam",
	  "Marie",
	  "Marieke",
	  "Mariella",
	  "Marika",
	  "Marina",
	  "Marisa",
	  "Marissa",
	  "Marit",
	  "Marla",
	  "Marleen",
	  "Marlen",
	  "Marlena",
	  "Marlene",
	  "Marta",
	  "Martha",
	  "Mary",
	  "Maryam",
	  "Mathilda",
	  "Mathilde",
	  "Matilda",
	  "Maxi",
	  "Maxima",
	  "Maxine",
	  "Maya",
	  "Mayra",
	  "Medina",
	  "Medine",
	  "Meike",
	  "Melanie",
	  "Melek",
	  "Melike",
	  "Melina",
	  "Melinda",
	  "Melis",
	  "Melisa",
	  "Melissa",
	  "Merle",
	  "Merve",
	  "Meryem",
	  "Mette",
	  "Mia",
	  "Michaela",
	  "Michelle",
	  "Mieke",
	  "Mila",
	  "Milana",
	  "Milena",
	  "Milla",
	  "Mina",
	  "Mira",
	  "Miray",
	  "Miriam",
	  "Mirja",
	  "Mona",
	  "Monique",
	  "Nadine",
	  "Nadja",
	  "Naemi",
	  "Nancy",
	  "Naomi",
	  "Natalia",
	  "Natalie",
	  "Nathalie",
	  "Neele",
	  "Nela",
	  "Nele",
	  "Nelli",
	  "Nelly",
	  "Nia",
	  "Nicole",
	  "Nika",
	  "Nike",
	  "Nikita",
	  "Nila",
	  "Nina",
	  "Nisa",
	  "Noemi",
	  "Nora",
	  "Olivia",
	  "Patricia",
	  "Patrizia",
	  "Paula",
	  "Paulina",
	  "Pauline",
	  "Penelope",
	  "Philine",
	  "Phoebe",
	  "Pia",
	  "Rahel",
	  "Rania",
	  "Rebecca",
	  "Rebekka",
	  "Riana",
	  "Rieke",
	  "Rike",
	  "Romina",
	  "Romy",
	  "Ronja",
	  "Rosa",
	  "Rosalie",
	  "Ruby",
	  "Sabrina",
	  "Sahra",
	  "Sally",
	  "Salome",
	  "Samantha",
	  "Samia",
	  "Samira",
	  "Sandra",
	  "Sandy",
	  "Sanja",
	  "Saphira",
	  "Sara",
	  "Sarah",
	  "Saskia",
	  "Selin",
	  "Selina",
	  "Selma",
	  "Sena",
	  "Sidney",
	  "Sienna",
	  "Silja",
	  "Sina",
	  "Sinja",
	  "Smilla",
	  "Sofia",
	  "Sofie",
	  "Sonja",
	  "Sophia",
	  "Sophie",
	  "Soraya",
	  "Stefanie",
	  "Stella",
	  "Stephanie",
	  "Stina",
	  "Sude",
	  "Summer",
	  "Susanne",
	  "Svea",
	  "Svenja",
	  "Sydney",
	  "Tabea",
	  "Talea",
	  "Talia",
	  "Tamara",
	  "Tamia",
	  "Tamina",
	  "Tanja",
	  "Tara",
	  "Tarja",
	  "Teresa",
	  "Tessa",
	  "Thalea",
	  "Thalia",
	  "Thea",
	  "Theresa",
	  "Tia",
	  "Tina",
	  "Tomke",
	  "Tuana",
	  "Valentina",
	  "Valeria",
	  "Valerie",
	  "Vanessa",
	  "Vera",
	  "Veronika",
	  "Victoria",
	  "Viktoria",
	  "Viola",
	  "Vivian",
	  "Vivien",
	  "Vivienne",
	  "Wibke",
	  "Wiebke",
	  "Xenia",
	  "Yara",
	  "Yaren",
	  "Yasmin",
	  "Ylvi",
	  "Ylvie",
	  "Yvonne",
	  "Zara",
	  "Zehra",
	  "Zeynep",
	  "Zoe",
	  "Zoey",
	  "Zoé"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(425);
	name.last_name = __webpack_require__(427);
	name.prefix = __webpack_require__(430);
	name.nobility_title_prefix = __webpack_require__(429);
	name.name = __webpack_require__(428);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abel",
	  "Abicht",
	  "Abraham",
	  "Abramovic",
	  "Abt",
	  "Achilles",
	  "Achkinadze",
	  "Ackermann",
	  "Adam",
	  "Adams",
	  "Ade",
	  "Agostini",
	  "Ahlke",
	  "Ahrenberg",
	  "Ahrens",
	  "Aigner",
	  "Albert",
	  "Albrecht",
	  "Alexa",
	  "Alexander",
	  "Alizadeh",
	  "Allgeyer",
	  "Amann",
	  "Amberg",
	  "Anding",
	  "Anggreny",
	  "Apitz",
	  "Arendt",
	  "Arens",
	  "Arndt",
	  "Aryee",
	  "Aschenbroich",
	  "Assmus",
	  "Astafei",
	  "Auer",
	  "Axmann",
	  "Baarck",
	  "Bachmann",
	  "Badane",
	  "Bader",
	  "Baganz",
	  "Bahl",
	  "Bak",
	  "Balcer",
	  "Balck",
	  "Balkow",
	  "Balnuweit",
	  "Balzer",
	  "Banse",
	  "Barr",
	  "Bartels",
	  "Barth",
	  "Barylla",
	  "Baseda",
	  "Battke",
	  "Bauer",
	  "Bauermeister",
	  "Baumann",
	  "Baumeister",
	  "Bauschinger",
	  "Bauschke",
	  "Bayer",
	  "Beavogui",
	  "Beck",
	  "Beckel",
	  "Becker",
	  "Beckmann",
	  "Bedewitz",
	  "Beele",
	  "Beer",
	  "Beggerow",
	  "Beh",
	  "Behr",
	  "Behrenbruch",
	  "Belz",
	  "Bender",
	  "Benecke",
	  "Benner",
	  "Benninger",
	  "Benzing",
	  "Berends",
	  "Berger",
	  "Berner",
	  "Berning",
	  "Bertenbreiter",
	  "Best",
	  "Bethke",
	  "Betz",
	  "Beushausen",
	  "Beutelspacher",
	  "Beyer",
	  "Biba",
	  "Bichler",
	  "Bickel",
	  "Biedermann",
	  "Bieler",
	  "Bielert",
	  "Bienasch",
	  "Bienias",
	  "Biesenbach",
	  "Bigdeli",
	  "Birkemeyer",
	  "Bittner",
	  "Blank",
	  "Blaschek",
	  "Blassneck",
	  "Bloch",
	  "Blochwitz",
	  "Blockhaus",
	  "Blum",
	  "Blume",
	  "Bock",
	  "Bode",
	  "Bogdashin",
	  "Bogenrieder",
	  "Bohge",
	  "Bolm",
	  "Borgschulze",
	  "Bork",
	  "Bormann",
	  "Bornscheuer",
	  "Borrmann",
	  "Borsch",
	  "Boruschewski",
	  "Bos",
	  "Bosler",
	  "Bourrouag",
	  "Bouschen",
	  "Boxhammer",
	  "Boyde",
	  "Bozsik",
	  "Brand",
	  "Brandenburg",
	  "Brandis",
	  "Brandt",
	  "Brauer",
	  "Braun",
	  "Brehmer",
	  "Breitenstein",
	  "Bremer",
	  "Bremser",
	  "Brenner",
	  "Brettschneider",
	  "Breu",
	  "Breuer",
	  "Briesenick",
	  "Bringmann",
	  "Brinkmann",
	  "Brix",
	  "Broening",
	  "Brosch",
	  "Bruckmann",
	  "Bruder",
	  "Bruhns",
	  "Brunner",
	  "Bruns",
	  "Bräutigam",
	  "Brömme",
	  "Brüggmann",
	  "Buchholz",
	  "Buchrucker",
	  "Buder",
	  "Bultmann",
	  "Bunjes",
	  "Burger",
	  "Burghagen",
	  "Burkhard",
	  "Burkhardt",
	  "Burmeister",
	  "Busch",
	  "Buschbaum",
	  "Busemann",
	  "Buss",
	  "Busse",
	  "Bussmann",
	  "Byrd",
	  "Bäcker",
	  "Böhm",
	  "Bönisch",
	  "Börgeling",
	  "Börner",
	  "Böttner",
	  "Büchele",
	  "Bühler",
	  "Büker",
	  "Büngener",
	  "Bürger",
	  "Bürklein",
	  "Büscher",
	  "Büttner",
	  "Camara",
	  "Carlowitz",
	  "Carlsohn",
	  "Caspari",
	  "Caspers",
	  "Chapron",
	  "Christ",
	  "Cierpinski",
	  "Clarius",
	  "Cleem",
	  "Cleve",
	  "Co",
	  "Conrad",
	  "Cordes",
	  "Cornelsen",
	  "Cors",
	  "Cotthardt",
	  "Crews",
	  "Cronjäger",
	  "Crosskofp",
	  "Da",
	  "Dahm",
	  "Dahmen",
	  "Daimer",
	  "Damaske",
	  "Danneberg",
	  "Danner",
	  "Daub",
	  "Daubner",
	  "Daudrich",
	  "Dauer",
	  "Daum",
	  "Dauth",
	  "Dautzenberg",
	  "De",
	  "Decker",
	  "Deckert",
	  "Deerberg",
	  "Dehmel",
	  "Deja",
	  "Delonge",
	  "Demut",
	  "Dengler",
	  "Denner",
	  "Denzinger",
	  "Derr",
	  "Dertmann",
	  "Dethloff",
	  "Deuschle",
	  "Dieckmann",
	  "Diedrich",
	  "Diekmann",
	  "Dienel",
	  "Dies",
	  "Dietrich",
	  "Dietz",
	  "Dietzsch",
	  "Diezel",
	  "Dilla",
	  "Dingelstedt",
	  "Dippl",
	  "Dittmann",
	  "Dittmar",
	  "Dittmer",
	  "Dix",
	  "Dobbrunz",
	  "Dobler",
	  "Dohring",
	  "Dolch",
	  "Dold",
	  "Dombrowski",
	  "Donie",
	  "Doskoczynski",
	  "Dragu",
	  "Drechsler",
	  "Drees",
	  "Dreher",
	  "Dreier",
	  "Dreissigacker",
	  "Dressler",
	  "Drews",
	  "Duma",
	  "Dutkiewicz",
	  "Dyett",
	  "Dylus",
	  "Dächert",
	  "Döbel",
	  "Döring",
	  "Dörner",
	  "Dörre",
	  "Dück",
	  "Eberhard",
	  "Eberhardt",
	  "Ecker",
	  "Eckhardt",
	  "Edorh",
	  "Effler",
	  "Eggenmueller",
	  "Ehm",
	  "Ehmann",
	  "Ehrig",
	  "Eich",
	  "Eichmann",
	  "Eifert",
	  "Einert",
	  "Eisenlauer",
	  "Ekpo",
	  "Elbe",
	  "Eleyth",
	  "Elss",
	  "Emert",
	  "Emmelmann",
	  "Ender",
	  "Engel",
	  "Engelen",
	  "Engelmann",
	  "Eplinius",
	  "Erdmann",
	  "Erhardt",
	  "Erlei",
	  "Erm",
	  "Ernst",
	  "Ertl",
	  "Erwes",
	  "Esenwein",
	  "Esser",
	  "Evers",
	  "Everts",
	  "Ewald",
	  "Fahner",
	  "Faller",
	  "Falter",
	  "Farber",
	  "Fassbender",
	  "Faulhaber",
	  "Fehrig",
	  "Feld",
	  "Felke",
	  "Feller",
	  "Fenner",
	  "Fenske",
	  "Feuerbach",
	  "Fietz",
	  "Figl",
	  "Figura",
	  "Filipowski",
	  "Filsinger",
	  "Fincke",
	  "Fink",
	  "Finke",
	  "Fischer",
	  "Fitschen",
	  "Fleischer",
	  "Fleischmann",
	  "Floder",
	  "Florczak",
	  "Flore",
	  "Flottmann",
	  "Forkel",
	  "Forst",
	  "Frahmeke",
	  "Frank",
	  "Franke",
	  "Franta",
	  "Frantz",
	  "Franz",
	  "Franzis",
	  "Franzmann",
	  "Frauen",
	  "Frauendorf",
	  "Freigang",
	  "Freimann",
	  "Freimuth",
	  "Freisen",
	  "Frenzel",
	  "Frey",
	  "Fricke",
	  "Fried",
	  "Friedek",
	  "Friedenberg",
	  "Friedmann",
	  "Friedrich",
	  "Friess",
	  "Frisch",
	  "Frohn",
	  "Frosch",
	  "Fuchs",
	  "Fuhlbrügge",
	  "Fusenig",
	  "Fust",
	  "Förster",
	  "Gaba",
	  "Gabius",
	  "Gabler",
	  "Gadschiew",
	  "Gakstädter",
	  "Galander",
	  "Gamlin",
	  "Gamper",
	  "Gangnus",
	  "Ganzmann",
	  "Garatva",
	  "Gast",
	  "Gastel",
	  "Gatzka",
	  "Gauder",
	  "Gebhardt",
	  "Geese",
	  "Gehre",
	  "Gehrig",
	  "Gehring",
	  "Gehrke",
	  "Geiger",
	  "Geisler",
	  "Geissler",
	  "Gelling",
	  "Gens",
	  "Gerbennow",
	  "Gerdel",
	  "Gerhardt",
	  "Gerschler",
	  "Gerson",
	  "Gesell",
	  "Geyer",
	  "Ghirmai",
	  "Ghosh",
	  "Giehl",
	  "Gierisch",
	  "Giesa",
	  "Giesche",
	  "Gilde",
	  "Glatting",
	  "Goebel",
	  "Goedicke",
	  "Goldbeck",
	  "Goldfuss",
	  "Goldkamp",
	  "Goldkühle",
	  "Goller",
	  "Golling",
	  "Gollnow",
	  "Golomski",
	  "Gombert",
	  "Gotthardt",
	  "Gottschalk",
	  "Gotz",
	  "Goy",
	  "Gradzki",
	  "Graf",
	  "Grams",
	  "Grasse",
	  "Gratzky",
	  "Grau",
	  "Greb",
	  "Green",
	  "Greger",
	  "Greithanner",
	  "Greschner",
	  "Griem",
	  "Griese",
	  "Grimm",
	  "Gromisch",
	  "Gross",
	  "Grosser",
	  "Grossheim",
	  "Grosskopf",
	  "Grothaus",
	  "Grothkopp",
	  "Grotke",
	  "Grube",
	  "Gruber",
	  "Grundmann",
	  "Gruning",
	  "Gruszecki",
	  "Gröss",
	  "Grötzinger",
	  "Grün",
	  "Grüner",
	  "Gummelt",
	  "Gunkel",
	  "Gunther",
	  "Gutjahr",
	  "Gutowicz",
	  "Gutschank",
	  "Göbel",
	  "Göckeritz",
	  "Göhler",
	  "Görlich",
	  "Görmer",
	  "Götz",
	  "Götzelmann",
	  "Güldemeister",
	  "Günther",
	  "Günz",
	  "Gürbig",
	  "Haack",
	  "Haaf",
	  "Habel",
	  "Hache",
	  "Hackbusch",
	  "Hackelbusch",
	  "Hadfield",
	  "Hadwich",
	  "Haferkamp",
	  "Hahn",
	  "Hajek",
	  "Hallmann",
	  "Hamann",
	  "Hanenberger",
	  "Hannecker",
	  "Hanniske",
	  "Hansen",
	  "Hardy",
	  "Hargasser",
	  "Harms",
	  "Harnapp",
	  "Harter",
	  "Harting",
	  "Hartlieb",
	  "Hartmann",
	  "Hartwig",
	  "Hartz",
	  "Haschke",
	  "Hasler",
	  "Hasse",
	  "Hassfeld",
	  "Haug",
	  "Hauke",
	  "Haupt",
	  "Haverney",
	  "Heberstreit",
	  "Hechler",
	  "Hecht",
	  "Heck",
	  "Hedermann",
	  "Hehl",
	  "Heidelmann",
	  "Heidler",
	  "Heinemann",
	  "Heinig",
	  "Heinke",
	  "Heinrich",
	  "Heinze",
	  "Heiser",
	  "Heist",
	  "Hellmann",
	  "Helm",
	  "Helmke",
	  "Helpling",
	  "Hengmith",
	  "Henkel",
	  "Hennes",
	  "Henry",
	  "Hense",
	  "Hensel",
	  "Hentel",
	  "Hentschel",
	  "Hentschke",
	  "Hepperle",
	  "Herberger",
	  "Herbrand",
	  "Hering",
	  "Hermann",
	  "Hermecke",
	  "Herms",
	  "Herold",
	  "Herrmann",
	  "Herschmann",
	  "Hertel",
	  "Herweg",
	  "Herwig",
	  "Herzenberg",
	  "Hess",
	  "Hesse",
	  "Hessek",
	  "Hessler",
	  "Hetzler",
	  "Heuck",
	  "Heydemüller",
	  "Hiebl",
	  "Hildebrand",
	  "Hildenbrand",
	  "Hilgendorf",
	  "Hillard",
	  "Hiller",
	  "Hingsen",
	  "Hingst",
	  "Hinrichs",
	  "Hirsch",
	  "Hirschberg",
	  "Hirt",
	  "Hodea",
	  "Hoffman",
	  "Hoffmann",
	  "Hofmann",
	  "Hohenberger",
	  "Hohl",
	  "Hohn",
	  "Hohnheiser",
	  "Hold",
	  "Holdt",
	  "Holinski",
	  "Holl",
	  "Holtfreter",
	  "Holz",
	  "Holzdeppe",
	  "Holzner",
	  "Hommel",
	  "Honz",
	  "Hooss",
	  "Hoppe",
	  "Horak",
	  "Horn",
	  "Horna",
	  "Hornung",
	  "Hort",
	  "Howard",
	  "Huber",
	  "Huckestein",
	  "Hudak",
	  "Huebel",
	  "Hugo",
	  "Huhn",
	  "Hujo",
	  "Huke",
	  "Huls",
	  "Humbert",
	  "Huneke",
	  "Huth",
	  "Häber",
	  "Häfner",
	  "Höcke",
	  "Höft",
	  "Höhne",
	  "Hönig",
	  "Hördt",
	  "Hübenbecker",
	  "Hübl",
	  "Hübner",
	  "Hügel",
	  "Hüttcher",
	  "Hütter",
	  "Ibe",
	  "Ihly",
	  "Illing",
	  "Isak",
	  "Isekenmeier",
	  "Itt",
	  "Jacob",
	  "Jacobs",
	  "Jagusch",
	  "Jahn",
	  "Jahnke",
	  "Jakobs",
	  "Jakubczyk",
	  "Jambor",
	  "Jamrozy",
	  "Jander",
	  "Janich",
	  "Janke",
	  "Jansen",
	  "Jarets",
	  "Jaros",
	  "Jasinski",
	  "Jasper",
	  "Jegorov",
	  "Jellinghaus",
	  "Jeorga",
	  "Jerschabek",
	  "Jess",
	  "John",
	  "Jonas",
	  "Jossa",
	  "Jucken",
	  "Jung",
	  "Jungbluth",
	  "Jungton",
	  "Just",
	  "Jürgens",
	  "Kaczmarek",
	  "Kaesmacher",
	  "Kahl",
	  "Kahlert",
	  "Kahles",
	  "Kahlmeyer",
	  "Kaiser",
	  "Kalinowski",
	  "Kallabis",
	  "Kallensee",
	  "Kampf",
	  "Kampschulte",
	  "Kappe",
	  "Kappler",
	  "Karhoff",
	  "Karrass",
	  "Karst",
	  "Karsten",
	  "Karus",
	  "Kass",
	  "Kasten",
	  "Kastner",
	  "Katzinski",
	  "Kaufmann",
	  "Kaul",
	  "Kausemann",
	  "Kawohl",
	  "Kazmarek",
	  "Kedzierski",
	  "Keil",
	  "Keiner",
	  "Keller",
	  "Kelm",
	  "Kempe",
	  "Kemper",
	  "Kempter",
	  "Kerl",
	  "Kern",
	  "Kesselring",
	  "Kesselschläger",
	  "Kette",
	  "Kettenis",
	  "Keutel",
	  "Kick",
	  "Kiessling",
	  "Kinadeter",
	  "Kinzel",
	  "Kinzy",
	  "Kirch",
	  "Kirst",
	  "Kisabaka",
	  "Klaas",
	  "Klabuhn",
	  "Klapper",
	  "Klauder",
	  "Klaus",
	  "Kleeberg",
	  "Kleiber",
	  "Klein",
	  "Kleinert",
	  "Kleininger",
	  "Kleinmann",
	  "Kleinsteuber",
	  "Kleiss",
	  "Klemme",
	  "Klimczak",
	  "Klinger",
	  "Klink",
	  "Klopsch",
	  "Klose",
	  "Kloss",
	  "Kluge",
	  "Kluwe",
	  "Knabe",
	  "Kneifel",
	  "Knetsch",
	  "Knies",
	  "Knippel",
	  "Knobel",
	  "Knoblich",
	  "Knoll",
	  "Knorr",
	  "Knorscheidt",
	  "Knut",
	  "Kobs",
	  "Koch",
	  "Kochan",
	  "Kock",
	  "Koczulla",
	  "Koderisch",
	  "Koehl",
	  "Koehler",
	  "Koenig",
	  "Koester",
	  "Kofferschlager",
	  "Koha",
	  "Kohle",
	  "Kohlmann",
	  "Kohnle",
	  "Kohrt",
	  "Koj",
	  "Kolb",
	  "Koleiski",
	  "Kolokas",
	  "Komoll",
	  "Konieczny",
	  "Konig",
	  "Konow",
	  "Konya",
	  "Koob",
	  "Kopf",
	  "Kosenkow",
	  "Koster",
	  "Koszewski",
	  "Koubaa",
	  "Kovacs",
	  "Kowalick",
	  "Kowalinski",
	  "Kozakiewicz",
	  "Krabbe",
	  "Kraft",
	  "Kral",
	  "Kramer",
	  "Krauel",
	  "Kraus",
	  "Krause",
	  "Krauspe",
	  "Kreb",
	  "Krebs",
	  "Kreissig",
	  "Kresse",
	  "Kreutz",
	  "Krieger",
	  "Krippner",
	  "Krodinger",
	  "Krohn",
	  "Krol",
	  "Kron",
	  "Krueger",
	  "Krug",
	  "Kruger",
	  "Krull",
	  "Kruschinski",
	  "Krämer",
	  "Kröckert",
	  "Kröger",
	  "Krüger",
	  "Kubera",
	  "Kufahl",
	  "Kuhlee",
	  "Kuhnen",
	  "Kulimann",
	  "Kulma",
	  "Kumbernuss",
	  "Kummle",
	  "Kunz",
	  "Kupfer",
	  "Kupprion",
	  "Kuprion",
	  "Kurnicki",
	  "Kurrat",
	  "Kurschilgen",
	  "Kuschewitz",
	  "Kuschmann",
	  "Kuske",
	  "Kustermann",
	  "Kutscherauer",
	  "Kutzner",
	  "Kwadwo",
	  "Kähler",
	  "Käther",
	  "Köhler",
	  "Köhrbrück",
	  "Köhre",
	  "Kölotzei",
	  "König",
	  "Köpernick",
	  "Köseoglu",
	  "Kúhn",
	  "Kúhnert",
	  "Kühn",
	  "Kühnel",
	  "Kühnemund",
	  "Kühnert",
	  "Kühnke",
	  "Küsters",
	  "Küter",
	  "Laack",
	  "Lack",
	  "Ladewig",
	  "Lakomy",
	  "Lammert",
	  "Lamos",
	  "Landmann",
	  "Lang",
	  "Lange",
	  "Langfeld",
	  "Langhirt",
	  "Lanig",
	  "Lauckner",
	  "Lauinger",
	  "Laurén",
	  "Lausecker",
	  "Laux",
	  "Laws",
	  "Lax",
	  "Leberer",
	  "Lehmann",
	  "Lehner",
	  "Leibold",
	  "Leide",
	  "Leimbach",
	  "Leipold",
	  "Leist",
	  "Leiter",
	  "Leiteritz",
	  "Leitheim",
	  "Leiwesmeier",
	  "Lenfers",
	  "Lenk",
	  "Lenz",
	  "Lenzen",
	  "Leo",
	  "Lepthin",
	  "Lesch",
	  "Leschnik",
	  "Letzelter",
	  "Lewin",
	  "Lewke",
	  "Leyckes",
	  "Lg",
	  "Lichtenfeld",
	  "Lichtenhagen",
	  "Lichtl",
	  "Liebach",
	  "Liebe",
	  "Liebich",
	  "Liebold",
	  "Lieder",
	  "Lienshöft",
	  "Linden",
	  "Lindenberg",
	  "Lindenmayer",
	  "Lindner",
	  "Linke",
	  "Linnenbaum",
	  "Lippe",
	  "Lipske",
	  "Lipus",
	  "Lischka",
	  "Lobinger",
	  "Logsch",
	  "Lohmann",
	  "Lohre",
	  "Lohse",
	  "Lokar",
	  "Loogen",
	  "Lorenz",
	  "Losch",
	  "Loska",
	  "Lott",
	  "Loy",
	  "Lubina",
	  "Ludolf",
	  "Lufft",
	  "Lukoschek",
	  "Lutje",
	  "Lutz",
	  "Löser",
	  "Löwa",
	  "Lübke",
	  "Maak",
	  "Maczey",
	  "Madetzky",
	  "Madubuko",
	  "Mai",
	  "Maier",
	  "Maisch",
	  "Malek",
	  "Malkus",
	  "Mallmann",
	  "Malucha",
	  "Manns",
	  "Manz",
	  "Marahrens",
	  "Marchewski",
	  "Margis",
	  "Markowski",
	  "Marl",
	  "Marner",
	  "Marquart",
	  "Marschek",
	  "Martel",
	  "Marten",
	  "Martin",
	  "Marx",
	  "Marxen",
	  "Mathes",
	  "Mathies",
	  "Mathiszik",
	  "Matschke",
	  "Mattern",
	  "Matthes",
	  "Matula",
	  "Mau",
	  "Maurer",
	  "Mauroff",
	  "May",
	  "Maybach",
	  "Mayer",
	  "Mebold",
	  "Mehl",
	  "Mehlhorn",
	  "Mehlorn",
	  "Meier",
	  "Meisch",
	  "Meissner",
	  "Meloni",
	  "Melzer",
	  "Menga",
	  "Menne",
	  "Mensah",
	  "Mensing",
	  "Merkel",
	  "Merseburg",
	  "Mertens",
	  "Mesloh",
	  "Metzger",
	  "Metzner",
	  "Mewes",
	  "Meyer",
	  "Michallek",
	  "Michel",
	  "Mielke",
	  "Mikitenko",
	  "Milde",
	  "Minah",
	  "Mintzlaff",
	  "Mockenhaupt",
	  "Moede",
	  "Moedl",
	  "Moeller",
	  "Moguenara",
	  "Mohr",
	  "Mohrhard",
	  "Molitor",
	  "Moll",
	  "Moller",
	  "Molzan",
	  "Montag",
	  "Moormann",
	  "Mordhorst",
	  "Morgenstern",
	  "Morhelfer",
	  "Moritz",
	  "Moser",
	  "Motchebon",
	  "Motzenbbäcker",
	  "Mrugalla",
	  "Muckenthaler",
	  "Mues",
	  "Muller",
	  "Mulrain",
	  "Mächtig",
	  "Mäder",
	  "Möcks",
	  "Mögenburg",
	  "Möhsner",
	  "Möldner",
	  "Möllenbeck",
	  "Möller",
	  "Möllinger",
	  "Mörsch",
	  "Mühleis",
	  "Müller",
	  "Münch",
	  "Nabein",
	  "Nabow",
	  "Nagel",
	  "Nannen",
	  "Nastvogel",
	  "Nau",
	  "Naubert",
	  "Naumann",
	  "Ne",
	  "Neimke",
	  "Nerius",
	  "Neubauer",
	  "Neubert",
	  "Neuendorf",
	  "Neumair",
	  "Neumann",
	  "Neupert",
	  "Neurohr",
	  "Neuschwander",
	  "Newton",
	  "Ney",
	  "Nicolay",
	  "Niedermeier",
	  "Nieklauson",
	  "Niklaus",
	  "Nitzsche",
	  "Noack",
	  "Nodler",
	  "Nolte",
	  "Normann",
	  "Norris",
	  "Northoff",
	  "Nowak",
	  "Nussbeck",
	  "Nwachukwu",
	  "Nytra",
	  "Nöh",
	  "Oberem",
	  "Obergföll",
	  "Obermaier",
	  "Ochs",
	  "Oeser",
	  "Olbrich",
	  "Onnen",
	  "Ophey",
	  "Oppong",
	  "Orth",
	  "Orthmann",
	  "Oschkenat",
	  "Osei",
	  "Osenberg",
	  "Ostendarp",
	  "Ostwald",
	  "Otte",
	  "Otto",
	  "Paesler",
	  "Pajonk",
	  "Pallentin",
	  "Panzig",
	  "Paschke",
	  "Patzwahl",
	  "Paukner",
	  "Peselman",
	  "Peter",
	  "Peters",
	  "Petzold",
	  "Pfeiffer",
	  "Pfennig",
	  "Pfersich",
	  "Pfingsten",
	  "Pflieger",
	  "Pflügner",
	  "Philipp",
	  "Pichlmaier",
	  "Piesker",
	  "Pietsch",
	  "Pingpank",
	  "Pinnock",
	  "Pippig",
	  "Pitschugin",
	  "Plank",
	  "Plass",
	  "Platzer",
	  "Plauk",
	  "Plautz",
	  "Pletsch",
	  "Plotzitzka",
	  "Poehn",
	  "Poeschl",
	  "Pogorzelski",
	  "Pohl",
	  "Pohland",
	  "Pohle",
	  "Polifka",
	  "Polizzi",
	  "Pollmächer",
	  "Pomp",
	  "Ponitzsch",
	  "Porsche",
	  "Porth",
	  "Poschmann",
	  "Poser",
	  "Pottel",
	  "Prah",
	  "Prange",
	  "Prediger",
	  "Pressler",
	  "Preuk",
	  "Preuss",
	  "Prey",
	  "Priemer",
	  "Proske",
	  "Pusch",
	  "Pöche",
	  "Pöge",
	  "Raabe",
	  "Rabenstein",
	  "Rach",
	  "Radtke",
	  "Rahn",
	  "Ranftl",
	  "Rangen",
	  "Ranz",
	  "Rapp",
	  "Rath",
	  "Rau",
	  "Raubuch",
	  "Raukuc",
	  "Rautenkranz",
	  "Rehwagen",
	  "Reiber",
	  "Reichardt",
	  "Reichel",
	  "Reichling",
	  "Reif",
	  "Reifenrath",
	  "Reimann",
	  "Reinberg",
	  "Reinelt",
	  "Reinhardt",
	  "Reinke",
	  "Reitze",
	  "Renk",
	  "Rentz",
	  "Renz",
	  "Reppin",
	  "Restle",
	  "Restorff",
	  "Retzke",
	  "Reuber",
	  "Reumann",
	  "Reus",
	  "Reuss",
	  "Reusse",
	  "Rheder",
	  "Rhoden",
	  "Richards",
	  "Richter",
	  "Riedel",
	  "Riediger",
	  "Rieger",
	  "Riekmann",
	  "Riepl",
	  "Riermeier",
	  "Riester",
	  "Riethmüller",
	  "Rietmüller",
	  "Rietscher",
	  "Ringel",
	  "Ringer",
	  "Rink",
	  "Ripken",
	  "Ritosek",
	  "Ritschel",
	  "Ritter",
	  "Rittweg",
	  "Ritz",
	  "Roba",
	  "Rockmeier",
	  "Rodehau",
	  "Rodowski",
	  "Roecker",
	  "Roggatz",
	  "Rohländer",
	  "Rohrer",
	  "Rokossa",
	  "Roleder",
	  "Roloff",
	  "Roos",
	  "Rosbach",
	  "Roschinsky",
	  "Rose",
	  "Rosenauer",
	  "Rosenbauer",
	  "Rosenthal",
	  "Rosksch",
	  "Rossberg",
	  "Rossler",
	  "Roth",
	  "Rother",
	  "Ruch",
	  "Ruckdeschel",
	  "Rumpf",
	  "Rupprecht",
	  "Ruth",
	  "Ryjikh",
	  "Ryzih",
	  "Rädler",
	  "Räntsch",
	  "Rödiger",
	  "Röse",
	  "Röttger",
	  "Rücker",
	  "Rüdiger",
	  "Rüter",
	  "Sachse",
	  "Sack",
	  "Saflanis",
	  "Sagafe",
	  "Sagonas",
	  "Sahner",
	  "Saile",
	  "Sailer",
	  "Salow",
	  "Salzer",
	  "Salzmann",
	  "Sammert",
	  "Sander",
	  "Sarvari",
	  "Sattelmaier",
	  "Sauer",
	  "Sauerland",
	  "Saumweber",
	  "Savoia",
	  "Scc",
	  "Schacht",
	  "Schaefer",
	  "Schaffarzik",
	  "Schahbasian",
	  "Scharf",
	  "Schedler",
	  "Scheer",
	  "Schelk",
	  "Schellenbeck",
	  "Schembera",
	  "Schenk",
	  "Scherbarth",
	  "Scherer",
	  "Schersing",
	  "Scherz",
	  "Scheurer",
	  "Scheuring",
	  "Scheytt",
	  "Schielke",
	  "Schieskow",
	  "Schildhauer",
	  "Schilling",
	  "Schima",
	  "Schimmer",
	  "Schindzielorz",
	  "Schirmer",
	  "Schirrmeister",
	  "Schlachter",
	  "Schlangen",
	  "Schlawitz",
	  "Schlechtweg",
	  "Schley",
	  "Schlicht",
	  "Schlitzer",
	  "Schmalzle",
	  "Schmid",
	  "Schmidt",
	  "Schmidtchen",
	  "Schmitt",
	  "Schmitz",
	  "Schmuhl",
	  "Schneider",
	  "Schnelting",
	  "Schnieder",
	  "Schniedermeier",
	  "Schnürer",
	  "Schoberg",
	  "Scholz",
	  "Schonberg",
	  "Schondelmaier",
	  "Schorr",
	  "Schott",
	  "Schottmann",
	  "Schouren",
	  "Schrader",
	  "Schramm",
	  "Schreck",
	  "Schreiber",
	  "Schreiner",
	  "Schreiter",
	  "Schroder",
	  "Schröder",
	  "Schuermann",
	  "Schuff",
	  "Schuhaj",
	  "Schuldt",
	  "Schult",
	  "Schulte",
	  "Schultz",
	  "Schultze",
	  "Schulz",
	  "Schulze",
	  "Schumacher",
	  "Schumann",
	  "Schupp",
	  "Schuri",
	  "Schuster",
	  "Schwab",
	  "Schwalm",
	  "Schwanbeck",
	  "Schwandke",
	  "Schwanitz",
	  "Schwarthoff",
	  "Schwartz",
	  "Schwarz",
	  "Schwarzer",
	  "Schwarzkopf",
	  "Schwarzmeier",
	  "Schwatlo",
	  "Schweisfurth",
	  "Schwennen",
	  "Schwerdtner",
	  "Schwidde",
	  "Schwirkschlies",
	  "Schwuchow",
	  "Schäfer",
	  "Schäffel",
	  "Schäffer",
	  "Schäning",
	  "Schöckel",
	  "Schönball",
	  "Schönbeck",
	  "Schönberg",
	  "Schönebeck",
	  "Schönenberger",
	  "Schönfeld",
	  "Schönherr",
	  "Schönlebe",
	  "Schötz",
	  "Schüler",
	  "Schüppel",
	  "Schütz",
	  "Schütze",
	  "Seeger",
	  "Seelig",
	  "Sehls",
	  "Seibold",
	  "Seidel",
	  "Seiders",
	  "Seigel",
	  "Seiler",
	  "Seitz",
	  "Semisch",
	  "Senkel",
	  "Sewald",
	  "Siebel",
	  "Siebert",
	  "Siegling",
	  "Sielemann",
	  "Siemon",
	  "Siener",
	  "Sievers",
	  "Siewert",
	  "Sihler",
	  "Sillah",
	  "Simon",
	  "Sinnhuber",
	  "Sischka",
	  "Skibicki",
	  "Sladek",
	  "Slotta",
	  "Smieja",
	  "Soboll",
	  "Sokolowski",
	  "Soller",
	  "Sollner",
	  "Sommer",
	  "Somssich",
	  "Sonn",
	  "Sonnabend",
	  "Spahn",
	  "Spank",
	  "Spelmeyer",
	  "Spiegelburg",
	  "Spielvogel",
	  "Spinner",
	  "Spitzmüller",
	  "Splinter",
	  "Sporrer",
	  "Sprenger",
	  "Spöttel",
	  "Stahl",
	  "Stang",
	  "Stanger",
	  "Stauss",
	  "Steding",
	  "Steffen",
	  "Steffny",
	  "Steidl",
	  "Steigauf",
	  "Stein",
	  "Steinecke",
	  "Steinert",
	  "Steinkamp",
	  "Steinmetz",
	  "Stelkens",
	  "Stengel",
	  "Stengl",
	  "Stenzel",
	  "Stepanov",
	  "Stephan",
	  "Stern",
	  "Steuk",
	  "Stief",
	  "Stifel",
	  "Stoll",
	  "Stolle",
	  "Stolz",
	  "Storl",
	  "Storp",
	  "Stoutjesdijk",
	  "Stratmann",
	  "Straub",
	  "Strausa",
	  "Streck",
	  "Streese",
	  "Strege",
	  "Streit",
	  "Streller",
	  "Strieder",
	  "Striezel",
	  "Strogies",
	  "Strohschank",
	  "Strunz",
	  "Strutz",
	  "Stube",
	  "Stöckert",
	  "Stöppler",
	  "Stöwer",
	  "Stürmer",
	  "Suffa",
	  "Sujew",
	  "Sussmann",
	  "Suthe",
	  "Sutschet",
	  "Swillims",
	  "Szendrei",
	  "Sören",
	  "Sürth",
	  "Tafelmeier",
	  "Tang",
	  "Tasche",
	  "Taufratshofer",
	  "Tegethof",
	  "Teichmann",
	  "Tepper",
	  "Terheiden",
	  "Terlecki",
	  "Teufel",
	  "Theele",
	  "Thieke",
	  "Thimm",
	  "Thiomas",
	  "Thomas",
	  "Thriene",
	  "Thränhardt",
	  "Thust",
	  "Thyssen",
	  "Thöne",
	  "Tidow",
	  "Tiedtke",
	  "Tietze",
	  "Tilgner",
	  "Tillack",
	  "Timmermann",
	  "Tischler",
	  "Tischmann",
	  "Tittman",
	  "Tivontschik",
	  "Tonat",
	  "Tonn",
	  "Trampeli",
	  "Trauth",
	  "Trautmann",
	  "Travan",
	  "Treff",
	  "Tremmel",
	  "Tress",
	  "Tsamonikian",
	  "Tschiers",
	  "Tschirch",
	  "Tuch",
	  "Tucholke",
	  "Tudow",
	  "Tuschmo",
	  "Tächl",
	  "Többen",
	  "Töpfer",
	  "Uhlemann",
	  "Uhlig",
	  "Uhrig",
	  "Uibel",
	  "Uliczka",
	  "Ullmann",
	  "Ullrich",
	  "Umbach",
	  "Umlauft",
	  "Umminger",
	  "Unger",
	  "Unterpaintner",
	  "Urban",
	  "Urbaniak",
	  "Urbansky",
	  "Urhig",
	  "Vahlensieck",
	  "Van",
	  "Vangermain",
	  "Vater",
	  "Venghaus",
	  "Verniest",
	  "Verzi",
	  "Vey",
	  "Viellehner",
	  "Vieweg",
	  "Voelkel",
	  "Vogel",
	  "Vogelgsang",
	  "Vogt",
	  "Voigt",
	  "Vokuhl",
	  "Volk",
	  "Volker",
	  "Volkmann",
	  "Von",
	  "Vona",
	  "Vontein",
	  "Wachenbrunner",
	  "Wachtel",
	  "Wagner",
	  "Waibel",
	  "Wakan",
	  "Waldmann",
	  "Wallner",
	  "Wallstab",
	  "Walter",
	  "Walther",
	  "Walton",
	  "Walz",
	  "Wanner",
	  "Wartenberg",
	  "Waschbüsch",
	  "Wassilew",
	  "Wassiluk",
	  "Weber",
	  "Wehrsen",
	  "Weidlich",
	  "Weidner",
	  "Weigel",
	  "Weight",
	  "Weiler",
	  "Weimer",
	  "Weis",
	  "Weiss",
	  "Weller",
	  "Welsch",
	  "Welz",
	  "Welzel",
	  "Weniger",
	  "Wenk",
	  "Werle",
	  "Werner",
	  "Werrmann",
	  "Wessel",
	  "Wessinghage",
	  "Weyel",
	  "Wezel",
	  "Wichmann",
	  "Wickert",
	  "Wiebe",
	  "Wiechmann",
	  "Wiegelmann",
	  "Wierig",
	  "Wiese",
	  "Wieser",
	  "Wilhelm",
	  "Wilky",
	  "Will",
	  "Willwacher",
	  "Wilts",
	  "Wimmer",
	  "Winkelmann",
	  "Winkler",
	  "Winter",
	  "Wischek",
	  "Wischer",
	  "Wissing",
	  "Wittich",
	  "Wittl",
	  "Wolf",
	  "Wolfarth",
	  "Wolff",
	  "Wollenberg",
	  "Wollmann",
	  "Woytkowska",
	  "Wujak",
	  "Wurm",
	  "Wyludda",
	  "Wölpert",
	  "Wöschler",
	  "Wühn",
	  "Wünsche",
	  "Zach",
	  "Zaczkiewicz",
	  "Zahn",
	  "Zaituc",
	  "Zandt",
	  "Zanner",
	  "Zapletal",
	  "Zauber",
	  "Zeidler",
	  "Zekl",
	  "Zender",
	  "Zeuch",
	  "Zeyen",
	  "Zeyhle",
	  "Ziegler",
	  "Zimanyi",
	  "Zimmer",
	  "Zimmermann",
	  "Zinser",
	  "Zintl",
	  "Zipp",
	  "Zipse",
	  "Zschunke",
	  "Zuber",
	  "Zwiener",
	  "Zümsande",
	  "Östringer",
	  "Überacker"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{nobility_title_prefix} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "zu",
	  "von",
	  "vom",
	  "von der"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Dr.",
	  "Prof. Dr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "01 #######",
	  "01#######",
	  "+43-1-#######",
	  "+431#######",
	  "0#### ####",
	  "0#########",
	  "+43-####-####",
	  "+43 ########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(431);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "CH",
	  "CH",
	  "CH",
	  "DE",
	  "AT",
	  "US",
	  "LI",
	  "US",
	  "HK",
	  "VN"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Schweiz"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.country_code = __webpack_require__(433);
	address.postcode = __webpack_require__(436);
	address.default_country = __webpack_require__(434);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "1###",
	  "2###",
	  "3###",
	  "4###",
	  "5###",
	  "6###",
	  "7###",
	  "8###",
	  "9###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(439);
	company.name = __webpack_require__(438);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} und #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AG",
	  "GmbH",
	  "und Söhne",
	  "und Partner",
	  "& Co.",
	  "Gruppe",
	  "LLC",
	  "Inc."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var de_CH = {};
	module['exports'] = de_CH;
	de_CH.title = "German (Switzerland)";
	de_CH.address = __webpack_require__(435);
	de_CH.company = __webpack_require__(437);
	de_CH.internet = __webpack_require__(442);
	de_CH.name = __webpack_require__(444);
	de_CH.phone_number = __webpack_require__(449);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "net",
	  "biz",
	  "ch",
	  "de",
	  "li",
	  "at",
	  "ch",
	  "ch"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(441);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	    "Adolf",
	    "Adrian",
	    "Agnes",
	    "Alain",
	    "Albert",
	    "Alberto",
	    "Aldo",
	    "Alex",
	    "Alexander",
	    "Alexandre",
	    "Alfons",
	    "Alfred",
	    "Alice",
	    "Alois",
	    "André",
	    "Andrea",
	    "Andreas",
	    "Angela",
	    "Angelo",
	    "Anita",
	    "Anna",
	    "Anne",
	    "Anne-Marie",
	    "Annemarie",
	    "Antoine",
	    "Anton",
	    "Antonio",
	    "Armin",
	    "Arnold",
	    "Arthur",
	    "Astrid",
	    "Barbara",
	    "Beat",
	    "Beatrice",
	    "Beatrix",
	    "Bernadette",
	    "Bernard",
	    "Bernhard",
	    "Bettina",
	    "Brigitta",
	    "Brigitte",
	    "Bruno",
	    "Carlo",
	    "Carmen",
	    "Caroline",
	    "Catherine",
	    "Chantal",
	    "Charles",
	    "Charlotte",
	    "Christa",
	    "Christian",
	    "Christiane",
	    "Christina",
	    "Christine",
	    "Christoph",
	    "Christophe",
	    "Claire",
	    "Claude",
	    "Claudia",
	    "Claudine",
	    "Claudio",
	    "Corinne",
	    "Cornelia",
	    "Daniel",
	    "Daniela",
	    "Daniele",
	    "Danielle",
	    "David",
	    "Denis",
	    "Denise",
	    "Didier",
	    "Dieter",
	    "Dominik",
	    "Dominique",
	    "Dora",
	    "Doris",
	    "Edgar",
	    "Edith",
	    "Eduard",
	    "Edwin",
	    "Eliane",
	    "Elisabeth",
	    "Elsa",
	    "Elsbeth",
	    "Emil",
	    "Enrico",
	    "Eric",
	    "Erica",
	    "Erich",
	    "Erika",
	    "Ernst",
	    "Erwin",
	    "Esther",
	    "Eugen",
	    "Eva",
	    "Eveline",
	    "Evelyne",
	    "Fabienne",
	    "Felix",
	    "Ferdinand",
	    "Florence",
	    "Francesco",
	    "Francis",
	    "Franco",
	    "François",
	    "Françoise",
	    "Frank",
	    "Franz",
	    "Franziska",
	    "Frédéric",
	    "Fredy",
	    "Fridolin",
	    "Friedrich",
	    "Fritz",
	    "Gabriel",
	    "Gabriela",
	    "Gabrielle",
	    "Georg",
	    "Georges",
	    "Gérald",
	    "Gérard",
	    "Gerhard",
	    "Gertrud",
	    "Gianni",
	    "Gilbert",
	    "Giorgio",
	    "Giovanni",
	    "Gisela",
	    "Giuseppe",
	    "Gottfried",
	    "Guido",
	    "Guy",
	    "Hanna",
	    "Hans",
	    "Hans-Peter",
	    "Hans-Rudolf",
	    "Hans-Ulrich",
	    "Hansjörg",
	    "Hanspeter",
	    "Hansruedi",
	    "Hansueli",
	    "Harry",
	    "Heidi",
	    "Heinrich",
	    "Heinz",
	    "Helen",
	    "Helena",
	    "Helene",
	    "Helmut",
	    "Henri",
	    "Herbert",
	    "Hermann",
	    "Hildegard",
	    "Hubert",
	    "Hugo",
	    "Ingrid",
	    "Irene",
	    "Iris",
	    "Isabelle",
	    "Jacqueline",
	    "Jacques",
	    "Jakob",
	    "Jan",
	    "Janine",
	    "Jean",
	    "Jean-Claude",
	    "Jean-Daniel",
	    "Jean-François",
	    "Jean-Jacques",
	    "Jean-Louis",
	    "Jean-Luc",
	    "Jean-Marc",
	    "Jean-Marie",
	    "Jean-Paul",
	    "Jean-Pierre",
	    "Johann",
	    "Johanna",
	    "Johannes",
	    "John",
	    "Jolanda",
	    "Jörg",
	    "Josef",
	    "Joseph",
	    "Josette",
	    "Josiane",
	    "Judith",
	    "Julia",
	    "Jürg",
	    "Karin",
	    "Karl",
	    "Katharina",
	    "Klaus",
	    "Konrad",
	    "Kurt",
	    "Laura",
	    "Laurence",
	    "Laurent",
	    "Leo",
	    "Liliane",
	    "Liselotte",
	    "Louis",
	    "Luca",
	    "Luigi",
	    "Lukas",
	    "Lydia",
	    "Madeleine",
	    "Maja",
	    "Manfred",
	    "Manuel",
	    "Manuela",
	    "Marc",
	    "Marcel",
	    "Marco",
	    "Margrit",
	    "Margrith",
	    "Maria",
	    "Marianne",
	    "Mario",
	    "Marion",
	    "Markus",
	    "Marlène",
	    "Marlies",
	    "Marlis",
	    "Martha",
	    "Martin",
	    "Martina",
	    "Martine",
	    "Massimo",
	    "Matthias",
	    "Maurice",
	    "Max",
	    "Maya",
	    "Michael",
	    "Michel",
	    "Michele",
	    "Micheline",
	    "Monica",
	    "Monika",
	    "Monique",
	    "Myriam",
	    "Nadia",
	    "Nadja",
	    "Nathalie",
	    "Nelly",
	    "Nicolas",
	    "Nicole",
	    "Niklaus",
	    "Norbert",
	    "Olivier",
	    "Oskar",
	    "Otto",
	    "Paola",
	    "Paolo",
	    "Pascal",
	    "Patricia",
	    "Patrick",
	    "Paul",
	    "Peter",
	    "Petra",
	    "Philipp",
	    "Philippe",
	    "Pia",
	    "Pierre",
	    "Pierre-Alain",
	    "Pierre-André",
	    "Pius",
	    "Priska",
	    "Rainer",
	    "Raymond",
	    "Regina",
	    "Regula",
	    "Reinhard",
	    "Remo",
	    "Renata",
	    "Renate",
	    "Renato",
	    "Rene",
	    "René",
	    "Reto",
	    "Richard",
	    "Rita",
	    "Robert",
	    "Roberto",
	    "Roger",
	    "Roland",
	    "Rolf",
	    "Roman",
	    "Rosa",
	    "Rosemarie",
	    "Rosmarie",
	    "Rudolf",
	    "Ruedi",
	    "Ruth",
	    "Sabine",
	    "Samuel",
	    "Sandra",
	    "Sandro",
	    "Serge",
	    "Silvia",
	    "Silvio",
	    "Simon",
	    "Simone",
	    "Sonia",
	    "Sonja",
	    "Stefan",
	    "Stephan",
	    "Stéphane",
	    "Stéphanie",
	    "Susanna",
	    "Susanne",
	    "Suzanne",
	    "Sylvia",
	    "Sylvie",
	    "Theo",
	    "Theodor",
	    "Therese",
	    "Thomas",
	    "Toni",
	    "Ueli",
	    "Ulrich",
	    "Urs",
	    "Ursula",
	    "Verena",
	    "Véronique",
	    "Victor",
	    "Viktor",
	    "Vreni",
	    "Walter",
	    "Werner",
	    "Willi",
	    "Willy",
	    "Wolfgang",
	    "Yolande",
	    "Yves",
	    "Yvette",
	    "Yvonne",
	
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(443);
	name.last_name = __webpack_require__(445);
	name.prefix = __webpack_require__(447);
	name.name = __webpack_require__(446);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	    "Ackermann",
	    "Aebi",
	    "Albrecht",
	    "Ammann",
	    "Amrein",
	    "Arnold",
	    "Bachmann",
	    "Bader",
	    "Bär",
	    "Bättig",
	    "Bauer",
	    "Baumann",
	    "Baumgartner",
	    "Baur",
	    "Beck",
	    "Benz",
	    "Berger",
	    "Bernasconi",
	    "Betschart",
	    "Bianchi",
	    "Bieri",
	    "Blaser",
	    "Blum",
	    "Bolliger",
	    "Bosshard",
	    "Braun",
	    "Brun",
	    "Brunner",
	    "Bucher",
	    "Bühler",
	    "Bühlmann",
	    "Burri",
	    "Christen",
	    "Egger",
	    "Egli",
	    "Eichenberger",
	    "Erni",
	    "Ernst",
	    "Eugster",
	    "Fankhauser",
	    "Favre",
	    "Fehr",
	    "Felber",
	    "Felder",
	    "Ferrari",
	    "Fischer",
	    "Flückiger",
	    "Forster",
	    "Frei",
	    "Frey",
	    "Frick",
	    "Friedli",
	    "Fuchs",
	    "Furrer",
	    "Gasser",
	    "Geiger",
	    "Gerber",
	    "Gfeller",
	    "Giger",
	    "Gloor",
	    "Graf",
	    "Grob",
	    "Gross",
	    "Gut",
	    "Haas",
	    "Häfliger",
	    "Hafner",
	    "Hartmann",
	    "Hasler",
	    "Hauser",
	    "Hermann",
	    "Herzog",
	    "Hess",
	    "Hirt",
	    "Hodel",
	    "Hofer",
	    "Hoffmann",
	    "Hofmann",
	    "Hofstetter",
	    "Hotz",
	    "Huber",
	    "Hug",
	    "Hunziker",
	    "Hürlimann",
	    "Imhof",
	    "Isler",
	    "Iten",
	    "Jäggi",
	    "Jenni",
	    "Jost",
	    "Kägi",
	    "Kaiser",
	    "Kälin",
	    "Käser",
	    "Kaufmann",
	    "Keller",
	    "Kern",
	    "Kessler",
	    "Knecht",
	    "Koch",
	    "Kohler",
	    "Kuhn",
	    "Küng",
	    "Kunz",
	    "Lang",
	    "Lanz",
	    "Lehmann",
	    "Leu",
	    "Leunberger",
	    "Lüscher",
	    "Lustenberger",
	    "Lüthi",
	    "Lutz",
	    "Mäder",
	    "Maier",
	    "Marti",
	    "Martin",
	    "Maurer",
	    "Mayer",
	    "Meier",
	    "Meili",
	    "Meister",
	    "Merz",
	    "Mettler",
	    "Meyer",
	    "Michel",
	    "Moser",
	    "Müller",
	    "Näf",
	    "Ott",
	    "Peter",
	    "Pfister",
	    "Portmann",
	    "Probst",
	    "Rey",
	    "Ritter",
	    "Roos",
	    "Roth",
	    "Rüegg",
	    "Schäfer",
	    "Schaller",
	    "Schär",
	    "Schärer",
	    "Schaub",
	    "Scheidegger",
	    "Schenk",
	    "Scherrer",
	    "Schlatter",
	    "Schmid",
	    "Schmidt",
	    "Schneider",
	    "Schnyder",
	    "Schoch",
	    "Schuler",
	    "Schumacher",
	    "Schürch",
	    "Schwab",
	    "Schwarz",
	    "Schweizer",
	    "Seiler",
	    "Senn",
	    "Sidler",
	    "Siegrist",
	    "Sigrist",
	    "Spörri",
	    "Stadelmann",
	    "Stalder",
	    "Staub",
	    "Stauffer",
	    "Steffen",
	    "Steiger",
	    "Steiner",
	    "Steinmann",
	    "Stettler",
	    "Stocker",
	    "Stöckli",
	    "Stucki",
	    "Studer",
	    "Stutz",
	    "Suter",
	    "Sutter",
	    "Tanner",
	    "Thommen",
	    "Tobler",
	    "Vogel",
	    "Vogt",
	    "Wagner",
	    "Walder",
	    "Walter",
	    "Weber",
	    "Wegmann",
	    "Wehrli",
	    "Weibel",
	    "Wenger",
	    "Wettstein",
	    "Widmer",
	    "Winkler",
	    "Wirth",
	    "Wirz",
	    "Wolf",
	    "Wüthrich",
	    "Wyss",
	    "Zbinden",
	    "Zehnder",
	    "Ziegler",
	    "Zimmermann",
	    "Zingg",
	    "Zollinger",
	    "Zürcher"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Hr.",
	  "Fr.",
	  "Dr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0800 ### ###",
	  "0800 ## ## ##",
	  "0## ### ## ##",
	  "0## ### ## ##",
	  "+41 ## ### ## ##",
	  "0900 ### ###",
	  "076 ### ## ##",
	  "+4178 ### ## ##",
	  "0041 79 ### ## ##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(448);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "####",
	  "###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix} #{Name.first_name}#{city_suffix}",
	  "#{city_prefix} #{Name.first_name}",
	  "#{Name.first_name}#{city_suffix}",
	  "#{Name.last_name}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "North",
	  "East",
	  "West",
	  "South",
	  "New",
	  "Lake",
	  "Port"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "town",
	  "ton",
	  "land",
	  "ville",
	  "berg",
	  "burgh",
	  "borough",
	  "bury",
	  "view",
	  "port",
	  "mouth",
	  "stad",
	  "furt",
	  "chester",
	  "mouth",
	  "fort",
	  "haven",
	  "side",
	  "shire"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afghanistan",
	  "Albania",
	  "Algeria",
	  "American Samoa",
	  "Andorra",
	  "Angola",
	  "Anguilla",
	  "Antarctica (the territory South of 60 deg S)",
	  "Antigua and Barbuda",
	  "Argentina",
	  "Armenia",
	  "Aruba",
	  "Australia",
	  "Austria",
	  "Azerbaijan",
	  "Bahamas",
	  "Bahrain",
	  "Bangladesh",
	  "Barbados",
	  "Belarus",
	  "Belgium",
	  "Belize",
	  "Benin",
	  "Bermuda",
	  "Bhutan",
	  "Bolivia",
	  "Bosnia and Herzegovina",
	  "Botswana",
	  "Bouvet Island (Bouvetoya)",
	  "Brazil",
	  "British Indian Ocean Territory (Chagos Archipelago)",
	  "Brunei Darussalam",
	  "Bulgaria",
	  "Burkina Faso",
	  "Burundi",
	  "Cambodia",
	  "Cameroon",
	  "Canada",
	  "Cape Verde",
	  "Cayman Islands",
	  "Central African Republic",
	  "Chad",
	  "Chile",
	  "China",
	  "Christmas Island",
	  "Cocos (Keeling) Islands",
	  "Colombia",
	  "Comoros",
	  "Congo",
	  "Congo",
	  "Cook Islands",
	  "Costa Rica",
	  "Cote d'Ivoire",
	  "Croatia",
	  "Cuba",
	  "Cyprus",
	  "Czech Republic",
	  "Denmark",
	  "Djibouti",
	  "Dominica",
	  "Dominican Republic",
	  "Ecuador",
	  "Egypt",
	  "El Salvador",
	  "Equatorial Guinea",
	  "Eritrea",
	  "Estonia",
	  "Ethiopia",
	  "Faroe Islands",
	  "Falkland Islands (Malvinas)",
	  "Fiji",
	  "Finland",
	  "France",
	  "French Guiana",
	  "French Polynesia",
	  "French Southern Territories",
	  "Gabon",
	  "Gambia",
	  "Georgia",
	  "Germany",
	  "Ghana",
	  "Gibraltar",
	  "Greece",
	  "Greenland",
	  "Grenada",
	  "Guadeloupe",
	  "Guam",
	  "Guatemala",
	  "Guernsey",
	  "Guinea",
	  "Guinea-Bissau",
	  "Guyana",
	  "Haiti",
	  "Heard Island and McDonald Islands",
	  "Holy See (Vatican City State)",
	  "Honduras",
	  "Hong Kong",
	  "Hungary",
	  "Iceland",
	  "India",
	  "Indonesia",
	  "Iran",
	  "Iraq",
	  "Ireland",
	  "Isle of Man",
	  "Israel",
	  "Italy",
	  "Jamaica",
	  "Japan",
	  "Jersey",
	  "Jordan",
	  "Kazakhstan",
	  "Kenya",
	  "Kiribati",
	  "Democratic People's Republic of Korea",
	  "Republic of Korea",
	  "Kuwait",
	  "Kyrgyz Republic",
	  "Lao People's Democratic Republic",
	  "Latvia",
	  "Lebanon",
	  "Lesotho",
	  "Liberia",
	  "Libyan Arab Jamahiriya",
	  "Liechtenstein",
	  "Lithuania",
	  "Luxembourg",
	  "Macao",
	  "Macedonia",
	  "Madagascar",
	  "Malawi",
	  "Malaysia",
	  "Maldives",
	  "Mali",
	  "Malta",
	  "Marshall Islands",
	  "Martinique",
	  "Mauritania",
	  "Mauritius",
	  "Mayotte",
	  "Mexico",
	  "Micronesia",
	  "Moldova",
	  "Monaco",
	  "Mongolia",
	  "Montenegro",
	  "Montserrat",
	  "Morocco",
	  "Mozambique",
	  "Myanmar",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Netherlands Antilles",
	  "Netherlands",
	  "New Caledonia",
	  "New Zealand",
	  "Nicaragua",
	  "Niger",
	  "Nigeria",
	  "Niue",
	  "Norfolk Island",
	  "Northern Mariana Islands",
	  "Norway",
	  "Oman",
	  "Pakistan",
	  "Palau",
	  "Palestinian Territory",
	  "Panama",
	  "Papua New Guinea",
	  "Paraguay",
	  "Peru",
	  "Philippines",
	  "Pitcairn Islands",
	  "Poland",
	  "Portugal",
	  "Puerto Rico",
	  "Qatar",
	  "Reunion",
	  "Romania",
	  "Russian Federation",
	  "Rwanda",
	  "Saint Barthelemy",
	  "Saint Helena",
	  "Saint Kitts and Nevis",
	  "Saint Lucia",
	  "Saint Martin",
	  "Saint Pierre and Miquelon",
	  "Saint Vincent and the Grenadines",
	  "Samoa",
	  "San Marino",
	  "Sao Tome and Principe",
	  "Saudi Arabia",
	  "Senegal",
	  "Serbia",
	  "Seychelles",
	  "Sierra Leone",
	  "Singapore",
	  "Slovakia (Slovak Republic)",
	  "Slovenia",
	  "Solomon Islands",
	  "Somalia",
	  "South Africa",
	  "South Georgia and the South Sandwich Islands",
	  "Spain",
	  "Sri Lanka",
	  "Sudan",
	  "Suriname",
	  "Svalbard & Jan Mayen Islands",
	  "Swaziland",
	  "Sweden",
	  "Switzerland",
	  "Syrian Arab Republic",
	  "Taiwan",
	  "Tajikistan",
	  "Tanzania",
	  "Thailand",
	  "Timor-Leste",
	  "Togo",
	  "Tokelau",
	  "Tonga",
	  "Trinidad and Tobago",
	  "Tunisia",
	  "Turkey",
	  "Turkmenistan",
	  "Turks and Caicos Islands",
	  "Tuvalu",
	  "Uganda",
	  "Ukraine",
	  "United Arab Emirates",
	  "United Kingdom",
	  "United States of America",
	  "United States Minor Outlying Islands",
	  "Uruguay",
	  "Uzbekistan",
	  "Vanuatu",
	  "Venezuela",
	  "Vietnam",
	  "Virgin Islands, British",
	  "Virgin Islands, U.S.",
	  "Wallis and Futuna",
	  "Western Sahara",
	  "Yemen",
	  "Zambia",
	  "Zimbabwe"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AD",
	  "AE",
	  "AF",
	  "AG",
	  "AI",
	  "AL",
	  "AM",
	  "AO",
	  "AQ",
	  "AR",
	  "AS",
	  "AT",
	  "AU",
	  "AW",
	  "AX",
	  "AZ",
	  "BA",
	  "BB",
	  "BD",
	  "BE",
	  "BF",
	  "BG",
	  "BH",
	  "BI",
	  "BJ",
	  "BL",
	  "BM",
	  "BN",
	  "BO",
	  "BQ",
	  "BQ",
	  "BR",
	  "BS",
	  "BT",
	  "BV",
	  "BW",
	  "BY",
	  "BZ",
	  "CA",
	  "CC",
	  "CD",
	  "CF",
	  "CG",
	  "CH",
	  "CI",
	  "CK",
	  "CL",
	  "CM",
	  "CN",
	  "CO",
	  "CR",
	  "CU",
	  "CV",
	  "CW",
	  "CX",
	  "CY",
	  "CZ",
	  "DE",
	  "DJ",
	  "DK",
	  "DM",
	  "DO",
	  "DZ",
	  "EC",
	  "EE",
	  "EG",
	  "EH",
	  "ER",
	  "ES",
	  "ET",
	  "FI",
	  "FJ",
	  "FK",
	  "FM",
	  "FO",
	  "FR",
	  "GA",
	  "GB",
	  "GD",
	  "GE",
	  "GF",
	  "GG",
	  "GH",
	  "GI",
	  "GL",
	  "GM",
	  "GN",
	  "GP",
	  "GQ",
	  "GR",
	  "GS",
	  "GT",
	  "GU",
	  "GW",
	  "GY",
	  "HK",
	  "HM",
	  "HN",
	  "HR",
	  "HT",
	  "HU",
	  "ID",
	  "IE",
	  "IL",
	  "IM",
	  "IN",
	  "IO",
	  "IQ",
	  "IR",
	  "IS",
	  "IT",
	  "JE",
	  "JM",
	  "JO",
	  "JP",
	  "KE",
	  "KG",
	  "KH",
	  "KI",
	  "KM",
	  "KN",
	  "KP",
	  "KR",
	  "KW",
	  "KY",
	  "KZ",
	  "LA",
	  "LB",
	  "LC",
	  "LI",
	  "LK",
	  "LR",
	  "LS",
	  "LT",
	  "LU",
	  "LV",
	  "LY",
	  "MA",
	  "MC",
	  "MD",
	  "ME",
	  "MF",
	  "MG",
	  "MH",
	  "MK",
	  "ML",
	  "MM",
	  "MN",
	  "MO",
	  "MP",
	  "MQ",
	  "MR",
	  "MS",
	  "MT",
	  "MU",
	  "MV",
	  "MW",
	  "MX",
	  "MY",
	  "MZ",
	  "NA",
	  "NC",
	  "NE",
	  "NF",
	  "NG",
	  "NI",
	  "NL",
	  "NO",
	  "NP",
	  "NR",
	  "NU",
	  "NZ",
	  "OM",
	  "PA",
	  "PE",
	  "PF",
	  "PG",
	  "PH",
	  "PK",
	  "PL",
	  "PM",
	  "PN",
	  "PR",
	  "PS",
	  "PT",
	  "PW",
	  "PY",
	  "QA",
	  "RE",
	  "RO",
	  "RS",
	  "RU",
	  "RW",
	  "SA",
	  "SB",
	  "SC",
	  "SD",
	  "SE",
	  "SG",
	  "SH",
	  "SI",
	  "SJ",
	  "SK",
	  "SL",
	  "SM",
	  "SN",
	  "SO",
	  "SR",
	  "SS",
	  "ST",
	  "SV",
	  "SX",
	  "SY",
	  "SZ",
	  "TC",
	  "TD",
	  "TF",
	  "TG",
	  "TH",
	  "TJ",
	  "TK",
	  "TL",
	  "TM",
	  "TN",
	  "TO",
	  "TR",
	  "TT",
	  "TV",
	  "TW",
	  "TZ",
	  "UA",
	  "UG",
	  "UM",
	  "US",
	  "UY",
	  "UZ",
	  "VA",
	  "VC",
	  "VE",
	  "VG",
	  "VI",
	  "VN",
	  "VU",
	  "WF",
	  "WS",
	  "YE",
	  "YT",
	  "ZA",
	  "ZM",
	  "ZW"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Avon",
	  "Bedfordshire",
	  "Berkshire",
	  "Borders",
	  "Buckinghamshire",
	  "Cambridgeshire"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "United States of America"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(452);
	address.city_suffix = __webpack_require__(453);
	address.county = __webpack_require__(456);
	address.country = __webpack_require__(454);
	address.country_code = __webpack_require__(455);
	address.building_number = __webpack_require__(450);
	address.street_suffix = __webpack_require__(466);
	address.secondary_address = __webpack_require__(461);
	address.postcode = __webpack_require__(459);
	address.postcode_by_state = __webpack_require__(460);
	address.state = __webpack_require__(462);
	address.state_abbr = __webpack_require__(463);
	address.time_zone = __webpack_require__(467);
	address.city = __webpack_require__(451);
	address.street_name = __webpack_require__(465);
	address.street_address = __webpack_require__(464);
	address.default_country = __webpack_require__(457);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "#####-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "#####-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apt. ###",
	  "Suite ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alabama",
	  "Alaska",
	  "Arizona",
	  "Arkansas",
	  "California",
	  "Colorado",
	  "Connecticut",
	  "Delaware",
	  "Florida",
	  "Georgia",
	  "Hawaii",
	  "Idaho",
	  "Illinois",
	  "Indiana",
	  "Iowa",
	  "Kansas",
	  "Kentucky",
	  "Louisiana",
	  "Maine",
	  "Maryland",
	  "Massachusetts",
	  "Michigan",
	  "Minnesota",
	  "Mississippi",
	  "Missouri",
	  "Montana",
	  "Nebraska",
	  "Nevada",
	  "New Hampshire",
	  "New Jersey",
	  "New Mexico",
	  "New York",
	  "North Carolina",
	  "North Dakota",
	  "Ohio",
	  "Oklahoma",
	  "Oregon",
	  "Pennsylvania",
	  "Rhode Island",
	  "South Carolina",
	  "South Dakota",
	  "Tennessee",
	  "Texas",
	  "Utah",
	  "Vermont",
	  "Virginia",
	  "Washington",
	  "West Virginia",
	  "Wisconsin",
	  "Wyoming"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AL",
	  "AK",
	  "AZ",
	  "AR",
	  "CA",
	  "CO",
	  "CT",
	  "DE",
	  "FL",
	  "GA",
	  "HI",
	  "ID",
	  "IL",
	  "IN",
	  "IA",
	  "KS",
	  "KY",
	  "LA",
	  "ME",
	  "MD",
	  "MA",
	  "MI",
	  "MN",
	  "MS",
	  "MO",
	  "MT",
	  "NE",
	  "NV",
	  "NH",
	  "NJ",
	  "NM",
	  "NY",
	  "NC",
	  "ND",
	  "OH",
	  "OK",
	  "OR",
	  "PA",
	  "RI",
	  "SC",
	  "SD",
	  "TN",
	  "TX",
	  "UT",
	  "VT",
	  "VA",
	  "WA",
	  "WV",
	  "WI",
	  "WY"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{building_number} #{street_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.first_name} #{street_suffix}",
	  "#{Name.last_name} #{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alley",
	  "Avenue",
	  "Branch",
	  "Bridge",
	  "Brook",
	  "Brooks",
	  "Burg",
	  "Burgs",
	  "Bypass",
	  "Camp",
	  "Canyon",
	  "Cape",
	  "Causeway",
	  "Center",
	  "Centers",
	  "Circle",
	  "Circles",
	  "Cliff",
	  "Cliffs",
	  "Club",
	  "Common",
	  "Corner",
	  "Corners",
	  "Course",
	  "Court",
	  "Courts",
	  "Cove",
	  "Coves",
	  "Creek",
	  "Crescent",
	  "Crest",
	  "Crossing",
	  "Crossroad",
	  "Curve",
	  "Dale",
	  "Dam",
	  "Divide",
	  "Drive",
	  "Drive",
	  "Drives",
	  "Estate",
	  "Estates",
	  "Expressway",
	  "Extension",
	  "Extensions",
	  "Fall",
	  "Falls",
	  "Ferry",
	  "Field",
	  "Fields",
	  "Flat",
	  "Flats",
	  "Ford",
	  "Fords",
	  "Forest",
	  "Forge",
	  "Forges",
	  "Fork",
	  "Forks",
	  "Fort",
	  "Freeway",
	  "Garden",
	  "Gardens",
	  "Gateway",
	  "Glen",
	  "Glens",
	  "Green",
	  "Greens",
	  "Grove",
	  "Groves",
	  "Harbor",
	  "Harbors",
	  "Haven",
	  "Heights",
	  "Highway",
	  "Hill",
	  "Hills",
	  "Hollow",
	  "Inlet",
	  "Inlet",
	  "Island",
	  "Island",
	  "Islands",
	  "Islands",
	  "Isle",
	  "Isle",
	  "Junction",
	  "Junctions",
	  "Key",
	  "Keys",
	  "Knoll",
	  "Knolls",
	  "Lake",
	  "Lakes",
	  "Land",
	  "Landing",
	  "Lane",
	  "Light",
	  "Lights",
	  "Loaf",
	  "Lock",
	  "Locks",
	  "Locks",
	  "Lodge",
	  "Lodge",
	  "Loop",
	  "Mall",
	  "Manor",
	  "Manors",
	  "Meadow",
	  "Meadows",
	  "Mews",
	  "Mill",
	  "Mills",
	  "Mission",
	  "Mission",
	  "Motorway",
	  "Mount",
	  "Mountain",
	  "Mountain",
	  "Mountains",
	  "Mountains",
	  "Neck",
	  "Orchard",
	  "Oval",
	  "Overpass",
	  "Park",
	  "Parks",
	  "Parkway",
	  "Parkways",
	  "Pass",
	  "Passage",
	  "Path",
	  "Pike",
	  "Pine",
	  "Pines",
	  "Place",
	  "Plain",
	  "Plains",
	  "Plains",
	  "Plaza",
	  "Plaza",
	  "Point",
	  "Points",
	  "Port",
	  "Port",
	  "Ports",
	  "Ports",
	  "Prairie",
	  "Prairie",
	  "Radial",
	  "Ramp",
	  "Ranch",
	  "Rapid",
	  "Rapids",
	  "Rest",
	  "Ridge",
	  "Ridges",
	  "River",
	  "Road",
	  "Road",
	  "Roads",
	  "Roads",
	  "Route",
	  "Row",
	  "Rue",
	  "Run",
	  "Shoal",
	  "Shoals",
	  "Shore",
	  "Shores",
	  "Skyway",
	  "Spring",
	  "Springs",
	  "Springs",
	  "Spur",
	  "Spurs",
	  "Square",
	  "Square",
	  "Squares",
	  "Squares",
	  "Station",
	  "Station",
	  "Stravenue",
	  "Stravenue",
	  "Stream",
	  "Stream",
	  "Street",
	  "Street",
	  "Streets",
	  "Summit",
	  "Summit",
	  "Terrace",
	  "Throughway",
	  "Trace",
	  "Track",
	  "Trafficway",
	  "Trail",
	  "Trail",
	  "Tunnel",
	  "Tunnel",
	  "Turnpike",
	  "Turnpike",
	  "Underpass",
	  "Union",
	  "Unions",
	  "Valley",
	  "Valleys",
	  "Via",
	  "Viaduct",
	  "View",
	  "Views",
	  "Village",
	  "Village",
	  "Villages",
	  "Ville",
	  "Vista",
	  "Vista",
	  "Walk",
	  "Walks",
	  "Wall",
	  "Way",
	  "Ways",
	  "Well",
	  "Wells"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pacific/Midway",
	  "Pacific/Pago_Pago",
	  "Pacific/Honolulu",
	  "America/Juneau",
	  "America/Los_Angeles",
	  "America/Tijuana",
	  "America/Denver",
	  "America/Phoenix",
	  "America/Chihuahua",
	  "America/Mazatlan",
	  "America/Chicago",
	  "America/Regina",
	  "America/Mexico_City",
	  "America/Mexico_City",
	  "America/Monterrey",
	  "America/Guatemala",
	  "America/New_York",
	  "America/Indiana/Indianapolis",
	  "America/Bogota",
	  "America/Lima",
	  "America/Lima",
	  "America/Halifax",
	  "America/Caracas",
	  "America/La_Paz",
	  "America/Santiago",
	  "America/St_Johns",
	  "America/Sao_Paulo",
	  "America/Argentina/Buenos_Aires",
	  "America/Guyana",
	  "America/Godthab",
	  "Atlantic/South_Georgia",
	  "Atlantic/Azores",
	  "Atlantic/Cape_Verde",
	  "Europe/Dublin",
	  "Europe/London",
	  "Europe/Lisbon",
	  "Europe/London",
	  "Africa/Casablanca",
	  "Africa/Monrovia",
	  "Etc/UTC",
	  "Europe/Belgrade",
	  "Europe/Bratislava",
	  "Europe/Budapest",
	  "Europe/Ljubljana",
	  "Europe/Prague",
	  "Europe/Sarajevo",
	  "Europe/Skopje",
	  "Europe/Warsaw",
	  "Europe/Zagreb",
	  "Europe/Brussels",
	  "Europe/Copenhagen",
	  "Europe/Madrid",
	  "Europe/Paris",
	  "Europe/Amsterdam",
	  "Europe/Berlin",
	  "Europe/Berlin",
	  "Europe/Rome",
	  "Europe/Stockholm",
	  "Europe/Vienna",
	  "Africa/Algiers",
	  "Europe/Bucharest",
	  "Africa/Cairo",
	  "Europe/Helsinki",
	  "Europe/Kiev",
	  "Europe/Riga",
	  "Europe/Sofia",
	  "Europe/Tallinn",
	  "Europe/Vilnius",
	  "Europe/Athens",
	  "Europe/Istanbul",
	  "Europe/Minsk",
	  "Asia/Jerusalem",
	  "Africa/Harare",
	  "Africa/Johannesburg",
	  "Europe/Moscow",
	  "Europe/Moscow",
	  "Europe/Moscow",
	  "Asia/Kuwait",
	  "Asia/Riyadh",
	  "Africa/Nairobi",
	  "Asia/Baghdad",
	  "Asia/Tehran",
	  "Asia/Muscat",
	  "Asia/Muscat",
	  "Asia/Baku",
	  "Asia/Tbilisi",
	  "Asia/Yerevan",
	  "Asia/Kabul",
	  "Asia/Yekaterinburg",
	  "Asia/Karachi",
	  "Asia/Karachi",
	  "Asia/Tashkent",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kathmandu",
	  "Asia/Dhaka",
	  "Asia/Dhaka",
	  "Asia/Colombo",
	  "Asia/Almaty",
	  "Asia/Novosibirsk",
	  "Asia/Rangoon",
	  "Asia/Bangkok",
	  "Asia/Bangkok",
	  "Asia/Jakarta",
	  "Asia/Krasnoyarsk",
	  "Asia/Shanghai",
	  "Asia/Chongqing",
	  "Asia/Hong_Kong",
	  "Asia/Urumqi",
	  "Asia/Kuala_Lumpur",
	  "Asia/Singapore",
	  "Asia/Taipei",
	  "Australia/Perth",
	  "Asia/Irkutsk",
	  "Asia/Ulaanbaatar",
	  "Asia/Seoul",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Yakutsk",
	  "Australia/Darwin",
	  "Australia/Adelaide",
	  "Australia/Melbourne",
	  "Australia/Melbourne",
	  "Australia/Sydney",
	  "Australia/Brisbane",
	  "Australia/Hobart",
	  "Asia/Vladivostok",
	  "Pacific/Guam",
	  "Pacific/Port_Moresby",
	  "Asia/Magadan",
	  "Asia/Magadan",
	  "Pacific/Noumea",
	  "Pacific/Fiji",
	  "Asia/Kamchatka",
	  "Pacific/Majuro",
	  "Pacific/Auckland",
	  "Pacific/Auckland",
	  "Pacific/Tongatapu",
	  "Pacific/Fakaofo",
	  "Pacific/Apia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.name}",
	  "#{Company.name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var app = {};
	module['exports'] = app;
	app.name = __webpack_require__(470);
	app.version = __webpack_require__(471);
	app.author = __webpack_require__(468);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Redhold",
	  "Treeflex",
	  "Trippledex",
	  "Kanlam",
	  "Bigtax",
	  "Daltfresh",
	  "Toughjoyfax",
	  "Mat Lam Tam",
	  "Otcom",
	  "Tres-Zap",
	  "Y-Solowarm",
	  "Tresom",
	  "Voltsillam",
	  "Biodex",
	  "Greenlam",
	  "Viva",
	  "Matsoft",
	  "Temp",
	  "Zoolab",
	  "Subin",
	  "Rank",
	  "Job",
	  "Stringtough",
	  "Tin",
	  "It",
	  "Home Ing",
	  "Zamit",
	  "Sonsing",
	  "Konklab",
	  "Alpha",
	  "Latlux",
	  "Voyatouch",
	  "Alphazap",
	  "Holdlamis",
	  "Zaam-Dox",
	  "Sub-Ex",
	  "Quo Lux",
	  "Bamity",
	  "Ventosanzap",
	  "Lotstring",
	  "Hatity",
	  "Tempsoft",
	  "Overhold",
	  "Fixflex",
	  "Konklux",
	  "Zontrax",
	  "Tampflex",
	  "Span",
	  "Namfix",
	  "Transcof",
	  "Stim",
	  "Fix San",
	  "Sonair",
	  "Stronghold",
	  "Fintone",
	  "Y-find",
	  "Opela",
	  "Lotlux",
	  "Ronstring",
	  "Zathin",
	  "Duobam",
	  "Keylex"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0.#.#",
	  "0.##",
	  "#.##",
	  "#.#",
	  "#.#.#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "2011-10-12",
	  "2012-11-12",
	  "2015-11-11",
	  "2013-9-12"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "1234-2121-1221-1211",
	  "1212-1221-1121-1234",
	  "1211-1221-1234-2201",
	  "1228-1221-1221-1431"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "visa",
	  "mastercard",
	  "americanexpress",
	  "discover"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var business = {};
	module['exports'] = business;
	business.credit_card_numbers = __webpack_require__(473);
	business.credit_card_expiry_dates = __webpack_require__(472);
	business.credit_card_types = __webpack_require__(474);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###-###-####",
	  "(###) ###-####",
	  "1-###-###-####",
	  "###.###.####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(476);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "red",
	  "green",
	  "blue",
	  "yellow",
	  "purple",
	  "mint green",
	  "teal",
	  "white",
	  "black",
	  "orange",
	  "pink",
	  "grey",
	  "maroon",
	  "violet",
	  "turquoise",
	  "tan",
	  "sky blue",
	  "salmon",
	  "plum",
	  "orchid",
	  "olive",
	  "magenta",
	  "lime",
	  "ivory",
	  "indigo",
	  "gold",
	  "fuchsia",
	  "cyan",
	  "azure",
	  "lavender",
	  "silver"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Books",
	  "Movies",
	  "Music",
	  "Games",
	  "Electronics",
	  "Computers",
	  "Home",
	  "Garden",
	  "Tools",
	  "Grocery",
	  "Health",
	  "Beauty",
	  "Toys",
	  "Kids",
	  "Baby",
	  "Clothing",
	  "Shoes",
	  "Jewelery",
	  "Sports",
	  "Outdoors",
	  "Automotive",
	  "Industrial"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var commerce = {};
	module['exports'] = commerce;
	commerce.color = __webpack_require__(478);
	commerce.department = __webpack_require__(479);
	commerce.product_name = __webpack_require__(481);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "adjective": [
	    "Small",
	    "Ergonomic",
	    "Rustic",
	    "Intelligent",
	    "Gorgeous",
	    "Incredible",
	    "Fantastic",
	    "Practical",
	    "Sleek",
	    "Awesome",
	    "Generic",
	    "Handcrafted",
	    "Handmade",
	    "Licensed",
	    "Refined",
	    "Unbranded",
	    "Tasty"
	  ],
	  "material": [
	    "Steel",
	    "Wooden",
	    "Concrete",
	    "Plastic",
	    "Cotton",
	    "Granite",
	    "Rubber",
	    "Metal",
	    "Soft",
	    "Fresh",
	    "Frozen"
	  ],
	  "product": [
	    "Chair",
	    "Car",
	    "Computer",
	    "Keyboard",
	    "Mouse",
	    "Bike",
	    "Ball",
	    "Gloves",
	    "Pants",
	    "Shirt",
	    "Table",
	    "Shoes",
	    "Hat",
	    "Towels",
	    "Soap",
	    "Tuna",
	    "Chicken",
	    "Fish",
	    "Cheese",
	    "Bacon",
	    "Pizza",
	    "Salad",
	    "Sausages",
	    "Chips"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adaptive",
	  "Advanced",
	  "Ameliorated",
	  "Assimilated",
	  "Automated",
	  "Balanced",
	  "Business-focused",
	  "Centralized",
	  "Cloned",
	  "Compatible",
	  "Configurable",
	  "Cross-group",
	  "Cross-platform",
	  "Customer-focused",
	  "Customizable",
	  "Decentralized",
	  "De-engineered",
	  "Devolved",
	  "Digitized",
	  "Distributed",
	  "Diverse",
	  "Down-sized",
	  "Enhanced",
	  "Enterprise-wide",
	  "Ergonomic",
	  "Exclusive",
	  "Expanded",
	  "Extended",
	  "Face to face",
	  "Focused",
	  "Front-line",
	  "Fully-configurable",
	  "Function-based",
	  "Fundamental",
	  "Future-proofed",
	  "Grass-roots",
	  "Horizontal",
	  "Implemented",
	  "Innovative",
	  "Integrated",
	  "Intuitive",
	  "Inverse",
	  "Managed",
	  "Mandatory",
	  "Monitored",
	  "Multi-channelled",
	  "Multi-lateral",
	  "Multi-layered",
	  "Multi-tiered",
	  "Networked",
	  "Object-based",
	  "Open-architected",
	  "Open-source",
	  "Operative",
	  "Optimized",
	  "Optional",
	  "Organic",
	  "Organized",
	  "Persevering",
	  "Persistent",
	  "Phased",
	  "Polarised",
	  "Pre-emptive",
	  "Proactive",
	  "Profit-focused",
	  "Profound",
	  "Programmable",
	  "Progressive",
	  "Public-key",
	  "Quality-focused",
	  "Reactive",
	  "Realigned",
	  "Re-contextualized",
	  "Re-engineered",
	  "Reduced",
	  "Reverse-engineered",
	  "Right-sized",
	  "Robust",
	  "Seamless",
	  "Secured",
	  "Self-enabling",
	  "Sharable",
	  "Stand-alone",
	  "Streamlined",
	  "Switchable",
	  "Synchronised",
	  "Synergistic",
	  "Synergized",
	  "Team-oriented",
	  "Total",
	  "Triple-buffered",
	  "Universal",
	  "Up-sized",
	  "Upgradable",
	  "User-centric",
	  "User-friendly",
	  "Versatile",
	  "Virtual",
	  "Visionary",
	  "Vision-oriented"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "clicks-and-mortar",
	  "value-added",
	  "vertical",
	  "proactive",
	  "robust",
	  "revolutionary",
	  "scalable",
	  "leading-edge",
	  "innovative",
	  "intuitive",
	  "strategic",
	  "e-business",
	  "mission-critical",
	  "sticky",
	  "one-to-one",
	  "24/7",
	  "end-to-end",
	  "global",
	  "B2B",
	  "B2C",
	  "granular",
	  "frictionless",
	  "virtual",
	  "viral",
	  "dynamic",
	  "24/365",
	  "best-of-breed",
	  "killer",
	  "magnetic",
	  "bleeding-edge",
	  "web-enabled",
	  "interactive",
	  "dot-com",
	  "sexy",
	  "back-end",
	  "real-time",
	  "efficient",
	  "front-end",
	  "distributed",
	  "seamless",
	  "extensible",
	  "turn-key",
	  "world-class",
	  "open-source",
	  "cross-platform",
	  "cross-media",
	  "synergistic",
	  "bricks-and-clicks",
	  "out-of-the-box",
	  "enterprise",
	  "integrated",
	  "impactful",
	  "wireless",
	  "transparent",
	  "next-generation",
	  "cutting-edge",
	  "user-centric",
	  "visionary",
	  "customized",
	  "ubiquitous",
	  "plug-and-play",
	  "collaborative",
	  "compelling",
	  "holistic",
	  "rich"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "synergies",
	  "web-readiness",
	  "paradigms",
	  "markets",
	  "partnerships",
	  "infrastructures",
	  "platforms",
	  "initiatives",
	  "channels",
	  "eyeballs",
	  "communities",
	  "ROI",
	  "solutions",
	  "e-tailers",
	  "e-services",
	  "action-items",
	  "portals",
	  "niches",
	  "technologies",
	  "content",
	  "vortals",
	  "supply-chains",
	  "convergence",
	  "relationships",
	  "architectures",
	  "interfaces",
	  "e-markets",
	  "e-commerce",
	  "systems",
	  "bandwidth",
	  "infomediaries",
	  "models",
	  "mindshare",
	  "deliverables",
	  "users",
	  "schemas",
	  "networks",
	  "applications",
	  "metrics",
	  "e-business",
	  "functionalities",
	  "experiences",
	  "web services",
	  "methodologies"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "implement",
	  "utilize",
	  "integrate",
	  "streamline",
	  "optimize",
	  "evolve",
	  "transform",
	  "embrace",
	  "enable",
	  "orchestrate",
	  "leverage",
	  "reinvent",
	  "aggregate",
	  "architect",
	  "enhance",
	  "incentivize",
	  "morph",
	  "empower",
	  "envisioneer",
	  "monetize",
	  "harness",
	  "facilitate",
	  "seize",
	  "disintermediate",
	  "synergize",
	  "strategize",
	  "deploy",
	  "brand",
	  "grow",
	  "target",
	  "syndicate",
	  "synthesize",
	  "deliver",
	  "mesh",
	  "incubate",
	  "engage",
	  "maximize",
	  "benchmark",
	  "expedite",
	  "reintermediate",
	  "whiteboard",
	  "visualize",
	  "repurpose",
	  "innovate",
	  "scale",
	  "unleash",
	  "drive",
	  "extend",
	  "engineer",
	  "revolutionize",
	  "generate",
	  "exploit",
	  "transition",
	  "e-enable",
	  "iterate",
	  "cultivate",
	  "matrix",
	  "productize",
	  "redefine",
	  "recontextualize"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 hour",
	  "24/7",
	  "3rd generation",
	  "4th generation",
	  "5th generation",
	  "6th generation",
	  "actuating",
	  "analyzing",
	  "asymmetric",
	  "asynchronous",
	  "attitude-oriented",
	  "background",
	  "bandwidth-monitored",
	  "bi-directional",
	  "bifurcated",
	  "bottom-line",
	  "clear-thinking",
	  "client-driven",
	  "client-server",
	  "coherent",
	  "cohesive",
	  "composite",
	  "context-sensitive",
	  "contextually-based",
	  "content-based",
	  "dedicated",
	  "demand-driven",
	  "didactic",
	  "directional",
	  "discrete",
	  "disintermediate",
	  "dynamic",
	  "eco-centric",
	  "empowering",
	  "encompassing",
	  "even-keeled",
	  "executive",
	  "explicit",
	  "exuding",
	  "fault-tolerant",
	  "foreground",
	  "fresh-thinking",
	  "full-range",
	  "global",
	  "grid-enabled",
	  "heuristic",
	  "high-level",
	  "holistic",
	  "homogeneous",
	  "human-resource",
	  "hybrid",
	  "impactful",
	  "incremental",
	  "intangible",
	  "interactive",
	  "intermediate",
	  "leading edge",
	  "local",
	  "logistical",
	  "maximized",
	  "methodical",
	  "mission-critical",
	  "mobile",
	  "modular",
	  "motivating",
	  "multimedia",
	  "multi-state",
	  "multi-tasking",
	  "national",
	  "needs-based",
	  "neutral",
	  "next generation",
	  "non-volatile",
	  "object-oriented",
	  "optimal",
	  "optimizing",
	  "radical",
	  "real-time",
	  "reciprocal",
	  "regional",
	  "responsive",
	  "scalable",
	  "secondary",
	  "solution-oriented",
	  "stable",
	  "static",
	  "systematic",
	  "systemic",
	  "system-worthy",
	  "tangible",
	  "tertiary",
	  "transitional",
	  "uniform",
	  "upward-trending",
	  "user-facing",
	  "value-added",
	  "web-enabled",
	  "well-modulated",
	  "zero administration",
	  "zero defect",
	  "zero tolerance"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(490);
	company.adjective = __webpack_require__(482);
	company.descriptor = __webpack_require__(486);
	company.noun = __webpack_require__(489);
	company.bs_verb = __webpack_require__(485);
	company.bs_adjective = __webpack_require__(483);
	company.bs_noun = __webpack_require__(484);
	company.name = __webpack_require__(488);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} and #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ability",
	  "access",
	  "adapter",
	  "algorithm",
	  "alliance",
	  "analyzer",
	  "application",
	  "approach",
	  "architecture",
	  "archive",
	  "artificial intelligence",
	  "array",
	  "attitude",
	  "benchmark",
	  "budgetary management",
	  "capability",
	  "capacity",
	  "challenge",
	  "circuit",
	  "collaboration",
	  "complexity",
	  "concept",
	  "conglomeration",
	  "contingency",
	  "core",
	  "customer loyalty",
	  "database",
	  "data-warehouse",
	  "definition",
	  "emulation",
	  "encoding",
	  "encryption",
	  "extranet",
	  "firmware",
	  "flexibility",
	  "focus group",
	  "forecast",
	  "frame",
	  "framework",
	  "function",
	  "functionalities",
	  "Graphic Interface",
	  "groupware",
	  "Graphical User Interface",
	  "hardware",
	  "help-desk",
	  "hierarchy",
	  "hub",
	  "implementation",
	  "info-mediaries",
	  "infrastructure",
	  "initiative",
	  "installation",
	  "instruction set",
	  "interface",
	  "internet solution",
	  "intranet",
	  "knowledge user",
	  "knowledge base",
	  "local area network",
	  "leverage",
	  "matrices",
	  "matrix",
	  "methodology",
	  "middleware",
	  "migration",
	  "model",
	  "moderator",
	  "monitoring",
	  "moratorium",
	  "neural-net",
	  "open architecture",
	  "open system",
	  "orchestration",
	  "paradigm",
	  "parallelism",
	  "policy",
	  "portal",
	  "pricing structure",
	  "process improvement",
	  "product",
	  "productivity",
	  "project",
	  "projection",
	  "protocol",
	  "secured line",
	  "service-desk",
	  "software",
	  "solution",
	  "standardization",
	  "strategy",
	  "structure",
	  "success",
	  "superstructure",
	  "support",
	  "synergy",
	  "system engine",
	  "task-force",
	  "throughput",
	  "time-frame",
	  "toolset",
	  "utilisation",
	  "website",
	  "workforce"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Inc",
	  "and Sons",
	  "LLC",
	  "Group"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/34##-######-####L/",
	  "/37##-######-####L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/30[0-5]#-######-###L/",
	  "/368#-######-###L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/6011-####-####-###L/",
	  "/65##-####-####-###L/",
	  "/64[4-9]#-####-####-###L/",
	  "/6011-62##-####-####-###L/",
	  "/65##-62##-####-####-###L/",
	  "/64[4-9]#-62##-####-####-###L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var credit_card = {};
	module['exports'] = credit_card;
	credit_card.visa = __webpack_require__(501);
	credit_card.mastercard = __webpack_require__(498);
	credit_card.discover = __webpack_require__(493);
	credit_card.american_express = __webpack_require__(491);
	credit_card.diners_club = __webpack_require__(492);
	credit_card.jcb = __webpack_require__(495);
	credit_card.switch = __webpack_require__(500);
	credit_card.solo = __webpack_require__(499);
	credit_card.maestro = __webpack_require__(497);
	credit_card.laser = __webpack_require__(496);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/3528-####-####-###L/",
	  "/3529-####-####-###L/",
	  "/35[3-8]#-####-####-###L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/6304###########L/",
	  "/6706###########L/",
	  "/6771###########L/",
	  "/6709###########L/",
	  "/6304#########{5,6}L/",
	  "/6706#########{5,6}L/",
	  "/6771#########{5,6}L/",
	  "/6709#########{5,6}L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/50#{9,16}L/",
	  "/5[6-8]#{9,16}L/",
	  "/56##{9,16}L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/5[1-5]##-####-####-###L/",
	  "/6771-89##-####-###L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/6767-####-####-###L/",
	  "/6767-####-####-####-#L/",
	  "/6767-####-####-####-##L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/6759-####-####-###L/",
	  "/6759-####-####-####-#L/",
	  "/6759-####-####-####-##L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/4###########L/",
	  "/4###-####-####-###L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var date = {};
	module["exports"] = date;
	date.month = __webpack_require__(503);
	date.weekday = __webpack_require__(504);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// Source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/en.xml#L1799
	module["exports"] = {
	  wide: [
	    "January",
	    "February",
	    "March",
	    "April",
	    "May",
	    "June",
	    "July",
	    "August",
	    "September",
	    "October",
	    "November",
	    "December"
	  ],
	  // Property "wide_context" is optional, if not set then "wide" will be used instead
	  // It is used to specify a word in context, which may differ from a stand-alone word
	  wide_context: [
	    "January",
	    "February",
	    "March",
	    "April",
	    "May",
	    "June",
	    "July",
	    "August",
	    "September",
	    "October",
	    "November",
	    "December"
	  ],
	  abbr: [
	    "Jan",
	    "Feb",
	    "Mar",
	    "Apr",
	    "May",
	    "Jun",
	    "Jul",
	    "Aug",
	    "Sep",
	    "Oct",
	    "Nov",
	    "Dec"
	  ],
	  // Property "abbr_context" is optional, if not set then "abbr" will be used instead
	  // It is used to specify a word in context, which may differ from a stand-alone word
	  abbr_context: [
	    "Jan",
	    "Feb",
	    "Mar",
	    "Apr",
	    "May",
	    "Jun",
	    "Jul",
	    "Aug",
	    "Sep",
	    "Oct",
	    "Nov",
	    "Dec"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// Source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/en.xml#L1847
	module["exports"] = {
	  wide: [
	    "Sunday",
	    "Monday",
	    "Tuesday",
	    "Wednesday",
	    "Thursday",
	    "Friday",
	    "Saturday"
	  ],
	  // Property "wide_context" is optional, if not set then "wide" will be used instead
	  // It is used to specify a word in context, which may differ from a stand-alone word
	  wide_context: [
	    "Sunday",
	    "Monday",
	    "Tuesday",
	    "Wednesday",
	    "Thursday",
	    "Friday",
	    "Saturday"
	  ],
	  abbr: [
	    "Sun",
	    "Mon",
	    "Tue",
	    "Wed",
	    "Thu",
	    "Fri",
	    "Sat"
	  ],
	  // Property "abbr_context" is optional, if not set then "abbr" will be used instead
	  // It is used to specify a word in context, which may differ from a stand-alone word
	  abbr_context: [
	    "Sun",
	    "Mon",
	    "Tue",
	    "Wed",
	    "Thu",
	    "Fri",
	    "Sat"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Checking",
	  "Savings",
	  "Money Market",
	  "Investment",
	  "Home Loan",
	  "Credit Card",
	  "Auto Loan",
	  "Personal Loan"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "UAE Dirham": {
	    "code": "AED",
	    "symbol": ""
	  },
	  "Afghani": {
	    "code": "AFN",
	    "symbol": "؋"
	  },
	  "Lek": {
	    "code": "ALL",
	    "symbol": "Lek"
	  },
	  "Armenian Dram": {
	    "code": "AMD",
	    "symbol": ""
	  },
	  "Netherlands Antillian Guilder": {
	    "code": "ANG",
	    "symbol": "ƒ"
	  },
	  "Kwanza": {
	    "code": "AOA",
	    "symbol": ""
	  },
	  "Argentine Peso": {
	    "code": "ARS",
	    "symbol": "$"
	  },
	  "Australian Dollar": {
	    "code": "AUD",
	    "symbol": "$"
	  },
	  "Aruban Guilder": {
	    "code": "AWG",
	    "symbol": "ƒ"
	  },
	  "Azerbaijanian Manat": {
	    "code": "AZN",
	    "symbol": "ман"
	  },
	  "Convertible Marks": {
	    "code": "BAM",
	    "symbol": "KM"
	  },
	  "Barbados Dollar": {
	    "code": "BBD",
	    "symbol": "$"
	  },
	  "Taka": {
	    "code": "BDT",
	    "symbol": ""
	  },
	  "Bulgarian Lev": {
	    "code": "BGN",
	    "symbol": "лв"
	  },
	  "Bahraini Dinar": {
	    "code": "BHD",
	    "symbol": ""
	  },
	  "Burundi Franc": {
	    "code": "BIF",
	    "symbol": ""
	  },
	  "Bermudian Dollar (customarily known as Bermuda Dollar)": {
	    "code": "BMD",
	    "symbol": "$"
	  },
	  "Brunei Dollar": {
	    "code": "BND",
	    "symbol": "$"
	  },
	  "Boliviano Mvdol": {
	    "code": "BOB BOV",
	    "symbol": "$b"
	  },
	  "Brazilian Real": {
	    "code": "BRL",
	    "symbol": "R$"
	  },
	  "Bahamian Dollar": {
	    "code": "BSD",
	    "symbol": "$"
	  },
	  "Pula": {
	    "code": "BWP",
	    "symbol": "P"
	  },
	  "Belarussian Ruble": {
	    "code": "BYR",
	    "symbol": "p."
	  },
	  "Belize Dollar": {
	    "code": "BZD",
	    "symbol": "BZ$"
	  },
	  "Canadian Dollar": {
	    "code": "CAD",
	    "symbol": "$"
	  },
	  "Congolese Franc": {
	    "code": "CDF",
	    "symbol": ""
	  },
	  "Swiss Franc": {
	    "code": "CHF",
	    "symbol": "CHF"
	  },
	  "Chilean Peso Unidades de fomento": {
	    "code": "CLP CLF",
	    "symbol": "$"
	  },
	  "Yuan Renminbi": {
	    "code": "CNY",
	    "symbol": "¥"
	  },
	  "Colombian Peso Unidad de Valor Real": {
	    "code": "COP COU",
	    "symbol": "$"
	  },
	  "Costa Rican Colon": {
	    "code": "CRC",
	    "symbol": "₡"
	  },
	  "Cuban Peso Peso Convertible": {
	    "code": "CUP CUC",
	    "symbol": "₱"
	  },
	  "Cape Verde Escudo": {
	    "code": "CVE",
	    "symbol": ""
	  },
	  "Czech Koruna": {
	    "code": "CZK",
	    "symbol": "Kč"
	  },
	  "Djibouti Franc": {
	    "code": "DJF",
	    "symbol": ""
	  },
	  "Danish Krone": {
	    "code": "DKK",
	    "symbol": "kr"
	  },
	  "Dominican Peso": {
	    "code": "DOP",
	    "symbol": "RD$"
	  },
	  "Algerian Dinar": {
	    "code": "DZD",
	    "symbol": ""
	  },
	  "Kroon": {
	    "code": "EEK",
	    "symbol": ""
	  },
	  "Egyptian Pound": {
	    "code": "EGP",
	    "symbol": "£"
	  },
	  "Nakfa": {
	    "code": "ERN",
	    "symbol": ""
	  },
	  "Ethiopian Birr": {
	    "code": "ETB",
	    "symbol": ""
	  },
	  "Euro": {
	    "code": "EUR",
	    "symbol": "€"
	  },
	  "Fiji Dollar": {
	    "code": "FJD",
	    "symbol": "$"
	  },
	  "Falkland Islands Pound": {
	    "code": "FKP",
	    "symbol": "£"
	  },
	  "Pound Sterling": {
	    "code": "GBP",
	    "symbol": "£"
	  },
	  "Lari": {
	    "code": "GEL",
	    "symbol": ""
	  },
	  "Cedi": {
	    "code": "GHS",
	    "symbol": ""
	  },
	  "Gibraltar Pound": {
	    "code": "GIP",
	    "symbol": "£"
	  },
	  "Dalasi": {
	    "code": "GMD",
	    "symbol": ""
	  },
	  "Guinea Franc": {
	    "code": "GNF",
	    "symbol": ""
	  },
	  "Quetzal": {
	    "code": "GTQ",
	    "symbol": "Q"
	  },
	  "Guyana Dollar": {
	    "code": "GYD",
	    "symbol": "$"
	  },
	  "Hong Kong Dollar": {
	    "code": "HKD",
	    "symbol": "$"
	  },
	  "Lempira": {
	    "code": "HNL",
	    "symbol": "L"
	  },
	  "Croatian Kuna": {
	    "code": "HRK",
	    "symbol": "kn"
	  },
	  "Gourde US Dollar": {
	    "code": "HTG USD",
	    "symbol": ""
	  },
	  "Forint": {
	    "code": "HUF",
	    "symbol": "Ft"
	  },
	  "Rupiah": {
	    "code": "IDR",
	    "symbol": "Rp"
	  },
	  "New Israeli Sheqel": {
	    "code": "ILS",
	    "symbol": "₪"
	  },
	  "Indian Rupee": {
	    "code": "INR",
	    "symbol": ""
	  },
	  "Indian Rupee Ngultrum": {
	    "code": "INR BTN",
	    "symbol": ""
	  },
	  "Iraqi Dinar": {
	    "code": "IQD",
	    "symbol": ""
	  },
	  "Iranian Rial": {
	    "code": "IRR",
	    "symbol": "﷼"
	  },
	  "Iceland Krona": {
	    "code": "ISK",
	    "symbol": "kr"
	  },
	  "Jamaican Dollar": {
	    "code": "JMD",
	    "symbol": "J$"
	  },
	  "Jordanian Dinar": {
	    "code": "JOD",
	    "symbol": ""
	  },
	  "Yen": {
	    "code": "JPY",
	    "symbol": "¥"
	  },
	  "Kenyan Shilling": {
	    "code": "KES",
	    "symbol": ""
	  },
	  "Som": {
	    "code": "KGS",
	    "symbol": "лв"
	  },
	  "Riel": {
	    "code": "KHR",
	    "symbol": "៛"
	  },
	  "Comoro Franc": {
	    "code": "KMF",
	    "symbol": ""
	  },
	  "North Korean Won": {
	    "code": "KPW",
	    "symbol": "₩"
	  },
	  "Won": {
	    "code": "KRW",
	    "symbol": "₩"
	  },
	  "Kuwaiti Dinar": {
	    "code": "KWD",
	    "symbol": ""
	  },
	  "Cayman Islands Dollar": {
	    "code": "KYD",
	    "symbol": "$"
	  },
	  "Tenge": {
	    "code": "KZT",
	    "symbol": "лв"
	  },
	  "Kip": {
	    "code": "LAK",
	    "symbol": "₭"
	  },
	  "Lebanese Pound": {
	    "code": "LBP",
	    "symbol": "£"
	  },
	  "Sri Lanka Rupee": {
	    "code": "LKR",
	    "symbol": "₨"
	  },
	  "Liberian Dollar": {
	    "code": "LRD",
	    "symbol": "$"
	  },
	  "Lithuanian Litas": {
	    "code": "LTL",
	    "symbol": "Lt"
	  },
	  "Latvian Lats": {
	    "code": "LVL",
	    "symbol": "Ls"
	  },
	  "Libyan Dinar": {
	    "code": "LYD",
	    "symbol": ""
	  },
	  "Moroccan Dirham": {
	    "code": "MAD",
	    "symbol": ""
	  },
	  "Moldovan Leu": {
	    "code": "MDL",
	    "symbol": ""
	  },
	  "Malagasy Ariary": {
	    "code": "MGA",
	    "symbol": ""
	  },
	  "Denar": {
	    "code": "MKD",
	    "symbol": "ден"
	  },
	  "Kyat": {
	    "code": "MMK",
	    "symbol": ""
	  },
	  "Tugrik": {
	    "code": "MNT",
	    "symbol": "₮"
	  },
	  "Pataca": {
	    "code": "MOP",
	    "symbol": ""
	  },
	  "Ouguiya": {
	    "code": "MRO",
	    "symbol": ""
	  },
	  "Mauritius Rupee": {
	    "code": "MUR",
	    "symbol": "₨"
	  },
	  "Rufiyaa": {
	    "code": "MVR",
	    "symbol": ""
	  },
	  "Kwacha": {
	    "code": "MWK",
	    "symbol": ""
	  },
	  "Mexican Peso Mexican Unidad de Inversion (UDI)": {
	    "code": "MXN MXV",
	    "symbol": "$"
	  },
	  "Malaysian Ringgit": {
	    "code": "MYR",
	    "symbol": "RM"
	  },
	  "Metical": {
	    "code": "MZN",
	    "symbol": "MT"
	  },
	  "Naira": {
	    "code": "NGN",
	    "symbol": "₦"
	  },
	  "Cordoba Oro": {
	    "code": "NIO",
	    "symbol": "C$"
	  },
	  "Norwegian Krone": {
	    "code": "NOK",
	    "symbol": "kr"
	  },
	  "Nepalese Rupee": {
	    "code": "NPR",
	    "symbol": "₨"
	  },
	  "New Zealand Dollar": {
	    "code": "NZD",
	    "symbol": "$"
	  },
	  "Rial Omani": {
	    "code": "OMR",
	    "symbol": "﷼"
	  },
	  "Balboa US Dollar": {
	    "code": "PAB USD",
	    "symbol": "B/."
	  },
	  "Nuevo Sol": {
	    "code": "PEN",
	    "symbol": "S/."
	  },
	  "Kina": {
	    "code": "PGK",
	    "symbol": ""
	  },
	  "Philippine Peso": {
	    "code": "PHP",
	    "symbol": "Php"
	  },
	  "Pakistan Rupee": {
	    "code": "PKR",
	    "symbol": "₨"
	  },
	  "Zloty": {
	    "code": "PLN",
	    "symbol": "zł"
	  },
	  "Guarani": {
	    "code": "PYG",
	    "symbol": "Gs"
	  },
	  "Qatari Rial": {
	    "code": "QAR",
	    "symbol": "﷼"
	  },
	  "New Leu": {
	    "code": "RON",
	    "symbol": "lei"
	  },
	  "Serbian Dinar": {
	    "code": "RSD",
	    "symbol": "Дин."
	  },
	  "Russian Ruble": {
	    "code": "RUB",
	    "symbol": "руб"
	  },
	  "Rwanda Franc": {
	    "code": "RWF",
	    "symbol": ""
	  },
	  "Saudi Riyal": {
	    "code": "SAR",
	    "symbol": "﷼"
	  },
	  "Solomon Islands Dollar": {
	    "code": "SBD",
	    "symbol": "$"
	  },
	  "Seychelles Rupee": {
	    "code": "SCR",
	    "symbol": "₨"
	  },
	  "Sudanese Pound": {
	    "code": "SDG",
	    "symbol": ""
	  },
	  "Swedish Krona": {
	    "code": "SEK",
	    "symbol": "kr"
	  },
	  "Singapore Dollar": {
	    "code": "SGD",
	    "symbol": "$"
	  },
	  "Saint Helena Pound": {
	    "code": "SHP",
	    "symbol": "£"
	  },
	  "Leone": {
	    "code": "SLL",
	    "symbol": ""
	  },
	  "Somali Shilling": {
	    "code": "SOS",
	    "symbol": "S"
	  },
	  "Surinam Dollar": {
	    "code": "SRD",
	    "symbol": "$"
	  },
	  "Dobra": {
	    "code": "STD",
	    "symbol": ""
	  },
	  "El Salvador Colon US Dollar": {
	    "code": "SVC USD",
	    "symbol": "$"
	  },
	  "Syrian Pound": {
	    "code": "SYP",
	    "symbol": "£"
	  },
	  "Lilangeni": {
	    "code": "SZL",
	    "symbol": ""
	  },
	  "Baht": {
	    "code": "THB",
	    "symbol": "฿"
	  },
	  "Somoni": {
	    "code": "TJS",
	    "symbol": ""
	  },
	  "Manat": {
	    "code": "TMT",
	    "symbol": ""
	  },
	  "Tunisian Dinar": {
	    "code": "TND",
	    "symbol": ""
	  },
	  "Pa'anga": {
	    "code": "TOP",
	    "symbol": ""
	  },
	  "Turkish Lira": {
	    "code": "TRY",
	    "symbol": "TL"
	  },
	  "Trinidad and Tobago Dollar": {
	    "code": "TTD",
	    "symbol": "TT$"
	  },
	  "New Taiwan Dollar": {
	    "code": "TWD",
	    "symbol": "NT$"
	  },
	  "Tanzanian Shilling": {
	    "code": "TZS",
	    "symbol": ""
	  },
	  "Hryvnia": {
	    "code": "UAH",
	    "symbol": "₴"
	  },
	  "Uganda Shilling": {
	    "code": "UGX",
	    "symbol": ""
	  },
	  "US Dollar": {
	    "code": "USD",
	    "symbol": "$"
	  },
	  "Peso Uruguayo Uruguay Peso en Unidades Indexadas": {
	    "code": "UYU UYI",
	    "symbol": "$U"
	  },
	  "Uzbekistan Sum": {
	    "code": "UZS",
	    "symbol": "лв"
	  },
	  "Bolivar Fuerte": {
	    "code": "VEF",
	    "symbol": "Bs"
	  },
	  "Dong": {
	    "code": "VND",
	    "symbol": "₫"
	  },
	  "Vatu": {
	    "code": "VUV",
	    "symbol": ""
	  },
	  "Tala": {
	    "code": "WST",
	    "symbol": ""
	  },
	  "CFA Franc BEAC": {
	    "code": "XAF",
	    "symbol": ""
	  },
	  "Silver": {
	    "code": "XAG",
	    "symbol": ""
	  },
	  "Gold": {
	    "code": "XAU",
	    "symbol": ""
	  },
	  "Bond Markets Units European Composite Unit (EURCO)": {
	    "code": "XBA",
	    "symbol": ""
	  },
	  "European Monetary Unit (E.M.U.-6)": {
	    "code": "XBB",
	    "symbol": ""
	  },
	  "European Unit of Account 9(E.U.A.-9)": {
	    "code": "XBC",
	    "symbol": ""
	  },
	  "European Unit of Account 17(E.U.A.-17)": {
	    "code": "XBD",
	    "symbol": ""
	  },
	  "East Caribbean Dollar": {
	    "code": "XCD",
	    "symbol": "$"
	  },
	  "SDR": {
	    "code": "XDR",
	    "symbol": ""
	  },
	  "UIC-Franc": {
	    "code": "XFU",
	    "symbol": ""
	  },
	  "CFA Franc BCEAO": {
	    "code": "XOF",
	    "symbol": ""
	  },
	  "Palladium": {
	    "code": "XPD",
	    "symbol": ""
	  },
	  "CFP Franc": {
	    "code": "XPF",
	    "symbol": ""
	  },
	  "Platinum": {
	    "code": "XPT",
	    "symbol": ""
	  },
	  "Codes specifically reserved for testing purposes": {
	    "code": "XTS",
	    "symbol": ""
	  },
	  "Yemeni Rial": {
	    "code": "YER",
	    "symbol": "﷼"
	  },
	  "Rand": {
	    "code": "ZAR",
	    "symbol": "R"
	  },
	  "Rand Loti": {
	    "code": "ZAR LSL",
	    "symbol": ""
	  },
	  "Rand Namibia Dollar": {
	    "code": "ZAR NAD",
	    "symbol": ""
	  },
	  "Zambian Kwacha": {
	    "code": "ZMK",
	    "symbol": ""
	  },
	  "Zimbabwe Dollar": {
	    "code": "ZWL",
	    "symbol": ""
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var finance = {};
	module['exports'] = finance;
	finance.account_type = __webpack_require__(505);
	finance.transaction_type = __webpack_require__(508);
	finance.currency = __webpack_require__(506);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "deposit",
	  "withdrawal",
	  "payment",
	  "invoice"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "TCP",
	  "HTTP",
	  "SDD",
	  "RAM",
	  "GB",
	  "CSS",
	  "SSL",
	  "AGP",
	  "SQL",
	  "FTP",
	  "PCI",
	  "AI",
	  "ADP",
	  "RSS",
	  "XML",
	  "EXE",
	  "COM",
	  "HDD",
	  "THX",
	  "SMTP",
	  "SMS",
	  "USB",
	  "PNG",
	  "SAS",
	  "IB",
	  "SCSI",
	  "JSON",
	  "XSS",
	  "JBOD"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "auxiliary",
	  "primary",
	  "back-end",
	  "digital",
	  "open-source",
	  "virtual",
	  "cross-platform",
	  "redundant",
	  "online",
	  "haptic",
	  "multi-byte",
	  "bluetooth",
	  "wireless",
	  "1080p",
	  "neural",
	  "optical",
	  "solid state",
	  "mobile"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var hacker = {};
	module['exports'] = hacker;
	hacker.abbreviation = __webpack_require__(509);
	hacker.adjective = __webpack_require__(510);
	hacker.noun = __webpack_require__(513);
	hacker.verb = __webpack_require__(514);
	hacker.ingverb = __webpack_require__(512);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "backing up",
	  "bypassing",
	  "hacking",
	  "overriding",
	  "compressing",
	  "copying",
	  "navigating",
	  "indexing",
	  "connecting",
	  "generating",
	  "quantifying",
	  "calculating",
	  "synthesizing",
	  "transmitting",
	  "programming",
	  "parsing"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "driver",
	  "protocol",
	  "bandwidth",
	  "panel",
	  "microchip",
	  "program",
	  "port",
	  "card",
	  "array",
	  "interface",
	  "system",
	  "sensor",
	  "firewall",
	  "hard drive",
	  "pixel",
	  "alarm",
	  "feed",
	  "monitor",
	  "application",
	  "transmitter",
	  "bus",
	  "circuit",
	  "capacitor",
	  "matrix"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "back up",
	  "bypass",
	  "hack",
	  "override",
	  "compress",
	  "copy",
	  "navigate",
	  "index",
	  "connect",
	  "generate",
	  "quantify",
	  "calculate",
	  "synthesize",
	  "input",
	  "transmit",
	  "program",
	  "reboot",
	  "parse"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en = {};
	module['exports'] = en;
	en.title = "English";
	en.separator = " & ";
	en.address = __webpack_require__(458);
	en.credit_card = __webpack_require__(494);
	en.company = __webpack_require__(487);
	en.internet = __webpack_require__(520);
	en.lorem = __webpack_require__(521);
	en.name = __webpack_require__(525);
	en.phone_number = __webpack_require__(532);
	en.cell_phone = __webpack_require__(477);
	en.business = __webpack_require__(475);
	en.commerce = __webpack_require__(480);
	en.team = __webpack_require__(536);
	en.hacker = __webpack_require__(511);
	en.app = __webpack_require__(469);
	en.finance = __webpack_require__(507);
	en.date = __webpack_require__(502);
	en.system = __webpack_require__(533);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jarjan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mahdif/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sprayaga/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ruzinav/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Skyhartman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/moscoz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kurafire/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/91bilal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/igorgarybaldi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/calebogden/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/malykhinv/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joelhelin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kushsolitary/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/coreyweb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/snowshade/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/areus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/holdenweb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/heyimjuani/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/envex/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/unterdreht/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/collegeman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/peejfancher/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andyisonline/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ultragex/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fuck_you_two/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adellecharles/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ateneupopular/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ahmetalpbalkan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Stievius/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kerem/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/osvaldas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/angelceballos/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thierrykoblentz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/peterlandt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/catarino/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/weglov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brandclay/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/flame_kaizar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ahmetsulek/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nicolasfolliot/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jayrobinson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/victorerixon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kolage/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michzen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/markjenkins/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nicolai_larsen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/noxdzine/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alagoon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/idiot/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mizko/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chadengle/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mutlu82/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/simobenso/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vocino/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/guiiipontes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/soyjavi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joshaustin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tomaslau/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/VinThomas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ManikRathee/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/langate/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cemshid/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/leemunroe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_shahedk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/enda/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/BillSKenney/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/divya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joshhemsley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sindresorhus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/soffes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/9lessons/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/linux29/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Chakintosh/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/anaami/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joreira/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shadeed9/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scottkclark/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jedbridges/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/salleedesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marakasina/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ariil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/BrianPurkiss/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michaelmartinho/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bublienko/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/devankoshal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ZacharyZorbas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/timmillwood/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joshuasortino/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/damenleeturks/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tomas_janousek/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/herrhaase/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/RussellBishop/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brajeshwar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nachtmeister/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cbracco/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bermonpainter/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/abdullindenis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/isacosta/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/suprb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yalozhkin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chandlervdw/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iamgarth/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_victa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/commadelimited/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/roybarberuk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/axel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vladarbatov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ffbel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/syropian/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ankitind/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/traneblow/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/flashmurphy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ChrisFarina78/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/baliomega/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/saschamt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jm_denis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/anoff/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kennyadr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chatyrko/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dingyi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mds/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/terryxlife/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aaroni/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kinday/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/prrstn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/eduardostuart/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dhilipsiva/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/GavicoInd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/baires/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rohixx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bigmancho/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/blakesimkins/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/leeiio/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tjrus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/uberschizo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kylefoundry/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/claudioguglieri/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ripplemdk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/exentrich/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jakemoore/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joaoedumedeiros/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/poormini/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tereshenkov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/keryilmaz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/haydn_woods/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rude/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/llun/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sgaurav_baghel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jamiebrittain/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/badlittleduck/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pifagor/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/agromov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/benefritz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/erwanhesry/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/diesellaws/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeremiaha/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/koridhandy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chaensel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andrewcohen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/smaczny/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gonzalorobaina/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nandini_m/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sydlawrence/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cdharrison/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tgerken/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lewisainslie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/charliecwaite/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/robbschiller/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/flexrs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mattdetails/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/raquelwilson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/karsh/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mrmartineau/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/opnsrce/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hgharrygo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/maximseshuk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/uxalex/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/samihah/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chanpory/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sharvin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/josemarques/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jefffis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/krystalfister/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lokesh_coder/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thedamianhdez/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dpmachado/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/funwatercat/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/timothycd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ivanfilipovbg/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/picard102/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marcobarbosa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/krasnoukhov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/g3d/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ademilter/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rickdt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/operatino/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bungiwan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hugomano/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/logorado/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dc_user/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/horaciobella/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/SlaapMe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/teeragit/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iqonicd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ilya_pestov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andrewarrow/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ssiskind/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/HenryHoffman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rdsaunders/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adamsxu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/curiousoffice/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/themadray/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michigangraham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kohette/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nickfratter/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/runningskull/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/madysondesigns/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brenton_clarke/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jennyshen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bradenhamm/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kurtinc/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/amanruzaini/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/coreyhaggard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Karimmove/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aaronalfred/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wtrsld/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jitachi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/therealmarvin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pmeissner/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ooomz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chacky14/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jesseddy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thinmatt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shanehudson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/akmur/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/IsaryAmairani/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/arthurholcombe1/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andychipster/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/boxmodel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ehsandiary/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/LucasPerdidao/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shalt0ni/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/swaplord/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kaelifa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/plbabin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/guillemboti/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/arindam_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/renbyrd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thiagovernetti/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jmillspaysbills/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mikemai2awesome/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jervo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mekal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sta1ex/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/robergd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/felipecsl/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andrea211087/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/garand/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dhooyenga/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/abovefunction/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pcridesagain/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/randomlies/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/BryanHorsey/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/heykenneth/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dahparra/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/allthingssmitty/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danvernon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/beweinreich/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/increase/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/falvarad/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alxndrustinov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/souuf/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/orkuncaylar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/AM_Kn2/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gearpixels/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bassamology/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vimarethomas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kosmar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/SULiik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mrjamesnoble/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/silvanmuhlemann/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shaneIxD/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nacho/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yigitpinarbasi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/buzzusborne/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aaronkwhite/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rmlewisuk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/giancarlon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nbirckel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/d_nny_m_cher/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sdidonato/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/atariboy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/abotap/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/karalek/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/psdesignuk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ludwiczakpawel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nemanjaivanovic/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/baluli/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ahmadajmi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vovkasolovev/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/samgrover/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/derienzo777/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jonathansimmons/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nelsonjoyce/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/S0ufi4n3/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xtopherpaul/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/oaktreemedia/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nateschulte/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/findingjenny/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/namankreative/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/antonyzotov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/we_social/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/leehambley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/solid_color/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/abelcabans/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mbilderbach/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kkusaa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jordyvdboom/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carlosgavina/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pechkinator/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vc27/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rdbannon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/croakx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/suribbles/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kerihenare/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/catadeleon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gcmorley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/duivvv/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/saschadroste/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/victorDubugras/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wintopia/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mattbilotti/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/taylorling/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/megdraws/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/meln1ks/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mahmoudmetwally/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Silveredge9/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/derekebradley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/happypeter1983/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/travis_arnold/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/artem_kostenko/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adobi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/daykiine/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alek_djuric/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scips/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/miguelmendes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/justinrhee/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alsobrooks/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fronx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mcflydesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/santi_urso/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/allfordesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stayuber/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bertboerland/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marosholly/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adamnac/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cynthiasavard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/muringa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danro/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hiemil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jackiesaik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/zacsnider/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iduuck/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/antjanus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aroon_sharma/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dshster/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thehacker/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michaelbrooksjr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ryanmclaughlin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/clubb3rry/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/taybenlor/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xripunov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/myastro/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adityasutomo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/digitalmaverick/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hjartstrorn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/itolmach/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vaughanmoffitt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/abdots/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/isnifer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sergeysafonov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/maz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scrapdnb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chrismj83/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vitorleal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sokaniwaal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/zaki3d/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/illyzoren/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mocabyte/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/osmanince/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/djsherman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/davidhemphill/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/waghner/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/necodymiconer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/praveen_vijaya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fabbrucci/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cliffseal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/travishines/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kuldarkalvik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Elt_n/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/phillapier/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/okseanjay/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/id835559/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kudretkeskin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/anjhero/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/duck4fuck/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scott_riley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/noufalibrahim/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/h1brd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/borges_marcos/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/devinhalladay/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ciaranr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stefooo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mikebeecham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tonymillion/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joshuaraichur/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/irae/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/petrangr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dmitriychuta/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/charliegann/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/arashmanteghi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adhamdannaway/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ainsleywagon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/svenlen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/faisalabid/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/beshur/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carlyson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dutchnadia/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/teddyzetterlund/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/samuelkraft/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aoimedia/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/toddrew/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/codepoet_ru/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/artvavs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/benoitboucart/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jomarmen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kolmarlopez/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/creartinc/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/homka/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gaborenton/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/robinclediere/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/maximsorokin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/plasticine/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/j2deme/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/peachananr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kapaluccio/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/de_ascanio/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rikas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dawidwu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marcoramires/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/angelcreative/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rpatey/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/popey/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rehatkathuria/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/the_purplebunny/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/1markiz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ajaxy_ru/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brenmurrell/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dudestein/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/oskarlevinson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/victorstuber/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nehfy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vicivadeline/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/leandrovaranda/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scottgallant/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/victor_haydin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sawrb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ryhanhassan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/amayvs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/a_brixen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/karolkrakowiak_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/herkulano/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/geran7/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cggaurav/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chris_witko/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lososina/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/polarity/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mattlat/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brandonburke/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/constantx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/teylorfeliz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/craigelimeliah/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rachelreveley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/reabo101/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rahmeen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ky/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rickyyean/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/j04ntoh/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/spbroma/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sebashton/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jpenico/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/francis_vega/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/oktayelipek/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kikillo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fabbianz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/larrygerard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/BroumiYoussef/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/0therplanet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mbilalsiddique1/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ionuss/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/grrr_nl/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/liminha/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rawdiggie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ryandownie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sethlouey/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pixage/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/arpitnj/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/switmer777/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/josevnclch/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kanickairaj/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/puzik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tbakdesigns/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/besbujupi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/supjoey/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lowie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/linkibol/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/balintorosz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/imcoding/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/agustincruiz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gusoto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thomasschrijer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/superoutman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kalmerrautam/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gabrielizalo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gojeanyn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/davidbaldie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_vojto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/laurengray/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jydesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mymyboy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nellleo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marciotoledo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ninjad3m0/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/to_soham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hasslunsford/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/muridrahhal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/levisan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/grahamkennery/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lepetitogre/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/antongenkin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nessoila/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/amandabuzard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/safrankov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cocolero/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dss49/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/matt3224/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bluesix/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/quailandquasar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/AlbertoCococi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lepinski/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sementiy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mhudobivnik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thibaut_re/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/olgary/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shojberg/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mtolokonnikov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bereto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/naupintos/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wegotvices/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xadhix/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/macxim/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rodnylobos/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/madcampos/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/madebyvadim/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bartoszdawydzik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/supervova/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/markretzloff/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vonachoo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/darylws/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stevedesigner/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mylesb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/herbigt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/depaulawagner/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/geshan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gizmeedevil1991/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_scottburgess/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lisovsky/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/davidsasda/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/artd_sign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/YoungCutlass/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mgonto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/itstotallyamy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/victorquinn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/osmond/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/oksanafrewer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/zauerkraut/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iamkeithmason/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nitinhayaran/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lmjabreu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mandalareopens/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thinkleft/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ponchomendivil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/juamperro/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brunodesign1206/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/caseycavanagh/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/luxe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dotgridline/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/spedwig/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/madewulf/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mattsapii/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/helderleal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chrisstumph/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jayphen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nsamoylov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chrisvanderkooi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/justme_timothyg/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/otozk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/prinzadi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gu5taf/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cyril_gaillard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/d_kobelyatsky/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/daniloc/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nwdsha/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/romanbulah/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/skkirilov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dvdwinden/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dannol/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thekevinjones/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jwalter14/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/timgthomas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/buddhasource/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/uxpiper/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thatonetommy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/diansigitp/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adrienths/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/klimmka/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gkaam/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/derekcramer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jennyyo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nerrsoft/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xalionmalik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/edhenderson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/keyuri85/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/roxanejammet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kimcool/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/edkf/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/matkins/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alessandroribe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jacksonlatka/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lebronjennan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kostaspt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/karlkanall/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/moynihan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danpliego/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/saulihirvi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wesleytrankin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fjaguero/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bowbrick/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mashaaaaal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yassiryahya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dparrelli/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fotomagin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aka_james/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/denisepires/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iqbalperkasa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/martinansty/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jarsen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/r_oy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/justinrob/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gabrielrosser/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/malgordon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carlfairclough/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michaelabehsera/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pierrestoffe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/enjoythetau/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/loganjlambert/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rpeezy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/coreyginnivan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michalhron/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/msveet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lingeswaran/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kolsvein/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/peter576/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/reideiredale/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joeymurdah/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/raphaelnikson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mvdheuvel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/maxlinderman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jimmuirhead/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/begreative/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/frankiefreesbie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/robturlinckx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Talbi_ConSept/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/longlivemyword/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vanchesz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/maiklam/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hermanobrother/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rez___a/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gregsqueeb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/greenbes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_ragzor/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/anthonysukow/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fluidbrush/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dactrtr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jehnglynn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bergmartin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hugocornejo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_kkga/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dzantievm/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sawalazar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sovesove/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jonsgotwood/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/byryan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vytautas_a/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mizhgan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cicerobr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nilshelmersson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/d33pthought/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/davecraige/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nckjrvs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alexandermayes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jcubic/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/craigrcoles/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bagawarman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rob_thomas10/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cofla/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/maikelk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rtgibbons/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/russell_baylis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mhesslow/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/codysanfilippo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/webtanya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/madebybrenton/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dcalonaci/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/perfectflow/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jjsiii/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/saarabpreet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kumarrajan12123/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iamsteffen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/themikenagle/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ceekaytweet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/larrybolt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/conspirator/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dallasbpeters/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/n3dmax/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/terpimost/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kirillz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/byrnecore/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/j_drake_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/calebjoyce/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/russoedu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hoangloi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tobysaxon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gofrasdesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dimaposnyy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tjisousa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/okandungel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/billyroshan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/oskamaya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/motionthinks/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/knilob/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ashocka18/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marrimo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bartjo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/omnizya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ernestsemerda/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andreas_pr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/edgarchris99/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thomasgeisen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gseguin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joannefournier/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/demersdesigns/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adammarsbar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nasirwd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/n_tassone/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/javorszky/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/themrdave/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yecidsm/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nicollerich/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/canapud/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nicoleglynn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/judzhin_miles/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/designervzm/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kianoshp/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/evandrix/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alterchuca/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dhrubo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ma_tiax/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ssbb_me/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dorphern/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mauriolg/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bruno_mart/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mactopus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/the_winslet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joemdesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Shriiiiimp/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jacobbennett/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nfedoroff/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iamglimy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/allagringaus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aiiaiiaii/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/olaolusoga/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/buryaknick/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wim1k/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nicklacke/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/a1chapone/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/steynviljoen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/strikewan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ryankirkman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andrewabogado/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/doooon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jagan123/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ariffsetiawan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/elenadissi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mwarkentin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thierrymeier_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/r_garcia/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dmackerman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/borantula/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/konus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/spacewood_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ryuchi311/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/evanshajed/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tristanlegros/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shoaib253/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aislinnkelly/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/okcoker/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/timpetricola/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sunshinedgirl/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chadami/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aleclarsoniv/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nomidesigns/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/petebernardo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scottiedude/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/millinet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/imsoper/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/imammuht/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/benjamin_knight/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nepdud/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joki4/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lanceguyatt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bboy1895/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/amywebbb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rweve/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/haruintesettden/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ricburton/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nelshd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/batsirai/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/primozcigler/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jffgrdnr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/8d3k/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/geneseleznev/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/al_li/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/souperphly/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mslarkina/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/2fockus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cdavis565/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xiel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/turkutuuli/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/uxward/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lebinoclard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gauravjassal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/davidmerrique/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mdsisto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andrewofficer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kojourin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dnirmal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kevka/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mr_shiznit/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aluisio_azevedo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cloudstudio/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danvierich/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alexivanichkin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fran_mchamy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/perretmagali/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/betraydan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cadikkara/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/matbeedotcom/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeremyworboys/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bpartridge/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michaelkoper/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/silv3rgvn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alevizio/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/johnsmithagency/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lawlbwoy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vitor376/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/desastrozo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thimo_cz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jasonmarkjones/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lhausermann/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xravil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/guischmitt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vigobronx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/panghal0/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/miguelkooreman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/surgeonist/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/christianoliff/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/caspergrl/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iamkarna/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ipavelek/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pierre_nel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/y2graphic/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sterlingrules/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/elbuscainfo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bennyjien/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stushona/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/estebanuribe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/embrcecreations/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danillos/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/elliotlewis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/charlesrpratt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vladyn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/emmeffess/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carlosblanco_eu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/leonfedotov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rangafangs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chris_frees/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tgormtx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bryan_topham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jpscribbles/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mighty55/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carbontwelve/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/isaacfifth/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iamjdeleon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/snowwrite/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/barputro/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/drewbyreese/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sachacorazzi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bistrianiosip/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/magoo04/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pehamondello/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yayteejay/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/a_harris88/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/algunsanabria/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/zforrester/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ovall/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carlosjgsousa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/geobikas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ah_lice/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/looneydoodle/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nerdgr8/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ddggccaa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/zackeeler/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/normanbox/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/el_fuertisimo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ismail_biltagi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/juangomezw/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jnmnrd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/patrickcoombe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ryanjohnson_me/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/markolschesky/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeffgolenski/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kvasnic/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lindseyzilla/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gauchomatt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/afusinatto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kevinoh/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/okansurreel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adamawesomeface/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/emileboudeling/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/arishi_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/juanmamartinez/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wikiziner/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danthms/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mkginfo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/terrorpixel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/curiousonaut/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/prheemo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michaelcolenso/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/foczzi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/martip07/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thaodang17/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/johncafazza/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/robinlayfield/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/franciscoamk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/abdulhyeuk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marklamb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/edobene/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andresenfredrik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mikaeljorhult/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chrisslowik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vinciarts/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/meelford/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/elliotnolten/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yehudab/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vijaykarthik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bfrohs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/josep_martins/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/attacks/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sur4dye/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tumski/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/instalox/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mangosango/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/paulfarino/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kazaky999/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kiwiupover/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nvkznemo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tom_even/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ratbus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/woodsman001/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joshmedeski/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thewillbeard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/psaikali/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joe_black/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aleinadsays/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marcusgorillius/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hota_v/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jghyllebert/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shinze/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/janpalounek/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeremiespoken/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/her_ruu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dansowter/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/felipeapiress/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/magugzbrand2d/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/posterjob/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nathalie_fs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bobbytwoshoes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dreizle/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeremymouton/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/elisabethkjaer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/notbadart/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mohanrohith/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jlsolerdeltoro/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/itskawsar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/slowspock/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/zvchkelly/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wiljanslofstra/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/craighenneberry/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/trubeatto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/juaumlol/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/samscouto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/BenouarradeM/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gipsy_raf/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/netonet_il/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/arkokoley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/itsajimithing/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/smalonso/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/victordeanda/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_dwite_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/richardgarretts/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gregrwilkinson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/anatolinicolae/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lu4sh1i/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stefanotirloni/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ostirbu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/darcystonge/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/naitanamoreno/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michaelcomiskey/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adhiardana/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marcomano_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/davidcazalis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/falconerie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gregkilian/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bcrad/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bolzanmarco/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/low_res/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vlajki/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/petar_prog/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jonkspr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/akmalfikri/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mfacchinello/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/atanism/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/harry_sistalam/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/murrayswift/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bobwassermann/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gavr1l0/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/madshensel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mr_subtle/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/deviljho_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/salimianoff/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joetruesdell/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/twittypork/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/airskylar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dnezkumar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dgajjar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cherif_b/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/salvafc/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/louis_currie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/deeenright/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cybind/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/eyronn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vickyshits/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sweetdelisa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cboller1/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andresdjasso/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/melvindidit/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andysolomon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thaisselenator_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lvovenok/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/giuliusa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/belyaev_rs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/overcloacked/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kamal_chaneman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/incubo82/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hellofeverrrr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mhaligowski/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sunlandictwin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bu7921/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andytlaw/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeremery/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/finchjke/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/manigm/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/umurgdk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scottfeltham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ganserene/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mutu_krish/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jodytaggart/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ntfblog/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tanveerrao/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hfalucas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alxleroydeval/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kucingbelang4/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bargaorobalo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/colgruv/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stalewine/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kylefrost/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/baumannzone/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/angelcolberg/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sachingawas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jjshaw14/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ramanathan_pdy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/johndezember/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nilshoenson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brandonmorreale/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nutzumi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brandonflatsoda/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sergeyalmone/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/klefue/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kirangopal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/baumann_alex/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/matthewkay_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jay_wilburn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shesgared/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/apriendeau/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/johnriordan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wake_gs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aleksitappura/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/emsgulam/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xilantra/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/imomenui/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sircalebgrove/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/newbrushes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hsinyo23/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/m4rio/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/katiemdaly/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/s4f1/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ecommerceil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marlinjayakody/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/swooshycueb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sangdth/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/coderdiaz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bluefx_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vivekprvr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sasha_shestakov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/eugeneeweb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dgclegg/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/n1ght_coder/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dixchen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/blakehawksworth/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/trueblood_33/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hai_ninh_nguyen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marclgonzales/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yesmeck/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stephcoue/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/doronmalki/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ruehldesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/anasnakawa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kijanmaharjan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wearesavas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stefvdham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tweetubhai/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alecarpentier/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fiterik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/antonyryndya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/d00maz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/theonlyzeke/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/missaaamy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carlosm/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/manekenthe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/reetajayendra/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeremyshimko/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/justinrgraham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stefanozoffoli/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/overra/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mrebay007/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shvelo96/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pyronite/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thedjpetersen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rtyukmaev/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_williamguerra/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/albertaugustin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vikashpathak18/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kevinjohndayy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vj_demien/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/colirpixoil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/goddardlewis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/laasli/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jqiuss/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/heycamtaylor/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nastya_mane/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mastermindesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ccinojasso1/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nyancecom/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sandywoodruff/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bighanddesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sbtransparent/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aviddayentonbay/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/richwild/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kaysix_dizzy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tur8le/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/seyedhossein1/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/privetwagner/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/emmandenn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dev_essentials/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jmfsocial/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_yardenoon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mateaodviteza/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/weavermedia/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mufaddal_mw/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hafeeskhan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ashernatali/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sulaqo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/eddiechen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/josecarlospsh/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vm_f/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/enricocicconi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danmartin70/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gmourier/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/donjain/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mrxloka/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_pedropinho/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/eitarafa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/oscarowusu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ralph_lam/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/panchajanyag/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/woodydotmx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jerrybai1907/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marshallchen_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xamorep/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aio___/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chaabane_wail/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/txcx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/akashsharma39/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/falling_soul/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sainraja/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mugukamil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/johannesneu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/markwienands/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/karthipanraj/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/balakayuriy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alan_zhang_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/layerssss/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kaspernordkvist/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mirfanqureshi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hanna_smi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/VMilescu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aeon56/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/m_kalibry/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sreejithexp/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dicesales/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dhoot_amit/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/smenov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lonesomelemon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vladimirdevic/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joelcipriano/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/haligaliharun/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/buleswapnil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/serefka/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ifarafonow/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vikasvinfotech/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/urrutimeoli/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/areandacom/128.jpg"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "biz",
	  "info",
	  "name",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "example.org",
	  "example.com",
	  "example.net"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(519);
	internet.example_email = __webpack_require__(518);
	internet.domain_suffix = __webpack_require__(517);
	internet.avatar_uri = __webpack_require__(516);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(523);
	lorem.supplemental = __webpack_require__(522);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "abbas",
	  "abduco",
	  "abeo",
	  "abscido",
	  "absconditus",
	  "absens",
	  "absorbeo",
	  "absque",
	  "abstergo",
	  "absum",
	  "abundans",
	  "abutor",
	  "accedo",
	  "accendo",
	  "acceptus",
	  "accipio",
	  "accommodo",
	  "accusator",
	  "acer",
	  "acerbitas",
	  "acervus",
	  "acidus",
	  "acies",
	  "acquiro",
	  "acsi",
	  "adamo",
	  "adaugeo",
	  "addo",
	  "adduco",
	  "ademptio",
	  "adeo",
	  "adeptio",
	  "adfectus",
	  "adfero",
	  "adficio",
	  "adflicto",
	  "adhaero",
	  "adhuc",
	  "adicio",
	  "adimpleo",
	  "adinventitias",
	  "adipiscor",
	  "adiuvo",
	  "administratio",
	  "admiratio",
	  "admitto",
	  "admoneo",
	  "admoveo",
	  "adnuo",
	  "adopto",
	  "adsidue",
	  "adstringo",
	  "adsuesco",
	  "adsum",
	  "adulatio",
	  "adulescens",
	  "adultus",
	  "aduro",
	  "advenio",
	  "adversus",
	  "advoco",
	  "aedificium",
	  "aeger",
	  "aegre",
	  "aegrotatio",
	  "aegrus",
	  "aeneus",
	  "aequitas",
	  "aequus",
	  "aer",
	  "aestas",
	  "aestivus",
	  "aestus",
	  "aetas",
	  "aeternus",
	  "ager",
	  "aggero",
	  "aggredior",
	  "agnitio",
	  "agnosco",
	  "ago",
	  "ait",
	  "aiunt",
	  "alienus",
	  "alii",
	  "alioqui",
	  "aliqua",
	  "alius",
	  "allatus",
	  "alo",
	  "alter",
	  "altus",
	  "alveus",
	  "amaritudo",
	  "ambitus",
	  "ambulo",
	  "amicitia",
	  "amiculum",
	  "amissio",
	  "amita",
	  "amitto",
	  "amo",
	  "amor",
	  "amoveo",
	  "amplexus",
	  "amplitudo",
	  "amplus",
	  "ancilla",
	  "angelus",
	  "angulus",
	  "angustus",
	  "animadverto",
	  "animi",
	  "animus",
	  "annus",
	  "anser",
	  "ante",
	  "antea",
	  "antepono",
	  "antiquus",
	  "aperio",
	  "aperte",
	  "apostolus",
	  "apparatus",
	  "appello",
	  "appono",
	  "appositus",
	  "approbo",
	  "apto",
	  "aptus",
	  "apud",
	  "aqua",
	  "ara",
	  "aranea",
	  "arbitro",
	  "arbor",
	  "arbustum",
	  "arca",
	  "arceo",
	  "arcesso",
	  "arcus",
	  "argentum",
	  "argumentum",
	  "arguo",
	  "arma",
	  "armarium",
	  "armo",
	  "aro",
	  "ars",
	  "articulus",
	  "artificiose",
	  "arto",
	  "arx",
	  "ascisco",
	  "ascit",
	  "asper",
	  "aspicio",
	  "asporto",
	  "assentator",
	  "astrum",
	  "atavus",
	  "ater",
	  "atqui",
	  "atrocitas",
	  "atrox",
	  "attero",
	  "attollo",
	  "attonbitus",
	  "auctor",
	  "auctus",
	  "audacia",
	  "audax",
	  "audentia",
	  "audeo",
	  "audio",
	  "auditor",
	  "aufero",
	  "aureus",
	  "auris",
	  "aurum",
	  "aut",
	  "autem",
	  "autus",
	  "auxilium",
	  "avaritia",
	  "avarus",
	  "aveho",
	  "averto",
	  "avoco",
	  "baiulus",
	  "balbus",
	  "barba",
	  "bardus",
	  "basium",
	  "beatus",
	  "bellicus",
	  "bellum",
	  "bene",
	  "beneficium",
	  "benevolentia",
	  "benigne",
	  "bestia",
	  "bibo",
	  "bis",
	  "blandior",
	  "bonus",
	  "bos",
	  "brevis",
	  "cado",
	  "caecus",
	  "caelestis",
	  "caelum",
	  "calamitas",
	  "calcar",
	  "calco",
	  "calculus",
	  "callide",
	  "campana",
	  "candidus",
	  "canis",
	  "canonicus",
	  "canto",
	  "capillus",
	  "capio",
	  "capitulus",
	  "capto",
	  "caput",
	  "carbo",
	  "carcer",
	  "careo",
	  "caries",
	  "cariosus",
	  "caritas",
	  "carmen",
	  "carpo",
	  "carus",
	  "casso",
	  "caste",
	  "casus",
	  "catena",
	  "caterva",
	  "cattus",
	  "cauda",
	  "causa",
	  "caute",
	  "caveo",
	  "cavus",
	  "cedo",
	  "celebrer",
	  "celer",
	  "celo",
	  "cena",
	  "cenaculum",
	  "ceno",
	  "censura",
	  "centum",
	  "cerno",
	  "cernuus",
	  "certe",
	  "certo",
	  "certus",
	  "cervus",
	  "cetera",
	  "charisma",
	  "chirographum",
	  "cibo",
	  "cibus",
	  "cicuta",
	  "cilicium",
	  "cimentarius",
	  "ciminatio",
	  "cinis",
	  "circumvenio",
	  "cito",
	  "civis",
	  "civitas",
	  "clam",
	  "clamo",
	  "claro",
	  "clarus",
	  "claudeo",
	  "claustrum",
	  "clementia",
	  "clibanus",
	  "coadunatio",
	  "coaegresco",
	  "coepi",
	  "coerceo",
	  "cogito",
	  "cognatus",
	  "cognomen",
	  "cogo",
	  "cohaero",
	  "cohibeo",
	  "cohors",
	  "colligo",
	  "colloco",
	  "collum",
	  "colo",
	  "color",
	  "coma",
	  "combibo",
	  "comburo",
	  "comedo",
	  "comes",
	  "cometes",
	  "comis",
	  "comitatus",
	  "commemoro",
	  "comminor",
	  "commodo",
	  "communis",
	  "comparo",
	  "compello",
	  "complectus",
	  "compono",
	  "comprehendo",
	  "comptus",
	  "conatus",
	  "concedo",
	  "concido",
	  "conculco",
	  "condico",
	  "conduco",
	  "confero",
	  "confido",
	  "conforto",
	  "confugo",
	  "congregatio",
	  "conicio",
	  "coniecto",
	  "conitor",
	  "coniuratio",
	  "conor",
	  "conqueror",
	  "conscendo",
	  "conservo",
	  "considero",
	  "conspergo",
	  "constans",
	  "consuasor",
	  "contabesco",
	  "contego",
	  "contigo",
	  "contra",
	  "conturbo",
	  "conventus",
	  "convoco",
	  "copia",
	  "copiose",
	  "cornu",
	  "corona",
	  "corpus",
	  "correptius",
	  "corrigo",
	  "corroboro",
	  "corrumpo",
	  "coruscus",
	  "cotidie",
	  "crapula",
	  "cras",
	  "crastinus",
	  "creator",
	  "creber",
	  "crebro",
	  "credo",
	  "creo",
	  "creptio",
	  "crepusculum",
	  "cresco",
	  "creta",
	  "cribro",
	  "crinis",
	  "cruciamentum",
	  "crudelis",
	  "cruentus",
	  "crur",
	  "crustulum",
	  "crux",
	  "cubicularis",
	  "cubitum",
	  "cubo",
	  "cui",
	  "cuius",
	  "culpa",
	  "culpo",
	  "cultellus",
	  "cultura",
	  "cum",
	  "cunabula",
	  "cunae",
	  "cunctatio",
	  "cupiditas",
	  "cupio",
	  "cuppedia",
	  "cupressus",
	  "cur",
	  "cura",
	  "curatio",
	  "curia",
	  "curiositas",
	  "curis",
	  "curo",
	  "curriculum",
	  "currus",
	  "cursim",
	  "curso",
	  "cursus",
	  "curto",
	  "curtus",
	  "curvo",
	  "curvus",
	  "custodia",
	  "damnatio",
	  "damno",
	  "dapifer",
	  "debeo",
	  "debilito",
	  "decens",
	  "decerno",
	  "decet",
	  "decimus",
	  "decipio",
	  "decor",
	  "decretum",
	  "decumbo",
	  "dedecor",
	  "dedico",
	  "deduco",
	  "defaeco",
	  "defendo",
	  "defero",
	  "defessus",
	  "defetiscor",
	  "deficio",
	  "defigo",
	  "defleo",
	  "defluo",
	  "defungo",
	  "degenero",
	  "degero",
	  "degusto",
	  "deinde",
	  "delectatio",
	  "delego",
	  "deleo",
	  "delibero",
	  "delicate",
	  "delinquo",
	  "deludo",
	  "demens",
	  "demergo",
	  "demitto",
	  "demo",
	  "demonstro",
	  "demoror",
	  "demulceo",
	  "demum",
	  "denego",
	  "denique",
	  "dens",
	  "denuncio",
	  "denuo",
	  "deorsum",
	  "depereo",
	  "depono",
	  "depopulo",
	  "deporto",
	  "depraedor",
	  "deprecator",
	  "deprimo",
	  "depromo",
	  "depulso",
	  "deputo",
	  "derelinquo",
	  "derideo",
	  "deripio",
	  "desidero",
	  "desino",
	  "desipio",
	  "desolo",
	  "desparatus",
	  "despecto",
	  "despirmatio",
	  "infit",
	  "inflammatio",
	  "paens",
	  "patior",
	  "patria",
	  "patrocinor",
	  "patruus",
	  "pauci",
	  "paulatim",
	  "pauper",
	  "pax",
	  "peccatus",
	  "pecco",
	  "pecto",
	  "pectus",
	  "pecunia",
	  "pecus",
	  "peior",
	  "pel",
	  "ocer",
	  "socius",
	  "sodalitas",
	  "sol",
	  "soleo",
	  "solio",
	  "solitudo",
	  "solium",
	  "sollers",
	  "sollicito",
	  "solum",
	  "solus",
	  "solutio",
	  "solvo",
	  "somniculosus",
	  "somnus",
	  "sonitus",
	  "sono",
	  "sophismata",
	  "sopor",
	  "sordeo",
	  "sortitus",
	  "spargo",
	  "speciosus",
	  "spectaculum",
	  "speculum",
	  "sperno",
	  "spero",
	  "spes",
	  "spiculum",
	  "spiritus",
	  "spoliatio",
	  "sponte",
	  "stabilis",
	  "statim",
	  "statua",
	  "stella",
	  "stillicidium",
	  "stipes",
	  "stips",
	  "sto",
	  "strenuus",
	  "strues",
	  "studio",
	  "stultus",
	  "suadeo",
	  "suasoria",
	  "sub",
	  "subito",
	  "subiungo",
	  "sublime",
	  "subnecto",
	  "subseco",
	  "substantia",
	  "subvenio",
	  "succedo",
	  "succurro",
	  "sufficio",
	  "suffoco",
	  "suffragium",
	  "suggero",
	  "sui",
	  "sulum",
	  "sum",
	  "summa",
	  "summisse",
	  "summopere",
	  "sumo",
	  "sumptus",
	  "supellex",
	  "super",
	  "suppellex",
	  "supplanto",
	  "suppono",
	  "supra",
	  "surculus",
	  "surgo",
	  "sursum",
	  "suscipio",
	  "suspendo",
	  "sustineo",
	  "suus",
	  "synagoga",
	  "tabella",
	  "tabernus",
	  "tabesco",
	  "tabgo",
	  "tabula",
	  "taceo",
	  "tactus",
	  "taedium",
	  "talio",
	  "talis",
	  "talus",
	  "tam",
	  "tamdiu",
	  "tamen",
	  "tametsi",
	  "tamisium",
	  "tamquam",
	  "tandem",
	  "tantillus",
	  "tantum",
	  "tardus",
	  "tego",
	  "temeritas",
	  "temperantia",
	  "templum",
	  "temptatio",
	  "tempus",
	  "tenax",
	  "tendo",
	  "teneo",
	  "tener",
	  "tenuis",
	  "tenus",
	  "tepesco",
	  "tepidus",
	  "ter",
	  "terebro",
	  "teres",
	  "terga",
	  "tergeo",
	  "tergiversatio",
	  "tergo",
	  "tergum",
	  "termes",
	  "terminatio",
	  "tero",
	  "terra",
	  "terreo",
	  "territo",
	  "terror",
	  "tersus",
	  "tertius",
	  "testimonium",
	  "texo",
	  "textilis",
	  "textor",
	  "textus",
	  "thalassinus",
	  "theatrum",
	  "theca",
	  "thema",
	  "theologus",
	  "thermae",
	  "thesaurus",
	  "thesis",
	  "thorax",
	  "thymbra",
	  "thymum",
	  "tibi",
	  "timidus",
	  "timor",
	  "titulus",
	  "tolero",
	  "tollo",
	  "tondeo",
	  "tonsor",
	  "torqueo",
	  "torrens",
	  "tot",
	  "totidem",
	  "toties",
	  "totus",
	  "tracto",
	  "trado",
	  "traho",
	  "trans",
	  "tredecim",
	  "tremo",
	  "trepide",
	  "tres",
	  "tribuo",
	  "tricesimus",
	  "triduana",
	  "triginta",
	  "tripudio",
	  "tristis",
	  "triumphus",
	  "trucido",
	  "truculenter",
	  "tubineus",
	  "tui",
	  "tum",
	  "tumultus",
	  "tunc",
	  "turba",
	  "turbo",
	  "turpe",
	  "turpis",
	  "tutamen",
	  "tutis",
	  "tyrannus",
	  "uberrime",
	  "ubi",
	  "ulciscor",
	  "ullus",
	  "ulterius",
	  "ultio",
	  "ultra",
	  "umbra",
	  "umerus",
	  "umquam",
	  "una",
	  "unde",
	  "undique",
	  "universe",
	  "unus",
	  "urbanus",
	  "urbs",
	  "uredo",
	  "usitas",
	  "usque",
	  "ustilo",
	  "ustulo",
	  "usus",
	  "uter",
	  "uterque",
	  "utilis",
	  "utique",
	  "utor",
	  "utpote",
	  "utrimque",
	  "utroque",
	  "utrum",
	  "uxor",
	  "vaco",
	  "vacuus",
	  "vado",
	  "vae",
	  "valde",
	  "valens",
	  "valeo",
	  "valetudo",
	  "validus",
	  "vallum",
	  "vapulus",
	  "varietas",
	  "varius",
	  "vehemens",
	  "vel",
	  "velociter",
	  "velum",
	  "velut",
	  "venia",
	  "venio",
	  "ventito",
	  "ventosus",
	  "ventus",
	  "venustas",
	  "ver",
	  "verbera",
	  "verbum",
	  "vere",
	  "verecundia",
	  "vereor",
	  "vergo",
	  "veritas",
	  "vero",
	  "versus",
	  "verto",
	  "verumtamen",
	  "verus",
	  "vesco",
	  "vesica",
	  "vesper",
	  "vespillo",
	  "vester",
	  "vestigium",
	  "vestrum",
	  "vetus",
	  "via",
	  "vicinus",
	  "vicissitudo",
	  "victoria",
	  "victus",
	  "videlicet",
	  "video",
	  "viduata",
	  "viduo",
	  "vigilo",
	  "vigor",
	  "vilicus",
	  "vilis",
	  "vilitas",
	  "villa",
	  "vinco",
	  "vinculum",
	  "vindico",
	  "vinitor",
	  "vinum",
	  "vir",
	  "virga",
	  "virgo",
	  "viridis",
	  "viriliter",
	  "virtus",
	  "vis",
	  "viscus",
	  "vita",
	  "vitiosus",
	  "vitium",
	  "vito",
	  "vivo",
	  "vix",
	  "vobis",
	  "vociferor",
	  "voco",
	  "volaticus",
	  "volo",
	  "volubilis",
	  "voluntarius",
	  "volup",
	  "volutabrum",
	  "volva",
	  "vomer",
	  "vomica",
	  "vomito",
	  "vorago",
	  "vorax",
	  "voro",
	  "vos",
	  "votum",
	  "voveo",
	  "vox",
	  "vulariter",
	  "vulgaris",
	  "vulgivagus",
	  "vulgo",
	  "vulgus",
	  "vulnero",
	  "vulnus",
	  "vulpes",
	  "vulticulus",
	  "vultuosus",
	  "xiphias"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aaliyah",
	  "Aaron",
	  "Abagail",
	  "Abbey",
	  "Abbie",
	  "Abbigail",
	  "Abby",
	  "Abdiel",
	  "Abdul",
	  "Abdullah",
	  "Abe",
	  "Abel",
	  "Abelardo",
	  "Abigail",
	  "Abigale",
	  "Abigayle",
	  "Abner",
	  "Abraham",
	  "Ada",
	  "Adah",
	  "Adalberto",
	  "Adaline",
	  "Adam",
	  "Adan",
	  "Addie",
	  "Addison",
	  "Adela",
	  "Adelbert",
	  "Adele",
	  "Adelia",
	  "Adeline",
	  "Adell",
	  "Adella",
	  "Adelle",
	  "Aditya",
	  "Adolf",
	  "Adolfo",
	  "Adolph",
	  "Adolphus",
	  "Adonis",
	  "Adrain",
	  "Adrian",
	  "Adriana",
	  "Adrianna",
	  "Adriel",
	  "Adrien",
	  "Adrienne",
	  "Afton",
	  "Aglae",
	  "Agnes",
	  "Agustin",
	  "Agustina",
	  "Ahmad",
	  "Ahmed",
	  "Aida",
	  "Aidan",
	  "Aiden",
	  "Aileen",
	  "Aimee",
	  "Aisha",
	  "Aiyana",
	  "Akeem",
	  "Al",
	  "Alaina",
	  "Alan",
	  "Alana",
	  "Alanis",
	  "Alanna",
	  "Alayna",
	  "Alba",
	  "Albert",
	  "Alberta",
	  "Albertha",
	  "Alberto",
	  "Albin",
	  "Albina",
	  "Alda",
	  "Alden",
	  "Alec",
	  "Aleen",
	  "Alejandra",
	  "Alejandrin",
	  "Alek",
	  "Alena",
	  "Alene",
	  "Alessandra",
	  "Alessandro",
	  "Alessia",
	  "Aletha",
	  "Alex",
	  "Alexa",
	  "Alexander",
	  "Alexandra",
	  "Alexandre",
	  "Alexandrea",
	  "Alexandria",
	  "Alexandrine",
	  "Alexandro",
	  "Alexane",
	  "Alexanne",
	  "Alexie",
	  "Alexis",
	  "Alexys",
	  "Alexzander",
	  "Alf",
	  "Alfonso",
	  "Alfonzo",
	  "Alford",
	  "Alfred",
	  "Alfreda",
	  "Alfredo",
	  "Ali",
	  "Alia",
	  "Alice",
	  "Alicia",
	  "Alisa",
	  "Alisha",
	  "Alison",
	  "Alivia",
	  "Aliya",
	  "Aliyah",
	  "Aliza",
	  "Alize",
	  "Allan",
	  "Allen",
	  "Allene",
	  "Allie",
	  "Allison",
	  "Ally",
	  "Alphonso",
	  "Alta",
	  "Althea",
	  "Alva",
	  "Alvah",
	  "Alvena",
	  "Alvera",
	  "Alverta",
	  "Alvina",
	  "Alvis",
	  "Alyce",
	  "Alycia",
	  "Alysa",
	  "Alysha",
	  "Alyson",
	  "Alysson",
	  "Amalia",
	  "Amanda",
	  "Amani",
	  "Amara",
	  "Amari",
	  "Amaya",
	  "Amber",
	  "Ambrose",
	  "Amelia",
	  "Amelie",
	  "Amely",
	  "America",
	  "Americo",
	  "Amie",
	  "Amina",
	  "Amir",
	  "Amira",
	  "Amiya",
	  "Amos",
	  "Amparo",
	  "Amy",
	  "Amya",
	  "Ana",
	  "Anabel",
	  "Anabelle",
	  "Anahi",
	  "Anais",
	  "Anastacio",
	  "Anastasia",
	  "Anderson",
	  "Andre",
	  "Andreane",
	  "Andreanne",
	  "Andres",
	  "Andrew",
	  "Andy",
	  "Angel",
	  "Angela",
	  "Angelica",
	  "Angelina",
	  "Angeline",
	  "Angelita",
	  "Angelo",
	  "Angie",
	  "Angus",
	  "Anibal",
	  "Anika",
	  "Anissa",
	  "Anita",
	  "Aniya",
	  "Aniyah",
	  "Anjali",
	  "Anna",
	  "Annabel",
	  "Annabell",
	  "Annabelle",
	  "Annalise",
	  "Annamae",
	  "Annamarie",
	  "Anne",
	  "Annetta",
	  "Annette",
	  "Annie",
	  "Ansel",
	  "Ansley",
	  "Anthony",
	  "Antoinette",
	  "Antone",
	  "Antonetta",
	  "Antonette",
	  "Antonia",
	  "Antonietta",
	  "Antonina",
	  "Antonio",
	  "Antwan",
	  "Antwon",
	  "Anya",
	  "April",
	  "Ara",
	  "Araceli",
	  "Aracely",
	  "Arch",
	  "Archibald",
	  "Ardella",
	  "Arden",
	  "Ardith",
	  "Arely",
	  "Ari",
	  "Ariane",
	  "Arianna",
	  "Aric",
	  "Ariel",
	  "Arielle",
	  "Arjun",
	  "Arlene",
	  "Arlie",
	  "Arlo",
	  "Armand",
	  "Armando",
	  "Armani",
	  "Arnaldo",
	  "Arne",
	  "Arno",
	  "Arnold",
	  "Arnoldo",
	  "Arnulfo",
	  "Aron",
	  "Art",
	  "Arthur",
	  "Arturo",
	  "Arvel",
	  "Arvid",
	  "Arvilla",
	  "Aryanna",
	  "Asa",
	  "Asha",
	  "Ashlee",
	  "Ashleigh",
	  "Ashley",
	  "Ashly",
	  "Ashlynn",
	  "Ashton",
	  "Ashtyn",
	  "Asia",
	  "Assunta",
	  "Astrid",
	  "Athena",
	  "Aubree",
	  "Aubrey",
	  "Audie",
	  "Audra",
	  "Audreanne",
	  "Audrey",
	  "August",
	  "Augusta",
	  "Augustine",
	  "Augustus",
	  "Aurelia",
	  "Aurelie",
	  "Aurelio",
	  "Aurore",
	  "Austen",
	  "Austin",
	  "Austyn",
	  "Autumn",
	  "Ava",
	  "Avery",
	  "Avis",
	  "Axel",
	  "Ayana",
	  "Ayden",
	  "Ayla",
	  "Aylin",
	  "Baby",
	  "Bailee",
	  "Bailey",
	  "Barbara",
	  "Barney",
	  "Baron",
	  "Barrett",
	  "Barry",
	  "Bart",
	  "Bartholome",
	  "Barton",
	  "Baylee",
	  "Beatrice",
	  "Beau",
	  "Beaulah",
	  "Bell",
	  "Bella",
	  "Belle",
	  "Ben",
	  "Benedict",
	  "Benjamin",
	  "Bennett",
	  "Bennie",
	  "Benny",
	  "Benton",
	  "Berenice",
	  "Bernadette",
	  "Bernadine",
	  "Bernard",
	  "Bernardo",
	  "Berneice",
	  "Bernhard",
	  "Bernice",
	  "Bernie",
	  "Berniece",
	  "Bernita",
	  "Berry",
	  "Bert",
	  "Berta",
	  "Bertha",
	  "Bertram",
	  "Bertrand",
	  "Beryl",
	  "Bessie",
	  "Beth",
	  "Bethany",
	  "Bethel",
	  "Betsy",
	  "Bette",
	  "Bettie",
	  "Betty",
	  "Bettye",
	  "Beulah",
	  "Beverly",
	  "Bianka",
	  "Bill",
	  "Billie",
	  "Billy",
	  "Birdie",
	  "Blair",
	  "Blaise",
	  "Blake",
	  "Blanca",
	  "Blanche",
	  "Blaze",
	  "Bo",
	  "Bobbie",
	  "Bobby",
	  "Bonita",
	  "Bonnie",
	  "Boris",
	  "Boyd",
	  "Brad",
	  "Braden",
	  "Bradford",
	  "Bradley",
	  "Bradly",
	  "Brady",
	  "Braeden",
	  "Brain",
	  "Brandi",
	  "Brando",
	  "Brandon",
	  "Brandt",
	  "Brandy",
	  "Brandyn",
	  "Brannon",
	  "Branson",
	  "Brant",
	  "Braulio",
	  "Braxton",
	  "Brayan",
	  "Breana",
	  "Breanna",
	  "Breanne",
	  "Brenda",
	  "Brendan",
	  "Brenden",
	  "Brendon",
	  "Brenna",
	  "Brennan",
	  "Brennon",
	  "Brent",
	  "Bret",
	  "Brett",
	  "Bria",
	  "Brian",
	  "Briana",
	  "Brianne",
	  "Brice",
	  "Bridget",
	  "Bridgette",
	  "Bridie",
	  "Brielle",
	  "Brigitte",
	  "Brionna",
	  "Brisa",
	  "Britney",
	  "Brittany",
	  "Brock",
	  "Broderick",
	  "Brody",
	  "Brook",
	  "Brooke",
	  "Brooklyn",
	  "Brooks",
	  "Brown",
	  "Bruce",
	  "Bryana",
	  "Bryce",
	  "Brycen",
	  "Bryon",
	  "Buck",
	  "Bud",
	  "Buddy",
	  "Buford",
	  "Bulah",
	  "Burdette",
	  "Burley",
	  "Burnice",
	  "Buster",
	  "Cade",
	  "Caden",
	  "Caesar",
	  "Caitlyn",
	  "Cale",
	  "Caleb",
	  "Caleigh",
	  "Cali",
	  "Calista",
	  "Callie",
	  "Camden",
	  "Cameron",
	  "Camila",
	  "Camilla",
	  "Camille",
	  "Camren",
	  "Camron",
	  "Camryn",
	  "Camylle",
	  "Candace",
	  "Candelario",
	  "Candice",
	  "Candida",
	  "Candido",
	  "Cara",
	  "Carey",
	  "Carissa",
	  "Carlee",
	  "Carleton",
	  "Carley",
	  "Carli",
	  "Carlie",
	  "Carlo",
	  "Carlos",
	  "Carlotta",
	  "Carmel",
	  "Carmela",
	  "Carmella",
	  "Carmelo",
	  "Carmen",
	  "Carmine",
	  "Carol",
	  "Carolanne",
	  "Carole",
	  "Carolina",
	  "Caroline",
	  "Carolyn",
	  "Carolyne",
	  "Carrie",
	  "Carroll",
	  "Carson",
	  "Carter",
	  "Cary",
	  "Casandra",
	  "Casey",
	  "Casimer",
	  "Casimir",
	  "Casper",
	  "Cassandra",
	  "Cassandre",
	  "Cassidy",
	  "Cassie",
	  "Catalina",
	  "Caterina",
	  "Catharine",
	  "Catherine",
	  "Cathrine",
	  "Cathryn",
	  "Cathy",
	  "Cayla",
	  "Ceasar",
	  "Cecelia",
	  "Cecil",
	  "Cecile",
	  "Cecilia",
	  "Cedrick",
	  "Celestine",
	  "Celestino",
	  "Celia",
	  "Celine",
	  "Cesar",
	  "Chad",
	  "Chadd",
	  "Chadrick",
	  "Chaim",
	  "Chance",
	  "Chandler",
	  "Chanel",
	  "Chanelle",
	  "Charity",
	  "Charlene",
	  "Charles",
	  "Charley",
	  "Charlie",
	  "Charlotte",
	  "Chase",
	  "Chasity",
	  "Chauncey",
	  "Chaya",
	  "Chaz",
	  "Chelsea",
	  "Chelsey",
	  "Chelsie",
	  "Chesley",
	  "Chester",
	  "Chet",
	  "Cheyanne",
	  "Cheyenne",
	  "Chloe",
	  "Chris",
	  "Christ",
	  "Christa",
	  "Christelle",
	  "Christian",
	  "Christiana",
	  "Christina",
	  "Christine",
	  "Christop",
	  "Christophe",
	  "Christopher",
	  "Christy",
	  "Chyna",
	  "Ciara",
	  "Cicero",
	  "Cielo",
	  "Cierra",
	  "Cindy",
	  "Citlalli",
	  "Clair",
	  "Claire",
	  "Clara",
	  "Clarabelle",
	  "Clare",
	  "Clarissa",
	  "Clark",
	  "Claud",
	  "Claude",
	  "Claudia",
	  "Claudie",
	  "Claudine",
	  "Clay",
	  "Clemens",
	  "Clement",
	  "Clementina",
	  "Clementine",
	  "Clemmie",
	  "Cleo",
	  "Cleora",
	  "Cleta",
	  "Cletus",
	  "Cleve",
	  "Cleveland",
	  "Clifford",
	  "Clifton",
	  "Clint",
	  "Clinton",
	  "Clotilde",
	  "Clovis",
	  "Cloyd",
	  "Clyde",
	  "Coby",
	  "Cody",
	  "Colby",
	  "Cole",
	  "Coleman",
	  "Colin",
	  "Colleen",
	  "Collin",
	  "Colt",
	  "Colten",
	  "Colton",
	  "Columbus",
	  "Concepcion",
	  "Conner",
	  "Connie",
	  "Connor",
	  "Conor",
	  "Conrad",
	  "Constance",
	  "Constantin",
	  "Consuelo",
	  "Cooper",
	  "Cora",
	  "Coralie",
	  "Corbin",
	  "Cordelia",
	  "Cordell",
	  "Cordia",
	  "Cordie",
	  "Corene",
	  "Corine",
	  "Cornelius",
	  "Cornell",
	  "Corrine",
	  "Cortez",
	  "Cortney",
	  "Cory",
	  "Coty",
	  "Courtney",
	  "Coy",
	  "Craig",
	  "Crawford",
	  "Creola",
	  "Cristal",
	  "Cristian",
	  "Cristina",
	  "Cristobal",
	  "Cristopher",
	  "Cruz",
	  "Crystal",
	  "Crystel",
	  "Cullen",
	  "Curt",
	  "Curtis",
	  "Cydney",
	  "Cynthia",
	  "Cyril",
	  "Cyrus",
	  "Dagmar",
	  "Dahlia",
	  "Daija",
	  "Daisha",
	  "Daisy",
	  "Dakota",
	  "Dale",
	  "Dallas",
	  "Dallin",
	  "Dalton",
	  "Damaris",
	  "Dameon",
	  "Damian",
	  "Damien",
	  "Damion",
	  "Damon",
	  "Dan",
	  "Dana",
	  "Dandre",
	  "Dane",
	  "D'angelo",
	  "Dangelo",
	  "Danial",
	  "Daniela",
	  "Daniella",
	  "Danielle",
	  "Danika",
	  "Dannie",
	  "Danny",
	  "Dante",
	  "Danyka",
	  "Daphne",
	  "Daphnee",
	  "Daphney",
	  "Darby",
	  "Daren",
	  "Darian",
	  "Dariana",
	  "Darien",
	  "Dario",
	  "Darion",
	  "Darius",
	  "Darlene",
	  "Daron",
	  "Darrel",
	  "Darrell",
	  "Darren",
	  "Darrick",
	  "Darrin",
	  "Darrion",
	  "Darron",
	  "Darryl",
	  "Darwin",
	  "Daryl",
	  "Dashawn",
	  "Dasia",
	  "Dave",
	  "David",
	  "Davin",
	  "Davion",
	  "Davon",
	  "Davonte",
	  "Dawn",
	  "Dawson",
	  "Dax",
	  "Dayana",
	  "Dayna",
	  "Dayne",
	  "Dayton",
	  "Dean",
	  "Deangelo",
	  "Deanna",
	  "Deborah",
	  "Declan",
	  "Dedric",
	  "Dedrick",
	  "Dee",
	  "Deion",
	  "Deja",
	  "Dejah",
	  "Dejon",
	  "Dejuan",
	  "Delaney",
	  "Delbert",
	  "Delfina",
	  "Delia",
	  "Delilah",
	  "Dell",
	  "Della",
	  "Delmer",
	  "Delores",
	  "Delpha",
	  "Delphia",
	  "Delphine",
	  "Delta",
	  "Demarco",
	  "Demarcus",
	  "Demario",
	  "Demetris",
	  "Demetrius",
	  "Demond",
	  "Dena",
	  "Denis",
	  "Dennis",
	  "Deon",
	  "Deondre",
	  "Deontae",
	  "Deonte",
	  "Dereck",
	  "Derek",
	  "Derick",
	  "Deron",
	  "Derrick",
	  "Deshaun",
	  "Deshawn",
	  "Desiree",
	  "Desmond",
	  "Dessie",
	  "Destany",
	  "Destin",
	  "Destinee",
	  "Destiney",
	  "Destini",
	  "Destiny",
	  "Devan",
	  "Devante",
	  "Deven",
	  "Devin",
	  "Devon",
	  "Devonte",
	  "Devyn",
	  "Dewayne",
	  "Dewitt",
	  "Dexter",
	  "Diamond",
	  "Diana",
	  "Dianna",
	  "Diego",
	  "Dillan",
	  "Dillon",
	  "Dimitri",
	  "Dina",
	  "Dino",
	  "Dion",
	  "Dixie",
	  "Dock",
	  "Dolly",
	  "Dolores",
	  "Domenic",
	  "Domenica",
	  "Domenick",
	  "Domenico",
	  "Domingo",
	  "Dominic",
	  "Dominique",
	  "Don",
	  "Donald",
	  "Donato",
	  "Donavon",
	  "Donna",
	  "Donnell",
	  "Donnie",
	  "Donny",
	  "Dora",
	  "Dorcas",
	  "Dorian",
	  "Doris",
	  "Dorothea",
	  "Dorothy",
	  "Dorris",
	  "Dortha",
	  "Dorthy",
	  "Doug",
	  "Douglas",
	  "Dovie",
	  "Doyle",
	  "Drake",
	  "Drew",
	  "Duane",
	  "Dudley",
	  "Dulce",
	  "Duncan",
	  "Durward",
	  "Dustin",
	  "Dusty",
	  "Dwight",
	  "Dylan",
	  "Earl",
	  "Earlene",
	  "Earline",
	  "Earnest",
	  "Earnestine",
	  "Easter",
	  "Easton",
	  "Ebba",
	  "Ebony",
	  "Ed",
	  "Eda",
	  "Edd",
	  "Eddie",
	  "Eden",
	  "Edgar",
	  "Edgardo",
	  "Edison",
	  "Edmond",
	  "Edmund",
	  "Edna",
	  "Eduardo",
	  "Edward",
	  "Edwardo",
	  "Edwin",
	  "Edwina",
	  "Edyth",
	  "Edythe",
	  "Effie",
	  "Efrain",
	  "Efren",
	  "Eileen",
	  "Einar",
	  "Eino",
	  "Eladio",
	  "Elaina",
	  "Elbert",
	  "Elda",
	  "Eldon",
	  "Eldora",
	  "Eldred",
	  "Eldridge",
	  "Eleanora",
	  "Eleanore",
	  "Eleazar",
	  "Electa",
	  "Elena",
	  "Elenor",
	  "Elenora",
	  "Eleonore",
	  "Elfrieda",
	  "Eli",
	  "Elian",
	  "Eliane",
	  "Elias",
	  "Eliezer",
	  "Elijah",
	  "Elinor",
	  "Elinore",
	  "Elisa",
	  "Elisabeth",
	  "Elise",
	  "Eliseo",
	  "Elisha",
	  "Elissa",
	  "Eliza",
	  "Elizabeth",
	  "Ella",
	  "Ellen",
	  "Ellie",
	  "Elliot",
	  "Elliott",
	  "Ellis",
	  "Ellsworth",
	  "Elmer",
	  "Elmira",
	  "Elmo",
	  "Elmore",
	  "Elna",
	  "Elnora",
	  "Elody",
	  "Eloisa",
	  "Eloise",
	  "Elouise",
	  "Eloy",
	  "Elroy",
	  "Elsa",
	  "Else",
	  "Elsie",
	  "Elta",
	  "Elton",
	  "Elva",
	  "Elvera",
	  "Elvie",
	  "Elvis",
	  "Elwin",
	  "Elwyn",
	  "Elyse",
	  "Elyssa",
	  "Elza",
	  "Emanuel",
	  "Emelia",
	  "Emelie",
	  "Emely",
	  "Emerald",
	  "Emerson",
	  "Emery",
	  "Emie",
	  "Emil",
	  "Emile",
	  "Emilia",
	  "Emiliano",
	  "Emilie",
	  "Emilio",
	  "Emily",
	  "Emma",
	  "Emmalee",
	  "Emmanuel",
	  "Emmanuelle",
	  "Emmet",
	  "Emmett",
	  "Emmie",
	  "Emmitt",
	  "Emmy",
	  "Emory",
	  "Ena",
	  "Enid",
	  "Enoch",
	  "Enola",
	  "Enos",
	  "Enrico",
	  "Enrique",
	  "Ephraim",
	  "Era",
	  "Eriberto",
	  "Eric",
	  "Erica",
	  "Erich",
	  "Erick",
	  "Ericka",
	  "Erik",
	  "Erika",
	  "Erin",
	  "Erling",
	  "Erna",
	  "Ernest",
	  "Ernestina",
	  "Ernestine",
	  "Ernesto",
	  "Ernie",
	  "Ervin",
	  "Erwin",
	  "Eryn",
	  "Esmeralda",
	  "Esperanza",
	  "Esta",
	  "Esteban",
	  "Estefania",
	  "Estel",
	  "Estell",
	  "Estella",
	  "Estelle",
	  "Estevan",
	  "Esther",
	  "Estrella",
	  "Etha",
	  "Ethan",
	  "Ethel",
	  "Ethelyn",
	  "Ethyl",
	  "Ettie",
	  "Eudora",
	  "Eugene",
	  "Eugenia",
	  "Eula",
	  "Eulah",
	  "Eulalia",
	  "Euna",
	  "Eunice",
	  "Eusebio",
	  "Eva",
	  "Evalyn",
	  "Evan",
	  "Evangeline",
	  "Evans",
	  "Eve",
	  "Eveline",
	  "Evelyn",
	  "Everardo",
	  "Everett",
	  "Everette",
	  "Evert",
	  "Evie",
	  "Ewald",
	  "Ewell",
	  "Ezekiel",
	  "Ezequiel",
	  "Ezra",
	  "Fabian",
	  "Fabiola",
	  "Fae",
	  "Fannie",
	  "Fanny",
	  "Fatima",
	  "Faustino",
	  "Fausto",
	  "Favian",
	  "Fay",
	  "Faye",
	  "Federico",
	  "Felicia",
	  "Felicita",
	  "Felicity",
	  "Felipa",
	  "Felipe",
	  "Felix",
	  "Felton",
	  "Fermin",
	  "Fern",
	  "Fernando",
	  "Ferne",
	  "Fidel",
	  "Filiberto",
	  "Filomena",
	  "Finn",
	  "Fiona",
	  "Flavie",
	  "Flavio",
	  "Fleta",
	  "Fletcher",
	  "Flo",
	  "Florence",
	  "Florencio",
	  "Florian",
	  "Florida",
	  "Florine",
	  "Flossie",
	  "Floy",
	  "Floyd",
	  "Ford",
	  "Forest",
	  "Forrest",
	  "Foster",
	  "Frances",
	  "Francesca",
	  "Francesco",
	  "Francis",
	  "Francisca",
	  "Francisco",
	  "Franco",
	  "Frank",
	  "Frankie",
	  "Franz",
	  "Fred",
	  "Freda",
	  "Freddie",
	  "Freddy",
	  "Frederic",
	  "Frederick",
	  "Frederik",
	  "Frederique",
	  "Fredrick",
	  "Fredy",
	  "Freeda",
	  "Freeman",
	  "Freida",
	  "Frida",
	  "Frieda",
	  "Friedrich",
	  "Fritz",
	  "Furman",
	  "Gabe",
	  "Gabriel",
	  "Gabriella",
	  "Gabrielle",
	  "Gaetano",
	  "Gage",
	  "Gail",
	  "Gardner",
	  "Garett",
	  "Garfield",
	  "Garland",
	  "Garnet",
	  "Garnett",
	  "Garret",
	  "Garrett",
	  "Garrick",
	  "Garrison",
	  "Garry",
	  "Garth",
	  "Gaston",
	  "Gavin",
	  "Gay",
	  "Gayle",
	  "Gaylord",
	  "Gene",
	  "General",
	  "Genesis",
	  "Genevieve",
	  "Gennaro",
	  "Genoveva",
	  "Geo",
	  "Geoffrey",
	  "George",
	  "Georgette",
	  "Georgiana",
	  "Georgianna",
	  "Geovanni",
	  "Geovanny",
	  "Geovany",
	  "Gerald",
	  "Geraldine",
	  "Gerard",
	  "Gerardo",
	  "Gerda",
	  "Gerhard",
	  "Germaine",
	  "German",
	  "Gerry",
	  "Gerson",
	  "Gertrude",
	  "Gia",
	  "Gianni",
	  "Gideon",
	  "Gilbert",
	  "Gilberto",
	  "Gilda",
	  "Giles",
	  "Gillian",
	  "Gina",
	  "Gino",
	  "Giovani",
	  "Giovanna",
	  "Giovanni",
	  "Giovanny",
	  "Gisselle",
	  "Giuseppe",
	  "Gladyce",
	  "Gladys",
	  "Glen",
	  "Glenda",
	  "Glenna",
	  "Glennie",
	  "Gloria",
	  "Godfrey",
	  "Golda",
	  "Golden",
	  "Gonzalo",
	  "Gordon",
	  "Grace",
	  "Gracie",
	  "Graciela",
	  "Grady",
	  "Graham",
	  "Grant",
	  "Granville",
	  "Grayce",
	  "Grayson",
	  "Green",
	  "Greg",
	  "Gregg",
	  "Gregoria",
	  "Gregorio",
	  "Gregory",
	  "Greta",
	  "Gretchen",
	  "Greyson",
	  "Griffin",
	  "Grover",
	  "Guadalupe",
	  "Gudrun",
	  "Guido",
	  "Guillermo",
	  "Guiseppe",
	  "Gunnar",
	  "Gunner",
	  "Gus",
	  "Gussie",
	  "Gust",
	  "Gustave",
	  "Guy",
	  "Gwen",
	  "Gwendolyn",
	  "Hadley",
	  "Hailee",
	  "Hailey",
	  "Hailie",
	  "Hal",
	  "Haleigh",
	  "Haley",
	  "Halie",
	  "Halle",
	  "Hallie",
	  "Hank",
	  "Hanna",
	  "Hannah",
	  "Hans",
	  "Hardy",
	  "Harley",
	  "Harmon",
	  "Harmony",
	  "Harold",
	  "Harrison",
	  "Harry",
	  "Harvey",
	  "Haskell",
	  "Hassan",
	  "Hassie",
	  "Hattie",
	  "Haven",
	  "Hayden",
	  "Haylee",
	  "Hayley",
	  "Haylie",
	  "Hazel",
	  "Hazle",
	  "Heath",
	  "Heather",
	  "Heaven",
	  "Heber",
	  "Hector",
	  "Heidi",
	  "Helen",
	  "Helena",
	  "Helene",
	  "Helga",
	  "Hellen",
	  "Helmer",
	  "Heloise",
	  "Henderson",
	  "Henri",
	  "Henriette",
	  "Henry",
	  "Herbert",
	  "Herman",
	  "Hermann",
	  "Hermina",
	  "Herminia",
	  "Herminio",
	  "Hershel",
	  "Herta",
	  "Hertha",
	  "Hester",
	  "Hettie",
	  "Hilario",
	  "Hilbert",
	  "Hilda",
	  "Hildegard",
	  "Hillard",
	  "Hillary",
	  "Hilma",
	  "Hilton",
	  "Hipolito",
	  "Hiram",
	  "Hobart",
	  "Holden",
	  "Hollie",
	  "Hollis",
	  "Holly",
	  "Hope",
	  "Horace",
	  "Horacio",
	  "Hortense",
	  "Hosea",
	  "Houston",
	  "Howard",
	  "Howell",
	  "Hoyt",
	  "Hubert",
	  "Hudson",
	  "Hugh",
	  "Hulda",
	  "Humberto",
	  "Hunter",
	  "Hyman",
	  "Ian",
	  "Ibrahim",
	  "Icie",
	  "Ida",
	  "Idell",
	  "Idella",
	  "Ignacio",
	  "Ignatius",
	  "Ike",
	  "Ila",
	  "Ilene",
	  "Iliana",
	  "Ima",
	  "Imani",
	  "Imelda",
	  "Immanuel",
	  "Imogene",
	  "Ines",
	  "Irma",
	  "Irving",
	  "Irwin",
	  "Isaac",
	  "Isabel",
	  "Isabell",
	  "Isabella",
	  "Isabelle",
	  "Isac",
	  "Isadore",
	  "Isai",
	  "Isaiah",
	  "Isaias",
	  "Isidro",
	  "Ismael",
	  "Isobel",
	  "Isom",
	  "Israel",
	  "Issac",
	  "Itzel",
	  "Iva",
	  "Ivah",
	  "Ivory",
	  "Ivy",
	  "Izabella",
	  "Izaiah",
	  "Jabari",
	  "Jace",
	  "Jacey",
	  "Jacinthe",
	  "Jacinto",
	  "Jack",
	  "Jackeline",
	  "Jackie",
	  "Jacklyn",
	  "Jackson",
	  "Jacky",
	  "Jaclyn",
	  "Jacquelyn",
	  "Jacques",
	  "Jacynthe",
	  "Jada",
	  "Jade",
	  "Jaden",
	  "Jadon",
	  "Jadyn",
	  "Jaeden",
	  "Jaida",
	  "Jaiden",
	  "Jailyn",
	  "Jaime",
	  "Jairo",
	  "Jakayla",
	  "Jake",
	  "Jakob",
	  "Jaleel",
	  "Jalen",
	  "Jalon",
	  "Jalyn",
	  "Jamaal",
	  "Jamal",
	  "Jamar",
	  "Jamarcus",
	  "Jamel",
	  "Jameson",
	  "Jamey",
	  "Jamie",
	  "Jamil",
	  "Jamir",
	  "Jamison",
	  "Jammie",
	  "Jan",
	  "Jana",
	  "Janae",
	  "Jane",
	  "Janelle",
	  "Janessa",
	  "Janet",
	  "Janice",
	  "Janick",
	  "Janie",
	  "Janis",
	  "Janiya",
	  "Jannie",
	  "Jany",
	  "Jaquan",
	  "Jaquelin",
	  "Jaqueline",
	  "Jared",
	  "Jaren",
	  "Jarod",
	  "Jaron",
	  "Jarred",
	  "Jarrell",
	  "Jarret",
	  "Jarrett",
	  "Jarrod",
	  "Jarvis",
	  "Jasen",
	  "Jasmin",
	  "Jason",
	  "Jasper",
	  "Jaunita",
	  "Javier",
	  "Javon",
	  "Javonte",
	  "Jay",
	  "Jayce",
	  "Jaycee",
	  "Jayda",
	  "Jayde",
	  "Jayden",
	  "Jaydon",
	  "Jaylan",
	  "Jaylen",
	  "Jaylin",
	  "Jaylon",
	  "Jayme",
	  "Jayne",
	  "Jayson",
	  "Jazlyn",
	  "Jazmin",
	  "Jazmyn",
	  "Jazmyne",
	  "Jean",
	  "Jeanette",
	  "Jeanie",
	  "Jeanne",
	  "Jed",
	  "Jedediah",
	  "Jedidiah",
	  "Jeff",
	  "Jefferey",
	  "Jeffery",
	  "Jeffrey",
	  "Jeffry",
	  "Jena",
	  "Jenifer",
	  "Jennie",
	  "Jennifer",
	  "Jennings",
	  "Jennyfer",
	  "Jensen",
	  "Jerad",
	  "Jerald",
	  "Jeramie",
	  "Jeramy",
	  "Jerel",
	  "Jeremie",
	  "Jeremy",
	  "Jermain",
	  "Jermaine",
	  "Jermey",
	  "Jerod",
	  "Jerome",
	  "Jeromy",
	  "Jerrell",
	  "Jerrod",
	  "Jerrold",
	  "Jerry",
	  "Jess",
	  "Jesse",
	  "Jessica",
	  "Jessie",
	  "Jessika",
	  "Jessy",
	  "Jessyca",
	  "Jesus",
	  "Jett",
	  "Jettie",
	  "Jevon",
	  "Jewel",
	  "Jewell",
	  "Jillian",
	  "Jimmie",
	  "Jimmy",
	  "Jo",
	  "Joan",
	  "Joana",
	  "Joanie",
	  "Joanne",
	  "Joannie",
	  "Joanny",
	  "Joany",
	  "Joaquin",
	  "Jocelyn",
	  "Jodie",
	  "Jody",
	  "Joe",
	  "Joel",
	  "Joelle",
	  "Joesph",
	  "Joey",
	  "Johan",
	  "Johann",
	  "Johanna",
	  "Johathan",
	  "John",
	  "Johnathan",
	  "Johnathon",
	  "Johnnie",
	  "Johnny",
	  "Johnpaul",
	  "Johnson",
	  "Jolie",
	  "Jon",
	  "Jonas",
	  "Jonatan",
	  "Jonathan",
	  "Jonathon",
	  "Jordan",
	  "Jordane",
	  "Jordi",
	  "Jordon",
	  "Jordy",
	  "Jordyn",
	  "Jorge",
	  "Jose",
	  "Josefa",
	  "Josefina",
	  "Joseph",
	  "Josephine",
	  "Josh",
	  "Joshua",
	  "Joshuah",
	  "Josiah",
	  "Josiane",
	  "Josianne",
	  "Josie",
	  "Josue",
	  "Jovan",
	  "Jovani",
	  "Jovanny",
	  "Jovany",
	  "Joy",
	  "Joyce",
	  "Juana",
	  "Juanita",
	  "Judah",
	  "Judd",
	  "Jude",
	  "Judge",
	  "Judson",
	  "Judy",
	  "Jules",
	  "Julia",
	  "Julian",
	  "Juliana",
	  "Julianne",
	  "Julie",
	  "Julien",
	  "Juliet",
	  "Julio",
	  "Julius",
	  "June",
	  "Junior",
	  "Junius",
	  "Justen",
	  "Justice",
	  "Justina",
	  "Justine",
	  "Juston",
	  "Justus",
	  "Justyn",
	  "Juvenal",
	  "Juwan",
	  "Kacey",
	  "Kaci",
	  "Kacie",
	  "Kade",
	  "Kaden",
	  "Kadin",
	  "Kaela",
	  "Kaelyn",
	  "Kaia",
	  "Kailee",
	  "Kailey",
	  "Kailyn",
	  "Kaitlin",
	  "Kaitlyn",
	  "Kale",
	  "Kaleb",
	  "Kaleigh",
	  "Kaley",
	  "Kali",
	  "Kallie",
	  "Kameron",
	  "Kamille",
	  "Kamren",
	  "Kamron",
	  "Kamryn",
	  "Kane",
	  "Kara",
	  "Kareem",
	  "Karelle",
	  "Karen",
	  "Kari",
	  "Kariane",
	  "Karianne",
	  "Karina",
	  "Karine",
	  "Karl",
	  "Karlee",
	  "Karley",
	  "Karli",
	  "Karlie",
	  "Karolann",
	  "Karson",
	  "Kasandra",
	  "Kasey",
	  "Kassandra",
	  "Katarina",
	  "Katelin",
	  "Katelyn",
	  "Katelynn",
	  "Katharina",
	  "Katherine",
	  "Katheryn",
	  "Kathleen",
	  "Kathlyn",
	  "Kathryn",
	  "Kathryne",
	  "Katlyn",
	  "Katlynn",
	  "Katrina",
	  "Katrine",
	  "Kattie",
	  "Kavon",
	  "Kay",
	  "Kaya",
	  "Kaycee",
	  "Kayden",
	  "Kayla",
	  "Kaylah",
	  "Kaylee",
	  "Kayleigh",
	  "Kayley",
	  "Kayli",
	  "Kaylie",
	  "Kaylin",
	  "Keagan",
	  "Keanu",
	  "Keara",
	  "Keaton",
	  "Keegan",
	  "Keeley",
	  "Keely",
	  "Keenan",
	  "Keira",
	  "Keith",
	  "Kellen",
	  "Kelley",
	  "Kelli",
	  "Kellie",
	  "Kelly",
	  "Kelsi",
	  "Kelsie",
	  "Kelton",
	  "Kelvin",
	  "Ken",
	  "Kendall",
	  "Kendra",
	  "Kendrick",
	  "Kenna",
	  "Kennedi",
	  "Kennedy",
	  "Kenneth",
	  "Kennith",
	  "Kenny",
	  "Kenton",
	  "Kenya",
	  "Kenyatta",
	  "Kenyon",
	  "Keon",
	  "Keshaun",
	  "Keshawn",
	  "Keven",
	  "Kevin",
	  "Kevon",
	  "Keyon",
	  "Keyshawn",
	  "Khalid",
	  "Khalil",
	  "Kian",
	  "Kiana",
	  "Kianna",
	  "Kiara",
	  "Kiarra",
	  "Kiel",
	  "Kiera",
	  "Kieran",
	  "Kiley",
	  "Kim",
	  "Kimberly",
	  "King",
	  "Kip",
	  "Kira",
	  "Kirk",
	  "Kirsten",
	  "Kirstin",
	  "Kitty",
	  "Kobe",
	  "Koby",
	  "Kody",
	  "Kolby",
	  "Kole",
	  "Korbin",
	  "Korey",
	  "Kory",
	  "Kraig",
	  "Kris",
	  "Krista",
	  "Kristian",
	  "Kristin",
	  "Kristina",
	  "Kristofer",
	  "Kristoffer",
	  "Kristopher",
	  "Kristy",
	  "Krystal",
	  "Krystel",
	  "Krystina",
	  "Kurt",
	  "Kurtis",
	  "Kyla",
	  "Kyle",
	  "Kylee",
	  "Kyleigh",
	  "Kyler",
	  "Kylie",
	  "Kyra",
	  "Lacey",
	  "Lacy",
	  "Ladarius",
	  "Lafayette",
	  "Laila",
	  "Laisha",
	  "Lamar",
	  "Lambert",
	  "Lamont",
	  "Lance",
	  "Landen",
	  "Lane",
	  "Laney",
	  "Larissa",
	  "Laron",
	  "Larry",
	  "Larue",
	  "Laura",
	  "Laurel",
	  "Lauren",
	  "Laurence",
	  "Lauretta",
	  "Lauriane",
	  "Laurianne",
	  "Laurie",
	  "Laurine",
	  "Laury",
	  "Lauryn",
	  "Lavada",
	  "Lavern",
	  "Laverna",
	  "Laverne",
	  "Lavina",
	  "Lavinia",
	  "Lavon",
	  "Lavonne",
	  "Lawrence",
	  "Lawson",
	  "Layla",
	  "Layne",
	  "Lazaro",
	  "Lea",
	  "Leann",
	  "Leanna",
	  "Leanne",
	  "Leatha",
	  "Leda",
	  "Lee",
	  "Leif",
	  "Leila",
	  "Leilani",
	  "Lela",
	  "Lelah",
	  "Leland",
	  "Lelia",
	  "Lempi",
	  "Lemuel",
	  "Lenna",
	  "Lennie",
	  "Lenny",
	  "Lenora",
	  "Lenore",
	  "Leo",
	  "Leola",
	  "Leon",
	  "Leonard",
	  "Leonardo",
	  "Leone",
	  "Leonel",
	  "Leonie",
	  "Leonor",
	  "Leonora",
	  "Leopold",
	  "Leopoldo",
	  "Leora",
	  "Lera",
	  "Lesley",
	  "Leslie",
	  "Lesly",
	  "Lessie",
	  "Lester",
	  "Leta",
	  "Letha",
	  "Letitia",
	  "Levi",
	  "Lew",
	  "Lewis",
	  "Lexi",
	  "Lexie",
	  "Lexus",
	  "Lia",
	  "Liam",
	  "Liana",
	  "Libbie",
	  "Libby",
	  "Lila",
	  "Lilian",
	  "Liliana",
	  "Liliane",
	  "Lilla",
	  "Lillian",
	  "Lilliana",
	  "Lillie",
	  "Lilly",
	  "Lily",
	  "Lilyan",
	  "Lina",
	  "Lincoln",
	  "Linda",
	  "Lindsay",
	  "Lindsey",
	  "Linnea",
	  "Linnie",
	  "Linwood",
	  "Lionel",
	  "Lisa",
	  "Lisandro",
	  "Lisette",
	  "Litzy",
	  "Liza",
	  "Lizeth",
	  "Lizzie",
	  "Llewellyn",
	  "Lloyd",
	  "Logan",
	  "Lois",
	  "Lola",
	  "Lolita",
	  "Loma",
	  "Lon",
	  "London",
	  "Lonie",
	  "Lonnie",
	  "Lonny",
	  "Lonzo",
	  "Lora",
	  "Loraine",
	  "Loren",
	  "Lorena",
	  "Lorenz",
	  "Lorenza",
	  "Lorenzo",
	  "Lori",
	  "Lorine",
	  "Lorna",
	  "Lottie",
	  "Lou",
	  "Louie",
	  "Louisa",
	  "Lourdes",
	  "Louvenia",
	  "Lowell",
	  "Loy",
	  "Loyal",
	  "Loyce",
	  "Lucas",
	  "Luciano",
	  "Lucie",
	  "Lucienne",
	  "Lucile",
	  "Lucinda",
	  "Lucio",
	  "Lucious",
	  "Lucius",
	  "Lucy",
	  "Ludie",
	  "Ludwig",
	  "Lue",
	  "Luella",
	  "Luigi",
	  "Luis",
	  "Luisa",
	  "Lukas",
	  "Lula",
	  "Lulu",
	  "Luna",
	  "Lupe",
	  "Lura",
	  "Lurline",
	  "Luther",
	  "Luz",
	  "Lyda",
	  "Lydia",
	  "Lyla",
	  "Lynn",
	  "Lyric",
	  "Lysanne",
	  "Mabel",
	  "Mabelle",
	  "Mable",
	  "Mac",
	  "Macey",
	  "Maci",
	  "Macie",
	  "Mack",
	  "Mackenzie",
	  "Macy",
	  "Madaline",
	  "Madalyn",
	  "Maddison",
	  "Madeline",
	  "Madelyn",
	  "Madelynn",
	  "Madge",
	  "Madie",
	  "Madilyn",
	  "Madisen",
	  "Madison",
	  "Madisyn",
	  "Madonna",
	  "Madyson",
	  "Mae",
	  "Maegan",
	  "Maeve",
	  "Mafalda",
	  "Magali",
	  "Magdalen",
	  "Magdalena",
	  "Maggie",
	  "Magnolia",
	  "Magnus",
	  "Maia",
	  "Maida",
	  "Maiya",
	  "Major",
	  "Makayla",
	  "Makenna",
	  "Makenzie",
	  "Malachi",
	  "Malcolm",
	  "Malika",
	  "Malinda",
	  "Mallie",
	  "Mallory",
	  "Malvina",
	  "Mandy",
	  "Manley",
	  "Manuel",
	  "Manuela",
	  "Mara",
	  "Marc",
	  "Marcel",
	  "Marcelina",
	  "Marcelino",
	  "Marcella",
	  "Marcelle",
	  "Marcellus",
	  "Marcelo",
	  "Marcia",
	  "Marco",
	  "Marcos",
	  "Marcus",
	  "Margaret",
	  "Margarete",
	  "Margarett",
	  "Margaretta",
	  "Margarette",
	  "Margarita",
	  "Marge",
	  "Margie",
	  "Margot",
	  "Margret",
	  "Marguerite",
	  "Maria",
	  "Mariah",
	  "Mariam",
	  "Marian",
	  "Mariana",
	  "Mariane",
	  "Marianna",
	  "Marianne",
	  "Mariano",
	  "Maribel",
	  "Marie",
	  "Mariela",
	  "Marielle",
	  "Marietta",
	  "Marilie",
	  "Marilou",
	  "Marilyne",
	  "Marina",
	  "Mario",
	  "Marion",
	  "Marisa",
	  "Marisol",
	  "Maritza",
	  "Marjolaine",
	  "Marjorie",
	  "Marjory",
	  "Mark",
	  "Markus",
	  "Marlee",
	  "Marlen",
	  "Marlene",
	  "Marley",
	  "Marlin",
	  "Marlon",
	  "Marques",
	  "Marquis",
	  "Marquise",
	  "Marshall",
	  "Marta",
	  "Martin",
	  "Martina",
	  "Martine",
	  "Marty",
	  "Marvin",
	  "Mary",
	  "Maryam",
	  "Maryjane",
	  "Maryse",
	  "Mason",
	  "Mateo",
	  "Mathew",
	  "Mathias",
	  "Mathilde",
	  "Matilda",
	  "Matilde",
	  "Matt",
	  "Matteo",
	  "Mattie",
	  "Maud",
	  "Maude",
	  "Maudie",
	  "Maureen",
	  "Maurice",
	  "Mauricio",
	  "Maurine",
	  "Maverick",
	  "Mavis",
	  "Max",
	  "Maxie",
	  "Maxime",
	  "Maximilian",
	  "Maximillia",
	  "Maximillian",
	  "Maximo",
	  "Maximus",
	  "Maxine",
	  "Maxwell",
	  "May",
	  "Maya",
	  "Maybell",
	  "Maybelle",
	  "Maye",
	  "Maymie",
	  "Maynard",
	  "Mayra",
	  "Mazie",
	  "Mckayla",
	  "Mckenna",
	  "Mckenzie",
	  "Meagan",
	  "Meaghan",
	  "Meda",
	  "Megane",
	  "Meggie",
	  "Meghan",
	  "Mekhi",
	  "Melany",
	  "Melba",
	  "Melisa",
	  "Melissa",
	  "Mellie",
	  "Melody",
	  "Melvin",
	  "Melvina",
	  "Melyna",
	  "Melyssa",
	  "Mercedes",
	  "Meredith",
	  "Merl",
	  "Merle",
	  "Merlin",
	  "Merritt",
	  "Mertie",
	  "Mervin",
	  "Meta",
	  "Mia",
	  "Micaela",
	  "Micah",
	  "Michael",
	  "Michaela",
	  "Michale",
	  "Micheal",
	  "Michel",
	  "Michele",
	  "Michelle",
	  "Miguel",
	  "Mikayla",
	  "Mike",
	  "Mikel",
	  "Milan",
	  "Miles",
	  "Milford",
	  "Miller",
	  "Millie",
	  "Milo",
	  "Milton",
	  "Mina",
	  "Minerva",
	  "Minnie",
	  "Miracle",
	  "Mireille",
	  "Mireya",
	  "Misael",
	  "Missouri",
	  "Misty",
	  "Mitchel",
	  "Mitchell",
	  "Mittie",
	  "Modesta",
	  "Modesto",
	  "Mohamed",
	  "Mohammad",
	  "Mohammed",
	  "Moises",
	  "Mollie",
	  "Molly",
	  "Mona",
	  "Monica",
	  "Monique",
	  "Monroe",
	  "Monserrat",
	  "Monserrate",
	  "Montana",
	  "Monte",
	  "Monty",
	  "Morgan",
	  "Moriah",
	  "Morris",
	  "Mortimer",
	  "Morton",
	  "Mose",
	  "Moses",
	  "Moshe",
	  "Mossie",
	  "Mozell",
	  "Mozelle",
	  "Muhammad",
	  "Muriel",
	  "Murl",
	  "Murphy",
	  "Murray",
	  "Mustafa",
	  "Mya",
	  "Myah",
	  "Mylene",
	  "Myles",
	  "Myra",
	  "Myriam",
	  "Myrl",
	  "Myrna",
	  "Myron",
	  "Myrtice",
	  "Myrtie",
	  "Myrtis",
	  "Myrtle",
	  "Nadia",
	  "Nakia",
	  "Name",
	  "Nannie",
	  "Naomi",
	  "Naomie",
	  "Napoleon",
	  "Narciso",
	  "Nash",
	  "Nasir",
	  "Nat",
	  "Natalia",
	  "Natalie",
	  "Natasha",
	  "Nathan",
	  "Nathanael",
	  "Nathanial",
	  "Nathaniel",
	  "Nathen",
	  "Nayeli",
	  "Neal",
	  "Ned",
	  "Nedra",
	  "Neha",
	  "Neil",
	  "Nelda",
	  "Nella",
	  "Nelle",
	  "Nellie",
	  "Nels",
	  "Nelson",
	  "Neoma",
	  "Nestor",
	  "Nettie",
	  "Neva",
	  "Newell",
	  "Newton",
	  "Nia",
	  "Nicholas",
	  "Nicholaus",
	  "Nichole",
	  "Nick",
	  "Nicklaus",
	  "Nickolas",
	  "Nico",
	  "Nicola",
	  "Nicolas",
	  "Nicole",
	  "Nicolette",
	  "Nigel",
	  "Nikita",
	  "Nikki",
	  "Nikko",
	  "Niko",
	  "Nikolas",
	  "Nils",
	  "Nina",
	  "Noah",
	  "Noble",
	  "Noe",
	  "Noel",
	  "Noelia",
	  "Noemi",
	  "Noemie",
	  "Noemy",
	  "Nola",
	  "Nolan",
	  "Nona",
	  "Nora",
	  "Norbert",
	  "Norberto",
	  "Norene",
	  "Norma",
	  "Norris",
	  "Norval",
	  "Norwood",
	  "Nova",
	  "Novella",
	  "Nya",
	  "Nyah",
	  "Nyasia",
	  "Obie",
	  "Oceane",
	  "Ocie",
	  "Octavia",
	  "Oda",
	  "Odell",
	  "Odessa",
	  "Odie",
	  "Ofelia",
	  "Okey",
	  "Ola",
	  "Olaf",
	  "Ole",
	  "Olen",
	  "Oleta",
	  "Olga",
	  "Olin",
	  "Oliver",
	  "Ollie",
	  "Oma",
	  "Omari",
	  "Omer",
	  "Ona",
	  "Onie",
	  "Opal",
	  "Ophelia",
	  "Ora",
	  "Oral",
	  "Oran",
	  "Oren",
	  "Orie",
	  "Orin",
	  "Orion",
	  "Orland",
	  "Orlando",
	  "Orlo",
	  "Orpha",
	  "Orrin",
	  "Orval",
	  "Orville",
	  "Osbaldo",
	  "Osborne",
	  "Oscar",
	  "Osvaldo",
	  "Oswald",
	  "Oswaldo",
	  "Otha",
	  "Otho",
	  "Otilia",
	  "Otis",
	  "Ottilie",
	  "Ottis",
	  "Otto",
	  "Ova",
	  "Owen",
	  "Ozella",
	  "Pablo",
	  "Paige",
	  "Palma",
	  "Pamela",
	  "Pansy",
	  "Paolo",
	  "Paris",
	  "Parker",
	  "Pascale",
	  "Pasquale",
	  "Pat",
	  "Patience",
	  "Patricia",
	  "Patrick",
	  "Patsy",
	  "Pattie",
	  "Paul",
	  "Paula",
	  "Pauline",
	  "Paxton",
	  "Payton",
	  "Pearl",
	  "Pearlie",
	  "Pearline",
	  "Pedro",
	  "Peggie",
	  "Penelope",
	  "Percival",
	  "Percy",
	  "Perry",
	  "Pete",
	  "Peter",
	  "Petra",
	  "Peyton",
	  "Philip",
	  "Phoebe",
	  "Phyllis",
	  "Pierce",
	  "Pierre",
	  "Pietro",
	  "Pink",
	  "Pinkie",
	  "Piper",
	  "Polly",
	  "Porter",
	  "Precious",
	  "Presley",
	  "Preston",
	  "Price",
	  "Prince",
	  "Princess",
	  "Priscilla",
	  "Providenci",
	  "Prudence",
	  "Queen",
	  "Queenie",
	  "Quentin",
	  "Quincy",
	  "Quinn",
	  "Quinten",
	  "Quinton",
	  "Rachael",
	  "Rachel",
	  "Rachelle",
	  "Rae",
	  "Raegan",
	  "Rafael",
	  "Rafaela",
	  "Raheem",
	  "Rahsaan",
	  "Rahul",
	  "Raina",
	  "Raleigh",
	  "Ralph",
	  "Ramiro",
	  "Ramon",
	  "Ramona",
	  "Randal",
	  "Randall",
	  "Randi",
	  "Randy",
	  "Ransom",
	  "Raoul",
	  "Raphael",
	  "Raphaelle",
	  "Raquel",
	  "Rashad",
	  "Rashawn",
	  "Rasheed",
	  "Raul",
	  "Raven",
	  "Ray",
	  "Raymond",
	  "Raymundo",
	  "Reagan",
	  "Reanna",
	  "Reba",
	  "Rebeca",
	  "Rebecca",
	  "Rebeka",
	  "Rebekah",
	  "Reece",
	  "Reed",
	  "Reese",
	  "Regan",
	  "Reggie",
	  "Reginald",
	  "Reid",
	  "Reilly",
	  "Reina",
	  "Reinhold",
	  "Remington",
	  "Rene",
	  "Renee",
	  "Ressie",
	  "Reta",
	  "Retha",
	  "Retta",
	  "Reuben",
	  "Reva",
	  "Rex",
	  "Rey",
	  "Reyes",
	  "Reymundo",
	  "Reyna",
	  "Reynold",
	  "Rhea",
	  "Rhett",
	  "Rhianna",
	  "Rhiannon",
	  "Rhoda",
	  "Ricardo",
	  "Richard",
	  "Richie",
	  "Richmond",
	  "Rick",
	  "Rickey",
	  "Rickie",
	  "Ricky",
	  "Rico",
	  "Rigoberto",
	  "Riley",
	  "Rita",
	  "River",
	  "Robb",
	  "Robbie",
	  "Robert",
	  "Roberta",
	  "Roberto",
	  "Robin",
	  "Robyn",
	  "Rocio",
	  "Rocky",
	  "Rod",
	  "Roderick",
	  "Rodger",
	  "Rodolfo",
	  "Rodrick",
	  "Rodrigo",
	  "Roel",
	  "Rogelio",
	  "Roger",
	  "Rogers",
	  "Rolando",
	  "Rollin",
	  "Roma",
	  "Romaine",
	  "Roman",
	  "Ron",
	  "Ronaldo",
	  "Ronny",
	  "Roosevelt",
	  "Rory",
	  "Rosa",
	  "Rosalee",
	  "Rosalia",
	  "Rosalind",
	  "Rosalinda",
	  "Rosalyn",
	  "Rosamond",
	  "Rosanna",
	  "Rosario",
	  "Roscoe",
	  "Rose",
	  "Rosella",
	  "Roselyn",
	  "Rosemarie",
	  "Rosemary",
	  "Rosendo",
	  "Rosetta",
	  "Rosie",
	  "Rosina",
	  "Roslyn",
	  "Ross",
	  "Rossie",
	  "Rowan",
	  "Rowena",
	  "Rowland",
	  "Roxane",
	  "Roxanne",
	  "Roy",
	  "Royal",
	  "Royce",
	  "Rozella",
	  "Ruben",
	  "Rubie",
	  "Ruby",
	  "Rubye",
	  "Rudolph",
	  "Rudy",
	  "Rupert",
	  "Russ",
	  "Russel",
	  "Russell",
	  "Rusty",
	  "Ruth",
	  "Ruthe",
	  "Ruthie",
	  "Ryan",
	  "Ryann",
	  "Ryder",
	  "Rylan",
	  "Rylee",
	  "Ryleigh",
	  "Ryley",
	  "Sabina",
	  "Sabrina",
	  "Sabryna",
	  "Sadie",
	  "Sadye",
	  "Sage",
	  "Saige",
	  "Sallie",
	  "Sally",
	  "Salma",
	  "Salvador",
	  "Salvatore",
	  "Sam",
	  "Samanta",
	  "Samantha",
	  "Samara",
	  "Samir",
	  "Sammie",
	  "Sammy",
	  "Samson",
	  "Sandra",
	  "Sandrine",
	  "Sandy",
	  "Sanford",
	  "Santa",
	  "Santiago",
	  "Santina",
	  "Santino",
	  "Santos",
	  "Sarah",
	  "Sarai",
	  "Sarina",
	  "Sasha",
	  "Saul",
	  "Savanah",
	  "Savanna",
	  "Savannah",
	  "Savion",
	  "Scarlett",
	  "Schuyler",
	  "Scot",
	  "Scottie",
	  "Scotty",
	  "Seamus",
	  "Sean",
	  "Sebastian",
	  "Sedrick",
	  "Selena",
	  "Selina",
	  "Selmer",
	  "Serena",
	  "Serenity",
	  "Seth",
	  "Shad",
	  "Shaina",
	  "Shakira",
	  "Shana",
	  "Shane",
	  "Shanel",
	  "Shanelle",
	  "Shania",
	  "Shanie",
	  "Shaniya",
	  "Shanna",
	  "Shannon",
	  "Shanny",
	  "Shanon",
	  "Shany",
	  "Sharon",
	  "Shaun",
	  "Shawn",
	  "Shawna",
	  "Shaylee",
	  "Shayna",
	  "Shayne",
	  "Shea",
	  "Sheila",
	  "Sheldon",
	  "Shemar",
	  "Sheridan",
	  "Sherman",
	  "Sherwood",
	  "Shirley",
	  "Shyann",
	  "Shyanne",
	  "Sibyl",
	  "Sid",
	  "Sidney",
	  "Sienna",
	  "Sierra",
	  "Sigmund",
	  "Sigrid",
	  "Sigurd",
	  "Silas",
	  "Sim",
	  "Simeon",
	  "Simone",
	  "Sincere",
	  "Sister",
	  "Skye",
	  "Skyla",
	  "Skylar",
	  "Sofia",
	  "Soledad",
	  "Solon",
	  "Sonia",
	  "Sonny",
	  "Sonya",
	  "Sophia",
	  "Sophie",
	  "Spencer",
	  "Stacey",
	  "Stacy",
	  "Stan",
	  "Stanford",
	  "Stanley",
	  "Stanton",
	  "Stefan",
	  "Stefanie",
	  "Stella",
	  "Stephan",
	  "Stephania",
	  "Stephanie",
	  "Stephany",
	  "Stephen",
	  "Stephon",
	  "Sterling",
	  "Steve",
	  "Stevie",
	  "Stewart",
	  "Stone",
	  "Stuart",
	  "Summer",
	  "Sunny",
	  "Susan",
	  "Susana",
	  "Susanna",
	  "Susie",
	  "Suzanne",
	  "Sven",
	  "Syble",
	  "Sydnee",
	  "Sydney",
	  "Sydni",
	  "Sydnie",
	  "Sylvan",
	  "Sylvester",
	  "Sylvia",
	  "Tabitha",
	  "Tad",
	  "Talia",
	  "Talon",
	  "Tamara",
	  "Tamia",
	  "Tania",
	  "Tanner",
	  "Tanya",
	  "Tara",
	  "Taryn",
	  "Tate",
	  "Tatum",
	  "Tatyana",
	  "Taurean",
	  "Tavares",
	  "Taya",
	  "Taylor",
	  "Teagan",
	  "Ted",
	  "Telly",
	  "Terence",
	  "Teresa",
	  "Terrance",
	  "Terrell",
	  "Terrence",
	  "Terrill",
	  "Terry",
	  "Tess",
	  "Tessie",
	  "Tevin",
	  "Thad",
	  "Thaddeus",
	  "Thalia",
	  "Thea",
	  "Thelma",
	  "Theo",
	  "Theodora",
	  "Theodore",
	  "Theresa",
	  "Therese",
	  "Theresia",
	  "Theron",
	  "Thomas",
	  "Thora",
	  "Thurman",
	  "Tia",
	  "Tiana",
	  "Tianna",
	  "Tiara",
	  "Tierra",
	  "Tiffany",
	  "Tillman",
	  "Timmothy",
	  "Timmy",
	  "Timothy",
	  "Tina",
	  "Tito",
	  "Titus",
	  "Tobin",
	  "Toby",
	  "Tod",
	  "Tom",
	  "Tomas",
	  "Tomasa",
	  "Tommie",
	  "Toney",
	  "Toni",
	  "Tony",
	  "Torey",
	  "Torrance",
	  "Torrey",
	  "Toy",
	  "Trace",
	  "Tracey",
	  "Tracy",
	  "Travis",
	  "Travon",
	  "Tre",
	  "Tremaine",
	  "Tremayne",
	  "Trent",
	  "Trenton",
	  "Tressa",
	  "Tressie",
	  "Treva",
	  "Trever",
	  "Trevion",
	  "Trevor",
	  "Trey",
	  "Trinity",
	  "Trisha",
	  "Tristian",
	  "Tristin",
	  "Triston",
	  "Troy",
	  "Trudie",
	  "Trycia",
	  "Trystan",
	  "Turner",
	  "Twila",
	  "Tyler",
	  "Tyra",
	  "Tyree",
	  "Tyreek",
	  "Tyrel",
	  "Tyrell",
	  "Tyrese",
	  "Tyrique",
	  "Tyshawn",
	  "Tyson",
	  "Ubaldo",
	  "Ulices",
	  "Ulises",
	  "Una",
	  "Unique",
	  "Urban",
	  "Uriah",
	  "Uriel",
	  "Ursula",
	  "Vada",
	  "Valentin",
	  "Valentina",
	  "Valentine",
	  "Valerie",
	  "Vallie",
	  "Van",
	  "Vance",
	  "Vanessa",
	  "Vaughn",
	  "Veda",
	  "Velda",
	  "Vella",
	  "Velma",
	  "Velva",
	  "Vena",
	  "Verda",
	  "Verdie",
	  "Vergie",
	  "Verla",
	  "Verlie",
	  "Vern",
	  "Verna",
	  "Verner",
	  "Vernice",
	  "Vernie",
	  "Vernon",
	  "Verona",
	  "Veronica",
	  "Vesta",
	  "Vicenta",
	  "Vicente",
	  "Vickie",
	  "Vicky",
	  "Victor",
	  "Victoria",
	  "Vida",
	  "Vidal",
	  "Vilma",
	  "Vince",
	  "Vincent",
	  "Vincenza",
	  "Vincenzo",
	  "Vinnie",
	  "Viola",
	  "Violet",
	  "Violette",
	  "Virgie",
	  "Virgil",
	  "Virginia",
	  "Virginie",
	  "Vita",
	  "Vito",
	  "Viva",
	  "Vivian",
	  "Viviane",
	  "Vivianne",
	  "Vivien",
	  "Vivienne",
	  "Vladimir",
	  "Wade",
	  "Waino",
	  "Waldo",
	  "Walker",
	  "Wallace",
	  "Walter",
	  "Walton",
	  "Wanda",
	  "Ward",
	  "Warren",
	  "Watson",
	  "Wava",
	  "Waylon",
	  "Wayne",
	  "Webster",
	  "Weldon",
	  "Wellington",
	  "Wendell",
	  "Wendy",
	  "Werner",
	  "Westley",
	  "Weston",
	  "Whitney",
	  "Wilber",
	  "Wilbert",
	  "Wilburn",
	  "Wiley",
	  "Wilford",
	  "Wilfred",
	  "Wilfredo",
	  "Wilfrid",
	  "Wilhelm",
	  "Wilhelmine",
	  "Will",
	  "Willa",
	  "Willard",
	  "William",
	  "Willie",
	  "Willis",
	  "Willow",
	  "Willy",
	  "Wilma",
	  "Wilmer",
	  "Wilson",
	  "Wilton",
	  "Winfield",
	  "Winifred",
	  "Winnifred",
	  "Winona",
	  "Winston",
	  "Woodrow",
	  "Wyatt",
	  "Wyman",
	  "Xander",
	  "Xavier",
	  "Xzavier",
	  "Yadira",
	  "Yasmeen",
	  "Yasmin",
	  "Yasmine",
	  "Yazmin",
	  "Yesenia",
	  "Yessenia",
	  "Yolanda",
	  "Yoshiko",
	  "Yvette",
	  "Yvonne",
	  "Zachariah",
	  "Zachary",
	  "Zachery",
	  "Zack",
	  "Zackary",
	  "Zackery",
	  "Zakary",
	  "Zander",
	  "Zane",
	  "Zaria",
	  "Zechariah",
	  "Zelda",
	  "Zella",
	  "Zelma",
	  "Zena",
	  "Zetta",
	  "Zion",
	  "Zita",
	  "Zoe",
	  "Zoey",
	  "Zoie",
	  "Zoila",
	  "Zola",
	  "Zora",
	  "Zula"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(524);
	name.last_name = __webpack_require__(526);
	name.prefix = __webpack_require__(528);
	name.suffix = __webpack_require__(529);
	name.title = __webpack_require__(530);
	name.name = __webpack_require__(527);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abbott",
	  "Abernathy",
	  "Abshire",
	  "Adams",
	  "Altenwerth",
	  "Anderson",
	  "Ankunding",
	  "Armstrong",
	  "Auer",
	  "Aufderhar",
	  "Bahringer",
	  "Bailey",
	  "Balistreri",
	  "Barrows",
	  "Bartell",
	  "Bartoletti",
	  "Barton",
	  "Bashirian",
	  "Batz",
	  "Bauch",
	  "Baumbach",
	  "Bayer",
	  "Beahan",
	  "Beatty",
	  "Bechtelar",
	  "Becker",
	  "Bednar",
	  "Beer",
	  "Beier",
	  "Berge",
	  "Bergnaum",
	  "Bergstrom",
	  "Bernhard",
	  "Bernier",
	  "Bins",
	  "Blanda",
	  "Blick",
	  "Block",
	  "Bode",
	  "Boehm",
	  "Bogan",
	  "Bogisich",
	  "Borer",
	  "Bosco",
	  "Botsford",
	  "Boyer",
	  "Boyle",
	  "Bradtke",
	  "Brakus",
	  "Braun",
	  "Breitenberg",
	  "Brekke",
	  "Brown",
	  "Bruen",
	  "Buckridge",
	  "Carroll",
	  "Carter",
	  "Cartwright",
	  "Casper",
	  "Cassin",
	  "Champlin",
	  "Christiansen",
	  "Cole",
	  "Collier",
	  "Collins",
	  "Conn",
	  "Connelly",
	  "Conroy",
	  "Considine",
	  "Corkery",
	  "Cormier",
	  "Corwin",
	  "Cremin",
	  "Crist",
	  "Crona",
	  "Cronin",
	  "Crooks",
	  "Cruickshank",
	  "Cummerata",
	  "Cummings",
	  "Dach",
	  "D'Amore",
	  "Daniel",
	  "Dare",
	  "Daugherty",
	  "Davis",
	  "Deckow",
	  "Denesik",
	  "Dibbert",
	  "Dickens",
	  "Dicki",
	  "Dickinson",
	  "Dietrich",
	  "Donnelly",
	  "Dooley",
	  "Douglas",
	  "Doyle",
	  "DuBuque",
	  "Durgan",
	  "Ebert",
	  "Effertz",
	  "Eichmann",
	  "Emard",
	  "Emmerich",
	  "Erdman",
	  "Ernser",
	  "Fadel",
	  "Fahey",
	  "Farrell",
	  "Fay",
	  "Feeney",
	  "Feest",
	  "Feil",
	  "Ferry",
	  "Fisher",
	  "Flatley",
	  "Frami",
	  "Franecki",
	  "Friesen",
	  "Fritsch",
	  "Funk",
	  "Gaylord",
	  "Gerhold",
	  "Gerlach",
	  "Gibson",
	  "Gislason",
	  "Gleason",
	  "Gleichner",
	  "Glover",
	  "Goldner",
	  "Goodwin",
	  "Gorczany",
	  "Gottlieb",
	  "Goyette",
	  "Grady",
	  "Graham",
	  "Grant",
	  "Green",
	  "Greenfelder",
	  "Greenholt",
	  "Grimes",
	  "Gulgowski",
	  "Gusikowski",
	  "Gutkowski",
	  "Gutmann",
	  "Haag",
	  "Hackett",
	  "Hagenes",
	  "Hahn",
	  "Haley",
	  "Halvorson",
	  "Hamill",
	  "Hammes",
	  "Hand",
	  "Hane",
	  "Hansen",
	  "Harber",
	  "Harris",
	  "Hartmann",
	  "Harvey",
	  "Hauck",
	  "Hayes",
	  "Heaney",
	  "Heathcote",
	  "Hegmann",
	  "Heidenreich",
	  "Heller",
	  "Herman",
	  "Hermann",
	  "Hermiston",
	  "Herzog",
	  "Hessel",
	  "Hettinger",
	  "Hickle",
	  "Hilll",
	  "Hills",
	  "Hilpert",
	  "Hintz",
	  "Hirthe",
	  "Hodkiewicz",
	  "Hoeger",
	  "Homenick",
	  "Hoppe",
	  "Howe",
	  "Howell",
	  "Hudson",
	  "Huel",
	  "Huels",
	  "Hyatt",
	  "Jacobi",
	  "Jacobs",
	  "Jacobson",
	  "Jakubowski",
	  "Jaskolski",
	  "Jast",
	  "Jenkins",
	  "Jerde",
	  "Johns",
	  "Johnson",
	  "Johnston",
	  "Jones",
	  "Kassulke",
	  "Kautzer",
	  "Keebler",
	  "Keeling",
	  "Kemmer",
	  "Kerluke",
	  "Kertzmann",
	  "Kessler",
	  "Kiehn",
	  "Kihn",
	  "Kilback",
	  "King",
	  "Kirlin",
	  "Klein",
	  "Kling",
	  "Klocko",
	  "Koch",
	  "Koelpin",
	  "Koepp",
	  "Kohler",
	  "Konopelski",
	  "Koss",
	  "Kovacek",
	  "Kozey",
	  "Krajcik",
	  "Kreiger",
	  "Kris",
	  "Kshlerin",
	  "Kub",
	  "Kuhic",
	  "Kuhlman",
	  "Kuhn",
	  "Kulas",
	  "Kunde",
	  "Kunze",
	  "Kuphal",
	  "Kutch",
	  "Kuvalis",
	  "Labadie",
	  "Lakin",
	  "Lang",
	  "Langosh",
	  "Langworth",
	  "Larkin",
	  "Larson",
	  "Leannon",
	  "Lebsack",
	  "Ledner",
	  "Leffler",
	  "Legros",
	  "Lehner",
	  "Lemke",
	  "Lesch",
	  "Leuschke",
	  "Lind",
	  "Lindgren",
	  "Littel",
	  "Little",
	  "Lockman",
	  "Lowe",
	  "Lubowitz",
	  "Lueilwitz",
	  "Luettgen",
	  "Lynch",
	  "Macejkovic",
	  "MacGyver",
	  "Maggio",
	  "Mann",
	  "Mante",
	  "Marks",
	  "Marquardt",
	  "Marvin",
	  "Mayer",
	  "Mayert",
	  "McClure",
	  "McCullough",
	  "McDermott",
	  "McGlynn",
	  "McKenzie",
	  "McLaughlin",
	  "Medhurst",
	  "Mertz",
	  "Metz",
	  "Miller",
	  "Mills",
	  "Mitchell",
	  "Moen",
	  "Mohr",
	  "Monahan",
	  "Moore",
	  "Morar",
	  "Morissette",
	  "Mosciski",
	  "Mraz",
	  "Mueller",
	  "Muller",
	  "Murazik",
	  "Murphy",
	  "Murray",
	  "Nader",
	  "Nicolas",
	  "Nienow",
	  "Nikolaus",
	  "Nitzsche",
	  "Nolan",
	  "Oberbrunner",
	  "O'Connell",
	  "O'Conner",
	  "O'Hara",
	  "O'Keefe",
	  "O'Kon",
	  "Okuneva",
	  "Olson",
	  "Ondricka",
	  "O'Reilly",
	  "Orn",
	  "Ortiz",
	  "Osinski",
	  "Pacocha",
	  "Padberg",
	  "Pagac",
	  "Parisian",
	  "Parker",
	  "Paucek",
	  "Pfannerstill",
	  "Pfeffer",
	  "Pollich",
	  "Pouros",
	  "Powlowski",
	  "Predovic",
	  "Price",
	  "Prohaska",
	  "Prosacco",
	  "Purdy",
	  "Quigley",
	  "Quitzon",
	  "Rath",
	  "Ratke",
	  "Rau",
	  "Raynor",
	  "Reichel",
	  "Reichert",
	  "Reilly",
	  "Reinger",
	  "Rempel",
	  "Renner",
	  "Reynolds",
	  "Rice",
	  "Rippin",
	  "Ritchie",
	  "Robel",
	  "Roberts",
	  "Rodriguez",
	  "Rogahn",
	  "Rohan",
	  "Rolfson",
	  "Romaguera",
	  "Roob",
	  "Rosenbaum",
	  "Rowe",
	  "Ruecker",
	  "Runolfsdottir",
	  "Runolfsson",
	  "Runte",
	  "Russel",
	  "Rutherford",
	  "Ryan",
	  "Sanford",
	  "Satterfield",
	  "Sauer",
	  "Sawayn",
	  "Schaden",
	  "Schaefer",
	  "Schamberger",
	  "Schiller",
	  "Schimmel",
	  "Schinner",
	  "Schmeler",
	  "Schmidt",
	  "Schmitt",
	  "Schneider",
	  "Schoen",
	  "Schowalter",
	  "Schroeder",
	  "Schulist",
	  "Schultz",
	  "Schumm",
	  "Schuppe",
	  "Schuster",
	  "Senger",
	  "Shanahan",
	  "Shields",
	  "Simonis",
	  "Sipes",
	  "Skiles",
	  "Smith",
	  "Smitham",
	  "Spencer",
	  "Spinka",
	  "Sporer",
	  "Stamm",
	  "Stanton",
	  "Stark",
	  "Stehr",
	  "Steuber",
	  "Stiedemann",
	  "Stokes",
	  "Stoltenberg",
	  "Stracke",
	  "Streich",
	  "Stroman",
	  "Strosin",
	  "Swaniawski",
	  "Swift",
	  "Terry",
	  "Thiel",
	  "Thompson",
	  "Tillman",
	  "Torp",
	  "Torphy",
	  "Towne",
	  "Toy",
	  "Trantow",
	  "Tremblay",
	  "Treutel",
	  "Tromp",
	  "Turcotte",
	  "Turner",
	  "Ullrich",
	  "Upton",
	  "Vandervort",
	  "Veum",
	  "Volkman",
	  "Von",
	  "VonRueden",
	  "Waelchi",
	  "Walker",
	  "Walsh",
	  "Walter",
	  "Ward",
	  "Waters",
	  "Watsica",
	  "Weber",
	  "Wehner",
	  "Weimann",
	  "Weissnat",
	  "Welch",
	  "West",
	  "White",
	  "Wiegand",
	  "Wilderman",
	  "Wilkinson",
	  "Will",
	  "Williamson",
	  "Willms",
	  "Windler",
	  "Wintheiser",
	  "Wisoky",
	  "Wisozk",
	  "Witting",
	  "Wiza",
	  "Wolf",
	  "Wolff",
	  "Wuckert",
	  "Wunsch",
	  "Wyman",
	  "Yost",
	  "Yundt",
	  "Zboncak",
	  "Zemlak",
	  "Ziemann",
	  "Zieme",
	  "Zulauf"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name} #{suffix}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Mr.",
	  "Mrs.",
	  "Ms.",
	  "Miss",
	  "Dr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Jr.",
	  "Sr.",
	  "I",
	  "II",
	  "III",
	  "IV",
	  "V",
	  "MD",
	  "DDS",
	  "PhD",
	  "DVM"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "Lead",
	    "Senior",
	    "Direct",
	    "Corporate",
	    "Dynamic",
	    "Future",
	    "Product",
	    "National",
	    "Regional",
	    "District",
	    "Central",
	    "Global",
	    "Customer",
	    "Investor",
	    "Dynamic",
	    "International",
	    "Legacy",
	    "Forward",
	    "Internal",
	    "Human",
	    "Chief",
	    "Principal"
	  ],
	  "level": [
	    "Solutions",
	    "Program",
	    "Brand",
	    "Security",
	    "Research",
	    "Marketing",
	    "Directives",
	    "Implementation",
	    "Integration",
	    "Functionality",
	    "Response",
	    "Paradigm",
	    "Tactics",
	    "Identity",
	    "Markets",
	    "Group",
	    "Division",
	    "Applications",
	    "Optimization",
	    "Operations",
	    "Infrastructure",
	    "Intranet",
	    "Communications",
	    "Web",
	    "Branding",
	    "Quality",
	    "Assurance",
	    "Mobility",
	    "Accounts",
	    "Data",
	    "Creative",
	    "Configuration",
	    "Accountability",
	    "Interactions",
	    "Factors",
	    "Usability",
	    "Metrics"
	  ],
	  "job": [
	    "Supervisor",
	    "Associate",
	    "Executive",
	    "Liason",
	    "Officer",
	    "Manager",
	    "Engineer",
	    "Specialist",
	    "Director",
	    "Coordinator",
	    "Administrator",
	    "Architect",
	    "Analyst",
	    "Designer",
	    "Planner",
	    "Orchestrator",
	    "Technician",
	    "Developer",
	    "Producer",
	    "Consultant",
	    "Assistant",
	    "Facilitator",
	    "Agent",
	    "Representative",
	    "Strategist"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###-###-####",
	  "(###) ###-####",
	  "1-###-###-####",
	  "###.###.####",
	  "###-###-####",
	  "(###) ###-####",
	  "1-###-###-####",
	  "###.###.####",
	  "###-###-#### x###",
	  "(###) ###-#### x###",
	  "1-###-###-#### x###",
	  "###.###.#### x###",
	  "###-###-#### x####",
	  "(###) ###-#### x####",
	  "1-###-###-#### x####",
	  "###.###.#### x####",
	  "###-###-#### x#####",
	  "(###) ###-#### x#####",
	  "1-###-###-#### x#####",
	  "###.###.#### x#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(531);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var system = {};
	module['exports'] = system;
	system.mimeTypes = __webpack_require__(534);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*
	
	The MIT License (MIT)
	
	Copyright (c) 2014 Jonathan Ong me@jongleberry.com
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	
	Definitions from mime-db v1.21.0
	For updates check: https://github.com/jshttp/mime-db/blob/master/db.json
	
	*/
	
	module['exports'] = {
	  "application/1d-interleaved-parityfec": {
	    "source": "iana"
	  },
	  "application/3gpdash-qoe-report+xml": {
	    "source": "iana"
	  },
	  "application/3gpp-ims+xml": {
	    "source": "iana"
	  },
	  "application/a2l": {
	    "source": "iana"
	  },
	  "application/activemessage": {
	    "source": "iana"
	  },
	  "application/alto-costmap+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-costmapfilter+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-directory+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-endpointcost+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-endpointcostparams+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-endpointprop+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-endpointpropparams+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-error+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-networkmap+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-networkmapfilter+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/aml": {
	    "source": "iana"
	  },
	  "application/andrew-inset": {
	    "source": "iana",
	    "extensions": ["ez"]
	  },
	  "application/applefile": {
	    "source": "iana"
	  },
	  "application/applixware": {
	    "source": "apache",
	    "extensions": ["aw"]
	  },
	  "application/atf": {
	    "source": "iana"
	  },
	  "application/atfx": {
	    "source": "iana"
	  },
	  "application/atom+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["atom"]
	  },
	  "application/atomcat+xml": {
	    "source": "iana",
	    "extensions": ["atomcat"]
	  },
	  "application/atomdeleted+xml": {
	    "source": "iana"
	  },
	  "application/atomicmail": {
	    "source": "iana"
	  },
	  "application/atomsvc+xml": {
	    "source": "iana",
	    "extensions": ["atomsvc"]
	  },
	  "application/atxml": {
	    "source": "iana"
	  },
	  "application/auth-policy+xml": {
	    "source": "iana"
	  },
	  "application/bacnet-xdd+zip": {
	    "source": "iana"
	  },
	  "application/batch-smtp": {
	    "source": "iana"
	  },
	  "application/bdoc": {
	    "compressible": false,
	    "extensions": ["bdoc"]
	  },
	  "application/beep+xml": {
	    "source": "iana"
	  },
	  "application/calendar+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/calendar+xml": {
	    "source": "iana"
	  },
	  "application/call-completion": {
	    "source": "iana"
	  },
	  "application/cals-1840": {
	    "source": "iana"
	  },
	  "application/cbor": {
	    "source": "iana"
	  },
	  "application/ccmp+xml": {
	    "source": "iana"
	  },
	  "application/ccxml+xml": {
	    "source": "iana",
	    "extensions": ["ccxml"]
	  },
	  "application/cdfx+xml": {
	    "source": "iana"
	  },
	  "application/cdmi-capability": {
	    "source": "iana",
	    "extensions": ["cdmia"]
	  },
	  "application/cdmi-container": {
	    "source": "iana",
	    "extensions": ["cdmic"]
	  },
	  "application/cdmi-domain": {
	    "source": "iana",
	    "extensions": ["cdmid"]
	  },
	  "application/cdmi-object": {
	    "source": "iana",
	    "extensions": ["cdmio"]
	  },
	  "application/cdmi-queue": {
	    "source": "iana",
	    "extensions": ["cdmiq"]
	  },
	  "application/cdni": {
	    "source": "iana"
	  },
	  "application/cea": {
	    "source": "iana"
	  },
	  "application/cea-2018+xml": {
	    "source": "iana"
	  },
	  "application/cellml+xml": {
	    "source": "iana"
	  },
	  "application/cfw": {
	    "source": "iana"
	  },
	  "application/cms": {
	    "source": "iana"
	  },
	  "application/cnrp+xml": {
	    "source": "iana"
	  },
	  "application/coap-group+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/commonground": {
	    "source": "iana"
	  },
	  "application/conference-info+xml": {
	    "source": "iana"
	  },
	  "application/cpl+xml": {
	    "source": "iana"
	  },
	  "application/csrattrs": {
	    "source": "iana"
	  },
	  "application/csta+xml": {
	    "source": "iana"
	  },
	  "application/cstadata+xml": {
	    "source": "iana"
	  },
	  "application/csvm+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/cu-seeme": {
	    "source": "apache",
	    "extensions": ["cu"]
	  },
	  "application/cybercash": {
	    "source": "iana"
	  },
	  "application/dart": {
	    "compressible": true
	  },
	  "application/dash+xml": {
	    "source": "iana",
	    "extensions": ["mdp"]
	  },
	  "application/dashdelta": {
	    "source": "iana"
	  },
	  "application/davmount+xml": {
	    "source": "iana",
	    "extensions": ["davmount"]
	  },
	  "application/dca-rft": {
	    "source": "iana"
	  },
	  "application/dcd": {
	    "source": "iana"
	  },
	  "application/dec-dx": {
	    "source": "iana"
	  },
	  "application/dialog-info+xml": {
	    "source": "iana"
	  },
	  "application/dicom": {
	    "source": "iana"
	  },
	  "application/dii": {
	    "source": "iana"
	  },
	  "application/dit": {
	    "source": "iana"
	  },
	  "application/dns": {
	    "source": "iana"
	  },
	  "application/docbook+xml": {
	    "source": "apache",
	    "extensions": ["dbk"]
	  },
	  "application/dskpp+xml": {
	    "source": "iana"
	  },
	  "application/dssc+der": {
	    "source": "iana",
	    "extensions": ["dssc"]
	  },
	  "application/dssc+xml": {
	    "source": "iana",
	    "extensions": ["xdssc"]
	  },
	  "application/dvcs": {
	    "source": "iana"
	  },
	  "application/ecmascript": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["ecma"]
	  },
	  "application/edi-consent": {
	    "source": "iana"
	  },
	  "application/edi-x12": {
	    "source": "iana",
	    "compressible": false
	  },
	  "application/edifact": {
	    "source": "iana",
	    "compressible": false
	  },
	  "application/emergencycalldata.comment+xml": {
	    "source": "iana"
	  },
	  "application/emergencycalldata.deviceinfo+xml": {
	    "source": "iana"
	  },
	  "application/emergencycalldata.providerinfo+xml": {
	    "source": "iana"
	  },
	  "application/emergencycalldata.serviceinfo+xml": {
	    "source": "iana"
	  },
	  "application/emergencycalldata.subscriberinfo+xml": {
	    "source": "iana"
	  },
	  "application/emma+xml": {
	    "source": "iana",
	    "extensions": ["emma"]
	  },
	  "application/emotionml+xml": {
	    "source": "iana"
	  },
	  "application/encaprtp": {
	    "source": "iana"
	  },
	  "application/epp+xml": {
	    "source": "iana"
	  },
	  "application/epub+zip": {
	    "source": "iana",
	    "extensions": ["epub"]
	  },
	  "application/eshop": {
	    "source": "iana"
	  },
	  "application/exi": {
	    "source": "iana",
	    "extensions": ["exi"]
	  },
	  "application/fastinfoset": {
	    "source": "iana"
	  },
	  "application/fastsoap": {
	    "source": "iana"
	  },
	  "application/fdt+xml": {
	    "source": "iana"
	  },
	  "application/fits": {
	    "source": "iana"
	  },
	  "application/font-sfnt": {
	    "source": "iana"
	  },
	  "application/font-tdpfr": {
	    "source": "iana",
	    "extensions": ["pfr"]
	  },
	  "application/font-woff": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["woff"]
	  },
	  "application/font-woff2": {
	    "compressible": false,
	    "extensions": ["woff2"]
	  },
	  "application/framework-attributes+xml": {
	    "source": "iana"
	  },
	  "application/gml+xml": {
	    "source": "apache",
	    "extensions": ["gml"]
	  },
	  "application/gpx+xml": {
	    "source": "apache",
	    "extensions": ["gpx"]
	  },
	  "application/gxf": {
	    "source": "apache",
	    "extensions": ["gxf"]
	  },
	  "application/gzip": {
	    "source": "iana",
	    "compressible": false
	  },
	  "application/h224": {
	    "source": "iana"
	  },
	  "application/held+xml": {
	    "source": "iana"
	  },
	  "application/http": {
	    "source": "iana"
	  },
	  "application/hyperstudio": {
	    "source": "iana",
	    "extensions": ["stk"]
	  },
	  "application/ibe-key-request+xml": {
	    "source": "iana"
	  },
	  "application/ibe-pkg-reply+xml": {
	    "source": "iana"
	  },
	  "application/ibe-pp-data": {
	    "source": "iana"
	  },
	  "application/iges": {
	    "source": "iana"
	  },
	  "application/im-iscomposing+xml": {
	    "source": "iana"
	  },
	  "application/index": {
	    "source": "iana"
	  },
	  "application/index.cmd": {
	    "source": "iana"
	  },
	  "application/index.obj": {
	    "source": "iana"
	  },
	  "application/index.response": {
	    "source": "iana"
	  },
	  "application/index.vnd": {
	    "source": "iana"
	  },
	  "application/inkml+xml": {
	    "source": "iana",
	    "extensions": ["ink","inkml"]
	  },
	  "application/iotp": {
	    "source": "iana"
	  },
	  "application/ipfix": {
	    "source": "iana",
	    "extensions": ["ipfix"]
	  },
	  "application/ipp": {
	    "source": "iana"
	  },
	  "application/isup": {
	    "source": "iana"
	  },
	  "application/its+xml": {
	    "source": "iana"
	  },
	  "application/java-archive": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["jar","war","ear"]
	  },
	  "application/java-serialized-object": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["ser"]
	  },
	  "application/java-vm": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["class"]
	  },
	  "application/javascript": {
	    "source": "iana",
	    "charset": "UTF-8",
	    "compressible": true,
	    "extensions": ["js"]
	  },
	  "application/jose": {
	    "source": "iana"
	  },
	  "application/jose+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/jrd+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/json": {
	    "source": "iana",
	    "charset": "UTF-8",
	    "compressible": true,
	    "extensions": ["json","map"]
	  },
	  "application/json-patch+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/json-seq": {
	    "source": "iana"
	  },
	  "application/json5": {
	    "extensions": ["json5"]
	  },
	  "application/jsonml+json": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["jsonml"]
	  },
	  "application/jwk+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/jwk-set+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/jwt": {
	    "source": "iana"
	  },
	  "application/kpml-request+xml": {
	    "source": "iana"
	  },
	  "application/kpml-response+xml": {
	    "source": "iana"
	  },
	  "application/ld+json": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["jsonld"]
	  },
	  "application/link-format": {
	    "source": "iana"
	  },
	  "application/load-control+xml": {
	    "source": "iana"
	  },
	  "application/lost+xml": {
	    "source": "iana",
	    "extensions": ["lostxml"]
	  },
	  "application/lostsync+xml": {
	    "source": "iana"
	  },
	  "application/lxf": {
	    "source": "iana"
	  },
	  "application/mac-binhex40": {
	    "source": "iana",
	    "extensions": ["hqx"]
	  },
	  "application/mac-compactpro": {
	    "source": "apache",
	    "extensions": ["cpt"]
	  },
	  "application/macwriteii": {
	    "source": "iana"
	  },
	  "application/mads+xml": {
	    "source": "iana",
	    "extensions": ["mads"]
	  },
	  "application/manifest+json": {
	    "charset": "UTF-8",
	    "compressible": true,
	    "extensions": ["webmanifest"]
	  },
	  "application/marc": {
	    "source": "iana",
	    "extensions": ["mrc"]
	  },
	  "application/marcxml+xml": {
	    "source": "iana",
	    "extensions": ["mrcx"]
	  },
	  "application/mathematica": {
	    "source": "iana",
	    "extensions": ["ma","nb","mb"]
	  },
	  "application/mathml+xml": {
	    "source": "iana",
	    "extensions": ["mathml"]
	  },
	  "application/mathml-content+xml": {
	    "source": "iana"
	  },
	  "application/mathml-presentation+xml": {
	    "source": "iana"
	  },
	  "application/mbms-associated-procedure-description+xml": {
	    "source": "iana"
	  },
	  "application/mbms-deregister+xml": {
	    "source": "iana"
	  },
	  "application/mbms-envelope+xml": {
	    "source": "iana"
	  },
	  "application/mbms-msk+xml": {
	    "source": "iana"
	  },
	  "application/mbms-msk-response+xml": {
	    "source": "iana"
	  },
	  "application/mbms-protection-description+xml": {
	    "source": "iana"
	  },
	  "application/mbms-reception-report+xml": {
	    "source": "iana"
	  },
	  "application/mbms-register+xml": {
	    "source": "iana"
	  },
	  "application/mbms-register-response+xml": {
	    "source": "iana"
	  },
	  "application/mbms-schedule+xml": {
	    "source": "iana"
	  },
	  "application/mbms-user-service-description+xml": {
	    "source": "iana"
	  },
	  "application/mbox": {
	    "source": "iana",
	    "extensions": ["mbox"]
	  },
	  "application/media-policy-dataset+xml": {
	    "source": "iana"
	  },
	  "application/media_control+xml": {
	    "source": "iana"
	  },
	  "application/mediaservercontrol+xml": {
	    "source": "iana",
	    "extensions": ["mscml"]
	  },
	  "application/merge-patch+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/metalink+xml": {
	    "source": "apache",
	    "extensions": ["metalink"]
	  },
	  "application/metalink4+xml": {
	    "source": "iana",
	    "extensions": ["meta4"]
	  },
	  "application/mets+xml": {
	    "source": "iana",
	    "extensions": ["mets"]
	  },
	  "application/mf4": {
	    "source": "iana"
	  },
	  "application/mikey": {
	    "source": "iana"
	  },
	  "application/mods+xml": {
	    "source": "iana",
	    "extensions": ["mods"]
	  },
	  "application/moss-keys": {
	    "source": "iana"
	  },
	  "application/moss-signature": {
	    "source": "iana"
	  },
	  "application/mosskey-data": {
	    "source": "iana"
	  },
	  "application/mosskey-request": {
	    "source": "iana"
	  },
	  "application/mp21": {
	    "source": "iana",
	    "extensions": ["m21","mp21"]
	  },
	  "application/mp4": {
	    "source": "iana",
	    "extensions": ["mp4s","m4p"]
	  },
	  "application/mpeg4-generic": {
	    "source": "iana"
	  },
	  "application/mpeg4-iod": {
	    "source": "iana"
	  },
	  "application/mpeg4-iod-xmt": {
	    "source": "iana"
	  },
	  "application/mrb-consumer+xml": {
	    "source": "iana"
	  },
	  "application/mrb-publish+xml": {
	    "source": "iana"
	  },
	  "application/msc-ivr+xml": {
	    "source": "iana"
	  },
	  "application/msc-mixer+xml": {
	    "source": "iana"
	  },
	  "application/msword": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["doc","dot"]
	  },
	  "application/mxf": {
	    "source": "iana",
	    "extensions": ["mxf"]
	  },
	  "application/nasdata": {
	    "source": "iana"
	  },
	  "application/news-checkgroups": {
	    "source": "iana"
	  },
	  "application/news-groupinfo": {
	    "source": "iana"
	  },
	  "application/news-transmission": {
	    "source": "iana"
	  },
	  "application/nlsml+xml": {
	    "source": "iana"
	  },
	  "application/nss": {
	    "source": "iana"
	  },
	  "application/ocsp-request": {
	    "source": "iana"
	  },
	  "application/ocsp-response": {
	    "source": "iana"
	  },
	  "application/octet-stream": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"]
	  },
	  "application/oda": {
	    "source": "iana",
	    "extensions": ["oda"]
	  },
	  "application/odx": {
	    "source": "iana"
	  },
	  "application/oebps-package+xml": {
	    "source": "iana",
	    "extensions": ["opf"]
	  },
	  "application/ogg": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["ogx"]
	  },
	  "application/omdoc+xml": {
	    "source": "apache",
	    "extensions": ["omdoc"]
	  },
	  "application/onenote": {
	    "source": "apache",
	    "extensions": ["onetoc","onetoc2","onetmp","onepkg"]
	  },
	  "application/oxps": {
	    "source": "iana",
	    "extensions": ["oxps"]
	  },
	  "application/p2p-overlay+xml": {
	    "source": "iana"
	  },
	  "application/parityfec": {
	    "source": "iana"
	  },
	  "application/patch-ops-error+xml": {
	    "source": "iana",
	    "extensions": ["xer"]
	  },
	  "application/pdf": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["pdf"]
	  },
	  "application/pdx": {
	    "source": "iana"
	  },
	  "application/pgp-encrypted": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["pgp"]
	  },
	  "application/pgp-keys": {
	    "source": "iana"
	  },
	  "application/pgp-signature": {
	    "source": "iana",
	    "extensions": ["asc","sig"]
	  },
	  "application/pics-rules": {
	    "source": "apache",
	    "extensions": ["prf"]
	  },
	  "application/pidf+xml": {
	    "source": "iana"
	  },
	  "application/pidf-diff+xml": {
	    "source": "iana"
	  },
	  "application/pkcs10": {
	    "source": "iana",
	    "extensions": ["p10"]
	  },
	  "application/pkcs12": {
	    "source": "iana"
	  },
	  "application/pkcs7-mime": {
	    "source": "iana",
	    "extensions": ["p7m","p7c"]
	  },
	  "application/pkcs7-signature": {
	    "source": "iana",
	    "extensions": ["p7s"]
	  },
	  "application/pkcs8": {
	    "source": "iana",
	    "extensions": ["p8"]
	  },
	  "application/pkix-attr-cert": {
	    "source": "iana",
	    "extensions": ["ac"]
	  },
	  "application/pkix-cert": {
	    "source": "iana",
	    "extensions": ["cer"]
	  },
	  "application/pkix-crl": {
	    "source": "iana",
	    "extensions": ["crl"]
	  },
	  "application/pkix-pkipath": {
	    "source": "iana",
	    "extensions": ["pkipath"]
	  },
	  "application/pkixcmp": {
	    "source": "iana",
	    "extensions": ["pki"]
	  },
	  "application/pls+xml": {
	    "source": "iana",
	    "extensions": ["pls"]
	  },
	  "application/poc-settings+xml": {
	    "source": "iana"
	  },
	  "application/postscript": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["ai","eps","ps"]
	  },
	  "application/provenance+xml": {
	    "source": "iana"
	  },
	  "application/prs.alvestrand.titrax-sheet": {
	    "source": "iana"
	  },
	  "application/prs.cww": {
	    "source": "iana",
	    "extensions": ["cww"]
	  },
	  "application/prs.hpub+zip": {
	    "source": "iana"
	  },
	  "application/prs.nprend": {
	    "source": "iana"
	  },
	  "application/prs.plucker": {
	    "source": "iana"
	  },
	  "application/prs.rdf-xml-crypt": {
	    "source": "iana"
	  },
	  "application/prs.xsf+xml": {
	    "source": "iana"
	  },
	  "application/pskc+xml": {
	    "source": "iana",
	    "extensions": ["pskcxml"]
	  },
	  "application/qsig": {
	    "source": "iana"
	  },
	  "application/raptorfec": {
	    "source": "iana"
	  },
	  "application/rdap+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/rdf+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["rdf"]
	  },
	  "application/reginfo+xml": {
	    "source": "iana",
	    "extensions": ["rif"]
	  },
	  "application/relax-ng-compact-syntax": {
	    "source": "iana",
	    "extensions": ["rnc"]
	  },
	  "application/remote-printing": {
	    "source": "iana"
	  },
	  "application/reputon+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/resource-lists+xml": {
	    "source": "iana",
	    "extensions": ["rl"]
	  },
	  "application/resource-lists-diff+xml": {
	    "source": "iana",
	    "extensions": ["rld"]
	  },
	  "application/rfc+xml": {
	    "source": "iana"
	  },
	  "application/riscos": {
	    "source": "iana"
	  },
	  "application/rlmi+xml": {
	    "source": "iana"
	  },
	  "application/rls-services+xml": {
	    "source": "iana",
	    "extensions": ["rs"]
	  },
	  "application/rpki-ghostbusters": {
	    "source": "iana",
	    "extensions": ["gbr"]
	  },
	  "application/rpki-manifest": {
	    "source": "iana",
	    "extensions": ["mft"]
	  },
	  "application/rpki-roa": {
	    "source": "iana",
	    "extensions": ["roa"]
	  },
	  "application/rpki-updown": {
	    "source": "iana"
	  },
	  "application/rsd+xml": {
	    "source": "apache",
	    "extensions": ["rsd"]
	  },
	  "application/rss+xml": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["rss"]
	  },
	  "application/rtf": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["rtf"]
	  },
	  "application/rtploopback": {
	    "source": "iana"
	  },
	  "application/rtx": {
	    "source": "iana"
	  },
	  "application/samlassertion+xml": {
	    "source": "iana"
	  },
	  "application/samlmetadata+xml": {
	    "source": "iana"
	  },
	  "application/sbml+xml": {
	    "source": "iana",
	    "extensions": ["sbml"]
	  },
	  "application/scaip+xml": {
	    "source": "iana"
	  },
	  "application/scim+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/scvp-cv-request": {
	    "source": "iana",
	    "extensions": ["scq"]
	  },
	  "application/scvp-cv-response": {
	    "source": "iana",
	    "extensions": ["scs"]
	  },
	  "application/scvp-vp-request": {
	    "source": "iana",
	    "extensions": ["spq"]
	  },
	  "application/scvp-vp-response": {
	    "source": "iana",
	    "extensions": ["spp"]
	  },
	  "application/sdp": {
	    "source": "iana",
	    "extensions": ["sdp"]
	  },
	  "application/sep+xml": {
	    "source": "iana"
	  },
	  "application/sep-exi": {
	    "source": "iana"
	  },
	  "application/session-info": {
	    "source": "iana"
	  },
	  "application/set-payment": {
	    "source": "iana"
	  },
	  "application/set-payment-initiation": {
	    "source": "iana",
	    "extensions": ["setpay"]
	  },
	  "application/set-registration": {
	    "source": "iana"
	  },
	  "application/set-registration-initiation": {
	    "source": "iana",
	    "extensions": ["setreg"]
	  },
	  "application/sgml": {
	    "source": "iana"
	  },
	  "application/sgml-open-catalog": {
	    "source": "iana"
	  },
	  "application/shf+xml": {
	    "source": "iana",
	    "extensions": ["shf"]
	  },
	  "application/sieve": {
	    "source": "iana"
	  },
	  "application/simple-filter+xml": {
	    "source": "iana"
	  },
	  "application/simple-message-summary": {
	    "source": "iana"
	  },
	  "application/simplesymbolcontainer": {
	    "source": "iana"
	  },
	  "application/slate": {
	    "source": "iana"
	  },
	  "application/smil": {
	    "source": "iana"
	  },
	  "application/smil+xml": {
	    "source": "iana",
	    "extensions": ["smi","smil"]
	  },
	  "application/smpte336m": {
	    "source": "iana"
	  },
	  "application/soap+fastinfoset": {
	    "source": "iana"
	  },
	  "application/soap+xml": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/sparql-query": {
	    "source": "iana",
	    "extensions": ["rq"]
	  },
	  "application/sparql-results+xml": {
	    "source": "iana",
	    "extensions": ["srx"]
	  },
	  "application/spirits-event+xml": {
	    "source": "iana"
	  },
	  "application/sql": {
	    "source": "iana"
	  },
	  "application/srgs": {
	    "source": "iana",
	    "extensions": ["gram"]
	  },
	  "application/srgs+xml": {
	    "source": "iana",
	    "extensions": ["grxml"]
	  },
	  "application/sru+xml": {
	    "source": "iana",
	    "extensions": ["sru"]
	  },
	  "application/ssdl+xml": {
	    "source": "apache",
	    "extensions": ["ssdl"]
	  },
	  "application/ssml+xml": {
	    "source": "iana",
	    "extensions": ["ssml"]
	  },
	  "application/tamp-apex-update": {
	    "source": "iana"
	  },
	  "application/tamp-apex-update-confirm": {
	    "source": "iana"
	  },
	  "application/tamp-community-update": {
	    "source": "iana"
	  },
	  "application/tamp-community-update-confirm": {
	    "source": "iana"
	  },
	  "application/tamp-error": {
	    "source": "iana"
	  },
	  "application/tamp-sequence-adjust": {
	    "source": "iana"
	  },
	  "application/tamp-sequence-adjust-confirm": {
	    "source": "iana"
	  },
	  "application/tamp-status-query": {
	    "source": "iana"
	  },
	  "application/tamp-status-response": {
	    "source": "iana"
	  },
	  "application/tamp-update": {
	    "source": "iana"
	  },
	  "application/tamp-update-confirm": {
	    "source": "iana"
	  },
	  "application/tar": {
	    "compressible": true
	  },
	  "application/tei+xml": {
	    "source": "iana",
	    "extensions": ["tei","teicorpus"]
	  },
	  "application/thraud+xml": {
	    "source": "iana",
	    "extensions": ["tfi"]
	  },
	  "application/timestamp-query": {
	    "source": "iana"
	  },
	  "application/timestamp-reply": {
	    "source": "iana"
	  },
	  "application/timestamped-data": {
	    "source": "iana",
	    "extensions": ["tsd"]
	  },
	  "application/ttml+xml": {
	    "source": "iana"
	  },
	  "application/tve-trigger": {
	    "source": "iana"
	  },
	  "application/ulpfec": {
	    "source": "iana"
	  },
	  "application/urc-grpsheet+xml": {
	    "source": "iana"
	  },
	  "application/urc-ressheet+xml": {
	    "source": "iana"
	  },
	  "application/urc-targetdesc+xml": {
	    "source": "iana"
	  },
	  "application/urc-uisocketdesc+xml": {
	    "source": "iana"
	  },
	  "application/vcard+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vcard+xml": {
	    "source": "iana"
	  },
	  "application/vemmi": {
	    "source": "iana"
	  },
	  "application/vividence.scriptfile": {
	    "source": "apache"
	  },
	  "application/vnd.3gpp-prose+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp-prose-pc3ch+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.access-transfer-events+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.bsf+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.mid-call+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.pic-bw-large": {
	    "source": "iana",
	    "extensions": ["plb"]
	  },
	  "application/vnd.3gpp.pic-bw-small": {
	    "source": "iana",
	    "extensions": ["psb"]
	  },
	  "application/vnd.3gpp.pic-bw-var": {
	    "source": "iana",
	    "extensions": ["pvb"]
	  },
	  "application/vnd.3gpp.sms": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.srvcc-ext+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.srvcc-info+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.state-and-event-info+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.ussd+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp2.bcmcsinfo+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp2.sms": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp2.tcap": {
	    "source": "iana",
	    "extensions": ["tcap"]
	  },
	  "application/vnd.3m.post-it-notes": {
	    "source": "iana",
	    "extensions": ["pwn"]
	  },
	  "application/vnd.accpac.simply.aso": {
	    "source": "iana",
	    "extensions": ["aso"]
	  },
	  "application/vnd.accpac.simply.imp": {
	    "source": "iana",
	    "extensions": ["imp"]
	  },
	  "application/vnd.acucobol": {
	    "source": "iana",
	    "extensions": ["acu"]
	  },
	  "application/vnd.acucorp": {
	    "source": "iana",
	    "extensions": ["atc","acutc"]
	  },
	  "application/vnd.adobe.air-application-installer-package+zip": {
	    "source": "apache",
	    "extensions": ["air"]
	  },
	  "application/vnd.adobe.flash.movie": {
	    "source": "iana"
	  },
	  "application/vnd.adobe.formscentral.fcdt": {
	    "source": "iana",
	    "extensions": ["fcdt"]
	  },
	  "application/vnd.adobe.fxp": {
	    "source": "iana",
	    "extensions": ["fxp","fxpl"]
	  },
	  "application/vnd.adobe.partial-upload": {
	    "source": "iana"
	  },
	  "application/vnd.adobe.xdp+xml": {
	    "source": "iana",
	    "extensions": ["xdp"]
	  },
	  "application/vnd.adobe.xfdf": {
	    "source": "iana",
	    "extensions": ["xfdf"]
	  },
	  "application/vnd.aether.imp": {
	    "source": "iana"
	  },
	  "application/vnd.ah-barcode": {
	    "source": "iana"
	  },
	  "application/vnd.ahead.space": {
	    "source": "iana",
	    "extensions": ["ahead"]
	  },
	  "application/vnd.airzip.filesecure.azf": {
	    "source": "iana",
	    "extensions": ["azf"]
	  },
	  "application/vnd.airzip.filesecure.azs": {
	    "source": "iana",
	    "extensions": ["azs"]
	  },
	  "application/vnd.amazon.ebook": {
	    "source": "apache",
	    "extensions": ["azw"]
	  },
	  "application/vnd.americandynamics.acc": {
	    "source": "iana",
	    "extensions": ["acc"]
	  },
	  "application/vnd.amiga.ami": {
	    "source": "iana",
	    "extensions": ["ami"]
	  },
	  "application/vnd.amundsen.maze+xml": {
	    "source": "iana"
	  },
	  "application/vnd.android.package-archive": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["apk"]
	  },
	  "application/vnd.anki": {
	    "source": "iana"
	  },
	  "application/vnd.anser-web-certificate-issue-initiation": {
	    "source": "iana",
	    "extensions": ["cii"]
	  },
	  "application/vnd.anser-web-funds-transfer-initiation": {
	    "source": "apache",
	    "extensions": ["fti"]
	  },
	  "application/vnd.antix.game-component": {
	    "source": "iana",
	    "extensions": ["atx"]
	  },
	  "application/vnd.apache.thrift.binary": {
	    "source": "iana"
	  },
	  "application/vnd.apache.thrift.compact": {
	    "source": "iana"
	  },
	  "application/vnd.apache.thrift.json": {
	    "source": "iana"
	  },
	  "application/vnd.api+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.apple.installer+xml": {
	    "source": "iana",
	    "extensions": ["mpkg"]
	  },
	  "application/vnd.apple.mpegurl": {
	    "source": "iana",
	    "extensions": ["m3u8"]
	  },
	  "application/vnd.apple.pkpass": {
	    "compressible": false,
	    "extensions": ["pkpass"]
	  },
	  "application/vnd.arastra.swi": {
	    "source": "iana"
	  },
	  "application/vnd.aristanetworks.swi": {
	    "source": "iana",
	    "extensions": ["swi"]
	  },
	  "application/vnd.artsquare": {
	    "source": "iana"
	  },
	  "application/vnd.astraea-software.iota": {
	    "source": "iana",
	    "extensions": ["iota"]
	  },
	  "application/vnd.audiograph": {
	    "source": "iana",
	    "extensions": ["aep"]
	  },
	  "application/vnd.autopackage": {
	    "source": "iana"
	  },
	  "application/vnd.avistar+xml": {
	    "source": "iana"
	  },
	  "application/vnd.balsamiq.bmml+xml": {
	    "source": "iana"
	  },
	  "application/vnd.balsamiq.bmpr": {
	    "source": "iana"
	  },
	  "application/vnd.bekitzur-stech+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.biopax.rdf+xml": {
	    "source": "iana"
	  },
	  "application/vnd.blueice.multipass": {
	    "source": "iana",
	    "extensions": ["mpm"]
	  },
	  "application/vnd.bluetooth.ep.oob": {
	    "source": "iana"
	  },
	  "application/vnd.bluetooth.le.oob": {
	    "source": "iana"
	  },
	  "application/vnd.bmi": {
	    "source": "iana",
	    "extensions": ["bmi"]
	  },
	  "application/vnd.businessobjects": {
	    "source": "iana",
	    "extensions": ["rep"]
	  },
	  "application/vnd.cab-jscript": {
	    "source": "iana"
	  },
	  "application/vnd.canon-cpdl": {
	    "source": "iana"
	  },
	  "application/vnd.canon-lips": {
	    "source": "iana"
	  },
	  "application/vnd.cendio.thinlinc.clientconf": {
	    "source": "iana"
	  },
	  "application/vnd.century-systems.tcp_stream": {
	    "source": "iana"
	  },
	  "application/vnd.chemdraw+xml": {
	    "source": "iana",
	    "extensions": ["cdxml"]
	  },
	  "application/vnd.chipnuts.karaoke-mmd": {
	    "source": "iana",
	    "extensions": ["mmd"]
	  },
	  "application/vnd.cinderella": {
	    "source": "iana",
	    "extensions": ["cdy"]
	  },
	  "application/vnd.cirpack.isdn-ext": {
	    "source": "iana"
	  },
	  "application/vnd.citationstyles.style+xml": {
	    "source": "iana"
	  },
	  "application/vnd.claymore": {
	    "source": "iana",
	    "extensions": ["cla"]
	  },
	  "application/vnd.cloanto.rp9": {
	    "source": "iana",
	    "extensions": ["rp9"]
	  },
	  "application/vnd.clonk.c4group": {
	    "source": "iana",
	    "extensions": ["c4g","c4d","c4f","c4p","c4u"]
	  },
	  "application/vnd.cluetrust.cartomobile-config": {
	    "source": "iana",
	    "extensions": ["c11amc"]
	  },
	  "application/vnd.cluetrust.cartomobile-config-pkg": {
	    "source": "iana",
	    "extensions": ["c11amz"]
	  },
	  "application/vnd.coffeescript": {
	    "source": "iana"
	  },
	  "application/vnd.collection+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.collection.doc+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.collection.next+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.commerce-battelle": {
	    "source": "iana"
	  },
	  "application/vnd.commonspace": {
	    "source": "iana",
	    "extensions": ["csp"]
	  },
	  "application/vnd.contact.cmsg": {
	    "source": "iana",
	    "extensions": ["cdbcmsg"]
	  },
	  "application/vnd.cosmocaller": {
	    "source": "iana",
	    "extensions": ["cmc"]
	  },
	  "application/vnd.crick.clicker": {
	    "source": "iana",
	    "extensions": ["clkx"]
	  },
	  "application/vnd.crick.clicker.keyboard": {
	    "source": "iana",
	    "extensions": ["clkk"]
	  },
	  "application/vnd.crick.clicker.palette": {
	    "source": "iana",
	    "extensions": ["clkp"]
	  },
	  "application/vnd.crick.clicker.template": {
	    "source": "iana",
	    "extensions": ["clkt"]
	  },
	  "application/vnd.crick.clicker.wordbank": {
	    "source": "iana",
	    "extensions": ["clkw"]
	  },
	  "application/vnd.criticaltools.wbs+xml": {
	    "source": "iana",
	    "extensions": ["wbs"]
	  },
	  "application/vnd.ctc-posml": {
	    "source": "iana",
	    "extensions": ["pml"]
	  },
	  "application/vnd.ctct.ws+xml": {
	    "source": "iana"
	  },
	  "application/vnd.cups-pdf": {
	    "source": "iana"
	  },
	  "application/vnd.cups-postscript": {
	    "source": "iana"
	  },
	  "application/vnd.cups-ppd": {
	    "source": "iana",
	    "extensions": ["ppd"]
	  },
	  "application/vnd.cups-raster": {
	    "source": "iana"
	  },
	  "application/vnd.cups-raw": {
	    "source": "iana"
	  },
	  "application/vnd.curl": {
	    "source": "iana"
	  },
	  "application/vnd.curl.car": {
	    "source": "apache",
	    "extensions": ["car"]
	  },
	  "application/vnd.curl.pcurl": {
	    "source": "apache",
	    "extensions": ["pcurl"]
	  },
	  "application/vnd.cyan.dean.root+xml": {
	    "source": "iana"
	  },
	  "application/vnd.cybank": {
	    "source": "iana"
	  },
	  "application/vnd.dart": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["dart"]
	  },
	  "application/vnd.data-vision.rdz": {
	    "source": "iana",
	    "extensions": ["rdz"]
	  },
	  "application/vnd.debian.binary-package": {
	    "source": "iana"
	  },
	  "application/vnd.dece.data": {
	    "source": "iana",
	    "extensions": ["uvf","uvvf","uvd","uvvd"]
	  },
	  "application/vnd.dece.ttml+xml": {
	    "source": "iana",
	    "extensions": ["uvt","uvvt"]
	  },
	  "application/vnd.dece.unspecified": {
	    "source": "iana",
	    "extensions": ["uvx","uvvx"]
	  },
	  "application/vnd.dece.zip": {
	    "source": "iana",
	    "extensions": ["uvz","uvvz"]
	  },
	  "application/vnd.denovo.fcselayout-link": {
	    "source": "iana",
	    "extensions": ["fe_launch"]
	  },
	  "application/vnd.desmume-movie": {
	    "source": "iana"
	  },
	  "application/vnd.dir-bi.plate-dl-nosuffix": {
	    "source": "iana"
	  },
	  "application/vnd.dm.delegation+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dna": {
	    "source": "iana",
	    "extensions": ["dna"]
	  },
	  "application/vnd.document+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.dolby.mlp": {
	    "source": "apache",
	    "extensions": ["mlp"]
	  },
	  "application/vnd.dolby.mobile.1": {
	    "source": "iana"
	  },
	  "application/vnd.dolby.mobile.2": {
	    "source": "iana"
	  },
	  "application/vnd.doremir.scorecloud-binary-document": {
	    "source": "iana"
	  },
	  "application/vnd.dpgraph": {
	    "source": "iana",
	    "extensions": ["dpg"]
	  },
	  "application/vnd.dreamfactory": {
	    "source": "iana",
	    "extensions": ["dfac"]
	  },
	  "application/vnd.drive+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.ds-keypoint": {
	    "source": "apache",
	    "extensions": ["kpxx"]
	  },
	  "application/vnd.dtg.local": {
	    "source": "iana"
	  },
	  "application/vnd.dtg.local.flash": {
	    "source": "iana"
	  },
	  "application/vnd.dtg.local.html": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.ait": {
	    "source": "iana",
	    "extensions": ["ait"]
	  },
	  "application/vnd.dvb.dvbj": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.esgcontainer": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.ipdcdftnotifaccess": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.ipdcesgaccess": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.ipdcesgaccess2": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.ipdcesgpdd": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.ipdcroaming": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.iptv.alfec-base": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.iptv.alfec-enhancement": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-aggregate-root+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-container+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-generic+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-ia-msglist+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-ia-registration-request+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-ia-registration-response+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-init+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.pfr": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.service": {
	    "source": "iana",
	    "extensions": ["svc"]
	  },
	  "application/vnd.dxr": {
	    "source": "iana"
	  },
	  "application/vnd.dynageo": {
	    "source": "iana",
	    "extensions": ["geo"]
	  },
	  "application/vnd.dzr": {
	    "source": "iana"
	  },
	  "application/vnd.easykaraoke.cdgdownload": {
	    "source": "iana"
	  },
	  "application/vnd.ecdis-update": {
	    "source": "iana"
	  },
	  "application/vnd.ecowin.chart": {
	    "source": "iana",
	    "extensions": ["mag"]
	  },
	  "application/vnd.ecowin.filerequest": {
	    "source": "iana"
	  },
	  "application/vnd.ecowin.fileupdate": {
	    "source": "iana"
	  },
	  "application/vnd.ecowin.series": {
	    "source": "iana"
	  },
	  "application/vnd.ecowin.seriesrequest": {
	    "source": "iana"
	  },
	  "application/vnd.ecowin.seriesupdate": {
	    "source": "iana"
	  },
	  "application/vnd.emclient.accessrequest+xml": {
	    "source": "iana"
	  },
	  "application/vnd.enliven": {
	    "source": "iana",
	    "extensions": ["nml"]
	  },
	  "application/vnd.enphase.envoy": {
	    "source": "iana"
	  },
	  "application/vnd.eprints.data+xml": {
	    "source": "iana"
	  },
	  "application/vnd.epson.esf": {
	    "source": "iana",
	    "extensions": ["esf"]
	  },
	  "application/vnd.epson.msf": {
	    "source": "iana",
	    "extensions": ["msf"]
	  },
	  "application/vnd.epson.quickanime": {
	    "source": "iana",
	    "extensions": ["qam"]
	  },
	  "application/vnd.epson.salt": {
	    "source": "iana",
	    "extensions": ["slt"]
	  },
	  "application/vnd.epson.ssf": {
	    "source": "iana",
	    "extensions": ["ssf"]
	  },
	  "application/vnd.ericsson.quickcall": {
	    "source": "iana"
	  },
	  "application/vnd.eszigno3+xml": {
	    "source": "iana",
	    "extensions": ["es3","et3"]
	  },
	  "application/vnd.etsi.aoc+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.asic-e+zip": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.asic-s+zip": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.cug+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvcommand+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvdiscovery+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvprofile+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvsad-bc+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvsad-cod+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvsad-npvr+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvservice+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvsync+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvueprofile+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.mcid+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.mheg5": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.overload-control-policy-dataset+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.pstn+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.sci+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.simservs+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.timestamp-token": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.tsl+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.tsl.der": {
	    "source": "iana"
	  },
	  "application/vnd.eudora.data": {
	    "source": "iana"
	  },
	  "application/vnd.ezpix-album": {
	    "source": "iana",
	    "extensions": ["ez2"]
	  },
	  "application/vnd.ezpix-package": {
	    "source": "iana",
	    "extensions": ["ez3"]
	  },
	  "application/vnd.f-secure.mobile": {
	    "source": "iana"
	  },
	  "application/vnd.fastcopy-disk-image": {
	    "source": "iana"
	  },
	  "application/vnd.fdf": {
	    "source": "iana",
	    "extensions": ["fdf"]
	  },
	  "application/vnd.fdsn.mseed": {
	    "source": "iana",
	    "extensions": ["mseed"]
	  },
	  "application/vnd.fdsn.seed": {
	    "source": "iana",
	    "extensions": ["seed","dataless"]
	  },
	  "application/vnd.ffsns": {
	    "source": "iana"
	  },
	  "application/vnd.filmit.zfc": {
	    "source": "iana"
	  },
	  "application/vnd.fints": {
	    "source": "iana"
	  },
	  "application/vnd.firemonkeys.cloudcell": {
	    "source": "iana"
	  },
	  "application/vnd.flographit": {
	    "source": "iana",
	    "extensions": ["gph"]
	  },
	  "application/vnd.fluxtime.clip": {
	    "source": "iana",
	    "extensions": ["ftc"]
	  },
	  "application/vnd.font-fontforge-sfd": {
	    "source": "iana"
	  },
	  "application/vnd.framemaker": {
	    "source": "iana",
	    "extensions": ["fm","frame","maker","book"]
	  },
	  "application/vnd.frogans.fnc": {
	    "source": "iana",
	    "extensions": ["fnc"]
	  },
	  "application/vnd.frogans.ltf": {
	    "source": "iana",
	    "extensions": ["ltf"]
	  },
	  "application/vnd.fsc.weblaunch": {
	    "source": "iana",
	    "extensions": ["fsc"]
	  },
	  "application/vnd.fujitsu.oasys": {
	    "source": "iana",
	    "extensions": ["oas"]
	  },
	  "application/vnd.fujitsu.oasys2": {
	    "source": "iana",
	    "extensions": ["oa2"]
	  },
	  "application/vnd.fujitsu.oasys3": {
	    "source": "iana",
	    "extensions": ["oa3"]
	  },
	  "application/vnd.fujitsu.oasysgp": {
	    "source": "iana",
	    "extensions": ["fg5"]
	  },
	  "application/vnd.fujitsu.oasysprs": {
	    "source": "iana",
	    "extensions": ["bh2"]
	  },
	  "application/vnd.fujixerox.art-ex": {
	    "source": "iana"
	  },
	  "application/vnd.fujixerox.art4": {
	    "source": "iana"
	  },
	  "application/vnd.fujixerox.ddd": {
	    "source": "iana",
	    "extensions": ["ddd"]
	  },
	  "application/vnd.fujixerox.docuworks": {
	    "source": "iana",
	    "extensions": ["xdw"]
	  },
	  "application/vnd.fujixerox.docuworks.binder": {
	    "source": "iana",
	    "extensions": ["xbd"]
	  },
	  "application/vnd.fujixerox.docuworks.container": {
	    "source": "iana"
	  },
	  "application/vnd.fujixerox.hbpl": {
	    "source": "iana"
	  },
	  "application/vnd.fut-misnet": {
	    "source": "iana"
	  },
	  "application/vnd.fuzzysheet": {
	    "source": "iana",
	    "extensions": ["fzs"]
	  },
	  "application/vnd.genomatix.tuxedo": {
	    "source": "iana",
	    "extensions": ["txd"]
	  },
	  "application/vnd.geo+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.geocube+xml": {
	    "source": "iana"
	  },
	  "application/vnd.geogebra.file": {
	    "source": "iana",
	    "extensions": ["ggb"]
	  },
	  "application/vnd.geogebra.tool": {
	    "source": "iana",
	    "extensions": ["ggt"]
	  },
	  "application/vnd.geometry-explorer": {
	    "source": "iana",
	    "extensions": ["gex","gre"]
	  },
	  "application/vnd.geonext": {
	    "source": "iana",
	    "extensions": ["gxt"]
	  },
	  "application/vnd.geoplan": {
	    "source": "iana",
	    "extensions": ["g2w"]
	  },
	  "application/vnd.geospace": {
	    "source": "iana",
	    "extensions": ["g3w"]
	  },
	  "application/vnd.gerber": {
	    "source": "iana"
	  },
	  "application/vnd.globalplatform.card-content-mgt": {
	    "source": "iana"
	  },
	  "application/vnd.globalplatform.card-content-mgt-response": {
	    "source": "iana"
	  },
	  "application/vnd.gmx": {
	    "source": "iana",
	    "extensions": ["gmx"]
	  },
	  "application/vnd.google-apps.document": {
	    "compressible": false,
	    "extensions": ["gdoc"]
	  },
	  "application/vnd.google-apps.presentation": {
	    "compressible": false,
	    "extensions": ["gslides"]
	  },
	  "application/vnd.google-apps.spreadsheet": {
	    "compressible": false,
	    "extensions": ["gsheet"]
	  },
	  "application/vnd.google-earth.kml+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["kml"]
	  },
	  "application/vnd.google-earth.kmz": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["kmz"]
	  },
	  "application/vnd.gov.sk.e-form+xml": {
	    "source": "iana"
	  },
	  "application/vnd.gov.sk.e-form+zip": {
	    "source": "iana"
	  },
	  "application/vnd.gov.sk.xmldatacontainer+xml": {
	    "source": "iana"
	  },
	  "application/vnd.grafeq": {
	    "source": "iana",
	    "extensions": ["gqf","gqs"]
	  },
	  "application/vnd.gridmp": {
	    "source": "iana"
	  },
	  "application/vnd.groove-account": {
	    "source": "iana",
	    "extensions": ["gac"]
	  },
	  "application/vnd.groove-help": {
	    "source": "iana",
	    "extensions": ["ghf"]
	  },
	  "application/vnd.groove-identity-message": {
	    "source": "iana",
	    "extensions": ["gim"]
	  },
	  "application/vnd.groove-injector": {
	    "source": "iana",
	    "extensions": ["grv"]
	  },
	  "application/vnd.groove-tool-message": {
	    "source": "iana",
	    "extensions": ["gtm"]
	  },
	  "application/vnd.groove-tool-template": {
	    "source": "iana",
	    "extensions": ["tpl"]
	  },
	  "application/vnd.groove-vcard": {
	    "source": "iana",
	    "extensions": ["vcg"]
	  },
	  "application/vnd.hal+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.hal+xml": {
	    "source": "iana",
	    "extensions": ["hal"]
	  },
	  "application/vnd.handheld-entertainment+xml": {
	    "source": "iana",
	    "extensions": ["zmm"]
	  },
	  "application/vnd.hbci": {
	    "source": "iana",
	    "extensions": ["hbci"]
	  },
	  "application/vnd.hcl-bireports": {
	    "source": "iana"
	  },
	  "application/vnd.heroku+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.hhe.lesson-player": {
	    "source": "iana",
	    "extensions": ["les"]
	  },
	  "application/vnd.hp-hpgl": {
	    "source": "iana",
	    "extensions": ["hpgl"]
	  },
	  "application/vnd.hp-hpid": {
	    "source": "iana",
	    "extensions": ["hpid"]
	  },
	  "application/vnd.hp-hps": {
	    "source": "iana",
	    "extensions": ["hps"]
	  },
	  "application/vnd.hp-jlyt": {
	    "source": "iana",
	    "extensions": ["jlt"]
	  },
	  "application/vnd.hp-pcl": {
	    "source": "iana",
	    "extensions": ["pcl"]
	  },
	  "application/vnd.hp-pclxl": {
	    "source": "iana",
	    "extensions": ["pclxl"]
	  },
	  "application/vnd.httphone": {
	    "source": "iana"
	  },
	  "application/vnd.hydrostatix.sof-data": {
	    "source": "iana",
	    "extensions": ["sfd-hdstx"]
	  },
	  "application/vnd.hyperdrive+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.hzn-3d-crossword": {
	    "source": "iana"
	  },
	  "application/vnd.ibm.afplinedata": {
	    "source": "iana"
	  },
	  "application/vnd.ibm.electronic-media": {
	    "source": "iana"
	  },
	  "application/vnd.ibm.minipay": {
	    "source": "iana",
	    "extensions": ["mpy"]
	  },
	  "application/vnd.ibm.modcap": {
	    "source": "iana",
	    "extensions": ["afp","listafp","list3820"]
	  },
	  "application/vnd.ibm.rights-management": {
	    "source": "iana",
	    "extensions": ["irm"]
	  },
	  "application/vnd.ibm.secure-container": {
	    "source": "iana",
	    "extensions": ["sc"]
	  },
	  "application/vnd.iccprofile": {
	    "source": "iana",
	    "extensions": ["icc","icm"]
	  },
	  "application/vnd.ieee.1905": {
	    "source": "iana"
	  },
	  "application/vnd.igloader": {
	    "source": "iana",
	    "extensions": ["igl"]
	  },
	  "application/vnd.immervision-ivp": {
	    "source": "iana",
	    "extensions": ["ivp"]
	  },
	  "application/vnd.immervision-ivu": {
	    "source": "iana",
	    "extensions": ["ivu"]
	  },
	  "application/vnd.ims.imsccv1p1": {
	    "source": "iana"
	  },
	  "application/vnd.ims.imsccv1p2": {
	    "source": "iana"
	  },
	  "application/vnd.ims.imsccv1p3": {
	    "source": "iana"
	  },
	  "application/vnd.ims.lis.v2.result+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.ims.lti.v2.toolconsumerprofile+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.ims.lti.v2.toolproxy+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.ims.lti.v2.toolproxy.id+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.ims.lti.v2.toolsettings+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.ims.lti.v2.toolsettings.simple+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.informedcontrol.rms+xml": {
	    "source": "iana"
	  },
	  "application/vnd.informix-visionary": {
	    "source": "iana"
	  },
	  "application/vnd.infotech.project": {
	    "source": "iana"
	  },
	  "application/vnd.infotech.project+xml": {
	    "source": "iana"
	  },
	  "application/vnd.innopath.wamp.notification": {
	    "source": "iana"
	  },
	  "application/vnd.insors.igm": {
	    "source": "iana",
	    "extensions": ["igm"]
	  },
	  "application/vnd.intercon.formnet": {
	    "source": "iana",
	    "extensions": ["xpw","xpx"]
	  },
	  "application/vnd.intergeo": {
	    "source": "iana",
	    "extensions": ["i2g"]
	  },
	  "application/vnd.intertrust.digibox": {
	    "source": "iana"
	  },
	  "application/vnd.intertrust.nncp": {
	    "source": "iana"
	  },
	  "application/vnd.intu.qbo": {
	    "source": "iana",
	    "extensions": ["qbo"]
	  },
	  "application/vnd.intu.qfx": {
	    "source": "iana",
	    "extensions": ["qfx"]
	  },
	  "application/vnd.iptc.g2.catalogitem+xml": {
	    "source": "iana"
	  },
	  "application/vnd.iptc.g2.conceptitem+xml": {
	    "source": "iana"
	  },
	  "application/vnd.iptc.g2.knowledgeitem+xml": {
	    "source": "iana"
	  },
	  "application/vnd.iptc.g2.newsitem+xml": {
	    "source": "iana"
	  },
	  "application/vnd.iptc.g2.newsmessage+xml": {
	    "source": "iana"
	  },
	  "application/vnd.iptc.g2.packageitem+xml": {
	    "source": "iana"
	  },
	  "application/vnd.iptc.g2.planningitem+xml": {
	    "source": "iana"
	  },
	  "application/vnd.ipunplugged.rcprofile": {
	    "source": "iana",
	    "extensions": ["rcprofile"]
	  },
	  "application/vnd.irepository.package+xml": {
	    "source": "iana",
	    "extensions": ["irp"]
	  },
	  "application/vnd.is-xpr": {
	    "source": "iana",
	    "extensions": ["xpr"]
	  },
	  "application/vnd.isac.fcs": {
	    "source": "iana",
	    "extensions": ["fcs"]
	  },
	  "application/vnd.jam": {
	    "source": "iana",
	    "extensions": ["jam"]
	  },
	  "application/vnd.japannet-directory-service": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-jpnstore-wakeup": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-payment-wakeup": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-registration": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-registration-wakeup": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-setstore-wakeup": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-verification": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-verification-wakeup": {
	    "source": "iana"
	  },
	  "application/vnd.jcp.javame.midlet-rms": {
	    "source": "iana",
	    "extensions": ["rms"]
	  },
	  "application/vnd.jisp": {
	    "source": "iana",
	    "extensions": ["jisp"]
	  },
	  "application/vnd.joost.joda-archive": {
	    "source": "iana",
	    "extensions": ["joda"]
	  },
	  "application/vnd.jsk.isdn-ngn": {
	    "source": "iana"
	  },
	  "application/vnd.kahootz": {
	    "source": "iana",
	    "extensions": ["ktz","ktr"]
	  },
	  "application/vnd.kde.karbon": {
	    "source": "iana",
	    "extensions": ["karbon"]
	  },
	  "application/vnd.kde.kchart": {
	    "source": "iana",
	    "extensions": ["chrt"]
	  },
	  "application/vnd.kde.kformula": {
	    "source": "iana",
	    "extensions": ["kfo"]
	  },
	  "application/vnd.kde.kivio": {
	    "source": "iana",
	    "extensions": ["flw"]
	  },
	  "application/vnd.kde.kontour": {
	    "source": "iana",
	    "extensions": ["kon"]
	  },
	  "application/vnd.kde.kpresenter": {
	    "source": "iana",
	    "extensions": ["kpr","kpt"]
	  },
	  "application/vnd.kde.kspread": {
	    "source": "iana",
	    "extensions": ["ksp"]
	  },
	  "application/vnd.kde.kword": {
	    "source": "iana",
	    "extensions": ["kwd","kwt"]
	  },
	  "application/vnd.kenameaapp": {
	    "source": "iana",
	    "extensions": ["htke"]
	  },
	  "application/vnd.kidspiration": {
	    "source": "iana",
	    "extensions": ["kia"]
	  },
	  "application/vnd.kinar": {
	    "source": "iana",
	    "extensions": ["kne","knp"]
	  },
	  "application/vnd.koan": {
	    "source": "iana",
	    "extensions": ["skp","skd","skt","skm"]
	  },
	  "application/vnd.kodak-descriptor": {
	    "source": "iana",
	    "extensions": ["sse"]
	  },
	  "application/vnd.las.las+xml": {
	    "source": "iana",
	    "extensions": ["lasxml"]
	  },
	  "application/vnd.liberty-request+xml": {
	    "source": "iana"
	  },
	  "application/vnd.llamagraphics.life-balance.desktop": {
	    "source": "iana",
	    "extensions": ["lbd"]
	  },
	  "application/vnd.llamagraphics.life-balance.exchange+xml": {
	    "source": "iana",
	    "extensions": ["lbe"]
	  },
	  "application/vnd.lotus-1-2-3": {
	    "source": "iana",
	    "extensions": ["123"]
	  },
	  "application/vnd.lotus-approach": {
	    "source": "iana",
	    "extensions": ["apr"]
	  },
	  "application/vnd.lotus-freelance": {
	    "source": "iana",
	    "extensions": ["pre"]
	  },
	  "application/vnd.lotus-notes": {
	    "source": "iana",
	    "extensions": ["nsf"]
	  },
	  "application/vnd.lotus-organizer": {
	    "source": "iana",
	    "extensions": ["org"]
	  },
	  "application/vnd.lotus-screencam": {
	    "source": "iana",
	    "extensions": ["scm"]
	  },
	  "application/vnd.lotus-wordpro": {
	    "source": "iana",
	    "extensions": ["lwp"]
	  },
	  "application/vnd.macports.portpkg": {
	    "source": "iana",
	    "extensions": ["portpkg"]
	  },
	  "application/vnd.mapbox-vector-tile": {
	    "source": "iana"
	  },
	  "application/vnd.marlin.drm.actiontoken+xml": {
	    "source": "iana"
	  },
	  "application/vnd.marlin.drm.conftoken+xml": {
	    "source": "iana"
	  },
	  "application/vnd.marlin.drm.license+xml": {
	    "source": "iana"
	  },
	  "application/vnd.marlin.drm.mdcf": {
	    "source": "iana"
	  },
	  "application/vnd.mason+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.maxmind.maxmind-db": {
	    "source": "iana"
	  },
	  "application/vnd.mcd": {
	    "source": "iana",
	    "extensions": ["mcd"]
	  },
	  "application/vnd.medcalcdata": {
	    "source": "iana",
	    "extensions": ["mc1"]
	  },
	  "application/vnd.mediastation.cdkey": {
	    "source": "iana",
	    "extensions": ["cdkey"]
	  },
	  "application/vnd.meridian-slingshot": {
	    "source": "iana"
	  },
	  "application/vnd.mfer": {
	    "source": "iana",
	    "extensions": ["mwf"]
	  },
	  "application/vnd.mfmp": {
	    "source": "iana",
	    "extensions": ["mfm"]
	  },
	  "application/vnd.micro+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.micrografx.flo": {
	    "source": "iana",
	    "extensions": ["flo"]
	  },
	  "application/vnd.micrografx.igx": {
	    "source": "iana",
	    "extensions": ["igx"]
	  },
	  "application/vnd.microsoft.portable-executable": {
	    "source": "iana"
	  },
	  "application/vnd.miele+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.mif": {
	    "source": "iana",
	    "extensions": ["mif"]
	  },
	  "application/vnd.minisoft-hp3000-save": {
	    "source": "iana"
	  },
	  "application/vnd.mitsubishi.misty-guard.trustweb": {
	    "source": "iana"
	  },
	  "application/vnd.mobius.daf": {
	    "source": "iana",
	    "extensions": ["daf"]
	  },
	  "application/vnd.mobius.dis": {
	    "source": "iana",
	    "extensions": ["dis"]
	  },
	  "application/vnd.mobius.mbk": {
	    "source": "iana",
	    "extensions": ["mbk"]
	  },
	  "application/vnd.mobius.mqy": {
	    "source": "iana",
	    "extensions": ["mqy"]
	  },
	  "application/vnd.mobius.msl": {
	    "source": "iana",
	    "extensions": ["msl"]
	  },
	  "application/vnd.mobius.plc": {
	    "source": "iana",
	    "extensions": ["plc"]
	  },
	  "application/vnd.mobius.txf": {
	    "source": "iana",
	    "extensions": ["txf"]
	  },
	  "application/vnd.mophun.application": {
	    "source": "iana",
	    "extensions": ["mpn"]
	  },
	  "application/vnd.mophun.certificate": {
	    "source": "iana",
	    "extensions": ["mpc"]
	  },
	  "application/vnd.motorola.flexsuite": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.flexsuite.adsi": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.flexsuite.fis": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.flexsuite.gotap": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.flexsuite.kmr": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.flexsuite.ttc": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.flexsuite.wem": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.iprm": {
	    "source": "iana"
	  },
	  "application/vnd.mozilla.xul+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["xul"]
	  },
	  "application/vnd.ms-3mfdocument": {
	    "source": "iana"
	  },
	  "application/vnd.ms-artgalry": {
	    "source": "iana",
	    "extensions": ["cil"]
	  },
	  "application/vnd.ms-asf": {
	    "source": "iana"
	  },
	  "application/vnd.ms-cab-compressed": {
	    "source": "iana",
	    "extensions": ["cab"]
	  },
	  "application/vnd.ms-color.iccprofile": {
	    "source": "apache"
	  },
	  "application/vnd.ms-excel": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["xls","xlm","xla","xlc","xlt","xlw"]
	  },
	  "application/vnd.ms-excel.addin.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["xlam"]
	  },
	  "application/vnd.ms-excel.sheet.binary.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["xlsb"]
	  },
	  "application/vnd.ms-excel.sheet.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["xlsm"]
	  },
	  "application/vnd.ms-excel.template.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["xltm"]
	  },
	  "application/vnd.ms-fontobject": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["eot"]
	  },
	  "application/vnd.ms-htmlhelp": {
	    "source": "iana",
	    "extensions": ["chm"]
	  },
	  "application/vnd.ms-ims": {
	    "source": "iana",
	    "extensions": ["ims"]
	  },
	  "application/vnd.ms-lrm": {
	    "source": "iana",
	    "extensions": ["lrm"]
	  },
	  "application/vnd.ms-office.activex+xml": {
	    "source": "iana"
	  },
	  "application/vnd.ms-officetheme": {
	    "source": "iana",
	    "extensions": ["thmx"]
	  },
	  "application/vnd.ms-opentype": {
	    "source": "apache",
	    "compressible": true
	  },
	  "application/vnd.ms-package.obfuscated-opentype": {
	    "source": "apache"
	  },
	  "application/vnd.ms-pki.seccat": {
	    "source": "apache",
	    "extensions": ["cat"]
	  },
	  "application/vnd.ms-pki.stl": {
	    "source": "apache",
	    "extensions": ["stl"]
	  },
	  "application/vnd.ms-playready.initiator+xml": {
	    "source": "iana"
	  },
	  "application/vnd.ms-powerpoint": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["ppt","pps","pot"]
	  },
	  "application/vnd.ms-powerpoint.addin.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["ppam"]
	  },
	  "application/vnd.ms-powerpoint.presentation.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["pptm"]
	  },
	  "application/vnd.ms-powerpoint.slide.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["sldm"]
	  },
	  "application/vnd.ms-powerpoint.slideshow.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["ppsm"]
	  },
	  "application/vnd.ms-powerpoint.template.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["potm"]
	  },
	  "application/vnd.ms-printdevicecapabilities+xml": {
	    "source": "iana"
	  },
	  "application/vnd.ms-printing.printticket+xml": {
	    "source": "apache"
	  },
	  "application/vnd.ms-project": {
	    "source": "iana",
	    "extensions": ["mpp","mpt"]
	  },
	  "application/vnd.ms-tnef": {
	    "source": "iana"
	  },
	  "application/vnd.ms-windows.devicepairing": {
	    "source": "iana"
	  },
	  "application/vnd.ms-windows.nwprinting.oob": {
	    "source": "iana"
	  },
	  "application/vnd.ms-windows.printerpairing": {
	    "source": "iana"
	  },
	  "application/vnd.ms-windows.wsd.oob": {
	    "source": "iana"
	  },
	  "application/vnd.ms-wmdrm.lic-chlg-req": {
	    "source": "iana"
	  },
	  "application/vnd.ms-wmdrm.lic-resp": {
	    "source": "iana"
	  },
	  "application/vnd.ms-wmdrm.meter-chlg-req": {
	    "source": "iana"
	  },
	  "application/vnd.ms-wmdrm.meter-resp": {
	    "source": "iana"
	  },
	  "application/vnd.ms-word.document.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["docm"]
	  },
	  "application/vnd.ms-word.template.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["dotm"]
	  },
	  "application/vnd.ms-works": {
	    "source": "iana",
	    "extensions": ["wps","wks","wcm","wdb"]
	  },
	  "application/vnd.ms-wpl": {
	    "source": "iana",
	    "extensions": ["wpl"]
	  },
	  "application/vnd.ms-xpsdocument": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["xps"]
	  },
	  "application/vnd.msa-disk-image": {
	    "source": "iana"
	  },
	  "application/vnd.mseq": {
	    "source": "iana",
	    "extensions": ["mseq"]
	  },
	  "application/vnd.msign": {
	    "source": "iana"
	  },
	  "application/vnd.multiad.creator": {
	    "source": "iana"
	  },
	  "application/vnd.multiad.creator.cif": {
	    "source": "iana"
	  },
	  "application/vnd.music-niff": {
	    "source": "iana"
	  },
	  "application/vnd.musician": {
	    "source": "iana",
	    "extensions": ["mus"]
	  },
	  "application/vnd.muvee.style": {
	    "source": "iana",
	    "extensions": ["msty"]
	  },
	  "application/vnd.mynfc": {
	    "source": "iana",
	    "extensions": ["taglet"]
	  },
	  "application/vnd.ncd.control": {
	    "source": "iana"
	  },
	  "application/vnd.ncd.reference": {
	    "source": "iana"
	  },
	  "application/vnd.nervana": {
	    "source": "iana"
	  },
	  "application/vnd.netfpx": {
	    "source": "iana"
	  },
	  "application/vnd.neurolanguage.nlu": {
	    "source": "iana",
	    "extensions": ["nlu"]
	  },
	  "application/vnd.nintendo.nitro.rom": {
	    "source": "iana"
	  },
	  "application/vnd.nintendo.snes.rom": {
	    "source": "iana"
	  },
	  "application/vnd.nitf": {
	    "source": "iana",
	    "extensions": ["ntf","nitf"]
	  },
	  "application/vnd.noblenet-directory": {
	    "source": "iana",
	    "extensions": ["nnd"]
	  },
	  "application/vnd.noblenet-sealer": {
	    "source": "iana",
	    "extensions": ["nns"]
	  },
	  "application/vnd.noblenet-web": {
	    "source": "iana",
	    "extensions": ["nnw"]
	  },
	  "application/vnd.nokia.catalogs": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.conml+wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.conml+xml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.iptv.config+xml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.isds-radio-presets": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.landmark+wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.landmark+xml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.landmarkcollection+xml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.n-gage.ac+xml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.n-gage.data": {
	    "source": "iana",
	    "extensions": ["ngdat"]
	  },
	  "application/vnd.nokia.n-gage.symbian.install": {
	    "source": "iana",
	    "extensions": ["n-gage"]
	  },
	  "application/vnd.nokia.ncd": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.pcd+wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.pcd+xml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.radio-preset": {
	    "source": "iana",
	    "extensions": ["rpst"]
	  },
	  "application/vnd.nokia.radio-presets": {
	    "source": "iana",
	    "extensions": ["rpss"]
	  },
	  "application/vnd.novadigm.edm": {
	    "source": "iana",
	    "extensions": ["edm"]
	  },
	  "application/vnd.novadigm.edx": {
	    "source": "iana",
	    "extensions": ["edx"]
	  },
	  "application/vnd.novadigm.ext": {
	    "source": "iana",
	    "extensions": ["ext"]
	  },
	  "application/vnd.ntt-local.content-share": {
	    "source": "iana"
	  },
	  "application/vnd.ntt-local.file-transfer": {
	    "source": "iana"
	  },
	  "application/vnd.ntt-local.ogw_remote-access": {
	    "source": "iana"
	  },
	  "application/vnd.ntt-local.sip-ta_remote": {
	    "source": "iana"
	  },
	  "application/vnd.ntt-local.sip-ta_tcp_stream": {
	    "source": "iana"
	  },
	  "application/vnd.oasis.opendocument.chart": {
	    "source": "iana",
	    "extensions": ["odc"]
	  },
	  "application/vnd.oasis.opendocument.chart-template": {
	    "source": "iana",
	    "extensions": ["otc"]
	  },
	  "application/vnd.oasis.opendocument.database": {
	    "source": "iana",
	    "extensions": ["odb"]
	  },
	  "application/vnd.oasis.opendocument.formula": {
	    "source": "iana",
	    "extensions": ["odf"]
	  },
	  "application/vnd.oasis.opendocument.formula-template": {
	    "source": "iana",
	    "extensions": ["odft"]
	  },
	  "application/vnd.oasis.opendocument.graphics": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["odg"]
	  },
	  "application/vnd.oasis.opendocument.graphics-template": {
	    "source": "iana",
	    "extensions": ["otg"]
	  },
	  "application/vnd.oasis.opendocument.image": {
	    "source": "iana",
	    "extensions": ["odi"]
	  },
	  "application/vnd.oasis.opendocument.image-template": {
	    "source": "iana",
	    "extensions": ["oti"]
	  },
	  "application/vnd.oasis.opendocument.presentation": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["odp"]
	  },
	  "application/vnd.oasis.opendocument.presentation-template": {
	    "source": "iana",
	    "extensions": ["otp"]
	  },
	  "application/vnd.oasis.opendocument.spreadsheet": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["ods"]
	  },
	  "application/vnd.oasis.opendocument.spreadsheet-template": {
	    "source": "iana",
	    "extensions": ["ots"]
	  },
	  "application/vnd.oasis.opendocument.text": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["odt"]
	  },
	  "application/vnd.oasis.opendocument.text-master": {
	    "source": "iana",
	    "extensions": ["odm"]
	  },
	  "application/vnd.oasis.opendocument.text-template": {
	    "source": "iana",
	    "extensions": ["ott"]
	  },
	  "application/vnd.oasis.opendocument.text-web": {
	    "source": "iana",
	    "extensions": ["oth"]
	  },
	  "application/vnd.obn": {
	    "source": "iana"
	  },
	  "application/vnd.oftn.l10n+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.oipf.contentaccessdownload+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.contentaccessstreaming+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.cspg-hexbinary": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.dae.svg+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.dae.xhtml+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.mippvcontrolmessage+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.pae.gem": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.spdiscovery+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.spdlist+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.ueprofile+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.userprofile+xml": {
	    "source": "iana"
	  },
	  "application/vnd.olpc-sugar": {
	    "source": "iana",
	    "extensions": ["xo"]
	  },
	  "application/vnd.oma-scws-config": {
	    "source": "iana"
	  },
	  "application/vnd.oma-scws-http-request": {
	    "source": "iana"
	  },
	  "application/vnd.oma-scws-http-response": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.associated-procedure-parameter+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.drm-trigger+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.imd+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.ltkm": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.notification+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.provisioningtrigger": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.sgboot": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.sgdd+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.sgdu": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.simple-symbol-container": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.smartcard-trigger+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.sprov+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.stkm": {
	    "source": "iana"
	  },
	  "application/vnd.oma.cab-address-book+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.cab-feature-handler+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.cab-pcc+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.cab-subs-invite+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.cab-user-prefs+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.dcd": {
	    "source": "iana"
	  },
	  "application/vnd.oma.dcdc": {
	    "source": "iana"
	  },
	  "application/vnd.oma.dd2+xml": {
	    "source": "iana",
	    "extensions": ["dd2"]
	  },
	  "application/vnd.oma.drm.risd+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.group-usage-list+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.pal+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.poc.detailed-progress-report+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.poc.final-report+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.poc.groups+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.poc.invocation-descriptor+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.poc.optimized-progress-report+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.push": {
	    "source": "iana"
	  },
	  "application/vnd.oma.scidm.messages+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.xcap-directory+xml": {
	    "source": "iana"
	  },
	  "application/vnd.omads-email+xml": {
	    "source": "iana"
	  },
	  "application/vnd.omads-file+xml": {
	    "source": "iana"
	  },
	  "application/vnd.omads-folder+xml": {
	    "source": "iana"
	  },
	  "application/vnd.omaloc-supl-init": {
	    "source": "iana"
	  },
	  "application/vnd.openblox.game+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openblox.game-binary": {
	    "source": "iana"
	  },
	  "application/vnd.openeye.oeb": {
	    "source": "iana"
	  },
	  "application/vnd.openofficeorg.extension": {
	    "source": "apache",
	    "extensions": ["oxt"]
	  },
	  "application/vnd.openxmlformats-officedocument.custom-properties+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.customxmlproperties+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawing+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.extended-properties+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml-template": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.comments+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["pptx"]
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.presprops+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slide": {
	    "source": "iana",
	    "extensions": ["sldx"]
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slide+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slideshow": {
	    "source": "iana",
	    "extensions": ["ppsx"]
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.tags+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.template": {
	    "source": "apache",
	    "extensions": ["potx"]
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.template.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml-template": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["xlsx"]
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": {
	    "source": "apache",
	    "extensions": ["xltx"]
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.theme+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.themeoverride+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.vmldrawing": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml-template": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["docx"]
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": {
	    "source": "apache",
	    "extensions": ["dotx"]
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-package.core-properties+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-package.relationships+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oracle.resource+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.orange.indata": {
	    "source": "iana"
	  },
	  "application/vnd.osa.netdeploy": {
	    "source": "iana"
	  },
	  "application/vnd.osgeo.mapguide.package": {
	    "source": "iana",
	    "extensions": ["mgp"]
	  },
	  "application/vnd.osgi.bundle": {
	    "source": "iana"
	  },
	  "application/vnd.osgi.dp": {
	    "source": "iana",
	    "extensions": ["dp"]
	  },
	  "application/vnd.osgi.subsystem": {
	    "source": "iana",
	    "extensions": ["esa"]
	  },
	  "application/vnd.otps.ct-kip+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oxli.countgraph": {
	    "source": "iana"
	  },
	  "application/vnd.pagerduty+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.palm": {
	    "source": "iana",
	    "extensions": ["pdb","pqa","oprc"]
	  },
	  "application/vnd.panoply": {
	    "source": "iana"
	  },
	  "application/vnd.paos+xml": {
	    "source": "iana"
	  },
	  "application/vnd.paos.xml": {
	    "source": "apache"
	  },
	  "application/vnd.pawaafile": {
	    "source": "iana",
	    "extensions": ["paw"]
	  },
	  "application/vnd.pcos": {
	    "source": "iana"
	  },
	  "application/vnd.pg.format": {
	    "source": "iana",
	    "extensions": ["str"]
	  },
	  "application/vnd.pg.osasli": {
	    "source": "iana",
	    "extensions": ["ei6"]
	  },
	  "application/vnd.piaccess.application-licence": {
	    "source": "iana"
	  },
	  "application/vnd.picsel": {
	    "source": "iana",
	    "extensions": ["efif"]
	  },
	  "application/vnd.pmi.widget": {
	    "source": "iana",
	    "extensions": ["wg"]
	  },
	  "application/vnd.poc.group-advertisement+xml": {
	    "source": "iana"
	  },
	  "application/vnd.pocketlearn": {
	    "source": "iana",
	    "extensions": ["plf"]
	  },
	  "application/vnd.powerbuilder6": {
	    "source": "iana",
	    "extensions": ["pbd"]
	  },
	  "application/vnd.powerbuilder6-s": {
	    "source": "iana"
	  },
	  "application/vnd.powerbuilder7": {
	    "source": "iana"
	  },
	  "application/vnd.powerbuilder7-s": {
	    "source": "iana"
	  },
	  "application/vnd.powerbuilder75": {
	    "source": "iana"
	  },
	  "application/vnd.powerbuilder75-s": {
	    "source": "iana"
	  },
	  "application/vnd.preminet": {
	    "source": "iana"
	  },
	  "application/vnd.previewsystems.box": {
	    "source": "iana",
	    "extensions": ["box"]
	  },
	  "application/vnd.proteus.magazine": {
	    "source": "iana",
	    "extensions": ["mgz"]
	  },
	  "application/vnd.publishare-delta-tree": {
	    "source": "iana",
	    "extensions": ["qps"]
	  },
	  "application/vnd.pvi.ptid1": {
	    "source": "iana",
	    "extensions": ["ptid"]
	  },
	  "application/vnd.pwg-multiplexed": {
	    "source": "iana"
	  },
	  "application/vnd.pwg-xhtml-print+xml": {
	    "source": "iana"
	  },
	  "application/vnd.qualcomm.brew-app-res": {
	    "source": "iana"
	  },
	  "application/vnd.quark.quarkxpress": {
	    "source": "iana",
	    "extensions": ["qxd","qxt","qwd","qwt","qxl","qxb"]
	  },
	  "application/vnd.quobject-quoxdocument": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.moml+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-audit+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-audit-conf+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-audit-conn+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-audit-dialog+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-audit-stream+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-conf+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog-base+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog-fax-detect+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog-fax-sendrecv+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog-group+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog-speech+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog-transform+xml": {
	    "source": "iana"
	  },
	  "application/vnd.rainstor.data": {
	    "source": "iana"
	  },
	  "application/vnd.rapid": {
	    "source": "iana"
	  },
	  "application/vnd.realvnc.bed": {
	    "source": "iana",
	    "extensions": ["bed"]
	  },
	  "application/vnd.recordare.musicxml": {
	    "source": "iana",
	    "extensions": ["mxl"]
	  },
	  "application/vnd.recordare.musicxml+xml": {
	    "source": "iana",
	    "extensions": ["musicxml"]
	  },
	  "application/vnd.renlearn.rlprint": {
	    "source": "iana"
	  },
	  "application/vnd.rig.cryptonote": {
	    "source": "iana",
	    "extensions": ["cryptonote"]
	  },
	  "application/vnd.rim.cod": {
	    "source": "apache",
	    "extensions": ["cod"]
	  },
	  "application/vnd.rn-realmedia": {
	    "source": "apache",
	    "extensions": ["rm"]
	  },
	  "application/vnd.rn-realmedia-vbr": {
	    "source": "apache",
	    "extensions": ["rmvb"]
	  },
	  "application/vnd.route66.link66+xml": {
	    "source": "iana",
	    "extensions": ["link66"]
	  },
	  "application/vnd.rs-274x": {
	    "source": "iana"
	  },
	  "application/vnd.ruckus.download": {
	    "source": "iana"
	  },
	  "application/vnd.s3sms": {
	    "source": "iana"
	  },
	  "application/vnd.sailingtracker.track": {
	    "source": "iana",
	    "extensions": ["st"]
	  },
	  "application/vnd.sbm.cid": {
	    "source": "iana"
	  },
	  "application/vnd.sbm.mid2": {
	    "source": "iana"
	  },
	  "application/vnd.scribus": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.3df": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.csf": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.doc": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.eml": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.mht": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.net": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.ppt": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.tiff": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.xls": {
	    "source": "iana"
	  },
	  "application/vnd.sealedmedia.softseal.html": {
	    "source": "iana"
	  },
	  "application/vnd.sealedmedia.softseal.pdf": {
	    "source": "iana"
	  },
	  "application/vnd.seemail": {
	    "source": "iana",
	    "extensions": ["see"]
	  },
	  "application/vnd.sema": {
	    "source": "iana",
	    "extensions": ["sema"]
	  },
	  "application/vnd.semd": {
	    "source": "iana",
	    "extensions": ["semd"]
	  },
	  "application/vnd.semf": {
	    "source": "iana",
	    "extensions": ["semf"]
	  },
	  "application/vnd.shana.informed.formdata": {
	    "source": "iana",
	    "extensions": ["ifm"]
	  },
	  "application/vnd.shana.informed.formtemplate": {
	    "source": "iana",
	    "extensions": ["itp"]
	  },
	  "application/vnd.shana.informed.interchange": {
	    "source": "iana",
	    "extensions": ["iif"]
	  },
	  "application/vnd.shana.informed.package": {
	    "source": "iana",
	    "extensions": ["ipk"]
	  },
	  "application/vnd.simtech-mindmapper": {
	    "source": "iana",
	    "extensions": ["twd","twds"]
	  },
	  "application/vnd.siren+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.smaf": {
	    "source": "iana",
	    "extensions": ["mmf"]
	  },
	  "application/vnd.smart.notebook": {
	    "source": "iana"
	  },
	  "application/vnd.smart.teacher": {
	    "source": "iana",
	    "extensions": ["teacher"]
	  },
	  "application/vnd.software602.filler.form+xml": {
	    "source": "iana"
	  },
	  "application/vnd.software602.filler.form-xml-zip": {
	    "source": "iana"
	  },
	  "application/vnd.solent.sdkm+xml": {
	    "source": "iana",
	    "extensions": ["sdkm","sdkd"]
	  },
	  "application/vnd.spotfire.dxp": {
	    "source": "iana",
	    "extensions": ["dxp"]
	  },
	  "application/vnd.spotfire.sfs": {
	    "source": "iana",
	    "extensions": ["sfs"]
	  },
	  "application/vnd.sss-cod": {
	    "source": "iana"
	  },
	  "application/vnd.sss-dtf": {
	    "source": "iana"
	  },
	  "application/vnd.sss-ntf": {
	    "source": "iana"
	  },
	  "application/vnd.stardivision.calc": {
	    "source": "apache",
	    "extensions": ["sdc"]
	  },
	  "application/vnd.stardivision.draw": {
	    "source": "apache",
	    "extensions": ["sda"]
	  },
	  "application/vnd.stardivision.impress": {
	    "source": "apache",
	    "extensions": ["sdd"]
	  },
	  "application/vnd.stardivision.math": {
	    "source": "apache",
	    "extensions": ["smf"]
	  },
	  "application/vnd.stardivision.writer": {
	    "source": "apache",
	    "extensions": ["sdw","vor"]
	  },
	  "application/vnd.stardivision.writer-global": {
	    "source": "apache",
	    "extensions": ["sgl"]
	  },
	  "application/vnd.stepmania.package": {
	    "source": "iana",
	    "extensions": ["smzip"]
	  },
	  "application/vnd.stepmania.stepchart": {
	    "source": "iana",
	    "extensions": ["sm"]
	  },
	  "application/vnd.street-stream": {
	    "source": "iana"
	  },
	  "application/vnd.sun.wadl+xml": {
	    "source": "iana"
	  },
	  "application/vnd.sun.xml.calc": {
	    "source": "apache",
	    "extensions": ["sxc"]
	  },
	  "application/vnd.sun.xml.calc.template": {
	    "source": "apache",
	    "extensions": ["stc"]
	  },
	  "application/vnd.sun.xml.draw": {
	    "source": "apache",
	    "extensions": ["sxd"]
	  },
	  "application/vnd.sun.xml.draw.template": {
	    "source": "apache",
	    "extensions": ["std"]
	  },
	  "application/vnd.sun.xml.impress": {
	    "source": "apache",
	    "extensions": ["sxi"]
	  },
	  "application/vnd.sun.xml.impress.template": {
	    "source": "apache",
	    "extensions": ["sti"]
	  },
	  "application/vnd.sun.xml.math": {
	    "source": "apache",
	    "extensions": ["sxm"]
	  },
	  "application/vnd.sun.xml.writer": {
	    "source": "apache",
	    "extensions": ["sxw"]
	  },
	  "application/vnd.sun.xml.writer.global": {
	    "source": "apache",
	    "extensions": ["sxg"]
	  },
	  "application/vnd.sun.xml.writer.template": {
	    "source": "apache",
	    "extensions": ["stw"]
	  },
	  "application/vnd.sus-calendar": {
	    "source": "iana",
	    "extensions": ["sus","susp"]
	  },
	  "application/vnd.svd": {
	    "source": "iana",
	    "extensions": ["svd"]
	  },
	  "application/vnd.swiftview-ics": {
	    "source": "iana"
	  },
	  "application/vnd.symbian.install": {
	    "source": "apache",
	    "extensions": ["sis","sisx"]
	  },
	  "application/vnd.syncml+xml": {
	    "source": "iana",
	    "extensions": ["xsm"]
	  },
	  "application/vnd.syncml.dm+wbxml": {
	    "source": "iana",
	    "extensions": ["bdm"]
	  },
	  "application/vnd.syncml.dm+xml": {
	    "source": "iana",
	    "extensions": ["xdm"]
	  },
	  "application/vnd.syncml.dm.notification": {
	    "source": "iana"
	  },
	  "application/vnd.syncml.dmddf+wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.syncml.dmddf+xml": {
	    "source": "iana"
	  },
	  "application/vnd.syncml.dmtnds+wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.syncml.dmtnds+xml": {
	    "source": "iana"
	  },
	  "application/vnd.syncml.ds.notification": {
	    "source": "iana"
	  },
	  "application/vnd.tao.intent-module-archive": {
	    "source": "iana",
	    "extensions": ["tao"]
	  },
	  "application/vnd.tcpdump.pcap": {
	    "source": "iana",
	    "extensions": ["pcap","cap","dmp"]
	  },
	  "application/vnd.tmd.mediaflex.api+xml": {
	    "source": "iana"
	  },
	  "application/vnd.tml": {
	    "source": "iana"
	  },
	  "application/vnd.tmobile-livetv": {
	    "source": "iana",
	    "extensions": ["tmo"]
	  },
	  "application/vnd.trid.tpt": {
	    "source": "iana",
	    "extensions": ["tpt"]
	  },
	  "application/vnd.triscape.mxs": {
	    "source": "iana",
	    "extensions": ["mxs"]
	  },
	  "application/vnd.trueapp": {
	    "source": "iana",
	    "extensions": ["tra"]
	  },
	  "application/vnd.truedoc": {
	    "source": "iana"
	  },
	  "application/vnd.ubisoft.webplayer": {
	    "source": "iana"
	  },
	  "application/vnd.ufdl": {
	    "source": "iana",
	    "extensions": ["ufd","ufdl"]
	  },
	  "application/vnd.uiq.theme": {
	    "source": "iana",
	    "extensions": ["utz"]
	  },
	  "application/vnd.umajin": {
	    "source": "iana",
	    "extensions": ["umj"]
	  },
	  "application/vnd.unity": {
	    "source": "iana",
	    "extensions": ["unityweb"]
	  },
	  "application/vnd.uoml+xml": {
	    "source": "iana",
	    "extensions": ["uoml"]
	  },
	  "application/vnd.uplanet.alert": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.alert-wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.bearer-choice": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.bearer-choice-wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.cacheop": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.cacheop-wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.channel": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.channel-wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.list": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.list-wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.listcmd": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.listcmd-wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.signal": {
	    "source": "iana"
	  },
	  "application/vnd.uri-map": {
	    "source": "iana"
	  },
	  "application/vnd.valve.source.material": {
	    "source": "iana"
	  },
	  "application/vnd.vcx": {
	    "source": "iana",
	    "extensions": ["vcx"]
	  },
	  "application/vnd.vd-study": {
	    "source": "iana"
	  },
	  "application/vnd.vectorworks": {
	    "source": "iana"
	  },
	  "application/vnd.verimatrix.vcas": {
	    "source": "iana"
	  },
	  "application/vnd.vidsoft.vidconference": {
	    "source": "iana"
	  },
	  "application/vnd.visio": {
	    "source": "iana",
	    "extensions": ["vsd","vst","vss","vsw"]
	  },
	  "application/vnd.visionary": {
	    "source": "iana",
	    "extensions": ["vis"]
	  },
	  "application/vnd.vividence.scriptfile": {
	    "source": "iana"
	  },
	  "application/vnd.vsf": {
	    "source": "iana",
	    "extensions": ["vsf"]
	  },
	  "application/vnd.wap.sic": {
	    "source": "iana"
	  },
	  "application/vnd.wap.slc": {
	    "source": "iana"
	  },
	  "application/vnd.wap.wbxml": {
	    "source": "iana",
	    "extensions": ["wbxml"]
	  },
	  "application/vnd.wap.wmlc": {
	    "source": "iana",
	    "extensions": ["wmlc"]
	  },
	  "application/vnd.wap.wmlscriptc": {
	    "source": "iana",
	    "extensions": ["wmlsc"]
	  },
	  "application/vnd.webturbo": {
	    "source": "iana",
	    "extensions": ["wtb"]
	  },
	  "application/vnd.wfa.p2p": {
	    "source": "iana"
	  },
	  "application/vnd.wfa.wsc": {
	    "source": "iana"
	  },
	  "application/vnd.windows.devicepairing": {
	    "source": "iana"
	  },
	  "application/vnd.wmc": {
	    "source": "iana"
	  },
	  "application/vnd.wmf.bootstrap": {
	    "source": "iana"
	  },
	  "application/vnd.wolfram.mathematica": {
	    "source": "iana"
	  },
	  "application/vnd.wolfram.mathematica.package": {
	    "source": "iana"
	  },
	  "application/vnd.wolfram.player": {
	    "source": "iana",
	    "extensions": ["nbp"]
	  },
	  "application/vnd.wordperfect": {
	    "source": "iana",
	    "extensions": ["wpd"]
	  },
	  "application/vnd.wqd": {
	    "source": "iana",
	    "extensions": ["wqd"]
	  },
	  "application/vnd.wrq-hp3000-labelled": {
	    "source": "iana"
	  },
	  "application/vnd.wt.stf": {
	    "source": "iana",
	    "extensions": ["stf"]
	  },
	  "application/vnd.wv.csp+wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.wv.csp+xml": {
	    "source": "iana"
	  },
	  "application/vnd.wv.ssp+xml": {
	    "source": "iana"
	  },
	  "application/vnd.xacml+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.xara": {
	    "source": "iana",
	    "extensions": ["xar"]
	  },
	  "application/vnd.xfdl": {
	    "source": "iana",
	    "extensions": ["xfdl"]
	  },
	  "application/vnd.xfdl.webform": {
	    "source": "iana"
	  },
	  "application/vnd.xmi+xml": {
	    "source": "iana"
	  },
	  "application/vnd.xmpie.cpkg": {
	    "source": "iana"
	  },
	  "application/vnd.xmpie.dpkg": {
	    "source": "iana"
	  },
	  "application/vnd.xmpie.plan": {
	    "source": "iana"
	  },
	  "application/vnd.xmpie.ppkg": {
	    "source": "iana"
	  },
	  "application/vnd.xmpie.xlim": {
	    "source": "iana"
	  },
	  "application/vnd.yamaha.hv-dic": {
	    "source": "iana",
	    "extensions": ["hvd"]
	  },
	  "application/vnd.yamaha.hv-script": {
	    "source": "iana",
	    "extensions": ["hvs"]
	  },
	  "application/vnd.yamaha.hv-voice": {
	    "source": "iana",
	    "extensions": ["hvp"]
	  },
	  "application/vnd.yamaha.openscoreformat": {
	    "source": "iana",
	    "extensions": ["osf"]
	  },
	  "application/vnd.yamaha.openscoreformat.osfpvg+xml": {
	    "source": "iana",
	    "extensions": ["osfpvg"]
	  },
	  "application/vnd.yamaha.remote-setup": {
	    "source": "iana"
	  },
	  "application/vnd.yamaha.smaf-audio": {
	    "source": "iana",
	    "extensions": ["saf"]
	  },
	  "application/vnd.yamaha.smaf-phrase": {
	    "source": "iana",
	    "extensions": ["spf"]
	  },
	  "application/vnd.yamaha.through-ngn": {
	    "source": "iana"
	  },
	  "application/vnd.yamaha.tunnel-udpencap": {
	    "source": "iana"
	  },
	  "application/vnd.yaoweme": {
	    "source": "iana"
	  },
	  "application/vnd.yellowriver-custom-menu": {
	    "source": "iana",
	    "extensions": ["cmp"]
	  },
	  "application/vnd.zul": {
	    "source": "iana",
	    "extensions": ["zir","zirz"]
	  },
	  "application/vnd.zzazz.deck+xml": {
	    "source": "iana",
	    "extensions": ["zaz"]
	  },
	  "application/voicexml+xml": {
	    "source": "iana",
	    "extensions": ["vxml"]
	  },
	  "application/vq-rtcpxr": {
	    "source": "iana"
	  },
	  "application/watcherinfo+xml": {
	    "source": "iana"
	  },
	  "application/whoispp-query": {
	    "source": "iana"
	  },
	  "application/whoispp-response": {
	    "source": "iana"
	  },
	  "application/widget": {
	    "source": "iana",
	    "extensions": ["wgt"]
	  },
	  "application/winhlp": {
	    "source": "apache",
	    "extensions": ["hlp"]
	  },
	  "application/wita": {
	    "source": "iana"
	  },
	  "application/wordperfect5.1": {
	    "source": "iana"
	  },
	  "application/wsdl+xml": {
	    "source": "iana",
	    "extensions": ["wsdl"]
	  },
	  "application/wspolicy+xml": {
	    "source": "iana",
	    "extensions": ["wspolicy"]
	  },
	  "application/x-7z-compressed": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["7z"]
	  },
	  "application/x-abiword": {
	    "source": "apache",
	    "extensions": ["abw"]
	  },
	  "application/x-ace-compressed": {
	    "source": "apache",
	    "extensions": ["ace"]
	  },
	  "application/x-amf": {
	    "source": "apache"
	  },
	  "application/x-apple-diskimage": {
	    "source": "apache",
	    "extensions": ["dmg"]
	  },
	  "application/x-authorware-bin": {
	    "source": "apache",
	    "extensions": ["aab","x32","u32","vox"]
	  },
	  "application/x-authorware-map": {
	    "source": "apache",
	    "extensions": ["aam"]
	  },
	  "application/x-authorware-seg": {
	    "source": "apache",
	    "extensions": ["aas"]
	  },
	  "application/x-bcpio": {
	    "source": "apache",
	    "extensions": ["bcpio"]
	  },
	  "application/x-bdoc": {
	    "compressible": false,
	    "extensions": ["bdoc"]
	  },
	  "application/x-bittorrent": {
	    "source": "apache",
	    "extensions": ["torrent"]
	  },
	  "application/x-blorb": {
	    "source": "apache",
	    "extensions": ["blb","blorb"]
	  },
	  "application/x-bzip": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["bz"]
	  },
	  "application/x-bzip2": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["bz2","boz"]
	  },
	  "application/x-cbr": {
	    "source": "apache",
	    "extensions": ["cbr","cba","cbt","cbz","cb7"]
	  },
	  "application/x-cdlink": {
	    "source": "apache",
	    "extensions": ["vcd"]
	  },
	  "application/x-cfs-compressed": {
	    "source": "apache",
	    "extensions": ["cfs"]
	  },
	  "application/x-chat": {
	    "source": "apache",
	    "extensions": ["chat"]
	  },
	  "application/x-chess-pgn": {
	    "source": "apache",
	    "extensions": ["pgn"]
	  },
	  "application/x-chrome-extension": {
	    "extensions": ["crx"]
	  },
	  "application/x-cocoa": {
	    "source": "nginx",
	    "extensions": ["cco"]
	  },
	  "application/x-compress": {
	    "source": "apache"
	  },
	  "application/x-conference": {
	    "source": "apache",
	    "extensions": ["nsc"]
	  },
	  "application/x-cpio": {
	    "source": "apache",
	    "extensions": ["cpio"]
	  },
	  "application/x-csh": {
	    "source": "apache",
	    "extensions": ["csh"]
	  },
	  "application/x-deb": {
	    "compressible": false
	  },
	  "application/x-debian-package": {
	    "source": "apache",
	    "extensions": ["deb","udeb"]
	  },
	  "application/x-dgc-compressed": {
	    "source": "apache",
	    "extensions": ["dgc"]
	  },
	  "application/x-director": {
	    "source": "apache",
	    "extensions": ["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"]
	  },
	  "application/x-doom": {
	    "source": "apache",
	    "extensions": ["wad"]
	  },
	  "application/x-dtbncx+xml": {
	    "source": "apache",
	    "extensions": ["ncx"]
	  },
	  "application/x-dtbook+xml": {
	    "source": "apache",
	    "extensions": ["dtb"]
	  },
	  "application/x-dtbresource+xml": {
	    "source": "apache",
	    "extensions": ["res"]
	  },
	  "application/x-dvi": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["dvi"]
	  },
	  "application/x-envoy": {
	    "source": "apache",
	    "extensions": ["evy"]
	  },
	  "application/x-eva": {
	    "source": "apache",
	    "extensions": ["eva"]
	  },
	  "application/x-font-bdf": {
	    "source": "apache",
	    "extensions": ["bdf"]
	  },
	  "application/x-font-dos": {
	    "source": "apache"
	  },
	  "application/x-font-framemaker": {
	    "source": "apache"
	  },
	  "application/x-font-ghostscript": {
	    "source": "apache",
	    "extensions": ["gsf"]
	  },
	  "application/x-font-libgrx": {
	    "source": "apache"
	  },
	  "application/x-font-linux-psf": {
	    "source": "apache",
	    "extensions": ["psf"]
	  },
	  "application/x-font-otf": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["otf"]
	  },
	  "application/x-font-pcf": {
	    "source": "apache",
	    "extensions": ["pcf"]
	  },
	  "application/x-font-snf": {
	    "source": "apache",
	    "extensions": ["snf"]
	  },
	  "application/x-font-speedo": {
	    "source": "apache"
	  },
	  "application/x-font-sunos-news": {
	    "source": "apache"
	  },
	  "application/x-font-ttf": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["ttf","ttc"]
	  },
	  "application/x-font-type1": {
	    "source": "apache",
	    "extensions": ["pfa","pfb","pfm","afm"]
	  },
	  "application/x-font-vfont": {
	    "source": "apache"
	  },
	  "application/x-freearc": {
	    "source": "apache",
	    "extensions": ["arc"]
	  },
	  "application/x-futuresplash": {
	    "source": "apache",
	    "extensions": ["spl"]
	  },
	  "application/x-gca-compressed": {
	    "source": "apache",
	    "extensions": ["gca"]
	  },
	  "application/x-glulx": {
	    "source": "apache",
	    "extensions": ["ulx"]
	  },
	  "application/x-gnumeric": {
	    "source": "apache",
	    "extensions": ["gnumeric"]
	  },
	  "application/x-gramps-xml": {
	    "source": "apache",
	    "extensions": ["gramps"]
	  },
	  "application/x-gtar": {
	    "source": "apache",
	    "extensions": ["gtar"]
	  },
	  "application/x-gzip": {
	    "source": "apache"
	  },
	  "application/x-hdf": {
	    "source": "apache",
	    "extensions": ["hdf"]
	  },
	  "application/x-httpd-php": {
	    "compressible": true,
	    "extensions": ["php"]
	  },
	  "application/x-install-instructions": {
	    "source": "apache",
	    "extensions": ["install"]
	  },
	  "application/x-iso9660-image": {
	    "source": "apache",
	    "extensions": ["iso"]
	  },
	  "application/x-java-archive-diff": {
	    "source": "nginx",
	    "extensions": ["jardiff"]
	  },
	  "application/x-java-jnlp-file": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["jnlp"]
	  },
	  "application/x-javascript": {
	    "compressible": true
	  },
	  "application/x-latex": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["latex"]
	  },
	  "application/x-lua-bytecode": {
	    "extensions": ["luac"]
	  },
	  "application/x-lzh-compressed": {
	    "source": "apache",
	    "extensions": ["lzh","lha"]
	  },
	  "application/x-makeself": {
	    "source": "nginx",
	    "extensions": ["run"]
	  },
	  "application/x-mie": {
	    "source": "apache",
	    "extensions": ["mie"]
	  },
	  "application/x-mobipocket-ebook": {
	    "source": "apache",
	    "extensions": ["prc","mobi"]
	  },
	  "application/x-mpegurl": {
	    "compressible": false
	  },
	  "application/x-ms-application": {
	    "source": "apache",
	    "extensions": ["application"]
	  },
	  "application/x-ms-shortcut": {
	    "source": "apache",
	    "extensions": ["lnk"]
	  },
	  "application/x-ms-wmd": {
	    "source": "apache",
	    "extensions": ["wmd"]
	  },
	  "application/x-ms-wmz": {
	    "source": "apache",
	    "extensions": ["wmz"]
	  },
	  "application/x-ms-xbap": {
	    "source": "apache",
	    "extensions": ["xbap"]
	  },
	  "application/x-msaccess": {
	    "source": "apache",
	    "extensions": ["mdb"]
	  },
	  "application/x-msbinder": {
	    "source": "apache",
	    "extensions": ["obd"]
	  },
	  "application/x-mscardfile": {
	    "source": "apache",
	    "extensions": ["crd"]
	  },
	  "application/x-msclip": {
	    "source": "apache",
	    "extensions": ["clp"]
	  },
	  "application/x-msdos-program": {
	    "extensions": ["exe"]
	  },
	  "application/x-msdownload": {
	    "source": "apache",
	    "extensions": ["exe","dll","com","bat","msi"]
	  },
	  "application/x-msmediaview": {
	    "source": "apache",
	    "extensions": ["mvb","m13","m14"]
	  },
	  "application/x-msmetafile": {
	    "source": "apache",
	    "extensions": ["wmf","wmz","emf","emz"]
	  },
	  "application/x-msmoney": {
	    "source": "apache",
	    "extensions": ["mny"]
	  },
	  "application/x-mspublisher": {
	    "source": "apache",
	    "extensions": ["pub"]
	  },
	  "application/x-msschedule": {
	    "source": "apache",
	    "extensions": ["scd"]
	  },
	  "application/x-msterminal": {
	    "source": "apache",
	    "extensions": ["trm"]
	  },
	  "application/x-mswrite": {
	    "source": "apache",
	    "extensions": ["wri"]
	  },
	  "application/x-netcdf": {
	    "source": "apache",
	    "extensions": ["nc","cdf"]
	  },
	  "application/x-ns-proxy-autoconfig": {
	    "compressible": true,
	    "extensions": ["pac"]
	  },
	  "application/x-nzb": {
	    "source": "apache",
	    "extensions": ["nzb"]
	  },
	  "application/x-perl": {
	    "source": "nginx",
	    "extensions": ["pl","pm"]
	  },
	  "application/x-pilot": {
	    "source": "nginx",
	    "extensions": ["prc","pdb"]
	  },
	  "application/x-pkcs12": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["p12","pfx"]
	  },
	  "application/x-pkcs7-certificates": {
	    "source": "apache",
	    "extensions": ["p7b","spc"]
	  },
	  "application/x-pkcs7-certreqresp": {
	    "source": "apache",
	    "extensions": ["p7r"]
	  },
	  "application/x-rar-compressed": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["rar"]
	  },
	  "application/x-redhat-package-manager": {
	    "source": "nginx",
	    "extensions": ["rpm"]
	  },
	  "application/x-research-info-systems": {
	    "source": "apache",
	    "extensions": ["ris"]
	  },
	  "application/x-sea": {
	    "source": "nginx",
	    "extensions": ["sea"]
	  },
	  "application/x-sh": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["sh"]
	  },
	  "application/x-shar": {
	    "source": "apache",
	    "extensions": ["shar"]
	  },
	  "application/x-shockwave-flash": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["swf"]
	  },
	  "application/x-silverlight-app": {
	    "source": "apache",
	    "extensions": ["xap"]
	  },
	  "application/x-sql": {
	    "source": "apache",
	    "extensions": ["sql"]
	  },
	  "application/x-stuffit": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["sit"]
	  },
	  "application/x-stuffitx": {
	    "source": "apache",
	    "extensions": ["sitx"]
	  },
	  "application/x-subrip": {
	    "source": "apache",
	    "extensions": ["srt"]
	  },
	  "application/x-sv4cpio": {
	    "source": "apache",
	    "extensions": ["sv4cpio"]
	  },
	  "application/x-sv4crc": {
	    "source": "apache",
	    "extensions": ["sv4crc"]
	  },
	  "application/x-t3vm-image": {
	    "source": "apache",
	    "extensions": ["t3"]
	  },
	  "application/x-tads": {
	    "source": "apache",
	    "extensions": ["gam"]
	  },
	  "application/x-tar": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["tar"]
	  },
	  "application/x-tcl": {
	    "source": "apache",
	    "extensions": ["tcl","tk"]
	  },
	  "application/x-tex": {
	    "source": "apache",
	    "extensions": ["tex"]
	  },
	  "application/x-tex-tfm": {
	    "source": "apache",
	    "extensions": ["tfm"]
	  },
	  "application/x-texinfo": {
	    "source": "apache",
	    "extensions": ["texinfo","texi"]
	  },
	  "application/x-tgif": {
	    "source": "apache",
	    "extensions": ["obj"]
	  },
	  "application/x-ustar": {
	    "source": "apache",
	    "extensions": ["ustar"]
	  },
	  "application/x-wais-source": {
	    "source": "apache",
	    "extensions": ["src"]
	  },
	  "application/x-web-app-manifest+json": {
	    "compressible": true,
	    "extensions": ["webapp"]
	  },
	  "application/x-www-form-urlencoded": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/x-x509-ca-cert": {
	    "source": "apache",
	    "extensions": ["der","crt","pem"]
	  },
	  "application/x-xfig": {
	    "source": "apache",
	    "extensions": ["fig"]
	  },
	  "application/x-xliff+xml": {
	    "source": "apache",
	    "extensions": ["xlf"]
	  },
	  "application/x-xpinstall": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["xpi"]
	  },
	  "application/x-xz": {
	    "source": "apache",
	    "extensions": ["xz"]
	  },
	  "application/x-zmachine": {
	    "source": "apache",
	    "extensions": ["z1","z2","z3","z4","z5","z6","z7","z8"]
	  },
	  "application/x400-bp": {
	    "source": "iana"
	  },
	  "application/xacml+xml": {
	    "source": "iana"
	  },
	  "application/xaml+xml": {
	    "source": "apache",
	    "extensions": ["xaml"]
	  },
	  "application/xcap-att+xml": {
	    "source": "iana"
	  },
	  "application/xcap-caps+xml": {
	    "source": "iana"
	  },
	  "application/xcap-diff+xml": {
	    "source": "iana",
	    "extensions": ["xdf"]
	  },
	  "application/xcap-el+xml": {
	    "source": "iana"
	  },
	  "application/xcap-error+xml": {
	    "source": "iana"
	  },
	  "application/xcap-ns+xml": {
	    "source": "iana"
	  },
	  "application/xcon-conference-info+xml": {
	    "source": "iana"
	  },
	  "application/xcon-conference-info-diff+xml": {
	    "source": "iana"
	  },
	  "application/xenc+xml": {
	    "source": "iana",
	    "extensions": ["xenc"]
	  },
	  "application/xhtml+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["xhtml","xht"]
	  },
	  "application/xhtml-voice+xml": {
	    "source": "apache"
	  },
	  "application/xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["xml","xsl","xsd"]
	  },
	  "application/xml-dtd": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["dtd"]
	  },
	  "application/xml-external-parsed-entity": {
	    "source": "iana"
	  },
	  "application/xml-patch+xml": {
	    "source": "iana"
	  },
	  "application/xmpp+xml": {
	    "source": "iana"
	  },
	  "application/xop+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["xop"]
	  },
	  "application/xproc+xml": {
	    "source": "apache",
	    "extensions": ["xpl"]
	  },
	  "application/xslt+xml": {
	    "source": "iana",
	    "extensions": ["xslt"]
	  },
	  "application/xspf+xml": {
	    "source": "apache",
	    "extensions": ["xspf"]
	  },
	  "application/xv+xml": {
	    "source": "iana",
	    "extensions": ["mxml","xhvml","xvml","xvm"]
	  },
	  "application/yang": {
	    "source": "iana",
	    "extensions": ["yang"]
	  },
	  "application/yin+xml": {
	    "source": "iana",
	    "extensions": ["yin"]
	  },
	  "application/zip": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["zip"]
	  },
	  "application/zlib": {
	    "source": "iana"
	  },
	  "audio/1d-interleaved-parityfec": {
	    "source": "iana"
	  },
	  "audio/32kadpcm": {
	    "source": "iana"
	  },
	  "audio/3gpp": {
	    "source": "iana"
	  },
	  "audio/3gpp2": {
	    "source": "iana"
	  },
	  "audio/ac3": {
	    "source": "iana"
	  },
	  "audio/adpcm": {
	    "source": "apache",
	    "extensions": ["adp"]
	  },
	  "audio/amr": {
	    "source": "iana"
	  },
	  "audio/amr-wb": {
	    "source": "iana"
	  },
	  "audio/amr-wb+": {
	    "source": "iana"
	  },
	  "audio/aptx": {
	    "source": "iana"
	  },
	  "audio/asc": {
	    "source": "iana"
	  },
	  "audio/atrac-advanced-lossless": {
	    "source": "iana"
	  },
	  "audio/atrac-x": {
	    "source": "iana"
	  },
	  "audio/atrac3": {
	    "source": "iana"
	  },
	  "audio/basic": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["au","snd"]
	  },
	  "audio/bv16": {
	    "source": "iana"
	  },
	  "audio/bv32": {
	    "source": "iana"
	  },
	  "audio/clearmode": {
	    "source": "iana"
	  },
	  "audio/cn": {
	    "source": "iana"
	  },
	  "audio/dat12": {
	    "source": "iana"
	  },
	  "audio/dls": {
	    "source": "iana"
	  },
	  "audio/dsr-es201108": {
	    "source": "iana"
	  },
	  "audio/dsr-es202050": {
	    "source": "iana"
	  },
	  "audio/dsr-es202211": {
	    "source": "iana"
	  },
	  "audio/dsr-es202212": {
	    "source": "iana"
	  },
	  "audio/dv": {
	    "source": "iana"
	  },
	  "audio/dvi4": {
	    "source": "iana"
	  },
	  "audio/eac3": {
	    "source": "iana"
	  },
	  "audio/encaprtp": {
	    "source": "iana"
	  },
	  "audio/evrc": {
	    "source": "iana"
	  },
	  "audio/evrc-qcp": {
	    "source": "iana"
	  },
	  "audio/evrc0": {
	    "source": "iana"
	  },
	  "audio/evrc1": {
	    "source": "iana"
	  },
	  "audio/evrcb": {
	    "source": "iana"
	  },
	  "audio/evrcb0": {
	    "source": "iana"
	  },
	  "audio/evrcb1": {
	    "source": "iana"
	  },
	  "audio/evrcnw": {
	    "source": "iana"
	  },
	  "audio/evrcnw0": {
	    "source": "iana"
	  },
	  "audio/evrcnw1": {
	    "source": "iana"
	  },
	  "audio/evrcwb": {
	    "source": "iana"
	  },
	  "audio/evrcwb0": {
	    "source": "iana"
	  },
	  "audio/evrcwb1": {
	    "source": "iana"
	  },
	  "audio/evs": {
	    "source": "iana"
	  },
	  "audio/fwdred": {
	    "source": "iana"
	  },
	  "audio/g711-0": {
	    "source": "iana"
	  },
	  "audio/g719": {
	    "source": "iana"
	  },
	  "audio/g722": {
	    "source": "iana"
	  },
	  "audio/g7221": {
	    "source": "iana"
	  },
	  "audio/g723": {
	    "source": "iana"
	  },
	  "audio/g726-16": {
	    "source": "iana"
	  },
	  "audio/g726-24": {
	    "source": "iana"
	  },
	  "audio/g726-32": {
	    "source": "iana"
	  },
	  "audio/g726-40": {
	    "source": "iana"
	  },
	  "audio/g728": {
	    "source": "iana"
	  },
	  "audio/g729": {
	    "source": "iana"
	  },
	  "audio/g7291": {
	    "source": "iana"
	  },
	  "audio/g729d": {
	    "source": "iana"
	  },
	  "audio/g729e": {
	    "source": "iana"
	  },
	  "audio/gsm": {
	    "source": "iana"
	  },
	  "audio/gsm-efr": {
	    "source": "iana"
	  },
	  "audio/gsm-hr-08": {
	    "source": "iana"
	  },
	  "audio/ilbc": {
	    "source": "iana"
	  },
	  "audio/ip-mr_v2.5": {
	    "source": "iana"
	  },
	  "audio/isac": {
	    "source": "apache"
	  },
	  "audio/l16": {
	    "source": "iana"
	  },
	  "audio/l20": {
	    "source": "iana"
	  },
	  "audio/l24": {
	    "source": "iana",
	    "compressible": false
	  },
	  "audio/l8": {
	    "source": "iana"
	  },
	  "audio/lpc": {
	    "source": "iana"
	  },
	  "audio/midi": {
	    "source": "apache",
	    "extensions": ["mid","midi","kar","rmi"]
	  },
	  "audio/mobile-xmf": {
	    "source": "iana"
	  },
	  "audio/mp4": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["mp4a","m4a"]
	  },
	  "audio/mp4a-latm": {
	    "source": "iana"
	  },
	  "audio/mpa": {
	    "source": "iana"
	  },
	  "audio/mpa-robust": {
	    "source": "iana"
	  },
	  "audio/mpeg": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["mpga","mp2","mp2a","mp3","m2a","m3a"]
	  },
	  "audio/mpeg4-generic": {
	    "source": "iana"
	  },
	  "audio/musepack": {
	    "source": "apache"
	  },
	  "audio/ogg": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["oga","ogg","spx"]
	  },
	  "audio/opus": {
	    "source": "iana"
	  },
	  "audio/parityfec": {
	    "source": "iana"
	  },
	  "audio/pcma": {
	    "source": "iana"
	  },
	  "audio/pcma-wb": {
	    "source": "iana"
	  },
	  "audio/pcmu": {
	    "source": "iana"
	  },
	  "audio/pcmu-wb": {
	    "source": "iana"
	  },
	  "audio/prs.sid": {
	    "source": "iana"
	  },
	  "audio/qcelp": {
	    "source": "iana"
	  },
	  "audio/raptorfec": {
	    "source": "iana"
	  },
	  "audio/red": {
	    "source": "iana"
	  },
	  "audio/rtp-enc-aescm128": {
	    "source": "iana"
	  },
	  "audio/rtp-midi": {
	    "source": "iana"
	  },
	  "audio/rtploopback": {
	    "source": "iana"
	  },
	  "audio/rtx": {
	    "source": "iana"
	  },
	  "audio/s3m": {
	    "source": "apache",
	    "extensions": ["s3m"]
	  },
	  "audio/silk": {
	    "source": "apache",
	    "extensions": ["sil"]
	  },
	  "audio/smv": {
	    "source": "iana"
	  },
	  "audio/smv-qcp": {
	    "source": "iana"
	  },
	  "audio/smv0": {
	    "source": "iana"
	  },
	  "audio/sp-midi": {
	    "source": "iana"
	  },
	  "audio/speex": {
	    "source": "iana"
	  },
	  "audio/t140c": {
	    "source": "iana"
	  },
	  "audio/t38": {
	    "source": "iana"
	  },
	  "audio/telephone-event": {
	    "source": "iana"
	  },
	  "audio/tone": {
	    "source": "iana"
	  },
	  "audio/uemclip": {
	    "source": "iana"
	  },
	  "audio/ulpfec": {
	    "source": "iana"
	  },
	  "audio/vdvi": {
	    "source": "iana"
	  },
	  "audio/vmr-wb": {
	    "source": "iana"
	  },
	  "audio/vnd.3gpp.iufp": {
	    "source": "iana"
	  },
	  "audio/vnd.4sb": {
	    "source": "iana"
	  },
	  "audio/vnd.audiokoz": {
	    "source": "iana"
	  },
	  "audio/vnd.celp": {
	    "source": "iana"
	  },
	  "audio/vnd.cisco.nse": {
	    "source": "iana"
	  },
	  "audio/vnd.cmles.radio-events": {
	    "source": "iana"
	  },
	  "audio/vnd.cns.anp1": {
	    "source": "iana"
	  },
	  "audio/vnd.cns.inf1": {
	    "source": "iana"
	  },
	  "audio/vnd.dece.audio": {
	    "source": "iana",
	    "extensions": ["uva","uvva"]
	  },
	  "audio/vnd.digital-winds": {
	    "source": "iana",
	    "extensions": ["eol"]
	  },
	  "audio/vnd.dlna.adts": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.heaac.1": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.heaac.2": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.mlp": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.mps": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.pl2": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.pl2x": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.pl2z": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.pulse.1": {
	    "source": "iana"
	  },
	  "audio/vnd.dra": {
	    "source": "iana",
	    "extensions": ["dra"]
	  },
	  "audio/vnd.dts": {
	    "source": "iana",
	    "extensions": ["dts"]
	  },
	  "audio/vnd.dts.hd": {
	    "source": "iana",
	    "extensions": ["dtshd"]
	  },
	  "audio/vnd.dvb.file": {
	    "source": "iana"
	  },
	  "audio/vnd.everad.plj": {
	    "source": "iana"
	  },
	  "audio/vnd.hns.audio": {
	    "source": "iana"
	  },
	  "audio/vnd.lucent.voice": {
	    "source": "iana",
	    "extensions": ["lvp"]
	  },
	  "audio/vnd.ms-playready.media.pya": {
	    "source": "iana",
	    "extensions": ["pya"]
	  },
	  "audio/vnd.nokia.mobile-xmf": {
	    "source": "iana"
	  },
	  "audio/vnd.nortel.vbk": {
	    "source": "iana"
	  },
	  "audio/vnd.nuera.ecelp4800": {
	    "source": "iana",
	    "extensions": ["ecelp4800"]
	  },
	  "audio/vnd.nuera.ecelp7470": {
	    "source": "iana",
	    "extensions": ["ecelp7470"]
	  },
	  "audio/vnd.nuera.ecelp9600": {
	    "source": "iana",
	    "extensions": ["ecelp9600"]
	  },
	  "audio/vnd.octel.sbc": {
	    "source": "iana"
	  },
	  "audio/vnd.qcelp": {
	    "source": "iana"
	  },
	  "audio/vnd.rhetorex.32kadpcm": {
	    "source": "iana"
	  },
	  "audio/vnd.rip": {
	    "source": "iana",
	    "extensions": ["rip"]
	  },
	  "audio/vnd.rn-realaudio": {
	    "compressible": false
	  },
	  "audio/vnd.sealedmedia.softseal.mpeg": {
	    "source": "iana"
	  },
	  "audio/vnd.vmx.cvsd": {
	    "source": "iana"
	  },
	  "audio/vnd.wave": {
	    "compressible": false
	  },
	  "audio/vorbis": {
	    "source": "iana",
	    "compressible": false
	  },
	  "audio/vorbis-config": {
	    "source": "iana"
	  },
	  "audio/wav": {
	    "compressible": false,
	    "extensions": ["wav"]
	  },
	  "audio/wave": {
	    "compressible": false,
	    "extensions": ["wav"]
	  },
	  "audio/webm": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["weba"]
	  },
	  "audio/x-aac": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["aac"]
	  },
	  "audio/x-aiff": {
	    "source": "apache",
	    "extensions": ["aif","aiff","aifc"]
	  },
	  "audio/x-caf": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["caf"]
	  },
	  "audio/x-flac": {
	    "source": "apache",
	    "extensions": ["flac"]
	  },
	  "audio/x-m4a": {
	    "source": "nginx",
	    "extensions": ["m4a"]
	  },
	  "audio/x-matroska": {
	    "source": "apache",
	    "extensions": ["mka"]
	  },
	  "audio/x-mpegurl": {
	    "source": "apache",
	    "extensions": ["m3u"]
	  },
	  "audio/x-ms-wax": {
	    "source": "apache",
	    "extensions": ["wax"]
	  },
	  "audio/x-ms-wma": {
	    "source": "apache",
	    "extensions": ["wma"]
	  },
	  "audio/x-pn-realaudio": {
	    "source": "apache",
	    "extensions": ["ram","ra"]
	  },
	  "audio/x-pn-realaudio-plugin": {
	    "source": "apache",
	    "extensions": ["rmp"]
	  },
	  "audio/x-realaudio": {
	    "source": "nginx",
	    "extensions": ["ra"]
	  },
	  "audio/x-tta": {
	    "source": "apache"
	  },
	  "audio/x-wav": {
	    "source": "apache",
	    "extensions": ["wav"]
	  },
	  "audio/xm": {
	    "source": "apache",
	    "extensions": ["xm"]
	  },
	  "chemical/x-cdx": {
	    "source": "apache",
	    "extensions": ["cdx"]
	  },
	  "chemical/x-cif": {
	    "source": "apache",
	    "extensions": ["cif"]
	  },
	  "chemical/x-cmdf": {
	    "source": "apache",
	    "extensions": ["cmdf"]
	  },
	  "chemical/x-cml": {
	    "source": "apache",
	    "extensions": ["cml"]
	  },
	  "chemical/x-csml": {
	    "source": "apache",
	    "extensions": ["csml"]
	  },
	  "chemical/x-pdb": {
	    "source": "apache"
	  },
	  "chemical/x-xyz": {
	    "source": "apache",
	    "extensions": ["xyz"]
	  },
	  "font/opentype": {
	    "compressible": true,
	    "extensions": ["otf"]
	  },
	  "image/bmp": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["bmp"]
	  },
	  "image/cgm": {
	    "source": "iana",
	    "extensions": ["cgm"]
	  },
	  "image/fits": {
	    "source": "iana"
	  },
	  "image/g3fax": {
	    "source": "iana",
	    "extensions": ["g3"]
	  },
	  "image/gif": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["gif"]
	  },
	  "image/ief": {
	    "source": "iana",
	    "extensions": ["ief"]
	  },
	  "image/jp2": {
	    "source": "iana"
	  },
	  "image/jpeg": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["jpeg","jpg","jpe"]
	  },
	  "image/jpm": {
	    "source": "iana"
	  },
	  "image/jpx": {
	    "source": "iana"
	  },
	  "image/ktx": {
	    "source": "iana",
	    "extensions": ["ktx"]
	  },
	  "image/naplps": {
	    "source": "iana"
	  },
	  "image/pjpeg": {
	    "compressible": false
	  },
	  "image/png": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["png"]
	  },
	  "image/prs.btif": {
	    "source": "iana",
	    "extensions": ["btif"]
	  },
	  "image/prs.pti": {
	    "source": "iana"
	  },
	  "image/pwg-raster": {
	    "source": "iana"
	  },
	  "image/sgi": {
	    "source": "apache",
	    "extensions": ["sgi"]
	  },
	  "image/svg+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["svg","svgz"]
	  },
	  "image/t38": {
	    "source": "iana"
	  },
	  "image/tiff": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["tiff","tif"]
	  },
	  "image/tiff-fx": {
	    "source": "iana"
	  },
	  "image/vnd.adobe.photoshop": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["psd"]
	  },
	  "image/vnd.airzip.accelerator.azv": {
	    "source": "iana"
	  },
	  "image/vnd.cns.inf2": {
	    "source": "iana"
	  },
	  "image/vnd.dece.graphic": {
	    "source": "iana",
	    "extensions": ["uvi","uvvi","uvg","uvvg"]
	  },
	  "image/vnd.djvu": {
	    "source": "iana",
	    "extensions": ["djvu","djv"]
	  },
	  "image/vnd.dvb.subtitle": {
	    "source": "iana",
	    "extensions": ["sub"]
	  },
	  "image/vnd.dwg": {
	    "source": "iana",
	    "extensions": ["dwg"]
	  },
	  "image/vnd.dxf": {
	    "source": "iana",
	    "extensions": ["dxf"]
	  },
	  "image/vnd.fastbidsheet": {
	    "source": "iana",
	    "extensions": ["fbs"]
	  },
	  "image/vnd.fpx": {
	    "source": "iana",
	    "extensions": ["fpx"]
	  },
	  "image/vnd.fst": {
	    "source": "iana",
	    "extensions": ["fst"]
	  },
	  "image/vnd.fujixerox.edmics-mmr": {
	    "source": "iana",
	    "extensions": ["mmr"]
	  },
	  "image/vnd.fujixerox.edmics-rlc": {
	    "source": "iana",
	    "extensions": ["rlc"]
	  },
	  "image/vnd.globalgraphics.pgb": {
	    "source": "iana"
	  },
	  "image/vnd.microsoft.icon": {
	    "source": "iana"
	  },
	  "image/vnd.mix": {
	    "source": "iana"
	  },
	  "image/vnd.mozilla.apng": {
	    "source": "iana"
	  },
	  "image/vnd.ms-modi": {
	    "source": "iana",
	    "extensions": ["mdi"]
	  },
	  "image/vnd.ms-photo": {
	    "source": "apache",
	    "extensions": ["wdp"]
	  },
	  "image/vnd.net-fpx": {
	    "source": "iana",
	    "extensions": ["npx"]
	  },
	  "image/vnd.radiance": {
	    "source": "iana"
	  },
	  "image/vnd.sealed.png": {
	    "source": "iana"
	  },
	  "image/vnd.sealedmedia.softseal.gif": {
	    "source": "iana"
	  },
	  "image/vnd.sealedmedia.softseal.jpg": {
	    "source": "iana"
	  },
	  "image/vnd.svf": {
	    "source": "iana"
	  },
	  "image/vnd.tencent.tap": {
	    "source": "iana"
	  },
	  "image/vnd.valve.source.texture": {
	    "source": "iana"
	  },
	  "image/vnd.wap.wbmp": {
	    "source": "iana",
	    "extensions": ["wbmp"]
	  },
	  "image/vnd.xiff": {
	    "source": "iana",
	    "extensions": ["xif"]
	  },
	  "image/vnd.zbrush.pcx": {
	    "source": "iana"
	  },
	  "image/webp": {
	    "source": "apache",
	    "extensions": ["webp"]
	  },
	  "image/x-3ds": {
	    "source": "apache",
	    "extensions": ["3ds"]
	  },
	  "image/x-cmu-raster": {
	    "source": "apache",
	    "extensions": ["ras"]
	  },
	  "image/x-cmx": {
	    "source": "apache",
	    "extensions": ["cmx"]
	  },
	  "image/x-freehand": {
	    "source": "apache",
	    "extensions": ["fh","fhc","fh4","fh5","fh7"]
	  },
	  "image/x-icon": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["ico"]
	  },
	  "image/x-jng": {
	    "source": "nginx",
	    "extensions": ["jng"]
	  },
	  "image/x-mrsid-image": {
	    "source": "apache",
	    "extensions": ["sid"]
	  },
	  "image/x-ms-bmp": {
	    "source": "nginx",
	    "compressible": true,
	    "extensions": ["bmp"]
	  },
	  "image/x-pcx": {
	    "source": "apache",
	    "extensions": ["pcx"]
	  },
	  "image/x-pict": {
	    "source": "apache",
	    "extensions": ["pic","pct"]
	  },
	  "image/x-portable-anymap": {
	    "source": "apache",
	    "extensions": ["pnm"]
	  },
	  "image/x-portable-bitmap": {
	    "source": "apache",
	    "extensions": ["pbm"]
	  },
	  "image/x-portable-graymap": {
	    "source": "apache",
	    "extensions": ["pgm"]
	  },
	  "image/x-portable-pixmap": {
	    "source": "apache",
	    "extensions": ["ppm"]
	  },
	  "image/x-rgb": {
	    "source": "apache",
	    "extensions": ["rgb"]
	  },
	  "image/x-tga": {
	    "source": "apache",
	    "extensions": ["tga"]
	  },
	  "image/x-xbitmap": {
	    "source": "apache",
	    "extensions": ["xbm"]
	  },
	  "image/x-xcf": {
	    "compressible": false
	  },
	  "image/x-xpixmap": {
	    "source": "apache",
	    "extensions": ["xpm"]
	  },
	  "image/x-xwindowdump": {
	    "source": "apache",
	    "extensions": ["xwd"]
	  },
	  "message/cpim": {
	    "source": "iana"
	  },
	  "message/delivery-status": {
	    "source": "iana"
	  },
	  "message/disposition-notification": {
	    "source": "iana"
	  },
	  "message/external-body": {
	    "source": "iana"
	  },
	  "message/feedback-report": {
	    "source": "iana"
	  },
	  "message/global": {
	    "source": "iana"
	  },
	  "message/global-delivery-status": {
	    "source": "iana"
	  },
	  "message/global-disposition-notification": {
	    "source": "iana"
	  },
	  "message/global-headers": {
	    "source": "iana"
	  },
	  "message/http": {
	    "source": "iana",
	    "compressible": false
	  },
	  "message/imdn+xml": {
	    "source": "iana",
	    "compressible": true
	  },
	  "message/news": {
	    "source": "iana"
	  },
	  "message/partial": {
	    "source": "iana",
	    "compressible": false
	  },
	  "message/rfc822": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["eml","mime"]
	  },
	  "message/s-http": {
	    "source": "iana"
	  },
	  "message/sip": {
	    "source": "iana"
	  },
	  "message/sipfrag": {
	    "source": "iana"
	  },
	  "message/tracking-status": {
	    "source": "iana"
	  },
	  "message/vnd.si.simp": {
	    "source": "iana"
	  },
	  "message/vnd.wfa.wsc": {
	    "source": "iana"
	  },
	  "model/iges": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["igs","iges"]
	  },
	  "model/mesh": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["msh","mesh","silo"]
	  },
	  "model/vnd.collada+xml": {
	    "source": "iana",
	    "extensions": ["dae"]
	  },
	  "model/vnd.dwf": {
	    "source": "iana",
	    "extensions": ["dwf"]
	  },
	  "model/vnd.flatland.3dml": {
	    "source": "iana"
	  },
	  "model/vnd.gdl": {
	    "source": "iana",
	    "extensions": ["gdl"]
	  },
	  "model/vnd.gs-gdl": {
	    "source": "apache"
	  },
	  "model/vnd.gs.gdl": {
	    "source": "iana"
	  },
	  "model/vnd.gtw": {
	    "source": "iana",
	    "extensions": ["gtw"]
	  },
	  "model/vnd.moml+xml": {
	    "source": "iana"
	  },
	  "model/vnd.mts": {
	    "source": "iana",
	    "extensions": ["mts"]
	  },
	  "model/vnd.opengex": {
	    "source": "iana"
	  },
	  "model/vnd.parasolid.transmit.binary": {
	    "source": "iana"
	  },
	  "model/vnd.parasolid.transmit.text": {
	    "source": "iana"
	  },
	  "model/vnd.valve.source.compiled-map": {
	    "source": "iana"
	  },
	  "model/vnd.vtu": {
	    "source": "iana",
	    "extensions": ["vtu"]
	  },
	  "model/vrml": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["wrl","vrml"]
	  },
	  "model/x3d+binary": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["x3db","x3dbz"]
	  },
	  "model/x3d+fastinfoset": {
	    "source": "iana"
	  },
	  "model/x3d+vrml": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["x3dv","x3dvz"]
	  },
	  "model/x3d+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["x3d","x3dz"]
	  },
	  "model/x3d-vrml": {
	    "source": "iana"
	  },
	  "multipart/alternative": {
	    "source": "iana",
	    "compressible": false
	  },
	  "multipart/appledouble": {
	    "source": "iana"
	  },
	  "multipart/byteranges": {
	    "source": "iana"
	  },
	  "multipart/digest": {
	    "source": "iana"
	  },
	  "multipart/encrypted": {
	    "source": "iana",
	    "compressible": false
	  },
	  "multipart/form-data": {
	    "source": "iana",
	    "compressible": false
	  },
	  "multipart/header-set": {
	    "source": "iana"
	  },
	  "multipart/mixed": {
	    "source": "iana",
	    "compressible": false
	  },
	  "multipart/parallel": {
	    "source": "iana"
	  },
	  "multipart/related": {
	    "source": "iana",
	    "compressible": false
	  },
	  "multipart/report": {
	    "source": "iana"
	  },
	  "multipart/signed": {
	    "source": "iana",
	    "compressible": false
	  },
	  "multipart/voice-message": {
	    "source": "iana"
	  },
	  "multipart/x-mixed-replace": {
	    "source": "iana"
	  },
	  "text/1d-interleaved-parityfec": {
	    "source": "iana"
	  },
	  "text/cache-manifest": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["appcache","manifest"]
	  },
	  "text/calendar": {
	    "source": "iana",
	    "extensions": ["ics","ifb"]
	  },
	  "text/calender": {
	    "compressible": true
	  },
	  "text/cmd": {
	    "compressible": true
	  },
	  "text/coffeescript": {
	    "extensions": ["coffee","litcoffee"]
	  },
	  "text/css": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["css"]
	  },
	  "text/csv": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["csv"]
	  },
	  "text/csv-schema": {
	    "source": "iana"
	  },
	  "text/directory": {
	    "source": "iana"
	  },
	  "text/dns": {
	    "source": "iana"
	  },
	  "text/ecmascript": {
	    "source": "iana"
	  },
	  "text/encaprtp": {
	    "source": "iana"
	  },
	  "text/enriched": {
	    "source": "iana"
	  },
	  "text/fwdred": {
	    "source": "iana"
	  },
	  "text/grammar-ref-list": {
	    "source": "iana"
	  },
	  "text/hjson": {
	    "extensions": ["hjson"]
	  },
	  "text/html": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["html","htm","shtml"]
	  },
	  "text/jade": {
	    "extensions": ["jade"]
	  },
	  "text/javascript": {
	    "source": "iana",
	    "compressible": true
	  },
	  "text/jcr-cnd": {
	    "source": "iana"
	  },
	  "text/jsx": {
	    "compressible": true,
	    "extensions": ["jsx"]
	  },
	  "text/less": {
	    "extensions": ["less"]
	  },
	  "text/markdown": {
	    "source": "iana"
	  },
	  "text/mathml": {
	    "source": "nginx",
	    "extensions": ["mml"]
	  },
	  "text/mizar": {
	    "source": "iana"
	  },
	  "text/n3": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["n3"]
	  },
	  "text/parameters": {
	    "source": "iana"
	  },
	  "text/parityfec": {
	    "source": "iana"
	  },
	  "text/plain": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["txt","text","conf","def","list","log","in","ini"]
	  },
	  "text/provenance-notation": {
	    "source": "iana"
	  },
	  "text/prs.fallenstein.rst": {
	    "source": "iana"
	  },
	  "text/prs.lines.tag": {
	    "source": "iana",
	    "extensions": ["dsc"]
	  },
	  "text/raptorfec": {
	    "source": "iana"
	  },
	  "text/red": {
	    "source": "iana"
	  },
	  "text/rfc822-headers": {
	    "source": "iana"
	  },
	  "text/richtext": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["rtx"]
	  },
	  "text/rtf": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["rtf"]
	  },
	  "text/rtp-enc-aescm128": {
	    "source": "iana"
	  },
	  "text/rtploopback": {
	    "source": "iana"
	  },
	  "text/rtx": {
	    "source": "iana"
	  },
	  "text/sgml": {
	    "source": "iana",
	    "extensions": ["sgml","sgm"]
	  },
	  "text/stylus": {
	    "extensions": ["stylus","styl"]
	  },
	  "text/t140": {
	    "source": "iana"
	  },
	  "text/tab-separated-values": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["tsv"]
	  },
	  "text/troff": {
	    "source": "iana",
	    "extensions": ["t","tr","roff","man","me","ms"]
	  },
	  "text/turtle": {
	    "source": "iana",
	    "extensions": ["ttl"]
	  },
	  "text/ulpfec": {
	    "source": "iana"
	  },
	  "text/uri-list": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["uri","uris","urls"]
	  },
	  "text/vcard": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["vcard"]
	  },
	  "text/vnd.a": {
	    "source": "iana"
	  },
	  "text/vnd.abc": {
	    "source": "iana"
	  },
	  "text/vnd.curl": {
	    "source": "iana",
	    "extensions": ["curl"]
	  },
	  "text/vnd.curl.dcurl": {
	    "source": "apache",
	    "extensions": ["dcurl"]
	  },
	  "text/vnd.curl.mcurl": {
	    "source": "apache",
	    "extensions": ["mcurl"]
	  },
	  "text/vnd.curl.scurl": {
	    "source": "apache",
	    "extensions": ["scurl"]
	  },
	  "text/vnd.debian.copyright": {
	    "source": "iana"
	  },
	  "text/vnd.dmclientscript": {
	    "source": "iana"
	  },
	  "text/vnd.dvb.subtitle": {
	    "source": "iana",
	    "extensions": ["sub"]
	  },
	  "text/vnd.esmertec.theme-descriptor": {
	    "source": "iana"
	  },
	  "text/vnd.fly": {
	    "source": "iana",
	    "extensions": ["fly"]
	  },
	  "text/vnd.fmi.flexstor": {
	    "source": "iana",
	    "extensions": ["flx"]
	  },
	  "text/vnd.graphviz": {
	    "source": "iana",
	    "extensions": ["gv"]
	  },
	  "text/vnd.in3d.3dml": {
	    "source": "iana",
	    "extensions": ["3dml"]
	  },
	  "text/vnd.in3d.spot": {
	    "source": "iana",
	    "extensions": ["spot"]
	  },
	  "text/vnd.iptc.newsml": {
	    "source": "iana"
	  },
	  "text/vnd.iptc.nitf": {
	    "source": "iana"
	  },
	  "text/vnd.latex-z": {
	    "source": "iana"
	  },
	  "text/vnd.motorola.reflex": {
	    "source": "iana"
	  },
	  "text/vnd.ms-mediapackage": {
	    "source": "iana"
	  },
	  "text/vnd.net2phone.commcenter.command": {
	    "source": "iana"
	  },
	  "text/vnd.radisys.msml-basic-layout": {
	    "source": "iana"
	  },
	  "text/vnd.si.uricatalogue": {
	    "source": "iana"
	  },
	  "text/vnd.sun.j2me.app-descriptor": {
	    "source": "iana",
	    "extensions": ["jad"]
	  },
	  "text/vnd.trolltech.linguist": {
	    "source": "iana"
	  },
	  "text/vnd.wap.si": {
	    "source": "iana"
	  },
	  "text/vnd.wap.sl": {
	    "source": "iana"
	  },
	  "text/vnd.wap.wml": {
	    "source": "iana",
	    "extensions": ["wml"]
	  },
	  "text/vnd.wap.wmlscript": {
	    "source": "iana",
	    "extensions": ["wmls"]
	  },
	  "text/vtt": {
	    "charset": "UTF-8",
	    "compressible": true,
	    "extensions": ["vtt"]
	  },
	  "text/x-asm": {
	    "source": "apache",
	    "extensions": ["s","asm"]
	  },
	  "text/x-c": {
	    "source": "apache",
	    "extensions": ["c","cc","cxx","cpp","h","hh","dic"]
	  },
	  "text/x-component": {
	    "source": "nginx",
	    "extensions": ["htc"]
	  },
	  "text/x-fortran": {
	    "source": "apache",
	    "extensions": ["f","for","f77","f90"]
	  },
	  "text/x-gwt-rpc": {
	    "compressible": true
	  },
	  "text/x-handlebars-template": {
	    "extensions": ["hbs"]
	  },
	  "text/x-java-source": {
	    "source": "apache",
	    "extensions": ["java"]
	  },
	  "text/x-jquery-tmpl": {
	    "compressible": true
	  },
	  "text/x-lua": {
	    "extensions": ["lua"]
	  },
	  "text/x-markdown": {
	    "compressible": true,
	    "extensions": ["markdown","md","mkd"]
	  },
	  "text/x-nfo": {
	    "source": "apache",
	    "extensions": ["nfo"]
	  },
	  "text/x-opml": {
	    "source": "apache",
	    "extensions": ["opml"]
	  },
	  "text/x-pascal": {
	    "source": "apache",
	    "extensions": ["p","pas"]
	  },
	  "text/x-processing": {
	    "compressible": true,
	    "extensions": ["pde"]
	  },
	  "text/x-sass": {
	    "extensions": ["sass"]
	  },
	  "text/x-scss": {
	    "extensions": ["scss"]
	  },
	  "text/x-setext": {
	    "source": "apache",
	    "extensions": ["etx"]
	  },
	  "text/x-sfv": {
	    "source": "apache",
	    "extensions": ["sfv"]
	  },
	  "text/x-suse-ymp": {
	    "compressible": true,
	    "extensions": ["ymp"]
	  },
	  "text/x-uuencode": {
	    "source": "apache",
	    "extensions": ["uu"]
	  },
	  "text/x-vcalendar": {
	    "source": "apache",
	    "extensions": ["vcs"]
	  },
	  "text/x-vcard": {
	    "source": "apache",
	    "extensions": ["vcf"]
	  },
	  "text/xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["xml"]
	  },
	  "text/xml-external-parsed-entity": {
	    "source": "iana"
	  },
	  "text/yaml": {
	    "extensions": ["yaml","yml"]
	  },
	  "video/1d-interleaved-parityfec": {
	    "source": "apache"
	  },
	  "video/3gpp": {
	    "source": "apache",
	    "extensions": ["3gp","3gpp"]
	  },
	  "video/3gpp-tt": {
	    "source": "apache"
	  },
	  "video/3gpp2": {
	    "source": "apache",
	    "extensions": ["3g2"]
	  },
	  "video/bmpeg": {
	    "source": "apache"
	  },
	  "video/bt656": {
	    "source": "apache"
	  },
	  "video/celb": {
	    "source": "apache"
	  },
	  "video/dv": {
	    "source": "apache"
	  },
	  "video/h261": {
	    "source": "apache",
	    "extensions": ["h261"]
	  },
	  "video/h263": {
	    "source": "apache",
	    "extensions": ["h263"]
	  },
	  "video/h263-1998": {
	    "source": "apache"
	  },
	  "video/h263-2000": {
	    "source": "apache"
	  },
	  "video/h264": {
	    "source": "apache",
	    "extensions": ["h264"]
	  },
	  "video/h264-rcdo": {
	    "source": "apache"
	  },
	  "video/h264-svc": {
	    "source": "apache"
	  },
	  "video/jpeg": {
	    "source": "apache",
	    "extensions": ["jpgv"]
	  },
	  "video/jpeg2000": {
	    "source": "apache"
	  },
	  "video/jpm": {
	    "source": "apache",
	    "extensions": ["jpm","jpgm"]
	  },
	  "video/mj2": {
	    "source": "apache",
	    "extensions": ["mj2","mjp2"]
	  },
	  "video/mp1s": {
	    "source": "apache"
	  },
	  "video/mp2p": {
	    "source": "apache"
	  },
	  "video/mp2t": {
	    "source": "apache",
	    "extensions": ["ts"]
	  },
	  "video/mp4": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["mp4","mp4v","mpg4"]
	  },
	  "video/mp4v-es": {
	    "source": "apache"
	  },
	  "video/mpeg": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["mpeg","mpg","mpe","m1v","m2v"]
	  },
	  "video/mpeg4-generic": {
	    "source": "apache"
	  },
	  "video/mpv": {
	    "source": "apache"
	  },
	  "video/nv": {
	    "source": "apache"
	  },
	  "video/ogg": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["ogv"]
	  },
	  "video/parityfec": {
	    "source": "apache"
	  },
	  "video/pointer": {
	    "source": "apache"
	  },
	  "video/quicktime": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["qt","mov"]
	  },
	  "video/raw": {
	    "source": "apache"
	  },
	  "video/rtp-enc-aescm128": {
	    "source": "apache"
	  },
	  "video/rtx": {
	    "source": "apache"
	  },
	  "video/smpte292m": {
	    "source": "apache"
	  },
	  "video/ulpfec": {
	    "source": "apache"
	  },
	  "video/vc1": {
	    "source": "apache"
	  },
	  "video/vnd.cctv": {
	    "source": "apache"
	  },
	  "video/vnd.dece.hd": {
	    "source": "apache",
	    "extensions": ["uvh","uvvh"]
	  },
	  "video/vnd.dece.mobile": {
	    "source": "apache",
	    "extensions": ["uvm","uvvm"]
	  },
	  "video/vnd.dece.mp4": {
	    "source": "apache"
	  },
	  "video/vnd.dece.pd": {
	    "source": "apache",
	    "extensions": ["uvp","uvvp"]
	  },
	  "video/vnd.dece.sd": {
	    "source": "apache",
	    "extensions": ["uvs","uvvs"]
	  },
	  "video/vnd.dece.video": {
	    "source": "apache",
	    "extensions": ["uvv","uvvv"]
	  },
	  "video/vnd.directv.mpeg": {
	    "source": "apache"
	  },
	  "video/vnd.directv.mpeg-tts": {
	    "source": "apache"
	  },
	  "video/vnd.dlna.mpeg-tts": {
	    "source": "apache"
	  },
	  "video/vnd.dvb.file": {
	    "source": "apache",
	    "extensions": ["dvb"]
	  },
	  "video/vnd.fvt": {
	    "source": "apache",
	    "extensions": ["fvt"]
	  },
	  "video/vnd.hns.video": {
	    "source": "apache"
	  },
	  "video/vnd.iptvforum.1dparityfec-1010": {
	    "source": "apache"
	  },
	  "video/vnd.iptvforum.1dparityfec-2005": {
	    "source": "apache"
	  },
	  "video/vnd.iptvforum.2dparityfec-1010": {
	    "source": "apache"
	  },
	  "video/vnd.iptvforum.2dparityfec-2005": {
	    "source": "apache"
	  },
	  "video/vnd.iptvforum.ttsavc": {
	    "source": "apache"
	  },
	  "video/vnd.iptvforum.ttsmpeg2": {
	    "source": "apache"
	  },
	  "video/vnd.motorola.video": {
	    "source": "apache"
	  },
	  "video/vnd.motorola.videop": {
	    "source": "apache"
	  },
	  "video/vnd.mpegurl": {
	    "source": "apache",
	    "extensions": ["mxu","m4u"]
	  },
	  "video/vnd.ms-playready.media.pyv": {
	    "source": "apache",
	    "extensions": ["pyv"]
	  },
	  "video/vnd.nokia.interleaved-multimedia": {
	    "source": "apache"
	  },
	  "video/vnd.nokia.videovoip": {
	    "source": "apache"
	  },
	  "video/vnd.objectvideo": {
	    "source": "apache"
	  },
	  "video/vnd.sealed.mpeg1": {
	    "source": "apache"
	  },
	  "video/vnd.sealed.mpeg4": {
	    "source": "apache"
	  },
	  "video/vnd.sealed.swf": {
	    "source": "apache"
	  },
	  "video/vnd.sealedmedia.softseal.mov": {
	    "source": "apache"
	  },
	  "video/vnd.uvvu.mp4": {
	    "source": "apache",
	    "extensions": ["uvu","uvvu"]
	  },
	  "video/vnd.vivo": {
	    "source": "apache",
	    "extensions": ["viv"]
	  },
	  "video/webm": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["webm"]
	  },
	  "video/x-f4v": {
	    "source": "apache",
	    "extensions": ["f4v"]
	  },
	  "video/x-fli": {
	    "source": "apache",
	    "extensions": ["fli"]
	  },
	  "video/x-flv": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["flv"]
	  },
	  "video/x-m4v": {
	    "source": "apache",
	    "extensions": ["m4v"]
	  },
	  "video/x-matroska": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["mkv","mk3d","mks"]
	  },
	  "video/x-mng": {
	    "source": "apache",
	    "extensions": ["mng"]
	  },
	  "video/x-ms-asf": {
	    "source": "apache",
	    "extensions": ["asf","asx"]
	  },
	  "video/x-ms-vob": {
	    "source": "apache",
	    "extensions": ["vob"]
	  },
	  "video/x-ms-wm": {
	    "source": "apache",
	    "extensions": ["wm"]
	  },
	  "video/x-ms-wmv": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["wmv"]
	  },
	  "video/x-ms-wmx": {
	    "source": "apache",
	    "extensions": ["wmx"]
	  },
	  "video/x-ms-wvx": {
	    "source": "apache",
	    "extensions": ["wvx"]
	  },
	  "video/x-msvideo": {
	    "source": "apache",
	    "extensions": ["avi"]
	  },
	  "video/x-sgi-movie": {
	    "source": "apache",
	    "extensions": ["movie"]
	  },
	  "video/x-smv": {
	    "source": "apache",
	    "extensions": ["smv"]
	  },
	  "x-conference/x-cooltalk": {
	    "source": "apache",
	    "extensions": ["ice"]
	  },
	  "x-shader/x-fragment": {
	    "compressible": true
	  },
	  "x-shader/x-vertex": {
	    "compressible": true
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ants",
	  "bats",
	  "bears",
	  "bees",
	  "birds",
	  "buffalo",
	  "cats",
	  "chickens",
	  "cattle",
	  "dogs",
	  "dolphins",
	  "ducks",
	  "elephants",
	  "fishes",
	  "foxes",
	  "frogs",
	  "geese",
	  "goats",
	  "horses",
	  "kangaroos",
	  "lions",
	  "monkeys",
	  "owls",
	  "oxen",
	  "penguins",
	  "people",
	  "pigs",
	  "rabbits",
	  "sheep",
	  "tigers",
	  "whales",
	  "wolves",
	  "zebras",
	  "banshees",
	  "crows",
	  "black cats",
	  "chimeras",
	  "ghosts",
	  "conspirators",
	  "dragons",
	  "dwarves",
	  "elves",
	  "enchanters",
	  "exorcists",
	  "sons",
	  "foes",
	  "giants",
	  "gnomes",
	  "goblins",
	  "gooses",
	  "griffins",
	  "lycanthropes",
	  "nemesis",
	  "ogres",
	  "oracles",
	  "prophets",
	  "sorcerors",
	  "spiders",
	  "spirits",
	  "vampires",
	  "warlocks",
	  "vixens",
	  "werewolves",
	  "witches",
	  "worshipers",
	  "zombies",
	  "druids"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var team = {};
	module['exports'] = team;
	team.creature = __webpack_require__(535);
	team.name = __webpack_require__(537);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Address.state} #{creature}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####",
	  "###",
	  "##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Australia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.state_abbr = __webpack_require__(543);
	address.state = __webpack_require__(542);
	address.postcode = __webpack_require__(541);
	address.building_number = __webpack_require__(538);
	address.street_suffix = __webpack_require__(544);
	address.default_country = __webpack_require__(539);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0###",
	  "2###",
	  "3###",
	  "4###",
	  "5###",
	  "6###",
	  "7###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "New South Wales",
	  "Queensland",
	  "Northern Territory",
	  "South Australia",
	  "Western Australia",
	  "Tasmania",
	  "Australian Capital Territory",
	  "Victoria"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "NSW",
	  "QLD",
	  "NT",
	  "SA",
	  "WA",
	  "TAS",
	  "ACT",
	  "VIC"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Avenue",
	  "Boulevard",
	  "Circle",
	  "Circuit",
	  "Court",
	  "Crescent",
	  "Crest",
	  "Drive",
	  "Estate Dr",
	  "Grove",
	  "Hill",
	  "Island",
	  "Junction",
	  "Knoll",
	  "Lane",
	  "Loop",
	  "Mall",
	  "Manor",
	  "Meadow",
	  "Mews",
	  "Parade",
	  "Parkway",
	  "Pass",
	  "Place",
	  "Plaza",
	  "Ridge",
	  "Road",
	  "Run",
	  "Square",
	  "Station St",
	  "Street",
	  "Summit",
	  "Terrace",
	  "Track",
	  "Trail",
	  "View Rd",
	  "Way"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(546);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pty Ltd",
	  "and Sons",
	  "Corp",
	  "Group",
	  "Brothers",
	  "Partners"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_AU = {};
	module['exports'] = en_AU;
	en_AU.title = "Australia (English)";
	en_AU.name = __webpack_require__(551);
	en_AU.company = __webpack_require__(545);
	en_AU.internet = __webpack_require__(549);
	en_AU.address = __webpack_require__(540);
	en_AU.phone_number = __webpack_require__(554);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com.au",
	  "com",
	  "net.au",
	  "net",
	  "org.au",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(548);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "William",
	  "Jack",
	  "Oliver",
	  "Joshua",
	  "Thomas",
	  "Lachlan",
	  "Cooper",
	  "Noah",
	  "Ethan",
	  "Lucas",
	  "James",
	  "Samuel",
	  "Jacob",
	  "Liam",
	  "Alexander",
	  "Benjamin",
	  "Max",
	  "Isaac",
	  "Daniel",
	  "Riley",
	  "Ryan",
	  "Charlie",
	  "Tyler",
	  "Jake",
	  "Matthew",
	  "Xavier",
	  "Harry",
	  "Jayden",
	  "Nicholas",
	  "Harrison",
	  "Levi",
	  "Luke",
	  "Adam",
	  "Henry",
	  "Aiden",
	  "Dylan",
	  "Oscar",
	  "Michael",
	  "Jackson",
	  "Logan",
	  "Joseph",
	  "Blake",
	  "Nathan",
	  "Connor",
	  "Elijah",
	  "Nate",
	  "Archie",
	  "Bailey",
	  "Marcus",
	  "Cameron",
	  "Jordan",
	  "Zachary",
	  "Caleb",
	  "Hunter",
	  "Ashton",
	  "Toby",
	  "Aidan",
	  "Hayden",
	  "Mason",
	  "Hamish",
	  "Edward",
	  "Angus",
	  "Eli",
	  "Sebastian",
	  "Christian",
	  "Patrick",
	  "Andrew",
	  "Anthony",
	  "Luca",
	  "Kai",
	  "Beau",
	  "Alex",
	  "George",
	  "Callum",
	  "Finn",
	  "Zac",
	  "Mitchell",
	  "Jett",
	  "Jesse",
	  "Gabriel",
	  "Leo",
	  "Declan",
	  "Charles",
	  "Jasper",
	  "Jonathan",
	  "Aaron",
	  "Hugo",
	  "David",
	  "Christopher",
	  "Chase",
	  "Owen",
	  "Justin",
	  "Ali",
	  "Darcy",
	  "Lincoln",
	  "Cody",
	  "Phoenix",
	  "Sam",
	  "John",
	  "Joel",
	  "Isabella",
	  "Ruby",
	  "Chloe",
	  "Olivia",
	  "Charlotte",
	  "Mia",
	  "Lily",
	  "Emily",
	  "Ella",
	  "Sienna",
	  "Sophie",
	  "Amelia",
	  "Grace",
	  "Ava",
	  "Zoe",
	  "Emma",
	  "Sophia",
	  "Matilda",
	  "Hannah",
	  "Jessica",
	  "Lucy",
	  "Georgia",
	  "Sarah",
	  "Abigail",
	  "Zara",
	  "Eva",
	  "Scarlett",
	  "Jasmine",
	  "Chelsea",
	  "Lilly",
	  "Ivy",
	  "Isla",
	  "Evie",
	  "Isabelle",
	  "Maddison",
	  "Layla",
	  "Summer",
	  "Annabelle",
	  "Alexis",
	  "Elizabeth",
	  "Bella",
	  "Holly",
	  "Lara",
	  "Madison",
	  "Alyssa",
	  "Maya",
	  "Tahlia",
	  "Claire",
	  "Hayley",
	  "Imogen",
	  "Jade",
	  "Ellie",
	  "Sofia",
	  "Addison",
	  "Molly",
	  "Phoebe",
	  "Alice",
	  "Savannah",
	  "Gabriella",
	  "Kayla",
	  "Mikayla",
	  "Abbey",
	  "Eliza",
	  "Willow",
	  "Alexandra",
	  "Poppy",
	  "Samantha",
	  "Stella",
	  "Amy",
	  "Amelie",
	  "Anna",
	  "Piper",
	  "Gemma",
	  "Isabel",
	  "Victoria",
	  "Stephanie",
	  "Caitlin",
	  "Heidi",
	  "Paige",
	  "Rose",
	  "Amber",
	  "Audrey",
	  "Claudia",
	  "Taylor",
	  "Madeline",
	  "Angelina",
	  "Natalie",
	  "Charli",
	  "Lauren",
	  "Ashley",
	  "Violet",
	  "Mackenzie",
	  "Abby",
	  "Skye",
	  "Lillian",
	  "Alana",
	  "Lola",
	  "Leah",
	  "Eve",
	  "Kiara"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(550);
	name.last_name = __webpack_require__(552);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Smith",
	  "Jones",
	  "Williams",
	  "Brown",
	  "Wilson",
	  "Taylor",
	  "Johnson",
	  "White",
	  "Martin",
	  "Anderson",
	  "Thompson",
	  "Nguyen",
	  "Thomas",
	  "Walker",
	  "Harris",
	  "Lee",
	  "Ryan",
	  "Robinson",
	  "Kelly",
	  "King",
	  "Davis",
	  "Wright",
	  "Evans",
	  "Roberts",
	  "Green",
	  "Hall",
	  "Wood",
	  "Jackson",
	  "Clarke",
	  "Patel",
	  "Khan",
	  "Lewis",
	  "James",
	  "Phillips",
	  "Mason",
	  "Mitchell",
	  "Rose",
	  "Davies",
	  "Rodriguez",
	  "Cox",
	  "Alexander",
	  "Garden",
	  "Campbell",
	  "Johnston",
	  "Moore",
	  "Smyth",
	  "O'neill",
	  "Doherty",
	  "Stewart",
	  "Quinn",
	  "Murphy",
	  "Graham",
	  "Mclaughlin",
	  "Hamilton",
	  "Murray",
	  "Hughes",
	  "Robertson",
	  "Thomson",
	  "Scott",
	  "Macdonald",
	  "Reid",
	  "Clark",
	  "Ross",
	  "Young",
	  "Watson",
	  "Paterson",
	  "Morrison",
	  "Morgan",
	  "Griffiths",
	  "Edwards",
	  "Rees",
	  "Jenkins",
	  "Owen",
	  "Price",
	  "Moss",
	  "Richards",
	  "Abbott",
	  "Adams",
	  "Armstrong",
	  "Bahringer",
	  "Bailey",
	  "Barrows",
	  "Bartell",
	  "Bartoletti",
	  "Barton",
	  "Bauch",
	  "Baumbach",
	  "Bayer",
	  "Beahan",
	  "Beatty",
	  "Becker",
	  "Beier",
	  "Berge",
	  "Bergstrom",
	  "Bode",
	  "Bogan",
	  "Borer",
	  "Bosco",
	  "Botsford",
	  "Boyer",
	  "Boyle",
	  "Braun",
	  "Bruen",
	  "Carroll",
	  "Carter",
	  "Cartwright",
	  "Casper",
	  "Cassin",
	  "Champlin",
	  "Christiansen",
	  "Cole",
	  "Collier",
	  "Collins",
	  "Connelly",
	  "Conroy",
	  "Corkery",
	  "Cormier",
	  "Corwin",
	  "Cronin",
	  "Crooks",
	  "Cruickshank",
	  "Cummings",
	  "D'amore",
	  "Daniel",
	  "Dare",
	  "Daugherty",
	  "Dickens",
	  "Dickinson",
	  "Dietrich",
	  "Donnelly",
	  "Dooley",
	  "Douglas",
	  "Doyle",
	  "Durgan",
	  "Ebert",
	  "Emard",
	  "Emmerich",
	  "Erdman",
	  "Ernser",
	  "Fadel",
	  "Fahey",
	  "Farrell",
	  "Fay",
	  "Feeney",
	  "Feil",
	  "Ferry",
	  "Fisher",
	  "Flatley",
	  "Gibson",
	  "Gleason",
	  "Glover",
	  "Goldner",
	  "Goodwin",
	  "Grady",
	  "Grant",
	  "Greenfelder",
	  "Greenholt",
	  "Grimes",
	  "Gutmann",
	  "Hackett",
	  "Hahn",
	  "Haley",
	  "Hammes",
	  "Hand",
	  "Hane",
	  "Hansen",
	  "Harber",
	  "Hartmann",
	  "Harvey",
	  "Hayes",
	  "Heaney",
	  "Heathcote",
	  "Heller",
	  "Hermann",
	  "Hermiston",
	  "Hessel",
	  "Hettinger",
	  "Hickle",
	  "Hill",
	  "Hills",
	  "Hoppe",
	  "Howe",
	  "Howell",
	  "Hudson",
	  "Huel",
	  "Hyatt",
	  "Jacobi",
	  "Jacobs",
	  "Jacobson",
	  "Jerde",
	  "Johns",
	  "Keeling",
	  "Kemmer",
	  "Kessler",
	  "Kiehn",
	  "Kirlin",
	  "Klein",
	  "Koch",
	  "Koelpin",
	  "Kohler",
	  "Koss",
	  "Kovacek",
	  "Kreiger",
	  "Kris",
	  "Kuhlman",
	  "Kuhn",
	  "Kulas",
	  "Kunde",
	  "Kutch",
	  "Lakin",
	  "Lang",
	  "Langworth",
	  "Larkin",
	  "Larson",
	  "Leannon",
	  "Leffler",
	  "Little",
	  "Lockman",
	  "Lowe",
	  "Lynch",
	  "Mann",
	  "Marks",
	  "Marvin",
	  "Mayer",
	  "Mccullough",
	  "Mcdermott",
	  "Mckenzie",
	  "Miller",
	  "Mills",
	  "Monahan",
	  "Morissette",
	  "Mueller",
	  "Muller",
	  "Nader",
	  "Nicolas",
	  "Nolan",
	  "O'connell",
	  "O'conner",
	  "O'hara",
	  "O'keefe",
	  "Olson",
	  "O'reilly",
	  "Parisian",
	  "Parker",
	  "Quigley",
	  "Reilly",
	  "Reynolds",
	  "Rice",
	  "Ritchie",
	  "Rohan",
	  "Rolfson",
	  "Rowe",
	  "Russel",
	  "Rutherford",
	  "Sanford",
	  "Sauer",
	  "Schmidt",
	  "Schmitt",
	  "Schneider",
	  "Schroeder",
	  "Schultz",
	  "Shields",
	  "Smitham",
	  "Spencer",
	  "Stanton",
	  "Stark",
	  "Stokes",
	  "Swift",
	  "Tillman",
	  "Towne",
	  "Tremblay",
	  "Tromp",
	  "Turcotte",
	  "Turner",
	  "Walsh",
	  "Walter",
	  "Ward",
	  "Waters",
	  "Weber",
	  "Welch",
	  "West",
	  "Wilderman",
	  "Wilkinson",
	  "Williamson",
	  "Windler",
	  "Wolf"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0# #### ####",
	  "+61 # #### ####",
	  "04## ### ###",
	  "+61 4## ### ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(553);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_BORK = {};
	module['exports'] = en_BORK;
	en_BORK.title = "Bork (English)";
	en_BORK.lorem = __webpack_require__(556);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(557);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Boot",
	  "I",
	  "Nu",
	  "Nur",
	  "Tu",
	  "Um",
	  "a",
	  "becoose-a",
	  "boot",
	  "bork",
	  "burn",
	  "chuuses",
	  "cumplete-a",
	  "cun",
	  "cunseqooences",
	  "curcoomstunces",
	  "dee",
	  "deeslikes",
	  "denuoonceeng",
	  "desures",
	  "du",
	  "eccuoont",
	  "ectooel",
	  "edfuntege-a",
	  "efueeds",
	  "egeeen",
	  "ell",
	  "ere-a",
	  "feend",
	  "foolt",
	  "frum",
	  "geefe-a",
	  "gesh",
	  "greet",
	  "heem",
	  "heppeeness",
	  "hes",
	  "hoo",
	  "hoomun",
	  "idea",
	  "ifer",
	  "in",
	  "incuoonter",
	  "injuy",
	  "itselff",
	  "ixcept",
	  "ixemple-a",
	  "ixerceese-a",
	  "ixpleeen",
	  "ixplurer",
	  "ixpuoond",
	  "ixtremely",
	  "knoo",
	  "lebureeuoos",
	  "lufes",
	  "meestekee",
	  "mester-booeelder",
	  "moost",
	  "mun",
	  "nu",
	  "nut",
	  "oobteeen",
	  "oocceseeunelly",
	  "ooccoor",
	  "ooff",
	  "oone-a",
	  "oor",
	  "peeen",
	  "peeenffool",
	  "physeecel",
	  "pleesoore-a",
	  "poorsooe-a",
	  "poorsooes",
	  "preeesing",
	  "prucoore-a",
	  "prudooces",
	  "reeght",
	  "reshunelly",
	  "resooltunt",
	  "sume-a",
	  "teecheengs",
	  "teke-a",
	  "thees",
	  "thet",
	  "thuse-a",
	  "treefiel",
	  "troot",
	  "tu",
	  "tueel",
	  "und",
	  "undertekes",
	  "unnuyeeng",
	  "uny",
	  "unyune-a",
	  "us",
	  "veell",
	  "veet",
	  "ves",
	  "vheech",
	  "vhu",
	  "yuoo",
	  "zee",
	  "zeere-a"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Canada"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.state = __webpack_require__(561);
	address.state_abbr = __webpack_require__(562);
	address.default_country = __webpack_require__(558);
	address.postcode = __webpack_require__(560);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "?#? #?#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alberta",
	  "British Columbia",
	  "Manitoba",
	  "New Brunswick",
	  "Newfoundland and Labrador",
	  "Nova Scotia",
	  "Northwest Territories",
	  "Nunavut",
	  "Ontario",
	  "Prince Edward Island",
	  "Quebec",
	  "Saskatchewan",
	  "Yukon"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AB",
	  "BC",
	  "MB",
	  "NB",
	  "NL",
	  "NS",
	  "NU",
	  "NT",
	  "ON",
	  "PE",
	  "QC",
	  "SK",
	  "YT"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_CA = {};
	module['exports'] = en_CA;
	en_CA.title = "Canada (English)";
	en_CA.address = __webpack_require__(559);
	en_CA.internet = __webpack_require__(566);
	en_CA.phone_number = __webpack_require__(568);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ca",
	  "com",
	  "biz",
	  "info",
	  "name",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.ca",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(565);
	internet.domain_suffix = __webpack_require__(564);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###-###-####",
	  "(###)###-####",
	  "###.###.####",
	  "1-###-###-####",
	  "###-###-#### x###",
	  "(###)###-#### x###",
	  "1-###-###-#### x###",
	  "###.###.#### x###",
	  "###-###-#### x####",
	  "(###)###-#### x####",
	  "1-###-###-#### x####",
	  "###.###.#### x####",
	  "###-###-#### x#####",
	  "(###)###-#### x#####",
	  "1-###-###-#### x#####",
	  "###.###.#### x#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(567);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Avon",
	  "Bedfordshire",
	  "Berkshire",
	  "Borders",
	  "Buckinghamshire",
	  "Cambridgeshire",
	  "Central",
	  "Cheshire",
	  "Cleveland",
	  "Clwyd",
	  "Cornwall",
	  "County Antrim",
	  "County Armagh",
	  "County Down",
	  "County Fermanagh",
	  "County Londonderry",
	  "County Tyrone",
	  "Cumbria",
	  "Derbyshire",
	  "Devon",
	  "Dorset",
	  "Dumfries and Galloway",
	  "Durham",
	  "Dyfed",
	  "East Sussex",
	  "Essex",
	  "Fife",
	  "Gloucestershire",
	  "Grampian",
	  "Greater Manchester",
	  "Gwent",
	  "Gwynedd County",
	  "Hampshire",
	  "Herefordshire",
	  "Hertfordshire",
	  "Highlands and Islands",
	  "Humberside",
	  "Isle of Wight",
	  "Kent",
	  "Lancashire",
	  "Leicestershire",
	  "Lincolnshire",
	  "Lothian",
	  "Merseyside",
	  "Mid Glamorgan",
	  "Norfolk",
	  "North Yorkshire",
	  "Northamptonshire",
	  "Northumberland",
	  "Nottinghamshire",
	  "Oxfordshire",
	  "Powys",
	  "Rutland",
	  "Shropshire",
	  "Somerset",
	  "South Glamorgan",
	  "South Yorkshire",
	  "Staffordshire",
	  "Strathclyde",
	  "Suffolk",
	  "Surrey",
	  "Tayside",
	  "Tyne and Wear",
	  "Warwickshire",
	  "West Glamorgan",
	  "West Midlands",
	  "West Sussex",
	  "West Yorkshire",
	  "Wiltshire",
	  "Worcestershire"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "England",
	  "Scotland",
	  "Wales",
	  "Northern Ireland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.county = __webpack_require__(569);
	address.uk_country = __webpack_require__(573);
	address.default_country = __webpack_require__(570);
	address.postcode = __webpack_require__(572);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "??# #??",
	  "??## #??",
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "England",
	  "Scotland",
	  "Wales",
	  "Northern Ireland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "074## ######",
	  "075## ######",
	  "076## ######",
	  "077## ######",
	  "078## ######",
	  "079## ######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(574);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_GB = {};
	module['exports'] = en_GB;
	en_GB.title = "Great Britain (English)";
	en_GB.address = __webpack_require__(571);
	en_GB.internet = __webpack_require__(578);
	en_GB.phone_number = __webpack_require__(580);
	en_GB.cell_phone = __webpack_require__(575);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "co.uk",
	  "com",
	  "biz",
	  "info",
	  "name"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(577);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "01#### #####",
	  "01### ######",
	  "01#1 ### ####",
	  "011# ### ####",
	  "02# #### ####",
	  "03## ### ####",
	  "055 #### ####",
	  "056 #### ####",
	  "0800 ### ####",
	  "08## ### ####",
	  "09## ### ####",
	  "016977 ####",
	  "01### #####",
	  "0500 ######",
	  "0800 ######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(579);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Carlow",
	  "Cavan",
	  "Clare",
	  "Cork",
	  "Donegal",
	  "Dublin",
	  "Galway",
	  "Kerry",
	  "Kildare",
	  "Kilkenny",
	  "Laois",
	  "Leitrim",
	  "Limerick",
	  "Longford",
	  "Louth",
	  "Mayo",
	  "Meath",
	  "Monaghan",
	  "Offaly",
	  "Roscommon",
	  "Sligo",
	  "Tipperary",
	  "Waterford",
	  "Westmeath",
	  "Wexford",
	  "Wicklow"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ireland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.county = __webpack_require__(581);
	address.default_country = __webpack_require__(582);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "082 ### ####",
	  "083 ### ####",
	  "085 ### ####",
	  "086 ### ####",
	  "087 ### ####",
	  "089 ### ####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(584);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_IE = {};
	module['exports'] = en_IE;
	en_IE.title = "Ireland (English)";
	en_IE.address = __webpack_require__(583);
	en_IE.internet = __webpack_require__(588);
	en_IE.phone_number = __webpack_require__(590);
	en_IE.cell_phone = __webpack_require__(585);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ie",
	  "com",
	  "net",
	  "info",
	  "eu"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(587);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "01 #######",
	  "021 #######",
	  "022 #######",
	  "023 #######",
	  "024 #######",
	  "025 #######",
	  "026 #######",
	  "027 #######",
	  "028 #######",
	  "029 #######",
	  "0402 #######",
	  "0404 #######",
	  "041 #######",
	  "042 #######",
	  "043 #######",
	  "044 #######",
	  "045 #######",
	  "046 #######",
	  "047 #######",
	  "049 #######",
	  "0504 #######",
	  "0505 #######",
	  "051 #######",
	  "052 #######",
	  "053 #######",
	  "056 #######",
	  "057 #######",
	  "058 #######",
	  "059 #######",
	  "061 #######",
	  "062 #######",
	  "063 #######",
	  "064 #######",
	  "065 #######",
	  "066 #######",
	  "067 #######",
	  "068 #######",
	  "069 #######",
	  "071 #######",
	  "074 #######",
	  "090 #######",
	  "091 #######",
	  "093 #######",
	  "094 #######",
	  "095 #######",
	  "096 #######",
	  "097 #######",
	  "098 #######",
	  "099 #######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(589);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "India",
	  "Indian Republic",
	  "Bharat",
	  "Hindustan"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.postcode = __webpack_require__(593);
	address.state = __webpack_require__(594);
	address.state_abbr = __webpack_require__(595);
	address.default_country = __webpack_require__(591);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "?#? #?#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Andra Pradesh",
	  "Arunachal Pradesh",
	  "Assam",
	  "Bihar",
	  "Chhattisgarh",
	  "Goa",
	  "Gujarat",
	  "Haryana",
	  "Himachal Pradesh",
	  "Jammu and Kashmir",
	  "Jharkhand",
	  "Karnataka",
	  "Kerala",
	  "Madya Pradesh",
	  "Maharashtra",
	  "Manipur",
	  "Meghalaya",
	  "Mizoram",
	  "Nagaland",
	  "Orissa",
	  "Punjab",
	  "Rajasthan",
	  "Sikkim",
	  "Tamil Nadu",
	  "Tripura",
	  "Uttaranchal",
	  "Uttar Pradesh",
	  "West Bengal",
	  "Andaman and Nicobar Islands",
	  "Chandigarh",
	  "Dadar and Nagar Haveli",
	  "Daman and Diu",
	  "Delhi",
	  "Lakshadweep",
	  "Pondicherry"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AP",
	  "AR",
	  "AS",
	  "BR",
	  "CG",
	  "DL",
	  "GA",
	  "GJ",
	  "HR",
	  "HP",
	  "JK",
	  "JS",
	  "KA",
	  "KL",
	  "MP",
	  "MH",
	  "MN",
	  "ML",
	  "MZ",
	  "NL",
	  "OR",
	  "PB",
	  "RJ",
	  "SK",
	  "TN",
	  "TR",
	  "UK",
	  "UP",
	  "WB",
	  "AN",
	  "CH",
	  "DN",
	  "DD",
	  "LD",
	  "PY"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(597);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pvt Ltd",
	  "Limited",
	  "Ltd",
	  "and Sons",
	  "Corp",
	  "Group",
	  "Brothers"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_IND = {};
	module['exports'] = en_IND;
	en_IND.title = "India (English)";
	en_IND.name = __webpack_require__(603);
	en_IND.address = __webpack_require__(592);
	en_IND.internet = __webpack_require__(601);
	en_IND.company = __webpack_require__(596);
	en_IND.phone_number = __webpack_require__(606);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "in",
	  "com",
	  "biz",
	  "info",
	  "name",
	  "net",
	  "org",
	  "co.in"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.co.in",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(600);
	internet.domain_suffix = __webpack_require__(599);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aadrika",
	  "Aanandinii",
	  "Aaratrika",
	  "Aarya",
	  "Arya",
	  "Aashritha",
	  "Aatmaja",
	  "Atmaja",
	  "Abhaya",
	  "Adwitiya",
	  "Agrata",
	  "Ahilya",
	  "Ahalya",
	  "Aishani",
	  "Akshainie",
	  "Akshata",
	  "Akshita",
	  "Akula",
	  "Ambar",
	  "Amodini",
	  "Amrita",
	  "Amritambu",
	  "Anala",
	  "Anamika",
	  "Ananda",
	  "Anandamayi",
	  "Ananta",
	  "Anila",
	  "Anjali",
	  "Anjushri",
	  "Anjushree",
	  "Annapurna",
	  "Anshula",
	  "Anuja",
	  "Anusuya",
	  "Anasuya",
	  "Anasooya",
	  "Anwesha",
	  "Apsara",
	  "Aruna",
	  "Asha",
	  "Aasa",
	  "Aasha",
	  "Aslesha",
	  "Atreyi",
	  "Atreyee",
	  "Avani",
	  "Abani",
	  "Avantika",
	  "Ayushmati",
	  "Baidehi",
	  "Vaidehi",
	  "Bala",
	  "Baala",
	  "Balamani",
	  "Basanti",
	  "Vasanti",
	  "Bela",
	  "Bhadra",
	  "Bhagirathi",
	  "Bhagwanti",
	  "Bhagwati",
	  "Bhamini",
	  "Bhanumati",
	  "Bhaanumati",
	  "Bhargavi",
	  "Bhavani",
	  "Bhilangana",
	  "Bilwa",
	  "Bilva",
	  "Buddhana",
	  "Chakrika",
	  "Chanda",
	  "Chandi",
	  "Chandni",
	  "Chandini",
	  "Chandani",
	  "Chandra",
	  "Chandira",
	  "Chandrabhaga",
	  "Chandrakala",
	  "Chandrakin",
	  "Chandramani",
	  "Chandrani",
	  "Chandraprabha",
	  "Chandraswaroopa",
	  "Chandravati",
	  "Chapala",
	  "Charumati",
	  "Charvi",
	  "Chatura",
	  "Chitrali",
	  "Chitramala",
	  "Chitrangada",
	  "Daksha",
	  "Dakshayani",
	  "Damayanti",
	  "Darshwana",
	  "Deepali",
	  "Dipali",
	  "Deeptimoyee",
	  "Deeptimayee",
	  "Devangana",
	  "Devani",
	  "Devasree",
	  "Devi",
	  "Daevi",
	  "Devika",
	  "Daevika",
	  "Dhaanyalakshmi",
	  "Dhanalakshmi",
	  "Dhana",
	  "Dhanadeepa",
	  "Dhara",
	  "Dharani",
	  "Dharitri",
	  "Dhatri",
	  "Diksha",
	  "Deeksha",
	  "Divya",
	  "Draupadi",
	  "Dulari",
	  "Durga",
	  "Durgeshwari",
	  "Ekaparnika",
	  "Elakshi",
	  "Enakshi",
	  "Esha",
	  "Eshana",
	  "Eshita",
	  "Gautami",
	  "Gayatri",
	  "Geeta",
	  "Geetanjali",
	  "Gitanjali",
	  "Gemine",
	  "Gemini",
	  "Girja",
	  "Girija",
	  "Gita",
	  "Hamsini",
	  "Harinakshi",
	  "Harita",
	  "Heema",
	  "Himadri",
	  "Himani",
	  "Hiranya",
	  "Indira",
	  "Jaimini",
	  "Jaya",
	  "Jyoti",
	  "Jyotsana",
	  "Kali",
	  "Kalinda",
	  "Kalpana",
	  "Kalyani",
	  "Kama",
	  "Kamala",
	  "Kamla",
	  "Kanchan",
	  "Kanishka",
	  "Kanti",
	  "Kashyapi",
	  "Kumari",
	  "Kumuda",
	  "Lakshmi",
	  "Laxmi",
	  "Lalita",
	  "Lavanya",
	  "Leela",
	  "Lila",
	  "Leela",
	  "Madhuri",
	  "Malti",
	  "Malati",
	  "Mandakini",
	  "Mandaakin",
	  "Mangala",
	  "Mangalya",
	  "Mani",
	  "Manisha",
	  "Manjusha",
	  "Meena",
	  "Mina",
	  "Meenakshi",
	  "Minakshi",
	  "Menka",
	  "Menaka",
	  "Mohana",
	  "Mohini",
	  "Nalini",
	  "Nikita",
	  "Ojaswini",
	  "Omana",
	  "Oormila",
	  "Urmila",
	  "Opalina",
	  "Opaline",
	  "Padma",
	  "Parvati",
	  "Poornima",
	  "Purnima",
	  "Pramila",
	  "Prasanna",
	  "Preity",
	  "Prema",
	  "Priya",
	  "Priyala",
	  "Pushti",
	  "Radha",
	  "Rageswari",
	  "Rageshwari",
	  "Rajinder",
	  "Ramaa",
	  "Rati",
	  "Rita",
	  "Rohana",
	  "Rukhmani",
	  "Rukmin",
	  "Rupinder",
	  "Sanya",
	  "Sarada",
	  "Sharda",
	  "Sarala",
	  "Sarla",
	  "Saraswati",
	  "Sarisha",
	  "Saroja",
	  "Shakti",
	  "Shakuntala",
	  "Shanti",
	  "Sharmila",
	  "Shashi",
	  "Shashikala",
	  "Sheela",
	  "Shivakari",
	  "Shobhana",
	  "Shresth",
	  "Shresthi",
	  "Shreya",
	  "Shreyashi",
	  "Shridevi",
	  "Shrishti",
	  "Shubha",
	  "Shubhaprada",
	  "Siddhi",
	  "Sitara",
	  "Sloka",
	  "Smita",
	  "Smriti",
	  "Soma",
	  "Subhashini",
	  "Subhasini",
	  "Sucheta",
	  "Sudeva",
	  "Sujata",
	  "Sukanya",
	  "Suma",
	  "Suma",
	  "Sumitra",
	  "Sunita",
	  "Suryakantam",
	  "Sushma",
	  "Swara",
	  "Swarnalata",
	  "Sweta",
	  "Shwet",
	  "Tanirika",
	  "Tanushree",
	  "Tanushri",
	  "Tanushri",
	  "Tanya",
	  "Tara",
	  "Trisha",
	  "Uma",
	  "Usha",
	  "Vaijayanti",
	  "Vaijayanthi",
	  "Baijayanti",
	  "Vaishvi",
	  "Vaishnavi",
	  "Vaishno",
	  "Varalakshmi",
	  "Vasudha",
	  "Vasundhara",
	  "Veda",
	  "Vedanshi",
	  "Vidya",
	  "Vimala",
	  "Vrinda",
	  "Vrund",
	  "Aadi",
	  "Aadidev",
	  "Aadinath",
	  "Aaditya",
	  "Aagam",
	  "Aagney",
	  "Aamod",
	  "Aanandaswarup",
	  "Anand Swarup",
	  "Aanjaneya",
	  "Anjaneya",
	  "Aaryan",
	  "Aryan",
	  "Aatmaj",
	  "Aatreya",
	  "Aayushmaan",
	  "Aayushman",
	  "Abhaidev",
	  "Abhaya",
	  "Abhirath",
	  "Abhisyanta",
	  "Acaryatanaya",
	  "Achalesvara",
	  "Acharyanandana",
	  "Acharyasuta",
	  "Achintya",
	  "Achyut",
	  "Adheesh",
	  "Adhiraj",
	  "Adhrit",
	  "Adikavi",
	  "Adinath",
	  "Aditeya",
	  "Aditya",
	  "Adityanandan",
	  "Adityanandana",
	  "Adripathi",
	  "Advaya",
	  "Agasti",
	  "Agastya",
	  "Agneya",
	  "Aagneya",
	  "Agnimitra",
	  "Agniprava",
	  "Agnivesh",
	  "Agrata",
	  "Ajit",
	  "Ajeet",
	  "Akroor",
	  "Akshaj",
	  "Akshat",
	  "Akshayakeerti",
	  "Alok",
	  "Aalok",
	  "Amaranaath",
	  "Amarnath",
	  "Amaresh",
	  "Ambar",
	  "Ameyatma",
	  "Amish",
	  "Amogh",
	  "Amrit",
	  "Anaadi",
	  "Anagh",
	  "Anal",
	  "Anand",
	  "Aanand",
	  "Anang",
	  "Anil",
	  "Anilaabh",
	  "Anilabh",
	  "Anish",
	  "Ankal",
	  "Anunay",
	  "Anurag",
	  "Anuraag",
	  "Archan",
	  "Arindam",
	  "Arjun",
	  "Arnesh",
	  "Arun",
	  "Ashlesh",
	  "Ashok",
	  "Atmanand",
	  "Atmananda",
	  "Avadhesh",
	  "Baalaaditya",
	  "Baladitya",
	  "Baalagopaal",
	  "Balgopal",
	  "Balagopal",
	  "Bahula",
	  "Bakula",
	  "Bala",
	  "Balaaditya",
	  "Balachandra",
	  "Balagovind",
	  "Bandhu",
	  "Bandhul",
	  "Bankim",
	  "Bankimchandra",
	  "Bhadrak",
	  "Bhadraksh",
	  "Bhadran",
	  "Bhagavaan",
	  "Bhagvan",
	  "Bharadwaj",
	  "Bhardwaj",
	  "Bharat",
	  "Bhargava",
	  "Bhasvan",
	  "Bhaasvan",
	  "Bhaswar",
	  "Bhaaswar",
	  "Bhaumik",
	  "Bhaves",
	  "Bheeshma",
	  "Bhisham",
	  "Bhishma",
	  "Bhima",
	  "Bhoj",
	  "Bhramar",
	  "Bhudev",
	  "Bhudeva",
	  "Bhupati",
	  "Bhoopati",
	  "Bhoopat",
	  "Bhupen",
	  "Bhushan",
	  "Bhooshan",
	  "Bhushit",
	  "Bhooshit",
	  "Bhuvanesh",
	  "Bhuvaneshwar",
	  "Bilva",
	  "Bodhan",
	  "Brahma",
	  "Brahmabrata",
	  "Brahmanandam",
	  "Brahmaanand",
	  "Brahmdev",
	  "Brajendra",
	  "Brajesh",
	  "Brijesh",
	  "Birjesh",
	  "Budhil",
	  "Chakor",
	  "Chakradhar",
	  "Chakravartee",
	  "Chakravarti",
	  "Chanakya",
	  "Chaanakya",
	  "Chandak",
	  "Chandan",
	  "Chandra",
	  "Chandraayan",
	  "Chandrabhan",
	  "Chandradev",
	  "Chandraketu",
	  "Chandramauli",
	  "Chandramohan",
	  "Chandran",
	  "Chandranath",
	  "Chapal",
	  "Charak",
	  "Charuchandra",
	  "Chaaruchandra",
	  "Charuvrat",
	  "Chatur",
	  "Chaturaanan",
	  "Chaturbhuj",
	  "Chetan",
	  "Chaten",
	  "Chaitan",
	  "Chetanaanand",
	  "Chidaakaash",
	  "Chidaatma",
	  "Chidambar",
	  "Chidambaram",
	  "Chidananda",
	  "Chinmayanand",
	  "Chinmayananda",
	  "Chiranjeev",
	  "Chiranjeeve",
	  "Chitraksh",
	  "Daiwik",
	  "Daksha",
	  "Damodara",
	  "Dandak",
	  "Dandapaani",
	  "Darshan",
	  "Datta",
	  "Dayaamay",
	  "Dayamayee",
	  "Dayaananda",
	  "Dayaanidhi",
	  "Kin",
	  "Deenabandhu",
	  "Deepan",
	  "Deepankar",
	  "Dipankar",
	  "Deependra",
	  "Dipendra",
	  "Deepesh",
	  "Dipesh",
	  "Deeptanshu",
	  "Deeptendu",
	  "Diptendu",
	  "Deeptiman",
	  "Deeptimoy",
	  "Deeptimay",
	  "Dev",
	  "Deb",
	  "Devadatt",
	  "Devagya",
	  "Devajyoti",
	  "Devak",
	  "Devdan",
	  "Deven",
	  "Devesh",
	  "Deveshwar",
	  "Devi",
	  "Devvrat",
	  "Dhananjay",
	  "Dhanapati",
	  "Dhanpati",
	  "Dhanesh",
	  "Dhanu",
	  "Dhanvin",
	  "Dharmaketu",
	  "Dhruv",
	  "Dhyanesh",
	  "Dhyaneshwar",
	  "Digambar",
	  "Digambara",
	  "Dinakar",
	  "Dinkar",
	  "Dinesh",
	  "Divaakar",
	  "Divakar",
	  "Deevakar",
	  "Divjot",
	  "Dron",
	  "Drona",
	  "Dwaipayan",
	  "Dwaipayana",
	  "Eekalabya",
	  "Ekalavya",
	  "Ekaksh",
	  "Ekaaksh",
	  "Ekaling",
	  "Ekdant",
	  "Ekadant",
	  "Gajaadhar",
	  "Gajadhar",
	  "Gajbaahu",
	  "Gajabahu",
	  "Ganak",
	  "Ganaka",
	  "Ganapati",
	  "Gandharv",
	  "Gandharva",
	  "Ganesh",
	  "Gangesh",
	  "Garud",
	  "Garuda",
	  "Gati",
	  "Gatik",
	  "Gaurang",
	  "Gauraang",
	  "Gauranga",
	  "Gouranga",
	  "Gautam",
	  "Gautama",
	  "Goutam",
	  "Ghanaanand",
	  "Ghanshyam",
	  "Ghanashyam",
	  "Giri",
	  "Girik",
	  "Girika",
	  "Girindra",
	  "Giriraaj",
	  "Giriraj",
	  "Girish",
	  "Gopal",
	  "Gopaal",
	  "Gopi",
	  "Gopee",
	  "Gorakhnath",
	  "Gorakhanatha",
	  "Goswamee",
	  "Goswami",
	  "Gotum",
	  "Gautam",
	  "Govinda",
	  "Gobinda",
	  "Gudakesha",
	  "Gudakesa",
	  "Gurdev",
	  "Guru",
	  "Hari",
	  "Harinarayan",
	  "Harit",
	  "Himadri",
	  "Hiranmay",
	  "Hiranmaya",
	  "Hiranya",
	  "Inder",
	  "Indra",
	  "Indra",
	  "Jagadish",
	  "Jagadisha",
	  "Jagathi",
	  "Jagdeep",
	  "Jagdish",
	  "Jagmeet",
	  "Jahnu",
	  "Jai",
	  "Javas",
	  "Jay",
	  "Jitendra",
	  "Jitender",
	  "Jyotis",
	  "Kailash",
	  "Kama",
	  "Kamalesh",
	  "Kamlesh",
	  "Kanak",
	  "Kanaka",
	  "Kannan",
	  "Kannen",
	  "Karan",
	  "Karthik",
	  "Kartik",
	  "Karunanidhi",
	  "Kashyap",
	  "Kiran",
	  "Kirti",
	  "Keerti",
	  "Krishna",
	  "Krishnadas",
	  "Krishnadasa",
	  "Kumar",
	  "Lai",
	  "Lakshman",
	  "Laxman",
	  "Lakshmidhar",
	  "Lakshminath",
	  "Lal",
	  "Laal",
	  "Mahendra",
	  "Mohinder",
	  "Mahesh",
	  "Maheswar",
	  "Mani",
	  "Manik",
	  "Manikya",
	  "Manoj",
	  "Marut",
	  "Mayoor",
	  "Meghnad",
	  "Meghnath",
	  "Mohan",
	  "Mukesh",
	  "Mukul",
	  "Nagabhushanam",
	  "Nanda",
	  "Narayan",
	  "Narendra",
	  "Narinder",
	  "Naveen",
	  "Navin",
	  "Nawal",
	  "Naval",
	  "Nimit",
	  "Niranjan",
	  "Nirbhay",
	  "Niro",
	  "Param",
	  "Paramartha",
	  "Pran",
	  "Pranay",
	  "Prasad",
	  "Prathamesh",
	  "Prayag",
	  "Prem",
	  "Puneet",
	  "Purushottam",
	  "Rahul",
	  "Raj",
	  "Rajan",
	  "Rajendra",
	  "Rajinder",
	  "Rajiv",
	  "Rakesh",
	  "Ramesh",
	  "Rameshwar",
	  "Ranjit",
	  "Ranjeet",
	  "Ravi",
	  "Ritesh",
	  "Rohan",
	  "Rohit",
	  "Rudra",
	  "Sachin",
	  "Sameer",
	  "Samir",
	  "Sanjay",
	  "Sanka",
	  "Sarvin",
	  "Satish",
	  "Satyen",
	  "Shankar",
	  "Shantanu",
	  "Shashi",
	  "Sher",
	  "Shiv",
	  "Siddarth",
	  "Siddhran",
	  "Som",
	  "Somu",
	  "Somnath",
	  "Subhash",
	  "Subodh",
	  "Suman",
	  "Suresh",
	  "Surya",
	  "Suryakant",
	  "Suryakanta",
	  "Sushil",
	  "Susheel",
	  "Swami",
	  "Swapnil",
	  "Tapan",
	  "Tara",
	  "Tarun",
	  "Tej",
	  "Tejas",
	  "Trilochan",
	  "Trilochana",
	  "Trilok",
	  "Trilokesh",
	  "Triloki",
	  "Triloki Nath",
	  "Trilokanath",
	  "Tushar",
	  "Udai",
	  "Udit",
	  "Ujjawal",
	  "Ujjwal",
	  "Umang",
	  "Upendra",
	  "Uttam",
	  "Vasudev",
	  "Vasudeva",
	  "Vedang",
	  "Vedanga",
	  "Vidhya",
	  "Vidur",
	  "Vidhur",
	  "Vijay",
	  "Vimal",
	  "Vinay",
	  "Vishnu",
	  "Bishnu",
	  "Vishwamitra",
	  "Vyas",
	  "Yogendra",
	  "Yoginder",
	  "Yogesh"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(602);
	name.last_name = __webpack_require__(604);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abbott",
	  "Achari",
	  "Acharya",
	  "Adiga",
	  "Agarwal",
	  "Ahluwalia",
	  "Ahuja",
	  "Arora",
	  "Asan",
	  "Bandopadhyay",
	  "Banerjee",
	  "Bharadwaj",
	  "Bhat",
	  "Butt",
	  "Bhattacharya",
	  "Bhattathiri",
	  "Chaturvedi",
	  "Chattopadhyay",
	  "Chopra",
	  "Desai",
	  "Deshpande",
	  "Devar",
	  "Dhawan",
	  "Dubashi",
	  "Dutta",
	  "Dwivedi",
	  "Embranthiri",
	  "Ganaka",
	  "Gandhi",
	  "Gill",
	  "Gowda",
	  "Guha",
	  "Guneta",
	  "Gupta",
	  "Iyer",
	  "Iyengar",
	  "Jain",
	  "Jha",
	  "Johar",
	  "Joshi",
	  "Kakkar",
	  "Kaniyar",
	  "Kapoor",
	  "Kaul",
	  "Kaur",
	  "Khan",
	  "Khanna",
	  "Khatri",
	  "Kocchar",
	  "Mahajan",
	  "Malik",
	  "Marar",
	  "Menon",
	  "Mehra",
	  "Mehrotra",
	  "Mishra",
	  "Mukhopadhyay",
	  "Nayar",
	  "Naik",
	  "Nair",
	  "Nambeesan",
	  "Namboothiri",
	  "Nehru",
	  "Pandey",
	  "Panicker",
	  "Patel",
	  "Patil",
	  "Pilla",
	  "Pillai",
	  "Pothuvaal",
	  "Prajapat",
	  "Rana",
	  "Reddy",
	  "Saini",
	  "Sethi",
	  "Shah",
	  "Sharma",
	  "Shukla",
	  "Singh",
	  "Sinha",
	  "Somayaji",
	  "Tagore",
	  "Talwar",
	  "Tandon",
	  "Trivedi",
	  "Varrier",
	  "Varma",
	  "Varman",
	  "Verma"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "+91###-###-####",
	  "+91##########",
	  "+91-###-#######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(605);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "United States",
	  "United States of America",
	  "USA"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.default_country = __webpack_require__(607);
	address.postcode_by_state = __webpack_require__(609);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "AL": "350##",
	  "AK": "995##",
	  "AS": "967##",
	  "AZ": "850##",
	  "AR": "717##",
	  "CA": "900##",
	  "CO": "800##",
	  "CT": "061##",
	  "DC": "204##",
	  "DE": "198##",
	  "FL": "322##",
	  "GA": "301##",
	  "HI": "967##",
	  "ID": "832##",
	  "IL": "600##",
	  "IN": "463##",
	  "IA": "510##",
	  "KS": "666##",
	  "KY": "404##",
	  "LA": "701##",
	  "ME": "042##",
	  "MD": "210##",
	  "MA": "026##",
	  "MI": "480##",
	  "MN": "555##",
	  "MS": "387##",
	  "MO": "650##",
	  "MT": "590##",
	  "NE": "688##",
	  "NV": "898##",
	  "NH": "036##",
	  "NJ": "076##",
	  "NM": "880##",
	  "NY": "122##",
	  "NC": "288##",
	  "ND": "586##",
	  "OH": "444##",
	  "OK": "730##",
	  "OR": "979##",
	  "PA": "186##",
	  "RI": "029##",
	  "SC": "299##",
	  "SD": "577##",
	  "TN": "383##",
	  "TX": "798##",
	  "UT": "847##",
	  "VT": "050##",
	  "VA": "222##",
	  "WA": "990##",
	  "WV": "247##",
	  "WI": "549##",
	  "WY": "831##"
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_US = {};
	module['exports'] = en_US;
	en_US.title = "United States (English)";
	en_US.internet = __webpack_require__(612);
	en_US.address = __webpack_require__(608);
	en_US.phone_number = __webpack_require__(615);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "us",
	  "biz",
	  "info",
	  "name",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(611);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "201",
	  "202",
	  "203",
	  "205",
	  "206",
	  "207",
	  "208",
	  "209",
	  "210",
	  "212",
	  "213",
	  "214",
	  "215",
	  "216",
	  "217",
	  "218",
	  "219",
	  "224",
	  "225",
	  "227",
	  "228",
	  "229",
	  "231",
	  "234",
	  "239",
	  "240",
	  "248",
	  "251",
	  "252",
	  "253",
	  "254",
	  "256",
	  "260",
	  "262",
	  "267",
	  "269",
	  "270",
	  "276",
	  "281",
	  "283",
	  "301",
	  "302",
	  "303",
	  "304",
	  "305",
	  "307",
	  "308",
	  "309",
	  "310",
	  "312",
	  "313",
	  "314",
	  "315",
	  "316",
	  "317",
	  "318",
	  "319",
	  "320",
	  "321",
	  "323",
	  "330",
	  "331",
	  "334",
	  "336",
	  "337",
	  "339",
	  "347",
	  "351",
	  "352",
	  "360",
	  "361",
	  "386",
	  "401",
	  "402",
	  "404",
	  "405",
	  "406",
	  "407",
	  "408",
	  "409",
	  "410",
	  "412",
	  "413",
	  "414",
	  "415",
	  "417",
	  "419",
	  "423",
	  "424",
	  "425",
	  "434",
	  "435",
	  "440",
	  "443",
	  "445",
	  "464",
	  "469",
	  "470",
	  "475",
	  "478",
	  "479",
	  "480",
	  "484",
	  "501",
	  "502",
	  "503",
	  "504",
	  "505",
	  "507",
	  "508",
	  "509",
	  "510",
	  "512",
	  "513",
	  "515",
	  "516",
	  "517",
	  "518",
	  "520",
	  "530",
	  "540",
	  "541",
	  "551",
	  "557",
	  "559",
	  "561",
	  "562",
	  "563",
	  "564",
	  "567",
	  "570",
	  "571",
	  "573",
	  "574",
	  "580",
	  "585",
	  "586",
	  "601",
	  "602",
	  "603",
	  "605",
	  "606",
	  "607",
	  "608",
	  "609",
	  "610",
	  "612",
	  "614",
	  "615",
	  "616",
	  "617",
	  "618",
	  "619",
	  "620",
	  "623",
	  "626",
	  "630",
	  "631",
	  "636",
	  "641",
	  "646",
	  "650",
	  "651",
	  "660",
	  "661",
	  "662",
	  "667",
	  "678",
	  "682",
	  "701",
	  "702",
	  "703",
	  "704",
	  "706",
	  "707",
	  "708",
	  "712",
	  "713",
	  "714",
	  "715",
	  "716",
	  "717",
	  "718",
	  "719",
	  "720",
	  "724",
	  "727",
	  "731",
	  "732",
	  "734",
	  "737",
	  "740",
	  "754",
	  "757",
	  "760",
	  "763",
	  "765",
	  "770",
	  "772",
	  "773",
	  "774",
	  "775",
	  "781",
	  "785",
	  "786",
	  "801",
	  "802",
	  "803",
	  "804",
	  "805",
	  "806",
	  "808",
	  "810",
	  "812",
	  "813",
	  "814",
	  "815",
	  "816",
	  "817",
	  "818",
	  "828",
	  "830",
	  "831",
	  "832",
	  "835",
	  "843",
	  "845",
	  "847",
	  "848",
	  "850",
	  "856",
	  "857",
	  "858",
	  "859",
	  "860",
	  "862",
	  "863",
	  "864",
	  "865",
	  "870",
	  "872",
	  "878",
	  "901",
	  "903",
	  "904",
	  "906",
	  "907",
	  "908",
	  "909",
	  "910",
	  "912",
	  "913",
	  "914",
	  "915",
	  "916",
	  "917",
	  "918",
	  "919",
	  "920",
	  "925",
	  "928",
	  "931",
	  "936",
	  "937",
	  "940",
	  "941",
	  "947",
	  "949",
	  "952",
	  "954",
	  "956",
	  "959",
	  "970",
	  "971",
	  "972",
	  "973",
	  "975",
	  "978",
	  "979",
	  "980",
	  "984",
	  "985",
	  "989"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "201",
	  "202",
	  "203",
	  "205",
	  "206",
	  "207",
	  "208",
	  "209",
	  "210",
	  "212",
	  "213",
	  "214",
	  "215",
	  "216",
	  "217",
	  "218",
	  "219",
	  "224",
	  "225",
	  "227",
	  "228",
	  "229",
	  "231",
	  "234",
	  "239",
	  "240",
	  "248",
	  "251",
	  "252",
	  "253",
	  "254",
	  "256",
	  "260",
	  "262",
	  "267",
	  "269",
	  "270",
	  "276",
	  "281",
	  "283",
	  "301",
	  "302",
	  "303",
	  "304",
	  "305",
	  "307",
	  "308",
	  "309",
	  "310",
	  "312",
	  "313",
	  "314",
	  "315",
	  "316",
	  "317",
	  "318",
	  "319",
	  "320",
	  "321",
	  "323",
	  "330",
	  "331",
	  "334",
	  "336",
	  "337",
	  "339",
	  "347",
	  "351",
	  "352",
	  "360",
	  "361",
	  "386",
	  "401",
	  "402",
	  "404",
	  "405",
	  "406",
	  "407",
	  "408",
	  "409",
	  "410",
	  "412",
	  "413",
	  "414",
	  "415",
	  "417",
	  "419",
	  "423",
	  "424",
	  "425",
	  "434",
	  "435",
	  "440",
	  "443",
	  "445",
	  "464",
	  "469",
	  "470",
	  "475",
	  "478",
	  "479",
	  "480",
	  "484",
	  "501",
	  "502",
	  "503",
	  "504",
	  "505",
	  "507",
	  "508",
	  "509",
	  "510",
	  "512",
	  "513",
	  "515",
	  "516",
	  "517",
	  "518",
	  "520",
	  "530",
	  "540",
	  "541",
	  "551",
	  "557",
	  "559",
	  "561",
	  "562",
	  "563",
	  "564",
	  "567",
	  "570",
	  "571",
	  "573",
	  "574",
	  "580",
	  "585",
	  "586",
	  "601",
	  "602",
	  "603",
	  "605",
	  "606",
	  "607",
	  "608",
	  "609",
	  "610",
	  "612",
	  "614",
	  "615",
	  "616",
	  "617",
	  "618",
	  "619",
	  "620",
	  "623",
	  "626",
	  "630",
	  "631",
	  "636",
	  "641",
	  "646",
	  "650",
	  "651",
	  "660",
	  "661",
	  "662",
	  "667",
	  "678",
	  "682",
	  "701",
	  "702",
	  "703",
	  "704",
	  "706",
	  "707",
	  "708",
	  "712",
	  "713",
	  "714",
	  "715",
	  "716",
	  "717",
	  "718",
	  "719",
	  "720",
	  "724",
	  "727",
	  "731",
	  "732",
	  "734",
	  "737",
	  "740",
	  "754",
	  "757",
	  "760",
	  "763",
	  "765",
	  "770",
	  "772",
	  "773",
	  "774",
	  "775",
	  "781",
	  "785",
	  "786",
	  "801",
	  "802",
	  "803",
	  "804",
	  "805",
	  "806",
	  "808",
	  "810",
	  "812",
	  "813",
	  "814",
	  "815",
	  "816",
	  "817",
	  "818",
	  "828",
	  "830",
	  "831",
	  "832",
	  "835",
	  "843",
	  "845",
	  "847",
	  "848",
	  "850",
	  "856",
	  "857",
	  "858",
	  "859",
	  "860",
	  "862",
	  "863",
	  "864",
	  "865",
	  "870",
	  "872",
	  "878",
	  "901",
	  "903",
	  "904",
	  "906",
	  "907",
	  "908",
	  "909",
	  "910",
	  "912",
	  "913",
	  "914",
	  "915",
	  "916",
	  "917",
	  "918",
	  "919",
	  "920",
	  "925",
	  "928",
	  "931",
	  "936",
	  "937",
	  "940",
	  "941",
	  "947",
	  "949",
	  "952",
	  "954",
	  "956",
	  "959",
	  "970",
	  "971",
	  "972",
	  "973",
	  "975",
	  "978",
	  "979",
	  "980",
	  "984",
	  "985",
	  "989"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.area_code = __webpack_require__(613);
	phone_number.exchange_code = __webpack_require__(614);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####",
	  "###",
	  "##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bondi",
	  "Burleigh Heads",
	  "Carlton",
	  "Fitzroy",
	  "Fremantle",
	  "Glenelg",
	  "Manly",
	  "Noosa",
	  "Stones Corner",
	  "St Kilda",
	  "Surry Hills",
	  "Yarra Valley"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Australia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.street_root = __webpack_require__(626);
	address.street_name = __webpack_require__(625);
	address.city_prefix = __webpack_require__(618);
	address.city = __webpack_require__(617);
	address.state_abbr = __webpack_require__(624);
	address.region = __webpack_require__(622);
	address.state = __webpack_require__(623);
	address.postcode = __webpack_require__(621);
	address.building_number = __webpack_require__(616);
	address.street_suffix = __webpack_require__(627);
	address.default_country = __webpack_require__(619);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0###",
	  "2###",
	  "3###",
	  "4###",
	  "5###",
	  "6###",
	  "7###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "South East Queensland",
	  "Wide Bay Burnett",
	  "Margaret River",
	  "Port Pirie",
	  "Gippsland",
	  "Elizabeth",
	  "Barossa"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "New South Wales",
	  "Queensland",
	  "Northern Territory",
	  "South Australia",
	  "Western Australia",
	  "Tasmania",
	  "Australian Capital Territory",
	  "Victoria"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "NSW",
	  "QLD",
	  "NT",
	  "SA",
	  "WA",
	  "TAS",
	  "ACT",
	  "VIC"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ramsay Street",
	  "Bonnie Doon",
	  "Cavill Avenue",
	  "Queen Street"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Avenue",
	  "Boulevard",
	  "Circle",
	  "Circuit",
	  "Court",
	  "Crescent",
	  "Crest",
	  "Drive",
	  "Estate Dr",
	  "Grove",
	  "Hill",
	  "Island",
	  "Junction",
	  "Knoll",
	  "Lane",
	  "Loop",
	  "Mall",
	  "Manor",
	  "Meadow",
	  "Mews",
	  "Parade",
	  "Parkway",
	  "Pass",
	  "Place",
	  "Plaza",
	  "Ridge",
	  "Road",
	  "Run",
	  "Square",
	  "Station St",
	  "Street",
	  "Summit",
	  "Terrace",
	  "Track",
	  "Trail",
	  "View Rd",
	  "Way"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(629);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pty Ltd",
	  "and Sons",
	  "Corp",
	  "Group",
	  "Brothers",
	  "Partners"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_au_ocker = {};
	module['exports'] = en_au_ocker;
	en_au_ocker.title = "Australia Ocker (English)";
	en_au_ocker.name = __webpack_require__(634);
	en_au_ocker.company = __webpack_require__(628);
	en_au_ocker.internet = __webpack_require__(632);
	en_au_ocker.address = __webpack_require__(620);
	en_au_ocker.phone_number = __webpack_require__(638);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com.au",
	  "com",
	  "net.au",
	  "net",
	  "org.au",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(631);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Charlotte",
	  "Ava",
	  "Chloe",
	  "Emily",
	  "Olivia",
	  "Zoe",
	  "Lily",
	  "Sophie",
	  "Amelia",
	  "Sofia",
	  "Ella",
	  "Isabella",
	  "Ruby",
	  "Sienna",
	  "Mia+3",
	  "Grace",
	  "Emma",
	  "Ivy",
	  "Layla",
	  "Abigail",
	  "Isla",
	  "Hannah",
	  "Zara",
	  "Lucy",
	  "Evie",
	  "Annabelle",
	  "Madison",
	  "Alice",
	  "Georgia",
	  "Maya",
	  "Madeline",
	  "Audrey",
	  "Scarlett",
	  "Isabelle",
	  "Chelsea",
	  "Mila",
	  "Holly",
	  "Indiana",
	  "Poppy",
	  "Harper",
	  "Sarah",
	  "Alyssa",
	  "Jasmine",
	  "Imogen",
	  "Hayley",
	  "Pheobe",
	  "Eva",
	  "Evelyn",
	  "Mackenzie",
	  "Ayla",
	  "Oliver",
	  "Jack",
	  "Jackson",
	  "William",
	  "Ethan",
	  "Charlie",
	  "Lucas",
	  "Cooper",
	  "Lachlan",
	  "Noah",
	  "Liam",
	  "Alexander",
	  "Max",
	  "Isaac",
	  "Thomas",
	  "Xavier",
	  "Oscar",
	  "Benjamin",
	  "Aiden",
	  "Mason",
	  "Samuel",
	  "James",
	  "Levi",
	  "Riley",
	  "Harrison",
	  "Ryan",
	  "Henry",
	  "Jacob",
	  "Joshua",
	  "Leo",
	  "Zach",
	  "Harry",
	  "Hunter",
	  "Flynn",
	  "Archie",
	  "Tyler",
	  "Elijah",
	  "Hayden",
	  "Jayden",
	  "Blake",
	  "Archer",
	  "Ashton",
	  "Sebastian",
	  "Zachery",
	  "Lincoln",
	  "Mitchell",
	  "Luca",
	  "Nathan",
	  "Kai",
	  "Connor",
	  "Tom",
	  "Nigel",
	  "Matt",
	  "Sean"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(633);
	name.last_name = __webpack_require__(635);
	name.ocker_first_name = __webpack_require__(636);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Smith",
	  "Jones",
	  "Williams",
	  "Brown",
	  "Wilson",
	  "Taylor",
	  "Morton",
	  "White",
	  "Martin",
	  "Anderson",
	  "Thompson",
	  "Nguyen",
	  "Thomas",
	  "Walker",
	  "Harris",
	  "Lee",
	  "Ryan",
	  "Robinson",
	  "Kelly",
	  "King",
	  "Rausch",
	  "Ridge",
	  "Connolly",
	  "LeQuesne"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bazza",
	  "Bluey",
	  "Davo",
	  "Johno",
	  "Shano",
	  "Shazza"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0# #### ####",
	  "+61 # #### ####",
	  "04## ### ###",
	  "+61 4## ### ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(637);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  " s/n.",
	  ", #",
	  ", ##",
	  " #",
	  " ##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Parla",
	  "Telde",
	  "Baracaldo",
	  "San Fernando",
	  "Torrevieja",
	  "Lugo",
	  "Santiago de Compostela",
	  "Gerona",
	  "Cáceres",
	  "Lorca",
	  "Coslada",
	  "Talavera de la Reina",
	  "El Puerto de Santa María",
	  "Cornellá de Llobregat",
	  "Avilés",
	  "Palencia",
	  "Gecho",
	  "Orihuela",
	  "Pontevedra",
	  "Pozuelo de Alarcón",
	  "Toledo",
	  "El Ejido",
	  "Guadalajara",
	  "Gandía",
	  "Ceuta",
	  "Ferrol",
	  "Chiclana de la Frontera",
	  "Manresa",
	  "Roquetas de Mar",
	  "Ciudad Real",
	  "Rubí",
	  "Benidorm",
	  "San Sebastían de los Reyes",
	  "Ponferrada",
	  "Zamora",
	  "Alcalá de Guadaira",
	  "Fuengirola",
	  "Mijas",
	  "Sanlúcar de Barrameda",
	  "La Línea de la Concepción",
	  "Majadahonda",
	  "Sagunto",
	  "El Prat de LLobregat",
	  "Viladecans",
	  "Linares",
	  "Alcoy",
	  "Irún",
	  "Estepona",
	  "Torremolinos",
	  "Rivas-Vaciamadrid",
	  "Molina de Segura",
	  "Paterna",
	  "Granollers",
	  "Santa Lucía de Tirajana",
	  "Motril",
	  "Cerdañola del Vallés",
	  "Arrecife",
	  "Segovia",
	  "Torrelavega",
	  "Elda",
	  "Mérida",
	  "Ávila",
	  "Valdemoro",
	  "Cuenta",
	  "Collado Villalba",
	  "Benalmádena",
	  "Mollet del Vallés",
	  "Puertollano",
	  "Madrid",
	  "Barcelona",
	  "Valencia",
	  "Sevilla",
	  "Zaragoza",
	  "Málaga",
	  "Murcia",
	  "Palma de Mallorca",
	  "Las Palmas de Gran Canaria",
	  "Bilbao",
	  "Córdoba",
	  "Alicante",
	  "Valladolid",
	  "Vigo",
	  "Gijón",
	  "Hospitalet de LLobregat",
	  "La Coruña",
	  "Granada",
	  "Vitoria",
	  "Elche",
	  "Santa Cruz de Tenerife",
	  "Oviedo",
	  "Badalona",
	  "Cartagena",
	  "Móstoles",
	  "Jerez de la Frontera",
	  "Tarrasa",
	  "Sabadell",
	  "Alcalá de Henares",
	  "Pamplona",
	  "Fuenlabrada",
	  "Almería",
	  "San Sebastián",
	  "Leganés",
	  "Santander",
	  "Burgos",
	  "Castellón de la Plana",
	  "Alcorcón",
	  "Albacete",
	  "Getafe",
	  "Salamanca",
	  "Huelva",
	  "Logroño",
	  "Badajoz",
	  "San Cristróbal de la Laguna",
	  "León",
	  "Tarragona",
	  "Cádiz",
	  "Lérida",
	  "Marbella",
	  "Mataró",
	  "Dos Hermanas",
	  "Santa Coloma de Gramanet",
	  "Jaén",
	  "Algeciras",
	  "Torrejón de Ardoz",
	  "Orense",
	  "Alcobendas",
	  "Reus",
	  "Calahorra",
	  "Inca"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afganistán",
	  "Albania",
	  "Argelia",
	  "Andorra",
	  "Angola",
	  "Argentina",
	  "Armenia",
	  "Aruba",
	  "Australia",
	  "Austria",
	  "Azerbayán",
	  "Bahamas",
	  "Barein",
	  "Bangladesh",
	  "Barbados",
	  "Bielorusia",
	  "Bélgica",
	  "Belice",
	  "Bermuda",
	  "Bután",
	  "Bolivia",
	  "Bosnia Herzegovina",
	  "Botswana",
	  "Brasil",
	  "Bulgaria",
	  "Burkina Faso",
	  "Burundi",
	  "Camboya",
	  "Camerún",
	  "Canada",
	  "Cabo Verde",
	  "Islas Caimán",
	  "Chad",
	  "Chile",
	  "China",
	  "Isla de Navidad",
	  "Colombia",
	  "Comodos",
	  "Congo",
	  "Costa Rica",
	  "Costa de Marfil",
	  "Croacia",
	  "Cuba",
	  "Chipre",
	  "República Checa",
	  "Dinamarca",
	  "Dominica",
	  "República Dominicana",
	  "Ecuador",
	  "Egipto",
	  "El Salvador",
	  "Guinea Ecuatorial",
	  "Eritrea",
	  "Estonia",
	  "Etiopía",
	  "Islas Faro",
	  "Fiji",
	  "Finlandia",
	  "Francia",
	  "Gabón",
	  "Gambia",
	  "Georgia",
	  "Alemania",
	  "Ghana",
	  "Grecia",
	  "Groenlandia",
	  "Granada",
	  "Guadalupe",
	  "Guam",
	  "Guatemala",
	  "Guinea",
	  "Guinea-Bisau",
	  "Guayana",
	  "Haiti",
	  "Honduras",
	  "Hong Kong",
	  "Hungria",
	  "Islandia",
	  "India",
	  "Indonesia",
	  "Iran",
	  "Irak",
	  "Irlanda",
	  "Italia",
	  "Jamaica",
	  "Japón",
	  "Jordania",
	  "Kazajistan",
	  "Kenia",
	  "Kiribati",
	  "Corea",
	  "Kuwait",
	  "Letonia",
	  "Líbano",
	  "Liberia",
	  "Liechtenstein",
	  "Lituania",
	  "Luxemburgo",
	  "Macao",
	  "Macedonia",
	  "Madagascar",
	  "Malawi",
	  "Malasia",
	  "Maldivas",
	  "Mali",
	  "Malta",
	  "Martinica",
	  "Mauritania",
	  "Méjico",
	  "Micronesia",
	  "Moldavia",
	  "Mónaco",
	  "Mongolia",
	  "Montenegro",
	  "Montserrat",
	  "Marruecos",
	  "Mozambique",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Holanda",
	  "Nueva Zelanda",
	  "Nicaragua",
	  "Niger",
	  "Nigeria",
	  "Noruega",
	  "Omán",
	  "Pakistan",
	  "Panamá",
	  "Papúa Nueva Guinea",
	  "Paraguay",
	  "Perú",
	  "Filipinas",
	  "Poland",
	  "Portugal",
	  "Puerto Rico",
	  "Rusia",
	  "Ruanda",
	  "Samoa",
	  "San Marino",
	  "Santo Tomé y Principe",
	  "Arabia Saudí",
	  "Senegal",
	  "Serbia",
	  "Seychelles",
	  "Sierra Leona",
	  "Singapur",
	  "Eslovaquia",
	  "Eslovenia",
	  "Somalia",
	  "España",
	  "Sri Lanka",
	  "Sudán",
	  "Suriname",
	  "Suecia",
	  "Suiza",
	  "Siria",
	  "Taiwan",
	  "Tajikistan",
	  "Tanzania",
	  "Tailandia",
	  "Timor-Leste",
	  "Togo",
	  "Tonga",
	  "Trinidad y Tobago",
	  "Tunez",
	  "Turquia",
	  "Uganda",
	  "Ucrania",
	  "Emiratos Árabes Unidos",
	  "Reino Unido",
	  "Estados Unidos de América",
	  "Uruguay",
	  "Uzbekistan",
	  "Vanuatu",
	  "Venezuela",
	  "Vietnam",
	  "Yemen",
	  "Zambia",
	  "Zimbabwe"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "España"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(641);
	address.country = __webpack_require__(642);
	address.building_number = __webpack_require__(639);
	address.street_suffix = __webpack_require__(652);
	address.secondary_address = __webpack_require__(647);
	address.postcode = __webpack_require__(645);
	address.province = __webpack_require__(646);
	address.state = __webpack_require__(648);
	address.state_abbr = __webpack_require__(649);
	address.time_zone = __webpack_require__(653);
	address.city = __webpack_require__(640);
	address.street_name = __webpack_require__(651);
	address.street_address = __webpack_require__(650);
	address.default_country = __webpack_require__(643);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Álava",
	  "Albacete",
	  "Alicante",
	  "Almería",
	  "Asturias",
	  "Ávila",
	  "Badajoz",
	  "Barcelona",
	  "Burgos",
	  "Cantabria",
	  "Castellón",
	  "Ciudad Real",
	  "Cuenca",
	  "Cáceres",
	  "Cádiz",
	  "Córdoba",
	  "Gerona",
	  "Granada",
	  "Guadalajara",
	  "Guipúzcoa",
	  "Huelva",
	  "Huesca",
	  "Islas Baleares",
	  "Jaén",
	  "La Coruña",
	  "La Rioja",
	  "Las Palmas",
	  "León",
	  "Lugo",
	  "lérida",
	  "Madrid",
	  "Murcia",
	  "Málaga",
	  "Navarra",
	  "Orense",
	  "Palencia",
	  "Pontevedra",
	  "Salamanca",
	  "Santa Cruz de Tenerife",
	  "Segovia",
	  "Sevilla",
	  "Soria",
	  "Tarragona",
	  "Teruel",
	  "Toledo",
	  "Valencia",
	  "Valladolid",
	  "Vizcaya",
	  "Zamora",
	  "Zaragoza"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Esc. ###",
	  "Puerta ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Andalucía",
	  "Aragón",
	  "Principado de Asturias",
	  "Baleares",
	  "Canarias",
	  "Cantabria",
	  "Castilla-La Mancha",
	  "Castilla y León",
	  "Cataluña",
	  "Comunidad Valenciana",
	  "Extremadura",
	  "Galicia",
	  "La Rioja",
	  "Comunidad de Madrid",
	  "Navarra",
	  "País Vasco",
	  "Región de Murcia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "And",
	  "Ara",
	  "Ast",
	  "Bal",
	  "Can",
	  "Cbr",
	  "Man",
	  "Leo",
	  "Cat",
	  "Com",
	  "Ext",
	  "Gal",
	  "Rio",
	  "Mad",
	  "Nav",
	  "Vas",
	  "Mur"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name}#{building_number}",
	  "#{street_name}#{building_number} #{secondary_address}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_suffix} #{Name.first_name}",
	  "#{street_suffix} #{Name.first_name} #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aldea",
	  "Apartamento",
	  "Arrabal",
	  "Arroyo",
	  "Avenida",
	  "Bajada",
	  "Barranco",
	  "Barrio",
	  "Bloque",
	  "Calle",
	  "Calleja",
	  "Camino",
	  "Carretera",
	  "Caserio",
	  "Colegio",
	  "Colonia",
	  "Conjunto",
	  "Cuesta",
	  "Chalet",
	  "Edificio",
	  "Entrada",
	  "Escalinata",
	  "Explanada",
	  "Extramuros",
	  "Extrarradio",
	  "Ferrocarril",
	  "Glorieta",
	  "Gran Subida",
	  "Grupo",
	  "Huerta",
	  "Jardines",
	  "Lado",
	  "Lugar",
	  "Manzana",
	  "Masía",
	  "Mercado",
	  "Monte",
	  "Muelle",
	  "Municipio",
	  "Parcela",
	  "Parque",
	  "Partida",
	  "Pasaje",
	  "Paseo",
	  "Plaza",
	  "Poblado",
	  "Polígono",
	  "Prolongación",
	  "Puente",
	  "Puerta",
	  "Quinta",
	  "Ramal",
	  "Rambla",
	  "Rampa",
	  "Riera",
	  "Rincón",
	  "Ronda",
	  "Rua",
	  "Salida",
	  "Sector",
	  "Sección",
	  "Senda",
	  "Solar",
	  "Subida",
	  "Terrenos",
	  "Torrente",
	  "Travesía",
	  "Urbanización",
	  "Vía",
	  "Vía Pública"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pacífico/Midway",
	  "Pacífico/Pago_Pago",
	  "Pacífico/Honolulu",
	  "America/Juneau",
	  "America/Los_Angeles",
	  "America/Tijuana",
	  "America/Denver",
	  "America/Phoenix",
	  "America/Chihuahua",
	  "America/Mazatlan",
	  "America/Chicago",
	  "America/Regina",
	  "America/Mexico_City",
	  "America/Mexico_City",
	  "America/Monterrey",
	  "America/Guatemala",
	  "America/New_York",
	  "America/Indiana/Indianapolis",
	  "America/Bogota",
	  "America/Lima",
	  "America/Lima",
	  "America/Halifax",
	  "America/Caracas",
	  "America/La_Paz",
	  "America/Santiago",
	  "America/St_Johns",
	  "America/Sao_Paulo",
	  "America/Argentina/Buenos_Aires",
	  "America/Guyana",
	  "America/Godthab",
	  "Atlantic/South_Georgia",
	  "Atlantic/Azores",
	  "Atlantic/Cape_Verde",
	  "Europa/Dublin",
	  "Europa/London",
	  "Europa/Lisbon",
	  "Europa/London",
	  "Africa/Casablanca",
	  "Africa/Monrovia",
	  "Etc/UTC",
	  "Europa/Belgrade",
	  "Europa/Bratislava",
	  "Europa/Budapest",
	  "Europa/Ljubljana",
	  "Europa/Prague",
	  "Europa/Sarajevo",
	  "Europa/Skopje",
	  "Europa/Warsaw",
	  "Europa/Zagreb",
	  "Europa/Brussels",
	  "Europa/Copenhagen",
	  "Europa/Madrid",
	  "Europa/Paris",
	  "Europa/Amsterdam",
	  "Europa/Berlin",
	  "Europa/Berlin",
	  "Europa/Rome",
	  "Europa/Stockholm",
	  "Europa/Vienna",
	  "Africa/Algiers",
	  "Europa/Bucharest",
	  "Africa/Cairo",
	  "Europa/Helsinki",
	  "Europa/Kiev",
	  "Europa/Riga",
	  "Europa/Sofia",
	  "Europa/Tallinn",
	  "Europa/Vilnius",
	  "Europa/Athens",
	  "Europa/Istanbul",
	  "Europa/Minsk",
	  "Asia/Jerusalen",
	  "Africa/Harare",
	  "Africa/Johannesburg",
	  "Europa/Moscú",
	  "Europa/Moscú",
	  "Europa/Moscú",
	  "Asia/Kuwait",
	  "Asia/Riyadh",
	  "Africa/Nairobi",
	  "Asia/Baghdad",
	  "Asia/Tehran",
	  "Asia/Muscat",
	  "Asia/Muscat",
	  "Asia/Baku",
	  "Asia/Tbilisi",
	  "Asia/Yerevan",
	  "Asia/Kabul",
	  "Asia/Yekaterinburg",
	  "Asia/Karachi",
	  "Asia/Karachi",
	  "Asia/Tashkent",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kathmandu",
	  "Asia/Dhaka",
	  "Asia/Dhaka",
	  "Asia/Colombo",
	  "Asia/Almaty",
	  "Asia/Novosibirsk",
	  "Asia/Rangoon",
	  "Asia/Bangkok",
	  "Asia/Bangkok",
	  "Asia/Jakarta",
	  "Asia/Krasnoyarsk",
	  "Asia/Shanghai",
	  "Asia/Chongqing",
	  "Asia/Hong_Kong",
	  "Asia/Urumqi",
	  "Asia/Kuala_Lumpur",
	  "Asia/Singapore",
	  "Asia/Taipei",
	  "Australia/Perth",
	  "Asia/Irkutsk",
	  "Asia/Ulaanbaatar",
	  "Asia/Seoul",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Yakutsk",
	  "Australia/Darwin",
	  "Australia/Adelaide",
	  "Australia/Melbourne",
	  "Australia/Melbourne",
	  "Australia/Sydney",
	  "Australia/Brisbane",
	  "Australia/Hobart",
	  "Asia/Vladivostok",
	  "Pacífico/Guam",
	  "Pacífico/Port_Moresby",
	  "Asia/Magadan",
	  "Asia/Magadan",
	  "Pacífico/Noumea",
	  "Pacífico/Fiji",
	  "Asia/Kamchatka",
	  "Pacífico/Majuro",
	  "Pacífico/Auckland",
	  "Pacífico/Auckland",
	  "Pacífico/Tongatapu",
	  "Pacífico/Fakaofo",
	  "Pacífico/Apia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "6##-###-###",
	  "6##.###.###",
	  "6## ### ###",
	  "6########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(654);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adaptativo",
	  "Avanzado",
	  "Asimilado",
	  "Automatizado",
	  "Equilibrado",
	  "Centrado en el negocio",
	  "Centralizado",
	  "Clonado",
	  "Compatible",
	  "Configurable",
	  "Multi grupo",
	  "Multi plataforma",
	  "Centrado en el usuario",
	  "Configurable",
	  "Descentralizado",
	  "Digitalizado",
	  "Distribuido",
	  "Diverso",
	  "Reducido",
	  "Mejorado",
	  "Para toda la empresa",
	  "Ergonomico",
	  "Exclusivo",
	  "Expandido",
	  "Extendido",
	  "Cara a cara",
	  "Enfocado",
	  "Totalmente configurable",
	  "Fundamental",
	  "Orígenes",
	  "Horizontal",
	  "Implementado",
	  "Innovador",
	  "Integrado",
	  "Intuitivo",
	  "Inverso",
	  "Gestionado",
	  "Obligatorio",
	  "Monitorizado",
	  "Multi canal",
	  "Multi lateral",
	  "Multi capa",
	  "En red",
	  "Orientado a objetos",
	  "Open-source",
	  "Operativo",
	  "Optimizado",
	  "Opcional",
	  "Organico",
	  "Organizado",
	  "Perseverando",
	  "Persistente",
	  "en fases",
	  "Polarizado",
	  "Pre-emptivo",
	  "Proactivo",
	  "Enfocado a benficios",
	  "Profundo",
	  "Programable",
	  "Progresivo",
	  "Public-key",
	  "Enfocado en la calidad",
	  "Reactivo",
	  "Realineado",
	  "Re-contextualizado",
	  "Re-implementado",
	  "Reducido",
	  "Ingenieria inversa",
	  "Robusto",
	  "Fácil",
	  "Seguro",
	  "Auto proporciona",
	  "Compartible",
	  "Intercambiable",
	  "Sincronizado",
	  "Orientado a equipos",
	  "Total",
	  "Universal",
	  "Mejorado",
	  "Actualizable",
	  "Centrado en el usuario",
	  "Amigable",
	  "Versatil",
	  "Virtual",
	  "Visionario"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 horas",
	  "24/7",
	  "3rd generación",
	  "4th generación",
	  "5th generación",
	  "6th generación",
	  "analizada",
	  "asimétrica",
	  "asíncrona",
	  "monitorizada por red",
	  "bidireccional",
	  "bifurcada",
	  "generada por el cliente",
	  "cliente servidor",
	  "coherente",
	  "cohesiva",
	  "compuesto",
	  "sensible al contexto",
	  "basado en el contexto",
	  "basado en contenido",
	  "dedicada",
	  "generado por la demanda",
	  "didactica",
	  "direccional",
	  "discreta",
	  "dinámica",
	  "potenciada",
	  "acompasada",
	  "ejecutiva",
	  "explícita",
	  "tolerante a fallos",
	  "innovadora",
	  "amplio ábanico",
	  "global",
	  "heurística",
	  "alto nivel",
	  "holística",
	  "homogénea",
	  "hibrida",
	  "incremental",
	  "intangible",
	  "interactiva",
	  "intermedia",
	  "local",
	  "logística",
	  "maximizada",
	  "metódica",
	  "misión crítica",
	  "móbil",
	  "modular",
	  "motivadora",
	  "multimedia",
	  "multiestado",
	  "multitarea",
	  "nacional",
	  "basado en necesidades",
	  "neutral",
	  "nueva generación",
	  "no-volátil",
	  "orientado a objetos",
	  "óptima",
	  "optimizada",
	  "radical",
	  "tiempo real",
	  "recíproca",
	  "regional",
	  "escalable",
	  "secundaria",
	  "orientada a soluciones",
	  "estable",
	  "estatica",
	  "sistemática",
	  "sistémica",
	  "tangible",
	  "terciaria",
	  "transicional",
	  "uniforme",
	  "valor añadido",
	  "vía web",
	  "defectos cero",
	  "tolerancia cero"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(661);
	company.noun = __webpack_require__(660);
	company.descriptor = __webpack_require__(657);
	company.adjective = __webpack_require__(656);
	company.name = __webpack_require__(659);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name} y #{Name.last_name}",
	  "#{Name.last_name} #{Name.last_name} #{suffix}",
	  "#{Name.last_name}, #{Name.last_name} y #{Name.last_name} Asociados"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "habilidad",
	  "acceso",
	  "adaptador",
	  "algoritmo",
	  "alianza",
	  "analista",
	  "aplicación",
	  "enfoque",
	  "arquitectura",
	  "archivo",
	  "inteligencia artificial",
	  "array",
	  "actitud",
	  "medición",
	  "gestión presupuestaria",
	  "capacidad",
	  "desafío",
	  "circuito",
	  "colaboración",
	  "complejidad",
	  "concepto",
	  "conglomeración",
	  "contingencia",
	  "núcleo",
	  "fidelidad",
	  "base de datos",
	  "data-warehouse",
	  "definición",
	  "emulación",
	  "codificar",
	  "encriptar",
	  "extranet",
	  "firmware",
	  "flexibilidad",
	  "focus group",
	  "previsión",
	  "base de trabajo",
	  "función",
	  "funcionalidad",
	  "Interfaz Gráfica",
	  "groupware",
	  "Interfaz gráfico de usuario",
	  "hardware",
	  "Soporte",
	  "jerarquía",
	  "conjunto",
	  "implementación",
	  "infraestructura",
	  "iniciativa",
	  "instalación",
	  "conjunto de instrucciones",
	  "interfaz",
	  "intranet",
	  "base del conocimiento",
	  "red de area local",
	  "aprovechar",
	  "matrices",
	  "metodologías",
	  "middleware",
	  "migración",
	  "modelo",
	  "moderador",
	  "monitorizar",
	  "arquitectura abierta",
	  "sistema abierto",
	  "orquestar",
	  "paradigma",
	  "paralelismo",
	  "política",
	  "portal",
	  "estructura de precios",
	  "proceso de mejora",
	  "producto",
	  "productividad",
	  "proyecto",
	  "proyección",
	  "protocolo",
	  "línea segura",
	  "software",
	  "solución",
	  "estandardización",
	  "estrategia",
	  "estructura",
	  "éxito",
	  "superestructura",
	  "soporte",
	  "sinergia",
	  "mediante",
	  "marco de tiempo",
	  "caja de herramientas",
	  "utilización",
	  "website",
	  "fuerza de trabajo"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "S.L.",
	  "e Hijos",
	  "S.A.",
	  "Hermanos"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var es = {};
	module['exports'] = es;
	es.title = "Spanish";
	es.address = __webpack_require__(644);
	es.company = __webpack_require__(658);
	es.internet = __webpack_require__(665);
	es.name = __webpack_require__(667);
	es.phone_number = __webpack_require__(674);
	es.cell_phone = __webpack_require__(655);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "es",
	  "info",
	  "com.es",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(664);
	internet.domain_suffix = __webpack_require__(663);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adán",
	  "Agustín",
	  "Alberto",
	  "Alejandro",
	  "Alfonso",
	  "Alfredo",
	  "Andrés",
	  "Antonio",
	  "Armando",
	  "Arturo",
	  "Benito",
	  "Benjamín",
	  "Bernardo",
	  "Carlos",
	  "César",
	  "Claudio",
	  "Clemente",
	  "Cristian",
	  "Cristobal",
	  "Daniel",
	  "David",
	  "Diego",
	  "Eduardo",
	  "Emilio",
	  "Enrique",
	  "Ernesto",
	  "Esteban",
	  "Federico",
	  "Felipe",
	  "Fernando",
	  "Francisco",
	  "Gabriel",
	  "Gerardo",
	  "Germán",
	  "Gilberto",
	  "Gonzalo",
	  "Gregorio",
	  "Guillermo",
	  "Gustavo",
	  "Hernán",
	  "Homero",
	  "Horacio",
	  "Hugo",
	  "Ignacio",
	  "Jacobo",
	  "Jaime",
	  "Javier",
	  "Jerónimo",
	  "Jesús",
	  "Joaquín",
	  "Jorge",
	  "Jorge Luis",
	  "José",
	  "José Eduardo",
	  "José Emilio",
	  "José Luis",
	  "José María",
	  "Juan",
	  "Juan Carlos",
	  "Julio",
	  "Julio César",
	  "Lorenzo",
	  "Lucas",
	  "Luis",
	  "Luis Miguel",
	  "Manuel",
	  "Marco Antonio",
	  "Marcos",
	  "Mariano",
	  "Mario",
	  "Martín",
	  "Mateo",
	  "Miguel",
	  "Miguel Ángel",
	  "Nicolás",
	  "Octavio",
	  "Óscar",
	  "Pablo",
	  "Patricio",
	  "Pedro",
	  "Rafael",
	  "Ramiro",
	  "Ramón",
	  "Raúl",
	  "Ricardo",
	  "Roberto",
	  "Rodrigo",
	  "Rubén",
	  "Salvador",
	  "Samuel",
	  "Sancho",
	  "Santiago",
	  "Sergio",
	  "Teodoro",
	  "Timoteo",
	  "Tomás",
	  "Vicente",
	  "Víctor",
	  "Adela",
	  "Adriana",
	  "Alejandra",
	  "Alicia",
	  "Amalia",
	  "Ana",
	  "Ana Luisa",
	  "Ana María",
	  "Andrea",
	  "Anita",
	  "Ángela",
	  "Antonia",
	  "Ariadna",
	  "Barbara",
	  "Beatriz",
	  "Berta",
	  "Blanca",
	  "Caridad",
	  "Carla",
	  "Carlota",
	  "Carmen",
	  "Carolina",
	  "Catalina",
	  "Cecilia",
	  "Clara",
	  "Claudia",
	  "Concepción",
	  "Conchita",
	  "Cristina",
	  "Daniela",
	  "Débora",
	  "Diana",
	  "Dolores",
	  "Lola",
	  "Dorotea",
	  "Elena",
	  "Elisa",
	  "Eloisa",
	  "Elsa",
	  "Elvira",
	  "Emilia",
	  "Esperanza",
	  "Estela",
	  "Ester",
	  "Eva",
	  "Florencia",
	  "Francisca",
	  "Gabriela",
	  "Gloria",
	  "Graciela",
	  "Guadalupe",
	  "Guillermina",
	  "Inés",
	  "Irene",
	  "Isabel",
	  "Isabela",
	  "Josefina",
	  "Juana",
	  "Julia",
	  "Laura",
	  "Leonor",
	  "Leticia",
	  "Lilia",
	  "Lorena",
	  "Lourdes",
	  "Lucia",
	  "Luisa",
	  "Luz",
	  "Magdalena",
	  "Manuela",
	  "Marcela",
	  "Margarita",
	  "María",
	  "María del Carmen",
	  "María Cristina",
	  "María Elena",
	  "María Eugenia",
	  "María José",
	  "María Luisa",
	  "María Soledad",
	  "María Teresa",
	  "Mariana",
	  "Maricarmen",
	  "Marilu",
	  "Marisol",
	  "Marta",
	  "Mayte",
	  "Mercedes",
	  "Micaela",
	  "Mónica",
	  "Natalia",
	  "Norma",
	  "Olivia",
	  "Patricia",
	  "Pilar",
	  "Ramona",
	  "Raquel",
	  "Rebeca",
	  "Reina",
	  "Rocio",
	  "Rosa",
	  "Rosalia",
	  "Rosario",
	  "Sara",
	  "Silvia",
	  "Sofia",
	  "Soledad",
	  "Sonia",
	  "Susana",
	  "Teresa",
	  "Verónica",
	  "Victoria",
	  "Virginia",
	  "Yolanda"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(666);
	name.last_name = __webpack_require__(668);
	name.prefix = __webpack_require__(670);
	name.suffix = __webpack_require__(671);
	name.title = __webpack_require__(672);
	name.name = __webpack_require__(669);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abeyta",
	  "Abrego",
	  "Abreu",
	  "Acevedo",
	  "Acosta",
	  "Acuña",
	  "Adame",
	  "Adorno",
	  "Agosto",
	  "Aguayo",
	  "Águilar",
	  "Aguilera",
	  "Aguirre",
	  "Alanis",
	  "Alaniz",
	  "Alarcón",
	  "Alba",
	  "Alcala",
	  "Alcántar",
	  "Alcaraz",
	  "Alejandro",
	  "Alemán",
	  "Alfaro",
	  "Alicea",
	  "Almanza",
	  "Almaraz",
	  "Almonte",
	  "Alonso",
	  "Alonzo",
	  "Altamirano",
	  "Alva",
	  "Alvarado",
	  "Alvarez",
	  "Amador",
	  "Amaya",
	  "Anaya",
	  "Anguiano",
	  "Angulo",
	  "Aparicio",
	  "Apodaca",
	  "Aponte",
	  "Aragón",
	  "Araña",
	  "Aranda",
	  "Arce",
	  "Archuleta",
	  "Arellano",
	  "Arenas",
	  "Arevalo",
	  "Arguello",
	  "Arias",
	  "Armas",
	  "Armendáriz",
	  "Armenta",
	  "Armijo",
	  "Arredondo",
	  "Arreola",
	  "Arriaga",
	  "Arroyo",
	  "Arteaga",
	  "Atencio",
	  "Ávalos",
	  "Ávila",
	  "Avilés",
	  "Ayala",
	  "Baca",
	  "Badillo",
	  "Báez",
	  "Baeza",
	  "Bahena",
	  "Balderas",
	  "Ballesteros",
	  "Banda",
	  "Bañuelos",
	  "Barajas",
	  "Barela",
	  "Barragán",
	  "Barraza",
	  "Barrera",
	  "Barreto",
	  "Barrientos",
	  "Barrios",
	  "Batista",
	  "Becerra",
	  "Beltrán",
	  "Benavides",
	  "Benavídez",
	  "Benítez",
	  "Bermúdez",
	  "Bernal",
	  "Berríos",
	  "Bétancourt",
	  "Blanco",
	  "Bonilla",
	  "Borrego",
	  "Botello",
	  "Bravo",
	  "Briones",
	  "Briseño",
	  "Brito",
	  "Bueno",
	  "Burgos",
	  "Bustamante",
	  "Bustos",
	  "Caballero",
	  "Cabán",
	  "Cabrera",
	  "Cadena",
	  "Caldera",
	  "Calderón",
	  "Calvillo",
	  "Camacho",
	  "Camarillo",
	  "Campos",
	  "Canales",
	  "Candelaria",
	  "Cano",
	  "Cantú",
	  "Caraballo",
	  "Carbajal",
	  "Cardenas",
	  "Cardona",
	  "Carmona",
	  "Carranza",
	  "Carrasco",
	  "Carrasquillo",
	  "Carreón",
	  "Carrera",
	  "Carrero",
	  "Carrillo",
	  "Carrion",
	  "Carvajal",
	  "Casanova",
	  "Casares",
	  "Casárez",
	  "Casas",
	  "Casillas",
	  "Castañeda",
	  "Castellanos",
	  "Castillo",
	  "Castro",
	  "Cavazos",
	  "Cazares",
	  "Ceballos",
	  "Cedillo",
	  "Ceja",
	  "Centeno",
	  "Cepeda",
	  "Cerda",
	  "Cervantes",
	  "Cervántez",
	  "Chacón",
	  "Chapa",
	  "Chavarría",
	  "Chávez",
	  "Cintrón",
	  "Cisneros",
	  "Collado",
	  "Collazo",
	  "Colón",
	  "Colunga",
	  "Concepción",
	  "Contreras",
	  "Cordero",
	  "Córdova",
	  "Cornejo",
	  "Corona",
	  "Coronado",
	  "Corral",
	  "Corrales",
	  "Correa",
	  "Cortés",
	  "Cortez",
	  "Cotto",
	  "Covarrubias",
	  "Crespo",
	  "Cruz",
	  "Cuellar",
	  "Curiel",
	  "Dávila",
	  "de Anda",
	  "de Jesús",
	  "Delacrúz",
	  "Delafuente",
	  "Delagarza",
	  "Delao",
	  "Delapaz",
	  "Delarosa",
	  "Delatorre",
	  "Deleón",
	  "Delgadillo",
	  "Delgado",
	  "Delrío",
	  "Delvalle",
	  "Díaz",
	  "Domínguez",
	  "Domínquez",
	  "Duarte",
	  "Dueñas",
	  "Duran",
	  "Echevarría",
	  "Elizondo",
	  "Enríquez",
	  "Escalante",
	  "Escamilla",
	  "Escobar",
	  "Escobedo",
	  "Esparza",
	  "Espinal",
	  "Espino",
	  "Espinosa",
	  "Espinoza",
	  "Esquibel",
	  "Esquivel",
	  "Estévez",
	  "Estrada",
	  "Fajardo",
	  "Farías",
	  "Feliciano",
	  "Fernández",
	  "Ferrer",
	  "Fierro",
	  "Figueroa",
	  "Flores",
	  "Flórez",
	  "Fonseca",
	  "Franco",
	  "Frías",
	  "Fuentes",
	  "Gaitán",
	  "Galarza",
	  "Galindo",
	  "Gallardo",
	  "Gallegos",
	  "Galván",
	  "Gálvez",
	  "Gamboa",
	  "Gamez",
	  "Gaona",
	  "Garay",
	  "García",
	  "Garibay",
	  "Garica",
	  "Garrido",
	  "Garza",
	  "Gastélum",
	  "Gaytán",
	  "Gil",
	  "Girón",
	  "Godínez",
	  "Godoy",
	  "Gómez",
	  "Gonzales",
	  "González",
	  "Gollum",
	  "Gracia",
	  "Granado",
	  "Granados",
	  "Griego",
	  "Grijalva",
	  "Guajardo",
	  "Guardado",
	  "Guerra",
	  "Guerrero",
	  "Guevara",
	  "Guillen",
	  "Gurule",
	  "Gutiérrez",
	  "Guzmán",
	  "Haro",
	  "Henríquez",
	  "Heredia",
	  "Hernádez",
	  "Hernandes",
	  "Hernández",
	  "Herrera",
	  "Hidalgo",
	  "Hinojosa",
	  "Holguín",
	  "Huerta",
	  "Hurtado",
	  "Ibarra",
	  "Iglesias",
	  "Irizarry",
	  "Jaime",
	  "Jaimes",
	  "Jáquez",
	  "Jaramillo",
	  "Jasso",
	  "Jiménez",
	  "Jimínez",
	  "Juárez",
	  "Jurado",
	  "Laboy",
	  "Lara",
	  "Laureano",
	  "Leal",
	  "Lebrón",
	  "Ledesma",
	  "Leiva",
	  "Lemus",
	  "León",
	  "Lerma",
	  "Leyva",
	  "Limón",
	  "Linares",
	  "Lira",
	  "Llamas",
	  "Loera",
	  "Lomeli",
	  "Longoria",
	  "López",
	  "Lovato",
	  "Loya",
	  "Lozada",
	  "Lozano",
	  "Lucero",
	  "Lucio",
	  "Luevano",
	  "Lugo",
	  "Luna",
	  "Macías",
	  "Madera",
	  "Madrid",
	  "Madrigal",
	  "Maestas",
	  "Magaña",
	  "Malave",
	  "Maldonado",
	  "Manzanares",
	  "Mares",
	  "Marín",
	  "Márquez",
	  "Marrero",
	  "Marroquín",
	  "Martínez",
	  "Mascareñas",
	  "Mata",
	  "Mateo",
	  "Matías",
	  "Matos",
	  "Maya",
	  "Mayorga",
	  "Medina",
	  "Medrano",
	  "Mejía",
	  "Meléndez",
	  "Melgar",
	  "Mena",
	  "Menchaca",
	  "Méndez",
	  "Mendoza",
	  "Menéndez",
	  "Meraz",
	  "Mercado",
	  "Merino",
	  "Mesa",
	  "Meza",
	  "Miramontes",
	  "Miranda",
	  "Mireles",
	  "Mojica",
	  "Molina",
	  "Mondragón",
	  "Monroy",
	  "Montalvo",
	  "Montañez",
	  "Montaño",
	  "Montemayor",
	  "Montenegro",
	  "Montero",
	  "Montes",
	  "Montez",
	  "Montoya",
	  "Mora",
	  "Morales",
	  "Moreno",
	  "Mota",
	  "Moya",
	  "Munguía",
	  "Muñiz",
	  "Muñoz",
	  "Murillo",
	  "Muro",
	  "Nájera",
	  "Naranjo",
	  "Narváez",
	  "Nava",
	  "Navarrete",
	  "Navarro",
	  "Nazario",
	  "Negrete",
	  "Negrón",
	  "Nevárez",
	  "Nieto",
	  "Nieves",
	  "Niño",
	  "Noriega",
	  "Núñez",
	  "Ocampo",
	  "Ocasio",
	  "Ochoa",
	  "Ojeda",
	  "Olivares",
	  "Olivárez",
	  "Olivas",
	  "Olivera",
	  "Olivo",
	  "Olmos",
	  "Olvera",
	  "Ontiveros",
	  "Oquendo",
	  "Ordóñez",
	  "Orellana",
	  "Ornelas",
	  "Orosco",
	  "Orozco",
	  "Orta",
	  "Ortega",
	  "Ortiz",
	  "Osorio",
	  "Otero",
	  "Ozuna",
	  "Pabón",
	  "Pacheco",
	  "Padilla",
	  "Padrón",
	  "Páez",
	  "Pagan",
	  "Palacios",
	  "Palomino",
	  "Palomo",
	  "Pantoja",
	  "Paredes",
	  "Parra",
	  "Partida",
	  "Patiño",
	  "Paz",
	  "Pedraza",
	  "Pedroza",
	  "Pelayo",
	  "Peña",
	  "Perales",
	  "Peralta",
	  "Perea",
	  "Peres",
	  "Pérez",
	  "Pichardo",
	  "Piña",
	  "Pineda",
	  "Pizarro",
	  "Polanco",
	  "Ponce",
	  "Porras",
	  "Portillo",
	  "Posada",
	  "Prado",
	  "Preciado",
	  "Prieto",
	  "Puente",
	  "Puga",
	  "Pulido",
	  "Quesada",
	  "Quezada",
	  "Quiñones",
	  "Quiñónez",
	  "Quintana",
	  "Quintanilla",
	  "Quintero",
	  "Quiroz",
	  "Rael",
	  "Ramírez",
	  "Ramón",
	  "Ramos",
	  "Rangel",
	  "Rascón",
	  "Raya",
	  "Razo",
	  "Regalado",
	  "Rendón",
	  "Rentería",
	  "Reséndez",
	  "Reyes",
	  "Reyna",
	  "Reynoso",
	  "Rico",
	  "Rincón",
	  "Riojas",
	  "Ríos",
	  "Rivas",
	  "Rivera",
	  "Rivero",
	  "Robledo",
	  "Robles",
	  "Rocha",
	  "Rodarte",
	  "Rodrígez",
	  "Rodríguez",
	  "Rodríquez",
	  "Rojas",
	  "Rojo",
	  "Roldán",
	  "Rolón",
	  "Romero",
	  "Romo",
	  "Roque",
	  "Rosado",
	  "Rosales",
	  "Rosario",
	  "Rosas",
	  "Roybal",
	  "Rubio",
	  "Ruelas",
	  "Ruiz",
	  "Saavedra",
	  "Sáenz",
	  "Saiz",
	  "Salas",
	  "Salazar",
	  "Salcedo",
	  "Salcido",
	  "Saldaña",
	  "Saldivar",
	  "Salgado",
	  "Salinas",
	  "Samaniego",
	  "Sanabria",
	  "Sanches",
	  "Sánchez",
	  "Sandoval",
	  "Santacruz",
	  "Santana",
	  "Santiago",
	  "Santillán",
	  "Sarabia",
	  "Sauceda",
	  "Saucedo",
	  "Sedillo",
	  "Segovia",
	  "Segura",
	  "Sepúlveda",
	  "Serna",
	  "Serrano",
	  "Serrato",
	  "Sevilla",
	  "Sierra",
	  "Sisneros",
	  "Solano",
	  "Solís",
	  "Soliz",
	  "Solorio",
	  "Solorzano",
	  "Soria",
	  "Sosa",
	  "Sotelo",
	  "Soto",
	  "Suárez",
	  "Tafoya",
	  "Tamayo",
	  "Tamez",
	  "Tapia",
	  "Tejada",
	  "Tejeda",
	  "Téllez",
	  "Tello",
	  "Terán",
	  "Terrazas",
	  "Tijerina",
	  "Tirado",
	  "Toledo",
	  "Toro",
	  "Torres",
	  "Tórrez",
	  "Tovar",
	  "Trejo",
	  "Treviño",
	  "Trujillo",
	  "Ulibarri",
	  "Ulloa",
	  "Urbina",
	  "Ureña",
	  "Urías",
	  "Uribe",
	  "Urrutia",
	  "Vaca",
	  "Valadez",
	  "Valdés",
	  "Valdez",
	  "Valdivia",
	  "Valencia",
	  "Valentín",
	  "Valenzuela",
	  "Valladares",
	  "Valle",
	  "Vallejo",
	  "Valles",
	  "Valverde",
	  "Vanegas",
	  "Varela",
	  "Vargas",
	  "Vásquez",
	  "Vázquez",
	  "Vega",
	  "Vela",
	  "Velasco",
	  "Velásquez",
	  "Velázquez",
	  "Vélez",
	  "Véliz",
	  "Venegas",
	  "Vera",
	  "Verdugo",
	  "Verduzco",
	  "Vergara",
	  "Viera",
	  "Vigil",
	  "Villa",
	  "Villagómez",
	  "Villalobos",
	  "Villalpando",
	  "Villanueva",
	  "Villareal",
	  "Villarreal",
	  "Villaseñor",
	  "Villegas",
	  "Yáñez",
	  "Ybarra",
	  "Zambrano",
	  "Zamora",
	  "Zamudio",
	  "Zapata",
	  "Zaragoza",
	  "Zarate",
	  "Zavala",
	  "Zayas",
	  "Zelaya",
	  "Zepeda",
	  "Zúñiga"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Sr.",
	  "Sra.",
	  "Sta."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Jr.",
	  "Sr.",
	  "I",
	  "II",
	  "III",
	  "IV",
	  "V",
	  "MD",
	  "DDS",
	  "PhD",
	  "DVM"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "Jefe",
	    "Senior",
	    "Directo",
	    "Corporativo",
	    "Dinánmico",
	    "Futuro",
	    "Producto",
	    "Nacional",
	    "Regional",
	    "Distrito",
	    "Central",
	    "Global",
	    "Cliente",
	    "Inversor",
	    "International",
	    "Heredado",
	    "Adelante",
	    "Interno",
	    "Humano",
	    "Gerente",
	    "Director"
	  ],
	  "level": [
	    "Soluciones",
	    "Programa",
	    "Marca",
	    "Seguridada",
	    "Investigación",
	    "Marketing",
	    "Normas",
	    "Implementación",
	    "Integración",
	    "Funcionalidad",
	    "Respuesta",
	    "Paradigma",
	    "Tácticas",
	    "Identidad",
	    "Mercados",
	    "Grupo",
	    "División",
	    "Aplicaciones",
	    "Optimización",
	    "Operaciones",
	    "Infraestructura",
	    "Intranet",
	    "Comunicaciones",
	    "Web",
	    "Calidad",
	    "Seguro",
	    "Mobilidad",
	    "Cuentas",
	    "Datos",
	    "Creativo",
	    "Configuración",
	    "Contabilidad",
	    "Interacciones",
	    "Factores",
	    "Usabilidad",
	    "Métricas"
	  ],
	  "job": [
	    "Supervisor",
	    "Asociado",
	    "Ejecutivo",
	    "Relacciones",
	    "Oficial",
	    "Gerente",
	    "Ingeniero",
	    "Especialista",
	    "Director",
	    "Coordinador",
	    "Administrador",
	    "Arquitecto",
	    "Analista",
	    "Diseñador",
	    "Planificador",
	    "Técnico",
	    "Funcionario",
	    "Desarrollador",
	    "Productor",
	    "Consultor",
	    "Asistente",
	    "Facilitador",
	    "Agente",
	    "Representante",
	    "Estratega"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "9##-###-###",
	  "9##.###.###",
	  "9## ### ###",
	  "9########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(673);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  " s/n.",
	  ", #",
	  ", ##",
	  " #",
	  " ##",
	  " ###",
	  " ####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aguascalientes",
	  "Apodaca",
	  "Buenavista",
	  "Campeche",
	  "Cancún",
	  "Cárdenas",
	  "Celaya",
	  "Chalco",
	  "Chetumal",
	  "Chicoloapan",
	  "Chignahuapan",
	  "Chihuahua",
	  "Chilpancingo",
	  "Chimalhuacán",
	  "Ciudad Acuña",
	  "Ciudad de México",
	  "Ciudad del Carmen",
	  "Ciudad López Mateos",
	  "Ciudad Madero",
	  "Ciudad Obregón",
	  "Ciudad Valles",
	  "Ciudad Victoria",
	  "Coatzacoalcos",
	  "Colima-Villa de Álvarez",
	  "Comitán de Dominguez",
	  "Córdoba",
	  "Cuautitlán Izcalli",
	  "Cuautla",
	  "Cuernavaca",
	  "Culiacán",
	  "Delicias",
	  "Durango",
	  "Ensenada",
	  "Fresnillo",
	  "General Escobedo",
	  "Gómez Palacio",
	  "Guadalajara",
	  "Guadalupe",
	  "Guanajuato",
	  "Guaymas",
	  "Hermosillo",
	  "Hidalgo del Parral",
	  "Iguala",
	  "Irapuato",
	  "Ixtapaluca",
	  "Jiutepec",
	  "Juárez",
	  "La Laguna",
	  "La Paz",
	  "La Piedad-Pénjamo",
	  "León",
	  "Los Cabos",
	  "Los Mochis",
	  "Manzanillo",
	  "Matamoros",
	  "Mazatlán",
	  "Mérida",
	  "Mexicali",
	  "Minatitlán",
	  "Miramar",
	  "Monclova",
	  "Monclova-Frontera",
	  "Monterrey",
	  "Morelia",
	  "Naucalpan de Juárez",
	  "Navojoa",
	  "Nezahualcóyotl",
	  "Nogales",
	  "Nuevo Laredo",
	  "Oaxaca",
	  "Ocotlán",
	  "Ojo de agua",
	  "Orizaba",
	  "Pachuca",
	  "Piedras Negras",
	  "Poza Rica",
	  "Puebla",
	  "Puerto Vallarta",
	  "Querétaro",
	  "Reynosa-Río Bravo",
	  "Rioverde-Ciudad Fernández",
	  "Salamanca",
	  "Saltillo",
	  "San Cristobal de las Casas",
	  "San Francisco Coacalco",
	  "San Francisco del Rincón",
	  "San Juan Bautista Tuxtepec",
	  "San Juan del Río",
	  "San Luis Potosí-Soledad",
	  "San Luis Río Colorado",
	  "San Nicolás de los Garza",
	  "San Pablo de las Salinas",
	  "San Pedro Garza García",
	  "Santa Catarina",
	  "Soledad de Graciano Sánchez",
	  "Tampico-Pánuco",
	  "Tapachula",
	  "Tecomán",
	  "Tehuacán",
	  "Tehuacán",
	  "Tehuantepec-Salina Cruz",
	  "Tepexpan",
	  "Tepic",
	  "Tetela de Ocampo",
	  "Texcoco de Mora",
	  "Tijuana",
	  "Tlalnepantla",
	  "Tlaquepaque",
	  "Tlaxcala-Apizaco",
	  "Toluca",
	  "Tonalá",
	  "Torreón",
	  "Tula",
	  "Tulancingo",
	  "Tulancingo de Bravo",
	  "Tuxtla Gutiérrez",
	  "Uruapan",
	  "Uruapan del Progreso",
	  "Valle de México",
	  "Veracruz",
	  "Villa de Álvarez",
	  "Villa Nicolás Romero",
	  "Villahermosa",
	  "Xalapa",
	  "Zacatecas-Guadalupe",
	  "Zacatlan",
	  "Zacatzingo",
	  "Zamora-Jacona",
	  "Zapopan",
	  "Zitacuaro"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "town",
	  "ton",
	  "land",
	  "ville",
	  "berg",
	  "burgh",
	  "borough",
	  "bury",
	  "view",
	  "port",
	  "mouth",
	  "stad",
	  "furt",
	  "chester",
	  "mouth",
	  "fort",
	  "haven",
	  "side",
	  "shire"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afganistán",
	  "Albania",
	  "Argelia",
	  "Andorra",
	  "Angola",
	  "Argentina",
	  "Armenia",
	  "Aruba",
	  "Australia",
	  "Austria",
	  "Azerbayán",
	  "Bahamas",
	  "Barein",
	  "Bangladesh",
	  "Barbados",
	  "Bielorusia",
	  "Bélgica",
	  "Belice",
	  "Bermuda",
	  "Bután",
	  "Bolivia",
	  "Bosnia Herzegovina",
	  "Botswana",
	  "Brasil",
	  "Bulgaria",
	  "Burkina Faso",
	  "Burundi",
	  "Camboya",
	  "Camerún",
	  "Canada",
	  "Cabo Verde",
	  "Islas Caimán",
	  "Chad",
	  "Chile",
	  "China",
	  "Isla de Navidad",
	  "Colombia",
	  "Comodos",
	  "Congo",
	  "Costa Rica",
	  "Costa de Marfil",
	  "Croacia",
	  "Cuba",
	  "Chipre",
	  "República Checa",
	  "Dinamarca",
	  "Dominica",
	  "República Dominicana",
	  "Ecuador",
	  "Egipto",
	  "El Salvador",
	  "Guinea Ecuatorial",
	  "Eritrea",
	  "Estonia",
	  "Etiopía",
	  "Islas Faro",
	  "Fiji",
	  "Finlandia",
	  "Francia",
	  "Gabón",
	  "Gambia",
	  "Georgia",
	  "Alemania",
	  "Ghana",
	  "Grecia",
	  "Groenlandia",
	  "Granada",
	  "Guadalupe",
	  "Guam",
	  "Guatemala",
	  "Guinea",
	  "Guinea-Bisau",
	  "Guayana",
	  "Haiti",
	  "Honduras",
	  "Hong Kong",
	  "Hungria",
	  "Islandia",
	  "India",
	  "Indonesia",
	  "Iran",
	  "Irak",
	  "Irlanda",
	  "Italia",
	  "Jamaica",
	  "Japón",
	  "Jordania",
	  "Kazajistan",
	  "Kenia",
	  "Kiribati",
	  "Corea",
	  "Kuwait",
	  "Letonia",
	  "Líbano",
	  "Liberia",
	  "Liechtenstein",
	  "Lituania",
	  "Luxemburgo",
	  "Macao",
	  "Macedonia",
	  "Madagascar",
	  "Malawi",
	  "Malasia",
	  "Maldivas",
	  "Mali",
	  "Malta",
	  "Martinica",
	  "Mauritania",
	  "México",
	  "Micronesia",
	  "Moldavia",
	  "Mónaco",
	  "Mongolia",
	  "Montenegro",
	  "Montserrat",
	  "Marruecos",
	  "Mozambique",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Holanda",
	  "Nueva Zelanda",
	  "Nicaragua",
	  "Niger",
	  "Nigeria",
	  "Noruega",
	  "Omán",
	  "Pakistan",
	  "Panamá",
	  "Papúa Nueva Guinea",
	  "Paraguay",
	  "Perú",
	  "Filipinas",
	  "Poland",
	  "Portugal",
	  "Puerto Rico",
	  "Rusia",
	  "Ruanda",
	  "Samoa",
	  "San Marino",
	  "Santo Tomé y Principe",
	  "Arabia Saudí",
	  "Senegal",
	  "Serbia",
	  "Seychelles",
	  "Sierra Leona",
	  "Singapur",
	  "Eslovaquia",
	  "Eslovenia",
	  "Somalia",
	  "España",
	  "Sri Lanka",
	  "Sudán",
	  "Suriname",
	  "Suecia",
	  "Suiza",
	  "Siria",
	  "Taiwan",
	  "Tajikistan",
	  "Tanzania",
	  "Tailandia",
	  "Timor-Leste",
	  "Togo",
	  "Tonga",
	  "Trinidad y Tobago",
	  "Tunez",
	  "Turquia",
	  "Uganda",
	  "Ucrania",
	  "Emiratos Árabes Unidos",
	  "Reino Unido",
	  "Estados Unidos de América",
	  "Uruguay",
	  "Uzbekistan",
	  "Vanuatu",
	  "Venezuela",
	  "Vietnam",
	  "Yemen",
	  "Zambia",
	  "Zimbabwe"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "México"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(677);
	address.city_suffix = __webpack_require__(678);
	address.country = __webpack_require__(679);
	address.building_number = __webpack_require__(675);
	address.street_suffix = __webpack_require__(689);
	address.secondary_address = __webpack_require__(683);
	address.postcode = __webpack_require__(682);
	address.state = __webpack_require__(684);
	address.state_abbr = __webpack_require__(685);
	address.time_zone = __webpack_require__(690);
	address.city = __webpack_require__(676);
	address.street = __webpack_require__(686);
	address.street_name = __webpack_require__(688);
	address.street_address = __webpack_require__(687);
	address.default_country = __webpack_require__(680);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Esc. ###",
	  "Puerta ###",
	  "Edificio #"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aguascalientes",
	  "Baja California Norte",
	  "Baja California Sur",
	  'Estado de México',
	  "Campeche",
	  "Chiapas",
	  "Chihuahua",
	  "Coahuila",
	  "Colima",
	  "Durango",
	  "Guanajuato",
	  "Guerrero",
	  "Hidalgo",
	  "Jalisco",
	  "Michoacan",
	  "Morelos",
	  "Nayarit",
	  'Nuevo León',
	  "Oaxaca",
	  "Puebla",
	  "Querétaro",
	  "Quintana Roo",
	  "San Luis Potosí",
	  "Sinaloa",
	  "Sonora",
	  "Tabasco",
	  "Tamaulipas",
	  "Tlaxcala",
	  "Veracruz",
	  "Yucatán",
	  "Zacatecas"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AS",
	  "BC",
	  "BS",
	  "CC",
	  "CS",
	  "CH",
	  "CL",
	  "CM",
	  "DF",
	  "DG",
	  "GT",
	  "GR",
	  "HG",
	  "JC",
	  "MC",
	  "MN",
	  "MS",
	  "NT",
	  "NL",
	  "OC",
	  "PL",
	  "QT",
	  "QR",
	  "SP",
	  "SL",
	  "SR",
	  "TC",
	  "TS",
	  "TL",
	  "VZ",
	  "YN",
	  "ZS"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
		"20 de Noviembre",
		"Cinco de Mayo",
		"Cuahutemoc",
		"Manzanares",
		"Donceles",
		"Francisco I. Madero",
		"Juárez",
		"Repúplica de Cuba",
		"Repúplica de Chile",
		"Repúplica de Argentina",
		"Repúplica de Uruguay",
		"Isabel la Católica",
		"Izazaga",
		"Eje Central",
		"Eje 6",
		"Eje 5",
		"La viga",
		"Aniceto Ortega",
		"Miguel Ángel de Quevedo",
		"Amores",
		"Coyoacán",
		"Coruña",
		"Batalla de Naco",
		"La otra banda",
		"Piedra del Comal",
		"Balcón de los edecanes",
		"Barrio la Lonja",
		"Jicolapa",
		"Zacatlán",
		"Zapata",
		"Polotitlan",
		"Calimaya",
		"Flor Marina",
		"Flor Solvestre",
		"San Miguel",
		"Naranjo",
		"Cedro",
		"Jalisco",
		"Avena"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name}#{building_number}",
	  "#{street_name}#{building_number} #{secondary_address}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_suffix} #{Name.first_name}",
	  "#{street_suffix} #{Name.first_name} #{Name.last_name}",
	  "#{street_suffix} #{street}",
	  "#{street_suffix} #{street}",
	  "#{street_suffix} #{street}",
	  "#{street_suffix} #{street}"
	
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aldea",
	  "Apartamento",
	  "Arrabal",
	  "Arroyo",
	  "Avenida",
	  "Bajada",
	  "Barranco",
	  "Barrio",
	  "Bloque",
	  "Calle",
	  "Calleja",
	  "Camino",
	  "Carretera",
	  "Caserio",
	  "Colegio",
	  "Colonia",
	  "Conjunto",
	  "Cuesta",
	  "Chalet",
	  "Edificio",
	  "Entrada",
	  "Escalinata",
	  "Explanada",
	  "Extramuros",
	  "Extrarradio",
	  "Ferrocarril",
	  "Glorieta",
	  "Gran Subida",
	  "Grupo",
	  "Huerta",
	  "Jardines",
	  "Lado",
	  "Lugar",
	  "Manzana",
	  "Masía",
	  "Mercado",
	  "Monte",
	  "Muelle",
	  "Municipio",
	  "Parcela",
	  "Parque",
	  "Partida",
	  "Pasaje",
	  "Paseo",
	  "Plaza",
	  "Poblado",
	  "Polígono",
	  "Prolongación",
	  "Puente",
	  "Puerta",
	  "Quinta",
	  "Ramal",
	  "Rambla",
	  "Rampa",
	  "Riera",
	  "Rincón",
	  "Ronda",
	  "Rua",
	  "Salida",
	  "Sector",
	  "Sección",
	  "Senda",
	  "Solar",
	  "Subida",
	  "Terrenos",
	  "Torrente",
	  "Travesía",
	  "Urbanización",
	  "Vía",
	  "Vía Pública"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pacífico/Midway",
	  "Pacífico/Pago_Pago",
	  "Pacífico/Honolulu",
	  "America/Juneau",
	  "America/Los_Angeles",
	  "America/Tijuana",
	  "America/Denver",
	  "America/Phoenix",
	  "America/Chihuahua",
	  "America/Mazatlan",
	  "America/Chicago",
	  "America/Regina",
	  "America/Mexico_City",
	  "America/Monterrey",
	  "America/Guatemala",
	  "America/New_York",
	  "America/Indiana/Indianapolis",
	  "America/Bogota",
	  "America/Lima",
	  "America/Lima",
	  "America/Halifax",
	  "America/Caracas",
	  "America/La_Paz",
	  "America/Santiago",
	  "America/St_Johns",
	  "America/Sao_Paulo",
	  "America/Argentina/Buenos_Aires",
	  "America/Guyana",
	  "America/Godthab",
	  "Atlantic/South_Georgia",
	  "Atlantic/Azores",
	  "Atlantic/Cape_Verde",
	  "Europa/Dublin",
	  "Europa/London",
	  "Europa/Lisbon",
	  "Europa/London",
	  "Africa/Casablanca",
	  "Africa/Monrovia",
	  "Etc/UTC",
	  "Europa/Belgrade",
	  "Europa/Bratislava",
	  "Europa/Budapest",
	  "Europa/Ljubljana",
	  "Europa/Prague",
	  "Europa/Sarajevo",
	  "Europa/Skopje",
	  "Europa/Warsaw",
	  "Europa/Zagreb",
	  "Europa/Brussels",
	  "Europa/Copenhagen",
	  "Europa/Madrid",
	  "Europa/Paris",
	  "Europa/Amsterdam",
	  "Europa/Berlin",
	  "Europa/Berlin",
	  "Europa/Rome",
	  "Europa/Stockholm",
	  "Europa/Vienna",
	  "Africa/Algiers",
	  "Europa/Bucharest",
	  "Africa/Cairo",
	  "Europa/Helsinki",
	  "Europa/Kiev",
	  "Europa/Riga",
	  "Europa/Sofia",
	  "Europa/Tallinn",
	  "Europa/Vilnius",
	  "Europa/Athens",
	  "Europa/Istanbul",
	  "Europa/Minsk",
	  "Asia/Jerusalen",
	  "Africa/Harare",
	  "Africa/Johannesburg",
	  "Europa/Moscú",
	  "Europa/Moscú",
	  "Europa/Moscú",
	  "Asia/Kuwait",
	  "Asia/Riyadh",
	  "Africa/Nairobi",
	  "Asia/Baghdad",
	  "Asia/Tehran",
	  "Asia/Muscat",
	  "Asia/Muscat",
	  "Asia/Baku",
	  "Asia/Tbilisi",
	  "Asia/Yerevan",
	  "Asia/Kabul",
	  "Asia/Yekaterinburg",
	  "Asia/Karachi",
	  "Asia/Karachi",
	  "Asia/Tashkent",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kathmandu",
	  "Asia/Dhaka",
	  "Asia/Dhaka",
	  "Asia/Colombo",
	  "Asia/Almaty",
	  "Asia/Novosibirsk",
	  "Asia/Rangoon",
	  "Asia/Bangkok",
	  "Asia/Bangkok",
	  "Asia/Jakarta",
	  "Asia/Krasnoyarsk",
	  "Asia/Shanghai",
	  "Asia/Chongqing",
	  "Asia/Hong_Kong",
	  "Asia/Urumqi",
	  "Asia/Kuala_Lumpur",
	  "Asia/Singapore",
	  "Asia/Taipei",
	  "Australia/Perth",
	  "Asia/Irkutsk",
	  "Asia/Ulaanbaatar",
	  "Asia/Seoul",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Yakutsk",
	  "Australia/Darwin",
	  "Australia/Adelaide",
	  "Australia/Melbourne",
	  "Australia/Melbourne",
	  "Australia/Sydney",
	  "Australia/Brisbane",
	  "Australia/Hobart",
	  "Asia/Vladivostok",
	  "Pacífico/Guam",
	  "Pacífico/Port_Moresby",
	  "Asia/Magadan",
	  "Asia/Magadan",
	  "Pacífico/Noumea",
	  "Pacífico/Fiji",
	  "Asia/Kamchatka",
	  "Pacífico/Majuro",
	  "Pacífico/Auckland",
	  "Pacífico/Auckland",
	  "Pacífico/Tongatapu",
	  "Pacífico/Fakaofo",
	  "Pacífico/Apia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "5##-###-###",
	  "5##.###.###",
	  "5## ### ###",
	  "5########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(691);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	   "rojo",
	   "verde",
	   "azul",
	   "amarillo",
	   "morado",
	   "Menta verde",
	   "teal",
	   "blanco",
	   "negro",
	   "Naranja",
	   "Rosa",
	   "gris",
	   "marrón",
	   "violeta",
	   "turquesa",
	   "tan",
	   "cielo azul",
	   "salmón",
	   "ciruela",
	   "orquídea",
	   "aceituna",
	   "magenta",
	   "Lima",
	   "marfil",
	   "índigo",
	   "oro",
	   "fucsia",
	   "cian",
	   "azul",
	   "lavanda",
	   "plata"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	   "Libros",
	   "Películas",
	   "Música",
	   "Juegos",
	   "Electrónica",
	   "Ordenadores",
	   "Hogar",
	   "Jardín",
	   "Herramientas",
	   "Ultramarinos",
	   "Salud",
	   "Belleza",
	   "Juguetes",
	   "Kids",
	   "Baby",
	   "Ropa",
	   "Zapatos",
	   "Joyería",
	   "Deportes",
	   "Aire libre",
	   "Automoción",
	   "Industrial"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var commerce = {};
	module['exports'] = commerce;
	commerce.color = __webpack_require__(693);
	commerce.department = __webpack_require__(694);
	commerce.product_name = __webpack_require__(696);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	"adjective": [
	     "Pequeño",
	     "Ergonómico",
	     "Rústico",
	     "Inteligente",
	     "Gorgeous",
	     "Increíble",
	     "Fantástico",
	     "Práctica",
	     "Elegante",
	     "Increíble",
	     "Genérica",
	     "Artesanal",
	     "Hecho a mano",
	     "Licencia",
	     "Refinado",
	     "Sin marca",
	     "Sabrosa"
	   ],
	"material": [
	     "Acero",
	     "Madera",
	     "Hormigón",
	     "Plástico",
	     "Cotton",
	     "Granito",
	     "Caucho",
	     "Metal",
	     "Soft",
	     "Fresco",
	     "Frozen"
	   ],
	"product": [
	     "Presidente",
	     "Auto",
	     "Computadora",
	     "Teclado",
	     "Ratón",
	     "Bike",
	     "Pelota",
	     "Guantes",
	     "Pantalones",
	     "Camisa",
	     "Mesa",
	     "Zapatos",
	     "Sombrero",
	     "Toallas",
	     "Jabón",
	     "Tuna",
	     "Pollo",
	     "Pescado",
	     "Queso",
	     "Tocino",
	     "Pizza",
	     "Ensalada",
	     "Embutidos"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adaptativo",
	  "Avanzado",
	  "Asimilado",
	  "Automatizado",
	  "Equilibrado",
	  "Centrado en el negocio",
	  "Centralizado",
	  "Clonado",
	  "Compatible",
	  "Configurable",
	  "Multi grupo",
	  "Multi plataforma",
	  "Centrado en el usuario",
	  "Configurable",
	  "Descentralizado",
	  "Digitalizado",
	  "Distribuido",
	  "Diverso",
	  "Reducido",
	  "Mejorado",
	  "Para toda la empresa",
	  "Ergonomico",
	  "Exclusivo",
	  "Expandido",
	  "Extendido",
	  "Cara a cara",
	  "Enfocado",
	  "Totalmente configurable",
	  "Fundamental",
	  "Orígenes",
	  "Horizontal",
	  "Implementado",
	  "Innovador",
	  "Integrado",
	  "Intuitivo",
	  "Inverso",
	  "Gestionado",
	  "Obligatorio",
	  "Monitorizado",
	  "Multi canal",
	  "Multi lateral",
	  "Multi capa",
	  "En red",
	  "Orientado a objetos",
	  "Open-source",
	  "Operativo",
	  "Optimizado",
	  "Opcional",
	  "Organico",
	  "Organizado",
	  "Perseverando",
	  "Persistente",
	  "en fases",
	  "Polarizado",
	  "Pre-emptivo",
	  "Proactivo",
	  "Enfocado a benficios",
	  "Profundo",
	  "Programable",
	  "Progresivo",
	  "Public-key",
	  "Enfocado en la calidad",
	  "Reactivo",
	  "Realineado",
	  "Re-contextualizado",
	  "Re-implementado",
	  "Reducido",
	  "Ingenieria inversa",
	  "Robusto",
	  "Fácil",
	  "Seguro",
	  "Auto proporciona",
	  "Compartible",
	  "Intercambiable",
	  "Sincronizado",
	  "Orientado a equipos",
	  "Total",
	  "Universal",
	  "Mejorado",
	  "Actualizable",
	  "Centrado en el usuario",
	  "Amigable",
	  "Versatil",
	  "Virtual",
	  "Visionario"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Clics y mortero",
	  "Valor añadido",
	  "Vertical",
	  "Proactivo",
	  "Robusto",
	  "Revolucionario",
	  "Escalable",
	  "De vanguardia",
	  "Innovador",
	  "Intuitivo",
	  "Estratégico",
	  "E-business",
	  "Misión crítica",
	  "Pegajosa",
	  "Doce y cincuenta y nueve de la noche",
	  "24/7",
	  "De extremo a extremo",
	  "Global",
	  "B2B",
	  "B2C",
	  "Granular",
	  "Fricción",
	  "Virtual",
	  "Viral",
	  "Dinámico",
	  "24/365",
	  "Mejor de su clase",
	  "Asesino",
	  "Magnética",
	  "Filo sangriento",
	  "Habilitado web",
	  "Interactiva",
	  "Punto com",
	  "Sexy",
	  "Back-end",
	  "Tiempo real",
	  "Eficiente",
	  "Frontal",
	  "Distribuida",
	  "Sin costura",
	  "Extensible",
	  "Llave en mano",
	  "Clase mundial",
	  "Código abierto",
	  "Multiplataforma",
	  "Cross-media",
	  "Sinérgico",
	  "ladrillos y clics",
	  "Fuera de la caja",
	  "Empresa",
	  "Integrado",
	  "Impactante",
	  "Inalámbrico",
	  "Transparente",
	  "Próxima generación",
	  "Innovador",
	  "User-centric",
	  "Visionario",
	  "A medida",
	  "Ubicua",
	  "Enchufa y juega",
	  "Colaboración",
	  "Convincente",
	  "Holístico",
	  "Ricos"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	   "sinergias",
	   "web-readiness",
	   "paradigmas",
	   "mercados",
	   "asociaciones",
	   "infraestructuras",
	   "plataformas",
	   "iniciativas",
	   "canales",
	   "ojos",
	   "comunidades",
	   "ROI",
	   "soluciones",
	   "minoristas electrónicos",
	   "e-servicios",
	   "elementos de acción",
	   "portales",
	   "nichos",
	   "tecnologías",
	   "contenido",
	   "vortales",
	   "cadenas de suministro",
	   "convergencia",
	   "relaciones",
	   "arquitecturas",
	   "interfaces",
	   "mercados electrónicos",
	   "e-commerce",
	   "sistemas",
	   "ancho de banda",
	   "infomediarios",
	   "modelos",
	   "Mindshare",
	   "entregables",
	   "usuarios",
	   "esquemas",
	   "redes",
	   "aplicaciones",
	   "métricas",
	   "e-business",
	   "funcionalidades",
	   "experiencias",
	   "servicios web",
	   "metodologías"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	   "poner en práctica",
	   "utilizar",
	   "integrar",
	   "racionalizar",
	   "optimizar",
	   "evolucionar",
	   "transformar",
	   "abrazar",
	   "habilitar",
	   "orquestar",
	   "apalancamiento",
	   "reinventar",
	   "agregado",
	   "arquitecto",
	   "mejorar",
	   "incentivar",
	   "transformarse",
	   "empoderar",
	   "Envisioneer",
	   "monetizar",
	   "arnés",
	   "facilitar",
	   "aprovechar",
	   "desintermediar",
	   "sinergia",
	   "estrategias",
	   "desplegar",
	   "marca",
	   "crecer",
	   "objetivo",
	   "sindicato",
	   "sintetizar",
	   "entregue",
	   "malla",
	   "incubar",
	   "enganchar",
	   "maximizar",
	   "punto de referencia",
	   "acelerar",
	   "reintermediate",
	   "pizarra",
	   "visualizar",
	   "reutilizar",
	   "innovar",
	   "escala",
	   "desatar",
	   "conducir",
	   "extender",
	   "ingeniero",
	   "revolucionar",
	   "generar",
	   "explotar",
	   "transición",
	   "e-enable",
	   "repetir",
	   "cultivar",
	   "matriz",
	   "productize",
	   "redefinir",
	   "recontextualizar"
	]
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 horas",
	  "24/7",
	  "3rd generación",
	  "4th generación",
	  "5th generación",
	  "6th generación",
	  "analizada",
	  "asimétrica",
	  "asíncrona",
	  "monitorizada por red",
	  "bidireccional",
	  "bifurcada",
	  "generada por el cliente",
	  "cliente servidor",
	  "coherente",
	  "cohesiva",
	  "compuesto",
	  "sensible al contexto",
	  "basado en el contexto",
	  "basado en contenido",
	  "dedicada",
	  "generado por la demanda",
	  "didactica",
	  "direccional",
	  "discreta",
	  "dinámica",
	  "potenciada",
	  "acompasada",
	  "ejecutiva",
	  "explícita",
	  "tolerante a fallos",
	  "innovadora",
	  "amplio ábanico",
	  "global",
	  "heurística",
	  "alto nivel",
	  "holística",
	  "homogénea",
	  "hibrida",
	  "incremental",
	  "intangible",
	  "interactiva",
	  "intermedia",
	  "local",
	  "logística",
	  "maximizada",
	  "metódica",
	  "misión crítica",
	  "móbil",
	  "modular",
	  "motivadora",
	  "multimedia",
	  "multiestado",
	  "multitarea",
	  "nacional",
	  "basado en necesidades",
	  "neutral",
	  "nueva generación",
	  "no-volátil",
	  "orientado a objetos",
	  "óptima",
	  "optimizada",
	  "radical",
	  "tiempo real",
	  "recíproca",
	  "regional",
	  "escalable",
	  "secundaria",
	  "orientada a soluciones",
	  "estable",
	  "estatica",
	  "sistemática",
	  "sistémica",
	  "tangible",
	  "terciaria",
	  "transicional",
	  "uniforme",
	  "valor añadido",
	  "vía web",
	  "defectos cero",
	  "tolerancia cero"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(705);
	company.adjective = __webpack_require__(697);
	company.descriptor = __webpack_require__(701);
	company.noun = __webpack_require__(704);
	company.bs_verb = __webpack_require__(700);
	company.name = __webpack_require__(703);
	company.bs_adjective = __webpack_require__(698);
	company.bs_noun = __webpack_require__(699);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name} y #{Name.last_name}",
	  "#{Name.last_name} #{Name.last_name} #{suffix}",
	  "#{Name.last_name}, #{Name.last_name} y #{Name.last_name} Asociados"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "habilidad",
	  "acceso",
	  "adaptador",
	  "algoritmo",
	  "alianza",
	  "analista",
	  "aplicación",
	  "enfoque",
	  "arquitectura",
	  "archivo",
	  "inteligencia artificial",
	  "array",
	  "actitud",
	  "medición",
	  "gestión presupuestaria",
	  "capacidad",
	  "desafío",
	  "circuito",
	  "colaboración",
	  "complejidad",
	  "concepto",
	  "conglomeración",
	  "contingencia",
	  "núcleo",
	  "fidelidad",
	  "base de datos",
	  "data-warehouse",
	  "definición",
	  "emulación",
	  "codificar",
	  "encriptar",
	  "extranet",
	  "firmware",
	  "flexibilidad",
	  "focus group",
	  "previsión",
	  "base de trabajo",
	  "función",
	  "funcionalidad",
	  "Interfaz Gráfica",
	  "groupware",
	  "Interfaz gráfico de usuario",
	  "hardware",
	  "Soporte",
	  "jerarquía",
	  "conjunto",
	  "implementación",
	  "infraestructura",
	  "iniciativa",
	  "instalación",
	  "conjunto de instrucciones",
	  "interfaz",
	  "intranet",
	  "base del conocimiento",
	  "red de area local",
	  "aprovechar",
	  "matrices",
	  "metodologías",
	  "middleware",
	  "migración",
	  "modelo",
	  "moderador",
	  "monitorizar",
	  "arquitectura abierta",
	  "sistema abierto",
	  "orquestar",
	  "paradigma",
	  "paralelismo",
	  "política",
	  "portal",
	  "estructura de precios",
	  "proceso de mejora",
	  "producto",
	  "productividad",
	  "proyecto",
	  "proyección",
	  "protocolo",
	  "línea segura",
	  "software",
	  "solución",
	  "estandardización",
	  "estrategia",
	  "estructura",
	  "éxito",
	  "superestructura",
	  "soporte",
	  "sinergia",
	  "mediante",
	  "marco de tiempo",
	  "caja de herramientas",
	  "utilización",
	  "website",
	  "fuerza de trabajo"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "S.L.",
	  "e Hijos",
	  "S.A.",
	  "Hermanos"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var es_MX = {};
	module['exports'] = es_MX;
	es_MX.title = "Spanish Mexico";
	es_MX.separator = " & ";
	es_MX.name = __webpack_require__(714);
	es_MX.address = __webpack_require__(681);
	es_MX.company = __webpack_require__(702);
	es_MX.internet = __webpack_require__(709);
	es_MX.phone_number = __webpack_require__(721);
	es_MX.cell_phone = __webpack_require__(692);
	es_MX.lorem = __webpack_require__(710);
	es_MX.commerce = __webpack_require__(695);
	es_MX.team = __webpack_require__(723);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "mx",
	  "info",
	  "com.mx",
	  "org",
	  "gob.mx"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com",
	  "nearbpo.com",
	  "corpfolder.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(708);
	internet.domain_suffix = __webpack_require__(707);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(712);
	lorem.supplemental = __webpack_require__(711);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "abbas",
	  "abduco",
	  "abeo",
	  "abscido",
	  "absconditus",
	  "absens",
	  "absorbeo",
	  "absque",
	  "abstergo",
	  "absum",
	  "abundans",
	  "abutor",
	  "accedo",
	  "accendo",
	  "acceptus",
	  "accipio",
	  "accommodo",
	  "accusator",
	  "acer",
	  "acerbitas",
	  "acervus",
	  "acidus",
	  "acies",
	  "acquiro",
	  "acsi",
	  "adamo",
	  "adaugeo",
	  "addo",
	  "adduco",
	  "ademptio",
	  "adeo",
	  "adeptio",
	  "adfectus",
	  "adfero",
	  "adficio",
	  "adflicto",
	  "adhaero",
	  "adhuc",
	  "adicio",
	  "adimpleo",
	  "adinventitias",
	  "adipiscor",
	  "adiuvo",
	  "administratio",
	  "admiratio",
	  "admitto",
	  "admoneo",
	  "admoveo",
	  "adnuo",
	  "adopto",
	  "adsidue",
	  "adstringo",
	  "adsuesco",
	  "adsum",
	  "adulatio",
	  "adulescens",
	  "adultus",
	  "aduro",
	  "advenio",
	  "adversus",
	  "advoco",
	  "aedificium",
	  "aeger",
	  "aegre",
	  "aegrotatio",
	  "aegrus",
	  "aeneus",
	  "aequitas",
	  "aequus",
	  "aer",
	  "aestas",
	  "aestivus",
	  "aestus",
	  "aetas",
	  "aeternus",
	  "ager",
	  "aggero",
	  "aggredior",
	  "agnitio",
	  "agnosco",
	  "ago",
	  "ait",
	  "aiunt",
	  "alienus",
	  "alii",
	  "alioqui",
	  "aliqua",
	  "alius",
	  "allatus",
	  "alo",
	  "alter",
	  "altus",
	  "alveus",
	  "amaritudo",
	  "ambitus",
	  "ambulo",
	  "amicitia",
	  "amiculum",
	  "amissio",
	  "amita",
	  "amitto",
	  "amo",
	  "amor",
	  "amoveo",
	  "amplexus",
	  "amplitudo",
	  "amplus",
	  "ancilla",
	  "angelus",
	  "angulus",
	  "angustus",
	  "animadverto",
	  "animi",
	  "animus",
	  "annus",
	  "anser",
	  "ante",
	  "antea",
	  "antepono",
	  "antiquus",
	  "aperio",
	  "aperte",
	  "apostolus",
	  "apparatus",
	  "appello",
	  "appono",
	  "appositus",
	  "approbo",
	  "apto",
	  "aptus",
	  "apud",
	  "aqua",
	  "ara",
	  "aranea",
	  "arbitro",
	  "arbor",
	  "arbustum",
	  "arca",
	  "arceo",
	  "arcesso",
	  "arcus",
	  "argentum",
	  "argumentum",
	  "arguo",
	  "arma",
	  "armarium",
	  "armo",
	  "aro",
	  "ars",
	  "articulus",
	  "artificiose",
	  "arto",
	  "arx",
	  "ascisco",
	  "ascit",
	  "asper",
	  "aspicio",
	  "asporto",
	  "assentator",
	  "astrum",
	  "atavus",
	  "ater",
	  "atqui",
	  "atrocitas",
	  "atrox",
	  "attero",
	  "attollo",
	  "attonbitus",
	  "auctor",
	  "auctus",
	  "audacia",
	  "audax",
	  "audentia",
	  "audeo",
	  "audio",
	  "auditor",
	  "aufero",
	  "aureus",
	  "auris",
	  "aurum",
	  "aut",
	  "autem",
	  "autus",
	  "auxilium",
	  "avaritia",
	  "avarus",
	  "aveho",
	  "averto",
	  "avoco",
	  "baiulus",
	  "balbus",
	  "barba",
	  "bardus",
	  "basium",
	  "beatus",
	  "bellicus",
	  "bellum",
	  "bene",
	  "beneficium",
	  "benevolentia",
	  "benigne",
	  "bestia",
	  "bibo",
	  "bis",
	  "blandior",
	  "bonus",
	  "bos",
	  "brevis",
	  "cado",
	  "caecus",
	  "caelestis",
	  "caelum",
	  "calamitas",
	  "calcar",
	  "calco",
	  "calculus",
	  "callide",
	  "campana",
	  "candidus",
	  "canis",
	  "canonicus",
	  "canto",
	  "capillus",
	  "capio",
	  "capitulus",
	  "capto",
	  "caput",
	  "carbo",
	  "carcer",
	  "careo",
	  "caries",
	  "cariosus",
	  "caritas",
	  "carmen",
	  "carpo",
	  "carus",
	  "casso",
	  "caste",
	  "casus",
	  "catena",
	  "caterva",
	  "cattus",
	  "cauda",
	  "causa",
	  "caute",
	  "caveo",
	  "cavus",
	  "cedo",
	  "celebrer",
	  "celer",
	  "celo",
	  "cena",
	  "cenaculum",
	  "ceno",
	  "censura",
	  "centum",
	  "cerno",
	  "cernuus",
	  "certe",
	  "certo",
	  "certus",
	  "cervus",
	  "cetera",
	  "charisma",
	  "chirographum",
	  "cibo",
	  "cibus",
	  "cicuta",
	  "cilicium",
	  "cimentarius",
	  "ciminatio",
	  "cinis",
	  "circumvenio",
	  "cito",
	  "civis",
	  "civitas",
	  "clam",
	  "clamo",
	  "claro",
	  "clarus",
	  "claudeo",
	  "claustrum",
	  "clementia",
	  "clibanus",
	  "coadunatio",
	  "coaegresco",
	  "coepi",
	  "coerceo",
	  "cogito",
	  "cognatus",
	  "cognomen",
	  "cogo",
	  "cohaero",
	  "cohibeo",
	  "cohors",
	  "colligo",
	  "colloco",
	  "collum",
	  "colo",
	  "color",
	  "coma",
	  "combibo",
	  "comburo",
	  "comedo",
	  "comes",
	  "cometes",
	  "comis",
	  "comitatus",
	  "commemoro",
	  "comminor",
	  "commodo",
	  "communis",
	  "comparo",
	  "compello",
	  "complectus",
	  "compono",
	  "comprehendo",
	  "comptus",
	  "conatus",
	  "concedo",
	  "concido",
	  "conculco",
	  "condico",
	  "conduco",
	  "confero",
	  "confido",
	  "conforto",
	  "confugo",
	  "congregatio",
	  "conicio",
	  "coniecto",
	  "conitor",
	  "coniuratio",
	  "conor",
	  "conqueror",
	  "conscendo",
	  "conservo",
	  "considero",
	  "conspergo",
	  "constans",
	  "consuasor",
	  "contabesco",
	  "contego",
	  "contigo",
	  "contra",
	  "conturbo",
	  "conventus",
	  "convoco",
	  "copia",
	  "copiose",
	  "cornu",
	  "corona",
	  "corpus",
	  "correptius",
	  "corrigo",
	  "corroboro",
	  "corrumpo",
	  "coruscus",
	  "cotidie",
	  "crapula",
	  "cras",
	  "crastinus",
	  "creator",
	  "creber",
	  "crebro",
	  "credo",
	  "creo",
	  "creptio",
	  "crepusculum",
	  "cresco",
	  "creta",
	  "cribro",
	  "crinis",
	  "cruciamentum",
	  "crudelis",
	  "cruentus",
	  "crur",
	  "crustulum",
	  "crux",
	  "cubicularis",
	  "cubitum",
	  "cubo",
	  "cui",
	  "cuius",
	  "culpa",
	  "culpo",
	  "cultellus",
	  "cultura",
	  "cum",
	  "cunabula",
	  "cunae",
	  "cunctatio",
	  "cupiditas",
	  "cupio",
	  "cuppedia",
	  "cupressus",
	  "cur",
	  "cura",
	  "curatio",
	  "curia",
	  "curiositas",
	  "curis",
	  "curo",
	  "curriculum",
	  "currus",
	  "cursim",
	  "curso",
	  "cursus",
	  "curto",
	  "curtus",
	  "curvo",
	  "curvus",
	  "custodia",
	  "damnatio",
	  "damno",
	  "dapifer",
	  "debeo",
	  "debilito",
	  "decens",
	  "decerno",
	  "decet",
	  "decimus",
	  "decipio",
	  "decor",
	  "decretum",
	  "decumbo",
	  "dedecor",
	  "dedico",
	  "deduco",
	  "defaeco",
	  "defendo",
	  "defero",
	  "defessus",
	  "defetiscor",
	  "deficio",
	  "defigo",
	  "defleo",
	  "defluo",
	  "defungo",
	  "degenero",
	  "degero",
	  "degusto",
	  "deinde",
	  "delectatio",
	  "delego",
	  "deleo",
	  "delibero",
	  "delicate",
	  "delinquo",
	  "deludo",
	  "demens",
	  "demergo",
	  "demitto",
	  "demo",
	  "demonstro",
	  "demoror",
	  "demulceo",
	  "demum",
	  "denego",
	  "denique",
	  "dens",
	  "denuncio",
	  "denuo",
	  "deorsum",
	  "depereo",
	  "depono",
	  "depopulo",
	  "deporto",
	  "depraedor",
	  "deprecator",
	  "deprimo",
	  "depromo",
	  "depulso",
	  "deputo",
	  "derelinquo",
	  "derideo",
	  "deripio",
	  "desidero",
	  "desino",
	  "desipio",
	  "desolo",
	  "desparatus",
	  "despecto",
	  "despirmatio",
	  "infit",
	  "inflammatio",
	  "paens",
	  "patior",
	  "patria",
	  "patrocinor",
	  "patruus",
	  "pauci",
	  "paulatim",
	  "pauper",
	  "pax",
	  "peccatus",
	  "pecco",
	  "pecto",
	  "pectus",
	  "pecunia",
	  "pecus",
	  "peior",
	  "pel",
	  "ocer",
	  "socius",
	  "sodalitas",
	  "sol",
	  "soleo",
	  "solio",
	  "solitudo",
	  "solium",
	  "sollers",
	  "sollicito",
	  "solum",
	  "solus",
	  "solutio",
	  "solvo",
	  "somniculosus",
	  "somnus",
	  "sonitus",
	  "sono",
	  "sophismata",
	  "sopor",
	  "sordeo",
	  "sortitus",
	  "spargo",
	  "speciosus",
	  "spectaculum",
	  "speculum",
	  "sperno",
	  "spero",
	  "spes",
	  "spiculum",
	  "spiritus",
	  "spoliatio",
	  "sponte",
	  "stabilis",
	  "statim",
	  "statua",
	  "stella",
	  "stillicidium",
	  "stipes",
	  "stips",
	  "sto",
	  "strenuus",
	  "strues",
	  "studio",
	  "stultus",
	  "suadeo",
	  "suasoria",
	  "sub",
	  "subito",
	  "subiungo",
	  "sublime",
	  "subnecto",
	  "subseco",
	  "substantia",
	  "subvenio",
	  "succedo",
	  "succurro",
	  "sufficio",
	  "suffoco",
	  "suffragium",
	  "suggero",
	  "sui",
	  "sulum",
	  "sum",
	  "summa",
	  "summisse",
	  "summopere",
	  "sumo",
	  "sumptus",
	  "supellex",
	  "super",
	  "suppellex",
	  "supplanto",
	  "suppono",
	  "supra",
	  "surculus",
	  "surgo",
	  "sursum",
	  "suscipio",
	  "suspendo",
	  "sustineo",
	  "suus",
	  "synagoga",
	  "tabella",
	  "tabernus",
	  "tabesco",
	  "tabgo",
	  "tabula",
	  "taceo",
	  "tactus",
	  "taedium",
	  "talio",
	  "talis",
	  "talus",
	  "tam",
	  "tamdiu",
	  "tamen",
	  "tametsi",
	  "tamisium",
	  "tamquam",
	  "tandem",
	  "tantillus",
	  "tantum",
	  "tardus",
	  "tego",
	  "temeritas",
	  "temperantia",
	  "templum",
	  "temptatio",
	  "tempus",
	  "tenax",
	  "tendo",
	  "teneo",
	  "tener",
	  "tenuis",
	  "tenus",
	  "tepesco",
	  "tepidus",
	  "ter",
	  "terebro",
	  "teres",
	  "terga",
	  "tergeo",
	  "tergiversatio",
	  "tergo",
	  "tergum",
	  "termes",
	  "terminatio",
	  "tero",
	  "terra",
	  "terreo",
	  "territo",
	  "terror",
	  "tersus",
	  "tertius",
	  "testimonium",
	  "texo",
	  "textilis",
	  "textor",
	  "textus",
	  "thalassinus",
	  "theatrum",
	  "theca",
	  "thema",
	  "theologus",
	  "thermae",
	  "thesaurus",
	  "thesis",
	  "thorax",
	  "thymbra",
	  "thymum",
	  "tibi",
	  "timidus",
	  "timor",
	  "titulus",
	  "tolero",
	  "tollo",
	  "tondeo",
	  "tonsor",
	  "torqueo",
	  "torrens",
	  "tot",
	  "totidem",
	  "toties",
	  "totus",
	  "tracto",
	  "trado",
	  "traho",
	  "trans",
	  "tredecim",
	  "tremo",
	  "trepide",
	  "tres",
	  "tribuo",
	  "tricesimus",
	  "triduana",
	  "triginta",
	  "tripudio",
	  "tristis",
	  "triumphus",
	  "trucido",
	  "truculenter",
	  "tubineus",
	  "tui",
	  "tum",
	  "tumultus",
	  "tunc",
	  "turba",
	  "turbo",
	  "turpe",
	  "turpis",
	  "tutamen",
	  "tutis",
	  "tyrannus",
	  "uberrime",
	  "ubi",
	  "ulciscor",
	  "ullus",
	  "ulterius",
	  "ultio",
	  "ultra",
	  "umbra",
	  "umerus",
	  "umquam",
	  "una",
	  "unde",
	  "undique",
	  "universe",
	  "unus",
	  "urbanus",
	  "urbs",
	  "uredo",
	  "usitas",
	  "usque",
	  "ustilo",
	  "ustulo",
	  "usus",
	  "uter",
	  "uterque",
	  "utilis",
	  "utique",
	  "utor",
	  "utpote",
	  "utrimque",
	  "utroque",
	  "utrum",
	  "uxor",
	  "vaco",
	  "vacuus",
	  "vado",
	  "vae",
	  "valde",
	  "valens",
	  "valeo",
	  "valetudo",
	  "validus",
	  "vallum",
	  "vapulus",
	  "varietas",
	  "varius",
	  "vehemens",
	  "vel",
	  "velociter",
	  "velum",
	  "velut",
	  "venia",
	  "venio",
	  "ventito",
	  "ventosus",
	  "ventus",
	  "venustas",
	  "ver",
	  "verbera",
	  "verbum",
	  "vere",
	  "verecundia",
	  "vereor",
	  "vergo",
	  "veritas",
	  "vero",
	  "versus",
	  "verto",
	  "verumtamen",
	  "verus",
	  "vesco",
	  "vesica",
	  "vesper",
	  "vespillo",
	  "vester",
	  "vestigium",
	  "vestrum",
	  "vetus",
	  "via",
	  "vicinus",
	  "vicissitudo",
	  "victoria",
	  "victus",
	  "videlicet",
	  "video",
	  "viduata",
	  "viduo",
	  "vigilo",
	  "vigor",
	  "vilicus",
	  "vilis",
	  "vilitas",
	  "villa",
	  "vinco",
	  "vinculum",
	  "vindico",
	  "vinitor",
	  "vinum",
	  "vir",
	  "virga",
	  "virgo",
	  "viridis",
	  "viriliter",
	  "virtus",
	  "vis",
	  "viscus",
	  "vita",
	  "vitiosus",
	  "vitium",
	  "vito",
	  "vivo",
	  "vix",
	  "vobis",
	  "vociferor",
	  "voco",
	  "volaticus",
	  "volo",
	  "volubilis",
	  "voluntarius",
	  "volup",
	  "volutabrum",
	  "volva",
	  "vomer",
	  "vomica",
	  "vomito",
	  "vorago",
	  "vorax",
	  "voro",
	  "vos",
	  "votum",
	  "voveo",
	  "vox",
	  "vulariter",
	  "vulgaris",
	  "vulgivagus",
	  "vulgo",
	  "vulgus",
	  "vulnero",
	  "vulnus",
	  "vulpes",
	  "vulticulus",
	  "vultuosus",
	  "xiphias"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	"Abacalero",
	"Abacería",
	"Abacero",
	"Abacial",
	"Abaco",
	"Abacora",
	"Abacorar",
	"Abad",
	"Abada",
	"Abadejo",
	"Abadengo",
	"Abadernar",
	"Abadesa",
	"Abadí",
	"Abadía",
	"Abadiado",
	"Abadiato",
	"Abajadero",
	"Abajamiento",
	"Abajar",
	"Abajeño",
	"Abajera",
	"Abajo",
	"Abalada",
	"Abalanzar",
	"Abalar",
	"Abalaustrado",
	"Abaldonadamente",
	"Abaldonamiento",
	"Bastonada",
	"Bastonazo",
	"Bastoncillo",
	"Bastonear",
	"Bastonero",
	"Bástulo",
	"Basura",
	"Basural",
	"Basurear",
	"Basurero",
	"Bata",
	"Batacazo",
	"Batahola",
	"Batalán",
	"Batalla",
	"Batallador",
	"Batallar",
	"Batallaroso",
	"Batallola",
	"Batallón",
	"Batallona",
	"Batalloso",
	"Batán",
	"Batanar",
	"Batanear",
	"Batanero",
	"Batanga",
	"Bataola",
	"Batata",
	"Batatazo",
	"Batato",
	"Batavia",
	"Bátavo",
	"Batayola",
	"Batazo",
	"Bate",
	"Batea",
	"Bateador",
	"Bateaguas",
	"Cenagar",
	"Cenagoso",
	"Cenal",
	"Cenaoscuras",
	"Ceñar",
	"Cenata",
	"Cenca",
	"Cencapa",
	"Cencellada",
	"Cenceñada",
	"Cenceño",
	"Cencero",
	"Cencerra",
	"Cencerrada",
	"Cencerrado",
	"Cencerrear",
	"Cencerreo",
	"Cencerril",
	"Cencerrillas",
	"Cencerro",
	"Cencerrón",
	"Cencha",
	"Cencido",
	"Cencío",
	"Cencivera",
	"Cenco",
	"Cencuate",
	"Cendal",
	"Cendalí",
	"Céndea",
	"Cendolilla",
	"Cendra",
	"Cendrada",
	"Cendradilla",
	"Cendrado",
	"Cendrar",
	"Cendrazo",
	"Cenefa",
	"Cenegar",
	"Ceneque",
	"Cenero",
	"Cenestesia",
	"Desceñir",
	"Descensión",
	"Descenso",
	"Descentrado",
	"Descentralización",
	"Descentralizador",
	"Descentralizar",
	"Descentrar",
	"Descepar",
	"Descerar",
	"Descercado",
	"Descercador",
	"Descercar",
	"Descerco",
	"Descerebración",
	"Descerebrado",
	"Descerebrar",
	"Descerezar",
	"Descerrajado",
	"Descerrajadura",
	"Descerrajar",
	"Descerrar",
	"Descerrumarse",
	"Descervigamiento",
	"Descervigar",
	"Deschapar",
	"Descharchar",
	"Deschavetado",
	"Deschavetarse",
	"Deschuponar",
	"Descifrable",
	"Descifrador",
	"Desciframiento",
	"Descifrar",
	"Descifre",
	"Descimbramiento",
	"Descimbrar",
	"Engarbarse",
	"Engarberar",
	"Engarbullar",
	"Engarce",
	"Engarfiar",
	"Engargantadura",
	"Engargantar",
	"Engargante",
	"Engargolado",
	"Engargolar",
	"Engaritar",
	"Engarmarse",
	"Engarnio",
	"Engarrafador",
	"Engarrafar",
	"Engarrar",
	"Engarro",
	"Engarronar",
	"Engarrotar",
	"Engarzador",
	"Engarzadura",
	"Engarzar",
	"Engasgarse",
	"Engastador",
	"Engastadura",
	"Engastar",
	"Engaste",
	"Ficción",
	"Fice",
	"Ficha",
	"Fichaje",
	"Fichar",
	"Fichero",
	"Ficoideo",
	"Ficticio",
	"Fidalgo",
	"Fidecomiso",
	"Fidedigno",
	"Fideero",
	"Fideicomisario",
	"Fideicomiso",
	"Fideicomitente",
	"Fideísmo",
	"Fidelidad",
	"Fidelísimo",
	"Fideo",
	"Fido",
	"Fiducia",
	"Geminación",
	"Geminado",
	"Geminar",
	"Géminis",
	"Gémino",
	"Gemíparo",
	"Gemiquear",
	"Gemiqueo",
	"Gemir",
	"Gemología",
	"Gemológico",
	"Gemólogo",
	"Gemonias",
	"Gemoso",
	"Gemoterapia",
	"Gen",
	"Genciana",
	"Gencianáceo",
	"Gencianeo",
	"Gendarme",
	"Gendarmería",
	"Genealogía",
	"Genealógico",
	"Genealogista",
	"Genearca",
	"Geneático",
	"Generable",
	"Generación",
	"Generacional",
	"Generador",
	"General",
	"Generala",
	"Generalato",
	"Generalidad",
	"Generalísimo",
	"Incordio",
	"Incorporación",
	"Incorporal",
	"Incorporalmente",
	"Incorporar",
	"Incorporeidad",
	"Incorpóreo",
	"Incorporo",
	"Incorrección",
	"Incorrectamente",
	"Incorrecto",
	"Incorregibilidad",
	"Incorregible",
	"Incorregiblemente",
	"Incorrupción",
	"Incorruptamente",
	"Incorruptibilidad",
	"Incorruptible",
	"Incorrupto",
	"Incrasar",
	"Increado",
	"Incredibilidad",
	"Incrédulamente",
	"Incredulidad",
	"Incrédulo",
	"Increíble",
	"Increíblemente",
	"Incrementar",
	"Incremento",
	"Increpación",
	"Increpador",
	"Increpar",
	"Incriminación",
	"Incriminar",
	"Incristalizable",
	"Incruentamente",
	"Incruento",
	"Incrustación"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	"Aarón",
	"Abraham",
	"Adán",
	"Agustín",
	"Alan",
	"Alberto",
	"Alejandro",
	"Alexander",
	"Alexis",
	"Alfonso",
	"Alfredo",
	"Andrés",
	"Ángel Daniel",
	"Ángel Gabriel",
	"Antonio",
	"Armando",
	"Arturo",
	"Axel",
	"Benito",
	"Benjamín",
	"Bernardo",
	"Brandon",
	"Brayan",
	"Carlos",
	"César",
	"Claudio",
	"Clemente",
	"Cristian",
	"Cristobal",
	"Damián",
	"Daniel",
	"David",
	"Diego",
	"Eduardo",
	"Elías",
	"Emiliano",
	"Emilio",
	"Emilio",
	"Emmanuel",
	"Enrique",
	"Erick",
	"Ernesto",
	"Esteban",
	"Federico",
	"Felipe",
	"Fernando",
	"Fernando Javier",
	"Francisco",
	"Francisco Javier",
	"Gabriel",
	"Gael",
	"Gerardo",
	"Germán",
	"Gilberto",
	"Gonzalo",
	"Gregorio",
	"Guillermo",
	"Gustavo",
	"Hernán",
	"Homero",
	"Horacio",
	"Hugo",
	"Ignacio",
	"Iker",
	"Isaac",
	"Isaias",
	"Israel",
	"Ivan",
	"Jacobo",
	"Jaime",
	"Javier",
	"Jerónimo",
	"Jesús",
	"Joaquín",
	"Jorge",
	"Jorge Luis",
	"José",
	"José Antonio",
	"Jose Daniel",
	"José Eduardo",
	"José Emilio",
	"José Luis",
	"José María",
	"José Miguel",
	"Juan",
	"Juan Carlos",
	"Juan Manuel",
	"Juan Pablo",
	"Julio",
	"Julio César",
	"Kevin",
	"Leonardo",
	"Lorenzo",
	"Lucas",
	"Luis",
	"Luis Ángel",
	"Luis Fernando",
	"Luis Gabino",
	"Luis Miguel",
	"Manuel",
	"Marco Antonio",
	"Marcos",
	"Mariano",
	"Mario",
	"Martín",
	"Mateo",
	"Matías",
	"Mauricio",
	"Maximiliano",
	"Miguel",
	"Miguel Ángel",
	"Nicolás",
	"Octavio",
	"Óscar",
	"Pablo",
	"Patricio",
	"Pedro",
	"Rafael",
	"Ramiro",
	"Ramón",
	"Raúl",
	"Ricardo",
	"Roberto",
	"Rodrigo",
	"Rubén",
	"Salvador",
	"Samuel",
	"Sancho",
	"Santiago",
	"Saúl",
	"Sebastian",
	"Sergio",
	"Tadeo",
	"Teodoro",
	"Timoteo",
	"Tomás",
	"Uriel",
	"Vicente",
	"Víctor",
	"Victor Manuel",
	"Adriana",
	"Alejandra",
	"Alicia",
	"Amalia",
	"Ana",
	"Ana Luisa",
	"Ana María",
	"Andrea",
	"Ángela",
	"Anita",
	"Antonia",
	"Araceli",
	"Ariadna",
	"Barbara",
	"Beatriz",
	"Berta",
	"Blanca",
	"Caridad",
	"Carla",
	"Carlota",
	"Carmen",
	"Carolina",
	"Catalina",
	"Cecilia",
	"Clara",
	"Claudia",
	"Concepción",
	"Conchita",
	"Cristina",
	"Daniela",
	"Débora",
	"Diana",
	"Dolores",
	"Dorotea",
	"Elena",
	"Elisa",
	"Elizabeth",
	"Eloisa",
	"Elsa",
	"Elvira",
	"Emilia",
	"Esperanza",
	"Estela",
	"Ester",
	"Eva",
	"Florencia",
	"Francisca",
	"Gabriela",
	"Gloria",
	"Graciela",
	"Guadalupe",
	"Guillermina",
	"Inés",
	"Irene",
	"Isabel",
	"Isabela",
	"Josefina",
	"Juana",
	"Julia",
	"Laura",
	"Leonor",
	"Leticia",
	"Lilia",
	"Lola",
	"Lorena",
	"Lourdes",
	"Lucia",
	"Luisa",
	"Luz",
	"Magdalena",
	"Manuela",
	"Marcela",
	"Margarita",
	"María",
	"María Cristina",
	"María de Jesús",
	"María de los Ángeles",
	"María del Carmen",
	"María Elena",
	"María Eugenia",
	"María Guadalupe",
	"María José",
	"María Luisa",
	"María Soledad",
	"María Teresa",
	"Mariana",
	"Maricarmen",
	"Marilu",
	"Marisol",
	"Marta",
	"Mayte",
	"Mercedes",
	"Micaela",
	"Mónica",
	"Natalia",
	"Norma",
	"Olivia",
	"Patricia",
	"Pilar",
	"Ramona",
	"Raquel",
	"Rebeca",
	"Reina",
	"Rocio",
	"Rosa",
	"Rosa María",
	"Rosalia",
	"Rosario",
	"Sara",
	"Silvia",
	"Sofia",
	"Soledad",
	"Sonia",
	"Susana",
	"Teresa",
	"Verónica",
	"Victoria",
	"Virginia",
	"Xochitl",
	"Yolanda",
	"Abigail",
	"Abril",
	"Adela",
	"Alexa",
	"Alondra Romina",
	"Ana Sofía",
	"Ana Victoria",
	"Camila",
	"Carolina",
	"Daniela",
	"Dulce María",
	"Emily",
	"Esmeralda",
	"Estefanía",
	"Evelyn",
	"Fatima",
	"Ivanna",
	"Jazmin",
	"Jennifer",
	"Jimena",
	"Julieta",
	"Kimberly",
	"Liliana",
	"Lizbeth",
	"María Fernanda",
	"Melany",
	"Melissa",
	"Miranda",
	"Monserrat",
	"Naomi",
	"Natalia",
	"Nicole",
	"Paola",
	"Paulina",
	"Regina",
	"Renata",
	"Valentina",
	"Valeria",
	"Vanessa",
	"Ximena",
	"Ximena Guadalupe",
	"Yamileth",
	"Yaretzi",
	"Zoe"
	]
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(713);
	name.last_name = __webpack_require__(715);
	name.prefix = __webpack_require__(717);
	name.suffix = __webpack_require__(718);
	name.title = __webpack_require__(719);
	name.name = __webpack_require__(716);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abeyta",
	"Abrego",
	"Abreu",
	"Acevedo",
	"Acosta",
	"Acuña",
	"Adame",
	"Adorno",
	"Agosto",
	"Aguayo",
	"Águilar",
	"Aguilera",
	"Aguirre",
	"Alanis",
	"Alaniz",
	"Alarcón",
	"Alba",
	"Alcala",
	"Alcántar",
	"Alcaraz",
	"Alejandro",
	"Alemán",
	"Alfaro",
	"Alicea",
	"Almanza",
	"Almaraz",
	"Almonte",
	"Alonso",
	"Alonzo",
	"Altamirano",
	"Alva",
	"Alvarado",
	"Alvarez",
	"Amador",
	"Amaya",
	"Anaya",
	"Anguiano",
	"Angulo",
	"Aparicio",
	"Apodaca",
	"Aponte",
	"Aragón",
	"Aranda",
	"Araña",
	"Arce",
	"Archuleta",
	"Arellano",
	"Arenas",
	"Arevalo",
	"Arguello",
	"Arias",
	"Armas",
	"Armendáriz",
	"Armenta",
	"Armijo",
	"Arredondo",
	"Arreola",
	"Arriaga",
	"Arroyo",
	"Arteaga",
	"Atencio",
	"Ávalos",
	"Ávila",
	"Avilés",
	"Ayala",
	"Baca",
	"Badillo",
	"Báez",
	"Baeza",
	"Bahena",
	"Balderas",
	"Ballesteros",
	"Banda",
	"Bañuelos",
	"Barajas",
	"Barela",
	"Barragán",
	"Barraza",
	"Barrera",
	"Barreto",
	"Barrientos",
	"Barrios",
	"Batista",
	"Becerra",
	"Beltrán",
	"Benavides",
	"Benavídez",
	"Benítez",
	"Bermúdez",
	"Bernal",
	"Berríos",
	"Bétancourt",
	"Blanco",
	"Bonilla",
	"Borrego",
	"Botello",
	"Bravo",
	"Briones",
	"Briseño",
	"Brito",
	"Bueno",
	"Burgos",
	"Bustamante",
	"Bustos",
	"Caballero",
	"Cabán",
	"Cabrera",
	"Cadena",
	"Caldera",
	"Calderón",
	"Calvillo",
	"Camacho",
	"Camarillo",
	"Campos",
	"Canales",
	"Candelaria",
	"Cano",
	"Cantú",
	"Caraballo",
	"Carbajal",
	"Cardenas",
	"Cardona",
	"Carmona",
	"Carranza",
	"Carrasco",
	"Carrasquillo",
	"Carreón",
	"Carrera",
	"Carrero",
	"Carrillo",
	"Carrion",
	"Carvajal",
	"Casanova",
	"Casares",
	"Casárez",
	"Casas",
	"Casillas",
	"Castañeda",
	"Castellanos",
	"Castillo",
	"Castro",
	"Cavazos",
	"Cazares",
	"Ceballos",
	"Cedillo",
	"Ceja",
	"Centeno",
	"Cepeda",
	"Cerda",
	"Cervantes",
	"Cervántez",
	"Chacón",
	"Chapa",
	"Chavarría",
	"Chávez",
	"Cintrón",
	"Cisneros",
	"Collado",
	"Collazo",
	"Colón",
	"Colunga",
	"Concepción",
	"Contreras",
	"Cordero",
	"Córdova",
	"Cornejo",
	"Corona",
	"Coronado",
	"Corral",
	"Corrales",
	"Correa",
	"Cortés",
	"Cortez",
	"Cotto",
	"Covarrubias",
	"Crespo",
	"Cruz",
	"Cuellar",
	"Curiel",
	"Dávila",
	"de Anda",
	"de Jesús",
	"Delacrúz",
	"Delafuente",
	"Delagarza",
	"Delao",
	"Delapaz",
	"Delarosa",
	"Delatorre",
	"Deleón",
	"Delgadillo",
	"Delgado",
	"Delrío",
	"Delvalle",
	"Díaz",
	"Domínguez",
	"Domínquez",
	"Duarte",
	"Dueñas",
	"Duran",
	"Echevarría",
	"Elizondo",
	"Enríquez",
	"Escalante",
	"Escamilla",
	"Escobar",
	"Escobedo",
	"Esparza",
	"Espinal",
	"Espino",
	"Espinosa",
	"Espinoza",
	"Esquibel",
	"Esquivel",
	"Estévez",
	"Estrada",
	"Fajardo",
	"Farías",
	"Feliciano",
	"Fernández",
	"Ferrer",
	"Fierro",
	"Figueroa",
	"Flores",
	"Flórez",
	"Fonseca",
	"Franco",
	"Frías",
	"Fuentes",
	"Gaitán",
	"Galarza",
	"Galindo",
	"Gallardo",
	"Gallegos",
	"Galván",
	"Gálvez",
	"Gamboa",
	"Gamez",
	"Gaona",
	"Garay",
	"García",
	"Garibay",
	"Garica",
	"Garrido",
	"Garza",
	"Gastélum",
	"Gaytán",
	"Gil",
	"Girón",
	"Godínez",
	"Godoy",
	"Gollum",
	"Gómez",
	"Gonzales",
	"González",
	"Gracia",
	"Granado",
	"Granados",
	"Griego",
	"Grijalva",
	"Guajardo",
	"Guardado",
	"Guerra",
	"Guerrero",
	"Guevara",
	"Guillen",
	"Gurule",
	"Gutiérrez",
	"Guzmán",
	"Haro",
	"Henríquez",
	"Heredia",
	"Hernádez",
	"Hernandes",
	"Hernández",
	"Herrera",
	"Hidalgo",
	"Hinojosa",
	"Holguín",
	"Huerta",
	"Huixtlacatl",
	"Hurtado",
	"Ibarra",
	"Iglesias",
	"Irizarry",
	"Jaime",
	"Jaimes",
	"Jáquez",
	"Jaramillo",
	"Jasso",
	"Jiménez",
	"Jimínez",
	"Juárez",
	"Jurado",
	"Kadar rodriguez",
	"Kamal",
	"Kamat",
	"Kanaria",
	"Kanea",
	"Kanimal",
	"Kano",
	"Kanzaki",
	"Kaplan",
	"Kara",
	"Karam",
	"Karan",
	"Kardache soto",
	"Karem",
	"Karen",
	"Khalid",
	"Kindelan",
	"Koenig",
	"Korta",
	"Korta hernandez",
	"Kortajarena",
	"Kranz sans",
	"Krasnova",
	"Krauel natera",
	"Kuzmina",
	"Kyra",
	"Laboy",
	"Lara",
	"Laureano",
	"Leal",
	"Lebrón",
	"Ledesma",
	"Leiva",
	"Lemus",
	"León",
	"Lerma",
	"Leyva",
	"Limón",
	"Linares",
	"Lira",
	"Llamas",
	"Loera",
	"Lomeli",
	"Longoria",
	"López",
	"Lovato",
	"Loya",
	"Lozada",
	"Lozano",
	"Lucero",
	"Lucio",
	"Luevano",
	"Lugo",
	"Luna",
	"Macías",
	"Madera",
	"Madrid",
	"Madrigal",
	"Maestas",
	"Magaña",
	"Malave",
	"Maldonado",
	"Manzanares",
	"Mares",
	"Marín",
	"Márquez",
	"Marrero",
	"Marroquín",
	"Martínez",
	"Mascareñas",
	"Mata",
	"Mateo",
	"Matías",
	"Matos",
	"Maya",
	"Mayorga",
	"Medina",
	"Medrano",
	"Mejía",
	"Meléndez",
	"Melgar",
	"Mena",
	"Menchaca",
	"Méndez",
	"Mendoza",
	"Menéndez",
	"Meraz",
	"Mercado",
	"Merino",
	"Mesa",
	"Meza",
	"Miramontes",
	"Miranda",
	"Mireles",
	"Mojica",
	"Molina",
	"Mondragón",
	"Monroy",
	"Montalvo",
	"Montañez",
	"Montaño",
	"Montemayor",
	"Montenegro",
	"Montero",
	"Montes",
	"Montez",
	"Montoya",
	"Mora",
	"Morales",
	"Moreno",
	"Mota",
	"Moya",
	"Munguía",
	"Muñiz",
	"Muñoz",
	"Murillo",
	"Muro",
	"Nájera",
	"Naranjo",
	"Narváez",
	"Nava",
	"Navarrete",
	"Navarro",
	"Nazario",
	"Negrete",
	"Negrón",
	"Nevárez",
	"Nieto",
	"Nieves",
	"Niño",
	"Noriega",
	"Núñez",
	"Ñañez",
	"Ocampo",
	"Ocasio",
	"Ochoa",
	"Ojeda",
	"Olivares",
	"Olivárez",
	"Olivas",
	"Olivera",
	"Olivo",
	"Olmos",
	"Olvera",
	"Ontiveros",
	"Oquendo",
	"Ordóñez",
	"Orellana",
	"Ornelas",
	"Orosco",
	"Orozco",
	"Orta",
	"Ortega",
	"Ortiz",
	"Osorio",
	"Otero",
	"Ozuna",
	"Pabón",
	"Pacheco",
	"Padilla",
	"Padrón",
	"Páez",
	"Pagan",
	"Palacios",
	"Palomino",
	"Palomo",
	"Pantoja",
	"Paredes",
	"Parra",
	"Partida",
	"Patiño",
	"Paz",
	"Pedraza",
	"Pedroza",
	"Pelayo",
	"Peña",
	"Perales",
	"Peralta",
	"Perea",
	"Peres",
	"Pérez",
	"Pichardo",
	"Pineda",
	"Piña",
	"Pizarro",
	"Polanco",
	"Ponce",
	"Porras",
	"Portillo",
	"Posada",
	"Prado",
	"Preciado",
	"Prieto",
	"Puente",
	"Puga",
	"Pulido",
	"Quesada",
	"Quevedo",
	"Quezada",
	"Quinta",
	"Quintairos",
	"Quintana",
	"Quintanilla",
	"Quintero",
	"Quintero cruz",
	"Quintero de la cruz",
	"Quiñones",
	"Quiñónez",
	"Quiros",
	"Quiroz",
	"Rael",
	"Ramírez",
	"Ramón",
	"Ramos",
	"Rangel",
	"Rascón",
	"Raya",
	"Razo",
	"Regalado",
	"Rendón",
	"Rentería",
	"Reséndez",
	"Reyes",
	"Reyna",
	"Reynoso",
	"Rico",
	"Rincón",
	"Riojas",
	"Ríos",
	"Rivas",
	"Rivera",
	"Rivero",
	"Robledo",
	"Robles",
	"Rocha",
	"Rodarte",
	"Rodrígez",
	"Rodríguez",
	"Rodríquez",
	"Rojas",
	"Rojo",
	"Roldán",
	"Rolón",
	"Romero",
	"Romo",
	"Roque",
	"Rosado",
	"Rosales",
	"Rosario",
	"Rosas",
	"Roybal",
	"Rubio",
	"Ruelas",
	"Ruiz",
	"Saavedra",
	"Sáenz",
	"Saiz",
	"Salas",
	"Salazar",
	"Salcedo",
	"Salcido",
	"Saldaña",
	"Saldivar",
	"Salgado",
	"Salinas",
	"Samaniego",
	"Sanabria",
	"Sanches",
	"Sánchez",
	"Sandoval",
	"Santacruz",
	"Santana",
	"Santiago",
	"Santillán",
	"Sarabia",
	"Sauceda",
	"Saucedo",
	"Sedillo",
	"Segovia",
	"Segura",
	"Sepúlveda",
	"Serna",
	"Serrano",
	"Serrato",
	"Sevilla",
	"Sierra",
	"Sisneros",
	"Solano",
	"Solís",
	"Soliz",
	"Solorio",
	"Solorzano",
	"Soria",
	"Sosa",
	"Sotelo",
	"Soto",
	"Suárez",
	"Tafoya",
	"Tamayo",
	"Tamez",
	"Tapia",
	"Tejada",
	"Tejeda",
	"Téllez",
	"Tello",
	"Terán",
	"Terrazas",
	"Tijerina",
	"Tirado",
	"Toledo",
	"Toro",
	"Torres",
	"Tórrez",
	"Tovar",
	"Trejo",
	"Treviño",
	"Trujillo",
	"Ulibarri",
	"Ulloa",
	"Urbina",
	"Ureña",
	"Urías",
	"Uribe",
	"Urrutia",
	"Vaca",
	"Valadez",
	"Valdés",
	"Valdez",
	"Valdivia",
	"Valencia",
	"Valentín",
	"Valenzuela",
	"Valladares",
	"Valle",
	"Vallejo",
	"Valles",
	"Valverde",
	"Vanegas",
	"Varela",
	"Vargas",
	"Vásquez",
	"Vázquez",
	"Vega",
	"Vela",
	"Velasco",
	"Velásquez",
	"Velázquez",
	"Vélez",
	"Véliz",
	"Venegas",
	"Vera",
	"Verdugo",
	"Verduzco",
	"Vergara",
	"Viera",
	"Vigil",
	"Villa",
	"Villagómez",
	"Villalobos",
	"Villalpando",
	"Villanueva",
	"Villareal",
	"Villarreal",
	"Villaseñor",
	"Villegas",
	"Xacon",
	"Xairo Belmonte",
	"Xana",
	"Xenia",
	"Xiana",
	"Xicoy",
	"Yago",
	"Yami",
	"Yanes",
	"Yáñez",
	"Ybarra",
	"Yebra",
	"Yunta",
	"Zabaleta",
	"Zamarreno",
	"Zamarripa",
	"Zambrana",
	"Zambrano",
	"Zamora",
	"Zamudio",
	"Zapata",
	"Zaragoza",
	"Zarate",
	"Zavala",
	"Zayas",
	"Zelaya",
	"Zepeda",
	"Zúñiga"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} de #{last_name}",
	  "#{suffix} #{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Sr.",
	  "Sra.",
	  "Sta."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Jr.",
	  "Sr.",
	  "I",
	  "II",
	  "III",
	  "IV",
	  "V",
	  "MD",
	  "DDS",
	  "PhD",
	  "DVM",
	  "Ing.",
	  "Lic.",
	  "Dr.",
	  "Mtro."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) { module["exports"] = {
	  "descriptor": [
	    "Jefe",
	    "Senior",
	    "Directo",
	    "Corporativo",
	    "Dinánmico",
	    "Futuro",
	    "Producto",
	    "Nacional",
	    "Regional",
	    "Distrito",
	    "Central",
	    "Global",
	    "Cliente",
	    "Inversor",
	    "International",
	    "Heredado",
	    "Adelante",
	    "Interno",
	    "Humano",
	    "Gerente",
	    "SubGerente",
	    "Director"
	  ],
	  "level": [
	    "Soluciones",
	    "Programa",
	    "Marca",
	    "Seguridad",
	    "Investigación",
	    "Marketing",
	    "Normas",
	    "Implementación",
	    "Integración",
	    "Funcionalidad",
	    "Respuesta",
	    "Paradigma",
	    "Tácticas",
	    "Identidad",
	    "Mercados",
	    "Grupo",
	    "División",
	    "Aplicaciones",
	    "Optimización",
	    "Operaciones",
	    "Infraestructura",
	    "Intranet",
	    "Comunicaciones",
	    "Web",
	    "Calidad",
	    "Seguro",
	    "Mobilidad",
	    "Cuentas",
	    "Datos",
	    "Creativo",
	    "Configuración",
	    "Contabilidad",
	    "Interacciones",
	    "Factores",
	    "Usabilidad",
	    "Métricas",
	  ],
	  "job": [
	    "Supervisor",
	    "Asociado",
	    "Ejecutivo",
	    "Relacciones",
	    "Oficial",
	    "Gerente",
	    "Ingeniero",
	    "Especialista",
	    "Director",
	    "Coordinador",
	    "Administrador",
	    "Arquitecto",
	    "Analista",
	    "Diseñador",
	    "Planificador",
	    "Técnico",
	    "Funcionario",
	    "Desarrollador",
	    "Productor",
	    "Consultor",
	    "Asistente",
	    "Facilitador",
	    "Agente",
	    "Representante",
	    "Estratega",
	    "Scrum Master",
	    "Scrum Owner",
	    "Product Owner",
	    "Scrum Developer"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "5###-###-###",
	  "5##.###.###",
	  "5## ### ###",
	  "5########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(720);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "hormigas",
	   "murciélagos",
	   "osos",
	   "abejas",
	   "pájaros",
	   "búfalo",
	   "gatos",
	   "pollos",
	   "ganado",
	   "perros",
	   "delfines",
	   "patos",
	   "elefantes",
	   "peces",
	   "zorros",
	   "ranas",
	   "gansos",
	   "cabras",
	   "caballos",
	   "canguros",
	   "leones",
	   "monos",
	   "búhos",
	   "bueyes",
	   "pingüinos",
	   "pueblo",
	   "cerdos",
	   "conejos",
	   "ovejas",
	   "tigres",
	   "ballenas",
	   "lobos",
	   "cebras",
	   "almas en pena",
	   "cuervos",
	   "gatos negros",
	   "quimeras",
	   "fantasmas",
	   "conspiradores",
	   "dragones",
	   "enanos",
	   "duendes",
	   "encantadores",
	   "exorcistas",
	   "hijos",
	   "enemigos",
	   "gigantes",
	   "gnomos",
	   "duendes",
	   "gansos",
	   "grifos",
	   "licántropos",
	   "némesis",
	   "ogros",
	   "oráculos",
	   "profetas",
	   "hechiceros",
	   "arañas",
	   "espíritus",
	   "vampiros",
	   "brujos",
	   "zorras",
	   "hombres lobo",
	   "brujas",
	   "adoradores",
	   "zombies",
	   "druidas"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var team = {};
	module['exports'] = team;
	team.creature = __webpack_require__(722);
	team.name = __webpack_require__(724);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Address.state} #{creature}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var fa = {};
	module['exports'] = fa;
	fa.title = "Farsi";
	fa.name = __webpack_require__(727);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "آبان دخت",
	  "آبتین",
	  "آتوسا",
	  "آفر",
	  "آفره دخت",
	  "آذرنوش‌",
	  "آذین",
	  "آراه",
	  "آرزو",
	  "آرش",
	  "آرتین",
	  "آرتام",
	  "آرتمن",
	  "آرشام",
	  "آرمان",
	  "آرمین",
	  "آرمیتا",
	  "آریا فر",
	  "آریا",
	  "آریا مهر",
	  "آرین",
	  "آزاده",
	  "آزرم",
	  "آزرمدخت",
	  "آزیتا",
	  "آناهیتا",
	  "آونگ",
	  "آهو",
	  "آیدا",
	  "اتسز",
	  "اختر",
	  "ارد",
	  "ارد شیر",
	  "اردوان",
	  "ارژن",
	  "ارژنگ",
	  "ارسلان",
	  "ارغوان",
	  "ارمغان",
	  "ارنواز",
	  "اروانه",
	  "استر",
	  "اسفندیار",
	  "اشکان",
	  "اشکبوس",
	  "افسانه",
	  "افسون",
	  "افشین",
	  "امید",
	  "انوش (‌ آنوشا )",
	  "انوشروان",
	  "اورنگ",
	  "اوژن",
	  "اوستا",
	  "اهورا",
	  "ایاز",
	  "ایران",
	  "ایراندخت",
	  "ایرج",
	  "ایزدیار",
	  "بابک",
	  "باپوک",
	  "باربد",
	  "بارمان",
	  "بامداد",
	  "بامشاد",
	  "بانو",
	  "بختیار",
	  "برانوش",
	  "بردیا",
	  "برزو",
	  "برزویه",
	  "برزین",
	  "برمک",
	  "بزرگمهر",
	  "بنفشه",
	  "بوژان",
	  "بویان",
	  "بهار",
	  "بهارک",
	  "بهاره",
	  "بهتاش",
	  "بهداد",
	  "بهرام",
	  "بهدیس",
	  "بهرخ",
	  "بهرنگ",
	  "بهروز",
	  "بهزاد",
	  "بهشاد",
	  "بهمن",
	  "بهناز",
	  "بهنام",
	  "بهنود",
	  "بهنوش",
	  "بیتا",
	  "بیژن",
	  "پارسا",
	  "پاکان",
	  "پاکتن",
	  "پاکدخت",
	  "پانته آ",
	  "پدرام",
	  "پرتو",
	  "پرشنگ",
	  "پرتو",
	  "پرستو",
	  "پرویز",
	  "پردیس",
	  "پرهام",
	  "پژمان",
	  "پژوا",
	  "پرنیا",
	  "پشنگ",
	  "پروانه",
	  "پروین",
	  "پری",
	  "پریچهر",
	  "پریدخت",
	  "پریسا",
	  "پرناز",
	  "پریوش",
	  "پریا",
	  "پوپک",
	  "پوران",
	  "پوراندخت",
	  "پوریا",
	  "پولاد",
	  "پویا",
	  "پونه",
	  "پیام",
	  "پیروز",
	  "پیمان",
	  "تابان",
	  "تاباندخت",
	  "تاجی",
	  "تارا",
	  "تاویار",
	  "ترانه",
	  "تناز",
	  "توران",
	  "توراندخت",
	  "تورج",
	  "تورتک",
	  "توفان",
	  "توژال",
	  "تیر داد",
	  "تینا",
	  "تینو",
	  "جابان",
	  "جامین",
	  "جاوید",
	  "جریره",
	  "جمشید",
	  "جوان",
	  "جویا",
	  "جهان",
	  "جهانبخت",
	  "جهانبخش",
	  "جهاندار",
	  "جهانگیر",
	  "جهان بانو",
	  "جهاندخت",
	  "جهان ناز",
	  "جیران",
	  "چابک",
	  "چالاک",
	  "چاوش",
	  "چترا",
	  "چوبین",
	  "چهرزاد",
	  "خاوردخت",
	  "خداداد",
	  "خدایار",
	  "خرم",
	  "خرمدخت",
	  "خسرو",
	  "خشایار",
	  "خورشید",
	  "دادمهر",
	  "دارا",
	  "داراب",
	  "داریا",
	  "داریوش",
	  "دانوش",
	  "داور‌",
	  "دایان",
	  "دریا",
	  "دل آرا",
	  "دل آویز",
	  "دلارام",
	  "دل انگیز",
	  "دلبر",
	  "دلبند",
	  "دلربا",
	  "دلشاد",
	  "دلکش",
	  "دلناز",
	  "دلنواز",
	  "دورشاسب",
	  "دنیا",
	  "دیااکو",
	  "دیانوش",
	  "دیبا",
	  "دیبا دخت",
	  "رابو",
	  "رابین",
	  "رادبانو",
	  "رادمان",
	  "رازبان",
	  "راژانه",
	  "راسا",
	  "رامتین",
	  "رامش",
	  "رامشگر",
	  "رامونا",
	  "رامیار",
	  "رامیلا",
	  "رامین",
	  "راویار",
	  "رژینا",
	  "رخپاک",
	  "رخسار",
	  "رخشانه",
	  "رخشنده",
	  "رزمیار",
	  "رستم",
	  "رکسانا",
	  "روبینا",
	  "رودابه",
	  "روزبه",
	  "روشنک",
	  "روناک",
	  "رهام",
	  "رهی",
	  "ریبار",
	  "راسپینا",
	  "زادبخت",
	  "زاد به",
	  "زاد چهر",
	  "زاد فر",
	  "زال",
	  "زادماسب",
	  "زاوا",
	  "زردشت",
	  "زرنگار",
	  "زری",
	  "زرین",
	  "زرینه",
	  "زمانه",
	  "زونا",
	  "زیبا",
	  "زیبار",
	  "زیما",
	  "زینو",
	  "ژاله",
	  "ژالان",
	  "ژیار",
	  "ژینا",
	  "ژیوار",
	  "سارا",
	  "سارک",
	  "سارنگ",
	  "ساره",
	  "ساسان",
	  "ساغر",
	  "سام",
	  "سامان",
	  "سانا",
	  "ساناز",
	  "سانیار",
	  "ساویز",
	  "ساهی",
	  "ساینا",
	  "سایه",
	  "سپنتا",
	  "سپند",
	  "سپهر",
	  "سپهرداد",
	  "سپیدار",
	  "سپید بانو",
	  "سپیده",
	  "ستاره",
	  "ستی",
	  "سرافراز",
	  "سرور",
	  "سروش",
	  "سرور",
	  "سوبا",
	  "سوبار",
	  "سنبله",
	  "سودابه",
	  "سوری",
	  "سورن",
	  "سورنا",
	  "سوزان",
	  "سوزه",
	  "سوسن",
	  "سومار",
	  "سولان",
	  "سولماز",
	  "سوگند",
	  "سهراب",
	  "سهره",
	  "سهند",
	  "سیامک",
	  "سیاوش",
	  "سیبوبه ‌",
	  "سیما",
	  "سیمدخت",
	  "سینا",
	  "سیمین",
	  "سیمین دخت",
	  "شاپرک",
	  "شادی",
	  "شادمهر",
	  "شاران",
	  "شاهپور",
	  "شاهدخت",
	  "شاهرخ",
	  "شاهین",
	  "شاهیندخت",
	  "شایسته",
	  "شباهنگ",
	  "شب بو",
	  "شبدیز",
	  "شبنم",
	  "شراره",
	  "شرمین",
	  "شروین",
	  "شکوفه",
	  "شکفته",
	  "شمشاد",
	  "شمین",
	  "شوان",
	  "شمیلا",
	  "شورانگیز",
	  "شوری",
	  "شهاب",
	  "شهبار",
	  "شهباز",
	  "شهبال",
	  "شهپر",
	  "شهداد",
	  "شهرآرا",
	  "شهرام",
	  "شهربانو",
	  "شهرزاد",
	  "شهرناز",
	  "شهرنوش",
	  "شهره",
	  "شهریار",
	  "شهرزاد",
	  "شهلا",
	  "شهنواز",
	  "شهین",
	  "شیبا",
	  "شیدا",
	  "شیده",
	  "شیردل",
	  "شیرزاد",
	  "شیرنگ",
	  "شیرو",
	  "شیرین دخت",
	  "شیما",
	  "شینا",
	  "شیرین",
	  "شیوا",
	  "طوس",
	  "طوطی",
	  "طهماسب",
	  "طهمورث",
	  "غوغا",
	  "غنچه",
	  "فتانه",
	  "فدا",
	  "فراز",
	  "فرامرز",
	  "فرانک",
	  "فراهان",
	  "فربد",
	  "فربغ",
	  "فرجاد",
	  "فرخ",
	  "فرخ پی",
	  "فرخ داد",
	  "فرخ رو",
	  "فرخ زاد",
	  "فرخ لقا",
	  "فرخ مهر",
	  "فرداد",
	  "فردیس",
	  "فرین",
	  "فرزاد",
	  "فرزام",
	  "فرزان",
	  "فرزانه",
	  "فرزین",
	  "فرشاد",
	  "فرشته",
	  "فرشید",
	  "فرمان",
	  "فرناز",
	  "فرنگیس",
	  "فرنود",
	  "فرنوش",
	  "فرنیا",
	  "فروتن",
	  "فرود",
	  "فروز",
	  "فروزان",
	  "فروزش",
	  "فروزنده",
	  "فروغ",
	  "فرهاد",
	  "فرهنگ",
	  "فرهود",
	  "فربار",
	  "فریبا",
	  "فرید",
	  "فریدخت",
	  "فریدون",
	  "فریمان",
	  "فریناز",
	  "فرینوش",
	  "فریوش",
	  "فیروز",
	  "فیروزه",
	  "قابوس",
	  "قباد",
	  "قدسی",
	  "کابان",
	  "کابوک",
	  "کارا",
	  "کارو",
	  "کاراکو",
	  "کامبخت",
	  "کامبخش",
	  "کامبیز",
	  "کامجو",
	  "کامدین",
	  "کامران",
	  "کامراوا",
	  "کامک",
	  "کامنوش",
	  "کامیار",
	  "کانیار",
	  "کاووس",
	  "کاوه",
	  "کتایون",
	  "کرشمه",
	  "کسری",
	  "کلاله",
	  "کمبوجیه",
	  "کوشا",
	  "کهبد",
	  "کهرام",
	  "کهزاد",
	  "کیارش",
	  "کیان",
	  "کیانا",
	  "کیانچهر",
	  "کیاندخت",
	  "کیانوش",
	  "کیاوش",
	  "کیخسرو",
	  "کیقباد",
	  "کیکاووس",
	  "کیوان",
	  "کیوان دخت",
	  "کیومرث",
	  "کیهان",
	  "کیاندخت",
	  "کیهانه",
	  "گرد آفرید",
	  "گردان",
	  "گرشا",
	  "گرشاسب",
	  "گرشین",
	  "گرگین",
	  "گزل",
	  "گشتاسب",
	  "گشسب",
	  "گشسب بانو",
	  "گل",
	  "گل آذین",
	  "گل آرا‌",
	  "گلاره",
	  "گل افروز",
	  "گلاله",
	  "گل اندام",
	  "گلاویز",
	  "گلباد",
	  "گلبار",
	  "گلبام",
	  "گلبان",
	  "گلبانو",
	  "گلبرگ",
	  "گلبو",
	  "گلبهار",
	  "گلبیز",
	  "گلپاره",
	  "گلپر",
	  "گلپری",
	  "گلپوش",
	  "گل پونه",
	  "گلچین",
	  "گلدخت",
	  "گلدیس",
	  "گلربا",
	  "گلرخ",
	  "گلرنگ",
	  "گلرو",
	  "گلشن",
	  "گلریز",
	  "گلزاد",
	  "گلزار",
	  "گلسا",
	  "گلشید",
	  "گلنار",
	  "گلناز",
	  "گلنسا",
	  "گلنواز",
	  "گلنوش",
	  "گلی",
	  "گودرز",
	  "گوماتو",
	  "گهر چهر",
	  "گوهر ناز",
	  "گیتی",
	  "گیسو",
	  "گیلدا",
	  "گیو",
	  "لادن",
	  "لاله",
	  "لاله رخ",
	  "لاله دخت",
	  "لبخند",
	  "لقاء",
	  "لومانا",
	  "لهراسب",
	  "مارال",
	  "ماری",
	  "مازیار",
	  "ماکان",
	  "مامک",
	  "مانا",
	  "ماندانا",
	  "مانوش",
	  "مانی",
	  "مانیا",
	  "ماهان",
	  "ماهاندخت",
	  "ماه برزین",
	  "ماه جهان",
	  "ماهچهر",
	  "ماهدخت",
	  "ماهور",
	  "ماهرخ",
	  "ماهزاد",
	  "مردآویز",
	  "مرداس",
	  "مرزبان",
	  "مرمر",
	  "مزدک",
	  "مژده",
	  "مژگان",
	  "مستان",
	  "مستانه",
	  "مشکاندخت",
	  "مشکناز",
	  "مشکین دخت",
	  "منیژه",
	  "منوچهر",
	  "مهبانو",
	  "مهبد",
	  "مه داد",
	  "مهتاب",
	  "مهدیس",
	  "مه جبین",
	  "مه دخت",
	  "مهر آذر",
	  "مهر آرا",
	  "مهر آسا",
	  "مهر آفاق",
	  "مهر افرین",
	  "مهرآب",
	  "مهرداد",
	  "مهر افزون",
	  "مهرام",
	  "مهران",
	  "مهراندخت",
	  "مهراندیش",
	  "مهرانفر",
	  "مهرانگیز",
	  "مهرداد",
	  "مهر دخت",
	  "مهرزاده ‌",
	  "مهرناز",
	  "مهرنوش",
	  "مهرنکار",
	  "مهرنیا",
	  "مهروز",
	  "مهری",
	  "مهریار",
	  "مهسا",
	  "مهستی",
	  "مه سیما",
	  "مهشاد",
	  "مهشید",
	  "مهنام",
	  "مهناز",
	  "مهنوش",
	  "مهوش",
	  "مهیار",
	  "مهین",
	  "مهین دخت",
	  "میترا",
	  "میخک",
	  "مینا",
	  "مینا دخت",
	  "مینو",
	  "مینودخت",
	  "مینو فر",
	  "نادر",
	  "ناز آفرین",
	  "نازبانو",
	  "نازپرور",
	  "نازچهر",
	  "نازفر",
	  "نازلی",
	  "نازی",
	  "نازیدخت",
	  "نامور",
	  "ناهید",
	  "ندا",
	  "نرسی",
	  "نرگس",
	  "نرمک",
	  "نرمین",
	  "نریمان",
	  "نسترن",
	  "نسرین",
	  "نسرین دخت",
	  "نسرین نوش",
	  "نکیسا",
	  "نگار",
	  "نگاره",
	  "نگارین",
	  "نگین",
	  "نوا",
	  "نوش",
	  "نوش آذر",
	  "نوش آور",
	  "نوشا",
	  "نوش آفرین",
	  "نوشدخت",
	  "نوشروان",
	  "نوشفر",
	  "نوشناز",
	  "نوشین",
	  "نوید",
	  "نوین",
	  "نوین دخت",
	  "نیش ا",
	  "نیک بین",
	  "نیک پی",
	  "نیک چهر",
	  "نیک خواه",
	  "نیکداد",
	  "نیکدخت",
	  "نیکدل",
	  "نیکزاد",
	  "نیلوفر",
	  "نیما",
	  "وامق",
	  "ورجاوند",
	  "وریا",
	  "وشمگیر",
	  "وهرز",
	  "وهسودان",
	  "ویدا",
	  "ویس",
	  "ویشتاسب",
	  "ویگن",
	  "هژیر",
	  "هخامنش",
	  "هربد( هیربد )",
	  "هرمز",
	  "همایون",
	  "هما",
	  "همادخت",
	  "همدم",
	  "همراز",
	  "همراه",
	  "هنگامه",
	  "هوتن",
	  "هور",
	  "هورتاش",
	  "هورچهر",
	  "هورداد",
	  "هوردخت",
	  "هورزاد",
	  "هورمند",
	  "هوروش",
	  "هوشنگ",
	  "هوشیار",
	  "هومان",
	  "هومن",
	  "هونام",
	  "هویدا",
	  "هیتاسب",
	  "هیرمند",
	  "هیما",
	  "هیوا",
	  "یادگار",
	  "یاسمن ( یاسمین )",
	  "یاشار",
	  "یاور",
	  "یزدان",
	  "یگانه",
	  "یوشیتا"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(726);
	name.last_name = __webpack_require__(728);
	name.prefix = __webpack_require__(729);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "عارف",
	  "عاشوری",
	  "عالی",
	  "عبادی",
	  "عبدالکریمی",
	  "عبدالملکی",
	  "عراقی",
	  "عزیزی",
	  "عصار",
	  "عقیلی",
	  "علم",
	  "علم‌الهدی",
	  "علی عسگری",
	  "علی‌آبادی",
	  "علیا",
	  "علی‌پور",
	  "علی‌زمانی",
	  "عنایت",
	  "غضنفری",
	  "غنی",
	  "فارسی",
	  "فاطمی",
	  "فانی",
	  "فتاحی",
	  "فرامرزی",
	  "فرج",
	  "فرشیدورد",
	  "فرمانفرمائیان",
	  "فروتن",
	  "فرهنگ",
	  "فریاد",
	  "فنایی",
	  "فنی‌زاده",
	  "فولادوند",
	  "فهمیده",
	  "قاضی",
	  "قانعی",
	  "قانونی",
	  "قمیشی",
	  "قنبری",
	  "قهرمان",
	  "قهرمانی",
	  "قهرمانیان",
	  "قهستانی",
	  "کاشی",
	  "کاکاوند",
	  "کامکار",
	  "کاملی",
	  "کاویانی",
	  "کدیور",
	  "کردبچه",
	  "کرمانی",
	  "کریمی",
	  "کلباسی",
	  "کمالی",
	  "کوشکی",
	  "کهنمویی",
	  "کیان",
	  "کیانی (نام خانوادگی)",
	  "کیمیایی",
	  "گل محمدی",
	  "گلپایگانی",
	  "گنجی",
	  "لاجوردی",
	  "لاچینی",
	  "لاهوتی",
	  "لنکرانی",
	  "لوکس",
	  "مجاهد",
	  "مجتبایی",
	  "مجتبوی",
	  "مجتهد شبستری",
	  "مجتهدی",
	  "مجرد",
	  "محجوب",
	  "محجوبی",
	  "محدثی",
	  "محمدرضایی",
	  "محمدی",
	  "مددی",
	  "مرادخانی",
	  "مرتضوی",
	  "مستوفی",
	  "مشا",
	  "مصاحب",
	  "مصباح",
	  "مصباح‌زاده",
	  "مطهری",
	  "مظفر",
	  "معارف",
	  "معروف",
	  "معین",
	  "مفتاح",
	  "مفتح",
	  "مقدم",
	  "ملایری",
	  "ملک",
	  "ملکیان",
	  "منوچهری",
	  "موحد",
	  "موسوی",
	  "موسویان",
	  "مهاجرانی",
	  "مهدی‌پور",
	  "میرباقری",
	  "میردامادی",
	  "میرزاده",
	  "میرسپاسی",
	  "میزبانی",
	  "ناظری",
	  "نامور",
	  "نجفی",
	  "ندوشن",
	  "نراقی",
	  "نعمت‌زاده",
	  "نقدی",
	  "نقیب‌زاده",
	  "نواب",
	  "نوبخت",
	  "نوبختی",
	  "نهاوندی",
	  "نیشابوری",
	  "نیلوفری",
	  "واثقی",
	  "واعظ",
	  "واعظ‌زاده",
	  "واعظی",
	  "وکیلی",
	  "هاشمی",
	  "هاشمی رفسنجانی",
	  "هاشمیان",
	  "هامون",
	  "هدایت",
	  "هراتی",
	  "هروی",
	  "همایون",
	  "همت",
	  "همدانی",
	  "هوشیار",
	  "هومن",
	  "یاحقی",
	  "یادگار",
	  "یثربی",
	  "یلدا"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "آقای",
	  "خانم",
	  "دکتر"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####",
	  "###",
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Paris",
	  "Marseille",
	  "Lyon",
	  "Toulouse",
	  "Nice",
	  "Nantes",
	  "Strasbourg",
	  "Montpellier",
	  "Bordeaux",
	  "Lille13",
	  "Rennes",
	  "Reims",
	  "Le Havre",
	  "Saint-Étienne",
	  "Toulon",
	  "Grenoble",
	  "Dijon",
	  "Angers",
	  "Saint-Denis",
	  "Villeurbanne",
	  "Le Mans",
	  "Aix-en-Provence",
	  "Brest",
	  "Nîmes",
	  "Limoges",
	  "Clermont-Ferrand",
	  "Tours",
	  "Amiens",
	  "Metz",
	  "Perpignan",
	  "Besançon",
	  "Orléans",
	  "Boulogne-Billancourt",
	  "Mulhouse",
	  "Rouen",
	  "Caen",
	  "Nancy",
	  "Saint-Denis",
	  "Saint-Paul",
	  "Montreuil",
	  "Argenteuil",
	  "Roubaix",
	  "Dunkerque14",
	  "Tourcoing",
	  "Nanterre",
	  "Avignon",
	  "Créteil",
	  "Poitiers",
	  "Fort-de-France",
	  "Courbevoie",
	  "Versailles",
	  "Vitry-sur-Seine",
	  "Colombes",
	  "Pau",
	  "Aulnay-sous-Bois",
	  "Asnières-sur-Seine",
	  "Rueil-Malmaison",
	  "Saint-Pierre",
	  "Antibes",
	  "Saint-Maur-des-Fossés",
	  "Champigny-sur-Marne",
	  "La Rochelle",
	  "Aubervilliers",
	  "Calais",
	  "Cannes",
	  "Le Tampon",
	  "Béziers",
	  "Colmar",
	  "Bourges",
	  "Drancy",
	  "Mérignac",
	  "Saint-Nazaire",
	  "Valence",
	  "Ajaccio",
	  "Issy-les-Moulineaux",
	  "Villeneuve-d'Ascq",
	  "Levallois-Perret",
	  "Noisy-le-Grand",
	  "Quimper",
	  "La Seyne-sur-Mer",
	  "Antony",
	  "Troyes",
	  "Neuilly-sur-Seine",
	  "Sarcelles",
	  "Les Abymes",
	  "Vénissieux",
	  "Clichy",
	  "Lorient",
	  "Pessac",
	  "Ivry-sur-Seine",
	  "Cergy",
	  "Cayenne",
	  "Niort",
	  "Chambéry",
	  "Montauban",
	  "Saint-Quentin",
	  "Villejuif",
	  "Hyères",
	  "Beauvais",
	  "Cholet"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "France"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.building_number = __webpack_require__(730);
	address.street_prefix = __webpack_require__(740);
	address.secondary_address = __webpack_require__(736);
	address.postcode = __webpack_require__(735);
	address.state = __webpack_require__(737);
	address.city_name = __webpack_require__(732);
	address.city = __webpack_require__(731);
	address.street_suffix = __webpack_require__(741);
	address.street_name = __webpack_require__(739);
	address.street_address = __webpack_require__(738);
	address.default_country = __webpack_require__(733);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apt. ###",
	  "# étage"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alsace",
	  "Aquitaine",
	  "Auvergne",
	  "Basse-Normandie",
	  "Bourgogne",
	  "Bretagne",
	  "Centre",
	  "Champagne-Ardenne",
	  "Corse",
	  "Franche-Comté",
	  "Haute-Normandie",
	  "Île-de-France",
	  "Languedoc-Roussillon",
	  "Limousin",
	  "Lorraine",
	  "Midi-Pyrénées",
	  "Nord-Pas-de-Calais",
	  "Pays de la Loire",
	  "Picardie",
	  "Poitou-Charentes",
	  "Provence-Alpes-Côte d'Azur",
	  "Rhône-Alpes"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{building_number} #{street_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_prefix} #{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Allée, Voie",
	  "Rue",
	  "Avenue",
	  "Boulevard",
	  "Quai",
	  "Passage",
	  "Impasse",
	  "Place"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "de l'Abbaye",
	  "Adolphe Mille",
	  "d'Alésia",
	  "d'Argenteuil",
	  "d'Assas",
	  "du Bac",
	  "de Paris",
	  "La Boétie",
	  "Bonaparte",
	  "de la Bûcherie",
	  "de Caumartin",
	  "Charlemagne",
	  "du Chat-qui-Pêche",
	  "de la Chaussée-d'Antin",
	  "du Dahomey",
	  "Dauphine",
	  "Delesseux",
	  "du Faubourg Saint-Honoré",
	  "du Faubourg-Saint-Denis",
	  "de la Ferronnerie",
	  "des Francs-Bourgeois",
	  "des Grands Augustins",
	  "de la Harpe",
	  "du Havre",
	  "de la Huchette",
	  "Joubert",
	  "Laffitte",
	  "Lepic",
	  "des Lombards",
	  "Marcadet",
	  "Molière",
	  "Monsieur-le-Prince",
	  "de Montmorency",
	  "Montorgueil",
	  "Mouffetard",
	  "de Nesle",
	  "Oberkampf",
	  "de l'Odéon",
	  "d'Orsel",
	  "de la Paix",
	  "des Panoramas",
	  "Pastourelle",
	  "Pierre Charron",
	  "de la Pompe",
	  "de Presbourg",
	  "de Provence",
	  "de Richelieu",
	  "de Rivoli",
	  "des Rosiers",
	  "Royale",
	  "d'Abbeville",
	  "Saint-Honoré",
	  "Saint-Bernard",
	  "Saint-Denis",
	  "Saint-Dominique",
	  "Saint-Jacques",
	  "Saint-Séverin",
	  "des Saussaies",
	  "de Seine",
	  "de Solférino",
	  "Du Sommerard",
	  "de Tilsitt",
	  "Vaneau",
	  "de Vaugirard",
	  "de la Victoire",
	  "Zadkine"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adaptive",
	  "Advanced",
	  "Ameliorated",
	  "Assimilated",
	  "Automated",
	  "Balanced",
	  "Business-focused",
	  "Centralized",
	  "Cloned",
	  "Compatible",
	  "Configurable",
	  "Cross-group",
	  "Cross-platform",
	  "Customer-focused",
	  "Customizable",
	  "Decentralized",
	  "De-engineered",
	  "Devolved",
	  "Digitized",
	  "Distributed",
	  "Diverse",
	  "Down-sized",
	  "Enhanced",
	  "Enterprise-wide",
	  "Ergonomic",
	  "Exclusive",
	  "Expanded",
	  "Extended",
	  "Face to face",
	  "Focused",
	  "Front-line",
	  "Fully-configurable",
	  "Function-based",
	  "Fundamental",
	  "Future-proofed",
	  "Grass-roots",
	  "Horizontal",
	  "Implemented",
	  "Innovative",
	  "Integrated",
	  "Intuitive",
	  "Inverse",
	  "Managed",
	  "Mandatory",
	  "Monitored",
	  "Multi-channelled",
	  "Multi-lateral",
	  "Multi-layered",
	  "Multi-tiered",
	  "Networked",
	  "Object-based",
	  "Open-architected",
	  "Open-source",
	  "Operative",
	  "Optimized",
	  "Optional",
	  "Organic",
	  "Organized",
	  "Persevering",
	  "Persistent",
	  "Phased",
	  "Polarised",
	  "Pre-emptive",
	  "Proactive",
	  "Profit-focused",
	  "Profound",
	  "Programmable",
	  "Progressive",
	  "Public-key",
	  "Quality-focused",
	  "Reactive",
	  "Realigned",
	  "Re-contextualized",
	  "Re-engineered",
	  "Reduced",
	  "Reverse-engineered",
	  "Right-sized",
	  "Robust",
	  "Seamless",
	  "Secured",
	  "Self-enabling",
	  "Sharable",
	  "Stand-alone",
	  "Streamlined",
	  "Switchable",
	  "Synchronised",
	  "Synergistic",
	  "Synergized",
	  "Team-oriented",
	  "Total",
	  "Triple-buffered",
	  "Universal",
	  "Up-sized",
	  "Upgradable",
	  "User-centric",
	  "User-friendly",
	  "Versatile",
	  "Virtual",
	  "Visionary",
	  "Vision-oriented"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "clicks-and-mortar",
	  "value-added",
	  "vertical",
	  "proactive",
	  "robust",
	  "revolutionary",
	  "scalable",
	  "leading-edge",
	  "innovative",
	  "intuitive",
	  "strategic",
	  "e-business",
	  "mission-critical",
	  "sticky",
	  "one-to-one",
	  "24/7",
	  "end-to-end",
	  "global",
	  "B2B",
	  "B2C",
	  "granular",
	  "frictionless",
	  "virtual",
	  "viral",
	  "dynamic",
	  "24/365",
	  "best-of-breed",
	  "killer",
	  "magnetic",
	  "bleeding-edge",
	  "web-enabled",
	  "interactive",
	  "dot-com",
	  "sexy",
	  "back-end",
	  "real-time",
	  "efficient",
	  "front-end",
	  "distributed",
	  "seamless",
	  "extensible",
	  "turn-key",
	  "world-class",
	  "open-source",
	  "cross-platform",
	  "cross-media",
	  "synergistic",
	  "bricks-and-clicks",
	  "out-of-the-box",
	  "enterprise",
	  "integrated",
	  "impactful",
	  "wireless",
	  "transparent",
	  "next-generation",
	  "cutting-edge",
	  "user-centric",
	  "visionary",
	  "customized",
	  "ubiquitous",
	  "plug-and-play",
	  "collaborative",
	  "compelling",
	  "holistic",
	  "rich"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "synergies",
	  "web-readiness",
	  "paradigms",
	  "markets",
	  "partnerships",
	  "infrastructures",
	  "platforms",
	  "initiatives",
	  "channels",
	  "eyeballs",
	  "communities",
	  "ROI",
	  "solutions",
	  "e-tailers",
	  "e-services",
	  "action-items",
	  "portals",
	  "niches",
	  "technologies",
	  "content",
	  "vortals",
	  "supply-chains",
	  "convergence",
	  "relationships",
	  "architectures",
	  "interfaces",
	  "e-markets",
	  "e-commerce",
	  "systems",
	  "bandwidth",
	  "infomediaries",
	  "models",
	  "mindshare",
	  "deliverables",
	  "users",
	  "schemas",
	  "networks",
	  "applications",
	  "metrics",
	  "e-business",
	  "functionalities",
	  "experiences",
	  "web services",
	  "methodologies"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "implement",
	  "utilize",
	  "integrate",
	  "streamline",
	  "optimize",
	  "evolve",
	  "transform",
	  "embrace",
	  "enable",
	  "orchestrate",
	  "leverage",
	  "reinvent",
	  "aggregate",
	  "architect",
	  "enhance",
	  "incentivize",
	  "morph",
	  "empower",
	  "envisioneer",
	  "monetize",
	  "harness",
	  "facilitate",
	  "seize",
	  "disintermediate",
	  "synergize",
	  "strategize",
	  "deploy",
	  "brand",
	  "grow",
	  "target",
	  "syndicate",
	  "synthesize",
	  "deliver",
	  "mesh",
	  "incubate",
	  "engage",
	  "maximize",
	  "benchmark",
	  "expedite",
	  "reintermediate",
	  "whiteboard",
	  "visualize",
	  "repurpose",
	  "innovate",
	  "scale",
	  "unleash",
	  "drive",
	  "extend",
	  "engineer",
	  "revolutionize",
	  "generate",
	  "exploit",
	  "transition",
	  "e-enable",
	  "iterate",
	  "cultivate",
	  "matrix",
	  "productize",
	  "redefine",
	  "recontextualize"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 hour",
	  "24/7",
	  "3rd generation",
	  "4th generation",
	  "5th generation",
	  "6th generation",
	  "actuating",
	  "analyzing",
	  "asymmetric",
	  "asynchronous",
	  "attitude-oriented",
	  "background",
	  "bandwidth-monitored",
	  "bi-directional",
	  "bifurcated",
	  "bottom-line",
	  "clear-thinking",
	  "client-driven",
	  "client-server",
	  "coherent",
	  "cohesive",
	  "composite",
	  "context-sensitive",
	  "contextually-based",
	  "content-based",
	  "dedicated",
	  "demand-driven",
	  "didactic",
	  "directional",
	  "discrete",
	  "disintermediate",
	  "dynamic",
	  "eco-centric",
	  "empowering",
	  "encompassing",
	  "even-keeled",
	  "executive",
	  "explicit",
	  "exuding",
	  "fault-tolerant",
	  "foreground",
	  "fresh-thinking",
	  "full-range",
	  "global",
	  "grid-enabled",
	  "heuristic",
	  "high-level",
	  "holistic",
	  "homogeneous",
	  "human-resource",
	  "hybrid",
	  "impactful",
	  "incremental",
	  "intangible",
	  "interactive",
	  "intermediate",
	  "leading edge",
	  "local",
	  "logistical",
	  "maximized",
	  "methodical",
	  "mission-critical",
	  "mobile",
	  "modular",
	  "motivating",
	  "multimedia",
	  "multi-state",
	  "multi-tasking",
	  "national",
	  "needs-based",
	  "neutral",
	  "next generation",
	  "non-volatile",
	  "object-oriented",
	  "optimal",
	  "optimizing",
	  "radical",
	  "real-time",
	  "reciprocal",
	  "regional",
	  "responsive",
	  "scalable",
	  "secondary",
	  "solution-oriented",
	  "stable",
	  "static",
	  "systematic",
	  "systemic",
	  "system-worthy",
	  "tangible",
	  "tertiary",
	  "transitional",
	  "uniform",
	  "upward-trending",
	  "user-facing",
	  "value-added",
	  "web-enabled",
	  "well-modulated",
	  "zero administration",
	  "zero defect",
	  "zero tolerance"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(750);
	company.adjective = __webpack_require__(742);
	company.descriptor = __webpack_require__(746);
	company.noun = __webpack_require__(749);
	company.bs_verb = __webpack_require__(745);
	company.bs_adjective = __webpack_require__(743);
	company.bs_noun = __webpack_require__(744);
	company.name = __webpack_require__(748);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name} et #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ability",
	  "access",
	  "adapter",
	  "algorithm",
	  "alliance",
	  "analyzer",
	  "application",
	  "approach",
	  "architecture",
	  "archive",
	  "artificial intelligence",
	  "array",
	  "attitude",
	  "benchmark",
	  "budgetary management",
	  "capability",
	  "capacity",
	  "challenge",
	  "circuit",
	  "collaboration",
	  "complexity",
	  "concept",
	  "conglomeration",
	  "contingency",
	  "core",
	  "customer loyalty",
	  "database",
	  "data-warehouse",
	  "definition",
	  "emulation",
	  "encoding",
	  "encryption",
	  "extranet",
	  "firmware",
	  "flexibility",
	  "focus group",
	  "forecast",
	  "frame",
	  "framework",
	  "function",
	  "functionalities",
	  "Graphic Interface",
	  "groupware",
	  "Graphical User Interface",
	  "hardware",
	  "help-desk",
	  "hierarchy",
	  "hub",
	  "implementation",
	  "info-mediaries",
	  "infrastructure",
	  "initiative",
	  "installation",
	  "instruction set",
	  "interface",
	  "internet solution",
	  "intranet",
	  "knowledge user",
	  "knowledge base",
	  "local area network",
	  "leverage",
	  "matrices",
	  "matrix",
	  "methodology",
	  "middleware",
	  "migration",
	  "model",
	  "moderator",
	  "monitoring",
	  "moratorium",
	  "neural-net",
	  "open architecture",
	  "open system",
	  "orchestration",
	  "paradigm",
	  "parallelism",
	  "policy",
	  "portal",
	  "pricing structure",
	  "process improvement",
	  "product",
	  "productivity",
	  "project",
	  "projection",
	  "protocol",
	  "secured line",
	  "service-desk",
	  "software",
	  "solution",
	  "standardization",
	  "strategy",
	  "structure",
	  "success",
	  "superstructure",
	  "support",
	  "synergy",
	  "system engine",
	  "task-force",
	  "throughput",
	  "time-frame",
	  "toolset",
	  "utilisation",
	  "website",
	  "workforce"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "SARL",
	  "SA",
	  "EURL",
	  "SAS",
	  "SEM",
	  "SCOP",
	  "GIE",
	  "EI"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var fr = {};
	module['exports'] = fr;
	fr.title = "French";
	fr.address = __webpack_require__(734);
	fr.company = __webpack_require__(747);
	fr.internet = __webpack_require__(754);
	fr.lorem = __webpack_require__(755);
	fr.name = __webpack_require__(759);
	fr.phone_number = __webpack_require__(765);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "fr",
	  "eu",
	  "info",
	  "name",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.fr",
	  "hotmail.fr"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(753);
	internet.domain_suffix = __webpack_require__(752);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(757);
	lorem.supplemental = __webpack_require__(756);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "abbas",
	  "abduco",
	  "abeo",
	  "abscido",
	  "absconditus",
	  "absens",
	  "absorbeo",
	  "absque",
	  "abstergo",
	  "absum",
	  "abundans",
	  "abutor",
	  "accedo",
	  "accendo",
	  "acceptus",
	  "accipio",
	  "accommodo",
	  "accusator",
	  "acer",
	  "acerbitas",
	  "acervus",
	  "acidus",
	  "acies",
	  "acquiro",
	  "acsi",
	  "adamo",
	  "adaugeo",
	  "addo",
	  "adduco",
	  "ademptio",
	  "adeo",
	  "adeptio",
	  "adfectus",
	  "adfero",
	  "adficio",
	  "adflicto",
	  "adhaero",
	  "adhuc",
	  "adicio",
	  "adimpleo",
	  "adinventitias",
	  "adipiscor",
	  "adiuvo",
	  "administratio",
	  "admiratio",
	  "admitto",
	  "admoneo",
	  "admoveo",
	  "adnuo",
	  "adopto",
	  "adsidue",
	  "adstringo",
	  "adsuesco",
	  "adsum",
	  "adulatio",
	  "adulescens",
	  "adultus",
	  "aduro",
	  "advenio",
	  "adversus",
	  "advoco",
	  "aedificium",
	  "aeger",
	  "aegre",
	  "aegrotatio",
	  "aegrus",
	  "aeneus",
	  "aequitas",
	  "aequus",
	  "aer",
	  "aestas",
	  "aestivus",
	  "aestus",
	  "aetas",
	  "aeternus",
	  "ager",
	  "aggero",
	  "aggredior",
	  "agnitio",
	  "agnosco",
	  "ago",
	  "ait",
	  "aiunt",
	  "alienus",
	  "alii",
	  "alioqui",
	  "aliqua",
	  "alius",
	  "allatus",
	  "alo",
	  "alter",
	  "altus",
	  "alveus",
	  "amaritudo",
	  "ambitus",
	  "ambulo",
	  "amicitia",
	  "amiculum",
	  "amissio",
	  "amita",
	  "amitto",
	  "amo",
	  "amor",
	  "amoveo",
	  "amplexus",
	  "amplitudo",
	  "amplus",
	  "ancilla",
	  "angelus",
	  "angulus",
	  "angustus",
	  "animadverto",
	  "animi",
	  "animus",
	  "annus",
	  "anser",
	  "ante",
	  "antea",
	  "antepono",
	  "antiquus",
	  "aperio",
	  "aperte",
	  "apostolus",
	  "apparatus",
	  "appello",
	  "appono",
	  "appositus",
	  "approbo",
	  "apto",
	  "aptus",
	  "apud",
	  "aqua",
	  "ara",
	  "aranea",
	  "arbitro",
	  "arbor",
	  "arbustum",
	  "arca",
	  "arceo",
	  "arcesso",
	  "arcus",
	  "argentum",
	  "argumentum",
	  "arguo",
	  "arma",
	  "armarium",
	  "armo",
	  "aro",
	  "ars",
	  "articulus",
	  "artificiose",
	  "arto",
	  "arx",
	  "ascisco",
	  "ascit",
	  "asper",
	  "aspicio",
	  "asporto",
	  "assentator",
	  "astrum",
	  "atavus",
	  "ater",
	  "atqui",
	  "atrocitas",
	  "atrox",
	  "attero",
	  "attollo",
	  "attonbitus",
	  "auctor",
	  "auctus",
	  "audacia",
	  "audax",
	  "audentia",
	  "audeo",
	  "audio",
	  "auditor",
	  "aufero",
	  "aureus",
	  "auris",
	  "aurum",
	  "aut",
	  "autem",
	  "autus",
	  "auxilium",
	  "avaritia",
	  "avarus",
	  "aveho",
	  "averto",
	  "avoco",
	  "baiulus",
	  "balbus",
	  "barba",
	  "bardus",
	  "basium",
	  "beatus",
	  "bellicus",
	  "bellum",
	  "bene",
	  "beneficium",
	  "benevolentia",
	  "benigne",
	  "bestia",
	  "bibo",
	  "bis",
	  "blandior",
	  "bonus",
	  "bos",
	  "brevis",
	  "cado",
	  "caecus",
	  "caelestis",
	  "caelum",
	  "calamitas",
	  "calcar",
	  "calco",
	  "calculus",
	  "callide",
	  "campana",
	  "candidus",
	  "canis",
	  "canonicus",
	  "canto",
	  "capillus",
	  "capio",
	  "capitulus",
	  "capto",
	  "caput",
	  "carbo",
	  "carcer",
	  "careo",
	  "caries",
	  "cariosus",
	  "caritas",
	  "carmen",
	  "carpo",
	  "carus",
	  "casso",
	  "caste",
	  "casus",
	  "catena",
	  "caterva",
	  "cattus",
	  "cauda",
	  "causa",
	  "caute",
	  "caveo",
	  "cavus",
	  "cedo",
	  "celebrer",
	  "celer",
	  "celo",
	  "cena",
	  "cenaculum",
	  "ceno",
	  "censura",
	  "centum",
	  "cerno",
	  "cernuus",
	  "certe",
	  "certo",
	  "certus",
	  "cervus",
	  "cetera",
	  "charisma",
	  "chirographum",
	  "cibo",
	  "cibus",
	  "cicuta",
	  "cilicium",
	  "cimentarius",
	  "ciminatio",
	  "cinis",
	  "circumvenio",
	  "cito",
	  "civis",
	  "civitas",
	  "clam",
	  "clamo",
	  "claro",
	  "clarus",
	  "claudeo",
	  "claustrum",
	  "clementia",
	  "clibanus",
	  "coadunatio",
	  "coaegresco",
	  "coepi",
	  "coerceo",
	  "cogito",
	  "cognatus",
	  "cognomen",
	  "cogo",
	  "cohaero",
	  "cohibeo",
	  "cohors",
	  "colligo",
	  "colloco",
	  "collum",
	  "colo",
	  "color",
	  "coma",
	  "combibo",
	  "comburo",
	  "comedo",
	  "comes",
	  "cometes",
	  "comis",
	  "comitatus",
	  "commemoro",
	  "comminor",
	  "commodo",
	  "communis",
	  "comparo",
	  "compello",
	  "complectus",
	  "compono",
	  "comprehendo",
	  "comptus",
	  "conatus",
	  "concedo",
	  "concido",
	  "conculco",
	  "condico",
	  "conduco",
	  "confero",
	  "confido",
	  "conforto",
	  "confugo",
	  "congregatio",
	  "conicio",
	  "coniecto",
	  "conitor",
	  "coniuratio",
	  "conor",
	  "conqueror",
	  "conscendo",
	  "conservo",
	  "considero",
	  "conspergo",
	  "constans",
	  "consuasor",
	  "contabesco",
	  "contego",
	  "contigo",
	  "contra",
	  "conturbo",
	  "conventus",
	  "convoco",
	  "copia",
	  "copiose",
	  "cornu",
	  "corona",
	  "corpus",
	  "correptius",
	  "corrigo",
	  "corroboro",
	  "corrumpo",
	  "coruscus",
	  "cotidie",
	  "crapula",
	  "cras",
	  "crastinus",
	  "creator",
	  "creber",
	  "crebro",
	  "credo",
	  "creo",
	  "creptio",
	  "crepusculum",
	  "cresco",
	  "creta",
	  "cribro",
	  "crinis",
	  "cruciamentum",
	  "crudelis",
	  "cruentus",
	  "crur",
	  "crustulum",
	  "crux",
	  "cubicularis",
	  "cubitum",
	  "cubo",
	  "cui",
	  "cuius",
	  "culpa",
	  "culpo",
	  "cultellus",
	  "cultura",
	  "cum",
	  "cunabula",
	  "cunae",
	  "cunctatio",
	  "cupiditas",
	  "cupio",
	  "cuppedia",
	  "cupressus",
	  "cur",
	  "cura",
	  "curatio",
	  "curia",
	  "curiositas",
	  "curis",
	  "curo",
	  "curriculum",
	  "currus",
	  "cursim",
	  "curso",
	  "cursus",
	  "curto",
	  "curtus",
	  "curvo",
	  "curvus",
	  "custodia",
	  "damnatio",
	  "damno",
	  "dapifer",
	  "debeo",
	  "debilito",
	  "decens",
	  "decerno",
	  "decet",
	  "decimus",
	  "decipio",
	  "decor",
	  "decretum",
	  "decumbo",
	  "dedecor",
	  "dedico",
	  "deduco",
	  "defaeco",
	  "defendo",
	  "defero",
	  "defessus",
	  "defetiscor",
	  "deficio",
	  "defigo",
	  "defleo",
	  "defluo",
	  "defungo",
	  "degenero",
	  "degero",
	  "degusto",
	  "deinde",
	  "delectatio",
	  "delego",
	  "deleo",
	  "delibero",
	  "delicate",
	  "delinquo",
	  "deludo",
	  "demens",
	  "demergo",
	  "demitto",
	  "demo",
	  "demonstro",
	  "demoror",
	  "demulceo",
	  "demum",
	  "denego",
	  "denique",
	  "dens",
	  "denuncio",
	  "denuo",
	  "deorsum",
	  "depereo",
	  "depono",
	  "depopulo",
	  "deporto",
	  "depraedor",
	  "deprecator",
	  "deprimo",
	  "depromo",
	  "depulso",
	  "deputo",
	  "derelinquo",
	  "derideo",
	  "deripio",
	  "desidero",
	  "desino",
	  "desipio",
	  "desolo",
	  "desparatus",
	  "despecto",
	  "despirmatio",
	  "infit",
	  "inflammatio",
	  "paens",
	  "patior",
	  "patria",
	  "patrocinor",
	  "patruus",
	  "pauci",
	  "paulatim",
	  "pauper",
	  "pax",
	  "peccatus",
	  "pecco",
	  "pecto",
	  "pectus",
	  "pecunia",
	  "pecus",
	  "peior",
	  "pel",
	  "ocer",
	  "socius",
	  "sodalitas",
	  "sol",
	  "soleo",
	  "solio",
	  "solitudo",
	  "solium",
	  "sollers",
	  "sollicito",
	  "solum",
	  "solus",
	  "solutio",
	  "solvo",
	  "somniculosus",
	  "somnus",
	  "sonitus",
	  "sono",
	  "sophismata",
	  "sopor",
	  "sordeo",
	  "sortitus",
	  "spargo",
	  "speciosus",
	  "spectaculum",
	  "speculum",
	  "sperno",
	  "spero",
	  "spes",
	  "spiculum",
	  "spiritus",
	  "spoliatio",
	  "sponte",
	  "stabilis",
	  "statim",
	  "statua",
	  "stella",
	  "stillicidium",
	  "stipes",
	  "stips",
	  "sto",
	  "strenuus",
	  "strues",
	  "studio",
	  "stultus",
	  "suadeo",
	  "suasoria",
	  "sub",
	  "subito",
	  "subiungo",
	  "sublime",
	  "subnecto",
	  "subseco",
	  "substantia",
	  "subvenio",
	  "succedo",
	  "succurro",
	  "sufficio",
	  "suffoco",
	  "suffragium",
	  "suggero",
	  "sui",
	  "sulum",
	  "sum",
	  "summa",
	  "summisse",
	  "summopere",
	  "sumo",
	  "sumptus",
	  "supellex",
	  "super",
	  "suppellex",
	  "supplanto",
	  "suppono",
	  "supra",
	  "surculus",
	  "surgo",
	  "sursum",
	  "suscipio",
	  "suspendo",
	  "sustineo",
	  "suus",
	  "synagoga",
	  "tabella",
	  "tabernus",
	  "tabesco",
	  "tabgo",
	  "tabula",
	  "taceo",
	  "tactus",
	  "taedium",
	  "talio",
	  "talis",
	  "talus",
	  "tam",
	  "tamdiu",
	  "tamen",
	  "tametsi",
	  "tamisium",
	  "tamquam",
	  "tandem",
	  "tantillus",
	  "tantum",
	  "tardus",
	  "tego",
	  "temeritas",
	  "temperantia",
	  "templum",
	  "temptatio",
	  "tempus",
	  "tenax",
	  "tendo",
	  "teneo",
	  "tener",
	  "tenuis",
	  "tenus",
	  "tepesco",
	  "tepidus",
	  "ter",
	  "terebro",
	  "teres",
	  "terga",
	  "tergeo",
	  "tergiversatio",
	  "tergo",
	  "tergum",
	  "termes",
	  "terminatio",
	  "tero",
	  "terra",
	  "terreo",
	  "territo",
	  "terror",
	  "tersus",
	  "tertius",
	  "testimonium",
	  "texo",
	  "textilis",
	  "textor",
	  "textus",
	  "thalassinus",
	  "theatrum",
	  "theca",
	  "thema",
	  "theologus",
	  "thermae",
	  "thesaurus",
	  "thesis",
	  "thorax",
	  "thymbra",
	  "thymum",
	  "tibi",
	  "timidus",
	  "timor",
	  "titulus",
	  "tolero",
	  "tollo",
	  "tondeo",
	  "tonsor",
	  "torqueo",
	  "torrens",
	  "tot",
	  "totidem",
	  "toties",
	  "totus",
	  "tracto",
	  "trado",
	  "traho",
	  "trans",
	  "tredecim",
	  "tremo",
	  "trepide",
	  "tres",
	  "tribuo",
	  "tricesimus",
	  "triduana",
	  "triginta",
	  "tripudio",
	  "tristis",
	  "triumphus",
	  "trucido",
	  "truculenter",
	  "tubineus",
	  "tui",
	  "tum",
	  "tumultus",
	  "tunc",
	  "turba",
	  "turbo",
	  "turpe",
	  "turpis",
	  "tutamen",
	  "tutis",
	  "tyrannus",
	  "uberrime",
	  "ubi",
	  "ulciscor",
	  "ullus",
	  "ulterius",
	  "ultio",
	  "ultra",
	  "umbra",
	  "umerus",
	  "umquam",
	  "una",
	  "unde",
	  "undique",
	  "universe",
	  "unus",
	  "urbanus",
	  "urbs",
	  "uredo",
	  "usitas",
	  "usque",
	  "ustilo",
	  "ustulo",
	  "usus",
	  "uter",
	  "uterque",
	  "utilis",
	  "utique",
	  "utor",
	  "utpote",
	  "utrimque",
	  "utroque",
	  "utrum",
	  "uxor",
	  "vaco",
	  "vacuus",
	  "vado",
	  "vae",
	  "valde",
	  "valens",
	  "valeo",
	  "valetudo",
	  "validus",
	  "vallum",
	  "vapulus",
	  "varietas",
	  "varius",
	  "vehemens",
	  "vel",
	  "velociter",
	  "velum",
	  "velut",
	  "venia",
	  "venio",
	  "ventito",
	  "ventosus",
	  "ventus",
	  "venustas",
	  "ver",
	  "verbera",
	  "verbum",
	  "vere",
	  "verecundia",
	  "vereor",
	  "vergo",
	  "veritas",
	  "vero",
	  "versus",
	  "verto",
	  "verumtamen",
	  "verus",
	  "vesco",
	  "vesica",
	  "vesper",
	  "vespillo",
	  "vester",
	  "vestigium",
	  "vestrum",
	  "vetus",
	  "via",
	  "vicinus",
	  "vicissitudo",
	  "victoria",
	  "victus",
	  "videlicet",
	  "video",
	  "viduata",
	  "viduo",
	  "vigilo",
	  "vigor",
	  "vilicus",
	  "vilis",
	  "vilitas",
	  "villa",
	  "vinco",
	  "vinculum",
	  "vindico",
	  "vinitor",
	  "vinum",
	  "vir",
	  "virga",
	  "virgo",
	  "viridis",
	  "viriliter",
	  "virtus",
	  "vis",
	  "viscus",
	  "vita",
	  "vitiosus",
	  "vitium",
	  "vito",
	  "vivo",
	  "vix",
	  "vobis",
	  "vociferor",
	  "voco",
	  "volaticus",
	  "volo",
	  "volubilis",
	  "voluntarius",
	  "volup",
	  "volutabrum",
	  "volva",
	  "vomer",
	  "vomica",
	  "vomito",
	  "vorago",
	  "vorax",
	  "voro",
	  "vos",
	  "votum",
	  "voveo",
	  "vox",
	  "vulariter",
	  "vulgaris",
	  "vulgivagus",
	  "vulgo",
	  "vulgus",
	  "vulnero",
	  "vulnus",
	  "vulpes",
	  "vulticulus",
	  "vultuosus",
	  "xiphias"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Enzo",
	  "Lucas",
	  "Mathis",
	  "Nathan",
	  "Thomas",
	  "Hugo",
	  "Théo",
	  "Tom",
	  "Louis",
	  "Raphaël",
	  "Clément",
	  "Léo",
	  "Mathéo",
	  "Maxime",
	  "Alexandre",
	  "Antoine",
	  "Yanis",
	  "Paul",
	  "Baptiste",
	  "Alexis",
	  "Gabriel",
	  "Arthur",
	  "Jules",
	  "Ethan",
	  "Noah",
	  "Quentin",
	  "Axel",
	  "Evan",
	  "Mattéo",
	  "Romain",
	  "Valentin",
	  "Maxence",
	  "Noa",
	  "Adam",
	  "Nicolas",
	  "Julien",
	  "Mael",
	  "Pierre",
	  "Rayan",
	  "Victor",
	  "Mohamed",
	  "Adrien",
	  "Kylian",
	  "Sacha",
	  "Benjamin",
	  "Léa",
	  "Clara",
	  "Manon",
	  "Chloé",
	  "Camille",
	  "Ines",
	  "Sarah",
	  "Jade",
	  "Lola",
	  "Anaïs",
	  "Lucie",
	  "Océane",
	  "Lilou",
	  "Marie",
	  "Eva",
	  "Romane",
	  "Lisa",
	  "Zoe",
	  "Julie",
	  "Mathilde",
	  "Louise",
	  "Juliette",
	  "Clémence",
	  "Célia",
	  "Laura",
	  "Lena",
	  "Maëlys",
	  "Charlotte",
	  "Ambre",
	  "Maeva",
	  "Pauline",
	  "Lina",
	  "Jeanne",
	  "Lou",
	  "Noémie",
	  "Justine",
	  "Louna",
	  "Elisa",
	  "Alice",
	  "Emilie",
	  "Carla",
	  "Maëlle",
	  "Alicia",
	  "Mélissa"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(758);
	name.last_name = __webpack_require__(760);
	name.prefix = __webpack_require__(762);
	name.title = __webpack_require__(763);
	name.name = __webpack_require__(761);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Martin",
	  "Bernard",
	  "Dubois",
	  "Thomas",
	  "Robert",
	  "Richard",
	  "Petit",
	  "Durand",
	  "Leroy",
	  "Moreau",
	  "Simon",
	  "Laurent",
	  "Lefebvre",
	  "Michel",
	  "Garcia",
	  "David",
	  "Bertrand",
	  "Roux",
	  "Vincent",
	  "Fournier",
	  "Morel",
	  "Girard",
	  "Andre",
	  "Lefevre",
	  "Mercier",
	  "Dupont",
	  "Lambert",
	  "Bonnet",
	  "Francois",
	  "Martinez",
	  "Legrand",
	  "Garnier",
	  "Faure",
	  "Rousseau",
	  "Blanc",
	  "Guerin",
	  "Muller",
	  "Henry",
	  "Roussel",
	  "Nicolas",
	  "Perrin",
	  "Morin",
	  "Mathieu",
	  "Clement",
	  "Gauthier",
	  "Dumont",
	  "Lopez",
	  "Fontaine",
	  "Chevalier",
	  "Robin",
	  "Masson",
	  "Sanchez",
	  "Gerard",
	  "Nguyen",
	  "Boyer",
	  "Denis",
	  "Lemaire",
	  "Duval",
	  "Joly",
	  "Gautier",
	  "Roger",
	  "Roche",
	  "Roy",
	  "Noel",
	  "Meyer",
	  "Lucas",
	  "Meunier",
	  "Jean",
	  "Perez",
	  "Marchand",
	  "Dufour",
	  "Blanchard",
	  "Marie",
	  "Barbier",
	  "Brun",
	  "Dumas",
	  "Brunet",
	  "Schmitt",
	  "Leroux",
	  "Colin",
	  "Fernandez",
	  "Pierre",
	  "Renard",
	  "Arnaud",
	  "Rolland",
	  "Caron",
	  "Aubert",
	  "Giraud",
	  "Leclerc",
	  "Vidal",
	  "Bourgeois",
	  "Renaud",
	  "Lemoine",
	  "Picard",
	  "Gaillard",
	  "Philippe",
	  "Leclercq",
	  "Lacroix",
	  "Fabre",
	  "Dupuis",
	  "Olivier",
	  "Rodriguez",
	  "Da silva",
	  "Hubert",
	  "Louis",
	  "Charles",
	  "Guillot",
	  "Riviere",
	  "Le gall",
	  "Guillaume",
	  "Adam",
	  "Rey",
	  "Moulin",
	  "Gonzalez",
	  "Berger",
	  "Lecomte",
	  "Menard",
	  "Fleury",
	  "Deschamps",
	  "Carpentier",
	  "Julien",
	  "Benoit",
	  "Paris",
	  "Maillard",
	  "Marchal",
	  "Aubry",
	  "Vasseur",
	  "Le roux",
	  "Renault",
	  "Jacquet",
	  "Collet",
	  "Prevost",
	  "Poirier",
	  "Charpentier",
	  "Royer",
	  "Huet",
	  "Baron",
	  "Dupuy",
	  "Pons",
	  "Paul",
	  "Laine",
	  "Carre",
	  "Breton",
	  "Remy",
	  "Schneider",
	  "Perrot",
	  "Guyot",
	  "Barre",
	  "Marty",
	  "Cousin"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{last_name} #{first_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "M",
	  "Mme",
	  "Mlle",
	  "Dr",
	  "Prof"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "job": [
	    "Superviseur",
	    "Executif",
	    "Manager",
	    "Ingenieur",
	    "Specialiste",
	    "Directeur",
	    "Coordinateur",
	    "Administrateur",
	    "Architecte",
	    "Analyste",
	    "Designer",
	    "Technicien",
	    "Developpeur",
	    "Producteur",
	    "Consultant",
	    "Assistant",
	    "Agent",
	    "Stagiaire"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "01########",
	  "02########",
	  "03########",
	  "04########",
	  "05########",
	  "06########",
	  "07########",
	  "+33 1########",
	  "+33 2########",
	  "+33 3########",
	  "+33 4########",
	  "+33 5########",
	  "+33 6########",
	  "+33 7########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(764);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Canada"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.postcode = __webpack_require__(768);
	address.state = __webpack_require__(769);
	address.state_abbr = __webpack_require__(770);
	address.default_country = __webpack_require__(766);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "?#? #?#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alberta",
	  "Colombie-Britannique",
	  "Manitoba",
	  "Nouveau-Brunswick",
	  "Terre-Neuve-et-Labrador",
	  "Nouvelle-Écosse",
	  "Territoires du Nord-Ouest",
	  "Nunavut",
	  "Ontario",
	  "Île-du-Prince-Édouard",
	  "Québec",
	  "Saskatchewan",
	  "Yukon"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AB",
	  "BC",
	  "MB",
	  "NB",
	  "NL",
	  "NS",
	  "NU",
	  "NT",
	  "ON",
	  "PE",
	  "QC",
	  "SK",
	  "YK"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var fr_CA = {};
	module['exports'] = fr_CA;
	fr_CA.title = "Canada (French)";
	fr_CA.address = __webpack_require__(767);
	fr_CA.internet = __webpack_require__(774);
	fr_CA.phone_number = __webpack_require__(776);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "qc.ca",
	  "ca",
	  "com",
	  "biz",
	  "info",
	  "name",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.ca",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(773);
	internet.domain_suffix = __webpack_require__(772);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "### ###-####",
	  "1 ### ###-####",
	  "### ###-####, poste ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(775);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###",
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix} #{Name.first_name}#{city_suffix}",
	  "#{city_prefix} #{Name.first_name}",
	  "#{Name.first_name}#{city_suffix}",
	  "#{Name.first_name}#{city_suffix}",
	  "#{Name.last_name}#{city_suffix}",
	  "#{Name.last_name}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "აბასთუმანი",
	  "აბაშა",
	  "ადიგენი",
	  "ამბროლაური",
	  "ანაკლია",
	  "ასპინძა",
	  "ახალგორი",
	  "ახალქალაქი",
	  "ახალციხე",
	  "ახმეტა",
	  "ბათუმი",
	  "ბაკურიანი",
	  "ბაღდათი",
	  "ბახმარო",
	  "ბოლნისი",
	  "ბორჯომი",
	  "გარდაბანი",
	  "გონიო",
	  "გორი",
	  "გრიგოლეთი",
	  "გუდაური",
	  "გურჯაანი",
	  "დედოფლისწყარო",
	  "დმანისი",
	  "დუშეთი",
	  "ვანი",
	  "ზესტაფონი",
	  "ზუგდიდი",
	  "თბილისი",
	  "თეთრიწყარო",
	  "თელავი",
	  "თერჯოლა",
	  "თიანეთი",
	  "კასპი",
	  "კვარიათი",
	  "კიკეთი",
	  "კოჯორი",
	  "ლაგოდეხი",
	  "ლანჩხუთი",
	  "ლენტეხი",
	  "მარნეული",
	  "მარტვილი",
	  "მესტია",
	  "მცხეთა",
	  "მწვანე კონცხი",
	  "ნინოწმინდა",
	  "ოზურგეთი",
	  "ონი",
	  "რუსთავი",
	  "საგარეჯო",
	  "საგურამო",
	  "საირმე",
	  "სამტრედია",
	  "სარფი",
	  "საჩხერე",
	  "სენაკი",
	  "სიღნაღი",
	  "სტეფანწმინდა",
	  "სურამი",
	  "ტაბახმელა",
	  "ტყიბული",
	  "ურეკი",
	  "ფოთი",
	  "ქარელი",
	  "ქედა",
	  "ქობულეთი",
	  "ქუთაისი",
	  "ყვარელი",
	  "შუახევი",
	  "ჩაქვი",
	  "ჩოხატაური",
	  "ცაგერი",
	  "ცხოროჭყუ",
	  "წავკისი",
	  "წალენჯიხა",
	  "წალკა",
	  "წაღვერი",
	  "წეროვანი",
	  "წნორი",
	  "წყალტუბო",
	  "წყნეთი",
	  "ჭიათურა",
	  "ხარაგაული",
	  "ხაშური",
	  "ხელვაჩაური",
	  "ხობი",
	  "ხონი",
	  "ხულო"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ახალი",
	  "ძველი",
	  "ზემო",
	  "ქვემო"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "სოფელი",
	  "ძირი",
	  "სკარი",
	  "დაბა"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ავსტრალია",
	  "ავსტრია",
	  "ავღანეთი",
	  "აზავადი",
	  "აზერბაიჯანი",
	  "აზიაში",
	  "აზიის",
	  "ალბანეთი",
	  "ალჟირი",
	  "ამაღლება და ტრისტანი-და-კუნია",
	  "ამერიკის ვირჯინიის კუნძულები",
	  "ამერიკის სამოა",
	  "ამერიკის შეერთებული შტატები",
	  "ამერიკის",
	  "ანგილია",
	  "ანგოლა",
	  "ანდორა",
	  "ანტიგუა და ბარბუდა",
	  "არაბეთის საემიროები",
	  "არაბთა გაერთიანებული საამიროები",
	  "არაბული ქვეყნების ლიგის",
	  "არგენტინა",
	  "არუბა",
	  "არცნობილი ქვეყნების სია",
	  "აფრიკაში",
	  "აფრიკაშია",
	  "აღდგომის კუნძული",
	  "აღმ. ტიმორი",
	  "აღმოსავლეთი აფრიკა",
	  "აღმოსავლეთი ტიმორი",
	  "აშშ",
	  "აშშ-ის ვირჯინის კუნძულები",
	  "ახალი ზელანდია",
	  "ახალი კალედონია",
	  "ბანგლადეში",
	  "ბარბადოსი",
	  "ბაჰამის კუნძულები",
	  "ბაჰრეინი",
	  "ბელარუსი",
	  "ბელგია",
	  "ბელიზი",
	  "ბენინი",
	  "ბერმუდა",
	  "ბერმუდის კუნძულები",
	  "ბოლივია",
	  "ბოსნია და ჰერცეგოვინა",
	  "ბოტსვანა",
	  "ბრაზილია",
	  "ბრიტანეთის ვირჯინიის კუნძულები",
	  "ბრიტანეთის ვირჯინის კუნძულები",
	  "ბრიტანეთის ინდოეთის ოკეანის ტერიტორია",
	  "ბრუნეი",
	  "ბულგარეთი",
	  "ბურკინა ფასო",
	  "ბურკინა-ფასო",
	  "ბურუნდი",
	  "ბჰუტანი",
	  "გაბონი",
	  "გაერთიანებული სამეფო",
	  "გაეროს",
	  "გაიანა",
	  "გამბია",
	  "განა",
	  "გერმანია",
	  "გვადელუპა",
	  "გვატემალა",
	  "გვინეა",
	  "გვინეა-ბისაუ",
	  "გიბრალტარი",
	  "გრენადა",
	  "გრენლანდია",
	  "გუამი",
	  "დამოკიდებული ტერ.",
	  "დამოკიდებული ტერიტორია",
	  "დამოკიდებული",
	  "დანია",
	  "დასავლეთი აფრიკა",
	  "დასავლეთი საჰარა",
	  "დიდი ბრიტანეთი",
	  "დომინიკა",
	  "დომინიკელთა რესპუბლიკა",
	  "ეგვიპტე",
	  "ევროკავშირის",
	  "ევროპასთან",
	  "ევროპაშია",
	  "ევროპის ქვეყნები",
	  "ეთიოპია",
	  "ეკვადორი",
	  "ეკვატორული გვინეა",
	  "ეპარსეს კუნძული",
	  "ერაყი",
	  "ერიტრეა",
	  "ესპანეთი",
	  "ესპანეთის სუვერენული ტერიტორიები",
	  "ესტონეთი",
	  "ეშმორის და კარტიეს კუნძულები",
	  "ვანუატუ",
	  "ვატიკანი",
	  "ვენესუელა",
	  "ვიეტნამი",
	  "ზამბია",
	  "ზიმბაბვე",
	  "თურქეთი",
	  "თურქმენეთი",
	  "იამაიკა",
	  "იან მაიენი",
	  "იაპონია",
	  "იემენი",
	  "ინდოეთი",
	  "ინდონეზია",
	  "იორდანია",
	  "ირანი",
	  "ირლანდია",
	  "ისლანდია",
	  "ისრაელი",
	  "იტალია",
	  "კაბო-ვერდე",
	  "კაიმანის კუნძულები",
	  "კამბოჯა",
	  "კამერუნი",
	  "კანადა",
	  "კანარის კუნძულები",
	  "კარიბის ზღვის",
	  "კატარი",
	  "კენია",
	  "კვიპროსი",
	  "კინგმენის რიფი",
	  "კირიბატი",
	  "კლიპერტონი",
	  "კოლუმბია",
	  "კომორი",
	  "კომორის კუნძულები",
	  "კონგოს დემოკრატიული რესპუბლიკა",
	  "კონგოს რესპუბლიკა",
	  "კორეის რესპუბლიკა",
	  "კოსტა-რიკა",
	  "კოტ-დ’ივუარი",
	  "კუბა",
	  "კუკის კუნძულები",
	  "ლაოსი",
	  "ლატვია",
	  "ლესოთო",
	  "ლიბანი",
	  "ლიბერია",
	  "ლიბია",
	  "ლიტვა",
	  "ლიხტენშტაინი",
	  "ლუქსემბურგი",
	  "მადაგასკარი",
	  "მადეირა",
	  "მავრიკი",
	  "მავრიტანია",
	  "მაიოტა",
	  "მაკაო",
	  "მაკედონია",
	  "მალავი",
	  "მალაიზია",
	  "მალდივი",
	  "მალდივის კუნძულები",
	  "მალი",
	  "მალტა",
	  "მაროკო",
	  "მარტინიკა",
	  "მარშალის კუნძულები",
	  "მარჯნის ზღვის კუნძულები",
	  "მელილია",
	  "მექსიკა",
	  "მიანმარი",
	  "მიკრონეზია",
	  "მიკრონეზიის ფედერაციული შტატები",
	  "მიმდებარე კუნძულები",
	  "მოზამბიკი",
	  "მოლდოვა",
	  "მონაკო",
	  "მონსერატი",
	  "მონღოლეთი",
	  "ნამიბია",
	  "ნაურუ",
	  "ნაწილობრივ აფრიკაში",
	  "ნეპალი",
	  "ნიგერი",
	  "ნიგერია",
	  "ნიდერლანდი",
	  "ნიდერლანდის ანტილები",
	  "ნიკარაგუა",
	  "ნიუე",
	  "ნორვეგია",
	  "ნორფოლკის კუნძული",
	  "ოკეანეთის",
	  "ოკეანიას",
	  "ომანი",
	  "პაკისტანი",
	  "პალაუ",
	  "პალესტინა",
	  "პალმირა (ატოლი)",
	  "პანამა",
	  "პანტელერია",
	  "პაპუა-ახალი გვინეა",
	  "პარაგვაი",
	  "პერუ",
	  "პიტკერნის კუნძულები",
	  "პოლონეთი",
	  "პორტუგალია",
	  "პრინც-ედუარდის კუნძული",
	  "პუერტო-რიკო",
	  "რეუნიონი",
	  "როტუმა",
	  "რუანდა",
	  "რუმინეთი",
	  "რუსეთი",
	  "საბერძნეთი",
	  "სადავო ტერიტორიები",
	  "სალვადორი",
	  "სამოა",
	  "სამხ. კორეა",
	  "სამხრეთ ამერიკაშია",
	  "სამხრეთ ამერიკის",
	  "სამხრეთ აფრიკის რესპუბლიკა",
	  "სამხრეთი აფრიკა",
	  "სამხრეთი გეორგია და სამხრეთ სენდვიჩის კუნძულები",
	  "სამხრეთი სუდანი",
	  "სან-მარინო",
	  "სან-ტომე და პრინსიპი",
	  "საუდის არაბეთი",
	  "საფრანგეთი",
	  "საფრანგეთის გვიანა",
	  "საფრანგეთის პოლინეზია",
	  "საქართველო",
	  "საჰარის არაბთა დემოკრატიული რესპუბლიკა",
	  "სეიშელის კუნძულები",
	  "სენ-ბართელმი",
	  "სენ-მარტენი",
	  "სენ-პიერი და მიკელონი",
	  "სენეგალი",
	  "სენტ-ვინსენტი და გრენადინები",
	  "სენტ-კიტსი და ნევისი",
	  "სენტ-ლუსია",
	  "სერბეთი",
	  "სეუტა",
	  "სვაზილენდი",
	  "სვალბარდი",
	  "სიერა-ლეონე",
	  "სინგაპური",
	  "სირია",
	  "სლოვაკეთი",
	  "სლოვენია",
	  "სოკოტრა",
	  "სოლომონის კუნძულები",
	  "სომალი",
	  "სომალილენდი",
	  "სომხეთი",
	  "სუდანი",
	  "სუვერენული სახელმწიფოები",
	  "სურინამი",
	  "ტაივანი",
	  "ტაილანდი",
	  "ტანზანია",
	  "ტაჯიკეთი",
	  "ტერიტორიები",
	  "ტერქსისა და კაიკოსის კუნძულები",
	  "ტოგო",
	  "ტოკელაუ",
	  "ტონგა",
	  "ტრანსკონტინენტური ქვეყანა",
	  "ტრინიდადი და ტობაგო",
	  "ტუვალუ",
	  "ტუნისი",
	  "უგანდა",
	  "უზბეკეთი",
	  "უკრაინა",
	  "უნგრეთი",
	  "უოლისი და ფუტუნა",
	  "ურუგვაი",
	  "ფარერის კუნძულები",
	  "ფილიპინები",
	  "ფინეთი",
	  "ფიჯი",
	  "ფოლკლენდის კუნძულები",
	  "ქვეყნები",
	  "ქოქოსის კუნძულები",
	  "ქუვეითი",
	  "ღაზის სექტორი",
	  "ყაზახეთი",
	  "ყირგიზეთი",
	  "შვედეთი",
	  "შვეიცარია",
	  "შობის კუნძული",
	  "შრი-ლანკა",
	  "ჩადი",
	  "ჩერნოგორია",
	  "ჩეჩნეთის რესპუბლიკა იჩქერია",
	  "ჩეხეთი",
	  "ჩილე",
	  "ჩინეთი",
	  "ჩრდ. კორეა",
	  "ჩრდილოეთ ამერიკის",
	  "ჩრდილოეთ მარიანას კუნძულები",
	  "ჩრდილოეთი აფრიკა",
	  "ჩრდილოეთი კორეა",
	  "ჩრდილოეთი მარიანას კუნძულები",
	  "ცენტრალური აფრიკა",
	  "ცენტრალური აფრიკის რესპუბლიკა",
	  "წევრები",
	  "წმინდა ელენე",
	  "წმინდა ელენეს კუნძული",
	  "ხორვატია",
	  "ჯერსი",
	  "ჯიბუტი",
	  "ჰავაი",
	  "ჰაიტი",
	  "ჰერდი და მაკდონალდის კუნძულები",
	  "ჰონდურასი",
	  "ჰონკონგი"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "საქართველო"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(780);
	address.city_suffix = __webpack_require__(781);
	address.city = __webpack_require__(778);
	address.country = __webpack_require__(782);
	address.building_number = __webpack_require__(777);
	address.street_suffix = __webpack_require__(789);
	address.secondary_address = __webpack_require__(786);
	address.postcode = __webpack_require__(785);
	address.city_name = __webpack_require__(779);
	address.street_title = __webpack_require__(790);
	address.street_name = __webpack_require__(788);
	address.street_address = __webpack_require__(787);
	address.default_country = __webpack_require__(783);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "01##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "კორპ. ##",
	  "შენობა ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_title} #{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "გამზ.",
	  "გამზირი",
	  "ქ.",
	  "ქუჩა",
	  "ჩიხი",
	  "ხეივანი"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "აბაშიძის",
	  "აბესაძის",
	  "აბულაძის",
	  "აგლაძის",
	  "ადლერის",
	  "ავიაქიმიის",
	  "ავლაბრის",
	  "ათარბეგოვის",
	  "ათონელის",
	  "ალავერდოვის",
	  "ალექსიძის",
	  "ალილუევის",
	  "ალმასიანის",
	  "ამაღლების",
	  "ამირეჯიბის",
	  "ანაგის",
	  "ანდრონიკაშვილის",
	  "ანთელავას",
	  "ანჯაფარიძის",
	  "არაგვის",
	  "არდონის",
	  "არეშიძის",
	  "ასათიანის",
	  "ასკურავას",
	  "ასლანიდის",
	  "ატენის",
	  "აფხაზი",
	  "აღმაშენებლის",
	  "ახალშენის",
	  "ახვლედიანის",
	  "ბააზოვის",
	  "ბაბისხევის",
	  "ბაბუშკინის",
	  "ბაგრატიონის",
	  "ბალანჩივაძეების",
	  "ბალანჩივაძის",
	  "ბალანჩინის",
	  "ბალმაშევის",
	  "ბარამიძის",
	  "ბარნოვის",
	  "ბაშალეიშვილის",
	  "ბევრეთის",
	  "ბელინსკის",
	  "ბელოსტოკის",
	  "ბენაშვილის",
	  "ბეჟანიშვილის",
	  "ბერიძის",
	  "ბოლქვაძის",
	  "ბოცვაძის",
	  "ბოჭორიშვილის",
	  "ბოჭორიძის",
	  "ბუაჩიძის",
	  "ბუდაპეშტის",
	  "ბურკიაშვილის",
	  "ბურძგლას",
	  "გაბესკირიას",
	  "გაგარინის",
	  "გაზაფხულის",
	  "გამრეკელის",
	  "გამსახურდიას",
	  "გარეჯელის",
	  "გეგეჭკორის",
	  "გედაურის",
	  "გელოვანი",
	  "გელოვანის",
	  "გერცენის",
	  "გლდანის",
	  "გოგებაშვილის",
	  "გოგიბერიძის",
	  "გოგოლის",
	  "გონაშვილის",
	  "გორგასლის",
	  "გრანელის",
	  "გრიზოდუბოვას",
	  "გრინევიცკის",
	  "გრომოვას",
	  "გრუზინსკის",
	  "გუდიაშვილის",
	  "გულრიფშის",
	  "გულუას",
	  "გურამიშვილის",
	  "გურგენიძის",
	  "დადიანის",
	  "დავითაშვილის",
	  "დამაკავშირებელი",
	  "დარიალის",
	  "დედოფლისწყაროს",
	  "დეპუტატის",
	  "დიდგორის",
	  "დიდი",
	  "დიდუბის",
	  "დიუმას",
	  "დიღმის",
	  "დიღომში",
	  "დოლიძის",
	  "დუნდუას",
	  "დურმიშიძის",
	  "ელიავას",
	  "ენგელსის",
	  "ენგურის",
	  "ეპისკოპოსის",
	  "ერისთავი",
	  "ერისთავის",
	  "ვაზისუბნის",
	  "ვაკელის",
	  "ვართაგავას",
	  "ვატუტინის",
	  "ვაჩნაძის",
	  "ვაცეკის",
	  "ვეკუას",
	  "ვეშაპურის",
	  "ვირსალაძის",
	  "ვოლოდარსკის",
	  "ვორონინის",
	  "ზაარბრიუკენის",
	  "ზაზიაშვილის",
	  "ზაზიშვილის",
	  "ზაკომოლდინის",
	  "ზანდუკელის",
	  "ზაქარაიას",
	  "ზაქარიაძის",
	  "ზახაროვის",
	  "ზაჰესის",
	  "ზნაურის",
	  "ზურაბაშვილის",
	  "ზღვის",
	  "თაბუკაშვილის",
	  "თავაძის",
	  "თავისუფლების",
	  "თამარაშვილის",
	  "თაქთაქიშვილის",
	  "თბილელის",
	  "თელიას",
	  "თორაძის",
	  "თოფურიძის",
	  "იალბუზის",
	  "იამანიძის",
	  "იაშვილის",
	  "იბერიის",
	  "იერუსალიმის",
	  "ივანიძის",
	  "ივერიელის",
	  "იზაშვილის",
	  "ილურიძის",
	  "იმედაშვილის",
	  "იმედაძის",
	  "იმედის",
	  "ინანიშვილის",
	  "ინგოროყვას",
	  "ინდუსტრიალიზაციის",
	  "ინჟინრის",
	  "ინწკირველის",
	  "ირბახის",
	  "ირემაშვილის",
	  "ისაკაძის",
	  "ისპასჰანლის",
	  "იტალიის",
	  "იუნკერთა",
	  "კათალიკოსის",
	  "კაიროს",
	  "კაკაბაძის",
	  "კაკაბეთის",
	  "კაკლიანის",
	  "კალანდაძის",
	  "კალიაევის",
	  "კალინინის",
	  "კამალოვის",
	  "კამოს",
	  "კაშენის",
	  "კახოვკის",
	  "კედიას",
	  "კელაპტრიშვილის",
	  "კერესელიძის",
	  "კეცხოველის",
	  "კიბალჩიჩის",
	  "კიკნაძის",
	  "კიროვის",
	  "კობარეთის",
	  "კოლექტივიზაციის",
	  "კოლმეურნეობის",
	  "კოლხეთის",
	  "კომკავშირის",
	  "კომუნისტური",
	  "კონსტიტუციის",
	  "კოოპერაციის",
	  "კოსტავას",
	  "კოტეტიშვილის",
	  "კოჩეტკოვის",
	  "კოჯრის",
	  "კრონშტადტის",
	  "კროპოტკინის",
	  "კრუპსკაიას",
	  "კუიბიშევის",
	  "კურნატოვსკის",
	  "კურტანოვსკის",
	  "კუტუზოვის",
	  "ლაღიძის",
	  "ლელაშვილის",
	  "ლენინაშენის",
	  "ლენინგრადის",
	  "ლენინის",
	  "ლენის",
	  "ლეონიძის",
	  "ლვოვის",
	  "ლორთქიფანიძის",
	  "ლოტკინის",
	  "ლუბლიანის",
	  "ლუბოვსკის",
	  "ლუნაჩარსკის",
	  "ლუქსემბურგის",
	  "მაგნიტოგორსკის",
	  "მაზნიაშვილის",
	  "მაისურაძის",
	  "მამარდაშვილის",
	  "მამაცაშვილის",
	  "მანაგაძის",
	  "მანჯგალაძის",
	  "მარის",
	  "მარუაშვილის",
	  "მარქსის",
	  "მარჯანის",
	  "მატროსოვის",
	  "მაჭავარიანი",
	  "მახალდიანის",
	  "მახარაძის",
	  "მებაღიშვილის",
	  "მეგობრობის",
	  "მელაანის",
	  "მერკვილაძის",
	  "მესხიას",
	  "მესხის",
	  "მეტეხის",
	  "მეტრეველი",
	  "მეჩნიკოვის",
	  "მთავარანგელოზის",
	  "მიასნიკოვის",
	  "მილორავას",
	  "მიმინოშვილის",
	  "მიროტაძის",
	  "მიქატაძის",
	  "მიქელაძის",
	  "მონტინის",
	  "მორეტის",
	  "მოსკოვის",
	  "მრევლიშვილის",
	  "მუშკორის",
	  "მუჯირიშვილის",
	  "მშვიდობის",
	  "მცხეთის",
	  "ნადირაძის",
	  "ნაკაშიძის",
	  "ნარიმანოვის",
	  "ნასიძის",
	  "ნაფარეულის",
	  "ნეკრასოვის",
	  "ნიაღვრის",
	  "ნინიძის",
	  "ნიშნიანიძის",
	  "ობოლაძის",
	  "ონიანის",
	  "ოჟიოს",
	  "ორახელაშვილის",
	  "ორბელიანის",
	  "ორჯონიკიძის",
	  "ოქტომბრის",
	  "ოცდაექვსი",
	  "პავლოვის",
	  "პარალელურის",
	  "პარიზის",
	  "პეკინის",
	  "პეროვსკაიას",
	  "პეტეფის",
	  "პიონერის",
	  "პირველი",
	  "პისარევის",
	  "პლეხანოვის",
	  "პრავდის",
	  "პროლეტარიატის",
	  "ჟელიაბოვის",
	  "ჟვანიას",
	  "ჟორდანიას",
	  "ჟღენტი",
	  "ჟღენტის",
	  "რადიანის",
	  "რამიშვილი",
	  "რასკოვას",
	  "რენინგერის",
	  "რინგის",
	  "რიჟინაშვილის",
	  "რობაქიძის",
	  "რობესპიერის",
	  "რუსის",
	  "რუხაძის",
	  "რჩეულიშვილის",
	  "სააკაძის",
	  "საბადურის",
	  "საბაშვილის",
	  "საბურთალოს",
	  "საბჭოს",
	  "საგურამოს",
	  "სამრეკლოს",
	  "სამღერეთის",
	  "სანაკოევის",
	  "სარაჯიშვილის",
	  "საჯაიას",
	  "სევასტოპოლის",
	  "სერგი",
	  "სვანიძის",
	  "სვერდლოვის",
	  "სტახანოვის",
	  "სულთნიშნის",
	  "სურგულაძის",
	  "სხირტლაძის",
	  "ტაბიძის",
	  "ტატიშვილის",
	  "ტელმანის",
	  "ტერევერკოს",
	  "ტეტელაშვილის",
	  "ტოვსტონოგოვის",
	  "ტოროშელიძის",
	  "ტრაქტორის",
	  "ტრიკოტაჟის",
	  "ტურბინის",
	  "უბილავას",
	  "უბინაშვილის",
	  "უზნაძის",
	  "უკლებას",
	  "ულიანოვის",
	  "ურიდიას",
	  "ფაბრიციუსის",
	  "ფაღავას",
	  "ფერისცვალების",
	  "ფიგნერის",
	  "ფიზკულტურის",
	  "ფიოლეტოვის",
	  "ფიფიების",
	  "ფოცხიშვილის",
	  "ქართველიშვილის",
	  "ქართლელიშვილის",
	  "ქინქლაძის",
	  "ქიქოძის",
	  "ქსოვრელის",
	  "ქუთათელაძის",
	  "ქუთათელის",
	  "ქურდიანის",
	  "ღოღობერიძის",
	  "ღუდუშაურის",
	  "ყავლაშვილის",
	  "ყაზბეგის",
	  "ყარყარაშვილის",
	  "ყიფიანის",
	  "ყუშიტაშვილის",
	  "შანიძის",
	  "შარტავას",
	  "შატილოვის",
	  "შაუმიანის",
	  "შენგელაიას",
	  "შერვაშიძის",
	  "შეროზიას",
	  "შირშოვის",
	  "შმიდტის",
	  "შრომის",
	  "შუშინის",
	  "შჩორსის",
	  "ჩალაუბნის",
	  "ჩანტლაძის",
	  "ჩაპაევის",
	  "ჩაჩავას",
	  "ჩელუსკინელების",
	  "ჩერნიახოვსკის",
	  "ჩერქეზიშვილი",
	  "ჩერქეზიშვილის",
	  "ჩვიდმეტი",
	  "ჩიტაიას",
	  "ჩიტაძის",
	  "ჩიქვანაიას",
	  "ჩიქობავას",
	  "ჩიხლაძის",
	  "ჩოდრიშვილის",
	  "ჩოლოყაშვილის",
	  "ჩუღურეთის",
	  "ცაბაძის",
	  "ცაგარელის",
	  "ცეტკინის",
	  "ცინცაძის",
	  "ცისკარიშვილის",
	  "ცურტაველის",
	  "ცქიტიშვილის",
	  "ცხაკაიას",
	  "ძმობის",
	  "ძნელაძის",
	  "წერეთლის",
	  "წითელი",
	  "წითელწყაროს",
	  "წინამძღვრიშვილის",
	  "წულაძის",
	  "წულუკიძის",
	  "ჭაბუკიანის",
	  "ჭავჭავაძის",
	  "ჭანტურიას",
	  "ჭოველიძის",
	  "ჭონქაძის",
	  "ჭყონდიდელის",
	  "ხანძთელის",
	  "ხვამლის",
	  "ხვინგიას",
	  "ხვიჩიას",
	  "ხიმშიაშვილის",
	  "ხმელნიცკის",
	  "ხორნაბუჯის",
	  "ხრამჰესის",
	  "ხუციშვილის",
	  "ჯავახიშვილის",
	  "ჯაფარიძის",
	  "ჯიბლაძის",
	  "ჯორჯიაშვილის"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(+995 32) 2-##-##-##",
	  "032-2-##-##-##",
	  "032-2-######",
	  "032-2-###-###",
	  "032 2 ## ## ##",
	  "032 2 ######",
	  "2 ## ## ##",
	  "2######",
	  "2 ### ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(791);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.prefix = __webpack_require__(795);
	company.suffix = __webpack_require__(796);
	company.name = __webpack_require__(794);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{Name.first_name}",
	  "#{prefix} #{Name.last_name}",
	  "#{prefix} #{Name.last_name} #{suffix}",
	  "#{prefix} #{Name.first_name} #{suffix}",
	  "#{prefix} #{Name.last_name}-#{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "შპს",
	  "სს",
	  "ააიპ",
	  "სსიპ"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ჯგუფი",
	  "და კომპანია",
	  "სტუდია",
	  "გრუპი"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var ge = {};
	module['exports'] = ge;
	ge.title = "Georgian";
	ge.separator = " და ";
	ge.name = __webpack_require__(802);
	ge.address = __webpack_require__(784);
	ge.internet = __webpack_require__(800);
	ge.company = __webpack_require__(793);
	ge.phone_number = __webpack_require__(808);
	ge.cell_phone = __webpack_require__(792);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ge",
	  "com",
	  "net",
	  "org",
	  "com.ge",
	  "org.ge"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "posta.ge"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(799);
	internet.domain_suffix = __webpack_require__(798);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "აგული",
	  "აგუნა",
	  "ადოლა",
	  "ავთანდილ",
	  "ავთო",
	  "აკაკი",
	  "აკო",
	  "ალეკო",
	  "ალექსანდრე",
	  "ალექსი",
	  "ალიო",
	  "ამირან",
	  "ანა",
	  "ანანო",
	  "ანზორ",
	  "ანნა",
	  "ანუკა",
	  "ანუკი",
	  "არჩილ",
	  "ასკილა",
	  "ასლანაზ",
	  "აჩიკო",
	  "ბადრი",
	  "ბაია",
	  "ბარბარე",
	  "ბაქარ",
	  "ბაჩა",
	  "ბაჩანა",
	  "ბაჭუა",
	  "ბაჭუკი",
	  "ბახვა",
	  "ბელა",
	  "ბერა",
	  "ბერდია",
	  "ბესიკ",
	  "ბესიკ",
	  "ბესო",
	  "ბექა",
	  "ბიძინა",
	  "ბიჭიკო",
	  "ბოჩია",
	  "ბოცო",
	  "ბროლა",
	  "ბუბუ",
	  "ბუდუ",
	  "ბუხუტი",
	  "გაგა",
	  "გაგი",
	  "გახა",
	  "გეგა",
	  "გეგი",
	  "გედია",
	  "გელა",
	  "გენადი",
	  "გვადი",
	  "გვანცა",
	  "გვანჯი",
	  "გვიტია",
	  "გვრიტა",
	  "გია",
	  "გიგა",
	  "გიგი",
	  "გიგილო",
	  "გიგლა",
	  "გიგოლი",
	  "გივი",
	  "გივიკო",
	  "გიორგი",
	  "გოგი",
	  "გოგიტა",
	  "გოგიჩა",
	  "გოგოთურ",
	  "გოგოლა",
	  "გოდერძი",
	  "გოლა",
	  "გოჩა",
	  "გრიგოლ",
	  "გუგა",
	  "გუგუ",
	  "გუგულა",
	  "გუგული",
	  "გუგუნა",
	  "გუკა",
	  "გულარისა",
	  "გულვარდი",
	  "გულვარდისა",
	  "გულთამზე",
	  "გულია",
	  "გულიკო",
	  "გულისა",
	  "გულნარა",
	  "გურამ",
	  "დავით",
	  "დალი",
	  "დარეჯან",
	  "დიანა",
	  "დიმიტრი",
	  "დოდო",
	  "დუტუ",
	  "ეთერ",
	  "ეთო",
	  "ეკა",
	  "ეკატერინე",
	  "ელგუჯა",
	  "ელენა",
	  "ელენე",
	  "ელზა",
	  "ელიკო",
	  "ელისო",
	  "ემზარ",
	  "ეშხა",
	  "ვალენტინა",
	  "ვალერი",
	  "ვანო",
	  "ვაჟა",
	  "ვაჟა",
	  "ვარდო",
	  "ვარსკვლავისა",
	  "ვასიკო",
	  "ვასილ",
	  "ვატო",
	  "ვახო",
	  "ვახტანგ",
	  "ვენერა",
	  "ვერა",
	  "ვერიკო",
	  "ზაზა",
	  "ზაირა",
	  "ზაურ",
	  "ზეზვა",
	  "ზვიად",
	  "ზინა",
	  "ზოია",
	  "ზუკა",
	  "ზურა",
	  "ზურაბ",
	  "ზურია",
	  "ზურიკო",
	  "თაზო",
	  "თათა",
	  "თათია",
	  "თათული",
	  "თაია",
	  "თაკო",
	  "თალიკო",
	  "თამაზ",
	  "თამარ",
	  "თამარა",
	  "თამთა",
	  "თამთიკე",
	  "თამი",
	  "თამილა",
	  "თამრიკო",
	  "თამრო",
	  "თამუნა",
	  "თამჩო",
	  "თანანა",
	  "თანდილა",
	  "თაყა",
	  "თეა",
	  "თებრონე",
	  "თეიმურაზ",
	  "თემურ",
	  "თენგიზ",
	  "თენგო",
	  "თეონა",
	  "თიკა",
	  "თიკო",
	  "თიკუნა",
	  "თინა",
	  "თინათინ",
	  "თინიკო",
	  "თმაგიშერა",
	  "თორნიკე",
	  "თუთა",
	  "თუთია",
	  "ია",
	  "იათამზე",
	  "იამზე",
	  "ივანე",
	  "ივერი",
	  "ივქირიონ",
	  "იზოლდა",
	  "ილია",
	  "ილიკო",
	  "იმედა",
	  "ინგა",
	  "იოსებ",
	  "ირაკლი",
	  "ირინა",
	  "ირინე",
	  "ირინკა",
	  "ირმა",
	  "იური",
	  "კაკო",
	  "კალე",
	  "კატო",
	  "კახა",
	  "კახაბერ",
	  "კეკელა",
	  "კესანე",
	  "კესო",
	  "კვირია",
	  "კიტა",
	  "კობა",
	  "კოკა",
	  "კონსტანტინე",
	  "კოსტა",
	  "კოტე",
	  "კუკური",
	  "ლადო",
	  "ლალი",
	  "ლამაზა",
	  "ლამარა",
	  "ლამზირა",
	  "ლაშა",
	  "ლევან",
	  "ლეილა",
	  "ლელა",
	  "ლენა",
	  "ლერწამისა",
	  "ლექსო",
	  "ლია",
	  "ლიანა",
	  "ლიზა",
	  "ლიზიკო",
	  "ლილე",
	  "ლილი",
	  "ლილიკო",
	  "ლომია",
	  "ლუიზა",
	  "მაგული",
	  "მადონა",
	  "მათიკო",
	  "მაია",
	  "მაიკო",
	  "მაისა",
	  "მაკა",
	  "მაკო",
	  "მაკუნა",
	  "მალხაზ",
	  "მამამზე",
	  "მამია",
	  "მამისა",
	  "მამისთვალი",
	  "მამისიმედი",
	  "მამუკა",
	  "მამულა",
	  "მანანა",
	  "მანჩო",
	  "მარადი",
	  "მარი",
	  "მარია",
	  "მარიამი",
	  "მარიკა",
	  "მარინა",
	  "მარინე",
	  "მარიტა",
	  "მაყვალა",
	  "მაყვალა",
	  "მაშიკო",
	  "მაშო",
	  "მაცაცო",
	  "მგელია",
	  "მგელიკა",
	  "მედეა",
	  "მეკაშო",
	  "მელანო",
	  "მერაბ",
	  "მერი",
	  "მეტია",
	  "მზაღო",
	  "მზევინარ",
	  "მზეთამზე",
	  "მზეთვალა",
	  "მზეონა",
	  "მზექალა",
	  "მზეხა",
	  "მზეხათუნი",
	  "მზია",
	  "მზირა",
	  "მზისადარ",
	  "მზისთანადარი",
	  "მზიულა",
	  "მთვარისა",
	  "მინდია",
	  "მიშა",
	  "მიშიკო",
	  "მიხეილ",
	  "მნათობი",
	  "მნათობისა",
	  "მოგელი",
	  "მონავარდისა",
	  "მურმან",
	  "მუხრან",
	  "ნაზი",
	  "ნაზიკო",
	  "ნათელა",
	  "ნათია",
	  "ნაირა",
	  "ნანა",
	  "ნანი",
	  "ნანიკო",
	  "ნანუკა",
	  "ნანული",
	  "ნარგიზი",
	  "ნასყიდა",
	  "ნატალია",
	  "ნატო",
	  "ნელი",
	  "ნენე",
	  "ნესტან",
	  "ნია",
	  "ნიაკო",
	  "ნიკა",
	  "ნიკოლოზ",
	  "ნინა",
	  "ნინაკა",
	  "ნინი",
	  "ნინიკო",
	  "ნინო",
	  "ნინუკა",
	  "ნინუცა",
	  "ნოდარ",
	  "ნოდო",
	  "ნონა",
	  "ნორა",
	  "ნუგზარ",
	  "ნუგო",
	  "ნუკა",
	  "ნუკი",
	  "ნუკრი",
	  "ნუნუ",
	  "ნუნუ",
	  "ნუნუკა",
	  "ნუცა",
	  "ნუცი",
	  "ოთარ",
	  "ოთია",
	  "ოთო",
	  "ომარ",
	  "ორბელ",
	  "ოტია",
	  "ოქროპირ",
	  "პაატა",
	  "პაპუნა",
	  "პატარკაცი",
	  "პატარქალი",
	  "პეპელა",
	  "პირვარდისა",
	  "პირიმზე",
	  "ჟამიერა",
	  "ჟამიტა",
	  "ჟამუტა",
	  "ჟუჟუნა",
	  "რამაზ",
	  "რევაზ",
	  "რეზი",
	  "რეზო",
	  "როზა",
	  "რომან",
	  "რუსკა",
	  "რუსუდან",
	  "საბა",
	  "სალი",
	  "სალომე",
	  "სანათა",
	  "სანდრო",
	  "სერგო",
	  "სესია",
	  "სეხნია",
	  "სვეტლანა",
	  "სიხარულა",
	  "სოსო",
	  "სოფიკო",
	  "სოფიო",
	  "სოფო",
	  "სულა",
	  "სულიკო",
	  "ტარიელ",
	  "ტასიკო",
	  "ტასო",
	  "ტატიანა",
	  "ტატო",
	  "ტეტია",
	  "ტურია",
	  "უმანკო",
	  "უტა",
	  "უჩა",
	  "ფაქიზო",
	  "ფაცია",
	  "ფეფელა",
	  "ფეფენა",
	  "ფეფიკო",
	  "ფეფო",
	  "ფოსო",
	  "ფოფო",
	  "ქაბატო",
	  "ქავთარი",
	  "ქალია",
	  "ქართლოს",
	  "ქეთათო",
	  "ქეთევან",
	  "ქეთი",
	  "ქეთინო",
	  "ქეთო",
	  "ქველი",
	  "ქიტესა",
	  "ქიშვარდი",
	  "ქობული",
	  "ქრისტესია",
	  "ქტისტეფორე",
	  "ქურციკა",
	  "ღარიბა",
	  "ღვთისავარი",
	  "ღვთისია",
	  "ღვთისო",
	  "ღვინია",
	  "ღუღუნა",
	  "ყაითამზა",
	  "ყაყიტა",
	  "ყვარყვარე",
	  "ყიასა",
	  "შაბური",
	  "შაკო",
	  "შალვა",
	  "შალიკო",
	  "შანშე",
	  "შარია",
	  "შაქარა",
	  "შაქრო",
	  "შოთა",
	  "შორენა",
	  "შოშია",
	  "შუქია",
	  "ჩიორა",
	  "ჩიტო",
	  "ჩიტო",
	  "ჩოყოლა",
	  "ცაგო",
	  "ცაგული",
	  "ცანგალა",
	  "ცარო",
	  "ცაცა",
	  "ცაცო",
	  "ციალა",
	  "ციკო",
	  "ცინარა",
	  "ცირა",
	  "ცისანა",
	  "ცისია",
	  "ცისკარა",
	  "ცისკარი",
	  "ცისმარა",
	  "ცისმარი",
	  "ციური",
	  "ციცი",
	  "ციცია",
	  "ციცინო",
	  "ცოტნე",
	  "ცოქალა",
	  "ცუცა",
	  "ცხვარი",
	  "ძაბული",
	  "ძამისა",
	  "ძაღინა",
	  "ძიძია",
	  "წათე",
	  "წყალობა",
	  "ჭაბუკა",
	  "ჭიაბერ",
	  "ჭიკჭიკა",
	  "ჭიჭია",
	  "ჭიჭიკო",
	  "ჭოლა",
	  "ხათუნა",
	  "ხარება",
	  "ხატია",
	  "ხახულა",
	  "ხახუტა",
	  "ხეჩუა",
	  "ხვიჩა",
	  "ხიზანა",
	  "ხირხელა",
	  "ხობელასი",
	  "ხოხია",
	  "ხოხიტა",
	  "ხუტა",
	  "ხუცია",
	  "ჯაბა",
	  "ჯავახი",
	  "ჯარჯი",
	  "ჯემალ",
	  "ჯონდო",
	  "ჯოტო",
	  "ჯუბი",
	  "ჯულიეტა",
	  "ჯუმბერ",
	  "ჰამლეტ"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(801);
	name.last_name = __webpack_require__(803);
	name.prefix = __webpack_require__(805);
	name.title = __webpack_require__(806);
	name.name = __webpack_require__(804);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "აბაზაძე",
	  "აბაშიძე",
	  "აბრამაშვილი",
	  "აბუსერიძე",
	  "აბშილავა",
	  "ავაზნელი",
	  "ავალიშვილი",
	  "ამილახვარი",
	  "ანთაძე",
	  "ასლამაზიშვილი",
	  "ასპანიძე",
	  "აშკარელი",
	  "ახალბედაშვილი",
	  "ახალკაცი",
	  "ახვლედიანი",
	  "ბარათაშვილი",
	  "ბარდაველიძე",
	  "ბახტაძე",
	  "ბედიანიძე",
	  "ბერიძე",
	  "ბერუაშვილი",
	  "ბეჟანიშვილი",
	  "ბოგველიშვილი",
	  "ბოტკოველი",
	  "გაბრიჩიძე",
	  "გაგნიძე",
	  "გამრეკელი",
	  "გელაშვილი",
	  "გზირიშვილი",
	  "გიგაური",
	  "გურამიშვილი",
	  "გურგენიძე",
	  "დადიანი",
	  "დავითიშვილი",
	  "დათუაშვილი",
	  "დარბაისელი",
	  "დეკანოიძე",
	  "დვალი",
	  "დოლაბერიძე",
	  "ედიშერაშვილი",
	  "ელიზბარაშვილი",
	  "ელიოზაშვილი",
	  "ერისთავი",
	  "ვარამაშვილი",
	  "ვარდიაშვილი",
	  "ვაჩნაძე",
	  "ვარდანიძე",
	  "ველიაშვილი",
	  "ველიჯანაშვილი",
	  "ზარანდია",
	  "ზარიძე",
	  "ზედგინიძე",
	  "ზუბიაშვილი",
	  "თაბაგარი",
	  "თავდგირიძე",
	  "თათარაშვილი",
	  "თამაზაშვილი",
	  "თამარაშვილი",
	  "თაქთაქიშვილი",
	  "თაყაიშვილი",
	  "თბილელი",
	  "თუხარელი",
	  "იაშვილი",
	  "იგითხანიშვილი",
	  "ინასარიძე",
	  "იშხნელი",
	  "კანდელაკი",
	  "კაცია",
	  "კერესელიძე",
	  "კვირიკაშვილი",
	  "კიკნაძე",
	  "კლდიაშვილი",
	  "კოვზაძე",
	  "კოპაძე",
	  "კოპტონაშვილი",
	  "კოშკელაშვილი",
	  "ლაბაძე",
	  "ლეკიშვილი",
	  "ლიქოკელი",
	  "ლოლაძე",
	  "ლურსმანაშვილი",
	  "მაისურაძე",
	  "მარტოლეკი",
	  "მაღალაძე",
	  "მახარაშვილი",
	  "მგალობლიშვილი",
	  "მეგრელიშვილი",
	  "მელაშვილი",
	  "მელიქიძე",
	  "მერაბიშვილი",
	  "მეფარიშვილი",
	  "მუჯირი",
	  "მჭედლიძე",
	  "მხეიძე",
	  "ნათაძე",
	  "ნაჭყებია",
	  "ნოზაძე",
	  "ოდიშვილი",
	  "ონოფრიშვილი",
	  "პარეხელაშვილი",
	  "პეტრიაშვილი",
	  "სააკაძე",
	  "სააკაშვილი",
	  "საგინაშვილი",
	  "სადუნიშვილი",
	  "საძაგლიშვილი",
	  "სებისკვერიძე",
	  "სეთური",
	  "სუთიაშვილი",
	  "სულაშვილი",
	  "ტაბაღუა",
	  "ტყეშელაშვილი",
	  "ულუმბელაშვილი",
	  "უნდილაძე",
	  "ქავთარაძე",
	  "ქართველიშვილი",
	  "ყაზბეგი",
	  "ყაუხჩიშვილი",
	  "შავლაშვილი",
	  "შალიკაშვილი",
	  "შონია",
	  "ჩიბუხაშვილი",
	  "ჩიხრაძე",
	  "ჩიქოვანი",
	  "ჩუბინიძე",
	  "ჩოლოყაშვილი",
	  "ჩოხელი",
	  "ჩხვიმიანი",
	  "ცალუღელაშვილი",
	  "ცაძიკიძე",
	  "ციციშვილი",
	  "ციხელაშვილი",
	  "ციხისთავი",
	  "ცხოვრებაძე",
	  "ცხომარია",
	  "წამალაიძე",
	  "წერეთელი",
	  "წიკლაური",
	  "წიფურია",
	  "ჭაბუკაშვილი",
	  "ჭავჭავაძე",
	  "ჭანტურია",
	  "ჭარელიძე",
	  "ჭიორელი",
	  "ჭუმბურიძე",
	  "ხაბაზი",
	  "ხარაძე",
	  "ხარატიშვილი",
	  "ხარატასშვილი",
	  "ხარისჭირაშვილი",
	  "ხარხელაური",
	  "ხაშმელაშვილი",
	  "ხეთაგური",
	  "ხიზამბარელი",
	  "ხიზანიშვილი",
	  "ხიმშიაშვილი",
	  "ხოსრუაშვილი",
	  "ხოჯივანიშვილი",
	  "ხუციშვილი",
	  "ჯაბადარი",
	  "ჯავახი",
	  "ჯავახიშვილი",
	  "ჯანელიძე",
	  "ჯაფარიძე",
	  "ჯაყელი",
	  "ჯაჯანიძე",
	  "ჯვარელია",
	  "ჯინიუზაშვილი",
	  "ჯუღაშვილი"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ბ-ნი",
	  "ბატონი",
	  "ქ-ნი",
	  "ქალბატონი"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "გენერალური",
	    "მთავარი",
	    "სტაჟიორ",
	    "უმცროსი",
	    "ყოფილი",
	    "წამყვანი"
	  ],
	  "level": [
	    "აღრიცხვების",
	    "ბრენდინგის",
	    "ბრენიდს",
	    "ბუღალტერიის",
	    "განყოფილების",
	    "გაყიდვების",
	    "გუნდის",
	    "დახმარების",
	    "დიზაინის",
	    "თავდაცვის",
	    "ინფორმაციის",
	    "კვლევების",
	    "კომუნიკაციების",
	    "მარკეტინგის",
	    "ოპერაციათა",
	    "ოპტიმიზაციების",
	    "პიარ",
	    "პროგრამის",
	    "საქმეთა",
	    "ტაქტიკური",
	    "უსაფრთხოების",
	    "ფინანსთა",
	    "ქსელის",
	    "ხარისხის",
	    "ჯგუფის"
	  ],
	  "job": [
	    "აგენტი",
	    "ადვოკატი",
	    "ადმინისტრატორი",
	    "არქიტექტორი",
	    "ასისტენტი",
	    "აღმასრულებელი დირექტორი",
	    "დეველოპერი",
	    "დეკანი",
	    "დიზაინერი",
	    "დირექტორი",
	    "ელექტრიკოსი",
	    "ექსპერტი",
	    "ინჟინერი",
	    "იურისტი",
	    "კონსტრუქტორი",
	    "კონსულტანტი",
	    "კოორდინატორი",
	    "ლექტორი",
	    "მასაჟისტი",
	    "მემანქანე",
	    "მენეჯერი",
	    "მძღოლი",
	    "მწვრთნელი",
	    "ოპერატორი",
	    "ოფიცერი",
	    "პედაგოგი",
	    "პოლიციელი",
	    "პროგრამისტი",
	    "პროდიუსერი",
	    "პრორექტორი",
	    "ჟურნალისტი",
	    "რექტორი",
	    "სპეციალისტი",
	    "სტრატეგისტი",
	    "ტექნიკოსი",
	    "ფოტოგრაფი",
	    "წარმომადგენელი"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "5##-###-###",
	  "5########",
	  "5## ## ## ##",
	  "5## ######",
	  "5## ### ###",
	  "995 5##-###-###",
	  "995 5########",
	  "995 5## ## ## ##",
	  "995 5## ######",
	  "995 5## ### ###",
	  "+995 5##-###-###",
	  "+995 5########",
	  "+995 5## ## ## ##",
	  "+995 5## ######",
	  "+995 5## ### ###",
	  "(+995) 5##-###-###",
	  "(+995) 5########",
	  "(+995) 5## ## ## ##",
	  "(+995) 5## ######",
	  "(+995) 5## ### ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(807);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [  
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Airmadidi",
	  "Ampana",
	  "Amurang",
	  "Andolo",
	  "Banggai",
	  "Bantaeng",
	  "Barru",
	  "Bau-Bau",
	  "Benteng",
	  "Bitung",
	  "Bolaang Uki",
	  "Boroko",
	  "Bulukumba",
	  "Bungku",
	  "Buol",
	  "Buranga",
	  "Donggala",
	  "Enrekang",
	  "Gorontalo",
	  "Jeneponto",
	  "Kawangkoan",
	  "Kendari",
	  "Kolaka",
	  "Kotamobagu",
	  "Kota Raha",
	  "Kwandang",
	  "Lasusua",
	  "Luwuk",
	  "Majene",
	  "Makale",
	  "Makassar",
	  "Malili",
	  "Mamasa",
	  "Mamuju",
	  "Manado",
	  "Marisa",
	  "Maros",
	  "Masamba",
	  "Melonguane",
	  "Ondong Siau",
	  "Palopo",
	  "Palu",
	  "Pangkajene",
	  "Pare-Pare",
	  "Parigi",
	  "Pasangkayu",
	  "Pinrang",
	  "Polewali",
	  "Poso",
	  "Rantepao",
	  "Ratahan",
	  "Rumbia",
	  "Sengkang",
	  "Sidenreng",
	  "Sigi Biromaru",
	  "Sinjai",
	  "Sunggu Minasa",
	  "Suwawa",
	  "Tahuna",
	  "Takalar",
	  "Tilamuta",
	  "Toli Toli",
	  "Tomohon",
	  "Tondano",
	  "Tutuyan",
	  "Unaaha",
	  "Wangi Wangi",
	  "Wanggudu",
	  "Watampone",
	  "Watan Soppeng",
	  "Ambarawa",
	  "Anyer",
	  "Bandung",
	  "Bangil",
	  "Banjar (Jawa Barat)",
	  "Banjarnegara",
	  "Bangkalan",
	  "Bantul",
	  "Banyumas",
	  "Banyuwangi",
	  "Batang",
	  "Batu",
	  "Bekasi",
	  "Blitar",
	  "Blora",
	  "Bogor",
	  "Bojonegoro",
	  "Bondowoso",
	  "Boyolali",
	  "Bumiayu",
	  "Brebes",
	  "Caruban",
	  "Cianjur",
	  "Ciamis",
	  "Cibinong",
	  "Cikampek",
	  "Cikarang",
	  "Cilacap",
	  "Cilegon",
	  "Cirebon",
	  "Demak",
	  "Depok",
	  "Garut",
	  "Gresik",
	  "Indramayu",
	  "Jakarta",
	  "Jember",
	  "Jepara",
	  "Jombang",
	  "Kajen",
	  "Karanganyar",
	  "Kebumen",
	  "Kediri",
	  "Kendal",
	  "Kepanjen",
	  "Klaten",
	  "Pelabuhan Ratu",
	  "Kraksaan",
	  "Kudus",
	  "Kuningan",
	  "Lamongan",
	  "Lumajang",
	  "Madiun",
	  "Magelang",
	  "Magetan",
	  "Majalengka",
	  "Malang",
	  "Mojokerto",
	  "Mojosari",
	  "Mungkid",
	  "Ngamprah",
	  "Nganjuk",
	  "Ngawi",
	  "Pacitan",
	  "Pamekasan",
	  "Pandeglang",
	  "Pare",
	  "Pati",
	  "Pasuruan",
	  "Pekalongan",
	  "Pemalang",
	  "Ponorogo",
	  "Probolinggo",
	  "Purbalingga",
	  "Purwakarta",
	  "Purwodadi",
	  "Purwokerto",
	  "Purworejo",
	  "Rangkasbitung",
	  "Rembang",
	  "Salatiga",
	  "Sampang",
	  "Semarang",
	  "Serang",
	  "Sidayu",
	  "Sidoarjo",
	  "Singaparna",
	  "Situbondo",
	  "Slawi",
	  "Sleman",
	  "Soreang",
	  "Sragen",
	  "Subang",
	  "Sukabumi",
	  "Sukoharjo",
	  "Sumber",
	  "Sumedang",
	  "Sumenep",
	  "Surabaya",
	  "Surakarta",
	  "Tasikmalaya",
	  "Tangerang",
	  "Tangerang Selatan",
	  "Tegal",
	  "Temanggung",
	  "Tigaraksa",
	  "Trenggalek",
	  "Tuban",
	  "Tulungagung",
	  "Ungaran",
	  "Wates",
	  "Wlingi",
	  "Wonogiri",
	  "Wonosari",
	  "Wonosobo",
	  "Yogyakarta",
	  "Atambua",
	  "Baa",
	  "Badung",
	  "Bajawa",
	  "Bangli",
	  "Bima",
	  "Denpasar",
	  "Dompu",
	  "Ende",
	  "Gianyar",
	  "Kalabahi",
	  "Karangasem",
	  "Kefamenanu",
	  "Klungkung",
	  "Kupang",
	  "Labuhan Bajo",
	  "Larantuka",
	  "Lewoleba",
	  "Maumere",
	  "Mataram",
	  "Mbay",
	  "Negara",
	  "Praya",
	  "Raba",
	  "Ruteng",
	  "Selong",
	  "Singaraja",
	  "Soe",
	  "Sumbawa Besar",
	  "Tabanan",
	  "Taliwang",
	  "Tambolaka",
	  "Tanjung",
	  "Waibakul",
	  "Waikabubak",
	  "Waingapu",
	  "Denpasar",
	  "Negara,Bali",
	  "Singaraja",
	  "Tabanan",
	  "Bangli"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Indonesia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.building_number = __webpack_require__(809);
	address.postcode = __webpack_require__(814);
	address.state = __webpack_require__(815);
	address.city_name = __webpack_require__(811);
	address.city = __webpack_require__(810);
	address.street_prefix = __webpack_require__(818);
	address.street_name = __webpack_require__(817);
	address.street_address = __webpack_require__(816);
	address.default_country = __webpack_require__(812);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aceh",
	  "Sumatera Utara",
	  "Sumatera Barat",
	  "Jambi",
	  "Bangka Belitung",
	  "Riau",
	  "Kepulauan Riau",
	  "Bengkulu",
	  "Sumatera Selatan",
	  "Lampung",
	  "Banten",
	  "DKI Jakarta",
	  "Jawa Barat",
	  "Jawa Tengah",
	  "Jawa Timur",
	  "Nusa Tenggara Timur",
	  "DI Yogyakarta",
	  "Bali",
	  "Nusa Tenggara Barat",
	  "Kalimantan Barat",
	  "Kalimantan Tengah",
	  "Kalimantan Selatan",
	  "Kalimantan Timur",
	  "Kalimantan Utara",
	  "Sulawesi Selatan",
	  "Sulawesi Utara",
	  "Gorontalo",
	  "Sulawesi Tengah",
	  "Sulawesi Barat",
	  "Sulawesi Tenggara",
	  "Maluku",
	  "Maluku Utara",
	  "Papua Barat",
	  "Papua"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} no #{building_number}"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_prefix} #{Name.first_name}",
	  "#{street_prefix} #{Name.last_name}"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ds.",
	  "Dk.",
	  "Gg.",
	  "Jln.",
	  "Jr.",
	  "Kpg.",
	  "Ki.",
	  "Psr."
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.prefix = __webpack_require__(821);
	company.suffix = __webpack_require__(822);
	company.name = __webpack_require__(820);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{Name.last_name}",
	  "#{Name.last_name} #{suffix}",
	  "#{prefix} #{Name.last_name} #{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "PT",
	  "CV",
	  "UD",
	  "PD",
	  "Perum"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(Persero) Tbk",
	  "Tbk"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var date = {};
	module["exports"] = date;
	date.month = __webpack_require__(824);
	date.weekday = __webpack_require__(825);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  wide: [
	    "Januari",
	    "Februari",
	    "Maret",
	    "April",
	    "Mei",
	    "Juni",
	    "Juli",
	    "Agustus",
	    "September",
	    "Oktober",
	    "November",
	    "Desember"
	  ],
	  wide_context: [
	    "Januari",
	    "Februari",
	    "Maret",
	    "April",
	    "Mei",
	    "Juni",
	    "Juli",
	    "Agustus",
	    "September",
	    "Oktober",
	    "November",
	    "Desember"
	  ],
	  abbr: [
	    "Jan",
	    "Feb",
	    "Mar",
	    "Apr",
	    "Mei",
	    "Jun",
	    "Jul",
	    "Ags",
	    "Sep",
	    "Okt",
	    "Nov",
	    "Des"
	  ],
	  abbr_context: [
	    "Jan",
	    "Feb",
	    "Mar",
	    "Apr",
	    "Mei",
	    "Jun",
	    "Jul",
	    "Ags",
	    "Sep",
	    "Okt",
	    "Nov",
	    "Des"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  wide: [
	    "Minggu",
	    "Senin",
	    "Selasa",
	    "Rabu",
	    "Kamis",
	    "Jumat",
	    "Sabtu"
	  ],
	  wide_context: [
	    "Minggu",
	    "Senin",
	    "Selasa",
	    "Rabu",
	    "Kamis",
	    "Jumat",
	    "Sabtu"
	  ],
	  abbr: [
	    "Min",
	    "Sen",
	    "Sel",
	    "Rab",
	    "Kam",
	    "Jum",
	    "Sab"
	  ],
	  abbr_context: [
	    "Min",
	    "Sen",
	    "Sel",
	    "Rab",
	    "Kam",
	    "Jum",
	    "Sab"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var id = {};
	module['exports'] = id;
	id.title = "Indonesia";
	id.address = __webpack_require__(813);
	id.company = __webpack_require__(819);
	id.internet = __webpack_require__(829);
	id.date = __webpack_require__(823);
	id.name = __webpack_require__(832);
	id.phone_number = __webpack_require__(839);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "net",
	  "org",
	  "asia",
	  "tv",
	  "biz",
	  "info",
	  "in",
	  "name",
	  "co",
	  "ac.id",
	  "sch.id",
	  "go.id",
	  "mil.id",
	  "co.id",
	  "or.id",
	  "web.id",
	  "my.id",
	  "biz.id",
	  "desa.id"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  'gmail.com',
	  'yahoo.com',
	  'gmail.co.id',
	  'yahoo.co.id'
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(828);
	internet.domain_suffix = __webpack_require__(827);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ade",
	  "Agnes",
	  "Ajeng",
	  "Amalia",
	  "Anita",
	  "Ayu",
	  "Aisyah",
	  "Ana",
	  "Ami",
	  "Ani",
	  "Azalea",
	  "Aurora",
	  "Alika",
	  "Anastasia",
	  "Amelia",
	  "Almira",
	  "Bella",
	  "Betania",
	  "Belinda",
	  "Citra",
	  "Cindy",
	  "Chelsea",
	  "Clara",
	  "Cornelia",
	  "Cinta",
	  "Cinthia",
	  "Ciaobella",
	  "Cici",
	  "Carla",
	  "Calista",
	  "Devi",
	  "Dewi","Dian",
	  "Diah",
	  "Diana",
	  "Dina",
	  "Dinda",
	  "Dalima",
	  "Eka",
	  "Eva",
	  "Endah",
	  "Elisa",
	  "Eli",
	  "Ella",
	  "Ellis",
	  "Elma",
	  "Elvina",
	  "Fitria",
	  "Fitriani",
	  "Febi",
	  "Faizah",
	  "Farah",
	  "Farhunnisa",
	  "Fathonah",
	  "Gabriella",
	  "Gasti",
	  "Gawati",
	  "Genta",
	  "Ghaliyati",
	  "Gina",
	  "Gilda",
	  "Halima",
	  "Hesti",
	  "Hilda",
	  "Hafshah",
	  "Hamima",
	  "Hana",
	  "Hani",
	  "Hasna",
	  "Humaira",
	  "Ika",
	  "Indah",
	  "Intan",
	  "Irma",
	  "Icha",
	  "Ida",
	  "Ifa",
	  "Ilsa",
	  "Ina",
	  "Ira",
	  "Iriana",
	  "Jamalia",
	  "Janet",
	  "Jane",
	  "Julia",
	  "Juli",
	  "Jessica",
	  "Jasmin",
	  "Jelita",
	  "Kamaria",
	  "Kamila",
	  "Kani",
	  "Karen",
	  "Karimah",
	  "Kartika",
	  "Kasiyah",
	  "Keisha",
	  "Kezia",
	  "Kiandra",
	  "Kayla",
	  "Kania",
	  "Lala",
	  "Lalita",
	  "Latika",
	  "Laila",
	  "Laras",
	  "Lidya",
	  "Lili",
	  "Lintang",
	  "Maria",
	  "Mala",
	  "Maya",
	  "Maida",
	  "Maimunah",
	  "Melinda",
	  "Mila",
	  "Mutia",
	  "Michelle",
	  "Malika",
	  "Nadia",
	  "Nadine",
	  "Nabila",
	  "Natalia",
	  "Novi",
	  "Nova",
	  "Nurul",
	  "Nilam",
	  "Najwa",
	  "Olivia",
	  "Ophelia",
	  "Oni",
	  "Oliva",
	  "Padma",
	  "Putri",
	  "Paramita",
	  "Paris",
	  "Patricia",
	  "Paulin",
	  "Puput",
	  "Puji",
	  "Pia",
	  "Puspa",
	  "Puti",
	  "Putri",
	  "Padmi",
	  "Qori",
	  "Queen",
	  "Ratih",
	  "Ratna",
	  "Restu",
	  "Rini",
	  "Rika",
	  "Rina",
	  "Rahayu",
	  "Rahmi",
	  "Rachel",
	  "Rahmi",
	  "Raisa",
	  "Raina",
	  "Sarah",
	  "Sari",
	  "Siti",
	  "Siska",
	  "Suci",
	  "Syahrini",
	  "Septi",
	  "Sadina",
	  "Safina",
	  "Sakura",
	  "Salimah",
	  "Salwa",
	  "Salsabila",
	  "Samiah",
	  "Shania",
	  "Sabrina",
	  "Silvia",
	  "Shakila",
	  "Talia",
	  "Tami",
	  "Tira",
	  "Tiara",
	  "Titin",
	  "Tania",
	  "Tina",
	  "Tantri",
	  "Tari",
	  "Titi",
	  "Uchita",
	  "Unjani",
	  "Ulya",
	  "Uli",
	  "Ulva",
	  "Umi",
	  "Usyi",
	  "Vanya",
	  "Vanesa",
	  "Vivi",
	  "Vera",
	  "Vicky",
	  "Victoria",
	  "Violet",
	  "Winda",
	  "Widya",
	  "Wulan",
	  "Wirda",
	  "Wani",
	  "Yani",
	  "Yessi",
	  "Yulia",
	  "Yuliana",
	  "Yuni",
	  "Yunita",
	  "Yance",
	  "Zahra",
	  "Zalindra",
	  "Zaenab",
	  "Zulfa",
	  "Zizi",
	  "Zulaikha",
	  "Zamira",
	  "Zelda",
	  "Zelaya"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Agustina",
	  "Andriani",
	  "Anggraini",
	  "Aryani",
	  "Astuti",
	  "Fujiati",
	  "Farida",
	  "Handayani",
	  "Hassanah",
	  "Hartati",
	  "Hasanah",
	  "Haryanti",
	  "Hariyah",
	  "Hastuti",
	  "Halimah",
	  "Kusmawati",
	  "Kuswandari",
	  "Laksmiwati",
	  "Laksita",
	  "Lestari",
	  "Lailasari",
	  "Mandasari",
	  "Mardhiyah",
	  "Mayasari",
	  "Melani",
	  "Mulyani",
	  "Maryati",
	  "Nurdiyanti",
	  "Novitasari",
	  "Nuraini",
	  "Nasyidah",
	  "Nasyiah",
	  "Namaga",
	  "Palastri",
	  "Pudjiastuti",
	  "Puspasari",
	  "Puspita",
	  "Purwanti",
	  "Pratiwi",
	  "Purnawati",
	  "Pertiwi",
	  "Permata",
	  "Prastuti",
	  "Padmasari",
	  "Rahmawati",
	  "Rahayu",
	  "Riyanti",
	  "Rahimah",
	  "Suartini",
	  "Sudiati",
	  "Suryatmi",
	  "Susanti",
	  "Safitri",
	  "Oktaviani",
	  "Utami",
	  "Usamah",
	  "Usada",
	  "Uyainah",
	  "Yuniar",
	  "Yuliarti",
	  "Yulianti",
	  "Yolanda",
	  "Wahyuni",
	  "Wijayanti",
	  "Widiastuti",
	  "Winarsih",
	  "Wulandari",
	  "Wastuti",
	  "Zulaika"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.male_first_name = __webpack_require__(833);
	name.male_last_name = __webpack_require__(834);
	name.female_first_name = __webpack_require__(830);
	name.female_last_name = __webpack_require__(831);
	name.prefix = __webpack_require__(836);
	name.suffix = __webpack_require__(837);
	name.name = __webpack_require__(835);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abyasa",
	  "Ade",
	  "Adhiarja",
	  "Adiarja",
	  "Adika",
	  "Adikara",
	  "Adinata",
	  "Aditya",
	  "Agus",
	  "Ajiman",
	  "Ajimat",
	  "Ajimin",
	  "Ajiono",
	  "Akarsana",
	  "Alambana",
	  "Among",
	  "Anggabaya",
	  "Anom",
	  "Argono",
	  "Aris",
	  "Arta",
	  "Artanto",
	  "Artawan",
	  "Arsipatra",
	  "Asirwada",
	  "Asirwanda",
	  "Aslijan",
	  "Asmadi",
	  "Asman",
	  "Asmianto",
	  "Asmuni",
	  "Aswani",
	  "Atma",
	  "Atmaja",
	  "Bagas",
	  "Bagiya",
	  "Bagus",
	  "Bagya",
	  "Bahuraksa",
	  "Bahuwarna",
	  "Bahuwirya",
	  "Bajragin",
	  "Bakda",
	  "Bakiadi",
	  "Bakianto",
	  "Bakidin",
	  "Bakijan",
	  "Bakiman",
	  "Bakiono",
	  "Bakti",
	  "Baktiadi",
	  "Baktianto",
	  "Baktiono",
	  "Bala",
	  "Balamantri",
	  "Balangga",
	  "Balapati",
	  "Balidin",
	  "Balijan",
	  "Bambang",
	  "Banara",
	  "Banawa",
	  "Banawi",
	  "Bancar",
	  "Budi",
	  "Cagak",
	  "Cager",
	  "Cahyadi",
	  "Cahyanto",
	  "Cahya",
	  "Cahyo",
	  "Cahyono",
	  "Caket",
	  "Cakrabirawa",
	  "Cakrabuana",
	  "Cakrajiya",
	  "Cakrawala",
	  "Cakrawangsa",
	  "Candra",
	  "Chandra",
	  "Candrakanta",
	  "Capa",
	  "Caraka",
	  "Carub",
	  "Catur",
	  "Caturangga",
	  "Cawisadi",
	  "Cawisono",
	  "Cawuk",
	  "Cayadi",
	  "Cecep",
	  "Cemani",
	  "Cemeti",
	  "Cemplunk",
	  "Cengkal",
	  "Cengkir",
	  "Dacin",
	  "Dadap",
	  "Dadi",
	  "Dagel",
	  "Daliman",
	  "Dalimin",
	  "Daliono",
	  "Damar",
	  "Damu",
	  "Danang",
	  "Daniswara",
	  "Danu",
	  "Danuja",
	  "Dariati",
	  "Darijan",
	  "Darimin",
	  "Darmaji",
	  "Darman",
	  "Darmana",
	  "Darmanto",
	  "Darsirah",
	  "Dartono",
	  "Daru",
	  "Daruna",
	  "Daryani",
	  "Dasa",
	  "Digdaya",
	  "Dimas",
	  "Dimaz",
	  "Dipa",
	  "Dirja",
	  "Drajat",
	  "Dwi",
	  "Dono",
	  "Dodo",
	  "Edi",
	  "Eka",
	  "Elon",
	  "Eluh",
	  "Eman",
	  "Emas",
	  "Embuh",
	  "Emong",
	  "Empluk",
	  "Endra",
	  "Enteng",
	  "Estiawan",
	  "Estiono",
	  "Eko",
	  "Edi",
	  "Edison",
	  "Edward",
	  "Elvin",
	  "Erik",
	  "Emil",
	  "Ega",
	  "Emin",
	  "Eja",
	  "Gada",
	  "Gadang",
	  "Gaduh",
	  "Gaiman",
	  "Galak",
	  "Galang",
	  "Galar",
	  "Galih",
	  "Galiono",
	  "Galuh",
	  "Galur",
	  "Gaman",
	  "Gamani",
	  "Gamanto",
	  "Gambira",
	  "Gamblang",
	  "Ganda",
	  "Gandewa",
	  "Gandi",
	  "Gandi",
	  "Ganep",
	  "Gangsa",
	  "Gangsar",
	  "Ganjaran",
	  "Gantar",
	  "Gara",
	  "Garan",
	  "Garang",
	  "Garda",
	  "Gatot",
	  "Gatra",
	  "Gilang",
	  "Galih",
	  "Ghani",
	  "Gading",
	  "Hairyanto",
	  "Hardana",
	  "Hardi",
	  "Harimurti",
	  "Harja",
	  "Harjasa",
	  "Harjaya",
	  "Harjo",
	  "Harsana",
	  "Harsanto",
	  "Harsaya",
	  "Hartaka",
	  "Hartana",
	  "Harto",
	  "Hasta",
	  "Heru",
	  "Himawan",
	  "Hadi",
	  "Halim",
	  "Hasim",
	  "Hasan",
	  "Hendra",
	  "Hendri",
	  "Heryanto",
	  "Hamzah",
	  "Hari",
	  "Imam",
	  "Indra",
	  "Irwan",
	  "Irsad",
	  "Ikhsan",
	  "Irfan",
	  "Ian",
	  "Ibrahim",
	  "Ibrani",
	  "Ismail",
	  "Irnanto",
	  "Ilyas",
	  "Ibun",
	  "Ivan",
	  "Ikin",
	  "Ihsan",
	  "Jabal",
	  "Jaeman",
	  "Jaga",
	  "Jagapati",
	  "Jagaraga",
	  "Jail",
	  "Jaiman",
	  "Jaka",
	  "Jarwa",
	  "Jarwadi",
	  "Jarwi",
	  "Jasmani",
	  "Jaswadi",
	  "Jati",
	  "Jatmiko",
	  "Jaya",
	  "Jayadi",
	  "Jayeng",
	  "Jinawi",
	  "Jindra",
	  "Joko",
	  "Jumadi",
	  "Jumari",
	  "Jamal",
	  "Jamil",
	  "Jais",
	  "Jefri",
	  "Johan",
	  "Jono",
	  "Kacung",
	  "Kajen",
	  "Kambali",
	  "Kamidin",
	  "Kariman",
	  "Karja",
	  "Karma",
	  "Karman",
	  "Karna",
	  "Karsa",
	  "Karsana",
	  "Karta",
	  "Kasiran",
	  "Kasusra",
	  "Kawaca",
	  "Kawaya",
	  "Kayun",
	  "Kemba",
	  "Kenari",
	  "Kenes",
	  "Kuncara",
	  "Kunthara",
	  "Kusuma",
	  "Kadir",
	  "Kala",
	  "Kalim",
	  "Kurnia",
	  "Kanda",
	  "Kardi",
	  "Karya",
	  "Kasim",
	  "Kairav",
	  "Kenzie",
	  "Kemal",
	  "Kamal",
	  "Koko",
	  "Labuh",
	  "Laksana",
	  "Lamar",
	  "Lanang",
	  "Langgeng",
	  "Lanjar",
	  "Lantar",
	  "Lega",
	  "Legawa",
	  "Lembah",
	  "Liman",
	  "Limar",
	  "Luhung",
	  "Lukita",
	  "Luluh",
	  "Lulut",
	  "Lurhur",
	  "Luwar",
	  "Luwes",
	  "Latif",
	  "Lasmanto",
	  "Lukman",
	  "Luthfi",
	  "Leo",
	  "Luis",
	  "Lutfan",
	  "Lasmono",
	  "Laswi",
	  "Mahesa",
	  "Makara",
	  "Makuta",
	  "Manah",
	  "Maras",
	  "Margana",
	  "Mariadi",
	  "Marsudi",
	  "Martaka",
	  "Martana",
	  "Martani",
	  "Marwata",
	  "Maryadi",
	  "Maryanto",
	  "Mitra",
	  "Mujur",
	  "Mulya",
	  "Mulyanto",
	  "Mulyono",
	  "Mumpuni",
	  "Muni",
	  "Mursita",
	  "Murti",
	  "Mustika",
	  "Maman",
	  "Mahmud",
	  "Mahdi",
	  "Mahfud",
	  "Malik",
	  "Muhammad",
	  "Mustofa",
	  "Marsito",
	  "Mursinin",
	  "Nalar",
	  "Naradi",
	  "Nardi",
	  "Niyaga",
	  "Nrima",
	  "Nugraha",
	  "Nyana",
	  "Narji",
	  "Nasab",
	  "Nasrullah",
	  "Nasim",
	  "Najib",
	  "Najam",
	  "Nyoman",
	  "Olga",
	  "Ozy",
	  "Omar",
	  "Opan",
	  "Oskar",
	  "Oman",
	  "Okto",
	  "Okta",
	  "Opung",
	  "Paiman",
	  "Panca",
	  "Pangeran",
	  "Pangestu",
	  "Pardi",
	  "Parman",
	  "Perkasa",
	  "Praba",
	  "Prabu",
	  "Prabawa",
	  "Prabowo",
	  "Prakosa",
	  "Pranata",
	  "Pranawa",
	  "Prasetya",
	  "Prasetyo",
	  "Prayitna",
	  "Prayoga",
	  "Prayogo",
	  "Purwadi",
	  "Purwa",
	  "Purwanto",
	  "Panji",
	  "Pandu",
	  "Paiman",
	  "Prima",
	  "Putu",
	  "Raden",
	  "Raditya",
	  "Raharja",
	  "Rama",
	  "Rangga",
	  "Reksa",
	  "Respati",
	  "Rusman",
	  "Rosman",
	  "Rahmat",
	  "Rahman",
	  "Rendy",
	  "Reza",
	  "Rizki",
	  "Ridwan",
	  "Rudi",
	  "Raden",
	  "Radit",
	  "Radika",
	  "Rafi",
	  "Rafid",
	  "Raihan",
	  "Salman",
	  "Saadat",
	  "Saiful",
	  "Surya",
	  "Slamet",
	  "Samsul",
	  "Soleh",
	  "Simon",
	  "Sabar",
	  "Sabri",
	  "Sidiq",
	  "Satya",
	  "Setya",
	  "Saka",
	  "Sakti",
	  "Taswir",
	  "Tedi",
	  "Teddy",
	  "Taufan",
	  "Taufik",
	  "Tomi",
	  "Tasnim",
	  "Teguh",
	  "Tasdik",
	  "Timbul",
	  "Tirta",
	  "Tirtayasa",
	  "Tri",
	  "Tugiman",
	  "Umar",
	  "Usman",
	  "Uda",
	  "Umay",
	  "Unggul",
	  "Utama",
	  "Umaya",
	  "Upik",
	  "Viktor",
	  "Vino",
	  "Vinsen",
	  "Vero",
	  "Vega",
	  "Viman",
	  "Virman",
	  "Wahyu",
	  "Wira",
	  "Wisnu",
	  "Wadi",
	  "Wardi",
	  "Warji",
	  "Waluyo",
	  "Wakiman",
	  "Wage",
	  "Wardaya",
	  "Warsa",
	  "Warsita",
	  "Warta",
	  "Wasis",
	  "Wawan",
	  "Xanana",
	  "Yahya",
	  "Yusuf",
	  "Yosef",
	  "Yono",
	  "Yoga"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adriansyah",
	  "Ardianto",
	  "Anggriawan",
	  "Budiman",
	  "Budiyanto",
	  "Damanik",
	  "Dongoran",
	  "Dabukke",
	  "Firmansyah",
	  "Firgantoro",
	  "Gunarto",
	  "Gunawan",
	  "Hardiansyah",
	  "Habibi",
	  "Hakim",
	  "Halim",
	  "Haryanto",
	  "Hidayat",
	  "Hidayanto",
	  "Hutagalung",
	  "Hutapea",
	  "Hutasoit",
	  "Irawan",
	  "Iswahyudi",
	  "Kuswoyo",
	  "Januar",
	  "Jailani",
	  "Kurniawan",
	  "Kusumo",
	  "Latupono",
	  "Lazuardi",
	  "Maheswara",
	  "Mahendra",
	  "Mustofa",
	  "Mansur",
	  "Mandala",
	  "Megantara",
	  "Maulana",
	  "Maryadi",
	  "Mangunsong",
	  "Manullang",
	  "Marpaung",
	  "Marbun",
	  "Narpati",
	  "Natsir",
	  "Nugroho",
	  "Najmudin",
	  "Nashiruddin",
	  "Nainggolan",
	  "Nababan",
	  "Napitupulu",
	  "Pangestu",
	  "Putra",
	  "Pranowo",
	  "Prabowo",
	  "Pratama",
	  "Prasetya",
	  "Prasetyo",
	  "Pradana",
	  "Pradipta",
	  "Prakasa",
	  "Permadi",
	  "Prasasta",
	  "Prayoga",
	  "Ramadan",
	  "Rajasa",
	  "Rajata",
	  "Saptono",
	  "Santoso",
	  "Saputra",
	  "Saefullah",
	  "Setiawan",
	  "Suryono",
	  "Suwarno",
	  "Siregar",
	  "Sihombing",
	  "Salahudin",
	  "Sihombing",
	  "Samosir",
	  "Saragih",
	  "Sihotang",
	  "Simanjuntak",
	  "Sinaga",
	  "Simbolon",
	  "Sitompul",
	  "Sitorus",
	  "Sirait",
	  "Siregar",
	  "Situmorang",
	  "Tampubolon",
	  "Thamrin",
	  "Tamba",
	  "Tarihoran",
	  "Utama",
	  "Uwais",
	  "Wahyudin",
	  "Waluyo",
	  "Wibowo",
	  "Winarno",
	  "Wibisono",
	  "Wijaya",
	  "Widodo",
	  "Wacana",
	  "Waskita",
	  "Wasita",
	  "Zulkarnain"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{male_first_name} #{male_last_name}",
	  "#{male_last_name} #{male_first_name}",
	  "#{male_first_name} #{male_first_name} #{male_last_name}",
	  "#{female_first_name} #{female_last_name}",
	  "#{female_first_name} #{male_last_name}",
	  "#{female_last_name} #{female_first_name}",
	  "#{female_first_name} #{female_first_name} #{female_last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "S.Ked",
	  "S.Gz",
	  "S.Pt",
	  "S.IP",
	  "S.E.I",
	  "S.E.",
	  "S.Kom",
	  "S.H.",
	  "S.T.",
	  "S.Pd",
	  "S.Psi",
	  "S.I.Kom",
	  "S.Sos",
	  "S.Farm",
	  "M.M.",
	  "M.Kom.",
	  "M.TI.",
	  "M.Pd",
	  "M.Farm",
	  "M.Ak"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "02# #### ###",
	  "02## #### ###",
	  "03## #### ###",
	  "04## #### ###",
	  "05## #### ###",
	  "06## #### ###",
	  "07## #### ###",
	  "09## #### ###",
	  "02# #### ####",
	  "02## #### ####",
	  "03## #### ####",
	  "04## #### ####",
	  "05## #### ####",
	  "06## #### ####",
	  "07## #### ####",
	  "09## #### ####",
	  "08## ### ###",
	  "08## #### ###",
	  "08## #### ####",
	  "(+62) 8## ### ###",
	  "(+62) 2# #### ###",
	  "(+62) 2## #### ###",
	  "(+62) 3## #### ###",
	  "(+62) 4## #### ###",
	  "(+62) 5## #### ###",
	  "(+62) 6## #### ###",
	  "(+62) 7## #### ###",
	  "(+62) 8## #### ###",
	  "(+62) 9## #### ###",
	  "(+62) 2# #### ####",
	  "(+62) 2## #### ####",
	  "(+62) 3## #### ####",
	  "(+62) 4## #### ####",
	  "(+62) 5## #### ####",
	  "(+62) 6## #### ####",
	  "(+62) 7## #### ####",
	  "(+62) 8## #### ####",
	  "(+62) 9## #### ####"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(838);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###",
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix} #{Name.first_name} #{city_suffix}",
	  "#{city_prefix} #{Name.first_name}",
	  "#{Name.first_name} #{city_suffix}",
	  "#{Name.last_name} #{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "San",
	  "Borgo",
	  "Sesto",
	  "Quarto",
	  "Settimo"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "a mare",
	  "lido",
	  "ligure",
	  "del friuli",
	  "salentino",
	  "calabro",
	  "veneto",
	  "nell'emilia",
	  "umbro",
	  "laziale",
	  "terme",
	  "sardo"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afghanistan",
	  "Albania",
	  "Algeria",
	  "American Samoa",
	  "Andorra",
	  "Angola",
	  "Anguilla",
	  "Antartide (territori a sud del 60° parallelo)",
	  "Antigua e Barbuda",
	  "Argentina",
	  "Armenia",
	  "Aruba",
	  "Australia",
	  "Austria",
	  "Azerbaijan",
	  "Bahamas",
	  "Bahrain",
	  "Bangladesh",
	  "Barbados",
	  "Bielorussia",
	  "Belgio",
	  "Belize",
	  "Benin",
	  "Bermuda",
	  "Bhutan",
	  "Bolivia",
	  "Bosnia e Herzegovina",
	  "Botswana",
	  "Bouvet Island (Bouvetoya)",
	  "Brasile",
	  "Territorio dell'arcipelago indiano",
	  "Isole Vergini Britanniche",
	  "Brunei Darussalam",
	  "Bulgaria",
	  "Burkina Faso",
	  "Burundi",
	  "Cambogia",
	  "Cameroon",
	  "Canada",
	  "Capo Verde",
	  "Isole Cayman",
	  "Repubblica Centrale Africana",
	  "Chad",
	  "Cile",
	  "Cina",
	  "Isola di Pasqua",
	  "Isola di Cocos (Keeling)",
	  "Colombia",
	  "Comoros",
	  "Congo",
	  "Isole Cook",
	  "Costa Rica",
	  "Costa d'Avorio",
	  "Croazia",
	  "Cuba",
	  "Cipro",
	  "Repubblica Ceca",
	  "Danimarca",
	  "Gibuti",
	  "Repubblica Dominicana",
	  "Equador",
	  "Egitto",
	  "El Salvador",
	  "Guinea Equatoriale",
	  "Eritrea",
	  "Estonia",
	  "Etiopia",
	  "Isole Faroe",
	  "Isole Falkland (Malvinas)",
	  "Fiji",
	  "Finlandia",
	  "Francia",
	  "Guyana Francese",
	  "Polinesia Francese",
	  "Territori Francesi del sud",
	  "Gabon",
	  "Gambia",
	  "Georgia",
	  "Germania",
	  "Ghana",
	  "Gibilterra",
	  "Grecia",
	  "Groenlandia",
	  "Grenada",
	  "Guadalupa",
	  "Guam",
	  "Guatemala",
	  "Guernsey",
	  "Guinea",
	  "Guinea-Bissau",
	  "Guyana",
	  "Haiti",
	  "Heard Island and McDonald Islands",
	  "Città del Vaticano",
	  "Honduras",
	  "Hong Kong",
	  "Ungheria",
	  "Islanda",
	  "India",
	  "Indonesia",
	  "Iran",
	  "Iraq",
	  "Irlanda",
	  "Isola di Man",
	  "Israele",
	  "Italia",
	  "Giamaica",
	  "Giappone",
	  "Jersey",
	  "Giordania",
	  "Kazakhstan",
	  "Kenya",
	  "Kiribati",
	  "Korea",
	  "Kuwait",
	  "Republicca Kirgiza",
	  "Repubblica del Laos",
	  "Latvia",
	  "Libano",
	  "Lesotho",
	  "Liberia",
	  "Libyan Arab Jamahiriya",
	  "Liechtenstein",
	  "Lituania",
	  "Lussemburgo",
	  "Macao",
	  "Macedonia",
	  "Madagascar",
	  "Malawi",
	  "Malesia",
	  "Maldive",
	  "Mali",
	  "Malta",
	  "Isole Marshall",
	  "Martinica",
	  "Mauritania",
	  "Mauritius",
	  "Mayotte",
	  "Messico",
	  "Micronesia",
	  "Moldova",
	  "Principato di Monaco",
	  "Mongolia",
	  "Montenegro",
	  "Montserrat",
	  "Marocco",
	  "Mozambico",
	  "Myanmar",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Antille Olandesi",
	  "Olanda",
	  "Nuova Caledonia",
	  "Nuova Zelanda",
	  "Nicaragua",
	  "Niger",
	  "Nigeria",
	  "Niue",
	  "Isole Norfolk",
	  "Northern Mariana Islands",
	  "Norvegia",
	  "Oman",
	  "Pakistan",
	  "Palau",
	  "Palestina",
	  "Panama",
	  "Papua Nuova Guinea",
	  "Paraguay",
	  "Peru",
	  "Filippine",
	  "Pitcairn Islands",
	  "Polonia",
	  "Portogallo",
	  "Porto Rico",
	  "Qatar",
	  "Reunion",
	  "Romania",
	  "Russia",
	  "Rwanda",
	  "San Bartolomeo",
	  "Sant'Elena",
	  "Saint Kitts and Nevis",
	  "Saint Lucia",
	  "Saint Martin",
	  "Saint Pierre and Miquelon",
	  "Saint Vincent and the Grenadines",
	  "Samoa",
	  "San Marino",
	  "Sao Tome and Principe",
	  "Arabia Saudita",
	  "Senegal",
	  "Serbia",
	  "Seychelles",
	  "Sierra Leone",
	  "Singapore",
	  "Slovenia",
	  "Isole Solomon",
	  "Somalia",
	  "Sud Africa",
	  "Georgia del sud e South Sandwich Islands",
	  "Spagna",
	  "Sri Lanka",
	  "Sudan",
	  "Suriname",
	  "Svalbard & Jan Mayen Islands",
	  "Swaziland",
	  "Svezia",
	  "Svizzera",
	  "Siria",
	  "Taiwan",
	  "Tajikistan",
	  "Tanzania",
	  "Tailandia",
	  "Timor-Leste",
	  "Togo",
	  "Tokelau",
	  "Tonga",
	  "Trinidad e Tobago",
	  "Tunisia",
	  "Turchia",
	  "Turkmenistan",
	  "Isole di Turks and Caicos",
	  "Tuvalu",
	  "Uganda",
	  "Ucraina",
	  "Emirati Arabi Uniti",
	  "Regno Unito",
	  "Stati Uniti d'America",
	  "United States Minor Outlying Islands",
	  "Isole Vergini Statunitensi",
	  "Uruguay",
	  "Uzbekistan",
	  "Vanuatu",
	  "Venezuela",
	  "Vietnam",
	  "Wallis and Futuna",
	  "Western Sahara",
	  "Yemen",
	  "Zambia",
	  "Zimbabwe"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Italia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(842);
	address.city_suffix = __webpack_require__(843);
	address.country = __webpack_require__(844);
	address.building_number = __webpack_require__(840);
	address.street_suffix = __webpack_require__(853);
	address.secondary_address = __webpack_require__(848);
	address.postcode = __webpack_require__(847);
	address.state = __webpack_require__(849);
	address.state_abbr = __webpack_require__(850);
	address.city = __webpack_require__(841);
	address.street_name = __webpack_require__(852);
	address.street_address = __webpack_require__(851);
	address.default_country = __webpack_require__(845);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Appartamento ##",
	  "Piano #"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Agrigento",
	  "Alessandria",
	  "Ancona",
	  "Aosta",
	  "Arezzo",
	  "Ascoli Piceno",
	  "Asti",
	  "Avellino",
	  "Bari",
	  "Barletta-Andria-Trani",
	  "Belluno",
	  "Benevento",
	  "Bergamo",
	  "Biella",
	  "Bologna",
	  "Bolzano",
	  "Brescia",
	  "Brindisi",
	  "Cagliari",
	  "Caltanissetta",
	  "Campobasso",
	  "Carbonia-Iglesias",
	  "Caserta",
	  "Catania",
	  "Catanzaro",
	  "Chieti",
	  "Como",
	  "Cosenza",
	  "Cremona",
	  "Crotone",
	  "Cuneo",
	  "Enna",
	  "Fermo",
	  "Ferrara",
	  "Firenze",
	  "Foggia",
	  "Forlì-Cesena",
	  "Frosinone",
	  "Genova",
	  "Gorizia",
	  "Grosseto",
	  "Imperia",
	  "Isernia",
	  "La Spezia",
	  "L'Aquila",
	  "Latina",
	  "Lecce",
	  "Lecco",
	  "Livorno",
	  "Lodi",
	  "Lucca",
	  "Macerata",
	  "Mantova",
	  "Massa-Carrara",
	  "Matera",
	  "Messina",
	  "Milano",
	  "Modena",
	  "Monza e della Brianza",
	  "Napoli",
	  "Novara",
	  "Nuoro",
	  "Olbia-Tempio",
	  "Oristano",
	  "Padova",
	  "Palermo",
	  "Parma",
	  "Pavia",
	  "Perugia",
	  "Pesaro e Urbino",
	  "Pescara",
	  "Piacenza",
	  "Pisa",
	  "Pistoia",
	  "Pordenone",
	  "Potenza",
	  "Prato",
	  "Ragusa",
	  "Ravenna",
	  "Reggio Calabria",
	  "Reggio Emilia",
	  "Rieti",
	  "Rimini",
	  "Roma",
	  "Rovigo",
	  "Salerno",
	  "Medio Campidano",
	  "Sassari",
	  "Savona",
	  "Siena",
	  "Siracusa",
	  "Sondrio",
	  "Taranto",
	  "Teramo",
	  "Terni",
	  "Torino",
	  "Ogliastra",
	  "Trapani",
	  "Trento",
	  "Treviso",
	  "Trieste",
	  "Udine",
	  "Varese",
	  "Venezia",
	  "Verbano-Cusio-Ossola",
	  "Vercelli",
	  "Verona",
	  "Vibo Valentia",
	  "Vicenza",
	  "Viterbo"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AG",
	  "AL",
	  "AN",
	  "AO",
	  "AR",
	  "AP",
	  "AT",
	  "AV",
	  "BA",
	  "BT",
	  "BL",
	  "BN",
	  "BG",
	  "BI",
	  "BO",
	  "BZ",
	  "BS",
	  "BR",
	  "CA",
	  "CL",
	  "CB",
	  "CI",
	  "CE",
	  "CT",
	  "CZ",
	  "CH",
	  "CO",
	  "CS",
	  "CR",
	  "KR",
	  "CN",
	  "EN",
	  "FM",
	  "FE",
	  "FI",
	  "FG",
	  "FC",
	  "FR",
	  "GE",
	  "GO",
	  "GR",
	  "IM",
	  "IS",
	  "SP",
	  "AQ",
	  "LT",
	  "LE",
	  "LC",
	  "LI",
	  "LO",
	  "LU",
	  "MC",
	  "MN",
	  "MS",
	  "MT",
	  "ME",
	  "MI",
	  "MO",
	  "MB",
	  "NA",
	  "NO",
	  "NU",
	  "OT",
	  "OR",
	  "PD",
	  "PA",
	  "PR",
	  "PV",
	  "PG",
	  "PU",
	  "PE",
	  "PC",
	  "PI",
	  "PT",
	  "PN",
	  "PZ",
	  "PO",
	  "RG",
	  "RA",
	  "RC",
	  "RE",
	  "RI",
	  "RN",
	  "RM",
	  "RO",
	  "SA",
	  "VS",
	  "SS",
	  "SV",
	  "SI",
	  "SR",
	  "SO",
	  "TA",
	  "TE",
	  "TR",
	  "TO",
	  "OG",
	  "TP",
	  "TN",
	  "TV",
	  "TS",
	  "UD",
	  "VA",
	  "VE",
	  "VB",
	  "VC",
	  "VR",
	  "VV",
	  "VI",
	  "VT"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}",
	  "#{street_name} #{building_number}, #{secondary_address}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_suffix} #{Name.first_name}",
	  "#{street_suffix} #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Piazza",
	  "Strada",
	  "Via",
	  "Borgo",
	  "Contrada",
	  "Rotonda",
	  "Incrocio"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 ore",
	  "24/7",
	  "terza generazione",
	  "quarta generazione",
	  "quinta generazione",
	  "sesta generazione",
	  "asimmetrica",
	  "asincrona",
	  "background",
	  "bi-direzionale",
	  "biforcata",
	  "bottom-line",
	  "coerente",
	  "coesiva",
	  "composita",
	  "sensibile al contesto",
	  "basta sul contesto",
	  "basata sul contenuto",
	  "dedicata",
	  "didattica",
	  "direzionale",
	  "discreta",
	  "dinamica",
	  "eco-centrica",
	  "esecutiva",
	  "esplicita",
	  "full-range",
	  "globale",
	  "euristica",
	  "alto livello",
	  "olistica",
	  "omogenea",
	  "ibrida",
	  "impattante",
	  "incrementale",
	  "intangibile",
	  "interattiva",
	  "intermediaria",
	  "locale",
	  "logistica",
	  "massimizzata",
	  "metodica",
	  "mission-critical",
	  "mobile",
	  "modulare",
	  "motivazionale",
	  "multimedia",
	  "multi-tasking",
	  "nazionale",
	  "neutrale",
	  "nextgeneration",
	  "non-volatile",
	  "object-oriented",
	  "ottima",
	  "ottimizzante",
	  "radicale",
	  "real-time",
	  "reciproca",
	  "regionale",
	  "responsiva",
	  "scalabile",
	  "secondaria",
	  "stabile",
	  "statica",
	  "sistematica",
	  "sistemica",
	  "tangibile",
	  "terziaria",
	  "uniforme",
	  "valore aggiunto"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "valore aggiunto",
	  "verticalizzate",
	  "proattive",
	  "forti",
	  "rivoluzionari",
	  "scalabili",
	  "innovativi",
	  "intuitivi",
	  "strategici",
	  "e-business",
	  "mission-critical",
	  "24/7",
	  "globali",
	  "B2B",
	  "B2C",
	  "granulari",
	  "virtuali",
	  "virali",
	  "dinamiche",
	  "magnetiche",
	  "web",
	  "interattive",
	  "sexy",
	  "back-end",
	  "real-time",
	  "efficienti",
	  "front-end",
	  "distributivi",
	  "estensibili",
	  "mondiali",
	  "open-source",
	  "cross-platform",
	  "sinergiche",
	  "out-of-the-box",
	  "enterprise",
	  "integrate",
	  "di impatto",
	  "wireless",
	  "trasparenti",
	  "next-generation",
	  "cutting-edge",
	  "visionari",
	  "plug-and-play",
	  "collaborative",
	  "olistiche",
	  "ricche"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "partnerships",
	  "comunità",
	  "ROI",
	  "soluzioni",
	  "e-services",
	  "nicchie",
	  "tecnologie",
	  "contenuti",
	  "supply-chains",
	  "convergenze",
	  "relazioni",
	  "architetture",
	  "interfacce",
	  "mercati",
	  "e-commerce",
	  "sistemi",
	  "modelli",
	  "schemi",
	  "reti",
	  "applicazioni",
	  "metriche",
	  "e-business",
	  "funzionalità",
	  "esperienze",
	  "webservices",
	  "metodologie"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "implementate",
	  "utilizzo",
	  "integrate",
	  "ottimali",
	  "evolutive",
	  "abilitate",
	  "reinventate",
	  "aggregate",
	  "migliorate",
	  "incentivate",
	  "monetizzate",
	  "sinergizzate",
	  "strategiche",
	  "deploy",
	  "marchi",
	  "accrescitive",
	  "target",
	  "sintetizzate",
	  "spedizioni",
	  "massimizzate",
	  "innovazione",
	  "guida",
	  "estensioni",
	  "generate",
	  "exploit",
	  "transizionali",
	  "matrici",
	  "ricontestualizzate"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "adattiva",
	  "avanzata",
	  "migliorata",
	  "assimilata",
	  "automatizzata",
	  "bilanciata",
	  "centralizzata",
	  "compatibile",
	  "configurabile",
	  "cross-platform",
	  "decentralizzata",
	  "digitalizzata",
	  "distribuita",
	  "piccola",
	  "ergonomica",
	  "esclusiva",
	  "espansa",
	  "estesa",
	  "configurabile",
	  "fondamentale",
	  "orizzontale",
	  "implementata",
	  "innovativa",
	  "integrata",
	  "intuitiva",
	  "inversa",
	  "gestita",
	  "obbligatoria",
	  "monitorata",
	  "multi-canale",
	  "multi-laterale",
	  "open-source",
	  "operativa",
	  "ottimizzata",
	  "organica",
	  "persistente",
	  "polarizzata",
	  "proattiva",
	  "programmabile",
	  "progressiva",
	  "reattiva",
	  "riallineata",
	  "ricontestualizzata",
	  "ridotta",
	  "robusta",
	  "sicura",
	  "condivisibile",
	  "stand-alone",
	  "switchabile",
	  "sincronizzata",
	  "sinergica",
	  "totale",
	  "universale",
	  "user-friendly",
	  "versatile",
	  "virtuale",
	  "visionaria"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(862);
	company.noun = __webpack_require__(861);
	company.descriptor = __webpack_require__(858);
	company.adjective = __webpack_require__(854);
	company.bs_noun = __webpack_require__(856);
	company.bs_verb = __webpack_require__(857);
	company.bs_adjective = __webpack_require__(855);
	company.name = __webpack_require__(860);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name} #{suffix}",
	  "#{Name.last_name}, #{Name.last_name} e #{Name.last_name} #{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abilità",
	  "Access",
	  "Adattatore",
	  "Algoritmo",
	  "Alleanza",
	  "Analizzatore",
	  "Applicazione",
	  "Approccio",
	  "Architettura",
	  "Archivio",
	  "Intelligenza artificiale",
	  "Array",
	  "Attitudine",
	  "Benchmark",
	  "Capacità",
	  "Sfida",
	  "Circuito",
	  "Collaborazione",
	  "Complessità",
	  "Concetto",
	  "Conglomerato",
	  "Contingenza",
	  "Core",
	  "Database",
	  "Data-warehouse",
	  "Definizione",
	  "Emulazione",
	  "Codifica",
	  "Criptazione",
	  "Firmware",
	  "Flessibilità",
	  "Previsione",
	  "Frame",
	  "framework",
	  "Funzione",
	  "Funzionalità",
	  "Interfaccia grafica",
	  "Hardware",
	  "Help-desk",
	  "Gerarchia",
	  "Hub",
	  "Implementazione",
	  "Infrastruttura",
	  "Iniziativa",
	  "Installazione",
	  "Set di istruzioni",
	  "Interfaccia",
	  "Soluzione internet",
	  "Intranet",
	  "Conoscenza base",
	  "Matrici",
	  "Matrice",
	  "Metodologia",
	  "Middleware",
	  "Migrazione",
	  "Modello",
	  "Moderazione",
	  "Monitoraggio",
	  "Moratoria",
	  "Rete",
	  "Architettura aperta",
	  "Sistema aperto",
	  "Orchestrazione",
	  "Paradigma",
	  "Parallelismo",
	  "Policy",
	  "Portale",
	  "Struttura di prezzo",
	  "Prodotto",
	  "Produttività",
	  "Progetto",
	  "Proiezione",
	  "Protocollo",
	  "Servizio clienti",
	  "Software",
	  "Soluzione",
	  "Standardizzazione",
	  "Strategia",
	  "Struttura",
	  "Successo",
	  "Sovrastruttura",
	  "Supporto",
	  "Sinergia",
	  "Task-force",
	  "Finestra temporale",
	  "Strumenti",
	  "Utilizzazione",
	  "Sito web",
	  "Forza lavoro"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "SPA",
	  "e figli",
	  "Group",
	  "s.r.l."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var it = {};
	module['exports'] = it;
	it.title = "Italian";
	it.address = __webpack_require__(846);
	it.company = __webpack_require__(859);
	it.internet = __webpack_require__(866);
	it.name = __webpack_require__(868);
	it.phone_number = __webpack_require__(874);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "com",
	  "com",
	  "net",
	  "org",
	  "it",
	  "it",
	  "it"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com",
	  "email.it",
	  "libero.it",
	  "yahoo.it"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(865);
	internet.domain_suffix = __webpack_require__(864);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aaron",
	  "Akira",
	  "Alberto",
	  "Alessandro",
	  "Alighieri",
	  "Amedeo",
	  "Amos",
	  "Anselmo",
	  "Antonino",
	  "Arcibaldo",
	  "Armando",
	  "Artes",
	  "Audenico",
	  "Ausonio",
	  "Bacchisio",
	  "Battista",
	  "Bernardo",
	  "Boris",
	  "Caio",
	  "Carlo",
	  "Cecco",
	  "Cirino",
	  "Cleros",
	  "Costantino",
	  "Damiano",
	  "Danny",
	  "Davide",
	  "Demian",
	  "Dimitri",
	  "Domingo",
	  "Dylan",
	  "Edilio",
	  "Egidio",
	  "Elio",
	  "Emanuel",
	  "Enrico",
	  "Ercole",
	  "Ermes",
	  "Ethan",
	  "Eusebio",
	  "Evangelista",
	  "Fabiano",
	  "Ferdinando",
	  "Fiorentino",
	  "Flavio",
	  "Fulvio",
	  "Gabriele",
	  "Gastone",
	  "Germano",
	  "Giacinto",
	  "Gianantonio",
	  "Gianleonardo",
	  "Gianmarco",
	  "Gianriccardo",
	  "Gioacchino",
	  "Giordano",
	  "Giuliano",
	  "Graziano",
	  "Guido",
	  "Harry",
	  "Iacopo",
	  "Ilario",
	  "Ione",
	  "Italo",
	  "Jack",
	  "Jari",
	  "Joey",
	  "Joseph",
	  "Kai",
	  "Kociss",
	  "Laerte",
	  "Lauro",
	  "Leonardo",
	  "Liborio",
	  "Lorenzo",
	  "Ludovico",
	  "Maggiore",
	  "Manuele",
	  "Mariano",
	  "Marvin",
	  "Matteo",
	  "Mauro",
	  "Michael",
	  "Mirco",
	  "Modesto",
	  "Muzio",
	  "Nabil",
	  "Nathan",
	  "Nick",
	  "Noah",
	  "Odino",
	  "Olo",
	  "Oreste",
	  "Osea",
	  "Pablo",
	  "Patrizio",
	  "Piererminio",
	  "Pierfrancesco",
	  "Piersilvio",
	  "Priamo",
	  "Quarto",
	  "Quirino",
	  "Radames",
	  "Raniero",
	  "Renato",
	  "Rocco",
	  "Romeo",
	  "Rosalino",
	  "Rudy",
	  "Sabatino",
	  "Samuel",
	  "Santo",
	  "Sebastian",
	  "Serse",
	  "Silvano",
	  "Sirio",
	  "Tancredi",
	  "Terzo",
	  "Timoteo",
	  "Tolomeo",
	  "Trevis",
	  "Ubaldo",
	  "Ulrico",
	  "Valdo",
	  "Neri",
	  "Vinicio",
	  "Walter",
	  "Xavier",
	  "Yago",
	  "Zaccaria",
	  "Abramo",
	  "Adriano",
	  "Alan",
	  "Albino",
	  "Alessio",
	  "Alighiero",
	  "Amerigo",
	  "Anastasio",
	  "Antimo",
	  "Antonio",
	  "Arduino",
	  "Aroldo",
	  "Arturo",
	  "Augusto",
	  "Avide",
	  "Baldassarre",
	  "Bettino",
	  "Bortolo",
	  "Caligola",
	  "Carmelo",
	  "Celeste",
	  "Ciro",
	  "Costanzo",
	  "Dante",
	  "Danthon",
	  "Davis",
	  "Demis",
	  "Dindo",
	  "Domiziano",
	  "Edipo",
	  "Egisto",
	  "Eliziario",
	  "Emidio",
	  "Enzo",
	  "Eriberto",
	  "Erminio",
	  "Ettore",
	  "Eustachio",
	  "Fabio",
	  "Fernando",
	  "Fiorenzo",
	  "Folco",
	  "Furio",
	  "Gaetano",
	  "Gavino",
	  "Gerlando",
	  "Giacobbe",
	  "Giancarlo",
	  "Gianmaria",
	  "Giobbe",
	  "Giorgio",
	  "Giulio",
	  "Gregorio",
	  "Hector",
	  "Ian",
	  "Ippolito",
	  "Ivano",
	  "Jacopo",
	  "Jarno",
	  "Joannes",
	  "Joshua",
	  "Karim",
	  "Kris",
	  "Lamberto",
	  "Lazzaro",
	  "Leone",
	  "Lino",
	  "Loris",
	  "Luigi",
	  "Manfredi",
	  "Marco",
	  "Marino",
	  "Marzio",
	  "Mattia",
	  "Max",
	  "Michele",
	  "Mirko",
	  "Moreno",
	  "Nadir",
	  "Nazzareno",
	  "Nestore",
	  "Nico",
	  "Noel",
	  "Odone",
	  "Omar",
	  "Orfeo",
	  "Osvaldo",
	  "Pacifico",
	  "Pericle",
	  "Pietro",
	  "Primo",
	  "Quasimodo",
	  "Radio",
	  "Raoul",
	  "Renzo",
	  "Rodolfo",
	  "Romolo",
	  "Rosolino",
	  "Rufo",
	  "Sabino",
	  "Sandro",
	  "Sasha",
	  "Secondo",
	  "Sesto",
	  "Silverio",
	  "Siro",
	  "Tazio",
	  "Teseo",
	  "Timothy",
	  "Tommaso",
	  "Tristano",
	  "Umberto",
	  "Ariel",
	  "Artemide",
	  "Assia",
	  "Azue",
	  "Benedetta",
	  "Bibiana",
	  "Brigitta",
	  "Carmela",
	  "Cassiopea",
	  "Cesidia",
	  "Cira",
	  "Clea",
	  "Cleopatra",
	  "Clodovea",
	  "Concetta",
	  "Cosetta",
	  "Cristyn",
	  "Damiana",
	  "Danuta",
	  "Deborah",
	  "Demi",
	  "Diamante",
	  "Diana",
	  "Donatella",
	  "Doriana",
	  "Edvige",
	  "Elda",
	  "Elga",
	  "Elsa",
	  "Emilia",
	  "Enrica",
	  "Erminia",
	  "Eufemia",
	  "Evita",
	  "Fatima",
	  "Felicia",
	  "Filomena",
	  "Flaviana",
	  "Fortunata",
	  "Gelsomina",
	  "Genziana",
	  "Giacinta",
	  "Gilda",
	  "Giovanna",
	  "Giulietta",
	  "Grazia",
	  "Guendalina",
	  "Helga",
	  "Ileana",
	  "Ingrid",
	  "Irene",
	  "Isabel",
	  "Isira",
	  "Ivonne",
	  "Jelena",
	  "Jole",
	  "Claudia",
	  "Kayla",
	  "Kristel",
	  "Laura",
	  "Lucia",
	  "Lia",
	  "Lidia",
	  "Lisa",
	  "Loredana",
	  "Loretta",
	  "Luce",
	  "Lucrezia",
	  "Luna",
	  "Maika",
	  "Marcella",
	  "Maria",
	  "Mariagiulia",
	  "Marianita",
	  "Mariapia",
	  "Marieva",
	  "Marina",
	  "Maristella",
	  "Maruska",
	  "Matilde",
	  "Mecren",
	  "Mercedes",
	  "Mietta",
	  "Miriana",
	  "Miriam",
	  "Monia",
	  "Morgana",
	  "Naomi",
	  "Nayade",
	  "Nicoletta",
	  "Ninfa",
	  "Noemi",
	  "Nunzia",
	  "Olimpia",
	  "Oretta",
	  "Ortensia",
	  "Penelope",
	  "Piccarda",
	  "Prisca",
	  "Rebecca",
	  "Rita",
	  "Rosalba",
	  "Rosaria",
	  "Rosita",
	  "Ruth",
	  "Samira",
	  "Sarita",
	  "Selvaggia",
	  "Shaira",
	  "Sibilla",
	  "Soriana",
	  "Thea",
	  "Tosca",
	  "Ursula",
	  "Vania",
	  "Vera",
	  "Vienna",
	  "Violante",
	  "Vitalba",
	  "Zelida"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(867);
	name.last_name = __webpack_require__(869);
	name.prefix = __webpack_require__(871);
	name.suffix = __webpack_require__(872);
	name.name = __webpack_require__(870);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Amato",
	  "Barbieri",
	  "Barone",
	  "Basile",
	  "Battaglia",
	  "Bellini",
	  "Benedetti",
	  "Bernardi",
	  "Bianc",
	  "Bianchi",
	  "Bruno",
	  "Caputo",
	  "Carbon",
	  "Caruso",
	  "Cattaneo",
	  "Colombo",
	  "Cont",
	  "Conte",
	  "Coppola",
	  "Costa",
	  "Costantin",
	  "D'amico",
	  "D'angelo",
	  "Damico",
	  "De Angelis",
	  "De luca",
	  "De rosa",
	  "De Santis",
	  "Donati",
	  "Esposito",
	  "Fabbri",
	  "Farin",
	  "Ferrara",
	  "Ferrari",
	  "Ferraro",
	  "Ferretti",
	  "Ferri",
	  "Fior",
	  "Fontana",
	  "Galli",
	  "Gallo",
	  "Gatti",
	  "Gentile",
	  "Giordano",
	  "Giuliani",
	  "Grassi",
	  "Grasso",
	  "Greco",
	  "Guerra",
	  "Leone",
	  "Lombardi",
	  "Lombardo",
	  "Longo",
	  "Mancini",
	  "Marchetti",
	  "Marian",
	  "Marini",
	  "Marino",
	  "Martinelli",
	  "Martini",
	  "Martino",
	  "Mazza",
	  "Messina",
	  "Milani",
	  "Montanari",
	  "Monti",
	  "Morelli",
	  "Moretti",
	  "Negri",
	  "Neri",
	  "Orlando",
	  "Pagano",
	  "Palmieri",
	  "Palumbo",
	  "Parisi",
	  "Pellegrini",
	  "Pellegrino",
	  "Piras",
	  "Ricci",
	  "Rinaldi",
	  "Riva",
	  "Rizzi",
	  "Rizzo",
	  "Romano",
	  "Ross",
	  "Rossetti",
	  "Ruggiero",
	  "Russo",
	  "Sala",
	  "Sanna",
	  "Santoro",
	  "Sartori",
	  "Serr",
	  "Silvestri",
	  "Sorrentino",
	  "Testa",
	  "Valentini",
	  "Villa",
	  "Vitale",
	  "Vitali"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Sig.",
	  "Dott.",
	  "Dr.",
	  "Ing."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "+## ### ## ## ####",
	  "+## ## #######",
	  "+## ## ########",
	  "+## ### #######",
	  "+## ### ########",
	  "+## #### #######",
	  "+## #### ########",
	  "0## ### ####",
	  "+39 0## ### ###",
	  "3## ### ###",
	  "+39 3## ### ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(873);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}#{Name.first_name}#{city_suffix}",
	  "#{Name.first_name}#{city_suffix}",
	  "#{city_prefix}#{Name.last_name}#{city_suffix}",
	  "#{Name.last_name}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "北",
	  "東",
	  "西",
	  "南",
	  "新",
	  "湖",
	  "港"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "市",
	  "区",
	  "町",
	  "村"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.postcode = __webpack_require__(879);
	address.state = __webpack_require__(880);
	address.state_abbr = __webpack_require__(881);
	address.city_prefix = __webpack_require__(876);
	address.city_suffix = __webpack_require__(877);
	address.city = __webpack_require__(875);
	address.street_name = __webpack_require__(882);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "北海道",
	  "青森県",
	  "岩手県",
	  "宮城県",
	  "秋田県",
	  "山形県",
	  "福島県",
	  "茨城県",
	  "栃木県",
	  "群馬県",
	  "埼玉県",
	  "千葉県",
	  "東京都",
	  "神奈川県",
	  "新潟県",
	  "富山県",
	  "石川県",
	  "福井県",
	  "山梨県",
	  "長野県",
	  "岐阜県",
	  "静岡県",
	  "愛知県",
	  "三重県",
	  "滋賀県",
	  "京都府",
	  "大阪府",
	  "兵庫県",
	  "奈良県",
	  "和歌山県",
	  "鳥取県",
	  "島根県",
	  "岡山県",
	  "広島県",
	  "山口県",
	  "徳島県",
	  "香川県",
	  "愛媛県",
	  "高知県",
	  "福岡県",
	  "佐賀県",
	  "長崎県",
	  "熊本県",
	  "大分県",
	  "宮崎県",
	  "鹿児島県",
	  "沖縄県"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "1",
	  "2",
	  "3",
	  "4",
	  "5",
	  "6",
	  "7",
	  "8",
	  "9",
	  "10",
	  "11",
	  "12",
	  "13",
	  "14",
	  "15",
	  "16",
	  "17",
	  "18",
	  "19",
	  "20",
	  "21",
	  "22",
	  "23",
	  "24",
	  "25",
	  "26",
	  "27",
	  "28",
	  "29",
	  "30",
	  "31",
	  "32",
	  "33",
	  "34",
	  "35",
	  "36",
	  "37",
	  "38",
	  "39",
	  "40",
	  "41",
	  "42",
	  "43",
	  "44",
	  "45",
	  "46",
	  "47"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.first_name}#{street_suffix}",
	  "#{Name.last_name}#{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "090-####-####",
	  "080-####-####",
	  "070-####-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(883);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var ja = {};
	module['exports'] = ja;
	ja.title = "Japanese";
	ja.address = __webpack_require__(878);
	ja.phone_number = __webpack_require__(891);
	ja.cell_phone = __webpack_require__(884);
	ja.name = __webpack_require__(887);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "大翔",
	  "蓮",
	  "颯太",
	  "樹",
	  "大和",
	  "陽翔",
	  "陸斗",
	  "太一",
	  "海翔",
	  "蒼空",
	  "翼",
	  "陽菜",
	  "結愛",
	  "結衣",
	  "杏",
	  "莉子",
	  "美羽",
	  "結菜",
	  "心愛",
	  "愛菜",
	  "美咲"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.last_name = __webpack_require__(888);
	name.first_name = __webpack_require__(886);
	name.name = __webpack_require__(889);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "佐藤",
	  "鈴木",
	  "高橋",
	  "田中",
	  "渡辺",
	  "伊藤",
	  "山本",
	  "中村",
	  "小林",
	  "加藤",
	  "吉田",
	  "山田",
	  "佐々木",
	  "山口",
	  "斎藤",
	  "松本",
	  "井上",
	  "木村",
	  "林",
	  "清水"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{last_name} #{first_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0####-#-####",
	  "0###-##-####",
	  "0##-###-####",
	  "0#-####-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(890);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "강릉",
	  "양양",
	  "인제",
	  "광주",
	  "구리",
	  "부천",
	  "밀양",
	  "통영",
	  "창원",
	  "거창",
	  "고성",
	  "양산",
	  "김천",
	  "구미",
	  "영주",
	  "광산",
	  "남",
	  "북",
	  "고창",
	  "군산",
	  "남원",
	  "동작",
	  "마포",
	  "송파",
	  "용산",
	  "부평",
	  "강화",
	  "수성"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "구",
	  "시",
	  "군"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.postcode = __webpack_require__(896);
	address.state = __webpack_require__(897);
	address.state_abbr = __webpack_require__(898);
	address.city_suffix = __webpack_require__(894);
	address.city_name = __webpack_require__(893);
	address.city = __webpack_require__(892);
	address.street_root = __webpack_require__(900);
	address.street_suffix = __webpack_require__(901);
	address.street_name = __webpack_require__(899);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###-###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "강원",
	  "경기",
	  "경남",
	  "경북",
	  "광주",
	  "대구",
	  "대전",
	  "부산",
	  "서울",
	  "울산",
	  "인천",
	  "전남",
	  "전북",
	  "제주",
	  "충남",
	  "충북",
	  "세종"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "강원",
	  "경기",
	  "경남",
	  "경북",
	  "광주",
	  "대구",
	  "대전",
	  "부산",
	  "서울",
	  "울산",
	  "인천",
	  "전남",
	  "전북",
	  "제주",
	  "충남",
	  "충북",
	  "세종"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}#{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "상계",
	  "화곡",
	  "신정",
	  "목",
	  "잠실",
	  "면목",
	  "주안",
	  "안양",
	  "중",
	  "정왕",
	  "구로",
	  "신월",
	  "연산",
	  "부평",
	  "창",
	  "만수",
	  "중계",
	  "검단",
	  "시흥",
	  "상도",
	  "방배",
	  "장유",
	  "상",
	  "광명",
	  "신길",
	  "행신",
	  "대명",
	  "동탄"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "읍",
	  "면",
	  "동"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(905);
	company.prefix = __webpack_require__(904);
	company.name = __webpack_require__(903);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{Name.first_name}",
	  "#{Name.first_name} #{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "주식회사",
	  "한국"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "연구소",
	  "게임즈",
	  "그룹",
	  "전자",
	  "물산",
	  "코리아"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var ko = {};
	module['exports'] = ko;
	ko.title = "Korean";
	ko.address = __webpack_require__(895);
	ko.phone_number = __webpack_require__(917);
	ko.company = __webpack_require__(902);
	ko.internet = __webpack_require__(909);
	ko.lorem = __webpack_require__(910);
	ko.name = __webpack_require__(913);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "co.kr",
	  "com",
	  "biz",
	  "info",
	  "ne.kr",
	  "net",
	  "or.kr",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.co.kr",
	  "hanmail.net",
	  "naver.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(908);
	internet.domain_suffix = __webpack_require__(907);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(911);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "국가는",
	  "법률이",
	  "정하는",
	  "바에",
	  "의하여",
	  "재외국민을",
	  "보호할",
	  "의무를",
	  "진다.",
	  "모든",
	  "국민은",
	  "신체의",
	  "자유를",
	  "가진다.",
	  "국가는",
	  "전통문화의",
	  "계승·발전과",
	  "민족문화의",
	  "창달에",
	  "노력하여야",
	  "한다.",
	  "통신·방송의",
	  "시설기준과",
	  "신문의",
	  "기능을",
	  "보장하기",
	  "위하여",
	  "필요한",
	  "사항은",
	  "법률로",
	  "정한다.",
	  "헌법에",
	  "의하여",
	  "체결·공포된",
	  "조약과",
	  "일반적으로",
	  "승인된",
	  "국제법규는",
	  "국내법과",
	  "같은",
	  "효력을",
	  "가진다.",
	  "다만,",
	  "현행범인인",
	  "경우와",
	  "장기",
	  "3년",
	  "이상의",
	  "형에",
	  "해당하는",
	  "죄를",
	  "범하고",
	  "도피",
	  "또는",
	  "증거인멸의",
	  "염려가",
	  "있을",
	  "때에는",
	  "사후에",
	  "영장을",
	  "청구할",
	  "수",
	  "있다.",
	  "저작자·발명가·과학기술자와",
	  "예술가의",
	  "권리는",
	  "법률로써",
	  "보호한다.",
	  "형사피고인은",
	  "유죄의",
	  "판결이",
	  "확정될",
	  "때까지는",
	  "무죄로",
	  "추정된다.",
	  "모든",
	  "국민은",
	  "행위시의",
	  "법률에",
	  "의하여",
	  "범죄를",
	  "구성하지",
	  "아니하는",
	  "행위로",
	  "소추되지",
	  "아니하며,",
	  "동일한",
	  "범죄에",
	  "대하여",
	  "거듭",
	  "처벌받지",
	  "아니한다.",
	  "국가는",
	  "평생교육을",
	  "진흥하여야",
	  "한다.",
	  "모든",
	  "국민은",
	  "사생활의",
	  "비밀과",
	  "자유를",
	  "침해받지",
	  "아니한다.",
	  "의무교육은",
	  "무상으로",
	  "한다.",
	  "저작자·발명가·과학기술자와",
	  "예술가의",
	  "권리는",
	  "법률로써",
	  "보호한다.",
	  "국가는",
	  "모성의",
	  "보호를",
	  "위하여",
	  "노력하여야",
	  "한다.",
	  "헌법에",
	  "의하여",
	  "체결·공포된",
	  "조약과",
	  "일반적으로",
	  "승인된",
	  "국제법규는",
	  "국내법과",
	  "같은",
	  "효력을",
	  "가진다."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "서연",
	  "민서",
	  "서현",
	  "지우",
	  "서윤",
	  "지민",
	  "수빈",
	  "하은",
	  "예은",
	  "윤서",
	  "민준",
	  "지후",
	  "지훈",
	  "준서",
	  "현우",
	  "예준",
	  "건우",
	  "현준",
	  "민재",
	  "우진",
	  "은주"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.last_name = __webpack_require__(914);
	name.first_name = __webpack_require__(912);
	name.name = __webpack_require__(915);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "김",
	  "이",
	  "박",
	  "최",
	  "정",
	  "강",
	  "조",
	  "윤",
	  "장",
	  "임",
	  "오",
	  "한",
	  "신",
	  "서",
	  "권",
	  "황",
	  "안",
	  "송",
	  "류",
	  "홍"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{last_name} #{first_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0#-#####-####",
	  "0##-###-####",
	  "0##-####-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(916);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#",
	  "##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_root}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Fet",
	  "Gjes",
	  "Høy",
	  "Inn",
	  "Fager",
	  "Lille",
	  "Lo",
	  "Mal",
	  "Nord",
	  "Nær",
	  "Sand",
	  "Sme",
	  "Stav",
	  "Stor",
	  "Tand",
	  "Ut",
	  "Vest"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "berg",
	  "borg",
	  "by",
	  "bø",
	  "dal",
	  "eid",
	  "fjell",
	  "fjord",
	  "foss",
	  "grunn",
	  "hamn",
	  "havn",
	  "helle",
	  "mark",
	  "nes",
	  "odden",
	  "sand",
	  "sjøen",
	  "stad",
	  "strand",
	  "strøm",
	  "sund",
	  "vik",
	  "vær",
	  "våg",
	  "ø",
	  "øy",
	  "ås"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "sgate",
	  "svei",
	  "s Gate",
	  "s Vei",
	  "gata",
	  "veien"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Norge"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_root = __webpack_require__(920);
	address.city_suffix = __webpack_require__(921);
	address.street_prefix = __webpack_require__(930);
	address.street_root = __webpack_require__(931);
	address.street_suffix = __webpack_require__(932);
	address.common_street_suffix = __webpack_require__(922);
	address.building_number = __webpack_require__(918);
	address.secondary_address = __webpack_require__(926);
	address.postcode = __webpack_require__(925);
	address.state = __webpack_require__(927);
	address.city = __webpack_require__(919);
	address.street_name = __webpack_require__(929);
	address.street_address = __webpack_require__(928);
	address.default_country = __webpack_require__(923);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####",
	  "####",
	  "####",
	  "0###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Leil. ###",
	  "Oppgang A",
	  "Oppgang B"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  ""
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}#{street_suffix}",
	  "#{street_prefix} #{street_root}#{street_suffix}",
	  "#{Name.first_name}#{common_street_suffix}",
	  "#{Name.last_name}#{common_street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Øvre",
	  "Nedre",
	  "Søndre",
	  "Gamle",
	  "Østre",
	  "Vestre"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Eike",
	  "Bjørke",
	  "Gran",
	  "Vass",
	  "Furu",
	  "Litj",
	  "Lille",
	  "Høy",
	  "Fosse",
	  "Elve",
	  "Ku",
	  "Konvall",
	  "Soldugg",
	  "Hestemyr",
	  "Granitt",
	  "Hegge",
	  "Rogne",
	  "Fiol",
	  "Sol",
	  "Ting",
	  "Malm",
	  "Klokker",
	  "Preste",
	  "Dam",
	  "Geiterygg",
	  "Bekke",
	  "Berg",
	  "Kirke",
	  "Kors",
	  "Bru",
	  "Blåveis",
	  "Torg",
	  "Sjø"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alléen",
	  "bakken",
	  "berget",
	  "bråten",
	  "eggen",
	  "engen",
	  "ekra",
	  "faret",
	  "flata",
	  "gata",
	  "gjerdet",
	  "grenda",
	  "gropa",
	  "hagen",
	  "haugen",
	  "havna",
	  "holtet",
	  "høgda",
	  "jordet",
	  "kollen",
	  "kroken",
	  "lia",
	  "lunden",
	  "lyngen",
	  "løkka",
	  "marka",
	  "moen",
	  "myra",
	  "plassen",
	  "ringen",
	  "roa",
	  "røa",
	  "skogen",
	  "skrenten",
	  "spranget",
	  "stien",
	  "stranda",
	  "stubben",
	  "stykket",
	  "svingen",
	  "tjernet",
	  "toppen",
	  "tunet",
	  "vollen",
	  "vika",
	  "åsen"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(935);
	company.name = __webpack_require__(934);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} og #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Gruppen",
	  "AS",
	  "ASA",
	  "BA",
	  "RFH",
	  "og Sønner"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var nb_NO = {};
	module['exports'] = nb_NO;
	nb_NO.title = "Norwegian";
	nb_NO.address = __webpack_require__(924);
	nb_NO.company = __webpack_require__(933);
	nb_NO.internet = __webpack_require__(938);
	nb_NO.name = __webpack_require__(941);
	nb_NO.phone_number = __webpack_require__(948);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "no",
	  "com",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(937);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Emma",
	  "Sara",
	  "Thea",
	  "Ida",
	  "Julie",
	  "Nora",
	  "Emilie",
	  "Ingrid",
	  "Hanna",
	  "Maria",
	  "Sofie",
	  "Anna",
	  "Malin",
	  "Amalie",
	  "Vilde",
	  "Frida",
	  "Andrea",
	  "Tuva",
	  "Victoria",
	  "Mia",
	  "Karoline",
	  "Mathilde",
	  "Martine",
	  "Linnea",
	  "Marte",
	  "Hedda",
	  "Marie",
	  "Helene",
	  "Silje",
	  "Leah",
	  "Maja",
	  "Elise",
	  "Oda",
	  "Kristine",
	  "Aurora",
	  "Kaja",
	  "Camilla",
	  "Mari",
	  "Maren",
	  "Mina",
	  "Selma",
	  "Jenny",
	  "Celine",
	  "Eline",
	  "Sunniva",
	  "Natalie",
	  "Tiril",
	  "Synne",
	  "Sandra",
	  "Madeleine"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Emma",
	  "Sara",
	  "Thea",
	  "Ida",
	  "Julie",
	  "Nora",
	  "Emilie",
	  "Ingrid",
	  "Hanna",
	  "Maria",
	  "Sofie",
	  "Anna",
	  "Malin",
	  "Amalie",
	  "Vilde",
	  "Frida",
	  "Andrea",
	  "Tuva",
	  "Victoria",
	  "Mia",
	  "Karoline",
	  "Mathilde",
	  "Martine",
	  "Linnea",
	  "Marte",
	  "Hedda",
	  "Marie",
	  "Helene",
	  "Silje",
	  "Leah",
	  "Maja",
	  "Elise",
	  "Oda",
	  "Kristine",
	  "Aurora",
	  "Kaja",
	  "Camilla",
	  "Mari",
	  "Maren",
	  "Mina",
	  "Selma",
	  "Jenny",
	  "Celine",
	  "Eline",
	  "Sunniva",
	  "Natalie",
	  "Tiril",
	  "Synne",
	  "Sandra",
	  "Madeleine",
	  "Markus",
	  "Mathias",
	  "Kristian",
	  "Jonas",
	  "Andreas",
	  "Alexander",
	  "Martin",
	  "Sander",
	  "Daniel",
	  "Magnus",
	  "Henrik",
	  "Tobias",
	  "Kristoffer",
	  "Emil",
	  "Adrian",
	  "Sebastian",
	  "Marius",
	  "Elias",
	  "Fredrik",
	  "Thomas",
	  "Sondre",
	  "Benjamin",
	  "Jakob",
	  "Oliver",
	  "Lucas",
	  "Oskar",
	  "Nikolai",
	  "Filip",
	  "Mats",
	  "William",
	  "Erik",
	  "Simen",
	  "Ole",
	  "Eirik",
	  "Isak",
	  "Kasper",
	  "Noah",
	  "Lars",
	  "Joakim",
	  "Johannes",
	  "Håkon",
	  "Sindre",
	  "Jørgen",
	  "Herman",
	  "Anders",
	  "Jonathan",
	  "Even",
	  "Theodor",
	  "Mikkel",
	  "Aksel"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(940);
	name.feminine_name = __webpack_require__(939);
	name.masculine_name = __webpack_require__(943);
	name.last_name = __webpack_require__(942);
	name.prefix = __webpack_require__(945);
	name.suffix = __webpack_require__(946);
	name.name = __webpack_require__(944);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Johansen",
	  "Hansen",
	  "Andersen",
	  "Kristiansen",
	  "Larsen",
	  "Olsen",
	  "Solberg",
	  "Andresen",
	  "Pedersen",
	  "Nilsen",
	  "Berg",
	  "Halvorsen",
	  "Karlsen",
	  "Svendsen",
	  "Jensen",
	  "Haugen",
	  "Martinsen",
	  "Eriksen",
	  "Sørensen",
	  "Johnsen",
	  "Myhrer",
	  "Johannessen",
	  "Nielsen",
	  "Hagen",
	  "Pettersen",
	  "Bakke",
	  "Skuterud",
	  "Løken",
	  "Gundersen",
	  "Strand",
	  "Jørgensen",
	  "Kvarme",
	  "Røed",
	  "Sæther",
	  "Stensrud",
	  "Moe",
	  "Kristoffersen",
	  "Jakobsen",
	  "Holm",
	  "Aas",
	  "Lie",
	  "Moen",
	  "Andreassen",
	  "Vedvik",
	  "Nguyen",
	  "Jacobsen",
	  "Torgersen",
	  "Ruud",
	  "Krogh",
	  "Christiansen",
	  "Bjerke",
	  "Aalerud",
	  "Borge",
	  "Sørlie",
	  "Berge",
	  "Østli",
	  "Ødegård",
	  "Torp",
	  "Henriksen",
	  "Haukelidsæter",
	  "Fjeld",
	  "Danielsen",
	  "Aasen",
	  "Fredriksen",
	  "Dahl",
	  "Berntsen",
	  "Arnesen",
	  "Wold",
	  "Thoresen",
	  "Solheim",
	  "Skoglund",
	  "Bakken",
	  "Amundsen",
	  "Solli",
	  "Smogeli",
	  "Kristensen",
	  "Glosli",
	  "Fossum",
	  "Evensen",
	  "Eide",
	  "Carlsen",
	  "Østby",
	  "Vegge",
	  "Tangen",
	  "Smedsrud",
	  "Olstad",
	  "Lunde",
	  "Kleven",
	  "Huseby",
	  "Bjørnstad",
	  "Ryan",
	  "Rasmussen",
	  "Nygård",
	  "Nordskaug",
	  "Nordby",
	  "Mathisen",
	  "Hopland",
	  "Gran",
	  "Finstad",
	  "Edvardsen"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Markus",
	  "Mathias",
	  "Kristian",
	  "Jonas",
	  "Andreas",
	  "Alexander",
	  "Martin",
	  "Sander",
	  "Daniel",
	  "Magnus",
	  "Henrik",
	  "Tobias",
	  "Kristoffer",
	  "Emil",
	  "Adrian",
	  "Sebastian",
	  "Marius",
	  "Elias",
	  "Fredrik",
	  "Thomas",
	  "Sondre",
	  "Benjamin",
	  "Jakob",
	  "Oliver",
	  "Lucas",
	  "Oskar",
	  "Nikolai",
	  "Filip",
	  "Mats",
	  "William",
	  "Erik",
	  "Simen",
	  "Ole",
	  "Eirik",
	  "Isak",
	  "Kasper",
	  "Noah",
	  "Lars",
	  "Joakim",
	  "Johannes",
	  "Håkon",
	  "Sindre",
	  "Jørgen",
	  "Herman",
	  "Anders",
	  "Jonathan",
	  "Even",
	  "Theodor",
	  "Mikkel",
	  "Aksel"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name} #{suffix}",
	  "#{feminine_name} #{feminine_name} #{last_name}",
	  "#{masculine_name} #{masculine_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Dr.",
	  "Prof."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Jr.",
	  "Sr.",
	  "I",
	  "II",
	  "III",
	  "IV",
	  "V"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "########",
	  "## ## ## ##",
	  "### ## ###",
	  "+47 ## ## ## ##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(947);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bhaktapur",
	  "Biratnagar",
	  "Birendranagar",
	  "Birgunj",
	  "Butwal",
	  "Damak",
	  "Dharan",
	  "Gaur",
	  "Gorkha",
	  "Hetauda",
	  "Itahari",
	  "Janakpur",
	  "Kathmandu",
	  "Lahan",
	  "Nepalgunj",
	  "Pokhara"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Nepal"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.postcode = __webpack_require__(952);
	address.state = __webpack_require__(953);
	address.city = __webpack_require__(949);
	address.default_country = __webpack_require__(950);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  0
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Baglung",
	  "Banke",
	  "Bara",
	  "Bardiya",
	  "Bhaktapur",
	  "Bhojupu",
	  "Chitwan",
	  "Dailekh",
	  "Dang",
	  "Dhading",
	  "Dhankuta",
	  "Dhanusa",
	  "Dolakha",
	  "Dolpha",
	  "Gorkha",
	  "Gulmi",
	  "Humla",
	  "Ilam",
	  "Jajarkot",
	  "Jhapa",
	  "Jumla",
	  "Kabhrepalanchok",
	  "Kalikot",
	  "Kapilvastu",
	  "Kaski",
	  "Kathmandu",
	  "Lalitpur",
	  "Lamjung",
	  "Manang",
	  "Mohottari",
	  "Morang",
	  "Mugu",
	  "Mustang",
	  "Myagdi",
	  "Nawalparasi",
	  "Nuwakot",
	  "Palpa",
	  "Parbat",
	  "Parsa",
	  "Ramechhap",
	  "Rauswa",
	  "Rautahat",
	  "Rolpa",
	  "Rupandehi",
	  "Sankhuwasabha",
	  "Sarlahi",
	  "Sindhuli",
	  "Sindhupalchok",
	  "Sunsari",
	  "Surket",
	  "Syangja",
	  "Tanahu",
	  "Terhathum"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(955);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pvt Ltd",
	  "Group",
	  "Ltd",
	  "Limited"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var nep = {};
	module['exports'] = nep;
	nep.title = "Nepalese";
	nep.name = __webpack_require__(961);
	nep.address = __webpack_require__(951);
	nep.internet = __webpack_require__(959);
	nep.company = __webpack_require__(954);
	nep.phone_number = __webpack_require__(964);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "np",
	  "com",
	  "info",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "worldlink.com.np",
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(958);
	internet.domain_suffix = __webpack_require__(957);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aarav",
	  "Ajita",
	  "Amit",
	  "Amita",
	  "Amrit",
	  "Arijit",
	  "Ashmi",
	  "Asmita",
	  "Bibek",
	  "Bijay",
	  "Bikash",
	  "Bina",
	  "Bishal",
	  "Bishnu",
	  "Buddha",
	  "Deepika",
	  "Dipendra",
	  "Gagan",
	  "Ganesh",
	  "Khem",
	  "Krishna",
	  "Laxmi",
	  "Manisha",
	  "Nabin",
	  "Nikita",
	  "Niraj",
	  "Nischal",
	  "Padam",
	  "Pooja",
	  "Prabin",
	  "Prakash",
	  "Prashant",
	  "Prem",
	  "Purna",
	  "Rajendra",
	  "Rajina",
	  "Raju",
	  "Rakesh",
	  "Ranjan",
	  "Ratna",
	  "Sagar",
	  "Sandeep",
	  "Sanjay",
	  "Santosh",
	  "Sarita",
	  "Shilpa",
	  "Shirisha",
	  "Shristi",
	  "Siddhartha",
	  "Subash",
	  "Sumeet",
	  "Sunita",
	  "Suraj",
	  "Susan",
	  "Sushant"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(960);
	name.last_name = __webpack_require__(962);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adhikari",
	  "Aryal",
	  "Baral",
	  "Basnet",
	  "Bastola",
	  "Basynat",
	  "Bhandari",
	  "Bhattarai",
	  "Chettri",
	  "Devkota",
	  "Dhakal",
	  "Dongol",
	  "Ghale",
	  "Gurung",
	  "Gyawali",
	  "Hamal",
	  "Jung",
	  "KC",
	  "Kafle",
	  "Karki",
	  "Khadka",
	  "Koirala",
	  "Lama",
	  "Limbu",
	  "Magar",
	  "Maharjan",
	  "Niroula",
	  "Pandey",
	  "Pradhan",
	  "Rana",
	  "Raut",
	  "Sai",
	  "Shai",
	  "Shakya",
	  "Sherpa",
	  "Shrestha",
	  "Subedi",
	  "Tamang",
	  "Thapa"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "##-#######",
	  "+977-#-#######",
	  "+977########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(963);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#",
	  "##",
	  "###",
	  "###a",
	  "###b",
	  "###c",
	  "### I",
	  "### II",
	  "### III"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.first_name}#{city_suffix}",
	  "#{Name.last_name}#{city_suffix}",
	  "#{city_prefix} #{Name.first_name}#{city_suffix}",
	  "#{city_prefix} #{Name.last_name}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Noord",
	  "Oost",
	  "West",
	  "Zuid",
	  "Nieuw",
	  "Oud"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "dam",
	  "berg",
	  " aan de Rijn",
	  " aan de IJssel",
	  "swaerd",
	  "endrecht",
	  "recht",
	  "ambacht",
	  "enmaes",
	  "wijk",
	  "sland",
	  "stroom",
	  "sluus",
	  "dijk",
	  "dorp",
	  "burg",
	  "veld",
	  "sluis",
	  "koop",
	  "lek",
	  "hout",
	  "geest",
	  "kerk",
	  "woude",
	  "hoven",
	  "hoten",
	  "ingen",
	  "plas",
	  "meer"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afghanistan",
	  "Akrotiri",
	  "Albanië",
	  "Algerije",
	  "Amerikaanse Maagdeneilanden",
	  "Amerikaans-Samoa",
	  "Andorra",
	  "Angola",
	  "Anguilla",
	  "Antarctica",
	  "Antigua en Barbuda",
	  "Arctic Ocean",
	  "Argentinië",
	  "Armenië",
	  "Aruba",
	  "Ashmore and Cartier Islands",
	  "Atlantic Ocean",
	  "Australië",
	  "Azerbeidzjan",
	  "Bahama's",
	  "Bahrein",
	  "Bangladesh",
	  "Barbados",
	  "Belarus",
	  "België",
	  "Belize",
	  "Benin",
	  "Bermuda",
	  "Bhutan",
	  "Bolivië",
	  "Bosnië-Herzegovina",
	  "Botswana",
	  "Bouvet Island",
	  "Brazilië",
	  "British Indian Ocean Territory",
	  "Britse Maagdeneilanden",
	  "Brunei",
	  "Bulgarije",
	  "Burkina Faso",
	  "Burundi",
	  "Cambodja",
	  "Canada",
	  "Caymaneilanden",
	  "Centraal-Afrikaanse Republiek",
	  "Chili",
	  "China",
	  "Christmas Island",
	  "Clipperton Island",
	  "Cocos (Keeling) Islands",
	  "Colombia",
	  "Comoren (Unie)",
	  "Congo (Democratische Republiek)",
	  "Congo (Volksrepubliek)",
	  "Cook",
	  "Coral Sea Islands",
	  "Costa Rica",
	  "Cuba",
	  "Cyprus",
	  "Denemarken",
	  "Dhekelia",
	  "Djibouti",
	  "Dominica",
	  "Dominicaanse Republiek",
	  "Duitsland",
	  "Ecuador",
	  "Egypte",
	  "El Salvador",
	  "Equatoriaal-Guinea",
	  "Eritrea",
	  "Estland",
	  "Ethiopië",
	  "European Union",
	  "Falkland",
	  "Faroe Islands",
	  "Fiji",
	  "Filipijnen",
	  "Finland",
	  "Frankrijk",
	  "Frans-Polynesië",
	  "French Southern and Antarctic Lands",
	  "Gabon",
	  "Gambia",
	  "Gaza Strip",
	  "Georgië",
	  "Ghana",
	  "Gibraltar",
	  "Grenada",
	  "Griekenland",
	  "Groenland",
	  "Guam",
	  "Guatemala",
	  "Guernsey",
	  "Guinea",
	  "Guinee-Bissau",
	  "Guyana",
	  "Haïti",
	  "Heard Island and McDonald Islands",
	  "Heilige Stoel",
	  "Honduras",
	  "Hongarije",
	  "Hongkong",
	  "Ierland",
	  "IJsland",
	  "India",
	  "Indian Ocean",
	  "Indonesië",
	  "Irak",
	  "Iran",
	  "Isle of Man",
	  "Israël",
	  "Italië",
	  "Ivoorkust",
	  "Jamaica",
	  "Jan Mayen",
	  "Japan",
	  "Jemen",
	  "Jersey",
	  "Jordanië",
	  "Kaapverdië",
	  "Kameroen",
	  "Kazachstan",
	  "Kenia",
	  "Kirgizstan",
	  "Kiribati",
	  "Koeweit",
	  "Kroatië",
	  "Laos",
	  "Lesotho",
	  "Letland",
	  "Libanon",
	  "Liberia",
	  "Libië",
	  "Liechtenstein",
	  "Litouwen",
	  "Luxemburg",
	  "Macao",
	  "Macedonië",
	  "Madagaskar",
	  "Malawi",
	  "Maldiven",
	  "Maleisië",
	  "Mali",
	  "Malta",
	  "Marokko",
	  "Marshall Islands",
	  "Mauritanië",
	  "Mauritius",
	  "Mayotte",
	  "Mexico",
	  "Micronesia, Federated States of",
	  "Moldavië",
	  "Monaco",
	  "Mongolië",
	  "Montenegro",
	  "Montserrat",
	  "Mozambique",
	  "Myanmar",
	  "Namibië",
	  "Nauru",
	  "Navassa Island",
	  "Nederland",
	  "Nederlandse Antillen",
	  "Nepal",
	  "Ngwane",
	  "Nicaragua",
	  "Nieuw-Caledonië",
	  "Nieuw-Zeeland",
	  "Niger",
	  "Nigeria",
	  "Niue",
	  "Noordelijke Marianen",
	  "Noord-Korea",
	  "Noorwegen",
	  "Norfolk Island",
	  "Oekraïne",
	  "Oezbekistan",
	  "Oman",
	  "Oostenrijk",
	  "Pacific Ocean",
	  "Pakistan",
	  "Palau",
	  "Panama",
	  "Papoea-Nieuw-Guinea",
	  "Paracel Islands",
	  "Paraguay",
	  "Peru",
	  "Pitcairn",
	  "Polen",
	  "Portugal",
	  "Puerto Rico",
	  "Qatar",
	  "Roemenië",
	  "Rusland",
	  "Rwanda",
	  "Saint Helena",
	  "Saint Lucia",
	  "Saint Vincent en de Grenadines",
	  "Saint-Pierre en Miquelon",
	  "Salomon",
	  "Samoa",
	  "San Marino",
	  "São Tomé en Principe",
	  "Saudi-Arabië",
	  "Senegal",
	  "Servië",
	  "Seychellen",
	  "Sierra Leone",
	  "Singapore",
	  "Sint-Kitts en Nevis",
	  "Slovenië",
	  "Slowakije",
	  "Soedan",
	  "Somalië",
	  "South Georgia and the South Sandwich Islands",
	  "Southern Ocean",
	  "Spanje",
	  "Spratly Islands",
	  "Sri Lanka",
	  "Suriname",
	  "Svalbard",
	  "Syrië",
	  "Tadzjikistan",
	  "Taiwan",
	  "Tanzania",
	  "Thailand",
	  "Timor Leste",
	  "Togo",
	  "Tokelau",
	  "Tonga",
	  "Trinidad en Tobago",
	  "Tsjaad",
	  "Tsjechië",
	  "Tunesië",
	  "Turkije",
	  "Turkmenistan",
	  "Turks-en Caicoseilanden",
	  "Tuvalu",
	  "Uganda",
	  "Uruguay",
	  "Vanuatu",
	  "Venezuela",
	  "Verenigd Koninkrijk",
	  "Verenigde Arabische Emiraten",
	  "Verenigde Staten van Amerika",
	  "Vietnam",
	  "Wake Island",
	  "Wallis en Futuna",
	  "Wereld",
	  "West Bank",
	  "Westelijke Sahara",
	  "Zambia",
	  "Zimbabwe",
	  "Zuid-Afrika",
	  "Zuid-Korea",
	  "Zweden",
	  "Zwitserland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Nederland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(967);
	address.city_suffix = __webpack_require__(968);
	address.city = __webpack_require__(966);
	address.country = __webpack_require__(969);
	address.building_number = __webpack_require__(965);
	address.street_suffix = __webpack_require__(977);
	address.secondary_address = __webpack_require__(973);
	address.street_name = __webpack_require__(976);
	address.street_address = __webpack_require__(975);
	address.postcode = __webpack_require__(972);
	address.state = __webpack_require__(974);
	address.default_country = __webpack_require__(970);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#### ??"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "1 hoog",
	  "2 hoog",
	  "3 hoog"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Noord-Holland",
	  "Zuid-Holland",
	  "Utrecht",
	  "Zeeland",
	  "Overijssel",
	  "Gelderland",
	  "Drenthe",
	  "Friesland",
	  "Groningen",
	  "Noord-Brabant",
	  "Limburg",
	  "Flevoland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.first_name}#{street_suffix}",
	  "#{Name.last_name}#{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "straat",
	  "laan",
	  "weg",
	  "plantsoen",
	  "park"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(979);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "BV",
	  "V.O.F.",
	  "Group",
	  "en Zonen"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var nl = {};
	module['exports'] = nl;
	nl.title = "Dutch";
	nl.address = __webpack_require__(971);
	nl.company = __webpack_require__(978);
	nl.internet = __webpack_require__(983);
	nl.lorem = __webpack_require__(984);
	nl.name = __webpack_require__(988);
	nl.phone_number = __webpack_require__(995);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "nl",
	  "com",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(982);
	internet.domain_suffix = __webpack_require__(981);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(986);
	lorem.supplemental = __webpack_require__(985);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "abbas",
	  "abduco",
	  "abeo",
	  "abscido",
	  "absconditus",
	  "absens",
	  "absorbeo",
	  "absque",
	  "abstergo",
	  "absum",
	  "abundans",
	  "abutor",
	  "accedo",
	  "accendo",
	  "acceptus",
	  "accipio",
	  "accommodo",
	  "accusator",
	  "acer",
	  "acerbitas",
	  "acervus",
	  "acidus",
	  "acies",
	  "acquiro",
	  "acsi",
	  "adamo",
	  "adaugeo",
	  "addo",
	  "adduco",
	  "ademptio",
	  "adeo",
	  "adeptio",
	  "adfectus",
	  "adfero",
	  "adficio",
	  "adflicto",
	  "adhaero",
	  "adhuc",
	  "adicio",
	  "adimpleo",
	  "adinventitias",
	  "adipiscor",
	  "adiuvo",
	  "administratio",
	  "admiratio",
	  "admitto",
	  "admoneo",
	  "admoveo",
	  "adnuo",
	  "adopto",
	  "adsidue",
	  "adstringo",
	  "adsuesco",
	  "adsum",
	  "adulatio",
	  "adulescens",
	  "adultus",
	  "aduro",
	  "advenio",
	  "adversus",
	  "advoco",
	  "aedificium",
	  "aeger",
	  "aegre",
	  "aegrotatio",
	  "aegrus",
	  "aeneus",
	  "aequitas",
	  "aequus",
	  "aer",
	  "aestas",
	  "aestivus",
	  "aestus",
	  "aetas",
	  "aeternus",
	  "ager",
	  "aggero",
	  "aggredior",
	  "agnitio",
	  "agnosco",
	  "ago",
	  "ait",
	  "aiunt",
	  "alienus",
	  "alii",
	  "alioqui",
	  "aliqua",
	  "alius",
	  "allatus",
	  "alo",
	  "alter",
	  "altus",
	  "alveus",
	  "amaritudo",
	  "ambitus",
	  "ambulo",
	  "amicitia",
	  "amiculum",
	  "amissio",
	  "amita",
	  "amitto",
	  "amo",
	  "amor",
	  "amoveo",
	  "amplexus",
	  "amplitudo",
	  "amplus",
	  "ancilla",
	  "angelus",
	  "angulus",
	  "angustus",
	  "animadverto",
	  "animi",
	  "animus",
	  "annus",
	  "anser",
	  "ante",
	  "antea",
	  "antepono",
	  "antiquus",
	  "aperio",
	  "aperte",
	  "apostolus",
	  "apparatus",
	  "appello",
	  "appono",
	  "appositus",
	  "approbo",
	  "apto",
	  "aptus",
	  "apud",
	  "aqua",
	  "ara",
	  "aranea",
	  "arbitro",
	  "arbor",
	  "arbustum",
	  "arca",
	  "arceo",
	  "arcesso",
	  "arcus",
	  "argentum",
	  "argumentum",
	  "arguo",
	  "arma",
	  "armarium",
	  "armo",
	  "aro",
	  "ars",
	  "articulus",
	  "artificiose",
	  "arto",
	  "arx",
	  "ascisco",
	  "ascit",
	  "asper",
	  "aspicio",
	  "asporto",
	  "assentator",
	  "astrum",
	  "atavus",
	  "ater",
	  "atqui",
	  "atrocitas",
	  "atrox",
	  "attero",
	  "attollo",
	  "attonbitus",
	  "auctor",
	  "auctus",
	  "audacia",
	  "audax",
	  "audentia",
	  "audeo",
	  "audio",
	  "auditor",
	  "aufero",
	  "aureus",
	  "auris",
	  "aurum",
	  "aut",
	  "autem",
	  "autus",
	  "auxilium",
	  "avaritia",
	  "avarus",
	  "aveho",
	  "averto",
	  "avoco",
	  "baiulus",
	  "balbus",
	  "barba",
	  "bardus",
	  "basium",
	  "beatus",
	  "bellicus",
	  "bellum",
	  "bene",
	  "beneficium",
	  "benevolentia",
	  "benigne",
	  "bestia",
	  "bibo",
	  "bis",
	  "blandior",
	  "bonus",
	  "bos",
	  "brevis",
	  "cado",
	  "caecus",
	  "caelestis",
	  "caelum",
	  "calamitas",
	  "calcar",
	  "calco",
	  "calculus",
	  "callide",
	  "campana",
	  "candidus",
	  "canis",
	  "canonicus",
	  "canto",
	  "capillus",
	  "capio",
	  "capitulus",
	  "capto",
	  "caput",
	  "carbo",
	  "carcer",
	  "careo",
	  "caries",
	  "cariosus",
	  "caritas",
	  "carmen",
	  "carpo",
	  "carus",
	  "casso",
	  "caste",
	  "casus",
	  "catena",
	  "caterva",
	  "cattus",
	  "cauda",
	  "causa",
	  "caute",
	  "caveo",
	  "cavus",
	  "cedo",
	  "celebrer",
	  "celer",
	  "celo",
	  "cena",
	  "cenaculum",
	  "ceno",
	  "censura",
	  "centum",
	  "cerno",
	  "cernuus",
	  "certe",
	  "certo",
	  "certus",
	  "cervus",
	  "cetera",
	  "charisma",
	  "chirographum",
	  "cibo",
	  "cibus",
	  "cicuta",
	  "cilicium",
	  "cimentarius",
	  "ciminatio",
	  "cinis",
	  "circumvenio",
	  "cito",
	  "civis",
	  "civitas",
	  "clam",
	  "clamo",
	  "claro",
	  "clarus",
	  "claudeo",
	  "claustrum",
	  "clementia",
	  "clibanus",
	  "coadunatio",
	  "coaegresco",
	  "coepi",
	  "coerceo",
	  "cogito",
	  "cognatus",
	  "cognomen",
	  "cogo",
	  "cohaero",
	  "cohibeo",
	  "cohors",
	  "colligo",
	  "colloco",
	  "collum",
	  "colo",
	  "color",
	  "coma",
	  "combibo",
	  "comburo",
	  "comedo",
	  "comes",
	  "cometes",
	  "comis",
	  "comitatus",
	  "commemoro",
	  "comminor",
	  "commodo",
	  "communis",
	  "comparo",
	  "compello",
	  "complectus",
	  "compono",
	  "comprehendo",
	  "comptus",
	  "conatus",
	  "concedo",
	  "concido",
	  "conculco",
	  "condico",
	  "conduco",
	  "confero",
	  "confido",
	  "conforto",
	  "confugo",
	  "congregatio",
	  "conicio",
	  "coniecto",
	  "conitor",
	  "coniuratio",
	  "conor",
	  "conqueror",
	  "conscendo",
	  "conservo",
	  "considero",
	  "conspergo",
	  "constans",
	  "consuasor",
	  "contabesco",
	  "contego",
	  "contigo",
	  "contra",
	  "conturbo",
	  "conventus",
	  "convoco",
	  "copia",
	  "copiose",
	  "cornu",
	  "corona",
	  "corpus",
	  "correptius",
	  "corrigo",
	  "corroboro",
	  "corrumpo",
	  "coruscus",
	  "cotidie",
	  "crapula",
	  "cras",
	  "crastinus",
	  "creator",
	  "creber",
	  "crebro",
	  "credo",
	  "creo",
	  "creptio",
	  "crepusculum",
	  "cresco",
	  "creta",
	  "cribro",
	  "crinis",
	  "cruciamentum",
	  "crudelis",
	  "cruentus",
	  "crur",
	  "crustulum",
	  "crux",
	  "cubicularis",
	  "cubitum",
	  "cubo",
	  "cui",
	  "cuius",
	  "culpa",
	  "culpo",
	  "cultellus",
	  "cultura",
	  "cum",
	  "cunabula",
	  "cunae",
	  "cunctatio",
	  "cupiditas",
	  "cupio",
	  "cuppedia",
	  "cupressus",
	  "cur",
	  "cura",
	  "curatio",
	  "curia",
	  "curiositas",
	  "curis",
	  "curo",
	  "curriculum",
	  "currus",
	  "cursim",
	  "curso",
	  "cursus",
	  "curto",
	  "curtus",
	  "curvo",
	  "curvus",
	  "custodia",
	  "damnatio",
	  "damno",
	  "dapifer",
	  "debeo",
	  "debilito",
	  "decens",
	  "decerno",
	  "decet",
	  "decimus",
	  "decipio",
	  "decor",
	  "decretum",
	  "decumbo",
	  "dedecor",
	  "dedico",
	  "deduco",
	  "defaeco",
	  "defendo",
	  "defero",
	  "defessus",
	  "defetiscor",
	  "deficio",
	  "defigo",
	  "defleo",
	  "defluo",
	  "defungo",
	  "degenero",
	  "degero",
	  "degusto",
	  "deinde",
	  "delectatio",
	  "delego",
	  "deleo",
	  "delibero",
	  "delicate",
	  "delinquo",
	  "deludo",
	  "demens",
	  "demergo",
	  "demitto",
	  "demo",
	  "demonstro",
	  "demoror",
	  "demulceo",
	  "demum",
	  "denego",
	  "denique",
	  "dens",
	  "denuncio",
	  "denuo",
	  "deorsum",
	  "depereo",
	  "depono",
	  "depopulo",
	  "deporto",
	  "depraedor",
	  "deprecator",
	  "deprimo",
	  "depromo",
	  "depulso",
	  "deputo",
	  "derelinquo",
	  "derideo",
	  "deripio",
	  "desidero",
	  "desino",
	  "desipio",
	  "desolo",
	  "desparatus",
	  "despecto",
	  "despirmatio",
	  "infit",
	  "inflammatio",
	  "paens",
	  "patior",
	  "patria",
	  "patrocinor",
	  "patruus",
	  "pauci",
	  "paulatim",
	  "pauper",
	  "pax",
	  "peccatus",
	  "pecco",
	  "pecto",
	  "pectus",
	  "pecunia",
	  "pecus",
	  "peior",
	  "pel",
	  "ocer",
	  "socius",
	  "sodalitas",
	  "sol",
	  "soleo",
	  "solio",
	  "solitudo",
	  "solium",
	  "sollers",
	  "sollicito",
	  "solum",
	  "solus",
	  "solutio",
	  "solvo",
	  "somniculosus",
	  "somnus",
	  "sonitus",
	  "sono",
	  "sophismata",
	  "sopor",
	  "sordeo",
	  "sortitus",
	  "spargo",
	  "speciosus",
	  "spectaculum",
	  "speculum",
	  "sperno",
	  "spero",
	  "spes",
	  "spiculum",
	  "spiritus",
	  "spoliatio",
	  "sponte",
	  "stabilis",
	  "statim",
	  "statua",
	  "stella",
	  "stillicidium",
	  "stipes",
	  "stips",
	  "sto",
	  "strenuus",
	  "strues",
	  "studio",
	  "stultus",
	  "suadeo",
	  "suasoria",
	  "sub",
	  "subito",
	  "subiungo",
	  "sublime",
	  "subnecto",
	  "subseco",
	  "substantia",
	  "subvenio",
	  "succedo",
	  "succurro",
	  "sufficio",
	  "suffoco",
	  "suffragium",
	  "suggero",
	  "sui",
	  "sulum",
	  "sum",
	  "summa",
	  "summisse",
	  "summopere",
	  "sumo",
	  "sumptus",
	  "supellex",
	  "super",
	  "suppellex",
	  "supplanto",
	  "suppono",
	  "supra",
	  "surculus",
	  "surgo",
	  "sursum",
	  "suscipio",
	  "suspendo",
	  "sustineo",
	  "suus",
	  "synagoga",
	  "tabella",
	  "tabernus",
	  "tabesco",
	  "tabgo",
	  "tabula",
	  "taceo",
	  "tactus",
	  "taedium",
	  "talio",
	  "talis",
	  "talus",
	  "tam",
	  "tamdiu",
	  "tamen",
	  "tametsi",
	  "tamisium",
	  "tamquam",
	  "tandem",
	  "tantillus",
	  "tantum",
	  "tardus",
	  "tego",
	  "temeritas",
	  "temperantia",
	  "templum",
	  "temptatio",
	  "tempus",
	  "tenax",
	  "tendo",
	  "teneo",
	  "tener",
	  "tenuis",
	  "tenus",
	  "tepesco",
	  "tepidus",
	  "ter",
	  "terebro",
	  "teres",
	  "terga",
	  "tergeo",
	  "tergiversatio",
	  "tergo",
	  "tergum",
	  "termes",
	  "terminatio",
	  "tero",
	  "terra",
	  "terreo",
	  "territo",
	  "terror",
	  "tersus",
	  "tertius",
	  "testimonium",
	  "texo",
	  "textilis",
	  "textor",
	  "textus",
	  "thalassinus",
	  "theatrum",
	  "theca",
	  "thema",
	  "theologus",
	  "thermae",
	  "thesaurus",
	  "thesis",
	  "thorax",
	  "thymbra",
	  "thymum",
	  "tibi",
	  "timidus",
	  "timor",
	  "titulus",
	  "tolero",
	  "tollo",
	  "tondeo",
	  "tonsor",
	  "torqueo",
	  "torrens",
	  "tot",
	  "totidem",
	  "toties",
	  "totus",
	  "tracto",
	  "trado",
	  "traho",
	  "trans",
	  "tredecim",
	  "tremo",
	  "trepide",
	  "tres",
	  "tribuo",
	  "tricesimus",
	  "triduana",
	  "triginta",
	  "tripudio",
	  "tristis",
	  "triumphus",
	  "trucido",
	  "truculenter",
	  "tubineus",
	  "tui",
	  "tum",
	  "tumultus",
	  "tunc",
	  "turba",
	  "turbo",
	  "turpe",
	  "turpis",
	  "tutamen",
	  "tutis",
	  "tyrannus",
	  "uberrime",
	  "ubi",
	  "ulciscor",
	  "ullus",
	  "ulterius",
	  "ultio",
	  "ultra",
	  "umbra",
	  "umerus",
	  "umquam",
	  "una",
	  "unde",
	  "undique",
	  "universe",
	  "unus",
	  "urbanus",
	  "urbs",
	  "uredo",
	  "usitas",
	  "usque",
	  "ustilo",
	  "ustulo",
	  "usus",
	  "uter",
	  "uterque",
	  "utilis",
	  "utique",
	  "utor",
	  "utpote",
	  "utrimque",
	  "utroque",
	  "utrum",
	  "uxor",
	  "vaco",
	  "vacuus",
	  "vado",
	  "vae",
	  "valde",
	  "valens",
	  "valeo",
	  "valetudo",
	  "validus",
	  "vallum",
	  "vapulus",
	  "varietas",
	  "varius",
	  "vehemens",
	  "vel",
	  "velociter",
	  "velum",
	  "velut",
	  "venia",
	  "venio",
	  "ventito",
	  "ventosus",
	  "ventus",
	  "venustas",
	  "ver",
	  "verbera",
	  "verbum",
	  "vere",
	  "verecundia",
	  "vereor",
	  "vergo",
	  "veritas",
	  "vero",
	  "versus",
	  "verto",
	  "verumtamen",
	  "verus",
	  "vesco",
	  "vesica",
	  "vesper",
	  "vespillo",
	  "vester",
	  "vestigium",
	  "vestrum",
	  "vetus",
	  "via",
	  "vicinus",
	  "vicissitudo",
	  "victoria",
	  "victus",
	  "videlicet",
	  "video",
	  "viduata",
	  "viduo",
	  "vigilo",
	  "vigor",
	  "vilicus",
	  "vilis",
	  "vilitas",
	  "villa",
	  "vinco",
	  "vinculum",
	  "vindico",
	  "vinitor",
	  "vinum",
	  "vir",
	  "virga",
	  "virgo",
	  "viridis",
	  "viriliter",
	  "virtus",
	  "vis",
	  "viscus",
	  "vita",
	  "vitiosus",
	  "vitium",
	  "vito",
	  "vivo",
	  "vix",
	  "vobis",
	  "vociferor",
	  "voco",
	  "volaticus",
	  "volo",
	  "volubilis",
	  "voluntarius",
	  "volup",
	  "volutabrum",
	  "volva",
	  "vomer",
	  "vomica",
	  "vomito",
	  "vorago",
	  "vorax",
	  "voro",
	  "vos",
	  "votum",
	  "voveo",
	  "vox",
	  "vulariter",
	  "vulgaris",
	  "vulgivagus",
	  "vulgo",
	  "vulgus",
	  "vulnero",
	  "vulnus",
	  "vulpes",
	  "vulticulus",
	  "vultuosus",
	  "xiphias"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Amber",
	  "Anna",
	  "Anne",
	  "Anouk",
	  "Bas",
	  "Bram",
	  "Britt",
	  "Daan",
	  "Emma",
	  "Eva",
	  "Femke",
	  "Finn",
	  "Fleur",
	  "Iris",
	  "Isa",
	  "Jan",
	  "Jasper",
	  "Jayden",
	  "Jesse",
	  "Johannes",
	  "Julia",
	  "Julian",
	  "Kevin",
	  "Lars",
	  "Lieke",
	  "Lisa",
	  "Lotte",
	  "Lucas",
	  "Luuk",
	  "Maud",
	  "Max",
	  "Mike",
	  "Milan",
	  "Nick",
	  "Niels",
	  "Noa",
	  "Rick",
	  "Roos",
	  "Ruben",
	  "Sander",
	  "Sanne",
	  "Sem",
	  "Sophie",
	  "Stijn",
	  "Sven",
	  "Thijs",
	  "Thijs",
	  "Thomas",
	  "Tim",
	  "Tom"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(987);
	name.tussenvoegsel = __webpack_require__(993);
	name.last_name = __webpack_require__(989);
	name.prefix = __webpack_require__(991);
	name.suffix = __webpack_require__(992);
	name.name = __webpack_require__(990);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bakker",
	  "Beek",
	  "Berg",
	  "Boer",
	  "Bos",
	  "Bosch",
	  "Brink",
	  "Broek",
	  "Brouwer",
	  "Bruin",
	  "Dam",
	  "Dekker",
	  "Dijk",
	  "Dijkstra",
	  "Graaf",
	  "Groot",
	  "Haan",
	  "Hendriks",
	  "Heuvel",
	  "Hoek",
	  "Jacobs",
	  "Jansen",
	  "Janssen",
	  "Jong",
	  "Klein",
	  "Kok",
	  "Koning",
	  "Koster",
	  "Leeuwen",
	  "Linden",
	  "Maas",
	  "Meer",
	  "Meijer",
	  "Mulder",
	  "Peters",
	  "Ruiter",
	  "Schouten",
	  "Smit",
	  "Smits",
	  "Stichting",
	  "Veen",
	  "Ven",
	  "Vermeulen",
	  "Visser",
	  "Vliet",
	  "Vos",
	  "Vries",
	  "Wal",
	  "Willems",
	  "Wit"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name} #{suffix}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{tussenvoegsel} #{last_name}",
	  "#{first_name} #{tussenvoegsel} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Dhr.",
	  "Mevr. Dr.",
	  "Bsc",
	  "Msc",
	  "Prof."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Jr.",
	  "Sr.",
	  "I",
	  "II",
	  "III",
	  "IV",
	  "V"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "van",
	  "van de",
	  "van den",
	  "van 't",
	  "van het",
	  "de",
	  "den"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(####) ######",
	  "##########",
	  "06########",
	  "06 #### ####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(994);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "####",
	  "###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aleksandrów Kujawski",
	  "Aleksandrów Łódzki",
	  "Alwernia",
	  "Andrychów",
	  "Annopol",
	  "Augustów",
	  "Babimost",
	  "Baborów",
	  "Baranów Sandomierski",
	  "Barcin",
	  "Barczewo",
	  "Bardo",
	  "Barlinek",
	  "Bartoszyce",
	  "Barwice",
	  "Bełchatów",
	  "Bełżyce",
	  "Będzin",
	  "Biała",
	  "Biała Piska",
	  "Biała Podlaska",
	  "Biała Rawska",
	  "Białobrzegi",
	  "Białogard",
	  "Biały Bór",
	  "Białystok",
	  "Biecz",
	  "Bielawa",
	  "Bielsk Podlaski",
	  "Bielsko-Biała",
	  "Bieruń",
	  "Bierutów",
	  "Bieżuń",
	  "Biłgoraj",
	  "Biskupiec",
	  "Bisztynek",
	  "Blachownia",
	  "Błaszki",
	  "Błażowa",
	  "Błonie",
	  "Bobolice",
	  "Bobowa",
	  "Bochnia",
	  "Bodzentyn",
	  "Bogatynia",
	  "Boguchwała",
	  "Boguszów-Gorce",
	  "Bojanowo",
	  "Bolesławiec",
	  "Bolków",
	  "Borek Wielkopolski",
	  "Borne Sulinowo",
	  "Braniewo",
	  "Brańsk",
	  "Brodnica",
	  "Brok",
	  "Brusy",
	  "Brwinów",
	  "Brzeg",
	  "Brzeg Dolny",
	  "Brzesko",
	  "Brzeszcze",
	  "Brześć Kujawski",
	  "Brzeziny",
	  "Brzostek",
	  "Brzozów",
	  "Buk",
	  "Bukowno",
	  "Busko-Zdrój",
	  "Bychawa",
	  "Byczyna",
	  "Bydgoszcz",
	  "Bystrzyca Kłodzka",
	  "Bytom",
	  "Bytom Odrzański",
	  "Bytów",
	  "Cedynia",
	  "Chełm",
	  "Chełmek",
	  "Chełmno",
	  "Chełmża",
	  "Chęciny",
	  "Chmielnik",
	  "Chocianów",
	  "Chociwel",
	  "Chodecz",
	  "Chodzież",
	  "Chojna",
	  "Chojnice",
	  "Chojnów",
	  "Choroszcz",
	  "Chorzele",
	  "Chorzów",
	  "Choszczno",
	  "Chrzanów",
	  "Ciechanowiec",
	  "Ciechanów",
	  "Ciechocinek",
	  "Cieszanów",
	  "Cieszyn",
	  "Ciężkowice",
	  "Cybinka",
	  "Czaplinek",
	  "Czarna Białostocka",
	  "Czarna Woda",
	  "Czarne",
	  "Czarnków",
	  "Czchów",
	  "Czechowice-Dziedzice",
	  "Czeladź",
	  "Czempiń",
	  "Czerniejewo",
	  "Czersk",
	  "Czerwieńsk",
	  "Czerwionka-Leszczyny",
	  "Częstochowa",
	  "Człopa",
	  "Człuchów",
	  "Czyżew",
	  "Ćmielów",
	  "Daleszyce",
	  "Darłowo",
	  "Dąbie",
	  "Dąbrowa Białostocka",
	  "Dąbrowa Górnicza",
	  "Dąbrowa Tarnowska",
	  "Debrzno",
	  "Dębica",
	  "Dęblin",
	  "Dębno",
	  "Dobczyce",
	  "Dobiegniew",
	  "Dobra (powiat łobeski)",
	  "Dobra (powiat turecki)",
	  "Dobre Miasto",
	  "Dobrodzień",
	  "Dobrzany",
	  "Dobrzyń nad Wisłą",
	  "Dolsk",
	  "Drawno",
	  "Drawsko Pomorskie",
	  "Drezdenko",
	  "Drobin",
	  "Drohiczyn",
	  "Drzewica",
	  "Dukla",
	  "Duszniki-Zdrój",
	  "Dynów",
	  "Działdowo",
	  "Działoszyce",
	  "Działoszyn",
	  "Dzierzgoń",
	  "Dzierżoniów",
	  "Dziwnów",
	  "Elbląg",
	  "Ełk",
	  "Frampol",
	  "Frombork",
	  "Garwolin",
	  "Gąbin",
	  "Gdańsk",
	  "Gdynia",
	  "Giżycko",
	  "Glinojeck",
	  "Gliwice",
	  "Głogów",
	  "Głogów Małopolski",
	  "Głogówek",
	  "Głowno",
	  "Głubczyce",
	  "Głuchołazy",
	  "Głuszyca",
	  "Gniew",
	  "Gniewkowo",
	  "Gniezno",
	  "Gogolin",
	  "Golczewo",
	  "Goleniów",
	  "Golina",
	  "Golub-Dobrzyń",
	  "Gołańcz",
	  "Gołdap",
	  "Goniądz",
	  "Gorlice",
	  "Gorzów Śląski",
	  "Gorzów Wielkopolski",
	  "Gostynin",
	  "Gostyń",
	  "Gościno",
	  "Gozdnica",
	  "Góra",
	  "Góra Kalwaria",
	  "Górowo Iławeckie",
	  "Górzno",
	  "Grabów nad Prosną",
	  "Grajewo",
	  "Grodków",
	  "Grodzisk Mazowiecki",
	  "Grodzisk Wielkopolski",
	  "Grójec",
	  "Grudziądz",
	  "Grybów",
	  "Gryfice",
	  "Gryfino",
	  "Gryfów Śląski",
	  "Gubin",
	  "Hajnówka",
	  "Halinów",
	  "Hel",
	  "Hrubieszów",
	  "Iława",
	  "Iłowa",
	  "Iłża",
	  "Imielin",
	  "Inowrocław",
	  "Ińsko",
	  "Iwonicz-Zdrój",
	  "Izbica Kujawska",
	  "Jabłonowo Pomorskie",
	  "Janikowo",
	  "Janowiec Wielkopolski",
	  "Janów Lubelski",
	  "Jarocin",
	  "Jarosław",
	  "Jasień",
	  "Jasło",
	  "Jastarnia",
	  "Jastrowie",
	  "Jastrzębie-Zdrój",
	  "Jawor",
	  "Jaworzno",
	  "Jaworzyna Śląska",
	  "Jedlicze",
	  "Jedlina-Zdrój",
	  "Jedwabne",
	  "Jelcz-Laskowice",
	  "Jelenia Góra",
	  "Jeziorany",
	  "Jędrzejów",
	  "Jordanów",
	  "Józefów (powiat biłgorajski)",
	  "Józefów (powiat otwocki)",
	  "Jutrosin",
	  "Kalety",
	  "Kalisz",
	  "Kalisz Pomorski",
	  "Kalwaria Zebrzydowska",
	  "Kałuszyn",
	  "Kamienna Góra",
	  "Kamień Krajeński",
	  "Kamień Pomorski",
	  "Kamieńsk",
	  "Kańczuga",
	  "Karczew",
	  "Kargowa",
	  "Karlino",
	  "Karpacz",
	  "Kartuzy",
	  "Katowice",
	  "Kazimierz Dolny",
	  "Kazimierza Wielka",
	  "Kąty Wrocławskie",
	  "Kcynia",
	  "Kędzierzyn-Koźle",
	  "Kępice",
	  "Kępno",
	  "Kętrzyn",
	  "Kęty",
	  "Kielce",
	  "Kietrz",
	  "Kisielice",
	  "Kleczew",
	  "Kleszczele",
	  "Kluczbork",
	  "Kłecko",
	  "Kłobuck",
	  "Kłodawa",
	  "Kłodzko",
	  "Knurów",
	  "Knyszyn",
	  "Kobylin",
	  "Kobyłka",
	  "Kock",
	  "Kolbuszowa",
	  "Kolno",
	  "Kolonowskie",
	  "Koluszki",
	  "Kołaczyce",
	  "Koło",
	  "Kołobrzeg",
	  "Koniecpol",
	  "Konin",
	  "Konstancin-Jeziorna",
	  "Konstantynów Łódzki",
	  "Końskie",
	  "Koprzywnica",
	  "Korfantów",
	  "Koronowo",
	  "Korsze",
	  "Kosów Lacki",
	  "Kostrzyn",
	  "Kostrzyn nad Odrą",
	  "Koszalin",
	  "Kościan",
	  "Kościerzyna",
	  "Kowal",
	  "Kowalewo Pomorskie",
	  "Kowary",
	  "Koziegłowy",
	  "Kozienice",
	  "Koźmin Wielkopolski",
	  "Kożuchów",
	  "Kórnik",
	  "Krajenka",
	  "Kraków",
	  "Krapkowice",
	  "Krasnobród",
	  "Krasnystaw",
	  "Kraśnik",
	  "Krobia",
	  "Krosno",
	  "Krosno Odrzańskie",
	  "Krośniewice",
	  "Krotoszyn",
	  "Kruszwica",
	  "Krynica Morska",
	  "Krynica-Zdrój",
	  "Krynki",
	  "Krzanowice",
	  "Krzepice",
	  "Krzeszowice",
	  "Krzywiń",
	  "Krzyż Wielkopolski",
	  "Książ Wielkopolski",
	  "Kudowa-Zdrój",
	  "Kunów",
	  "Kutno",
	  "Kuźnia Raciborska",
	  "Kwidzyn",
	  "Lądek-Zdrój",
	  "Legionowo",
	  "Legnica",
	  "Lesko",
	  "Leszno",
	  "Leśna",
	  "Leśnica",
	  "Lewin Brzeski",
	  "Leżajsk",
	  "Lębork",
	  "Lędziny",
	  "Libiąż",
	  "Lidzbark",
	  "Lidzbark Warmiński",
	  "Limanowa",
	  "Lipiany",
	  "Lipno",
	  "Lipsk",
	  "Lipsko",
	  "Lubaczów",
	  "Lubań",
	  "Lubartów",
	  "Lubawa",
	  "Lubawka",
	  "Lubień Kujawski",
	  "Lubin",
	  "Lublin",
	  "Lubliniec",
	  "Lubniewice",
	  "Lubomierz",
	  "Luboń",
	  "Lubraniec",
	  "Lubsko",
	  "Lwówek",
	  "Lwówek Śląski",
	  "Łabiszyn",
	  "Łańcut",
	  "Łapy",
	  "Łasin",
	  "Łask",
	  "Łaskarzew",
	  "Łaszczów",
	  "Łaziska Górne",
	  "Łazy",
	  "Łeba",
	  "Łęczna",
	  "Łęczyca",
	  "Łęknica",
	  "Łobez",
	  "Łobżenica",
	  "Łochów",
	  "Łomianki",
	  "Łomża",
	  "Łosice",
	  "Łowicz",
	  "Łódź",
	  "Łuków",
	  "Maków Mazowiecki",
	  "Maków Podhalański",
	  "Malbork",
	  "Małogoszcz",
	  "Małomice",
	  "Margonin",
	  "Marki",
	  "Maszewo",
	  "Miasteczko Śląskie",
	  "Miastko",
	  "Michałowo",
	  "Miechów",
	  "Miejska Górka",
	  "Mielec",
	  "Mieroszów",
	  "Mieszkowice",
	  "Międzybórz",
	  "Międzychód",
	  "Międzylesie",
	  "Międzyrzec Podlaski",
	  "Międzyrzecz",
	  "Międzyzdroje",
	  "Mikołajki",
	  "Mikołów",
	  "Mikstat",
	  "Milanówek",
	  "Milicz",
	  "Miłakowo",
	  "Miłomłyn",
	  "Miłosław",
	  "Mińsk Mazowiecki",
	  "Mirosławiec",
	  "Mirsk",
	  "Mława",
	  "Młynary",
	  "Mogielnica",
	  "Mogilno",
	  "Mońki",
	  "Morąg",
	  "Mordy",
	  "Moryń",
	  "Mosina",
	  "Mrągowo",
	  "Mrocza",
	  "Mszana Dolna",
	  "Mszczonów",
	  "Murowana Goślina",
	  "Muszyna",
	  "Mysłowice",
	  "Myszków",
	  "Myszyniec",
	  "Myślenice",
	  "Myślibórz",
	  "Nakło nad Notecią",
	  "Nałęczów",
	  "Namysłów",
	  "Narol",
	  "Nasielsk",
	  "Nekla",
	  "Nidzica",
	  "Niemcza",
	  "Niemodlin",
	  "Niepołomice",
	  "Nieszawa",
	  "Nisko",
	  "Nowa Dęba",
	  "Nowa Ruda",
	  "Nowa Sarzyna",
	  "Nowa Sól",
	  "Nowe",
	  "Nowe Brzesko",
	  "Nowe Miasteczko",
	  "Nowe Miasto Lubawskie",
	  "Nowe Miasto nad Pilicą",
	  "Nowe Skalmierzyce",
	  "Nowe Warpno",
	  "Nowogard",
	  "Nowogrodziec",
	  "Nowogród",
	  "Nowogród Bobrzański",
	  "Nowy Dwór Gdański",
	  "Nowy Dwór Mazowiecki",
	  "Nowy Sącz",
	  "Nowy Staw",
	  "Nowy Targ",
	  "Nowy Tomyśl",
	  "Nowy Wiśnicz",
	  "Nysa",
	  "Oborniki",
	  "Oborniki Śląskie",
	  "Obrzycko",
	  "Odolanów",
	  "Ogrodzieniec",
	  "Okonek",
	  "Olecko",
	  "Olesno",
	  "Oleszyce",
	  "Oleśnica",
	  "Olkusz",
	  "Olsztyn",
	  "Olsztynek",
	  "Olszyna",
	  "Oława",
	  "Opalenica",
	  "Opatów",
	  "Opoczno",
	  "Opole",
	  "Opole Lubelskie",
	  "Orneta",
	  "Orzesze",
	  "Orzysz",
	  "Osieczna",
	  "Osiek",
	  "Ostrołęka",
	  "Ostroróg",
	  "Ostrowiec Świętokrzyski",
	  "Ostróda",
	  "Ostrów Lubelski",
	  "Ostrów Mazowiecka",
	  "Ostrów Wielkopolski",
	  "Ostrzeszów",
	  "Ośno Lubuskie",
	  "Oświęcim",
	  "Otmuchów",
	  "Otwock",
	  "Ozimek",
	  "Ozorków",
	  "Ożarów",
	  "Ożarów Mazowiecki",
	  "Pabianice",
	  "Paczków",
	  "Pajęczno",
	  "Pakość",
	  "Parczew",
	  "Pasłęk",
	  "Pasym",
	  "Pelplin",
	  "Pełczyce",
	  "Piaseczno",
	  "Piaski",
	  "Piastów",
	  "Piechowice",
	  "Piekary Śląskie",
	  "Pieniężno",
	  "Pieńsk",
	  "Pieszyce",
	  "Pilawa",
	  "Pilica",
	  "Pilzno",
	  "Piła",
	  "Piława Górna",
	  "Pińczów",
	  "Pionki",
	  "Piotrków Kujawski",
	  "Piotrków Trybunalski",
	  "Pisz",
	  "Piwniczna-Zdrój",
	  "Pleszew",
	  "Płock",
	  "Płońsk",
	  "Płoty",
	  "Pniewy",
	  "Pobiedziska",
	  "Poddębice",
	  "Podkowa Leśna",
	  "Pogorzela",
	  "Polanica-Zdrój",
	  "Polanów",
	  "Police",
	  "Polkowice",
	  "Połaniec",
	  "Połczyn-Zdrój",
	  "Poniatowa",
	  "Poniec",
	  "Poręba",
	  "Poznań",
	  "Prabuty",
	  "Praszka",
	  "Prochowice",
	  "Proszowice",
	  "Prószków",
	  "Pruchnik",
	  "Prudnik",
	  "Prusice",
	  "Pruszcz Gdański",
	  "Pruszków",
	  "Przasnysz",
	  "Przecław",
	  "Przedbórz",
	  "Przedecz",
	  "Przemków",
	  "Przemyśl",
	  "Przeworsk",
	  "Przysucha",
	  "Pszczyna",
	  "Pszów",
	  "Puck",
	  "Puławy",
	  "Pułtusk",
	  "Puszczykowo",
	  "Pyrzyce",
	  "Pyskowice",
	  "Pyzdry",
	  "Rabka-Zdrój",
	  "Raciąż",
	  "Racibórz",
	  "Radków",
	  "Radlin",
	  "Radłów",
	  "Radom",
	  "Radomsko",
	  "Radomyśl Wielki",
	  "Radymno",
	  "Radziejów",
	  "Radzionków",
	  "Radzymin",
	  "Radzyń Chełmiński",
	  "Radzyń Podlaski",
	  "Rajgród",
	  "Rakoniewice",
	  "Raszków",
	  "Rawa Mazowiecka",
	  "Rawicz",
	  "Recz",
	  "Reda",
	  "Rejowiec Fabryczny",
	  "Resko",
	  "Reszel",
	  "Rogoźno",
	  "Ropczyce",
	  "Różan",
	  "Ruciane-Nida",
	  "Ruda Śląska",
	  "Rudnik nad Sanem",
	  "Rumia",
	  "Rybnik",
	  "Rychwał",
	  "Rydułtowy",
	  "Rydzyna",
	  "Ryglice",
	  "Ryki",
	  "Rymanów",
	  "Ryn",
	  "Rypin",
	  "Rzepin",
	  "Rzeszów",
	  "Rzgów",
	  "Sandomierz",
	  "Sanok",
	  "Sejny",
	  "Serock",
	  "Sędziszów",
	  "Sędziszów Małopolski",
	  "Sępopol",
	  "Sępólno Krajeńskie",
	  "Sianów",
	  "Siechnice",
	  "Siedlce",
	  "Siemianowice Śląskie",
	  "Siemiatycze",
	  "Sieniawa",
	  "Sieradz",
	  "Sieraków",
	  "Sierpc",
	  "Siewierz",
	  "Skalbmierz",
	  "Skała",
	  "Skarszewy",
	  "Skaryszew",
	  "Skarżysko-Kamienna",
	  "Skawina",
	  "Skępe",
	  "Skierniewice",
	  "Skoczów",
	  "Skoki",
	  "Skórcz",
	  "Skwierzyna",
	  "Sława",
	  "Sławków",
	  "Sławno",
	  "Słomniki",
	  "Słubice",
	  "Słupca",
	  "Słupsk",
	  "Sobótka",
	  "Sochaczew",
	  "Sokołów Małopolski",
	  "Sokołów Podlaski",
	  "Sokółka",
	  "Solec Kujawski",
	  "Sompolno",
	  "Sopot",
	  "Sosnowiec",
	  "Sośnicowice",
	  "Stalowa Wola",
	  "Starachowice",
	  "Stargard Szczeciński",
	  "Starogard Gdański",
	  "Stary Sącz",
	  "Staszów",
	  "Stawiski",
	  "Stawiszyn",
	  "Stąporków",
	  "Stęszew",
	  "Stoczek Łukowski",
	  "Stronie Śląskie",
	  "Strumień",
	  "Stryków",
	  "Strzegom",
	  "Strzelce Krajeńskie",
	  "Strzelce Opolskie",
	  "Strzelin",
	  "Strzelno",
	  "Strzyżów",
	  "Sucha Beskidzka",
	  "Suchań",
	  "Suchedniów",
	  "Suchowola",
	  "Sulechów",
	  "Sulejów",
	  "Sulejówek",
	  "Sulęcin",
	  "Sulmierzyce",
	  "Sułkowice",
	  "Supraśl",
	  "Suraż",
	  "Susz",
	  "Suwałki",
	  "Swarzędz",
	  "Syców",
	  "Szadek",
	  "Szamocin",
	  "Szamotuły",
	  "Szczawnica",
	  "Szczawno-Zdrój",
	  "Szczebrzeszyn",
	  "Szczecin",
	  "Szczecinek",
	  "Szczekociny",
	  "Szczucin",
	  "Szczuczyn",
	  "Szczyrk",
	  "Szczytna",
	  "Szczytno",
	  "Szepietowo",
	  "Szklarska Poręba",
	  "Szlichtyngowa",
	  "Szprotawa",
	  "Sztum",
	  "Szubin",
	  "Szydłowiec",
	  "Ścinawa",
	  "Ślesin",
	  "Śmigiel",
	  "Śrem",
	  "Środa Śląska",
	  "Środa Wielkopolska",
	  "Świątniki Górne",
	  "Świdnica",
	  "Świdnik",
	  "Świdwin",
	  "Świebodzice",
	  "Świebodzin",
	  "Świecie",
	  "Świeradów-Zdrój",
	  "Świerzawa",
	  "Świętochłowice",
	  "Świnoujście",
	  "Tarczyn",
	  "Tarnobrzeg",
	  "Tarnogród",
	  "Tarnowskie Góry",
	  "Tarnów",
	  "Tczew",
	  "Terespol",
	  "Tłuszcz",
	  "Tolkmicko",
	  "Tomaszów Lubelski",
	  "Tomaszów Mazowiecki",
	  "Toruń",
	  "Torzym",
	  "Toszek",
	  "Trzcianka",
	  "Trzciel",
	  "Trzcińsko-Zdrój",
	  "Trzebiatów",
	  "Trzebinia",
	  "Trzebnica",
	  "Trzemeszno",
	  "Tuchola",
	  "Tuchów",
	  "Tuczno",
	  "Tuliszków",
	  "Turek",
	  "Tuszyn",
	  "Twardogóra",
	  "Tychowo",
	  "Tychy",
	  "Tyczyn",
	  "Tykocin",
	  "Tyszowce",
	  "Ujazd",
	  "Ujście",
	  "Ulanów",
	  "Uniejów",
	  "Ustka",
	  "Ustroń",
	  "Ustrzyki Dolne",
	  "Wadowice",
	  "Wałbrzych",
	  "Wałcz",
	  "Warka",
	  "Warszawa",
	  "Warta",
	  "Wasilków",
	  "Wąbrzeźno",
	  "Wąchock",
	  "Wągrowiec",
	  "Wąsosz",
	  "Wejherowo",
	  "Węgliniec",
	  "Węgorzewo",
	  "Węgorzyno",
	  "Węgrów",
	  "Wiązów",
	  "Wieleń",
	  "Wielichowo",
	  "Wieliczka",
	  "Wieluń",
	  "Wieruszów",
	  "Więcbork",
	  "Wilamowice",
	  "Wisła",
	  "Witkowo",
	  "Witnica",
	  "Wleń",
	  "Władysławowo",
	  "Włocławek",
	  "Włodawa",
	  "Włoszczowa",
	  "Wodzisław Śląski",
	  "Wojcieszów",
	  "Wojkowice",
	  "Wojnicz",
	  "Wolbórz",
	  "Wolbrom",
	  "Wolin",
	  "Wolsztyn",
	  "Wołczyn",
	  "Wołomin",
	  "Wołów",
	  "Woźniki",
	  "Wrocław",
	  "Wronki",
	  "Września",
	  "Wschowa",
	  "Wyrzysk",
	  "Wysoka",
	  "Wysokie Mazowieckie",
	  "Wyszków",
	  "Wyszogród",
	  "Wyśmierzyce",
	  "Zabłudów",
	  "Zabrze",
	  "Zagórów",
	  "Zagórz",
	  "Zakliczyn",
	  "Zakopane",
	  "Zakroczym",
	  "Zalewo",
	  "Zambrów",
	  "Zamość",
	  "Zator",
	  "Zawadzkie",
	  "Zawichost",
	  "Zawidów",
	  "Zawiercie",
	  "Ząbki",
	  "Ząbkowice Śląskie",
	  "Zbąszynek",
	  "Zbąszyń",
	  "Zduny",
	  "Zduńska Wola",
	  "Zdzieszowice",
	  "Zelów",
	  "Zgierz",
	  "Zgorzelec",
	  "Zielona Góra",
	  "Zielonka",
	  "Ziębice",
	  "Złocieniec",
	  "Złoczew",
	  "Złotoryja",
	  "Złotów",
	  "Złoty Stok",
	  "Zwierzyniec",
	  "Zwoleń",
	  "Żabno",
	  "Żagań",
	  "Żarki",
	  "Żarów",
	  "Żary",
	  "Żelechów",
	  "Żerków",
	  "Żmigród",
	  "Żnin",
	  "Żory",
	  "Żukowo",
	  "Żuromin",
	  "Żychlin",
	  "Żyrardów",
	  "Żywiec"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afganistan",
	  "Albania",
	  "Algieria",
	  "Andora",
	  "Angola",
	  "Antigua i Barbuda",
	  "Arabia Saudyjska",
	  "Argentyna",
	  "Armenia",
	  "Australia",
	  "Austria",
	  "Azerbejdżan",
	  "Bahamy",
	  "Bahrajn",
	  "Bangladesz",
	  "Barbados",
	  "Belgia",
	  "Belize",
	  "Benin",
	  "Bhutan",
	  "Białoruś",
	  "Birma",
	  "Boliwia",
	  "Sucre",
	  "Bośnia i Hercegowina",
	  "Botswana",
	  "Brazylia",
	  "Brunei",
	  "Bułgaria",
	  "Burkina Faso",
	  "Burundi",
	  "Chile",
	  "Chiny",
	  "Chorwacja",
	  "Cypr",
	  "Czad",
	  "Czarnogóra",
	  "Czechy",
	  "Dania",
	  "Demokratyczna Republika Konga",
	  "Dominika",
	  "Dominikana",
	  "Dżibuti",
	  "Egipt",
	  "Ekwador",
	  "Erytrea",
	  "Estonia",
	  "Etiopia",
	  "Fidżi",
	  "Filipiny",
	  "Finlandia",
	  "Francja",
	  "Gabon",
	  "Gambia",
	  "Ghana",
	  "Grecja",
	  "Grenada",
	  "Gruzja",
	  "Gujana",
	  "Gwatemala",
	  "Gwinea",
	  "Gwinea Bissau",
	  "Gwinea Równikowa",
	  "Haiti",
	  "Hiszpania",
	  "Holandia",
	  "Haga",
	  "Honduras",
	  "Indie",
	  "Indonezja",
	  "Irak",
	  "Iran",
	  "Irlandia",
	  "Islandia",
	  "Izrael",
	  "Jamajka",
	  "Japonia",
	  "Jemen",
	  "Jordania",
	  "Kambodża",
	  "Kamerun",
	  "Kanada",
	  "Katar",
	  "Kazachstan",
	  "Kenia",
	  "Kirgistan",
	  "Kiribati",
	  "Kolumbia",
	  "Komory",
	  "Kongo",
	  "Korea Południowa",
	  "Korea Północna",
	  "Kostaryka",
	  "Kuba",
	  "Kuwejt",
	  "Laos",
	  "Lesotho",
	  "Liban",
	  "Liberia",
	  "Libia",
	  "Liechtenstein",
	  "Litwa",
	  "Luksemburg",
	  "Łotwa",
	  "Macedonia",
	  "Madagaskar",
	  "Malawi",
	  "Malediwy",
	  "Malezja",
	  "Mali",
	  "Malta",
	  "Maroko",
	  "Mauretania",
	  "Mauritius",
	  "Meksyk",
	  "Mikronezja",
	  "Mołdawia",
	  "Monako",
	  "Mongolia",
	  "Mozambik",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Niemcy",
	  "Niger",
	  "Nigeria",
	  "Nikaragua",
	  "Norwegia",
	  "Nowa Zelandia",
	  "Oman",
	  "Pakistan",
	  "Palau",
	  "Panama",
	  "Papua-Nowa Gwinea",
	  "Paragwaj",
	  "Peru",
	  "Polska",
	  "322 575",
	  "Portugalia",
	  "Republika Południowej Afryki",
	  "Republika Środkowoafrykańska",
	  "Republika Zielonego Przylądka",
	  "Rosja",
	  "Rumunia",
	  "Rwanda",
	  "Saint Kitts i Nevis",
	  "Saint Lucia",
	  "Saint Vincent i Grenadyny",
	  "Salwador",
	  "Samoa",
	  "San Marino",
	  "Senegal",
	  "Serbia",
	  "Seszele",
	  "Sierra Leone",
	  "Singapur",
	  "Słowacja",
	  "Słowenia",
	  "Somalia",
	  "Sri Lanka",
	  "Stany Zjednoczone",
	  "Suazi",
	  "Sudan",
	  "Sudan Południowy",
	  "Surinam",
	  "Syria",
	  "Szwajcaria",
	  "Szwecja",
	  "Tadżykistan",
	  "Tajlandia",
	  "Tanzania",
	  "Timor Wschodni",
	  "Togo",
	  "Tonga",
	  "Trynidad i Tobago",
	  "Tunezja",
	  "Turcja",
	  "Turkmenistan",
	  "Tuvalu",
	  "Funafuti",
	  "Uganda",
	  "Ukraina",
	  "Urugwaj",
	  2008,
	  "Uzbekistan",
	  "Vanuatu",
	  "Watykan",
	  "Wenezuela",
	  "Węgry",
	  "Wielka Brytania",
	  "Wietnam",
	  "Włochy",
	  "Wybrzeże Kości Słoniowej",
	  "Wyspy Marshalla",
	  "Wyspy Salomona",
	  "Wyspy Świętego Tomasza i Książęca",
	  "Zambia",
	  "Zimbabwe",
	  "Zjednoczone Emiraty Arabskie"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Polska"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.country = __webpack_require__(999);
	address.building_number = __webpack_require__(996);
	address.street_prefix = __webpack_require__(1008);
	address.secondary_address = __webpack_require__(1003);
	address.postcode = __webpack_require__(1002);
	address.state = __webpack_require__(1004);
	address.state_abbr = __webpack_require__(1005);
	address.city_name = __webpack_require__(998);
	address.city = __webpack_require__(997);
	address.street_name = __webpack_require__(1007);
	address.street_address = __webpack_require__(1006);
	address.default_country = __webpack_require__(1000);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "##-###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apt. ###",
	  "Suite ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Dolnośląskie",
	  "Kujawsko-pomorskie",
	  "Lubelskie",
	  "Lubuskie",
	  "Łódzkie",
	  "Małopolskie",
	  "Mazowieckie",
	  "Opolskie",
	  "Podkarpackie",
	  "Podlaskie",
	  "Pomorskie",
	  "Śląskie",
	  "Świętokrzyskie",
	  "Warmińsko-mazurskie",
	  "Wielkopolskie",
	  "Zachodniopomorskie"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "DŚ",
	  "KP",
	  "LB",
	  "LS",
	  "ŁD",
	  "MP",
	  "MZ",
	  "OP",
	  "PK",
	  "PL",
	  "PM",
	  "ŚL",
	  "ŚK",
	  "WM",
	  "WP",
	  "ZP"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_prefix} #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ul.",
	  "al."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "50-###-##-##",
	  "51-###-##-##",
	  "53-###-##-##",
	  "57-###-##-##",
	  "60-###-##-##",
	  "66-###-##-##",
	  "69-###-##-##",
	  "72-###-##-##",
	  "73-###-##-##",
	  "78-###-##-##",
	  "79-###-##-##",
	  "88-###-##-##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(1009);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adaptive",
	  "Advanced",
	  "Ameliorated",
	  "Assimilated",
	  "Automated",
	  "Balanced",
	  "Business-focused",
	  "Centralized",
	  "Cloned",
	  "Compatible",
	  "Configurable",
	  "Cross-group",
	  "Cross-platform",
	  "Customer-focused",
	  "Customizable",
	  "Decentralized",
	  "De-engineered",
	  "Devolved",
	  "Digitized",
	  "Distributed",
	  "Diverse",
	  "Down-sized",
	  "Enhanced",
	  "Enterprise-wide",
	  "Ergonomic",
	  "Exclusive",
	  "Expanded",
	  "Extended",
	  "Face to face",
	  "Focused",
	  "Front-line",
	  "Fully-configurable",
	  "Function-based",
	  "Fundamental",
	  "Future-proofed",
	  "Grass-roots",
	  "Horizontal",
	  "Implemented",
	  "Innovative",
	  "Integrated",
	  "Intuitive",
	  "Inverse",
	  "Managed",
	  "Mandatory",
	  "Monitored",
	  "Multi-channelled",
	  "Multi-lateral",
	  "Multi-layered",
	  "Multi-tiered",
	  "Networked",
	  "Object-based",
	  "Open-architected",
	  "Open-source",
	  "Operative",
	  "Optimized",
	  "Optional",
	  "Organic",
	  "Organized",
	  "Persevering",
	  "Persistent",
	  "Phased",
	  "Polarised",
	  "Pre-emptive",
	  "Proactive",
	  "Profit-focused",
	  "Profound",
	  "Programmable",
	  "Progressive",
	  "Public-key",
	  "Quality-focused",
	  "Reactive",
	  "Realigned",
	  "Re-contextualized",
	  "Re-engineered",
	  "Reduced",
	  "Reverse-engineered",
	  "Right-sized",
	  "Robust",
	  "Seamless",
	  "Secured",
	  "Self-enabling",
	  "Sharable",
	  "Stand-alone",
	  "Streamlined",
	  "Switchable",
	  "Synchronised",
	  "Synergistic",
	  "Synergized",
	  "Team-oriented",
	  "Total",
	  "Triple-buffered",
	  "Universal",
	  "Up-sized",
	  "Upgradable",
	  "User-centric",
	  "User-friendly",
	  "Versatile",
	  "Virtual",
	  "Visionary",
	  "Vision-oriented"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "clicks-and-mortar",
	  "value-added",
	  "vertical",
	  "proactive",
	  "robust",
	  "revolutionary",
	  "scalable",
	  "leading-edge",
	  "innovative",
	  "intuitive",
	  "strategic",
	  "e-business",
	  "mission-critical",
	  "sticky",
	  "one-to-one",
	  "24/7",
	  "end-to-end",
	  "global",
	  "B2B",
	  "B2C",
	  "granular",
	  "frictionless",
	  "virtual",
	  "viral",
	  "dynamic",
	  "24/365",
	  "best-of-breed",
	  "killer",
	  "magnetic",
	  "bleeding-edge",
	  "web-enabled",
	  "interactive",
	  "dot-com",
	  "sexy",
	  "back-end",
	  "real-time",
	  "efficient",
	  "front-end",
	  "distributed",
	  "seamless",
	  "extensible",
	  "turn-key",
	  "world-class",
	  "open-source",
	  "cross-platform",
	  "cross-media",
	  "synergistic",
	  "bricks-and-clicks",
	  "out-of-the-box",
	  "enterprise",
	  "integrated",
	  "impactful",
	  "wireless",
	  "transparent",
	  "next-generation",
	  "cutting-edge",
	  "user-centric",
	  "visionary",
	  "customized",
	  "ubiquitous",
	  "plug-and-play",
	  "collaborative",
	  "compelling",
	  "holistic",
	  "rich"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "synergies",
	  "web-readiness",
	  "paradigms",
	  "markets",
	  "partnerships",
	  "infrastructures",
	  "platforms",
	  "initiatives",
	  "channels",
	  "eyeballs",
	  "communities",
	  "ROI",
	  "solutions",
	  "e-tailers",
	  "e-services",
	  "action-items",
	  "portals",
	  "niches",
	  "technologies",
	  "content",
	  "vortals",
	  "supply-chains",
	  "convergence",
	  "relationships",
	  "architectures",
	  "interfaces",
	  "e-markets",
	  "e-commerce",
	  "systems",
	  "bandwidth",
	  "infomediaries",
	  "models",
	  "mindshare",
	  "deliverables",
	  "users",
	  "schemas",
	  "networks",
	  "applications",
	  "metrics",
	  "e-business",
	  "functionalities",
	  "experiences",
	  "web services",
	  "methodologies"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "implement",
	  "utilize",
	  "integrate",
	  "streamline",
	  "optimize",
	  "evolve",
	  "transform",
	  "embrace",
	  "enable",
	  "orchestrate",
	  "leverage",
	  "reinvent",
	  "aggregate",
	  "architect",
	  "enhance",
	  "incentivize",
	  "morph",
	  "empower",
	  "envisioneer",
	  "monetize",
	  "harness",
	  "facilitate",
	  "seize",
	  "disintermediate",
	  "synergize",
	  "strategize",
	  "deploy",
	  "brand",
	  "grow",
	  "target",
	  "syndicate",
	  "synthesize",
	  "deliver",
	  "mesh",
	  "incubate",
	  "engage",
	  "maximize",
	  "benchmark",
	  "expedite",
	  "reintermediate",
	  "whiteboard",
	  "visualize",
	  "repurpose",
	  "innovate",
	  "scale",
	  "unleash",
	  "drive",
	  "extend",
	  "engineer",
	  "revolutionize",
	  "generate",
	  "exploit",
	  "transition",
	  "e-enable",
	  "iterate",
	  "cultivate",
	  "matrix",
	  "productize",
	  "redefine",
	  "recontextualize"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 hour",
	  "24/7",
	  "3rd generation",
	  "4th generation",
	  "5th generation",
	  "6th generation",
	  "actuating",
	  "analyzing",
	  "asymmetric",
	  "asynchronous",
	  "attitude-oriented",
	  "background",
	  "bandwidth-monitored",
	  "bi-directional",
	  "bifurcated",
	  "bottom-line",
	  "clear-thinking",
	  "client-driven",
	  "client-server",
	  "coherent",
	  "cohesive",
	  "composite",
	  "context-sensitive",
	  "contextually-based",
	  "content-based",
	  "dedicated",
	  "demand-driven",
	  "didactic",
	  "directional",
	  "discrete",
	  "disintermediate",
	  "dynamic",
	  "eco-centric",
	  "empowering",
	  "encompassing",
	  "even-keeled",
	  "executive",
	  "explicit",
	  "exuding",
	  "fault-tolerant",
	  "foreground",
	  "fresh-thinking",
	  "full-range",
	  "global",
	  "grid-enabled",
	  "heuristic",
	  "high-level",
	  "holistic",
	  "homogeneous",
	  "human-resource",
	  "hybrid",
	  "impactful",
	  "incremental",
	  "intangible",
	  "interactive",
	  "intermediate",
	  "leading edge",
	  "local",
	  "logistical",
	  "maximized",
	  "methodical",
	  "mission-critical",
	  "mobile",
	  "modular",
	  "motivating",
	  "multimedia",
	  "multi-state",
	  "multi-tasking",
	  "national",
	  "needs-based",
	  "neutral",
	  "next generation",
	  "non-volatile",
	  "object-oriented",
	  "optimal",
	  "optimizing",
	  "radical",
	  "real-time",
	  "reciprocal",
	  "regional",
	  "responsive",
	  "scalable",
	  "secondary",
	  "solution-oriented",
	  "stable",
	  "static",
	  "systematic",
	  "systemic",
	  "system-worthy",
	  "tangible",
	  "tertiary",
	  "transitional",
	  "uniform",
	  "upward-trending",
	  "user-facing",
	  "value-added",
	  "web-enabled",
	  "well-modulated",
	  "zero administration",
	  "zero defect",
	  "zero tolerance"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(1019);
	company.adjetive = __webpack_require__(1011);
	company.descriptor = __webpack_require__(1015);
	company.noun = __webpack_require__(1018);
	company.bs_verb = __webpack_require__(1014);
	company.bs_adjective = __webpack_require__(1012);
	company.bs_noun = __webpack_require__(1013);
	company.name = __webpack_require__(1017);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} and #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ability",
	  "access",
	  "adapter",
	  "algorithm",
	  "alliance",
	  "analyzer",
	  "application",
	  "approach",
	  "architecture",
	  "archive",
	  "artificial intelligence",
	  "array",
	  "attitude",
	  "benchmark",
	  "budgetary management",
	  "capability",
	  "capacity",
	  "challenge",
	  "circuit",
	  "collaboration",
	  "complexity",
	  "concept",
	  "conglomeration",
	  "contingency",
	  "core",
	  "customer loyalty",
	  "database",
	  "data-warehouse",
	  "definition",
	  "emulation",
	  "encoding",
	  "encryption",
	  "extranet",
	  "firmware",
	  "flexibility",
	  "focus group",
	  "forecast",
	  "frame",
	  "framework",
	  "function",
	  "functionalities",
	  "Graphic Interface",
	  "groupware",
	  "Graphical User Interface",
	  "hardware",
	  "help-desk",
	  "hierarchy",
	  "hub",
	  "implementation",
	  "info-mediaries",
	  "infrastructure",
	  "initiative",
	  "installation",
	  "instruction set",
	  "interface",
	  "internet solution",
	  "intranet",
	  "knowledge user",
	  "knowledge base",
	  "local area network",
	  "leverage",
	  "matrices",
	  "matrix",
	  "methodology",
	  "middleware",
	  "migration",
	  "model",
	  "moderator",
	  "monitoring",
	  "moratorium",
	  "neural-net",
	  "open architecture",
	  "open system",
	  "orchestration",
	  "paradigm",
	  "parallelism",
	  "policy",
	  "portal",
	  "pricing structure",
	  "process improvement",
	  "product",
	  "productivity",
	  "project",
	  "projection",
	  "protocol",
	  "secured line",
	  "service-desk",
	  "software",
	  "solution",
	  "standardization",
	  "strategy",
	  "structure",
	  "success",
	  "superstructure",
	  "support",
	  "synergy",
	  "system engine",
	  "task-force",
	  "throughput",
	  "time-frame",
	  "toolset",
	  "utilisation",
	  "website",
	  "workforce"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Inc",
	  "and Sons",
	  "LLC",
	  "Group"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var pl = {};
	module['exports'] = pl;
	pl.title = "Polish";
	pl.name = __webpack_require__(1028);
	pl.address = __webpack_require__(1001);
	pl.company = __webpack_require__(1016);
	pl.internet = __webpack_require__(1023);
	pl.lorem = __webpack_require__(1024);
	pl.phone_number = __webpack_require__(1034);
	pl.cell_phone = __webpack_require__(1010);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "pl",
	  "com.pl",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1022);
	internet.domain_suffix = __webpack_require__(1021);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(1026);
	lorem.supplemental = __webpack_require__(1025);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "abbas",
	  "abduco",
	  "abeo",
	  "abscido",
	  "absconditus",
	  "absens",
	  "absorbeo",
	  "absque",
	  "abstergo",
	  "absum",
	  "abundans",
	  "abutor",
	  "accedo",
	  "accendo",
	  "acceptus",
	  "accipio",
	  "accommodo",
	  "accusator",
	  "acer",
	  "acerbitas",
	  "acervus",
	  "acidus",
	  "acies",
	  "acquiro",
	  "acsi",
	  "adamo",
	  "adaugeo",
	  "addo",
	  "adduco",
	  "ademptio",
	  "adeo",
	  "adeptio",
	  "adfectus",
	  "adfero",
	  "adficio",
	  "adflicto",
	  "adhaero",
	  "adhuc",
	  "adicio",
	  "adimpleo",
	  "adinventitias",
	  "adipiscor",
	  "adiuvo",
	  "administratio",
	  "admiratio",
	  "admitto",
	  "admoneo",
	  "admoveo",
	  "adnuo",
	  "adopto",
	  "adsidue",
	  "adstringo",
	  "adsuesco",
	  "adsum",
	  "adulatio",
	  "adulescens",
	  "adultus",
	  "aduro",
	  "advenio",
	  "adversus",
	  "advoco",
	  "aedificium",
	  "aeger",
	  "aegre",
	  "aegrotatio",
	  "aegrus",
	  "aeneus",
	  "aequitas",
	  "aequus",
	  "aer",
	  "aestas",
	  "aestivus",
	  "aestus",
	  "aetas",
	  "aeternus",
	  "ager",
	  "aggero",
	  "aggredior",
	  "agnitio",
	  "agnosco",
	  "ago",
	  "ait",
	  "aiunt",
	  "alienus",
	  "alii",
	  "alioqui",
	  "aliqua",
	  "alius",
	  "allatus",
	  "alo",
	  "alter",
	  "altus",
	  "alveus",
	  "amaritudo",
	  "ambitus",
	  "ambulo",
	  "amicitia",
	  "amiculum",
	  "amissio",
	  "amita",
	  "amitto",
	  "amo",
	  "amor",
	  "amoveo",
	  "amplexus",
	  "amplitudo",
	  "amplus",
	  "ancilla",
	  "angelus",
	  "angulus",
	  "angustus",
	  "animadverto",
	  "animi",
	  "animus",
	  "annus",
	  "anser",
	  "ante",
	  "antea",
	  "antepono",
	  "antiquus",
	  "aperio",
	  "aperte",
	  "apostolus",
	  "apparatus",
	  "appello",
	  "appono",
	  "appositus",
	  "approbo",
	  "apto",
	  "aptus",
	  "apud",
	  "aqua",
	  "ara",
	  "aranea",
	  "arbitro",
	  "arbor",
	  "arbustum",
	  "arca",
	  "arceo",
	  "arcesso",
	  "arcus",
	  "argentum",
	  "argumentum",
	  "arguo",
	  "arma",
	  "armarium",
	  "armo",
	  "aro",
	  "ars",
	  "articulus",
	  "artificiose",
	  "arto",
	  "arx",
	  "ascisco",
	  "ascit",
	  "asper",
	  "aspicio",
	  "asporto",
	  "assentator",
	  "astrum",
	  "atavus",
	  "ater",
	  "atqui",
	  "atrocitas",
	  "atrox",
	  "attero",
	  "attollo",
	  "attonbitus",
	  "auctor",
	  "auctus",
	  "audacia",
	  "audax",
	  "audentia",
	  "audeo",
	  "audio",
	  "auditor",
	  "aufero",
	  "aureus",
	  "auris",
	  "aurum",
	  "aut",
	  "autem",
	  "autus",
	  "auxilium",
	  "avaritia",
	  "avarus",
	  "aveho",
	  "averto",
	  "avoco",
	  "baiulus",
	  "balbus",
	  "barba",
	  "bardus",
	  "basium",
	  "beatus",
	  "bellicus",
	  "bellum",
	  "bene",
	  "beneficium",
	  "benevolentia",
	  "benigne",
	  "bestia",
	  "bibo",
	  "bis",
	  "blandior",
	  "bonus",
	  "bos",
	  "brevis",
	  "cado",
	  "caecus",
	  "caelestis",
	  "caelum",
	  "calamitas",
	  "calcar",
	  "calco",
	  "calculus",
	  "callide",
	  "campana",
	  "candidus",
	  "canis",
	  "canonicus",
	  "canto",
	  "capillus",
	  "capio",
	  "capitulus",
	  "capto",
	  "caput",
	  "carbo",
	  "carcer",
	  "careo",
	  "caries",
	  "cariosus",
	  "caritas",
	  "carmen",
	  "carpo",
	  "carus",
	  "casso",
	  "caste",
	  "casus",
	  "catena",
	  "caterva",
	  "cattus",
	  "cauda",
	  "causa",
	  "caute",
	  "caveo",
	  "cavus",
	  "cedo",
	  "celebrer",
	  "celer",
	  "celo",
	  "cena",
	  "cenaculum",
	  "ceno",
	  "censura",
	  "centum",
	  "cerno",
	  "cernuus",
	  "certe",
	  "certo",
	  "certus",
	  "cervus",
	  "cetera",
	  "charisma",
	  "chirographum",
	  "cibo",
	  "cibus",
	  "cicuta",
	  "cilicium",
	  "cimentarius",
	  "ciminatio",
	  "cinis",
	  "circumvenio",
	  "cito",
	  "civis",
	  "civitas",
	  "clam",
	  "clamo",
	  "claro",
	  "clarus",
	  "claudeo",
	  "claustrum",
	  "clementia",
	  "clibanus",
	  "coadunatio",
	  "coaegresco",
	  "coepi",
	  "coerceo",
	  "cogito",
	  "cognatus",
	  "cognomen",
	  "cogo",
	  "cohaero",
	  "cohibeo",
	  "cohors",
	  "colligo",
	  "colloco",
	  "collum",
	  "colo",
	  "color",
	  "coma",
	  "combibo",
	  "comburo",
	  "comedo",
	  "comes",
	  "cometes",
	  "comis",
	  "comitatus",
	  "commemoro",
	  "comminor",
	  "commodo",
	  "communis",
	  "comparo",
	  "compello",
	  "complectus",
	  "compono",
	  "comprehendo",
	  "comptus",
	  "conatus",
	  "concedo",
	  "concido",
	  "conculco",
	  "condico",
	  "conduco",
	  "confero",
	  "confido",
	  "conforto",
	  "confugo",
	  "congregatio",
	  "conicio",
	  "coniecto",
	  "conitor",
	  "coniuratio",
	  "conor",
	  "conqueror",
	  "conscendo",
	  "conservo",
	  "considero",
	  "conspergo",
	  "constans",
	  "consuasor",
	  "contabesco",
	  "contego",
	  "contigo",
	  "contra",
	  "conturbo",
	  "conventus",
	  "convoco",
	  "copia",
	  "copiose",
	  "cornu",
	  "corona",
	  "corpus",
	  "correptius",
	  "corrigo",
	  "corroboro",
	  "corrumpo",
	  "coruscus",
	  "cotidie",
	  "crapula",
	  "cras",
	  "crastinus",
	  "creator",
	  "creber",
	  "crebro",
	  "credo",
	  "creo",
	  "creptio",
	  "crepusculum",
	  "cresco",
	  "creta",
	  "cribro",
	  "crinis",
	  "cruciamentum",
	  "crudelis",
	  "cruentus",
	  "crur",
	  "crustulum",
	  "crux",
	  "cubicularis",
	  "cubitum",
	  "cubo",
	  "cui",
	  "cuius",
	  "culpa",
	  "culpo",
	  "cultellus",
	  "cultura",
	  "cum",
	  "cunabula",
	  "cunae",
	  "cunctatio",
	  "cupiditas",
	  "cupio",
	  "cuppedia",
	  "cupressus",
	  "cur",
	  "cura",
	  "curatio",
	  "curia",
	  "curiositas",
	  "curis",
	  "curo",
	  "curriculum",
	  "currus",
	  "cursim",
	  "curso",
	  "cursus",
	  "curto",
	  "curtus",
	  "curvo",
	  "curvus",
	  "custodia",
	  "damnatio",
	  "damno",
	  "dapifer",
	  "debeo",
	  "debilito",
	  "decens",
	  "decerno",
	  "decet",
	  "decimus",
	  "decipio",
	  "decor",
	  "decretum",
	  "decumbo",
	  "dedecor",
	  "dedico",
	  "deduco",
	  "defaeco",
	  "defendo",
	  "defero",
	  "defessus",
	  "defetiscor",
	  "deficio",
	  "defigo",
	  "defleo",
	  "defluo",
	  "defungo",
	  "degenero",
	  "degero",
	  "degusto",
	  "deinde",
	  "delectatio",
	  "delego",
	  "deleo",
	  "delibero",
	  "delicate",
	  "delinquo",
	  "deludo",
	  "demens",
	  "demergo",
	  "demitto",
	  "demo",
	  "demonstro",
	  "demoror",
	  "demulceo",
	  "demum",
	  "denego",
	  "denique",
	  "dens",
	  "denuncio",
	  "denuo",
	  "deorsum",
	  "depereo",
	  "depono",
	  "depopulo",
	  "deporto",
	  "depraedor",
	  "deprecator",
	  "deprimo",
	  "depromo",
	  "depulso",
	  "deputo",
	  "derelinquo",
	  "derideo",
	  "deripio",
	  "desidero",
	  "desino",
	  "desipio",
	  "desolo",
	  "desparatus",
	  "despecto",
	  "despirmatio",
	  "infit",
	  "inflammatio",
	  "paens",
	  "patior",
	  "patria",
	  "patrocinor",
	  "patruus",
	  "pauci",
	  "paulatim",
	  "pauper",
	  "pax",
	  "peccatus",
	  "pecco",
	  "pecto",
	  "pectus",
	  "pecunia",
	  "pecus",
	  "peior",
	  "pel",
	  "ocer",
	  "socius",
	  "sodalitas",
	  "sol",
	  "soleo",
	  "solio",
	  "solitudo",
	  "solium",
	  "sollers",
	  "sollicito",
	  "solum",
	  "solus",
	  "solutio",
	  "solvo",
	  "somniculosus",
	  "somnus",
	  "sonitus",
	  "sono",
	  "sophismata",
	  "sopor",
	  "sordeo",
	  "sortitus",
	  "spargo",
	  "speciosus",
	  "spectaculum",
	  "speculum",
	  "sperno",
	  "spero",
	  "spes",
	  "spiculum",
	  "spiritus",
	  "spoliatio",
	  "sponte",
	  "stabilis",
	  "statim",
	  "statua",
	  "stella",
	  "stillicidium",
	  "stipes",
	  "stips",
	  "sto",
	  "strenuus",
	  "strues",
	  "studio",
	  "stultus",
	  "suadeo",
	  "suasoria",
	  "sub",
	  "subito",
	  "subiungo",
	  "sublime",
	  "subnecto",
	  "subseco",
	  "substantia",
	  "subvenio",
	  "succedo",
	  "succurro",
	  "sufficio",
	  "suffoco",
	  "suffragium",
	  "suggero",
	  "sui",
	  "sulum",
	  "sum",
	  "summa",
	  "summisse",
	  "summopere",
	  "sumo",
	  "sumptus",
	  "supellex",
	  "super",
	  "suppellex",
	  "supplanto",
	  "suppono",
	  "supra",
	  "surculus",
	  "surgo",
	  "sursum",
	  "suscipio",
	  "suspendo",
	  "sustineo",
	  "suus",
	  "synagoga",
	  "tabella",
	  "tabernus",
	  "tabesco",
	  "tabgo",
	  "tabula",
	  "taceo",
	  "tactus",
	  "taedium",
	  "talio",
	  "talis",
	  "talus",
	  "tam",
	  "tamdiu",
	  "tamen",
	  "tametsi",
	  "tamisium",
	  "tamquam",
	  "tandem",
	  "tantillus",
	  "tantum",
	  "tardus",
	  "tego",
	  "temeritas",
	  "temperantia",
	  "templum",
	  "temptatio",
	  "tempus",
	  "tenax",
	  "tendo",
	  "teneo",
	  "tener",
	  "tenuis",
	  "tenus",
	  "tepesco",
	  "tepidus",
	  "ter",
	  "terebro",
	  "teres",
	  "terga",
	  "tergeo",
	  "tergiversatio",
	  "tergo",
	  "tergum",
	  "termes",
	  "terminatio",
	  "tero",
	  "terra",
	  "terreo",
	  "territo",
	  "terror",
	  "tersus",
	  "tertius",
	  "testimonium",
	  "texo",
	  "textilis",
	  "textor",
	  "textus",
	  "thalassinus",
	  "theatrum",
	  "theca",
	  "thema",
	  "theologus",
	  "thermae",
	  "thesaurus",
	  "thesis",
	  "thorax",
	  "thymbra",
	  "thymum",
	  "tibi",
	  "timidus",
	  "timor",
	  "titulus",
	  "tolero",
	  "tollo",
	  "tondeo",
	  "tonsor",
	  "torqueo",
	  "torrens",
	  "tot",
	  "totidem",
	  "toties",
	  "totus",
	  "tracto",
	  "trado",
	  "traho",
	  "trans",
	  "tredecim",
	  "tremo",
	  "trepide",
	  "tres",
	  "tribuo",
	  "tricesimus",
	  "triduana",
	  "triginta",
	  "tripudio",
	  "tristis",
	  "triumphus",
	  "trucido",
	  "truculenter",
	  "tubineus",
	  "tui",
	  "tum",
	  "tumultus",
	  "tunc",
	  "turba",
	  "turbo",
	  "turpe",
	  "turpis",
	  "tutamen",
	  "tutis",
	  "tyrannus",
	  "uberrime",
	  "ubi",
	  "ulciscor",
	  "ullus",
	  "ulterius",
	  "ultio",
	  "ultra",
	  "umbra",
	  "umerus",
	  "umquam",
	  "una",
	  "unde",
	  "undique",
	  "universe",
	  "unus",
	  "urbanus",
	  "urbs",
	  "uredo",
	  "usitas",
	  "usque",
	  "ustilo",
	  "ustulo",
	  "usus",
	  "uter",
	  "uterque",
	  "utilis",
	  "utique",
	  "utor",
	  "utpote",
	  "utrimque",
	  "utroque",
	  "utrum",
	  "uxor",
	  "vaco",
	  "vacuus",
	  "vado",
	  "vae",
	  "valde",
	  "valens",
	  "valeo",
	  "valetudo",
	  "validus",
	  "vallum",
	  "vapulus",
	  "varietas",
	  "varius",
	  "vehemens",
	  "vel",
	  "velociter",
	  "velum",
	  "velut",
	  "venia",
	  "venio",
	  "ventito",
	  "ventosus",
	  "ventus",
	  "venustas",
	  "ver",
	  "verbera",
	  "verbum",
	  "vere",
	  "verecundia",
	  "vereor",
	  "vergo",
	  "veritas",
	  "vero",
	  "versus",
	  "verto",
	  "verumtamen",
	  "verus",
	  "vesco",
	  "vesica",
	  "vesper",
	  "vespillo",
	  "vester",
	  "vestigium",
	  "vestrum",
	  "vetus",
	  "via",
	  "vicinus",
	  "vicissitudo",
	  "victoria",
	  "victus",
	  "videlicet",
	  "video",
	  "viduata",
	  "viduo",
	  "vigilo",
	  "vigor",
	  "vilicus",
	  "vilis",
	  "vilitas",
	  "villa",
	  "vinco",
	  "vinculum",
	  "vindico",
	  "vinitor",
	  "vinum",
	  "vir",
	  "virga",
	  "virgo",
	  "viridis",
	  "viriliter",
	  "virtus",
	  "vis",
	  "viscus",
	  "vita",
	  "vitiosus",
	  "vitium",
	  "vito",
	  "vivo",
	  "vix",
	  "vobis",
	  "vociferor",
	  "voco",
	  "volaticus",
	  "volo",
	  "volubilis",
	  "voluntarius",
	  "volup",
	  "volutabrum",
	  "volva",
	  "vomer",
	  "vomica",
	  "vomito",
	  "vorago",
	  "vorax",
	  "voro",
	  "vos",
	  "votum",
	  "voveo",
	  "vox",
	  "vulariter",
	  "vulgaris",
	  "vulgivagus",
	  "vulgo",
	  "vulgus",
	  "vulnero",
	  "vulnus",
	  "vulpes",
	  "vulticulus",
	  "vultuosus",
	  "xiphias"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aaron",
	  "Abraham",
	  "Adam",
	  "Adrian",
	  "Atanazy",
	  "Agaton",
	  "Alan",
	  "Albert",
	  "Aleksander",
	  "Aleksy",
	  "Alfred",
	  "Alwar",
	  "Ambroży",
	  "Anatol",
	  "Andrzej",
	  "Antoni",
	  "Apollinary",
	  "Apollo",
	  "Arkady",
	  "Arkadiusz",
	  "Archibald",
	  "Arystarch",
	  "Arnold",
	  "Arseniusz",
	  "Artur",
	  "August",
	  "Baldwin",
	  "Bazyli",
	  "Benedykt",
	  "Beniamin",
	  "Bernard",
	  "Bertrand",
	  "Bertram",
	  "Borys",
	  "Brajan",
	  "Bruno",
	  "Cezary",
	  "Cecyliusz",
	  "Karol",
	  "Krystian",
	  "Krzysztof",
	  "Klarencjusz",
	  "Klaudiusz",
	  "Klemens",
	  "Konrad",
	  "Konstanty",
	  "Konstantyn",
	  "Kornel",
	  "Korneliusz",
	  "Korneli",
	  "Cyryl",
	  "Cyrus",
	  "Damian",
	  "Daniel",
	  "Dariusz",
	  "Dawid",
	  "Dionizy",
	  "Demetriusz",
	  "Dominik",
	  "Donald",
	  "Dorian",
	  "Edgar",
	  "Edmund",
	  "Edward",
	  "Edwin",
	  "Efrem",
	  "Efraim",
	  "Eliasz",
	  "Eleazar",
	  "Emil",
	  "Emanuel",
	  "Erast",
	  "Ernest",
	  "Eugeniusz",
	  "Eustracjusz",
	  "Fabian",
	  "Feliks",
	  "Florian",
	  "Franciszek",
	  "Fryderyk",
	  "Gabriel",
	  "Gedeon",
	  "Galfryd",
	  "Jerzy",
	  "Gerald",
	  "Gerazym",
	  "Gilbert",
	  "Gonsalwy",
	  "Grzegorz",
	  "Gwido",
	  "Harald",
	  "Henryk",
	  "Herbert",
	  "Herman",
	  "Hilary",
	  "Horacy",
	  "Hubert",
	  "Hugo",
	  "Ignacy",
	  "Igor",
	  "Hilarion",
	  "Innocenty",
	  "Hipolit",
	  "Ireneusz",
	  "Erwin",
	  "Izaak",
	  "Izajasz",
	  "Izydor",
	  "Jakub",
	  "Jeremi",
	  "Jeremiasz",
	  "Hieronim",
	  "Gerald",
	  "Joachim",
	  "Jan",
	  "Janusz",
	  "Jonatan",
	  "Józef",
	  "Jozue",
	  "Julian",
	  "Juliusz",
	  "Justyn",
	  "Kalistrat",
	  "Kazimierz",
	  "Wawrzyniec",
	  "Laurenty",
	  "Laurencjusz",
	  "Łazarz",
	  "Leon",
	  "Leonard",
	  "Leonid",
	  "Leon",
	  "Ludwik",
	  "Łukasz",
	  "Lucjan",
	  "Magnus",
	  "Makary",
	  "Marceli",
	  "Marek",
	  "Marcin",
	  "Mateusz",
	  "Maurycy",
	  "Maksym",
	  "Maksymilian",
	  "Michał",
	  "Miron",
	  "Modest",
	  "Mojżesz",
	  "Natan",
	  "Natanael",
	  "Nazariusz",
	  "Nazary",
	  "Nestor",
	  "Mikołaj",
	  "Nikodem",
	  "Olaf",
	  "Oleg",
	  "Oliwier",
	  "Onufry",
	  "Orestes",
	  "Oskar",
	  "Ansgary",
	  "Osmund",
	  "Pankracy",
	  "Pantaleon",
	  "Patryk",
	  "Patrycjusz",
	  "Patrycy",
	  "Paweł",
	  "Piotr",
	  "Filemon",
	  "Filip",
	  "Platon",
	  "Polikarp",
	  "Porfiry",
	  "Porfiriusz",
	  "Prokles",
	  "Prokul",
	  "Prokop",
	  "Kwintyn",
	  "Randolf",
	  "Rafał",
	  "Rajmund",
	  "Reginald",
	  "Rajnold",
	  "Ryszard",
	  "Robert",
	  "Roderyk",
	  "Roger",
	  "Roland",
	  "Roman",
	  "Romeo",
	  "Reginald",
	  "Rudolf",
	  "Samson",
	  "Samuel",
	  "Salwator",
	  "Sebastian",
	  "Serafin",
	  "Sergiusz",
	  "Seweryn",
	  "Zygmunt",
	  "Sylwester",
	  "Szymon",
	  "Salomon",
	  "Spirydion",
	  "Stanisław",
	  "Szczepan",
	  "Stefan",
	  "Terencjusz",
	  "Teodor",
	  "Tomasz",
	  "Tymoteusz",
	  "Tobiasz",
	  "Walenty",
	  "Walentyn",
	  "Walerian",
	  "Walery",
	  "Wiktor",
	  "Wincenty",
	  "Witalis",
	  "Włodzimierz",
	  "Władysław",
	  "Błażej",
	  "Walter",
	  "Walgierz",
	  "Wacław",
	  "Wilfryd",
	  "Wilhelm",
	  "Ksawery",
	  "Ksenofont",
	  "Jerzy",
	  "Zachariasz",
	  "Zachary",
	  "Ada",
	  "Adelajda",
	  "Agata",
	  "Agnieszka",
	  "Agrypina",
	  "Aida",
	  "Aleksandra",
	  "Alicja",
	  "Alina",
	  "Amanda",
	  "Anastazja",
	  "Angela",
	  "Andżelika",
	  "Angelina",
	  "Anna",
	  "Hanna",
	  "—",
	  "Antonina",
	  "Ariadna",
	  "Aurora",
	  "Barbara",
	  "Beatrycze",
	  "Berta",
	  "Brygida",
	  "Kamila",
	  "Karolina",
	  "Karolina",
	  "Kornelia",
	  "Katarzyna",
	  "Cecylia",
	  "Karolina",
	  "Chloe",
	  "Krystyna",
	  "Klara",
	  "Klaudia",
	  "Klementyna",
	  "Konstancja",
	  "Koralia",
	  "Daria",
	  "Diana",
	  "Dina",
	  "Dorota",
	  "Edyta",
	  "Eleonora",
	  "Eliza",
	  "Elżbieta",
	  "Izabela",
	  "Elwira",
	  "Emilia",
	  "Estera",
	  "Eudoksja",
	  "Eudokia",
	  "Eugenia",
	  "Ewa",
	  "Ewelina",
	  "Ferdynanda",
	  "Florencja",
	  "Franciszka",
	  "Gabriela",
	  "Gertruda",
	  "Gloria",
	  "Gracja",
	  "Jadwiga",
	  "Helena",
	  "Henryka",
	  "Nadzieja",
	  "Ida",
	  "Ilona",
	  "Helena",
	  "Irena",
	  "Irma",
	  "Izabela",
	  "Izolda",
	  "Jakubina",
	  "Joanna",
	  "Janina",
	  "Żaneta",
	  "Joanna",
	  "Ginewra",
	  "Józefina",
	  "Judyta",
	  "Julia",
	  "Julia",
	  "Julita",
	  "Justyna",
	  "Kira",
	  "Cyra",
	  "Kleopatra",
	  "Larysa",
	  "Laura",
	  "Laurencja",
	  "Laurentyna",
	  "Lea",
	  "Leila",
	  "Eleonora",
	  "Liliana",
	  "Lilianna",
	  "Lilia",
	  "Lilla",
	  "Liza",
	  "Eliza",
	  "Laura",
	  "Ludwika",
	  "Luiza",
	  "Łucja",
	  "Lucja",
	  "Lidia",
	  "Amabela",
	  "Magdalena",
	  "Malwina",
	  "Małgorzata",
	  "Greta",
	  "Marianna",
	  "Maryna",
	  "Marta",
	  "Martyna",
	  "Maria",
	  "Matylda",
	  "Maja",
	  "Maja",
	  "Melania",
	  "Michalina",
	  "Monika",
	  "Nadzieja",
	  "Noemi",
	  "Natalia",
	  "Nikola",
	  "Nina",
	  "Olga",
	  "Olimpia",
	  "Oliwia",
	  "Ofelia",
	  "Patrycja",
	  "Paula",
	  "Pelagia",
	  "Penelopa",
	  "Filipa",
	  "Paulina",
	  "Rachela",
	  "Rebeka",
	  "Regina",
	  "Renata",
	  "Rozalia",
	  "Róża",
	  "Roksana",
	  "Rufina",
	  "Ruta",
	  "Sabina",
	  "Sara",
	  "Serafina",
	  "Sybilla",
	  "Sylwia",
	  "Zofia",
	  "Stella",
	  "Stefania",
	  "Zuzanna",
	  "Tamara",
	  "Tacjana",
	  "Tekla",
	  "Teodora",
	  "Teresa",
	  "Walentyna",
	  "Waleria",
	  "Wanesa",
	  "Wiara",
	  "Weronika",
	  "Wiktoria",
	  "Wirginia",
	  "Bibiana",
	  "Bibianna",
	  "Wanda",
	  "Wilhelmina",
	  "Ksawera",
	  "Ksenia",
	  "Zoe"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1027);
	name.last_name = __webpack_require__(1029);
	name.prefix = __webpack_require__(1031);
	name.title = __webpack_require__(1032);
	name.name = __webpack_require__(1030);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adamczak",
	  "Adamczyk",
	  "Adamek",
	  "Adamiak",
	  "Adamiec",
	  "Adamowicz",
	  "Adamski",
	  "Adamus",
	  "Aleksandrowicz",
	  "Andrzejczak",
	  "Andrzejewski",
	  "Antczak",
	  "Augustyn",
	  "Augustyniak",
	  "Bagiński",
	  "Balcerzak",
	  "Banach",
	  "Banasiak",
	  "Banasik",
	  "Banaś",
	  "Baran",
	  "Baranowski",
	  "Barański",
	  "Bartczak",
	  "Bartkowiak",
	  "Bartnik",
	  "Bartosik",
	  "Bednarczyk",
	  "Bednarek",
	  "Bednarski",
	  "Bednarz",
	  "Białas",
	  "Białek",
	  "Białkowski",
	  "Bielak",
	  "Bielawski",
	  "Bielecki",
	  "Bielski",
	  "Bieniek",
	  "Biernacki",
	  "Biernat",
	  "Bieńkowski",
	  "Bilski",
	  "Bober",
	  "Bochenek",
	  "Bogucki",
	  "Bogusz",
	  "Borek",
	  "Borkowski",
	  "Borowiec",
	  "Borowski",
	  "Bożek",
	  "Broda",
	  "Brzeziński",
	  "Brzozowski",
	  "Buczek",
	  "Buczkowski",
	  "Buczyński",
	  "Budziński",
	  "Budzyński",
	  "Bujak",
	  "Bukowski",
	  "Burzyński",
	  "Bąk",
	  "Bąkowski",
	  "Błaszczak",
	  "Błaszczyk",
	  "Cebula",
	  "Chmiel",
	  "Chmielewski",
	  "Chmura",
	  "Chojnacki",
	  "Chojnowski",
	  "Cholewa",
	  "Chrzanowski",
	  "Chudzik",
	  "Cichocki",
	  "Cichoń",
	  "Cichy",
	  "Ciesielski",
	  "Cieśla",
	  "Cieślak",
	  "Cieślik",
	  "Ciszewski",
	  "Cybulski",
	  "Cygan",
	  "Czaja",
	  "Czajka",
	  "Czajkowski",
	  "Czapla",
	  "Czarnecki",
	  "Czech",
	  "Czechowski",
	  "Czekaj",
	  "Czerniak",
	  "Czerwiński",
	  "Czyż",
	  "Czyżewski",
	  "Dec",
	  "Dobosz",
	  "Dobrowolski",
	  "Dobrzyński",
	  "Domagała",
	  "Domański",
	  "Dominiak",
	  "Drabik",
	  "Drozd",
	  "Drozdowski",
	  "Drzewiecki",
	  "Dróżdż",
	  "Dubiel",
	  "Duda",
	  "Dudek",
	  "Dudziak",
	  "Dudzik",
	  "Dudziński",
	  "Duszyński",
	  "Dziedzic",
	  "Dziuba",
	  "Dąbek",
	  "Dąbkowski",
	  "Dąbrowski",
	  "Dębowski",
	  "Dębski",
	  "Długosz",
	  "Falkowski",
	  "Fijałkowski",
	  "Filipek",
	  "Filipiak",
	  "Filipowicz",
	  "Flak",
	  "Flis",
	  "Florczak",
	  "Florek",
	  "Frankowski",
	  "Frąckowiak",
	  "Frączek",
	  "Frątczak",
	  "Furman",
	  "Gadomski",
	  "Gajda",
	  "Gajewski",
	  "Gaweł",
	  "Gawlik",
	  "Gawron",
	  "Gawroński",
	  "Gałka",
	  "Gałązka",
	  "Gil",
	  "Godlewski",
	  "Golec",
	  "Gołąb",
	  "Gołębiewski",
	  "Gołębiowski",
	  "Grabowski",
	  "Graczyk",
	  "Grochowski",
	  "Grudzień",
	  "Gruszczyński",
	  "Gruszka",
	  "Grzegorczyk",
	  "Grzelak",
	  "Grzesiak",
	  "Grzesik",
	  "Grześkowiak",
	  "Grzyb",
	  "Grzybowski",
	  "Grzywacz",
	  "Gutowski",
	  "Guzik",
	  "Gwóźdź",
	  "Góra",
	  "Góral",
	  "Górecki",
	  "Górka",
	  "Górniak",
	  "Górny",
	  "Górski",
	  "Gąsior",
	  "Gąsiorowski",
	  "Głogowski",
	  "Głowacki",
	  "Głąb",
	  "Hajduk",
	  "Herman",
	  "Iwański",
	  "Izdebski",
	  "Jabłoński",
	  "Jackowski",
	  "Jagielski",
	  "Jagiełło",
	  "Jagodziński",
	  "Jakubiak",
	  "Jakubowski",
	  "Janas",
	  "Janiak",
	  "Janicki",
	  "Janik",
	  "Janiszewski",
	  "Jankowiak",
	  "Jankowski",
	  "Janowski",
	  "Janus",
	  "Janusz",
	  "Januszewski",
	  "Jaros",
	  "Jarosz",
	  "Jarząbek",
	  "Jasiński",
	  "Jastrzębski",
	  "Jaworski",
	  "Jaśkiewicz",
	  "Jezierski",
	  "Jurek",
	  "Jurkiewicz",
	  "Jurkowski",
	  "Juszczak",
	  "Jóźwiak",
	  "Jóźwik",
	  "Jędrzejczak",
	  "Jędrzejczyk",
	  "Jędrzejewski",
	  "Kacprzak",
	  "Kaczmarczyk",
	  "Kaczmarek",
	  "Kaczmarski",
	  "Kaczor",
	  "Kaczorowski",
	  "Kaczyński",
	  "Kaleta",
	  "Kalinowski",
	  "Kalisz",
	  "Kamiński",
	  "Kania",
	  "Kaniewski",
	  "Kapusta",
	  "Karaś",
	  "Karczewski",
	  "Karpiński",
	  "Karwowski",
	  "Kasperek",
	  "Kasprzak",
	  "Kasprzyk",
	  "Kaszuba",
	  "Kawa",
	  "Kawecki",
	  "Kałuża",
	  "Kaźmierczak",
	  "Kiełbasa",
	  "Kisiel",
	  "Kita",
	  "Klimczak",
	  "Klimek",
	  "Kmiecik",
	  "Kmieć",
	  "Knapik",
	  "Kobus",
	  "Kogut",
	  "Kolasa",
	  "Komorowski",
	  "Konieczna",
	  "Konieczny",
	  "Konopka",
	  "Kopczyński",
	  "Koper",
	  "Kopeć",
	  "Korzeniowski",
	  "Kos",
	  "Kosiński",
	  "Kosowski",
	  "Kostecki",
	  "Kostrzewa",
	  "Kot",
	  "Kotowski",
	  "Kowal",
	  "Kowalczuk",
	  "Kowalczyk",
	  "Kowalewski",
	  "Kowalik",
	  "Kowalski",
	  "Koza",
	  "Kozak",
	  "Kozieł",
	  "Kozioł",
	  "Kozłowski",
	  "Kołakowski",
	  "Kołodziej",
	  "Kołodziejczyk",
	  "Kołodziejski",
	  "Krajewski",
	  "Krakowiak",
	  "Krawczyk",
	  "Krawiec",
	  "Kruk",
	  "Krukowski",
	  "Krupa",
	  "Krupiński",
	  "Kruszewski",
	  "Krysiak",
	  "Krzemiński",
	  "Krzyżanowski",
	  "Król",
	  "Królikowski",
	  "Książek",
	  "Kubacki",
	  "Kubiak",
	  "Kubica",
	  "Kubicki",
	  "Kubik",
	  "Kuc",
	  "Kucharczyk",
	  "Kucharski",
	  "Kuchta",
	  "Kuciński",
	  "Kuczyński",
	  "Kujawa",
	  "Kujawski",
	  "Kula",
	  "Kulesza",
	  "Kulig",
	  "Kulik",
	  "Kuliński",
	  "Kurek",
	  "Kurowski",
	  "Kuś",
	  "Kwaśniewski",
	  "Kwiatkowski",
	  "Kwiecień",
	  "Kwieciński",
	  "Kędzierski",
	  "Kędziora",
	  "Kępa",
	  "Kłos",
	  "Kłosowski",
	  "Lach",
	  "Laskowski",
	  "Lasota",
	  "Lech",
	  "Lenart",
	  "Lesiak",
	  "Leszczyński",
	  "Lewandowski",
	  "Lewicki",
	  "Leśniak",
	  "Leśniewski",
	  "Lipiński",
	  "Lipka",
	  "Lipski",
	  "Lis",
	  "Lisiecki",
	  "Lisowski",
	  "Maciejewski",
	  "Maciąg",
	  "Mackiewicz",
	  "Madej",
	  "Maj",
	  "Majcher",
	  "Majchrzak",
	  "Majewski",
	  "Majka",
	  "Makowski",
	  "Malec",
	  "Malicki",
	  "Malinowski",
	  "Maliszewski",
	  "Marchewka",
	  "Marciniak",
	  "Marcinkowski",
	  "Marczak",
	  "Marek",
	  "Markiewicz",
	  "Markowski",
	  "Marszałek",
	  "Marzec",
	  "Masłowski",
	  "Matusiak",
	  "Matuszak",
	  "Matuszewski",
	  "Matysiak",
	  "Mazur",
	  "Mazurek",
	  "Mazurkiewicz",
	  "Maćkowiak",
	  "Małecki",
	  "Małek",
	  "Maślanka",
	  "Michalak",
	  "Michalczyk",
	  "Michalik",
	  "Michalski",
	  "Michałek",
	  "Michałowski",
	  "Mielczarek",
	  "Mierzejewski",
	  "Mika",
	  "Mikołajczak",
	  "Mikołajczyk",
	  "Mikulski",
	  "Milczarek",
	  "Milewski",
	  "Miller",
	  "Misiak",
	  "Misztal",
	  "Miśkiewicz",
	  "Modzelewski",
	  "Molenda",
	  "Morawski",
	  "Motyka",
	  "Mroczek",
	  "Mroczkowski",
	  "Mrozek",
	  "Mróz",
	  "Mucha",
	  "Murawski",
	  "Musiał",
	  "Muszyński",
	  "Młynarczyk",
	  "Napierała",
	  "Nawrocki",
	  "Nawrot",
	  "Niedziela",
	  "Niedzielski",
	  "Niedźwiecki",
	  "Niemczyk",
	  "Niemiec",
	  "Niewiadomski",
	  "Noga",
	  "Nowacki",
	  "Nowaczyk",
	  "Nowak",
	  "Nowakowski",
	  "Nowicki",
	  "Nowiński",
	  "Olczak",
	  "Olejniczak",
	  "Olejnik",
	  "Olszewski",
	  "Orzechowski",
	  "Orłowski",
	  "Osiński",
	  "Ossowski",
	  "Ostrowski",
	  "Owczarek",
	  "Paczkowski",
	  "Pająk",
	  "Pakuła",
	  "Paluch",
	  "Panek",
	  "Partyka",
	  "Pasternak",
	  "Paszkowski",
	  "Pawelec",
	  "Pawlak",
	  "Pawlicki",
	  "Pawlik",
	  "Pawlikowski",
	  "Pawłowski",
	  "Pałka",
	  "Piasecki",
	  "Piechota",
	  "Piekarski",
	  "Pietras",
	  "Pietruszka",
	  "Pietrzak",
	  "Pietrzyk",
	  "Pilarski",
	  "Pilch",
	  "Piotrowicz",
	  "Piotrowski",
	  "Piwowarczyk",
	  "Piórkowski",
	  "Piątek",
	  "Piątkowski",
	  "Piłat",
	  "Pluta",
	  "Podgórski",
	  "Polak",
	  "Popławski",
	  "Porębski",
	  "Prokop",
	  "Prus",
	  "Przybylski",
	  "Przybysz",
	  "Przybył",
	  "Przybyła",
	  "Ptak",
	  "Puchalski",
	  "Pytel",
	  "Płonka",
	  "Raczyński",
	  "Radecki",
	  "Radomski",
	  "Rak",
	  "Rakowski",
	  "Ratajczak",
	  "Robak",
	  "Rogala",
	  "Rogalski",
	  "Rogowski",
	  "Rojek",
	  "Romanowski",
	  "Rosa",
	  "Rosiak",
	  "Rosiński",
	  "Ruciński",
	  "Rudnicki",
	  "Rudziński",
	  "Rudzki",
	  "Rusin",
	  "Rutkowski",
	  "Rybak",
	  "Rybarczyk",
	  "Rybicki",
	  "Rzepka",
	  "Różański",
	  "Różycki",
	  "Sadowski",
	  "Sawicki",
	  "Serafin",
	  "Siedlecki",
	  "Sienkiewicz",
	  "Sieradzki",
	  "Sikora",
	  "Sikorski",
	  "Sitek",
	  "Siwek",
	  "Skalski",
	  "Skiba",
	  "Skibiński",
	  "Skoczylas",
	  "Skowron",
	  "Skowronek",
	  "Skowroński",
	  "Skrzypczak",
	  "Skrzypek",
	  "Skóra",
	  "Smoliński",
	  "Sobczak",
	  "Sobczyk",
	  "Sobieraj",
	  "Sobolewski",
	  "Socha",
	  "Sochacki",
	  "Sokołowski",
	  "Sokół",
	  "Sosnowski",
	  "Sowa",
	  "Sowiński",
	  "Sołtys",
	  "Sołtysiak",
	  "Sroka",
	  "Stachowiak",
	  "Stachowicz",
	  "Stachura",
	  "Stachurski",
	  "Stanek",
	  "Staniszewski",
	  "Stanisławski",
	  "Stankiewicz",
	  "Stasiak",
	  "Staszewski",
	  "Stawicki",
	  "Stec",
	  "Stefaniak",
	  "Stefański",
	  "Stelmach",
	  "Stolarczyk",
	  "Stolarski",
	  "Strzelczyk",
	  "Strzelecki",
	  "Stępień",
	  "Stępniak",
	  "Surma",
	  "Suski",
	  "Szafrański",
	  "Szatkowski",
	  "Szczepaniak",
	  "Szczepanik",
	  "Szczepański",
	  "Szczerba",
	  "Szcześniak",
	  "Szczygieł",
	  "Szczęsna",
	  "Szczęsny",
	  "Szeląg",
	  "Szewczyk",
	  "Szostak",
	  "Szulc",
	  "Szwarc",
	  "Szwed",
	  "Szydłowski",
	  "Szymański",
	  "Szymczak",
	  "Szymczyk",
	  "Szymkowiak",
	  "Szyszka",
	  "Sławiński",
	  "Słowik",
	  "Słowiński",
	  "Tarnowski",
	  "Tkaczyk",
	  "Tokarski",
	  "Tomala",
	  "Tomaszewski",
	  "Tomczak",
	  "Tomczyk",
	  "Tracz",
	  "Trojanowski",
	  "Trzciński",
	  "Trzeciak",
	  "Turek",
	  "Twardowski",
	  "Urban",
	  "Urbanek",
	  "Urbaniak",
	  "Urbanowicz",
	  "Urbańczyk",
	  "Urbański",
	  "Walczak",
	  "Walkowiak",
	  "Warchoł",
	  "Wasiak",
	  "Wasilewski",
	  "Wawrzyniak",
	  "Wesołowski",
	  "Wieczorek",
	  "Wierzbicki",
	  "Wilczek",
	  "Wilczyński",
	  "Wilk",
	  "Winiarski",
	  "Witczak",
	  "Witek",
	  "Witkowski",
	  "Wiącek",
	  "Więcek",
	  "Więckowski",
	  "Wiśniewski",
	  "Wnuk",
	  "Wojciechowski",
	  "Wojtas",
	  "Wojtasik",
	  "Wojtczak",
	  "Wojtkowiak",
	  "Wolak",
	  "Woliński",
	  "Wolny",
	  "Wolski",
	  "Woś",
	  "Woźniak",
	  "Wrona",
	  "Wroński",
	  "Wróbel",
	  "Wróblewski",
	  "Wypych",
	  "Wysocki",
	  "Wyszyński",
	  "Wójcicki",
	  "Wójcik",
	  "Wójtowicz",
	  "Wąsik",
	  "Węgrzyn",
	  "Włodarczyk",
	  "Włodarski",
	  "Zaborowski",
	  "Zabłocki",
	  "Zagórski",
	  "Zając",
	  "Zajączkowski",
	  "Zakrzewski",
	  "Zalewski",
	  "Zaremba",
	  "Zarzycki",
	  "Zaręba",
	  "Zawada",
	  "Zawadzki",
	  "Zdunek",
	  "Zieliński",
	  "Zielonka",
	  "Ziółkowski",
	  "Zięba",
	  "Ziętek",
	  "Zwoliński",
	  "Zych",
	  "Zygmunt",
	  "Łapiński",
	  "Łuczak",
	  "Łukasiewicz",
	  "Łukasik",
	  "Łukaszewski",
	  "Śliwa",
	  "Śliwiński",
	  "Ślusarczyk",
	  "Świderski",
	  "Świerczyński",
	  "Świątek",
	  "Żak",
	  "Żebrowski",
	  "Żmuda",
	  "Żuk",
	  "Żukowski",
	  "Żurawski",
	  "Żurek",
	  "Żyła"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pan",
	  "Pani"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "Lead",
	    "Senior",
	    "Direct",
	    "Corporate",
	    "Dynamic",
	    "Future",
	    "Product",
	    "National",
	    "Regional",
	    "District",
	    "Central",
	    "Global",
	    "Customer",
	    "Investor",
	    "Dynamic",
	    "International",
	    "Legacy",
	    "Forward",
	    "Internal",
	    "Human",
	    "Chief",
	    "Principal"
	  ],
	  "level": [
	    "Solutions",
	    "Program",
	    "Brand",
	    "Security",
	    "Research",
	    "Marketing",
	    "Directives",
	    "Implementation",
	    "Integration",
	    "Functionality",
	    "Response",
	    "Paradigm",
	    "Tactics",
	    "Identity",
	    "Markets",
	    "Group",
	    "Division",
	    "Applications",
	    "Optimization",
	    "Operations",
	    "Infrastructure",
	    "Intranet",
	    "Communications",
	    "Web",
	    "Branding",
	    "Quality",
	    "Assurance",
	    "Mobility",
	    "Accounts",
	    "Data",
	    "Creative",
	    "Configuration",
	    "Accountability",
	    "Interactions",
	    "Factors",
	    "Usability",
	    "Metrics"
	  ],
	  "job": [
	    "Supervisor",
	    "Associate",
	    "Executive",
	    "Liason",
	    "Officer",
	    "Manager",
	    "Engineer",
	    "Specialist",
	    "Director",
	    "Coordinator",
	    "Administrator",
	    "Architect",
	    "Analyst",
	    "Designer",
	    "Planner",
	    "Orchestrator",
	    "Technician",
	    "Developer",
	    "Producer",
	    "Consultant",
	    "Assistant",
	    "Facilitator",
	    "Agent",
	    "Representative",
	    "Strategist"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "12-###-##-##",
	  "13-###-##-##",
	  "14-###-##-##",
	  "15-###-##-##",
	  "16-###-##-##",
	  "17-###-##-##",
	  "18-###-##-##",
	  "22-###-##-##",
	  "23-###-##-##",
	  "24-###-##-##",
	  "25-###-##-##",
	  "29-###-##-##",
	  "32-###-##-##",
	  "33-###-##-##",
	  "34-###-##-##",
	  "41-###-##-##",
	  "42-###-##-##",
	  "43-###-##-##",
	  "44-###-##-##",
	  "46-###-##-##",
	  "48-###-##-##",
	  "52-###-##-##",
	  "54-###-##-##",
	  "55-###-##-##",
	  "56-###-##-##",
	  "58-###-##-##",
	  "59-###-##-##",
	  "61-###-##-##",
	  "62-###-##-##",
	  "63-###-##-##",
	  "65-###-##-##",
	  "67-###-##-##",
	  "68-###-##-##",
	  "71-###-##-##",
	  "74-###-##-##",
	  "75-###-##-##",
	  "76-###-##-##",
	  "77-###-##-##",
	  "81-###-##-##",
	  "82-###-##-##",
	  "83-###-##-##",
	  "84-###-##-##",
	  "85-###-##-##",
	  "86-###-##-##",
	  "87-###-##-##",
	  "89-###-##-##",
	  "91-###-##-##",
	  "94-###-##-##",
	  "95-###-##-##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1033);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "####",
	  "###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Nova",
	  "Velha",
	  "Grande",
	  "Vila",
	  "Município de"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "do Descoberto",
	  "de Nossa Senhora",
	  "do Norte",
	  "do Sul"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afeganistão",
	  "Albânia",
	  "Algéria",
	  "Samoa",
	  "Andorra",
	  "Angola",
	  "Anguilla",
	  "Antigua and Barbada",
	  "Argentina",
	  "Armênia",
	  "Aruba",
	  "Austrália",
	  "Áustria",
	  "Alzerbajão",
	  "Bahamas",
	  "Barém",
	  "Bangladesh",
	  "Barbado",
	  "Belgrado",
	  "Bélgica",
	  "Belize",
	  "Benin",
	  "Bermuda",
	  "Bhutan",
	  "Bolívia",
	  "Bôsnia",
	  "Botuasuna",
	  "Bouvetoia",
	  "Brasil",
	  "Arquipélago de Chagos",
	  "Ilhas Virgens",
	  "Brunei",
	  "Bulgária",
	  "Burkina Faso",
	  "Burundi",
	  "Cambójia",
	  "Camarões",
	  "Canadá",
	  "Cabo Verde",
	  "Ilhas Caiman",
	  "República da África Central",
	  "Chad",
	  "Chile",
	  "China",
	  "Ilhas Natal",
	  "Ilhas Cocos",
	  "Colômbia",
	  "Comoros",
	  "Congo",
	  "Ilhas Cook",
	  "Costa Rica",
	  "Costa do Marfim",
	  "Croácia",
	  "Cuba",
	  "Cyprus",
	  "República Tcheca",
	  "Dinamarca",
	  "Djibouti",
	  "Dominica",
	  "República Dominicana",
	  "Equador",
	  "Egito",
	  "El Salvador",
	  "Guiné Equatorial",
	  "Eritrea",
	  "Estônia",
	  "Etiópia",
	  "Ilhas Faroe",
	  "Malvinas",
	  "Fiji",
	  "Finlândia",
	  "França",
	  "Guiné Francesa",
	  "Polinésia Francesa",
	  "Gabão",
	  "Gâmbia",
	  "Georgia",
	  "Alemanha",
	  "Gana",
	  "Gibraltar",
	  "Grécia",
	  "Groelândia",
	  "Granada",
	  "Guadalupe",
	  "Guano",
	  "Guatemala",
	  "Guernsey",
	  "Guiné",
	  "Guiné-Bissau",
	  "Guiana",
	  "Haiti",
	  "Heard Island and McDonald Islands",
	  "Vaticano",
	  "Honduras",
	  "Hong Kong",
	  "Hungria",
	  "Iceland",
	  "Índia",
	  "Indonésia",
	  "Irã",
	  "Iraque",
	  "Irlanda",
	  "Ilha de Man",
	  "Israel",
	  "Itália",
	  "Jamaica",
	  "Japão",
	  "Jersey",
	  "Jordânia",
	  "Cazaquistão",
	  "Quênia",
	  "Kiribati",
	  "Coreia do Norte",
	  "Coreia do Sul",
	  "Kuwait",
	  "Kyrgyz Republic",
	  "República Democrática de Lao People",
	  "Latvia",
	  "Líbano",
	  "Lesotho",
	  "Libéria",
	  "Libyan Arab Jamahiriya",
	  "Liechtenstein",
	  "Lituânia",
	  "Luxemburgo",
	  "Macao",
	  "Macedônia",
	  "Madagascar",
	  "Malawi",
	  "Malásia",
	  "Maldives",
	  "Mali",
	  "Malta",
	  "Ilhas Marshall",
	  "Martinica",
	  "Mauritânia",
	  "Mauritius",
	  "Mayotte",
	  "México",
	  "Micronésia",
	  "Moldova",
	  "Mônaco",
	  "Mongólia",
	  "Montenegro",
	  "Montserrat",
	  "Marrocos",
	  "Moçambique",
	  "Myanmar",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Antilhas Holandesas",
	  "Holanda",
	  "Nova Caledonia",
	  "Nova Zelândia",
	  "Nicarágua",
	  "Nigéria",
	  "Niue",
	  "Ilha Norfolk",
	  "Northern Mariana Islands",
	  "Noruega",
	  "Oman",
	  "Paquistão",
	  "Palau",
	  "Território da Palestina",
	  "Panamá",
	  "Nova Guiné Papua",
	  "Paraguai",
	  "Peru",
	  "Filipinas",
	  "Polônia",
	  "Portugal",
	  "Puerto Rico",
	  "Qatar",
	  "Romênia",
	  "Rússia",
	  "Ruanda",
	  "São Bartolomeu",
	  "Santa Helena",
	  "Santa Lúcia",
	  "Saint Martin",
	  "Saint Pierre and Miquelon",
	  "Saint Vincent and the Grenadines",
	  "Samoa",
	  "San Marino",
	  "Sao Tomé e Príncipe",
	  "Arábia Saudita",
	  "Senegal",
	  "Sérvia",
	  "Seychelles",
	  "Serra Leoa",
	  "Singapura",
	  "Eslováquia",
	  "Eslovênia",
	  "Ilhas Salomão",
	  "Somália",
	  "África do Sul",
	  "South Georgia and the South Sandwich Islands",
	  "Spanha",
	  "Sri Lanka",
	  "Sudão",
	  "Suriname",
	  "Svalbard & Jan Mayen Islands",
	  "Swaziland",
	  "Suécia",
	  "Suíça",
	  "Síria",
	  "Taiwan",
	  "Tajiquistão",
	  "Tanzânia",
	  "Tailândia",
	  "Timor-Leste",
	  "Togo",
	  "Tokelau",
	  "Tonga",
	  "Trinidá e Tobago",
	  "Tunísia",
	  "Turquia",
	  "Turcomenistão",
	  "Turks and Caicos Islands",
	  "Tuvalu",
	  "Uganda",
	  "Ucrânia",
	  "Emirados Árabes Unidos",
	  "Reino Unido",
	  "Estados Unidos da América",
	  "Estados Unidos das Ilhas Virgens",
	  "Uruguai",
	  "Uzbequistão",
	  "Vanuatu",
	  "Venezuela",
	  "Vietnã",
	  "Wallis and Futuna",
	  "Sahara",
	  "Yemen",
	  "Zâmbia",
	  "Zimbábue"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Brasil"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(1036);
	address.city_suffix = __webpack_require__(1037);
	address.country = __webpack_require__(1038);
	address.building_number = __webpack_require__(1035);
	address.street_suffix = __webpack_require__(1045);
	address.secondary_address = __webpack_require__(1042);
	address.postcode = __webpack_require__(1041);
	address.state = __webpack_require__(1043);
	address.state_abbr = __webpack_require__(1044);
	address.default_country = __webpack_require__(1039);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "#####-###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apto. ###",
	  "Sobrado ##",
	  "Casa #",
	  "Lote ##",
	  "Quadra ##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Acre",
	  "Alagoas",
	  "Amapá",
	  "Amazonas",
	  "Bahia",
	  "Ceará",
	  "Distrito Federal",
	  "Espírito Santo",
	  "Goiás",
	  "Maranhão",
	  "Mato Grosso",
	  "Mato Grosso do Sul",
	  "Minas Gerais",
	  "Pará",
	  "Paraíba",
	  "Paraná",
	  "Pernambuco",
	  "Piauí",
	  "Rio de Janeiro",
	  "Rio Grande do Norte",
	  "Rio Grande do Sul",
	  "Rondônia",
	  "Roraima",
	  "Santa Catarina",
	  "São Paulo",
	  "Sergipe",
	  "Tocantins"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AC",
	  "AL",
	  "AP",
	  "AM",
	  "BA",
	  "CE",
	  "DF",
	  "ES",
	  "GO",
	  "MA",
	  "MT",
	  "MS",
	  "PA",
	  "PB",
	  "PR",
	  "PE",
	  "PI",
	  "RJ",
	  "RN",
	  "RS",
	  "RO",
	  "RR",
	  "SC",
	  "SP"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Rua",
	  "Avenida",
	  "Travessa",
	  "Ponte",
	  "Alameda",
	  "Marginal",
	  "Viela",
	  "Rodovia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(1048);
	company.name = __webpack_require__(1047);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} e #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "S.A.",
	  "LTDA",
	  "e Associados",
	  "Comércio"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var pt_BR = {};
	module['exports'] = pt_BR;
	pt_BR.title = "Portuguese (Brazil)";
	pt_BR.address = __webpack_require__(1040);
	pt_BR.company = __webpack_require__(1046);
	pt_BR.internet = __webpack_require__(1052);
	pt_BR.lorem = __webpack_require__(1053);
	pt_BR.name = __webpack_require__(1056);
	pt_BR.phone_number = __webpack_require__(1061);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "br",
	  "com",
	  "biz",
	  "info",
	  "name",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com",
	  "live.com",
	  "bol.com.br"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1051);
	internet.domain_suffix = __webpack_require__(1050);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(1054);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alessandro",
	  "Alessandra",
	  "Alexandre",
	  "Aline",
	  "Antônio",
	  "Breno",
	  "Bruna",
	  "Carlos",
	  "Carla",
	  "Célia",
	  "Cecília",
	  "César",
	  "Danilo",
	  "Dalila",
	  "Deneval",
	  "Eduardo",
	  "Eduarda",
	  "Esther",
	  "Elísio",
	  "Fábio",
	  "Fabrício",
	  "Fabrícia",
	  "Félix",
	  "Felícia",
	  "Feliciano",
	  "Frederico",
	  "Fabiano",
	  "Gustavo",
	  "Guilherme",
	  "Gúbio",
	  "Heitor",
	  "Hélio",
	  "Hugo",
	  "Isabel",
	  "Isabela",
	  "Ígor",
	  "João",
	  "Joana",
	  "Júlio César",
	  "Júlio",
	  "Júlia",
	  "Janaína",
	  "Karla",
	  "Kléber",
	  "Lucas",
	  "Lorena",
	  "Lorraine",
	  "Larissa",
	  "Ladislau",
	  "Marcos",
	  "Meire",
	  "Marcelo",
	  "Marcela",
	  "Margarida",
	  "Mércia",
	  "Márcia",
	  "Marli",
	  "Morgana",
	  "Maria",
	  "Norberto",
	  "Natália",
	  "Nataniel",
	  "Núbia",
	  "Ofélia",
	  "Paulo",
	  "Paula",
	  "Pablo",
	  "Pedro",
	  "Raul",
	  "Rafael",
	  "Rafaela",
	  "Ricardo",
	  "Roberto",
	  "Roberta",
	  "Sílvia",
	  "Sílvia",
	  "Silas",
	  "Suélen",
	  "Sara",
	  "Salvador",
	  "Sirineu",
	  "Talita",
	  "Tertuliano",
	  "Vicente",
	  "Víctor",
	  "Vitória",
	  "Yango",
	  "Yago",
	  "Yuri",
	  "Washington",
	  "Warley"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1055);
	name.last_name = __webpack_require__(1057);
	name.prefix = __webpack_require__(1058);
	name.suffix = __webpack_require__(1059);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Silva",
	  "Souza",
	  "Carvalho",
	  "Santos",
	  "Reis",
	  "Xavier",
	  "Franco",
	  "Braga",
	  "Macedo",
	  "Batista",
	  "Barros",
	  "Moraes",
	  "Costa",
	  "Pereira",
	  "Carvalho",
	  "Melo",
	  "Saraiva",
	  "Nogueira",
	  "Oliveira",
	  "Martins",
	  "Moreira",
	  "Albuquerque"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Sr.",
	  "Sra.",
	  "Srta.",
	  "Dr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Jr.",
	  "Neto",
	  "Filho"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(##) ####-####",
	  "+55 (##) ####-####",
	  "(##) #####-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1060);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Address.city_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Москва",
	  "Владимир",
	  "Санкт-Петербург",
	  "Новосибирск",
	  "Екатеринбург",
	  "Нижний Новгород",
	  "Самара",
	  "Казань",
	  "Омск",
	  "Челябинск",
	  "Ростов-на-Дону",
	  "Уфа",
	  "Волгоград",
	  "Пермь",
	  "Красноярск",
	  "Воронеж",
	  "Саратов",
	  "Краснодар",
	  "Тольятти",
	  "Ижевск",
	  "Барнаул",
	  "Ульяновск",
	  "Тюмень",
	  "Иркутск",
	  "Владивосток",
	  "Ярославль",
	  "Хабаровск",
	  "Махачкала",
	  "Оренбург",
	  "Новокузнецк",
	  "Томск",
	  "Кемерово",
	  "Рязань",
	  "Астрахань",
	  "Пенза",
	  "Липецк",
	  "Тула",
	  "Киров",
	  "Чебоксары",
	  "Курск",
	  "Брянскm Магнитогорск",
	  "Иваново",
	  "Тверь",
	  "Ставрополь",
	  "Белгород",
	  "Сочи"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Австралия",
	  "Австрия",
	  "Азербайджан",
	  "Албания",
	  "Алжир",
	  "Американское Самоа (не признана)",
	  "Ангилья",
	  "Ангола",
	  "Андорра",
	  "Антарктика (не признана)",
	  "Антигуа и Барбуда",
	  "Антильские Острова (не признана)",
	  "Аомынь (не признана)",
	  "Аргентина",
	  "Армения",
	  "Афганистан",
	  "Багамские Острова",
	  "Бангладеш",
	  "Барбадос",
	  "Бахрейн",
	  "Беларусь",
	  "Белиз",
	  "Бельгия",
	  "Бенин",
	  "Болгария",
	  "Боливия",
	  "Босния и Герцеговина",
	  "Ботсвана",
	  "Бразилия",
	  "Бруней",
	  "Буркина-Фасо",
	  "Бурунди",
	  "Бутан",
	  "Вануату",
	  "Ватикан",
	  "Великобритания",
	  "Венгрия",
	  "Венесуэла",
	  "Восточный Тимор",
	  "Вьетнам",
	  "Габон",
	  "Гаити",
	  "Гайана",
	  "Гамбия",
	  "Гана",
	  "Гваделупа (не признана)",
	  "Гватемала",
	  "Гвиана (не признана)",
	  "Гвинея",
	  "Гвинея-Бисау",
	  "Германия",
	  "Гондурас",
	  "Гренада",
	  "Греция",
	  "Грузия",
	  "Дания",
	  "Джибути",
	  "Доминика",
	  "Доминиканская Республика",
	  "Египет",
	  "Замбия",
	  "Зимбабве",
	  "Израиль",
	  "Индия",
	  "Индонезия",
	  "Иордания",
	  "Ирак",
	  "Иран",
	  "Ирландия",
	  "Исландия",
	  "Испания",
	  "Италия",
	  "Йемен",
	  "Кабо-Верде",
	  "Казахстан",
	  "Камбоджа",
	  "Камерун",
	  "Канада",
	  "Катар",
	  "Кения",
	  "Кипр",
	  "Кирибати",
	  "Китай",
	  "Колумбия",
	  "Коморские Острова",
	  "Конго",
	  "Демократическая Республика",
	  "Корея (Северная)",
	  "Корея (Южная)",
	  "Косово",
	  "Коста-Рика",
	  "Кот-д'Ивуар",
	  "Куба",
	  "Кувейт",
	  "Кука острова",
	  "Кыргызстан",
	  "Лаос",
	  "Латвия",
	  "Лесото",
	  "Либерия",
	  "Ливан",
	  "Ливия",
	  "Литва",
	  "Лихтенштейн",
	  "Люксембург",
	  "Маврикий",
	  "Мавритания",
	  "Мадагаскар",
	  "Македония",
	  "Малави",
	  "Малайзия",
	  "Мали",
	  "Мальдивы",
	  "Мальта",
	  "Маршалловы Острова",
	  "Мексика",
	  "Микронезия",
	  "Мозамбик",
	  "Молдова",
	  "Монако",
	  "Монголия",
	  "Марокко",
	  "Мьянма",
	  "Намибия",
	  "Науру",
	  "Непал",
	  "Нигер",
	  "Нигерия",
	  "Нидерланды",
	  "Никарагуа",
	  "Новая Зеландия",
	  "Норвегия",
	  "Объединенные Арабские Эмираты",
	  "Оман",
	  "Пакистан",
	  "Палау",
	  "Панама",
	  "Папуа — Новая Гвинея",
	  "Парагвай",
	  "Перу",
	  "Польша",
	  "Португалия",
	  "Республика Конго",
	  "Россия",
	  "Руанда",
	  "Румыния",
	  "Сальвадор",
	  "Самоа",
	  "Сан-Марино",
	  "Сан-Томе и Принсипи",
	  "Саудовская Аравия",
	  "Свазиленд",
	  "Сейшельские острова",
	  "Сенегал",
	  "Сент-Винсент и Гренадины",
	  "Сент-Киттс и Невис",
	  "Сент-Люсия",
	  "Сербия",
	  "Сингапур",
	  "Сирия",
	  "Словакия",
	  "Словения",
	  "Соединенные Штаты Америки",
	  "Соломоновы Острова",
	  "Сомали",
	  "Судан",
	  "Суринам",
	  "Сьерра-Леоне",
	  "Таджикистан",
	  "Таиланд",
	  "Тайвань (не признана)",
	  "Тамил-Илам (не признана)",
	  "Танзания",
	  "Тёркс и Кайкос (не признана)",
	  "Того",
	  "Токелау (не признана)",
	  "Тонга",
	  "Тринидад и Тобаго",
	  "Тувалу",
	  "Тунис",
	  "Турецкая Республика Северного Кипра (не признана)",
	  "Туркменистан",
	  "Турция",
	  "Уганда",
	  "Узбекистан",
	  "Украина",
	  "Уругвай",
	  "Фарерские Острова (не признана)",
	  "Фиджи",
	  "Филиппины",
	  "Финляндия",
	  "Франция",
	  "Французская Полинезия (не признана)",
	  "Хорватия",
	  "Центральноафриканская Республика",
	  "Чад",
	  "Черногория",
	  "Чехия",
	  "Чили",
	  "Швейцария",
	  "Швеция",
	  "Шри-Ланка",
	  "Эквадор",
	  "Экваториальная Гвинея",
	  "Эритрея",
	  "Эстония",
	  "Эфиопия",
	  "Южно-Африканская Республика",
	  "Ямайка",
	  "Япония"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Россия"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.country = __webpack_require__(1065);
	address.building_number = __webpack_require__(1062);
	address.street_suffix = __webpack_require__(1073);
	address.secondary_address = __webpack_require__(1069);
	address.postcode = __webpack_require__(1068);
	address.state = __webpack_require__(1070);
	address.street_title = __webpack_require__(1074);
	address.city_name = __webpack_require__(1064);
	address.city = __webpack_require__(1063);
	address.street_name = __webpack_require__(1072);
	address.street_address = __webpack_require__(1071);
	address.default_country = __webpack_require__(1066);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "кв. ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Республика Адыгея",
	  "Республика Башкортостан",
	  "Республика Бурятия",
	  "Республика Алтай Республика Дагестан",
	  "Республика Ингушетия",
	  "Кабардино-Балкарская Республика",
	  "Республика Калмыкия",
	  "Республика Карачаево-Черкессия",
	  "Республика Карелия",
	  "Республика Коми",
	  "Республика Марий Эл",
	  "Республика Мордовия",
	  "Республика Саха (Якутия)",
	  "Республика Северная Осетия-Алания",
	  "Республика Татарстан",
	  "Республика Тыва",
	  "Удмуртская Республика",
	  "Республика Хакасия",
	  "Чувашская Республика",
	  "Алтайский край",
	  "Краснодарский край",
	  "Красноярский край",
	  "Приморский край",
	  "Ставропольский край",
	  "Хабаровский край",
	  "Амурская область",
	  "Архангельская область",
	  "Астраханская область",
	  "Белгородская область",
	  "Брянская область",
	  "Владимирская область",
	  "Волгоградская область",
	  "Вологодская область",
	  "Воронежская область",
	  "Ивановская область",
	  "Иркутская область",
	  "Калиниградская область",
	  "Калужская область",
	  "Камчатская область",
	  "Кемеровская область",
	  "Кировская область",
	  "Костромская область",
	  "Курганская область",
	  "Курская область",
	  "Ленинградская область",
	  "Липецкая область",
	  "Магаданская область",
	  "Московская область",
	  "Мурманская область",
	  "Нижегородская область",
	  "Новгородская область",
	  "Новосибирская область",
	  "Омская область",
	  "Оренбургская область",
	  "Орловская область",
	  "Пензенская область",
	  "Пермская область",
	  "Псковская область",
	  "Ростовская область",
	  "Рязанская область",
	  "Самарская область",
	  "Саратовская область",
	  "Сахалинская область",
	  "Свердловская область",
	  "Смоленская область",
	  "Тамбовская область",
	  "Тверская область",
	  "Томская область",
	  "Тульская область",
	  "Тюменская область",
	  "Ульяновская область",
	  "Челябинская область",
	  "Читинская область",
	  "Ярославская область",
	  "Еврейская автономная область",
	  "Агинский Бурятский авт. округ",
	  "Коми-Пермяцкий автономный округ",
	  "Корякский автономный округ",
	  "Ненецкий автономный округ",
	  "Таймырский (Долгано-Ненецкий) автономный округ",
	  "Усть-Ордынский Бурятский автономный округ",
	  "Ханты-Мансийский автономный округ",
	  "Чукотский автономный округ",
	  "Эвенкийский автономный округ",
	  "Ямало-Ненецкий автономный округ",
	  "Чеченская Республика"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name}, #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_suffix} #{Address.street_title}",
	  "#{Address.street_title} #{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ул.",
	  "улица",
	  "проспект",
	  "пр.",
	  "площадь",
	  "пл."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Советская",
	  "Молодежная",
	  "Центральная",
	  "Школьная",
	  "Новая",
	  "Садовая",
	  "Лесная",
	  "Набережная",
	  "Ленина",
	  "Мира",
	  "Октябрьская",
	  "Зеленая",
	  "Комсомольская",
	  "Заречная",
	  "Первомайская",
	  "Гагарина",
	  "Полевая",
	  "Луговая",
	  "Пионерская",
	  "Кирова",
	  "Юбилейная",
	  "Северная",
	  "Пролетарская",
	  "Степная",
	  "Пушкина",
	  "Калинина",
	  "Южная",
	  "Колхозная",
	  "Рабочая",
	  "Солнечная",
	  "Железнодорожная",
	  "Восточная",
	  "Заводская",
	  "Чапаева",
	  "Нагорная",
	  "Строителей",
	  "Береговая",
	  "Победы",
	  "Горького",
	  "Кооперативная",
	  "Красноармейская",
	  "Совхозная",
	  "Речная",
	  "Школьный",
	  "Спортивная",
	  "Озерная",
	  "Строительная",
	  "Парковая",
	  "Чкалова",
	  "Мичурина",
	  "речень улиц",
	  "Подгорная",
	  "Дружбы",
	  "Почтовая",
	  "Партизанская",
	  "Вокзальная",
	  "Лермонтова",
	  "Свободы",
	  "Дорожная",
	  "Дачная",
	  "Маяковского",
	  "Западная",
	  "Фрунзе",
	  "Дзержинского",
	  "Московская",
	  "Свердлова",
	  "Некрасова",
	  "Гоголя",
	  "Красная",
	  "Трудовая",
	  "Шоссейная",
	  "Чехова",
	  "Коммунистическая",
	  "Труда",
	  "Комарова",
	  "Матросова",
	  "Островского",
	  "Сосновая",
	  "Клубная",
	  "Куйбышева",
	  "Крупской",
	  "Березовая",
	  "Карла Маркса",
	  "8 Марта",
	  "Больничная",
	  "Садовый",
	  "Интернациональная",
	  "Суворова",
	  "Цветочная",
	  "Трактовая",
	  "Ломоносова",
	  "Горная",
	  "Космонавтов",
	  "Энергетиков",
	  "Шевченко",
	  "Весенняя",
	  "Механизаторов",
	  "Коммунальная",
	  "Лесной",
	  "40 лет Победы",
	  "Майская"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "красный",
	  "зеленый",
	  "синий",
	  "желтый",
	  "багровый",
	  "мятный",
	  "зеленовато-голубой",
	  "белый",
	  "черный",
	  "оранжевый",
	  "розовый",
	  "серый",
	  "красно-коричневый",
	  "фиолетовый",
	  "бирюзовый",
	  "желто-коричневый",
	  "небесно голубой",
	  "оранжево-розовый",
	  "темно-фиолетовый",
	  "орхидный",
	  "оливковый",
	  "пурпурный",
	  "лимонный",
	  "кремовый",
	  "сине-фиолетовый",
	  "золотой",
	  "красно-пурпурный",
	  "голубой",
	  "лазурный",
	  "лиловый",
	  "серебряный"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Книги",
	  "Фильмы",
	  "музыка",
	  "игры",
	  "Электроника",
	  "компьютеры",
	  "Дом",
	  "садинструмент",
	  "Бакалея",
	  "здоровье",
	  "красота",
	  "Игрушки",
	  "детское",
	  "для малышей",
	  "Одежда",
	  "обувь",
	  "украшения",
	  "Спорт",
	  "туризм",
	  "Автомобильное",
	  "промышленное"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var commerce = {};
	module['exports'] = commerce;
	commerce.color = __webpack_require__(1075);
	commerce.department = __webpack_require__(1076);
	commerce.product_name = __webpack_require__(1078);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "adjective": [
	    "Маленький",
	    "Эргономичный",
	    "Грубый",
	    "Интеллектуальный",
	    "Великолепный",
	    "Невероятный",
	    "Фантастический",
	    "Практчиный",
	    "Лоснящийся",
	    "Потрясающий"
	  ],
	  "material": [
	    "Стальной",
	    "Деревянный",
	    "Бетонный",
	    "Пластиковый",
	    "Хлопковый",
	    "Гранитный",
	    "Резиновый"
	  ],
	  "product": [
	    "Стул",
	    "Автомобиль",
	    "Компьютер",
	    "Берет",
	    "Кулон",
	    "Стол",
	    "Свитер",
	    "Ремень",
	    "Ботинок"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.prefix = __webpack_require__(1081);
	company.suffix = __webpack_require__(1082);
	company.name = __webpack_require__(1080);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{Name.female_first_name}",
	  "#{prefix} #{Name.male_first_name}",
	  "#{prefix} #{Name.male_last_name}",
	  "#{prefix} #{suffix}#{suffix}",
	  "#{prefix} #{suffix}#{suffix}#{suffix}",
	  "#{prefix} #{Address.city_name}#{suffix}",
	  "#{prefix} #{Address.city_name}#{suffix}#{suffix}",
	  "#{prefix} #{Address.city_name}#{suffix}#{suffix}#{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ИП",
	  "ООО",
	  "ЗАО",
	  "ОАО",
	  "НКО",
	  "ТСЖ",
	  "ОП"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Снаб",
	  "Торг",
	  "Пром",
	  "Трейд",
	  "Сбыт"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var date = {};
	module["exports"] = date;
	date.month = __webpack_require__(1084);
	date.weekday = __webpack_require__(1085);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/ru.xml#L1734
	module["exports"] = {
	  wide: [
	    "январь",
	    "февраль",
	    "март",
	    "апрель",
	    "май",
	    "июнь",
	    "июль",
	    "август",
	    "сентябрь",
	    "октябрь",
	    "ноябрь",
	    "декабрь"
	  ],
	  wide_context: [
	    "января",
	    "февраля",
	    "марта",
	    "апреля",
	    "мая",
	    "июня",
	    "июля",
	    "августа",
	    "сентября",
	    "октября",
	    "ноября",
	    "декабря"
	  ],
	  abbr: [
	    "янв.",
	    "февр.",
	    "март",
	    "апр.",
	    "май",
	    "июнь",
	    "июль",
	    "авг.",
	    "сент.",
	    "окт.",
	    "нояб.",
	    "дек."
	  ],
	  abbr_context: [
	    "янв.",
	    "февр.",
	    "марта",
	    "апр.",
	    "мая",
	    "июня",
	    "июля",
	    "авг.",
	    "сент.",
	    "окт.",
	    "нояб.",
	    "дек."
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/ru.xml#L1825
	module["exports"] = {
	  wide: [
	    "Воскресенье",
	    "Понедельник",
	    "Вторник",
	    "Среда",
	    "Четверг",
	    "Пятница",
	    "Суббота"
	  ],
	  wide_context: [
	    "воскресенье",
	    "понедельник",
	    "вторник",
	    "среда",
	    "четверг",
	    "пятница",
	    "суббота"
	  ],
	  abbr: [
	    "Вс",
	    "Пн",
	    "Вт",
	    "Ср",
	    "Чт",
	    "Пт",
	    "Сб"
	  ],
	  abbr_context: [
	    "вс",
	    "пн",
	    "вт",
	    "ср",
	    "чт",
	    "пт",
	    "сб"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var ru = {};
	module['exports'] = ru;
	ru.title = "Russian";
	ru.separator = " и ";
	ru.address = __webpack_require__(1067);
	ru.internet = __webpack_require__(1089);
	ru.name = __webpack_require__(1093);
	ru.phone_number = __webpack_require__(1101);
	ru.commerce = __webpack_require__(1077);
	ru.company = __webpack_require__(1079);
	ru.date = __webpack_require__(1083);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "ru",
	  "info",
	  "рф",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "yandex.ru",
	  "ya.ru",
	  "mail.ru",
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1088);
	internet.domain_suffix = __webpack_require__(1087);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Анна",
	  "Алёна",
	  "Алевтина",
	  "Александра",
	  "Алина",
	  "Алла",
	  "Анастасия",
	  "Ангелина",
	  "Анжела",
	  "Анжелика",
	  "Антонида",
	  "Антонина",
	  "Анфиса",
	  "Арина",
	  "Валентина",
	  "Валерия",
	  "Варвара",
	  "Василиса",
	  "Вера",
	  "Вероника",
	  "Виктория",
	  "Галина",
	  "Дарья",
	  "Евгения",
	  "Екатерина",
	  "Елена",
	  "Елизавета",
	  "Жанна",
	  "Зинаида",
	  "Зоя",
	  "Ирина",
	  "Кира",
	  "Клавдия",
	  "Ксения",
	  "Лариса",
	  "Лидия",
	  "Любовь",
	  "Людмила",
	  "Маргарита",
	  "Марина",
	  "Мария",
	  "Надежда",
	  "Наталья",
	  "Нина",
	  "Оксана",
	  "Ольга",
	  "Раиса",
	  "Регина",
	  "Римма",
	  "Светлана",
	  "София",
	  "Таисия",
	  "Тамара",
	  "Татьяна",
	  "Ульяна",
	  "Юлия"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Смирнова",
	  "Иванова",
	  "Кузнецова",
	  "Попова",
	  "Соколова",
	  "Лебедева",
	  "Козлова",
	  "Новикова",
	  "Морозова",
	  "Петрова",
	  "Волкова",
	  "Соловьева",
	  "Васильева",
	  "Зайцева",
	  "Павлова",
	  "Семенова",
	  "Голубева",
	  "Виноградова",
	  "Богданова",
	  "Воробьева",
	  "Федорова",
	  "Михайлова",
	  "Беляева",
	  "Тарасова",
	  "Белова",
	  "Комарова",
	  "Орлова",
	  "Киселева",
	  "Макарова",
	  "Андреева",
	  "Ковалева",
	  "Ильина",
	  "Гусева",
	  "Титова",
	  "Кузьмина",
	  "Кудрявцева",
	  "Баранова",
	  "Куликова",
	  "Алексеева",
	  "Степанова",
	  "Яковлева",
	  "Сорокина",
	  "Сергеева",
	  "Романова",
	  "Захарова",
	  "Борисова",
	  "Королева",
	  "Герасимова",
	  "Пономарева",
	  "Григорьева",
	  "Лазарева",
	  "Медведева",
	  "Ершова",
	  "Никитина",
	  "Соболева",
	  "Рябова",
	  "Полякова",
	  "Цветкова",
	  "Данилова",
	  "Жукова",
	  "Фролова",
	  "Журавлева",
	  "Николаева",
	  "Крылова",
	  "Максимова",
	  "Сидорова",
	  "Осипова",
	  "Белоусова",
	  "Федотова",
	  "Дорофеева",
	  "Егорова",
	  "Матвеева",
	  "Боброва",
	  "Дмитриева",
	  "Калинина",
	  "Анисимова",
	  "Петухова",
	  "Антонова",
	  "Тимофеева",
	  "Никифорова",
	  "Веселова",
	  "Филиппова",
	  "Маркова",
	  "Большакова",
	  "Суханова",
	  "Миронова",
	  "Ширяева",
	  "Александрова",
	  "Коновалова",
	  "Шестакова",
	  "Казакова",
	  "Ефимова",
	  "Денисова",
	  "Громова",
	  "Фомина",
	  "Давыдова",
	  "Мельникова",
	  "Щербакова",
	  "Блинова",
	  "Колесникова",
	  "Карпова",
	  "Афанасьева",
	  "Власова",
	  "Маслова",
	  "Исакова",
	  "Тихонова",
	  "Аксенова",
	  "Гаврилова",
	  "Родионова",
	  "Котова",
	  "Горбунова",
	  "Кудряшова",
	  "Быкова",
	  "Зуева",
	  "Третьякова",
	  "Савельева",
	  "Панова",
	  "Рыбакова",
	  "Суворова",
	  "Абрамова",
	  "Воронова",
	  "Мухина",
	  "Архипова",
	  "Трофимова",
	  "Мартынова",
	  "Емельянова",
	  "Горшкова",
	  "Чернова",
	  "Овчинникова",
	  "Селезнева",
	  "Панфилова",
	  "Копылова",
	  "Михеева",
	  "Галкина",
	  "Назарова",
	  "Лобанова",
	  "Лукина",
	  "Белякова",
	  "Потапова",
	  "Некрасова",
	  "Хохлова",
	  "Жданова",
	  "Наумова",
	  "Шилова",
	  "Воронцова",
	  "Ермакова",
	  "Дроздова",
	  "Игнатьева",
	  "Савина",
	  "Логинова",
	  "Сафонова",
	  "Капустина",
	  "Кириллова",
	  "Моисеева",
	  "Елисеева",
	  "Кошелева",
	  "Костина",
	  "Горбачева",
	  "Орехова",
	  "Ефремова",
	  "Исаева",
	  "Евдокимова",
	  "Калашникова",
	  "Кабанова",
	  "Носкова",
	  "Юдина",
	  "Кулагина",
	  "Лапина",
	  "Прохорова",
	  "Нестерова",
	  "Харитонова",
	  "Агафонова",
	  "Муравьева",
	  "Ларионова",
	  "Федосеева",
	  "Зимина",
	  "Пахомова",
	  "Шубина",
	  "Игнатова",
	  "Филатова",
	  "Крюкова",
	  "Рогова",
	  "Кулакова",
	  "Терентьева",
	  "Молчанова",
	  "Владимирова",
	  "Артемьева",
	  "Гурьева",
	  "Зиновьева",
	  "Гришина",
	  "Кононова",
	  "Дементьева",
	  "Ситникова",
	  "Симонова",
	  "Мишина",
	  "Фадеева",
	  "Комиссарова",
	  "Мамонтова",
	  "Носова",
	  "Гуляева",
	  "Шарова",
	  "Устинова",
	  "Вишнякова",
	  "Евсеева",
	  "Лаврентьева",
	  "Брагина",
	  "Константинова",
	  "Корнилова",
	  "Авдеева",
	  "Зыкова",
	  "Бирюкова",
	  "Шарапова",
	  "Никонова",
	  "Щукина",
	  "Дьячкова",
	  "Одинцова",
	  "Сазонова",
	  "Якушева",
	  "Красильникова",
	  "Гордеева",
	  "Самойлова",
	  "Князева",
	  "Беспалова",
	  "Уварова",
	  "Шашкова",
	  "Бобылева",
	  "Доронина",
	  "Белозерова",
	  "Рожкова",
	  "Самсонова",
	  "Мясникова",
	  "Лихачева",
	  "Бурова",
	  "Сысоева",
	  "Фомичева",
	  "Русакова",
	  "Стрелкова",
	  "Гущина",
	  "Тетерина",
	  "Колобова",
	  "Субботина",
	  "Фокина",
	  "Блохина",
	  "Селиверстова",
	  "Пестова",
	  "Кондратьева",
	  "Силина",
	  "Меркушева",
	  "Лыткина",
	  "Турова"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Александровна",
	  "Алексеевна",
	  "Альбертовна",
	  "Анатольевна",
	  "Андреевна",
	  "Антоновна",
	  "Аркадьевна",
	  "Арсеньевна",
	  "Артёмовна",
	  "Борисовна",
	  "Вадимовна",
	  "Валентиновна",
	  "Валерьевна",
	  "Васильевна",
	  "Викторовна",
	  "Витальевна",
	  "Владимировна",
	  "Владиславовна",
	  "Вячеславовна",
	  "Геннадьевна",
	  "Георгиевна",
	  "Германовна",
	  "Григорьевна",
	  "Данииловна",
	  "Денисовна",
	  "Дмитриевна",
	  "Евгеньевна",
	  "Егоровна",
	  "Ивановна",
	  "Игнатьевна",
	  "Игоревна",
	  "Ильинична",
	  "Константиновна",
	  "Лаврентьевна",
	  "Леонидовна",
	  "Макаровна",
	  "Максимовна",
	  "Матвеевна",
	  "Михайловна",
	  "Никитична",
	  "Николаевна",
	  "Олеговна",
	  "Романовна",
	  "Семёновна",
	  "Сергеевна",
	  "Станиславовна",
	  "Степановна",
	  "Фёдоровна",
	  "Эдуардовна",
	  "Юрьевна",
	  "Ярославовна"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.male_first_name = __webpack_require__(1094);
	name.male_middle_name = __webpack_require__(1096);
	name.male_last_name = __webpack_require__(1095);
	name.female_first_name = __webpack_require__(1090);
	name.female_middle_name = __webpack_require__(1092);
	name.female_last_name = __webpack_require__(1091);
	name.prefix = __webpack_require__(1098);
	name.suffix = __webpack_require__(1099);
	name.name = __webpack_require__(1097);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Александр",
	  "Алексей",
	  "Альберт",
	  "Анатолий",
	  "Андрей",
	  "Антон",
	  "Аркадий",
	  "Арсений",
	  "Артём",
	  "Борис",
	  "Вадим",
	  "Валентин",
	  "Валерий",
	  "Василий",
	  "Виктор",
	  "Виталий",
	  "Владимир",
	  "Владислав",
	  "Вячеслав",
	  "Геннадий",
	  "Георгий",
	  "Герман",
	  "Григорий",
	  "Даниил",
	  "Денис",
	  "Дмитрий",
	  "Евгений",
	  "Егор",
	  "Иван",
	  "Игнатий",
	  "Игорь",
	  "Илья",
	  "Константин",
	  "Лаврентий",
	  "Леонид",
	  "Лука",
	  "Макар",
	  "Максим",
	  "Матвей",
	  "Михаил",
	  "Никита",
	  "Николай",
	  "Олег",
	  "Роман",
	  "Семён",
	  "Сергей",
	  "Станислав",
	  "Степан",
	  "Фёдор",
	  "Эдуард",
	  "Юрий",
	  "Ярослав"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Смирнов",
	  "Иванов",
	  "Кузнецов",
	  "Попов",
	  "Соколов",
	  "Лебедев",
	  "Козлов",
	  "Новиков",
	  "Морозов",
	  "Петров",
	  "Волков",
	  "Соловьев",
	  "Васильев",
	  "Зайцев",
	  "Павлов",
	  "Семенов",
	  "Голубев",
	  "Виноградов",
	  "Богданов",
	  "Воробьев",
	  "Федоров",
	  "Михайлов",
	  "Беляев",
	  "Тарасов",
	  "Белов",
	  "Комаров",
	  "Орлов",
	  "Киселев",
	  "Макаров",
	  "Андреев",
	  "Ковалев",
	  "Ильин",
	  "Гусев",
	  "Титов",
	  "Кузьмин",
	  "Кудрявцев",
	  "Баранов",
	  "Куликов",
	  "Алексеев",
	  "Степанов",
	  "Яковлев",
	  "Сорокин",
	  "Сергеев",
	  "Романов",
	  "Захаров",
	  "Борисов",
	  "Королев",
	  "Герасимов",
	  "Пономарев",
	  "Григорьев",
	  "Лазарев",
	  "Медведев",
	  "Ершов",
	  "Никитин",
	  "Соболев",
	  "Рябов",
	  "Поляков",
	  "Цветков",
	  "Данилов",
	  "Жуков",
	  "Фролов",
	  "Журавлев",
	  "Николаев",
	  "Крылов",
	  "Максимов",
	  "Сидоров",
	  "Осипов",
	  "Белоусов",
	  "Федотов",
	  "Дорофеев",
	  "Егоров",
	  "Матвеев",
	  "Бобров",
	  "Дмитриев",
	  "Калинин",
	  "Анисимов",
	  "Петухов",
	  "Антонов",
	  "Тимофеев",
	  "Никифоров",
	  "Веселов",
	  "Филиппов",
	  "Марков",
	  "Большаков",
	  "Суханов",
	  "Миронов",
	  "Ширяев",
	  "Александров",
	  "Коновалов",
	  "Шестаков",
	  "Казаков",
	  "Ефимов",
	  "Денисов",
	  "Громов",
	  "Фомин",
	  "Давыдов",
	  "Мельников",
	  "Щербаков",
	  "Блинов",
	  "Колесников",
	  "Карпов",
	  "Афанасьев",
	  "Власов",
	  "Маслов",
	  "Исаков",
	  "Тихонов",
	  "Аксенов",
	  "Гаврилов",
	  "Родионов",
	  "Котов",
	  "Горбунов",
	  "Кудряшов",
	  "Быков",
	  "Зуев",
	  "Третьяков",
	  "Савельев",
	  "Панов",
	  "Рыбаков",
	  "Суворов",
	  "Абрамов",
	  "Воронов",
	  "Мухин",
	  "Архипов",
	  "Трофимов",
	  "Мартынов",
	  "Емельянов",
	  "Горшков",
	  "Чернов",
	  "Овчинников",
	  "Селезнев",
	  "Панфилов",
	  "Копылов",
	  "Михеев",
	  "Галкин",
	  "Назаров",
	  "Лобанов",
	  "Лукин",
	  "Беляков",
	  "Потапов",
	  "Некрасов",
	  "Хохлов",
	  "Жданов",
	  "Наумов",
	  "Шилов",
	  "Воронцов",
	  "Ермаков",
	  "Дроздов",
	  "Игнатьев",
	  "Савин",
	  "Логинов",
	  "Сафонов",
	  "Капустин",
	  "Кириллов",
	  "Моисеев",
	  "Елисеев",
	  "Кошелев",
	  "Костин",
	  "Горбачев",
	  "Орехов",
	  "Ефремов",
	  "Исаев",
	  "Евдокимов",
	  "Калашников",
	  "Кабанов",
	  "Носков",
	  "Юдин",
	  "Кулагин",
	  "Лапин",
	  "Прохоров",
	  "Нестеров",
	  "Харитонов",
	  "Агафонов",
	  "Муравьев",
	  "Ларионов",
	  "Федосеев",
	  "Зимин",
	  "Пахомов",
	  "Шубин",
	  "Игнатов",
	  "Филатов",
	  "Крюков",
	  "Рогов",
	  "Кулаков",
	  "Терентьев",
	  "Молчанов",
	  "Владимиров",
	  "Артемьев",
	  "Гурьев",
	  "Зиновьев",
	  "Гришин",
	  "Кононов",
	  "Дементьев",
	  "Ситников",
	  "Симонов",
	  "Мишин",
	  "Фадеев",
	  "Комиссаров",
	  "Мамонтов",
	  "Носов",
	  "Гуляев",
	  "Шаров",
	  "Устинов",
	  "Вишняков",
	  "Евсеев",
	  "Лаврентьев",
	  "Брагин",
	  "Константинов",
	  "Корнилов",
	  "Авдеев",
	  "Зыков",
	  "Бирюков",
	  "Шарапов",
	  "Никонов",
	  "Щукин",
	  "Дьячков",
	  "Одинцов",
	  "Сазонов",
	  "Якушев",
	  "Красильников",
	  "Гордеев",
	  "Самойлов",
	  "Князев",
	  "Беспалов",
	  "Уваров",
	  "Шашков",
	  "Бобылев",
	  "Доронин",
	  "Белозеров",
	  "Рожков",
	  "Самсонов",
	  "Мясников",
	  "Лихачев",
	  "Буров",
	  "Сысоев",
	  "Фомичев",
	  "Русаков",
	  "Стрелков",
	  "Гущин",
	  "Тетерин",
	  "Колобов",
	  "Субботин",
	  "Фокин",
	  "Блохин",
	  "Селиверстов",
	  "Пестов",
	  "Кондратьев",
	  "Силин",
	  "Меркушев",
	  "Лыткин",
	  "Туров"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Александрович",
	  "Алексеевич",
	  "Альбертович",
	  "Анатольевич",
	  "Андреевич",
	  "Антонович",
	  "Аркадьевич",
	  "Арсеньевич",
	  "Артёмович",
	  "Борисович",
	  "Вадимович",
	  "Валентинович",
	  "Валерьевич",
	  "Васильевич",
	  "Викторович",
	  "Витальевич",
	  "Владимирович",
	  "Владиславович",
	  "Вячеславович",
	  "Геннадьевич",
	  "Георгиевич",
	  "Германович",
	  "Григорьевич",
	  "Даниилович",
	  "Денисович",
	  "Дмитриевич",
	  "Евгеньевич",
	  "Егорович",
	  "Иванович",
	  "Игнатьевич",
	  "Игоревич",
	  "Ильич",
	  "Константинович",
	  "Лаврентьевич",
	  "Леонидович",
	  "Лукич",
	  "Макарович",
	  "Максимович",
	  "Матвеевич",
	  "Михайлович",
	  "Никитич",
	  "Николаевич",
	  "Олегович",
	  "Романович",
	  "Семёнович",
	  "Сергеевич",
	  "Станиславович",
	  "Степанович",
	  "Фёдорович",
	  "Эдуардович",
	  "Юрьевич",
	  "Ярославович"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{male_first_name} #{male_last_name}",
	  "#{male_last_name} #{male_first_name}",
	  "#{male_first_name} #{male_middle_name} #{male_last_name}",
	  "#{male_last_name} #{male_first_name} #{male_middle_name}",
	  "#{female_first_name} #{female_last_name}",
	  "#{female_last_name} #{female_first_name}",
	  "#{female_first_name} #{female_middle_name} #{female_last_name}",
	  "#{female_last_name} #{female_first_name} #{female_middle_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(9##)###-##-##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1100);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#",
	  "##",
	  "###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bánovce nad Bebravou",
	  "Banská Bystrica",
	  "Banská Štiavnica",
	  "Bardejov",
	  "Bratislava I",
	  "Bratislava II",
	  "Bratislava III",
	  "Bratislava IV",
	  "Bratislava V",
	  "Brezno",
	  "Bytča",
	  "Čadca",
	  "Detva",
	  "Dolný Kubín",
	  "Dunajská Streda",
	  "Galanta",
	  "Gelnica",
	  "Hlohovec",
	  "Humenné",
	  "Ilava",
	  "Kežmarok",
	  "Komárno",
	  "Košice I",
	  "Košice II",
	  "Košice III",
	  "Košice IV",
	  "Košice-okolie",
	  "Krupina",
	  "Kysucké Nové Mesto",
	  "Levice",
	  "Levoča",
	  "Liptovský Mikuláš",
	  "Lučenec",
	  "Malacky",
	  "Martin",
	  "Medzilaborce",
	  "Michalovce",
	  "Myjava",
	  "Námestovo",
	  "Nitra",
	  "Nové Mesto n.Váhom",
	  "Nové Zámky",
	  "Partizánske",
	  "Pezinok",
	  "Piešťany",
	  "Poltár",
	  "Poprad",
	  "Považská Bystrica",
	  "Prešov",
	  "Prievidza",
	  "Púchov",
	  "Revúca",
	  "Rimavská Sobota",
	  "Rožňava",
	  "Ružomberok",
	  "Sabinov",
	  "Šaľa",
	  "Senec",
	  "Senica",
	  "Skalica",
	  "Snina",
	  "Sobrance",
	  "Spišská Nová Ves",
	  "Stará Ľubovňa",
	  "Stropkov",
	  "Svidník",
	  "Topoľčany",
	  "Trebišov",
	  "Trenčín",
	  "Trnava",
	  "Turčianske Teplice",
	  "Tvrdošín",
	  "Veľký Krtíš",
	  "Vranov nad Topľou",
	  "Žarnovica",
	  "Žiar nad Hronom",
	  "Žilina",
	  "Zlaté Moravce",
	  "Zvolen"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "North",
	  "East",
	  "West",
	  "South",
	  "New",
	  "Lake",
	  "Port"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "town",
	  "ton",
	  "land",
	  "ville",
	  "berg",
	  "burgh",
	  "borough",
	  "bury",
	  "view",
	  "port",
	  "mouth",
	  "stad",
	  "furt",
	  "chester",
	  "mouth",
	  "fort",
	  "haven",
	  "side",
	  "shire"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afganistan",
	  "Afgánsky islamský štát",
	  "Albánsko",
	  "Albánska republika",
	  "Alžírsko",
	  "Alžírska demokratická ľudová republika",
	  "Andorra",
	  "Andorrské kniežatsvo",
	  "Angola",
	  "Angolská republika",
	  "Antigua a Barbuda",
	  "Antigua a Barbuda",
	  "Argentína",
	  "Argentínska republika",
	  "Arménsko",
	  "Arménska republika",
	  "Austrália",
	  "Austrálsky zväz",
	  "Azerbajdžan",
	  "Azerbajdžanská republika",
	  "Bahamy",
	  "Bahamské spoločenstvo",
	  "Bahrajn",
	  "Bahrajnské kráľovstvo",
	  "Bangladéš",
	  "Bangladéšska ľudová republika",
	  "Barbados",
	  "Barbados",
	  "Belgicko",
	  "Belgické kráľovstvo",
	  "Belize",
	  "Belize",
	  "Benin",
	  "Beninská republika",
	  "Bhután",
	  "Bhutánske kráľovstvo",
	  "Bielorusko",
	  "Bieloruská republika",
	  "Bolívia",
	  "Bolívijská republika",
	  "Bosna a Hercegovina",
	  "Republika Bosny a Hercegoviny",
	  "Botswana",
	  "Botswanská republika",
	  "Brazília",
	  "Brazílska federatívna republika",
	  "Brunej",
	  "Brunejský sultanát",
	  "Bulharsko",
	  "Bulharská republika",
	  "Burkina Faso",
	  "Burkina Faso",
	  "Burundi",
	  "Burundská republika",
	  "Cyprus",
	  "Cyperská republika",
	  "Čad",
	  "Republika Čad",
	  "Česko",
	  "Česká republika",
	  "Čína",
	  "Čínska ľudová republika",
	  "Dánsko",
	  "Dánsko kráľovstvo",
	  "Dominika",
	  "Spoločenstvo Dominika",
	  "Dominikánska republika",
	  "Dominikánska republika",
	  "Džibutsko",
	  "Džibutská republika",
	  "Egypt",
	  "Egyptská arabská republika",
	  "Ekvádor",
	  "Ekvádorská republika",
	  "Eritrea",
	  "Eritrejský štát",
	  "Estónsko",
	  "Estónska republika",
	  "Etiópia",
	  "Etiópska federatívna demokratická republika",
	  "Fidži",
	  "Republika ostrovy Fidži",
	  "Filipíny",
	  "Filipínska republika",
	  "Fínsko",
	  "Fínska republika",
	  "Francúzsko",
	  "Francúzska republika",
	  "Gabon",
	  "Gabonská republika",
	  "Gambia",
	  "Gambijská republika",
	  "Ghana",
	  "Ghanská republika",
	  "Grécko",
	  "Helénska republika",
	  "Grenada",
	  "Grenada",
	  "Gruzínsko",
	  "Gruzínsko",
	  "Guatemala",
	  "Guatemalská republika",
	  "Guinea",
	  "Guinejská republika",
	  "Guinea-Bissau",
	  "Republika Guinea-Bissau",
	  "Guayana",
	  "Guayanská republika",
	  "Haiti",
	  "Republika Haiti",
	  "Holandsko",
	  "Holandské kráľovstvo",
	  "Honduras",
	  "Honduraská republika",
	  "Chile",
	  "Čílska republika",
	  "Chorvátsko",
	  "Chorvátska republika",
	  "India",
	  "Indická republika",
	  "Indonézia",
	  "Indonézska republika",
	  "Irak",
	  "Iracká republika",
	  "Irán",
	  "Iránska islamská republika",
	  "Island",
	  "Islandská republika",
	  "Izrael",
	  "Štát Izrael",
	  "Írsko",
	  "Írska republika",
	  "Jamajka",
	  "Jamajka",
	  "Japonsko",
	  "Japonsko",
	  "Jemen",
	  "Jemenská republika",
	  "Jordánsko",
	  "Jordánske hášimovské kráľovstvo",
	  "Južná Afrika",
	  "Juhoafrická republika",
	  "Kambodža",
	  "Kambodžské kráľovstvo",
	  "Kamerun",
	  "Kamerunská republika",
	  "Kanada",
	  "Kanada",
	  "Kapverdy",
	  "Kapverdská republika",
	  "Katar",
	  "Štát Katar",
	  "Kazachstan",
	  "Kazašská republika",
	  "Keňa",
	  "Kenská republika",
	  "Kirgizsko",
	  "Kirgizská republika",
	  "Kiribati",
	  "Kiribatská republika",
	  "Kolumbia",
	  "Kolumbijská republika",
	  "Komory",
	  "Komorská únia",
	  "Kongo",
	  "Konžská demokratická republika",
	  "Kongo (\"Brazzaville\")",
	  "Konžská republika",
	  "Kórea (\"Južná\")",
	  "Kórejská republika",
	  "Kórea (\"Severná\")",
	  "Kórejská ľudovodemokratická republika",
	  "Kostarika",
	  "Kostarická republika",
	  "Kuba",
	  "Kubánska republika",
	  "Kuvajt",
	  "Kuvajtský štát",
	  "Laos",
	  "Laoská ľudovodemokratická republika",
	  "Lesotho",
	  "Lesothské kráľovstvo",
	  "Libanon",
	  "Libanonská republika",
	  "Libéria",
	  "Libérijská republika",
	  "Líbya",
	  "Líbyjská arabská ľudová socialistická džamáhírija",
	  "Lichtenštajnsko",
	  "Lichtenštajnské kniežatstvo",
	  "Litva",
	  "Litovská republika",
	  "Lotyšsko",
	  "Lotyšská republika",
	  "Luxembursko",
	  "Luxemburské veľkovojvodstvo",
	  "Macedónsko",
	  "Macedónska republika",
	  "Madagaskar",
	  "Madagaskarská republika",
	  "Maďarsko",
	  "Maďarská republika",
	  "Malajzia",
	  "Malajzia",
	  "Malawi",
	  "Malawijská republika",
	  "Maldivy",
	  "Maldivská republika",
	  "Mali",
	  "Malijská republika",
	  "Malta",
	  "Malta",
	  "Maroko",
	  "Marocké kráľovstvo",
	  "Marshallove ostrovy",
	  "Republika Marshallových ostrovy",
	  "Mauritánia",
	  "Mauritánska islamská republika",
	  "Maurícius",
	  "Maurícijská republika",
	  "Mexiko",
	  "Spojené štáty mexické",
	  "Mikronézia",
	  "Mikronézske federatívne štáty",
	  "Mjanmarsko",
	  "Mjanmarský zväz",
	  "Moldavsko",
	  "Moldavská republika",
	  "Monako",
	  "Monacké kniežatstvo",
	  "Mongolsko",
	  "Mongolsko",
	  "Mozambik",
	  "Mozambická republika",
	  "Namíbia",
	  "Namíbijská republika",
	  "Nauru",
	  "Naurská republika",
	  "Nemecko",
	  "Nemecká spolková republika",
	  "Nepál",
	  "Nepálske kráľovstvo",
	  "Niger",
	  "Nigerská republika",
	  "Nigéria",
	  "Nigérijská federatívna republika",
	  "Nikaragua",
	  "Nikaragujská republika",
	  "Nový Zéland",
	  "Nový Zéland",
	  "Nórsko",
	  "Nórske kráľovstvo",
	  "Omán",
	  "Ománsky sultanát",
	  "Pakistan",
	  "Pakistanská islamská republika",
	  "Palau",
	  "Palauská republika",
	  "Panama",
	  "Panamská republika",
	  "Papua-Nová Guinea",
	  "Nezávislý štát Papua-Nová Guinea",
	  "Paraguaj",
	  "Paraguajská republika",
	  "Peru",
	  "Peruánska republika",
	  "Pobrežie Slonoviny",
	  "Republika Pobrežie Slonoviny",
	  "Poľsko",
	  "Poľská republika",
	  "Portugalsko",
	  "Portugalská republika",
	  "Rakúsko",
	  "Rakúska republika",
	  "Rovníková Guinea",
	  "Republika Rovníková Guinea",
	  "Rumunsko",
	  "Rumunsko",
	  "Rusko",
	  "Ruská federácia",
	  "Rwanda",
	  "Rwandská republika",
	  "Salvádor",
	  "Salvádorská republika",
	  "Samoa",
	  "Nezávislý štát Samoa",
	  "San Maríno",
	  "Sanmarínska republika",
	  "Saudská Arábia",
	  "Kráľovstvo Saudskej Arábie",
	  "Senegal",
	  "Senegalská republika",
	  "Seychely",
	  "Seychelská republika",
	  "Sierra Leone",
	  "Republika Sierra Leone",
	  "Singapur",
	  "Singapurska republika",
	  "Slovensko",
	  "Slovenská republika",
	  "Slovinsko",
	  "Slovinská republika",
	  "Somálsko",
	  "Somálska demokratická republika",
	  "Spojené arabské emiráty",
	  "Spojené arabské emiráty",
	  "Spojené štáty americké",
	  "Spojené štáty americké",
	  "Srbsko a Čierna Hora",
	  "Srbsko a Čierna Hora",
	  "Srí Lanka",
	  "Demokratická socialistická republika Srí Lanka",
	  "Stredoafrická republika",
	  "Stredoafrická republika",
	  "Sudán",
	  "Sudánska republika",
	  "Surinam",
	  "Surinamská republika",
	  "Svazijsko",
	  "Svazijské kráľovstvo",
	  "Svätá Lucia",
	  "Svätá Lucia",
	  "Svätý Krištof a Nevis",
	  "Federácia Svätý Krištof a Nevis",
	  "Sv. Tomáš a Princov Ostrov",
	  "Demokratická republika Svätý Tomáš a Princov Ostrov",
	  "Sv. Vincent a Grenadíny",
	  "Svätý Vincent a Grenadíny",
	  "Sýria",
	  "Sýrska arabská republika",
	  "Šalamúnove ostrovy",
	  "Šalamúnove ostrovy",
	  "Španielsko",
	  "Španielske kráľovstvo",
	  "Švajčiarsko",
	  "Švajčiarska konfederácia",
	  "Švédsko",
	  "Švédske kráľovstvo",
	  "Tadžikistan",
	  "Tadžická republika",
	  "Taliansko",
	  "Talianska republika",
	  "Tanzánia",
	  "Tanzánijská zjednotená republika",
	  "Thajsko",
	  "Thajské kráľovstvo",
	  "Togo",
	  "Tožská republika",
	  "Tonga",
	  "Tonžské kráľovstvo",
	  "Trinidad a Tobago",
	  "Republika Trinidad a Tobago",
	  "Tunisko",
	  "Tuniská republika",
	  "Turecko",
	  "Turecká republika",
	  "Turkménsko",
	  "Turkménsko",
	  "Tuvalu",
	  "Tuvalu",
	  "Uganda",
	  "Ugandská republika",
	  "Ukrajina",
	  "Uruguaj",
	  "Uruguajská východná republika",
	  "Uzbekistan",
	  "Vanuatu",
	  "Vanuatská republika",
	  "Vatikán",
	  "Svätá Stolica",
	  "Veľká Británia",
	  "Spojené kráľovstvo Veľkej Británie a Severného Írska",
	  "Venezuela",
	  "Venezuelská bolívarovská republika",
	  "Vietnam",
	  "Vietnamská socialistická republika",
	  "Východný Timor",
	  "Demokratická republika Východný Timor",
	  "Zambia",
	  "Zambijská republika",
	  "Zimbabwe",
	  "Zimbabwianska republika"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Slovensko"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(1105);
	address.city_suffix = __webpack_require__(1106);
	address.country = __webpack_require__(1107);
	address.building_number = __webpack_require__(1102);
	address.secondary_address = __webpack_require__(1111);
	address.postcode = __webpack_require__(1110);
	address.state = __webpack_require__(1112);
	address.state_abbr = __webpack_require__(1113);
	address.time_zone = __webpack_require__(1117);
	address.city_name = __webpack_require__(1104);
	address.city = __webpack_require__(1103);
	address.street = __webpack_require__(1114);
	address.street_name = __webpack_require__(1116);
	address.street_address = __webpack_require__(1115);
	address.default_country = __webpack_require__(1108);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "### ##",
	  "## ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apt. ###",
	  "Suite ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adámiho",
	  "Ahoj",
	  "Albína Brunovského",
	  "Albrechtova",
	  "Alejová",
	  "Alešova",
	  "Alibernetová",
	  "Alžbetínska",
	  "Alžbety Gwerkovej",
	  "Ambroseho",
	  "Ambrušova",
	  "Americká",
	  "Americké námestie",
	  "Americké námestie",
	  "Andreja Mráza",
	  "Andreja Plávku",
	  "Andrusovova",
	  "Anenská",
	  "Anenská",
	  "Antolská",
	  "Astronomická",
	  "Astrová",
	  "Azalková",
	  "Azovská",
	  "Babuškova",
	  "Bachova",
	  "Bajkalská",
	  "Bajkalská",
	  "Bajkalská",
	  "Bajkalská",
	  "Bajkalská",
	  "Bajkalská",
	  "Bajzova",
	  "Bancíkovej",
	  "Banícka",
	  "Baníkova",
	  "Banskobystrická",
	  "Banšelova",
	  "Bardejovská",
	  "Bartókova",
	  "Bartoňova",
	  "Bartoškova",
	  "Baštová",
	  "Bazová",
	  "Bažantia",
	  "Beblavého",
	  "Beckovská",
	  "Bedľová",
	  "Belániková",
	  "Belehradská",
	  "Belinského",
	  "Belopotockého",
	  "Beňadická",
	  "Bencúrova",
	  "Benediktiho",
	  "Beniakova",
	  "Bernolákova",
	  "Beskydská",
	  "Betliarska",
	  "Bezručova",
	  "Biela",
	  "Bielkova",
	  "Björnsonova",
	  "Blagoevova",
	  "Blatnická",
	  "Blumentálska",
	  "Blyskáčová",
	  "Bočná",
	  "Bohrova",
	  "Bohúňova",
	  "Bojnická",
	  "Borodáčova",
	  "Borská",
	  "Bosákova",
	  "Botanická",
	  "Bottova",
	  "Boženy Němcovej",
	  "Bôrik",
	  "Bradáčova",
	  "Bradlianska",
	  "Brančská",
	  "Bratská",
	  "Brestová",
	  "Brezovská",
	  "Briežky",
	  "Brnianska",
	  "Brodná",
	  "Brodská",
	  "Broskyňová",
	  "Břeclavská",
	  "Budatínska",
	  "Budatínska",
	  "Budatínska",
	  "Búdkova  cesta",
	  "Budovateľská",
	  "Budyšínska",
	  "Budyšínska",
	  "Buková",
	  "Bukureštská",
	  "Bulharská",
	  "Bulíkova",
	  "Bystrého",
	  "Bzovícka",
	  "Cablkova",
	  "Cesta na Červený most",
	  "Cesta na Červený most",
	  "Cesta na Senec",
	  "Cikkerova",
	  "Cintorínska",
	  "Cintulova",
	  "Cukrová",
	  "Cyrilova",
	  "Čajakova",
	  "Čajkovského",
	  "Čaklovská",
	  "Čalovská",
	  "Čapajevova",
	  "Čapkova",
	  "Čárskeho",
	  "Čavojského",
	  "Čečinová",
	  "Čelakovského",
	  "Čerešňová",
	  "Černyševského",
	  "Červeňova",
	  "Česká",
	  "Československých par",
	  "Čipkárska",
	  "Čmelíkova",
	  "Čmeľovec",
	  "Čulenova",
	  "Daliborovo námestie",
	  "Dankovského",
	  "Dargovská",
	  "Ďatelinová",
	  "Daxnerovo námestie",
	  "Devínska cesta",
	  "Dlhé diely I.",
	  "Dlhé diely II.",
	  "Dlhé diely III.",
	  "Dobrovičova",
	  "Dobrovičova",
	  "Dobrovského",
	  "Dobšinského",
	  "Dohnalova",
	  "Dohnányho",
	  "Doležalova",
	  "Dolná",
	  "Dolnozemská cesta",
	  "Domkárska",
	  "Domové role",
	  "Donnerova",
	  "Donovalova",
	  "Dostojevského rad",
	  "Dr. Vladimíra Clemen",
	  "Drevená",
	  "Drieňová",
	  "Drieňová",
	  "Drieňová",
	  "Drotárska cesta",
	  "Drotárska cesta",
	  "Drotárska cesta",
	  "Družicová",
	  "Družstevná",
	  "Dubnická",
	  "Dubová",
	  "Dúbravská cesta",
	  "Dudova",
	  "Dulovo námestie",
	  "Dulovo námestie",
	  "Dunajská",
	  "Dvořákovo nábrežie",
	  "Edisonova",
	  "Einsteinova",
	  "Elektrárenská",
	  "Exnárova",
	  "F. Kostku",
	  "Fadruszova",
	  "Fajnorovo nábrežie",
	  "Fándlyho",
	  "Farebná",
	  "Farská",
	  "Farského",
	  "Fazuľová",
	  "Fedinova",
	  "Ferienčíkova",
	  "Fialkové údolie",
	  "Fibichova",
	  "Filiálne nádražie",
	  "Flöglova",
	  "Floriánske námestie",
	  "Fraňa Kráľa",
	  "Francisciho",
	  "Francúzskych partizá",
	  "Františkánska",
	  "Františkánske námest",
	  "Furdekova",
	  "Furdekova",
	  "Gabčíkova",
	  "Gagarinova",
	  "Gagarinova",
	  "Gagarinova",
	  "Gajova",
	  "Galaktická",
	  "Galandova",
	  "Gallova",
	  "Galvaniho",
	  "Gašparíkova",
	  "Gaštanová",
	  "Gavlovičova",
	  "Gemerská",
	  "Gercenova",
	  "Gessayova",
	  "Gettingová",
	  "Godrova",
	  "Gogoľova",
	  "Goláňova",
	  "Gondova",
	  "Goralská",
	  "Gorazdova",
	  "Gorkého",
	  "Gregorovej",
	  "Grösslingova",
	  "Gruzínska",
	  "Gunduličova",
	  "Gusevova",
	  "Haanova",
	  "Haburská",
	  "Halašova",
	  "Hálkova",
	  "Hálova",
	  "Hamuliakova",
	  "Hanácka",
	  "Handlovská",
	  "Hany Meličkovej",
	  "Harmanecká",
	  "Hasičská",
	  "Hattalova",
	  "Havlíčkova",
	  "Havrania",
	  "Haydnova",
	  "Herlianska",
	  "Herlianska",
	  "Heydukova",
	  "Hlaváčikova",
	  "Hlavatého",
	  "Hlavné námestie",
	  "Hlboká cesta",
	  "Hlboká cesta",
	  "Hlivová",
	  "Hlučínska",
	  "Hodálova",
	  "Hodžovo námestie",
	  "Holekova",
	  "Holíčska",
	  "Hollého",
	  "Holubyho",
	  "Hontianska",
	  "Horárska",
	  "Horné Židiny",
	  "Horská",
	  "Horská",
	  "Hrad",
	  "Hradné údolie",
	  "Hrachová",
	  "Hraničná",
	  "Hrebendova",
	  "Hríbová",
	  "Hriňovská",
	  "Hrobákova",
	  "Hrobárska",
	  "Hroboňova",
	  "Hudecova",
	  "Humenské námestie",
	  "Hummelova",
	  "Hurbanovo námestie",
	  "Hurbanovo námestie",
	  "Hviezdoslavovo námes",
	  "Hýrošova",
	  "Chalupkova",
	  "Chemická",
	  "Chlumeckého",
	  "Chorvátska",
	  "Chorvátska",
	  "Iľjušinova",
	  "Ilkovičova",
	  "Inovecká",
	  "Inovecká",
	  "Iskerníková",
	  "Ivana Horvátha",
	  "Ivánska cesta",
	  "J.C.Hronského",
	  "Jabloňová",
	  "Jadrová",
	  "Jakabova",
	  "Jakubovo námestie",
	  "Jamnického",
	  "Jána Stanislava",
	  "Janáčkova",
	  "Jančova",
	  "Janíkove role",
	  "Jankolova",
	  "Jánošíkova",
	  "Jánoškova",
	  "Janotova",
	  "Jánska",
	  "Jantárová cesta",
	  "Jarabinková",
	  "Jarná",
	  "Jaroslavova",
	  "Jarošova",
	  "Jaseňová",
	  "Jasná",
	  "Jasovská",
	  "Jastrabia",
	  "Jašíkova",
	  "Javorinská",
	  "Javorová",
	  "Jazdecká",
	  "Jedlíkova",
	  "Jégého",
	  "Jelačičova",
	  "Jelenia",
	  "Jesenná",
	  "Jesenského",
	  "Jiráskova",
	  "Jiskrova",
	  "Jozefská",
	  "Junácka",
	  "Jungmannova",
	  "Jurigovo námestie",
	  "Jurovského",
	  "Jurská",
	  "Justičná",
	  "K lomu",
	  "K Železnej studienke",
	  "Kalinčiakova",
	  "Kamenárska",
	  "Kamenné námestie",
	  "Kapicova",
	  "Kapitulská",
	  "Kapitulský dvor",
	  "Kapucínska",
	  "Kapušianska",
	  "Karadžičova",
	  "Karadžičova",
	  "Karadžičova",
	  "Karadžičova",
	  "Karloveská",
	  "Karloveské rameno",
	  "Karpatská",
	  "Kašmírska",
	  "Kaštielska",
	  "Kaukazská",
	  "Kempelenova",
	  "Kežmarské námestie",
	  "Kladnianska",
	  "Klariská",
	  "Kláštorská",
	  "Klatovská",
	  "Klatovská",
	  "Klemensova",
	  "Klincová",
	  "Klobučnícka",
	  "Klokočova",
	  "Kľukatá",
	  "Kmeťovo námestie",
	  "Koceľova",
	  "Kočánkova",
	  "Kohútova",
	  "Kolárska",
	  "Kolískova",
	  "Kollárovo námestie",
	  "Kollárovo námestie",
	  "Kolmá",
	  "Komárňanská",
	  "Komárnická",
	  "Komárnická",
	  "Komenského námestie",
	  "Kominárska",
	  "Komonicová",
	  "Konopná",
	  "Konvalinková",
	  "Konventná",
	  "Kopanice",
	  "Kopčianska",
	  "Koperníkova",
	  "Korabinského",
	  "Koreničova",
	  "Kostlivého",
	  "Kostolná",
	  "Košická",
	  "Košická",
	  "Košická",
	  "Kováčska",
	  "Kovorobotnícka",
	  "Kozia",
	  "Koziarka",
	  "Kozmonautická",
	  "Krajná",
	  "Krakovská",
	  "Kráľovské údolie",
	  "Krasinského",
	  "Kraskova",
	  "Krásna",
	  "Krásnohorská",
	  "Krasovského",
	  "Krátka",
	  "Krčméryho",
	  "Kremnická",
	  "Kresánkova",
	  "Krivá",
	  "Križkova",
	  "Krížna",
	  "Krížna",
	  "Krížna",
	  "Krížna",
	  "Krmanova",
	  "Krompašská",
	  "Krupinská",
	  "Krupkova",
	  "Kubániho",
	  "Kubínska",
	  "Kuklovská",
	  "Kukučínova",
	  "Kukuričná",
	  "Kulíškova",
	  "Kultúrna",
	  "Kupeckého",
	  "Kúpeľná",
	  "Kutlíkova",
	  "Kutuzovova",
	  "Kuzmányho",
	  "Kvačalova",
	  "Kvetná",
	  "Kýčerského",
	  "Kyjevská",
	  "Kysucká",
	  "Laborecká",
	  "Lackova",
	  "Ladislava Sáru",
	  "Ľadová",
	  "Lachova",
	  "Ľaliová",
	  "Lamačská cesta",
	  "Lamačská cesta",
	  "Lamanského",
	  "Landererova",
	  "Langsfeldova",
	  "Ľanová",
	  "Laskomerského",
	  "Laučekova",
	  "Laurinská",
	  "Lazaretská",
	  "Lazaretská",
	  "Legerského",
	  "Legionárska",
	  "Legionárska",
	  "Lehockého",
	  "Lehockého",
	  "Lenardova",
	  "Lermontovova",
	  "Lesná",
	  "Leškova",
	  "Letecká",
	  "Letisko M.R.Štefánik",
	  "Letná",
	  "Levárska",
	  "Levická",
	  "Levočská",
	  "Lidická",
	  "Lietavská",
	  "Lichardova",
	  "Lipová",
	  "Lipovinová",
	  "Liptovská",
	  "Listová",
	  "Líščie nivy",
	  "Líščie údolie",
	  "Litovská",
	  "Lodná",
	  "Lombardiniho",
	  "Lomonosovova",
	  "Lopenícka",
	  "Lovinského",
	  "Ľubietovská",
	  "Ľubinská",
	  "Ľubľanská",
	  "Ľubochnianska",
	  "Ľubovnianska",
	  "Lúčna",
	  "Ľudové námestie",
	  "Ľudovíta Fullu",
	  "Luhačovická",
	  "Lužická",
	  "Lužná",
	  "Lýcejná",
	  "Lykovcová",
	  "M. Hella",
	  "Magnetová",
	  "Macharova",
	  "Majakovského",
	  "Majerníkova",
	  "Májkova",
	  "Májová",
	  "Makovického",
	  "Malá",
	  "Malé pálenisko",
	  "Malinová",
	  "Malý Draždiak",
	  "Malý trh",
	  "Mamateyova",
	  "Mamateyova",
	  "Mánesovo námestie",
	  "Mariánska",
	  "Marie Curie-Sklodows",
	  "Márie Medveďovej",
	  "Markova",
	  "Marótyho",
	  "Martákovej",
	  "Martinčekova",
	  "Martinčekova",
	  "Martinengova",
	  "Martinská",
	  "Mateja Bela",
	  "Matejkova",
	  "Matičná",
	  "Matúšova",
	  "Medená",
	  "Medzierka",
	  "Medzilaborecká",
	  "Merlotová",
	  "Mesačná",
	  "Mestská",
	  "Meteorová",
	  "Metodova",
	  "Mickiewiczova",
	  "Mierová",
	  "Michalská",
	  "Mikovíniho",
	  "Mikulášska",
	  "Miletičova",
	  "Miletičova",
	  "Mišíkova",
	  "Mišíkova",
	  "Mišíkova",
	  "Mliekárenská",
	  "Mlynarovičova",
	  "Mlynská dolina",
	  "Mlynská dolina",
	  "Mlynská dolina",
	  "Mlynské luhy",
	  "Mlynské nivy",
	  "Mlynské nivy",
	  "Mlynské nivy",
	  "Mlynské nivy",
	  "Mlynské nivy",
	  "Mlyny",
	  "Modranská",
	  "Mojmírova",
	  "Mokráň záhon",
	  "Mokrohájska cesta",
	  "Moldavská",
	  "Molecova",
	  "Moravská",
	  "Moskovská",
	  "Most SNP",
	  "Mostová",
	  "Mošovského",
	  "Motýlia",
	  "Moyzesova",
	  "Mozartova",
	  "Mraziarenská",
	  "Mudroňova",
	  "Mudroňova",
	  "Mudroňova",
	  "Muchovo námestie",
	  "Murgašova",
	  "Muškátová",
	  "Muštová",
	  "Múzejná",
	  "Myjavská",
	  "Mýtna",
	  "Mýtna",
	  "Na Baránku",
	  "Na Brezinách",
	  "Na Hrebienku",
	  "Na Kalvárii",
	  "Na Kampárke",
	  "Na kopci",
	  "Na križovatkách",
	  "Na lánoch",
	  "Na paši",
	  "Na piesku",
	  "Na Riviére",
	  "Na Sitine",
	  "Na Slavíne",
	  "Na stráni",
	  "Na Štyridsiatku",
	  "Na úvrati",
	  "Na vŕšku",
	  "Na výslní",
	  "Nábělkova",
	  "Nábrežie arm. gen. L",
	  "Nábrežná",
	  "Nad Dunajom",
	  "Nad lomom",
	  "Nad lúčkami",
	  "Nad lúčkami",
	  "Nad ostrovom",
	  "Nad Sihoťou",
	  "Námestie 1. mája",
	  "Námestie Alexandra D",
	  "Námestie Biely kríž",
	  "Námestie Hraničiarov",
	  "Námestie Jána Pavla",
	  "Námestie Ľudovíta Št",
	  "Námestie Martina Ben",
	  "Nám. M.R.Štefánika",
	  "Námestie slobody",
	  "Námestie slobody",
	  "Námestie SNP",
	  "Námestie SNP",
	  "Námestie sv. Františ",
	  "Narcisová",
	  "Nedbalova",
	  "Nekrasovova",
	  "Neronetová",
	  "Nerudova",
	  "Nevädzová",
	  "Nezábudková",
	  "Niťová",
	  "Nitrianska",
	  "Nížinná",
	  "Nobelova",
	  "Nobelovo námestie",
	  "Nová",
	  "Nová Rožňavská",
	  "Novackého",
	  "Nové pálenisko",
	  "Nové záhrady I",
	  "Nové záhrady II",
	  "Nové záhrady III",
	  "Nové záhrady IV",
	  "Nové záhrady V",
	  "Nové záhrady VI",
	  "Nové záhrady VII",
	  "Novinárska",
	  "Novobanská",
	  "Novohradská",
	  "Novosvetská",
	  "Novosvetská",
	  "Novosvetská",
	  "Obežná",
	  "Obchodná",
	  "Očovská",
	  "Odbojárov",
	  "Odborárska",
	  "Odborárske námestie",
	  "Odborárske námestie",
	  "Ohnicová",
	  "Okánikova",
	  "Okružná",
	  "Olbrachtova",
	  "Olejkárska",
	  "Ondavská",
	  "Ondrejovova",
	  "Oravská",
	  "Orechová cesta",
	  "Orechový rad",
	  "Oriešková",
	  "Ormisova",
	  "Osadná",
	  "Ostravská",
	  "Ostredková",
	  "Osuského",
	  "Osvetová",
	  "Otonelská",
	  "Ovručská",
	  "Ovsištské námestie",
	  "Pajštúnska",
	  "Palackého",
	  "Palárikova",
	  "Palárikova",
	  "Pálavská",
	  "Palisády",
	  "Palisády",
	  "Palisády",
	  "Palkovičova",
	  "Panenská",
	  "Pankúchova",
	  "Panónska cesta",
	  "Panská",
	  "Papánkovo námestie",
	  "Papraďová",
	  "Páričkova",
	  "Parková",
	  "Partizánska",
	  "Pasienky",
	  "Paulínyho",
	  "Pavlovičova",
	  "Pavlovova",
	  "Pavlovská",
	  "Pažického",
	  "Pažítková",
	  "Pečnianska",
	  "Pernecká",
	  "Pestovateľská",
	  "Peterská",
	  "Petzvalova",
	  "Pezinská",
	  "Piesočná",
	  "Piešťanská",
	  "Pifflova",
	  "Pilárikova",
	  "Pionierska",
	  "Pivoňková",
	  "Planckova",
	  "Planét",
	  "Plátenícka",
	  "Pluhová",
	  "Plynárenská",
	  "Plzenská",
	  "Pobrežná",
	  "Pod Bôrikom",
	  "Pod Kalváriou",
	  "Pod lesom",
	  "Pod Rovnicami",
	  "Pod vinicami",
	  "Podhorského",
	  "Podjavorinskej",
	  "Podlučinského",
	  "Podniková",
	  "Podtatranského",
	  "Pohronská",
	  "Polárna",
	  "Poloreckého",
	  "Poľná",
	  "Poľská",
	  "Poludníková",
	  "Porubského",
	  "Poštová",
	  "Považská",
	  "Povraznícka",
	  "Povraznícka",
	  "Pražská",
	  "Predstaničné námesti",
	  "Prepoštská",
	  "Prešernova",
	  "Prešovská",
	  "Prešovská",
	  "Prešovská",
	  "Pri Bielom kríži",
	  "Pri dvore",
	  "Pri Dynamitke",
	  "Pri Habánskom mlyne",
	  "Pri hradnej studni",
	  "Pri seči",
	  "Pri Starej Prachárni",
	  "Pri Starom háji",
	  "Pri Starom Mýte",
	  "Pri strelnici",
	  "Pri Suchom mlyne",
	  "Pri zvonici",
	  "Pribinova",
	  "Pribinova",
	  "Pribinova",
	  "Pribišova",
	  "Pribylinská",
	  "Priečna",
	  "Priekopy",
	  "Priemyselná",
	  "Priemyselná",
	  "Prievozská",
	  "Prievozská",
	  "Prievozská",
	  "Príkopova",
	  "Primaciálne námestie",
	  "Prístav",
	  "Prístavná",
	  "Prokofievova",
	  "Prokopa Veľkého",
	  "Prokopova",
	  "Prúdová",
	  "Prvosienková",
	  "Púpavová",
	  "Pustá",
	  "Puškinova",
	  "Račianska",
	  "Račianska",
	  "Račianske mýto",
	  "Radarová",
	  "Rádiová",
	  "Radlinského",
	  "Radničná",
	  "Radničné námestie",
	  "Radvanská",
	  "Rajská",
	  "Raketová",
	  "Rákosová",
	  "Rastislavova",
	  "Rázusovo nábrežie",
	  "Repná",
	  "Rešetkova",
	  "Revolučná",
	  "Révová",
	  "Revúcka",
	  "Rezedová",
	  "Riazanská",
	  "Riazanská",
	  "Ribayová",
	  "Riečna",
	  "Rigeleho",
	  "Rízlingová",
	  "Riznerova",
	  "Robotnícka",
	  "Romanova",
	  "Röntgenova",
	  "Rosná",
	  "Rovná",
	  "Rovniankova",
	  "Rovníková",
	  "Rozmarínová",
	  "Rožňavská",
	  "Rožňavská",
	  "Rožňavská",
	  "Rubinsteinova",
	  "Rudnayovo námestie",
	  "Rumančeková",
	  "Rusovská cesta",
	  "Ružičková",
	  "Ružinovská",
	  "Ružinovská",
	  "Ružinovská",
	  "Ružomberská",
	  "Ružová dolina",
	  "Ružová dolina",
	  "Rybárska brána",
	  "Rybné námestie",
	  "Rýdziková",
	  "Sabinovská",
	  "Sabinovská",
	  "Sad Janka Kráľa",
	  "Sadová",
	  "Sartorisova",
	  "Sasinkova",
	  "Seberíniho",
	  "Sečovská",
	  "Sedlárska",
	  "Sedmokrásková",
	  "Segnerova",
	  "Sekulská",
	  "Semianova",
	  "Senická",
	  "Senná",
	  "Schillerova",
	  "Schody pri starej vo",
	  "Sibírska",
	  "Sienkiewiczova",
	  "Silvánska",
	  "Sinokvetná",
	  "Skalická cesta",
	  "Skalná",
	  "Sklenárova",
	  "Sklenárska",
	  "Sládkovičova",
	  "Sladová",
	  "Slávičie údolie",
	  "Slavín",
	  "Slepá",
	  "Sliačska",
	  "Sliezska",
	  "Slivková",
	  "Slnečná",
	  "Slovanská",
	  "Slovinská",
	  "Slovnaftská",
	  "Slowackého",
	  "Smetanova",
	  "Smikova",
	  "Smolenická",
	  "Smolnícka",
	  "Smrečianska",
	  "Soferove schody",
	  "Socháňova",
	  "Sokolská",
	  "Solivarská",
	  "Sološnická",
	  "Somolického",
	  "Somolického",
	  "Sosnová",
	  "Spišská",
	  "Spojná",
	  "Spoločenská",
	  "Sputniková",
	  "Sreznevského",
	  "Srnčia",
	  "Stachanovská",
	  "Stálicová",
	  "Staničná",
	  "Stará Černicová",
	  "Stará Ivánska cesta",
	  "Stará Prievozská",
	  "Stará Vajnorská",
	  "Stará vinárska",
	  "Staré Grunty",
	  "Staré ihrisko",
	  "Staré záhrady",
	  "Starhradská",
	  "Starohájska",
	  "Staromestská",
	  "Staroturský chodník",
	  "Staviteľská",
	  "Stodolova",
	  "Stoklasová",
	  "Strakova",
	  "Strážnická",
	  "Strážny dom",
	  "Strečnianska",
	  "Stredná",
	  "Strelecká",
	  "Strmá cesta",
	  "Strojnícka",
	  "Stropkovská",
	  "Struková",
	  "Studená",
	  "Stuhová",
	  "Súbežná",
	  "Súhvezdná",
	  "Suché mýto",
	  "Suchohradská",
	  "Súkennícka",
	  "Súľovská",
	  "Sumbalova",
	  "Súmračná",
	  "Súťažná",
	  "Svätého Vincenta",
	  "Svätoplukova",
	  "Svätoplukova",
	  "Svätovojtešská",
	  "Svetlá",
	  "Svíbová",
	  "Svidnícka",
	  "Svoradova",
	  "Svrčia",
	  "Syslia",
	  "Šafárikovo námestie",
	  "Šafárikovo námestie",
	  "Šafránová",
	  "Šagátova",
	  "Šalviová",
	  "Šancová",
	  "Šancová",
	  "Šancová",
	  "Šancová",
	  "Šándorova",
	  "Šarišská",
	  "Šášovská",
	  "Šaštínska",
	  "Ševčenkova",
	  "Šintavská",
	  "Šípková",
	  "Škarniclova",
	  "Školská",
	  "Škovránčia",
	  "Škultétyho",
	  "Šoltésovej",
	  "Špieszova",
	  "Špitálska",
	  "Športová",
	  "Šrobárovo námestie",
	  "Šťastná",
	  "Štedrá",
	  "Štefánikova",
	  "Štefánikova",
	  "Štefánikova",
	  "Štefanovičova",
	  "Štefunkova",
	  "Štetinova",
	  "Štiavnická",
	  "Štúrova",
	  "Štyndlova",
	  "Šulekova",
	  "Šulekova",
	  "Šulekova",
	  "Šumavská",
	  "Šuňavcova",
	  "Šustekova",
	  "Švabinského",
	  "Tabaková",
	  "Tablicova",
	  "Táborská",
	  "Tajovského",
	  "Tallerova",
	  "Tehelná",
	  "Technická",
	  "Tekovská",
	  "Telocvičná",
	  "Tematínska",
	  "Teplická",
	  "Terchovská",
	  "Teslova",
	  "Tetmayerova",
	  "Thurzova",
	  "Tichá",
	  "Tilgnerova",
	  "Timravina",
	  "Tobrucká",
	  "Tokajícka",
	  "Tolstého",
	  "Tománkova",
	  "Tomášikova",
	  "Tomášikova",
	  "Tomášikova",
	  "Tomášikova",
	  "Tomášikova",
	  "Topoľčianska",
	  "Topoľová",
	  "Továrenská",
	  "Trebišovská",
	  "Trebišovská",
	  "Trebišovská",
	  "Trenčianska",
	  "Treskoňova",
	  "Trnavská cesta",
	  "Trnavská cesta",
	  "Trnavská cesta",
	  "Trnavská cesta",
	  "Trnavská cesta",
	  "Trnavské mýto",
	  "Tŕňová",
	  "Trojdomy",
	  "Tučkova",
	  "Tupolevova",
	  "Turbínova",
	  "Turčianska",
	  "Turnianska",
	  "Tvarožkova",
	  "Tylova",
	  "Tyršovo nábrežie",
	  "Údernícka",
	  "Údolná",
	  "Uhorková",
	  "Ukrajinská",
	  "Ulica 29. augusta",
	  "Ulica 29. augusta",
	  "Ulica 29. augusta",
	  "Ulica 29. augusta",
	  "Ulica Imricha Karvaš",
	  "Ulica Jozefa Krónera",
	  "Ulica Viktora Tegelh",
	  "Úprkova",
	  "Úradnícka",
	  "Uránová",
	  "Urbánkova",
	  "Ursínyho",
	  "Uršulínska",
	  "Úzka",
	  "V záhradách",
	  "Vajanského nábrežie",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Valašská",
	  "Valchárska",
	  "Vansovej",
	  "Vápenná",
	  "Varínska",
	  "Varšavská",
	  "Varšavská",
	  "Vavilovova",
	  "Vavrínova",
	  "Vazovova",
	  "Včelárska",
	  "Velehradská",
	  "Veltlínska",
	  "Ventúrska",
	  "Veterná",
	  "Veternicová",
	  "Vetvová",
	  "Viedenská cesta",
	  "Viedenská cesta",
	  "Vietnamská",
	  "Vígľašská",
	  "Vihorlatská",
	  "Viktorínova",
	  "Vilová",
	  "Vincenta Hložníka",
	  "Vínna",
	  "Vlastenecké námestie",
	  "Vlčkova",
	  "Vlčkova",
	  "Vlčkova",
	  "Vodný vrch",
	  "Votrubova",
	  "Vrábeľská",
	  "Vrakunská cesta",
	  "Vranovská",
	  "Vretenová",
	  "Vrchná",
	  "Vrútocká",
	  "Vyhliadka",
	  "Vyhnianska cesta",
	  "Vysoká",
	  "Vyšehradská",
	  "Vyšná",
	  "Wattova",
	  "Wilsonova",
	  "Wolkrova",
	  "Za Kasárňou",
	  "Za sokolovňou",
	  "Za Stanicou",
	  "Za tehelňou",
	  "Záborského",
	  "Zadunajská cesta",
	  "Záhorácka",
	  "Záhradnícka",
	  "Záhradnícka",
	  "Záhradnícka",
	  "Záhradnícka",
	  "Záhrebská",
	  "Záhrebská",
	  "Zálužická",
	  "Zámocká",
	  "Zámocké schody",
	  "Zámočnícka",
	  "Západná",
	  "Západný rad",
	  "Záporožská",
	  "Zátišie",
	  "Závodníkova",
	  "Zelená",
	  "Zelinárska",
	  "Zimná",
	  "Zlaté piesky",
	  "Zlaté schody",
	  "Znievska",
	  "Zohorská",
	  "Zochova",
	  "Zrinského",
	  "Zvolenská",
	  "Žabí majer",
	  "Žabotova",
	  "Žehrianska",
	  "Železná",
	  "Železničiarska",
	  "Žellova",
	  "Žiarska",
	  "Židovská",
	  "Žilinská",
	  "Žilinská",
	  "Živnostenská",
	  "Žižkova",
	  "Župné námestie"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pacific/Midway",
	  "Pacific/Pago_Pago",
	  "Pacific/Honolulu",
	  "America/Juneau",
	  "America/Los_Angeles",
	  "America/Tijuana",
	  "America/Denver",
	  "America/Phoenix",
	  "America/Chihuahua",
	  "America/Mazatlan",
	  "America/Chicago",
	  "America/Regina",
	  "America/Mexico_City",
	  "America/Mexico_City",
	  "America/Monterrey",
	  "America/Guatemala",
	  "America/New_York",
	  "America/Indiana/Indianapolis",
	  "America/Bogota",
	  "America/Lima",
	  "America/Lima",
	  "America/Halifax",
	  "America/Caracas",
	  "America/La_Paz",
	  "America/Santiago",
	  "America/St_Johns",
	  "America/Sao_Paulo",
	  "America/Argentina/Buenos_Aires",
	  "America/Guyana",
	  "America/Godthab",
	  "Atlantic/South_Georgia",
	  "Atlantic/Azores",
	  "Atlantic/Cape_Verde",
	  "Europe/Dublin",
	  "Europe/London",
	  "Europe/Lisbon",
	  "Europe/London",
	  "Africa/Casablanca",
	  "Africa/Monrovia",
	  "Etc/UTC",
	  "Europe/Belgrade",
	  "Europe/Bratislava",
	  "Europe/Budapest",
	  "Europe/Ljubljana",
	  "Europe/Prague",
	  "Europe/Sarajevo",
	  "Europe/Skopje",
	  "Europe/Warsaw",
	  "Europe/Zagreb",
	  "Europe/Brussels",
	  "Europe/Copenhagen",
	  "Europe/Madrid",
	  "Europe/Paris",
	  "Europe/Amsterdam",
	  "Europe/Berlin",
	  "Europe/Berlin",
	  "Europe/Rome",
	  "Europe/Stockholm",
	  "Europe/Vienna",
	  "Africa/Algiers",
	  "Europe/Bucharest",
	  "Africa/Cairo",
	  "Europe/Helsinki",
	  "Europe/Kiev",
	  "Europe/Riga",
	  "Europe/Sofia",
	  "Europe/Tallinn",
	  "Europe/Vilnius",
	  "Europe/Athens",
	  "Europe/Istanbul",
	  "Europe/Minsk",
	  "Asia/Jerusalem",
	  "Africa/Harare",
	  "Africa/Johannesburg",
	  "Europe/Moscow",
	  "Europe/Moscow",
	  "Europe/Moscow",
	  "Asia/Kuwait",
	  "Asia/Riyadh",
	  "Africa/Nairobi",
	  "Asia/Baghdad",
	  "Asia/Tehran",
	  "Asia/Muscat",
	  "Asia/Muscat",
	  "Asia/Baku",
	  "Asia/Tbilisi",
	  "Asia/Yerevan",
	  "Asia/Kabul",
	  "Asia/Yekaterinburg",
	  "Asia/Karachi",
	  "Asia/Karachi",
	  "Asia/Tashkent",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kathmandu",
	  "Asia/Dhaka",
	  "Asia/Dhaka",
	  "Asia/Colombo",
	  "Asia/Almaty",
	  "Asia/Novosibirsk",
	  "Asia/Rangoon",
	  "Asia/Bangkok",
	  "Asia/Bangkok",
	  "Asia/Jakarta",
	  "Asia/Krasnoyarsk",
	  "Asia/Shanghai",
	  "Asia/Chongqing",
	  "Asia/Hong_Kong",
	  "Asia/Urumqi",
	  "Asia/Kuala_Lumpur",
	  "Asia/Singapore",
	  "Asia/Taipei",
	  "Australia/Perth",
	  "Asia/Irkutsk",
	  "Asia/Ulaanbaatar",
	  "Asia/Seoul",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Yakutsk",
	  "Australia/Darwin",
	  "Australia/Adelaide",
	  "Australia/Melbourne",
	  "Australia/Melbourne",
	  "Australia/Sydney",
	  "Australia/Brisbane",
	  "Australia/Hobart",
	  "Asia/Vladivostok",
	  "Pacific/Guam",
	  "Pacific/Port_Moresby",
	  "Asia/Magadan",
	  "Asia/Magadan",
	  "Pacific/Noumea",
	  "Pacific/Fiji",
	  "Asia/Kamchatka",
	  "Pacific/Majuro",
	  "Pacific/Auckland",
	  "Pacific/Auckland",
	  "Pacific/Tongatapu",
	  "Pacific/Fakaofo",
	  "Pacific/Apia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adaptive",
	  "Advanced",
	  "Ameliorated",
	  "Assimilated",
	  "Automated",
	  "Balanced",
	  "Business-focused",
	  "Centralized",
	  "Cloned",
	  "Compatible",
	  "Configurable",
	  "Cross-group",
	  "Cross-platform",
	  "Customer-focused",
	  "Customizable",
	  "Decentralized",
	  "De-engineered",
	  "Devolved",
	  "Digitized",
	  "Distributed",
	  "Diverse",
	  "Down-sized",
	  "Enhanced",
	  "Enterprise-wide",
	  "Ergonomic",
	  "Exclusive",
	  "Expanded",
	  "Extended",
	  "Face to face",
	  "Focused",
	  "Front-line",
	  "Fully-configurable",
	  "Function-based",
	  "Fundamental",
	  "Future-proofed",
	  "Grass-roots",
	  "Horizontal",
	  "Implemented",
	  "Innovative",
	  "Integrated",
	  "Intuitive",
	  "Inverse",
	  "Managed",
	  "Mandatory",
	  "Monitored",
	  "Multi-channelled",
	  "Multi-lateral",
	  "Multi-layered",
	  "Multi-tiered",
	  "Networked",
	  "Object-based",
	  "Open-architected",
	  "Open-source",
	  "Operative",
	  "Optimized",
	  "Optional",
	  "Organic",
	  "Organized",
	  "Persevering",
	  "Persistent",
	  "Phased",
	  "Polarised",
	  "Pre-emptive",
	  "Proactive",
	  "Profit-focused",
	  "Profound",
	  "Programmable",
	  "Progressive",
	  "Public-key",
	  "Quality-focused",
	  "Reactive",
	  "Realigned",
	  "Re-contextualized",
	  "Re-engineered",
	  "Reduced",
	  "Reverse-engineered",
	  "Right-sized",
	  "Robust",
	  "Seamless",
	  "Secured",
	  "Self-enabling",
	  "Sharable",
	  "Stand-alone",
	  "Streamlined",
	  "Switchable",
	  "Synchronised",
	  "Synergistic",
	  "Synergized",
	  "Team-oriented",
	  "Total",
	  "Triple-buffered",
	  "Universal",
	  "Up-sized",
	  "Upgradable",
	  "User-centric",
	  "User-friendly",
	  "Versatile",
	  "Virtual",
	  "Visionary",
	  "Vision-oriented"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "clicks-and-mortar",
	  "value-added",
	  "vertical",
	  "proactive",
	  "robust",
	  "revolutionary",
	  "scalable",
	  "leading-edge",
	  "innovative",
	  "intuitive",
	  "strategic",
	  "e-business",
	  "mission-critical",
	  "sticky",
	  "one-to-one",
	  "24/7",
	  "end-to-end",
	  "global",
	  "B2B",
	  "B2C",
	  "granular",
	  "frictionless",
	  "virtual",
	  "viral",
	  "dynamic",
	  "24/365",
	  "best-of-breed",
	  "killer",
	  "magnetic",
	  "bleeding-edge",
	  "web-enabled",
	  "interactive",
	  "dot-com",
	  "sexy",
	  "back-end",
	  "real-time",
	  "efficient",
	  "front-end",
	  "distributed",
	  "seamless",
	  "extensible",
	  "turn-key",
	  "world-class",
	  "open-source",
	  "cross-platform",
	  "cross-media",
	  "synergistic",
	  "bricks-and-clicks",
	  "out-of-the-box",
	  "enterprise",
	  "integrated",
	  "impactful",
	  "wireless",
	  "transparent",
	  "next-generation",
	  "cutting-edge",
	  "user-centric",
	  "visionary",
	  "customized",
	  "ubiquitous",
	  "plug-and-play",
	  "collaborative",
	  "compelling",
	  "holistic",
	  "rich",
	  "synergies",
	  "web-readiness",
	  "paradigms",
	  "markets",
	  "partnerships",
	  "infrastructures",
	  "platforms",
	  "initiatives",
	  "channels",
	  "eyeballs",
	  "communities",
	  "ROI",
	  "solutions",
	  "e-tailers",
	  "e-services",
	  "action-items",
	  "portals",
	  "niches",
	  "technologies",
	  "content",
	  "vortals",
	  "supply-chains",
	  "convergence",
	  "relationships",
	  "architectures",
	  "interfaces",
	  "e-markets",
	  "e-commerce",
	  "systems",
	  "bandwidth",
	  "infomediaries",
	  "models",
	  "mindshare",
	  "deliverables",
	  "users",
	  "schemas",
	  "networks",
	  "applications",
	  "metrics",
	  "e-business",
	  "functionalities",
	  "experiences",
	  "web services",
	  "methodologies"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "implement",
	  "utilize",
	  "integrate",
	  "streamline",
	  "optimize",
	  "evolve",
	  "transform",
	  "embrace",
	  "enable",
	  "orchestrate",
	  "leverage",
	  "reinvent",
	  "aggregate",
	  "architect",
	  "enhance",
	  "incentivize",
	  "morph",
	  "empower",
	  "envisioneer",
	  "monetize",
	  "harness",
	  "facilitate",
	  "seize",
	  "disintermediate",
	  "synergize",
	  "strategize",
	  "deploy",
	  "brand",
	  "grow",
	  "target",
	  "syndicate",
	  "synthesize",
	  "deliver",
	  "mesh",
	  "incubate",
	  "engage",
	  "maximize",
	  "benchmark",
	  "expedite",
	  "reintermediate",
	  "whiteboard",
	  "visualize",
	  "repurpose",
	  "innovate",
	  "scale",
	  "unleash",
	  "drive",
	  "extend",
	  "engineer",
	  "revolutionize",
	  "generate",
	  "exploit",
	  "transition",
	  "e-enable",
	  "iterate",
	  "cultivate",
	  "matrix",
	  "productize",
	  "redefine",
	  "recontextualize"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 hour",
	  "24/7",
	  "3rd generation",
	  "4th generation",
	  "5th generation",
	  "6th generation",
	  "actuating",
	  "analyzing",
	  "asymmetric",
	  "asynchronous",
	  "attitude-oriented",
	  "background",
	  "bandwidth-monitored",
	  "bi-directional",
	  "bifurcated",
	  "bottom-line",
	  "clear-thinking",
	  "client-driven",
	  "client-server",
	  "coherent",
	  "cohesive",
	  "composite",
	  "context-sensitive",
	  "contextually-based",
	  "content-based",
	  "dedicated",
	  "demand-driven",
	  "didactic",
	  "directional",
	  "discrete",
	  "disintermediate",
	  "dynamic",
	  "eco-centric",
	  "empowering",
	  "encompassing",
	  "even-keeled",
	  "executive",
	  "explicit",
	  "exuding",
	  "fault-tolerant",
	  "foreground",
	  "fresh-thinking",
	  "full-range",
	  "global",
	  "grid-enabled",
	  "heuristic",
	  "high-level",
	  "holistic",
	  "homogeneous",
	  "human-resource",
	  "hybrid",
	  "impactful",
	  "incremental",
	  "intangible",
	  "interactive",
	  "intermediate",
	  "leading edge",
	  "local",
	  "logistical",
	  "maximized",
	  "methodical",
	  "mission-critical",
	  "mobile",
	  "modular",
	  "motivating",
	  "multimedia",
	  "multi-state",
	  "multi-tasking",
	  "national",
	  "needs-based",
	  "neutral",
	  "next generation",
	  "non-volatile",
	  "object-oriented",
	  "optimal",
	  "optimizing",
	  "radical",
	  "real-time",
	  "reciprocal",
	  "regional",
	  "responsive",
	  "scalable",
	  "secondary",
	  "solution-oriented",
	  "stable",
	  "static",
	  "systematic",
	  "systemic",
	  "system-worthy",
	  "tangible",
	  "tertiary",
	  "transitional",
	  "uniform",
	  "upward-trending",
	  "user-facing",
	  "value-added",
	  "web-enabled",
	  "well-modulated",
	  "zero administration",
	  "zero defect",
	  "zero tolerance"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(1125);
	company.adjective = __webpack_require__(1118);
	company.descriptor = __webpack_require__(1121);
	company.noun = __webpack_require__(1124);
	company.bs_verb = __webpack_require__(1120);
	company.bs_noun = __webpack_require__(1119);
	company.name = __webpack_require__(1123);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name} #{suffix}",
	  "#{Name.man_last_name} a #{Name.man_last_name} #{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ability",
	  "access",
	  "adapter",
	  "algorithm",
	  "alliance",
	  "analyzer",
	  "application",
	  "approach",
	  "architecture",
	  "archive",
	  "artificial intelligence",
	  "array",
	  "attitude",
	  "benchmark",
	  "budgetary management",
	  "capability",
	  "capacity",
	  "challenge",
	  "circuit",
	  "collaboration",
	  "complexity",
	  "concept",
	  "conglomeration",
	  "contingency",
	  "core",
	  "customer loyalty",
	  "database",
	  "data-warehouse",
	  "definition",
	  "emulation",
	  "encoding",
	  "encryption",
	  "extranet",
	  "firmware",
	  "flexibility",
	  "focus group",
	  "forecast",
	  "frame",
	  "framework",
	  "function",
	  "functionalities",
	  "Graphic Interface",
	  "groupware",
	  "Graphical User Interface",
	  "hardware",
	  "help-desk",
	  "hierarchy",
	  "hub",
	  "implementation",
	  "info-mediaries",
	  "infrastructure",
	  "initiative",
	  "installation",
	  "instruction set",
	  "interface",
	  "internet solution",
	  "intranet",
	  "knowledge user",
	  "knowledge base",
	  "local area network",
	  "leverage",
	  "matrices",
	  "matrix",
	  "methodology",
	  "middleware",
	  "migration",
	  "model",
	  "moderator",
	  "monitoring",
	  "moratorium",
	  "neural-net",
	  "open architecture",
	  "open system",
	  "orchestration",
	  "paradigm",
	  "parallelism",
	  "policy",
	  "portal",
	  "pricing structure",
	  "process improvement",
	  "product",
	  "productivity",
	  "project",
	  "projection",
	  "protocol",
	  "secured line",
	  "service-desk",
	  "software",
	  "solution",
	  "standardization",
	  "strategy",
	  "structure",
	  "success",
	  "superstructure",
	  "support",
	  "synergy",
	  "system engine",
	  "task-force",
	  "throughput",
	  "time-frame",
	  "toolset",
	  "utilisation",
	  "website",
	  "workforce"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "s.r.o.",
	  "a.s.",
	  "v.o.s."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var sk = {};
	module['exports'] = sk;
	sk.title = "Slovakian";
	sk.address = __webpack_require__(1109);
	sk.company = __webpack_require__(1122);
	sk.internet = __webpack_require__(1129);
	sk.lorem = __webpack_require__(1130);
	sk.name = __webpack_require__(1135);
	sk.phone_number = __webpack_require__(1143);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "sk",
	  "com",
	  "net",
	  "eu",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "zoznam.sk",
	  "azet.sk"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1128);
	internet.domain_suffix = __webpack_require__(1127);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(1132);
	lorem.supplemental = __webpack_require__(1131);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "abbas",
	  "abduco",
	  "abeo",
	  "abscido",
	  "absconditus",
	  "absens",
	  "absorbeo",
	  "absque",
	  "abstergo",
	  "absum",
	  "abundans",
	  "abutor",
	  "accedo",
	  "accendo",
	  "acceptus",
	  "accipio",
	  "accommodo",
	  "accusator",
	  "acer",
	  "acerbitas",
	  "acervus",
	  "acidus",
	  "acies",
	  "acquiro",
	  "acsi",
	  "adamo",
	  "adaugeo",
	  "addo",
	  "adduco",
	  "ademptio",
	  "adeo",
	  "adeptio",
	  "adfectus",
	  "adfero",
	  "adficio",
	  "adflicto",
	  "adhaero",
	  "adhuc",
	  "adicio",
	  "adimpleo",
	  "adinventitias",
	  "adipiscor",
	  "adiuvo",
	  "administratio",
	  "admiratio",
	  "admitto",
	  "admoneo",
	  "admoveo",
	  "adnuo",
	  "adopto",
	  "adsidue",
	  "adstringo",
	  "adsuesco",
	  "adsum",
	  "adulatio",
	  "adulescens",
	  "adultus",
	  "aduro",
	  "advenio",
	  "adversus",
	  "advoco",
	  "aedificium",
	  "aeger",
	  "aegre",
	  "aegrotatio",
	  "aegrus",
	  "aeneus",
	  "aequitas",
	  "aequus",
	  "aer",
	  "aestas",
	  "aestivus",
	  "aestus",
	  "aetas",
	  "aeternus",
	  "ager",
	  "aggero",
	  "aggredior",
	  "agnitio",
	  "agnosco",
	  "ago",
	  "ait",
	  "aiunt",
	  "alienus",
	  "alii",
	  "alioqui",
	  "aliqua",
	  "alius",
	  "allatus",
	  "alo",
	  "alter",
	  "altus",
	  "alveus",
	  "amaritudo",
	  "ambitus",
	  "ambulo",
	  "amicitia",
	  "amiculum",
	  "amissio",
	  "amita",
	  "amitto",
	  "amo",
	  "amor",
	  "amoveo",
	  "amplexus",
	  "amplitudo",
	  "amplus",
	  "ancilla",
	  "angelus",
	  "angulus",
	  "angustus",
	  "animadverto",
	  "animi",
	  "animus",
	  "annus",
	  "anser",
	  "ante",
	  "antea",
	  "antepono",
	  "antiquus",
	  "aperio",
	  "aperte",
	  "apostolus",
	  "apparatus",
	  "appello",
	  "appono",
	  "appositus",
	  "approbo",
	  "apto",
	  "aptus",
	  "apud",
	  "aqua",
	  "ara",
	  "aranea",
	  "arbitro",
	  "arbor",
	  "arbustum",
	  "arca",
	  "arceo",
	  "arcesso",
	  "arcus",
	  "argentum",
	  "argumentum",
	  "arguo",
	  "arma",
	  "armarium",
	  "armo",
	  "aro",
	  "ars",
	  "articulus",
	  "artificiose",
	  "arto",
	  "arx",
	  "ascisco",
	  "ascit",
	  "asper",
	  "aspicio",
	  "asporto",
	  "assentator",
	  "astrum",
	  "atavus",
	  "ater",
	  "atqui",
	  "atrocitas",
	  "atrox",
	  "attero",
	  "attollo",
	  "attonbitus",
	  "auctor",
	  "auctus",
	  "audacia",
	  "audax",
	  "audentia",
	  "audeo",
	  "audio",
	  "auditor",
	  "aufero",
	  "aureus",
	  "auris",
	  "aurum",
	  "aut",
	  "autem",
	  "autus",
	  "auxilium",
	  "avaritia",
	  "avarus",
	  "aveho",
	  "averto",
	  "avoco",
	  "baiulus",
	  "balbus",
	  "barba",
	  "bardus",
	  "basium",
	  "beatus",
	  "bellicus",
	  "bellum",
	  "bene",
	  "beneficium",
	  "benevolentia",
	  "benigne",
	  "bestia",
	  "bibo",
	  "bis",
	  "blandior",
	  "bonus",
	  "bos",
	  "brevis",
	  "cado",
	  "caecus",
	  "caelestis",
	  "caelum",
	  "calamitas",
	  "calcar",
	  "calco",
	  "calculus",
	  "callide",
	  "campana",
	  "candidus",
	  "canis",
	  "canonicus",
	  "canto",
	  "capillus",
	  "capio",
	  "capitulus",
	  "capto",
	  "caput",
	  "carbo",
	  "carcer",
	  "careo",
	  "caries",
	  "cariosus",
	  "caritas",
	  "carmen",
	  "carpo",
	  "carus",
	  "casso",
	  "caste",
	  "casus",
	  "catena",
	  "caterva",
	  "cattus",
	  "cauda",
	  "causa",
	  "caute",
	  "caveo",
	  "cavus",
	  "cedo",
	  "celebrer",
	  "celer",
	  "celo",
	  "cena",
	  "cenaculum",
	  "ceno",
	  "censura",
	  "centum",
	  "cerno",
	  "cernuus",
	  "certe",
	  "certo",
	  "certus",
	  "cervus",
	  "cetera",
	  "charisma",
	  "chirographum",
	  "cibo",
	  "cibus",
	  "cicuta",
	  "cilicium",
	  "cimentarius",
	  "ciminatio",
	  "cinis",
	  "circumvenio",
	  "cito",
	  "civis",
	  "civitas",
	  "clam",
	  "clamo",
	  "claro",
	  "clarus",
	  "claudeo",
	  "claustrum",
	  "clementia",
	  "clibanus",
	  "coadunatio",
	  "coaegresco",
	  "coepi",
	  "coerceo",
	  "cogito",
	  "cognatus",
	  "cognomen",
	  "cogo",
	  "cohaero",
	  "cohibeo",
	  "cohors",
	  "colligo",
	  "colloco",
	  "collum",
	  "colo",
	  "color",
	  "coma",
	  "combibo",
	  "comburo",
	  "comedo",
	  "comes",
	  "cometes",
	  "comis",
	  "comitatus",
	  "commemoro",
	  "comminor",
	  "commodo",
	  "communis",
	  "comparo",
	  "compello",
	  "complectus",
	  "compono",
	  "comprehendo",
	  "comptus",
	  "conatus",
	  "concedo",
	  "concido",
	  "conculco",
	  "condico",
	  "conduco",
	  "confero",
	  "confido",
	  "conforto",
	  "confugo",
	  "congregatio",
	  "conicio",
	  "coniecto",
	  "conitor",
	  "coniuratio",
	  "conor",
	  "conqueror",
	  "conscendo",
	  "conservo",
	  "considero",
	  "conspergo",
	  "constans",
	  "consuasor",
	  "contabesco",
	  "contego",
	  "contigo",
	  "contra",
	  "conturbo",
	  "conventus",
	  "convoco",
	  "copia",
	  "copiose",
	  "cornu",
	  "corona",
	  "corpus",
	  "correptius",
	  "corrigo",
	  "corroboro",
	  "corrumpo",
	  "coruscus",
	  "cotidie",
	  "crapula",
	  "cras",
	  "crastinus",
	  "creator",
	  "creber",
	  "crebro",
	  "credo",
	  "creo",
	  "creptio",
	  "crepusculum",
	  "cresco",
	  "creta",
	  "cribro",
	  "crinis",
	  "cruciamentum",
	  "crudelis",
	  "cruentus",
	  "crur",
	  "crustulum",
	  "crux",
	  "cubicularis",
	  "cubitum",
	  "cubo",
	  "cui",
	  "cuius",
	  "culpa",
	  "culpo",
	  "cultellus",
	  "cultura",
	  "cum",
	  "cunabula",
	  "cunae",
	  "cunctatio",
	  "cupiditas",
	  "cupio",
	  "cuppedia",
	  "cupressus",
	  "cur",
	  "cura",
	  "curatio",
	  "curia",
	  "curiositas",
	  "curis",
	  "curo",
	  "curriculum",
	  "currus",
	  "cursim",
	  "curso",
	  "cursus",
	  "curto",
	  "curtus",
	  "curvo",
	  "curvus",
	  "custodia",
	  "damnatio",
	  "damno",
	  "dapifer",
	  "debeo",
	  "debilito",
	  "decens",
	  "decerno",
	  "decet",
	  "decimus",
	  "decipio",
	  "decor",
	  "decretum",
	  "decumbo",
	  "dedecor",
	  "dedico",
	  "deduco",
	  "defaeco",
	  "defendo",
	  "defero",
	  "defessus",
	  "defetiscor",
	  "deficio",
	  "defigo",
	  "defleo",
	  "defluo",
	  "defungo",
	  "degenero",
	  "degero",
	  "degusto",
	  "deinde",
	  "delectatio",
	  "delego",
	  "deleo",
	  "delibero",
	  "delicate",
	  "delinquo",
	  "deludo",
	  "demens",
	  "demergo",
	  "demitto",
	  "demo",
	  "demonstro",
	  "demoror",
	  "demulceo",
	  "demum",
	  "denego",
	  "denique",
	  "dens",
	  "denuncio",
	  "denuo",
	  "deorsum",
	  "depereo",
	  "depono",
	  "depopulo",
	  "deporto",
	  "depraedor",
	  "deprecator",
	  "deprimo",
	  "depromo",
	  "depulso",
	  "deputo",
	  "derelinquo",
	  "derideo",
	  "deripio",
	  "desidero",
	  "desino",
	  "desipio",
	  "desolo",
	  "desparatus",
	  "despecto",
	  "despirmatio",
	  "infit",
	  "inflammatio",
	  "paens",
	  "patior",
	  "patria",
	  "patrocinor",
	  "patruus",
	  "pauci",
	  "paulatim",
	  "pauper",
	  "pax",
	  "peccatus",
	  "pecco",
	  "pecto",
	  "pectus",
	  "pecunia",
	  "pecus",
	  "peior",
	  "pel",
	  "ocer",
	  "socius",
	  "sodalitas",
	  "sol",
	  "soleo",
	  "solio",
	  "solitudo",
	  "solium",
	  "sollers",
	  "sollicito",
	  "solum",
	  "solus",
	  "solutio",
	  "solvo",
	  "somniculosus",
	  "somnus",
	  "sonitus",
	  "sono",
	  "sophismata",
	  "sopor",
	  "sordeo",
	  "sortitus",
	  "spargo",
	  "speciosus",
	  "spectaculum",
	  "speculum",
	  "sperno",
	  "spero",
	  "spes",
	  "spiculum",
	  "spiritus",
	  "spoliatio",
	  "sponte",
	  "stabilis",
	  "statim",
	  "statua",
	  "stella",
	  "stillicidium",
	  "stipes",
	  "stips",
	  "sto",
	  "strenuus",
	  "strues",
	  "studio",
	  "stultus",
	  "suadeo",
	  "suasoria",
	  "sub",
	  "subito",
	  "subiungo",
	  "sublime",
	  "subnecto",
	  "subseco",
	  "substantia",
	  "subvenio",
	  "succedo",
	  "succurro",
	  "sufficio",
	  "suffoco",
	  "suffragium",
	  "suggero",
	  "sui",
	  "sulum",
	  "sum",
	  "summa",
	  "summisse",
	  "summopere",
	  "sumo",
	  "sumptus",
	  "supellex",
	  "super",
	  "suppellex",
	  "supplanto",
	  "suppono",
	  "supra",
	  "surculus",
	  "surgo",
	  "sursum",
	  "suscipio",
	  "suspendo",
	  "sustineo",
	  "suus",
	  "synagoga",
	  "tabella",
	  "tabernus",
	  "tabesco",
	  "tabgo",
	  "tabula",
	  "taceo",
	  "tactus",
	  "taedium",
	  "talio",
	  "talis",
	  "talus",
	  "tam",
	  "tamdiu",
	  "tamen",
	  "tametsi",
	  "tamisium",
	  "tamquam",
	  "tandem",
	  "tantillus",
	  "tantum",
	  "tardus",
	  "tego",
	  "temeritas",
	  "temperantia",
	  "templum",
	  "temptatio",
	  "tempus",
	  "tenax",
	  "tendo",
	  "teneo",
	  "tener",
	  "tenuis",
	  "tenus",
	  "tepesco",
	  "tepidus",
	  "ter",
	  "terebro",
	  "teres",
	  "terga",
	  "tergeo",
	  "tergiversatio",
	  "tergo",
	  "tergum",
	  "termes",
	  "terminatio",
	  "tero",
	  "terra",
	  "terreo",
	  "territo",
	  "terror",
	  "tersus",
	  "tertius",
	  "testimonium",
	  "texo",
	  "textilis",
	  "textor",
	  "textus",
	  "thalassinus",
	  "theatrum",
	  "theca",
	  "thema",
	  "theologus",
	  "thermae",
	  "thesaurus",
	  "thesis",
	  "thorax",
	  "thymbra",
	  "thymum",
	  "tibi",
	  "timidus",
	  "timor",
	  "titulus",
	  "tolero",
	  "tollo",
	  "tondeo",
	  "tonsor",
	  "torqueo",
	  "torrens",
	  "tot",
	  "totidem",
	  "toties",
	  "totus",
	  "tracto",
	  "trado",
	  "traho",
	  "trans",
	  "tredecim",
	  "tremo",
	  "trepide",
	  "tres",
	  "tribuo",
	  "tricesimus",
	  "triduana",
	  "triginta",
	  "tripudio",
	  "tristis",
	  "triumphus",
	  "trucido",
	  "truculenter",
	  "tubineus",
	  "tui",
	  "tum",
	  "tumultus",
	  "tunc",
	  "turba",
	  "turbo",
	  "turpe",
	  "turpis",
	  "tutamen",
	  "tutis",
	  "tyrannus",
	  "uberrime",
	  "ubi",
	  "ulciscor",
	  "ullus",
	  "ulterius",
	  "ultio",
	  "ultra",
	  "umbra",
	  "umerus",
	  "umquam",
	  "una",
	  "unde",
	  "undique",
	  "universe",
	  "unus",
	  "urbanus",
	  "urbs",
	  "uredo",
	  "usitas",
	  "usque",
	  "ustilo",
	  "ustulo",
	  "usus",
	  "uter",
	  "uterque",
	  "utilis",
	  "utique",
	  "utor",
	  "utpote",
	  "utrimque",
	  "utroque",
	  "utrum",
	  "uxor",
	  "vaco",
	  "vacuus",
	  "vado",
	  "vae",
	  "valde",
	  "valens",
	  "valeo",
	  "valetudo",
	  "validus",
	  "vallum",
	  "vapulus",
	  "varietas",
	  "varius",
	  "vehemens",
	  "vel",
	  "velociter",
	  "velum",
	  "velut",
	  "venia",
	  "venio",
	  "ventito",
	  "ventosus",
	  "ventus",
	  "venustas",
	  "ver",
	  "verbera",
	  "verbum",
	  "vere",
	  "verecundia",
	  "vereor",
	  "vergo",
	  "veritas",
	  "vero",
	  "versus",
	  "verto",
	  "verumtamen",
	  "verus",
	  "vesco",
	  "vesica",
	  "vesper",
	  "vespillo",
	  "vester",
	  "vestigium",
	  "vestrum",
	  "vetus",
	  "via",
	  "vicinus",
	  "vicissitudo",
	  "victoria",
	  "victus",
	  "videlicet",
	  "video",
	  "viduata",
	  "viduo",
	  "vigilo",
	  "vigor",
	  "vilicus",
	  "vilis",
	  "vilitas",
	  "villa",
	  "vinco",
	  "vinculum",
	  "vindico",
	  "vinitor",
	  "vinum",
	  "vir",
	  "virga",
	  "virgo",
	  "viridis",
	  "viriliter",
	  "virtus",
	  "vis",
	  "viscus",
	  "vita",
	  "vitiosus",
	  "vitium",
	  "vito",
	  "vivo",
	  "vix",
	  "vobis",
	  "vociferor",
	  "voco",
	  "volaticus",
	  "volo",
	  "volubilis",
	  "voluntarius",
	  "volup",
	  "volutabrum",
	  "volva",
	  "vomer",
	  "vomica",
	  "vomito",
	  "vorago",
	  "vorax",
	  "voro",
	  "vos",
	  "votum",
	  "voveo",
	  "vox",
	  "vulariter",
	  "vulgaris",
	  "vulgivagus",
	  "vulgo",
	  "vulgus",
	  "vulnero",
	  "vulnus",
	  "vulpes",
	  "vulticulus",
	  "vultuosus",
	  "xiphias"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alexandra",
	  "Karina",
	  "Daniela",
	  "Andrea",
	  "Antónia",
	  "Bohuslava",
	  "Dáša",
	  "Malvína",
	  "Kristína",
	  "Nataša",
	  "Bohdana",
	  "Drahomíra",
	  "Sára",
	  "Zora",
	  "Tamara",
	  "Ema",
	  "Tatiana",
	  "Erika",
	  "Veronika",
	  "Agáta",
	  "Dorota",
	  "Vanda",
	  "Zoja",
	  "Gabriela",
	  "Perla",
	  "Ida",
	  "Liana",
	  "Miloslava",
	  "Vlasta",
	  "Lívia",
	  "Eleonóra",
	  "Etela",
	  "Romana",
	  "Zlatica",
	  "Anežka",
	  "Bohumila",
	  "Františka",
	  "Angela",
	  "Matilda",
	  "Svetlana",
	  "Ľubica",
	  "Alena",
	  "Soňa",
	  "Vieroslava",
	  "Zita",
	  "Miroslava",
	  "Irena",
	  "Milena",
	  "Estera",
	  "Justína",
	  "Dana",
	  "Danica",
	  "Jela",
	  "Jaroslava",
	  "Jarmila",
	  "Lea",
	  "Anastázia",
	  "Galina",
	  "Lesana",
	  "Hermína",
	  "Monika",
	  "Ingrida",
	  "Viktória",
	  "Blažena",
	  "Žofia",
	  "Sofia",
	  "Gizela",
	  "Viola",
	  "Gertrúda",
	  "Zina",
	  "Júlia",
	  "Juliana",
	  "Želmíra",
	  "Ela",
	  "Vanesa",
	  "Iveta",
	  "Vilma",
	  "Petronela",
	  "Žaneta",
	  "Xénia",
	  "Karolína",
	  "Lenka",
	  "Laura",
	  "Stanislava",
	  "Margaréta",
	  "Dobroslava",
	  "Blanka",
	  "Valéria",
	  "Paulína",
	  "Sidónia",
	  "Adriána",
	  "Beáta",
	  "Petra",
	  "Melánia",
	  "Diana",
	  "Berta",
	  "Patrícia",
	  "Lujza",
	  "Amália",
	  "Milota",
	  "Nina",
	  "Margita",
	  "Kamila",
	  "Dušana",
	  "Magdaléna",
	  "Oľga",
	  "Anna",
	  "Hana",
	  "Božena",
	  "Marta",
	  "Libuša",
	  "Božidara",
	  "Dominika",
	  "Hortenzia",
	  "Jozefína",
	  "Štefánia",
	  "Ľubomíra",
	  "Zuzana",
	  "Darina",
	  "Marcela",
	  "Milica",
	  "Elena",
	  "Helena",
	  "Lýdia",
	  "Anabela",
	  "Jana",
	  "Silvia",
	  "Nikola",
	  "Ružena",
	  "Nora",
	  "Drahoslava",
	  "Linda",
	  "Melinda",
	  "Rebeka",
	  "Rozália",
	  "Regína",
	  "Alica",
	  "Marianna",
	  "Miriama",
	  "Martina",
	  "Mária",
	  "Jolana",
	  "Ľudomila",
	  "Ľudmila",
	  "Olympia",
	  "Eugénia",
	  "Ľuboslava",
	  "Zdenka",
	  "Edita",
	  "Michaela",
	  "Stela",
	  "Viera",
	  "Natália",
	  "Eliška",
	  "Brigita",
	  "Valentína",
	  "Terézia",
	  "Vladimíra",
	  "Hedviga",
	  "Uršuľa",
	  "Alojza",
	  "Kvetoslava",
	  "Sabína",
	  "Dobromila",
	  "Klára",
	  "Simona",
	  "Aurélia",
	  "Denisa",
	  "Renáta",
	  "Irma",
	  "Agnesa",
	  "Klaudia",
	  "Alžbeta",
	  "Elvíra",
	  "Cecília",
	  "Emília",
	  "Katarína",
	  "Henrieta",
	  "Bibiána",
	  "Barbora",
	  "Marína",
	  "Izabela",
	  "Hilda",
	  "Otília",
	  "Lucia",
	  "Branislava",
	  "Bronislava",
	  "Ivica",
	  "Albína",
	  "Kornélia",
	  "Sláva",
	  "Slávka",
	  "Judita",
	  "Dagmara",
	  "Adela",
	  "Nadežda",
	  "Eva",
	  "Filoména",
	  "Ivana",
	  "Milada"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Antalová",
	  "Babková",
	  "Bahnová",
	  "Balážová",
	  "Baranová",
	  "Baranková",
	  "Bartovičová",
	  "Bartošová",
	  "Bačová",
	  "Bernoláková",
	  "Beňová",
	  "Biceková",
	  "Bieliková",
	  "Blahová",
	  "Bondrová",
	  "Bosáková",
	  "Bošková",
	  "Brezinová",
	  "Bukovská",
	  "Chalupková",
	  "Chudíková",
	  "Cibulová",
	  "Cibulková",
	  "Cyprichová",
	  "Cígerová",
	  "Danková",
	  "Daňková",
	  "Daňová",
	  "Debnárová",
	  "Dejová",
	  "Dekýšová",
	  "Doležalová",
	  "Dočolomanská",
	  "Droppová",
	  "Dubovská",
	  "Dudeková",
	  "Dulová",
	  "Dullová",
	  "Dusíková",
	  "Dvončová",
	  "Dzurjaninová",
	  "Dávidová",
	  "Fabianová",
	  "Fabiánová",
	  "Fajnorová",
	  "Farkašovská",
	  "Ficová",
	  "Filcová",
	  "Filipová",
	  "Finková",
	  "Ftoreková",
	  "Gašparová",
	  "Gašparovičová",
	  "Gocníková",
	  "Gregorová",
	  "Gregušová",
	  "Grznárová",
	  "Habláková",
	  "Habšudová",
	  "Haldová",
	  "Halušková",
	  "Haláková",
	  "Hanková",
	  "Hanzalová",
	  "Haščáková",
	  "Heretiková",
	  "Hečková",
	  "Hlaváčeková",
	  "Hlinková",
	  "Holubová",
	  "Holubyová",
	  "Hossová",
	  "Hozová",
	  "Hrašková",
	  "Hricová",
	  "Hrmová",
	  "Hrušovská",
	  "Hubová",
	  "Ihnačáková",
	  "Janečeková",
	  "Janošková",
	  "Jantošovičová",
	  "Janíková",
	  "Jančeková",
	  "Jedľovská",
	  "Jendeková",
	  "Jonatová",
	  "Jurinová",
	  "Jurkovičová",
	  "Juríková",
	  "Jánošíková",
	  "Kafendová",
	  "Kaliská",
	  "Karulová",
	  "Kenížová",
	  "Klapková",
	  "Kmeťová",
	  "Kolesárová",
	  "Kollárová",
	  "Kolniková",
	  "Kolníková",
	  "Kolárová",
	  "Korecová",
	  "Kostkaová",
	  "Kostrecová",
	  "Kováčová",
	  "Kováčiková",
	  "Kozová",
	  "Kočišová",
	  "Krajíčeková",
	  "Krajčová",
	  "Krajčovičová",
	  "Krajčírová",
	  "Králiková",
	  "Krúpová",
	  "Kubíková",
	  "Kyseľová",
	  "Kállayová",
	  "Labudová",
	  "Lepšíková",
	  "Liptáková",
	  "Lisická",
	  "Lubinová",
	  "Lukáčová",
	  "Luptáková",
	  "Líšková",
	  "Madejová",
	  "Majeská",
	  "Malachovská",
	  "Malíšeková",
	  "Mamojková",
	  "Marcinková",
	  "Mariánová",
	  "Masaryková",
	  "Maslová",
	  "Matiašková",
	  "Medveďová",
	  "Melcerová",
	  "Mečiarová",
	  "Michalíková",
	  "Mihaliková",
	  "Mihálová",
	  "Miháliková",
	  "Miklošková",
	  "Mikulíková",
	  "Mikušová",
	  "Mikúšová",
	  "Milotová",
	  "Mináčová",
	  "Mišíková",
	  "Mojžišová",
	  "Mokrošová",
	  "Morová",
	  "Moravčíková",
	  "Mydlová",
	  "Nemcová",
	  "Nováková",
	  "Obšutová",
	  "Ondrušová",
	  "Otčenášová",
	  "Pauková",
	  "Pavlikovská",
	  "Pavúková",
	  "Pašeková",
	  "Pašková",
	  "Pelikánová",
	  "Petrovická",
	  "Petrušková",
	  "Pešková",
	  "Plchová",
	  "Plekanecová",
	  "Podhradská",
	  "Podkonická",
	  "Poliaková",
	  "Pupáková",
	  "Raková",
	  "Repiská",
	  "Romančíková",
	  "Rusová",
	  "Ružičková",
	  "Rybníčeková",
	  "Rybárová",
	  "Rybáriková",
	  "Samsonová",
	  "Sedliaková",
	  "Senková",
	  "Sklenková",
	  "Skokanová",
	  "Skutecká",
	  "Slašťanová",
	  "Slobodová",
	  "Slobodníková",
	  "Slotová",
	  "Slováková",
	  "Smreková",
	  "Stodolová",
	  "Straková",
	  "Strnisková",
	  "Svrbíková",
	  "Sámelová",
	  "Sýkorová",
	  "Tatarová",
	  "Tatarková",
	  "Tatárová",
	  "Tatárkaová",
	  "Thomková",
	  "Tomečeková",
	  "Tomková",
	  "Trubenová",
	  "Turčoková",
	  "Uramová",
	  "Urblíková",
	  "Vajcíková",
	  "Vajdová",
	  "Valachová",
	  "Valachovičová",
	  "Valentová",
	  "Valušková",
	  "Vaneková",
	  "Veselová",
	  "Vicenová",
	  "Višňovská",
	  "Vlachová",
	  "Vojteková",
	  "Vydarená",
	  "Zajacová",
	  "Zimová",
	  "Zimková",
	  "Záborská",
	  "Zúbriková",
	  "Čapkovičová",
	  "Čaplovičová",
	  "Čarnogurská",
	  "Čierná",
	  "Čobrdová",
	  "Ďaďová",
	  "Ďuricová",
	  "Ďurišová",
	  "Šidlová",
	  "Šimonovičová",
	  "Škriniarová",
	  "Škultétyová",
	  "Šmajdová",
	  "Šoltésová",
	  "Šoltýsová",
	  "Štefanová",
	  "Štefanková",
	  "Šulcová",
	  "Šurková",
	  "Švehlová",
	  "Šťastná"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.male_first_name = __webpack_require__(1136);
	name.female_first_name = __webpack_require__(1133);
	name.male_last_name = __webpack_require__(1137);
	name.female_last_name = __webpack_require__(1134);
	name.prefix = __webpack_require__(1139);
	name.suffix = __webpack_require__(1140);
	name.title = __webpack_require__(1141);
	name.name = __webpack_require__(1138);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Drahoslav",
	  "Severín",
	  "Alexej",
	  "Ernest",
	  "Rastislav",
	  "Radovan",
	  "Dobroslav",
	  "Dalibor",
	  "Vincent",
	  "Miloš",
	  "Timotej",
	  "Gejza",
	  "Bohuš",
	  "Alfonz",
	  "Gašpar",
	  "Emil",
	  "Erik",
	  "Blažej",
	  "Zdenko",
	  "Dezider",
	  "Arpád",
	  "Valentín",
	  "Pravoslav",
	  "Jaromír",
	  "Roman",
	  "Matej",
	  "Frederik",
	  "Viktor",
	  "Alexander",
	  "Radomír",
	  "Albín",
	  "Bohumil",
	  "Kazimír",
	  "Fridrich",
	  "Radoslav",
	  "Tomáš",
	  "Alan",
	  "Branislav",
	  "Bruno",
	  "Gregor",
	  "Vlastimil",
	  "Boleslav",
	  "Eduard",
	  "Jozef",
	  "Víťazoslav",
	  "Blahoslav",
	  "Beňadik",
	  "Adrián",
	  "Gabriel",
	  "Marián",
	  "Emanuel",
	  "Miroslav",
	  "Benjamín",
	  "Hugo",
	  "Richard",
	  "Izidor",
	  "Zoltán",
	  "Albert",
	  "Igor",
	  "Július",
	  "Aleš",
	  "Fedor",
	  "Rudolf",
	  "Valér",
	  "Marcel",
	  "Ervín",
	  "Slavomír",
	  "Vojtech",
	  "Juraj",
	  "Marek",
	  "Jaroslav",
	  "Žigmund",
	  "Florián",
	  "Roland",
	  "Pankrác",
	  "Servác",
	  "Bonifác",
	  "Svetozár",
	  "Bernard",
	  "Júlia",
	  "Urban",
	  "Dušan",
	  "Viliam",
	  "Ferdinand",
	  "Norbert",
	  "Róbert",
	  "Medard",
	  "Zlatko",
	  "Anton",
	  "Vasil",
	  "Vít",
	  "Adolf",
	  "Vratislav",
	  "Alfréd",
	  "Alojz",
	  "Ján",
	  "Tadeáš",
	  "Ladislav",
	  "Peter",
	  "Pavol",
	  "Miloslav",
	  "Prokop",
	  "Cyril",
	  "Metod",
	  "Patrik",
	  "Oliver",
	  "Ivan",
	  "Kamil",
	  "Henrich",
	  "Drahomír",
	  "Bohuslav",
	  "Iľja",
	  "Daniel",
	  "Vladimír",
	  "Jakub",
	  "Krištof",
	  "Ignác",
	  "Gustáv",
	  "Jerguš",
	  "Dominik",
	  "Oskar",
	  "Vavrinec",
	  "Ľubomír",
	  "Mojmír",
	  "Leonard",
	  "Tichomír",
	  "Filip",
	  "Bartolomej",
	  "Ľudovít",
	  "Samuel",
	  "Augustín",
	  "Belo",
	  "Oleg",
	  "Bystrík",
	  "Ctibor",
	  "Ľudomil",
	  "Konštantín",
	  "Ľuboslav",
	  "Matúš",
	  "Móric",
	  "Ľuboš",
	  "Ľubor",
	  "Vladislav",
	  "Cyprián",
	  "Václav",
	  "Michal",
	  "Jarolím",
	  "Arnold",
	  "Levoslav",
	  "František",
	  "Dionýz",
	  "Maximilián",
	  "Koloman",
	  "Boris",
	  "Lukáš",
	  "Kristián",
	  "Vendelín",
	  "Sergej",
	  "Aurel",
	  "Demeter",
	  "Denis",
	  "Hubert",
	  "Karol",
	  "Imrich",
	  "René",
	  "Bohumír",
	  "Teodor",
	  "Tibor",
	  "Maroš",
	  "Martin",
	  "Svätopluk",
	  "Stanislav",
	  "Leopold",
	  "Eugen",
	  "Félix",
	  "Klement",
	  "Kornel",
	  "Milan",
	  "Vratko",
	  "Ondrej",
	  "Andrej",
	  "Edmund",
	  "Oldrich",
	  "Oto",
	  "Mikuláš",
	  "Ambróz",
	  "Radúz",
	  "Bohdan",
	  "Adam",
	  "Štefan",
	  "Dávid",
	  "Silvester"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Antal",
	  "Babka",
	  "Bahna",
	  "Bahno",
	  "Baláž",
	  "Baran",
	  "Baranka",
	  "Bartovič",
	  "Bartoš",
	  "Bača",
	  "Bernolák",
	  "Beňo",
	  "Bicek",
	  "Bielik",
	  "Blaho",
	  "Bondra",
	  "Bosák",
	  "Boška",
	  "Brezina",
	  "Bukovský",
	  "Chalupka",
	  "Chudík",
	  "Cibula",
	  "Cibulka",
	  "Cibuľa",
	  "Cyprich",
	  "Cíger",
	  "Danko",
	  "Daňko",
	  "Daňo",
	  "Debnár",
	  "Dej",
	  "Dekýš",
	  "Doležal",
	  "Dočolomanský",
	  "Droppa",
	  "Dubovský",
	  "Dudek",
	  "Dula",
	  "Dulla",
	  "Dusík",
	  "Dvonč",
	  "Dzurjanin",
	  "Dávid",
	  "Fabian",
	  "Fabián",
	  "Fajnor",
	  "Farkašovský",
	  "Fico",
	  "Filc",
	  "Filip",
	  "Finka",
	  "Ftorek",
	  "Gašpar",
	  "Gašparovič",
	  "Gocník",
	  "Gregor",
	  "Greguš",
	  "Grznár",
	  "Hablák",
	  "Habšuda",
	  "Halda",
	  "Haluška",
	  "Halák",
	  "Hanko",
	  "Hanzal",
	  "Haščák",
	  "Heretik",
	  "Hečko",
	  "Hlaváček",
	  "Hlinka",
	  "Holub",
	  "Holuby",
	  "Hossa",
	  "Hoza",
	  "Hraško",
	  "Hric",
	  "Hrmo",
	  "Hrušovský",
	  "Huba",
	  "Ihnačák",
	  "Janeček",
	  "Janoška",
	  "Jantošovič",
	  "Janík",
	  "Janček",
	  "Jedľovský",
	  "Jendek",
	  "Jonata",
	  "Jurina",
	  "Jurkovič",
	  "Jurík",
	  "Jánošík",
	  "Kafenda",
	  "Kaliský",
	  "Karul",
	  "Keníž",
	  "Klapka",
	  "Kmeť",
	  "Kolesár",
	  "Kollár",
	  "Kolnik",
	  "Kolník",
	  "Kolár",
	  "Korec",
	  "Kostka",
	  "Kostrec",
	  "Kováč",
	  "Kováčik",
	  "Koza",
	  "Kočiš",
	  "Krajíček",
	  "Krajči",
	  "Krajčo",
	  "Krajčovič",
	  "Krajčír",
	  "Králik",
	  "Krúpa",
	  "Kubík",
	  "Kyseľ",
	  "Kállay",
	  "Labuda",
	  "Lepšík",
	  "Lipták",
	  "Lisický",
	  "Lubina",
	  "Lukáč",
	  "Lupták",
	  "Líška",
	  "Madej",
	  "Majeský",
	  "Malachovský",
	  "Malíšek",
	  "Mamojka",
	  "Marcinko",
	  "Marián",
	  "Masaryk",
	  "Maslo",
	  "Matiaško",
	  "Medveď",
	  "Melcer",
	  "Mečiar",
	  "Michalík",
	  "Mihalik",
	  "Mihál",
	  "Mihálik",
	  "Mikloško",
	  "Mikulík",
	  "Mikuš",
	  "Mikúš",
	  "Milota",
	  "Mináč",
	  "Mišík",
	  "Mojžiš",
	  "Mokroš",
	  "Mora",
	  "Moravčík",
	  "Mydlo",
	  "Nemec",
	  "Nitra",
	  "Novák",
	  "Obšut",
	  "Ondruš",
	  "Otčenáš",
	  "Pauko",
	  "Pavlikovský",
	  "Pavúk",
	  "Pašek",
	  "Paška",
	  "Paško",
	  "Pelikán",
	  "Petrovický",
	  "Petruška",
	  "Peško",
	  "Plch",
	  "Plekanec",
	  "Podhradský",
	  "Podkonický",
	  "Poliak",
	  "Pupák",
	  "Rak",
	  "Repiský",
	  "Romančík",
	  "Rus",
	  "Ružička",
	  "Rybníček",
	  "Rybár",
	  "Rybárik",
	  "Samson",
	  "Sedliak",
	  "Senko",
	  "Sklenka",
	  "Skokan",
	  "Skutecký",
	  "Slašťan",
	  "Sloboda",
	  "Slobodník",
	  "Slota",
	  "Slovák",
	  "Smrek",
	  "Stodola",
	  "Straka",
	  "Strnisko",
	  "Svrbík",
	  "Sámel",
	  "Sýkora",
	  "Tatar",
	  "Tatarka",
	  "Tatár",
	  "Tatárka",
	  "Thomka",
	  "Tomeček",
	  "Tomka",
	  "Tomko",
	  "Truben",
	  "Turčok",
	  "Uram",
	  "Urblík",
	  "Vajcík",
	  "Vajda",
	  "Valach",
	  "Valachovič",
	  "Valent",
	  "Valuška",
	  "Vanek",
	  "Vesel",
	  "Vicen",
	  "Višňovský",
	  "Vlach",
	  "Vojtek",
	  "Vydarený",
	  "Zajac",
	  "Zima",
	  "Zimka",
	  "Záborský",
	  "Zúbrik",
	  "Čapkovič",
	  "Čaplovič",
	  "Čarnogurský",
	  "Čierny",
	  "Čobrda",
	  "Ďaďo",
	  "Ďurica",
	  "Ďuriš",
	  "Šidlo",
	  "Šimonovič",
	  "Škriniar",
	  "Škultéty",
	  "Šmajda",
	  "Šoltés",
	  "Šoltýs",
	  "Štefan",
	  "Štefanka",
	  "Šulc",
	  "Šurka",
	  "Švehla",
	  "Šťastný"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{man_first_name} #{man_last_name}",
	  "#{prefix} #{woman_first_name} #{woman_last_name}",
	  "#{man_first_name} #{man_last_name} #{suffix}",
	  "#{woman_first_name} #{woman_last_name} #{suffix}",
	  "#{man_first_name} #{man_last_name}",
	  "#{man_first_name} #{man_last_name}",
	  "#{man_first_name} #{man_last_name}",
	  "#{woman_first_name} #{woman_last_name}",
	  "#{woman_first_name} #{woman_last_name}",
	  "#{woman_first_name} #{woman_last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ing.",
	  "Mgr.",
	  "JUDr.",
	  "MUDr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Phd."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "Lead",
	    "Senior",
	    "Direct",
	    "Corporate",
	    "Dynamic",
	    "Future",
	    "Product",
	    "National",
	    "Regional",
	    "District",
	    "Central",
	    "Global",
	    "Customer",
	    "Investor",
	    "Dynamic",
	    "International",
	    "Legacy",
	    "Forward",
	    "Internal",
	    "Human",
	    "Chief",
	    "Principal"
	  ],
	  "level": [
	    "Solutions",
	    "Program",
	    "Brand",
	    "Security",
	    "Research",
	    "Marketing",
	    "Directives",
	    "Implementation",
	    "Integration",
	    "Functionality",
	    "Response",
	    "Paradigm",
	    "Tactics",
	    "Identity",
	    "Markets",
	    "Group",
	    "Division",
	    "Applications",
	    "Optimization",
	    "Operations",
	    "Infrastructure",
	    "Intranet",
	    "Communications",
	    "Web",
	    "Branding",
	    "Quality",
	    "Assurance",
	    "Mobility",
	    "Accounts",
	    "Data",
	    "Creative",
	    "Configuration",
	    "Accountability",
	    "Interactions",
	    "Factors",
	    "Usability",
	    "Metrics"
	  ],
	  "job": [
	    "Supervisor",
	    "Associate",
	    "Executive",
	    "Liason",
	    "Officer",
	    "Manager",
	    "Engineer",
	    "Specialist",
	    "Director",
	    "Coordinator",
	    "Administrator",
	    "Architect",
	    "Analyst",
	    "Designer",
	    "Planner",
	    "Orchestrator",
	    "Technician",
	    "Developer",
	    "Producer",
	    "Consultant",
	    "Assistant",
	    "Facilitator",
	    "Agent",
	    "Representative",
	    "Strategist"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "09## ### ###",
	  "0## #### ####",
	  "0# #### ####",
	  "+421 ### ### ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1142);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###",
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Söder",
	  "Norr",
	  "Väst",
	  "Öster",
	  "Aling",
	  "Ar",
	  "Av",
	  "Bo",
	  "Br",
	  "Bå",
	  "Ek",
	  "En",
	  "Esk",
	  "Fal",
	  "Gäv",
	  "Göte",
	  "Ha",
	  "Helsing",
	  "Karl",
	  "Krist",
	  "Kram",
	  "Kung",
	  "Kö",
	  "Lyck",
	  "Ny"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "stad",
	  "land",
	  "sås",
	  "ås",
	  "holm",
	  "tuna",
	  "sta",
	  "berg",
	  "löv",
	  "borg",
	  "mora",
	  "hamn",
	  "fors",
	  "köping",
	  "by",
	  "hult",
	  "torp",
	  "fred",
	  "vik"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "s Väg",
	  "s Gata"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ryssland",
	  "Kanada",
	  "Kina",
	  "USA",
	  "Brasilien",
	  "Australien",
	  "Indien",
	  "Argentina",
	  "Kazakstan",
	  "Algeriet",
	  "DR Kongo",
	  "Danmark",
	  "Färöarna",
	  "Grönland",
	  "Saudiarabien",
	  "Mexiko",
	  "Indonesien",
	  "Sudan",
	  "Libyen",
	  "Iran",
	  "Mongoliet",
	  "Peru",
	  "Tchad",
	  "Niger",
	  "Angola",
	  "Mali",
	  "Sydafrika",
	  "Colombia",
	  "Etiopien",
	  "Bolivia",
	  "Mauretanien",
	  "Egypten",
	  "Tanzania",
	  "Nigeria",
	  "Venezuela",
	  "Namibia",
	  "Pakistan",
	  "Moçambique",
	  "Turkiet",
	  "Chile",
	  "Zambia",
	  "Marocko",
	  "Västsahara",
	  "Burma",
	  "Afghanistan",
	  "Somalia",
	  "Centralafrikanska republiken",
	  "Sydsudan",
	  "Ukraina",
	  "Botswana",
	  "Madagaskar",
	  "Kenya",
	  "Frankrike",
	  "Franska Guyana",
	  "Jemen",
	  "Thailand",
	  "Spanien",
	  "Turkmenistan",
	  "Kamerun",
	  "Papua Nya Guinea",
	  "Sverige",
	  "Uzbekistan",
	  "Irak",
	  "Paraguay",
	  "Zimbabwe",
	  "Japan",
	  "Tyskland",
	  "Kongo",
	  "Finland",
	  "Malaysia",
	  "Vietnam",
	  "Norge",
	  "Svalbard",
	  "Jan Mayen",
	  "Elfenbenskusten",
	  "Polen",
	  "Italien",
	  "Filippinerna",
	  "Ecuador",
	  "Burkina Faso",
	  "Nya Zeeland",
	  "Gabon",
	  "Guinea",
	  "Storbritannien",
	  "Ghana",
	  "Rumänien",
	  "Laos",
	  "Uganda",
	  "Guyana",
	  "Oman",
	  "Vitryssland",
	  "Kirgizistan",
	  "Senegal",
	  "Syrien",
	  "Kambodja",
	  "Uruguay",
	  "Tunisien",
	  "Surinam",
	  "Nepal",
	  "Bangladesh",
	  "Tadzjikistan",
	  "Grekland",
	  "Nicaragua",
	  "Eritrea",
	  "Nordkorea",
	  "Malawi",
	  "Benin",
	  "Honduras",
	  "Liberia",
	  "Bulgarien",
	  "Kuba",
	  "Guatemala",
	  "Island",
	  "Sydkorea",
	  "Ungern",
	  "Portugal",
	  "Jordanien",
	  "Serbien",
	  "Azerbajdzjan",
	  "Österrike",
	  "Förenade Arabemiraten",
	  "Tjeckien",
	  "Panama",
	  "Sierra Leone",
	  "Irland",
	  "Georgien",
	  "Sri Lanka",
	  "Litauen",
	  "Lettland",
	  "Togo",
	  "Kroatien",
	  "Bosnien och Hercegovina",
	  "Costa Rica",
	  "Slovakien",
	  "Dominikanska republiken",
	  "Bhutan",
	  "Estland",
	  "Danmark",
	  "Färöarna",
	  "Grönland",
	  "Nederländerna",
	  "Schweiz",
	  "Guinea-Bissau",
	  "Taiwan",
	  "Moldavien",
	  "Belgien",
	  "Lesotho",
	  "Armenien",
	  "Albanien",
	  "Salomonöarna",
	  "Ekvatorialguinea",
	  "Burundi",
	  "Haiti",
	  "Rwanda",
	  "Makedonien",
	  "Djibouti",
	  "Belize",
	  "Israel",
	  "El Salvador",
	  "Slovenien",
	  "Fiji",
	  "Kuwait",
	  "Swaziland",
	  "Timor-Leste",
	  "Montenegro",
	  "Bahamas",
	  "Vanuatu",
	  "Qatar",
	  "Gambia",
	  "Jamaica",
	  "Kosovo",
	  "Libanon",
	  "Cypern",
	  "Brunei",
	  "Trinidad och Tobago",
	  "Kap Verde",
	  "Samoa",
	  "Luxemburg",
	  "Komorerna",
	  "Mauritius",
	  "São Tomé och Príncipe",
	  "Kiribati",
	  "Dominica",
	  "Tonga",
	  "Mikronesiens federerade stater",
	  "Singapore",
	  "Bahrain",
	  "Saint Lucia",
	  "Andorra",
	  "Palau",
	  "Seychellerna",
	  "Antigua och Barbuda",
	  "Barbados",
	  "Saint Vincent och Grenadinerna",
	  "Grenada",
	  "Malta",
	  "Maldiverna",
	  "Saint Kitts och Nevis",
	  "Marshallöarna",
	  "Liechtenstein",
	  "San Marino",
	  "Tuvalu",
	  "Nauru",
	  "Monaco",
	  "Vatikanstaten"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Sverige"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(1146);
	address.city_suffix = __webpack_require__(1147);
	address.country = __webpack_require__(1149);
	address.common_street_suffix = __webpack_require__(1148);
	address.street_prefix = __webpack_require__(1157);
	address.street_root = __webpack_require__(1158);
	address.street_suffix = __webpack_require__(1159);
	address.state = __webpack_require__(1154);
	address.city = __webpack_require__(1145);
	address.street_name = __webpack_require__(1156);
	address.postcode = __webpack_require__(1152);
	address.building_number = __webpack_require__(1144);
	address.secondary_address = __webpack_require__(1153);
	address.street_address = __webpack_require__(1155);
	address.default_country = __webpack_require__(1150);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Lgh. ###",
	  "Hus ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Blekinge",
	  "Dalarna",
	  "Gotland",
	  "Gävleborg",
	  "Göteborg",
	  "Halland",
	  "Jämtland",
	  "Jönköping",
	  "Kalmar",
	  "Kronoberg",
	  "Norrbotten",
	  "Skaraborg",
	  "Skåne",
	  "Stockholm",
	  "Södermanland",
	  "Uppsala",
	  "Värmland",
	  "Västerbotten",
	  "Västernorrland",
	  "Västmanland",
	  "Älvsborg",
	  "Örebro",
	  "Östergötland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}#{street_suffix}",
	  "#{street_prefix} #{street_root}#{street_suffix}",
	  "#{Name.first_name}#{common_street_suffix}",
	  "#{Name.last_name}#{common_street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Västra",
	  "Östra",
	  "Norra",
	  "Södra",
	  "Övre",
	  "Undre"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Björk",
	  "Järnvägs",
	  "Ring",
	  "Skol",
	  "Skogs",
	  "Ny",
	  "Gran",
	  "Idrotts",
	  "Stor",
	  "Kyrk",
	  "Industri",
	  "Park",
	  "Strand",
	  "Skol",
	  "Trädgård",
	  "Ängs",
	  "Kyrko",
	  "Villa",
	  "Ek",
	  "Kvarn",
	  "Stations",
	  "Back",
	  "Furu",
	  "Gen",
	  "Fabriks",
	  "Åker",
	  "Bäck",
	  "Asp"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "vägen",
	  "gatan",
	  "gränden",
	  "gärdet",
	  "allén"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  56,
	  62,
	  59
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{common_cell_prefix}-###-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.common_cell_prefix = __webpack_require__(1160);
	cell_phone.formats = __webpack_require__(1161);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "vit",
	  "silver",
	  "grå",
	  "svart",
	  "röd",
	  "grön",
	  "blå",
	  "gul",
	  "lila",
	  "indigo",
	  "guld",
	  "brun",
	  "rosa",
	  "purpur",
	  "korall"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Böcker",
	  "Filmer",
	  "Musik",
	  "Spel",
	  "Elektronik",
	  "Datorer",
	  "Hem",
	  "Trädgård",
	  "Verktyg",
	  "Livsmedel",
	  "Hälsa",
	  "Skönhet",
	  "Leksaker",
	  "Klädsel",
	  "Skor",
	  "Smycken",
	  "Sport"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var commerce = {};
	module['exports'] = commerce;
	commerce.color = __webpack_require__(1163);
	commerce.department = __webpack_require__(1164);
	commerce.product_name = __webpack_require__(1166);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "adjective": [
	    "Liten",
	    "Ergonomisk",
	    "Robust",
	    "Intelligent",
	    "Söt",
	    "Otrolig",
	    "Fatastisk",
	    "Praktisk",
	    "Slimmad",
	    "Grym"
	  ],
	  "material": [
	    "Stål",
	    "Metall",
	    "Trä",
	    "Betong",
	    "Plast",
	    "Bomul",
	    "Grnit",
	    "Gummi",
	    "Latex"
	  ],
	  "product": [
	    "Stol",
	    "Bil",
	    "Dator",
	    "Handskar",
	    "Pants",
	    "Shirt",
	    "Table",
	    "Shoes",
	    "Hat"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(1169);
	company.name = __webpack_require__(1168);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} #{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Gruppen",
	  "AB",
	  "HB",
	  "Group",
	  "Investment",
	  "Kommanditbolag",
	  "Aktiebolag"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var date = {};
	module["exports"] = date;
	date.month = __webpack_require__(1171);
	date.weekday = __webpack_require__(1172);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// Source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/en.xml#L1799
	module["exports"] = {
	  wide: [
	    "januari",
	    "februari",
	    "mars",
	    "april",
	    "maj",
	    "juni",
	    "juli",
	    "augusti",
	    "september",
	    "oktober",
	    "november",
	    "december"
	  ],
	  abbr: [
	    "jan",
	    "feb",
	    "mar",
	    "apr",
	    "maj",
	    "jun",
	    "jul",
	    "aug",
	    "sep",
	    "okt",
	    "nov",
	    "dec"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// Source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/en.xml#L1847
	module["exports"] = {
	  wide: [
	    "söndag",
	    "måndag",
	    "tisdag",
	    "onsdag",
	    "torsdag",
	    "fredag",
	    "lördag"
	  ],
	  abbr: [
	    "sön",
	    "mån",
	    "tis",
	    "ons",
	    "tor",
	    "fre",
	    "lör"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var sv = {};
	module['exports'] = sv;
	sv.title = "Swedish";
	sv.address = __webpack_require__(1151);
	sv.company = __webpack_require__(1167);
	sv.internet = __webpack_require__(1175);
	sv.name = __webpack_require__(1178);
	sv.phone_number = __webpack_require__(1184);
	sv.cell_phone = __webpack_require__(1162);
	sv.commerce = __webpack_require__(1165);
	sv.team = __webpack_require__(1185);
	sv.date = __webpack_require__(1170);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "se",
	  "nu",
	  "info",
	  "com",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(1174);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Erik",
	  "Lars",
	  "Karl",
	  "Anders",
	  "Per",
	  "Johan",
	  "Nils",
	  "Lennart",
	  "Emil",
	  "Hans"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Maria",
	  "Anna",
	  "Margareta",
	  "Elisabeth",
	  "Eva",
	  "Birgitta",
	  "Kristina",
	  "Karin",
	  "Elisabet",
	  "Marie"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name_women = __webpack_require__(1177);
	name.first_name_men = __webpack_require__(1176);
	name.last_name = __webpack_require__(1179);
	name.prefix = __webpack_require__(1181);
	name.title = __webpack_require__(1182);
	name.name = __webpack_require__(1180);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Johansson",
	  "Andersson",
	  "Karlsson",
	  "Nilsson",
	  "Eriksson",
	  "Larsson",
	  "Olsson",
	  "Persson",
	  "Svensson",
	  "Gustafsson"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{first_name_women} #{last_name}",
	  "#{first_name_men} #{last_name}",
	  "#{first_name_women} #{last_name}",
	  "#{first_name_men} #{last_name}",
	  "#{first_name_women} #{last_name}",
	  "#{first_name_men} #{last_name}",
	  "#{prefix} #{first_name_men} #{last_name}",
	  "#{prefix} #{first_name_women} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Dr.",
	  "Prof.",
	  "PhD."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "Lead",
	    "Senior",
	    "Direct",
	    "Corporate",
	    "Dynamic",
	    "Future",
	    "Product",
	    "National",
	    "Regional",
	    "District",
	    "Central",
	    "Global",
	    "Customer",
	    "Investor",
	    "Dynamic",
	    "International",
	    "Legacy",
	    "Forward",
	    "Internal",
	    "Human",
	    "Chief",
	    "Principal"
	  ],
	  "level": [
	    "Solutions",
	    "Program",
	    "Brand",
	    "Security",
	    "Research",
	    "Marketing",
	    "Directives",
	    "Implementation",
	    "Integration",
	    "Functionality",
	    "Response",
	    "Paradigm",
	    "Tactics",
	    "Identity",
	    "Markets",
	    "Group",
	    "Division",
	    "Applications",
	    "Optimization",
	    "Operations",
	    "Infrastructure",
	    "Intranet",
	    "Communications",
	    "Web",
	    "Branding",
	    "Quality",
	    "Assurance",
	    "Mobility",
	    "Accounts",
	    "Data",
	    "Creative",
	    "Configuration",
	    "Accountability",
	    "Interactions",
	    "Factors",
	    "Usability",
	    "Metrics"
	  ],
	  "job": [
	    "Supervisor",
	    "Associate",
	    "Executive",
	    "Liason",
	    "Officer",
	    "Manager",
	    "Engineer",
	    "Specialist",
	    "Director",
	    "Coordinator",
	    "Administrator",
	    "Architect",
	    "Analyst",
	    "Designer",
	    "Planner",
	    "Orchestrator",
	    "Technician",
	    "Developer",
	    "Producer",
	    "Consultant",
	    "Assistant",
	    "Facilitator",
	    "Agent",
	    "Representative",
	    "Strategist"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####-#####",
	  "####-######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1183);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var team = {};
	module['exports'] = team;
	team.suffix = __webpack_require__(1187);
	team.name = __webpack_require__(1186);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Address.city} #{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "IF",
	  "FF",
	  "BK",
	  "HK",
	  "AIF",
	  "SK",
	  "FC",
	  "SK",
	  "BoIS",
	  "FK",
	  "BIS",
	  "FIF",
	  "IK"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###",
	  "##",
	  "#",
	  "##a",
	  "##b",
	  "##c"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adana",
	  "Adıyaman",
	  "Afyon",
	  "Ağrı",
	  "Amasya",
	  "Ankara",
	  "Antalya",
	  "Artvin",
	  "Aydın",
	  "Balıkesir",
	  "Bilecik",
	  "Bingöl",
	  "Bitlis",
	  "Bolu",
	  "Burdur",
	  "Bursa",
	  "Çanakkale",
	  "Çankırı",
	  "Çorum",
	  "Denizli",
	  "Diyarbakır",
	  "Edirne",
	  "Elazığ",
	  "Erzincan",
	  "Erzurum",
	  "Eskişehir",
	  "Gaziantep",
	  "Giresun",
	  "Gümüşhane",
	  "Hakkari",
	  "Hatay",
	  "Isparta",
	  "İçel (Mersin)",
	  "İstanbul",
	  "İzmir",
	  "Kars",
	  "Kastamonu",
	  "Kayseri",
	  "Kırklareli",
	  "Kırşehir",
	  "Kocaeli",
	  "Konya",
	  "Kütahya",
	  "Malatya",
	  "Manisa",
	  "K.maraş",
	  "Mardin",
	  "Muğla",
	  "Muş",
	  "Nevşehir",
	  "Niğde",
	  "Ordu",
	  "Rize",
	  "Sakarya",
	  "Samsun",
	  "Siirt",
	  "Sinop",
	  "Sivas",
	  "Tekirdağ",
	  "Tokat",
	  "Trabzon",
	  "Tunceli",
	  "Şanlıurfa",
	  "Uşak",
	  "Van",
	  "Yozgat",
	  "Zonguldak",
	  "Aksaray",
	  "Bayburt",
	  "Karaman",
	  "Kırıkkale",
	  "Batman",
	  "Şırnak",
	  "Bartın",
	  "Ardahan",
	  "Iğdır",
	  "Yalova",
	  "Karabük",
	  "Kilis",
	  "Osmaniye",
	  "Düzce"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afganistan",
	  "Almanya",
	  "Amerika Birleşik Devletleri",
	  "Amerikan Samoa",
	  "Andorra",
	  "Angola",
	  "Anguilla, İngiltere",
	  "Antigua ve Barbuda",
	  "Arjantin",
	  "Arnavutluk",
	  "Aruba, Hollanda",
	  "Avustralya",
	  "Avusturya",
	  "Azerbaycan",
	  "Bahama Adaları",
	  "Bahreyn",
	  "Bangladeş",
	  "Barbados",
	  "Belçika",
	  "Belize",
	  "Benin",
	  "Bermuda, İngiltere",
	  "Beyaz Rusya",
	  "Bhutan",
	  "Birleşik Arap Emirlikleri",
	  "Birmanya (Myanmar)",
	  "Bolivya",
	  "Bosna Hersek",
	  "Botswana",
	  "Brezilya",
	  "Brunei",
	  "Bulgaristan",
	  "Burkina Faso",
	  "Burundi",
	  "Cape Verde",
	  "Cayman Adaları, İngiltere",
	  "Cebelitarık, İngiltere",
	  "Cezayir",
	  "Christmas Adası , Avusturalya",
	  "Cibuti",
	  "Çad",
	  "Çek Cumhuriyeti",
	  "Çin",
	  "Danimarka",
	  "Doğu Timor",
	  "Dominik Cumhuriyeti",
	  "Dominika",
	  "Ekvator",
	  "Ekvator Ginesi",
	  "El Salvador",
	  "Endonezya",
	  "Eritre",
	  "Ermenistan",
	  "Estonya",
	  "Etiyopya",
	  "Fas",
	  "Fiji",
	  "Fildişi Sahili",
	  "Filipinler",
	  "Filistin",
	  "Finlandiya",
	  "Folkland Adaları, İngiltere",
	  "Fransa",
	  "Fransız Guyanası",
	  "Fransız Güney Eyaletleri (Kerguelen Adaları)",
	  "Fransız Polinezyası",
	  "Gabon",
	  "Galler",
	  "Gambiya",
	  "Gana",
	  "Gine",
	  "Gine-Bissau",
	  "Grenada",
	  "Grönland",
	  "Guadalup, Fransa",
	  "Guam, Amerika",
	  "Guatemala",
	  "Guyana",
	  "Güney Afrika",
	  "Güney Georgia ve Güney Sandviç Adaları, İngiltere",
	  "Güney Kıbrıs Rum Yönetimi",
	  "Güney Kore",
	  "Gürcistan H",
	  "Haiti",
	  "Hırvatistan",
	  "Hindistan",
	  "Hollanda",
	  "Hollanda Antilleri",
	  "Honduras",
	  "Irak",
	  "İngiltere",
	  "İran",
	  "İrlanda",
	  "İspanya",
	  "İsrail",
	  "İsveç",
	  "İsviçre",
	  "İtalya",
	  "İzlanda",
	  "Jamaika",
	  "Japonya",
	  "Johnston Atoll, Amerika",
	  "K.K.T.C.",
	  "Kamboçya",
	  "Kamerun",
	  "Kanada",
	  "Kanarya Adaları",
	  "Karadağ",
	  "Katar",
	  "Kazakistan",
	  "Kenya",
	  "Kırgızistan",
	  "Kiribati",
	  "Kolombiya",
	  "Komorlar",
	  "Kongo",
	  "Kongo Demokratik Cumhuriyeti",
	  "Kosova",
	  "Kosta Rika",
	  "Kuveyt",
	  "Kuzey İrlanda",
	  "Kuzey Kore",
	  "Kuzey Maryana Adaları",
	  "Küba",
	  "Laos",
	  "Lesotho",
	  "Letonya",
	  "Liberya",
	  "Libya",
	  "Liechtenstein",
	  "Litvanya",
	  "Lübnan",
	  "Lüksemburg",
	  "Macaristan",
	  "Madagaskar",
	  "Makau (Makao)",
	  "Makedonya",
	  "Malavi",
	  "Maldiv Adaları",
	  "Malezya",
	  "Mali",
	  "Malta",
	  "Marşal Adaları",
	  "Martinik, Fransa",
	  "Mauritius",
	  "Mayotte, Fransa",
	  "Meksika",
	  "Mısır",
	  "Midway Adaları, Amerika",
	  "Mikronezya",
	  "Moğolistan",
	  "Moldavya",
	  "Monako",
	  "Montserrat",
	  "Moritanya",
	  "Mozambik",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Nijer",
	  "Nijerya",
	  "Nikaragua",
	  "Niue, Yeni Zelanda",
	  "Norveç",
	  "Orta Afrika Cumhuriyeti",
	  "Özbekistan",
	  "Pakistan",
	  "Palau Adaları",
	  "Palmyra Atoll, Amerika",
	  "Panama",
	  "Papua Yeni Gine",
	  "Paraguay",
	  "Peru",
	  "Polonya",
	  "Portekiz",
	  "Porto Riko, Amerika",
	  "Reunion, Fransa",
	  "Romanya",
	  "Ruanda",
	  "Rusya Federasyonu",
	  "Saint Helena, İngiltere",
	  "Saint Martin, Fransa",
	  "Saint Pierre ve Miquelon, Fransa",
	  "Samoa",
	  "San Marino",
	  "Santa Kitts ve Nevis",
	  "Santa Lucia",
	  "Santa Vincent ve Grenadinler",
	  "Sao Tome ve Principe",
	  "Senegal",
	  "Seyşeller",
	  "Sırbistan",
	  "Sierra Leone",
	  "Singapur",
	  "Slovakya",
	  "Slovenya",
	  "Solomon Adaları",
	  "Somali",
	  "Sri Lanka",
	  "Sudan",
	  "Surinam",
	  "Suriye",
	  "Suudi Arabistan",
	  "Svalbard, Norveç",
	  "Svaziland",
	  "Şili",
	  "Tacikistan",
	  "Tanzanya",
	  "Tayland",
	  "Tayvan",
	  "Togo",
	  "Tonga",
	  "Trinidad ve Tobago",
	  "Tunus",
	  "Turks ve Caicos Adaları, İngiltere",
	  "Tuvalu",
	  "Türkiye",
	  "Türkmenistan",
	  "Uganda",
	  "Ukrayna",
	  "Umman",
	  "Uruguay",
	  "Ürdün",
	  "Vallis ve Futuna, Fransa",
	  "Vanuatu",
	  "Venezuela",
	  "Vietnam",
	  "Virgin Adaları, Amerika",
	  "Virgin Adaları, İngiltere",
	  "Wake Adaları, Amerika",
	  "Yemen",
	  "Yeni Kaledonya, Fransa",
	  "Yeni Zelanda",
	  "Yunanistan",
	  "Zambiya",
	  "Zimbabve"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Türkiye"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city = __webpack_require__(1189);
	address.street_root = __webpack_require__(1196);
	address.country = __webpack_require__(1190);
	address.postcode = __webpack_require__(1193);
	address.default_country = __webpack_require__(1191);
	address.building_number = __webpack_require__(1188);
	address.street_name = __webpack_require__(1195);
	address.street_address = __webpack_require__(1194);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Atatürk Bulvarı",
	  "Alparslan Türkeş Bulvarı",
	  "Ali Çetinkaya Caddesi",
	  "Tevfik Fikret Caddesi",
	  "Kocatepe Caddesi",
	  "İsmet Paşa Caddesi",
	  "30 Ağustos Caddesi",
	  "İsmet Attila Caddesi",
	  "Namık Kemal Caddesi",
	  "Lütfi Karadirek Caddesi",
	  "Sarıkaya Caddesi",
	  "Yunus Emre Sokak",
	  "Dar Sokak",
	  "Fatih Sokak ",
	  "Harman Yolu Sokak ",
	  "Ergenekon Sokak  ",
	  "Ülkü Sokak",
	  "Sağlık Sokak",
	  "Okul Sokak",
	  "Harman Altı Sokak",
	  "Kaldırım Sokak",
	  "Mevlana Sokak",
	  "Gül Sokak",
	  "Sıran Söğüt Sokak",
	  "Güven Yaka Sokak",
	  "Saygılı Sokak",
	  "Menekşe Sokak",
	  "Dağınık Evler Sokak",
	  "Sevgi Sokak",
	  "Afyon Kaya Sokak",
	  "Oğuzhan Sokak",
	  "İbn-i Sina Sokak",
	  "Okul Sokak",
	  "Bahçe Sokak",
	  "Köypınar Sokak",
	  "Kekeçoğlu Sokak",
	  "Barış Sokak",
	  "Bayır Sokak",
	  "Kerimoğlu Sokak",
	  "Nalbant Sokak",
	  "Bandak Sokak"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "+90-53#-###-##-##",
	  "+90-54#-###-##-##",
	  "+90-55#-###-##-##",
	  "+90-50#-###-##-##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(1197);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var tr = {};
	module['exports'] = tr;
	tr.title = "Turkish";
	tr.address = __webpack_require__(1192);
	tr.internet = __webpack_require__(1201);
	tr.lorem = __webpack_require__(1202);
	tr.phone_number = __webpack_require__(1211);
	tr.cell_phone = __webpack_require__(1198);
	tr.name = __webpack_require__(1205);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com.tr",
	  "com",
	  "biz",
	  "info",
	  "name",
	  "gov.tr"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(1200);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(1203);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aba",
	  "Abak",
	  "Abaka",
	  "Abakan",
	  "Abakay",
	  "Abar",
	  "Abay",
	  "Abı",
	  "Abılay",
	  "Abluç",
	  "Abşar",
	  "Açığ",
	  "Açık",
	  "Açuk",
	  "Adalan",
	  "Adaldı",
	  "Adalmış",
	  "Adar",
	  "Adaş",
	  "Adberilgen",
	  "Adıgüzel",
	  "Adık",
	  "Adıkutlu",
	  "Adıkutlutaş",
	  "Adlı",
	  "Adlıbeğ",
	  "Adraman",
	  "Adsız",
	  "Afşar",
	  "Afşın",
	  "Ağabay",
	  "Ağakağan",
	  "Ağalak",
	  "Ağlamış",
	  "Ak",
	  "Akaş",
	  "Akata",
	  "Akbaş",
	  "Akbay",
	  "Akboğa",
	  "Akbörü",
	  "Akbudak",
	  "Akbuğra",
	  "Akbulak",
	  "Akça",
	  "Akçakoca",
	  "Akçora",
	  "Akdemir",
	  "Akdoğan",
	  "Akı",
	  "Akıbudak",
	  "Akım",
	  "Akın",
	  "Akınçı",
	  "Akkun",
	  "Akkunlu",
	  "Akkurt",
	  "Akkuş",
	  "Akpıra",
	  "Aksungur",
	  "Aktan",
	  "Al",
	  "Ala",
	  "Alaban",
	  "Alabörü",
	  "Aladağ",
	  "Aladoğan",
	  "Alakurt",
	  "Alayunt",
	  "Alayuntlu",
	  "Aldemir",
	  "Aldıgerey",
	  "Aldoğan",
	  "Algu",
	  "Alımga",
	  "Alka",
	  "Alkabölük",
	  "Alkaevli",
	  "Alkan",
	  "Alkaşı",
	  "Alkış",
	  "Alp",
	  "Alpagut",
	  "Alpamış",
	  "Alparsbeğ",
	  "Alparslan",
	  "Alpata",
	  "Alpay",
	  "Alpaya",
	  "Alpaykağan",
	  "Alpbamsı",
	  "Alpbilge",
	  "Alpdirek",
	  "Alpdoğan",
	  "Alper",
	  "Alperen",
	  "Alpertunga",
	  "Alpgerey",
	  "Alpış",
	  "Alpilig",
	  "Alpkara",
	  "Alpkutlu",
	  "Alpkülük",
	  "Alpşalçı",
	  "Alptegin",
	  "Alptuğrul",
	  "Alptunga",
	  "Alpturan",
	  "Alptutuk",
	  "Alpuluğ",
	  "Alpurungu",
	  "Alpurungututuk",
	  "Alpyörük",
	  "Altan",
	  "Altankağan",
	  "Altankan",
	  "Altay",
	  "Altın",
	  "Altınkağan",
	  "Altınkan",
	  "Altınoba",
	  "Altıntamgan",
	  "Altıntamgantarkan",
	  "Altıntarkan",
	  "Altıntay",
	  "Altmışkara",
	  "Altuga",
	  "Amaç",
	  "Amrak",
	  "Amul",
	  "Ançuk",
	  "Andarıman",
	  "Anıl",
	  "Ant",
	  "Apa",
	  "Apak",
	  "Apatarkan",
	  "Aprançur",
	  "Araboğa",
	  "Arademir",
	  "Aral",
	  "Arbay",
	  "Arbuz",
	  "Arçuk",
	  "Ardıç",
	  "Argıl",
	  "Argu",
	  "Argun",
	  "Arı",
	  "Arıboğa",
	  "Arık",
	  "Arıkağan",
	  "Arıkdoruk",
	  "Arınç",
	  "Arkın",
	  "Arkış",
	  "Armağan",
	  "Arnaç",
	  "Arpat",
	  "Arsal",
	  "Arsıl",
	  "Arslan",
	  "Arslanargun",
	  "Arslanbörü",
	  "Arslansungur",
	  "Arslantegin",
	  "Arslanyabgu",
	  "Arşun",
	  "Artıınal",
	  "Artuk",
	  "Artukaç",
	  "Artut",
	  "Aruk",
	  "Asartegin",
	  "Asığ",
	  "Asrı",
	  "Asuğ",
	  "Aşan",
	  "Aşanboğa",
	  "Aşantuğrul",
	  "Aşantudun",
	  "Aşıkbulmuş",
	  "Aşkın",
	  "Aştaloğul",
	  "Aşuk",
	  "Ataç",
	  "Atakağan",
	  "Atakan",
	  "Atalan",
	  "Ataldı",
	  "Atalmış",
	  "Ataman",
	  "Atasagun",
	  "Atasu",
	  "Atberilgen",
	  "Atıgay",
	  "Atıkutlu",
	  "Atıkutlutaş",
	  "Atıla",
	  "Atılgan",
	  "Atım",
	  "Atımer",
	  "Atış",
	  "Atlı",
	  "Atlıbeğ",
	  "Atlıkağan",
	  "Atmaca",
	  "Atsız",
	  "Atunçu",
	  "Avar",
	  "Avluç",
	  "Avşar",
	  "Ay",
	  "Ayaçı",
	  "Ayas",
	  "Ayaş",
	  "Ayaz",
	  "Aybalta",
	  "Ayban",
	  "Aybars",
	  "Aybeğ",
	  "Aydarkağan",
	  "Aydemir",
	  "Aydın",
	  "Aydınalp",
	  "Aydoğan",
	  "Aydoğdu",
	  "Aydoğmuş",
	  "Aygırak",
	  "Ayıtmış",
	  "Ayız",
	  "Ayızdağ",
	  "Aykağan",
	  "Aykan",
	  "Aykurt",
	  "Ayluç",
	  "Ayluçtarkan",
	  "Ayma",
	  "Ayruk",
	  "Aysılığ",
	  "Aytak",
	  "Ayyıldız",
	  "Azak",
	  "Azban",
	  "Azgan",
	  "Azganaz",
	  "Azıl",
	  "Babır",
	  "Babur",
	  "Baçara",
	  "Baççayman",
	  "Baçman",
	  "Badabul",
	  "Badruk",
	  "Badur",
	  "Bağa",
	  "Bağaalp",
	  "Bağaışbara",
	  "Bağan",
	  "Bağaşatulu",
	  "Bağatarkan",
	  "Bağatengrikağan",
	  "Bağatur",
	  "Bağaturçigşi",
	  "Bağaturgerey",
	  "Bağaturipi",
	  "Bağatursepi",
	  "Bağış",
	  "Bağtaş",
	  "Bakağul",
	  "Bakır",
	  "Bakırsokum",
	  "Baksı",
	  "Bakşı",
	  "Balaban",
	  "Balaka",
	  "Balakatay",
	  "Balamır",
	  "Balçar",
	  "Baldu",
	  "Balkık",
	  "Balta",
	  "Baltacı",
	  "Baltar",
	  "Baltır",
	  "Baltur",
	  "Bamsı",
	  "Bangu",
	  "Barak",
	  "Baraktöre",
	  "Baran",
	  "Barbeğ",
	  "Barboğa",
	  "Barbol",
	  "Barbulsun",
	  "Barça",
	  "Barçadoğdu",
	  "Barçadoğmuş",
	  "Barçadurdu",
	  "Barçadurmuş",
	  "Barçan",
	  "Barçatoyun",
	  "Bardıbay",
	  "Bargan",
	  "Barımtay",
	  "Barın",
	  "Barkan",
	  "Barkdoğdu",
	  "Barkdoğmuş",
	  "Barkdurdu",
	  "Barkdurmuş",
	  "Barkın",
	  "Barlas",
	  "Barlıbay",
	  "Barmaklak",
	  "Barmaklı",
	  "Barman",
	  "Bars",
	  "Barsbeğ",
	  "Barsboğa",
	  "Barsgan",
	  "Barskan",
	  "Barsurungu",
	  "Bartu",
	  "Basademir",
	  "Basan",
	  "Basanyalavaç",
	  "Basar",
	  "Basat",
	  "Baskın",
	  "Basmıl",
	  "Bastı",
	  "Bastuğrul",
	  "Basu",
	  "Basut",
	  "Başak",
	  "Başbuğ",
	  "Başçı",
	  "Başgan",
	  "Başkırt",
	  "Başkurt",
	  "Baştar",
	  "Batrak",
	  "Batu",
	  "Batuk",
	  "Batur",
	  "Baturalp",
	  "Bay",
	  "Bayançar",
	  "Bayankağan",
	  "Bayat",
	  "Bayazıt",
	  "Baybars",
	  "Baybayık",
	  "Baybiçen",
	  "Bayboğa",
	  "Baybora",
	  "Baybüre",
	  "Baydar",
	  "Baydemir",
	  "Baydur",
	  "Bayık",
	  "Bayınçur",
	  "Bayındır",
	  "Baykal",
	  "Baykara",
	  "Baykoca",
	  "Baykuzu",
	  "Baymünke",
	  "Bayna",
	  "Baynal",
	  "Baypüre",
	  "Bayrı",
	  "Bayraç",
	  "Bayrak",
	  "Bayram",
	  "Bayrın",
	  "Bayruk",
	  "Baysungur",
	  "Baytara",
	  "Baytaş",
	  "Bayunçur",
	  "Bayur",
	  "Bayurku",
	  "Bayutmuş",
	  "Bayuttu",
	  "Bazır",
	  "Beçeapa",
	  "Beçkem",
	  "Beğ",
	  "Beğarslan",
	  "Beğbars",
	  "Beğbilgeçikşin",
	  "Beğboğa",
	  "Beğçur",
	  "Beğdemir",
	  "Beğdilli",
	  "Beğdurmuş",
	  "Beğkulu",
	  "Beğtaş",
	  "Beğtegin",
	  "Beğtüzün",
	  "Begi",
	  "Begil",
	  "Begine",
	  "Begitutuk",
	  "Beglen",
	  "Begni",
	  "Bek",
	  "Bekazıl",
	  "Bekbekeç",
	  "Bekeç",
	  "Bekeçarslan",
	  "Bekeçarslantegin",
	  "Bekeçtegin",
	  "Beker",
	  "Beklemiş",
	  "Bektür",
	  "Belçir",
	  "Belek",
	  "Belgi",
	  "Belgüc",
	  "Beltir",
	  "Bengi",
	  "Bengü",
	  "Benlidemir",
	  "Berdibeğ",
	  "Berendey",
	  "Bergü",
	  "Berginsenge",
	  "Berk",
	  "Berke",
	  "Berkiş",
	  "Berkyaruk",
	  "Bermek",
	  "Besentegin",
	  "Betemir",
	  "Beyizçi",
	  "Beyrek",
	  "Beyrem",
	  "Bıçkı",
	  "Bıçkıcı",
	  "Bıdın",
	  "Bıtaybıkı",
	  "Bıtrı",
	  "Biçek",
	  "Bilge",
	  "Bilgebayunçur",
	  "Bilgebeğ",
	  "Bilgeçikşin",
	  "Bilgeışbara",
	  "Bilgeışbaratamgan",
	  "Bilgekağan",
	  "Bilgekan",
	  "Bilgekutluk",
	  "Bilgekülüçur",
	  "Bilgetaçam",
	  "Bilgetamgacı",
	  "Bilgetardu",
	  "Bilgetegin",
	  "Bilgetonyukuk",
	  "Bilgez",
	  "Bilgiç",
	  "Bilgin",
	  "Bilig",
	  "Biligköngülsengün",
	  "Bilik",
	  "Binbeği",
	  "Bindir",
	  "Boğa",
	  "Boğaç",
	  "Boğaçuk",
	  "Boldaz",
	  "Bolmuş",
	  "Bolsun",
	  "Bolun",
	  "Boncuk",
	  "Bongul",
	  "Bongulboğa",
	  "Bora",
	  "Boran",
	  "Borçul",
	  "Borlukçu",
	  "Bornak",
	  "Boyan",
	  "Boyankulu",
	  "Boylabağa",
	  "Boylabağatarkan",
	  "Boylakutlutarkan",
	  "Bozan",
	  "Bozbörü",
	  "Bozdoğan",
	  "Bozkurt",
	  "Bozkuş",
	  "Bozok",
	  "Bögde",
	  "Böge",
	  "Bögü",
	  "Bökde",
	  "Bökde",
	  "Böke",
	  "Bölen",
	  "Bölükbaşı",
	  "Bönek",
	  "Bönge",
	  "Börü",
	  "Börübars",
	  "Börüsengün",
	  "Börteçine",
	  "Buçan",
	  "Buçur",
	  "Budağ",
	  "Budak",
	  "Budunlu",
	  "Buğday",
	  "Buğra",
	  "Buğrakarakağan",
	  "Bukak",
	  "Bukaktutuk",
	  "Bulaçapan",
	  "Bulak",
	  "Bulan",
	  "Buldur",
	  "Bulgak",
	  "Bulmaz",
	  "Bulmuş",
	  "Buluç",
	  "Buluğ",
	  "Buluk",
	  "Buluş",
	  "Bulut",
	  "Bumın",
	  "Bunsuz",
	  "Burçak",
	  "Burguçan",
	  "Burkay",
	  "Burslan",
	  "Burulday",
	  "Burulgu",
	  "Burunduk",
	  "Buşulgan",
	  "Butak",
	  "Butuk",
	  "Buyan",
	  "Buyançuk",
	  "Buyandemir",
	  "Buyankara",
	  "Buyat",
	  "Buyraç",
	  "Buyruç",
	  "Buyruk",
	  "Buzaç",
	  "Buzaçtutuk",
	  "Büdüs",
	  "Büdüstudun",
	  "Bügü",
	  "Bügdüz",
	  "Bügdüzemen",
	  "Büge",
	  "Büğübilge",
	  "Bükdüz",
	  "Büke",
	  "Bükebuyraç",
	  "Bükebuyruç",
	  "Bükey",
	  "Büktegin",
	  "Büküşboğa",
	  "Bümen",
	  "Bünül",
	  "Büre",
	  "Bürgüt",
	  "Bürkek",
	  "Bürküt",
	  "Bürlük",
	  "Cebe",
	  "Ceyhun",
	  "Cılasun",
	  "Çaba",
	  "Çabdar",
	  "Çablı",
	  "Çabuş",
	  "Çağan",
	  "Çağatay",
	  "Çağlar",
	  "Çağlayan",
	  "Çağrı",
	  "Çağrıbeğ",
	  "Çağrıtegin",
	  "Çağru",
	  "Çalapkulu",
	  "Çankız",
	  "Çemen",
	  "Çemgen",
	  "Çeykün",
	  "Çıngır",
	  "Çiçek",
	  "Çiçem",
	  "Çiğdem",
	  "Çilenti",
	  "Çimen",
	  "Çobulmak",
	  "Çocukbörü",
	  "Çokramayul",
	  "Çolman",
	  "Çolpan",
	  "Çölü",
	  "Damla",
	  "Deniz",
	  "Dilek",
	  "Diri",
	  "Dizik",
	  "Duru",
	  "Dururbunsuz",
	  "Duygu",
	  "Ebin",
	  "Ebkızı",
	  "Ebren",
	  "Edil",
	  "Ediz",
	  "Egemen",
	  "Eğrim",
	  "Ekeç",
	  "Ekim",
	  "Ekin",
	  "Elkin",
	  "Elti",
	  "Engin",
	  "Erdem",
	  "Erdeni",
	  "Erdeniözük",
	  "Erdenikatun",
	  "Erentüz",
	  "Ergene",
	  "Ergenekatun",
	  "Erinç",
	  "Erke",
	  "Ermen",
	  "Erten",
	  "Ertenözük",
	  "Esen",
	  "Esenbike",
	  "Eser",
	  "Esin",
	  "Etil",
	  "Evin",
	  "Eyiz",
	  "Gelin",
	  "Gelincik",
	  "Gökbörü",
	  "Gökçe",
	  "Gökçegöl",
	  "Gökçen",
	  "Gökçiçek",
	  "Gökşin",
	  "Gönül",
	  "Görün",
	  "Gözde",
	  "Gülegen",
	  "Gülemen",
	  "Güler",
	  "Gülümser",
	  "Gümüş",
	  "Gün",
	  "Günay",
	  "Günçiçek",
	  "Gündoğdu",
	  "Gündoğmuş",
	  "Güneş",
	  "Günyaruk",
	  "Gürbüz",
	  "Güvercin",
	  "Güzey",
	  "Işığ",
	  "Işık",
	  "Işıl",
	  "Işılay",
	  "Ila",
	  "Ilaçın",
	  "Ilgın",
	  "Inanç",
	  "Irmak",
	  "Isığ",
	  "Isık",
	  "Iyık",
	  "Iyıktağ",
	  "İdil",
	  "İkeme",
	  "İkiçitoyun",
	  "İlbilge",
	  "İldike",
	  "İlgegü",
	  "İmrem",
	  "İnci",
	  "İnç",
	  "İrinç",
	  "İrinçköl",
	  "İrtiş",
	  "İtil",
	  "Kancı",
	  "Kançı",
	  "Kapgar",
	  "Karaca",
	  "Karaça",
	  "Karak",
	  "Kargılaç",
	  "Karlıgaç",
	  "Katun",
	  "Katunkız",
	  "Kayacık",
	  "Kayaçık",
	  "Kayça",
	  "Kaynak",
	  "Kazanç",
	  "Kazkatun",
	  "Kekik",
	  "Keklik",
	  "Kepez",
	  "Kesme",
	  "Keyken",
	  "Kezlik",
	  "Kımız",
	  "Kımızın",
	  "Kımızalma",
	  "Kımızalmıla",
	  "Kırçiçek",
	  "Kırgavul",
	  "Kırlangıç",
	  "Kıvanç",
	  "Kıvılcım",
	  "Kızdurmuş",
	  "Kızılalma"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1204);
	name.last_name = __webpack_require__(1206);
	name.prefix = __webpack_require__(1208);
	name.name = __webpack_require__(1207);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abacı",
	  "Abadan",
	  "Aclan",
	  "Adal",
	  "Adan",
	  "Adıvar",
	  "Akal",
	  "Akan",
	  "Akar ",
	  "Akay",
	  "Akaydın",
	  "Akbulut",
	  "Akgül",
	  "Akışık",
	  "Akman",
	  "Akyürek",
	  "Akyüz",
	  "Akşit",
	  "Alnıaçık",
	  "Alpuğan",
	  "Alyanak",
	  "Arıcan",
	  "Arslanoğlu",
	  "Atakol",
	  "Atan",
	  "Avan",
	  "Ayaydın",
	  "Aybar",
	  "Aydan",
	  "Aykaç",
	  "Ayverdi",
	  "Ağaoğlu",
	  "Aşıkoğlu",
	  "Babacan",
	  "Babaoğlu",
	  "Bademci",
	  "Bakırcıoğlu",
	  "Balaban",
	  "Balcı",
	  "Barbarosoğlu",
	  "Baturalp",
	  "Baykam",
	  "Başoğlu",
	  "Berberoğlu",
	  "Beşerler",
	  "Beşok",
	  "Biçer",
	  "Bolatlı",
	  "Dalkıran",
	  "Dağdaş",
	  "Dağlaroğlu",
	  "Demirbaş",
	  "Demirel",
	  "Denkel",
	  "Dizdar ",
	  "Doğan ",
	  "Durak ",
	  "Durmaz",
	  "Duygulu",
	  "Düşenkalkar",
	  "Egeli",
	  "Ekici",
	  "Ekşioğlu",
	  "Eliçin",
	  "Elmastaşoğlu",
	  "Elçiboğa",
	  "Erbay",
	  "Erberk",
	  "Erbulak",
	  "Erdoğan",
	  "Erez",
	  "Erginsoy",
	  "Erkekli",
	  "Eronat",
	  "Ertepınar",
	  "Ertürk",
	  "Erçetin",
	  "Evliyaoğlu",
	  "Gönültaş",
	  "Gümüşpala",
	  "Günday",
	  "Gürmen",
	  "Hakyemez",
	  "Hamzaoğlu",
	  "Ilıcalı",
	  "Kahveci",
	  "Kaplangı",
	  "Karabulut",
	  "Karaböcek",
	  "Karadaş",
	  "Karaduman",
	  "Karaer",
	  "Kasapoğlu",
	  "Kavaklıoğlu",
	  "Kaya ",
	  "Keseroğlu",
	  "Keçeci",
	  "Kılıççı",
	  "Kıraç ",
	  "Kocabıyık",
	  "Korol",
	  "Koyuncu",
	  "Koç",
	  "Koçoğlu",
	  "Koçyiğit",
	  "Kuday",
	  "Kulaksızoğlu",
	  "Kumcuoğlu",
	  "Kunt",
	  "Kunter",
	  "Kurutluoğlu",
	  "Kutlay",
	  "Kuzucu",
	  "Körmükçü",
	  "Köybaşı",
	  "Köylüoğlu",
	  "Küçükler",
	  "Limoncuoğlu",
	  "Mayhoş",
	  "Menemencioğlu",
	  "Mertoğlu",
	  "Nalbantoğlu",
	  "Nebioğlu",
	  "Numanoğlu",
	  "Okumuş",
	  "Okur",
	  "Oraloğlu",
	  "Orbay",
	  "Ozansoy",
	  "Paksüt",
	  "Pekkan",
	  "Pektemek",
	  "Polat",
	  "Poyrazoğlu",
	  "Poçan",
	  "Sadıklar",
	  "Samancı",
	  "Sandalcı",
	  "Sarıoğlu",
	  "Saygıner",
	  "Sepetçi",
	  "Sezek",
	  "Sinanoğlu",
	  "Solmaz",
	  "Sözeri",
	  "Süleymanoğlu",
	  "Tahincioğlu",
	  "Tanrıkulu",
	  "Tazegül",
	  "Taşlı",
	  "Taşçı",
	  "Tekand",
	  "Tekelioğlu",
	  "Tokatlıoğlu",
	  "Tokgöz",
	  "Topaloğlu",
	  "Topçuoğlu",
	  "Toraman",
	  "Tunaboylu",
	  "Tunçeri",
	  "Tuğlu",
	  "Tuğluk",
	  "Türkdoğan",
	  "Türkyılmaz",
	  "Tütüncü",
	  "Tüzün",
	  "Uca",
	  "Uluhan",
	  "Velioğlu",
	  "Yalçın",
	  "Yazıcı",
	  "Yetkiner",
	  "Yeşilkaya",
	  "Yıldırım ",
	  "Yıldızoğlu",
	  "Yılmazer",
	  "Yorulmaz",
	  "Çamdalı",
	  "Çapanoğlu",
	  "Çatalbaş",
	  "Çağıran",
	  "Çetin",
	  "Çetiner",
	  "Çevik",
	  "Çörekçi",
	  "Önür",
	  "Örge",
	  "Öymen",
	  "Özberk",
	  "Özbey",
	  "Özbir",
	  "Özdenak",
	  "Özdoğan",
	  "Özgörkey",
	  "Özkara",
	  "Özkök ",
	  "Öztonga",
	  "Öztuna"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bay",
	  "Bayan",
	  "Dr.",
	  "Prof. Dr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "392",
	  "510",
	  "512",
	  "522",
	  "562",
	  "564",
	  "592",
	  "594",
	  "800",
	  "811",
	  "822",
	  "850",
	  "888",
	  "898",
	  "900",
	  "322",
	  "416",
	  "272",
	  "472",
	  "382",
	  "358",
	  "312",
	  "242",
	  "478",
	  "466",
	  "256",
	  "266",
	  "378",
	  "488",
	  "458",
	  "228",
	  "426",
	  "434",
	  "374",
	  "248",
	  "224",
	  "286",
	  "376",
	  "364",
	  "258",
	  "412",
	  "380",
	  "284",
	  "424",
	  "446",
	  "442",
	  "222",
	  "342",
	  "454",
	  "456",
	  "438",
	  "326",
	  "476",
	  "246",
	  "216",
	  "212",
	  "232",
	  "344",
	  "370",
	  "338",
	  "474",
	  "366",
	  "352",
	  "318",
	  "288",
	  "386",
	  "348",
	  "262",
	  "332",
	  "274",
	  "422",
	  "236",
	  "482",
	  "324",
	  "252",
	  "436",
	  "384",
	  "388",
	  "452",
	  "328",
	  "464",
	  "264",
	  "362",
	  "484",
	  "368",
	  "346",
	  "414",
	  "486",
	  "282",
	  "356",
	  "462",
	  "428",
	  "276",
	  "432",
	  "226",
	  "354",
	  "372"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "+90-###-###-##-##",
	  "+90-###-###-#-###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.area_code = __webpack_require__(1209);
	phone_number.formats = __webpack_require__(1210);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#",
	  "##",
	  "###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}",
	  "#{city_prefix} #{Name.male_first_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Алчевськ",
	  "Артемівськ",
	  "Бердичів",
	  "Бердянськ",
	  "Біла Церква",
	  "Бровари",
	  "Вінниця",
	  "Горлівка",
	  "Дніпродзержинськ",
	  "Дніпропетровськ",
	  "Донецьк",
	  "Євпаторія",
	  "Єнакієве",
	  "Житомир",
	  "Запоріжжя",
	  "Івано-Франківськ",
	  "Ізмаїл",
	  "Кам’янець-Подільський",
	  "Керч",
	  "Київ",
	  "Кіровоград",
	  "Конотоп",
	  "Краматорськ",
	  "Красний Луч",
	  "Кременчук",
	  "Кривий Ріг",
	  "Лисичанськ",
	  "Луганськ",
	  "Луцьк",
	  "Львів",
	  "Макіївка",
	  "Маріуполь",
	  "Мелітополь",
	  "Миколаїв",
	  "Мукачеве",
	  "Нікополь",
	  "Одеса",
	  "Олександрія",
	  "Павлоград",
	  "Полтава",
	  "Рівне",
	  "Севастополь",
	  "Сєвєродонецьк",
	  "Сімферополь",
	  "Слов’янськ",
	  "Суми",
	  "Тернопіль",
	  "Ужгород",
	  "Умань",
	  "Харків",
	  "Херсон",
	  "Хмельницький",
	  "Черкаси",
	  "Чернівці",
	  "Чернігів",
	  "Шостка",
	  "Ялта"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Південний",
	  "Північний",
	  "Східний",
	  "Західний"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "град"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Австралія",
	  "Австрія",
	  "Азербайджан",
	  "Албанія",
	  "Алжир",
	  "Ангола",
	  "Андорра",
	  "Антигуа і Барбуда",
	  "Аргентина",
	  "Афганістан",
	  "Багамські Острови",
	  "Бангладеш",
	  "Барбадос",
	  "Бахрейн",
	  "Беліз",
	  "Бельгія",
	  "Бенін",
	  "Білорусь",
	  "Болгарія",
	  "Болівія",
	  "Боснія і Герцеговина",
	  "Ботсвана",
	  "Бразилія",
	  "Бруней",
	  "Буркіна-Фасо",
	  "Бурунді",
	  "Бутан",
	  "В’єтнам",
	  "Вануату",
	  "Ватикан",
	  "Велика Британія",
	  "Венесуела",
	  "Вірменія",
	  "Габон",
	  "Гаїті",
	  "Гайана",
	  "Гамбія",
	  "Гана",
	  "Гватемала",
	  "Гвінея",
	  "Гвінея-Бісау",
	  "Гондурас",
	  "Гренада",
	  "Греція",
	  "Грузія",
	  "Данія",
	  "Демократична Республіка Конго",
	  "Джибуті",
	  "Домініка",
	  "Домініканська Республіка",
	  "Еквадор",
	  "Екваторіальна Гвінея",
	  "Еритрея",
	  "Естонія",
	  "Ефіопія",
	  "Єгипет",
	  "Ємен",
	  "Замбія",
	  "Зімбабве",
	  "Ізраїль",
	  "Індія",
	  "Індонезія",
	  "Ірак",
	  "Іран",
	  "Ірландія",
	  "Ісландія",
	  "Іспанія",
	  "Італія",
	  "Йорданія",
	  "Кабо-Верде",
	  "Казахстан",
	  "Камбоджа",
	  "Камерун",
	  "Канада",
	  "Катар",
	  "Кенія",
	  "Киргизстан",
	  "Китай",
	  "Кіпр",
	  "Кірибаті",
	  "Колумбія",
	  "Коморські Острови",
	  "Конго",
	  "Коста-Рика",
	  "Кот-д’Івуар",
	  "Куба",
	  "Кувейт",
	  "Лаос",
	  "Латвія",
	  "Лесото",
	  "Литва",
	  "Ліберія",
	  "Ліван",
	  "Лівія",
	  "Ліхтенштейн",
	  "Люксембург",
	  "Маврикій",
	  "Мавританія",
	  "Мадаґаскар",
	  "Македонія",
	  "Малаві",
	  "Малайзія",
	  "Малі",
	  "Мальдіви",
	  "Мальта",
	  "Марокко",
	  "Маршаллові Острови",
	  "Мексика",
	  "Мозамбік",
	  "Молдова",
	  "Монако",
	  "Монголія",
	  "Намібія",
	  "Науру",
	  "Непал",
	  "Нігер",
	  "Нігерія",
	  "Нідерланди",
	  "Нікарагуа",
	  "Німеччина",
	  "Нова Зеландія",
	  "Норвегія",
	  "Об’єднані Арабські Емірати",
	  "Оман",
	  "Пакистан",
	  "Палау",
	  "Панама",
	  "Папуа-Нова Гвінея",
	  "Парагвай",
	  "Перу",
	  "Південна Корея",
	  "Південний Судан",
	  "Південно-Африканська Республіка",
	  "Північна Корея",
	  "Польща",
	  "Португалія",
	  "Російська Федерація",
	  "Руанда",
	  "Румунія",
	  "Сальвадор",
	  "Самоа",
	  "Сан-Марино",
	  "Сан-Томе і Принсіпі",
	  "Саудівська Аравія",
	  "Свазіленд",
	  "Сейшельські Острови",
	  "Сенеґал",
	  "Сент-Вінсент і Гренадини",
	  "Сент-Кітс і Невіс",
	  "Сент-Люсія",
	  "Сербія",
	  "Сирія",
	  "Сінгапур",
	  "Словаччина",
	  "Словенія",
	  "Соломонові Острови",
	  "Сомалі",
	  "Судан",
	  "Суринам",
	  "Східний Тимор",
	  "США",
	  "Сьєрра-Леоне",
	  "Таджикистан",
	  "Таїланд",
	  "Танзанія",
	  "Того",
	  "Тонга",
	  "Тринідад і Тобаго",
	  "Тувалу",
	  "Туніс",
	  "Туреччина",
	  "Туркменістан",
	  "Уганда",
	  "Угорщина",
	  "Узбекистан",
	  "Україна",
	  "Уругвай",
	  "Федеративні Штати Мікронезії",
	  "Фіджі",
	  "Філіппіни",
	  "Фінляндія",
	  "Франція",
	  "Хорватія",
	  "Центральноафриканська Республіка",
	  "Чад",
	  "Чехія",
	  "Чилі",
	  "Чорногорія",
	  "Швейцарія",
	  "Швеція",
	  "Шрі-Ланка",
	  "Ямайка",
	  "Японія"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Україна"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.country = __webpack_require__(1217);
	address.building_number = __webpack_require__(1212);
	address.street_prefix = __webpack_require__(1225);
	address.street_suffix = __webpack_require__(1226);
	address.secondary_address = __webpack_require__(1221);
	address.postcode = __webpack_require__(1220);
	address.state = __webpack_require__(1222);
	address.street_title = __webpack_require__(1227);
	address.city_name = __webpack_require__(1214);
	address.city = __webpack_require__(1213);
	address.city_prefix = __webpack_require__(1215);
	address.city_suffix = __webpack_require__(1216);
	address.street_name = __webpack_require__(1224);
	address.street_address = __webpack_require__(1223);
	address.default_country = __webpack_require__(1218);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "кв. ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "АР Крим",
	  "Вінницька область",
	  "Волинська область",
	  "Дніпропетровська область",
	  "Донецька область",
	  "Житомирська область",
	  "Закарпатська область",
	  "Запорізька область",
	  "Івано-Франківська область",
	  "Київська область",
	  "Кіровоградська область",
	  "Луганська область",
	  "Львівська область",
	  "Миколаївська область",
	  "Одеська область",
	  "Полтавська область",
	  "Рівненська область",
	  "Сумська область",
	  "Тернопільська область",
	  "Харківська область",
	  "Херсонська область",
	  "Хмельницька область",
	  "Черкаська область",
	  "Чернівецька область",
	  "Чернігівська область",
	  "Київ",
	  "Севастополь"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name}, #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_prefix} #{Address.street_title}",
	  "#{Address.street_title} #{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "вул.",
	  "вулиця",
	  "пр.",
	  "проспект",
	  "пл.",
	  "площа",
	  "пров.",
	  "провулок"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "майдан"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Зелена",
	  "Молодіжна",
	  "Городоцька",
	  "Стрийська",
	  "Вузька",
	  "Нижанківського",
	  "Староміська",
	  "Ліста",
	  "Вічева",
	  "Брюховичів",
	  "Винників",
	  "Рудного",
	  "Коліївщини"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.prefix = __webpack_require__(1230);
	company.suffix = __webpack_require__(1231);
	company.name = __webpack_require__(1229);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{Name.female_first_name}",
	  "#{prefix} #{Name.male_first_name}",
	  "#{prefix} #{Name.male_last_name}",
	  "#{prefix} #{suffix}#{suffix}",
	  "#{prefix} #{suffix}#{suffix}#{suffix}",
	  "#{prefix} #{Address.city_name}#{suffix}",
	  "#{prefix} #{Address.city_name}#{suffix}#{suffix}",
	  "#{prefix} #{Address.city_name}#{suffix}#{suffix}#{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ТОВ",
	  "ПАТ",
	  "ПрАТ",
	  "ТДВ",
	  "КТ",
	  "ПТ",
	  "ДП",
	  "ФОП"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Постач",
	  "Торг",
	  "Пром",
	  "Трейд",
	  "Збут"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var uk = {};
	module['exports'] = uk;
	uk.title = "Ukrainian";
	uk.address = __webpack_require__(1219);
	uk.company = __webpack_require__(1228);
	uk.internet = __webpack_require__(1235);
	uk.name = __webpack_require__(1239);
	uk.phone_number = __webpack_require__(1248);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "cherkassy.ua",
	  "cherkasy.ua",
	  "ck.ua",
	  "cn.ua",
	  "com.ua",
	  "crimea.ua",
	  "cv.ua",
	  "dn.ua",
	  "dnepropetrovsk.ua",
	  "dnipropetrovsk.ua",
	  "donetsk.ua",
	  "dp.ua",
	  "if.ua",
	  "in.ua",
	  "ivano-frankivsk.ua",
	  "kh.ua",
	  "kharkiv.ua",
	  "kharkov.ua",
	  "kherson.ua",
	  "khmelnitskiy.ua",
	  "kiev.ua",
	  "kirovograd.ua",
	  "km.ua",
	  "kr.ua",
	  "ks.ua",
	  "lg.ua",
	  "lt.ua",
	  "lugansk.ua",
	  "lutsk.ua",
	  "lutsk.net",
	  "lviv.ua",
	  "mk.ua",
	  "net.ua",
	  "nikolaev.ua",
	  "od.ua",
	  "odessa.ua",
	  "org.ua",
	  "pl.ua",
	  "pl.ua",
	  "poltava.ua",
	  "rovno.ua",
	  "rv.ua",
	  "sebastopol.ua",
	  "sm.ua",
	  "sumy.ua",
	  "te.ua",
	  "ternopil.ua",
	  "ua",
	  "uz.ua",
	  "uzhgorod.ua",
	  "vinnica.ua",
	  "vn.ua",
	  "volyn.net",
	  "volyn.ua",
	  "yalta.ua",
	  "zaporizhzhe.ua",
	  "zhitomir.ua",
	  "zp.ua",
	  "zt.ua",
	  "укр"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ukr.net",
	  "ex.ua",
	  "e-mail.ua",
	  "i.ua",
	  "meta.ua",
	  "yandex.ua",
	  "gmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1234);
	internet.domain_suffix = __webpack_require__(1233);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Аврелія",
	  "Аврора",
	  "Агапія",
	  "Агата",
	  "Агафія",
	  "Агнеса",
	  "Агнія",
	  "Агрипина",
	  "Ада",
	  "Аделаїда",
	  "Аделіна",
	  "Адріана",
	  "Азалія",
	  "Алевтина",
	  "Аліна",
	  "Алла",
	  "Альбіна",
	  "Альвіна",
	  "Анастасія",
	  "Анастасія",
	  "Анатолія",
	  "Ангеліна",
	  "Анжела",
	  "Анна",
	  "Антонида",
	  "Антоніна",
	  "Антонія",
	  "Анфіса",
	  "Аполлінарія",
	  "Аполлонія",
	  "Аркадія",
	  "Артемія",
	  "Афанасія",
	  "Білослава",
	  "Біляна",
	  "Благовіста",
	  "Богдана",
	  "Богуслава",
	  "Божена",
	  "Болеслава",
	  "Борислава",
	  "Броніслава",
	  "В’ячеслава",
	  "Валентина",
	  "Валерія",
	  "Варвара",
	  "Василина",
	  "Вікторія",
	  "Вілена",
	  "Віленіна",
	  "Віліна",
	  "Віола",
	  "Віолетта",
	  "Віра",
	  "Віргінія",
	  "Віта",
	  "Віталіна",
	  "Влада",
	  "Владислава",
	  "Власта",
	  "Всеслава",
	  "Галина",
	  "Ганна",
	  "Гелена",
	  "Далеслава",
	  "Дана",
	  "Дарина",
	  "Дарислава",
	  "Діана",
	  "Діяна",
	  "Добринка",
	  "Добромила",
	  "Добромира",
	  "Добромисла",
	  "Доброслава",
	  "Долеслава",
	  "Доляна",
	  "Жанна",
	  "Жозефіна",
	  "Забава",
	  "Звенислава",
	  "Зінаїда",
	  "Злата",
	  "Зореслава",
	  "Зорина",
	  "Зоряна",
	  "Зоя",
	  "Іванна",
	  "Ілона",
	  "Інна",
	  "Іннеса",
	  "Ірина",
	  "Ірма",
	  "Калина",
	  "Каріна",
	  "Катерина",
	  "Квітка",
	  "Квітослава",
	  "Клавдія",
	  "Крентта",
	  "Ксенія",
	  "Купава",
	  "Лада",
	  "Лариса",
	  "Леся",
	  "Ликера",
	  "Лідія",
	  "Лілія",
	  "Любава",
	  "Любислава",
	  "Любов",
	  "Любомила",
	  "Любомира",
	  "Люборада",
	  "Любослава",
	  "Людмила",
	  "Людомила",
	  "Майя",
	  "Мальва",
	  "Мар’яна",
	  "Марина",
	  "Марічка",
	  "Марія",
	  "Марта",
	  "Меланія",
	  "Мечислава",
	  "Милодара",
	  "Милослава",
	  "Мирослава",
	  "Мілана",
	  "Мокрина",
	  "Мотря",
	  "Мстислава",
	  "Надія",
	  "Наталія",
	  "Неля",
	  "Немира",
	  "Ніна",
	  "Огняна",
	  "Оксана",
	  "Олександра",
	  "Олена",
	  "Олеся",
	  "Ольга",
	  "Ореста",
	  "Орина",
	  "Орислава",
	  "Орися",
	  "Оріяна",
	  "Павліна",
	  "Палажка",
	  "Пелагея",
	  "Пелагія",
	  "Поліна",
	  "Поляна",
	  "Потішана",
	  "Радміла",
	  "Радослава",
	  "Раїна",
	  "Раїса",
	  "Роксолана",
	  "Ромена",
	  "Ростислава",
	  "Руслана",
	  "Світлана",
	  "Святослава",
	  "Слава",
	  "Сміяна",
	  "Сніжана",
	  "Соломія",
	  "Соня",
	  "Софія",
	  "Станислава",
	  "Сюзана",
	  "Таїсія",
	  "Тамара",
	  "Тетяна",
	  "Устина",
	  "Фаїна",
	  "Февронія",
	  "Федора",
	  "Феодосія",
	  "Харитина",
	  "Христина",
	  "Христя",
	  "Юліанна",
	  "Юлія",
	  "Юстина",
	  "Юхима",
	  "Юхимія",
	  "Яна",
	  "Ярина",
	  "Ярослава"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Андрухович",
	  "Бабух",
	  "Балабан",
	  "Балабуха",
	  "Балакун",
	  "Балицька",
	  "Бамбула",
	  "Бандера",
	  "Барановська",
	  "Бачей",
	  "Башук",
	  "Бердник",
	  "Білич",
	  "Бондаренко",
	  "Борецька",
	  "Боровська",
	  "Борочко",
	  "Боярчук",
	  "Брицька",
	  "Бурмило",
	  "Бутько",
	  "Василишина",
	  "Васильківська",
	  "Вергун",
	  "Вередун",
	  "Верещук",
	  "Витребенько",
	  "Вітряк",
	  "Волощук",
	  "Гайдук",
	  "Гайова",
	  "Гайчук",
	  "Галаєнко",
	  "Галатей",
	  "Галаціон",
	  "Гаман",
	  "Гамула",
	  "Ганич",
	  "Гарай",
	  "Гарун",
	  "Гладківська",
	  "Гладух",
	  "Глинська",
	  "Гнатишина",
	  "Гойко",
	  "Головець",
	  "Горбач",
	  "Гордійчук",
	  "Горова",
	  "Городоцька",
	  "Гречко",
	  "Григоришина",
	  "Гриневецька",
	  "Гриневська",
	  "Гришко",
	  "Громико",
	  "Данилишина",
	  "Данилко",
	  "Демків",
	  "Демчишина",
	  "Дзюб’як",
	  "Дзюба",
	  "Дідух",
	  "Дмитришина",
	  "Дмитрук",
	  "Довгалевська",
	  "Дурдинець",
	  "Євенко",
	  "Євпак",
	  "Ємець",
	  "Єрмак",
	  "Забіла",
	  "Зварич",
	  "Зінкевич",
	  "Зленко",
	  "Іванишина",
	  "Калач",
	  "Кандиба",
	  "Карпух",
	  "Кивач",
	  "Коваленко",
	  "Ковальська",
	  "Коломієць",
	  "Коман",
	  "Компанієць",
	  "Кононець",
	  "Кордун",
	  "Корецька",
	  "Корнїйчук",
	  "Коров’як",
	  "Коцюбинська",
	  "Кулинич",
	  "Кульчицька",
	  "Лагойда",
	  "Лазірко",
	  "Ланова",
	  "Латан",
	  "Латанська",
	  "Лахман",
	  "Левадовська",
	  "Ликович",
	  "Линдик",
	  "Ліхно",
	  "Лобачевська",
	  "Ломова",
	  "Лугова",
	  "Луцька",
	  "Луцьків",
	  "Лученко",
	  "Лучко",
	  "Люта",
	  "Лящук",
	  "Магера",
	  "Мазайло",
	  "Мазило",
	  "Мазун",
	  "Майборода",
	  "Майстренко",
	  "Маковецька",
	  "Малкович",
	  "Мамій",
	  "Маринич",
	  "Марієвська",
	  "Марків",
	  "Махно",
	  "Миклашевська",
	  "Миклухо",
	  "Милославська",
	  "Михайлюк",
	  "Міняйло",
	  "Могилевська",
	  "Москаль",
	  "Москалюк",
	  "Мотрієнко",
	  "Негода",
	  "Ногачевська",
	  "Опенько",
	  "Осадко",
	  "Павленко",
	  "Павлишина",
	  "Павлів",
	  "Пагутяк",
	  "Паламарчук",
	  "Палій",
	  "Паращук",
	  "Пасічник",
	  "Пендик",
	  "Петик",
	  "Петлюра",
	  "Петренко",
	  "Петрина",
	  "Петришина",
	  "Петрів",
	  "Плаксій",
	  "Погиба",
	  "Поліщук",
	  "Пономарів",
	  "Поривай",
	  "Поривайло",
	  "Потебенько",
	  "Потоцька",
	  "Пригода",
	  "Приймак",
	  "Притула",
	  "Прядун",
	  "Розпутня",
	  "Романишина",
	  "Ромей",
	  "Роменець",
	  "Ромочко",
	  "Савицька",
	  "Саєнко",
	  "Свидригайло",
	  "Семеночко",
	  "Семещук",
	  "Сердюк",
	  "Силецька",
	  "Сідлецька",
	  "Сідляк",
	  "Сірко",
	  "Скиба",
	  "Скоропадська",
	  "Слободян",
	  "Сосюра",
	  "Сплюха",
	  "Спотикач",
	  "Степанець",
	  "Стигайло",
	  "Сторожук",
	  "Сторчак",
	  "Стоян",
	  "Сучак",
	  "Сушко",
	  "Тарасюк",
	  "Тиндарей",
	  "Ткаченко",
	  "Третяк",
	  "Троян",
	  "Трублаєвська",
	  "Трясило",
	  "Трясун",
	  "Уманець",
	  "Унич",
	  "Усич",
	  "Федоришина",
	  "Цушко",
	  "Червоній",
	  "Шамрило",
	  "Шевченко",
	  "Шестак",
	  "Шиндарей",
	  "Шиян",
	  "Шкараба",
	  "Шудрик",
	  "Шумило",
	  "Шупик",
	  "Шухевич",
	  "Щербак",
	  "Юрчишина",
	  "Юхно",
	  "Ющик",
	  "Ющук",
	  "Яворівська",
	  "Ялова",
	  "Ялюк",
	  "Янюк",
	  "Ярмак",
	  "Яцишина",
	  "Яцьків",
	  "Ящук"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Адамівна",
	  "Азарівна",
	  "Алевтинівна",
	  "Альбертівна",
	  "Анастасівна",
	  "Анатоліївна",
	  "Андріївна",
	  "Антонівна",
	  "Аркадіївна",
	  "Арсенівна",
	  "Арсеніївна",
	  "Артемівна",
	  "Архипівна",
	  "Аскольдівна",
	  "Афанасіївна",
	  "Білославівна",
	  "Богданівна",
	  "Божемирівна",
	  "Боженівна",
	  "Болеславівна",
	  "Боримирівна",
	  "Борисівна",
	  "Бориславівна",
	  "Братиславівна",
	  "В’ячеславівна",
	  "Вадимівна",
	  "Валентинівна",
	  "Валеріївна",
	  "Василівна",
	  "Вікторівна",
	  "Віталіївна",
	  "Владиславівна",
	  "Володимирівна",
	  "Всеволодівна",
	  "Всеславівна",
	  "Гаврилівна",
	  "Гарасимівна",
	  "Георгіївна",
	  "Гнатівна",
	  "Гордіївна",
	  "Григоріївна",
	  "Данилівна",
	  "Даромирівна",
	  "Денисівна",
	  "Дмитрівна",
	  "Добромирівна",
	  "Доброславівна",
	  "Євгенівна",
	  "Захарівна",
	  "Захаріївна",
	  "Збориславівна",
	  "Звенимирівна",
	  "Звениславівна",
	  "Зеновіївна",
	  "Зиновіївна",
	  "Златомирівна",
	  "Зореславівна",
	  "Іванівна",
	  "Ігорівна",
	  "Ізяславівна",
	  "Корнеліївна",
	  "Корнилівна",
	  "Корніївна",
	  "Костянтинівна",
	  "Лаврентіївна",
	  "Любомирівна",
	  "Макарівна",
	  "Максимівна",
	  "Марківна",
	  "Маркіянівна",
	  "Матвіївна",
	  "Мечиславівна",
	  "Микитівна",
	  "Миколаївна",
	  "Миронівна",
	  "Мирославівна",
	  "Михайлівна",
	  "Мстиславівна",
	  "Назарівна",
	  "Назаріївна",
	  "Натанівна",
	  "Немирівна",
	  "Несторівна",
	  "Олегівна",
	  "Олександрівна",
	  "Олексіївна",
	  "Олельківна",
	  "Омелянівна",
	  "Орестівна",
	  "Орхипівна",
	  "Остапівна",
	  "Охрімівна",
	  "Павлівна",
	  "Панасівна",
	  "Пантелеймонівна",
	  "Петрівна",
	  "Пилипівна",
	  "Радимирівна",
	  "Радимівна",
	  "Родіонівна",
	  "Романівна",
	  "Ростиславівна",
	  "Русланівна",
	  "Святославівна",
	  "Сергіївна",
	  "Славутівна",
	  "Станіславівна",
	  "Степанівна",
	  "Стефаніївна",
	  "Тарасівна",
	  "Тимофіївна",
	  "Тихонівна",
	  "Устимівна",
	  "Юріївна",
	  "Юхимівна",
	  "Ярославівна"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.male_first_name = __webpack_require__(1240);
	name.male_middle_name = __webpack_require__(1242);
	name.male_last_name = __webpack_require__(1241);
	name.female_first_name = __webpack_require__(1236);
	name.female_middle_name = __webpack_require__(1238);
	name.female_last_name = __webpack_require__(1237);
	name.prefix = __webpack_require__(1244);
	name.suffix = __webpack_require__(1245);
	name.title = __webpack_require__(1246);
	name.name = __webpack_require__(1243);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Августин",
	  "Аврелій",
	  "Адам",
	  "Адріян",
	  "Азарій",
	  "Алевтин",
	  "Альберт",
	  "Анастас",
	  "Анастасій",
	  "Анатолій",
	  "Андрій",
	  "Антін",
	  "Антон",
	  "Антоній",
	  "Аркадій",
	  "Арсен",
	  "Арсеній",
	  "Артем",
	  "Архип",
	  "Аскольд",
	  "Афанасій",
	  "Біломир",
	  "Білослав",
	  "Богдан",
	  "Божемир",
	  "Божен",
	  "Болеслав",
	  "Боримир",
	  "Боримисл",
	  "Борис",
	  "Борислав",
	  "Братимир",
	  "Братислав",
	  "Братомил",
	  "Братослав",
	  "Брячислав",
	  "Будимир",
	  "Буйтур",
	  "Буревіст",
	  "В’ячеслав",
	  "Вадим",
	  "Валентин",
	  "Валерій",
	  "Василь",
	  "Велемир",
	  "Віктор",
	  "Віталій",
	  "Влад",
	  "Владислав",
	  "Володимир",
	  "Володислав",
	  "Всевлад",
	  "Всеволод",
	  "Всеслав",
	  "Гаврило",
	  "Гарнослав",
	  "Геннадій",
	  "Георгій",
	  "Герасим",
	  "Гліб",
	  "Гнат",
	  "Гордій",
	  "Горимир",
	  "Горислав",
	  "Градимир",
	  "Григорій",
	  "Далемир",
	  "Данило",
	  "Дарій",
	  "Даромир",
	  "Денис",
	  "Дмитро",
	  "Добромир",
	  "Добромисл",
	  "Доброслав",
	  "Євген",
	  "Єремій",
	  "Захар",
	  "Захарій",
	  "Зборислав",
	  "Звенигор",
	  "Звенимир",
	  "Звенислав",
	  "Земислав",
	  "Зеновій",
	  "Зиновій",
	  "Злат",
	  "Златомир",
	  "Зоремир",
	  "Зореслав",
	  "Зорян",
	  "Іван",
	  "Ігор",
	  "Ізяслав",
	  "Ілля",
	  "Кий",
	  "Корнелій",
	  "Корнилій",
	  "Корнило",
	  "Корній",
	  "Костянтин",
	  "Кузьма",
	  "Лаврентій",
	  "Лаврін",
	  "Лад",
	  "Ладислав",
	  "Ладо",
	  "Ладомир",
	  "Левко",
	  "Листвич",
	  "Лук’ян",
	  "Любодар",
	  "Любозар",
	  "Любомир",
	  "Макар",
	  "Максим",
	  "Мар’ян",
	  "Маркіян",
	  "Марко",
	  "Матвій",
	  "Мечислав",
	  "Микита",
	  "Микола",
	  "Мирон",
	  "Мирослав",
	  "Михайло",
	  "Мстислав",
	  "Мусій",
	  "Назар",
	  "Назарій",
	  "Натан",
	  "Немир",
	  "Нестор",
	  "Олег",
	  "Олександр",
	  "Олексій",
	  "Олелько",
	  "Олесь",
	  "Омелян",
	  "Орест",
	  "Орхип",
	  "Остап",
	  "Охрім",
	  "Павло",
	  "Панас",
	  "Пантелеймон",
	  "Петро",
	  "Пилип",
	  "Подолян",
	  "Потап",
	  "Радим",
	  "Радимир",
	  "Ратибор",
	  "Ратимир",
	  "Родіон",
	  "Родослав",
	  "Роксолан",
	  "Роман",
	  "Ростислав",
	  "Руслан",
	  "Святополк",
	  "Святослав",
	  "Семибор",
	  "Сергій",
	  "Синьоок",
	  "Славолюб",
	  "Славомир",
	  "Славута",
	  "Сніжан",
	  "Сологуб",
	  "Станіслав",
	  "Степан",
	  "Стефаній",
	  "Стожар",
	  "Тарас",
	  "Тиміш",
	  "Тимофій",
	  "Тихон",
	  "Тур",
	  "Устим",
	  "Хвалимир",
	  "Хорив",
	  "Чорнота",
	  "Щастислав",
	  "Щек",
	  "Юліан",
	  "Юрій",
	  "Юхим",
	  "Ян",
	  "Ярема",
	  "Яровид",
	  "Яромил",
	  "Яромир",
	  "Ярополк",
	  "Ярослав"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Андрухович",
	  "Бабух",
	  "Балабан",
	  "Балабух",
	  "Балакун",
	  "Балицький",
	  "Бамбула",
	  "Бандера",
	  "Барановський",
	  "Бачей",
	  "Башук",
	  "Бердник",
	  "Білич",
	  "Бондаренко",
	  "Борецький",
	  "Боровський",
	  "Борочко",
	  "Боярчук",
	  "Брицький",
	  "Бурмило",
	  "Бутько",
	  "Василин",
	  "Василишин",
	  "Васильківський",
	  "Вергун",
	  "Вередун",
	  "Верещук",
	  "Витребенько",
	  "Вітряк",
	  "Волощук",
	  "Гайдук",
	  "Гайовий",
	  "Гайчук",
	  "Галаєнко",
	  "Галатей",
	  "Галаціон",
	  "Гаман",
	  "Гамула",
	  "Ганич",
	  "Гарай",
	  "Гарун",
	  "Гладківський",
	  "Гладух",
	  "Глинський",
	  "Гнатишин",
	  "Гойко",
	  "Головець",
	  "Горбач",
	  "Гордійчук",
	  "Горовий",
	  "Городоцький",
	  "Гречко",
	  "Григоришин",
	  "Гриневецький",
	  "Гриневський",
	  "Гришко",
	  "Громико",
	  "Данилишин",
	  "Данилко",
	  "Демків",
	  "Демчишин",
	  "Дзюб’як",
	  "Дзюба",
	  "Дідух",
	  "Дмитришин",
	  "Дмитрук",
	  "Довгалевський",
	  "Дурдинець",
	  "Євенко",
	  "Євпак",
	  "Ємець",
	  "Єрмак",
	  "Забіла",
	  "Зварич",
	  "Зінкевич",
	  "Зленко",
	  "Іванишин",
	  "Іванів",
	  "Іванців",
	  "Калач",
	  "Кандиба",
	  "Карпух",
	  "Каськів",
	  "Кивач",
	  "Коваленко",
	  "Ковальський",
	  "Коломієць",
	  "Коман",
	  "Компанієць",
	  "Кононець",
	  "Кордун",
	  "Корецький",
	  "Корнїйчук",
	  "Коров’як",
	  "Коцюбинський",
	  "Кулинич",
	  "Кульчицький",
	  "Лагойда",
	  "Лазірко",
	  "Лановий",
	  "Латаний",
	  "Латанський",
	  "Лахман",
	  "Левадовський",
	  "Ликович",
	  "Линдик",
	  "Ліхно",
	  "Лобачевський",
	  "Ломовий",
	  "Луговий",
	  "Луцький",
	  "Луцьків",
	  "Лученко",
	  "Лучко",
	  "Лютий",
	  "Лящук",
	  "Магера",
	  "Мазайло",
	  "Мазило",
	  "Мазун",
	  "Майборода",
	  "Майстренко",
	  "Маковецький",
	  "Малкович",
	  "Мамій",
	  "Маринич",
	  "Марієвський",
	  "Марків",
	  "Махно",
	  "Миклашевський",
	  "Миклухо",
	  "Милославський",
	  "Михайлюк",
	  "Міняйло",
	  "Могилевський",
	  "Москаль",
	  "Москалюк",
	  "Мотрієнко",
	  "Негода",
	  "Ногачевський",
	  "Опенько",
	  "Осадко",
	  "Павленко",
	  "Павлишин",
	  "Павлів",
	  "Пагутяк",
	  "Паламарчук",
	  "Палій",
	  "Паращук",
	  "Пасічник",
	  "Пендик",
	  "Петик",
	  "Петлюра",
	  "Петренко",
	  "Петрин",
	  "Петришин",
	  "Петрів",
	  "Плаксій",
	  "Погиба",
	  "Поліщук",
	  "Пономарів",
	  "Поривай",
	  "Поривайло",
	  "Потебенько",
	  "Потоцький",
	  "Пригода",
	  "Приймак",
	  "Притула",
	  "Прядун",
	  "Розпутній",
	  "Романишин",
	  "Романів",
	  "Ромей",
	  "Роменець",
	  "Ромочко",
	  "Савицький",
	  "Саєнко",
	  "Свидригайло",
	  "Семеночко",
	  "Семещук",
	  "Сердюк",
	  "Силецький",
	  "Сідлецький",
	  "Сідляк",
	  "Сірко",
	  "Скиба",
	  "Скоропадський",
	  "Слободян",
	  "Сосюра",
	  "Сплюх",
	  "Спотикач",
	  "Стахів",
	  "Степанець",
	  "Стецьків",
	  "Стигайло",
	  "Сторожук",
	  "Сторчак",
	  "Стоян",
	  "Сучак",
	  "Сушко",
	  "Тарасюк",
	  "Тиндарей",
	  "Ткаченко",
	  "Третяк",
	  "Троян",
	  "Трублаєвський",
	  "Трясило",
	  "Трясун",
	  "Уманець",
	  "Унич",
	  "Усич",
	  "Федоришин",
	  "Хитрово",
	  "Цимбалістий",
	  "Цушко",
	  "Червоній",
	  "Шамрило",
	  "Шевченко",
	  "Шестак",
	  "Шиндарей",
	  "Шиян",
	  "Шкараба",
	  "Шудрик",
	  "Шумило",
	  "Шупик",
	  "Шухевич",
	  "Щербак",
	  "Юрчишин",
	  "Юхно",
	  "Ющик",
	  "Ющук",
	  "Яворівський",
	  "Яловий",
	  "Ялюк",
	  "Янюк",
	  "Ярмак",
	  "Яцишин",
	  "Яцьків",
	  "Ящук"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Адамович",
	  "Азарович",
	  "Алевтинович",
	  "Альбертович",
	  "Анастасович",
	  "Анатолійович",
	  "Андрійович",
	  "Антонович",
	  "Аркадійович",
	  "Арсенійович",
	  "Арсенович",
	  "Артемович",
	  "Архипович",
	  "Аскольдович",
	  "Афанасійович",
	  "Білославович",
	  "Богданович",
	  "Божемирович",
	  "Боженович",
	  "Болеславович",
	  "Боримирович",
	  "Борисович",
	  "Бориславович",
	  "Братиславович",
	  "В’ячеславович",
	  "Вадимович",
	  "Валентинович",
	  "Валерійович",
	  "Васильович",
	  "Вікторович",
	  "Віталійович",
	  "Владиславович",
	  "Володимирович",
	  "Всеволодович",
	  "Всеславович",
	  "Гаврилович",
	  "Герасимович",
	  "Георгійович",
	  "Гнатович",
	  "Гордійович",
	  "Григорійович",
	  "Данилович",
	  "Даромирович",
	  "Денисович",
	  "Дмитрович",
	  "Добромирович",
	  "Доброславович",
	  "Євгенович",
	  "Захарович",
	  "Захарійович",
	  "Збориславович",
	  "Звенимирович",
	  "Звениславович",
	  "Зеновійович",
	  "Зиновійович",
	  "Златомирович",
	  "Зореславович",
	  "Іванович",
	  "Ігорович",
	  "Ізяславович",
	  "Корнелійович",
	  "Корнилович",
	  "Корнійович",
	  "Костянтинович",
	  "Лаврентійович",
	  "Любомирович",
	  "Макарович",
	  "Максимович",
	  "Маркович",
	  "Маркіянович",
	  "Матвійович",
	  "Мечиславович",
	  "Микитович",
	  "Миколайович",
	  "Миронович",
	  "Мирославович",
	  "Михайлович",
	  "Мстиславович",
	  "Назарович",
	  "Назарійович",
	  "Натанович",
	  "Немирович",
	  "Несторович",
	  "Олегович",
	  "Олександрович",
	  "Олексійович",
	  "Олелькович",
	  "Омелянович",
	  "Орестович",
	  "Орхипович",
	  "Остапович",
	  "Охрімович",
	  "Павлович",
	  "Панасович",
	  "Пантелеймонович",
	  "Петрович",
	  "Пилипович",
	  "Радимирович",
	  "Радимович",
	  "Родіонович",
	  "Романович",
	  "Ростиславович",
	  "Русланович",
	  "Святославович",
	  "Сергійович",
	  "Славутович",
	  "Станіславович",
	  "Степанович",
	  "Стефанович",
	  "Тарасович",
	  "Тимофійович",
	  "Тихонович",
	  "Устимович",
	  "Юрійович",
	  "Юхимович",
	  "Ярославович"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{male_first_name} #{male_last_name}",
	  "#{male_last_name} #{male_first_name}",
	  "#{male_first_name} #{male_middle_name} #{male_last_name}",
	  "#{male_last_name} #{male_first_name} #{male_middle_name}",
	  "#{female_first_name} #{female_last_name}",
	  "#{female_last_name} #{female_first_name}",
	  "#{female_first_name} #{female_middle_name} #{female_last_name}",
	  "#{female_last_name} #{female_first_name} #{female_middle_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Пан",
	  "Пані"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "проф.",
	  "доц.",
	  "докт. пед. наук",
	  "докт. політ. наук",
	  "докт. філол. наук",
	  "докт. філос. наук",
	  "докт. і. наук",
	  "докт. юрид. наук",
	  "докт. техн. наук",
	  "докт. психол. наук",
	  "канд. пед. наук",
	  "канд. політ. наук",
	  "канд. філол. наук",
	  "канд. філос. наук",
	  "канд. і. наук",
	  "канд. юрид. наук",
	  "канд. техн. наук",
	  "канд. психол. наук"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "Головний",
	    "Генеральний",
	    "Провідний",
	    "Національний",
	    "Регіональний",
	    "Обласний",
	    "Районний",
	    "Глобальний",
	    "Міжнародний",
	    "Центральний"
	  ],
	  "level": [
	    "маркетинговий",
	    "оптимізаційний",
	    "страховий",
	    "функціональний",
	    "інтеграційний",
	    "логістичний"
	  ],
	  "job": [
	    "інженер",
	    "агент",
	    "адміністратор",
	    "аналітик",
	    "архітектор",
	    "дизайнер",
	    "керівник",
	    "консультант",
	    "координатор",
	    "менеджер",
	    "планувальник",
	    "помічник",
	    "розробник",
	    "спеціаліст",
	    "співробітник",
	    "технік"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(044) ###-##-##",
	  "(050) ###-##-##",
	  "(063) ###-##-##",
	  "(066) ###-##-##",
	  "(073) ###-##-##",
	  "(091) ###-##-##",
	  "(092) ###-##-##",
	  "(093) ###-##-##",
	  "(094) ###-##-##",
	  "(095) ###-##-##",
	  "(096) ###-##-##",
	  "(097) ###-##-##",
	  "(098) ###-##-##",
	  "(099) ###-##-##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1247);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_root}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bắc Giang",
	  "Bắc Kạn",
	  "Bắc Ninh",
	  "Cao Bằng",
	  "Điện Biên",
	  "Hà Giang",
	  "Hà Nam",
	  "Hà Tây",
	  "Hải Dương",
	  "TP Hải Phòng",
	  "Hòa Bình",
	  "Hưng Yên",
	  "Lai Châu",
	  "Lào Cai",
	  "Lạng Sơn",
	  "Nam Định",
	  "Ninh Bình",
	  "Phú Thọ",
	  "Quảng Ninh",
	  "Sơn La",
	  "Thái Bình",
	  "Thái Nguyên",
	  "Tuyên Quang",
	  "Vĩnh Phúc",
	  "Yên Bái",
	  "TP Đà Nẵng",
	  "Bình Định",
	  "Đắk Lắk",
	  "Đắk Nông",
	  "Gia Lai",
	  "Hà Tĩnh",
	  "Khánh Hòa",
	  "Kon Tum",
	  "Nghệ An",
	  "Phú Yên",
	  "Quảng Bình",
	  "Quảng Nam",
	  "Quảng Ngãi",
	  "Quảng Trị",
	  "Thanh Hóa",
	  "Thừa Thiên Huế",
	  "TP TP. Hồ Chí Minh",
	  "An Giang",
	  "Bà Rịa Vũng Tàu",
	  "Bạc Liêu",
	  "Bến Tre",
	  "Bình Dương",
	  "Bình Phước",
	  "Bình Thuận",
	  "Cà Mau",
	  "TP Cần Thơ",
	  "Đồng Nai",
	  "Đồng Tháp",
	  "Hậu Giang",
	  "Kiên Giang",
	  "Lâm Đồng",
	  "Long An",
	  "Ninh Thuận",
	  "Sóc Trăng",
	  "Tây Ninh",
	  "Tiền Giang",
	  "Trà Vinh",
	  "Vĩnh Long"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Avon",
	  "Bedfordshire",
	  "Berkshire",
	  "Borders",
	  "Buckinghamshire",
	  "Cambridgeshire",
	  "Central",
	  "Cheshire",
	  "Cleveland",
	  "Clwyd",
	  "Cornwall",
	  "County Antrim",
	  "County Armagh",
	  "County Down",
	  "County Fermanagh",
	  "County Londonderry",
	  "County Tyrone",
	  "Cumbria",
	  "Derbyshire",
	  "Devon",
	  "Dorset",
	  "Dumfries and Galloway",
	  "Durham",
	  "Dyfed",
	  "East Sussex",
	  "Essex",
	  "Fife",
	  "Gloucestershire",
	  "Grampian",
	  "Greater Manchester",
	  "Gwent",
	  "Gwynedd County",
	  "Hampshire",
	  "Herefordshire",
	  "Hertfordshire",
	  "Highlands and Islands",
	  "Humberside",
	  "Isle of Wight",
	  "Kent",
	  "Lancashire",
	  "Leicestershire",
	  "Lincolnshire",
	  "Lothian",
	  "Merseyside",
	  "Mid Glamorgan",
	  "Norfolk",
	  "North Yorkshire",
	  "Northamptonshire",
	  "Northumberland",
	  "Nottinghamshire",
	  "Oxfordshire",
	  "Powys",
	  "Rutland",
	  "Shropshire",
	  "Somerset",
	  "South Glamorgan",
	  "South Yorkshire",
	  "Staffordshire",
	  "Strathclyde",
	  "Suffolk",
	  "Surrey",
	  "Tayside",
	  "Tyne and Wear",
	  "Việt Nam",
	  "Warwickshire",
	  "West Glamorgan",
	  "West Midlands",
	  "West Sussex",
	  "West Yorkshire",
	  "Wiltshire",
	  "Worcestershire"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Việt Nam"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_root = __webpack_require__(1250);
	address.city = __webpack_require__(1249);
	address.county = __webpack_require__(1251);
	address.default_country = __webpack_require__(1252);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "074## ######",
	  "075## ######",
	  "076## ######",
	  "077## ######",
	  "078## ######",
	  "079## ######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(1254);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.prefix = __webpack_require__(1258);
	company.name = __webpack_require__(1257);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Công ty",
	  "Cty TNHH",
	  "Cty",
	  "Cửa hàng",
	  "Trung tâm",
	  "Chi nhánh"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var vi = {};
	module['exports'] = vi;
	vi.title = "Vietnamese";
	vi.address = __webpack_require__(1253);
	vi.internet = __webpack_require__(1261);
	vi.phone_number = __webpack_require__(1269);
	vi.cell_phone = __webpack_require__(1255);
	vi.name = __webpack_require__(1265);
	vi.company = __webpack_require__(1256);
	vi.lorem = __webpack_require__(1262);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "net",
	  "info",
	  "vn",
	  "com.vn"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(1260);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(1263);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "đã",
	  "đang",
	  "ừ",
	  "ờ",
	  "á",
	  "không",
	  "biết",
	  "gì",
	  "hết",
	  "đâu",
	  "nha",
	  "thế",
	  "thì",
	  "là",
	  "đánh",
	  "đá",
	  "đập",
	  "phá",
	  "viết",
	  "vẽ",
	  "tô",
	  "thuê",
	  "mướn",
	  "mượn",
	  "mua",
	  "một",
	  "hai",
	  "ba",
	  "bốn",
	  "năm",
	  "sáu",
	  "bảy",
	  "tám",
	  "chín",
	  "mười",
	  "thôi",
	  "việc",
	  "nghỉ",
	  "làm",
	  "nhà",
	  "cửa",
	  "xe",
	  "đạp",
	  "ác",
	  "độc",
	  "khoảng",
	  "khoan",
	  "thuyền",
	  "tàu",
	  "bè",
	  "lầu",
	  "xanh",
	  "đỏ",
	  "tím",
	  "vàng",
	  "kim",
	  "chỉ",
	  "khâu",
	  "may",
	  "vá",
	  "em",
	  "anh",
	  "yêu",
	  "thương",
	  "thích",
	  "con",
	  "cái",
	  "bàn",
	  "ghế",
	  "tủ",
	  "quần",
	  "áo",
	  "nón",
	  "dép",
	  "giày",
	  "lỗi",
	  "được",
	  "ghét",
	  "giết",
	  "chết",
	  "hết",
	  "tôi",
	  "bạn",
	  "tui",
	  "trời",
	  "trăng",
	  "mây",
	  "gió",
	  "máy",
	  "hàng",
	  "hóa",
	  "leo",
	  "núi",
	  "bơi",
	  "biển",
	  "chìm",
	  "xuồng",
	  "nước",
	  "ngọt",
	  "ruộng",
	  "đồng",
	  "quê",
	  "hương"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Phạm",
	  "Nguyễn",
	  "Trần",
	  "Lê",
	  "Lý",
	  "Hoàng",
	  "Phan",
	  "Vũ",
	  "Tăng",
	  "Đặng",
	  "Bùi",
	  "Đỗ",
	  "Hồ",
	  "Ngô",
	  "Dương",
	  "Đào",
	  "Đoàn",
	  "Vương",
	  "Trịnh",
	  "Đinh",
	  "Lâm",
	  "Phùng",
	  "Mai",
	  "Tô",
	  "Trương",
	  "Hà"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1264);
	name.last_name = __webpack_require__(1266);
	name.name = __webpack_require__(1267);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Nam",
	  "Trung",
	  "Thanh",
	  "Thị",
	  "Văn",
	  "Dương",
	  "Tăng",
	  "Quốc",
	  "Như",
	  "Phạm",
	  "Nguyễn",
	  "Trần",
	  "Lê",
	  "Lý",
	  "Hoàng",
	  "Phan",
	  "Vũ",
	  "Tăng",
	  "Đặng",
	  "Bùi",
	  "Đỗ",
	  "Hồ",
	  "Ngô",
	  "Dương",
	  "Đào",
	  "Đoàn",
	  "Vương",
	  "Trịnh",
	  "Đinh",
	  "Lâm",
	  "Phùng",
	  "Mai",
	  "Tô",
	  "Trương",
	  "Hà",
	  "Vinh",
	  "Nhung",
	  "Hòa",
	  "Tiến",
	  "Tâm",
	  "Bửu",
	  "Loan",
	  "Hiền",
	  "Hải",
	  "Vân",
	  "Kha",
	  "Minh",
	  "Nhân",
	  "Triệu",
	  "Tuân",
	  "Hữu",
	  "Đức",
	  "Phú",
	  "Khoa",
	  "Thắgn",
	  "Sơn",
	  "Dung",
	  "Tú",
	  "Trinh",
	  "Thảo",
	  "Sa",
	  "Kim",
	  "Long",
	  "Thi",
	  "Cường",
	  "Ngọc",
	  "Sinh",
	  "Khang",
	  "Phong",
	  "Thắm",
	  "Thu",
	  "Thủy",
	  "Nhàn"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "01#### #####",
	  "01### ######",
	  "01#1 ### ####",
	  "011# ### ####",
	  "02# #### ####",
	  "03## ### ####",
	  "055 #### ####",
	  "056 #### ####",
	  "0800 ### ####",
	  "08## ### ####",
	  "09## ### ####",
	  "016977 ####",
	  "01### #####",
	  "0500 ######",
	  "0800 ######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1268);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "####",
	  "###",
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "长",
	  "上",
	  "南",
	  "西",
	  "北",
	  "诸",
	  "宁",
	  "珠",
	  "武",
	  "衡",
	  "成",
	  "福",
	  "厦",
	  "贵",
	  "吉",
	  "海",
	  "太",
	  "济",
	  "安",
	  "吉",
	  "包"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "沙市",
	  "京市",
	  "宁市",
	  "安市",
	  "乡县",
	  "海市",
	  "码市",
	  "汉市",
	  "阳市",
	  "都市",
	  "州市",
	  "门市",
	  "阳市",
	  "口市",
	  "原市",
	  "南市",
	  "徽市",
	  "林市",
	  "头市"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "中国"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(1272);
	address.city_suffix = __webpack_require__(1273);
	address.building_number = __webpack_require__(1270);
	address.street_suffix = __webpack_require__(1281);
	address.postcode = __webpack_require__(1276);
	address.state = __webpack_require__(1277);
	address.state_abbr = __webpack_require__(1278);
	address.city = __webpack_require__(1271);
	address.street_name = __webpack_require__(1280);
	address.street_address = __webpack_require__(1279);
	address.default_country = __webpack_require__(1274);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "北京市",
	  "上海市",
	  "天津市",
	  "重庆市",
	  "黑龙江省",
	  "吉林省",
	  "辽宁省",
	  "内蒙古",
	  "河北省",
	  "新疆",
	  "甘肃省",
	  "青海省",
	  "陕西省",
	  "宁夏",
	  "河南省",
	  "山东省",
	  "山西省",
	  "安徽省",
	  "湖北省",
	  "湖南省",
	  "江苏省",
	  "四川省",
	  "贵州省",
	  "云南省",
	  "广西省",
	  "西藏",
	  "浙江省",
	  "江西省",
	  "广东省",
	  "福建省",
	  "台湾省",
	  "海南省",
	  "香港",
	  "澳门"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "京",
	  "沪",
	  "津",
	  "渝",
	  "黑",
	  "吉",
	  "辽",
	  "蒙",
	  "冀",
	  "新",
	  "甘",
	  "青",
	  "陕",
	  "宁",
	  "豫",
	  "鲁",
	  "晋",
	  "皖",
	  "鄂",
	  "湘",
	  "苏",
	  "川",
	  "黔",
	  "滇",
	  "桂",
	  "藏",
	  "浙",
	  "赣",
	  "粤",
	  "闽",
	  "台",
	  "琼",
	  "港",
	  "澳"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name}#{building_number}号"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name}#{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "巷",
	  "街",
	  "路",
	  "桥",
	  "侬",
	  "旁",
	  "中心",
	  "栋"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var zh_CN = {};
	module['exports'] = zh_CN;
	zh_CN.title = "Chinese";
	zh_CN.address = __webpack_require__(1275);
	zh_CN.name = __webpack_require__(1284);
	zh_CN.phone_number = __webpack_require__(1288);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "王",
	  "李",
	  "张",
	  "刘",
	  "陈",
	  "杨",
	  "黄",
	  "吴",
	  "赵",
	  "周",
	  "徐",
	  "孙",
	  "马",
	  "朱",
	  "胡",
	  "林",
	  "郭",
	  "何",
	  "高",
	  "罗",
	  "郑",
	  "梁",
	  "谢",
	  "宋",
	  "唐",
	  "许",
	  "邓",
	  "冯",
	  "韩",
	  "曹",
	  "曾",
	  "彭",
	  "萧",
	  "蔡",
	  "潘",
	  "田",
	  "董",
	  "袁",
	  "于",
	  "余",
	  "叶",
	  "蒋",
	  "杜",
	  "苏",
	  "魏",
	  "程",
	  "吕",
	  "丁",
	  "沈",
	  "任",
	  "姚",
	  "卢",
	  "傅",
	  "钟",
	  "姜",
	  "崔",
	  "谭",
	  "廖",
	  "范",
	  "汪",
	  "陆",
	  "金",
	  "石",
	  "戴",
	  "贾",
	  "韦",
	  "夏",
	  "邱",
	  "方",
	  "侯",
	  "邹",
	  "熊",
	  "孟",
	  "秦",
	  "白",
	  "江",
	  "阎",
	  "薛",
	  "尹",
	  "段",
	  "雷",
	  "黎",
	  "史",
	  "龙",
	  "陶",
	  "贺",
	  "顾",
	  "毛",
	  "郝",
	  "龚",
	  "邵",
	  "万",
	  "钱",
	  "严",
	  "赖",
	  "覃",
	  "洪",
	  "武",
	  "莫",
	  "孔"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1283);
	name.last_name = __webpack_require__(1285);
	name.name = __webpack_require__(1286);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "绍齐",
	  "博文",
	  "梓晨",
	  "胤祥",
	  "瑞霖",
	  "明哲",
	  "天翊",
	  "凯瑞",
	  "健雄",
	  "耀杰",
	  "潇然",
	  "子涵",
	  "越彬",
	  "钰轩",
	  "智辉",
	  "致远",
	  "俊驰",
	  "雨泽",
	  "烨磊",
	  "晟睿",
	  "文昊",
	  "修洁",
	  "黎昕",
	  "远航",
	  "旭尧",
	  "鸿涛",
	  "伟祺",
	  "荣轩",
	  "越泽",
	  "浩宇",
	  "瑾瑜",
	  "皓轩",
	  "擎苍",
	  "擎宇",
	  "志泽",
	  "子轩",
	  "睿渊",
	  "弘文",
	  "哲瀚",
	  "雨泽",
	  "楷瑞",
	  "建辉",
	  "晋鹏",
	  "天磊",
	  "绍辉",
	  "泽洋",
	  "鑫磊",
	  "鹏煊",
	  "昊强",
	  "伟宸",
	  "博超",
	  "君浩",
	  "子骞",
	  "鹏涛",
	  "炎彬",
	  "鹤轩",
	  "越彬",
	  "风华",
	  "靖琪",
	  "明辉",
	  "伟诚",
	  "明轩",
	  "健柏",
	  "修杰",
	  "志泽",
	  "弘文",
	  "峻熙",
	  "嘉懿",
	  "煜城",
	  "懿轩",
	  "烨伟",
	  "苑博",
	  "伟泽",
	  "熠彤",
	  "鸿煊",
	  "博涛",
	  "烨霖",
	  "烨华",
	  "煜祺",
	  "智宸",
	  "正豪",
	  "昊然",
	  "明杰",
	  "立诚",
	  "立轩",
	  "立辉",
	  "峻熙",
	  "弘文",
	  "熠彤",
	  "鸿煊",
	  "烨霖",
	  "哲瀚",
	  "鑫鹏",
	  "昊天",
	  "思聪",
	  "展鹏",
	  "笑愚",
	  "志强",
	  "炫明",
	  "雪松",
	  "思源",
	  "智渊",
	  "思淼",
	  "晓啸",
	  "天宇",
	  "浩然",
	  "文轩",
	  "鹭洋",
	  "振家",
	  "乐驹",
	  "晓博",
	  "文博",
	  "昊焱",
	  "立果",
	  "金鑫",
	  "锦程",
	  "嘉熙",
	  "鹏飞",
	  "子默",
	  "思远",
	  "浩轩",
	  "语堂",
	  "聪健",
	  "明",
	  "文",
	  "果",
	  "思",
	  "鹏",
	  "驰",
	  "涛",
	  "琪",
	  "浩",
	  "航",
	  "彬"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{first_name}#{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###-########",
	  "####-########",
	  "###########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1287);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####",
	  "###",
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "臺北",
	  "新北",
	  "桃園",
	  "臺中",
	  "臺南",
	  "高雄",
	  "基隆",
	  "新竹",
	  "嘉義",
	  "苗栗",
	  "彰化",
	  "南投",
	  "雲林",
	  "屏東",
	  "宜蘭",
	  "花蓮",
	  "臺東",
	  "澎湖",
	  "金門",
	  "連江"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "縣",
	  "市"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Taiwan (R.O.C.)"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(1291);
	address.city_suffix = __webpack_require__(1292);
	address.building_number = __webpack_require__(1289);
	address.street_suffix = __webpack_require__(1300);
	address.postcode = __webpack_require__(1295);
	address.state = __webpack_require__(1296);
	address.state_abbr = __webpack_require__(1297);
	address.city = __webpack_require__(1290);
	address.street_name = __webpack_require__(1299);
	address.street_address = __webpack_require__(1298);
	address.default_country = __webpack_require__(1293);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "福建省",
	  "台灣省"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "北",
	  "新北",
	  "桃",
	  "中",
	  "南",
	  "高",
	  "基",
	  "竹市",
	  "嘉市",
	  "竹縣",
	  "苗",
	  "彰",
	  "投",
	  "雲",
	  "嘉縣",
	  "宜",
	  "花",
	  "東",
	  "澎",
	  "金",
	  "馬"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name}#{building_number}號"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name}#{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "街",
	  "路",
	  "北路",
	  "南路",
	  "東路",
	  "西路"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var zh_TW = {};
	module['exports'] = zh_TW;
	zh_TW.title = "Chinese (Taiwan)";
	zh_TW.address = __webpack_require__(1294);
	zh_TW.name = __webpack_require__(1303);
	zh_TW.phone_number = __webpack_require__(1307);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "王",
	  "李",
	  "張",
	  "劉",
	  "陳",
	  "楊",
	  "黃",
	  "吳",
	  "趙",
	  "週",
	  "徐",
	  "孫",
	  "馬",
	  "朱",
	  "胡",
	  "林",
	  "郭",
	  "何",
	  "高",
	  "羅",
	  "鄭",
	  "梁",
	  "謝",
	  "宋",
	  "唐",
	  "許",
	  "鄧",
	  "馮",
	  "韓",
	  "曹",
	  "曾",
	  "彭",
	  "蕭",
	  "蔡",
	  "潘",
	  "田",
	  "董",
	  "袁",
	  "於",
	  "餘",
	  "葉",
	  "蔣",
	  "杜",
	  "蘇",
	  "魏",
	  "程",
	  "呂",
	  "丁",
	  "沈",
	  "任",
	  "姚",
	  "盧",
	  "傅",
	  "鐘",
	  "姜",
	  "崔",
	  "譚",
	  "廖",
	  "範",
	  "汪",
	  "陸",
	  "金",
	  "石",
	  "戴",
	  "賈",
	  "韋",
	  "夏",
	  "邱",
	  "方",
	  "侯",
	  "鄒",
	  "熊",
	  "孟",
	  "秦",
	  "白",
	  "江",
	  "閻",
	  "薛",
	  "尹",
	  "段",
	  "雷",
	  "黎",
	  "史",
	  "龍",
	  "陶",
	  "賀",
	  "顧",
	  "毛",
	  "郝",
	  "龔",
	  "邵",
	  "萬",
	  "錢",
	  "嚴",
	  "賴",
	  "覃",
	  "洪",
	  "武",
	  "莫",
	  "孔"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1302);
	name.last_name = __webpack_require__(1304);
	name.name = __webpack_require__(1305);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "紹齊",
	  "博文",
	  "梓晨",
	  "胤祥",
	  "瑞霖",
	  "明哲",
	  "天翊",
	  "凱瑞",
	  "健雄",
	  "耀傑",
	  "瀟然",
	  "子涵",
	  "越彬",
	  "鈺軒",
	  "智輝",
	  "致遠",
	  "俊馳",
	  "雨澤",
	  "燁磊",
	  "晟睿",
	  "文昊",
	  "修潔",
	  "黎昕",
	  "遠航",
	  "旭堯",
	  "鴻濤",
	  "偉祺",
	  "榮軒",
	  "越澤",
	  "浩宇",
	  "瑾瑜",
	  "皓軒",
	  "擎蒼",
	  "擎宇",
	  "志澤",
	  "子軒",
	  "睿淵",
	  "弘文",
	  "哲瀚",
	  "雨澤",
	  "楷瑞",
	  "建輝",
	  "晉鵬",
	  "天磊",
	  "紹輝",
	  "澤洋",
	  "鑫磊",
	  "鵬煊",
	  "昊強",
	  "偉宸",
	  "博超",
	  "君浩",
	  "子騫",
	  "鵬濤",
	  "炎彬",
	  "鶴軒",
	  "越彬",
	  "風華",
	  "靖琪",
	  "明輝",
	  "偉誠",
	  "明軒",
	  "健柏",
	  "修傑",
	  "志澤",
	  "弘文",
	  "峻熙",
	  "嘉懿",
	  "煜城",
	  "懿軒",
	  "燁偉",
	  "苑博",
	  "偉澤",
	  "熠彤",
	  "鴻煊",
	  "博濤",
	  "燁霖",
	  "燁華",
	  "煜祺",
	  "智宸",
	  "正豪",
	  "昊然",
	  "明杰",
	  "立誠",
	  "立軒",
	  "立輝",
	  "峻熙",
	  "弘文",
	  "熠彤",
	  "鴻煊",
	  "燁霖",
	  "哲瀚",
	  "鑫鵬",
	  "昊天",
	  "思聰",
	  "展鵬",
	  "笑愚",
	  "志強",
	  "炫明",
	  "雪松",
	  "思源",
	  "智淵",
	  "思淼",
	  "曉嘯",
	  "天宇",
	  "浩然",
	  "文軒",
	  "鷺洋",
	  "振家",
	  "樂駒",
	  "曉博",
	  "文博",
	  "昊焱",
	  "立果",
	  "金鑫",
	  "錦程",
	  "嘉熙",
	  "鵬飛",
	  "子默",
	  "思遠",
	  "浩軒",
	  "語堂",
	  "聰健"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{first_name}#{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0#-#######",
	  "02-########",
	  "09##-######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1306);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {
	/**
	 *
	 * @namespace faker.lorem
	 */
	var Lorem = function (faker) {
	  var self = this;
	  var Helpers = faker.helpers;
	
	  /**
	   * word
	   *
	   * @method faker.lorem.word
	   * @param {number} num
	   */
	  self.word = function (num) {
	    return faker.random.arrayElement(faker.definitions.lorem.words);
	  };
	
	  /**
	   * generates a space separated list of words
	   *
	   * @method faker.lorem.words
	   * @param {number} num number of words, defaults to 3
	   */
	  self.words = function (num) {
	      if (typeof num == 'undefined') { num = 3; }
	      var words = [];
	      for (var i = 0; i < num; i++) {
	        words.push(faker.lorem.word());
	      }
	      return words.join(' ');
	  };
	
	  /**
	   * sentence
	   *
	   * @method faker.lorem.sentence
	   * @param {number} wordCount defaults to a random number between 3 and 10
	   * @param {number} range
	   */
	  self.sentence = function (wordCount, range) {
	      if (typeof wordCount == 'undefined') { wordCount = faker.random.number({ min: 3, max: 10 }); }
	      // if (typeof range == 'undefined') { range = 7; }
	
	      // strange issue with the node_min_test failing for captialize, please fix and add faker.lorem.back
	      //return  faker.lorem.words(wordCount + Helpers.randomNumber(range)).join(' ').capitalize();
	
	      var sentence = faker.lorem.words(wordCount);
	      return sentence.charAt(0).toUpperCase() + sentence.slice(1) + '.';
	  };
	
	  /**
	   * sentences
	   *
	   * @method faker.lorem.sentences
	   * @param {number} sentenceCount defautls to a random number between 2 and 6
	   * @param {string} separator defaults to `' '`
	   */
	  self.sentences = function (sentenceCount, separator) {
	      if (typeof sentenceCount === 'undefined') { sentenceCount = faker.random.number({ min: 2, max: 6 });}
	      if (typeof separator == 'undefined') { separator = " "; }
	      var sentences = [];
	      for (sentenceCount; sentenceCount > 0; sentenceCount--) {
	        sentences.push(faker.lorem.sentence());
	      }
	      return sentences.join(separator);
	  };
	
	  /**
	   * paragraph
	   *
	   * @method faker.lorem.paragraph
	   * @param {number} sentenceCount defaults to 3
	   */
	  self.paragraph = function (sentenceCount) {
	      if (typeof sentenceCount == 'undefined') { sentenceCount = 3; }
	      return faker.lorem.sentences(sentenceCount + faker.random.number(3));
	  };
	
	  /**
	   * paragraphs
	   *
	   * @method faker.lorem.paragraphs
	   * @param {number} paragraphCount defaults to 3
	   * @param {string} separatora defaults to `'\n \r'`
	   */
	  self.paragraphs = function (paragraphCount, separator) {
	    if (typeof separator === "undefined") {
	      separator = "\n \r";
	    }
	    if (typeof paragraphCount == 'undefined') { paragraphCount = 3; }
	    var paragraphs = [];
	    for (paragraphCount; paragraphCount > 0; paragraphCount--) {
	        paragraphs.push(faker.lorem.paragraph());
	    }
	    return paragraphs.join(separator);
	  }
	
	  /**
	   * returns random text based on a random lorem method
	   *
	   * @method faker.lorem.text
	   * @param {number} times
	   */
	  self.text = function loremText (times) {
	    var loremMethods = ['lorem.word', 'lorem.words', 'lorem.sentence', 'lorem.sentences', 'lorem.paragraph', 'lorem.paragraphs', 'lorem.lines'];
	    var randomLoremMethod = faker.random.arrayElement(loremMethods);
	    return faker.fake('{{' + randomLoremMethod + '}}');
	  };
	
	  /**
	   * returns lines of lorem separated by `'\n'`
	   *
	   * @method faker.lorem.lines
	   * @param {number} lineCount defaults to a random number between 1 and 5
	   */
	  self.lines = function lines (lineCount) {
	    if (typeof lineCount === 'undefined') { lineCount = faker.random.number({ min: 1, max: 5 });}
	    return faker.lorem.sentences(lineCount, '\n')
	  };
	
	  return self;
	};
	
	
	module["exports"] = Lorem;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.name
	 */
	function Name (faker) {
	
	  /**
	   * firstName
	   *
	   * @method firstName
	   * @param {mixed} gender
	   * @memberof faker.name
	   */
	  this.firstName = function (gender) {
	    if (typeof faker.definitions.name.male_first_name !== "undefined" && typeof faker.definitions.name.female_first_name !== "undefined") {
	      // some locale datasets ( like ru ) have first_name split by gender. since the name.first_name field does not exist in these datasets,
	      // we must randomly pick a name from either gender array so faker.name.firstName will return the correct locale data ( and not fallback )
	      if (typeof gender !== 'number') {
	        gender = faker.random.number(1);
	      }
	      if (gender === 0) {
	        return faker.random.arrayElement(faker.locales[faker.locale].name.male_first_name)
	      } else {
	        return faker.random.arrayElement(faker.locales[faker.locale].name.female_first_name);
	      }
	    }
	    return faker.random.arrayElement(faker.definitions.name.first_name);
	  };
	
	  /**
	   * lastName
	   *
	   * @method lastName
	   * @param {mixed} gender
	   * @memberof faker.name
	   */
	  this.lastName = function (gender) {
	    if (typeof faker.definitions.name.male_last_name !== "undefined" && typeof faker.definitions.name.female_last_name !== "undefined") {
	      // some locale datasets ( like ru ) have last_name split by gender. i have no idea how last names can have genders, but also i do not speak russian
	      // see above comment of firstName method
	      if (typeof gender !== 'number') {
	        gender = faker.random.number(1);
	      }
	      if (gender === 0) {
	        return faker.random.arrayElement(faker.locales[faker.locale].name.male_last_name);
	      } else {
	        return faker.random.arrayElement(faker.locales[faker.locale].name.female_last_name);
	      }
	    }
	    return faker.random.arrayElement(faker.definitions.name.last_name);
	  };
	
	  /**
	   * findName
	   *
	   * @method findName
	   * @param {string} firstName
	   * @param {string} lastName
	   * @param {mixed} gender
	   * @memberof faker.name
	   */
	  this.findName = function (firstName, lastName, gender) {
	      var r = faker.random.number(8);
	      var prefix, suffix;
	      // in particular locales first and last names split by gender,
	      // thus we keep consistency by passing 0 as male and 1 as female
	      if (typeof gender !== 'number') {
	        gender = faker.random.number(1);
	      }
	      firstName = firstName || faker.name.firstName(gender);
	      lastName = lastName || faker.name.lastName(gender);
	      switch (r) {
	      case 0:
	          prefix = faker.name.prefix(gender);
	          if (prefix) {
	              return prefix + " " + firstName + " " + lastName;
	          }
	      case 1:
	          suffix = faker.name.suffix(gender);
	          if (suffix) {
	              return firstName + " " + lastName + " " + suffix;
	          }
	      }
	
	      return firstName + " " + lastName;
	  };
	
	  /**
	   * jobTitle
	   *
	   * @method jobTitle
	   * @memberof faker.name
	   */
	  this.jobTitle = function () {
	    return  faker.name.jobDescriptor() + " " +
	      faker.name.jobArea() + " " +
	      faker.name.jobType();
	  };
	  
	  /**
	   * prefix
	   *
	   * @method prefix
	   * @param {mixed} gender
	   * @memberof faker.name
	   */
	  this.prefix = function (gender) {
	    if (typeof faker.definitions.name.male_prefix !== "undefined" && typeof faker.definitions.name.female_prefix !== "undefined") {
	      if (typeof gender !== 'number') {
	        gender = faker.random.number(1);
	      }
	      if (gender === 0) {
	        return faker.random.arrayElement(faker.locales[faker.locale].name.male_prefix);
	      } else {
	        return faker.random.arrayElement(faker.locales[faker.locale].name.female_prefix);
	      }
	    }
	    return faker.random.arrayElement(faker.definitions.name.prefix);
	  };
	
	  /**
	   * suffix
	   *
	   * @method suffix
	   * @memberof faker.name
	   */
	  this.suffix = function () {
	      return faker.random.arrayElement(faker.definitions.name.suffix);
	  };
	
	  /**
	   * title
	   *
	   * @method title
	   * @memberof faker.name
	   */
	  this.title = function() {
	      var descriptor  = faker.random.arrayElement(faker.definitions.name.title.descriptor),
	          level       = faker.random.arrayElement(faker.definitions.name.title.level),
	          job         = faker.random.arrayElement(faker.definitions.name.title.job);
	
	      return descriptor + " " + level + " " + job;
	  };
	
	  /**
	   * jobDescriptor
	   *
	   * @method jobDescriptor
	   * @memberof faker.name
	   */
	  this.jobDescriptor = function () {
	    return faker.random.arrayElement(faker.definitions.name.title.descriptor);
	  };
	
	  /**
	   * jobArea
	   *
	   * @method jobArea
	   * @memberof faker.name
	   */
	  this.jobArea = function () {
	    return faker.random.arrayElement(faker.definitions.name.title.level);
	  };
	
	  /**
	   * jobType
	   *
	   * @method jobType
	   * @memberof faker.name
	   */
	  this.jobType = function () {
	    return faker.random.arrayElement(faker.definitions.name.title.job);
	  };
	
	}
	
	module['exports'] = Name;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.phone
	 */
	var Phone = function (faker) {
	  var self = this;
	
	  /**
	   * phoneNumber
	   *
	   * @method faker.phone.phoneNumber
	   * @param {string} format
	   */
	  self.phoneNumber = function (format) {
	      format = format || faker.phone.phoneFormats();
	      return faker.helpers.replaceSymbolWithNumber(format);
	  };
	
	  // FIXME: this is strange passing in an array index.
	  /**
	   * phoneNumberFormat
	   *
	   * @method faker.phone.phoneFormatsArrayIndex
	   * @param phoneFormatsArrayIndex
	   */
	  self.phoneNumberFormat = function (phoneFormatsArrayIndex) {
	      phoneFormatsArrayIndex = phoneFormatsArrayIndex || 0;
	      return faker.helpers.replaceSymbolWithNumber(faker.definitions.phone_number.formats[phoneFormatsArrayIndex]);
	  };
	
	  /**
	   * phoneFormats
	   *
	   * @method faker.phone.phoneFormats
	   */
	  self.phoneFormats = function () {
	    return faker.random.arrayElement(faker.definitions.phone_number.formats);
	  };
	  
	  return self;
	
	};
	
	module['exports'] = Phone;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// generates fake data for many computer systems properties
	
	/**
	 *
	 * @namespace faker.system
	 */
	function System (faker) {
	
	  /**
	   * generates a file name with extension or optional type
	   *
	   * @method faker.system.fileName
	   * @param {string} ext
	   * @param {string} type
	   */
	  this.fileName = function (ext, type) {
	    var str = faker.fake("{{random.words}}.{{system.fileExt}}");
	    str = str.replace(/ /g, '_');
	    str = str.replace(/\,/g, '_');
	    str = str.replace(/\-/g, '_');
	    str = str.replace(/\\/g, '_');
	    str = str.toLowerCase();
	    return str;
	  };
	
	  /**
	   * commonFileName
	   *
	   * @method faker.system.commonFileName
	   * @param {string} ext
	   * @param {string} type
	   */
	  this.commonFileName = function (ext, type) {
	    var str = faker.random.words() + "." + (ext || faker.system.commonFileExt());
	    str = str.replace(/ /g, '_');
	    str = str.replace(/\,/g, '_');
	    str = str.replace(/\-/g, '_');
	    str = str.replace(/\\/g, '_');
	    str = str.toLowerCase();
	    return str;
	  };
	
	  /**
	   * mimeType
	   *
	   * @method faker.system.mimeType
	   */
	  this.mimeType = function () {
	    return faker.random.arrayElement(Object.keys(faker.definitions.system.mimeTypes));
	  };
	
	  /**
	   * returns a commonly used file type
	   *
	   * @method faker.system.commonFileType
	   */
	  this.commonFileType = function () {
	    var types = ['video', 'audio', 'image', 'text', 'application'];
	    return faker.random.arrayElement(types)
	  };
	
	  /**
	   * returns a commonly used file extension based on optional type
	   *
	   * @method faker.system.commonFileExt
	   * @param {string} type
	   */
	  this.commonFileExt = function (type) {
	    var types = [
	      'application/pdf',
	      'audio/mpeg',
	      'audio/wav',
	      'image/png',
	      'image/jpeg',
	      'image/gif',
	      'video/mp4',
	      'video/mpeg',
	      'text/html'
	    ];
	    return faker.system.fileExt(faker.random.arrayElement(types));
	  };
	
	
	  /**
	   * returns any file type available as mime-type
	   *
	   * @method faker.system.fileType
	   */
	  this.fileType = function () {
	    var types = [];
	    var mimes = faker.definitions.system.mimeTypes;
	    Object.keys(mimes).forEach(function(m){
	      var parts = m.split('/');
	      if (types.indexOf(parts[0]) === -1) {
	        types.push(parts[0]);
	      }
	    });
	    return faker.random.arrayElement(types);
	  };
	
	  /**
	   * fileExt
	   *
	   * @method faker.system.fileExt
	   * @param {string} mimeType
	   */
	  this.fileExt = function (mimeType) {
	    var exts = [];
	    var mimes = faker.definitions.system.mimeTypes;
	
	    // get specific ext by mime-type
	    if (typeof mimes[mimeType] === "object") {
	      return faker.random.arrayElement(mimes[mimeType].extensions);
	    }
	
	    // reduce mime-types to those with file-extensions
	    Object.keys(mimes).forEach(function(m){
	      if (mimes[m].extensions instanceof Array) {
	        mimes[m].extensions.forEach(function(ext){
	          exts.push(ext)
	        });
	      }
	    });
	    return faker.random.arrayElement(exts);
	  };
	
	  /**
	   * not yet implemented
	   *
	   * @method faker.system.directoryPath
	   */
	  this.directoryPath = function () {
	    // TODO
	  };
	
	  /**
	   * not yet implemented
	   *
	   * @method faker.system.filePath
	   */
	  this.filePath = function () {
	    // TODO
	  };
	
	  /**
	   * semver
	   *
	   * @method faker.system.semver
	   */
	  this.semver = function () {
	      return [faker.random.number(9),
	              faker.random.number(9),
	              faker.random.number(9)].join('.');
	  }
	
	}
	
	module['exports'] = System;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ },
/* 1312 */
/***/ function(module, exports) {

	// this program is a JavaScript version of Mersenne Twister, with concealment and encapsulation in class,
	// an almost straight conversion from the original program, mt19937ar.c,
	// translated by y. okada on July 17, 2006.
	// and modified a little at july 20, 2006, but there are not any substantial differences.
	// in this program, procedure descriptions and comments of original source code were not removed.
	// lines commented with //c// were originally descriptions of c procedure. and a few following lines are appropriate JavaScript descriptions.
	// lines commented with /* and */ are original comments.
	// lines commented with // are additional comments in this JavaScript version.
	// before using this version, create at least one instance of MersenneTwister19937 class, and initialize the each state, given below in c comments, of all the instances.
	/*
	   A C-program for MT19937, with initialization improved 2002/1/26.
	   Coded by Takuji Nishimura and Makoto Matsumoto.
	
	   Before using, initialize the state by using init_genrand(seed)
	   or init_by_array(init_key, key_length).
	
	   Copyright (C) 1997 - 2002, Makoto Matsumoto and Takuji Nishimura,
	   All rights reserved.
	
	   Redistribution and use in source and binary forms, with or without
	   modification, are permitted provided that the following conditions
	   are met:
	
	     1. Redistributions of source code must retain the above copyright
	        notice, this list of conditions and the following disclaimer.
	
	     2. Redistributions in binary form must reproduce the above copyright
	        notice, this list of conditions and the following disclaimer in the
	        documentation and/or other materials provided with the distribution.
	
	     3. The names of its contributors may not be used to endorse or promote
	        products derived from this software without specific prior written
	        permission.
	
	   THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	   "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	   LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	   A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR
	   CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
	   EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
	   PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	   PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	   SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	
	
	   Any feedback is very welcome.
	   http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/emt.html
	   email: m-mat @ math.sci.hiroshima-u.ac.jp (remove space)
	*/
	
	function MersenneTwister19937()
	{
		/* constants should be scoped inside the class */
		var N, M, MATRIX_A, UPPER_MASK, LOWER_MASK;
		/* Period parameters */
		//c//#define N 624
		//c//#define M 397
		//c//#define MATRIX_A 0x9908b0dfUL   /* constant vector a */
		//c//#define UPPER_MASK 0x80000000UL /* most significant w-r bits */
		//c//#define LOWER_MASK 0x7fffffffUL /* least significant r bits */
		N = 624;
		M = 397;
		MATRIX_A = 0x9908b0df;   /* constant vector a */
		UPPER_MASK = 0x80000000; /* most significant w-r bits */
		LOWER_MASK = 0x7fffffff; /* least significant r bits */
		//c//static unsigned long mt[N]; /* the array for the state vector  */
		//c//static int mti=N+1; /* mti==N+1 means mt[N] is not initialized */
		var mt = new Array(N);   /* the array for the state vector  */
		var mti = N+1;           /* mti==N+1 means mt[N] is not initialized */
	
		function unsigned32 (n1) // returns a 32-bits unsiged integer from an operand to which applied a bit operator.
		{
			return n1 < 0 ? (n1 ^ UPPER_MASK) + UPPER_MASK : n1;
		}
	
		function subtraction32 (n1, n2) // emulates lowerflow of a c 32-bits unsiged integer variable, instead of the operator -. these both arguments must be non-negative integers expressible using unsigned 32 bits.
		{
			return n1 < n2 ? unsigned32((0x100000000 - (n2 - n1)) & 0xffffffff) : n1 - n2;
		}
	
		function addition32 (n1, n2) // emulates overflow of a c 32-bits unsiged integer variable, instead of the operator +. these both arguments must be non-negative integers expressible using unsigned 32 bits.
		{
			return unsigned32((n1 + n2) & 0xffffffff)
		}
	
		function multiplication32 (n1, n2) // emulates overflow of a c 32-bits unsiged integer variable, instead of the operator *. these both arguments must be non-negative integers expressible using unsigned 32 bits.
		{
			var sum = 0;
			for (var i = 0; i < 32; ++i){
				if ((n1 >>> i) & 0x1){
					sum = addition32(sum, unsigned32(n2 << i));
				}
			}
			return sum;
		}
	
		/* initializes mt[N] with a seed */
		//c//void init_genrand(unsigned long s)
		this.init_genrand = function (s)
		{
			//c//mt[0]= s & 0xffffffff;
			mt[0]= unsigned32(s & 0xffffffff);
			for (mti=1; mti<N; mti++) {
				mt[mti] =
				//c//(1812433253 * (mt[mti-1] ^ (mt[mti-1] >> 30)) + mti);
				addition32(multiplication32(1812433253, unsigned32(mt[mti-1] ^ (mt[mti-1] >>> 30))), mti);
				/* See Knuth TAOCP Vol2. 3rd Ed. P.106 for multiplier. */
				/* In the previous versions, MSBs of the seed affect   */
				/* only MSBs of the array mt[].                        */
				/* 2002/01/09 modified by Makoto Matsumoto             */
				//c//mt[mti] &= 0xffffffff;
				mt[mti] = unsigned32(mt[mti] & 0xffffffff);
				/* for >32 bit machines */
			}
		}
	
		/* initialize by an array with array-length */
		/* init_key is the array for initializing keys */
		/* key_length is its length */
		/* slight change for C++, 2004/2/26 */
		//c//void init_by_array(unsigned long init_key[], int key_length)
		this.init_by_array = function (init_key, key_length)
		{
			//c//int i, j, k;
			var i, j, k;
			//c//init_genrand(19650218);
			this.init_genrand(19650218);
			i=1; j=0;
			k = (N>key_length ? N : key_length);
			for (; k; k--) {
				//c//mt[i] = (mt[i] ^ ((mt[i-1] ^ (mt[i-1] >> 30)) * 1664525))
				//c//	+ init_key[j] + j; /* non linear */
				mt[i] = addition32(addition32(unsigned32(mt[i] ^ multiplication32(unsigned32(mt[i-1] ^ (mt[i-1] >>> 30)), 1664525)), init_key[j]), j);
				mt[i] =
				//c//mt[i] &= 0xffffffff; /* for WORDSIZE > 32 machines */
				unsigned32(mt[i] & 0xffffffff);
				i++; j++;
				if (i>=N) { mt[0] = mt[N-1]; i=1; }
				if (j>=key_length) j=0;
			}
			for (k=N-1; k; k--) {
				//c//mt[i] = (mt[i] ^ ((mt[i-1] ^ (mt[i-1] >> 30)) * 1566083941))
				//c//- i; /* non linear */
				mt[i] = subtraction32(unsigned32((dbg=mt[i]) ^ multiplication32(unsigned32(mt[i-1] ^ (mt[i-1] >>> 30)), 1566083941)), i);
				//c//mt[i] &= 0xffffffff; /* for WORDSIZE > 32 machines */
				mt[i] = unsigned32(mt[i] & 0xffffffff);
				i++;
				if (i>=N) { mt[0] = mt[N-1]; i=1; }
			}
			mt[0] = 0x80000000; /* MSB is 1; assuring non-zero initial array */
		}
	
	    /* moved outside of genrand_int32() by jwatte 2010-11-17; generate less garbage */
	    var mag01 = [0x0, MATRIX_A];
	
		/* generates a random number on [0,0xffffffff]-interval */
		//c//unsigned long genrand_int32(void)
		this.genrand_int32 = function ()
		{
			//c//unsigned long y;
			//c//static unsigned long mag01[2]={0x0UL, MATRIX_A};
			var y;
			/* mag01[x] = x * MATRIX_A  for x=0,1 */
	
			if (mti >= N) { /* generate N words at one time */
				//c//int kk;
				var kk;
	
				if (mti == N+1)   /* if init_genrand() has not been called, */
					//c//init_genrand(5489); /* a default initial seed is used */
					this.init_genrand(5489); /* a default initial seed is used */
	
				for (kk=0;kk<N-M;kk++) {
					//c//y = (mt[kk]&UPPER_MASK)|(mt[kk+1]&LOWER_MASK);
					//c//mt[kk] = mt[kk+M] ^ (y >> 1) ^ mag01[y & 0x1];
					y = unsigned32((mt[kk]&UPPER_MASK)|(mt[kk+1]&LOWER_MASK));
					mt[kk] = unsigned32(mt[kk+M] ^ (y >>> 1) ^ mag01[y & 0x1]);
				}
				for (;kk<N-1;kk++) {
					//c//y = (mt[kk]&UPPER_MASK)|(mt[kk+1]&LOWER_MASK);
					//c//mt[kk] = mt[kk+(M-N)] ^ (y >> 1) ^ mag01[y & 0x1];
					y = unsigned32((mt[kk]&UPPER_MASK)|(mt[kk+1]&LOWER_MASK));
					mt[kk] = unsigned32(mt[kk+(M-N)] ^ (y >>> 1) ^ mag01[y & 0x1]);
				}
				//c//y = (mt[N-1]&UPPER_MASK)|(mt[0]&LOWER_MASK);
				//c//mt[N-1] = mt[M-1] ^ (y >> 1) ^ mag01[y & 0x1];
				y = unsigned32((mt[N-1]&UPPER_MASK)|(mt[0]&LOWER_MASK));
				mt[N-1] = unsigned32(mt[M-1] ^ (y >>> 1) ^ mag01[y & 0x1]);
				mti = 0;
			}
	
			y = mt[mti++];
	
			/* Tempering */
			//c//y ^= (y >> 11);
			//c//y ^= (y << 7) & 0x9d2c5680;
			//c//y ^= (y << 15) & 0xefc60000;
			//c//y ^= (y >> 18);
			y = unsigned32(y ^ (y >>> 11));
			y = unsigned32(y ^ ((y << 7) & 0x9d2c5680));
			y = unsigned32(y ^ ((y << 15) & 0xefc60000));
			y = unsigned32(y ^ (y >>> 18));
	
			return y;
		}
	
		/* generates a random number on [0,0x7fffffff]-interval */
		//c//long genrand_int31(void)
		this.genrand_int31 = function ()
		{
			//c//return (genrand_int32()>>1);
			return (this.genrand_int32()>>>1);
		}
	
		/* generates a random number on [0,1]-real-interval */
		//c//double genrand_real1(void)
		this.genrand_real1 = function ()
		{
			//c//return genrand_int32()*(1.0/4294967295.0);
			return this.genrand_int32()*(1.0/4294967295.0);
			/* divided by 2^32-1 */
		}
	
		/* generates a random number on [0,1)-real-interval */
		//c//double genrand_real2(void)
		this.genrand_real2 = function ()
		{
			//c//return genrand_int32()*(1.0/4294967296.0);
			return this.genrand_int32()*(1.0/4294967296.0);
			/* divided by 2^32 */
		}
	
		/* generates a random number on (0,1)-real-interval */
		//c//double genrand_real3(void)
		this.genrand_real3 = function ()
		{
			//c//return ((genrand_int32()) + 0.5)*(1.0/4294967296.0);
			return ((this.genrand_int32()) + 0.5)*(1.0/4294967296.0);
			/* divided by 2^32 */
		}
	
		/* generates a random number on [0,1) with 53-bit resolution*/
		//c//double genrand_res53(void)
		this.genrand_res53 = function ()
		{
			//c//unsigned long a=genrand_int32()>>5, b=genrand_int32()>>6;
			var a=this.genrand_int32()>>>5, b=this.genrand_int32()>>>6;
			return(a*67108864.0+b)*(1.0/9007199254740992.0);
		}
		/* These real versions are due to Isaku Wada, 2002/01/09 added */
	}
	
	//  Exports: Public API
	
	//  Export the twister class
	exports.MersenneTwister19937 = MersenneTwister19937;
	
	//  Export a simplified function to generate random numbers
	var gen = new MersenneTwister19937;
	gen.init_genrand((new Date).getTime() % 1000000000);
	
	// Added max, min range functionality, Marak Squires Sept 11 2014
	exports.rand = function(max, min) {
	    if (max === undefined)
	        {
	        min = 0;
	        max = 32768;
	        }
	    return Math.floor(gen.genrand_real2() * (max - min) + min);
	}
	exports.seed = function(S) {
	    if (typeof(S) != 'number')
	        {
	        throw new Error("seed(S) must take numeric argument; is " + typeof(S));
	        }
	    gen.init_genrand(S);
	}
	exports.seed_array = function(A) {
	    if (typeof(A) != 'object')
	        {
	        throw new Error("seed_array(A) must take array of numbers; is " + typeof(A));
	        }
	    gen.init_by_array(A);
	}


/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * password-generator
	 * Copyright(c) 2011-2013 Bermi Ferrer <bermi@bermilabs.com>
	 * MIT Licensed
	 */
	(function (root) {
	
	  var localName, consonant, letter, password, vowel;
	  letter = /[a-zA-Z]$/;
	  vowel = /[aeiouAEIOU]$/;
	  consonant = /[bcdfghjklmnpqrstvwxyzBCDFGHJKLMNPQRSTVWXYZ]$/;
	
	
	  // Defines the name of the local variable the passwordGenerator library will use
	  // this is specially useful if window.passwordGenerator is already being used
	  // by your application and you want a different name. For example:
	  //    // Declare before including the passwordGenerator library
	  //    var localPasswordGeneratorLibraryName = 'pass';
	  localName = root.localPasswordGeneratorLibraryName || "generatePassword",
	
	  password = function (length, memorable, pattern, prefix) {
	    var char, n;
	    if (length == null) {
	      length = 10;
	    }
	    if (memorable == null) {
	      memorable = true;
	    }
	    if (pattern == null) {
	      pattern = /\w/;
	    }
	    if (prefix == null) {
	      prefix = '';
	    }
	    if (prefix.length >= length) {
	      return prefix;
	    }
	    if (memorable) {
	      if (prefix.match(consonant)) {
	        pattern = vowel;
	      } else {
	        pattern = consonant;
	      }
	    }
	    n = Math.floor(Math.random() * 94) + 33;
	    char = String.fromCharCode(n);
	    if (memorable) {
	      char = char.toLowerCase();
	    }
	    if (!char.match(pattern)) {
	      return password(length, memorable, pattern, prefix);
	    }
	    return password(length, memorable, pattern, "" + prefix + char);
	  };
	
	
	  (( true) ? exports : root)[localName] = password;
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      module.exports = password;
	    }
	  }
	
	  // Establish the root object, `window` in the browser, or `global` on the server.
	}(this));

/***/ },
/* 1314 */
/***/ function(module, exports) {

	/*
	
	Copyright (c) 2012-2014 Jeffrey Mealo
	
	Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
	documentation files (the "Software"), to deal in the Software without restriction, including without limitation
	the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and
	to permit persons to whom the Software is furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in all copies or substantial portions of the
	Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
	WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
	COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	------------------------------------------------------------------------------------------------------------------------
	
	Based loosely on Luka Pusic's PHP Script: http://360percents.com/posts/php-random-user-agent-generator/
	
	The license for that script is as follows:
	
	"THE BEER-WARE LICENSE" (Revision 42):
	
	<pusic93@gmail.com> wrote this file. As long as you retain this notice you can do whatever you want with this stuff.
	If we meet some day, and you think this stuff is worth it, you can buy me a beer in return. Luka Pusic
	*/
	
	function rnd(a, b) {
	    //calling rnd() with no arguments is identical to rnd(0, 100)
	    a = a || 0;
	    b = b || 100;
	
	    if (typeof b === 'number' && typeof a === 'number') {
	        //rnd(int min, int max) returns integer between min, max
	        return (function (min, max) {
	            if (min > max) {
	                throw new RangeError('expected min <= max; got min = ' + min + ', max = ' + max);
	            }
	            return Math.floor(Math.random() * (max - min + 1)) + min;
	        }(a, b));
	    }
	
	    if (Object.prototype.toString.call(a) === "[object Array]") {
	        //returns a random element from array (a), even weighting
	        return a[Math.floor(Math.random() * a.length)];
	    }
	
	    if (a && typeof a === 'object') {
	        //returns a random key from the passed object; keys are weighted by the decimal probability in their value
	        return (function (obj) {
	            var rand = rnd(0, 100) / 100, min = 0, max = 0, key, return_val;
	
	            for (key in obj) {
	                if (obj.hasOwnProperty(key)) {
	                    max = obj[key] + min;
	                    return_val = key;
	                    if (rand >= min && rand <= max) {
	                        break;
	                    }
	                    min = min + obj[key];
	                }
	            }
	
	            return return_val;
	        }(a));
	    }
	
	    throw new TypeError('Invalid arguments passed to rnd. (' + (b ? a + ', ' + b : a) + ')');
	}
	
	function randomLang() {
	    return rnd(['AB', 'AF', 'AN', 'AR', 'AS', 'AZ', 'BE', 'BG', 'BN', 'BO', 'BR', 'BS', 'CA', 'CE', 'CO', 'CS',
	                'CU', 'CY', 'DA', 'DE', 'EL', 'EN', 'EO', 'ES', 'ET', 'EU', 'FA', 'FI', 'FJ', 'FO', 'FR', 'FY',
	                'GA', 'GD', 'GL', 'GV', 'HE', 'HI', 'HR', 'HT', 'HU', 'HY', 'ID', 'IS', 'IT', 'JA', 'JV', 'KA',
	                'KG', 'KO', 'KU', 'KW', 'KY', 'LA', 'LB', 'LI', 'LN', 'LT', 'LV', 'MG', 'MK', 'MN', 'MO', 'MS',
	                'MT', 'MY', 'NB', 'NE', 'NL', 'NN', 'NO', 'OC', 'PL', 'PT', 'RM', 'RO', 'RU', 'SC', 'SE', 'SK',
	                'SL', 'SO', 'SQ', 'SR', 'SV', 'SW', 'TK', 'TR', 'TY', 'UK', 'UR', 'UZ', 'VI', 'VO', 'YI', 'ZH']);
	}
	
	function randomBrowserAndOS() {
	    var browser = rnd({
	        chrome:    .45132810566,
	        iexplorer: .27477061836,
	        firefox:   .19384170608,
	        safari:    .06186781118,
	        opera:     .01574236955
	    }),
	    os = {
	        chrome:  {win: .89,  mac: .09 , lin: .02},
	        firefox: {win: .83,  mac: .16,  lin: .01},
	        opera:   {win: .91,  mac: .03 , lin: .06},
	        safari:  {win: .04 , mac: .96  },
	        iexplorer: ['win']
	    };
	
	    return [browser, rnd(os[browser])];
	}
	
	function randomProc(arch) {
	    var procs = {
	        lin:['i686', 'x86_64'],
	        mac: {'Intel' : .48, 'PPC': .01, 'U; Intel':.48, 'U; PPC' :.01},
	        win:['', 'WOW64', 'Win64; x64']
	    };
	    return rnd(procs[arch]);
	}
	
	function randomRevision(dots) {
	    var return_val = '';
	    //generate a random revision
	    //dots = 2 returns .x.y where x & y are between 0 and 9
	    for (var x = 0; x < dots; x++) {
	        return_val += '.' + rnd(0, 9);
	    }
	    return return_val;
	}
	
	var version_string = {
	    net: function () {
	        return [rnd(1, 4), rnd(0, 9), rnd(10000, 99999), rnd(0, 9)].join('.');
	    },
	    nt: function () {
	        return rnd(5, 6) + '.' + rnd(0, 3);
	    },
	    ie: function () {
	        return rnd(7, 11);
	    },
	    trident: function () {
	        return rnd(3, 7) + '.' + rnd(0, 1);
	    },
	    osx: function (delim) {
	        return [10, rnd(5, 10), rnd(0, 9)].join(delim || '.');
	    },
	    chrome: function () {
	        return [rnd(13, 39), 0, rnd(800, 899), 0].join('.');
	    },
	    presto: function () {
	        return '2.9.' + rnd(160, 190);
	    },
	    presto2: function () {
	        return rnd(10, 12) + '.00';
	    },
	    safari: function () {
	        return rnd(531, 538) + '.' + rnd(0, 2) + '.' + rnd(0,2);
	    }
	};
	
	var browser = {
	    firefox: function firefox(arch) {
	        //https://developer.mozilla.org/en-US/docs/Gecko_user_agent_string_reference
	        var firefox_ver = rnd(5, 15) + randomRevision(2),
	            gecko_ver = 'Gecko/20100101 Firefox/' + firefox_ver,
	            proc = randomProc(arch),
	            os_ver = (arch === 'win') ? '(Windows NT ' + version_string.nt() + ((proc) ? '; ' + proc : '')
	            : (arch === 'mac') ? '(Macintosh; ' + proc + ' Mac OS X ' + version_string.osx()
	            : '(X11; Linux ' + proc;
	
	        return 'Mozilla/5.0 ' + os_ver + '; rv:' + firefox_ver.slice(0, -2) + ') ' + gecko_ver;
	    },
	
	    iexplorer: function iexplorer() {
	        var ver = version_string.ie();
	
	        if (ver >= 11) {
	            //http://msdn.microsoft.com/en-us/library/ie/hh869301(v=vs.85).aspx
	            return 'Mozilla/5.0 (Windows NT 6.' + rnd(1,3) + '; Trident/7.0; ' + rnd(['Touch; ', '']) + 'rv:11.0) like Gecko';
	        }
	
	        //http://msdn.microsoft.com/en-us/library/ie/ms537503(v=vs.85).aspx
	        return 'Mozilla/5.0 (compatible; MSIE ' + ver + '.0; Windows NT ' + version_string.nt() + '; Trident/' +
	            version_string.trident() + ((rnd(0, 1) === 1) ? '; .NET CLR ' + version_string.net() : '') + ')';
	    },
	
	    opera: function opera(arch) {
	        //http://www.opera.com/docs/history/
	        var presto_ver = ' Presto/' + version_string.presto() + ' Version/' + version_string.presto2() + ')',
	            os_ver = (arch === 'win') ? '(Windows NT ' + version_string.nt() + '; U; ' + randomLang() + presto_ver
	            : (arch === 'lin') ? '(X11; Linux ' + randomProc(arch) + '; U; ' + randomLang() + presto_ver
	            : '(Macintosh; Intel Mac OS X ' + version_string.osx() + ' U; ' + randomLang() + ' Presto/' +
	            version_string.presto() + ' Version/' + version_string.presto2() + ')';
	
	        return 'Opera/' + rnd(9, 14) + '.' + rnd(0, 99) + ' ' + os_ver;
	    },
	
	    safari: function safari(arch) {
	        var safari = version_string.safari(),
	            ver = rnd(4, 7) + '.' + rnd(0,1) + '.' + rnd(0,10),
	            os_ver = (arch === 'mac') ? '(Macintosh; ' + randomProc('mac') + ' Mac OS X '+ version_string.osx('_') + ' rv:' + rnd(2, 6) + '.0; '+ randomLang() + ') '
	            : '(Windows; U; Windows NT ' + version_string.nt() + ')';
	
	        return 'Mozilla/5.0 ' + os_ver + 'AppleWebKit/' + safari + ' (KHTML, like Gecko) Version/' + ver + ' Safari/' + safari;
	    },
	
	    chrome: function chrome(arch) {
	        var safari = version_string.safari(),
	            os_ver = (arch === 'mac') ? '(Macintosh; ' + randomProc('mac') + ' Mac OS X ' + version_string.osx('_') + ') '
	            : (arch === 'win') ? '(Windows; U; Windows NT ' + version_string.nt() + ')'
	            : '(X11; Linux ' + randomProc(arch);
	
	        return 'Mozilla/5.0 ' + os_ver + ' AppleWebKit/' + safari + ' (KHTML, like Gecko) Chrome/' + version_string.chrome() + ' Safari/' + safari;
	    }
	};
	
	exports.generate = function generate() {
	    var random = randomBrowserAndOS();
	    return browser[random[0]](random[1]);
	};


/***/ },
/* 1315 */
/***/ function(module, exports) {

	/**
	 * Check if argument is a HTML element.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.node = function(value) {
	    return value !== undefined
	        && value instanceof HTMLElement
	        && value.nodeType === 1;
	};
	
	/**
	 * Check if argument is a list of HTML elements.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.nodeList = function(value) {
	    var type = Object.prototype.toString.call(value);
	
	    return value !== undefined
	        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
	        && ('length' in value)
	        && (value.length === 0 || exports.node(value[0]));
	};
	
	/**
	 * Check if argument is a string.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.string = function(value) {
	    return typeof value === 'string'
	        || value instanceof String;
	};
	
	/**
	 * Check if argument is a function.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.fn = function(value) {
	    var type = Object.prototype.toString.call(value);
	
	    return type === '[object Function]';
	};


/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	var is = __webpack_require__(1315);
	var delegate = __webpack_require__(293);
	
	/**
	 * Validates all params and calls the right
	 * listener function based on its target type.
	 *
	 * @param {String|HTMLElement|HTMLCollection|NodeList} target
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listen(target, type, callback) {
	    if (!target && !type && !callback) {
	        throw new Error('Missing required arguments');
	    }
	
	    if (!is.string(type)) {
	        throw new TypeError('Second argument must be a String');
	    }
	
	    if (!is.fn(callback)) {
	        throw new TypeError('Third argument must be a Function');
	    }
	
	    if (is.node(target)) {
	        return listenNode(target, type, callback);
	    }
	    else if (is.nodeList(target)) {
	        return listenNodeList(target, type, callback);
	    }
	    else if (is.string(target)) {
	        return listenSelector(target, type, callback);
	    }
	    else {
	        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
	    }
	}
	
	/**
	 * Adds an event listener to a HTML element
	 * and returns a remove listener function.
	 *
	 * @param {HTMLElement} node
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenNode(node, type, callback) {
	    node.addEventListener(type, callback);
	
	    return {
	        destroy: function() {
	            node.removeEventListener(type, callback);
	        }
	    }
	}
	
	/**
	 * Add an event listener to a list of HTML elements
	 * and returns a remove listener function.
	 *
	 * @param {NodeList|HTMLCollection} nodeList
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenNodeList(nodeList, type, callback) {
	    Array.prototype.forEach.call(nodeList, function(node) {
	        node.addEventListener(type, callback);
	    });
	
	    return {
	        destroy: function() {
	            Array.prototype.forEach.call(nodeList, function(node) {
	                node.removeEventListener(type, callback);
	            });
	        }
	    }
	}
	
	/**
	 * Add an event listener to a selector
	 * and returns a remove listener function.
	 *
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenSelector(selector, type, callback) {
	    return delegate(document.body, selector, type, callback);
	}
	
	module.exports = listen;


/***/ },
/* 1317 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1330)
	  .extend('chance', function() {
	    try {
	      return __webpack_require__(124).Chance();
	    } catch (e) {
	      return null;
	    }
	  })
	  .extend('faker', function() {
	    try {
	      return __webpack_require__(355);
	    } catch (e) {
	      return null;
	    }
	  });


/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Registry = __webpack_require__(105);
	/**
	 * This class defines a registry for custom formats used within JSF.
	 */
	var OptionRegistry = (function (_super) {
	    __extends(OptionRegistry, _super);
	    function OptionRegistry() {
	        var _this = _super.call(this) || this;
	        _this.data['failOnInvalidTypes'] = true;
	        _this.data['defaultInvalidTypeProduct'] = null;
	        _this.data['useDefaultValue'] = false;
	        _this.data['requiredOnly'] = false;
	        _this.data['maxItems'] = null;
	        _this.data['maxLength'] = null;
	        _this.data['defaultMinItems'] = 0;
	        _this.data['defaultRandExpMax'] = 10;
	        _this.data['alwaysFakeOptionals'] = false;
	        return _this;
	    }
	    return OptionRegistry;
	}(Registry));
	module.exports = OptionRegistry;


/***/ },
/* 1320 */
/***/ function(module, exports) {

	// TODO: tsify
	"use strict";
	function isArray(obj) {
	    return obj && Array.isArray(obj);
	}
	function isObject(obj) {
	    return obj && obj !== null && typeof obj === 'object';
	}
	function hasNothing(obj) {
	    if (isArray(obj)) {
	        return obj.length === 0;
	    }
	    if (isObject(obj)) {
	        return Object.keys(obj).length === 0;
	    }
	    return typeof obj === 'undefined' || obj === null;
	}
	function removeProps(obj, key, parent) {
	    var i, value, isFullyEmpty = true;
	    if (isArray(obj)) {
	        for (i = 0; i < obj.length; ++i) {
	            value = obj[i];
	            if (isObject(value)) {
	                removeProps(value, i, obj);
	            }
	            if (hasNothing(value)) {
	                obj.splice(i--, 1);
	            }
	            else {
	                isFullyEmpty = false;
	            }
	        }
	    }
	    else {
	        for (i in obj) {
	            value = obj[i];
	            if (isObject(value)) {
	                removeProps(value, i, obj);
	            }
	            if (hasNothing(value)) {
	                delete obj[i];
	            }
	            else {
	                isFullyEmpty = false;
	            }
	        }
	    }
	    if (typeof key !== 'undefined' && isFullyEmpty) {
	        delete parent[key];
	        removeProps(obj);
	    }
	}
	module.exports = function (obj) {
	    removeProps(obj);
	    return obj;
	};


/***/ },
/* 1321 */
/***/ function(module, exports) {

	"use strict";
	var inferredProperties = {
	    array: [
	        'additionalItems',
	        'items',
	        'maxItems',
	        'minItems',
	        'uniqueItems'
	    ],
	    integer: [
	        'exclusiveMaximum',
	        'exclusiveMinimum',
	        'maximum',
	        'minimum',
	        'multipleOf'
	    ],
	    object: [
	        'additionalProperties',
	        'dependencies',
	        'maxProperties',
	        'minProperties',
	        'patternProperties',
	        'properties',
	        'required'
	    ],
	    string: [
	        'maxLength',
	        'minLength',
	        'pattern'
	    ]
	};
	inferredProperties.number = inferredProperties.integer;
	var subschemaProperties = [
	    'additionalItems',
	    'items',
	    'additionalProperties',
	    'dependencies',
	    'patternProperties',
	    'properties'
	];
	/**
	 * Iterates through all keys of `obj` and:
	 * - checks whether those keys match properties of a given inferred type
	 * - makes sure that `obj` is not a subschema; _Do not attempt to infer properties named as subschema containers. The
	 * reason for this is that any property name within those containers that matches one of the properties used for
	 * inferring missing type values causes the container itself to get processed which leads to invalid output. (Issue 62)_
	 *
	 * @returns {boolean}
	 */
	function matchesType(obj, lastElementInPath, inferredTypeProperties) {
	    return Object.keys(obj).filter(function (prop) {
	        var isSubschema = subschemaProperties.indexOf(lastElementInPath) > -1, inferredPropertyFound = inferredTypeProperties.indexOf(prop) > -1;
	        if (inferredPropertyFound && !isSubschema) {
	            return true;
	        }
	    }).length > 0;
	}
	/**
	 * Checks whether given `obj` type might be inferred. The mechanism iterates through all inferred types definitions,
	 * tries to match allowed properties with properties of given `obj`. Returns type name, if inferred, or null.
	 *
	 * @returns {string|null}
	 */
	function inferType(obj, schemaPath) {
	    for (var typeName in inferredProperties) {
	        var lastElementInPath = schemaPath[schemaPath.length - 1];
	        if (matchesType(obj, lastElementInPath, inferredProperties[typeName])) {
	            return typeName;
	        }
	    }
	}
	module.exports = inferType;


/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var deref = __webpack_require__(294);
	var traverse = __webpack_require__(1323);
	var random = __webpack_require__(6);
	var utils = __webpack_require__(36);
	function isKey(prop) {
	    return prop === 'enum' || prop === 'default' || prop === 'required' || prop === 'definitions';
	}
	// TODO provide types
	function run(schema, refs, ex) {
	    var $ = deref();
	    var _ = {};
	    try {
	        return traverse($(schema, refs, ex), [], function reduce(sub, maxReduceDepth) {
	            if (typeof maxReduceDepth === 'undefined') {
	                maxReduceDepth = random.number(1, 3);
	            }
	            if (!sub) {
	                return null;
	            }
	            if (typeof sub.$ref === 'string') {
	                var id = sub.$ref;
	                // match and increment seen references
	                if (!_[id]) {
	                    _[id] = 0;
	                }
	                _[id] += 1;
	                // cleanup
	                delete sub.$ref;
	                if (_[id] > maxReduceDepth) {
	                    delete sub.oneOf;
	                    delete sub.anyOf;
	                    delete sub.allOf;
	                    return sub;
	                }
	                utils.merge(sub, $.util.findByRef(id, $.refs));
	            }
	            if (Array.isArray(sub.allOf)) {
	                var schemas = sub.allOf;
	                delete sub.allOf;
	                // this is the only case where all sub-schemas
	                // must be resolved before any merge
	                schemas.forEach(function (schema) {
	                    utils.merge(sub, reduce(schema, maxReduceDepth + 1));
	                });
	            }
	            if (Array.isArray(sub.oneOf || sub.anyOf)) {
	                var mix = sub.oneOf || sub.anyOf;
	                delete sub.anyOf;
	                delete sub.oneOf;
	                utils.merge(sub, random.pick(mix));
	            }
	            for (var prop in sub) {
	                if ((Array.isArray(sub[prop]) || typeof sub[prop] === 'object') && !isKey(prop)) {
	                    sub[prop] = reduce(sub[prop], maxReduceDepth);
	                }
	            }
	            return sub;
	        });
	    }
	    catch (e) {
	        if (e.path) {
	            throw new Error(e.message + ' in ' + '/' + e.path.join('/'));
	        }
	        else {
	            throw e;
	        }
	    }
	}
	module.exports = run;


/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var clean = __webpack_require__(1320);
	var random = __webpack_require__(6);
	var ParseError = __webpack_require__(59);
	var inferType = __webpack_require__(1321);
	var types = __webpack_require__(1334);
	var option = __webpack_require__(17);
	function isExternal(schema) {
	    return schema.faker || schema.chance || schema.casual;
	}
	function reduceExternal(schema, path) {
	    if (schema['x-faker']) {
	        schema.faker = schema['x-faker'];
	    }
	    if (schema['x-chance']) {
	        schema.chance = schema['x-chance'];
	    }
	    if (schema['x-casual']) {
	        schema.casual = schema['x-casual'];
	    }
	    var count = (schema.faker !== undefined ? 1 : 0) +
	        (schema.chance !== undefined ? 1 : 0) +
	        (schema.casual !== undefined ? 1 : 0);
	    if (count > 1) {
	        throw new ParseError('ambiguous generator mixing faker, chance or casual: ' + JSON.stringify(schema), path);
	    }
	    return schema;
	}
	// TODO provide types
	function traverse(schema, path, resolve) {
	    resolve(schema);
	    if (Array.isArray(schema["enum"])) {
	        return random.pick(schema["enum"]);
	    }
	    if (option('useDefaultValue') && 'default' in schema) {
	        return schema["default"];
	    }
	    // TODO remove the ugly overcome
	    var type = schema.type;
	    if (Array.isArray(type)) {
	        type = random.pick(type);
	    }
	    else if (typeof type === 'undefined') {
	        // Attempt to infer the type
	        type = inferType(schema, path) || type;
	    }
	    schema = reduceExternal(schema, path);
	    if (isExternal(schema)) {
	        type = 'external';
	    }
	    if (typeof type === 'string') {
	        if (!types[type]) {
	            if (option('failOnInvalidTypes')) {
	                throw new ParseError('unknown primitive ' + JSON.stringify(type), path.concat(['type']));
	            }
	            else {
	                return option('defaultInvalidTypeProduct');
	            }
	        }
	        else {
	            try {
	                return types[type](schema, path, resolve, traverse);
	            }
	            catch (e) {
	                if (typeof e.path === 'undefined') {
	                    throw new ParseError(e.message, path);
	                }
	                throw e;
	            }
	        }
	    }
	    var copy = {};
	    if (Array.isArray(schema)) {
	        copy = [];
	    }
	    for (var prop in schema) {
	        if (typeof schema[prop] === 'object' && prop !== 'definitions') {
	            copy[prop] = traverse(schema[prop], path.concat([prop]), resolve);
	        }
	        else {
	            copy[prop] = schema[prop];
	        }
	    }
	    return clean(copy);
	}
	module.exports = traverse;


/***/ },
/* 1324 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Generates randomized boolean value.
	 *
	 * @returns {boolean}
	 */
	function booleanGenerator() {
	    return Math.random() > 0.5;
	}
	module.exports = booleanGenerator;


/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var container = __webpack_require__(24);
	var randexp = container.get('randexp');
	/**
	 * Predefined core formats
	 * @type {[key: string]: string}
	 */
	var regexps = {
	    email: '[a-zA-Z\\d][a-zA-Z\\d-]{1,13}[a-zA-Z\\d]@{hostname}',
	    hostname: '[a-zA-Z]{1,33}\\.[a-z]{2,4}',
	    ipv6: '[a-f\\d]{4}(:[a-f\\d]{4}){7}',
	    uri: '[a-zA-Z][a-zA-Z0-9+-.]*'
	};
	/**
	 * Generates randomized string basing on a built-in regex format
	 *
	 * @param coreFormat
	 * @returns {string}
	 */
	function coreFormatGenerator(coreFormat) {
	    return randexp(regexps[coreFormat]).replace(/\{(\w+)\}/, function (match, key) {
	        return randexp(regexps[key]);
	    });
	}
	module.exports = coreFormatGenerator;


/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var random = __webpack_require__(6);
	/**
	 * Generates randomized date time ISO format string.
	 *
	 * @returns {string}
	 */
	function dateTimeGenerator() {
	    return new Date(random.number(0, 100000000000000)).toISOString();
	}
	module.exports = dateTimeGenerator;


/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var random = __webpack_require__(6);
	/**
	 * Generates randomized ipv4 address.
	 *
	 * @returns {string}
	 */
	function ipv4Generator() {
	    return [0, 0, 0, 0].map(function () {
	        return random.number(0, 255);
	    }).join('.');
	}
	module.exports = ipv4Generator;


/***/ },
/* 1328 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Generates null value.
	 *
	 * @returns {null}
	 */
	function nullGenerator() {
	    return null;
	}
	module.exports = nullGenerator;


/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var words = __webpack_require__(106);
	var random = __webpack_require__(6);
	/**
	 * Helper function used by thunkGenerator to produce some words for the final result.
	 *
	 * @returns {string}
	 */
	function produce() {
	    var length = random.number(1, 5);
	    return words(length).join(' ');
	}
	/**
	 * Generates randomized concatenated string based on words generator.
	 *
	 * @returns {string}
	 */
	function thunkGenerator(min, max) {
	    if (min === void 0) { min = 0; }
	    if (max === void 0) { max = 140; }
	    var min = Math.max(0, min), max = random.number(min, max), result = produce();
	    // append until length is reached
	    while (result.length < min) {
	        result += produce();
	    }
	    // cut if needed
	    if (result.length > max) {
	        result = result.substr(0, max);
	    }
	    return result;
	}
	module.exports = thunkGenerator;


/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var container = __webpack_require__(24);
	var format = __webpack_require__(104);
	var option = __webpack_require__(17);
	var run = __webpack_require__(1322);
	var jsf = function (schema, refs) {
	    return run(schema, refs);
	};
	jsf.format = format;
	jsf.option = option;
	// returns itself for chaining
	jsf.extend = function (name, cb) {
	    container.extend(name, cb);
	    return jsf;
	};
	jsf.version = '0.4.0';
	module.exports = jsf;


/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var random = __webpack_require__(6);
	var utils = __webpack_require__(36);
	var ParseError = __webpack_require__(59);
	var option = __webpack_require__(17);
	// TODO provide types
	function unique(path, items, value, sample, resolve, traverseCallback) {
	    var tmp = [], seen = [];
	    function walk(obj) {
	        var json = JSON.stringify(obj);
	        if (seen.indexOf(json) === -1) {
	            seen.push(json);
	            tmp.push(obj);
	        }
	    }
	    items.forEach(walk);
	    // TODO: find a better solution?
	    var limit = 100;
	    while (tmp.length !== items.length) {
	        walk(traverseCallback(value.items || sample, path, resolve));
	        if (!limit--) {
	            break;
	        }
	    }
	    return tmp;
	}
	// TODO provide types
	var arrayType = function arrayType(value, path, resolve, traverseCallback) {
	    var items = [];
	    if (!(value.items || value.additionalItems)) {
	        if (utils.hasProperties(value, 'minItems', 'maxItems', 'uniqueItems')) {
	            throw new ParseError('missing items for ' + JSON.stringify(value), path);
	        }
	        return items;
	    }
	    // see http://stackoverflow.com/a/38355228/769384
	    // after type guards support subproperties (in TS 2.0) we can simplify below to (value.items instanceof Array)
	    // so that value.items.map becomes recognized for typescript compiler
	    var tmpItems = value.items;
	    if (tmpItems instanceof Array) {
	        return Array.prototype.concat.apply(items, tmpItems.map(function (item, key) {
	            var itemSubpath = path.concat(['items', key + '']);
	            return traverseCallback(item, itemSubpath, resolve);
	        }));
	    }
	    var minItems = value.minItems;
	    var maxItems = value.maxItems;
	    if (option('defaultMinItems') && minItems === undefined) {
	        // fix boundaries
	        minItems = !maxItems
	            ? option('defaultMinItems')
	            : Math.min(option('defaultMinItems'), maxItems);
	    }
	    if (option('maxItems')) {
	        // Don't allow user to set max items above our maximum
	        if (maxItems && maxItems > option('maxItems')) {
	            maxItems = option('maxItems');
	        }
	        // Don't allow user to set min items above our maximum
	        if (minItems && minItems > option('maxItems')) {
	            minItems = maxItems;
	        }
	    }
	    var length = random.number(minItems, maxItems, 1, 5), 
	    // TODO below looks bad. Should additionalItems be copied as-is?
	    sample = typeof value.additionalItems === 'object' ? value.additionalItems : {};
	    for (var current = items.length; current < length; current++) {
	        var itemSubpath = path.concat(['items', current + '']);
	        var element = traverseCallback(value.items || sample, itemSubpath, resolve);
	        items.push(element);
	    }
	    if (value.uniqueItems) {
	        return unique(path.concat(['items']), items, value, sample, resolve, traverseCallback);
	    }
	    return items;
	};
	module.exports = arrayType;


/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var booleanGenerator = __webpack_require__(1324);
	var booleanType = booleanGenerator;
	module.exports = booleanType;


/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var utils = __webpack_require__(36);
	var container = __webpack_require__(24);
	var externalType = function externalType(value, path) {
	    var libraryName = value.faker ? 'faker' : (value.chance ? 'chance' : 'casual'), libraryModule = container.get(libraryName), key = value.faker || value.chance || value.casual, path = key, args = [];
	    if (typeof path === 'object') {
	        path = Object.keys(path)[0];
	        if (Array.isArray(key[path])) {
	            args = key[path];
	        }
	        else {
	            args.push(key[path]);
	        }
	    }
	    var genFunction = utils.getSubAttribute(libraryModule, path);
	    try {
	        // see #116, #117 - faker.js 3.1.0 introduced local dependencies between generators
	        // making jsf break after upgrading from 3.0.1
	        var contextObject = libraryModule;
	        if (libraryName === 'faker') {
	            var parts = path.split('.');
	            while (parts.length > 1) {
	                contextObject = libraryModule[parts.shift()];
	            }
	            genFunction = contextObject[parts[0]];
	        }
	    }
	    catch (e) {
	        throw new Error('cannot resolve ' + libraryName + '-generator for ' + JSON.stringify(key));
	    }
	    if (typeof genFunction !== 'function') {
	        if (libraryName === 'casual') {
	            return utils.typecast(genFunction, value.type);
	        }
	        throw new Error('unknown ' + libraryName + '-generator for ' + JSON.stringify(key));
	    }
	    var result = genFunction.apply(contextObject, args);
	    return utils.typecast(result, value.type);
	};
	module.exports = externalType;


/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var _boolean = __webpack_require__(1332);
	var _null = __webpack_require__(1336);
	var _array = __webpack_require__(1331);
	var _integer = __webpack_require__(1335);
	var _number = __webpack_require__(107);
	var _object = __webpack_require__(1337);
	var _string = __webpack_require__(1338);
	var _external = __webpack_require__(1333);
	var typeMap = {
	    boolean: _boolean,
	    "null": _null,
	    array: _array,
	    integer: _integer,
	    number: _number,
	    object: _object,
	    string: _string,
	    external: _external
	};
	module.exports = typeMap;


/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var number = __webpack_require__(107);
	// The `integer` type is just a wrapper for the `number` type. The `number` type
	// returns floating point numbers, and `integer` type truncates the fraction
	// part, leaving the result as an integer.
	var integerType = function integerType(value) {
	    var generated = number(value);
	    // whether the generated number is positive or negative, need to use either
	    // floor (positive) or ceil (negative) function to get rid of the fraction
	    return generated > 0 ? Math.floor(generated) : Math.ceil(generated);
	};
	module.exports = integerType;


/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var nullGenerator = __webpack_require__(1328);
	var nullType = nullGenerator;
	module.exports = nullType;


/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var container = __webpack_require__(24);
	var random = __webpack_require__(6);
	var words = __webpack_require__(106);
	var utils = __webpack_require__(36);
	var option = __webpack_require__(17);
	var ParseError = __webpack_require__(59);
	var randexp = container.get('randexp');
	// fallback generator
	var anyType = { type: ['string', 'number', 'integer', 'boolean'] };
	// TODO provide types
	var objectType = function objectType(value, path, resolve, traverseCallback) {
	    var props = {};
	    var properties = value.properties || {};
	    var patternProperties = value.patternProperties || {};
	    var requiredProperties = (value.required || []).slice();
	    var allowsAdditional = value.additionalProperties === false ? false : true;
	    var propertyKeys = Object.keys(properties);
	    var patternPropertyKeys = Object.keys(patternProperties);
	    var additionalProperties = allowsAdditional
	        ? (value.additionalProperties === true ? {} : value.additionalProperties)
	        : null;
	    if (!allowsAdditional &&
	        propertyKeys.length === 0 &&
	        patternPropertyKeys.length === 0 &&
	        utils.hasProperties(value, 'minProperties', 'maxProperties', 'dependencies', 'required')) {
	        throw new ParseError('missing properties for:\n' + JSON.stringify(value, null, '  '), path);
	    }
	    if (option('requiredOnly') === true) {
	        requiredProperties.forEach(function (key) {
	            if (properties[key]) {
	                props[key] = properties[key];
	            }
	        });
	        return traverseCallback(props, path.concat(['properties']), resolve);
	    }
	    var min = Math.max(value.minProperties || 0, requiredProperties.length);
	    var max = Math.max(value.maxProperties || random.number(min, min + 5));
	    random.shuffle(patternPropertyKeys.concat(propertyKeys)).forEach(function (_key) {
	        if (requiredProperties.indexOf(_key) === -1) {
	            requiredProperties.push(_key);
	        }
	    });
	    // properties are read from right-to-left
	    var _props = option('alwaysFakeOptionals') ? requiredProperties
	        : requiredProperties.slice(0, random.number(min, max));
	    _props.forEach(function (key) {
	        // first ones are the required properies
	        if (properties[key]) {
	            props[key] = properties[key];
	        }
	        else {
	            var found;
	            // then try patternProperties
	            patternPropertyKeys.forEach(function (_key) {
	                if (key.match(new RegExp(_key))) {
	                    found = true;
	                    props[randexp(key)] = patternProperties[_key];
	                }
	            });
	            if (!found) {
	                // try patternProperties again,
	                var subschema = patternProperties[key] || additionalProperties;
	                if (subschema) {
	                    // otherwise we can use additionalProperties?
	                    props[patternProperties[key] ? randexp(key) : key] = subschema;
	                }
	            }
	        }
	    });
	    var current = Object.keys(props).length;
	    while (true) {
	        if (!(patternPropertyKeys.length || allowsAdditional)) {
	            break;
	        }
	        if (current >= min) {
	            break;
	        }
	        if (allowsAdditional) {
	            var word = words(1) + randexp('[a-f\\d]{1,3}');
	            if (!props[word]) {
	                props[word] = additionalProperties || anyType;
	                current += 1;
	            }
	        }
	        patternPropertyKeys.forEach(function (_key) {
	            var word = randexp(_key);
	            if (!props[word]) {
	                props[word] = patternProperties[_key];
	                current += 1;
	            }
	        });
	    }
	    if (!allowsAdditional && current < min) {
	        throw new ParseError('properties constraints were too strong to successfully generate a valid object for:\n' +
	            JSON.stringify(value, null, '  '), path);
	    }
	    return traverseCallback(props, path.concat(['properties']), resolve);
	};
	module.exports = objectType;


/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var thunk = __webpack_require__(1329);
	var ipv4 = __webpack_require__(1327);
	var dateTime = __webpack_require__(1326);
	var coreFormat = __webpack_require__(1325);
	var format = __webpack_require__(104);
	var option = __webpack_require__(17);
	var container = __webpack_require__(24);
	var randexp = container.get('randexp');
	function generateFormat(value) {
	    switch (value.format) {
	        case 'date-time':
	            return dateTime();
	        case 'ipv4':
	            return ipv4();
	        case 'regex':
	            // TODO: discuss
	            return '.+?';
	        case 'email':
	        case 'hostname':
	        case 'ipv6':
	        case 'uri':
	            return coreFormat(value.format);
	        default:
	            var callback = format(value.format);
	            return callback(container.getAll(), value);
	    }
	}
	var stringType = function stringType(value) {
	    var output;
	    var minLength = value.minLength;
	    var maxLength = value.maxLength;
	    if (option('maxLength')) {
	        // Don't allow user to set max length above our maximum
	        if (maxLength && maxLength > option('maxLength')) {
	            maxLength = option('maxLength');
	        }
	        // Don't allow user to set min length above our maximum
	        if (minLength && minLength > option('maxLength')) {
	            minLength = option('maxLength');
	        }
	    }
	    if (value.format) {
	        output = generateFormat(value);
	    }
	    else if (value.pattern) {
	        output = randexp(value.pattern);
	    }
	    else {
	        output = thunk(minLength, maxLength);
	    }
	    while (output.length < minLength) {
	        output += Math.random() > 0.7 ? thunk() : randexp('.+');
	    }
	    if (output.length > maxLength) {
	        output = output.substr(0, maxLength);
	    }
	    return output;
	};
	module.exports = stringType;


/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1342);

/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	Generates an Abstract Syntax Tree
	used for generating the schema.
	
	@see: https://en.wikipedia.org/wiki/Abstract_syntax_tree
	*/
	var utils = __webpack_require__(60);
	var crypto = __webpack_require__(287);
	
	/**
	Abstract Syntax Tree Class
	
	@class AST
	@return {Object}
	*/
	var AST = function() {
	  if (!this instanceof AST) {
	    return new AST();
	  }
	
	  this.tree = {};
	};
	
	/**
	Computes the hex hash of the given value
	
	@method generateHash
	@param {Mixed} value Value to hash
	@return {String} HEX value.
	*/
	AST.prototype.generateHash = function(value) {
	 if (utils.isObject(value)) {
	    var keys = Object.keys(value);
	    return crypto.createHash("md5").update(JSON.stringify(keys)).digest("hex");
	  } else if (utils.Array(value)) {
	    return crypto.createHash("md5").update(JSON.stringify(value)).digest("hex");
	  } else {
	    return crypto.createHash("md5").update(value).digest("hex");
	  }
	};
	
	/**
	Checks if the elements in the given node are all
	equal. 
	
	@method isAllSimilarObject
	@param {Object} node JSON node to inspect
	@return {Object}
	*/
	AST.prototype.isAllSimilarObjects = function(node) {
	  var hashes = [];
	  var max = 0;
	  var selected = null;
	  for (var i in node) {
	    var hash = this.generateHash(node[i]);
	    hashes[hash] = true;
	    var keys = Object.keys(node[i]);
	    if (!max || keys.length > max) {
	      max = keys.length;
	      selected = node[i];
	    }
	  }
	
	  return {same: (hashes.length === 1), selected: selected};
	}
	
	/**
	Inspect primitatives and apply the correct type
	and mark as required if the element contains a value.
	
	@method buildPrimitive
	@param {Object} tree Schema which represents the node
	@param {Node} node The JSON node being inspected
	@return void
	*/
	AST.prototype.buildPrimitive = function(tree, node) {
	  tree.type = utils.getType(node);
	  if (tree.type === 'string') {
	    tree.minLength = (node.length > 0) ? 1 : 0;
	  } 
	
	  if (node !== null && typeof node !== 'undefined') {
	    tree.required = true;
	  }
	}
	
	/**
	Inspect object properties and apply the correct
	type and mark as required if the element has set 
	properties.
	
	@method buildObject
	@param {Object} tree Schema which represents the node
	@param {Node} node The JSON node being inspected
	*/
	AST.prototype.buildObjectTree = function(tree, node) {
	  tree.type = tree.type || 'object';
	  tree.children = tree.children || {};
	  for (var i in node) {
	    if (utils.isObject(node[i])) {
	      tree.children[i] = {};
	      this.buildObjectTree(tree.children[i], node[i]);
	      continue;
	    } else if (utils.isArray(node[i])) {
	      tree.children[i] = {};
	      this.buildArrayTree(tree.children[i], node[i]);
	    } else {
	      tree.children[i] = {};
	      this.buildPrimitive(tree.children[i], node[i]);
	    } 
	  }
	};
	
	/**
	Inspect array elements apply the correct
	type and mark as required if the element has 
	set properties.
	
	@method buildObject
	@param {Object} tree Schema which represents the node
	@param {Node} node The JSON node being inspected
	*/
	AST.prototype.buildArrayTree = function(tree, node) {
	  tree.type = 'array';
	  tree.children = {};
	  var first = node[0];
	  if (utils.isObject(first)) {
	    var similar = this.isAllSimilarObjects(node);
	    if (this.isAllSimilarObjects(node)) {
	      tree.uniqueItems = true;
	      tree.minItems = 1;
	
	      return this.buildObjectTree(tree, similar.selected);
	    }
	  };
	
	  for (var i=0; i<node.length; i++) {
	    if (utils.isObject(node[i])) {
	      tree.children[i] = {};
	      tree.children[i].type = 'object';
	      var keys = Object.keys(node[i]);
	      if (keys.length > 0) {
	        tree.children[i].required = true;
	      }
	      this.buildObjectTree(tree.children[i], node[i]);
	    } else if (utils.isArray(node[i])) {
	      tree.children[i] = {};
	      tree.children[i].type = 'array';
	      tree.children[i].uniqueItems = true;
	      if (node[i].length > 0) {
	        tree.children[i].required = true;
	      }
	      this.buildArrayTree(tree.children[i], node[i]);
	    } else {
	      if (tree.type === 'object') {
	        tree.children[i] = {};
	        this.buildPrimitive(tree.children[i], node[i]);
	      }
	    }
	  }
	};
	
	/**
	Initiates generating the AST from the 
	given JSON document.
	
	@param {Object} json JSON object
	@return void
	*/
	AST.prototype.build = function(json) {
	  if (json instanceof Array) {
	    this.buildArrayTree(this.tree, json);
	  } else {
	    this.buildObjectTree(this.tree, json);
	  }
	};
	
	module.exports = AST;

/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(60);
	
	/**
	Schema generator using a AST
	tree.
	
	@class Compiler
	*/
	var Compiler = function() {
	  if (!this instanceof Compiler) {
	    return new Compiler();
	  }
	
	  this.schema = {};
	};
	
	/**
	Generates a JSON schema based on the provided AST tree.
	
	@method generate
	@param {Object} tree AST
	@param {Object} schema The schema object
	@param {Object} parent Schema node parent object
	@return void
	*/
	Compiler.prototype.generate = function(tree, schema, parent) {
	  for (var i in tree.children) {
	    var child = tree.children[i];
	    if (child.type === 'object') {
	      if (utils.isArray(parent.required)) {
	        parent.required.push(i);
	      }
	      schema[i] = {
	        type: 'object'
	        ,properties: {}
	        ,required: []
	      };
	      this.generate(child, schema[i].properties, schema[i]);
	    } else if (child.type === 'array') {
	      if (utils.isArray(parent.required)) {
	        parent.required.push(i);
	      }
	      schema[i] = {
	        type: 'array'
	        ,uniqueItems: child.uniqueItems
	        ,minItems: child.minItems
	        ,items: {
	          required:[]
	          ,properties: {}
	        }
	      }
	      this.generate(child, schema[i].items.properties, schema[i]);
	    } else {
	      schema[i] = {};
	      if (child.type) {
	        schema[i].type = child.type;
	      }
	
	      if (child.minLength) { 
	        schema[i].minLength = child.minLength;
	      }
	
	      if (child.required) {
	        if (parent.items && utils.isArray(parent.items.required)) {
	          parent.items.required.push(i);
	        } else {
	          parent.required.push(i);
	        }
	      }
	    }
	  }
	};
	
	/**
	Initates compiling the given AST into a
	JSON schema.
	
	@method compile
	@param {Object} tree AST object
	@return void
	*/
	Compiler.prototype.compile = function(tree) {
	  if (tree.type === 'object') {
	   this.schema = {
	    '$schema': 'http://json-schema.org/draft-04/schema#'
	    ,description: ''
	    ,type: 'object'
	    ,properties: {}
	    ,required: []
	   };
	   this.generate(tree, this.schema.properties, this.schema);
	  } else {
	    this.schema = {
	      type: 'array'
	      ,'$schema': 'http://json-schema.org/draft-04/schema#'
	      ,'description': ''
	      ,minItems: 1
	      ,uniqueItems: true
	      ,items: {
	        type: 'object'
	        ,required: []
	        ,properties: {}
	      }
	    };
	
	    this.generate(tree, this.schema.items.properties, this.schema.items);
	  }
	};
	
	module.exports = Compiler;

/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Compiler = __webpack_require__(1341);
	var AST = __webpack_require__(1340);
	var utils = __webpack_require__(60);
	
	var jsonToSchema = function(json) {
	  var compiler = new Compiler();
	  var ast = new AST();
	  ast.build(json);
	  compiler.compile(ast.tree);
	  return compiler.schema;
	};
	
	module.exports = jsonToSchema;


/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function(crypto) {
	  function pbkdf2(password, salt, iterations, keylen, digest, callback) {
	    if ('function' === typeof digest) {
	      callback = digest
	      digest = undefined
	    }
	
	    if ('function' !== typeof callback)
	      throw new Error('No callback provided to pbkdf2')
	
	    setTimeout(function() {
	      var result
	
	      try {
	        result = pbkdf2Sync(password, salt, iterations, keylen, digest)
	      } catch (e) {
	        return callback(e)
	      }
	
	      callback(undefined, result)
	    })
	  }
	
	  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
	    if ('number' !== typeof iterations)
	      throw new TypeError('Iterations not a number')
	
	    if (iterations < 0)
	      throw new TypeError('Bad iterations')
	
	    if ('number' !== typeof keylen)
	      throw new TypeError('Key length not a number')
	
	    if (keylen < 0)
	      throw new TypeError('Bad key length')
	
	    digest = digest || 'sha1'
	
	    if (!Buffer.isBuffer(password)) password = new Buffer(password)
	    if (!Buffer.isBuffer(salt)) salt = new Buffer(salt)
	
	    var hLen, l = 1, r, T
	    var DK = new Buffer(keylen)
	    var block1 = new Buffer(salt.length + 4)
	    salt.copy(block1, 0, 0, salt.length)
	
	    for (var i = 1; i <= l; i++) {
	      block1.writeUInt32BE(i, salt.length)
	
	      var U = crypto.createHmac(digest, password).update(block1).digest()
	
	      if (!hLen) {
	        hLen = U.length
	        T = new Buffer(hLen)
	        l = Math.ceil(keylen / hLen)
	        r = keylen - (l - 1) * hLen
	
	        if (keylen > (Math.pow(2, 32) - 1) * hLen)
	          throw new TypeError('keylen exceeds maximum length')
	      }
	
	      U.copy(T, 0, 0, hLen)
	
	      for (var j = 1; j < iterations; j++) {
	        U = crypto.createHmac(digest, password).update(U).digest()
	
	        for (var k = 0; k < hLen; k++) {
	          T[k] ^= U[k]
	        }
	      }
	
	      var destPos = (i - 1) * hLen
	      var len = (i == l ? r : hLen)
	      T.copy(DK, destPos, 0, len)
	    }
	
	    return DK
	  }
	
	  return {
	    pbkdf2: pbkdf2,
	    pbkdf2Sync: pbkdf2Sync
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	var ret = __webpack_require__(1351);
	var DRange = __webpack_require__(298);
	var types = ret.types;
	
	
	/**
	 * If code is alphabetic, converts to other case.
	 * If not alphabetic, returns back code.
	 *
	 * @param {Number} code
	 * @return {Number}
	 */
	function toOtherCase(code) {
	  return code + (97 <= code && code <= 122 ? -32 :
	                 65 <= code && code <= 90  ?  32 : 0);
	}
	
	
	/**
	 * Randomly returns a true or false value.
	 *
	 * @return {Boolean}
	 */
	function randBool() {
	  return !this.randInt(0, 1);
	}
	
	
	/**
	 * Randomly selects and returns a value from the array.
	 *
	 * @param {Array.<Object>} arr
	 * @return {Object}
	 */
	function randSelect(arr) {
	  if (arr instanceof DRange) {
	    return arr.index(this.randInt(0, arr.length - 1));
	  }
	  return arr[this.randInt(0, arr.length - 1)];
	}
	
	
	/**
	 * expands a token to a DiscontinuousRange of characters which has a
	 * length and an index function (for random selecting)
	 *
	 * @param {Object} token
	 * @return {DiscontinuousRange}
	 */
	function expand(token) {
	  if (token.type === ret.types.CHAR) {
	    return new DRange(token.value);
	  } else if (token.type === ret.types.RANGE) {
	    return new DRange(token.from, token.to);
	  } else {
	    var drange = new DRange();
	    for (var i = 0; i < token.set.length; i++) {
	      var subrange = expand.call(this, token.set[i]);
	      drange.add(subrange);
	      if (this.ignoreCase) {
	        for (var j = 0; j < subrange.length; j++) {
	          var code = subrange.index(j);
	          var otherCaseCode = toOtherCase(code);
	          if (code !== otherCaseCode) {
	            drange.add(otherCaseCode);
	          }
	        }
	      }
	    }
	    if (token.not) {
	      return this.defaultRange.clone().subtract(drange);
	    } else {
	      return drange;
	    }
	  }
	}
	
	
	/**
	 * Checks if some custom properties have been set for this regexp.
	 *
	 * @param {RandExp} randexp
	 * @param {RegExp} regexp
	 */
	function checkCustom(randexp, regexp) {
	  if (typeof regexp.max === 'number') {
	    randexp.max = regexp.max;
	  }
	  if (regexp.defaultRange instanceof DRange) {
	    randexp.defaultRange = regexp.defaultRange;
	  }
	  if (typeof regexp.randInt === 'function') {
	    randexp.randInt = regexp.randInt;
	  }
	}
	
	
	/**
	 * @constructor
	 * @param {RegExp|String} regexp
	 * @param {String} m
	 */
	var RandExp = module.exports = function(regexp, m) {
	  this.defaultRange = this.defaultRange.clone();
	  if (regexp instanceof RegExp) {
	    this.ignoreCase = regexp.ignoreCase;
	    this.multiline = regexp.multiline;
	    checkCustom(this, regexp);
	    regexp = regexp.source;
	
	  } else if (typeof regexp === 'string') {
	    this.ignoreCase = m && m.indexOf('i') !== -1;
	    this.multiline = m && m.indexOf('m') !== -1;
	  } else {
	    throw new Error('Expected a regexp or string');
	  }
	
	  this.tokens = ret(regexp);
	};
	
	
	// When a repetitional token has its max set to Infinite,
	// randexp won't actually generate a random amount between min and Infinite
	// instead it will see Infinite as min + 100.
	RandExp.prototype.max = 100;
	
	
	// Generates the random string.
	RandExp.prototype.gen = function() {
	  return gen.call(this, this.tokens, []);
	};
	
	
	// Enables use of randexp with a shorter call.
	RandExp.randexp = function(regexp, m) {
	  var randexp;
	  if (regexp._randexp === undefined) {
	    randexp = new RandExp(regexp, m);
	    regexp._randexp = randexp;
	  } else {
	    randexp = regexp._randexp;
	  }
	  checkCustom(randexp, regexp);
	  return randexp.gen();
	};
	
	
	// This enables sugary /regexp/.gen syntax.
	RandExp.sugar = function() {
	  /* jshint freeze:false */
	  RegExp.prototype.gen = function() {
	    return RandExp.randexp(this);
	  };
	};
	
	// This allows expanding to include additional characters
	// for instance: RandExp.defaultRange.add(0, 65535);
	RandExp.prototype.defaultRange = new DRange(32, 126);
	
	
	/**
	 * Randomly generates and returns a number between a and b (inclusive).
	 *
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Number}
	 */
	RandExp.prototype.randInt = function(a, b) {
	  return a + Math.floor(Math.random() * (1 + b - a));
	};
	
	
	/**
	 * Generate random string modeled after given tokens.
	 *
	 * @param {Object} token
	 * @param {Array.<String>} groups
	 * @return {String}
	 */
	function gen(token, groups) {
	  var stack, str, n, i, l;
	
	  switch (token.type) {
	
	
	    case types.ROOT:
	    case types.GROUP:
	      // Ignore lookaheads for now.
	      if (token.followedBy || token.notFollowedBy) { return ''; }
	
	      // Insert placeholder until group string is generated.
	      if (token.remember && token.groupNumber === undefined) {
	        token.groupNumber = groups.push(null) - 1;
	      }
	
	      stack = token.options ?
	        randSelect.call(this, token.options) : token.stack;
	
	      str = '';
	      for (i = 0, l = stack.length; i < l; i++) {
	        str += gen.call(this, stack[i], groups);
	      }
	
	      if (token.remember) {
	        groups[token.groupNumber] = str;
	      }
	      return str;
	
	
	    case types.POSITION:
	      // Do nothing for now.
	      return '';
	
	
	    case types.SET:
	      var expandedSet = expand.call(this, token);
	      if (!expandedSet.length) { return ''; }
	      return String.fromCharCode(randSelect.call(this, expandedSet));
	
	
	    case types.REPETITION:
	      // Randomly generate number between min and max.
	      n = this.randInt(token.min,
	              token.max === Infinity ? token.min + this.max : token.max);
	
	      str = '';
	      for (i = 0; i < n; i++) {
	        str += gen.call(this, token.value, groups);
	      }
	
	      return str;
	
	
	    case types.REFERENCE:
	      return groups[token.value - 1] || '';
	
	
	    case types.CHAR:
	      var code = this.ignoreCase && randBool.call(this) ?
	        toOtherCase(token.value) : token.value;
	      return String.fromCharCode(code);
	  }
	}
	
	


/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(11)


/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(3).Buffer;
	/*<replacement>*/
	var bufferShim = __webpack_require__(42);
	/*</replacement>*/
	
	module.exports = BufferList;
	
	function BufferList() {
	  this.head = null;
	  this.tail = null;
	  this.length = 0;
	}
	
	BufferList.prototype.push = function (v) {
	  var entry = { data: v, next: null };
	  if (this.length > 0) this.tail.next = entry;else this.head = entry;
	  this.tail = entry;
	  ++this.length;
	};
	
	BufferList.prototype.unshift = function (v) {
	  var entry = { data: v, next: this.head };
	  if (this.length === 0) this.tail = entry;
	  this.head = entry;
	  ++this.length;
	};
	
	BufferList.prototype.shift = function () {
	  if (this.length === 0) return;
	  var ret = this.head.data;
	  if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	  --this.length;
	  return ret;
	};
	
	BufferList.prototype.clear = function () {
	  this.head = this.tail = null;
	  this.length = 0;
	};
	
	BufferList.prototype.join = function (s) {
	  if (this.length === 0) return '';
	  var p = this.head;
	  var ret = '' + p.data;
	  while (p = p.next) {
	    ret += s + p.data;
	  }return ret;
	};
	
	BufferList.prototype.concat = function (n) {
	  if (this.length === 0) return bufferShim.alloc(0);
	  if (this.length === 1) return this.head.data;
	  var ret = bufferShim.allocUnsafe(n >>> 0);
	  var p = this.head;
	  var i = 0;
	  while (p) {
	    p.data.copy(ret, i);
	    i += p.data.length;
	    p = p.next;
	  }
	  return ret;
	};

/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(108)


/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var Stream = (function (){
	  try {
	    return __webpack_require__(38); // hack to fix a circular dependency issue when used with browserify
	  } catch(_){}
	}());
	exports = module.exports = __webpack_require__(109);
	exports.Stream = Stream || exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(63);
	exports.Duplex = __webpack_require__(11);
	exports.Transform = __webpack_require__(62);
	exports.PassThrough = __webpack_require__(108);
	
	if (!process.browser && ({"NODE_ENV":"production"}).READABLE_STREAM === 'disable' && Stream) {
	  module.exports = Stream;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(62)


/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(63)


/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	var util      = __webpack_require__(1353);
	var types     = __webpack_require__(37);
	var sets      = __webpack_require__(110);
	var positions = __webpack_require__(1352);
	
	
	module.exports = function(regexpStr) {
	  var i = 0, l, c,
	      start = { type: types.ROOT, stack: []},
	
	      // Keep track of last clause/group and stack.
	      lastGroup = start,
	      last = start.stack,
	      groupStack = [];
	
	
	  var repeatErr = function(i) {
	    util.error(regexpStr, 'Nothing to repeat at column ' + (i - 1));
	  };
	
	  // Decode a few escaped characters.
	  var str = util.strToChars(regexpStr);
	  l = str.length;
	
	  // Iterate through each character in string.
	  while (i < l) {
	    c = str[i++];
	
	    switch (c) {
	      // Handle escaped characters, inclues a few sets.
	      case '\\':
	        c = str[i++];
	
	        switch (c) {
	          case 'b':
	            last.push(positions.wordBoundary());
	            break;
	
	          case 'B':
	            last.push(positions.nonWordBoundary());
	            break;
	
	          case 'w':
	            last.push(sets.words());
	            break;
	
	          case 'W':
	            last.push(sets.notWords());
	            break;
	
	          case 'd':
	            last.push(sets.ints());
	            break;
	
	          case 'D':
	            last.push(sets.notInts());
	            break;
	
	          case 's':
	            last.push(sets.whitespace());
	            break;
	
	          case 'S':
	            last.push(sets.notWhitespace());
	            break;
	
	          default:
	            // Check if c is integer.
	            // In which case it's a reference.
	            if (/\d/.test(c)) {
	              last.push({ type: types.REFERENCE, value: parseInt(c, 10) });
	
	            // Escaped character.
	            } else {
	              last.push({ type: types.CHAR, value: c.charCodeAt(0) });
	            }
	        }
	
	        break;
	
	
	      // Positionals.
	      case '^':
	          last.push(positions.begin());
	        break;
	
	      case '$':
	          last.push(positions.end());
	        break;
	
	
	      // Handle custom sets.
	      case '[':
	        // Check if this class is 'anti' i.e. [^abc].
	        var not;
	        if (str[i] === '^') {
	          not = true;
	          i++;
	        } else {
	          not = false;
	        }
	
	        // Get all the characters in class.
	        var classTokens = util.tokenizeClass(str.slice(i), regexpStr);
	
	        // Increase index by length of class.
	        i += classTokens[1];
	        last.push({
	          type: types.SET,
	          set: classTokens[0],
	          not: not,
	        });
	
	        break;
	
	
	      // Class of any character except \n.
	      case '.':
	        last.push(sets.anyChar());
	        break;
	
	
	      // Push group onto stack.
	      case '(':
	        // Create group.
	        var group = {
	          type: types.GROUP,
	          stack: [],
	          remember: true,
	        };
	
	        c = str[i];
	
	        // If if this is a special kind of group.
	        if (c === '?') {
	          c = str[i + 1];
	          i += 2;
	
	          // Match if followed by.
	          if (c === '=') {
	            group.followedBy = true;
	
	          // Match if not followed by.
	          } else if (c === '!') {
	            group.notFollowedBy = true;
	
	          } else if (c !== ':') {
	            util.error(regexpStr,
	              'Invalid group, character \'' + c +
	              '\' after \'?\' at column ' + (i - 1));
	          }
	
	          group.remember = false;
	        }
	
	        // Insert subgroup into current group stack.
	        last.push(group);
	
	        // Remember the current group for when the group closes.
	        groupStack.push(lastGroup);
	
	        // Make this new group the current group.
	        lastGroup = group;
	        last = group.stack;
	        break;
	
	
	      // Pop group out of stack.
	      case ')':
	        if (groupStack.length === 0) {
	          util.error(regexpStr, 'Unmatched ) at column ' + (i - 1));
	        }
	        lastGroup = groupStack.pop();
	
	        // Check if this group has a PIPE.
	        // To get back the correct last stack.
	        last = lastGroup.options ?
	          lastGroup.options[lastGroup.options.length - 1] : lastGroup.stack;
	        break;
	
	
	      // Use pipe character to give more choices.
	      case '|':
	        // Create array where options are if this is the first PIPE
	        // in this clause.
	        if (!lastGroup.options) {
	          lastGroup.options = [lastGroup.stack];
	          delete lastGroup.stack;
	        }
	
	        // Create a new stack and add to options for rest of clause.
	        var stack = [];
	        lastGroup.options.push(stack);
	        last = stack;
	        break;
	
	
	      // Repetition.
	      // For every repetition, remove last element from last stack
	      // then insert back a RANGE object.
	      // This design is chosen because there could be more than
	      // one repetition symbols in a regex i.e. `a?+{2,3}`.
	      case '{':
	        var rs = /^(\d+)(,(\d+)?)?\}/.exec(str.slice(i)), min, max;
	        if (rs !== null) {
	          if (last.length === 0) {
	            repeatErr(i);
	          }
	          min = parseInt(rs[1], 10);
	          max = rs[2] ? rs[3] ? parseInt(rs[3], 10) : Infinity : min;
	          i += rs[0].length;
	
	          last.push({
	            type: types.REPETITION,
	            min: min,
	            max: max,
	            value: last.pop(),
	          });
	        } else {
	          last.push({
	            type: types.CHAR,
	            value: 123,
	          });
	        }
	        break;
	
	      case '?':
	        if (last.length === 0) {
	          repeatErr(i);
	        }
	        last.push({
	          type: types.REPETITION,
	          min: 0,
	          max: 1,
	          value: last.pop(),
	        });
	        break;
	
	      case '+':
	        if (last.length === 0) {
	          repeatErr(i);
	        }
	        last.push({
	          type: types.REPETITION,
	          min: 1,
	          max: Infinity,
	          value: last.pop(),
	        });
	        break;
	
	      case '*':
	        if (last.length === 0) {
	          repeatErr(i);
	        }
	        last.push({
	          type: types.REPETITION,
	          min: 0,
	          max: Infinity,
	          value: last.pop(),
	        });
	        break;
	
	
	      // Default is a character that is not `\[](){}?+*^$`.
	      default:
	        last.push({
	          type: types.CHAR,
	          value: c.charCodeAt(0),
	        });
	    }
	
	  }
	
	  // Check if any groups have not been closed.
	  if (groupStack.length !== 0) {
	    util.error(regexpStr, 'Unterminated group');
	  }
	
	  return start;
	};
	
	module.exports.types = types;


/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	var types = __webpack_require__(37);
	
	exports.wordBoundary = function() {
	  return { type: types.POSITION, value: 'b' };
	};
	
	exports.nonWordBoundary = function() {
	  return { type: types.POSITION, value: 'B' };
	};
	
	exports.begin = function() {
	  return { type: types.POSITION, value: '^' };
	};
	
	exports.end = function() {
	  return { type: types.POSITION, value: '$' };
	};


/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	var types = __webpack_require__(37);
	var sets  = __webpack_require__(110);
	
	
	// All of these are private and only used by randexp.
	// It's assumed that they will always be called with the correct input.
	
	var CTRL = '@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^ ?';
	var SLSH = { '0': 0, 't': 9, 'n': 10, 'v': 11, 'f': 12, 'r': 13 };
	
	/**
	 * Finds character representations in str and convert all to
	 * their respective characters
	 *
	 * @param {String} str
	 * @return {String}
	 */
	exports.strToChars = function(str) {
	  /* jshint maxlen: false */
	  var chars_regex = /(\[\\b\])|(\\)?\\(?:u([A-F0-9]{4})|x([A-F0-9]{2})|(0?[0-7]{2})|c([@A-Z\[\\\]\^?])|([0tnvfr]))/g;
	  str = str.replace(chars_regex, function(s, b, lbs, a16, b16, c8, dctrl, eslsh) {
	    if (lbs) {
	      return s;
	    }
	
	    var code = b     ? 8 :
	               a16   ? parseInt(a16, 16) :
	               b16   ? parseInt(b16, 16) :
	               c8    ? parseInt(c8,   8) :
	               dctrl ? CTRL.indexOf(dctrl) :
	               SLSH[eslsh];
	
	    var c = String.fromCharCode(code);
	
	    // Escape special regex characters.
	    if (/[\[\]{}\^$.|?*+()]/.test(c)) {
	      c = '\\' + c;
	    }
	
	    return c;
	  });
	
	  return str;
	};
	
	
	/**
	 * turns class into tokens
	 * reads str until it encounters a ] not preceeded by a \
	 *
	 * @param {String} str
	 * @param {String} regexpStr
	 * @return {Array.<Array.<Object>, Number>}
	 */
	exports.tokenizeClass = function(str, regexpStr) {
	  /* jshint maxlen: false */
	  var tokens = [];
	  var regexp = /\\(?:(w)|(d)|(s)|(W)|(D)|(S))|((?:(?:\\)(.)|([^\]\\]))-(?:\\)?([^\]]))|(\])|(?:\\)?(.)/g;
	  var rs, c;
	
	
	  while ((rs = regexp.exec(str)) != null) {
	    if (rs[1]) {
	      tokens.push(sets.words());
	
	    } else if (rs[2]) {
	      tokens.push(sets.ints());
	
	    } else if (rs[3]) {
	      tokens.push(sets.whitespace());
	
	    } else if (rs[4]) {
	      tokens.push(sets.notWords());
	
	    } else if (rs[5]) {
	      tokens.push(sets.notInts());
	
	    } else if (rs[6]) {
	      tokens.push(sets.notWhitespace());
	
	    } else if (rs[7]) {
	      tokens.push({
	        type: types.RANGE,
	        from: (rs[8] || rs[9]).charCodeAt(0),
	          to: rs[10].charCodeAt(0),
	      });
	
	    } else if (c = rs[12]) {
	      tokens.push({
	        type: types.CHAR,
	        value: c.charCodeAt(0),
	      });
	
	    } else {
	      return [tokens, regexp.lastIndex];
	    }
	  }
	
	  exports.error(regexpStr, 'Unterminated character class');
	};
	
	
	/**
	 * Shortcut to throw errors.
	 *
	 * @param {String} regexp
	 * @param {String} msg
	 */
	exports.error = function(regexp, msg) {
	  throw new SyntaxError('Invalid regular expression: /' + regexp + '/: ' + msg);
	};


/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = ripemd160
	
	
	
	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.
	
	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	// Constants table
	var zl = [
	    0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	    7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	    3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	    1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	    4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13];
	var zr = [
	    5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	    6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	    15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	    8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	    12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11];
	var sl = [
	     11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	    7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	    11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	      11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	    9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ];
	var sr = [
	    8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	    9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	    9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	    15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	    8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ];
	
	var hl =  [ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
	var hr =  [ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];
	
	var bytesToWords = function (bytes) {
	  var words = [];
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << (24 - b % 32);
	  }
	  return words;
	};
	
	var wordsToBytes = function (words) {
	  var bytes = [];
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	  }
	  return bytes;
	};
	
	var processBlock = function (H, M, offset) {
	
	  // Swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i;
	    var M_offset_i = M[offset_i];
	
	    // Swap
	    M[offset_i] = (
	        (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	        (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	    );
	  }
	
	  // Working variables
	  var al, bl, cl, dl, el;
	  var ar, br, cr, dr, er;
	
	  ar = al = H[0];
	  br = bl = H[1];
	  cr = cl = H[2];
	  dr = dl = H[3];
	  er = el = H[4];
	  // Computation
	  var t;
	  for (var i = 0; i < 80; i += 1) {
	    t = (al +  M[offset+zl[i]])|0;
	    if (i<16){
	        t +=  f1(bl,cl,dl) + hl[0];
	    } else if (i<32) {
	        t +=  f2(bl,cl,dl) + hl[1];
	    } else if (i<48) {
	        t +=  f3(bl,cl,dl) + hl[2];
	    } else if (i<64) {
	        t +=  f4(bl,cl,dl) + hl[3];
	    } else {// if (i<80) {
	        t +=  f5(bl,cl,dl) + hl[4];
	    }
	    t = t|0;
	    t =  rotl(t,sl[i]);
	    t = (t+el)|0;
	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = t;
	
	    t = (ar + M[offset+zr[i]])|0;
	    if (i<16){
	        t +=  f5(br,cr,dr) + hr[0];
	    } else if (i<32) {
	        t +=  f4(br,cr,dr) + hr[1];
	    } else if (i<48) {
	        t +=  f3(br,cr,dr) + hr[2];
	    } else if (i<64) {
	        t +=  f2(br,cr,dr) + hr[3];
	    } else {// if (i<80) {
	        t +=  f1(br,cr,dr) + hr[4];
	    }
	    t = t|0;
	    t =  rotl(t,sr[i]) ;
	    t = (t+er)|0;
	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = t;
	  }
	  // Intermediate hash value
	  t    = (H[1] + cl + dr)|0;
	  H[1] = (H[2] + dl + er)|0;
	  H[2] = (H[3] + el + ar)|0;
	  H[3] = (H[4] + al + br)|0;
	  H[4] = (H[0] + bl + cr)|0;
	  H[0] =  t;
	};
	
	function f1(x, y, z) {
	  return ((x) ^ (y) ^ (z));
	}
	
	function f2(x, y, z) {
	  return (((x)&(y)) | ((~x)&(z)));
	}
	
	function f3(x, y, z) {
	  return (((x) | (~(y))) ^ (z));
	}
	
	function f4(x, y, z) {
	  return (((x) & (z)) | ((y)&(~(z))));
	}
	
	function f5(x, y, z) {
	  return ((x) ^ ((y) |(~(z))));
	}
	
	function rotl(x,n) {
	  return (x<<n) | (x>>>(32-n));
	}
	
	function ripemd160(message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];
	
	  if (typeof message == 'string')
	    message = new Buffer(message, 'utf8');
	
	  var m = bytesToWords(message);
	
	  var nBitsLeft = message.length * 8;
	  var nBitsTotal = message.length * 8;
	
	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	      (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	      (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	  );
	
	  for (var i=0 ; i<m.length; i += 16) {
	    processBlock(H, m, i);
	  }
	
	  // Swap endian
	  for (var i = 0; i < 5; i++) {
	      // Shortcut
	    var H_i = H[i];
	
	    // Swap
	    H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	          (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	  }
	
	  var digestbytes = wordsToBytes(H);
	  return new Buffer(digestbytes);
	}
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ },
/* 1355 */
/***/ function(module, exports) {

	function select(element) {
	    var selectedText;
	
	    if (element.nodeName === 'SELECT') {
	        element.focus();
	
	        selectedText = element.value;
	    }
	    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
	        element.focus();
	        element.setSelectionRange(0, element.value.length);
	
	        selectedText = element.value;
	    }
	    else {
	        if (element.hasAttribute('contenteditable')) {
	            element.focus();
	        }
	
	        var selection = window.getSelection();
	        var range = document.createRange();
	
	        range.selectNodeContents(element);
	        selection.removeAllRanges();
	        selection.addRange(range);
	
	        selectedText = selection.toString();
	    }
	
	    return selectedText;
	}
	
	module.exports = select;


/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(18)))

/***/ },
/* 1357 */
/***/ function(module, exports) {

	module.exports = function (Buffer) {
	
	  //prototype class for hash functions
	  function Hash (blockSize, finalSize) {
	    this._block = new Buffer(blockSize) //new Uint32Array(blockSize/4)
	    this._finalSize = finalSize
	    this._blockSize = blockSize
	    this._len = 0
	    this._s = 0
	  }
	
	  Hash.prototype.init = function () {
	    this._s = 0
	    this._len = 0
	  }
	
	  Hash.prototype.update = function (data, enc) {
	    if ("string" === typeof data) {
	      enc = enc || "utf8"
	      data = new Buffer(data, enc)
	    }
	
	    var l = this._len += data.length
	    var s = this._s = (this._s || 0)
	    var f = 0
	    var buffer = this._block
	
	    while (s < l) {
	      var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
	      var ch = (t - f)
	
	      for (var i = 0; i < ch; i++) {
	        buffer[(s % this._blockSize) + i] = data[i + f]
	      }
	
	      s += ch
	      f += ch
	
	      if ((s % this._blockSize) === 0) {
	        this._update(buffer)
	      }
	    }
	    this._s = s
	
	    return this
	  }
	
	  Hash.prototype.digest = function (enc) {
	    // Suppose the length of the message M, in bits, is l
	    var l = this._len * 8
	
	    // Append the bit 1 to the end of the message
	    this._block[this._len % this._blockSize] = 0x80
	
	    // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	    this._block.fill(0, this._len % this._blockSize + 1)
	
	    if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	      this._update(this._block)
	      this._block.fill(0)
	    }
	
	    // to this append the block which is equal to the number l written in binary
	    // TODO: handle case where l is > Math.pow(2, 29)
	    this._block.writeInt32BE(l, this._blockSize - 4)
	
	    var hash = this._update(this._block) || this._hash()
	
	    return enc ? hash.toString(enc) : hash
	  }
	
	  Hash.prototype._update = function () {
	    throw new Error('_update must be implemented by subclass')
	  }
	
	  return Hash
	}


/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	var exports = module.exports = function (alg) {
	  var Alg = exports[alg]
	  if(!Alg) throw new Error(alg + ' is not supported (we accept pull requests)')
	  return new Alg()
	}
	
	var Buffer = __webpack_require__(3).Buffer
	var Hash   = __webpack_require__(1357)(Buffer)
	
	exports.sha1 = __webpack_require__(1359)(Buffer, Hash)
	exports.sha256 = __webpack_require__(1360)(Buffer, Hash)
	exports.sha512 = __webpack_require__(1361)(Buffer, Hash)


/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(64).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var A = 0|0
	  var B = 4|0
	  var C = 8|0
	  var D = 12|0
	  var E = 16|0
	
	  var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80)
	
	  var POOL = []
	
	  function Sha1 () {
	    if(POOL.length)
	      return POOL.pop().init()
	
	    if(!(this instanceof Sha1)) return new Sha1()
	    this._w = W
	    Hash.call(this, 16*4, 14*4)
	
	    this._h = null
	    this.init()
	  }
	
	  inherits(Sha1, Hash)
	
	  Sha1.prototype.init = function () {
	    this._a = 0x67452301
	    this._b = 0xefcdab89
	    this._c = 0x98badcfe
	    this._d = 0x10325476
	    this._e = 0xc3d2e1f0
	
	    Hash.prototype.init.call(this)
	    return this
	  }
	
	  Sha1.prototype._POOL = POOL
	  Sha1.prototype._update = function (X) {
	
	    var a, b, c, d, e, _a, _b, _c, _d, _e
	
	    a = _a = this._a
	    b = _b = this._b
	    c = _c = this._c
	    d = _d = this._d
	    e = _e = this._e
	
	    var w = this._w
	
	    for(var j = 0; j < 80; j++) {
	      var W = w[j] = j < 16 ? X.readInt32BE(j*4)
	        : rol(w[j - 3] ^ w[j -  8] ^ w[j - 14] ^ w[j - 16], 1)
	
	      var t = add(
	        add(rol(a, 5), sha1_ft(j, b, c, d)),
	        add(add(e, W), sha1_kt(j))
	      )
	
	      e = d
	      d = c
	      c = rol(b, 30)
	      b = a
	      a = t
	    }
	
	    this._a = add(a, _a)
	    this._b = add(b, _b)
	    this._c = add(c, _c)
	    this._d = add(d, _d)
	    this._e = add(e, _e)
	  }
	
	  Sha1.prototype._hash = function () {
	    if(POOL.length < 100) POOL.push(this)
	    var H = new Buffer(20)
	    //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
	    H.writeInt32BE(this._a|0, A)
	    H.writeInt32BE(this._b|0, B)
	    H.writeInt32BE(this._c|0, C)
	    H.writeInt32BE(this._d|0, D)
	    H.writeInt32BE(this._e|0, E)
	    return H
	  }
	
	  /*
	   * Perform the appropriate triplet combination function for the current
	   * iteration
	   */
	  function sha1_ft(t, b, c, d) {
	    if(t < 20) return (b & c) | ((~b) & d);
	    if(t < 40) return b ^ c ^ d;
	    if(t < 60) return (b & c) | (b & d) | (c & d);
	    return b ^ c ^ d;
	  }
	
	  /*
	   * Determine the appropriate additive constant for the current iteration
	   */
	  function sha1_kt(t) {
	    return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
	           (t < 60) ? -1894007588 : -899497514;
	  }
	
	  /*
	   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	   * to work around bugs in some JS interpreters.
	   * //dominictarr: this is 10 years old, so maybe this can be dropped?)
	   *
	   */
	  function add(x, y) {
	    return (x + y ) | 0
	  //lets see how this goes on testling.
	  //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  //  return (msw << 16) | (lsw & 0xFFFF);
	  }
	
	  /*
	   * Bitwise rotate a 32-bit number to the left.
	   */
	  function rol(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt));
	  }
	
	  return Sha1
	}


/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(64).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var K = [
	      0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	      0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	      0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	      0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	      0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	      0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	      0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	      0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	      0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	      0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	      0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	      0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	      0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	      0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	      0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	      0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	    ]
	
	  var W = new Array(64)
	
	  function Sha256() {
	    this.init()
	
	    this._w = W //new Array(64)
	
	    Hash.call(this, 16*4, 14*4)
	  }
	
	  inherits(Sha256, Hash)
	
	  Sha256.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, n) {
	    return (X >>> n) | (X << (32 - n));
	  }
	
	  function R (X, n) {
	    return (X >>> n);
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  function Sigma0256 (x) {
	    return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
	  }
	
	  function Sigma1256 (x) {
	    return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
	  }
	
	  function Gamma0256 (x) {
	    return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
	  }
	
	  function Gamma1256 (x) {
	    return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
	  }
	
	  Sha256.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var T1, T2
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    for (var j = 0; j < 64; j++) {
	      var w = W[j] = j < 16
	        ? M.readInt32BE(j * 4)
	        : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16]
	
	      T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w
	
	      T2 = Sigma0256(a) + Maj(a, b, c);
	      h = g; g = f; f = e; e = d + T1; d = c; c = b; b = a; a = T1 + T2;
	    }
	
	    this._a = (a + this._a) | 0
	    this._b = (b + this._b) | 0
	    this._c = (c + this._c) | 0
	    this._d = (d + this._d) | 0
	    this._e = (e + this._e) | 0
	    this._f = (f + this._f) | 0
	    this._g = (g + this._g) | 0
	    this._h = (h + this._h) | 0
	
	  };
	
	  Sha256.prototype._hash = function () {
	    var H = new Buffer(32)
	
	    H.writeInt32BE(this._a,  0)
	    H.writeInt32BE(this._b,  4)
	    H.writeInt32BE(this._c,  8)
	    H.writeInt32BE(this._d, 12)
	    H.writeInt32BE(this._e, 16)
	    H.writeInt32BE(this._f, 20)
	    H.writeInt32BE(this._g, 24)
	    H.writeInt32BE(this._h, 28)
	
	    return H
	  }
	
	  return Sha256
	
	}


/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(64).inherits
	
	module.exports = function (Buffer, Hash) {
	  var K = [
	    0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	    0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	    0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	    0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	    0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	    0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	    0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	    0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	    0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	    0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	    0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	    0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	    0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	    0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	    0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	    0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	    0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	    0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	    0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	    0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	    0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	    0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	    0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	    0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	    0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	    0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	    0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	    0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	    0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	    0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	    0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	    0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	    0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	    0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	    0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	    0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	    0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	    0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	    0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	    0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	  ]
	
	  var W = new Array(160)
	
	  function Sha512() {
	    this.init()
	    this._w = W
	
	    Hash.call(this, 128, 112)
	  }
	
	  inherits(Sha512, Hash)
	
	  Sha512.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._al = 0xf3bcc908|0
	    this._bl = 0x84caa73b|0
	    this._cl = 0xfe94f82b|0
	    this._dl = 0x5f1d36f1|0
	    this._el = 0xade682d1|0
	    this._fl = 0x2b3e6c1f|0
	    this._gl = 0xfb41bd6b|0
	    this._hl = 0x137e2179|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, Xl, n) {
	    return (X >>> n) | (Xl << (32 - n))
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  Sha512.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var al, bl, cl, dl, el, fl, gl, hl
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    al = this._al | 0
	    bl = this._bl | 0
	    cl = this._cl | 0
	    dl = this._dl | 0
	    el = this._el | 0
	    fl = this._fl | 0
	    gl = this._gl | 0
	    hl = this._hl | 0
	
	    for (var i = 0; i < 80; i++) {
	      var j = i * 2
	
	      var Wi, Wil
	
	      if (i < 16) {
	        Wi = W[j] = M.readInt32BE(j * 4)
	        Wil = W[j + 1] = M.readInt32BE(j * 4 + 4)
	
	      } else {
	        var x  = W[j - 15*2]
	        var xl = W[j - 15*2 + 1]
	        var gamma0  = S(x, xl, 1) ^ S(x, xl, 8) ^ (x >>> 7)
	        var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7)
	
	        x  = W[j - 2*2]
	        xl = W[j - 2*2 + 1]
	        var gamma1  = S(x, xl, 19) ^ S(xl, x, 29) ^ (x >>> 6)
	        var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6)
	
	        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	        var Wi7  = W[j - 7*2]
	        var Wi7l = W[j - 7*2 + 1]
	
	        var Wi16  = W[j - 16*2]
	        var Wi16l = W[j - 16*2 + 1]
	
	        Wil = gamma0l + Wi7l
	        Wi  = gamma0  + Wi7 + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0)
	        Wil = Wil + gamma1l
	        Wi  = Wi  + gamma1  + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0)
	        Wil = Wil + Wi16l
	        Wi  = Wi  + Wi16 + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0)
	
	        W[j] = Wi
	        W[j + 1] = Wil
	      }
	
	      var maj = Maj(a, b, c)
	      var majl = Maj(al, bl, cl)
	
	      var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7)
	      var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7)
	      var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9)
	      var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9)
	
	      // t1 = h + sigma1 + ch + K[i] + W[i]
	      var Ki = K[j]
	      var Kil = K[j + 1]
	
	      var ch = Ch(e, f, g)
	      var chl = Ch(el, fl, gl)
	
	      var t1l = hl + sigma1l
	      var t1 = h + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0)
	      t1l = t1l + chl
	      t1 = t1 + ch + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0)
	      t1l = t1l + Kil
	      t1 = t1 + Ki + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0)
	      t1l = t1l + Wil
	      t1 = t1 + Wi + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0)
	
	      // t2 = sigma0 + maj
	      var t2l = sigma0l + majl
	      var t2 = sigma0h + maj + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0)
	
	      h  = g
	      hl = gl
	      g  = f
	      gl = fl
	      f  = e
	      fl = el
	      el = (dl + t1l) | 0
	      e  = (d + t1 + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	      d  = c
	      dl = cl
	      c  = b
	      cl = bl
	      b  = a
	      bl = al
	      al = (t1l + t2l) | 0
	      a  = (t1 + t2 + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0
	    }
	
	    this._al = (this._al + al) | 0
	    this._bl = (this._bl + bl) | 0
	    this._cl = (this._cl + cl) | 0
	    this._dl = (this._dl + dl) | 0
	    this._el = (this._el + el) | 0
	    this._fl = (this._fl + fl) | 0
	    this._gl = (this._gl + gl) | 0
	    this._hl = (this._hl + hl) | 0
	
	    this._a = (this._a + a + ((this._al >>> 0) < (al >>> 0) ? 1 : 0)) | 0
	    this._b = (this._b + b + ((this._bl >>> 0) < (bl >>> 0) ? 1 : 0)) | 0
	    this._c = (this._c + c + ((this._cl >>> 0) < (cl >>> 0) ? 1 : 0)) | 0
	    this._d = (this._d + d + ((this._dl >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	    this._e = (this._e + e + ((this._el >>> 0) < (el >>> 0) ? 1 : 0)) | 0
	    this._f = (this._f + f + ((this._fl >>> 0) < (fl >>> 0) ? 1 : 0)) | 0
	    this._g = (this._g + g + ((this._gl >>> 0) < (gl >>> 0) ? 1 : 0)) | 0
	    this._h = (this._h + h + ((this._hl >>> 0) < (hl >>> 0) ? 1 : 0)) | 0
	  }
	
	  Sha512.prototype._hash = function () {
	    var H = new Buffer(64)
	
	    function writeInt64BE(h, l, offset) {
	      H.writeInt32BE(h, offset)
	      H.writeInt32BE(l, offset + 4)
	    }
	
	    writeInt64BE(this._a, this._al, 0)
	    writeInt64BE(this._b, this._bl, 8)
	    writeInt64BE(this._c, this._cl, 16)
	    writeInt64BE(this._d, this._dl, 24)
	    writeInt64BE(this._e, this._el, 32)
	    writeInt64BE(this._f, this._fl, 40)
	    writeInt64BE(this._g, this._gl, 48)
	    writeInt64BE(this._h, this._hl, 56)
	
	    return H
	  }
	
	  return Sha512
	
	}


/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(1356);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ },
/* 1363 */
/***/ function(module, exports) {

	function E () {
	  // Keep this empty so it's easier to inherit from
	  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
	}
	
	E.prototype = {
	  on: function (name, callback, ctx) {
	    var e = this.e || (this.e = {});
	
	    (e[name] || (e[name] = [])).push({
	      fn: callback,
	      ctx: ctx
	    });
	
	    return this;
	  },
	
	  once: function (name, callback, ctx) {
	    var self = this;
	    function listener () {
	      self.off(name, listener);
	      callback.apply(ctx, arguments);
	    };
	
	    listener._ = callback
	    return this.on(name, listener, ctx);
	  },
	
	  emit: function (name) {
	    var data = [].slice.call(arguments, 1);
	    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
	    var i = 0;
	    var len = evtArr.length;
	
	    for (i; i < len; i++) {
	      evtArr[i].fn.apply(evtArr[i].ctx, data);
	    }
	
	    return this;
	  },
	
	  off: function (name, callback) {
	    var e = this.e || (this.e = {});
	    var evts = e[name];
	    var liveEvents = [];
	
	    if (evts && callback) {
	      for (var i = 0, len = evts.length; i < len; i++) {
	        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
	          liveEvents.push(evts[i]);
	      }
	    }
	
	    // Remove event from queue to prevent memory leak
	    // Suggested by https://github.com/lazd
	    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
	
	    (liveEvents.length)
	      ? e[name] = liveEvents
	      : delete e[name];
	
	    return this;
	  }
	};
	
	module.exports = E;


/***/ },
/* 1364 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1365 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 1366 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Vue-CodeMirror
	 * @author Surmon.me
	 */
	
	var CodeMirror = __webpack_require__(2)
	var CmComponent = __webpack_require__(1370)
	if (typeof global.window != 'undefined') window.CodeMirror = CodeMirror
	var Codemirror = {
	  CodeMirror: CodeMirror,
	  codemirror: CmComponent,
	  install: function(Vue) {
	    Vue.component('codemirror', CmComponent)
	  }
	}
	
	module.exports = Codemirror
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1368 */
/***/ function(module, exports) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	var CodeMirrorMetas = {
	  modeInfo: [
	    {name: "APL", mime: "text/apl", mode: "apl", ext: ["dyalog", "apl"]},
	    {name: "PGP", mimes: ["application/pgp", "application/pgp-keys", "application/pgp-signature"], mode: "asciiarmor", ext: ["pgp"]},
	    {name: "ASN.1", mime: "text/x-ttcn-asn", mode: "asn.1", ext: ["asn", "asn1"]},
	    {name: "Asterisk", mime: "text/x-asterisk", mode: "asterisk", file: /^extensions\.conf$/i},
	    {name: "Brainfuck", mime: "text/x-brainfuck", mode: "brainfuck", ext: ["b", "bf"]},
	    {name: "C", mime: "text/x-csrc", mode: "clike", ext: ["c", "h"]},
	    {name: "C++", mime: "text/x-c++src", mode: "clike", ext: ["cpp", "c++", "cc", "cxx", "hpp", "h++", "hh", "hxx"], alias: ["cpp"]},
	    {name: "Cobol", mime: "text/x-cobol", mode: "cobol", ext: ["cob", "cpy"]},
	    {name: "C#", mime: "text/x-csharp", mode: "clike", ext: ["cs"], alias: ["csharp"]},
	    {name: "Clojure", mime: "text/x-clojure", mode: "clojure", ext: ["clj", "cljc", "cljx"]},
	    {name: "ClojureScript", mime: "text/x-clojurescript", mode: "clojure", ext: ["cljs"]},
	    {name: "Closure Stylesheets (GSS)", mime: "text/x-gss", mode: "css", ext: ["gss"]},
	    {name: "CMake", mime: "text/x-cmake", mode: "cmake", ext: ["cmake", "cmake.in"], file: /^CMakeLists.txt$/},
	    {name: "CoffeeScript", mime: "text/x-coffeescript", mode: "coffeescript", ext: ["coffee"], alias: ["coffee", "coffee-script"]},
	    {name: "Common Lisp", mime: "text/x-common-lisp", mode: "commonlisp", ext: ["cl", "lisp", "el"], alias: ["lisp"]},
	    {name: "Cypher", mime: "application/x-cypher-query", mode: "cypher", ext: ["cyp", "cypher"]},
	    {name: "Cython", mime: "text/x-cython", mode: "python", ext: ["pyx", "pxd", "pxi"]},
	    {name: "Crystal", mime: "text/x-crystal", mode: "crystal", ext: ["cr"]},
	    {name: "CSS", mime: "text/css", mode: "css", ext: ["css"]},
	    {name: "CQL", mime: "text/x-cassandra", mode: "sql", ext: ["cql"]},
	    {name: "D", mime: "text/x-d", mode: "d", ext: ["d"]},
	    {name: "Dart", mimes: ["application/dart", "text/x-dart"], mode: "dart", ext: ["dart"]},
	    {name: "diff", mime: "text/x-diff", mode: "diff", ext: ["diff", "patch"]},
	    {name: "Django", mime: "text/x-django", mode: "django"},
	    {name: "Dockerfile", mime: "text/x-dockerfile", mode: "dockerfile", file: /^Dockerfile$/},
	    {name: "DTD", mime: "application/xml-dtd", mode: "dtd", ext: ["dtd"]},
	    {name: "Dylan", mime: "text/x-dylan", mode: "dylan", ext: ["dylan", "dyl", "intr"]},
	    {name: "EBNF", mime: "text/x-ebnf", mode: "ebnf"},
	    {name: "ECL", mime: "text/x-ecl", mode: "ecl", ext: ["ecl"]},
	    {name: "edn", mime: "application/edn", mode: "clojure", ext: ["edn"]},
	    {name: "Eiffel", mime: "text/x-eiffel", mode: "eiffel", ext: ["e"]},
	    {name: "Elm", mime: "text/x-elm", mode: "elm", ext: ["elm"]},
	    {name: "Embedded Javascript", mime: "application/x-ejs", mode: "htmlembedded", ext: ["ejs"]},
	    {name: "Embedded Ruby", mime: "application/x-erb", mode: "htmlembedded", ext: ["erb"]},
	    {name: "Erlang", mime: "text/x-erlang", mode: "erlang", ext: ["erl"]},
	    {name: "Factor", mime: "text/x-factor", mode: "factor", ext: ["factor"]},
	    {name: "FCL", mime: "text/x-fcl", mode: "fcl"},
	    {name: "Forth", mime: "text/x-forth", mode: "forth", ext: ["forth", "fth", "4th"]},
	    {name: "Fortran", mime: "text/x-fortran", mode: "fortran", ext: ["f", "for", "f77", "f90"]},
	    {name: "F#", mime: "text/x-fsharp", mode: "mllike", ext: ["fs"], alias: ["fsharp"]},
	    {name: "Gas", mime: "text/x-gas", mode: "gas", ext: ["s"]},
	    {name: "Gherkin", mime: "text/x-feature", mode: "gherkin", ext: ["feature"]},
	    {name: "GitHub Flavored Markdown", mime: "text/x-gfm", mode: "gfm", file: /^(readme|contributing|history).md$/i},
	    {name: "Go", mime: "text/x-go", mode: "go", ext: ["go"]},
	    {name: "Groovy", mime: "text/x-groovy", mode: "groovy", ext: ["groovy", "gradle"], file: /^Jenkinsfile$/},
	    {name: "HAML", mime: "text/x-haml", mode: "haml", ext: ["haml"]},
	    {name: "Haskell", mime: "text/x-haskell", mode: "haskell", ext: ["hs"]},
	    {name: "Haskell (Literate)", mime: "text/x-literate-haskell", mode: "haskell-literate", ext: ["lhs"]},
	    {name: "Haxe", mime: "text/x-haxe", mode: "haxe", ext: ["hx"]},
	    {name: "HXML", mime: "text/x-hxml", mode: "haxe", ext: ["hxml"]},
	    {name: "ASP.NET", mime: "application/x-aspx", mode: "htmlembedded", ext: ["aspx"], alias: ["asp", "aspx"]},
	    {name: "HTML", mime: "text/html", mode: "htmlmixed", ext: ["html", "htm"], alias: ["xhtml"]},
	    {name: "HTTP", mime: "message/http", mode: "http"},
	    {name: "IDL", mime: "text/x-idl", mode: "idl", ext: ["pro"]},
	    {name: "Pug", mime: "text/x-pug", mode: "pug", ext: ["jade", "pug"], alias: ["jade"]},
	    {name: "Java", mime: "text/x-java", mode: "clike", ext: ["java"]},
	    {name: "Java Server Pages", mime: "application/x-jsp", mode: "htmlembedded", ext: ["jsp"], alias: ["jsp"]},
	    {name: "JavaScript", mimes: ["text/javascript", "text/ecmascript", "application/javascript", "application/x-javascript", "application/ecmascript"],
	     mode: "javascript", ext: ["js"], alias: ["ecmascript", "js", "node"]},
	    {name: "JSON", mimes: ["application/json", "application/x-json"], mode: "javascript", ext: ["json", "map"], alias: ["json5"]},
	    {name: "JSON-LD", mime: "application/ld+json", mode: "javascript", ext: ["jsonld"], alias: ["jsonld"]},
	    {name: "JSX", mime: "text/jsx", mode: "jsx", ext: ["jsx"]},
	    {name: "Jinja2", mime: "null", mode: "jinja2"},
	    {name: "Julia", mime: "text/x-julia", mode: "julia", ext: ["jl"]},
	    {name: "Kotlin", mime: "text/x-kotlin", mode: "clike", ext: ["kt"]},
	    {name: "LESS", mime: "text/x-less", mode: "css", ext: ["less"]},
	    {name: "LiveScript", mime: "text/x-livescript", mode: "livescript", ext: ["ls"], alias: ["ls"]},
	    {name: "Lua", mime: "text/x-lua", mode: "lua", ext: ["lua"]},
	    {name: "Markdown", mime: "text/x-markdown", mode: "markdown", ext: ["markdown", "md", "mkd"]},
	    {name: "mIRC", mime: "text/mirc", mode: "mirc"},
	    {name: "MariaDB SQL", mime: "text/x-mariadb", mode: "sql"},
	    {name: "Mathematica", mime: "text/x-mathematica", mode: "mathematica", ext: ["m", "nb"]},
	    {name: "Modelica", mime: "text/x-modelica", mode: "modelica", ext: ["mo"]},
	    {name: "MUMPS", mime: "text/x-mumps", mode: "mumps", ext: ["mps"]},
	    {name: "MS SQL", mime: "text/x-mssql", mode: "sql"},
	    {name: "mbox", mime: "application/mbox", mode: "mbox", ext: ["mbox"]},
	    {name: "MySQL", mime: "text/x-mysql", mode: "sql"},
	    {name: "Nginx", mime: "text/x-nginx-conf", mode: "nginx", file: /nginx.*\.conf$/i},
	    {name: "NSIS", mime: "text/x-nsis", mode: "nsis", ext: ["nsh", "nsi"]},
	    {name: "NTriples", mime: "text/n-triples", mode: "ntriples", ext: ["nt"]},
	    {name: "Objective C", mime: "text/x-objectivec", mode: "clike", ext: ["m", "mm"], alias: ["objective-c", "objc"]},
	    {name: "OCaml", mime: "text/x-ocaml", mode: "mllike", ext: ["ml", "mli", "mll", "mly"]},
	    {name: "Octave", mime: "text/x-octave", mode: "octave", ext: ["m"]},
	    {name: "Oz", mime: "text/x-oz", mode: "oz", ext: ["oz"]},
	    {name: "Pascal", mime: "text/x-pascal", mode: "pascal", ext: ["p", "pas"]},
	    {name: "PEG.js", mime: "null", mode: "pegjs", ext: ["jsonld"]},
	    {name: "Perl", mime: "text/x-perl", mode: "perl", ext: ["pl", "pm"]},
	    {name: "PHP", mime: "application/x-httpd-php", mode: "php", ext: ["php", "php3", "php4", "php5", "phtml"]},
	    {name: "Pig", mime: "text/x-pig", mode: "pig", ext: ["pig"]},
	    {name: "Plain Text", mime: "text/plain", mode: "null", ext: ["txt", "text", "conf", "def", "list", "log"]},
	    {name: "PLSQL", mime: "text/x-plsql", mode: "sql", ext: ["pls"]},
	    {name: "PowerShell", mime: "application/x-powershell", mode: "powershell", ext: ["ps1", "psd1", "psm1"]},
	    {name: "Properties files", mime: "text/x-properties", mode: "properties", ext: ["properties", "ini", "in"], alias: ["ini", "properties"]},
	    {name: "ProtoBuf", mime: "text/x-protobuf", mode: "protobuf", ext: ["proto"]},
	    {name: "Python", mime: "text/x-python", mode: "python", ext: ["BUILD", "bzl", "py", "pyw"], file: /^(BUCK|BUILD)$/},
	    {name: "Puppet", mime: "text/x-puppet", mode: "puppet", ext: ["pp"]},
	    {name: "Q", mime: "text/x-q", mode: "q", ext: ["q"]},
	    {name: "R", mime: "text/x-rsrc", mode: "r", ext: ["r", "R"], alias: ["rscript"]},
	    {name: "reStructuredText", mime: "text/x-rst", mode: "rst", ext: ["rst"], alias: ["rst"]},
	    {name: "RPM Changes", mime: "text/x-rpm-changes", mode: "rpm"},
	    {name: "RPM Spec", mime: "text/x-rpm-spec", mode: "rpm", ext: ["spec"]},
	    {name: "Ruby", mime: "text/x-ruby", mode: "ruby", ext: ["rb"], alias: ["jruby", "macruby", "rake", "rb", "rbx"]},
	    {name: "Rust", mime: "text/x-rustsrc", mode: "rust", ext: ["rs"]},
	    {name: "SAS", mime: "text/x-sas", mode: "sas", ext: ["sas"]},
	    {name: "Sass", mime: "text/x-sass", mode: "sass", ext: ["sass"]},
	    {name: "Scala", mime: "text/x-scala", mode: "clike", ext: ["scala"]},
	    {name: "Scheme", mime: "text/x-scheme", mode: "scheme", ext: ["scm", "ss"]},
	    {name: "SCSS", mime: "text/x-scss", mode: "css", ext: ["scss"]},
	    {name: "Shell", mime: "text/x-sh", mode: "shell", ext: ["sh", "ksh", "bash"], alias: ["bash", "sh", "zsh"], file: /^PKGBUILD$/},
	    {name: "Sieve", mime: "application/sieve", mode: "sieve", ext: ["siv", "sieve"]},
	    {name: "Slim", mimes: ["text/x-slim", "application/x-slim"], mode: "slim", ext: ["slim"]},
	    {name: "Smalltalk", mime: "text/x-stsrc", mode: "smalltalk", ext: ["st"]},
	    {name: "Smarty", mime: "text/x-smarty", mode: "smarty", ext: ["tpl"]},
	    {name: "Solr", mime: "text/x-solr", mode: "solr"},
	    {name: "Soy", mime: "text/x-soy", mode: "soy", ext: ["soy"], alias: ["closure template"]},
	    {name: "SPARQL", mime: "application/sparql-query", mode: "sparql", ext: ["rq", "sparql"], alias: ["sparul"]},
	    {name: "Spreadsheet", mime: "text/x-spreadsheet", mode: "spreadsheet", alias: ["excel", "formula"]},
	    {name: "SQL", mime: "text/x-sql", mode: "sql", ext: ["sql"]},
	    {name: "Squirrel", mime: "text/x-squirrel", mode: "clike", ext: ["nut"]},
	    {name: "Stylus", mime: "text/x-styl", mode: "stylus", ext: ["styl"]},
	    {name: "Swift", mime: "text/x-swift", mode: "swift", ext: ["swift"]},
	    {name: "sTeX", mime: "text/x-stex", mode: "stex"},
	    {name: "LaTeX", mime: "text/x-latex", mode: "stex", ext: ["text", "ltx"], alias: ["tex"]},
	    {name: "SystemVerilog", mime: "text/x-systemverilog", mode: "verilog", ext: ["v"]},
	    {name: "Tcl", mime: "text/x-tcl", mode: "tcl", ext: ["tcl"]},
	    {name: "Textile", mime: "text/x-textile", mode: "textile", ext: ["textile"]},
	    {name: "TiddlyWiki ", mime: "text/x-tiddlywiki", mode: "tiddlywiki"},
	    {name: "Tiki wiki", mime: "text/tiki", mode: "tiki"},
	    {name: "TOML", mime: "text/x-toml", mode: "toml", ext: ["toml"]},
	    {name: "Tornado", mime: "text/x-tornado", mode: "tornado"},
	    {name: "troff", mime: "text/troff", mode: "troff", ext: ["1", "2", "3", "4", "5", "6", "7", "8", "9"]},
	    {name: "TTCN", mime: "text/x-ttcn", mode: "ttcn", ext: ["ttcn", "ttcn3", "ttcnpp"]},
	    {name: "TTCN_CFG", mime: "text/x-ttcn-cfg", mode: "ttcn-cfg", ext: ["cfg"]},
	    {name: "Turtle", mime: "text/turtle", mode: "turtle", ext: ["ttl"]},
	    {name: "TypeScript", mime: "application/typescript", mode: "javascript", ext: ["ts"], alias: ["ts"]},
	    {name: "Twig", mime: "text/x-twig", mode: "twig"},
	    {name: "Web IDL", mime: "text/x-webidl", mode: "webidl", ext: ["webidl"]},
	    {name: "VB.NET", mime: "text/x-vb", mode: "vb", ext: ["vb"]},
	    {name: "VBScript", mime: "text/vbscript", mode: "vbscript", ext: ["vbs"]},
	    {name: "Velocity", mime: "text/velocity", mode: "velocity", ext: ["vtl"]},
	    {name: "Verilog", mime: "text/x-verilog", mode: "verilog", ext: ["v"]},
	    {name: "VHDL", mime: "text/x-vhdl", mode: "vhdl", ext: ["vhd", "vhdl"]},
	    {name: "Vue.js Component", mimes: ["script/x-vue", "text/x-vue"], mode: "vue", ext: ["vue"]},
	    {name: "XML", mimes: ["application/xml", "text/xml"], mode: "xml", ext: ["xml", "xsl", "xsd"], alias: ["rss", "wsdl", "xsd"]},
	    {name: "XQuery", mime: "application/xquery", mode: "xquery", ext: ["xy", "xquery"]},
	    {name: "Yacas", mime: "text/x-yacas", mode: "yacas", ext: ["ys"]},
	    {name: "YAML", mimes: ["text/x-yaml", "text/yaml"], mode: "yaml", ext: ["yaml", "yml"], alias: ["yml"]},
	    {name: "Z80", mime: "text/x-z80", mode: "z80", ext: ["z80"]},
	    {name: "mscgen", mime: "text/x-mscgen", mode: "mscgen", ext: ["mscgen", "mscin", "msc"]},
	    {name: "xu", mime: "text/x-xu", mode: "mscgen", ext: ["xu"]},
	    {name: "msgenny", mime: "text/x-msgenny", mode: "mscgen", ext: ["msgenny"]}
	  ]
	}
	
	// Ensure all modes have a mime property for backwards compatibility
	for (var i = 0; i < CodeMirrorMetas.modeInfo.length; i++) {
	  var info = CodeMirrorMetas.modeInfo[i];
	  if (info.mimes) info.mime = info.mimes[0];
	}
	
	CodeMirrorMetas.findModeByMIME = function(mime) {
	  mime = mime.toLowerCase()
	  for (var i = 0; i < CodeMirrorMetas.modeInfo.length; i++) {
	    var info = CodeMirrorMetas.modeInfo[i]
	    if (info.mime == mime) return info
	    if (info.mimes) for (var j = 0; j < info.mimes.length; j++)
	      if (info.mimes[j] == mime) return info
	  }
	}
	
	CodeMirrorMetas.findModeByExtension = function(ext) {
	  for (var i = 0; i < CodeMirrorMetas.modeInfo.length; i++) {
	    var info = CodeMirrorMetas.modeInfo[i]
	    if (info.ext) for (var j = 0; j < info.ext.length; j++)
	      if (info.ext[j] == ext) return info
	  }
	}
	
	CodeMirrorMetas.findModeByFileName = function(filename) {
	  for (var i = 0; i < CodeMirrorMetas.modeInfo.length; i++) {
	    var info = CodeMirrorMetas.modeInfo[i]
	    if (info.file && info.file.test(filename)) return info
	  }
	  var dot = filename.lastIndexOf(".")
	  var ext = dot > -1 && filename.substring(dot + 1, filename.length)
	  if (ext) return CodeMirrorMetas.findModeByExtension(ext)
	}
	
	CodeMirrorMetas.findModeByName = function(name) {
	  name = name.toLowerCase()
	  for (var i = 0; i < CodeMirrorMetas.modeInfo.length; i++) {
	    var info = CodeMirrorMetas.modeInfo[i]
	    if (info.name.toLowerCase() == name) return info
	    if (info.alias) for (var j = 0; j < info.alias.length; j++)
	      if (info.alias[j].toLowerCase() == name) return info
	  }
	}
	
	module.exports = CodeMirrorMetas


/***/ },
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Vue Material v0.6.3
	 * Made with love by Marcos Moura
	 * Released under the MIT License.
	 */
	!(function(t,e){ true?module.exports=e(__webpack_require__(113)):"function"==typeof define&&define.amd?define(["vue"],e):"object"==typeof exports?exports.VueMaterial=e(require("vue")):t.VueMaterial=e(t.Vue)})(this,(function(t){return (function(t){function e(o){if(n[o])return n[o].exports;var i=n[o]={exports:{},id:o,loaded:!1};return t[o].call(i.exports,i,i.exports,e),i.loaded=!0,i.exports}var n={};return e.m=t,e.c=n,e.p="/",e(0)})(function(t){for(var e in t)if(Object.prototype.hasOwnProperty.call(t,e))switch(typeof t[e]){case"function":break;case"object":t[e]=(function(e){var n=e.slice(1),o=t[e[0]];return function(t,e,i){o.apply(this,[t,e,i].concat(n))}})(t[e]);break;default:t[e]=t[t[e]]}return t}([(function(t,e,n){t.exports=n(375)}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={props:{mdTheme:String},data:function(){return{closestThemedParent:!1}},methods:{getClosestThemedParent:function(t){return!(!t||!t.$el||0===t._uid)&&(t.mdTheme||t.mdName?t:this.getClosestThemedParent(t.$parent))}},computed:{themeClass:function(){if(this.mdTheme)return"md-theme-"+this.mdTheme;var t=this.closestThemedParent.mdTheme;return t||(t=this.closestThemedParent?this.closestThemedParent.mdName:this.$material.currentTheme),"md-theme-"+t}},mounted:function(){this.closestThemedParent=this.getClosestThemedParent(this.$parent),this.$material.currentTheme||this.$material.setCurrentTheme("default")}},t.exports=e.default}),(function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)}),(function(t,e,n){var o=n(24)("wks"),i=n(19),r=n(2).Symbol,a="function"==typeof r,s=t.exports=function(t){return o[t]||(o[t]=a&&r[t]||(a?r:i)("Symbol."+t))};s.store=o}),(function(t,e,n){t.exports=!n(11)((function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a}))}),(function(t,e){var n=t.exports={version:"2.4.0"};"number"==typeof __e&&(__e=n)}),(function(t,e,n){var o=n(10),i=n(29),r=n(28),a=Object.defineProperty;e.f=n(4)?Object.defineProperty:function(t,e,n){if(o(t),e=r(e,!0),o(n),i)try{return a(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}}),(function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}}),(function(t,e,n){var o=n(6),i=n(14);t.exports=n(4)?function(t,e,n){return o.f(t,e,i(1,n))}:function(t,e,n){return t[e]=n,t}}),(function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}}),(function(t,e,n){var o=n(9);t.exports=function(t){if(!o(t))throw TypeError(t+" is not an object!");return t}}),(function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}}),(function(t,e,n){var o=n(35),i=n(15);t.exports=function(t){return o(i(t))}}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function t(e,n){return!(!e||!e.$el)&&(0!==e._uid&&(e.$el.classList.contains(n)?e:t(e.$parent,n)))};e.default=n,t.exports=e.default}),(function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}}),(function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}}),(function(t,e){var n=Math.ceil,o=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?o:n)(t)}}),(function(t,e,n){var o=n(2),i=n(5),r=n(26),a=n(8),s="prototype",d=function(t,e,n){var l,c,u,f=t&d.F,m=t&d.G,p=t&d.S,h=t&d.P,b=t&d.B,v=t&d.W,g=m?i:i[e]||(i[e]={}),E=g[s],_=m?o:p?o[e]:(o[e]||{})[s];m&&(n=e);for(l in n)c=!f&&_&&void 0!==_[l],c&&l in g||(u=c?_[l]:n[l],g[l]=m&&"function"!=typeof _[l]?n[l]:b&&c?r(u,o):v&&_[l]==u?(function(t){var e=function(e,n,o){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(e);case 2:return new t(e,n)}return new t(e,n,o)}return t.apply(this,arguments)};return e[s]=t[s],e})(u):h&&"function"==typeof u?r(Function.call,u):u,h&&((g.virtual||(g.virtual={}))[l]=u,t&d.R&&E&&!E[l]&&a(E,l,u)))};d.F=1,d.G=2,d.S=4,d.P=8,d.B=16,d.W=32,d.U=64,d.R=128,t.exports=d}),(function(t,e,n){var o=n(24)("keys"),i=n(19);t.exports=function(t){return o[t]||(o[t]=i(t))}}),(function(t,e){var n=0,o=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+o).toString(36))}}),(function(t,e){t.exports={}}),(function(t,e,n){var o=n(33),i=n(23);t.exports=Object.keys||function(t){return o(t,i)}}),(function(t,e,n){var o=n(9),i=n(2).document,r=o(i)&&o(i.createElement);t.exports=function(t){return r?i.createElement(t):{}}}),(function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")}),(function(t,e,n){var o=n(2),i="__core-js_shared__",r=o[i]||(o[i]={});t.exports=function(t){return r[t]||(r[t]={})}}),(function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}}),(function(t,e,n){var o=n(32);t.exports=function(t,e,n){if(o(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,o){return t.call(e,n,o)};case 3:return function(n,o,i){return t.call(e,n,o,i)}}return function(){return t.apply(e,arguments)}}}),(function(t,e,n){var o=n(15);t.exports=function(t){return Object(o(t))}}),(function(t,e,n){var o=n(9);t.exports=function(t,e){if(!o(t))return t;var n,i;if(e&&"function"==typeof(n=t.toString)&&!o(i=n.call(t)))return i;if("function"==typeof(n=t.valueOf)&&!o(i=n.call(t)))return i;if(!e&&"function"==typeof(n=t.toString)&&!o(i=n.call(t)))return i;throw TypeError("Can't convert object to primitive value")}}),(function(t,e,n){t.exports=!n(4)&&!n(11)((function(){return 7!=Object.defineProperty(n(22)("div"),"a",{get:function(){return 7}}).a}))}),(function(t,e,n){var o=n(16),i=Math.min;t.exports=function(t){return t>0?i(o(t),9007199254740991):0}}),(function(t,e,n){var o=n(6).f,i=n(7),r=n(3)("toStringTag");t.exports=function(t,e,n){t&&!i(t=n?t:t.prototype,r)&&o(t,r,{configurable:!0,value:e})}}),(function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}}),(function(t,e,n){var o=n(7),i=n(12),r=n(34)(!1),a=n(18)("IE_PROTO");t.exports=function(t,e){var n,s=i(t),d=0,l=[];for(n in s)n!=a&&o(s,n)&&l.push(n);for(;e.length>d;)o(s,n=e[d++])&&(~r(l,n)||l.push(n));return l}}),(function(t,e,n){var o=n(12),i=n(30),r=n(37);t.exports=function(t){return function(e,n,a){var s,d=o(e),l=i(d.length),c=r(a,l);if(t&&n!=n){for(;l>c;)if(s=d[c++],s!=s)return!0}else for(;l>c;c++)if((t||c in d)&&d[c]===n)return t||c||0;return!t&&-1}}}),(function(t,e,n){var o=n(25);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==o(t)?t.split(""):Object(t)}}),(function(t,e){t.exports=!0}),(function(t,e,n){var o=n(16),i=Math.max,r=Math.min;t.exports=function(t,e){return t=o(t),t<0?i(t+e,0):r(t,e)}}),(function(t,e){"use strict";function n(){var t=document.createElement("span"),e={transition:"transitionend",OTransition:"oTransitionEnd",MozTransition:"transitionend",WebkitTransition:"webkitTransitionEnd"};for(var n in e)if(void 0!==t.style[n])return e[n]}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n(),t.exports=e.default}),(function(t,e,n){"use strict";var o=n(36),i=n(17),r=n(41),a=n(8),s=n(7),d=n(20),l=n(47),c=n(31),u=n(49),f=n(3)("iterator"),m=!([].keys&&"next"in[].keys()),p="@@iterator",h="keys",b="values",v=function(){return this};t.exports=function(t,e,n,g,E,_,C){l(n,e,g);var y,M,T,x=function(t){if(!m&&t in N)return N[t];switch(t){case h:return function(){return new n(this,t)};case b:return function(){return new n(this,t)}}return function(){return new n(this,t)}},A=e+" Iterator",O=E==b,R=!1,N=t.prototype,k=N[f]||N[p]||E&&N[E],w=k||x(E),S=E?O?x("entries"):w:void 0,P="Array"==e?N.entries||k:k;if(P&&(T=u(P.call(new t)),T!==Object.prototype&&(c(T,A,!0),o||s(T,f)||a(T,f,v))),O&&k&&k.name!==b&&(R=!0,w=function(){return k.call(this)}),o&&!C||!m&&!R&&N[f]||a(N,f,w),d[e]=w,d[A]=v,E)if(y={values:O?w:x(b),keys:_?w:x(h),entries:S},C)for(M in y)M in N||r(N,M,y[M]);else i(i.P+i.F*(m||R),e,y);return y}}),(function(t,e,n){var o=n(10),i=n(48),r=n(23),a=n(18)("IE_PROTO"),s=function(){},d="prototype",l=function(){var t,e=n(22)("iframe"),o=r.length,i="<",a=">";for(e.style.display="none",n(46).appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write(i+"script"+a+"document.F=Object"+i+"/script"+a),t.close(),l=t.F;o--;)delete l[d][r[o]];return l()};t.exports=Object.create||function(t,e){var n;return null!==t?(s[d]=o(t),n=new s,s[d]=null,n[a]=t):n=l(),void 0===e?n:i(n,e)}}),(function(t,e,n){t.exports=n(8)}),(function(t,e,n){"use strict";var o=n(50)(!0);n(39)(String,"String",(function(t){this._t=String(t),this._i=0}),(function(){var t,e=this._t,n=this._i;return n>=e.length?{value:void 0,done:!0}:(t=o(e,n),this._i+=t.length,{value:t,done:!1})}))}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(){return Math.random().toString(36).slice(4)};e.default=n,t.exports=e.default}),(function(t,e,n){t.exports={default:n(53),__esModule:!0}}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0;var i=n(51),r=o(i);e.default=function(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return(0,r.default)(t)}}),(function(t,e,n){t.exports=n(2).document&&document.documentElement}),(function(t,e,n){"use strict";var o=n(40),i=n(14),r=n(31),a={};n(8)(a,n(3)("iterator"),(function(){return this})),t.exports=function(t,e,n){t.prototype=o(a,{next:i(1,n)}),r(t,e+" Iterator")}}),(function(t,e,n){var o=n(6),i=n(10),r=n(21);t.exports=n(4)?Object.defineProperties:function(t,e){i(t);for(var n,a=r(e),s=a.length,d=0;s>d;)o.f(t,n=a[d++],e[n]);return t}}),(function(t,e,n){var o=n(7),i=n(27),r=n(18)("IE_PROTO"),a=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=i(t),o(t,r)?t[r]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?a:null}}),(function(t,e,n){var o=n(16),i=n(15);t.exports=function(t){return function(e,n){var r,a,s=String(i(e)),d=o(n),l=s.length;return d<0||d>=l?t?"":void 0:(r=s.charCodeAt(d),r<55296||r>56319||d+1===l||(a=s.charCodeAt(d+1))<56320||a>57343?t?s.charAt(d):r:t?s.slice(d,d+2):(r-55296<<10)+(a-56320)+65536)}}}),(function(t,e,n){t.exports={default:n(52),__esModule:!0}}),(function(t,e,n){n(42),n(64),t.exports=n(5).Array.from}),(function(t,e,n){n(65),t.exports=n(5).Object.keys}),(function(t,e,n){var o=n(25),i=n(3)("toStringTag"),r="Arguments"==o(function(){return arguments}()),a=function(t,e){try{return t[e]}catch(t){}};t.exports=function(t){var e,n,s;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=a(e=Object(t),i))?n:r?o(e):"Object"==(s=o(e))&&"function"==typeof e.callee?"Arguments":s}}),(function(t,e,n){"use strict";var o=n(6),i=n(14);t.exports=function(t,e,n){e in t?o.f(t,e,i(0,n)):t[e]=n}}),(function(t,e,n){var o=n(20),i=n(3)("iterator"),r=Array.prototype;t.exports=function(t){return void 0!==t&&(o.Array===t||r[i]===t)}}),(function(t,e,n){var o=n(10);t.exports=function(t,e,n,i){try{return i?e(o(n)[0],n[1]):e(n)}catch(e){var r=t.return;throw void 0!==r&&o(r.call(t)),e}}}),(function(t,e,n){var o=n(3)("iterator"),i=!1;try{var r=[7][o]();r.return=function(){i=!0},Array.from(r,(function(){throw 2}))}catch(t){}t.exports=function(t,e){if(!e&&!i)return!1;var n=!1;try{var r=[7],a=r[o]();a.next=function(){return{done:n=!0}},r[o]=function(){return a},t(r)}catch(t){}return n}}),(function(t,e){e.f={}.propertyIsEnumerable}),(function(t,e,n){var o=n(17),i=n(5),r=n(11);t.exports=function(t,e){var n=(i.Object||{})[t]||Object[t],a={};a[t]=e(n),o(o.S+o.F*r((function(){n(1)})),"Object",a)}}),(function(t,e,n){var o=n(2),i=n(5),r=n(36),a=n(62),s=n(6).f;t.exports=function(t){var e=i.Symbol||(i.Symbol=r?{}:o.Symbol||{});"_"==t.charAt(0)||t in e||s(e,t,{value:a.f(t)})}}),(function(t,e,n){e.f=n(3)}),(function(t,e,n){var o=n(54),i=n(3)("iterator"),r=n(20);t.exports=n(5).getIteratorMethod=function(t){if(void 0!=t)return t[i]||t["@@iterator"]||r[o(t)]}}),(function(t,e,n){"use strict";var o=n(26),i=n(17),r=n(27),a=n(57),s=n(56),d=n(30),l=n(55),c=n(63);i(i.S+i.F*!n(58)((function(t){Array.from(t)})),"Array",{from:function(t){var e,n,i,u,f=r(t),m="function"==typeof this?this:Array,p=arguments.length,h=p>1?arguments[1]:void 0,b=void 0!==h,v=0,g=c(f);if(b&&(h=o(h,p>2?arguments[2]:void 0,2)),void 0==g||m==Array&&s(g))for(e=d(f.length),n=new m(e);e>v;v++)l(n,v,b?h(f[v],v):f[v]);else for(u=g.call(f),n=new m;!(i=u.next()).done;v++)l(n,v,b?a(u,h,[i.value,v],!0):i.value);return n.length=v,n}})}),(function(t,e,n){var o=n(27),i=n(21);n(60)("keys",(function(){return function(t){return i(o(t))}}))}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(t,e){var n=document.createElement("canvas");t.onload=function(){var t=0,o=void 0,i=void 0,r=void 0,a=void 0,s=void 0,d=void 0,l=void 0;n.width=this.width,n.height=this.height,o=n.getContext("2d"),o.drawImage(this,0,0),i=o.getImageData(0,0,n.width,n.height),r=i.data;for(var c=0,u=r.length;c<u;c+=4)a=r[c],s=r[c+1],d=r[c+2],l=Math.floor((a+s+d)/3),t+=l;e(Math.floor(t/(this.width*this.height)))}};e.default=n,t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(t){return t&&t.constructor===Array};e.default=n,t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={props:{value:[String,Number],disabled:Boolean,required:Boolean,maxlength:[Number,String],placeholder:String},watch:{value:function(t){this.$el.value=t,this.setParentValue(t)},disabled:function(){this.setParentDisabled()},required:function(){this.setParentRequired()},placeholder:function(){this.setParentPlaceholder()},maxlength:function(){this.handleMaxLength()}},methods:{handleMaxLength:function(){this.parentContainer.enableCounter=this.maxlength>0,this.parentContainer.counterLength=this.maxlength},setParentValue:function(t){this.parentContainer.setValue(t||this.$el.value)},setParentDisabled:function(){this.parentContainer.isDisabled=this.disabled},setParentRequired:function(){this.parentContainer.isRequired=this.required},setParentPlaceholder:function(){this.parentContainer.hasPlaceholder=!!this.placeholder},onFocus:function(){this.parentContainer.isFocused=!0},onBlur:function(){this.parentContainer.isFocused=!1,this.setParentValue()},onInput:function(){var t=this.$el.value;this.setParentValue(),this.parentContainer.inputLength=t?t.length:0,this.$emit("change",t),this.$emit("input",t)}}},t.exports=e.default}),(function(t,e,n){var o=n(33),i=n(23).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return o(t,i)}}),(function(t,e){e.f=Object.getOwnPropertySymbols}),(function(t,e,n){var o,i,r;!(function(n,a){i=[e,t],o=a,r="function"==typeof o?o.apply(e,i):o,!(void 0!==r&&(t.exports=r))})(this,(function(t,e){"use strict";function n(t){function e(){var e=window.getComputedStyle(t,null);"vertical"===e.resize?t.style.resize="none":"both"===e.resize&&(t.style.resize="horizontal"),d="content-box"===e.boxSizing?-(parseFloat(e.paddingTop)+parseFloat(e.paddingBottom)):parseFloat(e.borderTopWidth)+parseFloat(e.borderBottomWidth),isNaN(d)&&(d=0),s()}function n(e){var n=t.style.width;t.style.width="0px",t.offsetWidth,t.style.width=n,t.style.overflowY=e}function o(t){for(var e=[];t&&t.parentNode&&t.parentNode instanceof Element;)t.parentNode.scrollTop&&e.push({node:t.parentNode,scrollTop:t.parentNode.scrollTop}),t=t.parentNode;return e}function i(){var e=t.style.height,n=o(t),i=document.documentElement&&document.documentElement.scrollTop;t.style.height="auto";var r=t.scrollHeight+d;return 0===t.scrollHeight?void(t.style.height=e):(t.style.height=r+"px",l=t.clientWidth,n.forEach((function(t){t.node.scrollTop=t.scrollTop})),void(i&&(document.documentElement.scrollTop=i)))}function s(){i();var e=Math.round(parseFloat(t.style.height)),o=window.getComputedStyle(t,null),r=Math.round(parseFloat(o.height));if(r!==e?"visible"!==o.overflowY&&(n("visible"),i(),r=Math.round(parseFloat(window.getComputedStyle(t,null).height))):"hidden"!==o.overflowY&&(n("hidden"),i(),r=Math.round(parseFloat(window.getComputedStyle(t,null).height))),c!==r){c=r;var s=a("autosize:resized");try{t.dispatchEvent(s)}catch(t){}}}if(t&&t.nodeName&&"TEXTAREA"===t.nodeName&&!r.has(t)){var d=null,l=t.clientWidth,c=null,u=function(){t.clientWidth!==l&&s()},f=function(e){window.removeEventListener("resize",u,!1),t.removeEventListener("input",s,!1),t.removeEventListener("keyup",s,!1),t.removeEventListener("autosize:destroy",f,!1),t.removeEventListener("autosize:update",s,!1),Object.keys(e).forEach((function(n){t.style[n]=e[n]})),r.delete(t)}.bind(t,{height:t.style.height,resize:t.style.resize,overflowY:t.style.overflowY,overflowX:t.style.overflowX,wordWrap:t.style.wordWrap});t.addEventListener("autosize:destroy",f,!1),"onpropertychange"in t&&"oninput"in t&&t.addEventListener("keyup",s,!1),window.addEventListener("resize",u,!1),t.addEventListener("input",s,!1),t.addEventListener("autosize:update",s,!1),t.style.overflowX="hidden",t.style.wordWrap="break-word",r.set(t,{destroy:f,update:s}),e()}}function o(t){var e=r.get(t);e&&e.destroy()}function i(t){var e=r.get(t);e&&e.update()}var r="function"==typeof Map?new Map:(function(){var t=[],e=[];return{has:function(e){return t.indexOf(e)>-1},get:function(n){return e[t.indexOf(n)]},set:function(n,o){t.indexOf(n)===-1&&(t.push(n),e.push(o))},delete:function(n){var o=t.indexOf(n);o>-1&&(t.splice(o,1),e.splice(o,1))}}})(),a=function(t){return new Event(t,{bubbles:!0})};try{new Event("test")}catch(t){a=function(t){var e=document.createEvent("Event");return e.initEvent(t,!0,!1),e}}var s=null;"undefined"==typeof window||"function"!=typeof window.getComputedStyle?(s=function(t){return t},s.destroy=function(t){return t},s.update=function(t){return t}):(s=function(t,e){return t&&Array.prototype.forEach.call(t.length?t:[t],(function(t){return n(t,e)})),t},s.destroy=function(t){return t&&Array.prototype.forEach.call(t.length?t:[t],o),t},s.update=function(t){return t&&Array.prototype.forEach.call(t.length?t:[t],i),t}),e.exports=s}))}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-avatar",t.extend(a.default)),t.material.styles.push(d.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(248),a=o(r),s=n(222),d=o(s);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-backdrop",t.extend(a.default))}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(249),a=o(r);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-bottom-bar",t.extend(a.default)),t.component("md-bottom-bar-item",t.extend(d.default)),t.material.styles.push(c.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(250),a=o(r),s=n(251),d=o(s),l=n(223),c=o(l);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-button",t.extend(a.default)),t.material.styles.push(d.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(252),a=o(r),s=n(224),d=o(s);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-button-toggle",t.extend(a.default)),t.material.styles.push(d.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(253),a=o(r),s=n(225),d=o(s);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-card",t.extend(a.default)),t.component("md-card-media",t.extend(d.default)),t.component("md-card-media-cover",t.extend(c.default)),t.component("md-card-media-actions",t.extend(f.default)),t.component("md-card-header",t.extend(p.default)),t.component("md-card-header-text",t.extend(b.default)),t.component("md-card-content",t.extend(g.default)),t.component("md-card-actions",t.extend(_.default)),t.component("md-card-area",t.extend(y.default)),t.component("md-card-expand",t.extend(T.default)),t.material.styles.push(A.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(254),a=o(r),s=n(261),d=o(s),l=n(263),c=o(l),u=n(262),f=o(u),m=n(259),p=o(m),h=n(260),b=o(h),v=n(257),g=o(v),E=n(255),_=o(E),C=n(256),y=o(C),M=n(258),T=o(M),x=n(226),A=o(x);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-checkbox",t.extend(a.default)),t.material.styles.push(d.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(264),a=o(r),s=n(227),d=o(s);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-chips",t.extend(a.default)),t.component("md-chip",t.extend(d.default)),t.material.styles.push(c.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(266),a=o(r),s=n(265),d=o(s),l=n(228),c=o(l);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-dialog",t.extend(a.default)),t.component("md-dialog-title",t.extend(d.default)),t.component("md-dialog-content",t.extend(c.default)),t.component("md-dialog-actions",t.extend(f.default)),t.component("md-dialog-alert",t.extend(p.default)),t.component("md-dialog-confirm",t.extend(b.default)),t.component("md-dialog-prompt",t.extend(g.default)),t.material.styles.push(_.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(267),a=o(r),s=n(270),d=o(s),l=n(269),c=o(l),u=n(268),f=o(u),m=n(271),p=o(m),h=n(272),b=o(h),v=n(273),g=o(v),E=n(229),_=o(E);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-divider",t.extend(a.default))}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(274),a=o(r);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-file",t.extend(a.default)),t.material.styles.push(d.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(275),a=o(r),s=n(230),d=o(s);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-icon",t.extend(a.default)),t.material.styles.push(d.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(276),a=o(r),s=n(231),d=o(s);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-image",t.extend(a.default)),t.material.styles.push(d.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(277),a=o(r),s=n(232),d=o(s);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-input-container",a.default),t.component("md-input",d.default),t.component("md-textarea",c.default),t.material.styles.push(f.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(279),a=o(r),s=n(278),d=o(s),l=n(280),c=o(l),u=n(233),f=o(u);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-layout",t.extend(a.default))}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(281),a=o(r);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-list",t.extend(a.default)),t.component("md-list-item",t.extend(d.default)),t.component("md-list-expand",t.extend(c.default)),t.material.styles.push(f.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(282),a=o(r),s=n(284),d=o(s),l=n(283),c=o(l),u=n(234),f=o(u);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-menu",t.extend(a.default)),t.component("md-menu-item",t.extend(d.default)),t.component("md-menu-content",t.extend(c.default)),t.material.styles.push(f.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(285),a=o(r),s=n(287),d=o(s),l=n(286),c=o(l),u=n(235),f=o(u);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-progress",t.extend(a.default)),t.material.styles.push(d.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(288),a=o(r),s=n(236),d=o(s);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-radio",t.extend(a.default)),t.material.styles.push(d.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(289),a=o(r),s=n(237),d=o(s);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-select",t.extend(a.default)),t.component("md-option",t.extend(d.default)),t.material.styles.push(c.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(291),a=o(r),s=n(290),d=o(s),l=n(238),c=o(l);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-sidenav",t.extend(a.default)),t.material.styles.push(d.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(292),a=o(r),s=n(239),d=o(s);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-snackbar",t.extend(a.default)),t.material.styles.push(d.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(293),a=o(r),s=n(240),d=o(s);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(374),r=o(i),a=new r.default({data:function(){return{current:null}}});e.default=a,t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-spinner",t.extend(a.default)),t.material.styles.push(d.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(294),a=o(r),s=n(241),d=o(s);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-subheader",t.extend(a.default)),t.material.styles.push(d.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(295),a=o(r),s=n(242),d=o(s);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-switch",t.extend(a.default)),t.material.styles.push(d.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(296),a=o(r),s=n(243),d=o(s);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-table",t.extend(a.default)),t.component("md-table-header",{functional:!0,render:function(t,e){return t("thead",{staticClass:"md-table-header"},e.children)}}),t.component("md-table-body",{functional:!0,render:function(t,e){return t("tbody",{staticClass:"md-table-body"},e.children)}}),t.component("md-table-row",t.extend(d.default)),t.component("md-table-head",t.extend(c.default)),t.component("md-table-cell",t.extend(f.default)),t.component("md-table-edit",t.extend(p.default)),t.component("md-table-card",t.extend(b.default)),t.component("md-table-pagination",t.extend(_.default)),t.component("md-table-alternate-header",t.extend(g.default)),t.material.styles.push(y.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(297),a=o(r),s=n(304),d=o(s),l=n(302),c=o(l),u=n(300),f=o(u),m=n(301),p=o(m),h=n(299),b=o(h),v=n(298),g=o(v),E=n(303),_=o(E),C=n(244),y=o(C);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-tabs",t.extend(a.default)),t.component("md-tab",t.extend(d.default)),t.material.styles.push(c.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(306),a=o(r),s=n(305),d=o(s),l=n(245),c=o(l);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-toolbar",t.extend(a.default)),t.material.styles.push(d.default)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(307),a=o(r),s=n(246),d=o(s);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-tooltip",t.extend(a.default))}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(308),a=o(r);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-whiteframe",t.extend(a.default))}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(309),a=o(r);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.component("md-ink-ripple",t.extend(a.default))}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(310),a=o(r);t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){t.material=new t({data:function(){return{styles:[],currentTheme:null,inkRipple:!0}},methods:{registerTheme:function(t,e){var n={};"string"==typeof t?n[t]=e:n=t,E(n,this.styles)},applyCurrentTheme:function(t){document.body.classList.remove("md-theme-"+this.currentTheme),document.body.classList.add("md-theme-"+t),this.currentTheme=t},setCurrentTheme:function(t){b.indexOf(t)>=0?this.applyCurrentTheme(t):(b.indexOf("default")===-1?this.registerTheme("default",p):console.warn("The theme '"+t+"' doesn't exists. You need to register it first in order to use."),this.applyCurrentTheme("default"))}}}),t.component("md-theme",f.default),t.prototype.$material=t.material}Object.defineProperty(e,"__esModule",{value:!0});var r=n(44),a=o(r);e.default=i;var s=n(105),d=o(s),l=n(106),c=o(l),u=n(311),f=o(u),m=["primary","accent","background","warn","hue-1","hue-2","hue-3"],p={primary:"indigo",accent:"pink",background:"white",warn:"deep-orange"},h=function(t,e){var n=document.head,o="md-theme-"+e,i=n.querySelector("#"+o);if(i)i.textContent=t;else{var r=document.createElement("style");t=t.replace(/THEME_NAME/g,o),r.type="text/css",r.id=o,r.textContent=t,n.appendChild(r)}},b=[],v=function(t,e){return m.forEach((function(n){t=t.replace(RegExp("("+n.toUpperCase()+")-(COLOR|CONTRAST)-?(A?\\d*)-?(\\d*\\.?\\d+)?","g"),(function(t,o,i,r,a){var s=void 0,l=0===+r?500:r;if(e[n]?"string"==typeof e[n]?s=d.default[e[n]]:(s=d.default[e[n].color]||d.default[p[n]],l=0===+r?e[n].hue:r):s=d.default[p[n]],"COLOR"===i){var u=d.default[e[n]];return r||u||("accent"===n?l="A200":"background"===n&&(l=50)),a?(0,c.default)(s[l],a):s[l]}return s.darkText.indexOf(l)>=0?a?(0,c.default)("#000",a):"rgba(0, 0, 0, .87)":a?(0,c.default)("#fff",a):"rgba(255, 255, 255, .87)"}))})),t},g=function(t,e,n){var o=[];n.forEach((function(e){o.push(v(e,t))})),h(o.join("\n"),e)},E=function(t,e){var n=t?(0,a.default)(t):[];n.forEach((function(n){g(t[n],n,e),b.push(n)}))};t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={red:{50:"#ffebee",100:"#ffcdd2",200:"#ef9a9a",300:"#e57373",400:"#ef5350",500:"#f44336",600:"#e53935",700:"#d32f2f",800:"#c62828",900:"#b71c1c",A100:"#ff8a80",A200:"#ff5252",A400:"#ff1744",A700:"#d50000",darkText:[50,100,200,300,"A100"]},pink:{50:"#fce4ec",100:"#f8bbd0",200:"#f48fb1",300:"#f06292",400:"#ec407a",500:"#e91e63",600:"#d81b60",700:"#c2185b",800:"#ad1457",900:"#880e4f",A100:"#ff80ab",A200:"#ff4081",A400:"#f50057",
	A700:"#c51162",darkText:[50,100,200,"A100"]},purple:{50:"#f3e5f5",100:"#e1bee7",200:"#ce93d8",300:"#ba68c8",400:"#ab47bc",500:"#9c27b0",600:"#8e24aa",700:"#7b1fa2",800:"#6a1b9a",900:"#4a148c",A100:"#ea80fc",A200:"#e040fb",A400:"#d500f9",A700:"#aa00ff",darkText:[50,100,200,"A100"]},"deep-purple":{50:"#ede7f6",100:"#d1c4e9",200:"#b39ddb",300:"#9575cd",400:"#7e57c2",500:"#673ab7",600:"#5e35b1",700:"#512da8",800:"#4527a0",900:"#311b92",A100:"#b388ff",A200:"#7c4dff",A400:"#651fff",A700:"#6200ea",darkText:[50,100,200,"A100"]},indigo:{50:"#e8eaf6",100:"#c5cae9",200:"#9fa8da",300:"#7986cb",400:"#5c6bc0",500:"#3f51b5",600:"#3949ab",700:"#303f9f",800:"#283593",900:"#1a237e",A100:"#8c9eff",A200:"#536dfe",A400:"#3d5afe",A700:"#304ffe",darkText:[50,100,200,"A100"]},blue:{50:"#e3f2fd",100:"#bbdefb",200:"#90caf9",300:"#64b5f6",400:"#42a5f5",500:"#2196f3",600:"#1e88e5",700:"#1976d2",800:"#1565c0",900:"#0d47a1",A100:"#82b1ff",A200:"#448aff",A400:"#2979ff",A700:"#2962ff",darkText:[50,100,200,300,400,"A100"]},"light-blue":{50:"#e1f5fe",100:"#b3e5fc",200:"#81d4fa",300:"#4fc3f7",400:"#29b6f6",500:"#03a9f4",600:"#039be5",700:"#0288d1",800:"#0277bd",900:"#01579b",A100:"#80d8ff",A200:"#40c4ff",A400:"#00b0ff",A700:"#0091ea",darkText:[50,100,200,300,400,500,"A100","A200","A300"]},cyan:{50:"#e0f7fa",100:"#b2ebf2",200:"#80deea",300:"#4dd0e1",400:"#26c6da",500:"#00bcd4",600:"#00acc1",700:"#0097a7",800:"#00838f",900:"#006064",A100:"#84ffff",A200:"#18ffff",A400:"#00e5ff",A700:"#00b8d4",darkText:[50,100,200,300,400,500,600,"A100","A200","A300","A400"]},teal:{50:"#e0f2f1",100:"#b2dfdb",200:"#80cbc4",300:"#4db6ac",400:"#26a69a",500:"#009688",600:"#00897b",700:"#00796b",800:"#00695c",900:"#004d40",A100:"#a7ffeb",A200:"#64ffda",A400:"#1de9b6",A700:"#00bfa5",darkText:[50,100,200,300,400,"A100","A200","A300","A400"]},green:{50:"#e8f5e9",100:"#c8e6c9",200:"#a5d6a7",300:"#81c784",400:"#66bb6a",500:"#4caf50",600:"#43a047",700:"#388e3c",800:"#2e7d32",900:"#1b5e20",A100:"#b9f6ca",A200:"#69f0ae",A400:"#00e676",A700:"#00c853",darkText:[50,100,200,300,400,500,"A100","A200","A300","A400"]},"light-green":{50:"#f1f8e9",100:"#dcedc8",200:"#c5e1a5",300:"#aed581",400:"#9ccc65",500:"#8bc34a",600:"#7cb342",700:"#689f38",800:"#558b2f",900:"#33691e",A100:"#ccff90",A200:"#b2ff59",A400:"#76ff03",A700:"#64dd17",darkText:[50,100,200,300,400,500,600,"A100","A200","A300","A400"]},lime:{50:"#f9fbe7",100:"#f0f4c3",200:"#e6ee9c",300:"#dce775",400:"#d4e157",500:"#cddc39",600:"#c0ca33",700:"#afb42b",800:"#9e9d24",900:"#827717",A100:"#f4ff81",A200:"#eeff41",A400:"#c6ff00",A700:"#aeea00",darkText:[50,100,200,300,400,500,600,700,800,"A100","A200","A300","A400"]},yellow:{50:"#fffde7",100:"#fff9c4",200:"#fff59d",300:"#fff176",400:"#ffee58",500:"#ffeb3b",600:"#fdd835",700:"#fbc02d",800:"#f9a825",900:"#f57f17",A100:"#ffff8d",A200:"#ffff00",A400:"#ffea00",A700:"#ffd600",darkText:[50,100,200,300,400,500,600,700,800,900,"A100","A200","A300","A400"]},amber:{50:"#fff8e1",100:"#ffecb3",200:"#ffe082",300:"#ffd54f",400:"#ffca28",500:"#ffc107",600:"#ffb300",700:"#ffa000",800:"#ff8f00",900:"#ff6f00",A100:"#ffe57f",A200:"#ffd740",A400:"#ffc400",A700:"#ffab00",darkText:[50,100,200,300,400,500,600,700,800,900,"A100","A200","A300","A400"]},orange:{50:"#fff3e0",100:"#ffe0b2",200:"#ffcc80",300:"#ffb74d",400:"#ffa726",500:"#ff9800",600:"#fb8c00",700:"#f57c00",800:"#ef6c00",900:"#e65100",A100:"#ffd180",A200:"#ffab40",A400:"#ff9100",A700:"#ff6d00",darkText:[50,100,200,300,400,500,600,700,"A100","A200","A300","A400"]},"deep-orange":{50:"#fbe9e7",100:"#ffccbc",200:"#ffab91",300:"#ff8a65",400:"#ff7043",500:"#ff5722",600:"#f4511e",700:"#e64a19",800:"#d84315",900:"#bf360c",A100:"#ff9e80",A200:"#ff6e40",A400:"#ff3d00",A700:"#dd2c00",darkText:[50,100,200,300,400,"A100","A200"]},brown:{50:"#efebe9",100:"#d7ccc8",200:"#bcaaa4",300:"#a1887f",400:"#8d6e63",500:"#795548",600:"#6d4c41",700:"#5d4037",800:"#4e342e",900:"#3e2723",A100:"#d7ccc8",A200:"#bcaaa4",A400:"#8d6e63",A700:"#5d4037",darkText:[50,100,200,"A100","A200","A300","A400"]},grey:{50:"#fafafa",100:"#f5f5f5",200:"#eeeeee",300:"#e0e0e0",400:"#bdbdbd",500:"#9e9e9e",600:"#757575",700:"#616161",800:"#424242",900:"#212121",A100:"#fff",A200:"#000000",A400:"#303030",A700:"#616161",darkText:[50,100,200,300,400,500,"A100"]},"blue-grey":{50:"#eceff1",100:"#cfd8dc",200:"#b0bec5",300:"#90a4ae",400:"#78909c",500:"#607d8b",600:"#546e7a",700:"#455a64",800:"#37474f",900:"#263238",A100:"#cfd8dc",A200:"#b0bec5",A400:"#78909c",A700:"#455a64",darkText:[50,100,200,300,"A100","A200","A300","A400"]},white:{50:"#fff",100:"#fff",200:"#fff",300:"#fff",400:"#fff",500:"#fff",600:"#fff",700:"#fff",800:"#fff",900:"#fff",A100:"#fff",A200:"#fff",A400:"#fff",A700:"#fff",darkText:[50,100,200,300,400,500,600,700,800,900,"A100","A200","A300","A400"]},black:{50:"#000",100:"#000",200:"#000",300:"#000",400:"#000",500:"#000",600:"#000",700:"#000",800:"#000",900:"#000",A100:"#000",A200:"#000",A400:"#000",A700:"#000",darkText:[]}},t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t,e){var n="",o="",i="",r=t.toString().match(/^#?(([0-9a-zA-Z]{3}){1,3})$/);if(!r)throw new Error("Invalid color"+t);if(t=r[1],6===t.length)n=parseInt(t.substring(0,2),16),o=parseInt(t.substring(2,4),16),i=parseInt(t.substring(4,6),16);else if(3===t.length){var a=t.substring(0,1),s=t.substring(1,2),d=t.substring(2,3);n=parseInt(a+a,16),o=parseInt(s+s,16),i=parseInt(d+d,16)}return e?(e>1&&(e/=100),"rgba("+n+", "+o+", "+i+", "+e+")"):"rgb("+n+", "+o+", "+i+")"},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function i(t){return i.installed?void console.warn("Vue Material is already installed."):(i.installed=!0,t.use(a.default),t.use(d.default),void t.material.styles.push(c.default))}Object.defineProperty(e,"__esModule",{value:!0}),e.default=i;var r=n(104),a=o(r),s=n(103),d=o(s),l=n(247),c=o(l);n(373),t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=8,o=function(t,e){return e.top<=n-parseInt(getComputedStyle(t).marginTop,10)},i=function(t,e){return e.top+t.offsetHeight+n>=window.innerHeight-parseInt(getComputedStyle(t).marginTop,10)},r=function(t,e){return e.left<=n-parseInt(getComputedStyle(t).marginLeft,10)},a=function(t,e){return e.left+t.offsetWidth+n>=window.innerWidth-parseInt(getComputedStyle(t).marginLeft,10)},s=function(t,e){var s=getComputedStyle(t);return o(t,e)&&(e.top=n-parseInt(s.marginTop,10)),r(t,e)&&(e.left=n-parseInt(s.marginLeft,10)),a(t,e)&&(e.left=window.innerWidth-n-t.offsetWidth-parseInt(s.marginLeft,10)),i(t,e)&&(e.top=window.innerHeight-n-t.offsetHeight-parseInt(s.marginTop,10)),e};e.default=s,t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(t,e){var n=!1;return function(){n||(t.call(),n=!0,window.setTimeout((function(){n=!1}),e))}};e.default=n,t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(1),r=o(i);e.default={mixins:[r.default]},t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={methods:{close:function(){this.$emit("close")}}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(1),r=o(i);e.default={props:{mdShift:Boolean},mixins:[r.default],computed:{classes:function(){return this.mdShift?"md-shift":"md-fixed"}},methods:{setActive:function(t){this.$children.forEach((function(e){e.active=e===t})),this.$emit("change",this.$children.findIndex((function(e){return e===t})))}}},t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={props:{mdIcon:String,mdActive:Boolean,disabled:String,href:String},data:function(){return{active:!1}},computed:{classes:function(){return{"md-active":this.active}}},watch:{mdActive:function(t){this.setActive(t)}},methods:{setActive:function(t){t&&this.$parent.setActive(this)}},mounted:function(){if(!this.$parent.$el.classList.contains("md-bottom-bar"))throw this.$destroy(),new Error("You should wrap the md-bottom-bar-item in a md-bottom-bar");this.mdActive&&(this.active=!0)}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(1),r=o(i);e.default={props:{href:String,target:String,rel:String,type:{type:String,default:"button"},disabled:Boolean},mixins:[r.default],computed:{newRel:function(){return"_blank"===this.target?this.rel||"noopener":this.rel}}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(1),r=o(i),a=void 0;e.default={props:{mdSingle:Boolean},mixins:[r.default],mounted:function(){var t=this;this.$children.forEach((function(e){var n=e.$el,o="md-toggle";a=function(){t.mdSingle?(t.$children.forEach((function(t){t.$el.classList.remove(o)})),n.classList.add(o)):n.classList.toggle(o)},n&&n.classList.contains("md-button")&&n.addEventListener("click",a)}))},beforeDestroy:function(){this.$children.forEach((function(t){var e=t.$el;e&&e.classList.contains("md-button")&&e.removeEventListener("click",a)}))}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(1),r=o(i);e.default={props:{mdWithHover:Boolean},mixins:[r.default],computed:{classes:function(){return{"md-with-hover":this.mdWithHover}}}},t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={props:{mdInset:Boolean},computed:{classes:function(){return{"md-inset":this.mdInset}}}},t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={methods:{setContentMargin:function(){this.content.style.marginTop=-this.content.offsetHeight+"px"},toggle:function(){this.$refs.expand.classList.toggle("md-active")},onWindowResize:function(){window.requestAnimationFrame(this.setContentMargin)}},mounted:function(){var t=this;window.setTimeout((function(){t.trigger=t.$el.querySelector("[md-expand-trigger]"),t.content=t.$el.querySelector(".md-card-content"),t.content&&(t.setContentMargin(),t.trigger.addEventListener("click",t.toggle),window.addEventListener("resize",t.onWindowResize))}),200)},destroyed:function(){this.content&&(this.trigger.removeEventListener("click",this.toggle),window.removeEventListener("resize",this.onWindowResize))}},t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={mounted:function(){this.parentClasses=this.$parent.$el.classList,this.parentClasses.contains("md-card-header")&&(this.insideParent=!0,this.parentClasses.add("md-card-header-flex"))},destroyed:function(){this.parentClasses.remove("md-card-header-flex")}},t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={props:{mdRatio:String,mdMedium:Boolean,mdBig:Boolean},computed:{classes:function t(){var t={"md-16-9":"16:9"===this.mdRatio||"16/9"===this.mdRatio,"md-4-3":"4:3"===this.mdRatio||"4/3"===this.mdRatio,"md-1-1":"1:1"===this.mdRatio||"1/1"===this.mdRatio};return(this.mdMedium||this.mdBig)&&(t={"md-medium":this.mdMedium,"md-big":this.mdBig}),t}}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(66),r=o(i);e.default={props:{mdTextScrim:Boolean,mdSolid:Boolean},data:function(){return{backdropBg:{}}},computed:{classes:function(){return{"md-text-scrim":this.mdTextScrim,"md-solid":this.mdSolid}},styles:function(){return{background:this.backdropBg}}},methods:{applyScrimColor:function(t){this.$refs.backdrop&&(this.backdropBg="linear-gradient(to bottom, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, "+t/2+") 66%, rgba(0, 0, 0, "+t+") 100%)")},applySolidColor:function(t){var e=this.$el.querySelector(".md-card-area");e&&(e.style.background="rgba(0, 0, 0, "+t+")")}},mounted:function(){var t=this,e=this.$el.querySelector("img");e&&(this.mdTextScrim||this.mdSolid)&&(0,r.default)(e,(function(e){var n=256,o=(100*Math.abs(n-e)/n+15)/100;o>=.7&&(o=.7),t.mdTextScrim?t.applyScrimColor(o):t.mdSolid&&t.applySolidColor(o)}))}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(1),r=o(i);e.default={props:{name:String,value:[String,Boolean],id:String,disabled:Boolean},mixins:[r.default],data:function(){return{checked:this.value}},computed:{classes:function(){return{"md-checked":Boolean(this.checked),"md-disabled":this.disabled}}},watch:{value:function(){this.checked=this.value}},methods:{toggleCheck:function(t){this.disabled||(this.checked=!this.checked,this.$emit("change",this.checked,t),this.$emit("input",this.checked,t))}}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(1),r=o(i);e.default={props:{disabled:Boolean,mdDeletable:Boolean},mixins:[r.default],computed:{classes:function(){return{"md-deletable":this.mdDeletable,"md-disabled":this.disabled}}}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(1),r=o(i),a=n(43),s=o(a);e.default={props:{value:Array,disabled:Boolean,mdInputId:String,mdInputName:String,mdInputPlaceholder:String,mdInputType:{type:String,default:"text"},mdStatic:Boolean,mdMax:{type:Number,default:1/0}},mixins:[r.default],data:function(){return{currentChip:null,selectedChips:this.value,inputId:this.mdInputId||"chips-"+(0,s.default)()}},watch:{value:function(t){this.selectedChips=t}},computed:{classes:function(){return{"md-static":this.mdStatic,"md-disabled":this.disabled}}},methods:{applyInputFocus:function(){var t=this;this.$nextTick((function(){t.$refs.input.$el.focus()}))},selectChip:function(){if(this.currentChip&&this.selectedChips.length<this.mdMax){var t=this.currentChip.trim();this.selectedChips.indexOf(t)<0&&(this.selectedChips.push(t),this.currentChip=null,this.$emit("input",this.selectedChips),this.$emit("change",this.selectedChips),this.applyInputFocus())}},deleteChip:function(t){var e=this.selectedChips.indexOf(t);e>=0&&this.selectedChips.splice(e,1),this.$emit("change",this.selectedChips),this.applyInputFocus()},deleteLastChip:function(){this.currentChip||(this.selectedChips.pop(),this.$emit("change",this.selectedChips),this.applyInputFocus())}}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(1),r=o(i),a=n(38),s=o(a);e.default={props:{mdClickOutsideToClose:{type:Boolean,default:!0},mdEscToClose:{type:Boolean,default:!0},mdBackdrop:{type:Boolean,default:!0},mdOpenFrom:String,mdCloseTo:String,mdFullscreen:{type:Boolean,default:!1}},mixins:[r.default],data:function(){return{active:!1,transitionOff:!1,dialogTransform:""}},computed:{classes:function(){return{"md-active":this.active}},dialogClasses:function(){return{"md-fullscreen":this.mdFullscreen,"md-transition-off":this.transitionOff,"md-reference":this.mdOpenFrom||this.mdCloseTo}},styles:function(){return{transform:this.dialogTransform}}},methods:{removeDialog:function(){this.rootElement.contains(this.dialogElement)&&this.$el.parentNode.removeChild(this.$el)},calculateDialogPos:function(t){var e=document.querySelector(t);if(e){var n=e.getBoundingClientRect(),o=this.dialogInnerElement.getBoundingClientRect(),i=n.width/o.width,r=n.height/o.height,a={top:-(o.top-n.top),left:-(o.left-n.left+n.width)};n.top>o.top+o.height&&(a.top=n.top-o.top),n.left>o.left+o.width&&(a.left=n.left-o.left-n.width),this.dialogTransform="translate3D("+a.left+"px, "+a.top+"px, 0) scale("+i+", "+r+")"}},open:function(){var t=this;this.rootElement.appendChild(this.dialogElement),this.transitionOff=!0,this.calculateDialogPos(this.mdOpenFrom),window.setTimeout((function(){t.dialogElement.focus(),t.transitionOff=!1,t.active=!0})),this.$emit("open")},closeOnEsc:function(){this.mdEscToClose&&this.close()},close:function(){var t=this;this.rootElement.contains(this.dialogElement)&&this.$nextTick((function(){var e=function e(){var n=t.dialogElement.querySelector(".md-ripple.md-active");n&&n.classList.remove("md-active"),t.dialogInnerElement.removeEventListener(s.default,e),t.rootElement.removeChild(t.dialogElement),t.dialogTransform=""};t.transitionOff=!0,t.dialogTransform="",t.calculateDialogPos(t.mdCloseTo),window.setTimeout((function(){t.transitionOff=!1,t.active=!1,t.dialogInnerElement.addEventListener(s.default,e)})),t.$emit("close")}))}},mounted:function(){var t=this;this.$nextTick((function(){t.rootElement=t.$root.$el,t.dialogElement=t.$el,t.dialogInnerElement=t.$refs.dialog,t.removeDialog()}))},beforeDestroy:function(){this.removeDialog()}},t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={props:{mdTitle:String,mdContent:String,mdContentHtml:String,mdOkText:{type:String,default:"Ok"}},data:function(){return{debounce:!1}},methods:{fireCloseEvent:function(){this.debounce||this.$emit("close")},open:function(){this.$emit("open"),this.debounce=!1,this.$refs.dialog.open()},close:function(){this.fireCloseEvent(),this.debounce=!0,this.$refs.dialog.close()}},mounted:function(){if(!this.mdContent&&!this.mdContentHtml)throw new Error("Missing md-content or md-content-html attributes")}},t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={props:{mdTitle:String,mdContent:String,mdContentHtml:String,mdOkText:{type:String,default:"Ok"},mdCancelText:{type:String,default:"Cancel"}},data:function(){return{debounce:!1}},methods:{fireCloseEvent:function(t){this.debounce||this.$emit("close",t)},open:function(){this.$emit("open"),this.debounce=!1,this.$refs.dialog.open()},close:function(t){this.fireCloseEvent(t),this.debounce=!0,this.$refs.dialog.close()}},mounted:function(){if(!this.mdContent&&!this.mdContentHtml)throw new Error("Missing md-content or md-content-html attributes")}},t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={props:{value:{type:[String,Number],required:!0},mdTitle:String,mdContent:String,mdContentHtml:String,mdOkText:{type:String,default:"Ok"},mdCancelText:{type:String,default:"Cancel"},mdInputId:String,mdInputName:String,mdInputMaxlength:[String,Number],mdInputPlaceholder:String},data:function(){return{debounce:!1}},methods:{fireCloseEvent:function(t){this.debounce||this.$emit("close",t)},open:function(){var t=this;this.$emit("open"),this.debounce=!1,this.$refs.dialog.open(),window.setTimeout((function(){t.$refs.input.$el.focus()}))},close:function(t){this.fireCloseEvent(t),this.debounce=!0,this.$refs.dialog.close()},confirmValue:function(){this.$emit("input",this.$refs.input.$el.value),this.close("ok")}}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(45),r=o(i),a=n(13),s=o(a);e.default={props:{value:String,id:String,name:String,disabled:Boolean,required:Boolean,placeholder:String,accept:String,multiple:Boolean},data:function(){return{filename:this.value}},watch:{value:function(){this.filename=this.value}},methods:{getMultipleName:function(t){var e=[];return[].concat((0,r.default)(t)).forEach((function(t){e.push(t.name)})),e.join(", ")},openPicker:function(){this.disabled||(this.$refs.fileInput.click(),this.$refs.textInput.$el.focus())},onFileSelected:function(t){var e=t.target.files||t.dataTransfer.files;e?e.length>1?this.filename=this.getMultipleName(e):1===e.length?this.filename=e[0].name:this.filename=null:this.filename=t.target.value.split("\\").pop(),this.$emit("selected",e||t.target.value),this.$emit("input",this.filename)}},mounted:function(){if(this.parentContainer=(0,s.default)(this.$parent,"md-input-container"),!this.parentContainer)throw this.$destroy(),new Error("You should wrap the md-file in a md-input-container");this.parentContainer.hasFile=!0},beforeDestroy:function(){this.parentContainer.hasFile=!1}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(1),r=o(i),a={};e.default={props:{mdSrc:String},data:function(){return{svgContent:null,imageSrc:null}},mixins:[r.default],watch:{mdSrc:function(){this.svgContent=null,this.imageSrc=null,this.checkSrc()}},methods:{isImage:function(t){return t.indexOf("image")>=0},isSVG:function(t){return t.indexOf("svg")>=0},setSVGContent:function(t){var e=this;this.svgContent=t,this.$nextTick((function(){e.$el.children[0].removeAttribute("fill")}))},loadSVG:function(){var t=this;a[this.mdSrc]?this.setSVGContent(a[this.mdSrc]):!(function(){var e=new XMLHttpRequest,n=t;e.open("GET",t.mdSrc,!0),e.onload=function(){var t=this.getResponseHeader("content-type");this.status>=200&&this.status<400&&n.isImage(t)?n.isSVG(t)?(a[n.mdSrc]=this.response,n.setSVGContent(this.response)):n.loadImage():console.warn("The file "+n.mdSrc+" is not a valid image.")},e.send()})()},loadImage:function(){this.imageSrc=this.mdSrc},checkSrc:function(){this.mdSrc&&(this.mdSrc.indexOf(".svg")>=0?this.loadSVG():this.loadImage())}},mounted:function(){this.checkSrc()}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(66),r=o(i);e.default={props:{mdSrc:String},data:function(){return{loaded:!1,applyBlack:!0,imageElement:null}},watch:{mdSrc:function(){this.createImage()}},computed:{classes:function(){return{"md-loaded":this.loaded,"md-black-output":this.applyBlack}}},methods:{analyzeLightness:function(t){var e=this;(0,r.default)(t,(function(t){var n=256,o=(100*Math.abs(n-t)/n+15)/100;o>=.7&&(e.applyBlack=!0),e.$nextTick((function(){e.loaded=!0}))}))},createImage:function(){this.loaded=!1,this.applyBlack=!1,this.imageElement=null,this.mdSrc&&(this.imageElement=document.createElement("img"),this.imageElement.crossOrigin="",this.imageElement.src=this.mdSrc,this.analyzeLightness(this.imageElement))}},created:function(){this.createImage()}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(68),r=o(i),a=n(13),s=o(a);e.default={mixins:[r.default],props:{type:{type:String,default:"text"}},mounted:function(){if(this.parentContainer=(0,s.default)(this.$parent,"md-input-container"),!this.parentContainer)throw this.$destroy(),new Error("You should wrap the md-input in a md-input-container");this.setParentDisabled(),this.setParentRequired(),this.setParentPlaceholder(),this.setParentValue(),this.handleMaxLength()}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(1),r=o(i),a=n(67),s=o(a);e.default={props:{mdInline:Boolean,mdHasPassword:Boolean},mixins:[r.default],data:function(){return{value:"",input:!1,showPassword:!1,enableCounter:!1,hasSelect:!1,hasPlaceholder:!1,hasFile:!1,isDisabled:!1,isRequired:!1,isFocused:!1,counterLength:0,inputLength:0}},computed:{hasValue:function(){return(0,s.default)(this.value)?this.value.length>0:Boolean(this.value)},classes:function(){return{"md-input-inline":this.mdInline,"md-has-password":this.mdHasPassword,"md-has-select":this.hasSelect,"md-has-file":this.hasFile,"md-has-value":this.hasValue,"md-input-placeholder":this.hasPlaceholder,"md-input-disabled":this.isDisabled,"md-input-required":this.isRequired,"md-input-focused":this.isFocused}}},methods:{isInput:function(){return this.input&&"input"===this.input.tagName.toLowerCase()},togglePasswordType:function(){this.isInput()&&("password"===this.input.type?(this.input.type="text",this.showPassword=!0):(this.input.type="password",this.showPassword=!1),this.input.focus())},setValue:function(t){this.value=t}},mounted:function(){if(this.input=this.$el.querySelectorAll("input, textarea, select, .md-file")[0],!this.input)throw this.$destroy(),new Error("Missing input/select/textarea inside md-input-container")}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(71),r=o(i),a=n(68),s=o(a),d=n(13),l=o(d);e.default={mixins:[s.default],watch:{value:function(){var t=this;this.$nextTick((function(){r.default.update(t.$el)}))}},mounted:function(){if(this.parentContainer=(0,l.default)(this.$parent,"md-input-container"),!this.parentContainer)throw this.$destroy(),new Error("You should wrap the md-textarea in a md-input-container");this.setParentDisabled(),this.setParentRequired(),this.setParentPlaceholder(),this.setParentValue(),this.handleMaxLength(),this.$el.getAttribute("rows")||this.$el.setAttribute("rows","1"),(0,r.default)(this.$el)},beforeDestroy:function(){r.default.destroy(this.$el)}},t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={props:{mdTag:{type:String,default:"div"},mdRow:Boolean,mdRowXsmall:Boolean,mdRowSmall:Boolean,mdRowMedium:Boolean,mdRowLarge:Boolean,mdRowXlarge:Boolean,mdColumn:Boolean,mdColumnXsmall:Boolean,mdColumnSmall:Boolean,mdColumnMedium:Boolean,mdColumnLarge:Boolean,mdColumnXlarge:Boolean,mdHideXsmall:Boolean,mdHideSmall:Boolean,mdHideMedium:Boolean,mdHideLarge:Boolean,mdHideXlarge:Boolean,mdGutter:[String,Number,Boolean],mdAlign:String,mdAlignXsmall:String,mdAlignSmall:String,mdAlignMedium:String,mdAlignLarge:String,mdAlignXlarge:String,mdFlex:[String,Number,Boolean],mdFlexXsmall:[String,Number,Boolean],mdFlexSmall:[String,Number,Boolean],mdFlexMedium:[String,Number,Boolean],mdFlexLarge:[String,Number,Boolean],mdFlexXlarge:[String,Number,Boolean],mdFlexOffset:[String,Number,Boolean],mdFlexOffsetXsmall:[String,Number,Boolean],mdFlexOffsetSmall:[String,Number,Boolean],mdFlexOffsetMedium:[String,Number,Boolean],mdFlexOffsetLarge:[String,Number,Boolean],mdFlexOffsetXlarge:[String,Number,Boolean]},computed:{classes:function t(){var t={"md-row":this.mdRow,"md-row-xsmall":this.mdRowXsmall,"md-row-small":this.mdRowSmall,"md-row-medium":this.mdRowMedium,"md-row-large":this.mdRowLarge,"md-row-xlarge":this.mdRowXlarge,"md-column":this.mdColumn,"md-column-xsmall":this.mdColumnXsmall,"md-column-small":this.mdColumnSmall,"md-column-medium":this.mdColumnMedium,"md-column-large":this.mdColumnLarge,"md-column-xlarge":this.mdColumnXlarge,"md-hide-xsmall":this.mdHideXsmall,"md-hide-small":this.mdHideSmall,"md-hide-medium":this.mdHideMedium,"md-hide-large":this.mdHideLarge,"md-hide-xlarge":this.mdHideXlarge};return this.mdGutter&&("boolean"==typeof this.mdGutter?t["md-gutter"]=!0:this.mdGutter&&(t["md-gutter-"+this.mdGutter]=!0)),this.generatePropClasses("md-flex","","mdFlex",t),this.generatePropClasses("md-flex","xsmall","mdFlexXsmall",t),this.generatePropClasses("md-flex","small","mdFlexSmall",t),this.generatePropClasses("md-flex","medium","mdFlexMedium",t),this.generatePropClasses("md-flex","large","mdFlexLarge",t),this.generatePropClasses("md-flex","xlarge","mdFlexXlarge",t),this.generatePropClasses("md-flex-offset","","mdFlexOffset",t),this.generatePropClasses("md-flex-offset","xsmall","mdFlexOffsetXsmall",t),this.generatePropClasses("md-flex-offset","small","mdFlexOffsetSmall",t),this.generatePropClasses("md-flex-offset","medium","mdFlexOffsetMedium",t),this.generatePropClasses("md-flex-offset","large","mdFlexOffsetLarge",t),this.generatePropClasses("md-flex-offset","xlarge","mdFlexOffsetXlarge",t),this.generatePropClasses("md-align","","mdAlign",t),this.generatePropClasses("md-align","xsmall","mdAlignXsmall",t),this.generatePropClasses("md-align","small","mdAlignSmall",t),this.generatePropClasses("md-align","medium","mdAlignMedium",t),this.generatePropClasses("md-align","large","mdAlignLarge",t),this.generatePropClasses("md-align","xlarge","mdAlignXlarge",t),t}},methods:{generatePropClasses:function(t,e,n,o){e&&(e="-"+e),this[n]&&("boolean"==typeof this[n]?o[t+e]=!0:o[t+e+"-"+this[n]]=!0)}},render:function(t){return t(this.mdTag,{staticClass:"md-layout",class:this.classes},this.$slots.default)}},t.exports=e.default}),110,(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={data:function(){return{height:0,contentObserver:null,transitionOff:!0}},computed:{classes:function(){return{"md-transition-off":this.transitionOff}},styles:function(){return{"margin-bottom":this.height}}},methods:{calculatePadding:function(){var t=this;window.requestAnimationFrame((function(){t.height=-t.$el.offsetHeight-48+"px",window.setTimeout((function(){t.transitionOff=!1}))}))},recalculateAfterChange:function(){this.transitionOff=!0,this.calculatePadding()},observeChildChanges:function(){this.contentObserver=new MutationObserver(this.recalculateAfterChange),this.contentObserver.observe(this.$refs.expand,{childList:!0,characterData:!0,subtree:!0})}},mounted:function(){this.calculatePadding(),this.observeChildChanges(),window.addEventListener("resize",this.recalculateAfterChange)},beforeDestroy:function(){this.contentObserver&&this.contentObserver.disconnect(),window.removeEventListener("resize",this.recalculateAfterChange)}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(45),r=o(i);e.default={props:{href:String,target:String,disabled:Boolean},render:function(t){var e=this,n="md-button md-list-item-container",o="md-list-item-holder",i=this.$slots.default,a=i[0].componentOptions,s=void 0,d=void 0,l={staticClass:"md-list-item",on:{click:function(t){e.$emit("click",t)}}},c=function(e){return t("div",{staticClass:o},e)},u=function(){return t("md-ink-ripple")},f=function(){return i[0].data.staticClass=n+" "+o,t("li",l,[].concat((0,r.default)(i),[u()]))},m=function(){i.some((function(t,e){if(t.componentOptions&&"md-list-expand"===t.componentOptions.tag)return s=t,d=e,!0}))},p=function(){return t("md-icon",{staticClass:"md-list-expand-indicator"},"keyboard_arrow_down")},h=function(t){t.$children.some((function(t){t.$el.classList.contains("md-list-expand")&&t.calculatePadding()}))},b=function(t){var e=void 0;t.$parent.$children.some((function(t){var n=t.$el.classList;if(n.contains("md-list-item-expand")&&n.contains("md-active"))return e=t,n.remove("md-active"),h(t),!0})),e&&t.$el===e.$el||t.$el.classList.add("md-active")},v=function(){return i.splice(d,1),i.push(p()),t("button",{staticClass:n,on:{click:function(){b(e),e.$emit("click")}}},[c(i),u()])},g=function(){return l.staticClass+=" md-list-item-expand",t("li",l,[v(),s])};if(a&&"router-link"===a.tag)return f();if(m(),s)return g();var E=t("md-button",{staticClass:n,attrs:{target:this.target,href:this.href,disabled:this.disabled}},[c(i)]);return this.target&&(E.data.attrs.rel="noopener"),t("li",l,[E])}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(38),r=o(i),a=n(108),s=o(a);e.default={props:{mdSize:{type:[Number,String],default:0},mdDirection:{type:String,default:"bottom right"},mdAlignTrigger:{type:Boolean,default:!1},mdOffsetX:{type:[Number,String],default:0},mdOffsetY:{type:[Number,String],default:0},mdCloseOnSelect:{type:Boolean,default:!0}},data:function(){return{active:!1}},watch:{mdSize:function(t,e){t>=1&&t<=7&&(this.removeLastSizeMenuContentClass(e),this.addNewSizeMenuContentClass(t))},mdDirection:function(t,e){this.removeLastDirectionMenuContentClass(e),this.addNewDirectionMenuContentClass(t)},mdAlignTrigger:function(t){
	this.handleAlignTriggerClass(t)}},methods:{validateMenu:function(){if(!this.menuContent)throw this.$destroy(),new Error("You must have a md-menu-content inside your menu.");if(!this.menuTrigger)throw this.$destroy(),new Error("You must have an element with a md-menu-trigger attribute inside your menu.")},removeLastSizeMenuContentClass:function(t){this.menuContent.classList.remove("md-size-"+t)},removeLastDirectionMenuContentClass:function(t){this.menuContent.classList.remove("md-direction-"+t.replace(/ /g,"-"))},addNewSizeMenuContentClass:function(t){this.menuContent.classList.add("md-size-"+t)},addNewDirectionMenuContentClass:function(t){this.menuContent.classList.add("md-direction-"+t.replace(/ /g,"-"))},handleAlignTriggerClass:function(t){t&&this.menuContent.classList.add("md-align-trigger")},getPosition:function(t,e){var n=this.menuTrigger.getBoundingClientRect(),o="top"===t?n.top+n.height-this.menuContent.offsetHeight:n.top,i="left"===e?n.left-this.menuContent.offsetWidth+n.width:n.left;return o+=parseInt(this.mdOffsetY,10),i+=parseInt(this.mdOffsetX,10),this.mdAlignTrigger&&("top"===t?o-=n.height+11:o+=n.height+11),{top:o,left:i}},calculateMenuContentPos:function(){var t=void 0;t=this.mdDirection?this.getPosition.apply(this,this.mdDirection.trim().split(" ")):this.getPosition("bottom","right"),t=(0,s.default)(this.menuContent,t),this.menuContent.style.top=t.top+window.pageYOffset+"px",this.menuContent.style.left=t.left+window.pageXOffset+"px"},recalculateOnResize:function(){window.requestAnimationFrame(this.calculateMenuContentPos)},open:function(){this.rootElement.contains(this.menuContent)&&this.rootElement.removeChild(this.menuContent),this.rootElement.appendChild(this.menuContent),this.rootElement.appendChild(this.backdropElement),window.addEventListener("resize",this.recalculateOnResize),this.calculateMenuContentPos(),getComputedStyle(this.menuContent).top,this.menuContent.classList.add("md-active"),this.menuContent.focus(),this.active=!0,this.$emit("open")},close:function t(){var e=this,t=function t(n){if(e.menuContent&&n.target===e.menuContent){var o=e.menuContent.querySelector(".md-ripple.md-active");e.menuContent.removeEventListener(r.default,t),e.menuTrigger.focus(),e.active=!1,o&&o.classList.remove("md-active"),e.rootElement.removeChild(e.menuContent),e.rootElement.removeChild(e.backdropElement),window.removeEventListener("resize",e.recalculateOnResize)}};this.menuContent.addEventListener(r.default,t),this.menuContent.classList.remove("md-active"),this.$emit("close")},toggle:function(){this.active?this.close():this.open()}},mounted:function(){var t=this;this.$nextTick((function(){t.rootElement=t.$root.$el,t.menuTrigger=t.$el.querySelector("[md-menu-trigger]"),t.menuContent=t.$el.querySelector(".md-menu-content"),t.backdropElement=t.$refs.backdrop.$el,t.validateMenu(),t.handleAlignTriggerClass(t.mdAlignTrigger),t.addNewSizeMenuContentClass(t.mdSize),t.addNewDirectionMenuContentClass(t.mdDirection),t.$el.removeChild(t.$refs.backdrop.$el),t.menuContent.parentNode.removeChild(t.menuContent),t.menuTrigger.addEventListener("click",t.toggle)}))},beforeDestroy:function(){this.rootElement.contains(this.menuContent)&&(this.rootElement.removeChild(this.menuContent),this.rootElement.removeChild(this.backdropElement)),this.menuTrigger.removeEventListener("click",this.toggle),window.removeEventListener("resize",this.recalculateOnResize)}},t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={data:function(){return{oldHighlight:!1,highlighted:!1,itemsAmount:0}},methods:{close:function(){this.highlighted=!1,this.$parent.close()},highlightItem:function(t){this.oldHighlight=this.highlighted,"up"===t&&(1===this.highlighted?this.highlighted=this.itemsAmount:this.highlighted--),"down"===t&&(this.highlighted===this.itemsAmount?this.highlighted=1:this.highlighted++)},fireClick:function(){this.highlighted>0&&this.$children[0].$children[this.highlighted-1].$el.click()}},mounted:function(){if(!this.$parent.$el.classList.contains("md-menu"))throw this.$destroy(),new Error("You must wrap the md-menu-content in a md-menu")}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(13),r=o(i);n(190),e.default={props:{disabled:Boolean},data:function(){return{parentContent:{},index:0}},computed:{classes:function(){return{"md-highlighted":this.highlighted}},highlighted:function(){return this.index===this.parentContent.highlighted&&(this.disabled&&(this.parentContent.oldHighlight>this.parentContent.highlighted?this.parentContent.highlighted--:this.parentContent.highlighted++),1===this.index?this.parentContent.$el.scrollTop=0:this.index===this.parentContent.itemsAmount?this.parentContent.$el.scrollTop=this.parentContent.$el.scrollHeight:this.$el.scrollIntoViewIfNeeded(!1),!0)}},methods:{close:function(t){this.disabled||(this.parentMenu.mdCloseOnSelect&&this.parentContent.close(),this.$emit("click"),this.$emit("selected",t))}},mounted:function(){if(this.parentContent=(0,r.default)(this.$parent,"md-menu-content"),this.parentMenu=(0,r.default)(this.$parent,"md-menu"),!this.parentContent)throw this.$destroy(),new Error("You must wrap the md-menu-item in a md-menu-content");this.parentContent.itemsAmount++,this.index=this.parentContent.itemsAmount}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(1),r=o(i);e.default={props:{mdIndeterminate:Boolean,mdProgress:{type:Number,default:0}},mixins:[r.default],computed:{classes:function(){return{"md-indeterminate":this.mdIndeterminate}},styles:function(){if(!this.mdIndeterminate)return{width:this.mdProgress+"%"}}}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(1),r=o(i);e.default={props:{name:String,id:String,value:[String,Boolean,Number],mdValue:{type:[String,Boolean,Number],required:!0},disabled:Boolean},mixins:[r.default],computed:{classes:function(){return{"md-checked":this.value&&this.mdValue.toString()===this.value.toString(),"md-disabled":this.disabled}}},methods:{toggleCheck:function(t){this.disabled||(this.$emit("change",this.mdValue,t),this.$emit("input",this.mdValue,t))}}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(13),r=o(i);e.default={props:{value:[String,Boolean,Number]},data:function(){return{parentSelect:{},check:!1,index:0}},computed:{isSelected:function(){if(this.value&&this.parentSelect.value){var t=this.value.toString();return this.parentSelect.multiple?this.parentSelect.value.indexOf(t)>=0:this.value&&this.parentSelect.value&&t===this.parentSelect.value.toString()}return!1},classes:function(){return{"md-selected":this.isSelected,"md-checked":this.check}}},methods:{isMultiple:function(){return this.parentSelect.multiple},setParentOption:function(){this.isMultiple()?this.check=!this.check:this.parentSelect.selectOption(this.value,this.$refs.item.textContent)},selectOption:function(t){this.setParentOption(),this.$emit("selected",t)}},watch:{isSelected:function(t){this.isMultiple()&&(this.check=t)},check:function(t){t?this.parentSelect.selectMultiple(this.index,this.value,this.$refs.item.textContent):this.parentSelect.selectMultiple(this.index)}},mounted:function(){if(this.parentSelect=(0,r.default)(this.$parent,"md-select"),this.parentContent=(0,r.default)(this.$parent,"md-menu-content"),!this.parentSelect)throw new Error("You must wrap the md-option in a md-select");this.parentSelect.optionsAmount++,this.index=this.parentSelect.optionsAmount,this.parentSelect.multipleOptions[this.index]={},this.parentSelect.options[this.index]=this,(this.isMultiple()&&this.parentSelect.value.indexOf(this.value)>=0||this.parentSelect.value===this.value)&&this.setParentOption()},beforeDestroy:function(){this.parentSelect&&(delete this.parentSelect.options[this.index],delete this.parentSelect.multipleOptions[this.index])}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(169),r=o(i),a=n(44),s=o(a),d=n(1),l=o(d),c=n(13),u=o(c),f=n(67),m=o(f);e.default={props:{name:String,id:String,required:Boolean,multiple:Boolean,value:[String,Number,Array],disabled:Boolean,placeholder:String,mdMenuClass:String},mixins:[l.default],data:function(){return{selectedValue:null,selectedText:null,multipleText:null,multipleOptions:{},options:{},optionsAmount:0}},computed:{classes:function(){return{"md-disabled":this.disabled}},contentClasses:function(){return this.multiple?"md-multiple "+this.mdMenuClass:this.mdMenuClass}},watch:{value:function(t){this.setTextAndValue(t)},disabled:function(){this.setParentDisabled()},required:function(){this.setParentRequired()},placeholder:function(){this.setParentPlaceholder()}},methods:{setParentDisabled:function(){this.parentContainer.isDisabled=this.disabled},setParentRequired:function(){this.parentContainer.isRequired=this.required},setParentPlaceholder:function(){this.parentContainer.hasPlaceholder=!!this.placeholder},getSingleValue:function(t){var e=this,n={};return(0,s.default)(this.options).forEach((function(o){var i=e.options[o];i.value===t&&(n.value=t,n.text=i.$refs.item.textContent)})),n},getMultipleValue:function(t){var e=this;if((0,m.default)(this.value)){var n=(function(){var n=[];return t.forEach((function(t){(0,s.default)(e.options).forEach((function(o){var i=e.options[o];if(i.value===t){var r=i.$refs.item.textContent;e.multipleOptions[o]={value:t,text:r},n.push(r)}}))})),{v:{value:t,text:n.join(", ")}}})();if("object"===("undefined"==typeof n?"undefined":(0,r.default)(n)))return n.v}return{}},setTextAndValue:function(t){var e=this.multiple?this.getMultipleValue(t):this.getSingleValue(t);this.selectedValue=e.value,this.selectedText=e.text,this.selectedText&&this.parentContainer&&this.parentContainer.setValue(this.selectedText)},changeValue:function(t){this.$emit("input",t),this.$emit("change",t),this.$emit("selected",t)},selectMultiple:function(t,e,n){var o=[];this.multipleOptions[t]={value:e,text:n};for(var i in this.multipleOptions)this.multipleOptions.hasOwnProperty(i)&&this.multipleOptions[i].value&&o.push(this.multipleOptions[i].value);this.changeValue(o)},selectOption:function(t,e){this.selectedText=e,this.setTextAndValue(t),this.changeValue(t)}},mounted:function(){this.parentContainer=(0,u.default)(this.$parent,"md-input-container"),this.parentContainer&&(this.setParentDisabled(),this.setParentRequired(),this.setParentPlaceholder(),this.parentContainer.hasSelect=!0),this.setTextAndValue(this.value)},beforeDestroy:function(){this.parentContainer&&(this.parentContainer.setValue(""),this.parentContainer.hasSelect=!1)}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(1),r=o(i);e.default={data:function(){return{mdVisible:!1}},mixins:[r.default],computed:{classes:function(){return this.mdVisible&&"md-active"}},methods:{show:function(){this.open()},open:function(){this.mdVisible=!0,this.$el.focus(),this.$emit("open")},close:function(){this.mdVisible=!1,this.$el.blur(),this.$emit("close")},toggle:function(){this.mdVisible?this.close():this.open()}}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(43),r=o(i),a=n(38),s=o(a),d=n(1),l=o(d),c=n(94),u=o(c);e.default={props:{id:[String,Number],mdPosition:{type:String,default:"bottom center"},mdDuration:{type:[String,Number],default:4e3}},mixins:[l.default],data:function(){return{snackbarId:this.id||"snackbar-"+(0,r.default)(),active:!1,rootElement:{},snackbarElement:{},directionClass:null,closeTimeout:null}},computed:{classes:function(){var t={"md-active":this.active};return this.directionClass=this.mdPosition.replace(/ /g,"-"),t["md-position-"+this.directionClass]=!0,t}},watch:{active:function(t){var e="md-has-toast-"+this.directionClass,n="md-has-toast";t?(document.body.classList.add(e),document.body.classList.add(n)):(document.body.classList.remove(e),document.body.classList.remove(n))}},methods:{removeElement:function(){if(this.rootElement.contains(this.snackbarElement)){var t=this.snackbarElement.querySelector(".md-ripple.md-active");t&&t.classList.remove("md-active"),this.rootElement.removeChild(this.snackbarElement)}},open:function(){u.default.current&&u.default.current.close(),u.default.current=this,this.rootElement.appendChild(this.snackbarElement),window.getComputedStyle(this.$refs.container).backgroundColor,this.active=!0,this.$emit("open"),this.closeTimeout=window.setTimeout(this.close,this.mdDuration)},close:function(){var t=this;this.$refs.container&&!(function(){var e=function e(){t.$refs.container.removeEventListener(s.default,e),t.removeElement()};u.default.current=null,t.active=!1,t.$emit("close"),t.$refs.container.removeEventListener(s.default,e),t.$refs.container.addEventListener(s.default,e),window.clearTimeout(t.closeTimeout)})()}},mounted:function(){var t=this;this.$nextTick((function(){t.rootElement=t.$root.$el,t.snackbarElement=t.$el,t.snackbarElement.parentNode.removeChild(t.snackbarElement)}))},beforeDestroy:function(){window.clearTimeout(this.closeTimeout),this.removeElement()}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(1),r=o(i);e.default={props:{mdSize:{type:Number,default:50},mdStroke:{type:Number,default:3.5},mdIndeterminate:Boolean,mdProgress:{type:Number,default:0}},mixins:[r.default],computed:{classes:function(){return{"md-indeterminate":this.mdIndeterminate}},styles:function(){var t=this.mdSize+"px";return{width:t,height:t}},dashProgress:function(){var t=125*this.mdProgress/100;return!this.mdIndeterminate&&(t>=125&&(t=130),t+", 200")}}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(1),r=o(i);e.default={mixins:[r.default]},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(1),r=o(i),a=75,s="-1px";e.default={props:{name:String,value:Boolean,id:String,disabled:Boolean,type:{type:String,default:"button"}},mixins:[r.default],data:function(){return{leftPos:s,checked:this.value}},computed:{classes:function(){return{"md-checked":Boolean(this.value),"md-disabled":this.disabled}},styles:function(){return{transform:"translate3D("+this.leftPos+", -50%, 0)"}}},watch:{checked:function(){this.setPosition()},value:function(t){this.changeState(t)}},methods:{setPosition:function(){this.leftPos=this.checked?a+"%":s},changeState:function(t,e){this.checked=t,this.$emit("change",this.checked,e),this.$emit("input",this.checked,e)},toggle:function(t){this.disabled||this.changeState(!this.checked,t)}},mounted:function(){this.$nextTick(this.setPosition)}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(1),r=o(i),a=n(13),s=o(a);e.default={props:{mdSortType:String,mdSort:String},mixins:[r.default],data:function(){return{sortType:this.mdSortType,sortBy:this.mdSort,hasRowSelection:!1,data:[],numberOfRows:0,numberOfSelected:0,selectedRows:{}}},methods:{emitSort:function(t){this.sortBy=t,this.$emit("sort",{name:t,type:this.sortType})},emitSelection:function(){this.$emit("select",this.selectedRows)}},mounted:function(){this.parentCard=(0,s.default)(this.$parent,"md-table-card"),this.parentCard&&(this.parentCard.tableInstance=this)}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(1),r=o(i),a=n(13),s=o(a);e.default={props:{mdSelectedLabel:{type:String,default:"selected"}},mixins:[r.default],data:function(){return{classes:{},tableInstance:{}}},mounted:function(){var t=this;this.parentCard=(0,s.default)(this.$parent,"md-table-card"),this.$nextTick((function(){t.tableInstance=t.parentCard.tableInstance,t.$watch("tableInstance.numberOfSelected",(function(){t.$refs.counter.textContent=t.tableInstance.numberOfSelected,t.classes={"md-active":t.tableInstance.numberOfSelected>0}}))}))}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(1),r=o(i);e.default={mixins:[r.default]},t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={props:{mdNumeric:Boolean},data:function(){return{hasAction:!1}},computed:{classes:function(){return{"md-numeric":this.mdNumeric,"md-has-action":this.hasAction}}},mounted:function(){this.$children.length>0&&(this.hasAction=!0)}},t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={props:{value:[String,Number],mdLarge:Boolean,mdId:String,mdName:String,mdPlaceholder:String,mdMaxlength:[Number,String]},data:function(){return{active:!1}},computed:{triggerClasses:function(){return{"md-edited":this.value}},dialogClasses:function(){return{"md-active":this.active,"md-large":this.mdLarge}},realValue:function(){console.log(this.value)}},methods:{openDialog:function(){this.active=!0,this.$refs.input.$el.focus(),document.addEventListener("click",this.closeDialogOnOffClick)},closeDialog:function(){this.active&&(this.active=!1,this.$refs.input.$el.blur(),document.removeEventListener("click",this.closeDialogOnOffClick))},closeDialogOnOffClick:function(t){this.$refs.dialog.contains(t.target)||this.closeDialog()},confirmDialog:function(){var t=this.$refs.input.$el.value;this.closeDialog(),this.$emit("input",t),this.$emit("edited",t)}}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(13),r=o(i);e.default={props:{mdNumeric:Boolean,mdSortBy:String,mdTooltip:String},data:function(){return{sortType:null,sorted:!1,parentTable:{}}},computed:{classes:function(){var t=this.hasMatchSort();return t||(this.sorted=!1),{"md-numeric":this.mdNumeric,"md-sortable":this.mdSortBy,"md-sorted":t&&this.sorted,"md-sorted-descending":t&&"desc"===this.sortType}}},methods:{hasMatchSort:function(){return this.parentTable.sortBy===this.mdSortBy},changeSort:function(){this.mdSortBy&&("asc"===this.sortType&&this.sorted?this.sortType="desc":this.sortType="asc",this.sorted=!0,this.parentTable.sortType=this.sortType,this.parentTable.emitSort(this.mdSortBy))}},mounted:function(){this.parentTable=(0,r.default)(this.$parent,"md-table"),this.hasMatchSort()&&(this.sorted=!0,this.sortType=this.parentTable.sortType)}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(166),r=o(i);e.default={props:{mdSize:{type:[Number,String],default:10},mdPageOptions:[Array,Boolean],mdPage:{type:[Number,String],default:1},mdTotal:{type:[Number,String],default:"Many"},mdLabel:{type:String,default:"Rows per page"},mdSeparator:{type:String,default:"of"}},data:function(){return{subTotal:0,currentSize:parseInt(this.mdSize,10),currentPage:parseInt(this.mdPage,10),totalItems:isNaN(this.mdTotal)?r.default:parseInt(this.mdTotal,10)}},computed:{lastPage:function(){return!1}},methods:{emitPaginationEvent:function(){if(this.canFireEvents){var t=this.currentPage*this.currentSize;this.subTotal=t>this.mdTotal?this.mdTotal:t,this.$emit("pagination",{size:this.currentSize,page:this.currentPage})}},changeSize:function(){this.canFireEvents&&(this.$emit("size",this.currentSize),this.emitPaginationEvent())},previousPage:function(){this.canFireEvents&&(this.currentPage--,this.$emit("page",this.currentPage),this.emitPaginationEvent())},nextPage:function(){this.canFireEvents&&(this.currentPage++,this.$emit("page",this.currentPage),this.emitPaginationEvent())}},mounted:function(){var t=this;this.$nextTick((function(){t.subTotal=t.currentPage*t.currentSize,t.mdPageOptions=t.mdPageOptions||[10,25,50,100],t.currentSize=t.mdPageOptions[0],t.canFireEvents=!0}))}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(13),r=o(i),a="md-transition-off";e.default={props:{mdAutoSelect:Boolean,mdSelection:Boolean,mdItem:Object},data:function(){return{parentTable:{},headRow:!1,checkbox:!1,index:0}},computed:{isDisabled:function(){return!this.mdSelection&&!this.headRow},hasSelection:function(){return this.mdSelection||this.headRow&&this.parentTable.hasRowSelection},classes:function(){return{"md-selected":this.checkbox}}},watch:{mdItem:function(t,e){this.parentTable.data[this.index]=this.mdItem,this.handleMultipleSelection(t===e)}},methods:{setSelectedRow:function(t,e){t?(this.parentTable.selectedRows[e]=this.parentTable.data[e],++this.parentTable.numberOfSelected):(delete this.parentTable.selectedRows[e],--this.parentTable.numberOfSelected)},handleSingleSelection:function(t){this.setSelectedRow(t,this.index-1),this.parentTable.$children[0].checkbox=this.parentTable.numberOfSelected===this.parentTable.numberOfRows},handleMultipleSelection:function(t){var e=this;this.parentTable.numberOfRows>25&&this.parentTable.$el.classList.add(a),this.parentTable.$children.forEach((function(n,o){n.checkbox=t,n.headRow||e.setSelectedRow(t,o-1)})),t?this.parentTable.numberOfSelected=this.parentTable.numberOfRows:this.parentTable.numberOfSelected=0,window.setTimeout((function(){return e.parentTable.$el.classList.remove(a)}))},select:function(t){this.hasSelection&&(this.headRow?this.handleMultipleSelection(t):this.handleSingleSelection(t),this.parentTable.emitSelection())},autoSelect:function(){this.mdAutoSelect&&this.hasSelection&&(this.checkbox=!this.checkbox,this.handleSingleSelection(this.checkbox),this.parentTable.emitSelection())}},mounted:function(){this.parentTable=(0,r.default)(this.$parent,"md-table"),"thead"===this.$el.parentNode.tagName.toLowerCase()?this.headRow=!0:(this.parentTable.numberOfRows++,this.index=this.parentTable.numberOfRows,this.mdSelection&&(this.parentTable.hasRowSelection=!0),this.mdItem&&this.parentTable.data.push(this.mdItem))}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(43),r=o(i),a=n(13),s=o(a);e.default={props:{id:[String,Number],mdLabel:[String,Number],mdIcon:String,mdActive:Boolean,mdDisabled:Boolean,mdTooltip:String,mdTooltipDelay:{type:String,default:"0"},mdTooltipDirection:{type:String,default:"bottom"}},data:function(){return{mounted:!1,tabId:this.id||"tab-"+(0,r.default)(),width:"0px",left:"0px"}},watch:{mdActive:function(){this.updateTabData()},mdDisabled:function(){this.updateTabData()},mdIcon:function(){this.updateTabData()},mdLabel:function(){this.updateTabData()},mdTooltip:function(){this.updateTabData()},mdTooltipDelay:function(){this.updateTabData()},mdTooltipDirection:function(){this.updateTabData()}},computed:{styles:function(){return{width:this.width,left:this.left}}},methods:{getTabData:function(){return{id:this.tabId,label:this.mdLabel,icon:this.mdIcon,active:this.mdActive,disabled:this.mdDisabled,tooltip:this.mdTooltip,tooltipDelay:this.mdTooltipDelay,tooltipDirection:this.mdTooltipDirection,ref:this}},updateTabData:function(){this.parentTabs.updateTab(this.getTabData())}},mounted:function(){var t=this.getTabData();if(this.parentTabs=(0,s.default)(this.$parent,"md-tabs"),!this.parentTabs)throw new Error("You must wrap the md-tab in a md-tabs");this.mounted=!0,this.parentTabs.updateTab(t),this.mdActive&&this.parentTabs.setActiveTab(t)},beforeDestroy:function(){this.parentTabs.unregisterTab(this.getTabData())}},t.exports=e.default}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(44),r=o(i),a=n(1),s=o(a),d=n(109),l=o(d);e.default={props:{mdFixed:Boolean,mdCentered:Boolean,mdRight:Boolean,mdDynamicHeight:{type:Boolean,default:!0},mdElevation:{type:[String,Number],default:0}},mixins:[s.default],data:function(){return{tabList:{},activeTab:null,activeTabNumber:0,hasIcons:!1,hasLabel:!1,transitionControl:null,transitionOff:!1,contentHeight:"0px",contentWidth:"0px"}},computed:{tabClasses:function(){return{"md-dynamic-height":this.mdDynamicHeight,"md-transition-off":this.transitionOff}},navigationClasses:function(){return{"md-has-icon":this.hasIcons,"md-has-label":this.hasLabel,"md-fixed":this.mdFixed,"md-right":!this.mdCentered&&this.mdRight,"md-centered":this.mdCentered||this.mdFixed}},indicatorClasses:function(){var t=this.lastIndicatorNumber>this.activeTabNumber;return this.lastIndicatorNumber=this.activeTabNumber,{"md-transition-off":this.transitionOff,"md-to-right":!t,"md-to-left":t}}},methods:{getHeaderClass:function(t){return{"md-active":this.activeTab===t.id,"md-disabled":t.disabled}},registerTab:function(t){this.tabList[t.id]=t},unregisterTab:function(t){delete this.tabList[t.id]},updateTab:function(t){if(this.registerTab(t),t.active)if(t.disabled){if((0,r.default)(this.tabList).length){var e=(0,r.default)(this.tabList),n=e.indexOf(t.id)+1,o=e[n];o?this.setActiveTab(this.tabList[o]):this.setActiveTab(this.tabList[0])}}else this.setActiveTab(t)},observeElementChanges:function(){this.parentObserver=new MutationObserver((0,l.default)(this.calculateOnWatch,50)),this.parentObserver.observe(this.$refs.tabContent,{childList:!0,attributes:!0,subtree:!0})},getTabIndex:function(t){var e=(0,r.default)(this.tabList);return e.indexOf(t)},calculateIndicatorPos:function(){if(this.$refs.tabHeader&&this.$refs.tabHeader[this.activeTabNumber]){var t=this.$el.offsetWidth,e=this.$refs.tabHeader[this.activeTabNumber],n=e.offsetLeft,o=t-n-e.offsetWidth;this.$refs.indicator.style.left=n+"px",this.$refs.indicator.style.right=o+"px"}},calculateTabsWidthAndPosition:function(){var t=this.$el.offsetWidth,e=0;this.contentWidth=t*this.activeTabNumber+"px";for(var n in this.tabList){var o=this.tabList[n];o.ref.width=t+"px",o.ref.left=t*e+"px",e++}},calculateContentHeight:function(){var t=this;this.$nextTick((function(){if((0,r.default)(t.tabList).length){var e=t.tabList[t.activeTab].ref.$el.offsetHeight;t.contentHeight=e+"px"}}))},calculatePosition:function(){var t=this;window.requestAnimationFrame((function(){t.calculateIndicatorPos(),t.calculateTabsWidthAndPosition(),t.calculateContentHeight()}))},debounceTransition:function(){var t=this;window.clearTimeout(this.transitionControl),this.transitionControl=window.setTimeout((function(){t.calculatePosition(),t.transitionOff=!1}),200)},calculateOnWatch:function(){this.calculatePosition(),this.debounceTransition()},calculateOnResize:function(){this.transitionOff=!0,this.calculateOnWatch()},setActiveTab:function(t){this.hasIcons=!!t.icon,this.hasLabel=!!t.label,this.activeTab=t.id,this.activeTabNumber=this.getTabIndex(this.activeTab),this.calculatePosition(),this.$emit("change",this.activeTabNumber)}},mounted:function(){var t=this;this.$nextTick((function(){if(t.observeElementChanges(),window.addEventListener("resize",t.calculateOnResize),(0,r.default)(t.tabList).length&&!t.activeTab){var e=(0,r.default)(t.tabList)[0];t.setActiveTab(t.tabList[e])}}))},beforeDestroy:function(){this.parentObserver&&this.parentObserver.disconnect(),window.removeEventListener("resize",this.calculateOnResize)}},t.exports=e.default}),110,(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(45),r=o(i),a=n(38),s=o(a);e.default={props:{mdDirection:{type:String,default:"bottom"},mdDelay:{type:String,default:"0"}},data:function(){return{active:!1,parentClass:null,transitionOff:!1,topPosition:!1,leftPosition:!1}},computed:{classes:function(){var t={"md-active":this.active,"md-transition-off":this.transitionOff,"md-tooltip-top":"top"===this.mdDirection,"md-tooltip-right":"right"===this.mdDirection,"md-tooltip-bottom":"bottom"===this.mdDirection,"md-tooltip-left":"left"===this.mdDirection};return this.parentClass&&(t[this.parentClass]=!0),t},style:function(){return{"transition-delay":this.mdDelay+"ms",top:this.topPosition+"px",left:this.leftPosition+"px"}}},watch:{mdDirection:function(){this.calculateTooltipPosition()}},methods:{removeTooltips:function(){this.tooltipElement.parentNode&&(this.tooltipElement.removeEventListener(s.default,this.removeTooltips),this.tooltipElement.parentNode.removeChild(this.tooltipElement))},calculateTooltipPosition:function(){var t=this.parentElement.getBoundingClientRect(),e={};switch(this.mdDirection){case"top":e.top=t.top-this.$el.offsetHeight,e.left=t.left+t.width/2;break;case"right":e.top=t.top,e.left=t.left+t.width;break;case"bottom":e.top=t.bottom,e.left=t.left+t.width/2;break;case"left":e.top=t.top,e.left=t.left-this.$el.offsetWidth;break;default:console.warn("Invalid "+this.mdDirection+" option to md-direction option")}this.topPosition=e.top,this.leftPosition=e.left},generateTooltipClasses:function(){var t=[];[].concat((0,r.default)(this.parentElement.classList)).forEach((function(e){e.indexOf("md-")>=0&&"md-active"!==e&&t.push(e+"-tooltip")})),this.parentClass=t.join(" ")},open:function(){var t=this;this.removeTooltips(),this.$nextTick((function(){t.rootElement.appendChild(t.tooltipElement),getComputedStyle(t.tooltipElement).top,t.transitionOff=!0,t.generateTooltipClasses(),t.calculateTooltipPosition(),window.setTimeout((function(){t.transitionOff=!1,t.active=!0}),10)}))},close:function(){this.active=!1,this.tooltipElement.removeEventListener(s.default,this.removeTooltips),this.tooltipElement.addEventListener(s.default,this.removeTooltips)}},mounted:function(){var t=this;this.$nextTick((function(){t.tooltipElement=t.$el,t.parentElement=t.tooltipElement.parentNode,t.rootElement=t.$root.$el,t.$el.parentNode.removeChild(t.$el),t.parentElement.addEventListener("mouseenter",t.open),t.parentElement.addEventListener("focus",t.open),t.parentElement.addEventListener("mouseleave",t.close),t.parentElement.addEventListener("blur",t.close)}))},beforeDestroy:function(){this.active=!1,this.removeTooltips(),this.parentElement&&(this.parentElement.removeEventListener("mouseenter",this.open),this.parentElement.removeEventListener("focus",this.open),this.parentElement.removeEventListener("mouseleave",this.close),this.parentElement.removeEventListener("blur",this.close))}},t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={props:{mdElevation:{type:[String,Number],default:1},mdTag:{type:String,default:"div"}},computed:{classes:function(){var t=parseInt(this.mdElevation,10),e="md-whiteframe-";return isNaN(t)||"number"!=typeof t?this.mdElevation.indexOf("dp")>-1&&(e+=this.mdElevation):(e+=t,e+="dp"),e}},render:function(t){return t(this.mdTag,{staticClass:"md-whiteframe",class:this.classes},this.$slots.default)}},t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={props:{mdDisabled:Boolean},data:function(){return{mounted:!1,rippleElement:null,parentElement:null,parentDimensions:{width:null,height:null,top:null,left:null},awaitingComplete:!1,hasCompleted:!1,fadeOut:!1,active:!1}},computed:{classes:function(){return{"md-fadeout":this.fadeOut,"md-active":this.active}},styles:function(){return{width:this.parentDimensions.width,height:this.parentDimensions.height,top:this.parentDimensions.top,left:this.parentDimensions.left}},disabled:function(){return this.mdDisabled||!this.$material.inkRipple}},watch:{disabled:function(t){t?this.destroy():this.init();
	}},methods:{checkAvailablePositions:function(t){var e=["relative","absolute","fixed"];return e.indexOf(getComputedStyle(t).position)>-1},getClosestPositionedParent:function(t){var e=t.parentNode;return!(!t||!e||"body"===e.tagName.toLowerCase())&&(this.checkAvailablePositions(t)?t:this.getClosestPositionedParent(t.parentNode))},getParentSize:function(){var t=this.parentElement;return Math.round(Math.max(t.offsetWidth,t.offsetHeight))+"px"},getClickPosition:function(t){var e=this.parentElement.getBoundingClientRect(),n=t.pageY-e.top-this.$refs.ripple.offsetHeight/2-document.body.scrollTop+"px",o=t.pageX-e.left-this.$refs.ripple.offsetWidth/2-document.body.scrollLeft+"px";return{top:n,left:o}},setDimensions:function(){var t=this.getParentSize();this.parentDimensions.width=t,this.parentDimensions.height=t},setPositions:function(t){var e=this.getClickPosition(t);this.parentDimensions.top=e.top,this.parentDimensions.left=e.left},clearState:function(){this.active=!1,this.fadeOut=!1,this.hasCompleted=!1,this.setDimensions(),window.clearTimeout(this.awaitingComplete),document.body.removeEventListener("mouseup",this.endRipple)},startRipple:function(t){var e=this;window.requestAnimationFrame((function(){e.clearState(),e.awaitingComplete=window.setTimeout((function(){e.hasCompleted=!0}),400),document.body.addEventListener("mouseup",e.endRipple),e.setPositions(t),window.setTimeout((function(){e.active=!0}))}))},endRipple:function(){var t=this;this.hasCompleted?this.fadeOut=!0:this.awaitingComplete=window.setTimeout((function(){t.fadeOut=!0}),200),document.body.removeEventListener("mouseup",this.endRipple)},registerMouseEvent:function(){this.parentElement.addEventListener("mousedown",this.startRipple)},unregisterMouseEvent:function(){this.parentElement&&(this.parentElement.removeEventListener("mousedown",this.startRipple),document.body.removeEventListener("mouseup",this.endRipple))},init:function(){this.rippleElement=this.$el,this.parentElement=this.getClosestPositionedParent(this.$el.parentNode),this.parentElement?(this.rippleElement.parentNode.removeChild(this.rippleElement),this.parentElement.appendChild(this.rippleElement),this.registerMouseEvent(),this.setDimensions()):this.$destroy()},destroy:function(){this.rippleElement&&this.rippleElement.parentNode&&(this.unregisterMouseEvent(),this.rippleElement.parentNode.removeChild(this.rippleElement))}},mounted:function(){var t=this;window.setTimeout((function(){t.disabled?t.destroy():t.init(),t.$nextTick((function(){t.mounted=!0}))}),100)},beforeDestroy:function(){this.destroy()}},t.exports=e.default}),(function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={props:{mdTag:String,mdName:{type:String,default:"default"}},data:function(){return{name:"md-theme"}},render:function(t){return this.mdTag||this.$slots.default.length>1?t(this.mdTag||"div",{staticClass:"md-theme"},this.$slots.default):this.$slots.default[0]}},t.exports=e.default}),(function(t,e,n){t.exports={default:n(170),__esModule:!0}}),(function(t,e,n){t.exports={default:n(171),__esModule:!0}}),(function(t,e,n){t.exports={default:n(172),__esModule:!0}}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0;var i=n(168),r=o(i),a=n(167),s=o(a),d="function"==typeof s.default&&"symbol"==typeof r.default?function(t){return typeof t}:function(t){return t&&"function"==typeof s.default&&t.constructor===s.default&&t!==s.default.prototype?"symbol":typeof t};e.default="function"==typeof s.default&&"symbol"===d(r.default)?function(t){return"undefined"==typeof t?"undefined":d(t)}:function(t){return t&&"function"==typeof s.default&&t.constructor===s.default&&t!==s.default.prototype?"symbol":"undefined"==typeof t?"undefined":d(t)}}),(function(t,e,n){n(182),t.exports=9007199254740991}),(function(t,e,n){n(184),n(183),n(185),n(186),t.exports=n(5).Symbol}),(function(t,e,n){n(42),n(187),t.exports=n(62).f("iterator")}),(function(t,e){t.exports=function(){}}),(function(t,e,n){var o=n(21),i=n(70),r=n(59);t.exports=function(t){var e=o(t),n=i.f;if(n)for(var a,s=n(t),d=r.f,l=0;s.length>l;)d.call(t,a=s[l++])&&e.push(a);return e}}),(function(t,e,n){var o=n(25);t.exports=Array.isArray||function(t){return"Array"==o(t)}}),(function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}}),(function(t,e,n){var o=n(21),i=n(12);t.exports=function(t,e){for(var n,r=i(t),a=o(r),s=a.length,d=0;s>d;)if(r[n=a[d++]]===e)return n}}),(function(t,e,n){var o=n(19)("meta"),i=n(9),r=n(7),a=n(6).f,s=0,d=Object.isExtensible||function(){return!0},l=!n(11)((function(){return d(Object.preventExtensions({}))})),c=function(t){a(t,o,{value:{i:"O"+ ++s,w:{}}})},u=function(t,e){if(!i(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!r(t,o)){if(!d(t))return"F";if(!e)return"E";c(t)}return t[o].i},f=function(t,e){if(!r(t,o)){if(!d(t))return!0;if(!e)return!1;c(t)}return t[o].w},m=function(t){return l&&p.NEED&&d(t)&&!r(t,o)&&c(t),t},p=t.exports={KEY:o,NEED:!1,fastKey:u,getWeak:f,onFreeze:m}}),(function(t,e,n){var o=n(59),i=n(14),r=n(12),a=n(28),s=n(7),d=n(29),l=Object.getOwnPropertyDescriptor;e.f=n(4)?l:function(t,e){if(t=r(t),e=a(e,!0),d)try{return l(t,e)}catch(t){}if(s(t,e))return i(!o.f.call(t,e),t[e])}}),(function(t,e,n){var o=n(12),i=n(69).f,r={}.toString,a="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],s=function(t){try{return i(t)}catch(t){return a.slice()}};t.exports.f=function(t){return a&&"[object Window]"==r.call(t)?s(t):i(o(t))}}),(function(t,e,n){"use strict";var o=n(173),i=n(176),r=n(20),a=n(12);t.exports=n(39)(Array,"Array",(function(t,e){this._t=a(t),this._i=0,this._k=e}),(function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,i(1)):"keys"==e?i(0,n):"values"==e?i(0,t[n]):i(0,[n,t[n]])}),"values"),r.Arguments=r.Array,o("keys"),o("values"),o("entries")}),(function(t,e,n){var o=n(17);o(o.S,"Number",{MAX_SAFE_INTEGER:9007199254740991})}),(function(t,e){}),(function(t,e,n){"use strict";var o=n(2),i=n(7),r=n(4),a=n(17),s=n(41),d=n(178).KEY,l=n(11),c=n(24),u=n(31),f=n(19),m=n(3),p=n(62),h=n(61),b=n(177),v=n(174),g=n(175),E=n(10),_=n(12),C=n(28),y=n(14),M=n(40),T=n(180),x=n(179),A=n(6),O=n(21),R=x.f,N=A.f,k=T.f,w=o.Symbol,S=o.JSON,P=S&&S.stringify,L="prototype",H=m("_hidden"),$=m("toPrimitive"),F={}.propertyIsEnumerable,j=c("symbol-registry"),I=c("symbols"),B=c("op-symbols"),D=Object[L],W="function"==typeof w,z=o.QObject,G=!z||!z[L]||!z[L].findChild,Y=r&&l((function(){return 7!=M(N({},"a",{get:function(){return N(this,"a",{value:7}).a}})).a}))?function(t,e,n){var o=R(D,e);o&&delete D[e],N(t,e,n),o&&t!==D&&N(D,e,o)}:N,U=function(t){var e=I[t]=M(w[L]);return e._k=t,e},K=W&&"symbol"==typeof w.iterator?function(t){return"symbol"==typeof t}:function(t){return t instanceof w},V=function(t,e,n){return t===D&&V(B,e,n),E(t),e=C(e,!0),E(n),i(I,e)?(n.enumerable?(i(t,H)&&t[H][e]&&(t[H][e]=!1),n=M(n,{enumerable:y(0,!1)})):(i(t,H)||N(t,H,y(1,{})),t[H][e]=!0),Y(t,e,n)):N(t,e,n)},q=function(t,e){E(t);for(var n,o=v(e=_(e)),i=0,r=o.length;r>i;)V(t,n=o[i++],e[n]);return t},X=function(t,e){return void 0===e?M(t):q(M(t),e)},J=function(t){var e=F.call(this,t=C(t,!0));return!(this===D&&i(I,t)&&!i(B,t))&&(!(e||!i(this,t)||!i(I,t)||i(this,H)&&this[H][t])||e)},Q=function(t,e){if(t=_(t),e=C(e,!0),t!==D||!i(I,e)||i(B,e)){var n=R(t,e);return!n||!i(I,e)||i(t,H)&&t[H][e]||(n.enumerable=!0),n}},Z=function(t){for(var e,n=k(_(t)),o=[],r=0;n.length>r;)i(I,e=n[r++])||e==H||e==d||o.push(e);return o},tt=function(t){for(var e,n=t===D,o=k(n?B:_(t)),r=[],a=0;o.length>a;)!i(I,e=o[a++])||n&&!i(D,e)||r.push(I[e]);return r};W||(w=function(){if(this instanceof w)throw TypeError("Symbol is not a constructor!");var t=f(arguments.length>0?arguments[0]:void 0),e=function(n){this===D&&e.call(B,n),i(this,H)&&i(this[H],t)&&(this[H][t]=!1),Y(this,t,y(1,n))};return r&&G&&Y(D,t,{configurable:!0,set:e}),U(t)},s(w[L],"toString",(function(){return this._k})),x.f=Q,A.f=V,n(69).f=T.f=Z,n(59).f=J,n(70).f=tt,r&&!n(36)&&s(D,"propertyIsEnumerable",J,!0),p.f=function(t){return U(m(t))}),a(a.G+a.W+a.F*!W,{Symbol:w});for(var et="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),nt=0;et.length>nt;)m(et[nt++]);for(var et=O(m.store),nt=0;et.length>nt;)h(et[nt++]);a(a.S+a.F*!W,"Symbol",{for:function(t){return i(j,t+="")?j[t]:j[t]=w(t)},keyFor:function(t){if(K(t))return b(j,t);throw TypeError(t+" is not a symbol!")},useSetter:function(){G=!0},useSimple:function(){G=!1}}),a(a.S+a.F*!W,"Object",{create:X,defineProperty:V,defineProperties:q,getOwnPropertyDescriptor:Q,getOwnPropertyNames:Z,getOwnPropertySymbols:tt}),S&&a(a.S+a.F*(!W||l((function(){var t=w();return"[null]"!=P([t])||"{}"!=P({a:t})||"{}"!=P(Object(t))}))),"JSON",{stringify:function(t){if(void 0!==t&&!K(t)){for(var e,n,o=[t],i=1;arguments.length>i;)o.push(arguments[i++]);return e=o[1],"function"==typeof e&&(n=e),!n&&g(e)||(e=function(t,e){if(n&&(e=n.call(this,t,e)),!K(e))return e}),o[1]=e,P.apply(S,o)}}}),w[L][$]||n(8)(w[L],$,w[L].valueOf),u(w,"Symbol"),u(Math,"Math",!0),u(o.JSON,"JSON",!0)}),(function(t,e,n){n(61)("asyncIterator")}),(function(t,e,n){n(61)("observable")}),(function(t,e,n){n(181);for(var o=n(2),i=n(8),r=n(20),a=n(3)("toStringTag"),s=["NodeList","DOMTokenList","MediaList","StyleSheetList","CSSRuleList"],d=0;d<5;d++){var l=s[d],c=o[l],u=c&&c.prototype;u&&!u[a]&&i(u,a,l),r[l]=r.Array}}),(function(t,e,n){e=t.exports=n(189)(),e.push([t.id,'html{height:100%;box-sizing:border-box}html *,html :after,html :before{box-sizing:inherit}body{min-height:100%;margin:0;position:relative;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;color:rgba(0,0,0,.87);font-family:Roboto,Noto Sans,Noto,sans-serif}[tabindex="-1"]:focus{outline:none}audio,canvas,embed,iframe,img,object,svg,video{max-width:100%;font-style:italic;vertical-align:middle}audio:not(.md-image),canvas:not(.md-image),embed:not(.md-image),iframe:not(.md-image),img:not(.md-image),object:not(.md-image),svg:not(.md-image),video:not(.md-image){height:auto}[tabindex="-1"]:focus{outline:none!important}.md-scrollbar::-webkit-scrollbar,.md-scrollbar ::-webkit-scrollbar{width:10px;height:10px;box-shadow:inset 1px 1px 0 rgba(0,0,0,.12);transition:all .5s cubic-bezier(.35,0,.25,1);background-color:rgba(0,0,0,.05)}.md-scrollbar::-webkit-scrollbar:hover,.md-scrollbar ::-webkit-scrollbar:hover{box-shadow:inset 1px 1px 0 rgba(0,0,0,.054),inset 0 -1px 0 rgba(0,0,0,.038);background-color:rgba(0,0,0,.087)}.md-scrollbar::-webkit-scrollbar-button,.md-scrollbar ::-webkit-scrollbar-button{display:none}.md-scrollbar::-webkit-scrollbar-corner,.md-scrollbar ::-webkit-scrollbar-corner{background-color:transparent}.md-scrollbar::-webkit-scrollbar-thumb,.md-scrollbar ::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.26);box-shadow:inset 1px 1px 0 rgba(0,0,0,.054),inset 0 -1px 0 rgba(0,0,0,.087);transition:all .5s cubic-bezier(.35,0,.25,1)}.md-caption{font-size:12px;font-weight:400;letter-spacing:.02em;line-height:17px}.md-body-1,body{font-weight:400;line-height:20px}.md-body-1,.md-body-2,body{font-size:14px;letter-spacing:.01em}.md-body-2{font-weight:500;line-height:24px}.md-subheading{font-size:16px;font-weight:400;letter-spacing:.01em;line-height:24px}.md-title{font-size:20px;font-weight:500;letter-spacing:.005em;line-height:26px}.md-headline{font-size:24px;line-height:32px}.md-display-1,.md-headline{font-weight:400;letter-spacing:0}.md-display-1{font-size:34px;line-height:40px}.md-display-2{font-size:45px;font-weight:400;letter-spacing:0;line-height:48px}.md-display-3{font-size:56px;font-weight:400;letter-spacing:-.005em;line-height:58px}.md-display-4{font-size:112px;font-weight:300;letter-spacing:-.01em;line-height:112px}a:not(.md-button):not(.md-bottom-bar-item){text-decoration:none}a:not(.md-button):not(.md-bottom-bar-item):hover{text-decoration:underline}button:focus{outline:none}',""])}),(function(t,e){t.exports=function(){var t=[];return t.toString=function(){for(var t=[],e=0;e<this.length;e++){var n=this[e];n[2]?t.push("@media "+n[2]+"{"+n[1]+"}"):t.push(n[1])}return t.join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var o={},i=0;i<this.length;i++){var r=this[i][0];"number"==typeof r&&(o[r]=!0)}for(i=0;i<e.length;i++){var a=e[i];"number"==typeof a[0]&&o[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),t.push(a))}},t}}),(function(t,e){Element.prototype.scrollIntoViewIfNeeded||(Element.prototype.scrollIntoViewIfNeeded=function(t){t=0===arguments.length||!!t;var e=this.parentNode,n=window.getComputedStyle(e,null),o=parseInt(n.getPropertyValue("border-top-width")),i=parseInt(n.getPropertyValue("border-left-width")),r=this.offsetTop-e.offsetTop<e.scrollTop,a=this.offsetTop-e.offsetTop+this.clientHeight-o>e.scrollTop+e.clientHeight,s=this.offsetLeft-e.offsetLeft<e.scrollLeft,d=this.offsetLeft-e.offsetLeft+this.clientWidth-i>e.scrollLeft+e.clientWidth,l=r&&!a;(r||a)&&t&&(e.scrollTop=this.offsetTop-e.offsetTop-e.clientHeight/2-o+this.clientHeight/2),(s||d)&&t&&(e.scrollLeft=this.offsetLeft-e.offsetLeft-e.clientWidth/2-i+this.clientWidth/2),(r||a||s||d)&&!t&&this.scrollIntoView(l)})}),(function(t,e){}),191,191,191,191,191,191,191,191,191,191,191,191,191,191,191,191,191,191,191,191,191,191,191,191,191,191,191,191,191,191,(function(t,e){t.exports=".THEME_NAME.md-avatar.md-primary.md-avatar-icon{background-color:PRIMARY-COLOR}.THEME_NAME.md-avatar.md-primary.md-avatar-icon .md-icon{color:PRIMARY-CONTRAST-0.99999}.THEME_NAME.md-avatar.md-accent.md-avatar-icon{background-color:ACCENT-COLOR}.THEME_NAME.md-avatar.md-accent.md-avatar-icon .md-icon{color:ACCENT-CONTRAST-0.99999}.THEME_NAME.md-avatar.md-warn.md-avatar-icon{background-color:WARN-COLOR}.THEME_NAME.md-avatar.md-warn.md-avatar-icon .md-icon{color:WARN-CONTRAST-0.99999}\n"}),(function(t,e){t.exports=".THEME_NAME.md-bottom-bar.md-fixed{background-color:BACKGROUND-COLOR}.THEME_NAME.md-bottom-bar.md-fixed .md-bottom-bar-item{color:BACKGROUND-CONTRAST-0.54}.THEME_NAME.md-bottom-bar.md-fixed .md-bottom-bar-item:hover:not([disabled]):not(.md-active){color:BACKGROUND-CONTRAST-0.87}.THEME_NAME.md-bottom-bar.md-fixed .md-bottom-bar-item.md-active{color:PRIMARY-COLOR}.THEME_NAME.md-bottom-bar.md-fixed.md-accent .md-bottom-bar-item.md-active{color:ACCENT-COLOR}.THEME_NAME.md-bottom-bar.md-fixed.md-warn .md-bottom-bar-item.md-active{color:WARN-COLOR}.THEME_NAME.md-bottom-bar.md-fixed.md-transparent .md-bottom-bar-item.md-active{color:BACKGROUND-CONTRAST}.THEME_NAME.md-bottom-bar.md-shift{background-color:PRIMARY-COLOR;color:PRIMARY-CONTRAST}.THEME_NAME.md-bottom-bar.md-shift .md-bottom-bar-item{color:PRIMARY-CONTRAST-0.54}.THEME_NAME.md-bottom-bar.md-shift .md-bottom-bar-item:hover:not([disabled]):not(.md-active){color:PRIMARY-CONTRAST-0.87}.THEME_NAME.md-bottom-bar.md-shift .md-bottom-bar-item.md-active{color:PRIMARY-CONTRAST}.THEME_NAME.md-bottom-bar.md-shift.md-accent{background-color:ACCENT-COLOR}.THEME_NAME.md-bottom-bar.md-shift.md-accent .md-bottom-bar-item{color:ACCENT-CONTRAST-0.54}.THEME_NAME.md-bottom-bar.md-shift.md-accent .md-bottom-bar-item:hover:not([disabled]):not(.md-active){color:ACCENT-CONTRAST-0.87}.THEME_NAME.md-bottom-bar.md-shift.md-accent .md-bottom-bar-item.md-active{color:ACCENT-CONTRAST}.THEME_NAME.md-bottom-bar.md-shift.md-warn{background-color:WARN-COLOR}.THEME_NAME.md-bottom-bar.md-shift.md-warn .md-bottom-bar-item{color:WARN-CONTRAST-0.54}.THEME_NAME.md-bottom-bar.md-shift.md-warn .md-bottom-bar-item:hover:not([disabled]):not(.md-active){color:WARN-CONTRAST-0.87}.THEME_NAME.md-bottom-bar.md-shift.md-warn .md-bottom-bar-item.md-active{color:WARN-CONTRAST}.THEME_NAME.md-bottom-bar.md-shift.md-transparent{background-color:transparent}.THEME_NAME.md-bottom-bar.md-shift.md-transparent .md-bottom-bar-item{color:BACKGROUND-CONTRAST-0.54}.THEME_NAME.md-bottom-bar.md-shift.md-transparent .md-bottom-bar-item:hover:not([disabled]):not(.md-active){color:BACKGROUND-CONTRAST-0.87}.THEME_NAME.md-bottom-bar.md-shift.md-transparent .md-bottom-bar-item.md-active{color:BACKGROUND-CONTRAST}\n"}),(function(t,e){t.exports=".THEME_NAME.md-button:not([disabled]).md-raised:not(.md-icon-button){color:BACKGROUND-CONTRAST;background-color:BACKGROUND-COLOR}.THEME_NAME.md-button:not([disabled]).md-raised:not(.md-icon-button):hover{background-color:BACKGROUND-COLOR-200}.THEME_NAME.md-button:not([disabled]).md-raised.md-icon-button:not(.md-raised){color:BACKGROUND-CONTRAST}.THEME_NAME.md-button:not([disabled]).md-fab{color:ACCENT-CONTRAST;background-color:ACCENT-COLOR}.THEME_NAME.md-button:not([disabled]).md-fab:hover{background-color:ACCENT-COLOR-600}.THEME_NAME.md-button:not([disabled]).md-fab.md-clean{color:BACKGROUND-CONTRAST;background-color:BACKGROUND-COLOR}.THEME_NAME.md-button:not([disabled]).md-fab.md-clean:hover{background-color:BACKGROUND-COLOR-200}.THEME_NAME.md-button:not([disabled]).md-primary:not(.md-icon-button){color:PRIMARY-COLOR}.THEME_NAME.md-button:not([disabled]).md-primary.md-raised,.THEME_NAME.md-button:not([disabled]).md-primary.md-fab{background-color:PRIMARY-COLOR;color:PRIMARY-CONTRAST}.THEME_NAME.md-button:not([disabled]).md-primary.md-raised:hover,.THEME_NAME.md-button:not([disabled]).md-primary.md-fab:hover{background-color:PRIMARY-COLOR-600}.THEME_NAME.md-button:not([disabled]).md-primary.md-icon-button:not(.md-raised){color:PRIMARY-COLOR}.THEME_NAME.md-button:not([disabled]).md-accent:not(.md-icon-button){color:ACCENT-COLOR}.THEME_NAME.md-button:not([disabled]).md-accent.md-raised{background-color:ACCENT-COLOR;color:ACCENT-CONTRAST}.THEME_NAME.md-button:not([disabled]).md-accent.md-raised:hover{background-color:ACCENT-COLOR-600}.THEME_NAME.md-button:not([disabled]).md-accent.md-icon-button:not(.md-raised){color:ACCENT-COLOR}.THEME_NAME.md-button:not([disabled]).md-warn:not(.md-icon-button){color:WARN-COLOR}.THEME_NAME.md-button:not([disabled]).md-warn.md-raised,.THEME_NAME.md-button:not([disabled]).md-warn.md-fab{background-color:WARN-COLOR;color:WARN-CONTRAST}.THEME_NAME.md-button:not([disabled]).md-warn.md-raised:hover,.THEME_NAME.md-button:not([disabled]).md-warn.md-fab:hover{background-color:WARN-COLOR-600}.THEME_NAME.md-button:not([disabled]).md-warn.md-icon-button:not(.md-raised){color:WARN-COLOR}\n"}),(function(t,e){t.exports='.THEME_NAME.md-button-toggle .md-button:after{width:1px;position:absolute;top:0;bottom:0;left:0;content:" "}.THEME_NAME.md-button-toggle .md-toggle{color:BACKGROUND-CONTRAST-0.54;background-color:BACKGROUND-CONTRAST-0.26}.THEME_NAME.md-button-toggle .md-toggle:hover:not([disabled]){background-color:BACKGROUND-CONTRAST-0.38}.THEME_NAME.md-button-toggle .md-toggle+.md-toggle:after{background-color:BACKGROUND-CONTRAST-0.12}.THEME_NAME.md-button-toggle.md-primary .md-toggle{color:PRIMARY-CONTRAST;background-color:PRIMARY-COLOR}.THEME_NAME.md-button-toggle.md-primary .md-toggle:hover:not([disabled]){background-color:PRIMARY-COLOR}.THEME_NAME.md-button-toggle.md-primary .md-toggle+.md-toggle:after{background-color:PRIMARY-COLOR-600}.THEME_NAME.md-button-toggle.md-accent .md-toggle{color:ACCENT-CONTRAST;background-color:ACCENT-COLOR}.THEME_NAME.md-button-toggle.md-accent .md-toggle:hover:not([disabled]){background-color:ACCENT-COLOR}.THEME_NAME.md-button-toggle.md-accent .md-toggle+.md-toggle:after{background-color:ACCENT-COLOR-600}.THEME_NAME.md-button-toggle.md-warn .md-toggle{color:WARN-CONTRAST;background-color:WARN-COLOR}.THEME_NAME.md-button-toggle.md-warn .md-toggle:hover:not([disabled]){background-color:WARN-COLOR}.THEME_NAME.md-button-toggle.md-warn .md-toggle+.md-toggle:after{background-color:WARN-COLOR-600}.THEME_NAME.md-button-toggle [disabled]{color:rgba(0,0,0,0.26)}.THEME_NAME.md-button-toggle [disabled].md-toggle{color:BACKGROUND-CONTRAST-0.2;background-color:rgba(0,0,0,0.26)}\n'}),(function(t,e){t.exports=".THEME_NAME.md-card{background-color:BACKGROUND-COLOR}.THEME_NAME.md-card.md-primary{background-color:PRIMARY-COLOR;color:PRIMARY-CONTRAST}.THEME_NAME.md-card.md-primary .md-card-header .md-icon-button .md-icon,.THEME_NAME.md-card.md-primary .md-card-actions .md-icon-button .md-icon{color:PRIMARY-CONTRAST-0.87}.THEME_NAME.md-card.md-accent{background-color:ACCENT-COLOR;color:ACCENT-CONTRAST}.THEME_NAME.md-card.md-accent .md-card-header .md-icon-button .md-icon,.THEME_NAME.md-card.md-accent .md-card-actions .md-icon-button .md-icon{color:ACCENT-CONTRAST-0.87}.THEME_NAME.md-card.md-warn{background-color:WARN-COLOR;color:WARN-CONTRAST}.THEME_NAME.md-card.md-warn .md-card-header .md-icon-button .md-icon,.THEME_NAME.md-card.md-warn .md-card-actions .md-icon-button .md-icon{color:WARN-CONTRAST-0.87}.THEME_NAME.md-card .md-card-header .md-icon-button:not(.md-primary):not(.md-warn):not(.md-accent) .md-icon,.THEME_NAME.md-card .md-card-actions .md-icon-button:not(.md-primary):not(.md-warn):not(.md-accent) .md-icon{color:BACKGROUND-CONTRAST-0.54}.THEME_NAME.md-card>.md-card-area:after{background-color:BACKGROUND-CONTRAST-0.12}.THEME_NAME.md-card .md-card-media-cover.md-text-scrim .md-backdrop{background:linear-gradient(to bottom, BACKGROUND-CONTRAST-0.0 20%, BACKGROUND-CONTRAST-0.275 66%, BACKGROUND-CONTRAST-0.55 100%)}.THEME_NAME.md-card .md-card-media-cover.md-solid .md-card-area{background-color:BACKGROUND-CONTRAST-0.4}.THEME_NAME.md-card .md-card-expand .md-card-actions{background-color:BACKGROUND-COLOR}\n"}),(function(t,e){t.exports=".THEME_NAME.md-checkbox.md-checked .md-checkbox-container{background-color:ACCENT-COLOR;border-color:ACCENT-COLOR}.THEME_NAME.md-checkbox.md-checked .md-checkbox-container:after{border-color:ACCENT-CONTRAST}.THEME_NAME.md-checkbox .md-ink-ripple{color:ACCENT-COLOR}.THEME_NAME.md-checkbox .md-ripple{opacity:.26}.THEME_NAME.md-checkbox.md-primary.md-checked .md-checkbox-container{background-color:PRIMARY-COLOR;border-color:PRIMARY-COLOR}.THEME_NAME.md-checkbox.md-primary.md-checked .md-checkbox-container:after{border-color:PRIMARY-CONTRAST}.THEME_NAME.md-checkbox.md-primary .md-ink-ripple{color:PRIMARY-COLOR}.THEME_NAME.md-checkbox.md-warn.md-checked .md-checkbox-container{background-color:WARN-COLOR;border-color:WARN-COLOR}.THEME_NAME.md-checkbox.md-warn.md-checked .md-checkbox-container:after{border-color:WARN-CONTRAST}.THEME_NAME.md-checkbox.md-warn .md-ink-ripple{color:WARN-COLOR}.THEME_NAME.md-checkbox.md-disabled.md-checked .md-checkbox-container{background-color:rgba(0,0,0,0.26);border-color:transparent}.THEME_NAME.md-checkbox.md-disabled:not(.md-checked) .md-checkbox-container{border-color:rgba(0,0,0,0.26)}\n"}),(function(t,e){t.exports=".THEME_NAME.md-chip{background-color:BACKGROUND-CONTRAST-0.12}.THEME_NAME.md-chip.md-deletable:hover,.THEME_NAME.md-chip.md-deletable:focus{background-color:BACKGROUND-CONTRAST-0.54;color:BACKGROUND-COLOR}.THEME_NAME.md-chip.md-deletable:hover .md-delete,.THEME_NAME.md-chip.md-deletable:focus .md-delete{color:BACKGROUND-COLOR}.THEME_NAME.md-chip .md-delete{color:BACKGROUND-CONTRAST-0.38}.THEME_NAME.md-chip .md-delete .md-ripple{color:BACKGROUND-COLOR}\n"}),(function(t,e){t.exports=".THEME_NAME.md-dialog-container .md-dialog{background-color:BACKGROUND-COLOR;color:BACKGROUND-CONTRAST}\n"}),(function(t,e){t.exports=""}),(function(t,e){t.exports=".THEME_NAME.md-icon.md-primary{color:PRIMARY-COLOR}.THEME_NAME.md-icon.md-accent{color:ACCENT-COLOR}.THEME_NAME.md-icon.md-warn{color:WARN-COLOR}\n"}),230,(function(t,e){t.exports=".THEME_NAME.md-input-container.md-input-invalid:after{background-color:WARN-COLOR}.THEME_NAME.md-input-container.md-input-invalid label,.THEME_NAME.md-input-container.md-input-invalid input,.THEME_NAME.md-input-container.md-input-invalid textarea,.THEME_NAME.md-input-container.md-input-invalid .md-error,.THEME_NAME.md-input-container.md-input-invalid .md-count,.THEME_NAME.md-input-container.md-input-invalid .md-icon:not(.md-icon-delete){color:WARN-COLOR}.THEME_NAME.md-input-container.md-input-focused.md-input-inline label{color:rgba(0,0,0,0.54)}.THEME_NAME.md-input-container.md-input-focused.md-input-required label:after{color:WARN-COLOR}.THEME_NAME.md-input-container.md-input-focused:after{height:2px;background-color:PRIMARY-COLOR}.THEME_NAME.md-input-container.md-input-focused input,.THEME_NAME.md-input-container.md-input-focused textarea{color:PRIMARY-COLOR;text-shadow:0 0 0 BACKGROUND-CONTRAST;-webkit-text-fill-color:transparent}.THEME_NAME.md-input-container.md-input-focused label,.THEME_NAME.md-input-container.md-input-focused .md-icon:not(.md-icon-delete){color:PRIMARY-COLOR}.THEME_NAME.md-input-container.md-input-disabled label,.THEME_NAME.md-input-container.md-input-disabled input,.THEME_NAME.md-input-container.md-input-disabled textarea,.THEME_NAME.md-input-container.md-input-disabled .md-error,.THEME_NAME.md-input-container.md-input-disabled .md-count,.THEME_NAME.md-input-container.md-input-disabled .md-icon:not(.md-icon-delete),.THEME_NAME.md-input-container.md-input-disabled ::-webkit-input-placeholder{color:BACKGROUND-CONTRAST-0.38}.THEME_NAME.md-input-container .md-icon:not(.md-icon-delete):after{background:BACKGROUND-COLOR}\n"}),(function(t,e){t.exports=".THEME_NAME.md-list{background-color:BACKGROUND-COLOR;color:BACKGROUND-CONTRAST}.THEME_NAME.md-list.md-transparent{background-color:transparent;color:inherit}.THEME_NAME.md-list .md-list-item .router-link-active.md-list-item-container{color:PRIMARY-COLOR}.THEME_NAME.md-list .md-list-item .router-link-active.md-list-item-container>.md-icon{color:PRIMARY-COLOR}.THEME_NAME.md-list .md-list-item.md-primary .md-list-item-container{color:PRIMARY-COLOR}.THEME_NAME.md-list .md-list-item.md-primary .md-list-item-container>.md-icon{color:PRIMARY-COLOR}.THEME_NAME.md-list .md-list-item.md-accent .md-list-item-container{color:ACCENT-COLOR}.THEME_NAME.md-list .md-list-item.md-accent .md-list-item-container>.md-icon{color:ACCENT-COLOR}.THEME_NAME.md-list .md-list-item.md-warn .md-list-item-container{color:WARN-COLOR}.THEME_NAME.md-list .md-list-item.md-warn .md-list-item-container>.md-icon{color:WARN-COLOR}.THEME_NAME.md-list .md-list-item-expand .md-list-item-container{background-color:BACKGROUND-COLOR}.THEME_NAME.md-list .md-list-item-expand .md-list-item-container:hover,.THEME_NAME.md-list .md-list-item-expand .md-list-item-container:focus{background-color:rgba(153,153,153,0.2)}\n"}),(function(t,e){t.exports=".THEME_NAME.md-menu-content .md-list{background-color:BACKGROUND-COLOR;color:BACKGROUND-CONTRAST}.THEME_NAME.md-menu-content .md-list .md-menu-item:hover .md-button:not([disabled]),.THEME_NAME.md-menu-content .md-list .md-menu-item:focus .md-button:not([disabled]),.THEME_NAME.md-menu-content .md-list .md-menu-item.md-highlighted .md-button:not([disabled]){background-color:BACKGROUND-CONTRAST-0.12}.THEME_NAME.md-menu-content .md-list .md-menu-item[disabled]{color:BACKGROUND-CONTRAST-0.38}\n"}),(function(t,e){t.exports=".THEME_NAME.md-progress{background-color:PRIMARY-COLOR-0.38}.THEME_NAME.md-progress:not(.md-indeterminate) .md-progress-track{background-color:PRIMARY-COLOR}.THEME_NAME.md-progress .md-progress-track:after,.THEME_NAME.md-progress .md-progress-track:before{background-color:PRIMARY-COLOR}.THEME_NAME.md-progress.md-accent{background-color:ACCENT-COLOR-0.38}.THEME_NAME.md-progress.md-accent:not(.md-indeterminate) .md-progress-track{background-color:ACCENT-COLOR}.THEME_NAME.md-progress.md-accent .md-progress-track:after,.THEME_NAME.md-progress.md-accent .md-progress-track:before{background-color:ACCENT-COLOR}.THEME_NAME.md-progress.md-warn{background-color:WARN-COLOR-0.38}.THEME_NAME.md-progress.md-warn:not(.md-indeterminate) .md-progress-track{background-color:WARN-COLOR}.THEME_NAME.md-progress.md-warn .md-progress-track:after,.THEME_NAME.md-progress.md-warn .md-progress-track:before{background-color:WARN-COLOR}\n"}),(function(t,e){t.exports=".THEME_NAME.md-radio .md-radio-container:after{background-color:ACCENT-COLOR}.THEME_NAME.md-radio.md-checked .md-radio-container{border-color:ACCENT-COLOR}.THEME_NAME.md-radio.md-checked .md-ink-ripple{color:ACCENT-COLOR}.THEME_NAME.md-radio.md-checked .md-ripple{opacity:.38}.THEME_NAME.md-radio.md-primary .md-radio-container:after{background-color:PRIMARY-COLOR}.THEME_NAME.md-radio.md-primary.md-checked .md-radio-container{border-color:PRIMARY-COLOR}.THEME_NAME.md-radio.md-primary.md-checked .md-ink-ripple{color:PRIMARY-COLOR}.THEME_NAME.md-radio.md-warn .md-radio-container:after{background-color:WARN-COLOR}.THEME_NAME.md-radio.md-warn.md-checked .md-radio-container{border-color:WARN-COLOR}.THEME_NAME.md-radio.md-warn.md-checked .md-ink-ripple{color:WARN-COLOR}.THEME_NAME.md-radio.md-disabled .md-radio-container{border-color:rgba(0,0,0,0.26)}.THEME_NAME.md-radio.md-disabled .md-radio-container:after{background-color:rgba(0,0,0,0.26)}.THEME_NAME.md-radio.md-disabled.md-checked .md-radio-container{border-color:rgba(0,0,0,0.26)}\n"}),(function(t,e){t.exports=".THEME_NAME.md-select:after{color:BACKGROUND-CONTRAST-0.54}.THEME_NAME.md-select:after{color:BACKGROUND-CONTRAST-0.38}.THEME_NAME.md-select-content .md-menu-item.md-selected,.THEME_NAME.md-select-content .md-menu-item.md-checked{color:PRIMARY-COLOR}\n"}),(function(t,e){t.exports=".THEME_NAME.md-sidenav .md-sidenav-content{background-color:BACKGROUND-COLOR;color:BACKGROUND-CONTRAST}\n"}),(function(t,e){t.exports=".THEME_NAME .md-snackbar .md-ink-ripple,.THEME_NAME.md-snackbar .md-ink-ripple{color:#fff}\n"}),(function(t,e){t.exports=".THEME_NAME.md-spinner .md-spinner-path{stroke:PRIMARY-COLOR}.THEME_NAME.md-spinner.md-accent .md-spinner-path{stroke:ACCENT-COLOR}.THEME_NAME.md-spinner.md-warn .md-spinner-path{stroke:WARN-COLOR}\n"}),(function(t,e){t.exports=".THEME_NAME.md-subheader.md-primary{color:PRIMARY-COLOR}.THEME_NAME.md-subheader.md-accent{color:ACCENT-COLOR}.THEME_NAME.md-subheader.md-warn{color:WARN-COLOR}\n"}),(function(t,e){t.exports=".THEME_NAME.md-switch.md-checked .md-switch-container{background-color:ACCENT-COLOR-500-0.5}.THEME_NAME.md-switch.md-checked .md-switch-thumb{background-color:ACCENT-COLOR}.THEME_NAME.md-switch.md-checked .md-ink-ripple{color:ACCENT-COLOR}.THEME_NAME.md-switch.md-checked .md-ripple{opacity:.38}.THEME_NAME.md-switch.md-checked.md-primary .md-switch-container{background-color:PRIMARY-COLOR-500-0.5}.THEME_NAME.md-switch.md-checked.md-primary .md-switch-thumb{background-color:PRIMARY-COLOR}.THEME_NAME.md-switch.md-checked.md-primary .md-ink-ripple{color:PRIMARY-COLOR}.THEME_NAME.md-switch.md-checked.md-warn .md-switch-container{background-color:WARN-COLOR-500-0.5}.THEME_NAME.md-switch.md-checked.md-warn .md-switch-thumb{background-color:WARN-COLOR}.THEME_NAME.md-switch.md-checked.md-warn .md-ink-ripple{color:WARN-COLOR}.THEME_NAME.md-switch.md-disabled .md-switch-container,.THEME_NAME.md-switch.md-disabled.md-checked .md-switch-container{background-color:rgba(0,0,0,0.12)}.THEME_NAME.md-switch.md-disabled .md-switch-thumb,.THEME_NAME.md-switch.md-disabled.md-checked .md-switch-thumb{background-color:#bdbdbd}\n"}),(function(t,e){t.exports=".THEME_NAME.md-table-card .md-toolbar{background-color:BACKGROUND-COLOR;color:BACKGROUND-CONTRAST}.THEME_NAME.md-table-alternate-header{background-color:BACKGROUND-COLOR}.THEME_NAME.md-table-alternate-header .md-toolbar{background-color:ACCENT-COLOR-A100-0.2;color:ACCENT-CONTRAST-A100}.THEME_NAME.md-table-alternate-header .md-counter{color:ACCENT-COLOR}\n"}),(function(t,e){t.exports=".THEME_NAME.md-tabs>.md-tabs-navigation{background-color:PRIMARY-COLOR}.THEME_NAME.md-tabs>.md-tabs-navigation .md-tab-header{color:PRIMARY-CONTRAST-0.54}.THEME_NAME.md-tabs>.md-tabs-navigation .md-tab-header.md-active,.THEME_NAME.md-tabs>.md-tabs-navigation .md-tab-header:focus{color:PRIMARY-CONTRAST}.THEME_NAME.md-tabs>.md-tabs-navigation .md-tab-header.md-disabled{color:PRIMARY-CONTRAST-0.26}.THEME_NAME.md-tabs>.md-tabs-navigation .md-tab-indicator{background-color:ACCENT-COLOR}.THEME_NAME.md-tabs.md-transparent>.md-tabs-navigation{background-color:transparent;border-bottom:1px solid BACKGROUND-CONTRAST-0.12}.THEME_NAME.md-tabs.md-transparent>.md-tabs-navigation .md-tab-header{color:BACKGROUND-CONTRAST-0.54}.THEME_NAME.md-tabs.md-transparent>.md-tabs-navigation .md-tab-header.md-active,.THEME_NAME.md-tabs.md-transparent>.md-tabs-navigation .md-tab-header:focus{color:PRIMARY-COLOR}.THEME_NAME.md-tabs.md-transparent>.md-tabs-navigation .md-tab-header.md-disabled{color:BACKGROUND-CONTRAST-0.26}.THEME_NAME.md-tabs.md-transparent>.md-tabs-navigation .md-tab-indicator{background-color:PRIMARY-COLOR}.THEME_NAME.md-tabs.md-accent>.md-tabs-navigation{background-color:ACCENT-COLOR}.THEME_NAME.md-tabs.md-accent>.md-tabs-navigation .md-tab-header{color:ACCENT-CONTRAST-0.54}.THEME_NAME.md-tabs.md-accent>.md-tabs-navigation .md-tab-header.md-active,.THEME_NAME.md-tabs.md-accent>.md-tabs-navigation .md-tab-header:focus{color:ACCENT-CONTRAST}.THEME_NAME.md-tabs.md-accent>.md-tabs-navigation .md-tab-header.md-disabled{color:ACCENT-CONTRAST-0.26}.THEME_NAME.md-tabs.md-accent>.md-tabs-navigation .md-tab-indicator{background-color:BACKGROUND-COLOR}.THEME_NAME.md-tabs.md-warn>.md-tabs-navigation{background-color:WARN-COLOR}.THEME_NAME.md-tabs.md-warn>.md-tabs-navigation .md-tab-header{color:WARN-CONTRAST-0.54}.THEME_NAME.md-tabs.md-warn>.md-tabs-navigation .md-tab-header.md-active,.THEME_NAME.md-tabs.md-warn>.md-tabs-navigation .md-tab-header:focus{color:WARN-CONTRAST}.THEME_NAME.md-tabs.md-warn>.md-tabs-navigation .md-tab-header.md-disabled{color:WARN-CONTRAST-0.26}.THEME_NAME.md-tabs.md-warn>.md-tabs-navigation .md-tab-indicator{background-color:BACKGROUND-COLOR}\n";
	}),(function(t,e){t.exports=".THEME_NAME.md-toolbar{background-color:PRIMARY-COLOR;color:PRIMARY-CONTRAST}.THEME_NAME.md-toolbar.md-accent{background-color:ACCENT-COLOR;color:ACCENT-CONTRAST}.THEME_NAME.md-toolbar.md-warn{background-color:WARN-COLOR;color:WARN-CONTRAST}.THEME_NAME.md-toolbar.md-transparent{background-color:transparent;color:BACKGROUND-CONTRAST}\n"}),(function(t,e){t.exports=".THEME_NAME :not(input):not(textarea)::selection{background:ACCENT-COLOR;color:ACCENT-CONTRAST}.THEME_NAME a:not(.md-button){color:ACCENT-COLOR}.THEME_NAME a:not(.md-button):hover{color:ACCENT-COLOR-800}body.THEME_NAME{background-color:BACKGROUND-COLOR;color:BACKGROUND-CONTRAST-0.87}.THEME_NAME .md-caption,.THEME_NAME .md-display-1,.THEME_NAME .md-display-2,.THEME_NAME .md-display-3,.THEME_NAME .md-display-4{color:BACKGROUND-CONTRAST-0.57}.THEME_NAME code:not(.hljs){background-color:ACCENT-COLOR-A100-0.2;color:ACCENT-COLOR-800}\n"}),(function(t,e,n){var o,i;n(195),o=n(110);var r=n(322);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(219),o=n(111);var r=n(367);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(193),o=n(112);var r=n(315);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(113);var r=n(321);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(212),o=n(114);var r=n(357);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(194),o=n(115);var r=n(317);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(207),o=n(116);var r=n(340);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i,r=n(350);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(117);var r=n(332);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i,r=n(314);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(118);var r=n(365);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i,r=n(328);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(119);var r=n(333);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(120);var r=n(345);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i,r=n(356);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(121);var r=n(320);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(214),o=n(122);var r=n(359);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(123);var r=n(326);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(202),o=n(124);var r=n(334);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(209),o=n(125);var r=n(351);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i,r=n(348);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i,r=n(318);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i,r=n(313);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(126);var r=n(369);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(127);var r=n(349);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(128);var r=n(316);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(200);var r=n(330);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(213),o=n(129);var r=n(358);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(221),o=n(130);var r=n(371);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(199),o=n(131);var r=n(329);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(132);var r=n(342);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(206),o=n(133);var r=n(339);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(134);var r=n(346);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(197),o=n(135),i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),t.exports=o}),(function(t,e,n){var o,i;n(204),o=n(136);var r=n(336);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(137);var r=n(319);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(138),i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),t.exports=o}),(function(t,e,n){var o,i;n(191),o=n(139);var r=n(312);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(140);var r=n(341);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(141);var r=n(344);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(198),o=n(142);var r=n(327);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(220),o=n(143);var r=n(370);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(144);var r=n(361);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(196),o=n(145);var r=n(323);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(205),o=n(146);var r=n(337);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(216),o=n(147);var r=n(362);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(211),o=n(148);var r=n(353);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(215),o=n(149);var r=n(360);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(210),o=n(150);var r=n(352);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(218),o=n(151);var r=n(366);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(152);var r=n(324);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(153);var r=n(368);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(154);var r=n(343);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(155);var r=n(325);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(156);var r=n(338);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(157);var r=n(354);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(158);var r=n(364);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(159);var r=n(355);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(217),o=n(160);var r=n(363);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(208),o=n(161);var r=n(347);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(201),o=n(162);var r=n(331);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;n(192),o=n(163),i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),t.exports=o}),(function(t,e,n){var o,i;n(203),o=n(164);var r=n(335);i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),i.render=r.render,i.staticRenderFns=r.staticRenderFns,t.exports=o}),(function(t,e,n){var o,i;o=n(165),i=o=o||{},"object"!=typeof o.default&&"function"!=typeof o.default||(i=o=o.default),"function"==typeof i&&(i=i.options),t.exports=o}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-menu"},[t._t("default"),t._v(" "),n("md-backdrop",{ref:"backdrop",staticClass:"md-menu-backdrop md-transparent md-active",on:{close:t.close}})],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-dialog-title md-title"},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-card-content"},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-bottom-bar",class:[t.themeClass,t.classes]},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("md-dialog",{ref:"dialog",staticClass:"md-dialog-prompt",on:{close:function(e){t.fireCloseEvent("cancel")}}},[t.mdTitle?n("md-dialog-title",[t._v(t._s(t.mdTitle))]):t._e(),t._v(" "),t.mdContentHtml?n("md-dialog-content",{domProps:{innerHTML:t._s(t.mdContentHtml)}}):t._e(),t._v(" "),t.mdContent?n("md-dialog-content",[t._v(t._s(t.mdContent))]):t._e(),t._v(" "),n("md-dialog-content",[n("md-input-container",[n("md-input",{ref:"input",attrs:{id:t.mdInputId,name:t.mdInputName,maxlength:t.mdInputMaxlength,placeholder:t.mdInputPlaceholder,value:t.value},nativeOn:{keydown:function(e){t._k(e.keyCode,"enter",13)||t.confirmValue(e)}}})],1)],1),t._v(" "),n("md-dialog-actions",[n("md-button",{staticClass:"md-primary",on:{click:function(e){t.close("cancel")}}},[t._v(t._s(t.mdCancelText))]),t._v(" "),n("md-button",{staticClass:"md-primary",on:{click:t.confirmValue}},[t._v(t._s(t.mdOkText))])],1)],1)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-button-toggle",class:[t.themeClass]},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-dialog-content"},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{ref:"expand",staticClass:"md-list-expand",class:t.classes,style:t.styles},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-card-media-cover",class:t.classes},[t._t("default"),t._v(" "),t.mdTextScrim?n("div",{ref:"backdrop",staticClass:"md-card-backdrop",style:t.styles}):t._e()],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return t.href?n("a",{staticClass:"md-bottom-bar-item",class:t.classes,attrs:{href:t.href,disabled:t.disabled},on:{click:t.setActive}},[n("md-icon",[t._v(t._s(t.mdIcon))]),t._v(" "),n("md-ink-ripple",{attrs:{"md-disabled":t.disabled}}),t._v(" "),n("span",{staticClass:"md-text"},[t._t("default")],2)],1):n("button",{staticClass:"md-bottom-bar-item",class:t.classes,attrs:{type:"button",disabled:t.disabled},on:{click:t.setActive}},[n("md-icon",[t._v(t._s(t.mdIcon))]),t._v(" "),n("md-ink-ripple",{attrs:{"md-disabled":t.disabled}}),t._v(" "),n("span",{staticClass:"md-text"},[t._t("default")],2)],1)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-avatar",class:[t.themeClass]},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-select",class:[t.themeClass,t.classes]},[n("md-menu",{attrs:{"md-close-on-select":!t.multiple}},[n("span",{ref:"value",staticClass:"md-select-value",attrs:{"md-menu-trigger":""}},[t._v(t._s(t.selectedText||t.multipleText||t.placeholder))]),t._v(" "),n("md-menu-content",{staticClass:"md-select-content",class:[t.themeClass,t.contentClasses]},[t._t("default")],2)],1),t._v(" "),n("select",{attrs:{name:t.name,id:t.id,required:t.required,disabled:t.disabled,tabindex:"-1"}},[n("option",{domProps:{value:t.value}},[t._v(t._s(t.value))])])],1)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-table-alternate-header",class:[t.themeClass,t.classes]},[n("md-toolbar",[n("div",{staticClass:"md-counter"},[n("span",{ref:"counter"},[t._v(t._s(t.tableInstance.numberOfSelected))]),t._v(" "),n("span",[t._v(t._s(t.mdSelectedLabel))])]),t._v(" "),t._t("default")],2)],1)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-table-edit",on:{keydown:function(e){t._k(e.keyCode,"esc",27)||t.closeDialog(e)}}},[n("div",{staticClass:"md-table-edit-trigger",class:t.triggerClasses,on:{click:function(e){e.stopPropagation(),t.openDialog(e)}}},[t._v("\n    "+t._s(t.value||t.mdPlaceholder)+"\n  ")]),t._v(" "),n("div",{ref:"dialog",staticClass:"md-table-dialog",class:t.dialogClasses},[n("md-input-container",[n("md-input",{ref:"input",attrs:{id:t.mdId,name:t.mdName,maxlength:t.mdMaxlength,value:t.value,placeholder:t.mdPlaceholder},nativeOn:{keydown:function(e){t._k(e.keyCode,"enter",13)||t.confirmDialog(e)}}})],1)],1)])},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-chip",class:[t.themeClass,t.classes],attrs:{tabindex:"0"}},[t._t("default"),t._v(" "),t.mdDeletable?n("md-button",{staticClass:"md-icon-button md-dense md-delete",attrs:{tabindex:"-1"},nativeOn:{click:function(e){!t.disabled&&t.$emit("delete")},keyup:function(e){t._k(e.keyCode,"delete",[8,46])||!t.disabled&&t.$emit("delete")}}},[n("md-icon",{staticClass:"md-icon-delete"},[t._v("cancel")])],1):t._e()],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("transition",{attrs:{name:"md-progress",appear:""}},[n("div",{staticClass:"md-progress",class:[t.themeClass,t.classes]},[n("div",{staticClass:"md-progress-track",style:t.styles})])])},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-card-header"},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("img",{staticClass:"md-image",class:t.classes,attrs:{src:t.mdSrc}})},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("hr",{staticClass:"md-divider"})},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("span",{staticClass:"md-tooltip",class:t.classes,style:t.style},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-card-area",class:t.classes},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-card-header-text"},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-chips",class:[t.themeClass,t.classes]},[n("md-input-container",{nativeOn:{click:function(e){t.applyInputFocus(e)}}},[t._l(t.selectedChips,(function(e){return n("md-chip",{attrs:{"md-deletable":!t.mdStatic,disabled:t.disabled},on:{delete:function(n){t.deleteChip(e)}}},[t._t("default",null,{value:e})],2)})),t._v(" "),n("md-input",{directives:[{name:"show",rawName:"v-show",value:!t.mdStatic,expression:"!mdStatic"},{name:"model",rawName:"v-model",value:t.currentChip,expression:"currentChip"}],ref:"input",attrs:{type:t.mdInputType,placeholder:t.mdInputPlaceholder,id:t.inputId,name:t.mdInputName,disabled:t.disabled,tabindex:"0"},domProps:{value:t.currentChip},on:{input:function(e){t.currentChip=e}},nativeOn:{keydown:[function(e){t._k(e.keyCode,"delete",[8,46])||t.deleteLastChip(e)},function(e){t._k(e.keyCode,"enter",13)||t.selectChip(e)},function(e){186===e.keyCode&&t.selectChip(e)}]}})],2)],1)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return t.mounted||!t.disabled?n("div",{staticClass:"md-ink-ripple"},[n("div",{ref:"ripple",staticClass:"md-ripple",class:t.classes,style:t.styles})]):t._e()},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("ul",{staticClass:"md-list",class:[t.themeClass]},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-sidenav",class:[t.themeClass,t.classes],attrs:{tabindex:"0"},on:{keyup:function(e){t._k(e.keyCode,"esc",27)||t.close(e)}}},[n("div",{staticClass:"md-sidenav-content"},[t._t("default")],2),t._v(" "),n("md-backdrop",{staticClass:"md-sidenav-backdrop",on:{close:t.close}})],1)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("th",{staticClass:"md-table-head",class:t.classes,on:{click:t.changeSort}},[n("div",{staticClass:"md-table-head-container"},[n("div",{staticClass:"md-table-head-text md-test"},[t.mdSortBy?n("md-icon",{staticClass:"md-sortable-icon"},[t._v("arrow_downward")]):t._e(),t._v(" "),t._t("default"),t._v(" "),t.mdTooltip?n("md-tooltip",[t._v(t._s(t.mdTooltip))]):t._e()],2),t._v(" "),n("md-ink-ripple",{attrs:{"md-disabled":!t.mdSortBy}})],1)])},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-input-container",class:[t.themeClass,t.classes]},[t._t("default"),t._v(" "),t.enableCounter?n("span",{staticClass:"md-count"},[t._v(t._s(t.inputLength)+" / "+t._s(t.counterLength))]):t._e(),t._v(" "),t.mdHasPassword?n("md-button",{staticClass:"md-icon-button md-toggle-password",on:{click:t.togglePasswordType}},[n("md-icon",[t._v(t._s(t.showPassword?"visibility_off":"visibility"))])],1):t._e()],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-card",class:[t.themeClass,t.classes]},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-menu-content",attrs:{tabindex:"-1"},on:{keydown:[function(e){t._k(e.keyCode,"esc",27)||(e.preventDefault(),t.close(e))},function(e){t._k(e.keyCode,"tab",9)||(e.preventDefault(),t.close(e))},function(e){t._k(e.keyCode,"up",38)||(e.preventDefault(),t.highlightItem("up"))},function(e){t._k(e.keyCode,"down",40)||(e.preventDefault(),t.highlightItem("down"))},function(e){t._k(e.keyCode,"enter",13)||(e.preventDefault(),t.fireClick(e))},function(e){t._k(e.keyCode,"space",32)||(e.preventDefault(),t.fireClick(e))}]}},[n("md-list",[t._t("default")],2)],1)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("input",{staticClass:"md-input",attrs:{type:t.type,disabled:t.disabled,required:t.required,placeholder:t.placeholder,maxlength:t.maxlength},domProps:{value:t.value},on:{focus:t.onFocus,blur:t.onBlur,input:t.onInput,keydown:[function(e){t._k(e.keyCode,"up",38)||t.onInput(e)},function(e){t._k(e.keyCode,"down",40)||t.onInput(e)}]}})},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("td",{staticClass:"md-table-cell",class:t.classes},[n("div",{staticClass:"md-table-cell-container"},[t._t("default")],2)])},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("md-list-item",{staticClass:"md-menu-item",class:t.classes,attrs:{disabled:t.disabled},on:{click:t.close}},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-card-media",class:t.classes},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("textarea",{staticClass:"md-input",attrs:{disabled:t.disabled,required:t.required,placeholder:t.placeholder,maxlength:t.maxlength},domProps:{value:t.value},on:{focus:t.onFocus,blur:t.onBlur,input:t.onInput}})},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-toolbar",class:[t.themeClass]},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-dialog-actions"},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("md-dialog",{ref:"dialog",staticClass:"md-dialog-confirm",on:{close:function(e){t.fireCloseEvent("cancel")}}},[t.mdTitle?n("md-dialog-title",[t._v(t._s(t.mdTitle))]):t._e(),t._v(" "),t.mdContentHtml?n("md-dialog-content",{domProps:{innerHTML:t._s(t.mdContentHtml)}}):n("md-dialog-content",[t._v(t._s(t.mdContent))]),t._v(" "),n("md-dialog-actions",[n("md-button",{staticClass:"md-primary",on:{click:function(e){t.close("cancel")}}},[t._v(t._s(t.mdCancelText))]),t._v(" "),n("md-button",{staticClass:"md-primary",on:{click:function(e){t.close("ok")}}},[t._v(t._s(t.mdOkText))])],1)],1)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-card-actions"},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-dialog-container",class:[t.themeClass,t.classes],attrs:{tabindex:"0"},on:{keyup:function(e){t._k(e.keyCode,"esc",27)||(e.stopPropagation(),t.closeOnEsc(e))}}},[n("div",{ref:"dialog",staticClass:"md-dialog",class:t.dialogClasses,style:t.styles},[t._t("default")],2),t._v(" "),t.mdBackdrop?n("md-backdrop",{ref:"backdrop",staticClass:"md-dialog-backdrop",class:t.classes,on:{close:function(e){t.mdClickOutsideToClose&&t.close()}}}):t._e()],1)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-switch",class:[t.themeClass,t.classes]},[n("div",{staticClass:"md-switch-container",on:{click:function(e){t.toggle(e)}}},[n("div",{staticClass:"md-switch-thumb",style:t.styles},[n("input",{attrs:{type:"checkbox",name:t.name,id:t.id,disabled:t.disabled},domProps:{value:t.value}}),t._v(" "),n("button",{staticClass:"md-switch-holder",attrs:{type:t.type}}),t._v(" "),n("md-ink-ripple",{attrs:{"md-disabled":t.disabled}})],1)]),t._v(" "),t.$slots.default?n("label",{staticClass:"md-switch-label",attrs:{for:t.id||t.name}},[t._t("default")],2):t._e()])},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("transition",{attrs:{name:"md-spinner",appear:""}},[n("div",{staticClass:"md-spinner",class:[t.themeClass,t.classes],style:t.styles},[n("svg",{staticClass:"md-spinner-draw",attrs:{viewBox:"25 25 50 50"}},[n("circle",{staticClass:"md-spinner-path",attrs:{cx:"50",cy:"50",r:"20","stroke-width":t.mdStroke,"stroke-dasharray":t.dashProgress}})])])])},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-table-pagination"},[n("span",{staticClass:"md-table-pagination-label"},[t._v(t._s(t.mdLabel)+":")]),t._v(" "),t.mdPageOptions?n("md-select",{directives:[{name:"model",rawName:"v-model",value:t.currentSize,expression:"currentSize"}],attrs:{"md-menu-class":"md-pagination-select"},domProps:{value:t.currentSize},on:{change:t.changeSize,
	input:function(e){t.currentSize=e}}},t._l(t.mdPageOptions,(function(e){return n("md-option",{attrs:{value:e}},[t._v(t._s(e))])}))):t._e(),t._v(" "),n("span",[t._v(t._s((t.currentPage-1)*t.currentSize+1)+"-"+t._s(t.subTotal)+" "+t._s(t.mdSeparator)+" "+t._s(t.mdTotal))]),t._v(" "),n("md-button",{staticClass:"md-icon-button md-table-pagination-previous",attrs:{disabled:1===t.currentPage},on:{click:t.previousPage}},[n("md-icon",[t._v("keyboard_arrow_left")])],1),t._v(" "),n("md-button",{staticClass:"md-icon-button md-table-pagination-next",attrs:{disabled:t.currentSize*t.currentPage>=t.totalItems},on:{click:t.nextPage}},[n("md-icon",[t._v("keyboard_arrow_right")])],1)],1)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-tab",style:t.styles,attrs:{id:t.tabId}},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-card-media-actions"},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return t.href?n("a",{staticClass:"md-button",class:[t.themeClass],attrs:{href:t.href,disabled:t.disabled,target:t.target,rel:t.newRel},on:{click:function(e){t.$emit("click",e)}}},[n("md-ink-ripple",{attrs:{"md-disabled":t.disabled}}),t._v(" "),t._t("default")],2):n("button",{staticClass:"md-button",class:[t.themeClass],attrs:{type:t.type,disabled:t.disabled},on:{click:function(e){t.$emit("click",e)}}},[n("md-ink-ripple",{attrs:{"md-disabled":t.disabled}}),t._v(" "),t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-file",on:{click:t.openPicker}},[n("md-input",{directives:[{name:"model",rawName:"v-model",value:t.filename,expression:"filename"}],ref:"textInput",attrs:{readonly:"",required:t.required,placeholder:t.placeholder,disabled:t.disabled},domProps:{value:t.filename},on:{input:function(e){t.filename=e}}}),t._v(" "),n("md-icon",[t._v("attach_file")]),t._v(" "),n("input",{ref:"fileInput",attrs:{type:"file",id:t.id,name:t.name,disabled:t.disabled,multiple:t.multiple,accept:t.accept},on:{change:t.onFileSelected}})],1)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-checkbox",class:[t.themeClass,t.classes]},[n("div",{staticClass:"md-checkbox-container",attrs:{tabindex:"0"},on:{click:function(e){e.stopPropagation(),t.toggleCheck(e)}}},[n("input",{attrs:{type:"checkbox",name:t.name,id:t.id,disabled:t.disabled,tabindex:"-1"},domProps:{value:t.value}}),t._v(" "),n("md-ink-ripple",{attrs:{"md-disabled":t.disabled}})],1),t._v(" "),t.$slots.default?n("label",{staticClass:"md-checkbox-label",attrs:{for:t.id||t.name}},[t._t("default")],2):t._e()])},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return"md-list"===t.$parent.$options._componentTag?n("li",{staticClass:"md-subheader",class:[t.themeClass]},[t._t("default")],2):n("div",{staticClass:"md-subheader",class:[t.themeClass]},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("md-menu-item",{staticClass:"md-option",class:t.classes,attrs:{tabindex:"-1"},on:{click:t.selectOption}},[t.parentSelect.multiple?n("md-checkbox",{directives:[{name:"model",rawName:"v-model",value:t.check,expression:"check"}],staticClass:"md-primary",domProps:{value:t.check},on:{input:function(e){t.check=e}}},[n("span",{ref:"item"},[t._t("default")],2)]):n("span",{ref:"item"},[t._t("default")],2)],1)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-snackbar",class:[t.themeClass,t.classes],attrs:{id:t.snackbarId}},[n("div",{ref:"container",staticClass:"md-snackbar-container"},[n("div",{staticClass:"md-snackbar-content"},[t._t("default")],2)])])},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-tabs",class:[t.themeClass,t.tabClasses]},[n("md-whiteframe",{ref:"tabNavigation",staticClass:"md-tabs-navigation",class:t.navigationClasses,attrs:{"md-tag":"nav","md-elevation":t.mdElevation}},[t._l(t.tabList,(function(e){return n("button",{key:e.id,ref:"tabHeader",refInFor:!0,staticClass:"md-tab-header",class:t.getHeaderClass(e),attrs:{type:"button",disabled:e.disabled},on:{click:function(n){t.setActiveTab(e)}}},[n("md-ink-ripple",{attrs:{"md-disabled":e.disabled}}),t._v(" "),n("div",{staticClass:"md-tab-header-container"},[e.icon?n("md-icon",[t._v(t._s(e.icon))]):t._e(),t._v(" "),e.label?n("span",[t._v(t._s(e.label))]):t._e(),t._v(" "),e.tooltip?n("md-tooltip",{attrs:{"md-direction":e.tooltipDirection,"md-delay":e.tooltipDelay}},[t._v(t._s(e.tooltip))]):t._e()],1)],1)})),t._v(" "),n("span",{ref:"indicator",staticClass:"md-tab-indicator",class:t.indicatorClasses})],2),t._v(" "),n("div",{ref:"tabContent",staticClass:"md-tabs-content",style:{height:t.contentHeight}},[n("div",{staticClass:"md-tabs-wrapper",style:{transform:"translate3D(-"+t.contentWidth+", 0, 0)"}},[t._t("default")],2)])],1)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("tr",{staticClass:"md-table-row",class:t.classes,on:{click:t.autoSelect}},[t.hasSelection?n("md-table-cell",{staticClass:"md-table-selection"},[n("md-checkbox",{directives:[{name:"model",rawName:"v-model",value:t.checkbox,expression:"checkbox"}],attrs:{disabled:t.isDisabled},domProps:{value:t.checkbox},on:{change:t.select,input:function(e){t.checkbox=e}}})],1):t._e(),t._v(" "),t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{ref:"expand",staticClass:"md-card-expand"},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-table",class:[t.themeClass]},[n("table",[t._t("default")],2)])},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-backdrop",on:{click:t.close,keyup:function(e){t._k(e.keyCode,"esc",27)||t.close(e)}}})},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("md-card",{staticClass:"md-table-card",class:[t.themeClass]},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("md-dialog",{ref:"dialog",staticClass:"md-dialog-alert",on:{close:function(e){t.fireCloseEvent()}}},[t.mdTitle?n("md-dialog-title",[t._v(t._s(t.mdTitle))]):t._e(),t._v(" "),t.mdContentHtml?n("md-dialog-content",{domProps:{innerHTML:t._s(t.mdContentHtml)}}):n("md-dialog-content",[t._v(t._s(t.mdContent))]),t._v(" "),n("md-dialog-actions",[n("md-button",{staticClass:"md-primary",on:{click:function(e){t.close()}}},[t._v(t._s(t.mdOkText))])],1)],1)},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"md-radio",class:[t.themeClass,t.classes]},[n("div",{staticClass:"md-radio-container",on:{click:t.toggleCheck}},[n("input",{attrs:{type:"radio",name:t.name,id:t.id,disabled:t.disabled},domProps:{value:t.value}}),t._v(" "),n("md-ink-ripple",{attrs:{"md-disabled":t.disabled}})],1),t._v(" "),t.$slots.default?n("label",{staticClass:"md-radio-label",attrs:{for:t.id||t.name}},[t._t("default")],2):t._e()])},staticRenderFns:[]}}),(function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return t.svgContent?n("i",{staticClass:"md-icon",class:[t.themeClass],domProps:{innerHTML:t._s(t.svgContent)}}):t.imageSrc?n("md-image",{staticClass:"md-icon",class:[t.themeClass],attrs:{"md-src":t.imageSrc}}):n("i",{staticClass:"md-icon material-icons",class:[t.themeClass]},[t._t("default")],2)},staticRenderFns:[]}}),(function(t,e,n){function o(t,e){for(var n=0;n<t.length;n++){var o=t[n],i=u[o.id];if(i){i.refs++;for(var r=0;r<i.parts.length;r++)i.parts[r](o.parts[r]);for(;r<o.parts.length;r++)i.parts.push(d(o.parts[r],e))}else{for(var a=[],r=0;r<o.parts.length;r++)a.push(d(o.parts[r],e));u[o.id]={id:o.id,refs:1,parts:a}}}}function i(t){for(var e=[],n={},o=0;o<t.length;o++){var i=t[o],r=i[0],a=i[1],s=i[2],d=i[3],l={css:a,media:s,sourceMap:d};n[r]?n[r].parts.push(l):e.push(n[r]={id:r,parts:[l]})}return e}function r(t,e){var n=p(),o=v[v.length-1];if("top"===t.insertAt)o?o.nextSibling?n.insertBefore(e,o.nextSibling):n.appendChild(e):n.insertBefore(e,n.firstChild),v.push(e);else{if("bottom"!==t.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(e)}}function a(t){t.parentNode.removeChild(t);var e=v.indexOf(t);e>=0&&v.splice(e,1)}function s(t){var e=document.createElement("style");return e.type="text/css",r(t,e),e}function d(t,e){var n,o,i;if(e.singleton){var r=b++;n=h||(h=s(e)),o=l.bind(null,n,r,!1),i=l.bind(null,n,r,!0)}else n=s(e),o=c.bind(null,n),i=function(){a(n)};return o(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;o(t=e)}else i()}}function l(t,e,n,o){var i=n?"":o.css;if(t.styleSheet)t.styleSheet.cssText=g(e,i);else{var r=document.createTextNode(i),a=t.childNodes;a[e]&&t.removeChild(a[e]),a.length?t.insertBefore(r,a[e]):t.appendChild(r)}}function c(t,e){var n=e.css,o=e.media,i=e.sourceMap;if(o&&t.setAttribute("media",o),i&&(n+="\n/*# sourceURL="+i.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(i))))+" */"),t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}var u={},f=function(t){var e;return function(){return"undefined"==typeof e&&(e=t.apply(this,arguments)),e}},m=f((function(){return/msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase())})),p=f((function(){return document.head||document.getElementsByTagName("head")[0]})),h=null,b=0,v=[];t.exports=function(t,e){e=e||{},"undefined"==typeof e.singleton&&(e.singleton=m()),"undefined"==typeof e.insertAt&&(e.insertAt="bottom");var n=i(t);return o(n,e),function(t){for(var r=[],a=0;a<n.length;a++){var s=n[a],d=u[s.id];d.refs--,r.push(d)}if(t){var l=i(t);o(l,e)}for(var a=0;a<r.length;a++){var d=r[a];if(0===d.refs){for(var c=0;c<d.parts.length;c++)d.parts[c]();delete u[d.id]}}}};var g=(function(){var t=[];return function(e,n){return t[e]=n,t.filter(Boolean).join("\n")}})()}),(function(t,e,n){var o=n(188);"string"==typeof o&&(o=[[t.id,o,""]]);n(372)(o,{});o.locals&&(t.exports=o.locals)}),(function(e,n){e.exports=t}),(function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(107),r=o(i),a=n(72),s=o(a),d=n(73),l=o(d),c=n(74),u=o(c),f=n(75),m=o(f),p=n(76),h=o(p),b=n(77),v=o(b),g=n(78),E=o(g),_=n(79),C=o(_),y=n(80),M=o(y),T=n(81),x=o(T),A=n(82),O=o(A),R=n(83),N=o(R),k=n(84),w=o(k),S=n(85),P=o(S),L=n(86),H=o(L),$=n(87),F=o($),j=n(88),I=o(j),B=n(89),D=o(B),W=n(90),z=o(W),G=n(91),Y=o(G),U=n(92),K=o(U),V=n(93),q=o(V),X=n(95),J=o(X),Q=n(96),Z=o(Q),tt=n(97),et=o(tt),nt=n(98),ot=o(nt),it=n(99),rt=o(it),at=n(100),st=o(at),dt=n(101),lt=o(dt),ct=n(102),ut=o(ct),ft={MdCore:r.default,MdAvatar:s.default,MdBackdrop:l.default,MdBottomBar:u.default,MdButton:m.default,MdButtonToggle:h.default,MdCard:v.default,MdCheckbox:E.default,MdChips:C.default,MdDialog:M.default,MdDivider:x.default,MdFile:O.default,MdIcon:N.default,MdImage:w.default,MdInputContainer:P.default,MdLayout:H.default,MdList:F.default,MdMenu:I.default,MdProgress:D.default,MdRadio:z.default,MdSelect:Y.default,MdSidenav:K.default,MdSnackbar:q.default,MdSpinner:J.default,MdSubheader:Z.default,MdSwitch:et.default,MdTable:ot.default,MdTabs:rt.default,MdToolbar:st.default,MdTooltip:lt.default,MdWhiteframe:ut.default};ft.install=function(t){for(var e in ft){var n=ft[e];n&&"install"!==e&&t.use(n)}},e.default=ft,t.exports=e.default})]))}));

/***/ },
/* 1374 */,
/* 1375 */,
/* 1376 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if (media) {
			styleElement.setAttribute("media", media);
		}
	
		if (sourceMap) {
			// https://developer.chrome.com/devtools/docs/javascript-debugging
			// this makes source maps inside style tags work properly in Chrome
			css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */';
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}


/***/ }
]);


// WEBPACK FOOTER //
// static/js/vendor.c313c2aea0f0ddea7fef.js